// Auto-generated by bin/build-jma-hierarchy.js — do not edit manually
// Source: https://www.jma.go.jp/bosai/common/const/area.json (+ multilingual names merged from /Users/BaoDang_1/Desktop/univoice/univoice-server/statics/jma/new_area.const.js)

/** Shared multilingual name fields across all JMA area types */
export interface JMALocalizedNames {
  /** Japanese (日本語) */
  name?: string;
  /** English */
  enName?: string;
  /** Chinese Simplified (简体中文) */
  chName?: string;
  /** Chinese Traditional (繁體中文) */
  zhName?: string;
  /** Korean (한국어) */
  koName?: string;
  /** Spanish (Español) */
  esName?: string;
  /** Portuguese (Português) */
  ptName?: string;
  /** Thai (ภาษาไทย) */
  thName?: string;
  /** Vietnamese (Tiếng Việt) */
  viName?: string;
  /** Indonesian (Bahasa Indonesia) */
  inName?: string;
  /** Filipino (Wikang Filipino) */
  tlName?: string;
  /** Mongolian (Монгол хэл) */
  moName?: string;
  /** Burmese (မြန်မာဘာသာ) */
  buName?: string;
  /** Khmer (ភាសាខ្មែរ) */
  khName?: string;
  /** Nepali (नेपाली) */
  neName?: string;
}

export interface JMAAreaInfo extends JMALocalizedNames {
  code?: string;
}

export interface JMAOfficeInfo extends JMAAreaInfo {
  /** Responsible meteorological office (気象台名) */
  officeName?: string;
}

export interface JMAClass20Info extends JMALocalizedNames {
  code?: string;
  /** Japanese reading (ふりがな) */
  kana?: string;
}

export interface JMAHierarchyEntry {
  office: JMAOfficeInfo;
  class10: JMAAreaInfo;
  class15?: JMAAreaInfo;
  class20: JMAClass20Info;
}

export const jmaHierarchy: Record<string, JMAHierarchyEntry> = {
  "1020100": {
    "office": {
      "code": "100000",
      "name": "群馬県",
      "enName": "Gunma",
      "officeName": "前橋地方気象台",
      "chName": "群马县",
      "zhName": "群馬縣",
      "koName": "군마현",
      "esName": "Prefectura de Gunma",
      "ptName": "Província de Gunma",
      "thName": "จังหวัดกุมมะ",
      "viName": "Tỉnh Gunma",
      "inName": "Prefektur Gunma",
      "tlName": "Gunma Prefecture",
      "moName": "Гүнма аймаг",
      "buName": "ဂူးမ ပြည်နယ်",
      "khName": "ខេត្ដ ហ្គាន់ម៉ា",
      "neName": "गुन्मा जिल्ला"
    },
    "class10": {
      "code": "100010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "群马县南部",
      "zhName": "群馬縣南部",
      "koName": "군마 현 남부",
      "esName": "Sur de Prefectura de Gunma",
      "ptName": "Sul da Província de Gunma",
      "thName": "จังหวัดกุมมะตอนใต้",
      "viName": "Miền Nam tỉnh Gunma",
      "inName": "Bagian Selatan Prefektur Gunma",
      "tlName": "Timog na bahagi ng Gunma Prefecture",
      "moName": "Өмнөд Гүнма аймаг",
      "buName": "ဂွန်းမစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដហ្គឹនម៉ា",
      "neName": "गुन्मा जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "100011",
      "name": "前橋・桐生地域",
      "enName": "Maebashi Kiryu Area"
    },
    "class20": {
      "code": "1020100",
      "name": "前橋市",
      "enName": "Maebashi City",
      "kana": "まえばしし",
      "chName": "前桥市",
      "zhName": "前橋市",
      "koName": "마에바시 시",
      "esName": "Ciudad de Maebashi",
      "ptName": "cidade de Maebashi",
      "thName": "เมืองมาเอะบาชิ",
      "viName": "thành phố Maebashi",
      "inName": "kota Maebashi",
      "tlName": "siyudad ng Maebashi",
      "moName": "Маэбаши хот",
      "buName": "မာယဲဘာ့ရှိ မြို့",
      "khName": "ទីក្រុង មេបាស៊ី",
      "neName": "माइबाशि सहर"
    }
  },
  "1020200": {
    "office": {
      "code": "100000",
      "name": "群馬県",
      "enName": "Gunma",
      "officeName": "前橋地方気象台",
      "chName": "群马县",
      "zhName": "群馬縣",
      "koName": "군마현",
      "esName": "Prefectura de Gunma",
      "ptName": "Província de Gunma",
      "thName": "จังหวัดกุมมะ",
      "viName": "Tỉnh Gunma",
      "inName": "Prefektur Gunma",
      "tlName": "Gunma Prefecture",
      "moName": "Гүнма аймаг",
      "buName": "ဂူးမ ပြည်နယ်",
      "khName": "ខេត្ដ ហ្គាន់ម៉ា",
      "neName": "गुन्मा जिल्ला"
    },
    "class10": {
      "code": "100010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "群马县南部",
      "zhName": "群馬縣南部",
      "koName": "군마 현 남부",
      "esName": "Sur de Prefectura de Gunma",
      "ptName": "Sul da Província de Gunma",
      "thName": "จังหวัดกุมมะตอนใต้",
      "viName": "Miền Nam tỉnh Gunma",
      "inName": "Bagian Selatan Prefektur Gunma",
      "tlName": "Timog na bahagi ng Gunma Prefecture",
      "moName": "Өмнөд Гүнма аймаг",
      "buName": "ဂွန်းမစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដហ្គឹនម៉ា",
      "neName": "गुन्मा जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "100013",
      "name": "高崎・藤岡地域",
      "enName": "Takasaki Fujioka Area"
    },
    "class20": {
      "code": "1020200",
      "name": "高崎市",
      "enName": "Takasaki City",
      "kana": "たかさきし",
      "chName": "高崎市",
      "zhName": "髙崎市",
      "koName": "다카사키 시",
      "esName": "Ciudad de Takasaki",
      "ptName": "cidade de Takasaki",
      "thName": "เมืองทากาซากิ",
      "viName": "thành phố Takasaki",
      "inName": "kota Takasaki",
      "tlName": "siyudad ng Takasaki",
      "moName": "Такасаки хот",
      "buName": "တာဂါဆာ့ကိ မြို့",
      "khName": "ទីក្រុង តាកាសាគី",
      "neName": "ताकासाकी सहर"
    }
  },
  "1020300": {
    "office": {
      "code": "100000",
      "name": "群馬県",
      "enName": "Gunma",
      "officeName": "前橋地方気象台",
      "chName": "群马县",
      "zhName": "群馬縣",
      "koName": "군마현",
      "esName": "Prefectura de Gunma",
      "ptName": "Província de Gunma",
      "thName": "จังหวัดกุมมะ",
      "viName": "Tỉnh Gunma",
      "inName": "Prefektur Gunma",
      "tlName": "Gunma Prefecture",
      "moName": "Гүнма аймаг",
      "buName": "ဂူးမ ပြည်နယ်",
      "khName": "ខេត្ដ ហ្គាន់ម៉ា",
      "neName": "गुन्मा जिल्ला"
    },
    "class10": {
      "code": "100010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "群马县南部",
      "zhName": "群馬縣南部",
      "koName": "군마 현 남부",
      "esName": "Sur de Prefectura de Gunma",
      "ptName": "Sul da Província de Gunma",
      "thName": "จังหวัดกุมมะตอนใต้",
      "viName": "Miền Nam tỉnh Gunma",
      "inName": "Bagian Selatan Prefektur Gunma",
      "tlName": "Timog na bahagi ng Gunma Prefecture",
      "moName": "Өмнөд Гүнма аймаг",
      "buName": "ဂွန်းမစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដហ្គឹនម៉ា",
      "neName": "गुन्मा जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "100011",
      "name": "前橋・桐生地域",
      "enName": "Maebashi Kiryu Area"
    },
    "class20": {
      "code": "1020300",
      "name": "桐生市",
      "enName": "Kiryu City",
      "kana": "きりゅうし",
      "chName": "桐生市",
      "zhName": "桐生市",
      "koName": "기류 시",
      "esName": "Ciudad de Kiryu",
      "ptName": "cidade de Kiryu",
      "thName": "เมืองคิริว",
      "viName": "thành phố Kiryu",
      "inName": "kota Kiryu",
      "tlName": "siyudad ng Kiryu",
      "moName": "Кирю хот",
      "buName": "ကာရု မြို့",
      "khName": "ទីក្រុង ឃៀយូ",
      "neName": "किर्यु सहर"
    }
  },
  "1020400": {
    "office": {
      "code": "100000",
      "name": "群馬県",
      "enName": "Gunma",
      "officeName": "前橋地方気象台",
      "chName": "群马县",
      "zhName": "群馬縣",
      "koName": "군마현",
      "esName": "Prefectura de Gunma",
      "ptName": "Província de Gunma",
      "thName": "จังหวัดกุมมะ",
      "viName": "Tỉnh Gunma",
      "inName": "Prefektur Gunma",
      "tlName": "Gunma Prefecture",
      "moName": "Гүнма аймаг",
      "buName": "ဂူးမ ပြည်နယ်",
      "khName": "ខេត្ដ ហ្គាន់ម៉ា",
      "neName": "गुन्मा जिल्ला"
    },
    "class10": {
      "code": "100010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "群马县南部",
      "zhName": "群馬縣南部",
      "koName": "군마 현 남부",
      "esName": "Sur de Prefectura de Gunma",
      "ptName": "Sul da Província de Gunma",
      "thName": "จังหวัดกุมมะตอนใต้",
      "viName": "Miền Nam tỉnh Gunma",
      "inName": "Bagian Selatan Prefektur Gunma",
      "tlName": "Timog na bahagi ng Gunma Prefecture",
      "moName": "Өмнөд Гүнма аймаг",
      "buName": "ဂွန်းမစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដហ្គឹនម៉ា",
      "neName": "गुन्मा जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "100012",
      "name": "伊勢崎・太田地域",
      "enName": "Isesaki Ota Area"
    },
    "class20": {
      "code": "1020400",
      "name": "伊勢崎市",
      "enName": "Isesaki City",
      "kana": "いせさきし",
      "chName": "伊势崎市",
      "zhName": "伊勢崎市",
      "koName": "이세사키 시",
      "esName": "Ciudad de Isezaki",
      "ptName": "cidade de Isesaki",
      "thName": "เมืองอิเซะซากิ",
      "viName": "thành phố Isesaki",
      "inName": "kota Isesaki",
      "tlName": "siyudad ng Isesaki",
      "moName": "Исесаки хот",
      "buName": "အီဆေ့ဆာ့ကိ မြို့",
      "khName": "ទីក្រុង អាយសាសាគី",
      "neName": "इसेसाकी सहर"
    }
  },
  "1020500": {
    "office": {
      "code": "100000",
      "name": "群馬県",
      "enName": "Gunma",
      "officeName": "前橋地方気象台",
      "chName": "群马县",
      "zhName": "群馬縣",
      "koName": "군마현",
      "esName": "Prefectura de Gunma",
      "ptName": "Província de Gunma",
      "thName": "จังหวัดกุมมะ",
      "viName": "Tỉnh Gunma",
      "inName": "Prefektur Gunma",
      "tlName": "Gunma Prefecture",
      "moName": "Гүнма аймаг",
      "buName": "ဂူးမ ပြည်နယ်",
      "khName": "ខេត្ដ ហ្គាន់ម៉ា",
      "neName": "गुन्मा जिल्ला"
    },
    "class10": {
      "code": "100010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "群马县南部",
      "zhName": "群馬縣南部",
      "koName": "군마 현 남부",
      "esName": "Sur de Prefectura de Gunma",
      "ptName": "Sul da Província de Gunma",
      "thName": "จังหวัดกุมมะตอนใต้",
      "viName": "Miền Nam tỉnh Gunma",
      "inName": "Bagian Selatan Prefektur Gunma",
      "tlName": "Timog na bahagi ng Gunma Prefecture",
      "moName": "Өмнөд Гүнма аймаг",
      "buName": "ဂွန်းမစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដហ្គឹនម៉ា",
      "neName": "गुन्मा जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "100012",
      "name": "伊勢崎・太田地域",
      "enName": "Isesaki Ota Area"
    },
    "class20": {
      "code": "1020500",
      "name": "太田市",
      "enName": "Ota City",
      "kana": "おおたし",
      "chName": "太田市",
      "zhName": "太田市",
      "koName": "오타 시",
      "esName": "Ciudad de Ota",
      "ptName": "cidade de Ota",
      "thName": "เมืองโอตะ",
      "viName": "thành phố Ota",
      "inName": "kota Ota",
      "tlName": "siyudad ng Ota",
      "moName": "Ота хот",
      "buName": "အိုးတ မြို့",
      "khName": "ទីក្រុង អូតា",
      "neName": "ओता सहर"
    }
  },
  "1020600": {
    "office": {
      "code": "100000",
      "name": "群馬県",
      "enName": "Gunma",
      "officeName": "前橋地方気象台",
      "chName": "群马县",
      "zhName": "群馬縣",
      "koName": "군마현",
      "esName": "Prefectura de Gunma",
      "ptName": "Província de Gunma",
      "thName": "จังหวัดกุมมะ",
      "viName": "Tỉnh Gunma",
      "inName": "Prefektur Gunma",
      "tlName": "Gunma Prefecture",
      "moName": "Гүнма аймаг",
      "buName": "ဂူးမ ပြည်နယ်",
      "khName": "ខេត្ដ ហ្គាន់ម៉ា",
      "neName": "गुन्मा जिल्ला"
    },
    "class10": {
      "code": "100020",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "群马县北部",
      "zhName": "群馬縣北部",
      "koName": "군마 현 북부",
      "esName": "Norte de Prefectura de Gunma",
      "ptName": "Norte da Província de Gunma",
      "thName": "จังหวัดกุมมะตอนเหนือ",
      "viName": "Miền Bắc tỉnh Gunma",
      "inName": "Bagian Utara Prefektur Gunma",
      "tlName": "Hilagang bahagi ng Gunma Prefecture",
      "moName": "Хойд Гүнма аймаг",
      "buName": "ဂွန်းမစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដហ្គឹនម៉ា",
      "neName": "गुन्मा जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "100021",
      "name": "利根・沼田地域",
      "enName": "Tone Numata Area"
    },
    "class20": {
      "code": "1020600",
      "name": "沼田市",
      "enName": "Numata City",
      "kana": "ぬまたし",
      "chName": "沼田市",
      "zhName": "沼田市",
      "koName": "누마타 시",
      "esName": "Ciudad de Numata",
      "ptName": "cidade de Numata",
      "thName": "เมืองนุมาตะ",
      "viName": "thành phố Numata",
      "inName": "kota Numata",
      "tlName": "siyudad ng Numata",
      "moName": "Нүмата хот",
      "buName": "နူမာ့တ မြို့",
      "khName": "ទីក្រុង នូម៉ាតា",
      "neName": "नुमाता सहर"
    }
  },
  "1020700": {
    "office": {
      "code": "100000",
      "name": "群馬県",
      "enName": "Gunma",
      "officeName": "前橋地方気象台",
      "chName": "群马县",
      "zhName": "群馬縣",
      "koName": "군마현",
      "esName": "Prefectura de Gunma",
      "ptName": "Província de Gunma",
      "thName": "จังหวัดกุมมะ",
      "viName": "Tỉnh Gunma",
      "inName": "Prefektur Gunma",
      "tlName": "Gunma Prefecture",
      "moName": "Гүнма аймаг",
      "buName": "ဂူးမ ပြည်နယ်",
      "khName": "ខេត្ដ ហ្គាន់ម៉ា",
      "neName": "गुन्मा जिल्ला"
    },
    "class10": {
      "code": "100010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "群马县南部",
      "zhName": "群馬縣南部",
      "koName": "군마 현 남부",
      "esName": "Sur de Prefectura de Gunma",
      "ptName": "Sul da Província de Gunma",
      "thName": "จังหวัดกุมมะตอนใต้",
      "viName": "Miền Nam tỉnh Gunma",
      "inName": "Bagian Selatan Prefektur Gunma",
      "tlName": "Timog na bahagi ng Gunma Prefecture",
      "moName": "Өмнөд Гүнма аймаг",
      "buName": "ဂွန်းမစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដហ្គឹនម៉ា",
      "neName": "गुन्मा जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "100012",
      "name": "伊勢崎・太田地域",
      "enName": "Isesaki Ota Area"
    },
    "class20": {
      "code": "1020700",
      "name": "館林市",
      "enName": "Tatebayashi City",
      "kana": "たてばやしし",
      "chName": "馆林市",
      "zhName": "館林市",
      "koName": "다테바야시 시",
      "esName": "Ciudad de Tatebayashi",
      "ptName": "cidade de Tatebayashi",
      "thName": "เมืองทาเทะบายาชิ",
      "viName": "thành phố Tatebayashi",
      "inName": "kota Tatebayashi",
      "tlName": "siyudad ng Tatebayashi",
      "moName": "Татэбаяши хот",
      "buName": "တာတေးဘာ့ယရှိ မြို့",
      "khName": "ទីក្រុង តាតេបាយ៉ាស៊ី",
      "neName": "तातेबायासी सहर"
    }
  },
  "1020800": {
    "office": {
      "code": "100000",
      "name": "群馬県",
      "enName": "Gunma",
      "officeName": "前橋地方気象台",
      "chName": "群马县",
      "zhName": "群馬縣",
      "koName": "군마현",
      "esName": "Prefectura de Gunma",
      "ptName": "Província de Gunma",
      "thName": "จังหวัดกุมมะ",
      "viName": "Tỉnh Gunma",
      "inName": "Prefektur Gunma",
      "tlName": "Gunma Prefecture",
      "moName": "Гүнма аймаг",
      "buName": "ဂူးမ ပြည်နယ်",
      "khName": "ខេត្ដ ហ្គាន់ម៉ា",
      "neName": "गुन्मा जिल्ला"
    },
    "class10": {
      "code": "100010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "群马县南部",
      "zhName": "群馬縣南部",
      "koName": "군마 현 남부",
      "esName": "Sur de Prefectura de Gunma",
      "ptName": "Sul da Província de Gunma",
      "thName": "จังหวัดกุมมะตอนใต้",
      "viName": "Miền Nam tỉnh Gunma",
      "inName": "Bagian Selatan Prefektur Gunma",
      "tlName": "Timog na bahagi ng Gunma Prefecture",
      "moName": "Өмнөд Гүнма аймаг",
      "buName": "ဂွန်းမစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដហ្គឹនម៉ា",
      "neName": "गुन्मा जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "100011",
      "name": "前橋・桐生地域",
      "enName": "Maebashi Kiryu Area"
    },
    "class20": {
      "code": "1020800",
      "name": "渋川市",
      "enName": "Shibukawa City",
      "kana": "しぶかわし",
      "chName": "涩川市",
      "zhName": "澀川市",
      "koName": "시부카와 시",
      "esName": "Ciudad de Shibukawa",
      "ptName": "cidade de Shibukawa",
      "thName": "เมืองชิบุคาวา",
      "viName": "thành phố Shibukawa",
      "inName": "kota Shibukawa",
      "tlName": "siyudad ng Shibukawa",
      "moName": "Шибүкава хот",
      "buName": "ရှီဘုခါ့ဝ မြို့",
      "khName": "ទីក្រុង ស៊ីប៊ូកាវ៉ា",
      "neName": "शिबुकावा सहर"
    }
  },
  "1020900": {
    "office": {
      "code": "100000",
      "name": "群馬県",
      "enName": "Gunma",
      "officeName": "前橋地方気象台",
      "chName": "群马县",
      "zhName": "群馬縣",
      "koName": "군마현",
      "esName": "Prefectura de Gunma",
      "ptName": "Província de Gunma",
      "thName": "จังหวัดกุมมะ",
      "viName": "Tỉnh Gunma",
      "inName": "Prefektur Gunma",
      "tlName": "Gunma Prefecture",
      "moName": "Гүнма аймаг",
      "buName": "ဂူးမ ပြည်နယ်",
      "khName": "ខេត្ដ ហ្គាន់ម៉ា",
      "neName": "गुन्मा जिल्ला"
    },
    "class10": {
      "code": "100010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "群马县南部",
      "zhName": "群馬縣南部",
      "koName": "군마 현 남부",
      "esName": "Sur de Prefectura de Gunma",
      "ptName": "Sul da Província de Gunma",
      "thName": "จังหวัดกุมมะตอนใต้",
      "viName": "Miền Nam tỉnh Gunma",
      "inName": "Bagian Selatan Prefektur Gunma",
      "tlName": "Timog na bahagi ng Gunma Prefecture",
      "moName": "Өмнөд Гүнма аймаг",
      "buName": "ဂွန်းမစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដហ្គឹនម៉ា",
      "neName": "गुन्मा जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "100013",
      "name": "高崎・藤岡地域",
      "enName": "Takasaki Fujioka Area"
    },
    "class20": {
      "code": "1020900",
      "name": "藤岡市",
      "enName": "Fujioka City",
      "kana": "ふじおかし",
      "chName": "藤冈市",
      "zhName": "藤岡市",
      "koName": "후지오카 시",
      "esName": "Ciudad de Fujioka",
      "ptName": "cidade de Fujioka",
      "thName": "เมืองฟูจิโอกะ",
      "viName": "thành phố Fujioka",
      "inName": "kota Fujioka",
      "tlName": "siyudad ng Fujioka",
      "moName": "Фүжиока хот",
      "buName": "ဖူဂျီယော့က မြို့",
      "khName": "ទីក្រុង ហ្វូជីអូកា",
      "neName": "फुजियोका सहर"
    }
  },
  "1021000": {
    "office": {
      "code": "100000",
      "name": "群馬県",
      "enName": "Gunma",
      "officeName": "前橋地方気象台",
      "chName": "群马县",
      "zhName": "群馬縣",
      "koName": "군마현",
      "esName": "Prefectura de Gunma",
      "ptName": "Província de Gunma",
      "thName": "จังหวัดกุมมะ",
      "viName": "Tỉnh Gunma",
      "inName": "Prefektur Gunma",
      "tlName": "Gunma Prefecture",
      "moName": "Гүнма аймаг",
      "buName": "ဂူးမ ပြည်နယ်",
      "khName": "ខេត្ដ ហ្គាន់ម៉ា",
      "neName": "गुन्मा जिल्ला"
    },
    "class10": {
      "code": "100010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "群马县南部",
      "zhName": "群馬縣南部",
      "koName": "군마 현 남부",
      "esName": "Sur de Prefectura de Gunma",
      "ptName": "Sul da Província de Gunma",
      "thName": "จังหวัดกุมมะตอนใต้",
      "viName": "Miền Nam tỉnh Gunma",
      "inName": "Bagian Selatan Prefektur Gunma",
      "tlName": "Timog na bahagi ng Gunma Prefecture",
      "moName": "Өмнөд Гүнма аймаг",
      "buName": "ဂွန်းမစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដហ្គឹនម៉ា",
      "neName": "गुन्मा जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "100013",
      "name": "高崎・藤岡地域",
      "enName": "Takasaki Fujioka Area"
    },
    "class20": {
      "code": "1021000",
      "name": "富岡市",
      "enName": "Tomioka City",
      "kana": "とみおかし",
      "chName": "富冈市",
      "zhName": "富岡市",
      "koName": "도미오카 시",
      "esName": "Ciudad de Tomioka",
      "ptName": "cidade de Tomioka",
      "thName": "เมืองโทมิโอกะ",
      "viName": "thành phố Tomioka",
      "inName": "kota Tomioka",
      "tlName": "siyudad ng Tomioka",
      "moName": "Томиока хот",
      "buName": "တိုမီးရို့က မြို့",
      "khName": "ទីក្រុង ថូមីអូកា",
      "neName": "तोमियोका सहर"
    }
  },
  "1021100": {
    "office": {
      "code": "100000",
      "name": "群馬県",
      "enName": "Gunma",
      "officeName": "前橋地方気象台",
      "chName": "群马县",
      "zhName": "群馬縣",
      "koName": "군마현",
      "esName": "Prefectura de Gunma",
      "ptName": "Província de Gunma",
      "thName": "จังหวัดกุมมะ",
      "viName": "Tỉnh Gunma",
      "inName": "Prefektur Gunma",
      "tlName": "Gunma Prefecture",
      "moName": "Гүнма аймаг",
      "buName": "ဂူးမ ပြည်နယ်",
      "khName": "ខេត្ដ ហ្គាន់ម៉ា",
      "neName": "गुन्मा जिल्ला"
    },
    "class10": {
      "code": "100010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "群马县南部",
      "zhName": "群馬縣南部",
      "koName": "군마 현 남부",
      "esName": "Sur de Prefectura de Gunma",
      "ptName": "Sul da Província de Gunma",
      "thName": "จังหวัดกุมมะตอนใต้",
      "viName": "Miền Nam tỉnh Gunma",
      "inName": "Bagian Selatan Prefektur Gunma",
      "tlName": "Timog na bahagi ng Gunma Prefecture",
      "moName": "Өмнөд Гүнма аймаг",
      "buName": "ဂွန်းမစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដហ្គឹនម៉ា",
      "neName": "गुन्मा जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "100013",
      "name": "高崎・藤岡地域",
      "enName": "Takasaki Fujioka Area"
    },
    "class20": {
      "code": "1021100",
      "name": "安中市",
      "enName": "Annaka City",
      "kana": "あんなかし",
      "chName": "安中市",
      "zhName": "安中市",
      "koName": "안나카 시",
      "esName": "Ciudad de Annaka",
      "ptName": "cidade de Annaka",
      "thName": "เมืองอันนากะ",
      "viName": "thành phố Annaka",
      "inName": "kota Annaka",
      "tlName": "siyudad ng Annaka",
      "moName": "Аннака хот",
      "buName": "အာနာ့က မြို့",
      "khName": "ទីក្រុង អាណាកា",
      "neName": "आन्नाका सहर"
    }
  },
  "1021200": {
    "office": {
      "code": "100000",
      "name": "群馬県",
      "enName": "Gunma",
      "officeName": "前橋地方気象台",
      "chName": "群马县",
      "zhName": "群馬縣",
      "koName": "군마현",
      "esName": "Prefectura de Gunma",
      "ptName": "Província de Gunma",
      "thName": "จังหวัดกุมมะ",
      "viName": "Tỉnh Gunma",
      "inName": "Prefektur Gunma",
      "tlName": "Gunma Prefecture",
      "moName": "Гүнма аймаг",
      "buName": "ဂူးမ ပြည်နယ်",
      "khName": "ខេត្ដ ហ្គាន់ម៉ា",
      "neName": "गुन्मा जिल्ला"
    },
    "class10": {
      "code": "100010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "群马县南部",
      "zhName": "群馬縣南部",
      "koName": "군마 현 남부",
      "esName": "Sur de Prefectura de Gunma",
      "ptName": "Sul da Província de Gunma",
      "thName": "จังหวัดกุมมะตอนใต้",
      "viName": "Miền Nam tỉnh Gunma",
      "inName": "Bagian Selatan Prefektur Gunma",
      "tlName": "Timog na bahagi ng Gunma Prefecture",
      "moName": "Өмнөд Гүнма аймаг",
      "buName": "ဂွန်းမစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដហ្គឹនម៉ា",
      "neName": "गुन्मा जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "100011",
      "name": "前橋・桐生地域",
      "enName": "Maebashi Kiryu Area"
    },
    "class20": {
      "code": "1021200",
      "name": "みどり市",
      "enName": "Midori City",
      "kana": "みどりし",
      "chName": "绿市",
      "zhName": "綠市",
      "koName": "미도리 시",
      "esName": "Ciudad de Midori",
      "ptName": "cidade de Midori",
      "thName": "เมืองมิโดริ",
      "viName": "thành phố Midori",
      "inName": "kota Midori",
      "tlName": "siyudad ng Midori",
      "moName": "Мидори хот",
      "buName": "မီဒိုးရိ မြို့",
      "khName": "ទីក្រុង មីដូរី",
      "neName": "मिदोरी सहर"
    }
  },
  "1034400": {
    "office": {
      "code": "100000",
      "name": "群馬県",
      "enName": "Gunma",
      "officeName": "前橋地方気象台",
      "chName": "群马县",
      "zhName": "群馬縣",
      "koName": "군마현",
      "esName": "Prefectura de Gunma",
      "ptName": "Província de Gunma",
      "thName": "จังหวัดกุมมะ",
      "viName": "Tỉnh Gunma",
      "inName": "Prefektur Gunma",
      "tlName": "Gunma Prefecture",
      "moName": "Гүнма аймаг",
      "buName": "ဂူးမ ပြည်နယ်",
      "khName": "ខេត្ដ ហ្គាន់ម៉ា",
      "neName": "गुन्मा जिल्ला"
    },
    "class10": {
      "code": "100010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "群马县南部",
      "zhName": "群馬縣南部",
      "koName": "군마 현 남부",
      "esName": "Sur de Prefectura de Gunma",
      "ptName": "Sul da Província de Gunma",
      "thName": "จังหวัดกุมมะตอนใต้",
      "viName": "Miền Nam tỉnh Gunma",
      "inName": "Bagian Selatan Prefektur Gunma",
      "tlName": "Timog na bahagi ng Gunma Prefecture",
      "moName": "Өмнөд Гүнма аймаг",
      "buName": "ဂွန်းမစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដហ្គឹនម៉ា",
      "neName": "गुन्मा जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "100011",
      "name": "前橋・桐生地域",
      "enName": "Maebashi Kiryu Area"
    },
    "class20": {
      "code": "1034400",
      "name": "榛東村",
      "enName": "Shinto Village",
      "kana": "しんとうむら",
      "chName": "榛东村",
      "zhName": "榛東村",
      "koName": "신토 촌",
      "esName": "Aldea de Shintō",
      "ptName": "povoado de Shinto",
      "thName": "หมู่บ้านชินโต",
      "viName": "làng Shinto",
      "inName": "desa Shinto",
      "tlName": "nayon ng Shinto",
      "moName": "Шинто тосгон",
      "buName": "ရှင်းတော့ ကျေးရွာ",
      "khName": "ភូមិ ស៊ិនតុ",
      "neName": "शिन्तो गाउँ"
    }
  },
  "1034500": {
    "office": {
      "code": "100000",
      "name": "群馬県",
      "enName": "Gunma",
      "officeName": "前橋地方気象台",
      "chName": "群马县",
      "zhName": "群馬縣",
      "koName": "군마현",
      "esName": "Prefectura de Gunma",
      "ptName": "Província de Gunma",
      "thName": "จังหวัดกุมมะ",
      "viName": "Tỉnh Gunma",
      "inName": "Prefektur Gunma",
      "tlName": "Gunma Prefecture",
      "moName": "Гүнма аймаг",
      "buName": "ဂူးမ ပြည်နယ်",
      "khName": "ខេត្ដ ហ្គាន់ម៉ា",
      "neName": "गुन्मा जिल्ला"
    },
    "class10": {
      "code": "100010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "群马县南部",
      "zhName": "群馬縣南部",
      "koName": "군마 현 남부",
      "esName": "Sur de Prefectura de Gunma",
      "ptName": "Sul da Província de Gunma",
      "thName": "จังหวัดกุมมะตอนใต้",
      "viName": "Miền Nam tỉnh Gunma",
      "inName": "Bagian Selatan Prefektur Gunma",
      "tlName": "Timog na bahagi ng Gunma Prefecture",
      "moName": "Өмнөд Гүнма аймаг",
      "buName": "ဂွန်းမစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដហ្គឹនម៉ា",
      "neName": "गुन्मा जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "100011",
      "name": "前橋・桐生地域",
      "enName": "Maebashi Kiryu Area"
    },
    "class20": {
      "code": "1034500",
      "name": "吉岡町",
      "enName": "Yoshioka Town",
      "kana": "よしおかまち",
      "chName": "吉冈町",
      "zhName": "吉岡町",
      "koName": "요시오카 정",
      "esName": "Pueblo de Yoshioka",
      "ptName": "bairro de Yoshioka",
      "thName": "เมืองโยชิโอกะ",
      "viName": "thị trấn Yoshioka",
      "inName": "kota Yoshioka",
      "tlName": "bayan ng Yoshioka",
      "moName": "Ёшиока жижиг хот",
      "buName": "ယိုရှိယို့က မြို့နယ်",
      "khName": "ទីប្រជុំជន យ៉ូស៊ីអូកា",
      "neName": "योशिओका नगर"
    }
  },
  "1036600": {
    "office": {
      "code": "100000",
      "name": "群馬県",
      "enName": "Gunma",
      "officeName": "前橋地方気象台",
      "chName": "群马县",
      "zhName": "群馬縣",
      "koName": "군마현",
      "esName": "Prefectura de Gunma",
      "ptName": "Província de Gunma",
      "thName": "จังหวัดกุมมะ",
      "viName": "Tỉnh Gunma",
      "inName": "Prefektur Gunma",
      "tlName": "Gunma Prefecture",
      "moName": "Гүнма аймаг",
      "buName": "ဂူးမ ပြည်နယ်",
      "khName": "ខេត្ដ ហ្គាន់ម៉ា",
      "neName": "गुन्मा जिल्ला"
    },
    "class10": {
      "code": "100010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "群马县南部",
      "zhName": "群馬縣南部",
      "koName": "군마 현 남부",
      "esName": "Sur de Prefectura de Gunma",
      "ptName": "Sul da Província de Gunma",
      "thName": "จังหวัดกุมมะตอนใต้",
      "viName": "Miền Nam tỉnh Gunma",
      "inName": "Bagian Selatan Prefektur Gunma",
      "tlName": "Timog na bahagi ng Gunma Prefecture",
      "moName": "Өмнөд Гүнма аймаг",
      "buName": "ဂွန်းမစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដហ្គឹនម៉ា",
      "neName": "गुन्मा जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "100013",
      "name": "高崎・藤岡地域",
      "enName": "Takasaki Fujioka Area"
    },
    "class20": {
      "code": "1036600",
      "name": "上野村",
      "enName": "Ueno Village",
      "kana": "うえのむら",
      "chName": "群马上野村",
      "zhName": "群馬上野村",
      "koName": "군마 우에노 촌",
      "esName": "Aldea de Ueno, Gunma",
      "ptName": "Gunma, povoado de Ueno",
      "thName": "หมู่บ้านอุเอโนะ กุมมะ",
      "viName": "Làng Ueno, Gunma",
      "inName": "Desa Ueno, Gunma",
      "tlName": "nayon ng Ueno, Gunma",
      "moName": "Гүнма Үэно тосгон",
      "buName": "ဂွန်းမအုအဲနိုရွာ",
      "khName": "ភូមអឹអេណុ ហ្គឹនម៉ា",
      "neName": "गुन्मा उएनो गाउँ"
    }
  },
  "1036700": {
    "office": {
      "code": "100000",
      "name": "群馬県",
      "enName": "Gunma",
      "officeName": "前橋地方気象台",
      "chName": "群马县",
      "zhName": "群馬縣",
      "koName": "군마현",
      "esName": "Prefectura de Gunma",
      "ptName": "Província de Gunma",
      "thName": "จังหวัดกุมมะ",
      "viName": "Tỉnh Gunma",
      "inName": "Prefektur Gunma",
      "tlName": "Gunma Prefecture",
      "moName": "Гүнма аймаг",
      "buName": "ဂူးမ ပြည်နယ်",
      "khName": "ខេត្ដ ហ្គាន់ម៉ា",
      "neName": "गुन्मा जिल्ला"
    },
    "class10": {
      "code": "100010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "群马县南部",
      "zhName": "群馬縣南部",
      "koName": "군마 현 남부",
      "esName": "Sur de Prefectura de Gunma",
      "ptName": "Sul da Província de Gunma",
      "thName": "จังหวัดกุมมะตอนใต้",
      "viName": "Miền Nam tỉnh Gunma",
      "inName": "Bagian Selatan Prefektur Gunma",
      "tlName": "Timog na bahagi ng Gunma Prefecture",
      "moName": "Өмнөд Гүнма аймаг",
      "buName": "ဂွန်းမစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដហ្គឹនម៉ា",
      "neName": "गुन्मा जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "100013",
      "name": "高崎・藤岡地域",
      "enName": "Takasaki Fujioka Area"
    },
    "class20": {
      "code": "1036700",
      "name": "神流町",
      "enName": "Kanna Town",
      "kana": "かんなまち",
      "chName": "神流町",
      "zhName": "神流町",
      "koName": "간나 정",
      "esName": "Pueblo de Kanna",
      "ptName": "bairro de Kanna",
      "thName": "เมืองคันนะ",
      "viName": "thị trấn Kanna",
      "inName": "kota Kanna",
      "tlName": "bayan ng Kanna",
      "moName": "Каннa жижиг хот",
      "buName": "ခန်းဏ မြို့နယ်",
      "khName": "ទីប្រជុំជន កានណា",
      "neName": "कान्ना नगर"
    }
  },
  "1038200": {
    "office": {
      "code": "100000",
      "name": "群馬県",
      "enName": "Gunma",
      "officeName": "前橋地方気象台",
      "chName": "群马县",
      "zhName": "群馬縣",
      "koName": "군마현",
      "esName": "Prefectura de Gunma",
      "ptName": "Província de Gunma",
      "thName": "จังหวัดกุมมะ",
      "viName": "Tỉnh Gunma",
      "inName": "Prefektur Gunma",
      "tlName": "Gunma Prefecture",
      "moName": "Гүнма аймаг",
      "buName": "ဂူးမ ပြည်နယ်",
      "khName": "ខេត្ដ ហ្គាន់ម៉ា",
      "neName": "गुन्मा जिल्ला"
    },
    "class10": {
      "code": "100010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "群马县南部",
      "zhName": "群馬縣南部",
      "koName": "군마 현 남부",
      "esName": "Sur de Prefectura de Gunma",
      "ptName": "Sul da Província de Gunma",
      "thName": "จังหวัดกุมมะตอนใต้",
      "viName": "Miền Nam tỉnh Gunma",
      "inName": "Bagian Selatan Prefektur Gunma",
      "tlName": "Timog na bahagi ng Gunma Prefecture",
      "moName": "Өмнөд Гүнма аймаг",
      "buName": "ဂွန်းမစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដហ្គឹនម៉ា",
      "neName": "गुन्मा जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "100013",
      "name": "高崎・藤岡地域",
      "enName": "Takasaki Fujioka Area"
    },
    "class20": {
      "code": "1038200",
      "name": "下仁田町",
      "enName": "Shimonita Town",
      "kana": "しもにたまち",
      "chName": "下仁田町",
      "zhName": "下仁田町",
      "koName": "시모니타 정",
      "esName": "Pueblo de Shimonita",
      "ptName": "bairro de Shimonita",
      "thName": "เมืองชิโมนิตะ",
      "viName": "thị trấn Shimonita",
      "inName": "kota Shimonita",
      "tlName": "bayan ng Shimonita",
      "moName": "Шимонита жижиг хот",
      "buName": "ရှီမိုးနိတ မြို့နယ်",
      "khName": "ទីប្រជុំជន ស៊ីម៉ុនីតា",
      "neName": "शिमोनिता नगर"
    }
  },
  "1038300": {
    "office": {
      "code": "100000",
      "name": "群馬県",
      "enName": "Gunma",
      "officeName": "前橋地方気象台",
      "chName": "群马县",
      "zhName": "群馬縣",
      "koName": "군마현",
      "esName": "Prefectura de Gunma",
      "ptName": "Província de Gunma",
      "thName": "จังหวัดกุมมะ",
      "viName": "Tỉnh Gunma",
      "inName": "Prefektur Gunma",
      "tlName": "Gunma Prefecture",
      "moName": "Гүнма аймаг",
      "buName": "ဂူးမ ပြည်နယ်",
      "khName": "ខេត្ដ ហ្គាន់ម៉ា",
      "neName": "गुन्मा जिल्ला"
    },
    "class10": {
      "code": "100010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "群马县南部",
      "zhName": "群馬縣南部",
      "koName": "군마 현 남부",
      "esName": "Sur de Prefectura de Gunma",
      "ptName": "Sul da Província de Gunma",
      "thName": "จังหวัดกุมมะตอนใต้",
      "viName": "Miền Nam tỉnh Gunma",
      "inName": "Bagian Selatan Prefektur Gunma",
      "tlName": "Timog na bahagi ng Gunma Prefecture",
      "moName": "Өмнөд Гүнма аймаг",
      "buName": "ဂွန်းမစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដហ្គឹនម៉ា",
      "neName": "गुन्मा जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "100013",
      "name": "高崎・藤岡地域",
      "enName": "Takasaki Fujioka Area"
    },
    "class20": {
      "code": "1038300",
      "name": "南牧村",
      "enName": "Nammoku Village",
      "kana": "なんもくむら",
      "chName": "群马南牧村",
      "zhName": "群馬南牧村",
      "koName": "군마 난모쿠 촌",
      "esName": "Aldea de Nanmoku, Gunma",
      "ptName": "Gunma, povoado de Nanmoku",
      "thName": "หมู่บ้านนัมโมขุ กุมมะ",
      "viName": "Làng Nammoku, Gunma",
      "inName": "Desa Nammoku, Gunma",
      "tlName": "nayon ng Nanmoku, Gunma",
      "moName": "Гүнма Нанмокү тосгон",
      "buName": "ဂွန်းမနန်းမိုခုရွာ",
      "khName": "ភូមិណាំម៉ុគូ ហ្គឹនម៉ា",
      "neName": "गुन्मा नाम्मोकु गाउँ"
    }
  },
  "1038400": {
    "office": {
      "code": "100000",
      "name": "群馬県",
      "enName": "Gunma",
      "officeName": "前橋地方気象台",
      "chName": "群马县",
      "zhName": "群馬縣",
      "koName": "군마현",
      "esName": "Prefectura de Gunma",
      "ptName": "Província de Gunma",
      "thName": "จังหวัดกุมมะ",
      "viName": "Tỉnh Gunma",
      "inName": "Prefektur Gunma",
      "tlName": "Gunma Prefecture",
      "moName": "Гүнма аймаг",
      "buName": "ဂူးမ ပြည်နယ်",
      "khName": "ខេត្ដ ហ្គាន់ម៉ា",
      "neName": "गुन्मा जिल्ला"
    },
    "class10": {
      "code": "100010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "群马县南部",
      "zhName": "群馬縣南部",
      "koName": "군마 현 남부",
      "esName": "Sur de Prefectura de Gunma",
      "ptName": "Sul da Província de Gunma",
      "thName": "จังหวัดกุมมะตอนใต้",
      "viName": "Miền Nam tỉnh Gunma",
      "inName": "Bagian Selatan Prefektur Gunma",
      "tlName": "Timog na bahagi ng Gunma Prefecture",
      "moName": "Өмнөд Гүнма аймаг",
      "buName": "ဂွန်းမစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដហ្គឹនម៉ា",
      "neName": "गुन्मा जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "100013",
      "name": "高崎・藤岡地域",
      "enName": "Takasaki Fujioka Area"
    },
    "class20": {
      "code": "1038400",
      "name": "甘楽町",
      "enName": "Kanra Town",
      "kana": "かんらまち",
      "chName": "甘乐町",
      "zhName": "甘樂町",
      "koName": "간라 정",
      "esName": "Pueblo de Kanra",
      "ptName": "bairro de Kanra",
      "thName": "เมืองคันระ",
      "viName": "thị trấn Kanra",
      "inName": "kota Kanra",
      "tlName": "bayan ng Kanra",
      "moName": "Канра жижиг хот",
      "buName": "ခန်းရာ့ မြို့နယ်",
      "khName": "ទីប្រជុំជន កានរ៉ា",
      "neName": "कानरा नगर"
    }
  },
  "1042100": {
    "office": {
      "code": "100000",
      "name": "群馬県",
      "enName": "Gunma",
      "officeName": "前橋地方気象台",
      "chName": "群马县",
      "zhName": "群馬縣",
      "koName": "군마현",
      "esName": "Prefectura de Gunma",
      "ptName": "Província de Gunma",
      "thName": "จังหวัดกุมมะ",
      "viName": "Tỉnh Gunma",
      "inName": "Prefektur Gunma",
      "tlName": "Gunma Prefecture",
      "moName": "Гүнма аймаг",
      "buName": "ဂူးမ ပြည်နယ်",
      "khName": "ខេត្ដ ហ្គាន់ម៉ា",
      "neName": "गुन्मा जिल्ला"
    },
    "class10": {
      "code": "100020",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "群马县北部",
      "zhName": "群馬縣北部",
      "koName": "군마 현 북부",
      "esName": "Norte de Prefectura de Gunma",
      "ptName": "Norte da Província de Gunma",
      "thName": "จังหวัดกุมมะตอนเหนือ",
      "viName": "Miền Bắc tỉnh Gunma",
      "inName": "Bagian Utara Prefektur Gunma",
      "tlName": "Hilagang bahagi ng Gunma Prefecture",
      "moName": "Хойд Гүнма аймаг",
      "buName": "ဂွန်းမစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដហ្គឹនម៉ា",
      "neName": "गुन्मा जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "100022",
      "name": "吾妻地域",
      "enName": "Agatsuma Area"
    },
    "class20": {
      "code": "1042100",
      "name": "中之条町",
      "enName": "Nakanojo Town",
      "kana": "なかのじょうまち",
      "chName": "中之条町",
      "zhName": "中之條町",
      "koName": "나카노조 정",
      "esName": "Pueblo de Nakanojyo",
      "ptName": "bairro de Nakanojo",
      "thName": "เมืองนากาโนโจ",
      "viName": "thị trấn Nakanojo",
      "inName": "kota Nakanojo",
      "tlName": "bayan ng Nakanojo",
      "moName": "Наканожо жижиг хот",
      "buName": "နာကနိုဂျို မြို့နယ်",
      "khName": "ទីប្រជុំជន ណាកានណូចូ",
      "neName": "नाकानोजो नगर"
    }
  },
  "1042400": {
    "office": {
      "code": "100000",
      "name": "群馬県",
      "enName": "Gunma",
      "officeName": "前橋地方気象台",
      "chName": "群马县",
      "zhName": "群馬縣",
      "koName": "군마현",
      "esName": "Prefectura de Gunma",
      "ptName": "Província de Gunma",
      "thName": "จังหวัดกุมมะ",
      "viName": "Tỉnh Gunma",
      "inName": "Prefektur Gunma",
      "tlName": "Gunma Prefecture",
      "moName": "Гүнма аймаг",
      "buName": "ဂူးမ ပြည်နယ်",
      "khName": "ខេត្ដ ហ្គាន់ម៉ា",
      "neName": "गुन्मा जिल्ला"
    },
    "class10": {
      "code": "100020",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "群马县北部",
      "zhName": "群馬縣北部",
      "koName": "군마 현 북부",
      "esName": "Norte de Prefectura de Gunma",
      "ptName": "Norte da Província de Gunma",
      "thName": "จังหวัดกุมมะตอนเหนือ",
      "viName": "Miền Bắc tỉnh Gunma",
      "inName": "Bagian Utara Prefektur Gunma",
      "tlName": "Hilagang bahagi ng Gunma Prefecture",
      "moName": "Хойд Гүнма аймаг",
      "buName": "ဂွန်းမစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដហ្គឹនម៉ា",
      "neName": "गुन्मा जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "100022",
      "name": "吾妻地域",
      "enName": "Agatsuma Area"
    },
    "class20": {
      "code": "1042400",
      "name": "長野原町",
      "enName": "Naganohara Town",
      "kana": "ながのはらまち",
      "chName": "长野原町",
      "zhName": "長野原町",
      "koName": "나가노하라 정",
      "esName": "Pueblo de Naganohara",
      "ptName": "bairro de Naganohara",
      "thName": "เมืองนากาโนฮาระ",
      "viName": "thị trấn Naganohara",
      "inName": "kota Naganohara",
      "tlName": "bayan ng Naganohara",
      "moName": "Нaгaнохaра жижиг хот",
      "buName": "နာဂါနောဟာ့ရ မြို့နယ်",
      "khName": "ទីប្រជុំជន ណាហ្គាណូហារ៉ា",
      "neName": "नागानोहारा नगर"
    }
  },
  "1042500": {
    "office": {
      "code": "100000",
      "name": "群馬県",
      "enName": "Gunma",
      "officeName": "前橋地方気象台",
      "chName": "群马县",
      "zhName": "群馬縣",
      "koName": "군마현",
      "esName": "Prefectura de Gunma",
      "ptName": "Província de Gunma",
      "thName": "จังหวัดกุมมะ",
      "viName": "Tỉnh Gunma",
      "inName": "Prefektur Gunma",
      "tlName": "Gunma Prefecture",
      "moName": "Гүнма аймаг",
      "buName": "ဂူးမ ပြည်နယ်",
      "khName": "ខេត្ដ ហ្គាន់ម៉ា",
      "neName": "गुन्मा जिल्ला"
    },
    "class10": {
      "code": "100020",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "群马县北部",
      "zhName": "群馬縣北部",
      "koName": "군마 현 북부",
      "esName": "Norte de Prefectura de Gunma",
      "ptName": "Norte da Província de Gunma",
      "thName": "จังหวัดกุมมะตอนเหนือ",
      "viName": "Miền Bắc tỉnh Gunma",
      "inName": "Bagian Utara Prefektur Gunma",
      "tlName": "Hilagang bahagi ng Gunma Prefecture",
      "moName": "Хойд Гүнма аймаг",
      "buName": "ဂွန်းမစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដហ្គឹនម៉ា",
      "neName": "गुन्मा जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "100022",
      "name": "吾妻地域",
      "enName": "Agatsuma Area"
    },
    "class20": {
      "code": "1042500",
      "name": "嬬恋村",
      "enName": "Tsumagoi Village",
      "kana": "つまごいむら",
      "chName": "嬬恋村",
      "zhName": "嬬戀村",
      "koName": "쓰마고이 촌",
      "esName": "Aldea de Tsumagoi",
      "ptName": "povoado de Tsumagoi",
      "thName": "หมู่บ้านสึมาโงอิ",
      "viName": "làng Tsumagoi",
      "inName": "desa Tsumagoi",
      "tlName": "nayon ng Tsumagoi",
      "moName": "Цүмaгой тосгон",
      "buName": "ဆူမားဂို့အိ ကျေးရွာ",
      "khName": "ភូមិ ស៊ូម៉ាហ្គយ",
      "neName": "त्सुमागोइ गाउँ"
    }
  },
  "1042600": {
    "office": {
      "code": "100000",
      "name": "群馬県",
      "enName": "Gunma",
      "officeName": "前橋地方気象台",
      "chName": "群马县",
      "zhName": "群馬縣",
      "koName": "군마현",
      "esName": "Prefectura de Gunma",
      "ptName": "Província de Gunma",
      "thName": "จังหวัดกุมมะ",
      "viName": "Tỉnh Gunma",
      "inName": "Prefektur Gunma",
      "tlName": "Gunma Prefecture",
      "moName": "Гүнма аймаг",
      "buName": "ဂူးမ ပြည်နယ်",
      "khName": "ខេត្ដ ហ្គាន់ម៉ា",
      "neName": "गुन्मा जिल्ला"
    },
    "class10": {
      "code": "100020",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "群马县北部",
      "zhName": "群馬縣北部",
      "koName": "군마 현 북부",
      "esName": "Norte de Prefectura de Gunma",
      "ptName": "Norte da Província de Gunma",
      "thName": "จังหวัดกุมมะตอนเหนือ",
      "viName": "Miền Bắc tỉnh Gunma",
      "inName": "Bagian Utara Prefektur Gunma",
      "tlName": "Hilagang bahagi ng Gunma Prefecture",
      "moName": "Хойд Гүнма аймаг",
      "buName": "ဂွန်းမစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដហ្គឹនម៉ា",
      "neName": "गुन्मा जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "100022",
      "name": "吾妻地域",
      "enName": "Agatsuma Area"
    },
    "class20": {
      "code": "1042600",
      "name": "草津町",
      "enName": "Kusatsu Town",
      "kana": "くさつまち",
      "chName": "草津町",
      "zhName": "草津町",
      "koName": "구사쓰 정",
      "esName": "Pueblo de Kusatsu",
      "ptName": "bairro de Kusatsu",
      "thName": "เมืองคุซัตสึ",
      "viName": "thị trấn Kusatsu",
      "inName": "kota Kusatsu",
      "tlName": "bayan ng Kusatsu",
      "moName": "Күсaцү жижиг хот",
      "buName": "ခူဆာ့စု မြို့နယ်",
      "khName": "ទីប្រជុំជន គូសាត់ស៊ូ",
      "neName": "कुसात्सु नगर"
    }
  },
  "1042800": {
    "office": {
      "code": "100000",
      "name": "群馬県",
      "enName": "Gunma",
      "officeName": "前橋地方気象台",
      "chName": "群马县",
      "zhName": "群馬縣",
      "koName": "군마현",
      "esName": "Prefectura de Gunma",
      "ptName": "Província de Gunma",
      "thName": "จังหวัดกุมมะ",
      "viName": "Tỉnh Gunma",
      "inName": "Prefektur Gunma",
      "tlName": "Gunma Prefecture",
      "moName": "Гүнма аймаг",
      "buName": "ဂူးမ ပြည်နယ်",
      "khName": "ខេត្ដ ហ្គាន់ម៉ា",
      "neName": "गुन्मा जिल्ला"
    },
    "class10": {
      "code": "100020",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "群马县北部",
      "zhName": "群馬縣北部",
      "koName": "군마 현 북부",
      "esName": "Norte de Prefectura de Gunma",
      "ptName": "Norte da Província de Gunma",
      "thName": "จังหวัดกุมมะตอนเหนือ",
      "viName": "Miền Bắc tỉnh Gunma",
      "inName": "Bagian Utara Prefektur Gunma",
      "tlName": "Hilagang bahagi ng Gunma Prefecture",
      "moName": "Хойд Гүнма аймаг",
      "buName": "ဂွန်းမစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដហ្គឹនម៉ា",
      "neName": "गुन्मा जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "100022",
      "name": "吾妻地域",
      "enName": "Agatsuma Area"
    },
    "class20": {
      "code": "1042800",
      "name": "高山村",
      "enName": "Takayama Village",
      "kana": "たかやまむら",
      "chName": "群马高山村",
      "zhName": "群馬高山村",
      "koName": "군마 다카야마 촌",
      "esName": "Aldea de Takayama, Gunma",
      "ptName": "Gunma, povoado de Takayama",
      "thName": "หมู่บ้านทากายามะ กุมมะ",
      "viName": "Làng Takayama, Gunma",
      "inName": "Desa Takayama, Gunma",
      "tlName": "nayon ng Takayama, Gunma",
      "moName": "Гүнма Такаяма тосгон",
      "buName": "ဂွန်းမတကယမရွာ",
      "khName": "ភូមិតាកាយ៉ាម៉ា ហ្គឹនម៉ា",
      "neName": "गुन्मा ताकायामा गाउँ"
    }
  },
  "1042900": {
    "office": {
      "code": "100000",
      "name": "群馬県",
      "enName": "Gunma",
      "officeName": "前橋地方気象台",
      "chName": "群马县",
      "zhName": "群馬縣",
      "koName": "군마현",
      "esName": "Prefectura de Gunma",
      "ptName": "Província de Gunma",
      "thName": "จังหวัดกุมมะ",
      "viName": "Tỉnh Gunma",
      "inName": "Prefektur Gunma",
      "tlName": "Gunma Prefecture",
      "moName": "Гүнма аймаг",
      "buName": "ဂူးမ ပြည်နယ်",
      "khName": "ខេត្ដ ហ្គាន់ម៉ា",
      "neName": "गुन्मा जिल्ला"
    },
    "class10": {
      "code": "100020",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "群马县北部",
      "zhName": "群馬縣北部",
      "koName": "군마 현 북부",
      "esName": "Norte de Prefectura de Gunma",
      "ptName": "Norte da Província de Gunma",
      "thName": "จังหวัดกุมมะตอนเหนือ",
      "viName": "Miền Bắc tỉnh Gunma",
      "inName": "Bagian Utara Prefektur Gunma",
      "tlName": "Hilagang bahagi ng Gunma Prefecture",
      "moName": "Хойд Гүнма аймаг",
      "buName": "ဂွန်းမစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដហ្គឹនម៉ា",
      "neName": "गुन्मा जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "100022",
      "name": "吾妻地域",
      "enName": "Agatsuma Area"
    },
    "class20": {
      "code": "1042900",
      "name": "東吾妻町",
      "enName": "Higashiagatsuma Town",
      "kana": "ひがしあがつままち",
      "chName": "东吾妻町",
      "zhName": "東吾妻町",
      "koName": "히가시아가쓰마 정",
      "esName": "Pueblo de Higashiagatsuma",
      "ptName": "bairro de Higashiagatsuma",
      "thName": "เมืองฮิงาชิอางะสึมะ",
      "viName": "thị trấn Higashiagatsuma",
      "inName": "kota Higashiagatsuma",
      "tlName": "bayan ng Higashiagatsuma",
      "moName": "Хигaшиaгaцүмa жижиг хот",
      "buName": "ဟီဂါရှိယဂါ့ဆုမ မြို့နယ်",
      "khName": "ទីប្រជុំជន ហ៊ីហ្កាស៊ីអាកាតស៊ូម៉ា",
      "neName": "हिगाशियागात्सुमा नगर"
    }
  },
  "1044300": {
    "office": {
      "code": "100000",
      "name": "群馬県",
      "enName": "Gunma",
      "officeName": "前橋地方気象台",
      "chName": "群马县",
      "zhName": "群馬縣",
      "koName": "군마현",
      "esName": "Prefectura de Gunma",
      "ptName": "Província de Gunma",
      "thName": "จังหวัดกุมมะ",
      "viName": "Tỉnh Gunma",
      "inName": "Prefektur Gunma",
      "tlName": "Gunma Prefecture",
      "moName": "Гүнма аймаг",
      "buName": "ဂူးမ ပြည်နယ်",
      "khName": "ខេត្ដ ហ្គាន់ម៉ា",
      "neName": "गुन्मा जिल्ला"
    },
    "class10": {
      "code": "100020",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "群马县北部",
      "zhName": "群馬縣北部",
      "koName": "군마 현 북부",
      "esName": "Norte de Prefectura de Gunma",
      "ptName": "Norte da Província de Gunma",
      "thName": "จังหวัดกุมมะตอนเหนือ",
      "viName": "Miền Bắc tỉnh Gunma",
      "inName": "Bagian Utara Prefektur Gunma",
      "tlName": "Hilagang bahagi ng Gunma Prefecture",
      "moName": "Хойд Гүнма аймаг",
      "buName": "ဂွန်းမစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដហ្គឹនម៉ា",
      "neName": "गुन्मा जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "100021",
      "name": "利根・沼田地域",
      "enName": "Tone Numata Area"
    },
    "class20": {
      "code": "1044300",
      "name": "片品村",
      "enName": "Katashina Village",
      "kana": "かたしなむら",
      "chName": "片品村",
      "zhName": "片品村",
      "koName": "가타시나 촌",
      "esName": "Aldea de Katashina",
      "ptName": "povoado de Katashina",
      "thName": "หมู่บ้านคาตะชินะ",
      "viName": "làng Katashina",
      "inName": "desa Katashina",
      "tlName": "nayon ng Katashina",
      "moName": "Каташинa тосгон",
      "buName": "ခါတာ့ရှိဏ ကျေးရွာ",
      "khName": "ភូមិ កាតាស៊ីណា",
      "neName": "काताशिना गाउँ"
    }
  },
  "1044400": {
    "office": {
      "code": "100000",
      "name": "群馬県",
      "enName": "Gunma",
      "officeName": "前橋地方気象台",
      "chName": "群马县",
      "zhName": "群馬縣",
      "koName": "군마현",
      "esName": "Prefectura de Gunma",
      "ptName": "Província de Gunma",
      "thName": "จังหวัดกุมมะ",
      "viName": "Tỉnh Gunma",
      "inName": "Prefektur Gunma",
      "tlName": "Gunma Prefecture",
      "moName": "Гүнма аймаг",
      "buName": "ဂူးမ ပြည်နယ်",
      "khName": "ខេត្ដ ហ្គាន់ម៉ា",
      "neName": "गुन्मा जिल्ला"
    },
    "class10": {
      "code": "100020",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "群马县北部",
      "zhName": "群馬縣北部",
      "koName": "군마 현 북부",
      "esName": "Norte de Prefectura de Gunma",
      "ptName": "Norte da Província de Gunma",
      "thName": "จังหวัดกุมมะตอนเหนือ",
      "viName": "Miền Bắc tỉnh Gunma",
      "inName": "Bagian Utara Prefektur Gunma",
      "tlName": "Hilagang bahagi ng Gunma Prefecture",
      "moName": "Хойд Гүнма аймаг",
      "buName": "ဂွန်းမစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដហ្គឹនម៉ា",
      "neName": "गुन्मा जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "100021",
      "name": "利根・沼田地域",
      "enName": "Tone Numata Area"
    },
    "class20": {
      "code": "1044400",
      "name": "川場村",
      "enName": "Kawaba Village",
      "kana": "かわばむら",
      "chName": "川场村",
      "zhName": "川場村",
      "koName": "가와바 촌",
      "esName": "Aldea de Kawaba",
      "ptName": "povoado de Kawaba",
      "thName": "หมู่บ้านคาวาเบะ",
      "viName": "làng Kawaba",
      "inName": "desa Kawaba",
      "tlName": "nayon ng Kawaba",
      "moName": "Каваба тосгон",
      "buName": "ခါဝါးဘ ကျေးရွာ",
      "khName": "ភូមិ កាវ៉ាបា",
      "neName": "कावाबा गाउँ"
    }
  },
  "1044800": {
    "office": {
      "code": "100000",
      "name": "群馬県",
      "enName": "Gunma",
      "officeName": "前橋地方気象台",
      "chName": "群马县",
      "zhName": "群馬縣",
      "koName": "군마현",
      "esName": "Prefectura de Gunma",
      "ptName": "Província de Gunma",
      "thName": "จังหวัดกุมมะ",
      "viName": "Tỉnh Gunma",
      "inName": "Prefektur Gunma",
      "tlName": "Gunma Prefecture",
      "moName": "Гүнма аймаг",
      "buName": "ဂူးမ ပြည်နယ်",
      "khName": "ខេត្ដ ហ្គាន់ម៉ា",
      "neName": "गुन्मा जिल्ला"
    },
    "class10": {
      "code": "100020",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "群马县北部",
      "zhName": "群馬縣北部",
      "koName": "군마 현 북부",
      "esName": "Norte de Prefectura de Gunma",
      "ptName": "Norte da Província de Gunma",
      "thName": "จังหวัดกุมมะตอนเหนือ",
      "viName": "Miền Bắc tỉnh Gunma",
      "inName": "Bagian Utara Prefektur Gunma",
      "tlName": "Hilagang bahagi ng Gunma Prefecture",
      "moName": "Хойд Гүнма аймаг",
      "buName": "ဂွန်းမစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដហ្គឹនម៉ា",
      "neName": "गुन्मा जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "100021",
      "name": "利根・沼田地域",
      "enName": "Tone Numata Area"
    },
    "class20": {
      "code": "1044800",
      "name": "昭和村",
      "enName": "Showa Village",
      "kana": "しょうわむら",
      "chName": "群马昭和村",
      "zhName": "群馬昭和村",
      "koName": "군마 쇼와 촌",
      "esName": "Aldea de Showa, Gunma",
      "ptName": "Gunma, povoado de Showa",
      "thName": "หมู่บ้านโชวะ กุมมะ",
      "viName": "Làng Showa, Gunma",
      "inName": "Desa Showa, Gunma",
      "tlName": "nayon ng Showa, Gunma",
      "moName": "Гүнма Шоува тосгон",
      "buName": "ဂွန်းမရှောဝရွာ",
      "khName": "ភូមិសូវ៉ា ហ្គឹនម៉ា",
      "neName": "गुन्मा शोवा गाउँ"
    }
  },
  "1044900": {
    "office": {
      "code": "100000",
      "name": "群馬県",
      "enName": "Gunma",
      "officeName": "前橋地方気象台",
      "chName": "群马县",
      "zhName": "群馬縣",
      "koName": "군마현",
      "esName": "Prefectura de Gunma",
      "ptName": "Província de Gunma",
      "thName": "จังหวัดกุมมะ",
      "viName": "Tỉnh Gunma",
      "inName": "Prefektur Gunma",
      "tlName": "Gunma Prefecture",
      "moName": "Гүнма аймаг",
      "buName": "ဂူးမ ပြည်နယ်",
      "khName": "ខេត្ដ ហ្គាន់ម៉ា",
      "neName": "गुन्मा जिल्ला"
    },
    "class10": {
      "code": "100020",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "群马县北部",
      "zhName": "群馬縣北部",
      "koName": "군마 현 북부",
      "esName": "Norte de Prefectura de Gunma",
      "ptName": "Norte da Província de Gunma",
      "thName": "จังหวัดกุมมะตอนเหนือ",
      "viName": "Miền Bắc tỉnh Gunma",
      "inName": "Bagian Utara Prefektur Gunma",
      "tlName": "Hilagang bahagi ng Gunma Prefecture",
      "moName": "Хойд Гүнма аймаг",
      "buName": "ဂွန်းမစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដហ្គឹនម៉ា",
      "neName": "गुन्मा जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "100021",
      "name": "利根・沼田地域",
      "enName": "Tone Numata Area"
    },
    "class20": {
      "code": "1044900",
      "name": "みなかみ町",
      "enName": "Minakami Town",
      "kana": "みなかみまち",
      "chName": "水上町",
      "zhName": "水上町",
      "koName": "미나카미 정",
      "esName": "Pueblo de Minakami",
      "ptName": "bairro de Minakami",
      "thName": "เมืองมานาคามิ",
      "viName": "thị trấn Minakami",
      "inName": "kota Minakami",
      "tlName": "bayan ng Minakami",
      "moName": "Минaками жижиг хот",
      "buName": "မီနားကာ့မိ မြို့နယ်",
      "khName": "ទីប្រជុំជន មីណាកាមី",
      "neName": "मिनाकामी नगर"
    }
  },
  "1046400": {
    "office": {
      "code": "100000",
      "name": "群馬県",
      "enName": "Gunma",
      "officeName": "前橋地方気象台",
      "chName": "群马县",
      "zhName": "群馬縣",
      "koName": "군마현",
      "esName": "Prefectura de Gunma",
      "ptName": "Província de Gunma",
      "thName": "จังหวัดกุมมะ",
      "viName": "Tỉnh Gunma",
      "inName": "Prefektur Gunma",
      "tlName": "Gunma Prefecture",
      "moName": "Гүнма аймаг",
      "buName": "ဂူးမ ပြည်နယ်",
      "khName": "ខេត្ដ ហ្គាន់ម៉ា",
      "neName": "गुन्मा जिल्ला"
    },
    "class10": {
      "code": "100010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "群马县南部",
      "zhName": "群馬縣南部",
      "koName": "군마 현 남부",
      "esName": "Sur de Prefectura de Gunma",
      "ptName": "Sul da Província de Gunma",
      "thName": "จังหวัดกุมมะตอนใต้",
      "viName": "Miền Nam tỉnh Gunma",
      "inName": "Bagian Selatan Prefektur Gunma",
      "tlName": "Timog na bahagi ng Gunma Prefecture",
      "moName": "Өмнөд Гүнма аймаг",
      "buName": "ဂွန်းမစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដហ្គឹនម៉ា",
      "neName": "गुन्मा जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "100012",
      "name": "伊勢崎・太田地域",
      "enName": "Isesaki Ota Area"
    },
    "class20": {
      "code": "1046400",
      "name": "玉村町",
      "enName": "Tamamura Town",
      "kana": "たまむらまち",
      "chName": "玉村町",
      "zhName": "玉村町",
      "koName": "다마무라 정",
      "esName": "Pueblo de Tamamura",
      "ptName": "bairro de Tamamura",
      "thName": "เมืองทามามุระ",
      "viName": "thị trấn Tamamura",
      "inName": "kota Tamamura",
      "tlName": "bayan ng Tamamura",
      "moName": "Тамaмүра жижиг хот",
      "buName": "တာမာ့မုရာ့ မြို့နယ်",
      "khName": "ទីប្រជុំជន តាម៉ាមូរ៉ា",
      "neName": "तामामुरा नगर"
    }
  },
  "1052100": {
    "office": {
      "code": "100000",
      "name": "群馬県",
      "enName": "Gunma",
      "officeName": "前橋地方気象台",
      "chName": "群马县",
      "zhName": "群馬縣",
      "koName": "군마현",
      "esName": "Prefectura de Gunma",
      "ptName": "Província de Gunma",
      "thName": "จังหวัดกุมมะ",
      "viName": "Tỉnh Gunma",
      "inName": "Prefektur Gunma",
      "tlName": "Gunma Prefecture",
      "moName": "Гүнма аймаг",
      "buName": "ဂူးမ ပြည်နယ်",
      "khName": "ខេត្ដ ហ្គាន់ម៉ា",
      "neName": "गुन्मा जिल्ला"
    },
    "class10": {
      "code": "100010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "群马县南部",
      "zhName": "群馬縣南部",
      "koName": "군마 현 남부",
      "esName": "Sur de Prefectura de Gunma",
      "ptName": "Sul da Província de Gunma",
      "thName": "จังหวัดกุมมะตอนใต้",
      "viName": "Miền Nam tỉnh Gunma",
      "inName": "Bagian Selatan Prefektur Gunma",
      "tlName": "Timog na bahagi ng Gunma Prefecture",
      "moName": "Өмнөд Гүнма аймаг",
      "buName": "ဂွန်းမစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដហ្គឹនម៉ា",
      "neName": "गुन्मा जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "100012",
      "name": "伊勢崎・太田地域",
      "enName": "Isesaki Ota Area"
    },
    "class20": {
      "code": "1052100",
      "name": "板倉町",
      "enName": "Itakura Town",
      "kana": "いたくらまち",
      "chName": "板仓町",
      "zhName": "板倉町",
      "koName": "이타쿠라 정",
      "esName": "Pueblo de Itakura",
      "ptName": "bairro de Itakura",
      "thName": "เมืองอิตะคุระ",
      "viName": "thị trấn Itakura",
      "inName": "kota Itakura",
      "tlName": "bayan ng Itakura",
      "moName": "Итакүра жижиг хот",
      "buName": "အီတာ့ကုရာ့ မြို့နယ်",
      "khName": "ទីប្រជុំជន អ៊ីតាគូរ៉ា",
      "neName": "इताकुरा नगर"
    }
  },
  "1052200": {
    "office": {
      "code": "100000",
      "name": "群馬県",
      "enName": "Gunma",
      "officeName": "前橋地方気象台",
      "chName": "群马县",
      "zhName": "群馬縣",
      "koName": "군마현",
      "esName": "Prefectura de Gunma",
      "ptName": "Província de Gunma",
      "thName": "จังหวัดกุมมะ",
      "viName": "Tỉnh Gunma",
      "inName": "Prefektur Gunma",
      "tlName": "Gunma Prefecture",
      "moName": "Гүнма аймаг",
      "buName": "ဂူးမ ပြည်နယ်",
      "khName": "ខេត្ដ ហ្គាន់ម៉ា",
      "neName": "गुन्मा जिल्ला"
    },
    "class10": {
      "code": "100010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "群马县南部",
      "zhName": "群馬縣南部",
      "koName": "군마 현 남부",
      "esName": "Sur de Prefectura de Gunma",
      "ptName": "Sul da Província de Gunma",
      "thName": "จังหวัดกุมมะตอนใต้",
      "viName": "Miền Nam tỉnh Gunma",
      "inName": "Bagian Selatan Prefektur Gunma",
      "tlName": "Timog na bahagi ng Gunma Prefecture",
      "moName": "Өмнөд Гүнма аймаг",
      "buName": "ဂွန်းမစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដហ្គឹនម៉ា",
      "neName": "गुन्मा जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "100012",
      "name": "伊勢崎・太田地域",
      "enName": "Isesaki Ota Area"
    },
    "class20": {
      "code": "1052200",
      "name": "明和町",
      "enName": "Meiwa Town",
      "kana": "めいわまち",
      "chName": "群马明和町",
      "zhName": "群馬明和町",
      "koName": "군마 메이와 정",
      "esName": "Pueblo de Meiwa, Gunma",
      "ptName": "Gunma, bairro de Meiwa",
      "thName": "เมืองเมอิวะ กุมมะ",
      "viName": "Thị trấn Meiwa, Gunma",
      "inName": "Kota Meiwa, Gunma",
      "tlName": "bayan ng Meiwa, Gunma",
      "moName": "Гүнма Мэйва жижиг хот",
      "buName": "ဂွန်းမမဲဝမြို့နယ်",
      "khName": "ទីប្រជុំជនម៉ីវ៉ា ហ្គឹនម៉ា",
      "neName": "गुन्मा मेइवा नगर"
    }
  },
  "1052300": {
    "office": {
      "code": "100000",
      "name": "群馬県",
      "enName": "Gunma",
      "officeName": "前橋地方気象台",
      "chName": "群马县",
      "zhName": "群馬縣",
      "koName": "군마현",
      "esName": "Prefectura de Gunma",
      "ptName": "Província de Gunma",
      "thName": "จังหวัดกุมมะ",
      "viName": "Tỉnh Gunma",
      "inName": "Prefektur Gunma",
      "tlName": "Gunma Prefecture",
      "moName": "Гүнма аймаг",
      "buName": "ဂူးမ ပြည်နယ်",
      "khName": "ខេត្ដ ហ្គាន់ម៉ា",
      "neName": "गुन्मा जिल्ला"
    },
    "class10": {
      "code": "100010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "群马县南部",
      "zhName": "群馬縣南部",
      "koName": "군마 현 남부",
      "esName": "Sur de Prefectura de Gunma",
      "ptName": "Sul da Província de Gunma",
      "thName": "จังหวัดกุมมะตอนใต้",
      "viName": "Miền Nam tỉnh Gunma",
      "inName": "Bagian Selatan Prefektur Gunma",
      "tlName": "Timog na bahagi ng Gunma Prefecture",
      "moName": "Өмнөд Гүнма аймаг",
      "buName": "ဂွန်းမစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដហ្គឹនម៉ា",
      "neName": "गुन्मा जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "100012",
      "name": "伊勢崎・太田地域",
      "enName": "Isesaki Ota Area"
    },
    "class20": {
      "code": "1052300",
      "name": "千代田町",
      "enName": "Chiyoda Town",
      "kana": "ちよだまち",
      "chName": "千代田町",
      "zhName": "千代田町",
      "koName": "지요타 정",
      "esName": "Pueblo de Chiyoda",
      "ptName": "bairro de Chiyoda",
      "thName": "เมืองโยชิดะ",
      "viName": "thị trấn Chiyoda ",
      "inName": "kota Chiyoda",
      "tlName": "bayan ng Chiyoda",
      "moName": "Чиёода жижиг хот",
      "buName": "ကျိရိုးဒ မြို့နယ်",
      "khName": "ទីប្រជុំជន ជីយ៉ូដា",
      "neName": "चियोदा नगर"
    }
  },
  "1052400": {
    "office": {
      "code": "100000",
      "name": "群馬県",
      "enName": "Gunma",
      "officeName": "前橋地方気象台",
      "chName": "群马县",
      "zhName": "群馬縣",
      "koName": "군마현",
      "esName": "Prefectura de Gunma",
      "ptName": "Província de Gunma",
      "thName": "จังหวัดกุมมะ",
      "viName": "Tỉnh Gunma",
      "inName": "Prefektur Gunma",
      "tlName": "Gunma Prefecture",
      "moName": "Гүнма аймаг",
      "buName": "ဂူးမ ပြည်နယ်",
      "khName": "ខេត្ដ ហ្គាន់ម៉ា",
      "neName": "गुन्मा जिल्ला"
    },
    "class10": {
      "code": "100010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "群马县南部",
      "zhName": "群馬縣南部",
      "koName": "군마 현 남부",
      "esName": "Sur de Prefectura de Gunma",
      "ptName": "Sul da Província de Gunma",
      "thName": "จังหวัดกุมมะตอนใต้",
      "viName": "Miền Nam tỉnh Gunma",
      "inName": "Bagian Selatan Prefektur Gunma",
      "tlName": "Timog na bahagi ng Gunma Prefecture",
      "moName": "Өмнөд Гүнма аймаг",
      "buName": "ဂွန်းမစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដហ្គឹនម៉ា",
      "neName": "गुन्मा जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "100012",
      "name": "伊勢崎・太田地域",
      "enName": "Isesaki Ota Area"
    },
    "class20": {
      "code": "1052400",
      "name": "大泉町",
      "enName": "Oizumi Town",
      "kana": "おおいずみまち",
      "chName": "大泉町",
      "zhName": "大泉町",
      "koName": "오이즈미 정",
      "esName": "Pueblo de Oizumi",
      "ptName": "bairro de Oizumi",
      "thName": "เมืองโออิสุมิ",
      "viName": "thị trấn Oizumi",
      "inName": "kota Oizumi",
      "tlName": "bayan ng Oizumi",
      "moName": "Ойзүми жижиг хот",
      "buName": "အိုးယိဇုမိ မြို့နယ်",
      "khName": "ទីប្រជុំជន អយហ្សូមី",
      "neName": "ओइजुमी नगर"
    }
  },
  "1052500": {
    "office": {
      "code": "100000",
      "name": "群馬県",
      "enName": "Gunma",
      "officeName": "前橋地方気象台",
      "chName": "群马县",
      "zhName": "群馬縣",
      "koName": "군마현",
      "esName": "Prefectura de Gunma",
      "ptName": "Província de Gunma",
      "thName": "จังหวัดกุมมะ",
      "viName": "Tỉnh Gunma",
      "inName": "Prefektur Gunma",
      "tlName": "Gunma Prefecture",
      "moName": "Гүнма аймаг",
      "buName": "ဂူးမ ပြည်နယ်",
      "khName": "ខេត្ដ ហ្គាន់ម៉ា",
      "neName": "गुन्मा जिल्ला"
    },
    "class10": {
      "code": "100010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "群马县南部",
      "zhName": "群馬縣南部",
      "koName": "군마 현 남부",
      "esName": "Sur de Prefectura de Gunma",
      "ptName": "Sul da Província de Gunma",
      "thName": "จังหวัดกุมมะตอนใต้",
      "viName": "Miền Nam tỉnh Gunma",
      "inName": "Bagian Selatan Prefektur Gunma",
      "tlName": "Timog na bahagi ng Gunma Prefecture",
      "moName": "Өмнөд Гүнма аймаг",
      "buName": "ဂွန်းမစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដហ្គឹនម៉ា",
      "neName": "गुन्मा जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "100012",
      "name": "伊勢崎・太田地域",
      "enName": "Isesaki Ota Area"
    },
    "class20": {
      "code": "1052500",
      "name": "邑楽町",
      "enName": "Ora Town",
      "kana": "おうらまち",
      "chName": "邑乐町",
      "zhName": "邑樂町",
      "koName": "오라 정",
      "esName": "Pueblo de Oura",
      "ptName": "bairro de Ora",
      "thName": "เมืองโอระ",
      "viName": "thị trấn Ora",
      "inName": "kota Ora",
      "tlName": "bayan ng Ora",
      "moName": "Ора жижиг хот",
      "buName": "အောရာ့ မြို့နယ်",
      "khName": "ទីប្រជុំជន អូរ៉ា",
      "neName": "ओरा नगर"
    }
  },
  "1110000": {
    "office": {
      "code": "110000",
      "name": "埼玉県",
      "enName": "Saitama",
      "officeName": "熊谷地方気象台",
      "chName": "埼玉县",
      "zhName": "埼玉縣",
      "koName": "사이타마현",
      "esName": "Prefectura de Saitama",
      "ptName": "Província de Saitama",
      "thName": "จังหวัดไซตามะ",
      "viName": "Tỉnh Saitama",
      "inName": "Prefektur Saitama",
      "tlName": "Saitama Prefecture",
      "moName": "Сайтама аймаг",
      "buName": "ဆိုက်တာ့မ ပြည်နယ်",
      "khName": "ខេត្ដ សៃតាម៉ា",
      "neName": "साइतामा जिल्ला"
    },
    "class10": {
      "code": "110010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "埼玉县南部",
      "zhName": "埼玉縣南部",
      "koName": "사이타마 현 남부",
      "esName": "Sur de Prefectura de Saitama",
      "ptName": "Sul da Província de Saitama",
      "thName": "จังหวัดไซตามะตอนใต้",
      "viName": "Miền Nam tỉnh Saitama",
      "inName": "Bagian Selatan Prefektur Saitama",
      "tlName": "Timog na bahagi ng Saitama Prefecture",
      "moName": "Өмнөд Сайтама аймаг",
      "buName": "ဆိုင်းတမစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដសៃតាម៉ា",
      "neName": "साइतामा जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "110011",
      "name": "南中部",
      "enName": "Southern Central Region"
    },
    "class20": {
      "code": "1110000",
      "name": "さいたま市",
      "enName": "Saitama City",
      "kana": "さいたまし",
      "chName": "埼玉市",
      "zhName": "埼玉市",
      "koName": "사이타마시",
      "esName": "Ciudad de Saitama",
      "ptName": "Cidade de Saitama",
      "thName": "เมืองไซตามะ",
      "viName": "thành phố Saitama",
      "inName": "Kota Saitama",
      "tlName": "lungsod ng Saitama",
      "moName": "Сайтама хот",
      "buName": "စိုက်တာမာမြို့",
      "khName": "ទីក្រុង សៃតាម៉ា",
      "neName": "साइतामा शहर"
    }
  },
  "1120100": {
    "office": {
      "code": "110000",
      "name": "埼玉県",
      "enName": "Saitama",
      "officeName": "熊谷地方気象台",
      "chName": "埼玉县",
      "zhName": "埼玉縣",
      "koName": "사이타마현",
      "esName": "Prefectura de Saitama",
      "ptName": "Província de Saitama",
      "thName": "จังหวัดไซตามะ",
      "viName": "Tỉnh Saitama",
      "inName": "Prefektur Saitama",
      "tlName": "Saitama Prefecture",
      "moName": "Сайтама аймаг",
      "buName": "ဆိုက်တာ့မ ပြည်နယ်",
      "khName": "ខេត្ដ សៃតាម៉ា",
      "neName": "साइतामा जिल्ला"
    },
    "class10": {
      "code": "110010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "埼玉县南部",
      "zhName": "埼玉縣南部",
      "koName": "사이타마 현 남부",
      "esName": "Sur de Prefectura de Saitama",
      "ptName": "Sul da Província de Saitama",
      "thName": "จังหวัดไซตามะตอนใต้",
      "viName": "Miền Nam tỉnh Saitama",
      "inName": "Bagian Selatan Prefektur Saitama",
      "tlName": "Timog na bahagi ng Saitama Prefecture",
      "moName": "Өмнөд Сайтама аймаг",
      "buName": "ဆိုင်းတမစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដសៃតាម៉ា",
      "neName": "साइतामा जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "110011",
      "name": "南中部",
      "enName": "Southern Central Region"
    },
    "class20": {
      "code": "1120100",
      "name": "川越市",
      "enName": "Kawagoe City",
      "kana": "かわごえし",
      "chName": "川越市",
      "zhName": "川越市",
      "koName": "가와고에 시",
      "esName": "Ciudad de Kawagoe",
      "ptName": "cidade de Kawagoe",
      "thName": "เมืองคาวาโกเอะ",
      "viName": "thành phố Kawagoe",
      "inName": "kota Kawagoe",
      "tlName": "siyudad ng Kawagoe",
      "moName": "Кавагоэ хот",
      "buName": "ခါဝဂို့အဲ့ မြို့",
      "khName": "ទីក្រុង កាវ៉ាហ្គូ",
      "neName": "कावागोए सहर"
    }
  },
  "1120200": {
    "office": {
      "code": "110000",
      "name": "埼玉県",
      "enName": "Saitama",
      "officeName": "熊谷地方気象台",
      "chName": "埼玉县",
      "zhName": "埼玉縣",
      "koName": "사이타마현",
      "esName": "Prefectura de Saitama",
      "ptName": "Província de Saitama",
      "thName": "จังหวัดไซตามะ",
      "viName": "Tỉnh Saitama",
      "inName": "Prefektur Saitama",
      "tlName": "Saitama Prefecture",
      "moName": "Сайтама аймаг",
      "buName": "ဆိုက်တာ့မ ပြည်နယ်",
      "khName": "ខេត្ដ សៃតាម៉ា",
      "neName": "साइतामा जिल्ला"
    },
    "class10": {
      "code": "110020",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "埼玉县北部",
      "zhName": "埼玉縣北部",
      "koName": "사이타마 현 북부",
      "esName": "Norte de Prefectura de Saitama",
      "ptName": "Norte da Província de Saitama",
      "thName": "จังหวัดไซตามะตอนเหนือ",
      "viName": "Miền Bắc tỉnh Saitama",
      "inName": "Bagian Utara Prefektur Saitama",
      "tlName": "Hilagang bahagi ng Saitama Prefecture",
      "moName": "Хойд Сайтама аймаг",
      "buName": "ဆိုင်းတမစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដសៃតាម៉ា",
      "neName": "साइतामा जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "110022",
      "name": "北西部",
      "enName": "North-western Region"
    },
    "class20": {
      "code": "1120200",
      "name": "熊谷市",
      "enName": "Kumagaya City",
      "kana": "くまがやし",
      "chName": "熊谷市",
      "zhName": "熊谷市",
      "koName": "구마가야 시",
      "esName": "Ciudad de Kumagaya",
      "ptName": "cidade de Kumagaya",
      "thName": "เมืองคุมะงายะ",
      "viName": "thành phố Kumagaya",
      "inName": "kota Kumagaya",
      "tlName": "siyudad ng Kumagaya",
      "moName": "Күмaгaя хот",
      "buName": "ကူမားဂါ့ယ မြို့",
      "khName": "ទីក្រុង គូម៉ាហ្គាយ៉ា",
      "neName": "कुमागाया सहर"
    }
  },
  "1120300": {
    "office": {
      "code": "110000",
      "name": "埼玉県",
      "enName": "Saitama",
      "officeName": "熊谷地方気象台",
      "chName": "埼玉县",
      "zhName": "埼玉縣",
      "koName": "사이타마현",
      "esName": "Prefectura de Saitama",
      "ptName": "Província de Saitama",
      "thName": "จังหวัดไซตามะ",
      "viName": "Tỉnh Saitama",
      "inName": "Prefektur Saitama",
      "tlName": "Saitama Prefecture",
      "moName": "Сайтама аймаг",
      "buName": "ဆိုက်တာ့မ ပြည်နယ်",
      "khName": "ខេត្ដ សៃតាម៉ា",
      "neName": "साइतामा जिल्ला"
    },
    "class10": {
      "code": "110010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "埼玉县南部",
      "zhName": "埼玉縣南部",
      "koName": "사이타마 현 남부",
      "esName": "Sur de Prefectura de Saitama",
      "ptName": "Sul da Província de Saitama",
      "thName": "จังหวัดไซตามะตอนใต้",
      "viName": "Miền Nam tỉnh Saitama",
      "inName": "Bagian Selatan Prefektur Saitama",
      "tlName": "Timog na bahagi ng Saitama Prefecture",
      "moName": "Өмнөд Сайтама аймаг",
      "buName": "ဆိုင်းတမစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដសៃតាម៉ា",
      "neName": "साइतामा जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "110011",
      "name": "南中部",
      "enName": "Southern Central Region"
    },
    "class20": {
      "code": "1120300",
      "name": "川口市",
      "enName": "Kawaguchi City",
      "kana": "かわぐちし",
      "chName": "川口市",
      "zhName": "川口市",
      "koName": "가와구치 시",
      "esName": "Ciudad de Kawaguchi",
      "ptName": "cidade de Kawaguchi",
      "thName": "เมืองคาวางุจิ",
      "viName": "thành phố Kawaguchi",
      "inName": "kota Kawaguchi",
      "tlName": "siyudad ng Kawaguchi",
      "moName": "Кавагүчи хот",
      "buName": "ခါဝဂူ့ကျိ မြို့",
      "khName": "ទីក្រុង កាវ៉ាកូជី",
      "neName": "कावागुची सहर"
    }
  },
  "1120600": {
    "office": {
      "code": "110000",
      "name": "埼玉県",
      "enName": "Saitama",
      "officeName": "熊谷地方気象台",
      "chName": "埼玉县",
      "zhName": "埼玉縣",
      "koName": "사이타마현",
      "esName": "Prefectura de Saitama",
      "ptName": "Província de Saitama",
      "thName": "จังหวัดไซตามะ",
      "viName": "Tỉnh Saitama",
      "inName": "Prefektur Saitama",
      "tlName": "Saitama Prefecture",
      "moName": "Сайтама аймаг",
      "buName": "ဆိုက်တာ့မ ပြည်နယ်",
      "khName": "ខេត្ដ សៃតាម៉ា",
      "neName": "साइतामा जिल्ला"
    },
    "class10": {
      "code": "110020",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "埼玉县北部",
      "zhName": "埼玉縣北部",
      "koName": "사이타마 현 북부",
      "esName": "Norte de Prefectura de Saitama",
      "ptName": "Norte da Província de Saitama",
      "thName": "จังหวัดไซตามะตอนเหนือ",
      "viName": "Miền Bắc tỉnh Saitama",
      "inName": "Bagian Utara Prefektur Saitama",
      "tlName": "Hilagang bahagi ng Saitama Prefecture",
      "moName": "Хойд Сайтама аймаг",
      "buName": "ဆိုင်းတမစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដសៃតាម៉ា",
      "neName": "साइतामा जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "110021",
      "name": "北東部",
      "enName": "North-eastern Region"
    },
    "class20": {
      "code": "1120600",
      "name": "行田市",
      "enName": "Gyoda City",
      "kana": "ぎょうだし",
      "chName": "行田市",
      "zhName": "行田市",
      "koName": "교다 시",
      "esName": "Ciudad de Gyoda",
      "ptName": "cidade de Gyoda",
      "thName": "เมืองเกียวดะ",
      "viName": "thành phố Gyoda",
      "inName": "kota Gyoda",
      "tlName": "siyudad ng Gyoda",
      "moName": "Гиодa хот",
      "buName": "ယိုးဒါ့ မြို့",
      "khName": "ទីក្រុង គីយូដា",
      "neName": "ग्योदा सहर"
    }
  },
  "1120700": {
    "office": {
      "code": "110000",
      "name": "埼玉県",
      "enName": "Saitama",
      "officeName": "熊谷地方気象台",
      "chName": "埼玉县",
      "zhName": "埼玉縣",
      "koName": "사이타마현",
      "esName": "Prefectura de Saitama",
      "ptName": "Província de Saitama",
      "thName": "จังหวัดไซตามะ",
      "viName": "Tỉnh Saitama",
      "inName": "Prefektur Saitama",
      "tlName": "Saitama Prefecture",
      "moName": "Сайтама аймаг",
      "buName": "ဆိုက်တာ့မ ပြည်နယ်",
      "khName": "ខេត្ដ សៃតាម៉ា",
      "neName": "साइतामा जिल्ला"
    },
    "class10": {
      "code": "110030",
      "name": "秩父地方",
      "enName": "Chichibu Region",
      "chName": "埼玉县秩父地方",
      "zhName": "埼玉縣秩父地方",
      "koName": "사이타마 현 지치부 지방",
      "esName": "Región Chichibu, Prefectura de Saitama",
      "ptName": "Região de Chichibu da Província de Saitama",
      "thName": "ท้องถิ่นจิจิบุ จังหวัดไซตามะ",
      "viName": "Vùng Chichibu tỉnh Saitama",
      "inName": "Daerah Chichibu di Prefektur Saitama",
      "tlName": "Rehiyon ng Chichibu sa Saitama Prefecture",
      "moName": "Сайтама аймаг, Чичибү муж",
      "buName": "ချိချိဘုဒေသ၊ ဆိုင်းတမစီရင်စု",
      "khName": "តំបន់ជីជីបឹនៃខេត្ដសៃតាម៉ា",
      "neName": "साइतामा जिल्ला, चिचिबु क्षेत्र"
    },
    "class15": {
      "code": "110030",
      "name": "秩父地方",
      "enName": "Chichibu District"
    },
    "class20": {
      "code": "1120700",
      "name": "秩父市",
      "enName": "Chichibu City",
      "kana": "ちちぶし",
      "chName": "秩父市",
      "zhName": "秩父市",
      "koName": "지치부 시",
      "esName": "Ciudad de Chichibu",
      "ptName": "cidade de Chichibu",
      "thName": "เมืองจิจิบุ",
      "viName": "thành phố Chichibu",
      "inName": "kota Chichibu",
      "tlName": "siyudad ng Chichibu",
      "moName": "Чичибү хот",
      "buName": "ချီကျိဘု မြို့",
      "khName": "ទីក្រុង ឈីឈីប៊ូ",
      "neName": "चिचिबु सहर"
    }
  },
  "1120800": {
    "office": {
      "code": "110000",
      "name": "埼玉県",
      "enName": "Saitama",
      "officeName": "熊谷地方気象台",
      "chName": "埼玉县",
      "zhName": "埼玉縣",
      "koName": "사이타마현",
      "esName": "Prefectura de Saitama",
      "ptName": "Província de Saitama",
      "thName": "จังหวัดไซตามะ",
      "viName": "Tỉnh Saitama",
      "inName": "Prefektur Saitama",
      "tlName": "Saitama Prefecture",
      "moName": "Сайтама аймаг",
      "buName": "ဆိုက်တာ့မ ပြည်နယ်",
      "khName": "ខេត្ដ សៃតាម៉ា",
      "neName": "साइतामा जिल्ला"
    },
    "class10": {
      "code": "110010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "埼玉县南部",
      "zhName": "埼玉縣南部",
      "koName": "사이타마 현 남부",
      "esName": "Sur de Prefectura de Saitama",
      "ptName": "Sul da Província de Saitama",
      "thName": "จังหวัดไซตามะตอนใต้",
      "viName": "Miền Nam tỉnh Saitama",
      "inName": "Bagian Selatan Prefektur Saitama",
      "tlName": "Timog na bahagi ng Saitama Prefecture",
      "moName": "Өмнөд Сайтама аймаг",
      "buName": "ဆိုင်းတမစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដសៃតាម៉ា",
      "neName": "साइतामा जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "110011",
      "name": "南中部",
      "enName": "Southern Central Region"
    },
    "class20": {
      "code": "1120800",
      "name": "所沢市",
      "enName": "Tokorozawa City",
      "kana": "ところざわし",
      "chName": "所泽市",
      "zhName": "所澤市",
      "koName": "도코로자와 시",
      "esName": "Ciudad de Tokorozawa",
      "ptName": "cidade de Tokorozawa",
      "thName": "เมืองโทโรโระซาวา",
      "viName": "thành phố Tokorozawa",
      "inName": "kota Tokorozawa",
      "tlName": "siyudad ng Tokorozawa",
      "moName": "Токорозава хот",
      "buName": "တိုကိုရိုဇာ့ဝ မြို့",
      "khName": "ទីក្រុង តូកូរ៉ូហ្សាវ៉ា",
      "neName": "तोकोरोजावा सहर"
    }
  },
  "1120900": {
    "office": {
      "code": "110000",
      "name": "埼玉県",
      "enName": "Saitama",
      "officeName": "熊谷地方気象台",
      "chName": "埼玉县",
      "zhName": "埼玉縣",
      "koName": "사이타마현",
      "esName": "Prefectura de Saitama",
      "ptName": "Província de Saitama",
      "thName": "จังหวัดไซตามะ",
      "viName": "Tỉnh Saitama",
      "inName": "Prefektur Saitama",
      "tlName": "Saitama Prefecture",
      "moName": "Сайтама аймаг",
      "buName": "ဆိုက်တာ့မ ပြည်နယ်",
      "khName": "ខេត្ដ សៃតាម៉ា",
      "neName": "साइतामा जिल्ला"
    },
    "class10": {
      "code": "110010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "埼玉县南部",
      "zhName": "埼玉縣南部",
      "koName": "사이타마 현 남부",
      "esName": "Sur de Prefectura de Saitama",
      "ptName": "Sul da Província de Saitama",
      "thName": "จังหวัดไซตามะตอนใต้",
      "viName": "Miền Nam tỉnh Saitama",
      "inName": "Bagian Selatan Prefektur Saitama",
      "tlName": "Timog na bahagi ng Saitama Prefecture",
      "moName": "Өмнөд Сайтама аймаг",
      "buName": "ဆိုင်းတမစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដសៃតាម៉ា",
      "neName": "साइतामा जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "110013",
      "name": "南西部",
      "enName": "South-western Region"
    },
    "class20": {
      "code": "1120900",
      "name": "飯能市",
      "enName": "Hanno City",
      "kana": "はんのうし",
      "chName": "饭能市",
      "zhName": "飯能市",
      "koName": "한노 시",
      "esName": "Ciudad de Hannou",
      "ptName": "cidade de Hanno",
      "thName": "เมืองฮันโนะ",
      "viName": "thành phố Hanno",
      "inName": "kota Hanno",
      "tlName": "siyudad ng Hanno",
      "moName": "Ханно хот",
      "buName": "ဟမ်နို မြို့",
      "khName": "ទីក្រុង ហានណូ",
      "neName": "हान्नो सहर"
    }
  },
  "1121000": {
    "office": {
      "code": "110000",
      "name": "埼玉県",
      "enName": "Saitama",
      "officeName": "熊谷地方気象台",
      "chName": "埼玉县",
      "zhName": "埼玉縣",
      "koName": "사이타마현",
      "esName": "Prefectura de Saitama",
      "ptName": "Província de Saitama",
      "thName": "จังหวัดไซตามะ",
      "viName": "Tỉnh Saitama",
      "inName": "Prefektur Saitama",
      "tlName": "Saitama Prefecture",
      "moName": "Сайтама аймаг",
      "buName": "ဆိုက်တာ့မ ပြည်နယ်",
      "khName": "ខេត្ដ សៃតាម៉ា",
      "neName": "साइतामा जिल्ला"
    },
    "class10": {
      "code": "110020",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "埼玉县北部",
      "zhName": "埼玉縣北部",
      "koName": "사이타마 현 북부",
      "esName": "Norte de Prefectura de Saitama",
      "ptName": "Norte da Província de Saitama",
      "thName": "จังหวัดไซตามะตอนเหนือ",
      "viName": "Miền Bắc tỉnh Saitama",
      "inName": "Bagian Utara Prefektur Saitama",
      "tlName": "Hilagang bahagi ng Saitama Prefecture",
      "moName": "Хойд Сайтама аймаг",
      "buName": "ဆိုင်းတမစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដសៃតាម៉ា",
      "neName": "साइतामा जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "110021",
      "name": "北東部",
      "enName": "North-eastern Region"
    },
    "class20": {
      "code": "1121000",
      "name": "加須市",
      "enName": "Kazo City",
      "kana": "かぞし",
      "chName": "加须市",
      "zhName": "加須市",
      "koName": "가조 시",
      "esName": "Ciudad de Kazo",
      "ptName": "cidade de Kazo",
      "thName": "เมืองคะโซ",
      "viName": "thành phố Kazo",
      "inName": "kota Kazo",
      "tlName": "siyudad ng Kazo",
      "moName": "Казо хот",
      "buName": "ကာဇို မြို့",
      "khName": "ទីក្រុង កាហ្សូ ",
      "neName": "काजो सहर"
    }
  },
  "1121100": {
    "office": {
      "code": "110000",
      "name": "埼玉県",
      "enName": "Saitama",
      "officeName": "熊谷地方気象台",
      "chName": "埼玉县",
      "zhName": "埼玉縣",
      "koName": "사이타마현",
      "esName": "Prefectura de Saitama",
      "ptName": "Província de Saitama",
      "thName": "จังหวัดไซตามะ",
      "viName": "Tỉnh Saitama",
      "inName": "Prefektur Saitama",
      "tlName": "Saitama Prefecture",
      "moName": "Сайтама аймаг",
      "buName": "ဆိုက်တာ့မ ပြည်နယ်",
      "khName": "ខេត្ដ សៃតាម៉ា",
      "neName": "साइतामा जिल्ला"
    },
    "class10": {
      "code": "110020",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "埼玉县北部",
      "zhName": "埼玉縣北部",
      "koName": "사이타마 현 북부",
      "esName": "Norte de Prefectura de Saitama",
      "ptName": "Norte da Província de Saitama",
      "thName": "จังหวัดไซตามะตอนเหนือ",
      "viName": "Miền Bắc tỉnh Saitama",
      "inName": "Bagian Utara Prefektur Saitama",
      "tlName": "Hilagang bahagi ng Saitama Prefecture",
      "moName": "Хойд Сайтама аймаг",
      "buName": "ဆိုင်းတမစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដសៃតាម៉ា",
      "neName": "साइतामा जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "110022",
      "name": "北西部",
      "enName": "North-western Region"
    },
    "class20": {
      "code": "1121100",
      "name": "本庄市",
      "enName": "Honjo City",
      "kana": "ほんじょうし",
      "chName": "本庄市",
      "zhName": "本庄市",
      "koName": "혼조 시",
      "esName": "Ciudad de Honjyo",
      "ptName": "cidade de Honjo",
      "thName": "เมืองฮอนโจ",
      "viName": "thành phố Honjo",
      "inName": "kota Honjo",
      "tlName": "siyudad ng Honjo",
      "moName": "Хонжо хот",
      "buName": "ဟွမ်းဂျို မြို့",
      "khName": "ទីក្រុង ហុនចូ",
      "neName": "होन्जो सहर"
    }
  },
  "1121200": {
    "office": {
      "code": "110000",
      "name": "埼玉県",
      "enName": "Saitama",
      "officeName": "熊谷地方気象台",
      "chName": "埼玉县",
      "zhName": "埼玉縣",
      "koName": "사이타마현",
      "esName": "Prefectura de Saitama",
      "ptName": "Província de Saitama",
      "thName": "จังหวัดไซตามะ",
      "viName": "Tỉnh Saitama",
      "inName": "Prefektur Saitama",
      "tlName": "Saitama Prefecture",
      "moName": "Сайтама аймаг",
      "buName": "ဆိုက်တာ့မ ပြည်နယ်",
      "khName": "ខេត្ដ សៃតាម៉ា",
      "neName": "साइतामा जिल्ला"
    },
    "class10": {
      "code": "110020",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "埼玉县北部",
      "zhName": "埼玉縣北部",
      "koName": "사이타마 현 북부",
      "esName": "Norte de Prefectura de Saitama",
      "ptName": "Norte da Província de Saitama",
      "thName": "จังหวัดไซตามะตอนเหนือ",
      "viName": "Miền Bắc tỉnh Saitama",
      "inName": "Bagian Utara Prefektur Saitama",
      "tlName": "Hilagang bahagi ng Saitama Prefecture",
      "moName": "Хойд Сайтама аймаг",
      "buName": "ဆိုင်းတမစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដសៃតាម៉ា",
      "neName": "साइतामा जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "110022",
      "name": "北西部",
      "enName": "North-western Region"
    },
    "class20": {
      "code": "1121200",
      "name": "東松山市",
      "enName": "Higashimatsuyama City",
      "kana": "ひがしまつやまし",
      "chName": "东松山市",
      "zhName": "東松山市",
      "koName": "히가시마쓰야마 시",
      "esName": "Ciudad de Higashimatsuyama",
      "ptName": "cidade de Higashimatsuyama",
      "thName": "เมืองฮิงาชิมัทสึยามะ",
      "viName": "thành phố Higashimatsuyama",
      "inName": "kota Higashimatsuyama",
      "tlName": "siyudad ng Higashimatsuyama",
      "moName": "Хигашимацүяма хот",
      "buName": "ဟီဂရှီးမဆုယာ့မ မြို့",
      "khName": "ទីក្រុង ហ៊ីកាស៊ីម៉ាស៊ូយ៉ាម៉ា",
      "neName": "हिगाशिमात्सुयामा सहर"
    }
  },
  "1121400": {
    "office": {
      "code": "110000",
      "name": "埼玉県",
      "enName": "Saitama",
      "officeName": "熊谷地方気象台",
      "chName": "埼玉县",
      "zhName": "埼玉縣",
      "koName": "사이타마현",
      "esName": "Prefectura de Saitama",
      "ptName": "Província de Saitama",
      "thName": "จังหวัดไซตามะ",
      "viName": "Tỉnh Saitama",
      "inName": "Prefektur Saitama",
      "tlName": "Saitama Prefecture",
      "moName": "Сайтама аймаг",
      "buName": "ဆိုက်တာ့မ ပြည်နယ်",
      "khName": "ខេត្ដ សៃតាម៉ា",
      "neName": "साइतामा जिल्ला"
    },
    "class10": {
      "code": "110010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "埼玉县南部",
      "zhName": "埼玉縣南部",
      "koName": "사이타마 현 남부",
      "esName": "Sur de Prefectura de Saitama",
      "ptName": "Sul da Província de Saitama",
      "thName": "จังหวัดไซตามะตอนใต้",
      "viName": "Miền Nam tỉnh Saitama",
      "inName": "Bagian Selatan Prefektur Saitama",
      "tlName": "Timog na bahagi ng Saitama Prefecture",
      "moName": "Өмнөд Сайтама аймаг",
      "buName": "ဆိုင်းတမစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដសៃតាម៉ា",
      "neName": "साइतामा जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "110012",
      "name": "南東部",
      "enName": "South-eastern Region"
    },
    "class20": {
      "code": "1121400",
      "name": "春日部市",
      "enName": "Kasukabe City",
      "kana": "かすかべし",
      "chName": "春日部市",
      "zhName": "春日部市",
      "koName": "가스카베 시",
      "esName": "Ciudad de Kasukabe",
      "ptName": "cidade de Kasukabe",
      "thName": "เมืองคะสึคาเบะ",
      "viName": "thành phố Kasukabe",
      "inName": "kota Kasukabe",
      "tlName": "siyudad ng Kasukabe",
      "moName": "Каcүкабэ хот",
      "buName": "ခါဆုကာ့ဘဲ့ မြို့",
      "khName": "ទីក្រុង កាស៊ូកាបេ",
      "neName": "कासुकाबे सहर"
    }
  },
  "1121500": {
    "office": {
      "code": "110000",
      "name": "埼玉県",
      "enName": "Saitama",
      "officeName": "熊谷地方気象台",
      "chName": "埼玉县",
      "zhName": "埼玉縣",
      "koName": "사이타마현",
      "esName": "Prefectura de Saitama",
      "ptName": "Província de Saitama",
      "thName": "จังหวัดไซตามะ",
      "viName": "Tỉnh Saitama",
      "inName": "Prefektur Saitama",
      "tlName": "Saitama Prefecture",
      "moName": "Сайтама аймаг",
      "buName": "ဆိုက်တာ့မ ပြည်နယ်",
      "khName": "ខេត្ដ សៃតាម៉ា",
      "neName": "साइतामा जिल्ला"
    },
    "class10": {
      "code": "110010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "埼玉县南部",
      "zhName": "埼玉縣南部",
      "koName": "사이타마 현 남부",
      "esName": "Sur de Prefectura de Saitama",
      "ptName": "Sul da Província de Saitama",
      "thName": "จังหวัดไซตามะตอนใต้",
      "viName": "Miền Nam tỉnh Saitama",
      "inName": "Bagian Selatan Prefektur Saitama",
      "tlName": "Timog na bahagi ng Saitama Prefecture",
      "moName": "Өмнөд Сайтама аймаг",
      "buName": "ဆိုင်းတမစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដសៃតាម៉ា",
      "neName": "साइतामा जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "110011",
      "name": "南中部",
      "enName": "Southern Central Region"
    },
    "class20": {
      "code": "1121500",
      "name": "狭山市",
      "enName": "Sayama City",
      "kana": "さやまし",
      "chName": "狭山市",
      "zhName": "狹山市",
      "koName": "사야마 시",
      "esName": "Ciudad de Sayama",
      "ptName": "cidade de Sayama",
      "thName": "เมืองซายามะ",
      "viName": "thành phố Sayama",
      "inName": "kota Sayama",
      "tlName": "siyudad ng Sayama",
      "moName": "Сaямa хот",
      "buName": "ဆာယာ့မ မြို့",
      "khName": "ទីក្រុង សាយ៉ាម៉ា",
      "neName": "सायामा सहर"
    }
  },
  "1121600": {
    "office": {
      "code": "110000",
      "name": "埼玉県",
      "enName": "Saitama",
      "officeName": "熊谷地方気象台",
      "chName": "埼玉县",
      "zhName": "埼玉縣",
      "koName": "사이타마현",
      "esName": "Prefectura de Saitama",
      "ptName": "Província de Saitama",
      "thName": "จังหวัดไซตามะ",
      "viName": "Tỉnh Saitama",
      "inName": "Prefektur Saitama",
      "tlName": "Saitama Prefecture",
      "moName": "Сайтама аймаг",
      "buName": "ဆိုက်တာ့မ ပြည်နယ်",
      "khName": "ខេត្ដ សៃតាម៉ា",
      "neName": "साइतामा जिल्ला"
    },
    "class10": {
      "code": "110020",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "埼玉县北部",
      "zhName": "埼玉縣北部",
      "koName": "사이타마 현 북부",
      "esName": "Norte de Prefectura de Saitama",
      "ptName": "Norte da Província de Saitama",
      "thName": "จังหวัดไซตามะตอนเหนือ",
      "viName": "Miền Bắc tỉnh Saitama",
      "inName": "Bagian Utara Prefektur Saitama",
      "tlName": "Hilagang bahagi ng Saitama Prefecture",
      "moName": "Хойд Сайтама аймаг",
      "buName": "ဆိုင်းတမစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដសៃតាម៉ា",
      "neName": "साइतामा जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "110021",
      "name": "北東部",
      "enName": "North-eastern Region"
    },
    "class20": {
      "code": "1121600",
      "name": "羽生市",
      "enName": "Hanyu City",
      "kana": "はにゅうし",
      "chName": "羽生市",
      "zhName": "羽生市",
      "koName": "하뉴 시",
      "esName": "Ciudad de Hanyu",
      "ptName": "cidade de Hanyu",
      "thName": "เมืองฮันยู",
      "viName": "thành phố Hanyu",
      "inName": "kota Hanyu",
      "tlName": "siyudad ng Hanyu",
      "moName": "Хaню хот",
      "buName": "ဟမ်းညှု မြို့",
      "khName": "ទីក្រុង ហាន់យូ",
      "neName": "हान्यु सहर"
    }
  },
  "1121700": {
    "office": {
      "code": "110000",
      "name": "埼玉県",
      "enName": "Saitama",
      "officeName": "熊谷地方気象台",
      "chName": "埼玉县",
      "zhName": "埼玉縣",
      "koName": "사이타마현",
      "esName": "Prefectura de Saitama",
      "ptName": "Província de Saitama",
      "thName": "จังหวัดไซตามะ",
      "viName": "Tỉnh Saitama",
      "inName": "Prefektur Saitama",
      "tlName": "Saitama Prefecture",
      "moName": "Сайтама аймаг",
      "buName": "ဆိုက်တာ့မ ပြည်နယ်",
      "khName": "ខេត្ដ សៃតាម៉ា",
      "neName": "साइतामा जिल्ला"
    },
    "class10": {
      "code": "110020",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "埼玉县北部",
      "zhName": "埼玉縣北部",
      "koName": "사이타마 현 북부",
      "esName": "Norte de Prefectura de Saitama",
      "ptName": "Norte da Província de Saitama",
      "thName": "จังหวัดไซตามะตอนเหนือ",
      "viName": "Miền Bắc tỉnh Saitama",
      "inName": "Bagian Utara Prefektur Saitama",
      "tlName": "Hilagang bahagi ng Saitama Prefecture",
      "moName": "Хойд Сайтама аймаг",
      "buName": "ဆိုင်းတမစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដសៃតាម៉ា",
      "neName": "साइतामा जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "110021",
      "name": "北東部",
      "enName": "North-eastern Region"
    },
    "class20": {
      "code": "1121700",
      "name": "鴻巣市",
      "enName": "Kounosu City",
      "kana": "こうのすし",
      "chName": "鸿巢市",
      "zhName": "鴻巢市",
      "koName": "고노스 시",
      "esName": "Ciudad de Konosu",
      "ptName": "cidade de Kounosu",
      "thName": "เมืองโคโนะสึ",
      "viName": "thành phố Kounosu",
      "inName": "kota Kounosu",
      "tlName": "siyudad ng Kounosu",
      "moName": "Коүносү хот",
      "buName": "ကိုဥနော့ဆု မြို့",
      "khName": "ទីក្រុង គូណូស៊ុ",
      "neName": "कोउनोसु सहर"
    }
  },
  "1121800": {
    "office": {
      "code": "110000",
      "name": "埼玉県",
      "enName": "Saitama",
      "officeName": "熊谷地方気象台",
      "chName": "埼玉县",
      "zhName": "埼玉縣",
      "koName": "사이타마현",
      "esName": "Prefectura de Saitama",
      "ptName": "Província de Saitama",
      "thName": "จังหวัดไซตามะ",
      "viName": "Tỉnh Saitama",
      "inName": "Prefektur Saitama",
      "tlName": "Saitama Prefecture",
      "moName": "Сайтама аймаг",
      "buName": "ဆိုက်တာ့မ ပြည်နယ်",
      "khName": "ខេត្ដ សៃតាម៉ា",
      "neName": "साइतामा जिल्ला"
    },
    "class10": {
      "code": "110020",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "埼玉县北部",
      "zhName": "埼玉縣北部",
      "koName": "사이타마 현 북부",
      "esName": "Norte de Prefectura de Saitama",
      "ptName": "Norte da Província de Saitama",
      "thName": "จังหวัดไซตามะตอนเหนือ",
      "viName": "Miền Bắc tỉnh Saitama",
      "inName": "Bagian Utara Prefektur Saitama",
      "tlName": "Hilagang bahagi ng Saitama Prefecture",
      "moName": "Хойд Сайтама аймаг",
      "buName": "ဆိုင်းတမစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដសៃតាម៉ា",
      "neName": "साइतामा जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "110022",
      "name": "北西部",
      "enName": "North-western Region"
    },
    "class20": {
      "code": "1121800",
      "name": "深谷市",
      "enName": "Fukaya City",
      "kana": "ふかやし",
      "chName": "深谷市",
      "zhName": "深谷市",
      "koName": "후카야 시",
      "esName": "Ciudad de Fukaya",
      "ptName": "cidade de Fukaya",
      "thName": "เมืองฟุคายะ",
      "viName": "thành phố Fukaya",
      "inName": "kota Fukaya",
      "tlName": "siyudad ng Fukaya",
      "moName": "Фүкая хот",
      "buName": "ဖူကာ့ယ မြို့",
      "khName": "ទីក្រុង ហ្វូកាយ៉ា",
      "neName": "फुकाया सहर"
    }
  },
  "1121900": {
    "office": {
      "code": "110000",
      "name": "埼玉県",
      "enName": "Saitama",
      "officeName": "熊谷地方気象台",
      "chName": "埼玉县",
      "zhName": "埼玉縣",
      "koName": "사이타마현",
      "esName": "Prefectura de Saitama",
      "ptName": "Província de Saitama",
      "thName": "จังหวัดไซตามะ",
      "viName": "Tỉnh Saitama",
      "inName": "Prefektur Saitama",
      "tlName": "Saitama Prefecture",
      "moName": "Сайтама аймаг",
      "buName": "ဆိုက်တာ့မ ပြည်နယ်",
      "khName": "ខេត្ដ សៃតាម៉ា",
      "neName": "साइतामा जिल्ला"
    },
    "class10": {
      "code": "110010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "埼玉县南部",
      "zhName": "埼玉縣南部",
      "koName": "사이타마 현 남부",
      "esName": "Sur de Prefectura de Saitama",
      "ptName": "Sul da Província de Saitama",
      "thName": "จังหวัดไซตามะตอนใต้",
      "viName": "Miền Nam tỉnh Saitama",
      "inName": "Bagian Selatan Prefektur Saitama",
      "tlName": "Timog na bahagi ng Saitama Prefecture",
      "moName": "Өмнөд Сайтама аймаг",
      "buName": "ဆိုင်းတမစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដសៃតាម៉ា",
      "neName": "साइतामा जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "110011",
      "name": "南中部",
      "enName": "Southern Central Region"
    },
    "class20": {
      "code": "1121900",
      "name": "上尾市",
      "enName": "Ageo City",
      "kana": "あげおし",
      "chName": "上尾市",
      "zhName": "上尾市",
      "koName": "아게오 시",
      "esName": "Ciudad de Ageo",
      "ptName": "cidade de Ageo",
      "thName": "เมืองอาเกโอะ",
      "viName": "thành phố Ageo",
      "inName": "kota Ageo",
      "tlName": "siyudad ng Ageo",
      "moName": "Aгэо хот",
      "buName": "အာဂေးယို့ မြို့",
      "khName": "ទីក្រុង អាគីអូ",
      "neName": "आगेओ सहर"
    }
  },
  "1122100": {
    "office": {
      "code": "110000",
      "name": "埼玉県",
      "enName": "Saitama",
      "officeName": "熊谷地方気象台",
      "chName": "埼玉县",
      "zhName": "埼玉縣",
      "koName": "사이타마현",
      "esName": "Prefectura de Saitama",
      "ptName": "Província de Saitama",
      "thName": "จังหวัดไซตามะ",
      "viName": "Tỉnh Saitama",
      "inName": "Prefektur Saitama",
      "tlName": "Saitama Prefecture",
      "moName": "Сайтама аймаг",
      "buName": "ဆိုက်တာ့မ ပြည်နယ်",
      "khName": "ខេត្ដ សៃតាម៉ា",
      "neName": "साइतामा जिल्ला"
    },
    "class10": {
      "code": "110010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "埼玉县南部",
      "zhName": "埼玉縣南部",
      "koName": "사이타마 현 남부",
      "esName": "Sur de Prefectura de Saitama",
      "ptName": "Sul da Província de Saitama",
      "thName": "จังหวัดไซตามะตอนใต้",
      "viName": "Miền Nam tỉnh Saitama",
      "inName": "Bagian Selatan Prefektur Saitama",
      "tlName": "Timog na bahagi ng Saitama Prefecture",
      "moName": "Өмнөд Сайтама аймаг",
      "buName": "ဆိုင်းတမစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដសៃតាម៉ា",
      "neName": "साइतामा जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "110012",
      "name": "南東部",
      "enName": "South-eastern Region"
    },
    "class20": {
      "code": "1122100",
      "name": "草加市",
      "enName": "Soka City",
      "kana": "そうかし",
      "chName": "草加市",
      "zhName": "草加市",
      "koName": "소카 시",
      "esName": "Ciudad de Soka",
      "ptName": "cidade de Soka",
      "thName": "เมืองโซกะ",
      "viName": "thành phố Soka",
      "inName": "kota Soka",
      "tlName": "siyudad ng Soka",
      "moName": "Сока хот",
      "buName": "ဆော်က မြို့",
      "khName": "ទីក្រុង សុកា",
      "neName": "सोका सहर"
    }
  },
  "1122200": {
    "office": {
      "code": "110000",
      "name": "埼玉県",
      "enName": "Saitama",
      "officeName": "熊谷地方気象台",
      "chName": "埼玉县",
      "zhName": "埼玉縣",
      "koName": "사이타마현",
      "esName": "Prefectura de Saitama",
      "ptName": "Província de Saitama",
      "thName": "จังหวัดไซตามะ",
      "viName": "Tỉnh Saitama",
      "inName": "Prefektur Saitama",
      "tlName": "Saitama Prefecture",
      "moName": "Сайтама аймаг",
      "buName": "ဆိုက်တာ့မ ပြည်နယ်",
      "khName": "ខេត្ដ សៃតាម៉ា",
      "neName": "साइतामा जिल्ला"
    },
    "class10": {
      "code": "110010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "埼玉县南部",
      "zhName": "埼玉縣南部",
      "koName": "사이타마 현 남부",
      "esName": "Sur de Prefectura de Saitama",
      "ptName": "Sul da Província de Saitama",
      "thName": "จังหวัดไซตามะตอนใต้",
      "viName": "Miền Nam tỉnh Saitama",
      "inName": "Bagian Selatan Prefektur Saitama",
      "tlName": "Timog na bahagi ng Saitama Prefecture",
      "moName": "Өмнөд Сайтама аймаг",
      "buName": "ဆိုင်းတမစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដសៃតាម៉ា",
      "neName": "साइतामा जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "110012",
      "name": "南東部",
      "enName": "South-eastern Region"
    },
    "class20": {
      "code": "1122200",
      "name": "越谷市",
      "enName": "Koshigaya City",
      "kana": "こしがやし",
      "chName": "越谷市",
      "zhName": "越谷市",
      "koName": "고시가야 시",
      "esName": "Ciudad de Koshigaya",
      "ptName": "cidade de Koshigaya",
      "thName": "เมืองโคชิกายะ",
      "viName": "thành phố Koshigaya",
      "inName": "kota Koshigaya",
      "tlName": "siyudad ng Koshigaya",
      "moName": "Кошигaя хот",
      "buName": "ကိုရှိဂါ့ယ မြို့",
      "khName": "ទីក្រុង កូស៊ីកាយ៉ា",
      "neName": "कोशिगाया सहर"
    }
  },
  "1122300": {
    "office": {
      "code": "110000",
      "name": "埼玉県",
      "enName": "Saitama",
      "officeName": "熊谷地方気象台",
      "chName": "埼玉县",
      "zhName": "埼玉縣",
      "koName": "사이타마현",
      "esName": "Prefectura de Saitama",
      "ptName": "Província de Saitama",
      "thName": "จังหวัดไซตามะ",
      "viName": "Tỉnh Saitama",
      "inName": "Prefektur Saitama",
      "tlName": "Saitama Prefecture",
      "moName": "Сайтама аймаг",
      "buName": "ဆိုက်တာ့မ ပြည်နယ်",
      "khName": "ខេត្ដ សៃតាម៉ា",
      "neName": "साइतामा जिल्ला"
    },
    "class10": {
      "code": "110010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "埼玉县南部",
      "zhName": "埼玉縣南部",
      "koName": "사이타마 현 남부",
      "esName": "Sur de Prefectura de Saitama",
      "ptName": "Sul da Província de Saitama",
      "thName": "จังหวัดไซตามะตอนใต้",
      "viName": "Miền Nam tỉnh Saitama",
      "inName": "Bagian Selatan Prefektur Saitama",
      "tlName": "Timog na bahagi ng Saitama Prefecture",
      "moName": "Өмнөд Сайтама аймаг",
      "buName": "ဆိုင်းတမစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដសៃតាម៉ា",
      "neName": "साइतामा जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "110011",
      "name": "南中部",
      "enName": "Southern Central Region"
    },
    "class20": {
      "code": "1122300",
      "name": "蕨市",
      "enName": "Warabi City",
      "kana": "わらびし",
      "chName": "蕨市",
      "zhName": "蕨市",
      "koName": "와라비 시",
      "esName": "Ciudad de Warabi",
      "ptName": "cidade de Warabi",
      "thName": "เมืองวาราบิ",
      "viName": "thành phố Warabi",
      "inName": "kota Warabi",
      "tlName": "siyudad ng Warabi",
      "moName": "Вараби хот",
      "buName": "ဝါရာ့ဘိ မြို့",
      "khName": "ទីក្រុង វ៉ារ៉ាប៊ី",
      "neName": "वाराबी सहर"
    }
  },
  "1122400": {
    "office": {
      "code": "110000",
      "name": "埼玉県",
      "enName": "Saitama",
      "officeName": "熊谷地方気象台",
      "chName": "埼玉县",
      "zhName": "埼玉縣",
      "koName": "사이타마현",
      "esName": "Prefectura de Saitama",
      "ptName": "Província de Saitama",
      "thName": "จังหวัดไซตามะ",
      "viName": "Tỉnh Saitama",
      "inName": "Prefektur Saitama",
      "tlName": "Saitama Prefecture",
      "moName": "Сайтама аймаг",
      "buName": "ဆိုက်တာ့မ ပြည်နယ်",
      "khName": "ខេត្ដ សៃតាម៉ា",
      "neName": "साइतामा जिल्ला"
    },
    "class10": {
      "code": "110010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "埼玉县南部",
      "zhName": "埼玉縣南部",
      "koName": "사이타마 현 남부",
      "esName": "Sur de Prefectura de Saitama",
      "ptName": "Sul da Província de Saitama",
      "thName": "จังหวัดไซตามะตอนใต้",
      "viName": "Miền Nam tỉnh Saitama",
      "inName": "Bagian Selatan Prefektur Saitama",
      "tlName": "Timog na bahagi ng Saitama Prefecture",
      "moName": "Өмнөд Сайтама аймаг",
      "buName": "ဆိုင်းတမစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដសៃតាម៉ា",
      "neName": "साइतामा जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "110011",
      "name": "南中部",
      "enName": "Southern Central Region"
    },
    "class20": {
      "code": "1122400",
      "name": "戸田市",
      "enName": "Toda City",
      "kana": "とだし",
      "chName": "户田市",
      "zhName": "戶田市",
      "koName": "도다 시",
      "esName": "Ciudad de Toda",
      "ptName": "cidade de Toda",
      "thName": "เมืองโทดะ",
      "viName": "thành phố Toda",
      "inName": "kota Toda",
      "tlName": "siyudad ng Toda",
      "moName": "Тода хот",
      "buName": "တိုဒါ မြို့",
      "khName": "ទីក្រុង តូដា",
      "neName": "तोदा सहर"
    }
  },
  "1122500": {
    "office": {
      "code": "110000",
      "name": "埼玉県",
      "enName": "Saitama",
      "officeName": "熊谷地方気象台",
      "chName": "埼玉县",
      "zhName": "埼玉縣",
      "koName": "사이타마현",
      "esName": "Prefectura de Saitama",
      "ptName": "Província de Saitama",
      "thName": "จังหวัดไซตามะ",
      "viName": "Tỉnh Saitama",
      "inName": "Prefektur Saitama",
      "tlName": "Saitama Prefecture",
      "moName": "Сайтама аймаг",
      "buName": "ဆိုက်တာ့မ ပြည်နယ်",
      "khName": "ខេត្ដ សៃតាម៉ា",
      "neName": "साइतामा जिल्ला"
    },
    "class10": {
      "code": "110010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "埼玉县南部",
      "zhName": "埼玉縣南部",
      "koName": "사이타마 현 남부",
      "esName": "Sur de Prefectura de Saitama",
      "ptName": "Sul da Província de Saitama",
      "thName": "จังหวัดไซตามะตอนใต้",
      "viName": "Miền Nam tỉnh Saitama",
      "inName": "Bagian Selatan Prefektur Saitama",
      "tlName": "Timog na bahagi ng Saitama Prefecture",
      "moName": "Өмнөд Сайтама аймаг",
      "buName": "ဆိုင်းတမစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដសៃតាម៉ា",
      "neName": "साइतामा जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "110013",
      "name": "南西部",
      "enName": "South-western Region"
    },
    "class20": {
      "code": "1122500",
      "name": "入間市",
      "enName": "Iruma City",
      "kana": "いるまし",
      "chName": "入间市",
      "zhName": "入間市",
      "koName": "이루마 시",
      "esName": "Ciudad de Iruma",
      "ptName": "cidade de Iruma",
      "thName": "เมืองอิรุมะ",
      "viName": "thành phố Iruma",
      "inName": "kota Iruma",
      "tlName": "siyudad ng Iruma",
      "moName": "Ирүмa хот",
      "buName": "အီရုမ မြို့",
      "khName": "ទីក្រុង អ៊ីរូម៉ា",
      "neName": "इरुमा सहर"
    }
  },
  "1122700": {
    "office": {
      "code": "110000",
      "name": "埼玉県",
      "enName": "Saitama",
      "officeName": "熊谷地方気象台",
      "chName": "埼玉县",
      "zhName": "埼玉縣",
      "koName": "사이타마현",
      "esName": "Prefectura de Saitama",
      "ptName": "Província de Saitama",
      "thName": "จังหวัดไซตามะ",
      "viName": "Tỉnh Saitama",
      "inName": "Prefektur Saitama",
      "tlName": "Saitama Prefecture",
      "moName": "Сайтама аймаг",
      "buName": "ဆိုက်တာ့မ ပြည်နယ်",
      "khName": "ខេត្ដ សៃតាម៉ា",
      "neName": "साइतामा जिल्ला"
    },
    "class10": {
      "code": "110010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "埼玉县南部",
      "zhName": "埼玉縣南部",
      "koName": "사이타마 현 남부",
      "esName": "Sur de Prefectura de Saitama",
      "ptName": "Sul da Província de Saitama",
      "thName": "จังหวัดไซตามะตอนใต้",
      "viName": "Miền Nam tỉnh Saitama",
      "inName": "Bagian Selatan Prefektur Saitama",
      "tlName": "Timog na bahagi ng Saitama Prefecture",
      "moName": "Өмнөд Сайтама аймаг",
      "buName": "ဆိုင်းတမစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដសៃតាម៉ា",
      "neName": "साइतामा जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "110011",
      "name": "南中部",
      "enName": "Southern Central Region"
    },
    "class20": {
      "code": "1122700",
      "name": "朝霞市",
      "enName": "Asaka City",
      "kana": "あさかし",
      "chName": "朝霞市",
      "zhName": "朝霞市",
      "koName": "아사카 시",
      "esName": "Ciudad de Asaka",
      "ptName": "cidade de Asaka",
      "thName": "เมืองอาซากะ",
      "viName": "thành phố Asaka",
      "inName": "kota Asaka",
      "tlName": "siyudad ng Asaka",
      "moName": "Асака хот",
      "buName": "အာဆာ့က မြို့",
      "khName": "ទីក្រុង អាសាកា",
      "neName": "आसाका सहर"
    }
  },
  "1122800": {
    "office": {
      "code": "110000",
      "name": "埼玉県",
      "enName": "Saitama",
      "officeName": "熊谷地方気象台",
      "chName": "埼玉县",
      "zhName": "埼玉縣",
      "koName": "사이타마현",
      "esName": "Prefectura de Saitama",
      "ptName": "Província de Saitama",
      "thName": "จังหวัดไซตามะ",
      "viName": "Tỉnh Saitama",
      "inName": "Prefektur Saitama",
      "tlName": "Saitama Prefecture",
      "moName": "Сайтама аймаг",
      "buName": "ဆိုက်တာ့မ ပြည်နယ်",
      "khName": "ខេត្ដ សៃតាម៉ា",
      "neName": "साइतामा जिल्ला"
    },
    "class10": {
      "code": "110010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "埼玉县南部",
      "zhName": "埼玉縣南部",
      "koName": "사이타마 현 남부",
      "esName": "Sur de Prefectura de Saitama",
      "ptName": "Sul da Província de Saitama",
      "thName": "จังหวัดไซตามะตอนใต้",
      "viName": "Miền Nam tỉnh Saitama",
      "inName": "Bagian Selatan Prefektur Saitama",
      "tlName": "Timog na bahagi ng Saitama Prefecture",
      "moName": "Өмнөд Сайтама аймаг",
      "buName": "ဆိုင်းတမစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដសៃតាម៉ា",
      "neName": "साइतामा जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "110011",
      "name": "南中部",
      "enName": "Southern Central Region"
    },
    "class20": {
      "code": "1122800",
      "name": "志木市",
      "enName": "Shiki City",
      "kana": "しきし",
      "chName": "志木市",
      "zhName": "志木市",
      "koName": "시키 시",
      "esName": "Ciudad de Shiki",
      "ptName": "cidade de Shiki",
      "thName": "เมืองชิกิ",
      "viName": "thành phố Shiki",
      "inName": "kota Shiki",
      "tlName": "siyudad ng Shiki",
      "moName": "Шики хот",
      "buName": "ရှီကိ မြို့",
      "khName": "ទីក្រុង ស៊ីគី",
      "neName": "शिकी सहर"
    }
  },
  "1122900": {
    "office": {
      "code": "110000",
      "name": "埼玉県",
      "enName": "Saitama",
      "officeName": "熊谷地方気象台",
      "chName": "埼玉县",
      "zhName": "埼玉縣",
      "koName": "사이타마현",
      "esName": "Prefectura de Saitama",
      "ptName": "Província de Saitama",
      "thName": "จังหวัดไซตามะ",
      "viName": "Tỉnh Saitama",
      "inName": "Prefektur Saitama",
      "tlName": "Saitama Prefecture",
      "moName": "Сайтама аймаг",
      "buName": "ဆိုက်တာ့မ ပြည်နယ်",
      "khName": "ខេត្ដ សៃតាម៉ា",
      "neName": "साइतामा जिल्ला"
    },
    "class10": {
      "code": "110010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "埼玉县南部",
      "zhName": "埼玉縣南部",
      "koName": "사이타마 현 남부",
      "esName": "Sur de Prefectura de Saitama",
      "ptName": "Sul da Província de Saitama",
      "thName": "จังหวัดไซตามะตอนใต้",
      "viName": "Miền Nam tỉnh Saitama",
      "inName": "Bagian Selatan Prefektur Saitama",
      "tlName": "Timog na bahagi ng Saitama Prefecture",
      "moName": "Өмнөд Сайтама аймаг",
      "buName": "ဆိုင်းတမစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដសៃតាម៉ា",
      "neName": "साइतामा जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "110011",
      "name": "南中部",
      "enName": "Southern Central Region"
    },
    "class20": {
      "code": "1122900",
      "name": "和光市",
      "enName": "Wako City",
      "kana": "わこうし",
      "chName": "和光市",
      "zhName": "和光市",
      "koName": "와코 시",
      "esName": "Ciudad de Wako",
      "ptName": "cidade de Wako",
      "thName": "เมืองวาโกะ",
      "viName": "thành phố Wako",
      "inName": "kota Wako",
      "tlName": "siyudad ng Wako",
      "moName": "Вако хот",
      "buName": "ဝါကို မြို့",
      "khName": "ទីក្រុង វ៉ាកូ",
      "neName": "वाको सहर"
    }
  },
  "1123000": {
    "office": {
      "code": "110000",
      "name": "埼玉県",
      "enName": "Saitama",
      "officeName": "熊谷地方気象台",
      "chName": "埼玉县",
      "zhName": "埼玉縣",
      "koName": "사이타마현",
      "esName": "Prefectura de Saitama",
      "ptName": "Província de Saitama",
      "thName": "จังหวัดไซตามะ",
      "viName": "Tỉnh Saitama",
      "inName": "Prefektur Saitama",
      "tlName": "Saitama Prefecture",
      "moName": "Сайтама аймаг",
      "buName": "ဆိုက်တာ့မ ပြည်နယ်",
      "khName": "ខេត្ដ សៃតាម៉ា",
      "neName": "साइतामा जिल्ला"
    },
    "class10": {
      "code": "110010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "埼玉县南部",
      "zhName": "埼玉縣南部",
      "koName": "사이타마 현 남부",
      "esName": "Sur de Prefectura de Saitama",
      "ptName": "Sul da Província de Saitama",
      "thName": "จังหวัดไซตามะตอนใต้",
      "viName": "Miền Nam tỉnh Saitama",
      "inName": "Bagian Selatan Prefektur Saitama",
      "tlName": "Timog na bahagi ng Saitama Prefecture",
      "moName": "Өмнөд Сайтама аймаг",
      "buName": "ဆိုင်းတမစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដសៃតាម៉ា",
      "neName": "साइतामा जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "110011",
      "name": "南中部",
      "enName": "Southern Central Region"
    },
    "class20": {
      "code": "1123000",
      "name": "新座市",
      "enName": "Niiza City",
      "kana": "にいざし",
      "chName": "新座市",
      "zhName": "新座市",
      "koName": "니자 시",
      "esName": "Ciudad de Niiza",
      "ptName": "cidade de Niiza",
      "thName": "เมืองนีสะ",
      "viName": "thành phố Niiza",
      "inName": "kota Niiza",
      "tlName": "siyudad ng Niiza",
      "moName": "Нийза хот",
      "buName": "နီးဇာ့ မြို့",
      "khName": "ទីក្រុង នីហ្សា",
      "neName": "निइजा सहर"
    }
  },
  "1123100": {
    "office": {
      "code": "110000",
      "name": "埼玉県",
      "enName": "Saitama",
      "officeName": "熊谷地方気象台",
      "chName": "埼玉县",
      "zhName": "埼玉縣",
      "koName": "사이타마현",
      "esName": "Prefectura de Saitama",
      "ptName": "Província de Saitama",
      "thName": "จังหวัดไซตามะ",
      "viName": "Tỉnh Saitama",
      "inName": "Prefektur Saitama",
      "tlName": "Saitama Prefecture",
      "moName": "Сайтама аймаг",
      "buName": "ဆိုက်တာ့မ ပြည်နယ်",
      "khName": "ខេត្ដ សៃតាម៉ា",
      "neName": "साइतामा जिल्ला"
    },
    "class10": {
      "code": "110010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "埼玉县南部",
      "zhName": "埼玉縣南部",
      "koName": "사이타마 현 남부",
      "esName": "Sur de Prefectura de Saitama",
      "ptName": "Sul da Província de Saitama",
      "thName": "จังหวัดไซตามะตอนใต้",
      "viName": "Miền Nam tỉnh Saitama",
      "inName": "Bagian Selatan Prefektur Saitama",
      "tlName": "Timog na bahagi ng Saitama Prefecture",
      "moName": "Өмнөд Сайтама аймаг",
      "buName": "ဆိုင်းတမစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដសៃតាម៉ា",
      "neName": "साइतामा जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "110011",
      "name": "南中部",
      "enName": "Southern Central Region"
    },
    "class20": {
      "code": "1123100",
      "name": "桶川市",
      "enName": "Okegawa City",
      "kana": "おけがわし",
      "chName": "桶川市",
      "zhName": "桶川市",
      "koName": "오케가와 시",
      "esName": "Ciudad de Okegawa",
      "ptName": "cidade de Okegawa",
      "thName": "เมืองโอเคะกาวา",
      "viName": "thành phố Okegawa",
      "inName": "kota Okegawa",
      "tlName": "siyudad ng Okegawa",
      "moName": "Окэгава хот",
      "buName": "အိုကေးဂါ့ဝ မြို့",
      "khName": "ទីក្រុង អូកេកាវ៉ា",
      "neName": "ओकेगावा सहर"
    }
  },
  "1123200": {
    "office": {
      "code": "110000",
      "name": "埼玉県",
      "enName": "Saitama",
      "officeName": "熊谷地方気象台",
      "chName": "埼玉县",
      "zhName": "埼玉縣",
      "koName": "사이타마현",
      "esName": "Prefectura de Saitama",
      "ptName": "Província de Saitama",
      "thName": "จังหวัดไซตามะ",
      "viName": "Tỉnh Saitama",
      "inName": "Prefektur Saitama",
      "tlName": "Saitama Prefecture",
      "moName": "Сайтама аймаг",
      "buName": "ဆိုက်တာ့မ ပြည်နယ်",
      "khName": "ខេត្ដ សៃតាម៉ា",
      "neName": "साइतामा जिल्ला"
    },
    "class10": {
      "code": "110020",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "埼玉县北部",
      "zhName": "埼玉縣北部",
      "koName": "사이타마 현 북부",
      "esName": "Norte de Prefectura de Saitama",
      "ptName": "Norte da Província de Saitama",
      "thName": "จังหวัดไซตามะตอนเหนือ",
      "viName": "Miền Bắc tỉnh Saitama",
      "inName": "Bagian Utara Prefektur Saitama",
      "tlName": "Hilagang bahagi ng Saitama Prefecture",
      "moName": "Хойд Сайтама аймаг",
      "buName": "ဆိုင်းတမစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដសៃតាម៉ា",
      "neName": "साइतामा जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "110021",
      "name": "北東部",
      "enName": "North-eastern Region"
    },
    "class20": {
      "code": "1123200",
      "name": "久喜市",
      "enName": "Kuki City",
      "kana": "くきし",
      "chName": "久喜市",
      "zhName": "久喜市",
      "koName": "구키 시",
      "esName": "Ciudad de Kuki",
      "ptName": "cidade de Kuki",
      "thName": "เมืองคุคิ",
      "viName": "thành phố Kuki",
      "inName": "kota Kuki",
      "tlName": "siyudad ng Kuki",
      "moName": "Күки хот",
      "buName": "ခူကိ မြို့",
      "khName": "ទីក្រុង គូគី",
      "neName": "कुकी सहर"
    }
  },
  "1123300": {
    "office": {
      "code": "110000",
      "name": "埼玉県",
      "enName": "Saitama",
      "officeName": "熊谷地方気象台",
      "chName": "埼玉县",
      "zhName": "埼玉縣",
      "koName": "사이타마현",
      "esName": "Prefectura de Saitama",
      "ptName": "Província de Saitama",
      "thName": "จังหวัดไซตามะ",
      "viName": "Tỉnh Saitama",
      "inName": "Prefektur Saitama",
      "tlName": "Saitama Prefecture",
      "moName": "Сайтама аймаг",
      "buName": "ဆိုက်တာ့မ ပြည်နယ်",
      "khName": "ខេត្ដ សៃតាម៉ា",
      "neName": "साइतामा जिल्ला"
    },
    "class10": {
      "code": "110010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "埼玉县南部",
      "zhName": "埼玉縣南部",
      "koName": "사이타마 현 남부",
      "esName": "Sur de Prefectura de Saitama",
      "ptName": "Sul da Província de Saitama",
      "thName": "จังหวัดไซตามะตอนใต้",
      "viName": "Miền Nam tỉnh Saitama",
      "inName": "Bagian Selatan Prefektur Saitama",
      "tlName": "Timog na bahagi ng Saitama Prefecture",
      "moName": "Өмнөд Сайтама аймаг",
      "buName": "ဆိုင်းတမစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដសៃតាម៉ា",
      "neName": "साइतामा जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "110011",
      "name": "南中部",
      "enName": "Southern Central Region"
    },
    "class20": {
      "code": "1123300",
      "name": "北本市",
      "enName": "Kitamoto City",
      "kana": "きたもとし",
      "chName": "北本市",
      "zhName": "北本市",
      "koName": "기타모토 시",
      "esName": "Ciudad de Kitamoto",
      "ptName": "cidade de Kitamoto",
      "thName": "เมืองคิตะโมโตะ",
      "viName": "thành phố Kitamoto",
      "inName": "kota Kitamoto",
      "tlName": "siyudad ng Kitamoto",
      "moName": "Китамото хот",
      "buName": "ခီတမိုတို မြို့",
      "khName": "ទីក្រុង គីតាម៉ូតុ",
      "neName": "कितामोतो सहर"
    }
  },
  "1123400": {
    "office": {
      "code": "110000",
      "name": "埼玉県",
      "enName": "Saitama",
      "officeName": "熊谷地方気象台",
      "chName": "埼玉县",
      "zhName": "埼玉縣",
      "koName": "사이타마현",
      "esName": "Prefectura de Saitama",
      "ptName": "Província de Saitama",
      "thName": "จังหวัดไซตามะ",
      "viName": "Tỉnh Saitama",
      "inName": "Prefektur Saitama",
      "tlName": "Saitama Prefecture",
      "moName": "Сайтама аймаг",
      "buName": "ဆိုက်တာ့မ ပြည်နယ်",
      "khName": "ខេត្ដ សៃតាម៉ា",
      "neName": "साइतामा जिल्ला"
    },
    "class10": {
      "code": "110010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "埼玉县南部",
      "zhName": "埼玉縣南部",
      "koName": "사이타마 현 남부",
      "esName": "Sur de Prefectura de Saitama",
      "ptName": "Sul da Província de Saitama",
      "thName": "จังหวัดไซตามะตอนใต้",
      "viName": "Miền Nam tỉnh Saitama",
      "inName": "Bagian Selatan Prefektur Saitama",
      "tlName": "Timog na bahagi ng Saitama Prefecture",
      "moName": "Өмнөд Сайтама аймаг",
      "buName": "ဆိုင်းတမစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដសៃតាម៉ា",
      "neName": "साइतामा जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "110012",
      "name": "南東部",
      "enName": "South-eastern Region"
    },
    "class20": {
      "code": "1123400",
      "name": "八潮市",
      "enName": "Yashio City",
      "kana": "やしおし",
      "chName": "八潮市",
      "zhName": "八潮市",
      "koName": "야시오 시",
      "esName": "Ciudad de Yashio",
      "ptName": "cidade de Yashio",
      "thName": "เมืองยาชิโอะ",
      "viName": "thành phố Yashio",
      "inName": "kota Yashio",
      "tlName": "siyudad ng Yashio",
      "moName": "Яшио хот",
      "buName": "ယာရှီးယို့ မြို့",
      "khName": "ទីក្រុង យ៉ូស៊ីអូ",
      "neName": "याशियो सहर"
    }
  },
  "1123500": {
    "office": {
      "code": "110000",
      "name": "埼玉県",
      "enName": "Saitama",
      "officeName": "熊谷地方気象台",
      "chName": "埼玉县",
      "zhName": "埼玉縣",
      "koName": "사이타마현",
      "esName": "Prefectura de Saitama",
      "ptName": "Província de Saitama",
      "thName": "จังหวัดไซตามะ",
      "viName": "Tỉnh Saitama",
      "inName": "Prefektur Saitama",
      "tlName": "Saitama Prefecture",
      "moName": "Сайтама аймаг",
      "buName": "ဆိုက်တာ့မ ပြည်နယ်",
      "khName": "ខេត្ដ សៃតាម៉ា",
      "neName": "साइतामा जिल्ला"
    },
    "class10": {
      "code": "110010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "埼玉县南部",
      "zhName": "埼玉縣南部",
      "koName": "사이타마 현 남부",
      "esName": "Sur de Prefectura de Saitama",
      "ptName": "Sul da Província de Saitama",
      "thName": "จังหวัดไซตามะตอนใต้",
      "viName": "Miền Nam tỉnh Saitama",
      "inName": "Bagian Selatan Prefektur Saitama",
      "tlName": "Timog na bahagi ng Saitama Prefecture",
      "moName": "Өмнөд Сайтама аймаг",
      "buName": "ဆိုင်းတမစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដសៃតាម៉ា",
      "neName": "साइतामा जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "110011",
      "name": "南中部",
      "enName": "Southern Central Region"
    },
    "class20": {
      "code": "1123500",
      "name": "富士見市",
      "enName": "Fujimi City",
      "kana": "ふじみし",
      "chName": "富士见市",
      "zhName": "富士見市",
      "koName": "후지미 시",
      "esName": "Ciudad de Fujimi",
      "ptName": "cidade de Fujimi",
      "thName": "เมืองฟุจิมิ",
      "viName": "thành phố Fujimi",
      "inName": "kota Fujimi",
      "tlName": "siyudad ng Fujimi",
      "moName": "Фүжими хот",
      "buName": "ဖူဂျိမိ မြို့",
      "khName": "ទីក្រុង ហ្វូជីមិ",
      "neName": "फुजिमी सहर"
    }
  },
  "1123700": {
    "office": {
      "code": "110000",
      "name": "埼玉県",
      "enName": "Saitama",
      "officeName": "熊谷地方気象台",
      "chName": "埼玉县",
      "zhName": "埼玉縣",
      "koName": "사이타마현",
      "esName": "Prefectura de Saitama",
      "ptName": "Província de Saitama",
      "thName": "จังหวัดไซตามะ",
      "viName": "Tỉnh Saitama",
      "inName": "Prefektur Saitama",
      "tlName": "Saitama Prefecture",
      "moName": "Сайтама аймаг",
      "buName": "ဆိုက်တာ့မ ပြည်နယ်",
      "khName": "ខេត្ដ សៃតាម៉ា",
      "neName": "साइतामा जिल्ला"
    },
    "class10": {
      "code": "110010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "埼玉县南部",
      "zhName": "埼玉縣南部",
      "koName": "사이타마 현 남부",
      "esName": "Sur de Prefectura de Saitama",
      "ptName": "Sul da Província de Saitama",
      "thName": "จังหวัดไซตามะตอนใต้",
      "viName": "Miền Nam tỉnh Saitama",
      "inName": "Bagian Selatan Prefektur Saitama",
      "tlName": "Timog na bahagi ng Saitama Prefecture",
      "moName": "Өмнөд Сайтама аймаг",
      "buName": "ဆိုင်းတမစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដសៃតាម៉ា",
      "neName": "साइतामा जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "110012",
      "name": "南東部",
      "enName": "South-eastern Region"
    },
    "class20": {
      "code": "1123700",
      "name": "三郷市",
      "enName": "Misato City",
      "kana": "みさとし",
      "chName": "三乡市",
      "zhName": "三鄉市",
      "koName": "미사토 시",
      "esName": "Ciudad de Misato",
      "ptName": "cidade de Misato",
      "thName": "เมืองมิซาโตะ",
      "viName": "thành phố Misato",
      "inName": "kota Misato",
      "tlName": "siyudad ng Misato",
      "moName": "Мисато хот",
      "buName": "မီဆာ့တို မြို့",
      "khName": "ទីក្រុង មីសាតូ",
      "neName": "मिसातो सहर"
    }
  },
  "1123800": {
    "office": {
      "code": "110000",
      "name": "埼玉県",
      "enName": "Saitama",
      "officeName": "熊谷地方気象台",
      "chName": "埼玉县",
      "zhName": "埼玉縣",
      "koName": "사이타마현",
      "esName": "Prefectura de Saitama",
      "ptName": "Província de Saitama",
      "thName": "จังหวัดไซตามะ",
      "viName": "Tỉnh Saitama",
      "inName": "Prefektur Saitama",
      "tlName": "Saitama Prefecture",
      "moName": "Сайтама аймаг",
      "buName": "ဆိုက်တာ့မ ပြည်နယ်",
      "khName": "ខេត្ដ សៃតាម៉ា",
      "neName": "साइतामा जिल्ला"
    },
    "class10": {
      "code": "110010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "埼玉县南部",
      "zhName": "埼玉縣南部",
      "koName": "사이타마 현 남부",
      "esName": "Sur de Prefectura de Saitama",
      "ptName": "Sul da Província de Saitama",
      "thName": "จังหวัดไซตามะตอนใต้",
      "viName": "Miền Nam tỉnh Saitama",
      "inName": "Bagian Selatan Prefektur Saitama",
      "tlName": "Timog na bahagi ng Saitama Prefecture",
      "moName": "Өмнөд Сайтама аймаг",
      "buName": "ဆိုင်းတမစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដសៃតាម៉ា",
      "neName": "साइतामा जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "110012",
      "name": "南東部",
      "enName": "South-eastern Region"
    },
    "class20": {
      "code": "1123800",
      "name": "蓮田市",
      "enName": "Hasuda City",
      "kana": "はすだし",
      "chName": "莲田市",
      "zhName": "蓮田市",
      "koName": "하스다 시",
      "esName": "Ciudad de Hasuda",
      "ptName": "cidade de Hasuda",
      "thName": "เมืองฮาสุดะ",
      "viName": "thành phố Hasuda",
      "inName": "kota Hasuda",
      "tlName": "siyudad ng Hasuda",
      "moName": "Хасүда хот",
      "buName": "ဟားဆုဒါ့ မြို့",
      "khName": "ទីក្រុង ហាសូដា",
      "neName": "हासुदा सहर"
    }
  },
  "1123900": {
    "office": {
      "code": "110000",
      "name": "埼玉県",
      "enName": "Saitama",
      "officeName": "熊谷地方気象台",
      "chName": "埼玉县",
      "zhName": "埼玉縣",
      "koName": "사이타마현",
      "esName": "Prefectura de Saitama",
      "ptName": "Província de Saitama",
      "thName": "จังหวัดไซตามะ",
      "viName": "Tỉnh Saitama",
      "inName": "Prefektur Saitama",
      "tlName": "Saitama Prefecture",
      "moName": "Сайтама аймаг",
      "buName": "ဆိုက်တာ့မ ပြည်နယ်",
      "khName": "ខេត្ដ សៃតាម៉ា",
      "neName": "साइतामा जिल्ला"
    },
    "class10": {
      "code": "110010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "埼玉县南部",
      "zhName": "埼玉縣南部",
      "koName": "사이타마 현 남부",
      "esName": "Sur de Prefectura de Saitama",
      "ptName": "Sul da Província de Saitama",
      "thName": "จังหวัดไซตามะตอนใต้",
      "viName": "Miền Nam tỉnh Saitama",
      "inName": "Bagian Selatan Prefektur Saitama",
      "tlName": "Timog na bahagi ng Saitama Prefecture",
      "moName": "Өмнөд Сайтама аймаг",
      "buName": "ဆိုင်းတမစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដសៃតាម៉ា",
      "neName": "साइतामा जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "110013",
      "name": "南西部",
      "enName": "South-western Region"
    },
    "class20": {
      "code": "1123900",
      "name": "坂戸市",
      "enName": "Sakado City",
      "kana": "さかどし",
      "chName": "坂户市",
      "zhName": "坂戶市",
      "koName": "사카도 시",
      "esName": "Ciudad de Sakado",
      "ptName": "cidade de Sakado",
      "thName": "เมืองซาคาโดะ",
      "viName": "thành phố Sakado",
      "inName": "kota Sakado",
      "tlName": "siyudad ng Sakado",
      "moName": "Сакадо хот",
      "buName": "ဆားကာ့ဒေါ့ မြို့",
      "khName": "ទីក្រុង សាកាដុ",
      "neName": "साकादो सहर"
    }
  },
  "1124000": {
    "office": {
      "code": "110000",
      "name": "埼玉県",
      "enName": "Saitama",
      "officeName": "熊谷地方気象台",
      "chName": "埼玉县",
      "zhName": "埼玉縣",
      "koName": "사이타마현",
      "esName": "Prefectura de Saitama",
      "ptName": "Província de Saitama",
      "thName": "จังหวัดไซตามะ",
      "viName": "Tỉnh Saitama",
      "inName": "Prefektur Saitama",
      "tlName": "Saitama Prefecture",
      "moName": "Сайтама аймаг",
      "buName": "ဆိုက်တာ့မ ပြည်နယ်",
      "khName": "ខេត្ដ សៃតាម៉ា",
      "neName": "साइतामा जिल्ला"
    },
    "class10": {
      "code": "110010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "埼玉县南部",
      "zhName": "埼玉縣南部",
      "koName": "사이타마 현 남부",
      "esName": "Sur de Prefectura de Saitama",
      "ptName": "Sul da Província de Saitama",
      "thName": "จังหวัดไซตามะตอนใต้",
      "viName": "Miền Nam tỉnh Saitama",
      "inName": "Bagian Selatan Prefektur Saitama",
      "tlName": "Timog na bahagi ng Saitama Prefecture",
      "moName": "Өмнөд Сайтама аймаг",
      "buName": "ဆိုင်းတမစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដសៃតាម៉ា",
      "neName": "साइतामा जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "110012",
      "name": "南東部",
      "enName": "South-eastern Region"
    },
    "class20": {
      "code": "1124000",
      "name": "幸手市",
      "enName": "Satte City",
      "kana": "さってし",
      "chName": "幸手市",
      "zhName": "幸手市",
      "koName": "삿테 시",
      "esName": "Ciudad de Sattsute",
      "ptName": "cidade de Satte",
      "thName": "เมืองซัตเตะ",
      "viName": "thành phố Satte",
      "inName": "kota Satte",
      "tlName": "siyudad ng Satte",
      "moName": "Саттэ хот",
      "buName": "ဆက်တဲ့ မြို့",
      "khName": "ទីក្រុង សាត",
      "neName": "सात्टे सहर"
    }
  },
  "1124100": {
    "office": {
      "code": "110000",
      "name": "埼玉県",
      "enName": "Saitama",
      "officeName": "熊谷地方気象台",
      "chName": "埼玉县",
      "zhName": "埼玉縣",
      "koName": "사이타마현",
      "esName": "Prefectura de Saitama",
      "ptName": "Província de Saitama",
      "thName": "จังหวัดไซตามะ",
      "viName": "Tỉnh Saitama",
      "inName": "Prefektur Saitama",
      "tlName": "Saitama Prefecture",
      "moName": "Сайтама аймаг",
      "buName": "ဆိုက်တာ့မ ပြည်နယ်",
      "khName": "ខេត្ដ សៃតាម៉ា",
      "neName": "साइतामा जिल्ला"
    },
    "class10": {
      "code": "110010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "埼玉县南部",
      "zhName": "埼玉縣南部",
      "koName": "사이타마 현 남부",
      "esName": "Sur de Prefectura de Saitama",
      "ptName": "Sul da Província de Saitama",
      "thName": "จังหวัดไซตามะตอนใต้",
      "viName": "Miền Nam tỉnh Saitama",
      "inName": "Bagian Selatan Prefektur Saitama",
      "tlName": "Timog na bahagi ng Saitama Prefecture",
      "moName": "Өмнөд Сайтама аймаг",
      "buName": "ဆိုင်းတမစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដសៃតាម៉ា",
      "neName": "साइतामा जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "110013",
      "name": "南西部",
      "enName": "South-western Region"
    },
    "class20": {
      "code": "1124100",
      "name": "鶴ヶ島市",
      "enName": "Tsurugashima City",
      "kana": "つるがしまし",
      "chName": "鹤岛市",
      "zhName": "鶴島市",
      "koName": "쓰루가시마 시",
      "esName": "Ciudad de Tsurugashima",
      "ptName": "cidade de Tsurugashima",
      "thName": "เมืองสึรุงาชิมะ",
      "viName": "thành phố Tsurugashima",
      "inName": "kota Tsurugashima",
      "tlName": "siyudad ng Tsurugashima",
      "moName": "Цүрүгaшима хот",
      "buName": "ဆူရုဂါ့ရှိမ မြို့",
      "khName": "ទីក្រុង ស៊ូរូកាហ្សីម៉ា",
      "neName": "त्सुरुगाशिमा सहर"
    }
  },
  "1124200": {
    "office": {
      "code": "110000",
      "name": "埼玉県",
      "enName": "Saitama",
      "officeName": "熊谷地方気象台",
      "chName": "埼玉县",
      "zhName": "埼玉縣",
      "koName": "사이타마현",
      "esName": "Prefectura de Saitama",
      "ptName": "Província de Saitama",
      "thName": "จังหวัดไซตามะ",
      "viName": "Tỉnh Saitama",
      "inName": "Prefektur Saitama",
      "tlName": "Saitama Prefecture",
      "moName": "Сайтама аймаг",
      "buName": "ဆိုက်တာ့မ ပြည်နယ်",
      "khName": "ខេត្ដ សៃតាម៉ា",
      "neName": "साइतामा जिल्ला"
    },
    "class10": {
      "code": "110010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "埼玉县南部",
      "zhName": "埼玉縣南部",
      "koName": "사이타마 현 남부",
      "esName": "Sur de Prefectura de Saitama",
      "ptName": "Sul da Província de Saitama",
      "thName": "จังหวัดไซตามะตอนใต้",
      "viName": "Miền Nam tỉnh Saitama",
      "inName": "Bagian Selatan Prefektur Saitama",
      "tlName": "Timog na bahagi ng Saitama Prefecture",
      "moName": "Өмнөд Сайтама аймаг",
      "buName": "ဆိုင်းတမစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដសៃតាម៉ា",
      "neName": "साइतामा जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "110013",
      "name": "南西部",
      "enName": "South-western Region"
    },
    "class20": {
      "code": "1124200",
      "name": "日高市",
      "enName": "Hidaka City",
      "kana": "ひだかし",
      "chName": "日高市",
      "zhName": "日髙市",
      "koName": "히다카 시",
      "esName": "Ciudad de Hidaka",
      "ptName": "cidade de Hidaka",
      "thName": "เมืองฮิดากะ",
      "viName": "thành phố Hidaka",
      "inName": "kota Hidaka",
      "tlName": "siyudad ng Hidaka",
      "moName": "Хидака хот",
      "buName": "ဟီဒါ့က မြို့",
      "khName": "ទីក្រុង ហ៊ីដាកា",
      "neName": "हिदाका सहर"
    }
  },
  "1124300": {
    "office": {
      "code": "110000",
      "name": "埼玉県",
      "enName": "Saitama",
      "officeName": "熊谷地方気象台",
      "chName": "埼玉县",
      "zhName": "埼玉縣",
      "koName": "사이타마현",
      "esName": "Prefectura de Saitama",
      "ptName": "Província de Saitama",
      "thName": "จังหวัดไซตามะ",
      "viName": "Tỉnh Saitama",
      "inName": "Prefektur Saitama",
      "tlName": "Saitama Prefecture",
      "moName": "Сайтама аймаг",
      "buName": "ဆိုက်တာ့မ ပြည်နယ်",
      "khName": "ខេត្ដ សៃតាម៉ា",
      "neName": "साइतामा जिल्ला"
    },
    "class10": {
      "code": "110010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "埼玉县南部",
      "zhName": "埼玉縣南部",
      "koName": "사이타마 현 남부",
      "esName": "Sur de Prefectura de Saitama",
      "ptName": "Sul da Província de Saitama",
      "thName": "จังหวัดไซตามะตอนใต้",
      "viName": "Miền Nam tỉnh Saitama",
      "inName": "Bagian Selatan Prefektur Saitama",
      "tlName": "Timog na bahagi ng Saitama Prefecture",
      "moName": "Өмнөд Сайтама аймаг",
      "buName": "ဆိုင်းတမစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដសៃតាម៉ា",
      "neName": "साइतामा जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "110012",
      "name": "南東部",
      "enName": "South-eastern Region"
    },
    "class20": {
      "code": "1124300",
      "name": "吉川市",
      "enName": "Yoshikawa City",
      "kana": "よしかわし",
      "chName": "吉川市",
      "zhName": "吉川市",
      "koName": "요시카와 시",
      "esName": "Ciudad de Yoshikawa",
      "ptName": "cidade de Yoshikawa",
      "thName": "เมืองโยชิคาวะ",
      "viName": "thành phố Yoshikawa",
      "inName": "kota Yoshikawa",
      "tlName": "siyudad ng Yoshikawa",
      "moName": "Ёшикава хот",
      "buName": "ယိုရှိကာ့ဝ မြို့",
      "khName": "ទីក្រុង យ៉ូស៊ីកាវ៉ា",
      "neName": "योशिकावा सहर"
    }
  },
  "1124500": {
    "office": {
      "code": "110000",
      "name": "埼玉県",
      "enName": "Saitama",
      "officeName": "熊谷地方気象台",
      "chName": "埼玉县",
      "zhName": "埼玉縣",
      "koName": "사이타마현",
      "esName": "Prefectura de Saitama",
      "ptName": "Província de Saitama",
      "thName": "จังหวัดไซตามะ",
      "viName": "Tỉnh Saitama",
      "inName": "Prefektur Saitama",
      "tlName": "Saitama Prefecture",
      "moName": "Сайтама аймаг",
      "buName": "ဆိုက်တာ့မ ပြည်နယ်",
      "khName": "ខេត្ដ សៃតាម៉ា",
      "neName": "साइतामा जिल्ला"
    },
    "class10": {
      "code": "110010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "埼玉县南部",
      "zhName": "埼玉縣南部",
      "koName": "사이타마 현 남부",
      "esName": "Sur de Prefectura de Saitama",
      "ptName": "Sul da Província de Saitama",
      "thName": "จังหวัดไซตามะตอนใต้",
      "viName": "Miền Nam tỉnh Saitama",
      "inName": "Bagian Selatan Prefektur Saitama",
      "tlName": "Timog na bahagi ng Saitama Prefecture",
      "moName": "Өмнөд Сайтама аймаг",
      "buName": "ဆိုင်းတမစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដសៃតាម៉ា",
      "neName": "साइतामा जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "110011",
      "name": "南中部",
      "enName": "Southern Central Region"
    },
    "class20": {
      "code": "1124500",
      "name": "ふじみ野市",
      "enName": "Fujimino City",
      "kana": "ふじみのし",
      "chName": "富士见野市",
      "zhName": "富士見野市",
      "koName": "후지미노 시",
      "esName": "Ciudad de Fujimino",
      "ptName": "cidade de Fujimino",
      "thName": "เมืองฟูจิมิโนะ",
      "viName": "thành phố Fujimino",
      "inName": "kota Fujimino",
      "tlName": "siyudad ng Fujimino",
      "moName": "Фүжимино хот",
      "buName": "ဖူဂျိမိနို မြို့",
      "khName": "ទីក្រុង ហ្វូជីមីណូ",
      "neName": "फुजिमिनो सहर"
    }
  },
  "1124600": {
    "office": {
      "code": "110000",
      "name": "埼玉県",
      "enName": "Saitama",
      "officeName": "熊谷地方気象台",
      "chName": "埼玉县",
      "zhName": "埼玉縣",
      "koName": "사이타마현",
      "esName": "Prefectura de Saitama",
      "ptName": "Província de Saitama",
      "thName": "จังหวัดไซตามะ",
      "viName": "Tỉnh Saitama",
      "inName": "Prefektur Saitama",
      "tlName": "Saitama Prefecture",
      "moName": "Сайтама аймаг",
      "buName": "ဆိုက်တာ့မ ပြည်နယ်",
      "khName": "ខេត្ដ សៃតាម៉ា",
      "neName": "साइतामा जिल्ला"
    },
    "class10": {
      "code": "110010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "埼玉县南部",
      "zhName": "埼玉縣南部",
      "koName": "사이타마 현 남부",
      "esName": "Sur de Prefectura de Saitama",
      "ptName": "Sul da Província de Saitama",
      "thName": "จังหวัดไซตามะตอนใต้",
      "viName": "Miền Nam tỉnh Saitama",
      "inName": "Bagian Selatan Prefektur Saitama",
      "tlName": "Timog na bahagi ng Saitama Prefecture",
      "moName": "Өмнөд Сайтама аймаг",
      "buName": "ဆိုင်းတမစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដសៃតាម៉ា",
      "neName": "साइतामा जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "110012",
      "name": "南東部",
      "enName": "South-eastern Region"
    },
    "class20": {
      "code": "1124600",
      "name": "白岡市",
      "enName": "Shiraoka City",
      "kana": "しらおかし",
      "chName": "白冈市",
      "zhName": "白岡市",
      "koName": "시라오카 시",
      "esName": "Ciudad de Shiraoka",
      "ptName": "cidade de Shiraoka",
      "thName": "เมืองชิราโอกะ",
      "viName": "thành phố Shiraoka",
      "inName": "kota Shiraoka",
      "tlName": "siyudad ng Shiraoka",
      "moName": "Шираока хот",
      "buName": "ရှီရားအို့က မြို့",
      "khName": "ទីក្រុង សៀអូកា",
      "neName": "शिराओका सहर"
    }
  },
  "1130100": {
    "office": {
      "code": "110000",
      "name": "埼玉県",
      "enName": "Saitama",
      "officeName": "熊谷地方気象台",
      "chName": "埼玉县",
      "zhName": "埼玉縣",
      "koName": "사이타마현",
      "esName": "Prefectura de Saitama",
      "ptName": "Província de Saitama",
      "thName": "จังหวัดไซตามะ",
      "viName": "Tỉnh Saitama",
      "inName": "Prefektur Saitama",
      "tlName": "Saitama Prefecture",
      "moName": "Сайтама аймаг",
      "buName": "ဆိုက်တာ့မ ပြည်နယ်",
      "khName": "ខេត្ដ សៃតាម៉ា",
      "neName": "साइतामा जिल्ला"
    },
    "class10": {
      "code": "110010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "埼玉县南部",
      "zhName": "埼玉縣南部",
      "koName": "사이타마 현 남부",
      "esName": "Sur de Prefectura de Saitama",
      "ptName": "Sul da Província de Saitama",
      "thName": "จังหวัดไซตามะตอนใต้",
      "viName": "Miền Nam tỉnh Saitama",
      "inName": "Bagian Selatan Prefektur Saitama",
      "tlName": "Timog na bahagi ng Saitama Prefecture",
      "moName": "Өмнөд Сайтама аймаг",
      "buName": "ဆိုင်းတမစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដសៃតាម៉ា",
      "neName": "साइतामा जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "110011",
      "name": "南中部",
      "enName": "Southern Central Region"
    },
    "class20": {
      "code": "1130100",
      "name": "伊奈町",
      "enName": "Ina Town",
      "kana": "いなまち",
      "chName": "伊奈町",
      "zhName": "伊奈町",
      "koName": "이나 정",
      "esName": "Pueblo de Ina",
      "ptName": "bairro de Ina",
      "thName": "เมืองอินะ",
      "viName": "thị trấn Ina",
      "inName": "kota Ina",
      "tlName": "bayan ng Ina",
      "moName": "Инa жижиг хот",
      "buName": "အီဏ မြို့နယ်",
      "khName": "ទីប្រជុំជន អ៊ីណា",
      "neName": "इना नगर"
    }
  },
  "1132400": {
    "office": {
      "code": "110000",
      "name": "埼玉県",
      "enName": "Saitama",
      "officeName": "熊谷地方気象台",
      "chName": "埼玉县",
      "zhName": "埼玉縣",
      "koName": "사이타마현",
      "esName": "Prefectura de Saitama",
      "ptName": "Província de Saitama",
      "thName": "จังหวัดไซตามะ",
      "viName": "Tỉnh Saitama",
      "inName": "Prefektur Saitama",
      "tlName": "Saitama Prefecture",
      "moName": "Сайтама аймаг",
      "buName": "ဆိုက်တာ့မ ပြည်နယ်",
      "khName": "ខេត្ដ សៃតាម៉ា",
      "neName": "साइतामा जिल्ला"
    },
    "class10": {
      "code": "110010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "埼玉县南部",
      "zhName": "埼玉縣南部",
      "koName": "사이타마 현 남부",
      "esName": "Sur de Prefectura de Saitama",
      "ptName": "Sul da Província de Saitama",
      "thName": "จังหวัดไซตามะตอนใต้",
      "viName": "Miền Nam tỉnh Saitama",
      "inName": "Bagian Selatan Prefektur Saitama",
      "tlName": "Timog na bahagi ng Saitama Prefecture",
      "moName": "Өмнөд Сайтама аймаг",
      "buName": "ဆိုင်းတမစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដសៃតាម៉ា",
      "neName": "साइतामा जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "110011",
      "name": "南中部",
      "enName": "Southern Central Region"
    },
    "class20": {
      "code": "1132400",
      "name": "三芳町",
      "enName": "Miyoshi Town",
      "kana": "みよしまち",
      "chName": "埼玉三芳町",
      "zhName": "埼玉三芳町",
      "koName": "사이타마 미요시 정",
      "esName": "Pueblo de Miyoshi, Saitama",
      "ptName": "Saitama, bairro de Miyoshi",
      "thName": "เมืองมิโยชิ ไซตามะ",
      "viName": "Thị trấn Miyoshi, Saitama",
      "inName": "Kota Miyoshi, Saitama",
      "tlName": "bayan ng Miyoshi, Saitama",
      "moName": "Сайтама Миёши жижиг хот",
      "buName": "ဆိုင်းတမမိယိုရှိမြို့နယ်",
      "khName": "ទីប្រជុំជនមីយ៉ូស៊ី សៃតាម៉ា",
      "neName": "साइतामा मियोशी नगर"
    }
  },
  "1132600": {
    "office": {
      "code": "110000",
      "name": "埼玉県",
      "enName": "Saitama",
      "officeName": "熊谷地方気象台",
      "chName": "埼玉县",
      "zhName": "埼玉縣",
      "koName": "사이타마현",
      "esName": "Prefectura de Saitama",
      "ptName": "Província de Saitama",
      "thName": "จังหวัดไซตามะ",
      "viName": "Tỉnh Saitama",
      "inName": "Prefektur Saitama",
      "tlName": "Saitama Prefecture",
      "moName": "Сайтама аймаг",
      "buName": "ဆိုက်တာ့မ ပြည်နယ်",
      "khName": "ខេត្ដ សៃតាម៉ា",
      "neName": "साइतामा जिल्ला"
    },
    "class10": {
      "code": "110010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "埼玉县南部",
      "zhName": "埼玉縣南部",
      "koName": "사이타마 현 남부",
      "esName": "Sur de Prefectura de Saitama",
      "ptName": "Sul da Província de Saitama",
      "thName": "จังหวัดไซตามะตอนใต้",
      "viName": "Miền Nam tỉnh Saitama",
      "inName": "Bagian Selatan Prefektur Saitama",
      "tlName": "Timog na bahagi ng Saitama Prefecture",
      "moName": "Өмнөд Сайтама аймаг",
      "buName": "ဆိုင်းတမစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដសៃតាម៉ា",
      "neName": "साइतामा जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "110013",
      "name": "南西部",
      "enName": "South-western Region"
    },
    "class20": {
      "code": "1132600",
      "name": "毛呂山町",
      "enName": "Moroyama Town",
      "kana": "もろやままち",
      "chName": "毛吕山町",
      "zhName": "毛呂山町",
      "koName": "모로야마 정",
      "esName": "Pueblo de Moroyama",
      "ptName": "bairro de Moroyama",
      "thName": "เมืองโมโรยามะ",
      "viName": "thị trấn Moroyama",
      "inName": "kota Moroyama",
      "tlName": "bayan ng Moroyama",
      "moName": "Мороямa жижиг хот",
      "buName": "မိုရိုးယာ့မ မြို့နယ်",
      "khName": "ទីប្រជុំជន ម៉ូរ៉ូយ៉ាម៉ា",
      "neName": "मोरोयामा नगर"
    }
  },
  "1132700": {
    "office": {
      "code": "110000",
      "name": "埼玉県",
      "enName": "Saitama",
      "officeName": "熊谷地方気象台",
      "chName": "埼玉县",
      "zhName": "埼玉縣",
      "koName": "사이타마현",
      "esName": "Prefectura de Saitama",
      "ptName": "Província de Saitama",
      "thName": "จังหวัดไซตามะ",
      "viName": "Tỉnh Saitama",
      "inName": "Prefektur Saitama",
      "tlName": "Saitama Prefecture",
      "moName": "Сайтама аймаг",
      "buName": "ဆိုက်တာ့မ ပြည်နယ်",
      "khName": "ខេត្ដ សៃតាម៉ា",
      "neName": "साइतामा जिल्ला"
    },
    "class10": {
      "code": "110010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "埼玉县南部",
      "zhName": "埼玉縣南部",
      "koName": "사이타마 현 남부",
      "esName": "Sur de Prefectura de Saitama",
      "ptName": "Sul da Província de Saitama",
      "thName": "จังหวัดไซตามะตอนใต้",
      "viName": "Miền Nam tỉnh Saitama",
      "inName": "Bagian Selatan Prefektur Saitama",
      "tlName": "Timog na bahagi ng Saitama Prefecture",
      "moName": "Өмнөд Сайтама аймаг",
      "buName": "ဆိုင်းတမစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដសៃតាម៉ា",
      "neName": "साइतामा जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "110013",
      "name": "南西部",
      "enName": "South-western Region"
    },
    "class20": {
      "code": "1132700",
      "name": "越生町",
      "enName": "Ogose Town",
      "kana": "おごせまち",
      "chName": "越生町",
      "zhName": "越生町",
      "koName": "오고세 정",
      "esName": "Pueblo de Ogose",
      "ptName": "bairro de Ogose",
      "thName": "เมืองโอโงเสะ",
      "viName": "thị trấn Ogose",
      "inName": "kota Ogose",
      "tlName": "bayan ng Ogose",
      "moName": "Огосэ жижиг хот",
      "buName": "အို့ဂိုးဆဲ့ မြို့နယ်",
      "khName": "ទីប្រជុំជន អូហ្គូសេ",
      "neName": "ओगोसे नगर"
    }
  },
  "1134100": {
    "office": {
      "code": "110000",
      "name": "埼玉県",
      "enName": "Saitama",
      "officeName": "熊谷地方気象台",
      "chName": "埼玉县",
      "zhName": "埼玉縣",
      "koName": "사이타마현",
      "esName": "Prefectura de Saitama",
      "ptName": "Província de Saitama",
      "thName": "จังหวัดไซตามะ",
      "viName": "Tỉnh Saitama",
      "inName": "Prefektur Saitama",
      "tlName": "Saitama Prefecture",
      "moName": "Сайтама аймаг",
      "buName": "ဆိုက်တာ့မ ပြည်နယ်",
      "khName": "ខេត្ដ សៃតាម៉ា",
      "neName": "साइतामा जिल्ला"
    },
    "class10": {
      "code": "110020",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "埼玉县北部",
      "zhName": "埼玉縣北部",
      "koName": "사이타마 현 북부",
      "esName": "Norte de Prefectura de Saitama",
      "ptName": "Norte da Província de Saitama",
      "thName": "จังหวัดไซตามะตอนเหนือ",
      "viName": "Miền Bắc tỉnh Saitama",
      "inName": "Bagian Utara Prefektur Saitama",
      "tlName": "Hilagang bahagi ng Saitama Prefecture",
      "moName": "Хойд Сайтама аймаг",
      "buName": "ဆိုင်းတမစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដសៃតាម៉ា",
      "neName": "साइतामा जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "110022",
      "name": "北西部",
      "enName": "North-western Region"
    },
    "class20": {
      "code": "1134100",
      "name": "滑川町",
      "enName": "Namegawa Town",
      "kana": "なめがわまち",
      "chName": "滑川町",
      "zhName": "滑川町",
      "koName": "나메가와 정",
      "esName": "Pueblo de Namegawa",
      "ptName": "bairro de Namegawa",
      "thName": "เมืองนาเมงาวะ",
      "viName": "thị trấn Namegawa",
      "inName": "kota Namegawa",
      "tlName": "bayan ng Namegawa",
      "moName": "Нaмэгава жижиг хот",
      "buName": "နာမဲဂါ့ဝ မြို့နယ်",
      "khName": "ទីប្រជុំជន ណាមេហ្កាវ៉ា ",
      "neName": "नामेगावा नगर"
    }
  },
  "1134200": {
    "office": {
      "code": "110000",
      "name": "埼玉県",
      "enName": "Saitama",
      "officeName": "熊谷地方気象台",
      "chName": "埼玉县",
      "zhName": "埼玉縣",
      "koName": "사이타마현",
      "esName": "Prefectura de Saitama",
      "ptName": "Província de Saitama",
      "thName": "จังหวัดไซตามะ",
      "viName": "Tỉnh Saitama",
      "inName": "Prefektur Saitama",
      "tlName": "Saitama Prefecture",
      "moName": "Сайтама аймаг",
      "buName": "ဆိုက်တာ့မ ပြည်နယ်",
      "khName": "ខេត្ដ សៃតាម៉ា",
      "neName": "साइतामा जिल्ला"
    },
    "class10": {
      "code": "110020",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "埼玉县北部",
      "zhName": "埼玉縣北部",
      "koName": "사이타마 현 북부",
      "esName": "Norte de Prefectura de Saitama",
      "ptName": "Norte da Província de Saitama",
      "thName": "จังหวัดไซตามะตอนเหนือ",
      "viName": "Miền Bắc tỉnh Saitama",
      "inName": "Bagian Utara Prefektur Saitama",
      "tlName": "Hilagang bahagi ng Saitama Prefecture",
      "moName": "Хойд Сайтама аймаг",
      "buName": "ဆိုင်းတမစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដសៃតាម៉ា",
      "neName": "साइतामा जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "110022",
      "name": "北西部",
      "enName": "North-western Region"
    },
    "class20": {
      "code": "1134200",
      "name": "嵐山町",
      "enName": "Ranzan Town",
      "kana": "らんざんまち",
      "chName": "岚山町",
      "zhName": "嵐山町",
      "koName": "란잔 정",
      "esName": "Pueblo de Ranzan",
      "ptName": "bairro de Ranzan",
      "thName": "เมืองรันซัง",
      "viName": "thị trấn Ranzan",
      "inName": "kota Ranzan",
      "tlName": "bayan ng Ranzan",
      "moName": "Ранзaн жижиг хот",
      "buName": "ရန်းဇန်း မြို့နယ်",
      "khName": "ទីប្រជុំជន រ៉ានហ្សាន",
      "neName": "रान्जान नगर"
    }
  },
  "1134300": {
    "office": {
      "code": "110000",
      "name": "埼玉県",
      "enName": "Saitama",
      "officeName": "熊谷地方気象台",
      "chName": "埼玉县",
      "zhName": "埼玉縣",
      "koName": "사이타마현",
      "esName": "Prefectura de Saitama",
      "ptName": "Província de Saitama",
      "thName": "จังหวัดไซตามะ",
      "viName": "Tỉnh Saitama",
      "inName": "Prefektur Saitama",
      "tlName": "Saitama Prefecture",
      "moName": "Сайтама аймаг",
      "buName": "ဆိုက်တာ့မ ပြည်နယ်",
      "khName": "ខេត្ដ សៃតាម៉ា",
      "neName": "साइतामा जिल्ला"
    },
    "class10": {
      "code": "110020",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "埼玉县北部",
      "zhName": "埼玉縣北部",
      "koName": "사이타마 현 북부",
      "esName": "Norte de Prefectura de Saitama",
      "ptName": "Norte da Província de Saitama",
      "thName": "จังหวัดไซตามะตอนเหนือ",
      "viName": "Miền Bắc tỉnh Saitama",
      "inName": "Bagian Utara Prefektur Saitama",
      "tlName": "Hilagang bahagi ng Saitama Prefecture",
      "moName": "Хойд Сайтама аймаг",
      "buName": "ဆိုင်းတမစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដសៃតាម៉ា",
      "neName": "साइतामा जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "110022",
      "name": "北西部",
      "enName": "North-western Region"
    },
    "class20": {
      "code": "1134300",
      "name": "小川町",
      "enName": "Ogawa Town",
      "kana": "おがわまち",
      "chName": "小川町",
      "zhName": "小川町",
      "koName": "오가와 정",
      "esName": "Pueblo de Ogawa",
      "ptName": "bairro de Ogawa",
      "thName": "เมืองโองาวะ",
      "viName": "thị trấn Ogawa",
      "inName": "kota Ogawa",
      "tlName": "bayan ng Ogawa",
      "moName": "Огава жижиг хот",
      "buName": "အိုဂါ့ဝ မြို့နယ်",
      "khName": "ទីប្រជុំជន អូហ្គាវ៉ា",
      "neName": "ओगावा नगर"
    }
  },
  "1134600": {
    "office": {
      "code": "110000",
      "name": "埼玉県",
      "enName": "Saitama",
      "officeName": "熊谷地方気象台",
      "chName": "埼玉县",
      "zhName": "埼玉縣",
      "koName": "사이타마현",
      "esName": "Prefectura de Saitama",
      "ptName": "Província de Saitama",
      "thName": "จังหวัดไซตามะ",
      "viName": "Tỉnh Saitama",
      "inName": "Prefektur Saitama",
      "tlName": "Saitama Prefecture",
      "moName": "Сайтама аймаг",
      "buName": "ဆိုက်တာ့မ ပြည်နယ်",
      "khName": "ខេត្ដ សៃតាម៉ា",
      "neName": "साइतामा जिल्ला"
    },
    "class10": {
      "code": "110010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "埼玉县南部",
      "zhName": "埼玉縣南部",
      "koName": "사이타마 현 남부",
      "esName": "Sur de Prefectura de Saitama",
      "ptName": "Sul da Província de Saitama",
      "thName": "จังหวัดไซตามะตอนใต้",
      "viName": "Miền Nam tỉnh Saitama",
      "inName": "Bagian Selatan Prefektur Saitama",
      "tlName": "Timog na bahagi ng Saitama Prefecture",
      "moName": "Өмнөд Сайтама аймаг",
      "buName": "ဆိုင်းတမစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដសៃតាម៉ា",
      "neName": "साइतामा जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "110011",
      "name": "南中部",
      "enName": "Southern Central Region"
    },
    "class20": {
      "code": "1134600",
      "name": "川島町",
      "enName": "Kawajima Town",
      "kana": "かわじままち",
      "chName": "川岛町",
      "zhName": "川島町",
      "koName": "가와지마 정",
      "esName": "Pueblo de Kawajima",
      "ptName": "bairro de Kawajima",
      "thName": "เมืองคาวาจิมะ",
      "viName": "thị trấn Kawajima",
      "inName": "kota Kawajima",
      "tlName": "bayan ng Kawajima",
      "moName": "Каважимa жижиг хот",
      "buName": "ခါဝဂျိမ မြို့နယ်",
      "khName": "ទីប្រជុំជន កាវ៉ាជីម៉ា",
      "neName": "कावाजिमा नगर"
    }
  },
  "1134700": {
    "office": {
      "code": "110000",
      "name": "埼玉県",
      "enName": "Saitama",
      "officeName": "熊谷地方気象台",
      "chName": "埼玉县",
      "zhName": "埼玉縣",
      "koName": "사이타마현",
      "esName": "Prefectura de Saitama",
      "ptName": "Província de Saitama",
      "thName": "จังหวัดไซตามะ",
      "viName": "Tỉnh Saitama",
      "inName": "Prefektur Saitama",
      "tlName": "Saitama Prefecture",
      "moName": "Сайтама аймаг",
      "buName": "ဆိုက်တာ့မ ပြည်နယ်",
      "khName": "ខេត្ដ សៃតាម៉ា",
      "neName": "साइतामा जिल्ला"
    },
    "class10": {
      "code": "110020",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "埼玉县北部",
      "zhName": "埼玉縣北部",
      "koName": "사이타마 현 북부",
      "esName": "Norte de Prefectura de Saitama",
      "ptName": "Norte da Província de Saitama",
      "thName": "จังหวัดไซตามะตอนเหนือ",
      "viName": "Miền Bắc tỉnh Saitama",
      "inName": "Bagian Utara Prefektur Saitama",
      "tlName": "Hilagang bahagi ng Saitama Prefecture",
      "moName": "Хойд Сайтама аймаг",
      "buName": "ဆိုင်းတမစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដសៃតាម៉ា",
      "neName": "साइतामा जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "110022",
      "name": "北西部",
      "enName": "North-western Region"
    },
    "class20": {
      "code": "1134700",
      "name": "吉見町",
      "enName": "Yoshimi Town",
      "kana": "よしみまち",
      "chName": "吉见町",
      "zhName": "吉見町",
      "koName": "요시미 정",
      "esName": "Pueblo de Yoshimi",
      "ptName": "bairro de Yoshimi",
      "thName": "เมืองโยชิมิ",
      "viName": "thị trấn Yoshimi",
      "inName": "kota Yoshimi",
      "tlName": "bayan ng Yoshimi",
      "moName": "Ёшими жижиг хот",
      "buName": "ယော်ရှီမိ မြို့နယ်",
      "khName": "ទីប្រជុំជន យ៉ូស៊ីមី",
      "neName": "योशिमी नगर"
    }
  },
  "1134800": {
    "office": {
      "code": "110000",
      "name": "埼玉県",
      "enName": "Saitama",
      "officeName": "熊谷地方気象台",
      "chName": "埼玉县",
      "zhName": "埼玉縣",
      "koName": "사이타마현",
      "esName": "Prefectura de Saitama",
      "ptName": "Província de Saitama",
      "thName": "จังหวัดไซตามะ",
      "viName": "Tỉnh Saitama",
      "inName": "Prefektur Saitama",
      "tlName": "Saitama Prefecture",
      "moName": "Сайтама аймаг",
      "buName": "ဆိုက်တာ့မ ပြည်နယ်",
      "khName": "ខេត្ដ សៃតាម៉ា",
      "neName": "साइतामा जिल्ला"
    },
    "class10": {
      "code": "110020",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "埼玉县北部",
      "zhName": "埼玉縣北部",
      "koName": "사이타마 현 북부",
      "esName": "Norte de Prefectura de Saitama",
      "ptName": "Norte da Província de Saitama",
      "thName": "จังหวัดไซตามะตอนเหนือ",
      "viName": "Miền Bắc tỉnh Saitama",
      "inName": "Bagian Utara Prefektur Saitama",
      "tlName": "Hilagang bahagi ng Saitama Prefecture",
      "moName": "Хойд Сайтама аймаг",
      "buName": "ဆိုင်းတမစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដសៃតាម៉ា",
      "neName": "साइतामा जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "110022",
      "name": "北西部",
      "enName": "North-western Region"
    },
    "class20": {
      "code": "1134800",
      "name": "鳩山町",
      "enName": "Hatoyama Town",
      "kana": "はとやままち",
      "chName": "鸠山町",
      "zhName": "鳩山町",
      "koName": "하토야마 정",
      "esName": "Pueblo de Hatoyama",
      "ptName": "bairro de Hatoyama",
      "thName": "เมืองฮาโตยามะ",
      "viName": "thị trấn Hatoyama",
      "inName": "kota Hatoyama",
      "tlName": "bayan ng Hatoyama",
      "moName": "Хaтоямa жижиг хот",
      "buName": "ဟာတိုးယာ့မ မြို့နယ်",
      "khName": "ទីប្រជុំជន ហាតូយ៉ាម៉ា",
      "neName": "हातोयामा नगर"
    }
  },
  "1134900": {
    "office": {
      "code": "110000",
      "name": "埼玉県",
      "enName": "Saitama",
      "officeName": "熊谷地方気象台",
      "chName": "埼玉县",
      "zhName": "埼玉縣",
      "koName": "사이타마현",
      "esName": "Prefectura de Saitama",
      "ptName": "Província de Saitama",
      "thName": "จังหวัดไซตามะ",
      "viName": "Tỉnh Saitama",
      "inName": "Prefektur Saitama",
      "tlName": "Saitama Prefecture",
      "moName": "Сайтама аймаг",
      "buName": "ဆိုက်တာ့မ ပြည်နယ်",
      "khName": "ខេត្ដ សៃតាម៉ា",
      "neName": "साइतामा जिल्ला"
    },
    "class10": {
      "code": "110020",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "埼玉县北部",
      "zhName": "埼玉縣北部",
      "koName": "사이타마 현 북부",
      "esName": "Norte de Prefectura de Saitama",
      "ptName": "Norte da Província de Saitama",
      "thName": "จังหวัดไซตามะตอนเหนือ",
      "viName": "Miền Bắc tỉnh Saitama",
      "inName": "Bagian Utara Prefektur Saitama",
      "tlName": "Hilagang bahagi ng Saitama Prefecture",
      "moName": "Хойд Сайтама аймаг",
      "buName": "ဆိုင်းတမစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដសៃតាម៉ា",
      "neName": "साइतामा जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "110022",
      "name": "北西部",
      "enName": "North-western Region"
    },
    "class20": {
      "code": "1134900",
      "name": "ときがわ町",
      "enName": "Tokigawa Town",
      "kana": "ときがわまち",
      "chName": "都几川町",
      "zhName": "都幾川町",
      "koName": "도키가와 정",
      "esName": "Pueblo de Tokigawa",
      "ptName": "bairro de Tokigawa",
      "thName": "เมืองโทคิงาวะ",
      "viName": "thị trấn Tokigawa",
      "inName": "kota Tokigawa",
      "tlName": "bayan ng Tokigawa",
      "moName": "Токигава жижиг хот",
      "buName": "တိုကိဂါ့ဝ မြို့နယ်",
      "khName": "ទីប្រជុំជន ថូហ្គីកាវ៉ា ",
      "neName": "तोकिगावा नगर"
    }
  },
  "1136100": {
    "office": {
      "code": "110000",
      "name": "埼玉県",
      "enName": "Saitama",
      "officeName": "熊谷地方気象台",
      "chName": "埼玉县",
      "zhName": "埼玉縣",
      "koName": "사이타마현",
      "esName": "Prefectura de Saitama",
      "ptName": "Província de Saitama",
      "thName": "จังหวัดไซตามะ",
      "viName": "Tỉnh Saitama",
      "inName": "Prefektur Saitama",
      "tlName": "Saitama Prefecture",
      "moName": "Сайтама аймаг",
      "buName": "ဆိုက်တာ့မ ပြည်နယ်",
      "khName": "ខេត្ដ សៃតាម៉ា",
      "neName": "साइतामा जिल्ला"
    },
    "class10": {
      "code": "110030",
      "name": "秩父地方",
      "enName": "Chichibu Region",
      "chName": "埼玉县秩父地方",
      "zhName": "埼玉縣秩父地方",
      "koName": "사이타마 현 지치부 지방",
      "esName": "Región Chichibu, Prefectura de Saitama",
      "ptName": "Região de Chichibu da Província de Saitama",
      "thName": "ท้องถิ่นจิจิบุ จังหวัดไซตามะ",
      "viName": "Vùng Chichibu tỉnh Saitama",
      "inName": "Daerah Chichibu di Prefektur Saitama",
      "tlName": "Rehiyon ng Chichibu sa Saitama Prefecture",
      "moName": "Сайтама аймаг, Чичибү муж",
      "buName": "ချိချိဘုဒေသ၊ ဆိုင်းတမစီရင်စု",
      "khName": "តំបន់ជីជីបឹនៃខេត្ដសៃតាម៉ា",
      "neName": "साइतामा जिल्ला, चिचिबु क्षेत्र"
    },
    "class15": {
      "code": "110030",
      "name": "秩父地方",
      "enName": "Chichibu District"
    },
    "class20": {
      "code": "1136100",
      "name": "横瀬町",
      "enName": "Yokoze Town",
      "kana": "よこぜまち",
      "chName": "横濑町",
      "zhName": "橫瀨町",
      "koName": "요코제 정",
      "esName": "Pueblo de Yokoze",
      "ptName": "bairro de Yokoze",
      "thName": "เมืองโยโคเสะ",
      "viName": "thị trấn Yokoze",
      "inName": "kota Yokoze",
      "tlName": "bayan ng Yokoze",
      "moName": "Ёокозэ жижиг хот",
      "buName": "ယိုးကို့ဇဲ့ မြို့နယ်",
      "khName": "ទីប្រជុំជន​ យូកូហ្ស៊ី",
      "neName": "योकोजे नगर"
    }
  },
  "1136200": {
    "office": {
      "code": "110000",
      "name": "埼玉県",
      "enName": "Saitama",
      "officeName": "熊谷地方気象台",
      "chName": "埼玉县",
      "zhName": "埼玉縣",
      "koName": "사이타마현",
      "esName": "Prefectura de Saitama",
      "ptName": "Província de Saitama",
      "thName": "จังหวัดไซตามะ",
      "viName": "Tỉnh Saitama",
      "inName": "Prefektur Saitama",
      "tlName": "Saitama Prefecture",
      "moName": "Сайтама аймаг",
      "buName": "ဆိုက်တာ့မ ပြည်နယ်",
      "khName": "ខេត្ដ សៃតាម៉ា",
      "neName": "साइतामा जिल्ला"
    },
    "class10": {
      "code": "110030",
      "name": "秩父地方",
      "enName": "Chichibu Region",
      "chName": "埼玉县秩父地方",
      "zhName": "埼玉縣秩父地方",
      "koName": "사이타마 현 지치부 지방",
      "esName": "Región Chichibu, Prefectura de Saitama",
      "ptName": "Região de Chichibu da Província de Saitama",
      "thName": "ท้องถิ่นจิจิบุ จังหวัดไซตามะ",
      "viName": "Vùng Chichibu tỉnh Saitama",
      "inName": "Daerah Chichibu di Prefektur Saitama",
      "tlName": "Rehiyon ng Chichibu sa Saitama Prefecture",
      "moName": "Сайтама аймаг, Чичибү муж",
      "buName": "ချိချိဘုဒေသ၊ ဆိုင်းတမစီရင်စု",
      "khName": "តំបន់ជីជីបឹនៃខេត្ដសៃតាម៉ា",
      "neName": "साइतामा जिल्ला, चिचिबु क्षेत्र"
    },
    "class15": {
      "code": "110030",
      "name": "秩父地方",
      "enName": "Chichibu District"
    },
    "class20": {
      "code": "1136200",
      "name": "皆野町",
      "enName": "Minano Town",
      "kana": "みなのまち",
      "chName": "皆野町",
      "zhName": "皆野町",
      "koName": "미나노 정",
      "esName": "Pueblo de Minano",
      "ptName": "bairro de Minano",
      "thName": "เมืองมินาโนะ",
      "viName": "thị trấn Minano",
      "inName": "kota Minano",
      "tlName": "bayan ng Minano",
      "moName": "Минaно жижиг хот",
      "buName": "မီနာနို မြို့နယ်",
      "khName": "ទីប្រជុំជន មីណាណូ",
      "neName": "मिनानो नगर"
    }
  },
  "1136300": {
    "office": {
      "code": "110000",
      "name": "埼玉県",
      "enName": "Saitama",
      "officeName": "熊谷地方気象台",
      "chName": "埼玉县",
      "zhName": "埼玉縣",
      "koName": "사이타마현",
      "esName": "Prefectura de Saitama",
      "ptName": "Província de Saitama",
      "thName": "จังหวัดไซตามะ",
      "viName": "Tỉnh Saitama",
      "inName": "Prefektur Saitama",
      "tlName": "Saitama Prefecture",
      "moName": "Сайтама аймаг",
      "buName": "ဆိုက်တာ့မ ပြည်နယ်",
      "khName": "ខេត្ដ សៃតាម៉ា",
      "neName": "साइतामा जिल्ला"
    },
    "class10": {
      "code": "110030",
      "name": "秩父地方",
      "enName": "Chichibu Region",
      "chName": "埼玉县秩父地方",
      "zhName": "埼玉縣秩父地方",
      "koName": "사이타마 현 지치부 지방",
      "esName": "Región Chichibu, Prefectura de Saitama",
      "ptName": "Região de Chichibu da Província de Saitama",
      "thName": "ท้องถิ่นจิจิบุ จังหวัดไซตามะ",
      "viName": "Vùng Chichibu tỉnh Saitama",
      "inName": "Daerah Chichibu di Prefektur Saitama",
      "tlName": "Rehiyon ng Chichibu sa Saitama Prefecture",
      "moName": "Сайтама аймаг, Чичибү муж",
      "buName": "ချိချိဘုဒေသ၊ ဆိုင်းတမစီရင်စု",
      "khName": "តំបន់ជីជីបឹនៃខេត្ដសៃតាម៉ា",
      "neName": "साइतामा जिल्ला, चिचिबु क्षेत्र"
    },
    "class15": {
      "code": "110030",
      "name": "秩父地方",
      "enName": "Chichibu District"
    },
    "class20": {
      "code": "1136300",
      "name": "長瀞町",
      "enName": "Nagatoro Town",
      "kana": "ながとろまち",
      "chName": "长瀞町",
      "zhName": "長瀞町",
      "koName": "나가토로 정",
      "esName": "Pueblo de Nagatoro",
      "ptName": "bairro de Nagatoro",
      "thName": "เมืองนางาโทโร",
      "viName": "thị trấn Nagatoro",
      "inName": "kota Nagatoro",
      "tlName": "bayan ng Nagatoro",
      "moName": "Нaгaторо жижиг хот",
      "buName": "နာဂါတိုရို မြို့နယ်",
      "khName": "ទីប្រជុំជន ណាកាតូរ៉ូ",
      "neName": "नागातोरो नगर"
    }
  },
  "1136500": {
    "office": {
      "code": "110000",
      "name": "埼玉県",
      "enName": "Saitama",
      "officeName": "熊谷地方気象台",
      "chName": "埼玉县",
      "zhName": "埼玉縣",
      "koName": "사이타마현",
      "esName": "Prefectura de Saitama",
      "ptName": "Província de Saitama",
      "thName": "จังหวัดไซตามะ",
      "viName": "Tỉnh Saitama",
      "inName": "Prefektur Saitama",
      "tlName": "Saitama Prefecture",
      "moName": "Сайтама аймаг",
      "buName": "ဆိုက်တာ့မ ပြည်နယ်",
      "khName": "ខេត្ដ សៃតាម៉ា",
      "neName": "साइतामा जिल्ला"
    },
    "class10": {
      "code": "110030",
      "name": "秩父地方",
      "enName": "Chichibu Region",
      "chName": "埼玉县秩父地方",
      "zhName": "埼玉縣秩父地方",
      "koName": "사이타마 현 지치부 지방",
      "esName": "Región Chichibu, Prefectura de Saitama",
      "ptName": "Região de Chichibu da Província de Saitama",
      "thName": "ท้องถิ่นจิจิบุ จังหวัดไซตามะ",
      "viName": "Vùng Chichibu tỉnh Saitama",
      "inName": "Daerah Chichibu di Prefektur Saitama",
      "tlName": "Rehiyon ng Chichibu sa Saitama Prefecture",
      "moName": "Сайтама аймаг, Чичибү муж",
      "buName": "ချိချိဘုဒေသ၊ ဆိုင်းတမစီရင်စု",
      "khName": "តំបន់ជីជីបឹនៃខេត្ដសៃតាម៉ា",
      "neName": "साइतामा जिल्ला, चिचिबु क्षेत्र"
    },
    "class15": {
      "code": "110030",
      "name": "秩父地方",
      "enName": "Chichibu District"
    },
    "class20": {
      "code": "1136500",
      "name": "小鹿野町",
      "enName": "Ogano Town",
      "kana": "おがのまち",
      "chName": "小鹿野町",
      "zhName": "小鹿野町",
      "koName": "오가노 정",
      "esName": "Pueblo de Ogano",
      "ptName": "bairro de Ogano",
      "thName": "เมืองโองาโนะ",
      "viName": "thị trấn Ogano",
      "inName": "kota Ogano",
      "tlName": "bayan ng Ogano",
      "moName": "Огaно жижиг хот",
      "buName": "အိုးဂါနော့ မြို့နယ်",
      "khName": "ទីប្រជុំជន អូកាណូ",
      "neName": "ओगानो नगर"
    }
  },
  "1136900": {
    "office": {
      "code": "110000",
      "name": "埼玉県",
      "enName": "Saitama",
      "officeName": "熊谷地方気象台",
      "chName": "埼玉县",
      "zhName": "埼玉縣",
      "koName": "사이타마현",
      "esName": "Prefectura de Saitama",
      "ptName": "Província de Saitama",
      "thName": "จังหวัดไซตามะ",
      "viName": "Tỉnh Saitama",
      "inName": "Prefektur Saitama",
      "tlName": "Saitama Prefecture",
      "moName": "Сайтама аймаг",
      "buName": "ဆိုက်တာ့မ ပြည်နယ်",
      "khName": "ខេត្ដ សៃតាម៉ា",
      "neName": "साइतामा जिल्ला"
    },
    "class10": {
      "code": "110020",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "埼玉县北部",
      "zhName": "埼玉縣北部",
      "koName": "사이타마 현 북부",
      "esName": "Norte de Prefectura de Saitama",
      "ptName": "Norte da Província de Saitama",
      "thName": "จังหวัดไซตามะตอนเหนือ",
      "viName": "Miền Bắc tỉnh Saitama",
      "inName": "Bagian Utara Prefektur Saitama",
      "tlName": "Hilagang bahagi ng Saitama Prefecture",
      "moName": "Хойд Сайтама аймаг",
      "buName": "ဆိုင်းတမစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដសៃតាម៉ា",
      "neName": "साइतामा जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "110022",
      "name": "北西部",
      "enName": "North-western Region"
    },
    "class20": {
      "code": "1136900",
      "name": "東秩父村",
      "enName": "Higashichichibu Village",
      "kana": "ひがしちちぶむら",
      "chName": "东秩父村",
      "zhName": "東秩父村",
      "koName": "히가시치치부 촌",
      "esName": "Aldea de Higashi-chichibu",
      "ptName": "povoado de Higashichichibu",
      "thName": "หมู่บ้านฮิงาชิอิจิบุ",
      "viName": "làng Higashichichibu",
      "inName": "desa Higashichichibu",
      "tlName": "nayon ng Higashichichibu",
      "moName": "Хигaшичичибү тосгон",
      "buName": "ဟီဂါရှိကျိကျိဘု ကျေးရွာ",
      "khName": "ភូមិ ហ៊ីកាស៊ីជីជីជីប៊ូ",
      "neName": "हिगाशिचिचिबु गाउँ"
    }
  },
  "1138100": {
    "office": {
      "code": "110000",
      "name": "埼玉県",
      "enName": "Saitama",
      "officeName": "熊谷地方気象台",
      "chName": "埼玉县",
      "zhName": "埼玉縣",
      "koName": "사이타마현",
      "esName": "Prefectura de Saitama",
      "ptName": "Província de Saitama",
      "thName": "จังหวัดไซตามะ",
      "viName": "Tỉnh Saitama",
      "inName": "Prefektur Saitama",
      "tlName": "Saitama Prefecture",
      "moName": "Сайтама аймаг",
      "buName": "ဆိုက်တာ့မ ပြည်နယ်",
      "khName": "ខេត្ដ សៃតាម៉ា",
      "neName": "साइतामा जिल्ला"
    },
    "class10": {
      "code": "110020",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "埼玉县北部",
      "zhName": "埼玉縣北部",
      "koName": "사이타마 현 북부",
      "esName": "Norte de Prefectura de Saitama",
      "ptName": "Norte da Província de Saitama",
      "thName": "จังหวัดไซตามะตอนเหนือ",
      "viName": "Miền Bắc tỉnh Saitama",
      "inName": "Bagian Utara Prefektur Saitama",
      "tlName": "Hilagang bahagi ng Saitama Prefecture",
      "moName": "Хойд Сайтама аймаг",
      "buName": "ဆိုင်းတမစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដសៃតាម៉ា",
      "neName": "साइतामा जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "110022",
      "name": "北西部",
      "enName": "North-western Region"
    },
    "class20": {
      "code": "1138100",
      "name": "美里町",
      "enName": "Misato Town",
      "kana": "みさとまち",
      "chName": "埼玉美里町",
      "zhName": "埼玉美裡町",
      "koName": "사이타마 미사토 정",
      "esName": "Pueblo de Misato, Saitama",
      "ptName": "Saitama, bairro de Misato",
      "thName": "เมืองมิซาโตะ ไซตามะ",
      "viName": "Thị trấn Misato, Saitama",
      "inName": "Kota Misato, Saitama",
      "tlName": "bayan ng Misato, Saitama",
      "moName": "Сайтама Мисато жижиг хот",
      "buName": "ဆိုင်းတမမိဆတိုမြို့နယ်",
      "khName": "ទីប្រជុំជនមីសាតូ សៃតាម៉ា",
      "neName": "साइतामा मिसातो नगर"
    }
  },
  "1138300": {
    "office": {
      "code": "110000",
      "name": "埼玉県",
      "enName": "Saitama",
      "officeName": "熊谷地方気象台",
      "chName": "埼玉县",
      "zhName": "埼玉縣",
      "koName": "사이타마현",
      "esName": "Prefectura de Saitama",
      "ptName": "Província de Saitama",
      "thName": "จังหวัดไซตามะ",
      "viName": "Tỉnh Saitama",
      "inName": "Prefektur Saitama",
      "tlName": "Saitama Prefecture",
      "moName": "Сайтама аймаг",
      "buName": "ဆိုက်တာ့မ ပြည်နယ်",
      "khName": "ខេត្ដ សៃតាម៉ា",
      "neName": "साइतामा जिल्ला"
    },
    "class10": {
      "code": "110020",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "埼玉县北部",
      "zhName": "埼玉縣北部",
      "koName": "사이타마 현 북부",
      "esName": "Norte de Prefectura de Saitama",
      "ptName": "Norte da Província de Saitama",
      "thName": "จังหวัดไซตามะตอนเหนือ",
      "viName": "Miền Bắc tỉnh Saitama",
      "inName": "Bagian Utara Prefektur Saitama",
      "tlName": "Hilagang bahagi ng Saitama Prefecture",
      "moName": "Хойд Сайтама аймаг",
      "buName": "ဆိုင်းတမစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដសៃតាម៉ា",
      "neName": "साइतामा जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "110022",
      "name": "北西部",
      "enName": "North-western Region"
    },
    "class20": {
      "code": "1138300",
      "name": "神川町",
      "enName": "Kamikawa Town",
      "kana": "かみかわまち",
      "chName": "埼玉神川町",
      "zhName": "埼玉神川町",
      "koName": "사이타마 가미가와 정",
      "esName": "Pueblo de Kamikawa, Saitama",
      "ptName": "Saitama, bairro de Kamikawa",
      "thName": "เมืองคามิคาวะ ไซตามะ",
      "viName": "Thị trấn Kamikawa, Saitama",
      "inName": "Kota Kamikawa, Saitama",
      "tlName": "bayan ng Kamikawa, Saitama",
      "moName": "Сайтама Камикава жижиг хот",
      "buName": "ဆိုင်းတမခမိကဝမြို့နယ်",
      "khName": "ទីប្រជុំជនកាមីកាវ៉ា សៃតាម៉ា",
      "neName": "साइतामा कामिकावा नगर"
    }
  },
  "1138500": {
    "office": {
      "code": "110000",
      "name": "埼玉県",
      "enName": "Saitama",
      "officeName": "熊谷地方気象台",
      "chName": "埼玉县",
      "zhName": "埼玉縣",
      "koName": "사이타마현",
      "esName": "Prefectura de Saitama",
      "ptName": "Província de Saitama",
      "thName": "จังหวัดไซตามะ",
      "viName": "Tỉnh Saitama",
      "inName": "Prefektur Saitama",
      "tlName": "Saitama Prefecture",
      "moName": "Сайтама аймаг",
      "buName": "ဆိုက်တာ့မ ပြည်နယ်",
      "khName": "ខេត្ដ សៃតាម៉ា",
      "neName": "साइतामा जिल्ला"
    },
    "class10": {
      "code": "110020",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "埼玉县北部",
      "zhName": "埼玉縣北部",
      "koName": "사이타마 현 북부",
      "esName": "Norte de Prefectura de Saitama",
      "ptName": "Norte da Província de Saitama",
      "thName": "จังหวัดไซตามะตอนเหนือ",
      "viName": "Miền Bắc tỉnh Saitama",
      "inName": "Bagian Utara Prefektur Saitama",
      "tlName": "Hilagang bahagi ng Saitama Prefecture",
      "moName": "Хойд Сайтама аймаг",
      "buName": "ဆိုင်းတမစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដសៃតាម៉ា",
      "neName": "साइतामा जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "110022",
      "name": "北西部",
      "enName": "North-western Region"
    },
    "class20": {
      "code": "1138500",
      "name": "上里町",
      "enName": "Kamisato Town",
      "kana": "かみさとまち",
      "chName": "山里町",
      "zhName": "上里町",
      "koName": "가미사토 정",
      "esName": "Pueblo de Kamisato",
      "ptName": "bairro de Kamisato",
      "thName": "เมืองคามิซาโตะ",
      "viName": "thị trấn Kamisato",
      "inName": "kota Kamisato",
      "tlName": "bayan ng Kamisato",
      "moName": "Камисaто жижиг хот",
      "buName": "ဟာမိဆာတို မြို့နယ်",
      "khName": "ទីប្រជុំជន កាមីសាតូ",
      "neName": "कामिसातो नगर"
    }
  },
  "1140800": {
    "office": {
      "code": "110000",
      "name": "埼玉県",
      "enName": "Saitama",
      "officeName": "熊谷地方気象台",
      "chName": "埼玉县",
      "zhName": "埼玉縣",
      "koName": "사이타마현",
      "esName": "Prefectura de Saitama",
      "ptName": "Província de Saitama",
      "thName": "จังหวัดไซตามะ",
      "viName": "Tỉnh Saitama",
      "inName": "Prefektur Saitama",
      "tlName": "Saitama Prefecture",
      "moName": "Сайтама аймаг",
      "buName": "ဆိုက်တာ့မ ပြည်နယ်",
      "khName": "ខេត្ដ សៃតាម៉ា",
      "neName": "साइतामा जिल्ला"
    },
    "class10": {
      "code": "110020",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "埼玉县北部",
      "zhName": "埼玉縣北部",
      "koName": "사이타마 현 북부",
      "esName": "Norte de Prefectura de Saitama",
      "ptName": "Norte da Província de Saitama",
      "thName": "จังหวัดไซตามะตอนเหนือ",
      "viName": "Miền Bắc tỉnh Saitama",
      "inName": "Bagian Utara Prefektur Saitama",
      "tlName": "Hilagang bahagi ng Saitama Prefecture",
      "moName": "Хойд Сайтама аймаг",
      "buName": "ဆိုင်းတမစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដសៃតាម៉ា",
      "neName": "साइतामा जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "110022",
      "name": "北西部",
      "enName": "North-western Region"
    },
    "class20": {
      "code": "1140800",
      "name": "寄居町",
      "enName": "Yorii Town",
      "kana": "よりいまち",
      "chName": "寄居町",
      "zhName": "寄居町",
      "koName": "요리이 정",
      "esName": "Pueblo de Yorii",
      "ptName": "bairro de Yorii",
      "thName": "เมืองโยริอิ",
      "viName": "thị trấn Yorii",
      "inName": "kota Yorii",
      "tlName": "bayan ng Yorii",
      "moName": "Ёорий жижиг хот",
      "buName": "ယိုးရီ မြို့နယ်",
      "khName": "ទីប្រជុំជន យ៉ូរី",
      "neName": "योरी नगर"
    }
  },
  "1144200": {
    "office": {
      "code": "110000",
      "name": "埼玉県",
      "enName": "Saitama",
      "officeName": "熊谷地方気象台",
      "chName": "埼玉县",
      "zhName": "埼玉縣",
      "koName": "사이타마현",
      "esName": "Prefectura de Saitama",
      "ptName": "Província de Saitama",
      "thName": "จังหวัดไซตามะ",
      "viName": "Tỉnh Saitama",
      "inName": "Prefektur Saitama",
      "tlName": "Saitama Prefecture",
      "moName": "Сайтама аймаг",
      "buName": "ဆိုက်တာ့မ ပြည်နယ်",
      "khName": "ខេត្ដ សៃតាម៉ា",
      "neName": "साइतामा जिल्ला"
    },
    "class10": {
      "code": "110010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "埼玉县南部",
      "zhName": "埼玉縣南部",
      "koName": "사이타마 현 남부",
      "esName": "Sur de Prefectura de Saitama",
      "ptName": "Sul da Província de Saitama",
      "thName": "จังหวัดไซตามะตอนใต้",
      "viName": "Miền Nam tỉnh Saitama",
      "inName": "Bagian Selatan Prefektur Saitama",
      "tlName": "Timog na bahagi ng Saitama Prefecture",
      "moName": "Өмнөд Сайтама аймаг",
      "buName": "ဆိုင်းတမစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដសៃតាម៉ា",
      "neName": "साइतामा जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "110012",
      "name": "南東部",
      "enName": "South-eastern Region"
    },
    "class20": {
      "code": "1144200",
      "name": "宮代町",
      "enName": "Miyashiro Town",
      "kana": "みやしろまち",
      "chName": "宫代町",
      "zhName": "宮代町",
      "koName": "미야시로 정",
      "esName": "Pueblo de Miyashiro",
      "ptName": "bairro de Miyashiro",
      "thName": "เมืองมิยาชิโระ",
      "viName": "thị trấn Miyashiro",
      "inName": "kota Miyashiro",
      "tlName": "bayan ng Miyashiro",
      "moName": "Мияширо жижиг хот",
      "buName": "မီယားရှိရို မြို့နယ်",
      "khName": "ទីប្រជុំជន មីយ៉ាស៊ីរ៉ូ",
      "neName": "मियाशिरो नगर"
    }
  },
  "1146400": {
    "office": {
      "code": "110000",
      "name": "埼玉県",
      "enName": "Saitama",
      "officeName": "熊谷地方気象台",
      "chName": "埼玉县",
      "zhName": "埼玉縣",
      "koName": "사이타마현",
      "esName": "Prefectura de Saitama",
      "ptName": "Província de Saitama",
      "thName": "จังหวัดไซตามะ",
      "viName": "Tỉnh Saitama",
      "inName": "Prefektur Saitama",
      "tlName": "Saitama Prefecture",
      "moName": "Сайтама аймаг",
      "buName": "ဆိုက်တာ့မ ပြည်နယ်",
      "khName": "ខេត្ដ សៃតាម៉ា",
      "neName": "साइतामा जिल्ला"
    },
    "class10": {
      "code": "110010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "埼玉县南部",
      "zhName": "埼玉縣南部",
      "koName": "사이타마 현 남부",
      "esName": "Sur de Prefectura de Saitama",
      "ptName": "Sul da Província de Saitama",
      "thName": "จังหวัดไซตามะตอนใต้",
      "viName": "Miền Nam tỉnh Saitama",
      "inName": "Bagian Selatan Prefektur Saitama",
      "tlName": "Timog na bahagi ng Saitama Prefecture",
      "moName": "Өмнөд Сайтама аймаг",
      "buName": "ဆိုင်းတမစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដសៃតាម៉ា",
      "neName": "साइतामा जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "110012",
      "name": "南東部",
      "enName": "South-eastern Region"
    },
    "class20": {
      "code": "1146400",
      "name": "杉戸町",
      "enName": "Sugito Town",
      "kana": "すぎとまち",
      "chName": "杉户町",
      "zhName": "杉戶町",
      "koName": "스기토 정",
      "esName": "Pueblo de Sugito",
      "ptName": "bairro de Sugito",
      "thName": "เมืองสุงิโตะ",
      "viName": "thị trấn Sugito",
      "inName": "kota Sugito",
      "tlName": "bayan ng Sugito",
      "moName": "Сүгито жижиг хот",
      "buName": "ဆုဂိတို မြို့နယ်",
      "khName": "ទីប្រជុំជន ស៊ូជីតូ",
      "neName": "सुगितो नगर"
    }
  },
  "1146500": {
    "office": {
      "code": "110000",
      "name": "埼玉県",
      "enName": "Saitama",
      "officeName": "熊谷地方気象台",
      "chName": "埼玉县",
      "zhName": "埼玉縣",
      "koName": "사이타마현",
      "esName": "Prefectura de Saitama",
      "ptName": "Província de Saitama",
      "thName": "จังหวัดไซตามะ",
      "viName": "Tỉnh Saitama",
      "inName": "Prefektur Saitama",
      "tlName": "Saitama Prefecture",
      "moName": "Сайтама аймаг",
      "buName": "ဆိုက်တာ့မ ပြည်နယ်",
      "khName": "ខេត្ដ សៃតាម៉ា",
      "neName": "साइतामा जिल्ला"
    },
    "class10": {
      "code": "110010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "埼玉县南部",
      "zhName": "埼玉縣南部",
      "koName": "사이타마 현 남부",
      "esName": "Sur de Prefectura de Saitama",
      "ptName": "Sul da Província de Saitama",
      "thName": "จังหวัดไซตามะตอนใต้",
      "viName": "Miền Nam tỉnh Saitama",
      "inName": "Bagian Selatan Prefektur Saitama",
      "tlName": "Timog na bahagi ng Saitama Prefecture",
      "moName": "Өмнөд Сайтама аймаг",
      "buName": "ဆိုင်းတမစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដសៃតាម៉ា",
      "neName": "साइतामा जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "110012",
      "name": "南東部",
      "enName": "South-eastern Region"
    },
    "class20": {
      "code": "1146500",
      "name": "松伏町",
      "enName": "Matsubushi Town",
      "kana": "まつぶしまち",
      "chName": "松伏町",
      "zhName": "松伏町",
      "koName": "마쓰부시 정",
      "esName": "Pueblo de Matsubushi",
      "ptName": "bairro de Matsubushi",
      "thName": "เมืองมัตสึบุชิ",
      "viName": "thị trấn Matsubushi",
      "inName": "kota Matsubushi",
      "tlName": "bayan ng Matsubushi",
      "moName": "Мацүбүши жижиг хот",
      "buName": "မာဆုဘုရှိ မြို့နယ်",
      "khName": "ទីប្រជុំជន ម៉ាតស៊ូប៊ូស៊ី",
      "neName": "मात्सुबुशी नगर"
    }
  },
  "1210000": {
    "office": {
      "code": "120000",
      "name": "千葉県",
      "enName": "Chiba",
      "officeName": "銚子地方気象台",
      "chName": "千叶县",
      "zhName": "千葉縣",
      "koName": "지바현",
      "esName": "Prefectura de Chiba",
      "ptName": "Província de Chiba",
      "thName": "จังหวัดจิบะ",
      "viName": "Tỉnh Chiba",
      "inName": "Prefektur Chiba",
      "tlName": "Chiba Prefecture",
      "moName": "Чиба аймаг",
      "buName": "ကျီဘ ပြည်နယ်",
      "khName": "ខេត្ត ឈីបា",
      "neName": "चिबा जिल्ला"
    },
    "class10": {
      "code": "120010",
      "name": "北西部",
      "enName": "North-western Region",
      "chName": "千叶县北西部",
      "zhName": "千葉縣北西部",
      "koName": "지바 현 북서부",
      "esName": "Noroeste de Prefectura de Chiba",
      "ptName": "Região noroeste da Província de Chiba",
      "thName": "จังหวัดจิบะตอนเหนือฟากตะวันตก",
      "viName": "Miền Tây Bắc tỉnh Chiba",
      "inName": "Bagian Barat Laut Prefektur Chiba",
      "tlName": "Hilaga-kanlurang bahagi ng Chiba Prefecture",
      "moName": "Баруун хойд Чиба аймаг",
      "buName": "ချိဘစီရင်စု အနောက်မြောက်ပိုင်း",
      "khName": "តំបន់ពាយព្យនៃខេត្តឈីបា",
      "neName": "चिबा जिल्लाको उत्तर पश्चिमी भाग"
    },
    "class15": {
      "code": "120011",
      "name": "千葉中央",
      "enName": "Central Chiba"
    },
    "class20": {
      "code": "1210000",
      "name": "千葉市",
      "enName": "Chiba City",
      "kana": "ちばし",
      "chName": "千叶市",
      "zhName": "千葉市",
      "koName": "지바시",
      "esName": "Ciudad de Chiba",
      "ptName": "Cidade de Chiba",
      "thName": "เมืองชิบะ",
      "viName": "Thành phố Chiba",
      "inName": "Kota Chiba",
      "tlName": "Lungsod ng Chiba",
      "moName": "Cidade de Chiba",
      "buName": "ချိဘာမြို့",
      "khName": "ទីក្រុង Chiba",
      "neName": "चिबा शहर"
    }
  },
  "1220200": {
    "office": {
      "code": "120000",
      "name": "千葉県",
      "enName": "Chiba",
      "officeName": "銚子地方気象台",
      "chName": "千叶县",
      "zhName": "千葉縣",
      "koName": "지바현",
      "esName": "Prefectura de Chiba",
      "ptName": "Província de Chiba",
      "thName": "จังหวัดจิบะ",
      "viName": "Tỉnh Chiba",
      "inName": "Prefektur Chiba",
      "tlName": "Chiba Prefecture",
      "moName": "Чиба аймаг",
      "buName": "ကျီဘ ပြည်နယ်",
      "khName": "ខេត្ត ឈីបា",
      "neName": "चिबा जिल्ला"
    },
    "class10": {
      "code": "120020",
      "name": "北東部",
      "enName": "North-eastern Region",
      "chName": "千叶县北东部",
      "zhName": "千葉縣北東部",
      "koName": "지바 현 북동부",
      "esName": "Nodeste de Prefectura de Chiba",
      "ptName": "Região nordeste da Província de Chiba",
      "thName": "จังหวัดจิบะตอนเหนือฟากตะวันออก",
      "viName": "Miền Đông Bắc tỉnh Chiba",
      "inName": "Bagian Timur Laut Prefektur Chiba",
      "tlName": "Hilaga-silangang bahagi ng Chiba Prefecture",
      "moName": "Зүүн хойд Чиба аймаг",
      "buName": "ချိဘစီရင်စု အရှေ့မြောက်ပိုင်း",
      "khName": "តំបន់ឦសាននៃខេត្តឈីបា",
      "neName": "चिबा जिल्लाको उत्तर पूर्वी भाग"
    },
    "class15": {
      "code": "120021",
      "name": "香取・海匝",
      "enName": "Katori Kaiso"
    },
    "class20": {
      "code": "1220200",
      "name": "銚子市",
      "enName": "Choshi City",
      "kana": "ちょうしし",
      "chName": "铫子市",
      "zhName": "銚子市",
      "koName": "조시 시",
      "esName": "Ciudad de Choshi",
      "ptName": "cidade de Choshi",
      "thName": "เมืองโชชิ",
      "viName": "thành phố Choshi",
      "inName": "kota Choshi",
      "tlName": "siyudad ng Choshi",
      "moName": "Чоши хот",
      "buName": "ကျော့ရှိ မြို့",
      "khName": "ទីក្រុង ឆូស៊ី",
      "neName": "चोशि सहर"
    }
  },
  "1220300": {
    "office": {
      "code": "120000",
      "name": "千葉県",
      "enName": "Chiba",
      "officeName": "銚子地方気象台",
      "chName": "千叶县",
      "zhName": "千葉縣",
      "koName": "지바현",
      "esName": "Prefectura de Chiba",
      "ptName": "Província de Chiba",
      "thName": "จังหวัดจิบะ",
      "viName": "Tỉnh Chiba",
      "inName": "Prefektur Chiba",
      "tlName": "Chiba Prefecture",
      "moName": "Чиба аймаг",
      "buName": "ကျီဘ ပြည်နယ်",
      "khName": "ខេត្ត ឈីបា",
      "neName": "चिबा जिल्ला"
    },
    "class10": {
      "code": "120010",
      "name": "北西部",
      "enName": "North-western Region",
      "chName": "千叶县北西部",
      "zhName": "千葉縣北西部",
      "koName": "지바 현 북서부",
      "esName": "Noroeste de Prefectura de Chiba",
      "ptName": "Região noroeste da Província de Chiba",
      "thName": "จังหวัดจิบะตอนเหนือฟากตะวันตก",
      "viName": "Miền Tây Bắc tỉnh Chiba",
      "inName": "Bagian Barat Laut Prefektur Chiba",
      "tlName": "Hilaga-kanlurang bahagi ng Chiba Prefecture",
      "moName": "Баруун хойд Чиба аймаг",
      "buName": "ချိဘစီရင်စု အနောက်မြောက်ပိုင်း",
      "khName": "តំបន់ពាយព្យនៃខេត្តឈីបា",
      "neName": "चिबा जिल्लाको उत्तर पश्चिमी भाग"
    },
    "class15": {
      "code": "120013",
      "name": "東葛飾",
      "enName": "Higashi-katsushika"
    },
    "class20": {
      "code": "1220300",
      "name": "市川市",
      "enName": "Ichikawa City",
      "kana": "いちかわし",
      "chName": "市川市",
      "zhName": "市川市",
      "koName": "이치카와 시",
      "esName": "Ciudad de Ichikawa",
      "ptName": "cidade de Ichikawa",
      "thName": "เมืองอิชิคาวา",
      "viName": "thành phố Ichikawa",
      "inName": "kota Ichikawa",
      "tlName": "siyudad ng Ichikawa",
      "moName": "Ичикава хот",
      "buName": "အီကျိကာ့ဝ မြို့",
      "khName": "ទីក្រុង អ៊ីឈីកាវ៉ា",
      "neName": "इचिकावा सहर"
    }
  },
  "1220400": {
    "office": {
      "code": "120000",
      "name": "千葉県",
      "enName": "Chiba",
      "officeName": "銚子地方気象台",
      "chName": "千叶县",
      "zhName": "千葉縣",
      "koName": "지바현",
      "esName": "Prefectura de Chiba",
      "ptName": "Província de Chiba",
      "thName": "จังหวัดจิบะ",
      "viName": "Tỉnh Chiba",
      "inName": "Prefektur Chiba",
      "tlName": "Chiba Prefecture",
      "moName": "Чиба аймаг",
      "buName": "ကျီဘ ပြည်နယ်",
      "khName": "ខេត្ត ឈីបា",
      "neName": "चिबा जिल्ला"
    },
    "class10": {
      "code": "120010",
      "name": "北西部",
      "enName": "North-western Region",
      "chName": "千叶县北西部",
      "zhName": "千葉縣北西部",
      "koName": "지바 현 북서부",
      "esName": "Noroeste de Prefectura de Chiba",
      "ptName": "Região noroeste da Província de Chiba",
      "thName": "จังหวัดจิบะตอนเหนือฟากตะวันตก",
      "viName": "Miền Tây Bắc tỉnh Chiba",
      "inName": "Bagian Barat Laut Prefektur Chiba",
      "tlName": "Hilaga-kanlurang bahagi ng Chiba Prefecture",
      "moName": "Баруун хойд Чиба аймаг",
      "buName": "ချိဘစီရင်စု အနောက်မြောက်ပိုင်း",
      "khName": "តំបន់ពាយព្យនៃខេត្តឈីបា",
      "neName": "चिबा जिल्लाको उत्तर पश्चिमी भाग"
    },
    "class15": {
      "code": "120013",
      "name": "東葛飾",
      "enName": "Higashi-katsushika"
    },
    "class20": {
      "code": "1220400",
      "name": "船橋市",
      "enName": "Funabashi City",
      "kana": "ふなばしし",
      "chName": "船桥市",
      "zhName": "船橋市",
      "koName": "후나바시 시",
      "esName": "Ciudad de Funabashi",
      "ptName": "cidade de Funabashi",
      "thName": "เมืองฟุนะบาชิ",
      "viName": "thành phố Funabashi",
      "inName": "kota Funabashi",
      "tlName": "siyudad ng Funabashi",
      "moName": "Фүнaбаши хот",
      "buName": "ဖူနဘာ့ရှိ မြို့",
      "khName": "ទីក្រុង ហ្វូណាបាស៊ី",
      "neName": "फुनाबाशि सहर"
    }
  },
  "1220500": {
    "office": {
      "code": "120000",
      "name": "千葉県",
      "enName": "Chiba",
      "officeName": "銚子地方気象台",
      "chName": "千叶县",
      "zhName": "千葉縣",
      "koName": "지바현",
      "esName": "Prefectura de Chiba",
      "ptName": "Província de Chiba",
      "thName": "จังหวัดจิบะ",
      "viName": "Tỉnh Chiba",
      "inName": "Prefektur Chiba",
      "tlName": "Chiba Prefecture",
      "moName": "Чиба аймаг",
      "buName": "ကျီဘ ပြည်နယ်",
      "khName": "ខេត្ត ឈីបា",
      "neName": "चिबा जिल्ला"
    },
    "class10": {
      "code": "120030",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "千叶县南部",
      "zhName": "千葉縣南部",
      "koName": "지바 현 남부",
      "esName": "Sur de Prefectura de Chiba",
      "ptName": "Sul da Província de Chiba",
      "thName": "จังหวัดจิบะตอนใต้",
      "viName": "Miền Nam tỉnh Chiba",
      "inName": "Bagian Selatan Prefektur Chiba",
      "tlName": "Timog na bahagi ng Chiba Prefecture",
      "moName": "Өмнөд Чиба аймаг",
      "buName": "ချိဘစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្តឈីបា",
      "neName": "चिबा जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "120032",
      "name": "夷隅・安房",
      "enName": "Isumi Awa"
    },
    "class20": {
      "code": "1220500",
      "name": "館山市",
      "enName": "Tateyama City",
      "kana": "たてやまし",
      "chName": "馆山市",
      "zhName": "館山市",
      "koName": "다테야마 시",
      "esName": "Ciudad de Tateyama",
      "ptName": "cidade de Tateyama",
      "thName": "เมืองทะเทยามะ",
      "viName": "thành phố Tateyama",
      "inName": "kota Tateyama",
      "tlName": "siyudad ng Tateyama",
      "moName": "Татэямa хот",
      "buName": "တာတေးယာ့မ မြို့",
      "khName": "ទីក្រុង តាតយ៉ាម៉ា",
      "neName": "तातेयामा सहर"
    }
  },
  "1220600": {
    "office": {
      "code": "120000",
      "name": "千葉県",
      "enName": "Chiba",
      "officeName": "銚子地方気象台",
      "chName": "千叶县",
      "zhName": "千葉縣",
      "koName": "지바현",
      "esName": "Prefectura de Chiba",
      "ptName": "Província de Chiba",
      "thName": "จังหวัดจิบะ",
      "viName": "Tỉnh Chiba",
      "inName": "Prefektur Chiba",
      "tlName": "Chiba Prefecture",
      "moName": "Чиба аймаг",
      "buName": "ကျီဘ ပြည်နယ်",
      "khName": "ខេត្ត ឈីបា",
      "neName": "चिबा जिल्ला"
    },
    "class10": {
      "code": "120030",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "千叶县南部",
      "zhName": "千葉縣南部",
      "koName": "지바 현 남부",
      "esName": "Sur de Prefectura de Chiba",
      "ptName": "Sul da Província de Chiba",
      "thName": "จังหวัดจิบะตอนใต้",
      "viName": "Miền Nam tỉnh Chiba",
      "inName": "Bagian Selatan Prefektur Chiba",
      "tlName": "Timog na bahagi ng Chiba Prefecture",
      "moName": "Өмнөд Чиба аймаг",
      "buName": "ချိဘစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្តឈីបា",
      "neName": "चिबा जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "120031",
      "name": "君津",
      "enName": "Kimitsu"
    },
    "class20": {
      "code": "1220600",
      "name": "木更津市",
      "enName": "Kisarazu City",
      "kana": "きさらづし",
      "chName": "木更津市",
      "zhName": "木更津市",
      "koName": "기사라즈 시",
      "esName": "Ciudad de Kisarazu",
      "ptName": "cidade de Kisarazu",
      "thName": "เมืองคิซาราสุ",
      "viName": "thành phố Kisarazu",
      "inName": "kota Kisarazu",
      "tlName": "siyudad ng Kisarazu",
      "moName": "Кизaразү хот",
      "buName": "ခီဆာရာဇု မြို့",
      "khName": "ទីក្រុង គីសារ៉ាហ្សូ",
      "neName": "किसाराजु सहर"
    }
  },
  "1220700": {
    "office": {
      "code": "120000",
      "name": "千葉県",
      "enName": "Chiba",
      "officeName": "銚子地方気象台",
      "chName": "千叶县",
      "zhName": "千葉縣",
      "koName": "지바현",
      "esName": "Prefectura de Chiba",
      "ptName": "Província de Chiba",
      "thName": "จังหวัดจิบะ",
      "viName": "Tỉnh Chiba",
      "inName": "Prefektur Chiba",
      "tlName": "Chiba Prefecture",
      "moName": "Чиба аймаг",
      "buName": "ကျီဘ ပြည်နယ်",
      "khName": "ខេត្ត ឈីបា",
      "neName": "चिबा जिल्ला"
    },
    "class10": {
      "code": "120010",
      "name": "北西部",
      "enName": "North-western Region",
      "chName": "千叶县北西部",
      "zhName": "千葉縣北西部",
      "koName": "지바 현 북서부",
      "esName": "Noroeste de Prefectura de Chiba",
      "ptName": "Região noroeste da Província de Chiba",
      "thName": "จังหวัดจิบะตอนเหนือฟากตะวันตก",
      "viName": "Miền Tây Bắc tỉnh Chiba",
      "inName": "Bagian Barat Laut Prefektur Chiba",
      "tlName": "Hilaga-kanlurang bahagi ng Chiba Prefecture",
      "moName": "Баруун хойд Чиба аймаг",
      "buName": "ချိဘစီရင်စု အနောက်မြောက်ပိုင်း",
      "khName": "តំបន់ពាយព្យនៃខេត្តឈីបា",
      "neName": "चिबा जिल्लाको उत्तर पश्चिमी भाग"
    },
    "class15": {
      "code": "120013",
      "name": "東葛飾",
      "enName": "Higashi-katsushika"
    },
    "class20": {
      "code": "1220700",
      "name": "松戸市",
      "enName": "Matsudo City",
      "kana": "まつどし",
      "chName": "松户市",
      "zhName": "松戶市",
      "koName": "마쓰도 시",
      "esName": "Ciudad de Matsudo",
      "ptName": "cidade de Matsudo",
      "thName": "เมืองมัทสึโดะ",
      "viName": "thành phố Matsudo",
      "inName": "kota Matsudo",
      "tlName": "siyudad ng Matsudo",
      "moName": "Мацүдо хот",
      "buName": "မာဆုဒို မြို့",
      "khName": "ទីក្រុង ម៉ាត់ស៊ូដុ",
      "neName": "मात्सुदो सहर"
    }
  },
  "1220800": {
    "office": {
      "code": "120000",
      "name": "千葉県",
      "enName": "Chiba",
      "officeName": "銚子地方気象台",
      "chName": "千叶县",
      "zhName": "千葉縣",
      "koName": "지바현",
      "esName": "Prefectura de Chiba",
      "ptName": "Província de Chiba",
      "thName": "จังหวัดจิบะ",
      "viName": "Tỉnh Chiba",
      "inName": "Prefektur Chiba",
      "tlName": "Chiba Prefecture",
      "moName": "Чиба аймаг",
      "buName": "ကျီဘ ပြည်နယ်",
      "khName": "ខេត្ត ឈីបា",
      "neName": "चिबा जिल्ला"
    },
    "class10": {
      "code": "120010",
      "name": "北西部",
      "enName": "North-western Region",
      "chName": "千叶县北西部",
      "zhName": "千葉縣北西部",
      "koName": "지바 현 북서부",
      "esName": "Noroeste de Prefectura de Chiba",
      "ptName": "Região noroeste da Província de Chiba",
      "thName": "จังหวัดจิบะตอนเหนือฟากตะวันตก",
      "viName": "Miền Tây Bắc tỉnh Chiba",
      "inName": "Bagian Barat Laut Prefektur Chiba",
      "tlName": "Hilaga-kanlurang bahagi ng Chiba Prefecture",
      "moName": "Баруун хойд Чиба аймаг",
      "buName": "ချိဘစီရင်စု အနောက်မြောက်ပိုင်း",
      "khName": "តំបន់ពាយព្យនៃខេត្តឈីបា",
      "neName": "चिबा जिल्लाको उत्तर पश्चिमी भाग"
    },
    "class15": {
      "code": "120013",
      "name": "東葛飾",
      "enName": "Higashi-katsushika"
    },
    "class20": {
      "code": "1220800",
      "name": "野田市",
      "enName": "Noda City",
      "kana": "のだし",
      "chName": "野田市",
      "zhName": "野田市",
      "koName": "노다 시",
      "esName": "Ciudad de Noda",
      "ptName": "cidade de Noda",
      "thName": "เมืองโนดะ",
      "viName": "thành phố Noda",
      "inName": "kota Noda",
      "tlName": "siyudad ng Noda",
      "moName": "Нода хот",
      "buName": "နိုဒါ့ မြို့",
      "khName": "ទីក្រុង ណូដា",
      "neName": "नोदा सहर"
    }
  },
  "1221000": {
    "office": {
      "code": "120000",
      "name": "千葉県",
      "enName": "Chiba",
      "officeName": "銚子地方気象台",
      "chName": "千叶县",
      "zhName": "千葉縣",
      "koName": "지바현",
      "esName": "Prefectura de Chiba",
      "ptName": "Província de Chiba",
      "thName": "จังหวัดจิบะ",
      "viName": "Tỉnh Chiba",
      "inName": "Prefektur Chiba",
      "tlName": "Chiba Prefecture",
      "moName": "Чиба аймаг",
      "buName": "ကျီဘ ပြည်နယ်",
      "khName": "ខេត្ត ឈីបា",
      "neName": "चिबा जिल्ला"
    },
    "class10": {
      "code": "120020",
      "name": "北東部",
      "enName": "North-eastern Region",
      "chName": "千叶县北东部",
      "zhName": "千葉縣北東部",
      "koName": "지바 현 북동부",
      "esName": "Nodeste de Prefectura de Chiba",
      "ptName": "Região nordeste da Província de Chiba",
      "thName": "จังหวัดจิบะตอนเหนือฟากตะวันออก",
      "viName": "Miền Đông Bắc tỉnh Chiba",
      "inName": "Bagian Timur Laut Prefektur Chiba",
      "tlName": "Hilaga-silangang bahagi ng Chiba Prefecture",
      "moName": "Зүүн хойд Чиба аймаг",
      "buName": "ချိဘစီရင်စု အရှေ့မြောက်ပိုင်း",
      "khName": "តំបន់ឦសាននៃខេត្តឈីបា",
      "neName": "चिबा जिल्लाको उत्तर पूर्वी भाग"
    },
    "class15": {
      "code": "120022",
      "name": "山武・長生",
      "enName": "Sammu Chosei"
    },
    "class20": {
      "code": "1221000",
      "name": "茂原市",
      "enName": "Mobara City",
      "kana": "もばらし",
      "chName": "茂原市",
      "zhName": "茂原市",
      "koName": "모바라 시",
      "esName": "Ciudad de Mobara",
      "ptName": "cidade de Mobara",
      "thName": "เมืองโมบาระ",
      "viName": "thành phố Mobara",
      "inName": "kota Mobara",
      "tlName": "siyudad ng Mobara",
      "moName": "Мобара хот",
      "buName": "မိုးဘာ့ရာ့ မြို့",
      "khName": "ទីក្រុង ម៉ូបារ៉ា",
      "neName": "मोबारा सहर"
    }
  },
  "1221100": {
    "office": {
      "code": "120000",
      "name": "千葉県",
      "enName": "Chiba",
      "officeName": "銚子地方気象台",
      "chName": "千叶县",
      "zhName": "千葉縣",
      "koName": "지바현",
      "esName": "Prefectura de Chiba",
      "ptName": "Província de Chiba",
      "thName": "จังหวัดจิบะ",
      "viName": "Tỉnh Chiba",
      "inName": "Prefektur Chiba",
      "tlName": "Chiba Prefecture",
      "moName": "Чиба аймаг",
      "buName": "ကျီဘ ပြည်နယ်",
      "khName": "ខេត្ត ឈីបា",
      "neName": "चिबा जिल्ला"
    },
    "class10": {
      "code": "120010",
      "name": "北西部",
      "enName": "North-western Region",
      "chName": "千叶县北西部",
      "zhName": "千葉縣北西部",
      "koName": "지바 현 북서부",
      "esName": "Noroeste de Prefectura de Chiba",
      "ptName": "Região noroeste da Província de Chiba",
      "thName": "จังหวัดจิบะตอนเหนือฟากตะวันตก",
      "viName": "Miền Tây Bắc tỉnh Chiba",
      "inName": "Bagian Barat Laut Prefektur Chiba",
      "tlName": "Hilaga-kanlurang bahagi ng Chiba Prefecture",
      "moName": "Баруун хойд Чиба аймаг",
      "buName": "ချိဘစီရင်စု အနောက်မြောက်ပိုင်း",
      "khName": "តំបន់ពាយព្យនៃខេត្តឈីបា",
      "neName": "चिबा जिल्लाको उत्तर पश्चिमी भाग"
    },
    "class15": {
      "code": "120012",
      "name": "印旛",
      "enName": "Imba"
    },
    "class20": {
      "code": "1221100",
      "name": "成田市",
      "enName": "Narita City",
      "kana": "なりたし",
      "chName": "成田市",
      "zhName": "成田市",
      "koName": "나리타 시",
      "esName": "Ciudad de Narita",
      "ptName": "cidade de Narita",
      "thName": "เมืองนาริตะ",
      "viName": "thành phố Narita",
      "inName": "kota Narita",
      "tlName": "siyudad ng Narita",
      "moName": "Нарита хот",
      "buName": "နာ့ရိတ မြို့",
      "khName": "ទីក្រុង ណារីតា",
      "neName": "नारिता सहर"
    }
  },
  "1221200": {
    "office": {
      "code": "120000",
      "name": "千葉県",
      "enName": "Chiba",
      "officeName": "銚子地方気象台",
      "chName": "千叶县",
      "zhName": "千葉縣",
      "koName": "지바현",
      "esName": "Prefectura de Chiba",
      "ptName": "Província de Chiba",
      "thName": "จังหวัดจิบะ",
      "viName": "Tỉnh Chiba",
      "inName": "Prefektur Chiba",
      "tlName": "Chiba Prefecture",
      "moName": "Чиба аймаг",
      "buName": "ကျီဘ ပြည်နယ်",
      "khName": "ខេត្ត ឈីបា",
      "neName": "चिबा जिल्ला"
    },
    "class10": {
      "code": "120010",
      "name": "北西部",
      "enName": "North-western Region",
      "chName": "千叶县北西部",
      "zhName": "千葉縣北西部",
      "koName": "지바 현 북서부",
      "esName": "Noroeste de Prefectura de Chiba",
      "ptName": "Região noroeste da Província de Chiba",
      "thName": "จังหวัดจิบะตอนเหนือฟากตะวันตก",
      "viName": "Miền Tây Bắc tỉnh Chiba",
      "inName": "Bagian Barat Laut Prefektur Chiba",
      "tlName": "Hilaga-kanlurang bahagi ng Chiba Prefecture",
      "moName": "Баруун хойд Чиба аймаг",
      "buName": "ချိဘစီရင်စု အနောက်မြောက်ပိုင်း",
      "khName": "តំបន់ពាយព្យនៃខេត្តឈីបា",
      "neName": "चिबा जिल्लाको उत्तर पश्चिमी भाग"
    },
    "class15": {
      "code": "120012",
      "name": "印旛",
      "enName": "Imba"
    },
    "class20": {
      "code": "1221200",
      "name": "佐倉市",
      "enName": "Sakura City",
      "kana": "さくらし",
      "chName": "千叶佐仓市",
      "zhName": "千葉佐倉市",
      "koName": "치바 사쿠라 시",
      "esName": "Ciudad Sakura, Chiba",
      "ptName": "Chiba, cidade de Sakura",
      "thName": "เมืองซากุระ จิบะ",
      "viName": "Thành phố Sakura, Chiba",
      "inName": "Kota Sakura, Chiba",
      "tlName": "siyudad ng Sakura, Chiba",
      "moName": "Чиба Сакүра хот",
      "buName": "ချိဘဆကူယာမြို့",
      "khName": "ទីក្រុងសាគូរ៉ា ឈីបា",
      "neName": "चिबा साकुरा सहर"
    }
  },
  "1221300": {
    "office": {
      "code": "120000",
      "name": "千葉県",
      "enName": "Chiba",
      "officeName": "銚子地方気象台",
      "chName": "千叶县",
      "zhName": "千葉縣",
      "koName": "지바현",
      "esName": "Prefectura de Chiba",
      "ptName": "Província de Chiba",
      "thName": "จังหวัดจิบะ",
      "viName": "Tỉnh Chiba",
      "inName": "Prefektur Chiba",
      "tlName": "Chiba Prefecture",
      "moName": "Чиба аймаг",
      "buName": "ကျီဘ ပြည်နယ်",
      "khName": "ខេត្ត ឈីបា",
      "neName": "चिबा जिल्ला"
    },
    "class10": {
      "code": "120020",
      "name": "北東部",
      "enName": "North-eastern Region",
      "chName": "千叶县北东部",
      "zhName": "千葉縣北東部",
      "koName": "지바 현 북동부",
      "esName": "Nodeste de Prefectura de Chiba",
      "ptName": "Região nordeste da Província de Chiba",
      "thName": "จังหวัดจิบะตอนเหนือฟากตะวันออก",
      "viName": "Miền Đông Bắc tỉnh Chiba",
      "inName": "Bagian Timur Laut Prefektur Chiba",
      "tlName": "Hilaga-silangang bahagi ng Chiba Prefecture",
      "moName": "Зүүн хойд Чиба аймаг",
      "buName": "ချိဘစီရင်စု အရှေ့မြောက်ပိုင်း",
      "khName": "តំបន់ឦសាននៃខេត្តឈីបា",
      "neName": "चिबा जिल्लाको उत्तर पूर्वी भाग"
    },
    "class15": {
      "code": "120022",
      "name": "山武・長生",
      "enName": "Sammu Chosei"
    },
    "class20": {
      "code": "1221300",
      "name": "東金市",
      "enName": "Togane City",
      "kana": "とうがねし",
      "chName": "东金市",
      "zhName": "東金市",
      "koName": "도가네 시",
      "esName": "Ciudad de Togane",
      "ptName": "cidade de Togane",
      "thName": "เมืองโทกะเนะ",
      "viName": "thành phố Togane",
      "inName": "kota Togane",
      "tlName": "siyudad ng Togane",
      "moName": "Тоганэ хот",
      "buName": "တိုးဂါ့နဲ့ မြို့",
      "khName": "ទីក្រុង តូហ្គោន",
      "neName": "तोगाने सहर"
    }
  },
  "1221500": {
    "office": {
      "code": "120000",
      "name": "千葉県",
      "enName": "Chiba",
      "officeName": "銚子地方気象台",
      "chName": "千叶县",
      "zhName": "千葉縣",
      "koName": "지바현",
      "esName": "Prefectura de Chiba",
      "ptName": "Província de Chiba",
      "thName": "จังหวัดจิบะ",
      "viName": "Tỉnh Chiba",
      "inName": "Prefektur Chiba",
      "tlName": "Chiba Prefecture",
      "moName": "Чиба аймаг",
      "buName": "ကျီဘ ပြည်နယ်",
      "khName": "ខេត្ត ឈីបា",
      "neName": "चिबा जिल्ला"
    },
    "class10": {
      "code": "120020",
      "name": "北東部",
      "enName": "North-eastern Region",
      "chName": "千叶县北东部",
      "zhName": "千葉縣北東部",
      "koName": "지바 현 북동부",
      "esName": "Nodeste de Prefectura de Chiba",
      "ptName": "Região nordeste da Província de Chiba",
      "thName": "จังหวัดจิบะตอนเหนือฟากตะวันออก",
      "viName": "Miền Đông Bắc tỉnh Chiba",
      "inName": "Bagian Timur Laut Prefektur Chiba",
      "tlName": "Hilaga-silangang bahagi ng Chiba Prefecture",
      "moName": "Зүүн хойд Чиба аймаг",
      "buName": "ချိဘစီရင်စု အရှေ့မြောက်ပိုင်း",
      "khName": "តំបន់ឦសាននៃខេត្តឈីបា",
      "neName": "चिबा जिल्लाको उत्तर पूर्वी भाग"
    },
    "class15": {
      "code": "120021",
      "name": "香取・海匝",
      "enName": "Katori Kaiso"
    },
    "class20": {
      "code": "1221500",
      "name": "旭市",
      "enName": "Asahi City",
      "kana": "あさひし",
      "chName": "旭市",
      "zhName": "旭市",
      "koName": "아사히 시",
      "esName": "Ciudad de Asahi",
      "ptName": "cidade de Asahi",
      "thName": "เมืองอาซาฮิ",
      "viName": "thành phố Asahi",
      "inName": "kota Asahi",
      "tlName": "siyudad ng Asahi",
      "moName": "Асахи хот",
      "buName": "အာဆာ့ဟိ မြို့",
      "khName": "ទីក្រុង អាសាហ៊ី",
      "neName": "आसाही सहर"
    }
  },
  "1221600": {
    "office": {
      "code": "120000",
      "name": "千葉県",
      "enName": "Chiba",
      "officeName": "銚子地方気象台",
      "chName": "千叶县",
      "zhName": "千葉縣",
      "koName": "지바현",
      "esName": "Prefectura de Chiba",
      "ptName": "Província de Chiba",
      "thName": "จังหวัดจิบะ",
      "viName": "Tỉnh Chiba",
      "inName": "Prefektur Chiba",
      "tlName": "Chiba Prefecture",
      "moName": "Чиба аймаг",
      "buName": "ကျီဘ ပြည်နယ်",
      "khName": "ខេត្ត ឈីបា",
      "neName": "चिबा जिल्ला"
    },
    "class10": {
      "code": "120010",
      "name": "北西部",
      "enName": "North-western Region",
      "chName": "千叶县北西部",
      "zhName": "千葉縣北西部",
      "koName": "지바 현 북서부",
      "esName": "Noroeste de Prefectura de Chiba",
      "ptName": "Região noroeste da Província de Chiba",
      "thName": "จังหวัดจิบะตอนเหนือฟากตะวันตก",
      "viName": "Miền Tây Bắc tỉnh Chiba",
      "inName": "Bagian Barat Laut Prefektur Chiba",
      "tlName": "Hilaga-kanlurang bahagi ng Chiba Prefecture",
      "moName": "Баруун хойд Чиба аймаг",
      "buName": "ချိဘစီရင်စု အနောက်မြောက်ပိုင်း",
      "khName": "តំបន់ពាយព្យនៃខេត្តឈីបា",
      "neName": "चिबा जिल्लाको उत्तर पश्चिमी भाग"
    },
    "class15": {
      "code": "120013",
      "name": "東葛飾",
      "enName": "Higashi-katsushika"
    },
    "class20": {
      "code": "1221600",
      "name": "習志野市",
      "enName": "Narashino City",
      "kana": "ならしのし",
      "chName": "习志野市",
      "zhName": "習志野市",
      "koName": "나라시노 시",
      "esName": "Ciudad de Narashino",
      "ptName": "cidade de Narashino",
      "thName": "เมืองนาราชิโนะ",
      "viName": "thành phố Narashino",
      "inName": "kota Narashino",
      "tlName": "siyudad ng Narashino",
      "moName": "Нарашино хот",
      "buName": "နာရာရှိနို မြို့",
      "khName": "ទីក្រុង ណារ៉ាស៊ីណូ",
      "neName": "नाराशिनो सहर"
    }
  },
  "1221700": {
    "office": {
      "code": "120000",
      "name": "千葉県",
      "enName": "Chiba",
      "officeName": "銚子地方気象台",
      "chName": "千叶县",
      "zhName": "千葉縣",
      "koName": "지바현",
      "esName": "Prefectura de Chiba",
      "ptName": "Província de Chiba",
      "thName": "จังหวัดจิบะ",
      "viName": "Tỉnh Chiba",
      "inName": "Prefektur Chiba",
      "tlName": "Chiba Prefecture",
      "moName": "Чиба аймаг",
      "buName": "ကျီဘ ပြည်နယ်",
      "khName": "ខេត្ត ឈីបា",
      "neName": "चिबा जिल्ला"
    },
    "class10": {
      "code": "120010",
      "name": "北西部",
      "enName": "North-western Region",
      "chName": "千叶县北西部",
      "zhName": "千葉縣北西部",
      "koName": "지바 현 북서부",
      "esName": "Noroeste de Prefectura de Chiba",
      "ptName": "Região noroeste da Província de Chiba",
      "thName": "จังหวัดจิบะตอนเหนือฟากตะวันตก",
      "viName": "Miền Tây Bắc tỉnh Chiba",
      "inName": "Bagian Barat Laut Prefektur Chiba",
      "tlName": "Hilaga-kanlurang bahagi ng Chiba Prefecture",
      "moName": "Баруун хойд Чиба аймаг",
      "buName": "ချိဘစီရင်စု အနောက်မြောက်ပိုင်း",
      "khName": "តំបន់ពាយព្យនៃខេត្តឈីបា",
      "neName": "चिबा जिल्लाको उत्तर पश्चिमी भाग"
    },
    "class15": {
      "code": "120013",
      "name": "東葛飾",
      "enName": "Higashi-katsushika"
    },
    "class20": {
      "code": "1221700",
      "name": "柏市",
      "enName": "Kashiwa City",
      "kana": "かしわし",
      "chName": "柏市",
      "zhName": "柏市",
      "koName": "가시와 시",
      "esName": "Ciudad de Kashiwa",
      "ptName": "cidade de Kashiwa",
      "thName": "เมือคาชิวะ",
      "viName": "thành phố Kashiwa",
      "inName": "kota Kashiwa",
      "tlName": "siyudad ng Kashiwa",
      "moName": "Кашива хот",
      "buName": "ခါရှိဝ မြို့",
      "khName": "ទីក្រុង កាហ្សីវ៉ា",
      "neName": "काशिवा सहर"
    }
  },
  "1221800": {
    "office": {
      "code": "120000",
      "name": "千葉県",
      "enName": "Chiba",
      "officeName": "銚子地方気象台",
      "chName": "千叶县",
      "zhName": "千葉縣",
      "koName": "지바현",
      "esName": "Prefectura de Chiba",
      "ptName": "Província de Chiba",
      "thName": "จังหวัดจิบะ",
      "viName": "Tỉnh Chiba",
      "inName": "Prefektur Chiba",
      "tlName": "Chiba Prefecture",
      "moName": "Чиба аймаг",
      "buName": "ကျီဘ ပြည်နယ်",
      "khName": "ខេត្ត ឈីបា",
      "neName": "चिबा जिल्ला"
    },
    "class10": {
      "code": "120030",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "千叶县南部",
      "zhName": "千葉縣南部",
      "koName": "지바 현 남부",
      "esName": "Sur de Prefectura de Chiba",
      "ptName": "Sul da Província de Chiba",
      "thName": "จังหวัดจิบะตอนใต้",
      "viName": "Miền Nam tỉnh Chiba",
      "inName": "Bagian Selatan Prefektur Chiba",
      "tlName": "Timog na bahagi ng Chiba Prefecture",
      "moName": "Өмнөд Чиба аймаг",
      "buName": "ချိဘစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្តឈីបា",
      "neName": "चिबा जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "120032",
      "name": "夷隅・安房",
      "enName": "Isumi Awa"
    },
    "class20": {
      "code": "1221800",
      "name": "勝浦市",
      "enName": "Katsuura City",
      "kana": "かつうらし",
      "chName": "胜浦市",
      "zhName": "勝浦市",
      "koName": "가쓰우라 시",
      "esName": "Ciudad de Katsuura",
      "ptName": "cidade de Katsuura",
      "thName": "เมืองคัทสึอุระ",
      "viName": "thành phố Katsuura",
      "inName": "kota Katsuura",
      "tlName": "siyudad ng Katsuura",
      "moName": "Кацүра хот",
      "buName": "ခါဆူးရာ့ မြို့",
      "khName": "ទីក្រុង កាតស៊ូរ៉ា",
      "neName": "कात्सुरा सहर"
    }
  },
  "1221900": {
    "office": {
      "code": "120000",
      "name": "千葉県",
      "enName": "Chiba",
      "officeName": "銚子地方気象台",
      "chName": "千叶县",
      "zhName": "千葉縣",
      "koName": "지바현",
      "esName": "Prefectura de Chiba",
      "ptName": "Província de Chiba",
      "thName": "จังหวัดจิบะ",
      "viName": "Tỉnh Chiba",
      "inName": "Prefektur Chiba",
      "tlName": "Chiba Prefecture",
      "moName": "Чиба аймаг",
      "buName": "ကျီဘ ပြည်နယ်",
      "khName": "ខេត្ត ឈីបា",
      "neName": "चिबा जिल्ला"
    },
    "class10": {
      "code": "120010",
      "name": "北西部",
      "enName": "North-western Region",
      "chName": "千叶县北西部",
      "zhName": "千葉縣北西部",
      "koName": "지바 현 북서부",
      "esName": "Noroeste de Prefectura de Chiba",
      "ptName": "Região noroeste da Província de Chiba",
      "thName": "จังหวัดจิบะตอนเหนือฟากตะวันตก",
      "viName": "Miền Tây Bắc tỉnh Chiba",
      "inName": "Bagian Barat Laut Prefektur Chiba",
      "tlName": "Hilaga-kanlurang bahagi ng Chiba Prefecture",
      "moName": "Баруун хойд Чиба аймаг",
      "buName": "ချိဘစီရင်စု အနောက်မြောက်ပိုင်း",
      "khName": "តំបន់ពាយព្យនៃខេត្តឈីបា",
      "neName": "चिबा जिल्लाको उत्तर पश्चिमी भाग"
    },
    "class15": {
      "code": "120011",
      "name": "千葉中央",
      "enName": "Central Chiba"
    },
    "class20": {
      "code": "1221900",
      "name": "市原市",
      "enName": "Ichihara City",
      "kana": "いちはらし",
      "chName": "市原市",
      "zhName": "市原市",
      "koName": "이치하라 시",
      "esName": "Ciudad de Ichihara",
      "ptName": "cidade de Ichihara",
      "thName": "เมืองอิชิฮาระ",
      "viName": "thành phố Ichihara",
      "inName": "kota Ichihara",
      "tlName": "siyudad ng Ichihara",
      "moName": "Ичихара хот",
      "buName": "အီကျိဟားရာ့ မြို့",
      "khName": "ទីក្រុង អ៊ីជីហារ៉ា",
      "neName": "इचिहारा सहर"
    }
  },
  "1222000": {
    "office": {
      "code": "120000",
      "name": "千葉県",
      "enName": "Chiba",
      "officeName": "銚子地方気象台",
      "chName": "千叶县",
      "zhName": "千葉縣",
      "koName": "지바현",
      "esName": "Prefectura de Chiba",
      "ptName": "Província de Chiba",
      "thName": "จังหวัดจิบะ",
      "viName": "Tỉnh Chiba",
      "inName": "Prefektur Chiba",
      "tlName": "Chiba Prefecture",
      "moName": "Чиба аймаг",
      "buName": "ကျီဘ ပြည်နယ်",
      "khName": "ខេត្ត ឈីបា",
      "neName": "चिबा जिल्ला"
    },
    "class10": {
      "code": "120010",
      "name": "北西部",
      "enName": "North-western Region",
      "chName": "千叶县北西部",
      "zhName": "千葉縣北西部",
      "koName": "지바 현 북서부",
      "esName": "Noroeste de Prefectura de Chiba",
      "ptName": "Região noroeste da Província de Chiba",
      "thName": "จังหวัดจิบะตอนเหนือฟากตะวันตก",
      "viName": "Miền Tây Bắc tỉnh Chiba",
      "inName": "Bagian Barat Laut Prefektur Chiba",
      "tlName": "Hilaga-kanlurang bahagi ng Chiba Prefecture",
      "moName": "Баруун хойд Чиба аймаг",
      "buName": "ချိဘစီရင်စု အနောက်မြောက်ပိုင်း",
      "khName": "តំបន់ពាយព្យនៃខេត្តឈីបា",
      "neName": "चिबा जिल्लाको उत्तर पश्चिमी भाग"
    },
    "class15": {
      "code": "120013",
      "name": "東葛飾",
      "enName": "Higashi-katsushika"
    },
    "class20": {
      "code": "1222000",
      "name": "流山市",
      "enName": "Nagareyama City",
      "kana": "ながれやまし",
      "chName": "流山市",
      "zhName": "流山市",
      "koName": "나가레야마 시",
      "esName": "Ciudad de Nagareyama",
      "ptName": "cidade de Nagareyama",
      "thName": "เมืองนากาเระยามะ",
      "viName": "thành phố Nagareyama",
      "inName": "kota Nagareyama",
      "tlName": "siyudad ng Nagareyama",
      "moName": "Нaгарэямa хот",
      "buName": "နာဂရေးယာ့မ မြို့",
      "khName": "ទីក្រុង ណាហ្គារីយ៉ាម៉ា",
      "neName": "नागारेयामा सहर"
    }
  },
  "1222100": {
    "office": {
      "code": "120000",
      "name": "千葉県",
      "enName": "Chiba",
      "officeName": "銚子地方気象台",
      "chName": "千叶县",
      "zhName": "千葉縣",
      "koName": "지바현",
      "esName": "Prefectura de Chiba",
      "ptName": "Província de Chiba",
      "thName": "จังหวัดจิบะ",
      "viName": "Tỉnh Chiba",
      "inName": "Prefektur Chiba",
      "tlName": "Chiba Prefecture",
      "moName": "Чиба аймаг",
      "buName": "ကျီဘ ပြည်နယ်",
      "khName": "ខេត្ត ឈីបា",
      "neName": "चिबा जिल्ला"
    },
    "class10": {
      "code": "120010",
      "name": "北西部",
      "enName": "North-western Region",
      "chName": "千叶县北西部",
      "zhName": "千葉縣北西部",
      "koName": "지바 현 북서부",
      "esName": "Noroeste de Prefectura de Chiba",
      "ptName": "Região noroeste da Província de Chiba",
      "thName": "จังหวัดจิบะตอนเหนือฟากตะวันตก",
      "viName": "Miền Tây Bắc tỉnh Chiba",
      "inName": "Bagian Barat Laut Prefektur Chiba",
      "tlName": "Hilaga-kanlurang bahagi ng Chiba Prefecture",
      "moName": "Баруун хойд Чиба аймаг",
      "buName": "ချိဘစီရင်စု အနောက်မြောက်ပိုင်း",
      "khName": "តំបន់ពាយព្យនៃខេត្តឈីបា",
      "neName": "चिबा जिल्लाको उत्तर पश्चिमी भाग"
    },
    "class15": {
      "code": "120013",
      "name": "東葛飾",
      "enName": "Higashi-katsushika"
    },
    "class20": {
      "code": "1222100",
      "name": "八千代市",
      "enName": "Yachiyo City",
      "kana": "やちよし",
      "chName": "八千代市",
      "zhName": "八千代市",
      "koName": "야치요 시",
      "esName": "Ciudad de Yachiyo",
      "ptName": "cidade de Yachiyo",
      "thName": "เมืองยะจิโยะ",
      "viName": "thành phố Yachiyo",
      "inName": "kota Yachiyo",
      "tlName": "siyudad ng Yachiyo",
      "moName": "Ячиёо хот",
      "buName": "ယာကျိယို မြို့",
      "khName": "ទីក្រុង យ៉ាជីអូ",
      "neName": "याचियो सहर"
    }
  },
  "1222200": {
    "office": {
      "code": "120000",
      "name": "千葉県",
      "enName": "Chiba",
      "officeName": "銚子地方気象台",
      "chName": "千叶县",
      "zhName": "千葉縣",
      "koName": "지바현",
      "esName": "Prefectura de Chiba",
      "ptName": "Província de Chiba",
      "thName": "จังหวัดจิบะ",
      "viName": "Tỉnh Chiba",
      "inName": "Prefektur Chiba",
      "tlName": "Chiba Prefecture",
      "moName": "Чиба аймаг",
      "buName": "ကျီဘ ပြည်နယ်",
      "khName": "ខេត្ត ឈីបា",
      "neName": "चिबा जिल्ला"
    },
    "class10": {
      "code": "120010",
      "name": "北西部",
      "enName": "North-western Region",
      "chName": "千叶县北西部",
      "zhName": "千葉縣北西部",
      "koName": "지바 현 북서부",
      "esName": "Noroeste de Prefectura de Chiba",
      "ptName": "Região noroeste da Província de Chiba",
      "thName": "จังหวัดจิบะตอนเหนือฟากตะวันตก",
      "viName": "Miền Tây Bắc tỉnh Chiba",
      "inName": "Bagian Barat Laut Prefektur Chiba",
      "tlName": "Hilaga-kanlurang bahagi ng Chiba Prefecture",
      "moName": "Баруун хойд Чиба аймаг",
      "buName": "ချိဘစီရင်စု အနောက်မြောက်ပိုင်း",
      "khName": "តំបន់ពាយព្យនៃខេត្តឈីបា",
      "neName": "चिबा जिल्लाको उत्तर पश्चिमी भाग"
    },
    "class15": {
      "code": "120013",
      "name": "東葛飾",
      "enName": "Higashi-katsushika"
    },
    "class20": {
      "code": "1222200",
      "name": "我孫子市",
      "enName": "Abiko City",
      "kana": "あびこし",
      "chName": "我孙子市",
      "zhName": "我孫子市",
      "koName": "아비코 시",
      "esName": "Ciudad de Abiko",
      "ptName": "cidade de Abiko",
      "thName": "เมืองอะบิโกะ",
      "viName": "thành phố Abiko",
      "inName": "kota Abiko",
      "tlName": "siyudad ng Abiko",
      "moName": "Абико хот",
      "buName": "အာဘီကို မြို့",
      "khName": "ទីក្រុង អាប៊ីកូ",
      "neName": "आबिको सहर"
    }
  },
  "1222300": {
    "office": {
      "code": "120000",
      "name": "千葉県",
      "enName": "Chiba",
      "officeName": "銚子地方気象台",
      "chName": "千叶县",
      "zhName": "千葉縣",
      "koName": "지바현",
      "esName": "Prefectura de Chiba",
      "ptName": "Província de Chiba",
      "thName": "จังหวัดจิบะ",
      "viName": "Tỉnh Chiba",
      "inName": "Prefektur Chiba",
      "tlName": "Chiba Prefecture",
      "moName": "Чиба аймаг",
      "buName": "ကျီဘ ပြည်နယ်",
      "khName": "ខេត្ត ឈីបា",
      "neName": "चिबा जिल्ला"
    },
    "class10": {
      "code": "120030",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "千叶县南部",
      "zhName": "千葉縣南部",
      "koName": "지바 현 남부",
      "esName": "Sur de Prefectura de Chiba",
      "ptName": "Sul da Província de Chiba",
      "thName": "จังหวัดจิบะตอนใต้",
      "viName": "Miền Nam tỉnh Chiba",
      "inName": "Bagian Selatan Prefektur Chiba",
      "tlName": "Timog na bahagi ng Chiba Prefecture",
      "moName": "Өмнөд Чиба аймаг",
      "buName": "ချိဘစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្តឈីបា",
      "neName": "चिबा जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "120032",
      "name": "夷隅・安房",
      "enName": "Isumi Awa"
    },
    "class20": {
      "code": "1222300",
      "name": "鴨川市",
      "enName": "Kamogawa City",
      "kana": "かもがわし",
      "chName": "鸭川市",
      "zhName": "鴨川市",
      "koName": "가모가와 시",
      "esName": "Ciudad de Kamogawa",
      "ptName": "cidade de Kamogawa",
      "thName": "เมืองมาโมกาวา",
      "viName": "thành phố Kamogawa",
      "inName": "kota Kamogawa",
      "tlName": "siyudad ng Kamogawa",
      "moName": "Камогава хот",
      "buName": "ခါမိုကာ့ဝ မြို့",
      "khName": "ទីក្រុង កាម៉ូកាវ៉ា",
      "neName": "कामोगावा सहर"
    }
  },
  "1222400": {
    "office": {
      "code": "120000",
      "name": "千葉県",
      "enName": "Chiba",
      "officeName": "銚子地方気象台",
      "chName": "千叶县",
      "zhName": "千葉縣",
      "koName": "지바현",
      "esName": "Prefectura de Chiba",
      "ptName": "Província de Chiba",
      "thName": "จังหวัดจิบะ",
      "viName": "Tỉnh Chiba",
      "inName": "Prefektur Chiba",
      "tlName": "Chiba Prefecture",
      "moName": "Чиба аймаг",
      "buName": "ကျီဘ ပြည်နယ်",
      "khName": "ខេត្ត ឈីបា",
      "neName": "चिबा जिल्ला"
    },
    "class10": {
      "code": "120010",
      "name": "北西部",
      "enName": "North-western Region",
      "chName": "千叶县北西部",
      "zhName": "千葉縣北西部",
      "koName": "지바 현 북서부",
      "esName": "Noroeste de Prefectura de Chiba",
      "ptName": "Região noroeste da Província de Chiba",
      "thName": "จังหวัดจิบะตอนเหนือฟากตะวันตก",
      "viName": "Miền Tây Bắc tỉnh Chiba",
      "inName": "Bagian Barat Laut Prefektur Chiba",
      "tlName": "Hilaga-kanlurang bahagi ng Chiba Prefecture",
      "moName": "Баруун хойд Чиба аймаг",
      "buName": "ချိဘစီရင်စု အနောက်မြောက်ပိုင်း",
      "khName": "តំបន់ពាយព្យនៃខេត្តឈីបា",
      "neName": "चिबा जिल्लाको उत्तर पश्चिमी भाग"
    },
    "class15": {
      "code": "120013",
      "name": "東葛飾",
      "enName": "Higashi-katsushika"
    },
    "class20": {
      "code": "1222400",
      "name": "鎌ケ谷市",
      "enName": "Kamagaya City",
      "kana": "かまがやし",
      "chName": "镰谷市",
      "zhName": "鐮谷市",
      "koName": "가마가야 시",
      "esName": "Ciudad de Kamagaya",
      "ptName": "cidade de Kamagaya",
      "thName": "เมืองคามากายะ",
      "viName": "thành phố Kamagaya",
      "inName": "kota Kamagaya",
      "tlName": "siyudad ng Kamagaya",
      "moName": "Камагая хот",
      "buName": "ခါမားဂါ့ယ မြို့",
      "khName": "ទីក្រុង កាម៉ាកាយ៉ា",
      "neName": "कामागाया सहर"
    }
  },
  "1222500": {
    "office": {
      "code": "120000",
      "name": "千葉県",
      "enName": "Chiba",
      "officeName": "銚子地方気象台",
      "chName": "千叶县",
      "zhName": "千葉縣",
      "koName": "지바현",
      "esName": "Prefectura de Chiba",
      "ptName": "Província de Chiba",
      "thName": "จังหวัดจิบะ",
      "viName": "Tỉnh Chiba",
      "inName": "Prefektur Chiba",
      "tlName": "Chiba Prefecture",
      "moName": "Чиба аймаг",
      "buName": "ကျီဘ ပြည်နယ်",
      "khName": "ខេត្ត ឈីបា",
      "neName": "चिबा जिल्ला"
    },
    "class10": {
      "code": "120030",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "千叶县南部",
      "zhName": "千葉縣南部",
      "koName": "지바 현 남부",
      "esName": "Sur de Prefectura de Chiba",
      "ptName": "Sul da Província de Chiba",
      "thName": "จังหวัดจิบะตอนใต้",
      "viName": "Miền Nam tỉnh Chiba",
      "inName": "Bagian Selatan Prefektur Chiba",
      "tlName": "Timog na bahagi ng Chiba Prefecture",
      "moName": "Өмнөд Чиба аймаг",
      "buName": "ချိဘစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្តឈីបា",
      "neName": "चिबा जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "120031",
      "name": "君津",
      "enName": "Kimitsu"
    },
    "class20": {
      "code": "1222500",
      "name": "君津市",
      "enName": "Kimitsu City",
      "kana": "きみつし",
      "chName": "君津市",
      "zhName": "君津市",
      "koName": "기미츠 시",
      "esName": "Ciudad de Kimitsu",
      "ptName": "cidade de Kimitsu",
      "thName": "เมืองคิมิสึ",
      "viName": "thành phố Kimitsu",
      "inName": "kota Kimitsu",
      "tlName": "siyudad ng Kimitsu",
      "moName": "Кимицү хот",
      "buName": "ကီးမိဆု မြို့",
      "khName": "ទីក្រុង គីមមិតស៊ូ",
      "neName": "किमित्सु सहर"
    }
  },
  "1222600": {
    "office": {
      "code": "120000",
      "name": "千葉県",
      "enName": "Chiba",
      "officeName": "銚子地方気象台",
      "chName": "千叶县",
      "zhName": "千葉縣",
      "koName": "지바현",
      "esName": "Prefectura de Chiba",
      "ptName": "Província de Chiba",
      "thName": "จังหวัดจิบะ",
      "viName": "Tỉnh Chiba",
      "inName": "Prefektur Chiba",
      "tlName": "Chiba Prefecture",
      "moName": "Чиба аймаг",
      "buName": "ကျီဘ ပြည်နယ်",
      "khName": "ខេត្ត ឈីបា",
      "neName": "चिबा जिल्ला"
    },
    "class10": {
      "code": "120030",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "千叶县南部",
      "zhName": "千葉縣南部",
      "koName": "지바 현 남부",
      "esName": "Sur de Prefectura de Chiba",
      "ptName": "Sul da Província de Chiba",
      "thName": "จังหวัดจิบะตอนใต้",
      "viName": "Miền Nam tỉnh Chiba",
      "inName": "Bagian Selatan Prefektur Chiba",
      "tlName": "Timog na bahagi ng Chiba Prefecture",
      "moName": "Өмнөд Чиба аймаг",
      "buName": "ချိဘစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្តឈីបា",
      "neName": "चिबा जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "120031",
      "name": "君津",
      "enName": "Kimitsu"
    },
    "class20": {
      "code": "1222600",
      "name": "富津市",
      "enName": "Futtsu City",
      "kana": "ふっつし",
      "chName": "富津市",
      "zhName": "富津市",
      "koName": "훗츠 시",
      "esName": "Ciudad de Futtsu",
      "ptName": "cidade de Futtsu",
      "thName": "เมืองฟุตสึ",
      "viName": "thành phố Futtsu",
      "inName": "kota Futtsu",
      "tlName": "siyudad ng Futtsu",
      "moName": "Фүццү хот",
      "buName": "ဖုဆု မြို့",
      "khName": "ទីក្រុង ហ្វុតស៊ូ",
      "neName": "फुत्सु सहर"
    }
  },
  "1222700": {
    "office": {
      "code": "120000",
      "name": "千葉県",
      "enName": "Chiba",
      "officeName": "銚子地方気象台",
      "chName": "千叶县",
      "zhName": "千葉縣",
      "koName": "지바현",
      "esName": "Prefectura de Chiba",
      "ptName": "Província de Chiba",
      "thName": "จังหวัดจิบะ",
      "viName": "Tỉnh Chiba",
      "inName": "Prefektur Chiba",
      "tlName": "Chiba Prefecture",
      "moName": "Чиба аймаг",
      "buName": "ကျီဘ ပြည်နယ်",
      "khName": "ខេត្ត ឈីបា",
      "neName": "चिबा जिल्ला"
    },
    "class10": {
      "code": "120010",
      "name": "北西部",
      "enName": "North-western Region",
      "chName": "千叶县北西部",
      "zhName": "千葉縣北西部",
      "koName": "지바 현 북서부",
      "esName": "Noroeste de Prefectura de Chiba",
      "ptName": "Região noroeste da Província de Chiba",
      "thName": "จังหวัดจิบะตอนเหนือฟากตะวันตก",
      "viName": "Miền Tây Bắc tỉnh Chiba",
      "inName": "Bagian Barat Laut Prefektur Chiba",
      "tlName": "Hilaga-kanlurang bahagi ng Chiba Prefecture",
      "moName": "Баруун хойд Чиба аймаг",
      "buName": "ချိဘစီရင်စု အနောက်မြောက်ပိုင်း",
      "khName": "តំបន់ពាយព្យនៃខេត្តឈីបា",
      "neName": "चिबा जिल्लाको उत्तर पश्चिमी भाग"
    },
    "class15": {
      "code": "120013",
      "name": "東葛飾",
      "enName": "Higashi-katsushika"
    },
    "class20": {
      "code": "1222700",
      "name": "浦安市",
      "enName": "Urayasu City",
      "kana": "うらやすし",
      "chName": "浦安市",
      "zhName": "浦安市",
      "koName": "우라야스 시",
      "esName": "Ciudad de Urayasu",
      "ptName": "cidade de Urayasu",
      "thName": "เมืองอุระยะสึ",
      "viName": "thành phố Urayasu",
      "inName": "kota Urayasu",
      "tlName": "siyudad ng Urayasu",
      "moName": "Үраясү хот",
      "buName": "ဥရာယာ့ဆု မြို့",
      "khName": "ទីក្រុង អ៊ូរ៉ាយយ៉ាស៊ូ",
      "neName": "उरायासु सहर"
    }
  },
  "1222800": {
    "office": {
      "code": "120000",
      "name": "千葉県",
      "enName": "Chiba",
      "officeName": "銚子地方気象台",
      "chName": "千叶县",
      "zhName": "千葉縣",
      "koName": "지바현",
      "esName": "Prefectura de Chiba",
      "ptName": "Província de Chiba",
      "thName": "จังหวัดจิบะ",
      "viName": "Tỉnh Chiba",
      "inName": "Prefektur Chiba",
      "tlName": "Chiba Prefecture",
      "moName": "Чиба аймаг",
      "buName": "ကျီဘ ပြည်နယ်",
      "khName": "ខេត្ត ឈីបា",
      "neName": "चिबा जिल्ला"
    },
    "class10": {
      "code": "120010",
      "name": "北西部",
      "enName": "North-western Region",
      "chName": "千叶县北西部",
      "zhName": "千葉縣北西部",
      "koName": "지바 현 북서부",
      "esName": "Noroeste de Prefectura de Chiba",
      "ptName": "Região noroeste da Província de Chiba",
      "thName": "จังหวัดจิบะตอนเหนือฟากตะวันตก",
      "viName": "Miền Tây Bắc tỉnh Chiba",
      "inName": "Bagian Barat Laut Prefektur Chiba",
      "tlName": "Hilaga-kanlurang bahagi ng Chiba Prefecture",
      "moName": "Баруун хойд Чиба аймаг",
      "buName": "ချိဘစီရင်စု အနောက်မြောက်ပိုင်း",
      "khName": "តំបន់ពាយព្យនៃខេត្តឈីបា",
      "neName": "चिबा जिल्लाको उत्तर पश्चिमी भाग"
    },
    "class15": {
      "code": "120012",
      "name": "印旛",
      "enName": "Imba"
    },
    "class20": {
      "code": "1222800",
      "name": "四街道市",
      "enName": "Yotsukaido City",
      "kana": "よつかいどうし",
      "chName": "四街道市",
      "zhName": "四街道市",
      "koName": "요쓰카이도 시",
      "esName": "Ciudad de Yotsukaido",
      "ptName": "cidade de Yotsukaido",
      "thName": "เมืองยตสึไคโด",
      "viName": "thành phố Yotsukaido",
      "inName": "kota Yotsukaido",
      "tlName": "siyudad ng Yotsukaido",
      "moName": "Ёцүкайдо хот",
      "buName": "ယိုဆုကားယိဒို မြို့",
      "khName": "ទីក្រុង យ៉ុតស៊ូខៃដូ",
      "neName": "योत्सुकाइदो सहर"
    }
  },
  "1222900": {
    "office": {
      "code": "120000",
      "name": "千葉県",
      "enName": "Chiba",
      "officeName": "銚子地方気象台",
      "chName": "千叶县",
      "zhName": "千葉縣",
      "koName": "지바현",
      "esName": "Prefectura de Chiba",
      "ptName": "Província de Chiba",
      "thName": "จังหวัดจิบะ",
      "viName": "Tỉnh Chiba",
      "inName": "Prefektur Chiba",
      "tlName": "Chiba Prefecture",
      "moName": "Чиба аймаг",
      "buName": "ကျီဘ ပြည်နယ်",
      "khName": "ខេត្ត ឈីបា",
      "neName": "चिबा जिल्ला"
    },
    "class10": {
      "code": "120030",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "千叶县南部",
      "zhName": "千葉縣南部",
      "koName": "지바 현 남부",
      "esName": "Sur de Prefectura de Chiba",
      "ptName": "Sul da Província de Chiba",
      "thName": "จังหวัดจิบะตอนใต้",
      "viName": "Miền Nam tỉnh Chiba",
      "inName": "Bagian Selatan Prefektur Chiba",
      "tlName": "Timog na bahagi ng Chiba Prefecture",
      "moName": "Өмнөд Чиба аймаг",
      "buName": "ချိဘစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្តឈីបា",
      "neName": "चिबा जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "120031",
      "name": "君津",
      "enName": "Kimitsu"
    },
    "class20": {
      "code": "1222900",
      "name": "袖ケ浦市",
      "enName": "Sodegaura City",
      "kana": "そでがうらし",
      "chName": "袖浦市",
      "zhName": "袖浦市",
      "koName": "소데가우라 시",
      "esName": "Ciudad de Sodegaura",
      "ptName": "cidade de Sodegaura",
      "thName": "เมืองโซเดะงะอุระ",
      "viName": "thành phố Sodegaura",
      "inName": "kota Sodegaura",
      "tlName": "siyudad ng Sodegaura",
      "moName": "Содэгaүра хот",
      "buName": "ဆိုဒေဂါးအို့ရာ့ မြို့",
      "khName": "ទីក្រុង សូដេកូរ៉ា",
      "neName": "सोदेगाउरा सहर"
    }
  },
  "1223000": {
    "office": {
      "code": "120000",
      "name": "千葉県",
      "enName": "Chiba",
      "officeName": "銚子地方気象台",
      "chName": "千叶县",
      "zhName": "千葉縣",
      "koName": "지바현",
      "esName": "Prefectura de Chiba",
      "ptName": "Província de Chiba",
      "thName": "จังหวัดจิบะ",
      "viName": "Tỉnh Chiba",
      "inName": "Prefektur Chiba",
      "tlName": "Chiba Prefecture",
      "moName": "Чиба аймаг",
      "buName": "ကျီဘ ပြည်နယ်",
      "khName": "ខេត្ត ឈីបា",
      "neName": "चिबा जिल्ला"
    },
    "class10": {
      "code": "120010",
      "name": "北西部",
      "enName": "North-western Region",
      "chName": "千叶县北西部",
      "zhName": "千葉縣北西部",
      "koName": "지바 현 북서부",
      "esName": "Noroeste de Prefectura de Chiba",
      "ptName": "Região noroeste da Província de Chiba",
      "thName": "จังหวัดจิบะตอนเหนือฟากตะวันตก",
      "viName": "Miền Tây Bắc tỉnh Chiba",
      "inName": "Bagian Barat Laut Prefektur Chiba",
      "tlName": "Hilaga-kanlurang bahagi ng Chiba Prefecture",
      "moName": "Баруун хойд Чиба аймаг",
      "buName": "ချိဘစီရင်စု အနောက်မြောက်ပိုင်း",
      "khName": "តំបន់ពាយព្យនៃខេត្តឈីបា",
      "neName": "चिबा जिल्लाको उत्तर पश्चिमी भाग"
    },
    "class15": {
      "code": "120012",
      "name": "印旛",
      "enName": "Imba"
    },
    "class20": {
      "code": "1223000",
      "name": "八街市",
      "enName": "Yachimata City",
      "kana": "やちまたし",
      "chName": "八街市",
      "zhName": "八街市",
      "koName": "야치마타 시",
      "esName": "Ciudad de Yachimata",
      "ptName": "cidade de Yachimata",
      "thName": "เมืองยาชิมาตะ",
      "viName": "thành phố Yachimata",
      "inName": "kota Yachimata",
      "tlName": "siyudad ng Yachimata",
      "moName": "Ячимата хот",
      "buName": "ယာကျိမာ့တ မြို့",
      "khName": "ទីក្រុង យ៉ាជីម៉ាតា",
      "neName": "याचिमाता सहर"
    }
  },
  "1223100": {
    "office": {
      "code": "120000",
      "name": "千葉県",
      "enName": "Chiba",
      "officeName": "銚子地方気象台",
      "chName": "千叶县",
      "zhName": "千葉縣",
      "koName": "지바현",
      "esName": "Prefectura de Chiba",
      "ptName": "Província de Chiba",
      "thName": "จังหวัดจิบะ",
      "viName": "Tỉnh Chiba",
      "inName": "Prefektur Chiba",
      "tlName": "Chiba Prefecture",
      "moName": "Чиба аймаг",
      "buName": "ကျီဘ ပြည်နယ်",
      "khName": "ខេត្ត ឈីបា",
      "neName": "चिबा जिल्ला"
    },
    "class10": {
      "code": "120010",
      "name": "北西部",
      "enName": "North-western Region",
      "chName": "千叶县北西部",
      "zhName": "千葉縣北西部",
      "koName": "지바 현 북서부",
      "esName": "Noroeste de Prefectura de Chiba",
      "ptName": "Região noroeste da Província de Chiba",
      "thName": "จังหวัดจิบะตอนเหนือฟากตะวันตก",
      "viName": "Miền Tây Bắc tỉnh Chiba",
      "inName": "Bagian Barat Laut Prefektur Chiba",
      "tlName": "Hilaga-kanlurang bahagi ng Chiba Prefecture",
      "moName": "Баруун хойд Чиба аймаг",
      "buName": "ချိဘစီရင်စု အနောက်မြောက်ပိုင်း",
      "khName": "តំបន់ពាយព្យនៃខេត្តឈីបា",
      "neName": "चिबा जिल्लाको उत्तर पश्चिमी भाग"
    },
    "class15": {
      "code": "120012",
      "name": "印旛",
      "enName": "Imba"
    },
    "class20": {
      "code": "1223100",
      "name": "印西市",
      "enName": "Inzai City",
      "kana": "いんざいし",
      "chName": "印西市",
      "zhName": "印西市",
      "koName": "인자이 시",
      "esName": "Ciudad de Inzai",
      "ptName": "cidade de Inzai",
      "thName": "เมืองอินไซ",
      "viName": "thành phố Inzai",
      "inName": "kota Inzai",
      "tlName": "siyudad ng Inzai",
      "moName": "Инзай хот",
      "buName": "အင်းဇာ့ယိ မြို့",
      "khName": "ទីក្រុង អ៊ីនសាយ",
      "neName": "इनजाई सहर"
    }
  },
  "1223200": {
    "office": {
      "code": "120000",
      "name": "千葉県",
      "enName": "Chiba",
      "officeName": "銚子地方気象台",
      "chName": "千叶县",
      "zhName": "千葉縣",
      "koName": "지바현",
      "esName": "Prefectura de Chiba",
      "ptName": "Província de Chiba",
      "thName": "จังหวัดจิบะ",
      "viName": "Tỉnh Chiba",
      "inName": "Prefektur Chiba",
      "tlName": "Chiba Prefecture",
      "moName": "Чиба аймаг",
      "buName": "ကျီဘ ပြည်နယ်",
      "khName": "ខេត្ត ឈីបា",
      "neName": "चिबा जिल्ला"
    },
    "class10": {
      "code": "120010",
      "name": "北西部",
      "enName": "North-western Region",
      "chName": "千叶县北西部",
      "zhName": "千葉縣北西部",
      "koName": "지바 현 북서부",
      "esName": "Noroeste de Prefectura de Chiba",
      "ptName": "Região noroeste da Província de Chiba",
      "thName": "จังหวัดจิบะตอนเหนือฟากตะวันตก",
      "viName": "Miền Tây Bắc tỉnh Chiba",
      "inName": "Bagian Barat Laut Prefektur Chiba",
      "tlName": "Hilaga-kanlurang bahagi ng Chiba Prefecture",
      "moName": "Баруун хойд Чиба аймаг",
      "buName": "ချိဘစီရင်စု အနောက်မြောက်ပိုင်း",
      "khName": "តំបន់ពាយព្យនៃខេត្តឈីបា",
      "neName": "चिबा जिल्लाको उत्तर पश्चिमी भाग"
    },
    "class15": {
      "code": "120012",
      "name": "印旛",
      "enName": "Imba"
    },
    "class20": {
      "code": "1223200",
      "name": "白井市",
      "enName": "Shiroi City",
      "kana": "しろいし",
      "chName": "白井市",
      "zhName": "白井市",
      "koName": "시로이 시",
      "esName": "Ciudad de Shiroi",
      "ptName": "cidade de Shiroi",
      "thName": "เมืองชิโรอิ",
      "viName": "thành phố Shiroi",
      "inName": "kota Shiroi",
      "tlName": "siyudad ng Shiroi",
      "moName": "Широй хот",
      "buName": "ရှီရောယိ မြို့",
      "khName": "ទីក្រុង ស៊ីរ៉យ",
      "neName": "सिरोई सहर"
    }
  },
  "1223300": {
    "office": {
      "code": "120000",
      "name": "千葉県",
      "enName": "Chiba",
      "officeName": "銚子地方気象台",
      "chName": "千叶县",
      "zhName": "千葉縣",
      "koName": "지바현",
      "esName": "Prefectura de Chiba",
      "ptName": "Província de Chiba",
      "thName": "จังหวัดจิบะ",
      "viName": "Tỉnh Chiba",
      "inName": "Prefektur Chiba",
      "tlName": "Chiba Prefecture",
      "moName": "Чиба аймаг",
      "buName": "ကျီဘ ပြည်နယ်",
      "khName": "ខេត្ត ឈីបា",
      "neName": "चिबा जिल्ला"
    },
    "class10": {
      "code": "120010",
      "name": "北西部",
      "enName": "North-western Region",
      "chName": "千叶县北西部",
      "zhName": "千葉縣北西部",
      "koName": "지바 현 북서부",
      "esName": "Noroeste de Prefectura de Chiba",
      "ptName": "Região noroeste da Província de Chiba",
      "thName": "จังหวัดจิบะตอนเหนือฟากตะวันตก",
      "viName": "Miền Tây Bắc tỉnh Chiba",
      "inName": "Bagian Barat Laut Prefektur Chiba",
      "tlName": "Hilaga-kanlurang bahagi ng Chiba Prefecture",
      "moName": "Баруун хойд Чиба аймаг",
      "buName": "ချိဘစီရင်စု အနောက်မြောက်ပိုင်း",
      "khName": "តំបន់ពាយព្យនៃខេត្តឈីបា",
      "neName": "चिबा जिल्लाको उत्तर पश्चिमी भाग"
    },
    "class15": {
      "code": "120012",
      "name": "印旛",
      "enName": "Imba"
    },
    "class20": {
      "code": "1223300",
      "name": "富里市",
      "enName": "Tomisato City",
      "kana": "とみさとし",
      "chName": "富里市",
      "zhName": "富里市",
      "koName": "도미사토 시",
      "esName": "Ciudad de Tomisato",
      "ptName": "cidade de Tomisato",
      "thName": "เมืองโทมิซาโตะ",
      "viName": "thành phố Tomisato",
      "inName": "kota Tomisato",
      "tlName": "siyudad ng Tomisato",
      "moName": "Томисaто хот",
      "buName": "တိုမီးဆာ့တို မြို့",
      "khName": "ទីក្រុង តូមីសាតុ",
      "neName": "तोमिसातो सहर"
    }
  },
  "1223400": {
    "office": {
      "code": "120000",
      "name": "千葉県",
      "enName": "Chiba",
      "officeName": "銚子地方気象台",
      "chName": "千叶县",
      "zhName": "千葉縣",
      "koName": "지바현",
      "esName": "Prefectura de Chiba",
      "ptName": "Província de Chiba",
      "thName": "จังหวัดจิบะ",
      "viName": "Tỉnh Chiba",
      "inName": "Prefektur Chiba",
      "tlName": "Chiba Prefecture",
      "moName": "Чиба аймаг",
      "buName": "ကျီဘ ပြည်နယ်",
      "khName": "ខេត្ត ឈីបា",
      "neName": "चिबा जिल्ला"
    },
    "class10": {
      "code": "120030",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "千叶县南部",
      "zhName": "千葉縣南部",
      "koName": "지바 현 남부",
      "esName": "Sur de Prefectura de Chiba",
      "ptName": "Sul da Província de Chiba",
      "thName": "จังหวัดจิบะตอนใต้",
      "viName": "Miền Nam tỉnh Chiba",
      "inName": "Bagian Selatan Prefektur Chiba",
      "tlName": "Timog na bahagi ng Chiba Prefecture",
      "moName": "Өмнөд Чиба аймаг",
      "buName": "ချိဘစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្តឈីបា",
      "neName": "चिबा जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "120032",
      "name": "夷隅・安房",
      "enName": "Isumi Awa"
    },
    "class20": {
      "code": "1223400",
      "name": "南房総市",
      "enName": "Minamiboso City",
      "kana": "みなみぼうそうし",
      "chName": "南房总市",
      "zhName": "南房總市",
      "koName": "미나미보소 시",
      "esName": "Ciudad de Minamiboso",
      "ptName": "cidade de Minamiboso",
      "thName": "เมืองมินามิโบโสะ",
      "viName": "thành phố Minamiboso",
      "inName": "kota Minamiboso",
      "tlName": "siyudad ng Minamiboso",
      "moName": "Минaмибоcо хот",
      "buName": "မီနာမီးဘိုဆို မြို့",
      "khName": "ទីក្រុង មីណាមីបុសូ",
      "neName": "मिनामिबोसो सहर"
    }
  },
  "1223500": {
    "office": {
      "code": "120000",
      "name": "千葉県",
      "enName": "Chiba",
      "officeName": "銚子地方気象台",
      "chName": "千叶县",
      "zhName": "千葉縣",
      "koName": "지바현",
      "esName": "Prefectura de Chiba",
      "ptName": "Província de Chiba",
      "thName": "จังหวัดจิบะ",
      "viName": "Tỉnh Chiba",
      "inName": "Prefektur Chiba",
      "tlName": "Chiba Prefecture",
      "moName": "Чиба аймаг",
      "buName": "ကျီဘ ပြည်နယ်",
      "khName": "ខេត្ត ឈីបា",
      "neName": "चिबा जिल्ला"
    },
    "class10": {
      "code": "120020",
      "name": "北東部",
      "enName": "North-eastern Region",
      "chName": "千叶县北东部",
      "zhName": "千葉縣北東部",
      "koName": "지바 현 북동부",
      "esName": "Nodeste de Prefectura de Chiba",
      "ptName": "Região nordeste da Província de Chiba",
      "thName": "จังหวัดจิบะตอนเหนือฟากตะวันออก",
      "viName": "Miền Đông Bắc tỉnh Chiba",
      "inName": "Bagian Timur Laut Prefektur Chiba",
      "tlName": "Hilaga-silangang bahagi ng Chiba Prefecture",
      "moName": "Зүүн хойд Чиба аймаг",
      "buName": "ချိဘစီရင်စု အရှေ့မြောက်ပိုင်း",
      "khName": "តំបន់ឦសាននៃខេត្តឈីបា",
      "neName": "चिबा जिल्लाको उत्तर पूर्वी भाग"
    },
    "class15": {
      "code": "120021",
      "name": "香取・海匝",
      "enName": "Katori Kaiso"
    },
    "class20": {
      "code": "1223500",
      "name": "匝瑳市",
      "enName": "Sosa City",
      "kana": "そうさし",
      "chName": "匝瑳市",
      "zhName": "匝瑳市",
      "koName": "소사 시",
      "esName": "Ciudad de Sosa",
      "ptName": "cidade de Sosa",
      "thName": "เมืองโซสะ",
      "viName": "thành phố Sosa",
      "inName": "kota Sosa",
      "tlName": "siyudad ng Sosa",
      "moName": "Соса хот",
      "buName": "ဆိုဆာ မြို့",
      "khName": "ទីក្រុង សូសា",
      "neName": "सोसा सहर"
    }
  },
  "1223600": {
    "office": {
      "code": "120000",
      "name": "千葉県",
      "enName": "Chiba",
      "officeName": "銚子地方気象台",
      "chName": "千叶县",
      "zhName": "千葉縣",
      "koName": "지바현",
      "esName": "Prefectura de Chiba",
      "ptName": "Província de Chiba",
      "thName": "จังหวัดจิบะ",
      "viName": "Tỉnh Chiba",
      "inName": "Prefektur Chiba",
      "tlName": "Chiba Prefecture",
      "moName": "Чиба аймаг",
      "buName": "ကျီဘ ပြည်နယ်",
      "khName": "ខេត្ត ឈីបា",
      "neName": "चिबा जिल्ला"
    },
    "class10": {
      "code": "120020",
      "name": "北東部",
      "enName": "North-eastern Region",
      "chName": "千叶县北东部",
      "zhName": "千葉縣北東部",
      "koName": "지바 현 북동부",
      "esName": "Nodeste de Prefectura de Chiba",
      "ptName": "Região nordeste da Província de Chiba",
      "thName": "จังหวัดจิบะตอนเหนือฟากตะวันออก",
      "viName": "Miền Đông Bắc tỉnh Chiba",
      "inName": "Bagian Timur Laut Prefektur Chiba",
      "tlName": "Hilaga-silangang bahagi ng Chiba Prefecture",
      "moName": "Зүүн хойд Чиба аймаг",
      "buName": "ချိဘစီရင်စု အရှေ့မြောက်ပိုင်း",
      "khName": "តំបន់ឦសាននៃខេត្តឈីបា",
      "neName": "चिबा जिल्लाको उत्तर पूर्वी भाग"
    },
    "class15": {
      "code": "120021",
      "name": "香取・海匝",
      "enName": "Katori Kaiso"
    },
    "class20": {
      "code": "1223600",
      "name": "香取市",
      "enName": "Katori City",
      "kana": "かとりし",
      "chName": "香取市",
      "zhName": "香取市",
      "koName": "가토리 시",
      "esName": "Ciudad de Katori",
      "ptName": "cidade de Katori",
      "thName": "เมืองคาโทริ",
      "viName": "thành phố Katori",
      "inName": "kota Katori",
      "tlName": "siyudad ng Katori",
      "moName": "Катори хот",
      "buName": "ခါတိုးရိ မြို့",
      "khName": "ទីក្រុង កាតូរី",
      "neName": "कातोरी सहर"
    }
  },
  "1223700": {
    "office": {
      "code": "120000",
      "name": "千葉県",
      "enName": "Chiba",
      "officeName": "銚子地方気象台",
      "chName": "千叶县",
      "zhName": "千葉縣",
      "koName": "지바현",
      "esName": "Prefectura de Chiba",
      "ptName": "Província de Chiba",
      "thName": "จังหวัดจิบะ",
      "viName": "Tỉnh Chiba",
      "inName": "Prefektur Chiba",
      "tlName": "Chiba Prefecture",
      "moName": "Чиба аймаг",
      "buName": "ကျီဘ ပြည်နယ်",
      "khName": "ខេត្ត ឈីបា",
      "neName": "चिबा जिल्ला"
    },
    "class10": {
      "code": "120020",
      "name": "北東部",
      "enName": "North-eastern Region",
      "chName": "千叶县北东部",
      "zhName": "千葉縣北東部",
      "koName": "지바 현 북동부",
      "esName": "Nodeste de Prefectura de Chiba",
      "ptName": "Região nordeste da Província de Chiba",
      "thName": "จังหวัดจิบะตอนเหนือฟากตะวันออก",
      "viName": "Miền Đông Bắc tỉnh Chiba",
      "inName": "Bagian Timur Laut Prefektur Chiba",
      "tlName": "Hilaga-silangang bahagi ng Chiba Prefecture",
      "moName": "Зүүн хойд Чиба аймаг",
      "buName": "ချိဘစီရင်စု အရှေ့မြောက်ပိုင်း",
      "khName": "តំបន់ឦសាននៃខេត្តឈីបា",
      "neName": "चिबा जिल्लाको उत्तर पूर्वी भाग"
    },
    "class15": {
      "code": "120022",
      "name": "山武・長生",
      "enName": "Sammu Chosei"
    },
    "class20": {
      "code": "1223700",
      "name": "山武市",
      "enName": "Sammu City",
      "kana": "さんむし",
      "chName": "山武市",
      "zhName": "山武市",
      "koName": "산무 시",
      "esName": "Ciudad de Sanmu",
      "ptName": "cidade de Sammu",
      "thName": "เมืองซัมมุ",
      "viName": "thành phố Sammu",
      "inName": "kota Sammu",
      "tlName": "siyudad ng Sammu",
      "moName": "Саммү хот",
      "buName": "ဆန်းဘု မြို့",
      "khName": "ទីក្រុង សាមូ",
      "neName": "साम्मु सहर"
    }
  },
  "1223800": {
    "office": {
      "code": "120000",
      "name": "千葉県",
      "enName": "Chiba",
      "officeName": "銚子地方気象台",
      "chName": "千叶县",
      "zhName": "千葉縣",
      "koName": "지바현",
      "esName": "Prefectura de Chiba",
      "ptName": "Província de Chiba",
      "thName": "จังหวัดจิบะ",
      "viName": "Tỉnh Chiba",
      "inName": "Prefektur Chiba",
      "tlName": "Chiba Prefecture",
      "moName": "Чиба аймаг",
      "buName": "ကျီဘ ပြည်နယ်",
      "khName": "ខេត្ត ឈីបា",
      "neName": "चिबा जिल्ला"
    },
    "class10": {
      "code": "120030",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "千叶县南部",
      "zhName": "千葉縣南部",
      "koName": "지바 현 남부",
      "esName": "Sur de Prefectura de Chiba",
      "ptName": "Sul da Província de Chiba",
      "thName": "จังหวัดจิบะตอนใต้",
      "viName": "Miền Nam tỉnh Chiba",
      "inName": "Bagian Selatan Prefektur Chiba",
      "tlName": "Timog na bahagi ng Chiba Prefecture",
      "moName": "Өмнөд Чиба аймаг",
      "buName": "ချိဘစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្តឈីបា",
      "neName": "चिबा जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "120032",
      "name": "夷隅・安房",
      "enName": "Isumi Awa"
    },
    "class20": {
      "code": "1223800",
      "name": "いすみ市",
      "enName": "Isumi City",
      "kana": "いすみし",
      "chName": "夷隅市",
      "zhName": "夷隅市",
      "koName": "이스미 시",
      "esName": "Ciudad de Isumi",
      "ptName": "cidade de Isumi",
      "thName": "เมืองอิสึมิ",
      "viName": "thành phố Isumi",
      "inName": "kota Isumi",
      "tlName": "siyudad ng Isumi",
      "moName": "Исүми хот",
      "buName": "အိဆုမိ မြို့",
      "khName": "ទីក្រុង អ៊ីសូមី",
      "neName": "इसुमी सहर"
    }
  },
  "1223900": {
    "office": {
      "code": "120000",
      "name": "千葉県",
      "enName": "Chiba",
      "officeName": "銚子地方気象台",
      "chName": "千叶县",
      "zhName": "千葉縣",
      "koName": "지바현",
      "esName": "Prefectura de Chiba",
      "ptName": "Província de Chiba",
      "thName": "จังหวัดจิบะ",
      "viName": "Tỉnh Chiba",
      "inName": "Prefektur Chiba",
      "tlName": "Chiba Prefecture",
      "moName": "Чиба аймаг",
      "buName": "ကျီဘ ပြည်နယ်",
      "khName": "ខេត្ត ឈីបា",
      "neName": "चिबा जिल्ला"
    },
    "class10": {
      "code": "120020",
      "name": "北東部",
      "enName": "North-eastern Region",
      "chName": "千叶县北东部",
      "zhName": "千葉縣北東部",
      "koName": "지바 현 북동부",
      "esName": "Nodeste de Prefectura de Chiba",
      "ptName": "Região nordeste da Província de Chiba",
      "thName": "จังหวัดจิบะตอนเหนือฟากตะวันออก",
      "viName": "Miền Đông Bắc tỉnh Chiba",
      "inName": "Bagian Timur Laut Prefektur Chiba",
      "tlName": "Hilaga-silangang bahagi ng Chiba Prefecture",
      "moName": "Зүүн хойд Чиба аймаг",
      "buName": "ချိဘစီရင်စု အရှေ့မြောက်ပိုင်း",
      "khName": "តំបន់ឦសាននៃខេត្តឈីបា",
      "neName": "चिबा जिल्लाको उत्तर पूर्वी भाग"
    },
    "class15": {
      "code": "120022",
      "name": "山武・長生",
      "enName": "Sammu Chosei"
    },
    "class20": {
      "code": "1223900",
      "name": "大網白里市",
      "enName": "Oamishirasato City",
      "kana": "おおあみしらさとし",
      "chName": "大网白里市",
      "zhName": "大網白里市",
      "koName": "오아미시라사토 시",
      "esName": "Ciudad de Oamishirasato",
      "ptName": "cidade de Oamishirasato",
      "thName": "เมืองโออะมิชิราซาโตะ",
      "viName": "thành phố Oamishirasato",
      "inName": "kota Oamishirasato",
      "tlName": "siyudad ng Oamishirasato",
      "moName": "Оaмиширасaто хот",
      "buName": "အိုအာမိရှီရာဆာတို မြို့",
      "khName": "ទីក្រុង អូមីស៊ីរ៉ាសាតូ",
      "neName": "ओआमिशिरासाटो सहर"
    }
  },
  "1232200": {
    "office": {
      "code": "120000",
      "name": "千葉県",
      "enName": "Chiba",
      "officeName": "銚子地方気象台",
      "chName": "千叶县",
      "zhName": "千葉縣",
      "koName": "지바현",
      "esName": "Prefectura de Chiba",
      "ptName": "Província de Chiba",
      "thName": "จังหวัดจิบะ",
      "viName": "Tỉnh Chiba",
      "inName": "Prefektur Chiba",
      "tlName": "Chiba Prefecture",
      "moName": "Чиба аймаг",
      "buName": "ကျီဘ ပြည်နယ်",
      "khName": "ខេត្ត ឈីបា",
      "neName": "चिबा जिल्ला"
    },
    "class10": {
      "code": "120010",
      "name": "北西部",
      "enName": "North-western Region",
      "chName": "千叶县北西部",
      "zhName": "千葉縣北西部",
      "koName": "지바 현 북서부",
      "esName": "Noroeste de Prefectura de Chiba",
      "ptName": "Região noroeste da Província de Chiba",
      "thName": "จังหวัดจิบะตอนเหนือฟากตะวันตก",
      "viName": "Miền Tây Bắc tỉnh Chiba",
      "inName": "Bagian Barat Laut Prefektur Chiba",
      "tlName": "Hilaga-kanlurang bahagi ng Chiba Prefecture",
      "moName": "Баруун хойд Чиба аймаг",
      "buName": "ချိဘစီရင်စု အနောက်မြောက်ပိုင်း",
      "khName": "តំបន់ពាយព្យនៃខេត្តឈីបា",
      "neName": "चिबा जिल्लाको उत्तर पश्चिमी भाग"
    },
    "class15": {
      "code": "120012",
      "name": "印旛",
      "enName": "Imba"
    },
    "class20": {
      "code": "1232200",
      "name": "酒々井町",
      "enName": "Shisui Town",
      "kana": "しすいまち",
      "chName": "酒酒井町",
      "zhName": "酒酒井町",
      "koName": "시스이 정",
      "esName": "Pueblo de Shisui",
      "ptName": "bairro de Shisui",
      "thName": "เมืองชิซุย",
      "viName": "thị trấn Shisui",
      "inName": "kota Shisui",
      "tlName": "bayan ng Shisui",
      "moName": "Шисүй жижиг хот",
      "buName": "ရှီဆုယိ မြို့နယ်",
      "khName": "ទីប្រជុំជន ស៊ីស៊ូ",
      "neName": "शिसुई नगर"
    }
  },
  "1232900": {
    "office": {
      "code": "120000",
      "name": "千葉県",
      "enName": "Chiba",
      "officeName": "銚子地方気象台",
      "chName": "千叶县",
      "zhName": "千葉縣",
      "koName": "지바현",
      "esName": "Prefectura de Chiba",
      "ptName": "Província de Chiba",
      "thName": "จังหวัดจิบะ",
      "viName": "Tỉnh Chiba",
      "inName": "Prefektur Chiba",
      "tlName": "Chiba Prefecture",
      "moName": "Чиба аймаг",
      "buName": "ကျီဘ ပြည်နယ်",
      "khName": "ខេត្ត ឈីបា",
      "neName": "चिबा जिल्ला"
    },
    "class10": {
      "code": "120010",
      "name": "北西部",
      "enName": "North-western Region",
      "chName": "千叶县北西部",
      "zhName": "千葉縣北西部",
      "koName": "지바 현 북서부",
      "esName": "Noroeste de Prefectura de Chiba",
      "ptName": "Região noroeste da Província de Chiba",
      "thName": "จังหวัดจิบะตอนเหนือฟากตะวันตก",
      "viName": "Miền Tây Bắc tỉnh Chiba",
      "inName": "Bagian Barat Laut Prefektur Chiba",
      "tlName": "Hilaga-kanlurang bahagi ng Chiba Prefecture",
      "moName": "Баруун хойд Чиба аймаг",
      "buName": "ချိဘစီရင်စု အနောက်မြောက်ပိုင်း",
      "khName": "តំបន់ពាយព្យនៃខេត្តឈីបា",
      "neName": "चिबा जिल्लाको उत्तर पश्चिमी भाग"
    },
    "class15": {
      "code": "120012",
      "name": "印旛",
      "enName": "Imba"
    },
    "class20": {
      "code": "1232900",
      "name": "栄町",
      "enName": "Sakae Town",
      "kana": "さかえまち",
      "chName": "荣町",
      "zhName": "榮町",
      "koName": "사카에 정",
      "esName": "Pueblo de Sakae",
      "ptName": "bairro de Sakae",
      "thName": "เมืองซาคาเอะ",
      "viName": "thị trấn Sakae",
      "inName": "kota Sakae",
      "tlName": "bayan ng Sakae",
      "moName": "Сaкаэ жижиг хот",
      "buName": "ဆာကားယဲ့ မြို့နယ်",
      "khName": "ទីប្រជុំជន សាកែ",
      "neName": "साकाए नगर"
    }
  },
  "1234200": {
    "office": {
      "code": "120000",
      "name": "千葉県",
      "enName": "Chiba",
      "officeName": "銚子地方気象台",
      "chName": "千叶县",
      "zhName": "千葉縣",
      "koName": "지바현",
      "esName": "Prefectura de Chiba",
      "ptName": "Província de Chiba",
      "thName": "จังหวัดจิบะ",
      "viName": "Tỉnh Chiba",
      "inName": "Prefektur Chiba",
      "tlName": "Chiba Prefecture",
      "moName": "Чиба аймаг",
      "buName": "ကျီဘ ပြည်နယ်",
      "khName": "ខេត្ត ឈីបា",
      "neName": "चिबा जिल्ला"
    },
    "class10": {
      "code": "120020",
      "name": "北東部",
      "enName": "North-eastern Region",
      "chName": "千叶县北东部",
      "zhName": "千葉縣北東部",
      "koName": "지바 현 북동부",
      "esName": "Nodeste de Prefectura de Chiba",
      "ptName": "Região nordeste da Província de Chiba",
      "thName": "จังหวัดจิบะตอนเหนือฟากตะวันออก",
      "viName": "Miền Đông Bắc tỉnh Chiba",
      "inName": "Bagian Timur Laut Prefektur Chiba",
      "tlName": "Hilaga-silangang bahagi ng Chiba Prefecture",
      "moName": "Зүүн хойд Чиба аймаг",
      "buName": "ချိဘစီရင်စု အရှေ့မြောက်ပိုင်း",
      "khName": "តំបន់ឦសាននៃខេត្តឈីបា",
      "neName": "चिबा जिल्लाको उत्तर पूर्वी भाग"
    },
    "class15": {
      "code": "120021",
      "name": "香取・海匝",
      "enName": "Katori Kaiso"
    },
    "class20": {
      "code": "1234200",
      "name": "神崎町",
      "enName": "Kozaki Town",
      "kana": "こうざきまち",
      "chName": "神崎町",
      "zhName": "神崎町",
      "koName": "고자키 정",
      "esName": "Pueblo de Kozaki",
      "ptName": "bairro de Kozaki",
      "thName": "เมืองโคซากิ",
      "viName": "thị trấn Kozaki",
      "inName": "kota Kozaki",
      "tlName": "bayan ng Kozaki",
      "moName": "Козaки жижиг хот",
      "buName": "ကိုးဇာ့ကိ မြို့နယ်",
      "khName": "ទីប្រជុំជន កូហ្សាគី",
      "neName": "कोजाकी नगर"
    }
  },
  "1234700": {
    "office": {
      "code": "120000",
      "name": "千葉県",
      "enName": "Chiba",
      "officeName": "銚子地方気象台",
      "chName": "千叶县",
      "zhName": "千葉縣",
      "koName": "지바현",
      "esName": "Prefectura de Chiba",
      "ptName": "Província de Chiba",
      "thName": "จังหวัดจิบะ",
      "viName": "Tỉnh Chiba",
      "inName": "Prefektur Chiba",
      "tlName": "Chiba Prefecture",
      "moName": "Чиба аймаг",
      "buName": "ကျီဘ ပြည်နယ်",
      "khName": "ខេត្ត ឈីបា",
      "neName": "चिबा जिल्ला"
    },
    "class10": {
      "code": "120020",
      "name": "北東部",
      "enName": "North-eastern Region",
      "chName": "千叶县北东部",
      "zhName": "千葉縣北東部",
      "koName": "지바 현 북동부",
      "esName": "Nodeste de Prefectura de Chiba",
      "ptName": "Região nordeste da Província de Chiba",
      "thName": "จังหวัดจิบะตอนเหนือฟากตะวันออก",
      "viName": "Miền Đông Bắc tỉnh Chiba",
      "inName": "Bagian Timur Laut Prefektur Chiba",
      "tlName": "Hilaga-silangang bahagi ng Chiba Prefecture",
      "moName": "Зүүн хойд Чиба аймаг",
      "buName": "ချိဘစီရင်စု အရှေ့မြောက်ပိုင်း",
      "khName": "តំបន់ឦសាននៃខេត្តឈីបា",
      "neName": "चिबा जिल्लाको उत्तर पूर्वी भाग"
    },
    "class15": {
      "code": "120021",
      "name": "香取・海匝",
      "enName": "Katori Kaiso"
    },
    "class20": {
      "code": "1234700",
      "name": "多古町",
      "enName": "Tako Town",
      "kana": "たこまち",
      "chName": "多古町",
      "zhName": "多古町",
      "koName": "다코 정",
      "esName": "Pueblo de Tako",
      "ptName": "bairro de Tako",
      "thName": "เมืองทาโกะ",
      "viName": "thị trấn Tako",
      "inName": "kota Tako",
      "tlName": "bayan ng Tako",
      "moName": "Тако жижиг хот",
      "buName": "တာကို မြို့နယ်",
      "khName": "ទីប្រជុំជន តាកូ",
      "neName": "ताको नगर"
    }
  },
  "1234900": {
    "office": {
      "code": "120000",
      "name": "千葉県",
      "enName": "Chiba",
      "officeName": "銚子地方気象台",
      "chName": "千叶县",
      "zhName": "千葉縣",
      "koName": "지바현",
      "esName": "Prefectura de Chiba",
      "ptName": "Província de Chiba",
      "thName": "จังหวัดจิบะ",
      "viName": "Tỉnh Chiba",
      "inName": "Prefektur Chiba",
      "tlName": "Chiba Prefecture",
      "moName": "Чиба аймаг",
      "buName": "ကျီဘ ပြည်နယ်",
      "khName": "ខេត្ត ឈីបា",
      "neName": "चिबा जिल्ला"
    },
    "class10": {
      "code": "120020",
      "name": "北東部",
      "enName": "North-eastern Region",
      "chName": "千叶县北东部",
      "zhName": "千葉縣北東部",
      "koName": "지바 현 북동부",
      "esName": "Nodeste de Prefectura de Chiba",
      "ptName": "Região nordeste da Província de Chiba",
      "thName": "จังหวัดจิบะตอนเหนือฟากตะวันออก",
      "viName": "Miền Đông Bắc tỉnh Chiba",
      "inName": "Bagian Timur Laut Prefektur Chiba",
      "tlName": "Hilaga-silangang bahagi ng Chiba Prefecture",
      "moName": "Зүүн хойд Чиба аймаг",
      "buName": "ချိဘစီရင်စု အရှေ့မြောက်ပိုင်း",
      "khName": "តំបន់ឦសាននៃខេត្តឈីបា",
      "neName": "चिबा जिल्लाको उत्तर पूर्वी भाग"
    },
    "class15": {
      "code": "120021",
      "name": "香取・海匝",
      "enName": "Katori Kaiso"
    },
    "class20": {
      "code": "1234900",
      "name": "東庄町",
      "enName": "Tohnosho Town",
      "kana": "とうのしょうまち",
      "chName": "东庄町",
      "zhName": "東庄町",
      "koName": "도노쇼 정",
      "esName": "Pueblo de Tonosho",
      "ptName": "bairro de Tohnosho",
      "thName": "เมืองโทโนะโช",
      "viName": "thị trấn Tohnosho",
      "inName": "kota Tohnosho",
      "tlName": "bayan ng Tohnosho",
      "moName": "Тохношо жижиг хот",
      "buName": "တိုးနို့ရှို မြို့နယ်",
      "khName": "ទីប្រជុំជន ថូណូស៊ូ",
      "neName": "तोहनोशो नगर"
    }
  },
  "1240300": {
    "office": {
      "code": "120000",
      "name": "千葉県",
      "enName": "Chiba",
      "officeName": "銚子地方気象台",
      "chName": "千叶县",
      "zhName": "千葉縣",
      "koName": "지바현",
      "esName": "Prefectura de Chiba",
      "ptName": "Província de Chiba",
      "thName": "จังหวัดจิบะ",
      "viName": "Tỉnh Chiba",
      "inName": "Prefektur Chiba",
      "tlName": "Chiba Prefecture",
      "moName": "Чиба аймаг",
      "buName": "ကျီဘ ပြည်နယ်",
      "khName": "ខេត្ត ឈីបា",
      "neName": "चिबा जिल्ला"
    },
    "class10": {
      "code": "120020",
      "name": "北東部",
      "enName": "North-eastern Region",
      "chName": "千叶县北东部",
      "zhName": "千葉縣北東部",
      "koName": "지바 현 북동부",
      "esName": "Nodeste de Prefectura de Chiba",
      "ptName": "Região nordeste da Província de Chiba",
      "thName": "จังหวัดจิบะตอนเหนือฟากตะวันออก",
      "viName": "Miền Đông Bắc tỉnh Chiba",
      "inName": "Bagian Timur Laut Prefektur Chiba",
      "tlName": "Hilaga-silangang bahagi ng Chiba Prefecture",
      "moName": "Зүүн хойд Чиба аймаг",
      "buName": "ချိဘစီရင်စု အရှေ့မြောက်ပိုင်း",
      "khName": "តំបន់ឦសាននៃខេត្តឈីបា",
      "neName": "चिबा जिल्लाको उत्तर पूर्वी भाग"
    },
    "class15": {
      "code": "120022",
      "name": "山武・長生",
      "enName": "Sammu Chosei"
    },
    "class20": {
      "code": "1240300",
      "name": "九十九里町",
      "enName": "Kujukuri Town",
      "kana": "くじゅうくりまち",
      "chName": "九十九里町",
      "zhName": "九十九里町",
      "koName": "구주쿠리 정",
      "esName": "Pueblo de Kujyukuri",
      "ptName": "bairro de Kujukuri",
      "thName": "เมืองคุจุคุริ",
      "viName": "thị trấn Kujukuri",
      "inName": "kota Kujukuri",
      "tlName": "bayan ng Kujukuri",
      "moName": "Күжүкүри жижиг хот",
      "buName": "ခူဂျုကုရိ မြို့နယ်",
      "khName": "ទីប្រជុំជន គូជូគូរី",
      "neName": "कुजुकुरी नगर"
    }
  },
  "1240900": {
    "office": {
      "code": "120000",
      "name": "千葉県",
      "enName": "Chiba",
      "officeName": "銚子地方気象台",
      "chName": "千叶县",
      "zhName": "千葉縣",
      "koName": "지바현",
      "esName": "Prefectura de Chiba",
      "ptName": "Província de Chiba",
      "thName": "จังหวัดจิบะ",
      "viName": "Tỉnh Chiba",
      "inName": "Prefektur Chiba",
      "tlName": "Chiba Prefecture",
      "moName": "Чиба аймаг",
      "buName": "ကျီဘ ပြည်နယ်",
      "khName": "ខេត្ត ឈីបា",
      "neName": "चिबा जिल्ला"
    },
    "class10": {
      "code": "120020",
      "name": "北東部",
      "enName": "North-eastern Region",
      "chName": "千叶县北东部",
      "zhName": "千葉縣北東部",
      "koName": "지바 현 북동부",
      "esName": "Nodeste de Prefectura de Chiba",
      "ptName": "Região nordeste da Província de Chiba",
      "thName": "จังหวัดจิบะตอนเหนือฟากตะวันออก",
      "viName": "Miền Đông Bắc tỉnh Chiba",
      "inName": "Bagian Timur Laut Prefektur Chiba",
      "tlName": "Hilaga-silangang bahagi ng Chiba Prefecture",
      "moName": "Зүүн хойд Чиба аймаг",
      "buName": "ချိဘစီရင်စု အရှေ့မြောက်ပိုင်း",
      "khName": "តំបន់ឦសាននៃខេត្តឈីបា",
      "neName": "चिबा जिल्लाको उत्तर पूर्वी भाग"
    },
    "class15": {
      "code": "120022",
      "name": "山武・長生",
      "enName": "Sammu Chosei"
    },
    "class20": {
      "code": "1240900",
      "name": "芝山町",
      "enName": "Shibayama Town",
      "kana": "しばやままち",
      "chName": "芝山町",
      "zhName": "芝山町",
      "koName": "시바야마 정",
      "esName": "Pueblo de Shibayama",
      "ptName": "bairro de Shibayama",
      "thName": "เมืองชิบายามะ",
      "viName": "thị trấn Shibayama",
      "inName": "kota Shibayama",
      "tlName": "bayan ng Shibayama",
      "moName": "Шибаямa жижиг хот",
      "buName": "ရှီဘားရာ့မ မြို့နယ်",
      "khName": "ទីប្រជុំជន ស៊ីបេយ៉ាម៉ា",
      "neName": "शिबायामा नगर"
    }
  },
  "1241000": {
    "office": {
      "code": "120000",
      "name": "千葉県",
      "enName": "Chiba",
      "officeName": "銚子地方気象台",
      "chName": "千叶县",
      "zhName": "千葉縣",
      "koName": "지바현",
      "esName": "Prefectura de Chiba",
      "ptName": "Província de Chiba",
      "thName": "จังหวัดจิบะ",
      "viName": "Tỉnh Chiba",
      "inName": "Prefektur Chiba",
      "tlName": "Chiba Prefecture",
      "moName": "Чиба аймаг",
      "buName": "ကျီဘ ပြည်နယ်",
      "khName": "ខេត្ត ឈីបា",
      "neName": "चिबा जिल्ला"
    },
    "class10": {
      "code": "120020",
      "name": "北東部",
      "enName": "North-eastern Region",
      "chName": "千叶县北东部",
      "zhName": "千葉縣北東部",
      "koName": "지바 현 북동부",
      "esName": "Nodeste de Prefectura de Chiba",
      "ptName": "Região nordeste da Província de Chiba",
      "thName": "จังหวัดจิบะตอนเหนือฟากตะวันออก",
      "viName": "Miền Đông Bắc tỉnh Chiba",
      "inName": "Bagian Timur Laut Prefektur Chiba",
      "tlName": "Hilaga-silangang bahagi ng Chiba Prefecture",
      "moName": "Зүүн хойд Чиба аймаг",
      "buName": "ချိဘစီရင်စု အရှေ့မြောက်ပိုင်း",
      "khName": "តំបន់ឦសាននៃខេត្តឈីបា",
      "neName": "चिबा जिल्लाको उत्तर पूर्वी भाग"
    },
    "class15": {
      "code": "120022",
      "name": "山武・長生",
      "enName": "Sammu Chosei"
    },
    "class20": {
      "code": "1241000",
      "name": "横芝光町",
      "enName": "Yokoshibahikari Town",
      "kana": "よこしばひかりまち",
      "chName": "横芝光町",
      "zhName": "橫芝光町",
      "koName": "요코시바히카리 정",
      "esName": "Pueblo de Yokoshibahikari",
      "ptName": "bairro de Yokoshibahikari",
      "thName": "เมืองโยโคชิบะฮิคาริ",
      "viName": "thị trấn Yokoshibahikari",
      "inName": "kota Yokoshibahikari",
      "tlName": "bayan ng Yokoshibahikari",
      "moName": "Ёокошибахикари жижиг хот",
      "buName": "ယိုကိုရှီဘဟီကာ့ရိ မြို့နယ်",
      "khName": "ទីប្រជុំជន យ៉ូកូស៊ីបាហ៊ីការី",
      "neName": "योकोशिबाहिकारी नगर"
    }
  },
  "1242100": {
    "office": {
      "code": "120000",
      "name": "千葉県",
      "enName": "Chiba",
      "officeName": "銚子地方気象台",
      "chName": "千叶县",
      "zhName": "千葉縣",
      "koName": "지바현",
      "esName": "Prefectura de Chiba",
      "ptName": "Província de Chiba",
      "thName": "จังหวัดจิบะ",
      "viName": "Tỉnh Chiba",
      "inName": "Prefektur Chiba",
      "tlName": "Chiba Prefecture",
      "moName": "Чиба аймаг",
      "buName": "ကျီဘ ပြည်နယ်",
      "khName": "ខេត្ត ឈីបា",
      "neName": "चिबा जिल्ला"
    },
    "class10": {
      "code": "120020",
      "name": "北東部",
      "enName": "North-eastern Region",
      "chName": "千叶县北东部",
      "zhName": "千葉縣北東部",
      "koName": "지바 현 북동부",
      "esName": "Nodeste de Prefectura de Chiba",
      "ptName": "Região nordeste da Província de Chiba",
      "thName": "จังหวัดจิบะตอนเหนือฟากตะวันออก",
      "viName": "Miền Đông Bắc tỉnh Chiba",
      "inName": "Bagian Timur Laut Prefektur Chiba",
      "tlName": "Hilaga-silangang bahagi ng Chiba Prefecture",
      "moName": "Зүүн хойд Чиба аймаг",
      "buName": "ချိဘစီရင်စု အရှေ့မြောက်ပိုင်း",
      "khName": "តំបន់ឦសាននៃខេត្តឈីបា",
      "neName": "चिबा जिल्लाको उत्तर पूर्वी भाग"
    },
    "class15": {
      "code": "120022",
      "name": "山武・長生",
      "enName": "Sammu Chosei"
    },
    "class20": {
      "code": "1242100",
      "name": "一宮町",
      "enName": "Ichinomiya Town",
      "kana": "いちのみやまち",
      "chName": "一宫町",
      "zhName": "一宮町",
      "koName": "이치노미야 정",
      "esName": "Pueblo de Ichinomiya",
      "ptName": "bairro de Ichinomiya",
      "thName": "เมืองอิจิโนะมิยะ",
      "viName": "thị trấn Ichinomiya",
      "inName": "kota Ichinomiya",
      "tlName": "bayan ng Ichinomiya",
      "moName": "Ичиномия жижиг хот",
      "buName": "အီကျိနောမိယ မြို့နယ်",
      "khName": "ទីប្រជុំជន អាយឈិនណុមីយ៉ា",
      "neName": "इचिनोमिया नगर"
    }
  },
  "1242200": {
    "office": {
      "code": "120000",
      "name": "千葉県",
      "enName": "Chiba",
      "officeName": "銚子地方気象台",
      "chName": "千叶县",
      "zhName": "千葉縣",
      "koName": "지바현",
      "esName": "Prefectura de Chiba",
      "ptName": "Província de Chiba",
      "thName": "จังหวัดจิบะ",
      "viName": "Tỉnh Chiba",
      "inName": "Prefektur Chiba",
      "tlName": "Chiba Prefecture",
      "moName": "Чиба аймаг",
      "buName": "ကျီဘ ပြည်နယ်",
      "khName": "ខេត្ត ឈីបា",
      "neName": "चिबा जिल्ला"
    },
    "class10": {
      "code": "120020",
      "name": "北東部",
      "enName": "North-eastern Region",
      "chName": "千叶县北东部",
      "zhName": "千葉縣北東部",
      "koName": "지바 현 북동부",
      "esName": "Nodeste de Prefectura de Chiba",
      "ptName": "Região nordeste da Província de Chiba",
      "thName": "จังหวัดจิบะตอนเหนือฟากตะวันออก",
      "viName": "Miền Đông Bắc tỉnh Chiba",
      "inName": "Bagian Timur Laut Prefektur Chiba",
      "tlName": "Hilaga-silangang bahagi ng Chiba Prefecture",
      "moName": "Зүүн хойд Чиба аймаг",
      "buName": "ချိဘစီရင်စု အရှေ့မြောက်ပိုင်း",
      "khName": "តំបន់ឦសាននៃខេត្តឈីបា",
      "neName": "चिबा जिल्लाको उत्तर पूर्वी भाग"
    },
    "class15": {
      "code": "120022",
      "name": "山武・長生",
      "enName": "Sammu Chosei"
    },
    "class20": {
      "code": "1242200",
      "name": "睦沢町",
      "enName": "Mutsuzawa Town",
      "kana": "むつざわまち",
      "chName": "睦泽町",
      "zhName": "睦澤町",
      "koName": "무쓰자와 정",
      "esName": "Pueblo de Mutsuzawa",
      "ptName": "bairro de Mutsuzawa",
      "thName": "เมืองมัทสึซาวา",
      "viName": "thị trấn Mutsuzawa",
      "inName": "kota Mutsuzawa",
      "tlName": "bayan ng Mutsuzawa",
      "moName": "Мүцүзава жижиг хот",
      "buName": "မူဆုဇာ့ဝ မြို့နယ်",
      "khName": "ទីប្រជុំជន​ មុតស៊ូសាវ៉ា",
      "neName": "मुत्सुजावा नगर"
    }
  },
  "1242300": {
    "office": {
      "code": "120000",
      "name": "千葉県",
      "enName": "Chiba",
      "officeName": "銚子地方気象台",
      "chName": "千叶县",
      "zhName": "千葉縣",
      "koName": "지바현",
      "esName": "Prefectura de Chiba",
      "ptName": "Província de Chiba",
      "thName": "จังหวัดจิบะ",
      "viName": "Tỉnh Chiba",
      "inName": "Prefektur Chiba",
      "tlName": "Chiba Prefecture",
      "moName": "Чиба аймаг",
      "buName": "ကျီဘ ပြည်နယ်",
      "khName": "ខេត្ត ឈីបា",
      "neName": "चिबा जिल्ला"
    },
    "class10": {
      "code": "120020",
      "name": "北東部",
      "enName": "North-eastern Region",
      "chName": "千叶县北东部",
      "zhName": "千葉縣北東部",
      "koName": "지바 현 북동부",
      "esName": "Nodeste de Prefectura de Chiba",
      "ptName": "Região nordeste da Província de Chiba",
      "thName": "จังหวัดจิบะตอนเหนือฟากตะวันออก",
      "viName": "Miền Đông Bắc tỉnh Chiba",
      "inName": "Bagian Timur Laut Prefektur Chiba",
      "tlName": "Hilaga-silangang bahagi ng Chiba Prefecture",
      "moName": "Зүүн хойд Чиба аймаг",
      "buName": "ချိဘစီရင်စု အရှေ့မြောက်ပိုင်း",
      "khName": "តំបន់ឦសាននៃខេត្តឈីបា",
      "neName": "चिबा जिल्लाको उत्तर पूर्वी भाग"
    },
    "class15": {
      "code": "120022",
      "name": "山武・長生",
      "enName": "Sammu Chosei"
    },
    "class20": {
      "code": "1242300",
      "name": "長生村",
      "enName": "Chosei Village",
      "kana": "ちょうせいむら",
      "chName": "长生村",
      "zhName": "長生村",
      "koName": "조세이 촌",
      "esName": "Aldea de Chosei",
      "ptName": "povoado de Chosei",
      "thName": "หมู่บ้านโจเซ",
      "viName": "làng Chosei",
      "inName": "desa Chosei",
      "tlName": "nayon ng Chosei",
      "moName": "Чосэй тосгон",
      "buName": "ချို့ဆဲယိ ကျေးရွာ",
      "khName": "ភូមិ ឆូស៊ី",
      "neName": "चोसेइ गाउँ"
    }
  },
  "1242400": {
    "office": {
      "code": "120000",
      "name": "千葉県",
      "enName": "Chiba",
      "officeName": "銚子地方気象台",
      "chName": "千叶县",
      "zhName": "千葉縣",
      "koName": "지바현",
      "esName": "Prefectura de Chiba",
      "ptName": "Província de Chiba",
      "thName": "จังหวัดจิบะ",
      "viName": "Tỉnh Chiba",
      "inName": "Prefektur Chiba",
      "tlName": "Chiba Prefecture",
      "moName": "Чиба аймаг",
      "buName": "ကျီဘ ပြည်နယ်",
      "khName": "ខេត្ត ឈីបា",
      "neName": "चिबा जिल्ला"
    },
    "class10": {
      "code": "120020",
      "name": "北東部",
      "enName": "North-eastern Region",
      "chName": "千叶县北东部",
      "zhName": "千葉縣北東部",
      "koName": "지바 현 북동부",
      "esName": "Nodeste de Prefectura de Chiba",
      "ptName": "Região nordeste da Província de Chiba",
      "thName": "จังหวัดจิบะตอนเหนือฟากตะวันออก",
      "viName": "Miền Đông Bắc tỉnh Chiba",
      "inName": "Bagian Timur Laut Prefektur Chiba",
      "tlName": "Hilaga-silangang bahagi ng Chiba Prefecture",
      "moName": "Зүүн хойд Чиба аймаг",
      "buName": "ချိဘစီရင်စု အရှေ့မြောက်ပိုင်း",
      "khName": "តំបន់ឦសាននៃខេត្តឈីបា",
      "neName": "चिबा जिल्लाको उत्तर पूर्वी भाग"
    },
    "class15": {
      "code": "120022",
      "name": "山武・長生",
      "enName": "Sammu Chosei"
    },
    "class20": {
      "code": "1242400",
      "name": "白子町",
      "enName": "Shirako Town",
      "kana": "しらこまち",
      "chName": "白子町",
      "zhName": "白子町",
      "koName": "시라코 정",
      "esName": "Pueblo de Shirako",
      "ptName": "bairro de Shirako",
      "thName": "เมืองชิราโกะ",
      "viName": "thị trấn Shirako",
      "inName": "kota Shirako",
      "tlName": "bayan ng Shirako",
      "moName": "Ширако жижиг хот",
      "buName": "ရှီရာကို မြို့နယ်",
      "khName": "ទីប្រជុំជន ស៊ីរ៉ាកុ",
      "neName": "शिराको नगर"
    }
  },
  "1242600": {
    "office": {
      "code": "120000",
      "name": "千葉県",
      "enName": "Chiba",
      "officeName": "銚子地方気象台",
      "chName": "千叶县",
      "zhName": "千葉縣",
      "koName": "지바현",
      "esName": "Prefectura de Chiba",
      "ptName": "Província de Chiba",
      "thName": "จังหวัดจิบะ",
      "viName": "Tỉnh Chiba",
      "inName": "Prefektur Chiba",
      "tlName": "Chiba Prefecture",
      "moName": "Чиба аймаг",
      "buName": "ကျီဘ ပြည်နယ်",
      "khName": "ខេត្ត ឈីបា",
      "neName": "चिबा जिल्ला"
    },
    "class10": {
      "code": "120020",
      "name": "北東部",
      "enName": "North-eastern Region",
      "chName": "千叶县北东部",
      "zhName": "千葉縣北東部",
      "koName": "지바 현 북동부",
      "esName": "Nodeste de Prefectura de Chiba",
      "ptName": "Região nordeste da Província de Chiba",
      "thName": "จังหวัดจิบะตอนเหนือฟากตะวันออก",
      "viName": "Miền Đông Bắc tỉnh Chiba",
      "inName": "Bagian Timur Laut Prefektur Chiba",
      "tlName": "Hilaga-silangang bahagi ng Chiba Prefecture",
      "moName": "Зүүн хойд Чиба аймаг",
      "buName": "ချိဘစီရင်စု အရှေ့မြောက်ပိုင်း",
      "khName": "តំបន់ឦសាននៃខេត្តឈីបា",
      "neName": "चिबा जिल्लाको उत्तर पूर्वी भाग"
    },
    "class15": {
      "code": "120022",
      "name": "山武・長生",
      "enName": "Sammu Chosei"
    },
    "class20": {
      "code": "1242600",
      "name": "長柄町",
      "enName": "Nagara Town",
      "kana": "ながらまち",
      "chName": "长柄町",
      "zhName": "長柄町",
      "koName": "나가라 정",
      "esName": "Pueblo de Nagara",
      "ptName": "bairro de Nagara",
      "thName": "เมืองนางาระ",
      "viName": "thị trấn Nagara",
      "inName": "kota Nagara",
      "tlName": "bayan ng Nagara",
      "moName": "Нaгарa жижиг хот",
      "buName": "နာဂါရာ့ မြို့နယ်",
      "khName": "ទីប្រជុំជន ណាហ្គារ៉ា",
      "neName": "नागारा नगर"
    }
  },
  "1242700": {
    "office": {
      "code": "120000",
      "name": "千葉県",
      "enName": "Chiba",
      "officeName": "銚子地方気象台",
      "chName": "千叶县",
      "zhName": "千葉縣",
      "koName": "지바현",
      "esName": "Prefectura de Chiba",
      "ptName": "Província de Chiba",
      "thName": "จังหวัดจิบะ",
      "viName": "Tỉnh Chiba",
      "inName": "Prefektur Chiba",
      "tlName": "Chiba Prefecture",
      "moName": "Чиба аймаг",
      "buName": "ကျီဘ ပြည်နယ်",
      "khName": "ខេត្ត ឈីបា",
      "neName": "चिबा जिल्ला"
    },
    "class10": {
      "code": "120020",
      "name": "北東部",
      "enName": "North-eastern Region",
      "chName": "千叶县北东部",
      "zhName": "千葉縣北東部",
      "koName": "지바 현 북동부",
      "esName": "Nodeste de Prefectura de Chiba",
      "ptName": "Região nordeste da Província de Chiba",
      "thName": "จังหวัดจิบะตอนเหนือฟากตะวันออก",
      "viName": "Miền Đông Bắc tỉnh Chiba",
      "inName": "Bagian Timur Laut Prefektur Chiba",
      "tlName": "Hilaga-silangang bahagi ng Chiba Prefecture",
      "moName": "Зүүн хойд Чиба аймаг",
      "buName": "ချိဘစီရင်စု အရှေ့မြောက်ပိုင်း",
      "khName": "តំបន់ឦសាននៃខេត្តឈីបា",
      "neName": "चिबा जिल्लाको उत्तर पूर्वी भाग"
    },
    "class15": {
      "code": "120022",
      "name": "山武・長生",
      "enName": "Sammu Chosei"
    },
    "class20": {
      "code": "1242700",
      "name": "長南町",
      "enName": "Chonan Town",
      "kana": "ちょうなんまち",
      "chName": "长南町",
      "zhName": "長南町",
      "koName": "조난 정",
      "esName": "Pueblo de Chonan",
      "ptName": "bairro de Chonan",
      "thName": "เมืองโชนัน",
      "viName": "thị trấn Chonan",
      "inName": "kota Chonan",
      "tlName": "bayan ng Chonan",
      "moName": "Чонaн жижиг хот",
      "buName": "ချိုးနန် မြို့နယ်",
      "khName": "ទីប្រជុំជន ឈុនណាន",
      "neName": "चोनान नगर"
    }
  },
  "1244100": {
    "office": {
      "code": "120000",
      "name": "千葉県",
      "enName": "Chiba",
      "officeName": "銚子地方気象台",
      "chName": "千叶县",
      "zhName": "千葉縣",
      "koName": "지바현",
      "esName": "Prefectura de Chiba",
      "ptName": "Província de Chiba",
      "thName": "จังหวัดจิบะ",
      "viName": "Tỉnh Chiba",
      "inName": "Prefektur Chiba",
      "tlName": "Chiba Prefecture",
      "moName": "Чиба аймаг",
      "buName": "ကျီဘ ပြည်နယ်",
      "khName": "ខេត្ត ឈីបា",
      "neName": "चिबा जिल्ला"
    },
    "class10": {
      "code": "120030",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "千叶县南部",
      "zhName": "千葉縣南部",
      "koName": "지바 현 남부",
      "esName": "Sur de Prefectura de Chiba",
      "ptName": "Sul da Província de Chiba",
      "thName": "จังหวัดจิบะตอนใต้",
      "viName": "Miền Nam tỉnh Chiba",
      "inName": "Bagian Selatan Prefektur Chiba",
      "tlName": "Timog na bahagi ng Chiba Prefecture",
      "moName": "Өмнөд Чиба аймаг",
      "buName": "ချိဘစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្តឈីបា",
      "neName": "चिबा जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "120032",
      "name": "夷隅・安房",
      "enName": "Isumi Awa"
    },
    "class20": {
      "code": "1244100",
      "name": "大多喜町",
      "enName": "Otaki Town",
      "kana": "おおたきまち",
      "chName": "大多喜町",
      "zhName": "大多喜町",
      "koName": "오타키 정",
      "esName": "Pueblo de Otaki",
      "ptName": "bairro de Otaki",
      "thName": "เมืองโอตากิ",
      "viName": "thị trấn Otaki",
      "inName": "kota Otaki",
      "tlName": "bayan ng Otaki",
      "moName": "Отаки жижиг хот",
      "buName": "အိုးတာ့ကိ မြို့နယ်",
      "khName": "ទីប្រជុំជន អូតាគី",
      "neName": "ओताकी नगर"
    }
  },
  "1244300": {
    "office": {
      "code": "120000",
      "name": "千葉県",
      "enName": "Chiba",
      "officeName": "銚子地方気象台",
      "chName": "千叶县",
      "zhName": "千葉縣",
      "koName": "지바현",
      "esName": "Prefectura de Chiba",
      "ptName": "Província de Chiba",
      "thName": "จังหวัดจิบะ",
      "viName": "Tỉnh Chiba",
      "inName": "Prefektur Chiba",
      "tlName": "Chiba Prefecture",
      "moName": "Чиба аймаг",
      "buName": "ကျီဘ ပြည်နယ်",
      "khName": "ខេត្ត ឈីបា",
      "neName": "चिबा जिल्ला"
    },
    "class10": {
      "code": "120030",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "千叶县南部",
      "zhName": "千葉縣南部",
      "koName": "지바 현 남부",
      "esName": "Sur de Prefectura de Chiba",
      "ptName": "Sul da Província de Chiba",
      "thName": "จังหวัดจิบะตอนใต้",
      "viName": "Miền Nam tỉnh Chiba",
      "inName": "Bagian Selatan Prefektur Chiba",
      "tlName": "Timog na bahagi ng Chiba Prefecture",
      "moName": "Өмнөд Чиба аймаг",
      "buName": "ချိဘစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្តឈីបា",
      "neName": "चिबा जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "120032",
      "name": "夷隅・安房",
      "enName": "Isumi Awa"
    },
    "class20": {
      "code": "1244300",
      "name": "御宿町",
      "enName": "Onjuku Town",
      "kana": "おんじゅくまち",
      "chName": "御宿町",
      "zhName": "御宿町",
      "koName": "온주쿠 마치",
      "esName": "Pueblo de Onjyuku",
      "ptName": "bairro de Onjuku",
      "thName": "เมืองอนจูกุ",
      "viName": "thị trấn Onjuku",
      "inName": "kota Onjuku",
      "tlName": "bayan ng Onjuku",
      "moName": "Онжүкү жижиг хот",
      "buName": "အွန်းဂျုကု မြို့နယ်",
      "khName": "ទីប្រជុំជន អូជុគូ",
      "neName": "ओन्जुकु नगर"
    }
  },
  "1246300": {
    "office": {
      "code": "120000",
      "name": "千葉県",
      "enName": "Chiba",
      "officeName": "銚子地方気象台",
      "chName": "千叶县",
      "zhName": "千葉縣",
      "koName": "지바현",
      "esName": "Prefectura de Chiba",
      "ptName": "Província de Chiba",
      "thName": "จังหวัดจิบะ",
      "viName": "Tỉnh Chiba",
      "inName": "Prefektur Chiba",
      "tlName": "Chiba Prefecture",
      "moName": "Чиба аймаг",
      "buName": "ကျီဘ ပြည်နယ်",
      "khName": "ខេត្ត ឈីបា",
      "neName": "चिबा जिल्ला"
    },
    "class10": {
      "code": "120030",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "千叶县南部",
      "zhName": "千葉縣南部",
      "koName": "지바 현 남부",
      "esName": "Sur de Prefectura de Chiba",
      "ptName": "Sul da Província de Chiba",
      "thName": "จังหวัดจิบะตอนใต้",
      "viName": "Miền Nam tỉnh Chiba",
      "inName": "Bagian Selatan Prefektur Chiba",
      "tlName": "Timog na bahagi ng Chiba Prefecture",
      "moName": "Өмнөд Чиба аймаг",
      "buName": "ချိဘစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្តឈីបា",
      "neName": "चिबा जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "120032",
      "name": "夷隅・安房",
      "enName": "Isumi Awa"
    },
    "class20": {
      "code": "1246300",
      "name": "鋸南町",
      "enName": "Kyonan Town",
      "kana": "きょなんまち",
      "chName": "锯南町",
      "zhName": "鋸南町",
      "koName": "교난 정",
      "esName": "Pueblo de Kyonan",
      "ptName": "bairro de Kyonan",
      "thName": "เมืองเคียวนัน",
      "viName": "thị trấn Kyonan",
      "inName": "kota Kyonan",
      "tlName": "bayan ng Kyonan",
      "moName": "Кионaн жижиг хот",
      "buName": "ကျိုနန် မြို့နယ်",
      "khName": "ទីប្រជុំជន ក្យូណាន",
      "neName": "क्योनान नगर"
    }
  },
  "1310100": {
    "office": {
      "code": "130000",
      "name": "東京都",
      "enName": "Tokyo",
      "officeName": "気象庁",
      "chName": "东京都",
      "zhName": "東京都",
      "koName": "도쿄도",
      "esName": "Prefectura de Tokio",
      "ptName": "Metrópole de Tóquio (Tōkyō)",
      "thName": "กรุงโตเกียว",
      "viName": "Thủ đô Tokyo",
      "inName": "Ibu Kota Tokyo",
      "tlName": "Tokyo Metropolis",
      "moName": "Токио",
      "buName": "တိုကျို",
      "khName": "តូក្យូ​",
      "neName": "टोक्यो महानगरपालिका"
    },
    "class10": {
      "code": "130010",
      "name": "東京地方",
      "enName": "Tokyo Region",
      "chName": "東京地區, 東京都",
      "zhName": "东京地区, 東京都",
      "koName": "도쿄 지방, 도쿄도",
      "esName": "Región de Tokio, Prefectura de Tokio",
      "ptName": "Região de Tóquio, Metrópole de Tóquio (Tōkyō)",
      "thName": "ภูมิภาคโตเกียว, กรุงโตเกียว",
      "viName": "khu vực Tokyo, Thủ đô Tokyo",
      "inName": "wilayah Tokyo, Ibu Kota Tokyo",
      "tlName": "Rehiyon ng Tokyo, Tokyo Metropolis",
      "moName": "Токио бүс, Токио",
      "buName": "တိုကျိုဒေသ, တိုကျို",
      "khName": "តំបន់តូក្យូ, តូក្យូ​",
      "neName": "टोकियो क्षेत्र, टोक्यो महानगरपालिका"
    },
    "class15": {
      "code": "130011",
      "name": "２３区西部",
      "enName": "Western Region of 23 wards"
    },
    "class20": {
      "code": "1310100",
      "name": "千代田区",
      "enName": "Chiyoda City",
      "kana": "ちよだく",
      "chName": "东京千代田区",
      "zhName": "東京千代田區",
      "koName": "도쿄 치요다 구",
      "esName": "Distrito Chiyoda (Chiyoda-ku), Tokio",
      "ptName": "Tóquio, bairro de Chiyoda",
      "thName": "เมืองชิโยดะ โตเกียว",
      "viName": "thành phố Chiyoda, Tokyo",
      "inName": "Distrik Kota Chiyoda, Tokyo",
      "tlName": "siyudad ng Chiyoda, Tokyo",
      "moName": "Токио Чиёда дүүрэг",
      "buName": "တိုကျိုချိယိုဒမြို့",
      "khName": "សង្កាត់ឈីយ៉ូដា តូក្យូ​",
      "neName": "टोक्यो चियोदा सहर"
    }
  },
  "1310200": {
    "office": {
      "code": "130000",
      "name": "東京都",
      "enName": "Tokyo",
      "officeName": "気象庁",
      "chName": "东京都",
      "zhName": "東京都",
      "koName": "도쿄도",
      "esName": "Prefectura de Tokio",
      "ptName": "Metrópole de Tóquio (Tōkyō)",
      "thName": "กรุงโตเกียว",
      "viName": "Thủ đô Tokyo",
      "inName": "Ibu Kota Tokyo",
      "tlName": "Tokyo Metropolis",
      "moName": "Токио",
      "buName": "တိုကျို",
      "khName": "តូក្យូ​",
      "neName": "टोक्यो महानगरपालिका"
    },
    "class10": {
      "code": "130010",
      "name": "東京地方",
      "enName": "Tokyo Region",
      "chName": "東京地區, 東京都",
      "zhName": "东京地区, 東京都",
      "koName": "도쿄 지방, 도쿄도",
      "esName": "Región de Tokio, Prefectura de Tokio",
      "ptName": "Região de Tóquio, Metrópole de Tóquio (Tōkyō)",
      "thName": "ภูมิภาคโตเกียว, กรุงโตเกียว",
      "viName": "khu vực Tokyo, Thủ đô Tokyo",
      "inName": "wilayah Tokyo, Ibu Kota Tokyo",
      "tlName": "Rehiyon ng Tokyo, Tokyo Metropolis",
      "moName": "Токио бүс, Токио",
      "buName": "တိုကျိုဒေသ, တိုကျို",
      "khName": "តំបន់តូក្យូ, តូក្យូ​",
      "neName": "टोकियो क्षेत्र, टोक्यो महानगरपालिका"
    },
    "class15": {
      "code": "130011",
      "name": "２３区西部",
      "enName": "Western Region of 23 wards"
    },
    "class20": {
      "code": "1310200",
      "name": "中央区",
      "enName": "Chuo City",
      "kana": "ちゅうおうく",
      "chName": "东京中央区",
      "zhName": "東京中央區",
      "koName": "도쿄 주오 구",
      "esName": "Distrito Chuo (Chuo-ku), Tokio",
      "ptName": "Tóquio, bairro de Chuo",
      "thName": "เมืองชูโอะ โตเกียว",
      "viName": "thành phố Chuo, Tokyo",
      "inName": "Distrik Kota Chuo, Tokyo",
      "tlName": "siyudad ng Chuo, Tokyo",
      "moName": "Токио чүүоо дүүрэг",
      "buName": "တိုကျိုချူးအိုးမြို့",
      "khName": "សង្កាត់ឈូអូ តូក្យូ​",
      "neName": "टोक्यो च्युओ सहर"
    }
  },
  "1310300": {
    "office": {
      "code": "130000",
      "name": "東京都",
      "enName": "Tokyo",
      "officeName": "気象庁",
      "chName": "东京都",
      "zhName": "東京都",
      "koName": "도쿄도",
      "esName": "Prefectura de Tokio",
      "ptName": "Metrópole de Tóquio (Tōkyō)",
      "thName": "กรุงโตเกียว",
      "viName": "Thủ đô Tokyo",
      "inName": "Ibu Kota Tokyo",
      "tlName": "Tokyo Metropolis",
      "moName": "Токио",
      "buName": "တိုကျို",
      "khName": "តូក្យូ​",
      "neName": "टोक्यो महानगरपालिका"
    },
    "class10": {
      "code": "130010",
      "name": "東京地方",
      "enName": "Tokyo Region",
      "chName": "東京地區, 東京都",
      "zhName": "东京地区, 東京都",
      "koName": "도쿄 지방, 도쿄도",
      "esName": "Región de Tokio, Prefectura de Tokio",
      "ptName": "Região de Tóquio, Metrópole de Tóquio (Tōkyō)",
      "thName": "ภูมิภาคโตเกียว, กรุงโตเกียว",
      "viName": "khu vực Tokyo, Thủ đô Tokyo",
      "inName": "wilayah Tokyo, Ibu Kota Tokyo",
      "tlName": "Rehiyon ng Tokyo, Tokyo Metropolis",
      "moName": "Токио бүс, Токио",
      "buName": "တိုကျိုဒေသ, တိုကျို",
      "khName": "តំបន់តូក្យូ, តូក្យូ​",
      "neName": "टोकियो क्षेत्र, टोक्यो महानगरपालिका"
    },
    "class15": {
      "code": "130011",
      "name": "２３区西部",
      "enName": "Western Region of 23 wards"
    },
    "class20": {
      "code": "1310300",
      "name": "港区",
      "enName": "Minato City",
      "kana": "みなとく",
      "chName": "东京港区",
      "zhName": "東京港區",
      "koName": "도쿄 미나토 구",
      "esName": "Distrito Minato (Minato-ku), Tokio",
      "ptName": "Tóquio, bairro de Minato",
      "thName": "เมืองมินาโตะ โตเกียว",
      "viName": "thành phố Minato, Tokyo",
      "inName": "Distrik Kota Minato, Tokyo",
      "tlName": "siyudad ng Minato, Tokyo",
      "moName": "Токио Минато дүүрэг",
      "buName": "တိုကျိုမိနတိုမြို့",
      "khName": "សង្កាត់មីណាតូ តូក្យូ​",
      "neName": "टोक्यो मिनातो सहर"
    }
  },
  "1310400": {
    "office": {
      "code": "130000",
      "name": "東京都",
      "enName": "Tokyo",
      "officeName": "気象庁",
      "chName": "东京都",
      "zhName": "東京都",
      "koName": "도쿄도",
      "esName": "Prefectura de Tokio",
      "ptName": "Metrópole de Tóquio (Tōkyō)",
      "thName": "กรุงโตเกียว",
      "viName": "Thủ đô Tokyo",
      "inName": "Ibu Kota Tokyo",
      "tlName": "Tokyo Metropolis",
      "moName": "Токио",
      "buName": "တိုကျို",
      "khName": "តូក្យូ​",
      "neName": "टोक्यो महानगरपालिका"
    },
    "class10": {
      "code": "130010",
      "name": "東京地方",
      "enName": "Tokyo Region",
      "chName": "東京地區, 東京都",
      "zhName": "东京地区, 東京都",
      "koName": "도쿄 지방, 도쿄도",
      "esName": "Región de Tokio, Prefectura de Tokio",
      "ptName": "Região de Tóquio, Metrópole de Tóquio (Tōkyō)",
      "thName": "ภูมิภาคโตเกียว, กรุงโตเกียว",
      "viName": "khu vực Tokyo, Thủ đô Tokyo",
      "inName": "wilayah Tokyo, Ibu Kota Tokyo",
      "tlName": "Rehiyon ng Tokyo, Tokyo Metropolis",
      "moName": "Токио бүс, Токио",
      "buName": "တိုကျိုဒေသ, တိုကျို",
      "khName": "តំបន់តូក្យូ, តូក្យូ​",
      "neName": "टोकियो क्षेत्र, टोक्यो महानगरपालिका"
    },
    "class15": {
      "code": "130011",
      "name": "２３区西部",
      "enName": "Western Region of 23 wards"
    },
    "class20": {
      "code": "1310400",
      "name": "新宿区",
      "enName": "Shinjuku City",
      "kana": "しんじゅくく",
      "chName": "东京新宿区",
      "zhName": "東京新宿區",
      "koName": "도쿄 신주쿠 구",
      "esName": "Distrito Shinjuku (Shinjuku-ku), Tokio",
      "ptName": "Tóquio, bairro de Shinjuku",
      "thName": "เมืองชินจูกุ โตเกียว",
      "viName": "thành phố Shinjuku, Tokyo",
      "inName": "Distrik Kota Shinjuku, Tokyo",
      "tlName": "siyudad ng Shinjuku, Tokyo",
      "moName": "Токио Шинжюкү дүүрэг",
      "buName": "တိုကျိုရှင်းဂျုခုမြို့",
      "khName": "សង្កាត់ស៊ីនជូគូ តូក្យូ​",
      "neName": "टोक्यो शिन्जुकु सहर"
    }
  },
  "1310500": {
    "office": {
      "code": "130000",
      "name": "東京都",
      "enName": "Tokyo",
      "officeName": "気象庁",
      "chName": "东京都",
      "zhName": "東京都",
      "koName": "도쿄도",
      "esName": "Prefectura de Tokio",
      "ptName": "Metrópole de Tóquio (Tōkyō)",
      "thName": "กรุงโตเกียว",
      "viName": "Thủ đô Tokyo",
      "inName": "Ibu Kota Tokyo",
      "tlName": "Tokyo Metropolis",
      "moName": "Токио",
      "buName": "တိုကျို",
      "khName": "តូក្យូ​",
      "neName": "टोक्यो महानगरपालिका"
    },
    "class10": {
      "code": "130010",
      "name": "東京地方",
      "enName": "Tokyo Region",
      "chName": "東京地區, 東京都",
      "zhName": "东京地区, 東京都",
      "koName": "도쿄 지방, 도쿄도",
      "esName": "Región de Tokio, Prefectura de Tokio",
      "ptName": "Região de Tóquio, Metrópole de Tóquio (Tōkyō)",
      "thName": "ภูมิภาคโตเกียว, กรุงโตเกียว",
      "viName": "khu vực Tokyo, Thủ đô Tokyo",
      "inName": "wilayah Tokyo, Ibu Kota Tokyo",
      "tlName": "Rehiyon ng Tokyo, Tokyo Metropolis",
      "moName": "Токио бүс, Токио",
      "buName": "တိုကျိုဒေသ, တိုကျို",
      "khName": "តំបន់តូក្យូ, តូក្យូ​",
      "neName": "टोकियो क्षेत्र, टोक्यो महानगरपालिका"
    },
    "class15": {
      "code": "130011",
      "name": "２３区西部",
      "enName": "Western Region of 23 wards"
    },
    "class20": {
      "code": "1310500",
      "name": "文京区",
      "enName": "Bunkyo City",
      "kana": "ぶんきょうく",
      "chName": "东京文京区",
      "zhName": "東京文京區",
      "koName": "도쿄 분쿄 구",
      "esName": "Distrito Bunkyo (Bunkyo-ku), Tokio",
      "ptName": "Tóquio, bairro de Bunkyo",
      "thName": "เมืองบุงเกียว โตเกียว",
      "viName": "thành phố Bunkyo, Tokyo",
      "inName": "Distrik Kota Bunkyo, Tokyo",
      "tlName": "siyudad ng Bunkyo, Tokyo",
      "moName": "Токио Бүнкё дүүрэг",
      "buName": "တိုကျိုဘွန်းခယောမြို့",
      "khName": "សង្កាត់ប៊ុនខ្យូ តូក្យូ​",
      "neName": "टोक्यो बुन्क्यो सहर"
    }
  },
  "1310600": {
    "office": {
      "code": "130000",
      "name": "東京都",
      "enName": "Tokyo",
      "officeName": "気象庁",
      "chName": "东京都",
      "zhName": "東京都",
      "koName": "도쿄도",
      "esName": "Prefectura de Tokio",
      "ptName": "Metrópole de Tóquio (Tōkyō)",
      "thName": "กรุงโตเกียว",
      "viName": "Thủ đô Tokyo",
      "inName": "Ibu Kota Tokyo",
      "tlName": "Tokyo Metropolis",
      "moName": "Токио",
      "buName": "တိုကျို",
      "khName": "តូក្យូ​",
      "neName": "टोक्यो महानगरपालिका"
    },
    "class10": {
      "code": "130010",
      "name": "東京地方",
      "enName": "Tokyo Region",
      "chName": "東京地區, 東京都",
      "zhName": "东京地区, 東京都",
      "koName": "도쿄 지방, 도쿄도",
      "esName": "Región de Tokio, Prefectura de Tokio",
      "ptName": "Região de Tóquio, Metrópole de Tóquio (Tōkyō)",
      "thName": "ภูมิภาคโตเกียว, กรุงโตเกียว",
      "viName": "khu vực Tokyo, Thủ đô Tokyo",
      "inName": "wilayah Tokyo, Ibu Kota Tokyo",
      "tlName": "Rehiyon ng Tokyo, Tokyo Metropolis",
      "moName": "Токио бүс, Токио",
      "buName": "တိုကျိုဒေသ, တိုကျို",
      "khName": "តំបន់តូក្យូ, តូក្យូ​",
      "neName": "टोकियो क्षेत्र, टोक्यो महानगरपालिका"
    },
    "class15": {
      "code": "130012",
      "name": "２３区東部",
      "enName": "Eastern Region of 23 wards"
    },
    "class20": {
      "code": "1310600",
      "name": "台東区",
      "enName": "Taito City",
      "kana": "たいとうく",
      "chName": "东京台东区",
      "zhName": "東京台東區",
      "koName": "도쿄 다이토 구",
      "esName": "Distrito Taito (Taito-ku), Tokio",
      "ptName": "Tóquio, bairro de Taito",
      "thName": "เมืองไทโตะ โตเกียว",
      "viName": "thành phố Taito, Tokyo",
      "inName": "Distrik Kota Taito, Tokyo",
      "tlName": "siyudad ng Taito, Tokyo",
      "moName": "Токио Тайто дүүрэг",
      "buName": "တိုကျိုတိုင်းတိုးမြို့",
      "khName": "សង្កាត់តៃតូ តូក្យូ​",
      "neName": "टोक्यो ताइतो सहर"
    }
  },
  "1310700": {
    "office": {
      "code": "130000",
      "name": "東京都",
      "enName": "Tokyo",
      "officeName": "気象庁",
      "chName": "东京都",
      "zhName": "東京都",
      "koName": "도쿄도",
      "esName": "Prefectura de Tokio",
      "ptName": "Metrópole de Tóquio (Tōkyō)",
      "thName": "กรุงโตเกียว",
      "viName": "Thủ đô Tokyo",
      "inName": "Ibu Kota Tokyo",
      "tlName": "Tokyo Metropolis",
      "moName": "Токио",
      "buName": "တိုကျို",
      "khName": "តូក្យូ​",
      "neName": "टोक्यो महानगरपालिका"
    },
    "class10": {
      "code": "130010",
      "name": "東京地方",
      "enName": "Tokyo Region",
      "chName": "東京地區, 東京都",
      "zhName": "东京地区, 東京都",
      "koName": "도쿄 지방, 도쿄도",
      "esName": "Región de Tokio, Prefectura de Tokio",
      "ptName": "Região de Tóquio, Metrópole de Tóquio (Tōkyō)",
      "thName": "ภูมิภาคโตเกียว, กรุงโตเกียว",
      "viName": "khu vực Tokyo, Thủ đô Tokyo",
      "inName": "wilayah Tokyo, Ibu Kota Tokyo",
      "tlName": "Rehiyon ng Tokyo, Tokyo Metropolis",
      "moName": "Токио бүс, Токио",
      "buName": "တိုကျိုဒေသ, တိုကျို",
      "khName": "តំបន់តូក្យូ, តូក្យូ​",
      "neName": "टोकियो क्षेत्र, टोक्यो महानगरपालिका"
    },
    "class15": {
      "code": "130012",
      "name": "２３区東部",
      "enName": "Eastern Region of 23 wards"
    },
    "class20": {
      "code": "1310700",
      "name": "墨田区",
      "enName": "Sumida City",
      "kana": "すみだく",
      "chName": "东京墨田区",
      "zhName": "東京墨田區",
      "koName": "도쿄 스미다 구",
      "esName": "Distrito Sumida (Sumida-ku), Tokio",
      "ptName": "Tóquio, bairro de Sumida",
      "thName": "เมืองสุมิดะ โตเกียว",
      "viName": "thành phố Sumida, Tokyo",
      "inName": "Distrik Kota Sumida, Tokyo",
      "tlName": "siyudad ng Sumida, Tokyo",
      "moName": "Токио Сүмида дүүрэг",
      "buName": "တိုကျိုဆုမိဒမြို့",
      "khName": "សង្កាត់ស៊ូមីដា តូក្យូ​",
      "neName": "टोक्यो सुमिदा सहर"
    }
  },
  "1310800": {
    "office": {
      "code": "130000",
      "name": "東京都",
      "enName": "Tokyo",
      "officeName": "気象庁",
      "chName": "东京都",
      "zhName": "東京都",
      "koName": "도쿄도",
      "esName": "Prefectura de Tokio",
      "ptName": "Metrópole de Tóquio (Tōkyō)",
      "thName": "กรุงโตเกียว",
      "viName": "Thủ đô Tokyo",
      "inName": "Ibu Kota Tokyo",
      "tlName": "Tokyo Metropolis",
      "moName": "Токио",
      "buName": "တိုကျို",
      "khName": "តូក្យូ​",
      "neName": "टोक्यो महानगरपालिका"
    },
    "class10": {
      "code": "130010",
      "name": "東京地方",
      "enName": "Tokyo Region",
      "chName": "東京地區, 東京都",
      "zhName": "东京地区, 東京都",
      "koName": "도쿄 지방, 도쿄도",
      "esName": "Región de Tokio, Prefectura de Tokio",
      "ptName": "Região de Tóquio, Metrópole de Tóquio (Tōkyō)",
      "thName": "ภูมิภาคโตเกียว, กรุงโตเกียว",
      "viName": "khu vực Tokyo, Thủ đô Tokyo",
      "inName": "wilayah Tokyo, Ibu Kota Tokyo",
      "tlName": "Rehiyon ng Tokyo, Tokyo Metropolis",
      "moName": "Токио бүс, Токио",
      "buName": "တိုကျိုဒေသ, တိုကျို",
      "khName": "តំបន់តូក្យូ, តូក្យូ​",
      "neName": "टोकियो क्षेत्र, टोक्यो महानगरपालिका"
    },
    "class15": {
      "code": "130012",
      "name": "２３区東部",
      "enName": "Eastern Region of 23 wards"
    },
    "class20": {
      "code": "1310800",
      "name": "江東区",
      "enName": "Koto City",
      "kana": "こうとうく",
      "chName": "东京江东区",
      "zhName": "東京江東區",
      "koName": "도쿄 고토 구",
      "esName": "Distrito Koto (Koto-ku), Tokio",
      "ptName": "Tóquio, bairro de Koto",
      "thName": "เมืองโกโต โตเกียว",
      "viName": "thành phố Koto, Tokyo",
      "inName": "Distrik Kota Koto, Tokyo",
      "tlName": "siyudad ng Koto, Tokyo",
      "moName": "Токио Кото дүүрэг",
      "buName": "တိုကျိုခိုးတိုမြို့",
      "khName": "សង្កាត់កូតូ តូក្យូ​",
      "neName": "टोक्यो कोतो सहर"
    }
  },
  "1310900": {
    "office": {
      "code": "130000",
      "name": "東京都",
      "enName": "Tokyo",
      "officeName": "気象庁",
      "chName": "东京都",
      "zhName": "東京都",
      "koName": "도쿄도",
      "esName": "Prefectura de Tokio",
      "ptName": "Metrópole de Tóquio (Tōkyō)",
      "thName": "กรุงโตเกียว",
      "viName": "Thủ đô Tokyo",
      "inName": "Ibu Kota Tokyo",
      "tlName": "Tokyo Metropolis",
      "moName": "Токио",
      "buName": "တိုကျို",
      "khName": "តូក្យូ​",
      "neName": "टोक्यो महानगरपालिका"
    },
    "class10": {
      "code": "130010",
      "name": "東京地方",
      "enName": "Tokyo Region",
      "chName": "東京地區, 東京都",
      "zhName": "东京地区, 東京都",
      "koName": "도쿄 지방, 도쿄도",
      "esName": "Región de Tokio, Prefectura de Tokio",
      "ptName": "Região de Tóquio, Metrópole de Tóquio (Tōkyō)",
      "thName": "ภูมิภาคโตเกียว, กรุงโตเกียว",
      "viName": "khu vực Tokyo, Thủ đô Tokyo",
      "inName": "wilayah Tokyo, Ibu Kota Tokyo",
      "tlName": "Rehiyon ng Tokyo, Tokyo Metropolis",
      "moName": "Токио бүс, Токио",
      "buName": "တိုကျိုဒေသ, တိုကျို",
      "khName": "តំបន់តូក្យូ, តូក្យូ​",
      "neName": "टोकियो क्षेत्र, टोक्यो महानगरपालिका"
    },
    "class15": {
      "code": "130011",
      "name": "２３区西部",
      "enName": "Western Region of 23 wards"
    },
    "class20": {
      "code": "1310900",
      "name": "品川区",
      "enName": "Shinagawa City",
      "kana": "しながわく",
      "chName": "东京品川区",
      "zhName": "東京品川區",
      "koName": "도쿄 시나가와 구",
      "esName": "Distrito Shinagawa (Shinagawa-ku), Tokio",
      "ptName": "Tóquio, bairro de Shinagawa",
      "thName": "เมืองชินาคาวา โตเกียว",
      "viName": "thành phố Shinagawa, Tokyo",
      "inName": "Distrik Kota Shinagawa, Tokyo",
      "tlName": "siyudad ng Shinagawa, Tokyo",
      "moName": "Токио Шинагава дүүрэг",
      "buName": "တိုကျိုရှိနဂဝမြို့",
      "khName": "សង្កាត់ស៊ីនណាហ្គាវ៉ា តូក្យូ​",
      "neName": "टोक्यो शिनागावा सहर"
    }
  },
  "1311000": {
    "office": {
      "code": "130000",
      "name": "東京都",
      "enName": "Tokyo",
      "officeName": "気象庁",
      "chName": "东京都",
      "zhName": "東京都",
      "koName": "도쿄도",
      "esName": "Prefectura de Tokio",
      "ptName": "Metrópole de Tóquio (Tōkyō)",
      "thName": "กรุงโตเกียว",
      "viName": "Thủ đô Tokyo",
      "inName": "Ibu Kota Tokyo",
      "tlName": "Tokyo Metropolis",
      "moName": "Токио",
      "buName": "တိုကျို",
      "khName": "តូក្យូ​",
      "neName": "टोक्यो महानगरपालिका"
    },
    "class10": {
      "code": "130010",
      "name": "東京地方",
      "enName": "Tokyo Region",
      "chName": "東京地區, 東京都",
      "zhName": "东京地区, 東京都",
      "koName": "도쿄 지방, 도쿄도",
      "esName": "Región de Tokio, Prefectura de Tokio",
      "ptName": "Região de Tóquio, Metrópole de Tóquio (Tōkyō)",
      "thName": "ภูมิภาคโตเกียว, กรุงโตเกียว",
      "viName": "khu vực Tokyo, Thủ đô Tokyo",
      "inName": "wilayah Tokyo, Ibu Kota Tokyo",
      "tlName": "Rehiyon ng Tokyo, Tokyo Metropolis",
      "moName": "Токио бүс, Токио",
      "buName": "တိုကျိုဒေသ, တိုကျို",
      "khName": "តំបន់តូក្យូ, តូក្យូ​",
      "neName": "टोकियो क्षेत्र, टोक्यो महानगरपालिका"
    },
    "class15": {
      "code": "130011",
      "name": "２３区西部",
      "enName": "Western Region of 23 wards"
    },
    "class20": {
      "code": "1311000",
      "name": "目黒区",
      "enName": "Meguro City",
      "kana": "めぐろく",
      "chName": "东京目黑区",
      "zhName": "東京目黑區",
      "koName": "도쿄 메구로 구",
      "esName": "Distrito Meguro (Meguro-ku), Tokio",
      "ptName": "Tóquio, bairro de Meguro",
      "thName": "เมืองเมงุโระ โตเกียว",
      "viName": "thành phố Meguro, Tokyo",
      "inName": "Distrik Kota Meguro, Tokyo",
      "tlName": "siyudad ng Meguro, Tokyo",
      "moName": "Токио Мэгүродүүрэг",
      "buName": "တိုကျိုမဲဂုယိုမြို့",
      "khName": "សង្កាត់មេហ្គូរ៉ូ តូក្យូ​",
      "neName": "टोक्यो मेगुरो सहर"
    }
  },
  "1311100": {
    "office": {
      "code": "130000",
      "name": "東京都",
      "enName": "Tokyo",
      "officeName": "気象庁",
      "chName": "东京都",
      "zhName": "東京都",
      "koName": "도쿄도",
      "esName": "Prefectura de Tokio",
      "ptName": "Metrópole de Tóquio (Tōkyō)",
      "thName": "กรุงโตเกียว",
      "viName": "Thủ đô Tokyo",
      "inName": "Ibu Kota Tokyo",
      "tlName": "Tokyo Metropolis",
      "moName": "Токио",
      "buName": "တိုကျို",
      "khName": "តូក្យូ​",
      "neName": "टोक्यो महानगरपालिका"
    },
    "class10": {
      "code": "130010",
      "name": "東京地方",
      "enName": "Tokyo Region",
      "chName": "東京地區, 東京都",
      "zhName": "东京地区, 東京都",
      "koName": "도쿄 지방, 도쿄도",
      "esName": "Región de Tokio, Prefectura de Tokio",
      "ptName": "Região de Tóquio, Metrópole de Tóquio (Tōkyō)",
      "thName": "ภูมิภาคโตเกียว, กรุงโตเกียว",
      "viName": "khu vực Tokyo, Thủ đô Tokyo",
      "inName": "wilayah Tokyo, Ibu Kota Tokyo",
      "tlName": "Rehiyon ng Tokyo, Tokyo Metropolis",
      "moName": "Токио бүс, Токио",
      "buName": "တိုကျိုဒေသ, တိုကျို",
      "khName": "តំបន់តូក្យូ, តូក្យូ​",
      "neName": "टोकियो क्षेत्र, टोक्यो महानगरपालिका"
    },
    "class15": {
      "code": "130011",
      "name": "２３区西部",
      "enName": "Western Region of 23 wards"
    },
    "class20": {
      "code": "1311100",
      "name": "大田区",
      "enName": "Ota City",
      "kana": "おおたく",
      "chName": "东京大田区",
      "zhName": "東京大田區",
      "koName": "도쿄 오타 구",
      "esName": "Distrito Ota (Ota-ku), Tokio",
      "ptName": "Tóquio, bairro de Ota",
      "thName": "เมืองโอตะ โตเกียว",
      "viName": "thành phố Ota, Tokyo",
      "inName": "Distrik Kota Ota, Tokyo",
      "tlName": "siyudad ng Ota, Tokyo",
      "moName": "Токио Оотакү дүүрэг",
      "buName": "တိုကျိုအိုအိုတမြို့",
      "khName": "សង្កាត់អូតា តូក្យូ​",
      "neName": "टोक्यो ओता सहर"
    }
  },
  "1311200": {
    "office": {
      "code": "130000",
      "name": "東京都",
      "enName": "Tokyo",
      "officeName": "気象庁",
      "chName": "东京都",
      "zhName": "東京都",
      "koName": "도쿄도",
      "esName": "Prefectura de Tokio",
      "ptName": "Metrópole de Tóquio (Tōkyō)",
      "thName": "กรุงโตเกียว",
      "viName": "Thủ đô Tokyo",
      "inName": "Ibu Kota Tokyo",
      "tlName": "Tokyo Metropolis",
      "moName": "Токио",
      "buName": "တိုကျို",
      "khName": "តូក្យូ​",
      "neName": "टोक्यो महानगरपालिका"
    },
    "class10": {
      "code": "130010",
      "name": "東京地方",
      "enName": "Tokyo Region",
      "chName": "東京地區, 東京都",
      "zhName": "东京地区, 東京都",
      "koName": "도쿄 지방, 도쿄도",
      "esName": "Región de Tokio, Prefectura de Tokio",
      "ptName": "Região de Tóquio, Metrópole de Tóquio (Tōkyō)",
      "thName": "ภูมิภาคโตเกียว, กรุงโตเกียว",
      "viName": "khu vực Tokyo, Thủ đô Tokyo",
      "inName": "wilayah Tokyo, Ibu Kota Tokyo",
      "tlName": "Rehiyon ng Tokyo, Tokyo Metropolis",
      "moName": "Токио бүс, Токио",
      "buName": "တိုကျိုဒေသ, တိုကျို",
      "khName": "តំបន់តូក្យូ, តូក្យូ​",
      "neName": "टोकियो क्षेत्र, टोक्यो महानगरपालिका"
    },
    "class15": {
      "code": "130011",
      "name": "２３区西部",
      "enName": "Western Region of 23 wards"
    },
    "class20": {
      "code": "1311200",
      "name": "世田谷区",
      "enName": "Setagaya City",
      "kana": "せたがやく",
      "chName": "东京世田谷区",
      "zhName": "東京世田穀區",
      "koName": "도쿄 세타가야 구",
      "esName": "Distrito Setagaya (Setagaya-ku), Tokio",
      "ptName": "Tóquio, bairro de Setagaya",
      "thName": "เมืองเซตะงายะ โตเกียว",
      "viName": "thành phố Setagaya, Tokyo",
      "inName": "Distrik Kota Setagaya, Tokyo",
      "tlName": "siyudad ng Setagaya, Tokyo",
      "moName": "Токио Сэтагая дүүрэг",
      "buName": "တိုကျိုဆဲတဂယမြို့",
      "khName": "សង្កាត់ស៊ីតាហ្គាយ៉ា តូក្យូ​",
      "neName": "टोक्यो सेतागाया सहर"
    }
  },
  "1311300": {
    "office": {
      "code": "130000",
      "name": "東京都",
      "enName": "Tokyo",
      "officeName": "気象庁",
      "chName": "东京都",
      "zhName": "東京都",
      "koName": "도쿄도",
      "esName": "Prefectura de Tokio",
      "ptName": "Metrópole de Tóquio (Tōkyō)",
      "thName": "กรุงโตเกียว",
      "viName": "Thủ đô Tokyo",
      "inName": "Ibu Kota Tokyo",
      "tlName": "Tokyo Metropolis",
      "moName": "Токио",
      "buName": "တိုကျို",
      "khName": "តូក្យូ​",
      "neName": "टोक्यो महानगरपालिका"
    },
    "class10": {
      "code": "130010",
      "name": "東京地方",
      "enName": "Tokyo Region",
      "chName": "東京地區, 東京都",
      "zhName": "东京地区, 東京都",
      "koName": "도쿄 지방, 도쿄도",
      "esName": "Región de Tokio, Prefectura de Tokio",
      "ptName": "Região de Tóquio, Metrópole de Tóquio (Tōkyō)",
      "thName": "ภูมิภาคโตเกียว, กรุงโตเกียว",
      "viName": "khu vực Tokyo, Thủ đô Tokyo",
      "inName": "wilayah Tokyo, Ibu Kota Tokyo",
      "tlName": "Rehiyon ng Tokyo, Tokyo Metropolis",
      "moName": "Токио бүс, Токио",
      "buName": "တိုကျိုဒေသ, တိုကျို",
      "khName": "តំបន់តូក្យូ, តូក្យូ​",
      "neName": "टोकियो क्षेत्र, टोक्यो महानगरपालिका"
    },
    "class15": {
      "code": "130011",
      "name": "２３区西部",
      "enName": "Western Region of 23 wards"
    },
    "class20": {
      "code": "1311300",
      "name": "渋谷区",
      "enName": "Shibuya City",
      "kana": "しぶやく",
      "chName": "东京涩谷区",
      "zhName": "東京澀穀區",
      "koName": "도쿄 시부야 구",
      "esName": "Distrito Shibuya (Shibuya-ku), Tokio",
      "ptName": "Tóquio, bairro de Shibuya",
      "thName": "เมืองชิบุยะ โตเกียว",
      "viName": "thành phố Shibuya, Tokyo",
      "inName": "Distrik Kota Shibuya, Tokyo",
      "tlName": "siyudad ng Shibuya, Tokyo",
      "moName": "Токио Шибүя дүүрэг",
      "buName": "တိုကျိုရှိဘုယမြို့",
      "khName": "សង្កាត់ស៊ីប៊ូយ៉ា តូក្យូ​",
      "neName": "टोक्यो सिबुया सहर"
    }
  },
  "1311400": {
    "office": {
      "code": "130000",
      "name": "東京都",
      "enName": "Tokyo",
      "officeName": "気象庁",
      "chName": "东京都",
      "zhName": "東京都",
      "koName": "도쿄도",
      "esName": "Prefectura de Tokio",
      "ptName": "Metrópole de Tóquio (Tōkyō)",
      "thName": "กรุงโตเกียว",
      "viName": "Thủ đô Tokyo",
      "inName": "Ibu Kota Tokyo",
      "tlName": "Tokyo Metropolis",
      "moName": "Токио",
      "buName": "တိုကျို",
      "khName": "តូក្យូ​",
      "neName": "टोक्यो महानगरपालिका"
    },
    "class10": {
      "code": "130010",
      "name": "東京地方",
      "enName": "Tokyo Region",
      "chName": "東京地區, 東京都",
      "zhName": "东京地区, 東京都",
      "koName": "도쿄 지방, 도쿄도",
      "esName": "Región de Tokio, Prefectura de Tokio",
      "ptName": "Região de Tóquio, Metrópole de Tóquio (Tōkyō)",
      "thName": "ภูมิภาคโตเกียว, กรุงโตเกียว",
      "viName": "khu vực Tokyo, Thủ đô Tokyo",
      "inName": "wilayah Tokyo, Ibu Kota Tokyo",
      "tlName": "Rehiyon ng Tokyo, Tokyo Metropolis",
      "moName": "Токио бүс, Токио",
      "buName": "တိုကျိုဒေသ, တိုကျို",
      "khName": "តំបន់តូក្យូ, តូក្យូ​",
      "neName": "टोकियो क्षेत्र, टोक्यो महानगरपालिका"
    },
    "class15": {
      "code": "130011",
      "name": "２３区西部",
      "enName": "Western Region of 23 wards"
    },
    "class20": {
      "code": "1311400",
      "name": "中野区",
      "enName": "Nakano City",
      "kana": "なかのく",
      "chName": "东京中野区",
      "zhName": "東京中野區",
      "koName": "도쿄 나카노 구",
      "esName": "Distrito Nakano (Nakano-ku), Tokio",
      "ptName": "Tóquio, bairro de Nakano",
      "thName": "เมืองนากาโนะ โตเกียว",
      "viName": "thành phố Nakano, Tokyo",
      "inName": "Distrik Kota Nakano, Tokyo",
      "tlName": "siyudad ng Nakano, Tokyo",
      "moName": "Токио Накано дүүрэг",
      "buName": "တိုကျိုနကနိုမြို့",
      "khName": "សង្កាត់ណាកាណូ តូក្យូ​",
      "neName": "टोक्यो नाकानो सहर"
    }
  },
  "1311500": {
    "office": {
      "code": "130000",
      "name": "東京都",
      "enName": "Tokyo",
      "officeName": "気象庁",
      "chName": "东京都",
      "zhName": "東京都",
      "koName": "도쿄도",
      "esName": "Prefectura de Tokio",
      "ptName": "Metrópole de Tóquio (Tōkyō)",
      "thName": "กรุงโตเกียว",
      "viName": "Thủ đô Tokyo",
      "inName": "Ibu Kota Tokyo",
      "tlName": "Tokyo Metropolis",
      "moName": "Токио",
      "buName": "တိုကျို",
      "khName": "តូក្យូ​",
      "neName": "टोक्यो महानगरपालिका"
    },
    "class10": {
      "code": "130010",
      "name": "東京地方",
      "enName": "Tokyo Region",
      "chName": "東京地區, 東京都",
      "zhName": "东京地区, 東京都",
      "koName": "도쿄 지방, 도쿄도",
      "esName": "Región de Tokio, Prefectura de Tokio",
      "ptName": "Região de Tóquio, Metrópole de Tóquio (Tōkyō)",
      "thName": "ภูมิภาคโตเกียว, กรุงโตเกียว",
      "viName": "khu vực Tokyo, Thủ đô Tokyo",
      "inName": "wilayah Tokyo, Ibu Kota Tokyo",
      "tlName": "Rehiyon ng Tokyo, Tokyo Metropolis",
      "moName": "Токио бүс, Токио",
      "buName": "တိုကျိုဒေသ, တိုကျို",
      "khName": "តំបន់តូក្យូ, តូក្យូ​",
      "neName": "टोकियो क्षेत्र, टोक्यो महानगरपालिका"
    },
    "class15": {
      "code": "130011",
      "name": "２３区西部",
      "enName": "Western Region of 23 wards"
    },
    "class20": {
      "code": "1311500",
      "name": "杉並区",
      "enName": "Suginami City",
      "kana": "すぎなみく",
      "chName": "东京杉并区",
      "zhName": "東京杉並區",
      "koName": "도쿄 스기나미 구",
      "esName": "Distrito Suginami (Suginami-ku), Tokio",
      "ptName": "Tóquio, bairro de Suginami",
      "thName": "เมืองซูกินามิ โตเกียว",
      "viName": "thành phố Suginami, Tokyo",
      "inName": "Distrik Kota Suginami, Tokyo",
      "tlName": "siyudad ng Suginami, Tokyo",
      "moName": "Токио Сүгинами дүүрэг",
      "buName": "တိုကျိုဆုဂိနမိမြို့",
      "khName": "សង្កាត់ស៊ូគីណាមិ តូក្យូ​",
      "neName": "टोक्यो सुगिनामी सहर"
    }
  },
  "1311600": {
    "office": {
      "code": "130000",
      "name": "東京都",
      "enName": "Tokyo",
      "officeName": "気象庁",
      "chName": "东京都",
      "zhName": "東京都",
      "koName": "도쿄도",
      "esName": "Prefectura de Tokio",
      "ptName": "Metrópole de Tóquio (Tōkyō)",
      "thName": "กรุงโตเกียว",
      "viName": "Thủ đô Tokyo",
      "inName": "Ibu Kota Tokyo",
      "tlName": "Tokyo Metropolis",
      "moName": "Токио",
      "buName": "တိုကျို",
      "khName": "តូក្យូ​",
      "neName": "टोक्यो महानगरपालिका"
    },
    "class10": {
      "code": "130010",
      "name": "東京地方",
      "enName": "Tokyo Region",
      "chName": "東京地區, 東京都",
      "zhName": "东京地区, 東京都",
      "koName": "도쿄 지방, 도쿄도",
      "esName": "Región de Tokio, Prefectura de Tokio",
      "ptName": "Região de Tóquio, Metrópole de Tóquio (Tōkyō)",
      "thName": "ภูมิภาคโตเกียว, กรุงโตเกียว",
      "viName": "khu vực Tokyo, Thủ đô Tokyo",
      "inName": "wilayah Tokyo, Ibu Kota Tokyo",
      "tlName": "Rehiyon ng Tokyo, Tokyo Metropolis",
      "moName": "Токио бүс, Токио",
      "buName": "တိုကျိုဒေသ, တိုကျို",
      "khName": "តំបន់តូក្យូ, តូក្យូ​",
      "neName": "टोकियो क्षेत्र, टोक्यो महानगरपालिका"
    },
    "class15": {
      "code": "130011",
      "name": "２３区西部",
      "enName": "Western Region of 23 wards"
    },
    "class20": {
      "code": "1311600",
      "name": "豊島区",
      "enName": "Toshima City",
      "kana": "としまく",
      "chName": "东京丰岛区",
      "zhName": "東京豐島區",
      "koName": "도쿄 도시마 구",
      "esName": "Distrito Toshima (Toshima-ku), Tokio",
      "ptName": "Tóquio, bairro de Toshima",
      "thName": "เมืองโทชิมะ โตเกียว",
      "viName": "thành phố Toshima, Tokyo",
      "inName": "Distrik Kota Toshima, Tokyo",
      "tlName": "siyudad ng Toshima, Tokyo",
      "moName": "Токио Тошима дүүрэг",
      "buName": "တိုကျိုတိုရှိမမြို့",
      "khName": "សង្កាត់តូស៊ីម៉ា តូក្យូ​",
      "neName": "टोक्यो तोशिमा सहर"
    }
  },
  "1311700": {
    "office": {
      "code": "130000",
      "name": "東京都",
      "enName": "Tokyo",
      "officeName": "気象庁",
      "chName": "东京都",
      "zhName": "東京都",
      "koName": "도쿄도",
      "esName": "Prefectura de Tokio",
      "ptName": "Metrópole de Tóquio (Tōkyō)",
      "thName": "กรุงโตเกียว",
      "viName": "Thủ đô Tokyo",
      "inName": "Ibu Kota Tokyo",
      "tlName": "Tokyo Metropolis",
      "moName": "Токио",
      "buName": "တိုကျို",
      "khName": "តូក្យូ​",
      "neName": "टोक्यो महानगरपालिका"
    },
    "class10": {
      "code": "130010",
      "name": "東京地方",
      "enName": "Tokyo Region",
      "chName": "東京地區, 東京都",
      "zhName": "东京地区, 東京都",
      "koName": "도쿄 지방, 도쿄도",
      "esName": "Región de Tokio, Prefectura de Tokio",
      "ptName": "Região de Tóquio, Metrópole de Tóquio (Tōkyō)",
      "thName": "ภูมิภาคโตเกียว, กรุงโตเกียว",
      "viName": "khu vực Tokyo, Thủ đô Tokyo",
      "inName": "wilayah Tokyo, Ibu Kota Tokyo",
      "tlName": "Rehiyon ng Tokyo, Tokyo Metropolis",
      "moName": "Токио бүс, Токио",
      "buName": "တိုကျိုဒေသ, တိုကျို",
      "khName": "តំបន់តូក្យូ, តូក្យូ​",
      "neName": "टोकियो क्षेत्र, टोक्यो महानगरपालिका"
    },
    "class15": {
      "code": "130011",
      "name": "２３区西部",
      "enName": "Western Region of 23 wards"
    },
    "class20": {
      "code": "1311700",
      "name": "北区",
      "enName": "Kita City",
      "kana": "きたく",
      "chName": "东京北区",
      "zhName": "東京北區",
      "koName": "도쿄 기타 구",
      "esName": "Distrito Kita (Kita-ku), Tokio",
      "ptName": "Tóquio, bairro de Kita",
      "thName": "เมืองคิตะ โตเกียว",
      "viName": "thành phố Kita, Tokyo",
      "inName": "Distrik Kota Kita, Tokyo",
      "tlName": "siyudad ng Kita, Tokyo",
      "moName": "Токио Кита дүүрэг",
      "buName": "တိုကျိုခိတမြို့",
      "khName": "សង្កាត់គីតា តូក្យូ​",
      "neName": "टोक्यो किता सहर"
    }
  },
  "1311800": {
    "office": {
      "code": "130000",
      "name": "東京都",
      "enName": "Tokyo",
      "officeName": "気象庁",
      "chName": "东京都",
      "zhName": "東京都",
      "koName": "도쿄도",
      "esName": "Prefectura de Tokio",
      "ptName": "Metrópole de Tóquio (Tōkyō)",
      "thName": "กรุงโตเกียว",
      "viName": "Thủ đô Tokyo",
      "inName": "Ibu Kota Tokyo",
      "tlName": "Tokyo Metropolis",
      "moName": "Токио",
      "buName": "တိုကျို",
      "khName": "តូក្យូ​",
      "neName": "टोक्यो महानगरपालिका"
    },
    "class10": {
      "code": "130010",
      "name": "東京地方",
      "enName": "Tokyo Region",
      "chName": "東京地區, 東京都",
      "zhName": "东京地区, 東京都",
      "koName": "도쿄 지방, 도쿄도",
      "esName": "Región de Tokio, Prefectura de Tokio",
      "ptName": "Região de Tóquio, Metrópole de Tóquio (Tōkyō)",
      "thName": "ภูมิภาคโตเกียว, กรุงโตเกียว",
      "viName": "khu vực Tokyo, Thủ đô Tokyo",
      "inName": "wilayah Tokyo, Ibu Kota Tokyo",
      "tlName": "Rehiyon ng Tokyo, Tokyo Metropolis",
      "moName": "Токио бүс, Токио",
      "buName": "တိုကျိုဒေသ, တိုကျို",
      "khName": "តំបន់តូក្យូ, តូក្យូ​",
      "neName": "टोकियो क्षेत्र, टोक्यो महानगरपालिका"
    },
    "class15": {
      "code": "130012",
      "name": "２３区東部",
      "enName": "Eastern Region of 23 wards"
    },
    "class20": {
      "code": "1311800",
      "name": "荒川区",
      "enName": "Arakawa City",
      "kana": "あらかわく",
      "chName": "东京荒川区",
      "zhName": "東京荒川區",
      "koName": "도쿄 아라카와 구",
      "esName": "Distrito Arakawa (Arakawa-ku), Tokio",
      "ptName": "Tóquio, bairro de Arakawa",
      "thName": "เมืองอารากาวะ โตเกียว",
      "viName": "thành phố Arakawa, Tokyo",
      "inName": "Distrik Kota Arakawa, Tokyo",
      "tlName": "siyudad ng Arakawa, Tokyo",
      "moName": "Токио Аракава дүүрэг",
      "buName": "တိုကျိုအယကဝမြို့",
      "khName": "សង្កាត់អារ៉ាកាវ៉ា តូក្យូ​",
      "neName": "टोक्यो आराकावा सहर"
    }
  },
  "1311900": {
    "office": {
      "code": "130000",
      "name": "東京都",
      "enName": "Tokyo",
      "officeName": "気象庁",
      "chName": "东京都",
      "zhName": "東京都",
      "koName": "도쿄도",
      "esName": "Prefectura de Tokio",
      "ptName": "Metrópole de Tóquio (Tōkyō)",
      "thName": "กรุงโตเกียว",
      "viName": "Thủ đô Tokyo",
      "inName": "Ibu Kota Tokyo",
      "tlName": "Tokyo Metropolis",
      "moName": "Токио",
      "buName": "တိုကျို",
      "khName": "តូក្យូ​",
      "neName": "टोक्यो महानगरपालिका"
    },
    "class10": {
      "code": "130010",
      "name": "東京地方",
      "enName": "Tokyo Region",
      "chName": "東京地區, 東京都",
      "zhName": "东京地区, 東京都",
      "koName": "도쿄 지방, 도쿄도",
      "esName": "Región de Tokio, Prefectura de Tokio",
      "ptName": "Região de Tóquio, Metrópole de Tóquio (Tōkyō)",
      "thName": "ภูมิภาคโตเกียว, กรุงโตเกียว",
      "viName": "khu vực Tokyo, Thủ đô Tokyo",
      "inName": "wilayah Tokyo, Ibu Kota Tokyo",
      "tlName": "Rehiyon ng Tokyo, Tokyo Metropolis",
      "moName": "Токио бүс, Токио",
      "buName": "တိုကျိုဒေသ, တိုကျို",
      "khName": "តំបន់តូក្យូ, តូក្យូ​",
      "neName": "टोकियो क्षेत्र, टोक्यो महानगरपालिका"
    },
    "class15": {
      "code": "130011",
      "name": "２３区西部",
      "enName": "Western Region of 23 wards"
    },
    "class20": {
      "code": "1311900",
      "name": "板橋区",
      "enName": "Itabashi City",
      "kana": "いたばしく",
      "chName": "东京板桥区",
      "zhName": "東京板橋區",
      "koName": "도쿄 이타바시 구",
      "esName": "Distrito Itabashi (Itabashi-ku), Tokio",
      "ptName": "Tóquio, bairro de Itabashi",
      "thName": "เมืองอิตะบาชิ โตเกียว",
      "viName": "thành phố Itabashi, Tokyo",
      "inName": "Distrik Kota Itabashi, Tokyo",
      "tlName": "siyudad ng Itabashi, Tokyo",
      "moName": "Токио Итабаши дүүрэг",
      "buName": "တိုကျိုအိတဘရှိမြို့",
      "khName": "សង្កាត់អ៊ីតាបាស៊ី តូក្យូ​",
      "neName": "टोक्यो इताबाशि सहर"
    }
  },
  "1312000": {
    "office": {
      "code": "130000",
      "name": "東京都",
      "enName": "Tokyo",
      "officeName": "気象庁",
      "chName": "东京都",
      "zhName": "東京都",
      "koName": "도쿄도",
      "esName": "Prefectura de Tokio",
      "ptName": "Metrópole de Tóquio (Tōkyō)",
      "thName": "กรุงโตเกียว",
      "viName": "Thủ đô Tokyo",
      "inName": "Ibu Kota Tokyo",
      "tlName": "Tokyo Metropolis",
      "moName": "Токио",
      "buName": "တိုကျို",
      "khName": "តូក្យូ​",
      "neName": "टोक्यो महानगरपालिका"
    },
    "class10": {
      "code": "130010",
      "name": "東京地方",
      "enName": "Tokyo Region",
      "chName": "東京地區, 東京都",
      "zhName": "东京地区, 東京都",
      "koName": "도쿄 지방, 도쿄도",
      "esName": "Región de Tokio, Prefectura de Tokio",
      "ptName": "Região de Tóquio, Metrópole de Tóquio (Tōkyō)",
      "thName": "ภูมิภาคโตเกียว, กรุงโตเกียว",
      "viName": "khu vực Tokyo, Thủ đô Tokyo",
      "inName": "wilayah Tokyo, Ibu Kota Tokyo",
      "tlName": "Rehiyon ng Tokyo, Tokyo Metropolis",
      "moName": "Токио бүс, Токио",
      "buName": "တိုကျိုဒေသ, တိုကျို",
      "khName": "តំបន់តូក្យូ, តូក្យូ​",
      "neName": "टोकियो क्षेत्र, टोक्यो महानगरपालिका"
    },
    "class15": {
      "code": "130011",
      "name": "２３区西部",
      "enName": "Western Region of 23 wards"
    },
    "class20": {
      "code": "1312000",
      "name": "練馬区",
      "enName": "Nerima City",
      "kana": "ねりまく",
      "chName": "东京练马区",
      "zhName": "東京練馬區",
      "koName": "도쿄 네리마 구",
      "esName": "Distrito Nerima (Nerima-ku), Tokio",
      "ptName": "Tóquio, bairro de Nerima",
      "thName": "เมืองเนริมะ โตเกียว",
      "viName": "thành phố Nerima, Tokyo",
      "inName": "Distrik Kota Nerima, Tokyo",
      "tlName": "siyudad ng Nerima, Tokyo",
      "moName": "Токио Нэрима дүүрэг",
      "buName": "တိုကျိုနဲယိမမြို့",
      "khName": "សង្កាត់ណឺរីម៉ា តូក្យូ​",
      "neName": "टोक्यो नेरिमा सहर"
    }
  },
  "1312100": {
    "office": {
      "code": "130000",
      "name": "東京都",
      "enName": "Tokyo",
      "officeName": "気象庁",
      "chName": "东京都",
      "zhName": "東京都",
      "koName": "도쿄도",
      "esName": "Prefectura de Tokio",
      "ptName": "Metrópole de Tóquio (Tōkyō)",
      "thName": "กรุงโตเกียว",
      "viName": "Thủ đô Tokyo",
      "inName": "Ibu Kota Tokyo",
      "tlName": "Tokyo Metropolis",
      "moName": "Токио",
      "buName": "တိုကျို",
      "khName": "តូក្យូ​",
      "neName": "टोक्यो महानगरपालिका"
    },
    "class10": {
      "code": "130010",
      "name": "東京地方",
      "enName": "Tokyo Region",
      "chName": "東京地區, 東京都",
      "zhName": "东京地区, 東京都",
      "koName": "도쿄 지방, 도쿄도",
      "esName": "Región de Tokio, Prefectura de Tokio",
      "ptName": "Região de Tóquio, Metrópole de Tóquio (Tōkyō)",
      "thName": "ภูมิภาคโตเกียว, กรุงโตเกียว",
      "viName": "khu vực Tokyo, Thủ đô Tokyo",
      "inName": "wilayah Tokyo, Ibu Kota Tokyo",
      "tlName": "Rehiyon ng Tokyo, Tokyo Metropolis",
      "moName": "Токио бүс, Токио",
      "buName": "တိုကျိုဒေသ, တိုကျို",
      "khName": "តំបន់តូក្យូ, តូក្យូ​",
      "neName": "टोकियो क्षेत्र, टोक्यो महानगरपालिका"
    },
    "class15": {
      "code": "130012",
      "name": "２３区東部",
      "enName": "Eastern Region of 23 wards"
    },
    "class20": {
      "code": "1312100",
      "name": "足立区",
      "enName": "Adachi City",
      "kana": "あだちく",
      "chName": "东京足立区",
      "zhName": "東京足立區",
      "koName": "도쿄 아다치 구",
      "esName": "Distrito Adachi (Adachi-ku), Tokio",
      "ptName": "Tóquio, bairro de Adachi",
      "thName": "เมืองอาดาจิ โตเกียว",
      "viName": "thành phố Adachi, Tokyo",
      "inName": "Distrik Kota Adachi, Tokyo",
      "tlName": "siyudad ng Adachi, Tokyo",
      "moName": "Токио Адачикү дүүрэг",
      "buName": "တိုကျိုအဒချိမြို့",
      "khName": "សង្កាត់អាដាជី តូក្យូ​",
      "neName": "टोक्यो आदाची सहर"
    }
  },
  "1312200": {
    "office": {
      "code": "130000",
      "name": "東京都",
      "enName": "Tokyo",
      "officeName": "気象庁",
      "chName": "东京都",
      "zhName": "東京都",
      "koName": "도쿄도",
      "esName": "Prefectura de Tokio",
      "ptName": "Metrópole de Tóquio (Tōkyō)",
      "thName": "กรุงโตเกียว",
      "viName": "Thủ đô Tokyo",
      "inName": "Ibu Kota Tokyo",
      "tlName": "Tokyo Metropolis",
      "moName": "Токио",
      "buName": "တိုကျို",
      "khName": "តូក្យូ​",
      "neName": "टोक्यो महानगरपालिका"
    },
    "class10": {
      "code": "130010",
      "name": "東京地方",
      "enName": "Tokyo Region",
      "chName": "東京地區, 東京都",
      "zhName": "东京地区, 東京都",
      "koName": "도쿄 지방, 도쿄도",
      "esName": "Región de Tokio, Prefectura de Tokio",
      "ptName": "Região de Tóquio, Metrópole de Tóquio (Tōkyō)",
      "thName": "ภูมิภาคโตเกียว, กรุงโตเกียว",
      "viName": "khu vực Tokyo, Thủ đô Tokyo",
      "inName": "wilayah Tokyo, Ibu Kota Tokyo",
      "tlName": "Rehiyon ng Tokyo, Tokyo Metropolis",
      "moName": "Токио бүс, Токио",
      "buName": "တိုကျိုဒေသ, တိုကျို",
      "khName": "តំបន់តូក្យូ, តូក្យូ​",
      "neName": "टोकियो क्षेत्र, टोक्यो महानगरपालिका"
    },
    "class15": {
      "code": "130012",
      "name": "２３区東部",
      "enName": "Eastern Region of 23 wards"
    },
    "class20": {
      "code": "1312200",
      "name": "葛飾区",
      "enName": "Katsushika City",
      "kana": "かつしかく",
      "chName": "东京葛饰区",
      "zhName": "東京葛飾區",
      "koName": "도쿄 가쓰시카 구",
      "esName": "Distrito Katsushika (Katsushika-ku), Tokio",
      "ptName": "Tóquio, bairro de Katsushika",
      "thName": "เมืองคัทสึชิกะ โตเกียว",
      "viName": "thành phố Katsushika, Tokyo",
      "inName": "Distrik Kota Katsushika, Tokyo",
      "tlName": "siyudad ng Katsushika, Tokyo",
      "moName": "Токио Кацүшика дүүрэг",
      "buName": "တိုကျိုကဆုရှိကမြို့",
      "khName": "សង្កាត់កាតស៊ូស៊ីកា តូក្យូ​",
      "neName": "टोक्यो कात्सुशिका सहर"
    }
  },
  "1312300": {
    "office": {
      "code": "130000",
      "name": "東京都",
      "enName": "Tokyo",
      "officeName": "気象庁",
      "chName": "东京都",
      "zhName": "東京都",
      "koName": "도쿄도",
      "esName": "Prefectura de Tokio",
      "ptName": "Metrópole de Tóquio (Tōkyō)",
      "thName": "กรุงโตเกียว",
      "viName": "Thủ đô Tokyo",
      "inName": "Ibu Kota Tokyo",
      "tlName": "Tokyo Metropolis",
      "moName": "Токио",
      "buName": "တိုကျို",
      "khName": "តូក្យូ​",
      "neName": "टोक्यो महानगरपालिका"
    },
    "class10": {
      "code": "130010",
      "name": "東京地方",
      "enName": "Tokyo Region",
      "chName": "東京地區, 東京都",
      "zhName": "东京地区, 東京都",
      "koName": "도쿄 지방, 도쿄도",
      "esName": "Región de Tokio, Prefectura de Tokio",
      "ptName": "Região de Tóquio, Metrópole de Tóquio (Tōkyō)",
      "thName": "ภูมิภาคโตเกียว, กรุงโตเกียว",
      "viName": "khu vực Tokyo, Thủ đô Tokyo",
      "inName": "wilayah Tokyo, Ibu Kota Tokyo",
      "tlName": "Rehiyon ng Tokyo, Tokyo Metropolis",
      "moName": "Токио бүс, Токио",
      "buName": "တိုကျိုဒေသ, တိုကျို",
      "khName": "តំបន់តូក្យូ, តូក្យូ​",
      "neName": "टोकियो क्षेत्र, टोक्यो महानगरपालिका"
    },
    "class15": {
      "code": "130012",
      "name": "２３区東部",
      "enName": "Eastern Region of 23 wards"
    },
    "class20": {
      "code": "1312300",
      "name": "江戸川区",
      "enName": "Edogawa City",
      "kana": "えどがわく",
      "chName": "东京江户川区",
      "zhName": "東京江戶川區",
      "koName": "도쿄 에도가와 구",
      "esName": "Distrito Edogawa (Edogawa-ku), Tokio",
      "ptName": "Tóquio, bairro de Edogawa",
      "thName": "เมืองเอโดงาวะ โตเกียว",
      "viName": "thành phố Edogawa, Tokyo",
      "inName": "Distrik Kota Edogawa, Tokyo",
      "tlName": "siyudad ng Edogawa, Tokyo",
      "moName": "Токио Эдогава дүүрэг",
      "buName": "တိုကျိုအဲဒိုဂဝမြို့",
      "khName": "សង្កាត់អេដូហ្គាវ៉ា តូក្យូ​",
      "neName": "टोक्यो एदोगावा सहर"
    }
  },
  "1320100": {
    "office": {
      "code": "130000",
      "name": "東京都",
      "enName": "Tokyo",
      "officeName": "気象庁",
      "chName": "东京都",
      "zhName": "東京都",
      "koName": "도쿄도",
      "esName": "Prefectura de Tokio",
      "ptName": "Metrópole de Tóquio (Tōkyō)",
      "thName": "กรุงโตเกียว",
      "viName": "Thủ đô Tokyo",
      "inName": "Ibu Kota Tokyo",
      "tlName": "Tokyo Metropolis",
      "moName": "Токио",
      "buName": "တိုကျို",
      "khName": "តូក្យូ​",
      "neName": "टोक्यो महानगरपालिका"
    },
    "class10": {
      "code": "130010",
      "name": "東京地方",
      "enName": "Tokyo Region",
      "chName": "東京地區, 東京都",
      "zhName": "东京地区, 東京都",
      "koName": "도쿄 지방, 도쿄도",
      "esName": "Región de Tokio, Prefectura de Tokio",
      "ptName": "Região de Tóquio, Metrópole de Tóquio (Tōkyō)",
      "thName": "ภูมิภาคโตเกียว, กรุงโตเกียว",
      "viName": "khu vực Tokyo, Thủ đô Tokyo",
      "inName": "wilayah Tokyo, Ibu Kota Tokyo",
      "tlName": "Rehiyon ng Tokyo, Tokyo Metropolis",
      "moName": "Токио бүс, Токио",
      "buName": "တိုကျိုဒေသ, တိုကျို",
      "khName": "តំបន់តូក្យូ, តូក្យូ​",
      "neName": "टोकियो क्षेत्र, टोक्यो महानगरपालिका"
    },
    "class15": {
      "code": "130015",
      "name": "多摩南部",
      "enName": "Southern Tama"
    },
    "class20": {
      "code": "1320100",
      "name": "八王子市",
      "enName": "Hachioji City",
      "kana": "はちおうじし",
      "chName": "八王子市",
      "zhName": "八王子市",
      "koName": "하치오지 시",
      "esName": "Ciudad de Hachioji",
      "ptName": "cidade de Hachioji",
      "thName": "เมืองฮัทจิโอจิ",
      "viName": "thành phố Hachioji",
      "inName": "kota Hachioji",
      "tlName": "siyudad ng Hachioji",
      "moName": "Хaчиожи хот",
      "buName": "ဟာကျိယိုးဂျိ မြို့",
      "khName": "ទីក្រុង ហាជីអូជី",
      "neName": "हाचियोजी सहर"
    }
  },
  "1320200": {
    "office": {
      "code": "130000",
      "name": "東京都",
      "enName": "Tokyo",
      "officeName": "気象庁",
      "chName": "东京都",
      "zhName": "東京都",
      "koName": "도쿄도",
      "esName": "Prefectura de Tokio",
      "ptName": "Metrópole de Tóquio (Tōkyō)",
      "thName": "กรุงโตเกียว",
      "viName": "Thủ đô Tokyo",
      "inName": "Ibu Kota Tokyo",
      "tlName": "Tokyo Metropolis",
      "moName": "Токио",
      "buName": "တိုကျို",
      "khName": "តូក្យូ​",
      "neName": "टोक्यो महानगरपालिका"
    },
    "class10": {
      "code": "130010",
      "name": "東京地方",
      "enName": "Tokyo Region",
      "chName": "東京地區, 東京都",
      "zhName": "东京地区, 東京都",
      "koName": "도쿄 지방, 도쿄도",
      "esName": "Región de Tokio, Prefectura de Tokio",
      "ptName": "Região de Tóquio, Metrópole de Tóquio (Tōkyō)",
      "thName": "ภูมิภาคโตเกียว, กรุงโตเกียว",
      "viName": "khu vực Tokyo, Thủ đô Tokyo",
      "inName": "wilayah Tokyo, Ibu Kota Tokyo",
      "tlName": "Rehiyon ng Tokyo, Tokyo Metropolis",
      "moName": "Токио бүс, Токио",
      "buName": "တိုကျိုဒေသ, တိုကျို",
      "khName": "តំបន់តូក្យូ, តូក្យូ​",
      "neName": "टोकियो क्षेत्र, टोक्यो महानगरपालिका"
    },
    "class15": {
      "code": "130013",
      "name": "多摩北部",
      "enName": "Northern Tama"
    },
    "class20": {
      "code": "1320200",
      "name": "立川市",
      "enName": "Tachikawa City",
      "kana": "たちかわし",
      "chName": "立川市",
      "zhName": "立川市",
      "koName": "다치카와 시",
      "esName": "Ciudad de Tachikawa",
      "ptName": "cidade de Tachikawa",
      "thName": "เมืองทาจิคาวา",
      "viName": "thành phố Tachikawa",
      "inName": "kota Tachikawa",
      "tlName": "siyudad ng Tachikawa",
      "moName": "Тачикава хот",
      "buName": "တာကျိကာ့ဝ မြို့",
      "khName": "ទីក្រុង តាឈីកាវ៉ា",
      "neName": "ताचिकावा सहर"
    }
  },
  "1320300": {
    "office": {
      "code": "130000",
      "name": "東京都",
      "enName": "Tokyo",
      "officeName": "気象庁",
      "chName": "东京都",
      "zhName": "東京都",
      "koName": "도쿄도",
      "esName": "Prefectura de Tokio",
      "ptName": "Metrópole de Tóquio (Tōkyō)",
      "thName": "กรุงโตเกียว",
      "viName": "Thủ đô Tokyo",
      "inName": "Ibu Kota Tokyo",
      "tlName": "Tokyo Metropolis",
      "moName": "Токио",
      "buName": "တိုကျို",
      "khName": "តូក្យូ​",
      "neName": "टोक्यो महानगरपालिका"
    },
    "class10": {
      "code": "130010",
      "name": "東京地方",
      "enName": "Tokyo Region",
      "chName": "東京地區, 東京都",
      "zhName": "东京地区, 東京都",
      "koName": "도쿄 지방, 도쿄도",
      "esName": "Región de Tokio, Prefectura de Tokio",
      "ptName": "Região de Tóquio, Metrópole de Tóquio (Tōkyō)",
      "thName": "ภูมิภาคโตเกียว, กรุงโตเกียว",
      "viName": "khu vực Tokyo, Thủ đô Tokyo",
      "inName": "wilayah Tokyo, Ibu Kota Tokyo",
      "tlName": "Rehiyon ng Tokyo, Tokyo Metropolis",
      "moName": "Токио бүс, Токио",
      "buName": "တိုကျိုဒေသ, တိုကျို",
      "khName": "តំបន់តូក្យូ, តូក្យូ​",
      "neName": "टोकियो क्षेत्र, टोक्यो महानगरपालिका"
    },
    "class15": {
      "code": "130013",
      "name": "多摩北部",
      "enName": "Northern Tama"
    },
    "class20": {
      "code": "1320300",
      "name": "武蔵野市",
      "enName": "Musashino City",
      "kana": "むさしのし",
      "chName": "武藏野市",
      "zhName": "武藏野市",
      "koName": "무사시노 시",
      "esName": "Ciudad de Musashino",
      "ptName": "cidade de Musashino",
      "thName": "เมืองมาซะชิโนะ",
      "viName": "thành phố Musashino",
      "inName": "kota Musashino",
      "tlName": "siyudad ng Musashino",
      "moName": "Мүсaшино хот",
      "buName": "မူဆာ့ရှီနို မြို့",
      "khName": "ទីក្រុង មូសាស៊ីណូ",
      "neName": "मुसाशिनो सहर"
    }
  },
  "1320400": {
    "office": {
      "code": "130000",
      "name": "東京都",
      "enName": "Tokyo",
      "officeName": "気象庁",
      "chName": "东京都",
      "zhName": "東京都",
      "koName": "도쿄도",
      "esName": "Prefectura de Tokio",
      "ptName": "Metrópole de Tóquio (Tōkyō)",
      "thName": "กรุงโตเกียว",
      "viName": "Thủ đô Tokyo",
      "inName": "Ibu Kota Tokyo",
      "tlName": "Tokyo Metropolis",
      "moName": "Токио",
      "buName": "တိုကျို",
      "khName": "តូក្យូ​",
      "neName": "टोक्यो महानगरपालिका"
    },
    "class10": {
      "code": "130010",
      "name": "東京地方",
      "enName": "Tokyo Region",
      "chName": "東京地區, 東京都",
      "zhName": "东京地区, 東京都",
      "koName": "도쿄 지방, 도쿄도",
      "esName": "Región de Tokio, Prefectura de Tokio",
      "ptName": "Região de Tóquio, Metrópole de Tóquio (Tōkyō)",
      "thName": "ภูมิภาคโตเกียว, กรุงโตเกียว",
      "viName": "khu vực Tokyo, Thủ đô Tokyo",
      "inName": "wilayah Tokyo, Ibu Kota Tokyo",
      "tlName": "Rehiyon ng Tokyo, Tokyo Metropolis",
      "moName": "Токио бүс, Токио",
      "buName": "တိုကျိုဒေသ, တိုကျို",
      "khName": "តំបន់តូក្យូ, តូក្យូ​",
      "neName": "टोकियो क्षेत्र, टोक्यो महानगरपालिका"
    },
    "class15": {
      "code": "130013",
      "name": "多摩北部",
      "enName": "Northern Tama"
    },
    "class20": {
      "code": "1320400",
      "name": "三鷹市",
      "enName": "Mitaka City",
      "kana": "みたかし",
      "chName": "三鹰市",
      "zhName": "三鷹市",
      "koName": "미타카 시",
      "esName": "Ciudad de Mitaka",
      "ptName": "cidade de Mitaka",
      "thName": "เมืองมิทากะ",
      "viName": "thành phố Mitaka",
      "inName": "kota Mitaka",
      "tlName": "siyudad ng Mitaka",
      "moName": "Митака хот",
      "buName": "မိတာ့ကာ မြို့",
      "khName": "ទីក្រុង មីតាកា",
      "neName": "मिताका सहर"
    }
  },
  "1320500": {
    "office": {
      "code": "130000",
      "name": "東京都",
      "enName": "Tokyo",
      "officeName": "気象庁",
      "chName": "东京都",
      "zhName": "東京都",
      "koName": "도쿄도",
      "esName": "Prefectura de Tokio",
      "ptName": "Metrópole de Tóquio (Tōkyō)",
      "thName": "กรุงโตเกียว",
      "viName": "Thủ đô Tokyo",
      "inName": "Ibu Kota Tokyo",
      "tlName": "Tokyo Metropolis",
      "moName": "Токио",
      "buName": "တိုကျို",
      "khName": "តូក្យូ​",
      "neName": "टोक्यो महानगरपालिका"
    },
    "class10": {
      "code": "130010",
      "name": "東京地方",
      "enName": "Tokyo Region",
      "chName": "東京地區, 東京都",
      "zhName": "东京地区, 東京都",
      "koName": "도쿄 지방, 도쿄도",
      "esName": "Región de Tokio, Prefectura de Tokio",
      "ptName": "Região de Tóquio, Metrópole de Tóquio (Tōkyō)",
      "thName": "ภูมิภาคโตเกียว, กรุงโตเกียว",
      "viName": "khu vực Tokyo, Thủ đô Tokyo",
      "inName": "wilayah Tokyo, Ibu Kota Tokyo",
      "tlName": "Rehiyon ng Tokyo, Tokyo Metropolis",
      "moName": "Токио бүс, Токио",
      "buName": "တိုကျိုဒေသ, တိုကျို",
      "khName": "តំបន់តូក្យូ, តូក្យូ​",
      "neName": "टोकियो क्षेत्र, टोक्यो महानगरपालिका"
    },
    "class15": {
      "code": "130014",
      "name": "多摩西部",
      "enName": "Western Tama"
    },
    "class20": {
      "code": "1320500",
      "name": "青梅市",
      "enName": "Ome City",
      "kana": "おうめし",
      "chName": "青梅市",
      "zhName": "青梅市",
      "koName": "오메 시",
      "esName": "Ciudad de Oume",
      "ptName": "cidade de Ome",
      "thName": "เมืองโอเมะ",
      "viName": "thành phố Ome",
      "inName": "kota Ome",
      "tlName": "siyudad ng Ome",
      "moName": "Омэ хот",
      "buName": "အိုးမဲ့ မြို့",
      "khName": "ទីក្រុង អូម",
      "neName": "ओमे सहर"
    }
  },
  "1320600": {
    "office": {
      "code": "130000",
      "name": "東京都",
      "enName": "Tokyo",
      "officeName": "気象庁",
      "chName": "东京都",
      "zhName": "東京都",
      "koName": "도쿄도",
      "esName": "Prefectura de Tokio",
      "ptName": "Metrópole de Tóquio (Tōkyō)",
      "thName": "กรุงโตเกียว",
      "viName": "Thủ đô Tokyo",
      "inName": "Ibu Kota Tokyo",
      "tlName": "Tokyo Metropolis",
      "moName": "Токио",
      "buName": "တိုကျို",
      "khName": "តូក្យូ​",
      "neName": "टोक्यो महानगरपालिका"
    },
    "class10": {
      "code": "130010",
      "name": "東京地方",
      "enName": "Tokyo Region",
      "chName": "東京地區, 東京都",
      "zhName": "东京地区, 東京都",
      "koName": "도쿄 지방, 도쿄도",
      "esName": "Región de Tokio, Prefectura de Tokio",
      "ptName": "Região de Tóquio, Metrópole de Tóquio (Tōkyō)",
      "thName": "ภูมิภาคโตเกียว, กรุงโตเกียว",
      "viName": "khu vực Tokyo, Thủ đô Tokyo",
      "inName": "wilayah Tokyo, Ibu Kota Tokyo",
      "tlName": "Rehiyon ng Tokyo, Tokyo Metropolis",
      "moName": "Токио бүс, Токио",
      "buName": "တိုကျိုဒေသ, တိုကျို",
      "khName": "តំបន់តូក្យូ, តូក្យូ​",
      "neName": "टोकियो क्षेत्र, टोक्यो महानगरपालिका"
    },
    "class15": {
      "code": "130013",
      "name": "多摩北部",
      "enName": "Northern Tama"
    },
    "class20": {
      "code": "1320600",
      "name": "府中市",
      "enName": "Fuchu City",
      "kana": "ふちゅうし",
      "chName": "东京府中市",
      "zhName": "東京府中市",
      "koName": "도쿄 후추 시",
      "esName": "Ciudad de Fuchu, Tokio",
      "ptName": "Tóquio, cidade de Fuchu ",
      "thName": "เมืองฟุชู โตเกียว",
      "viName": "Thành phố Fuchu, Tokyo",
      "inName": "Kota Fuchu, Tokyo",
      "tlName": "siyudad ng Fuchu, Tokyo",
      "moName": "Токио Фүчү хот",
      "buName": "တိုကျိုဟုချူးမြို့",
      "khName": "ទីក្រុងហ្វឹជឺ តូក្យូ​",
      "neName": "टोक्यो फुच्यु सहर"
    }
  },
  "1320700": {
    "office": {
      "code": "130000",
      "name": "東京都",
      "enName": "Tokyo",
      "officeName": "気象庁",
      "chName": "东京都",
      "zhName": "東京都",
      "koName": "도쿄도",
      "esName": "Prefectura de Tokio",
      "ptName": "Metrópole de Tóquio (Tōkyō)",
      "thName": "กรุงโตเกียว",
      "viName": "Thủ đô Tokyo",
      "inName": "Ibu Kota Tokyo",
      "tlName": "Tokyo Metropolis",
      "moName": "Токио",
      "buName": "တိုကျို",
      "khName": "តូក្យូ​",
      "neName": "टोक्यो महानगरपालिका"
    },
    "class10": {
      "code": "130010",
      "name": "東京地方",
      "enName": "Tokyo Region",
      "chName": "東京地區, 東京都",
      "zhName": "东京地区, 東京都",
      "koName": "도쿄 지방, 도쿄도",
      "esName": "Región de Tokio, Prefectura de Tokio",
      "ptName": "Região de Tóquio, Metrópole de Tóquio (Tōkyō)",
      "thName": "ภูมิภาคโตเกียว, กรุงโตเกียว",
      "viName": "khu vực Tokyo, Thủ đô Tokyo",
      "inName": "wilayah Tokyo, Ibu Kota Tokyo",
      "tlName": "Rehiyon ng Tokyo, Tokyo Metropolis",
      "moName": "Токио бүс, Токио",
      "buName": "တိုကျိုဒေသ, တိုကျို",
      "khName": "តំបន់តូក្យូ, តូក្យូ​",
      "neName": "टोकियो क्षेत्र, टोक्यो महानगरपालिका"
    },
    "class15": {
      "code": "130013",
      "name": "多摩北部",
      "enName": "Northern Tama"
    },
    "class20": {
      "code": "1320700",
      "name": "昭島市",
      "enName": "Akishima City",
      "kana": "あきしまし",
      "chName": "昭岛市",
      "zhName": "昭島市",
      "koName": "아키시마 시",
      "esName": "Ciudad de Akishima",
      "ptName": "cidade de Akishima",
      "thName": "เมืองอาคิชิมะ",
      "viName": "thành phố Akishima",
      "inName": "kota Akishima",
      "tlName": "siyudad ng Akishima",
      "moName": "Акишима хот",
      "buName": "အာကိရှိမ မြို့",
      "khName": "ទីក្រុង អាក់គីស៊ីម៉ា",
      "neName": "आकिशिमा सहर"
    }
  },
  "1320800": {
    "office": {
      "code": "130000",
      "name": "東京都",
      "enName": "Tokyo",
      "officeName": "気象庁",
      "chName": "东京都",
      "zhName": "東京都",
      "koName": "도쿄도",
      "esName": "Prefectura de Tokio",
      "ptName": "Metrópole de Tóquio (Tōkyō)",
      "thName": "กรุงโตเกียว",
      "viName": "Thủ đô Tokyo",
      "inName": "Ibu Kota Tokyo",
      "tlName": "Tokyo Metropolis",
      "moName": "Токио",
      "buName": "တိုကျို",
      "khName": "តូក្យូ​",
      "neName": "टोक्यो महानगरपालिका"
    },
    "class10": {
      "code": "130010",
      "name": "東京地方",
      "enName": "Tokyo Region",
      "chName": "東京地區, 東京都",
      "zhName": "东京地区, 東京都",
      "koName": "도쿄 지방, 도쿄도",
      "esName": "Región de Tokio, Prefectura de Tokio",
      "ptName": "Região de Tóquio, Metrópole de Tóquio (Tōkyō)",
      "thName": "ภูมิภาคโตเกียว, กรุงโตเกียว",
      "viName": "khu vực Tokyo, Thủ đô Tokyo",
      "inName": "wilayah Tokyo, Ibu Kota Tokyo",
      "tlName": "Rehiyon ng Tokyo, Tokyo Metropolis",
      "moName": "Токио бүс, Токио",
      "buName": "တိုကျိုဒေသ, တိုကျို",
      "khName": "តំបន់តូក្យូ, តូក្យូ​",
      "neName": "टोकियो क्षेत्र, टोक्यो महानगरपालिका"
    },
    "class15": {
      "code": "130013",
      "name": "多摩北部",
      "enName": "Northern Tama"
    },
    "class20": {
      "code": "1320800",
      "name": "調布市",
      "enName": "Chofu City",
      "kana": "ちょうふし",
      "chName": "调布市",
      "zhName": "調布市",
      "koName": "조후 시",
      "esName": "Ciudad de Chofu",
      "ptName": "cidade de Chofu",
      "thName": "เมืองโชฟุ",
      "viName": "thành phố Chofu",
      "inName": "kota Chofu",
      "tlName": "siyudad ng Chofu",
      "moName": "Чофү хот",
      "buName": "ချိုဖူ မြို့",
      "khName": "ទីក្រុង ជូហ្វូ",
      "neName": "चोफु सहर"
    }
  },
  "1320900": {
    "office": {
      "code": "130000",
      "name": "東京都",
      "enName": "Tokyo",
      "officeName": "気象庁",
      "chName": "东京都",
      "zhName": "東京都",
      "koName": "도쿄도",
      "esName": "Prefectura de Tokio",
      "ptName": "Metrópole de Tóquio (Tōkyō)",
      "thName": "กรุงโตเกียว",
      "viName": "Thủ đô Tokyo",
      "inName": "Ibu Kota Tokyo",
      "tlName": "Tokyo Metropolis",
      "moName": "Токио",
      "buName": "တိုကျို",
      "khName": "តូក្យូ​",
      "neName": "टोक्यो महानगरपालिका"
    },
    "class10": {
      "code": "130010",
      "name": "東京地方",
      "enName": "Tokyo Region",
      "chName": "東京地區, 東京都",
      "zhName": "东京地区, 東京都",
      "koName": "도쿄 지방, 도쿄도",
      "esName": "Región de Tokio, Prefectura de Tokio",
      "ptName": "Região de Tóquio, Metrópole de Tóquio (Tōkyō)",
      "thName": "ภูมิภาคโตเกียว, กรุงโตเกียว",
      "viName": "khu vực Tokyo, Thủ đô Tokyo",
      "inName": "wilayah Tokyo, Ibu Kota Tokyo",
      "tlName": "Rehiyon ng Tokyo, Tokyo Metropolis",
      "moName": "Токио бүс, Токио",
      "buName": "တိုကျိုဒေသ, တိုကျို",
      "khName": "តំបន់តូក្យូ, តូក្យូ​",
      "neName": "टोकियो क्षेत्र, टोक्यो महानगरपालिका"
    },
    "class15": {
      "code": "130015",
      "name": "多摩南部",
      "enName": "Southern Tama"
    },
    "class20": {
      "code": "1320900",
      "name": "町田市",
      "enName": "Machida City",
      "kana": "まちだし",
      "chName": "町田市",
      "zhName": "町田市",
      "koName": "마치다 시",
      "esName": "Ciudad de Machida",
      "ptName": "cidade de Machida",
      "thName": "เมืองมาจิดะ",
      "viName": "thành phố Machida",
      "inName": "kota Machida",
      "tlName": "siyudad ng Machida",
      "moName": "Мачида хот",
      "buName": "မာကျိဒါ့ မြို့",
      "khName": "ទីក្រុង ម៉ាឈីដា",
      "neName": "माचिदा सहर"
    }
  },
  "1321000": {
    "office": {
      "code": "130000",
      "name": "東京都",
      "enName": "Tokyo",
      "officeName": "気象庁",
      "chName": "东京都",
      "zhName": "東京都",
      "koName": "도쿄도",
      "esName": "Prefectura de Tokio",
      "ptName": "Metrópole de Tóquio (Tōkyō)",
      "thName": "กรุงโตเกียว",
      "viName": "Thủ đô Tokyo",
      "inName": "Ibu Kota Tokyo",
      "tlName": "Tokyo Metropolis",
      "moName": "Токио",
      "buName": "တိုကျို",
      "khName": "តូក្យូ​",
      "neName": "टोक्यो महानगरपालिका"
    },
    "class10": {
      "code": "130010",
      "name": "東京地方",
      "enName": "Tokyo Region",
      "chName": "東京地區, 東京都",
      "zhName": "东京地区, 東京都",
      "koName": "도쿄 지방, 도쿄도",
      "esName": "Región de Tokio, Prefectura de Tokio",
      "ptName": "Região de Tóquio, Metrópole de Tóquio (Tōkyō)",
      "thName": "ภูมิภาคโตเกียว, กรุงโตเกียว",
      "viName": "khu vực Tokyo, Thủ đô Tokyo",
      "inName": "wilayah Tokyo, Ibu Kota Tokyo",
      "tlName": "Rehiyon ng Tokyo, Tokyo Metropolis",
      "moName": "Токио бүс, Токио",
      "buName": "တိုကျိုဒေသ, တိုကျို",
      "khName": "តំបន់តូក្យូ, តូក្យូ​",
      "neName": "टोकियो क्षेत्र, टोक्यो महानगरपालिका"
    },
    "class15": {
      "code": "130013",
      "name": "多摩北部",
      "enName": "Northern Tama"
    },
    "class20": {
      "code": "1321000",
      "name": "小金井市",
      "enName": "Koganei City",
      "kana": "こがねいし",
      "chName": "小金井市",
      "zhName": "小金井市",
      "koName": "고가네이 시",
      "esName": "Ciudad de Koganei",
      "ptName": "cidade de Koganei",
      "thName": "เมืองโคงะเนอิ",
      "viName": "thành phố Koganei",
      "inName": "kota Koganei",
      "tlName": "siyudad ng Koganei",
      "moName": "Коганэй хот",
      "buName": "ကိုဂါးနဲ့ယိ မြို့",
      "khName": "ទីក្រុង កូហ្គានី",
      "neName": "कोगानेई सहर"
    }
  },
  "1321100": {
    "office": {
      "code": "130000",
      "name": "東京都",
      "enName": "Tokyo",
      "officeName": "気象庁",
      "chName": "东京都",
      "zhName": "東京都",
      "koName": "도쿄도",
      "esName": "Prefectura de Tokio",
      "ptName": "Metrópole de Tóquio (Tōkyō)",
      "thName": "กรุงโตเกียว",
      "viName": "Thủ đô Tokyo",
      "inName": "Ibu Kota Tokyo",
      "tlName": "Tokyo Metropolis",
      "moName": "Токио",
      "buName": "တိုကျို",
      "khName": "តូក្យូ​",
      "neName": "टोक्यो महानगरपालिका"
    },
    "class10": {
      "code": "130010",
      "name": "東京地方",
      "enName": "Tokyo Region",
      "chName": "東京地區, 東京都",
      "zhName": "东京地区, 東京都",
      "koName": "도쿄 지방, 도쿄도",
      "esName": "Región de Tokio, Prefectura de Tokio",
      "ptName": "Região de Tóquio, Metrópole de Tóquio (Tōkyō)",
      "thName": "ภูมิภาคโตเกียว, กรุงโตเกียว",
      "viName": "khu vực Tokyo, Thủ đô Tokyo",
      "inName": "wilayah Tokyo, Ibu Kota Tokyo",
      "tlName": "Rehiyon ng Tokyo, Tokyo Metropolis",
      "moName": "Токио бүс, Токио",
      "buName": "တိုကျိုဒေသ, တိုကျို",
      "khName": "តំបន់តូក្យូ, តូក្យូ​",
      "neName": "टोकियो क्षेत्र, टोक्यो महानगरपालिका"
    },
    "class15": {
      "code": "130013",
      "name": "多摩北部",
      "enName": "Northern Tama"
    },
    "class20": {
      "code": "1321100",
      "name": "小平市",
      "enName": "Kodaira City",
      "kana": "こだいらし",
      "chName": "小平市",
      "zhName": "小平市",
      "koName": "고다이라 시",
      "esName": "Ciudad de Kodaira",
      "ptName": "cidade de Kodaira",
      "thName": "เมืองโคไดระ",
      "viName": "thành phố Kodaira",
      "inName": "kota Kodaira",
      "tlName": "siyudad ng Kodaira",
      "moName": "Кодайра хот",
      "buName": "ကိုဒါ့ယိရ မြို့",
      "khName": "ទីក្រុង កូដាយរ៉ា",
      "neName": "कोदाइरा सहर"
    }
  },
  "1321200": {
    "office": {
      "code": "130000",
      "name": "東京都",
      "enName": "Tokyo",
      "officeName": "気象庁",
      "chName": "东京都",
      "zhName": "東京都",
      "koName": "도쿄도",
      "esName": "Prefectura de Tokio",
      "ptName": "Metrópole de Tóquio (Tōkyō)",
      "thName": "กรุงโตเกียว",
      "viName": "Thủ đô Tokyo",
      "inName": "Ibu Kota Tokyo",
      "tlName": "Tokyo Metropolis",
      "moName": "Токио",
      "buName": "တိုကျို",
      "khName": "តូក្យូ​",
      "neName": "टोक्यो महानगरपालिका"
    },
    "class10": {
      "code": "130010",
      "name": "東京地方",
      "enName": "Tokyo Region",
      "chName": "東京地區, 東京都",
      "zhName": "东京地区, 東京都",
      "koName": "도쿄 지방, 도쿄도",
      "esName": "Región de Tokio, Prefectura de Tokio",
      "ptName": "Região de Tóquio, Metrópole de Tóquio (Tōkyō)",
      "thName": "ภูมิภาคโตเกียว, กรุงโตเกียว",
      "viName": "khu vực Tokyo, Thủ đô Tokyo",
      "inName": "wilayah Tokyo, Ibu Kota Tokyo",
      "tlName": "Rehiyon ng Tokyo, Tokyo Metropolis",
      "moName": "Токио бүс, Токио",
      "buName": "တိုကျိုဒေသ, တိုကျို",
      "khName": "តំបន់តូក្យូ, តូក្យូ​",
      "neName": "टोकियो क्षेत्र, टोक्यो महानगरपालिका"
    },
    "class15": {
      "code": "130015",
      "name": "多摩南部",
      "enName": "Southern Tama"
    },
    "class20": {
      "code": "1321200",
      "name": "日野市",
      "enName": "Hino City",
      "kana": "ひのし",
      "chName": "日野市",
      "zhName": "日野市",
      "koName": "히노 시",
      "esName": "Ciudad de Hino",
      "ptName": "cidade de Hino",
      "thName": "เมืองฮิโนะ",
      "viName": "thành phố Hino",
      "inName": "kota Hino",
      "tlName": "siyudad ng Hino",
      "moName": "Хино хот",
      "buName": "ဟီနို မြို့",
      "khName": "ទីក្រុង ហ៊ីណូ",
      "neName": "हिनो सहर"
    }
  },
  "1321300": {
    "office": {
      "code": "130000",
      "name": "東京都",
      "enName": "Tokyo",
      "officeName": "気象庁",
      "chName": "东京都",
      "zhName": "東京都",
      "koName": "도쿄도",
      "esName": "Prefectura de Tokio",
      "ptName": "Metrópole de Tóquio (Tōkyō)",
      "thName": "กรุงโตเกียว",
      "viName": "Thủ đô Tokyo",
      "inName": "Ibu Kota Tokyo",
      "tlName": "Tokyo Metropolis",
      "moName": "Токио",
      "buName": "တိုကျို",
      "khName": "តូក្យូ​",
      "neName": "टोक्यो महानगरपालिका"
    },
    "class10": {
      "code": "130010",
      "name": "東京地方",
      "enName": "Tokyo Region",
      "chName": "東京地區, 東京都",
      "zhName": "东京地区, 東京都",
      "koName": "도쿄 지방, 도쿄도",
      "esName": "Región de Tokio, Prefectura de Tokio",
      "ptName": "Região de Tóquio, Metrópole de Tóquio (Tōkyō)",
      "thName": "ภูมิภาคโตเกียว, กรุงโตเกียว",
      "viName": "khu vực Tokyo, Thủ đô Tokyo",
      "inName": "wilayah Tokyo, Ibu Kota Tokyo",
      "tlName": "Rehiyon ng Tokyo, Tokyo Metropolis",
      "moName": "Токио бүс, Токио",
      "buName": "တိုကျိုဒေသ, တိုကျို",
      "khName": "តំបន់តូក្យូ, តូក្យូ​",
      "neName": "टोकियो क्षेत्र, टोक्यो महानगरपालिका"
    },
    "class15": {
      "code": "130013",
      "name": "多摩北部",
      "enName": "Northern Tama"
    },
    "class20": {
      "code": "1321300",
      "name": "東村山市",
      "enName": "Higashimurayama City",
      "kana": "ひがしむらやまし",
      "chName": "东村山市",
      "zhName": "東村山市",
      "koName": "히가시무라야마 시",
      "esName": "Ciudad de Higashimurayama",
      "ptName": "cidade de Higashimurayama",
      "thName": "เมืองฮิงาชิมูระยามะ",
      "viName": "thành phố Higashimurayama",
      "inName": "kota Higashimurayama",
      "tlName": "siyudad ng Higashimurayama",
      "moName": "Хигaшимүраямa хот",
      "buName": "ဟီဂရှိမုရာယာ့မ မြို့",
      "khName": "ទីក្រុង ហ៊ីកាស៊ីមូរីយាម",
      "neName": "हिगाशिमुरायामा सहर"
    }
  },
  "1321400": {
    "office": {
      "code": "130000",
      "name": "東京都",
      "enName": "Tokyo",
      "officeName": "気象庁",
      "chName": "东京都",
      "zhName": "東京都",
      "koName": "도쿄도",
      "esName": "Prefectura de Tokio",
      "ptName": "Metrópole de Tóquio (Tōkyō)",
      "thName": "กรุงโตเกียว",
      "viName": "Thủ đô Tokyo",
      "inName": "Ibu Kota Tokyo",
      "tlName": "Tokyo Metropolis",
      "moName": "Токио",
      "buName": "တိုကျို",
      "khName": "តូក្យូ​",
      "neName": "टोक्यो महानगरपालिका"
    },
    "class10": {
      "code": "130010",
      "name": "東京地方",
      "enName": "Tokyo Region",
      "chName": "東京地區, 東京都",
      "zhName": "东京地区, 東京都",
      "koName": "도쿄 지방, 도쿄도",
      "esName": "Región de Tokio, Prefectura de Tokio",
      "ptName": "Região de Tóquio, Metrópole de Tóquio (Tōkyō)",
      "thName": "ภูมิภาคโตเกียว, กรุงโตเกียว",
      "viName": "khu vực Tokyo, Thủ đô Tokyo",
      "inName": "wilayah Tokyo, Ibu Kota Tokyo",
      "tlName": "Rehiyon ng Tokyo, Tokyo Metropolis",
      "moName": "Токио бүс, Токио",
      "buName": "တိုကျိုဒေသ, တိုကျို",
      "khName": "តំបន់តូក្យូ, តូក្យូ​",
      "neName": "टोकियो क्षेत्र, टोक्यो महानगरपालिका"
    },
    "class15": {
      "code": "130013",
      "name": "多摩北部",
      "enName": "Northern Tama"
    },
    "class20": {
      "code": "1321400",
      "name": "国分寺市",
      "enName": "Kokubunji City",
      "kana": "こくぶんじし",
      "chName": "国分寺市",
      "zhName": "國分寺市",
      "koName": "고쿠분지 시",
      "esName": "Ciudad de Kokubunji",
      "ptName": "cidade de Kokubunji",
      "thName": "เมืองโคคุบุงจิ",
      "viName": "thành phố Kokubunji",
      "inName": "kota Kokubunji",
      "tlName": "siyudad ng Kokubunji",
      "moName": "Кокүбүнжи хот",
      "buName": "ကိုကုဘွန်းဂျိ မြို့",
      "khName": "ទីក្រុង ឃូឃូប៊ុនជី",
      "neName": "कोकुबुन्जी सहर"
    }
  },
  "1321500": {
    "office": {
      "code": "130000",
      "name": "東京都",
      "enName": "Tokyo",
      "officeName": "気象庁",
      "chName": "东京都",
      "zhName": "東京都",
      "koName": "도쿄도",
      "esName": "Prefectura de Tokio",
      "ptName": "Metrópole de Tóquio (Tōkyō)",
      "thName": "กรุงโตเกียว",
      "viName": "Thủ đô Tokyo",
      "inName": "Ibu Kota Tokyo",
      "tlName": "Tokyo Metropolis",
      "moName": "Токио",
      "buName": "တိုကျို",
      "khName": "តូក្យូ​",
      "neName": "टोक्यो महानगरपालिका"
    },
    "class10": {
      "code": "130010",
      "name": "東京地方",
      "enName": "Tokyo Region",
      "chName": "東京地區, 東京都",
      "zhName": "东京地区, 東京都",
      "koName": "도쿄 지방, 도쿄도",
      "esName": "Región de Tokio, Prefectura de Tokio",
      "ptName": "Região de Tóquio, Metrópole de Tóquio (Tōkyō)",
      "thName": "ภูมิภาคโตเกียว, กรุงโตเกียว",
      "viName": "khu vực Tokyo, Thủ đô Tokyo",
      "inName": "wilayah Tokyo, Ibu Kota Tokyo",
      "tlName": "Rehiyon ng Tokyo, Tokyo Metropolis",
      "moName": "Токио бүс, Токио",
      "buName": "တိုကျိုဒေသ, တိုကျို",
      "khName": "តំបន់តូក្យូ, តូក្យូ​",
      "neName": "टोकियो क्षेत्र, टोक्यो महानगरपालिका"
    },
    "class15": {
      "code": "130013",
      "name": "多摩北部",
      "enName": "Northern Tama"
    },
    "class20": {
      "code": "1321500",
      "name": "国立市",
      "enName": "Kunitachi City",
      "kana": "くにたちし",
      "chName": "国立市",
      "zhName": "國立市",
      "koName": "구니타치 시",
      "esName": "Ciudad de Kunitachi",
      "ptName": "cidade de Kunitachi",
      "thName": "เมืองคุนิตะจิ",
      "viName": "thành phố Kunitachi",
      "inName": "kota Kunitachi",
      "tlName": "siyudad ng Kunitachi",
      "moName": "Kүнитачи хот",
      "buName": "ခူနိတာ့ကျိ မြို့",
      "khName": "ទីក្រុង គុននីតាឈី",
      "neName": "कुनिताची सहर"
    }
  },
  "1321800": {
    "office": {
      "code": "130000",
      "name": "東京都",
      "enName": "Tokyo",
      "officeName": "気象庁",
      "chName": "东京都",
      "zhName": "東京都",
      "koName": "도쿄도",
      "esName": "Prefectura de Tokio",
      "ptName": "Metrópole de Tóquio (Tōkyō)",
      "thName": "กรุงโตเกียว",
      "viName": "Thủ đô Tokyo",
      "inName": "Ibu Kota Tokyo",
      "tlName": "Tokyo Metropolis",
      "moName": "Токио",
      "buName": "တိုကျို",
      "khName": "តូក្យូ​",
      "neName": "टोक्यो महानगरपालिका"
    },
    "class10": {
      "code": "130010",
      "name": "東京地方",
      "enName": "Tokyo Region",
      "chName": "東京地區, 東京都",
      "zhName": "东京地区, 東京都",
      "koName": "도쿄 지방, 도쿄도",
      "esName": "Región de Tokio, Prefectura de Tokio",
      "ptName": "Região de Tóquio, Metrópole de Tóquio (Tōkyō)",
      "thName": "ภูมิภาคโตเกียว, กรุงโตเกียว",
      "viName": "khu vực Tokyo, Thủ đô Tokyo",
      "inName": "wilayah Tokyo, Ibu Kota Tokyo",
      "tlName": "Rehiyon ng Tokyo, Tokyo Metropolis",
      "moName": "Токио бүс, Токио",
      "buName": "တိုကျိုဒေသ, တိုကျို",
      "khName": "តំបន់តូក្យូ, តូក្យូ​",
      "neName": "टोकियो क्षेत्र, टोक्यो महानगरपालिका"
    },
    "class15": {
      "code": "130014",
      "name": "多摩西部",
      "enName": "Western Tama"
    },
    "class20": {
      "code": "1321800",
      "name": "福生市",
      "enName": "Fussa City",
      "kana": "ふっさし",
      "chName": "福生市",
      "zhName": "福生市",
      "koName": "훗사 시",
      "esName": "Ciudad de Fussa",
      "ptName": "cidade de Fussa",
      "thName": "เมืองฟุสสะ",
      "viName": "thành phố Fussa",
      "inName": "kota Fussa",
      "tlName": "siyudad ng Fussa",
      "moName": "Фүссa хот",
      "buName": "ဖူဆာ့ မြို့",
      "khName": "ទីក្រុង ហ្វាស់សា",
      "neName": "फुस्सा सहर"
    }
  },
  "1321900": {
    "office": {
      "code": "130000",
      "name": "東京都",
      "enName": "Tokyo",
      "officeName": "気象庁",
      "chName": "东京都",
      "zhName": "東京都",
      "koName": "도쿄도",
      "esName": "Prefectura de Tokio",
      "ptName": "Metrópole de Tóquio (Tōkyō)",
      "thName": "กรุงโตเกียว",
      "viName": "Thủ đô Tokyo",
      "inName": "Ibu Kota Tokyo",
      "tlName": "Tokyo Metropolis",
      "moName": "Токио",
      "buName": "တိုကျို",
      "khName": "តូក្យូ​",
      "neName": "टोक्यो महानगरपालिका"
    },
    "class10": {
      "code": "130010",
      "name": "東京地方",
      "enName": "Tokyo Region",
      "chName": "東京地區, 東京都",
      "zhName": "东京地区, 東京都",
      "koName": "도쿄 지방, 도쿄도",
      "esName": "Región de Tokio, Prefectura de Tokio",
      "ptName": "Região de Tóquio, Metrópole de Tóquio (Tōkyō)",
      "thName": "ภูมิภาคโตเกียว, กรุงโตเกียว",
      "viName": "khu vực Tokyo, Thủ đô Tokyo",
      "inName": "wilayah Tokyo, Ibu Kota Tokyo",
      "tlName": "Rehiyon ng Tokyo, Tokyo Metropolis",
      "moName": "Токио бүс, Токио",
      "buName": "တိုကျိုဒေသ, တိုကျို",
      "khName": "តំបន់តូក្យូ, តូក្យូ​",
      "neName": "टोकियो क्षेत्र, टोक्यो महानगरपालिका"
    },
    "class15": {
      "code": "130013",
      "name": "多摩北部",
      "enName": "Northern Tama"
    },
    "class20": {
      "code": "1321900",
      "name": "狛江市",
      "enName": "Komae City",
      "kana": "こまえし",
      "chName": "狛江市",
      "zhName": "狛江市",
      "koName": "고마에 시",
      "esName": "Ciudad de Komae",
      "ptName": "cidade de Komae",
      "thName": "เมืองโคมาเอะ",
      "viName": "thành phố Komae",
      "inName": "kota Komae",
      "tlName": "siyudad ng Komae",
      "moName": "Комaэ хот",
      "buName": "ကို့မာယဲ့ မြို့",
      "khName": "ទីក្រុង កូម៉េ",
      "neName": "कोमाए सहर"
    }
  },
  "1322000": {
    "office": {
      "code": "130000",
      "name": "東京都",
      "enName": "Tokyo",
      "officeName": "気象庁",
      "chName": "东京都",
      "zhName": "東京都",
      "koName": "도쿄도",
      "esName": "Prefectura de Tokio",
      "ptName": "Metrópole de Tóquio (Tōkyō)",
      "thName": "กรุงโตเกียว",
      "viName": "Thủ đô Tokyo",
      "inName": "Ibu Kota Tokyo",
      "tlName": "Tokyo Metropolis",
      "moName": "Токио",
      "buName": "တိုကျို",
      "khName": "តូក្យូ​",
      "neName": "टोक्यो महानगरपालिका"
    },
    "class10": {
      "code": "130010",
      "name": "東京地方",
      "enName": "Tokyo Region",
      "chName": "東京地區, 東京都",
      "zhName": "东京地区, 東京都",
      "koName": "도쿄 지방, 도쿄도",
      "esName": "Región de Tokio, Prefectura de Tokio",
      "ptName": "Região de Tóquio, Metrópole de Tóquio (Tōkyō)",
      "thName": "ภูมิภาคโตเกียว, กรุงโตเกียว",
      "viName": "khu vực Tokyo, Thủ đô Tokyo",
      "inName": "wilayah Tokyo, Ibu Kota Tokyo",
      "tlName": "Rehiyon ng Tokyo, Tokyo Metropolis",
      "moName": "Токио бүс, Токио",
      "buName": "တိုကျိုဒေသ, တိုကျို",
      "khName": "តំបន់តូក្យូ, តូក្យូ​",
      "neName": "टोकियो क्षेत्र, टोक्यो महानगरपालिका"
    },
    "class15": {
      "code": "130013",
      "name": "多摩北部",
      "enName": "Northern Tama"
    },
    "class20": {
      "code": "1322000",
      "name": "東大���市",
      "enName": "Higashiyamato City",
      "kana": "ひがしやまとし",
      "chName": "东大和市",
      "zhName": "東大和市",
      "koName": "히가시야마토 시",
      "esName": "Ciudad de Higashiyamato",
      "ptName": "cidade de Higashiyamato",
      "thName": "เมืองฮางาชิยามาโตะ",
      "viName": "thành phố Higashiyamato",
      "inName": "kota Higashiyamato",
      "tlName": "siyudad ng Higashiyamato",
      "moName": "Хигaшиямaто хот",
      "buName": "ဟီဂရှိယာမာတို မြို့",
      "khName": "ទីក្រុង ហ៊ីកាស៊ីយ៉ាម៉ាតូ",
      "neName": "हिगाशियामातो सहर"
    }
  },
  "1322100": {
    "office": {
      "code": "130000",
      "name": "東京都",
      "enName": "Tokyo",
      "officeName": "気象庁",
      "chName": "东京都",
      "zhName": "東京都",
      "koName": "도쿄도",
      "esName": "Prefectura de Tokio",
      "ptName": "Metrópole de Tóquio (Tōkyō)",
      "thName": "กรุงโตเกียว",
      "viName": "Thủ đô Tokyo",
      "inName": "Ibu Kota Tokyo",
      "tlName": "Tokyo Metropolis",
      "moName": "Токио",
      "buName": "တိုကျို",
      "khName": "តូក្យូ​",
      "neName": "टोक्यो महानगरपालिका"
    },
    "class10": {
      "code": "130010",
      "name": "東京地方",
      "enName": "Tokyo Region",
      "chName": "東京地區, 東京都",
      "zhName": "东京地区, 東京都",
      "koName": "도쿄 지방, 도쿄도",
      "esName": "Región de Tokio, Prefectura de Tokio",
      "ptName": "Região de Tóquio, Metrópole de Tóquio (Tōkyō)",
      "thName": "ภูมิภาคโตเกียว, กรุงโตเกียว",
      "viName": "khu vực Tokyo, Thủ đô Tokyo",
      "inName": "wilayah Tokyo, Ibu Kota Tokyo",
      "tlName": "Rehiyon ng Tokyo, Tokyo Metropolis",
      "moName": "Токио бүс, Токио",
      "buName": "တိုကျိုဒေသ, တိုကျို",
      "khName": "តំបន់តូក្យូ, តូក្យូ​",
      "neName": "टोकियो क्षेत्र, टोक्यो महानगरपालिका"
    },
    "class15": {
      "code": "130013",
      "name": "多摩北部",
      "enName": "Northern Tama"
    },
    "class20": {
      "code": "1322100",
      "name": "清瀬市",
      "enName": "Kiyose City",
      "kana": "きよせし",
      "chName": "清濑市",
      "zhName": "清瀨市",
      "koName": "기요세 시",
      "esName": "Ciudad de Kiyose",
      "ptName": "cidade de Kiyose",
      "thName": "เมืองคิโยเสะ",
      "viName": "thành phố Kiyose",
      "inName": "kota Kiyose",
      "tlName": "siyudad ng Kiyose",
      "moName": "Киёсэ хот",
      "buName": "ကီယိုဆဲ့ မြို့",
      "khName": "ទីក្រុង ឃីយ៉ូស",
      "neName": "कियोसे सहर"
    }
  },
  "1322200": {
    "office": {
      "code": "130000",
      "name": "東京都",
      "enName": "Tokyo",
      "officeName": "気象庁",
      "chName": "东京都",
      "zhName": "東京都",
      "koName": "도쿄도",
      "esName": "Prefectura de Tokio",
      "ptName": "Metrópole de Tóquio (Tōkyō)",
      "thName": "กรุงโตเกียว",
      "viName": "Thủ đô Tokyo",
      "inName": "Ibu Kota Tokyo",
      "tlName": "Tokyo Metropolis",
      "moName": "Токио",
      "buName": "တိုကျို",
      "khName": "តូក្យូ​",
      "neName": "टोक्यो महानगरपालिका"
    },
    "class10": {
      "code": "130010",
      "name": "東京地方",
      "enName": "Tokyo Region",
      "chName": "東京地區, 東京都",
      "zhName": "东京地区, 東京都",
      "koName": "도쿄 지방, 도쿄도",
      "esName": "Región de Tokio, Prefectura de Tokio",
      "ptName": "Região de Tóquio, Metrópole de Tóquio (Tōkyō)",
      "thName": "ภูมิภาคโตเกียว, กรุงโตเกียว",
      "viName": "khu vực Tokyo, Thủ đô Tokyo",
      "inName": "wilayah Tokyo, Ibu Kota Tokyo",
      "tlName": "Rehiyon ng Tokyo, Tokyo Metropolis",
      "moName": "Токио бүс, Токио",
      "buName": "တိုကျိုဒေသ, တိုကျို",
      "khName": "តំបន់តូក្យូ, តូក្យូ​",
      "neName": "टोकियो क्षेत्र, टोक्यो महानगरपालिका"
    },
    "class15": {
      "code": "130013",
      "name": "多摩北部",
      "enName": "Northern Tama"
    },
    "class20": {
      "code": "1322200",
      "name": "東久留米市",
      "enName": "Higashikurume City",
      "kana": "ひがしくるめし",
      "chName": "东久留米市",
      "zhName": "東久留米市",
      "koName": "히가시쿠루메 시",
      "esName": "Ciudad de Higashikurume",
      "ptName": "cidade de Higashikurume",
      "thName": "เมืองฮิงาชิคุรุเมะ",
      "viName": "thành phố Higashikurume",
      "inName": "kota Higashikurume",
      "tlName": "siyudad ng Higashikurume",
      "moName": "Хигaшикүрүмэ хот",
      "buName": "ဟီဂရှိကုရုမဲ့ မြို့",
      "khName": "ទីក្រុង ហ៊ីកាស៊ីគួរ៉ូម",
      "neName": "हिगाशिकुरुमे सहर"
    }
  },
  "1322300": {
    "office": {
      "code": "130000",
      "name": "東京都",
      "enName": "Tokyo",
      "officeName": "気象庁",
      "chName": "东京都",
      "zhName": "東京都",
      "koName": "도쿄도",
      "esName": "Prefectura de Tokio",
      "ptName": "Metrópole de Tóquio (Tōkyō)",
      "thName": "กรุงโตเกียว",
      "viName": "Thủ đô Tokyo",
      "inName": "Ibu Kota Tokyo",
      "tlName": "Tokyo Metropolis",
      "moName": "Токио",
      "buName": "တိုကျို",
      "khName": "តូក្យូ​",
      "neName": "टोक्यो महानगरपालिका"
    },
    "class10": {
      "code": "130010",
      "name": "東京地方",
      "enName": "Tokyo Region",
      "chName": "東京地區, 東京都",
      "zhName": "东京地区, 東京都",
      "koName": "도쿄 지방, 도쿄도",
      "esName": "Región de Tokio, Prefectura de Tokio",
      "ptName": "Região de Tóquio, Metrópole de Tóquio (Tōkyō)",
      "thName": "ภูมิภาคโตเกียว, กรุงโตเกียว",
      "viName": "khu vực Tokyo, Thủ đô Tokyo",
      "inName": "wilayah Tokyo, Ibu Kota Tokyo",
      "tlName": "Rehiyon ng Tokyo, Tokyo Metropolis",
      "moName": "Токио бүс, Токио",
      "buName": "တိုကျိုဒေသ, တိုကျို",
      "khName": "តំបន់តូក្យូ, តូក្យូ​",
      "neName": "टोकियो क्षेत्र, टोक्यो महानगरपालिका"
    },
    "class15": {
      "code": "130013",
      "name": "多摩北部",
      "enName": "Northern Tama"
    },
    "class20": {
      "code": "1322300",
      "name": "武蔵村山市",
      "enName": "Musashimurayama City",
      "kana": "むさしむらやまし",
      "chName": "武藏村山市",
      "zhName": "武藏村山市",
      "koName": "무사시무라야마 시",
      "esName": "Ciudad de Musashimurayama",
      "ptName": "cidade de Musashimurayama",
      "thName": "เมืองมุซาชิมุระยามะ",
      "viName": "thành phố Musashimurayama",
      "inName": "kota Musashimurayama",
      "tlName": "siyudad ng Musashimurayama",
      "moName": "Мүсашимүраяма хот",
      "buName": "မူဆာရှိမုရာယာ့မ မြို့",
      "khName": "ទីក្រុង មូសាស៊ីមូរ៉ាយ៉ាម៉ា",
      "neName": "मुसाशिमुरायामा सहर"
    }
  },
  "1322400": {
    "office": {
      "code": "130000",
      "name": "東京都",
      "enName": "Tokyo",
      "officeName": "気象庁",
      "chName": "东京都",
      "zhName": "東京都",
      "koName": "도쿄도",
      "esName": "Prefectura de Tokio",
      "ptName": "Metrópole de Tóquio (Tōkyō)",
      "thName": "กรุงโตเกียว",
      "viName": "Thủ đô Tokyo",
      "inName": "Ibu Kota Tokyo",
      "tlName": "Tokyo Metropolis",
      "moName": "Токио",
      "buName": "တိုကျို",
      "khName": "តូក្យូ​",
      "neName": "टोक्यो महानगरपालिका"
    },
    "class10": {
      "code": "130010",
      "name": "東京地方",
      "enName": "Tokyo Region",
      "chName": "東京地區, 東京都",
      "zhName": "东京地区, 東京都",
      "koName": "도쿄 지방, 도쿄도",
      "esName": "Región de Tokio, Prefectura de Tokio",
      "ptName": "Região de Tóquio, Metrópole de Tóquio (Tōkyō)",
      "thName": "ภูมิภาคโตเกียว, กรุงโตเกียว",
      "viName": "khu vực Tokyo, Thủ đô Tokyo",
      "inName": "wilayah Tokyo, Ibu Kota Tokyo",
      "tlName": "Rehiyon ng Tokyo, Tokyo Metropolis",
      "moName": "Токио бүс, Токио",
      "buName": "တိုကျိုဒေသ, တိုကျို",
      "khName": "តំបន់តូក្យូ, តូក្យូ​",
      "neName": "टोकियो क्षेत्र, टोक्यो महानगरपालिका"
    },
    "class15": {
      "code": "130015",
      "name": "多摩南部",
      "enName": "Southern Tama"
    },
    "class20": {
      "code": "1322400",
      "name": "多摩市",
      "enName": "Tama City",
      "kana": "たまし",
      "chName": "多摩市",
      "zhName": "多摩市",
      "koName": "다마 시",
      "esName": "Ciudad de Tama",
      "ptName": "cidade de Tama",
      "thName": "เมืองทามะ",
      "viName": "thành phố Tama",
      "inName": "kota Tama",
      "tlName": "siyudad ng Tama",
      "moName": "Тама хот",
      "buName": "တာမာ့ မြို့",
      "khName": "ទីក្រុង តាម៉ា",
      "neName": "तामा सहर"
    }
  },
  "1322500": {
    "office": {
      "code": "130000",
      "name": "東京都",
      "enName": "Tokyo",
      "officeName": "気象庁",
      "chName": "东京都",
      "zhName": "東京都",
      "koName": "도쿄도",
      "esName": "Prefectura de Tokio",
      "ptName": "Metrópole de Tóquio (Tōkyō)",
      "thName": "กรุงโตเกียว",
      "viName": "Thủ đô Tokyo",
      "inName": "Ibu Kota Tokyo",
      "tlName": "Tokyo Metropolis",
      "moName": "Токио",
      "buName": "တိုကျို",
      "khName": "តូក្យូ​",
      "neName": "टोक्यो महानगरपालिका"
    },
    "class10": {
      "code": "130010",
      "name": "東京地方",
      "enName": "Tokyo Region",
      "chName": "東京地區, 東京都",
      "zhName": "东京地区, 東京都",
      "koName": "도쿄 지방, 도쿄도",
      "esName": "Región de Tokio, Prefectura de Tokio",
      "ptName": "Região de Tóquio, Metrópole de Tóquio (Tōkyō)",
      "thName": "ภูมิภาคโตเกียว, กรุงโตเกียว",
      "viName": "khu vực Tokyo, Thủ đô Tokyo",
      "inName": "wilayah Tokyo, Ibu Kota Tokyo",
      "tlName": "Rehiyon ng Tokyo, Tokyo Metropolis",
      "moName": "Токио бүс, Токио",
      "buName": "တိုကျိုဒေသ, တိုကျို",
      "khName": "តំបន់តូក្យូ, តូក្យូ​",
      "neName": "टोकियो क्षेत्र, टोक्यो महानगरपालिका"
    },
    "class15": {
      "code": "130015",
      "name": "多摩南部",
      "enName": "Southern Tama"
    },
    "class20": {
      "code": "1322500",
      "name": "稲城市",
      "enName": "Inagi City",
      "kana": "いなぎし",
      "chName": "稻城市",
      "zhName": "稻城市",
      "koName": "이나기 시",
      "esName": "Ciudad de Inagi",
      "ptName": "cidade de Inagi",
      "thName": "เมืองอินางิ",
      "viName": "thành phố Inagi",
      "inName": "kota Inagi",
      "tlName": "siyudad ng Inagi",
      "moName": "Инаги хот",
      "buName": "အိနာ့ဂိ မြို့",
      "khName": "ទីក្រុង អ៊ីនណាហ្គី",
      "neName": "इनागी सहर"
    }
  },
  "1322700": {
    "office": {
      "code": "130000",
      "name": "東京都",
      "enName": "Tokyo",
      "officeName": "気象庁",
      "chName": "东京都",
      "zhName": "東京都",
      "koName": "도쿄도",
      "esName": "Prefectura de Tokio",
      "ptName": "Metrópole de Tóquio (Tōkyō)",
      "thName": "กรุงโตเกียว",
      "viName": "Thủ đô Tokyo",
      "inName": "Ibu Kota Tokyo",
      "tlName": "Tokyo Metropolis",
      "moName": "Токио",
      "buName": "တိုကျို",
      "khName": "តូក្យូ​",
      "neName": "टोक्यो महानगरपालिका"
    },
    "class10": {
      "code": "130010",
      "name": "東京地方",
      "enName": "Tokyo Region",
      "chName": "東京地區, 東京都",
      "zhName": "东京地区, 東京都",
      "koName": "도쿄 지방, 도쿄도",
      "esName": "Región de Tokio, Prefectura de Tokio",
      "ptName": "Região de Tóquio, Metrópole de Tóquio (Tōkyō)",
      "thName": "ภูมิภาคโตเกียว, กรุงโตเกียว",
      "viName": "khu vực Tokyo, Thủ đô Tokyo",
      "inName": "wilayah Tokyo, Ibu Kota Tokyo",
      "tlName": "Rehiyon ng Tokyo, Tokyo Metropolis",
      "moName": "Токио бүс, Токио",
      "buName": "တိုကျိုဒေသ, တိုကျို",
      "khName": "តំបន់តូក្យូ, តូក្យូ​",
      "neName": "टोकियो क्षेत्र, टोक्यो महानगरपालिका"
    },
    "class15": {
      "code": "130014",
      "name": "多摩西部",
      "enName": "Western Tama"
    },
    "class20": {
      "code": "1322700",
      "name": "羽村市",
      "enName": "Hamura City",
      "kana": "はむらし",
      "chName": "羽村市",
      "zhName": "羽村市",
      "koName": "하무라 시",
      "esName": "Ciudad de Hamura",
      "ptName": "cidade de Hamura",
      "thName": "เมืองฮามุระ",
      "viName": "thành phố Hamura",
      "inName": "kota Hamura",
      "tlName": "siyudad ng Hamura",
      "moName": "Хамүра хот",
      "buName": "ဟာမုရာ့ မြို့",
      "khName": "ទីក្រុង ហាមូរ៉ា",
      "neName": "हामुरा सहर"
    }
  },
  "1322800": {
    "office": {
      "code": "130000",
      "name": "東京都",
      "enName": "Tokyo",
      "officeName": "気象庁",
      "chName": "东京都",
      "zhName": "東京都",
      "koName": "도쿄도",
      "esName": "Prefectura de Tokio",
      "ptName": "Metrópole de Tóquio (Tōkyō)",
      "thName": "กรุงโตเกียว",
      "viName": "Thủ đô Tokyo",
      "inName": "Ibu Kota Tokyo",
      "tlName": "Tokyo Metropolis",
      "moName": "Токио",
      "buName": "တိုကျို",
      "khName": "តូក្យូ​",
      "neName": "टोक्यो महानगरपालिका"
    },
    "class10": {
      "code": "130010",
      "name": "東京地方",
      "enName": "Tokyo Region",
      "chName": "東京地區, 東京都",
      "zhName": "东京地区, 東京都",
      "koName": "도쿄 지방, 도쿄도",
      "esName": "Región de Tokio, Prefectura de Tokio",
      "ptName": "Região de Tóquio, Metrópole de Tóquio (Tōkyō)",
      "thName": "ภูมิภาคโตเกียว, กรุงโตเกียว",
      "viName": "khu vực Tokyo, Thủ đô Tokyo",
      "inName": "wilayah Tokyo, Ibu Kota Tokyo",
      "tlName": "Rehiyon ng Tokyo, Tokyo Metropolis",
      "moName": "Токио бүс, Токио",
      "buName": "တိုကျိုဒေသ, တိုကျို",
      "khName": "តំបន់តូក្យូ, តូក្យូ​",
      "neName": "टोकियो क्षेत्र, टोक्यो महानगरपालिका"
    },
    "class15": {
      "code": "130014",
      "name": "多摩西部",
      "enName": "Western Tama"
    },
    "class20": {
      "code": "1322800",
      "name": "あきる野市",
      "enName": "Akiruno City",
      "kana": "あきるのし",
      "chName": "秋留野市",
      "zhName": "秋留野市",
      "koName": "아키루노 시",
      "esName": "Ciudad de Akiruno",
      "ptName": "cidade de Akiruno",
      "thName": "เมืองอากิรุโนะ",
      "viName": "thành phố Akiruno",
      "inName": "kota Akiruno",
      "tlName": "siyudad ng Akiruno",
      "moName": "Акирүно хот",
      "buName": "အာကိရုနို မြို့",
      "khName": "ទីក្រុង អាគីរូណូ",
      "neName": "आकिरुनो सहर"
    }
  },
  "1322900": {
    "office": {
      "code": "130000",
      "name": "東京都",
      "enName": "Tokyo",
      "officeName": "気象庁",
      "chName": "东京都",
      "zhName": "東京都",
      "koName": "도쿄도",
      "esName": "Prefectura de Tokio",
      "ptName": "Metrópole de Tóquio (Tōkyō)",
      "thName": "กรุงโตเกียว",
      "viName": "Thủ đô Tokyo",
      "inName": "Ibu Kota Tokyo",
      "tlName": "Tokyo Metropolis",
      "moName": "Токио",
      "buName": "တိုကျို",
      "khName": "តូក្យូ​",
      "neName": "टोक्यो महानगरपालिका"
    },
    "class10": {
      "code": "130010",
      "name": "東京地方",
      "enName": "Tokyo Region",
      "chName": "東京地區, 東京都",
      "zhName": "东京地区, 東京都",
      "koName": "도쿄 지방, 도쿄도",
      "esName": "Región de Tokio, Prefectura de Tokio",
      "ptName": "Região de Tóquio, Metrópole de Tóquio (Tōkyō)",
      "thName": "ภูมิภาคโตเกียว, กรุงโตเกียว",
      "viName": "khu vực Tokyo, Thủ đô Tokyo",
      "inName": "wilayah Tokyo, Ibu Kota Tokyo",
      "tlName": "Rehiyon ng Tokyo, Tokyo Metropolis",
      "moName": "Токио бүс, Токио",
      "buName": "တိုကျိုဒေသ, တိုကျို",
      "khName": "តំបន់តូក្យូ, តូក្យូ​",
      "neName": "टोकियो क्षेत्र, टोक्यो महानगरपालिका"
    },
    "class15": {
      "code": "130013",
      "name": "多摩北部",
      "enName": "Northern Tama"
    },
    "class20": {
      "code": "1322900",
      "name": "西東京市",
      "enName": "Nishitokyo City",
      "kana": "にしとうきょうし",
      "chName": "西东京市",
      "zhName": "西東京市",
      "koName": "니시토쿄 시",
      "esName": "Ciudad de Nishitokio",
      "ptName": "cidade de Nishitokyo",
      "thName": "เมืองนิชิโตเกียว",
      "viName": "thành phố Nishitokyo",
      "inName": "kota Nishitokyo",
      "tlName": "siyudad ng Nishitokyo",
      "moName": "Нишитокио хот",
      "buName": "နီရှိတိုကရို မြို့",
      "khName": "ទីក្រុង នីស៊ីតូក្យូ",
      "neName": "निशिटोक्यो सहर"
    }
  },
  "1330300": {
    "office": {
      "code": "130000",
      "name": "東京都",
      "enName": "Tokyo",
      "officeName": "気象庁",
      "chName": "东京都",
      "zhName": "東京都",
      "koName": "도쿄도",
      "esName": "Prefectura de Tokio",
      "ptName": "Metrópole de Tóquio (Tōkyō)",
      "thName": "กรุงโตเกียว",
      "viName": "Thủ đô Tokyo",
      "inName": "Ibu Kota Tokyo",
      "tlName": "Tokyo Metropolis",
      "moName": "Токио",
      "buName": "တိုကျို",
      "khName": "តូក្យូ​",
      "neName": "टोक्यो महानगरपालिका"
    },
    "class10": {
      "code": "130010",
      "name": "東京地方",
      "enName": "Tokyo Region",
      "chName": "東京地區, 東京都",
      "zhName": "东京地区, 東京都",
      "koName": "도쿄 지방, 도쿄도",
      "esName": "Región de Tokio, Prefectura de Tokio",
      "ptName": "Região de Tóquio, Metrópole de Tóquio (Tōkyō)",
      "thName": "ภูมิภาคโตเกียว, กรุงโตเกียว",
      "viName": "khu vực Tokyo, Thủ đô Tokyo",
      "inName": "wilayah Tokyo, Ibu Kota Tokyo",
      "tlName": "Rehiyon ng Tokyo, Tokyo Metropolis",
      "moName": "Токио бүс, Токио",
      "buName": "တိုကျိုဒေသ, တိုကျို",
      "khName": "តំបន់តូក្យូ, តូក្យូ​",
      "neName": "टोकियो क्षेत्र, टोक्यो महानगरपालिका"
    },
    "class15": {
      "code": "130014",
      "name": "多摩西部",
      "enName": "Western Tama"
    },
    "class20": {
      "code": "1330300",
      "name": "瑞穂町",
      "enName": "Mizuho Town",
      "kana": "みずほまち",
      "chName": "瑞穗町",
      "zhName": "瑞穗町",
      "koName": "미즈호 정",
      "esName": "Pueblo de Mizuho",
      "ptName": "bairro de Mizuho",
      "thName": "เมืองมิซูโฮะ",
      "viName": "thị trấn Mizuho",
      "inName": "kota Mizuho",
      "tlName": "bayan ng Mizuho",
      "moName": "Мизүхо жижиг хот",
      "buName": "မီဇုဟို မြို့နယ်",
      "khName": "ទីប្រជុំជន មីស៊ូហូ",
      "neName": "मिजुहो नगर"
    }
  },
  "1330500": {
    "office": {
      "code": "130000",
      "name": "東京都",
      "enName": "Tokyo",
      "officeName": "気象庁",
      "chName": "东京都",
      "zhName": "東京都",
      "koName": "도쿄도",
      "esName": "Prefectura de Tokio",
      "ptName": "Metrópole de Tóquio (Tōkyō)",
      "thName": "กรุงโตเกียว",
      "viName": "Thủ đô Tokyo",
      "inName": "Ibu Kota Tokyo",
      "tlName": "Tokyo Metropolis",
      "moName": "Токио",
      "buName": "တိုကျို",
      "khName": "តូក្យូ​",
      "neName": "टोक्यो महानगरपालिका"
    },
    "class10": {
      "code": "130010",
      "name": "東京地方",
      "enName": "Tokyo Region",
      "chName": "東京地區, 東京都",
      "zhName": "东京地区, 東京都",
      "koName": "도쿄 지방, 도쿄도",
      "esName": "Región de Tokio, Prefectura de Tokio",
      "ptName": "Região de Tóquio, Metrópole de Tóquio (Tōkyō)",
      "thName": "ภูมิภาคโตเกียว, กรุงโตเกียว",
      "viName": "khu vực Tokyo, Thủ đô Tokyo",
      "inName": "wilayah Tokyo, Ibu Kota Tokyo",
      "tlName": "Rehiyon ng Tokyo, Tokyo Metropolis",
      "moName": "Токио бүс, Токио",
      "buName": "တိုကျိုဒေသ, တိုကျို",
      "khName": "តំបន់តូក្យូ, តូក្យូ​",
      "neName": "टोकियो क्षेत्र, टोक्यो महानगरपालिका"
    },
    "class15": {
      "code": "130014",
      "name": "多摩西部",
      "enName": "Western Tama"
    },
    "class20": {
      "code": "1330500",
      "name": "日の出町",
      "enName": "Hinode Town",
      "kana": "ひのでまち",
      "chName": "日之出町",
      "zhName": "日之出町",
      "koName": "히노데 정",
      "esName": "Pueblo de Hinode",
      "ptName": "bairro de Hinode",
      "thName": "เมืองฮิโนเดะ",
      "viName": "thị trấn Hinode",
      "inName": "kota Hinode",
      "tlName": "bayan ng Hinode",
      "moName": "Хинодэ жижиг хот",
      "buName": "ဟီနိုဒဲ့ မြို့နယ်",
      "khName": "ទីប្រជុំជន ហ៊ីណូដេ",
      "neName": "हिनोदे नगर"
    }
  },
  "1330700": {
    "office": {
      "code": "130000",
      "name": "東京都",
      "enName": "Tokyo",
      "officeName": "気象庁",
      "chName": "东京都",
      "zhName": "東京都",
      "koName": "도쿄도",
      "esName": "Prefectura de Tokio",
      "ptName": "Metrópole de Tóquio (Tōkyō)",
      "thName": "กรุงโตเกียว",
      "viName": "Thủ đô Tokyo",
      "inName": "Ibu Kota Tokyo",
      "tlName": "Tokyo Metropolis",
      "moName": "Токио",
      "buName": "တိုကျို",
      "khName": "តូក្យូ​",
      "neName": "टोक्यो महानगरपालिका"
    },
    "class10": {
      "code": "130010",
      "name": "東京地方",
      "enName": "Tokyo Region",
      "chName": "東京地區, 東京都",
      "zhName": "东京地区, 東京都",
      "koName": "도쿄 지방, 도쿄도",
      "esName": "Región de Tokio, Prefectura de Tokio",
      "ptName": "Região de Tóquio, Metrópole de Tóquio (Tōkyō)",
      "thName": "ภูมิภาคโตเกียว, กรุงโตเกียว",
      "viName": "khu vực Tokyo, Thủ đô Tokyo",
      "inName": "wilayah Tokyo, Ibu Kota Tokyo",
      "tlName": "Rehiyon ng Tokyo, Tokyo Metropolis",
      "moName": "Токио бүс, Токио",
      "buName": "တိုကျိုဒေသ, တိုကျို",
      "khName": "តំបន់តូក្យូ, តូក្យូ​",
      "neName": "टोकियो क्षेत्र, टोक्यो महानगरपालिका"
    },
    "class15": {
      "code": "130014",
      "name": "多摩西部",
      "enName": "Western Tama"
    },
    "class20": {
      "code": "1330700",
      "name": "檜原村",
      "enName": "Hinohara Village",
      "kana": "ひのはらむら",
      "chName": "桧原村",
      "zhName": "檜原村",
      "koName": "히노하라 촌",
      "esName": "Aldea de Hinohara",
      "ptName": "povoado de Hinohara",
      "thName": "หมู่บ้านฮิโนะฮาระ",
      "viName": "làng Hinohara",
      "inName": "desa Hinohara",
      "tlName": "nayon ng Hinohara",
      "moName": "Хинохaра тосгон",
      "buName": "ဟီနိုဟာရာ ကျေးရွာ",
      "khName": "ភូមិ ហ៊ីណូហារ៉ា",
      "neName": "हिनोहारा गाउँ"
    }
  },
  "1330800": {
    "office": {
      "code": "130000",
      "name": "東京都",
      "enName": "Tokyo",
      "officeName": "気象庁",
      "chName": "东京都",
      "zhName": "東京都",
      "koName": "도쿄도",
      "esName": "Prefectura de Tokio",
      "ptName": "Metrópole de Tóquio (Tōkyō)",
      "thName": "กรุงโตเกียว",
      "viName": "Thủ đô Tokyo",
      "inName": "Ibu Kota Tokyo",
      "tlName": "Tokyo Metropolis",
      "moName": "Токио",
      "buName": "တိုကျို",
      "khName": "តូក្យូ​",
      "neName": "टोक्यो महानगरपालिका"
    },
    "class10": {
      "code": "130010",
      "name": "東京地方",
      "enName": "Tokyo Region",
      "chName": "東京地區, 東京都",
      "zhName": "东京地区, 東京都",
      "koName": "도쿄 지방, 도쿄도",
      "esName": "Región de Tokio, Prefectura de Tokio",
      "ptName": "Região de Tóquio, Metrópole de Tóquio (Tōkyō)",
      "thName": "ภูมิภาคโตเกียว, กรุงโตเกียว",
      "viName": "khu vực Tokyo, Thủ đô Tokyo",
      "inName": "wilayah Tokyo, Ibu Kota Tokyo",
      "tlName": "Rehiyon ng Tokyo, Tokyo Metropolis",
      "moName": "Токио бүс, Токио",
      "buName": "တိုကျိုဒေသ, တိုကျို",
      "khName": "តំបន់តូក្យូ, តូក្យូ​",
      "neName": "टोकियो क्षेत्र, टोक्यो महानगरपालिका"
    },
    "class15": {
      "code": "130014",
      "name": "多摩西部",
      "enName": "Western Tama"
    },
    "class20": {
      "code": "1330800",
      "name": "奥多摩町",
      "enName": "Okutama Town",
      "kana": "おくたままち",
      "chName": "奥多摩町",
      "zhName": "奧多摩町",
      "koName": "오쿠타마 정",
      "esName": "Puebla de Okutama",
      "ptName": "bairro de Okutama",
      "thName": "เมืองโอคุตามะ",
      "viName": "thị trấn Okutama",
      "inName": "kota Okutama",
      "tlName": "bayan ng Okutama",
      "moName": "Окүтамa жижиг хот",
      "buName": "အိုကုတာ့မ မြို့နယ်",
      "khName": "ទីប្រជុំជន អូគូតាម៉ា",
      "neName": "ओकुतामा नगर"
    }
  },
  "1336100": {
    "office": {
      "code": "130000",
      "name": "東京都",
      "enName": "Tokyo",
      "officeName": "気象庁",
      "chName": "东京都",
      "zhName": "東京都",
      "koName": "도쿄도",
      "esName": "Prefectura de Tokio",
      "ptName": "Metrópole de Tóquio (Tōkyō)",
      "thName": "กรุงโตเกียว",
      "viName": "Thủ đô Tokyo",
      "inName": "Ibu Kota Tokyo",
      "tlName": "Tokyo Metropolis",
      "moName": "Токио",
      "buName": "တိုကျို",
      "khName": "តូក្យូ​",
      "neName": "टोक्यो महानगरपालिका"
    },
    "class10": {
      "code": "130020",
      "name": "伊豆諸島北部",
      "enName": "Northern Izu Islands",
      "chName": "北伊豆群島",
      "zhName": "北伊豆群岛",
      "koName": "이즈 제도 북부",
      "esName": "Islas Izu del Norte",
      "ptName": "Ilhas Izu do Norte",
      "thName": "หมู่เกาะอิซุตอนเหนือ",
      "viName": "Quần đảo Bắc Izu",
      "inName": "Kepulauan Izu Utara",
      "tlName": "Northern Izu Islands",
      "moName": "Хойд Изү арлууд",
      "buName": "မြောက်ပိုင်း Izu ကျွန်းများ",
      "khName": "កោះ Izu ខាងជើង",
      "neName": "उत्तरी इजु टापुहरू"
    },
    "class15": {
      "code": "130021",
      "name": "大島",
      "enName": "Oshima Island"
    },
    "class20": {
      "code": "1336100",
      "name": "大島町",
      "enName": "Oshima Town",
      "kana": "おおしままち",
      "chName": "伊豆大岛町",
      "zhName": "伊豆大島町",
      "koName": "이즈오시마 정",
      "esName": "Pueblo de Oshima, Izu",
      "ptName": "Izu, bairro de Oshima",
      "thName": "เมืองโอชิมะ อิซุ",
      "viName": "Thị trấn Izu-Oshima",
      "inName": "Kota Oshima, Izu",
      "tlName": "bayan ng IzuOshima, Izu",
      "moName": "Изүо Огашима жижиг хот",
      "buName": "အိဇုအိုအိရှိမမြို့နယ်",
      "khName": "ទីប្រជុំជនអូស៊ីម៉ា អ៊ីហ៊្សូ",
      "neName": "इजु-ओसिमा नगर"
    }
  },
  "1336200": {
    "office": {
      "code": "130000",
      "name": "東京都",
      "enName": "Tokyo",
      "officeName": "気象庁",
      "chName": "东京都",
      "zhName": "東京都",
      "koName": "도쿄도",
      "esName": "Prefectura de Tokio",
      "ptName": "Metrópole de Tóquio (Tōkyō)",
      "thName": "กรุงโตเกียว",
      "viName": "Thủ đô Tokyo",
      "inName": "Ibu Kota Tokyo",
      "tlName": "Tokyo Metropolis",
      "moName": "Токио",
      "buName": "တိုကျို",
      "khName": "តូក្យូ​",
      "neName": "टोक्यो महानगरपालिका"
    },
    "class10": {
      "code": "130020",
      "name": "伊豆諸島北部",
      "enName": "Northern Izu Islands",
      "chName": "北伊豆群島",
      "zhName": "北伊豆群岛",
      "koName": "이즈 제도 북부",
      "esName": "Islas Izu del Norte",
      "ptName": "Ilhas Izu do Norte",
      "thName": "หมู่เกาะอิซุตอนเหนือ",
      "viName": "Quần đảo Bắc Izu",
      "inName": "Kepulauan Izu Utara",
      "tlName": "Northern Izu Islands",
      "moName": "Хойд Изү арлууд",
      "buName": "မြောက်ပိုင်း Izu ကျွန်းများ",
      "khName": "កោះ Izu ខាងជើង",
      "neName": "उत्तरी इजु टापुहरू"
    },
    "class15": {
      "code": "130022",
      "name": "新島",
      "enName": "Niijima Island"
    },
    "class20": {
      "code": "1336200",
      "name": "利島村",
      "enName": "Toshima Village",
      "kana": "としまむら",
      "chName": "东京利岛村",
      "zhName": "東京利島村",
      "koName": "토쿄 도시마 촌",
      "esName": "Aldea de Toshima, Tokio",
      "ptName": "Tóquio, Toshima-mura ",
      "thName": "หมู่บ้านโทชิมะ โตเกียว",
      "viName": "Làng Toshima, Tokyo",
      "inName": "Desa Toshima, Tokyo",
      "tlName": "nayon ng Toshima, Tokyo",
      "moName": "Токио Тошима тосгон",
      "buName": "တိုကျိုတိုရှိမရွာ",
      "khName": "ភូមិតូស៊ីម៉ា តូក្យូ​",
      "neName": "टोक्यो तोशिमा गाउँ"
    }
  },
  "1336300": {
    "office": {
      "code": "130000",
      "name": "東京都",
      "enName": "Tokyo",
      "officeName": "気象庁",
      "chName": "东京都",
      "zhName": "東京都",
      "koName": "도쿄도",
      "esName": "Prefectura de Tokio",
      "ptName": "Metrópole de Tóquio (Tōkyō)",
      "thName": "กรุงโตเกียว",
      "viName": "Thủ đô Tokyo",
      "inName": "Ibu Kota Tokyo",
      "tlName": "Tokyo Metropolis",
      "moName": "Токио",
      "buName": "တိုကျို",
      "khName": "តូក្យូ​",
      "neName": "टोक्यो महानगरपालिका"
    },
    "class10": {
      "code": "130020",
      "name": "伊豆諸島北部",
      "enName": "Northern Izu Islands",
      "chName": "北伊豆群島",
      "zhName": "北伊豆群岛",
      "koName": "이즈 제도 북부",
      "esName": "Islas Izu del Norte",
      "ptName": "Ilhas Izu do Norte",
      "thName": "หมู่เกาะอิซุตอนเหนือ",
      "viName": "Quần đảo Bắc Izu",
      "inName": "Kepulauan Izu Utara",
      "tlName": "Northern Izu Islands",
      "moName": "Хойд Изү арлууд",
      "buName": "မြောက်ပိုင်း Izu ကျွန်းများ",
      "khName": "កោះ Izu ខាងជើង",
      "neName": "उत्तरी इजु टापुहरू"
    },
    "class15": {
      "code": "130022",
      "name": "新島",
      "enName": "Niijima Island"
    },
    "class20": {
      "code": "1336300",
      "name": "新島村",
      "enName": "Niijima Village",
      "kana": "にいじまむら",
      "chName": "新岛村",
      "zhName": "新島村",
      "koName": "니지마 촌",
      "esName": "Aldea de Nijima",
      "ptName": "povoado de Niijima",
      "thName": "หมู่บ้านนีจิมะ",
      "viName": "làng Niijima",
      "inName": "desa Niijima",
      "tlName": "nayon ng Niijima",
      "moName": "Нийжима тосгон",
      "buName": "နီးဂျီးမ ကျေးရွာ",
      "khName": "ភូមិ នីហ្សីម៉ា",
      "neName": "निजिमा गाउँ"
    }
  },
  "1336400": {
    "office": {
      "code": "130000",
      "name": "東京都",
      "enName": "Tokyo",
      "officeName": "気象庁",
      "chName": "东京都",
      "zhName": "東京都",
      "koName": "도쿄도",
      "esName": "Prefectura de Tokio",
      "ptName": "Metrópole de Tóquio (Tōkyō)",
      "thName": "กรุงโตเกียว",
      "viName": "Thủ đô Tokyo",
      "inName": "Ibu Kota Tokyo",
      "tlName": "Tokyo Metropolis",
      "moName": "Токио",
      "buName": "တိုကျို",
      "khName": "តូក្យូ​",
      "neName": "टोक्यो महानगरपालिका"
    },
    "class10": {
      "code": "130020",
      "name": "伊豆諸島北部",
      "enName": "Northern Izu Islands",
      "chName": "北伊豆群島",
      "zhName": "北伊豆群岛",
      "koName": "이즈 제도 북부",
      "esName": "Islas Izu del Norte",
      "ptName": "Ilhas Izu do Norte",
      "thName": "หมู่เกาะอิซุตอนเหนือ",
      "viName": "Quần đảo Bắc Izu",
      "inName": "Kepulauan Izu Utara",
      "tlName": "Northern Izu Islands",
      "moName": "Хойд Изү арлууд",
      "buName": "မြောက်ပိုင်း Izu ကျွန်းများ",
      "khName": "កោះ Izu ខាងជើង",
      "neName": "उत्तरी इजु टापुहरू"
    },
    "class15": {
      "code": "130022",
      "name": "新島",
      "enName": "Niijima Island"
    },
    "class20": {
      "code": "1336400",
      "name": "神津島村",
      "enName": "Kouzushima Village",
      "kana": "こうづしまむら",
      "chName": "神津岛村",
      "zhName": "神津島村",
      "koName": "고즈시마 촌",
      "esName": "Aldea de Kozushima",
      "ptName": "povoado de Kouzushima",
      "thName": "หมู่บ้านโคสุชิมะ",
      "viName": "làng Kouzushima",
      "inName": "desa Kouzushima",
      "tlName": "nayon ng Kouzushima",
      "moName": "Коүзүшимa тосгон",
      "buName": "ကိုဥဇုရှိမ ကျေးရွာ",
      "khName": "ភូមិ គុហ្សុស៊ីម៉ា",
      "neName": "कोउजुशिमा गाउँ"
    }
  },
  "1338100": {
    "office": {
      "code": "130000",
      "name": "東京都",
      "enName": "Tokyo",
      "officeName": "気象庁",
      "chName": "东京都",
      "zhName": "東京都",
      "koName": "도쿄도",
      "esName": "Prefectura de Tokio",
      "ptName": "Metrópole de Tóquio (Tōkyō)",
      "thName": "กรุงโตเกียว",
      "viName": "Thủ đô Tokyo",
      "inName": "Ibu Kota Tokyo",
      "tlName": "Tokyo Metropolis",
      "moName": "Токио",
      "buName": "တိုကျို",
      "khName": "តូក្យូ​",
      "neName": "टोक्यो महानगरपालिका"
    },
    "class10": {
      "code": "130030",
      "name": "伊豆諸島南部",
      "enName": "Southern Izu Islands",
      "chName": "伊豆群島南部",
      "zhName": "伊豆群岛南部",
      "koName": "이즈 제도 남부",
      "esName": "Islas Izu del Sur",
      "ptName": "Ilhas Izu do Sul",
      "thName": "หมู่เกาะอิซุตอนใต้",
      "viName": "Quần đảo Nam Izu",
      "inName": "Kepulauan Izu Selatan",
      "tlName": "Southern Izu Islands",
      "moName": "Өмнөд Изү арлууд",
      "buName": "တောင်ပိုင်း Izu ကျွန်းများ",
      "khName": "កោះ Izu ភាគខាងត្បូង",
      "neName": "दक्षिणी इजु टापुहरू"
    },
    "class15": {
      "code": "130032",
      "name": "三宅島",
      "enName": "Miyakejima Island"
    },
    "class20": {
      "code": "1338100",
      "name": "三宅村",
      "enName": "Miyake Village",
      "kana": "みやけむら",
      "chName": "三宅村",
      "zhName": "三宅村",
      "koName": "미야케 촌",
      "esName": "Aldea de Miyake",
      "ptName": "povoado de Miyake",
      "thName": "หมู่บ้านมิยาเกะ",
      "viName": "làng Miyake",
      "inName": "desa Miyake",
      "tlName": "nayon ng Miyake",
      "moName": "Миякэ тосгон",
      "buName": "မီယာကဲ့ ကျေးရွာ",
      "khName": "ភូមិ មីយ៉ាគី",
      "neName": "मियाके गाउँ"
    }
  },
  "1338200": {
    "office": {
      "code": "130000",
      "name": "東京都",
      "enName": "Tokyo",
      "officeName": "気象庁",
      "chName": "东京都",
      "zhName": "東京都",
      "koName": "도쿄도",
      "esName": "Prefectura de Tokio",
      "ptName": "Metrópole de Tóquio (Tōkyō)",
      "thName": "กรุงโตเกียว",
      "viName": "Thủ đô Tokyo",
      "inName": "Ibu Kota Tokyo",
      "tlName": "Tokyo Metropolis",
      "moName": "Токио",
      "buName": "တိုကျို",
      "khName": "តូក្យូ​",
      "neName": "टोक्यो महानगरपालिका"
    },
    "class10": {
      "code": "130030",
      "name": "伊豆諸島南部",
      "enName": "Southern Izu Islands",
      "chName": "伊豆群島南部",
      "zhName": "伊豆群岛南部",
      "koName": "이즈 제도 남부",
      "esName": "Islas Izu del Sur",
      "ptName": "Ilhas Izu do Sul",
      "thName": "หมู่เกาะอิซุตอนใต้",
      "viName": "Quần đảo Nam Izu",
      "inName": "Kepulauan Izu Selatan",
      "tlName": "Southern Izu Islands",
      "moName": "Өмнөд Изү арлууд",
      "buName": "တောင်ပိုင်း Izu ကျွန်းများ",
      "khName": "កោះ Izu ភាគខាងត្បូង",
      "neName": "दक्षिणी इजु टापुहरू"
    },
    "class15": {
      "code": "130032",
      "name": "三宅島",
      "enName": "Miyakejima Island"
    },
    "class20": {
      "code": "1338200",
      "name": "御蔵島村",
      "enName": "Mikurashima Village",
      "kana": "みくらじまむら",
      "chName": "御藏岛村",
      "zhName": "御藏島村",
      "koName": "미쿠라시마 촌",
      "esName": "Aldea de Mikurajima",
      "ptName": "povoado de Mikurashima",
      "thName": "หมู่บ้านมิคุระชิมะ",
      "viName": "làng Mikurashima",
      "inName": "desa Mikurashima",
      "tlName": "nayon ng Mikurashima",
      "moName": "Микүрашимa тосгон",
      "buName": "မီကုရာ့ရှိမ ကျေးရွာ",
      "khName": "ភូមិ មីគូរ៉ាស៊ីម៉ា",
      "neName": "मिकुराशिमा गाउँ"
    }
  },
  "1340100": {
    "office": {
      "code": "130000",
      "name": "東京都",
      "enName": "Tokyo",
      "officeName": "気象庁",
      "chName": "东京都",
      "zhName": "東京都",
      "koName": "도쿄도",
      "esName": "Prefectura de Tokio",
      "ptName": "Metrópole de Tóquio (Tōkyō)",
      "thName": "กรุงโตเกียว",
      "viName": "Thủ đô Tokyo",
      "inName": "Ibu Kota Tokyo",
      "tlName": "Tokyo Metropolis",
      "moName": "Токио",
      "buName": "တိုကျို",
      "khName": "តូក្យូ​",
      "neName": "टोक्यो महानगरपालिका"
    },
    "class10": {
      "code": "130030",
      "name": "伊豆諸島南部",
      "enName": "Southern Izu Islands",
      "chName": "伊豆群島南部",
      "zhName": "伊豆群岛南部",
      "koName": "이즈 제도 남부",
      "esName": "Islas Izu del Sur",
      "ptName": "Ilhas Izu do Sul",
      "thName": "หมู่เกาะอิซุตอนใต้",
      "viName": "Quần đảo Nam Izu",
      "inName": "Kepulauan Izu Selatan",
      "tlName": "Southern Izu Islands",
      "moName": "Өмнөд Изү арлууд",
      "buName": "တောင်ပိုင်း Izu ကျွန်းများ",
      "khName": "កោះ Izu ភាគខាងត្បូង",
      "neName": "दक्षिणी इजु टापुहरू"
    },
    "class15": {
      "code": "130031",
      "name": "八丈島",
      "enName": "Hachijojima Island"
    },
    "class20": {
      "code": "1340100",
      "name": "八丈町",
      "enName": "Hachijo Town",
      "kana": "はちじょうまち",
      "chName": "八丈町",
      "zhName": "八丈町",
      "koName": "하치조 정",
      "esName": "Pueblo de Hachijyo",
      "ptName": "bairro de Hachijo",
      "thName": "เมืองฮาจิโจ",
      "viName": "thị trấn Hachijo",
      "inName": "kota Hachijo",
      "tlName": "bayan ng Hachijo",
      "moName": "Хачижо жижиг хот",
      "buName": "ဟကျိဂျို မြို့နယ်",
      "khName": "ទីប្រជុំជន ហាជីចូ",
      "neName": "हाचिजो नगर"
    }
  },
  "1340200": {
    "office": {
      "code": "130000",
      "name": "東京都",
      "enName": "Tokyo",
      "officeName": "気象庁",
      "chName": "东京都",
      "zhName": "東京都",
      "koName": "도쿄도",
      "esName": "Prefectura de Tokio",
      "ptName": "Metrópole de Tóquio (Tōkyō)",
      "thName": "กรุงโตเกียว",
      "viName": "Thủ đô Tokyo",
      "inName": "Ibu Kota Tokyo",
      "tlName": "Tokyo Metropolis",
      "moName": "Токио",
      "buName": "တိုကျို",
      "khName": "តូក្យូ​",
      "neName": "टोक्यो महानगरपालिका"
    },
    "class10": {
      "code": "130030",
      "name": "伊豆諸島南部",
      "enName": "Southern Izu Islands",
      "chName": "伊豆群島南部",
      "zhName": "伊豆群岛南部",
      "koName": "이즈 제도 남부",
      "esName": "Islas Izu del Sur",
      "ptName": "Ilhas Izu do Sul",
      "thName": "หมู่เกาะอิซุตอนใต้",
      "viName": "Quần đảo Nam Izu",
      "inName": "Kepulauan Izu Selatan",
      "tlName": "Southern Izu Islands",
      "moName": "Өмнөд Изү арлууд",
      "buName": "တောင်ပိုင်း Izu ကျွန်းများ",
      "khName": "កោះ Izu ភាគខាងត្បូង",
      "neName": "दक्षिणी इजु टापुहरू"
    },
    "class15": {
      "code": "130031",
      "name": "八丈島",
      "enName": "Hachijojima Island"
    },
    "class20": {
      "code": "1340200",
      "name": "青ヶ島村",
      "enName": "Aogashima Village",
      "kana": "あおがしまむら",
      "chName": "青岛村",
      "zhName": "青島村",
      "koName": "아오가시마 촌",
      "esName": "Aldea de Aogashima",
      "ptName": "povoado de Aogashima",
      "thName": "หมู่บ้านอาโองะชิมะ",
      "viName": "làng Aogashima",
      "inName": "desa Aogashima",
      "tlName": "nayon ng Aogashima",
      "moName": "Аогашима тосгон",
      "buName": "အာအိုဂါ့ရှိမ ကျေးရွာ",
      "khName": "ភូមិ អេអូហ្គាស៊ីម៉ា",
      "neName": "ओगाशिमा गाउँ"
    }
  },
  "1342100": {
    "office": {
      "code": "130000",
      "name": "東京都",
      "enName": "Tokyo",
      "officeName": "気象庁",
      "chName": "东京都",
      "zhName": "東京都",
      "koName": "도쿄도",
      "esName": "Prefectura de Tokio",
      "ptName": "Metrópole de Tóquio (Tōkyō)",
      "thName": "กรุงโตเกียว",
      "viName": "Thủ đô Tokyo",
      "inName": "Ibu Kota Tokyo",
      "tlName": "Tokyo Metropolis",
      "moName": "Токио",
      "buName": "တိုကျို",
      "khName": "តូក្យូ​",
      "neName": "टोक्यो महानगरपालिका"
    },
    "class10": {
      "code": "130040",
      "name": "小笠原諸島",
      "enName": "Ogasawara Islands",
      "chName": "小笠原群島",
      "zhName": "小笠原群岛",
      "koName": "오가사와라 제도",
      "esName": "Islas Ogasawara",
      "ptName": "Ilhas Ogasawara",
      "thName": "หมู่เกาะโอกาซาวาระ",
      "viName": "Quần đảo Ogasawara",
      "inName": "Kepulauan Ogasawara",
      "tlName": "Ogasawara Islands",
      "moName": "Огасавара арлууд",
      "buName": "Ogasawara ကျွန်းများ",
      "khName": "កោះ Ogasawara",
      "neName": "ओगासवारा टापुहरू"
    },
    "class15": {
      "code": "130040",
      "name": "小笠原諸島",
      "enName": "Ogasawara Islands"
    },
    "class20": {
      "code": "1342100",
      "name": "小笠原村",
      "enName": "Ogasawara Village",
      "kana": "おがさわらむら",
      "chName": "小笠原村",
      "zhName": "小笠原村",
      "koName": "오가사와라 촌",
      "esName": "Aldea de Ogasawara",
      "ptName": "povoado de Ogasawara",
      "thName": "หมู่บ้านโองะซาวาระ",
      "viName": "làng Ogasawara",
      "inName": "desa Ogasawara",
      "tlName": "nayon ng Ogasawara",
      "moName": "Огасавара тосгон",
      "buName": "အိုဂါဆာဝါးရာ့ ကျေးရွာ",
      "khName": "ភូមិ អូហ្គាសាវ៉ារ៉ា",
      "neName": "ओगासावारा गाउँ"
    }
  },
  "1410011": {
    "office": {
      "code": "140000",
      "name": "神奈川県",
      "enName": "Kanagawa",
      "officeName": "横浜地方気象台",
      "chName": "神奈川县",
      "zhName": "神奈川縣",
      "koName": "가나가와현",
      "esName": "Prefectura de Kanagawa",
      "ptName": "Província de Kanagawa",
      "thName": "จังหวัดคานางาวะ",
      "viName": "Tỉnh Kanagawa",
      "inName": "Prefektur Kanagawa",
      "tlName": "Kanagawa Prefecture",
      "moName": "Канагава аймаг",
      "buName": "ခန်ဏဂါးဝ ပြည်နယ်",
      "khName": "ខេត្ដ កាណាហ្គាវ៉ា",
      "neName": "कानागावा जिल्ला"
    },
    "class10": {
      "code": "140010",
      "name": "東部",
      "enName": "Eastern Region",
      "chName": "神奈川县东部",
      "zhName": "神奈川縣東部",
      "koName": "카나강 현 동부",
      "esName": "Este de Prefectura de Kanagawa",
      "ptName": "Leste da Província de Kanagawa",
      "thName": "จังหวัดคานางาวะฟากตะวันออก",
      "viName": "Miền Đông tỉnh Kanagawa",
      "inName": "Bagian Timur Prefektur Kanagawa",
      "tlName": "Silangang bahagi ng Kanagawa Prefecture",
      "moName": "Зүүн Канагава аймаг",
      "buName": "ကနဂဝအရှေ့ပိုင်းစီရင်စု",
      "khName": "តំបន់ខាងកើតនៃខេត្ដកាណាហ្គាវ៉ា",
      "neName": "कानागावा जिल्लाको पूर्वी भाग"
    },
    "class15": {
      "code": "140011",
      "name": "横浜・川崎",
      "enName": "Yokohama Kawasaki"
    },
    "class20": {
      "code": "1410011",
      "name": "横浜市北部",
      "enName": "Northern Yokohama City",
      "kana": "よこはましほくぶ"
    }
  },
  "1410012": {
    "office": {
      "code": "140000",
      "name": "神奈川県",
      "enName": "Kanagawa",
      "officeName": "横浜地方気象台",
      "chName": "神奈川县",
      "zhName": "神奈川縣",
      "koName": "가나가와현",
      "esName": "Prefectura de Kanagawa",
      "ptName": "Província de Kanagawa",
      "thName": "จังหวัดคานางาวะ",
      "viName": "Tỉnh Kanagawa",
      "inName": "Prefektur Kanagawa",
      "tlName": "Kanagawa Prefecture",
      "moName": "Канагава аймаг",
      "buName": "ခန်ဏဂါးဝ ပြည်နယ်",
      "khName": "ខេត្ដ កាណាហ្គាវ៉ា",
      "neName": "कानागावा जिल्ला"
    },
    "class10": {
      "code": "140010",
      "name": "東部",
      "enName": "Eastern Region",
      "chName": "神奈川县东部",
      "zhName": "神奈川縣東部",
      "koName": "카나강 현 동부",
      "esName": "Este de Prefectura de Kanagawa",
      "ptName": "Leste da Província de Kanagawa",
      "thName": "จังหวัดคานางาวะฟากตะวันออก",
      "viName": "Miền Đông tỉnh Kanagawa",
      "inName": "Bagian Timur Prefektur Kanagawa",
      "tlName": "Silangang bahagi ng Kanagawa Prefecture",
      "moName": "Зүүн Канагава аймаг",
      "buName": "ကနဂဝအရှေ့ပိုင်းစီရင်စု",
      "khName": "តំបន់ខាងកើតនៃខេត្ដកាណាហ្គាវ៉ា",
      "neName": "कानागावा जिल्लाको पूर्वी भाग"
    },
    "class15": {
      "code": "140011",
      "name": "横浜・川崎",
      "enName": "Yokohama Kawasaki"
    },
    "class20": {
      "code": "1410012",
      "name": "横浜市南部",
      "enName": "Southern Yokohama City",
      "kana": "よこはましなんぶ"
    }
  },
  "1413000": {
    "office": {
      "code": "140000",
      "name": "神奈川県",
      "enName": "Kanagawa",
      "officeName": "横浜地方気象台",
      "chName": "神奈川县",
      "zhName": "神奈川縣",
      "koName": "가나가와현",
      "esName": "Prefectura de Kanagawa",
      "ptName": "Província de Kanagawa",
      "thName": "จังหวัดคานางาวะ",
      "viName": "Tỉnh Kanagawa",
      "inName": "Prefektur Kanagawa",
      "tlName": "Kanagawa Prefecture",
      "moName": "Канагава аймаг",
      "buName": "ခန်ဏဂါးဝ ပြည်နယ်",
      "khName": "ខេត្ដ កាណាហ្គាវ៉ា",
      "neName": "कानागावा जिल्ला"
    },
    "class10": {
      "code": "140010",
      "name": "東部",
      "enName": "Eastern Region",
      "chName": "神奈川县东部",
      "zhName": "神奈川縣東部",
      "koName": "카나강 현 동부",
      "esName": "Este de Prefectura de Kanagawa",
      "ptName": "Leste da Província de Kanagawa",
      "thName": "จังหวัดคานางาวะฟากตะวันออก",
      "viName": "Miền Đông tỉnh Kanagawa",
      "inName": "Bagian Timur Prefektur Kanagawa",
      "tlName": "Silangang bahagi ng Kanagawa Prefecture",
      "moName": "Зүүн Канагава аймаг",
      "buName": "ကနဂဝအရှေ့ပိုင်းစီရင်စု",
      "khName": "តំបន់ខាងកើតនៃខេត្ដកាណាហ្គាវ៉ា",
      "neName": "कानागावा जिल्लाको पूर्वी भाग"
    },
    "class15": {
      "code": "140011",
      "name": "横浜・川崎",
      "enName": "Yokohama Kawasaki"
    },
    "class20": {
      "code": "1413000",
      "name": "川崎市",
      "enName": "Kawasaki City",
      "kana": "かわさきし",
      "chName": "川崎市",
      "zhName": "川崎市",
      "koName": "가와사키시",
      "esName": "Ciudad de Kawasaki",
      "ptName": "Cidade de Kawasaki",
      "thName": "เมืองคาวาซากิ",
      "viName": "Thành phố Kawasaki",
      "inName": "Kota Kawasaki",
      "tlName": "Lungsod ng Kawasaki",
      "moName": "Cidade de Kawasaki",
      "buName": "ကာဝါဆာကီမြို့",
      "khName": "ទីក្រុង Kawasaki",
      "neName": "कावासाकी शहर"
    }
  },
  "1415011": {
    "office": {
      "code": "140000",
      "name": "神奈川県",
      "enName": "Kanagawa",
      "officeName": "横浜地方気象台",
      "chName": "神奈川县",
      "zhName": "神奈川縣",
      "koName": "가나가와현",
      "esName": "Prefectura de Kanagawa",
      "ptName": "Província de Kanagawa",
      "thName": "จังหวัดคานางาวะ",
      "viName": "Tỉnh Kanagawa",
      "inName": "Prefektur Kanagawa",
      "tlName": "Kanagawa Prefecture",
      "moName": "Канагава аймаг",
      "buName": "ခန်ဏဂါးဝ ပြည်နယ်",
      "khName": "ខេត្ដ កាណាហ្គាវ៉ា",
      "neName": "कानागावा जिल्ला"
    },
    "class10": {
      "code": "140020",
      "name": "西部",
      "enName": "Western Region",
      "chName": "神奈川县西部",
      "zhName": "神奈川縣西部",
      "koName": "카나강 현 서부",
      "esName": "Oeste de Prefectura de Kanagawa",
      "ptName": "Oeste da Província de Kanagawa",
      "thName": "จังหวัดคานางาวะฟากตะวันตก",
      "viName": "Miền Tây tỉnh Kanagawa",
      "inName": "Bagian Barat Prefektur Kanagawa",
      "tlName": "Kanlurang bahagi ng Kanagawa Prefecture",
      "moName": "Баруун Канагава аймаг",
      "buName": "ကနဂဝအနောက်ပိုင်းစီရင်စု",
      "khName": "តំបន់ខាងលិចនៃខេត្ដកាណាហ្គាវ៉ា",
      "neName": "कानागावा जिल्लाको पश्चिमी भाग"
    },
    "class15": {
      "code": "140021",
      "name": "相模原",
      "enName": "Sagamihara"
    },
    "class20": {
      "code": "1415011",
      "name": "相模原市西部",
      "enName": "Western Sagamihara City",
      "kana": "さがみはらしせいぶ"
    }
  },
  "1415012": {
    "office": {
      "code": "140000",
      "name": "神奈川県",
      "enName": "Kanagawa",
      "officeName": "横浜地方気象台",
      "chName": "神奈川县",
      "zhName": "神奈川縣",
      "koName": "가나가와현",
      "esName": "Prefectura de Kanagawa",
      "ptName": "Província de Kanagawa",
      "thName": "จังหวัดคานางาวะ",
      "viName": "Tỉnh Kanagawa",
      "inName": "Prefektur Kanagawa",
      "tlName": "Kanagawa Prefecture",
      "moName": "Канагава аймаг",
      "buName": "ခန်ဏဂါးဝ ပြည်နယ်",
      "khName": "ខេត្ដ កាណាហ្គាវ៉ា",
      "neName": "कानागावा जिल्ला"
    },
    "class10": {
      "code": "140020",
      "name": "西部",
      "enName": "Western Region",
      "chName": "神奈川县西部",
      "zhName": "神奈川縣西部",
      "koName": "카나강 현 서부",
      "esName": "Oeste de Prefectura de Kanagawa",
      "ptName": "Oeste da Província de Kanagawa",
      "thName": "จังหวัดคานางาวะฟากตะวันตก",
      "viName": "Miền Tây tỉnh Kanagawa",
      "inName": "Bagian Barat Prefektur Kanagawa",
      "tlName": "Kanlurang bahagi ng Kanagawa Prefecture",
      "moName": "Баруун Канагава аймаг",
      "buName": "ကနဂဝအနောက်ပိုင်းစီရင်စု",
      "khName": "តំបន់ខាងលិចនៃខេត្ដកាណាហ្គាវ៉ា",
      "neName": "कानागावा जिल्लाको पश्चिमी भाग"
    },
    "class15": {
      "code": "140021",
      "name": "相模原",
      "enName": "Sagamihara"
    },
    "class20": {
      "code": "1415012",
      "name": "相模原市東部",
      "enName": "Eastern Sagamihara City",
      "kana": "さがみはらしとうぶ"
    }
  },
  "1420100": {
    "office": {
      "code": "140000",
      "name": "神奈川県",
      "enName": "Kanagawa",
      "officeName": "横浜地方気象台",
      "chName": "神奈川县",
      "zhName": "神奈川縣",
      "koName": "가나가와현",
      "esName": "Prefectura de Kanagawa",
      "ptName": "Província de Kanagawa",
      "thName": "จังหวัดคานางาวะ",
      "viName": "Tỉnh Kanagawa",
      "inName": "Prefektur Kanagawa",
      "tlName": "Kanagawa Prefecture",
      "moName": "Канагава аймаг",
      "buName": "ခန်ဏဂါးဝ ပြည်နယ်",
      "khName": "ខេត្ដ កាណាហ្គាវ៉ា",
      "neName": "कानागावा जिल्ला"
    },
    "class10": {
      "code": "140010",
      "name": "東部",
      "enName": "Eastern Region",
      "chName": "神奈川县东部",
      "zhName": "神奈川縣東部",
      "koName": "카나강 현 동부",
      "esName": "Este de Prefectura de Kanagawa",
      "ptName": "Leste da Província de Kanagawa",
      "thName": "จังหวัดคานางาวะฟากตะวันออก",
      "viName": "Miền Đông tỉnh Kanagawa",
      "inName": "Bagian Timur Prefektur Kanagawa",
      "tlName": "Silangang bahagi ng Kanagawa Prefecture",
      "moName": "Зүүн Канагава аймаг",
      "buName": "ကနဂဝအရှေ့ပိုင်းစီရင်စု",
      "khName": "តំបន់ខាងកើតនៃខេត្ដកាណាហ្គាវ៉ា",
      "neName": "कानागावा जिल्लाको पूर्वी भाग"
    },
    "class15": {
      "code": "140013",
      "name": "三浦半島",
      "enName": "Miura Peninsula"
    },
    "class20": {
      "code": "1420100",
      "name": "横須賀市",
      "enName": "Yokosuka City",
      "kana": "よこすかし",
      "chName": "横须贺市",
      "zhName": "橫須賀市",
      "koName": "요코스카 시",
      "esName": "Ciudad de Yokosuka",
      "ptName": "cidade de Yokosuka",
      "thName": "เมืองโยโคสุกะ",
      "viName": "thành phố Yokosuka",
      "inName": "kota Yokosuka",
      "tlName": "siyudad ng Yokosuka",
      "moName": "Ёкосүка хот",
      "buName": "ယိုကိုးဆုက မြို့",
      "khName": "ទីក្រុង យូកូស៊ូកា",
      "neName": "योकोसुका सहर"
    }
  },
  "1420300": {
    "office": {
      "code": "140000",
      "name": "神奈川県",
      "enName": "Kanagawa",
      "officeName": "横浜地方気象台",
      "chName": "神奈川县",
      "zhName": "神奈川縣",
      "koName": "가나가와현",
      "esName": "Prefectura de Kanagawa",
      "ptName": "Província de Kanagawa",
      "thName": "จังหวัดคานางาวะ",
      "viName": "Tỉnh Kanagawa",
      "inName": "Prefektur Kanagawa",
      "tlName": "Kanagawa Prefecture",
      "moName": "Канагава аймаг",
      "buName": "ခန်ဏဂါးဝ ပြည်နယ်",
      "khName": "ខេត្ដ កាណាហ្គាវ៉ា",
      "neName": "कानागावा जिल्ला"
    },
    "class10": {
      "code": "140010",
      "name": "東部",
      "enName": "Eastern Region",
      "chName": "神奈川县东部",
      "zhName": "神奈川縣東部",
      "koName": "카나강 현 동부",
      "esName": "Este de Prefectura de Kanagawa",
      "ptName": "Leste da Província de Kanagawa",
      "thName": "จังหวัดคานางาวะฟากตะวันออก",
      "viName": "Miền Đông tỉnh Kanagawa",
      "inName": "Bagian Timur Prefektur Kanagawa",
      "tlName": "Silangang bahagi ng Kanagawa Prefecture",
      "moName": "Зүүн Канагава аймаг",
      "buName": "ကနဂဝအရှေ့ပိုင်းစီရင်စု",
      "khName": "តំបន់ខាងកើតនៃខេត្ដកាណាហ្គាវ៉ា",
      "neName": "कानागावा जिल्लाको पूर्वी भाग"
    },
    "class15": {
      "code": "140012",
      "name": "湘南",
      "enName": "Shonan"
    },
    "class20": {
      "code": "1420300",
      "name": "平塚市",
      "enName": "Hiratsuka City",
      "kana": "ひらつかし",
      "chName": "平冢市",
      "zhName": "平塚市",
      "koName": "히라츠카 시",
      "esName": "Ciudad de Hiratsuka",
      "ptName": "cidade de Hiratsuka",
      "thName": "เมืองฮิระสึกะ",
      "viName": "thành phố Hiratsuka",
      "inName": "kota Hiratsuka",
      "tlName": "siyudad ng Hiratsuka",
      "moName": "Хирацүка хот",
      "buName": "ဟီရာ့ဆုက မြို့",
      "khName": "ទីក្រុង ហ៊ីរ៉ាស៊ូកា",
      "neName": "हिरात्सुका सहर"
    }
  },
  "1420400": {
    "office": {
      "code": "140000",
      "name": "神奈川県",
      "enName": "Kanagawa",
      "officeName": "横浜地方気象台",
      "chName": "神奈川县",
      "zhName": "神奈川縣",
      "koName": "가나가와현",
      "esName": "Prefectura de Kanagawa",
      "ptName": "Província de Kanagawa",
      "thName": "จังหวัดคานางาวะ",
      "viName": "Tỉnh Kanagawa",
      "inName": "Prefektur Kanagawa",
      "tlName": "Kanagawa Prefecture",
      "moName": "Канагава аймаг",
      "buName": "ခန်ဏဂါးဝ ပြည်နယ်",
      "khName": "ខេត្ដ កាណាហ្គាវ៉ា",
      "neName": "कानागावा जिल्ला"
    },
    "class10": {
      "code": "140010",
      "name": "東部",
      "enName": "Eastern Region",
      "chName": "神奈川县东部",
      "zhName": "神奈川縣東部",
      "koName": "카나강 현 동부",
      "esName": "Este de Prefectura de Kanagawa",
      "ptName": "Leste da Província de Kanagawa",
      "thName": "จังหวัดคานางาวะฟากตะวันออก",
      "viName": "Miền Đông tỉnh Kanagawa",
      "inName": "Bagian Timur Prefektur Kanagawa",
      "tlName": "Silangang bahagi ng Kanagawa Prefecture",
      "moName": "Зүүн Канагава аймаг",
      "buName": "ကနဂဝအရှေ့ပိုင်းစီရင်စု",
      "khName": "តំបន់ខាងកើតនៃខេត្ដកាណាហ្គាវ៉ា",
      "neName": "कानागावा जिल्लाको पूर्वी भाग"
    },
    "class15": {
      "code": "140013",
      "name": "三浦半島",
      "enName": "Miura Peninsula"
    },
    "class20": {
      "code": "1420400",
      "name": "鎌倉市",
      "enName": "Kamakura City",
      "kana": "かまくらし",
      "chName": "镰仓市",
      "zhName": "鐮倉市",
      "koName": "가마쿠라 시",
      "esName": "Ciudad de Kamakura",
      "ptName": "cidade de Kamakura",
      "thName": "เมืองคามากุระ",
      "viName": "thành phố Kamakura",
      "inName": "kota Kamakura",
      "tlName": "siyudad ng Kamakura",
      "moName": "Камакүра хот",
      "buName": "ကာမာ့ကုရာ့ မြို့",
      "khName": "ទីក្រុង កាម៉ាគូរ៉ា",
      "neName": "कामाकुरा सहर"
    }
  },
  "1420500": {
    "office": {
      "code": "140000",
      "name": "神奈川県",
      "enName": "Kanagawa",
      "officeName": "横浜地方気象台",
      "chName": "神奈川县",
      "zhName": "神奈川縣",
      "koName": "가나가와현",
      "esName": "Prefectura de Kanagawa",
      "ptName": "Província de Kanagawa",
      "thName": "จังหวัดคานางาวะ",
      "viName": "Tỉnh Kanagawa",
      "inName": "Prefektur Kanagawa",
      "tlName": "Kanagawa Prefecture",
      "moName": "Канагава аймаг",
      "buName": "ခန်ဏဂါးဝ ပြည်နယ်",
      "khName": "ខេត្ដ កាណាហ្គាវ៉ា",
      "neName": "कानागावा जिल्ला"
    },
    "class10": {
      "code": "140010",
      "name": "東部",
      "enName": "Eastern Region",
      "chName": "神奈川县东部",
      "zhName": "神奈川縣東部",
      "koName": "카나강 현 동부",
      "esName": "Este de Prefectura de Kanagawa",
      "ptName": "Leste da Província de Kanagawa",
      "thName": "จังหวัดคานางาวะฟากตะวันออก",
      "viName": "Miền Đông tỉnh Kanagawa",
      "inName": "Bagian Timur Prefektur Kanagawa",
      "tlName": "Silangang bahagi ng Kanagawa Prefecture",
      "moName": "Зүүн Канагава аймаг",
      "buName": "ကနဂဝအရှေ့ပိုင်းစီရင်စု",
      "khName": "តំបន់ខាងកើតនៃខេត្ដកាណាហ្គាវ៉ា",
      "neName": "कानागावा जिल्लाको पूर्वी भाग"
    },
    "class15": {
      "code": "140012",
      "name": "湘南",
      "enName": "Shonan"
    },
    "class20": {
      "code": "1420500",
      "name": "藤沢市",
      "enName": "Fujisawa City",
      "kana": "ふじさわし",
      "chName": "藤泽市",
      "zhName": "藤澤市",
      "koName": "후지사와 시",
      "esName": "Ciudad de Fujisawa",
      "ptName": "cidade de Fujisawa",
      "thName": "เมืองฟุจิซาวา",
      "viName": "thành phố Fujisawa",
      "inName": "kota Fujisawa",
      "tlName": "siyudad ng Fujisawa",
      "moName": "Фүжисава хот",
      "buName": "ဖူဂျီဆာ့ဝ မြို့",
      "khName": "ទីក្រុង ហ្វូជីសាវ៉ា",
      "neName": "फुजिसावा सहर"
    }
  },
  "1420600": {
    "office": {
      "code": "140000",
      "name": "神奈川県",
      "enName": "Kanagawa",
      "officeName": "横浜地方気象台",
      "chName": "神奈川县",
      "zhName": "神奈川縣",
      "koName": "가나가와현",
      "esName": "Prefectura de Kanagawa",
      "ptName": "Província de Kanagawa",
      "thName": "จังหวัดคานางาวะ",
      "viName": "Tỉnh Kanagawa",
      "inName": "Prefektur Kanagawa",
      "tlName": "Kanagawa Prefecture",
      "moName": "Канагава аймаг",
      "buName": "ခန်ဏဂါးဝ ပြည်နယ်",
      "khName": "ខេត្ដ កាណាហ្គាវ៉ា",
      "neName": "कानागावा जिल्ला"
    },
    "class10": {
      "code": "140020",
      "name": "西部",
      "enName": "Western Region",
      "chName": "神奈川县西部",
      "zhName": "神奈川縣西部",
      "koName": "카나강 현 서부",
      "esName": "Oeste de Prefectura de Kanagawa",
      "ptName": "Oeste da Província de Kanagawa",
      "thName": "จังหวัดคานางาวะฟากตะวันตก",
      "viName": "Miền Tây tỉnh Kanagawa",
      "inName": "Bagian Barat Prefektur Kanagawa",
      "tlName": "Kanlurang bahagi ng Kanagawa Prefecture",
      "moName": "Баруун Канагава аймаг",
      "buName": "ကနဂဝအနောက်ပိုင်းစီရင်စု",
      "khName": "តំបន់ខាងលិចនៃខេត្ដកាណាហ្គាវ៉ា",
      "neName": "कानागावा जिल्लाको पश्चिमी भाग"
    },
    "class15": {
      "code": "140024",
      "name": "西湘",
      "enName": "Seisho"
    },
    "class20": {
      "code": "1420600",
      "name": "小田原市",
      "enName": "Odawara City",
      "kana": "おだわらし",
      "chName": "小田原市",
      "zhName": "小田原市",
      "koName": "오다와라 시",
      "esName": "Ciudad de Odawara",
      "ptName": "cidade de Odawara",
      "thName": "เมืองโอดาวาระ",
      "viName": "thành phố Odawara",
      "inName": "kota Odawara",
      "tlName": "siyudad ng Odawara",
      "moName": "Одавара хот",
      "buName": "အိုဒါဝါးရာ့ မြို့",
      "khName": "ទីក្រុង អូដាវ៉ារ៉ា",
      "neName": "ओदावारा सहर"
    }
  },
  "1420700": {
    "office": {
      "code": "140000",
      "name": "神奈川県",
      "enName": "Kanagawa",
      "officeName": "横浜地方気象台",
      "chName": "神奈川县",
      "zhName": "神奈川縣",
      "koName": "가나가와현",
      "esName": "Prefectura de Kanagawa",
      "ptName": "Província de Kanagawa",
      "thName": "จังหวัดคานางาวะ",
      "viName": "Tỉnh Kanagawa",
      "inName": "Prefektur Kanagawa",
      "tlName": "Kanagawa Prefecture",
      "moName": "Канагава аймаг",
      "buName": "ခန်ဏဂါးဝ ပြည်နယ်",
      "khName": "ខេត្ដ កាណាហ្គាវ៉ា",
      "neName": "कानागावा जिल्ला"
    },
    "class10": {
      "code": "140010",
      "name": "東部",
      "enName": "Eastern Region",
      "chName": "神奈川县东部",
      "zhName": "神奈川縣東部",
      "koName": "카나강 현 동부",
      "esName": "Este de Prefectura de Kanagawa",
      "ptName": "Leste da Província de Kanagawa",
      "thName": "จังหวัดคานางาวะฟากตะวันออก",
      "viName": "Miền Đông tỉnh Kanagawa",
      "inName": "Bagian Timur Prefektur Kanagawa",
      "tlName": "Silangang bahagi ng Kanagawa Prefecture",
      "moName": "Зүүн Канагава аймаг",
      "buName": "ကနဂဝအရှေ့ပိုင်းစီရင်စု",
      "khName": "តំបន់ខាងកើតនៃខេត្ដកាណាហ្គាវ៉ា",
      "neName": "कानागावा जिल्लाको पूर्वी भाग"
    },
    "class15": {
      "code": "140012",
      "name": "湘南",
      "enName": "Shonan"
    },
    "class20": {
      "code": "1420700",
      "name": "茅ヶ崎市",
      "enName": "Chigasaki City",
      "kana": "ちがさきし",
      "chName": "茅崎市",
      "zhName": "茅崎市",
      "koName": "지가사키 시",
      "esName": "Ciudad de Chigasaki",
      "ptName": "cidade de Chigasaki",
      "thName": "เมืองชิกะซากิ",
      "viName": "thành phố Chigasaki",
      "inName": "kota Chigasaki",
      "tlName": "siyudad ng Chigasaki",
      "moName": "Чигасаки хот",
      "buName": "ကျိဂါဆာ့ကိ မြို့",
      "khName": "ទីក្រុង ជីកាសាគី",
      "neName": "चिगासाकी सहर"
    }
  },
  "1420800": {
    "office": {
      "code": "140000",
      "name": "神奈川県",
      "enName": "Kanagawa",
      "officeName": "横浜地方気象台",
      "chName": "神奈川县",
      "zhName": "神奈川縣",
      "koName": "가나가와현",
      "esName": "Prefectura de Kanagawa",
      "ptName": "Província de Kanagawa",
      "thName": "จังหวัดคานางาวะ",
      "viName": "Tỉnh Kanagawa",
      "inName": "Prefektur Kanagawa",
      "tlName": "Kanagawa Prefecture",
      "moName": "Канагава аймаг",
      "buName": "ခန်ဏဂါးဝ ပြည်နယ်",
      "khName": "ខេត្ដ កាណាហ្គាវ៉ា",
      "neName": "कानागावा जिल्ला"
    },
    "class10": {
      "code": "140010",
      "name": "東部",
      "enName": "Eastern Region",
      "chName": "神奈川县东部",
      "zhName": "神奈川縣東部",
      "koName": "카나강 현 동부",
      "esName": "Este de Prefectura de Kanagawa",
      "ptName": "Leste da Província de Kanagawa",
      "thName": "จังหวัดคานางาวะฟากตะวันออก",
      "viName": "Miền Đông tỉnh Kanagawa",
      "inName": "Bagian Timur Prefektur Kanagawa",
      "tlName": "Silangang bahagi ng Kanagawa Prefecture",
      "moName": "Зүүн Канагава аймаг",
      "buName": "ကနဂဝအရှေ့ပိုင်းစီရင်စု",
      "khName": "តំបន់ខាងកើតនៃខេត្ដកាណាហ្គាវ៉ា",
      "neName": "कानागावा जिल्लाको पूर्वी भाग"
    },
    "class15": {
      "code": "140013",
      "name": "三浦半島",
      "enName": "Miura Peninsula"
    },
    "class20": {
      "code": "1420800",
      "name": "逗子市",
      "enName": "Zushi City",
      "kana": "ずしし",
      "chName": "逗子市",
      "zhName": "逗子市",
      "koName": "즈시 시",
      "esName": "Ciudad de Zushi",
      "ptName": "cidade de Zushi",
      "thName": "เมืองซูชิ",
      "viName": "thành phố Zushi",
      "inName": "kota Zushi",
      "tlName": "siyudad ng Zushi",
      "moName": "Зүши хот",
      "buName": "ဇူရှိ မြို့",
      "khName": "ទីក្រុង ស៊ូហ្សី",
      "neName": "जुशि सहर"
    }
  },
  "1421000": {
    "office": {
      "code": "140000",
      "name": "神奈川県",
      "enName": "Kanagawa",
      "officeName": "横浜地方気象台",
      "chName": "神奈川县",
      "zhName": "神奈川縣",
      "koName": "가나가와현",
      "esName": "Prefectura de Kanagawa",
      "ptName": "Província de Kanagawa",
      "thName": "จังหวัดคานางาวะ",
      "viName": "Tỉnh Kanagawa",
      "inName": "Prefektur Kanagawa",
      "tlName": "Kanagawa Prefecture",
      "moName": "Канагава аймаг",
      "buName": "ခန်ဏဂါးဝ ပြည်နယ်",
      "khName": "ខេត្ដ កាណាហ្គាវ៉ា",
      "neName": "कानागावा जिल्ला"
    },
    "class10": {
      "code": "140010",
      "name": "東部",
      "enName": "Eastern Region",
      "chName": "神奈川县东部",
      "zhName": "神奈川縣東部",
      "koName": "카나강 현 동부",
      "esName": "Este de Prefectura de Kanagawa",
      "ptName": "Leste da Província de Kanagawa",
      "thName": "จังหวัดคานางาวะฟากตะวันออก",
      "viName": "Miền Đông tỉnh Kanagawa",
      "inName": "Bagian Timur Prefektur Kanagawa",
      "tlName": "Silangang bahagi ng Kanagawa Prefecture",
      "moName": "Зүүн Канагава аймаг",
      "buName": "ကနဂဝအရှေ့ပိုင်းစီရင်စု",
      "khName": "តំបន់ខាងកើតនៃខេត្ដកាណាហ្គាវ៉ា",
      "neName": "कानागावा जिल्लाको पूर्वी भाग"
    },
    "class15": {
      "code": "140013",
      "name": "三浦半島",
      "enName": "Miura Peninsula"
    },
    "class20": {
      "code": "1421000",
      "name": "三浦市",
      "enName": "Miura City",
      "kana": "みうらし",
      "chName": "三浦市",
      "zhName": "三浦市",
      "koName": "미우라 시",
      "esName": "Ciudad de Miura",
      "ptName": "cidade de Miura",
      "thName": "เมืองมิอุระ",
      "viName": "thành phố Miura",
      "inName": "kota Miura",
      "tlName": "siyudad ng Miura",
      "moName": "Миүра хот",
      "buName": "မီယူရာ့ မြို့",
      "khName": "ទីក្រុង មីយូរ៉ា",
      "neName": "मिउरा सहर"
    }
  },
  "1421100": {
    "office": {
      "code": "140000",
      "name": "神奈川県",
      "enName": "Kanagawa",
      "officeName": "横浜地方気象台",
      "chName": "神奈川县",
      "zhName": "神奈川縣",
      "koName": "가나가와현",
      "esName": "Prefectura de Kanagawa",
      "ptName": "Província de Kanagawa",
      "thName": "จังหวัดคานางาวะ",
      "viName": "Tỉnh Kanagawa",
      "inName": "Prefektur Kanagawa",
      "tlName": "Kanagawa Prefecture",
      "moName": "Канагава аймаг",
      "buName": "ခန်ဏဂါးဝ ပြည်နယ်",
      "khName": "ខេត្ដ កាណាហ្គាវ៉ា",
      "neName": "कानागावा जिल्ला"
    },
    "class10": {
      "code": "140020",
      "name": "西部",
      "enName": "Western Region",
      "chName": "神奈川县西部",
      "zhName": "神奈川縣西部",
      "koName": "카나강 현 서부",
      "esName": "Oeste de Prefectura de Kanagawa",
      "ptName": "Oeste da Província de Kanagawa",
      "thName": "จังหวัดคานางาวะฟากตะวันตก",
      "viName": "Miền Tây tỉnh Kanagawa",
      "inName": "Bagian Barat Prefektur Kanagawa",
      "tlName": "Kanlurang bahagi ng Kanagawa Prefecture",
      "moName": "Баруун Канагава аймаг",
      "buName": "ကနဂဝအနောက်ပိုင်းစီရင်စု",
      "khName": "តំបន់ខាងលិចនៃខេត្ដកាណាហ្គាវ៉ា",
      "neName": "कानागावा जिल्लाको पश्चिमी भाग"
    },
    "class15": {
      "code": "140022",
      "name": "県央",
      "enName": "Ken-o"
    },
    "class20": {
      "code": "1421100",
      "name": "秦野市",
      "enName": "Hadano City",
      "kana": "はだのし",
      "chName": "秦野市",
      "zhName": "秦野市",
      "koName": "하다노 시",
      "esName": "Ciudad de Hadano",
      "ptName": "cidade de Hadano",
      "thName": "เมืองฮาดาโนะ",
      "viName": "thành phố Hadano",
      "inName": "kota Hadano",
      "tlName": "siyudad ng Hadano",
      "moName": "Хадано хот",
      "buName": "ဟားဒါနို မြို့",
      "khName": "ទីក្រុង ហាដាណូ",
      "neName": "हादानो सहर"
    }
  },
  "1421200": {
    "office": {
      "code": "140000",
      "name": "神奈川県",
      "enName": "Kanagawa",
      "officeName": "横浜地方気象台",
      "chName": "神奈川县",
      "zhName": "神奈川縣",
      "koName": "가나가와현",
      "esName": "Prefectura de Kanagawa",
      "ptName": "Província de Kanagawa",
      "thName": "จังหวัดคานางาวะ",
      "viName": "Tỉnh Kanagawa",
      "inName": "Prefektur Kanagawa",
      "tlName": "Kanagawa Prefecture",
      "moName": "Канагава аймаг",
      "buName": "ခန်ဏဂါးဝ ပြည်နယ်",
      "khName": "ខេត្ដ កាណាហ្គាវ៉ា",
      "neName": "कानागावा जिल्ला"
    },
    "class10": {
      "code": "140020",
      "name": "西部",
      "enName": "Western Region",
      "chName": "神奈川县西部",
      "zhName": "神奈川縣西部",
      "koName": "카나강 현 서부",
      "esName": "Oeste de Prefectura de Kanagawa",
      "ptName": "Oeste da Província de Kanagawa",
      "thName": "จังหวัดคานางาวะฟากตะวันตก",
      "viName": "Miền Tây tỉnh Kanagawa",
      "inName": "Bagian Barat Prefektur Kanagawa",
      "tlName": "Kanlurang bahagi ng Kanagawa Prefecture",
      "moName": "Баруун Канагава аймаг",
      "buName": "ကနဂဝအနောက်ပိုင်းစီရင်စု",
      "khName": "តំបន់ខាងលិចនៃខេត្ដកាណាហ្គាវ៉ា",
      "neName": "कानागावा जिल्लाको पश्चिमी भाग"
    },
    "class15": {
      "code": "140022",
      "name": "県央",
      "enName": "Ken-o"
    },
    "class20": {
      "code": "1421200",
      "name": "厚木市",
      "enName": "Atsugi City",
      "kana": "あつぎし",
      "chName": "厚木市",
      "zhName": "厚木市",
      "koName": "아쓰기 시",
      "esName": "Ciudad de Atsugi",
      "ptName": "cidade de Atsugi",
      "thName": "เมืองอัทสึกิ",
      "viName": "thành phố Atsugi",
      "inName": "kota Atsugi",
      "tlName": "siyudad ng Atsugi",
      "moName": "Ацүги хот",
      "buName": "အာဆုဂိ မြို့",
      "khName": "ទីក្រុង អាត់ស៊ូហ្គី",
      "neName": "आत्सुगी सहर"
    }
  },
  "1421300": {
    "office": {
      "code": "140000",
      "name": "神奈川県",
      "enName": "Kanagawa",
      "officeName": "横浜地方気象台",
      "chName": "神奈川县",
      "zhName": "神奈川縣",
      "koName": "가나가와현",
      "esName": "Prefectura de Kanagawa",
      "ptName": "Província de Kanagawa",
      "thName": "จังหวัดคานางาวะ",
      "viName": "Tỉnh Kanagawa",
      "inName": "Prefektur Kanagawa",
      "tlName": "Kanagawa Prefecture",
      "moName": "Канагава аймаг",
      "buName": "ခန်ဏဂါးဝ ပြည်နယ်",
      "khName": "ខេត្ដ កាណាហ្គាវ៉ា",
      "neName": "कानागावा जिल्ला"
    },
    "class10": {
      "code": "140010",
      "name": "東部",
      "enName": "Eastern Region",
      "chName": "神奈川县东部",
      "zhName": "神奈川縣東部",
      "koName": "카나강 현 동부",
      "esName": "Este de Prefectura de Kanagawa",
      "ptName": "Leste da Província de Kanagawa",
      "thName": "จังหวัดคานางาวะฟากตะวันออก",
      "viName": "Miền Đông tỉnh Kanagawa",
      "inName": "Bagian Timur Prefektur Kanagawa",
      "tlName": "Silangang bahagi ng Kanagawa Prefecture",
      "moName": "Зүүн Канагава аймаг",
      "buName": "ကနဂဝအရှေ့ပိုင်းစီရင်စု",
      "khName": "តំបន់ខាងកើតនៃខេត្ដកាណាហ្គាវ៉ា",
      "neName": "कानागावा जिल्लाको पूर्वी भाग"
    },
    "class15": {
      "code": "140012",
      "name": "湘南",
      "enName": "Shonan"
    },
    "class20": {
      "code": "1421300",
      "name": "大和市",
      "enName": "Yamato City",
      "kana": "やまとし",
      "chName": "大和市",
      "zhName": "大和市",
      "koName": "야마토 시",
      "esName": "Ciudad de Yamato",
      "ptName": "cidade de Yamato",
      "thName": "เมืองยามาโตะ",
      "viName": "thành phố Yamato",
      "inName": "kota Yamato",
      "tlName": "siyudad ng Yamato",
      "moName": "Ямато хот",
      "buName": "ယာမာတို မြို့",
      "khName": "ទីក្រុង យ៉ាម៉ាតូ",
      "neName": "यामातो सहर"
    }
  },
  "1421400": {
    "office": {
      "code": "140000",
      "name": "神奈川県",
      "enName": "Kanagawa",
      "officeName": "横浜地方気象台",
      "chName": "神奈川县",
      "zhName": "神奈川縣",
      "koName": "가나가와현",
      "esName": "Prefectura de Kanagawa",
      "ptName": "Província de Kanagawa",
      "thName": "จังหวัดคานางาวะ",
      "viName": "Tỉnh Kanagawa",
      "inName": "Prefektur Kanagawa",
      "tlName": "Kanagawa Prefecture",
      "moName": "Канагава аймаг",
      "buName": "ခန်ဏဂါးဝ ပြည်နယ်",
      "khName": "ខេត្ដ កាណាហ្គាវ៉ា",
      "neName": "कानागावा जिल्ला"
    },
    "class10": {
      "code": "140020",
      "name": "西部",
      "enName": "Western Region",
      "chName": "神奈川县西部",
      "zhName": "神奈川縣西部",
      "koName": "카나강 현 서부",
      "esName": "Oeste de Prefectura de Kanagawa",
      "ptName": "Oeste da Província de Kanagawa",
      "thName": "จังหวัดคานางาวะฟากตะวันตก",
      "viName": "Miền Tây tỉnh Kanagawa",
      "inName": "Bagian Barat Prefektur Kanagawa",
      "tlName": "Kanlurang bahagi ng Kanagawa Prefecture",
      "moName": "Баруун Канагава аймаг",
      "buName": "ကနဂဝအနောက်ပိုင်းစီရင်စု",
      "khName": "តំបន់ខាងលិចនៃខេត្ដកាណាហ្គាវ៉ា",
      "neName": "कानागावा जिल्लाको पश्चिमी भाग"
    },
    "class15": {
      "code": "140022",
      "name": "県央",
      "enName": "Ken-o"
    },
    "class20": {
      "code": "1421400",
      "name": "伊勢原市",
      "enName": "Isehara City",
      "kana": "いせはらし",
      "chName": "伊势原市",
      "zhName": "伊勢原市",
      "koName": "이세하라 시",
      "esName": "Ciudad de Isehara",
      "ptName": "cidade de Isehara",
      "thName": "เมืองอิเสะฮาระ",
      "viName": "thành phố Isehara",
      "inName": "kota Isehara",
      "tlName": "siyudad ng Isehara",
      "moName": "Исэхара хот",
      "buName": "အီဆဲ့ဟားရာ့ မြို့",
      "khName": "ទីក្រុង អៃសេហារ៉ា",
      "neName": "इसेहारा सहर"
    }
  },
  "1421500": {
    "office": {
      "code": "140000",
      "name": "神奈川県",
      "enName": "Kanagawa",
      "officeName": "横浜地方気象台",
      "chName": "神奈川县",
      "zhName": "神奈川縣",
      "koName": "가나가와현",
      "esName": "Prefectura de Kanagawa",
      "ptName": "Província de Kanagawa",
      "thName": "จังหวัดคานางาวะ",
      "viName": "Tỉnh Kanagawa",
      "inName": "Prefektur Kanagawa",
      "tlName": "Kanagawa Prefecture",
      "moName": "Канагава аймаг",
      "buName": "ခန်ဏဂါးဝ ပြည်နယ်",
      "khName": "ខេត្ដ កាណាហ្គាវ៉ា",
      "neName": "कानागावा जिल्ला"
    },
    "class10": {
      "code": "140010",
      "name": "東部",
      "enName": "Eastern Region",
      "chName": "神奈川县东部",
      "zhName": "神奈川縣東部",
      "koName": "카나강 현 동부",
      "esName": "Este de Prefectura de Kanagawa",
      "ptName": "Leste da Província de Kanagawa",
      "thName": "จังหวัดคานางาวะฟากตะวันออก",
      "viName": "Miền Đông tỉnh Kanagawa",
      "inName": "Bagian Timur Prefektur Kanagawa",
      "tlName": "Silangang bahagi ng Kanagawa Prefecture",
      "moName": "Зүүн Канагава аймаг",
      "buName": "ကနဂဝအရှေ့ပိုင်းစီရင်စု",
      "khName": "តំបន់ខាងកើតនៃខេត្ដកាណាហ្គាវ៉ា",
      "neName": "कानागावा जिल्लाको पूर्वी भाग"
    },
    "class15": {
      "code": "140012",
      "name": "湘南",
      "enName": "Shonan"
    },
    "class20": {
      "code": "1421500",
      "name": "海老名市",
      "enName": "Ebina City",
      "kana": "えびなし",
      "chName": "海老名市",
      "zhName": "海老名市",
      "koName": "에비나 시",
      "esName": "Ciudad de Ebina",
      "ptName": "cidade de Ebina",
      "thName": "เมืองเอบินะ",
      "viName": "thành phố Ebina",
      "inName": "kota Ebina",
      "tlName": "siyudad ng Ebina",
      "moName": "Эбина хот",
      "buName": "အေဘိဏ မြို့",
      "khName": "ទីក្រុង អេប៊ីណា",
      "neName": "एबिना सहर"
    }
  },
  "1421600": {
    "office": {
      "code": "140000",
      "name": "神奈川県",
      "enName": "Kanagawa",
      "officeName": "横浜地方気象台",
      "chName": "神奈川县",
      "zhName": "神奈川縣",
      "koName": "가나가와현",
      "esName": "Prefectura de Kanagawa",
      "ptName": "Província de Kanagawa",
      "thName": "จังหวัดคานางาวะ",
      "viName": "Tỉnh Kanagawa",
      "inName": "Prefektur Kanagawa",
      "tlName": "Kanagawa Prefecture",
      "moName": "Канагава аймаг",
      "buName": "ခန်ဏဂါးဝ ပြည်နယ်",
      "khName": "ខេត្ដ កាណាហ្គាវ៉ា",
      "neName": "कानागावा जिल्ला"
    },
    "class10": {
      "code": "140010",
      "name": "東部",
      "enName": "Eastern Region",
      "chName": "神奈川县东部",
      "zhName": "神奈川縣東部",
      "koName": "카나강 현 동부",
      "esName": "Este de Prefectura de Kanagawa",
      "ptName": "Leste da Província de Kanagawa",
      "thName": "จังหวัดคานางาวะฟากตะวันออก",
      "viName": "Miền Đông tỉnh Kanagawa",
      "inName": "Bagian Timur Prefektur Kanagawa",
      "tlName": "Silangang bahagi ng Kanagawa Prefecture",
      "moName": "Зүүн Канагава аймаг",
      "buName": "ကနဂဝအရှေ့ပိုင်းစီရင်စု",
      "khName": "តំបន់ខាងកើតនៃខេត្ដកាណាហ្គាវ៉ា",
      "neName": "कानागावा जिल्लाको पूर्वी भाग"
    },
    "class15": {
      "code": "140012",
      "name": "湘南",
      "enName": "Shonan"
    },
    "class20": {
      "code": "1421600",
      "name": "座間市",
      "enName": "Zama City",
      "kana": "ざまし",
      "chName": "座间市",
      "zhName": "座間市",
      "koName": "자마 시",
      "esName": "Ciudad de Zama",
      "ptName": "cidade de Zama",
      "thName": "เมืองซามะ",
      "viName": "thành phố Zama",
      "inName": "kota Zama",
      "tlName": "siyudad ng Zama",
      "moName": "Зама хот",
      "buName": "ဇာမာ့ မြို့",
      "khName": "ទីក្រុង ហ្សាម៉ា",
      "neName": "जामा सहर"
    }
  },
  "1421700": {
    "office": {
      "code": "140000",
      "name": "神奈川県",
      "enName": "Kanagawa",
      "officeName": "横浜地方気象台",
      "chName": "神奈川县",
      "zhName": "神奈川縣",
      "koName": "가나가와현",
      "esName": "Prefectura de Kanagawa",
      "ptName": "Província de Kanagawa",
      "thName": "จังหวัดคานางาวะ",
      "viName": "Tỉnh Kanagawa",
      "inName": "Prefektur Kanagawa",
      "tlName": "Kanagawa Prefecture",
      "moName": "Канагава аймаг",
      "buName": "ခန်ဏဂါးဝ ပြည်နယ်",
      "khName": "ខេត្ដ កាណាហ្គាវ៉ា",
      "neName": "कानागावा जिल्ला"
    },
    "class10": {
      "code": "140020",
      "name": "西部",
      "enName": "Western Region",
      "chName": "神奈川县西部",
      "zhName": "神奈川縣西部",
      "koName": "카나강 현 서부",
      "esName": "Oeste de Prefectura de Kanagawa",
      "ptName": "Oeste da Província de Kanagawa",
      "thName": "จังหวัดคานางาวะฟากตะวันตก",
      "viName": "Miền Tây tỉnh Kanagawa",
      "inName": "Bagian Barat Prefektur Kanagawa",
      "tlName": "Kanlurang bahagi ng Kanagawa Prefecture",
      "moName": "Баруун Канагава аймаг",
      "buName": "ကနဂဝအနောက်ပိုင်းစီရင်စု",
      "khName": "តំបន់ខាងលិចនៃខេត្ដកាណាហ្គាវ៉ា",
      "neName": "कानागावा जिल्लाको पश्चिमी भाग"
    },
    "class15": {
      "code": "140023",
      "name": "足柄上",
      "enName": "Ashigara-kami"
    },
    "class20": {
      "code": "1421700",
      "name": "南足柄市",
      "enName": "Minamiashigara City",
      "kana": "みなみあしがらし",
      "chName": "南足柄市",
      "zhName": "南足柄市",
      "koName": "미나미아시가라 시",
      "esName": "Ciudad de Minami-ashigara",
      "ptName": "cidade de Minamiashigara",
      "thName": "เมืองมินามิอาชิงาระ",
      "viName": "thành phố Minamiashigara",
      "inName": "kota Minamiashigara",
      "tlName": "siyudad ng Minamiashigara",
      "moName": "Минамиашигара хот",
      "buName": "မီနာမိယရှိဂါးရာ့ မြို့",
      "khName": "ទីក្រុង មីណាមីស្សីហ្គារ៉ា",
      "neName": "मिनामियाशिगारा सहर"
    }
  },
  "1421800": {
    "office": {
      "code": "140000",
      "name": "神奈川県",
      "enName": "Kanagawa",
      "officeName": "横浜地方気象台",
      "chName": "神奈川县",
      "zhName": "神奈川縣",
      "koName": "가나가와현",
      "esName": "Prefectura de Kanagawa",
      "ptName": "Província de Kanagawa",
      "thName": "จังหวัดคานางาวะ",
      "viName": "Tỉnh Kanagawa",
      "inName": "Prefektur Kanagawa",
      "tlName": "Kanagawa Prefecture",
      "moName": "Канагава аймаг",
      "buName": "ခန်ဏဂါးဝ ပြည်နယ်",
      "khName": "ខេត្ដ កាណាហ្គាវ៉ា",
      "neName": "कानागावा जिल्ला"
    },
    "class10": {
      "code": "140010",
      "name": "東部",
      "enName": "Eastern Region",
      "chName": "神奈川县东部",
      "zhName": "神奈川縣東部",
      "koName": "카나강 현 동부",
      "esName": "Este de Prefectura de Kanagawa",
      "ptName": "Leste da Província de Kanagawa",
      "thName": "จังหวัดคานางาวะฟากตะวันออก",
      "viName": "Miền Đông tỉnh Kanagawa",
      "inName": "Bagian Timur Prefektur Kanagawa",
      "tlName": "Silangang bahagi ng Kanagawa Prefecture",
      "moName": "Зүүн Канагава аймаг",
      "buName": "ကနဂဝအရှေ့ပိုင်းစီရင်စု",
      "khName": "តំបន់ខាងកើតនៃខេត្ដកាណាហ្គាវ៉ា",
      "neName": "कानागावा जिल्लाको पूर्वी भाग"
    },
    "class15": {
      "code": "140012",
      "name": "湘南",
      "enName": "Shonan"
    },
    "class20": {
      "code": "1421800",
      "name": "綾瀬市",
      "enName": "Ayase City",
      "kana": "あやせし",
      "chName": "绫濑市",
      "zhName": "綾瀨市",
      "koName": "아야세 시",
      "esName": "Ciudad de Ayase",
      "ptName": "cidade de Ayase",
      "thName": "เมืองอายาเสะ",
      "viName": "thành phố Ayase",
      "inName": "kota Ayase",
      "tlName": "siyudad ng Ayase",
      "moName": "Аясэ хот",
      "buName": "အာယဆဲ့ မြို့",
      "khName": "ទីក្រុង អេអេស",
      "neName": "आयासे सहर"
    }
  },
  "1430100": {
    "office": {
      "code": "140000",
      "name": "神奈川県",
      "enName": "Kanagawa",
      "officeName": "横浜地方気象台",
      "chName": "神奈川县",
      "zhName": "神奈川縣",
      "koName": "가나가와현",
      "esName": "Prefectura de Kanagawa",
      "ptName": "Província de Kanagawa",
      "thName": "จังหวัดคานางาวะ",
      "viName": "Tỉnh Kanagawa",
      "inName": "Prefektur Kanagawa",
      "tlName": "Kanagawa Prefecture",
      "moName": "Канагава аймаг",
      "buName": "ခန်ဏဂါးဝ ပြည်နယ်",
      "khName": "ខេត្ដ កាណាហ្គាវ៉ា",
      "neName": "कानागावा जिल्ला"
    },
    "class10": {
      "code": "140010",
      "name": "東部",
      "enName": "Eastern Region",
      "chName": "神奈川县东部",
      "zhName": "神奈川縣東部",
      "koName": "카나강 현 동부",
      "esName": "Este de Prefectura de Kanagawa",
      "ptName": "Leste da Província de Kanagawa",
      "thName": "จังหวัดคานางาวะฟากตะวันออก",
      "viName": "Miền Đông tỉnh Kanagawa",
      "inName": "Bagian Timur Prefektur Kanagawa",
      "tlName": "Silangang bahagi ng Kanagawa Prefecture",
      "moName": "Зүүн Канагава аймаг",
      "buName": "ကနဂဝအရှေ့ပိုင်းစီရင်စု",
      "khName": "តំបន់ខាងកើតនៃខេត្ដកាណាហ្គាវ៉ា",
      "neName": "कानागावा जिल्लाको पूर्वी भाग"
    },
    "class15": {
      "code": "140013",
      "name": "三浦半島",
      "enName": "Miura Peninsula"
    },
    "class20": {
      "code": "1430100",
      "name": "葉山町",
      "enName": "Hayama Town",
      "kana": "はやままち",
      "chName": "叶山町",
      "zhName": "葉山町",
      "koName": "하야마 정",
      "esName": "Pueblo de Hayama",
      "ptName": "bairro de Hayama",
      "thName": "เมืองฮายามะ",
      "viName": "thị trấn Hayama",
      "inName": "kota Hayama",
      "tlName": "bayan ng Hayama",
      "moName": "Хaямa жижиг хот",
      "buName": "ဟယာ့မ မြို့နယ်",
      "khName": "ទីប្រជុំជន ហៃយ៉ាម៉ា",
      "neName": "हायामा नगर"
    }
  },
  "1432100": {
    "office": {
      "code": "140000",
      "name": "神奈川県",
      "enName": "Kanagawa",
      "officeName": "横浜地方気象台",
      "chName": "神奈川县",
      "zhName": "神奈川縣",
      "koName": "가나가와현",
      "esName": "Prefectura de Kanagawa",
      "ptName": "Província de Kanagawa",
      "thName": "จังหวัดคานางาวะ",
      "viName": "Tỉnh Kanagawa",
      "inName": "Prefektur Kanagawa",
      "tlName": "Kanagawa Prefecture",
      "moName": "Канагава аймаг",
      "buName": "ခန်ဏဂါးဝ ပြည်နယ်",
      "khName": "ខេត្ដ កាណាហ្គាវ៉ា",
      "neName": "कानागावा जिल्ला"
    },
    "class10": {
      "code": "140010",
      "name": "東部",
      "enName": "Eastern Region",
      "chName": "神奈川县东部",
      "zhName": "神奈川縣東部",
      "koName": "카나강 현 동부",
      "esName": "Este de Prefectura de Kanagawa",
      "ptName": "Leste da Província de Kanagawa",
      "thName": "จังหวัดคานางาวะฟากตะวันออก",
      "viName": "Miền Đông tỉnh Kanagawa",
      "inName": "Bagian Timur Prefektur Kanagawa",
      "tlName": "Silangang bahagi ng Kanagawa Prefecture",
      "moName": "Зүүн Канагава аймаг",
      "buName": "ကနဂဝအရှေ့ပိုင်းစီရင်စု",
      "khName": "តំបន់ខាងកើតនៃខេត្ដកាណាហ្គាវ៉ា",
      "neName": "कानागावा जिल्लाको पूर्वी भाग"
    },
    "class15": {
      "code": "140012",
      "name": "湘南",
      "enName": "Shonan"
    },
    "class20": {
      "code": "1432100",
      "name": "寒川町",
      "enName": "Samukawa Town",
      "kana": "さむかわまち",
      "chName": "寒川町",
      "zhName": "寒川町",
      "koName": "사무카와 정",
      "esName": "Pueblo de Samukawa",
      "ptName": "bairro de Samukawa",
      "thName": "เมืองซามุคาวะ",
      "viName": "thị trấn Samukawa",
      "inName": "kota Samukawa",
      "tlName": "bayan ng Samukawa",
      "moName": "Сaмүкава жижиг хот",
      "buName": "ဆာမုကာ့ဝ မြို့နယ်",
      "khName": "ទីប្រជុំជន សាមូកាវ៉ា",
      "neName": "सामुकावा नगर"
    }
  },
  "1434100": {
    "office": {
      "code": "140000",
      "name": "神奈川県",
      "enName": "Kanagawa",
      "officeName": "横浜地方気象台",
      "chName": "神奈川县",
      "zhName": "神奈川縣",
      "koName": "가나가와현",
      "esName": "Prefectura de Kanagawa",
      "ptName": "Província de Kanagawa",
      "thName": "จังหวัดคานางาวะ",
      "viName": "Tỉnh Kanagawa",
      "inName": "Prefektur Kanagawa",
      "tlName": "Kanagawa Prefecture",
      "moName": "Канагава аймаг",
      "buName": "ခန်ဏဂါးဝ ပြည်နယ်",
      "khName": "ខេត្ដ កាណាហ្គាវ៉ា",
      "neName": "कानागावा जिल्ला"
    },
    "class10": {
      "code": "140010",
      "name": "東部",
      "enName": "Eastern Region",
      "chName": "神奈川县东部",
      "zhName": "神奈川縣東部",
      "koName": "카나강 현 동부",
      "esName": "Este de Prefectura de Kanagawa",
      "ptName": "Leste da Província de Kanagawa",
      "thName": "จังหวัดคานางาวะฟากตะวันออก",
      "viName": "Miền Đông tỉnh Kanagawa",
      "inName": "Bagian Timur Prefektur Kanagawa",
      "tlName": "Silangang bahagi ng Kanagawa Prefecture",
      "moName": "Зүүн Канагава аймаг",
      "buName": "ကနဂဝအရှေ့ပိုင်းစီရင်စု",
      "khName": "តំបន់ខាងកើតនៃខេត្ដកាណាហ្គាវ៉ា",
      "neName": "कानागावा जिल्लाको पूर्वी भाग"
    },
    "class15": {
      "code": "140012",
      "name": "湘南",
      "enName": "Shonan"
    },
    "class20": {
      "code": "1434100",
      "name": "大磯町",
      "enName": "Oiso Town",
      "kana": "おおいそまち",
      "chName": "大矶町",
      "zhName": "大磯町",
      "koName": "오이소 정",
      "esName": "Pueblo de Oiso",
      "ptName": "bairro de Oiso",
      "thName": "เมืองโออิโสะ",
      "viName": "thị trấn Oiso",
      "inName": "kota Oiso",
      "tlName": "bayan ng Oiso",
      "moName": "Ойсо жижиг хот",
      "buName": "အို့ယိဆော့ မြို့နယ်",
      "khName": "ទីប្រជុំជន អូអ៊ីសូ",
      "neName": "ओइसो नगर"
    }
  },
  "1434200": {
    "office": {
      "code": "140000",
      "name": "神奈川県",
      "enName": "Kanagawa",
      "officeName": "横浜地方気象台",
      "chName": "神奈川县",
      "zhName": "神奈川縣",
      "koName": "가나가와현",
      "esName": "Prefectura de Kanagawa",
      "ptName": "Província de Kanagawa",
      "thName": "จังหวัดคานางาวะ",
      "viName": "Tỉnh Kanagawa",
      "inName": "Prefektur Kanagawa",
      "tlName": "Kanagawa Prefecture",
      "moName": "Канагава аймаг",
      "buName": "ခန်ဏဂါးဝ ပြည်နယ်",
      "khName": "ខេត្ដ កាណាហ្គាវ៉ា",
      "neName": "कानागावा जिल्ला"
    },
    "class10": {
      "code": "140010",
      "name": "東部",
      "enName": "Eastern Region",
      "chName": "神奈川县东部",
      "zhName": "神奈川縣東部",
      "koName": "카나강 현 동부",
      "esName": "Este de Prefectura de Kanagawa",
      "ptName": "Leste da Província de Kanagawa",
      "thName": "จังหวัดคานางาวะฟากตะวันออก",
      "viName": "Miền Đông tỉnh Kanagawa",
      "inName": "Bagian Timur Prefektur Kanagawa",
      "tlName": "Silangang bahagi ng Kanagawa Prefecture",
      "moName": "Зүүн Канагава аймаг",
      "buName": "ကနဂဝအရှေ့ပိုင်းစီရင်စု",
      "khName": "តំបន់ខាងកើតនៃខេត្ដកាណាហ្គាវ៉ា",
      "neName": "कानागावा जिल्लाको पूर्वी भाग"
    },
    "class15": {
      "code": "140012",
      "name": "湘南",
      "enName": "Shonan"
    },
    "class20": {
      "code": "1434200",
      "name": "二宮町",
      "enName": "Ninomiya Town",
      "kana": "にのみやまち",
      "chName": "二宫町",
      "zhName": "二宮町",
      "koName": "니노미야 정",
      "esName": "Pueblo de Ninomiya",
      "ptName": "bairro de Ninomiya",
      "thName": "เมืองนิโนมิยะ",
      "viName": "thị trấn Ninomiya",
      "inName": "kota Ninomiya",
      "tlName": "bayan ng Ninomiya",
      "moName": "Ниномия жижиг хот",
      "buName": "နီနိုမိယ မြို့နယ်",
      "khName": "ទីប្រជុំជន នីណូមីយ៉ា",
      "neName": "निनोमिया नगर"
    }
  },
  "1436100": {
    "office": {
      "code": "140000",
      "name": "神奈川県",
      "enName": "Kanagawa",
      "officeName": "横浜地方気象台",
      "chName": "神奈川县",
      "zhName": "神奈川縣",
      "koName": "가나가와현",
      "esName": "Prefectura de Kanagawa",
      "ptName": "Província de Kanagawa",
      "thName": "จังหวัดคานางาวะ",
      "viName": "Tỉnh Kanagawa",
      "inName": "Prefektur Kanagawa",
      "tlName": "Kanagawa Prefecture",
      "moName": "Канагава аймаг",
      "buName": "ခန်ဏဂါးဝ ပြည်နယ်",
      "khName": "ខេត្ដ កាណាហ្គាវ៉ា",
      "neName": "कानागावा जिल्ला"
    },
    "class10": {
      "code": "140020",
      "name": "西部",
      "enName": "Western Region",
      "chName": "神奈川县西部",
      "zhName": "神奈川縣西部",
      "koName": "카나강 현 서부",
      "esName": "Oeste de Prefectura de Kanagawa",
      "ptName": "Oeste da Província de Kanagawa",
      "thName": "จังหวัดคานางาวะฟากตะวันตก",
      "viName": "Miền Tây tỉnh Kanagawa",
      "inName": "Bagian Barat Prefektur Kanagawa",
      "tlName": "Kanlurang bahagi ng Kanagawa Prefecture",
      "moName": "Баруун Канагава аймаг",
      "buName": "ကနဂဝအနောက်ပိုင်းစီရင်စု",
      "khName": "តំបន់ខាងលិចនៃខេត្ដកាណាហ្គាវ៉ា",
      "neName": "कानागावा जिल्लाको पश्चिमी भाग"
    },
    "class15": {
      "code": "140023",
      "name": "足柄上",
      "enName": "Ashigara-kami"
    },
    "class20": {
      "code": "1436100",
      "name": "中井町",
      "enName": "Nakai Town",
      "kana": "なかいまち",
      "chName": "中井町",
      "zhName": "中井町",
      "koName": "나카이 정",
      "esName": "Pueblo de Nakai",
      "ptName": "bairro de Nakai",
      "thName": "เมืองนางาอิ",
      "viName": "thị trấn Nakai",
      "inName": "kota Nakai",
      "tlName": "bayan ng Nakai",
      "moName": "Нaкай жижиг хот",
      "buName": "နာကားယိ မြို့နယ်",
      "khName": "ទីប្រជុំជន ណាកៃ",
      "neName": "नाकाई नगर"
    }
  },
  "1436200": {
    "office": {
      "code": "140000",
      "name": "神奈川県",
      "enName": "Kanagawa",
      "officeName": "横浜地方気象台",
      "chName": "神奈川县",
      "zhName": "神奈川縣",
      "koName": "가나가와현",
      "esName": "Prefectura de Kanagawa",
      "ptName": "Província de Kanagawa",
      "thName": "จังหวัดคานางาวะ",
      "viName": "Tỉnh Kanagawa",
      "inName": "Prefektur Kanagawa",
      "tlName": "Kanagawa Prefecture",
      "moName": "Канагава аймаг",
      "buName": "ခန်ဏဂါးဝ ပြည်နယ်",
      "khName": "ខេត្ដ កាណាហ្គាវ៉ា",
      "neName": "कानागावा जिल्ला"
    },
    "class10": {
      "code": "140020",
      "name": "西部",
      "enName": "Western Region",
      "chName": "神奈川县西部",
      "zhName": "神奈川縣西部",
      "koName": "카나강 현 서부",
      "esName": "Oeste de Prefectura de Kanagawa",
      "ptName": "Oeste da Província de Kanagawa",
      "thName": "จังหวัดคานางาวะฟากตะวันตก",
      "viName": "Miền Tây tỉnh Kanagawa",
      "inName": "Bagian Barat Prefektur Kanagawa",
      "tlName": "Kanlurang bahagi ng Kanagawa Prefecture",
      "moName": "Баруун Канагава аймаг",
      "buName": "ကနဂဝအနောက်ပိုင်းစီရင်စု",
      "khName": "តំបន់ខាងលិចនៃខេត្ដកាណាហ្គាវ៉ា",
      "neName": "कानागावा जिल्लाको पश्चिमी भाग"
    },
    "class15": {
      "code": "140023",
      "name": "足柄上",
      "enName": "Ashigara-kami"
    },
    "class20": {
      "code": "1436200",
      "name": "大井町",
      "enName": "Oi Town",
      "kana": "おおいまち",
      "chName": "神奈川大井町",
      "zhName": "神奈川大井町",
      "koName": "가나가와 오이 정",
      "esName": "Pueblo de Ooi, Kanagawa",
      "ptName": "Kanagawa, bairro de Ooi",
      "thName": "เมืองโออิ คานางาวะ",
      "viName": "Thị trấn Oi, Kanagawa",
      "inName": "Kota Oi, Kanagawa",
      "tlName": "bayan ng Oi, Kanagawa",
      "moName": "Канагава Оои жижиг хот",
      "buName": "ခနဂဝအိုအိုအိမြို့နယ်",
      "khName": "ទីប្រជុំជនអូយ កាណាហ្គាវ៉ា",
      "neName": "कानागावा ओई नगर"
    }
  },
  "1436300": {
    "office": {
      "code": "140000",
      "name": "神奈川県",
      "enName": "Kanagawa",
      "officeName": "横浜地方気象台",
      "chName": "神奈川县",
      "zhName": "神奈川縣",
      "koName": "가나가와현",
      "esName": "Prefectura de Kanagawa",
      "ptName": "Província de Kanagawa",
      "thName": "จังหวัดคานางาวะ",
      "viName": "Tỉnh Kanagawa",
      "inName": "Prefektur Kanagawa",
      "tlName": "Kanagawa Prefecture",
      "moName": "Канагава аймаг",
      "buName": "ခန်ဏဂါးဝ ပြည်နယ်",
      "khName": "ខេត្ដ កាណាហ្គាវ៉ា",
      "neName": "कानागावा जिल्ला"
    },
    "class10": {
      "code": "140020",
      "name": "西部",
      "enName": "Western Region",
      "chName": "神奈川县西部",
      "zhName": "神奈川縣西部",
      "koName": "카나강 현 서부",
      "esName": "Oeste de Prefectura de Kanagawa",
      "ptName": "Oeste da Província de Kanagawa",
      "thName": "จังหวัดคานางาวะฟากตะวันตก",
      "viName": "Miền Tây tỉnh Kanagawa",
      "inName": "Bagian Barat Prefektur Kanagawa",
      "tlName": "Kanlurang bahagi ng Kanagawa Prefecture",
      "moName": "Баруун Канагава аймаг",
      "buName": "ကနဂဝအနောက်ပိုင်းစီရင်စု",
      "khName": "តំបន់ខាងលិចនៃខេត្ដកាណាហ្គាវ៉ា",
      "neName": "कानागावा जिल्लाको पश्चिमी भाग"
    },
    "class15": {
      "code": "140023",
      "name": "足柄上",
      "enName": "Ashigara-kami"
    },
    "class20": {
      "code": "1436300",
      "name": "松田町",
      "enName": "Matsuda Town",
      "kana": "まつだまち",
      "chName": "松田町",
      "zhName": "松田町",
      "koName": "마쓰다 정",
      "esName": "Pueblo de Matsuda",
      "ptName": "bairro de Matsuda",
      "thName": "เมืองมัทสึดะ",
      "viName": "thị trấn Matsuda",
      "inName": "kota Matsuda",
      "tlName": "bayan ng Matsuda",
      "moName": "Мацүда жижиг хот",
      "buName": "မာဆုဒ မြို့နယ်",
      "khName": "ទីប្រជុំជន ម៉ាត់ស៊ូដា",
      "neName": "मात्सुदा नगर"
    }
  },
  "1436400": {
    "office": {
      "code": "140000",
      "name": "神奈川県",
      "enName": "Kanagawa",
      "officeName": "横浜地方気象台",
      "chName": "神奈川县",
      "zhName": "神奈川縣",
      "koName": "가나가와현",
      "esName": "Prefectura de Kanagawa",
      "ptName": "Província de Kanagawa",
      "thName": "จังหวัดคานางาวะ",
      "viName": "Tỉnh Kanagawa",
      "inName": "Prefektur Kanagawa",
      "tlName": "Kanagawa Prefecture",
      "moName": "Канагава аймаг",
      "buName": "ခန်ဏဂါးဝ ပြည်နယ်",
      "khName": "ខេត្ដ កាណាហ្គាវ៉ា",
      "neName": "कानागावा जिल्ला"
    },
    "class10": {
      "code": "140020",
      "name": "西部",
      "enName": "Western Region",
      "chName": "神奈川县西部",
      "zhName": "神奈川縣西部",
      "koName": "카나강 현 서부",
      "esName": "Oeste de Prefectura de Kanagawa",
      "ptName": "Oeste da Província de Kanagawa",
      "thName": "จังหวัดคานางาวะฟากตะวันตก",
      "viName": "Miền Tây tỉnh Kanagawa",
      "inName": "Bagian Barat Prefektur Kanagawa",
      "tlName": "Kanlurang bahagi ng Kanagawa Prefecture",
      "moName": "Баруун Канагава аймаг",
      "buName": "ကနဂဝအနောက်ပိုင်းစီရင်စု",
      "khName": "តំបន់ខាងលិចនៃខេត្ដកាណាហ្គាវ៉ា",
      "neName": "कानागावा जिल्लाको पश्चिमी भाग"
    },
    "class15": {
      "code": "140023",
      "name": "足柄上",
      "enName": "Ashigara-kami"
    },
    "class20": {
      "code": "1436400",
      "name": "山北町",
      "enName": "Yamakita Town",
      "kana": "やまきたまち",
      "chName": "山北町",
      "zhName": "山北町",
      "koName": "야마키타 정",
      "esName": "Pueblo de Yamakita",
      "ptName": "bairro de Yamakita",
      "thName": "เมืองยามาคิตะ",
      "viName": "thị trấn Yamakita",
      "inName": "kota Yamakita",
      "tlName": "bayan ng Yamakita",
      "moName": "Ямaкита жижиг хот",
      "buName": "ယာမခိတ မြို့နယ်",
      "khName": "ទីប្រជុំជន យ៉ាម៉ាគីតា",
      "neName": "यामाकिता नगर"
    }
  },
  "1436600": {
    "office": {
      "code": "140000",
      "name": "神奈川県",
      "enName": "Kanagawa",
      "officeName": "横浜地方気象台",
      "chName": "神奈川县",
      "zhName": "神奈川縣",
      "koName": "가나가와현",
      "esName": "Prefectura de Kanagawa",
      "ptName": "Província de Kanagawa",
      "thName": "จังหวัดคานางาวะ",
      "viName": "Tỉnh Kanagawa",
      "inName": "Prefektur Kanagawa",
      "tlName": "Kanagawa Prefecture",
      "moName": "Канагава аймаг",
      "buName": "ခန်ဏဂါးဝ ပြည်နယ်",
      "khName": "ខេត្ដ កាណាហ្គាវ៉ា",
      "neName": "कानागावा जिल्ला"
    },
    "class10": {
      "code": "140020",
      "name": "西部",
      "enName": "Western Region",
      "chName": "神奈川县西部",
      "zhName": "神奈川縣西部",
      "koName": "카나강 현 서부",
      "esName": "Oeste de Prefectura de Kanagawa",
      "ptName": "Oeste da Província de Kanagawa",
      "thName": "จังหวัดคานางาวะฟากตะวันตก",
      "viName": "Miền Tây tỉnh Kanagawa",
      "inName": "Bagian Barat Prefektur Kanagawa",
      "tlName": "Kanlurang bahagi ng Kanagawa Prefecture",
      "moName": "Баруун Канагава аймаг",
      "buName": "ကနဂဝအနောက်ပိုင်းစီရင်စု",
      "khName": "តំបន់ខាងលិចនៃខេត្ដកាណាហ្គាវ៉ា",
      "neName": "कानागावा जिल्लाको पश्चिमी भाग"
    },
    "class15": {
      "code": "140023",
      "name": "足柄上",
      "enName": "Ashigara-kami"
    },
    "class20": {
      "code": "1436600",
      "name": "開成町",
      "enName": "Kaisei Town",
      "kana": "かいせいまち",
      "chName": "开成町",
      "zhName": "開成町",
      "koName": "가이세이 정",
      "esName": "Pueblo de Kaisei",
      "ptName": "bairro de Kaisei",
      "thName": "เมืองไคเซ",
      "viName": "thị trấn Kaisei",
      "inName": "kota Kaisei",
      "tlName": "bayan ng Kaisei",
      "moName": "Кайсэй жижиг хот",
      "buName": "ခိုင်ယိဆဲ့ မြို့နယ်",
      "khName": "ទីប្រជុំជន ឃេសី",
      "neName": "काइसेई नगर"
    }
  },
  "1438200": {
    "office": {
      "code": "140000",
      "name": "神奈川県",
      "enName": "Kanagawa",
      "officeName": "横浜地方気象台",
      "chName": "神奈川县",
      "zhName": "神奈川縣",
      "koName": "가나가와현",
      "esName": "Prefectura de Kanagawa",
      "ptName": "Província de Kanagawa",
      "thName": "จังหวัดคานางาวะ",
      "viName": "Tỉnh Kanagawa",
      "inName": "Prefektur Kanagawa",
      "tlName": "Kanagawa Prefecture",
      "moName": "Канагава аймаг",
      "buName": "ခန်ဏဂါးဝ ပြည်နယ်",
      "khName": "ខេត្ដ កាណាហ្គាវ៉ា",
      "neName": "कानागावा जिल्ला"
    },
    "class10": {
      "code": "140020",
      "name": "西部",
      "enName": "Western Region",
      "chName": "神奈川县西部",
      "zhName": "神奈川縣西部",
      "koName": "카나강 현 서부",
      "esName": "Oeste de Prefectura de Kanagawa",
      "ptName": "Oeste da Província de Kanagawa",
      "thName": "จังหวัดคานางาวะฟากตะวันตก",
      "viName": "Miền Tây tỉnh Kanagawa",
      "inName": "Bagian Barat Prefektur Kanagawa",
      "tlName": "Kanlurang bahagi ng Kanagawa Prefecture",
      "moName": "Баруун Канагава аймаг",
      "buName": "ကနဂဝအနောက်ပိုင်းစီရင်စု",
      "khName": "តំបន់ខាងលិចនៃខេត្ដកាណាហ្គាវ៉ា",
      "neName": "कानागावा जिल्लाको पश्चिमी भाग"
    },
    "class15": {
      "code": "140024",
      "name": "西湘",
      "enName": "Seisho"
    },
    "class20": {
      "code": "1438200",
      "name": "箱根町",
      "enName": "Hakone Town",
      "kana": "はこねまち",
      "chName": "箱根町",
      "zhName": "箱根町",
      "koName": "하코네 정",
      "esName": "Pueblo de Hakone",
      "ptName": "bairro de Hakone",
      "thName": "เมืองฮาโกเนะ",
      "viName": "thị trấn Hakone",
      "inName": "kota Hakone",
      "tlName": "bayan ng Hakone",
      "moName": "Хaконэ жижиг хот",
      "buName": "ဟာကို့နဲ့ မြို့နယ်",
      "khName": "ទីប្រជុំជន ហាកូណេ",
      "neName": "हाकोने नगर"
    }
  },
  "1438300": {
    "office": {
      "code": "140000",
      "name": "神奈川県",
      "enName": "Kanagawa",
      "officeName": "横浜地方気象台",
      "chName": "神奈川县",
      "zhName": "神奈川縣",
      "koName": "가나가와현",
      "esName": "Prefectura de Kanagawa",
      "ptName": "Província de Kanagawa",
      "thName": "จังหวัดคานางาวะ",
      "viName": "Tỉnh Kanagawa",
      "inName": "Prefektur Kanagawa",
      "tlName": "Kanagawa Prefecture",
      "moName": "Канагава аймаг",
      "buName": "ခန်ဏဂါးဝ ပြည်နယ်",
      "khName": "ខេត្ដ កាណាហ្គាវ៉ា",
      "neName": "कानागावा जिल्ला"
    },
    "class10": {
      "code": "140020",
      "name": "西部",
      "enName": "Western Region",
      "chName": "神奈川县西部",
      "zhName": "神奈川縣西部",
      "koName": "카나강 현 서부",
      "esName": "Oeste de Prefectura de Kanagawa",
      "ptName": "Oeste da Província de Kanagawa",
      "thName": "จังหวัดคานางาวะฟากตะวันตก",
      "viName": "Miền Tây tỉnh Kanagawa",
      "inName": "Bagian Barat Prefektur Kanagawa",
      "tlName": "Kanlurang bahagi ng Kanagawa Prefecture",
      "moName": "Баруун Канагава аймаг",
      "buName": "ကနဂဝအနောက်ပိုင်းစီရင်စု",
      "khName": "តំបន់ខាងលិចនៃខេត្ដកាណាហ្គាវ៉ា",
      "neName": "कानागावा जिल्लाको पश्चिमी भाग"
    },
    "class15": {
      "code": "140024",
      "name": "西湘",
      "enName": "Seisho"
    },
    "class20": {
      "code": "1438300",
      "name": "真鶴町",
      "enName": "Manazuru Town",
      "kana": "まなつるまち",
      "chName": "真鹤町",
      "zhName": "眞鶴町",
      "koName": "마나즈루 정",
      "esName": "Pueblo de Manazuru",
      "ptName": "bairro de Manazuru",
      "thName": "เมืองมานาซารุ",
      "viName": "thị trấn Manazuru",
      "inName": "kota Manazuru",
      "tlName": "bayan ng Manazuru",
      "moName": "Мaнaзүрү жижиг хот",
      "buName": "မာနဇုရု မြို့နယ်",
      "khName": "ទីប្រជុំជន ម៉ាណាស៊ូរូ ",
      "neName": "मानाजुरु नगर"
    }
  },
  "1438400": {
    "office": {
      "code": "140000",
      "name": "神奈川県",
      "enName": "Kanagawa",
      "officeName": "横浜地方気象台",
      "chName": "神奈川县",
      "zhName": "神奈川縣",
      "koName": "가나가와현",
      "esName": "Prefectura de Kanagawa",
      "ptName": "Província de Kanagawa",
      "thName": "จังหวัดคานางาวะ",
      "viName": "Tỉnh Kanagawa",
      "inName": "Prefektur Kanagawa",
      "tlName": "Kanagawa Prefecture",
      "moName": "Канагава аймаг",
      "buName": "ခန်ဏဂါးဝ ပြည်နယ်",
      "khName": "ខេត្ដ កាណាហ្គាវ៉ា",
      "neName": "कानागावा जिल्ला"
    },
    "class10": {
      "code": "140020",
      "name": "西部",
      "enName": "Western Region",
      "chName": "神奈川县西部",
      "zhName": "神奈川縣西部",
      "koName": "카나강 현 서부",
      "esName": "Oeste de Prefectura de Kanagawa",
      "ptName": "Oeste da Província de Kanagawa",
      "thName": "จังหวัดคานางาวะฟากตะวันตก",
      "viName": "Miền Tây tỉnh Kanagawa",
      "inName": "Bagian Barat Prefektur Kanagawa",
      "tlName": "Kanlurang bahagi ng Kanagawa Prefecture",
      "moName": "Баруун Канагава аймаг",
      "buName": "ကနဂဝအနောက်ပိုင်းစီရင်စု",
      "khName": "តំបន់ខាងលិចនៃខេត្ដកាណាហ្គាវ៉ា",
      "neName": "कानागावा जिल्लाको पश्चिमी भाग"
    },
    "class15": {
      "code": "140024",
      "name": "西湘",
      "enName": "Seisho"
    },
    "class20": {
      "code": "1438400",
      "name": "湯河原町",
      "enName": "Yugawara Town",
      "kana": "ゆがわらまち",
      "chName": "汤河原町",
      "zhName": "湯河原町",
      "koName": "유가와라 정",
      "esName": "Pueblo de Yugawara",
      "ptName": "bairro de Yugawara",
      "thName": "เมืองยูงาวาระ",
      "viName": "thị trấn Yugawara",
      "inName": "kota Yugawara",
      "tlName": "bayan ng Yugawara",
      "moName": "Югавара жижиг хот",
      "buName": "ယူဂါဝါ့ရ မြို့နယ်",
      "khName": "ទីប្រជុំជន យូហ្កាវ៉ារ៉ា",
      "neName": "युगावारा नगर"
    }
  },
  "1440100": {
    "office": {
      "code": "140000",
      "name": "神奈川県",
      "enName": "Kanagawa",
      "officeName": "横浜地方気象台",
      "chName": "神奈川县",
      "zhName": "神奈川縣",
      "koName": "가나가와현",
      "esName": "Prefectura de Kanagawa",
      "ptName": "Província de Kanagawa",
      "thName": "จังหวัดคานางาวะ",
      "viName": "Tỉnh Kanagawa",
      "inName": "Prefektur Kanagawa",
      "tlName": "Kanagawa Prefecture",
      "moName": "Канагава аймаг",
      "buName": "ခန်ဏဂါးဝ ပြည်နယ်",
      "khName": "ខេត្ដ កាណាហ្គាវ៉ា",
      "neName": "कानागावा जिल्ला"
    },
    "class10": {
      "code": "140020",
      "name": "西部",
      "enName": "Western Region",
      "chName": "神奈川县西部",
      "zhName": "神奈川縣西部",
      "koName": "카나강 현 서부",
      "esName": "Oeste de Prefectura de Kanagawa",
      "ptName": "Oeste da Província de Kanagawa",
      "thName": "จังหวัดคานางาวะฟากตะวันตก",
      "viName": "Miền Tây tỉnh Kanagawa",
      "inName": "Bagian Barat Prefektur Kanagawa",
      "tlName": "Kanlurang bahagi ng Kanagawa Prefecture",
      "moName": "Баруун Канагава аймаг",
      "buName": "ကနဂဝအနောက်ပိုင်းစီရင်စု",
      "khName": "តំបន់ខាងលិចនៃខេត្ដកាណាហ្គាវ៉ា",
      "neName": "कानागावा जिल्लाको पश्चिमी भाग"
    },
    "class15": {
      "code": "140022",
      "name": "県央",
      "enName": "Ken-o"
    },
    "class20": {
      "code": "1440100",
      "name": "愛川町",
      "enName": "Aikawa Town",
      "kana": "あいかわまち",
      "chName": "爱川町",
      "zhName": "愛川町",
      "koName": "아이카와 정",
      "esName": "Pueblo de Aikawa",
      "ptName": "bairro de Aikawa",
      "thName": "เมืองไอคาวะ",
      "viName": "thị trấn Aikawa",
      "inName": "kota Aikawa",
      "tlName": "bayan ng Aikawa",
      "moName": "Айкава жижиг хот",
      "buName": "အာယိကာ့ဝ မြို့နယ်",
      "khName": "ទីប្រជុំជន អាយកាវ៉ា",
      "neName": "आइकावा नगर"
    }
  },
  "1440200": {
    "office": {
      "code": "140000",
      "name": "神奈川県",
      "enName": "Kanagawa",
      "officeName": "横浜地方気象台",
      "chName": "神奈川县",
      "zhName": "神奈川縣",
      "koName": "가나가와현",
      "esName": "Prefectura de Kanagawa",
      "ptName": "Província de Kanagawa",
      "thName": "จังหวัดคานางาวะ",
      "viName": "Tỉnh Kanagawa",
      "inName": "Prefektur Kanagawa",
      "tlName": "Kanagawa Prefecture",
      "moName": "Канагава аймаг",
      "buName": "ခန်ဏဂါးဝ ပြည်နယ်",
      "khName": "ខេត្ដ កាណាហ្គាវ៉ា",
      "neName": "कानागावा जिल्ला"
    },
    "class10": {
      "code": "140020",
      "name": "西部",
      "enName": "Western Region",
      "chName": "神奈川县西部",
      "zhName": "神奈川縣西部",
      "koName": "카나강 현 서부",
      "esName": "Oeste de Prefectura de Kanagawa",
      "ptName": "Oeste da Província de Kanagawa",
      "thName": "จังหวัดคานางาวะฟากตะวันตก",
      "viName": "Miền Tây tỉnh Kanagawa",
      "inName": "Bagian Barat Prefektur Kanagawa",
      "tlName": "Kanlurang bahagi ng Kanagawa Prefecture",
      "moName": "Баруун Канагава аймаг",
      "buName": "ကနဂဝအနောက်ပိုင်းစီရင်စု",
      "khName": "តំបន់ខាងលិចនៃខេត្ដកាណាហ្គាវ៉ា",
      "neName": "कानागावा जिल्लाको पश्चिमी भाग"
    },
    "class15": {
      "code": "140022",
      "name": "県央",
      "enName": "Ken-o"
    },
    "class20": {
      "code": "1440200",
      "name": "清川村",
      "enName": "Kiyokawa Village",
      "kana": "きよかわむら",
      "chName": "清川村",
      "zhName": "清川村",
      "koName": "기요카와 촌",
      "esName": "Aldea de Kiyokawa",
      "ptName": "povoado de Kiyokawa",
      "thName": "หมู่บ้านคิโยคาวะ",
      "viName": "làng Kiyokawa",
      "inName": "desa Kiyokawa",
      "tlName": "nayon ng Kiyokawa",
      "moName": "Киёкава тосгон",
      "buName": "ကီယိုကာ့ဝ ကျေးရွာ",
      "khName": "ភូមិ គីយូកាវ៉ា",
      "neName": "कियोकावा गाउँ"
    }
  },
  "1510000": {
    "office": {
      "code": "150000",
      "name": "新潟県",
      "enName": "Niigata",
      "officeName": "新潟地方気象台",
      "chName": "新泻县",
      "zhName": "新潟縣",
      "koName": "니가타현",
      "esName": "Prefectura de Niigata",
      "ptName": "Província de Niigata",
      "thName": "จังหวัดนีงาตะ",
      "viName": "Tỉnh Niigata",
      "inName": "Prefektur Niigata",
      "tlName": "Niigata Prefecture",
      "moName": "Нийгата аймаг",
      "buName": "ဏီးဂါ့တ ပြည်နယ်",
      "khName": "ខេត្ដ នីហ្គាតា",
      "neName": "निइगाता जिल्ला"
    },
    "class10": {
      "code": "150010",
      "name": "下越",
      "enName": "Kaetsu",
      "chName": "新泻县下越地方",
      "zhName": "新瀉縣下越地方",
      "koName": "니가타 현 시모고에 지방",
      "esName": "Región Kaetsu, Prefectura de Niigata",
      "ptName": "Região de Kaetsu da Província de Niigata",
      "thName": "ท้องถิ่นคาเอ็ตสึ จังหวัดนีงาตะ",
      "viName": "Vùng Kaetsu tỉnh Niigata",
      "inName": "Daerah Kaetsu di Prefektur Niigata",
      "tlName": "Rehiyon ng Kaetsu sa Niigata Prefecture",
      "moName": "Ниигата аймаг, Каэцү муж",
      "buName": "ကအဲဆု၊ နိအိဂတစီရင်စု",
      "khName": "តំបន់កាអែហ្សីនៃខេត្ដនីហ្គាតាក់ឹ",
      "neName": "निइगाता जिल्ला, काएचु क्षेत्र"
    },
    "class15": {
      "code": "150011",
      "name": "新潟地域",
      "enName": "Niigata Area"
    },
    "class20": {
      "code": "1510000",
      "name": "新潟市",
      "enName": "Niigata City",
      "kana": "にいがたし",
      "chName": "新泻市",
      "zhName": "新潟市",
      "koName": "니가타시",
      "esName": "Ciudad de Niigata",
      "ptName": "Cidade de Niigata",
      "thName": "เมืองนีงะตะ",
      "viName": "Thành phố Niigata",
      "inName": "Kota Niigata",
      "tlName": "Lungsod ng Niigata",
      "moName": "Cidade de Niigata",
      "buName": "နီဂါတာမြို့",
      "khName": "ទីក្រុង Niigata",
      "neName": "निगाता शहर"
    }
  },
  "1520200": {
    "office": {
      "code": "150000",
      "name": "新潟県",
      "enName": "Niigata",
      "officeName": "新潟地方気象台",
      "chName": "新泻县",
      "zhName": "新潟縣",
      "koName": "니가타현",
      "esName": "Prefectura de Niigata",
      "ptName": "Província de Niigata",
      "thName": "จังหวัดนีงาตะ",
      "viName": "Tỉnh Niigata",
      "inName": "Prefektur Niigata",
      "tlName": "Niigata Prefecture",
      "moName": "Нийгата аймаг",
      "buName": "ဏီးဂါ့တ ပြည်နယ်",
      "khName": "ខេត្ដ នីហ្គាតា",
      "neName": "निइगाता जिल्ला"
    },
    "class10": {
      "code": "150020",
      "name": "中越",
      "enName": "Chuetsu",
      "chName": "新泻县中越地方",
      "zhName": "新瀉縣中越地方",
      "koName": "니가타 현 주에쓰 지방",
      "esName": "Región Chuetsu, Prefectura de Niigata",
      "ptName": "Região de Chūetsu da Província de Niigata",
      "thName": "ท้องถิ่นจูเอ็ตสึ จังหวัดนีงาตะ",
      "viName": "Vùng Chuetsu tỉnh Niigata",
      "inName": "Daerah Chuetsu di Prefektur Niigata",
      "tlName": "Rehiyon ng Chuetsu sa Niigata Prefecture",
      "moName": "Нийгата аймаг,  Чүэцү муж",
      "buName": "ချူးအဲဆု၊ နိအိဂတစီရင်စု",
      "khName": "តំបន់ឈឹអែហ្សីនៃខេត្ដនីហ្គាតាក់ឹ",
      "neName": "निइगाता जिल्ला, च्युएचु क्षेत्र"
    },
    "class15": {
      "code": "150021",
      "name": "長岡地域",
      "enName": "Nagaoka Area"
    },
    "class20": {
      "code": "1520200",
      "name": "長岡市",
      "enName": "Nagaoka City",
      "kana": "ながおかし",
      "chName": "长冈市",
      "zhName": "長岡市",
      "koName": "나가오카 시",
      "esName": "Ciudad de Nagaoka",
      "ptName": "cidade de Nagaoka",
      "thName": "เมืองนางาโอกะ",
      "viName": "thành phố Nagaoka",
      "inName": "kota Nagaoka",
      "tlName": "siyudad ng Nagaoka",
      "moName": "Нaгaока хот",
      "buName": "နာဂါအိုးက မြို့",
      "khName": "ទីក្រុង ណាហ្គាអូកា",
      "neName": "नागाओका सहर"
    }
  },
  "1520400": {
    "office": {
      "code": "150000",
      "name": "新潟県",
      "enName": "Niigata",
      "officeName": "新潟地方気象台",
      "chName": "新泻县",
      "zhName": "新潟縣",
      "koName": "니가타현",
      "esName": "Prefectura de Niigata",
      "ptName": "Província de Niigata",
      "thName": "จังหวัดนีงาตะ",
      "viName": "Tỉnh Niigata",
      "inName": "Prefektur Niigata",
      "tlName": "Niigata Prefecture",
      "moName": "Нийгата аймаг",
      "buName": "ဏီးဂါ့တ ပြည်နယ်",
      "khName": "ខេត្ដ នីហ្គាតា",
      "neName": "निइगाता जिल्ला"
    },
    "class10": {
      "code": "150020",
      "name": "中越",
      "enName": "Chuetsu",
      "chName": "新泻县中越地方",
      "zhName": "新瀉縣中越地方",
      "koName": "니가타 현 주에쓰 지방",
      "esName": "Región Chuetsu, Prefectura de Niigata",
      "ptName": "Região de Chūetsu da Província de Niigata",
      "thName": "ท้องถิ่นจูเอ็ตสึ จังหวัดนีงาตะ",
      "viName": "Vùng Chuetsu tỉnh Niigata",
      "inName": "Daerah Chuetsu di Prefektur Niigata",
      "tlName": "Rehiyon ng Chuetsu sa Niigata Prefecture",
      "moName": "Нийгата аймаг,  Чүэцү муж",
      "buName": "ချူးအဲဆု၊ နိအိဂတစီရင်စု",
      "khName": "តំបន់ឈឹអែហ្សីនៃខេត្ដនីហ្គាតាក់ឹ",
      "neName": "निइगाता जिल्ला, च्युएचु क्षेत्र"
    },
    "class15": {
      "code": "150022",
      "name": "三条地域",
      "enName": "Sanjo Area"
    },
    "class20": {
      "code": "1520400",
      "name": "三条市",
      "enName": "Sanjo City",
      "kana": "さんじょうし",
      "chName": "三条市",
      "zhName": "三條市",
      "koName": "산조 시",
      "esName": "Ciudad de Sanjyo",
      "ptName": "cidade de Sanjo",
      "thName": "เมืองซันโจ",
      "viName": "thành phố Sanjo",
      "inName": "kota Sanjo",
      "tlName": "siyudad ng Sanjo",
      "moName": "Санжо хот",
      "buName": "ဆန်ဂျို မြို့",
      "khName": "ទីក្រុង សាន់ជូ",
      "neName": "सान्जो सहर"
    }
  },
  "1520500": {
    "office": {
      "code": "150000",
      "name": "新潟県",
      "enName": "Niigata",
      "officeName": "新潟地方気象台",
      "chName": "新泻县",
      "zhName": "新潟縣",
      "koName": "니가타현",
      "esName": "Prefectura de Niigata",
      "ptName": "Província de Niigata",
      "thName": "จังหวัดนีงาตะ",
      "viName": "Tỉnh Niigata",
      "inName": "Prefektur Niigata",
      "tlName": "Niigata Prefecture",
      "moName": "Нийгата аймаг",
      "buName": "ဏီးဂါ့တ ပြည်နယ်",
      "khName": "ខេត្ដ នីហ្គាតា",
      "neName": "निइगाता जिल्ला"
    },
    "class10": {
      "code": "150020",
      "name": "中越",
      "enName": "Chuetsu",
      "chName": "新泻县中越地方",
      "zhName": "新瀉縣中越地方",
      "koName": "니가타 현 주에쓰 지방",
      "esName": "Región Chuetsu, Prefectura de Niigata",
      "ptName": "Região de Chūetsu da Província de Niigata",
      "thName": "ท้องถิ่นจูเอ็ตสึ จังหวัดนีงาตะ",
      "viName": "Vùng Chuetsu tỉnh Niigata",
      "inName": "Daerah Chuetsu di Prefektur Niigata",
      "tlName": "Rehiyon ng Chuetsu sa Niigata Prefecture",
      "moName": "Нийгата аймаг,  Чүэцү муж",
      "buName": "ချူးအဲဆု၊ နိအိဂတစီရင်စု",
      "khName": "តំបន់ឈឹអែហ្សីនៃខេត្ដនីហ្គាតាក់ឹ",
      "neName": "निइगाता जिल्ला, च्युएचु क्षेत्र"
    },
    "class15": {
      "code": "150024",
      "name": "柏崎地域",
      "enName": "Kashiwazaki Area"
    },
    "class20": {
      "code": "1520500",
      "name": "柏崎市",
      "enName": "Kashiwazaki City",
      "kana": "かしわざきし",
      "chName": "柏崎市",
      "zhName": "柏崎市",
      "koName": "가시와자키 시",
      "esName": "Ciudad de Kashiwazaki",
      "ptName": "cidade de Kashiwazaki",
      "thName": "เมืองคาชิวาซากิ",
      "viName": "thành phố Kashiwazaki",
      "inName": "kota Kashiwazaki",
      "tlName": "siyudad ng Kashiwazaki",
      "moName": "Кашивазaки хот",
      "buName": "ကာရှိဝါဇာ့ကိ မြို့",
      "khName": "ទីក្រុង កាស្សីវ៉ាសាគី",
      "neName": "काशिवाजाकी सहर"
    }
  },
  "1520600": {
    "office": {
      "code": "150000",
      "name": "新潟県",
      "enName": "Niigata",
      "officeName": "新潟地方気象台",
      "chName": "新泻县",
      "zhName": "新潟縣",
      "koName": "니가타현",
      "esName": "Prefectura de Niigata",
      "ptName": "Província de Niigata",
      "thName": "จังหวัดนีงาตะ",
      "viName": "Tỉnh Niigata",
      "inName": "Prefektur Niigata",
      "tlName": "Niigata Prefecture",
      "moName": "Нийгата аймаг",
      "buName": "ဏီးဂါ့တ ပြည်နယ်",
      "khName": "ខេត្ដ នីហ្គាតា",
      "neName": "निइगाता जिल्ला"
    },
    "class10": {
      "code": "150010",
      "name": "下越",
      "enName": "Kaetsu",
      "chName": "新泻县下越地方",
      "zhName": "新瀉縣下越地方",
      "koName": "니가타 현 시모고에 지방",
      "esName": "Región Kaetsu, Prefectura de Niigata",
      "ptName": "Região de Kaetsu da Província de Niigata",
      "thName": "ท้องถิ่นคาเอ็ตสึ จังหวัดนีงาตะ",
      "viName": "Vùng Kaetsu tỉnh Niigata",
      "inName": "Daerah Kaetsu di Prefektur Niigata",
      "tlName": "Rehiyon ng Kaetsu sa Niigata Prefecture",
      "moName": "Ниигата аймаг, Каэцү муж",
      "buName": "ကအဲဆု၊ နိအိဂတစီရင်စု",
      "khName": "តំបន់កាអែហ្សីនៃខេត្ដនីហ្គាតាក់ឹ",
      "neName": "निइगाता जिल्ला, काएचु क्षेत्र"
    },
    "class15": {
      "code": "150013",
      "name": "新発田地域",
      "enName": "Shibata Area"
    },
    "class20": {
      "code": "1520600",
      "name": "新発田市",
      "enName": "Shibata City",
      "kana": "しばたし",
      "chName": "新发田市",
      "zhName": "新發田市",
      "koName": "시바타 시",
      "esName": "Ciudad de Shibata",
      "ptName": "cidade de Shibata",
      "thName": "เมืองชิบาตะ",
      "viName": "thành phố Shibata",
      "inName": "kota Shibata",
      "tlName": "siyudad ng Shibata",
      "moName": "Шибата хот",
      "buName": "ရှီဘာ့တ မြို့",
      "khName": "ទីក្រុង ស៊ីបេតា",
      "neName": "शिबाता सहर"
    }
  },
  "1520800": {
    "office": {
      "code": "150000",
      "name": "新潟県",
      "enName": "Niigata",
      "officeName": "新潟地方気象台",
      "chName": "新泻县",
      "zhName": "新潟縣",
      "koName": "니가타현",
      "esName": "Prefectura de Niigata",
      "ptName": "Província de Niigata",
      "thName": "จังหวัดนีงาตะ",
      "viName": "Tỉnh Niigata",
      "inName": "Prefektur Niigata",
      "tlName": "Niigata Prefecture",
      "moName": "Нийгата аймаг",
      "buName": "ဏီးဂါ့တ ပြည်နယ်",
      "khName": "ខេត្ដ នីហ្គាតា",
      "neName": "निइगाता जिल्ला"
    },
    "class10": {
      "code": "150020",
      "name": "中越",
      "enName": "Chuetsu",
      "chName": "新泻县中越地方",
      "zhName": "新瀉縣中越地方",
      "koName": "니가타 현 주에쓰 지방",
      "esName": "Región Chuetsu, Prefectura de Niigata",
      "ptName": "Região de Chūetsu da Província de Niigata",
      "thName": "ท้องถิ่นจูเอ็ตสึ จังหวัดนีงาตะ",
      "viName": "Vùng Chuetsu tỉnh Niigata",
      "inName": "Daerah Chuetsu di Prefektur Niigata",
      "tlName": "Rehiyon ng Chuetsu sa Niigata Prefecture",
      "moName": "Нийгата аймаг,  Чүэцү муж",
      "buName": "ချူးအဲဆု၊ နိအိဂတစီရင်စု",
      "khName": "តំបន់ឈឹអែហ្សីនៃខេត្ដនីហ្គាតាក់ឹ",
      "neName": "निइगाता जिल्ला, च्युएचु क्षेत्र"
    },
    "class15": {
      "code": "150021",
      "name": "長岡地域",
      "enName": "Nagaoka Area"
    },
    "class20": {
      "code": "1520800",
      "name": "小千谷市",
      "enName": "Ojiya City",
      "kana": "おぢやし",
      "chName": "小千谷市",
      "zhName": "小千谷市",
      "koName": "오지야 시",
      "esName": "Ciudad de Ojiya",
      "ptName": "cidade de Ojiya",
      "thName": "เมืองโอจิยะ",
      "viName": "thành phố Ojiya",
      "inName": "kota Ojiya",
      "tlName": "siyudad ng Ojiya",
      "moName": "Ожия хот",
      "buName": "အိုဂျီယ မြို့",
      "khName": "ទីក្រុង អូជីយ៉ា",
      "neName": "ओजिया सहर"
    }
  },
  "1520900": {
    "office": {
      "code": "150000",
      "name": "新潟県",
      "enName": "Niigata",
      "officeName": "新潟地方気象台",
      "chName": "新泻县",
      "zhName": "新潟縣",
      "koName": "니가타현",
      "esName": "Prefectura de Niigata",
      "ptName": "Província de Niigata",
      "thName": "จังหวัดนีงาตะ",
      "viName": "Tỉnh Niigata",
      "inName": "Prefektur Niigata",
      "tlName": "Niigata Prefecture",
      "moName": "Нийгата аймаг",
      "buName": "ဏီးဂါ့တ ပြည်နယ်",
      "khName": "ខេត្ដ នីហ្គាតា",
      "neName": "निइगाता जिल्ला"
    },
    "class10": {
      "code": "150020",
      "name": "中越",
      "enName": "Chuetsu",
      "chName": "新泻县中越地方",
      "zhName": "新瀉縣中越地方",
      "koName": "니가타 현 주에쓰 지방",
      "esName": "Región Chuetsu, Prefectura de Niigata",
      "ptName": "Região de Chūetsu da Província de Niigata",
      "thName": "ท้องถิ่นจูเอ็ตสึ จังหวัดนีงาตะ",
      "viName": "Vùng Chuetsu tỉnh Niigata",
      "inName": "Daerah Chuetsu di Prefektur Niigata",
      "tlName": "Rehiyon ng Chuetsu sa Niigata Prefecture",
      "moName": "Нийгата аймаг,  Чүэцү муж",
      "buName": "ချူးအဲဆု၊ နိအိဂတစီရင်စု",
      "khName": "តំបន់ឈឹអែហ្សីនៃខេត្ដនីហ្គាតាក់ឹ",
      "neName": "निइगाता जिल्ला, च्युएचु क्षेत्र"
    },
    "class15": {
      "code": "150022",
      "name": "三条地域",
      "enName": "Sanjo Area"
    },
    "class20": {
      "code": "1520900",
      "name": "加茂市",
      "enName": "Kamo City",
      "kana": "かもし",
      "chName": "加茂市",
      "zhName": "加茂市",
      "koName": "가모 시",
      "esName": "Ciudad de Kamo",
      "ptName": "cidade de Kamo",
      "thName": "เมืองคาโมะ",
      "viName": "thành phố Kamo",
      "inName": "kota Kamo",
      "tlName": "siyudad ng Kamo",
      "moName": "Камо хот",
      "buName": "ကာမို မြို့",
      "khName": "ទីក្រុង កាម៉ូ",
      "neName": "कामो सहर"
    }
  },
  "1521000": {
    "office": {
      "code": "150000",
      "name": "新潟県",
      "enName": "Niigata",
      "officeName": "新潟地方気象台",
      "chName": "新泻县",
      "zhName": "新潟縣",
      "koName": "니가타현",
      "esName": "Prefectura de Niigata",
      "ptName": "Província de Niigata",
      "thName": "จังหวัดนีงาตะ",
      "viName": "Tỉnh Niigata",
      "inName": "Prefektur Niigata",
      "tlName": "Niigata Prefecture",
      "moName": "Нийгата аймаг",
      "buName": "ဏီးဂါ့တ ပြည်နယ်",
      "khName": "ខេត្ដ នីហ្គាតា",
      "neName": "निइगाता जिल्ला"
    },
    "class10": {
      "code": "150020",
      "name": "中越",
      "enName": "Chuetsu",
      "chName": "新泻县中越地方",
      "zhName": "新瀉縣中越地方",
      "koName": "니가타 현 주에쓰 지방",
      "esName": "Región Chuetsu, Prefectura de Niigata",
      "ptName": "Região de Chūetsu da Província de Niigata",
      "thName": "ท้องถิ่นจูเอ็ตสึ จังหวัดนีงาตะ",
      "viName": "Vùng Chuetsu tỉnh Niigata",
      "inName": "Daerah Chuetsu di Prefektur Niigata",
      "tlName": "Rehiyon ng Chuetsu sa Niigata Prefecture",
      "moName": "Нийгата аймаг,  Чүэцү муж",
      "buName": "ချူးအဲဆု၊ နိအိဂတစီရင်စု",
      "khName": "តំបន់ឈឹអែហ្សីនៃខេត្ដនីហ្គាតាក់ឹ",
      "neName": "निइगाता जिल्ला, च्युएचु क्षेत्र"
    },
    "class15": {
      "code": "150026",
      "name": "十日町地域",
      "enName": "Toka-machi Area"
    },
    "class20": {
      "code": "1521000",
      "name": "十日町市",
      "enName": "Tokamachi City",
      "kana": "とおかまちし",
      "chName": "十日町市",
      "zhName": "十日町市",
      "koName": "도카마치 시",
      "esName": "Ciudad de Tokamachi",
      "ptName": "cidade de Tokamachi",
      "thName": "เมืองโทคามาจิ",
      "viName": "thành phố Tokamachi",
      "inName": "kota Tokamachi",
      "tlName": "siyudad ng Tokamachi",
      "moName": "Токамaчи хот",
      "buName": "တိုကားမာ့ကျိ မြို့",
      "khName": "ទីក្រុង តូកាម៉ាឈី",
      "neName": "तोकामाची सहर"
    }
  },
  "1521100": {
    "office": {
      "code": "150000",
      "name": "新潟県",
      "enName": "Niigata",
      "officeName": "新潟地方気象台",
      "chName": "新泻县",
      "zhName": "新潟縣",
      "koName": "니가타현",
      "esName": "Prefectura de Niigata",
      "ptName": "Província de Niigata",
      "thName": "จังหวัดนีงาตะ",
      "viName": "Tỉnh Niigata",
      "inName": "Prefektur Niigata",
      "tlName": "Niigata Prefecture",
      "moName": "Нийгата аймаг",
      "buName": "ဏီးဂါ့တ ပြည်နယ်",
      "khName": "ខេត្ដ នីហ្គាតា",
      "neName": "निइगाता जिल्ला"
    },
    "class10": {
      "code": "150020",
      "name": "中越",
      "enName": "Chuetsu",
      "chName": "新泻县中越地方",
      "zhName": "新瀉縣中越地方",
      "koName": "니가타 현 주에쓰 지방",
      "esName": "Región Chuetsu, Prefectura de Niigata",
      "ptName": "Região de Chūetsu da Província de Niigata",
      "thName": "ท้องถิ่นจูเอ็ตสึ จังหวัดนีงาตะ",
      "viName": "Vùng Chuetsu tỉnh Niigata",
      "inName": "Daerah Chuetsu di Prefektur Niigata",
      "tlName": "Rehiyon ng Chuetsu sa Niigata Prefecture",
      "moName": "Нийгата аймаг,  Чүэцү муж",
      "buName": "ချူးအဲဆု၊ နိအိဂတစီရင်စု",
      "khName": "តំបន់ឈឹអែហ្សីនៃខេត្ដនីហ្គាតាក់ឹ",
      "neName": "निइगाता जिल्ला, च्युएचु क्षेत्र"
    },
    "class15": {
      "code": "150021",
      "name": "長岡地域",
      "enName": "Nagaoka Area"
    },
    "class20": {
      "code": "1521100",
      "name": "見附市",
      "enName": "Mitsuke City",
      "kana": "みつけし",
      "chName": "见附市",
      "zhName": "見附市",
      "koName": "미쓰케 시",
      "esName": "Ciudad de Mitsuke",
      "ptName": "cidade de Mitsuke",
      "thName": "เมืองมิสึสึเกะ",
      "viName": "thành phố Mitsuke",
      "inName": "kota Mitsuke",
      "tlName": "siyudad ng Mitsuke",
      "moName": "Мицүкэ хот",
      "buName": "မစ်ဆူကီ မြို့",
      "khName": "ទីក្រុង មីតស្គី",
      "neName": "मित्सुके सहर"
    }
  },
  "1521200": {
    "office": {
      "code": "150000",
      "name": "新潟県",
      "enName": "Niigata",
      "officeName": "新潟地方気象台",
      "chName": "新泻县",
      "zhName": "新潟縣",
      "koName": "니가타현",
      "esName": "Prefectura de Niigata",
      "ptName": "Província de Niigata",
      "thName": "จังหวัดนีงาตะ",
      "viName": "Tỉnh Niigata",
      "inName": "Prefektur Niigata",
      "tlName": "Niigata Prefecture",
      "moName": "Нийгата аймаг",
      "buName": "ဏီးဂါ့တ ပြည်နယ်",
      "khName": "ខេត្ដ នីហ្គាតា",
      "neName": "निइगाता जिल्ला"
    },
    "class10": {
      "code": "150010",
      "name": "下越",
      "enName": "Kaetsu",
      "chName": "新泻县下越地方",
      "zhName": "新瀉縣下越地方",
      "koName": "니가타 현 시모고에 지방",
      "esName": "Región Kaetsu, Prefectura de Niigata",
      "ptName": "Região de Kaetsu da Província de Niigata",
      "thName": "ท้องถิ่นคาเอ็ตสึ จังหวัดนีงาตะ",
      "viName": "Vùng Kaetsu tỉnh Niigata",
      "inName": "Daerah Kaetsu di Prefektur Niigata",
      "tlName": "Rehiyon ng Kaetsu sa Niigata Prefecture",
      "moName": "Ниигата аймаг, Каэцү муж",
      "buName": "ကအဲဆု၊ နိအိဂတစီရင်စု",
      "khName": "តំបន់កាអែហ្សីនៃខេត្ដនីហ្គាតាក់ឹ",
      "neName": "निइगाता जिल्ला, काएचु क्षेत्र"
    },
    "class15": {
      "code": "150012",
      "name": "岩船地域",
      "enName": "Iwafune Area"
    },
    "class20": {
      "code": "1521200",
      "name": "村上市",
      "enName": "Murakami City",
      "kana": "むらかみし",
      "chName": "村上市",
      "zhName": "村上市",
      "koName": "무라카미 시",
      "esName": "Ciudad de Murakami",
      "ptName": "cidade de Murakami",
      "thName": "เมืองมุราคามิ",
      "viName": "thành phố Murakami",
      "inName": "kota Murakami",
      "tlName": "siyudad ng Murakami",
      "moName": "Мүраками хот",
      "buName": "မူရာကာ့မိ မြို့",
      "khName": "ទីក្រុង មូរ៉ាកាមី",
      "neName": "मुराकामी सहर"
    }
  },
  "1521300": {
    "office": {
      "code": "150000",
      "name": "新潟県",
      "enName": "Niigata",
      "officeName": "新潟地方気象台",
      "chName": "新泻县",
      "zhName": "新潟縣",
      "koName": "니가타현",
      "esName": "Prefectura de Niigata",
      "ptName": "Província de Niigata",
      "thName": "จังหวัดนีงาตะ",
      "viName": "Tỉnh Niigata",
      "inName": "Prefektur Niigata",
      "tlName": "Niigata Prefecture",
      "moName": "Нийгата аймаг",
      "buName": "ဏီးဂါ့တ ပြည်နယ်",
      "khName": "ខេត្ដ នីហ្គាតា",
      "neName": "निइगाता जिल्ला"
    },
    "class10": {
      "code": "150010",
      "name": "下越",
      "enName": "Kaetsu",
      "chName": "新泻县下越地方",
      "zhName": "新瀉縣下越地方",
      "koName": "니가타 현 시모고에 지방",
      "esName": "Región Kaetsu, Prefectura de Niigata",
      "ptName": "Região de Kaetsu da Província de Niigata",
      "thName": "ท้องถิ่นคาเอ็ตสึ จังหวัดนีงาตะ",
      "viName": "Vùng Kaetsu tỉnh Niigata",
      "inName": "Daerah Kaetsu di Prefektur Niigata",
      "tlName": "Rehiyon ng Kaetsu sa Niigata Prefecture",
      "moName": "Ниигата аймаг, Каэцү муж",
      "buName": "ကအဲဆု၊ နိအိဂတစီရင်စု",
      "khName": "តំបន់កាអែហ្សីនៃខេត្ដនីហ្គាតាក់ឹ",
      "neName": "निइगाता जिल्ला, काएचु क्षेत्र"
    },
    "class15": {
      "code": "150011",
      "name": "新潟地域",
      "enName": "Niigata Area"
    },
    "class20": {
      "code": "1521300",
      "name": "燕市",
      "enName": "Tsubame City",
      "kana": "つばめし",
      "chName": "燕市",
      "zhName": "燕市",
      "koName": "쓰바메 시",
      "esName": "Ciudad de Tsubame",
      "ptName": "cidade de Tsubame",
      "thName": "เมืองสึบะเมะ",
      "viName": "thành phố Tsubame",
      "inName": "kota Tsubame",
      "tlName": "siyudad ng Tsubame",
      "moName": "Цүбамэ хот",
      "buName": "ဆူဘားမဲ့ မြို့",
      "khName": "ទីក្រុង ស៊ូបាម៉ា",
      "neName": "त्सुबामे सहर"
    }
  },
  "1521600": {
    "office": {
      "code": "150000",
      "name": "新潟県",
      "enName": "Niigata",
      "officeName": "新潟地方気象台",
      "chName": "新泻县",
      "zhName": "新潟縣",
      "koName": "니가타현",
      "esName": "Prefectura de Niigata",
      "ptName": "Província de Niigata",
      "thName": "จังหวัดนีงาตะ",
      "viName": "Tỉnh Niigata",
      "inName": "Prefektur Niigata",
      "tlName": "Niigata Prefecture",
      "moName": "Нийгата аймаг",
      "buName": "ဏီးဂါ့တ ပြည်နယ်",
      "khName": "ខេត្ដ នីហ្គាតា",
      "neName": "निइगाता जिल्ला"
    },
    "class10": {
      "code": "150030",
      "name": "上越",
      "enName": "Joetsu",
      "chName": "新泻县上越地方",
      "zhName": "新瀉縣上越地方",
      "koName": "니가타 현 조에쓰 지방",
      "esName": "Región Jyoetsu, Prefectura de Niigata",
      "ptName": "Região de Jōetsu da Província de Niigata",
      "thName": "ท้องถิ่นโจเอ็ตสึ จังหวัดนีงาตะ",
      "viName": "Vùng Joetsu tỉnh Niigata",
      "inName": "Daerah Joetsu di Prefektur Niigata",
      "tlName": "Rehiyon ng Joetsu sa Niigata Prefecture",
      "moName": "Нийгата аймаг, Жоэцү муж",
      "buName": "ဂျိုအဲဆု၊ နိအိဂတစီရင်စု",
      "khName": "តំបន់ជោអែហ្សឹនៃខេត្ដនីហ្គាតាក់",
      "neName": "निइगाता जिल्ला, ज्योएचु क्षेत्र"
    },
    "class15": {
      "code": "150032",
      "name": "糸魚川市",
      "enName": "Itoigawa City"
    },
    "class20": {
      "code": "1521600",
      "name": "糸魚川市",
      "enName": "Itoigawa City",
      "kana": "いといがわし",
      "chName": "丝鱼川市",
      "zhName": "糸魚川市",
      "koName": "이토이가와 시",
      "esName": "Ciudad de Itoigawa",
      "ptName": "cidade de Itoigawa",
      "thName": "เมืองอิโตอิกาวะ",
      "viName": "thành phố Itoigawa",
      "inName": "kota Itoigawa",
      "tlName": "siyudad ng Itoigawa",
      "moName": "Итойгава хот",
      "buName": "အီတိုးယိဂါ့ဝ မြို့",
      "khName": "ទីក្រុង អាយថយហ្គាវ៉ា",
      "neName": "आइतोइगावा सहर"
    }
  },
  "1521700": {
    "office": {
      "code": "150000",
      "name": "新潟県",
      "enName": "Niigata",
      "officeName": "新潟地方気象台",
      "chName": "新泻县",
      "zhName": "新潟縣",
      "koName": "니가타현",
      "esName": "Prefectura de Niigata",
      "ptName": "Província de Niigata",
      "thName": "จังหวัดนีงาตะ",
      "viName": "Tỉnh Niigata",
      "inName": "Prefektur Niigata",
      "tlName": "Niigata Prefecture",
      "moName": "Нийгата аймаг",
      "buName": "ဏီးဂါ့တ ပြည်နယ်",
      "khName": "ខេត្ដ នីហ្គាតា",
      "neName": "निइगाता जिल्ला"
    },
    "class10": {
      "code": "150030",
      "name": "上越",
      "enName": "Joetsu",
      "chName": "新泻县上越地方",
      "zhName": "新瀉縣上越地方",
      "koName": "니가타 현 조에쓰 지방",
      "esName": "Región Jyoetsu, Prefectura de Niigata",
      "ptName": "Região de Jōetsu da Província de Niigata",
      "thName": "ท้องถิ่นโจเอ็ตสึ จังหวัดนีงาตะ",
      "viName": "Vùng Joetsu tỉnh Niigata",
      "inName": "Daerah Joetsu di Prefektur Niigata",
      "tlName": "Rehiyon ng Joetsu sa Niigata Prefecture",
      "moName": "Нийгата аймаг, Жоэцү муж",
      "buName": "ဂျိုအဲဆု၊ နိအိဂတစီရင်စု",
      "khName": "តំបន់ជោអែហ្សឹនៃខេត្ដនីហ្គាតាក់",
      "neName": "निइगाता जिल्ला, ज्योएचु क्षेत्र"
    },
    "class15": {
      "code": "150033",
      "name": "妙高市",
      "enName": "Myoko City"
    },
    "class20": {
      "code": "1521700",
      "name": "妙高市",
      "enName": "Myoko City",
      "kana": "みょうこうし",
      "chName": "妙高市",
      "zhName": "妙髙市",
      "koName": "묘코 시",
      "esName": "Ciudad de Myoko",
      "ptName": "cidade de Myoko",
      "thName": "เมืองเมียวโกะ",
      "viName": "thành phố Myoko",
      "inName": "kota Myoko",
      "tlName": "siyudad ng Myoko",
      "moName": "Миоко хот",
      "buName": "မြိုကို မြို့",
      "khName": "ទីក្រុង ម៉ាយ៉ូកូ",
      "neName": "म्योका सहर"
    }
  },
  "1521800": {
    "office": {
      "code": "150000",
      "name": "新潟県",
      "enName": "Niigata",
      "officeName": "新潟地方気象台",
      "chName": "新泻县",
      "zhName": "新潟縣",
      "koName": "니가타현",
      "esName": "Prefectura de Niigata",
      "ptName": "Província de Niigata",
      "thName": "จังหวัดนีงาตะ",
      "viName": "Tỉnh Niigata",
      "inName": "Prefektur Niigata",
      "tlName": "Niigata Prefecture",
      "moName": "Нийгата аймаг",
      "buName": "ဏီးဂါ့တ ပြည်နယ်",
      "khName": "ខេត្ដ នីហ្គាតា",
      "neName": "निइगाता जिल्ला"
    },
    "class10": {
      "code": "150010",
      "name": "下越",
      "enName": "Kaetsu",
      "chName": "新泻县下越地方",
      "zhName": "新瀉縣下越地方",
      "koName": "니가타 현 시모고에 지방",
      "esName": "Región Kaetsu, Prefectura de Niigata",
      "ptName": "Região de Kaetsu da Província de Niigata",
      "thName": "ท้องถิ่นคาเอ็ตสึ จังหวัดนีงาตะ",
      "viName": "Vùng Kaetsu tỉnh Niigata",
      "inName": "Daerah Kaetsu di Prefektur Niigata",
      "tlName": "Rehiyon ng Kaetsu sa Niigata Prefecture",
      "moName": "Ниигата аймаг, Каэцү муж",
      "buName": "ကအဲဆု၊ နိအိဂတစီရင်စု",
      "khName": "តំបន់កាអែហ្សីនៃខេត្ដនីហ្គាតាក់ឹ",
      "neName": "निइगाता जिल्ला, काएचु क्षेत्र"
    },
    "class15": {
      "code": "150014",
      "name": "五泉地域",
      "enName": "Gosen Area"
    },
    "class20": {
      "code": "1521800",
      "name": "五泉市",
      "enName": "Gosen City",
      "kana": "ごせんし",
      "chName": "五泉市",
      "zhName": "五泉市",
      "koName": "고센 시",
      "esName": "Ciudad de Gosen",
      "ptName": "cidade de Gosen",
      "thName": "เมืองโกะเซน",
      "viName": "thành phố Gosen",
      "inName": "kota Gosen",
      "tlName": "siyudad ng Gosen",
      "moName": "Госэн хот",
      "buName": "ဂိုးဆန်း မြို့",
      "khName": "ទីក្រុង ហ្គូសិន",
      "neName": "गोसेन सहर"
    }
  },
  "1522200": {
    "office": {
      "code": "150000",
      "name": "新潟県",
      "enName": "Niigata",
      "officeName": "新潟地方気象台",
      "chName": "新泻县",
      "zhName": "新潟縣",
      "koName": "니가타현",
      "esName": "Prefectura de Niigata",
      "ptName": "Província de Niigata",
      "thName": "จังหวัดนีงาตะ",
      "viName": "Tỉnh Niigata",
      "inName": "Prefektur Niigata",
      "tlName": "Niigata Prefecture",
      "moName": "Нийгата аймаг",
      "buName": "ဏီးဂါ့တ ပြည်နယ်",
      "khName": "ខេត្ដ នីហ្គាតា",
      "neName": "निइगाता जिल्ला"
    },
    "class10": {
      "code": "150030",
      "name": "上越",
      "enName": "Joetsu",
      "chName": "新泻县上越地方",
      "zhName": "新瀉縣上越地方",
      "koName": "니가타 현 조에쓰 지방",
      "esName": "Región Jyoetsu, Prefectura de Niigata",
      "ptName": "Região de Jōetsu da Província de Niigata",
      "thName": "ท้องถิ่นโจเอ็ตสึ จังหวัดนีงาตะ",
      "viName": "Vùng Joetsu tỉnh Niigata",
      "inName": "Daerah Joetsu di Prefektur Niigata",
      "tlName": "Rehiyon ng Joetsu sa Niigata Prefecture",
      "moName": "Нийгата аймаг, Жоэцү муж",
      "buName": "ဂျိုအဲဆု၊ နိအိဂတစီရင်စု",
      "khName": "តំបន់ជោអែហ្សឹនៃខេត្ដនីហ្គាតាក់",
      "neName": "निइगाता जिल्ला, ज्योएचु क्षेत्र"
    },
    "class15": {
      "code": "150031",
      "name": "上越市",
      "enName": "Joetsu City"
    },
    "class20": {
      "code": "1522200",
      "name": "上越市",
      "enName": "Joetsu City",
      "kana": "じょうえつし",
      "chName": "上越市",
      "zhName": "上越市",
      "koName": "조에쓰 시",
      "esName": "Ciudad de Jyoetsu",
      "ptName": "cidade de Joetsu",
      "thName": "เมืองโจเอ็ตสึ",
      "viName": "thành phố Joetsu",
      "inName": "kota Joetsu",
      "tlName": "siyudad ng Joetsu",
      "moName": "Жоэцү хот",
      "buName": "ဂျိုးရေးဆု မြို့",
      "khName": "ទីក្រុង ចូអេតស៊ុ",
      "neName": "जोएत्सु सहर"
    }
  },
  "1522300": {
    "office": {
      "code": "150000",
      "name": "新潟県",
      "enName": "Niigata",
      "officeName": "新潟地方気象台",
      "chName": "新泻县",
      "zhName": "新潟縣",
      "koName": "니가타현",
      "esName": "Prefectura de Niigata",
      "ptName": "Província de Niigata",
      "thName": "จังหวัดนีงาตะ",
      "viName": "Tỉnh Niigata",
      "inName": "Prefektur Niigata",
      "tlName": "Niigata Prefecture",
      "moName": "Нийгата аймаг",
      "buName": "ဏီးဂါ့တ ပြည်နယ်",
      "khName": "ខេត្ដ នីហ្គាតា",
      "neName": "निइगाता जिल्ला"
    },
    "class10": {
      "code": "150010",
      "name": "下越",
      "enName": "Kaetsu",
      "chName": "新泻县下越地方",
      "zhName": "新瀉縣下越地方",
      "koName": "니가타 현 시모고에 지방",
      "esName": "Región Kaetsu, Prefectura de Niigata",
      "ptName": "Região de Kaetsu da Província de Niigata",
      "thName": "ท้องถิ่นคาเอ็ตสึ จังหวัดนีงาตะ",
      "viName": "Vùng Kaetsu tỉnh Niigata",
      "inName": "Daerah Kaetsu di Prefektur Niigata",
      "tlName": "Rehiyon ng Kaetsu sa Niigata Prefecture",
      "moName": "Ниигата аймаг, Каэцү муж",
      "buName": "ကအဲဆု၊ နိအိဂတစီရင်စု",
      "khName": "តំបន់កាអែហ្សីនៃខេត្ដនីហ្គាតាក់ឹ",
      "neName": "निइगाता जिल्ला, काएचु क्षेत्र"
    },
    "class15": {
      "code": "150011",
      "name": "新潟地域",
      "enName": "Niigata Area"
    },
    "class20": {
      "code": "1522300",
      "name": "阿賀野市",
      "enName": "Agano City",
      "kana": "あがのし",
      "chName": "阿贺野市",
      "zhName": "阿賀野市",
      "koName": "아가노 시",
      "esName": "Ciudad de Agano",
      "ptName": "cidade de Agano",
      "thName": "เมืองอากาโนะ",
      "viName": "thành phố Agano",
      "inName": "kota Agano",
      "tlName": "siyudad ng Agano",
      "moName": "Aгaно хот",
      "buName": "အာဂါးနို မြို့",
      "khName": "ទីក្រុង អាហ្គាណូ",
      "neName": "आगानो सहर"
    }
  },
  "1522400": {
    "office": {
      "code": "150000",
      "name": "新潟県",
      "enName": "Niigata",
      "officeName": "新潟地方気象台",
      "chName": "新泻县",
      "zhName": "新潟縣",
      "koName": "니가타현",
      "esName": "Prefectura de Niigata",
      "ptName": "Província de Niigata",
      "thName": "จังหวัดนีงาตะ",
      "viName": "Tỉnh Niigata",
      "inName": "Prefektur Niigata",
      "tlName": "Niigata Prefecture",
      "moName": "Нийгата аймаг",
      "buName": "ဏီးဂါ့တ ပြည်နယ်",
      "khName": "ខេត្ដ នីហ្គាតា",
      "neName": "निइगाता जिल्ला"
    },
    "class10": {
      "code": "150040",
      "name": "佐渡",
      "enName": "Sado",
      "chName": "佐渡",
      "zhName": "佐渡",
      "koName": "사도",
      "esName": "sado",
      "ptName": "Sado",
      "thName": "ซาโด้",
      "viName": "Sado",
      "inName": "Sado",
      "tlName": "Sado",
      "moName": "Садо",
      "buName": "ဆာဒို",
      "khName": "សាដូ",
      "neName": "Sado"
    },
    "class15": {
      "code": "150040",
      "name": "佐渡",
      "enName": "Sado"
    },
    "class20": {
      "code": "1522400",
      "name": "佐渡市",
      "enName": "Sado City",
      "kana": "さどし",
      "chName": "佐渡市",
      "zhName": "佐渡市",
      "koName": "사도 시",
      "esName": "Ciudad de Sado",
      "ptName": "cidade de Sado",
      "thName": "เมืองโซดะ",
      "viName": "thành phố Sado",
      "inName": "kota Sado",
      "tlName": "siyudad ng Sado",
      "moName": "Сaдо хот",
      "buName": "ဆာဒို မြို့",
      "khName": "ទីក្រុង សាដូ",
      "neName": "सादो सहर"
    }
  },
  "1522500": {
    "office": {
      "code": "150000",
      "name": "新潟県",
      "enName": "Niigata",
      "officeName": "新潟地方気象台",
      "chName": "新泻县",
      "zhName": "新潟縣",
      "koName": "니가타현",
      "esName": "Prefectura de Niigata",
      "ptName": "Província de Niigata",
      "thName": "จังหวัดนีงาตะ",
      "viName": "Tỉnh Niigata",
      "inName": "Prefektur Niigata",
      "tlName": "Niigata Prefecture",
      "moName": "Нийгата аймаг",
      "buName": "ဏီးဂါ့တ ပြည်နယ်",
      "khName": "ខេត្ដ នីហ្គាតា",
      "neName": "निइगाता जिल्ला"
    },
    "class10": {
      "code": "150020",
      "name": "中越",
      "enName": "Chuetsu",
      "chName": "新泻县中越地方",
      "zhName": "新瀉縣中越地方",
      "koName": "니가타 현 주에쓰 지방",
      "esName": "Región Chuetsu, Prefectura de Niigata",
      "ptName": "Região de Chūetsu da Província de Niigata",
      "thName": "ท้องถิ่นจูเอ็ตสึ จังหวัดนีงาตะ",
      "viName": "Vùng Chuetsu tỉnh Niigata",
      "inName": "Daerah Chuetsu di Prefektur Niigata",
      "tlName": "Rehiyon ng Chuetsu sa Niigata Prefecture",
      "moName": "Нийгата аймаг,  Чүэцү муж",
      "buName": "ချူးအဲဆု၊ နိအိဂတစီရင်စု",
      "khName": "តំបន់ឈឹអែហ្សីនៃខេត្ដនីហ្គាតាក់ឹ",
      "neName": "निइगाता जिल्ला, च्युएचु क्षेत्र"
    },
    "class15": {
      "code": "150023",
      "name": "魚沼市",
      "enName": "Uonuma City"
    },
    "class20": {
      "code": "1522500",
      "name": "魚沼市",
      "enName": "Uonuma City",
      "kana": "うおぬまし",
      "chName": "鱼沼市",
      "zhName": "魚沼市",
      "koName": "우오누마 시",
      "esName": "Ciudad de Uonuma",
      "ptName": "cidade de Uonuma",
      "thName": "เมืองอุโอะนุมะ",
      "viName": "thành phố Uonuma",
      "inName": "kota Uonuma",
      "tlName": "siyudad ng Uonuma",
      "moName": "Үонүмa хот",
      "buName": "အိုးနုမာ့ မြို့",
      "khName": "ទីក្រុង យូអូនូម៉ា",
      "neName": "उओनुमा सहर"
    }
  },
  "1522600": {
    "office": {
      "code": "150000",
      "name": "新潟県",
      "enName": "Niigata",
      "officeName": "新潟地方気象台",
      "chName": "新泻县",
      "zhName": "新潟縣",
      "koName": "니가타현",
      "esName": "Prefectura de Niigata",
      "ptName": "Província de Niigata",
      "thName": "จังหวัดนีงาตะ",
      "viName": "Tỉnh Niigata",
      "inName": "Prefektur Niigata",
      "tlName": "Niigata Prefecture",
      "moName": "Нийгата аймаг",
      "buName": "ဏီးဂါ့တ ပြည်နယ်",
      "khName": "ខេត្ដ នីហ្គាតា",
      "neName": "निइगाता जिल्ला"
    },
    "class10": {
      "code": "150020",
      "name": "中越",
      "enName": "Chuetsu",
      "chName": "新泻县中越地方",
      "zhName": "新瀉縣中越地方",
      "koName": "니가타 현 주에쓰 지방",
      "esName": "Región Chuetsu, Prefectura de Niigata",
      "ptName": "Região de Chūetsu da Província de Niigata",
      "thName": "ท้องถิ่นจูเอ็ตสึ จังหวัดนีงาตะ",
      "viName": "Vùng Chuetsu tỉnh Niigata",
      "inName": "Daerah Chuetsu di Prefektur Niigata",
      "tlName": "Rehiyon ng Chuetsu sa Niigata Prefecture",
      "moName": "Нийгата аймаг,  Чүэцү муж",
      "buName": "ချူးအဲဆု၊ နိအိဂတစီရင်စု",
      "khName": "តំបន់ឈឹអែហ្សីនៃខេត្ដនីហ្គាតាក់ឹ",
      "neName": "निइगाता जिल्ला, च्युएचु क्षेत्र"
    },
    "class15": {
      "code": "150025",
      "name": "南魚沼地域",
      "enName": "Minami-uonuma Area"
    },
    "class20": {
      "code": "1522600",
      "name": "南魚沼市",
      "enName": "Minamiuonuma City",
      "kana": "みなみうおぬまし",
      "chName": "南鱼沼市",
      "zhName": "南魚沼市",
      "koName": "미나미우오누마 시",
      "esName": "Ciudad de Minamiuonuma",
      "ptName": "cidade de Minamiuonuma",
      "thName": "เมืองมินามิอุโอนุมะ",
      "viName": "thành phố Minamiuonuma",
      "inName": "kota Minamiuonuma",
      "tlName": "siyudad ng Minamiuonuma",
      "moName": "Минaмиүонүмa хот",
      "buName": "မီနားမိယူအိုးနုမာ့ မြို့",
      "khName": "ទីក្រុង មីណាមីយូនូម៉ា",
      "neName": "मिनामिउओनुमा सहर"
    }
  },
  "1522700": {
    "office": {
      "code": "150000",
      "name": "新潟県",
      "enName": "Niigata",
      "officeName": "新潟地方気象台",
      "chName": "新泻县",
      "zhName": "新潟縣",
      "koName": "니가타현",
      "esName": "Prefectura de Niigata",
      "ptName": "Província de Niigata",
      "thName": "จังหวัดนีงาตะ",
      "viName": "Tỉnh Niigata",
      "inName": "Prefektur Niigata",
      "tlName": "Niigata Prefecture",
      "moName": "Нийгата аймаг",
      "buName": "ဏီးဂါ့တ ပြည်နယ်",
      "khName": "ខេត្ដ នីហ្គាតា",
      "neName": "निइगाता जिल्ला"
    },
    "class10": {
      "code": "150010",
      "name": "下越",
      "enName": "Kaetsu",
      "chName": "新泻县下越地方",
      "zhName": "新瀉縣下越地方",
      "koName": "니가타 현 시모고에 지방",
      "esName": "Región Kaetsu, Prefectura de Niigata",
      "ptName": "Região de Kaetsu da Província de Niigata",
      "thName": "ท้องถิ่นคาเอ็ตสึ จังหวัดนีงาตะ",
      "viName": "Vùng Kaetsu tỉnh Niigata",
      "inName": "Daerah Kaetsu di Prefektur Niigata",
      "tlName": "Rehiyon ng Kaetsu sa Niigata Prefecture",
      "moName": "Ниигата аймаг, Каэцү муж",
      "buName": "ကအဲဆု၊ နိအိဂတစီရင်စု",
      "khName": "តំបន់កាអែហ្សីនៃខេត្ដនីហ្គាតាក់ឹ",
      "neName": "निइगाता जिल्ला, काएचु क्षेत्र"
    },
    "class15": {
      "code": "150013",
      "name": "新発田地域",
      "enName": "Shibata Area"
    },
    "class20": {
      "code": "1522700",
      "name": "胎内市",
      "enName": "Tainai City",
      "kana": "たいないし",
      "chName": "胎内市",
      "zhName": "胎內市",
      "koName": "다이나이 시",
      "esName": "Ciudad de Tainai",
      "ptName": "cidade de Tainai",
      "thName": "เมืองไทไน",
      "viName": "thành phố Tainai",
      "inName": "kota Tainai",
      "tlName": "siyudad ng Tainai",
      "moName": "Тайнaй хот",
      "buName": "တိုင်ယိနာ့ယိ မြို့",
      "khName": "ទីក្រុង ថៃណៃ",
      "neName": "ताइनाई सहर"
    }
  },
  "1530700": {
    "office": {
      "code": "150000",
      "name": "新潟県",
      "enName": "Niigata",
      "officeName": "新潟地方気象台",
      "chName": "新泻县",
      "zhName": "新潟縣",
      "koName": "니가타현",
      "esName": "Prefectura de Niigata",
      "ptName": "Província de Niigata",
      "thName": "จังหวัดนีงาตะ",
      "viName": "Tỉnh Niigata",
      "inName": "Prefektur Niigata",
      "tlName": "Niigata Prefecture",
      "moName": "Нийгата аймаг",
      "buName": "ဏီးဂါ့တ ပြည်နယ်",
      "khName": "ខេត្ដ នីហ្គាតា",
      "neName": "निइगाता जिल्ला"
    },
    "class10": {
      "code": "150010",
      "name": "下越",
      "enName": "Kaetsu",
      "chName": "新泻县下越地方",
      "zhName": "新瀉縣下越地方",
      "koName": "니가타 현 시모고에 지방",
      "esName": "Región Kaetsu, Prefectura de Niigata",
      "ptName": "Região de Kaetsu da Província de Niigata",
      "thName": "ท้องถิ่นคาเอ็ตสึ จังหวัดนีงาตะ",
      "viName": "Vùng Kaetsu tỉnh Niigata",
      "inName": "Daerah Kaetsu di Prefektur Niigata",
      "tlName": "Rehiyon ng Kaetsu sa Niigata Prefecture",
      "moName": "Ниигата аймаг, Каэцү муж",
      "buName": "ကအဲဆု၊ နိအိဂတစီရင်စု",
      "khName": "តំបន់កាអែហ្សីនៃខេត្ដនីហ្គាតាក់ឹ",
      "neName": "निइगाता जिल्ला, काएचु क्षेत्र"
    },
    "class15": {
      "code": "150013",
      "name": "新発田地域",
      "enName": "Shibata Area"
    },
    "class20": {
      "code": "1530700",
      "name": "聖籠町",
      "enName": "Seiro Town",
      "kana": "せいろうまち",
      "chName": "圣笼町",
      "zhName": "聖籠町",
      "koName": "세이로 정",
      "esName": "Pueblo de Seiro",
      "ptName": "bairro de Seiro",
      "thName": "เมืองเซอิโระ",
      "viName": "thị trấn Seiro",
      "inName": "kota Seiro",
      "tlName": "bayan ng Seiro",
      "moName": "Сэйро жижиг хот",
      "buName": "ဆေးရို မြို့နယ်",
      "khName": "ទីប្រជុំជន ស៊ីរ៉ូ",
      "neName": "सेइरो नगर"
    }
  },
  "1534200": {
    "office": {
      "code": "150000",
      "name": "新潟県",
      "enName": "Niigata",
      "officeName": "新潟地方気象台",
      "chName": "新泻县",
      "zhName": "新潟縣",
      "koName": "니가타현",
      "esName": "Prefectura de Niigata",
      "ptName": "Província de Niigata",
      "thName": "จังหวัดนีงาตะ",
      "viName": "Tỉnh Niigata",
      "inName": "Prefektur Niigata",
      "tlName": "Niigata Prefecture",
      "moName": "Нийгата аймаг",
      "buName": "ဏီးဂါ့တ ပြည်နယ်",
      "khName": "ខេត្ដ នីហ្គាតា",
      "neName": "निइगाता जिल्ला"
    },
    "class10": {
      "code": "150010",
      "name": "下越",
      "enName": "Kaetsu",
      "chName": "新泻县下越地方",
      "zhName": "新瀉縣下越地方",
      "koName": "니가타 현 시모고에 지방",
      "esName": "Región Kaetsu, Prefectura de Niigata",
      "ptName": "Região de Kaetsu da Província de Niigata",
      "thName": "ท้องถิ่นคาเอ็ตสึ จังหวัดนีงาตะ",
      "viName": "Vùng Kaetsu tỉnh Niigata",
      "inName": "Daerah Kaetsu di Prefektur Niigata",
      "tlName": "Rehiyon ng Kaetsu sa Niigata Prefecture",
      "moName": "Ниигата аймаг, Каэцү муж",
      "buName": "ကအဲဆု၊ နိအိဂတစီရင်စု",
      "khName": "តំបន់កាអែហ្សីនៃខេត្ដនីហ្គាតាក់ឹ",
      "neName": "निइगाता जिल्ला, काएचु क्षेत्र"
    },
    "class15": {
      "code": "150011",
      "name": "新潟地域",
      "enName": "Niigata Area"
    },
    "class20": {
      "code": "1534200",
      "name": "弥彦村",
      "enName": "Yahiko Village",
      "kana": "やひこむら",
      "chName": "弥彦村",
      "zhName": "彌彥村",
      "koName": "야히코 촌",
      "esName": "Aldea de Yahiko",
      "ptName": "povoado de Yahiko",
      "thName": "หมู่บ้านยาฮิโกะ",
      "viName": "làng Yahiko",
      "inName": "desa Yahiko",
      "tlName": "nayon ng Yahiko",
      "moName": "Яхико тосгон",
      "buName": "ယာဟိကို ကျေးရွာ",
      "khName": "ភូមិ​ យ៉ាហ៊ីកុ",
      "neName": "याहिको गाउँ"
    }
  },
  "1536100": {
    "office": {
      "code": "150000",
      "name": "新潟県",
      "enName": "Niigata",
      "officeName": "新潟地方気象台",
      "chName": "新泻县",
      "zhName": "新潟縣",
      "koName": "니가타현",
      "esName": "Prefectura de Niigata",
      "ptName": "Província de Niigata",
      "thName": "จังหวัดนีงาตะ",
      "viName": "Tỉnh Niigata",
      "inName": "Prefektur Niigata",
      "tlName": "Niigata Prefecture",
      "moName": "Нийгата аймаг",
      "buName": "ဏီးဂါ့တ ပြည်နယ်",
      "khName": "ខេត្ដ នីហ្គាតា",
      "neName": "निइगाता जिल्ला"
    },
    "class10": {
      "code": "150020",
      "name": "中越",
      "enName": "Chuetsu",
      "chName": "新泻县中越地方",
      "zhName": "新瀉縣中越地方",
      "koName": "니가타 현 주에쓰 지방",
      "esName": "Región Chuetsu, Prefectura de Niigata",
      "ptName": "Região de Chūetsu da Província de Niigata",
      "thName": "ท้องถิ่นจูเอ็ตสึ จังหวัดนีงาตะ",
      "viName": "Vùng Chuetsu tỉnh Niigata",
      "inName": "Daerah Chuetsu di Prefektur Niigata",
      "tlName": "Rehiyon ng Chuetsu sa Niigata Prefecture",
      "moName": "Нийгата аймаг,  Чүэцү муж",
      "buName": "ချူးအဲဆု၊ နိအိဂတစီရင်စု",
      "khName": "តំបន់ឈឹអែហ្សីនៃខេត្ដនីហ្គាតាក់ឹ",
      "neName": "निइगाता जिल्ला, च्युएचु क्षेत्र"
    },
    "class15": {
      "code": "150022",
      "name": "三条地域",
      "enName": "Sanjo Area"
    },
    "class20": {
      "code": "1536100",
      "name": "田上町",
      "enName": "Tagami Town",
      "kana": "たがみまち",
      "chName": "田上町",
      "zhName": "田上町",
      "koName": "다가미 정",
      "esName": "Pueblo de Tagami",
      "ptName": "bairro de Tagami",
      "thName": "เมืองทากามิ",
      "viName": "thị trấn Tagami",
      "inName": "kota Tagami",
      "tlName": "bayan ng Tagami",
      "moName": "Тагaми жижиг хот",
      "buName": "တာဂါ့မိ မြို့နယ်",
      "khName": "ទីប្រជុំជន ថាហ្កាមី",
      "neName": "तागामी नगर"
    }
  },
  "1538500": {
    "office": {
      "code": "150000",
      "name": "新潟県",
      "enName": "Niigata",
      "officeName": "新潟地方気象台",
      "chName": "新泻县",
      "zhName": "新潟縣",
      "koName": "니가타현",
      "esName": "Prefectura de Niigata",
      "ptName": "Província de Niigata",
      "thName": "จังหวัดนีงาตะ",
      "viName": "Tỉnh Niigata",
      "inName": "Prefektur Niigata",
      "tlName": "Niigata Prefecture",
      "moName": "Нийгата аймаг",
      "buName": "ဏီးဂါ့တ ပြည်နယ်",
      "khName": "ខេត្ដ នីហ្គាតា",
      "neName": "निइगाता जिल्ला"
    },
    "class10": {
      "code": "150010",
      "name": "下越",
      "enName": "Kaetsu",
      "chName": "新泻县下越地方",
      "zhName": "新瀉縣下越地方",
      "koName": "니가타 현 시모고에 지방",
      "esName": "Región Kaetsu, Prefectura de Niigata",
      "ptName": "Região de Kaetsu da Província de Niigata",
      "thName": "ท้องถิ่นคาเอ็ตสึ จังหวัดนีงาตะ",
      "viName": "Vùng Kaetsu tỉnh Niigata",
      "inName": "Daerah Kaetsu di Prefektur Niigata",
      "tlName": "Rehiyon ng Kaetsu sa Niigata Prefecture",
      "moName": "Ниигата аймаг, Каэцү муж",
      "buName": "ကအဲဆု၊ နိအိဂတစီရင်စု",
      "khName": "តំបន់កាអែហ្សីនៃខេត្ដនីហ្គាតាក់ឹ",
      "neName": "निइगाता जिल्ला, काएचु क्षेत्र"
    },
    "class15": {
      "code": "150014",
      "name": "五泉地域",
      "enName": "Gosen Area"
    },
    "class20": {
      "code": "1538500",
      "name": "阿賀町",
      "enName": "Aga Town",
      "kana": "あがまち",
      "chName": "阿贺町",
      "zhName": "阿賀町",
      "koName": "아가 정",
      "esName": "Pueblo de Aga",
      "ptName": "bairro de Aga",
      "thName": "เมืองอางะ",
      "viName": "thị trấn Aga",
      "inName": "kota Aga",
      "tlName": "bayan ng Aga",
      "moName": "Aгa жижиг хот",
      "buName": "အာဂ မြို့နယ်",
      "khName": "ទីប្រជុំជន អាកា",
      "neName": "आगा नगर"
    }
  },
  "1540500": {
    "office": {
      "code": "150000",
      "name": "新潟県",
      "enName": "Niigata",
      "officeName": "新潟地方気象台",
      "chName": "新泻县",
      "zhName": "新潟縣",
      "koName": "니가타현",
      "esName": "Prefectura de Niigata",
      "ptName": "Província de Niigata",
      "thName": "จังหวัดนีงาตะ",
      "viName": "Tỉnh Niigata",
      "inName": "Prefektur Niigata",
      "tlName": "Niigata Prefecture",
      "moName": "Нийгата аймаг",
      "buName": "ဏီးဂါ့တ ပြည်နယ်",
      "khName": "ខេត្ដ នីហ្គាតា",
      "neName": "निइगाता जिल्ला"
    },
    "class10": {
      "code": "150020",
      "name": "中越",
      "enName": "Chuetsu",
      "chName": "新泻县中越地方",
      "zhName": "新瀉縣中越地方",
      "koName": "니가타 현 주에쓰 지방",
      "esName": "Región Chuetsu, Prefectura de Niigata",
      "ptName": "Região de Chūetsu da Província de Niigata",
      "thName": "ท้องถิ่นจูเอ็ตสึ จังหวัดนีงาตะ",
      "viName": "Vùng Chuetsu tỉnh Niigata",
      "inName": "Daerah Chuetsu di Prefektur Niigata",
      "tlName": "Rehiyon ng Chuetsu sa Niigata Prefecture",
      "moName": "Нийгата аймаг,  Чүэцү муж",
      "buName": "ချူးအဲဆု၊ နိအိဂတစီရင်စု",
      "khName": "តំបន់ឈឹអែហ្សីនៃខេត្ដនីហ្គាតាក់ឹ",
      "neName": "निइगाता जिल्ला, च्युएचु क्षेत्र"
    },
    "class15": {
      "code": "150021",
      "name": "長岡地域",
      "enName": "Nagaoka Area"
    },
    "class20": {
      "code": "1540500",
      "name": "出雲崎町",
      "enName": "Izumozaki Town",
      "kana": "いずもざきまち",
      "chName": "出云崎町",
      "zhName": "出雲崎町",
      "koName": "이즈모자키 정",
      "esName": "Pueblo de Izumozaki",
      "ptName": "bairro de Izumozaki",
      "thName": "เมืองอิสุโมซากิ",
      "viName": "thị trấn Izumozaki",
      "inName": "kota Izumozaki",
      "tlName": "bayan ng Izumozaki",
      "moName": "Изүмозaки жижиг хот",
      "buName": "အီဇုမိုးဇာ့ကိ မြို့နယ်",
      "khName": "ទីប្រជុំជន អ៊ីហ្សូម៉ូហ្សាគី",
      "neName": "इजुमोजाकी नगर"
    }
  },
  "1546100": {
    "office": {
      "code": "150000",
      "name": "新潟県",
      "enName": "Niigata",
      "officeName": "新潟地方気象台",
      "chName": "新泻县",
      "zhName": "新潟縣",
      "koName": "니가타현",
      "esName": "Prefectura de Niigata",
      "ptName": "Província de Niigata",
      "thName": "จังหวัดนีงาตะ",
      "viName": "Tỉnh Niigata",
      "inName": "Prefektur Niigata",
      "tlName": "Niigata Prefecture",
      "moName": "Нийгата аймаг",
      "buName": "ဏီးဂါ့တ ပြည်နယ်",
      "khName": "ខេត្ដ នីហ្គាតា",
      "neName": "निइगाता जिल्ला"
    },
    "class10": {
      "code": "150020",
      "name": "中越",
      "enName": "Chuetsu",
      "chName": "新泻县中越地方",
      "zhName": "新瀉縣中越地方",
      "koName": "니가타 현 주에쓰 지방",
      "esName": "Región Chuetsu, Prefectura de Niigata",
      "ptName": "Região de Chūetsu da Província de Niigata",
      "thName": "ท้องถิ่นจูเอ็ตสึ จังหวัดนีงาตะ",
      "viName": "Vùng Chuetsu tỉnh Niigata",
      "inName": "Daerah Chuetsu di Prefektur Niigata",
      "tlName": "Rehiyon ng Chuetsu sa Niigata Prefecture",
      "moName": "Нийгата аймаг,  Чүэцү муж",
      "buName": "ချူးအဲဆု၊ နိအိဂတစီရင်စု",
      "khName": "តំបន់ឈឹអែហ្សីនៃខេត្ដនីហ្គាតាក់ឹ",
      "neName": "निइगाता जिल्ला, च्युएचु क्षेत्र"
    },
    "class15": {
      "code": "150025",
      "name": "南魚沼地域",
      "enName": "Minami-uonuma Area"
    },
    "class20": {
      "code": "1546100",
      "name": "湯沢町",
      "enName": "Yuzawa Town",
      "kana": "ゆざわまち",
      "chName": "汤泽町",
      "zhName": "湯澤町",
      "koName": "유자와 정",
      "esName": "Pueblo de Yuzawa",
      "ptName": "bairro de Yuzawa",
      "thName": "เมืองยุซาวะ",
      "viName": "thị trấn Yuzawa",
      "inName": "kota Yuzawa",
      "tlName": "bayan ng Yuzawa",
      "moName": "Юзава жижиг хот",
      "buName": "ယုဇာ့ဝ မြို့နယ်",
      "khName": "ទីប្រជុំជន យូហ្សាវ៉ា",
      "neName": "युजावा नगर"
    }
  },
  "1548200": {
    "office": {
      "code": "150000",
      "name": "新潟県",
      "enName": "Niigata",
      "officeName": "新潟地方気象台",
      "chName": "新泻县",
      "zhName": "新潟縣",
      "koName": "니가타현",
      "esName": "Prefectura de Niigata",
      "ptName": "Província de Niigata",
      "thName": "จังหวัดนีงาตะ",
      "viName": "Tỉnh Niigata",
      "inName": "Prefektur Niigata",
      "tlName": "Niigata Prefecture",
      "moName": "Нийгата аймаг",
      "buName": "ဏီးဂါ့တ ပြည်နယ်",
      "khName": "ខេត្ដ នីហ្គាតា",
      "neName": "निइगाता जिल्ला"
    },
    "class10": {
      "code": "150020",
      "name": "中越",
      "enName": "Chuetsu",
      "chName": "新泻县中越地方",
      "zhName": "新瀉縣中越地方",
      "koName": "니가타 현 주에쓰 지방",
      "esName": "Región Chuetsu, Prefectura de Niigata",
      "ptName": "Região de Chūetsu da Província de Niigata",
      "thName": "ท้องถิ่นจูเอ็ตสึ จังหวัดนีงาตะ",
      "viName": "Vùng Chuetsu tỉnh Niigata",
      "inName": "Daerah Chuetsu di Prefektur Niigata",
      "tlName": "Rehiyon ng Chuetsu sa Niigata Prefecture",
      "moName": "Нийгата аймаг,  Чүэцү муж",
      "buName": "ချူးအဲဆု၊ နိအိဂတစီရင်စု",
      "khName": "តំបន់ឈឹអែហ្សីនៃខេត្ដនីហ្គាតាក់ឹ",
      "neName": "निइगाता जिल्ला, च्युएचु क्षेत्र"
    },
    "class15": {
      "code": "150026",
      "name": "十日町地域",
      "enName": "Toka-machi Area"
    },
    "class20": {
      "code": "1548200",
      "name": "津南町",
      "enName": "Tsunan Town",
      "kana": "つなんまち",
      "chName": "津南町",
      "zhName": "津南町",
      "koName": "쓰난 정",
      "esName": "Pueblo de Tsunan",
      "ptName": "bairro de Tsunan",
      "thName": "เมืองสึนัน",
      "viName": "thị trấn Tsunan",
      "inName": "kota Tsunan",
      "tlName": "bayan ng Tsunan",
      "moName": "Цүнaн жижиг хот",
      "buName": "ဆုနန် မြို့နယ်",
      "khName": "ទីប្រជុំជន ស៊ូណាន",
      "neName": "त्सुनान नगर"
    }
  },
  "1550400": {
    "office": {
      "code": "150000",
      "name": "新潟県",
      "enName": "Niigata",
      "officeName": "新潟地方気象台",
      "chName": "新泻县",
      "zhName": "新潟縣",
      "koName": "니가타현",
      "esName": "Prefectura de Niigata",
      "ptName": "Província de Niigata",
      "thName": "จังหวัดนีงาตะ",
      "viName": "Tỉnh Niigata",
      "inName": "Prefektur Niigata",
      "tlName": "Niigata Prefecture",
      "moName": "Нийгата аймаг",
      "buName": "ဏီးဂါ့တ ပြည်နယ်",
      "khName": "ខេត្ដ នីហ្គាតា",
      "neName": "निइगाता जिल्ला"
    },
    "class10": {
      "code": "150020",
      "name": "中越",
      "enName": "Chuetsu",
      "chName": "新泻县中越地方",
      "zhName": "新瀉縣中越地方",
      "koName": "니가타 현 주에쓰 지방",
      "esName": "Región Chuetsu, Prefectura de Niigata",
      "ptName": "Região de Chūetsu da Província de Niigata",
      "thName": "ท้องถิ่นจูเอ็ตสึ จังหวัดนีงาตะ",
      "viName": "Vùng Chuetsu tỉnh Niigata",
      "inName": "Daerah Chuetsu di Prefektur Niigata",
      "tlName": "Rehiyon ng Chuetsu sa Niigata Prefecture",
      "moName": "Нийгата аймаг,  Чүэцү муж",
      "buName": "ချူးအဲဆု၊ နိအိဂတစီရင်စု",
      "khName": "តំបន់ឈឹអែហ្សីនៃខេត្ដនីហ្គាតាក់ឹ",
      "neName": "निइगाता जिल्ला, च्युएचु क्षेत्र"
    },
    "class15": {
      "code": "150024",
      "name": "柏崎地域",
      "enName": "Kashiwazaki Area"
    },
    "class20": {
      "code": "1550400",
      "name": "刈羽村",
      "enName": "Kariwa Village",
      "kana": "かりわむら",
      "chName": "刈羽村",
      "zhName": "刈羽村",
      "koName": "가리와 촌",
      "esName": "Aldea de Kariwa",
      "ptName": "povoado de Kariwa",
      "thName": "หมู่บ้านคาริวะ",
      "viName": "làng Kariwa",
      "inName": "desa Kariwa",
      "tlName": "nayon ng Kariwa",
      "moName": "Карива тосгон",
      "buName": "ခါးရိဝ ကျေးရွာ",
      "khName": "ភូមិ ការីវ៉ា",
      "neName": "कारिवा गाउँ"
    }
  },
  "1558100": {
    "office": {
      "code": "150000",
      "name": "新潟県",
      "enName": "Niigata",
      "officeName": "新潟地方気象台",
      "chName": "新泻县",
      "zhName": "新潟縣",
      "koName": "니가타현",
      "esName": "Prefectura de Niigata",
      "ptName": "Província de Niigata",
      "thName": "จังหวัดนีงาตะ",
      "viName": "Tỉnh Niigata",
      "inName": "Prefektur Niigata",
      "tlName": "Niigata Prefecture",
      "moName": "Нийгата аймаг",
      "buName": "ဏီးဂါ့တ ပြည်နယ်",
      "khName": "ខេត្ដ នីហ្គាតា",
      "neName": "निइगाता जिल्ला"
    },
    "class10": {
      "code": "150010",
      "name": "下越",
      "enName": "Kaetsu",
      "chName": "新泻县下越地方",
      "zhName": "新瀉縣下越地方",
      "koName": "니가타 현 시모고에 지방",
      "esName": "Región Kaetsu, Prefectura de Niigata",
      "ptName": "Região de Kaetsu da Província de Niigata",
      "thName": "ท้องถิ่นคาเอ็ตสึ จังหวัดนีงาตะ",
      "viName": "Vùng Kaetsu tỉnh Niigata",
      "inName": "Daerah Kaetsu di Prefektur Niigata",
      "tlName": "Rehiyon ng Kaetsu sa Niigata Prefecture",
      "moName": "Ниигата аймаг, Каэцү муж",
      "buName": "ကအဲဆု၊ နိအိဂတစီရင်စု",
      "khName": "តំបន់កាអែហ្សីនៃខេត្ដនីហ្គាតាក់ឹ",
      "neName": "निइगाता जिल्ला, काएचु क्षेत्र"
    },
    "class15": {
      "code": "150012",
      "name": "岩船地域",
      "enName": "Iwafune Area"
    },
    "class20": {
      "code": "1558100",
      "name": "関川村",
      "enName": "Sekikawa Village",
      "kana": "せきかわむら",
      "chName": "关川村",
      "zhName": "關川村",
      "koName": "세키카와 촌",
      "esName": "Aldea de Sekikawa",
      "ptName": "povoado de Sekikawa",
      "thName": "หมู่บ้านเซคิคาวะ",
      "viName": "làng Sekikawa",
      "inName": "desa Sekikawa",
      "tlName": "nayon ng Sekikawa",
      "moName": "Сэкикава тосгон",
      "buName": "ဆေကိကာ့ဝ ကျေးရွာ",
      "khName": "ភូមិ សេគីកាវ៉ា",
      "neName": "सेकिकावा गाउँ"
    }
  },
  "1558600": {
    "office": {
      "code": "150000",
      "name": "新潟県",
      "enName": "Niigata",
      "officeName": "新潟地方気象台",
      "chName": "新泻县",
      "zhName": "新潟縣",
      "koName": "니가타현",
      "esName": "Prefectura de Niigata",
      "ptName": "Província de Niigata",
      "thName": "จังหวัดนีงาตะ",
      "viName": "Tỉnh Niigata",
      "inName": "Prefektur Niigata",
      "tlName": "Niigata Prefecture",
      "moName": "Нийгата аймаг",
      "buName": "ဏီးဂါ့တ ပြည်နယ်",
      "khName": "ខេត្ដ នីហ្គាតា",
      "neName": "निइगाता जिल्ला"
    },
    "class10": {
      "code": "150010",
      "name": "下越",
      "enName": "Kaetsu",
      "chName": "新泻县下越地方",
      "zhName": "新瀉縣下越地方",
      "koName": "니가타 현 시모고에 지방",
      "esName": "Región Kaetsu, Prefectura de Niigata",
      "ptName": "Região de Kaetsu da Província de Niigata",
      "thName": "ท้องถิ่นคาเอ็ตสึ จังหวัดนีงาตะ",
      "viName": "Vùng Kaetsu tỉnh Niigata",
      "inName": "Daerah Kaetsu di Prefektur Niigata",
      "tlName": "Rehiyon ng Kaetsu sa Niigata Prefecture",
      "moName": "Ниигата аймаг, Каэцү муж",
      "buName": "ကအဲဆု၊ နိအိဂတစီရင်စု",
      "khName": "តំបន់កាអែហ្សីនៃខេត្ដនីហ្គាតាក់ឹ",
      "neName": "निइगाता जिल्ला, काएचु क्षेत्र"
    },
    "class15": {
      "code": "150012",
      "name": "岩船地域",
      "enName": "Iwafune Area"
    },
    "class20": {
      "code": "1558600",
      "name": "粟島浦村",
      "enName": "Awashimaura Village",
      "kana": "あわしまうらむら",
      "chName": "粟岛浦村",
      "zhName": "粟島浦村",
      "koName": "아와시마우라 촌",
      "esName": "Aldea de Awashimaura",
      "ptName": "povoado de Awashimaura",
      "thName": "หมู่บ้านอาวาชิมะอุระ",
      "viName": "làng Awashimaura",
      "inName": "desa Awashimaura",
      "tlName": "nayon ng Awashimaura",
      "moName": "Авашимaүра тосгон",
      "buName": "အဝါရှိမာ့ဥရာ့ ကျေးရွာ",
      "khName": "ភូមិ អាវ៉ាស៊ីម៉ាអ៊ូរ៉ា",
      "neName": "आवाशिमाउरा गाउँ"
    }
  },
  "1620111": {
    "office": {
      "code": "160000",
      "name": "富山県",
      "enName": "Toyama",
      "officeName": "富山地方気象台",
      "chName": "富山县",
      "zhName": "富山縣",
      "koName": "도야마현",
      "esName": "Prefectura de Toyama",
      "ptName": "Província de Toyama",
      "thName": "จังหวัดโทะยามะ",
      "viName": "Tỉnh Toyama",
      "inName": "Prefektur Toyama",
      "tlName": "Toyama Prefecture",
      "moName": "Тояма аймаг",
      "buName": "တိုယာမ ပြည်နယ်",
      "khName": "ខេត្ដ តូយ៉ាម៉ា",
      "neName": "तोयामा जिल्ला"
    },
    "class10": {
      "code": "160010",
      "name": "東部",
      "enName": "Eastern Region",
      "chName": "富山县东部",
      "zhName": "富山縣東部",
      "koName": "토야마 현 동부",
      "esName": "Este de Prefectura de Toyama",
      "ptName": "Leste da Província de Toyama",
      "thName": "จังหวัดโทะยามะฟากตะวันออก",
      "viName": "Miền Đông tỉnh Toyama",
      "inName": "Bagian Timur Prefektur Toyama",
      "tlName": "Silangang bahagi ng Toyama Prefecture",
      "moName": "Зүүн Тояама аймаг",
      "buName": "တိုယမစီရင်စု အရှေ့ပိုင်း",
      "khName": "តំបន់ខាងកើតនៃខេត្ដតុយ៉ាម៉ា",
      "neName": "तोयामा जिल्लाको पूर्वी भाग"
    },
    "class15": {
      "code": "160011",
      "name": "東部南",
      "enName": "South-eastern Region"
    },
    "class20": {
      "code": "1620111",
      "name": "富山市平地",
      "enName": "Plain Area of Toyama City",
      "kana": "とやましへいち"
    }
  },
  "1620112": {
    "office": {
      "code": "160000",
      "name": "富山県",
      "enName": "Toyama",
      "officeName": "富山地方気象台",
      "chName": "富山县",
      "zhName": "富山縣",
      "koName": "도야마현",
      "esName": "Prefectura de Toyama",
      "ptName": "Província de Toyama",
      "thName": "จังหวัดโทะยามะ",
      "viName": "Tỉnh Toyama",
      "inName": "Prefektur Toyama",
      "tlName": "Toyama Prefecture",
      "moName": "Тояма аймаг",
      "buName": "တိုယာမ ပြည်နယ်",
      "khName": "ខេត្ដ តូយ៉ាម៉ា",
      "neName": "तोयामा जिल्ला"
    },
    "class10": {
      "code": "160010",
      "name": "東部",
      "enName": "Eastern Region",
      "chName": "富山县东部",
      "zhName": "富山縣東部",
      "koName": "토야마 현 동부",
      "esName": "Este de Prefectura de Toyama",
      "ptName": "Leste da Província de Toyama",
      "thName": "จังหวัดโทะยามะฟากตะวันออก",
      "viName": "Miền Đông tỉnh Toyama",
      "inName": "Bagian Timur Prefektur Toyama",
      "tlName": "Silangang bahagi ng Toyama Prefecture",
      "moName": "Зүүн Тояама аймаг",
      "buName": "တိုယမစီရင်စု အရှေ့ပိုင်း",
      "khName": "តំបន់ខាងកើតនៃខេត្ដតុយ៉ាម៉ា",
      "neName": "तोयामा जिल्लाको पूर्वी भाग"
    },
    "class15": {
      "code": "160011",
      "name": "東部南",
      "enName": "South-eastern Region"
    },
    "class20": {
      "code": "1620112",
      "name": "富山市山間部東",
      "enName": "Eastern mountains Region of Toyama City",
      "kana": "とやましさんかんぶひがし"
    }
  },
  "1620113": {
    "office": {
      "code": "160000",
      "name": "富山県",
      "enName": "Toyama",
      "officeName": "富山地方気象台",
      "chName": "富山县",
      "zhName": "富山縣",
      "koName": "도야마현",
      "esName": "Prefectura de Toyama",
      "ptName": "Província de Toyama",
      "thName": "จังหวัดโทะยามะ",
      "viName": "Tỉnh Toyama",
      "inName": "Prefektur Toyama",
      "tlName": "Toyama Prefecture",
      "moName": "Тояма аймаг",
      "buName": "တိုယာမ ပြည်နယ်",
      "khName": "ខេត្ដ តូយ៉ាម៉ា",
      "neName": "तोयामा जिल्ला"
    },
    "class10": {
      "code": "160010",
      "name": "東部",
      "enName": "Eastern Region",
      "chName": "富山县东部",
      "zhName": "富山縣東部",
      "koName": "토야마 현 동부",
      "esName": "Este de Prefectura de Toyama",
      "ptName": "Leste da Província de Toyama",
      "thName": "จังหวัดโทะยามะฟากตะวันออก",
      "viName": "Miền Đông tỉnh Toyama",
      "inName": "Bagian Timur Prefektur Toyama",
      "tlName": "Silangang bahagi ng Toyama Prefecture",
      "moName": "Зүүн Тояама аймаг",
      "buName": "တိုယမစီရင်စု အရှေ့ပိုင်း",
      "khName": "តំបន់ខាងកើតនៃខេត្ដតុយ៉ាម៉ា",
      "neName": "तोयामा जिल्लाको पूर्वी भाग"
    },
    "class15": {
      "code": "160011",
      "name": "東部南",
      "enName": "South-eastern Region"
    },
    "class20": {
      "code": "1620113",
      "name": "富山市山間部西",
      "enName": "Western mountains Region of Toyama City",
      "kana": "とやましさんかんぶにし"
    }
  },
  "1620200": {
    "office": {
      "code": "160000",
      "name": "富山県",
      "enName": "Toyama",
      "officeName": "富山地方気象台",
      "chName": "富山县",
      "zhName": "富山縣",
      "koName": "도야마현",
      "esName": "Prefectura de Toyama",
      "ptName": "Província de Toyama",
      "thName": "จังหวัดโทะยามะ",
      "viName": "Tỉnh Toyama",
      "inName": "Prefektur Toyama",
      "tlName": "Toyama Prefecture",
      "moName": "Тояма аймаг",
      "buName": "တိုယာမ ပြည်နယ်",
      "khName": "ខេត្ដ តូយ៉ាម៉ា",
      "neName": "तोयामा जिल्ला"
    },
    "class10": {
      "code": "160020",
      "name": "西部",
      "enName": "Western Region",
      "chName": "富山县西部",
      "zhName": "富山縣西部",
      "koName": "토야마 현 서부",
      "esName": "Oeste de Prefectura de Toyama",
      "ptName": "Oeste da Província de Toyama",
      "thName": "จังหวัดโทะยามะฟากตะวันตก",
      "viName": "Miền Tây tỉnh Toyama",
      "inName": "Bagian Barat Prefektur Toyama",
      "tlName": "Kanlurang bahagi ng Toyama Prefecture",
      "moName": "Баруун Тояама аймаг",
      "buName": "တိုယမစီရင်စု အနောက်ပိုင်း",
      "khName": "តំបន់ខាងលិចនៃខេត្ដតុយ៉ាម៉ា",
      "neName": "तोयामा जिल्लाको पश्चिमी भाग"
    },
    "class15": {
      "code": "160021",
      "name": "西部北",
      "enName": "North-western Region"
    },
    "class20": {
      "code": "1620200",
      "name": "高岡市",
      "enName": "Takaoka City",
      "kana": "たかおかし",
      "chName": "高冈市",
      "zhName": "髙岡市",
      "koName": "다카오카 시",
      "esName": "Ciudad de Takaoka",
      "ptName": "cidade de Takaoka",
      "thName": "เมืองทากาโอกะ",
      "viName": "thành phố Takaoka",
      "inName": "kota Takaoka",
      "tlName": "siyudad ng Takaoka",
      "moName": "Такаока хот",
      "buName": "တာကားအို့က မြို့",
      "khName": "ទីក្រុង ថាកាអូកា",
      "neName": "ताकाओका सहर"
    }
  },
  "1620400": {
    "office": {
      "code": "160000",
      "name": "富山県",
      "enName": "Toyama",
      "officeName": "富山地方気象台",
      "chName": "富山县",
      "zhName": "富山縣",
      "koName": "도야마현",
      "esName": "Prefectura de Toyama",
      "ptName": "Província de Toyama",
      "thName": "จังหวัดโทะยามะ",
      "viName": "Tỉnh Toyama",
      "inName": "Prefektur Toyama",
      "tlName": "Toyama Prefecture",
      "moName": "Тояма аймаг",
      "buName": "တိုယာမ ပြည်နယ်",
      "khName": "ខេត្ដ តូយ៉ាម៉ា",
      "neName": "तोयामा जिल्ला"
    },
    "class10": {
      "code": "160010",
      "name": "東部",
      "enName": "Eastern Region",
      "chName": "富山县东部",
      "zhName": "富山縣東部",
      "koName": "토야마 현 동부",
      "esName": "Este de Prefectura de Toyama",
      "ptName": "Leste da Província de Toyama",
      "thName": "จังหวัดโทะยามะฟากตะวันออก",
      "viName": "Miền Đông tỉnh Toyama",
      "inName": "Bagian Timur Prefektur Toyama",
      "tlName": "Silangang bahagi ng Toyama Prefecture",
      "moName": "Зүүн Тояама аймаг",
      "buName": "တိုယမစီရင်စု အရှေ့ပိုင်း",
      "khName": "តំបន់ខាងកើតនៃខេត្ដតុយ៉ាម៉ា",
      "neName": "तोयामा जिल्लाको पूर्वी भाग"
    },
    "class15": {
      "code": "160012",
      "name": "東部北",
      "enName": "North-eastern Region"
    },
    "class20": {
      "code": "1620400",
      "name": "魚津市",
      "enName": "Uozu City",
      "kana": "うおづし",
      "chName": "鱼津市",
      "zhName": "魚津市",
      "koName": "우오즈 시",
      "esName": "Ciudad de Uozu",
      "ptName": "cidade de Uozu",
      "thName": "เมืองอุโอะสึ",
      "viName": "thành phố Uozu",
      "inName": "kota Uozu",
      "tlName": "siyudad ng Uozu",
      "moName": "Үозү хот",
      "buName": "အိုးဇု မြို့",
      "khName": "ទីក្រុង យូអូហ្សូ",
      "neName": "उओजु सहर"
    }
  },
  "1620500": {
    "office": {
      "code": "160000",
      "name": "富山県",
      "enName": "Toyama",
      "officeName": "富山地方気象台",
      "chName": "富山县",
      "zhName": "富山縣",
      "koName": "도야마현",
      "esName": "Prefectura de Toyama",
      "ptName": "Província de Toyama",
      "thName": "จังหวัดโทะยามะ",
      "viName": "Tỉnh Toyama",
      "inName": "Prefektur Toyama",
      "tlName": "Toyama Prefecture",
      "moName": "Тояма аймаг",
      "buName": "တိုယာမ ပြည်နယ်",
      "khName": "ខេត្ដ តូយ៉ាម៉ា",
      "neName": "तोयामा जिल्ला"
    },
    "class10": {
      "code": "160020",
      "name": "西部",
      "enName": "Western Region",
      "chName": "富山县西部",
      "zhName": "富山縣西部",
      "koName": "토야마 현 서부",
      "esName": "Oeste de Prefectura de Toyama",
      "ptName": "Oeste da Província de Toyama",
      "thName": "จังหวัดโทะยามะฟากตะวันตก",
      "viName": "Miền Tây tỉnh Toyama",
      "inName": "Bagian Barat Prefektur Toyama",
      "tlName": "Kanlurang bahagi ng Toyama Prefecture",
      "moName": "Баруун Тояама аймаг",
      "buName": "တိုယမစီရင်စု အနောက်ပိုင်း",
      "khName": "តំបន់ខាងលិចនៃខេត្ដតុយ៉ាម៉ា",
      "neName": "तोयामा जिल्लाको पश्चिमी भाग"
    },
    "class15": {
      "code": "160021",
      "name": "西部北",
      "enName": "North-western Region"
    },
    "class20": {
      "code": "1620500",
      "name": "氷見市",
      "enName": "Himi City",
      "kana": "ひみし",
      "chName": "冰见市",
      "zhName": "冰見市",
      "koName": "히미 시",
      "esName": "Ciudad de Himi",
      "ptName": "cidade de Himi",
      "thName": "เมืองฮิมิ",
      "viName": "thành phố Himi",
      "inName": "kota Himi",
      "tlName": "siyudad ng Himi",
      "moName": "Хими хот",
      "buName": "ဟီမိ မြို့",
      "khName": "ទីក្រុង ហ៊ីមី",
      "neName": "हिमी सहर"
    }
  },
  "1620600": {
    "office": {
      "code": "160000",
      "name": "富山県",
      "enName": "Toyama",
      "officeName": "富山地方気象台",
      "chName": "富山县",
      "zhName": "富山縣",
      "koName": "도야마현",
      "esName": "Prefectura de Toyama",
      "ptName": "Província de Toyama",
      "thName": "จังหวัดโทะยามะ",
      "viName": "Tỉnh Toyama",
      "inName": "Prefektur Toyama",
      "tlName": "Toyama Prefecture",
      "moName": "Тояма аймаг",
      "buName": "တိုယာမ ပြည်နယ်",
      "khName": "ខេត្ដ តូយ៉ាម៉ា",
      "neName": "तोयामा जिल्ला"
    },
    "class10": {
      "code": "160010",
      "name": "東部",
      "enName": "Eastern Region",
      "chName": "富山县东部",
      "zhName": "富山縣東部",
      "koName": "토야마 현 동부",
      "esName": "Este de Prefectura de Toyama",
      "ptName": "Leste da Província de Toyama",
      "thName": "จังหวัดโทะยามะฟากตะวันออก",
      "viName": "Miền Đông tỉnh Toyama",
      "inName": "Bagian Timur Prefektur Toyama",
      "tlName": "Silangang bahagi ng Toyama Prefecture",
      "moName": "Зүүн Тояама аймаг",
      "buName": "တိုယမစီရင်စု အရှေ့ပိုင်း",
      "khName": "តំបន់ខាងកើតនៃខេត្ដតុយ៉ាម៉ា",
      "neName": "तोयामा जिल्लाको पूर्वी भाग"
    },
    "class15": {
      "code": "160012",
      "name": "東部北",
      "enName": "North-eastern Region"
    },
    "class20": {
      "code": "1620600",
      "name": "滑川市",
      "enName": "Namerikawa City",
      "kana": "なめりかわし",
      "chName": "滑川市",
      "zhName": "滑川市",
      "koName": "나메리카와 시",
      "esName": "Ciudad de Namerikawa",
      "ptName": "cidade de Namerikawa",
      "thName": "เมืองนาเมริคาวา",
      "viName": "thành phố Namerikawa",
      "inName": "kota Namerikawa",
      "tlName": "siyudad ng Namerikawa",
      "moName": "Намэрикава хот",
      "buName": "နာမေးရိကာ့ဝ မြို့",
      "khName": "ទីក្រុង ណេមៀរីកាវ៉ា",
      "neName": "नामेरिकावा सहर"
    }
  },
  "1620700": {
    "office": {
      "code": "160000",
      "name": "富山県",
      "enName": "Toyama",
      "officeName": "富山地方気象台",
      "chName": "富山县",
      "zhName": "富山縣",
      "koName": "도야마현",
      "esName": "Prefectura de Toyama",
      "ptName": "Província de Toyama",
      "thName": "จังหวัดโทะยามะ",
      "viName": "Tỉnh Toyama",
      "inName": "Prefektur Toyama",
      "tlName": "Toyama Prefecture",
      "moName": "Тояма аймаг",
      "buName": "တိုယာမ ပြည်နယ်",
      "khName": "ខេត្ដ តូយ៉ាម៉ា",
      "neName": "तोयामा जिल्ला"
    },
    "class10": {
      "code": "160010",
      "name": "東部",
      "enName": "Eastern Region",
      "chName": "富山县东部",
      "zhName": "富山縣東部",
      "koName": "토야마 현 동부",
      "esName": "Este de Prefectura de Toyama",
      "ptName": "Leste da Província de Toyama",
      "thName": "จังหวัดโทะยามะฟากตะวันออก",
      "viName": "Miền Đông tỉnh Toyama",
      "inName": "Bagian Timur Prefektur Toyama",
      "tlName": "Silangang bahagi ng Toyama Prefecture",
      "moName": "Зүүн Тояама аймаг",
      "buName": "တိုယမစီရင်စု အရှေ့ပိုင်း",
      "khName": "តំបន់ខាងកើតនៃខេត្ដតុយ៉ាម៉ា",
      "neName": "तोयामा जिल्लाको पूर्वी भाग"
    },
    "class15": {
      "code": "160012",
      "name": "東部北",
      "enName": "North-eastern Region"
    },
    "class20": {
      "code": "1620700",
      "name": "黒部市",
      "enName": "Kurobe City",
      "kana": "くろべし",
      "chName": "黑部市",
      "zhName": "黑部市",
      "koName": "구로베 시",
      "esName": "Ciudad de Kurobe",
      "ptName": "cidade de Kurobe",
      "thName": "เมืองคุโรเบะ",
      "viName": "thành phố Kurobe",
      "inName": "kota Kurobe",
      "tlName": "siyudad ng Kurobe",
      "moName": "Күробэ хот",
      "buName": "ကူရိုးဘဲ့ မြို့",
      "khName": "ទីក្រុង ឃូរ៉ូប",
      "neName": "कुरोबे सहर"
    }
  },
  "1620800": {
    "office": {
      "code": "160000",
      "name": "富山県",
      "enName": "Toyama",
      "officeName": "富山地方気象台",
      "chName": "富山县",
      "zhName": "富山縣",
      "koName": "도야마현",
      "esName": "Prefectura de Toyama",
      "ptName": "Província de Toyama",
      "thName": "จังหวัดโทะยามะ",
      "viName": "Tỉnh Toyama",
      "inName": "Prefektur Toyama",
      "tlName": "Toyama Prefecture",
      "moName": "Тояма аймаг",
      "buName": "တိုယာမ ပြည်နယ်",
      "khName": "ខេត្ដ តូយ៉ាម៉ា",
      "neName": "तोयामा जिल्ला"
    },
    "class10": {
      "code": "160020",
      "name": "西部",
      "enName": "Western Region",
      "chName": "富山县西部",
      "zhName": "富山縣西部",
      "koName": "토야마 현 서부",
      "esName": "Oeste de Prefectura de Toyama",
      "ptName": "Oeste da Província de Toyama",
      "thName": "จังหวัดโทะยามะฟากตะวันตก",
      "viName": "Miền Tây tỉnh Toyama",
      "inName": "Bagian Barat Prefektur Toyama",
      "tlName": "Kanlurang bahagi ng Toyama Prefecture",
      "moName": "Баруун Тояама аймаг",
      "buName": "တိုယမစီရင်စု အနောက်ပိုင်း",
      "khName": "តំបន់ខាងលិចនៃខេត្ដតុយ៉ាម៉ា",
      "neName": "तोयामा जिल्लाको पश्चिमी भाग"
    },
    "class15": {
      "code": "160022",
      "name": "西部南",
      "enName": "South-western Region"
    },
    "class20": {
      "code": "1620800",
      "name": "砺波市",
      "enName": "Tonami City",
      "kana": "となみし",
      "chName": "砺波市",
      "zhName": "礪波市",
      "koName": "도나미 시",
      "esName": "Ciudad de Tonami",
      "ptName": "cidade de Tonami",
      "thName": "เมืองโทนามิ",
      "viName": "thành phố Tonami",
      "inName": "kota Tonami",
      "tlName": "siyudad ng Tonami",
      "moName": "Тонaми хот",
      "buName": "တိုနာ့မိ မြို့",
      "khName": "ទីក្រុង តូណាមិ",
      "neName": "तोनामी सहर"
    }
  },
  "1620900": {
    "office": {
      "code": "160000",
      "name": "富山県",
      "enName": "Toyama",
      "officeName": "富山地方気象台",
      "chName": "富山县",
      "zhName": "富山縣",
      "koName": "도야마현",
      "esName": "Prefectura de Toyama",
      "ptName": "Província de Toyama",
      "thName": "จังหวัดโทะยามะ",
      "viName": "Tỉnh Toyama",
      "inName": "Prefektur Toyama",
      "tlName": "Toyama Prefecture",
      "moName": "Тояма аймаг",
      "buName": "တိုယာမ ပြည်နယ်",
      "khName": "ខេត្ដ តូយ៉ាម៉ា",
      "neName": "तोयामा जिल्ला"
    },
    "class10": {
      "code": "160020",
      "name": "西部",
      "enName": "Western Region",
      "chName": "富山县西部",
      "zhName": "富山縣西部",
      "koName": "토야마 현 서부",
      "esName": "Oeste de Prefectura de Toyama",
      "ptName": "Oeste da Província de Toyama",
      "thName": "จังหวัดโทะยามะฟากตะวันตก",
      "viName": "Miền Tây tỉnh Toyama",
      "inName": "Bagian Barat Prefektur Toyama",
      "tlName": "Kanlurang bahagi ng Toyama Prefecture",
      "moName": "Баруун Тояама аймаг",
      "buName": "တိုယမစီရင်စု အနောက်ပိုင်း",
      "khName": "តំបន់ខាងលិចនៃខេត្ដតុយ៉ាម៉ា",
      "neName": "तोयामा जिल्लाको पश्चिमी भाग"
    },
    "class15": {
      "code": "160021",
      "name": "西部北",
      "enName": "North-western Region"
    },
    "class20": {
      "code": "1620900",
      "name": "小矢部市",
      "enName": "Oyabe City",
      "kana": "おやべし",
      "chName": "小矢部市",
      "zhName": "小矢部市",
      "koName": "오야베 시",
      "esName": "Ciudad de Oyabe",
      "ptName": "cidade de Oyabe",
      "thName": "เมืองโอยาเบะ",
      "viName": "thành phố Oyabe",
      "inName": "kota Oyabe",
      "tlName": "siyudad ng Oyabe",
      "moName": "Оябэ хот",
      "buName": "အိုးယာဘဲ့ မြို့",
      "khName": "ទីក្រុង អូយ៉ាប៊ី",
      "neName": "ओयाबे सहर"
    }
  },
  "1621000": {
    "office": {
      "code": "160000",
      "name": "富山県",
      "enName": "Toyama",
      "officeName": "富山地方気象台",
      "chName": "富山县",
      "zhName": "富山縣",
      "koName": "도야마현",
      "esName": "Prefectura de Toyama",
      "ptName": "Província de Toyama",
      "thName": "จังหวัดโทะยามะ",
      "viName": "Tỉnh Toyama",
      "inName": "Prefektur Toyama",
      "tlName": "Toyama Prefecture",
      "moName": "Тояма аймаг",
      "buName": "တိုယာမ ပြည်နယ်",
      "khName": "ខេត្ដ តូយ៉ាម៉ា",
      "neName": "तोयामा जिल्ला"
    },
    "class10": {
      "code": "160020",
      "name": "西部",
      "enName": "Western Region",
      "chName": "富山县西部",
      "zhName": "富山縣西部",
      "koName": "토야마 현 서부",
      "esName": "Oeste de Prefectura de Toyama",
      "ptName": "Oeste da Província de Toyama",
      "thName": "จังหวัดโทะยามะฟากตะวันตก",
      "viName": "Miền Tây tỉnh Toyama",
      "inName": "Bagian Barat Prefektur Toyama",
      "tlName": "Kanlurang bahagi ng Toyama Prefecture",
      "moName": "Баруун Тояама аймаг",
      "buName": "တိုယမစီရင်စု အနောက်ပိုင်း",
      "khName": "តំបន់ខាងលិចនៃខេត្ដតុយ៉ាម៉ា",
      "neName": "तोयामा जिल्लाको पश्चिमी भाग"
    },
    "class15": {
      "code": "160022",
      "name": "西部南",
      "enName": "South-western Region"
    },
    "class20": {
      "code": "1621000",
      "name": "南砺市",
      "enName": "Nanto City",
      "kana": "なんとし",
      "chName": "南砺市",
      "zhName": "南礪市",
      "koName": "난토 시",
      "esName": "Ciudad de Nanto",
      "ptName": "cidade de Nanto",
      "thName": "เมืองนันโตะ",
      "viName": "thành phố Nanto",
      "inName": "kota Nanto",
      "tlName": "siyudad ng Nanto",
      "moName": "Нaнто хот",
      "buName": "နန်တို မြို့",
      "khName": "ទីក្រុង ណានតូ",
      "neName": "नान्तो सहर"
    }
  },
  "1621100": {
    "office": {
      "code": "160000",
      "name": "富山県",
      "enName": "Toyama",
      "officeName": "富山地方気象台",
      "chName": "富山县",
      "zhName": "富山縣",
      "koName": "도야마현",
      "esName": "Prefectura de Toyama",
      "ptName": "Província de Toyama",
      "thName": "จังหวัดโทะยามะ",
      "viName": "Tỉnh Toyama",
      "inName": "Prefektur Toyama",
      "tlName": "Toyama Prefecture",
      "moName": "Тояма аймаг",
      "buName": "တိုယာမ ပြည်နယ်",
      "khName": "ខេត្ដ តូយ៉ាម៉ា",
      "neName": "तोयामा जिल्ला"
    },
    "class10": {
      "code": "160020",
      "name": "西部",
      "enName": "Western Region",
      "chName": "富山县西部",
      "zhName": "富山縣西部",
      "koName": "토야마 현 서부",
      "esName": "Oeste de Prefectura de Toyama",
      "ptName": "Oeste da Província de Toyama",
      "thName": "จังหวัดโทะยามะฟากตะวันตก",
      "viName": "Miền Tây tỉnh Toyama",
      "inName": "Bagian Barat Prefektur Toyama",
      "tlName": "Kanlurang bahagi ng Toyama Prefecture",
      "moName": "Баруун Тояама аймаг",
      "buName": "တိုယမစီရင်စု အနောက်ပိုင်း",
      "khName": "តំបន់ខាងលិចនៃខេត្ដតុយ៉ាម៉ា",
      "neName": "तोयामा जिल्लाको पश्चिमी भाग"
    },
    "class15": {
      "code": "160021",
      "name": "西部北",
      "enName": "North-western Region"
    },
    "class20": {
      "code": "1621100",
      "name": "射水市",
      "enName": "Imizu City",
      "kana": "いみずし",
      "chName": "射水市",
      "zhName": "射水市",
      "koName": "이미즈 시",
      "esName": "Ciudad de Imizu",
      "ptName": "cidade de Imizu",
      "thName": "เมืองอิมิสุ",
      "viName": "thành phố Imizu",
      "inName": "kota Imizu",
      "tlName": "siyudad ng Imizu",
      "moName": "Имизү хот",
      "buName": "အီမိဇု မြို့",
      "khName": "ទីក្រុង អ៊ីមីហ្សូ",
      "neName": "इमिजु सहर"
    }
  },
  "1632100": {
    "office": {
      "code": "160000",
      "name": "富山県",
      "enName": "Toyama",
      "officeName": "富山地方気象台",
      "chName": "富山县",
      "zhName": "富山縣",
      "koName": "도야마현",
      "esName": "Prefectura de Toyama",
      "ptName": "Província de Toyama",
      "thName": "จังหวัดโทะยามะ",
      "viName": "Tỉnh Toyama",
      "inName": "Prefektur Toyama",
      "tlName": "Toyama Prefecture",
      "moName": "Тояма аймаг",
      "buName": "တိုယာမ ပြည်နယ်",
      "khName": "ខេត្ដ តូយ៉ាម៉ា",
      "neName": "तोयामा जिल्ला"
    },
    "class10": {
      "code": "160010",
      "name": "東部",
      "enName": "Eastern Region",
      "chName": "富山县东部",
      "zhName": "富山縣東部",
      "koName": "토야마 현 동부",
      "esName": "Este de Prefectura de Toyama",
      "ptName": "Leste da Província de Toyama",
      "thName": "จังหวัดโทะยามะฟากตะวันออก",
      "viName": "Miền Đông tỉnh Toyama",
      "inName": "Bagian Timur Prefektur Toyama",
      "tlName": "Silangang bahagi ng Toyama Prefecture",
      "moName": "Зүүн Тояама аймаг",
      "buName": "တိုယမစီရင်စု အရှေ့ပိုင်း",
      "khName": "តំបន់ខាងកើតនៃខេត្ដតុយ៉ាម៉ា",
      "neName": "तोयामा जिल्लाको पूर्वी भाग"
    },
    "class15": {
      "code": "160011",
      "name": "東部南",
      "enName": "South-eastern Region"
    },
    "class20": {
      "code": "1632100",
      "name": "舟橋村",
      "enName": "Funahashi Village",
      "kana": "ふなはしむら",
      "chName": "舟桥村",
      "zhName": "舟橋村",
      "koName": "후나하시 촌",
      "esName": "Aldea de Funahashi",
      "ptName": "povoado de Funahashi",
      "thName": "หมู่บ้านฟุนะฮาชิ",
      "viName": "làng Funahashi",
      "inName": "desa Funahashi",
      "tlName": "nayon ng Funahashi",
      "moName": "Фүнaхaши тосгон",
      "buName": "ဟူနာဟာ့ရှိ ကျေးရွာ",
      "khName": "ភូមិ ហ្វូណាហាស៊ី",
      "neName": "फुनाहाशी गाउँ"
    }
  },
  "1632200": {
    "office": {
      "code": "160000",
      "name": "富山県",
      "enName": "Toyama",
      "officeName": "富山地方気象台",
      "chName": "富山县",
      "zhName": "富山縣",
      "koName": "도야마현",
      "esName": "Prefectura de Toyama",
      "ptName": "Província de Toyama",
      "thName": "จังหวัดโทะยามะ",
      "viName": "Tỉnh Toyama",
      "inName": "Prefektur Toyama",
      "tlName": "Toyama Prefecture",
      "moName": "Тояма аймаг",
      "buName": "တိုယာမ ပြည်နယ်",
      "khName": "ខេត្ដ តូយ៉ាម៉ា",
      "neName": "तोयामा जिल्ला"
    },
    "class10": {
      "code": "160010",
      "name": "東部",
      "enName": "Eastern Region",
      "chName": "富山县东部",
      "zhName": "富山縣東部",
      "koName": "토야마 현 동부",
      "esName": "Este de Prefectura de Toyama",
      "ptName": "Leste da Província de Toyama",
      "thName": "จังหวัดโทะยามะฟากตะวันออก",
      "viName": "Miền Đông tỉnh Toyama",
      "inName": "Bagian Timur Prefektur Toyama",
      "tlName": "Silangang bahagi ng Toyama Prefecture",
      "moName": "Зүүн Тояама аймаг",
      "buName": "တိုယမစီရင်စု အရှေ့ပိုင်း",
      "khName": "តំបន់ខាងកើតនៃខេត្ដតុយ៉ាម៉ា",
      "neName": "तोयामा जिल्लाको पूर्वी भाग"
    },
    "class15": {
      "code": "160011",
      "name": "東部南",
      "enName": "South-eastern Region"
    },
    "class20": {
      "code": "1632200",
      "name": "上市町",
      "enName": "Kamiichi Town",
      "kana": "かみいちまち",
      "chName": "上市町",
      "zhName": "上市町",
      "koName": "가미이치 정",
      "esName": "Pueblo de Kamiichi",
      "ptName": "bairro de Kamiichi",
      "thName": "เมืองคามิอิจิ",
      "viName": "thị trấn Kamiichi",
      "inName": "kota Kamiichi",
      "tlName": "bayan ng Kamiichi",
      "moName": "Камийчи жижиг хот",
      "buName": "ကာမီးကျိ မြို့နယ်",
      "khName": "ទីប្រជុំជន កាមីជី",
      "neName": "कामिइची नगर"
    }
  },
  "1632300": {
    "office": {
      "code": "160000",
      "name": "富山県",
      "enName": "Toyama",
      "officeName": "富山地方気象台",
      "chName": "富山县",
      "zhName": "富山縣",
      "koName": "도야마현",
      "esName": "Prefectura de Toyama",
      "ptName": "Província de Toyama",
      "thName": "จังหวัดโทะยามะ",
      "viName": "Tỉnh Toyama",
      "inName": "Prefektur Toyama",
      "tlName": "Toyama Prefecture",
      "moName": "Тояма аймаг",
      "buName": "တိုယာမ ပြည်နယ်",
      "khName": "ខេត្ដ តូយ៉ាម៉ា",
      "neName": "तोयामा जिल्ला"
    },
    "class10": {
      "code": "160010",
      "name": "東部",
      "enName": "Eastern Region",
      "chName": "富山县东部",
      "zhName": "富山縣東部",
      "koName": "토야마 현 동부",
      "esName": "Este de Prefectura de Toyama",
      "ptName": "Leste da Província de Toyama",
      "thName": "จังหวัดโทะยามะฟากตะวันออก",
      "viName": "Miền Đông tỉnh Toyama",
      "inName": "Bagian Timur Prefektur Toyama",
      "tlName": "Silangang bahagi ng Toyama Prefecture",
      "moName": "Зүүн Тояама аймаг",
      "buName": "တိုယမစီရင်စု အရှေ့ပိုင်း",
      "khName": "តំបន់ខាងកើតនៃខេត្ដតុយ៉ាម៉ា",
      "neName": "तोयामा जिल्लाको पूर्वी भाग"
    },
    "class15": {
      "code": "160011",
      "name": "東部南",
      "enName": "South-eastern Region"
    },
    "class20": {
      "code": "1632300",
      "name": "立山町",
      "enName": "Tateyama Town",
      "kana": "たてやままち",
      "chName": "立山町",
      "zhName": "立山町",
      "koName": "다테야마 정",
      "esName": "Pueblo de Tateyama",
      "ptName": "bairro de Tateyama",
      "thName": "เมืองทาเทยามะ",
      "viName": "thị trấn Tateyama",
      "inName": "kota Tateyama",
      "tlName": "bayan ng Tateyama",
      "moName": "Татэямa жижиг хот",
      "buName": "တာတဲယာ့မ မြို့နယ်",
      "khName": "ទីប្រជុំជន ទីតាយ៉ាម៉ា",
      "neName": "तातेयामा नगर"
    }
  },
  "1634200": {
    "office": {
      "code": "160000",
      "name": "富山県",
      "enName": "Toyama",
      "officeName": "富山地方気象台",
      "chName": "富山县",
      "zhName": "富山縣",
      "koName": "도야마현",
      "esName": "Prefectura de Toyama",
      "ptName": "Província de Toyama",
      "thName": "จังหวัดโทะยามะ",
      "viName": "Tỉnh Toyama",
      "inName": "Prefektur Toyama",
      "tlName": "Toyama Prefecture",
      "moName": "Тояма аймаг",
      "buName": "တိုယာမ ပြည်နယ်",
      "khName": "ខេត្ដ តូយ៉ាម៉ា",
      "neName": "तोयामा जिल्ला"
    },
    "class10": {
      "code": "160010",
      "name": "東部",
      "enName": "Eastern Region",
      "chName": "富山县东部",
      "zhName": "富山縣東部",
      "koName": "토야마 현 동부",
      "esName": "Este de Prefectura de Toyama",
      "ptName": "Leste da Província de Toyama",
      "thName": "จังหวัดโทะยามะฟากตะวันออก",
      "viName": "Miền Đông tỉnh Toyama",
      "inName": "Bagian Timur Prefektur Toyama",
      "tlName": "Silangang bahagi ng Toyama Prefecture",
      "moName": "Зүүн Тояама аймаг",
      "buName": "တိုယမစီရင်စု အရှေ့ပိုင်း",
      "khName": "តំបន់ខាងកើតនៃខេត្ដតុយ៉ាម៉ា",
      "neName": "तोयामा जिल्लाको पूर्वी भाग"
    },
    "class15": {
      "code": "160012",
      "name": "東部北",
      "enName": "North-eastern Region"
    },
    "class20": {
      "code": "1634200",
      "name": "入善町",
      "enName": "Nyuzen Town",
      "kana": "にゅうぜんまち",
      "chName": "入善町",
      "zhName": "入善町",
      "koName": "뉴젠 정",
      "esName": "Pueblo de Nyuzen",
      "ptName": "bairro de Nyuzen",
      "thName": "เมืองนิวเซน",
      "viName": "thị trấn Nyuzen",
      "inName": "kota Nyuzen",
      "tlName": "bayan ng Nyuzen",
      "moName": "Нюзэн жижиг хот",
      "buName": "ညုဇန် မြို့နယ်",
      "khName": "ទីប្រជុំជន នីយូហ្សែន",
      "neName": "न्युजेन नगर"
    }
  },
  "1634300": {
    "office": {
      "code": "160000",
      "name": "富山県",
      "enName": "Toyama",
      "officeName": "富山地方気象台",
      "chName": "富山县",
      "zhName": "富山縣",
      "koName": "도야마현",
      "esName": "Prefectura de Toyama",
      "ptName": "Província de Toyama",
      "thName": "จังหวัดโทะยามะ",
      "viName": "Tỉnh Toyama",
      "inName": "Prefektur Toyama",
      "tlName": "Toyama Prefecture",
      "moName": "Тояма аймаг",
      "buName": "တိုယာမ ပြည်နယ်",
      "khName": "ខេត្ដ តូយ៉ាម៉ា",
      "neName": "तोयामा जिल्ला"
    },
    "class10": {
      "code": "160010",
      "name": "東部",
      "enName": "Eastern Region",
      "chName": "富山县东部",
      "zhName": "富山縣東部",
      "koName": "토야마 현 동부",
      "esName": "Este de Prefectura de Toyama",
      "ptName": "Leste da Província de Toyama",
      "thName": "จังหวัดโทะยามะฟากตะวันออก",
      "viName": "Miền Đông tỉnh Toyama",
      "inName": "Bagian Timur Prefektur Toyama",
      "tlName": "Silangang bahagi ng Toyama Prefecture",
      "moName": "Зүүн Тояама аймаг",
      "buName": "တိုယမစီရင်စု အရှေ့ပိုင်း",
      "khName": "តំបន់ខាងកើតនៃខេត្ដតុយ៉ាម៉ា",
      "neName": "तोयामा जिल्लाको पूर्वी भाग"
    },
    "class15": {
      "code": "160012",
      "name": "東部北",
      "enName": "North-eastern Region"
    },
    "class20": {
      "code": "1634300",
      "name": "朝日町",
      "enName": "Asahi Town",
      "kana": "あさひまち",
      "chName": "富山朝日町",
      "zhName": "富山朝日町",
      "koName": "도야마 아사히 정",
      "esName": "Pueblo de Asahi, Toyama",
      "ptName": "Toyama, bairro de Asahi",
      "thName": "เมืองอาซาฮิ โทะยามะ",
      "viName": "Thị trấn Asahi, Toyama",
      "inName": "Kota Asahi, Toyama",
      "tlName": "bayan ng Asahi, Toyama",
      "moName": "Тояма Асахи жижиг хот",
      "buName": "တိုယမအဆဟိမြို့နယ်",
      "khName": "ទីប្រជុំជនអាសាហ៊ី តុយ៉ាម៉ា",
      "neName": "तोयामा आसाही नगर"
    }
  },
  "1720100": {
    "office": {
      "code": "170000",
      "name": "石川県",
      "enName": "Ishikawa",
      "officeName": "金沢地方気象台",
      "chName": "石川县",
      "zhName": "石川縣",
      "koName": "이시카와현",
      "esName": "Prefectura de Ishikawa",
      "ptName": "Província de Ishikawa",
      "thName": "จังหวัดอิชิกาวะ",
      "viName": "Tỉnh Ishikawa",
      "inName": "Ishikawa Prefektur",
      "tlName": "Ishikawa Prefecture",
      "moName": "Ишикава аймаг",
      "buName": "အီရှီခါးဝ ပြည်နယ်",
      "khName": "ខេត្ត អ៊ីស៊ីកាវ៉ា",
      "neName": "इसिखावा जिल्ला"
    },
    "class10": {
      "code": "170010",
      "name": "加賀",
      "enName": "Kaga",
      "chName": "石川县加贺地方",
      "zhName": "石川縣加賀地方",
      "koName": "이시카와 현 카가 지방",
      "esName": "Región Kaga, Prefectura de Ishikawa",
      "ptName": "Região de Kaga da Província de Ishikawa",
      "thName": "ท้องถิ่นคางะ จังหวัดอิชิกาวะ",
      "viName": "Vùng Kaga tỉnh Ishikawa",
      "inName": "Daerah Kaga di Prefektur Ishikawa",
      "tlName": "Rehiyon ng Kaga sa Ishikawa Prefecture",
      "moName": "Ишикава аймаг, Кага",
      "buName": "ကဂ၊ အိရှိကဝစီရင်စု",
      "khName": "តំបន់កាហ្គានៃខេត្តអ៊ិស៊ីខាវ៉ា",
      "neName": "इसिखावा जिल्ला, कागा क्षेत्र"
    },
    "class15": {
      "code": "170011",
      "name": "加賀北部",
      "enName": "Northern Kaga"
    },
    "class20": {
      "code": "1720100",
      "name": "金沢市",
      "enName": "Kanazawa City",
      "kana": "かなざわし",
      "chName": "金泽市",
      "zhName": "金澤市",
      "koName": "가나자와 시",
      "esName": "Ciudad de Kanazawa",
      "ptName": "cidade de Kanazawa",
      "thName": "เมืองคานาซาวา",
      "viName": "thành phố Kanazawa",
      "inName": "kota Kanazawa",
      "tlName": "siyudad ng Kanazawa",
      "moName": "Канaзава хот",
      "buName": "ကန်နားဇာ့ဝ မြို့",
      "khName": "ទីក្រុង កាណាហ្សាវ៉ា",
      "neName": "कानाजावा सहर"
    }
  },
  "1720200": {
    "office": {
      "code": "170000",
      "name": "石川県",
      "enName": "Ishikawa",
      "officeName": "金沢地方気象台",
      "chName": "石川县",
      "zhName": "石川縣",
      "koName": "이시카와현",
      "esName": "Prefectura de Ishikawa",
      "ptName": "Província de Ishikawa",
      "thName": "จังหวัดอิชิกาวะ",
      "viName": "Tỉnh Ishikawa",
      "inName": "Ishikawa Prefektur",
      "tlName": "Ishikawa Prefecture",
      "moName": "Ишикава аймаг",
      "buName": "အီရှီခါးဝ ပြည်နယ်",
      "khName": "ខេត្ត អ៊ីស៊ីកាវ៉ា",
      "neName": "इसिखावा जिल्ला"
    },
    "class10": {
      "code": "170020",
      "name": "能登",
      "enName": "Noto",
      "chName": "石川县能登地方",
      "zhName": "石川縣能登地方",
      "koName": "이시카와 현 노토 지방",
      "esName": "Región Noto, Prefectura de Ishikawa",
      "ptName": "Região de Noto da Província de Ishikawa",
      "thName": "ท้องถิ่นโนะโตะ จังหวัดอิชิกาวะ",
      "viName": "Vùng Noto tỉnh Ishikawa",
      "inName": "Daerah Noto di Prefektur Ishikawa",
      "tlName": "Rehiyon ng Noto sa Ishikawa Prefecture",
      "moName": "Ишикава аймаг, Ното",
      "buName": "နိုတို၊ အိရှိကဝစီရင်စု",
      "khName": "តំបន់ណូតូនៃខេត្តអ៊ិស៊ីខាវ៉ា",
      "neName": "इसिखावा जिल्ला, नोतो क्षेत्र"
    },
    "class15": {
      "code": "170022",
      "name": "能登南部",
      "enName": "Southern Noto"
    },
    "class20": {
      "code": "1720200",
      "name": "七尾市",
      "enName": "Nanao City",
      "kana": "ななおし",
      "chName": "七尾市",
      "zhName": "七尾市",
      "koName": "나나오 시",
      "esName": "Ciudad de Nanao",
      "ptName": "cidade de Nanao",
      "thName": "เมืองนานาโอะ",
      "viName": "thành phố Nanao",
      "inName": "kota Nanao",
      "tlName": "siyudad ng Nanao",
      "moName": "Нaнaо хот",
      "buName": "နာနားဟို့ မြို့",
      "khName": "ទីក្រុង ណាណេអូ",
      "neName": "नानाओ सहर"
    }
  },
  "1720300": {
    "office": {
      "code": "170000",
      "name": "石川県",
      "enName": "Ishikawa",
      "officeName": "金沢地方気象台",
      "chName": "石川县",
      "zhName": "石川縣",
      "koName": "이시카와현",
      "esName": "Prefectura de Ishikawa",
      "ptName": "Província de Ishikawa",
      "thName": "จังหวัดอิชิกาวะ",
      "viName": "Tỉnh Ishikawa",
      "inName": "Ishikawa Prefektur",
      "tlName": "Ishikawa Prefecture",
      "moName": "Ишикава аймаг",
      "buName": "အီရှီခါးဝ ပြည်နယ်",
      "khName": "ខេត្ត អ៊ីស៊ីកាវ៉ា",
      "neName": "इसिखावा जिल्ला"
    },
    "class10": {
      "code": "170010",
      "name": "加賀",
      "enName": "Kaga",
      "chName": "石川县加贺地方",
      "zhName": "石川縣加賀地方",
      "koName": "이시카와 현 카가 지방",
      "esName": "Región Kaga, Prefectura de Ishikawa",
      "ptName": "Região de Kaga da Província de Ishikawa",
      "thName": "ท้องถิ่นคางะ จังหวัดอิชิกาวะ",
      "viName": "Vùng Kaga tỉnh Ishikawa",
      "inName": "Daerah Kaga di Prefektur Ishikawa",
      "tlName": "Rehiyon ng Kaga sa Ishikawa Prefecture",
      "moName": "Ишикава аймаг, Кага",
      "buName": "ကဂ၊ အိရှိကဝစီရင်စု",
      "khName": "តំបន់កាហ្គានៃខេត្តអ៊ិស៊ីខាវ៉ា",
      "neName": "इसिखावा जिल्ला, कागा क्षेत्र"
    },
    "class15": {
      "code": "170012",
      "name": "加賀南部",
      "enName": "Southern Kaga"
    },
    "class20": {
      "code": "1720300",
      "name": "小松市",
      "enName": "Komatsu City",
      "kana": "こまつし",
      "chName": "小松市",
      "zhName": "小松市",
      "koName": "고마쓰 시",
      "esName": "Ciudad de Komatsu",
      "ptName": "cidade de Komatsu",
      "thName": "เมืองโคมัทสึ",
      "viName": "thành phố Komatsu",
      "inName": "kota Komatsu",
      "tlName": "siyudad ng Komatsu",
      "moName": "Комацү хот",
      "buName": "ကိုမတ်ဆု မြို့",
      "khName": "ទីក្រុង កូម៉ាត់ស៊ូ",
      "neName": "कोमात्सु सहर"
    }
  },
  "1720400": {
    "office": {
      "code": "170000",
      "name": "石川県",
      "enName": "Ishikawa",
      "officeName": "金沢地方気象台",
      "chName": "石川县",
      "zhName": "石川縣",
      "koName": "이시카와현",
      "esName": "Prefectura de Ishikawa",
      "ptName": "Província de Ishikawa",
      "thName": "จังหวัดอิชิกาวะ",
      "viName": "Tỉnh Ishikawa",
      "inName": "Ishikawa Prefektur",
      "tlName": "Ishikawa Prefecture",
      "moName": "Ишикава аймаг",
      "buName": "အီရှီခါးဝ ပြည်နယ်",
      "khName": "ខេត្ត អ៊ីស៊ីកាវ៉ា",
      "neName": "इसिखावा जिल्ला"
    },
    "class10": {
      "code": "170020",
      "name": "能登",
      "enName": "Noto",
      "chName": "石川县能登地方",
      "zhName": "石川縣能登地方",
      "koName": "이시카와 현 노토 지방",
      "esName": "Región Noto, Prefectura de Ishikawa",
      "ptName": "Região de Noto da Província de Ishikawa",
      "thName": "ท้องถิ่นโนะโตะ จังหวัดอิชิกาวะ",
      "viName": "Vùng Noto tỉnh Ishikawa",
      "inName": "Daerah Noto di Prefektur Ishikawa",
      "tlName": "Rehiyon ng Noto sa Ishikawa Prefecture",
      "moName": "Ишикава аймаг, Ното",
      "buName": "နိုတို၊ အိရှိကဝစီရင်စု",
      "khName": "តំបន់ណូតូនៃខេត្តអ៊ិស៊ីខាវ៉ា",
      "neName": "इसिखावा जिल्ला, नोतो क्षेत्र"
    },
    "class15": {
      "code": "170021",
      "name": "能登北部",
      "enName": "Northern Noto"
    },
    "class20": {
      "code": "1720400",
      "name": "輪島市",
      "enName": "Wajima City",
      "kana": "わじまし",
      "chName": "轮岛市",
      "zhName": "輪島市",
      "koName": "와지마 시",
      "esName": "Ciudad de Wajima",
      "ptName": "cidade de Wajima",
      "thName": "เมืองวาจิมะ",
      "viName": "thành phố Wajima",
      "inName": "kota Wajima",
      "tlName": "siyudad ng Wajima",
      "moName": "Важимa хот",
      "buName": "ဝါးဂျိမ မြို့",
      "khName": "ទីក្រុង វ៉ាជីម៉ា",
      "neName": "वाजिमा सहर"
    }
  },
  "1720500": {
    "office": {
      "code": "170000",
      "name": "石川県",
      "enName": "Ishikawa",
      "officeName": "金沢地方気象台",
      "chName": "石川县",
      "zhName": "石川縣",
      "koName": "이시카와현",
      "esName": "Prefectura de Ishikawa",
      "ptName": "Província de Ishikawa",
      "thName": "จังหวัดอิชิกาวะ",
      "viName": "Tỉnh Ishikawa",
      "inName": "Ishikawa Prefektur",
      "tlName": "Ishikawa Prefecture",
      "moName": "Ишикава аймаг",
      "buName": "အီရှီခါးဝ ပြည်နယ်",
      "khName": "ខេត្ត អ៊ីស៊ីកាវ៉ា",
      "neName": "इसिखावा जिल्ला"
    },
    "class10": {
      "code": "170020",
      "name": "能登",
      "enName": "Noto",
      "chName": "石川县能登地方",
      "zhName": "石川縣能登地方",
      "koName": "이시카와 현 노토 지방",
      "esName": "Región Noto, Prefectura de Ishikawa",
      "ptName": "Região de Noto da Província de Ishikawa",
      "thName": "ท้องถิ่นโนะโตะ จังหวัดอิชิกาวะ",
      "viName": "Vùng Noto tỉnh Ishikawa",
      "inName": "Daerah Noto di Prefektur Ishikawa",
      "tlName": "Rehiyon ng Noto sa Ishikawa Prefecture",
      "moName": "Ишикава аймаг, Ното",
      "buName": "နိုတို၊ အိရှိကဝစီရင်စု",
      "khName": "តំបន់ណូតូនៃខេត្តអ៊ិស៊ីខាវ៉ា",
      "neName": "इसिखावा जिल्ला, नोतो क्षेत्र"
    },
    "class15": {
      "code": "170021",
      "name": "能登北部",
      "enName": "Northern Noto"
    },
    "class20": {
      "code": "1720500",
      "name": "珠洲市",
      "enName": "Suzu City",
      "kana": "すずし",
      "chName": "珠洲市",
      "zhName": "珠洲市",
      "koName": "스즈 시",
      "esName": "Ciudad de Suzu",
      "ptName": "cidade de Suzu",
      "thName": "เมืองซูสุ",
      "viName": "thành phố Suzu",
      "inName": "kota Suzu",
      "tlName": "siyudad ng Suzu",
      "moName": "Зүзү хот",
      "buName": "ဆူဇု မြို့",
      "khName": "ទីក្រុង ស៊ូហ្ស៊ូ",
      "neName": "सुजु सहर"
    }
  },
  "1720600": {
    "office": {
      "code": "170000",
      "name": "石川県",
      "enName": "Ishikawa",
      "officeName": "金沢地方気象台",
      "chName": "石川县",
      "zhName": "石川縣",
      "koName": "이시카와현",
      "esName": "Prefectura de Ishikawa",
      "ptName": "Província de Ishikawa",
      "thName": "จังหวัดอิชิกาวะ",
      "viName": "Tỉnh Ishikawa",
      "inName": "Ishikawa Prefektur",
      "tlName": "Ishikawa Prefecture",
      "moName": "Ишикава аймаг",
      "buName": "အီရှီခါးဝ ပြည်နယ်",
      "khName": "ខេត្ត អ៊ីស៊ីកាវ៉ា",
      "neName": "इसिखावा जिल्ला"
    },
    "class10": {
      "code": "170010",
      "name": "加賀",
      "enName": "Kaga",
      "chName": "石川县加贺地方",
      "zhName": "石川縣加賀地方",
      "koName": "이시카와 현 카가 지방",
      "esName": "Región Kaga, Prefectura de Ishikawa",
      "ptName": "Região de Kaga da Província de Ishikawa",
      "thName": "ท้องถิ่นคางะ จังหวัดอิชิกาวะ",
      "viName": "Vùng Kaga tỉnh Ishikawa",
      "inName": "Daerah Kaga di Prefektur Ishikawa",
      "tlName": "Rehiyon ng Kaga sa Ishikawa Prefecture",
      "moName": "Ишикава аймаг, Кага",
      "buName": "ကဂ၊ အိရှိကဝစီရင်စု",
      "khName": "តំបន់កាហ្គានៃខេត្តអ៊ិស៊ីខាវ៉ា",
      "neName": "इसिखावा जिल्ला, कागा क्षेत्र"
    },
    "class15": {
      "code": "170012",
      "name": "加賀南部",
      "enName": "Southern Kaga"
    },
    "class20": {
      "code": "1720600",
      "name": "加賀市",
      "enName": "Kaga City",
      "kana": "かがし",
      "chName": "加贺市",
      "zhName": "加賀市",
      "koName": "가가 시",
      "esName": "Ciudad de Kaga",
      "ptName": "cidade de Kaga",
      "thName": "เมืองคางะ",
      "viName": "thành phố Kaga",
      "inName": "kota Kaga",
      "tlName": "siyudad ng Kaga",
      "moName": "Кагa хот",
      "buName": "ခါဂ မြို့",
      "khName": "ទីក្រុង កាហ្កា",
      "neName": "कागा सहर"
    }
  },
  "1720700": {
    "office": {
      "code": "170000",
      "name": "石川県",
      "enName": "Ishikawa",
      "officeName": "金沢地方気象台",
      "chName": "石川县",
      "zhName": "石川縣",
      "koName": "이시카와현",
      "esName": "Prefectura de Ishikawa",
      "ptName": "Província de Ishikawa",
      "thName": "จังหวัดอิชิกาวะ",
      "viName": "Tỉnh Ishikawa",
      "inName": "Ishikawa Prefektur",
      "tlName": "Ishikawa Prefecture",
      "moName": "Ишикава аймаг",
      "buName": "အီရှီခါးဝ ပြည်နယ်",
      "khName": "ខេត្ត អ៊ីស៊ីកាវ៉ា",
      "neName": "इसिखावा जिल्ला"
    },
    "class10": {
      "code": "170020",
      "name": "能登",
      "enName": "Noto",
      "chName": "石川县能登地方",
      "zhName": "石川縣能登地方",
      "koName": "이시카와 현 노토 지방",
      "esName": "Región Noto, Prefectura de Ishikawa",
      "ptName": "Região de Noto da Província de Ishikawa",
      "thName": "ท้องถิ่นโนะโตะ จังหวัดอิชิกาวะ",
      "viName": "Vùng Noto tỉnh Ishikawa",
      "inName": "Daerah Noto di Prefektur Ishikawa",
      "tlName": "Rehiyon ng Noto sa Ishikawa Prefecture",
      "moName": "Ишикава аймаг, Ното",
      "buName": "နိုတို၊ အိရှိကဝစီရင်စု",
      "khName": "តំបន់ណូតូនៃខេត្តអ៊ិស៊ីខាវ៉ា",
      "neName": "इसिखावा जिल्ला, नोतो क्षेत्र"
    },
    "class15": {
      "code": "170022",
      "name": "能登南部",
      "enName": "Southern Noto"
    },
    "class20": {
      "code": "1720700",
      "name": "羽咋市",
      "enName": "Hakui City",
      "kana": "はくいし",
      "chName": "羽咋市",
      "zhName": "羽咋市",
      "koName": "하쿠이 시",
      "esName": "Ciudad de Hakui",
      "ptName": "cidade de Hakui",
      "thName": "เมืองฮาคุอิ",
      "viName": "thành phố Hakui",
      "inName": "kota Hakui",
      "tlName": "siyudad ng Hakui",
      "moName": "Хaкүй хот",
      "buName": "ဟာကုယိ မြို့",
      "khName": "ទីក្រុង ហាក់ហ្គុយអ៊ី",
      "neName": "हाकुई सहर"
    }
  },
  "1720900": {
    "office": {
      "code": "170000",
      "name": "石川県",
      "enName": "Ishikawa",
      "officeName": "金沢地方気象台",
      "chName": "石川县",
      "zhName": "石川縣",
      "koName": "이시카와현",
      "esName": "Prefectura de Ishikawa",
      "ptName": "Província de Ishikawa",
      "thName": "จังหวัดอิชิกาวะ",
      "viName": "Tỉnh Ishikawa",
      "inName": "Ishikawa Prefektur",
      "tlName": "Ishikawa Prefecture",
      "moName": "Ишикава аймаг",
      "buName": "အီရှီခါးဝ ပြည်နယ်",
      "khName": "ខេត្ត អ៊ីស៊ីកាវ៉ា",
      "neName": "इसिखावा जिल्ला"
    },
    "class10": {
      "code": "170010",
      "name": "加賀",
      "enName": "Kaga",
      "chName": "石川县加贺地方",
      "zhName": "石川縣加賀地方",
      "koName": "이시카와 현 카가 지방",
      "esName": "Región Kaga, Prefectura de Ishikawa",
      "ptName": "Região de Kaga da Província de Ishikawa",
      "thName": "ท้องถิ่นคางะ จังหวัดอิชิกาวะ",
      "viName": "Vùng Kaga tỉnh Ishikawa",
      "inName": "Daerah Kaga di Prefektur Ishikawa",
      "tlName": "Rehiyon ng Kaga sa Ishikawa Prefecture",
      "moName": "Ишикава аймаг, Кага",
      "buName": "ကဂ၊ အိရှိကဝစီရင်စု",
      "khName": "តំបន់កាហ្គានៃខេត្តអ៊ិស៊ីខាវ៉ា",
      "neName": "इसिखावा जिल्ला, कागा क्षेत्र"
    },
    "class15": {
      "code": "170011",
      "name": "加賀北部",
      "enName": "Northern Kaga"
    },
    "class20": {
      "code": "1720900",
      "name": "かほく市",
      "enName": "Kahoku City",
      "kana": "かほくし",
      "chName": "河北市",
      "zhName": "河北市",
      "koName": "가호쿠 시",
      "esName": "Ciudad de Kahoku",
      "ptName": "cidade de Kahoku",
      "thName": "เมืองคาโฮคุ",
      "viName": "thành phố Kahoku",
      "inName": "kota Kahoku",
      "tlName": "siyudad ng Kahoku",
      "moName": "Кахокү хот",
      "buName": "ခဟို့ကု မြို့",
      "khName": "ទីក្រុង កាហ៊ុគុយ",
      "neName": "काहोकु सहर"
    }
  },
  "1721000": {
    "office": {
      "code": "170000",
      "name": "石川県",
      "enName": "Ishikawa",
      "officeName": "金沢地方気象台",
      "chName": "石川县",
      "zhName": "石川縣",
      "koName": "이시카와현",
      "esName": "Prefectura de Ishikawa",
      "ptName": "Província de Ishikawa",
      "thName": "จังหวัดอิชิกาวะ",
      "viName": "Tỉnh Ishikawa",
      "inName": "Ishikawa Prefektur",
      "tlName": "Ishikawa Prefecture",
      "moName": "Ишикава аймаг",
      "buName": "အီရှီခါးဝ ပြည်နယ်",
      "khName": "ខេត្ត អ៊ីស៊ីកាវ៉ា",
      "neName": "इसिखावा जिल्ला"
    },
    "class10": {
      "code": "170010",
      "name": "加賀",
      "enName": "Kaga",
      "chName": "石川县加贺地方",
      "zhName": "石川縣加賀地方",
      "koName": "이시카와 현 카가 지방",
      "esName": "Región Kaga, Prefectura de Ishikawa",
      "ptName": "Região de Kaga da Província de Ishikawa",
      "thName": "ท้องถิ่นคางะ จังหวัดอิชิกาวะ",
      "viName": "Vùng Kaga tỉnh Ishikawa",
      "inName": "Daerah Kaga di Prefektur Ishikawa",
      "tlName": "Rehiyon ng Kaga sa Ishikawa Prefecture",
      "moName": "Ишикава аймаг, Кага",
      "buName": "ကဂ၊ အိရှိကဝစီရင်စု",
      "khName": "តំបន់កាហ្គានៃខេត្តអ៊ិស៊ីខាវ៉ា",
      "neName": "इसिखावा जिल्ला, कागा क्षेत्र"
    },
    "class15": {
      "code": "170012",
      "name": "加賀南部",
      "enName": "Southern Kaga"
    },
    "class20": {
      "code": "1721000",
      "name": "白山市",
      "enName": "Hakusan City",
      "kana": "はくさんし",
      "chName": "白山市",
      "zhName": "白山市",
      "koName": "하쿠산 시",
      "esName": "Ciudad de Hakusan",
      "ptName": "cidade de Hakusan",
      "thName": "เมืองฮาคุซัง",
      "viName": "thành phố Hakusan",
      "inName": "kota Hakusan",
      "tlName": "siyudad ng Hakusan",
      "moName": "Хaкүсaн хот",
      "buName": "ဟာကုဆန်း မြို့",
      "khName": "ទីក្រុង ហាក់គូសាន",
      "neName": "हाकुसान सहर"
    }
  },
  "1721100": {
    "office": {
      "code": "170000",
      "name": "石川県",
      "enName": "Ishikawa",
      "officeName": "金沢地方気象台",
      "chName": "石川县",
      "zhName": "石川縣",
      "koName": "이시카와현",
      "esName": "Prefectura de Ishikawa",
      "ptName": "Província de Ishikawa",
      "thName": "จังหวัดอิชิกาวะ",
      "viName": "Tỉnh Ishikawa",
      "inName": "Ishikawa Prefektur",
      "tlName": "Ishikawa Prefecture",
      "moName": "Ишикава аймаг",
      "buName": "အီရှီခါးဝ ပြည်နယ်",
      "khName": "ខេត្ត អ៊ីស៊ីកាវ៉ា",
      "neName": "इसिखावा जिल्ला"
    },
    "class10": {
      "code": "170010",
      "name": "加賀",
      "enName": "Kaga",
      "chName": "石川县加贺地方",
      "zhName": "石川縣加賀地方",
      "koName": "이시카와 현 카가 지방",
      "esName": "Región Kaga, Prefectura de Ishikawa",
      "ptName": "Região de Kaga da Província de Ishikawa",
      "thName": "ท้องถิ่นคางะ จังหวัดอิชิกาวะ",
      "viName": "Vùng Kaga tỉnh Ishikawa",
      "inName": "Daerah Kaga di Prefektur Ishikawa",
      "tlName": "Rehiyon ng Kaga sa Ishikawa Prefecture",
      "moName": "Ишикава аймаг, Кага",
      "buName": "ကဂ၊ အိရှိကဝစီရင်စု",
      "khName": "តំបន់កាហ្គានៃខេត្តអ៊ិស៊ីខាវ៉ា",
      "neName": "इसिखावा जिल्ला, कागा क्षेत्र"
    },
    "class15": {
      "code": "170012",
      "name": "加賀南部",
      "enName": "Southern Kaga"
    },
    "class20": {
      "code": "1721100",
      "name": "能美市",
      "enName": "Nomi City",
      "kana": "のみし",
      "chName": "能美市",
      "zhName": "能美市",
      "koName": "노미 시",
      "esName": "Ciudad de Nomi",
      "ptName": "cidade de Nomi",
      "thName": "เมืองโนมิ",
      "viName": "thành phố Nomi",
      "inName": "kota Nomi",
      "tlName": "siyudad ng Nomi",
      "moName": "Номи хот",
      "buName": "နိုမိ မြို့",
      "khName": "ទីក្រុង ណូមី",
      "neName": "नोमी सहर"
    }
  },
  "1721200": {
    "office": {
      "code": "170000",
      "name": "石川県",
      "enName": "Ishikawa",
      "officeName": "金沢地方気象台",
      "chName": "石川县",
      "zhName": "石川縣",
      "koName": "이시카와현",
      "esName": "Prefectura de Ishikawa",
      "ptName": "Província de Ishikawa",
      "thName": "จังหวัดอิชิกาวะ",
      "viName": "Tỉnh Ishikawa",
      "inName": "Ishikawa Prefektur",
      "tlName": "Ishikawa Prefecture",
      "moName": "Ишикава аймаг",
      "buName": "အီရှီခါးဝ ပြည်နယ်",
      "khName": "ខេត្ត អ៊ីស៊ីកាវ៉ា",
      "neName": "इसिखावा जिल्ला"
    },
    "class10": {
      "code": "170010",
      "name": "加賀",
      "enName": "Kaga",
      "chName": "石川县加贺地方",
      "zhName": "石川縣加賀地方",
      "koName": "이시카와 현 카가 지방",
      "esName": "Región Kaga, Prefectura de Ishikawa",
      "ptName": "Região de Kaga da Província de Ishikawa",
      "thName": "ท้องถิ่นคางะ จังหวัดอิชิกาวะ",
      "viName": "Vùng Kaga tỉnh Ishikawa",
      "inName": "Daerah Kaga di Prefektur Ishikawa",
      "tlName": "Rehiyon ng Kaga sa Ishikawa Prefecture",
      "moName": "Ишикава аймаг, Кага",
      "buName": "ကဂ၊ အိရှိကဝစီရင်စု",
      "khName": "តំបន់កាហ្គានៃខេត្តអ៊ិស៊ីខាវ៉ា",
      "neName": "इसिखावा जिल्ला, कागा क्षेत्र"
    },
    "class15": {
      "code": "170012",
      "name": "加賀南部",
      "enName": "Southern Kaga"
    },
    "class20": {
      "code": "1721200",
      "name": "野々市市",
      "enName": "Nonoichi City",
      "kana": "ののいちし",
      "chName": "野野市市",
      "zhName": "野野市市",
      "koName": "노노이치 시",
      "esName": "Ciudad de Nonoichi",
      "ptName": "cidade de Nonoichi",
      "thName": "เมืองโนโนะอิจิ",
      "viName": "thành phố Nonoichi",
      "inName": "kota Nonoichi",
      "tlName": "siyudad ng Nonoichi",
      "moName": "Нонойчи хот",
      "buName": "နိုနိုယိကျိ မြို့",
      "khName": "ទីក្រុង ណូណយឈី",
      "neName": "नोनोइची सहर"
    }
  },
  "1732400": {
    "office": {
      "code": "170000",
      "name": "石川県",
      "enName": "Ishikawa",
      "officeName": "金沢地方気象台",
      "chName": "石川县",
      "zhName": "石川縣",
      "koName": "이시카와현",
      "esName": "Prefectura de Ishikawa",
      "ptName": "Província de Ishikawa",
      "thName": "จังหวัดอิชิกาวะ",
      "viName": "Tỉnh Ishikawa",
      "inName": "Ishikawa Prefektur",
      "tlName": "Ishikawa Prefecture",
      "moName": "Ишикава аймаг",
      "buName": "အီရှီခါးဝ ပြည်နယ်",
      "khName": "ខេត្ត អ៊ីស៊ីកាវ៉ា",
      "neName": "इसिखावा जिल्ला"
    },
    "class10": {
      "code": "170010",
      "name": "加賀",
      "enName": "Kaga",
      "chName": "石川县加贺地方",
      "zhName": "石川縣加賀地方",
      "koName": "이시카와 현 카가 지방",
      "esName": "Región Kaga, Prefectura de Ishikawa",
      "ptName": "Região de Kaga da Província de Ishikawa",
      "thName": "ท้องถิ่นคางะ จังหวัดอิชิกาวะ",
      "viName": "Vùng Kaga tỉnh Ishikawa",
      "inName": "Daerah Kaga di Prefektur Ishikawa",
      "tlName": "Rehiyon ng Kaga sa Ishikawa Prefecture",
      "moName": "Ишикава аймаг, Кага",
      "buName": "ကဂ၊ အိရှိကဝစီရင်စု",
      "khName": "តំបន់កាហ្គានៃខេត្តអ៊ិស៊ីខាវ៉ា",
      "neName": "इसिखावा जिल्ला, कागा क्षेत्र"
    },
    "class15": {
      "code": "170012",
      "name": "加賀南部",
      "enName": "Southern Kaga"
    },
    "class20": {
      "code": "1732400",
      "name": "川北町",
      "enName": "Kawakita Town",
      "kana": "かわきたまち",
      "chName": "川北町",
      "zhName": "川北町",
      "koName": "가와키타 정",
      "esName": "Pueblo de Kawakita",
      "ptName": "bairro de Kawakita",
      "thName": "เมืองคาวาคิตะ",
      "viName": "thị trấn Kawakita",
      "inName": "kota Kawakita",
      "tlName": "bayan ng Kawakita",
      "moName": "Кавакита жижиг хот",
      "buName": "ခါဝါကိတ မြို့နယ်",
      "khName": "ទីប្រជុំជន កាវ៉ាគីតា",
      "neName": "कावाकिता नगर"
    }
  },
  "1736100": {
    "office": {
      "code": "170000",
      "name": "石川県",
      "enName": "Ishikawa",
      "officeName": "金沢地方気象台",
      "chName": "石川县",
      "zhName": "石川縣",
      "koName": "이시카와현",
      "esName": "Prefectura de Ishikawa",
      "ptName": "Província de Ishikawa",
      "thName": "จังหวัดอิชิกาวะ",
      "viName": "Tỉnh Ishikawa",
      "inName": "Ishikawa Prefektur",
      "tlName": "Ishikawa Prefecture",
      "moName": "Ишикава аймаг",
      "buName": "အီရှီခါးဝ ပြည်နယ်",
      "khName": "ខេត្ត អ៊ីស៊ីកាវ៉ា",
      "neName": "इसिखावा जिल्ला"
    },
    "class10": {
      "code": "170010",
      "name": "加賀",
      "enName": "Kaga",
      "chName": "石川县加贺地方",
      "zhName": "石川縣加賀地方",
      "koName": "이시카와 현 카가 지방",
      "esName": "Región Kaga, Prefectura de Ishikawa",
      "ptName": "Região de Kaga da Província de Ishikawa",
      "thName": "ท้องถิ่นคางะ จังหวัดอิชิกาวะ",
      "viName": "Vùng Kaga tỉnh Ishikawa",
      "inName": "Daerah Kaga di Prefektur Ishikawa",
      "tlName": "Rehiyon ng Kaga sa Ishikawa Prefecture",
      "moName": "Ишикава аймаг, Кага",
      "buName": "ကဂ၊ အိရှိကဝစီရင်စု",
      "khName": "តំបន់កាហ្គានៃខេត្តអ៊ិស៊ីខាវ៉ា",
      "neName": "इसिखावा जिल्ला, कागा क्षेत्र"
    },
    "class15": {
      "code": "170011",
      "name": "加賀北部",
      "enName": "Northern Kaga"
    },
    "class20": {
      "code": "1736100",
      "name": "津幡町",
      "enName": "Tsubata Town",
      "kana": "つばたまち",
      "chName": "津幡町",
      "zhName": "津幡町",
      "koName": "쓰바타 정",
      "esName": "Pueblo de Tsubata",
      "ptName": "bairro de Tsubata",
      "thName": "เมืองสึบาตะ",
      "viName": "thị trấn Tsubata",
      "inName": "kota Tsubata",
      "tlName": "bayan ng Tsubata",
      "moName": "Цүбата жижиг хот",
      "buName": "ဆုဘာ့တ မြို့နယ်",
      "khName": "ទីប្រជុំជន ស៊ូបាតា",
      "neName": "त्सुबाता नगर"
    }
  },
  "1736500": {
    "office": {
      "code": "170000",
      "name": "石川県",
      "enName": "Ishikawa",
      "officeName": "金沢地方気象台",
      "chName": "石川县",
      "zhName": "石川縣",
      "koName": "이시카와현",
      "esName": "Prefectura de Ishikawa",
      "ptName": "Província de Ishikawa",
      "thName": "จังหวัดอิชิกาวะ",
      "viName": "Tỉnh Ishikawa",
      "inName": "Ishikawa Prefektur",
      "tlName": "Ishikawa Prefecture",
      "moName": "Ишикава аймаг",
      "buName": "အီရှီခါးဝ ပြည်နယ်",
      "khName": "ខេត្ត អ៊ីស៊ីកាវ៉ា",
      "neName": "इसिखावा जिल्ला"
    },
    "class10": {
      "code": "170010",
      "name": "加賀",
      "enName": "Kaga",
      "chName": "石川县加贺地方",
      "zhName": "石川縣加賀地方",
      "koName": "이시카와 현 카가 지방",
      "esName": "Región Kaga, Prefectura de Ishikawa",
      "ptName": "Região de Kaga da Província de Ishikawa",
      "thName": "ท้องถิ่นคางะ จังหวัดอิชิกาวะ",
      "viName": "Vùng Kaga tỉnh Ishikawa",
      "inName": "Daerah Kaga di Prefektur Ishikawa",
      "tlName": "Rehiyon ng Kaga sa Ishikawa Prefecture",
      "moName": "Ишикава аймаг, Кага",
      "buName": "ကဂ၊ အိရှိကဝစီရင်စု",
      "khName": "តំបន់កាហ្គានៃខេត្តអ៊ិស៊ីខាវ៉ា",
      "neName": "इसिखावा जिल्ला, कागा क्षेत्र"
    },
    "class15": {
      "code": "170011",
      "name": "加賀北部",
      "enName": "Northern Kaga"
    },
    "class20": {
      "code": "1736500",
      "name": "内灘町",
      "enName": "Uchinada Town",
      "kana": "うちなだまち",
      "chName": "内滩町",
      "zhName": "內灘町",
      "koName": "우치나다 정",
      "esName": "Pueblo de Uchinada",
      "ptName": "bairro de Uchinada",
      "thName": "เมืองอุจินาดะ",
      "viName": "thị trấn Uchinada",
      "inName": "kota Uchinada",
      "tlName": "bayan ng Uchinada",
      "moName": "Үчинaда жижиг хот",
      "buName": "ဥကျိနာ့ဒ မြို့နယ်",
      "khName": "ទីប្រជុំជន អ៊ូជីណាដា",
      "neName": "उचिनादा नगर"
    }
  },
  "1738400": {
    "office": {
      "code": "170000",
      "name": "石川県",
      "enName": "Ishikawa",
      "officeName": "金沢地方気象台",
      "chName": "石川县",
      "zhName": "石川縣",
      "koName": "이시카와현",
      "esName": "Prefectura de Ishikawa",
      "ptName": "Província de Ishikawa",
      "thName": "จังหวัดอิชิกาวะ",
      "viName": "Tỉnh Ishikawa",
      "inName": "Ishikawa Prefektur",
      "tlName": "Ishikawa Prefecture",
      "moName": "Ишикава аймаг",
      "buName": "အီရှီခါးဝ ပြည်နယ်",
      "khName": "ខេត្ត អ៊ីស៊ីកាវ៉ា",
      "neName": "इसिखावा जिल्ला"
    },
    "class10": {
      "code": "170020",
      "name": "能登",
      "enName": "Noto",
      "chName": "石川县能登地方",
      "zhName": "石川縣能登地方",
      "koName": "이시카와 현 노토 지방",
      "esName": "Región Noto, Prefectura de Ishikawa",
      "ptName": "Região de Noto da Província de Ishikawa",
      "thName": "ท้องถิ่นโนะโตะ จังหวัดอิชิกาวะ",
      "viName": "Vùng Noto tỉnh Ishikawa",
      "inName": "Daerah Noto di Prefektur Ishikawa",
      "tlName": "Rehiyon ng Noto sa Ishikawa Prefecture",
      "moName": "Ишикава аймаг, Ното",
      "buName": "နိုတို၊ အိရှိကဝစီရင်စု",
      "khName": "តំបន់ណូតូនៃខេត្តអ៊ិស៊ីខាវ៉ា",
      "neName": "इसिखावा जिल्ला, नोतो क्षेत्र"
    },
    "class15": {
      "code": "170022",
      "name": "能登南部",
      "enName": "Southern Noto"
    },
    "class20": {
      "code": "1738400",
      "name": "志賀町",
      "enName": "Shika Town",
      "kana": "しかまち",
      "chName": "志贺町",
      "zhName": "志賀町",
      "koName": "시카 정",
      "esName": "Pueblo de Shika",
      "ptName": "bairro de Shika",
      "thName": "เมืองชิกะ",
      "viName": "thị trấn Shika",
      "inName": "kota Shika",
      "tlName": "bayan ng Shika",
      "moName": "Шика жижиг хот",
      "buName": "ရှီးက မြို့နယ်",
      "khName": "ទីប្រជុំជន ស៊ីកា",
      "neName": "शिका नगर"
    }
  },
  "1738600": {
    "office": {
      "code": "170000",
      "name": "石川県",
      "enName": "Ishikawa",
      "officeName": "金沢地方気象台",
      "chName": "石川县",
      "zhName": "石川縣",
      "koName": "이시카와현",
      "esName": "Prefectura de Ishikawa",
      "ptName": "Província de Ishikawa",
      "thName": "จังหวัดอิชิกาวะ",
      "viName": "Tỉnh Ishikawa",
      "inName": "Ishikawa Prefektur",
      "tlName": "Ishikawa Prefecture",
      "moName": "Ишикава аймаг",
      "buName": "အီရှီခါးဝ ပြည်နယ်",
      "khName": "ខេត្ត អ៊ីស៊ីកាវ៉ា",
      "neName": "इसिखावा जिल्ला"
    },
    "class10": {
      "code": "170020",
      "name": "能登",
      "enName": "Noto",
      "chName": "石川县能登地方",
      "zhName": "石川縣能登地方",
      "koName": "이시카와 현 노토 지방",
      "esName": "Región Noto, Prefectura de Ishikawa",
      "ptName": "Região de Noto da Província de Ishikawa",
      "thName": "ท้องถิ่นโนะโตะ จังหวัดอิชิกาวะ",
      "viName": "Vùng Noto tỉnh Ishikawa",
      "inName": "Daerah Noto di Prefektur Ishikawa",
      "tlName": "Rehiyon ng Noto sa Ishikawa Prefecture",
      "moName": "Ишикава аймаг, Ното",
      "buName": "နိုတို၊ အိရှိကဝစီရင်စု",
      "khName": "តំបន់ណូតូនៃខេត្តអ៊ិស៊ីខាវ៉ា",
      "neName": "इसिखावा जिल्ला, नोतो क्षेत्र"
    },
    "class15": {
      "code": "170022",
      "name": "能登南部",
      "enName": "Southern Noto"
    },
    "class20": {
      "code": "1738600",
      "name": "宝達志水町",
      "enName": "Hodatsushimizu Town",
      "kana": "ほうだつしみずちょう",
      "chName": "宝达志水町",
      "zhName": "寶達志水町",
      "koName": "호다쓰시미즈 정",
      "esName": "Pueblo de Hodatsu-shimizu",
      "ptName": "bairro de Hodatsushimizu",
      "thName": "เมืองโฮดัตสึชิมิสึ",
      "viName": "thị trấn Hodatsushimizu",
      "inName": "kota Hodatsushimizu",
      "tlName": "bayan ng Hodatsushimizu",
      "moName": "Ходацүшимизү жижиг хот",
      "buName": "ဟိုဒါဆုရှိမိဇု မြို့နယ်",
      "khName": "ទីប្រជុំជន ហូដាតស៊ូស៊ីមីហ្សូ",
      "neName": "होदात्सुशिमिजु नगर"
    }
  },
  "1740700": {
    "office": {
      "code": "170000",
      "name": "石川県",
      "enName": "Ishikawa",
      "officeName": "金沢地方気象台",
      "chName": "石川县",
      "zhName": "石川縣",
      "koName": "이시카와현",
      "esName": "Prefectura de Ishikawa",
      "ptName": "Província de Ishikawa",
      "thName": "จังหวัดอิชิกาวะ",
      "viName": "Tỉnh Ishikawa",
      "inName": "Ishikawa Prefektur",
      "tlName": "Ishikawa Prefecture",
      "moName": "Ишикава аймаг",
      "buName": "အီရှီခါးဝ ပြည်နယ်",
      "khName": "ខេត្ត អ៊ីស៊ីកាវ៉ា",
      "neName": "इसिखावा जिल्ला"
    },
    "class10": {
      "code": "170020",
      "name": "能登",
      "enName": "Noto",
      "chName": "石川县能登地方",
      "zhName": "石川縣能登地方",
      "koName": "이시카와 현 노토 지방",
      "esName": "Región Noto, Prefectura de Ishikawa",
      "ptName": "Região de Noto da Província de Ishikawa",
      "thName": "ท้องถิ่นโนะโตะ จังหวัดอิชิกาวะ",
      "viName": "Vùng Noto tỉnh Ishikawa",
      "inName": "Daerah Noto di Prefektur Ishikawa",
      "tlName": "Rehiyon ng Noto sa Ishikawa Prefecture",
      "moName": "Ишикава аймаг, Ното",
      "buName": "နိုတို၊ အိရှိကဝစီရင်စု",
      "khName": "តំបន់ណូតូនៃខេត្តអ៊ិស៊ីខាវ៉ា",
      "neName": "इसिखावा जिल्ला, नोतो क्षेत्र"
    },
    "class15": {
      "code": "170022",
      "name": "能登南部",
      "enName": "Southern Noto"
    },
    "class20": {
      "code": "1740700",
      "name": "中能登町",
      "enName": "Nakanoto Town",
      "kana": "なかのとまち",
      "chName": "中能登町",
      "zhName": "中能登町",
      "koName": "나카노토 정",
      "esName": "Pueblo de Nakanoto",
      "ptName": "bairro de Nakanoto",
      "thName": "เมืองนาคาโนโตะ",
      "viName": "thị trấn Nakanoto",
      "inName": "kota Nakanoto",
      "tlName": "bayan ng Nakanoto",
      "moName": "Нaканото жижиг хот",
      "buName": "နာကာနိုတို မြို့နယ်",
      "khName": "ទីប្រជុំជន ណាកាណូតូ",
      "neName": "नाकानोतो नगर"
    }
  },
  "1746100": {
    "office": {
      "code": "170000",
      "name": "石川県",
      "enName": "Ishikawa",
      "officeName": "金沢地方気象台",
      "chName": "石川县",
      "zhName": "石川縣",
      "koName": "이시카와현",
      "esName": "Prefectura de Ishikawa",
      "ptName": "Província de Ishikawa",
      "thName": "จังหวัดอิชิกาวะ",
      "viName": "Tỉnh Ishikawa",
      "inName": "Ishikawa Prefektur",
      "tlName": "Ishikawa Prefecture",
      "moName": "Ишикава аймаг",
      "buName": "အီရှီခါးဝ ပြည်နယ်",
      "khName": "ខេត្ត អ៊ីស៊ីកាវ៉ា",
      "neName": "इसिखावा जिल्ला"
    },
    "class10": {
      "code": "170020",
      "name": "能登",
      "enName": "Noto",
      "chName": "石川县能登地方",
      "zhName": "石川縣能登地方",
      "koName": "이시카와 현 노토 지방",
      "esName": "Región Noto, Prefectura de Ishikawa",
      "ptName": "Região de Noto da Província de Ishikawa",
      "thName": "ท้องถิ่นโนะโตะ จังหวัดอิชิกาวะ",
      "viName": "Vùng Noto tỉnh Ishikawa",
      "inName": "Daerah Noto di Prefektur Ishikawa",
      "tlName": "Rehiyon ng Noto sa Ishikawa Prefecture",
      "moName": "Ишикава аймаг, Ното",
      "buName": "နိုတို၊ အိရှိကဝစီရင်စု",
      "khName": "តំបន់ណូតូនៃខេត្តអ៊ិស៊ីខាវ៉ា",
      "neName": "इसिखावा जिल्ला, नोतो क्षेत्र"
    },
    "class15": {
      "code": "170021",
      "name": "能登北部",
      "enName": "Northern Noto"
    },
    "class20": {
      "code": "1746100",
      "name": "穴水町",
      "enName": "Anamizu Town",
      "kana": "あなみずまち",
      "chName": "穴水町",
      "zhName": "穴水町",
      "koName": "아나미즈 정",
      "esName": "Pueblo de Anamizu",
      "ptName": "bairro de Anamizu",
      "thName": "เมืองอานามิสึ",
      "viName": "thị trấn Anamizu",
      "inName": "kota Anamizu",
      "tlName": "bayan ng Anamizu",
      "moName": "Aнaмизү жижиг хот",
      "buName": "အာနမိဇု မြို့နယ်",
      "khName": "ទីប្រជុំជន អាណាមីស៊ូ",
      "neName": "आनामिजु नगर"
    }
  },
  "1746300": {
    "office": {
      "code": "170000",
      "name": "石川県",
      "enName": "Ishikawa",
      "officeName": "金沢地方気象台",
      "chName": "石川县",
      "zhName": "石川縣",
      "koName": "이시카와현",
      "esName": "Prefectura de Ishikawa",
      "ptName": "Província de Ishikawa",
      "thName": "จังหวัดอิชิกาวะ",
      "viName": "Tỉnh Ishikawa",
      "inName": "Ishikawa Prefektur",
      "tlName": "Ishikawa Prefecture",
      "moName": "Ишикава аймаг",
      "buName": "အီရှီခါးဝ ပြည်နယ်",
      "khName": "ខេត្ត អ៊ីស៊ីកាវ៉ា",
      "neName": "इसिखावा जिल्ला"
    },
    "class10": {
      "code": "170020",
      "name": "能登",
      "enName": "Noto",
      "chName": "石川县能登地方",
      "zhName": "石川縣能登地方",
      "koName": "이시카와 현 노토 지방",
      "esName": "Región Noto, Prefectura de Ishikawa",
      "ptName": "Região de Noto da Província de Ishikawa",
      "thName": "ท้องถิ่นโนะโตะ จังหวัดอิชิกาวะ",
      "viName": "Vùng Noto tỉnh Ishikawa",
      "inName": "Daerah Noto di Prefektur Ishikawa",
      "tlName": "Rehiyon ng Noto sa Ishikawa Prefecture",
      "moName": "Ишикава аймаг, Ното",
      "buName": "နိုတို၊ အိရှိကဝစီရင်စု",
      "khName": "តំបន់ណូតូនៃខេត្តអ៊ិស៊ីខាវ៉ា",
      "neName": "इसिखावा जिल्ला, नोतो क्षेत्र"
    },
    "class15": {
      "code": "170021",
      "name": "能登北部",
      "enName": "Northern Noto"
    },
    "class20": {
      "code": "1746300",
      "name": "能登町",
      "enName": "Noto Town",
      "kana": "のとちょう",
      "chName": "能登町",
      "zhName": "能登町",
      "koName": "노토 정",
      "esName": "Pueblo de Noto",
      "ptName": "bairro de Noto",
      "thName": "เมืองโนโตะ",
      "viName": "thị trấn Noto",
      "inName": "kota Noto",
      "tlName": "bayan ng Noto",
      "moName": "Ното жижиг хот",
      "buName": "နိုတို မြို့နယ်",
      "khName": "ទីប្រជុំជន ណូតូ",
      "neName": "नोतो नगर"
    }
  },
  "1820100": {
    "office": {
      "code": "180000",
      "name": "福井県",
      "enName": "Fukui",
      "officeName": "福井地方気象台",
      "chName": "福井县",
      "zhName": "福井縣",
      "koName": "후쿠이현",
      "esName": "Prefectura de Fukui",
      "ptName": "Província de Fukui",
      "thName": "จังหวัดฟุกุอิ",
      "viName": "Tỉnh Fukui",
      "inName": "Prefectur Fukui",
      "tlName": "Fukui Prefecture",
      "moName": "Фүкүй аймаг",
      "buName": "ဖူကူးရိ ပြည်နယ်",
      "khName": "ខេត្ត ហ្វូគូអ៊ី",
      "neName": "फुकुइ जिल्ला"
    },
    "class10": {
      "code": "180010",
      "name": "嶺北",
      "enName": "Reihoku",
      "chName": "福井県嶺北",
      "zhName": "福井县嶺北",
      "koName": "후쿠이현 령북",
      "esName": "Reihoku, Prefectura de Fukui",
      "ptName": "Região Reihoku da Província de Fukui",
      "thName": "เรโฮกุ จังหวัดฟุกุอิ",
      "viName": "Reihoku, tỉnh Fukui",
      "inName": "Reihoku, Prefektur Fukui",
      "tlName": "Reihoku, Fukui Prefecture",
      "moName": "Фүкүи аймаг, Рэйхокү",
      "buName": "ယဲအိဟိုခု၊ ဟုခုအိစီရင်စု",
      "khName": "តំបន់រ៉េហូគឹនៃខេត្តហ្វឹគឹយ",
      "neName": "फुकुइ जिल्ला, रेइहोकु"
    },
    "class15": {
      "code": "180011",
      "name": "嶺北北部",
      "enName": "Northern Reihoku"
    },
    "class20": {
      "code": "1820100",
      "name": "福井市",
      "enName": "Fukui City",
      "kana": "ふくいし",
      "chName": "福井市",
      "zhName": "福井市",
      "koName": "후쿠이 시",
      "esName": "Ciudad de Fukui",
      "ptName": "cidade de Fukui",
      "thName": "เมืองฟุคุอิ",
      "viName": "thành phố Fukui",
      "inName": "kota Fukui",
      "tlName": "siyudad ng Fukui",
      "moName": "Фүкүи хот",
      "buName": "ဖူကုယိ မြို့",
      "khName": "ទីក្រុង ហ្វូឃុយ",
      "neName": "फुकुई सहर"
    }
  },
  "1820200": {
    "office": {
      "code": "180000",
      "name": "福井県",
      "enName": "Fukui",
      "officeName": "福井地方気象台",
      "chName": "福井县",
      "zhName": "福井縣",
      "koName": "후쿠이현",
      "esName": "Prefectura de Fukui",
      "ptName": "Província de Fukui",
      "thName": "จังหวัดฟุกุอิ",
      "viName": "Tỉnh Fukui",
      "inName": "Prefectur Fukui",
      "tlName": "Fukui Prefecture",
      "moName": "Фүкүй аймаг",
      "buName": "ဖူကူးရိ ပြည်နယ်",
      "khName": "ខេត្ត ហ្វូគូអ៊ី",
      "neName": "फुकुइ जिल्ला"
    },
    "class10": {
      "code": "180020",
      "name": "嶺南",
      "enName": "Reinan",
      "chName": "福井県嶺南",
      "zhName": "福井縣嶺南",
      "koName": "후쿠이현 영남",
      "esName": "Reinan, Prefectura de Fukui",
      "ptName": "Região Reinan da Província de Fukui",
      "thName": "เรนัน จังหวัดฟุกุอิ",
      "viName": "Reinan, tỉnh Fukui",
      "inName": "Reinan, Prefektur Fukui",
      "tlName": "Reinan, Fukui Prefecture",
      "moName": "Фүкүи аймаг, Рэйнан",
      "buName": "ယဲအိနန်း၊ ဟုခုအိစီရင်စု",
      "khName": "តំបន់រ៉េណាន់នៃខេត្តហ្វឹគឹយ",
      "neName": "फुकुइ जिल्ला, रेइनान्"
    },
    "class15": {
      "code": "180021",
      "name": "嶺南東部",
      "enName": "Eastern Reinan"
    },
    "class20": {
      "code": "1820200",
      "name": "敦賀市",
      "enName": "Tsuruga City",
      "kana": "つるがし",
      "chName": "敦贺市",
      "zhName": "敦賀市",
      "koName": "쓰루가 시",
      "esName": "Ciudad de Tsuruga",
      "ptName": "cidade de Tsuruga",
      "thName": "เมืองสึรุงะ",
      "viName": "thành phố Tsuruga",
      "inName": "kota Tsuruga",
      "tlName": "siyudad ng Tsuruga",
      "moName": "Цүрүгa хот",
      "buName": "ဆုရုဂ မြို့",
      "khName": "ទីក្រុង សូរូហ្កា",
      "neName": "त्सुरुगा सहर"
    }
  },
  "1820400": {
    "office": {
      "code": "180000",
      "name": "福井県",
      "enName": "Fukui",
      "officeName": "福井地方気象台",
      "chName": "福井县",
      "zhName": "福井縣",
      "koName": "후쿠이현",
      "esName": "Prefectura de Fukui",
      "ptName": "Província de Fukui",
      "thName": "จังหวัดฟุกุอิ",
      "viName": "Tỉnh Fukui",
      "inName": "Prefectur Fukui",
      "tlName": "Fukui Prefecture",
      "moName": "Фүкүй аймаг",
      "buName": "ဖူကူးရိ ပြည်နယ်",
      "khName": "ខេត្ត ហ្វូគូអ៊ី",
      "neName": "फुकुइ जिल्ला"
    },
    "class10": {
      "code": "180020",
      "name": "嶺南",
      "enName": "Reinan",
      "chName": "福井県嶺南",
      "zhName": "福井縣嶺南",
      "koName": "후쿠이현 영남",
      "esName": "Reinan, Prefectura de Fukui",
      "ptName": "Região Reinan da Província de Fukui",
      "thName": "เรนัน จังหวัดฟุกุอิ",
      "viName": "Reinan, tỉnh Fukui",
      "inName": "Reinan, Prefektur Fukui",
      "tlName": "Reinan, Fukui Prefecture",
      "moName": "Фүкүи аймаг, Рэйнан",
      "buName": "ယဲအိနန်း၊ ဟုခုအိစီရင်စု",
      "khName": "តំបន់រ៉េណាន់នៃខេត្តហ្វឹគឹយ",
      "neName": "फुकुइ जिल्ला, रेइनान्"
    },
    "class15": {
      "code": "180022",
      "name": "嶺南西部",
      "enName": "Western Reinan"
    },
    "class20": {
      "code": "1820400",
      "name": "小浜市",
      "enName": "Obama City",
      "kana": "おばまし",
      "chName": "小滨市",
      "zhName": "小濱市",
      "koName": "오바마 시",
      "esName": "Ciudad de Obama",
      "ptName": "cidade de Obama",
      "thName": "เมืองโอบามะ",
      "viName": "thành phố Obama",
      "inName": "kota Obama",
      "tlName": "siyudad ng Obama",
      "moName": "Обамa хот",
      "buName": "အိုဘာ့မ မြို့",
      "khName": "ទីក្រុង អូបាម៉ា",
      "neName": "ओबामा सहर"
    }
  },
  "1820500": {
    "office": {
      "code": "180000",
      "name": "福井県",
      "enName": "Fukui",
      "officeName": "福井地方気象台",
      "chName": "福井县",
      "zhName": "福井縣",
      "koName": "후쿠이현",
      "esName": "Prefectura de Fukui",
      "ptName": "Província de Fukui",
      "thName": "จังหวัดฟุกุอิ",
      "viName": "Tỉnh Fukui",
      "inName": "Prefectur Fukui",
      "tlName": "Fukui Prefecture",
      "moName": "Фүкүй аймаг",
      "buName": "ဖူကူးရိ ပြည်နယ်",
      "khName": "ខេត្ត ហ្វូគូអ៊ី",
      "neName": "फुकुइ जिल्ला"
    },
    "class10": {
      "code": "180010",
      "name": "嶺北",
      "enName": "Reihoku",
      "chName": "福井県嶺北",
      "zhName": "福井县嶺北",
      "koName": "후쿠이현 령북",
      "esName": "Reihoku, Prefectura de Fukui",
      "ptName": "Região Reihoku da Província de Fukui",
      "thName": "เรโฮกุ จังหวัดฟุกุอิ",
      "viName": "Reihoku, tỉnh Fukui",
      "inName": "Reihoku, Prefektur Fukui",
      "tlName": "Reihoku, Fukui Prefecture",
      "moName": "Фүкүи аймаг, Рэйхокү",
      "buName": "ယဲအိဟိုခု၊ ဟုခုအိစီရင်စု",
      "khName": "តំបន់រ៉េហូគឹនៃខេត្តហ្វឹគឹយ",
      "neName": "फुकुइ जिल्ला, रेइहोकु"
    },
    "class15": {
      "code": "180013",
      "name": "奥越",
      "enName": "Okuetsu"
    },
    "class20": {
      "code": "1820500",
      "name": "大野市",
      "enName": "Ono City",
      "kana": "おおのし",
      "chName": "大野市",
      "zhName": "大野市",
      "koName": "오노 시",
      "esName": "Ciudad de Ono",
      "ptName": "cidade de Ono",
      "thName": "เมืองโอโนะ",
      "viName": "thành phố Ono",
      "inName": "kota Ono",
      "tlName": "siyudad ng Ono",
      "moName": "Оно хот",
      "buName": "အိုနို မြို့",
      "khName": "ទីក្រុង អូណូ",
      "neName": "ओनो सहर"
    }
  },
  "1820600": {
    "office": {
      "code": "180000",
      "name": "福井県",
      "enName": "Fukui",
      "officeName": "福井地方気象台",
      "chName": "福井县",
      "zhName": "福井縣",
      "koName": "후쿠이현",
      "esName": "Prefectura de Fukui",
      "ptName": "Província de Fukui",
      "thName": "จังหวัดฟุกุอิ",
      "viName": "Tỉnh Fukui",
      "inName": "Prefectur Fukui",
      "tlName": "Fukui Prefecture",
      "moName": "Фүкүй аймаг",
      "buName": "ဖူကူးရိ ပြည်နယ်",
      "khName": "ខេត្ត ហ្វូគូអ៊ី",
      "neName": "फुकुइ जिल्ला"
    },
    "class10": {
      "code": "180010",
      "name": "嶺北",
      "enName": "Reihoku",
      "chName": "福井県嶺北",
      "zhName": "福井县嶺北",
      "koName": "후쿠이현 령북",
      "esName": "Reihoku, Prefectura de Fukui",
      "ptName": "Região Reihoku da Província de Fukui",
      "thName": "เรโฮกุ จังหวัดฟุกุอิ",
      "viName": "Reihoku, tỉnh Fukui",
      "inName": "Reihoku, Prefektur Fukui",
      "tlName": "Reihoku, Fukui Prefecture",
      "moName": "Фүкүи аймаг, Рэйхокү",
      "buName": "ယဲအိဟိုခု၊ ဟုခုအိစီရင်စု",
      "khName": "តំបន់រ៉េហូគឹនៃខេត្តហ្វឹគឹយ",
      "neName": "फुकुइ जिल्ला, रेइहोकु"
    },
    "class15": {
      "code": "180013",
      "name": "奥越",
      "enName": "Okuetsu"
    },
    "class20": {
      "code": "1820600",
      "name": "勝山市",
      "enName": "Katsuyama City",
      "kana": "かつやまし",
      "chName": "胜山市",
      "zhName": "勝山市",
      "koName": "가쓰야마 시",
      "esName": "Ciudad de Katsuyama",
      "ptName": "cidade de Katsuyama",
      "thName": "เมืองคัทสึยามะ",
      "viName": "thành phố Katsuyama",
      "inName": "kota Katsuyama",
      "tlName": "siyudad ng Katsuyama",
      "moName": "Кацүямa хот",
      "buName": "ခါဆုယာ့မ မြို့",
      "khName": "ទីក្រុង ខេតស៊ូយ៉ាម៉ា",
      "neName": "कात्सुयामा सहर"
    }
  },
  "1820700": {
    "office": {
      "code": "180000",
      "name": "福井県",
      "enName": "Fukui",
      "officeName": "福井地方気象台",
      "chName": "福井县",
      "zhName": "福井縣",
      "koName": "후쿠이현",
      "esName": "Prefectura de Fukui",
      "ptName": "Província de Fukui",
      "thName": "จังหวัดฟุกุอิ",
      "viName": "Tỉnh Fukui",
      "inName": "Prefectur Fukui",
      "tlName": "Fukui Prefecture",
      "moName": "Фүкүй аймаг",
      "buName": "ဖူကူးရိ ပြည်နယ်",
      "khName": "ខេត្ត ហ្វូគូអ៊ី",
      "neName": "फुकुइ जिल्ला"
    },
    "class10": {
      "code": "180010",
      "name": "嶺北",
      "enName": "Reihoku",
      "chName": "福井県嶺北",
      "zhName": "福井县嶺北",
      "koName": "후쿠이현 령북",
      "esName": "Reihoku, Prefectura de Fukui",
      "ptName": "Região Reihoku da Província de Fukui",
      "thName": "เรโฮกุ จังหวัดฟุกุอิ",
      "viName": "Reihoku, tỉnh Fukui",
      "inName": "Reihoku, Prefektur Fukui",
      "tlName": "Reihoku, Fukui Prefecture",
      "moName": "Фүкүи аймаг, Рэйхокү",
      "buName": "ယဲအိဟိုခု၊ ဟုခုအိစီရင်စု",
      "khName": "តំបន់រ៉េហូគឹនៃខេត្តហ្វឹគឹយ",
      "neName": "फुकुइ जिल्ला, रेइहोकु"
    },
    "class15": {
      "code": "180012",
      "name": "嶺北南部",
      "enName": "Southern Reihoku"
    },
    "class20": {
      "code": "1820700",
      "name": "鯖江市",
      "enName": "Sabae City",
      "kana": "さばえし",
      "chName": "鲭江市",
      "zhName": "鯖江市",
      "koName": "사바에 시",
      "esName": "Ciudad de Sabae",
      "ptName": "cidade de Sabae",
      "thName": "เมืองซาบาเอะ",
      "viName": "thành phố Sabae",
      "inName": "kota Sabae",
      "tlName": "siyudad ng Sabae",
      "moName": "Сaбаэ хот",
      "buName": "ဆာဘာယဲ့ မြို့",
      "khName": "ទីក្រុង សាបេ",
      "neName": "साबाए सहर"
    }
  },
  "1820800": {
    "office": {
      "code": "180000",
      "name": "福井県",
      "enName": "Fukui",
      "officeName": "福井地方気象台",
      "chName": "福井县",
      "zhName": "福井縣",
      "koName": "후쿠이현",
      "esName": "Prefectura de Fukui",
      "ptName": "Província de Fukui",
      "thName": "จังหวัดฟุกุอิ",
      "viName": "Tỉnh Fukui",
      "inName": "Prefectur Fukui",
      "tlName": "Fukui Prefecture",
      "moName": "Фүкүй аймаг",
      "buName": "ဖူကူးရိ ပြည်နယ်",
      "khName": "ខេត្ត ហ្វូគូអ៊ី",
      "neName": "फुकुइ जिल्ला"
    },
    "class10": {
      "code": "180010",
      "name": "嶺北",
      "enName": "Reihoku",
      "chName": "福井県嶺北",
      "zhName": "福井县嶺北",
      "koName": "후쿠이현 령북",
      "esName": "Reihoku, Prefectura de Fukui",
      "ptName": "Região Reihoku da Província de Fukui",
      "thName": "เรโฮกุ จังหวัดฟุกุอิ",
      "viName": "Reihoku, tỉnh Fukui",
      "inName": "Reihoku, Prefektur Fukui",
      "tlName": "Reihoku, Fukui Prefecture",
      "moName": "Фүкүи аймаг, Рэйхокү",
      "buName": "ယဲအိဟိုခု၊ ဟုခုအိစီရင်စု",
      "khName": "តំបន់រ៉េហូគឹនៃខេត្តហ្វឹគឹយ",
      "neName": "फुकुइ जिल्ला, रेइहोकु"
    },
    "class15": {
      "code": "180011",
      "name": "嶺北北部",
      "enName": "Northern Reihoku"
    },
    "class20": {
      "code": "1820800",
      "name": "あわら市",
      "enName": "Awara City",
      "kana": "あわらし",
      "chName": "芦原市",
      "zhName": "蘆原市",
      "koName": "아와라 시",
      "esName": "Ciudad de Awara",
      "ptName": "cidade de Awara",
      "thName": "เมืองอาวาระ",
      "viName": "thành phố Awara",
      "inName": "kota Awara",
      "tlName": "siyudad ng Awara",
      "moName": "Авара хот",
      "buName": "အာဝါးရ မြို့",
      "khName": "ទីក្រុង អាវ៉ារ៉ា",
      "neName": "आवारा सहर"
    }
  },
  "1820900": {
    "office": {
      "code": "180000",
      "name": "福井県",
      "enName": "Fukui",
      "officeName": "福井地方気象台",
      "chName": "福井县",
      "zhName": "福井縣",
      "koName": "후쿠이현",
      "esName": "Prefectura de Fukui",
      "ptName": "Província de Fukui",
      "thName": "จังหวัดฟุกุอิ",
      "viName": "Tỉnh Fukui",
      "inName": "Prefectur Fukui",
      "tlName": "Fukui Prefecture",
      "moName": "Фүкүй аймаг",
      "buName": "ဖူကူးရိ ပြည်နယ်",
      "khName": "ខេត្ត ហ្វូគូអ៊ី",
      "neName": "फुकुइ जिल्ला"
    },
    "class10": {
      "code": "180010",
      "name": "嶺北",
      "enName": "Reihoku",
      "chName": "福井県嶺北",
      "zhName": "福井县嶺北",
      "koName": "후쿠이현 령북",
      "esName": "Reihoku, Prefectura de Fukui",
      "ptName": "Região Reihoku da Província de Fukui",
      "thName": "เรโฮกุ จังหวัดฟุกุอิ",
      "viName": "Reihoku, tỉnh Fukui",
      "inName": "Reihoku, Prefektur Fukui",
      "tlName": "Reihoku, Fukui Prefecture",
      "moName": "Фүкүи аймаг, Рэйхокү",
      "buName": "ယဲအိဟိုခု၊ ဟုခုအိစီရင်စု",
      "khName": "តំបន់រ៉េហូគឹនៃខេត្តហ្វឹគឹយ",
      "neName": "फुकुइ जिल्ला, रेइहोकु"
    },
    "class15": {
      "code": "180012",
      "name": "嶺北南部",
      "enName": "Southern Reihoku"
    },
    "class20": {
      "code": "1820900",
      "name": "越前市",
      "enName": "Echizen City",
      "kana": "えちぜんし",
      "chName": "越前市",
      "zhName": "越前市",
      "koName": "에치젠 시",
      "esName": "Ciudad de Echizen",
      "ptName": "cidade de Echizen",
      "thName": "เมืองเอจิเซน (เอจิเซนชิ)",
      "viName": "thành phố Echizen",
      "inName": "kota Echizen (Echizen-shi)",
      "tlName": "siyudad ng Echizen",
      "moName": "Эчизэн хот",
      "buName": "အိတ်ကျိဇန် မြို့",
      "khName": "ទីក្រុង អ៊ីឈីហ្សិន",
      "neName": "एचिजेन सहर"
    }
  },
  "1821000": {
    "office": {
      "code": "180000",
      "name": "福井県",
      "enName": "Fukui",
      "officeName": "福井地方気象台",
      "chName": "福井县",
      "zhName": "福井縣",
      "koName": "후쿠이현",
      "esName": "Prefectura de Fukui",
      "ptName": "Província de Fukui",
      "thName": "จังหวัดฟุกุอิ",
      "viName": "Tỉnh Fukui",
      "inName": "Prefectur Fukui",
      "tlName": "Fukui Prefecture",
      "moName": "Фүкүй аймаг",
      "buName": "ဖူကူးရိ ပြည်နယ်",
      "khName": "ខេត្ត ហ្វូគូអ៊ី",
      "neName": "फुकुइ जिल्ला"
    },
    "class10": {
      "code": "180010",
      "name": "嶺北",
      "enName": "Reihoku",
      "chName": "福井県嶺北",
      "zhName": "福井县嶺北",
      "koName": "후쿠이현 령북",
      "esName": "Reihoku, Prefectura de Fukui",
      "ptName": "Região Reihoku da Província de Fukui",
      "thName": "เรโฮกุ จังหวัดฟุกุอิ",
      "viName": "Reihoku, tỉnh Fukui",
      "inName": "Reihoku, Prefektur Fukui",
      "tlName": "Reihoku, Fukui Prefecture",
      "moName": "Фүкүи аймаг, Рэйхокү",
      "buName": "ယဲအိဟိုခု၊ ဟုခုအိစီရင်စု",
      "khName": "តំបន់រ៉េហូគឹនៃខេត្តហ្វឹគឹយ",
      "neName": "फुकुइ जिल्ला, रेइहोकु"
    },
    "class15": {
      "code": "180011",
      "name": "嶺北北部",
      "enName": "Northern Reihoku"
    },
    "class20": {
      "code": "1821000",
      "name": "坂井市",
      "enName": "Sakai City",
      "kana": "さかいし",
      "chName": "福井阪井市",
      "zhName": "福井阪井市",
      "koName": "후쿠이 사카이 시",
      "esName": "Ciudad de Sakai, Fukui",
      "ptName": "Fukui, cidade de Sakai",
      "thName": "เมืองซาไก ฟุกุอิ",
      "viName": "Thành phố Sakai, Fukui",
      "inName": "Kota Sakai, Fukui",
      "tlName": "siyudad ng Sakai, Fukui",
      "moName": "Фүкүи  Сакаи хот",
      "buName": "ဟုခုအိဆကအိမြို့",
      "khName": "ទីក្រុងសាកៃ ហ្វឹគឹយ",
      "neName": "फुकुइ साकाई सहर"
    }
  },
  "1832200": {
    "office": {
      "code": "180000",
      "name": "福井県",
      "enName": "Fukui",
      "officeName": "福井地方気象台",
      "chName": "福井县",
      "zhName": "福井縣",
      "koName": "후쿠이현",
      "esName": "Prefectura de Fukui",
      "ptName": "Província de Fukui",
      "thName": "จังหวัดฟุกุอิ",
      "viName": "Tỉnh Fukui",
      "inName": "Prefectur Fukui",
      "tlName": "Fukui Prefecture",
      "moName": "Фүкүй аймаг",
      "buName": "ဖူကူးရိ ပြည်နယ်",
      "khName": "ខេត្ត ហ្វូគូអ៊ី",
      "neName": "फुकुइ जिल्ला"
    },
    "class10": {
      "code": "180010",
      "name": "嶺北",
      "enName": "Reihoku",
      "chName": "福井県嶺北",
      "zhName": "福井县嶺北",
      "koName": "후쿠이현 령북",
      "esName": "Reihoku, Prefectura de Fukui",
      "ptName": "Região Reihoku da Província de Fukui",
      "thName": "เรโฮกุ จังหวัดฟุกุอิ",
      "viName": "Reihoku, tỉnh Fukui",
      "inName": "Reihoku, Prefektur Fukui",
      "tlName": "Reihoku, Fukui Prefecture",
      "moName": "Фүкүи аймаг, Рэйхокү",
      "buName": "ယဲအိဟိုခု၊ ဟုခုအိစီရင်စု",
      "khName": "តំបន់រ៉េហូគឹនៃខេត្តហ្វឹគឹយ",
      "neName": "फुकुइ जिल्ला, रेइहोकु"
    },
    "class15": {
      "code": "180011",
      "name": "嶺北北部",
      "enName": "Northern Reihoku"
    },
    "class20": {
      "code": "1832200",
      "name": "永平寺町",
      "enName": "Eiheiji Town",
      "kana": "えいへいじちょう",
      "chName": "永平寺町",
      "zhName": "永平寺町",
      "koName": "에이헤이지 정",
      "esName": "Pueblo de Eiheiji",
      "ptName": "bairro de Eiheiji",
      "thName": "เมืองเออิเฮจิ",
      "viName": "thị trấn Eiheiji",
      "inName": "kota Eiheiji",
      "tlName": "bayan ng Eiheiji",
      "moName": "Эйхэйжи жижиг хот",
      "buName": "အေ့ဟေးဂျိ မြို့နယ်",
      "khName": "ទីប្រជុំជន អ៊ីហ៊ីជី",
      "neName": "एइहेइजी नगर"
    }
  },
  "1838200": {
    "office": {
      "code": "180000",
      "name": "福井県",
      "enName": "Fukui",
      "officeName": "福井地方気象台",
      "chName": "福井县",
      "zhName": "福井縣",
      "koName": "후쿠이현",
      "esName": "Prefectura de Fukui",
      "ptName": "Província de Fukui",
      "thName": "จังหวัดฟุกุอิ",
      "viName": "Tỉnh Fukui",
      "inName": "Prefectur Fukui",
      "tlName": "Fukui Prefecture",
      "moName": "Фүкүй аймаг",
      "buName": "ဖူကူးရိ ပြည်နယ်",
      "khName": "ខេត្ត ហ្វូគូអ៊ី",
      "neName": "फुकुइ जिल्ला"
    },
    "class10": {
      "code": "180010",
      "name": "嶺北",
      "enName": "Reihoku",
      "chName": "福井県嶺北",
      "zhName": "福井县嶺北",
      "koName": "후쿠이현 령북",
      "esName": "Reihoku, Prefectura de Fukui",
      "ptName": "Região Reihoku da Província de Fukui",
      "thName": "เรโฮกุ จังหวัดฟุกุอิ",
      "viName": "Reihoku, tỉnh Fukui",
      "inName": "Reihoku, Prefektur Fukui",
      "tlName": "Reihoku, Fukui Prefecture",
      "moName": "Фүкүи аймаг, Рэйхокү",
      "buName": "ယဲအိဟိုခု၊ ဟုခုအိစီရင်စု",
      "khName": "តំបន់រ៉េហូគឹនៃខេត្តហ្វឹគឹយ",
      "neName": "फुकुइ जिल्ला, रेइहोकु"
    },
    "class15": {
      "code": "180012",
      "name": "嶺北南部",
      "enName": "Southern Reihoku"
    },
    "class20": {
      "code": "1838200",
      "name": "池田町",
      "enName": "Ikeda Town",
      "kana": "いけだちょう",
      "chName": "福井池田町",
      "zhName": "福井池田町",
      "koName": "후쿠이 이케다 정",
      "esName": "Pueblo de Ikeda, Fukui",
      "ptName": "Fukui, bairro de Ikeda",
      "thName": "เมืองอิเคดะ ฟุกุอิ",
      "viName": "Thị trấn Ikeda, Fukui",
      "inName": "Kota Ikeda, Fukui",
      "tlName": "bayan ng Ikeda, Fukui",
      "moName": "Фүкүи Икеда жижиг хот",
      "buName": "ဟုခုအိအိခဲဒမြို့နယ် ",
      "khName": "ទីប្រជុំជនអាយកេដា ហ្វឹគឹយ",
      "neName": "फुकुइ इकेदा नगर"
    }
  },
  "1840400": {
    "office": {
      "code": "180000",
      "name": "福井県",
      "enName": "Fukui",
      "officeName": "福井地方気象台",
      "chName": "福井县",
      "zhName": "福井縣",
      "koName": "후쿠이현",
      "esName": "Prefectura de Fukui",
      "ptName": "Província de Fukui",
      "thName": "จังหวัดฟุกุอิ",
      "viName": "Tỉnh Fukui",
      "inName": "Prefectur Fukui",
      "tlName": "Fukui Prefecture",
      "moName": "Фүкүй аймаг",
      "buName": "ဖူကူးရိ ပြည်နယ်",
      "khName": "ខេត្ត ហ្វូគូអ៊ី",
      "neName": "फुकुइ जिल्ला"
    },
    "class10": {
      "code": "180010",
      "name": "嶺北",
      "enName": "Reihoku",
      "chName": "福井県嶺北",
      "zhName": "福井县嶺北",
      "koName": "후쿠이현 령북",
      "esName": "Reihoku, Prefectura de Fukui",
      "ptName": "Região Reihoku da Província de Fukui",
      "thName": "เรโฮกุ จังหวัดฟุกุอิ",
      "viName": "Reihoku, tỉnh Fukui",
      "inName": "Reihoku, Prefektur Fukui",
      "tlName": "Reihoku, Fukui Prefecture",
      "moName": "Фүкүи аймаг, Рэйхокү",
      "buName": "ယဲအိဟိုခု၊ ဟုခုအိစီရင်စု",
      "khName": "តំបន់រ៉េហូគឹនៃខេត្តហ្វឹគឹយ",
      "neName": "फुकुइ जिल्ला, रेइहोकु"
    },
    "class15": {
      "code": "180012",
      "name": "嶺北南部",
      "enName": "Southern Reihoku"
    },
    "class20": {
      "code": "1840400",
      "name": "南越前町",
      "enName": "Minamiechizen Town",
      "kana": "みなみえちぜんちょう",
      "chName": "南越前町",
      "zhName": "南越前町",
      "koName": "미나미에치젠 정",
      "esName": "Pueblo de Minami-echizen",
      "ptName": "bairro de Minamiechizen",
      "thName": "เมืองมินามิเอจิเซน",
      "viName": "thị trấn Minamiechizen",
      "inName": "kota Minamiechizen",
      "tlName": "bayan ng Minamiechizen",
      "moName": "Минaмиэчизэн жижиг хот",
      "buName": "မီနာမိယဲ့ကျိဇန် မြို့နယ်",
      "khName": "ទីប្រជុំជន មីណាមីឈីឈីន",
      "neName": "मिनामिएचिजेन नगर"
    }
  },
  "1842300": {
    "office": {
      "code": "180000",
      "name": "福井県",
      "enName": "Fukui",
      "officeName": "福井地方気象台",
      "chName": "福井县",
      "zhName": "福井縣",
      "koName": "후쿠이현",
      "esName": "Prefectura de Fukui",
      "ptName": "Província de Fukui",
      "thName": "จังหวัดฟุกุอิ",
      "viName": "Tỉnh Fukui",
      "inName": "Prefectur Fukui",
      "tlName": "Fukui Prefecture",
      "moName": "Фүкүй аймаг",
      "buName": "ဖူကူးရိ ပြည်နယ်",
      "khName": "ខេត្ត ហ្វូគូអ៊ី",
      "neName": "फुकुइ जिल्ला"
    },
    "class10": {
      "code": "180010",
      "name": "嶺北",
      "enName": "Reihoku",
      "chName": "福井県嶺北",
      "zhName": "福井县嶺北",
      "koName": "후쿠이현 령북",
      "esName": "Reihoku, Prefectura de Fukui",
      "ptName": "Região Reihoku da Província de Fukui",
      "thName": "เรโฮกุ จังหวัดฟุกุอิ",
      "viName": "Reihoku, tỉnh Fukui",
      "inName": "Reihoku, Prefektur Fukui",
      "tlName": "Reihoku, Fukui Prefecture",
      "moName": "Фүкүи аймаг, Рэйхокү",
      "buName": "ယဲအိဟိုခု၊ ဟုခုအိစီရင်စု",
      "khName": "តំបន់រ៉េហូគឹនៃខេត្តហ្វឹគឹយ",
      "neName": "फुकुइ जिल्ला, रेइहोकु"
    },
    "class15": {
      "code": "180011",
      "name": "嶺北北部",
      "enName": "Northern Reihoku"
    },
    "class20": {
      "code": "1842300",
      "name": "越前町",
      "enName": "Echizen Town",
      "kana": "えちぜんちょう",
      "chName": "越前町",
      "zhName": "越前町",
      "koName": "에치젠 정",
      "esName": "Pueblo de Echizen",
      "ptName": "bairro de Echizen",
      "thName": "เมืองเอจิเซน (เอจิเซนโจ)",
      "viName": "thị trấn Echizen",
      "inName": "kota Echizen (Echizen-chō)",
      "tlName": "bayan ng Echizen",
      "moName": "Эчизэн жижиг хот",
      "buName": "အေ့ကျိဇန် မြို့နယ်",
      "khName": "ទីប្រជុំជន អ៊ីឈីហ្សេន",
      "neName": "एचिजेन नगर"
    }
  },
  "1844200": {
    "office": {
      "code": "180000",
      "name": "福井県",
      "enName": "Fukui",
      "officeName": "福井地方気象台",
      "chName": "福井县",
      "zhName": "福井縣",
      "koName": "후쿠이현",
      "esName": "Prefectura de Fukui",
      "ptName": "Província de Fukui",
      "thName": "จังหวัดฟุกุอิ",
      "viName": "Tỉnh Fukui",
      "inName": "Prefectur Fukui",
      "tlName": "Fukui Prefecture",
      "moName": "Фүкүй аймаг",
      "buName": "ဖူကူးရိ ပြည်နယ်",
      "khName": "ខេត្ត ហ្វូគូអ៊ី",
      "neName": "फुकुइ जिल्ला"
    },
    "class10": {
      "code": "180020",
      "name": "嶺南",
      "enName": "Reinan",
      "chName": "福井県嶺南",
      "zhName": "福井縣嶺南",
      "koName": "후쿠이현 영남",
      "esName": "Reinan, Prefectura de Fukui",
      "ptName": "Região Reinan da Província de Fukui",
      "thName": "เรนัน จังหวัดฟุกุอิ",
      "viName": "Reinan, tỉnh Fukui",
      "inName": "Reinan, Prefektur Fukui",
      "tlName": "Reinan, Fukui Prefecture",
      "moName": "Фүкүи аймаг, Рэйнан",
      "buName": "ယဲအိနန်း၊ ဟုခုအိစီရင်စု",
      "khName": "តំបន់រ៉េណាន់នៃខេត្តហ្វឹគឹយ",
      "neName": "फुकुइ जिल्ला, रेइनान्"
    },
    "class15": {
      "code": "180021",
      "name": "嶺南東部",
      "enName": "Eastern Reinan"
    },
    "class20": {
      "code": "1844200",
      "name": "美浜町",
      "enName": "Mihama Town",
      "kana": "みはまちょう",
      "chName": "福井美浜町",
      "zhName": "福井美浜町",
      "koName": "후쿠이 미하마 정",
      "esName": "Pueblo de Mihama, Fukui",
      "ptName": "Fukui, bairro de Mihama",
      "thName": "เมืองมิฮามะ ฟุกุอิ",
      "viName": "Thị trấn Mihama, Fukui",
      "inName": "Kota Mihama, Fukui",
      "tlName": "bayan ng Mihama, Fukui",
      "moName": "Фүкүи Михама жижиг хот",
      "buName": "ဟုခုအိမိဟမမြို့နယ် ",
      "khName": "ទីប្រជុំជន​មីហាម៉ា ហ្វឹគឹយ",
      "neName": "फुकुइ मिहामा नगर"
    }
  },
  "1848100": {
    "office": {
      "code": "180000",
      "name": "福井県",
      "enName": "Fukui",
      "officeName": "福井地方気象台",
      "chName": "福井县",
      "zhName": "福井縣",
      "koName": "후쿠이현",
      "esName": "Prefectura de Fukui",
      "ptName": "Província de Fukui",
      "thName": "จังหวัดฟุกุอิ",
      "viName": "Tỉnh Fukui",
      "inName": "Prefectur Fukui",
      "tlName": "Fukui Prefecture",
      "moName": "Фүкүй аймаг",
      "buName": "ဖူကူးရိ ပြည်နယ်",
      "khName": "ខេត្ត ហ្វូគូអ៊ី",
      "neName": "फुकुइ जिल्ला"
    },
    "class10": {
      "code": "180020",
      "name": "嶺南",
      "enName": "Reinan",
      "chName": "福井県嶺南",
      "zhName": "福井縣嶺南",
      "koName": "후쿠이현 영남",
      "esName": "Reinan, Prefectura de Fukui",
      "ptName": "Região Reinan da Província de Fukui",
      "thName": "เรนัน จังหวัดฟุกุอิ",
      "viName": "Reinan, tỉnh Fukui",
      "inName": "Reinan, Prefektur Fukui",
      "tlName": "Reinan, Fukui Prefecture",
      "moName": "Фүкүи аймаг, Рэйнан",
      "buName": "ယဲအိနန်း၊ ဟုခုအိစီရင်စု",
      "khName": "តំបន់រ៉េណាន់នៃខេត្តហ្វឹគឹយ",
      "neName": "फुकुइ जिल्ला, रेइनान्"
    },
    "class15": {
      "code": "180022",
      "name": "嶺南西部",
      "enName": "Western Reinan"
    },
    "class20": {
      "code": "1848100",
      "name": "高浜町",
      "enName": "Takahama Town",
      "kana": "たかはまちょう",
      "chName": "高滨町",
      "zhName": "髙濱町",
      "koName": "다카하마 정",
      "esName": "Pueblo de Takahama",
      "ptName": "bairro de Takahama",
      "thName": "เมืองทากาฮามะ",
      "viName": "thị trấn Takahama",
      "inName": "kota Takahama",
      "tlName": "bayan ng Takahama",
      "moName": "Такахaмa жижиг хот",
      "buName": "တာကားဟာ့မ မြို့နယ်",
      "khName": "ទីប្រជុំជន តាកាហាម៉ា",
      "neName": "ताकाहामा नगर"
    }
  },
  "1848300": {
    "office": {
      "code": "180000",
      "name": "福井県",
      "enName": "Fukui",
      "officeName": "福井地方気象台",
      "chName": "福井县",
      "zhName": "福井縣",
      "koName": "후쿠이현",
      "esName": "Prefectura de Fukui",
      "ptName": "Província de Fukui",
      "thName": "จังหวัดฟุกุอิ",
      "viName": "Tỉnh Fukui",
      "inName": "Prefectur Fukui",
      "tlName": "Fukui Prefecture",
      "moName": "Фүкүй аймаг",
      "buName": "ဖူကူးရိ ပြည်နယ်",
      "khName": "ខេត្ត ហ្វូគូអ៊ី",
      "neName": "फुकुइ जिल्ला"
    },
    "class10": {
      "code": "180020",
      "name": "嶺南",
      "enName": "Reinan",
      "chName": "福井県嶺南",
      "zhName": "福井縣嶺南",
      "koName": "후쿠이현 영남",
      "esName": "Reinan, Prefectura de Fukui",
      "ptName": "Região Reinan da Província de Fukui",
      "thName": "เรนัน จังหวัดฟุกุอิ",
      "viName": "Reinan, tỉnh Fukui",
      "inName": "Reinan, Prefektur Fukui",
      "tlName": "Reinan, Fukui Prefecture",
      "moName": "Фүкүи аймаг, Рэйнан",
      "buName": "ယဲအိနန်း၊ ဟုခုအိစီရင်စု",
      "khName": "តំបន់រ៉េណាន់នៃខេត្តហ្វឹគឹយ",
      "neName": "फुकुइ जिल्ला, रेइनान्"
    },
    "class15": {
      "code": "180022",
      "name": "嶺南西部",
      "enName": "Western Reinan"
    },
    "class20": {
      "code": "1848300",
      "name": "おおい町",
      "enName": "Ohi Town",
      "kana": "おおいちょう",
      "chName": "福井大井町",
      "zhName": "福井大井町",
      "koName": "후쿠이 오이 정",
      "esName": "Pueblo de Ooi, Fukui",
      "ptName": "Fukui, bairro de Ooi",
      "thName": "เมืองโออิ ฟุกุอิ",
      "viName": "Thị trấn Ooi, Fukui",
      "inName": "Kota Ohi, Fukui",
      "tlName": "bayan ng Oi, Fukui",
      "moName": "Фүкүи Ои жижиг хот",
      "buName": "ဟုခုအိအိုအိုအိမြို့နယ် ",
      "khName": "ទីប្រជុំជនអូហ៊ី ហ្វឹគឹយ",
      "neName": "फुकुइ ओओइ नगर"
    }
  },
  "1850100": {
    "office": {
      "code": "180000",
      "name": "福井県",
      "enName": "Fukui",
      "officeName": "福井地方気象台",
      "chName": "福井县",
      "zhName": "福井縣",
      "koName": "후쿠이현",
      "esName": "Prefectura de Fukui",
      "ptName": "Província de Fukui",
      "thName": "จังหวัดฟุกุอิ",
      "viName": "Tỉnh Fukui",
      "inName": "Prefectur Fukui",
      "tlName": "Fukui Prefecture",
      "moName": "Фүкүй аймаг",
      "buName": "ဖူကူးရိ ပြည်နယ်",
      "khName": "ខេត្ត ហ្វូគូអ៊ី",
      "neName": "फुकुइ जिल्ला"
    },
    "class10": {
      "code": "180020",
      "name": "嶺南",
      "enName": "Reinan",
      "chName": "福井県嶺南",
      "zhName": "福井縣嶺南",
      "koName": "후쿠이현 영남",
      "esName": "Reinan, Prefectura de Fukui",
      "ptName": "Região Reinan da Província de Fukui",
      "thName": "เรนัน จังหวัดฟุกุอิ",
      "viName": "Reinan, tỉnh Fukui",
      "inName": "Reinan, Prefektur Fukui",
      "tlName": "Reinan, Fukui Prefecture",
      "moName": "Фүкүи аймаг, Рэйнан",
      "buName": "ယဲအိနန်း၊ ဟုခုအိစီရင်စု",
      "khName": "តំបន់រ៉េណាន់នៃខេត្តហ្វឹគឹយ",
      "neName": "फुकुइ जिल्ला, रेइनान्"
    },
    "class15": {
      "code": "180021",
      "name": "嶺南東部",
      "enName": "Eastern Reinan"
    },
    "class20": {
      "code": "1850100",
      "name": "若狭町",
      "enName": "Wakasa Town",
      "kana": "わかさちょう",
      "chName": "福井若狭町",
      "zhName": "福井若狹町",
      "koName": "후쿠이 와카사 정",
      "esName": "Pueblo de Wakasa, Fukui",
      "ptName": "Fukui, bairro de Wakasa",
      "thName": "เมืองวาคาสะ ฟุกุอิ",
      "viName": "Thị trấn Wakasa, Fukui",
      "inName": "Kota Wakasa, Fukui",
      "tlName": "bayan ng Wakasa, Fukui",
      "moName": "Фүкүи Вакаса жижиг хот",
      "buName": "ဟုခုအိဝကဆမြို့နယ် ",
      "khName": "ទីប្រជុំជនវ៉ាកាសា ហ្វឹគឹយ",
      "neName": "फुकुइ वाकासा नगर"
    }
  },
  "1920100": {
    "office": {
      "code": "190000",
      "name": "山梨県",
      "enName": "Yamanashi",
      "officeName": "甲府地方気象台",
      "chName": "山梨县",
      "zhName": "山梨縣",
      "koName": "야마나시현",
      "esName": "Prefectura de Yamanashi",
      "ptName": "Província de Yamanashi",
      "thName": "จังหวัดยามานาชิ",
      "viName": "Tỉnh Yamanashi",
      "inName": "Prefektur Yamanashi",
      "tlName": "Yamanashi Prefecture",
      "moName": "Яманаши аймаг",
      "buName": "ယာမနာရှိ ပြည်နယ်",
      "khName": "ខេត្ត យ៉ាម៉ាណាស៊ី",
      "neName": "यामानासी जिल्ला"
    },
    "class10": {
      "code": "190010",
      "name": "中・西部",
      "enName": "Central Western Region",
      "chName": "山梨县中，西部",
      "zhName": "山梨縣中・西部",
      "koName": "야마나시 현 중·서부",
      "esName": "Centro-Oeste de Prefectura de Yamanashi",
      "ptName": "Região central e oeste da Província de Yamanashi",
      "thName": "จังหวัดยามานาชิตอนกลางและฟากตะวันตก",
      "viName": "Miền Trung và Tây tỉnh Yamanashi",
      "inName": "Bagian Tengah dan Barat Prefektur Yamanashi",
      "tlName": "Sentral at kanlurang bahagi ng Yamanashi Prefecture",
      "moName": "Төв・Баруун Яманаши аймаг",
      "buName": "ယမနရှိစီရင်စုအနောက်ပိုင်း၊ အလယ်ပိုင်းဒေသ",
      "khName": "តំបន់កណ្តាល/តំបន់ខាងលិចនៃខេត្តយ៉ាម៉ាណាស៊ី",
      "neName": "यामानासी जिल्लाको मध्य र पश्चिमी भाग"
    },
    "class15": {
      "code": "190011",
      "name": "中北地域",
      "enName": "Chuhoku Area"
    },
    "class20": {
      "code": "1920100",
      "name": "甲府市",
      "enName": "Kofu City",
      "kana": "こうふし",
      "chName": "甲府市",
      "zhName": "甲府市",
      "koName": "고후 시",
      "esName": "Ciudad de Kōfu",
      "ptName": "cidade de Kofu",
      "thName": "เมืองโคฟุ",
      "viName": "thành phố Kofu",
      "inName": "kota Kofu",
      "tlName": "siyudad ng Kofu",
      "moName": "Кофү хот",
      "buName": "ကိုဖူ မြို့",
      "khName": "ទីក្រុង កូហ្វូ",
      "neName": "कोफु सहर"
    }
  },
  "1920200": {
    "office": {
      "code": "190000",
      "name": "山梨県",
      "enName": "Yamanashi",
      "officeName": "甲府地方気象台",
      "chName": "山梨县",
      "zhName": "山梨縣",
      "koName": "야마나시현",
      "esName": "Prefectura de Yamanashi",
      "ptName": "Província de Yamanashi",
      "thName": "จังหวัดยามานาชิ",
      "viName": "Tỉnh Yamanashi",
      "inName": "Prefektur Yamanashi",
      "tlName": "Yamanashi Prefecture",
      "moName": "Яманаши аймаг",
      "buName": "ယာမနာရှိ ပြည်နယ်",
      "khName": "ខេត្ត យ៉ាម៉ាណាស៊ី",
      "neName": "यामानासी जिल्ला"
    },
    "class10": {
      "code": "190020",
      "name": "東部・富士五湖",
      "enName": "Eastern Region and Fuji Five Lakes",
      "chName": "山梨县东部、富士五湖",
      "zhName": "山梨縣東部・富士五湖",
      "koName": "야마나시 현 동부 후지 고호 수",
      "esName": "Este, Fujigoko de Prefectura de Yamanashi",
      "ptName": "Região leste ・Cinco Lagos do Fuji da Província de Yamanashi",
      "thName": "จังหวัดยามานาชิฟากตะวันออก และทะเลสาบฟูจิทั้งห้า (ฟูจิโงะโกะ)",
      "viName": "Miền Đông tỉnh Yamanashi và Ngũ hồ Fuji (Fuji-goko)",
      "inName": "Bagian Timur Prefektur Yamanashi dan 5 Danau Fuji (Fuji-goko)",
      "tlName": "Silangang bahagi ng Yamanashi Prefecture at ang Limang Lawa ng Fuji (Fuji-goko)",
      "moName": "Зүүн Яманаши аймаг・ Фүжи таван нуур",
      "buName": "ယမနရှိစီရင်စု၊ အရှေ့ပိုင်းဒေသ၊ ဖူဂျီဂေါ့ရေကန်",
      "khName": "តំបន់ខាងកើត/បឹងហ្វូជីប្រាំនៃខេត្តយ៉ាម៉ាណាស៊ី",
      "neName": "यामानासी जिल्लाको पूर्वी भाग र फुजी पाँच तालहरू (फुजी-गोको)"
    },
    "class15": {
      "code": "190022",
      "name": "富士五湖",
      "enName": "Fuji Five Lakes"
    },
    "class20": {
      "code": "1920200",
      "name": "富士吉田市",
      "enName": "Fujiyoshida City",
      "kana": "ふじよしだし",
      "chName": "富士吉田市",
      "zhName": "富士吉田市",
      "koName": "후지요시다 시",
      "esName": "Ciudad de Fujiyoshida",
      "ptName": "cidade de Fujiyoshida",
      "thName": "เมืองฟูจิโยชิดะ",
      "viName": "thành phố Fujiyoshida",
      "inName": "kota Fujiyoshida",
      "tlName": "siyudad ng Fujiyoshida",
      "moName": "Фүжиёошида хот",
      "buName": "ဖူဂျီယိုးရှိဒ မြို့",
      "khName": "ទីក្រុង ហ្វូជីយ៉ូស៊ីដា",
      "neName": "फुजियोसिडा सहर"
    }
  },
  "1920400": {
    "office": {
      "code": "190000",
      "name": "山梨県",
      "enName": "Yamanashi",
      "officeName": "甲府地方気象台",
      "chName": "山梨县",
      "zhName": "山梨縣",
      "koName": "야마나시현",
      "esName": "Prefectura de Yamanashi",
      "ptName": "Província de Yamanashi",
      "thName": "จังหวัดยามานาชิ",
      "viName": "Tỉnh Yamanashi",
      "inName": "Prefektur Yamanashi",
      "tlName": "Yamanashi Prefecture",
      "moName": "Яманаши аймаг",
      "buName": "ယာမနာရှိ ပြည်နယ်",
      "khName": "ខេត្ត យ៉ាម៉ាណាស៊ី",
      "neName": "यामानासी जिल्ला"
    },
    "class10": {
      "code": "190020",
      "name": "東部・富士五湖",
      "enName": "Eastern Region and Fuji Five Lakes",
      "chName": "山梨县东部、富士五湖",
      "zhName": "山梨縣東部・富士五湖",
      "koName": "야마나시 현 동부 후지 고호 수",
      "esName": "Este, Fujigoko de Prefectura de Yamanashi",
      "ptName": "Região leste ・Cinco Lagos do Fuji da Província de Yamanashi",
      "thName": "จังหวัดยามานาชิฟากตะวันออก และทะเลสาบฟูจิทั้งห้า (ฟูจิโงะโกะ)",
      "viName": "Miền Đông tỉnh Yamanashi và Ngũ hồ Fuji (Fuji-goko)",
      "inName": "Bagian Timur Prefektur Yamanashi dan 5 Danau Fuji (Fuji-goko)",
      "tlName": "Silangang bahagi ng Yamanashi Prefecture at ang Limang Lawa ng Fuji (Fuji-goko)",
      "moName": "Зүүн Яманаши аймаг・ Фүжи таван нуур",
      "buName": "ယမနရှိစီရင်စု၊ အရှေ့ပိုင်းဒေသ၊ ဖူဂျီဂေါ့ရေကန်",
      "khName": "តំបន់ខាងកើត/បឹងហ្វូជីប្រាំនៃខេត្តយ៉ាម៉ាណាស៊ី",
      "neName": "यामानासी जिल्लाको पूर्वी भाग र फुजी पाँच तालहरू (फुजी-गोको)"
    },
    "class15": {
      "code": "190021",
      "name": "東部",
      "enName": "Eastern Region"
    },
    "class20": {
      "code": "1920400",
      "name": "都留市",
      "enName": "Tsuru City",
      "kana": "つるし",
      "chName": "都留市",
      "zhName": "都留市",
      "koName": "쓰루 시",
      "esName": "Ciudad de Tsuru",
      "ptName": "cidade de Tsuru",
      "thName": "เมืองสึรุ",
      "viName": "thành phố Tsuru",
      "inName": "kota Tsuru",
      "tlName": "siyudad ng Tsuru",
      "moName": "Цүрү хот",
      "buName": "ဆုရု မြို့",
      "khName": "ទីក្រុង ស៊ូរូ",
      "neName": "त्सुरु सहर"
    }
  },
  "1920500": {
    "office": {
      "code": "190000",
      "name": "山梨県",
      "enName": "Yamanashi",
      "officeName": "甲府地方気象台",
      "chName": "山梨县",
      "zhName": "山梨縣",
      "koName": "야마나시현",
      "esName": "Prefectura de Yamanashi",
      "ptName": "Província de Yamanashi",
      "thName": "จังหวัดยามานาชิ",
      "viName": "Tỉnh Yamanashi",
      "inName": "Prefektur Yamanashi",
      "tlName": "Yamanashi Prefecture",
      "moName": "Яманаши аймаг",
      "buName": "ယာမနာရှိ ပြည်နယ်",
      "khName": "ខេត្ត យ៉ាម៉ាណាស៊ី",
      "neName": "यामानासी जिल्ला"
    },
    "class10": {
      "code": "190010",
      "name": "中・西部",
      "enName": "Central Western Region",
      "chName": "山梨县中，西部",
      "zhName": "山梨縣中・西部",
      "koName": "야마나시 현 중·서부",
      "esName": "Centro-Oeste de Prefectura de Yamanashi",
      "ptName": "Região central e oeste da Província de Yamanashi",
      "thName": "จังหวัดยามานาชิตอนกลางและฟากตะวันตก",
      "viName": "Miền Trung và Tây tỉnh Yamanashi",
      "inName": "Bagian Tengah dan Barat Prefektur Yamanashi",
      "tlName": "Sentral at kanlurang bahagi ng Yamanashi Prefecture",
      "moName": "Төв・Баруун Яманаши аймаг",
      "buName": "ယမနရှိစီရင်စုအနောက်ပိုင်း၊ အလယ်ပိုင်းဒေသ",
      "khName": "តំបន់កណ្តាល/តំបន់ខាងលិចនៃខេត្តយ៉ាម៉ាណាស៊ី",
      "neName": "यामानासी जिल्लाको मध्य र पश्चिमी भाग"
    },
    "class15": {
      "code": "190012",
      "name": "峡東地域",
      "enName": "Kyoto Area"
    },
    "class20": {
      "code": "1920500",
      "name": "山梨市",
      "enName": "Yamanashi City",
      "kana": "やまなしし",
      "chName": "山梨市",
      "zhName": "山梨市",
      "koName": "야마나시 시",
      "esName": "Ciudad de Yamanashi",
      "ptName": "cidade de Yamanashi",
      "thName": "เมืองยามานาชิ",
      "viName": "thành phố Yamanashi",
      "inName": "kota Yamanashi",
      "tlName": "siyudad ng Yamanashi",
      "moName": "Ямaнaши хот",
      "buName": "ယာမာနာ့ရှိ မြို့",
      "khName": "ទីក្រុង យ៉ាម៉ាណាហ្សី",
      "neName": "यामानासी सहर"
    }
  },
  "1920600": {
    "office": {
      "code": "190000",
      "name": "山梨県",
      "enName": "Yamanashi",
      "officeName": "甲府地方気象台",
      "chName": "山梨县",
      "zhName": "山梨縣",
      "koName": "야마나시현",
      "esName": "Prefectura de Yamanashi",
      "ptName": "Província de Yamanashi",
      "thName": "จังหวัดยามานาชิ",
      "viName": "Tỉnh Yamanashi",
      "inName": "Prefektur Yamanashi",
      "tlName": "Yamanashi Prefecture",
      "moName": "Яманаши аймаг",
      "buName": "ယာမနာရှိ ပြည်နယ်",
      "khName": "ខេត្ត យ៉ាម៉ាណាស៊ី",
      "neName": "यामानासी जिल्ला"
    },
    "class10": {
      "code": "190020",
      "name": "東部・富士五湖",
      "enName": "Eastern Region and Fuji Five Lakes",
      "chName": "山梨县东部、富士五湖",
      "zhName": "山梨縣東部・富士五湖",
      "koName": "야마나시 현 동부 후지 고호 수",
      "esName": "Este, Fujigoko de Prefectura de Yamanashi",
      "ptName": "Região leste ・Cinco Lagos do Fuji da Província de Yamanashi",
      "thName": "จังหวัดยามานาชิฟากตะวันออก และทะเลสาบฟูจิทั้งห้า (ฟูจิโงะโกะ)",
      "viName": "Miền Đông tỉnh Yamanashi và Ngũ hồ Fuji (Fuji-goko)",
      "inName": "Bagian Timur Prefektur Yamanashi dan 5 Danau Fuji (Fuji-goko)",
      "tlName": "Silangang bahagi ng Yamanashi Prefecture at ang Limang Lawa ng Fuji (Fuji-goko)",
      "moName": "Зүүн Яманаши аймаг・ Фүжи таван нуур",
      "buName": "ယမနရှိစီရင်စု၊ အရှေ့ပိုင်းဒေသ၊ ဖူဂျီဂေါ့ရေကန်",
      "khName": "តំបន់ខាងកើត/បឹងហ្វូជីប្រាំនៃខេត្តយ៉ាម៉ាណាស៊ី",
      "neName": "यामानासी जिल्लाको पूर्वी भाग र फुजी पाँच तालहरू (फुजी-गोको)"
    },
    "class15": {
      "code": "190021",
      "name": "東部",
      "enName": "Eastern Region"
    },
    "class20": {
      "code": "1920600",
      "name": "大月市",
      "enName": "Otsuki City",
      "kana": "おおつきし",
      "chName": "大月市",
      "zhName": "大月市",
      "koName": "오쓰키 시",
      "esName": "Ciudad de Ōtsuki",
      "ptName": "cidade de Otsuki",
      "thName": "เมืองโอสึกิ",
      "viName": "thành phố Otsuki",
      "inName": "kota Otsuki",
      "tlName": "siyudad ng Otsuki",
      "moName": "Оцүки хот",
      "buName": "အော်ဆုကိ မြို့",
      "khName": "ទីក្រុង អ៊ុតសូគី",
      "neName": "ओत्सुकी सहर"
    }
  },
  "1920700": {
    "office": {
      "code": "190000",
      "name": "山梨県",
      "enName": "Yamanashi",
      "officeName": "甲府地方気象台",
      "chName": "山梨县",
      "zhName": "山梨縣",
      "koName": "야마나시현",
      "esName": "Prefectura de Yamanashi",
      "ptName": "Província de Yamanashi",
      "thName": "จังหวัดยามานาชิ",
      "viName": "Tỉnh Yamanashi",
      "inName": "Prefektur Yamanashi",
      "tlName": "Yamanashi Prefecture",
      "moName": "Яманаши аймаг",
      "buName": "ယာမနာရှိ ပြည်နယ်",
      "khName": "ខេត្ត យ៉ាម៉ាណាស៊ី",
      "neName": "यामानासी जिल्ला"
    },
    "class10": {
      "code": "190010",
      "name": "中・西部",
      "enName": "Central Western Region",
      "chName": "山梨县中，西部",
      "zhName": "山梨縣中・西部",
      "koName": "야마나시 현 중·서부",
      "esName": "Centro-Oeste de Prefectura de Yamanashi",
      "ptName": "Região central e oeste da Província de Yamanashi",
      "thName": "จังหวัดยามานาชิตอนกลางและฟากตะวันตก",
      "viName": "Miền Trung và Tây tỉnh Yamanashi",
      "inName": "Bagian Tengah dan Barat Prefektur Yamanashi",
      "tlName": "Sentral at kanlurang bahagi ng Yamanashi Prefecture",
      "moName": "Төв・Баруун Яманаши аймаг",
      "buName": "ယမနရှိစီရင်စုအနောက်ပိုင်း၊ အလယ်ပိုင်းဒေသ",
      "khName": "តំបន់កណ្តាល/តំបន់ខាងលិចនៃខេត្តយ៉ាម៉ាណាស៊ី",
      "neName": "यामानासी जिल्लाको मध्य र पश्चिमी भाग"
    },
    "class15": {
      "code": "190011",
      "name": "中北地域",
      "enName": "Chuhoku Area"
    },
    "class20": {
      "code": "1920700",
      "name": "韮崎市",
      "enName": "Nirasaki City",
      "kana": "にらさきし",
      "chName": "韭崎市",
      "zhName": "韮崎市",
      "koName": "니라사키 시",
      "esName": "Ciudad de Nirasaki",
      "ptName": "cidade de Nirasaki",
      "thName": "เมืองนิราซากิ",
      "viName": "thành phố Nirasaki",
      "inName": "kota Nirasaki",
      "tlName": "siyudad ng Nirasaki",
      "moName": "Нирасaки хот",
      "buName": "နီရာဆာ့ကိ မြို့",
      "khName": "ទីក្រុង នីរ៉ាសាគី",
      "neName": "निराकाशि सहर"
    }
  },
  "1920800": {
    "office": {
      "code": "190000",
      "name": "山梨県",
      "enName": "Yamanashi",
      "officeName": "甲府地方気象台",
      "chName": "山梨县",
      "zhName": "山梨縣",
      "koName": "야마나시현",
      "esName": "Prefectura de Yamanashi",
      "ptName": "Província de Yamanashi",
      "thName": "จังหวัดยามานาชิ",
      "viName": "Tỉnh Yamanashi",
      "inName": "Prefektur Yamanashi",
      "tlName": "Yamanashi Prefecture",
      "moName": "Яманаши аймаг",
      "buName": "ယာမနာရှိ ပြည်နယ်",
      "khName": "ខេត្ត យ៉ាម៉ាណាស៊ី",
      "neName": "यामानासी जिल्ला"
    },
    "class10": {
      "code": "190010",
      "name": "中・西部",
      "enName": "Central Western Region",
      "chName": "山梨县中，西部",
      "zhName": "山梨縣中・西部",
      "koName": "야마나시 현 중·서부",
      "esName": "Centro-Oeste de Prefectura de Yamanashi",
      "ptName": "Região central e oeste da Província de Yamanashi",
      "thName": "จังหวัดยามานาชิตอนกลางและฟากตะวันตก",
      "viName": "Miền Trung và Tây tỉnh Yamanashi",
      "inName": "Bagian Tengah dan Barat Prefektur Yamanashi",
      "tlName": "Sentral at kanlurang bahagi ng Yamanashi Prefecture",
      "moName": "Төв・Баруун Яманаши аймаг",
      "buName": "ယမနရှိစီရင်စုအနောက်ပိုင်း၊ အလယ်ပိုင်းဒေသ",
      "khName": "តំបន់កណ្តាល/តំបន់ខាងលិចនៃខេត្តយ៉ាម៉ាណាស៊ី",
      "neName": "यामानासी जिल्लाको मध्य र पश्चिमी भाग"
    },
    "class15": {
      "code": "190011",
      "name": "中北地域",
      "enName": "Chuhoku Area"
    },
    "class20": {
      "code": "1920800",
      "name": "南アルプス市",
      "enName": "Minamialps City",
      "kana": "みなみあるぷすし",
      "chName": "南阿尔卑斯市",
      "zhName": "南阿爾卑斯市",
      "koName": "미나미알프스 시",
      "esName": "Ciudad de Minami-Alps",
      "ptName": "cidade de Minamialps",
      "thName": "เมืองมินามิแอลป์",
      "viName": "thành phố Minamialps",
      "inName": "kota Minamialps",
      "tlName": "siyudad ng Minamialps",
      "moName": "Минaмиaлпс хот",
      "buName": "မီနာမိယရုပုစု မြို့",
      "khName": "ទីក្រុង មីណាមីអាលភ៍",
      "neName": "मिनामिआल्प्स सहर"
    }
  },
  "1920900": {
    "office": {
      "code": "190000",
      "name": "山梨県",
      "enName": "Yamanashi",
      "officeName": "甲府地方気象台",
      "chName": "山梨县",
      "zhName": "山梨縣",
      "koName": "야마나시현",
      "esName": "Prefectura de Yamanashi",
      "ptName": "Província de Yamanashi",
      "thName": "จังหวัดยามานาชิ",
      "viName": "Tỉnh Yamanashi",
      "inName": "Prefektur Yamanashi",
      "tlName": "Yamanashi Prefecture",
      "moName": "Яманаши аймаг",
      "buName": "ယာမနာရှိ ပြည်နယ်",
      "khName": "ខេត្ត យ៉ាម៉ាណាស៊ី",
      "neName": "यामानासी जिल्ला"
    },
    "class10": {
      "code": "190010",
      "name": "中・西部",
      "enName": "Central Western Region",
      "chName": "山梨县中，西部",
      "zhName": "山梨縣中・西部",
      "koName": "야마나시 현 중·서부",
      "esName": "Centro-Oeste de Prefectura de Yamanashi",
      "ptName": "Região central e oeste da Província de Yamanashi",
      "thName": "จังหวัดยามานาชิตอนกลางและฟากตะวันตก",
      "viName": "Miền Trung và Tây tỉnh Yamanashi",
      "inName": "Bagian Tengah dan Barat Prefektur Yamanashi",
      "tlName": "Sentral at kanlurang bahagi ng Yamanashi Prefecture",
      "moName": "Төв・Баруун Яманаши аймаг",
      "buName": "ယမနရှိစီရင်စုအနောက်ပိုင်း၊ အလယ်ပိုင်းဒေသ",
      "khName": "តំបន់កណ្តាល/តំបន់ខាងលិចនៃខេត្តយ៉ាម៉ាណាស៊ី",
      "neName": "यामानासी जिल्लाको मध्य र पश्चिमी भाग"
    },
    "class15": {
      "code": "190011",
      "name": "中北地域",
      "enName": "Chuhoku Area"
    },
    "class20": {
      "code": "1920900",
      "name": "北杜市",
      "enName": "Hokuto City",
      "kana": "ほくとし",
      "chName": "山梨北杜市",
      "zhName": "山梨北杜市",
      "koName": "야마나시 호쿠토 시",
      "esName": "Ciudad de Hokuto, Yamanashi",
      "ptName": "Yamanashi, cidade de Hokuto",
      "thName": "เมืองโฮคุโตะ ยามานาชิ",
      "viName": "Thành phố Hokuto, Yamanashi",
      "inName": "Kota Hokuto, Yamanashi",
      "tlName": "siyudad ng Hokuto, Yamanashi",
      "moName": "Яманаши Хокуто  хот",
      "buName": "ယမနရှိဟိုခုမြို့",
      "khName": "ទីក្រុងហូគូតូ យ៉ាម៉ាណាស៊ី",
      "neName": "यामानासी होक्तो सहर"
    }
  },
  "1921000": {
    "office": {
      "code": "190000",
      "name": "山梨県",
      "enName": "Yamanashi",
      "officeName": "甲府地方気象台",
      "chName": "山梨县",
      "zhName": "山梨縣",
      "koName": "야마나시현",
      "esName": "Prefectura de Yamanashi",
      "ptName": "Província de Yamanashi",
      "thName": "จังหวัดยามานาชิ",
      "viName": "Tỉnh Yamanashi",
      "inName": "Prefektur Yamanashi",
      "tlName": "Yamanashi Prefecture",
      "moName": "Яманаши аймаг",
      "buName": "ယာမနာရှိ ပြည်နယ်",
      "khName": "ខេត្ត យ៉ាម៉ាណាស៊ី",
      "neName": "यामानासी जिल्ला"
    },
    "class10": {
      "code": "190010",
      "name": "中・西部",
      "enName": "Central Western Region",
      "chName": "山梨县中，西部",
      "zhName": "山梨縣中・西部",
      "koName": "야마나시 현 중·서부",
      "esName": "Centro-Oeste de Prefectura de Yamanashi",
      "ptName": "Região central e oeste da Província de Yamanashi",
      "thName": "จังหวัดยามานาชิตอนกลางและฟากตะวันตก",
      "viName": "Miền Trung và Tây tỉnh Yamanashi",
      "inName": "Bagian Tengah dan Barat Prefektur Yamanashi",
      "tlName": "Sentral at kanlurang bahagi ng Yamanashi Prefecture",
      "moName": "Төв・Баруун Яманаши аймаг",
      "buName": "ယမနရှိစီရင်စုအနောက်ပိုင်း၊ အလယ်ပိုင်းဒေသ",
      "khName": "តំបន់កណ្តាល/តំបន់ខាងលិចនៃខេត្តយ៉ាម៉ាណាស៊ី",
      "neName": "यामानासी जिल्लाको मध्य र पश्चिमी भाग"
    },
    "class15": {
      "code": "190011",
      "name": "中北地域",
      "enName": "Chuhoku Area"
    },
    "class20": {
      "code": "1921000",
      "name": "甲斐市",
      "enName": "Kai City",
      "kana": "かいし",
      "chName": "甲斐市",
      "zhName": "甲斐市",
      "koName": "가이 시",
      "esName": "Ciudad de Kai",
      "ptName": "cidade de Kai",
      "thName": "เมืองไค",
      "viName": "thành phố Kai",
      "inName": "kota Kai",
      "tlName": "siyudad ng Kai",
      "moName": "Кай хот",
      "buName": "ကိုက် မြို့",
      "khName": "ទីក្រុង កៃ",
      "neName": "काई सहर"
    }
  },
  "1921100": {
    "office": {
      "code": "190000",
      "name": "山梨県",
      "enName": "Yamanashi",
      "officeName": "甲府地方気象台",
      "chName": "山梨县",
      "zhName": "山梨縣",
      "koName": "야마나시현",
      "esName": "Prefectura de Yamanashi",
      "ptName": "Província de Yamanashi",
      "thName": "จังหวัดยามานาชิ",
      "viName": "Tỉnh Yamanashi",
      "inName": "Prefektur Yamanashi",
      "tlName": "Yamanashi Prefecture",
      "moName": "Яманаши аймаг",
      "buName": "ယာမနာရှိ ပြည်နယ်",
      "khName": "ខេត្ត យ៉ាម៉ាណាស៊ី",
      "neName": "यामानासी जिल्ला"
    },
    "class10": {
      "code": "190010",
      "name": "中・西部",
      "enName": "Central Western Region",
      "chName": "山梨县中，西部",
      "zhName": "山梨縣中・西部",
      "koName": "야마나시 현 중·서부",
      "esName": "Centro-Oeste de Prefectura de Yamanashi",
      "ptName": "Região central e oeste da Província de Yamanashi",
      "thName": "จังหวัดยามานาชิตอนกลางและฟากตะวันตก",
      "viName": "Miền Trung và Tây tỉnh Yamanashi",
      "inName": "Bagian Tengah dan Barat Prefektur Yamanashi",
      "tlName": "Sentral at kanlurang bahagi ng Yamanashi Prefecture",
      "moName": "Төв・Баруун Яманаши аймаг",
      "buName": "ယမနရှိစီရင်စုအနောက်ပိုင်း၊ အလယ်ပိုင်းဒေသ",
      "khName": "តំបន់កណ្តាល/តំបន់ខាងលិចនៃខេត្តយ៉ាម៉ាណាស៊ី",
      "neName": "यामानासी जिल्लाको मध्य र पश्चिमी भाग"
    },
    "class15": {
      "code": "190012",
      "name": "峡東地域",
      "enName": "Kyoto Area"
    },
    "class20": {
      "code": "1921100",
      "name": "笛吹市",
      "enName": "Fuefuki City",
      "kana": "ふえふきし",
      "chName": "笛吹市",
      "zhName": "笛吹市",
      "koName": "후에후키 시",
      "esName": "Ciudad de Fuefuki",
      "ptName": "cidade de Fuefuki",
      "thName": "เมืองฟุเอฟุคิ",
      "viName": "thành phố Fuefuki",
      "inName": "kota Fuefuki",
      "tlName": "siyudad ng Fuefuki",
      "moName": "Фүэфүки хот",
      "buName": "ဖူးဖူကိ မြို့",
      "khName": "ទីក្រុង ហ្វាហ្វូគី",
      "neName": "फुएफुकी सहर"
    }
  },
  "1921200": {
    "office": {
      "code": "190000",
      "name": "山梨県",
      "enName": "Yamanashi",
      "officeName": "甲府地方気象台",
      "chName": "山梨县",
      "zhName": "山梨縣",
      "koName": "야마나시현",
      "esName": "Prefectura de Yamanashi",
      "ptName": "Província de Yamanashi",
      "thName": "จังหวัดยามานาชิ",
      "viName": "Tỉnh Yamanashi",
      "inName": "Prefektur Yamanashi",
      "tlName": "Yamanashi Prefecture",
      "moName": "Яманаши аймаг",
      "buName": "ယာမနာရှိ ပြည်နယ်",
      "khName": "ខេត្ត យ៉ាម៉ាណាស៊ី",
      "neName": "यामानासी जिल्ला"
    },
    "class10": {
      "code": "190020",
      "name": "東部・富士五湖",
      "enName": "Eastern Region and Fuji Five Lakes",
      "chName": "山梨县东部、富士五湖",
      "zhName": "山梨縣東部・富士五湖",
      "koName": "야마나시 현 동부 후지 고호 수",
      "esName": "Este, Fujigoko de Prefectura de Yamanashi",
      "ptName": "Região leste ・Cinco Lagos do Fuji da Província de Yamanashi",
      "thName": "จังหวัดยามานาชิฟากตะวันออก และทะเลสาบฟูจิทั้งห้า (ฟูจิโงะโกะ)",
      "viName": "Miền Đông tỉnh Yamanashi và Ngũ hồ Fuji (Fuji-goko)",
      "inName": "Bagian Timur Prefektur Yamanashi dan 5 Danau Fuji (Fuji-goko)",
      "tlName": "Silangang bahagi ng Yamanashi Prefecture at ang Limang Lawa ng Fuji (Fuji-goko)",
      "moName": "Зүүн Яманаши аймаг・ Фүжи таван нуур",
      "buName": "ယမနရှိစီရင်စု၊ အရှေ့ပိုင်းဒေသ၊ ဖူဂျီဂေါ့ရေကန်",
      "khName": "តំបន់ខាងកើត/បឹងហ្វូជីប្រាំនៃខេត្តយ៉ាម៉ាណាស៊ី",
      "neName": "यामानासी जिल्लाको पूर्वी भाग र फुजी पाँच तालहरू (फुजी-गोको)"
    },
    "class15": {
      "code": "190021",
      "name": "東部",
      "enName": "Eastern Region"
    },
    "class20": {
      "code": "1921200",
      "name": "上野原市",
      "enName": "Uenohara City",
      "kana": "うえのはらし",
      "chName": "上野原市",
      "zhName": "上野原市",
      "koName": "우에노하라 시",
      "esName": "Ciudad de Uenohara",
      "ptName": "cidade de Uenohara",
      "thName": "เมืองอุเอโนะฮาระ",
      "viName": "thành phố Uenohara",
      "inName": "kota Uenohara",
      "tlName": "siyudad ng Uenohara",
      "moName": "Үэнохaра хот",
      "buName": "အူယေးနို့ဟာ့ရ မြို့",
      "khName": "ទីក្រុង យូអ៊ីណូហារ៉ា",
      "neName": "उएनोहारा सहर"
    }
  },
  "1921300": {
    "office": {
      "code": "190000",
      "name": "山梨県",
      "enName": "Yamanashi",
      "officeName": "甲府地方気象台",
      "chName": "山梨县",
      "zhName": "山梨縣",
      "koName": "야마나시현",
      "esName": "Prefectura de Yamanashi",
      "ptName": "Província de Yamanashi",
      "thName": "จังหวัดยามานาชิ",
      "viName": "Tỉnh Yamanashi",
      "inName": "Prefektur Yamanashi",
      "tlName": "Yamanashi Prefecture",
      "moName": "Яманаши аймаг",
      "buName": "ယာမနာရှိ ပြည်နယ်",
      "khName": "ខេត្ត យ៉ាម៉ាណាស៊ី",
      "neName": "यामानासी जिल्ला"
    },
    "class10": {
      "code": "190010",
      "name": "中・西部",
      "enName": "Central Western Region",
      "chName": "山梨县中，西部",
      "zhName": "山梨縣中・西部",
      "koName": "야마나시 현 중·서부",
      "esName": "Centro-Oeste de Prefectura de Yamanashi",
      "ptName": "Região central e oeste da Província de Yamanashi",
      "thName": "จังหวัดยามานาชิตอนกลางและฟากตะวันตก",
      "viName": "Miền Trung và Tây tỉnh Yamanashi",
      "inName": "Bagian Tengah dan Barat Prefektur Yamanashi",
      "tlName": "Sentral at kanlurang bahagi ng Yamanashi Prefecture",
      "moName": "Төв・Баруун Яманаши аймаг",
      "buName": "ယမနရှိစီရင်စုအနောက်ပိုင်း၊ အလယ်ပိုင်းဒေသ",
      "khName": "តំបន់កណ្តាល/តំបន់ខាងលិចនៃខេត្តយ៉ាម៉ាណាស៊ី",
      "neName": "यामानासी जिल्लाको मध्य र पश्चिमी भाग"
    },
    "class15": {
      "code": "190012",
      "name": "峡東地域",
      "enName": "Kyoto Area"
    },
    "class20": {
      "code": "1921300",
      "name": "甲州市",
      "enName": "Koshu City",
      "kana": "こうしゅうし",
      "chName": "甲州市",
      "zhName": "甲州市",
      "koName": "고슈 시",
      "esName": "Ciudad de Kōshū",
      "ptName": "cidade de Koshu",
      "thName": "เมืองโคชู",
      "viName": "thành phố Koshu",
      "inName": "kota Koshu",
      "tlName": "siyudad ng Koshu",
      "moName": "Кошү хот",
      "buName": "ကို့ရှု မြို့",
      "khName": "ទីក្រុង គូស៊ូ",
      "neName": "कोसु सहर"
    }
  },
  "1921400": {
    "office": {
      "code": "190000",
      "name": "山梨県",
      "enName": "Yamanashi",
      "officeName": "甲府地方気象台",
      "chName": "山梨县",
      "zhName": "山梨縣",
      "koName": "야마나시현",
      "esName": "Prefectura de Yamanashi",
      "ptName": "Província de Yamanashi",
      "thName": "จังหวัดยามานาชิ",
      "viName": "Tỉnh Yamanashi",
      "inName": "Prefektur Yamanashi",
      "tlName": "Yamanashi Prefecture",
      "moName": "Яманаши аймаг",
      "buName": "ယာမနာရှိ ပြည်နယ်",
      "khName": "ខេត្ត យ៉ាម៉ាណាស៊ី",
      "neName": "यामानासी जिल्ला"
    },
    "class10": {
      "code": "190010",
      "name": "中・西部",
      "enName": "Central Western Region",
      "chName": "山梨县中，西部",
      "zhName": "山梨縣中・西部",
      "koName": "야마나시 현 중·서부",
      "esName": "Centro-Oeste de Prefectura de Yamanashi",
      "ptName": "Região central e oeste da Província de Yamanashi",
      "thName": "จังหวัดยามานาชิตอนกลางและฟากตะวันตก",
      "viName": "Miền Trung và Tây tỉnh Yamanashi",
      "inName": "Bagian Tengah dan Barat Prefektur Yamanashi",
      "tlName": "Sentral at kanlurang bahagi ng Yamanashi Prefecture",
      "moName": "Төв・Баруун Яманаши аймаг",
      "buName": "ယမနရှိစီရင်စုအနောက်ပိုင်း၊ အလယ်ပိုင်းဒေသ",
      "khName": "តំបន់កណ្តាល/តំបន់ខាងលិចនៃខេត្តយ៉ាម៉ាណាស៊ី",
      "neName": "यामानासी जिल्लाको मध्य र पश्चिमी भाग"
    },
    "class15": {
      "code": "190011",
      "name": "中北地域",
      "enName": "Chuhoku Area"
    },
    "class20": {
      "code": "1921400",
      "name": "中央市",
      "enName": "Chuo City",
      "kana": "ちゅうおうし",
      "chName": "中央市",
      "zhName": "中央市",
      "koName": "주오시",
      "esName": "Ciudad de Chūō",
      "ptName": "cidade de Chuo",
      "thName": "เมืองชูโอะ",
      "viName": "thành phố Chuo",
      "inName": "kota Chuo",
      "tlName": "siyudad ng Chuo",
      "moName": "Чүо хот",
      "buName": "ကျုအော့ မြို့",
      "khName": "ទីក្រុង ឈូអូ",
      "neName": "च्युओ सहर"
    }
  },
  "1934600": {
    "office": {
      "code": "190000",
      "name": "山梨県",
      "enName": "Yamanashi",
      "officeName": "甲府地方気象台",
      "chName": "山梨县",
      "zhName": "山梨縣",
      "koName": "야마나시현",
      "esName": "Prefectura de Yamanashi",
      "ptName": "Província de Yamanashi",
      "thName": "จังหวัดยามานาชิ",
      "viName": "Tỉnh Yamanashi",
      "inName": "Prefektur Yamanashi",
      "tlName": "Yamanashi Prefecture",
      "moName": "Яманаши аймаг",
      "buName": "ယာမနာရှိ ပြည်နယ်",
      "khName": "ខេត្ត យ៉ាម៉ាណាស៊ី",
      "neName": "यामानासी जिल्ला"
    },
    "class10": {
      "code": "190010",
      "name": "中・西部",
      "enName": "Central Western Region",
      "chName": "山梨县中，西部",
      "zhName": "山梨縣中・西部",
      "koName": "야마나시 현 중·서부",
      "esName": "Centro-Oeste de Prefectura de Yamanashi",
      "ptName": "Região central e oeste da Província de Yamanashi",
      "thName": "จังหวัดยามานาชิตอนกลางและฟากตะวันตก",
      "viName": "Miền Trung và Tây tỉnh Yamanashi",
      "inName": "Bagian Tengah dan Barat Prefektur Yamanashi",
      "tlName": "Sentral at kanlurang bahagi ng Yamanashi Prefecture",
      "moName": "Төв・Баруун Яманаши аймаг",
      "buName": "ယမနရှိစီရင်စုအနောက်ပိုင်း၊ အလယ်ပိုင်းဒေသ",
      "khName": "តំបន់កណ្តាល/តំបន់ខាងលិចនៃខេត្តយ៉ាម៉ាណាស៊ី",
      "neName": "यामानासी जिल्लाको मध्य र पश्चिमी भाग"
    },
    "class15": {
      "code": "190013",
      "name": "峡南地域",
      "enName": "Kyonan Area"
    },
    "class20": {
      "code": "1934600",
      "name": "市川三郷町",
      "enName": "Ichikawamisato Town",
      "kana": "いちかわみさとちょう",
      "chName": "市川三乡町",
      "zhName": "市川三鄉町",
      "koName": "이치카와미사토 정",
      "esName": "Pueblo de Ichikawa-misato",
      "ptName": "bairro de Ichikawamisato",
      "thName": "เมืองอิชิคาวามิซาโตะ",
      "viName": "thị trấn Ichikawamisato",
      "inName": "kota Ichikawamisato",
      "tlName": "bayan ng Ichikawamisato",
      "moName": "Ичикавамисaто жижиг хот",
      "buName": "အီကျိကာဝါမိဆာ့တော့ မြို့နယ်",
      "khName": "ទីប្រជុំជន អ៊ីឈីកាវ៉ាមីសាតូ",
      "neName": "इचिकावामिसातो नगर"
    }
  },
  "1936400": {
    "office": {
      "code": "190000",
      "name": "山梨県",
      "enName": "Yamanashi",
      "officeName": "甲府地方気象台",
      "chName": "山梨县",
      "zhName": "山梨縣",
      "koName": "야마나시현",
      "esName": "Prefectura de Yamanashi",
      "ptName": "Província de Yamanashi",
      "thName": "จังหวัดยามานาชิ",
      "viName": "Tỉnh Yamanashi",
      "inName": "Prefektur Yamanashi",
      "tlName": "Yamanashi Prefecture",
      "moName": "Яманаши аймаг",
      "buName": "ယာမနာရှိ ပြည်နယ်",
      "khName": "ខេត្ត យ៉ាម៉ាណាស៊ី",
      "neName": "यामानासी जिल्ला"
    },
    "class10": {
      "code": "190010",
      "name": "中・西部",
      "enName": "Central Western Region",
      "chName": "山梨县中，西部",
      "zhName": "山梨縣中・西部",
      "koName": "야마나시 현 중·서부",
      "esName": "Centro-Oeste de Prefectura de Yamanashi",
      "ptName": "Região central e oeste da Província de Yamanashi",
      "thName": "จังหวัดยามานาชิตอนกลางและฟากตะวันตก",
      "viName": "Miền Trung và Tây tỉnh Yamanashi",
      "inName": "Bagian Tengah dan Barat Prefektur Yamanashi",
      "tlName": "Sentral at kanlurang bahagi ng Yamanashi Prefecture",
      "moName": "Төв・Баруун Яманаши аймаг",
      "buName": "ယမနရှိစီရင်စုအနောက်ပိုင်း၊ အလယ်ပိုင်းဒေသ",
      "khName": "តំបន់កណ្តាល/តំបន់ខាងលិចនៃខេត្តយ៉ាម៉ាណាស៊ី",
      "neName": "यामानासी जिल्लाको मध्य र पश्चिमी भाग"
    },
    "class15": {
      "code": "190013",
      "name": "峡南地域",
      "enName": "Kyonan Area"
    },
    "class20": {
      "code": "1936400",
      "name": "早川町",
      "enName": "Hayakawa Town",
      "kana": "はやかわちょう",
      "chName": "早川町",
      "zhName": "早川町",
      "koName": "하야카와 정",
      "esName": "Pueblo de Hayakawa",
      "ptName": "bairro de Hayakawa",
      "thName": "เมืองฮายาคาวา",
      "viName": "thị trấn Hayakawa",
      "inName": "kota Hayakawa",
      "tlName": "bayan ng Hayakawa",
      "moName": "Хаякава жижиг хот",
      "buName": "ဟာယာကာ့ဝ မြို့နယ်",
      "khName": "ទីប្រជុំជន ហៃយ៉ាកាវ៉ា",
      "neName": "हायाकावा नगर"
    }
  },
  "1936500": {
    "office": {
      "code": "190000",
      "name": "山梨県",
      "enName": "Yamanashi",
      "officeName": "甲府地方気象台",
      "chName": "山梨县",
      "zhName": "山梨縣",
      "koName": "야마나시현",
      "esName": "Prefectura de Yamanashi",
      "ptName": "Província de Yamanashi",
      "thName": "จังหวัดยามานาชิ",
      "viName": "Tỉnh Yamanashi",
      "inName": "Prefektur Yamanashi",
      "tlName": "Yamanashi Prefecture",
      "moName": "Яманаши аймаг",
      "buName": "ယာမနာရှိ ပြည်နယ်",
      "khName": "ខេត្ត យ៉ាម៉ាណាស៊ី",
      "neName": "यामानासी जिल्ला"
    },
    "class10": {
      "code": "190010",
      "name": "中・西部",
      "enName": "Central Western Region",
      "chName": "山梨县中，西部",
      "zhName": "山梨縣中・西部",
      "koName": "야마나시 현 중·서부",
      "esName": "Centro-Oeste de Prefectura de Yamanashi",
      "ptName": "Região central e oeste da Província de Yamanashi",
      "thName": "จังหวัดยามานาชิตอนกลางและฟากตะวันตก",
      "viName": "Miền Trung và Tây tỉnh Yamanashi",
      "inName": "Bagian Tengah dan Barat Prefektur Yamanashi",
      "tlName": "Sentral at kanlurang bahagi ng Yamanashi Prefecture",
      "moName": "Төв・Баруун Яманаши аймаг",
      "buName": "ယမနရှိစီရင်စုအနောက်ပိုင်း၊ အလယ်ပိုင်းဒေသ",
      "khName": "តំបន់កណ្តាល/តំបន់ខាងលិចនៃខេត្តយ៉ាម៉ាណាស៊ី",
      "neName": "यामानासी जिल्लाको मध्य र पश्चिमी भाग"
    },
    "class15": {
      "code": "190013",
      "name": "峡南地域",
      "enName": "Kyonan Area"
    },
    "class20": {
      "code": "1936500",
      "name": "身延町",
      "enName": "Minobu Town",
      "kana": "みのぶちょう",
      "chName": "身延町",
      "zhName": "身延町",
      "koName": "미노부 정",
      "esName": "Pueblo de Minobu",
      "ptName": "bairro de Minobu",
      "thName": "เมืองมิโนะบุ",
      "viName": "thị trấn Minobu",
      "inName": "kota Minobu",
      "tlName": "bayan ng Minobu",
      "moName": "Минобү жижиг хот",
      "buName": "မိနောဗု မြို့နယ်",
      "khName": "ទីប្រជុំជន មីណូប៊ុ",
      "neName": "मिनोबु नगर"
    }
  },
  "1936600": {
    "office": {
      "code": "190000",
      "name": "山梨県",
      "enName": "Yamanashi",
      "officeName": "甲府地方気象台",
      "chName": "山梨县",
      "zhName": "山梨縣",
      "koName": "야마나시현",
      "esName": "Prefectura de Yamanashi",
      "ptName": "Província de Yamanashi",
      "thName": "จังหวัดยามานาชิ",
      "viName": "Tỉnh Yamanashi",
      "inName": "Prefektur Yamanashi",
      "tlName": "Yamanashi Prefecture",
      "moName": "Яманаши аймаг",
      "buName": "ယာမနာရှိ ပြည်နယ်",
      "khName": "ខេត្ត យ៉ាម៉ាណាស៊ី",
      "neName": "यामानासी जिल्ला"
    },
    "class10": {
      "code": "190010",
      "name": "中・西部",
      "enName": "Central Western Region",
      "chName": "山梨县中，西部",
      "zhName": "山梨縣中・西部",
      "koName": "야마나시 현 중·서부",
      "esName": "Centro-Oeste de Prefectura de Yamanashi",
      "ptName": "Região central e oeste da Província de Yamanashi",
      "thName": "จังหวัดยามานาชิตอนกลางและฟากตะวันตก",
      "viName": "Miền Trung và Tây tỉnh Yamanashi",
      "inName": "Bagian Tengah dan Barat Prefektur Yamanashi",
      "tlName": "Sentral at kanlurang bahagi ng Yamanashi Prefecture",
      "moName": "Төв・Баруун Яманаши аймаг",
      "buName": "ယမနရှိစီရင်စုအနောက်ပိုင်း၊ အလယ်ပိုင်းဒေသ",
      "khName": "តំបន់កណ្តាល/តំបន់ខាងលិចនៃខេត្តយ៉ាម៉ាណាស៊ី",
      "neName": "यामानासी जिल्लाको मध्य र पश्चिमी भाग"
    },
    "class15": {
      "code": "190013",
      "name": "峡南地域",
      "enName": "Kyonan Area"
    },
    "class20": {
      "code": "1936600",
      "name": "南部町",
      "enName": "Nambu Town",
      "kana": "なんぶちょう",
      "chName": "山梨南部町",
      "zhName": "山梨南部町",
      "koName": "야마나시 난부 정",
      "esName": "Pueblo de Nambu, Yamanashi",
      "ptName": "Yamanashi, bairro de Nambu",
      "thName": "เมืองนัมบุ ยามานาชิ",
      "viName": "Thị trấn Nambu, Yamanashi",
      "inName": "Kota Nambu, Yamanashi",
      "tlName": "bayan ng Nanbu, Yamanashi",
      "moName": "Яманаши Намбу жижиг хот",
      "buName": "ယမနရှိဟိုနန်းဘုမြို့နယ်",
      "khName": "ទីប្រជុំជនណាំប៊ូ យ៉ាម៉ាណាស៊ី",
      "neName": "यामानासी नाम्बु नगर"
    }
  },
  "1936800": {
    "office": {
      "code": "190000",
      "name": "山梨県",
      "enName": "Yamanashi",
      "officeName": "甲府地方気象台",
      "chName": "山梨县",
      "zhName": "山梨縣",
      "koName": "야마나시현",
      "esName": "Prefectura de Yamanashi",
      "ptName": "Província de Yamanashi",
      "thName": "จังหวัดยามานาชิ",
      "viName": "Tỉnh Yamanashi",
      "inName": "Prefektur Yamanashi",
      "tlName": "Yamanashi Prefecture",
      "moName": "Яманаши аймаг",
      "buName": "ယာမနာရှိ ပြည်နယ်",
      "khName": "ខេត្ត យ៉ាម៉ាណាស៊ី",
      "neName": "यामानासी जिल्ला"
    },
    "class10": {
      "code": "190010",
      "name": "中・西部",
      "enName": "Central Western Region",
      "chName": "山梨县中，西部",
      "zhName": "山梨縣中・西部",
      "koName": "야마나시 현 중·서부",
      "esName": "Centro-Oeste de Prefectura de Yamanashi",
      "ptName": "Região central e oeste da Província de Yamanashi",
      "thName": "จังหวัดยามานาชิตอนกลางและฟากตะวันตก",
      "viName": "Miền Trung và Tây tỉnh Yamanashi",
      "inName": "Bagian Tengah dan Barat Prefektur Yamanashi",
      "tlName": "Sentral at kanlurang bahagi ng Yamanashi Prefecture",
      "moName": "Төв・Баруун Яманаши аймаг",
      "buName": "ယမနရှိစီရင်စုအနောက်ပိုင်း၊ အလယ်ပိုင်းဒေသ",
      "khName": "តំបន់កណ្តាល/តំបន់ខាងលិចនៃខេត្តយ៉ាម៉ាណាស៊ី",
      "neName": "यामानासी जिल्लाको मध्य र पश्चिमी भाग"
    },
    "class15": {
      "code": "190013",
      "name": "峡南地域",
      "enName": "Kyonan Area"
    },
    "class20": {
      "code": "1936800",
      "name": "富士川町",
      "enName": "Fujikawa Town",
      "kana": "ふじかわちょう",
      "chName": "富士川町",
      "zhName": "富士川町",
      "koName": "후지카와 정",
      "esName": "Pueblo de Fujikawa",
      "ptName": "bairro de Fujikawa",
      "thName": "เมืองฟุจิคาวะ",
      "viName": "thị trấn Fujikawa",
      "inName": "kota Fujikawa",
      "tlName": "bayan ng Fujikawa",
      "moName": "Фүжикава жижиг хот",
      "buName": "ဟူဂျိကာ့ဝ မြို့နယ်",
      "khName": "ទីប្រជុំជន ហ្វូជីកាវ៉ា",
      "neName": "फुजिकावा नगर"
    }
  },
  "1938400": {
    "office": {
      "code": "190000",
      "name": "山梨県",
      "enName": "Yamanashi",
      "officeName": "甲府地方気象台",
      "chName": "山梨县",
      "zhName": "山梨縣",
      "koName": "야마나시현",
      "esName": "Prefectura de Yamanashi",
      "ptName": "Província de Yamanashi",
      "thName": "จังหวัดยามานาชิ",
      "viName": "Tỉnh Yamanashi",
      "inName": "Prefektur Yamanashi",
      "tlName": "Yamanashi Prefecture",
      "moName": "Яманаши аймаг",
      "buName": "ယာမနာရှိ ပြည်နယ်",
      "khName": "ខេត្ត យ៉ាម៉ាណាស៊ី",
      "neName": "यामानासी जिल्ला"
    },
    "class10": {
      "code": "190010",
      "name": "中・西部",
      "enName": "Central Western Region",
      "chName": "山梨县中，西部",
      "zhName": "山梨縣中・西部",
      "koName": "야마나시 현 중·서부",
      "esName": "Centro-Oeste de Prefectura de Yamanashi",
      "ptName": "Região central e oeste da Província de Yamanashi",
      "thName": "จังหวัดยามานาชิตอนกลางและฟากตะวันตก",
      "viName": "Miền Trung và Tây tỉnh Yamanashi",
      "inName": "Bagian Tengah dan Barat Prefektur Yamanashi",
      "tlName": "Sentral at kanlurang bahagi ng Yamanashi Prefecture",
      "moName": "Төв・Баруун Яманаши аймаг",
      "buName": "ယမနရှိစီရင်စုအနောက်ပိုင်း၊ အလယ်ပိုင်းဒေသ",
      "khName": "តំបន់កណ្តាល/តំបន់ខាងលិចនៃខេត្តយ៉ាម៉ាណាស៊ី",
      "neName": "यामानासी जिल्लाको मध्य र पश्चिमी भाग"
    },
    "class15": {
      "code": "190011",
      "name": "中北地域",
      "enName": "Chuhoku Area"
    },
    "class20": {
      "code": "1938400",
      "name": "昭和町",
      "enName": "Showa Town",
      "kana": "しょうわちょう",
      "chName": "昭和町",
      "zhName": "昭和町",
      "koName": "쇼와 정",
      "esName": "Pueblo de Showa",
      "ptName": "bairro de Showa",
      "thName": "เมืองโชวะ",
      "viName": "thị trấn Showa",
      "inName": "kota Showa",
      "tlName": "bayan ng Showa",
      "moName": "Шова жижиг хот",
      "buName": "ရှောဝ မြို့နယ်",
      "khName": "ទីប្រជុំជន សូវ៉ា",
      "neName": "शोवा नगर"
    }
  },
  "1942200": {
    "office": {
      "code": "190000",
      "name": "山梨県",
      "enName": "Yamanashi",
      "officeName": "甲府地方気象台",
      "chName": "山梨县",
      "zhName": "山梨縣",
      "koName": "야마나시현",
      "esName": "Prefectura de Yamanashi",
      "ptName": "Província de Yamanashi",
      "thName": "จังหวัดยามานาชิ",
      "viName": "Tỉnh Yamanashi",
      "inName": "Prefektur Yamanashi",
      "tlName": "Yamanashi Prefecture",
      "moName": "Яманаши аймаг",
      "buName": "ယာမနာရှိ ပြည်နယ်",
      "khName": "ខេត្ត យ៉ាម៉ាណាស៊ី",
      "neName": "यामानासी जिल्ला"
    },
    "class10": {
      "code": "190020",
      "name": "東部・富士五湖",
      "enName": "Eastern Region and Fuji Five Lakes",
      "chName": "山梨县东部、富士五湖",
      "zhName": "山梨縣東部・富士五湖",
      "koName": "야마나시 현 동부 후지 고호 수",
      "esName": "Este, Fujigoko de Prefectura de Yamanashi",
      "ptName": "Região leste ・Cinco Lagos do Fuji da Província de Yamanashi",
      "thName": "จังหวัดยามานาชิฟากตะวันออก และทะเลสาบฟูจิทั้งห้า (ฟูจิโงะโกะ)",
      "viName": "Miền Đông tỉnh Yamanashi và Ngũ hồ Fuji (Fuji-goko)",
      "inName": "Bagian Timur Prefektur Yamanashi dan 5 Danau Fuji (Fuji-goko)",
      "tlName": "Silangang bahagi ng Yamanashi Prefecture at ang Limang Lawa ng Fuji (Fuji-goko)",
      "moName": "Зүүн Яманаши аймаг・ Фүжи таван нуур",
      "buName": "ယမနရှိစီရင်စု၊ အရှေ့ပိုင်းဒေသ၊ ဖူဂျီဂေါ့ရေကန်",
      "khName": "តំបន់ខាងកើត/បឹងហ្វូជីប្រាំនៃខេត្តយ៉ាម៉ាណាស៊ី",
      "neName": "यामानासी जिल्लाको पूर्वी भाग र फुजी पाँच तालहरू (फुजी-गोको)"
    },
    "class15": {
      "code": "190021",
      "name": "東部",
      "enName": "Eastern Region"
    },
    "class20": {
      "code": "1942200",
      "name": "道志村",
      "enName": "Doshi Village",
      "kana": "どうしむら",
      "chName": "道志村",
      "zhName": "道志村",
      "koName": "도시 촌",
      "esName": "Aldea de Doshi",
      "ptName": "povoado de Doshi",
      "thName": "หมู่บ้านโดชิ",
      "viName": "làng Doshi",
      "inName": "desa Doshi",
      "tlName": "nayon ng Doshi",
      "moName": "Доши тосгон",
      "buName": "ဒိုးရှိ ကျေးရွာ",
      "khName": "ភូមិ ដូស៊ី",
      "neName": "दोशी गाउँ"
    }
  },
  "1942300": {
    "office": {
      "code": "190000",
      "name": "山梨県",
      "enName": "Yamanashi",
      "officeName": "甲府地方気象台",
      "chName": "山梨县",
      "zhName": "山梨縣",
      "koName": "야마나시현",
      "esName": "Prefectura de Yamanashi",
      "ptName": "Província de Yamanashi",
      "thName": "จังหวัดยามานาชิ",
      "viName": "Tỉnh Yamanashi",
      "inName": "Prefektur Yamanashi",
      "tlName": "Yamanashi Prefecture",
      "moName": "Яманаши аймаг",
      "buName": "ယာမနာရှိ ပြည်နယ်",
      "khName": "ខេត្ត យ៉ាម៉ាណាស៊ី",
      "neName": "यामानासी जिल्ला"
    },
    "class10": {
      "code": "190020",
      "name": "東部・富士五湖",
      "enName": "Eastern Region and Fuji Five Lakes",
      "chName": "山梨县东部、富士五湖",
      "zhName": "山梨縣東部・富士五湖",
      "koName": "야마나시 현 동부 후지 고호 수",
      "esName": "Este, Fujigoko de Prefectura de Yamanashi",
      "ptName": "Região leste ・Cinco Lagos do Fuji da Província de Yamanashi",
      "thName": "จังหวัดยามานาชิฟากตะวันออก และทะเลสาบฟูจิทั้งห้า (ฟูจิโงะโกะ)",
      "viName": "Miền Đông tỉnh Yamanashi và Ngũ hồ Fuji (Fuji-goko)",
      "inName": "Bagian Timur Prefektur Yamanashi dan 5 Danau Fuji (Fuji-goko)",
      "tlName": "Silangang bahagi ng Yamanashi Prefecture at ang Limang Lawa ng Fuji (Fuji-goko)",
      "moName": "Зүүн Яманаши аймаг・ Фүжи таван нуур",
      "buName": "ယမနရှိစီရင်စု၊ အရှေ့ပိုင်းဒေသ၊ ဖူဂျီဂေါ့ရေကန်",
      "khName": "តំបន់ខាងកើត/បឹងហ្វូជីប្រាំនៃខេត្តយ៉ាម៉ាណាស៊ី",
      "neName": "यामानासी जिल्लाको पूर्वी भाग र फुजी पाँच तालहरू (फुजी-गोको)"
    },
    "class15": {
      "code": "190022",
      "name": "富士五湖",
      "enName": "Fuji Five Lakes"
    },
    "class20": {
      "code": "1942300",
      "name": "西桂町",
      "enName": "Nishikatsura Town",
      "kana": "にしかつらちょう",
      "chName": "西桂町",
      "zhName": "西桂町",
      "koName": "니시카쓰라 정",
      "esName": "Pueblo de Nishikatsura",
      "ptName": "bairro de Nishikatsura",
      "thName": "เมืองนิชิคัตสึระ",
      "viName": "thị trấn Nishikatsura",
      "inName": "kota Nishikatsura",
      "tlName": "bayan ng Nishikatsura",
      "moName": "Нишикацүра жижиг хот",
      "buName": "နီရှိကာဆုရ မြို့နယ်",
      "khName": "ទីប្រជុំជន នីសស៊ីកាស៊ូរ៉ា",
      "neName": "निशिकात्सुरा नगर"
    }
  },
  "1942400": {
    "office": {
      "code": "190000",
      "name": "山梨県",
      "enName": "Yamanashi",
      "officeName": "甲府地方気象台",
      "chName": "山梨县",
      "zhName": "山梨縣",
      "koName": "야마나시현",
      "esName": "Prefectura de Yamanashi",
      "ptName": "Província de Yamanashi",
      "thName": "จังหวัดยามานาชิ",
      "viName": "Tỉnh Yamanashi",
      "inName": "Prefektur Yamanashi",
      "tlName": "Yamanashi Prefecture",
      "moName": "Яманаши аймаг",
      "buName": "ယာမနာရှိ ပြည်နယ်",
      "khName": "ខេត្ត យ៉ាម៉ាណាស៊ី",
      "neName": "यामानासी जिल्ला"
    },
    "class10": {
      "code": "190020",
      "name": "東部・富士五湖",
      "enName": "Eastern Region and Fuji Five Lakes",
      "chName": "山梨县东部、富士五湖",
      "zhName": "山梨縣東部・富士五湖",
      "koName": "야마나시 현 동부 후지 고호 수",
      "esName": "Este, Fujigoko de Prefectura de Yamanashi",
      "ptName": "Região leste ・Cinco Lagos do Fuji da Província de Yamanashi",
      "thName": "จังหวัดยามานาชิฟากตะวันออก และทะเลสาบฟูจิทั้งห้า (ฟูจิโงะโกะ)",
      "viName": "Miền Đông tỉnh Yamanashi và Ngũ hồ Fuji (Fuji-goko)",
      "inName": "Bagian Timur Prefektur Yamanashi dan 5 Danau Fuji (Fuji-goko)",
      "tlName": "Silangang bahagi ng Yamanashi Prefecture at ang Limang Lawa ng Fuji (Fuji-goko)",
      "moName": "Зүүн Яманаши аймаг・ Фүжи таван нуур",
      "buName": "ယမနရှိစီရင်စု၊ အရှေ့ပိုင်းဒေသ၊ ဖူဂျီဂေါ့ရေကန်",
      "khName": "តំបន់ខាងកើត/បឹងហ្វូជីប្រាំនៃខេត្តយ៉ាម៉ាណាស៊ី",
      "neName": "यामानासी जिल्लाको पूर्वी भाग र फुजी पाँच तालहरू (फुजी-गोको)"
    },
    "class15": {
      "code": "190022",
      "name": "富士五湖",
      "enName": "Fuji Five Lakes"
    },
    "class20": {
      "code": "1942400",
      "name": "忍野村",
      "enName": "Oshino Village",
      "kana": "おし���むら",
      "chName": "忍野村",
      "zhName": "忍野村",
      "koName": "오시노 촌",
      "esName": "Aldea de Oshino",
      "ptName": "povoado de Oshino",
      "thName": "หมู่บ้านโอชิโนะ",
      "viName": "làng Oshino",
      "inName": "desa Oshino",
      "tlName": "nayon ng Oshino",
      "moName": "Ошино тосгон",
      "buName": "အိုရှိနို ကျေးရွာ",
      "khName": "ភូមិ អូស៊ីណូ",
      "neName": "ओशिनो गाउँ"
    }
  },
  "1942500": {
    "office": {
      "code": "190000",
      "name": "山梨県",
      "enName": "Yamanashi",
      "officeName": "甲府地方気象台",
      "chName": "山梨县",
      "zhName": "山梨縣",
      "koName": "야마나시현",
      "esName": "Prefectura de Yamanashi",
      "ptName": "Província de Yamanashi",
      "thName": "จังหวัดยามานาชิ",
      "viName": "Tỉnh Yamanashi",
      "inName": "Prefektur Yamanashi",
      "tlName": "Yamanashi Prefecture",
      "moName": "Яманаши аймаг",
      "buName": "ယာမနာရှိ ပြည်နယ်",
      "khName": "ខេត្ត យ៉ាម៉ាណាស៊ី",
      "neName": "यामानासी जिल्ला"
    },
    "class10": {
      "code": "190020",
      "name": "東部・富士五湖",
      "enName": "Eastern Region and Fuji Five Lakes",
      "chName": "山梨县东部、富士五湖",
      "zhName": "山梨縣東部・富士五湖",
      "koName": "야마나시 현 동부 후지 고호 수",
      "esName": "Este, Fujigoko de Prefectura de Yamanashi",
      "ptName": "Região leste ・Cinco Lagos do Fuji da Província de Yamanashi",
      "thName": "จังหวัดยามานาชิฟากตะวันออก และทะเลสาบฟูจิทั้งห้า (ฟูจิโงะโกะ)",
      "viName": "Miền Đông tỉnh Yamanashi và Ngũ hồ Fuji (Fuji-goko)",
      "inName": "Bagian Timur Prefektur Yamanashi dan 5 Danau Fuji (Fuji-goko)",
      "tlName": "Silangang bahagi ng Yamanashi Prefecture at ang Limang Lawa ng Fuji (Fuji-goko)",
      "moName": "Зүүн Яманаши аймаг・ Фүжи таван нуур",
      "buName": "ယမနရှိစီရင်စု၊ အရှေ့ပိုင်းဒေသ၊ ဖူဂျီဂေါ့ရေကန်",
      "khName": "តំបន់ខាងកើត/បឹងហ្វូជីប្រាំនៃខេត្តយ៉ាម៉ាណាស៊ី",
      "neName": "यामानासी जिल्लाको पूर्वी भाग र फुजी पाँच तालहरू (फुजी-गोको)"
    },
    "class15": {
      "code": "190022",
      "name": "富士五湖",
      "enName": "Fuji Five Lakes"
    },
    "class20": {
      "code": "1942500",
      "name": "山中湖村",
      "enName": "Yamanakako Village",
      "kana": "やまなかこむら",
      "chName": "山中湖村",
      "zhName": "山中湖村",
      "koName": "야마나카코 촌",
      "esName": "Aldea de Yamanakako",
      "ptName": "povoado de Yamanakako",
      "thName": "หมู่บ้านโยมานาคาโกะ",
      "viName": "làng Yamanakako",
      "inName": "desa Yamanakako",
      "tlName": "nayon ng Yamanakako",
      "moName": "Ямaнaкако тосгон",
      "buName": "ယာမာနာကာကို ကျေးရွာ",
      "khName": "ភូមិ យ៉ាម៉ាណាកាកូ",
      "neName": "यामानाकाको गाउँ"
    }
  },
  "1942900": {
    "office": {
      "code": "190000",
      "name": "山梨県",
      "enName": "Yamanashi",
      "officeName": "甲府地方気象台",
      "chName": "山梨县",
      "zhName": "山梨縣",
      "koName": "야마나시현",
      "esName": "Prefectura de Yamanashi",
      "ptName": "Província de Yamanashi",
      "thName": "จังหวัดยามานาชิ",
      "viName": "Tỉnh Yamanashi",
      "inName": "Prefektur Yamanashi",
      "tlName": "Yamanashi Prefecture",
      "moName": "Яманаши аймаг",
      "buName": "ယာမနာရှိ ပြည်နယ်",
      "khName": "ខេត្ត យ៉ាម៉ាណាស៊ី",
      "neName": "यामानासी जिल्ला"
    },
    "class10": {
      "code": "190020",
      "name": "東部・富士五湖",
      "enName": "Eastern Region and Fuji Five Lakes",
      "chName": "山梨县东部、富士五湖",
      "zhName": "山梨縣東部・富士五湖",
      "koName": "야마나시 현 동부 후지 고호 수",
      "esName": "Este, Fujigoko de Prefectura de Yamanashi",
      "ptName": "Região leste ・Cinco Lagos do Fuji da Província de Yamanashi",
      "thName": "จังหวัดยามานาชิฟากตะวันออก และทะเลสาบฟูจิทั้งห้า (ฟูจิโงะโกะ)",
      "viName": "Miền Đông tỉnh Yamanashi và Ngũ hồ Fuji (Fuji-goko)",
      "inName": "Bagian Timur Prefektur Yamanashi dan 5 Danau Fuji (Fuji-goko)",
      "tlName": "Silangang bahagi ng Yamanashi Prefecture at ang Limang Lawa ng Fuji (Fuji-goko)",
      "moName": "Зүүн Яманаши аймаг・ Фүжи таван нуур",
      "buName": "ယမနရှိစီရင်စု၊ အရှေ့ပိုင်းဒေသ၊ ဖူဂျီဂေါ့ရေကန်",
      "khName": "តំបន់ខាងកើត/បឹងហ្វូជីប្រាំនៃខេត្តយ៉ាម៉ាណាស៊ី",
      "neName": "यामानासी जिल्लाको पूर्वी भाग र फुजी पाँच तालहरू (फुजी-गोको)"
    },
    "class15": {
      "code": "190022",
      "name": "富士五湖",
      "enName": "Fuji Five Lakes"
    },
    "class20": {
      "code": "1942900",
      "name": "鳴沢村",
      "enName": "Narusawa Village",
      "kana": "なるさわむら",
      "chName": "鸣泽村",
      "zhName": "鳴澤村",
      "koName": "나루사와 촌",
      "esName": "Aldea de Narusawa",
      "ptName": "povoado de Narusawa",
      "thName": "หมู่บ้านนารุซาวะ",
      "viName": "làng Narusawa",
      "inName": "desa Narusawa",
      "tlName": "nayon ng Narusawa",
      "moName": "Нaрүсава тосгон",
      "buName": "နာရုဆာ့ဝ ကျေးရွာ",
      "khName": "ភូមិ ណារូសាវ៉ា",
      "neName": "नारुसावा गाउँ"
    }
  },
  "1943000": {
    "office": {
      "code": "190000",
      "name": "山梨県",
      "enName": "Yamanashi",
      "officeName": "甲府地方気象台",
      "chName": "山梨县",
      "zhName": "山梨縣",
      "koName": "야마나시현",
      "esName": "Prefectura de Yamanashi",
      "ptName": "Província de Yamanashi",
      "thName": "จังหวัดยามานาชิ",
      "viName": "Tỉnh Yamanashi",
      "inName": "Prefektur Yamanashi",
      "tlName": "Yamanashi Prefecture",
      "moName": "Яманаши аймаг",
      "buName": "ယာမနာရှိ ပြည်နယ်",
      "khName": "ខេត្ត យ៉ាម៉ាណាស៊ី",
      "neName": "यामानासी जिल्ला"
    },
    "class10": {
      "code": "190020",
      "name": "東部・富士五湖",
      "enName": "Eastern Region and Fuji Five Lakes",
      "chName": "山梨县东部、富士五湖",
      "zhName": "山梨縣東部・富士五湖",
      "koName": "야마나시 현 동부 후지 고호 수",
      "esName": "Este, Fujigoko de Prefectura de Yamanashi",
      "ptName": "Região leste ・Cinco Lagos do Fuji da Província de Yamanashi",
      "thName": "จังหวัดยามานาชิฟากตะวันออก และทะเลสาบฟูจิทั้งห้า (ฟูจิโงะโกะ)",
      "viName": "Miền Đông tỉnh Yamanashi và Ngũ hồ Fuji (Fuji-goko)",
      "inName": "Bagian Timur Prefektur Yamanashi dan 5 Danau Fuji (Fuji-goko)",
      "tlName": "Silangang bahagi ng Yamanashi Prefecture at ang Limang Lawa ng Fuji (Fuji-goko)",
      "moName": "Зүүн Яманаши аймаг・ Фүжи таван нуур",
      "buName": "ယမနရှိစီရင်စု၊ အရှေ့ပိုင်းဒေသ၊ ဖူဂျီဂေါ့ရေကန်",
      "khName": "តំបន់ខាងកើត/បឹងហ្វូជីប្រាំនៃខេត្តយ៉ាម៉ាណាស៊ី",
      "neName": "यामानासी जिल्लाको पूर्वी भाग र फुजी पाँच तालहरू (फुजी-गोको)"
    },
    "class15": {
      "code": "190022",
      "name": "富士五湖",
      "enName": "Fuji Five Lakes"
    },
    "class20": {
      "code": "1943000",
      "name": "富士河口湖町",
      "enName": "Fujikawaguchiko Town",
      "kana": "ふじかわぐちこまち",
      "chName": "富士河口湖町",
      "zhName": "富士河口湖町",
      "koName": "후지카와구치코 정",
      "esName": "Pueblo de Fuji-kawaguchiko",
      "ptName": "bairro de Fujikawaguchiko",
      "thName": "เมืองฟุจิคาวาคุจิโกะ",
      "viName": "thị trấn Fujikawaguchiko",
      "inName": "kota Fujikawaguchiko",
      "tlName": "bayan ng Fujikawaguchiko",
      "moName": "Фүжикавагүчико жижиг хот",
      "buName": "ဟူဂျိကာဝါဂုကျကော့ မြို့နယ်",
      "khName": "ទីប្រជុំជន ហ្វូជីកាវ៉ាហ្កូជីកូ",
      "neName": "फुजिकावागुचिको नगर"
    }
  },
  "1944200": {
    "office": {
      "code": "190000",
      "name": "山梨県",
      "enName": "Yamanashi",
      "officeName": "甲府地方気象台",
      "chName": "山梨县",
      "zhName": "山梨縣",
      "koName": "야마나시현",
      "esName": "Prefectura de Yamanashi",
      "ptName": "Província de Yamanashi",
      "thName": "จังหวัดยามานาชิ",
      "viName": "Tỉnh Yamanashi",
      "inName": "Prefektur Yamanashi",
      "tlName": "Yamanashi Prefecture",
      "moName": "Яманаши аймаг",
      "buName": "ယာမနာရှိ ပြည်နယ်",
      "khName": "ខេត្ត យ៉ាម៉ាណាស៊ី",
      "neName": "यामानासी जिल्ला"
    },
    "class10": {
      "code": "190020",
      "name": "東部・富士五湖",
      "enName": "Eastern Region and Fuji Five Lakes",
      "chName": "山梨县东部、富士五湖",
      "zhName": "山梨縣東部・富士五湖",
      "koName": "야마나시 현 동부 후지 고호 수",
      "esName": "Este, Fujigoko de Prefectura de Yamanashi",
      "ptName": "Região leste ・Cinco Lagos do Fuji da Província de Yamanashi",
      "thName": "จังหวัดยามานาชิฟากตะวันออก และทะเลสาบฟูจิทั้งห้า (ฟูจิโงะโกะ)",
      "viName": "Miền Đông tỉnh Yamanashi và Ngũ hồ Fuji (Fuji-goko)",
      "inName": "Bagian Timur Prefektur Yamanashi dan 5 Danau Fuji (Fuji-goko)",
      "tlName": "Silangang bahagi ng Yamanashi Prefecture at ang Limang Lawa ng Fuji (Fuji-goko)",
      "moName": "Зүүн Яманаши аймаг・ Фүжи таван нуур",
      "buName": "ယမနရှိစီရင်စု၊ အရှေ့ပိုင်းဒေသ၊ ဖူဂျီဂေါ့ရေကန်",
      "khName": "តំបន់ខាងកើត/បឹងហ្វូជីប្រាំនៃខេត្តយ៉ាម៉ាណាស៊ី",
      "neName": "यामानासी जिल्लाको पूर्वी भाग र फुजी पाँच तालहरू (फुजी-गोको)"
    },
    "class15": {
      "code": "190021",
      "name": "東部",
      "enName": "Eastern Region"
    },
    "class20": {
      "code": "1944200",
      "name": "小菅村",
      "enName": "Kosuge Village",
      "kana": "こすげむら",
      "chName": "小菅村",
      "zhName": "小菅村",
      "koName": "코스게 촌",
      "esName": "Aldea de Kosuge",
      "ptName": "povoado de Kosuge",
      "thName": "หมู่บ้านโคสุเกะ",
      "viName": "làng Kosuge",
      "inName": "desa Kosuge",
      "tlName": "nayon ng Kosuge",
      "moName": "Косүгэ тосгон",
      "buName": "ကိုဆုဂဲ့ ကျေးရွာ",
      "khName": "ភូមិ កូស៊ូជ",
      "neName": "कोसुगे गाउँ"
    }
  },
  "1944300": {
    "office": {
      "code": "190000",
      "name": "山梨県",
      "enName": "Yamanashi",
      "officeName": "甲府地方気象台",
      "chName": "山梨县",
      "zhName": "山梨縣",
      "koName": "야마나시현",
      "esName": "Prefectura de Yamanashi",
      "ptName": "Província de Yamanashi",
      "thName": "จังหวัดยามานาชิ",
      "viName": "Tỉnh Yamanashi",
      "inName": "Prefektur Yamanashi",
      "tlName": "Yamanashi Prefecture",
      "moName": "Яманаши аймаг",
      "buName": "ယာမနာရှိ ပြည်နယ်",
      "khName": "ខេត្ត យ៉ាម៉ាណាស៊ី",
      "neName": "यामानासी जिल्ला"
    },
    "class10": {
      "code": "190020",
      "name": "東部・富士五湖",
      "enName": "Eastern Region and Fuji Five Lakes",
      "chName": "山梨县东部、富士五湖",
      "zhName": "山梨縣東部・富士五湖",
      "koName": "야마나시 현 동부 후지 고호 수",
      "esName": "Este, Fujigoko de Prefectura de Yamanashi",
      "ptName": "Região leste ・Cinco Lagos do Fuji da Província de Yamanashi",
      "thName": "จังหวัดยามานาชิฟากตะวันออก และทะเลสาบฟูจิทั้งห้า (ฟูจิโงะโกะ)",
      "viName": "Miền Đông tỉnh Yamanashi và Ngũ hồ Fuji (Fuji-goko)",
      "inName": "Bagian Timur Prefektur Yamanashi dan 5 Danau Fuji (Fuji-goko)",
      "tlName": "Silangang bahagi ng Yamanashi Prefecture at ang Limang Lawa ng Fuji (Fuji-goko)",
      "moName": "Зүүн Яманаши аймаг・ Фүжи таван нуур",
      "buName": "ယမနရှိစီရင်စု၊ အရှေ့ပိုင်းဒေသ၊ ဖူဂျီဂေါ့ရေကန်",
      "khName": "តំបន់ខាងកើត/បឹងហ្វូជីប្រាំនៃខេត្តយ៉ាម៉ាណាស៊ី",
      "neName": "यामानासी जिल्लाको पूर्वी भाग र फुजी पाँच तालहरू (फुजी-गोको)"
    },
    "class15": {
      "code": "190021",
      "name": "東部",
      "enName": "Eastern Region"
    },
    "class20": {
      "code": "1944300",
      "name": "丹波山村",
      "enName": "Tabayama Village",
      "kana": "たばやまむら",
      "chName": "丹波山村",
      "zhName": "丹波山村",
      "koName": "다바야마 촌",
      "esName": "Aldea de Tabayama",
      "ptName": "povoado de Tabayama",
      "thName": "หมู่บ้านทาบายามะ",
      "viName": "làng Tabayama",
      "inName": "desa Tabayama",
      "tlName": "nayon ng Tabayama",
      "moName": "Табаямa тосгон",
      "buName": "တာဘာယာ့မ ကျေးရွာ",
      "khName": "ភូមិ តាបាយ៉ាម៉ា",
      "neName": "ताबायामा गाउँ"
    }
  },
  "2020111": {
    "office": {
      "code": "200000",
      "name": "長野県",
      "enName": "Nagano",
      "officeName": "長野地方気象台",
      "chName": "长野县",
      "zhName": "長野縣",
      "koName": "나가노현",
      "esName": "Prefectura de Nagano",
      "ptName": "Província de Nagano",
      "thName": "จังหวัดนางาโนะ",
      "viName": "Tỉnh Nagano",
      "inName": "Prefektur Nagano",
      "tlName": "Nagano Prefecture",
      "moName": "Нагано аймаг",
      "buName": "နားဂါနို ပြည်နယ်",
      "khName": "ខេត្ដ ណាហ្គាណូ",
      "neName": "नागानो जिल्ला"
    },
    "class10": {
      "code": "200010",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "长野县北部",
      "zhName": "長野縣北部",
      "koName": "나가노 현 북부",
      "esName": "Norte de Prefectura de Nagano",
      "ptName": "Região norte da Província de Nagano",
      "thName": "จังหวัดนางาโนะตอนเหนือ",
      "viName": "Miền Bắc tỉnh Nagano",
      "inName": "Bagian Utara Prefektur Nagano",
      "tlName": "Hilagang bahagi ng Nagano Prefecture",
      "moName": "Хойд Нагано аймаг",
      "buName": "နဂိုနိုစီရင်စုမြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដណាហ្គាណុ",
      "neName": "नागानो जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "200011",
      "name": "長野地域",
      "enName": "Nagano Area"
    },
    "class20": {
      "code": "2020111",
      "name": "長野市長野",
      "enName": "Nagano, Nagano City",
      "kana": "ながのしながの"
    }
  },
  "2020112": {
    "office": {
      "code": "200000",
      "name": "長野県",
      "enName": "Nagano",
      "officeName": "長野地方気象台",
      "chName": "长野县",
      "zhName": "長野縣",
      "koName": "나가노현",
      "esName": "Prefectura de Nagano",
      "ptName": "Província de Nagano",
      "thName": "จังหวัดนางาโนะ",
      "viName": "Tỉnh Nagano",
      "inName": "Prefektur Nagano",
      "tlName": "Nagano Prefecture",
      "moName": "Нагано аймаг",
      "buName": "နားဂါနို ပြည်နယ်",
      "khName": "ខេត្ដ ណាហ្គាណូ",
      "neName": "नागानो जिल्ला"
    },
    "class10": {
      "code": "200010",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "长野县北部",
      "zhName": "長野縣北部",
      "koName": "나가노 현 북부",
      "esName": "Norte de Prefectura de Nagano",
      "ptName": "Região norte da Província de Nagano",
      "thName": "จังหวัดนางาโนะตอนเหนือ",
      "viName": "Miền Bắc tỉnh Nagano",
      "inName": "Bagian Utara Prefektur Nagano",
      "tlName": "Hilagang bahagi ng Nagano Prefecture",
      "moName": "Хойд Нагано аймаг",
      "buName": "နဂိုနိုစီရင်စုမြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដណាហ្គាណុ",
      "neName": "नागानो जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "200011",
      "name": "長野地域",
      "enName": "Nagano Area"
    },
    "class20": {
      "code": "2020112",
      "name": "長野市鬼無里戸隠",
      "enName": "Kinasatogakushi, Nagano City",
      "kana": "ながのしきなさとがくし"
    }
  },
  "2020201": {
    "office": {
      "code": "200000",
      "name": "長野県",
      "enName": "Nagano",
      "officeName": "長野地方気象台",
      "chName": "长野县",
      "zhName": "長野縣",
      "koName": "나가노현",
      "esName": "Prefectura de Nagano",
      "ptName": "Província de Nagano",
      "thName": "จังหวัดนางาโนะ",
      "viName": "Tỉnh Nagano",
      "inName": "Prefektur Nagano",
      "tlName": "Nagano Prefecture",
      "moName": "Нагано аймаг",
      "buName": "နားဂါနို ပြည်နယ်",
      "khName": "ខេត្ដ ណាហ្គាណូ",
      "neName": "नागानो जिल्ला"
    },
    "class10": {
      "code": "200020",
      "name": "中部",
      "enName": "Central Region",
      "chName": "长野县中部",
      "zhName": "長野縣中部",
      "koName": "나가노 현 중부",
      "esName": "Centro de Prefectura de Nagano",
      "ptName": "Região central da Província de Nagano",
      "thName": "จังหวัดนางาโนะตอนกลาง",
      "viName": "Miền Trung tỉnh Nagano",
      "inName": "Bagian Tengah Prefektur Nagano",
      "tlName": "Sentral na bahagi ng Nagano Prefecture",
      "moName": "Төв Нагано аймаг",
      "buName": "နဂိုနိုစီရင်စုအလယ်ပိုင်း",
      "khName": "តំបន់កណ្តាលនៃខេត្ដណាហ្គាណុ",
      "neName": "नागानो जिल्लाको मध्य भाग"
    },
    "class15": {
      "code": "200023",
      "name": "松本地域",
      "enName": "Matsumoto Area"
    },
    "class20": {
      "code": "2020201",
      "name": "松本市松本",
      "enName": "Matsumoto, Matsumoto City",
      "kana": "まつもとしまつもと",
      "chName": "松本市",
      "zhName": "松本市",
      "koName": "마츠모토시",
      "esName": "Ciudad de Matsumoto",
      "ptName": "Cidade de Matsumoto",
      "thName": "เมืองมัตซูโมโตะ",
      "viName": "Thành phố Matsumoto",
      "inName": "Kota Matsumoto",
      "tlName": "Lungsod ng Matsumoto",
      "moName": "Cidade de Matsumoto",
      "buName": "မာတ်စူမိုတိုမြို့",
      "khName": "ទីក្រុង Matsumoto",
      "neName": "मात्सुमोटो शहर"
    }
  },
  "2020202": {
    "office": {
      "code": "200000",
      "name": "長野県",
      "enName": "Nagano",
      "officeName": "長野地方気象台",
      "chName": "长野县",
      "zhName": "長野縣",
      "koName": "나가노현",
      "esName": "Prefectura de Nagano",
      "ptName": "Província de Nagano",
      "thName": "จังหวัดนางาโนะ",
      "viName": "Tỉnh Nagano",
      "inName": "Prefektur Nagano",
      "tlName": "Nagano Prefecture",
      "moName": "Нагано аймаг",
      "buName": "နားဂါနို ပြည်နယ်",
      "khName": "ខេត្ដ ណាហ្គាណូ",
      "neName": "नागानो जिल्ला"
    },
    "class10": {
      "code": "200020",
      "name": "中部",
      "enName": "Central Region",
      "chName": "长野县中部",
      "zhName": "長野縣中部",
      "koName": "나가노 현 중부",
      "esName": "Centro de Prefectura de Nagano",
      "ptName": "Região central da Província de Nagano",
      "thName": "จังหวัดนางาโนะตอนกลาง",
      "viName": "Miền Trung tỉnh Nagano",
      "inName": "Bagian Tengah Prefektur Nagano",
      "tlName": "Sentral na bahagi ng Nagano Prefecture",
      "moName": "Төв Нагано аймаг",
      "buName": "နဂိုနိုစီရင်စုအလယ်ပိုင်း",
      "khName": "តំបន់កណ្តាលនៃខេត្ដណាហ្គាណុ",
      "neName": "नागानो जिल्लाको मध्य भाग"
    },
    "class15": {
      "code": "200024",
      "name": "乗鞍上高地地域",
      "enName": "Norikura Kamikochi Area"
    },
    "class20": {
      "code": "2020202",
      "name": "松本市乗鞍上高地",
      "enName": "Norikura Kamikochi, Matsumoto City",
      "kana": "まつもとしのりくらかみこうち",
      "chName": "乘鞍上高地",
      "zhName": "乘鞍上高地",
      "koName": "노리쿠라 카미코치",
      "esName": "Norikura Kamikochi, Ciudad de Matsumoto",
      "ptName": "Norikura Kamikochi, Cidade de Matsumoto",
      "thName": "นอริคุระ คามิโคจิ",
      "viName": "Norikura Kamikochi, Thành phố Matsumoto",
      "inName": "Norikura Kamikochi, Kota Matsumoto",
      "tlName": "Norikura Kamikochi, Lungsod ng Matsumoto",
      "moName": "Norikura Kamikochi, Cidade de Matsumoto",
      "buName": "နိုရီကူရာကာမီကိုချိ",
      "khName": "Norikura Kamikochi",
      "neName": "नोरिकुरा क्यामिकुची शहर"
    }
  },
  "2020300": {
    "office": {
      "code": "200000",
      "name": "長野県",
      "enName": "Nagano",
      "officeName": "長野地方気象台",
      "chName": "长野县",
      "zhName": "長野縣",
      "koName": "나가노현",
      "esName": "Prefectura de Nagano",
      "ptName": "Província de Nagano",
      "thName": "จังหวัดนางาโนะ",
      "viName": "Tỉnh Nagano",
      "inName": "Prefektur Nagano",
      "tlName": "Nagano Prefecture",
      "moName": "Нагано аймаг",
      "buName": "နားဂါနို ပြည်နယ်",
      "khName": "ខេត្ដ ណាហ្គាណូ",
      "neName": "नागानो जिल्ला"
    },
    "class10": {
      "code": "200020",
      "name": "中部",
      "enName": "Central Region",
      "chName": "长野县中部",
      "zhName": "長野縣中部",
      "koName": "나가노 현 중부",
      "esName": "Centro de Prefectura de Nagano",
      "ptName": "Região central da Província de Nagano",
      "thName": "จังหวัดนางาโนะตอนกลาง",
      "viName": "Miền Trung tỉnh Nagano",
      "inName": "Bagian Tengah Prefektur Nagano",
      "tlName": "Sentral na bahagi ng Nagano Prefecture",
      "moName": "Төв Нагано аймаг",
      "buName": "နဂိုနိုစီရင်စုအလယ်ပိုင်း",
      "khName": "តំបន់កណ្តាលនៃខេត្ដណាហ្គាណុ",
      "neName": "नागानो जिल्लाको मध्य भाग"
    },
    "class15": {
      "code": "200021",
      "name": "上田地域",
      "enName": "Ueda Area"
    },
    "class20": {
      "code": "2020300",
      "name": "上田市",
      "enName": "Ueda City",
      "kana": "うえだし",
      "chName": "上田市",
      "zhName": "上田市",
      "koName": "우에다 시",
      "esName": "Ciudad de Ueda",
      "ptName": "cidade de Ueda",
      "thName": "เมืองอุเอดะ",
      "viName": "thành phố Ueda",
      "inName": "kota Ueda",
      "tlName": "siyudad ng Ueda",
      "moName": "Үэда хот",
      "buName": "အူယေးဒ မြို့",
      "khName": "ទីក្រុង អ៊ូអៃដា",
      "neName": "उएदा सहर"
    }
  },
  "2020400": {
    "office": {
      "code": "200000",
      "name": "長野県",
      "enName": "Nagano",
      "officeName": "長野地方気象台",
      "chName": "长野县",
      "zhName": "長野縣",
      "koName": "나가노현",
      "esName": "Prefectura de Nagano",
      "ptName": "Província de Nagano",
      "thName": "จังหวัดนางาโนะ",
      "viName": "Tỉnh Nagano",
      "inName": "Prefektur Nagano",
      "tlName": "Nagano Prefecture",
      "moName": "Нагано аймаг",
      "buName": "နားဂါနို ပြည်နယ်",
      "khName": "ខេត្ដ ណាហ្គាណូ",
      "neName": "नागानो जिल्ला"
    },
    "class10": {
      "code": "200020",
      "name": "中部",
      "enName": "Central Region",
      "chName": "长野县中部",
      "zhName": "長野縣中部",
      "koName": "나가노 현 중부",
      "esName": "Centro de Prefectura de Nagano",
      "ptName": "Região central da Província de Nagano",
      "thName": "จังหวัดนางาโนะตอนกลาง",
      "viName": "Miền Trung tỉnh Nagano",
      "inName": "Bagian Tengah Prefektur Nagano",
      "tlName": "Sentral na bahagi ng Nagano Prefecture",
      "moName": "Төв Нагано аймаг",
      "buName": "နဂိုနိုစီရင်စုအလယ်ပိုင်း",
      "khName": "តំបន់កណ្តាលនៃខេត្ដណាហ្គាណុ",
      "neName": "नागानो जिल्लाको मध्य भाग"
    },
    "class15": {
      "code": "200025",
      "name": "諏訪地域",
      "enName": "Suwa Area"
    },
    "class20": {
      "code": "2020400",
      "name": "岡谷市",
      "enName": "Okaya City",
      "kana": "おかやし",
      "chName": "冈谷市",
      "zhName": "岡谷市",
      "koName": "오카야 시",
      "esName": "Ciudad de Okaya",
      "ptName": "cidade de Okaya",
      "thName": "เมืองโอคายะ",
      "viName": "thành phố Okaya",
      "inName": "kota Okaya",
      "tlName": "siyudad ng Okaya",
      "moName": "Окая хот",
      "buName": "အိုကာ့ယ မြို့",
      "khName": "ទីក្រុង អូកាយ៉ា",
      "neName": "ओकाया सहर"
    }
  },
  "2020500": {
    "office": {
      "code": "200000",
      "name": "長野県",
      "enName": "Nagano",
      "officeName": "長野地方気象台",
      "chName": "长野县",
      "zhName": "長野縣",
      "koName": "나가노현",
      "esName": "Prefectura de Nagano",
      "ptName": "Província de Nagano",
      "thName": "จังหวัดนางาโนะ",
      "viName": "Tỉnh Nagano",
      "inName": "Prefektur Nagano",
      "tlName": "Nagano Prefecture",
      "moName": "Нагано аймаг",
      "buName": "နားဂါနို ပြည်နယ်",
      "khName": "ខេត្ដ ណាហ្គាណូ",
      "neName": "नागानो जिल्ला"
    },
    "class10": {
      "code": "200030",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "长野县南部",
      "zhName": "長野縣南部",
      "koName": "나가노 현 남부",
      "esName": "Sur de Prefectura de Nagano",
      "ptName": "Região sul da Província de Nagano",
      "thName": "จังหวัดนางาโนะตอนใต้",
      "viName": "Miền Nam tỉnh Nagano",
      "inName": "Bagian Selatan Prefektur Nagano",
      "tlName": "Timog na bahagi ng Nagano Prefecture",
      "moName": "Өмнөд Нагано аймаг",
      "buName": "နဂိုနိုစီရင်စုတောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដណាហ្គាណុ",
      "neName": "नागानो जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "200033",
      "name": "下伊那地域",
      "enName": "Shimoina Area"
    },
    "class20": {
      "code": "2020500",
      "name": "飯田市",
      "enName": "Iida City",
      "kana": "いいだし",
      "chName": "饭田市",
      "zhName": "飯田市",
      "koName": "이다 시",
      "esName": "Ciudad de Iida",
      "ptName": "cidade de Iida",
      "thName": "เมืองลิดะ",
      "viName": "thành phố Iida",
      "inName": "kota Iida",
      "tlName": "siyudad ng Iida",
      "moName": "Ийда хот",
      "buName": "အီးဒါ့ မြို့",
      "khName": "ទីក្រុង អ៊ីអ៊ីដា",
      "neName": "आइदासहर"
    }
  },
  "2020600": {
    "office": {
      "code": "200000",
      "name": "長野県",
      "enName": "Nagano",
      "officeName": "長野地方気象台",
      "chName": "长野县",
      "zhName": "長野縣",
      "koName": "나가노현",
      "esName": "Prefectura de Nagano",
      "ptName": "Província de Nagano",
      "thName": "จังหวัดนางาโนะ",
      "viName": "Tỉnh Nagano",
      "inName": "Prefektur Nagano",
      "tlName": "Nagano Prefecture",
      "moName": "Нагано аймаг",
      "buName": "နားဂါနို ပြည်နယ်",
      "khName": "ខេត្ដ ណាហ្គាណូ",
      "neName": "नागानो जिल्ला"
    },
    "class10": {
      "code": "200020",
      "name": "中部",
      "enName": "Central Region",
      "chName": "长野县中部",
      "zhName": "長野縣中部",
      "koName": "나가노 현 중부",
      "esName": "Centro de Prefectura de Nagano",
      "ptName": "Região central da Província de Nagano",
      "thName": "จังหวัดนางาโนะตอนกลาง",
      "viName": "Miền Trung tỉnh Nagano",
      "inName": "Bagian Tengah Prefektur Nagano",
      "tlName": "Sentral na bahagi ng Nagano Prefecture",
      "moName": "Төв Нагано аймаг",
      "buName": "နဂိုနိုစီရင်စုအလယ်ပိုင်း",
      "khName": "តំបន់កណ្តាលនៃខេត្ដណាហ្គាណុ",
      "neName": "नागानो जिल्लाको मध्य भाग"
    },
    "class15": {
      "code": "200025",
      "name": "諏訪地域",
      "enName": "Suwa Area"
    },
    "class20": {
      "code": "2020600",
      "name": "諏訪市",
      "enName": "Suwa City",
      "kana": "すわし",
      "chName": "诹访市",
      "zhName": "諏訪市",
      "koName": "스와 시",
      "esName": "Ciudad de Suwa",
      "ptName": "cidade de Suwa",
      "thName": "เมืองซูวะ",
      "viName": "thành phố Suwa",
      "inName": "kota Suwa",
      "tlName": "siyudad ng Suwa",
      "moName": "Сүва хот",
      "buName": "ဆူဝါ မြို့",
      "khName": "ទីក្រុង ស៊ូវ៉ា",
      "neName": "सुवा सहर"
    }
  },
  "2020700": {
    "office": {
      "code": "200000",
      "name": "長野県",
      "enName": "Nagano",
      "officeName": "長野地方気象台",
      "chName": "长野县",
      "zhName": "長野縣",
      "koName": "나가노현",
      "esName": "Prefectura de Nagano",
      "ptName": "Província de Nagano",
      "thName": "จังหวัดนางาโนะ",
      "viName": "Tỉnh Nagano",
      "inName": "Prefektur Nagano",
      "tlName": "Nagano Prefecture",
      "moName": "Нагано аймаг",
      "buName": "နားဂါနို ပြည်နယ်",
      "khName": "ខេត្ដ ណាហ្គាណូ",
      "neName": "नागानो जिल्ला"
    },
    "class10": {
      "code": "200010",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "长野县北部",
      "zhName": "長野縣北部",
      "koName": "나가노 현 북부",
      "esName": "Norte de Prefectura de Nagano",
      "ptName": "Região norte da Província de Nagano",
      "thName": "จังหวัดนางาโนะตอนเหนือ",
      "viName": "Miền Bắc tỉnh Nagano",
      "inName": "Bagian Utara Prefektur Nagano",
      "tlName": "Hilagang bahagi ng Nagano Prefecture",
      "moName": "Хойд Нагано аймаг",
      "buName": "နဂိုနိုစီရင်စုမြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដណាហ្គាណុ",
      "neName": "नागानो जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "200011",
      "name": "長野地域",
      "enName": "Nagano Area"
    },
    "class20": {
      "code": "2020700",
      "name": "須坂市",
      "enName": "Suzaka City",
      "kana": "すざかし",
      "chName": "须坂市",
      "zhName": "須坂市",
      "koName": "스자카 시",
      "esName": "Ciudad de Suzaka",
      "ptName": "cidade de Suzaka",
      "thName": "เมืองซึซากะ",
      "viName": "thành phố Suzaka",
      "inName": "kota Suzaka",
      "tlName": "siyudad ng Suzaka",
      "moName": "Зүзaка хот",
      "buName": "ဆူဇာ့က မြို့",
      "khName": "ទីក្រុង ស៊ូហ្សាកា",
      "neName": "सुजाका सहर"
    }
  },
  "2020800": {
    "office": {
      "code": "200000",
      "name": "長野県",
      "enName": "Nagano",
      "officeName": "長野地方気象台",
      "chName": "长野县",
      "zhName": "長野縣",
      "koName": "나가노현",
      "esName": "Prefectura de Nagano",
      "ptName": "Província de Nagano",
      "thName": "จังหวัดนางาโนะ",
      "viName": "Tỉnh Nagano",
      "inName": "Prefektur Nagano",
      "tlName": "Nagano Prefecture",
      "moName": "Нагано аймаг",
      "buName": "နားဂါနို ပြည်နယ်",
      "khName": "ខេត្ដ ណាហ្គាណូ",
      "neName": "नागानो जिल्ला"
    },
    "class10": {
      "code": "200020",
      "name": "中部",
      "enName": "Central Region",
      "chName": "长野县中部",
      "zhName": "長野縣中部",
      "koName": "나가노 현 중부",
      "esName": "Centro de Prefectura de Nagano",
      "ptName": "Região central da Província de Nagano",
      "thName": "จังหวัดนางาโนะตอนกลาง",
      "viName": "Miền Trung tỉnh Nagano",
      "inName": "Bagian Tengah Prefektur Nagano",
      "tlName": "Sentral na bahagi ng Nagano Prefecture",
      "moName": "Төв Нагано аймаг",
      "buName": "နဂိုနိုစီရင်စုအလယ်ပိုင်း",
      "khName": "តំបន់កណ្តាលនៃខេត្ដណាហ្គាណុ",
      "neName": "नागानो जिल्लाको मध्य भाग"
    },
    "class15": {
      "code": "200022",
      "name": "佐久地域",
      "enName": "Saku Area"
    },
    "class20": {
      "code": "2020800",
      "name": "小諸市",
      "enName": "Komoro City",
      "kana": "こもろし",
      "chName": "小诸市",
      "zhName": "小諸市",
      "koName": "고모로 시",
      "esName": "Ciudad de Komoro",
      "ptName": "cidade de Komoro",
      "thName": "เมืองโคโมโระ",
      "viName": "thành phố Komoro",
      "inName": "kota Komoro",
      "tlName": "siyudad ng Komoro",
      "moName": "Коморо хот",
      "buName": "ကိုမိုရို မြို့",
      "khName": "ទីក្រុង កូម៉ូរ៉ូ",
      "neName": "कोमोरो सहर"
    }
  },
  "2020911": {
    "office": {
      "code": "200000",
      "name": "長野県",
      "enName": "Nagano",
      "officeName": "長野地方気象台",
      "chName": "长野县",
      "zhName": "長野縣",
      "koName": "나가노현",
      "esName": "Prefectura de Nagano",
      "ptName": "Província de Nagano",
      "thName": "จังหวัดนางาโนะ",
      "viName": "Tỉnh Nagano",
      "inName": "Prefektur Nagano",
      "tlName": "Nagano Prefecture",
      "moName": "Нагано аймаг",
      "buName": "နားဂါနို ပြည်နယ်",
      "khName": "ខេត្ដ ណាហ្គាណូ",
      "neName": "नागानो जिल्ला"
    },
    "class10": {
      "code": "200030",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "长野县南部",
      "zhName": "長野縣南部",
      "koName": "나가노 현 남부",
      "esName": "Sur de Prefectura de Nagano",
      "ptName": "Região sul da Província de Nagano",
      "thName": "จังหวัดนางาโนะตอนใต้",
      "viName": "Miền Nam tỉnh Nagano",
      "inName": "Bagian Selatan Prefektur Nagano",
      "tlName": "Timog na bahagi ng Nagano Prefecture",
      "moName": "Өмнөд Нагано аймаг",
      "buName": "နဂိုနိုစီရင်စုတောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដណាហ្គាណុ",
      "neName": "नागानो जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "200031",
      "name": "上伊那地域",
      "enName": "Kamiina Area"
    },
    "class20": {
      "code": "2020911",
      "name": "伊那市伊那",
      "enName": "Ina, Ina City",
      "kana": "いなしいな"
    }
  },
  "2020912": {
    "office": {
      "code": "200000",
      "name": "長野県",
      "enName": "Nagano",
      "officeName": "長野地方気象台",
      "chName": "长野县",
      "zhName": "長野縣",
      "koName": "나가노현",
      "esName": "Prefectura de Nagano",
      "ptName": "Província de Nagano",
      "thName": "จังหวัดนางาโนะ",
      "viName": "Tỉnh Nagano",
      "inName": "Prefektur Nagano",
      "tlName": "Nagano Prefecture",
      "moName": "Нагано аймаг",
      "buName": "နားဂါနို ပြည်နယ်",
      "khName": "ខេត្ដ ណាហ្គាណូ",
      "neName": "नागानो जिल्ला"
    },
    "class10": {
      "code": "200030",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "长野县南部",
      "zhName": "長野縣南部",
      "koName": "나가노 현 남부",
      "esName": "Sur de Prefectura de Nagano",
      "ptName": "Região sul da Província de Nagano",
      "thName": "จังหวัดนางาโนะตอนใต้",
      "viName": "Miền Nam tỉnh Nagano",
      "inName": "Bagian Selatan Prefektur Nagano",
      "tlName": "Timog na bahagi ng Nagano Prefecture",
      "moName": "Өмнөд Нагано аймаг",
      "buName": "နဂိုနိုစီရင်စုတောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដណាហ្គាណុ",
      "neName": "नागानो जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "200031",
      "name": "上伊那地域",
      "enName": "Kamiina Area"
    },
    "class20": {
      "code": "2020912",
      "name": "伊那市長谷",
      "enName": "Hase, Ina City",
      "kana": "いなしはせ"
    }
  },
  "2021000": {
    "office": {
      "code": "200000",
      "name": "長野県",
      "enName": "Nagano",
      "officeName": "長野地方気象台",
      "chName": "长野县",
      "zhName": "長野縣",
      "koName": "나가노현",
      "esName": "Prefectura de Nagano",
      "ptName": "Província de Nagano",
      "thName": "จังหวัดนางาโนะ",
      "viName": "Tỉnh Nagano",
      "inName": "Prefektur Nagano",
      "tlName": "Nagano Prefecture",
      "moName": "Нагано аймаг",
      "buName": "နားဂါနို ပြည်နယ်",
      "khName": "ខេត្ដ ណាហ្គាណូ",
      "neName": "नागानो जिल्ला"
    },
    "class10": {
      "code": "200030",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "长野县南部",
      "zhName": "長野縣南部",
      "koName": "나가노 현 남부",
      "esName": "Sur de Prefectura de Nagano",
      "ptName": "Região sul da Província de Nagano",
      "thName": "จังหวัดนางาโนะตอนใต้",
      "viName": "Miền Nam tỉnh Nagano",
      "inName": "Bagian Selatan Prefektur Nagano",
      "tlName": "Timog na bahagi ng Nagano Prefecture",
      "moName": "Өмнөд Нагано аймаг",
      "buName": "နဂိုနိုစီရင်စုတောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដណាហ្គាណុ",
      "neName": "नागानो जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "200031",
      "name": "上伊那地域",
      "enName": "Kamiina Area"
    },
    "class20": {
      "code": "2021000",
      "name": "駒ヶ根市",
      "enName": "Komagane City",
      "kana": "こまがねし",
      "chName": "驹根市",
      "zhName": "駒根市",
      "koName": "고마가네 시",
      "esName": "Ciudad de Komagane",
      "ptName": "cidade de Komagane",
      "thName": "เมืองโคมะกาเนะ",
      "viName": "thành phố Komagane",
      "inName": "kota Komagane",
      "tlName": "siyudad ng Komagane",
      "moName": "Комaгaнэ хот",
      "buName": "ကိုမားဂါနဲ့ မြို့",
      "khName": "ទីក្រុង ខូម៉ាហ្គែន",
      "neName": "कोमागाने सहर"
    }
  },
  "2021100": {
    "office": {
      "code": "200000",
      "name": "長野県",
      "enName": "Nagano",
      "officeName": "長野地方気象台",
      "chName": "长野县",
      "zhName": "長野縣",
      "koName": "나가노현",
      "esName": "Prefectura de Nagano",
      "ptName": "Província de Nagano",
      "thName": "จังหวัดนางาโนะ",
      "viName": "Tỉnh Nagano",
      "inName": "Prefektur Nagano",
      "tlName": "Nagano Prefecture",
      "moName": "Нагано аймаг",
      "buName": "နားဂါနို ပြည်နယ်",
      "khName": "ខេត្ដ ណាហ្គាណូ",
      "neName": "नागानो जिल्ला"
    },
    "class10": {
      "code": "200010",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "长野县北部",
      "zhName": "長野縣北部",
      "koName": "나가노 현 북부",
      "esName": "Norte de Prefectura de Nagano",
      "ptName": "Região norte da Província de Nagano",
      "thName": "จังหวัดนางาโนะตอนเหนือ",
      "viName": "Miền Bắc tỉnh Nagano",
      "inName": "Bagian Utara Prefektur Nagano",
      "tlName": "Hilagang bahagi ng Nagano Prefecture",
      "moName": "Хойд Нагано аймаг",
      "buName": "နဂိုနိုစီရင်စုမြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដណាហ្គាណុ",
      "neName": "नागानो जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "200012",
      "name": "中野飯山地域",
      "enName": "Nakano Iiyama Area"
    },
    "class20": {
      "code": "2021100",
      "name": "中野市",
      "enName": "Nakano City",
      "kana": "なかのし",
      "chName": "中野市",
      "zhName": "中野市",
      "koName": "나카노 시",
      "esName": "Ciudad de Nakano",
      "ptName": "cidade de Nakano",
      "thName": "เมืองนากาโนะ",
      "viName": "thành phố Nakano",
      "inName": "kota Nakano",
      "tlName": "siyudad ng Nakano",
      "moName": "Накано хот",
      "buName": "နာကာနို မြို့",
      "khName": "ទីក្រុង ណាកាណូ",
      "neName": "नाकानो सहर"
    }
  },
  "2021200": {
    "office": {
      "code": "200000",
      "name": "長野県",
      "enName": "Nagano",
      "officeName": "長野地方気象台",
      "chName": "长野县",
      "zhName": "長野縣",
      "koName": "나가노현",
      "esName": "Prefectura de Nagano",
      "ptName": "Província de Nagano",
      "thName": "จังหวัดนางาโนะ",
      "viName": "Tỉnh Nagano",
      "inName": "Prefektur Nagano",
      "tlName": "Nagano Prefecture",
      "moName": "Нагано аймаг",
      "buName": "နားဂါနို ပြည်နယ်",
      "khName": "ខេត្ដ ណាហ្គាណូ",
      "neName": "नागानो जिल्ला"
    },
    "class10": {
      "code": "200010",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "长野县北部",
      "zhName": "長野縣北部",
      "koName": "나가노 현 북부",
      "esName": "Norte de Prefectura de Nagano",
      "ptName": "Região norte da Província de Nagano",
      "thName": "จังหวัดนางาโนะตอนเหนือ",
      "viName": "Miền Bắc tỉnh Nagano",
      "inName": "Bagian Utara Prefektur Nagano",
      "tlName": "Hilagang bahagi ng Nagano Prefecture",
      "moName": "Хойд Нагано аймаг",
      "buName": "နဂိုနိုစီရင်စုမြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដណាហ្គាណុ",
      "neName": "नागानो जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "200013",
      "name": "大北地域",
      "enName": "Daihoku Area"
    },
    "class20": {
      "code": "2021200",
      "name": "大町市",
      "enName": "Omachi City",
      "kana": "おおまちし",
      "chName": "大町市",
      "zhName": "大町市",
      "koName": "오마치 시",
      "esName": "Ciudad de Ōmachi",
      "ptName": "cidade de Omachi",
      "thName": "เมืองโอมะจิ",
      "viName": "thành phố Omachi",
      "inName": "kota Omachi",
      "tlName": "siyudad ng Omachi",
      "moName": "Омaчи хот",
      "buName": "အိုမာ့ကျိ မြို့",
      "khName": "ទីក្រុង អូម៉ាជី",
      "neName": "ओमाची सहर"
    }
  },
  "2021300": {
    "office": {
      "code": "200000",
      "name": "長野県",
      "enName": "Nagano",
      "officeName": "長野地方気象台",
      "chName": "长野县",
      "zhName": "長野縣",
      "koName": "나가노현",
      "esName": "Prefectura de Nagano",
      "ptName": "Província de Nagano",
      "thName": "จังหวัดนางาโนะ",
      "viName": "Tỉnh Nagano",
      "inName": "Prefektur Nagano",
      "tlName": "Nagano Prefecture",
      "moName": "Нагано аймаг",
      "buName": "နားဂါနို ပြည်နယ်",
      "khName": "ខេត្ដ ណាហ្គាណូ",
      "neName": "नागानो जिल्ला"
    },
    "class10": {
      "code": "200010",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "长野县北部",
      "zhName": "長野縣北部",
      "koName": "나가노 현 북부",
      "esName": "Norte de Prefectura de Nagano",
      "ptName": "Região norte da Província de Nagano",
      "thName": "จังหวัดนางาโนะตอนเหนือ",
      "viName": "Miền Bắc tỉnh Nagano",
      "inName": "Bagian Utara Prefektur Nagano",
      "tlName": "Hilagang bahagi ng Nagano Prefecture",
      "moName": "Хойд Нагано аймаг",
      "buName": "နဂိုနိုစီရင်စုမြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដណាហ្គាណុ",
      "neName": "नागानो जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "200012",
      "name": "中野飯山地域",
      "enName": "Nakano Iiyama Area"
    },
    "class20": {
      "code": "2021300",
      "name": "飯山市",
      "enName": "Iiyama City",
      "kana": "いいやまし",
      "chName": "饭山市",
      "zhName": "飯山市",
      "koName": "이야마 시",
      "esName": "Ciudad de Iiyama",
      "ptName": "cidade de Iiyama",
      "thName": "เมืองลิยามะ",
      "viName": "thành phố Iiyama",
      "inName": "kota Iiyama",
      "tlName": "siyudad ng Iiyama",
      "moName": "Ийямa хот",
      "buName": "အီယာ့မ မြို့",
      "khName": "ទីក្រុង អ៊ីយ៉ាម៉ា",
      "neName": "आइयामा सहर"
    }
  },
  "2021400": {
    "office": {
      "code": "200000",
      "name": "長野県",
      "enName": "Nagano",
      "officeName": "長野地方気象台",
      "chName": "长野县",
      "zhName": "長野縣",
      "koName": "나가노현",
      "esName": "Prefectura de Nagano",
      "ptName": "Província de Nagano",
      "thName": "จังหวัดนางาโนะ",
      "viName": "Tỉnh Nagano",
      "inName": "Prefektur Nagano",
      "tlName": "Nagano Prefecture",
      "moName": "Нагано аймаг",
      "buName": "နားဂါနို ပြည်နယ်",
      "khName": "ខេត្ដ ណាហ្គាណូ",
      "neName": "नागानो जिल्ला"
    },
    "class10": {
      "code": "200020",
      "name": "中部",
      "enName": "Central Region",
      "chName": "长野县中部",
      "zhName": "長野縣中部",
      "koName": "나가노 현 중부",
      "esName": "Centro de Prefectura de Nagano",
      "ptName": "Região central da Província de Nagano",
      "thName": "จังหวัดนางาโนะตอนกลาง",
      "viName": "Miền Trung tỉnh Nagano",
      "inName": "Bagian Tengah Prefektur Nagano",
      "tlName": "Sentral na bahagi ng Nagano Prefecture",
      "moName": "Төв Нагано аймаг",
      "buName": "နဂိုနိုစီရင်စုအလယ်ပိုင်း",
      "khName": "តំបន់កណ្តាលនៃខេត្ដណាហ្គាណុ",
      "neName": "नागानो जिल्लाको मध्य भाग"
    },
    "class15": {
      "code": "200025",
      "name": "諏訪地域",
      "enName": "Suwa Area"
    },
    "class20": {
      "code": "2021400",
      "name": "茅野市",
      "enName": "Chino City",
      "kana": "ちのし",
      "chName": "茅野市",
      "zhName": "茅野市",
      "koName": "지노 시",
      "esName": "Ciudad de Chino",
      "ptName": "cidade de Chino",
      "thName": "เมืองชิโนะ",
      "viName": "thành phố Chino",
      "inName": "kota Chino",
      "tlName": "siyudad ng Chino",
      "moName": "Чино хот",
      "buName": "ကျိနော့ မြို့",
      "khName": "ទីក្រុង ឈីណូ",
      "neName": "चिनो सहर"
    }
  },
  "2021501": {
    "office": {
      "code": "200000",
      "name": "長野県",
      "enName": "Nagano",
      "officeName": "長野地方気象台",
      "chName": "长野县",
      "zhName": "長野縣",
      "koName": "나가노현",
      "esName": "Prefectura de Nagano",
      "ptName": "Província de Nagano",
      "thName": "จังหวัดนางาโนะ",
      "viName": "Tỉnh Nagano",
      "inName": "Prefektur Nagano",
      "tlName": "Nagano Prefecture",
      "moName": "Нагано аймаг",
      "buName": "နားဂါနို ပြည်နယ်",
      "khName": "ខេត្ដ ណាហ្គាណូ",
      "neName": "नागानो जिल्ला"
    },
    "class10": {
      "code": "200020",
      "name": "中部",
      "enName": "Central Region",
      "chName": "长野县中部",
      "zhName": "長野縣中部",
      "koName": "나가노 현 중부",
      "esName": "Centro de Prefectura de Nagano",
      "ptName": "Região central da Província de Nagano",
      "thName": "จังหวัดนางาโนะตอนกลาง",
      "viName": "Miền Trung tỉnh Nagano",
      "inName": "Bagian Tengah Prefektur Nagano",
      "tlName": "Sentral na bahagi ng Nagano Prefecture",
      "moName": "Төв Нагано аймаг",
      "buName": "နဂိုနိုစီရင်စုအလယ်ပိုင်း",
      "khName": "តំបន់កណ្តាលនៃខេត្ដណាហ្គាណុ",
      "neName": "नागानो जिल्लाको मध्य भाग"
    },
    "class15": {
      "code": "200023",
      "name": "松本地域",
      "enName": "Matsumoto Area"
    },
    "class20": {
      "code": "2021501",
      "name": "塩尻市塩尻",
      "enName": "Shiojiri, Shiojiri City",
      "kana": "しおじりししおじり",
      "chName": "盐尻市",
      "zhName": "盐尻市",
      "koName": "시오지리시",
      "esName": "Ciudad de Shiojiri",
      "ptName": "Cidade de Shiojiri",
      "thName": "เมืองชิโอจิริ",
      "viName": "Thành phố Shiojiri",
      "inName": "Kota Shiojiri",
      "tlName": "Lungsod ng Shiojiri",
      "moName": "Cidade de Shiojiri",
      "buName": "ရှီအိုဂျီရီမြို့",
      "khName": "ទីក្រុង Shiojiri",
      "neName": "शियोजीरी शहर"
    }
  },
  "2021502": {
    "office": {
      "code": "200000",
      "name": "長野県",
      "enName": "Nagano",
      "officeName": "長野地方気象台",
      "chName": "长野县",
      "zhName": "長野縣",
      "koName": "나가노현",
      "esName": "Prefectura de Nagano",
      "ptName": "Província de Nagano",
      "thName": "จังหวัดนางาโนะ",
      "viName": "Tỉnh Nagano",
      "inName": "Prefektur Nagano",
      "tlName": "Nagano Prefecture",
      "moName": "Нагано аймаг",
      "buName": "နားဂါနို ပြည်နယ်",
      "khName": "ខេត្ដ ណាហ្គាណូ",
      "neName": "नागानो जिल्ला"
    },
    "class10": {
      "code": "200030",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "长野县南部",
      "zhName": "長野縣南部",
      "koName": "나가노 현 남부",
      "esName": "Sur de Prefectura de Nagano",
      "ptName": "Região sul da Província de Nagano",
      "thName": "จังหวัดนางาโนะตอนใต้",
      "viName": "Miền Nam tỉnh Nagano",
      "inName": "Bagian Selatan Prefektur Nagano",
      "tlName": "Timog na bahagi ng Nagano Prefecture",
      "moName": "Өмнөд Нагано аймаг",
      "buName": "နဂိုနိုစီရင်စုတောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដណាហ្គាណុ",
      "neName": "नागानो जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "200032",
      "name": "木曽地域",
      "enName": "Kiso Area"
    },
    "class20": {
      "code": "2021502",
      "name": "塩尻市楢川",
      "enName": "Narakawa, Shiojiri City",
      "kana": "しおじりしならかわ",
      "chName": "楢川市",
      "zhName": "楢川市",
      "koName": "나라카와시",
      "esName": "Narakawa, Ciudad de Shiojiri",
      "ptName": "Narakawa, Cidade de Shiojiri",
      "thName": "นาราคาวา",
      "viName": "Narakawa, Thành phố Shiojiri",
      "inName": "Narakawa, Kota Shiojiri",
      "tlName": "Narakawa, Lungsod ng Shiojiri",
      "moName": "Narakawa, Cidade de Shiojiri",
      "buName": "နာရာကာမြို့",
      "khName": "ទីក្រុង Narakawa",
      "neName": "नाराकावा शहर"
    }
  },
  "2021700": {
    "office": {
      "code": "200000",
      "name": "長野県",
      "enName": "Nagano",
      "officeName": "長野地方気象台",
      "chName": "长野县",
      "zhName": "長野縣",
      "koName": "나가노현",
      "esName": "Prefectura de Nagano",
      "ptName": "Província de Nagano",
      "thName": "จังหวัดนางาโนะ",
      "viName": "Tỉnh Nagano",
      "inName": "Prefektur Nagano",
      "tlName": "Nagano Prefecture",
      "moName": "Нагано аймаг",
      "buName": "နားဂါနို ပြည်နယ်",
      "khName": "ខេត្ដ ណាហ្គាណូ",
      "neName": "नागानो जिल्ला"
    },
    "class10": {
      "code": "200020",
      "name": "中部",
      "enName": "Central Region",
      "chName": "长野县中部",
      "zhName": "長野縣中部",
      "koName": "나가노 현 중부",
      "esName": "Centro de Prefectura de Nagano",
      "ptName": "Região central da Província de Nagano",
      "thName": "จังหวัดนางาโนะตอนกลาง",
      "viName": "Miền Trung tỉnh Nagano",
      "inName": "Bagian Tengah Prefektur Nagano",
      "tlName": "Sentral na bahagi ng Nagano Prefecture",
      "moName": "Төв Нагано аймаг",
      "buName": "နဂိုနိုစီရင်စုအလယ်ပိုင်း",
      "khName": "តំបន់កណ្តាលនៃខេត្ដណាហ្គាណុ",
      "neName": "नागानो जिल्लाको मध्य भाग"
    },
    "class15": {
      "code": "200022",
      "name": "佐久地域",
      "enName": "Saku Area"
    },
    "class20": {
      "code": "2021700",
      "name": "佐久市",
      "enName": "Saku City",
      "kana": "さくし",
      "chName": "佐久市",
      "zhName": "佐久市",
      "koName": "사쿠 시",
      "esName": "Ciudad de Saku",
      "ptName": "cidade de Saku",
      "thName": "เมืองซากุ",
      "viName": "thành phố Saku",
      "inName": "kota Saku",
      "tlName": "siyudad ng Saku",
      "moName": "Сaкү хот",
      "buName": "ဆာ့ကု မြို့",
      "khName": "ទីក្រុង សាគូ",
      "neName": "साकु सहर"
    }
  },
  "2021800": {
    "office": {
      "code": "200000",
      "name": "長野県",
      "enName": "Nagano",
      "officeName": "長野地方気象台",
      "chName": "长野县",
      "zhName": "長野縣",
      "koName": "나가노현",
      "esName": "Prefectura de Nagano",
      "ptName": "Província de Nagano",
      "thName": "จังหวัดนางาโนะ",
      "viName": "Tỉnh Nagano",
      "inName": "Prefektur Nagano",
      "tlName": "Nagano Prefecture",
      "moName": "Нагано аймаг",
      "buName": "နားဂါနို ပြည်နယ်",
      "khName": "ខេត្ដ ណាហ្គាណូ",
      "neName": "नागानो जिल्ला"
    },
    "class10": {
      "code": "200010",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "长野县北部",
      "zhName": "長野縣北部",
      "koName": "나가노 현 북부",
      "esName": "Norte de Prefectura de Nagano",
      "ptName": "Região norte da Província de Nagano",
      "thName": "จังหวัดนางาโนะตอนเหนือ",
      "viName": "Miền Bắc tỉnh Nagano",
      "inName": "Bagian Utara Prefektur Nagano",
      "tlName": "Hilagang bahagi ng Nagano Prefecture",
      "moName": "Хойд Нагано аймаг",
      "buName": "နဂိုနိုစီရင်စုမြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដណាហ្គាណុ",
      "neName": "नागानो जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "200011",
      "name": "長野地域",
      "enName": "Nagano Area"
    },
    "class20": {
      "code": "2021800",
      "name": "千曲市",
      "enName": "Chikuma City",
      "kana": "ちくまし",
      "chName": "千曲市",
      "zhName": "千曲市",
      "koName": "지쿠마 시",
      "esName": "Ciudad de Chikuma",
      "ptName": "cidade de Chikuma",
      "thName": "เมืองชิคุมะ",
      "viName": "thành phố Chikuma",
      "inName": "kota Chikuma",
      "tlName": "siyudad ng Chikuma",
      "moName": "Чикүмa хот",
      "buName": "ကျီကုမ မြို့",
      "khName": "ទីក្រុង ឈីគូម៉ា",
      "neName": "चिकुमा सहर"
    }
  },
  "2021900": {
    "office": {
      "code": "200000",
      "name": "長野県",
      "enName": "Nagano",
      "officeName": "長野地方気象台",
      "chName": "长野县",
      "zhName": "長野縣",
      "koName": "나가노현",
      "esName": "Prefectura de Nagano",
      "ptName": "Província de Nagano",
      "thName": "จังหวัดนางาโนะ",
      "viName": "Tỉnh Nagano",
      "inName": "Prefektur Nagano",
      "tlName": "Nagano Prefecture",
      "moName": "Нагано аймаг",
      "buName": "နားဂါနို ပြည်နယ်",
      "khName": "ខេត្ដ ណាហ្គាណូ",
      "neName": "नागानो जिल्ला"
    },
    "class10": {
      "code": "200020",
      "name": "中部",
      "enName": "Central Region",
      "chName": "长野县中部",
      "zhName": "長野縣中部",
      "koName": "나가노 현 중부",
      "esName": "Centro de Prefectura de Nagano",
      "ptName": "Região central da Província de Nagano",
      "thName": "จังหวัดนางาโนะตอนกลาง",
      "viName": "Miền Trung tỉnh Nagano",
      "inName": "Bagian Tengah Prefektur Nagano",
      "tlName": "Sentral na bahagi ng Nagano Prefecture",
      "moName": "Төв Нагано аймаг",
      "buName": "နဂိုနိုစီရင်စုအလယ်ပိုင်း",
      "khName": "តំបន់កណ្តាលនៃខេត្ដណាហ្គាណុ",
      "neName": "नागानो जिल्लाको मध्य भाग"
    },
    "class15": {
      "code": "200021",
      "name": "上田地域",
      "enName": "Ueda Area"
    },
    "class20": {
      "code": "2021900",
      "name": "東御市",
      "enName": "Tomi City",
      "kana": "とうみし",
      "chName": "东御市",
      "zhName": "東御市",
      "koName": "도미 시",
      "esName": "Ciudad de Tomi",
      "ptName": "cidade de Tomi",
      "thName": "เมืองโทมิ",
      "viName": "thành phố Tomi",
      "inName": "kota Tomi",
      "tlName": "siyudad ng Tomi",
      "moName": "Томи хот",
      "buName": "တော်မိ မြို့",
      "khName": "ទីក្រុង ថូមី",
      "neName": "तोमी सहर"
    }
  },
  "2022000": {
    "office": {
      "code": "200000",
      "name": "長野県",
      "enName": "Nagano",
      "officeName": "長野地方気象台",
      "chName": "长野县",
      "zhName": "長野縣",
      "koName": "나가노현",
      "esName": "Prefectura de Nagano",
      "ptName": "Província de Nagano",
      "thName": "จังหวัดนางาโนะ",
      "viName": "Tỉnh Nagano",
      "inName": "Prefektur Nagano",
      "tlName": "Nagano Prefecture",
      "moName": "Нагано аймаг",
      "buName": "နားဂါနို ပြည်နယ်",
      "khName": "ខេត្ដ ណាហ្គាណូ",
      "neName": "नागानो जिल्ला"
    },
    "class10": {
      "code": "200020",
      "name": "中部",
      "enName": "Central Region",
      "chName": "长野县中部",
      "zhName": "長野縣中部",
      "koName": "나가노 현 중부",
      "esName": "Centro de Prefectura de Nagano",
      "ptName": "Região central da Província de Nagano",
      "thName": "จังหวัดนางาโนะตอนกลาง",
      "viName": "Miền Trung tỉnh Nagano",
      "inName": "Bagian Tengah Prefektur Nagano",
      "tlName": "Sentral na bahagi ng Nagano Prefecture",
      "moName": "Төв Нагано аймаг",
      "buName": "နဂိုနိုစီရင်စုအလယ်ပိုင်း",
      "khName": "តំបន់កណ្តាលនៃខេត្ដណាហ្គាណុ",
      "neName": "नागानो जिल्लाको मध्य भाग"
    },
    "class15": {
      "code": "200023",
      "name": "松本地域",
      "enName": "Matsumoto Area"
    },
    "class20": {
      "code": "2022000",
      "name": "安曇野市",
      "enName": "Azumino City",
      "kana": "あづみのし",
      "chName": "安昙野市",
      "zhName": "安曇野市",
      "koName": "아즈미노 시",
      "esName": "Ciudad de Azumino",
      "ptName": "cidade de Azumino",
      "thName": "เมืองอะซุมิโนะ",
      "viName": "thành phố Azumino",
      "inName": "kota Azumino",
      "tlName": "siyudad ng Azumino",
      "moName": "Aзүмино хот",
      "buName": "အာဇုမိနို မြို့",
      "khName": "ទីក្រុង អាហ្ស៊ូមីណូ",
      "neName": "आजुमिनो सहर"
    }
  },
  "2030300": {
    "office": {
      "code": "200000",
      "name": "長野県",
      "enName": "Nagano",
      "officeName": "長野地方気象台",
      "chName": "长野县",
      "zhName": "長野縣",
      "koName": "나가노현",
      "esName": "Prefectura de Nagano",
      "ptName": "Província de Nagano",
      "thName": "จังหวัดนางาโนะ",
      "viName": "Tỉnh Nagano",
      "inName": "Prefektur Nagano",
      "tlName": "Nagano Prefecture",
      "moName": "Нагано аймаг",
      "buName": "နားဂါနို ပြည်နယ်",
      "khName": "ខេត្ដ ណាហ្គាណូ",
      "neName": "नागानो जिल्ला"
    },
    "class10": {
      "code": "200020",
      "name": "中部",
      "enName": "Central Region",
      "chName": "长野县中部",
      "zhName": "長野縣中部",
      "koName": "나가노 현 중부",
      "esName": "Centro de Prefectura de Nagano",
      "ptName": "Região central da Província de Nagano",
      "thName": "จังหวัดนางาโนะตอนกลาง",
      "viName": "Miền Trung tỉnh Nagano",
      "inName": "Bagian Tengah Prefektur Nagano",
      "tlName": "Sentral na bahagi ng Nagano Prefecture",
      "moName": "Төв Нагано аймаг",
      "buName": "နဂိုနိုစီရင်စုအလယ်ပိုင်း",
      "khName": "តំបន់កណ្តាលនៃខេត្ដណាហ្គាណុ",
      "neName": "नागानो जिल्लाको मध्य भाग"
    },
    "class15": {
      "code": "200022",
      "name": "佐久地域",
      "enName": "Saku Area"
    },
    "class20": {
      "code": "2030300",
      "name": "小海町",
      "enName": "Koumi Town",
      "kana": "こうみまち",
      "chName": "小海町",
      "zhName": "小海町",
      "koName": "고우미 정",
      "esName": "Pueblo de Koumi",
      "ptName": "bairro de Koumi",
      "thName": "เมืองโคอุมิ",
      "viName": "thị trấn Koumi",
      "inName": "kota Koumi",
      "tlName": "bayan ng Koumi",
      "moName": "Коүми жижиг хот",
      "buName": "ကောဥမိ မြို့နယ်",
      "khName": "ទីប្រជុំជន គូមី",
      "neName": "कोउमी नगर"
    }
  },
  "2030400": {
    "office": {
      "code": "200000",
      "name": "長野県",
      "enName": "Nagano",
      "officeName": "長野地方気象台",
      "chName": "长野县",
      "zhName": "長野縣",
      "koName": "나가노현",
      "esName": "Prefectura de Nagano",
      "ptName": "Província de Nagano",
      "thName": "จังหวัดนางาโนะ",
      "viName": "Tỉnh Nagano",
      "inName": "Prefektur Nagano",
      "tlName": "Nagano Prefecture",
      "moName": "Нагано аймаг",
      "buName": "နားဂါနို ပြည်နယ်",
      "khName": "ខេត្ដ ណាហ្គាណូ",
      "neName": "नागानो जिल्ला"
    },
    "class10": {
      "code": "200020",
      "name": "中部",
      "enName": "Central Region",
      "chName": "长野县中部",
      "zhName": "長野縣中部",
      "koName": "나가노 현 중부",
      "esName": "Centro de Prefectura de Nagano",
      "ptName": "Região central da Província de Nagano",
      "thName": "จังหวัดนางาโนะตอนกลาง",
      "viName": "Miền Trung tỉnh Nagano",
      "inName": "Bagian Tengah Prefektur Nagano",
      "tlName": "Sentral na bahagi ng Nagano Prefecture",
      "moName": "Төв Нагано аймаг",
      "buName": "နဂိုနိုစီရင်စုအလယ်ပိုင်း",
      "khName": "តំបន់កណ្តាលនៃខេត្ដណាហ្គាណុ",
      "neName": "नागानो जिल्लाको मध्य भाग"
    },
    "class15": {
      "code": "200022",
      "name": "佐久地域",
      "enName": "Saku Area"
    },
    "class20": {
      "code": "2030400",
      "name": "川上村",
      "enName": "Kawakami Village",
      "kana": "かわかみむら",
      "chName": "长野川上村",
      "zhName": "長野川上村",
      "koName": "나가노 가와카미 촌",
      "esName": "Aldea de Kawakami, Nagano",
      "ptName": "Nagano, povoado de Kawakami",
      "thName": "หมู่บ้านคาวาคามิ นางาโนะ",
      "viName": "Làng Kawakami, Nagano",
      "inName": "Desa Kawakami, Nagano",
      "tlName": "nayon ng Kawakami, Nagano",
      "moName": "Нагано Каваками тосгон",
      "buName": "နကနိုကဝကမိရွာ",
      "khName": "ភូមិកាវ៉ាកាមី ណាហ្គាណុ",
      "neName": "नागानो कावाकामी गाउँ"
    }
  },
  "2030500": {
    "office": {
      "code": "200000",
      "name": "長野県",
      "enName": "Nagano",
      "officeName": "長野地方気象台",
      "chName": "长野县",
      "zhName": "長野縣",
      "koName": "나가노현",
      "esName": "Prefectura de Nagano",
      "ptName": "Província de Nagano",
      "thName": "จังหวัดนางาโนะ",
      "viName": "Tỉnh Nagano",
      "inName": "Prefektur Nagano",
      "tlName": "Nagano Prefecture",
      "moName": "Нагано аймаг",
      "buName": "နားဂါနို ပြည်နယ်",
      "khName": "ខេត្ដ ណាហ្គាណូ",
      "neName": "नागानो जिल्ला"
    },
    "class10": {
      "code": "200020",
      "name": "中部",
      "enName": "Central Region",
      "chName": "长野县中部",
      "zhName": "長野縣中部",
      "koName": "나가노 현 중부",
      "esName": "Centro de Prefectura de Nagano",
      "ptName": "Região central da Província de Nagano",
      "thName": "จังหวัดนางาโนะตอนกลาง",
      "viName": "Miền Trung tỉnh Nagano",
      "inName": "Bagian Tengah Prefektur Nagano",
      "tlName": "Sentral na bahagi ng Nagano Prefecture",
      "moName": "Төв Нагано аймаг",
      "buName": "နဂိုနိုစီရင်စုအလယ်ပိုင်း",
      "khName": "តំបន់កណ្តាលនៃខេត្ដណាហ្គាណុ",
      "neName": "नागानो जिल्लाको मध्य भाग"
    },
    "class15": {
      "code": "200022",
      "name": "佐久地域",
      "enName": "Saku Area"
    },
    "class20": {
      "code": "2030500",
      "name": "南牧村",
      "enName": "Minamimaki Village",
      "kana": "みなみまきむら",
      "chName": "长野南牧村",
      "zhName": "長野南牧村",
      "koName": "나가노 미나미마키 촌",
      "esName": "Aldea de Minamimaki, Nagano",
      "ptName": "Nagano, povoado de Minamimaki",
      "thName": "หมู่บ้านมินามิมาคิ นางาโนะ",
      "viName": "Làng Nammoku, Nagano",
      "inName": "Desa Minamimaki, Nagano",
      "tlName": "nayon ng Minamimaki, Nagano",
      "moName": "Нагано Минамимаки тосгон",
      "buName": "နကနိုနမိခိရွာ",
      "khName": "ភូមិមីណាមិម៉ាគី ណាហ្គាណុ",
      "neName": "नागानो मिनामीमाकी गाउँ"
    }
  },
  "2030600": {
    "office": {
      "code": "200000",
      "name": "長野県",
      "enName": "Nagano",
      "officeName": "長野地方気象台",
      "chName": "长野县",
      "zhName": "長野縣",
      "koName": "나가노현",
      "esName": "Prefectura de Nagano",
      "ptName": "Província de Nagano",
      "thName": "จังหวัดนางาโนะ",
      "viName": "Tỉnh Nagano",
      "inName": "Prefektur Nagano",
      "tlName": "Nagano Prefecture",
      "moName": "Нагано аймаг",
      "buName": "နားဂါနို ပြည်နယ်",
      "khName": "ខេត្ដ ណាហ្គាណូ",
      "neName": "नागानो जिल्ला"
    },
    "class10": {
      "code": "200020",
      "name": "中部",
      "enName": "Central Region",
      "chName": "长野县中部",
      "zhName": "長野縣中部",
      "koName": "나가노 현 중부",
      "esName": "Centro de Prefectura de Nagano",
      "ptName": "Região central da Província de Nagano",
      "thName": "จังหวัดนางาโนะตอนกลาง",
      "viName": "Miền Trung tỉnh Nagano",
      "inName": "Bagian Tengah Prefektur Nagano",
      "tlName": "Sentral na bahagi ng Nagano Prefecture",
      "moName": "Төв Нагано аймаг",
      "buName": "နဂိုနိုစီရင်စုအလယ်ပိုင်း",
      "khName": "តំបន់កណ្តាលនៃខេត្ដណាហ្គាណុ",
      "neName": "नागानो जिल्लाको मध्य भाग"
    },
    "class15": {
      "code": "200022",
      "name": "佐久地域",
      "enName": "Saku Area"
    },
    "class20": {
      "code": "2030600",
      "name": "南相木村",
      "enName": "Minamiaiki Village",
      "kana": "みなみあいきむら",
      "chName": "南相木村",
      "zhName": "南相木村",
      "koName": "미나미아이키 촌",
      "esName": "Aldea de Minami-aiki",
      "ptName": "povoado de Minamiaiki",
      "thName": "หมู่บ้านมินามิไอกิ",
      "viName": "làng Minamiaiki",
      "inName": "desa Minamiaiki",
      "tlName": "nayon ng Minamiaiki",
      "moName": "Минaмиaйки тосгон",
      "buName": "မီနားမိယာယိကိ ကျေးရွာ",
      "khName": "ភូមិ មីណាមីអាយគី",
      "neName": "मिनामिआइकी गाउँ"
    }
  },
  "2030700": {
    "office": {
      "code": "200000",
      "name": "長野県",
      "enName": "Nagano",
      "officeName": "長野地方気象台",
      "chName": "长野县",
      "zhName": "長野縣",
      "koName": "나가노현",
      "esName": "Prefectura de Nagano",
      "ptName": "Província de Nagano",
      "thName": "จังหวัดนางาโนะ",
      "viName": "Tỉnh Nagano",
      "inName": "Prefektur Nagano",
      "tlName": "Nagano Prefecture",
      "moName": "Нагано аймаг",
      "buName": "နားဂါနို ပြည်နယ်",
      "khName": "ខេត្ដ ណាហ្គាណូ",
      "neName": "नागानो जिल्ला"
    },
    "class10": {
      "code": "200020",
      "name": "中部",
      "enName": "Central Region",
      "chName": "长野县中部",
      "zhName": "長野縣中部",
      "koName": "나가노 현 중부",
      "esName": "Centro de Prefectura de Nagano",
      "ptName": "Região central da Província de Nagano",
      "thName": "จังหวัดนางาโนะตอนกลาง",
      "viName": "Miền Trung tỉnh Nagano",
      "inName": "Bagian Tengah Prefektur Nagano",
      "tlName": "Sentral na bahagi ng Nagano Prefecture",
      "moName": "Төв Нагано аймаг",
      "buName": "နဂိုနိုစီရင်စုအလယ်ပိုင်း",
      "khName": "តំបន់កណ្តាលនៃខេត្ដណាហ្គាណុ",
      "neName": "नागानो जिल्लाको मध्य भाग"
    },
    "class15": {
      "code": "200022",
      "name": "佐久地域",
      "enName": "Saku Area"
    },
    "class20": {
      "code": "2030700",
      "name": "北相木村",
      "enName": "Kitaaiki Village",
      "kana": "きたあいきむら",
      "chName": "北相木村",
      "zhName": "北相木村",
      "koName": "기타아이키 촌",
      "esName": "Aldea de Kita-aiki",
      "ptName": "povoado de Kitaaiki",
      "thName": "หมู่บ้านคิตะอากิ",
      "viName": "làng Kitaaiki",
      "inName": "desa Kitaaiki",
      "tlName": "nayon ng Kitaaiki",
      "moName": "Китаaйки тосгон",
      "buName": "ခီတားယိကိ ကျေးရွာ",
      "khName": "ភូមិ គីតាអៃគី",
      "neName": "किताआइकी गाउँ"
    }
  },
  "2030900": {
    "office": {
      "code": "200000",
      "name": "長野県",
      "enName": "Nagano",
      "officeName": "長野地方気象台",
      "chName": "长野县",
      "zhName": "長野縣",
      "koName": "나가노현",
      "esName": "Prefectura de Nagano",
      "ptName": "Província de Nagano",
      "thName": "จังหวัดนางาโนะ",
      "viName": "Tỉnh Nagano",
      "inName": "Prefektur Nagano",
      "tlName": "Nagano Prefecture",
      "moName": "Нагано аймаг",
      "buName": "နားဂါနို ပြည်နယ်",
      "khName": "ខេត្ដ ណាហ្គាណូ",
      "neName": "नागानो जिल्ला"
    },
    "class10": {
      "code": "200020",
      "name": "中部",
      "enName": "Central Region",
      "chName": "长野县中部",
      "zhName": "長野縣中部",
      "koName": "나가노 현 중부",
      "esName": "Centro de Prefectura de Nagano",
      "ptName": "Região central da Província de Nagano",
      "thName": "จังหวัดนางาโนะตอนกลาง",
      "viName": "Miền Trung tỉnh Nagano",
      "inName": "Bagian Tengah Prefektur Nagano",
      "tlName": "Sentral na bahagi ng Nagano Prefecture",
      "moName": "Төв Нагано аймаг",
      "buName": "နဂိုနိုစီရင်စုအလယ်ပိုင်း",
      "khName": "តំបន់កណ្តាលនៃខេត្ដណាហ្គាណុ",
      "neName": "नागानो जिल्लाको मध्य भाग"
    },
    "class15": {
      "code": "200022",
      "name": "佐久地域",
      "enName": "Saku Area"
    },
    "class20": {
      "code": "2030900",
      "name": "佐久穂町",
      "enName": "Sakuho Town",
      "kana": "さくほまち",
      "chName": "佐久穗町",
      "zhName": "佐久穗町",
      "koName": "사쿠호 정",
      "esName": "Pueblo de Sakuho",
      "ptName": "bairro de Sakuho",
      "thName": "เมืองซาคุโฮะ",
      "viName": "thị trấn Sakuho",
      "inName": "kota Sakuho",
      "tlName": "bayan ng Sakuho",
      "moName": "Сaкүхо жижиг хот",
      "buName": "ဆားကုဟို မြို့နယ်",
      "khName": "ទីប្រជុំជន សាគូហូ",
      "neName": "साकुहो नगर"
    }
  },
  "2032100": {
    "office": {
      "code": "200000",
      "name": "長野県",
      "enName": "Nagano",
      "officeName": "長野地方気象台",
      "chName": "长野县",
      "zhName": "長野縣",
      "koName": "나가노현",
      "esName": "Prefectura de Nagano",
      "ptName": "Província de Nagano",
      "thName": "จังหวัดนางาโนะ",
      "viName": "Tỉnh Nagano",
      "inName": "Prefektur Nagano",
      "tlName": "Nagano Prefecture",
      "moName": "Нагано аймаг",
      "buName": "နားဂါနို ပြည်နယ်",
      "khName": "ខេត្ដ ណាហ្គាណូ",
      "neName": "नागानो जिल्ला"
    },
    "class10": {
      "code": "200020",
      "name": "中部",
      "enName": "Central Region",
      "chName": "长野县中部",
      "zhName": "長野縣中部",
      "koName": "나가노 현 중부",
      "esName": "Centro de Prefectura de Nagano",
      "ptName": "Região central da Província de Nagano",
      "thName": "จังหวัดนางาโนะตอนกลาง",
      "viName": "Miền Trung tỉnh Nagano",
      "inName": "Bagian Tengah Prefektur Nagano",
      "tlName": "Sentral na bahagi ng Nagano Prefecture",
      "moName": "Төв Нагано аймаг",
      "buName": "နဂိုနိုစီရင်စုအလယ်ပိုင်း",
      "khName": "តំបន់កណ្តាលនៃខេត្ដណាហ្គាណុ",
      "neName": "नागानो जिल्लाको मध्य भाग"
    },
    "class15": {
      "code": "200022",
      "name": "佐久地域",
      "enName": "Saku Area"
    },
    "class20": {
      "code": "2032100",
      "name": "軽井沢町",
      "enName": "Karuizawa Town",
      "kana": "かるいざわまち",
      "chName": "轻井泽町",
      "zhName": "輕井澤町",
      "koName": "가루이자와 정",
      "esName": "Pueblo de Karuizawa",
      "ptName": "bairro de Karuizawa",
      "thName": "เมืองคารุอิซาวา",
      "viName": "thị trấn Karuizawa",
      "inName": "kota Karuizawa",
      "tlName": "bayan ng Karuizawa",
      "moName": "Карүйзава жижиг хот",
      "buName": "ခါရုယိဇာ့ဝ မြို့နယ်",
      "khName": "ទីប្រជុំជន ការូអ៊ីសាវ៉ា",
      "neName": "कारुइजावा नगर"
    }
  },
  "2032300": {
    "office": {
      "code": "200000",
      "name": "長野県",
      "enName": "Nagano",
      "officeName": "長野地方気象台",
      "chName": "长野县",
      "zhName": "長野縣",
      "koName": "나가노현",
      "esName": "Prefectura de Nagano",
      "ptName": "Província de Nagano",
      "thName": "จังหวัดนางาโนะ",
      "viName": "Tỉnh Nagano",
      "inName": "Prefektur Nagano",
      "tlName": "Nagano Prefecture",
      "moName": "Нагано аймаг",
      "buName": "နားဂါနို ပြည်နယ်",
      "khName": "ខេត្ដ ណាហ្គាណូ",
      "neName": "नागानो जिल्ला"
    },
    "class10": {
      "code": "200020",
      "name": "中部",
      "enName": "Central Region",
      "chName": "长野县中部",
      "zhName": "長野縣中部",
      "koName": "나가노 현 중부",
      "esName": "Centro de Prefectura de Nagano",
      "ptName": "Região central da Província de Nagano",
      "thName": "จังหวัดนางาโนะตอนกลาง",
      "viName": "Miền Trung tỉnh Nagano",
      "inName": "Bagian Tengah Prefektur Nagano",
      "tlName": "Sentral na bahagi ng Nagano Prefecture",
      "moName": "Төв Нагано аймаг",
      "buName": "နဂိုနိုစီရင်စုအလယ်ပိုင်း",
      "khName": "តំបន់កណ្តាលនៃខេត្ដណាហ្គាណុ",
      "neName": "नागानो जिल्लाको मध्य भाग"
    },
    "class15": {
      "code": "200022",
      "name": "佐久地域",
      "enName": "Saku Area"
    },
    "class20": {
      "code": "2032300",
      "name": "御代田町",
      "enName": "Miyota Town",
      "kana": "みよたまち",
      "chName": "御代田町",
      "zhName": "御代田町",
      "koName": "미요타 정",
      "esName": "Pueblo de Miyota",
      "ptName": "bairro de Miyota",
      "thName": "เมืองมิโยตะ",
      "viName": "thị trấn Miyota",
      "inName": "kota Miyota",
      "tlName": "bayan ng Miyota",
      "moName": "Миёота жижиг хот",
      "buName": "မီယောတ မြို့နယ်",
      "khName": "ទីប្រជុំជន មីយ៉ូតា",
      "neName": "मियोता नगर"
    }
  },
  "2032400": {
    "office": {
      "code": "200000",
      "name": "長野県",
      "enName": "Nagano",
      "officeName": "長野地方気象台",
      "chName": "长野县",
      "zhName": "長野縣",
      "koName": "나가노현",
      "esName": "Prefectura de Nagano",
      "ptName": "Província de Nagano",
      "thName": "จังหวัดนางาโนะ",
      "viName": "Tỉnh Nagano",
      "inName": "Prefektur Nagano",
      "tlName": "Nagano Prefecture",
      "moName": "Нагано аймаг",
      "buName": "နားဂါနို ပြည်နယ်",
      "khName": "ខេត្ដ ណាហ្គាណូ",
      "neName": "नागानो जिल्ला"
    },
    "class10": {
      "code": "200020",
      "name": "中部",
      "enName": "Central Region",
      "chName": "长野县中部",
      "zhName": "長野縣中部",
      "koName": "나가노 현 중부",
      "esName": "Centro de Prefectura de Nagano",
      "ptName": "Região central da Província de Nagano",
      "thName": "จังหวัดนางาโนะตอนกลาง",
      "viName": "Miền Trung tỉnh Nagano",
      "inName": "Bagian Tengah Prefektur Nagano",
      "tlName": "Sentral na bahagi ng Nagano Prefecture",
      "moName": "Төв Нагано аймаг",
      "buName": "နဂိုနိုစီရင်စုအလယ်ပိုင်း",
      "khName": "តំបន់កណ្តាលនៃខេត្ដណាហ្គាណុ",
      "neName": "नागानो जिल्लाको मध्य भाग"
    },
    "class15": {
      "code": "200022",
      "name": "佐久地域",
      "enName": "Saku Area"
    },
    "class20": {
      "code": "2032400",
      "name": "立科町",
      "enName": "Tateshina Town",
      "kana": "たてしなまち",
      "chName": "立科町",
      "zhName": "立科町",
      "koName": "다테시나 정",
      "esName": "Pueblo de Tateshina",
      "ptName": "bairro de Tateshina",
      "thName": "เมืองทาเทชินะ",
      "viName": "thị trấn Tateshina",
      "inName": "kota Tateshina",
      "tlName": "bayan ng Tateshina",
      "moName": "Татэшинa жижиг хот",
      "buName": "တာတဲရှိန မြို့နယ်",
      "khName": "ទីប្រជុំជន តាតេស៊ីណា",
      "neName": "तातेशिना नगर"
    }
  },
  "2034900": {
    "office": {
      "code": "200000",
      "name": "長野県",
      "enName": "Nagano",
      "officeName": "長野地方気象台",
      "chName": "长野县",
      "zhName": "長野縣",
      "koName": "나가노현",
      "esName": "Prefectura de Nagano",
      "ptName": "Província de Nagano",
      "thName": "จังหวัดนางาโนะ",
      "viName": "Tỉnh Nagano",
      "inName": "Prefektur Nagano",
      "tlName": "Nagano Prefecture",
      "moName": "Нагано аймаг",
      "buName": "နားဂါနို ပြည်နယ်",
      "khName": "ខេត្ដ ណាហ្គាណូ",
      "neName": "नागानो जिल्ला"
    },
    "class10": {
      "code": "200020",
      "name": "中部",
      "enName": "Central Region",
      "chName": "长野县中部",
      "zhName": "長野縣中部",
      "koName": "나가노 현 중부",
      "esName": "Centro de Prefectura de Nagano",
      "ptName": "Região central da Província de Nagano",
      "thName": "จังหวัดนางาโนะตอนกลาง",
      "viName": "Miền Trung tỉnh Nagano",
      "inName": "Bagian Tengah Prefektur Nagano",
      "tlName": "Sentral na bahagi ng Nagano Prefecture",
      "moName": "Төв Нагано аймаг",
      "buName": "နဂိုနိုစီရင်စုအလယ်ပိုင်း",
      "khName": "តំបន់កណ្តាលនៃខេត្ដណាហ្គាណុ",
      "neName": "नागानो जिल्लाको मध्य भाग"
    },
    "class15": {
      "code": "200021",
      "name": "上田地域",
      "enName": "Ueda Area"
    },
    "class20": {
      "code": "2034900",
      "name": "青木村",
      "enName": "Aoki Village",
      "kana": "あおきむら",
      "chName": "青木村",
      "zhName": "青木村",
      "koName": "아오키 촌",
      "esName": "Aldea de Aoki",
      "ptName": "povoado de Aoki",
      "thName": "หมู่บ้านอาโอกิ",
      "viName": "làng Aoki",
      "inName": "desa Aoki",
      "tlName": "nayon ng Aoki",
      "moName": "Aоки тосгон",
      "buName": "အာအိုကိ ကျေးရွာ",
      "khName": "ភូមិ អាគី",
      "neName": "आओकी गाउँ"
    }
  },
  "2035000": {
    "office": {
      "code": "200000",
      "name": "長野県",
      "enName": "Nagano",
      "officeName": "長野地方気象台",
      "chName": "长野县",
      "zhName": "長野縣",
      "koName": "나가노현",
      "esName": "Prefectura de Nagano",
      "ptName": "Província de Nagano",
      "thName": "จังหวัดนางาโนะ",
      "viName": "Tỉnh Nagano",
      "inName": "Prefektur Nagano",
      "tlName": "Nagano Prefecture",
      "moName": "Нагано аймаг",
      "buName": "နားဂါနို ပြည်နယ်",
      "khName": "ខេត្ដ ណាហ្គាណូ",
      "neName": "नागानो जिल्ला"
    },
    "class10": {
      "code": "200020",
      "name": "中部",
      "enName": "Central Region",
      "chName": "长野县中部",
      "zhName": "長野縣中部",
      "koName": "나가노 현 중부",
      "esName": "Centro de Prefectura de Nagano",
      "ptName": "Região central da Província de Nagano",
      "thName": "จังหวัดนางาโนะตอนกลาง",
      "viName": "Miền Trung tỉnh Nagano",
      "inName": "Bagian Tengah Prefektur Nagano",
      "tlName": "Sentral na bahagi ng Nagano Prefecture",
      "moName": "Төв Нагано аймаг",
      "buName": "နဂိုနိုစီရင်စုအလယ်ပိုင်း",
      "khName": "តំបន់កណ្តាលនៃខេត្ដណាហ្គាណុ",
      "neName": "नागानो जिल्लाको मध्य भाग"
    },
    "class15": {
      "code": "200021",
      "name": "上田地域",
      "enName": "Ueda Area"
    },
    "class20": {
      "code": "2035000",
      "name": "長和町",
      "enName": "Nagawa Town",
      "kana": "ながわまち",
      "chName": "长和町",
      "zhName": "長和町",
      "koName": "나가와 정",
      "esName": "Pueblo de Nagawa",
      "ptName": "bairro de Nagawa",
      "thName": "เมืองนางาวะ",
      "viName": "thị trấn Nagawa",
      "inName": "kota Nagawa",
      "tlName": "bayan ng Nagawa",
      "moName": "Нaгава жижиг хот",
      "buName": "နာဂါ့ဝ မြို့နယ်",
      "khName": "ទីប្រជុំជន ណាហ្គាវ៉ា",
      "neName": "नागावा नगर"
    }
  },
  "2036100": {
    "office": {
      "code": "200000",
      "name": "長野県",
      "enName": "Nagano",
      "officeName": "長野地方気象台",
      "chName": "长野县",
      "zhName": "長野縣",
      "koName": "나가노현",
      "esName": "Prefectura de Nagano",
      "ptName": "Província de Nagano",
      "thName": "จังหวัดนางาโนะ",
      "viName": "Tỉnh Nagano",
      "inName": "Prefektur Nagano",
      "tlName": "Nagano Prefecture",
      "moName": "Нагано аймаг",
      "buName": "နားဂါနို ပြည်နယ်",
      "khName": "ខេត្ដ ណាហ្គាណូ",
      "neName": "नागानो जिल्ला"
    },
    "class10": {
      "code": "200020",
      "name": "中部",
      "enName": "Central Region",
      "chName": "长野县中部",
      "zhName": "長野縣中部",
      "koName": "나가노 현 중부",
      "esName": "Centro de Prefectura de Nagano",
      "ptName": "Região central da Província de Nagano",
      "thName": "จังหวัดนางาโนะตอนกลาง",
      "viName": "Miền Trung tỉnh Nagano",
      "inName": "Bagian Tengah Prefektur Nagano",
      "tlName": "Sentral na bahagi ng Nagano Prefecture",
      "moName": "Төв Нагано аймаг",
      "buName": "နဂိုနိုစီရင်စုအလယ်ပိုင်း",
      "khName": "តំបន់កណ្តាលនៃខេត្ដណាហ្គាណុ",
      "neName": "नागानो जिल्लाको मध्य भाग"
    },
    "class15": {
      "code": "200025",
      "name": "諏訪地域",
      "enName": "Suwa Area"
    },
    "class20": {
      "code": "2036100",
      "name": "下諏訪町",
      "enName": "Shimosuwa Town",
      "kana": "しもすわまち",
      "chName": "下诹访町",
      "zhName": "下諏訪町",
      "koName": "시모스와 정",
      "esName": "Pueblo de Shimosuwa",
      "ptName": "bairro de Shimosuwa",
      "thName": "เมืองชิโมสึวะ",
      "viName": "thị trấn Shimosuwa",
      "inName": "kota Shimosuwa",
      "tlName": "bayan ng Shimosuwa",
      "moName": "Шимосүва жижиг хот",
      "buName": "ရှီမောဆုဝ မြို့နယ်",
      "khName": "ទីប្រជុំជន ស៊ីម៉ូស៊ូវ៉ា",
      "neName": "शिमोसुवा नगर"
    }
  },
  "2036200": {
    "office": {
      "code": "200000",
      "name": "長野県",
      "enName": "Nagano",
      "officeName": "長野地方気象台",
      "chName": "长野县",
      "zhName": "長野縣",
      "koName": "나가노현",
      "esName": "Prefectura de Nagano",
      "ptName": "Província de Nagano",
      "thName": "จังหวัดนางาโนะ",
      "viName": "Tỉnh Nagano",
      "inName": "Prefektur Nagano",
      "tlName": "Nagano Prefecture",
      "moName": "Нагано аймаг",
      "buName": "နားဂါနို ပြည်နယ်",
      "khName": "ខេត្ដ ណាហ្គាណូ",
      "neName": "नागानो जिल्ला"
    },
    "class10": {
      "code": "200020",
      "name": "中部",
      "enName": "Central Region",
      "chName": "长野县中部",
      "zhName": "長野縣中部",
      "koName": "나가노 현 중부",
      "esName": "Centro de Prefectura de Nagano",
      "ptName": "Região central da Província de Nagano",
      "thName": "จังหวัดนางาโนะตอนกลาง",
      "viName": "Miền Trung tỉnh Nagano",
      "inName": "Bagian Tengah Prefektur Nagano",
      "tlName": "Sentral na bahagi ng Nagano Prefecture",
      "moName": "Төв Нагано аймаг",
      "buName": "နဂိုနိုစီရင်စုအလယ်ပိုင်း",
      "khName": "តំបន់កណ្តាលនៃខេត្ដណាហ្គាណុ",
      "neName": "नागानो जिल्लाको मध्य भाग"
    },
    "class15": {
      "code": "200025",
      "name": "諏訪地域",
      "enName": "Suwa Area"
    },
    "class20": {
      "code": "2036200",
      "name": "富士見町",
      "enName": "Fujimi Town",
      "kana": "ふじみまち",
      "chName": "富士见町",
      "zhName": "富士見町",
      "koName": "후지미 정",
      "esName": "Pueblo de Fujimi",
      "ptName": "bairro de Fujimi",
      "thName": "เมืองฟุจิมิ",
      "viName": "thị trấn Fujimi",
      "inName": "kota Fujimi",
      "tlName": "bayan ng Fujimi",
      "moName": "Фүжими жижиг хот",
      "buName": "ဟူဂျိမိ မြို့နယ်",
      "khName": "ទីប្រជុំជន ហ្វូជីមី",
      "neName": "फुजिमी नगर"
    }
  },
  "2036300": {
    "office": {
      "code": "200000",
      "name": "長野県",
      "enName": "Nagano",
      "officeName": "長野地方気象台",
      "chName": "长野县",
      "zhName": "長野縣",
      "koName": "나가노현",
      "esName": "Prefectura de Nagano",
      "ptName": "Província de Nagano",
      "thName": "จังหวัดนางาโนะ",
      "viName": "Tỉnh Nagano",
      "inName": "Prefektur Nagano",
      "tlName": "Nagano Prefecture",
      "moName": "Нагано аймаг",
      "buName": "နားဂါနို ပြည်နယ်",
      "khName": "ខេត្ដ ណាហ្គាណូ",
      "neName": "नागानो जिल्ला"
    },
    "class10": {
      "code": "200020",
      "name": "中部",
      "enName": "Central Region",
      "chName": "长野县中部",
      "zhName": "長野縣中部",
      "koName": "나가노 현 중부",
      "esName": "Centro de Prefectura de Nagano",
      "ptName": "Região central da Província de Nagano",
      "thName": "จังหวัดนางาโนะตอนกลาง",
      "viName": "Miền Trung tỉnh Nagano",
      "inName": "Bagian Tengah Prefektur Nagano",
      "tlName": "Sentral na bahagi ng Nagano Prefecture",
      "moName": "Төв Нагано аймаг",
      "buName": "နဂိုနိုစီရင်စုအလယ်ပိုင်း",
      "khName": "តំបន់កណ្តាលនៃខេត្ដណាហ្គាណុ",
      "neName": "नागानो जिल्लाको मध्य भाग"
    },
    "class15": {
      "code": "200025",
      "name": "諏訪地域",
      "enName": "Suwa Area"
    },
    "class20": {
      "code": "2036300",
      "name": "原村",
      "enName": "Hara Village",
      "kana": "はらむら",
      "chName": "原村",
      "zhName": "原村",
      "koName": "하라 촌",
      "esName": "Aldea de Hara",
      "ptName": "povoado de Hara",
      "thName": "หมู่บ้านฮาระ",
      "viName": "làng Hara",
      "inName": "desa Hara",
      "tlName": "nayon ng Hara",
      "moName": "Хaра тосгон",
      "buName": "ဟာရ ကျေးရွာ",
      "khName": "ភូមិ ហារ៉ា",
      "neName": "हारा गाउँ"
    }
  },
  "2038200": {
    "office": {
      "code": "200000",
      "name": "長野県",
      "enName": "Nagano",
      "officeName": "長野地方気象台",
      "chName": "长野县",
      "zhName": "長野縣",
      "koName": "나가노현",
      "esName": "Prefectura de Nagano",
      "ptName": "Província de Nagano",
      "thName": "จังหวัดนางาโนะ",
      "viName": "Tỉnh Nagano",
      "inName": "Prefektur Nagano",
      "tlName": "Nagano Prefecture",
      "moName": "Нагано аймаг",
      "buName": "နားဂါနို ပြည်နယ်",
      "khName": "ខេត្ដ ណាហ្គាណូ",
      "neName": "नागानो जिल्ला"
    },
    "class10": {
      "code": "200030",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "长野县南部",
      "zhName": "長野縣南部",
      "koName": "나가노 현 남부",
      "esName": "Sur de Prefectura de Nagano",
      "ptName": "Região sul da Província de Nagano",
      "thName": "จังหวัดนางาโนะตอนใต้",
      "viName": "Miền Nam tỉnh Nagano",
      "inName": "Bagian Selatan Prefektur Nagano",
      "tlName": "Timog na bahagi ng Nagano Prefecture",
      "moName": "Өмнөд Нагано аймаг",
      "buName": "နဂိုနိုစီရင်စုတောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដណាហ្គាណុ",
      "neName": "नागानो जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "200031",
      "name": "上伊那地域",
      "enName": "Kamiina Area"
    },
    "class20": {
      "code": "2038200",
      "name": "辰野町",
      "enName": "Tatsuno Town",
      "kana": "たつのまち",
      "chName": "辰野町",
      "zhName": "辰野町",
      "koName": "다쓰노 정",
      "esName": "Pueblo de Tatsuno",
      "ptName": "bairro de Tatsuno",
      "thName": "เมืองทัตสึโนะ",
      "viName": "thị trấn Tatsuno",
      "inName": "kota Tatsuno",
      "tlName": "bayan ng Tatsuno",
      "moName": "Тацүно жижиг хот",
      "buName": "တတ်ဆူနို မြို့နယ်",
      "khName": "ទីប្រជុំជន តាស៊ូណូ",
      "neName": "तात्सुनो नगर"
    }
  },
  "2038300": {
    "office": {
      "code": "200000",
      "name": "長野県",
      "enName": "Nagano",
      "officeName": "長野地方気象台",
      "chName": "长野县",
      "zhName": "長野縣",
      "koName": "나가노현",
      "esName": "Prefectura de Nagano",
      "ptName": "Província de Nagano",
      "thName": "จังหวัดนางาโนะ",
      "viName": "Tỉnh Nagano",
      "inName": "Prefektur Nagano",
      "tlName": "Nagano Prefecture",
      "moName": "Нагано аймаг",
      "buName": "နားဂါနို ပြည်နယ်",
      "khName": "ខេត្ដ ណាហ្គាណូ",
      "neName": "नागानो जिल्ला"
    },
    "class10": {
      "code": "200030",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "长野县南部",
      "zhName": "長野縣南部",
      "koName": "나가노 현 남부",
      "esName": "Sur de Prefectura de Nagano",
      "ptName": "Região sul da Província de Nagano",
      "thName": "จังหวัดนางาโนะตอนใต้",
      "viName": "Miền Nam tỉnh Nagano",
      "inName": "Bagian Selatan Prefektur Nagano",
      "tlName": "Timog na bahagi ng Nagano Prefecture",
      "moName": "Өмнөд Нагано аймаг",
      "buName": "နဂိုနိုစီရင်စုတောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដណាហ្គាណុ",
      "neName": "नागानो जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "200031",
      "name": "上伊那地域",
      "enName": "Kamiina Area"
    },
    "class20": {
      "code": "2038300",
      "name": "箕輪町",
      "enName": "Minowa Town",
      "kana": "みのわまち",
      "chName": "箕轮町",
      "zhName": "箕輪町",
      "koName": "미노와 정",
      "esName": "Pueblo de Minowa",
      "ptName": "bairro de Minowa",
      "thName": "เมืองมิโนะวะ",
      "viName": "thị trấn Minowa",
      "inName": "kota Minowa",
      "tlName": "bayan ng Minowa",
      "moName": "Минова жижиг хот",
      "buName": "မီနိုဝ မြို့နယ်",
      "khName": "ទីប្រជុំជន មីណូវ៉ា",
      "neName": "मिनोवा नगर"
    }
  },
  "2038400": {
    "office": {
      "code": "200000",
      "name": "長野県",
      "enName": "Nagano",
      "officeName": "長野地方気象台",
      "chName": "长野县",
      "zhName": "長野縣",
      "koName": "나가노현",
      "esName": "Prefectura de Nagano",
      "ptName": "Província de Nagano",
      "thName": "จังหวัดนางาโนะ",
      "viName": "Tỉnh Nagano",
      "inName": "Prefektur Nagano",
      "tlName": "Nagano Prefecture",
      "moName": "Нагано аймаг",
      "buName": "နားဂါနို ပြည်နယ်",
      "khName": "ខេត្ដ ណាហ្គាណូ",
      "neName": "नागानो जिल्ला"
    },
    "class10": {
      "code": "200030",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "长野县南部",
      "zhName": "長野縣南部",
      "koName": "나가노 현 남부",
      "esName": "Sur de Prefectura de Nagano",
      "ptName": "Região sul da Província de Nagano",
      "thName": "จังหวัดนางาโนะตอนใต้",
      "viName": "Miền Nam tỉnh Nagano",
      "inName": "Bagian Selatan Prefektur Nagano",
      "tlName": "Timog na bahagi ng Nagano Prefecture",
      "moName": "Өмнөд Нагано аймаг",
      "buName": "နဂိုနိုစီရင်စုတောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដណាហ្គាណុ",
      "neName": "नागानो जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "200031",
      "name": "上伊那地域",
      "enName": "Kamiina Area"
    },
    "class20": {
      "code": "2038400",
      "name": "飯島町",
      "enName": "Iijima Town",
      "kana": "いいじままち",
      "chName": "饭岛町",
      "zhName": "飯島町",
      "koName": "이이지마 정",
      "esName": "Pueblo de Iijima",
      "ptName": "bairro de Iijima",
      "thName": "เมืองอิอิจิมะ",
      "viName": "thị trấn Iijima",
      "inName": "kota Iijima",
      "tlName": "bayan ng Iijima",
      "moName": "Ийжимa жижиг хот",
      "buName": "အီယိဂျိမ မြို့နယ်",
      "khName": "ទីប្រជុំជន អ៊ីជីម៉ា",
      "neName": "आइजिमा नगर"
    }
  },
  "2038500": {
    "office": {
      "code": "200000",
      "name": "長野県",
      "enName": "Nagano",
      "officeName": "長野地方気象台",
      "chName": "长野县",
      "zhName": "長野縣",
      "koName": "나가노현",
      "esName": "Prefectura de Nagano",
      "ptName": "Província de Nagano",
      "thName": "จังหวัดนางาโนะ",
      "viName": "Tỉnh Nagano",
      "inName": "Prefektur Nagano",
      "tlName": "Nagano Prefecture",
      "moName": "Нагано аймаг",
      "buName": "နားဂါနို ပြည်နယ်",
      "khName": "ខេត្ដ ណាហ្គាណូ",
      "neName": "नागानो जिल्ला"
    },
    "class10": {
      "code": "200030",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "长野县南部",
      "zhName": "長野縣南部",
      "koName": "나가노 현 남부",
      "esName": "Sur de Prefectura de Nagano",
      "ptName": "Região sul da Província de Nagano",
      "thName": "จังหวัดนางาโนะตอนใต้",
      "viName": "Miền Nam tỉnh Nagano",
      "inName": "Bagian Selatan Prefektur Nagano",
      "tlName": "Timog na bahagi ng Nagano Prefecture",
      "moName": "Өмнөд Нагано аймаг",
      "buName": "နဂိုနိုစီရင်စုတောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដណាហ្គាណុ",
      "neName": "नागानो जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "200031",
      "name": "上伊那地域",
      "enName": "Kamiina Area"
    },
    "class20": {
      "code": "2038500",
      "name": "南箕輪村",
      "enName": "Minamiminowa Village",
      "kana": "みなみみのわむら",
      "chName": "南箕轮町",
      "zhName": "南箕輪村",
      "koName": "미나미미노와 촌",
      "esName": "Aldea de Minami-Minowa",
      "ptName": "povoado de Minamiminowa",
      "thName": "หมู่บ้านมินามิมิโนวะ",
      "viName": "làng Minamiminowa",
      "inName": "desa Minamiminowa",
      "tlName": "nayon ng Minamiminowa",
      "moName": "Минaмиминова тосгон",
      "buName": "မီနားမိမိနိုဝ ကျေးရွာ",
      "khName": "ភូមិ មីណាមីមីណូវ៉ា",
      "neName": "मिनामिमिनोवा गाउँ"
    }
  },
  "2038600": {
    "office": {
      "code": "200000",
      "name": "長野県",
      "enName": "Nagano",
      "officeName": "長野地方気象台",
      "chName": "长野县",
      "zhName": "長野縣",
      "koName": "나가노현",
      "esName": "Prefectura de Nagano",
      "ptName": "Província de Nagano",
      "thName": "จังหวัดนางาโนะ",
      "viName": "Tỉnh Nagano",
      "inName": "Prefektur Nagano",
      "tlName": "Nagano Prefecture",
      "moName": "Нагано аймаг",
      "buName": "နားဂါနို ပြည်နယ်",
      "khName": "ខេត្ដ ណាហ្គាណូ",
      "neName": "नागानो जिल्ला"
    },
    "class10": {
      "code": "200030",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "长野县南部",
      "zhName": "長野縣南部",
      "koName": "나가노 현 남부",
      "esName": "Sur de Prefectura de Nagano",
      "ptName": "Região sul da Província de Nagano",
      "thName": "จังหวัดนางาโนะตอนใต้",
      "viName": "Miền Nam tỉnh Nagano",
      "inName": "Bagian Selatan Prefektur Nagano",
      "tlName": "Timog na bahagi ng Nagano Prefecture",
      "moName": "Өмнөд Нагано аймаг",
      "buName": "နဂိုနိုစီရင်စုတောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដណាហ្គាណុ",
      "neName": "नागानो जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "200031",
      "name": "上伊那地域",
      "enName": "Kamiina Area"
    },
    "class20": {
      "code": "2038600",
      "name": "中川村",
      "enName": "Nakagawa Village",
      "kana": "なかがわむら",
      "chName": "中川村",
      "zhName": "中川村",
      "koName": "나카가와 촌",
      "esName": "Aldea de Nakagawa",
      "ptName": "povoado de Nakagawa",
      "thName": "หมู่บ้านนาคางาวะ",
      "viName": "làng Nakagawa",
      "inName": "desa Nakagawa",
      "tlName": "nayon ng Nakagawa",
      "moName": "Нaкагава тосгон",
      "buName": "နာကားဂါ့ဝ ကျေးရွာ",
      "khName": "ភូមិ ណាកាកាវ៉ា",
      "neName": "नाकागावा गाउँ"
    }
  },
  "2038800": {
    "office": {
      "code": "200000",
      "name": "長野県",
      "enName": "Nagano",
      "officeName": "長野地方気象台",
      "chName": "长野县",
      "zhName": "長野縣",
      "koName": "나가노현",
      "esName": "Prefectura de Nagano",
      "ptName": "Província de Nagano",
      "thName": "จังหวัดนางาโนะ",
      "viName": "Tỉnh Nagano",
      "inName": "Prefektur Nagano",
      "tlName": "Nagano Prefecture",
      "moName": "Нагано аймаг",
      "buName": "နားဂါနို ပြည်နယ်",
      "khName": "ខេត្ដ ណាហ្គាណូ",
      "neName": "नागानो जिल्ला"
    },
    "class10": {
      "code": "200030",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "长野县南部",
      "zhName": "長野縣南部",
      "koName": "나가노 현 남부",
      "esName": "Sur de Prefectura de Nagano",
      "ptName": "Região sul da Província de Nagano",
      "thName": "จังหวัดนางาโนะตอนใต้",
      "viName": "Miền Nam tỉnh Nagano",
      "inName": "Bagian Selatan Prefektur Nagano",
      "tlName": "Timog na bahagi ng Nagano Prefecture",
      "moName": "Өмнөд Нагано аймаг",
      "buName": "နဂိုနိုစီရင်စုတောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដណាហ្គាណុ",
      "neName": "नागानो जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "200031",
      "name": "上伊那地域",
      "enName": "Kamiina Area"
    },
    "class20": {
      "code": "2038800",
      "name": "宮田村",
      "enName": "Miyada Village",
      "kana": "みやだむら",
      "chName": "宫田村",
      "zhName": "宮田村",
      "koName": "미야다 촌",
      "esName": "Aldea de Miyada",
      "ptName": "povoado de Miyada",
      "thName": "หมู่บ้านมิยาดะ",
      "viName": "làng Miyada",
      "inName": "desa Miyada",
      "tlName": "nayon ng Miyada",
      "moName": "Мияда тосгон",
      "buName": "မီးယာ့ဒ ကျေးရွာ",
      "khName": "ភូមិ មីយ៉ាដា",
      "neName": "मियादा गाउँ"
    }
  },
  "2040200": {
    "office": {
      "code": "200000",
      "name": "長野県",
      "enName": "Nagano",
      "officeName": "長野地方気象台",
      "chName": "长野县",
      "zhName": "長野縣",
      "koName": "나가노현",
      "esName": "Prefectura de Nagano",
      "ptName": "Província de Nagano",
      "thName": "จังหวัดนางาโนะ",
      "viName": "Tỉnh Nagano",
      "inName": "Prefektur Nagano",
      "tlName": "Nagano Prefecture",
      "moName": "Нагано аймаг",
      "buName": "နားဂါနို ပြည်နယ်",
      "khName": "ខេត្ដ ណាហ្គាណូ",
      "neName": "नागानो जिल्ला"
    },
    "class10": {
      "code": "200030",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "长野县南部",
      "zhName": "長野縣南部",
      "koName": "나가노 현 남부",
      "esName": "Sur de Prefectura de Nagano",
      "ptName": "Região sul da Província de Nagano",
      "thName": "จังหวัดนางาโนะตอนใต้",
      "viName": "Miền Nam tỉnh Nagano",
      "inName": "Bagian Selatan Prefektur Nagano",
      "tlName": "Timog na bahagi ng Nagano Prefecture",
      "moName": "Өмнөд Нагано аймаг",
      "buName": "နဂိုနိုစီရင်စုတောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដណាហ្គាណុ",
      "neName": "नागानो जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "200033",
      "name": "下伊那地域",
      "enName": "Shimoina Area"
    },
    "class20": {
      "code": "2040200",
      "name": "松川町",
      "enName": "Matsukawa Town",
      "kana": "まつかわまち",
      "chName": "松川町",
      "zhName": "松川町",
      "koName": "마쓰카와 정",
      "esName": "Pueblo de Matsukawa",
      "ptName": "bairro de Matsukawa",
      "thName": "เมืองมัทสึคาวะ",
      "viName": "thị trấn Matsukawa",
      "inName": "kota Matsukawa",
      "tlName": "bayan ng Matsukawa",
      "moName": "Мацүкава жижиг хот",
      "buName": "မာဆုကာ့ဝ မြို့နယ်",
      "khName": "ទីប្រជុំជន ម៉ាតស៊ូកាវ៉ា",
      "neName": "मात्सुकावा नगर"
    }
  },
  "2040300": {
    "office": {
      "code": "200000",
      "name": "長野県",
      "enName": "Nagano",
      "officeName": "長野地方気象台",
      "chName": "长野县",
      "zhName": "長野縣",
      "koName": "나가노현",
      "esName": "Prefectura de Nagano",
      "ptName": "Província de Nagano",
      "thName": "จังหวัดนางาโนะ",
      "viName": "Tỉnh Nagano",
      "inName": "Prefektur Nagano",
      "tlName": "Nagano Prefecture",
      "moName": "Нагано аймаг",
      "buName": "နားဂါနို ပြည်နယ်",
      "khName": "ខេត្ដ ណាហ្គាណូ",
      "neName": "नागानो जिल्ला"
    },
    "class10": {
      "code": "200030",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "长野县南部",
      "zhName": "長野縣南部",
      "koName": "나가노 현 남부",
      "esName": "Sur de Prefectura de Nagano",
      "ptName": "Região sul da Província de Nagano",
      "thName": "จังหวัดนางาโนะตอนใต้",
      "viName": "Miền Nam tỉnh Nagano",
      "inName": "Bagian Selatan Prefektur Nagano",
      "tlName": "Timog na bahagi ng Nagano Prefecture",
      "moName": "Өмнөд Нагано аймаг",
      "buName": "နဂိုနိုစီရင်စုတောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដណាហ្គាណុ",
      "neName": "नागानो जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "200033",
      "name": "下伊那地域",
      "enName": "Shimoina Area"
    },
    "class20": {
      "code": "2040300",
      "name": "高森町",
      "enName": "Takamori Town",
      "kana": "たかもりまち",
      "chName": "长野高森町",
      "zhName": "長野高森町",
      "koName": "나가노 다카모리 정",
      "esName": "Pueblo de Takamori, Nagano",
      "ptName": "Nagano, bairro de Takamori",
      "thName": "เมืองทากาโมริ นางาโนะ",
      "viName": "Thị trấn Takamori, Nagano",
      "inName": "Kota Takamori, Nagano",
      "tlName": "bayan ng Takamori, Nagano",
      "moName": "Нагано Такамори жижиг хот",
      "buName": "နကနိုတကမိုယိမြို့နယ် ",
      "khName": "ទីប្រជុំជនតាកាមូរី ណាហ្គាណុ",
      "neName": "नागानो ताकामोरी नगर"
    }
  },
  "2040400": {
    "office": {
      "code": "200000",
      "name": "長野県",
      "enName": "Nagano",
      "officeName": "長野地方気象台",
      "chName": "长野县",
      "zhName": "長野縣",
      "koName": "나가노현",
      "esName": "Prefectura de Nagano",
      "ptName": "Província de Nagano",
      "thName": "จังหวัดนางาโนะ",
      "viName": "Tỉnh Nagano",
      "inName": "Prefektur Nagano",
      "tlName": "Nagano Prefecture",
      "moName": "Нагано аймаг",
      "buName": "နားဂါနို ပြည်နယ်",
      "khName": "ខេត្ដ ណាហ្គាណូ",
      "neName": "नागानो जिल्ला"
    },
    "class10": {
      "code": "200030",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "长野县南部",
      "zhName": "長野縣南部",
      "koName": "나가노 현 남부",
      "esName": "Sur de Prefectura de Nagano",
      "ptName": "Região sul da Província de Nagano",
      "thName": "จังหวัดนางาโนะตอนใต้",
      "viName": "Miền Nam tỉnh Nagano",
      "inName": "Bagian Selatan Prefektur Nagano",
      "tlName": "Timog na bahagi ng Nagano Prefecture",
      "moName": "Өмнөд Нагано аймаг",
      "buName": "နဂိုနိုစီရင်စုတောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដណាហ្គាណុ",
      "neName": "नागानो जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "200033",
      "name": "下伊那地域",
      "enName": "Shimoina Area"
    },
    "class20": {
      "code": "2040400",
      "name": "阿南町",
      "enName": "Anan Town",
      "kana": "あなんちょう",
      "chName": "阿南町",
      "zhName": "阿南町",
      "koName": "아난 정",
      "esName": "Pueblo de Anan",
      "ptName": "bairro de Anan",
      "thName": "เมืองอะนัง",
      "viName": "thị trấn Anan",
      "inName": "kota Anan",
      "tlName": "bayan ng Anan",
      "moName": "Aнaн жижиг хот",
      "buName": "အာနန် မြို့နယ်",
      "khName": "ទីប្រជុំជន អាណាន",
      "neName": "आनान नगर"
    }
  },
  "2040700": {
    "office": {
      "code": "200000",
      "name": "長野県",
      "enName": "Nagano",
      "officeName": "長野地方気象台",
      "chName": "长野县",
      "zhName": "長野縣",
      "koName": "나가노현",
      "esName": "Prefectura de Nagano",
      "ptName": "Província de Nagano",
      "thName": "จังหวัดนางาโนะ",
      "viName": "Tỉnh Nagano",
      "inName": "Prefektur Nagano",
      "tlName": "Nagano Prefecture",
      "moName": "Нагано аймаг",
      "buName": "နားဂါနို ပြည်နယ်",
      "khName": "ខេត្ដ ណាហ្គាណូ",
      "neName": "नागानो जिल्ला"
    },
    "class10": {
      "code": "200030",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "长野县南部",
      "zhName": "長野縣南部",
      "koName": "나가노 현 남부",
      "esName": "Sur de Prefectura de Nagano",
      "ptName": "Região sul da Província de Nagano",
      "thName": "จังหวัดนางาโนะตอนใต้",
      "viName": "Miền Nam tỉnh Nagano",
      "inName": "Bagian Selatan Prefektur Nagano",
      "tlName": "Timog na bahagi ng Nagano Prefecture",
      "moName": "Өмнөд Нагано аймаг",
      "buName": "နဂိုနိုစီရင်စုတောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដណាហ្គាណុ",
      "neName": "नागानो जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "200033",
      "name": "下伊那地域",
      "enName": "Shimoina Area"
    },
    "class20": {
      "code": "2040700",
      "name": "阿智村",
      "enName": "Achi Village",
      "kana": "あちむら",
      "chName": "阿智村",
      "zhName": "阿智村",
      "koName": "아치 촌",
      "esName": "Aldea de Achi",
      "ptName": "povoado de Achi",
      "thName": "หมู่บ้านอะจิ",
      "viName": "làng Achi",
      "inName": "desa Achi",
      "tlName": "nayon ng Achi",
      "moName": "Aчи тосгон",
      "buName": "အကျိ ကျေးရွာ",
      "khName": "ភូមិ អាជី",
      "neName": "आची गाउँ"
    }
  },
  "2040900": {
    "office": {
      "code": "200000",
      "name": "長野県",
      "enName": "Nagano",
      "officeName": "長野地方気象台",
      "chName": "长野县",
      "zhName": "長野縣",
      "koName": "나가노현",
      "esName": "Prefectura de Nagano",
      "ptName": "Província de Nagano",
      "thName": "จังหวัดนางาโนะ",
      "viName": "Tỉnh Nagano",
      "inName": "Prefektur Nagano",
      "tlName": "Nagano Prefecture",
      "moName": "Нагано аймаг",
      "buName": "နားဂါနို ပြည်နယ်",
      "khName": "ខេត្ដ ណាហ្គាណូ",
      "neName": "नागानो जिल्ला"
    },
    "class10": {
      "code": "200030",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "长野县南部",
      "zhName": "長野縣南部",
      "koName": "나가노 현 남부",
      "esName": "Sur de Prefectura de Nagano",
      "ptName": "Região sul da Província de Nagano",
      "thName": "จังหวัดนางาโนะตอนใต้",
      "viName": "Miền Nam tỉnh Nagano",
      "inName": "Bagian Selatan Prefektur Nagano",
      "tlName": "Timog na bahagi ng Nagano Prefecture",
      "moName": "Өмнөд Нагано аймаг",
      "buName": "နဂိုနိုစီရင်စုတောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដណាហ្គាណុ",
      "neName": "नागानो जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "200033",
      "name": "下伊那地域",
      "enName": "Shimoina Area"
    },
    "class20": {
      "code": "2040900",
      "name": "平谷村",
      "enName": "Hiraya Village",
      "kana": "ひらやむら",
      "chName": "平谷村",
      "zhName": "平谷村",
      "koName": "히라야 촌",
      "esName": "Aldea de Hiraya",
      "ptName": "povoado de Hiraya",
      "thName": "หมู่บ้านฮิรายะ",
      "viName": "làng Hiraya",
      "inName": "desa Hiraya",
      "tlName": "nayon ng Hiraya",
      "moName": "Хирая тосгон",
      "buName": "ဟီရာယာ့ ကျေးရွာ",
      "khName": "ភូមិ ហ៊ីរ៉ាយ៉ា",
      "neName": "हिराया गाउँ"
    }
  },
  "2041000": {
    "office": {
      "code": "200000",
      "name": "長野県",
      "enName": "Nagano",
      "officeName": "長野地方気象台",
      "chName": "长野县",
      "zhName": "長野縣",
      "koName": "나가노현",
      "esName": "Prefectura de Nagano",
      "ptName": "Província de Nagano",
      "thName": "จังหวัดนางาโนะ",
      "viName": "Tỉnh Nagano",
      "inName": "Prefektur Nagano",
      "tlName": "Nagano Prefecture",
      "moName": "Нагано аймаг",
      "buName": "နားဂါနို ပြည်နယ်",
      "khName": "ខេត្ដ ណាហ្គាណូ",
      "neName": "नागानो जिल्ला"
    },
    "class10": {
      "code": "200030",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "长野县南部",
      "zhName": "長野縣南部",
      "koName": "나가노 현 남부",
      "esName": "Sur de Prefectura de Nagano",
      "ptName": "Região sul da Província de Nagano",
      "thName": "จังหวัดนางาโนะตอนใต้",
      "viName": "Miền Nam tỉnh Nagano",
      "inName": "Bagian Selatan Prefektur Nagano",
      "tlName": "Timog na bahagi ng Nagano Prefecture",
      "moName": "Өмнөд Нагано аймаг",
      "buName": "နဂိုနိုစီရင်စုတောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដណាហ្គាណុ",
      "neName": "नागानो जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "200033",
      "name": "下伊那地域",
      "enName": "Shimoina Area"
    },
    "class20": {
      "code": "2041000",
      "name": "根羽村",
      "enName": "Neba Village",
      "kana": "ねばむら",
      "chName": "根羽村",
      "zhName": "根羽村",
      "koName": "네바 촌",
      "esName": "Aldea de Neba ",
      "ptName": "povoado de Neba",
      "thName": "หมู่บ้านเนบะ",
      "viName": "làng Neba",
      "inName": "desa Neba",
      "tlName": "nayon ng Neba",
      "moName": "Нэба тосгон",
      "buName": "နယ်ဗ ကျေးရွာ",
      "khName": "ភូមិ នេបា",
      "neName": "नेबा गाउँ"
    }
  },
  "2041100": {
    "office": {
      "code": "200000",
      "name": "長野県",
      "enName": "Nagano",
      "officeName": "長野地方気象台",
      "chName": "长野县",
      "zhName": "長野縣",
      "koName": "나가노현",
      "esName": "Prefectura de Nagano",
      "ptName": "Província de Nagano",
      "thName": "จังหวัดนางาโนะ",
      "viName": "Tỉnh Nagano",
      "inName": "Prefektur Nagano",
      "tlName": "Nagano Prefecture",
      "moName": "Нагано аймаг",
      "buName": "နားဂါနို ပြည်နယ်",
      "khName": "ខេត្ដ ណាហ្គាណូ",
      "neName": "नागानो जिल्ला"
    },
    "class10": {
      "code": "200030",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "长野县南部",
      "zhName": "長野縣南部",
      "koName": "나가노 현 남부",
      "esName": "Sur de Prefectura de Nagano",
      "ptName": "Região sul da Província de Nagano",
      "thName": "จังหวัดนางาโนะตอนใต้",
      "viName": "Miền Nam tỉnh Nagano",
      "inName": "Bagian Selatan Prefektur Nagano",
      "tlName": "Timog na bahagi ng Nagano Prefecture",
      "moName": "Өмнөд Нагано аймаг",
      "buName": "နဂိုနိုစီရင်စုတောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដណាហ្គាណុ",
      "neName": "नागानो जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "200033",
      "name": "下伊那地域",
      "enName": "Shimoina Area"
    },
    "class20": {
      "code": "2041100",
      "name": "下條村",
      "enName": "Shimojo Village",
      "kana": "しもじょうむら",
      "chName": "下条村",
      "zhName": "下條村",
      "koName": "시모조 촌",
      "esName": "Aldea de Shimojyo",
      "ptName": "povoado de Shimojo",
      "thName": "หมู่บ้านชิโมโจ",
      "viName": "làng Shimojo",
      "inName": "desa Shimojo",
      "tlName": "nayon ng Shimojo",
      "moName": "Шиможо тосгон",
      "buName": "ရှီမိုဂျို ကျေးရွာ",
      "khName": "ភូមិ ស៊ីម៉ូជូ",
      "neName": "शिमोजो गाउँ"
    }
  },
  "2041200": {
    "office": {
      "code": "200000",
      "name": "長野県",
      "enName": "Nagano",
      "officeName": "長野地方気象台",
      "chName": "长野县",
      "zhName": "長野縣",
      "koName": "나가노현",
      "esName": "Prefectura de Nagano",
      "ptName": "Província de Nagano",
      "thName": "จังหวัดนางาโนะ",
      "viName": "Tỉnh Nagano",
      "inName": "Prefektur Nagano",
      "tlName": "Nagano Prefecture",
      "moName": "Нагано аймаг",
      "buName": "နားဂါနို ပြည်နယ်",
      "khName": "ខេត្ដ ណាហ្គាណូ",
      "neName": "नागानो जिल्ला"
    },
    "class10": {
      "code": "200030",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "长野县南部",
      "zhName": "長野縣南部",
      "koName": "나가노 현 남부",
      "esName": "Sur de Prefectura de Nagano",
      "ptName": "Região sul da Província de Nagano",
      "thName": "จังหวัดนางาโนะตอนใต้",
      "viName": "Miền Nam tỉnh Nagano",
      "inName": "Bagian Selatan Prefektur Nagano",
      "tlName": "Timog na bahagi ng Nagano Prefecture",
      "moName": "Өмнөд Нагано аймаг",
      "buName": "နဂိုနိုစီရင်စုတောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដណាហ្គាណុ",
      "neName": "नागानो जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "200033",
      "name": "下伊那地域",
      "enName": "Shimoina Area"
    },
    "class20": {
      "code": "2041200",
      "name": "売木村",
      "enName": "Urugi Village",
      "kana": "うるぎむら",
      "chName": "卖木村",
      "zhName": "賣木村",
      "koName": "우루기 촌",
      "esName": "Aldea de Urugi",
      "ptName": "povoado de Urugi",
      "thName": "หมู่บ้านอุรุงิ",
      "viName": "làng Urugi",
      "inName": "desa Urugi",
      "tlName": "nayon ng Urugi",
      "moName": "Үрүги тосгон",
      "buName": "ဥရုဂိ ကျေးရွာ",
      "khName": "ភូមិ យូរូគូគី",
      "neName": "उरुगी गाउँ"
    }
  },
  "2041300": {
    "office": {
      "code": "200000",
      "name": "長野県",
      "enName": "Nagano",
      "officeName": "長野地方気象台",
      "chName": "长野县",
      "zhName": "長野縣",
      "koName": "나가노현",
      "esName": "Prefectura de Nagano",
      "ptName": "Província de Nagano",
      "thName": "จังหวัดนางาโนะ",
      "viName": "Tỉnh Nagano",
      "inName": "Prefektur Nagano",
      "tlName": "Nagano Prefecture",
      "moName": "Нагано аймаг",
      "buName": "နားဂါနို ပြည်နယ်",
      "khName": "ខេត្ដ ណាហ្គាណូ",
      "neName": "नागानो जिल्ला"
    },
    "class10": {
      "code": "200030",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "长野县南部",
      "zhName": "長野縣南部",
      "koName": "나가노 현 남부",
      "esName": "Sur de Prefectura de Nagano",
      "ptName": "Região sul da Província de Nagano",
      "thName": "จังหวัดนางาโนะตอนใต้",
      "viName": "Miền Nam tỉnh Nagano",
      "inName": "Bagian Selatan Prefektur Nagano",
      "tlName": "Timog na bahagi ng Nagano Prefecture",
      "moName": "Өмнөд Нагано аймаг",
      "buName": "နဂိုနိုစီရင်စုတောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដណាហ្គាណុ",
      "neName": "नागानो जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "200033",
      "name": "下伊那地域",
      "enName": "Shimoina Area"
    },
    "class20": {
      "code": "2041300",
      "name": "天龍村",
      "enName": "Tenryu Village",
      "kana": "てんりゅうむら",
      "chName": "天龙村",
      "zhName": "天龍村",
      "koName": "덴류 촌",
      "esName": "Aldea de Tenryu",
      "ptName": "povoado de Tenryu",
      "thName": "หมู่บ้านเทนริว",
      "viName": "làng Tenryu",
      "inName": "desa Tenryu",
      "tlName": "nayon ng Tenryu",
      "moName": "Тэнрю тосгон",
      "buName": "တန်းရု ကျေးရွာ",
      "khName": "ភូមិ ថែនរីយូ",
      "neName": "तेनरयु गाउँ"
    }
  },
  "2041400": {
    "office": {
      "code": "200000",
      "name": "長野県",
      "enName": "Nagano",
      "officeName": "長野地方気象台",
      "chName": "长野县",
      "zhName": "長野縣",
      "koName": "나가노현",
      "esName": "Prefectura de Nagano",
      "ptName": "Província de Nagano",
      "thName": "จังหวัดนางาโนะ",
      "viName": "Tỉnh Nagano",
      "inName": "Prefektur Nagano",
      "tlName": "Nagano Prefecture",
      "moName": "Нагано аймаг",
      "buName": "နားဂါနို ပြည်နယ်",
      "khName": "ខេត្ដ ណាហ្គាណូ",
      "neName": "नागानो जिल्ला"
    },
    "class10": {
      "code": "200030",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "长野县南部",
      "zhName": "長野縣南部",
      "koName": "나가노 현 남부",
      "esName": "Sur de Prefectura de Nagano",
      "ptName": "Região sul da Província de Nagano",
      "thName": "จังหวัดนางาโนะตอนใต้",
      "viName": "Miền Nam tỉnh Nagano",
      "inName": "Bagian Selatan Prefektur Nagano",
      "tlName": "Timog na bahagi ng Nagano Prefecture",
      "moName": "Өмнөд Нагано аймаг",
      "buName": "နဂိုနိုစီရင်စုတောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដណាហ្គាណុ",
      "neName": "नागानो जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "200033",
      "name": "下伊那地域",
      "enName": "Shimoina Area"
    },
    "class20": {
      "code": "2041400",
      "name": "泰阜村",
      "enName": "Yasuoka Village",
      "kana": "やすおかむら",
      "chName": "泰阜村",
      "zhName": "泰阜村",
      "koName": "야스오카 촌",
      "esName": "Aldea de Yasuoka",
      "ptName": "povoado de Yasuoka",
      "thName": "หมู่บ้านยาสุโอกะ",
      "viName": "làng Yasuoka",
      "inName": "desa Yasuoka",
      "tlName": "nayon ng Yasuoka",
      "moName": "Ясүока тосгон",
      "buName": "ယာဆောက ကျေးရွာ",
      "khName": "ភូមិ យ៉ាស៊ូអូកា",
      "neName": "यासुओका गाउँ"
    }
  },
  "2041500": {
    "office": {
      "code": "200000",
      "name": "長野県",
      "enName": "Nagano",
      "officeName": "長野地方気象台",
      "chName": "长野县",
      "zhName": "長野縣",
      "koName": "나가노현",
      "esName": "Prefectura de Nagano",
      "ptName": "Província de Nagano",
      "thName": "จังหวัดนางาโนะ",
      "viName": "Tỉnh Nagano",
      "inName": "Prefektur Nagano",
      "tlName": "Nagano Prefecture",
      "moName": "Нагано аймаг",
      "buName": "နားဂါနို ပြည်နယ်",
      "khName": "ខេត្ដ ណាហ្គាណូ",
      "neName": "नागानो जिल्ला"
    },
    "class10": {
      "code": "200030",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "长野县南部",
      "zhName": "長野縣南部",
      "koName": "나가노 현 남부",
      "esName": "Sur de Prefectura de Nagano",
      "ptName": "Região sul da Província de Nagano",
      "thName": "จังหวัดนางาโนะตอนใต้",
      "viName": "Miền Nam tỉnh Nagano",
      "inName": "Bagian Selatan Prefektur Nagano",
      "tlName": "Timog na bahagi ng Nagano Prefecture",
      "moName": "Өмнөд Нагано аймаг",
      "buName": "နဂိုနိုစီရင်စုတောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដណាហ្គាណុ",
      "neName": "नागानो जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "200033",
      "name": "下伊那地域",
      "enName": "Shimoina Area"
    },
    "class20": {
      "code": "2041500",
      "name": "喬木村",
      "enName": "Takagi Village",
      "kana": "たかぎむら",
      "chName": "乔木村",
      "zhName": "喬木村",
      "koName": "다카기 촌",
      "esName": "Aldea de Takagi",
      "ptName": "povoado de Takagi",
      "thName": "หมู่บ้านทากากิ",
      "viName": "làng Takagi",
      "inName": "desa Takagi",
      "tlName": "nayon ng Takagi",
      "moName": "Такаги тосгон",
      "buName": "တာကားဂိ ကျေးရွာ",
      "khName": "ភូមិ តាកាគី",
      "neName": "ताकागी गाउँ"
    }
  },
  "2041600": {
    "office": {
      "code": "200000",
      "name": "長野県",
      "enName": "Nagano",
      "officeName": "長野地方気象台",
      "chName": "长野县",
      "zhName": "長野縣",
      "koName": "나가노현",
      "esName": "Prefectura de Nagano",
      "ptName": "Província de Nagano",
      "thName": "จังหวัดนางาโนะ",
      "viName": "Tỉnh Nagano",
      "inName": "Prefektur Nagano",
      "tlName": "Nagano Prefecture",
      "moName": "Нагано аймаг",
      "buName": "နားဂါနို ပြည်နယ်",
      "khName": "ខេត្ដ ណាហ្គាណូ",
      "neName": "नागानो जिल्ला"
    },
    "class10": {
      "code": "200030",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "长野县南部",
      "zhName": "長野縣南部",
      "koName": "나가노 현 남부",
      "esName": "Sur de Prefectura de Nagano",
      "ptName": "Região sul da Província de Nagano",
      "thName": "จังหวัดนางาโนะตอนใต้",
      "viName": "Miền Nam tỉnh Nagano",
      "inName": "Bagian Selatan Prefektur Nagano",
      "tlName": "Timog na bahagi ng Nagano Prefecture",
      "moName": "Өмнөд Нагано аймаг",
      "buName": "နဂိုနိုစီရင်စုတောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដណាហ្គាណុ",
      "neName": "नागानो जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "200033",
      "name": "下伊那地域",
      "enName": "Shimoina Area"
    },
    "class20": {
      "code": "2041600",
      "name": "豊丘村",
      "enName": "Toyooka Village",
      "kana": "とよおかむら",
      "chName": "丰丘村",
      "zhName": "豐丘村",
      "koName": "도요오카 촌",
      "esName": "Aldea de Toyooka",
      "ptName": "povoado de Toyooka",
      "thName": "หมู่บ้านโทโยโอกะ",
      "viName": "làng Toyooka",
      "inName": "desa Toyooka",
      "tlName": "nayon ng Toyooka",
      "moName": "Тоёока тосгон",
      "buName": "တိုရိုးက ကျေးရွာ",
      "khName": "ភូមិ តូយូកា",
      "neName": "तोयोओका गाउँ"
    }
  },
  "2041700": {
    "office": {
      "code": "200000",
      "name": "長野県",
      "enName": "Nagano",
      "officeName": "長野地方気象台",
      "chName": "长野县",
      "zhName": "長野縣",
      "koName": "나가노현",
      "esName": "Prefectura de Nagano",
      "ptName": "Província de Nagano",
      "thName": "จังหวัดนางาโนะ",
      "viName": "Tỉnh Nagano",
      "inName": "Prefektur Nagano",
      "tlName": "Nagano Prefecture",
      "moName": "Нагано аймаг",
      "buName": "နားဂါနို ပြည်နယ်",
      "khName": "ខេត្ដ ណាហ្គាណូ",
      "neName": "नागानो जिल्ला"
    },
    "class10": {
      "code": "200030",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "长野县南部",
      "zhName": "長野縣南部",
      "koName": "나가노 현 남부",
      "esName": "Sur de Prefectura de Nagano",
      "ptName": "Região sul da Província de Nagano",
      "thName": "จังหวัดนางาโนะตอนใต้",
      "viName": "Miền Nam tỉnh Nagano",
      "inName": "Bagian Selatan Prefektur Nagano",
      "tlName": "Timog na bahagi ng Nagano Prefecture",
      "moName": "Өмнөд Нагано аймаг",
      "buName": "နဂိုနိုစီရင်စုတောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដណាហ្គាណុ",
      "neName": "नागानो जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "200033",
      "name": "下伊那地域",
      "enName": "Shimoina Area"
    },
    "class20": {
      "code": "2041700",
      "name": "大鹿村",
      "enName": "Oshika Village",
      "kana": "おおしかむら",
      "chName": "大鹿村",
      "zhName": "大鹿村",
      "koName": "오시카 촌",
      "esName": "Aldea de Oshika",
      "ptName": "povoado de Oshika",
      "thName": "หมู่บ้านโอชิกะ",
      "viName": "làng Oshika",
      "inName": "desa Oshika",
      "tlName": "nayon ng Oshika",
      "moName": "Ошика тосгон",
      "buName": "အော့ရှိက ကျေးရွာ",
      "khName": "ភូមិ អូស៊ីកា",
      "neName": "ओशिका गाउँ"
    }
  },
  "2042200": {
    "office": {
      "code": "200000",
      "name": "長野県",
      "enName": "Nagano",
      "officeName": "長野地方気象台",
      "chName": "长野县",
      "zhName": "長野縣",
      "koName": "나가노현",
      "esName": "Prefectura de Nagano",
      "ptName": "Província de Nagano",
      "thName": "จังหวัดนางาโนะ",
      "viName": "Tỉnh Nagano",
      "inName": "Prefektur Nagano",
      "tlName": "Nagano Prefecture",
      "moName": "Нагано аймаг",
      "buName": "နားဂါနို ပြည်နယ်",
      "khName": "ខេត្ដ ណាហ្គាណូ",
      "neName": "नागानो जिल्ला"
    },
    "class10": {
      "code": "200030",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "长野县南部",
      "zhName": "長野縣南部",
      "koName": "나가노 현 남부",
      "esName": "Sur de Prefectura de Nagano",
      "ptName": "Região sul da Província de Nagano",
      "thName": "จังหวัดนางาโนะตอนใต้",
      "viName": "Miền Nam tỉnh Nagano",
      "inName": "Bagian Selatan Prefektur Nagano",
      "tlName": "Timog na bahagi ng Nagano Prefecture",
      "moName": "Өмнөд Нагано аймаг",
      "buName": "နဂိုနိုစီရင်စုတောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដណាហ្គាណុ",
      "neName": "नागानो जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "200032",
      "name": "木曽地域",
      "enName": "Kiso Area"
    },
    "class20": {
      "code": "2042200",
      "name": "上松町",
      "enName": "Agematsu Town",
      "kana": "あげまつまち",
      "chName": "上松町",
      "zhName": "上松町",
      "koName": "아게마쓰 정",
      "esName": "Pueblo de Agematsu",
      "ptName": "bairro de Agematsu",
      "thName": "เมืองอาเงะมัตสึ",
      "viName": "thị trấn Agematsu",
      "inName": "kota Agematsu",
      "tlName": "bayan ng Agematsu",
      "moName": "Aгэмaцү жижиг хот",
      "buName": "အာဂဲမာဆု မြို့နယ်",
      "khName": "ទីប្រជុំជន អាជីម៉ាតស៊ូ",
      "neName": "आगेमात्सु नगर"
    }
  },
  "2042300": {
    "office": {
      "code": "200000",
      "name": "長野県",
      "enName": "Nagano",
      "officeName": "長野地方気象台",
      "chName": "长野县",
      "zhName": "長野縣",
      "koName": "나가노현",
      "esName": "Prefectura de Nagano",
      "ptName": "Província de Nagano",
      "thName": "จังหวัดนางาโนะ",
      "viName": "Tỉnh Nagano",
      "inName": "Prefektur Nagano",
      "tlName": "Nagano Prefecture",
      "moName": "Нагано аймаг",
      "buName": "နားဂါနို ပြည်နယ်",
      "khName": "ខេត្ដ ណាហ្គាណូ",
      "neName": "नागानो जिल्ला"
    },
    "class10": {
      "code": "200030",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "长野县南部",
      "zhName": "長野縣南部",
      "koName": "나가노 현 남부",
      "esName": "Sur de Prefectura de Nagano",
      "ptName": "Região sul da Província de Nagano",
      "thName": "จังหวัดนางาโนะตอนใต้",
      "viName": "Miền Nam tỉnh Nagano",
      "inName": "Bagian Selatan Prefektur Nagano",
      "tlName": "Timog na bahagi ng Nagano Prefecture",
      "moName": "Өмнөд Нагано аймаг",
      "buName": "နဂိုနိုစီရင်စုတောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដណាហ្គាណុ",
      "neName": "नागानो जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "200032",
      "name": "木曽地域",
      "enName": "Kiso Area"
    },
    "class20": {
      "code": "2042300",
      "name": "南木曽町",
      "enName": "Nagiso Town",
      "kana": "なぎそまち",
      "chName": "南木曾町",
      "zhName": "南木曾町",
      "koName": "나기소 정",
      "esName": "Pueblo de Nagiso",
      "ptName": "bairro de Nagiso",
      "thName": "เมืองนางิโสะ",
      "viName": "thị trấn Nagiso",
      "inName": "kota Nagiso",
      "tlName": "bayan ng Nagiso",
      "moName": "Нaгисо жижиг хот",
      "buName": "နာ့ဂိဆို မြို့နယ်",
      "khName": "ទីប្រជុំជន ណាហ្គីសូ",
      "neName": "नागिसो नगर"
    }
  },
  "2042500": {
    "office": {
      "code": "200000",
      "name": "長野県",
      "enName": "Nagano",
      "officeName": "長野地方気象台",
      "chName": "长野县",
      "zhName": "長野縣",
      "koName": "나가노현",
      "esName": "Prefectura de Nagano",
      "ptName": "Província de Nagano",
      "thName": "จังหวัดนางาโนะ",
      "viName": "Tỉnh Nagano",
      "inName": "Prefektur Nagano",
      "tlName": "Nagano Prefecture",
      "moName": "Нагано аймаг",
      "buName": "နားဂါနို ပြည်နယ်",
      "khName": "ខេត្ដ ណាហ្គាណូ",
      "neName": "नागानो जिल्ला"
    },
    "class10": {
      "code": "200030",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "长野县南部",
      "zhName": "長野縣南部",
      "koName": "나가노 현 남부",
      "esName": "Sur de Prefectura de Nagano",
      "ptName": "Região sul da Província de Nagano",
      "thName": "จังหวัดนางาโนะตอนใต้",
      "viName": "Miền Nam tỉnh Nagano",
      "inName": "Bagian Selatan Prefektur Nagano",
      "tlName": "Timog na bahagi ng Nagano Prefecture",
      "moName": "Өмнөд Нагано аймаг",
      "buName": "နဂိုနိုစီရင်စုတောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដណាហ្គាណុ",
      "neName": "नागानो जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "200032",
      "name": "木曽地域",
      "enName": "Kiso Area"
    },
    "class20": {
      "code": "2042500",
      "name": "木祖村",
      "enName": "Kiso Village",
      "kana": "きそむら",
      "chName": "木祖村",
      "zhName": "木祖村",
      "koName": "기소 촌",
      "esName": "Aldea de Kiso",
      "ptName": "povoado de Kiso",
      "thName": "หมู่บ้านคิโสะ",
      "viName": "làng Kiso",
      "inName": "desa Kiso",
      "tlName": "nayon ng Kiso",
      "moName": "Кисо тосгон",
      "buName": "ခီဆို ကျေးရွာ",
      "khName": "ភូមិ គីសូ",
      "neName": "किसो गाउँ"
    }
  },
  "2042900": {
    "office": {
      "code": "200000",
      "name": "長野県",
      "enName": "Nagano",
      "officeName": "長野地方気象台",
      "chName": "长野县",
      "zhName": "長野縣",
      "koName": "나가노현",
      "esName": "Prefectura de Nagano",
      "ptName": "Província de Nagano",
      "thName": "จังหวัดนางาโนะ",
      "viName": "Tỉnh Nagano",
      "inName": "Prefektur Nagano",
      "tlName": "Nagano Prefecture",
      "moName": "Нагано аймаг",
      "buName": "နားဂါနို ပြည်နယ်",
      "khName": "ខេត្ដ ណាហ្គាណូ",
      "neName": "नागानो जिल्ला"
    },
    "class10": {
      "code": "200030",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "长野县南部",
      "zhName": "長野縣南部",
      "koName": "나가노 현 남부",
      "esName": "Sur de Prefectura de Nagano",
      "ptName": "Região sul da Província de Nagano",
      "thName": "จังหวัดนางาโนะตอนใต้",
      "viName": "Miền Nam tỉnh Nagano",
      "inName": "Bagian Selatan Prefektur Nagano",
      "tlName": "Timog na bahagi ng Nagano Prefecture",
      "moName": "Өмнөд Нагано аймаг",
      "buName": "နဂိုနိုစီရင်စုတောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដណាហ្គាណុ",
      "neName": "नागानो जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "200032",
      "name": "木曽地域",
      "enName": "Kiso Area"
    },
    "class20": {
      "code": "2042900",
      "name": "王滝村",
      "enName": "Otaki Village",
      "kana": "おうたきむら",
      "chName": "王泷村",
      "zhName": "王瀧村",
      "koName": "오타키 촌",
      "esName": "Aldea de Ōtaki",
      "ptName": "povoado de Otaki",
      "thName": "หมู่บ้านโอตากิ",
      "viName": "làng Otaki",
      "inName": "desa Otaki",
      "tlName": "nayon ng Otaki",
      "moName": "Отаки тосгон",
      "buName": "အိုတာ့ကိ ကျေးရွာ",
      "khName": "ភូមិ អូតាគី",
      "neName": "ओताकी गाउँ"
    }
  },
  "2043000": {
    "office": {
      "code": "200000",
      "name": "長野県",
      "enName": "Nagano",
      "officeName": "長野地方気象台",
      "chName": "长野县",
      "zhName": "長野縣",
      "koName": "나가노현",
      "esName": "Prefectura de Nagano",
      "ptName": "Província de Nagano",
      "thName": "จังหวัดนางาโนะ",
      "viName": "Tỉnh Nagano",
      "inName": "Prefektur Nagano",
      "tlName": "Nagano Prefecture",
      "moName": "Нагано аймаг",
      "buName": "နားဂါနို ပြည်နယ်",
      "khName": "ខេត្ដ ណាហ្គាណូ",
      "neName": "नागानो जिल्ला"
    },
    "class10": {
      "code": "200030",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "长野县南部",
      "zhName": "長野縣南部",
      "koName": "나가노 현 남부",
      "esName": "Sur de Prefectura de Nagano",
      "ptName": "Região sul da Província de Nagano",
      "thName": "จังหวัดนางาโนะตอนใต้",
      "viName": "Miền Nam tỉnh Nagano",
      "inName": "Bagian Selatan Prefektur Nagano",
      "tlName": "Timog na bahagi ng Nagano Prefecture",
      "moName": "Өмнөд Нагано аймаг",
      "buName": "နဂိုနိုစီရင်စုတောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដណាហ្គាណុ",
      "neName": "नागानो जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "200032",
      "name": "木曽地域",
      "enName": "Kiso Area"
    },
    "class20": {
      "code": "2043000",
      "name": "大桑村",
      "enName": "Okuwa Village",
      "kana": "おおくわむら",
      "chName": "大桑村",
      "zhName": "大桑村",
      "koName": "오쿠와 촌",
      "esName": "Aldea de Ōkuwa",
      "ptName": "povoado de Okuwa",
      "thName": "หมู่บ้านโอคุวะ",
      "viName": "làng Okuwa",
      "inName": "desa Okuwa",
      "tlName": "nayon ng Okuwa",
      "moName": "Окүва тосгон",
      "buName": "အိုကုဝ ကျေးရွာ",
      "khName": "ភូមិ អូគូវ៉ា",
      "neName": "ओकुवा गाउँ"
    }
  },
  "2043200": {
    "office": {
      "code": "200000",
      "name": "長野県",
      "enName": "Nagano",
      "officeName": "長野地方気象台",
      "chName": "长野县",
      "zhName": "長野縣",
      "koName": "나가노현",
      "esName": "Prefectura de Nagano",
      "ptName": "Província de Nagano",
      "thName": "จังหวัดนางาโนะ",
      "viName": "Tỉnh Nagano",
      "inName": "Prefektur Nagano",
      "tlName": "Nagano Prefecture",
      "moName": "Нагано аймаг",
      "buName": "နားဂါနို ပြည်နယ်",
      "khName": "ខេត្ដ ណាហ្គាណូ",
      "neName": "नागानो जिल्ला"
    },
    "class10": {
      "code": "200030",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "长野县南部",
      "zhName": "長野縣南部",
      "koName": "나가노 현 남부",
      "esName": "Sur de Prefectura de Nagano",
      "ptName": "Região sul da Província de Nagano",
      "thName": "จังหวัดนางาโนะตอนใต้",
      "viName": "Miền Nam tỉnh Nagano",
      "inName": "Bagian Selatan Prefektur Nagano",
      "tlName": "Timog na bahagi ng Nagano Prefecture",
      "moName": "Өмнөд Нагано аймаг",
      "buName": "နဂိုနိုစီရင်စုတောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដណាហ្គាណុ",
      "neName": "नागानो जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "200032",
      "name": "木曽地域",
      "enName": "Kiso Area"
    },
    "class20": {
      "code": "2043200",
      "name": "木曽町",
      "enName": "Kiso Town",
      "kana": "きそまち",
      "chName": "木曾町",
      "zhName": "木曾町",
      "koName": "기소 정",
      "esName": "Pueblo de Kiso",
      "ptName": "bairro de Kiso",
      "thName": "เมืองคิโสะ",
      "viName": "thị trấn Kiso",
      "inName": "kota Kiso",
      "tlName": "bayan ng Kiso",
      "moName": "Кисо жижиг хот",
      "buName": "ခီဆို မြို့နယ်",
      "khName": "ទីប្រជុំជន គីសូ",
      "neName": "किसो नगर"
    }
  },
  "2044600": {
    "office": {
      "code": "200000",
      "name": "長野県",
      "enName": "Nagano",
      "officeName": "長野地方気象台",
      "chName": "长野县",
      "zhName": "長野縣",
      "koName": "나가노현",
      "esName": "Prefectura de Nagano",
      "ptName": "Província de Nagano",
      "thName": "จังหวัดนางาโนะ",
      "viName": "Tỉnh Nagano",
      "inName": "Prefektur Nagano",
      "tlName": "Nagano Prefecture",
      "moName": "Нагано аймаг",
      "buName": "နားဂါနို ပြည်နယ်",
      "khName": "ខេត្ដ ណាហ្គាណូ",
      "neName": "नागानो जिल्ला"
    },
    "class10": {
      "code": "200020",
      "name": "中部",
      "enName": "Central Region",
      "chName": "长野县中部",
      "zhName": "長野縣中部",
      "koName": "나가노 현 중부",
      "esName": "Centro de Prefectura de Nagano",
      "ptName": "Região central da Província de Nagano",
      "thName": "จังหวัดนางาโนะตอนกลาง",
      "viName": "Miền Trung tỉnh Nagano",
      "inName": "Bagian Tengah Prefektur Nagano",
      "tlName": "Sentral na bahagi ng Nagano Prefecture",
      "moName": "Төв Нагано аймаг",
      "buName": "နဂိုနိုစီရင်စုအလယ်ပိုင်း",
      "khName": "តំបន់កណ្តាលនៃខេត្ដណាហ្គាណុ",
      "neName": "नागानो जिल्लाको मध्य भाग"
    },
    "class15": {
      "code": "200023",
      "name": "松本地域",
      "enName": "Matsumoto Area"
    },
    "class20": {
      "code": "2044600",
      "name": "麻績村",
      "enName": "Omi Village",
      "kana": "おみむら",
      "chName": "麻绩村",
      "zhName": "麻績村",
      "koName": "오미 촌",
      "esName": "Aldea de Omi",
      "ptName": "povoado de Omi",
      "thName": "หมู่บ้านโอมิ",
      "viName": "làng Omi",
      "inName": "desa Omi",
      "tlName": "nayon ng Omi",
      "moName": "Оми тосгон",
      "buName": "အိုမိ ကျေးရွာ",
      "khName": "ភូមិ អូមី",
      "neName": "ओमी गाउँ"
    }
  },
  "2044800": {
    "office": {
      "code": "200000",
      "name": "長野県",
      "enName": "Nagano",
      "officeName": "長野地方気象台",
      "chName": "长野县",
      "zhName": "長野縣",
      "koName": "나가노현",
      "esName": "Prefectura de Nagano",
      "ptName": "Província de Nagano",
      "thName": "จังหวัดนางาโนะ",
      "viName": "Tỉnh Nagano",
      "inName": "Prefektur Nagano",
      "tlName": "Nagano Prefecture",
      "moName": "Нагано аймаг",
      "buName": "နားဂါနို ပြည်နယ်",
      "khName": "ខេត្ដ ណាហ្គាណូ",
      "neName": "नागानो जिल्ला"
    },
    "class10": {
      "code": "200020",
      "name": "中部",
      "enName": "Central Region",
      "chName": "长野县中部",
      "zhName": "長野縣中部",
      "koName": "나가노 현 중부",
      "esName": "Centro de Prefectura de Nagano",
      "ptName": "Região central da Província de Nagano",
      "thName": "จังหวัดนางาโนะตอนกลาง",
      "viName": "Miền Trung tỉnh Nagano",
      "inName": "Bagian Tengah Prefektur Nagano",
      "tlName": "Sentral na bahagi ng Nagano Prefecture",
      "moName": "Төв Нагано аймаг",
      "buName": "နဂိုနိုစီရင်စုအလယ်ပိုင်း",
      "khName": "តំបន់កណ្តាលនៃខេត្ដណាហ្គាណុ",
      "neName": "नागानो जिल्लाको मध्य भाग"
    },
    "class15": {
      "code": "200023",
      "name": "松本地域",
      "enName": "Matsumoto Area"
    },
    "class20": {
      "code": "2044800",
      "name": "生坂村",
      "enName": "Ikusaka Village",
      "kana": "いくさかむら",
      "chName": "生坂村",
      "zhName": "生坂村",
      "koName": "이쿠사카 촌",
      "esName": "Aldea de Ikusaka",
      "ptName": "povoado de Ikusaka",
      "thName": "หมู่บ้านอิคุซากะ",
      "viName": "làng Ikusaka",
      "inName": "desa Ikusaka",
      "tlName": "nayon ng Ikusaka",
      "moName": "Икүсaка тосгон",
      "buName": "အီကုဆာ့က ကျေးရွာ",
      "khName": "ភូមិ អ៊ីគូសាកា",
      "neName": "इकुसाका गाउँ"
    }
  },
  "2045000": {
    "office": {
      "code": "200000",
      "name": "長野県",
      "enName": "Nagano",
      "officeName": "長野地方気象台",
      "chName": "长野县",
      "zhName": "長野縣",
      "koName": "나가노현",
      "esName": "Prefectura de Nagano",
      "ptName": "Província de Nagano",
      "thName": "จังหวัดนางาโนะ",
      "viName": "Tỉnh Nagano",
      "inName": "Prefektur Nagano",
      "tlName": "Nagano Prefecture",
      "moName": "Нагано аймаг",
      "buName": "နားဂါနို ပြည်နယ်",
      "khName": "ខេត្ដ ណាហ្គាណូ",
      "neName": "नागानो जिल्ला"
    },
    "class10": {
      "code": "200020",
      "name": "中部",
      "enName": "Central Region",
      "chName": "长野县中部",
      "zhName": "長野縣中部",
      "koName": "나가노 현 중부",
      "esName": "Centro de Prefectura de Nagano",
      "ptName": "Região central da Província de Nagano",
      "thName": "จังหวัดนางาโนะตอนกลาง",
      "viName": "Miền Trung tỉnh Nagano",
      "inName": "Bagian Tengah Prefektur Nagano",
      "tlName": "Sentral na bahagi ng Nagano Prefecture",
      "moName": "Төв Нагано аймаг",
      "buName": "နဂိုနိုစီရင်စုအလယ်ပိုင်း",
      "khName": "តំបន់កណ្តាលនៃខេត្ដណាហ្គាណុ",
      "neName": "नागानो जिल्लाको मध्य भाग"
    },
    "class15": {
      "code": "200023",
      "name": "松本地域",
      "enName": "Matsumoto Area"
    },
    "class20": {
      "code": "2045000",
      "name": "山形村",
      "enName": "Yamagata Village",
      "kana": "やまがたむら",
      "chName": "山形村",
      "zhName": "山形町",
      "koName": "야마가타 촌",
      "esName": "Aldea de Yamagata",
      "ptName": "povoado de Yamagata",
      "thName": "หมู่บ้านยามางาตะ",
      "viName": "làng Yamagata",
      "inName": "desa Yamagata",
      "tlName": "nayon ng Yamagata",
      "moName": "Ямaгaта тосгон",
      "buName": "ယာမာဂတ ကျေးရွာ",
      "khName": "ភូមិ យ៉ាម៉ាហ្គាតា",
      "neName": "यामागाता गाउँ"
    }
  },
  "2045100": {
    "office": {
      "code": "200000",
      "name": "長野県",
      "enName": "Nagano",
      "officeName": "長野地方気象台",
      "chName": "长野县",
      "zhName": "長野縣",
      "koName": "나가노현",
      "esName": "Prefectura de Nagano",
      "ptName": "Província de Nagano",
      "thName": "จังหวัดนางาโนะ",
      "viName": "Tỉnh Nagano",
      "inName": "Prefektur Nagano",
      "tlName": "Nagano Prefecture",
      "moName": "Нагано аймаг",
      "buName": "နားဂါနို ပြည်နယ်",
      "khName": "ខេត្ដ ណាហ្គាណូ",
      "neName": "नागानो जिल्ला"
    },
    "class10": {
      "code": "200020",
      "name": "中部",
      "enName": "Central Region",
      "chName": "长野县中部",
      "zhName": "長野縣中部",
      "koName": "나가노 현 중부",
      "esName": "Centro de Prefectura de Nagano",
      "ptName": "Região central da Província de Nagano",
      "thName": "จังหวัดนางาโนะตอนกลาง",
      "viName": "Miền Trung tỉnh Nagano",
      "inName": "Bagian Tengah Prefektur Nagano",
      "tlName": "Sentral na bahagi ng Nagano Prefecture",
      "moName": "Төв Нагано аймаг",
      "buName": "နဂိုနိုစီရင်စုအလယ်ပိုင်း",
      "khName": "តំបន់កណ្តាលនៃខេត្ដណាហ្គាណុ",
      "neName": "नागानो जिल्लाको मध्य भाग"
    },
    "class15": {
      "code": "200023",
      "name": "松本地域",
      "enName": "Matsumoto Area"
    },
    "class20": {
      "code": "2045100",
      "name": "朝日村",
      "enName": "Asahi Village",
      "kana": "あさひむら",
      "chName": "朝日村",
      "zhName": "朝日村",
      "koName": "아사히 촌",
      "esName": "Aldea de Asahi",
      "ptName": "povoado de Asahi",
      "thName": "หมู่บ้านอาซาฮิ",
      "viName": "làng Asahi",
      "inName": "desa Asahi",
      "tlName": "nayon ng Asahi",
      "moName": "Aсaхи тосгон",
      "buName": "အဆာ့ဟိ ကျေးရွာ",
      "khName": "ភូមិ អាសាហ៊ី",
      "neName": "आसाही गाउँ"
    }
  },
  "2045200": {
    "office": {
      "code": "200000",
      "name": "長野県",
      "enName": "Nagano",
      "officeName": "長野地方気象台",
      "chName": "长野县",
      "zhName": "長野縣",
      "koName": "나가노현",
      "esName": "Prefectura de Nagano",
      "ptName": "Província de Nagano",
      "thName": "จังหวัดนางาโนะ",
      "viName": "Tỉnh Nagano",
      "inName": "Prefektur Nagano",
      "tlName": "Nagano Prefecture",
      "moName": "Нагано аймаг",
      "buName": "နားဂါနို ပြည်နယ်",
      "khName": "ខេត្ដ ណាហ្គាណូ",
      "neName": "नागानो जिल्ला"
    },
    "class10": {
      "code": "200020",
      "name": "中部",
      "enName": "Central Region",
      "chName": "长野县中部",
      "zhName": "長野縣中部",
      "koName": "나가노 현 중부",
      "esName": "Centro de Prefectura de Nagano",
      "ptName": "Região central da Província de Nagano",
      "thName": "จังหวัดนางาโนะตอนกลาง",
      "viName": "Miền Trung tỉnh Nagano",
      "inName": "Bagian Tengah Prefektur Nagano",
      "tlName": "Sentral na bahagi ng Nagano Prefecture",
      "moName": "Төв Нагано аймаг",
      "buName": "နဂိုနိုစီရင်စုအလယ်ပိုင်း",
      "khName": "តំបន់កណ្តាលនៃខេត្ដណាហ្គាណុ",
      "neName": "नागानो जिल्लाको मध्य भाग"
    },
    "class15": {
      "code": "200023",
      "name": "松本地域",
      "enName": "Matsumoto Area"
    },
    "class20": {
      "code": "2045200",
      "name": "筑北村",
      "enName": "Chikuhoku Village",
      "kana": "ちくほくむら",
      "chName": "筑北村",
      "zhName": "築北村",
      "koName": "지쿠호쿠 촌",
      "esName": "Aldea de Chikuhoku",
      "ptName": "povoado de Chikuhoku",
      "thName": "หมู่บ้านชิกุโฮกุ",
      "viName": "làng Chikuhoku",
      "inName": "desa Chikuhoku",
      "tlName": "nayon ng Chikuhoku",
      "moName": "Чикүхокү тосгон",
      "buName": "ကျီကုဟိုကု ကျေးရွာ",
      "khName": "ភូមិ ជីគុហូគូ",
      "neName": "चिकुहोकु गाउँ"
    }
  },
  "2048100": {
    "office": {
      "code": "200000",
      "name": "長野県",
      "enName": "Nagano",
      "officeName": "長野地方気象台",
      "chName": "长野县",
      "zhName": "長野縣",
      "koName": "나가노현",
      "esName": "Prefectura de Nagano",
      "ptName": "Província de Nagano",
      "thName": "จังหวัดนางาโนะ",
      "viName": "Tỉnh Nagano",
      "inName": "Prefektur Nagano",
      "tlName": "Nagano Prefecture",
      "moName": "Нагано аймаг",
      "buName": "နားဂါနို ပြည်နယ်",
      "khName": "ខេត្ដ ណាហ្គាណូ",
      "neName": "नागानो जिल्ला"
    },
    "class10": {
      "code": "200010",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "长野县北部",
      "zhName": "長野縣北部",
      "koName": "나가노 현 북부",
      "esName": "Norte de Prefectura de Nagano",
      "ptName": "Região norte da Província de Nagano",
      "thName": "จังหวัดนางาโนะตอนเหนือ",
      "viName": "Miền Bắc tỉnh Nagano",
      "inName": "Bagian Utara Prefektur Nagano",
      "tlName": "Hilagang bahagi ng Nagano Prefecture",
      "moName": "Хойд Нагано аймаг",
      "buName": "နဂိုနိုစီရင်စုမြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដណាហ្គាណុ",
      "neName": "नागानो जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "200013",
      "name": "大北地域",
      "enName": "Daihoku Area"
    },
    "class20": {
      "code": "2048100",
      "name": "池田町",
      "enName": "Ikeda Town",
      "kana": "いけだまち",
      "chName": "长野池田町",
      "zhName": "長野池田町",
      "koName": "나가노 이케다 정",
      "esName": "Pueblo de Ikeda, Nagano",
      "ptName": "Nagano, bairro de Ikeda",
      "thName": "เมืองอิเคดะ นางาโนะ",
      "viName": "Thị trấn Ikeda, Nagano",
      "inName": "Kota Ikeda, Nagano",
      "tlName": "bayan ng Ikeda, Nagano",
      "moName": "Нагано Икеда жижиг хот",
      "buName": "နကနိုအိခဲဒမြို့နယ် ",
      "khName": "ទីប្រជុំជនអ៊ីកេដា ណាហ្គាណុ",
      "neName": "नागानो इकेदा नगर"
    }
  },
  "2048200": {
    "office": {
      "code": "200000",
      "name": "長野県",
      "enName": "Nagano",
      "officeName": "長野地方気象台",
      "chName": "长野县",
      "zhName": "長野縣",
      "koName": "나가노현",
      "esName": "Prefectura de Nagano",
      "ptName": "Província de Nagano",
      "thName": "จังหวัดนางาโนะ",
      "viName": "Tỉnh Nagano",
      "inName": "Prefektur Nagano",
      "tlName": "Nagano Prefecture",
      "moName": "Нагано аймаг",
      "buName": "နားဂါနို ပြည်နယ်",
      "khName": "ខេត្ដ ណាហ្គាណូ",
      "neName": "नागानो जिल्ला"
    },
    "class10": {
      "code": "200010",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "长野县北部",
      "zhName": "長野縣北部",
      "koName": "나가노 현 북부",
      "esName": "Norte de Prefectura de Nagano",
      "ptName": "Região norte da Província de Nagano",
      "thName": "จังหวัดนางาโนะตอนเหนือ",
      "viName": "Miền Bắc tỉnh Nagano",
      "inName": "Bagian Utara Prefektur Nagano",
      "tlName": "Hilagang bahagi ng Nagano Prefecture",
      "moName": "Хойд Нагано аймаг",
      "buName": "နဂိုနိုစီရင်စုမြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដណាហ្គាណុ",
      "neName": "नागानो जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "200013",
      "name": "大北地域",
      "enName": "Daihoku Area"
    },
    "class20": {
      "code": "2048200",
      "name": "松川村",
      "enName": "Matsukawa Village",
      "kana": "まつかわむら",
      "chName": "松川村",
      "zhName": "松川村",
      "koName": "마쓰카와 촌",
      "esName": "Aldea de Matsukawa",
      "ptName": "povoado de Matsukawa",
      "thName": "หมู่บ้านมัตสึคาวะ",
      "viName": "làng Matsukawa",
      "inName": "desa Matsukawa",
      "tlName": "nayon ng Matsukawa",
      "moName": "Мацүкава тосгон",
      "buName": "မာဆုကာ့ဝ ကျေးရွာ",
      "khName": "ភូមិ ម៉ាតស៊ូកាវ៉ា",
      "neName": "मात्सुकावा गाउँ"
    }
  },
  "2048500": {
    "office": {
      "code": "200000",
      "name": "長野県",
      "enName": "Nagano",
      "officeName": "長野地方気象台",
      "chName": "长野县",
      "zhName": "長野縣",
      "koName": "나가노현",
      "esName": "Prefectura de Nagano",
      "ptName": "Província de Nagano",
      "thName": "จังหวัดนางาโนะ",
      "viName": "Tỉnh Nagano",
      "inName": "Prefektur Nagano",
      "tlName": "Nagano Prefecture",
      "moName": "Нагано аймаг",
      "buName": "နားဂါနို ပြည်နယ်",
      "khName": "ខេត្ដ ណាហ្គាណូ",
      "neName": "नागानो जिल्ला"
    },
    "class10": {
      "code": "200010",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "长野县北部",
      "zhName": "長野縣北部",
      "koName": "나가노 현 북부",
      "esName": "Norte de Prefectura de Nagano",
      "ptName": "Região norte da Província de Nagano",
      "thName": "จังหวัดนางาโนะตอนเหนือ",
      "viName": "Miền Bắc tỉnh Nagano",
      "inName": "Bagian Utara Prefektur Nagano",
      "tlName": "Hilagang bahagi ng Nagano Prefecture",
      "moName": "Хойд Нагано аймаг",
      "buName": "နဂိုနိုစီရင်စုမြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដណាហ្គាណុ",
      "neName": "नागानो जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "200013",
      "name": "大北地域",
      "enName": "Daihoku Area"
    },
    "class20": {
      "code": "2048500",
      "name": "白馬村",
      "enName": "Hakuba Village",
      "kana": "はくばむら",
      "chName": "白马村",
      "zhName": "白馬村",
      "koName": "하쿠바 촌",
      "esName": "Aldea de Hakuba",
      "ptName": "povoado de Hakuba",
      "thName": "หมู่บ้านฮาคุบะ",
      "viName": "làng Hakuba",
      "inName": "desa Hakuba",
      "tlName": "nayon ng Hakuba",
      "moName": "Хaкүба тосгон",
      "buName": "ဟာကုဗ ကျေးရွာ",
      "khName": "ភូមិ ហាក់គូបា",
      "neName": "हाकुबा गाउँ"
    }
  },
  "2048600": {
    "office": {
      "code": "200000",
      "name": "長野県",
      "enName": "Nagano",
      "officeName": "長野地方気象台",
      "chName": "长野县",
      "zhName": "長野縣",
      "koName": "나가노현",
      "esName": "Prefectura de Nagano",
      "ptName": "Província de Nagano",
      "thName": "จังหวัดนางาโนะ",
      "viName": "Tỉnh Nagano",
      "inName": "Prefektur Nagano",
      "tlName": "Nagano Prefecture",
      "moName": "Нагано аймаг",
      "buName": "နားဂါနို ပြည်နယ်",
      "khName": "ខេត្ដ ណាហ្គាណូ",
      "neName": "नागानो जिल्ला"
    },
    "class10": {
      "code": "200010",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "长野县北部",
      "zhName": "長野縣北部",
      "koName": "나가노 현 북부",
      "esName": "Norte de Prefectura de Nagano",
      "ptName": "Região norte da Província de Nagano",
      "thName": "จังหวัดนางาโนะตอนเหนือ",
      "viName": "Miền Bắc tỉnh Nagano",
      "inName": "Bagian Utara Prefektur Nagano",
      "tlName": "Hilagang bahagi ng Nagano Prefecture",
      "moName": "Хойд Нагано аймаг",
      "buName": "နဂိုနိုစီရင်စုမြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដណាហ្គាណុ",
      "neName": "नागानो जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "200013",
      "name": "大北地域",
      "enName": "Daihoku Area"
    },
    "class20": {
      "code": "2048600",
      "name": "小谷村",
      "enName": "Otari Village",
      "kana": "おたりむら",
      "chName": "小谷村",
      "zhName": "小谷村",
      "koName": "오타리 촌",
      "esName": "Aldea de Otari",
      "ptName": "povoado de Otari",
      "thName": "หมู่บ้านโอตาริ",
      "viName": "làng Otari",
      "inName": "desa Otari",
      "tlName": "nayon ng Otari",
      "moName": "Отари тосгон",
      "buName": "အိုတာ့ရိ ကျေးရွာ",
      "khName": "ភូមិ អូតារី",
      "neName": "ओतारी गाउँ"
    }
  },
  "2052100": {
    "office": {
      "code": "200000",
      "name": "長野県",
      "enName": "Nagano",
      "officeName": "長野地方気象台",
      "chName": "长野县",
      "zhName": "長野縣",
      "koName": "나가노현",
      "esName": "Prefectura de Nagano",
      "ptName": "Província de Nagano",
      "thName": "จังหวัดนางาโนะ",
      "viName": "Tỉnh Nagano",
      "inName": "Prefektur Nagano",
      "tlName": "Nagano Prefecture",
      "moName": "Нагано аймаг",
      "buName": "နားဂါနို ပြည်နယ်",
      "khName": "ខេត្ដ ណាហ្គាណូ",
      "neName": "नागानो जिल्ला"
    },
    "class10": {
      "code": "200010",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "长野县北部",
      "zhName": "長野縣北部",
      "koName": "나가노 현 북부",
      "esName": "Norte de Prefectura de Nagano",
      "ptName": "Região norte da Província de Nagano",
      "thName": "จังหวัดนางาโนะตอนเหนือ",
      "viName": "Miền Bắc tỉnh Nagano",
      "inName": "Bagian Utara Prefektur Nagano",
      "tlName": "Hilagang bahagi ng Nagano Prefecture",
      "moName": "Хойд Нагано аймаг",
      "buName": "နဂိုနိုစီရင်စုမြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដណាហ្គាណុ",
      "neName": "नागानो जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "200011",
      "name": "長野地域",
      "enName": "Nagano Area"
    },
    "class20": {
      "code": "2052100",
      "name": "坂城町",
      "enName": "Sakaki Town",
      "kana": "さかきまち",
      "chName": "坂城町",
      "zhName": "坂城町",
      "koName": "사카키 정",
      "esName": "Pueblo de Sakaki",
      "ptName": "bairro de Sakaki",
      "thName": "เมืองซาคากิ",
      "viName": "thị trấn Sakaki",
      "inName": "kota Sakaki",
      "tlName": "bayan ng Sakaki",
      "moName": "Сaкаки жижиг хот",
      "buName": "ဆာကာ့ကိ မြို့နယ်",
      "khName": "ទីប្រជុំជន សាកាគី",
      "neName": "साकाकी नगर"
    }
  },
  "2054100": {
    "office": {
      "code": "200000",
      "name": "長野県",
      "enName": "Nagano",
      "officeName": "長野地方気象台",
      "chName": "长野县",
      "zhName": "長野縣",
      "koName": "나가노현",
      "esName": "Prefectura de Nagano",
      "ptName": "Província de Nagano",
      "thName": "จังหวัดนางาโนะ",
      "viName": "Tỉnh Nagano",
      "inName": "Prefektur Nagano",
      "tlName": "Nagano Prefecture",
      "moName": "Нагано аймаг",
      "buName": "နားဂါနို ပြည်နယ်",
      "khName": "ខេត្ដ ណាហ្គាណូ",
      "neName": "नागानो जिल्ला"
    },
    "class10": {
      "code": "200010",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "长野县北部",
      "zhName": "長野縣北部",
      "koName": "나가노 현 북부",
      "esName": "Norte de Prefectura de Nagano",
      "ptName": "Região norte da Província de Nagano",
      "thName": "จังหวัดนางาโนะตอนเหนือ",
      "viName": "Miền Bắc tỉnh Nagano",
      "inName": "Bagian Utara Prefektur Nagano",
      "tlName": "Hilagang bahagi ng Nagano Prefecture",
      "moName": "Хойд Нагано аймаг",
      "buName": "နဂိုနိုစီရင်စုမြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដណាហ្គាណុ",
      "neName": "नागानो जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "200011",
      "name": "長野地域",
      "enName": "Nagano Area"
    },
    "class20": {
      "code": "2054100",
      "name": "小布施町",
      "enName": "Obuse Town",
      "kana": "おぶせまち",
      "chName": "小布施町",
      "zhName": "小布施町",
      "koName": "오부세 정",
      "esName": "Pueblo de Obuse",
      "ptName": "bairro de Obuse",
      "thName": "เมืองโอบุเสะ",
      "viName": "thị trấn Obuse",
      "inName": "kota Obuse",
      "tlName": "bayan ng Obuse Town",
      "moName": "Обүсэ жижиг хот",
      "buName": "အိုဘုဆဲ့ မြို့နယ်",
      "khName": "ទីប្រជុំជន អូប្យូស",
      "neName": "ओबुसे नगर"
    }
  },
  "2054300": {
    "office": {
      "code": "200000",
      "name": "長野県",
      "enName": "Nagano",
      "officeName": "長野地方気象台",
      "chName": "长野县",
      "zhName": "長野縣",
      "koName": "나가노현",
      "esName": "Prefectura de Nagano",
      "ptName": "Província de Nagano",
      "thName": "จังหวัดนางาโนะ",
      "viName": "Tỉnh Nagano",
      "inName": "Prefektur Nagano",
      "tlName": "Nagano Prefecture",
      "moName": "Нагано аймаг",
      "buName": "နားဂါနို ပြည်နယ်",
      "khName": "ខេត្ដ ណាហ្គាណូ",
      "neName": "नागानो जिल्ला"
    },
    "class10": {
      "code": "200010",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "长野县北部",
      "zhName": "長野縣北部",
      "koName": "나가노 현 북부",
      "esName": "Norte de Prefectura de Nagano",
      "ptName": "Região norte da Província de Nagano",
      "thName": "จังหวัดนางาโนะตอนเหนือ",
      "viName": "Miền Bắc tỉnh Nagano",
      "inName": "Bagian Utara Prefektur Nagano",
      "tlName": "Hilagang bahagi ng Nagano Prefecture",
      "moName": "Хойд Нагано аймаг",
      "buName": "နဂိုနိုစီရင်စုမြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដណាហ្គាណុ",
      "neName": "नागानो जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "200011",
      "name": "長野地域",
      "enName": "Nagano Area"
    },
    "class20": {
      "code": "2054300",
      "name": "高山村",
      "enName": "Takayama Village",
      "kana": "たかやまむら",
      "chName": "长野高山村",
      "zhName": "長野高山村",
      "koName": "나가노 다카야마 촌",
      "esName": "Aldea de Takayama, Nagano",
      "ptName": "Nagano, povoado de Takayama",
      "thName": "หมู่บ้านทากายามะ นางาโนะ",
      "viName": "Làng Takayama, Nagano",
      "inName": "Desa Takayama, Nagano",
      "tlName": "nayon ng Takayama, Nagano",
      "moName": "Нагано Такаяма тосгон",
      "buName": "နကနိုတကယမရွာ",
      "khName": "ភូមិតាកាយ៉ាម៉ា ណាហ្គាណុ",
      "neName": "नागानो ताकायामा गाउँ"
    }
  },
  "2056100": {
    "office": {
      "code": "200000",
      "name": "長野県",
      "enName": "Nagano",
      "officeName": "長野地方気象台",
      "chName": "长野县",
      "zhName": "長野縣",
      "koName": "나가노현",
      "esName": "Prefectura de Nagano",
      "ptName": "Província de Nagano",
      "thName": "จังหวัดนางาโนะ",
      "viName": "Tỉnh Nagano",
      "inName": "Prefektur Nagano",
      "tlName": "Nagano Prefecture",
      "moName": "Нагано аймаг",
      "buName": "နားဂါနို ပြည်နယ်",
      "khName": "ខេត្ដ ណាហ្គាណូ",
      "neName": "नागानो जिल्ला"
    },
    "class10": {
      "code": "200010",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "长野县北部",
      "zhName": "長野縣北部",
      "koName": "나가노 현 북부",
      "esName": "Norte de Prefectura de Nagano",
      "ptName": "Região norte da Província de Nagano",
      "thName": "จังหวัดนางาโนะตอนเหนือ",
      "viName": "Miền Bắc tỉnh Nagano",
      "inName": "Bagian Utara Prefektur Nagano",
      "tlName": "Hilagang bahagi ng Nagano Prefecture",
      "moName": "Хойд Нагано аймаг",
      "buName": "နဂိုနိုစီရင်စုမြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដណាហ្គាណុ",
      "neName": "नागानो जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "200012",
      "name": "中野飯山地域",
      "enName": "Nakano Iiyama Area"
    },
    "class20": {
      "code": "2056100",
      "name": "山ノ内町",
      "enName": "Yamanouchi Town",
      "kana": "やまのうちまち",
      "chName": "山之内町",
      "zhName": "山之內町",
      "koName": "야마노우치 촌",
      "esName": "Pueblo de Yamanouchi",
      "ptName": "bairro de Yamanouchi",
      "thName": "เมืองยามาโนอุจิ",
      "viName": "thị trấn Yamanouchi",
      "inName": "kota Yamanouchi",
      "tlName": "bayan ng Yamanouchi",
      "moName": "Ямaноүчи жижиг хот",
      "buName": "ယာမာနောဥကျိ မြို့နယ်",
      "khName": "ទីប្រជុំជន យ៉ាម៉ានូជី",
      "neName": "यामानोउची नगर"
    }
  },
  "2056200": {
    "office": {
      "code": "200000",
      "name": "長野県",
      "enName": "Nagano",
      "officeName": "長野地方気象台",
      "chName": "长野县",
      "zhName": "長野縣",
      "koName": "나가노현",
      "esName": "Prefectura de Nagano",
      "ptName": "Província de Nagano",
      "thName": "จังหวัดนางาโนะ",
      "viName": "Tỉnh Nagano",
      "inName": "Prefektur Nagano",
      "tlName": "Nagano Prefecture",
      "moName": "Нагано аймаг",
      "buName": "နားဂါနို ပြည်နယ်",
      "khName": "ខេត្ដ ណាហ្គាណូ",
      "neName": "नागानो जिल्ला"
    },
    "class10": {
      "code": "200010",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "长野县北部",
      "zhName": "長野縣北部",
      "koName": "나가노 현 북부",
      "esName": "Norte de Prefectura de Nagano",
      "ptName": "Região norte da Província de Nagano",
      "thName": "จังหวัดนางาโนะตอนเหนือ",
      "viName": "Miền Bắc tỉnh Nagano",
      "inName": "Bagian Utara Prefektur Nagano",
      "tlName": "Hilagang bahagi ng Nagano Prefecture",
      "moName": "Хойд Нагано аймаг",
      "buName": "နဂိုနိုစီရင်စုမြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដណាហ្គាណុ",
      "neName": "नागानो जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "200012",
      "name": "中野飯山地域",
      "enName": "Nakano Iiyama Area"
    },
    "class20": {
      "code": "2056200",
      "name": "木島平村",
      "enName": "Kijimadaira Village",
      "kana": "きじまだいらむら",
      "chName": "木岛平村",
      "zhName": "木島平村",
      "koName": "기지마다이라 촌",
      "esName": "Aldea de Kijimadaira",
      "ptName": "povoado de Kijimadaira",
      "thName": "หมู่บ้านคิจิมะไดระ",
      "viName": "làng Kijimadaira",
      "inName": "desa Kijimadaira",
      "tlName": "nayon ng Kijimadaira",
      "moName": "Кижимaдайра тосгон",
      "buName": "ကီဂျိမာဒါးယိရာ့ ကျေးရွာ",
      "khName": "ភូមិ គីជីម៉ាដាយរ៉ា",
      "neName": "किजिमादाइरा गाउँ"
    }
  },
  "2056300": {
    "office": {
      "code": "200000",
      "name": "長野県",
      "enName": "Nagano",
      "officeName": "長野地方気象台",
      "chName": "长野县",
      "zhName": "長野縣",
      "koName": "나가노현",
      "esName": "Prefectura de Nagano",
      "ptName": "Província de Nagano",
      "thName": "จังหวัดนางาโนะ",
      "viName": "Tỉnh Nagano",
      "inName": "Prefektur Nagano",
      "tlName": "Nagano Prefecture",
      "moName": "Нагано аймаг",
      "buName": "နားဂါနို ပြည်နယ်",
      "khName": "ខេត្ដ ណាហ្គាណូ",
      "neName": "नागानो जिल्ला"
    },
    "class10": {
      "code": "200010",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "长野县北部",
      "zhName": "長野縣北部",
      "koName": "나가노 현 북부",
      "esName": "Norte de Prefectura de Nagano",
      "ptName": "Região norte da Província de Nagano",
      "thName": "จังหวัดนางาโนะตอนเหนือ",
      "viName": "Miền Bắc tỉnh Nagano",
      "inName": "Bagian Utara Prefektur Nagano",
      "tlName": "Hilagang bahagi ng Nagano Prefecture",
      "moName": "Хойд Нагано аймаг",
      "buName": "နဂိုနိုစီရင်စုမြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដណាហ្គាណុ",
      "neName": "नागानो जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "200012",
      "name": "中野飯山地域",
      "enName": "Nakano Iiyama Area"
    },
    "class20": {
      "code": "2056300",
      "name": "野沢温泉村",
      "enName": "Nozawaonsen Village",
      "kana": "のざわおんせんむら",
      "chName": "野泽温泉村",
      "zhName": "野澤溫泉村",
      "koName": "노자와온센 촌",
      "esName": "Aldea de Nozawaonsen",
      "ptName": "povoado de Nozawaonsen",
      "thName": "หมู่บ้านโนซาวะออนเซน",
      "viName": "làng Nozawaonsen",
      "inName": "desa Nozawaonsen",
      "tlName": "nayon ng Nozawaonsen",
      "moName": "Нозаваонсэн тосгон",
      "buName": "နိုဇာဝဟွန်းဆန် ကျေးရွာ",
      "khName": "ភូមិ ណូហ្សាវ៉ាអនសែន",
      "neName": "नोजावाओन्सेन गाउँ"
    }
  },
  "2058300": {
    "office": {
      "code": "200000",
      "name": "長野県",
      "enName": "Nagano",
      "officeName": "長野地方気象台",
      "chName": "长野县",
      "zhName": "長野縣",
      "koName": "나가노현",
      "esName": "Prefectura de Nagano",
      "ptName": "Província de Nagano",
      "thName": "จังหวัดนางาโนะ",
      "viName": "Tỉnh Nagano",
      "inName": "Prefektur Nagano",
      "tlName": "Nagano Prefecture",
      "moName": "Нагано аймаг",
      "buName": "နားဂါနို ပြည်နယ်",
      "khName": "ខេត្ដ ណាហ្គាណូ",
      "neName": "नागानो जिल्ला"
    },
    "class10": {
      "code": "200010",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "长野县北部",
      "zhName": "長野縣北部",
      "koName": "나가노 현 북부",
      "esName": "Norte de Prefectura de Nagano",
      "ptName": "Região norte da Província de Nagano",
      "thName": "จังหวัดนางาโนะตอนเหนือ",
      "viName": "Miền Bắc tỉnh Nagano",
      "inName": "Bagian Utara Prefektur Nagano",
      "tlName": "Hilagang bahagi ng Nagano Prefecture",
      "moName": "Хойд Нагано аймаг",
      "buName": "နဂိုနိုစီရင်စုမြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដណាហ្គាណុ",
      "neName": "नागानो जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "200011",
      "name": "長野地域",
      "enName": "Nagano Area"
    },
    "class20": {
      "code": "2058300",
      "name": "信濃町",
      "enName": "Shinano Town",
      "kana": "しなのまち",
      "chName": "信浓町",
      "zhName": "信濃町",
      "koName": "시나노 정",
      "esName": "Pueblo de Shinano",
      "ptName": "bairro de Shinano",
      "thName": "เมืองชินันโนะ",
      "viName": "thị trấn Shinano",
      "inName": "kota Shinano",
      "tlName": "bayan ng Shinano",
      "moName": "Шинaно жижиг хот",
      "buName": "ရှီနာနို မြို့နယ်",
      "khName": "ទីប្រជុំជន ស៊ីណាណូ",
      "neName": "शिनानो नगर"
    }
  },
  "2058800": {
    "office": {
      "code": "200000",
      "name": "長野県",
      "enName": "Nagano",
      "officeName": "長野地方気象台",
      "chName": "长野县",
      "zhName": "長野縣",
      "koName": "나가노현",
      "esName": "Prefectura de Nagano",
      "ptName": "Província de Nagano",
      "thName": "จังหวัดนางาโนะ",
      "viName": "Tỉnh Nagano",
      "inName": "Prefektur Nagano",
      "tlName": "Nagano Prefecture",
      "moName": "Нагано аймаг",
      "buName": "နားဂါနို ပြည်နယ်",
      "khName": "ខេត្ដ ណាហ្គាណូ",
      "neName": "नागानो जिल्ला"
    },
    "class10": {
      "code": "200010",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "长野县北部",
      "zhName": "長野縣北部",
      "koName": "나가노 현 북부",
      "esName": "Norte de Prefectura de Nagano",
      "ptName": "Região norte da Província de Nagano",
      "thName": "จังหวัดนางาโนะตอนเหนือ",
      "viName": "Miền Bắc tỉnh Nagano",
      "inName": "Bagian Utara Prefektur Nagano",
      "tlName": "Hilagang bahagi ng Nagano Prefecture",
      "moName": "Хойд Нагано аймаг",
      "buName": "နဂိုနိုစီရင်စုမြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដណាហ្គាណុ",
      "neName": "नागानो जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "200011",
      "name": "長野地域",
      "enName": "Nagano Area"
    },
    "class20": {
      "code": "2058800",
      "name": "小川村",
      "enName": "Ogawa Village",
      "kana": "おがわむら",
      "chName": "小川村",
      "zhName": "小川村",
      "koName": "오가와 촌",
      "esName": "Aldea de Ogawa",
      "ptName": "povoado de Ogawa",
      "thName": "หมู่บ้านโองาวะ",
      "viName": "làng Ogawa",
      "inName": "desa Ogawa",
      "tlName": "nayon ng Ogawa",
      "moName": "Огава тосгон",
      "buName": "အိုဂါ့ဝ ကျေးရွာ",
      "khName": "ភូមិ អូហ្គាវ៉ា",
      "neName": "ओगावा गाउँ"
    }
  },
  "2059000": {
    "office": {
      "code": "200000",
      "name": "長野県",
      "enName": "Nagano",
      "officeName": "長野地方気象台",
      "chName": "长野县",
      "zhName": "長野縣",
      "koName": "나가노현",
      "esName": "Prefectura de Nagano",
      "ptName": "Província de Nagano",
      "thName": "จังหวัดนางาโนะ",
      "viName": "Tỉnh Nagano",
      "inName": "Prefektur Nagano",
      "tlName": "Nagano Prefecture",
      "moName": "Нагано аймаг",
      "buName": "နားဂါနို ပြည်နယ်",
      "khName": "ខេត្ដ ណាហ្គាណូ",
      "neName": "नागानो जिल्ला"
    },
    "class10": {
      "code": "200010",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "长野县北部",
      "zhName": "長野縣北部",
      "koName": "나가노 현 북부",
      "esName": "Norte de Prefectura de Nagano",
      "ptName": "Região norte da Província de Nagano",
      "thName": "จังหวัดนางาโนะตอนเหนือ",
      "viName": "Miền Bắc tỉnh Nagano",
      "inName": "Bagian Utara Prefektur Nagano",
      "tlName": "Hilagang bahagi ng Nagano Prefecture",
      "moName": "Хойд Нагано аймаг",
      "buName": "နဂိုနိုစီရင်စုမြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដណាហ្គាណុ",
      "neName": "नागानो जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "200011",
      "name": "長野地域",
      "enName": "Nagano Area"
    },
    "class20": {
      "code": "2059000",
      "name": "飯綱町",
      "enName": "Iizuna Town",
      "kana": "いいづなまち",
      "chName": "饭网町",
      "zhName": "飯綱町",
      "koName": "이즈나 정",
      "esName": "Pueblo de Iizuna",
      "ptName": "bairro de Iizuna",
      "thName": "เมืองอิอิซุนะ",
      "viName": "thị trấn Iizuna",
      "inName": "kota Iizuna",
      "tlName": "bayan ng Iizuna",
      "moName": "Ийзүнa жижиг хот",
      "buName": "အီးဇုန မြို့နယ်",
      "khName": "ទីប្រជុំជន អាយហ្សូណា",
      "neName": "आइजुना नगर"
    }
  },
  "2060200": {
    "office": {
      "code": "200000",
      "name": "長野県",
      "enName": "Nagano",
      "officeName": "長野地方気象台",
      "chName": "长野县",
      "zhName": "長野縣",
      "koName": "나가노현",
      "esName": "Prefectura de Nagano",
      "ptName": "Província de Nagano",
      "thName": "จังหวัดนางาโนะ",
      "viName": "Tỉnh Nagano",
      "inName": "Prefektur Nagano",
      "tlName": "Nagano Prefecture",
      "moName": "Нагано аймаг",
      "buName": "နားဂါနို ပြည်နယ်",
      "khName": "ខេត្ដ ណាហ្គាណូ",
      "neName": "नागानो जिल्ला"
    },
    "class10": {
      "code": "200010",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "长野县北部",
      "zhName": "長野縣北部",
      "koName": "나가노 현 북부",
      "esName": "Norte de Prefectura de Nagano",
      "ptName": "Região norte da Província de Nagano",
      "thName": "จังหวัดนางาโนะตอนเหนือ",
      "viName": "Miền Bắc tỉnh Nagano",
      "inName": "Bagian Utara Prefektur Nagano",
      "tlName": "Hilagang bahagi ng Nagano Prefecture",
      "moName": "Хойд Нагано аймаг",
      "buName": "နဂိုနိုစီရင်စုမြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដណាហ្គាណុ",
      "neName": "नागानो जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "200012",
      "name": "中野飯山地域",
      "enName": "Nakano Iiyama Area"
    },
    "class20": {
      "code": "2060200",
      "name": "栄村",
      "enName": "Sakae Village",
      "kana": "さかえむら",
      "chName": "荣村",
      "zhName": "榮村",
      "koName": "사카에 촌",
      "esName": "Aldea de Sakae",
      "ptName": "povoado de Sakae",
      "thName": "หมู่บ้านซาคาเอะ",
      "viName": "làng Sakae",
      "inName": "desa Sakae",
      "tlName": "nayon ng Sakae",
      "moName": "Сaкаэ тосгон",
      "buName": "ဆာကားယဲ့ ကျေးရွာ",
      "khName": "ភូមិ សាកេ",
      "neName": "साकाए गाउँ"
    }
  },
  "2120100": {
    "office": {
      "code": "210000",
      "name": "岐阜県",
      "enName": "Gifu",
      "officeName": "岐阜地方気象台",
      "chName": "岐阜县",
      "zhName": "岐阜縣",
      "koName": "기후현",
      "esName": "Prefectura de Gifu",
      "ptName": "Província de Gifu",
      "thName": "จังหวัดกิฟุ",
      "viName": "Tỉnh Gifu",
      "inName": "Prefektur Gifu",
      "tlName": "Gifu Prefecture",
      "moName": "Гифү аймаг",
      "buName": "ဂျီဖု ပြည်နယ်",
      "khName": "ខេត្ដ ហ្គីហ្វូ",
      "neName": "गिफु जिल्ला"
    },
    "class10": {
      "code": "210010",
      "name": "美濃地方",
      "enName": "Mino Region",
      "chName": "美濃地區, 岐阜县",
      "zhName": "美浓地区, 飞弹地区",
      "koName": "미노 지방, 기후 현",
      "esName": "Región de Mino, Prefectura de Gifu",
      "ptName": "Região de Mino da Província de Gifu",
      "thName": "ภูมิภาคมิโนะ จังหวัดกิฟุ",
      "viName": "Vùng Mino, tỉnh Gifu",
      "inName": "Wilayah Mino di Provinsi Gifu",
      "tlName": "Rehiyon ng Mino sa Gifu Prefecture",
      "moName": "Мино бүс, Гифү аймаг",
      "buName": "Mino ဒေသ, ဂိဟုစီရင်စု",
      "khName": "តំបន់មីណូ, ខេត្តកីហ្វុ",
      "neName": "मिनो क्षेत्र, गिफु जिल्ला"
    },
    "class15": {
      "code": "210011",
      "name": "岐阜・西濃",
      "enName": "Gifu Seino"
    },
    "class20": {
      "code": "2120100",
      "name": "岐阜市",
      "enName": "Gifu City",
      "kana": "ぎふし",
      "chName": "岐阜市",
      "zhName": "岐阜市",
      "koName": "기후 시",
      "esName": "Ciudad de Gifu",
      "ptName": "cidade de Gifu",
      "thName": "เมืองกิฟุ",
      "viName": "thành phố Gifu",
      "inName": "kota Gifu",
      "tlName": "siyudad ng Gifu",
      "moName": "Гифү хот",
      "buName": "ဂီဖူ မြို့",
      "khName": "ទីក្រុង ហ្គីហ្វូ",
      "neName": "गिफु सहर"
    }
  },
  "2120200": {
    "office": {
      "code": "210000",
      "name": "岐阜県",
      "enName": "Gifu",
      "officeName": "岐阜地方気象台",
      "chName": "岐阜县",
      "zhName": "岐阜縣",
      "koName": "기후현",
      "esName": "Prefectura de Gifu",
      "ptName": "Província de Gifu",
      "thName": "จังหวัดกิฟุ",
      "viName": "Tỉnh Gifu",
      "inName": "Prefektur Gifu",
      "tlName": "Gifu Prefecture",
      "moName": "Гифү аймаг",
      "buName": "ဂျီဖု ပြည်နယ်",
      "khName": "ខេត្ដ ហ្គីហ្វូ",
      "neName": "गिफु जिल्ला"
    },
    "class10": {
      "code": "210010",
      "name": "美濃地方",
      "enName": "Mino Region",
      "chName": "美濃地區, 岐阜县",
      "zhName": "美浓地区, 飞弹地区",
      "koName": "미노 지방, 기후 현",
      "esName": "Región de Mino, Prefectura de Gifu",
      "ptName": "Região de Mino da Província de Gifu",
      "thName": "ภูมิภาคมิโนะ จังหวัดกิฟุ",
      "viName": "Vùng Mino, tỉnh Gifu",
      "inName": "Wilayah Mino di Provinsi Gifu",
      "tlName": "Rehiyon ng Mino sa Gifu Prefecture",
      "moName": "Мино бүс, Гифү аймаг",
      "buName": "Mino ဒေသ, ဂိဟုစီရင်စု",
      "khName": "តំបន់មីណូ, ខេត្តកីហ្វុ",
      "neName": "मिनो क्षेत्र, गिफु जिल्ला"
    },
    "class15": {
      "code": "210011",
      "name": "岐阜・西濃",
      "enName": "Gifu Seino"
    },
    "class20": {
      "code": "2120200",
      "name": "大垣市",
      "enName": "Ogaki City",
      "kana": "おおがきし",
      "chName": "大垣市",
      "zhName": "大垣市",
      "koName": "오가키 시",
      "esName": "Ciudad de Ogaki",
      "ptName": "cidade de Ogaki",
      "thName": "เมืองโองาคิ",
      "viName": "thành phố Ogaki",
      "inName": "kota Ogaki",
      "tlName": "siyudad ng Ogaki",
      "moName": "Огaки хот",
      "buName": "အို့ဂါးကိ မြို့",
      "khName": "ទីក្រុង អូហ្គាគី",
      "neName": "ओगाकी सहर"
    }
  },
  "2120300": {
    "office": {
      "code": "210000",
      "name": "岐阜県",
      "enName": "Gifu",
      "officeName": "岐阜地方気象台",
      "chName": "岐阜县",
      "zhName": "岐阜縣",
      "koName": "기후현",
      "esName": "Prefectura de Gifu",
      "ptName": "Província de Gifu",
      "thName": "จังหวัดกิฟุ",
      "viName": "Tỉnh Gifu",
      "inName": "Prefektur Gifu",
      "tlName": "Gifu Prefecture",
      "moName": "Гифү аймаг",
      "buName": "ဂျီဖု ပြည်နယ်",
      "khName": "ខេត្ដ ហ្គីហ្វូ",
      "neName": "गिफु जिल्ला"
    },
    "class10": {
      "code": "210020",
      "name": "飛騨地方",
      "enName": "Hida Region",
      "chName": "飛彈地區, 岐阜县",
      "zhName": "飞弹地区, 美浓地区",
      "koName": "히다 지방, 기후 현",
      "esName": "Región de Hida, Prefectura de Gifu",
      "ptName": "Região de Hida da Província de Gifu",
      "thName": "ภูมิภาคฮิดะ จังหวัดกิฟุ",
      "viName": "Vùng Hida, tỉnh Gifu",
      "inName": "Wilayah Hida di Provinsi Gifu",
      "tlName": "Rehiyon ng Hida sa Gifu Prefecture",
      "moName": "Хида бүс, Гифү аймаг",
      "buName": "Hida ဒေသ, ဂိဟုစီရင်စု",
      "khName": "តំបន់ Hida, ខេត្តកីហ្វុ",
      "neName": "हिडा क्षेत्र, गिफु जिल्ला"
    },
    "class15": {
      "code": "210021",
      "name": "飛騨北部",
      "enName": "Northern Hida"
    },
    "class20": {
      "code": "2120300",
      "name": "高山市",
      "enName": "Takayama City",
      "kana": "たかやまし",
      "chName": "高山市",
      "zhName": "髙山市",
      "koName": "타카야마 시",
      "esName": "Ciudad de Takayama",
      "ptName": "cidade de Takayama",
      "thName": "เมืองทากายามะ",
      "viName": "thành phố Takayama",
      "inName": "kota Takayama",
      "tlName": "siyudad ng Takayama",
      "moName": "Такаяма хот",
      "buName": "တာကားယာ့မ မြို့",
      "khName": "ទីក្រុង តាកាយ៉ាម៉ា",
      "neName": "ताकायामा सहर"
    }
  },
  "2120400": {
    "office": {
      "code": "210000",
      "name": "岐阜県",
      "enName": "Gifu",
      "officeName": "岐阜地方気象台",
      "chName": "岐阜县",
      "zhName": "岐阜縣",
      "koName": "기후현",
      "esName": "Prefectura de Gifu",
      "ptName": "Província de Gifu",
      "thName": "จังหวัดกิฟุ",
      "viName": "Tỉnh Gifu",
      "inName": "Prefektur Gifu",
      "tlName": "Gifu Prefecture",
      "moName": "Гифү аймаг",
      "buName": "ဂျီဖု ပြည်နယ်",
      "khName": "ខេត្ដ ហ្គីហ្វូ",
      "neName": "गिफु जिल्ला"
    },
    "class10": {
      "code": "210010",
      "name": "美濃地方",
      "enName": "Mino Region",
      "chName": "美濃地區, 岐阜县",
      "zhName": "美浓地区, 飞弹地区",
      "koName": "미노 지방, 기후 현",
      "esName": "Región de Mino, Prefectura de Gifu",
      "ptName": "Região de Mino da Província de Gifu",
      "thName": "ภูมิภาคมิโนะ จังหวัดกิฟุ",
      "viName": "Vùng Mino, tỉnh Gifu",
      "inName": "Wilayah Mino di Provinsi Gifu",
      "tlName": "Rehiyon ng Mino sa Gifu Prefecture",
      "moName": "Мино бүс, Гифү аймаг",
      "buName": "Mino ဒေသ, ဂိဟုစီရင်စု",
      "khName": "តំបន់មីណូ, ខេត្តកីហ្វុ",
      "neName": "मिनो क्षेत्र, गिफु जिल्ला"
    },
    "class15": {
      "code": "210012",
      "name": "東濃",
      "enName": "Tono"
    },
    "class20": {
      "code": "2120400",
      "name": "多治見市",
      "enName": "Tajimi City",
      "kana": "たじみし",
      "chName": "多治见市",
      "zhName": "多治見市",
      "koName": "다지미 시",
      "esName": "Ciudad de Tajimi",
      "ptName": "cidade de Tajimi",
      "thName": "เมืองทาจิมิ",
      "viName": "thành phố Tajimi",
      "inName": "kota Tajimi",
      "tlName": "siyudad ng Tajimi",
      "moName": "Тажими хот",
      "buName": "တာဂျီမိ မြို့",
      "khName": "ទីក្រុង តាហ្សីមី",
      "neName": "ताजिमी सहर"
    }
  },
  "2120500": {
    "office": {
      "code": "210000",
      "name": "岐阜県",
      "enName": "Gifu",
      "officeName": "岐阜地方気象台",
      "chName": "岐阜县",
      "zhName": "岐阜縣",
      "koName": "기후현",
      "esName": "Prefectura de Gifu",
      "ptName": "Província de Gifu",
      "thName": "จังหวัดกิฟุ",
      "viName": "Tỉnh Gifu",
      "inName": "Prefektur Gifu",
      "tlName": "Gifu Prefecture",
      "moName": "Гифү аймаг",
      "buName": "ဂျီဖု ပြည်နယ်",
      "khName": "ខេត្ដ ហ្គីហ្វូ",
      "neName": "गिफु जिल्ला"
    },
    "class10": {
      "code": "210010",
      "name": "美濃地方",
      "enName": "Mino Region",
      "chName": "美濃地區, 岐阜县",
      "zhName": "美浓地区, 飞弹地区",
      "koName": "미노 지방, 기후 현",
      "esName": "Región de Mino, Prefectura de Gifu",
      "ptName": "Região de Mino da Província de Gifu",
      "thName": "ภูมิภาคมิโนะ จังหวัดกิฟุ",
      "viName": "Vùng Mino, tỉnh Gifu",
      "inName": "Wilayah Mino di Provinsi Gifu",
      "tlName": "Rehiyon ng Mino sa Gifu Prefecture",
      "moName": "Мино бүс, Гифү аймаг",
      "buName": "Mino ဒေသ, ဂိဟုစီရင်စု",
      "khName": "តំបន់មីណូ, ខេត្តកីហ្វុ",
      "neName": "मिनो क्षेत्र, गिफु जिल्ला"
    },
    "class15": {
      "code": "210013",
      "name": "中濃",
      "enName": "Chuno"
    },
    "class20": {
      "code": "2120500",
      "name": "関市",
      "enName": "Seki City",
      "kana": "せきし",
      "chName": "关市",
      "zhName": "關市",
      "koName": "세키 시",
      "esName": "Ciudad de Seki",
      "ptName": "cidade de Seki",
      "thName": "เมืองเซกิ",
      "viName": "thành phố Seki",
      "inName": "kota Seki",
      "tlName": "siyudad ng Seki",
      "moName": "Сэки хот",
      "buName": "ဆေကိ မြို့",
      "khName": "ទីក្រុង សេគី",
      "neName": "सेकी सहर"
    }
  },
  "2120600": {
    "office": {
      "code": "210000",
      "name": "岐阜県",
      "enName": "Gifu",
      "officeName": "岐阜地方気象台",
      "chName": "岐阜县",
      "zhName": "岐阜縣",
      "koName": "기후현",
      "esName": "Prefectura de Gifu",
      "ptName": "Província de Gifu",
      "thName": "จังหวัดกิฟุ",
      "viName": "Tỉnh Gifu",
      "inName": "Prefektur Gifu",
      "tlName": "Gifu Prefecture",
      "moName": "Гифү аймаг",
      "buName": "ဂျီဖု ပြည်နယ်",
      "khName": "ខេត្ដ ហ្គីហ្វូ",
      "neName": "गिफु जिल्ला"
    },
    "class10": {
      "code": "210010",
      "name": "美濃地方",
      "enName": "Mino Region",
      "chName": "美濃地區, 岐阜县",
      "zhName": "美浓地区, 飞弹地区",
      "koName": "미노 지방, 기후 현",
      "esName": "Región de Mino, Prefectura de Gifu",
      "ptName": "Região de Mino da Província de Gifu",
      "thName": "ภูมิภาคมิโนะ จังหวัดกิฟุ",
      "viName": "Vùng Mino, tỉnh Gifu",
      "inName": "Wilayah Mino di Provinsi Gifu",
      "tlName": "Rehiyon ng Mino sa Gifu Prefecture",
      "moName": "Мино бүс, Гифү аймаг",
      "buName": "Mino ဒေသ, ဂိဟုစီရင်စု",
      "khName": "តំបន់មីណូ, ខេត្តកីហ្វុ",
      "neName": "मिनो क्षेत्र, गिफु जिल्ला"
    },
    "class15": {
      "code": "210012",
      "name": "東濃",
      "enName": "Tono"
    },
    "class20": {
      "code": "2120600",
      "name": "中津川市",
      "enName": "Nakatsugawa City",
      "kana": "なかつがわし",
      "chName": "中津川市",
      "zhName": "中津川市",
      "koName": "나카쓰가와 시",
      "esName": "Ciudad de Nakatsugawa",
      "ptName": "cidade de Nakatsugawa",
      "thName": "เมืองนาคาสึกาวา",
      "viName": "thành phố Nakatsugawa",
      "inName": "kota Nakatsugawa",
      "tlName": "siyudad ng Nakatsugawa",
      "moName": "Нaкацүгава хот",
      "buName": "နာကာဆုဂါ့ဝ မြို့",
      "khName": "ទីក្រុង ណាកាតសូហ្គាវ៉ា",
      "neName": "नाकात्सुगावा सहर"
    }
  },
  "2120700": {
    "office": {
      "code": "210000",
      "name": "岐阜県",
      "enName": "Gifu",
      "officeName": "岐阜地方気象台",
      "chName": "岐阜县",
      "zhName": "岐阜縣",
      "koName": "기후현",
      "esName": "Prefectura de Gifu",
      "ptName": "Província de Gifu",
      "thName": "จังหวัดกิฟุ",
      "viName": "Tỉnh Gifu",
      "inName": "Prefektur Gifu",
      "tlName": "Gifu Prefecture",
      "moName": "Гифү аймаг",
      "buName": "ဂျီဖု ပြည်နယ်",
      "khName": "ខេត្ដ ហ្គីហ្វូ",
      "neName": "गिफु जिल्ला"
    },
    "class10": {
      "code": "210010",
      "name": "美濃地方",
      "enName": "Mino Region",
      "chName": "美濃地區, 岐阜县",
      "zhName": "美浓地区, 飞弹地区",
      "koName": "미노 지방, 기후 현",
      "esName": "Región de Mino, Prefectura de Gifu",
      "ptName": "Região de Mino da Província de Gifu",
      "thName": "ภูมิภาคมิโนะ จังหวัดกิฟุ",
      "viName": "Vùng Mino, tỉnh Gifu",
      "inName": "Wilayah Mino di Provinsi Gifu",
      "tlName": "Rehiyon ng Mino sa Gifu Prefecture",
      "moName": "Мино бүс, Гифү аймаг",
      "buName": "Mino ဒေသ, ဂိဟုစီရင်စု",
      "khName": "តំបន់មីណូ, ខេត្តកីហ្វុ",
      "neName": "मिनो क्षेत्र, गिफु जिल्ला"
    },
    "class15": {
      "code": "210013",
      "name": "中濃",
      "enName": "Chuno"
    },
    "class20": {
      "code": "2120700",
      "name": "美濃市",
      "enName": "Mino City",
      "kana": "みのし",
      "chName": "美浓市",
      "zhName": "美濃市",
      "koName": "미노 시",
      "esName": "Ciudad de Mino",
      "ptName": "cidade de Mino",
      "thName": "เมืองมิโนะ",
      "viName": "thành phố Mino",
      "inName": "kota Mino",
      "tlName": "siyudad ng Mino",
      "moName": "Мино хот",
      "buName": "မီနော့ မြို့",
      "khName": "ទីក្រុង មីណូ",
      "neName": "मिनो सहर"
    }
  },
  "2120800": {
    "office": {
      "code": "210000",
      "name": "岐阜県",
      "enName": "Gifu",
      "officeName": "岐阜地方気象台",
      "chName": "岐阜县",
      "zhName": "岐阜縣",
      "koName": "기후현",
      "esName": "Prefectura de Gifu",
      "ptName": "Província de Gifu",
      "thName": "จังหวัดกิฟุ",
      "viName": "Tỉnh Gifu",
      "inName": "Prefektur Gifu",
      "tlName": "Gifu Prefecture",
      "moName": "Гифү аймаг",
      "buName": "ဂျီဖု ပြည်နယ်",
      "khName": "ខេត្ដ ហ្គីហ្វូ",
      "neName": "गिफु जिल्ला"
    },
    "class10": {
      "code": "210010",
      "name": "美濃地方",
      "enName": "Mino Region",
      "chName": "美濃地區, 岐阜县",
      "zhName": "美浓地区, 飞弹地区",
      "koName": "미노 지방, 기후 현",
      "esName": "Región de Mino, Prefectura de Gifu",
      "ptName": "Região de Mino da Província de Gifu",
      "thName": "ภูมิภาคมิโนะ จังหวัดกิฟุ",
      "viName": "Vùng Mino, tỉnh Gifu",
      "inName": "Wilayah Mino di Provinsi Gifu",
      "tlName": "Rehiyon ng Mino sa Gifu Prefecture",
      "moName": "Мино бүс, Гифү аймаг",
      "buName": "Mino ဒေသ, ဂိဟုစီရင်စု",
      "khName": "តំបន់មីណូ, ខេត្តកីហ្វុ",
      "neName": "मिनो क्षेत्र, गिफु जिल्ला"
    },
    "class15": {
      "code": "210012",
      "name": "東濃",
      "enName": "Tono"
    },
    "class20": {
      "code": "2120800",
      "name": "瑞浪市",
      "enName": "Mizunami City",
      "kana": "みずなみし",
      "chName": "瑞浪市",
      "zhName": "瑞浪市",
      "koName": "미즈나미 시",
      "esName": "Ciudad de Mizunami",
      "ptName": "cidade de Mizunami",
      "thName": "เมืองมิซูนามิ",
      "viName": "thành phố Mizunami",
      "inName": "kota Mizunami",
      "tlName": "siyudad ng Mizunami",
      "moName": "Мизүнaми хот",
      "buName": "မီဇုနာ့မိ မြို့",
      "khName": "ទីក្រុង មីហ្សុណាមី",
      "neName": "मिजुनामी सहर"
    }
  },
  "2120900": {
    "office": {
      "code": "210000",
      "name": "岐阜県",
      "enName": "Gifu",
      "officeName": "岐阜地方気象台",
      "chName": "岐阜县",
      "zhName": "岐阜縣",
      "koName": "기후현",
      "esName": "Prefectura de Gifu",
      "ptName": "Província de Gifu",
      "thName": "จังหวัดกิฟุ",
      "viName": "Tỉnh Gifu",
      "inName": "Prefektur Gifu",
      "tlName": "Gifu Prefecture",
      "moName": "Гифү аймаг",
      "buName": "ဂျီဖု ပြည်နယ်",
      "khName": "ខេត្ដ ហ្គីហ្វូ",
      "neName": "गिफु जिल्ला"
    },
    "class10": {
      "code": "210010",
      "name": "美濃地方",
      "enName": "Mino Region",
      "chName": "美濃地區, 岐阜县",
      "zhName": "美浓地区, 飞弹地区",
      "koName": "미노 지방, 기후 현",
      "esName": "Región de Mino, Prefectura de Gifu",
      "ptName": "Região de Mino da Província de Gifu",
      "thName": "ภูมิภาคมิโนะ จังหวัดกิฟุ",
      "viName": "Vùng Mino, tỉnh Gifu",
      "inName": "Wilayah Mino di Provinsi Gifu",
      "tlName": "Rehiyon ng Mino sa Gifu Prefecture",
      "moName": "Мино бүс, Гифү аймаг",
      "buName": "Mino ဒေသ, ဂိဟုစီရင်စု",
      "khName": "តំបន់មីណូ, ខេត្តកីហ្វុ",
      "neName": "मिनो क्षेत्र, गिफु जिल्ला"
    },
    "class15": {
      "code": "210011",
      "name": "岐阜・西濃",
      "enName": "Gifu Seino"
    },
    "class20": {
      "code": "2120900",
      "name": "羽島市",
      "enName": "Hashima City",
      "kana": "はしまし",
      "chName": "羽岛市",
      "zhName": "羽島市",
      "koName": "하시마 시",
      "esName": "Ciudad de Hashima",
      "ptName": "cidade de Hashima",
      "thName": "เมืองฮาชิมะ",
      "viName": "thành phố Hashima",
      "inName": "kota Hashima",
      "tlName": "siyudad ng Hashima",
      "moName": "Хaшимa хот",
      "buName": "ဟာရှိမ မြို့",
      "khName": "ទីក្រុង ហាស៊ីម៉ា",
      "neName": "हासिमा सहर"
    }
  },
  "2121000": {
    "office": {
      "code": "210000",
      "name": "岐阜県",
      "enName": "Gifu",
      "officeName": "岐阜地方気象台",
      "chName": "岐阜县",
      "zhName": "岐阜縣",
      "koName": "기후현",
      "esName": "Prefectura de Gifu",
      "ptName": "Província de Gifu",
      "thName": "จังหวัดกิฟุ",
      "viName": "Tỉnh Gifu",
      "inName": "Prefektur Gifu",
      "tlName": "Gifu Prefecture",
      "moName": "Гифү аймаг",
      "buName": "ဂျီဖု ပြည်နယ်",
      "khName": "ខេត្ដ ហ្គីហ្វូ",
      "neName": "गिफु जिल्ला"
    },
    "class10": {
      "code": "210010",
      "name": "美濃地方",
      "enName": "Mino Region",
      "chName": "美濃地區, 岐阜县",
      "zhName": "美浓地区, 飞弹地区",
      "koName": "미노 지방, 기후 현",
      "esName": "Región de Mino, Prefectura de Gifu",
      "ptName": "Região de Mino da Província de Gifu",
      "thName": "ภูมิภาคมิโนะ จังหวัดกิฟุ",
      "viName": "Vùng Mino, tỉnh Gifu",
      "inName": "Wilayah Mino di Provinsi Gifu",
      "tlName": "Rehiyon ng Mino sa Gifu Prefecture",
      "moName": "Мино бүс, Гифү аймаг",
      "buName": "Mino ဒေသ, ဂိဟုစီရင်စု",
      "khName": "តំបន់មីណូ, ខេត្តកីហ្វុ",
      "neName": "मिनो क्षेत्र, गिफु जिल्ला"
    },
    "class15": {
      "code": "210012",
      "name": "東濃",
      "enName": "Tono"
    },
    "class20": {
      "code": "2121000",
      "name": "恵那市",
      "enName": "Ena City",
      "kana": "えなし",
      "chName": "惠那市",
      "zhName": "惠那市",
      "koName": "에나 시",
      "esName": "Ciudad de Ena",
      "ptName": "cidade de Ena",
      "thName": "เมืองเอนะ",
      "viName": "thành phố Ena",
      "inName": "kota Ena",
      "tlName": "siyudad ng Ena",
      "moName": "Энa хот",
      "buName": "အီနာ မြို့",
      "khName": "ទីក្រុង អេណា",
      "neName": "एना सहर"
    }
  },
  "2121100": {
    "office": {
      "code": "210000",
      "name": "岐阜県",
      "enName": "Gifu",
      "officeName": "岐阜地方気象台",
      "chName": "岐阜县",
      "zhName": "岐阜縣",
      "koName": "기후현",
      "esName": "Prefectura de Gifu",
      "ptName": "Província de Gifu",
      "thName": "จังหวัดกิฟุ",
      "viName": "Tỉnh Gifu",
      "inName": "Prefektur Gifu",
      "tlName": "Gifu Prefecture",
      "moName": "Гифү аймаг",
      "buName": "ဂျီဖု ပြည်နယ်",
      "khName": "ខេត្ដ ហ្គីហ្វូ",
      "neName": "गिफु जिल्ला"
    },
    "class10": {
      "code": "210010",
      "name": "美濃地方",
      "enName": "Mino Region",
      "chName": "美濃地區, 岐阜县",
      "zhName": "美浓地区, 飞弹地区",
      "koName": "미노 지방, 기후 현",
      "esName": "Región de Mino, Prefectura de Gifu",
      "ptName": "Região de Mino da Província de Gifu",
      "thName": "ภูมิภาคมิโนะ จังหวัดกิฟุ",
      "viName": "Vùng Mino, tỉnh Gifu",
      "inName": "Wilayah Mino di Provinsi Gifu",
      "tlName": "Rehiyon ng Mino sa Gifu Prefecture",
      "moName": "Мино бүс, Гифү аймаг",
      "buName": "Mino ဒေသ, ဂိဟုစီရင်စု",
      "khName": "តំបន់មីណូ, ខេត្តកីហ្វុ",
      "neName": "मिनो क्षेत्र, गिफु जिल्ला"
    },
    "class15": {
      "code": "210013",
      "name": "中濃",
      "enName": "Chuno"
    },
    "class20": {
      "code": "2121100",
      "name": "美濃加茂市",
      "enName": "Minokamo City",
      "kana": "みのかもし",
      "chName": "美浓加茂市",
      "zhName": "美濃加茂市",
      "koName": "미노카모 시",
      "esName": "Ciudad de Minokamo",
      "ptName": "cidade de Minokamo",
      "thName": "เมืองมิโนะคาโมะ",
      "viName": "thành phố Minokamo",
      "inName": "kota Minokamo",
      "tlName": "siyudad ng Minokamo",
      "moName": "Минокамо хот",
      "buName": "မီနိုကာမို မြို့",
      "khName": "ទីក្រុង មីណូកាម៉ូ",
      "neName": "मिनोकामो सहर"
    }
  },
  "2121200": {
    "office": {
      "code": "210000",
      "name": "岐阜県",
      "enName": "Gifu",
      "officeName": "岐阜地方気象台",
      "chName": "岐阜县",
      "zhName": "岐阜縣",
      "koName": "기후현",
      "esName": "Prefectura de Gifu",
      "ptName": "Província de Gifu",
      "thName": "จังหวัดกิฟุ",
      "viName": "Tỉnh Gifu",
      "inName": "Prefektur Gifu",
      "tlName": "Gifu Prefecture",
      "moName": "Гифү аймаг",
      "buName": "ဂျီဖု ပြည်နယ်",
      "khName": "ខេត្ដ ហ្គីហ្វូ",
      "neName": "गिफु जिल्ला"
    },
    "class10": {
      "code": "210010",
      "name": "美濃地方",
      "enName": "Mino Region",
      "chName": "美濃地區, 岐阜县",
      "zhName": "美浓地区, 飞弹地区",
      "koName": "미노 지방, 기후 현",
      "esName": "Región de Mino, Prefectura de Gifu",
      "ptName": "Região de Mino da Província de Gifu",
      "thName": "ภูมิภาคมิโนะ จังหวัดกิฟุ",
      "viName": "Vùng Mino, tỉnh Gifu",
      "inName": "Wilayah Mino di Provinsi Gifu",
      "tlName": "Rehiyon ng Mino sa Gifu Prefecture",
      "moName": "Мино бүс, Гифү аймаг",
      "buName": "Mino ဒေသ, ဂိဟုစီရင်စု",
      "khName": "តំបន់មីណូ, ខេត្តកីហ្វុ",
      "neName": "मिनो क्षेत्र, गिफु जिल्ला"
    },
    "class15": {
      "code": "210012",
      "name": "東濃",
      "enName": "Tono"
    },
    "class20": {
      "code": "2121200",
      "name": "土岐市",
      "enName": "Toki City",
      "kana": "ときし",
      "chName": "土岐市",
      "zhName": "土岐市",
      "koName": "도키 시",
      "esName": "Ciudad de Toki",
      "ptName": "cidade de Toki",
      "thName": "เมืองโทคิ",
      "viName": "thành phố Toki",
      "inName": "kota Toki",
      "tlName": "siyudad ng Toki",
      "moName": "Токи хот",
      "buName": "တိုကိ မြို့",
      "khName": "ទីក្រុង តូគី",
      "neName": "तोकी सहर"
    }
  },
  "2121300": {
    "office": {
      "code": "210000",
      "name": "岐阜県",
      "enName": "Gifu",
      "officeName": "岐阜地方気象台",
      "chName": "岐阜县",
      "zhName": "岐阜縣",
      "koName": "기후현",
      "esName": "Prefectura de Gifu",
      "ptName": "Província de Gifu",
      "thName": "จังหวัดกิฟุ",
      "viName": "Tỉnh Gifu",
      "inName": "Prefektur Gifu",
      "tlName": "Gifu Prefecture",
      "moName": "Гифү аймаг",
      "buName": "ဂျီဖု ပြည်နယ်",
      "khName": "ខេត្ដ ហ្គីហ្វូ",
      "neName": "गिफु जिल्ला"
    },
    "class10": {
      "code": "210010",
      "name": "美濃地方",
      "enName": "Mino Region",
      "chName": "美濃地區, 岐阜县",
      "zhName": "美浓地区, 飞弹地区",
      "koName": "미노 지방, 기후 현",
      "esName": "Región de Mino, Prefectura de Gifu",
      "ptName": "Região de Mino da Província de Gifu",
      "thName": "ภูมิภาคมิโนะ จังหวัดกิฟุ",
      "viName": "Vùng Mino, tỉnh Gifu",
      "inName": "Wilayah Mino di Provinsi Gifu",
      "tlName": "Rehiyon ng Mino sa Gifu Prefecture",
      "moName": "Мино бүс, Гифү аймаг",
      "buName": "Mino ဒေသ, ဂိဟုစီရင်စု",
      "khName": "តំបន់មីណូ, ខេត្តកីហ្វុ",
      "neName": "मिनो क्षेत्र, गिफु जिल्ला"
    },
    "class15": {
      "code": "210011",
      "name": "岐阜・西濃",
      "enName": "Gifu Seino"
    },
    "class20": {
      "code": "2121300",
      "name": "各務原市",
      "enName": "Kakamigahara City",
      "kana": "かかみがはらし",
      "chName": "各务原市",
      "zhName": "各務原市",
      "koName": "가카미가하라 시",
      "esName": "Ciudad de Kakamigahara",
      "ptName": "cidade de Kakamigahara",
      "thName": "เมืองคากามิงาฮาระ",
      "viName": "thành phố Kakamigahara",
      "inName": "kota Kakamigahara",
      "tlName": "siyudad ng Kakamigahara",
      "moName": "Какамигахара хот",
      "buName": "ကာကာမိဂဟာ့ရ မြို့",
      "khName": "ទីក្រុង កាកាមីហ្កាហារ៉ា",
      "neName": "काकामिगाहारा सहर"
    }
  },
  "2121400": {
    "office": {
      "code": "210000",
      "name": "岐阜県",
      "enName": "Gifu",
      "officeName": "岐阜地方気象台",
      "chName": "岐阜县",
      "zhName": "岐阜縣",
      "koName": "기후현",
      "esName": "Prefectura de Gifu",
      "ptName": "Província de Gifu",
      "thName": "จังหวัดกิฟุ",
      "viName": "Tỉnh Gifu",
      "inName": "Prefektur Gifu",
      "tlName": "Gifu Prefecture",
      "moName": "Гифү аймаг",
      "buName": "ဂျီဖု ပြည်နယ်",
      "khName": "ខេត្ដ ហ្គីហ្វូ",
      "neName": "गिफु जिल्ला"
    },
    "class10": {
      "code": "210010",
      "name": "美濃地方",
      "enName": "Mino Region",
      "chName": "美濃地區, 岐阜县",
      "zhName": "美浓地区, 飞弹地区",
      "koName": "미노 지방, 기후 현",
      "esName": "Región de Mino, Prefectura de Gifu",
      "ptName": "Região de Mino da Província de Gifu",
      "thName": "ภูมิภาคมิโนะ จังหวัดกิฟุ",
      "viName": "Vùng Mino, tỉnh Gifu",
      "inName": "Wilayah Mino di Provinsi Gifu",
      "tlName": "Rehiyon ng Mino sa Gifu Prefecture",
      "moName": "Мино бүс, Гифү аймаг",
      "buName": "Mino ဒေသ, ဂိဟုစီရင်စု",
      "khName": "តំបន់មីណូ, ខេត្តកីហ្វុ",
      "neName": "मिनो क्षेत्र, गिफु जिल्ला"
    },
    "class15": {
      "code": "210013",
      "name": "中濃",
      "enName": "Chuno"
    },
    "class20": {
      "code": "2121400",
      "name": "可児市",
      "enName": "Kani City",
      "kana": "かにし",
      "chName": "可儿市",
      "zhName": "可兒市",
      "koName": "가니 시",
      "esName": "Ciudad de Kani",
      "ptName": "cidade de Kani",
      "thName": "เมืองคานิ",
      "viName": "thành phố Kani",
      "inName": "kota Kani",
      "tlName": "siyudad ng Kani",
      "moName": "Кани хот",
      "buName": "ကာနီ မြို့",
      "khName": "ទីក្រុង កានី",
      "neName": "कानी सहर"
    }
  },
  "2121500": {
    "office": {
      "code": "210000",
      "name": "岐阜県",
      "enName": "Gifu",
      "officeName": "岐阜地方気象台",
      "chName": "岐阜县",
      "zhName": "岐阜縣",
      "koName": "기후현",
      "esName": "Prefectura de Gifu",
      "ptName": "Província de Gifu",
      "thName": "จังหวัดกิฟุ",
      "viName": "Tỉnh Gifu",
      "inName": "Prefektur Gifu",
      "tlName": "Gifu Prefecture",
      "moName": "Гифү аймаг",
      "buName": "ဂျီဖု ပြည်နယ်",
      "khName": "ខេត្ដ ហ្គីហ្វូ",
      "neName": "गिफु जिल्ला"
    },
    "class10": {
      "code": "210010",
      "name": "美濃地方",
      "enName": "Mino Region",
      "chName": "美濃地區, 岐阜县",
      "zhName": "美浓地区, 飞弹地区",
      "koName": "미노 지방, 기후 현",
      "esName": "Región de Mino, Prefectura de Gifu",
      "ptName": "Região de Mino da Província de Gifu",
      "thName": "ภูมิภาคมิโนะ จังหวัดกิฟุ",
      "viName": "Vùng Mino, tỉnh Gifu",
      "inName": "Wilayah Mino di Provinsi Gifu",
      "tlName": "Rehiyon ng Mino sa Gifu Prefecture",
      "moName": "Мино бүс, Гифү аймаг",
      "buName": "Mino ဒေသ, ဂိဟုစီရင်စု",
      "khName": "តំបន់មីណូ, ខេត្តកីហ្វុ",
      "neName": "मिनो क्षेत्र, गिफु जिल्ला"
    },
    "class15": {
      "code": "210011",
      "name": "岐阜・西濃",
      "enName": "Gifu Seino"
    },
    "class20": {
      "code": "2121500",
      "name": "山県市",
      "enName": "Yamagata City",
      "kana": "やまがたし",
      "chName": "岐阜山县市",
      "zhName": "岐阜山縣市",
      "koName": "기후 야마가타 시",
      "esName": "Ciudad de Yamagata, Gifu",
      "ptName": "Gifu, cidade de Yamagata",
      "thName": "เมืองยามางาตะ กิฟุ",
      "viName": "Thành phố Yamagata, Gifu",
      "inName": "Kota Yamagata, Gifu",
      "tlName": "siyudad ng Yamagata, Gifu",
      "moName": "Гифү  Ямагада хот",
      "buName": "ဂိဟုယနဂတမြို့",
      "khName": "ទីក្រុងយ៉ាម៉ាហ្គាតា គ៊ីហ្វឹ",
      "neName": "गिफु यामागाता सहर"
    }
  },
  "2121600": {
    "office": {
      "code": "210000",
      "name": "岐阜県",
      "enName": "Gifu",
      "officeName": "岐阜地方気象台",
      "chName": "岐阜县",
      "zhName": "岐阜縣",
      "koName": "기후현",
      "esName": "Prefectura de Gifu",
      "ptName": "Província de Gifu",
      "thName": "จังหวัดกิฟุ",
      "viName": "Tỉnh Gifu",
      "inName": "Prefektur Gifu",
      "tlName": "Gifu Prefecture",
      "moName": "Гифү аймаг",
      "buName": "ဂျီဖု ပြည်နယ်",
      "khName": "ខេត្ដ ហ្គីហ្វូ",
      "neName": "गिफु जिल्ला"
    },
    "class10": {
      "code": "210010",
      "name": "美濃地方",
      "enName": "Mino Region",
      "chName": "美濃地區, 岐阜县",
      "zhName": "美浓地区, 飞弹地区",
      "koName": "미노 지방, 기후 현",
      "esName": "Región de Mino, Prefectura de Gifu",
      "ptName": "Região de Mino da Província de Gifu",
      "thName": "ภูมิภาคมิโนะ จังหวัดกิฟุ",
      "viName": "Vùng Mino, tỉnh Gifu",
      "inName": "Wilayah Mino di Provinsi Gifu",
      "tlName": "Rehiyon ng Mino sa Gifu Prefecture",
      "moName": "Мино бүс, Гифү аймаг",
      "buName": "Mino ဒေသ, ဂိဟုစီရင်စု",
      "khName": "តំបន់មីណូ, ខេត្តកីហ្វុ",
      "neName": "मिनो क्षेत्र, गिफु जिल्ला"
    },
    "class15": {
      "code": "210011",
      "name": "岐阜・西濃",
      "enName": "Gifu Seino"
    },
    "class20": {
      "code": "2121600",
      "name": "瑞穂市",
      "enName": "Mizuho City",
      "kana": "みずほし",
      "chName": "瑞穗市",
      "zhName": "瑞穗市",
      "koName": "미즈호 시",
      "esName": "Ciudad de Mizuho",
      "ptName": "cidade de Mizuho",
      "thName": "เมืองมิซูโฮะ",
      "viName": "thành phố Mizuho",
      "inName": "kota Mizuho",
      "tlName": "siyudad ng Mizuho",
      "moName": "Мизүхо хот",
      "buName": "မီဇုဟို မြို့",
      "khName": "ទីក្រុង មីហ្សូហូ",
      "neName": "मिजुहो सहर"
    }
  },
  "2121700": {
    "office": {
      "code": "210000",
      "name": "岐阜県",
      "enName": "Gifu",
      "officeName": "岐阜地方気象台",
      "chName": "岐阜县",
      "zhName": "岐阜縣",
      "koName": "기후현",
      "esName": "Prefectura de Gifu",
      "ptName": "Província de Gifu",
      "thName": "จังหวัดกิฟุ",
      "viName": "Tỉnh Gifu",
      "inName": "Prefektur Gifu",
      "tlName": "Gifu Prefecture",
      "moName": "Гифү аймаг",
      "buName": "ဂျီဖု ပြည်နယ်",
      "khName": "ខេត្ដ ហ្គីហ្វូ",
      "neName": "गिफु जिल्ला"
    },
    "class10": {
      "code": "210020",
      "name": "飛騨地方",
      "enName": "Hida Region",
      "chName": "飛彈地區, 岐阜县",
      "zhName": "飞弹地区, 美浓地区",
      "koName": "히다 지방, 기후 현",
      "esName": "Región de Hida, Prefectura de Gifu",
      "ptName": "Região de Hida da Província de Gifu",
      "thName": "ภูมิภาคฮิดะ จังหวัดกิฟุ",
      "viName": "Vùng Hida, tỉnh Gifu",
      "inName": "Wilayah Hida di Provinsi Gifu",
      "tlName": "Rehiyon ng Hida sa Gifu Prefecture",
      "moName": "Хида бүс, Гифү аймаг",
      "buName": "Hida ဒေသ, ဂိဟုစီရင်စု",
      "khName": "តំបន់ Hida, ខេត្តកីហ្វុ",
      "neName": "हिडा क्षेत्र, गिफु जिल्ला"
    },
    "class15": {
      "code": "210021",
      "name": "飛騨北部",
      "enName": "Northern Hida"
    },
    "class20": {
      "code": "2121700",
      "name": "飛騨市",
      "enName": "Hida City",
      "kana": "ひだし",
      "chName": "飞驒市",
      "zhName": "飛彈市",
      "koName": "히다 시",
      "esName": "Ciudad de Hida",
      "ptName": "cidade de Hida",
      "thName": "เมืองฮิดะ",
      "viName": "thành phố Hida",
      "inName": "kota Hida",
      "tlName": "siyudad ng Hida",
      "moName": "Хида хот",
      "buName": "ဟီဒ မြို့",
      "khName": "ទីក្រុង ហ៊ីដា",
      "neName": "हिदा सहर"
    }
  },
  "2121800": {
    "office": {
      "code": "210000",
      "name": "岐阜県",
      "enName": "Gifu",
      "officeName": "岐阜地方気象台",
      "chName": "岐阜县",
      "zhName": "岐阜縣",
      "koName": "기후현",
      "esName": "Prefectura de Gifu",
      "ptName": "Província de Gifu",
      "thName": "จังหวัดกิฟุ",
      "viName": "Tỉnh Gifu",
      "inName": "Prefektur Gifu",
      "tlName": "Gifu Prefecture",
      "moName": "Гифү аймаг",
      "buName": "ဂျီဖု ပြည်နယ်",
      "khName": "ខេត្ដ ហ្គីហ្វូ",
      "neName": "गिफु जिल्ला"
    },
    "class10": {
      "code": "210010",
      "name": "美濃地方",
      "enName": "Mino Region",
      "chName": "美濃地區, 岐阜县",
      "zhName": "美浓地区, 飞弹地区",
      "koName": "미노 지방, 기후 현",
      "esName": "Región de Mino, Prefectura de Gifu",
      "ptName": "Região de Mino da Província de Gifu",
      "thName": "ภูมิภาคมิโนะ จังหวัดกิฟุ",
      "viName": "Vùng Mino, tỉnh Gifu",
      "inName": "Wilayah Mino di Provinsi Gifu",
      "tlName": "Rehiyon ng Mino sa Gifu Prefecture",
      "moName": "Мино бүс, Гифү аймаг",
      "buName": "Mino ဒေသ, ဂိဟုစီရင်စု",
      "khName": "តំបន់មីណូ, ខេត្តកីហ្វុ",
      "neName": "मिनो क्षेत्र, गिफु जिल्ला"
    },
    "class15": {
      "code": "210011",
      "name": "岐阜・西濃",
      "enName": "Gifu Seino"
    },
    "class20": {
      "code": "2121800",
      "name": "本巣市",
      "enName": "Motosu City",
      "kana": "もとすし",
      "chName": "本巢市",
      "zhName": "本巢市",
      "koName": "모토스 시",
      "esName": "Ciudad de Motosu",
      "ptName": "cidade de Motosu",
      "thName": "เมืองโมโตสุ",
      "viName": "thành phố Motosu",
      "inName": "kota Motosu",
      "tlName": "siyudad ng Motosu",
      "moName": "Мотосү хот",
      "buName": "မိုတိုဆု မြို့",
      "khName": "ទីក្រុង ម៉ូតូស៊ុ",
      "neName": "मोतोसु सहर"
    }
  },
  "2121900": {
    "office": {
      "code": "210000",
      "name": "岐阜県",
      "enName": "Gifu",
      "officeName": "岐阜地方気象台",
      "chName": "岐阜县",
      "zhName": "岐阜縣",
      "koName": "기후현",
      "esName": "Prefectura de Gifu",
      "ptName": "Província de Gifu",
      "thName": "จังหวัดกิฟุ",
      "viName": "Tỉnh Gifu",
      "inName": "Prefektur Gifu",
      "tlName": "Gifu Prefecture",
      "moName": "Гифү аймаг",
      "buName": "ဂျီဖု ပြည်နယ်",
      "khName": "ខេត្ដ ហ្គីហ្វូ",
      "neName": "गिफु जिल्ला"
    },
    "class10": {
      "code": "210010",
      "name": "美濃地方",
      "enName": "Mino Region",
      "chName": "美濃地區, 岐阜县",
      "zhName": "美浓地区, 飞弹地区",
      "koName": "미노 지방, 기후 현",
      "esName": "Región de Mino, Prefectura de Gifu",
      "ptName": "Região de Mino da Província de Gifu",
      "thName": "ภูมิภาคมิโนะ จังหวัดกิฟุ",
      "viName": "Vùng Mino, tỉnh Gifu",
      "inName": "Wilayah Mino di Provinsi Gifu",
      "tlName": "Rehiyon ng Mino sa Gifu Prefecture",
      "moName": "Мино бүс, Гифү аймаг",
      "buName": "Mino ဒေသ, ဂိဟုစီရင်စု",
      "khName": "តំបន់មីណូ, ខេត្តកីហ្វុ",
      "neName": "मिनो क्षेत्र, गिफु जिल्ला"
    },
    "class15": {
      "code": "210013",
      "name": "中濃",
      "enName": "Chuno"
    },
    "class20": {
      "code": "2121900",
      "name": "郡上市",
      "enName": "Gujo City",
      "kana": "ぐじょうし",
      "chName": "郡上市",
      "zhName": "郡上市",
      "koName": "구조 시",
      "esName": "Ciudad de Gujyo",
      "ptName": "cidade de Gujo",
      "thName": "เมืองกุโจ",
      "viName": "thành phố Gujo",
      "inName": "kota Gujo",
      "tlName": "siyudad ng Gujo",
      "moName": "Гүжо хот",
      "buName": "ဂူးဂျို မြို့",
      "khName": "ទីក្រុង ហ្គូជូ",
      "neName": "गुजो सहर"
    }
  },
  "2122000": {
    "office": {
      "code": "210000",
      "name": "岐阜県",
      "enName": "Gifu",
      "officeName": "岐阜地方気象台",
      "chName": "岐阜县",
      "zhName": "岐阜縣",
      "koName": "기후현",
      "esName": "Prefectura de Gifu",
      "ptName": "Província de Gifu",
      "thName": "จังหวัดกิฟุ",
      "viName": "Tỉnh Gifu",
      "inName": "Prefektur Gifu",
      "tlName": "Gifu Prefecture",
      "moName": "Гифү аймаг",
      "buName": "ဂျီဖု ပြည်နယ်",
      "khName": "ខេត្ដ ហ្គីហ្វូ",
      "neName": "गिफु जिल्ला"
    },
    "class10": {
      "code": "210020",
      "name": "飛騨地方",
      "enName": "Hida Region",
      "chName": "飛彈地區, 岐阜县",
      "zhName": "飞弹地区, 美浓地区",
      "koName": "히다 지방, 기후 현",
      "esName": "Región de Hida, Prefectura de Gifu",
      "ptName": "Região de Hida da Província de Gifu",
      "thName": "ภูมิภาคฮิดะ จังหวัดกิฟุ",
      "viName": "Vùng Hida, tỉnh Gifu",
      "inName": "Wilayah Hida di Provinsi Gifu",
      "tlName": "Rehiyon ng Hida sa Gifu Prefecture",
      "moName": "Хида бүс, Гифү аймаг",
      "buName": "Hida ဒေသ, ဂိဟုစီရင်စု",
      "khName": "តំបន់ Hida, ខេត្តកីហ្វុ",
      "neName": "हिडा क्षेत्र, गिफु जिल्ला"
    },
    "class15": {
      "code": "210022",
      "name": "飛騨南部",
      "enName": "Southern Hida"
    },
    "class20": {
      "code": "2122000",
      "name": "下呂市",
      "enName": "Gero City",
      "kana": "げろし",
      "chName": "下吕市",
      "zhName": "下呂市",
      "koName": "게로 시",
      "esName": "Ciudad de Gero",
      "ptName": "cidade de Gero",
      "thName": "เมืองเกโระ",
      "viName": "thành phố Gero",
      "inName": "kota Gero",
      "tlName": "siyudad ng Gero",
      "moName": "Гэро хот",
      "buName": "ဂဲရော့ မြို့",
      "khName": "ទីក្រុង ជ័ររ៉ូ",
      "neName": "गेरो सहर"
    }
  },
  "2122100": {
    "office": {
      "code": "210000",
      "name": "岐阜県",
      "enName": "Gifu",
      "officeName": "岐阜地方気象台",
      "chName": "岐阜县",
      "zhName": "岐阜縣",
      "koName": "기후현",
      "esName": "Prefectura de Gifu",
      "ptName": "Província de Gifu",
      "thName": "จังหวัดกิฟุ",
      "viName": "Tỉnh Gifu",
      "inName": "Prefektur Gifu",
      "tlName": "Gifu Prefecture",
      "moName": "Гифү аймаг",
      "buName": "ဂျီဖု ပြည်နယ်",
      "khName": "ខេត្ដ ហ្គីហ្វូ",
      "neName": "गिफु जिल्ला"
    },
    "class10": {
      "code": "210010",
      "name": "美濃地方",
      "enName": "Mino Region",
      "chName": "美濃地區, 岐阜县",
      "zhName": "美浓地区, 飞弹地区",
      "koName": "미노 지방, 기후 현",
      "esName": "Región de Mino, Prefectura de Gifu",
      "ptName": "Região de Mino da Província de Gifu",
      "thName": "ภูมิภาคมิโนะ จังหวัดกิฟุ",
      "viName": "Vùng Mino, tỉnh Gifu",
      "inName": "Wilayah Mino di Provinsi Gifu",
      "tlName": "Rehiyon ng Mino sa Gifu Prefecture",
      "moName": "Мино бүс, Гифү аймаг",
      "buName": "Mino ဒေသ, ဂိဟုစီရင်စု",
      "khName": "តំបន់មីណូ, ខេត្តកីហ្វុ",
      "neName": "मिनो क्षेत्र, गिफु जिल्ला"
    },
    "class15": {
      "code": "210011",
      "name": "岐阜・西濃",
      "enName": "Gifu Seino"
    },
    "class20": {
      "code": "2122100",
      "name": "海津市",
      "enName": "Kaizu City",
      "kana": "かいづし",
      "chName": "海津市",
      "zhName": "海津市",
      "koName": "가이즈 시",
      "esName": "Ciudad de Kaizu",
      "ptName": "cidade de Kaizu",
      "thName": "เมืองไคซุ",
      "viName": "thành phố Kaizu",
      "inName": "kota Kaizu",
      "tlName": "siyudad ng Kaizu",
      "moName": "Кайзү хот",
      "buName": "ခိုင်းယိဇု မြို့",
      "khName": "ទីក្រុង កៃហ្សូ",
      "neName": "काइजु सहर"
    }
  },
  "2130200": {
    "office": {
      "code": "210000",
      "name": "岐阜県",
      "enName": "Gifu",
      "officeName": "岐阜地方気象台",
      "chName": "岐阜县",
      "zhName": "岐阜縣",
      "koName": "기후현",
      "esName": "Prefectura de Gifu",
      "ptName": "Província de Gifu",
      "thName": "จังหวัดกิฟุ",
      "viName": "Tỉnh Gifu",
      "inName": "Prefektur Gifu",
      "tlName": "Gifu Prefecture",
      "moName": "Гифү аймаг",
      "buName": "ဂျီဖု ပြည်နယ်",
      "khName": "ខេត្ដ ហ្គីហ្វូ",
      "neName": "गिफु जिल्ला"
    },
    "class10": {
      "code": "210010",
      "name": "美濃地方",
      "enName": "Mino Region",
      "chName": "美濃地區, 岐阜县",
      "zhName": "美浓地区, 飞弹地区",
      "koName": "미노 지방, 기후 현",
      "esName": "Región de Mino, Prefectura de Gifu",
      "ptName": "Região de Mino da Província de Gifu",
      "thName": "ภูมิภาคมิโนะ จังหวัดกิฟุ",
      "viName": "Vùng Mino, tỉnh Gifu",
      "inName": "Wilayah Mino di Provinsi Gifu",
      "tlName": "Rehiyon ng Mino sa Gifu Prefecture",
      "moName": "Мино бүс, Гифү аймаг",
      "buName": "Mino ဒေသ, ဂိဟုစီရင်စု",
      "khName": "តំបន់មីណូ, ខេត្តកីហ្វុ",
      "neName": "मिनो क्षेत्र, गिफु जिल्ला"
    },
    "class15": {
      "code": "210011",
      "name": "岐阜・西濃",
      "enName": "Gifu Seino"
    },
    "class20": {
      "code": "2130200",
      "name": "岐南町",
      "enName": "Ginan Town",
      "kana": "ぎなんちょう",
      "chName": "岐南町",
      "zhName": "岐南町",
      "koName": "기난 정",
      "esName": "Pueblo de Ginan",
      "ptName": "bairro de Ginan",
      "thName": "เมืองกินัน",
      "viName": "thị trấn Ginan",
      "inName": "kota Ginan",
      "tlName": "bayan ng Ginan",
      "moName": "Гинaн жижиг хот",
      "buName": "ဂိနန် မြို့နယ်",
      "khName": "ទីប្រជុំជន ជីនណាន",
      "neName": "गिनान नगर"
    }
  },
  "2130300": {
    "office": {
      "code": "210000",
      "name": "岐阜県",
      "enName": "Gifu",
      "officeName": "岐阜地方気象台",
      "chName": "岐阜县",
      "zhName": "岐阜縣",
      "koName": "기후현",
      "esName": "Prefectura de Gifu",
      "ptName": "Província de Gifu",
      "thName": "จังหวัดกิฟุ",
      "viName": "Tỉnh Gifu",
      "inName": "Prefektur Gifu",
      "tlName": "Gifu Prefecture",
      "moName": "Гифү аймаг",
      "buName": "ဂျီဖု ပြည်နယ်",
      "khName": "ខេត្ដ ហ្គីហ្វូ",
      "neName": "गिफु जिल्ला"
    },
    "class10": {
      "code": "210010",
      "name": "美濃地方",
      "enName": "Mino Region",
      "chName": "美濃地區, 岐阜县",
      "zhName": "美浓地区, 飞弹地区",
      "koName": "미노 지방, 기후 현",
      "esName": "Región de Mino, Prefectura de Gifu",
      "ptName": "Região de Mino da Província de Gifu",
      "thName": "ภูมิภาคมิโนะ จังหวัดกิฟุ",
      "viName": "Vùng Mino, tỉnh Gifu",
      "inName": "Wilayah Mino di Provinsi Gifu",
      "tlName": "Rehiyon ng Mino sa Gifu Prefecture",
      "moName": "Мино бүс, Гифү аймаг",
      "buName": "Mino ဒေသ, ဂိဟုစီရင်စု",
      "khName": "តំបន់មីណូ, ខេត្តកីហ្វុ",
      "neName": "मिनो क्षेत्र, गिफु जिल्ला"
    },
    "class15": {
      "code": "210011",
      "name": "岐阜・西濃",
      "enName": "Gifu Seino"
    },
    "class20": {
      "code": "2130300",
      "name": "笠松町",
      "enName": "Kasamatsu Town",
      "kana": "かさまつちょう",
      "chName": "笠松町",
      "zhName": "笠松町",
      "koName": "가사마쓰 정",
      "esName": "Pueblo de Kasamatsu",
      "ptName": "bairro de Kasamatsu",
      "thName": "เมืองคาซามัตสึ",
      "viName": "thị trấn Kasaha",
      "inName": "kota Kasamatsu",
      "tlName": "bayan ng Kasamatsu",
      "moName": "Касaмaцү жижиг хот",
      "buName": "ခါဆားမာ့ဆု မြို့နယ်",
      "khName": "ទីប្រជុំជន កាសាម៉ាតស៊ូ",
      "neName": "कासामात्सु नगर"
    }
  },
  "2134100": {
    "office": {
      "code": "210000",
      "name": "岐阜県",
      "enName": "Gifu",
      "officeName": "岐阜地方気象台",
      "chName": "岐阜县",
      "zhName": "岐阜縣",
      "koName": "기후현",
      "esName": "Prefectura de Gifu",
      "ptName": "Província de Gifu",
      "thName": "จังหวัดกิฟุ",
      "viName": "Tỉnh Gifu",
      "inName": "Prefektur Gifu",
      "tlName": "Gifu Prefecture",
      "moName": "Гифү аймаг",
      "buName": "ဂျီဖု ပြည်နယ်",
      "khName": "ខេត្ដ ហ្គីហ្វូ",
      "neName": "गिफु जिल्ला"
    },
    "class10": {
      "code": "210010",
      "name": "美濃地方",
      "enName": "Mino Region",
      "chName": "美濃地區, 岐阜县",
      "zhName": "美浓地区, 飞弹地区",
      "koName": "미노 지방, 기후 현",
      "esName": "Región de Mino, Prefectura de Gifu",
      "ptName": "Região de Mino da Província de Gifu",
      "thName": "ภูมิภาคมิโนะ จังหวัดกิฟุ",
      "viName": "Vùng Mino, tỉnh Gifu",
      "inName": "Wilayah Mino di Provinsi Gifu",
      "tlName": "Rehiyon ng Mino sa Gifu Prefecture",
      "moName": "Мино бүс, Гифү аймаг",
      "buName": "Mino ဒေသ, ဂိဟုစီရင်စု",
      "khName": "តំបន់មីណូ, ខេត្តកីហ្វុ",
      "neName": "मिनो क्षेत्र, गिफु जिल्ला"
    },
    "class15": {
      "code": "210011",
      "name": "岐阜・西濃",
      "enName": "Gifu Seino"
    },
    "class20": {
      "code": "2134100",
      "name": "養老町",
      "enName": "Yoro Town",
      "kana": "ようろうちょう",
      "chName": "养老町",
      "zhName": "養老町",
      "koName": "요로 정",
      "esName": "Pueblo de Yōrō",
      "ptName": "bairro de Yoro",
      "thName": "เมืองโยโระ",
      "viName": "thị trấn Yoro",
      "inName": "kota Yoro",
      "tlName": "bayan ng Yoro",
      "moName": "Ёоро жижиг хот",
      "buName": "ယိုရို မြို့နယ်",
      "khName": "ទីប្រជុំជន យូរូ",
      "neName": "योरो नगर"
    }
  },
  "2136100": {
    "office": {
      "code": "210000",
      "name": "岐阜県",
      "enName": "Gifu",
      "officeName": "岐阜地方気象台",
      "chName": "岐阜县",
      "zhName": "岐阜縣",
      "koName": "기후현",
      "esName": "Prefectura de Gifu",
      "ptName": "Província de Gifu",
      "thName": "จังหวัดกิฟุ",
      "viName": "Tỉnh Gifu",
      "inName": "Prefektur Gifu",
      "tlName": "Gifu Prefecture",
      "moName": "Гифү аймаг",
      "buName": "ဂျီဖု ပြည်နယ်",
      "khName": "ខេត្ដ ហ្គីហ្វូ",
      "neName": "गिफु जिल्ला"
    },
    "class10": {
      "code": "210010",
      "name": "美濃地方",
      "enName": "Mino Region",
      "chName": "美濃地區, 岐阜县",
      "zhName": "美浓地区, 飞弹地区",
      "koName": "미노 지방, 기후 현",
      "esName": "Región de Mino, Prefectura de Gifu",
      "ptName": "Região de Mino da Província de Gifu",
      "thName": "ภูมิภาคมิโนะ จังหวัดกิฟุ",
      "viName": "Vùng Mino, tỉnh Gifu",
      "inName": "Wilayah Mino di Provinsi Gifu",
      "tlName": "Rehiyon ng Mino sa Gifu Prefecture",
      "moName": "Мино бүс, Гифү аймаг",
      "buName": "Mino ဒေသ, ဂိဟုစီရင်စု",
      "khName": "តំបន់មីណូ, ខេត្តកីហ្វុ",
      "neName": "मिनो क्षेत्र, गिफु जिल्ला"
    },
    "class15": {
      "code": "210011",
      "name": "岐阜・西濃",
      "enName": "Gifu Seino"
    },
    "class20": {
      "code": "2136100",
      "name": "垂井町",
      "enName": "Tarui Town",
      "kana": "たるいちょう",
      "chName": "垂井町",
      "zhName": "垂井町",
      "koName": "다루이 정",
      "esName": "Pueblo de Tarui",
      "ptName": "bairro de Tarui",
      "thName": "เมืองทารุอิ",
      "viName": "thị trấn Tarui",
      "inName": "kota Tarui",
      "tlName": "bayan ng Tarui",
      "moName": "Тарүй жижиг хот",
      "buName": "တာရုယိ မြို့နယ်",
      "khName": "ទីប្រជុំជន តារ៉ុយ",
      "neName": "तारुई नगर"
    }
  },
  "2136200": {
    "office": {
      "code": "210000",
      "name": "岐阜県",
      "enName": "Gifu",
      "officeName": "岐阜地方気象台",
      "chName": "岐阜县",
      "zhName": "岐阜縣",
      "koName": "기후현",
      "esName": "Prefectura de Gifu",
      "ptName": "Província de Gifu",
      "thName": "จังหวัดกิฟุ",
      "viName": "Tỉnh Gifu",
      "inName": "Prefektur Gifu",
      "tlName": "Gifu Prefecture",
      "moName": "Гифү аймаг",
      "buName": "ဂျီဖု ပြည်နယ်",
      "khName": "ខេត្ដ ហ្គីហ្វូ",
      "neName": "गिफु जिल्ला"
    },
    "class10": {
      "code": "210010",
      "name": "美濃地方",
      "enName": "Mino Region",
      "chName": "美濃地區, 岐阜县",
      "zhName": "美浓地区, 飞弹地区",
      "koName": "미노 지방, 기후 현",
      "esName": "Región de Mino, Prefectura de Gifu",
      "ptName": "Região de Mino da Província de Gifu",
      "thName": "ภูมิภาคมิโนะ จังหวัดกิฟุ",
      "viName": "Vùng Mino, tỉnh Gifu",
      "inName": "Wilayah Mino di Provinsi Gifu",
      "tlName": "Rehiyon ng Mino sa Gifu Prefecture",
      "moName": "Мино бүс, Гифү аймаг",
      "buName": "Mino ဒေသ, ဂိဟုစီရင်စု",
      "khName": "តំបន់មីណូ, ខេត្តកីហ្វុ",
      "neName": "मिनो क्षेत्र, गिफु जिल्ला"
    },
    "class15": {
      "code": "210011",
      "name": "岐阜・西濃",
      "enName": "Gifu Seino"
    },
    "class20": {
      "code": "2136200",
      "name": "関ケ原町",
      "enName": "Sekigahara Town",
      "kana": "せきがはらちょう",
      "chName": "关原町",
      "zhName": "關原町",
      "koName": "세키가하라 정",
      "esName": "Pueblo de Sekigahara",
      "ptName": "bairro de Sekigahara",
      "thName": "เมืองเซกิงาฮาระ",
      "viName": "thị trấn Sekigahara",
      "inName": "kota Sekigahara",
      "tlName": "bayan ng Sekigahara",
      "moName": "Сэкигaхaра жижиг хот",
      "buName": "ဆေကီဂါဟာ့ရ မြို့နယ်",
      "khName": "ទីប្រជុំជន សេគីកាហារ៉ា",
      "neName": "सेकिगाहारा नगर"
    }
  },
  "2138100": {
    "office": {
      "code": "210000",
      "name": "岐阜県",
      "enName": "Gifu",
      "officeName": "岐阜地方気象台",
      "chName": "岐阜县",
      "zhName": "岐阜縣",
      "koName": "기후현",
      "esName": "Prefectura de Gifu",
      "ptName": "Província de Gifu",
      "thName": "จังหวัดกิฟุ",
      "viName": "Tỉnh Gifu",
      "inName": "Prefektur Gifu",
      "tlName": "Gifu Prefecture",
      "moName": "Гифү аймаг",
      "buName": "ဂျီဖု ပြည်နယ်",
      "khName": "ខេត្ដ ហ្គីហ្វូ",
      "neName": "गिफु जिल्ला"
    },
    "class10": {
      "code": "210010",
      "name": "美濃地方",
      "enName": "Mino Region",
      "chName": "美濃地區, 岐阜县",
      "zhName": "美浓地区, 飞弹地区",
      "koName": "미노 지방, 기후 현",
      "esName": "Región de Mino, Prefectura de Gifu",
      "ptName": "Região de Mino da Província de Gifu",
      "thName": "ภูมิภาคมิโนะ จังหวัดกิฟุ",
      "viName": "Vùng Mino, tỉnh Gifu",
      "inName": "Wilayah Mino di Provinsi Gifu",
      "tlName": "Rehiyon ng Mino sa Gifu Prefecture",
      "moName": "Мино бүс, Гифү аймаг",
      "buName": "Mino ဒေသ, ဂိဟုစီရင်စု",
      "khName": "តំបន់មីណូ, ខេត្តកីហ្វុ",
      "neName": "मिनो क्षेत्र, गिफु जिल्ला"
    },
    "class15": {
      "code": "210011",
      "name": "岐阜・西濃",
      "enName": "Gifu Seino"
    },
    "class20": {
      "code": "2138100",
      "name": "神戸町",
      "enName": "Godo Town",
      "kana": "ごうどちょう",
      "chName": "神户町",
      "zhName": "神戶町",
      "koName": "고도 정",
      "esName": "Pueblo de Godo",
      "ptName": "bairro de Godo",
      "thName": "เมืองโกโดะ",
      "viName": "thị trấn Godo",
      "inName": "kota Godo",
      "tlName": "bayan ng Godo",
      "moName": "Годо жижиг хот",
      "buName": "ဂိုဒို မြို့နယ်",
      "khName": "ទីប្រជុំជន ហ្គូដូ",
      "neName": "गोदो नगर"
    }
  },
  "2138200": {
    "office": {
      "code": "210000",
      "name": "岐阜県",
      "enName": "Gifu",
      "officeName": "岐阜地方気象台",
      "chName": "岐阜县",
      "zhName": "岐阜縣",
      "koName": "기후현",
      "esName": "Prefectura de Gifu",
      "ptName": "Província de Gifu",
      "thName": "จังหวัดกิฟุ",
      "viName": "Tỉnh Gifu",
      "inName": "Prefektur Gifu",
      "tlName": "Gifu Prefecture",
      "moName": "Гифү аймаг",
      "buName": "ဂျီဖု ပြည်နယ်",
      "khName": "ខេត្ដ ហ្គីហ្វូ",
      "neName": "गिफु जिल्ला"
    },
    "class10": {
      "code": "210010",
      "name": "美濃地方",
      "enName": "Mino Region",
      "chName": "美濃地區, 岐阜县",
      "zhName": "美浓地区, 飞弹地区",
      "koName": "미노 지방, 기후 현",
      "esName": "Región de Mino, Prefectura de Gifu",
      "ptName": "Região de Mino da Província de Gifu",
      "thName": "ภูมิภาคมิโนะ จังหวัดกิฟุ",
      "viName": "Vùng Mino, tỉnh Gifu",
      "inName": "Wilayah Mino di Provinsi Gifu",
      "tlName": "Rehiyon ng Mino sa Gifu Prefecture",
      "moName": "Мино бүс, Гифү аймаг",
      "buName": "Mino ဒေသ, ဂိဟုစီရင်စု",
      "khName": "តំបន់មីណូ, ខេត្តកីហ្វុ",
      "neName": "मिनो क्षेत्र, गिफु जिल्ला"
    },
    "class15": {
      "code": "210011",
      "name": "岐阜・西濃",
      "enName": "Gifu Seino"
    },
    "class20": {
      "code": "2138200",
      "name": "輪之内町",
      "enName": "Wanouchi Town",
      "kana": "わのうちちょう",
      "chName": "轮之内町",
      "zhName": "輪之內町",
      "koName": "와노우치 정",
      "esName": "Pueblo de Wanouchi",
      "ptName": "bairro de Wanouchi",
      "thName": "เมืองวาโนอุจิ",
      "viName": "thị trấn Wanouchi",
      "inName": "kota Wanouchi",
      "tlName": "bayan ng Wanouchi",
      "moName": "Ваноүчи жижиг хот",
      "buName": "ဝါနောဥကျိ မြို့နယ်",
      "khName": "ទីប្រជុំជន វ៉ាន់ណូជី",
      "neName": "वानोउची नगर"
    }
  },
  "2138300": {
    "office": {
      "code": "210000",
      "name": "岐阜県",
      "enName": "Gifu",
      "officeName": "岐阜地方気象台",
      "chName": "岐阜县",
      "zhName": "岐阜縣",
      "koName": "기후현",
      "esName": "Prefectura de Gifu",
      "ptName": "Província de Gifu",
      "thName": "จังหวัดกิฟุ",
      "viName": "Tỉnh Gifu",
      "inName": "Prefektur Gifu",
      "tlName": "Gifu Prefecture",
      "moName": "Гифү аймаг",
      "buName": "ဂျီဖု ပြည်နယ်",
      "khName": "ខេត្ដ ហ្គីហ្វូ",
      "neName": "गिफु जिल्ला"
    },
    "class10": {
      "code": "210010",
      "name": "美濃地方",
      "enName": "Mino Region",
      "chName": "美濃地區, 岐阜县",
      "zhName": "美浓地区, 飞弹地区",
      "koName": "미노 지방, 기후 현",
      "esName": "Región de Mino, Prefectura de Gifu",
      "ptName": "Região de Mino da Província de Gifu",
      "thName": "ภูมิภาคมิโนะ จังหวัดกิฟุ",
      "viName": "Vùng Mino, tỉnh Gifu",
      "inName": "Wilayah Mino di Provinsi Gifu",
      "tlName": "Rehiyon ng Mino sa Gifu Prefecture",
      "moName": "Мино бүс, Гифү аймаг",
      "buName": "Mino ဒေသ, ဂိဟုစီရင်စု",
      "khName": "តំបន់មីណូ, ខេត្តកីហ្វុ",
      "neName": "मिनो क्षेत्र, गिफु जिल्ला"
    },
    "class15": {
      "code": "210011",
      "name": "岐阜・西濃",
      "enName": "Gifu Seino"
    },
    "class20": {
      "code": "2138300",
      "name": "安八町",
      "enName": "Ampachi Town",
      "kana": "あんぱちちょう",
      "chName": "安八町",
      "zhName": "安八町",
      "koName": "안파치 정",
      "esName": "Pueblo de Anpachi",
      "ptName": "bairro de Ampachi",
      "thName": "เมืองอัมปาจิ",
      "viName": "thị trấn Ampachi",
      "inName": "kota Ampachi",
      "tlName": "bayan ng Ampachi",
      "moName": "Aмпaчи жижиг хот",
      "buName": "အမ်းပါ့ကျိ မြို့နယ်",
      "khName": "ទីប្រជុំជន អាំប៉ាជី",
      "neName": "आम्पाची नगर"
    }
  },
  "2140100": {
    "office": {
      "code": "210000",
      "name": "岐阜県",
      "enName": "Gifu",
      "officeName": "岐阜地方気象台",
      "chName": "岐阜县",
      "zhName": "岐阜縣",
      "koName": "기후현",
      "esName": "Prefectura de Gifu",
      "ptName": "Província de Gifu",
      "thName": "จังหวัดกิฟุ",
      "viName": "Tỉnh Gifu",
      "inName": "Prefektur Gifu",
      "tlName": "Gifu Prefecture",
      "moName": "Гифү аймаг",
      "buName": "ဂျီဖု ပြည်နယ်",
      "khName": "ខេត្ដ ហ្គីហ្វូ",
      "neName": "गिफु जिल्ला"
    },
    "class10": {
      "code": "210010",
      "name": "美濃地方",
      "enName": "Mino Region",
      "chName": "美濃地區, 岐阜县",
      "zhName": "美浓地区, 飞弹地区",
      "koName": "미노 지방, 기후 현",
      "esName": "Región de Mino, Prefectura de Gifu",
      "ptName": "Região de Mino da Província de Gifu",
      "thName": "ภูมิภาคมิโนะ จังหวัดกิฟุ",
      "viName": "Vùng Mino, tỉnh Gifu",
      "inName": "Wilayah Mino di Provinsi Gifu",
      "tlName": "Rehiyon ng Mino sa Gifu Prefecture",
      "moName": "Мино бүс, Гифү аймаг",
      "buName": "Mino ဒေသ, ဂိဟုစီရင်စု",
      "khName": "តំបន់មីណូ, ខេត្តកីហ្វុ",
      "neName": "मिनो क्षेत्र, गिफु जिल्ला"
    },
    "class15": {
      "code": "210011",
      "name": "岐阜・西濃",
      "enName": "Gifu Seino"
    },
    "class20": {
      "code": "2140100",
      "name": "揖斐川町",
      "enName": "Ibigawa Town",
      "kana": "いびがわちょう",
      "chName": "揖斐川町",
      "zhName": "揖斐川町",
      "koName": "이비가와 정",
      "esName": "Pueblo de Ibigawa",
      "ptName": "bairro de Ibigawa",
      "thName": "เมืองอิบิกาวา",
      "viName": "thị trấn Ibigawa",
      "inName": "kota Ibigawa",
      "tlName": "bayan ng Ibigawa",
      "moName": "Ибигава жижиг хот",
      "buName": "အီဘိဂါ့ဝ မြို့နယ်",
      "khName": "ទីប្រជុំជន អ៊ីប៊ីហ្កាវ៉ា",
      "neName": "इबिगावा नगर"
    }
  },
  "2140300": {
    "office": {
      "code": "210000",
      "name": "岐阜県",
      "enName": "Gifu",
      "officeName": "岐阜地方気象台",
      "chName": "岐阜县",
      "zhName": "岐阜縣",
      "koName": "기후현",
      "esName": "Prefectura de Gifu",
      "ptName": "Província de Gifu",
      "thName": "จังหวัดกิฟุ",
      "viName": "Tỉnh Gifu",
      "inName": "Prefektur Gifu",
      "tlName": "Gifu Prefecture",
      "moName": "Гифү аймаг",
      "buName": "ဂျီဖု ပြည်နယ်",
      "khName": "ខេត្ដ ហ្គីហ្វូ",
      "neName": "गिफु जिल्ला"
    },
    "class10": {
      "code": "210010",
      "name": "美濃地方",
      "enName": "Mino Region",
      "chName": "美濃地區, 岐阜县",
      "zhName": "美浓地区, 飞弹地区",
      "koName": "미노 지방, 기후 현",
      "esName": "Región de Mino, Prefectura de Gifu",
      "ptName": "Região de Mino da Província de Gifu",
      "thName": "ภูมิภาคมิโนะ จังหวัดกิฟุ",
      "viName": "Vùng Mino, tỉnh Gifu",
      "inName": "Wilayah Mino di Provinsi Gifu",
      "tlName": "Rehiyon ng Mino sa Gifu Prefecture",
      "moName": "Мино бүс, Гифү аймаг",
      "buName": "Mino ဒေသ, ဂိဟုစီရင်စု",
      "khName": "តំបន់មីណូ, ខេត្តកីហ្វុ",
      "neName": "मिनो क्षेत्र, गिफु जिल्ला"
    },
    "class15": {
      "code": "210011",
      "name": "岐阜・西濃",
      "enName": "Gifu Seino"
    },
    "class20": {
      "code": "2140300",
      "name": "大野町",
      "enName": "Ono Town",
      "kana": "おおのちょう",
      "chName": "大野町",
      "zhName": "大野町",
      "koName": "오노 정",
      "esName": "Pueblo de Ōno",
      "ptName": "bairro de Ono",
      "thName": "เมืองโอโนะ",
      "viName": "thị trấn Ono",
      "inName": "kota Ono",
      "tlName": "bayan ng Ono",
      "moName": "Оно жижиг хот",
      "buName": "အိုနို မြို့နယ်",
      "khName": "ទីប្រជុំជន អូណូ",
      "neName": "ओनो नगर"
    }
  },
  "2140400": {
    "office": {
      "code": "210000",
      "name": "岐阜県",
      "enName": "Gifu",
      "officeName": "岐阜地方気象台",
      "chName": "岐阜县",
      "zhName": "岐阜縣",
      "koName": "기후현",
      "esName": "Prefectura de Gifu",
      "ptName": "Província de Gifu",
      "thName": "จังหวัดกิฟุ",
      "viName": "Tỉnh Gifu",
      "inName": "Prefektur Gifu",
      "tlName": "Gifu Prefecture",
      "moName": "Гифү аймаг",
      "buName": "ဂျီဖု ပြည်နယ်",
      "khName": "ខេត្ដ ហ្គីហ្វូ",
      "neName": "गिफु जिल्ला"
    },
    "class10": {
      "code": "210010",
      "name": "美濃地方",
      "enName": "Mino Region",
      "chName": "美濃地區, 岐阜县",
      "zhName": "美浓地区, 飞弹地区",
      "koName": "미노 지방, 기후 현",
      "esName": "Región de Mino, Prefectura de Gifu",
      "ptName": "Região de Mino da Província de Gifu",
      "thName": "ภูมิภาคมิโนะ จังหวัดกิฟุ",
      "viName": "Vùng Mino, tỉnh Gifu",
      "inName": "Wilayah Mino di Provinsi Gifu",
      "tlName": "Rehiyon ng Mino sa Gifu Prefecture",
      "moName": "Мино бүс, Гифү аймаг",
      "buName": "Mino ဒေသ, ဂိဟုစီရင်စု",
      "khName": "តំបន់មីណូ, ខេត្តកីហ្វុ",
      "neName": "मिनो क्षेत्र, गिफु जिल्ला"
    },
    "class15": {
      "code": "210011",
      "name": "岐阜・西濃",
      "enName": "Gifu Seino"
    },
    "class20": {
      "code": "2140400",
      "name": "池田町",
      "enName": "Ikeda Town",
      "kana": "いけだちょう",
      "chName": "岐阜池田町",
      "zhName": "岐阜池田町",
      "koName": "기후 이케다 정",
      "esName": "Pueblo de Ikeda, Gifu",
      "ptName": "Gifu, bairro de Ikeda",
      "thName": "เมืองอิเคดะ กิฟุ",
      "viName": "Thị trấn Ikeda, Gifu",
      "inName": "Kota Ikeda, GIfu",
      "tlName": "bayan ng Ikeda, Gifu",
      "moName": "Гифү  Икэда жижиг хот",
      "buName": "ဂိဟုအိခဲဒမြို့နယ် ",
      "khName": "ទីប្រជុំជនអ៊ីកេដា គ៊ីហ្វឹ",
      "neName": "गिफु इकेदा नगर"
    }
  },
  "2142100": {
    "office": {
      "code": "210000",
      "name": "岐阜県",
      "enName": "Gifu",
      "officeName": "岐阜地方気象台",
      "chName": "岐阜县",
      "zhName": "岐阜縣",
      "koName": "기후현",
      "esName": "Prefectura de Gifu",
      "ptName": "Província de Gifu",
      "thName": "จังหวัดกิฟุ",
      "viName": "Tỉnh Gifu",
      "inName": "Prefektur Gifu",
      "tlName": "Gifu Prefecture",
      "moName": "Гифү аймаг",
      "buName": "ဂျီဖု ပြည်နယ်",
      "khName": "ខេត្ដ ហ្គីហ្វូ",
      "neName": "गिफु जिल्ला"
    },
    "class10": {
      "code": "210010",
      "name": "美濃地方",
      "enName": "Mino Region",
      "chName": "美濃地區, 岐阜县",
      "zhName": "美浓地区, 飞弹地区",
      "koName": "미노 지방, 기후 현",
      "esName": "Región de Mino, Prefectura de Gifu",
      "ptName": "Região de Mino da Província de Gifu",
      "thName": "ภูมิภาคมิโนะ จังหวัดกิฟุ",
      "viName": "Vùng Mino, tỉnh Gifu",
      "inName": "Wilayah Mino di Provinsi Gifu",
      "tlName": "Rehiyon ng Mino sa Gifu Prefecture",
      "moName": "Мино бүс, Гифү аймаг",
      "buName": "Mino ဒေသ, ဂိဟုစီရင်စု",
      "khName": "តំបន់មីណូ, ខេត្តកីហ្វុ",
      "neName": "मिनो क्षेत्र, गिफु जिल्ला"
    },
    "class15": {
      "code": "210011",
      "name": "岐阜・西濃",
      "enName": "Gifu Seino"
    },
    "class20": {
      "code": "2142100",
      "name": "北方町",
      "enName": "Kitagata Town",
      "kana": "きたがたちょう",
      "chName": "北方町",
      "zhName": "北方町",
      "koName": "기타가타 정",
      "esName": "Pueblo de Kitagata",
      "ptName": "bairro de Kitagata",
      "thName": "เมืองคิตะกาะวะ",
      "viName": "thị trấn Kitagata",
      "inName": "kota Kitagata",
      "tlName": "bayan ng Kitagata",
      "moName": "Китагaта жижиг хот",
      "buName": "ခီတဂါ့တ မြို့နယ်",
      "khName": "ទីប្រជុំជន ឃីធីហ្គាតា",
      "neName": "कितागाता नगर"
    }
  },
  "2150100": {
    "office": {
      "code": "210000",
      "name": "岐阜県",
      "enName": "Gifu",
      "officeName": "岐阜地方気象台",
      "chName": "岐阜县",
      "zhName": "岐阜縣",
      "koName": "기후현",
      "esName": "Prefectura de Gifu",
      "ptName": "Província de Gifu",
      "thName": "จังหวัดกิฟุ",
      "viName": "Tỉnh Gifu",
      "inName": "Prefektur Gifu",
      "tlName": "Gifu Prefecture",
      "moName": "Гифү аймаг",
      "buName": "ဂျီဖု ပြည်နယ်",
      "khName": "ខេត្ដ ហ្គីហ្វូ",
      "neName": "गिफु जिल्ला"
    },
    "class10": {
      "code": "210010",
      "name": "美濃地方",
      "enName": "Mino Region",
      "chName": "美濃地區, 岐阜县",
      "zhName": "美浓地区, 飞弹地区",
      "koName": "미노 지방, 기후 현",
      "esName": "Región de Mino, Prefectura de Gifu",
      "ptName": "Região de Mino da Província de Gifu",
      "thName": "ภูมิภาคมิโนะ จังหวัดกิฟุ",
      "viName": "Vùng Mino, tỉnh Gifu",
      "inName": "Wilayah Mino di Provinsi Gifu",
      "tlName": "Rehiyon ng Mino sa Gifu Prefecture",
      "moName": "Мино бүс, Гифү аймаг",
      "buName": "Mino ဒေသ, ဂိဟုစီရင်စု",
      "khName": "តំបន់មីណូ, ខេត្តកីហ្វុ",
      "neName": "मिनो क्षेत्र, गिफु जिल्ला"
    },
    "class15": {
      "code": "210013",
      "name": "中濃",
      "enName": "Chuno"
    },
    "class20": {
      "code": "2150100",
      "name": "坂祝町",
      "enName": "Sakahogi Town",
      "kana": "さかほぎちょう",
      "chName": "坂祝町",
      "zhName": "坂祝町",
      "koName": "사카호기 정",
      "esName": "Pueblo de Sakahogi",
      "ptName": "bairro de Sakahogi",
      "thName": "เมืองซากาโฮงิ",
      "viName": "thị trấn Sakahogi",
      "inName": "kota Sakahogi",
      "tlName": "bayan ng Sakahogi",
      "moName": "Сaкахоги жижиг хот",
      "buName": "ဆာကားဟော့ဂိ မြို့နယ်",
      "khName": "ទីប្រជុំជន សាកាហ៊ូជី",
      "neName": "साकाहोगी नगर"
    }
  },
  "2150200": {
    "office": {
      "code": "210000",
      "name": "岐阜県",
      "enName": "Gifu",
      "officeName": "岐阜地方気象台",
      "chName": "岐阜县",
      "zhName": "岐阜縣",
      "koName": "기후현",
      "esName": "Prefectura de Gifu",
      "ptName": "Província de Gifu",
      "thName": "จังหวัดกิฟุ",
      "viName": "Tỉnh Gifu",
      "inName": "Prefektur Gifu",
      "tlName": "Gifu Prefecture",
      "moName": "Гифү аймаг",
      "buName": "ဂျီဖု ပြည်နယ်",
      "khName": "ខេត្ដ ហ្គីហ្វូ",
      "neName": "गिफु जिल्ला"
    },
    "class10": {
      "code": "210010",
      "name": "美濃地方",
      "enName": "Mino Region",
      "chName": "美濃地區, 岐阜县",
      "zhName": "美浓地区, 飞弹地区",
      "koName": "미노 지방, 기후 현",
      "esName": "Región de Mino, Prefectura de Gifu",
      "ptName": "Região de Mino da Província de Gifu",
      "thName": "ภูมิภาคมิโนะ จังหวัดกิฟุ",
      "viName": "Vùng Mino, tỉnh Gifu",
      "inName": "Wilayah Mino di Provinsi Gifu",
      "tlName": "Rehiyon ng Mino sa Gifu Prefecture",
      "moName": "Мино бүс, Гифү аймаг",
      "buName": "Mino ဒေသ, ဂိဟုစီရင်စု",
      "khName": "តំបន់មីណូ, ខេត្តកីហ្វុ",
      "neName": "मिनो क्षेत्र, गिफु जिल्ला"
    },
    "class15": {
      "code": "210013",
      "name": "中濃",
      "enName": "Chuno"
    },
    "class20": {
      "code": "2150200",
      "name": "富加町",
      "enName": "Tomika Town",
      "kana": "とみかちょう",
      "chName": "富加町",
      "zhName": "富加町",
      "koName": "도미카 정",
      "esName": "Pueblo de Tomika",
      "ptName": "bairro de Tomika",
      "thName": "เมืองโทมิกะ",
      "viName": "thị trấn Tomika",
      "inName": "kota Tomika",
      "tlName": "bayan ng Tomika",
      "moName": "Томика жижиг хот",
      "buName": "တိုမိက မြို့နယ်",
      "khName": "ទីប្រជុំជន ថូមីកា",
      "neName": "तोमिका नगर"
    }
  },
  "2150300": {
    "office": {
      "code": "210000",
      "name": "岐阜県",
      "enName": "Gifu",
      "officeName": "岐阜地方気象台",
      "chName": "岐阜县",
      "zhName": "岐阜縣",
      "koName": "기후현",
      "esName": "Prefectura de Gifu",
      "ptName": "Província de Gifu",
      "thName": "จังหวัดกิฟุ",
      "viName": "Tỉnh Gifu",
      "inName": "Prefektur Gifu",
      "tlName": "Gifu Prefecture",
      "moName": "Гифү аймаг",
      "buName": "ဂျီဖု ပြည်နယ်",
      "khName": "ខេត្ដ ហ្គីហ្វូ",
      "neName": "गिफु जिल्ला"
    },
    "class10": {
      "code": "210010",
      "name": "美濃地方",
      "enName": "Mino Region",
      "chName": "美濃地區, 岐阜县",
      "zhName": "美浓地区, 飞弹地区",
      "koName": "미노 지방, 기후 현",
      "esName": "Región de Mino, Prefectura de Gifu",
      "ptName": "Região de Mino da Província de Gifu",
      "thName": "ภูมิภาคมิโนะ จังหวัดกิฟุ",
      "viName": "Vùng Mino, tỉnh Gifu",
      "inName": "Wilayah Mino di Provinsi Gifu",
      "tlName": "Rehiyon ng Mino sa Gifu Prefecture",
      "moName": "Мино бүс, Гифү аймаг",
      "buName": "Mino ဒေသ, ဂိဟုစီရင်စု",
      "khName": "តំបន់មីណូ, ខេត្តកីហ្វុ",
      "neName": "मिनो क्षेत्र, गिफु जिल्ला"
    },
    "class15": {
      "code": "210013",
      "name": "中濃",
      "enName": "Chuno"
    },
    "class20": {
      "code": "2150300",
      "name": "川辺町",
      "enName": "Kawabe Town",
      "kana": "かわべちょう",
      "chName": "川边町",
      "zhName": "川邊町",
      "koName": "가와베 정",
      "esName": "Pueblo de Kawabe",
      "ptName": "bairro de Kawabe",
      "thName": "เมืองคาวาเบะ",
      "viName": "thị trấn Kawabe",
      "inName": "kota Kawabe",
      "tlName": "bayan ng Kawabe",
      "moName": "Кавабэ жижиг хот",
      "buName": "ခါဝါ့ဗဲ့ မြို့နယ်",
      "khName": "ទីប្រជុំជន កាវ៉ាបេ",
      "neName": "कावाबे नगर"
    }
  },
  "2150400": {
    "office": {
      "code": "210000",
      "name": "岐阜県",
      "enName": "Gifu",
      "officeName": "岐阜地方気象台",
      "chName": "岐阜县",
      "zhName": "岐阜縣",
      "koName": "기후현",
      "esName": "Prefectura de Gifu",
      "ptName": "Província de Gifu",
      "thName": "จังหวัดกิฟุ",
      "viName": "Tỉnh Gifu",
      "inName": "Prefektur Gifu",
      "tlName": "Gifu Prefecture",
      "moName": "Гифү аймаг",
      "buName": "ဂျီဖု ပြည်နယ်",
      "khName": "ខេត្ដ ហ្គីហ្វូ",
      "neName": "गिफु जिल्ला"
    },
    "class10": {
      "code": "210010",
      "name": "美濃地方",
      "enName": "Mino Region",
      "chName": "美濃地區, 岐阜县",
      "zhName": "美浓地区, 飞弹地区",
      "koName": "미노 지방, 기후 현",
      "esName": "Región de Mino, Prefectura de Gifu",
      "ptName": "Região de Mino da Província de Gifu",
      "thName": "ภูมิภาคมิโนะ จังหวัดกิฟุ",
      "viName": "Vùng Mino, tỉnh Gifu",
      "inName": "Wilayah Mino di Provinsi Gifu",
      "tlName": "Rehiyon ng Mino sa Gifu Prefecture",
      "moName": "Мино бүс, Гифү аймаг",
      "buName": "Mino ဒေသ, ဂိဟုစီရင်စု",
      "khName": "តំបន់មីណូ, ខេត្តកីហ្វុ",
      "neName": "मिनो क्षेत्र, गिफु जिल्ला"
    },
    "class15": {
      "code": "210013",
      "name": "中濃",
      "enName": "Chuno"
    },
    "class20": {
      "code": "2150400",
      "name": "七宗町",
      "enName": "Hichiso Town",
      "kana": "ひちそうちょう",
      "chName": "七宗町",
      "zhName": "七宗町",
      "koName": "히치소 정",
      "esName": "Pueblo de Hichiso",
      "ptName": "bairro de Hichiso",
      "thName": "เมืองฮิจิโสะ",
      "viName": "thị trấn Hichiso",
      "inName": "kota Hichiso",
      "tlName": "bayan ng Hichiso",
      "moName": "Хичисо жижиг хот",
      "buName": "ဟီကျိဆို မြို့နယ်",
      "khName": "ទីប្រជុំជន ហ៊ីឈីសូ",
      "neName": "हिचिसो नगर"
    }
  },
  "2150500": {
    "office": {
      "code": "210000",
      "name": "岐阜県",
      "enName": "Gifu",
      "officeName": "岐阜地方気象台",
      "chName": "岐阜县",
      "zhName": "岐阜縣",
      "koName": "기후현",
      "esName": "Prefectura de Gifu",
      "ptName": "Província de Gifu",
      "thName": "จังหวัดกิฟุ",
      "viName": "Tỉnh Gifu",
      "inName": "Prefektur Gifu",
      "tlName": "Gifu Prefecture",
      "moName": "Гифү аймаг",
      "buName": "ဂျီဖု ပြည်နယ်",
      "khName": "ខេត្ដ ហ្គីហ្វូ",
      "neName": "गिफु जिल्ला"
    },
    "class10": {
      "code": "210010",
      "name": "美濃地方",
      "enName": "Mino Region",
      "chName": "美濃地區, 岐阜县",
      "zhName": "美浓地区, 飞弹地区",
      "koName": "미노 지방, 기후 현",
      "esName": "Región de Mino, Prefectura de Gifu",
      "ptName": "Região de Mino da Província de Gifu",
      "thName": "ภูมิภาคมิโนะ จังหวัดกิฟุ",
      "viName": "Vùng Mino, tỉnh Gifu",
      "inName": "Wilayah Mino di Provinsi Gifu",
      "tlName": "Rehiyon ng Mino sa Gifu Prefecture",
      "moName": "Мино бүс, Гифү аймаг",
      "buName": "Mino ဒေသ, ဂိဟုစီရင်စု",
      "khName": "តំបន់មីណូ, ខេត្តកីហ្វុ",
      "neName": "मिनो क्षेत्र, गिफु जिल्ला"
    },
    "class15": {
      "code": "210013",
      "name": "中濃",
      "enName": "Chuno"
    },
    "class20": {
      "code": "2150500",
      "name": "八百津町",
      "enName": "Yaotsu Town",
      "kana": "やおつちょう",
      "chName": "八百津町",
      "zhName": "八百津町",
      "koName": "야오쓰 정",
      "esName": "Pueblo de Yaotsu",
      "ptName": "bairro de Yaotsu",
      "thName": "เมืองยาโอสึ",
      "viName": "thị trấn Yaotsu",
      "inName": "kota Yaotsu",
      "tlName": "bayan ng Yaotsu",
      "moName": "Яоцү жижиг хот",
      "buName": "ယားအို့ဆု မြို့နယ်",
      "khName": "ទីប្រជុំជន​​ យ៉ោតស៊ូ",
      "neName": "याओत्सु नगर"
    }
  },
  "2150600": {
    "office": {
      "code": "210000",
      "name": "岐阜県",
      "enName": "Gifu",
      "officeName": "岐阜地方気象台",
      "chName": "岐阜县",
      "zhName": "岐阜縣",
      "koName": "기후현",
      "esName": "Prefectura de Gifu",
      "ptName": "Província de Gifu",
      "thName": "จังหวัดกิฟุ",
      "viName": "Tỉnh Gifu",
      "inName": "Prefektur Gifu",
      "tlName": "Gifu Prefecture",
      "moName": "Гифү аймаг",
      "buName": "ဂျီဖု ပြည်နယ်",
      "khName": "ខេត្ដ ហ្គីហ្វូ",
      "neName": "गिफु जिल्ला"
    },
    "class10": {
      "code": "210010",
      "name": "美濃地方",
      "enName": "Mino Region",
      "chName": "美濃地區, 岐阜县",
      "zhName": "美浓地区, 飞弹地区",
      "koName": "미노 지방, 기후 현",
      "esName": "Región de Mino, Prefectura de Gifu",
      "ptName": "Região de Mino da Província de Gifu",
      "thName": "ภูมิภาคมิโนะ จังหวัดกิฟุ",
      "viName": "Vùng Mino, tỉnh Gifu",
      "inName": "Wilayah Mino di Provinsi Gifu",
      "tlName": "Rehiyon ng Mino sa Gifu Prefecture",
      "moName": "Мино бүс, Гифү аймаг",
      "buName": "Mino ဒေသ, ဂိဟုစီရင်စု",
      "khName": "តំបន់មីណូ, ខេត្តកីហ្វុ",
      "neName": "मिनो क्षेत्र, गिफु जिल्ला"
    },
    "class15": {
      "code": "210013",
      "name": "中濃",
      "enName": "Chuno"
    },
    "class20": {
      "code": "2150600",
      "name": "白川町",
      "enName": "Shirakawa Town",
      "kana": "しらかわちょう",
      "chName": "白川町",
      "zhName": "白川町",
      "koName": "시라카와 정",
      "esName": "Pueblo de Shirakawa",
      "ptName": "bairro de Shirakawa",
      "thName": "เมืองชิราคาวะ",
      "viName": "thị trấn Shirakawa",
      "inName": "kota Shirakawa",
      "tlName": "bayan ng Shirakawa",
      "moName": "Ширакава жижиг хот",
      "buName": "ရှီရာကာ့ဝ မြို့နယ်",
      "khName": "ទីប្រជុំជន ស៊ីរ៉ាកាវ៉ា",
      "neName": "शिराकावा नगर"
    }
  },
  "2150700": {
    "office": {
      "code": "210000",
      "name": "岐阜県",
      "enName": "Gifu",
      "officeName": "岐阜地方気象台",
      "chName": "岐阜县",
      "zhName": "岐阜縣",
      "koName": "기후현",
      "esName": "Prefectura de Gifu",
      "ptName": "Província de Gifu",
      "thName": "จังหวัดกิฟุ",
      "viName": "Tỉnh Gifu",
      "inName": "Prefektur Gifu",
      "tlName": "Gifu Prefecture",
      "moName": "Гифү аймаг",
      "buName": "ဂျီဖု ပြည်နယ်",
      "khName": "ខេត្ដ ហ្គីហ្វូ",
      "neName": "गिफु जिल्ला"
    },
    "class10": {
      "code": "210010",
      "name": "美濃地方",
      "enName": "Mino Region",
      "chName": "美濃地區, 岐阜县",
      "zhName": "美浓地区, 飞弹地区",
      "koName": "미노 지방, 기후 현",
      "esName": "Región de Mino, Prefectura de Gifu",
      "ptName": "Região de Mino da Província de Gifu",
      "thName": "ภูมิภาคมิโนะ จังหวัดกิฟุ",
      "viName": "Vùng Mino, tỉnh Gifu",
      "inName": "Wilayah Mino di Provinsi Gifu",
      "tlName": "Rehiyon ng Mino sa Gifu Prefecture",
      "moName": "Мино бүс, Гифү аймаг",
      "buName": "Mino ဒေသ, ဂိဟုစီရင်စု",
      "khName": "តំបន់មីណូ, ខេត្តកីហ្វុ",
      "neName": "मिनो क्षेत्र, गिफु जिल्ला"
    },
    "class15": {
      "code": "210013",
      "name": "中濃",
      "enName": "Chuno"
    },
    "class20": {
      "code": "2150700",
      "name": "東白川村",
      "enName": "Higashishirakawa Village",
      "kana": "ひがししらかわむら",
      "chName": "东白川村",
      "zhName": "東白川村",
      "koName": "히가시시라카와 촌",
      "esName": "Aldea de Higashi-Shirakawa",
      "ptName": "povoado de Higashishirakawa",
      "thName": "หมู่บ้านฮิงาชิชิราคาวะ",
      "viName": "làng Higashishirakawa",
      "inName": "desa Higashishirakawa",
      "tlName": "nayon ng Higashishirakawa",
      "moName": "Хигашиширакава тосгон",
      "buName": "ဟီဂါရှိရှီရာကာ့ဝ ကျေးရွာ",
      "khName": "ភូមិ ហ៊ីហ្កាស៊ីស៊ីរ៉ាកាវ៉ា",
      "neName": "हिगाशिशिराकावा गाउँ"
    }
  },
  "2152100": {
    "office": {
      "code": "210000",
      "name": "岐阜県",
      "enName": "Gifu",
      "officeName": "岐阜地方気象台",
      "chName": "岐阜县",
      "zhName": "岐阜縣",
      "koName": "기후현",
      "esName": "Prefectura de Gifu",
      "ptName": "Província de Gifu",
      "thName": "จังหวัดกิฟุ",
      "viName": "Tỉnh Gifu",
      "inName": "Prefektur Gifu",
      "tlName": "Gifu Prefecture",
      "moName": "Гифү аймаг",
      "buName": "ဂျီဖု ပြည်နယ်",
      "khName": "ខេត្ដ ហ្គីហ្វូ",
      "neName": "गिफु जिल्ला"
    },
    "class10": {
      "code": "210010",
      "name": "美濃地方",
      "enName": "Mino Region",
      "chName": "美濃地區, 岐阜县",
      "zhName": "美浓地区, 飞弹地区",
      "koName": "미노 지방, 기후 현",
      "esName": "Región de Mino, Prefectura de Gifu",
      "ptName": "Região de Mino da Província de Gifu",
      "thName": "ภูมิภาคมิโนะ จังหวัดกิฟุ",
      "viName": "Vùng Mino, tỉnh Gifu",
      "inName": "Wilayah Mino di Provinsi Gifu",
      "tlName": "Rehiyon ng Mino sa Gifu Prefecture",
      "moName": "Мино бүс, Гифү аймаг",
      "buName": "Mino ဒေသ, ဂိဟုစီရင်စု",
      "khName": "តំបន់មីណូ, ខេត្តកីហ្វុ",
      "neName": "मिनो क्षेत्र, गिफु जिल्ला"
    },
    "class15": {
      "code": "210013",
      "name": "中濃",
      "enName": "Chuno"
    },
    "class20": {
      "code": "2152100",
      "name": "御嵩町",
      "enName": "Mitake Town",
      "kana": "みたけちょう",
      "chName": "御嵩町",
      "zhName": "御嵩町",
      "koName": "미타케 정",
      "esName": "Pueblo de Mitake",
      "ptName": "bairro de Mitake",
      "thName": "เมืองมิทาเกะ",
      "viName": "thị trấn Mitake",
      "inName": "kota Mitake",
      "tlName": "bayan ng Mitake",
      "moName": "Митакэ жижиг хот",
      "buName": "မီတာ့ကဲ့ မြို့နယ်",
      "khName": "ទីប្រជុំជន មីតាកេ",
      "neName": "मिताके नगर"
    }
  },
  "2160400": {
    "office": {
      "code": "210000",
      "name": "岐阜県",
      "enName": "Gifu",
      "officeName": "岐阜地方気象台",
      "chName": "岐阜县",
      "zhName": "岐阜縣",
      "koName": "기후현",
      "esName": "Prefectura de Gifu",
      "ptName": "Província de Gifu",
      "thName": "จังหวัดกิฟุ",
      "viName": "Tỉnh Gifu",
      "inName": "Prefektur Gifu",
      "tlName": "Gifu Prefecture",
      "moName": "Гифү аймаг",
      "buName": "ဂျီဖု ပြည်နယ်",
      "khName": "ខេត្ដ ហ្គីហ្វូ",
      "neName": "गिफु जिल्ला"
    },
    "class10": {
      "code": "210020",
      "name": "飛騨地方",
      "enName": "Hida Region",
      "chName": "飛彈地區, 岐阜县",
      "zhName": "飞弹地区, 美浓地区",
      "koName": "히다 지방, 기후 현",
      "esName": "Región de Hida, Prefectura de Gifu",
      "ptName": "Região de Hida da Província de Gifu",
      "thName": "ภูมิภาคฮิดะ จังหวัดกิฟุ",
      "viName": "Vùng Hida, tỉnh Gifu",
      "inName": "Wilayah Hida di Provinsi Gifu",
      "tlName": "Rehiyon ng Hida sa Gifu Prefecture",
      "moName": "Хида бүс, Гифү аймаг",
      "buName": "Hida ဒေသ, ဂိဟုစီရင်စု",
      "khName": "តំបន់ Hida, ខេត្តកីហ្វុ",
      "neName": "हिडा क्षेत्र, गिफु जिल्ला"
    },
    "class15": {
      "code": "210021",
      "name": "飛騨北部",
      "enName": "Northern Hida"
    },
    "class20": {
      "code": "2160400",
      "name": "白川村",
      "enName": "Shirakawa Village",
      "kana": "しらかわむら",
      "chName": "白川村",
      "zhName": "白川村",
      "koName": "시라카와 촌",
      "esName": "Aldea de Shirakawa",
      "ptName": "povoado de Shirakawa",
      "thName": "หมู่บ้านชิราคาวะ",
      "viName": "làng Shirakawa",
      "inName": "desa Shirakawa",
      "tlName": "nayon ng Shirakawa",
      "moName": "Ширакава тосгон",
      "buName": "ရှီရားကာ့ဝ ကျေးရွာ",
      "khName": "ភូមិ ស៊ីរ៉ាកាវ៉ា",
      "neName": "शिराकावा गाउँ"
    }
  },
  "2210001": {
    "office": {
      "code": "220000",
      "name": "静岡県",
      "enName": "Shizuoka",
      "officeName": "静岡地方気象台",
      "chName": "静冈县",
      "zhName": "靜岡縣",
      "koName": "시즈오카현",
      "esName": "Prefectura de Shizuoka",
      "ptName": "Província de Shizuoka",
      "thName": "จังหวัดชิซุโอกะ",
      "viName": "Tỉnh Shizuoka",
      "inName": "Prefektur Shizuoka",
      "tlName": "Shizuoka Prefecture",
      "moName": "Шизүока аймаг",
      "buName": "ရှီဇူးအိုက ပြည်နယ်",
      "khName": "ខេត្ដ ហ្ស៊ីស៊ូកា",
      "neName": "सिजुओका जिल्ला"
    },
    "class10": {
      "code": "220010",
      "name": "中部",
      "enName": "Central Region",
      "chName": "静冈县中部",
      "zhName": "靜岡縣中部",
      "koName": "시즈오카 현 중부",
      "esName": "Centro de Prefectura de Shizuoka",
      "ptName": "Região central da Província de Shizuoka",
      "thName": "จังหวัดชิซุโอกะตอนกลาง",
      "viName": "Miền Trung tỉnh Shizuoka",
      "inName": "Bagian Tengah Prefektur Shizuoka",
      "tlName": "Sentral na bahagi ng Shizuoka Prefecture",
      "moName": "Төв Шизүока аймаг",
      "buName": "ရှိဇုအိုကစီရင်စု အလယ်ပိုင်း",
      "khName": "តំបន់កណ្តាលនៃខេត្ដស៊ីស្ស៊ឹអុកា",
      "neName": "सिजुओका जिल्लाको मध्य भाग"
    },
    "class15": {
      "code": "220011",
      "name": "中部南",
      "enName": "Southern Central Region"
    },
    "class20": {
      "code": "2210001",
      "name": "静岡市南部",
      "enName": "Southern Shizuoka City",
      "kana": "しずおかしなんぶ",
      "chName": "静冈市",
      "zhName": "静冈市",
      "koName": "시즈오카시",
      "esName": "Ciudad de Shizuoka",
      "ptName": "Cidade de Shizuoka",
      "thName": "เมืองชิซูโอกะ",
      "viName": "Thành phố Shizuoka",
      "inName": "Kota Shizuoka",
      "tlName": "Lungsod ng Shizuoka",
      "moName": "Cidade de Shizuoka",
      "buName": "ရှီဇိုကာမြို့",
      "khName": "ទីក្រុង Shizuoka",
      "neName": "सिज़ूओका शहर"
    }
  },
  "2210002": {
    "office": {
      "code": "220000",
      "name": "静岡県",
      "enName": "Shizuoka",
      "officeName": "静岡地方気象台",
      "chName": "静冈县",
      "zhName": "靜岡縣",
      "koName": "시즈오카현",
      "esName": "Prefectura de Shizuoka",
      "ptName": "Província de Shizuoka",
      "thName": "จังหวัดชิซุโอกะ",
      "viName": "Tỉnh Shizuoka",
      "inName": "Prefektur Shizuoka",
      "tlName": "Shizuoka Prefecture",
      "moName": "Шизүока аймаг",
      "buName": "ရှီဇူးအိုက ပြည်နယ်",
      "khName": "ខេត្ដ ហ្ស៊ីស៊ូកា",
      "neName": "सिजुओका जिल्ला"
    },
    "class10": {
      "code": "220010",
      "name": "中部",
      "enName": "Central Region",
      "chName": "静冈县中部",
      "zhName": "靜岡縣中部",
      "koName": "시즈오카 현 중부",
      "esName": "Centro de Prefectura de Shizuoka",
      "ptName": "Região central da Província de Shizuoka",
      "thName": "จังหวัดชิซุโอกะตอนกลาง",
      "viName": "Miền Trung tỉnh Shizuoka",
      "inName": "Bagian Tengah Prefektur Shizuoka",
      "tlName": "Sentral na bahagi ng Shizuoka Prefecture",
      "moName": "Төв Шизүока аймаг",
      "buName": "ရှိဇုအိုကစီရင်စု အလယ်ပိုင်း",
      "khName": "តំបន់កណ្តាលនៃខេត្ដស៊ីស្ស៊ឹអុកា",
      "neName": "सिजुओका जिल्लाको मध्य भाग"
    },
    "class15": {
      "code": "220012",
      "name": "中部北",
      "enName": "Northern Central Region"
    },
    "class20": {
      "code": "2210002",
      "name": "静岡市北部",
      "enName": "Northern Shizuoka City",
      "kana": "しずおかしほうぶ",
      "chName": "静冈市",
      "zhName": "静冈市",
      "koName": "시즈오카시",
      "esName": "Ciudad de Shizuoka",
      "ptName": "Cidade de Shizuoka",
      "thName": "เมืองชิซูโอกะ",
      "viName": "Thành phố Shizuoka",
      "inName": "Kota Shizuoka",
      "tlName": "Lungsod ng Shizuoka",
      "moName": "Cidade de Shizuoka",
      "buName": "ရှီဇိုကာမြို့",
      "khName": "ទីក្រុង Shizuoka",
      "neName": "सिज़ूओका शहर"
    }
  },
  "2213001": {
    "office": {
      "code": "220000",
      "name": "静岡県",
      "enName": "Shizuoka",
      "officeName": "静岡地方気象台",
      "chName": "静冈县",
      "zhName": "靜岡縣",
      "koName": "시즈오카현",
      "esName": "Prefectura de Shizuoka",
      "ptName": "Província de Shizuoka",
      "thName": "จังหวัดชิซุโอกะ",
      "viName": "Tỉnh Shizuoka",
      "inName": "Prefektur Shizuoka",
      "tlName": "Shizuoka Prefecture",
      "moName": "Шизүока аймаг",
      "buName": "ရှီဇူးအိုက ပြည်နယ်",
      "khName": "ខេត្ដ ហ្ស៊ីស៊ូកា",
      "neName": "सिजुओका जिल्ला"
    },
    "class10": {
      "code": "220040",
      "name": "西部",
      "enName": "Western Region",
      "chName": "静冈县西部",
      "zhName": "靜岡縣西部",
      "koName": "시즈오카 현 서부",
      "esName": "Oeste de Prefectura de Shizuoka",
      "ptName": "Região Oeste da Província de Shizuoka",
      "thName": "จังหวัดชิซุโอกะฟากตะวันตก",
      "viName": "Miền Tây tỉnh Shizuoka",
      "inName": "Bagian Barat Prefektur Shizuoka",
      "tlName": "Kanlurang bahagi ng Shizuoka Prefecture",
      "moName": "Баруун Шизүока аймаг",
      "buName": "ရှိဇုအိုကစီရင်စု အနောက်ပိုင်း",
      "khName": "តំបន់ខាងលិចនៃខេត្ដស៊ីស្ស៊ឹអុកា",
      "neName": "सिजुओका जिल्लाको पश्चिमी भाग"
    },
    "class15": {
      "code": "220042",
      "name": "遠州南",
      "enName": "Southern Enshu"
    },
    "class20": {
      "code": "2213001",
      "name": "浜松市南部",
      "enName": "Southern Hamamatsu City",
      "kana": "はままつしなんぶ",
      "chName": "浜松市",
      "zhName": "浜松市",
      "koName": "하마마츠시",
      "esName": "Ciudad de Hamamatsu",
      "ptName": "Cidade de Hamamatsu",
      "thName": "เมืองฮามามัตสึ",
      "viName": "Thành phố Hamamatsu",
      "inName": "Kota Hamamatsu",
      "tlName": "Lungsod ng Hamamatsu",
      "moName": "Cidade de Hamamatsu",
      "buName": "ဟမမတ်စုမြို့",
      "khName": "ទីក្រុង Hamamatsu",
      "neName": "हामामात्सु शहर"
    }
  },
  "2213002": {
    "office": {
      "code": "220000",
      "name": "静岡県",
      "enName": "Shizuoka",
      "officeName": "静岡地方気象台",
      "chName": "静冈县",
      "zhName": "靜岡縣",
      "koName": "시즈오카현",
      "esName": "Prefectura de Shizuoka",
      "ptName": "Província de Shizuoka",
      "thName": "จังหวัดชิซุโอกะ",
      "viName": "Tỉnh Shizuoka",
      "inName": "Prefektur Shizuoka",
      "tlName": "Shizuoka Prefecture",
      "moName": "Шизүока аймаг",
      "buName": "ရှီဇူးအိုက ပြည်နယ်",
      "khName": "ខេត្ដ ហ្ស៊ីស៊ូកា",
      "neName": "सिजुओका जिल्ला"
    },
    "class10": {
      "code": "220040",
      "name": "西部",
      "enName": "Western Region",
      "chName": "静冈县西部",
      "zhName": "靜岡縣西部",
      "koName": "시즈오카 현 서부",
      "esName": "Oeste de Prefectura de Shizuoka",
      "ptName": "Região Oeste da Província de Shizuoka",
      "thName": "จังหวัดชิซุโอกะฟากตะวันตก",
      "viName": "Miền Tây tỉnh Shizuoka",
      "inName": "Bagian Barat Prefektur Shizuoka",
      "tlName": "Kanlurang bahagi ng Shizuoka Prefecture",
      "moName": "Баруун Шизүока аймаг",
      "buName": "ရှိဇုအိုကစီရင်စု အနောက်ပိုင်း",
      "khName": "តំបន់ខាងលិចនៃខេត្ដស៊ីស្ស៊ឹអុកា",
      "neName": "सिजुओका जिल्लाको पश्चिमी भाग"
    },
    "class15": {
      "code": "220041",
      "name": "遠州北",
      "enName": "Northern Enshu"
    },
    "class20": {
      "code": "2213002",
      "name": "浜松市北部",
      "enName": "Northern Hamamatsu City",
      "kana": "はままつしほくぶ",
      "chName": "浜松市",
      "zhName": "浜松市",
      "koName": "하마마츠시",
      "esName": "Ciudad de Hamamatsu",
      "ptName": "Cidade de Hamamatsu",
      "thName": "เมืองฮามามัตสึ",
      "viName": "Thành phố Hamamatsu",
      "inName": "Kota Hamamatsu",
      "tlName": "Lungsod ng Hamamatsu",
      "moName": "Cidade de Hamamatsu",
      "buName": "ဟမမတ်စုမြို့",
      "khName": "ទីក្រុង Hamamatsu",
      "neName": "हामामात्सु शहर"
    }
  },
  "2220300": {
    "office": {
      "code": "220000",
      "name": "静岡県",
      "enName": "Shizuoka",
      "officeName": "静岡地方気象台",
      "chName": "静冈县",
      "zhName": "靜岡縣",
      "koName": "시즈오카현",
      "esName": "Prefectura de Shizuoka",
      "ptName": "Província de Shizuoka",
      "thName": "จังหวัดชิซุโอกะ",
      "viName": "Tỉnh Shizuoka",
      "inName": "Prefektur Shizuoka",
      "tlName": "Shizuoka Prefecture",
      "moName": "Шизүока аймаг",
      "buName": "ရှီဇူးအိုက ပြည်နယ်",
      "khName": "ខេត្ដ ហ្ស៊ីស៊ូកា",
      "neName": "सिजुओका जिल्ला"
    },
    "class10": {
      "code": "220030",
      "name": "東部",
      "enName": "Eastern Region",
      "chName": "静冈县东部",
      "zhName": "靜岡縣東部",
      "koName": "시즈오카 현 동부",
      "esName": "Este de Prefectura de Shizuoka",
      "ptName": "Região Leste da Província de Shizuoka",
      "thName": "จังหวัดชิซุโอกะฟากตะวันออก",
      "viName": "Miền Đông tỉnh Shizuoka",
      "inName": "Bagian Timur Prefektur Shizuoka",
      "tlName": "Silangang bahagi ng Shizuoka Prefecture",
      "moName": "Зүүн Шизүока аймаг",
      "buName": "ရှိဇုအိုကစီရင်စု အရှေ့ပိုင်း",
      "khName": "តំបន់ខាងកើតនៃខេត្ដស៊ីស្ស៊ឹអុកា",
      "neName": "सिजुओका जिल्लाको पूर्वी भाग"
    },
    "class15": {
      "code": "220031",
      "name": "富士山南東",
      "enName": "South-eastern Mt. Fuji"
    },
    "class20": {
      "code": "2220300",
      "name": "沼津市",
      "enName": "Numazu City",
      "kana": "ぬまづし",
      "chName": "沼津市",
      "zhName": "沼津市",
      "koName": "누마즈 시",
      "esName": "Ciudad de Numazu",
      "ptName": "cidade de Numazu",
      "thName": "เมืองนามาสึ",
      "viName": "thành phố Numazu",
      "inName": "kota Numazu",
      "tlName": "siyudad ng Numazu",
      "moName": "Нүмaзү хот",
      "buName": "နူမားဇု မြို့",
      "khName": "ទីក្រុង នូម៉ាស៊ូ",
      "neName": "नामाजु सहर"
    }
  },
  "2220500": {
    "office": {
      "code": "220000",
      "name": "静岡県",
      "enName": "Shizuoka",
      "officeName": "静岡地方気象台",
      "chName": "静冈县",
      "zhName": "靜岡縣",
      "koName": "시즈오카현",
      "esName": "Prefectura de Shizuoka",
      "ptName": "Província de Shizuoka",
      "thName": "จังหวัดชิซุโอกะ",
      "viName": "Tỉnh Shizuoka",
      "inName": "Prefektur Shizuoka",
      "tlName": "Shizuoka Prefecture",
      "moName": "Шизүока аймаг",
      "buName": "ရှီဇူးအိုက ပြည်နယ်",
      "khName": "ខេត្ដ ហ្ស៊ីស៊ូកា",
      "neName": "सिजुओका जिल्ला"
    },
    "class10": {
      "code": "220020",
      "name": "伊豆",
      "enName": "Izu",
      "chName": "静冈县伊豆地方",
      "zhName": "静岡縣伊豆地方",
      "koName": "시즈오카 현 이즈 지방",
      "esName": "Región Izu, Prefectura de Shizuoka",
      "ptName": "Região de Izu da Província de Shizuoka",
      "thName": "ท้องถิ่นอิซุ จังหวัดชิซุโอกะ",
      "viName": "Vùng Izu tỉnh Shizuoka",
      "inName": "Daerah Izu di Prefektur Shizuoka",
      "tlName": "Rehiyon ng Izu sa Shizuoka Prefecture",
      "moName": "Шизүока аймаг, Изү",
      "buName": "အိဇု၊ ရှိဇုအိုကစီရင်စု",
      "khName": "តំបន់អ៊ីហ៊្សូនៃខេត្ដស៊ីស្ស៊ឹអុកា",
      "neName": "सिजुओका जिल्ला, इजु क्षेत्र"
    },
    "class15": {
      "code": "220021",
      "name": "伊豆北",
      "enName": "Northern Izu"
    },
    "class20": {
      "code": "2220500",
      "name": "熱海市",
      "enName": "Atami City",
      "kana": "あたみし",
      "chName": "热海市",
      "zhName": "熱海市",
      "koName": "아타미 시",
      "esName": "Ciudad de Atami",
      "ptName": "cidade de Atami",
      "thName": "เมืองอะตามิ",
      "viName": "thành phố Atami",
      "inName": "kota Atami",
      "tlName": "siyudad ng Atami",
      "moName": "Aтами хот",
      "buName": "အာတားမိ မြို့",
      "khName": "ទីក្រុង អាតាមិ",
      "neName": "आतामी सहर"
    }
  },
  "2220600": {
    "office": {
      "code": "220000",
      "name": "静岡県",
      "enName": "Shizuoka",
      "officeName": "静岡地方気象台",
      "chName": "静冈县",
      "zhName": "靜岡縣",
      "koName": "시즈오카현",
      "esName": "Prefectura de Shizuoka",
      "ptName": "Província de Shizuoka",
      "thName": "จังหวัดชิซุโอกะ",
      "viName": "Tỉnh Shizuoka",
      "inName": "Prefektur Shizuoka",
      "tlName": "Shizuoka Prefecture",
      "moName": "Шизүока аймаг",
      "buName": "ရှီဇူးအိုက ပြည်နယ်",
      "khName": "ខេត្ដ ហ្ស៊ីស៊ូកា",
      "neName": "सिजुओका जिल्ला"
    },
    "class10": {
      "code": "220030",
      "name": "東部",
      "enName": "Eastern Region",
      "chName": "静冈县东部",
      "zhName": "靜岡縣東部",
      "koName": "시즈오카 현 동부",
      "esName": "Este de Prefectura de Shizuoka",
      "ptName": "Região Leste da Província de Shizuoka",
      "thName": "จังหวัดชิซุโอกะฟากตะวันออก",
      "viName": "Miền Đông tỉnh Shizuoka",
      "inName": "Bagian Timur Prefektur Shizuoka",
      "tlName": "Silangang bahagi ng Shizuoka Prefecture",
      "moName": "Зүүн Шизүока аймаг",
      "buName": "ရှိဇုအိုကစီရင်စု အရှေ့ပိုင်း",
      "khName": "តំបន់ខាងកើតនៃខេត្ដស៊ីស្ស៊ឹអុកា",
      "neName": "सिजुओका जिल्लाको पूर्वी भाग"
    },
    "class15": {
      "code": "220031",
      "name": "富士山南東",
      "enName": "South-eastern Mt. Fuji"
    },
    "class20": {
      "code": "2220600",
      "name": "三島市",
      "enName": "Mishima City",
      "kana": "みしまし",
      "chName": "三岛市",
      "zhName": "三島市",
      "koName": "미시마 시",
      "esName": "Ciudad de Mishima",
      "ptName": "cidade de Mishima",
      "thName": "เมืองมิชิมา",
      "viName": "thành phố Mishima",
      "inName": "kota Mishima",
      "tlName": "siyudad ng Mishima",
      "moName": "Мишимa хот",
      "buName": "မီရှိမ မြို့",
      "khName": "ទីក្រុង មីស៊ីម៉ា",
      "neName": "मिसिमा सहर"
    }
  },
  "2220700": {
    "office": {
      "code": "220000",
      "name": "静岡県",
      "enName": "Shizuoka",
      "officeName": "静岡地方気象台",
      "chName": "静冈县",
      "zhName": "靜岡縣",
      "koName": "시즈오카현",
      "esName": "Prefectura de Shizuoka",
      "ptName": "Província de Shizuoka",
      "thName": "จังหวัดชิซุโอกะ",
      "viName": "Tỉnh Shizuoka",
      "inName": "Prefektur Shizuoka",
      "tlName": "Shizuoka Prefecture",
      "moName": "Шизүока аймаг",
      "buName": "ရှီဇူးအိုက ပြည်နယ်",
      "khName": "ខេត្ដ ហ្ស៊ីស៊ូកា",
      "neName": "सिजुओका जिल्ला"
    },
    "class10": {
      "code": "220030",
      "name": "東部",
      "enName": "Eastern Region",
      "chName": "静冈县东部",
      "zhName": "靜岡縣東部",
      "koName": "시즈오카 현 동부",
      "esName": "Este de Prefectura de Shizuoka",
      "ptName": "Região Leste da Província de Shizuoka",
      "thName": "จังหวัดชิซุโอกะฟากตะวันออก",
      "viName": "Miền Đông tỉnh Shizuoka",
      "inName": "Bagian Timur Prefektur Shizuoka",
      "tlName": "Silangang bahagi ng Shizuoka Prefecture",
      "moName": "Зүүн Шизүока аймаг",
      "buName": "ရှိဇုအိုကစီရင်စု အရှေ့ပိုင်း",
      "khName": "តំបន់ខាងកើតនៃខេត្ដស៊ីស្ស៊ឹអុកា",
      "neName": "सिजुओका जिल्लाको पूर्वी भाग"
    },
    "class15": {
      "code": "220032",
      "name": "富士山南西",
      "enName": "South-western Mt. Fuji"
    },
    "class20": {
      "code": "2220700",
      "name": "富士宮市",
      "enName": "Fujinomiya City",
      "kana": "ふじのみやし",
      "chName": "富士宫市",
      "zhName": "富士宮市",
      "koName": "후지노미야 시",
      "esName": "Ciudad de Fujinomiya",
      "ptName": "cidade de Fujinomiya",
      "thName": "เมืองฟุจิโนะมิยะ",
      "viName": "thành phố Fujinomiya",
      "inName": "kota Fujinomiya",
      "tlName": "siyudad ng Fujinomiya",
      "moName": "Фүжиномия хот",
      "buName": "ဟူဂျိနိုးမိယ မြို့",
      "khName": "ទីក្រុង ហ្វូជីណូមីយ៉ា",
      "neName": "फुजिनोमिया सहर"
    }
  },
  "2220800": {
    "office": {
      "code": "220000",
      "name": "静岡県",
      "enName": "Shizuoka",
      "officeName": "静岡地方気象台",
      "chName": "静冈县",
      "zhName": "靜岡縣",
      "koName": "시즈오카현",
      "esName": "Prefectura de Shizuoka",
      "ptName": "Província de Shizuoka",
      "thName": "จังหวัดชิซุโอกะ",
      "viName": "Tỉnh Shizuoka",
      "inName": "Prefektur Shizuoka",
      "tlName": "Shizuoka Prefecture",
      "moName": "Шизүока аймаг",
      "buName": "ရှီဇူးအိုက ပြည်နယ်",
      "khName": "ខេត្ដ ហ្ស៊ីស៊ូកា",
      "neName": "सिजुओका जिल्ला"
    },
    "class10": {
      "code": "220020",
      "name": "伊豆",
      "enName": "Izu",
      "chName": "静冈县伊豆地方",
      "zhName": "静岡縣伊豆地方",
      "koName": "시즈오카 현 이즈 지방",
      "esName": "Región Izu, Prefectura de Shizuoka",
      "ptName": "Região de Izu da Província de Shizuoka",
      "thName": "ท้องถิ่นอิซุ จังหวัดชิซุโอกะ",
      "viName": "Vùng Izu tỉnh Shizuoka",
      "inName": "Daerah Izu di Prefektur Shizuoka",
      "tlName": "Rehiyon ng Izu sa Shizuoka Prefecture",
      "moName": "Шизүока аймаг, Изү",
      "buName": "အိဇု၊ ရှိဇုအိုကစီရင်စု",
      "khName": "តំបន់អ៊ីហ៊្សូនៃខេត្ដស៊ីស្ស៊ឹអុកា",
      "neName": "सिजुओका जिल्ला, इजु क्षेत्र"
    },
    "class15": {
      "code": "220021",
      "name": "伊豆北",
      "enName": "Northern Izu"
    },
    "class20": {
      "code": "2220800",
      "name": "伊東市",
      "enName": "Ito City",
      "kana": "いとうし",
      "chName": "伊东市",
      "zhName": "伊東市",
      "koName": "이토시",
      "esName": "Ciudad de Ito",
      "ptName": "cidade de Ito",
      "thName": "เมืองอิโตะ",
      "viName": "thành phố Ito",
      "inName": "kota Ito",
      "tlName": "siyudad ng Ito",
      "moName": "Ито хот",
      "buName": "အီတို မြို့",
      "khName": "ទីក្រុង អ៊ីតុ",
      "neName": "इतो सहर"
    }
  },
  "2220900": {
    "office": {
      "code": "220000",
      "name": "静岡県",
      "enName": "Shizuoka",
      "officeName": "静岡地方気象台",
      "chName": "静冈县",
      "zhName": "靜岡縣",
      "koName": "시즈오카현",
      "esName": "Prefectura de Shizuoka",
      "ptName": "Província de Shizuoka",
      "thName": "จังหวัดชิซุโอกะ",
      "viName": "Tỉnh Shizuoka",
      "inName": "Prefektur Shizuoka",
      "tlName": "Shizuoka Prefecture",
      "moName": "Шизүока аймаг",
      "buName": "ရှီဇူးအိုက ပြည်နယ်",
      "khName": "ខេត្ដ ហ្ស៊ីស៊ូកា",
      "neName": "सिजुओका जिल्ला"
    },
    "class10": {
      "code": "220010",
      "name": "中部",
      "enName": "Central Region",
      "chName": "静冈县中部",
      "zhName": "靜岡縣中部",
      "koName": "시즈오카 현 중부",
      "esName": "Centro de Prefectura de Shizuoka",
      "ptName": "Região central da Província de Shizuoka",
      "thName": "จังหวัดชิซุโอกะตอนกลาง",
      "viName": "Miền Trung tỉnh Shizuoka",
      "inName": "Bagian Tengah Prefektur Shizuoka",
      "tlName": "Sentral na bahagi ng Shizuoka Prefecture",
      "moName": "Төв Шизүока аймаг",
      "buName": "ရှိဇုအိုကစီရင်စု အလယ်ပိုင်း",
      "khName": "តំបន់កណ្តាលនៃខេត្ដស៊ីស្ស៊ឹអុកា",
      "neName": "सिजुओका जिल्लाको मध्य भाग"
    },
    "class15": {
      "code": "220011",
      "name": "中部南",
      "enName": "Southern Central Region"
    },
    "class20": {
      "code": "2220900",
      "name": "島田市",
      "enName": "Shimada City",
      "kana": "しまだし",
      "chName": "岛田市",
      "zhName": "島田市",
      "koName": "시마다 시",
      "esName": "Ciudad de Shimada",
      "ptName": "cidade de Shimada",
      "thName": "เมืองชิมะดะ",
      "viName": "thành phố Shimada",
      "inName": "kota Shimada",
      "tlName": "siyudad ng Shimada",
      "moName": "Шимaда хот",
      "buName": "ရှီမားဒ မြို့",
      "khName": "ទីក្រុង ស៊ីម៉ាដា",
      "neName": "शिमादा सहर"
    }
  },
  "2221000": {
    "office": {
      "code": "220000",
      "name": "静岡県",
      "enName": "Shizuoka",
      "officeName": "静岡地方気象台",
      "chName": "静冈县",
      "zhName": "靜岡縣",
      "koName": "시즈오카현",
      "esName": "Prefectura de Shizuoka",
      "ptName": "Província de Shizuoka",
      "thName": "จังหวัดชิซุโอกะ",
      "viName": "Tỉnh Shizuoka",
      "inName": "Prefektur Shizuoka",
      "tlName": "Shizuoka Prefecture",
      "moName": "Шизүока аймаг",
      "buName": "ရှီဇူးအိုက ပြည်နယ်",
      "khName": "ខេត្ដ ហ្ស៊ីស៊ូកា",
      "neName": "सिजुओका जिल्ला"
    },
    "class10": {
      "code": "220030",
      "name": "東部",
      "enName": "Eastern Region",
      "chName": "静冈县东部",
      "zhName": "靜岡縣東部",
      "koName": "시즈오카 현 동부",
      "esName": "Este de Prefectura de Shizuoka",
      "ptName": "Região Leste da Província de Shizuoka",
      "thName": "จังหวัดชิซุโอกะฟากตะวันออก",
      "viName": "Miền Đông tỉnh Shizuoka",
      "inName": "Bagian Timur Prefektur Shizuoka",
      "tlName": "Silangang bahagi ng Shizuoka Prefecture",
      "moName": "Зүүн Шизүока аймаг",
      "buName": "ရှိဇုအိုကစီရင်စု အရှေ့ပိုင်း",
      "khName": "តំបន់ខាងកើតនៃខេត្ដស៊ីស្ស៊ឹអុកា",
      "neName": "सिजुओका जिल्लाको पूर्वी भाग"
    },
    "class15": {
      "code": "220032",
      "name": "富士山南西",
      "enName": "South-western Mt. Fuji"
    },
    "class20": {
      "code": "2221000",
      "name": "富士市",
      "enName": "Fuji City",
      "kana": "ふじし",
      "chName": "富士市",
      "zhName": "富士市",
      "koName": "후지 시",
      "esName": "Ciudad de Fuji",
      "ptName": "cidade de Fuji",
      "thName": "เมืองฟุจิ",
      "viName": "thành phố Fuji",
      "inName": "kota Fuji",
      "tlName": "siyudad ng Fuji",
      "moName": "Фүжи хот",
      "buName": "ဖူဂျီ မြို့",
      "khName": "ទីក្រុង ហ្វូជី",
      "neName": "फुजी सहर"
    }
  },
  "2221100": {
    "office": {
      "code": "220000",
      "name": "静岡県",
      "enName": "Shizuoka",
      "officeName": "静岡地方気象台",
      "chName": "静冈县",
      "zhName": "靜岡縣",
      "koName": "시즈오카현",
      "esName": "Prefectura de Shizuoka",
      "ptName": "Província de Shizuoka",
      "thName": "จังหวัดชิซุโอกะ",
      "viName": "Tỉnh Shizuoka",
      "inName": "Prefektur Shizuoka",
      "tlName": "Shizuoka Prefecture",
      "moName": "Шизүока аймаг",
      "buName": "ရှီဇူးအိုက ပြည်နယ်",
      "khName": "ខេត្ដ ហ្ស៊ីស៊ូកា",
      "neName": "सिजुओका जिल्ला"
    },
    "class10": {
      "code": "220040",
      "name": "西部",
      "enName": "Western Region",
      "chName": "静冈县西部",
      "zhName": "靜岡縣西部",
      "koName": "시즈오카 현 서부",
      "esName": "Oeste de Prefectura de Shizuoka",
      "ptName": "Região Oeste da Província de Shizuoka",
      "thName": "จังหวัดชิซุโอกะฟากตะวันตก",
      "viName": "Miền Tây tỉnh Shizuoka",
      "inName": "Bagian Barat Prefektur Shizuoka",
      "tlName": "Kanlurang bahagi ng Shizuoka Prefecture",
      "moName": "Баруун Шизүока аймаг",
      "buName": "ရှိဇုအိုကစီရင်စု အနောက်ပိုင်း",
      "khName": "តំបន់ខាងលិចនៃខេត្ដស៊ីស្ស៊ឹអុកា",
      "neName": "सिजुओका जिल्लाको पश्चिमी भाग"
    },
    "class15": {
      "code": "220042",
      "name": "遠州南",
      "enName": "Southern Enshu"
    },
    "class20": {
      "code": "2221100",
      "name": "磐田市",
      "enName": "Iwata City",
      "kana": "いわたし",
      "chName": "磐田市",
      "zhName": "磐田市",
      "koName": "이와타 시",
      "esName": "Ciudad de Iwata",
      "ptName": "cidade de Iwata",
      "thName": "เมืองอิวาตะ",
      "viName": "thành phố Iwata",
      "inName": "kota Iwata",
      "tlName": "siyudad ng Iwata",
      "moName": "Ивата хот",
      "buName": "အီဝါ့တ မြို့",
      "khName": "ទីក្រុង អ៊ីវ៉ាតា",
      "neName": "इवाता सहर"
    }
  },
  "2221200": {
    "office": {
      "code": "220000",
      "name": "静岡県",
      "enName": "Shizuoka",
      "officeName": "静岡地方気象台",
      "chName": "静冈县",
      "zhName": "靜岡縣",
      "koName": "시즈오카현",
      "esName": "Prefectura de Shizuoka",
      "ptName": "Província de Shizuoka",
      "thName": "จังหวัดชิซุโอกะ",
      "viName": "Tỉnh Shizuoka",
      "inName": "Prefektur Shizuoka",
      "tlName": "Shizuoka Prefecture",
      "moName": "Шизүока аймаг",
      "buName": "ရှီဇူးအိုက ပြည်နယ်",
      "khName": "ខេត្ដ ហ្ស៊ីស៊ូកា",
      "neName": "सिजुओका जिल्ला"
    },
    "class10": {
      "code": "220010",
      "name": "中部",
      "enName": "Central Region",
      "chName": "静冈县中部",
      "zhName": "靜岡縣中部",
      "koName": "시즈오카 현 중부",
      "esName": "Centro de Prefectura de Shizuoka",
      "ptName": "Região central da Província de Shizuoka",
      "thName": "จังหวัดชิซุโอกะตอนกลาง",
      "viName": "Miền Trung tỉnh Shizuoka",
      "inName": "Bagian Tengah Prefektur Shizuoka",
      "tlName": "Sentral na bahagi ng Shizuoka Prefecture",
      "moName": "Төв Шизүока аймаг",
      "buName": "ရှိဇုအိုကစီရင်စု အလယ်ပိုင်း",
      "khName": "តំបន់កណ្តាលនៃខេត្ដស៊ីស្ស៊ឹអុកា",
      "neName": "सिजुओका जिल्लाको मध्य भाग"
    },
    "class15": {
      "code": "220011",
      "name": "中部南",
      "enName": "Southern Central Region"
    },
    "class20": {
      "code": "2221200",
      "name": "焼津市",
      "enName": "Yaizu City",
      "kana": "やいづし",
      "chName": "烧津市",
      "zhName": "燒津市",
      "koName": "야이즈 시",
      "esName": "Ciudad de Yaizu",
      "ptName": "cidade de Yaizu",
      "thName": "เมืองยาซุ",
      "viName": "thành phố Yaizu",
      "inName": "kota Yaizu",
      "tlName": "siyudad ng Yaizu",
      "moName": "Яйзү хот",
      "buName": "ယာအိဇု မြို့",
      "khName": "ទីក្រុង យ៉ាយស៊ូ",
      "neName": "याइजु सहर"
    }
  },
  "2221300": {
    "office": {
      "code": "220000",
      "name": "静岡県",
      "enName": "Shizuoka",
      "officeName": "静岡地方気象台",
      "chName": "静冈县",
      "zhName": "靜岡縣",
      "koName": "시즈오카현",
      "esName": "Prefectura de Shizuoka",
      "ptName": "Província de Shizuoka",
      "thName": "จังหวัดชิซุโอกะ",
      "viName": "Tỉnh Shizuoka",
      "inName": "Prefektur Shizuoka",
      "tlName": "Shizuoka Prefecture",
      "moName": "Шизүока аймаг",
      "buName": "ရှီဇူးအိုက ပြည်နယ်",
      "khName": "ខេត្ដ ហ្ស៊ីស៊ូកា",
      "neName": "सिजुओका जिल्ला"
    },
    "class10": {
      "code": "220040",
      "name": "西部",
      "enName": "Western Region",
      "chName": "静冈县西部",
      "zhName": "靜岡縣西部",
      "koName": "시즈오카 현 서부",
      "esName": "Oeste de Prefectura de Shizuoka",
      "ptName": "Região Oeste da Província de Shizuoka",
      "thName": "จังหวัดชิซุโอกะฟากตะวันตก",
      "viName": "Miền Tây tỉnh Shizuoka",
      "inName": "Bagian Barat Prefektur Shizuoka",
      "tlName": "Kanlurang bahagi ng Shizuoka Prefecture",
      "moName": "Баруун Шизүока аймаг",
      "buName": "ရှိဇုအိုကစီရင်စု အနောက်ပိုင်း",
      "khName": "តំបន់ខាងលិចនៃខេត្ដស៊ីស្ស៊ឹអុកា",
      "neName": "सिजुओका जिल्लाको पश्चिमी भाग"
    },
    "class15": {
      "code": "220042",
      "name": "遠州南",
      "enName": "Southern Enshu"
    },
    "class20": {
      "code": "2221300",
      "name": "掛川市",
      "enName": "Kakegawa City",
      "kana": "かけがわし",
      "chName": "挂川市",
      "zhName": "掛川市",
      "koName": "가케가와 시",
      "esName": "Ciudad de Kakegawa",
      "ptName": "cidade de Kakegawa",
      "thName": "เมืองคาเคกาวา",
      "viName": "thành phố Kakegawa",
      "inName": "kota Kakegawa",
      "tlName": "siyudad ng Kakegawa",
      "moName": "Какэгава хот",
      "buName": "ခါကေးဂါ့ဝ မြို့",
      "khName": "ទីក្រុង កាកេហ្គាវ៉ា",
      "neName": "काकेगावा सहर"
    }
  },
  "2221400": {
    "office": {
      "code": "220000",
      "name": "静岡県",
      "enName": "Shizuoka",
      "officeName": "静岡地方気象台",
      "chName": "静冈县",
      "zhName": "靜岡縣",
      "koName": "시즈오카현",
      "esName": "Prefectura de Shizuoka",
      "ptName": "Província de Shizuoka",
      "thName": "จังหวัดชิซุโอกะ",
      "viName": "Tỉnh Shizuoka",
      "inName": "Prefektur Shizuoka",
      "tlName": "Shizuoka Prefecture",
      "moName": "Шизүока аймаг",
      "buName": "ရှီဇူးအိုက ပြည်နယ်",
      "khName": "ខេត្ដ ហ្ស៊ីស៊ូកា",
      "neName": "सिजुओका जिल्ला"
    },
    "class10": {
      "code": "220010",
      "name": "中部",
      "enName": "Central Region",
      "chName": "静冈县中部",
      "zhName": "靜岡縣中部",
      "koName": "시즈오카 현 중부",
      "esName": "Centro de Prefectura de Shizuoka",
      "ptName": "Região central da Província de Shizuoka",
      "thName": "จังหวัดชิซุโอกะตอนกลาง",
      "viName": "Miền Trung tỉnh Shizuoka",
      "inName": "Bagian Tengah Prefektur Shizuoka",
      "tlName": "Sentral na bahagi ng Shizuoka Prefecture",
      "moName": "Төв Шизүока аймаг",
      "buName": "ရှိဇုအိုကစီရင်စု အလယ်ပိုင်း",
      "khName": "តំបន់កណ្តាលនៃខេត្ដស៊ីស្ស៊ឹអុកា",
      "neName": "सिजुओका जिल्लाको मध्य भाग"
    },
    "class15": {
      "code": "220011",
      "name": "中部南",
      "enName": "Southern Central Region"
    },
    "class20": {
      "code": "2221400",
      "name": "藤枝市",
      "enName": "Fujieda City",
      "kana": "ふじえだし",
      "chName": "藤枝市",
      "zhName": "藤枝市",
      "koName": "후지에다 시",
      "esName": "Ciudad de Fujieda",
      "ptName": "cidade de Fujieda",
      "thName": "เมืองฟุจิเอดะ",
      "viName": "thành phố Fujieda",
      "inName": "kota Fujieda",
      "tlName": "siyudad ng Fujieda",
      "moName": "Фүжиэда хот",
      "buName": "ဟူဂျိယဲ့ဒ မြို့",
      "khName": "ទីក្រុង ហ្វូជីអ៊ីដា",
      "neName": "फुजिएदा सहर"
    }
  },
  "2221500": {
    "office": {
      "code": "220000",
      "name": "静岡県",
      "enName": "Shizuoka",
      "officeName": "静岡地方気象台",
      "chName": "静冈县",
      "zhName": "靜岡縣",
      "koName": "시즈오카현",
      "esName": "Prefectura de Shizuoka",
      "ptName": "Província de Shizuoka",
      "thName": "จังหวัดชิซุโอกะ",
      "viName": "Tỉnh Shizuoka",
      "inName": "Prefektur Shizuoka",
      "tlName": "Shizuoka Prefecture",
      "moName": "Шизүока аймаг",
      "buName": "ရှီဇူးအိုက ပြည်နယ်",
      "khName": "ខេត្ដ ហ្ស៊ីស៊ូកា",
      "neName": "सिजुओका जिल्ला"
    },
    "class10": {
      "code": "220030",
      "name": "東部",
      "enName": "Eastern Region",
      "chName": "静冈县东部",
      "zhName": "靜岡縣東部",
      "koName": "시즈오카 현 동부",
      "esName": "Este de Prefectura de Shizuoka",
      "ptName": "Região Leste da Província de Shizuoka",
      "thName": "จังหวัดชิซุโอกะฟากตะวันออก",
      "viName": "Miền Đông tỉnh Shizuoka",
      "inName": "Bagian Timur Prefektur Shizuoka",
      "tlName": "Silangang bahagi ng Shizuoka Prefecture",
      "moName": "Зүүн Шизүока аймаг",
      "buName": "ရှိဇုအိုကစီရင်စု အရှေ့ပိုင်း",
      "khName": "តំបន់ខាងកើតនៃខេត្ដស៊ីស្ស៊ឹអុកា",
      "neName": "सिजुओका जिल्लाको पूर्वी भाग"
    },
    "class15": {
      "code": "220031",
      "name": "富士山南東",
      "enName": "South-eastern Mt. Fuji"
    },
    "class20": {
      "code": "2221500",
      "name": "御殿場市",
      "enName": "Gotemba City",
      "kana": "ごてんばし",
      "chName": "御殿场市",
      "zhName": "御殿場市",
      "koName": "고텐바 시",
      "esName": "Ciudad de Gotenba",
      "ptName": "cidade de Gotemba",
      "thName": "เมืองโกเต็มบะ",
      "viName": "thành phố Gotemba",
      "inName": "kota Gotemba",
      "tlName": "siyudad ng Gotemba",
      "moName": "Готэмба хот",
      "buName": "ဂိုတင်းဘ မြို့",
      "khName": "ទីក្រុង ហ្កូតេមបា",
      "neName": "गोतेम्बा सहर"
    }
  },
  "2221600": {
    "office": {
      "code": "220000",
      "name": "静岡県",
      "enName": "Shizuoka",
      "officeName": "静岡地方気象台",
      "chName": "静冈县",
      "zhName": "靜岡縣",
      "koName": "시즈오카현",
      "esName": "Prefectura de Shizuoka",
      "ptName": "Província de Shizuoka",
      "thName": "จังหวัดชิซุโอกะ",
      "viName": "Tỉnh Shizuoka",
      "inName": "Prefektur Shizuoka",
      "tlName": "Shizuoka Prefecture",
      "moName": "Шизүока аймаг",
      "buName": "ရှီဇူးအိုက ပြည်နယ်",
      "khName": "ខេត្ដ ហ្ស៊ីស៊ូកា",
      "neName": "सिजुओका जिल्ला"
    },
    "class10": {
      "code": "220040",
      "name": "西部",
      "enName": "Western Region",
      "chName": "静冈县西部",
      "zhName": "靜岡縣西部",
      "koName": "시즈오카 현 서부",
      "esName": "Oeste de Prefectura de Shizuoka",
      "ptName": "Região Oeste da Província de Shizuoka",
      "thName": "จังหวัดชิซุโอกะฟากตะวันตก",
      "viName": "Miền Tây tỉnh Shizuoka",
      "inName": "Bagian Barat Prefektur Shizuoka",
      "tlName": "Kanlurang bahagi ng Shizuoka Prefecture",
      "moName": "Баруун Шизүока аймаг",
      "buName": "ရှိဇုအိုကစီရင်စု အနောက်ပိုင်း",
      "khName": "តំបន់ខាងលិចនៃខេត្ដស៊ីស្ស៊ឹអុកា",
      "neName": "सिजुओका जिल्लाको पश्चिमी भाग"
    },
    "class15": {
      "code": "220042",
      "name": "遠州南",
      "enName": "Southern Enshu"
    },
    "class20": {
      "code": "2221600",
      "name": "袋井市",
      "enName": "Fukuroi City",
      "kana": "ふくろいし",
      "chName": "袋井市",
      "zhName": "袋井市",
      "koName": "후쿠로이 시",
      "esName": "Ciudad de Fukuroi",
      "ptName": "cidade de Fukuroi",
      "thName": "เมืองฟุคุโรอิ",
      "viName": "thành phố Fukuroi",
      "inName": "kota Fukuroi",
      "tlName": "siyudad ng Fukuroi",
      "moName": "Фүкүрой хот",
      "buName": "ဖူကုရို့ယိ မြို့",
      "khName": "ទីក្រុង ហ្វូគូរ៉យ",
      "neName": "फुकुरोई सहर"
    }
  },
  "2221900": {
    "office": {
      "code": "220000",
      "name": "静岡県",
      "enName": "Shizuoka",
      "officeName": "静岡地方気象台",
      "chName": "静冈县",
      "zhName": "靜岡縣",
      "koName": "시즈오카현",
      "esName": "Prefectura de Shizuoka",
      "ptName": "Província de Shizuoka",
      "thName": "จังหวัดชิซุโอกะ",
      "viName": "Tỉnh Shizuoka",
      "inName": "Prefektur Shizuoka",
      "tlName": "Shizuoka Prefecture",
      "moName": "Шизүока аймаг",
      "buName": "ရှီဇူးအိုက ပြည်နယ်",
      "khName": "ខេត្ដ ហ្ស៊ីស៊ូកា",
      "neName": "सिजुओका जिल्ला"
    },
    "class10": {
      "code": "220020",
      "name": "伊豆",
      "enName": "Izu",
      "chName": "静冈县伊豆地方",
      "zhName": "静岡縣伊豆地方",
      "koName": "시즈오카 현 이즈 지방",
      "esName": "Región Izu, Prefectura de Shizuoka",
      "ptName": "Região de Izu da Província de Shizuoka",
      "thName": "ท้องถิ่นอิซุ จังหวัดชิซุโอกะ",
      "viName": "Vùng Izu tỉnh Shizuoka",
      "inName": "Daerah Izu di Prefektur Shizuoka",
      "tlName": "Rehiyon ng Izu sa Shizuoka Prefecture",
      "moName": "Шизүока аймаг, Изү",
      "buName": "အိဇု၊ ရှိဇုအိုကစီရင်စု",
      "khName": "តំបន់អ៊ីហ៊្សូនៃខេត្ដស៊ីស្ស៊ឹអុកា",
      "neName": "सिजुओका जिल्ला, इजु क्षेत्र"
    },
    "class15": {
      "code": "220022",
      "name": "伊豆南",
      "enName": "Southern Izu"
    },
    "class20": {
      "code": "2221900",
      "name": "下田市",
      "enName": "Shimoda City",
      "kana": "しもだし",
      "chName": "下田市",
      "zhName": "下田市",
      "koName": "시모다 시",
      "esName": "Ciudad de Shimoda",
      "ptName": "cidade de Shimoda",
      "thName": "เมืองชิโมดะ",
      "viName": "thành phố Shimoda",
      "inName": "kota Shimoda",
      "tlName": "siyudad ng Shimoda",
      "moName": "Шимода хот",
      "buName": "ရှီမိုးဒ မြို့",
      "khName": " ទីក្រុង ស៊ីម៉ូដា",
      "neName": "शिमोदा सहर"
    }
  },
  "2222000": {
    "office": {
      "code": "220000",
      "name": "静岡県",
      "enName": "Shizuoka",
      "officeName": "静岡地方気象台",
      "chName": "静冈县",
      "zhName": "靜岡縣",
      "koName": "시즈오카현",
      "esName": "Prefectura de Shizuoka",
      "ptName": "Província de Shizuoka",
      "thName": "จังหวัดชิซุโอกะ",
      "viName": "Tỉnh Shizuoka",
      "inName": "Prefektur Shizuoka",
      "tlName": "Shizuoka Prefecture",
      "moName": "Шизүока аймаг",
      "buName": "ရှီဇူးအိုက ပြည်နယ်",
      "khName": "ខេត្ដ ហ្ស៊ីស៊ូកា",
      "neName": "सिजुओका जिल्ला"
    },
    "class10": {
      "code": "220030",
      "name": "東部",
      "enName": "Eastern Region",
      "chName": "静冈县东部",
      "zhName": "靜岡縣東部",
      "koName": "시즈오카 현 동부",
      "esName": "Este de Prefectura de Shizuoka",
      "ptName": "Região Leste da Província de Shizuoka",
      "thName": "จังหวัดชิซุโอกะฟากตะวันออก",
      "viName": "Miền Đông tỉnh Shizuoka",
      "inName": "Bagian Timur Prefektur Shizuoka",
      "tlName": "Silangang bahagi ng Shizuoka Prefecture",
      "moName": "Зүүн Шизүока аймаг",
      "buName": "ရှိဇုအိုကစီရင်စု အရှေ့ပိုင်း",
      "khName": "តំបន់ខាងកើតនៃខេត្ដស៊ីស្ស៊ឹអុកា",
      "neName": "सिजुओका जिल्लाको पूर्वी भाग"
    },
    "class15": {
      "code": "220031",
      "name": "富士山南東",
      "enName": "South-eastern Mt. Fuji"
    },
    "class20": {
      "code": "2222000",
      "name": "裾野市",
      "enName": "Susono City",
      "kana": "すそのし",
      "chName": "裾野市",
      "zhName": "裾野市",
      "koName": "스소노 시",
      "esName": "Ciudad de Susono",
      "ptName": "cidade de Susono",
      "thName": "เมืองซุโซโนะ",
      "viName": "thành phố Susono",
      "inName": "kota Susono",
      "tlName": "siyudad ng Susono",
      "moName": "Сүсоно хот",
      "buName": "ဆူဆိုနို မြို့",
      "khName": "ទីក្រុង ស៊ូសូណូ",
      "neName": "सुसोनो सहर"
    }
  },
  "2222100": {
    "office": {
      "code": "220000",
      "name": "静岡県",
      "enName": "Shizuoka",
      "officeName": "静岡地方気象台",
      "chName": "静冈县",
      "zhName": "靜岡縣",
      "koName": "시즈오카현",
      "esName": "Prefectura de Shizuoka",
      "ptName": "Província de Shizuoka",
      "thName": "จังหวัดชิซุโอกะ",
      "viName": "Tỉnh Shizuoka",
      "inName": "Prefektur Shizuoka",
      "tlName": "Shizuoka Prefecture",
      "moName": "Шизүока аймаг",
      "buName": "ရှီဇူးအိုက ပြည်နယ်",
      "khName": "ខេត្ដ ហ្ស៊ីស៊ូកា",
      "neName": "सिजुओका जिल्ला"
    },
    "class10": {
      "code": "220040",
      "name": "西部",
      "enName": "Western Region",
      "chName": "静冈县西部",
      "zhName": "靜岡縣西部",
      "koName": "시즈오카 현 서부",
      "esName": "Oeste de Prefectura de Shizuoka",
      "ptName": "Região Oeste da Província de Shizuoka",
      "thName": "จังหวัดชิซุโอกะฟากตะวันตก",
      "viName": "Miền Tây tỉnh Shizuoka",
      "inName": "Bagian Barat Prefektur Shizuoka",
      "tlName": "Kanlurang bahagi ng Shizuoka Prefecture",
      "moName": "Баруун Шизүока аймаг",
      "buName": "ရှိဇုအိုကစီရင်စု အနောက်ပိုင်း",
      "khName": "តំបន់ខាងលិចនៃខេត្ដស៊ីស្ស៊ឹអុកា",
      "neName": "सिजुओका जिल्लाको पश्चिमी भाग"
    },
    "class15": {
      "code": "220042",
      "name": "遠州南",
      "enName": "Southern Enshu"
    },
    "class20": {
      "code": "2222100",
      "name": "湖西市",
      "enName": "Kosai City",
      "kana": "こさいし",
      "chName": "湖西市",
      "zhName": "湖西市",
      "koName": "고사이 시",
      "esName": "Ciudad de Kosei",
      "ptName": "cidade de Kosai",
      "thName": "เมืองโคไซ",
      "viName": "thành phố Kosai",
      "inName": "kota Kosai",
      "tlName": "siyudad ng Kosai",
      "moName": "Косaй хот",
      "buName": "ကိုဆာယိ မြို့",
      "khName": "ទីក្រុង កូសៃ",
      "neName": "कोसाई सहर"
    }
  },
  "2222200": {
    "office": {
      "code": "220000",
      "name": "静岡県",
      "enName": "Shizuoka",
      "officeName": "静岡地方気象台",
      "chName": "静冈县",
      "zhName": "靜岡縣",
      "koName": "시즈오카현",
      "esName": "Prefectura de Shizuoka",
      "ptName": "Província de Shizuoka",
      "thName": "จังหวัดชิซุโอกะ",
      "viName": "Tỉnh Shizuoka",
      "inName": "Prefektur Shizuoka",
      "tlName": "Shizuoka Prefecture",
      "moName": "Шизүока аймаг",
      "buName": "ရှီဇူးအိုက ပြည်နယ်",
      "khName": "ខេត្ដ ហ្ស៊ីស៊ូកា",
      "neName": "सिजुओका जिल्ला"
    },
    "class10": {
      "code": "220020",
      "name": "伊豆",
      "enName": "Izu",
      "chName": "静冈县伊豆地方",
      "zhName": "静岡縣伊豆地方",
      "koName": "시즈오카 현 이즈 지방",
      "esName": "Región Izu, Prefectura de Shizuoka",
      "ptName": "Região de Izu da Província de Shizuoka",
      "thName": "ท้องถิ่นอิซุ จังหวัดชิซุโอกะ",
      "viName": "Vùng Izu tỉnh Shizuoka",
      "inName": "Daerah Izu di Prefektur Shizuoka",
      "tlName": "Rehiyon ng Izu sa Shizuoka Prefecture",
      "moName": "Шизүока аймаг, Изү",
      "buName": "အိဇု၊ ရှိဇုအိုကစီရင်စု",
      "khName": "តំបន់អ៊ីហ៊្សូនៃខេត្ដស៊ីស្ស៊ឹអុកា",
      "neName": "सिजुओका जिल्ला, इजु क्षेत्र"
    },
    "class15": {
      "code": "220021",
      "name": "伊豆北",
      "enName": "Northern Izu"
    },
    "class20": {
      "code": "2222200",
      "name": "伊豆市",
      "enName": "Izu City",
      "kana": "いずし",
      "chName": "伊豆市",
      "zhName": "伊豆市",
      "koName": "이즈 시",
      "esName": "Ciudad de Izu",
      "ptName": "cidade de Izu",
      "thName": "เมืองอิซุ",
      "viName": "thành phố Izu",
      "inName": "kota Izu",
      "tlName": "siyudad ng Izu",
      "moName": "Изү хот",
      "buName": "အီဇု မြို့",
      "khName": "ទីក្រុង អ៊ីហ្សូ៊",
      "neName": "इजु सहर"
    }
  },
  "2222300": {
    "office": {
      "code": "220000",
      "name": "静岡県",
      "enName": "Shizuoka",
      "officeName": "静岡地方気象台",
      "chName": "静冈县",
      "zhName": "靜岡縣",
      "koName": "시즈오카현",
      "esName": "Prefectura de Shizuoka",
      "ptName": "Província de Shizuoka",
      "thName": "จังหวัดชิซุโอกะ",
      "viName": "Tỉnh Shizuoka",
      "inName": "Prefektur Shizuoka",
      "tlName": "Shizuoka Prefecture",
      "moName": "Шизүока аймаг",
      "buName": "ရှီဇူးအိုက ပြည်နယ်",
      "khName": "ខេត្ដ ហ្ស៊ីស៊ូកា",
      "neName": "सिजुओका जिल्ला"
    },
    "class10": {
      "code": "220040",
      "name": "西部",
      "enName": "Western Region",
      "chName": "静冈县西部",
      "zhName": "靜岡縣西部",
      "koName": "시즈오카 현 서부",
      "esName": "Oeste de Prefectura de Shizuoka",
      "ptName": "Região Oeste da Província de Shizuoka",
      "thName": "จังหวัดชิซุโอกะฟากตะวันตก",
      "viName": "Miền Tây tỉnh Shizuoka",
      "inName": "Bagian Barat Prefektur Shizuoka",
      "tlName": "Kanlurang bahagi ng Shizuoka Prefecture",
      "moName": "Баруун Шизүока аймаг",
      "buName": "ရှိဇုအိုကစီရင်စု အနောက်ပိုင်း",
      "khName": "តំបន់ខាងលិចនៃខេត្ដស៊ីស្ស៊ឹអុកា",
      "neName": "सिजुओका जिल्लाको पश्चिमी भाग"
    },
    "class15": {
      "code": "220042",
      "name": "遠州南",
      "enName": "Southern Enshu"
    },
    "class20": {
      "code": "2222300",
      "name": "御前崎市",
      "enName": "Omaezaki City",
      "kana": "おまえざきし",
      "chName": "御前崎市",
      "zhName": "御前崎市",
      "koName": "오마에자키 시",
      "esName": "Ciudad de Omaezaki",
      "ptName": "cidade de Omaezaki",
      "thName": "เมืองโอมาเอะซากิ",
      "viName": "thành phố Omaezaki",
      "inName": "kota Omaezaki",
      "tlName": "siyudad ng Omaezaki",
      "moName": "Омaэзaки хот",
      "buName": "အိုမားယဲဇာ့ကိ မြို့",
      "khName": "ទីក្រុង អូម៉ាហ្សាគី",
      "neName": "ओमाएजाकी सहर"
    }
  },
  "2222400": {
    "office": {
      "code": "220000",
      "name": "静岡県",
      "enName": "Shizuoka",
      "officeName": "静岡地方気象台",
      "chName": "静冈县",
      "zhName": "靜岡縣",
      "koName": "시즈오카현",
      "esName": "Prefectura de Shizuoka",
      "ptName": "Província de Shizuoka",
      "thName": "จังหวัดชิซุโอกะ",
      "viName": "Tỉnh Shizuoka",
      "inName": "Prefektur Shizuoka",
      "tlName": "Shizuoka Prefecture",
      "moName": "Шизүока аймаг",
      "buName": "ရှီဇူးအိုက ပြည်နယ်",
      "khName": "ខេត្ដ ហ្ស៊ីស៊ូកា",
      "neName": "सिजुओका जिल्ला"
    },
    "class10": {
      "code": "220040",
      "name": "西部",
      "enName": "Western Region",
      "chName": "静冈县西部",
      "zhName": "靜岡縣西部",
      "koName": "시즈오카 현 서부",
      "esName": "Oeste de Prefectura de Shizuoka",
      "ptName": "Região Oeste da Província de Shizuoka",
      "thName": "จังหวัดชิซุโอกะฟากตะวันตก",
      "viName": "Miền Tây tỉnh Shizuoka",
      "inName": "Bagian Barat Prefektur Shizuoka",
      "tlName": "Kanlurang bahagi ng Shizuoka Prefecture",
      "moName": "Баруун Шизүока аймаг",
      "buName": "ရှိဇုအိုကစီရင်စု အနောက်ပိုင်း",
      "khName": "តំបន់ខាងលិចនៃខេត្ដស៊ីស្ស៊ឹអុកា",
      "neName": "सिजुओका जिल्लाको पश्चिमी भाग"
    },
    "class15": {
      "code": "220042",
      "name": "遠州南",
      "enName": "Southern Enshu"
    },
    "class20": {
      "code": "2222400",
      "name": "菊川市",
      "enName": "Kikugawa City",
      "kana": "きくがわし",
      "chName": "菊川市",
      "zhName": "菊川市",
      "koName": "기쿠가와 시",
      "esName": "Ciudad de Kikugawa",
      "ptName": "cidade de Kikugawa",
      "thName": "เมืองคิคุกาวา",
      "viName": "thành phố Kikugawa",
      "inName": "kota Kikugawa",
      "tlName": "siyudad ng Kikugawa",
      "moName": "Кикүгава хот",
      "buName": "ခီကုဂါ့ဝ မြို့",
      "khName": "ទីក្រុង គីគុហ្គាវ៉ា",
      "neName": "किकुगावा सहर"
    }
  },
  "2222500": {
    "office": {
      "code": "220000",
      "name": "静岡県",
      "enName": "Shizuoka",
      "officeName": "静岡地方気象台",
      "chName": "静冈县",
      "zhName": "靜岡縣",
      "koName": "시즈오카현",
      "esName": "Prefectura de Shizuoka",
      "ptName": "Província de Shizuoka",
      "thName": "จังหวัดชิซุโอกะ",
      "viName": "Tỉnh Shizuoka",
      "inName": "Prefektur Shizuoka",
      "tlName": "Shizuoka Prefecture",
      "moName": "Шизүока аймаг",
      "buName": "ရှီဇူးအိုက ပြည်နယ်",
      "khName": "ខេត្ដ ហ្ស៊ីស៊ូកា",
      "neName": "सिजुओका जिल्ला"
    },
    "class10": {
      "code": "220020",
      "name": "伊豆",
      "enName": "Izu",
      "chName": "静冈县伊豆地方",
      "zhName": "静岡縣伊豆地方",
      "koName": "시즈오카 현 이즈 지방",
      "esName": "Región Izu, Prefectura de Shizuoka",
      "ptName": "Região de Izu da Província de Shizuoka",
      "thName": "ท้องถิ่นอิซุ จังหวัดชิซุโอกะ",
      "viName": "Vùng Izu tỉnh Shizuoka",
      "inName": "Daerah Izu di Prefektur Shizuoka",
      "tlName": "Rehiyon ng Izu sa Shizuoka Prefecture",
      "moName": "Шизүока аймаг, Изү",
      "buName": "အိဇု၊ ရှိဇုအိုကစီရင်စု",
      "khName": "តំបន់អ៊ីហ៊្សូនៃខេត្ដស៊ីស្ស៊ឹអុកា",
      "neName": "सिजुओका जिल्ला, इजु क्षेत्र"
    },
    "class15": {
      "code": "220021",
      "name": "伊豆北",
      "enName": "Northern Izu"
    },
    "class20": {
      "code": "2222500",
      "name": "伊豆の国市",
      "enName": "Izunokuni City",
      "kana": "いずのくにし",
      "chName": "伊豆之国市",
      "zhName": "伊豆之國市",
      "koName": "이즈노쿠니 시",
      "esName": "Ciudad de Izunokuni",
      "ptName": "cidade de Izunokuni",
      "thName": "เมืองอิซุโนะคุนิ",
      "viName": "thành phố Izunokuni",
      "inName": "kota Izunokuni",
      "tlName": "siyudad ng Izunokuni",
      "moName": "Изүнокүни хот",
      "buName": "အီဇုနိုကူနိ မြို့",
      "khName": "ទីក្រុង អ៊ីហ្សុណូគុនី",
      "neName": "इजुनोकुनी सहर"
    }
  },
  "2222600": {
    "office": {
      "code": "220000",
      "name": "静岡県",
      "enName": "Shizuoka",
      "officeName": "静岡地方気象台",
      "chName": "静冈县",
      "zhName": "靜岡縣",
      "koName": "시즈오카현",
      "esName": "Prefectura de Shizuoka",
      "ptName": "Província de Shizuoka",
      "thName": "จังหวัดชิซุโอกะ",
      "viName": "Tỉnh Shizuoka",
      "inName": "Prefektur Shizuoka",
      "tlName": "Shizuoka Prefecture",
      "moName": "Шизүока аймаг",
      "buName": "ရှီဇူးအိုက ပြည်နယ်",
      "khName": "ខេត្ដ ហ្ស៊ីស៊ូកា",
      "neName": "सिजुओका जिल्ला"
    },
    "class10": {
      "code": "220010",
      "name": "中部",
      "enName": "Central Region",
      "chName": "静冈县中部",
      "zhName": "靜岡縣中部",
      "koName": "시즈오카 현 중부",
      "esName": "Centro de Prefectura de Shizuoka",
      "ptName": "Região central da Província de Shizuoka",
      "thName": "จังหวัดชิซุโอกะตอนกลาง",
      "viName": "Miền Trung tỉnh Shizuoka",
      "inName": "Bagian Tengah Prefektur Shizuoka",
      "tlName": "Sentral na bahagi ng Shizuoka Prefecture",
      "moName": "Төв Шизүока аймаг",
      "buName": "ရှိဇုအိုကစီရင်စု အလယ်ပိုင်း",
      "khName": "តំបន់កណ្តាលនៃខេត្ដស៊ីស្ស៊ឹអុកា",
      "neName": "सिजुओका जिल्लाको मध्य भाग"
    },
    "class15": {
      "code": "220011",
      "name": "中部南",
      "enName": "Southern Central Region"
    },
    "class20": {
      "code": "2222600",
      "name": "牧之原市",
      "enName": "Makinohara City",
      "kana": "まきのはらし",
      "chName": "牧之原市",
      "zhName": "牧之原市",
      "koName": "마키노하라 시",
      "esName": "Ciudad de Makinohara",
      "ptName": "cidade de Makinohara",
      "thName": "เมืองมากิโนะฮาระ",
      "viName": "thành phố Makinohara",
      "inName": "kota Makinohara",
      "tlName": "siyudad ng Makinohara",
      "moName": "Мaкинохaра хот",
      "buName": "မာကိနိုးဟာ့ရ မြို့",
      "khName": "ទីក្រុង ម៉ាក់គីណូហារ៉ា",
      "neName": "माकिनोहारा सहर"
    }
  },
  "2230100": {
    "office": {
      "code": "220000",
      "name": "静岡県",
      "enName": "Shizuoka",
      "officeName": "静岡地方気象台",
      "chName": "静冈县",
      "zhName": "靜岡縣",
      "koName": "시즈오카현",
      "esName": "Prefectura de Shizuoka",
      "ptName": "Província de Shizuoka",
      "thName": "จังหวัดชิซุโอกะ",
      "viName": "Tỉnh Shizuoka",
      "inName": "Prefektur Shizuoka",
      "tlName": "Shizuoka Prefecture",
      "moName": "Шизүока аймаг",
      "buName": "ရှီဇူးအိုက ပြည်နယ်",
      "khName": "ខេត្ដ ហ្ស៊ីស៊ូកា",
      "neName": "सिजुओका जिल्ला"
    },
    "class10": {
      "code": "220020",
      "name": "伊豆",
      "enName": "Izu",
      "chName": "静冈县伊豆地方",
      "zhName": "静岡縣伊豆地方",
      "koName": "시즈오카 현 이즈 지방",
      "esName": "Región Izu, Prefectura de Shizuoka",
      "ptName": "Região de Izu da Província de Shizuoka",
      "thName": "ท้องถิ่นอิซุ จังหวัดชิซุโอกะ",
      "viName": "Vùng Izu tỉnh Shizuoka",
      "inName": "Daerah Izu di Prefektur Shizuoka",
      "tlName": "Rehiyon ng Izu sa Shizuoka Prefecture",
      "moName": "Шизүока аймаг, Изү",
      "buName": "အိဇု၊ ရှိဇုအိုကစီရင်စု",
      "khName": "តំបន់អ៊ីហ៊្សូនៃខេត្ដស៊ីស្ស៊ឹអុកា",
      "neName": "सिजुओका जिल्ला, इजु क्षेत्र"
    },
    "class15": {
      "code": "220022",
      "name": "伊豆南",
      "enName": "Southern Izu"
    },
    "class20": {
      "code": "2230100",
      "name": "東伊豆町",
      "enName": "Higashiizu Town",
      "kana": "ひがしいずちょう",
      "chName": "东伊豆町",
      "zhName": "東伊豆町",
      "koName": "히가시이즈 정",
      "esName": "Pueblo de Higashi-Izu",
      "ptName": "bairro de Higashiizu",
      "thName": "เมืองฮิงาชิอิสุ",
      "viName": "thị trấn Higashiizu",
      "inName": "kota Higashiizu",
      "tlName": "bayan ng Higashiizu",
      "moName": "Хигaшийзү жижиг хот",
      "buName": "ဟီဂရှီးဇု မြို့နယ်",
      "khName": "ទីប្រជុំជន ហ៊ីកាស៊ីហ្សូ",
      "neName": "हिगाशीइजु नगर"
    }
  },
  "2230200": {
    "office": {
      "code": "220000",
      "name": "静岡県",
      "enName": "Shizuoka",
      "officeName": "静岡地方気象台",
      "chName": "静冈县",
      "zhName": "靜岡縣",
      "koName": "시즈오카현",
      "esName": "Prefectura de Shizuoka",
      "ptName": "Província de Shizuoka",
      "thName": "จังหวัดชิซุโอกะ",
      "viName": "Tỉnh Shizuoka",
      "inName": "Prefektur Shizuoka",
      "tlName": "Shizuoka Prefecture",
      "moName": "Шизүока аймаг",
      "buName": "ရှီဇူးအိုက ပြည်နယ်",
      "khName": "ខេត្ដ ហ្ស៊ីស៊ូកា",
      "neName": "सिजुओका जिल्ला"
    },
    "class10": {
      "code": "220020",
      "name": "伊豆",
      "enName": "Izu",
      "chName": "静冈县伊豆地方",
      "zhName": "静岡縣伊豆地方",
      "koName": "시즈오카 현 이즈 지방",
      "esName": "Región Izu, Prefectura de Shizuoka",
      "ptName": "Região de Izu da Província de Shizuoka",
      "thName": "ท้องถิ่นอิซุ จังหวัดชิซุโอกะ",
      "viName": "Vùng Izu tỉnh Shizuoka",
      "inName": "Daerah Izu di Prefektur Shizuoka",
      "tlName": "Rehiyon ng Izu sa Shizuoka Prefecture",
      "moName": "Шизүока аймаг, Изү",
      "buName": "အိဇု၊ ရှိဇုအိုကစီရင်စု",
      "khName": "តំបន់អ៊ីហ៊្សូនៃខេត្ដស៊ីស្ស៊ឹអុកា",
      "neName": "सिजुओका जिल्ला, इजु क्षेत्र"
    },
    "class15": {
      "code": "220022",
      "name": "伊豆南",
      "enName": "Southern Izu"
    },
    "class20": {
      "code": "2230200",
      "name": "河津町",
      "enName": "Kawazu Town",
      "kana": "かわづちょう",
      "chName": "河津町",
      "zhName": "河津町",
      "koName": "가와즈 정",
      "esName": "Pueblo de Kawazu",
      "ptName": "bairro de Kawazu",
      "thName": "เมืองคาวาสุ",
      "viName": "thị trấn Kawazu",
      "inName": "kota Kawazu",
      "tlName": "bayan ng Kawazu",
      "moName": "Кавазү жижиг хот",
      "buName": "ခါဝါဇု မြို့နယ်",
      "khName": "ទីប្រជុំជន កាវ៉ាហ្សូ",
      "neName": "कावाजु नगर"
    }
  },
  "2230400": {
    "office": {
      "code": "220000",
      "name": "静岡県",
      "enName": "Shizuoka",
      "officeName": "静岡地方気象台",
      "chName": "静冈县",
      "zhName": "靜岡縣",
      "koName": "시즈오카현",
      "esName": "Prefectura de Shizuoka",
      "ptName": "Província de Shizuoka",
      "thName": "จังหวัดชิซุโอกะ",
      "viName": "Tỉnh Shizuoka",
      "inName": "Prefektur Shizuoka",
      "tlName": "Shizuoka Prefecture",
      "moName": "Шизүока аймаг",
      "buName": "ရှီဇူးအိုက ပြည်နယ်",
      "khName": "ខេត្ដ ហ្ស៊ីស៊ូកា",
      "neName": "सिजुओका जिल्ला"
    },
    "class10": {
      "code": "220020",
      "name": "伊豆",
      "enName": "Izu",
      "chName": "静冈县伊豆地方",
      "zhName": "静岡縣伊豆地方",
      "koName": "시즈오카 현 이즈 지방",
      "esName": "Región Izu, Prefectura de Shizuoka",
      "ptName": "Região de Izu da Província de Shizuoka",
      "thName": "ท้องถิ่นอิซุ จังหวัดชิซุโอกะ",
      "viName": "Vùng Izu tỉnh Shizuoka",
      "inName": "Daerah Izu di Prefektur Shizuoka",
      "tlName": "Rehiyon ng Izu sa Shizuoka Prefecture",
      "moName": "Шизүока аймаг, Изү",
      "buName": "အိဇု၊ ရှိဇုအိုကစီရင်စု",
      "khName": "តំបន់អ៊ីហ៊្សូនៃខេត្ដស៊ីស្ស៊ឹអុកា",
      "neName": "सिजुओका जिल्ला, इजु क्षेत्र"
    },
    "class15": {
      "code": "220022",
      "name": "伊豆南",
      "enName": "Southern Izu"
    },
    "class20": {
      "code": "2230400",
      "name": "南伊豆町",
      "enName": "Miamiizu Town",
      "kana": "みなみいずちょう",
      "chName": "南伊豆町",
      "zhName": "南伊豆町",
      "koName": "미나미이즈 정",
      "esName": "Pueblo de Minami-Izu",
      "ptName": "bairro de Miamiizu",
      "thName": "เมืองมิอามิอิสึ",
      "viName": "thị trấn Miamiizu",
      "inName": "kota Miamiizu",
      "tlName": "bayan ng Miamiizu",
      "moName": "Миaмийзү жижиг хот",
      "buName": "မီယာမီးဇု မြို့နယ်",
      "khName": "ទីប្រជុំជន ម៉ៃអាមីហ្សូ",
      "neName": "मिआमिइजु नगर"
    }
  },
  "2230500": {
    "office": {
      "code": "220000",
      "name": "静岡県",
      "enName": "Shizuoka",
      "officeName": "静岡地方気象台",
      "chName": "静冈县",
      "zhName": "靜岡縣",
      "koName": "시즈오카현",
      "esName": "Prefectura de Shizuoka",
      "ptName": "Província de Shizuoka",
      "thName": "จังหวัดชิซุโอกะ",
      "viName": "Tỉnh Shizuoka",
      "inName": "Prefektur Shizuoka",
      "tlName": "Shizuoka Prefecture",
      "moName": "Шизүока аймаг",
      "buName": "ရှီဇူးအိုက ပြည်နယ်",
      "khName": "ខេត្ដ ហ្ស៊ីស៊ូកា",
      "neName": "सिजुओका जिल्ला"
    },
    "class10": {
      "code": "220020",
      "name": "伊豆",
      "enName": "Izu",
      "chName": "静冈县伊豆地方",
      "zhName": "静岡縣伊豆地方",
      "koName": "시즈오카 현 이즈 지방",
      "esName": "Región Izu, Prefectura de Shizuoka",
      "ptName": "Região de Izu da Província de Shizuoka",
      "thName": "ท้องถิ่นอิซุ จังหวัดชิซุโอกะ",
      "viName": "Vùng Izu tỉnh Shizuoka",
      "inName": "Daerah Izu di Prefektur Shizuoka",
      "tlName": "Rehiyon ng Izu sa Shizuoka Prefecture",
      "moName": "Шизүока аймаг, Изү",
      "buName": "အိဇု၊ ရှိဇုအိုကစီရင်စု",
      "khName": "តំបន់អ៊ីហ៊្សូនៃខេត្ដស៊ីស្ស៊ឹអុកា",
      "neName": "सिजुओका जिल्ला, इजु क्षेत्र"
    },
    "class15": {
      "code": "220022",
      "name": "伊豆南",
      "enName": "Southern Izu"
    },
    "class20": {
      "code": "2230500",
      "name": "松崎町",
      "enName": "Matsuzaki Town",
      "kana": "まつざきちょう",
      "chName": "松崎町",
      "zhName": "松崎町",
      "koName": "마쓰자키 정",
      "esName": "Pueblo de Matsuzaki",
      "ptName": "bairro de Matsuzaki",
      "thName": "เมืองมัทสึซากิ",
      "viName": "thị trấn Matsuzaki",
      "inName": "kota Matsuzaki",
      "tlName": "bayan ng Matsuzaki",
      "moName": "Мaцүзaки жижиг хот",
      "buName": "မာဆုဇာ့ကိ မြို့နယ်",
      "khName": "ទីប្រជុំជន ម៉ាតស៊ូហ្សាគី",
      "neName": "मात्सुजाकी नगर"
    }
  },
  "2230600": {
    "office": {
      "code": "220000",
      "name": "静岡県",
      "enName": "Shizuoka",
      "officeName": "静岡地方気象台",
      "chName": "静冈县",
      "zhName": "靜岡縣",
      "koName": "시즈오카현",
      "esName": "Prefectura de Shizuoka",
      "ptName": "Província de Shizuoka",
      "thName": "จังหวัดชิซุโอกะ",
      "viName": "Tỉnh Shizuoka",
      "inName": "Prefektur Shizuoka",
      "tlName": "Shizuoka Prefecture",
      "moName": "Шизүока аймаг",
      "buName": "ရှီဇူးအိုက ပြည်နယ်",
      "khName": "ខេត្ដ ហ្ស៊ីស៊ូកា",
      "neName": "सिजुओका जिल्ला"
    },
    "class10": {
      "code": "220020",
      "name": "伊豆",
      "enName": "Izu",
      "chName": "静冈县伊豆地方",
      "zhName": "静岡縣伊豆地方",
      "koName": "시즈오카 현 이즈 지방",
      "esName": "Región Izu, Prefectura de Shizuoka",
      "ptName": "Região de Izu da Província de Shizuoka",
      "thName": "ท้องถิ่นอิซุ จังหวัดชิซุโอกะ",
      "viName": "Vùng Izu tỉnh Shizuoka",
      "inName": "Daerah Izu di Prefektur Shizuoka",
      "tlName": "Rehiyon ng Izu sa Shizuoka Prefecture",
      "moName": "Шизүока аймаг, Изү",
      "buName": "အိဇု၊ ရှိဇုအိုကစီရင်စု",
      "khName": "តំបន់អ៊ីហ៊្សូនៃខេត្ដស៊ីស្ស៊ឹអុកា",
      "neName": "सिजुओका जिल्ला, इजु क्षेत्र"
    },
    "class15": {
      "code": "220022",
      "name": "伊豆南",
      "enName": "Southern Izu"
    },
    "class20": {
      "code": "2230600",
      "name": "西伊豆町",
      "enName": "Nishiizu Town",
      "kana": "にしいずちょう",
      "chName": "西伊豆町",
      "zhName": "西伊豆町",
      "koName": "니시이즈 정",
      "esName": "Pueblo de Nishi-Izu",
      "ptName": "bairro de Nishiizu",
      "thName": "เมืองนิชิอิสุ",
      "viName": "thị trấn Nishiizu",
      "inName": "kota Nishiizu",
      "tlName": "bayan ng Nishiizu",
      "moName": "Нишийзү жижиг хот",
      "buName": "နီရှီးဇု မြို့နယ်",
      "khName": "ទីប្រជុំជន នីស៊ីហ្សូ",
      "neName": "निशीइजु नगर"
    }
  },
  "2232500": {
    "office": {
      "code": "220000",
      "name": "静岡県",
      "enName": "Shizuoka",
      "officeName": "静岡地方気象台",
      "chName": "静冈县",
      "zhName": "靜岡縣",
      "koName": "시즈오카현",
      "esName": "Prefectura de Shizuoka",
      "ptName": "Província de Shizuoka",
      "thName": "จังหวัดชิซุโอกะ",
      "viName": "Tỉnh Shizuoka",
      "inName": "Prefektur Shizuoka",
      "tlName": "Shizuoka Prefecture",
      "moName": "Шизүока аймаг",
      "buName": "ရှီဇူးအိုက ပြည်နယ်",
      "khName": "ខេត្ដ ហ្ស៊ីស៊ូកា",
      "neName": "सिजुओका जिल्ला"
    },
    "class10": {
      "code": "220020",
      "name": "伊豆",
      "enName": "Izu",
      "chName": "静冈县伊豆地方",
      "zhName": "静岡縣伊豆地方",
      "koName": "시즈오카 현 이즈 지방",
      "esName": "Región Izu, Prefectura de Shizuoka",
      "ptName": "Região de Izu da Província de Shizuoka",
      "thName": "ท้องถิ่นอิซุ จังหวัดชิซุโอกะ",
      "viName": "Vùng Izu tỉnh Shizuoka",
      "inName": "Daerah Izu di Prefektur Shizuoka",
      "tlName": "Rehiyon ng Izu sa Shizuoka Prefecture",
      "moName": "Шизүока аймаг, Изү",
      "buName": "အိဇု၊ ရှိဇုအိုကစီရင်စု",
      "khName": "តំបន់អ៊ីហ៊្សូនៃខេត្ដស៊ីស្ស៊ឹអុកា",
      "neName": "सिजुओका जिल्ला, इजु क्षेत्र"
    },
    "class15": {
      "code": "220021",
      "name": "伊豆北",
      "enName": "Northern Izu"
    },
    "class20": {
      "code": "2232500",
      "name": "函南町",
      "enName": "Kannami Town",
      "kana": "かんなみちょう",
      "chName": "函南町",
      "zhName": "函南町",
      "koName": "간나미 정",
      "esName": "Pueblo de Kannami",
      "ptName": "bairro de Kannami",
      "thName": "เมืองคันนามิ",
      "viName": "thị trấn Kannami",
      "inName": "kota Kannami",
      "tlName": "bayan ng Kannami",
      "moName": "Каннaми жижиг хот",
      "buName": "ခန်နားမိ မြို့နယ်",
      "khName": "ទីប្រជុំជន កានណាមិ",
      "neName": "कान्नामी नगर"
    }
  },
  "2234100": {
    "office": {
      "code": "220000",
      "name": "静岡県",
      "enName": "Shizuoka",
      "officeName": "静岡地方気象台",
      "chName": "静冈县",
      "zhName": "靜岡縣",
      "koName": "시즈오카현",
      "esName": "Prefectura de Shizuoka",
      "ptName": "Província de Shizuoka",
      "thName": "จังหวัดชิซุโอกะ",
      "viName": "Tỉnh Shizuoka",
      "inName": "Prefektur Shizuoka",
      "tlName": "Shizuoka Prefecture",
      "moName": "Шизүока аймаг",
      "buName": "ရှီဇူးအိုက ပြည်နယ်",
      "khName": "ខេត្ដ ហ្ស៊ីស៊ូកា",
      "neName": "सिजुओका जिल्ला"
    },
    "class10": {
      "code": "220030",
      "name": "東部",
      "enName": "Eastern Region",
      "chName": "静冈县东部",
      "zhName": "靜岡縣東部",
      "koName": "시즈오카 현 동부",
      "esName": "Este de Prefectura de Shizuoka",
      "ptName": "Região Leste da Província de Shizuoka",
      "thName": "จังหวัดชิซุโอกะฟากตะวันออก",
      "viName": "Miền Đông tỉnh Shizuoka",
      "inName": "Bagian Timur Prefektur Shizuoka",
      "tlName": "Silangang bahagi ng Shizuoka Prefecture",
      "moName": "Зүүн Шизүока аймаг",
      "buName": "ရှိဇုအိုကစီရင်စု အရှေ့ပိုင်း",
      "khName": "តំបន់ខាងកើតនៃខេត្ដស៊ីស្ស៊ឹអុកា",
      "neName": "सिजुओका जिल्लाको पूर्वी भाग"
    },
    "class15": {
      "code": "220031",
      "name": "富士山南東",
      "enName": "South-eastern Mt. Fuji"
    },
    "class20": {
      "code": "2234100",
      "name": "清水町",
      "enName": "Shimizu Town",
      "kana": "しみずちょう",
      "chName": "静冈清水町",
      "zhName": "靜岡清水町",
      "koName": "시즈오카 시미즈 정",
      "esName": "Pueblo de Shimizu, Shizuoka",
      "ptName": "Shizuoka, bairro de Shimizu",
      "thName": "ชิมิสุโจ ชิซูโอกะ",
      "viName": "Thị trấn Shimizu, Shizuoka",
      "inName": "Kota Shimizu, Shizuoka",
      "tlName": "bayan ng Shimizu, Shizuoka",
      "moName": "Шизүока Шимизү жижиг хот",
      "buName": "ရှိဇုအိုကရှိမိဇုမြို့နယ် ",
      "khName": "ទីប្រជុំជនស៊ីមីហ្សឹ ស៊ីស្ស៊ឹអុកា",
      "neName": "सिजुओका शिमिजु नगर"
    }
  },
  "2234200": {
    "office": {
      "code": "220000",
      "name": "静岡県",
      "enName": "Shizuoka",
      "officeName": "静岡地方気象台",
      "chName": "静冈县",
      "zhName": "靜岡縣",
      "koName": "시즈오카현",
      "esName": "Prefectura de Shizuoka",
      "ptName": "Província de Shizuoka",
      "thName": "จังหวัดชิซุโอกะ",
      "viName": "Tỉnh Shizuoka",
      "inName": "Prefektur Shizuoka",
      "tlName": "Shizuoka Prefecture",
      "moName": "Шизүока аймаг",
      "buName": "ရှီဇူးအိုက ပြည်နယ်",
      "khName": "ខេត្ដ ហ្ស៊ីស៊ូកា",
      "neName": "सिजुओका जिल्ला"
    },
    "class10": {
      "code": "220030",
      "name": "東部",
      "enName": "Eastern Region",
      "chName": "静冈县东部",
      "zhName": "靜岡縣東部",
      "koName": "시즈오카 현 동부",
      "esName": "Este de Prefectura de Shizuoka",
      "ptName": "Região Leste da Província de Shizuoka",
      "thName": "จังหวัดชิซุโอกะฟากตะวันออก",
      "viName": "Miền Đông tỉnh Shizuoka",
      "inName": "Bagian Timur Prefektur Shizuoka",
      "tlName": "Silangang bahagi ng Shizuoka Prefecture",
      "moName": "Зүүн Шизүока аймаг",
      "buName": "ရှိဇုအိုကစီရင်စု အရှေ့ပိုင်း",
      "khName": "តំបន់ខាងកើតនៃខេត្ដស៊ីស្ស៊ឹអុកា",
      "neName": "सिजुओका जिल्लाको पूर्वी भाग"
    },
    "class15": {
      "code": "220031",
      "name": "富士山南東",
      "enName": "South-eastern Mt. Fuji"
    },
    "class20": {
      "code": "2234200",
      "name": "長泉町",
      "enName": "Nagaizumi Town",
      "kana": "ながいずみちょう",
      "chName": "长泉町",
      "zhName": "長泉町",
      "koName": "나가이즈미 정",
      "esName": "Pueblo de Nagaizumi",
      "ptName": "bairro de Nagaizumi",
      "thName": "เมืองนางาอิสุมิ",
      "viName": "thị trấn Nagaizumi",
      "inName": "kota Nagaizumi",
      "tlName": "bayan ng Nagaizumi",
      "moName": "Нaгaйзүми жижиг хот",
      "buName": "နာဂါယိဇုမိ မြို့နယ်",
      "khName": "ទីប្រជុំជន ណាហ្គាយហ្សូមី",
      "neName": "नागाइजुमी नगर"
    }
  },
  "2234400": {
    "office": {
      "code": "220000",
      "name": "静岡県",
      "enName": "Shizuoka",
      "officeName": "静岡地方気象台",
      "chName": "静冈县",
      "zhName": "靜岡縣",
      "koName": "시즈오카현",
      "esName": "Prefectura de Shizuoka",
      "ptName": "Província de Shizuoka",
      "thName": "จังหวัดชิซุโอกะ",
      "viName": "Tỉnh Shizuoka",
      "inName": "Prefektur Shizuoka",
      "tlName": "Shizuoka Prefecture",
      "moName": "Шизүока аймаг",
      "buName": "ရှီဇူးအိုက ပြည်နယ်",
      "khName": "ខេត្ដ ហ្ស៊ីស៊ូកា",
      "neName": "सिजुओका जिल्ला"
    },
    "class10": {
      "code": "220030",
      "name": "東部",
      "enName": "Eastern Region",
      "chName": "静冈县东部",
      "zhName": "靜岡縣東部",
      "koName": "시즈오카 현 동부",
      "esName": "Este de Prefectura de Shizuoka",
      "ptName": "Região Leste da Província de Shizuoka",
      "thName": "จังหวัดชิซุโอกะฟากตะวันออก",
      "viName": "Miền Đông tỉnh Shizuoka",
      "inName": "Bagian Timur Prefektur Shizuoka",
      "tlName": "Silangang bahagi ng Shizuoka Prefecture",
      "moName": "Зүүн Шизүока аймаг",
      "buName": "ရှိဇုအိုကစီရင်စု အရှေ့ပိုင်း",
      "khName": "តំបន់ខាងកើតនៃខេត្ដស៊ីស្ស៊ឹអុកា",
      "neName": "सिजुओका जिल्लाको पूर्वी भाग"
    },
    "class15": {
      "code": "220031",
      "name": "富士山南東",
      "enName": "South-eastern Mt. Fuji"
    },
    "class20": {
      "code": "2234400",
      "name": "小山町",
      "enName": "Oyama Town",
      "kana": "おやまちょう",
      "chName": "小山町",
      "zhName": "小山町",
      "koName": "오야마 정",
      "esName": "Pueblo de Oyama",
      "ptName": "bairro de Oyama",
      "thName": "เมืองโอยามะ",
      "viName": "thị trấn Oyama",
      "inName": "kota Oyama",
      "tlName": "bayan ng Oyama",
      "moName": "Оямa жижиг хот",
      "buName": "အိုးယမ မြို့နယ်",
      "khName": "ទីប្រជុំជន អូយ៉ាម៉ា",
      "neName": "ओयामा नगर"
    }
  },
  "2242400": {
    "office": {
      "code": "220000",
      "name": "静岡県",
      "enName": "Shizuoka",
      "officeName": "静岡地方気象台",
      "chName": "静冈县",
      "zhName": "靜岡縣",
      "koName": "시즈오카현",
      "esName": "Prefectura de Shizuoka",
      "ptName": "Província de Shizuoka",
      "thName": "จังหวัดชิซุโอกะ",
      "viName": "Tỉnh Shizuoka",
      "inName": "Prefektur Shizuoka",
      "tlName": "Shizuoka Prefecture",
      "moName": "Шизүока аймаг",
      "buName": "ရှီဇူးအိုက ပြည်နယ်",
      "khName": "ខេត្ដ ហ្ស៊ីស៊ូកា",
      "neName": "सिजुओका जिल्ला"
    },
    "class10": {
      "code": "220010",
      "name": "中部",
      "enName": "Central Region",
      "chName": "静冈县中部",
      "zhName": "靜岡縣中部",
      "koName": "시즈오카 현 중부",
      "esName": "Centro de Prefectura de Shizuoka",
      "ptName": "Região central da Província de Shizuoka",
      "thName": "จังหวัดชิซุโอกะตอนกลาง",
      "viName": "Miền Trung tỉnh Shizuoka",
      "inName": "Bagian Tengah Prefektur Shizuoka",
      "tlName": "Sentral na bahagi ng Shizuoka Prefecture",
      "moName": "Төв Шизүока аймаг",
      "buName": "ရှိဇုအိုကစီရင်စု အလယ်ပိုင်း",
      "khName": "តំបន់កណ្តាលនៃខេត្ដស៊ីស្ស៊ឹអុកា",
      "neName": "सिजुओका जिल्लाको मध्य भाग"
    },
    "class15": {
      "code": "220011",
      "name": "中部南",
      "enName": "Southern Central Region"
    },
    "class20": {
      "code": "2242400",
      "name": "吉田町",
      "enName": "Yoshida Town",
      "kana": "よしだちょう",
      "chName": "吉田町",
      "zhName": "吉田町",
      "koName": "요시다 정",
      "esName": "Pueblo de Yoshida",
      "ptName": "bairro de Yoshida",
      "thName": "เมืองโยชิดะ",
      "viName": "thị trấn Yoshida",
      "inName": "kota Yoshida",
      "tlName": "bayan ng Yoshida",
      "moName": "Ёшида жижиг хот",
      "buName": "ရိုရှိဒါ့ မြို့နယ်",
      "khName": "ទីប្រជុំជន យ៉ូស៊ីដា",
      "neName": "योशिदा नगर"
    }
  },
  "2242900": {
    "office": {
      "code": "220000",
      "name": "静岡県",
      "enName": "Shizuoka",
      "officeName": "静岡地方気象台",
      "chName": "静冈县",
      "zhName": "靜岡縣",
      "koName": "시즈오카현",
      "esName": "Prefectura de Shizuoka",
      "ptName": "Província de Shizuoka",
      "thName": "จังหวัดชิซุโอกะ",
      "viName": "Tỉnh Shizuoka",
      "inName": "Prefektur Shizuoka",
      "tlName": "Shizuoka Prefecture",
      "moName": "Шизүока аймаг",
      "buName": "ရှီဇူးအိုက ပြည်နယ်",
      "khName": "ខេត្ដ ហ្ស៊ីស៊ូកា",
      "neName": "सिजुओका जिल्ला"
    },
    "class10": {
      "code": "220010",
      "name": "中部",
      "enName": "Central Region",
      "chName": "静冈县中部",
      "zhName": "靜岡縣中部",
      "koName": "시즈오카 현 중부",
      "esName": "Centro de Prefectura de Shizuoka",
      "ptName": "Região central da Província de Shizuoka",
      "thName": "จังหวัดชิซุโอกะตอนกลาง",
      "viName": "Miền Trung tỉnh Shizuoka",
      "inName": "Bagian Tengah Prefektur Shizuoka",
      "tlName": "Sentral na bahagi ng Shizuoka Prefecture",
      "moName": "Төв Шизүока аймаг",
      "buName": "ရှိဇုအိုကစီရင်စု အလယ်ပိုင်း",
      "khName": "តំបន់កណ្តាលនៃខេត្ដស៊ីស្ស៊ឹអុកា",
      "neName": "सिजुओका जिल्लाको मध्य भाग"
    },
    "class15": {
      "code": "220012",
      "name": "中部北",
      "enName": "Northern Central Region"
    },
    "class20": {
      "code": "2242900",
      "name": "川根本町",
      "enName": "Kawanehoncho Town",
      "kana": "かわねほんちょう",
      "chName": "川根本町",
      "zhName": "川根本町",
      "koName": "가와네혼 정",
      "esName": "Pueblo de Kawane-honcho",
      "ptName": "bairro de Kawanehoncho",
      "thName": "เมืองคาวาเนฮอนโจ",
      "viName": "thị trấn Kawanehoncho",
      "inName": "kota Kawanehoncho",
      "tlName": "bayan ng Kawanehoncho",
      "moName": "Каванэхончо жижиг хот",
      "buName": "ခါဝါနဲဟွန်းကျို မြို့နယ်",
      "khName": "ទីប្រជុំជន ខាវ៉ានណេហ៊ុនចូ",
      "neName": "कावानेहोन्चो नगर"
    }
  },
  "2246100": {
    "office": {
      "code": "220000",
      "name": "静岡県",
      "enName": "Shizuoka",
      "officeName": "静岡地方気象台",
      "chName": "静冈县",
      "zhName": "靜岡縣",
      "koName": "시즈오카현",
      "esName": "Prefectura de Shizuoka",
      "ptName": "Província de Shizuoka",
      "thName": "จังหวัดชิซุโอกะ",
      "viName": "Tỉnh Shizuoka",
      "inName": "Prefektur Shizuoka",
      "tlName": "Shizuoka Prefecture",
      "moName": "Шизүока аймаг",
      "buName": "ရှီဇူးအိုက ပြည်နယ်",
      "khName": "ខេត្ដ ហ្ស៊ីស៊ូកា",
      "neName": "सिजुओका जिल्ला"
    },
    "class10": {
      "code": "220040",
      "name": "西部",
      "enName": "Western Region",
      "chName": "静冈县西部",
      "zhName": "靜岡縣西部",
      "koName": "시즈오카 현 서부",
      "esName": "Oeste de Prefectura de Shizuoka",
      "ptName": "Região Oeste da Província de Shizuoka",
      "thName": "จังหวัดชิซุโอกะฟากตะวันตก",
      "viName": "Miền Tây tỉnh Shizuoka",
      "inName": "Bagian Barat Prefektur Shizuoka",
      "tlName": "Kanlurang bahagi ng Shizuoka Prefecture",
      "moName": "Баруун Шизүока аймаг",
      "buName": "ရှိဇုအိုကစီရင်စု အနောက်ပိုင်း",
      "khName": "តំបន់ខាងលិចនៃខេត្ដស៊ីស្ស៊ឹអុកា",
      "neName": "सिजुओका जिल्लाको पश्चिमी भाग"
    },
    "class15": {
      "code": "220042",
      "name": "遠州南",
      "enName": "Southern Enshu"
    },
    "class20": {
      "code": "2246100",
      "name": "森町",
      "enName": "Mori Town",
      "kana": "もりまち",
      "chName": "静冈森町",
      "zhName": "靜岡森町",
      "koName": "시즈오카 모리 정",
      "esName": "Pueblo de Mori, Shizuoka",
      "ptName": "Shizuoka, bairro de Mori",
      "thName": "เมืองโมริ ชิซุโอกะ",
      "viName": "Thị trấn Mori, Shizuoka",
      "inName": "Kota Mori, Shizuoka",
      "tlName": "bayan ng Mori, Shizuoka",
      "moName": "Шизүока Мори жижиг хот",
      "buName": "ရှိဇုအိုကမိုယိမြို့နယ် ",
      "khName": "ទីប្រជុំជនម៉ូរី ស៊ីស្ស៊ឹអុកា",
      "neName": "सिजुओका मोरी नगर"
    }
  },
  "2310000": {
    "office": {
      "code": "230000",
      "name": "愛知県",
      "enName": "Aichi",
      "officeName": "名古屋地方気象台",
      "chName": "爱知县",
      "zhName": "愛知縣",
      "koName": "아이치현",
      "esName": "Prefectura de Aichi",
      "ptName": "Província de Aichi",
      "thName": "จังหวัดไอจิ",
      "viName": "Tỉnh Aichi",
      "inName": "Prefektur Aichi",
      "tlName": "Aichi Prefecture",
      "moName": "Айчи аймаг",
      "buName": "အိုင်အိကျိ ပြည်နယ်",
      "khName": "ខេត្ដ​ អាឈី",
      "neName": "आइची जिल्ला"
    },
    "class10": {
      "code": "230010",
      "name": "西部",
      "enName": "Western Region",
      "chName": "爱知县西部",
      "zhName": "愛知縣西部",
      "koName": "아이치 현 서부",
      "esName": "Oeste de Prefectura de Aichi",
      "ptName": "Região Oeste da Província de Aichi",
      "thName": "จังหวัดไอจิฟากตะวันตก",
      "viName": "Miền Tây tỉnh Aichi",
      "inName": "Bagian Barat Prefektur Aichi",
      "tlName": "Kanlurang bahagi ng Aichi Prefecture",
      "moName": "Баруун Айчи аймаг",
      "buName": "အအိချိစီရင်စု အနောက်ပိုင်း",
      "khName": "តំបន់ខាងលិចនៃខេត្ដ​អៃឈិ",
      "neName": "आइची जिल्लाको पश्चिमी भाग"
    },
    "class15": {
      "code": "230011",
      "name": "尾張東部",
      "enName": "Eastern Owari"
    },
    "class20": {
      "code": "2310000",
      "name": "名古屋市",
      "enName": "Nagoya City",
      "kana": "なごやし",
      "chName": "名古屋市",
      "zhName": "名古屋市",
      "koName": "나고야시",
      "esName": "Ciudad de Nagoya",
      "ptName": "Cidade de Nagoya",
      "thName": "เมืองนาโงย่า",
      "viName": "thành phố Nagoya",
      "inName": "Kota Nagoya",
      "tlName": "lungsod ng Nagoya",
      "moName": "Нагоя хот",
      "buName": "နာဂိုယာမြို့",
      "khName": "ទីក្រុង ណាហ្គោយា",
      "neName": "नागोया शहर"
    }
  },
  "2320100": {
    "office": {
      "code": "230000",
      "name": "愛知県",
      "enName": "Aichi",
      "officeName": "名古屋地方気象台",
      "chName": "爱知县",
      "zhName": "愛知縣",
      "koName": "아이치현",
      "esName": "Prefectura de Aichi",
      "ptName": "Província de Aichi",
      "thName": "จังหวัดไอจิ",
      "viName": "Tỉnh Aichi",
      "inName": "Prefektur Aichi",
      "tlName": "Aichi Prefecture",
      "moName": "Айчи аймаг",
      "buName": "အိုင်အိကျိ ပြည်နယ်",
      "khName": "ខេត្ដ​ អាឈី",
      "neName": "आइची जिल्ला"
    },
    "class10": {
      "code": "230020",
      "name": "東部",
      "enName": "Eastern Region",
      "chName": "爱知县东部",
      "zhName": "愛知縣東部",
      "koName": "아이치 현 동부",
      "esName": "Este de Prefectura de Aichi",
      "ptName": "Região Leste da Província de Aichi",
      "thName": "จังหวัดไอจิฟากตะวันออก",
      "viName": "Miền Đông tỉnh Aichi",
      "inName": "Bagian Timur Prefektur Aichi",
      "tlName": "Silangang bahagi ng Aichi Prefecture",
      "moName": "Зүүн Айчи аймаг",
      "buName": "အအိချိစီရင်စု အရှေ့ပိုင်း",
      "khName": "តំបន់ខាងកើតនៃខេត្ដ​អៃឈិ",
      "neName": "आइची जिल्लाको पूर्वी भाग"
    },
    "class15": {
      "code": "230023",
      "name": "東三河南部",
      "enName": "Southern Higashi-mikawa Region"
    },
    "class20": {
      "code": "2320100",
      "name": "豊橋市",
      "enName": "Toyohashi City",
      "kana": "とよはしし",
      "chName": "丰桥市",
      "zhName": "豐橋市",
      "koName": "도요하시 시",
      "esName": "Ciudad de Toyohashi",
      "ptName": "cidade de Toyohashi",
      "thName": "เมืองโทโยฮาชิ",
      "viName": "thành phố Toyohashi",
      "inName": "kota Toyohashi",
      "tlName": "siyudad ng Toyohashi",
      "moName": "Тоёохaши хот",
      "buName": "တိုယိုးဟာ့ရှိ မြို့",
      "khName": "ទីក្រុង តូយ៉ូហាស៊ី",
      "neName": "तोयोहाशि सहर"
    }
  },
  "2320200": {
    "office": {
      "code": "230000",
      "name": "愛知県",
      "enName": "Aichi",
      "officeName": "名古屋地方気象台",
      "chName": "爱知县",
      "zhName": "愛知縣",
      "koName": "아이치현",
      "esName": "Prefectura de Aichi",
      "ptName": "Província de Aichi",
      "thName": "จังหวัดไอจิ",
      "viName": "Tỉnh Aichi",
      "inName": "Prefektur Aichi",
      "tlName": "Aichi Prefecture",
      "moName": "Айчи аймаг",
      "buName": "အိုင်အိကျိ ပြည်နယ်",
      "khName": "ខេត្ដ​ អាឈី",
      "neName": "आइची जिल्ला"
    },
    "class10": {
      "code": "230010",
      "name": "西部",
      "enName": "Western Region",
      "chName": "爱知县西部",
      "zhName": "愛知縣西部",
      "koName": "아이치 현 서부",
      "esName": "Oeste de Prefectura de Aichi",
      "ptName": "Região Oeste da Província de Aichi",
      "thName": "จังหวัดไอจิฟากตะวันตก",
      "viName": "Miền Tây tỉnh Aichi",
      "inName": "Bagian Barat Prefektur Aichi",
      "tlName": "Kanlurang bahagi ng Aichi Prefecture",
      "moName": "Баруун Айчи аймаг",
      "buName": "အအိချိစီရင်စု အနောက်ပိုင်း",
      "khName": "តំបន់ខាងលិចនៃខេត្ដ​អៃឈិ",
      "neName": "आइची जिल्लाको पश्चिमी भाग"
    },
    "class15": {
      "code": "230014",
      "name": "西三河南部",
      "enName": "Southern Nishi-mikawa Region"
    },
    "class20": {
      "code": "2320200",
      "name": "岡崎市",
      "enName": "Okazaki City",
      "kana": "おかざきし",
      "chName": "冈崎市",
      "zhName": "岡崎市",
      "koName": "오카자키 시",
      "esName": "Ciudad de Okazaki",
      "ptName": "cidade de Okazaki",
      "thName": "เมืองโอกาซากิ",
      "viName": "thành phố Okazaki",
      "inName": "kota Okazaki",
      "tlName": "siyudad ng Okazaki",
      "moName": "Оказaки хот",
      "buName": "အိုကားဇာ့ကိ မြို့",
      "khName": "ទីក្រុង អូកាហ្សាគី",
      "neName": "ओकाजाकी सहर"
    }
  },
  "2320300": {
    "office": {
      "code": "230000",
      "name": "愛知県",
      "enName": "Aichi",
      "officeName": "名古屋地方気象台",
      "chName": "爱知县",
      "zhName": "愛知縣",
      "koName": "아이치현",
      "esName": "Prefectura de Aichi",
      "ptName": "Província de Aichi",
      "thName": "จังหวัดไอจิ",
      "viName": "Tỉnh Aichi",
      "inName": "Prefektur Aichi",
      "tlName": "Aichi Prefecture",
      "moName": "Айчи аймаг",
      "buName": "အိုင်အိကျိ ပြည်နယ်",
      "khName": "ខេត្ដ​ អាឈី",
      "neName": "आइची जिल्ला"
    },
    "class10": {
      "code": "230010",
      "name": "西部",
      "enName": "Western Region",
      "chName": "爱知县西部",
      "zhName": "愛知縣西部",
      "koName": "아이치 현 서부",
      "esName": "Oeste de Prefectura de Aichi",
      "ptName": "Região Oeste da Província de Aichi",
      "thName": "จังหวัดไอจิฟากตะวันตก",
      "viName": "Miền Tây tỉnh Aichi",
      "inName": "Bagian Barat Prefektur Aichi",
      "tlName": "Kanlurang bahagi ng Aichi Prefecture",
      "moName": "Баруун Айчи аймаг",
      "buName": "အအိချိစီရင်စု အနောက်ပိုင်း",
      "khName": "តំបន់ខាងលិចនៃខេត្ដ​អៃឈិ",
      "neName": "आइची जिल्लाको पश्चिमी भाग"
    },
    "class15": {
      "code": "230012",
      "name": "尾張西部",
      "enName": "Western Owari"
    },
    "class20": {
      "code": "2320300",
      "name": "一宮市",
      "enName": "Ichinomiya City",
      "kana": "いちのみやし",
      "chName": "一宫市",
      "zhName": "一宮市",
      "koName": "이치노미야 시",
      "esName": "Ciudad de Ichinomiya",
      "ptName": "cidade de Ichinomiya",
      "thName": "เมืองอิจิโนะมิยะ",
      "viName": "thành phố Ichinomiya",
      "inName": "kota Ichinomiya",
      "tlName": "siyudad ng Ichinomiya",
      "moName": "Ичиномия хот",
      "buName": "အီကျိနောမိယ မြို့",
      "khName": "ទីក្រុង អ៊ីឈិនណូមីយ៉ា",
      "neName": "इचिनोमिया सहर"
    }
  },
  "2320400": {
    "office": {
      "code": "230000",
      "name": "愛知県",
      "enName": "Aichi",
      "officeName": "名古屋地方気象台",
      "chName": "爱知县",
      "zhName": "愛知縣",
      "koName": "아이치현",
      "esName": "Prefectura de Aichi",
      "ptName": "Província de Aichi",
      "thName": "จังหวัดไอจิ",
      "viName": "Tỉnh Aichi",
      "inName": "Prefektur Aichi",
      "tlName": "Aichi Prefecture",
      "moName": "Айчи аймаг",
      "buName": "အိုင်အိကျိ ပြည်နယ်",
      "khName": "ខេត្ដ​ អាឈី",
      "neName": "आइची जिल्ला"
    },
    "class10": {
      "code": "230010",
      "name": "西部",
      "enName": "Western Region",
      "chName": "爱知县西部",
      "zhName": "愛知縣西部",
      "koName": "아이치 현 서부",
      "esName": "Oeste de Prefectura de Aichi",
      "ptName": "Região Oeste da Província de Aichi",
      "thName": "จังหวัดไอจิฟากตะวันตก",
      "viName": "Miền Tây tỉnh Aichi",
      "inName": "Bagian Barat Prefektur Aichi",
      "tlName": "Kanlurang bahagi ng Aichi Prefecture",
      "moName": "Баруун Айчи аймаг",
      "buName": "အအိချိစီရင်စု အနောက်ပိုင်း",
      "khName": "តំបន់ខាងលិចនៃខេត្ដ​អៃឈិ",
      "neName": "आइची जिल्लाको पश्चिमी भाग"
    },
    "class15": {
      "code": "230011",
      "name": "尾張東部",
      "enName": "Eastern Owari"
    },
    "class20": {
      "code": "2320400",
      "name": "瀬戸市",
      "enName": "Seto City",
      "kana": "せとし",
      "chName": "濑户市",
      "zhName": "瀨戶市",
      "koName": "세토 시",
      "esName": "Ciudad de Seto",
      "ptName": "cidade de Seto",
      "thName": "เมืองเซโตะ",
      "viName": "thành phố Seto",
      "inName": "kota Seto",
      "tlName": "siyudad ng Seto",
      "moName": "Сэто хот",
      "buName": "ဆီတို မြို့",
      "khName": "ទីក្រុង សេតូ",
      "neName": "सेतो सहर"
    }
  },
  "2320500": {
    "office": {
      "code": "230000",
      "name": "愛知県",
      "enName": "Aichi",
      "officeName": "名古屋地方気象台",
      "chName": "爱知县",
      "zhName": "愛知縣",
      "koName": "아이치현",
      "esName": "Prefectura de Aichi",
      "ptName": "Província de Aichi",
      "thName": "จังหวัดไอจิ",
      "viName": "Tỉnh Aichi",
      "inName": "Prefektur Aichi",
      "tlName": "Aichi Prefecture",
      "moName": "Айчи аймаг",
      "buName": "အိုင်အိကျိ ပြည်နယ်",
      "khName": "ខេត្ដ​ អាឈី",
      "neName": "आइची जिल्ला"
    },
    "class10": {
      "code": "230010",
      "name": "西部",
      "enName": "Western Region",
      "chName": "爱知县西部",
      "zhName": "愛知縣西部",
      "koName": "아이치 현 서부",
      "esName": "Oeste de Prefectura de Aichi",
      "ptName": "Região Oeste da Província de Aichi",
      "thName": "จังหวัดไอจิฟากตะวันตก",
      "viName": "Miền Tây tỉnh Aichi",
      "inName": "Bagian Barat Prefektur Aichi",
      "tlName": "Kanlurang bahagi ng Aichi Prefecture",
      "moName": "Баруун Айчи аймаг",
      "buName": "အအိချိစီရင်စု အနောက်ပိုင်း",
      "khName": "តំបន់ខាងលិចនៃខេត្ដ​អៃឈិ",
      "neName": "आइची जिल्लाको पश्चिमी भाग"
    },
    "class15": {
      "code": "230013",
      "name": "知多地域",
      "enName": "Chita Area"
    },
    "class20": {
      "code": "2320500",
      "name": "半田市",
      "enName": "Handa City",
      "kana": "はんだし",
      "chName": "半田市",
      "zhName": "半田市",
      "koName": "한다 시",
      "esName": "Ciudad de Handa",
      "ptName": "cidade de Handa",
      "thName": "เมืองฮันดะ",
      "viName": "thành phố Handa",
      "inName": "kota Handa",
      "tlName": "siyudad ng Handa",
      "moName": "Хaнда хот",
      "buName": "ဟန်းဒ မြို့",
      "khName": "ទីក្រុង ហាន់ដា",
      "neName": "हान्दा सहर"
    }
  },
  "2320600": {
    "office": {
      "code": "230000",
      "name": "愛知県",
      "enName": "Aichi",
      "officeName": "名古屋地方気象台",
      "chName": "爱知县",
      "zhName": "愛知縣",
      "koName": "아이치현",
      "esName": "Prefectura de Aichi",
      "ptName": "Província de Aichi",
      "thName": "จังหวัดไอจิ",
      "viName": "Tỉnh Aichi",
      "inName": "Prefektur Aichi",
      "tlName": "Aichi Prefecture",
      "moName": "Айчи аймаг",
      "buName": "အိုင်အိကျိ ပြည်နယ်",
      "khName": "ខេត្ដ​ អាឈី",
      "neName": "आइची जिल्ला"
    },
    "class10": {
      "code": "230010",
      "name": "西部",
      "enName": "Western Region",
      "chName": "爱知县西部",
      "zhName": "愛知縣西部",
      "koName": "아이치 현 서부",
      "esName": "Oeste de Prefectura de Aichi",
      "ptName": "Região Oeste da Província de Aichi",
      "thName": "จังหวัดไอจิฟากตะวันตก",
      "viName": "Miền Tây tỉnh Aichi",
      "inName": "Bagian Barat Prefektur Aichi",
      "tlName": "Kanlurang bahagi ng Aichi Prefecture",
      "moName": "Баруун Айчи аймаг",
      "buName": "အအိချိစီရင်စု အနောက်ပိုင်း",
      "khName": "តំបន់ខាងលិចនៃខេត្ដ​អៃឈិ",
      "neName": "आइची जिल्लाको पश्चिमी भाग"
    },
    "class15": {
      "code": "230011",
      "name": "尾張東部",
      "enName": "Eastern Owari"
    },
    "class20": {
      "code": "2320600",
      "name": "春日井市",
      "enName": "Kasugai City",
      "kana": "かすがいし",
      "chName": "春日井市",
      "zhName": "春日井市",
      "koName": "가스가이 시",
      "esName": "Ciudad de Kasugai",
      "ptName": "cidade de Kasugai",
      "thName": "เมืองคาสุกาอิ",
      "viName": "thành phố Kasugai",
      "inName": "kota Kasugai",
      "tlName": "siyudad ng Kasugai",
      "moName": "Касүгaй хот",
      "buName": "ကာဆူဂါးယိ မြို့",
      "khName": "ទីក្រុង កាស៊ូហ្គាយ",
      "neName": "कासुगाई सहर"
    }
  },
  "2320700": {
    "office": {
      "code": "230000",
      "name": "愛知県",
      "enName": "Aichi",
      "officeName": "名古屋地方気象台",
      "chName": "爱知县",
      "zhName": "愛知縣",
      "koName": "아이치현",
      "esName": "Prefectura de Aichi",
      "ptName": "Província de Aichi",
      "thName": "จังหวัดไอจิ",
      "viName": "Tỉnh Aichi",
      "inName": "Prefektur Aichi",
      "tlName": "Aichi Prefecture",
      "moName": "Айчи аймаг",
      "buName": "အိုင်အိကျိ ပြည်နယ်",
      "khName": "ខេត្ដ​ អាឈី",
      "neName": "आइची जिल्ला"
    },
    "class10": {
      "code": "230020",
      "name": "東部",
      "enName": "Eastern Region",
      "chName": "爱知县东部",
      "zhName": "愛知縣東部",
      "koName": "아이치 현 동부",
      "esName": "Este de Prefectura de Aichi",
      "ptName": "Região Leste da Província de Aichi",
      "thName": "จังหวัดไอจิฟากตะวันออก",
      "viName": "Miền Đông tỉnh Aichi",
      "inName": "Bagian Timur Prefektur Aichi",
      "tlName": "Silangang bahagi ng Aichi Prefecture",
      "moName": "Зүүн Айчи аймаг",
      "buName": "အအိချိစီရင်စု အရှေ့ပိုင်း",
      "khName": "តំបន់ខាងកើតនៃខេត្ដ​អៃឈិ",
      "neName": "आइची जिल्लाको पूर्वी भाग"
    },
    "class15": {
      "code": "230023",
      "name": "東三河南部",
      "enName": "Southern Higashi-mikawa Region"
    },
    "class20": {
      "code": "2320700",
      "name": "豊川市",
      "enName": "Toyokawa City",
      "kana": "とよかわし",
      "chName": "丰川市",
      "zhName": "豐川市",
      "koName": "도요카와 시",
      "esName": "Ciudad de Toyokawa",
      "ptName": "cidade de Toyokawa",
      "thName": "เมืองโทโยคาวา",
      "viName": "thành phố Toyokawa",
      "inName": "kota Toyokawa",
      "tlName": "siyudad ng Toyokawa",
      "moName": "Тоёкава хот",
      "buName": "တိုယိုကာ့ဝ မြို့",
      "khName": "ទីក្រុង តូយ៉ូកាវ៉ា",
      "neName": "तोयोकावा सहर"
    }
  },
  "2320800": {
    "office": {
      "code": "230000",
      "name": "愛知県",
      "enName": "Aichi",
      "officeName": "名古屋地方気象台",
      "chName": "爱知县",
      "zhName": "愛知縣",
      "koName": "아이치현",
      "esName": "Prefectura de Aichi",
      "ptName": "Província de Aichi",
      "thName": "จังหวัดไอจิ",
      "viName": "Tỉnh Aichi",
      "inName": "Prefektur Aichi",
      "tlName": "Aichi Prefecture",
      "moName": "Айчи аймаг",
      "buName": "အိုင်အိကျိ ပြည်နယ်",
      "khName": "ខេត្ដ​ អាឈី",
      "neName": "आइची जिल्ला"
    },
    "class10": {
      "code": "230010",
      "name": "西部",
      "enName": "Western Region",
      "chName": "爱知县西部",
      "zhName": "愛知縣西部",
      "koName": "아이치 현 서부",
      "esName": "Oeste de Prefectura de Aichi",
      "ptName": "Região Oeste da Província de Aichi",
      "thName": "จังหวัดไอจิฟากตะวันตก",
      "viName": "Miền Tây tỉnh Aichi",
      "inName": "Bagian Barat Prefektur Aichi",
      "tlName": "Kanlurang bahagi ng Aichi Prefecture",
      "moName": "Баруун Айчи аймаг",
      "buName": "အအိချိစီရင်စု အနောက်ပိုင်း",
      "khName": "តំបន់ខាងលិចនៃខេត្ដ​អៃឈិ",
      "neName": "आइची जिल्लाको पश्चिमी भाग"
    },
    "class15": {
      "code": "230012",
      "name": "尾張西部",
      "enName": "Western Owari"
    },
    "class20": {
      "code": "2320800",
      "name": "津島市",
      "enName": "Tsushima City",
      "kana": "つしまし",
      "chName": "爱知津岛市",
      "zhName": "愛知津島市",
      "koName": "아이치 쓰시마 시",
      "esName": "Ciudad de Tsushima, Aichi",
      "ptName": "Aichi, cidade de Tsushima",
      "thName": "เมืองสึชิมะ ไอจิ",
      "viName": "Thành phố Tsushima, Aichi",
      "inName": "Kota Tsushima, Aichi",
      "tlName": "siyudad ng Tsushima, Aichi",
      "moName": "Айчи Цүшима хот",
      "buName": "အအိချိဆုရှိမမြို့",
      "khName": "ទីក្រុងហ្សឹស៊ីម៉ា អៃឈិ",
      "neName": "आइची त्सुशिमा सहर"
    }
  },
  "2320900": {
    "office": {
      "code": "230000",
      "name": "愛知県",
      "enName": "Aichi",
      "officeName": "名古屋地方気象台",
      "chName": "爱知县",
      "zhName": "愛知縣",
      "koName": "아이치현",
      "esName": "Prefectura de Aichi",
      "ptName": "Província de Aichi",
      "thName": "จังหวัดไอจิ",
      "viName": "Tỉnh Aichi",
      "inName": "Prefektur Aichi",
      "tlName": "Aichi Prefecture",
      "moName": "Айчи аймаг",
      "buName": "အိုင်အိကျိ ပြည်နယ်",
      "khName": "ខេត្ដ​ អាឈី",
      "neName": "आइची जिल्ला"
    },
    "class10": {
      "code": "230010",
      "name": "西部",
      "enName": "Western Region",
      "chName": "爱知县西部",
      "zhName": "愛知縣西部",
      "koName": "아이치 현 서부",
      "esName": "Oeste de Prefectura de Aichi",
      "ptName": "Região Oeste da Província de Aichi",
      "thName": "จังหวัดไอจิฟากตะวันตก",
      "viName": "Miền Tây tỉnh Aichi",
      "inName": "Bagian Barat Prefektur Aichi",
      "tlName": "Kanlurang bahagi ng Aichi Prefecture",
      "moName": "Баруун Айчи аймаг",
      "buName": "အအိချိစီရင်စု အနောက်ပိုင်း",
      "khName": "តំបន់ខាងលិចនៃខេត្ដ​អៃឈិ",
      "neName": "आइची जिल्लाको पश्चिमी भाग"
    },
    "class15": {
      "code": "230014",
      "name": "西三河南部",
      "enName": "Southern Nishi-mikawa Region"
    },
    "class20": {
      "code": "2320900",
      "name": "碧南市",
      "enName": "Hekinan City",
      "kana": "へきなんし",
      "chName": "碧南市",
      "zhName": "碧南市",
      "koName": "헤키난 시",
      "esName": "Ciudad de Hekinan",
      "ptName": "cidade de Hekinan",
      "thName": "เมืองเฮคินัน",
      "viName": "thành phố Hekinan",
      "inName": "kota Hekinan",
      "tlName": "siyudad ng Hekinan",
      "moName": "Хэкинан хот",
      "buName": "ဟဲကိနန် မြို့",
      "khName": "ទីក្រុង ហេគីណាន",
      "neName": "हेकिनान सहर"
    }
  },
  "2321000": {
    "office": {
      "code": "230000",
      "name": "愛知県",
      "enName": "Aichi",
      "officeName": "名古屋地方気象台",
      "chName": "爱知县",
      "zhName": "愛知縣",
      "koName": "아이치현",
      "esName": "Prefectura de Aichi",
      "ptName": "Província de Aichi",
      "thName": "จังหวัดไอจิ",
      "viName": "Tỉnh Aichi",
      "inName": "Prefektur Aichi",
      "tlName": "Aichi Prefecture",
      "moName": "Айчи аймаг",
      "buName": "အိုင်အိကျိ ပြည်နယ်",
      "khName": "ខេត្ដ​ អាឈី",
      "neName": "आइची जिल्ला"
    },
    "class10": {
      "code": "230010",
      "name": "西部",
      "enName": "Western Region",
      "chName": "爱知县西部",
      "zhName": "愛知縣西部",
      "koName": "아이치 현 서부",
      "esName": "Oeste de Prefectura de Aichi",
      "ptName": "Região Oeste da Província de Aichi",
      "thName": "จังหวัดไอจิฟากตะวันตก",
      "viName": "Miền Tây tỉnh Aichi",
      "inName": "Bagian Barat Prefektur Aichi",
      "tlName": "Kanlurang bahagi ng Aichi Prefecture",
      "moName": "Баруун Айчи аймаг",
      "buName": "အအိချိစီရင်စု အနောက်ပိုင်း",
      "khName": "តំបន់ខាងលិចនៃខេត្ដ​អៃឈិ",
      "neName": "आइची जिल्लाको पश्चिमी भाग"
    },
    "class15": {
      "code": "230014",
      "name": "西三河南部",
      "enName": "Southern Nishi-mikawa Region"
    },
    "class20": {
      "code": "2321000",
      "name": "刈谷市",
      "enName": "Kariya City",
      "kana": "かりやし",
      "chName": "刈谷市",
      "zhName": "刈谷市",
      "koName": "가리야 시",
      "esName": "Ciudad de Kariya",
      "ptName": "cidade de Kariya",
      "thName": "เมืองคาริยะ",
      "viName": "thành phố Kariya",
      "inName": "kota Kariya",
      "tlName": "siyudad ng Kariya",
      "moName": "Кария хот",
      "buName": "ခါရိယ မြို့",
      "khName": "ទីក្រុង ការីយ៉ា",
      "neName": "कारिया सहर"
    }
  },
  "2321101": {
    "office": {
      "code": "230000",
      "name": "愛知県",
      "enName": "Aichi",
      "officeName": "名古屋地方気象台",
      "chName": "爱知县",
      "zhName": "愛知縣",
      "koName": "아이치현",
      "esName": "Prefectura de Aichi",
      "ptName": "Província de Aichi",
      "thName": "จังหวัดไอจิ",
      "viName": "Tỉnh Aichi",
      "inName": "Prefektur Aichi",
      "tlName": "Aichi Prefecture",
      "moName": "Айчи аймаг",
      "buName": "အိုင်အိကျိ ပြည်နယ်",
      "khName": "ខេត្ដ​ អាឈី",
      "neName": "आइची जिल्ला"
    },
    "class10": {
      "code": "230010",
      "name": "西部",
      "enName": "Western Region",
      "chName": "爱知县西部",
      "zhName": "愛知縣西部",
      "koName": "아이치 현 서부",
      "esName": "Oeste de Prefectura de Aichi",
      "ptName": "Região Oeste da Província de Aichi",
      "thName": "จังหวัดไอจิฟากตะวันตก",
      "viName": "Miền Tây tỉnh Aichi",
      "inName": "Bagian Barat Prefektur Aichi",
      "tlName": "Kanlurang bahagi ng Aichi Prefecture",
      "moName": "Баруун Айчи аймаг",
      "buName": "အအိချိစီရင်စု အနောက်ပိုင်း",
      "khName": "តំបន់ខាងលិចនៃខេត្ដ​អៃឈិ",
      "neName": "आइची जिल्लाको पश्चिमी भाग"
    },
    "class15": {
      "code": "230015",
      "name": "西三河北西部",
      "enName": "North-western Nishi-mikawa Region"
    },
    "class20": {
      "code": "2321101",
      "name": "豊田市西部",
      "enName": "Western Toyota City",
      "kana": "とよたしせいぶ",
      "chName": "丰田市",
      "zhName": "丰田市",
      "koName": "도요타시",
      "esName": "Ciudad de Toyota",
      "ptName": "Cidade de Toyota",
      "thName": "เมืองโตโยตะ",
      "viName": "Thành phố Toyota",
      "inName": "Kota Toyota",
      "tlName": "Lungsod ng Toyota",
      "moName": "Cidade de Toyota",
      "buName": "တောယိုတမြို့",
      "khName": "ខេត្តតូយ៉ូតា",
      "neName": "टोयोता शहर"
    }
  },
  "2321102": {
    "office": {
      "code": "230000",
      "name": "愛知県",
      "enName": "Aichi",
      "officeName": "名古屋地方気象台",
      "chName": "爱知县",
      "zhName": "愛知縣",
      "koName": "아이치현",
      "esName": "Prefectura de Aichi",
      "ptName": "Província de Aichi",
      "thName": "จังหวัดไอจิ",
      "viName": "Tỉnh Aichi",
      "inName": "Prefektur Aichi",
      "tlName": "Aichi Prefecture",
      "moName": "Айчи аймаг",
      "buName": "အိုင်အိကျိ ပြည်နယ်",
      "khName": "ខេត្ដ​ អាឈី",
      "neName": "आइची जिल्ला"
    },
    "class10": {
      "code": "230020",
      "name": "東部",
      "enName": "Eastern Region",
      "chName": "爱知县东部",
      "zhName": "愛知縣東部",
      "koName": "아이치 현 동부",
      "esName": "Este de Prefectura de Aichi",
      "ptName": "Região Leste da Província de Aichi",
      "thName": "จังหวัดไอจิฟากตะวันออก",
      "viName": "Miền Đông tỉnh Aichi",
      "inName": "Bagian Timur Prefektur Aichi",
      "tlName": "Silangang bahagi ng Aichi Prefecture",
      "moName": "Зүүн Айчи аймаг",
      "buName": "အအိချိစီရင်စု အရှေ့ပိုင်း",
      "khName": "តំបន់ខាងកើតនៃខេត្ដ​អៃឈិ",
      "neName": "आइची जिल्लाको पूर्वी भाग"
    },
    "class15": {
      "code": "230021",
      "name": "西三河北東部",
      "enName": "North-eastern Nishi-mikawa Region"
    },
    "class20": {
      "code": "2321102",
      "name": "豊田市東部",
      "enName": "Eastern Toyota City",
      "kana": "とよたしとうぶ",
      "chName": "丰田市",
      "zhName": "丰田市",
      "koName": "도요타시",
      "esName": "Ciudad de Toyota",
      "ptName": "Cidade de Toyota",
      "thName": "เมืองโตโยตะ",
      "viName": "Thành phố Toyota",
      "inName": "Kota Toyota",
      "tlName": "Lungsod ng Toyota",
      "moName": "Cidade de Toyota",
      "buName": "တောယိုတမြို့",
      "khName": "ខេត្តតូយ៉ូតា",
      "neName": "टोयोता शहर"
    }
  },
  "2321200": {
    "office": {
      "code": "230000",
      "name": "愛知県",
      "enName": "Aichi",
      "officeName": "名古屋地方気象台",
      "chName": "爱知县",
      "zhName": "愛知縣",
      "koName": "아이치현",
      "esName": "Prefectura de Aichi",
      "ptName": "Província de Aichi",
      "thName": "จังหวัดไอจิ",
      "viName": "Tỉnh Aichi",
      "inName": "Prefektur Aichi",
      "tlName": "Aichi Prefecture",
      "moName": "Айчи аймаг",
      "buName": "အိုင်အိကျိ ပြည်နယ်",
      "khName": "ខេត្ដ​ អាឈី",
      "neName": "आइची जिल्ला"
    },
    "class10": {
      "code": "230010",
      "name": "西部",
      "enName": "Western Region",
      "chName": "爱知县西部",
      "zhName": "愛知縣西部",
      "koName": "아이치 현 서부",
      "esName": "Oeste de Prefectura de Aichi",
      "ptName": "Região Oeste da Província de Aichi",
      "thName": "จังหวัดไอจิฟากตะวันตก",
      "viName": "Miền Tây tỉnh Aichi",
      "inName": "Bagian Barat Prefektur Aichi",
      "tlName": "Kanlurang bahagi ng Aichi Prefecture",
      "moName": "Баруун Айчи аймаг",
      "buName": "အအိချိစီရင်စု အနောက်ပိုင်း",
      "khName": "តំបន់ខាងលិចនៃខេត្ដ​អៃឈិ",
      "neName": "आइची जिल्लाको पश्चिमी भाग"
    },
    "class15": {
      "code": "230014",
      "name": "西三河南部",
      "enName": "Southern Nishi-mikawa Region"
    },
    "class20": {
      "code": "2321200",
      "name": "安城市",
      "enName": "Anjo City",
      "kana": "あんじょうし",
      "chName": "安城市",
      "zhName": "安城市",
      "koName": "안조 시",
      "esName": "Ciudad de Anjyo",
      "ptName": "cidade de Anjo",
      "thName": "เมืองอันโจ",
      "viName": "thành phố Anjo",
      "inName": "kota Anjo",
      "tlName": "siyudad ng Anjo",
      "moName": "Анжо хот",
      "buName": "အန်ဂျို မြို့",
      "khName": "ទីក្រុង អាន់ជូ",
      "neName": "आन्जो सहर"
    }
  },
  "2321300": {
    "office": {
      "code": "230000",
      "name": "愛知県",
      "enName": "Aichi",
      "officeName": "名古屋地方気象台",
      "chName": "爱知县",
      "zhName": "愛知縣",
      "koName": "아이치현",
      "esName": "Prefectura de Aichi",
      "ptName": "Província de Aichi",
      "thName": "จังหวัดไอจิ",
      "viName": "Tỉnh Aichi",
      "inName": "Prefektur Aichi",
      "tlName": "Aichi Prefecture",
      "moName": "Айчи аймаг",
      "buName": "အိုင်အိကျိ ပြည်နယ်",
      "khName": "ខេត្ដ​ អាឈី",
      "neName": "आइची जिल्ला"
    },
    "class10": {
      "code": "230010",
      "name": "西部",
      "enName": "Western Region",
      "chName": "爱知县西部",
      "zhName": "愛知縣西部",
      "koName": "아이치 현 서부",
      "esName": "Oeste de Prefectura de Aichi",
      "ptName": "Região Oeste da Província de Aichi",
      "thName": "จังหวัดไอจิฟากตะวันตก",
      "viName": "Miền Tây tỉnh Aichi",
      "inName": "Bagian Barat Prefektur Aichi",
      "tlName": "Kanlurang bahagi ng Aichi Prefecture",
      "moName": "Баруун Айчи аймаг",
      "buName": "အအိချိစီရင်စု အနောက်ပိုင်း",
      "khName": "តំបន់ខាងលិចនៃខេត្ដ​អៃឈិ",
      "neName": "आइची जिल्लाको पश्चिमी भाग"
    },
    "class15": {
      "code": "230014",
      "name": "西三河南部",
      "enName": "Southern Nishi-mikawa Region"
    },
    "class20": {
      "code": "2321300",
      "name": "西尾市",
      "enName": "Nishio City",
      "kana": "にしおし",
      "chName": "西尾市",
      "zhName": "西尾市",
      "koName": "니시오 시",
      "esName": "Ciudad de Nishio",
      "ptName": "cidade de Nishio",
      "thName": "เมืองนิชิโอ",
      "viName": "thành phố Nishio",
      "inName": "kota Nishio",
      "tlName": "siyudad ng Nishio",
      "moName": "Нишио хот",
      "buName": "နီရှီရို မြို့",
      "khName": "ទីក្រុង នីស៊ីអូ",
      "neName": "निशियो सहर"
    }
  },
  "2321400": {
    "office": {
      "code": "230000",
      "name": "愛知県",
      "enName": "Aichi",
      "officeName": "名古屋地方気象台",
      "chName": "爱知县",
      "zhName": "愛知縣",
      "koName": "아이치현",
      "esName": "Prefectura de Aichi",
      "ptName": "Província de Aichi",
      "thName": "จังหวัดไอจิ",
      "viName": "Tỉnh Aichi",
      "inName": "Prefektur Aichi",
      "tlName": "Aichi Prefecture",
      "moName": "Айчи аймаг",
      "buName": "အိုင်အိကျိ ပြည်နယ်",
      "khName": "ខេត្ដ​ អាឈី",
      "neName": "आइची जिल्ला"
    },
    "class10": {
      "code": "230020",
      "name": "東部",
      "enName": "Eastern Region",
      "chName": "爱知县东部",
      "zhName": "愛知縣東部",
      "koName": "아이치 현 동부",
      "esName": "Este de Prefectura de Aichi",
      "ptName": "Região Leste da Província de Aichi",
      "thName": "จังหวัดไอจิฟากตะวันออก",
      "viName": "Miền Đông tỉnh Aichi",
      "inName": "Bagian Timur Prefektur Aichi",
      "tlName": "Silangang bahagi ng Aichi Prefecture",
      "moName": "Зүүн Айчи аймаг",
      "buName": "အအိချိစီရင်စု အရှေ့ပိုင်း",
      "khName": "តំបន់ខាងកើតនៃខេត្ដ​អៃឈិ",
      "neName": "आइची जिल्लाको पूर्वी भाग"
    },
    "class15": {
      "code": "230023",
      "name": "東三河南部",
      "enName": "Southern Higashi-mikawa Region"
    },
    "class20": {
      "code": "2321400",
      "name": "蒲郡市",
      "enName": "Gamagori City",
      "kana": "がまごおりし",
      "chName": "蒲郡市",
      "zhName": "蒲郡市",
      "koName": "가마고리 시",
      "esName": "Ciudad de Gamagori",
      "ptName": "cidade de Gamagori",
      "thName": "เมืองกามาโกริ",
      "viName": "thành phố Gamagori",
      "inName": "kota Gamagori",
      "tlName": "siyudad ng Gamagori",
      "moName": "Гaмaгори хот",
      "buName": "ဂါမဂိုးရိ မြို့",
      "khName": "ទីក្រុង ហ្គាម៉ាហ្គូរី",
      "neName": "गामागोरी सहर"
    }
  },
  "2321500": {
    "office": {
      "code": "230000",
      "name": "愛知県",
      "enName": "Aichi",
      "officeName": "名古屋地方気象台",
      "chName": "爱知县",
      "zhName": "愛知縣",
      "koName": "아이치현",
      "esName": "Prefectura de Aichi",
      "ptName": "Província de Aichi",
      "thName": "จังหวัดไอจิ",
      "viName": "Tỉnh Aichi",
      "inName": "Prefektur Aichi",
      "tlName": "Aichi Prefecture",
      "moName": "Айчи аймаг",
      "buName": "အိုင်အိကျိ ပြည်နယ်",
      "khName": "ខេត្ដ​ អាឈី",
      "neName": "आइची जिल्ला"
    },
    "class10": {
      "code": "230010",
      "name": "西部",
      "enName": "Western Region",
      "chName": "爱知县西部",
      "zhName": "愛知縣西部",
      "koName": "아이치 현 서부",
      "esName": "Oeste de Prefectura de Aichi",
      "ptName": "Região Oeste da Província de Aichi",
      "thName": "จังหวัดไอจิฟากตะวันตก",
      "viName": "Miền Tây tỉnh Aichi",
      "inName": "Bagian Barat Prefektur Aichi",
      "tlName": "Kanlurang bahagi ng Aichi Prefecture",
      "moName": "Баруун Айчи аймаг",
      "buName": "အအိချိစီရင်စု အနောက်ပိုင်း",
      "khName": "តំបន់ខាងលិចនៃខេត្ដ​អៃឈិ",
      "neName": "आइची जिल्लाको पश्चिमी भाग"
    },
    "class15": {
      "code": "230011",
      "name": "尾張東部",
      "enName": "Eastern Owari"
    },
    "class20": {
      "code": "2321500",
      "name": "犬山市",
      "enName": "Inuyama City",
      "kana": "いぬやまし",
      "chName": "犬山市",
      "zhName": "犬山市",
      "koName": "이누야마 시",
      "esName": "Ciiudad de Inuyama",
      "ptName": "cidade de Inuyama",
      "thName": "เมืองอินุยามะ",
      "viName": "thành phố Inuyama",
      "inName": "kota Inuyama",
      "tlName": "siyudad ng Inuyama",
      "moName": "Инүямa хот",
      "buName": "အီနုယာ့မ မြို့",
      "khName": "ទីក្រុង អ៊ីនណូយ៉ាម៉ា",
      "neName": "इनुयामा सहर"
    }
  },
  "2321600": {
    "office": {
      "code": "230000",
      "name": "愛知県",
      "enName": "Aichi",
      "officeName": "名古屋地方気象台",
      "chName": "爱知县",
      "zhName": "愛知縣",
      "koName": "아이치현",
      "esName": "Prefectura de Aichi",
      "ptName": "Província de Aichi",
      "thName": "จังหวัดไอจิ",
      "viName": "Tỉnh Aichi",
      "inName": "Prefektur Aichi",
      "tlName": "Aichi Prefecture",
      "moName": "Айчи аймаг",
      "buName": "အိုင်အိကျိ ပြည်နယ်",
      "khName": "ខេត្ដ​ អាឈី",
      "neName": "आइची जिल्ला"
    },
    "class10": {
      "code": "230010",
      "name": "西部",
      "enName": "Western Region",
      "chName": "爱知县西部",
      "zhName": "愛知縣西部",
      "koName": "아이치 현 서부",
      "esName": "Oeste de Prefectura de Aichi",
      "ptName": "Região Oeste da Província de Aichi",
      "thName": "จังหวัดไอจิฟากตะวันตก",
      "viName": "Miền Tây tỉnh Aichi",
      "inName": "Bagian Barat Prefektur Aichi",
      "tlName": "Kanlurang bahagi ng Aichi Prefecture",
      "moName": "Баруун Айчи аймаг",
      "buName": "အအိချိစီရင်စု အနောက်ပိုင်း",
      "khName": "តំបន់ខាងលិចនៃខេត្ដ​អៃឈិ",
      "neName": "आइची जिल्लाको पश्चिमी भाग"
    },
    "class15": {
      "code": "230013",
      "name": "知多地域",
      "enName": "Chita Area"
    },
    "class20": {
      "code": "2321600",
      "name": "常滑市",
      "enName": "Tokoname City",
      "kana": "とこなめし",
      "chName": "常滑市",
      "zhName": "常滑市",
      "koName": "도코나메 시",
      "esName": "Ciudad de Tokoname",
      "ptName": "cidade de Tokoname",
      "thName": "เมืองโทโกนาเมะ",
      "viName": "thành phố Tokoname",
      "inName": "kota Tokoname",
      "tlName": "siyudad ng Tokoname",
      "moName": "Токонaмэ хот",
      "buName": "တိုကိုးနာ့မဲ့ မြို့",
      "khName": "ទីក្រុង តូខុនណេម",
      "neName": "तोकोनामे सहर"
    }
  },
  "2321700": {
    "office": {
      "code": "230000",
      "name": "愛知県",
      "enName": "Aichi",
      "officeName": "名古屋地方気象台",
      "chName": "爱知县",
      "zhName": "愛知縣",
      "koName": "아이치현",
      "esName": "Prefectura de Aichi",
      "ptName": "Província de Aichi",
      "thName": "จังหวัดไอจิ",
      "viName": "Tỉnh Aichi",
      "inName": "Prefektur Aichi",
      "tlName": "Aichi Prefecture",
      "moName": "Айчи аймаг",
      "buName": "အိုင်အိကျိ ပြည်နယ်",
      "khName": "ខេត្ដ​ អាឈី",
      "neName": "आइची जिल्ला"
    },
    "class10": {
      "code": "230010",
      "name": "西部",
      "enName": "Western Region",
      "chName": "爱知县西部",
      "zhName": "愛知縣西部",
      "koName": "아이치 현 서부",
      "esName": "Oeste de Prefectura de Aichi",
      "ptName": "Região Oeste da Província de Aichi",
      "thName": "จังหวัดไอจิฟากตะวันตก",
      "viName": "Miền Tây tỉnh Aichi",
      "inName": "Bagian Barat Prefektur Aichi",
      "tlName": "Kanlurang bahagi ng Aichi Prefecture",
      "moName": "Баруун Айчи аймаг",
      "buName": "အအိချိစီရင်စု အနောက်ပိုင်း",
      "khName": "តំបន់ខាងលិចនៃខេត្ដ​អៃឈិ",
      "neName": "आइची जिल्लाको पश्चिमी भाग"
    },
    "class15": {
      "code": "230012",
      "name": "尾張西部",
      "enName": "Western Owari"
    },
    "class20": {
      "code": "2321700",
      "name": "江南市",
      "enName": "Konan City",
      "kana": "こうなんし",
      "chName": "爱知江南市",
      "zhName": "愛知江南市",
      "koName": "아이치 코난 시",
      "esName": "Ciudad de Konan, Aichi",
      "ptName": "Aichi, cidade de Konan",
      "thName": "เมืองโคนัน ไอจิ",
      "viName": "Thành phố Konan, Aichi",
      "inName": "Kota Konan, Aichi",
      "tlName": "siyudad ng Konan, Aichi",
      "moName": "Айчи Конан хот",
      "buName": "အအိချိကိုးနန်းမြို့",
      "khName": "ទីក្រុងខូណាន អៃឈិ",
      "neName": "आइची कोनान सहर"
    }
  },
  "2321900": {
    "office": {
      "code": "230000",
      "name": "愛知県",
      "enName": "Aichi",
      "officeName": "名古屋地方気象台",
      "chName": "爱知县",
      "zhName": "愛知縣",
      "koName": "아이치현",
      "esName": "Prefectura de Aichi",
      "ptName": "Província de Aichi",
      "thName": "จังหวัดไอจิ",
      "viName": "Tỉnh Aichi",
      "inName": "Prefektur Aichi",
      "tlName": "Aichi Prefecture",
      "moName": "Айчи аймаг",
      "buName": "အိုင်အိကျိ ပြည်နယ်",
      "khName": "ខេត្ដ​ អាឈី",
      "neName": "आइची जिल्ला"
    },
    "class10": {
      "code": "230010",
      "name": "西部",
      "enName": "Western Region",
      "chName": "爱知县西部",
      "zhName": "愛知縣西部",
      "koName": "아이치 현 서부",
      "esName": "Oeste de Prefectura de Aichi",
      "ptName": "Região Oeste da Província de Aichi",
      "thName": "จังหวัดไอจิฟากตะวันตก",
      "viName": "Miền Tây tỉnh Aichi",
      "inName": "Bagian Barat Prefektur Aichi",
      "tlName": "Kanlurang bahagi ng Aichi Prefecture",
      "moName": "Баруун Айчи аймаг",
      "buName": "အအိချိစီရင်စု အနောက်ပိုင်း",
      "khName": "តំបន់ខាងលិចនៃខេត្ដ​អៃឈិ",
      "neName": "आइची जिल्लाको पश्चिमी भाग"
    },
    "class15": {
      "code": "230011",
      "name": "尾張東部",
      "enName": "Eastern Owari"
    },
    "class20": {
      "code": "2321900",
      "name": "小牧市",
      "enName": "Komaki City",
      "kana": "こまきし",
      "chName": "小牧市",
      "zhName": "小牧市",
      "koName": "고마키 시",
      "esName": "Ciudad de Komaki",
      "ptName": "cidade de Komaki",
      "thName": "เมืองโคมากิ",
      "viName": "thành phố Komaki",
      "inName": "kota Komaki",
      "tlName": "siyudad ng Komaki",
      "moName": "Комaки хот",
      "buName": "ကိုမားကိ မြို့",
      "khName": "ទីក្រុង កូម៉ាគី",
      "neName": "कोमाकी सहर"
    }
  },
  "2322000": {
    "office": {
      "code": "230000",
      "name": "愛知県",
      "enName": "Aichi",
      "officeName": "名古屋地方気象台",
      "chName": "爱知县",
      "zhName": "愛知縣",
      "koName": "아이치현",
      "esName": "Prefectura de Aichi",
      "ptName": "Província de Aichi",
      "thName": "จังหวัดไอจิ",
      "viName": "Tỉnh Aichi",
      "inName": "Prefektur Aichi",
      "tlName": "Aichi Prefecture",
      "moName": "Айчи аймаг",
      "buName": "အိုင်အိကျိ ပြည်နယ်",
      "khName": "ខេត្ដ​ អាឈី",
      "neName": "आइची जिल्ला"
    },
    "class10": {
      "code": "230010",
      "name": "西部",
      "enName": "Western Region",
      "chName": "爱知县西部",
      "zhName": "愛知縣西部",
      "koName": "아이치 현 서부",
      "esName": "Oeste de Prefectura de Aichi",
      "ptName": "Região Oeste da Província de Aichi",
      "thName": "จังหวัดไอจิฟากตะวันตก",
      "viName": "Miền Tây tỉnh Aichi",
      "inName": "Bagian Barat Prefektur Aichi",
      "tlName": "Kanlurang bahagi ng Aichi Prefecture",
      "moName": "Баруун Айчи аймаг",
      "buName": "အအိချိစီရင်စု အနောက်ပိုင်း",
      "khName": "តំបន់ខាងលិចនៃខេត្ដ​អៃឈិ",
      "neName": "आइची जिल्लाको पश्चिमी भाग"
    },
    "class15": {
      "code": "230012",
      "name": "尾張西部",
      "enName": "Western Owari"
    },
    "class20": {
      "code": "2322000",
      "name": "稲沢市",
      "enName": "Inazawa City",
      "kana": "いなざわし",
      "chName": "稻泽市",
      "zhName": "稻澤市",
      "koName": "이나자와 시",
      "esName": "Ciudad de Inazawa",
      "ptName": "cidade de Inazawa",
      "thName": "เมืองอินาซาวา",
      "viName": "thành phố Inazawa",
      "inName": "kota Inazawa",
      "tlName": "siyudad ng Inazawa",
      "moName": "Инaзава хот",
      "buName": "အီနားဇာ့ဝ မြို့",
      "khName": "ទីក្រុង អ៊ីំណាហ្សាវ៉ា",
      "neName": "इनाजावा सहर"
    }
  },
  "2322100": {
    "office": {
      "code": "230000",
      "name": "愛知県",
      "enName": "Aichi",
      "officeName": "名古屋地方気象台",
      "chName": "爱知县",
      "zhName": "愛知縣",
      "koName": "아이치현",
      "esName": "Prefectura de Aichi",
      "ptName": "Província de Aichi",
      "thName": "จังหวัดไอจิ",
      "viName": "Tỉnh Aichi",
      "inName": "Prefektur Aichi",
      "tlName": "Aichi Prefecture",
      "moName": "Айчи аймаг",
      "buName": "အိုင်အိကျိ ပြည်နယ်",
      "khName": "ខេត្ដ​ អាឈី",
      "neName": "आइची जिल्ला"
    },
    "class10": {
      "code": "230020",
      "name": "東部",
      "enName": "Eastern Region",
      "chName": "爱知县东部",
      "zhName": "愛知縣東部",
      "koName": "아이치 현 동부",
      "esName": "Este de Prefectura de Aichi",
      "ptName": "Região Leste da Província de Aichi",
      "thName": "จังหวัดไอจิฟากตะวันออก",
      "viName": "Miền Đông tỉnh Aichi",
      "inName": "Bagian Timur Prefektur Aichi",
      "tlName": "Silangang bahagi ng Aichi Prefecture",
      "moName": "Зүүн Айчи аймаг",
      "buName": "အအိချိစီရင်စု အရှေ့ပိုင်း",
      "khName": "តំបន់ខាងកើតនៃខេត្ដ​អៃឈិ",
      "neName": "आइची जिल्लाको पूर्वी भाग"
    },
    "class15": {
      "code": "230022",
      "name": "東三河北部",
      "enName": "Northern Higashi-mikawa Region"
    },
    "class20": {
      "code": "2322100",
      "name": "新城市",
      "enName": "Shinshiro City",
      "kana": "しんしろし",
      "chName": "新城市",
      "zhName": "新城市",
      "koName": "신시로 시",
      "esName": "Ciudad de Shinshiro",
      "ptName": "cidade de Shinshiro",
      "thName": "เมืองชินชิโระ",
      "viName": "thành phố Shinshiro",
      "inName": "kota Shinshiro",
      "tlName": "siyudad ng Shinshiro",
      "moName": "Шинширо хот",
      "buName": "ရှင်ရှီရို မြို့",
      "khName": "ទីក្រុង ស៊ីនស៊ីរ៉ូ",
      "neName": "शिन्शिरो सहर"
    }
  },
  "2322200": {
    "office": {
      "code": "230000",
      "name": "愛知県",
      "enName": "Aichi",
      "officeName": "名古屋地方気象台",
      "chName": "爱知县",
      "zhName": "愛知縣",
      "koName": "아이치현",
      "esName": "Prefectura de Aichi",
      "ptName": "Província de Aichi",
      "thName": "จังหวัดไอจิ",
      "viName": "Tỉnh Aichi",
      "inName": "Prefektur Aichi",
      "tlName": "Aichi Prefecture",
      "moName": "Айчи аймаг",
      "buName": "အိုင်အိကျိ ပြည်နယ်",
      "khName": "ខេត្ដ​ អាឈី",
      "neName": "आइची जिल्ला"
    },
    "class10": {
      "code": "230010",
      "name": "西部",
      "enName": "Western Region",
      "chName": "爱知县西部",
      "zhName": "愛知縣西部",
      "koName": "아이치 현 서부",
      "esName": "Oeste de Prefectura de Aichi",
      "ptName": "Região Oeste da Província de Aichi",
      "thName": "จังหวัดไอจิฟากตะวันตก",
      "viName": "Miền Tây tỉnh Aichi",
      "inName": "Bagian Barat Prefektur Aichi",
      "tlName": "Kanlurang bahagi ng Aichi Prefecture",
      "moName": "Баруун Айчи аймаг",
      "buName": "အအိချိစီရင်စု အနောက်ပိုင်း",
      "khName": "តំបន់ខាងលិចនៃខេត្ដ​អៃឈិ",
      "neName": "आइची जिल्लाको पश्चिमी भाग"
    },
    "class15": {
      "code": "230013",
      "name": "知多地域",
      "enName": "Chita Area"
    },
    "class20": {
      "code": "2322200",
      "name": "東海市",
      "enName": "Tokai City",
      "kana": "とうかいし",
      "chName": "东海市",
      "zhName": "東海市",
      "koName": "도카이 시",
      "esName": "Ciudad de Tokai",
      "ptName": "cidade de Tokai",
      "thName": "เมืองโตไก",
      "viName": "thành phố Tokai",
      "inName": "kota Tokai",
      "tlName": "siyudad ng Tokai",
      "moName": "Токай хот",
      "buName": "တိုကိုင်းယိ မြို့",
      "khName": "ទីក្រុង តូកៃ",
      "neName": "तोकाई सहर"
    }
  },
  "2322300": {
    "office": {
      "code": "230000",
      "name": "愛知県",
      "enName": "Aichi",
      "officeName": "名古屋地方気象台",
      "chName": "爱知县",
      "zhName": "愛知縣",
      "koName": "아이치현",
      "esName": "Prefectura de Aichi",
      "ptName": "Província de Aichi",
      "thName": "จังหวัดไอจิ",
      "viName": "Tỉnh Aichi",
      "inName": "Prefektur Aichi",
      "tlName": "Aichi Prefecture",
      "moName": "Айчи аймаг",
      "buName": "အိုင်အိကျိ ပြည်နယ်",
      "khName": "ខេត្ដ​ អាឈី",
      "neName": "आइची जिल्ला"
    },
    "class10": {
      "code": "230010",
      "name": "西部",
      "enName": "Western Region",
      "chName": "爱知县西部",
      "zhName": "愛知縣西部",
      "koName": "아이치 현 서부",
      "esName": "Oeste de Prefectura de Aichi",
      "ptName": "Região Oeste da Província de Aichi",
      "thName": "จังหวัดไอจิฟากตะวันตก",
      "viName": "Miền Tây tỉnh Aichi",
      "inName": "Bagian Barat Prefektur Aichi",
      "tlName": "Kanlurang bahagi ng Aichi Prefecture",
      "moName": "Баруун Айчи аймаг",
      "buName": "အအိချိစီရင်စု အနောက်ပိုင်း",
      "khName": "តំបន់ខាងលិចនៃខេត្ដ​អៃឈិ",
      "neName": "आइची जिल्लाको पश्चिमी भाग"
    },
    "class15": {
      "code": "230013",
      "name": "知多地域",
      "enName": "Chita Area"
    },
    "class20": {
      "code": "2322300",
      "name": "大府市",
      "enName": "Obu City",
      "kana": "おおぶし",
      "chName": "大府市",
      "zhName": "大府市",
      "koName": "오부 시",
      "esName": "Ciudad de Obu",
      "ptName": "cidade de Obu",
      "thName": "เมืองโอบุ",
      "viName": "thành phố Obu",
      "inName": "kota Obu",
      "tlName": "siyudad ng Obu",
      "moName": "Обү хот",
      "buName": "အိုးဗု မြို့",
      "khName": "ទីក្រុង អូបូ",
      "neName": "ओबु सहर"
    }
  },
  "2322400": {
    "office": {
      "code": "230000",
      "name": "愛知県",
      "enName": "Aichi",
      "officeName": "名古屋地方気象台",
      "chName": "爱知县",
      "zhName": "愛知縣",
      "koName": "아이치현",
      "esName": "Prefectura de Aichi",
      "ptName": "Província de Aichi",
      "thName": "จังหวัดไอจิ",
      "viName": "Tỉnh Aichi",
      "inName": "Prefektur Aichi",
      "tlName": "Aichi Prefecture",
      "moName": "Айчи аймаг",
      "buName": "အိုင်အိကျိ ပြည်နယ်",
      "khName": "ខេត្ដ​ អាឈី",
      "neName": "आइची जिल्ला"
    },
    "class10": {
      "code": "230010",
      "name": "西部",
      "enName": "Western Region",
      "chName": "爱知县西部",
      "zhName": "愛知縣西部",
      "koName": "아이치 현 서부",
      "esName": "Oeste de Prefectura de Aichi",
      "ptName": "Região Oeste da Província de Aichi",
      "thName": "จังหวัดไอจิฟากตะวันตก",
      "viName": "Miền Tây tỉnh Aichi",
      "inName": "Bagian Barat Prefektur Aichi",
      "tlName": "Kanlurang bahagi ng Aichi Prefecture",
      "moName": "Баруун Айчи аймаг",
      "buName": "အအိချိစီရင်စု အနောက်ပိုင်း",
      "khName": "តំបន់ខាងលិចនៃខេត្ដ​អៃឈិ",
      "neName": "आइची जिल्लाको पश्चिमी भाग"
    },
    "class15": {
      "code": "230013",
      "name": "知多地域",
      "enName": "Chita Area"
    },
    "class20": {
      "code": "2322400",
      "name": "知多市",
      "enName": "Chita City",
      "kana": "ちたし",
      "chName": "知多市",
      "zhName": "知多市",
      "koName": "지타 시",
      "esName": "Ciudad de Chita",
      "ptName": "cidade de Chita",
      "thName": "เมืองชิตะ",
      "viName": "thành phố Chita",
      "inName": "kota Chita",
      "tlName": "siyudad ng Chita",
      "moName": "Чита хот",
      "buName": "ကျိတ မြို့",
      "khName": "ទីក្រុង ជីតា",
      "neName": "चिता सहर"
    }
  },
  "2322500": {
    "office": {
      "code": "230000",
      "name": "愛知県",
      "enName": "Aichi",
      "officeName": "名古屋地方気象台",
      "chName": "爱知县",
      "zhName": "愛知縣",
      "koName": "아이치현",
      "esName": "Prefectura de Aichi",
      "ptName": "Província de Aichi",
      "thName": "จังหวัดไอจิ",
      "viName": "Tỉnh Aichi",
      "inName": "Prefektur Aichi",
      "tlName": "Aichi Prefecture",
      "moName": "Айчи аймаг",
      "buName": "အိုင်အိကျိ ပြည်နယ်",
      "khName": "ខេត្ដ​ អាឈី",
      "neName": "आइची जिल्ला"
    },
    "class10": {
      "code": "230010",
      "name": "西部",
      "enName": "Western Region",
      "chName": "爱知县西部",
      "zhName": "愛知縣西部",
      "koName": "아이치 현 서부",
      "esName": "Oeste de Prefectura de Aichi",
      "ptName": "Região Oeste da Província de Aichi",
      "thName": "จังหวัดไอจิฟากตะวันตก",
      "viName": "Miền Tây tỉnh Aichi",
      "inName": "Bagian Barat Prefektur Aichi",
      "tlName": "Kanlurang bahagi ng Aichi Prefecture",
      "moName": "Баруун Айчи аймаг",
      "buName": "အအိချိစီရင်စု အနောက်ပိုင်း",
      "khName": "តំបន់ខាងលិចនៃខេត្ដ​អៃឈិ",
      "neName": "आइची जिल्लाको पश्चिमी भाग"
    },
    "class15": {
      "code": "230014",
      "name": "西三河南部",
      "enName": "Southern Nishi-mikawa Region"
    },
    "class20": {
      "code": "2322500",
      "name": "知立市",
      "enName": "Chiryu City",
      "kana": "ちりゅうし",
      "chName": "知立市",
      "zhName": "知立市",
      "koName": "지류 시",
      "esName": "Ciudad de Chiryu",
      "ptName": "cidade de Chiryu",
      "thName": "เมืองชิริว",
      "viName": "thành phố Chiryu",
      "inName": "kota Chiryu",
      "tlName": "siyudad ng Chiryu",
      "moName": "Чирю хот",
      "buName": "ချာယု မြို့",
      "khName": "ទីក្រុង ឈីយូ",
      "neName": "चिर्यु सहर"
    }
  },
  "2322600": {
    "office": {
      "code": "230000",
      "name": "愛知県",
      "enName": "Aichi",
      "officeName": "名古屋地方気象台",
      "chName": "爱知县",
      "zhName": "愛知縣",
      "koName": "아이치현",
      "esName": "Prefectura de Aichi",
      "ptName": "Província de Aichi",
      "thName": "จังหวัดไอจิ",
      "viName": "Tỉnh Aichi",
      "inName": "Prefektur Aichi",
      "tlName": "Aichi Prefecture",
      "moName": "Айчи аймаг",
      "buName": "အိုင်အိကျိ ပြည်နယ်",
      "khName": "ខេត្ដ​ អាឈី",
      "neName": "आइची जिल्ला"
    },
    "class10": {
      "code": "230010",
      "name": "西部",
      "enName": "Western Region",
      "chName": "爱知县西部",
      "zhName": "愛知縣西部",
      "koName": "아이치 현 서부",
      "esName": "Oeste de Prefectura de Aichi",
      "ptName": "Região Oeste da Província de Aichi",
      "thName": "จังหวัดไอจิฟากตะวันตก",
      "viName": "Miền Tây tỉnh Aichi",
      "inName": "Bagian Barat Prefektur Aichi",
      "tlName": "Kanlurang bahagi ng Aichi Prefecture",
      "moName": "Баруун Айчи аймаг",
      "buName": "အအိချိစီရင်စု အနောက်ပိုင်း",
      "khName": "តំបន់ខាងលិចនៃខេត្ដ​អៃឈិ",
      "neName": "आइची जिल्लाको पश्चिमी भाग"
    },
    "class15": {
      "code": "230011",
      "name": "尾張東部",
      "enName": "Eastern Owari"
    },
    "class20": {
      "code": "2322600",
      "name": "尾張旭市",
      "enName": "Owariasahi City",
      "kana": "おわりあさひし",
      "chName": "尾张旭市",
      "zhName": "尾張旭市",
      "koName": "오와리아사히 시",
      "esName": "Ciudad de Owariasahi",
      "ptName": "cidade de Owariasahi",
      "thName": "เมืองโอวาริอาซาฮิ",
      "viName": "thành phố Owariasahi",
      "inName": "kota Owariasahi",
      "tlName": "siyudad ng Owariasahi",
      "moName": "Овариaсaхи хот",
      "buName": "အိုဝါရိယဆာဟိ မြို့",
      "khName": "ទីក្រុង អូអារីយ៉ាសាហ៊ី",
      "neName": "ओवारियासाही सहर"
    }
  },
  "2322700": {
    "office": {
      "code": "230000",
      "name": "愛知県",
      "enName": "Aichi",
      "officeName": "名古屋地方気象台",
      "chName": "爱知县",
      "zhName": "愛知縣",
      "koName": "아이치현",
      "esName": "Prefectura de Aichi",
      "ptName": "Província de Aichi",
      "thName": "จังหวัดไอจิ",
      "viName": "Tỉnh Aichi",
      "inName": "Prefektur Aichi",
      "tlName": "Aichi Prefecture",
      "moName": "Айчи аймаг",
      "buName": "အိုင်အိကျိ ပြည်နယ်",
      "khName": "ខេត្ដ​ អាឈី",
      "neName": "आइची जिल्ला"
    },
    "class10": {
      "code": "230010",
      "name": "西部",
      "enName": "Western Region",
      "chName": "爱知县西部",
      "zhName": "愛知縣西部",
      "koName": "아이치 현 서부",
      "esName": "Oeste de Prefectura de Aichi",
      "ptName": "Região Oeste da Província de Aichi",
      "thName": "จังหวัดไอจิฟากตะวันตก",
      "viName": "Miền Tây tỉnh Aichi",
      "inName": "Bagian Barat Prefektur Aichi",
      "tlName": "Kanlurang bahagi ng Aichi Prefecture",
      "moName": "Баруун Айчи аймаг",
      "buName": "အအိချိစီရင်စု အနောက်ပိုင်း",
      "khName": "តំបន់ខាងលិចនៃខេត្ដ​អៃឈិ",
      "neName": "आइची जिल्लाको पश्चिमी भाग"
    },
    "class15": {
      "code": "230014",
      "name": "西三河南部",
      "enName": "Southern Nishi-mikawa Region"
    },
    "class20": {
      "code": "2322700",
      "name": "高浜市",
      "enName": "Takahama City",
      "kana": "たかはまし",
      "chName": "高滨市",
      "zhName": "髙濱市",
      "koName": "다카하마 시",
      "esName": "Ciudad de Takahama",
      "ptName": "cidade de Takahama",
      "thName": "เมืองทากาฮามา",
      "viName": "thành phố Takahama",
      "inName": "kota Takahama",
      "tlName": "siyudad ng Takahama",
      "moName": "Такахама хот",
      "buName": "တာကဟာ့မ မြို့",
      "khName": "ទីក្រុង តាកាហាម៉ា",
      "neName": "ताकाहामा सहर"
    }
  },
  "2322800": {
    "office": {
      "code": "230000",
      "name": "愛知県",
      "enName": "Aichi",
      "officeName": "名古屋地方気象台",
      "chName": "爱知县",
      "zhName": "愛知縣",
      "koName": "아이치현",
      "esName": "Prefectura de Aichi",
      "ptName": "Província de Aichi",
      "thName": "จังหวัดไอจิ",
      "viName": "Tỉnh Aichi",
      "inName": "Prefektur Aichi",
      "tlName": "Aichi Prefecture",
      "moName": "Айчи аймаг",
      "buName": "အိုင်အိကျိ ပြည်နယ်",
      "khName": "ខេត្ដ​ អាឈី",
      "neName": "आइची जिल्ला"
    },
    "class10": {
      "code": "230010",
      "name": "西部",
      "enName": "Western Region",
      "chName": "爱知县西部",
      "zhName": "愛知縣西部",
      "koName": "아이치 현 서부",
      "esName": "Oeste de Prefectura de Aichi",
      "ptName": "Região Oeste da Província de Aichi",
      "thName": "จังหวัดไอจิฟากตะวันตก",
      "viName": "Miền Tây tỉnh Aichi",
      "inName": "Bagian Barat Prefektur Aichi",
      "tlName": "Kanlurang bahagi ng Aichi Prefecture",
      "moName": "Баруун Айчи аймаг",
      "buName": "အအိချိစီရင်စု အနောက်ပိုင်း",
      "khName": "តំបន់ខាងលិចនៃខេត្ដ​អៃឈិ",
      "neName": "आइची जिल्लाको पश्चिमी भाग"
    },
    "class15": {
      "code": "230012",
      "name": "尾張西部",
      "enName": "Western Owari"
    },
    "class20": {
      "code": "2322800",
      "name": "岩倉市",
      "enName": "Iwakura City",
      "kana": "いわくらし",
      "chName": "岩仓市",
      "zhName": "岩倉市",
      "koName": "이와쿠라 시",
      "esName": "Ciudad de Iwakura",
      "ptName": "cidade de Iwakura",
      "thName": "เมืองอิวาคุระ",
      "viName": "thành phố Iwakura",
      "inName": "kota Iwakura",
      "tlName": "siyudad ng Iwakura",
      "moName": "Ивакүра хот",
      "buName": "အီဝကုရ မြို့",
      "khName": "ទីក្រុង អ៊ីវ៉ាគូរ៉ា",
      "neName": "इवाकुरा सहर"
    }
  },
  "2322900": {
    "office": {
      "code": "230000",
      "name": "愛知県",
      "enName": "Aichi",
      "officeName": "名古屋地方気象台",
      "chName": "爱知县",
      "zhName": "愛知縣",
      "koName": "아이치현",
      "esName": "Prefectura de Aichi",
      "ptName": "Província de Aichi",
      "thName": "จังหวัดไอจิ",
      "viName": "Tỉnh Aichi",
      "inName": "Prefektur Aichi",
      "tlName": "Aichi Prefecture",
      "moName": "Айчи аймаг",
      "buName": "အိုင်အိကျိ ပြည်နယ်",
      "khName": "ខេត្ដ​ អាឈី",
      "neName": "आइची जिल्ला"
    },
    "class10": {
      "code": "230010",
      "name": "西部",
      "enName": "Western Region",
      "chName": "爱知县西部",
      "zhName": "愛知縣西部",
      "koName": "아이치 현 서부",
      "esName": "Oeste de Prefectura de Aichi",
      "ptName": "Região Oeste da Província de Aichi",
      "thName": "จังหวัดไอจิฟากตะวันตก",
      "viName": "Miền Tây tỉnh Aichi",
      "inName": "Bagian Barat Prefektur Aichi",
      "tlName": "Kanlurang bahagi ng Aichi Prefecture",
      "moName": "Баруун Айчи аймаг",
      "buName": "အအိချိစီရင်စု အနောက်ပိုင်း",
      "khName": "តំបន់ខាងលិចនៃខេត្ដ​អៃឈិ",
      "neName": "आइची जिल्लाको पश्चिमी भाग"
    },
    "class15": {
      "code": "230011",
      "name": "尾張東部",
      "enName": "Eastern Owari"
    },
    "class20": {
      "code": "2322900",
      "name": "豊明市",
      "enName": "Toyoake City",
      "kana": "とよあけし",
      "chName": "丰明市",
      "zhName": "豐明市",
      "koName": "도요아케 시",
      "esName": "Ciudad de Toyoake",
      "ptName": "cidade de Toyoake",
      "thName": "เมืองโทโยอาเกะ",
      "viName": "thành phố Toyoake",
      "inName": "kota Toyoake",
      "tlName": "siyudad ng Toyoake",
      "moName": "Тоёaкэ хот",
      "buName": "တိုယိုးယာကဲ့ မြို့",
      "khName": "ទីក្រុង តូយ៉ូក",
      "neName": "तोयोआके सहर"
    }
  },
  "2323000": {
    "office": {
      "code": "230000",
      "name": "愛知県",
      "enName": "Aichi",
      "officeName": "名古屋地方気象台",
      "chName": "爱知县",
      "zhName": "愛知縣",
      "koName": "아이치현",
      "esName": "Prefectura de Aichi",
      "ptName": "Província de Aichi",
      "thName": "จังหวัดไอจิ",
      "viName": "Tỉnh Aichi",
      "inName": "Prefektur Aichi",
      "tlName": "Aichi Prefecture",
      "moName": "Айчи аймаг",
      "buName": "အိုင်အိကျိ ပြည်နယ်",
      "khName": "ខេត្ដ​ អាឈី",
      "neName": "आइची जिल्ला"
    },
    "class10": {
      "code": "230010",
      "name": "西部",
      "enName": "Western Region",
      "chName": "爱知县西部",
      "zhName": "愛知縣西部",
      "koName": "아이치 현 서부",
      "esName": "Oeste de Prefectura de Aichi",
      "ptName": "Região Oeste da Província de Aichi",
      "thName": "จังหวัดไอจิฟากตะวันตก",
      "viName": "Miền Tây tỉnh Aichi",
      "inName": "Bagian Barat Prefektur Aichi",
      "tlName": "Kanlurang bahagi ng Aichi Prefecture",
      "moName": "Баруун Айчи аймаг",
      "buName": "အအိချိစီရင်စု အနောက်ပိုင်း",
      "khName": "តំបន់ខាងលិចនៃខេត្ដ​អៃឈិ",
      "neName": "आइची जिल्लाको पश्चिमी भाग"
    },
    "class15": {
      "code": "230011",
      "name": "尾張東部",
      "enName": "Eastern Owari"
    },
    "class20": {
      "code": "2323000",
      "name": "日進市",
      "enName": "Nisshin City",
      "kana": "にっしんし",
      "chName": "日进市",
      "zhName": "日進市",
      "koName": "닛신 시",
      "esName": "Ciudad de Nisshin",
      "ptName": "cidade de Nisshin",
      "thName": "เมืองนิชชิน",
      "viName": "thành phố Nisshin",
      "inName": "kota Nisshin",
      "tlName": "siyudad ng Nisshin",
      "moName": "Нишшин хот",
      "buName": "နီရှင်း မြို့",
      "khName": "ទីក្រុង នីសស៊ីន",
      "neName": "निस्सिन सहर"
    }
  },
  "2323100": {
    "office": {
      "code": "230000",
      "name": "愛知県",
      "enName": "Aichi",
      "officeName": "名古屋地方気象台",
      "chName": "爱知县",
      "zhName": "愛知縣",
      "koName": "아이치현",
      "esName": "Prefectura de Aichi",
      "ptName": "Província de Aichi",
      "thName": "จังหวัดไอจิ",
      "viName": "Tỉnh Aichi",
      "inName": "Prefektur Aichi",
      "tlName": "Aichi Prefecture",
      "moName": "Айчи аймаг",
      "buName": "အိုင်အိကျိ ပြည်နယ်",
      "khName": "ខេត្ដ​ អាឈី",
      "neName": "आइची जिल्ला"
    },
    "class10": {
      "code": "230020",
      "name": "東部",
      "enName": "Eastern Region",
      "chName": "爱知县东部",
      "zhName": "愛知縣東部",
      "koName": "아이치 현 동부",
      "esName": "Este de Prefectura de Aichi",
      "ptName": "Região Leste da Província de Aichi",
      "thName": "จังหวัดไอจิฟากตะวันออก",
      "viName": "Miền Đông tỉnh Aichi",
      "inName": "Bagian Timur Prefektur Aichi",
      "tlName": "Silangang bahagi ng Aichi Prefecture",
      "moName": "Зүүн Айчи аймаг",
      "buName": "အအိချိစီရင်စု အရှေ့ပိုင်း",
      "khName": "តំបន់ខាងកើតនៃខេត្ដ​អៃឈិ",
      "neName": "आइची जिल्लाको पूर्वी भाग"
    },
    "class15": {
      "code": "230023",
      "name": "東三河南部",
      "enName": "Southern Higashi-mikawa Region"
    },
    "class20": {
      "code": "2323100",
      "name": "田原市",
      "enName": "Tahara City",
      "kana": "たはらし",
      "chName": "田原市",
      "zhName": "田原市",
      "koName": "다하라 시",
      "esName": "Ciudad de Tahara",
      "ptName": "cidade de Tahara",
      "thName": "เมืองทาฮาระ",
      "viName": "thành phố Tahara",
      "inName": "kota Tahara",
      "tlName": "siyudad ng Tahara",
      "moName": "Тахaра хот",
      "buName": "တာ့ဟားရ မြို့",
      "khName": "ទីក្រុង តាហារ៉ា",
      "neName": "ताहारा सहर"
    }
  },
  "2323200": {
    "office": {
      "code": "230000",
      "name": "愛知県",
      "enName": "Aichi",
      "officeName": "名古屋地方気象台",
      "chName": "爱知县",
      "zhName": "愛知縣",
      "koName": "아이치현",
      "esName": "Prefectura de Aichi",
      "ptName": "Província de Aichi",
      "thName": "จังหวัดไอจิ",
      "viName": "Tỉnh Aichi",
      "inName": "Prefektur Aichi",
      "tlName": "Aichi Prefecture",
      "moName": "Айчи аймаг",
      "buName": "အိုင်အိကျိ ပြည်နယ်",
      "khName": "ខេត្ដ​ អាឈី",
      "neName": "आइची जिल्ला"
    },
    "class10": {
      "code": "230010",
      "name": "西部",
      "enName": "Western Region",
      "chName": "爱知县西部",
      "zhName": "愛知縣西部",
      "koName": "아이치 현 서부",
      "esName": "Oeste de Prefectura de Aichi",
      "ptName": "Região Oeste da Província de Aichi",
      "thName": "จังหวัดไอจิฟากตะวันตก",
      "viName": "Miền Tây tỉnh Aichi",
      "inName": "Bagian Barat Prefektur Aichi",
      "tlName": "Kanlurang bahagi ng Aichi Prefecture",
      "moName": "Баруун Айчи аймаг",
      "buName": "အအိချိစီရင်စု အနောက်ပိုင်း",
      "khName": "តំបន់ខាងលិចនៃខេត្ដ​អៃឈិ",
      "neName": "आइची जिल्लाको पश्चिमी भाग"
    },
    "class15": {
      "code": "230012",
      "name": "尾張西部",
      "enName": "Western Owari"
    },
    "class20": {
      "code": "2323200",
      "name": "愛西市",
      "enName": "Aisai City",
      "kana": "あいさいし",
      "chName": "爱西市",
      "zhName": "愛西市",
      "koName": "아이사이 시",
      "esName": "Ciudad de Aisai",
      "ptName": "cidade de Aisai",
      "thName": "เมืองไอไซ",
      "viName": "thành phố Aisai",
      "inName": "kota Aisai",
      "tlName": "siyudad ng Aisai",
      "moName": "Aйсaй хот",
      "buName": "အိုင်ဆားယိ မြို့",
      "khName": "ទីក្រុង អៃសាយ",
      "neName": "आइसाई सहर"
    }
  },
  "2323300": {
    "office": {
      "code": "230000",
      "name": "愛知県",
      "enName": "Aichi",
      "officeName": "名古屋地方気象台",
      "chName": "爱知县",
      "zhName": "愛知縣",
      "koName": "아이치현",
      "esName": "Prefectura de Aichi",
      "ptName": "Província de Aichi",
      "thName": "จังหวัดไอจิ",
      "viName": "Tỉnh Aichi",
      "inName": "Prefektur Aichi",
      "tlName": "Aichi Prefecture",
      "moName": "Айчи аймаг",
      "buName": "အိုင်အိကျိ ပြည်နယ်",
      "khName": "ខេត្ដ​ អាឈី",
      "neName": "आइची जिल्ला"
    },
    "class10": {
      "code": "230010",
      "name": "西部",
      "enName": "Western Region",
      "chName": "爱知县西部",
      "zhName": "愛知縣西部",
      "koName": "아이치 현 서부",
      "esName": "Oeste de Prefectura de Aichi",
      "ptName": "Região Oeste da Província de Aichi",
      "thName": "จังหวัดไอจิฟากตะวันตก",
      "viName": "Miền Tây tỉnh Aichi",
      "inName": "Bagian Barat Prefektur Aichi",
      "tlName": "Kanlurang bahagi ng Aichi Prefecture",
      "moName": "Баруун Айчи аймаг",
      "buName": "အအိချိစီရင်စု အနောက်ပိုင်း",
      "khName": "តំបន់ខាងលិចនៃខេត្ដ​អៃឈិ",
      "neName": "आइची जिल्लाको पश्चिमी भाग"
    },
    "class15": {
      "code": "230012",
      "name": "尾張西部",
      "enName": "Western Owari"
    },
    "class20": {
      "code": "2323300",
      "name": "清須市",
      "enName": "Kiyosu City",
      "kana": "きよすし",
      "chName": "清须市",
      "zhName": "清須市",
      "koName": "기요스 시",
      "esName": "Ciudad de Kiyosu",
      "ptName": "cidade de Kiyosu",
      "thName": "เมืองคิโยสุ",
      "viName": "thành phố Kiyosu",
      "inName": "kota Kiyosu",
      "tlName": "siyudad ng Kiyosu",
      "moName": "Киёосү хот",
      "buName": "ကီယို့ဆု မြို့",
      "khName": "ទីក្រុង គីយូស៊ូ",
      "neName": "कियोसु सहर"
    }
  },
  "2323400": {
    "office": {
      "code": "230000",
      "name": "愛知県",
      "enName": "Aichi",
      "officeName": "名古屋地方気象台",
      "chName": "爱知县",
      "zhName": "愛知縣",
      "koName": "아이치현",
      "esName": "Prefectura de Aichi",
      "ptName": "Província de Aichi",
      "thName": "จังหวัดไอจิ",
      "viName": "Tỉnh Aichi",
      "inName": "Prefektur Aichi",
      "tlName": "Aichi Prefecture",
      "moName": "Айчи аймаг",
      "buName": "အိုင်အိကျိ ပြည်နယ်",
      "khName": "ខេត្ដ​ អាឈី",
      "neName": "आइची जिल्ला"
    },
    "class10": {
      "code": "230010",
      "name": "西部",
      "enName": "Western Region",
      "chName": "爱知县西部",
      "zhName": "愛知縣西部",
      "koName": "아이치 현 서부",
      "esName": "Oeste de Prefectura de Aichi",
      "ptName": "Região Oeste da Província de Aichi",
      "thName": "จังหวัดไอจิฟากตะวันตก",
      "viName": "Miền Tây tỉnh Aichi",
      "inName": "Bagian Barat Prefektur Aichi",
      "tlName": "Kanlurang bahagi ng Aichi Prefecture",
      "moName": "Баруун Айчи аймаг",
      "buName": "အအိချိစီရင်စု အနောက်ပိုင်း",
      "khName": "តំបន់ខាងលិចនៃខេត្ដ​អៃឈិ",
      "neName": "आइची जिल्लाको पश्चिमी भाग"
    },
    "class15": {
      "code": "230012",
      "name": "尾張西部",
      "enName": "Western Owari"
    },
    "class20": {
      "code": "2323400",
      "name": "北名古屋市",
      "enName": "Kitanagoya City",
      "kana": "きたなごやし",
      "chName": "北名古屋市",
      "zhName": "北名古屋市",
      "koName": "기타나고야 시",
      "esName": "Ciudad de Kitanagoya",
      "ptName": "cidade de Kitanagoya",
      "thName": "เมืองคิตะนาโกยา",
      "viName": "thành phố Kitanagoya",
      "inName": "kota Kitanagoya",
      "tlName": "siyudad ng Kitanagoya",
      "moName": "Китанагоя хот",
      "buName": "ကီတာနာဂိုယာ မြို့",
      "khName": "ទីក្រុង គីតាណាហ្កូយ៉ា",
      "neName": "कितानागोया सहर"
    }
  },
  "2323500": {
    "office": {
      "code": "230000",
      "name": "愛知県",
      "enName": "Aichi",
      "officeName": "名古屋地方気象台",
      "chName": "爱知县",
      "zhName": "愛知縣",
      "koName": "아이치현",
      "esName": "Prefectura de Aichi",
      "ptName": "Província de Aichi",
      "thName": "จังหวัดไอจิ",
      "viName": "Tỉnh Aichi",
      "inName": "Prefektur Aichi",
      "tlName": "Aichi Prefecture",
      "moName": "Айчи аймаг",
      "buName": "အိုင်အိကျိ ပြည်နယ်",
      "khName": "ខេត្ដ​ អាឈី",
      "neName": "आइची जिल्ला"
    },
    "class10": {
      "code": "230010",
      "name": "西部",
      "enName": "Western Region",
      "chName": "爱知县西部",
      "zhName": "愛知縣西部",
      "koName": "아이치 현 서부",
      "esName": "Oeste de Prefectura de Aichi",
      "ptName": "Região Oeste da Província de Aichi",
      "thName": "จังหวัดไอจิฟากตะวันตก",
      "viName": "Miền Tây tỉnh Aichi",
      "inName": "Bagian Barat Prefektur Aichi",
      "tlName": "Kanlurang bahagi ng Aichi Prefecture",
      "moName": "Баруун Айчи аймаг",
      "buName": "အအိချိစီရင်စု အနောက်ပိုင်း",
      "khName": "តំបន់ខាងលិចនៃខេត្ដ​អៃឈិ",
      "neName": "आइची जिल्लाको पश्चिमी भाग"
    },
    "class15": {
      "code": "230012",
      "name": "尾張西部",
      "enName": "Western Owari"
    },
    "class20": {
      "code": "2323500",
      "name": "弥富市",
      "enName": "Yatomi City",
      "kana": "やとみし",
      "chName": "弥富市",
      "zhName": "彌富市",
      "koName": "야토미 시",
      "esName": "Ciudad de Yatomi",
      "ptName": "cidade de Yatomi",
      "thName": "เมืองยาโตมิ",
      "viName": "thành phố Yatomi",
      "inName": "kota Yatomi",
      "tlName": "siyudad ng Yatomi",
      "moName": "Ятоми хот",
      "buName": "ယာတို့မိ မြို့",
      "khName": "ទីក្រុង យ៉ាតូមី",
      "neName": "यातोमी सहर"
    }
  },
  "2323600": {
    "office": {
      "code": "230000",
      "name": "愛知県",
      "enName": "Aichi",
      "officeName": "名古屋地方気象台",
      "chName": "爱知县",
      "zhName": "愛知縣",
      "koName": "아이치현",
      "esName": "Prefectura de Aichi",
      "ptName": "Província de Aichi",
      "thName": "จังหวัดไอจิ",
      "viName": "Tỉnh Aichi",
      "inName": "Prefektur Aichi",
      "tlName": "Aichi Prefecture",
      "moName": "Айчи аймаг",
      "buName": "အိုင်အိကျိ ပြည်နယ်",
      "khName": "ខេត្ដ​ អាឈី",
      "neName": "आइची जिल्ला"
    },
    "class10": {
      "code": "230010",
      "name": "西部",
      "enName": "Western Region",
      "chName": "爱知县西部",
      "zhName": "愛知縣西部",
      "koName": "아이치 현 서부",
      "esName": "Oeste de Prefectura de Aichi",
      "ptName": "Região Oeste da Província de Aichi",
      "thName": "จังหวัดไอจิฟากตะวันตก",
      "viName": "Miền Tây tỉnh Aichi",
      "inName": "Bagian Barat Prefektur Aichi",
      "tlName": "Kanlurang bahagi ng Aichi Prefecture",
      "moName": "Баруун Айчи аймаг",
      "buName": "အအိချိစီရင်စု အနောက်ပိုင်း",
      "khName": "តំបន់ខាងលិចនៃខេត្ដ​អៃឈិ",
      "neName": "आइची जिल्लाको पश्चिमी भाग"
    },
    "class15": {
      "code": "230015",
      "name": "西三河北西部",
      "enName": "North-western Nishi-mikawa Region"
    },
    "class20": {
      "code": "2323600",
      "name": "みよし市",
      "enName": "Miyoshi City",
      "kana": "みよしし",
      "chName": "爱知三好市",
      "zhName": "愛知三好市",
      "koName": "아이치 미요시 시",
      "esName": "Ciudad de Miyoshi, Aichi",
      "ptName": "Aichi, cidade de Miyoshi",
      "thName": "เมืองมิโยชิ ไอจิ",
      "viName": "Thành phố Miyoshi, Aichi",
      "inName": "Kota Miyoshi, Aichi",
      "tlName": "siyudad ng Miyoshi, Aichi",
      "moName": "Айчи Миёши хот",
      "buName": "အအိချိမိယိုမြို့",
      "khName": "ទីក្រុងមីយ៉ូស៊ី អៃឈិ",
      "neName": "आइची मियोसी सहर"
    }
  },
  "2323700": {
    "office": {
      "code": "230000",
      "name": "愛知県",
      "enName": "Aichi",
      "officeName": "名古屋地方気象台",
      "chName": "爱知县",
      "zhName": "愛知縣",
      "koName": "아이치현",
      "esName": "Prefectura de Aichi",
      "ptName": "Província de Aichi",
      "thName": "จังหวัดไอจิ",
      "viName": "Tỉnh Aichi",
      "inName": "Prefektur Aichi",
      "tlName": "Aichi Prefecture",
      "moName": "Айчи аймаг",
      "buName": "အိုင်အိကျိ ပြည်နယ်",
      "khName": "ខេត្ដ​ អាឈី",
      "neName": "आइची जिल्ला"
    },
    "class10": {
      "code": "230010",
      "name": "西部",
      "enName": "Western Region",
      "chName": "爱知县西部",
      "zhName": "愛知縣西部",
      "koName": "아이치 현 서부",
      "esName": "Oeste de Prefectura de Aichi",
      "ptName": "Região Oeste da Província de Aichi",
      "thName": "จังหวัดไอจิฟากตะวันตก",
      "viName": "Miền Tây tỉnh Aichi",
      "inName": "Bagian Barat Prefektur Aichi",
      "tlName": "Kanlurang bahagi ng Aichi Prefecture",
      "moName": "Баруун Айчи аймаг",
      "buName": "အအိချိစီရင်စု အနောက်ပိုင်း",
      "khName": "តំបន់ខាងលិចនៃខេត្ដ​អៃឈិ",
      "neName": "आइची जिल्लाको पश्चिमी भाग"
    },
    "class15": {
      "code": "230012",
      "name": "尾張西部",
      "enName": "Western Owari"
    },
    "class20": {
      "code": "2323700",
      "name": "あま市",
      "enName": "Ama City",
      "kana": "あまし",
      "chName": "海部市",
      "zhName": "海部市",
      "koName": "아마 시",
      "esName": "Ciudad de Ama",
      "ptName": "cidade de Ama",
      "thName": "เมืองอามะ",
      "viName": "thành phố Ama",
      "inName": "kota Ama",
      "tlName": "siyudad ng Ama",
      "moName": "Aмa хот",
      "buName": "အာမ မြို့",
      "khName": "ទីក្រុង អាម៉ា",
      "neName": "आमा सहर"
    }
  },
  "2323800": {
    "office": {
      "code": "230000",
      "name": "愛知県",
      "enName": "Aichi",
      "officeName": "名古屋地方気象台",
      "chName": "爱知县",
      "zhName": "愛知縣",
      "koName": "아이치현",
      "esName": "Prefectura de Aichi",
      "ptName": "Província de Aichi",
      "thName": "จังหวัดไอจิ",
      "viName": "Tỉnh Aichi",
      "inName": "Prefektur Aichi",
      "tlName": "Aichi Prefecture",
      "moName": "Айчи аймаг",
      "buName": "အိုင်အိကျိ ပြည်နယ်",
      "khName": "ខេត្ដ​ អាឈី",
      "neName": "आइची जिल्ला"
    },
    "class10": {
      "code": "230010",
      "name": "西部",
      "enName": "Western Region",
      "chName": "爱知县西部",
      "zhName": "愛知縣西部",
      "koName": "아이치 현 서부",
      "esName": "Oeste de Prefectura de Aichi",
      "ptName": "Região Oeste da Província de Aichi",
      "thName": "จังหวัดไอจิฟากตะวันตก",
      "viName": "Miền Tây tỉnh Aichi",
      "inName": "Bagian Barat Prefektur Aichi",
      "tlName": "Kanlurang bahagi ng Aichi Prefecture",
      "moName": "Баруун Айчи аймаг",
      "buName": "အအိချိစီရင်စု အနောက်ပိုင်း",
      "khName": "តំបន់ខាងលិចនៃខេត្ដ​អៃឈិ",
      "neName": "आइची जिल्लाको पश्चिमी भाग"
    },
    "class15": {
      "code": "230011",
      "name": "尾張東部",
      "enName": "Eastern Owari"
    },
    "class20": {
      "code": "2323800",
      "name": "長久手市",
      "enName": "Nagakute City",
      "kana": "ながくてし",
      "chName": "长久手市",
      "zhName": "長久手市",
      "koName": "나가쿠테 시",
      "esName": "Ciudad de Nagakute",
      "ptName": "cidade de Nagakute",
      "thName": "เมืองนางาคุเตะ",
      "viName": "thành phố Nagakute",
      "inName": "kota Nagakute",
      "tlName": "siyudad ng Nagakute",
      "moName": "Нaгaкүтэ хот",
      "buName": "နာဂကုတဲ့ မြို့",
      "khName": "ទីក្រុង ណាកាឃូត",
      "neName": "नागाकुते सहर"
    }
  },
  "2330200": {
    "office": {
      "code": "230000",
      "name": "愛知県",
      "enName": "Aichi",
      "officeName": "名古屋地方気象台",
      "chName": "爱知县",
      "zhName": "愛知縣",
      "koName": "아이치현",
      "esName": "Prefectura de Aichi",
      "ptName": "Província de Aichi",
      "thName": "จังหวัดไอจิ",
      "viName": "Tỉnh Aichi",
      "inName": "Prefektur Aichi",
      "tlName": "Aichi Prefecture",
      "moName": "Айчи аймаг",
      "buName": "အိုင်အိကျိ ပြည်နယ်",
      "khName": "ខេត្ដ​ អាឈី",
      "neName": "आइची जिल्ला"
    },
    "class10": {
      "code": "230010",
      "name": "西部",
      "enName": "Western Region",
      "chName": "爱知县西部",
      "zhName": "愛知縣西部",
      "koName": "아이치 현 서부",
      "esName": "Oeste de Prefectura de Aichi",
      "ptName": "Região Oeste da Província de Aichi",
      "thName": "จังหวัดไอจิฟากตะวันตก",
      "viName": "Miền Tây tỉnh Aichi",
      "inName": "Bagian Barat Prefektur Aichi",
      "tlName": "Kanlurang bahagi ng Aichi Prefecture",
      "moName": "Баруун Айчи аймаг",
      "buName": "အအိချိစီရင်စု အနောက်ပိုင်း",
      "khName": "តំបន់ខាងលិចនៃខេត្ដ​អៃឈិ",
      "neName": "आइची जिल्लाको पश्चिमी भाग"
    },
    "class15": {
      "code": "230011",
      "name": "尾張東部",
      "enName": "Eastern Owari"
    },
    "class20": {
      "code": "2330200",
      "name": "東郷町",
      "enName": "Togo Town",
      "kana": "とうごうちょう",
      "chName": "东乡町",
      "zhName": "東鄉町",
      "koName": "도고 정",
      "esName": "Pueblo de Togo",
      "ptName": "bairro de Togo",
      "thName": "เมืองโทโกะ",
      "viName": "thị trấn Togo",
      "inName": "kota Togo",
      "tlName": "bayan ng Togo",
      "moName": "Того жижиг хот",
      "buName": "တိုဂို မြို့နယ်",
      "khName": "ទីប្រជុំជន តូហ្គោ",
      "neName": "तोगो नगर"
    }
  },
  "2334200": {
    "office": {
      "code": "230000",
      "name": "愛知県",
      "enName": "Aichi",
      "officeName": "名古屋地方気象台",
      "chName": "爱知县",
      "zhName": "愛知縣",
      "koName": "아이치현",
      "esName": "Prefectura de Aichi",
      "ptName": "Província de Aichi",
      "thName": "จังหวัดไอจิ",
      "viName": "Tỉnh Aichi",
      "inName": "Prefektur Aichi",
      "tlName": "Aichi Prefecture",
      "moName": "Айчи аймаг",
      "buName": "အိုင်အိကျိ ပြည်နယ်",
      "khName": "ខេត្ដ​ អាឈី",
      "neName": "आइची जिल्ला"
    },
    "class10": {
      "code": "230010",
      "name": "西部",
      "enName": "Western Region",
      "chName": "爱知县西部",
      "zhName": "愛知縣西部",
      "koName": "아이치 현 서부",
      "esName": "Oeste de Prefectura de Aichi",
      "ptName": "Região Oeste da Província de Aichi",
      "thName": "จังหวัดไอจิฟากตะวันตก",
      "viName": "Miền Tây tỉnh Aichi",
      "inName": "Bagian Barat Prefektur Aichi",
      "tlName": "Kanlurang bahagi ng Aichi Prefecture",
      "moName": "Баруун Айчи аймаг",
      "buName": "အအိချိစီရင်စု အနောက်ပိုင်း",
      "khName": "តំបន់ខាងលិចនៃខេត្ដ​អៃឈិ",
      "neName": "आइची जिल्लाको पश्चिमी भाग"
    },
    "class15": {
      "code": "230012",
      "name": "尾張西部",
      "enName": "Western Owari"
    },
    "class20": {
      "code": "2334200",
      "name": "豊山町",
      "enName": "Toyoyama Town",
      "kana": "とよやまちょう",
      "chName": "丰山町",
      "zhName": "豐山町",
      "koName": "도요야마 정",
      "esName": "Pueblo de Toyoyama ",
      "ptName": "bairro de Toyoyama",
      "thName": "เมืองโทโยยามะ",
      "viName": "thị trấn Toyoyama",
      "inName": "kota Toyoyama",
      "tlName": "bayan ng Toyoyama",
      "moName": "Тоёямa жижиг хот",
      "buName": "တိုရိုယာ့မ မြို့နယ်",
      "khName": "ទីប្រជុំជន តូយ៉ូយ៉ាម៉ា",
      "neName": "तोयोयामा नगर"
    }
  },
  "2336100": {
    "office": {
      "code": "230000",
      "name": "愛知県",
      "enName": "Aichi",
      "officeName": "名古屋地方気象台",
      "chName": "爱知县",
      "zhName": "愛知縣",
      "koName": "아이치현",
      "esName": "Prefectura de Aichi",
      "ptName": "Província de Aichi",
      "thName": "จังหวัดไอจิ",
      "viName": "Tỉnh Aichi",
      "inName": "Prefektur Aichi",
      "tlName": "Aichi Prefecture",
      "moName": "Айчи аймаг",
      "buName": "အိုင်အိကျိ ပြည်နယ်",
      "khName": "ខេត្ដ​ អាឈី",
      "neName": "आइची जिल्ला"
    },
    "class10": {
      "code": "230010",
      "name": "西部",
      "enName": "Western Region",
      "chName": "爱知县西部",
      "zhName": "愛知縣西部",
      "koName": "아이치 현 서부",
      "esName": "Oeste de Prefectura de Aichi",
      "ptName": "Região Oeste da Província de Aichi",
      "thName": "จังหวัดไอจิฟากตะวันตก",
      "viName": "Miền Tây tỉnh Aichi",
      "inName": "Bagian Barat Prefektur Aichi",
      "tlName": "Kanlurang bahagi ng Aichi Prefecture",
      "moName": "Баруун Айчи аймаг",
      "buName": "အအိချိစီရင်စု အနောက်ပိုင်း",
      "khName": "តំបន់ខាងលិចនៃខេត្ដ​អៃឈិ",
      "neName": "आइची जिल्लाको पश्चिमी भाग"
    },
    "class15": {
      "code": "230012",
      "name": "尾張西部",
      "enName": "Western Owari"
    },
    "class20": {
      "code": "2336100",
      "name": "大口町",
      "enName": "Oguchi Town",
      "kana": "おおぐちちょう",
      "chName": "大口町",
      "zhName": "大口町",
      "koName": "오구치 정",
      "esName": "Pueblo de Oguchi",
      "ptName": "bairro de Oguchi",
      "thName": "เมืองโองุจิ",
      "viName": "thị trấn Oguchi",
      "inName": "kota Oguchi",
      "tlName": "bayan ng Oguchi",
      "moName": "Огүчи жижиг хот",
      "buName": "အို့ဂုကျိ မြို့နယ်",
      "khName": "ទីប្រជុំជន អូហ្កូជី",
      "neName": "ओगुची नगर"
    }
  },
  "2336200": {
    "office": {
      "code": "230000",
      "name": "愛知県",
      "enName": "Aichi",
      "officeName": "名古屋地方気象台",
      "chName": "爱知县",
      "zhName": "愛知縣",
      "koName": "아이치현",
      "esName": "Prefectura de Aichi",
      "ptName": "Província de Aichi",
      "thName": "จังหวัดไอจิ",
      "viName": "Tỉnh Aichi",
      "inName": "Prefektur Aichi",
      "tlName": "Aichi Prefecture",
      "moName": "Айчи аймаг",
      "buName": "အိုင်အိကျိ ပြည်နယ်",
      "khName": "ខេត្ដ​ អាឈី",
      "neName": "आइची जिल्ला"
    },
    "class10": {
      "code": "230010",
      "name": "西部",
      "enName": "Western Region",
      "chName": "爱知县西部",
      "zhName": "愛知縣西部",
      "koName": "아이치 현 서부",
      "esName": "Oeste de Prefectura de Aichi",
      "ptName": "Região Oeste da Província de Aichi",
      "thName": "จังหวัดไอจิฟากตะวันตก",
      "viName": "Miền Tây tỉnh Aichi",
      "inName": "Bagian Barat Prefektur Aichi",
      "tlName": "Kanlurang bahagi ng Aichi Prefecture",
      "moName": "Баруун Айчи аймаг",
      "buName": "အအိချိစီရင်စု အနောက်ပိုင်း",
      "khName": "តំបន់ខាងលិចនៃខេត្ដ​អៃឈិ",
      "neName": "आइची जिल्लाको पश्चिमी भाग"
    },
    "class15": {
      "code": "230012",
      "name": "尾張西部",
      "enName": "Western Owari"
    },
    "class20": {
      "code": "2336200",
      "name": "扶桑町",
      "enName": "Fuso Town",
      "kana": "ふそうちょう",
      "chName": "扶桑町",
      "zhName": "扶桑町",
      "koName": "후소 정",
      "esName": "Pueblo de Fuso",
      "ptName": "bairro de Fuso",
      "thName": "เมืองฟุโสะ",
      "viName": "thị trấn Fuso",
      "inName": "kota Fuso",
      "tlName": "bayan ng Fuso",
      "moName": "Фүсо жижиг хот",
      "buName": "ဖူဆို မြို့နယ်",
      "khName": "ទីប្រជុំជន ហ្វូសូ",
      "neName": "फुसो नगर"
    }
  },
  "2342400": {
    "office": {
      "code": "230000",
      "name": "愛知県",
      "enName": "Aichi",
      "officeName": "名古屋地方気象台",
      "chName": "爱知县",
      "zhName": "愛知縣",
      "koName": "아이치현",
      "esName": "Prefectura de Aichi",
      "ptName": "Província de Aichi",
      "thName": "จังหวัดไอจิ",
      "viName": "Tỉnh Aichi",
      "inName": "Prefektur Aichi",
      "tlName": "Aichi Prefecture",
      "moName": "Айчи аймаг",
      "buName": "အိုင်အိကျိ ပြည်နယ်",
      "khName": "ខេត្ដ​ អាឈី",
      "neName": "आइची जिल्ला"
    },
    "class10": {
      "code": "230010",
      "name": "西部",
      "enName": "Western Region",
      "chName": "爱知县西部",
      "zhName": "愛知縣西部",
      "koName": "아이치 현 서부",
      "esName": "Oeste de Prefectura de Aichi",
      "ptName": "Região Oeste da Província de Aichi",
      "thName": "จังหวัดไอจิฟากตะวันตก",
      "viName": "Miền Tây tỉnh Aichi",
      "inName": "Bagian Barat Prefektur Aichi",
      "tlName": "Kanlurang bahagi ng Aichi Prefecture",
      "moName": "Баруун Айчи аймаг",
      "buName": "အအိချိစီရင်စု အနောက်ပိုင်း",
      "khName": "តំបន់ខាងលិចនៃខេត្ដ​អៃឈិ",
      "neName": "आइची जिल्लाको पश्चिमी भाग"
    },
    "class15": {
      "code": "230012",
      "name": "尾張西部",
      "enName": "Western Owari"
    },
    "class20": {
      "code": "2342400",
      "name": "大治町",
      "enName": "Oharu Town",
      "kana": "おおはるちょう",
      "chName": "大治町",
      "zhName": "大治町",
      "koName": "오하루 정",
      "esName": "Pueblo de Oharu",
      "ptName": "bairro de Oharu",
      "thName": "เมืองโอฮาระ",
      "viName": "thị trấn Oharu",
      "inName": "kota Oharu",
      "tlName": "bayan ng Oharu",
      "moName": "Охaрү жижиг хот",
      "buName": "အိုဟာ့ရု မြို့နယ်",
      "khName": "ទីប្រជុំជន អូហារូ",
      "neName": "ओहारू नगर"
    }
  },
  "2342500": {
    "office": {
      "code": "230000",
      "name": "愛知県",
      "enName": "Aichi",
      "officeName": "名古屋地方気象台",
      "chName": "爱知县",
      "zhName": "愛知縣",
      "koName": "아이치현",
      "esName": "Prefectura de Aichi",
      "ptName": "Província de Aichi",
      "thName": "จังหวัดไอจิ",
      "viName": "Tỉnh Aichi",
      "inName": "Prefektur Aichi",
      "tlName": "Aichi Prefecture",
      "moName": "Айчи аймаг",
      "buName": "အိုင်အိကျိ ပြည်နယ်",
      "khName": "ខេត្ដ​ អាឈី",
      "neName": "आइची जिल्ला"
    },
    "class10": {
      "code": "230010",
      "name": "西部",
      "enName": "Western Region",
      "chName": "爱知县西部",
      "zhName": "愛知縣西部",
      "koName": "아이치 현 서부",
      "esName": "Oeste de Prefectura de Aichi",
      "ptName": "Região Oeste da Província de Aichi",
      "thName": "จังหวัดไอจิฟากตะวันตก",
      "viName": "Miền Tây tỉnh Aichi",
      "inName": "Bagian Barat Prefektur Aichi",
      "tlName": "Kanlurang bahagi ng Aichi Prefecture",
      "moName": "Баруун Айчи аймаг",
      "buName": "အအိချိစီရင်စု အနောက်ပိုင်း",
      "khName": "តំបន់ខាងលិចនៃខេត្ដ​អៃឈិ",
      "neName": "आइची जिल्लाको पश्चिमी भाग"
    },
    "class15": {
      "code": "230012",
      "name": "尾張西部",
      "enName": "Western Owari"
    },
    "class20": {
      "code": "2342500",
      "name": "蟹江町",
      "enName": "Kanie Town",
      "kana": "かにえちょう",
      "chName": "蟹江町",
      "zhName": "蟹江町",
      "koName": "가니에 정",
      "esName": "Pueblo de Kanie",
      "ptName": "bairro de Kanie",
      "thName": "เมืองคานิเอะ",
      "viName": "thị trấn Kanie",
      "inName": "kota Kanie",
      "tlName": "bayan ng Kanie",
      "moName": "Каниэ жижиг хот",
      "buName": "ခါနိယဲ့ မြို့နယ်",
      "khName": "ទីប្រជុំជន កាននី",
      "neName": "कनिए नगर"
    }
  },
  "2342700": {
    "office": {
      "code": "230000",
      "name": "愛知県",
      "enName": "Aichi",
      "officeName": "名古屋地方気象台",
      "chName": "爱知县",
      "zhName": "愛知縣",
      "koName": "아이치현",
      "esName": "Prefectura de Aichi",
      "ptName": "Província de Aichi",
      "thName": "จังหวัดไอจิ",
      "viName": "Tỉnh Aichi",
      "inName": "Prefektur Aichi",
      "tlName": "Aichi Prefecture",
      "moName": "Айчи аймаг",
      "buName": "အိုင်အိကျိ ပြည်နယ်",
      "khName": "ខេត្ដ​ អាឈី",
      "neName": "आइची जिल्ला"
    },
    "class10": {
      "code": "230010",
      "name": "西部",
      "enName": "Western Region",
      "chName": "爱知县西部",
      "zhName": "愛知縣西部",
      "koName": "아이치 현 서부",
      "esName": "Oeste de Prefectura de Aichi",
      "ptName": "Região Oeste da Província de Aichi",
      "thName": "จังหวัดไอจิฟากตะวันตก",
      "viName": "Miền Tây tỉnh Aichi",
      "inName": "Bagian Barat Prefektur Aichi",
      "tlName": "Kanlurang bahagi ng Aichi Prefecture",
      "moName": "Баруун Айчи аймаг",
      "buName": "အအိချိစီရင်စု အနောက်ပိုင်း",
      "khName": "តំបន់ខាងលិចនៃខេត្ដ​អៃឈិ",
      "neName": "आइची जिल्लाको पश्चिमी भाग"
    },
    "class15": {
      "code": "230012",
      "name": "尾張西部",
      "enName": "Western Owari"
    },
    "class20": {
      "code": "2342700",
      "name": "飛島村",
      "enName": "Tobishima Village",
      "kana": "とびしまむら",
      "chName": "飞岛村",
      "zhName": "飛島村",
      "koName": "도비시마 정",
      "esName": "Aldea de Tobishima",
      "ptName": "povoado de Tobishima",
      "thName": "หมู่บ้านโทบิชิมะ",
      "viName": "làng Tobishima",
      "inName": "desa Tobishima",
      "tlName": "nayon ng Tobishima",
      "moName": "Тобишимa тосгон",
      "buName": "တိုဘီရှိမ ကျေးရွာ",
      "khName": " ភូមិ តូប៊ីស៊ីម៉ា",
      "neName": "तोबिशिमा गाउँ"
    }
  },
  "2344100": {
    "office": {
      "code": "230000",
      "name": "愛知県",
      "enName": "Aichi",
      "officeName": "名古屋地方気象台",
      "chName": "爱知县",
      "zhName": "愛知縣",
      "koName": "아이치현",
      "esName": "Prefectura de Aichi",
      "ptName": "Província de Aichi",
      "thName": "จังหวัดไอจิ",
      "viName": "Tỉnh Aichi",
      "inName": "Prefektur Aichi",
      "tlName": "Aichi Prefecture",
      "moName": "Айчи аймаг",
      "buName": "အိုင်အိကျိ ပြည်နယ်",
      "khName": "ខេត្ដ​ អាឈី",
      "neName": "आइची जिल्ला"
    },
    "class10": {
      "code": "230010",
      "name": "西部",
      "enName": "Western Region",
      "chName": "爱知县西部",
      "zhName": "愛知縣西部",
      "koName": "아이치 현 서부",
      "esName": "Oeste de Prefectura de Aichi",
      "ptName": "Região Oeste da Província de Aichi",
      "thName": "จังหวัดไอจิฟากตะวันตก",
      "viName": "Miền Tây tỉnh Aichi",
      "inName": "Bagian Barat Prefektur Aichi",
      "tlName": "Kanlurang bahagi ng Aichi Prefecture",
      "moName": "Баруун Айчи аймаг",
      "buName": "အအိချိစီရင်စု အနောက်ပိုင်း",
      "khName": "តំបន់ខាងលិចនៃខេត្ដ​អៃឈិ",
      "neName": "आइची जिल्लाको पश्चिमी भाग"
    },
    "class15": {
      "code": "230013",
      "name": "知多地域",
      "enName": "Chita Area"
    },
    "class20": {
      "code": "2344100",
      "name": "阿久比町",
      "enName": "Agui Town",
      "kana": "あぐいちょう",
      "chName": "阿久比町",
      "zhName": "阿久比町",
      "koName": "아구이 정",
      "esName": "Pueblo de Agui",
      "ptName": "bairro de Agui",
      "thName": "เมืองอางุอิ",
      "viName": "thị trấn Agui",
      "inName": "kota Agui",
      "tlName": "bayan ng Agui",
      "moName": "Aгүй жижиг хот",
      "buName": "အာဂုယိ မြို့နယ်",
      "khName": "ទីប្រជុំជន អាហ្គី",
      "neName": "आगुई नगर"
    }
  },
  "2344200": {
    "office": {
      "code": "230000",
      "name": "愛知県",
      "enName": "Aichi",
      "officeName": "名古屋地方気象台",
      "chName": "爱知县",
      "zhName": "愛知縣",
      "koName": "아이치현",
      "esName": "Prefectura de Aichi",
      "ptName": "Província de Aichi",
      "thName": "จังหวัดไอจิ",
      "viName": "Tỉnh Aichi",
      "inName": "Prefektur Aichi",
      "tlName": "Aichi Prefecture",
      "moName": "Айчи аймаг",
      "buName": "အိုင်အိကျိ ပြည်နယ်",
      "khName": "ខេត្ដ​ អាឈី",
      "neName": "आइची जिल्ला"
    },
    "class10": {
      "code": "230010",
      "name": "西部",
      "enName": "Western Region",
      "chName": "爱知县西部",
      "zhName": "愛知縣西部",
      "koName": "아이치 현 서부",
      "esName": "Oeste de Prefectura de Aichi",
      "ptName": "Região Oeste da Província de Aichi",
      "thName": "จังหวัดไอจิฟากตะวันตก",
      "viName": "Miền Tây tỉnh Aichi",
      "inName": "Bagian Barat Prefektur Aichi",
      "tlName": "Kanlurang bahagi ng Aichi Prefecture",
      "moName": "Баруун Айчи аймаг",
      "buName": "အအိချိစီရင်စု အနောက်ပိုင်း",
      "khName": "តំបន់ខាងលិចនៃខេត្ដ​អៃឈិ",
      "neName": "आइची जिल्लाको पश्चिमी भाग"
    },
    "class15": {
      "code": "230013",
      "name": "知多地域",
      "enName": "Chita Area"
    },
    "class20": {
      "code": "2344200",
      "name": "東浦町",
      "enName": "Higashiura Town",
      "kana": "ひがしうらちょう",
      "chName": "东浦町",
      "zhName": "東浦町",
      "koName": "히가시우라 정",
      "esName": "Pueblo de Higashiura",
      "ptName": "bairro de Higashiura",
      "thName": "เมืองฮิงาชิอุระ",
      "viName": "thị trấn Higashiura",
      "inName": "kota Higashiura",
      "tlName": "bayan ng Higashiura",
      "moName": "Хигaшиүра жижиг хот",
      "buName": "ဟီဂါရှိဥရာ့ မြို့နယ်",
      "khName": "ទីប្រជុំជន ហ៊ីកាស៊ីអូរ៉ា",
      "neName": "हिगाशिउरा नगर"
    }
  },
  "2344500": {
    "office": {
      "code": "230000",
      "name": "愛知県",
      "enName": "Aichi",
      "officeName": "名古屋地方気象台",
      "chName": "爱知县",
      "zhName": "愛知縣",
      "koName": "아이치현",
      "esName": "Prefectura de Aichi",
      "ptName": "Província de Aichi",
      "thName": "จังหวัดไอจิ",
      "viName": "Tỉnh Aichi",
      "inName": "Prefektur Aichi",
      "tlName": "Aichi Prefecture",
      "moName": "Айчи аймаг",
      "buName": "အိုင်အိကျိ ပြည်နယ်",
      "khName": "ខេត្ដ​ អាឈី",
      "neName": "आइची जिल्ला"
    },
    "class10": {
      "code": "230010",
      "name": "西部",
      "enName": "Western Region",
      "chName": "爱知县西部",
      "zhName": "愛知縣西部",
      "koName": "아이치 현 서부",
      "esName": "Oeste de Prefectura de Aichi",
      "ptName": "Região Oeste da Província de Aichi",
      "thName": "จังหวัดไอจิฟากตะวันตก",
      "viName": "Miền Tây tỉnh Aichi",
      "inName": "Bagian Barat Prefektur Aichi",
      "tlName": "Kanlurang bahagi ng Aichi Prefecture",
      "moName": "Баруун Айчи аймаг",
      "buName": "အအိချိစီရင်စု အနောက်ပိုင်း",
      "khName": "តំបន់ខាងលិចនៃខេត្ដ​អៃឈិ",
      "neName": "आइची जिल्लाको पश्चिमी भाग"
    },
    "class15": {
      "code": "230013",
      "name": "知多地域",
      "enName": "Chita Area"
    },
    "class20": {
      "code": "2344500",
      "name": "南知多町",
      "enName": "Minamichita Town",
      "kana": "みなみちたちょう",
      "chName": "南知多町",
      "zhName": "南知多町",
      "koName": "미나미치타 정",
      "esName": "Pueblo de Minamichita",
      "ptName": "bairro de Minamichita",
      "thName": "เมืองมินามิจิตะ",
      "viName": "thị trấn Minamichita",
      "inName": "kota Minamichita",
      "tlName": "bayan ng Minamichita",
      "moName": "Минaмичита жижиг хот",
      "buName": "မီနာမီးကျိတ မြို့နယ်",
      "khName": "ទីប្រជុំជន មីណាមីជីតា",
      "neName": "मिनामिचिता नगर"
    }
  },
  "2344600": {
    "office": {
      "code": "230000",
      "name": "愛知県",
      "enName": "Aichi",
      "officeName": "名古屋地方気象台",
      "chName": "爱知县",
      "zhName": "愛知縣",
      "koName": "아이치현",
      "esName": "Prefectura de Aichi",
      "ptName": "Província de Aichi",
      "thName": "จังหวัดไอจิ",
      "viName": "Tỉnh Aichi",
      "inName": "Prefektur Aichi",
      "tlName": "Aichi Prefecture",
      "moName": "Айчи аймаг",
      "buName": "အိုင်အိကျိ ပြည်နယ်",
      "khName": "ខេត្ដ​ អាឈី",
      "neName": "आइची जिल्ला"
    },
    "class10": {
      "code": "230010",
      "name": "西部",
      "enName": "Western Region",
      "chName": "爱知县西部",
      "zhName": "愛知縣西部",
      "koName": "아이치 현 서부",
      "esName": "Oeste de Prefectura de Aichi",
      "ptName": "Região Oeste da Província de Aichi",
      "thName": "จังหวัดไอจิฟากตะวันตก",
      "viName": "Miền Tây tỉnh Aichi",
      "inName": "Bagian Barat Prefektur Aichi",
      "tlName": "Kanlurang bahagi ng Aichi Prefecture",
      "moName": "Баруун Айчи аймаг",
      "buName": "အအိချိစီရင်စု အနောက်ပိုင်း",
      "khName": "តំបន់ខាងលិចនៃខេត្ដ​អៃឈិ",
      "neName": "आइची जिल्लाको पश्चिमी भाग"
    },
    "class15": {
      "code": "230013",
      "name": "知多地域",
      "enName": "Chita Area"
    },
    "class20": {
      "code": "2344600",
      "name": "美浜町",
      "enName": "Mihama Town",
      "kana": "みはまちょう",
      "chName": "爱知美浜町",
      "zhName": "愛知美浜町",
      "koName": "아이치 미하마 정",
      "esName": "Pueblo de Mihama, Aichi",
      "ptName": "Aichi, bairro de Mihama",
      "thName": "เมืองมิฮามะ ไอจิ",
      "viName": "Thị trấn Mihama, Aichi",
      "inName": "Kota Mihama, Aichi",
      "tlName": "bayan ng Mihama, Aichi",
      "moName": "Айчи Михама жижиг хот",
      "buName": "အအိချိမိဟမမြို့နယ်",
      "khName": "ទីប្រជុំជន​មីហាម៉ា អៃឈិ",
      "neName": "आइची मिहामा नगर"
    }
  },
  "2344700": {
    "office": {
      "code": "230000",
      "name": "愛知県",
      "enName": "Aichi",
      "officeName": "名古屋地方気象台",
      "chName": "爱知县",
      "zhName": "愛知縣",
      "koName": "아이치현",
      "esName": "Prefectura de Aichi",
      "ptName": "Província de Aichi",
      "thName": "จังหวัดไอจิ",
      "viName": "Tỉnh Aichi",
      "inName": "Prefektur Aichi",
      "tlName": "Aichi Prefecture",
      "moName": "Айчи аймаг",
      "buName": "အိုင်အိကျိ ပြည်နယ်",
      "khName": "ខេត្ដ​ អាឈី",
      "neName": "आइची जिल्ला"
    },
    "class10": {
      "code": "230010",
      "name": "西部",
      "enName": "Western Region",
      "chName": "爱知县西部",
      "zhName": "愛知縣西部",
      "koName": "아이치 현 서부",
      "esName": "Oeste de Prefectura de Aichi",
      "ptName": "Região Oeste da Província de Aichi",
      "thName": "จังหวัดไอจิฟากตะวันตก",
      "viName": "Miền Tây tỉnh Aichi",
      "inName": "Bagian Barat Prefektur Aichi",
      "tlName": "Kanlurang bahagi ng Aichi Prefecture",
      "moName": "Баруун Айчи аймаг",
      "buName": "အအိချိစီရင်စု အနောက်ပိုင်း",
      "khName": "តំបន់ខាងលិចនៃខេត្ដ​អៃឈិ",
      "neName": "आइची जिल्लाको पश्चिमी भाग"
    },
    "class15": {
      "code": "230013",
      "name": "知多地域",
      "enName": "Chita Area"
    },
    "class20": {
      "code": "2344700",
      "name": "武豊町",
      "enName": "Taketoyo Town",
      "kana": "たけとよちょう",
      "chName": "武丰町",
      "zhName": "武豐町",
      "koName": "다케토요 정",
      "esName": "Pueblo de Taketoyo",
      "ptName": "bairro de Taketoyo",
      "thName": "เมืองทาเคโทโยะ",
      "viName": "thị trấn Taketoyo",
      "inName": "kota Taketoyo",
      "tlName": "bayan ng Taketoyo",
      "moName": "Такэтоё жижиг хот",
      "buName": "တာကေ့တိုရို မြို့နယ်",
      "khName": "ទីប្រជុំជន តាកេតូយូ",
      "neName": "ताकेतोयो नगर"
    }
  },
  "2350100": {
    "office": {
      "code": "230000",
      "name": "愛知県",
      "enName": "Aichi",
      "officeName": "名古屋地方気象台",
      "chName": "爱知县",
      "zhName": "愛知縣",
      "koName": "아이치현",
      "esName": "Prefectura de Aichi",
      "ptName": "Província de Aichi",
      "thName": "จังหวัดไอจิ",
      "viName": "Tỉnh Aichi",
      "inName": "Prefektur Aichi",
      "tlName": "Aichi Prefecture",
      "moName": "Айчи аймаг",
      "buName": "အိုင်အိကျိ ပြည်နယ်",
      "khName": "ខេត្ដ​ អាឈី",
      "neName": "आइची जिल्ला"
    },
    "class10": {
      "code": "230010",
      "name": "西部",
      "enName": "Western Region",
      "chName": "爱知县西部",
      "zhName": "愛知縣西部",
      "koName": "아이치 현 서부",
      "esName": "Oeste de Prefectura de Aichi",
      "ptName": "Região Oeste da Província de Aichi",
      "thName": "จังหวัดไอจิฟากตะวันตก",
      "viName": "Miền Tây tỉnh Aichi",
      "inName": "Bagian Barat Prefektur Aichi",
      "tlName": "Kanlurang bahagi ng Aichi Prefecture",
      "moName": "Баруун Айчи аймаг",
      "buName": "အအိချိစီရင်စု အနောက်ပိုင်း",
      "khName": "តំបន់ខាងលិចនៃខេត្ដ​អៃឈិ",
      "neName": "आइची जिल्लाको पश्चिमी भाग"
    },
    "class15": {
      "code": "230014",
      "name": "西三河南部",
      "enName": "Southern Nishi-mikawa Region"
    },
    "class20": {
      "code": "2350100",
      "name": "幸田町",
      "enName": "Kota Town",
      "kana": "こうたちょう",
      "chName": "幸田町",
      "zhName": "幸田町",
      "koName": "고타 정",
      "esName": "Pueblo de Kota",
      "ptName": "bairro de Kota",
      "thName": "เมืองโคตะ",
      "viName": "thị trấn Kota",
      "inName": "kota Kota",
      "tlName": "bayan ng Kota",
      "moName": "Кота жижиг хот",
      "buName": "ကိုးတ မြို့နယ်",
      "khName": "ទីប្រជុំជន កូតា",
      "neName": "कोता नगर"
    }
  },
  "2356100": {
    "office": {
      "code": "230000",
      "name": "愛知県",
      "enName": "Aichi",
      "officeName": "名古屋地方気象台",
      "chName": "爱知县",
      "zhName": "愛知縣",
      "koName": "아이치현",
      "esName": "Prefectura de Aichi",
      "ptName": "Província de Aichi",
      "thName": "จังหวัดไอจิ",
      "viName": "Tỉnh Aichi",
      "inName": "Prefektur Aichi",
      "tlName": "Aichi Prefecture",
      "moName": "Айчи аймаг",
      "buName": "အိုင်အိကျိ ပြည်နယ်",
      "khName": "ខេត្ដ​ អាឈី",
      "neName": "आइची जिल्ला"
    },
    "class10": {
      "code": "230020",
      "name": "東部",
      "enName": "Eastern Region",
      "chName": "爱知县东部",
      "zhName": "愛知縣東部",
      "koName": "아이치 현 동부",
      "esName": "Este de Prefectura de Aichi",
      "ptName": "Região Leste da Província de Aichi",
      "thName": "จังหวัดไอจิฟากตะวันออก",
      "viName": "Miền Đông tỉnh Aichi",
      "inName": "Bagian Timur Prefektur Aichi",
      "tlName": "Silangang bahagi ng Aichi Prefecture",
      "moName": "Зүүн Айчи аймаг",
      "buName": "အအိချိစီရင်စု အရှေ့ပိုင်း",
      "khName": "តំបន់ខាងកើតនៃខេត្ដ​អៃឈិ",
      "neName": "आइची जिल्लाको पूर्वी भाग"
    },
    "class15": {
      "code": "230022",
      "name": "東三河北部",
      "enName": "Northern Higashi-mikawa Region"
    },
    "class20": {
      "code": "2356100",
      "name": "設楽町",
      "enName": "Shitara Town",
      "kana": "したらちょう",
      "chName": "设乐町",
      "zhName": "設樂町",
      "koName": "시타라 정",
      "esName": "Pueblo de Shitara",
      "ptName": "bairro de Shitara",
      "thName": "เมืองชิตาระ",
      "viName": "thị trấn Shitara",
      "inName": "kota Shitara",
      "tlName": "bayan ng Shitara",
      "moName": "Шитара жижиг хот",
      "buName": "ရှီတာ့ရာ့ မြို့နယ်",
      "khName": "ទីប្រជុំជន ស៊ីតារ៉ា",
      "neName": "शितारा नगर"
    }
  },
  "2356200": {
    "office": {
      "code": "230000",
      "name": "愛知県",
      "enName": "Aichi",
      "officeName": "名古屋地方気象台",
      "chName": "爱知县",
      "zhName": "愛知縣",
      "koName": "아이치현",
      "esName": "Prefectura de Aichi",
      "ptName": "Província de Aichi",
      "thName": "จังหวัดไอจิ",
      "viName": "Tỉnh Aichi",
      "inName": "Prefektur Aichi",
      "tlName": "Aichi Prefecture",
      "moName": "Айчи аймаг",
      "buName": "အိုင်အိကျိ ပြည်နယ်",
      "khName": "ខេត្ដ​ អាឈី",
      "neName": "आइची जिल्ला"
    },
    "class10": {
      "code": "230020",
      "name": "東部",
      "enName": "Eastern Region",
      "chName": "爱知县东部",
      "zhName": "愛知縣東部",
      "koName": "아이치 현 동부",
      "esName": "Este de Prefectura de Aichi",
      "ptName": "Região Leste da Província de Aichi",
      "thName": "จังหวัดไอจิฟากตะวันออก",
      "viName": "Miền Đông tỉnh Aichi",
      "inName": "Bagian Timur Prefektur Aichi",
      "tlName": "Silangang bahagi ng Aichi Prefecture",
      "moName": "Зүүн Айчи аймаг",
      "buName": "အအိချိစီရင်စု အရှေ့ပိုင်း",
      "khName": "តំបន់ខាងកើតនៃខេត្ដ​អៃឈិ",
      "neName": "आइची जिल्लाको पूर्वी भाग"
    },
    "class15": {
      "code": "230022",
      "name": "東三河北部",
      "enName": "Northern Higashi-mikawa Region"
    },
    "class20": {
      "code": "2356200",
      "name": "東栄町",
      "enName": "Toei Town",
      "kana": "とうえいちょう",
      "chName": "东荣町",
      "zhName": "東榮町",
      "koName": "도에이 정",
      "esName": "Pueblo de Toei",
      "ptName": "bairro de Toei",
      "thName": "เมืองโทเอ",
      "viName": "thị trấn Toei",
      "inName": "kota Toei",
      "tlName": "bayan ng Toei",
      "moName": "Тоэй жижиг хот",
      "buName": "တိုးအဲ့ မြို့နယ်",
      "khName": "ទីប្រជុំជន ថូអេ",
      "neName": "तोएई नगर"
    }
  },
  "2356300": {
    "office": {
      "code": "230000",
      "name": "愛知県",
      "enName": "Aichi",
      "officeName": "名古屋地方気象台",
      "chName": "爱知县",
      "zhName": "愛知縣",
      "koName": "아이치현",
      "esName": "Prefectura de Aichi",
      "ptName": "Província de Aichi",
      "thName": "จังหวัดไอจิ",
      "viName": "Tỉnh Aichi",
      "inName": "Prefektur Aichi",
      "tlName": "Aichi Prefecture",
      "moName": "Айчи аймаг",
      "buName": "အိုင်အိကျိ ပြည်နယ်",
      "khName": "ខេត្ដ​ អាឈី",
      "neName": "आइची जिल्ला"
    },
    "class10": {
      "code": "230020",
      "name": "東部",
      "enName": "Eastern Region",
      "chName": "爱知县东部",
      "zhName": "愛知縣東部",
      "koName": "아이치 현 동부",
      "esName": "Este de Prefectura de Aichi",
      "ptName": "Região Leste da Província de Aichi",
      "thName": "จังหวัดไอจิฟากตะวันออก",
      "viName": "Miền Đông tỉnh Aichi",
      "inName": "Bagian Timur Prefektur Aichi",
      "tlName": "Silangang bahagi ng Aichi Prefecture",
      "moName": "Зүүн Айчи аймаг",
      "buName": "အအိချိစီရင်စု အရှေ့ပိုင်း",
      "khName": "តំបន់ខាងកើតនៃខេត្ដ​អៃឈិ",
      "neName": "आइची जिल्लाको पूर्वी भाग"
    },
    "class15": {
      "code": "230022",
      "name": "東三河北部",
      "enName": "Northern Higashi-mikawa Region"
    },
    "class20": {
      "code": "2356300",
      "name": "豊根村",
      "enName": "Toyone Village",
      "kana": "とよねむら",
      "chName": "丰根村",
      "zhName": "豐根村",
      "koName": "도요네 촌",
      "esName": "Aldea de Toyone",
      "ptName": "povoado de Toyone",
      "thName": "หมู่บ้านโทโยเนะ",
      "viName": "làng Toyone",
      "inName": "desa Toyone",
      "tlName": "nayon ng Toyone",
      "moName": "Тоёнэ тосгон",
      "buName": "တိုယို့နဲ့ ကျေးရွာ",
      "khName": "ភូមិ ថូយ៉ូណេ ",
      "neName": "तोयोने गाउँ"
    }
  },
  "2420111": {
    "office": {
      "code": "240000",
      "name": "三重県",
      "enName": "Mie",
      "officeName": "津地方気象台",
      "chName": "三重县",
      "zhName": "三重縣",
      "koName": "미에현",
      "esName": "Prefectura de Mie",
      "ptName": "Província de Mie",
      "thName": "จังหวัดมิเอะ",
      "viName": "Tỉnh Mie",
      "inName": "Prefektur Mie",
      "tlName": "Mie Prefecture",
      "moName": "Миэ аймаг",
      "buName": "မီးယဲ့ ပြည်နယ်",
      "khName": "ខេត្ដ មី",
      "neName": "मिए जिल्ला"
    },
    "class10": {
      "code": "240010",
      "name": "北中部",
      "enName": "Northern Central Region",
      "chName": "三重县北部",
      "zhName": "三重縣北部",
      "koName": "미에 현 북부",
      "esName": "Este de Prefectura de Mie",
      "ptName": "Região norte da Província de Mie",
      "thName": "จังหวัดมิเอะตอนเหนือ",
      "viName": "Miền Bắc tỉnh Mie",
      "inName": "Bagian Utara Prefektur Mie",
      "tlName": "Hilagang bahagi ng Mie Prefecture",
      "moName": "Хойд Миэ аймаг",
      "buName": "မိအဲစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដមីអិ",
      "neName": "मिए जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "240011",
      "name": "中部",
      "enName": "Central Region"
    },
    "class20": {
      "code": "2420111",
      "name": "津市東部",
      "enName": "Eastern Tsu City",
      "kana": "つしとうぶ"
    }
  },
  "2420112": {
    "office": {
      "code": "240000",
      "name": "三重県",
      "enName": "Mie",
      "officeName": "津地方気象台",
      "chName": "三重县",
      "zhName": "三重縣",
      "koName": "미에현",
      "esName": "Prefectura de Mie",
      "ptName": "Província de Mie",
      "thName": "จังหวัดมิเอะ",
      "viName": "Tỉnh Mie",
      "inName": "Prefektur Mie",
      "tlName": "Mie Prefecture",
      "moName": "Миэ аймаг",
      "buName": "မီးယဲ့ ပြည်နယ်",
      "khName": "ខេត្ដ មី",
      "neName": "मिए जिल्ला"
    },
    "class10": {
      "code": "240010",
      "name": "北中部",
      "enName": "Northern Central Region",
      "chName": "三重县北部",
      "zhName": "三重縣北部",
      "koName": "미에 현 북부",
      "esName": "Este de Prefectura de Mie",
      "ptName": "Região norte da Província de Mie",
      "thName": "จังหวัดมิเอะตอนเหนือ",
      "viName": "Miền Bắc tỉnh Mie",
      "inName": "Bagian Utara Prefektur Mie",
      "tlName": "Hilagang bahagi ng Mie Prefecture",
      "moName": "Хойд Миэ аймаг",
      "buName": "မိအဲစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដមីអិ",
      "neName": "मिए जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "240011",
      "name": "中部",
      "enName": "Central Region"
    },
    "class20": {
      "code": "2420112",
      "name": "津市中西部",
      "enName": "Midwestern Tsu City",
      "kana": "つしちゅうせいぶ"
    }
  },
  "2420200": {
    "office": {
      "code": "240000",
      "name": "三重県",
      "enName": "Mie",
      "officeName": "津地方気象台",
      "chName": "三重县",
      "zhName": "三重縣",
      "koName": "미에현",
      "esName": "Prefectura de Mie",
      "ptName": "Província de Mie",
      "thName": "จังหวัดมิเอะ",
      "viName": "Tỉnh Mie",
      "inName": "Prefektur Mie",
      "tlName": "Mie Prefecture",
      "moName": "Миэ аймаг",
      "buName": "မီးယဲ့ ပြည်နယ်",
      "khName": "ខេត្ដ មី",
      "neName": "मिए जिल्ला"
    },
    "class10": {
      "code": "240010",
      "name": "北中部",
      "enName": "Northern Central Region",
      "chName": "三重县北部",
      "zhName": "三重縣北部",
      "koName": "미에 현 북부",
      "esName": "Este de Prefectura de Mie",
      "ptName": "Região norte da Província de Mie",
      "thName": "จังหวัดมิเอะตอนเหนือ",
      "viName": "Miền Bắc tỉnh Mie",
      "inName": "Bagian Utara Prefektur Mie",
      "tlName": "Hilagang bahagi ng Mie Prefecture",
      "moName": "Хойд Миэ аймаг",
      "buName": "မိအဲစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដមីអិ",
      "neName": "मिए जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "240012",
      "name": "北部",
      "enName": "Northern Region"
    },
    "class20": {
      "code": "2420200",
      "name": "四日市市",
      "enName": "Yokkaichi City",
      "kana": "よっかいちし",
      "chName": "四日市市",
      "zhName": "四日市市",
      "koName": "욧카이치 시",
      "esName": "Ciudad de Yokkaichi",
      "ptName": "cidade de Yokkaichi",
      "thName": "เมืองยกไคจิ",
      "viName": "thành phố Yokkaichi",
      "inName": "kota Yokkaichi",
      "tlName": "siyudad ng Yokkaichi",
      "moName": "Ёоккайчи хот",
      "buName": "ယိုကိုင်းယိကျိ မြို့",
      "khName": "ទីក្រុង យូកាឈី",
      "neName": "योक्काइची सहर"
    }
  },
  "2420300": {
    "office": {
      "code": "240000",
      "name": "三重県",
      "enName": "Mie",
      "officeName": "津地方気象台",
      "chName": "三重县",
      "zhName": "三重縣",
      "koName": "미에현",
      "esName": "Prefectura de Mie",
      "ptName": "Província de Mie",
      "thName": "จังหวัดมิเอะ",
      "viName": "Tỉnh Mie",
      "inName": "Prefektur Mie",
      "tlName": "Mie Prefecture",
      "moName": "Миэ аймаг",
      "buName": "မီးယဲ့ ပြည်နယ်",
      "khName": "ខេត្ដ មី",
      "neName": "मिए जिल्ला"
    },
    "class10": {
      "code": "240020",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "三重县南部",
      "zhName": "三重縣南部",
      "koName": "미에 현 남부",
      "esName": "Sur de Prefectura de Mie",
      "ptName": "Regiõ sul da Província de Mie",
      "thName": "จังหวัดมิเอะตอนใต้",
      "viName": "Miền Nam tỉnh Mie",
      "inName": "Bagian Selatan Prefektur Mie",
      "tlName": "Timog na bahagi ng Mie Prefecture",
      "moName": "Өмнөд Миэ аймаг",
      "buName": "မိအဲစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដមីអិ",
      "neName": "मिए जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "240021",
      "name": "伊勢志摩",
      "enName": "Ise Shima"
    },
    "class20": {
      "code": "2420300",
      "name": "伊勢市",
      "enName": "Ise City",
      "kana": "いせし",
      "chName": "伊势市",
      "zhName": "伊勢市",
      "koName": "이세 시",
      "esName": "Ciudad de Ise",
      "ptName": "cidade de Ise",
      "thName": "เมืองอิเซะ",
      "viName": "thành phố Ise",
      "inName": "kota Ise",
      "tlName": "siyudad ng Ise",
      "moName": "Исэ хот",
      "buName": "အိဆဲ့ မြို့",
      "khName": "ទីក្រុង អៃស៍",
      "neName": "इसे सहर"
    }
  },
  "2420411": {
    "office": {
      "code": "240000",
      "name": "三重県",
      "enName": "Mie",
      "officeName": "津地方気象台",
      "chName": "三重县",
      "zhName": "三重縣",
      "koName": "미에현",
      "esName": "Prefectura de Mie",
      "ptName": "Província de Mie",
      "thName": "จังหวัดมิเอะ",
      "viName": "Tỉnh Mie",
      "inName": "Prefektur Mie",
      "tlName": "Mie Prefecture",
      "moName": "Миэ аймаг",
      "buName": "မီးယဲ့ ပြည်နယ်",
      "khName": "ខេត្ដ មី",
      "neName": "मिए जिल्ला"
    },
    "class10": {
      "code": "240010",
      "name": "北中部",
      "enName": "Northern Central Region",
      "chName": "三重县北部",
      "zhName": "三重縣北部",
      "koName": "미에 현 북부",
      "esName": "Este de Prefectura de Mie",
      "ptName": "Região norte da Província de Mie",
      "thName": "จังหวัดมิเอะตอนเหนือ",
      "viName": "Miền Bắc tỉnh Mie",
      "inName": "Bagian Utara Prefektur Mie",
      "tlName": "Hilagang bahagi ng Mie Prefecture",
      "moName": "Хойд Миэ аймаг",
      "buName": "မိအဲစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដមីអិ",
      "neName": "मिए जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "240011",
      "name": "中部",
      "enName": "Central Region"
    },
    "class20": {
      "code": "2420411",
      "name": "松阪市東部",
      "enName": "Eastern Matsusaka City",
      "kana": "まつさかしとうぶ"
    }
  },
  "2420412": {
    "office": {
      "code": "240000",
      "name": "三重県",
      "enName": "Mie",
      "officeName": "津地方気象台",
      "chName": "三重县",
      "zhName": "三重縣",
      "koName": "미에현",
      "esName": "Prefectura de Mie",
      "ptName": "Província de Mie",
      "thName": "จังหวัดมิเอะ",
      "viName": "Tỉnh Mie",
      "inName": "Prefektur Mie",
      "tlName": "Mie Prefecture",
      "moName": "Миэ аймаг",
      "buName": "မီးယဲ့ ပြည်နယ်",
      "khName": "ខេត្ដ មី",
      "neName": "मिए जिल्ला"
    },
    "class10": {
      "code": "240010",
      "name": "北中部",
      "enName": "Northern Central Region",
      "chName": "三重县北部",
      "zhName": "三重縣北部",
      "koName": "미에 현 북부",
      "esName": "Este de Prefectura de Mie",
      "ptName": "Região norte da Província de Mie",
      "thName": "จังหวัดมิเอะตอนเหนือ",
      "viName": "Miền Bắc tỉnh Mie",
      "inName": "Bagian Utara Prefektur Mie",
      "tlName": "Hilagang bahagi ng Mie Prefecture",
      "moName": "Хойд Миэ аймаг",
      "buName": "မိအဲစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដមីអិ",
      "neName": "मिए जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "240011",
      "name": "中部",
      "enName": "Central Region"
    },
    "class20": {
      "code": "2420412",
      "name": "松阪市西部",
      "enName": "Western Matsusaka City",
      "kana": "まつさかしせいぶ"
    }
  },
  "2420500": {
    "office": {
      "code": "240000",
      "name": "三重県",
      "enName": "Mie",
      "officeName": "津地方気象台",
      "chName": "三重县",
      "zhName": "三重縣",
      "koName": "미에현",
      "esName": "Prefectura de Mie",
      "ptName": "Província de Mie",
      "thName": "จังหวัดมิเอะ",
      "viName": "Tỉnh Mie",
      "inName": "Prefektur Mie",
      "tlName": "Mie Prefecture",
      "moName": "Миэ аймаг",
      "buName": "မီးယဲ့ ပြည်နယ်",
      "khName": "ខេត្ដ មី",
      "neName": "मिए जिल्ला"
    },
    "class10": {
      "code": "240010",
      "name": "北中部",
      "enName": "Northern Central Region",
      "chName": "三重县北部",
      "zhName": "三重縣北部",
      "koName": "미에 현 북부",
      "esName": "Este de Prefectura de Mie",
      "ptName": "Região norte da Província de Mie",
      "thName": "จังหวัดมิเอะตอนเหนือ",
      "viName": "Miền Bắc tỉnh Mie",
      "inName": "Bagian Utara Prefektur Mie",
      "tlName": "Hilagang bahagi ng Mie Prefecture",
      "moName": "Хойд Миэ аймаг",
      "buName": "မိအဲစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដមីអិ",
      "neName": "मिए जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "240012",
      "name": "北部",
      "enName": "Northern Region"
    },
    "class20": {
      "code": "2420500",
      "name": "桑名市",
      "enName": "Kuwana City",
      "kana": "くわなし",
      "chName": "桑名市",
      "zhName": "桑名市",
      "koName": "구와나 시",
      "esName": "Ciudad de Kuwana",
      "ptName": "cidade de Kuwana",
      "thName": "เมืองคุวานะ",
      "viName": "thành phố Kuwana",
      "inName": "kota Kuwana",
      "tlName": "siyudad ng Kuwana",
      "moName": "Күванa хот",
      "buName": "ကုဝါ့ဏ မြို့",
      "khName": "ទីក្រុង គុយវ៉ាណា",
      "neName": "कुवाना सहर"
    }
  },
  "2420700": {
    "office": {
      "code": "240000",
      "name": "三重県",
      "enName": "Mie",
      "officeName": "津地方気象台",
      "chName": "三重县",
      "zhName": "三重縣",
      "koName": "미에현",
      "esName": "Prefectura de Mie",
      "ptName": "Província de Mie",
      "thName": "จังหวัดมิเอะ",
      "viName": "Tỉnh Mie",
      "inName": "Prefektur Mie",
      "tlName": "Mie Prefecture",
      "moName": "Миэ аймаг",
      "buName": "မီးယဲ့ ပြည်နယ်",
      "khName": "ខេត្ដ មី",
      "neName": "मिए जिल्ला"
    },
    "class10": {
      "code": "240010",
      "name": "北中部",
      "enName": "Northern Central Region",
      "chName": "三重县北部",
      "zhName": "三重縣北部",
      "koName": "미에 현 북부",
      "esName": "Este de Prefectura de Mie",
      "ptName": "Região norte da Província de Mie",
      "thName": "จังหวัดมิเอะตอนเหนือ",
      "viName": "Miền Bắc tỉnh Mie",
      "inName": "Bagian Utara Prefektur Mie",
      "tlName": "Hilagang bahagi ng Mie Prefecture",
      "moName": "Хойд Миэ аймаг",
      "buName": "မိအဲစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដមីអិ",
      "neName": "मिए जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "240012",
      "name": "北部",
      "enName": "Northern Region"
    },
    "class20": {
      "code": "2420700",
      "name": "鈴鹿市",
      "enName": "Suzuka City",
      "kana": "すずかし",
      "chName": "铃鹿市",
      "zhName": "鈴鹿市",
      "koName": "스즈카 시",
      "esName": "Ciudad de Suzuka",
      "ptName": "cidade de Suzuka",
      "thName": "เมืองสุซุกะ",
      "viName": "thành phố Suzuka",
      "inName": "kota Suzuka",
      "tlName": "siyudad ng Suzuka",
      "moName": "Сүзүка хот",
      "buName": "ဆူဇုက မြို့",
      "khName": "ទីក្រុង ស៊ូយស៊ូកា",
      "neName": "सुजुका सहर"
    }
  },
  "2420800": {
    "office": {
      "code": "240000",
      "name": "三重県",
      "enName": "Mie",
      "officeName": "津地方気象台",
      "chName": "三重县",
      "zhName": "三重縣",
      "koName": "미에현",
      "esName": "Prefectura de Mie",
      "ptName": "Província de Mie",
      "thName": "จังหวัดมิเอะ",
      "viName": "Tỉnh Mie",
      "inName": "Prefektur Mie",
      "tlName": "Mie Prefecture",
      "moName": "Миэ аймаг",
      "buName": "မီးယဲ့ ပြည်နယ်",
      "khName": "ខេត្ដ មី",
      "neName": "मिए जिल्ला"
    },
    "class10": {
      "code": "240010",
      "name": "北中部",
      "enName": "Northern Central Region",
      "chName": "三重县北部",
      "zhName": "三重縣北部",
      "koName": "미에 현 북부",
      "esName": "Este de Prefectura de Mie",
      "ptName": "Região norte da Província de Mie",
      "thName": "จังหวัดมิเอะตอนเหนือ",
      "viName": "Miền Bắc tỉnh Mie",
      "inName": "Bagian Utara Prefektur Mie",
      "tlName": "Hilagang bahagi ng Mie Prefecture",
      "moName": "Хойд Миэ аймаг",
      "buName": "မိအဲစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដមីអិ",
      "neName": "मिए जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "240013",
      "name": "伊賀",
      "enName": "Iga"
    },
    "class20": {
      "code": "2420800",
      "name": "名張市",
      "enName": "Nabari City",
      "kana": "なばりし",
      "chName": "名张市",
      "zhName": "名張市",
      "koName": "나바리 시",
      "esName": "Ciudad de Nabari",
      "ptName": "cidade de Nabari",
      "thName": "เมืองนาบาริ",
      "viName": "thành phố Nabari",
      "inName": "kota Nabari",
      "tlName": "siyudad ng Nabari",
      "moName": "Нaбари хот",
      "buName": "နာဘာ့ရိ မြို့",
      "khName": "ទីក្រុង ណាបារី",
      "neName": "नाबारी सहर"
    }
  },
  "2420900": {
    "office": {
      "code": "240000",
      "name": "三重県",
      "enName": "Mie",
      "officeName": "津地方気象台",
      "chName": "三重县",
      "zhName": "三重縣",
      "koName": "미에현",
      "esName": "Prefectura de Mie",
      "ptName": "Província de Mie",
      "thName": "จังหวัดมิเอะ",
      "viName": "Tỉnh Mie",
      "inName": "Prefektur Mie",
      "tlName": "Mie Prefecture",
      "moName": "Миэ аймаг",
      "buName": "မီးယဲ့ ပြည်နယ်",
      "khName": "ខេត្ដ មី",
      "neName": "मिए जिल्ला"
    },
    "class10": {
      "code": "240020",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "三重县南部",
      "zhName": "三重縣南部",
      "koName": "미에 현 남부",
      "esName": "Sur de Prefectura de Mie",
      "ptName": "Regiõ sul da Província de Mie",
      "thName": "จังหวัดมิเอะตอนใต้",
      "viName": "Miền Nam tỉnh Mie",
      "inName": "Bagian Selatan Prefektur Mie",
      "tlName": "Timog na bahagi ng Mie Prefecture",
      "moName": "Өмнөд Миэ аймаг",
      "buName": "မိအဲစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដមីអិ",
      "neName": "मिए जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "240022",
      "name": "紀勢・東紀州",
      "enName": "Kisei Higashi-kishu"
    },
    "class20": {
      "code": "2420900",
      "name": "尾鷲市",
      "enName": "Owase City",
      "kana": "おわせし",
      "chName": "尾鹫市",
      "zhName": "尾鷲市",
      "koName": "오와세 시",
      "esName": "Ciudad de Owase",
      "ptName": "cidade de Owase",
      "thName": "เมืองโอวาเสะ",
      "viName": "thành phố Owase",
      "inName": "kota Owase",
      "tlName": "siyudad ng Owase",
      "moName": "Овасэ хот",
      "buName": "အိုဝါဆီ မြို့",
      "khName": "ទីក្រុង អូវ៉ាសិ",
      "neName": "ओवासे सहर"
    }
  },
  "2421000": {
    "office": {
      "code": "240000",
      "name": "三重県",
      "enName": "Mie",
      "officeName": "津地方気象台",
      "chName": "三重县",
      "zhName": "三重縣",
      "koName": "미에현",
      "esName": "Prefectura de Mie",
      "ptName": "Província de Mie",
      "thName": "จังหวัดมิเอะ",
      "viName": "Tỉnh Mie",
      "inName": "Prefektur Mie",
      "tlName": "Mie Prefecture",
      "moName": "Миэ аймаг",
      "buName": "မီးယဲ့ ပြည်နယ်",
      "khName": "ខេត្ដ មី",
      "neName": "मिए जिल्ला"
    },
    "class10": {
      "code": "240010",
      "name": "北中部",
      "enName": "Northern Central Region",
      "chName": "三重县北部",
      "zhName": "三重縣北部",
      "koName": "미에 현 북부",
      "esName": "Este de Prefectura de Mie",
      "ptName": "Região norte da Província de Mie",
      "thName": "จังหวัดมิเอะตอนเหนือ",
      "viName": "Miền Bắc tỉnh Mie",
      "inName": "Bagian Utara Prefektur Mie",
      "tlName": "Hilagang bahagi ng Mie Prefecture",
      "moName": "Хойд Миэ аймаг",
      "buName": "မိအဲစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដមីអិ",
      "neName": "मिए जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "240012",
      "name": "北部",
      "enName": "Northern Region"
    },
    "class20": {
      "code": "2421000",
      "name": "亀山市",
      "enName": "Kameyama City",
      "kana": "かめやまし",
      "chName": "龟山市",
      "zhName": "龜山市",
      "koName": "가메야마 시",
      "esName": "Ciudad de Kameyama",
      "ptName": "cidade de Kameyama",
      "thName": "เมืองคาเมยามะ",
      "viName": "thành phố Kameyama",
      "inName": "kota Kameyama",
      "tlName": "siyudad ng Kameyama",
      "moName": "Камэямa хот",
      "buName": "ခါမေးယာ့မ မြို့",
      "khName": "ទីក្រុង កាម៉ីយ៉ាម៉ា",
      "neName": "कामेयामा सहर"
    }
  },
  "2421100": {
    "office": {
      "code": "240000",
      "name": "三重県",
      "enName": "Mie",
      "officeName": "津地方気象台",
      "chName": "三重县",
      "zhName": "三重縣",
      "koName": "미에현",
      "esName": "Prefectura de Mie",
      "ptName": "Província de Mie",
      "thName": "จังหวัดมิเอะ",
      "viName": "Tỉnh Mie",
      "inName": "Prefektur Mie",
      "tlName": "Mie Prefecture",
      "moName": "Миэ аймаг",
      "buName": "မီးယဲ့ ပြည်နယ်",
      "khName": "ខេត្ដ មី",
      "neName": "मिए जिल्ला"
    },
    "class10": {
      "code": "240020",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "三重县南部",
      "zhName": "三重縣南部",
      "koName": "미에 현 남부",
      "esName": "Sur de Prefectura de Mie",
      "ptName": "Regiõ sul da Província de Mie",
      "thName": "จังหวัดมิเอะตอนใต้",
      "viName": "Miền Nam tỉnh Mie",
      "inName": "Bagian Selatan Prefektur Mie",
      "tlName": "Timog na bahagi ng Mie Prefecture",
      "moName": "Өмнөд Миэ аймаг",
      "buName": "မိအဲစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដមីអិ",
      "neName": "मिए जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "240021",
      "name": "伊勢志摩",
      "enName": "Ise Shima"
    },
    "class20": {
      "code": "2421100",
      "name": "鳥羽市",
      "enName": "Toba City",
      "kana": "とばし",
      "chName": "鸟羽市",
      "zhName": "鳥羽市",
      "koName": "도바 시",
      "esName": "Ciudad de Toba",
      "ptName": "cidade de Toba",
      "thName": "เมืองโทบะ",
      "viName": "thành phố Toba",
      "inName": "kota Toba",
      "tlName": "siyudad ng Toba",
      "moName": "Тоба хот",
      "buName": "တိုဗ မြို့",
      "khName": "ទីក្រុង តូបា ",
      "neName": "तोबा सहर"
    }
  },
  "2421200": {
    "office": {
      "code": "240000",
      "name": "三重県",
      "enName": "Mie",
      "officeName": "津地方気象台",
      "chName": "三重县",
      "zhName": "三重縣",
      "koName": "미에현",
      "esName": "Prefectura de Mie",
      "ptName": "Província de Mie",
      "thName": "จังหวัดมิเอะ",
      "viName": "Tỉnh Mie",
      "inName": "Prefektur Mie",
      "tlName": "Mie Prefecture",
      "moName": "Миэ аймаг",
      "buName": "မီးယဲ့ ပြည်နယ်",
      "khName": "ខេត្ដ មី",
      "neName": "मिए जिल्ला"
    },
    "class10": {
      "code": "240020",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "三重县南部",
      "zhName": "三重縣南部",
      "koName": "미에 현 남부",
      "esName": "Sur de Prefectura de Mie",
      "ptName": "Regiõ sul da Província de Mie",
      "thName": "จังหวัดมิเอะตอนใต้",
      "viName": "Miền Nam tỉnh Mie",
      "inName": "Bagian Selatan Prefektur Mie",
      "tlName": "Timog na bahagi ng Mie Prefecture",
      "moName": "Өмнөд Миэ аймаг",
      "buName": "မိအဲစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដមីអិ",
      "neName": "मिए जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "240022",
      "name": "紀勢・東紀州",
      "enName": "Kisei Higashi-kishu"
    },
    "class20": {
      "code": "2421200",
      "name": "熊野市",
      "enName": "Kumano City",
      "kana": "くまのし",
      "chName": "熊野市",
      "zhName": "熊野市",
      "koName": "구마노 시",
      "esName": "Ciudad de Kumano",
      "ptName": "cidade de Kumano",
      "thName": "เมืองคุมาโนะ",
      "viName": "thành phố Kumano",
      "inName": "kota Kumano",
      "tlName": "siyudad ng Kumano",
      "moName": "Күмaно хот",
      "buName": "ကူမာနို မြို့",
      "khName": "ទីក្រុង គូម៉ាណូ",
      "neName": "कुमानो सहर"
    }
  },
  "2421400": {
    "office": {
      "code": "240000",
      "name": "三重県",
      "enName": "Mie",
      "officeName": "津地方気象台",
      "chName": "三重县",
      "zhName": "三重縣",
      "koName": "미에현",
      "esName": "Prefectura de Mie",
      "ptName": "Província de Mie",
      "thName": "จังหวัดมิเอะ",
      "viName": "Tỉnh Mie",
      "inName": "Prefektur Mie",
      "tlName": "Mie Prefecture",
      "moName": "Миэ аймаг",
      "buName": "မီးယဲ့ ပြည်နယ်",
      "khName": "ខេត្ដ មី",
      "neName": "मिए जिल्ला"
    },
    "class10": {
      "code": "240010",
      "name": "北中部",
      "enName": "Northern Central Region",
      "chName": "三重县北部",
      "zhName": "三重縣北部",
      "koName": "미에 현 북부",
      "esName": "Este de Prefectura de Mie",
      "ptName": "Região norte da Província de Mie",
      "thName": "จังหวัดมิเอะตอนเหนือ",
      "viName": "Miền Bắc tỉnh Mie",
      "inName": "Bagian Utara Prefektur Mie",
      "tlName": "Hilagang bahagi ng Mie Prefecture",
      "moName": "Хойд Миэ аймаг",
      "buName": "မိအဲစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដមីអិ",
      "neName": "मिए जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "240012",
      "name": "北部",
      "enName": "Northern Region"
    },
    "class20": {
      "code": "2421400",
      "name": "いなべ市",
      "enName": "Inabe City",
      "kana": "いなべし",
      "chName": "员辨市",
      "zhName": "員弁市",
      "koName": "이나베 시",
      "esName": "Ciudad de Inabe",
      "ptName": "cidade de Inabe",
      "thName": "เมืองอินาเบะ",
      "viName": "thành phố Inabe",
      "inName": "kota Inabe",
      "tlName": "siyudad ng Inabe",
      "moName": "Инaбэ хот",
      "buName": "အီနားဗဲ့ မြို့",
      "khName": "ទីក្រុង អ៊ីនណាបេ",
      "neName": "इनाबे सहर"
    }
  },
  "2421500": {
    "office": {
      "code": "240000",
      "name": "三重県",
      "enName": "Mie",
      "officeName": "津地方気象台",
      "chName": "三重县",
      "zhName": "三重縣",
      "koName": "미에현",
      "esName": "Prefectura de Mie",
      "ptName": "Província de Mie",
      "thName": "จังหวัดมิเอะ",
      "viName": "Tỉnh Mie",
      "inName": "Prefektur Mie",
      "tlName": "Mie Prefecture",
      "moName": "Миэ аймаг",
      "buName": "မီးယဲ့ ပြည်နယ်",
      "khName": "ខេត្ដ មី",
      "neName": "मिए जिल्ला"
    },
    "class10": {
      "code": "240020",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "三重县南部",
      "zhName": "三重縣南部",
      "koName": "미에 현 남부",
      "esName": "Sur de Prefectura de Mie",
      "ptName": "Regiõ sul da Província de Mie",
      "thName": "จังหวัดมิเอะตอนใต้",
      "viName": "Miền Nam tỉnh Mie",
      "inName": "Bagian Selatan Prefektur Mie",
      "tlName": "Timog na bahagi ng Mie Prefecture",
      "moName": "Өмнөд Миэ аймаг",
      "buName": "မိအဲစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដមីអិ",
      "neName": "मिए जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "240021",
      "name": "伊勢志摩",
      "enName": "Ise Shima"
    },
    "class20": {
      "code": "2421500",
      "name": "志摩市",
      "enName": "Shima City",
      "kana": "しまし",
      "chName": "志摩市",
      "zhName": "志摩市",
      "koName": "시마 시",
      "esName": "Ciudad de Shima",
      "ptName": "cidade de Shima",
      "thName": "เมืองชิมะ",
      "viName": "thành phố Shima",
      "inName": "kota Shima",
      "tlName": "siyudad ng Shima",
      "moName": "Шимa хот",
      "buName": "ရှီးမ မြို့",
      "khName": "ទីក្រុង ស៊ីម៉ា",
      "neName": "शिमा सहर"
    }
  },
  "2421600": {
    "office": {
      "code": "240000",
      "name": "三重県",
      "enName": "Mie",
      "officeName": "津地方気象台",
      "chName": "三重县",
      "zhName": "三重縣",
      "koName": "미에현",
      "esName": "Prefectura de Mie",
      "ptName": "Província de Mie",
      "thName": "จังหวัดมิเอะ",
      "viName": "Tỉnh Mie",
      "inName": "Prefektur Mie",
      "tlName": "Mie Prefecture",
      "moName": "Миэ аймаг",
      "buName": "မီးယဲ့ ပြည်နယ်",
      "khName": "ខេត្ដ មី",
      "neName": "मिए जिल्ला"
    },
    "class10": {
      "code": "240010",
      "name": "北中部",
      "enName": "Northern Central Region",
      "chName": "三重县北部",
      "zhName": "三重縣北部",
      "koName": "미에 현 북부",
      "esName": "Este de Prefectura de Mie",
      "ptName": "Região norte da Província de Mie",
      "thName": "จังหวัดมิเอะตอนเหนือ",
      "viName": "Miền Bắc tỉnh Mie",
      "inName": "Bagian Utara Prefektur Mie",
      "tlName": "Hilagang bahagi ng Mie Prefecture",
      "moName": "Хойд Миэ аймаг",
      "buName": "မိအဲစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដមីអិ",
      "neName": "मिए जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "240013",
      "name": "伊賀",
      "enName": "Iga"
    },
    "class20": {
      "code": "2421600",
      "name": "伊賀市",
      "enName": "Iga City",
      "kana": "いがし",
      "chName": "伊贺市",
      "zhName": "伊賀市",
      "koName": "이가 시",
      "esName": "Ciudad de Iga",
      "ptName": "cidade de Iga",
      "thName": "เมืองอิงะ",
      "viName": "thành phố Iga",
      "inName": "kota Iga",
      "tlName": "siyudad ng Iga",
      "moName": "Игa хот",
      "buName": "အီးဂ မြို့",
      "khName": "ទីក្រុង ស៊ីម៉ា",
      "neName": "इगा सहर"
    }
  },
  "2430300": {
    "office": {
      "code": "240000",
      "name": "三重県",
      "enName": "Mie",
      "officeName": "津地方気象台",
      "chName": "三重县",
      "zhName": "三重縣",
      "koName": "미에현",
      "esName": "Prefectura de Mie",
      "ptName": "Província de Mie",
      "thName": "จังหวัดมิเอะ",
      "viName": "Tỉnh Mie",
      "inName": "Prefektur Mie",
      "tlName": "Mie Prefecture",
      "moName": "Миэ аймаг",
      "buName": "မီးယဲ့ ပြည်နယ်",
      "khName": "ខេត្ដ មី",
      "neName": "मिए जिल्ला"
    },
    "class10": {
      "code": "240010",
      "name": "北中部",
      "enName": "Northern Central Region",
      "chName": "三重县北部",
      "zhName": "三重縣北部",
      "koName": "미에 현 북부",
      "esName": "Este de Prefectura de Mie",
      "ptName": "Região norte da Província de Mie",
      "thName": "จังหวัดมิเอะตอนเหนือ",
      "viName": "Miền Bắc tỉnh Mie",
      "inName": "Bagian Utara Prefektur Mie",
      "tlName": "Hilagang bahagi ng Mie Prefecture",
      "moName": "Хойд Миэ аймаг",
      "buName": "မိအဲစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដមីអិ",
      "neName": "मिए जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "240012",
      "name": "北部",
      "enName": "Northern Region"
    },
    "class20": {
      "code": "2430300",
      "name": "木曽岬町",
      "enName": "Kisosaki Town",
      "kana": "きそさきちょう",
      "chName": "木曾岬町",
      "zhName": "木曾岬町",
      "koName": "기소사키 정",
      "esName": "Pueblo de Kisomisaki",
      "ptName": "bairro de Kisosaki",
      "thName": "เมืองคิโซซากิ",
      "viName": "thị trấn Kisosaki",
      "inName": "kota Kisosaki",
      "tlName": "bayan ng Kisosaki",
      "moName": "Кисосaки жижиг хот",
      "buName": "ခီဆောဆာ့ကိ မြို့နယ်",
      "khName": "ទីប្រជុំជន គីសូសាគី",
      "neName": "कोसोसाकी नगर"
    }
  },
  "2432400": {
    "office": {
      "code": "240000",
      "name": "三重県",
      "enName": "Mie",
      "officeName": "津地方気象台",
      "chName": "三重县",
      "zhName": "三重縣",
      "koName": "미에현",
      "esName": "Prefectura de Mie",
      "ptName": "Província de Mie",
      "thName": "จังหวัดมิเอะ",
      "viName": "Tỉnh Mie",
      "inName": "Prefektur Mie",
      "tlName": "Mie Prefecture",
      "moName": "Миэ аймаг",
      "buName": "မီးယဲ့ ပြည်နယ်",
      "khName": "ខេត្ដ មី",
      "neName": "मिए जिल्ला"
    },
    "class10": {
      "code": "240010",
      "name": "北中部",
      "enName": "Northern Central Region",
      "chName": "三重县北部",
      "zhName": "三重縣北部",
      "koName": "미에 현 북부",
      "esName": "Este de Prefectura de Mie",
      "ptName": "Região norte da Província de Mie",
      "thName": "จังหวัดมิเอะตอนเหนือ",
      "viName": "Miền Bắc tỉnh Mie",
      "inName": "Bagian Utara Prefektur Mie",
      "tlName": "Hilagang bahagi ng Mie Prefecture",
      "moName": "Хойд Миэ аймаг",
      "buName": "မိအဲစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដមីអិ",
      "neName": "मिए जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "240012",
      "name": "北部",
      "enName": "Northern Region"
    },
    "class20": {
      "code": "2432400",
      "name": "東員町",
      "enName": "Toin Town",
      "kana": "とういんちょう",
      "chName": "东员町",
      "zhName": "東員町",
      "koName": "도인 정",
      "esName": "Pueblo de Toin",
      "ptName": "bairro de Toin",
      "thName": "เมืองโทอิน",
      "viName": "thị trấn Toin",
      "inName": "kota Toin",
      "tlName": "bayan ng Toin",
      "moName": "Тойн жижиг хот",
      "buName": "တိုးယင် မြို့နယ်",
      "khName": "ទីប្រជុំជន ថអន",
      "neName": "तोइन नगर"
    }
  },
  "2434100": {
    "office": {
      "code": "240000",
      "name": "三重県",
      "enName": "Mie",
      "officeName": "津地方気象台",
      "chName": "三重县",
      "zhName": "三重縣",
      "koName": "미에현",
      "esName": "Prefectura de Mie",
      "ptName": "Província de Mie",
      "thName": "จังหวัดมิเอะ",
      "viName": "Tỉnh Mie",
      "inName": "Prefektur Mie",
      "tlName": "Mie Prefecture",
      "moName": "Миэ аймаг",
      "buName": "မီးယဲ့ ပြည်နယ်",
      "khName": "ខេត្ដ មី",
      "neName": "मिए जिल्ला"
    },
    "class10": {
      "code": "240010",
      "name": "北中部",
      "enName": "Northern Central Region",
      "chName": "三重县北部",
      "zhName": "三重縣北部",
      "koName": "미에 현 북부",
      "esName": "Este de Prefectura de Mie",
      "ptName": "Região norte da Província de Mie",
      "thName": "จังหวัดมิเอะตอนเหนือ",
      "viName": "Miền Bắc tỉnh Mie",
      "inName": "Bagian Utara Prefektur Mie",
      "tlName": "Hilagang bahagi ng Mie Prefecture",
      "moName": "Хойд Миэ аймаг",
      "buName": "မိအဲစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដមីអិ",
      "neName": "मिए जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "240012",
      "name": "北部",
      "enName": "Northern Region"
    },
    "class20": {
      "code": "2434100",
      "name": "菰野町",
      "enName": "Komono Town",
      "kana": "こものちょう",
      "chName": "菰野町",
      "zhName": "菰野町",
      "koName": "고모노 정",
      "esName": "Pueblo de Komono",
      "ptName": "bairro de Komono",
      "thName": "เมืองโคโมโน",
      "viName": "thị trấn Komono",
      "inName": "kota Komono",
      "tlName": "bayan ng Komono",
      "moName": "Комоно жижиг хот",
      "buName": "ခိုမိုနို မြို့နယ်",
      "khName": "ទីប្រជុំជន កូម៉ូណុ",
      "neName": "कोमोनो नगर"
    }
  },
  "2434300": {
    "office": {
      "code": "240000",
      "name": "三重県",
      "enName": "Mie",
      "officeName": "津地方気象台",
      "chName": "三重县",
      "zhName": "三重縣",
      "koName": "미에현",
      "esName": "Prefectura de Mie",
      "ptName": "Província de Mie",
      "thName": "จังหวัดมิเอะ",
      "viName": "Tỉnh Mie",
      "inName": "Prefektur Mie",
      "tlName": "Mie Prefecture",
      "moName": "Миэ аймаг",
      "buName": "မီးယဲ့ ပြည်နယ်",
      "khName": "ខេត្ដ មី",
      "neName": "मिए जिल्ला"
    },
    "class10": {
      "code": "240010",
      "name": "北中部",
      "enName": "Northern Central Region",
      "chName": "三重县北部",
      "zhName": "三重縣北部",
      "koName": "미에 현 북부",
      "esName": "Este de Prefectura de Mie",
      "ptName": "Região norte da Província de Mie",
      "thName": "จังหวัดมิเอะตอนเหนือ",
      "viName": "Miền Bắc tỉnh Mie",
      "inName": "Bagian Utara Prefektur Mie",
      "tlName": "Hilagang bahagi ng Mie Prefecture",
      "moName": "Хойд Миэ аймаг",
      "buName": "မိအဲစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដមីអិ",
      "neName": "मिए जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "240012",
      "name": "北部",
      "enName": "Northern Region"
    },
    "class20": {
      "code": "2434300",
      "name": "朝日町",
      "enName": "Asahi Town",
      "kana": "あさひちょう",
      "chName": "三重朝日町",
      "zhName": "三重朝日町",
      "koName": "미에 아사이 정",
      "esName": "Pueblo de Asahi, Mie",
      "ptName": "Mie, bairro de Asahi",
      "thName": "เมืองอาซาฮิ มิเอะ",
      "viName": "Thị trấn Asahi, Mie",
      "inName": "Kota Asahi, Mie",
      "tlName": "bayan ng Asahi, Mie",
      "moName": "Миэ Асахи жижиг хот",
      "buName": "မိအဲအဆဟိမြို့နယ်",
      "khName": "ទីប្រជុំជនអាសាហ៊ី មីអិ",
      "neName": "मिए आसाही नगर"
    }
  },
  "2434400": {
    "office": {
      "code": "240000",
      "name": "三重県",
      "enName": "Mie",
      "officeName": "津地方気象台",
      "chName": "三重县",
      "zhName": "三重縣",
      "koName": "미에현",
      "esName": "Prefectura de Mie",
      "ptName": "Província de Mie",
      "thName": "จังหวัดมิเอะ",
      "viName": "Tỉnh Mie",
      "inName": "Prefektur Mie",
      "tlName": "Mie Prefecture",
      "moName": "Миэ аймаг",
      "buName": "မီးယဲ့ ပြည်နယ်",
      "khName": "ខេត្ដ មី",
      "neName": "मिए जिल्ला"
    },
    "class10": {
      "code": "240010",
      "name": "北中部",
      "enName": "Northern Central Region",
      "chName": "三重县北部",
      "zhName": "三重縣北部",
      "koName": "미에 현 북부",
      "esName": "Este de Prefectura de Mie",
      "ptName": "Região norte da Província de Mie",
      "thName": "จังหวัดมิเอะตอนเหนือ",
      "viName": "Miền Bắc tỉnh Mie",
      "inName": "Bagian Utara Prefektur Mie",
      "tlName": "Hilagang bahagi ng Mie Prefecture",
      "moName": "Хойд Миэ аймаг",
      "buName": "မိအဲစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដមីអិ",
      "neName": "मिए जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "240012",
      "name": "北部",
      "enName": "Northern Region"
    },
    "class20": {
      "code": "2434400",
      "name": "川越町",
      "enName": "Kawagoe Town",
      "kana": "かわごえちょう",
      "chName": "川越町",
      "zhName": "川越町",
      "koName": "가와고에 정",
      "esName": "Pueblo de Kawagoe",
      "ptName": "bairro de Kawagoe",
      "thName": "เมืองคาวาโกเอะ",
      "viName": "thị trấn Kawagoe",
      "inName": "kota Kawagoe",
      "tlName": "bayan ng Kawagoe",
      "moName": "Кавагоэ жижиг хот",
      "buName": "ခါဝါဂေါ့အဲ့ မြို့နယ်",
      "khName": "ទីប្រជុំជន កាវ៉ាហ្គោ",
      "neName": "कावागोइ नगर"
    }
  },
  "2444100": {
    "office": {
      "code": "240000",
      "name": "三重県",
      "enName": "Mie",
      "officeName": "津地方気象台",
      "chName": "三重县",
      "zhName": "三重縣",
      "koName": "미에현",
      "esName": "Prefectura de Mie",
      "ptName": "Província de Mie",
      "thName": "จังหวัดมิเอะ",
      "viName": "Tỉnh Mie",
      "inName": "Prefektur Mie",
      "tlName": "Mie Prefecture",
      "moName": "Миэ аймаг",
      "buName": "မီးယဲ့ ပြည်နယ်",
      "khName": "ខេត្ដ មី",
      "neName": "मिए जिल्ला"
    },
    "class10": {
      "code": "240010",
      "name": "北中部",
      "enName": "Northern Central Region",
      "chName": "三重县北部",
      "zhName": "三重縣北部",
      "koName": "미에 현 북부",
      "esName": "Este de Prefectura de Mie",
      "ptName": "Região norte da Província de Mie",
      "thName": "จังหวัดมิเอะตอนเหนือ",
      "viName": "Miền Bắc tỉnh Mie",
      "inName": "Bagian Utara Prefektur Mie",
      "tlName": "Hilagang bahagi ng Mie Prefecture",
      "moName": "Хойд Миэ аймаг",
      "buName": "မိအဲစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដមីអិ",
      "neName": "मिए जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "240011",
      "name": "中部",
      "enName": "Central Region"
    },
    "class20": {
      "code": "2444100",
      "name": "多気町",
      "enName": "Taki Town",
      "kana": "たきちょう",
      "chName": "多气町",
      "zhName": "多氣町",
      "koName": "다키 정",
      "esName": "Pueblo de Taki",
      "ptName": "bairro de Taki",
      "thName": "เมืองทากิ",
      "viName": "thị trấn Taki",
      "inName": "kota Taki",
      "tlName": "bayan ng Taki",
      "moName": "Таки жижиг хот",
      "buName": "တာကိ မြို့နယ်",
      "khName": "ទីប្រជុំជន តាគី",
      "neName": "ताकी नगर"
    }
  },
  "2444200": {
    "office": {
      "code": "240000",
      "name": "三重県",
      "enName": "Mie",
      "officeName": "津地方気象台",
      "chName": "三重县",
      "zhName": "三重縣",
      "koName": "미에현",
      "esName": "Prefectura de Mie",
      "ptName": "Província de Mie",
      "thName": "จังหวัดมิเอะ",
      "viName": "Tỉnh Mie",
      "inName": "Prefektur Mie",
      "tlName": "Mie Prefecture",
      "moName": "Миэ аймаг",
      "buName": "မီးယဲ့ ပြည်နယ်",
      "khName": "ខេត្ដ មី",
      "neName": "मिए जिल्ला"
    },
    "class10": {
      "code": "240010",
      "name": "北中部",
      "enName": "Northern Central Region",
      "chName": "三重县北部",
      "zhName": "三重縣北部",
      "koName": "미에 현 북부",
      "esName": "Este de Prefectura de Mie",
      "ptName": "Região norte da Província de Mie",
      "thName": "จังหวัดมิเอะตอนเหนือ",
      "viName": "Miền Bắc tỉnh Mie",
      "inName": "Bagian Utara Prefektur Mie",
      "tlName": "Hilagang bahagi ng Mie Prefecture",
      "moName": "Хойд Миэ аймаг",
      "buName": "မိအဲစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដមីអិ",
      "neName": "मिए जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "240011",
      "name": "中部",
      "enName": "Central Region"
    },
    "class20": {
      "code": "2444200",
      "name": "明和町",
      "enName": "Meiwa Town",
      "kana": "めいわちょう",
      "chName": "三重明和町",
      "zhName": "三重明和町",
      "koName": "미에 메이와 정",
      "esName": "Pueblo de Meiwa, Mie",
      "ptName": "Mie, bairro de Meiwa",
      "thName": "เมืองเมอิวะ มิเอะ",
      "viName": "Thị trấn Meiwa, Mie",
      "inName": "Kota Meiwa, Mie",
      "tlName": "bayan ng Meiwa, Mie",
      "moName": "Миэ Мэйва жижиг хот",
      "buName": "မိအဲမဲမြို့နယ်",
      "khName": "ទីប្រជុំជនម៉ីវ៉ា មីអិ",
      "neName": "मिए मेइवा नगर"
    }
  },
  "2444300": {
    "office": {
      "code": "240000",
      "name": "三重県",
      "enName": "Mie",
      "officeName": "津地方気象台",
      "chName": "三重县",
      "zhName": "三重縣",
      "koName": "미에현",
      "esName": "Prefectura de Mie",
      "ptName": "Província de Mie",
      "thName": "จังหวัดมิเอะ",
      "viName": "Tỉnh Mie",
      "inName": "Prefektur Mie",
      "tlName": "Mie Prefecture",
      "moName": "Миэ аймаг",
      "buName": "မီးယဲ့ ပြည်နယ်",
      "khName": "ខេត្ដ មី",
      "neName": "मिए जिल्ला"
    },
    "class10": {
      "code": "240020",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "三重县南部",
      "zhName": "三重縣南部",
      "koName": "미에 현 남부",
      "esName": "Sur de Prefectura de Mie",
      "ptName": "Regiõ sul da Província de Mie",
      "thName": "จังหวัดมิเอะตอนใต้",
      "viName": "Miền Nam tỉnh Mie",
      "inName": "Bagian Selatan Prefektur Mie",
      "tlName": "Timog na bahagi ng Mie Prefecture",
      "moName": "Өмнөд Миэ аймаг",
      "buName": "မိအဲစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដមីអិ",
      "neName": "मिए जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "240022",
      "name": "紀勢・東紀州",
      "enName": "Kisei Higashi-kishu"
    },
    "class20": {
      "code": "2444300",
      "name": "大台町",
      "enName": "Odai Town",
      "kana": "おおだいちょう",
      "chName": "大台町",
      "zhName": "大台町",
      "koName": "오다이 정",
      "esName": "Pueblo de Ōdai",
      "ptName": "bairro de Odai",
      "thName": "เมืองโอได",
      "viName": "thị trấn Odai",
      "inName": "kota Odai",
      "tlName": "bayan ng Odai",
      "moName": "Одай жижиг хот",
      "buName": "အို့ဒါယိ မြို့နယ်",
      "khName": "ទីប្រជុំជន អូដាយ",
      "neName": "ओडाई नगर"
    }
  },
  "2446100": {
    "office": {
      "code": "240000",
      "name": "三重県",
      "enName": "Mie",
      "officeName": "津地方気象台",
      "chName": "三重县",
      "zhName": "三重縣",
      "koName": "미에현",
      "esName": "Prefectura de Mie",
      "ptName": "Província de Mie",
      "thName": "จังหวัดมิเอะ",
      "viName": "Tỉnh Mie",
      "inName": "Prefektur Mie",
      "tlName": "Mie Prefecture",
      "moName": "Миэ аймаг",
      "buName": "မီးယဲ့ ပြည်နယ်",
      "khName": "ខេត្ដ មី",
      "neName": "मिए जिल्ला"
    },
    "class10": {
      "code": "240020",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "三重县南部",
      "zhName": "三重縣南部",
      "koName": "미에 현 남부",
      "esName": "Sur de Prefectura de Mie",
      "ptName": "Regiõ sul da Província de Mie",
      "thName": "จังหวัดมิเอะตอนใต้",
      "viName": "Miền Nam tỉnh Mie",
      "inName": "Bagian Selatan Prefektur Mie",
      "tlName": "Timog na bahagi ng Mie Prefecture",
      "moName": "Өмнөд Миэ аймаг",
      "buName": "မိအဲစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដមីអិ",
      "neName": "मिए जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "240021",
      "name": "伊勢志摩",
      "enName": "Ise Shima"
    },
    "class20": {
      "code": "2446100",
      "name": "玉城町",
      "enName": "Tamaki Town",
      "kana": "たまきちょう",
      "chName": "玉城町",
      "zhName": "玉城町",
      "koName": "다마키 정",
      "esName": "Pueblo de Tamaki",
      "ptName": "bairro de Tamaki",
      "thName": "เมืองทามากิ",
      "viName": "thị trấn Tamaki",
      "inName": "kota Tamaki",
      "tlName": "bayan ng Tamaki",
      "moName": "Тамaки жижиг хот",
      "buName": "တာမာ့ကိ မြို့နယ်",
      "khName": "ទីប្រជុំជន តាម៉ាគិ",
      "neName": "तामाकी नगर"
    }
  },
  "2447000": {
    "office": {
      "code": "240000",
      "name": "三重県",
      "enName": "Mie",
      "officeName": "津地方気象台",
      "chName": "三重县",
      "zhName": "三重縣",
      "koName": "미에현",
      "esName": "Prefectura de Mie",
      "ptName": "Província de Mie",
      "thName": "จังหวัดมิเอะ",
      "viName": "Tỉnh Mie",
      "inName": "Prefektur Mie",
      "tlName": "Mie Prefecture",
      "moName": "Миэ аймаг",
      "buName": "မီးယဲ့ ပြည်နယ်",
      "khName": "ខេត្ដ មី",
      "neName": "मिए जिल्ला"
    },
    "class10": {
      "code": "240020",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "三重县南部",
      "zhName": "三重縣南部",
      "koName": "미에 현 남부",
      "esName": "Sur de Prefectura de Mie",
      "ptName": "Regiõ sul da Província de Mie",
      "thName": "จังหวัดมิเอะตอนใต้",
      "viName": "Miền Nam tỉnh Mie",
      "inName": "Bagian Selatan Prefektur Mie",
      "tlName": "Timog na bahagi ng Mie Prefecture",
      "moName": "Өмнөд Миэ аймаг",
      "buName": "မိအဲစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដមីអិ",
      "neName": "मिए जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "240021",
      "name": "伊勢志摩",
      "enName": "Ise Shima"
    },
    "class20": {
      "code": "2447000",
      "name": "度会町",
      "enName": "Watarai Town",
      "kana": "わたらいちょう",
      "chName": "度会町",
      "zhName": "度會町",
      "koName": "와타라이 정",
      "esName": "Pueblo de Watarai",
      "ptName": "bairro de Watarai",
      "thName": "เมืองวาตาราอิ",
      "viName": "thị trấn Watarai",
      "inName": "kota Watarai",
      "tlName": "bayan ng Watarai",
      "moName": "Ватарай жижиг хот",
      "buName": "ဝါတားရာ့ယိ မြို့နယ်",
      "khName": "ទីប្រជុំជន វ៉ាតារ៉ាយ",
      "neName": "वाताराई नगर"
    }
  },
  "2447100": {
    "office": {
      "code": "240000",
      "name": "三重県",
      "enName": "Mie",
      "officeName": "津地方気象台",
      "chName": "三重县",
      "zhName": "三重縣",
      "koName": "미에현",
      "esName": "Prefectura de Mie",
      "ptName": "Província de Mie",
      "thName": "จังหวัดมิเอะ",
      "viName": "Tỉnh Mie",
      "inName": "Prefektur Mie",
      "tlName": "Mie Prefecture",
      "moName": "Миэ аймаг",
      "buName": "မီးယဲ့ ပြည်နယ်",
      "khName": "ខេត្ដ មី",
      "neName": "मिए जिल्ला"
    },
    "class10": {
      "code": "240020",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "三重县南部",
      "zhName": "三重縣南部",
      "koName": "미에 현 남부",
      "esName": "Sur de Prefectura de Mie",
      "ptName": "Regiõ sul da Província de Mie",
      "thName": "จังหวัดมิเอะตอนใต้",
      "viName": "Miền Nam tỉnh Mie",
      "inName": "Bagian Selatan Prefektur Mie",
      "tlName": "Timog na bahagi ng Mie Prefecture",
      "moName": "Өмнөд Миэ аймаг",
      "buName": "မိအဲစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដមីអិ",
      "neName": "मिए जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "240022",
      "name": "紀勢・東紀州",
      "enName": "Kisei Higashi-kishu"
    },
    "class20": {
      "code": "2447100",
      "name": "大紀町",
      "enName": "Taiki Town",
      "kana": "たいきちょう",
      "chName": "三重大纪町",
      "zhName": "三重大紀町",
      "koName": "미에 다이키 정",
      "esName": "Pueblo de Taiki, Mie",
      "ptName": "Mie, bairro de Taiki",
      "thName": "เมืองไทกิ มิเอะ",
      "viName": "Thị trấn Taiki, Mie",
      "inName": "Kota Taiki, Mie",
      "tlName": "bayan ng Taiki, Mie",
      "moName": "Миэ  Тайки жижиг хот",
      "buName": "မိအဲတိုင်းခိမြို့နယ်",
      "khName": "ទីប្រជុំជនតៃគី មីអិ",
      "neName": "मिए ताइकी नगर"
    }
  },
  "2447200": {
    "office": {
      "code": "240000",
      "name": "三重県",
      "enName": "Mie",
      "officeName": "津地方気象台",
      "chName": "三重县",
      "zhName": "三重縣",
      "koName": "미에현",
      "esName": "Prefectura de Mie",
      "ptName": "Província de Mie",
      "thName": "จังหวัดมิเอะ",
      "viName": "Tỉnh Mie",
      "inName": "Prefektur Mie",
      "tlName": "Mie Prefecture",
      "moName": "Миэ аймаг",
      "buName": "မီးယဲ့ ပြည်နယ်",
      "khName": "ខេត្ដ មី",
      "neName": "मिए जिल्ला"
    },
    "class10": {
      "code": "240020",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "三重县南部",
      "zhName": "三重縣南部",
      "koName": "미에 현 남부",
      "esName": "Sur de Prefectura de Mie",
      "ptName": "Regiõ sul da Província de Mie",
      "thName": "จังหวัดมิเอะตอนใต้",
      "viName": "Miền Nam tỉnh Mie",
      "inName": "Bagian Selatan Prefektur Mie",
      "tlName": "Timog na bahagi ng Mie Prefecture",
      "moName": "Өмнөд Миэ аймаг",
      "buName": "မိအဲစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដមីអិ",
      "neName": "मिए जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "240021",
      "name": "伊勢志摩",
      "enName": "Ise Shima"
    },
    "class20": {
      "code": "2447200",
      "name": "南伊勢町",
      "enName": "Minamiise Town",
      "kana": "みなみいせちょう",
      "chName": "南伊势町",
      "zhName": "南伊勢町",
      "koName": "미나미이세 정",
      "esName": "Pueblo de Minami-Ise",
      "ptName": "bairro de Minamiise",
      "thName": "เมืองมานามิอิเสะ",
      "viName": "thị trấn Minamiise",
      "inName": "kota Minamiise",
      "tlName": "bayan ng Minamiise",
      "moName": "Минaмийсэ жижиг хот",
      "buName": "မီနာမီးဆဲ့ မြို့နယ်",
      "khName": "ទីប្រជុំជន មីណាមីសេ",
      "neName": "मिनामीइसे नगर "
    }
  },
  "2454300": {
    "office": {
      "code": "240000",
      "name": "三重県",
      "enName": "Mie",
      "officeName": "津地方気象台",
      "chName": "三重县",
      "zhName": "三重縣",
      "koName": "미에현",
      "esName": "Prefectura de Mie",
      "ptName": "Província de Mie",
      "thName": "จังหวัดมิเอะ",
      "viName": "Tỉnh Mie",
      "inName": "Prefektur Mie",
      "tlName": "Mie Prefecture",
      "moName": "Миэ аймаг",
      "buName": "မီးယဲ့ ပြည်နယ်",
      "khName": "ខេត្ដ មី",
      "neName": "मिए जिल्ला"
    },
    "class10": {
      "code": "240020",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "三重县南部",
      "zhName": "三重縣南部",
      "koName": "미에 현 남부",
      "esName": "Sur de Prefectura de Mie",
      "ptName": "Regiõ sul da Província de Mie",
      "thName": "จังหวัดมิเอะตอนใต้",
      "viName": "Miền Nam tỉnh Mie",
      "inName": "Bagian Selatan Prefektur Mie",
      "tlName": "Timog na bahagi ng Mie Prefecture",
      "moName": "Өмнөд Миэ аймаг",
      "buName": "မိအဲစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដមីអិ",
      "neName": "मिए जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "240022",
      "name": "紀勢・東紀州",
      "enName": "Kisei Higashi-kishu"
    },
    "class20": {
      "code": "2454300",
      "name": "紀北町",
      "enName": "Kihoku Town",
      "kana": "きほくちょう",
      "chName": "三重纪北町",
      "zhName": "三重紀北町",
      "koName": "미에 기호쿠 정",
      "esName": "Pueblo de Kihoku, Mie",
      "ptName": "Mie, bairro de Kihoku",
      "thName": "เมืองคิโฮขุ มิเอะ",
      "viName": "Thị trấn Kihoku, Mie",
      "inName": "Kota Kihoku, Mie",
      "tlName": "bayan ng Kihoku, Mie",
      "moName": "Миэ Кихокү жижиг хот",
      "buName": "မိအဲခိဟိုခုမြို့နယ်",
      "khName": "ទីប្រជុំជនគីហុគូ មីអិ",
      "neName": "मिए किहोकु नगर "
    }
  },
  "2456100": {
    "office": {
      "code": "240000",
      "name": "三重県",
      "enName": "Mie",
      "officeName": "津地方気象台",
      "chName": "三重县",
      "zhName": "三重縣",
      "koName": "미에현",
      "esName": "Prefectura de Mie",
      "ptName": "Província de Mie",
      "thName": "จังหวัดมิเอะ",
      "viName": "Tỉnh Mie",
      "inName": "Prefektur Mie",
      "tlName": "Mie Prefecture",
      "moName": "Миэ аймаг",
      "buName": "မီးယဲ့ ပြည်နယ်",
      "khName": "ខេត្ដ មី",
      "neName": "मिए जिल्ला"
    },
    "class10": {
      "code": "240020",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "三重县南部",
      "zhName": "三重縣南部",
      "koName": "미에 현 남부",
      "esName": "Sur de Prefectura de Mie",
      "ptName": "Regiõ sul da Província de Mie",
      "thName": "จังหวัดมิเอะตอนใต้",
      "viName": "Miền Nam tỉnh Mie",
      "inName": "Bagian Selatan Prefektur Mie",
      "tlName": "Timog na bahagi ng Mie Prefecture",
      "moName": "Өмнөд Миэ аймаг",
      "buName": "မိအဲစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដមីអិ",
      "neName": "मिए जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "240022",
      "name": "紀勢・東紀州",
      "enName": "Kisei Higashi-kishu"
    },
    "class20": {
      "code": "2456100",
      "name": "御浜町",
      "enName": "Mihama Town",
      "kana": "みはまちょう",
      "chName": "三重御浜町",
      "zhName": "三重禦浜町",
      "koName": "미에 미하마 정",
      "esName": "Pueblo de Mihama, Mie",
      "ptName": "Mie, bairro de Mihama",
      "thName": "เมืองมิฮามะ มิเอะ",
      "viName": "Thị trấn Mihama, Mie",
      "inName": "Kota Mihama, Mie",
      "tlName": "bayan ng Mihama, Mie",
      "moName": "Миэ Михама жижиг хот",
      "buName": "မိအဲမိဟမိမြို့နယ်",
      "khName": "ទីប្រជុំជន​មីហាម៉ា មីអិ",
      "neName": "मिए मिहामा नगर"
    }
  },
  "2456200": {
    "office": {
      "code": "240000",
      "name": "三重県",
      "enName": "Mie",
      "officeName": "津地方気象台",
      "chName": "三重县",
      "zhName": "三重縣",
      "koName": "미에현",
      "esName": "Prefectura de Mie",
      "ptName": "Província de Mie",
      "thName": "จังหวัดมิเอะ",
      "viName": "Tỉnh Mie",
      "inName": "Prefektur Mie",
      "tlName": "Mie Prefecture",
      "moName": "Миэ аймаг",
      "buName": "မီးယဲ့ ပြည်နယ်",
      "khName": "ខេត្ដ មី",
      "neName": "मिए जिल्ला"
    },
    "class10": {
      "code": "240020",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "三重县南部",
      "zhName": "三重縣南部",
      "koName": "미에 현 남부",
      "esName": "Sur de Prefectura de Mie",
      "ptName": "Regiõ sul da Província de Mie",
      "thName": "จังหวัดมิเอะตอนใต้",
      "viName": "Miền Nam tỉnh Mie",
      "inName": "Bagian Selatan Prefektur Mie",
      "tlName": "Timog na bahagi ng Mie Prefecture",
      "moName": "Өмнөд Миэ аймаг",
      "buName": "မိအဲစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដមីអិ",
      "neName": "मिए जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "240022",
      "name": "紀勢・東紀州",
      "enName": "Kisei Higashi-kishu"
    },
    "class20": {
      "code": "2456200",
      "name": "紀宝町",
      "enName": "Kiho Town",
      "kana": "きほうちょう",
      "chName": "纪宝町",
      "zhName": "紀寶町",
      "koName": "기호 정",
      "esName": "Pueblo de Kihō",
      "ptName": "bairro de Kiho",
      "thName": "เมืองคิโฮะ",
      "viName": "thị trấn Kiho",
      "inName": "kota Kiho",
      "tlName": "bayan ng Kiho",
      "moName": "Кихо жижиг хот",
      "buName": "ကျီဟို မြို့နယ်",
      "khName": "ទីប្រជុំជន គីហូ",
      "neName": "किहो नगर "
    }
  },
  "2520101": {
    "office": {
      "code": "250000",
      "name": "滋賀県",
      "enName": "Shiga",
      "officeName": "彦根地方気象台",
      "chName": "滋贺县",
      "zhName": "滋賀縣",
      "koName": "시가현",
      "esName": "Prefectura de Shiga",
      "ptName": "Província de Shiga",
      "thName": "จังหวัดชิงะ",
      "viName": "Tỉnh Shiga",
      "inName": "Prefektur Shiga",
      "tlName": "Shiga Prefecture",
      "moName": "Шига аймаг",
      "buName": "ရှီးဂ ပြည်နယ်",
      "khName": "ខេត្ដ ស៊ីហ្គា",
      "neName": "सिगा जिल्ला"
    },
    "class10": {
      "code": "250010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "滋贺县南部",
      "zhName": "滋賀縣南部",
      "koName": "시가 현 남부",
      "esName": "Sur de Prefectura de Shiga",
      "ptName": "Sul da Província de Shiga",
      "thName": "จังหวัดชิงะตอนใต้",
      "viName": "Miền Nam tỉnh Shiga",
      "inName": "Bagian Selatan Prefektur Shiga",
      "tlName": "Timog na bahagi ng Shiga Prefecture",
      "moName": "Өмнөд Шига аймаг",
      "buName": "ရှိဂစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដស៊ីហ្គា",
      "neName": "सिगा जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "250011",
      "name": "近江南部",
      "enName": "Southern Omi Region"
    },
    "class20": {
      "code": "2520101",
      "name": "大津市南部",
      "enName": "Southern Otsu City",
      "kana": "おおつしなんぶ",
      "chName": "大津市",
      "zhName": "大津市",
      "koName": "오쓰시",
      "esName": "Ciudad de Otsu",
      "ptName": "Cidade de Otsu",
      "thName": "เมืองโอสึ",
      "viName": "Thành phố Otsu",
      "inName": "Kota Otsu",
      "tlName": "Lungsod ng Otsu",
      "moName": "Cidade de Otsu",
      "buName": "အိုတုပျိုမြို့",
      "khName": "ខេត្តអូសូ",
      "neName": "ओत्सु शहर"
    }
  },
  "2520102": {
    "office": {
      "code": "250000",
      "name": "滋賀県",
      "enName": "Shiga",
      "officeName": "彦根地方気象台",
      "chName": "滋贺县",
      "zhName": "滋賀縣",
      "koName": "시가현",
      "esName": "Prefectura de Shiga",
      "ptName": "Província de Shiga",
      "thName": "จังหวัดชิงะ",
      "viName": "Tỉnh Shiga",
      "inName": "Prefektur Shiga",
      "tlName": "Shiga Prefecture",
      "moName": "Шига аймаг",
      "buName": "ရှီးဂ ပြည်နယ်",
      "khName": "ខេត្ដ ស៊ីហ្គា",
      "neName": "सिगा जिल्ला"
    },
    "class10": {
      "code": "250020",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "滋贺县北部",
      "zhName": "滋賀縣北部",
      "koName": "시가 현 북부",
      "esName": "Norte de Prefectura de Shiga",
      "ptName": "Norte da Província de Shiga",
      "thName": "จังหวัดชิงะตอนเหนือ",
      "viName": "Miền Bắc tỉnh Shiga",
      "inName": "Bagian Utara Prefektur Shiga",
      "tlName": "Hilagang bahagi ng Shiga Prefecture",
      "moName": "Хойд Шига аймаг",
      "buName": "ရှိဂစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដស៊ីហ្គា",
      "neName": "सिगा जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "250021",
      "name": "近江西部",
      "enName": "Western Omi"
    },
    "class20": {
      "code": "2520102",
      "name": "大津市北部",
      "enName": "Northern Otsu City",
      "kana": "おおつしほくぶ",
      "chName": "大津市",
      "zhName": "大津市",
      "koName": "오쓰시",
      "esName": "Ciudad de Otsu",
      "ptName": "Cidade de Otsu",
      "thName": "เมืองโอสึ",
      "viName": "Thành phố Otsu",
      "inName": "Kota Otsu",
      "tlName": "Lungsod ng Otsu",
      "moName": "Cidade de Otsu",
      "buName": "အိုတုပျိုမြို့",
      "khName": "ខេត្តអូសូ",
      "neName": "ओत्सु शहर"
    }
  },
  "2520200": {
    "office": {
      "code": "250000",
      "name": "滋賀県",
      "enName": "Shiga",
      "officeName": "彦根地方気象台",
      "chName": "滋贺县",
      "zhName": "滋賀縣",
      "koName": "시가현",
      "esName": "Prefectura de Shiga",
      "ptName": "Província de Shiga",
      "thName": "จังหวัดชิงะ",
      "viName": "Tỉnh Shiga",
      "inName": "Prefektur Shiga",
      "tlName": "Shiga Prefecture",
      "moName": "Шига аймаг",
      "buName": "ရှီးဂ ပြည်နယ်",
      "khName": "ខេត្ដ ស៊ីហ្គា",
      "neName": "सिगा जिल्ला"
    },
    "class10": {
      "code": "250020",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "滋贺县北部",
      "zhName": "滋賀縣北部",
      "koName": "시가 현 북부",
      "esName": "Norte de Prefectura de Shiga",
      "ptName": "Norte da Província de Shiga",
      "thName": "จังหวัดชิงะตอนเหนือ",
      "viName": "Miền Bắc tỉnh Shiga",
      "inName": "Bagian Utara Prefektur Shiga",
      "tlName": "Hilagang bahagi ng Shiga Prefecture",
      "moName": "Хойд Шига аймаг",
      "buName": "ရှိဂစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដស៊ីហ្គា",
      "neName": "सिगा जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "250023",
      "name": "湖東",
      "enName": "Koto"
    },
    "class20": {
      "code": "2520200",
      "name": "彦根市",
      "enName": "Hikone City",
      "kana": "ひこねし",
      "chName": "彦根市",
      "zhName": "彥根市",
      "koName": "히코네 시",
      "esName": "Ciudad de Hikone",
      "ptName": "cidade de Hikone",
      "thName": "เมืองฮิโกเนะ",
      "viName": "thành phố Hikone",
      "inName": "kota Hikone",
      "tlName": "siyudad ng Hikone",
      "moName": "Хиконэ хот",
      "buName": "ဟီကိုးနဲ့ မြို့",
      "khName": "ទីក្រុង ហ៊ីកកូន",
      "neName": "हिकोने सहर"
    }
  },
  "2520300": {
    "office": {
      "code": "250000",
      "name": "滋賀県",
      "enName": "Shiga",
      "officeName": "彦根地方気象台",
      "chName": "滋贺县",
      "zhName": "滋賀縣",
      "koName": "시가현",
      "esName": "Prefectura de Shiga",
      "ptName": "Província de Shiga",
      "thName": "จังหวัดชิงะ",
      "viName": "Tỉnh Shiga",
      "inName": "Prefektur Shiga",
      "tlName": "Shiga Prefecture",
      "moName": "Шига аймаг",
      "buName": "ရှီးဂ ပြည်နယ်",
      "khName": "ខេត្ដ ស៊ីហ្គា",
      "neName": "सिगा जिल्ला"
    },
    "class10": {
      "code": "250020",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "滋贺县北部",
      "zhName": "滋賀縣北部",
      "koName": "시가 현 북부",
      "esName": "Norte de Prefectura de Shiga",
      "ptName": "Norte da Província de Shiga",
      "thName": "จังหวัดชิงะตอนเหนือ",
      "viName": "Miền Bắc tỉnh Shiga",
      "inName": "Bagian Utara Prefektur Shiga",
      "tlName": "Hilagang bahagi ng Shiga Prefecture",
      "moName": "Хойд Шига аймаг",
      "buName": "ရှိဂစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដស៊ីហ្គា",
      "neName": "सिगा जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "250022",
      "name": "湖北",
      "enName": "Kohoku"
    },
    "class20": {
      "code": "2520300",
      "name": "長浜市",
      "enName": "Nagahama City",
      "kana": "ながはまし",
      "chName": "长滨市",
      "zhName": "長濱市",
      "koName": "나가하마 시",
      "esName": "Ciudad de Nagahama",
      "ptName": "cidade de Nagahama",
      "thName": "เมืองนากาฮามะ",
      "viName": "thành phố Nagahama",
      "inName": "kota Nagahama",
      "tlName": "siyudad ng Nagahama",
      "moName": "Нагахама хот",
      "buName": "နာဂါဟာ့မ မြို့",
      "khName": "ទីក្រុង ណាហ្គាហាម៉ា",
      "neName": "नागाहामा सहर"
    }
  },
  "2520400": {
    "office": {
      "code": "250000",
      "name": "滋賀県",
      "enName": "Shiga",
      "officeName": "彦根地方気象台",
      "chName": "滋贺县",
      "zhName": "滋賀縣",
      "koName": "시가현",
      "esName": "Prefectura de Shiga",
      "ptName": "Província de Shiga",
      "thName": "จังหวัดชิงะ",
      "viName": "Tỉnh Shiga",
      "inName": "Prefektur Shiga",
      "tlName": "Shiga Prefecture",
      "moName": "Шига аймаг",
      "buName": "ရှီးဂ ပြည်နယ်",
      "khName": "ខេត្ដ ស៊ីហ្គា",
      "neName": "सिगा जिल्ला"
    },
    "class10": {
      "code": "250010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "滋贺县南部",
      "zhName": "滋賀縣南部",
      "koName": "시가 현 남부",
      "esName": "Sur de Prefectura de Shiga",
      "ptName": "Sul da Província de Shiga",
      "thName": "จังหวัดชิงะตอนใต้",
      "viName": "Miền Nam tỉnh Shiga",
      "inName": "Bagian Selatan Prefektur Shiga",
      "tlName": "Timog na bahagi ng Shiga Prefecture",
      "moName": "Өмнөд Шига аймаг",
      "buName": "ရှိဂစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដស៊ីហ្គា",
      "neName": "सिगा जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "250012",
      "name": "東近江",
      "enName": "Higashi-omi"
    },
    "class20": {
      "code": "2520400",
      "name": "近江八幡市",
      "enName": "Omihachiman City",
      "kana": "おうみはちまんし",
      "chName": "近江八幡市",
      "zhName": "近江八幡市",
      "koName": "오미하치만 시",
      "esName": "Ciudad de Ohmihachiman",
      "ptName": "cidade de Omihachiman",
      "thName": "เมืองโอมิฮาจิมัน",
      "viName": "thành phố Omihachiman",
      "inName": "kota Omihachiman",
      "tlName": "siyudad ng Omihachiman",
      "moName": "Омихaчимaн хот",
      "buName": "အိုမီဟာ့ကျိမန် မြို့",
      "khName": "ទីក្រុង អូមីហាជីម៉ាន",
      "neName": "ओमिहाचिमान सहर"
    }
  },
  "2520600": {
    "office": {
      "code": "250000",
      "name": "滋賀県",
      "enName": "Shiga",
      "officeName": "彦根地方気象台",
      "chName": "滋贺县",
      "zhName": "滋賀縣",
      "koName": "시가현",
      "esName": "Prefectura de Shiga",
      "ptName": "Província de Shiga",
      "thName": "จังหวัดชิงะ",
      "viName": "Tỉnh Shiga",
      "inName": "Prefektur Shiga",
      "tlName": "Shiga Prefecture",
      "moName": "Шига аймаг",
      "buName": "ရှီးဂ ပြည်နယ်",
      "khName": "ខេត្ដ ស៊ីហ្គា",
      "neName": "सिगा जिल्ला"
    },
    "class10": {
      "code": "250010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "滋贺县南部",
      "zhName": "滋賀縣南部",
      "koName": "시가 현 남부",
      "esName": "Sur de Prefectura de Shiga",
      "ptName": "Sul da Província de Shiga",
      "thName": "จังหวัดชิงะตอนใต้",
      "viName": "Miền Nam tỉnh Shiga",
      "inName": "Bagian Selatan Prefektur Shiga",
      "tlName": "Timog na bahagi ng Shiga Prefecture",
      "moName": "Өмнөд Шига аймаг",
      "buName": "ရှိဂစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដស៊ីហ្គា",
      "neName": "सिगा जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "250011",
      "name": "近江南部",
      "enName": "Southern Omi Region"
    },
    "class20": {
      "code": "2520600",
      "name": "草津市",
      "enName": "Kusatsu City",
      "kana": "くさつし",
      "chName": "草津市",
      "zhName": "草津市",
      "koName": "구사쓰 시",
      "esName": "Ciudad de Kusatsu",
      "ptName": "cidade de Kusatsu",
      "thName": "เมืองคุซาสึ",
      "viName": "thành phố Kusatsu",
      "inName": "kota Kusatsu",
      "tlName": "siyudad ng Kusatsu",
      "moName": "Күсaцү хот",
      "buName": "ခူဆက်ဆု မြို့",
      "khName": "ទីក្រុង គូសាតស៊ូ",
      "neName": "कुसात्सु सहर"
    }
  },
  "2520700": {
    "office": {
      "code": "250000",
      "name": "滋賀県",
      "enName": "Shiga",
      "officeName": "彦根地方気象台",
      "chName": "滋贺县",
      "zhName": "滋賀縣",
      "koName": "시가현",
      "esName": "Prefectura de Shiga",
      "ptName": "Província de Shiga",
      "thName": "จังหวัดชิงะ",
      "viName": "Tỉnh Shiga",
      "inName": "Prefektur Shiga",
      "tlName": "Shiga Prefecture",
      "moName": "Шига аймаг",
      "buName": "ရှီးဂ ပြည်နယ်",
      "khName": "ខេត្ដ ស៊ីហ្គា",
      "neName": "सिगा जिल्ला"
    },
    "class10": {
      "code": "250010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "滋贺县南部",
      "zhName": "滋賀縣南部",
      "koName": "시가 현 남부",
      "esName": "Sur de Prefectura de Shiga",
      "ptName": "Sul da Província de Shiga",
      "thName": "จังหวัดชิงะตอนใต้",
      "viName": "Miền Nam tỉnh Shiga",
      "inName": "Bagian Selatan Prefektur Shiga",
      "tlName": "Timog na bahagi ng Shiga Prefecture",
      "moName": "Өмнөд Шига аймаг",
      "buName": "ရှိဂစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដស៊ីហ្គា",
      "neName": "सिगा जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "250011",
      "name": "近江南部",
      "enName": "Southern Omi Region"
    },
    "class20": {
      "code": "2520700",
      "name": "守山市",
      "enName": "Moriyama City",
      "kana": "もりやまし",
      "chName": "守山市",
      "zhName": "守山市",
      "koName": "모리야마 시",
      "esName": "Ciudad de Moriyama",
      "ptName": "cidade de Moriyama",
      "thName": "เมืองโมริยามะ",
      "viName": "thành phố Moriyama",
      "inName": "kota Moriyama",
      "tlName": "siyudad ng Moriyama",
      "moName": "Морияма хот",
      "buName": "မိုရိယာ့မ မြို့",
      "khName": "ទីក្រុង ម៉ូរីយ៉ាម៉ា",
      "neName": "मोरियामा सहर"
    }
  },
  "2520800": {
    "office": {
      "code": "250000",
      "name": "滋賀県",
      "enName": "Shiga",
      "officeName": "彦根地方気象台",
      "chName": "滋贺县",
      "zhName": "滋賀縣",
      "koName": "시가현",
      "esName": "Prefectura de Shiga",
      "ptName": "Província de Shiga",
      "thName": "จังหวัดชิงะ",
      "viName": "Tỉnh Shiga",
      "inName": "Prefektur Shiga",
      "tlName": "Shiga Prefecture",
      "moName": "Шига аймаг",
      "buName": "ရှီးဂ ပြည်နယ်",
      "khName": "ខេត្ដ ស៊ីហ្គា",
      "neName": "सिगा जिल्ला"
    },
    "class10": {
      "code": "250010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "滋贺县南部",
      "zhName": "滋賀縣南部",
      "koName": "시가 현 남부",
      "esName": "Sur de Prefectura de Shiga",
      "ptName": "Sul da Província de Shiga",
      "thName": "จังหวัดชิงะตอนใต้",
      "viName": "Miền Nam tỉnh Shiga",
      "inName": "Bagian Selatan Prefektur Shiga",
      "tlName": "Timog na bahagi ng Shiga Prefecture",
      "moName": "Өмнөд Шига аймаг",
      "buName": "ရှိဂစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដស៊ីហ្គា",
      "neName": "सिगा जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "250011",
      "name": "近江南部",
      "enName": "Southern Omi Region"
    },
    "class20": {
      "code": "2520800",
      "name": "栗東市",
      "enName": "Ritto City",
      "kana": "りっとうし",
      "chName": "栗东市",
      "zhName": "栗東市",
      "koName": "릿토 시",
      "esName": "Ciudad de Ritto",
      "ptName": "cidade de Ritto",
      "thName": "เมืองริตโตะ",
      "viName": "thành phố Ritto",
      "inName": "kota Ritto",
      "tlName": "siyudad ng Ritto",
      "moName": "Ритто хот",
      "buName": "ရစ်တို မြို့",
      "khName": "ទីក្រុង រីតតូ",
      "neName": "रिट्टो सहर"
    }
  },
  "2520900": {
    "office": {
      "code": "250000",
      "name": "滋賀県",
      "enName": "Shiga",
      "officeName": "彦根地方気象台",
      "chName": "滋贺县",
      "zhName": "滋賀縣",
      "koName": "시가현",
      "esName": "Prefectura de Shiga",
      "ptName": "Província de Shiga",
      "thName": "จังหวัดชิงะ",
      "viName": "Tỉnh Shiga",
      "inName": "Prefektur Shiga",
      "tlName": "Shiga Prefecture",
      "moName": "Шига аймаг",
      "buName": "ရှီးဂ ပြည်နယ်",
      "khName": "ខេត្ដ ស៊ីហ្គា",
      "neName": "सिगा जिल्ला"
    },
    "class10": {
      "code": "250010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "滋贺县南部",
      "zhName": "滋賀縣南部",
      "koName": "시가 현 남부",
      "esName": "Sur de Prefectura de Shiga",
      "ptName": "Sul da Província de Shiga",
      "thName": "จังหวัดชิงะตอนใต้",
      "viName": "Miền Nam tỉnh Shiga",
      "inName": "Bagian Selatan Prefektur Shiga",
      "tlName": "Timog na bahagi ng Shiga Prefecture",
      "moName": "Өмнөд Шига аймаг",
      "buName": "ရှိဂစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដស៊ីហ្គា",
      "neName": "सिगा जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "250013",
      "name": "甲賀",
      "enName": "Koka"
    },
    "class20": {
      "code": "2520900",
      "name": "甲賀市",
      "enName": "Koka City",
      "kana": "こうかし",
      "chName": "甲贺市",
      "zhName": "甲賀市",
      "koName": "고카 시",
      "esName": "Ciudad de Koka",
      "ptName": "cidade de Koka",
      "thName": "เมืองโคคะ",
      "viName": "thành phố Koka",
      "inName": "kota Koka",
      "tlName": "siyudad ng Koka",
      "moName": "Коока хот",
      "buName": "ကိုကာ မြို့",
      "khName": "ទីក្រុង កូកា",
      "neName": "कोका सहर"
    }
  },
  "2521000": {
    "office": {
      "code": "250000",
      "name": "滋賀県",
      "enName": "Shiga",
      "officeName": "彦根地方気象台",
      "chName": "滋贺县",
      "zhName": "滋賀縣",
      "koName": "시가현",
      "esName": "Prefectura de Shiga",
      "ptName": "Província de Shiga",
      "thName": "จังหวัดชิงะ",
      "viName": "Tỉnh Shiga",
      "inName": "Prefektur Shiga",
      "tlName": "Shiga Prefecture",
      "moName": "Шига аймаг",
      "buName": "ရှီးဂ ပြည်နယ်",
      "khName": "ខេត្ដ ស៊ីហ្គា",
      "neName": "सिगा जिल्ला"
    },
    "class10": {
      "code": "250010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "滋贺县南部",
      "zhName": "滋賀縣南部",
      "koName": "시가 현 남부",
      "esName": "Sur de Prefectura de Shiga",
      "ptName": "Sul da Província de Shiga",
      "thName": "จังหวัดชิงะตอนใต้",
      "viName": "Miền Nam tỉnh Shiga",
      "inName": "Bagian Selatan Prefektur Shiga",
      "tlName": "Timog na bahagi ng Shiga Prefecture",
      "moName": "Өмнөд Шига аймаг",
      "buName": "ရှိဂစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដស៊ីហ្គា",
      "neName": "सिगा जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "250011",
      "name": "近江南部",
      "enName": "Southern Omi Region"
    },
    "class20": {
      "code": "2521000",
      "name": "野洲市",
      "enName": "Yasu City",
      "kana": "やすし",
      "chName": "野洲市",
      "zhName": "野洲市",
      "koName": "야스 시",
      "esName": "Ciudad de Yasu",
      "ptName": "cidade de Yasu",
      "thName": "เมืองยะสุ",
      "viName": "thành phố Yasu",
      "inName": "kota Yasu",
      "tlName": "siyudad ng Yasu",
      "moName": "Ясү хот",
      "buName": "ယာဆု မြို့",
      "khName": "ទីក្រុង យ៉ាស៊ូ",
      "neName": "यासु सहर"
    }
  },
  "2521100": {
    "office": {
      "code": "250000",
      "name": "滋賀県",
      "enName": "Shiga",
      "officeName": "彦根地方気象台",
      "chName": "滋贺县",
      "zhName": "滋賀縣",
      "koName": "시가현",
      "esName": "Prefectura de Shiga",
      "ptName": "Província de Shiga",
      "thName": "จังหวัดชิงะ",
      "viName": "Tỉnh Shiga",
      "inName": "Prefektur Shiga",
      "tlName": "Shiga Prefecture",
      "moName": "Шига аймаг",
      "buName": "ရှီးဂ ပြည်နယ်",
      "khName": "ខេត្ដ ស៊ីហ្គា",
      "neName": "सिगा जिल्ला"
    },
    "class10": {
      "code": "250010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "滋贺县南部",
      "zhName": "滋賀縣南部",
      "koName": "시가 현 남부",
      "esName": "Sur de Prefectura de Shiga",
      "ptName": "Sul da Província de Shiga",
      "thName": "จังหวัดชิงะตอนใต้",
      "viName": "Miền Nam tỉnh Shiga",
      "inName": "Bagian Selatan Prefektur Shiga",
      "tlName": "Timog na bahagi ng Shiga Prefecture",
      "moName": "Өмнөд Шига аймаг",
      "buName": "ရှိဂစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដស៊ីហ្គា",
      "neName": "सिगा जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "250013",
      "name": "甲賀",
      "enName": "Koka"
    },
    "class20": {
      "code": "2521100",
      "name": "湖南市",
      "enName": "Konan City",
      "kana": "こなんし",
      "chName": "湖南市",
      "zhName": "湖南市",
      "koName": "고난 시",
      "esName": "Ciudad de Konan",
      "ptName": "cidade de Konan",
      "thName": "เมืองโคนัน",
      "viName": "thành phố Konan",
      "inName": "kota Konan",
      "tlName": "siyudad ng Konan",
      "moName": "Конан хот",
      "buName": "ကိုနန်း မြို့",
      "khName": "ទីក្រុង ខូណាន",
      "neName": "कोनान सहर"
    }
  },
  "2521200": {
    "office": {
      "code": "250000",
      "name": "滋賀県",
      "enName": "Shiga",
      "officeName": "彦根地方気象台",
      "chName": "滋贺县",
      "zhName": "滋賀縣",
      "koName": "시가현",
      "esName": "Prefectura de Shiga",
      "ptName": "Província de Shiga",
      "thName": "จังหวัดชิงะ",
      "viName": "Tỉnh Shiga",
      "inName": "Prefektur Shiga",
      "tlName": "Shiga Prefecture",
      "moName": "Шига аймаг",
      "buName": "ရှီးဂ ပြည်နယ်",
      "khName": "ខេត្ដ ស៊ីហ្គា",
      "neName": "सिगा जिल्ला"
    },
    "class10": {
      "code": "250020",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "滋贺县北部",
      "zhName": "滋賀縣北部",
      "koName": "시가 현 북부",
      "esName": "Norte de Prefectura de Shiga",
      "ptName": "Norte da Província de Shiga",
      "thName": "จังหวัดชิงะตอนเหนือ",
      "viName": "Miền Bắc tỉnh Shiga",
      "inName": "Bagian Utara Prefektur Shiga",
      "tlName": "Hilagang bahagi ng Shiga Prefecture",
      "moName": "Хойд Шига аймаг",
      "buName": "ရှိဂစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដស៊ីហ្គា",
      "neName": "सिगा जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "250021",
      "name": "近江西部",
      "enName": "Western Omi"
    },
    "class20": {
      "code": "2521200",
      "name": "高島市",
      "enName": "Takashima City",
      "kana": "たかしまし",
      "chName": "高岛市",
      "zhName": "髙島市",
      "koName": "다카시마 시",
      "esName": "Ciudad de Takashima",
      "ptName": "cidade de Takashima",
      "thName": "เมืองทากาชิมะ",
      "viName": "thành phố Takashima",
      "inName": "kota Takashima",
      "tlName": "siyudad ng Takashima",
      "moName": "Такашима хот",
      "buName": "တာကားရှိမ မြို့",
      "khName": "ទីក្រុង តាកាស៊ីម៉ា",
      "neName": "ताकाशिमा सहर"
    }
  },
  "2521300": {
    "office": {
      "code": "250000",
      "name": "滋賀県",
      "enName": "Shiga",
      "officeName": "彦根地方気象台",
      "chName": "滋贺县",
      "zhName": "滋賀縣",
      "koName": "시가현",
      "esName": "Prefectura de Shiga",
      "ptName": "Província de Shiga",
      "thName": "จังหวัดชิงะ",
      "viName": "Tỉnh Shiga",
      "inName": "Prefektur Shiga",
      "tlName": "Shiga Prefecture",
      "moName": "Шига аймаг",
      "buName": "ရှီးဂ ပြည်နယ်",
      "khName": "ខេត្ដ ស៊ីហ្គា",
      "neName": "सिगा जिल्ला"
    },
    "class10": {
      "code": "250010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "滋贺县南部",
      "zhName": "滋賀縣南部",
      "koName": "시가 현 남부",
      "esName": "Sur de Prefectura de Shiga",
      "ptName": "Sul da Província de Shiga",
      "thName": "จังหวัดชิงะตอนใต้",
      "viName": "Miền Nam tỉnh Shiga",
      "inName": "Bagian Selatan Prefektur Shiga",
      "tlName": "Timog na bahagi ng Shiga Prefecture",
      "moName": "Өмнөд Шига аймаг",
      "buName": "ရှိဂစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដស៊ីហ្គា",
      "neName": "सिगा जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "250012",
      "name": "東近江",
      "enName": "Higashi-omi"
    },
    "class20": {
      "code": "2521300",
      "name": "東近江市",
      "enName": "Higashiomi City",
      "kana": "ひがしおうみし",
      "chName": "东近江市",
      "zhName": "東近江市",
      "koName": "히가시오미 시",
      "esName": "Ciudad de Higashiohmi",
      "ptName": "cidade de Higashiomi",
      "thName": "เมืองฮิงะชิโอมิ",
      "viName": "thành phố Higashiomi",
      "inName": "kota Higashiomi",
      "tlName": "siyudad ng Higashiomi",
      "moName": "Хигaшиоми хот",
      "buName": "ဟီဂါရှိယိုမိ မြို့",
      "khName": "ទីក្រុង ហ៊ីហ្គាស៊ីអូមី",
      "neName": "हिगाशियोमी सहर"
    }
  },
  "2521400": {
    "office": {
      "code": "250000",
      "name": "滋賀県",
      "enName": "Shiga",
      "officeName": "彦根地方気象台",
      "chName": "滋贺县",
      "zhName": "滋賀縣",
      "koName": "시가현",
      "esName": "Prefectura de Shiga",
      "ptName": "Província de Shiga",
      "thName": "จังหวัดชิงะ",
      "viName": "Tỉnh Shiga",
      "inName": "Prefektur Shiga",
      "tlName": "Shiga Prefecture",
      "moName": "Шига аймаг",
      "buName": "ရှီးဂ ပြည်နယ်",
      "khName": "ខេត្ដ ស៊ីហ្គា",
      "neName": "सिगा जिल्ला"
    },
    "class10": {
      "code": "250020",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "滋贺县北部",
      "zhName": "滋賀縣北部",
      "koName": "시가 현 북부",
      "esName": "Norte de Prefectura de Shiga",
      "ptName": "Norte da Província de Shiga",
      "thName": "จังหวัดชิงะตอนเหนือ",
      "viName": "Miền Bắc tỉnh Shiga",
      "inName": "Bagian Utara Prefektur Shiga",
      "tlName": "Hilagang bahagi ng Shiga Prefecture",
      "moName": "Хойд Шига аймаг",
      "buName": "ရှိဂစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដស៊ីហ្គា",
      "neName": "सिगा जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "250022",
      "name": "湖北",
      "enName": "Kohoku"
    },
    "class20": {
      "code": "2521400",
      "name": "米原市",
      "enName": "Maibara City",
      "kana": "まいばらし",
      "chName": "米原市",
      "zhName": "米原市",
      "koName": "마이바라 시",
      "esName": "Ciudad de Maibara",
      "ptName": "cidade de Maibara",
      "thName": "เมืองมาอิบาระ",
      "viName": "thành phố Maibara",
      "inName": "kota Maibara",
      "tlName": "siyudad ng Maibara",
      "moName": "Мaйбара хот",
      "buName": "မာအီဘာ့ရာ့ မြို့",
      "khName": "ទីក្រុង ម៉ីបារ៉ា",
      "neName": "माइबारा सहर"
    }
  },
  "2538300": {
    "office": {
      "code": "250000",
      "name": "滋賀県",
      "enName": "Shiga",
      "officeName": "彦根地方気象台",
      "chName": "滋贺县",
      "zhName": "滋賀縣",
      "koName": "시가현",
      "esName": "Prefectura de Shiga",
      "ptName": "Província de Shiga",
      "thName": "จังหวัดชิงะ",
      "viName": "Tỉnh Shiga",
      "inName": "Prefektur Shiga",
      "tlName": "Shiga Prefecture",
      "moName": "Шига аймаг",
      "buName": "ရှီးဂ ပြည်နယ်",
      "khName": "ខេត្ដ ស៊ីហ្គា",
      "neName": "सिगा जिल्ला"
    },
    "class10": {
      "code": "250010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "滋贺县南部",
      "zhName": "滋賀縣南部",
      "koName": "시가 현 남부",
      "esName": "Sur de Prefectura de Shiga",
      "ptName": "Sul da Província de Shiga",
      "thName": "จังหวัดชิงะตอนใต้",
      "viName": "Miền Nam tỉnh Shiga",
      "inName": "Bagian Selatan Prefektur Shiga",
      "tlName": "Timog na bahagi ng Shiga Prefecture",
      "moName": "Өмнөд Шига аймаг",
      "buName": "ရှိဂစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដស៊ីហ្គា",
      "neName": "सिगा जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "250012",
      "name": "東近江",
      "enName": "Higashi-omi"
    },
    "class20": {
      "code": "2538300",
      "name": "日野町",
      "enName": "Hino Town",
      "kana": "ひのちょう",
      "chName": "滋贺日野町",
      "zhName": "滋賀日野町",
      "koName": "시가 히노 정",
      "esName": "Pueblo de Hino, Shiga",
      "ptName": "Shiga, bairro de Hino",
      "thName": "เมืองฮิโนะ ชิงะ",
      "viName": "Thị trấn Hino, Shiga",
      "inName": "Kota Hino, Shiga",
      "tlName": "bayan ng Hino, Shiga",
      "moName": "Шига Хино жижиг хот",
      "buName": "ရှိဂဟိနိုမြို့နယ်",
      "khName": "ទីប្រជុំជនហ៊ីណូ ស៊ីហ្គា",
      "neName": "सिगा हिनो नगर "
    }
  },
  "2538400": {
    "office": {
      "code": "250000",
      "name": "滋賀県",
      "enName": "Shiga",
      "officeName": "彦根地方気象台",
      "chName": "滋贺县",
      "zhName": "滋賀縣",
      "koName": "시가현",
      "esName": "Prefectura de Shiga",
      "ptName": "Província de Shiga",
      "thName": "จังหวัดชิงะ",
      "viName": "Tỉnh Shiga",
      "inName": "Prefektur Shiga",
      "tlName": "Shiga Prefecture",
      "moName": "Шига аймаг",
      "buName": "ရှီးဂ ပြည်နယ်",
      "khName": "ខេត្ដ ស៊ីហ្គា",
      "neName": "सिगा जिल्ला"
    },
    "class10": {
      "code": "250010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "滋贺县南部",
      "zhName": "滋賀縣南部",
      "koName": "시가 현 남부",
      "esName": "Sur de Prefectura de Shiga",
      "ptName": "Sul da Província de Shiga",
      "thName": "จังหวัดชิงะตอนใต้",
      "viName": "Miền Nam tỉnh Shiga",
      "inName": "Bagian Selatan Prefektur Shiga",
      "tlName": "Timog na bahagi ng Shiga Prefecture",
      "moName": "Өмнөд Шига аймаг",
      "buName": "ရှိဂစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដស៊ីហ្គា",
      "neName": "सिगा जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "250012",
      "name": "東近江",
      "enName": "Higashi-omi"
    },
    "class20": {
      "code": "2538400",
      "name": "竜王町",
      "enName": "Ryuoh Town",
      "kana": "りゅうおうちょう",
      "chName": "龙王町",
      "zhName": "龍王町",
      "koName": "류오 정",
      "esName": "Pueblo de Ryuo",
      "ptName": "bairro de Ryuoh",
      "thName": "เมืองริวโอะ",
      "viName": "thị trấn Ryuoh",
      "inName": "kota Ryuoh",
      "tlName": "bayan ng Ryuoh",
      "moName": "Рюо жижиг хот",
      "buName": "ရာယုဟို မြို့နယ်",
      "khName": "ទីប្រជុំជន រូអូ",
      "neName": "ह्रिउहो नगर "
    }
  },
  "2542500": {
    "office": {
      "code": "250000",
      "name": "滋賀県",
      "enName": "Shiga",
      "officeName": "彦根地方気象台",
      "chName": "滋贺县",
      "zhName": "滋賀縣",
      "koName": "시가현",
      "esName": "Prefectura de Shiga",
      "ptName": "Província de Shiga",
      "thName": "จังหวัดชิงะ",
      "viName": "Tỉnh Shiga",
      "inName": "Prefektur Shiga",
      "tlName": "Shiga Prefecture",
      "moName": "Шига аймаг",
      "buName": "ရှီးဂ ပြည်နယ်",
      "khName": "ខេត្ដ ស៊ីហ្គា",
      "neName": "सिगा जिल्ला"
    },
    "class10": {
      "code": "250020",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "滋贺县北部",
      "zhName": "滋賀縣北部",
      "koName": "시가 현 북부",
      "esName": "Norte de Prefectura de Shiga",
      "ptName": "Norte da Província de Shiga",
      "thName": "จังหวัดชิงะตอนเหนือ",
      "viName": "Miền Bắc tỉnh Shiga",
      "inName": "Bagian Utara Prefektur Shiga",
      "tlName": "Hilagang bahagi ng Shiga Prefecture",
      "moName": "Хойд Шига аймаг",
      "buName": "ရှိဂစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដស៊ីហ្គា",
      "neName": "सिगा जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "250023",
      "name": "湖東",
      "enName": "Koto"
    },
    "class20": {
      "code": "2542500",
      "name": "愛荘町",
      "enName": "Aisho Town",
      "kana": "あいしょうちょう",
      "chName": "爱庄町",
      "zhName": "愛莊町",
      "koName": "아이쇼 정",
      "esName": "Pueblo de Aisho",
      "ptName": "bairro de Aisho",
      "thName": "เมืองไอโช",
      "viName": "thị trấn Aisho",
      "inName": "kota Aisho",
      "tlName": "bayan ng Aisho",
      "moName": "Aйшо жижиг хот",
      "buName": "အာယိရှို မြို့နယ်",
      "khName": "ទីប្រជុំជន អាយសូ",
      "neName": "आइशो नगर "
    }
  },
  "2544100": {
    "office": {
      "code": "250000",
      "name": "滋賀県",
      "enName": "Shiga",
      "officeName": "彦根地方気象台",
      "chName": "滋贺县",
      "zhName": "滋賀縣",
      "koName": "시가현",
      "esName": "Prefectura de Shiga",
      "ptName": "Província de Shiga",
      "thName": "จังหวัดชิงะ",
      "viName": "Tỉnh Shiga",
      "inName": "Prefektur Shiga",
      "tlName": "Shiga Prefecture",
      "moName": "Шига аймаг",
      "buName": "ရှီးဂ ပြည်နယ်",
      "khName": "ខេត្ដ ស៊ីហ្គា",
      "neName": "सिगा जिल्ला"
    },
    "class10": {
      "code": "250020",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "滋贺县北部",
      "zhName": "滋賀縣北部",
      "koName": "시가 현 북부",
      "esName": "Norte de Prefectura de Shiga",
      "ptName": "Norte da Província de Shiga",
      "thName": "จังหวัดชิงะตอนเหนือ",
      "viName": "Miền Bắc tỉnh Shiga",
      "inName": "Bagian Utara Prefektur Shiga",
      "tlName": "Hilagang bahagi ng Shiga Prefecture",
      "moName": "Хойд Шига аймаг",
      "buName": "ရှိဂစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដស៊ីហ្គា",
      "neName": "सिगा जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "250023",
      "name": "湖東",
      "enName": "Koto"
    },
    "class20": {
      "code": "2544100",
      "name": "豊郷町",
      "enName": "Toyosato Town",
      "kana": "とよさとちょう",
      "chName": "丰乡町",
      "zhName": "豐鄉町",
      "koName": "도요사토 정",
      "esName": "Pueblo de Toyosato",
      "ptName": "bairro de Toyosato",
      "thName": "เมืองโทโยซาโตะ",
      "viName": "thị trấn Toyosato",
      "inName": "kota Toyosato",
      "tlName": "bayan ng Toyosato",
      "moName": "Тоёсaто жижиг хот",
      "buName": "တိုယိုဆာတို မြို့နယ်",
      "khName": "ទីប្រជុំជន ថូយ៉ូសាតូ",
      "neName": "तोयोसातो नगर "
    }
  },
  "2544200": {
    "office": {
      "code": "250000",
      "name": "滋賀県",
      "enName": "Shiga",
      "officeName": "彦根地方気象台",
      "chName": "滋贺县",
      "zhName": "滋賀縣",
      "koName": "시가현",
      "esName": "Prefectura de Shiga",
      "ptName": "Província de Shiga",
      "thName": "จังหวัดชิงะ",
      "viName": "Tỉnh Shiga",
      "inName": "Prefektur Shiga",
      "tlName": "Shiga Prefecture",
      "moName": "Шига аймаг",
      "buName": "ရှီးဂ ပြည်နယ်",
      "khName": "ខេត្ដ ស៊ីហ្គា",
      "neName": "सिगा जिल्ला"
    },
    "class10": {
      "code": "250020",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "滋贺县北部",
      "zhName": "滋賀縣北部",
      "koName": "시가 현 북부",
      "esName": "Norte de Prefectura de Shiga",
      "ptName": "Norte da Província de Shiga",
      "thName": "จังหวัดชิงะตอนเหนือ",
      "viName": "Miền Bắc tỉnh Shiga",
      "inName": "Bagian Utara Prefektur Shiga",
      "tlName": "Hilagang bahagi ng Shiga Prefecture",
      "moName": "Хойд Шига аймаг",
      "buName": "ရှိဂစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដស៊ីហ្គា",
      "neName": "सिगा जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "250023",
      "name": "湖東",
      "enName": "Koto"
    },
    "class20": {
      "code": "2544200",
      "name": "甲良町",
      "enName": "Kora Town",
      "kana": "こうらちょう",
      "chName": "甲良町",
      "zhName": "甲良町",
      "koName": "고라 정",
      "esName": "Pueblo de Kora",
      "ptName": "bairro de Kora",
      "thName": "เมืองโคระ",
      "viName": "thị trấn Kora",
      "inName": "kota Kora",
      "tlName": "bayan ng Kora",
      "moName": "Кора жижиг хот",
      "buName": "ကိုရာ မြို့နယ်",
      "khName": "ទីប្រជុំជន កូរ៉ា",
      "neName": "कोरा नगर "
    }
  },
  "2544300": {
    "office": {
      "code": "250000",
      "name": "滋賀県",
      "enName": "Shiga",
      "officeName": "彦根地方気象台",
      "chName": "滋贺县",
      "zhName": "滋賀縣",
      "koName": "시가현",
      "esName": "Prefectura de Shiga",
      "ptName": "Província de Shiga",
      "thName": "จังหวัดชิงะ",
      "viName": "Tỉnh Shiga",
      "inName": "Prefektur Shiga",
      "tlName": "Shiga Prefecture",
      "moName": "Шига аймаг",
      "buName": "ရှီးဂ ပြည်နယ်",
      "khName": "ខេត្ដ ស៊ីហ្គា",
      "neName": "सिगा जिल्ला"
    },
    "class10": {
      "code": "250020",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "滋贺县北部",
      "zhName": "滋賀縣北部",
      "koName": "시가 현 북부",
      "esName": "Norte de Prefectura de Shiga",
      "ptName": "Norte da Província de Shiga",
      "thName": "จังหวัดชิงะตอนเหนือ",
      "viName": "Miền Bắc tỉnh Shiga",
      "inName": "Bagian Utara Prefektur Shiga",
      "tlName": "Hilagang bahagi ng Shiga Prefecture",
      "moName": "Хойд Шига аймаг",
      "buName": "ရှိဂစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដស៊ីហ្គា",
      "neName": "सिगा जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "250023",
      "name": "湖東",
      "enName": "Koto"
    },
    "class20": {
      "code": "2544300",
      "name": "多賀町",
      "enName": "Taga Town",
      "kana": "たがちょう",
      "chName": "多贺町",
      "zhName": "多賀町",
      "koName": "다가 정",
      "esName": "Pueblo de Taga",
      "ptName": "bairro de Taga",
      "thName": "เมืองทางะ",
      "viName": "thị trấn Taga",
      "inName": "kota Taga",
      "tlName": "bayan ng Taga",
      "moName": "Тагa жижиг хот",
      "buName": "တာဂ မြို့နယ်",
      "khName": "ទីប្រជុំជន ថាកា",
      "neName": "तागा नगर "
    }
  },
  "2610000": {
    "office": {
      "code": "260000",
      "name": "京都府",
      "enName": "Kyoto",
      "officeName": "京都地方気象台",
      "chName": "京都府",
      "zhName": "京都府",
      "koName": "교토부",
      "esName": "Prefectura de Kioto",
      "ptName": "Província de Kyōto",
      "thName": "จังหวัดเกียวโต",
      "viName": "Tỉnh Kyoto",
      "inName": "Prefektur Kyoto",
      "tlName": "Kyoto Prefecture",
      "moName": "Киото аймаг",
      "buName": "ကျိုတို ပြည်နယ်",
      "khName": "ខេត្ដ ខ្យូតូ",
      "neName": "क्योतो जिल्ला"
    },
    "class10": {
      "code": "260010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "京都府南部",
      "zhName": "京都府南部",
      "koName": "교토 부 남부",
      "esName": "Sur de Prefectura de Kioto",
      "ptName": "Sul da Província de Kyōto",
      "thName": "จังหวัดเกียวโตตอนใต้",
      "viName": "Miền Nam tỉnh Kyoto",
      "inName": "Bagian Selatan Prefektur Kyoto",
      "tlName": "Timog na bahagi ng Kyoto Prefecture",
      "moName": "Өмнөд Киото аймаг",
      "buName": "ကျိုတိုစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃក្យូតុ",
      "neName": "क्योतो जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "260011",
      "name": "京都・亀岡",
      "enName": "Kyoto Kameoka"
    },
    "class20": {
      "code": "2610000",
      "name": "京都市",
      "enName": "Kyoto City",
      "kana": "きょうとし",
      "chName": "京都市",
      "zhName": "京都市",
      "koName": "교토시",
      "esName": "Ciudad de Kioto",
      "ptName": "Cidade de Quioto",
      "thName": "เมืองเกียวโต",
      "viName": "Thành phố Kyoto",
      "inName": "Kota Kyoto",
      "tlName": "Lungsod ng Kyoto",
      "moName": "Cidade de Quioto",
      "buName": "ကျိုတိုမြို့",
      "khName": "ទីក្រុង Kyoto",
      "neName": "क्योटो शहर"
    }
  },
  "2620100": {
    "office": {
      "code": "260000",
      "name": "京都府",
      "enName": "Kyoto",
      "officeName": "京都地方気象台",
      "chName": "京都府",
      "zhName": "京都府",
      "koName": "교토부",
      "esName": "Prefectura de Kioto",
      "ptName": "Província de Kyōto",
      "thName": "จังหวัดเกียวโต",
      "viName": "Tỉnh Kyoto",
      "inName": "Prefektur Kyoto",
      "tlName": "Kyoto Prefecture",
      "moName": "Киото аймаг",
      "buName": "ကျိုတို ပြည်နယ်",
      "khName": "ខេត្ដ ខ្យូតូ",
      "neName": "क्योतो जिल्ला"
    },
    "class10": {
      "code": "260020",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "京都府北部",
      "zhName": "京都府北部",
      "koName": "교토 부 북부",
      "esName": "Norte de Prefectura de Kioto",
      "ptName": "Norte da Província de Kyōto",
      "thName": "จังหวัดเกียวโตตอนเหนือ",
      "viName": "Miền Bắc tỉnh Kyoto",
      "inName": "Bagian Utara Prefektur Kyoto",
      "tlName": "Hilagang bahagi ng Kyoto Prefecture",
      "moName": "Хойд Киото аймаг",
      "buName": "ကျိုတိုစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃក្យូតុ",
      "neName": "क्योतो जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "260023",
      "name": "福知山",
      "enName": "Fukuchiyama"
    },
    "class20": {
      "code": "2620100",
      "name": "福知山市",
      "enName": "Fukuchiyama City",
      "kana": "ふくちやまし",
      "chName": "福知山市",
      "zhName": "福知山市",
      "koName": "후쿠치야마 시",
      "esName": "Ciudad de Fukuchiyama",
      "ptName": "cidade de Fukuchiyama",
      "thName": "เมืองฟุคุจิยามะ",
      "viName": "thành phố Fukuchiyama",
      "inName": "kota Fukuchiyama",
      "tlName": "siyudad ng Fukuchiyama",
      "moName": "Фүкүчияма хот",
      "buName": "ဖူကုကျိယာ့မ မြို့",
      "khName": "ទីក្រុង ហ្វូគូជីយ៉ាម៉ា",
      "neName": "फुकुचियामा सहर"
    }
  },
  "2620200": {
    "office": {
      "code": "260000",
      "name": "京都府",
      "enName": "Kyoto",
      "officeName": "京都地方気象台",
      "chName": "京都府",
      "zhName": "京都府",
      "koName": "교토부",
      "esName": "Prefectura de Kioto",
      "ptName": "Província de Kyōto",
      "thName": "จังหวัดเกียวโต",
      "viName": "Tỉnh Kyoto",
      "inName": "Prefektur Kyoto",
      "tlName": "Kyoto Prefecture",
      "moName": "Киото аймаг",
      "buName": "ကျိုတို ပြည်နယ်",
      "khName": "ខេត្ដ ខ្យូតូ",
      "neName": "क्योतो जिल्ला"
    },
    "class10": {
      "code": "260020",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "京都府北部",
      "zhName": "京都府北部",
      "koName": "교토 부 북부",
      "esName": "Norte de Prefectura de Kioto",
      "ptName": "Norte da Província de Kyōto",
      "thName": "จังหวัดเกียวโตตอนเหนือ",
      "viName": "Miền Bắc tỉnh Kyoto",
      "inName": "Bagian Utara Prefektur Kyoto",
      "tlName": "Hilagang bahagi ng Kyoto Prefecture",
      "moName": "Хойд Киото аймаг",
      "buName": "ကျိုတိုစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃក្យូតុ",
      "neName": "क्योतो जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "260022",
      "name": "舞鶴・綾部",
      "enName": "Maizuru Ayabe"
    },
    "class20": {
      "code": "2620200",
      "name": "舞鶴市",
      "enName": "Maizuru City",
      "kana": "まいづるし",
      "chName": "舞鹤市",
      "zhName": "舞鶴市",
      "koName": "마이즈루 시",
      "esName": "Ciudad de Maizuru",
      "ptName": "cidade de Maizuru",
      "thName": "เมืองมาอิซุรุ",
      "viName": "thành phố Maizuru",
      "inName": "kota Maizuru",
      "tlName": "siyudad ng Maizuru",
      "moName": "Мaйзүрү хот",
      "buName": "မာအီဇုရု မြို့",
      "khName": "ទីក្រុង ម៉ៃហ៊្សូរូ",
      "neName": "माइजुरु सहर"
    }
  },
  "2620300": {
    "office": {
      "code": "260000",
      "name": "京都府",
      "enName": "Kyoto",
      "officeName": "京都地方気象台",
      "chName": "京都府",
      "zhName": "京都府",
      "koName": "교토부",
      "esName": "Prefectura de Kioto",
      "ptName": "Província de Kyōto",
      "thName": "จังหวัดเกียวโต",
      "viName": "Tỉnh Kyoto",
      "inName": "Prefektur Kyoto",
      "tlName": "Kyoto Prefecture",
      "moName": "Киото аймаг",
      "buName": "ကျိုတို ပြည်နယ်",
      "khName": "ខេត្ដ ខ្យូតូ",
      "neName": "क्योतो जिल्ला"
    },
    "class10": {
      "code": "260020",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "京都府北部",
      "zhName": "京都府北部",
      "koName": "교토 부 북부",
      "esName": "Norte de Prefectura de Kioto",
      "ptName": "Norte da Província de Kyōto",
      "thName": "จังหวัดเกียวโตตอนเหนือ",
      "viName": "Miền Bắc tỉnh Kyoto",
      "inName": "Bagian Utara Prefektur Kyoto",
      "tlName": "Hilagang bahagi ng Kyoto Prefecture",
      "moName": "Хойд Киото аймаг",
      "buName": "ကျိုတိုစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃក្យូតុ",
      "neName": "क्योतो जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "260022",
      "name": "舞鶴・綾部",
      "enName": "Maizuru Ayabe"
    },
    "class20": {
      "code": "2620300",
      "name": "綾部市",
      "enName": "Ayabe City",
      "kana": "あやべし",
      "chName": "绫部市",
      "zhName": "綾部市",
      "koName": "아야베 시",
      "esName": "Ciudad de Ayabe",
      "ptName": "cidade de Ayabe",
      "thName": "เมืองอายาเบะ",
      "viName": "thành phố Ayabe",
      "inName": "kota Ayabe",
      "tlName": "siyudad ng Ayabe",
      "moName": "Aябэ хот",
      "buName": "အာယဘဲ့ မြို့",
      "khName": "ទីក្រុង អេអាបេ",
      "neName": "आयाबे सहर"
    }
  },
  "2620400": {
    "office": {
      "code": "260000",
      "name": "京都府",
      "enName": "Kyoto",
      "officeName": "京都地方気象台",
      "chName": "京都府",
      "zhName": "京都府",
      "koName": "교토부",
      "esName": "Prefectura de Kioto",
      "ptName": "Província de Kyōto",
      "thName": "จังหวัดเกียวโต",
      "viName": "Tỉnh Kyoto",
      "inName": "Prefektur Kyoto",
      "tlName": "Kyoto Prefecture",
      "moName": "Киото аймаг",
      "buName": "ကျိုတို ပြည်နယ်",
      "khName": "ខេត្ដ ខ្យូតូ",
      "neName": "क्योतो जिल्ला"
    },
    "class10": {
      "code": "260010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "京都府南部",
      "zhName": "京都府南部",
      "koName": "교토 부 남부",
      "esName": "Sur de Prefectura de Kioto",
      "ptName": "Sul da Província de Kyōto",
      "thName": "จังหวัดเกียวโตตอนใต้",
      "viName": "Miền Nam tỉnh Kyoto",
      "inName": "Bagian Selatan Prefektur Kyoto",
      "tlName": "Timog na bahagi ng Kyoto Prefecture",
      "moName": "Өмнөд Киото аймаг",
      "buName": "ကျိုတိုစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃក្យូតុ",
      "neName": "क्योतो जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "260013",
      "name": "山城中部",
      "enName": "Central Yamashiro"
    },
    "class20": {
      "code": "2620400",
      "name": "宇治市",
      "enName": "Uji City",
      "kana": "うじし",
      "chName": "宇治市",
      "zhName": "宇治市",
      "koName": "우지시",
      "esName": "Ciudad de Uji",
      "ptName": "cidade de Uji",
      "thName": "เมืองอุจิ",
      "viName": "thành phố Uji",
      "inName": "kota Uji",
      "tlName": "siyudad ng Uji",
      "moName": "Үжи хот",
      "buName": "အူးဂျိ မြို့",
      "khName": "ទីក្រុង យូជី",
      "neName": "उजी सहर"
    }
  },
  "2620500": {
    "office": {
      "code": "260000",
      "name": "京都府",
      "enName": "Kyoto",
      "officeName": "京都地方気象台",
      "chName": "京都府",
      "zhName": "京都府",
      "koName": "교토부",
      "esName": "Prefectura de Kioto",
      "ptName": "Província de Kyōto",
      "thName": "จังหวัดเกียวโต",
      "viName": "Tỉnh Kyoto",
      "inName": "Prefektur Kyoto",
      "tlName": "Kyoto Prefecture",
      "moName": "Киото аймаг",
      "buName": "ကျိုတို ပြည်နယ်",
      "khName": "ខេត្ដ ខ្យូតូ",
      "neName": "क्योतो जिल्ला"
    },
    "class10": {
      "code": "260020",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "京都府北部",
      "zhName": "京都府北部",
      "koName": "교토 부 북부",
      "esName": "Norte de Prefectura de Kioto",
      "ptName": "Norte da Província de Kyōto",
      "thName": "จังหวัดเกียวโตตอนเหนือ",
      "viName": "Miền Bắc tỉnh Kyoto",
      "inName": "Bagian Utara Prefektur Kyoto",
      "tlName": "Hilagang bahagi ng Kyoto Prefecture",
      "moName": "Хойд Киото аймаг",
      "buName": "ကျိုတိုစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃក្យូតុ",
      "neName": "क्योतो जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "260021",
      "name": "丹後",
      "enName": "Tango"
    },
    "class20": {
      "code": "2620500",
      "name": "宮津市",
      "enName": "Miyazu City",
      "kana": "みやづし",
      "chName": "宫津市",
      "zhName": "宮津市",
      "koName": "미야즈 시",
      "esName": "Ciudad de Miyazu",
      "ptName": "cidade de Miyazu",
      "thName": "เมืองมิยาสุ",
      "viName": "thành phố Miyazu",
      "inName": "kota Miyazu",
      "tlName": "siyudad ng Miyazu",
      "moName": "Миязү хот",
      "buName": "မီးယာ့ဇု မြို့",
      "khName": "ទីក្រុង មីយ៉ាហ្សូ",
      "neName": "मियाजु सहर"
    }
  },
  "2620600": {
    "office": {
      "code": "260000",
      "name": "京都府",
      "enName": "Kyoto",
      "officeName": "京都地方気象台",
      "chName": "京都府",
      "zhName": "京都府",
      "koName": "교토부",
      "esName": "Prefectura de Kioto",
      "ptName": "Província de Kyōto",
      "thName": "จังหวัดเกียวโต",
      "viName": "Tỉnh Kyoto",
      "inName": "Prefektur Kyoto",
      "tlName": "Kyoto Prefecture",
      "moName": "Киото аймаг",
      "buName": "ကျိုတို ပြည်နယ်",
      "khName": "ខេត្ដ ខ្យូតូ",
      "neName": "क्योतो जिल्ला"
    },
    "class10": {
      "code": "260010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "京都府南部",
      "zhName": "京都府南部",
      "koName": "교토 부 남부",
      "esName": "Sur de Prefectura de Kioto",
      "ptName": "Sul da Província de Kyōto",
      "thName": "จังหวัดเกียวโตตอนใต้",
      "viName": "Miền Nam tỉnh Kyoto",
      "inName": "Bagian Selatan Prefektur Kyoto",
      "tlName": "Timog na bahagi ng Kyoto Prefecture",
      "moName": "Өмнөд Киото аймаг",
      "buName": "ကျိုတိုစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃក្យូតុ",
      "neName": "क्योतो जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "260011",
      "name": "京都・亀岡",
      "enName": "Kyoto Kameoka"
    },
    "class20": {
      "code": "2620600",
      "name": "亀岡市",
      "enName": "Kameoka City",
      "kana": "かめおかし",
      "chName": "龟冈市",
      "zhName": "龜岡市",
      "koName": "가메오카 시",
      "esName": "Ciudad de Kameoka",
      "ptName": "cidade de Kameoka",
      "thName": "เมืองคาเมะโอกะ",
      "viName": "thành phố Kameoka",
      "inName": "kota Kameoka",
      "tlName": "siyudad ng Kameoka",
      "moName": "Камэока хот",
      "buName": "ခါမေယိုးက မြို့",
      "khName": "ទីក្រុង កាមេអូកា",
      "neName": "कामेओका सहर"
    }
  },
  "2620700": {
    "office": {
      "code": "260000",
      "name": "京都府",
      "enName": "Kyoto",
      "officeName": "京都地方気象台",
      "chName": "京都府",
      "zhName": "京都府",
      "koName": "교토부",
      "esName": "Prefectura de Kioto",
      "ptName": "Província de Kyōto",
      "thName": "จังหวัดเกียวโต",
      "viName": "Tỉnh Kyoto",
      "inName": "Prefektur Kyoto",
      "tlName": "Kyoto Prefecture",
      "moName": "Киото аймаг",
      "buName": "ကျိုတို ပြည်နယ်",
      "khName": "ខេត្ដ ខ្យូតូ",
      "neName": "क्योतो जिल्ला"
    },
    "class10": {
      "code": "260010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "京都府南部",
      "zhName": "京都府南部",
      "koName": "교토 부 남부",
      "esName": "Sur de Prefectura de Kioto",
      "ptName": "Sul da Província de Kyōto",
      "thName": "จังหวัดเกียวโตตอนใต้",
      "viName": "Miền Nam tỉnh Kyoto",
      "inName": "Bagian Selatan Prefektur Kyoto",
      "tlName": "Timog na bahagi ng Kyoto Prefecture",
      "moName": "Өмнөд Киото аймаг",
      "buName": "ကျိုတိုစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃក្យូតុ",
      "neName": "क्योतो जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "260013",
      "name": "山城中部",
      "enName": "Central Yamashiro"
    },
    "class20": {
      "code": "2620700",
      "name": "城陽市",
      "enName": "Joyo City",
      "kana": "じょうようし",
      "chName": "城阳市",
      "zhName": "城陽市",
      "koName": "조요 시",
      "esName": "Ciudad de Jyōyo",
      "ptName": "cidade de Joyo",
      "thName": "เมืองโจโยะ",
      "viName": "thành phố Joyo",
      "inName": "kota Joyo",
      "tlName": "siyudad ng Joyo",
      "moName": "Жоёо хот",
      "buName": "ဂျိုရို မြို့",
      "khName": "ទីក្រុង ជូយ៉ូ",
      "neName": "जोयो सहर"
    }
  },
  "2620800": {
    "office": {
      "code": "260000",
      "name": "京都府",
      "enName": "Kyoto",
      "officeName": "京都地方気象台",
      "chName": "京都府",
      "zhName": "京都府",
      "koName": "교토부",
      "esName": "Prefectura de Kioto",
      "ptName": "Província de Kyōto",
      "thName": "จังหวัดเกียวโต",
      "viName": "Tỉnh Kyoto",
      "inName": "Prefektur Kyoto",
      "tlName": "Kyoto Prefecture",
      "moName": "Киото аймаг",
      "buName": "ကျိုတို ပြည်နယ်",
      "khName": "ខេត្ដ ខ្យូតូ",
      "neName": "क्योतो जिल्ला"
    },
    "class10": {
      "code": "260010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "京都府南部",
      "zhName": "京都府南部",
      "koName": "교토 부 남부",
      "esName": "Sur de Prefectura de Kioto",
      "ptName": "Sul da Província de Kyōto",
      "thName": "จังหวัดเกียวโตตอนใต้",
      "viName": "Miền Nam tỉnh Kyoto",
      "inName": "Bagian Selatan Prefektur Kyoto",
      "tlName": "Timog na bahagi ng Kyoto Prefecture",
      "moName": "Өмнөд Киото аймаг",
      "buName": "ကျိုတိုစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃក្យូតុ",
      "neName": "क्योतो जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "260011",
      "name": "京都・亀岡",
      "enName": "Kyoto Kameoka"
    },
    "class20": {
      "code": "2620800",
      "name": "向日市",
      "enName": "Muko City",
      "kana": "むこうし",
      "chName": "向日市",
      "zhName": "向日市",
      "koName": "무코 시",
      "esName": "Ciudad de Muko",
      "ptName": "cidade de Muko",
      "thName": "เมืองมุโคะ",
      "viName": "thành phố Muko",
      "inName": "kota Muko",
      "tlName": "siyudad ng Muko",
      "moName": "Мүко хот",
      "buName": "မူကို မြို့",
      "khName": "ទីក្រុង មូកុ",
      "neName": "मुको सहर"
    }
  },
  "2620900": {
    "office": {
      "code": "260000",
      "name": "京都府",
      "enName": "Kyoto",
      "officeName": "京都地方気象台",
      "chName": "京都府",
      "zhName": "京都府",
      "koName": "교토부",
      "esName": "Prefectura de Kioto",
      "ptName": "Província de Kyōto",
      "thName": "จังหวัดเกียวโต",
      "viName": "Tỉnh Kyoto",
      "inName": "Prefektur Kyoto",
      "tlName": "Kyoto Prefecture",
      "moName": "Киото аймаг",
      "buName": "ကျိုတို ပြည်နယ်",
      "khName": "ខេត្ដ ខ្យូតូ",
      "neName": "क्योतो जिल्ला"
    },
    "class10": {
      "code": "260010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "京都府南部",
      "zhName": "京都府南部",
      "koName": "교토 부 남부",
      "esName": "Sur de Prefectura de Kioto",
      "ptName": "Sul da Província de Kyōto",
      "thName": "จังหวัดเกียวโตตอนใต้",
      "viName": "Miền Nam tỉnh Kyoto",
      "inName": "Bagian Selatan Prefektur Kyoto",
      "tlName": "Timog na bahagi ng Kyoto Prefecture",
      "moName": "Өмнөд Киото аймаг",
      "buName": "ကျိုတိုစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃក្យូតុ",
      "neName": "क्योतो जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "260011",
      "name": "京都・亀岡",
      "enName": "Kyoto Kameoka"
    },
    "class20": {
      "code": "2620900",
      "name": "長岡京市",
      "enName": "Nagaokakyo City",
      "kana": "ながおかきょうし",
      "chName": "常冈京市",
      "zhName": "長岡京市",
      "koName": "나가오카쿄 시",
      "esName": "Ciudad de Nagaokakyō",
      "ptName": "cidade de Nagaokakyo",
      "thName": "เมืองนากาโอกะเคียว",
      "viName": "thành phố Nagaokakyo",
      "inName": "kota Nagaokakyo",
      "tlName": "siyudad ng Nagaokakyo",
      "moName": "Нaгaокакио хот",
      "buName": "နာဂါအိုကာကျို မြို့",
      "khName": "ទីក្រុង ណាកីអូខាឃីយូ",
      "neName": "नागाओकाक्यो सहर"
    }
  },
  "2621000": {
    "office": {
      "code": "260000",
      "name": "京都府",
      "enName": "Kyoto",
      "officeName": "京都地方気象台",
      "chName": "京都府",
      "zhName": "京都府",
      "koName": "교토부",
      "esName": "Prefectura de Kioto",
      "ptName": "Província de Kyōto",
      "thName": "จังหวัดเกียวโต",
      "viName": "Tỉnh Kyoto",
      "inName": "Prefektur Kyoto",
      "tlName": "Kyoto Prefecture",
      "moName": "Киото аймаг",
      "buName": "ကျိုတို ပြည်နယ်",
      "khName": "ខេត្ដ ខ្យូតូ",
      "neName": "क्योतो जिल्ला"
    },
    "class10": {
      "code": "260010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "京都府南部",
      "zhName": "京都府南部",
      "koName": "교토 부 남부",
      "esName": "Sur de Prefectura de Kioto",
      "ptName": "Sul da Província de Kyōto",
      "thName": "จังหวัดเกียวโตตอนใต้",
      "viName": "Miền Nam tỉnh Kyoto",
      "inName": "Bagian Selatan Prefektur Kyoto",
      "tlName": "Timog na bahagi ng Kyoto Prefecture",
      "moName": "Өмнөд Киото аймаг",
      "buName": "ကျိုတိုစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃក្យូតុ",
      "neName": "क्योतो जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "260013",
      "name": "山城中部",
      "enName": "Central Yamashiro"
    },
    "class20": {
      "code": "2621000",
      "name": "八幡市",
      "enName": "Yawata City",
      "kana": "やわたし",
      "chName": "八幡市",
      "zhName": "八幡市",
      "koName": "야와타 시",
      "esName": "Ciudad de Yawata",
      "ptName": "cidade de Yawata",
      "thName": "เมืองยาวาตะ",
      "viName": "thành phố Yawata",
      "inName": "kota Yawata",
      "tlName": "siyudad ng Yawata",
      "moName": "Явата хот",
      "buName": "ယာဝါ့တ မြို့",
      "khName": "ទីក្រុង យ៉ាវ៉ាតា",
      "neName": "यावाता सहर"
    }
  },
  "2621100": {
    "office": {
      "code": "260000",
      "name": "京都府",
      "enName": "Kyoto",
      "officeName": "京都地方気象台",
      "chName": "京都府",
      "zhName": "京都府",
      "koName": "교토부",
      "esName": "Prefectura de Kioto",
      "ptName": "Província de Kyōto",
      "thName": "จังหวัดเกียวโต",
      "viName": "Tỉnh Kyoto",
      "inName": "Prefektur Kyoto",
      "tlName": "Kyoto Prefecture",
      "moName": "Киото аймаг",
      "buName": "ကျိုတို ပြည်နယ်",
      "khName": "ខេត្ដ ខ្យូតូ",
      "neName": "क्योतो जिल्ला"
    },
    "class10": {
      "code": "260010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "京都府南部",
      "zhName": "京都府南部",
      "koName": "교토 부 남부",
      "esName": "Sur de Prefectura de Kioto",
      "ptName": "Sul da Província de Kyōto",
      "thName": "จังหวัดเกียวโตตอนใต้",
      "viName": "Miền Nam tỉnh Kyoto",
      "inName": "Bagian Selatan Prefektur Kyoto",
      "tlName": "Timog na bahagi ng Kyoto Prefecture",
      "moName": "Өмнөд Киото аймаг",
      "buName": "ကျိုတိုစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃក្យូតុ",
      "neName": "क्योतो जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "260013",
      "name": "山城中部",
      "enName": "Central Yamashiro"
    },
    "class20": {
      "code": "2621100",
      "name": "京田辺市",
      "enName": "Kyotanabe City",
      "kana": "きょうたなべし",
      "chName": "京田边市",
      "zhName": "京田邊市",
      "koName": "교타나베 시",
      "esName": "Ciudad de Kyotanabe",
      "ptName": "cidade de Kyotanabe",
      "thName": "เมืองเคียวตะนาเบะ",
      "viName": "thành phố Kyotanabe",
      "inName": "kota Kyotanabe",
      "tlName": "siyudad ng Kyotanabe",
      "moName": "Киотанaбэ хот",
      "buName": "ချိုတာနားဘဲ့ မြို့",
      "khName": "ទីក្រុង ឃីយ៉ូថាណូបេ",
      "neName": "क्योतानाबे सहर"
    }
  },
  "2621200": {
    "office": {
      "code": "260000",
      "name": "京都府",
      "enName": "Kyoto",
      "officeName": "京都地方気象台",
      "chName": "京都府",
      "zhName": "京都府",
      "koName": "교토부",
      "esName": "Prefectura de Kioto",
      "ptName": "Província de Kyōto",
      "thName": "จังหวัดเกียวโต",
      "viName": "Tỉnh Kyoto",
      "inName": "Prefektur Kyoto",
      "tlName": "Kyoto Prefecture",
      "moName": "Киото аймаг",
      "buName": "ကျိုတို ပြည်နယ်",
      "khName": "ខេត្ដ ខ្យូតូ",
      "neName": "क्योतो जिल्ला"
    },
    "class10": {
      "code": "260020",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "京都府北部",
      "zhName": "京都府北部",
      "koName": "교토 부 북부",
      "esName": "Norte de Prefectura de Kioto",
      "ptName": "Norte da Província de Kyōto",
      "thName": "จังหวัดเกียวโตตอนเหนือ",
      "viName": "Miền Bắc tỉnh Kyoto",
      "inName": "Bagian Utara Prefektur Kyoto",
      "tlName": "Hilagang bahagi ng Kyoto Prefecture",
      "moName": "Хойд Киото аймаг",
      "buName": "ကျိုတိုစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃក្យូតុ",
      "neName": "क्योतो जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "260021",
      "name": "丹後",
      "enName": "Tango"
    },
    "class20": {
      "code": "2621200",
      "name": "京丹後市",
      "enName": "Kyotango City",
      "kana": "きょうたんごし",
      "chName": "京丹后市",
      "zhName": "京丹後市",
      "koName": "교탄고 시",
      "esName": "Ciudad de Kyotango",
      "ptName": "cidade de Kyotango",
      "thName": "เมืองเคียวทังโงะ",
      "viName": "thành phố Kyotango",
      "inName": "kota Kyotango",
      "tlName": "siyudad ng Kyotango",
      "moName": "Киотанго хот",
      "buName": "ကျိုတန်ဂို မြို့",
      "khName": "ទីក្រុង ឃីយ៉ូថេងហ្គូ",
      "neName": "क्योताङ्गो सहर"
    }
  },
  "2621300": {
    "office": {
      "code": "260000",
      "name": "京都府",
      "enName": "Kyoto",
      "officeName": "京都地方気象台",
      "chName": "京都府",
      "zhName": "京都府",
      "koName": "교토부",
      "esName": "Prefectura de Kioto",
      "ptName": "Província de Kyōto",
      "thName": "จังหวัดเกียวโต",
      "viName": "Tỉnh Kyoto",
      "inName": "Prefektur Kyoto",
      "tlName": "Kyoto Prefecture",
      "moName": "Киото аймаг",
      "buName": "ကျိုတို ပြည်နယ်",
      "khName": "ខេត្ដ ខ្យូតូ",
      "neName": "क्योतो जिल्ला"
    },
    "class10": {
      "code": "260010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "京都府南部",
      "zhName": "京都府南部",
      "koName": "교토 부 남부",
      "esName": "Sur de Prefectura de Kioto",
      "ptName": "Sul da Província de Kyōto",
      "thName": "จังหวัดเกียวโตตอนใต้",
      "viName": "Miền Nam tỉnh Kyoto",
      "inName": "Bagian Selatan Prefektur Kyoto",
      "tlName": "Timog na bahagi ng Kyoto Prefecture",
      "moName": "Өмнөд Киото аймаг",
      "buName": "ကျိုတိုစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃក្យូតុ",
      "neName": "क्योतो जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "260012",
      "name": "南丹・京丹波",
      "enName": "Nantan Kyotamba"
    },
    "class20": {
      "code": "2621300",
      "name": "南丹市",
      "enName": "Nantan City",
      "kana": "なんたんし",
      "chName": "南丹市",
      "zhName": "南丹市",
      "koName": "난탄 시",
      "esName": "Ciudad de Nantan",
      "ptName": "cidade de Nantan",
      "thName": "เมืองนันตัน",
      "viName": "thành phố Nantan",
      "inName": "kota Nantan",
      "tlName": "siyudad ng Nantan",
      "moName": "Нaнтан хот",
      "buName": "နန့်တန် မြို့",
      "khName": "ទីក្រុង ណានតាន",
      "neName": "नान्तान सहर"
    }
  },
  "2621400": {
    "office": {
      "code": "260000",
      "name": "京都府",
      "enName": "Kyoto",
      "officeName": "京都地方気象台",
      "chName": "京都府",
      "zhName": "京都府",
      "koName": "교토부",
      "esName": "Prefectura de Kioto",
      "ptName": "Província de Kyōto",
      "thName": "จังหวัดเกียวโต",
      "viName": "Tỉnh Kyoto",
      "inName": "Prefektur Kyoto",
      "tlName": "Kyoto Prefecture",
      "moName": "Киото аймаг",
      "buName": "ကျိုတို ပြည်နယ်",
      "khName": "ខេត្ដ ខ្យូតូ",
      "neName": "क्योतो जिल्ला"
    },
    "class10": {
      "code": "260010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "京都府南部",
      "zhName": "京都府南部",
      "koName": "교토 부 남부",
      "esName": "Sur de Prefectura de Kioto",
      "ptName": "Sul da Província de Kyōto",
      "thName": "จังหวัดเกียวโตตอนใต้",
      "viName": "Miền Nam tỉnh Kyoto",
      "inName": "Bagian Selatan Prefektur Kyoto",
      "tlName": "Timog na bahagi ng Kyoto Prefecture",
      "moName": "Өмнөд Киото аймаг",
      "buName": "ကျိုတိုစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃក្យូតុ",
      "neName": "क्योतो जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "260014",
      "name": "山城南部",
      "enName": "Southern Yamashiro"
    },
    "class20": {
      "code": "2621400",
      "name": "木津川市",
      "enName": "Kizugawa City",
      "kana": "きづがわし",
      "chName": "木津川市",
      "zhName": "木津川市",
      "koName": "기즈가와 시",
      "esName": "Ciudad de Kizugawa",
      "ptName": "cidade de Kizugawa",
      "thName": "เมืองคิสุกาวา",
      "viName": "thành phố Kizugawa",
      "inName": "kota Kizugawa",
      "tlName": "siyudad ng Kizugawa",
      "moName": "Кизүгава хот",
      "buName": "ခီဇုဂါ့ဝ မြို့",
      "khName": "ទីក្រុង គីហ្សូហ្គាវ៉ា",
      "neName": "किजुगावा सहर"
    }
  },
  "2630300": {
    "office": {
      "code": "260000",
      "name": "京都府",
      "enName": "Kyoto",
      "officeName": "京都地方気象台",
      "chName": "京都府",
      "zhName": "京都府",
      "koName": "교토부",
      "esName": "Prefectura de Kioto",
      "ptName": "Província de Kyōto",
      "thName": "จังหวัดเกียวโต",
      "viName": "Tỉnh Kyoto",
      "inName": "Prefektur Kyoto",
      "tlName": "Kyoto Prefecture",
      "moName": "Киото аймаг",
      "buName": "ကျိုတို ပြည်နယ်",
      "khName": "ខេត្ដ ខ្យូតូ",
      "neName": "क्योतो जिल्ला"
    },
    "class10": {
      "code": "260010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "京都府南部",
      "zhName": "京都府南部",
      "koName": "교토 부 남부",
      "esName": "Sur de Prefectura de Kioto",
      "ptName": "Sul da Província de Kyōto",
      "thName": "จังหวัดเกียวโตตอนใต้",
      "viName": "Miền Nam tỉnh Kyoto",
      "inName": "Bagian Selatan Prefektur Kyoto",
      "tlName": "Timog na bahagi ng Kyoto Prefecture",
      "moName": "Өмнөд Киото аймаг",
      "buName": "ကျိုတိုစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃក្យូតុ",
      "neName": "क्योतो जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "260011",
      "name": "京都・亀岡",
      "enName": "Kyoto Kameoka"
    },
    "class20": {
      "code": "2630300",
      "name": "大山崎町",
      "enName": "Oyamazaki Town",
      "kana": "おおやまざきちょう",
      "chName": "大山崎町",
      "zhName": "大山崎町",
      "koName": "오야마자키 정",
      "esName": "Pueblo de Ōyamazaki",
      "ptName": "bairro de Oyamazaki",
      "thName": "เมืองโอยามะซากิ",
      "viName": "thị trấn Oyamazaki",
      "inName": "kota Oyamazaki",
      "tlName": "bayan ng Oyamazaki",
      "moName": "Оямaзaки жижиг хот",
      "buName": "အိုယာမားဇာ့ကိ မြို့နယ်",
      "khName": "ទីប្រជុំជន អូយ៉ាម៉ាសាគី",
      "neName": "ओयामाजाकी नगर"
    }
  },
  "2632200": {
    "office": {
      "code": "260000",
      "name": "京都府",
      "enName": "Kyoto",
      "officeName": "京都地方気象台",
      "chName": "京都府",
      "zhName": "京都府",
      "koName": "교토부",
      "esName": "Prefectura de Kioto",
      "ptName": "Província de Kyōto",
      "thName": "จังหวัดเกียวโต",
      "viName": "Tỉnh Kyoto",
      "inName": "Prefektur Kyoto",
      "tlName": "Kyoto Prefecture",
      "moName": "Киото аймаг",
      "buName": "ကျိုတို ပြည်နယ်",
      "khName": "ខេត្ដ ខ្យូតូ",
      "neName": "क्योतो जिल्ला"
    },
    "class10": {
      "code": "260010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "京都府南部",
      "zhName": "京都府南部",
      "koName": "교토 부 남부",
      "esName": "Sur de Prefectura de Kioto",
      "ptName": "Sul da Província de Kyōto",
      "thName": "จังหวัดเกียวโตตอนใต้",
      "viName": "Miền Nam tỉnh Kyoto",
      "inName": "Bagian Selatan Prefektur Kyoto",
      "tlName": "Timog na bahagi ng Kyoto Prefecture",
      "moName": "Өмнөд Киото аймаг",
      "buName": "ကျိုတိုစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃក្យូតុ",
      "neName": "क्योतो जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "260013",
      "name": "山城中部",
      "enName": "Central Yamashiro"
    },
    "class20": {
      "code": "2632200",
      "name": "久御山町",
      "enName": "Kumiyama Town",
      "kana": "くみやまちょう",
      "chName": "久御山町",
      "zhName": "久御山町",
      "koName": "구미야마 정",
      "esName": "Pueblo de Kumiyama",
      "ptName": "bairro de Kumiyama",
      "thName": "เมืองคุมิยามะ",
      "viName": "thị trấn Kumiyama",
      "inName": "kota Kumiyama",
      "tlName": "bayan ng Kumiyama",
      "moName": "Күмиямa жижиг хот",
      "buName": "ခူမိယာ့မ မြို့နယ်",
      "khName": "ទីប្រជុំជន គូមីយ៉ាម៉ា",
      "neName": "कुमियामा नगर"
    }
  },
  "2634300": {
    "office": {
      "code": "260000",
      "name": "京都府",
      "enName": "Kyoto",
      "officeName": "京都地方気象台",
      "chName": "京都府",
      "zhName": "京都府",
      "koName": "교토부",
      "esName": "Prefectura de Kioto",
      "ptName": "Província de Kyōto",
      "thName": "จังหวัดเกียวโต",
      "viName": "Tỉnh Kyoto",
      "inName": "Prefektur Kyoto",
      "tlName": "Kyoto Prefecture",
      "moName": "Киото аймаг",
      "buName": "ကျိုတို ပြည်နယ်",
      "khName": "ខេត្ដ ខ្យូតូ",
      "neName": "क्योतो जिल्ला"
    },
    "class10": {
      "code": "260010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "京都府南部",
      "zhName": "京都府南部",
      "koName": "교토 부 남부",
      "esName": "Sur de Prefectura de Kioto",
      "ptName": "Sul da Província de Kyōto",
      "thName": "จังหวัดเกียวโตตอนใต้",
      "viName": "Miền Nam tỉnh Kyoto",
      "inName": "Bagian Selatan Prefektur Kyoto",
      "tlName": "Timog na bahagi ng Kyoto Prefecture",
      "moName": "Өмнөд Киото аймаг",
      "buName": "ကျိုတိုစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃក្យូតុ",
      "neName": "क्योतो जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "260013",
      "name": "山城中部",
      "enName": "Central Yamashiro"
    },
    "class20": {
      "code": "2634300",
      "name": "井手町",
      "enName": "Ide Town",
      "kana": "いでちょう",
      "chName": "井手町",
      "zhName": "井手町",
      "koName": "이데 정",
      "esName": "Pueblo de Ide",
      "ptName": "bairro de Ide",
      "thName": "เมืองอิเดะ",
      "viName": "thị trấn Ide",
      "inName": "kota Ide",
      "tlName": "bayan ng Ide",
      "moName": "Идэ жижиг хот",
      "buName": "အိဒဲ့ မြို့နယ်",
      "khName": "ទីប្រជុំជន អ៊ីដេ",
      "neName": "इदे नगर"
    }
  },
  "2634400": {
    "office": {
      "code": "260000",
      "name": "京都府",
      "enName": "Kyoto",
      "officeName": "京都地方気象台",
      "chName": "京都府",
      "zhName": "京都府",
      "koName": "교토부",
      "esName": "Prefectura de Kioto",
      "ptName": "Província de Kyōto",
      "thName": "จังหวัดเกียวโต",
      "viName": "Tỉnh Kyoto",
      "inName": "Prefektur Kyoto",
      "tlName": "Kyoto Prefecture",
      "moName": "Киото аймаг",
      "buName": "ကျိုတို ပြည်နယ်",
      "khName": "ខេត្ដ ខ្យូតូ",
      "neName": "क्योतो जिल्ला"
    },
    "class10": {
      "code": "260010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "京都府南部",
      "zhName": "京都府南部",
      "koName": "교토 부 남부",
      "esName": "Sur de Prefectura de Kioto",
      "ptName": "Sul da Província de Kyōto",
      "thName": "จังหวัดเกียวโตตอนใต้",
      "viName": "Miền Nam tỉnh Kyoto",
      "inName": "Bagian Selatan Prefektur Kyoto",
      "tlName": "Timog na bahagi ng Kyoto Prefecture",
      "moName": "Өмнөд Киото аймаг",
      "buName": "ကျိုတိုစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃក្យូតុ",
      "neName": "क्योतो जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "260013",
      "name": "山城中部",
      "enName": "Central Yamashiro"
    },
    "class20": {
      "code": "2634400",
      "name": "宇治田原町",
      "enName": "Ujitawara Town",
      "kana": "うじたわらちょう",
      "chName": "宇治田原町",
      "zhName": "宇治田原町",
      "koName": "우지타와라 정",
      "esName": "Pueblo de Ujitawara",
      "ptName": "bairro de Ujitawara",
      "thName": "เมืองอุจิตาวาระ",
      "viName": "thị trấn Ujitawara",
      "inName": "kota Ujitawara",
      "tlName": "bayan ng Ujitawara",
      "moName": "Үжитавара жижиг хот",
      "buName": "ဥဂျိတားဝါရာ့ မြို့နယ်",
      "khName": "ទីប្រជុំជន យូជីតាវ៉ារ៉ា",
      "neName": "उजितावारा नगर"
    }
  },
  "2636400": {
    "office": {
      "code": "260000",
      "name": "京都府",
      "enName": "Kyoto",
      "officeName": "京都地方気象台",
      "chName": "京都府",
      "zhName": "京都府",
      "koName": "교토부",
      "esName": "Prefectura de Kioto",
      "ptName": "Província de Kyōto",
      "thName": "จังหวัดเกียวโต",
      "viName": "Tỉnh Kyoto",
      "inName": "Prefektur Kyoto",
      "tlName": "Kyoto Prefecture",
      "moName": "Киото аймаг",
      "buName": "ကျိုတို ပြည်နယ်",
      "khName": "ខេត្ដ ខ្យូតូ",
      "neName": "क्योतो जिल्ला"
    },
    "class10": {
      "code": "260010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "京都府南部",
      "zhName": "京都府南部",
      "koName": "교토 부 남부",
      "esName": "Sur de Prefectura de Kioto",
      "ptName": "Sul da Província de Kyōto",
      "thName": "จังหวัดเกียวโตตอนใต้",
      "viName": "Miền Nam tỉnh Kyoto",
      "inName": "Bagian Selatan Prefektur Kyoto",
      "tlName": "Timog na bahagi ng Kyoto Prefecture",
      "moName": "Өмнөд Киото аймаг",
      "buName": "ကျိုတိုစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃក្យូតុ",
      "neName": "क्योतो जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "260014",
      "name": "山城南部",
      "enName": "Southern Yamashiro"
    },
    "class20": {
      "code": "2636400",
      "name": "笠置町",
      "enName": "Kasagi Town",
      "kana": "かさぎちょう",
      "chName": "笠置町",
      "zhName": "笠置町",
      "koName": "가사기 정",
      "esName": "Pueblo de Kasagi",
      "ptName": "bairro de Kasagi",
      "thName": "เมืองคาซางิ",
      "viName": "thị trấn Kasagi",
      "inName": "kota Kasagi",
      "tlName": "bayan ng Kasagi",
      "moName": "Касaги жижиг хот",
      "buName": "ခါဆာ့ဂိ မြို့နယ်",
      "khName": "ទីប្រជុំជន កាសាគី",
      "neName": "कासागी नगर"
    }
  },
  "2636500": {
    "office": {
      "code": "260000",
      "name": "京都府",
      "enName": "Kyoto",
      "officeName": "京都地方気象台",
      "chName": "京都府",
      "zhName": "京都府",
      "koName": "교토부",
      "esName": "Prefectura de Kioto",
      "ptName": "Província de Kyōto",
      "thName": "จังหวัดเกียวโต",
      "viName": "Tỉnh Kyoto",
      "inName": "Prefektur Kyoto",
      "tlName": "Kyoto Prefecture",
      "moName": "Киото аймаг",
      "buName": "ကျိုတို ပြည်နယ်",
      "khName": "ខេត្ដ ខ្យូតូ",
      "neName": "क्योतो जिल्ला"
    },
    "class10": {
      "code": "260010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "京都府南部",
      "zhName": "京都府南部",
      "koName": "교토 부 남부",
      "esName": "Sur de Prefectura de Kioto",
      "ptName": "Sul da Província de Kyōto",
      "thName": "จังหวัดเกียวโตตอนใต้",
      "viName": "Miền Nam tỉnh Kyoto",
      "inName": "Bagian Selatan Prefektur Kyoto",
      "tlName": "Timog na bahagi ng Kyoto Prefecture",
      "moName": "Өмнөд Киото аймаг",
      "buName": "ကျိုတိုစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃក្យូតុ",
      "neName": "क्योतो जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "260014",
      "name": "山城南部",
      "enName": "Southern Yamashiro"
    },
    "class20": {
      "code": "2636500",
      "name": "和束町",
      "enName": "Wazuka Town",
      "kana": "わづかちょう",
      "chName": "和束町",
      "zhName": "和束町",
      "koName": "와즈카 정",
      "esName": "Pueblo de Wazuka",
      "ptName": "bairro de Wazuka",
      "thName": "เมืองวาซุกะ",
      "viName": "thị trấn Wazuka",
      "inName": "kota Wazuka",
      "tlName": "bayan ng Wazuka",
      "moName": "Вазүка жижиг хот",
      "buName": "ဝါဇုက မြို့နယ်",
      "khName": "ទីប្រជុំជន វ៉ាហ្សូកា",
      "neName": "वाजुका नगर"
    }
  },
  "2636600": {
    "office": {
      "code": "260000",
      "name": "京都府",
      "enName": "Kyoto",
      "officeName": "京都地方気象台",
      "chName": "京都府",
      "zhName": "京都府",
      "koName": "교토부",
      "esName": "Prefectura de Kioto",
      "ptName": "Província de Kyōto",
      "thName": "จังหวัดเกียวโต",
      "viName": "Tỉnh Kyoto",
      "inName": "Prefektur Kyoto",
      "tlName": "Kyoto Prefecture",
      "moName": "Киото аймаг",
      "buName": "ကျိုတို ပြည်နယ်",
      "khName": "ខេត្ដ ខ្យូតូ",
      "neName": "क्योतो जिल्ला"
    },
    "class10": {
      "code": "260010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "京都府南部",
      "zhName": "京都府南部",
      "koName": "교토 부 남부",
      "esName": "Sur de Prefectura de Kioto",
      "ptName": "Sul da Província de Kyōto",
      "thName": "จังหวัดเกียวโตตอนใต้",
      "viName": "Miền Nam tỉnh Kyoto",
      "inName": "Bagian Selatan Prefektur Kyoto",
      "tlName": "Timog na bahagi ng Kyoto Prefecture",
      "moName": "Өмнөд Киото аймаг",
      "buName": "ကျိုတိုစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃក្យូតុ",
      "neName": "क्योतो जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "260014",
      "name": "山城南部",
      "enName": "Southern Yamashiro"
    },
    "class20": {
      "code": "2636600",
      "name": "精華町",
      "enName": "Seika Town",
      "kana": "せいかちょう",
      "chName": "精华町",
      "zhName": "精華町",
      "koName": "세이카 정",
      "esName": "Pueblo de Seika",
      "ptName": "bairro de Seika",
      "thName": "เมืองเซกะ",
      "viName": "thị trấn Seika",
      "inName": "kota Seika",
      "tlName": "bayan ng Seika",
      "moName": "Сэйка жижиг хот",
      "buName": "ဆဲက မြို့နယ်",
      "khName": "ទីប្រជុំជន សៃកា",
      "neName": "सेइका नगर"
    }
  },
  "2636700": {
    "office": {
      "code": "260000",
      "name": "京都府",
      "enName": "Kyoto",
      "officeName": "京都地方気象台",
      "chName": "京都府",
      "zhName": "京都府",
      "koName": "교토부",
      "esName": "Prefectura de Kioto",
      "ptName": "Província de Kyōto",
      "thName": "จังหวัดเกียวโต",
      "viName": "Tỉnh Kyoto",
      "inName": "Prefektur Kyoto",
      "tlName": "Kyoto Prefecture",
      "moName": "Киото аймаг",
      "buName": "ကျိုတို ပြည်နယ်",
      "khName": "ខេត្ដ ខ្យូតូ",
      "neName": "क्योतो जिल्ला"
    },
    "class10": {
      "code": "260010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "京都府南部",
      "zhName": "京都府南部",
      "koName": "교토 부 남부",
      "esName": "Sur de Prefectura de Kioto",
      "ptName": "Sul da Província de Kyōto",
      "thName": "จังหวัดเกียวโตตอนใต้",
      "viName": "Miền Nam tỉnh Kyoto",
      "inName": "Bagian Selatan Prefektur Kyoto",
      "tlName": "Timog na bahagi ng Kyoto Prefecture",
      "moName": "Өмнөд Киото аймаг",
      "buName": "ကျိုတိုစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃក្យូតុ",
      "neName": "क्योतो जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "260014",
      "name": "山城南部",
      "enName": "Southern Yamashiro"
    },
    "class20": {
      "code": "2636700",
      "name": "南山城村",
      "enName": "Minamiyamashiro Village",
      "kana": "みなみやましろむら",
      "chName": "南山城村",
      "zhName": "南山城村",
      "koName": "미나미야마시로 촌",
      "esName": "Aldea de Minami-yamashiro",
      "ptName": "povoado de Minamiyamashiro",
      "thName": "หมู่บ้านมินามิยามาชิโระ",
      "viName": "làng Minamiyamashiro",
      "inName": "desa Minamiyamashiro",
      "tlName": "nayon ng Minamiyamashiro",
      "moName": "Минaмиямaширо тосгон",
      "buName": "မီနာမိယားမာ့ရှိရို ကျေးရွာ",
      "khName": "ភូមិ មីណាមីយ៉ាម៉ាស៊ីរ៉ូ",
      "neName": "मिनामियामाशिरो गाउँ"
    }
  },
  "2640700": {
    "office": {
      "code": "260000",
      "name": "京都府",
      "enName": "Kyoto",
      "officeName": "京都地方気象台",
      "chName": "京都府",
      "zhName": "京都府",
      "koName": "교토부",
      "esName": "Prefectura de Kioto",
      "ptName": "Província de Kyōto",
      "thName": "จังหวัดเกียวโต",
      "viName": "Tỉnh Kyoto",
      "inName": "Prefektur Kyoto",
      "tlName": "Kyoto Prefecture",
      "moName": "Киото аймаг",
      "buName": "ကျိုတို ပြည်နယ်",
      "khName": "ខេត្ដ ខ្យូតូ",
      "neName": "क्योतो जिल्ला"
    },
    "class10": {
      "code": "260010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "京都府南部",
      "zhName": "京都府南部",
      "koName": "교토 부 남부",
      "esName": "Sur de Prefectura de Kioto",
      "ptName": "Sul da Província de Kyōto",
      "thName": "จังหวัดเกียวโตตอนใต้",
      "viName": "Miền Nam tỉnh Kyoto",
      "inName": "Bagian Selatan Prefektur Kyoto",
      "tlName": "Timog na bahagi ng Kyoto Prefecture",
      "moName": "Өмнөд Киото аймаг",
      "buName": "ကျိုတိုစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃក្យូតុ",
      "neName": "क्योतो जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "260012",
      "name": "南丹・京丹波",
      "enName": "Nantan Kyotamba"
    },
    "class20": {
      "code": "2640700",
      "name": "京丹波町",
      "enName": "Kyotamba Town",
      "kana": "きょうたんばちょう",
      "chName": "京丹波町",
      "zhName": "京丹波町",
      "koName": "교탄바 정",
      "esName": "Pueblo de Kyotanba",
      "ptName": "bairro de Kyotamba",
      "thName": "เมืองเคียวทัมบะ",
      "viName": "thị trấn Kyotamba",
      "inName": "kota Kyotamba",
      "tlName": "bayan ng Kyotamba",
      "moName": "Киотамба жижиг хот",
      "buName": "ကျိုတန်းဗာ့ မြို့နယ်",
      "khName": "ទីប្រជុំជន ក្យូតាំបា",
      "neName": "क्योताम्बा नगर"
    }
  },
  "2646300": {
    "office": {
      "code": "260000",
      "name": "京都府",
      "enName": "Kyoto",
      "officeName": "京都地方気象台",
      "chName": "京都府",
      "zhName": "京都府",
      "koName": "교토부",
      "esName": "Prefectura de Kioto",
      "ptName": "Província de Kyōto",
      "thName": "จังหวัดเกียวโต",
      "viName": "Tỉnh Kyoto",
      "inName": "Prefektur Kyoto",
      "tlName": "Kyoto Prefecture",
      "moName": "Киото аймаг",
      "buName": "ကျိုတို ပြည်နယ်",
      "khName": "ខេត្ដ ខ្យូតូ",
      "neName": "क्योतो जिल्ला"
    },
    "class10": {
      "code": "260020",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "京都府北部",
      "zhName": "京都府北部",
      "koName": "교토 부 북부",
      "esName": "Norte de Prefectura de Kioto",
      "ptName": "Norte da Província de Kyōto",
      "thName": "จังหวัดเกียวโตตอนเหนือ",
      "viName": "Miền Bắc tỉnh Kyoto",
      "inName": "Bagian Utara Prefektur Kyoto",
      "tlName": "Hilagang bahagi ng Kyoto Prefecture",
      "moName": "Хойд Киото аймаг",
      "buName": "ကျိုတိုစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃក្យូតុ",
      "neName": "क्योतो जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "260021",
      "name": "丹後",
      "enName": "Tango"
    },
    "class20": {
      "code": "2646300",
      "name": "伊根町",
      "enName": "Ine Town",
      "kana": "いねちょう",
      "chName": "伊根町",
      "zhName": "伊根町",
      "koName": "이네 정",
      "esName": "Pueblo de Ine",
      "ptName": "bairro de Ine",
      "thName": "เมืองอิเนะ",
      "viName": "thị trấn Ine",
      "inName": "kota Ine",
      "tlName": "bayan ng Ine",
      "moName": "Инэ жижиг хот",
      "buName": "အိနဲ့ မြို့နယ်",
      "khName": "ទីប្រជុំជន អ៊ិន",
      "neName": "इने नगर"
    }
  },
  "2646500": {
    "office": {
      "code": "260000",
      "name": "京都府",
      "enName": "Kyoto",
      "officeName": "京都地方気象台",
      "chName": "京都府",
      "zhName": "京都府",
      "koName": "교토부",
      "esName": "Prefectura de Kioto",
      "ptName": "Província de Kyōto",
      "thName": "จังหวัดเกียวโต",
      "viName": "Tỉnh Kyoto",
      "inName": "Prefektur Kyoto",
      "tlName": "Kyoto Prefecture",
      "moName": "Киото аймаг",
      "buName": "ကျိုတို ပြည်နယ်",
      "khName": "ខេត្ដ ខ្យូតូ",
      "neName": "क्योतो जिल्ला"
    },
    "class10": {
      "code": "260020",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "京都府北部",
      "zhName": "京都府北部",
      "koName": "교토 부 북부",
      "esName": "Norte de Prefectura de Kioto",
      "ptName": "Norte da Província de Kyōto",
      "thName": "จังหวัดเกียวโตตอนเหนือ",
      "viName": "Miền Bắc tỉnh Kyoto",
      "inName": "Bagian Utara Prefektur Kyoto",
      "tlName": "Hilagang bahagi ng Kyoto Prefecture",
      "moName": "Хойд Киото аймаг",
      "buName": "ကျိုတိုစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃក្យូតុ",
      "neName": "क्योतो जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "260021",
      "name": "丹後",
      "enName": "Tango"
    },
    "class20": {
      "code": "2646500",
      "name": "与謝野町",
      "enName": "Yosano Town",
      "kana": "よさのちょう",
      "chName": "与谢野町",
      "zhName": "與謝野町",
      "koName": "요사노 정",
      "esName": "Pueblo de Yosano",
      "ptName": "bairro de Yosano",
      "thName": "เมืองโยซาโนะ",
      "viName": "thị trấn Yosano",
      "inName": "kota Yosano",
      "tlName": "bayan ng Yosano",
      "moName": "Ёсaно жижиг хот",
      "buName": "ယိုဆာနို မြို့နယ်",
      "khName": "ទីប្រជុំជន យ៉ូសាណូ",
      "neName": "योसानो नगर"
    }
  },
  "2710000": {
    "office": {
      "code": "270000",
      "name": "大阪府",
      "enName": "Osaka",
      "officeName": "大阪管区気象台",
      "chName": "大阪府",
      "zhName": "大阪府",
      "koName": "오사카부",
      "esName": "Prefectura de Osaka",
      "ptName": "Província de Ōsaka",
      "thName": "จังหวัดโอซากะ",
      "viName": "Tỉnh Osaka",
      "inName": "Prefektur Osaka",
      "tlName": "Osaka Prefecture",
      "moName": "Осака аймаг",
      "buName": "အိုးဆာ့က ပြည်နယ်",
      "khName": "ខេត្ដ អូសាកា",
      "neName": "ओसाका जिल्ला"
    },
    "class10": {
      "code": "270000",
      "name": "大阪府",
      "enName": "Osaka Prefecture",
      "chName": "大阪府",
      "zhName": "大阪府",
      "koName": "오사카부",
      "esName": "Prefectura de Osaka",
      "ptName": "Prefeitura de Osaka",
      "thName": "จังหวัดโอซาก้า",
      "viName": "tỉnh Osaka",
      "inName": "Prefektur Osaka",
      "tlName": "Osaka Prefecture",
      "moName": "Осака муж",
      "buName": "အိုဆာကာစီရင်စု",
      "khName": "ខេត្តអូសាកា",
      "neName": "ओसाका प्रिफेक्चर"
    },
    "class15": {
      "code": "270001",
      "name": "大阪市",
      "enName": "Osaka City"
    },
    "class20": {
      "code": "2710000",
      "name": "大阪市",
      "enName": "Osaka City",
      "kana": "おおさかし",
      "chName": "大阪市",
      "zhName": "大阪市",
      "koName": "오사카시",
      "esName": "Ciudad de Osaka",
      "ptName": "Cidade de Osaka",
      "thName": "เมืองโอซาก้า",
      "viName": "Thành phố Osaka",
      "inName": "Kota Osaka",
      "tlName": "Lungsod ng Osaka",
      "moName": "Cidade de Osaka",
      "buName": "အိုဆာကာမြို့",
      "khName": "ទីក្រុង Osaka",
      "neName": "ओसाका शहर"
    }
  },
  "2714000": {
    "office": {
      "code": "270000",
      "name": "大阪府",
      "enName": "Osaka",
      "officeName": "大阪管区気象台",
      "chName": "大阪府",
      "zhName": "大阪府",
      "koName": "오사카부",
      "esName": "Prefectura de Osaka",
      "ptName": "Província de Ōsaka",
      "thName": "จังหวัดโอซากะ",
      "viName": "Tỉnh Osaka",
      "inName": "Prefektur Osaka",
      "tlName": "Osaka Prefecture",
      "moName": "Осака аймаг",
      "buName": "အိုးဆာ့က ပြည်နယ်",
      "khName": "ខេត្ដ អូសាកា",
      "neName": "ओसाका जिल्ला"
    },
    "class10": {
      "code": "270000",
      "name": "大阪府",
      "enName": "Osaka Prefecture",
      "chName": "大阪府",
      "zhName": "大阪府",
      "koName": "오사카부",
      "esName": "Prefectura de Osaka",
      "ptName": "Prefeitura de Osaka",
      "thName": "จังหวัดโอซาก้า",
      "viName": "tỉnh Osaka",
      "inName": "Prefektur Osaka",
      "tlName": "Osaka Prefecture",
      "moName": "Осака муж",
      "buName": "အိုဆာကာစီရင်စု",
      "khName": "ខេត្តអូសាកា",
      "neName": "ओसाका प्रिफेक्चर"
    },
    "class15": {
      "code": "270005",
      "name": "泉州",
      "enName": "Senshu"
    },
    "class20": {
      "code": "2714000",
      "name": "堺市",
      "enName": "Sakai City",
      "kana": "さかいし",
      "chName": "堺市",
      "zhName": "堺市",
      "koName": "사카이시",
      "esName": "Ciudad de Sakai",
      "ptName": "Cidade de Sakai",
      "thName": "เมืองซากาอิ",
      "viName": "Thành phố Sakai",
      "inName": "Kota Sakai",
      "tlName": "Lungsod ng Sakai",
      "moName": "Cidade de Sakai",
      "buName": "စကိုင်မြို့",
      "khName": "ខេត្តសាកាយ",
      "neName": "सकाई सिटी"
    }
  },
  "2720200": {
    "office": {
      "code": "270000",
      "name": "大阪府",
      "enName": "Osaka",
      "officeName": "大阪管区気象台",
      "chName": "大阪府",
      "zhName": "大阪府",
      "koName": "오사카부",
      "esName": "Prefectura de Osaka",
      "ptName": "Província de Ōsaka",
      "thName": "จังหวัดโอซากะ",
      "viName": "Tỉnh Osaka",
      "inName": "Prefektur Osaka",
      "tlName": "Osaka Prefecture",
      "moName": "Осака аймаг",
      "buName": "အိုးဆာ့က ပြည်နယ်",
      "khName": "ខេត្ដ អូសាកា",
      "neName": "ओसाका जिल्ला"
    },
    "class10": {
      "code": "270000",
      "name": "大阪府",
      "enName": "Osaka Prefecture",
      "chName": "大阪府",
      "zhName": "大阪府",
      "koName": "오사카부",
      "esName": "Prefectura de Osaka",
      "ptName": "Prefeitura de Osaka",
      "thName": "จังหวัดโอซาก้า",
      "viName": "tỉnh Osaka",
      "inName": "Prefektur Osaka",
      "tlName": "Osaka Prefecture",
      "moName": "Осака муж",
      "buName": "အိုဆာကာစီရင်စု",
      "khName": "ខេត្តអូសាកា",
      "neName": "ओसाका प्रिफेक्चर"
    },
    "class15": {
      "code": "270005",
      "name": "泉州",
      "enName": "Senshu"
    },
    "class20": {
      "code": "2720200",
      "name": "岸和田市",
      "enName": "Kishiwada City",
      "kana": "きしわだし",
      "chName": "岸和田市",
      "zhName": "岸和田市",
      "koName": "기시와다 시",
      "esName": "Ciudad de Kishiwada",
      "ptName": "cidade de Kishiwada",
      "thName": "เมืองคิชิวาดะ",
      "viName": "thành phố Kishiwada",
      "inName": "kota Kishiwada",
      "tlName": "siyudad ng Kishiwada",
      "moName": "Кишивада хот",
      "buName": "ကီရှိဝါ့ဒ မြို့",
      "khName": "ទីក្រុង គីស៊ីវ៉ាដា",
      "neName": "किशिवाडा सहर"
    }
  },
  "2720300": {
    "office": {
      "code": "270000",
      "name": "大阪府",
      "enName": "Osaka",
      "officeName": "大阪管区気象台",
      "chName": "大阪府",
      "zhName": "大阪府",
      "koName": "오사카부",
      "esName": "Prefectura de Osaka",
      "ptName": "Província de Ōsaka",
      "thName": "จังหวัดโอซากะ",
      "viName": "Tỉnh Osaka",
      "inName": "Prefektur Osaka",
      "tlName": "Osaka Prefecture",
      "moName": "Осака аймаг",
      "buName": "အိုးဆာ့က ပြည်နယ်",
      "khName": "ខេត្ដ អូសាកា",
      "neName": "ओसाका जिल्ला"
    },
    "class10": {
      "code": "270000",
      "name": "大阪府",
      "enName": "Osaka Prefecture",
      "chName": "大阪府",
      "zhName": "大阪府",
      "koName": "오사카부",
      "esName": "Prefectura de Osaka",
      "ptName": "Prefeitura de Osaka",
      "thName": "จังหวัดโอซาก้า",
      "viName": "tỉnh Osaka",
      "inName": "Prefektur Osaka",
      "tlName": "Osaka Prefecture",
      "moName": "Осака муж",
      "buName": "အိုဆာကာစီရင်စု",
      "khName": "ខេត្តអូសាកា",
      "neName": "ओसाका प्रिफेक्चर"
    },
    "class15": {
      "code": "270002",
      "name": "北大阪",
      "enName": "Kita-osaka"
    },
    "class20": {
      "code": "2720300",
      "name": "豊中市",
      "enName": "Toyonaka City",
      "kana": "とよなかし",
      "chName": "丰中市",
      "zhName": "豐中市",
      "koName": "도요나카 시",
      "esName": "Ciudad de Toyonaka",
      "ptName": "cidade de Toyonaka",
      "thName": "เมืองโทโยนากะ",
      "viName": "thành phố Toyonaka",
      "inName": "kota Toyonaka",
      "tlName": "siyudad ng Toyonaka",
      "moName": "Тоёонaка хот",
      "buName": "တိုယိုးနာ့က မြို့",
      "khName": "ទីក្រុង តូយ៉ូណាកា",
      "neName": "तोयोनाका सहर"
    }
  },
  "2720400": {
    "office": {
      "code": "270000",
      "name": "大阪府",
      "enName": "Osaka",
      "officeName": "大阪管区気象台",
      "chName": "大阪府",
      "zhName": "大阪府",
      "koName": "오사카부",
      "esName": "Prefectura de Osaka",
      "ptName": "Província de Ōsaka",
      "thName": "จังหวัดโอซากะ",
      "viName": "Tỉnh Osaka",
      "inName": "Prefektur Osaka",
      "tlName": "Osaka Prefecture",
      "moName": "Осака аймаг",
      "buName": "အိုးဆာ့က ပြည်နယ်",
      "khName": "ខេត្ដ អូសាកា",
      "neName": "ओसाका जिल्ला"
    },
    "class10": {
      "code": "270000",
      "name": "大阪府",
      "enName": "Osaka Prefecture",
      "chName": "大阪府",
      "zhName": "大阪府",
      "koName": "오사카부",
      "esName": "Prefectura de Osaka",
      "ptName": "Prefeitura de Osaka",
      "thName": "จังหวัดโอซาก้า",
      "viName": "tỉnh Osaka",
      "inName": "Prefektur Osaka",
      "tlName": "Osaka Prefecture",
      "moName": "Осака муж",
      "buName": "အိုဆာကာစီရင်စု",
      "khName": "ខេត្តអូសាកា",
      "neName": "ओसाका प्रिफेक्चर"
    },
    "class15": {
      "code": "270002",
      "name": "北大阪",
      "enName": "Kita-osaka"
    },
    "class20": {
      "code": "2720400",
      "name": "池田市",
      "enName": "Ikeda City",
      "kana": "いけだし",
      "chName": "池田市",
      "zhName": "池田市",
      "koName": "이케다 시",
      "esName": "Ciudad de Ikeda",
      "ptName": "cidade de Ikeda",
      "thName": "เมืองอิเคดะ",
      "viName": "thành phố Ikeda",
      "inName": "kota Ikeda",
      "tlName": "siyudad ng Ikeda",
      "moName": "Икэда хот",
      "buName": "အီကေးဒ မြို့",
      "khName": "ទីក្រុង អាយខីដា",
      "neName": "इकेदा सहर"
    }
  },
  "2720500": {
    "office": {
      "code": "270000",
      "name": "大阪府",
      "enName": "Osaka",
      "officeName": "大阪管区気象台",
      "chName": "大阪府",
      "zhName": "大阪府",
      "koName": "오사카부",
      "esName": "Prefectura de Osaka",
      "ptName": "Província de Ōsaka",
      "thName": "จังหวัดโอซากะ",
      "viName": "Tỉnh Osaka",
      "inName": "Prefektur Osaka",
      "tlName": "Osaka Prefecture",
      "moName": "Осака аймаг",
      "buName": "အိုးဆာ့က ပြည်နယ်",
      "khName": "ខេត្ដ អូសាកា",
      "neName": "ओसाका जिल्ला"
    },
    "class10": {
      "code": "270000",
      "name": "大阪府",
      "enName": "Osaka Prefecture",
      "chName": "大阪府",
      "zhName": "大阪府",
      "koName": "오사카부",
      "esName": "Prefectura de Osaka",
      "ptName": "Prefeitura de Osaka",
      "thName": "จังหวัดโอซาก้า",
      "viName": "tỉnh Osaka",
      "inName": "Prefektur Osaka",
      "tlName": "Osaka Prefecture",
      "moName": "Осака муж",
      "buName": "အိုဆာကာစီရင်စု",
      "khName": "ខេត្តអូសាកា",
      "neName": "ओसाका प्रिफेक्चर"
    },
    "class15": {
      "code": "270002",
      "name": "北大阪",
      "enName": "Kita-osaka"
    },
    "class20": {
      "code": "2720500",
      "name": "吹田市",
      "enName": "Suita City",
      "kana": "すいたし",
      "chName": "吹田市",
      "zhName": "吹田市",
      "koName": "스이타 시",
      "esName": "Ciudad de Suita",
      "ptName": "cidade de Suita",
      "thName": "เมืองซุยตะ",
      "viName": "thành phố Suita",
      "inName": "kota Suita",
      "tlName": "siyudad ng Suita",
      "moName": "Сүйта хот",
      "buName": "ဆုအိတ မြို့",
      "khName": "ទីក្រុង ស៊ូអ៊ីដា",
      "neName": "सुइता सहर"
    }
  },
  "2720600": {
    "office": {
      "code": "270000",
      "name": "大阪府",
      "enName": "Osaka",
      "officeName": "大阪管区気象台",
      "chName": "大阪府",
      "zhName": "大阪府",
      "koName": "오사카부",
      "esName": "Prefectura de Osaka",
      "ptName": "Província de Ōsaka",
      "thName": "จังหวัดโอซากะ",
      "viName": "Tỉnh Osaka",
      "inName": "Prefektur Osaka",
      "tlName": "Osaka Prefecture",
      "moName": "Осака аймаг",
      "buName": "အိုးဆာ့က ပြည်နယ်",
      "khName": "ខេត្ដ អូសាកា",
      "neName": "ओसाका जिल्ला"
    },
    "class10": {
      "code": "270000",
      "name": "大阪府",
      "enName": "Osaka Prefecture",
      "chName": "大阪府",
      "zhName": "大阪府",
      "koName": "오사카부",
      "esName": "Prefectura de Osaka",
      "ptName": "Prefeitura de Osaka",
      "thName": "จังหวัดโอซาก้า",
      "viName": "tỉnh Osaka",
      "inName": "Prefektur Osaka",
      "tlName": "Osaka Prefecture",
      "moName": "Осака муж",
      "buName": "အိုဆာကာစီရင်စု",
      "khName": "ខេត្តអូសាកា",
      "neName": "ओसाका प्रिफेक्चर"
    },
    "class15": {
      "code": "270005",
      "name": "泉州",
      "enName": "Senshu"
    },
    "class20": {
      "code": "2720600",
      "name": "泉大津市",
      "enName": "Izumiotsu City",
      "kana": "いずみおおつし",
      "chName": "泉大津市",
      "zhName": "泉大津市",
      "koName": "이즈미오쓰 시",
      "esName": "Ciudad de Izumiotsu",
      "ptName": "cidade de Izumiotsu",
      "thName": "เมืองอิสุมิโอทสี",
      "viName": "thành phố Izumiotsu",
      "inName": "kota Izumiotsu",
      "tlName": "siyudad ng Izumiotsu",
      "moName": "Изүмиоцү хот",
      "buName": "အီဇိုမီးယိုဆု မြို့",
      "khName": "ទីក្រុង អ៊ីហ្ស៊ូមីអូតស៊ូ",
      "neName": "इजुमियोत्सु सहर"
    }
  },
  "2720700": {
    "office": {
      "code": "270000",
      "name": "大阪府",
      "enName": "Osaka",
      "officeName": "大阪管区気象台",
      "chName": "大阪府",
      "zhName": "大阪府",
      "koName": "오사카부",
      "esName": "Prefectura de Osaka",
      "ptName": "Província de Ōsaka",
      "thName": "จังหวัดโอซากะ",
      "viName": "Tỉnh Osaka",
      "inName": "Prefektur Osaka",
      "tlName": "Osaka Prefecture",
      "moName": "Осака аймаг",
      "buName": "အိုးဆာ့က ပြည်နယ်",
      "khName": "ខេត្ដ អូសាកា",
      "neName": "ओसाका जिल्ला"
    },
    "class10": {
      "code": "270000",
      "name": "大阪府",
      "enName": "Osaka Prefecture",
      "chName": "大阪府",
      "zhName": "大阪府",
      "koName": "오사카부",
      "esName": "Prefectura de Osaka",
      "ptName": "Prefeitura de Osaka",
      "thName": "จังหวัดโอซาก้า",
      "viName": "tỉnh Osaka",
      "inName": "Prefektur Osaka",
      "tlName": "Osaka Prefecture",
      "moName": "Осака муж",
      "buName": "အိုဆာကာစီရင်စု",
      "khName": "ខេត្តអូសាកា",
      "neName": "ओसाका प्रिफेक्चर"
    },
    "class15": {
      "code": "270002",
      "name": "北大阪",
      "enName": "Kita-osaka"
    },
    "class20": {
      "code": "2720700",
      "name": "高槻市",
      "enName": "Takatsuki City",
      "kana": "たかつきし",
      "chName": "高槻市",
      "zhName": "髙槻市",
      "koName": "다카쓰키 시",
      "esName": "Ciudad de Takatsuki",
      "ptName": "cidade de Takatsuki",
      "thName": "เมืองทากาสึกิ",
      "viName": "thành phố Takatsuki",
      "inName": "kota Takatsuki",
      "tlName": "siyudad ng Takatsuki",
      "moName": "Такацүки хот",
      "buName": "တာကားဆုကိ မြို့",
      "khName": "ទីក្រុង តាកាស៊ុគី",
      "neName": "ताकात्सुकी सहर"
    }
  },
  "2720800": {
    "office": {
      "code": "270000",
      "name": "大阪府",
      "enName": "Osaka",
      "officeName": "大阪管区気象台",
      "chName": "大阪府",
      "zhName": "大阪府",
      "koName": "오사카부",
      "esName": "Prefectura de Osaka",
      "ptName": "Província de Ōsaka",
      "thName": "จังหวัดโอซากะ",
      "viName": "Tỉnh Osaka",
      "inName": "Prefektur Osaka",
      "tlName": "Osaka Prefecture",
      "moName": "Осака аймаг",
      "buName": "အိုးဆာ့က ပြည်နယ်",
      "khName": "ខេត្ដ អូសាកា",
      "neName": "ओसाका जिल्ला"
    },
    "class10": {
      "code": "270000",
      "name": "大阪府",
      "enName": "Osaka Prefecture",
      "chName": "大阪府",
      "zhName": "大阪府",
      "koName": "오사카부",
      "esName": "Prefectura de Osaka",
      "ptName": "Prefeitura de Osaka",
      "thName": "จังหวัดโอซาก้า",
      "viName": "tỉnh Osaka",
      "inName": "Prefektur Osaka",
      "tlName": "Osaka Prefecture",
      "moName": "Осака муж",
      "buName": "အိုဆာကာစီရင်စု",
      "khName": "ខេត្តអូសាកា",
      "neName": "ओसाका प्रिफेक्चर"
    },
    "class15": {
      "code": "270005",
      "name": "泉州",
      "enName": "Senshu"
    },
    "class20": {
      "code": "2720800",
      "name": "貝塚市",
      "enName": "Kaizuka City",
      "kana": "かいづかし",
      "chName": "贝冢市",
      "zhName": "貝塚市",
      "koName": "가이즈카 시",
      "esName": "Ciudad de Kaizuka",
      "ptName": "cidade de Kaizuka",
      "thName": "เมืองไคสุกะ",
      "viName": "thành phố Kaizuka",
      "inName": "kota Kaizuka",
      "tlName": "siyudad ng Kaizuka",
      "moName": "Кайзүка хот",
      "buName": "ခိုင်ယိဇုက မြို့",
      "khName": "ទីក្រុង កាយស៊ូហ្កា",
      "neName": "काइजुका सहर"
    }
  },
  "2720900": {
    "office": {
      "code": "270000",
      "name": "大阪府",
      "enName": "Osaka",
      "officeName": "大阪管区気象台",
      "chName": "大阪府",
      "zhName": "大阪府",
      "koName": "오사카부",
      "esName": "Prefectura de Osaka",
      "ptName": "Província de Ōsaka",
      "thName": "จังหวัดโอซากะ",
      "viName": "Tỉnh Osaka",
      "inName": "Prefektur Osaka",
      "tlName": "Osaka Prefecture",
      "moName": "Осака аймаг",
      "buName": "အိုးဆာ့က ပြည်နယ်",
      "khName": "ខេត្ដ អូសាកា",
      "neName": "ओसाका जिल्ला"
    },
    "class10": {
      "code": "270000",
      "name": "大阪府",
      "enName": "Osaka Prefecture",
      "chName": "大阪府",
      "zhName": "大阪府",
      "koName": "오사카부",
      "esName": "Prefectura de Osaka",
      "ptName": "Prefeitura de Osaka",
      "thName": "จังหวัดโอซาก้า",
      "viName": "tỉnh Osaka",
      "inName": "Prefektur Osaka",
      "tlName": "Osaka Prefecture",
      "moName": "Осака муж",
      "buName": "အိုဆာကာစီရင်စု",
      "khName": "ខេត្តអូសាកា",
      "neName": "ओसाका प्रिफेक्चर"
    },
    "class15": {
      "code": "270003",
      "name": "東部大阪",
      "enName": "Eastern Osaka"
    },
    "class20": {
      "code": "2720900",
      "name": "守口市",
      "enName": "Moriguchi City",
      "kana": "もりぐちし",
      "chName": "守口市",
      "zhName": "守口市",
      "koName": "모리구치 시",
      "esName": "Ciudad de Moriguchi",
      "ptName": "cidade de Moriguchi",
      "thName": "เมืองโมริงุจิ",
      "viName": "thành phố Moriguchi",
      "inName": "kota Moriguchi",
      "tlName": "siyudad ng Moriguchi",
      "moName": "Моригучи хот",
      "buName": "မိုရိဂုကျိ မြို့",
      "khName": "ទីក្រុង ម៉ូរីគូជី",
      "neName": "मोरिगुची सहर"
    }
  },
  "2721000": {
    "office": {
      "code": "270000",
      "name": "大阪府",
      "enName": "Osaka",
      "officeName": "大阪管区気象台",
      "chName": "大阪府",
      "zhName": "大阪府",
      "koName": "오사카부",
      "esName": "Prefectura de Osaka",
      "ptName": "Província de Ōsaka",
      "thName": "จังหวัดโอซากะ",
      "viName": "Tỉnh Osaka",
      "inName": "Prefektur Osaka",
      "tlName": "Osaka Prefecture",
      "moName": "Осака аймаг",
      "buName": "အိုးဆာ့က ပြည်နယ်",
      "khName": "ខេត្ដ អូសាកា",
      "neName": "ओसाका जिल्ला"
    },
    "class10": {
      "code": "270000",
      "name": "大阪府",
      "enName": "Osaka Prefecture",
      "chName": "大阪府",
      "zhName": "大阪府",
      "koName": "오사카부",
      "esName": "Prefectura de Osaka",
      "ptName": "Prefeitura de Osaka",
      "thName": "จังหวัดโอซาก้า",
      "viName": "tỉnh Osaka",
      "inName": "Prefektur Osaka",
      "tlName": "Osaka Prefecture",
      "moName": "Осака муж",
      "buName": "အိုဆာကာစီရင်စု",
      "khName": "ខេត្តអូសាកា",
      "neName": "ओसाका प्रिफेक्चर"
    },
    "class15": {
      "code": "270003",
      "name": "東部大阪",
      "enName": "Eastern Osaka"
    },
    "class20": {
      "code": "2721000",
      "name": "枚方市",
      "enName": "Hirakata City",
      "kana": "ひらかたし",
      "chName": "枚方市",
      "zhName": "枚方市",
      "koName": "히라카타 시",
      "esName": "Ciudad de Hirakata",
      "ptName": "cidade de Hirakata",
      "thName": "เมืองฮิราคาตะ",
      "viName": "thành phố Hirakata",
      "inName": "kota Hirakata",
      "tlName": "siyudad ng Hirakata",
      "moName": "Хираката хот",
      "buName": "ဟီရာဂါ့တ မြို့",
      "khName": "ទីក្រុង ហ៊ីរ៉ាកាតា",
      "neName": "हिराकाता सहर"
    }
  },
  "2721100": {
    "office": {
      "code": "270000",
      "name": "大阪府",
      "enName": "Osaka",
      "officeName": "大阪管区気象台",
      "chName": "大阪府",
      "zhName": "大阪府",
      "koName": "오사카부",
      "esName": "Prefectura de Osaka",
      "ptName": "Província de Ōsaka",
      "thName": "จังหวัดโอซากะ",
      "viName": "Tỉnh Osaka",
      "inName": "Prefektur Osaka",
      "tlName": "Osaka Prefecture",
      "moName": "Осака аймаг",
      "buName": "အိုးဆာ့က ပြည်နယ်",
      "khName": "ខេត្ដ អូសាកា",
      "neName": "ओसाका जिल्ला"
    },
    "class10": {
      "code": "270000",
      "name": "大阪府",
      "enName": "Osaka Prefecture",
      "chName": "大阪府",
      "zhName": "大阪府",
      "koName": "오사카부",
      "esName": "Prefectura de Osaka",
      "ptName": "Prefeitura de Osaka",
      "thName": "จังหวัดโอซาก้า",
      "viName": "tỉnh Osaka",
      "inName": "Prefektur Osaka",
      "tlName": "Osaka Prefecture",
      "moName": "Осака муж",
      "buName": "အိုဆာကာစီရင်စု",
      "khName": "ខេត្តអូសាកា",
      "neName": "ओसाका प्रिफेक्चर"
    },
    "class15": {
      "code": "270002",
      "name": "北大阪",
      "enName": "Kita-osaka"
    },
    "class20": {
      "code": "2721100",
      "name": "茨木市",
      "enName": "Ibaraki City",
      "kana": "いばらきし",
      "chName": "茨木市",
      "zhName": "茨木市",
      "koName": "이바라키 시",
      "esName": "Ciudad de Ibaraki",
      "ptName": "cidade de Ibaraki",
      "thName": "เมืองอิบารากิ",
      "viName": "thành phố Ibaraki",
      "inName": "kota Ibaraki",
      "tlName": "siyudad ng Ibaraki",
      "moName": "Ибараки хот",
      "buName": "အီဘာရာ့ကိ မြို့",
      "khName": "ទីក្រុង អ៊ីបារ៉ាគី",
      "neName": "इबाराकी सहर"
    }
  },
  "2721200": {
    "office": {
      "code": "270000",
      "name": "大阪府",
      "enName": "Osaka",
      "officeName": "大阪管区気象台",
      "chName": "大阪府",
      "zhName": "大阪府",
      "koName": "오사카부",
      "esName": "Prefectura de Osaka",
      "ptName": "Província de Ōsaka",
      "thName": "จังหวัดโอซากะ",
      "viName": "Tỉnh Osaka",
      "inName": "Prefektur Osaka",
      "tlName": "Osaka Prefecture",
      "moName": "Осака аймаг",
      "buName": "အိုးဆာ့က ပြည်နယ်",
      "khName": "ខេត្ដ អូសាកា",
      "neName": "ओसाका जिल्ला"
    },
    "class10": {
      "code": "270000",
      "name": "大阪府",
      "enName": "Osaka Prefecture",
      "chName": "大阪府",
      "zhName": "大阪府",
      "koName": "오사카부",
      "esName": "Prefectura de Osaka",
      "ptName": "Prefeitura de Osaka",
      "thName": "จังหวัดโอซาก้า",
      "viName": "tỉnh Osaka",
      "inName": "Prefektur Osaka",
      "tlName": "Osaka Prefecture",
      "moName": "Осака муж",
      "buName": "အိုဆာကာစီရင်စု",
      "khName": "ខេត្តអូសាកា",
      "neName": "ओसाका प्रिफेक्चर"
    },
    "class15": {
      "code": "270003",
      "name": "東部大阪",
      "enName": "Eastern Osaka"
    },
    "class20": {
      "code": "2721200",
      "name": "八尾市",
      "enName": "Yao City",
      "kana": "やおし",
      "chName": "八尾市",
      "zhName": "八尾市",
      "koName": "야오 시",
      "esName": "Ciudad de Yao",
      "ptName": "cidade de Yao",
      "thName": "เมืองยาโอะ",
      "viName": "thành phố Yao",
      "inName": "kota Yao",
      "tlName": "siyudad ng Yao",
      "moName": "Яо хот",
      "buName": "ယောင်းအို့ မြို့",
      "khName": "ទីក្រុង យ៉ៅ",
      "neName": "याओ सहर"
    }
  },
  "2721300": {
    "office": {
      "code": "270000",
      "name": "大阪府",
      "enName": "Osaka",
      "officeName": "大阪管区気象台",
      "chName": "大阪府",
      "zhName": "大阪府",
      "koName": "오사카부",
      "esName": "Prefectura de Osaka",
      "ptName": "Província de Ōsaka",
      "thName": "จังหวัดโอซากะ",
      "viName": "Tỉnh Osaka",
      "inName": "Prefektur Osaka",
      "tlName": "Osaka Prefecture",
      "moName": "Осака аймаг",
      "buName": "အိုးဆာ့က ပြည်နယ်",
      "khName": "ខេត្ដ អូសាកា",
      "neName": "ओसाका जिल्ला"
    },
    "class10": {
      "code": "270000",
      "name": "大阪府",
      "enName": "Osaka Prefecture",
      "chName": "大阪府",
      "zhName": "大阪府",
      "koName": "오사카부",
      "esName": "Prefectura de Osaka",
      "ptName": "Prefeitura de Osaka",
      "thName": "จังหวัดโอซาก้า",
      "viName": "tỉnh Osaka",
      "inName": "Prefektur Osaka",
      "tlName": "Osaka Prefecture",
      "moName": "Осака муж",
      "buName": "အိုဆာကာစီရင်စု",
      "khName": "ខេត្តអូសាកា",
      "neName": "ओसाका प्रिफेक्चर"
    },
    "class15": {
      "code": "270005",
      "name": "泉州",
      "enName": "Senshu"
    },
    "class20": {
      "code": "2721300",
      "name": "泉佐野市",
      "enName": "Izumisano City",
      "kana": "いずみさのし",
      "chName": "泉佐野市",
      "zhName": "泉佐野市",
      "koName": "이즈미사노 시",
      "esName": "Ciudad de Izumisano",
      "ptName": "cidade de Izumisano",
      "thName": "เมืองอิสุมิซาโนะ",
      "viName": "thành phố Izumisano",
      "inName": "kota Izumisano",
      "tlName": "siyudad ng Izumisano",
      "moName": "Изүмизaно хот",
      "buName": "အီဇုမိဆာနို မြို့",
      "khName": "ទីក្រុង អ៊ីហ្សុមីសាណូ",
      "neName": "इजुमिसानो सहर"
    }
  },
  "2721400": {
    "office": {
      "code": "270000",
      "name": "大阪府",
      "enName": "Osaka",
      "officeName": "大阪管区気象台",
      "chName": "大阪府",
      "zhName": "大阪府",
      "koName": "오사카부",
      "esName": "Prefectura de Osaka",
      "ptName": "Província de Ōsaka",
      "thName": "จังหวัดโอซากะ",
      "viName": "Tỉnh Osaka",
      "inName": "Prefektur Osaka",
      "tlName": "Osaka Prefecture",
      "moName": "Осака аймаг",
      "buName": "အိုးဆာ့က ပြည်နယ်",
      "khName": "ខេត្ដ អូសាកា",
      "neName": "ओसाका जिल्ला"
    },
    "class10": {
      "code": "270000",
      "name": "大阪府",
      "enName": "Osaka Prefecture",
      "chName": "大阪府",
      "zhName": "大阪府",
      "koName": "오사카부",
      "esName": "Prefectura de Osaka",
      "ptName": "Prefeitura de Osaka",
      "thName": "จังหวัดโอซาก้า",
      "viName": "tỉnh Osaka",
      "inName": "Prefektur Osaka",
      "tlName": "Osaka Prefecture",
      "moName": "Осака муж",
      "buName": "အိုဆာကာစီရင်စု",
      "khName": "ខេត្តអូសាកា",
      "neName": "ओसाका प्रिफेक्चर"
    },
    "class15": {
      "code": "270004",
      "name": "南河内",
      "enName": "Minami-kawachi"
    },
    "class20": {
      "code": "2721400",
      "name": "富田林市",
      "enName": "Tondabayashi City",
      "kana": "とんだばやしし",
      "chName": "富田林市",
      "zhName": "富田林市",
      "koName": "돈다바야시 시",
      "esName": "Ciudad de Tondabayashi",
      "ptName": "cidade de Tondabayashi",
      "thName": "เมืองทนดะบายาชิ",
      "viName": "thành phố Tondabayashi",
      "inName": "kota Tondabayashi",
      "tlName": "siyudad ng Tondabayashi",
      "moName": "Тондабаяши хот",
      "buName": "တွန်ဒါဘာယာ့ရှိ မြို့",
      "khName": "ទីក្រុង តុនដាបាយ៉ាស៊ី",
      "neName": "तोन्दाबायासी सहर"
    }
  },
  "2721500": {
    "office": {
      "code": "270000",
      "name": "大阪府",
      "enName": "Osaka",
      "officeName": "大阪管区気象台",
      "chName": "大阪府",
      "zhName": "大阪府",
      "koName": "오사카부",
      "esName": "Prefectura de Osaka",
      "ptName": "Província de Ōsaka",
      "thName": "จังหวัดโอซากะ",
      "viName": "Tỉnh Osaka",
      "inName": "Prefektur Osaka",
      "tlName": "Osaka Prefecture",
      "moName": "Осака аймаг",
      "buName": "အိုးဆာ့က ပြည်နယ်",
      "khName": "ខេត្ដ អូសាកា",
      "neName": "ओसाका जिल्ला"
    },
    "class10": {
      "code": "270000",
      "name": "大阪府",
      "enName": "Osaka Prefecture",
      "chName": "大阪府",
      "zhName": "大阪府",
      "koName": "오사카부",
      "esName": "Prefectura de Osaka",
      "ptName": "Prefeitura de Osaka",
      "thName": "จังหวัดโอซาก้า",
      "viName": "tỉnh Osaka",
      "inName": "Prefektur Osaka",
      "tlName": "Osaka Prefecture",
      "moName": "Осака муж",
      "buName": "အိုဆာကာစီရင်စု",
      "khName": "ខេត្តអូសាកា",
      "neName": "ओसाका प्रिफेक्चर"
    },
    "class15": {
      "code": "270003",
      "name": "東部大阪",
      "enName": "Eastern Osaka"
    },
    "class20": {
      "code": "2721500",
      "name": "寝屋川市",
      "enName": "Neyagawa City",
      "kana": "ねやがわし",
      "chName": "寝屋川市",
      "zhName": "寢屋川市",
      "koName": "네야가와 시",
      "esName": "Ciudad de Neyagawa",
      "ptName": "cidade de Neyagawa",
      "thName": "เมืองเนยางาวา",
      "viName": "thành phố Neyagawa",
      "inName": "kota Neyagawa",
      "tlName": "siyudad ng Neyagawa",
      "moName": "Нэягава хот",
      "buName": "နေယဂါ့ဝ မြို့",
      "khName": "ទីក្រុង ណីយ៉ាហ្គាវ៉ា",
      "neName": "नेयागावा सहर"
    }
  },
  "2721600": {
    "office": {
      "code": "270000",
      "name": "大阪府",
      "enName": "Osaka",
      "officeName": "大阪管区気象台",
      "chName": "大阪府",
      "zhName": "大阪府",
      "koName": "오사카부",
      "esName": "Prefectura de Osaka",
      "ptName": "Província de Ōsaka",
      "thName": "จังหวัดโอซากะ",
      "viName": "Tỉnh Osaka",
      "inName": "Prefektur Osaka",
      "tlName": "Osaka Prefecture",
      "moName": "Осака аймаг",
      "buName": "အိုးဆာ့က ပြည်နယ်",
      "khName": "ខេត្ដ អូសាកា",
      "neName": "ओसाका जिल्ला"
    },
    "class10": {
      "code": "270000",
      "name": "大阪府",
      "enName": "Osaka Prefecture",
      "chName": "大阪府",
      "zhName": "大阪府",
      "koName": "오사카부",
      "esName": "Prefectura de Osaka",
      "ptName": "Prefeitura de Osaka",
      "thName": "จังหวัดโอซาก้า",
      "viName": "tỉnh Osaka",
      "inName": "Prefektur Osaka",
      "tlName": "Osaka Prefecture",
      "moName": "Осака муж",
      "buName": "အိုဆာကာစီရင်စု",
      "khName": "ខេត្តអូសាកា",
      "neName": "ओसाका प्रिफेक्चर"
    },
    "class15": {
      "code": "270004",
      "name": "南河内",
      "enName": "Minami-kawachi"
    },
    "class20": {
      "code": "2721600",
      "name": "河内長野市",
      "enName": "Kawachinagano City",
      "kana": "かわちながのし",
      "chName": "河内长野市",
      "zhName": "河內長野市",
      "koName": "가와치나가노 시",
      "esName": "Ciudad de Kawachinagano",
      "ptName": "cidade de Kawachinagano",
      "thName": "เมืองคาวาจินากาโนะ",
      "viName": "thành phố Kawachinagano",
      "inName": "kota Kawachinagano",
      "tlName": "siyudad ng Kawachinagano",
      "moName": "Кавачинагано хот",
      "buName": "ခါဝါကျိနဂါ့နော့ မြို့",
      "khName": "ទីក្រុង ខាវ៉ាជីណាហ្គាណូ",
      "neName": "कावाचिनागानो सहर"
    }
  },
  "2721700": {
    "office": {
      "code": "270000",
      "name": "大阪府",
      "enName": "Osaka",
      "officeName": "大阪管区気象台",
      "chName": "大阪府",
      "zhName": "大阪府",
      "koName": "오사카부",
      "esName": "Prefectura de Osaka",
      "ptName": "Província de Ōsaka",
      "thName": "จังหวัดโอซากะ",
      "viName": "Tỉnh Osaka",
      "inName": "Prefektur Osaka",
      "tlName": "Osaka Prefecture",
      "moName": "Осака аймаг",
      "buName": "အိုးဆာ့က ပြည်နယ်",
      "khName": "ខេត្ដ អូសាកា",
      "neName": "ओसाका जिल्ला"
    },
    "class10": {
      "code": "270000",
      "name": "大阪府",
      "enName": "Osaka Prefecture",
      "chName": "大阪府",
      "zhName": "大阪府",
      "koName": "오사카부",
      "esName": "Prefectura de Osaka",
      "ptName": "Prefeitura de Osaka",
      "thName": "จังหวัดโอซาก้า",
      "viName": "tỉnh Osaka",
      "inName": "Prefektur Osaka",
      "tlName": "Osaka Prefecture",
      "moName": "Осака муж",
      "buName": "အိုဆာကာစီရင်စု",
      "khName": "ខេត្តអូសាកា",
      "neName": "ओसाका प्रिफेक्चर"
    },
    "class15": {
      "code": "270004",
      "name": "南河内",
      "enName": "Minami-kawachi"
    },
    "class20": {
      "code": "2721700",
      "name": "松原市",
      "enName": "Matsubara City",
      "kana": "まつばらし",
      "chName": "松原市",
      "zhName": "松原市",
      "koName": "마쓰바라 시",
      "esName": "Ciudad de Matsubara",
      "ptName": "cidade de Matsubara",
      "thName": "เมืองมัทสึบาระ",
      "viName": "thành phố Matsubara",
      "inName": "kota Matsubara",
      "tlName": "siyudad ng Matsubara",
      "moName": "Мацүбара хот",
      "buName": "မာဆုဘားရာ့ မြို့",
      "khName": "ទីក្រុង ម៉ាត់ស៊ូបារ៉ា",
      "neName": "मात्सुबारा सहर"
    }
  },
  "2721800": {
    "office": {
      "code": "270000",
      "name": "大阪府",
      "enName": "Osaka",
      "officeName": "大阪管区気象台",
      "chName": "大阪府",
      "zhName": "大阪府",
      "koName": "오사카부",
      "esName": "Prefectura de Osaka",
      "ptName": "Província de Ōsaka",
      "thName": "จังหวัดโอซากะ",
      "viName": "Tỉnh Osaka",
      "inName": "Prefektur Osaka",
      "tlName": "Osaka Prefecture",
      "moName": "Осака аймаг",
      "buName": "အိုးဆာ့က ပြည်နယ်",
      "khName": "ខេត្ដ អូសាកា",
      "neName": "ओसाका जिल्ला"
    },
    "class10": {
      "code": "270000",
      "name": "大阪府",
      "enName": "Osaka Prefecture",
      "chName": "大阪府",
      "zhName": "大阪府",
      "koName": "오사카부",
      "esName": "Prefectura de Osaka",
      "ptName": "Prefeitura de Osaka",
      "thName": "จังหวัดโอซาก้า",
      "viName": "tỉnh Osaka",
      "inName": "Prefektur Osaka",
      "tlName": "Osaka Prefecture",
      "moName": "Осака муж",
      "buName": "အိုဆာကာစီရင်စု",
      "khName": "ខេត្តអូសាកា",
      "neName": "ओसाका प्रिफेक्चर"
    },
    "class15": {
      "code": "270003",
      "name": "東部大阪",
      "enName": "Eastern Osaka"
    },
    "class20": {
      "code": "2721800",
      "name": "大東市",
      "enName": "Daito City",
      "kana": "だいとうし",
      "chName": "大东市",
      "zhName": "大東市",
      "koName": "다이토 시",
      "esName": "Ciudad de Daito",
      "ptName": "cidade de Daito",
      "thName": "เมืองไดโตะ",
      "viName": "thành phố Daito",
      "inName": "kota Daito",
      "tlName": "siyudad ng Daito",
      "moName": "Дайто хот",
      "buName": "ဒါယိတို မြို့",
      "khName": "ទីក្រុង ដាយតូ",
      "neName": "दाइतो सहर"
    }
  },
  "2721900": {
    "office": {
      "code": "270000",
      "name": "大阪府",
      "enName": "Osaka",
      "officeName": "大阪管区気象台",
      "chName": "大阪府",
      "zhName": "大阪府",
      "koName": "오사카부",
      "esName": "Prefectura de Osaka",
      "ptName": "Província de Ōsaka",
      "thName": "จังหวัดโอซากะ",
      "viName": "Tỉnh Osaka",
      "inName": "Prefektur Osaka",
      "tlName": "Osaka Prefecture",
      "moName": "Осака аймаг",
      "buName": "အိုးဆာ့က ပြည်နယ်",
      "khName": "ខេត្ដ អូសាកា",
      "neName": "ओसाका जिल्ला"
    },
    "class10": {
      "code": "270000",
      "name": "大阪府",
      "enName": "Osaka Prefecture",
      "chName": "大阪府",
      "zhName": "大阪府",
      "koName": "오사카부",
      "esName": "Prefectura de Osaka",
      "ptName": "Prefeitura de Osaka",
      "thName": "จังหวัดโอซาก้า",
      "viName": "tỉnh Osaka",
      "inName": "Prefektur Osaka",
      "tlName": "Osaka Prefecture",
      "moName": "Осака муж",
      "buName": "အိုဆာကာစီရင်စု",
      "khName": "ខេត្តអូសាកា",
      "neName": "ओसाका प्रिफेक्चर"
    },
    "class15": {
      "code": "270005",
      "name": "泉州",
      "enName": "Senshu"
    },
    "class20": {
      "code": "2721900",
      "name": "和泉市",
      "enName": "Izumi City",
      "kana": "いずみし",
      "chName": "大阪和泉市",
      "zhName": "大阪和泉市",
      "koName": "오사카 이즈미 시",
      "esName": "Ciudad de Izumi, Osaka",
      "ptName": "Osaka, cidade de Izumi",
      "thName": "เมืองอิสุมิ โอซากะ",
      "viName": "Thành phố Izumi, Osaka",
      "inName": "Kota Izumi, Osaka",
      "tlName": "siyudad ng Izumi, Osaka",
      "moName": "Осака Изуми хот",
      "buName": "အိုးဆကအိဇုမိမြို့",
      "khName": "ទីក្រុងអ៊ីហ្សុមី អូសាកា",
      "neName": "ओसाका इजुमी सहर"
    }
  },
  "2722000": {
    "office": {
      "code": "270000",
      "name": "大阪府",
      "enName": "Osaka",
      "officeName": "大阪管区気象台",
      "chName": "大阪府",
      "zhName": "大阪府",
      "koName": "오사카부",
      "esName": "Prefectura de Osaka",
      "ptName": "Província de Ōsaka",
      "thName": "จังหวัดโอซากะ",
      "viName": "Tỉnh Osaka",
      "inName": "Prefektur Osaka",
      "tlName": "Osaka Prefecture",
      "moName": "Осака аймаг",
      "buName": "အိုးဆာ့က ပြည်နယ်",
      "khName": "ខេត្ដ អូសាកា",
      "neName": "ओसाका जिल्ला"
    },
    "class10": {
      "code": "270000",
      "name": "大阪府",
      "enName": "Osaka Prefecture",
      "chName": "大阪府",
      "zhName": "大阪府",
      "koName": "오사카부",
      "esName": "Prefectura de Osaka",
      "ptName": "Prefeitura de Osaka",
      "thName": "จังหวัดโอซาก้า",
      "viName": "tỉnh Osaka",
      "inName": "Prefektur Osaka",
      "tlName": "Osaka Prefecture",
      "moName": "Осака муж",
      "buName": "အိုဆာကာစီရင်စု",
      "khName": "ខេត្តអូសាកា",
      "neName": "ओसाका प्रिफेक्चर"
    },
    "class15": {
      "code": "270002",
      "name": "北大阪",
      "enName": "Kita-osaka"
    },
    "class20": {
      "code": "2722000",
      "name": "箕面市",
      "enName": "Minoh City",
      "kana": "みのおし",
      "chName": "箕面市",
      "zhName": "箕面市",
      "koName": "미노 시",
      "esName": "Ciudad de Minoh",
      "ptName": "cidade de Minoh",
      "thName": "เมืองมิโนะ",
      "viName": "thành phố Minoh",
      "inName": "kota Minoh",
      "tlName": "siyudad ng Minoh",
      "moName": "Минох хот",
      "buName": "မီးနော့ မြို့",
      "khName": " ទីក្រុង មីណូ",
      "neName": "मिनो सहर"
    }
  },
  "2722100": {
    "office": {
      "code": "270000",
      "name": "大阪府",
      "enName": "Osaka",
      "officeName": "大阪管区気象台",
      "chName": "大阪府",
      "zhName": "大阪府",
      "koName": "오사카부",
      "esName": "Prefectura de Osaka",
      "ptName": "Província de Ōsaka",
      "thName": "จังหวัดโอซากะ",
      "viName": "Tỉnh Osaka",
      "inName": "Prefektur Osaka",
      "tlName": "Osaka Prefecture",
      "moName": "Осака аймаг",
      "buName": "အိုးဆာ့က ပြည်နယ်",
      "khName": "ខេត្ដ អូសាកា",
      "neName": "ओसाका जिल्ला"
    },
    "class10": {
      "code": "270000",
      "name": "大阪府",
      "enName": "Osaka Prefecture",
      "chName": "大阪府",
      "zhName": "大阪府",
      "koName": "오사카부",
      "esName": "Prefectura de Osaka",
      "ptName": "Prefeitura de Osaka",
      "thName": "จังหวัดโอซาก้า",
      "viName": "tỉnh Osaka",
      "inName": "Prefektur Osaka",
      "tlName": "Osaka Prefecture",
      "moName": "Осака муж",
      "buName": "အိုဆာကာစီရင်စု",
      "khName": "ខេត្តអូសាកា",
      "neName": "ओसाका प्रिफेक्चर"
    },
    "class15": {
      "code": "270003",
      "name": "東部大阪",
      "enName": "Eastern Osaka"
    },
    "class20": {
      "code": "2722100",
      "name": "柏原市",
      "enName": "Kashiwara City",
      "kana": "かしわらし",
      "chName": "柏原市",
      "zhName": "柏原市",
      "koName": "가시와라 시",
      "esName": "Ciudad de kashiwara",
      "ptName": "cidade de Kashiwara",
      "thName": "เมืองคาชิวาระ",
      "viName": "thành phố Kashiwara",
      "inName": "kota Kashiwara",
      "tlName": "siyudad ng Kashiwara",
      "moName": "Кашивара хот",
      "buName": "ကာရှိဝါးရာ့ မြို့",
      "khName": "ទីក្រុង កាស៊ីវ៉ារ៉ា",
      "neName": "काशिवारा सहर"
    }
  },
  "2722200": {
    "office": {
      "code": "270000",
      "name": "大阪府",
      "enName": "Osaka",
      "officeName": "大阪管区気象台",
      "chName": "大阪府",
      "zhName": "大阪府",
      "koName": "오사카부",
      "esName": "Prefectura de Osaka",
      "ptName": "Província de Ōsaka",
      "thName": "จังหวัดโอซากะ",
      "viName": "Tỉnh Osaka",
      "inName": "Prefektur Osaka",
      "tlName": "Osaka Prefecture",
      "moName": "Осака аймаг",
      "buName": "အိုးဆာ့က ပြည်နယ်",
      "khName": "ខេត្ដ អូសាកា",
      "neName": "ओसाका जिल्ला"
    },
    "class10": {
      "code": "270000",
      "name": "大阪府",
      "enName": "Osaka Prefecture",
      "chName": "大阪府",
      "zhName": "大阪府",
      "koName": "오사카부",
      "esName": "Prefectura de Osaka",
      "ptName": "Prefeitura de Osaka",
      "thName": "จังหวัดโอซาก้า",
      "viName": "tỉnh Osaka",
      "inName": "Prefektur Osaka",
      "tlName": "Osaka Prefecture",
      "moName": "Осака муж",
      "buName": "အိုဆာကာစီရင်စု",
      "khName": "ខេត្តអូសាកា",
      "neName": "ओसाका प्रिफेक्चर"
    },
    "class15": {
      "code": "270004",
      "name": "南河内",
      "enName": "Minami-kawachi"
    },
    "class20": {
      "code": "2722200",
      "name": "羽曳野市",
      "enName": "Habikino City",
      "kana": "はびきのし",
      "chName": "羽曳野市",
      "zhName": "羽曳野市",
      "koName": "하비키노 시",
      "esName": "Ciudad de Habikino",
      "ptName": "cidade de Habikino",
      "thName": "เมืองฮาบิคิโนะ",
      "viName": "thành phố Habikino",
      "inName": "kota Habikino",
      "tlName": "siyudad ng Habikino",
      "moName": "Хaбикино хот",
      "buName": "ဟာဘိကိနို မြို့",
      "khName": "ទីក្រុង ហាប៊ីគីណូ",
      "neName": "हाबिकिनो सहर"
    }
  },
  "2722300": {
    "office": {
      "code": "270000",
      "name": "大阪府",
      "enName": "Osaka",
      "officeName": "大阪管区気象台",
      "chName": "大阪府",
      "zhName": "大阪府",
      "koName": "오사카부",
      "esName": "Prefectura de Osaka",
      "ptName": "Província de Ōsaka",
      "thName": "จังหวัดโอซากะ",
      "viName": "Tỉnh Osaka",
      "inName": "Prefektur Osaka",
      "tlName": "Osaka Prefecture",
      "moName": "Осака аймаг",
      "buName": "အိုးဆာ့က ပြည်နယ်",
      "khName": "ខេត្ដ អូសាកា",
      "neName": "ओसाका जिल्ला"
    },
    "class10": {
      "code": "270000",
      "name": "大阪府",
      "enName": "Osaka Prefecture",
      "chName": "大阪府",
      "zhName": "大阪府",
      "koName": "오사카부",
      "esName": "Prefectura de Osaka",
      "ptName": "Prefeitura de Osaka",
      "thName": "จังหวัดโอซาก้า",
      "viName": "tỉnh Osaka",
      "inName": "Prefektur Osaka",
      "tlName": "Osaka Prefecture",
      "moName": "Осака муж",
      "buName": "အိုဆာကာစီရင်စု",
      "khName": "ខេត្តអូសាកា",
      "neName": "ओसाका प्रिफेक्चर"
    },
    "class15": {
      "code": "270003",
      "name": "東部大阪",
      "enName": "Eastern Osaka"
    },
    "class20": {
      "code": "2722300",
      "name": "門真市",
      "enName": "Kadoma City",
      "kana": "かどまし",
      "chName": "门真市",
      "zhName": "門真市",
      "koName": "가도마 시",
      "esName": "Ciudad de Kadoma",
      "ptName": "cidade de Kadoma",
      "thName": "เมืองคาโดะมะ",
      "viName": "thành phố Kadoma",
      "inName": "kota Kadoma",
      "tlName": "siyudad ng Kadoma",
      "moName": "Кадомa хот",
      "buName": "ခါးဒို့မ မြို့",
      "khName": "ទីក្រុង ំ កាដូម៉ា",
      "neName": "कादोमा सहर"
    }
  },
  "2722400": {
    "office": {
      "code": "270000",
      "name": "大阪府",
      "enName": "Osaka",
      "officeName": "大阪管区気象台",
      "chName": "大阪府",
      "zhName": "大阪府",
      "koName": "오사카부",
      "esName": "Prefectura de Osaka",
      "ptName": "Província de Ōsaka",
      "thName": "จังหวัดโอซากะ",
      "viName": "Tỉnh Osaka",
      "inName": "Prefektur Osaka",
      "tlName": "Osaka Prefecture",
      "moName": "Осака аймаг",
      "buName": "အိုးဆာ့က ပြည်နယ်",
      "khName": "ខេត្ដ អូសាកា",
      "neName": "ओसाका जिल्ला"
    },
    "class10": {
      "code": "270000",
      "name": "大阪府",
      "enName": "Osaka Prefecture",
      "chName": "大阪府",
      "zhName": "大阪府",
      "koName": "오사카부",
      "esName": "Prefectura de Osaka",
      "ptName": "Prefeitura de Osaka",
      "thName": "จังหวัดโอซาก้า",
      "viName": "tỉnh Osaka",
      "inName": "Prefektur Osaka",
      "tlName": "Osaka Prefecture",
      "moName": "Осака муж",
      "buName": "အိုဆာကာစီရင်စု",
      "khName": "ខេត្តអូសាកា",
      "neName": "ओसाका प्रिफेक्चर"
    },
    "class15": {
      "code": "270002",
      "name": "北大阪",
      "enName": "Kita-osaka"
    },
    "class20": {
      "code": "2722400",
      "name": "摂津市",
      "enName": "Settsu City",
      "kana": "せっつし",
      "chName": "摄津市",
      "zhName": "攝津市",
      "koName": "셋쓰 시",
      "esName": "Ciudad de Settsu",
      "ptName": "cidade de Settsu",
      "thName": "เมืองเซตสึ",
      "viName": "thành phố Settsu",
      "inName": "kota Settsu",
      "tlName": "siyudad ng Settsu",
      "moName": "Сэццү хот",
      "buName": "ဆက်ဆု မြို့",
      "khName": "ទីក្រុង ស៊ីតស៊ូ",
      "neName": "सेेत्सु सहर"
    }
  },
  "2722500": {
    "office": {
      "code": "270000",
      "name": "大阪府",
      "enName": "Osaka",
      "officeName": "大阪管区気象台",
      "chName": "大阪府",
      "zhName": "大阪府",
      "koName": "오사카부",
      "esName": "Prefectura de Osaka",
      "ptName": "Província de Ōsaka",
      "thName": "จังหวัดโอซากะ",
      "viName": "Tỉnh Osaka",
      "inName": "Prefektur Osaka",
      "tlName": "Osaka Prefecture",
      "moName": "Осака аймаг",
      "buName": "အိုးဆာ့က ပြည်နယ်",
      "khName": "ខេត្ដ អូសាកា",
      "neName": "ओसाका जिल्ला"
    },
    "class10": {
      "code": "270000",
      "name": "大阪府",
      "enName": "Osaka Prefecture",
      "chName": "大阪府",
      "zhName": "大阪府",
      "koName": "오사카부",
      "esName": "Prefectura de Osaka",
      "ptName": "Prefeitura de Osaka",
      "thName": "จังหวัดโอซาก้า",
      "viName": "tỉnh Osaka",
      "inName": "Prefektur Osaka",
      "tlName": "Osaka Prefecture",
      "moName": "Осака муж",
      "buName": "အိုဆာကာစီရင်စု",
      "khName": "ខេត្តអូសាកា",
      "neName": "ओसाका प्रिफेक्चर"
    },
    "class15": {
      "code": "270005",
      "name": "泉州",
      "enName": "Senshu"
    },
    "class20": {
      "code": "2722500",
      "name": "高石市",
      "enName": "Takaishi City",
      "kana": "たかいしし",
      "chName": "高石市",
      "zhName": "髙石市",
      "koName": "다카이시 시",
      "esName": "Ciudad de Takaishi",
      "ptName": "cidade de Takaishi",
      "thName": "เมืองทากาอิจิ",
      "viName": "thành phố Takaishi",
      "inName": "kota Takaishi",
      "tlName": "siyudad ng Takaishi",
      "moName": "Такайши хот",
      "buName": "တာကားယိရှိ မြို့",
      "khName": "ទីក្រុង តាកៃស៊ី",
      "neName": "ताकाइशि सहर"
    }
  },
  "2722600": {
    "office": {
      "code": "270000",
      "name": "大阪府",
      "enName": "Osaka",
      "officeName": "大阪管区気象台",
      "chName": "大阪府",
      "zhName": "大阪府",
      "koName": "오사카부",
      "esName": "Prefectura de Osaka",
      "ptName": "Província de Ōsaka",
      "thName": "จังหวัดโอซากะ",
      "viName": "Tỉnh Osaka",
      "inName": "Prefektur Osaka",
      "tlName": "Osaka Prefecture",
      "moName": "Осака аймаг",
      "buName": "အိုးဆာ့က ပြည်နယ်",
      "khName": "ខេត្ដ អូសាកា",
      "neName": "ओसाका जिल्ला"
    },
    "class10": {
      "code": "270000",
      "name": "大阪府",
      "enName": "Osaka Prefecture",
      "chName": "大阪府",
      "zhName": "大阪府",
      "koName": "오사카부",
      "esName": "Prefectura de Osaka",
      "ptName": "Prefeitura de Osaka",
      "thName": "จังหวัดโอซาก้า",
      "viName": "tỉnh Osaka",
      "inName": "Prefektur Osaka",
      "tlName": "Osaka Prefecture",
      "moName": "Осака муж",
      "buName": "အိုဆာကာစီရင်စု",
      "khName": "ខេត្តអូសាកា",
      "neName": "ओसाका प्रिफेक्चर"
    },
    "class15": {
      "code": "270004",
      "name": "南河内",
      "enName": "Minami-kawachi"
    },
    "class20": {
      "code": "2722600",
      "name": "藤井寺市",
      "enName": "Fujiidera City",
      "kana": "ふじいでらし",
      "chName": "藤井寺市",
      "zhName": "藤井寺市",
      "koName": "후지이데라 시",
      "esName": "Ciudad de Fujiidera",
      "ptName": "cidade de Fujiidera",
      "thName": "เมืองฟุจิเดระ",
      "viName": "thành phố Fujiidera",
      "inName": "kota Fujiidera",
      "tlName": "siyudad ng Fujiidera",
      "moName": "Фүжийдэра хот",
      "buName": "ဖူဂျီဒဲ့ရာ့ မြို့",
      "khName": "ទីក្រុង ហ្វូជីដេរ៉ា",
      "neName": "फुजिदेरा सहर"
    }
  },
  "2722700": {
    "office": {
      "code": "270000",
      "name": "大阪府",
      "enName": "Osaka",
      "officeName": "大阪管区気象台",
      "chName": "大阪府",
      "zhName": "大阪府",
      "koName": "오사카부",
      "esName": "Prefectura de Osaka",
      "ptName": "Província de Ōsaka",
      "thName": "จังหวัดโอซากะ",
      "viName": "Tỉnh Osaka",
      "inName": "Prefektur Osaka",
      "tlName": "Osaka Prefecture",
      "moName": "Осака аймаг",
      "buName": "အိုးဆာ့က ပြည်နယ်",
      "khName": "ខេត្ដ អូសាកា",
      "neName": "ओसाका जिल्ला"
    },
    "class10": {
      "code": "270000",
      "name": "大阪府",
      "enName": "Osaka Prefecture",
      "chName": "大阪府",
      "zhName": "大阪府",
      "koName": "오사카부",
      "esName": "Prefectura de Osaka",
      "ptName": "Prefeitura de Osaka",
      "thName": "จังหวัดโอซาก้า",
      "viName": "tỉnh Osaka",
      "inName": "Prefektur Osaka",
      "tlName": "Osaka Prefecture",
      "moName": "Осака муж",
      "buName": "အိုဆာကာစီရင်စု",
      "khName": "ខេត្តអូសាកា",
      "neName": "ओसाका प्रिफेक्चर"
    },
    "class15": {
      "code": "270003",
      "name": "東部大阪",
      "enName": "Eastern Osaka"
    },
    "class20": {
      "code": "2722700",
      "name": "東大阪市",
      "enName": "Higashiosaka City",
      "kana": "ひがしおおさかし",
      "chName": "东大阪市",
      "zhName": "東大阪市",
      "koName": "히가시오사카 시",
      "esName": "Ciudad de Higashi-osaka",
      "ptName": "cidade de Higashiosaka",
      "thName": "เมืองฮิงาชิโอซากะ",
      "viName": "thành phố Higashiosaka",
      "inName": "kota Higashiosaka",
      "tlName": "siyudad ng Higashiosaka",
      "moName": "Хигашиосака хот",
      "buName": "ဟီဂရှီယိုဆာ့က မြို့",
      "khName": "ទីក្រុង ហ៊ីកាស៊ីអូសាកា",
      "neName": "हिगाशियोसाका सहर"
    }
  },
  "2722800": {
    "office": {
      "code": "270000",
      "name": "大阪府",
      "enName": "Osaka",
      "officeName": "大阪管区気象台",
      "chName": "大阪府",
      "zhName": "大阪府",
      "koName": "오사카부",
      "esName": "Prefectura de Osaka",
      "ptName": "Província de Ōsaka",
      "thName": "จังหวัดโอซากะ",
      "viName": "Tỉnh Osaka",
      "inName": "Prefektur Osaka",
      "tlName": "Osaka Prefecture",
      "moName": "Осака аймаг",
      "buName": "အိုးဆာ့က ပြည်နယ်",
      "khName": "ខេត្ដ អូសាកា",
      "neName": "ओसाका जिल्ला"
    },
    "class10": {
      "code": "270000",
      "name": "大阪府",
      "enName": "Osaka Prefecture",
      "chName": "大阪府",
      "zhName": "大阪府",
      "koName": "오사카부",
      "esName": "Prefectura de Osaka",
      "ptName": "Prefeitura de Osaka",
      "thName": "จังหวัดโอซาก้า",
      "viName": "tỉnh Osaka",
      "inName": "Prefektur Osaka",
      "tlName": "Osaka Prefecture",
      "moName": "Осака муж",
      "buName": "အိုဆာကာစီရင်စု",
      "khName": "ខេត្តអូសាកា",
      "neName": "ओसाका प्रिफेक्चर"
    },
    "class15": {
      "code": "270005",
      "name": "泉州",
      "enName": "Senshu"
    },
    "class20": {
      "code": "2722800",
      "name": "泉南市",
      "enName": "Sennan City",
      "kana": "せんなんし",
      "chName": "泉南市",
      "zhName": "泉南市",
      "koName": "센난 시",
      "esName": "Ciudad de Sennan",
      "ptName": "cidade de Sennan",
      "thName": "เมืองเซนนัน",
      "viName": "thành phố Sennan",
      "inName": "kota Sennan",
      "tlName": "siyudad ng Sennan",
      "moName": "Сэннaн хот",
      "buName": "ဆေးနန် မြို့",
      "khName": "ទីក្រុង សេនណាន",
      "neName": "सेन्नान सहर"
    }
  },
  "2722900": {
    "office": {
      "code": "270000",
      "name": "大阪府",
      "enName": "Osaka",
      "officeName": "大阪管区気象台",
      "chName": "大阪府",
      "zhName": "大阪府",
      "koName": "오사카부",
      "esName": "Prefectura de Osaka",
      "ptName": "Província de Ōsaka",
      "thName": "จังหวัดโอซากะ",
      "viName": "Tỉnh Osaka",
      "inName": "Prefektur Osaka",
      "tlName": "Osaka Prefecture",
      "moName": "Осака аймаг",
      "buName": "အိုးဆာ့က ပြည်နယ်",
      "khName": "ខេត្ដ អូសាកា",
      "neName": "ओसाका जिल्ला"
    },
    "class10": {
      "code": "270000",
      "name": "大阪府",
      "enName": "Osaka Prefecture",
      "chName": "大阪府",
      "zhName": "大阪府",
      "koName": "오사카부",
      "esName": "Prefectura de Osaka",
      "ptName": "Prefeitura de Osaka",
      "thName": "จังหวัดโอซาก้า",
      "viName": "tỉnh Osaka",
      "inName": "Prefektur Osaka",
      "tlName": "Osaka Prefecture",
      "moName": "Осака муж",
      "buName": "အိုဆာကာစီရင်စု",
      "khName": "ខេត្តអូសាកា",
      "neName": "ओसाका प्रिफेक्चर"
    },
    "class15": {
      "code": "270003",
      "name": "東部大阪",
      "enName": "Eastern Osaka"
    },
    "class20": {
      "code": "2722900",
      "name": "四條畷市",
      "enName": "Shijonawate City",
      "kana": "しじょうなわてし",
      "chName": "四条畷市",
      "zhName": "四條畷市",
      "koName": "시죠나와테 시",
      "esName": "Ciudad de Shijyonawate",
      "ptName": "cidade de Shijonawate",
      "thName": "เมืองชินโจนาวาเตะ",
      "viName": "thành phố Shijonawate",
      "inName": "kota Shijonawate",
      "tlName": "siyudad ng Shijonawate",
      "moName": "Шижонаватэ хот",
      "buName": "ရှီဂျိုနာ့ဝါးတဲ့ မြို့",
      "khName": "ទីក្រុង ស៊ីហ៊ន់ណាវ៉ាតេ",
      "neName": "शिजोनावाते सहर"
    }
  },
  "2723000": {
    "office": {
      "code": "270000",
      "name": "大阪府",
      "enName": "Osaka",
      "officeName": "大阪管区気象台",
      "chName": "大阪府",
      "zhName": "大阪府",
      "koName": "오사카부",
      "esName": "Prefectura de Osaka",
      "ptName": "Província de Ōsaka",
      "thName": "จังหวัดโอซากะ",
      "viName": "Tỉnh Osaka",
      "inName": "Prefektur Osaka",
      "tlName": "Osaka Prefecture",
      "moName": "Осака аймаг",
      "buName": "အိုးဆာ့က ပြည်နယ်",
      "khName": "ខេត្ដ អូសាកា",
      "neName": "ओसाका जिल्ला"
    },
    "class10": {
      "code": "270000",
      "name": "大阪府",
      "enName": "Osaka Prefecture",
      "chName": "大阪府",
      "zhName": "大阪府",
      "koName": "오사카부",
      "esName": "Prefectura de Osaka",
      "ptName": "Prefeitura de Osaka",
      "thName": "จังหวัดโอซาก้า",
      "viName": "tỉnh Osaka",
      "inName": "Prefektur Osaka",
      "tlName": "Osaka Prefecture",
      "moName": "Осака муж",
      "buName": "အိုဆာကာစီရင်စု",
      "khName": "ខេត្តអូសាកា",
      "neName": "ओसाका प्रिफेक्चर"
    },
    "class15": {
      "code": "270003",
      "name": "東部大阪",
      "enName": "Eastern Osaka"
    },
    "class20": {
      "code": "2723000",
      "name": "交野市",
      "enName": "Katano City",
      "kana": "かたのし",
      "chName": "交野市",
      "zhName": "交野市",
      "koName": "가타노 시",
      "esName": "Ciudad de Katano",
      "ptName": "cidade de Katano",
      "thName": "เมืองคาตาโนะ",
      "viName": "thành phố Katano",
      "inName": "kota Katano",
      "tlName": "siyudad ng Katano",
      "moName": "Катано хот",
      "buName": "ကာတာနို မြို့",
      "khName": "ទីក្រុង កាតាណូ",
      "neName": "कातानो सहर"
    }
  },
  "2723100": {
    "office": {
      "code": "270000",
      "name": "大阪府",
      "enName": "Osaka",
      "officeName": "大阪管区気象台",
      "chName": "大阪府",
      "zhName": "大阪府",
      "koName": "오사카부",
      "esName": "Prefectura de Osaka",
      "ptName": "Província de Ōsaka",
      "thName": "จังหวัดโอซากะ",
      "viName": "Tỉnh Osaka",
      "inName": "Prefektur Osaka",
      "tlName": "Osaka Prefecture",
      "moName": "Осака аймаг",
      "buName": "အိုးဆာ့က ပြည်နယ်",
      "khName": "ខេត្ដ អូសាកា",
      "neName": "ओसाका जिल्ला"
    },
    "class10": {
      "code": "270000",
      "name": "大阪府",
      "enName": "Osaka Prefecture",
      "chName": "大阪府",
      "zhName": "大阪府",
      "koName": "오사카부",
      "esName": "Prefectura de Osaka",
      "ptName": "Prefeitura de Osaka",
      "thName": "จังหวัดโอซาก้า",
      "viName": "tỉnh Osaka",
      "inName": "Prefektur Osaka",
      "tlName": "Osaka Prefecture",
      "moName": "Осака муж",
      "buName": "အိုဆာကာစီရင်စု",
      "khName": "ខេត្តអូសាកា",
      "neName": "ओसाका प्रिफेक्चर"
    },
    "class15": {
      "code": "270004",
      "name": "南河内",
      "enName": "Minami-kawachi"
    },
    "class20": {
      "code": "2723100",
      "name": "大阪狭山市",
      "enName": "Osakasayama City",
      "kana": "おおさかさやまし",
      "chName": "大阪狭山市",
      "zhName": "大阪狹山市",
      "koName": "오사카사야마 시",
      "esName": "Ciudad de Osakasayama",
      "ptName": "cidade de Osakasayama",
      "thName": "เมืองโอซากะซายามะ",
      "viName": "thành phố Osakasayama",
      "inName": "kota Osakasayama",
      "tlName": "siyudad ng Osakasayama",
      "moName": "Осакасаяма хот",
      "buName": "အိုဆာကာဆားယာ့မ မြို့",
      "khName": "ទីក្រុង អូសាកាសាយ៉ាម៉ា",
      "neName": "ओसाकासायामा सहर"
    }
  },
  "2723200": {
    "office": {
      "code": "270000",
      "name": "大阪府",
      "enName": "Osaka",
      "officeName": "大阪管区気象台",
      "chName": "大阪府",
      "zhName": "大阪府",
      "koName": "오사카부",
      "esName": "Prefectura de Osaka",
      "ptName": "Província de Ōsaka",
      "thName": "จังหวัดโอซากะ",
      "viName": "Tỉnh Osaka",
      "inName": "Prefektur Osaka",
      "tlName": "Osaka Prefecture",
      "moName": "Осака аймаг",
      "buName": "အိုးဆာ့က ပြည်နယ်",
      "khName": "ខេត្ដ អូសាកា",
      "neName": "ओसाका जिल्ला"
    },
    "class10": {
      "code": "270000",
      "name": "大阪府",
      "enName": "Osaka Prefecture",
      "chName": "大阪府",
      "zhName": "大阪府",
      "koName": "오사카부",
      "esName": "Prefectura de Osaka",
      "ptName": "Prefeitura de Osaka",
      "thName": "จังหวัดโอซาก้า",
      "viName": "tỉnh Osaka",
      "inName": "Prefektur Osaka",
      "tlName": "Osaka Prefecture",
      "moName": "Осака муж",
      "buName": "အိုဆာကာစီရင်စု",
      "khName": "ខេត្តអូសាកា",
      "neName": "ओसाका प्रिफेक्चर"
    },
    "class15": {
      "code": "270005",
      "name": "泉州",
      "enName": "Senshu"
    },
    "class20": {
      "code": "2723200",
      "name": "阪南市",
      "enName": "Hannan City",
      "kana": "はんなんし",
      "chName": "阪南市",
      "zhName": "阪南市",
      "koName": "한난 시",
      "esName": "Ciudad de Hannan",
      "ptName": "cidade de Hannan",
      "thName": "เมืองฮันนัน",
      "viName": "thành phố Hannan",
      "inName": "kota Hannan",
      "tlName": "siyudad ng Hannan",
      "moName": "Хaннaн хот",
      "buName": "ဟန်နန် မြို့",
      "khName": "ទីក្រុង ហាន់ណាន",
      "neName": "हान्नान सहर"
    }
  },
  "2730100": {
    "office": {
      "code": "270000",
      "name": "大阪府",
      "enName": "Osaka",
      "officeName": "大阪管区気象台",
      "chName": "大阪府",
      "zhName": "大阪府",
      "koName": "오사카부",
      "esName": "Prefectura de Osaka",
      "ptName": "Província de Ōsaka",
      "thName": "จังหวัดโอซากะ",
      "viName": "Tỉnh Osaka",
      "inName": "Prefektur Osaka",
      "tlName": "Osaka Prefecture",
      "moName": "Осака аймаг",
      "buName": "အိုးဆာ့က ပြည်နယ်",
      "khName": "ខេត្ដ អូសាកា",
      "neName": "ओसाका जिल्ला"
    },
    "class10": {
      "code": "270000",
      "name": "大阪府",
      "enName": "Osaka Prefecture",
      "chName": "大阪府",
      "zhName": "大阪府",
      "koName": "오사카부",
      "esName": "Prefectura de Osaka",
      "ptName": "Prefeitura de Osaka",
      "thName": "จังหวัดโอซาก้า",
      "viName": "tỉnh Osaka",
      "inName": "Prefektur Osaka",
      "tlName": "Osaka Prefecture",
      "moName": "Осака муж",
      "buName": "အိုဆာကာစီရင်စု",
      "khName": "ខេត្តអូសាកា",
      "neName": "ओसाका प्रिफेक्चर"
    },
    "class15": {
      "code": "270002",
      "name": "北大阪",
      "enName": "Kita-osaka"
    },
    "class20": {
      "code": "2730100",
      "name": "島本町",
      "enName": "Shimamoto Town",
      "kana": "しまもとちょう",
      "chName": "岛本町",
      "zhName": "島本町",
      "koName": "시마모토 정",
      "esName": "Pueblo de Shimamoto",
      "ptName": "bairro de Shimamoto",
      "thName": "เมืองชิมะโมโตะ",
      "viName": "thị trấn Shimamoto",
      "inName": "kota Shimamoto",
      "tlName": "bayan ng Shimamoto",
      "moName": "Шимaмото жижиг хот",
      "buName": "ရှီမာမိုတို မြို့နယ်",
      "khName": "ទីប្រជុំជន ស៊ីម៉ាម៉ូតុ",
      "neName": "शिमामोतो नगर"
    }
  },
  "2732100": {
    "office": {
      "code": "270000",
      "name": "大阪府",
      "enName": "Osaka",
      "officeName": "大阪管区気象台",
      "chName": "大阪府",
      "zhName": "大阪府",
      "koName": "오사카부",
      "esName": "Prefectura de Osaka",
      "ptName": "Província de Ōsaka",
      "thName": "จังหวัดโอซากะ",
      "viName": "Tỉnh Osaka",
      "inName": "Prefektur Osaka",
      "tlName": "Osaka Prefecture",
      "moName": "Осака аймаг",
      "buName": "အိုးဆာ့က ပြည်နယ်",
      "khName": "ខេត្ដ អូសាកា",
      "neName": "ओसाका जिल्ला"
    },
    "class10": {
      "code": "270000",
      "name": "大阪府",
      "enName": "Osaka Prefecture",
      "chName": "大阪府",
      "zhName": "大阪府",
      "koName": "오사카부",
      "esName": "Prefectura de Osaka",
      "ptName": "Prefeitura de Osaka",
      "thName": "จังหวัดโอซาก้า",
      "viName": "tỉnh Osaka",
      "inName": "Prefektur Osaka",
      "tlName": "Osaka Prefecture",
      "moName": "Осака муж",
      "buName": "အိုဆာကာစီရင်စု",
      "khName": "ខេត្តអូសាកា",
      "neName": "ओसाका प्रिफेक्चर"
    },
    "class15": {
      "code": "270002",
      "name": "北大阪",
      "enName": "Kita-osaka"
    },
    "class20": {
      "code": "2732100",
      "name": "豊能町",
      "enName": "Toyono Town",
      "kana": "とよのちょう",
      "chName": "丰能町",
      "zhName": "豐能町",
      "koName": "도요노 정",
      "esName": "Pueblo de Toyono",
      "ptName": "bairro de Toyono",
      "thName": "เมืองโตโยโนะ",
      "viName": "thị trấn Toyono",
      "inName": "kota Toyono",
      "tlName": "bayan ng Toyono",
      "moName": "Тоёоно жижиг хот",
      "buName": "တိုယိုနို မြို့နယ်",
      "khName": "ទីប្រជុំជន តូយ៉ូណុ",
      "neName": "तोयोनो नगर"
    }
  },
  "2732200": {
    "office": {
      "code": "270000",
      "name": "大阪府",
      "enName": "Osaka",
      "officeName": "大阪管区気象台",
      "chName": "大阪府",
      "zhName": "大阪府",
      "koName": "오사카부",
      "esName": "Prefectura de Osaka",
      "ptName": "Província de Ōsaka",
      "thName": "จังหวัดโอซากะ",
      "viName": "Tỉnh Osaka",
      "inName": "Prefektur Osaka",
      "tlName": "Osaka Prefecture",
      "moName": "Осака аймаг",
      "buName": "အိုးဆာ့က ပြည်နယ်",
      "khName": "ខេត្ដ អូសាកា",
      "neName": "ओसाका जिल्ला"
    },
    "class10": {
      "code": "270000",
      "name": "大阪府",
      "enName": "Osaka Prefecture",
      "chName": "大阪府",
      "zhName": "大阪府",
      "koName": "오사카부",
      "esName": "Prefectura de Osaka",
      "ptName": "Prefeitura de Osaka",
      "thName": "จังหวัดโอซาก้า",
      "viName": "tỉnh Osaka",
      "inName": "Prefektur Osaka",
      "tlName": "Osaka Prefecture",
      "moName": "Осака муж",
      "buName": "အိုဆာကာစီရင်စု",
      "khName": "ខេត្តអូសាកា",
      "neName": "ओसाका प्रिफेक्चर"
    },
    "class15": {
      "code": "270002",
      "name": "北大阪",
      "enName": "Kita-osaka"
    },
    "class20": {
      "code": "2732200",
      "name": "能勢町",
      "enName": "Nose Town",
      "kana": "のせちょう",
      "chName": "能势町",
      "zhName": "能勢町",
      "koName": "노세 정",
      "esName": "Pueblo de Nose",
      "ptName": "bairro de Nose",
      "thName": "เมืองโนเซ",
      "viName": "thị trấn Nose",
      "inName": "kota Nose",
      "tlName": "bayan ng Nose",
      "moName": "Носэ жижиг хот",
      "buName": "နောဆဲ့ မြို့နယ်",
      "khName": "ទីប្រជុំជន ណូសេ",
      "neName": "नोसे नगर"
    }
  },
  "2734100": {
    "office": {
      "code": "270000",
      "name": "大阪府",
      "enName": "Osaka",
      "officeName": "大阪管区気象台",
      "chName": "大阪府",
      "zhName": "大阪府",
      "koName": "오사카부",
      "esName": "Prefectura de Osaka",
      "ptName": "Província de Ōsaka",
      "thName": "จังหวัดโอซากะ",
      "viName": "Tỉnh Osaka",
      "inName": "Prefektur Osaka",
      "tlName": "Osaka Prefecture",
      "moName": "Осака аймаг",
      "buName": "အိုးဆာ့က ပြည်နယ်",
      "khName": "ខេត្ដ អូសាកា",
      "neName": "ओसाका जिल्ला"
    },
    "class10": {
      "code": "270000",
      "name": "大阪府",
      "enName": "Osaka Prefecture",
      "chName": "大阪府",
      "zhName": "大阪府",
      "koName": "오사카부",
      "esName": "Prefectura de Osaka",
      "ptName": "Prefeitura de Osaka",
      "thName": "จังหวัดโอซาก้า",
      "viName": "tỉnh Osaka",
      "inName": "Prefektur Osaka",
      "tlName": "Osaka Prefecture",
      "moName": "Осака муж",
      "buName": "အိုဆာကာစီရင်စု",
      "khName": "ខេត្តអូសាកា",
      "neName": "ओसाका प्रिफेक्चर"
    },
    "class15": {
      "code": "270005",
      "name": "泉州",
      "enName": "Senshu"
    },
    "class20": {
      "code": "2734100",
      "name": "忠岡町",
      "enName": "Tadaoka Town",
      "kana": "ただおかちょう",
      "chName": "忠冈町",
      "zhName": "忠岡町",
      "koName": "다다오카 정",
      "esName": "Pueblo de Tadaoka",
      "ptName": "bairro de Tadaoka",
      "thName": "เมืองทาดาโอกะ",
      "viName": "thị trấn Tadaoka",
      "inName": "kota Tadaoka",
      "tlName": "bayan ng Tadaoka",
      "moName": "Тадаока жижиг хот",
      "buName": "တာဒါအိုးက မြို့နယ်",
      "khName": "ទីប្រជុំជន តាដាអូកា",
      "neName": "तादाओका नगर"
    }
  },
  "2736100": {
    "office": {
      "code": "270000",
      "name": "大阪府",
      "enName": "Osaka",
      "officeName": "大阪管区気象台",
      "chName": "大阪府",
      "zhName": "大阪府",
      "koName": "오사카부",
      "esName": "Prefectura de Osaka",
      "ptName": "Província de Ōsaka",
      "thName": "จังหวัดโอซากะ",
      "viName": "Tỉnh Osaka",
      "inName": "Prefektur Osaka",
      "tlName": "Osaka Prefecture",
      "moName": "Осака аймаг",
      "buName": "အိုးဆာ့က ပြည်နယ်",
      "khName": "ខេត្ដ អូសាកា",
      "neName": "ओसाका जिल्ला"
    },
    "class10": {
      "code": "270000",
      "name": "大阪府",
      "enName": "Osaka Prefecture",
      "chName": "大阪府",
      "zhName": "大阪府",
      "koName": "오사카부",
      "esName": "Prefectura de Osaka",
      "ptName": "Prefeitura de Osaka",
      "thName": "จังหวัดโอซาก้า",
      "viName": "tỉnh Osaka",
      "inName": "Prefektur Osaka",
      "tlName": "Osaka Prefecture",
      "moName": "Осака муж",
      "buName": "အိုဆာကာစီရင်စု",
      "khName": "ខេត្តអូសាកា",
      "neName": "ओसाका प्रिफेक्चर"
    },
    "class15": {
      "code": "270005",
      "name": "泉州",
      "enName": "Senshu"
    },
    "class20": {
      "code": "2736100",
      "name": "熊取町",
      "enName": "Kumatori Town",
      "kana": "くまとりちょう",
      "chName": "熊取町",
      "zhName": "熊取町",
      "koName": "구마토리 정",
      "esName": "Pueblo de Kumatori",
      "ptName": "bairro de Kumatori",
      "thName": "เมืองคุมะโทริ",
      "viName": "thị trấn Kumatori",
      "inName": "kota Kumatori",
      "tlName": "bayan ng Kumatori",
      "moName": "Күмaтори жижиг хот",
      "buName": "ခူမာတောရိ မြို့နယ်",
      "khName": "ទីប្រជុំជន គូម៉ាតូរី",
      "neName": "कुमातोरी नगर"
    }
  },
  "2736200": {
    "office": {
      "code": "270000",
      "name": "大阪府",
      "enName": "Osaka",
      "officeName": "大阪管区気象台",
      "chName": "大阪府",
      "zhName": "大阪府",
      "koName": "오사카부",
      "esName": "Prefectura de Osaka",
      "ptName": "Província de Ōsaka",
      "thName": "จังหวัดโอซากะ",
      "viName": "Tỉnh Osaka",
      "inName": "Prefektur Osaka",
      "tlName": "Osaka Prefecture",
      "moName": "Осака аймаг",
      "buName": "အိုးဆာ့က ပြည်နယ်",
      "khName": "ខេត្ដ អូសាកា",
      "neName": "ओसाका जिल्ला"
    },
    "class10": {
      "code": "270000",
      "name": "大阪府",
      "enName": "Osaka Prefecture",
      "chName": "大阪府",
      "zhName": "大阪府",
      "koName": "오사카부",
      "esName": "Prefectura de Osaka",
      "ptName": "Prefeitura de Osaka",
      "thName": "จังหวัดโอซาก้า",
      "viName": "tỉnh Osaka",
      "inName": "Prefektur Osaka",
      "tlName": "Osaka Prefecture",
      "moName": "Осака муж",
      "buName": "အိုဆာကာစီရင်စု",
      "khName": "ខេត្តអូសាកា",
      "neName": "ओसाका प्रिफेक्चर"
    },
    "class15": {
      "code": "270005",
      "name": "泉州",
      "enName": "Senshu"
    },
    "class20": {
      "code": "2736200",
      "name": "田尻町",
      "enName": "Tajiri Town",
      "kana": "たじりちょう",
      "chName": "田尻町",
      "zhName": "田尻町",
      "koName": "다지리 정",
      "esName": "Pueblo de Tajiri",
      "ptName": "bairro de Tajiri",
      "thName": "เมืองทะจิริ",
      "viName": "thị trấn Tajiri",
      "inName": "kota Tajiri",
      "tlName": "bayan ng Tajiri",
      "moName": "Тажири жижиг хот",
      "buName": "တာဂျိရိ မြို့နယ်",
      "khName": "ទីប្រជុំជន តាជីរី",
      "neName": "ताजिरी नगर"
    }
  },
  "2736600": {
    "office": {
      "code": "270000",
      "name": "大阪府",
      "enName": "Osaka",
      "officeName": "大阪管区気象台",
      "chName": "大阪府",
      "zhName": "大阪府",
      "koName": "오사카부",
      "esName": "Prefectura de Osaka",
      "ptName": "Província de Ōsaka",
      "thName": "จังหวัดโอซากะ",
      "viName": "Tỉnh Osaka",
      "inName": "Prefektur Osaka",
      "tlName": "Osaka Prefecture",
      "moName": "Осака аймаг",
      "buName": "အိုးဆာ့က ပြည်နယ်",
      "khName": "ខេត្ដ អូសាកា",
      "neName": "ओसाका जिल्ला"
    },
    "class10": {
      "code": "270000",
      "name": "大阪府",
      "enName": "Osaka Prefecture",
      "chName": "大阪府",
      "zhName": "大阪府",
      "koName": "오사카부",
      "esName": "Prefectura de Osaka",
      "ptName": "Prefeitura de Osaka",
      "thName": "จังหวัดโอซาก้า",
      "viName": "tỉnh Osaka",
      "inName": "Prefektur Osaka",
      "tlName": "Osaka Prefecture",
      "moName": "Осака муж",
      "buName": "အိုဆာကာစီရင်စု",
      "khName": "ខេត្តអូសាកា",
      "neName": "ओसाका प्रिफेक्चर"
    },
    "class15": {
      "code": "270005",
      "name": "泉州",
      "enName": "Senshu"
    },
    "class20": {
      "code": "2736600",
      "name": "岬町",
      "enName": "Misaki Town",
      "kana": "みさきちょう",
      "chName": "大阪岬町",
      "zhName": "大阪岬町",
      "koName": "오사카 미사키 정",
      "esName": "Pueblo de Misaki, Osaka",
      "ptName": "Osaka, bairro de Misaki",
      "thName": "เมืองมิซากิ โอซากะ",
      "viName": "Thị trấn Misaki, Osaka",
      "inName": "Kota Misaki, Osaka",
      "tlName": "bayan ng Misaki, Osaka",
      "moName": "Осака Мисаки жижиг хот",
      "buName": "အိုးဆကမိဆခိမြို့နယ်",
      "khName": "ទីប្រជុំជនមីសាគី អូសាកា",
      "neName": "ओसाका मिसाकी नगर"
    }
  },
  "2738100": {
    "office": {
      "code": "270000",
      "name": "大阪府",
      "enName": "Osaka",
      "officeName": "大阪管区気象台",
      "chName": "大阪府",
      "zhName": "大阪府",
      "koName": "오사카부",
      "esName": "Prefectura de Osaka",
      "ptName": "Província de Ōsaka",
      "thName": "จังหวัดโอซากะ",
      "viName": "Tỉnh Osaka",
      "inName": "Prefektur Osaka",
      "tlName": "Osaka Prefecture",
      "moName": "Осака аймаг",
      "buName": "အိုးဆာ့က ပြည်နယ်",
      "khName": "ខេត្ដ អូសាកា",
      "neName": "ओसाका जिल्ला"
    },
    "class10": {
      "code": "270000",
      "name": "大阪府",
      "enName": "Osaka Prefecture",
      "chName": "大阪府",
      "zhName": "大阪府",
      "koName": "오사카부",
      "esName": "Prefectura de Osaka",
      "ptName": "Prefeitura de Osaka",
      "thName": "จังหวัดโอซาก้า",
      "viName": "tỉnh Osaka",
      "inName": "Prefektur Osaka",
      "tlName": "Osaka Prefecture",
      "moName": "Осака муж",
      "buName": "အိုဆာကာစီရင်စု",
      "khName": "ខេត្តអូសាកា",
      "neName": "ओसाका प्रिफेक्चर"
    },
    "class15": {
      "code": "270004",
      "name": "南河内",
      "enName": "Minami-kawachi"
    },
    "class20": {
      "code": "2738100",
      "name": "太子町",
      "enName": "Taishi Town",
      "kana": "たいしちょう",
      "chName": "大阪太子町",
      "zhName": "大阪太子町",
      "koName": "오사카 다이시 정",
      "esName": "Pueblo de Taishi, Osaka",
      "ptName": "Osaka, bairro de Taishi",
      "thName": "เมืองไทชิ โอซากะ",
      "viName": "Thị trấn Taishi, Osaka",
      "inName": "Kota Taishi, Osaka",
      "tlName": "bayan ng Taishi, Osaka",
      "moName": "Осака Тайши жижиг хот",
      "buName": "အိုးဆကတိုင်းရှိမြို့နယ်",
      "khName": "ទីប្រជុំជនតៃស៊ី អូសាកា",
      "neName": "ओसाका ताइशी नगर"
    }
  },
  "2738200": {
    "office": {
      "code": "270000",
      "name": "大阪府",
      "enName": "Osaka",
      "officeName": "大阪管区気象台",
      "chName": "大阪府",
      "zhName": "大阪府",
      "koName": "오사카부",
      "esName": "Prefectura de Osaka",
      "ptName": "Província de Ōsaka",
      "thName": "จังหวัดโอซากะ",
      "viName": "Tỉnh Osaka",
      "inName": "Prefektur Osaka",
      "tlName": "Osaka Prefecture",
      "moName": "Осака аймаг",
      "buName": "အိုးဆာ့က ပြည်နယ်",
      "khName": "ខេត្ដ អូសាកា",
      "neName": "ओसाका जिल्ला"
    },
    "class10": {
      "code": "270000",
      "name": "大阪府",
      "enName": "Osaka Prefecture",
      "chName": "大阪府",
      "zhName": "大阪府",
      "koName": "오사카부",
      "esName": "Prefectura de Osaka",
      "ptName": "Prefeitura de Osaka",
      "thName": "จังหวัดโอซาก้า",
      "viName": "tỉnh Osaka",
      "inName": "Prefektur Osaka",
      "tlName": "Osaka Prefecture",
      "moName": "Осака муж",
      "buName": "အိုဆာကာစီရင်စု",
      "khName": "ខេត្តអូសាកា",
      "neName": "ओसाका प्रिफेक्चर"
    },
    "class15": {
      "code": "270004",
      "name": "南河内",
      "enName": "Minami-kawachi"
    },
    "class20": {
      "code": "2738200",
      "name": "河南町",
      "enName": "Kanan Town",
      "kana": "かなんちょう",
      "chName": "河南町",
      "zhName": "河南町",
      "koName": "가난 정",
      "esName": "Pueblo de Kanan",
      "ptName": "bairro de Kanan",
      "thName": "เมืองคะนัน",
      "viName": "thị trấn Kanan",
      "inName": "kota Kanan",
      "tlName": "bayan ng Kanan",
      "moName": "Канaн жижиг хот",
      "buName": "ခန်နန်း မြို့နယ်",
      "khName": "ទីប្រជុំជន កាណាន",
      "neName": "कानान नगर"
    }
  },
  "2738300": {
    "office": {
      "code": "270000",
      "name": "大阪府",
      "enName": "Osaka",
      "officeName": "大阪管区気象台",
      "chName": "大阪府",
      "zhName": "大阪府",
      "koName": "오사카부",
      "esName": "Prefectura de Osaka",
      "ptName": "Província de Ōsaka",
      "thName": "จังหวัดโอซากะ",
      "viName": "Tỉnh Osaka",
      "inName": "Prefektur Osaka",
      "tlName": "Osaka Prefecture",
      "moName": "Осака аймаг",
      "buName": "အိုးဆာ့က ပြည်နယ်",
      "khName": "ខេត្ដ អូសាកា",
      "neName": "ओसाका जिल्ला"
    },
    "class10": {
      "code": "270000",
      "name": "大阪府",
      "enName": "Osaka Prefecture",
      "chName": "大阪府",
      "zhName": "大阪府",
      "koName": "오사카부",
      "esName": "Prefectura de Osaka",
      "ptName": "Prefeitura de Osaka",
      "thName": "จังหวัดโอซาก้า",
      "viName": "tỉnh Osaka",
      "inName": "Prefektur Osaka",
      "tlName": "Osaka Prefecture",
      "moName": "Осака муж",
      "buName": "အိုဆာကာစီရင်စု",
      "khName": "ខេត្តអូសាកា",
      "neName": "ओसाका प्रिफेक्चर"
    },
    "class15": {
      "code": "270004",
      "name": "南河内",
      "enName": "Minami-kawachi"
    },
    "class20": {
      "code": "2738300",
      "name": "千早赤阪村",
      "enName": "Chihayaakasaka Village",
      "kana": "ちはやあかさかむら",
      "chName": "千早赤阪村",
      "zhName": "千早赤阪村",
      "koName": "지하야아카사카 촌",
      "esName": "Aldea de Chihaya-akasaka",
      "ptName": "povoado de Chihayaakasaka",
      "thName": "หมู่บ้านจิฮายะอากาซากะ",
      "viName": "làng Chihayaakasaka",
      "inName": "desa Chihayaakasaka",
      "tlName": "nayon ng Chihayaakasaka",
      "moName": "Чихaяaкасaка тосгон",
      "buName": "ကျီဟာယားကာဆာ့က ကျေးရွာ",
      "khName": "ភូមិ ជីហាយ៉ាកាសាកា",
      "neName": "चिहायाआकासाका गाउँ"
    }
  },
  "2810100": {
    "office": {
      "code": "280000",
      "name": "兵庫県",
      "enName": "Hyogo",
      "officeName": "神戸地方気象台",
      "chName": "兵库县",
      "zhName": "兵庫縣",
      "koName": "효고현",
      "esName": "Prefectura de Hyogo",
      "ptName": "Província de Hyōgo",
      "thName": "จังหวัดเฮียวโงะ",
      "viName": "Tỉnh Hyogo",
      "inName": "Prefektur Hyogo",
      "tlName": "Hyogo Prefecture",
      "moName": "Хёого аймаг",
      "buName": "ချိုးဂို ပြည်နယ်",
      "khName": "ខេត្ដ ហ៊ីយ៉ូហ្គូ",
      "neName": "ह्योगो जिल्ला"
    },
    "class10": {
      "code": "280010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "兵库县南部",
      "zhName": "兵庫縣南部",
      "koName": "효고 현 남부",
      "esName": "Sur de Prefectura de Hyogo",
      "ptName": "Sul da Província de Hyōgo",
      "thName": "จังหวัดเฮียวโงะตอนใต้",
      "viName": "Miền Nam tỉnh Hyogo",
      "inName": "Bagian Selatan Prefektur Hyogo",
      "tlName": "Timog na bahagi ng Hyogo Prefecture",
      "moName": "Өмнөд Хёого аймаг",
      "buName": "ဟယောဂိုစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដហ្យូហ្គុ",
      "neName": "ह्योगो जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "280011",
      "name": "阪神",
      "enName": "Hanshin"
    },
    "class20": {
      "code": "2810100",
      "name": "神戸市東灘区",
      "enName": "Kobe City Higashinada Ward",
      "kana": "こうべしひがしなだく"
    }
  },
  "2810200": {
    "office": {
      "code": "280000",
      "name": "兵庫県",
      "enName": "Hyogo",
      "officeName": "神戸地方気象台",
      "chName": "兵库县",
      "zhName": "兵庫縣",
      "koName": "효고현",
      "esName": "Prefectura de Hyogo",
      "ptName": "Província de Hyōgo",
      "thName": "จังหวัดเฮียวโงะ",
      "viName": "Tỉnh Hyogo",
      "inName": "Prefektur Hyogo",
      "tlName": "Hyogo Prefecture",
      "moName": "Хёого аймаг",
      "buName": "ချိုးဂို ပြည်နယ်",
      "khName": "ខេត្ដ ហ៊ីយ៉ូហ្គូ",
      "neName": "ह्योगो जिल्ला"
    },
    "class10": {
      "code": "280010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "兵库县南部",
      "zhName": "兵庫縣南部",
      "koName": "효고 현 남부",
      "esName": "Sur de Prefectura de Hyogo",
      "ptName": "Sul da Província de Hyōgo",
      "thName": "จังหวัดเฮียวโงะตอนใต้",
      "viName": "Miền Nam tỉnh Hyogo",
      "inName": "Bagian Selatan Prefektur Hyogo",
      "tlName": "Timog na bahagi ng Hyogo Prefecture",
      "moName": "Өмнөд Хёого аймаг",
      "buName": "ဟယောဂိုစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដហ្យូហ្គុ",
      "neName": "ह्योगो जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "280011",
      "name": "阪神",
      "enName": "Hanshin"
    },
    "class20": {
      "code": "2810200",
      "name": "神戸市灘区",
      "enName": "Kobe City Nada Ward",
      "kana": "こうべしなだく"
    }
  },
  "2810500": {
    "office": {
      "code": "280000",
      "name": "兵庫県",
      "enName": "Hyogo",
      "officeName": "神戸地方気象台",
      "chName": "兵库县",
      "zhName": "兵庫縣",
      "koName": "효고현",
      "esName": "Prefectura de Hyogo",
      "ptName": "Província de Hyōgo",
      "thName": "จังหวัดเฮียวโงะ",
      "viName": "Tỉnh Hyogo",
      "inName": "Prefektur Hyogo",
      "tlName": "Hyogo Prefecture",
      "moName": "Хёого аймаг",
      "buName": "ချိုးဂို ပြည်နယ်",
      "khName": "ខេត្ដ ហ៊ីយ៉ូហ្គូ",
      "neName": "ह्योगो जिल्ला"
    },
    "class10": {
      "code": "280010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "兵库县南部",
      "zhName": "兵庫縣南部",
      "koName": "효고 현 남부",
      "esName": "Sur de Prefectura de Hyogo",
      "ptName": "Sul da Província de Hyōgo",
      "thName": "จังหวัดเฮียวโงะตอนใต้",
      "viName": "Miền Nam tỉnh Hyogo",
      "inName": "Bagian Selatan Prefektur Hyogo",
      "tlName": "Timog na bahagi ng Hyogo Prefecture",
      "moName": "Өмнөд Хёого аймаг",
      "buName": "ဟယောဂိုစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដហ្យូហ្គុ",
      "neName": "ह्योगो जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "280011",
      "name": "阪神",
      "enName": "Hanshin"
    },
    "class20": {
      "code": "2810500",
      "name": "神戸市兵庫区",
      "enName": "Kobe City Hyogo Ward",
      "kana": "こうべしひょうごく"
    }
  },
  "2810600": {
    "office": {
      "code": "280000",
      "name": "兵庫県",
      "enName": "Hyogo",
      "officeName": "神戸地方気象台",
      "chName": "兵库县",
      "zhName": "兵庫縣",
      "koName": "효고현",
      "esName": "Prefectura de Hyogo",
      "ptName": "Província de Hyōgo",
      "thName": "จังหวัดเฮียวโงะ",
      "viName": "Tỉnh Hyogo",
      "inName": "Prefektur Hyogo",
      "tlName": "Hyogo Prefecture",
      "moName": "Хёого аймаг",
      "buName": "ချိုးဂို ပြည်နယ်",
      "khName": "ខេត្ដ ហ៊ីយ៉ូហ្គូ",
      "neName": "ह्योगो जिल्ला"
    },
    "class10": {
      "code": "280010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "兵库县南部",
      "zhName": "兵庫縣南部",
      "koName": "효고 현 남부",
      "esName": "Sur de Prefectura de Hyogo",
      "ptName": "Sul da Província de Hyōgo",
      "thName": "จังหวัดเฮียวโงะตอนใต้",
      "viName": "Miền Nam tỉnh Hyogo",
      "inName": "Bagian Selatan Prefektur Hyogo",
      "tlName": "Timog na bahagi ng Hyogo Prefecture",
      "moName": "Өмнөд Хёого аймаг",
      "buName": "ဟယောဂိုစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដហ្យូហ្គុ",
      "neName": "ह्योगो जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "280011",
      "name": "阪神",
      "enName": "Hanshin"
    },
    "class20": {
      "code": "2810600",
      "name": "神戸市長田区",
      "enName": "Kobe City Nagata Ward",
      "kana": "こうべしながたく"
    }
  },
  "2810700": {
    "office": {
      "code": "280000",
      "name": "兵庫県",
      "enName": "Hyogo",
      "officeName": "神戸地方気象台",
      "chName": "兵库县",
      "zhName": "兵庫縣",
      "koName": "효고현",
      "esName": "Prefectura de Hyogo",
      "ptName": "Província de Hyōgo",
      "thName": "จังหวัดเฮียวโงะ",
      "viName": "Tỉnh Hyogo",
      "inName": "Prefektur Hyogo",
      "tlName": "Hyogo Prefecture",
      "moName": "Хёого аймаг",
      "buName": "ချိုးဂို ပြည်နယ်",
      "khName": "ខេត្ដ ហ៊ីយ៉ូហ្គូ",
      "neName": "ह्योगो जिल्ला"
    },
    "class10": {
      "code": "280010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "兵库县南部",
      "zhName": "兵庫縣南部",
      "koName": "효고 현 남부",
      "esName": "Sur de Prefectura de Hyogo",
      "ptName": "Sul da Província de Hyōgo",
      "thName": "จังหวัดเฮียวโงะตอนใต้",
      "viName": "Miền Nam tỉnh Hyogo",
      "inName": "Bagian Selatan Prefektur Hyogo",
      "tlName": "Timog na bahagi ng Hyogo Prefecture",
      "moName": "Өмнөд Хёого аймаг",
      "buName": "ဟယောဂိုစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដហ្យូហ្គុ",
      "neName": "ह्योगो जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "280011",
      "name": "阪神",
      "enName": "Hanshin"
    },
    "class20": {
      "code": "2810700",
      "name": "神戸市須磨区",
      "enName": "Kobe City Suma Ward",
      "kana": "こうべしすまく"
    }
  },
  "2810800": {
    "office": {
      "code": "280000",
      "name": "兵庫県",
      "enName": "Hyogo",
      "officeName": "神戸地方気象台",
      "chName": "兵库县",
      "zhName": "兵庫縣",
      "koName": "효고현",
      "esName": "Prefectura de Hyogo",
      "ptName": "Província de Hyōgo",
      "thName": "จังหวัดเฮียวโงะ",
      "viName": "Tỉnh Hyogo",
      "inName": "Prefektur Hyogo",
      "tlName": "Hyogo Prefecture",
      "moName": "Хёого аймаг",
      "buName": "ချိုးဂို ပြည်နယ်",
      "khName": "ខេត្ដ ហ៊ីយ៉ូហ្គូ",
      "neName": "ह्योगो जिल्ला"
    },
    "class10": {
      "code": "280010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "兵库县南部",
      "zhName": "兵庫縣南部",
      "koName": "효고 현 남부",
      "esName": "Sur de Prefectura de Hyogo",
      "ptName": "Sul da Província de Hyōgo",
      "thName": "จังหวัดเฮียวโงะตอนใต้",
      "viName": "Miền Nam tỉnh Hyogo",
      "inName": "Bagian Selatan Prefektur Hyogo",
      "tlName": "Timog na bahagi ng Hyogo Prefecture",
      "moName": "Өмнөд Хёого аймаг",
      "buName": "ဟယောဂိုစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដហ្យូហ្គុ",
      "neName": "ह्योगो जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "280011",
      "name": "阪神",
      "enName": "Hanshin"
    },
    "class20": {
      "code": "2810800",
      "name": "神戸市垂水区",
      "enName": "Kobe City Tarumi Ward",
      "kana": "こうべしたるみく"
    }
  },
  "2810900": {
    "office": {
      "code": "280000",
      "name": "兵庫県",
      "enName": "Hyogo",
      "officeName": "神戸地方気象台",
      "chName": "兵库县",
      "zhName": "兵庫縣",
      "koName": "효고현",
      "esName": "Prefectura de Hyogo",
      "ptName": "Província de Hyōgo",
      "thName": "จังหวัดเฮียวโงะ",
      "viName": "Tỉnh Hyogo",
      "inName": "Prefektur Hyogo",
      "tlName": "Hyogo Prefecture",
      "moName": "Хёого аймаг",
      "buName": "ချိုးဂို ပြည်နယ်",
      "khName": "ខេត្ដ ហ៊ីយ៉ូហ្គូ",
      "neName": "ह्योगो जिल्ला"
    },
    "class10": {
      "code": "280010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "兵库县南部",
      "zhName": "兵庫縣南部",
      "koName": "효고 현 남부",
      "esName": "Sur de Prefectura de Hyogo",
      "ptName": "Sul da Província de Hyōgo",
      "thName": "จังหวัดเฮียวโงะตอนใต้",
      "viName": "Miền Nam tỉnh Hyogo",
      "inName": "Bagian Selatan Prefektur Hyogo",
      "tlName": "Timog na bahagi ng Hyogo Prefecture",
      "moName": "Өмнөд Хёого аймаг",
      "buName": "ဟယောဂိုစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដហ្យូហ្គុ",
      "neName": "ह्योगो जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "280011",
      "name": "阪神",
      "enName": "Hanshin"
    },
    "class20": {
      "code": "2810900",
      "name": "神戸市北区",
      "enName": "Kobe City Kita Ward",
      "kana": "こうべしきたく"
    }
  },
  "2811000": {
    "office": {
      "code": "280000",
      "name": "兵庫県",
      "enName": "Hyogo",
      "officeName": "神戸地方気象台",
      "chName": "兵库县",
      "zhName": "兵庫縣",
      "koName": "효고현",
      "esName": "Prefectura de Hyogo",
      "ptName": "Província de Hyōgo",
      "thName": "จังหวัดเฮียวโงะ",
      "viName": "Tỉnh Hyogo",
      "inName": "Prefektur Hyogo",
      "tlName": "Hyogo Prefecture",
      "moName": "Хёого аймаг",
      "buName": "ချိုးဂို ပြည်နယ်",
      "khName": "ខេត្ដ ហ៊ីយ៉ូហ្គូ",
      "neName": "ह्योगो जिल्ला"
    },
    "class10": {
      "code": "280010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "兵库县南部",
      "zhName": "兵庫縣南部",
      "koName": "효고 현 남부",
      "esName": "Sur de Prefectura de Hyogo",
      "ptName": "Sul da Província de Hyōgo",
      "thName": "จังหวัดเฮียวโงะตอนใต้",
      "viName": "Miền Nam tỉnh Hyogo",
      "inName": "Bagian Selatan Prefektur Hyogo",
      "tlName": "Timog na bahagi ng Hyogo Prefecture",
      "moName": "Өмнөд Хёого аймаг",
      "buName": "ဟယောဂိုစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដហ្យូហ្គុ",
      "neName": "ह्योगो जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "280011",
      "name": "阪神",
      "enName": "Hanshin"
    },
    "class20": {
      "code": "2811000",
      "name": "神戸市中央区",
      "enName": "Kobe City Chuo Ward",
      "kana": "こうべしちゅうおうく"
    }
  },
  "2811100": {
    "office": {
      "code": "280000",
      "name": "兵庫県",
      "enName": "Hyogo",
      "officeName": "神戸地方気象台",
      "chName": "兵库县",
      "zhName": "兵庫縣",
      "koName": "효고현",
      "esName": "Prefectura de Hyogo",
      "ptName": "Província de Hyōgo",
      "thName": "จังหวัดเฮียวโงะ",
      "viName": "Tỉnh Hyogo",
      "inName": "Prefektur Hyogo",
      "tlName": "Hyogo Prefecture",
      "moName": "Хёого аймаг",
      "buName": "ချိုးဂို ပြည်နယ်",
      "khName": "ខេត្ដ ហ៊ីយ៉ូហ្គូ",
      "neName": "ह्योगो जिल्ला"
    },
    "class10": {
      "code": "280010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "兵库县南部",
      "zhName": "兵庫縣南部",
      "koName": "효고 현 남부",
      "esName": "Sur de Prefectura de Hyogo",
      "ptName": "Sul da Província de Hyōgo",
      "thName": "จังหวัดเฮียวโงะตอนใต้",
      "viName": "Miền Nam tỉnh Hyogo",
      "inName": "Bagian Selatan Prefektur Hyogo",
      "tlName": "Timog na bahagi ng Hyogo Prefecture",
      "moName": "Өмнөд Хёого аймаг",
      "buName": "ဟယောဂိုစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដហ្យូហ្គុ",
      "neName": "ह्योगो जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "280011",
      "name": "阪神",
      "enName": "Hanshin"
    },
    "class20": {
      "code": "2811100",
      "name": "神戸市西区",
      "enName": "Kobe City Nishi Ward",
      "kana": "こうべしにしく"
    }
  },
  "2820100": {
    "office": {
      "code": "280000",
      "name": "兵庫県",
      "enName": "Hyogo",
      "officeName": "神戸地方気象台",
      "chName": "兵库县",
      "zhName": "兵庫縣",
      "koName": "효고현",
      "esName": "Prefectura de Hyogo",
      "ptName": "Província de Hyōgo",
      "thName": "จังหวัดเฮียวโงะ",
      "viName": "Tỉnh Hyogo",
      "inName": "Prefektur Hyogo",
      "tlName": "Hyogo Prefecture",
      "moName": "Хёого аймаг",
      "buName": "ချိုးဂို ပြည်နယ်",
      "khName": "ខេត្ដ ហ៊ីយ៉ូហ្គូ",
      "neName": "ह्योगो जिल्ला"
    },
    "class10": {
      "code": "280010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "兵库县南部",
      "zhName": "兵庫縣南部",
      "koName": "효고 현 남부",
      "esName": "Sur de Prefectura de Hyogo",
      "ptName": "Sul da Província de Hyōgo",
      "thName": "จังหวัดเฮียวโงะตอนใต้",
      "viName": "Miền Nam tỉnh Hyogo",
      "inName": "Bagian Selatan Prefektur Hyogo",
      "tlName": "Timog na bahagi ng Hyogo Prefecture",
      "moName": "Өмнөд Хёого аймаг",
      "buName": "ဟယောဂိုစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដហ្យូហ្គុ",
      "neName": "ह्योगो जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "280015",
      "name": "播磨南西部",
      "enName": "South-western Harima"
    },
    "class20": {
      "code": "2820100",
      "name": "姫路市",
      "enName": "Himeji City",
      "kana": "ひめじし",
      "chName": "姬路市",
      "zhName": "姬路市",
      "koName": "히메지 시",
      "esName": "Ciudad de Himeji",
      "ptName": "cidade de Himeji",
      "thName": "เมืองฮิเมจิ",
      "viName": "thành phố Himeji",
      "inName": "kota Himeji",
      "tlName": "siyudad ng Himeji",
      "moName": "Химэжи хот",
      "buName": "ဟီမဲ့ဂျိ မြို့",
      "khName": "ទីក្រុង ហ៊ីមីជី",
      "neName": "हिमेजी सहर"
    }
  },
  "2820200": {
    "office": {
      "code": "280000",
      "name": "兵庫県",
      "enName": "Hyogo",
      "officeName": "神戸地方気象台",
      "chName": "兵库县",
      "zhName": "兵庫縣",
      "koName": "효고현",
      "esName": "Prefectura de Hyogo",
      "ptName": "Província de Hyōgo",
      "thName": "จังหวัดเฮียวโงะ",
      "viName": "Tỉnh Hyogo",
      "inName": "Prefektur Hyogo",
      "tlName": "Hyogo Prefecture",
      "moName": "Хёого аймаг",
      "buName": "ချိုးဂို ပြည်နယ်",
      "khName": "ខេត្ដ ហ៊ីយ៉ូហ្គូ",
      "neName": "ह्योगो जिल्ला"
    },
    "class10": {
      "code": "280010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "兵库县南部",
      "zhName": "兵庫縣南部",
      "koName": "효고 현 남부",
      "esName": "Sur de Prefectura de Hyogo",
      "ptName": "Sul da Província de Hyōgo",
      "thName": "จังหวัดเฮียวโงะตอนใต้",
      "viName": "Miền Nam tỉnh Hyogo",
      "inName": "Bagian Selatan Prefektur Hyogo",
      "tlName": "Timog na bahagi ng Hyogo Prefecture",
      "moName": "Өмнөд Хёого аймаг",
      "buName": "ဟယောဂိုစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដហ្យូហ្គុ",
      "neName": "ह्योगो जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "280011",
      "name": "阪神",
      "enName": "Hanshin"
    },
    "class20": {
      "code": "2820200",
      "name": "尼崎市",
      "enName": "Amagasaki City",
      "kana": "あまがさきし",
      "chName": "尼崎市",
      "zhName": "尼崎市",
      "koName": "아마가사키 시",
      "esName": "Ciudad de Amagasaki",
      "ptName": "cidade de Amagasaki",
      "thName": "เมืองอามางาซากิ",
      "viName": "thành phố Amagasaki",
      "inName": "kota Amagasaki",
      "tlName": "siyudad ng Amagasaki",
      "moName": "Aмaгaсaки хот",
      "buName": "အမာဂါဆာ့ကိ မြို့",
      "khName": "ទីក្រុង អាម៉ាហ្គាសាគី",
      "neName": "आमागासाकी सहर"
    }
  },
  "2820300": {
    "office": {
      "code": "280000",
      "name": "兵庫県",
      "enName": "Hyogo",
      "officeName": "神戸地方気象台",
      "chName": "兵库县",
      "zhName": "兵庫縣",
      "koName": "효고현",
      "esName": "Prefectura de Hyogo",
      "ptName": "Província de Hyōgo",
      "thName": "จังหวัดเฮียวโงะ",
      "viName": "Tỉnh Hyogo",
      "inName": "Prefektur Hyogo",
      "tlName": "Hyogo Prefecture",
      "moName": "Хёого аймаг",
      "buName": "ချိုးဂို ပြည်နယ်",
      "khName": "ខេត្ដ ហ៊ីយ៉ូហ្គូ",
      "neName": "ह्योगो जिल्ला"
    },
    "class10": {
      "code": "280010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "兵库县南部",
      "zhName": "兵庫縣南部",
      "koName": "효고 현 남부",
      "esName": "Sur de Prefectura de Hyogo",
      "ptName": "Sul da Província de Hyōgo",
      "thName": "จังหวัดเฮียวโงะตอนใต้",
      "viName": "Miền Nam tỉnh Hyogo",
      "inName": "Bagian Selatan Prefektur Hyogo",
      "tlName": "Timog na bahagi ng Hyogo Prefecture",
      "moName": "Өмнөд Хёого аймаг",
      "buName": "ဟယောဂိုစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដហ្យូហ្គុ",
      "neName": "ह्योगो जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "280014",
      "name": "播磨南東部",
      "enName": "South-eastern Harima"
    },
    "class20": {
      "code": "2820300",
      "name": "明石市",
      "enName": "Akashi City",
      "kana": "あかしし",
      "chName": "明石市",
      "zhName": "明石市",
      "koName": "아카시 시",
      "esName": "Ciudad de Akashi",
      "ptName": "cidade de Akashi",
      "thName": "เมืองอากาชิ",
      "viName": "thành phố Akashi",
      "inName": "kota Akashi",
      "tlName": "siyudad ng Akashi",
      "moName": "Aкаши хот",
      "buName": "အကာ့ရှိ မြို့",
      "khName": "ទីក្រុង អាកាស៊ី",
      "neName": "आकाशि सहर"
    }
  },
  "2820400": {
    "office": {
      "code": "280000",
      "name": "兵庫県",
      "enName": "Hyogo",
      "officeName": "神戸地方気象台",
      "chName": "兵库县",
      "zhName": "兵庫縣",
      "koName": "효고현",
      "esName": "Prefectura de Hyogo",
      "ptName": "Província de Hyōgo",
      "thName": "จังหวัดเฮียวโงะ",
      "viName": "Tỉnh Hyogo",
      "inName": "Prefektur Hyogo",
      "tlName": "Hyogo Prefecture",
      "moName": "Хёого аймаг",
      "buName": "ချိုးဂို ပြည်နယ်",
      "khName": "ខេត្ដ ហ៊ីយ៉ូហ្គូ",
      "neName": "ह्योगो जिल्ला"
    },
    "class10": {
      "code": "280010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "兵库县南部",
      "zhName": "兵庫縣南部",
      "koName": "효고 현 남부",
      "esName": "Sur de Prefectura de Hyogo",
      "ptName": "Sul da Província de Hyōgo",
      "thName": "จังหวัดเฮียวโงะตอนใต้",
      "viName": "Miền Nam tỉnh Hyogo",
      "inName": "Bagian Selatan Prefektur Hyogo",
      "tlName": "Timog na bahagi ng Hyogo Prefecture",
      "moName": "Өмнөд Хёого аймаг",
      "buName": "ဟယောဂိုစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដហ្យូហ្គុ",
      "neName": "ह्योगो जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "280011",
      "name": "阪神",
      "enName": "Hanshin"
    },
    "class20": {
      "code": "2820400",
      "name": "西宮市",
      "enName": "Nishinomiya City",
      "kana": "にしのみやし",
      "chName": "西宫市",
      "zhName": "西宮市",
      "koName": "니시노미야 시",
      "esName": "Ciudad de Nishinomiya",
      "ptName": "cidade de Nishinomiya",
      "thName": "เมืองนิชิโนะมิยะ",
      "viName": "thành phố Nishinomiya",
      "inName": "kota Nishinomiya",
      "tlName": "siyudad ng Nishinomiya",
      "moName": "Нишиномия хот",
      "buName": "နီရှိနောမိယ မြို့",
      "khName": "ទីក្រុង នីស៊ីនអូមីយ៉ា",
      "neName": "निशिनोमिया सहर"
    }
  },
  "2820500": {
    "office": {
      "code": "280000",
      "name": "兵庫県",
      "enName": "Hyogo",
      "officeName": "神戸地方気象台",
      "chName": "兵库县",
      "zhName": "兵庫縣",
      "koName": "효고현",
      "esName": "Prefectura de Hyogo",
      "ptName": "Província de Hyōgo",
      "thName": "จังหวัดเฮียวโงะ",
      "viName": "Tỉnh Hyogo",
      "inName": "Prefektur Hyogo",
      "tlName": "Hyogo Prefecture",
      "moName": "Хёого аймаг",
      "buName": "ချိုးဂို ပြည်နယ်",
      "khName": "ខេត្ដ ហ៊ីយ៉ូហ្គូ",
      "neName": "ह्योगो जिल्ला"
    },
    "class10": {
      "code": "280010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "兵库县南部",
      "zhName": "兵庫縣南部",
      "koName": "효고 현 남부",
      "esName": "Sur de Prefectura de Hyogo",
      "ptName": "Sul da Província de Hyōgo",
      "thName": "จังหวัดเฮียวโงะตอนใต้",
      "viName": "Miền Nam tỉnh Hyogo",
      "inName": "Bagian Selatan Prefektur Hyogo",
      "tlName": "Timog na bahagi ng Hyogo Prefecture",
      "moName": "Өмнөд Хёого аймаг",
      "buName": "ဟယောဂိုစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដហ្យូហ្គុ",
      "neName": "ह्योगो जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "280016",
      "name": "淡路島",
      "enName": "Awajishima"
    },
    "class20": {
      "code": "2820500",
      "name": "洲本市",
      "enName": "Sumoto City",
      "kana": "すもとし",
      "chName": "洲本市",
      "zhName": "洲本市",
      "koName": "스모토 시",
      "esName": "Ciudad de Sumoto",
      "ptName": "cidade de Sumoto",
      "thName": "เมืองซูโมโตะ",
      "viName": "thành phố Sumoto",
      "inName": "kota Sumoto",
      "tlName": "siyudad ng Sumoto",
      "moName": "Сүмото хот",
      "buName": "ဆုမိုတို မြို့",
      "khName": "ទីក្រុង ស៊ូម៉ូតុ",
      "neName": "सुमोतो सहर"
    }
  },
  "2820600": {
    "office": {
      "code": "280000",
      "name": "兵庫県",
      "enName": "Hyogo",
      "officeName": "神戸地方気象台",
      "chName": "兵库县",
      "zhName": "兵庫縣",
      "koName": "효고현",
      "esName": "Prefectura de Hyogo",
      "ptName": "Província de Hyōgo",
      "thName": "จังหวัดเฮียวโงะ",
      "viName": "Tỉnh Hyogo",
      "inName": "Prefektur Hyogo",
      "tlName": "Hyogo Prefecture",
      "moName": "Хёого аймаг",
      "buName": "ချိုးဂို ပြည်နယ်",
      "khName": "ខេត្ដ ហ៊ីយ៉ូហ្គូ",
      "neName": "ह्योगो जिल्ला"
    },
    "class10": {
      "code": "280010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "兵库县南部",
      "zhName": "兵庫縣南部",
      "koName": "효고 현 남부",
      "esName": "Sur de Prefectura de Hyogo",
      "ptName": "Sul da Província de Hyōgo",
      "thName": "จังหวัดเฮียวโงะตอนใต้",
      "viName": "Miền Nam tỉnh Hyogo",
      "inName": "Bagian Selatan Prefektur Hyogo",
      "tlName": "Timog na bahagi ng Hyogo Prefecture",
      "moName": "Өмнөд Хёого аймаг",
      "buName": "ဟယောဂိုစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដហ្យូហ្គុ",
      "neName": "ह्योगो जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "280011",
      "name": "阪神",
      "enName": "Hanshin"
    },
    "class20": {
      "code": "2820600",
      "name": "芦屋市",
      "enName": "Ashiya City",
      "kana": "あしやし",
      "chName": "芦屋市",
      "zhName": "蘆屋市",
      "koName": "아시야 시",
      "esName": "Ciudad de Ashiya",
      "ptName": "cidade de Ashiya",
      "thName": "เมืองอาชิยะ",
      "viName": "thành phố Ashiya",
      "inName": "kota Ashiya",
      "tlName": "siyudad ng Ashiya",
      "moName": "Aшия хот",
      "buName": "အရှီယ မြို့",
      "khName": "ទីក្រុង អាស៊ីយ៉ា",
      "neName": "आशिया सहर"
    }
  },
  "2820700": {
    "office": {
      "code": "280000",
      "name": "兵庫県",
      "enName": "Hyogo",
      "officeName": "神戸地方気象台",
      "chName": "兵库县",
      "zhName": "兵庫縣",
      "koName": "효고현",
      "esName": "Prefectura de Hyogo",
      "ptName": "Província de Hyōgo",
      "thName": "จังหวัดเฮียวโงะ",
      "viName": "Tỉnh Hyogo",
      "inName": "Prefektur Hyogo",
      "tlName": "Hyogo Prefecture",
      "moName": "Хёого аймаг",
      "buName": "ချိုးဂို ပြည်နယ်",
      "khName": "ខេត្ដ ហ៊ីយ៉ូហ្គូ",
      "neName": "ह्योगो जिल्ला"
    },
    "class10": {
      "code": "280010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "兵库县南部",
      "zhName": "兵庫縣南部",
      "koName": "효고 현 남부",
      "esName": "Sur de Prefectura de Hyogo",
      "ptName": "Sul da Província de Hyōgo",
      "thName": "จังหวัดเฮียวโงะตอนใต้",
      "viName": "Miền Nam tỉnh Hyogo",
      "inName": "Bagian Selatan Prefektur Hyogo",
      "tlName": "Timog na bahagi ng Hyogo Prefecture",
      "moName": "Өмнөд Хёого аймаг",
      "buName": "ဟယောဂိုစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដហ្យូហ្គុ",
      "neName": "ह्योगो जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "280011",
      "name": "阪神",
      "enName": "Hanshin"
    },
    "class20": {
      "code": "2820700",
      "name": "伊丹市",
      "enName": "Itami City",
      "kana": "いたみし",
      "chName": "伊丹市",
      "zhName": "伊丹市",
      "koName": "이타미 시",
      "esName": "Ciudad de Itami",
      "ptName": "cidade de Itami",
      "thName": "เมืองอิตามิ",
      "viName": "thành phố Itami",
      "inName": "kota Itami",
      "tlName": "siyudad ng Itami",
      "moName": "Итами хот",
      "buName": "အီတာ့မိ မြို့",
      "khName": "ទីក្រុង អ៊ីតាមី",
      "neName": "इतामी सहर"
    }
  },
  "2820800": {
    "office": {
      "code": "280000",
      "name": "兵庫県",
      "enName": "Hyogo",
      "officeName": "神戸地方気象台",
      "chName": "兵库县",
      "zhName": "兵庫縣",
      "koName": "효고현",
      "esName": "Prefectura de Hyogo",
      "ptName": "Província de Hyōgo",
      "thName": "จังหวัดเฮียวโงะ",
      "viName": "Tỉnh Hyogo",
      "inName": "Prefektur Hyogo",
      "tlName": "Hyogo Prefecture",
      "moName": "Хёого аймаг",
      "buName": "ချိုးဂို ပြည်နယ်",
      "khName": "ខេត្ដ ហ៊ីយ៉ូហ្គូ",
      "neName": "ह्योगो जिल्ला"
    },
    "class10": {
      "code": "280010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "兵库县南部",
      "zhName": "兵庫縣南部",
      "koName": "효고 현 남부",
      "esName": "Sur de Prefectura de Hyogo",
      "ptName": "Sul da Província de Hyōgo",
      "thName": "จังหวัดเฮียวโงะตอนใต้",
      "viName": "Miền Nam tỉnh Hyogo",
      "inName": "Bagian Selatan Prefektur Hyogo",
      "tlName": "Timog na bahagi ng Hyogo Prefecture",
      "moName": "Өмнөд Хёого аймаг",
      "buName": "ဟယောဂိုစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដហ្យូហ្គុ",
      "neName": "ह्योगो जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "280015",
      "name": "播磨南西部",
      "enName": "South-western Harima"
    },
    "class20": {
      "code": "2820800",
      "name": "相生市",
      "enName": "Aioi City",
      "kana": "あいおいし",
      "chName": "相生市",
      "zhName": "相生市",
      "koName": "아이오이 시",
      "esName": "Ciudad de Aioi",
      "ptName": "cidade de Aioi",
      "thName": "เมืองไอโออิ",
      "viName": "thành phố Aioi",
      "inName": "kota Aioi",
      "tlName": "siyudad ng Aioi",
      "moName": "Aйой хот",
      "buName": "အိုင်းယိုးယိ မြို့",
      "khName": "ទីក្រុង អាយអយ",
      "neName": "आइओई सहर"
    }
  },
  "2820900": {
    "office": {
      "code": "280000",
      "name": "兵庫県",
      "enName": "Hyogo",
      "officeName": "神戸地方気象台",
      "chName": "兵库县",
      "zhName": "兵庫縣",
      "koName": "효고현",
      "esName": "Prefectura de Hyogo",
      "ptName": "Província de Hyōgo",
      "thName": "จังหวัดเฮียวโงะ",
      "viName": "Tỉnh Hyogo",
      "inName": "Prefektur Hyogo",
      "tlName": "Hyogo Prefecture",
      "moName": "Хёого аймаг",
      "buName": "ချိုးဂို ပြည်နယ်",
      "khName": "ខេត្ដ ហ៊ីយ៉ូហ្គូ",
      "neName": "ह्योगो जिल्ला"
    },
    "class10": {
      "code": "280020",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "兵库县北部",
      "zhName": "兵庫縣北部",
      "koName": "효고 현 북부",
      "esName": "Norte de Prefectura de Hyogo",
      "ptName": "Norte da Província de Hyōgo",
      "thName": "จังหวัดเฮียวโงะตอนเหนือ",
      "viName": "Miền Bắc tỉnh Hyogo",
      "inName": "Bagian Utara Prefektur Hyogo",
      "tlName": "Hilagang bahagi ng Hyogo Prefecture",
      "moName": "Хойд Хёого аймаг",
      "buName": "ဟယောဂိုစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដហ្យូហ្គុ",
      "neName": "ह्योगो जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "280021",
      "name": "但馬北部",
      "enName": "Northern Tajima"
    },
    "class20": {
      "code": "2820900",
      "name": "豊岡市",
      "enName": "Toyooka City",
      "kana": "とよおかし",
      "chName": "丰冈市",
      "zhName": "豐岡市",
      "koName": "도요오카 시",
      "esName": "Ciudad de Toyooka",
      "ptName": "cidade de Toyooka",
      "thName": "เมืองโตโยกะ",
      "viName": "thành phố Toyooka",
      "inName": "kota Toyooka",
      "tlName": "siyudad ng Toyooka",
      "moName": "Тоёоока хот",
      "buName": "တိုယိုအိုးက မြို့",
      "khName": "ទីក្រុង តូយូកា",
      "neName": "तोयोओका सहर"
    }
  },
  "2821000": {
    "office": {
      "code": "280000",
      "name": "兵庫県",
      "enName": "Hyogo",
      "officeName": "神戸地方気象台",
      "chName": "兵库县",
      "zhName": "兵庫縣",
      "koName": "효고현",
      "esName": "Prefectura de Hyogo",
      "ptName": "Província de Hyōgo",
      "thName": "จังหวัดเฮียวโงะ",
      "viName": "Tỉnh Hyogo",
      "inName": "Prefektur Hyogo",
      "tlName": "Hyogo Prefecture",
      "moName": "Хёого аймаг",
      "buName": "ချိုးဂို ပြည်နယ်",
      "khName": "ខេត្ដ ហ៊ីយ៉ូហ្គូ",
      "neName": "ह्योगो जिल्ला"
    },
    "class10": {
      "code": "280010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "兵库县南部",
      "zhName": "兵庫縣南部",
      "koName": "효고 현 남부",
      "esName": "Sur de Prefectura de Hyogo",
      "ptName": "Sul da Província de Hyōgo",
      "thName": "จังหวัดเฮียวโงะตอนใต้",
      "viName": "Miền Nam tỉnh Hyogo",
      "inName": "Bagian Selatan Prefektur Hyogo",
      "tlName": "Timog na bahagi ng Hyogo Prefecture",
      "moName": "Өмнөд Хёого аймаг",
      "buName": "ဟယောဂိုစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដហ្យូហ្គុ",
      "neName": "ह्योगो जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "280014",
      "name": "播磨南東部",
      "enName": "South-eastern Harima"
    },
    "class20": {
      "code": "2821000",
      "name": "加古川市",
      "enName": "Kakogawa City",
      "kana": "かこがわし",
      "chName": "加古川市",
      "zhName": "加古川市",
      "koName": "가코가와 시",
      "esName": "Ciudad de Kakogawa",
      "ptName": "cidade de Kakogawa",
      "thName": "เมืองคาโคกาวะ",
      "viName": "thành phố Kakogawa",
      "inName": "kota Kakogawa",
      "tlName": "siyudad ng Kakogawa",
      "moName": "Какогава хот",
      "buName": "ခါကိုးဂါ့ဝ မြို့",
      "khName": "ទីក្រុង កាកូហ្គាវ៉ា",
      "neName": "काकोगावा सहर"
    }
  },
  "2821200": {
    "office": {
      "code": "280000",
      "name": "兵庫県",
      "enName": "Hyogo",
      "officeName": "神戸地方気象台",
      "chName": "兵库县",
      "zhName": "兵庫縣",
      "koName": "효고현",
      "esName": "Prefectura de Hyogo",
      "ptName": "Província de Hyōgo",
      "thName": "จังหวัดเฮียวโงะ",
      "viName": "Tỉnh Hyogo",
      "inName": "Prefektur Hyogo",
      "tlName": "Hyogo Prefecture",
      "moName": "Хёого аймаг",
      "buName": "ချိုးဂို ပြည်နယ်",
      "khName": "ខេត្ដ ហ៊ីយ៉ូហ្គូ",
      "neName": "ह्योगो जिल्ला"
    },
    "class10": {
      "code": "280010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "兵库县南部",
      "zhName": "兵庫縣南部",
      "koName": "효고 현 남부",
      "esName": "Sur de Prefectura de Hyogo",
      "ptName": "Sul da Província de Hyōgo",
      "thName": "จังหวัดเฮียวโงะตอนใต้",
      "viName": "Miền Nam tỉnh Hyogo",
      "inName": "Bagian Selatan Prefektur Hyogo",
      "tlName": "Timog na bahagi ng Hyogo Prefecture",
      "moName": "Өмнөд Хёого аймаг",
      "buName": "ဟယောဂိုစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដហ្យូហ្គុ",
      "neName": "ह्योगो जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "280015",
      "name": "播磨南西部",
      "enName": "South-western Harima"
    },
    "class20": {
      "code": "2821200",
      "name": "赤穂市",
      "enName": "Ako City",
      "kana": "あこうし",
      "chName": "赤穗市",
      "zhName": "赤穗市",
      "koName": "아코 시",
      "esName": "Ciudad de Akō",
      "ptName": "cidade de Ako",
      "thName": "เมืองอะโกะ",
      "viName": "thành phố Ako",
      "inName": "kota Ako",
      "tlName": "siyudad ng Ako",
      "moName": "Aко хот",
      "buName": "အာကော့ မြို့",
      "khName": "ទីក្រុង អាកូ",
      "neName": "आको सहर"
    }
  },
  "2821300": {
    "office": {
      "code": "280000",
      "name": "兵庫県",
      "enName": "Hyogo",
      "officeName": "神戸地方気象台",
      "chName": "兵库县",
      "zhName": "兵庫縣",
      "koName": "효고현",
      "esName": "Prefectura de Hyogo",
      "ptName": "Província de Hyōgo",
      "thName": "จังหวัดเฮียวโงะ",
      "viName": "Tỉnh Hyogo",
      "inName": "Prefektur Hyogo",
      "tlName": "Hyogo Prefecture",
      "moName": "Хёого аймаг",
      "buName": "ချိုးဂို ပြည်နယ်",
      "khName": "ខេត្ដ ហ៊ីយ៉ូហ្គូ",
      "neName": "ह्योगो जिल्ला"
    },
    "class10": {
      "code": "280010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "兵库县南部",
      "zhName": "兵庫縣南部",
      "koName": "효고 현 남부",
      "esName": "Sur de Prefectura de Hyogo",
      "ptName": "Sul da Província de Hyōgo",
      "thName": "จังหวัดเฮียวโงะตอนใต้",
      "viName": "Miền Nam tỉnh Hyogo",
      "inName": "Bagian Selatan Prefektur Hyogo",
      "tlName": "Timog na bahagi ng Hyogo Prefecture",
      "moName": "Өмнөд Хёого аймаг",
      "buName": "ဟယောဂိုစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដហ្យូហ្គុ",
      "neName": "ह्योगो जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "280012",
      "name": "北播丹波",
      "enName": "Hokuban Tamba"
    },
    "class20": {
      "code": "2821300",
      "name": "西脇市",
      "enName": "Nishiwaki City",
      "kana": "にしわきし",
      "chName": "西胁市",
      "zhName": "西脇市",
      "koName": "니시와키 시",
      "esName": "Ciudad de Nishiwaki",
      "ptName": "cidade de Nishiwaki",
      "thName": "เมืองนิชิวากิ",
      "viName": "thành phố Nishiwaki",
      "inName": "kota Nishiwaki",
      "tlName": "siyudad ng Nishiwaki",
      "moName": "Нишиваки хот",
      "buName": "နီရှိဝါ့ကိ မြို့",
      "khName": "ទីក្រុង នីស៊ីវ៉ាគី",
      "neName": "निशिवाकी सहर"
    }
  },
  "2821400": {
    "office": {
      "code": "280000",
      "name": "兵庫県",
      "enName": "Hyogo",
      "officeName": "神戸地方気象台",
      "chName": "兵库县",
      "zhName": "兵庫縣",
      "koName": "효고현",
      "esName": "Prefectura de Hyogo",
      "ptName": "Província de Hyōgo",
      "thName": "จังหวัดเฮียวโงะ",
      "viName": "Tỉnh Hyogo",
      "inName": "Prefektur Hyogo",
      "tlName": "Hyogo Prefecture",
      "moName": "Хёого аймаг",
      "buName": "ချိုးဂို ပြည်နယ်",
      "khName": "ខេត្ដ ហ៊ីយ៉ូហ្គូ",
      "neName": "ह्योगो जिल्ला"
    },
    "class10": {
      "code": "280010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "兵库县南部",
      "zhName": "兵庫縣南部",
      "koName": "효고 현 남부",
      "esName": "Sur de Prefectura de Hyogo",
      "ptName": "Sul da Província de Hyōgo",
      "thName": "จังหวัดเฮียวโงะตอนใต้",
      "viName": "Miền Nam tỉnh Hyogo",
      "inName": "Bagian Selatan Prefektur Hyogo",
      "tlName": "Timog na bahagi ng Hyogo Prefecture",
      "moName": "Өмнөд Хёого аймаг",
      "buName": "ဟယောဂိုစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដហ្យូហ្គុ",
      "neName": "ह्योगो जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "280011",
      "name": "阪神",
      "enName": "Hanshin"
    },
    "class20": {
      "code": "2821400",
      "name": "宝塚市",
      "enName": "Takarazuka City",
      "kana": "たからづかし",
      "chName": "宝冢市",
      "zhName": "寶塚市",
      "koName": "다카라즈카 시",
      "esName": "Ciudad de Takarazuka",
      "ptName": "cidade de Takarazuka",
      "thName": "เมืองทาการาซูกะ",
      "viName": "thành phố Takarazuka",
      "inName": "kota Takarazuka",
      "tlName": "siyudad ng Takarazuka",
      "moName": "Такаразүка хот",
      "buName": "တာကာရာ့ဇုက မြို့",
      "khName": "ទីក្រុង តាការ៉ាហ្សូកា",
      "neName": "ताकाराजुका सहर"
    }
  },
  "2821500": {
    "office": {
      "code": "280000",
      "name": "兵庫県",
      "enName": "Hyogo",
      "officeName": "神戸地方気象台",
      "chName": "兵库县",
      "zhName": "兵庫縣",
      "koName": "효고현",
      "esName": "Prefectura de Hyogo",
      "ptName": "Província de Hyōgo",
      "thName": "จังหวัดเฮียวโงะ",
      "viName": "Tỉnh Hyogo",
      "inName": "Prefektur Hyogo",
      "tlName": "Hyogo Prefecture",
      "moName": "Хёого аймаг",
      "buName": "ချိုးဂို ပြည်နယ်",
      "khName": "ខេត្ដ ហ៊ីយ៉ូហ្គូ",
      "neName": "ह्योगो जिल्ला"
    },
    "class10": {
      "code": "280010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "兵库县南部",
      "zhName": "兵庫縣南部",
      "koName": "효고 현 남부",
      "esName": "Sur de Prefectura de Hyogo",
      "ptName": "Sul da Província de Hyōgo",
      "thName": "จังหวัดเฮียวโงะตอนใต้",
      "viName": "Miền Nam tỉnh Hyogo",
      "inName": "Bagian Selatan Prefektur Hyogo",
      "tlName": "Timog na bahagi ng Hyogo Prefecture",
      "moName": "Өмнөд Хёого аймаг",
      "buName": "ဟယောဂိုစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដហ្យូហ្គុ",
      "neName": "ह्योगो जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "280014",
      "name": "播磨南東部",
      "enName": "South-eastern Harima"
    },
    "class20": {
      "code": "2821500",
      "name": "三木市",
      "enName": "Miki City",
      "kana": "みきし",
      "chName": "三木市 ",
      "zhName": "三木市",
      "koName": "미키 시",
      "esName": "Ciudad de Miki",
      "ptName": "cidade de Miki",
      "thName": "เมืองมิกิ",
      "viName": "thành phố Miki",
      "inName": "kota Miki",
      "tlName": "siyudad ng Miki",
      "moName": "Мики хот",
      "buName": "မီကိ မြို့",
      "khName": "ទីក្រុង មីគី",
      "neName": "मिकी सहर"
    }
  },
  "2821600": {
    "office": {
      "code": "280000",
      "name": "兵庫県",
      "enName": "Hyogo",
      "officeName": "神戸地方気象台",
      "chName": "兵库县",
      "zhName": "兵庫縣",
      "koName": "효고현",
      "esName": "Prefectura de Hyogo",
      "ptName": "Província de Hyōgo",
      "thName": "จังหวัดเฮียวโงะ",
      "viName": "Tỉnh Hyogo",
      "inName": "Prefektur Hyogo",
      "tlName": "Hyogo Prefecture",
      "moName": "Хёого аймаг",
      "buName": "ချိုးဂို ပြည်နယ်",
      "khName": "ខេត្ដ ហ៊ីយ៉ូហ្គូ",
      "neName": "ह्योगो जिल्ला"
    },
    "class10": {
      "code": "280010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "兵库县南部",
      "zhName": "兵庫縣南部",
      "koName": "효고 현 남부",
      "esName": "Sur de Prefectura de Hyogo",
      "ptName": "Sul da Província de Hyōgo",
      "thName": "จังหวัดเฮียวโงะตอนใต้",
      "viName": "Miền Nam tỉnh Hyogo",
      "inName": "Bagian Selatan Prefektur Hyogo",
      "tlName": "Timog na bahagi ng Hyogo Prefecture",
      "moName": "Өмнөд Хёого аймаг",
      "buName": "ဟယောဂိုစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដហ្យូហ្គុ",
      "neName": "ह्योगो जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "280014",
      "name": "播磨南東部",
      "enName": "South-eastern Harima"
    },
    "class20": {
      "code": "2821600",
      "name": "高砂市",
      "enName": "Takasago City",
      "kana": "たかさごし",
      "chName": "高砂市",
      "zhName": "髙砂市",
      "koName": "다카사고 시",
      "esName": "Ciudad de Takasago",
      "ptName": "cidade de Takasago",
      "thName": "เมืองทากาซาโกะ",
      "viName": "thành phố Takasago",
      "inName": "kota Takasago",
      "tlName": "siyudad ng Takasago",
      "moName": "Такасаго хот",
      "buName": "တာကာဆာဂို မြို့",
      "khName": "ទីក្រុង តាកាសាហ្គូ",
      "neName": "ताकासागो सहर"
    }
  },
  "2821700": {
    "office": {
      "code": "280000",
      "name": "兵庫県",
      "enName": "Hyogo",
      "officeName": "神戸地方気象台",
      "chName": "兵库县",
      "zhName": "兵庫縣",
      "koName": "효고현",
      "esName": "Prefectura de Hyogo",
      "ptName": "Província de Hyōgo",
      "thName": "จังหวัดเฮียวโงะ",
      "viName": "Tỉnh Hyogo",
      "inName": "Prefektur Hyogo",
      "tlName": "Hyogo Prefecture",
      "moName": "Хёого аймаг",
      "buName": "ချိုးဂို ပြည်နယ်",
      "khName": "ខេត្ដ ហ៊ីយ៉ូហ្គូ",
      "neName": "ह्योगो जिल्ला"
    },
    "class10": {
      "code": "280010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "兵库县南部",
      "zhName": "兵庫縣南部",
      "koName": "효고 현 남부",
      "esName": "Sur de Prefectura de Hyogo",
      "ptName": "Sul da Província de Hyōgo",
      "thName": "จังหวัดเฮียวโงะตอนใต้",
      "viName": "Miền Nam tỉnh Hyogo",
      "inName": "Bagian Selatan Prefektur Hyogo",
      "tlName": "Timog na bahagi ng Hyogo Prefecture",
      "moName": "Өмнөд Хёого аймаг",
      "buName": "ဟယောဂိုစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដហ្យូហ្គុ",
      "neName": "ह्योगो जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "280011",
      "name": "阪神",
      "enName": "Hanshin"
    },
    "class20": {
      "code": "2821700",
      "name": "川西市",
      "enName": "Kawanishi City",
      "kana": "かわにしし",
      "chName": "川西市",
      "zhName": "川西市",
      "koName": "가와니시 시",
      "esName": "Ciudad de Kawanishi",
      "ptName": "cidade de Kawanishi",
      "thName": "เมืองคาวานิชิ",
      "viName": "thành phố Kaw Biếni",
      "inName": "kota Kawanishi",
      "tlName": "siyudad ng Kawanishi",
      "moName": "Каваниши хот",
      "buName": "ကာဝါ့နိရှိ မြို့",
      "khName": "ទីក្រុង កាវ៉ាន់នីស៊ី",
      "neName": "कावानिशि सहर"
    }
  },
  "2821800": {
    "office": {
      "code": "280000",
      "name": "兵庫県",
      "enName": "Hyogo",
      "officeName": "神戸地方気象台",
      "chName": "兵库县",
      "zhName": "兵庫縣",
      "koName": "효고현",
      "esName": "Prefectura de Hyogo",
      "ptName": "Província de Hyōgo",
      "thName": "จังหวัดเฮียวโงะ",
      "viName": "Tỉnh Hyogo",
      "inName": "Prefektur Hyogo",
      "tlName": "Hyogo Prefecture",
      "moName": "Хёого аймаг",
      "buName": "ချိုးဂို ပြည်နယ်",
      "khName": "ខេត្ដ ហ៊ីយ៉ូហ្គូ",
      "neName": "ह्योगो जिल्ला"
    },
    "class10": {
      "code": "280010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "兵库县南部",
      "zhName": "兵庫縣南部",
      "koName": "효고 현 남부",
      "esName": "Sur de Prefectura de Hyogo",
      "ptName": "Sul da Província de Hyōgo",
      "thName": "จังหวัดเฮียวโงะตอนใต้",
      "viName": "Miền Nam tỉnh Hyogo",
      "inName": "Bagian Selatan Prefektur Hyogo",
      "tlName": "Timog na bahagi ng Hyogo Prefecture",
      "moName": "Өмнөд Хёого аймаг",
      "buName": "ဟယောဂိုစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដហ្យូហ្គុ",
      "neName": "ह्योगो जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "280014",
      "name": "播磨南東部",
      "enName": "South-eastern Harima"
    },
    "class20": {
      "code": "2821800",
      "name": "小野市",
      "enName": "Ono City",
      "kana": "おのし",
      "chName": "小野市",
      "zhName": "小野市",
      "koName": "오노 시",
      "esName": "Ciudad de Ono",
      "ptName": "cidade de Ono",
      "thName": "เมืองโอโนะ",
      "viName": "thành phố Ono",
      "inName": "kota Ono",
      "tlName": "siyudad ng Ono",
      "moName": "Оно хот",
      "buName": "အိုနို မြို့",
      "khName": "ទីក្រុង អូណូ",
      "neName": "ओनो सहर"
    }
  },
  "2821900": {
    "office": {
      "code": "280000",
      "name": "兵庫県",
      "enName": "Hyogo",
      "officeName": "神戸地方気象台",
      "chName": "兵库县",
      "zhName": "兵庫縣",
      "koName": "효고현",
      "esName": "Prefectura de Hyogo",
      "ptName": "Província de Hyōgo",
      "thName": "จังหวัดเฮียวโงะ",
      "viName": "Tỉnh Hyogo",
      "inName": "Prefektur Hyogo",
      "tlName": "Hyogo Prefecture",
      "moName": "Хёого аймаг",
      "buName": "ချိုးဂို ပြည်နယ်",
      "khName": "ខេត្ដ ហ៊ីយ៉ូហ្គូ",
      "neName": "ह्योगो जिल्ला"
    },
    "class10": {
      "code": "280010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "兵库县南部",
      "zhName": "兵庫縣南部",
      "koName": "효고 현 남부",
      "esName": "Sur de Prefectura de Hyogo",
      "ptName": "Sul da Província de Hyōgo",
      "thName": "จังหวัดเฮียวโงะตอนใต้",
      "viName": "Miền Nam tỉnh Hyogo",
      "inName": "Bagian Selatan Prefektur Hyogo",
      "tlName": "Timog na bahagi ng Hyogo Prefecture",
      "moName": "Өмнөд Хёого аймаг",
      "buName": "ဟယောဂိုစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដហ្យូហ្គុ",
      "neName": "ह्योगो जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "280011",
      "name": "阪神",
      "enName": "Hanshin"
    },
    "class20": {
      "code": "2821900",
      "name": "三田市",
      "enName": "Sanda City",
      "kana": "さんだし",
      "chName": "三田市",
      "zhName": "三田市",
      "koName": "산다 시",
      "esName": "Ciudad de Sanda",
      "ptName": "cidade de Sanda",
      "thName": "เมืองซานดะ",
      "viName": "thành phố Sanda",
      "inName": "kota Sanda",
      "tlName": "siyudad ng Sanda",
      "moName": "Сaнда хот",
      "buName": "ဆန်းဒ မြို့",
      "khName": "ទីក្រុង សាន់ដា",
      "neName": "सान्दा सहर"
    }
  },
  "2822000": {
    "office": {
      "code": "280000",
      "name": "兵庫県",
      "enName": "Hyogo",
      "officeName": "神戸地方気象台",
      "chName": "兵库县",
      "zhName": "兵庫縣",
      "koName": "효고현",
      "esName": "Prefectura de Hyogo",
      "ptName": "Província de Hyōgo",
      "thName": "จังหวัดเฮียวโงะ",
      "viName": "Tỉnh Hyogo",
      "inName": "Prefektur Hyogo",
      "tlName": "Hyogo Prefecture",
      "moName": "Хёого аймаг",
      "buName": "ချိုးဂို ပြည်နယ်",
      "khName": "ខេត្ដ ហ៊ីយ៉ូហ្គូ",
      "neName": "ह्योगो जिल्ला"
    },
    "class10": {
      "code": "280010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "兵库县南部",
      "zhName": "兵庫縣南部",
      "koName": "효고 현 남부",
      "esName": "Sur de Prefectura de Hyogo",
      "ptName": "Sul da Província de Hyōgo",
      "thName": "จังหวัดเฮียวโงะตอนใต้",
      "viName": "Miền Nam tỉnh Hyogo",
      "inName": "Bagian Selatan Prefektur Hyogo",
      "tlName": "Timog na bahagi ng Hyogo Prefecture",
      "moName": "Өмнөд Хёого аймаг",
      "buName": "ဟယောဂိုစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដហ្យូហ្គុ",
      "neName": "ह्योगो जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "280014",
      "name": "播磨南東部",
      "enName": "South-eastern Harima"
    },
    "class20": {
      "code": "2822000",
      "name": "加西市",
      "enName": "Kasai City",
      "kana": "かさいし",
      "chName": "加西市",
      "zhName": "加西市",
      "koName": "가사이 시",
      "esName": "Ciudad de Kasai",
      "ptName": "cidade de Kasai",
      "thName": "เมืองคะไซ",
      "viName": "thành phố Kasai",
      "inName": "kota Kasai",
      "tlName": "siyudad ng Kasai",
      "moName": "Касaй хот",
      "buName": "ခါဆာ့ယိ မြို့",
      "khName": "ទីក្រុង កាសៃ",
      "neName": "कासाई सहर"
    }
  },
  "2822100": {
    "office": {
      "code": "280000",
      "name": "兵庫県",
      "enName": "Hyogo",
      "officeName": "神戸地方気象台",
      "chName": "兵库县",
      "zhName": "兵庫縣",
      "koName": "효고현",
      "esName": "Prefectura de Hyogo",
      "ptName": "Província de Hyōgo",
      "thName": "จังหวัดเฮียวโงะ",
      "viName": "Tỉnh Hyogo",
      "inName": "Prefektur Hyogo",
      "tlName": "Hyogo Prefecture",
      "moName": "Хёого аймаг",
      "buName": "ချိုးဂို ပြည်နယ်",
      "khName": "ខេត្ដ ហ៊ីយ៉ូហ្គូ",
      "neName": "ह्योगो जिल्ला"
    },
    "class10": {
      "code": "280010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "兵库县南部",
      "zhName": "兵庫縣南部",
      "koName": "효고 현 남부",
      "esName": "Sur de Prefectura de Hyogo",
      "ptName": "Sul da Província de Hyōgo",
      "thName": "จังหวัดเฮียวโงะตอนใต้",
      "viName": "Miền Nam tỉnh Hyogo",
      "inName": "Bagian Selatan Prefektur Hyogo",
      "tlName": "Timog na bahagi ng Hyogo Prefecture",
      "moName": "Өмнөд Хёого аймаг",
      "buName": "ဟယောဂိုစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដហ្យូហ្គុ",
      "neName": "ह्योगो जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "280012",
      "name": "北播丹波",
      "enName": "Hokuban Tamba"
    },
    "class20": {
      "code": "2822100",
      "name": "丹波篠山市",
      "enName": "Tanba Sasayama City",
      "kana": "たんばささやまし",
      "chName": "丹波篠山市",
      "zhName": "丹波篠山市",
      "koName": "단바사사야마시",
      "esName": "Ciudad de Tanbasasayama",
      "ptName": "cidade de Tamba Sasayama",
      "thName": "เมืองทัมบะ-ซาซายามะ",
      "viName": "Thành phố Tanba-sasayama",
      "inName": "Kota Tanba-sasayama ",
      "tlName": "Lungsod ng Tanba-Sasayama",
      "moName": "Тамба Сaсaямa хот",
      "buName": "တန်းဘ ဆာဆယာ့မ မြို့",
      "khName": "ទីក្រុង តាំបា សាសាយ៉ាម៉ា",
      "neName": "ताम्बा-सासायामा सहर"
    }
  },
  "2822200": {
    "office": {
      "code": "280000",
      "name": "兵庫県",
      "enName": "Hyogo",
      "officeName": "神戸地方気象台",
      "chName": "兵库县",
      "zhName": "兵庫縣",
      "koName": "효고현",
      "esName": "Prefectura de Hyogo",
      "ptName": "Província de Hyōgo",
      "thName": "จังหวัดเฮียวโงะ",
      "viName": "Tỉnh Hyogo",
      "inName": "Prefektur Hyogo",
      "tlName": "Hyogo Prefecture",
      "moName": "Хёого аймаг",
      "buName": "ချိုးဂို ပြည်နယ်",
      "khName": "ខេត្ដ ហ៊ីយ៉ូហ្គូ",
      "neName": "ह्योगो जिल्ला"
    },
    "class10": {
      "code": "280020",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "兵库县北部",
      "zhName": "兵庫縣北部",
      "koName": "효고 현 북부",
      "esName": "Norte de Prefectura de Hyogo",
      "ptName": "Norte da Província de Hyōgo",
      "thName": "จังหวัดเฮียวโงะตอนเหนือ",
      "viName": "Miền Bắc tỉnh Hyogo",
      "inName": "Bagian Utara Prefektur Hyogo",
      "tlName": "Hilagang bahagi ng Hyogo Prefecture",
      "moName": "Хойд Хёого аймаг",
      "buName": "ဟယောဂိုစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដហ្យូហ្គុ",
      "neName": "ह्योगो जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "280022",
      "name": "但馬南部",
      "enName": "Southern Tajima"
    },
    "class20": {
      "code": "2822200",
      "name": "養父市",
      "enName": "Yabu City",
      "kana": "やぶし",
      "chName": "养父市",
      "zhName": "養父市",
      "koName": "야부 시",
      "esName": "Ciudad de Yabu",
      "ptName": "cidade de Yabu",
      "thName": "เมืองยาบุ",
      "viName": "thành phố Yabu",
      "inName": "kota Yabu",
      "tlName": "siyudad ng Yabu",
      "moName": "Ябү хот",
      "buName": "ယာဘု မြို့",
      "khName": "ទីក្រុង យ៉ាប៊ូ",
      "neName": "याबु सहर"
    }
  },
  "2822300": {
    "office": {
      "code": "280000",
      "name": "兵庫県",
      "enName": "Hyogo",
      "officeName": "神戸地方気象台",
      "chName": "兵库县",
      "zhName": "兵庫縣",
      "koName": "효고현",
      "esName": "Prefectura de Hyogo",
      "ptName": "Província de Hyōgo",
      "thName": "จังหวัดเฮียวโงะ",
      "viName": "Tỉnh Hyogo",
      "inName": "Prefektur Hyogo",
      "tlName": "Hyogo Prefecture",
      "moName": "Хёого аймаг",
      "buName": "ချိုးဂို ပြည်နယ်",
      "khName": "ខេត្ដ ហ៊ីយ៉ូហ្គូ",
      "neName": "ह्योगो जिल्ला"
    },
    "class10": {
      "code": "280010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "兵库县南部",
      "zhName": "兵庫縣南部",
      "koName": "효고 현 남부",
      "esName": "Sur de Prefectura de Hyogo",
      "ptName": "Sul da Província de Hyōgo",
      "thName": "จังหวัดเฮียวโงะตอนใต้",
      "viName": "Miền Nam tỉnh Hyogo",
      "inName": "Bagian Selatan Prefektur Hyogo",
      "tlName": "Timog na bahagi ng Hyogo Prefecture",
      "moName": "Өмнөд Хёого аймаг",
      "buName": "ဟယောဂိုစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដហ្យូហ្គុ",
      "neName": "ह्योगो जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "280012",
      "name": "北播丹波",
      "enName": "Hokuban Tamba"
    },
    "class20": {
      "code": "2822300",
      "name": "丹波市",
      "enName": "Tamba City",
      "kana": "たんばし",
      "chName": "丹波市",
      "zhName": "丹波市",
      "koName": "단바 시",
      "esName": "Ciudad de Tanba",
      "ptName": "cidade de Tamba",
      "thName": "เมืองทัมบะ",
      "viName": "thành phố Tamba",
      "inName": "kota Tamba",
      "tlName": "siyudad ng Tamba",
      "moName": "Тамба хот",
      "buName": "တန်းဘ မြို့",
      "khName": "ទីក្រុង តាំបា",
      "neName": "ताम्बा सहर"
    }
  },
  "2822400": {
    "office": {
      "code": "280000",
      "name": "兵庫県",
      "enName": "Hyogo",
      "officeName": "神戸地方気象台",
      "chName": "兵库县",
      "zhName": "兵庫縣",
      "koName": "효고현",
      "esName": "Prefectura de Hyogo",
      "ptName": "Província de Hyōgo",
      "thName": "จังหวัดเฮียวโงะ",
      "viName": "Tỉnh Hyogo",
      "inName": "Prefektur Hyogo",
      "tlName": "Hyogo Prefecture",
      "moName": "Хёого аймаг",
      "buName": "ချိုးဂို ပြည်နယ်",
      "khName": "ខេត្ដ ហ៊ីយ៉ូហ្គូ",
      "neName": "ह्योगो जिल्ला"
    },
    "class10": {
      "code": "280010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "兵库县南部",
      "zhName": "兵庫縣南部",
      "koName": "효고 현 남부",
      "esName": "Sur de Prefectura de Hyogo",
      "ptName": "Sul da Província de Hyōgo",
      "thName": "จังหวัดเฮียวโงะตอนใต้",
      "viName": "Miền Nam tỉnh Hyogo",
      "inName": "Bagian Selatan Prefektur Hyogo",
      "tlName": "Timog na bahagi ng Hyogo Prefecture",
      "moName": "Өмнөд Хёого аймаг",
      "buName": "ဟယောဂိုစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដហ្យូហ្គុ",
      "neName": "ह्योगो जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "280016",
      "name": "淡路島",
      "enName": "Awajishima"
    },
    "class20": {
      "code": "2822400",
      "name": "南あわじ市",
      "enName": "Minamiawaji City",
      "kana": "みなみあわじし",
      "chName": "南淡路市",
      "zhName": "南淡路市",
      "koName": "미나미아와지 시",
      "esName": "Ciudad de Minamiawaji",
      "ptName": "cidade de Minamiawaji",
      "thName": "เมืองมินามิอาวาจิ",
      "viName": "thành phố Minamiawaji",
      "inName": "kota Minamiawaji",
      "tlName": "siyudad ng Minamiawaji",
      "moName": "Минaмиаважи хот",
      "buName": "မီနာမိယားဝါ့ဂျိ မြို့",
      "khName": "ទីក្រុង មីណាមីអាវ៉ាជី",
      "neName": "मिनामियावाजी सहर"
    }
  },
  "2822500": {
    "office": {
      "code": "280000",
      "name": "兵庫県",
      "enName": "Hyogo",
      "officeName": "神戸地方気象台",
      "chName": "兵库县",
      "zhName": "兵庫縣",
      "koName": "효고현",
      "esName": "Prefectura de Hyogo",
      "ptName": "Província de Hyōgo",
      "thName": "จังหวัดเฮียวโงะ",
      "viName": "Tỉnh Hyogo",
      "inName": "Prefektur Hyogo",
      "tlName": "Hyogo Prefecture",
      "moName": "Хёого аймаг",
      "buName": "ချိုးဂို ပြည်နယ်",
      "khName": "ខេត្ដ ហ៊ីយ៉ូហ្គូ",
      "neName": "ह्योगो जिल्ला"
    },
    "class10": {
      "code": "280020",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "兵库县北部",
      "zhName": "兵庫縣北部",
      "koName": "효고 현 북부",
      "esName": "Norte de Prefectura de Hyogo",
      "ptName": "Norte da Província de Hyōgo",
      "thName": "จังหวัดเฮียวโงะตอนเหนือ",
      "viName": "Miền Bắc tỉnh Hyogo",
      "inName": "Bagian Utara Prefektur Hyogo",
      "tlName": "Hilagang bahagi ng Hyogo Prefecture",
      "moName": "Хойд Хёого аймаг",
      "buName": "ဟယောဂိုစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដហ្យូហ្គុ",
      "neName": "ह्योगो जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "280022",
      "name": "但馬南部",
      "enName": "Southern Tajima"
    },
    "class20": {
      "code": "2822500",
      "name": "朝来市",
      "enName": "Asago City",
      "kana": "あさごし",
      "chName": "朝来市",
      "zhName": "朝來市",
      "koName": "아사고 시",
      "esName": "Ciudad de Asago",
      "ptName": "cidade de Asago",
      "thName": "เมืองอาซาโงะ",
      "viName": "thành phố Asago",
      "inName": "kota Asago",
      "tlName": "siyudad ng Asago",
      "moName": "Aсaго хот",
      "buName": "အာဆာ့ဂို မြို့",
      "khName": "ទីក្រុង អាសាកូ",
      "neName": "आसागो सहर"
    }
  },
  "2822600": {
    "office": {
      "code": "280000",
      "name": "兵庫県",
      "enName": "Hyogo",
      "officeName": "神戸地方気象台",
      "chName": "兵库县",
      "zhName": "兵庫縣",
      "koName": "효고현",
      "esName": "Prefectura de Hyogo",
      "ptName": "Província de Hyōgo",
      "thName": "จังหวัดเฮียวโงะ",
      "viName": "Tỉnh Hyogo",
      "inName": "Prefektur Hyogo",
      "tlName": "Hyogo Prefecture",
      "moName": "Хёого аймаг",
      "buName": "ချိုးဂို ပြည်နယ်",
      "khName": "ខេត្ដ ហ៊ីយ៉ូហ្គូ",
      "neName": "ह्योगो जिल्ला"
    },
    "class10": {
      "code": "280010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "兵库县南部",
      "zhName": "兵庫縣南部",
      "koName": "효고 현 남부",
      "esName": "Sur de Prefectura de Hyogo",
      "ptName": "Sul da Província de Hyōgo",
      "thName": "จังหวัดเฮียวโงะตอนใต้",
      "viName": "Miền Nam tỉnh Hyogo",
      "inName": "Bagian Selatan Prefektur Hyogo",
      "tlName": "Timog na bahagi ng Hyogo Prefecture",
      "moName": "Өмнөд Хёого аймаг",
      "buName": "ဟယောဂိုစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដហ្យូហ្គុ",
      "neName": "ह्योगो जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "280016",
      "name": "淡路島",
      "enName": "Awajishima"
    },
    "class20": {
      "code": "2822600",
      "name": "淡路市",
      "enName": "Awaji City",
      "kana": "あわじし",
      "chName": "淡路市",
      "zhName": "淡路市",
      "koName": "아와지 시",
      "esName": "Ciudad de Awaji",
      "ptName": "cidade de Awaji",
      "thName": "เมืองอาวาจิ",
      "viName": "thành phố Awaji",
      "inName": "kota Awaji",
      "tlName": "siyudad ng Awaji",
      "moName": "Аважи хот",
      "buName": "အာဝါးဂျိ မြို့",
      "khName": "ទីក្រុង អាវ៉ាជី",
      "neName": "आवाजी सहर"
    }
  },
  "2822700": {
    "office": {
      "code": "280000",
      "name": "兵庫県",
      "enName": "Hyogo",
      "officeName": "神戸地方気象台",
      "chName": "兵库县",
      "zhName": "兵庫縣",
      "koName": "효고현",
      "esName": "Prefectura de Hyogo",
      "ptName": "Província de Hyōgo",
      "thName": "จังหวัดเฮียวโงะ",
      "viName": "Tỉnh Hyogo",
      "inName": "Prefektur Hyogo",
      "tlName": "Hyogo Prefecture",
      "moName": "Хёого аймаг",
      "buName": "ချိုးဂို ပြည်နယ်",
      "khName": "ខេត្ដ ហ៊ីយ៉ូហ្គូ",
      "neName": "ह्योगो जिल्ला"
    },
    "class10": {
      "code": "280010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "兵库县南部",
      "zhName": "兵庫縣南部",
      "koName": "효고 현 남부",
      "esName": "Sur de Prefectura de Hyogo",
      "ptName": "Sul da Província de Hyōgo",
      "thName": "จังหวัดเฮียวโงะตอนใต้",
      "viName": "Miền Nam tỉnh Hyogo",
      "inName": "Bagian Selatan Prefektur Hyogo",
      "tlName": "Timog na bahagi ng Hyogo Prefecture",
      "moName": "Өмнөд Хёого аймаг",
      "buName": "ဟယောဂိုစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដហ្យូហ្គុ",
      "neName": "ह्योगो जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "280013",
      "name": "播磨北西部",
      "enName": "North-western Harima"
    },
    "class20": {
      "code": "2822700",
      "name": "宍粟市",
      "enName": "Shiso City",
      "kana": "しそうし",
      "chName": "宍粟市",
      "zhName": "宍粟市",
      "koName": "시소 시",
      "esName": "Ciudad deShisō",
      "ptName": "cidade de Shiso",
      "thName": "เมืองชิโสะ",
      "viName": "thành phố Shiso",
      "inName": "kota Shiso",
      "tlName": "siyudad ng Shiso",
      "moName": "Шисо хот",
      "buName": "ရှီဆို မြို့",
      "khName": "ទីក្រុង ស៊ីសូ",
      "neName": "शिसो सहर"
    }
  },
  "2822800": {
    "office": {
      "code": "280000",
      "name": "兵庫県",
      "enName": "Hyogo",
      "officeName": "神戸地方気象台",
      "chName": "兵库县",
      "zhName": "兵庫縣",
      "koName": "효고현",
      "esName": "Prefectura de Hyogo",
      "ptName": "Província de Hyōgo",
      "thName": "จังหวัดเฮียวโงะ",
      "viName": "Tỉnh Hyogo",
      "inName": "Prefektur Hyogo",
      "tlName": "Hyogo Prefecture",
      "moName": "Хёого аймаг",
      "buName": "ချိုးဂို ပြည်နယ်",
      "khName": "ខេត្ដ ហ៊ីយ៉ូហ្គូ",
      "neName": "ह्योगो जिल्ला"
    },
    "class10": {
      "code": "280010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "兵库县南部",
      "zhName": "兵庫縣南部",
      "koName": "효고 현 남부",
      "esName": "Sur de Prefectura de Hyogo",
      "ptName": "Sul da Província de Hyōgo",
      "thName": "จังหวัดเฮียวโงะตอนใต้",
      "viName": "Miền Nam tỉnh Hyogo",
      "inName": "Bagian Selatan Prefektur Hyogo",
      "tlName": "Timog na bahagi ng Hyogo Prefecture",
      "moName": "Өмнөд Хёого аймаг",
      "buName": "ဟယောဂိုစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដហ្យូហ្គុ",
      "neName": "ह्योगो जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "280014",
      "name": "播磨南東部",
      "enName": "South-eastern Harima"
    },
    "class20": {
      "code": "2822800",
      "name": "加東市",
      "enName": "Kato City",
      "kana": "かとうし",
      "chName": "加东市",
      "zhName": "加東市",
      "koName": "가토 시",
      "esName": "Ciudad de Katō",
      "ptName": "cidade de Kato",
      "thName": "เมืองคาโตะ",
      "viName": "thành phố Kato",
      "inName": "kota Kato",
      "tlName": "siyudad ng Kato",
      "moName": "Като хот",
      "buName": "ကာတို မြို့",
      "khName": "ទីក្រុង កាតូ",
      "neName": "कातो सहर"
    }
  },
  "2822900": {
    "office": {
      "code": "280000",
      "name": "兵庫県",
      "enName": "Hyogo",
      "officeName": "神戸地方気象台",
      "chName": "兵库县",
      "zhName": "兵庫縣",
      "koName": "효고현",
      "esName": "Prefectura de Hyogo",
      "ptName": "Província de Hyōgo",
      "thName": "จังหวัดเฮียวโงะ",
      "viName": "Tỉnh Hyogo",
      "inName": "Prefektur Hyogo",
      "tlName": "Hyogo Prefecture",
      "moName": "Хёого аймаг",
      "buName": "ချိုးဂို ပြည်နယ်",
      "khName": "ខេត្ដ ហ៊ីយ៉ូហ្គូ",
      "neName": "ह्योगो जिल्ला"
    },
    "class10": {
      "code": "280010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "兵库县南部",
      "zhName": "兵庫縣南部",
      "koName": "효고 현 남부",
      "esName": "Sur de Prefectura de Hyogo",
      "ptName": "Sul da Província de Hyōgo",
      "thName": "จังหวัดเฮียวโงะตอนใต้",
      "viName": "Miền Nam tỉnh Hyogo",
      "inName": "Bagian Selatan Prefektur Hyogo",
      "tlName": "Timog na bahagi ng Hyogo Prefecture",
      "moName": "Өмнөд Хёого аймаг",
      "buName": "ဟယောဂိုစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដហ្យូហ្គុ",
      "neName": "ह्योगो जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "280015",
      "name": "播磨南西部",
      "enName": "South-western Harima"
    },
    "class20": {
      "code": "2822900",
      "name": "たつの市",
      "enName": "Tatsuno City",
      "kana": "たつのし",
      "chName": "龙野市",
      "zhName": "龍野市",
      "koName": "다쓰노 시",
      "esName": "Ciudad de Tatsuno",
      "ptName": "cidade de Tatsuno",
      "thName": "เมืองทัตสึโนะ",
      "viName": "thành phố Tatsuno",
      "inName": "kota Tatsuno",
      "tlName": "siyudad ng Tatsuno",
      "moName": "Тацүно хот",
      "buName": "တတ်ဆူနို မြို့",
      "khName": "ទីក្រុង តាស៊ូណូ",
      "neName": "तात्सुनो सहर"
    }
  },
  "2830100": {
    "office": {
      "code": "280000",
      "name": "兵庫県",
      "enName": "Hyogo",
      "officeName": "神戸地方気象台",
      "chName": "兵库县",
      "zhName": "兵庫縣",
      "koName": "효고현",
      "esName": "Prefectura de Hyogo",
      "ptName": "Província de Hyōgo",
      "thName": "จังหวัดเฮียวโงะ",
      "viName": "Tỉnh Hyogo",
      "inName": "Prefektur Hyogo",
      "tlName": "Hyogo Prefecture",
      "moName": "Хёого аймаг",
      "buName": "ချိုးဂို ပြည်နယ်",
      "khName": "ខេត្ដ ហ៊ីយ៉ូហ្គូ",
      "neName": "ह्योगो जिल्ला"
    },
    "class10": {
      "code": "280010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "兵库县南部",
      "zhName": "兵庫縣南部",
      "koName": "효고 현 남부",
      "esName": "Sur de Prefectura de Hyogo",
      "ptName": "Sul da Província de Hyōgo",
      "thName": "จังหวัดเฮียวโงะตอนใต้",
      "viName": "Miền Nam tỉnh Hyogo",
      "inName": "Bagian Selatan Prefektur Hyogo",
      "tlName": "Timog na bahagi ng Hyogo Prefecture",
      "moName": "Өмнөд Хёого аймаг",
      "buName": "ဟယောဂိုစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដហ្យូហ្គុ",
      "neName": "ह्योगो जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "280011",
      "name": "阪神",
      "enName": "Hanshin"
    },
    "class20": {
      "code": "2830100",
      "name": "猪名川町",
      "enName": "Inagawa Town",
      "kana": "いながわちょう",
      "chName": "猪名川町",
      "zhName": "豬名川町",
      "koName": "이나가와 정",
      "esName": "Pueblo de Inagawa",
      "ptName": "bairro de Inagawa",
      "thName": "เมืองอินางาวะ",
      "viName": "thị trấn Inagawa",
      "inName": "kota Inagawa",
      "tlName": "bayan ng Inagawa",
      "moName": "Инaгава жижиг хот",
      "buName": "အီနားဂါ့ဝ မြို့နယ်",
      "khName": "ទីប្រជុំជន អ៊ីណាហ្គាវ៉ា",
      "neName": "इनागावा नगर"
    }
  },
  "2836500": {
    "office": {
      "code": "280000",
      "name": "兵庫県",
      "enName": "Hyogo",
      "officeName": "神戸地方気象台",
      "chName": "兵库县",
      "zhName": "兵庫縣",
      "koName": "효고현",
      "esName": "Prefectura de Hyogo",
      "ptName": "Província de Hyōgo",
      "thName": "จังหวัดเฮียวโงะ",
      "viName": "Tỉnh Hyogo",
      "inName": "Prefektur Hyogo",
      "tlName": "Hyogo Prefecture",
      "moName": "Хёого аймаг",
      "buName": "ချိုးဂို ပြည်နယ်",
      "khName": "ខេត្ដ ហ៊ីយ៉ូហ្គូ",
      "neName": "ह्योगो जिल्ला"
    },
    "class10": {
      "code": "280010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "兵库县南部",
      "zhName": "兵庫縣南部",
      "koName": "효고 현 남부",
      "esName": "Sur de Prefectura de Hyogo",
      "ptName": "Sul da Província de Hyōgo",
      "thName": "จังหวัดเฮียวโงะตอนใต้",
      "viName": "Miền Nam tỉnh Hyogo",
      "inName": "Bagian Selatan Prefektur Hyogo",
      "tlName": "Timog na bahagi ng Hyogo Prefecture",
      "moName": "Өмнөд Хёого аймаг",
      "buName": "ဟယောဂိုစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដហ្យូហ្គុ",
      "neName": "ह्योगो जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "280012",
      "name": "北播丹波",
      "enName": "Hokuban Tamba"
    },
    "class20": {
      "code": "2836500",
      "name": "多可町",
      "enName": "Taka Town",
      "kana": "たかちょう",
      "chName": "多可町",
      "zhName": "多可町",
      "koName": "다카 정",
      "esName": "Pueblo de Taka",
      "ptName": "bairro de Taka",
      "thName": "เมืองทากะ",
      "viName": "thị trấn Taka",
      "inName": "kota Taka",
      "tlName": "bayan ng Taka",
      "moName": "Така жижиг хот",
      "buName": "တာက မြို့နယ်",
      "khName": "ទីប្រជុំជន តាកា",
      "neName": "ताका नगर"
    }
  },
  "2838100": {
    "office": {
      "code": "280000",
      "name": "兵庫県",
      "enName": "Hyogo",
      "officeName": "神戸地方気象台",
      "chName": "兵库县",
      "zhName": "兵庫縣",
      "koName": "효고현",
      "esName": "Prefectura de Hyogo",
      "ptName": "Província de Hyōgo",
      "thName": "จังหวัดเฮียวโงะ",
      "viName": "Tỉnh Hyogo",
      "inName": "Prefektur Hyogo",
      "tlName": "Hyogo Prefecture",
      "moName": "Хёого аймаг",
      "buName": "ချိုးဂို ပြည်နယ်",
      "khName": "ខេត្ដ ហ៊ីយ៉ូហ្គូ",
      "neName": "ह्योगो जिल्ला"
    },
    "class10": {
      "code": "280010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "兵库县南部",
      "zhName": "兵庫縣南部",
      "koName": "효고 현 남부",
      "esName": "Sur de Prefectura de Hyogo",
      "ptName": "Sul da Província de Hyōgo",
      "thName": "จังหวัดเฮียวโงะตอนใต้",
      "viName": "Miền Nam tỉnh Hyogo",
      "inName": "Bagian Selatan Prefektur Hyogo",
      "tlName": "Timog na bahagi ng Hyogo Prefecture",
      "moName": "Өмнөд Хёого аймаг",
      "buName": "ဟယောဂိုစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដហ្យូហ្គុ",
      "neName": "ह्योगो जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "280014",
      "name": "播磨南東部",
      "enName": "South-eastern Harima"
    },
    "class20": {
      "code": "2838100",
      "name": "稲美町",
      "enName": "Inami Town",
      "kana": "いなみちょう",
      "chName": "兵库稻美町",
      "zhName": "兵庫稻美町",
      "koName": "효고 이나미 정",
      "esName": "Pueblo de Inami, Hyogo",
      "ptName": "Hyogo, bairro de Inami",
      "thName": "เมืองอินามิ เฮียวโงะ",
      "viName": "Thị trấn Inami, Hyogo",
      "inName": "Kota Inami, Hyogo",
      "tlName": "bayan ng Inami, Hyogo",
      "moName": "Хёого Инами жижиг хот",
      "buName": "ဟိယောဂေါ့အိတမိမြို့နယ်",
      "khName": "ទីប្រជុំជនអ៊ីនណាមិ ហ្យូហ្គុ",
      "neName": "ह्योगो इनामी नगर"
    }
  },
  "2838200": {
    "office": {
      "code": "280000",
      "name": "兵庫県",
      "enName": "Hyogo",
      "officeName": "神戸地方気象台",
      "chName": "兵库县",
      "zhName": "兵庫縣",
      "koName": "효고현",
      "esName": "Prefectura de Hyogo",
      "ptName": "Província de Hyōgo",
      "thName": "จังหวัดเฮียวโงะ",
      "viName": "Tỉnh Hyogo",
      "inName": "Prefektur Hyogo",
      "tlName": "Hyogo Prefecture",
      "moName": "Хёого аймаг",
      "buName": "ချိုးဂို ပြည်နယ်",
      "khName": "ខេត្ដ ហ៊ីយ៉ូហ្គូ",
      "neName": "ह्योगो जिल्ला"
    },
    "class10": {
      "code": "280010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "兵库县南部",
      "zhName": "兵庫縣南部",
      "koName": "효고 현 남부",
      "esName": "Sur de Prefectura de Hyogo",
      "ptName": "Sul da Província de Hyōgo",
      "thName": "จังหวัดเฮียวโงะตอนใต้",
      "viName": "Miền Nam tỉnh Hyogo",
      "inName": "Bagian Selatan Prefektur Hyogo",
      "tlName": "Timog na bahagi ng Hyogo Prefecture",
      "moName": "Өмнөд Хёого аймаг",
      "buName": "ဟယောဂိုစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដហ្យូហ្គុ",
      "neName": "ह्योगो जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "280014",
      "name": "播磨南東部",
      "enName": "South-eastern Harima"
    },
    "class20": {
      "code": "2838200",
      "name": "播磨町",
      "enName": "Harima Town",
      "kana": "はりまちょう",
      "chName": "播磨町",
      "zhName": "播磨町",
      "koName": "하리마 정",
      "esName": "Pueblo de Harima",
      "ptName": "bairro de Harima",
      "thName": "เมืองฮาริมะ",
      "viName": "thị trấn Harima",
      "inName": "kota Harima",
      "tlName": "bayan ng Harima",
      "moName": "Хaримa жижиг хот",
      "buName": "ဟာရိမ မြို့နယ်",
      "khName": "ទីប្រជុំជន ហារិម៉ា",
      "neName": "हारिमा नगर"
    }
  },
  "2844200": {
    "office": {
      "code": "280000",
      "name": "兵庫県",
      "enName": "Hyogo",
      "officeName": "神戸地方気象台",
      "chName": "兵库县",
      "zhName": "兵庫縣",
      "koName": "효고현",
      "esName": "Prefectura de Hyogo",
      "ptName": "Província de Hyōgo",
      "thName": "จังหวัดเฮียวโงะ",
      "viName": "Tỉnh Hyogo",
      "inName": "Prefektur Hyogo",
      "tlName": "Hyogo Prefecture",
      "moName": "Хёого аймаг",
      "buName": "ချိုးဂို ပြည်နယ်",
      "khName": "ខេត្ដ ហ៊ីយ៉ូហ្គូ",
      "neName": "ह्योगो जिल्ला"
    },
    "class10": {
      "code": "280010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "兵库县南部",
      "zhName": "兵庫縣南部",
      "koName": "효고 현 남부",
      "esName": "Sur de Prefectura de Hyogo",
      "ptName": "Sul da Província de Hyōgo",
      "thName": "จังหวัดเฮียวโงะตอนใต้",
      "viName": "Miền Nam tỉnh Hyogo",
      "inName": "Bagian Selatan Prefektur Hyogo",
      "tlName": "Timog na bahagi ng Hyogo Prefecture",
      "moName": "Өмнөд Хёого аймаг",
      "buName": "ဟယောဂိုစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដហ្យូហ្គុ",
      "neName": "ह्योगो जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "280013",
      "name": "播磨北西部",
      "enName": "North-western Harima"
    },
    "class20": {
      "code": "2844200",
      "name": "市川町",
      "enName": "Ichikawa Town",
      "kana": "いちかわちょう",
      "chName": "市川町",
      "zhName": "市川町",
      "koName": "이치카와 정",
      "esName": "Pueblo de Ichikawa",
      "ptName": "bairro de Ichikawa",
      "thName": "เมืองอิชิคาวะ",
      "viName": "thị trấn Ichikawa",
      "inName": "kota Ichikawa",
      "tlName": "bayan ng Ichikawa",
      "moName": "Ичикава жижиг хот",
      "buName": "အီကျိကာ့ဝ မြို့နယ်",
      "khName": "ទីប្រជុំជន អ៊ីឈីកាវ៉ា",
      "neName": "इचिकावा नगर"
    }
  },
  "2844300": {
    "office": {
      "code": "280000",
      "name": "兵庫県",
      "enName": "Hyogo",
      "officeName": "神戸地方気象台",
      "chName": "兵库县",
      "zhName": "兵庫縣",
      "koName": "효고현",
      "esName": "Prefectura de Hyogo",
      "ptName": "Província de Hyōgo",
      "thName": "จังหวัดเฮียวโงะ",
      "viName": "Tỉnh Hyogo",
      "inName": "Prefektur Hyogo",
      "tlName": "Hyogo Prefecture",
      "moName": "Хёого аймаг",
      "buName": "ချိုးဂို ပြည်နယ်",
      "khName": "ខេត្ដ ហ៊ីយ៉ូហ្គូ",
      "neName": "ह्योगो जिल्ला"
    },
    "class10": {
      "code": "280010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "兵库县南部",
      "zhName": "兵庫縣南部",
      "koName": "효고 현 남부",
      "esName": "Sur de Prefectura de Hyogo",
      "ptName": "Sul da Província de Hyōgo",
      "thName": "จังหวัดเฮียวโงะตอนใต้",
      "viName": "Miền Nam tỉnh Hyogo",
      "inName": "Bagian Selatan Prefektur Hyogo",
      "tlName": "Timog na bahagi ng Hyogo Prefecture",
      "moName": "Өмнөд Хёого аймаг",
      "buName": "ဟယောဂိုစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដហ្យូហ្គុ",
      "neName": "ह्योगो जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "280013",
      "name": "播磨北西部",
      "enName": "North-western Harima"
    },
    "class20": {
      "code": "2844300",
      "name": "福崎町",
      "enName": "Fukusaki Town",
      "kana": "ふくさきちょう",
      "chName": "福崎町",
      "zhName": "福崎町",
      "koName": "후쿠사키 정",
      "esName": "Pueblo de Fukusaki",
      "ptName": "bairro de Fukusaki",
      "thName": "เมืองฟุคุซากิ",
      "viName": "thị trấn Fukusaki",
      "inName": "kota Fukusaki",
      "tlName": "bayan ng Fukusaki",
      "moName": "Фүкүсаки жижиг хот",
      "buName": "ဖူကုဆာ့ကိ မြို့နယ်",
      "khName": "ទីប្រជុំជន ហ្វូគូសាគី",
      "neName": "फुकुसाकी नगर"
    }
  },
  "2844600": {
    "office": {
      "code": "280000",
      "name": "兵庫県",
      "enName": "Hyogo",
      "officeName": "神戸地方気象台",
      "chName": "兵库县",
      "zhName": "兵庫縣",
      "koName": "효고현",
      "esName": "Prefectura de Hyogo",
      "ptName": "Província de Hyōgo",
      "thName": "จังหวัดเฮียวโงะ",
      "viName": "Tỉnh Hyogo",
      "inName": "Prefektur Hyogo",
      "tlName": "Hyogo Prefecture",
      "moName": "Хёого аймаг",
      "buName": "ချိုးဂို ပြည်နယ်",
      "khName": "ខេត្ដ ហ៊ីយ៉ូហ្គូ",
      "neName": "ह्योगो जिल्ला"
    },
    "class10": {
      "code": "280010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "兵库县南部",
      "zhName": "兵庫縣南部",
      "koName": "효고 현 남부",
      "esName": "Sur de Prefectura de Hyogo",
      "ptName": "Sul da Província de Hyōgo",
      "thName": "จังหวัดเฮียวโงะตอนใต้",
      "viName": "Miền Nam tỉnh Hyogo",
      "inName": "Bagian Selatan Prefektur Hyogo",
      "tlName": "Timog na bahagi ng Hyogo Prefecture",
      "moName": "Өмнөд Хёого аймаг",
      "buName": "ဟယောဂိုစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដហ្យូហ្គុ",
      "neName": "ह्योगो जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "280013",
      "name": "播磨北西部",
      "enName": "North-western Harima"
    },
    "class20": {
      "code": "2844600",
      "name": "神河町",
      "enName": "Kamikawa Town",
      "kana": "かみかわちょう",
      "chName": "兵库神河町",
      "zhName": "兵庫神河町",
      "koName": "효고 가미카와 정",
      "esName": "Pueblo de Kamikawa, Hyogo",
      "ptName": "Hyogo, bairro de Kamikawa",
      "thName": "เมืองคามิคาวะ เฮียวโงะ",
      "viName": "Thị trấn Kamikawa, Hyogo",
      "inName": "Kota Kamikawa, Hyogo",
      "tlName": "bayan ng Kamikawa, Hyogo",
      "moName": "Хёого Камикава жижиг хот",
      "buName": "ဟိယောဂေါ့ကမိကဝမြို့နယ်",
      "khName": "ទីប្រជុំជនកាមីកាវ៉ា ហ្យូហ្គុ",
      "neName": "ह्योगो कामिकावा नगर"
    }
  },
  "2846400": {
    "office": {
      "code": "280000",
      "name": "兵庫県",
      "enName": "Hyogo",
      "officeName": "神戸地方気象台",
      "chName": "兵库县",
      "zhName": "兵庫縣",
      "koName": "효고현",
      "esName": "Prefectura de Hyogo",
      "ptName": "Província de Hyōgo",
      "thName": "จังหวัดเฮียวโงะ",
      "viName": "Tỉnh Hyogo",
      "inName": "Prefektur Hyogo",
      "tlName": "Hyogo Prefecture",
      "moName": "Хёого аймаг",
      "buName": "ချိုးဂို ပြည်နယ်",
      "khName": "ខេត្ដ ហ៊ីយ៉ូហ្គូ",
      "neName": "ह्योगो जिल्ला"
    },
    "class10": {
      "code": "280010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "兵库县南部",
      "zhName": "兵庫縣南部",
      "koName": "효고 현 남부",
      "esName": "Sur de Prefectura de Hyogo",
      "ptName": "Sul da Província de Hyōgo",
      "thName": "จังหวัดเฮียวโงะตอนใต้",
      "viName": "Miền Nam tỉnh Hyogo",
      "inName": "Bagian Selatan Prefektur Hyogo",
      "tlName": "Timog na bahagi ng Hyogo Prefecture",
      "moName": "Өмнөд Хёого аймаг",
      "buName": "ဟယောဂိုစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដហ្យូហ្គុ",
      "neName": "ह्योगो जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "280015",
      "name": "播磨南西部",
      "enName": "South-western Harima"
    },
    "class20": {
      "code": "2846400",
      "name": "太子町",
      "enName": "Taishi Town",
      "kana": "たいしちょう",
      "chName": "兵库太子町",
      "zhName": "兵庫太子町",
      "koName": "효고 다이시 정",
      "esName": "Pueblo de Taishi, Hyogo",
      "ptName": "Hyogo, bairro de Taishi",
      "thName": "เมืองไทชิ เฮียวโงะ",
      "viName": "Thị trấn Taishi, Hyogo",
      "inName": "Kota Taishi, Hyogo",
      "tlName": "bayan ng Taishi, Hyogo",
      "moName": "Хёого Тайши жижиг хот",
      "buName": "ဟိယောဂေါ့တိုင်းရှိမြို့နယ်",
      "khName": "ទីប្រជុំជនតៃស៊ី ហ្យូហ្គុ",
      "neName": "ह्योगो ताइशी नगर"
    }
  },
  "2848100": {
    "office": {
      "code": "280000",
      "name": "兵庫県",
      "enName": "Hyogo",
      "officeName": "神戸地方気象台",
      "chName": "兵库县",
      "zhName": "兵庫縣",
      "koName": "효고현",
      "esName": "Prefectura de Hyogo",
      "ptName": "Província de Hyōgo",
      "thName": "จังหวัดเฮียวโงะ",
      "viName": "Tỉnh Hyogo",
      "inName": "Prefektur Hyogo",
      "tlName": "Hyogo Prefecture",
      "moName": "Хёого аймаг",
      "buName": "ချိုးဂို ပြည်နယ်",
      "khName": "ខេត្ដ ហ៊ីយ៉ូហ្គូ",
      "neName": "ह्योगो जिल्ला"
    },
    "class10": {
      "code": "280010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "兵库县南部",
      "zhName": "兵庫縣南部",
      "koName": "효고 현 남부",
      "esName": "Sur de Prefectura de Hyogo",
      "ptName": "Sul da Província de Hyōgo",
      "thName": "จังหวัดเฮียวโงะตอนใต้",
      "viName": "Miền Nam tỉnh Hyogo",
      "inName": "Bagian Selatan Prefektur Hyogo",
      "tlName": "Timog na bahagi ng Hyogo Prefecture",
      "moName": "Өмнөд Хёого аймаг",
      "buName": "ဟယောဂိုစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដហ្យូហ្គុ",
      "neName": "ह्योगो जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "280015",
      "name": "播磨南西部",
      "enName": "South-western Harima"
    },
    "class20": {
      "code": "2848100",
      "name": "上郡町",
      "enName": "Kamigori Town",
      "kana": "かみごおりちょう",
      "chName": "上郡町",
      "zhName": "上郡町",
      "koName": "가미고리 정",
      "esName": "Pueblo de Kamigori",
      "ptName": "bairro de Kamigori",
      "thName": "เมืองคามิโงริ",
      "viName": "thị trấn Kamigori",
      "inName": "kota Kamigori",
      "tlName": "bayan ng Kamigori",
      "moName": "Камигори жижиг хот",
      "buName": "ခါမိဂေါရိ မြို့နယ်",
      "khName": "ទីប្រជុំជន កាមីហ្កូរី",
      "neName": "कामिगोरी नगर"
    }
  },
  "2850100": {
    "office": {
      "code": "280000",
      "name": "兵庫県",
      "enName": "Hyogo",
      "officeName": "神戸地方気象台",
      "chName": "兵库县",
      "zhName": "兵庫縣",
      "koName": "효고현",
      "esName": "Prefectura de Hyogo",
      "ptName": "Província de Hyōgo",
      "thName": "จังหวัดเฮียวโงะ",
      "viName": "Tỉnh Hyogo",
      "inName": "Prefektur Hyogo",
      "tlName": "Hyogo Prefecture",
      "moName": "Хёого аймаг",
      "buName": "ချိုးဂို ပြည်နယ်",
      "khName": "ខេត្ដ ហ៊ីយ៉ូហ្គូ",
      "neName": "ह्योगो जिल्ला"
    },
    "class10": {
      "code": "280010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "兵库县南部",
      "zhName": "兵庫縣南部",
      "koName": "효고 현 남부",
      "esName": "Sur de Prefectura de Hyogo",
      "ptName": "Sul da Província de Hyōgo",
      "thName": "จังหวัดเฮียวโงะตอนใต้",
      "viName": "Miền Nam tỉnh Hyogo",
      "inName": "Bagian Selatan Prefektur Hyogo",
      "tlName": "Timog na bahagi ng Hyogo Prefecture",
      "moName": "Өмнөд Хёого аймаг",
      "buName": "ဟယောဂိုစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដហ្យូហ្គុ",
      "neName": "ह्योगो जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "280013",
      "name": "播磨北西部",
      "enName": "North-western Harima"
    },
    "class20": {
      "code": "2850100",
      "name": "佐用町",
      "enName": "Sayo Town",
      "kana": "さようちょう",
      "chName": "佐用町",
      "zhName": "佐用町",
      "koName": "사요 정",
      "esName": "Pueblo de Sayo",
      "ptName": "bairro de Sayo",
      "thName": "เมืองซาโย",
      "viName": "thị trấn Sayo",
      "inName": "kota Sayo",
      "tlName": "bayan ng Sayo",
      "moName": "Сaёо жижиг хот",
      "buName": "ဆားယို မြို့နယ်",
      "khName": "ទីប្រជុំជន សាយ៉ូ",
      "neName": "सायो नगर"
    }
  },
  "2858500": {
    "office": {
      "code": "280000",
      "name": "兵庫県",
      "enName": "Hyogo",
      "officeName": "神戸地方気象台",
      "chName": "兵库县",
      "zhName": "兵庫縣",
      "koName": "효고현",
      "esName": "Prefectura de Hyogo",
      "ptName": "Província de Hyōgo",
      "thName": "จังหวัดเฮียวโงะ",
      "viName": "Tỉnh Hyogo",
      "inName": "Prefektur Hyogo",
      "tlName": "Hyogo Prefecture",
      "moName": "Хёого аймаг",
      "buName": "ချိုးဂို ပြည်နယ်",
      "khName": "ខេត្ដ ហ៊ីយ៉ូហ្គូ",
      "neName": "ह्योगो जिल्ला"
    },
    "class10": {
      "code": "280020",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "兵库县北部",
      "zhName": "兵庫縣北部",
      "koName": "효고 현 북부",
      "esName": "Norte de Prefectura de Hyogo",
      "ptName": "Norte da Província de Hyōgo",
      "thName": "จังหวัดเฮียวโงะตอนเหนือ",
      "viName": "Miền Bắc tỉnh Hyogo",
      "inName": "Bagian Utara Prefektur Hyogo",
      "tlName": "Hilagang bahagi ng Hyogo Prefecture",
      "moName": "Хойд Хёого аймаг",
      "buName": "ဟယောဂိုစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដហ្យូហ្គុ",
      "neName": "ह्योगो जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "280021",
      "name": "但馬北部",
      "enName": "Northern Tajima"
    },
    "class20": {
      "code": "2858500",
      "name": "香美町",
      "enName": "Kami Town",
      "kana": "かみちょう",
      "chName": "兵库香美町",
      "zhName": "兵庫香美町",
      "koName": "효고 가미 정",
      "esName": "Pueblo de Kami, Hyogo",
      "ptName": "Hyogo, bairro de Kami",
      "thName": "เมืองคามิ เฮียวโงะ",
      "viName": "Thị trấn Kami, Hyogo",
      "inName": "Kota Kami, Hyogo",
      "tlName": "bayan ng Kami, Hyogo",
      "moName": "Хёого Камичё жижиг хот",
      "buName": "ဟိယောဂေါ့ကမိမြို့နယ်",
      "khName": "ទីប្រជុំជនកាមិ ហ្យូហ្គុ",
      "neName": "ह्योगो कामी नगर"
    }
  },
  "2858600": {
    "office": {
      "code": "280000",
      "name": "兵庫県",
      "enName": "Hyogo",
      "officeName": "神戸地方気象台",
      "chName": "兵库县",
      "zhName": "兵庫縣",
      "koName": "효고현",
      "esName": "Prefectura de Hyogo",
      "ptName": "Província de Hyōgo",
      "thName": "จังหวัดเฮียวโงะ",
      "viName": "Tỉnh Hyogo",
      "inName": "Prefektur Hyogo",
      "tlName": "Hyogo Prefecture",
      "moName": "Хёого аймаг",
      "buName": "ချိုးဂို ပြည်နယ်",
      "khName": "ខេត្ដ ហ៊ីយ៉ូហ្គូ",
      "neName": "ह्योगो जिल्ला"
    },
    "class10": {
      "code": "280020",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "兵库县北部",
      "zhName": "兵庫縣北部",
      "koName": "효고 현 북부",
      "esName": "Norte de Prefectura de Hyogo",
      "ptName": "Norte da Província de Hyōgo",
      "thName": "จังหวัดเฮียวโงะตอนเหนือ",
      "viName": "Miền Bắc tỉnh Hyogo",
      "inName": "Bagian Utara Prefektur Hyogo",
      "tlName": "Hilagang bahagi ng Hyogo Prefecture",
      "moName": "Хойд Хёого аймаг",
      "buName": "ဟယောဂိုစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដហ្យូហ្គុ",
      "neName": "ह्योगो जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "280021",
      "name": "但馬北部",
      "enName": "Northern Tajima"
    },
    "class20": {
      "code": "2858600",
      "name": "新温泉町",
      "enName": "Shinonsen Town",
      "kana": "しんおんせんちょう",
      "chName": "新温泉町",
      "zhName": "新溫泉町",
      "koName": "신온센 정",
      "esName": "Pueblo de Shin-Onsen",
      "ptName": "bairro de Shinonsen",
      "thName": "เมืองชินอนเซน",
      "viName": "thị trấn Shinonsen",
      "inName": "kota Shinonsen",
      "tlName": "bayan ng Shinonsen",
      "moName": "Шинонсэн жижиг хот",
      "buName": "ရှီနွန်းဇန် မြို့နယ်",
      "khName": "ទីប្រជុំជន ស៊ីណូនសែន",
      "neName": "शिनोन्सेन नगर"
    }
  },
  "2920101": {
    "office": {
      "code": "290000",
      "name": "奈良県",
      "enName": "Nara",
      "officeName": "奈良地方気象台",
      "chName": "奈良县",
      "zhName": "奈良縣",
      "koName": "나라현",
      "esName": "Prefectura de Nara",
      "ptName": "Província de Nara",
      "thName": "จังหวัดนาระ",
      "viName": "Tỉnh Nara",
      "inName": "Prefektur Nara",
      "tlName": "Nara Prefecture",
      "moName": "Нара аймаг",
      "buName": "နာရာ ပြည်နယ်",
      "khName": "ខេត្ដ ណារ៉ា",
      "neName": "नारा जिल्ला"
    },
    "class10": {
      "code": "290010",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "奈良县北部",
      "zhName": "奈良縣北部",
      "koName": "나라현 북부",
      "esName": "Norte de Prefectura de Nara",
      "ptName": "Norte da Província de Nara",
      "thName": "จังหวัดนาระตอนเหนือ",
      "viName": "Miền Bắc tỉnh Nara",
      "inName": "Bagian Utara Prefektur Nara",
      "tlName": "Hilagang bahagi ng Nara Prefecture",
      "moName": "Хойд Нара аймаг",
      "buName": "နယစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដណារ៉ា",
      "neName": "नारा जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "290011",
      "name": "北西部",
      "enName": "North-western Region"
    },
    "class20": {
      "code": "2920101",
      "name": "奈良市西部",
      "enName": "Western Nara City",
      "kana": "ならしせいぶ"
    }
  },
  "2920102": {
    "office": {
      "code": "290000",
      "name": "奈良県",
      "enName": "Nara",
      "officeName": "奈良地方気象台",
      "chName": "奈良县",
      "zhName": "奈良縣",
      "koName": "나라현",
      "esName": "Prefectura de Nara",
      "ptName": "Província de Nara",
      "thName": "จังหวัดนาระ",
      "viName": "Tỉnh Nara",
      "inName": "Prefektur Nara",
      "tlName": "Nara Prefecture",
      "moName": "Нара аймаг",
      "buName": "နာရာ ပြည်နယ်",
      "khName": "ខេត្ដ ណារ៉ា",
      "neName": "नारा जिल्ला"
    },
    "class10": {
      "code": "290010",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "奈良县北部",
      "zhName": "奈良縣北部",
      "koName": "나라현 북부",
      "esName": "Norte de Prefectura de Nara",
      "ptName": "Norte da Província de Nara",
      "thName": "จังหวัดนาระตอนเหนือ",
      "viName": "Miền Bắc tỉnh Nara",
      "inName": "Bagian Utara Prefektur Nara",
      "tlName": "Hilagang bahagi ng Nara Prefecture",
      "moName": "Хойд Нара аймаг",
      "buName": "နယစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដណារ៉ា",
      "neName": "नारा जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "290011",
      "name": "北西部",
      "enName": "North-western Region"
    },
    "class20": {
      "code": "2920102",
      "name": "奈良市東部",
      "enName": "Eastern Nara City",
      "kana": "ならしとうぶ"
    }
  },
  "2920200": {
    "office": {
      "code": "290000",
      "name": "奈良県",
      "enName": "Nara",
      "officeName": "奈良地方気象台",
      "chName": "奈良县",
      "zhName": "奈良縣",
      "koName": "나라현",
      "esName": "Prefectura de Nara",
      "ptName": "Província de Nara",
      "thName": "จังหวัดนาระ",
      "viName": "Tỉnh Nara",
      "inName": "Prefektur Nara",
      "tlName": "Nara Prefecture",
      "moName": "Нара аймаг",
      "buName": "နာရာ ပြည်နယ်",
      "khName": "ខេត្ដ ណារ៉ា",
      "neName": "नारा जिल्ला"
    },
    "class10": {
      "code": "290010",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "奈良县北部",
      "zhName": "奈良縣北部",
      "koName": "나라현 북부",
      "esName": "Norte de Prefectura de Nara",
      "ptName": "Norte da Província de Nara",
      "thName": "จังหวัดนาระตอนเหนือ",
      "viName": "Miền Bắc tỉnh Nara",
      "inName": "Bagian Utara Prefektur Nara",
      "tlName": "Hilagang bahagi ng Nara Prefecture",
      "moName": "Хойд Нара аймаг",
      "buName": "နယစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដណារ៉ា",
      "neName": "नारा जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "290011",
      "name": "北西部",
      "enName": "North-western Region"
    },
    "class20": {
      "code": "2920200",
      "name": "大和高田市",
      "enName": "Yamatotakada City",
      "kana": "やまとたかだし",
      "chName": "大和高田市",
      "zhName": "大和髙田市",
      "koName": "야마토타카다 시",
      "esName": "Ciudad de Yamatotakada",
      "ptName": "cidade de Yamatotakada",
      "thName": "เมืองยามาโตะทากาดะ",
      "viName": "thành phố Yamatotakada",
      "inName": "kota Yamatotakada",
      "tlName": "siyudad ng Yamatotakada",
      "moName": "Ямaтотакада хот",
      "buName": "ယာမာတိုတာ့ကာ့ဒ မြို့",
      "khName": "ទីក្រុង យ៉ាម៉ាតូតាកាដា",
      "neName": "यामातोताकादा सहर"
    }
  },
  "2920300": {
    "office": {
      "code": "290000",
      "name": "奈良県",
      "enName": "Nara",
      "officeName": "奈良地方気象台",
      "chName": "奈良县",
      "zhName": "奈良縣",
      "koName": "나라현",
      "esName": "Prefectura de Nara",
      "ptName": "Província de Nara",
      "thName": "จังหวัดนาระ",
      "viName": "Tỉnh Nara",
      "inName": "Prefektur Nara",
      "tlName": "Nara Prefecture",
      "moName": "Нара аймаг",
      "buName": "နာရာ ပြည်နယ်",
      "khName": "ខេត្ដ ណារ៉ា",
      "neName": "नारा जिल्ला"
    },
    "class10": {
      "code": "290010",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "奈良县北部",
      "zhName": "奈良縣北部",
      "koName": "나라현 북부",
      "esName": "Norte de Prefectura de Nara",
      "ptName": "Norte da Província de Nara",
      "thName": "จังหวัดนาระตอนเหนือ",
      "viName": "Miền Bắc tỉnh Nara",
      "inName": "Bagian Utara Prefektur Nara",
      "tlName": "Hilagang bahagi ng Nara Prefecture",
      "moName": "Хойд Нара аймаг",
      "buName": "နယစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដណារ៉ា",
      "neName": "नारा जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "290011",
      "name": "北西部",
      "enName": "North-western Region"
    },
    "class20": {
      "code": "2920300",
      "name": "大和郡山市",
      "enName": "Yamatokoriyama City",
      "kana": "やまとこおりやまし",
      "chName": "大和郡山市",
      "zhName": "大和郡山市",
      "koName": "야마토코리야마 시",
      "esName": "Ciudad de Yamatokoriyama",
      "ptName": "cidade de Yamatokoriyama",
      "thName": "เมืองยามาโตะโคริยามะ",
      "viName": "thành phố Yamatokoriyama",
      "inName": "kota Yamatokoriyama",
      "tlName": "siyudad ng Yamatokoriyama",
      "moName": "Ямaтокориямa хот",
      "buName": "ယာမာတိုကိုရိယာ့မ မြို့",
      "khName": "ទីក្រុង យ៉ាម៉ាតូកូរីយ៉ាម៉ា",
      "neName": "यामातोकोरियामा सहर"
    }
  },
  "2920400": {
    "office": {
      "code": "290000",
      "name": "奈良県",
      "enName": "Nara",
      "officeName": "奈良地方気象台",
      "chName": "奈良县",
      "zhName": "奈良縣",
      "koName": "나라현",
      "esName": "Prefectura de Nara",
      "ptName": "Província de Nara",
      "thName": "จังหวัดนาระ",
      "viName": "Tỉnh Nara",
      "inName": "Prefektur Nara",
      "tlName": "Nara Prefecture",
      "moName": "Нара аймаг",
      "buName": "နာရာ ပြည်နယ်",
      "khName": "ខេត្ដ ណារ៉ា",
      "neName": "नारा जिल्ला"
    },
    "class10": {
      "code": "290010",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "奈良县北部",
      "zhName": "奈良縣北部",
      "koName": "나라현 북부",
      "esName": "Norte de Prefectura de Nara",
      "ptName": "Norte da Província de Nara",
      "thName": "จังหวัดนาระตอนเหนือ",
      "viName": "Miền Bắc tỉnh Nara",
      "inName": "Bagian Utara Prefektur Nara",
      "tlName": "Hilagang bahagi ng Nara Prefecture",
      "moName": "Хойд Нара аймаг",
      "buName": "နယစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដណារ៉ា",
      "neName": "नारा जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "290011",
      "name": "北西部",
      "enName": "North-western Region"
    },
    "class20": {
      "code": "2920400",
      "name": "天理市",
      "enName": "Tenri City",
      "kana": "てんりし",
      "chName": "天理市",
      "zhName": "天理市",
      "koName": "덴리 시",
      "esName": "Ciudad de Tenri",
      "ptName": "cidade de Tenri",
      "thName": "เมืองเทนริ",
      "viName": "thành phố Tenri",
      "inName": "kota Tenri",
      "tlName": "siyudad ng Tenri",
      "moName": "Тэнри хот",
      "buName": "တန်းရိ မြို့",
      "khName": "ទីក្រុង ថេនរី",
      "neName": "तेन्री सहर"
    }
  },
  "2920500": {
    "office": {
      "code": "290000",
      "name": "奈良県",
      "enName": "Nara",
      "officeName": "奈良地方気象台",
      "chName": "奈良县",
      "zhName": "奈良縣",
      "koName": "나라현",
      "esName": "Prefectura de Nara",
      "ptName": "Província de Nara",
      "thName": "จังหวัดนาระ",
      "viName": "Tỉnh Nara",
      "inName": "Prefektur Nara",
      "tlName": "Nara Prefecture",
      "moName": "Нара аймаг",
      "buName": "နာရာ ပြည်နယ်",
      "khName": "ខេត្ដ ណារ៉ា",
      "neName": "नारा जिल्ला"
    },
    "class10": {
      "code": "290010",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "奈良县北部",
      "zhName": "奈良縣北部",
      "koName": "나라현 북부",
      "esName": "Norte de Prefectura de Nara",
      "ptName": "Norte da Província de Nara",
      "thName": "จังหวัดนาระตอนเหนือ",
      "viName": "Miền Bắc tỉnh Nara",
      "inName": "Bagian Utara Prefektur Nara",
      "tlName": "Hilagang bahagi ng Nara Prefecture",
      "moName": "Хойд Нара аймаг",
      "buName": "နယစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដណារ៉ា",
      "neName": "नारा जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "290011",
      "name": "北西部",
      "enName": "North-western Region"
    },
    "class20": {
      "code": "2920500",
      "name": "橿原市",
      "enName": "Kashihara City",
      "kana": "かしはらし",
      "chName": "橿原市",
      "zhName": "橿原市",
      "koName": "가시하라 시",
      "esName": "Ciudad de Kashihara",
      "ptName": "cidade de Kashihara",
      "thName": "เมืองคาชิฮาระ",
      "viName": "thành phố Kashihara",
      "inName": "kota Kashihara",
      "tlName": "siyudad ng Kashihara",
      "moName": "Кашихaра хот",
      "buName": "ခါရှိဟာ့ရ မြို့",
      "khName": "ទីក្រុង កាស៊ីហារ៉ា",
      "neName": "काशिहारा सहर"
    }
  },
  "2920600": {
    "office": {
      "code": "290000",
      "name": "奈良県",
      "enName": "Nara",
      "officeName": "奈良地方気象台",
      "chName": "奈良县",
      "zhName": "奈良縣",
      "koName": "나라현",
      "esName": "Prefectura de Nara",
      "ptName": "Província de Nara",
      "thName": "จังหวัดนาระ",
      "viName": "Tỉnh Nara",
      "inName": "Prefektur Nara",
      "tlName": "Nara Prefecture",
      "moName": "Нара аймаг",
      "buName": "နာရာ ပြည်နယ်",
      "khName": "ខេត្ដ ណារ៉ា",
      "neName": "नारा जिल्ला"
    },
    "class10": {
      "code": "290010",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "奈良县北部",
      "zhName": "奈良縣北部",
      "koName": "나라현 북부",
      "esName": "Norte de Prefectura de Nara",
      "ptName": "Norte da Província de Nara",
      "thName": "จังหวัดนาระตอนเหนือ",
      "viName": "Miền Bắc tỉnh Nara",
      "inName": "Bagian Utara Prefektur Nara",
      "tlName": "Hilagang bahagi ng Nara Prefecture",
      "moName": "Хойд Нара аймаг",
      "buName": "နယစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដណារ៉ា",
      "neName": "नारा जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "290011",
      "name": "北西部",
      "enName": "North-western Region"
    },
    "class20": {
      "code": "2920600",
      "name": "桜井市",
      "enName": "Sakurai City",
      "kana": "さくらいし",
      "chName": "樱井市",
      "zhName": "櫻井市",
      "koName": "사쿠라이 시",
      "esName": "Ciudad de Sakurai",
      "ptName": "cidade de Sakurai",
      "thName": "เมืองซากุระอิ",
      "viName": "thành phố Sakurai",
      "inName": "kota Sakurai",
      "tlName": "siyudad ng Sakurai",
      "moName": "Сaкурай хот",
      "buName": "ဆာကုရယိ မြို့",
      "khName": "ទីក្រុង ​ សាគូរ៉ាយ",
      "neName": "साकुराई सहर"
    }
  },
  "2920701": {
    "office": {
      "code": "290000",
      "name": "奈良県",
      "enName": "Nara",
      "officeName": "奈良地方気象台",
      "chName": "奈良县",
      "zhName": "奈良縣",
      "koName": "나라현",
      "esName": "Prefectura de Nara",
      "ptName": "Província de Nara",
      "thName": "จังหวัดนาระ",
      "viName": "Tỉnh Nara",
      "inName": "Prefektur Nara",
      "tlName": "Nara Prefecture",
      "moName": "Нара аймаг",
      "buName": "နာရာ ပြည်နယ်",
      "khName": "ខេត្ដ ណារ៉ា",
      "neName": "नारा जिल्ला"
    },
    "class10": {
      "code": "290010",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "奈良县北部",
      "zhName": "奈良縣北部",
      "koName": "나라현 북부",
      "esName": "Norte de Prefectura de Nara",
      "ptName": "Norte da Província de Nara",
      "thName": "จังหวัดนาระตอนเหนือ",
      "viName": "Miền Bắc tỉnh Nara",
      "inName": "Bagian Utara Prefektur Nara",
      "tlName": "Hilagang bahagi ng Nara Prefecture",
      "moName": "Хойд Нара аймаг",
      "buName": "နယစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដណារ៉ា",
      "neName": "नारा जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "290013",
      "name": "五條・北部吉野",
      "enName": "Gojo and Northern Yoshino"
    },
    "class20": {
      "code": "2920701",
      "name": "五條市北部",
      "enName": "Northern Gojo City",
      "kana": "ごじょうしほくぶ",
      "chName": "五条市",
      "zhName": "五条市",
      "koName": "고조시",
      "esName": "Ciudad de Gojo",
      "ptName": "Cidade de Gojo",
      "thName": "เมืองโกโจ",
      "viName": "Thành phố Gojo",
      "inName": "Kota Gojo",
      "tlName": "Lungsod ng Gojo",
      "moName": "Cidade de Gojo",
      "buName": "ဂိုးဂျိုမြို့",
      "khName": "ខេត្តកូជូ",
      "neName": "गोजो शहर"
    }
  },
  "2920702": {
    "office": {
      "code": "290000",
      "name": "奈良県",
      "enName": "Nara",
      "officeName": "奈良地方気象台",
      "chName": "奈良县",
      "zhName": "奈良縣",
      "koName": "나라현",
      "esName": "Prefectura de Nara",
      "ptName": "Província de Nara",
      "thName": "จังหวัดนาระ",
      "viName": "Tỉnh Nara",
      "inName": "Prefektur Nara",
      "tlName": "Nara Prefecture",
      "moName": "Нара аймаг",
      "buName": "နာရာ ပြည်နယ်",
      "khName": "ខេត្ដ ណារ៉ា",
      "neName": "नारा जिल्ला"
    },
    "class10": {
      "code": "290020",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "奈良县南部",
      "zhName": "奈良縣南部",
      "koName": "나라현 남부",
      "esName": "Sur de Prefectura de Nara",
      "ptName": "Sul da Província de Nara",
      "thName": "จังหวัดนาระตอนใต้",
      "viName": "Miền Nam tỉnh Nara",
      "inName": "Bagian Selatan Prefektur Nara",
      "tlName": "Timog na bahagi ng Nara Prefecture",
      "moName": "Өмнөд Нара аймаг",
      "buName": "နယစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដណារ៉ា",
      "neName": "नारा जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "290022",
      "name": "南西部",
      "enName": "South-western Region"
    },
    "class20": {
      "code": "2920702",
      "name": "五條市南部",
      "enName": "Southern Gojo City",
      "kana": "ごじょうしなんぶ",
      "chName": "五条市",
      "zhName": "五条市",
      "koName": "고조시",
      "esName": "Ciudad de Gojo",
      "ptName": "Cidade de Gojo",
      "thName": "เมืองโกโจ",
      "viName": "Thành phố Gojo",
      "inName": "Kota Gojo",
      "tlName": "Lungsod ng Gojo",
      "moName": "Cidade de Gojo",
      "buName": "ဂိုးဂျိုမြို့",
      "khName": "ខេត្តកូជូ",
      "neName": "गोजो शहर"
    }
  },
  "2920800": {
    "office": {
      "code": "290000",
      "name": "奈良県",
      "enName": "Nara",
      "officeName": "奈良地方気象台",
      "chName": "奈良县",
      "zhName": "奈良縣",
      "koName": "나라현",
      "esName": "Prefectura de Nara",
      "ptName": "Província de Nara",
      "thName": "จังหวัดนาระ",
      "viName": "Tỉnh Nara",
      "inName": "Prefektur Nara",
      "tlName": "Nara Prefecture",
      "moName": "Нара аймаг",
      "buName": "နာရာ ပြည်နယ်",
      "khName": "ខេត្ដ ណារ៉ា",
      "neName": "नारा जिल्ला"
    },
    "class10": {
      "code": "290010",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "奈良县北部",
      "zhName": "奈良縣北部",
      "koName": "나라현 북부",
      "esName": "Norte de Prefectura de Nara",
      "ptName": "Norte da Província de Nara",
      "thName": "จังหวัดนาระตอนเหนือ",
      "viName": "Miền Bắc tỉnh Nara",
      "inName": "Bagian Utara Prefektur Nara",
      "tlName": "Hilagang bahagi ng Nara Prefecture",
      "moName": "Хойд Нара аймаг",
      "buName": "နယစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដណារ៉ា",
      "neName": "नारा जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "290011",
      "name": "北西部",
      "enName": "North-western Region"
    },
    "class20": {
      "code": "2920800",
      "name": "御所市",
      "enName": "Gose City",
      "kana": "ごせし",
      "chName": "御所市",
      "zhName": "御所市",
      "koName": "고세 시",
      "esName": "Ciudad de Gose",
      "ptName": "cidade de Gose",
      "thName": "เมืองโกะเสะ",
      "viName": "thành phố Gose",
      "inName": "kota Gose",
      "tlName": "siyudad ng Gose",
      "moName": "Госэ хот",
      "buName": "ဂိုးဇဲ့ မြို့",
      "khName": "ទីក្រុង ហ្គូស",
      "neName": "होसे सहर"
    }
  },
  "2920900": {
    "office": {
      "code": "290000",
      "name": "奈良県",
      "enName": "Nara",
      "officeName": "奈良地方気象台",
      "chName": "奈良县",
      "zhName": "奈良縣",
      "koName": "나라현",
      "esName": "Prefectura de Nara",
      "ptName": "Província de Nara",
      "thName": "จังหวัดนาระ",
      "viName": "Tỉnh Nara",
      "inName": "Prefektur Nara",
      "tlName": "Nara Prefecture",
      "moName": "Нара аймаг",
      "buName": "နာရာ ပြည်နယ်",
      "khName": "ខេត្ដ ណារ៉ា",
      "neName": "नारा जिल्ला"
    },
    "class10": {
      "code": "290010",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "奈良县北部",
      "zhName": "奈良縣北部",
      "koName": "나라현 북부",
      "esName": "Norte de Prefectura de Nara",
      "ptName": "Norte da Província de Nara",
      "thName": "จังหวัดนาระตอนเหนือ",
      "viName": "Miền Bắc tỉnh Nara",
      "inName": "Bagian Utara Prefektur Nara",
      "tlName": "Hilagang bahagi ng Nara Prefecture",
      "moName": "Хойд Нара аймаг",
      "buName": "နယစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដណារ៉ា",
      "neName": "नारा जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "290011",
      "name": "北西部",
      "enName": "North-western Region"
    },
    "class20": {
      "code": "2920900",
      "name": "生駒市",
      "enName": "Ikoma City",
      "kana": "いこまし",
      "chName": "生驹市",
      "zhName": "生駒市",
      "koName": "이코마 시",
      "esName": "Ciudad de Ikoma",
      "ptName": "cidade de Ikoma",
      "thName": "เมืองอิโคมะ",
      "viName": "thành phố Ikoma",
      "inName": "kota Ikoma",
      "tlName": "siyudad ng Ikoma",
      "moName": "Икомa хот",
      "buName": "အီကောမ မြို့",
      "khName": "ទីក្រុង អាយខូម៉ា",
      "neName": "इकोमा सहर"
    }
  },
  "2921000": {
    "office": {
      "code": "290000",
      "name": "奈良県",
      "enName": "Nara",
      "officeName": "奈良地方気象台",
      "chName": "奈良县",
      "zhName": "奈良縣",
      "koName": "나라현",
      "esName": "Prefectura de Nara",
      "ptName": "Província de Nara",
      "thName": "จังหวัดนาระ",
      "viName": "Tỉnh Nara",
      "inName": "Prefektur Nara",
      "tlName": "Nara Prefecture",
      "moName": "Нара аймаг",
      "buName": "နာရာ ပြည်နယ်",
      "khName": "ខេត្ដ ណារ៉ា",
      "neName": "नारा जिल्ला"
    },
    "class10": {
      "code": "290010",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "奈良县北部",
      "zhName": "奈良縣北部",
      "koName": "나라현 북부",
      "esName": "Norte de Prefectura de Nara",
      "ptName": "Norte da Província de Nara",
      "thName": "จังหวัดนาระตอนเหนือ",
      "viName": "Miền Bắc tỉnh Nara",
      "inName": "Bagian Utara Prefektur Nara",
      "tlName": "Hilagang bahagi ng Nara Prefecture",
      "moName": "Хойд Нара аймаг",
      "buName": "နယစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដណារ៉ា",
      "neName": "नारा जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "290011",
      "name": "北西部",
      "enName": "North-western Region"
    },
    "class20": {
      "code": "2921000",
      "name": "香芝市",
      "enName": "Kashiba City",
      "kana": "かしばし",
      "chName": "香芝市",
      "zhName": "香芝市",
      "koName": "가시바 시",
      "esName": "Ciudad de Kashiba ",
      "ptName": "cidade de Kashiba",
      "thName": "เมืองคาชิบะ",
      "viName": "thành phố Kashiba",
      "inName": "kota Kashiba",
      "tlName": "siyudad ng Kashiba",
      "moName": "Кашиба хот",
      "buName": "ခါ့ရှိဘ မြို့",
      "khName": "ទីក្រុង កាស៊ីបា",
      "neName": "काशिबा सहर"
    }
  },
  "2921100": {
    "office": {
      "code": "290000",
      "name": "奈良県",
      "enName": "Nara",
      "officeName": "奈良地方気象台",
      "chName": "奈良县",
      "zhName": "奈良縣",
      "koName": "나라현",
      "esName": "Prefectura de Nara",
      "ptName": "Província de Nara",
      "thName": "จังหวัดนาระ",
      "viName": "Tỉnh Nara",
      "inName": "Prefektur Nara",
      "tlName": "Nara Prefecture",
      "moName": "Нара аймаг",
      "buName": "နာရာ ပြည်နယ်",
      "khName": "ខេត្ដ ណារ៉ា",
      "neName": "नारा जिल्ला"
    },
    "class10": {
      "code": "290010",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "奈良县北部",
      "zhName": "奈良縣北部",
      "koName": "나라현 북부",
      "esName": "Norte de Prefectura de Nara",
      "ptName": "Norte da Província de Nara",
      "thName": "จังหวัดนาระตอนเหนือ",
      "viName": "Miền Bắc tỉnh Nara",
      "inName": "Bagian Utara Prefektur Nara",
      "tlName": "Hilagang bahagi ng Nara Prefecture",
      "moName": "Хойд Нара аймаг",
      "buName": "နယစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដណារ៉ា",
      "neName": "नारा जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "290011",
      "name": "北西部",
      "enName": "North-western Region"
    },
    "class20": {
      "code": "2921100",
      "name": "葛城市",
      "enName": "Katsuragi City",
      "kana": "かつらぎし",
      "chName": "葛城市",
      "zhName": "葛城市",
      "koName": "가쓰라기 시",
      "esName": "Ciudad de Katsuragi",
      "ptName": "cidade de Katsuragi",
      "thName": "เมืองคัทสึระงิ",
      "viName": "thành phố Katsuragi",
      "inName": "kota Katsuragi",
      "tlName": "siyudad ng Katsuragi",
      "moName": "Кацүраги хот",
      "buName": "ခါဆုရဂိ မြို့",
      "khName": "ទីក្រុង កាស៊ូរ៉ាជី",
      "neName": "कात्सुरागी सहर"
    }
  },
  "2921200": {
    "office": {
      "code": "290000",
      "name": "奈良県",
      "enName": "Nara",
      "officeName": "奈良地方気象台",
      "chName": "奈良县",
      "zhName": "奈良縣",
      "koName": "나라현",
      "esName": "Prefectura de Nara",
      "ptName": "Província de Nara",
      "thName": "จังหวัดนาระ",
      "viName": "Tỉnh Nara",
      "inName": "Prefektur Nara",
      "tlName": "Nara Prefecture",
      "moName": "Нара аймаг",
      "buName": "နာရာ ပြည်နယ်",
      "khName": "ខេត្ដ ណារ៉ា",
      "neName": "नारा जिल्ला"
    },
    "class10": {
      "code": "290010",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "奈良县北部",
      "zhName": "奈良縣北部",
      "koName": "나라현 북부",
      "esName": "Norte de Prefectura de Nara",
      "ptName": "Norte da Província de Nara",
      "thName": "จังหวัดนาระตอนเหนือ",
      "viName": "Miền Bắc tỉnh Nara",
      "inName": "Bagian Utara Prefektur Nara",
      "tlName": "Hilagang bahagi ng Nara Prefecture",
      "moName": "Хойд Нара аймаг",
      "buName": "နယစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដណារ៉ា",
      "neName": "नारा जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "290012",
      "name": "北東部",
      "enName": "North-eastern Region"
    },
    "class20": {
      "code": "2921200",
      "name": "宇陀市",
      "enName": "Uda City",
      "kana": "うだし",
      "chName": "宇陀市",
      "zhName": "宇陀市",
      "koName": "우다 시",
      "esName": "Ciudad de Uda",
      "ptName": "cidade de Uda",
      "thName": "เมืองอุดะ",
      "viName": "thành phố Uda",
      "inName": "kota Uda",
      "tlName": "siyudad ng Uda",
      "moName": "Үда хот",
      "buName": "အူးဒ မြို့",
      "khName": "ទីក្រុង យូដា",
      "neName": "उदा सहर"
    }
  },
  "2932200": {
    "office": {
      "code": "290000",
      "name": "奈良県",
      "enName": "Nara",
      "officeName": "奈良地方気象台",
      "chName": "奈良县",
      "zhName": "奈良縣",
      "koName": "나라현",
      "esName": "Prefectura de Nara",
      "ptName": "Província de Nara",
      "thName": "จังหวัดนาระ",
      "viName": "Tỉnh Nara",
      "inName": "Prefektur Nara",
      "tlName": "Nara Prefecture",
      "moName": "Нара аймаг",
      "buName": "နာရာ ပြည်နယ်",
      "khName": "ខេត្ដ ណារ៉ា",
      "neName": "नारा जिल्ला"
    },
    "class10": {
      "code": "290010",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "奈良县北部",
      "zhName": "奈良縣北部",
      "koName": "나라현 북부",
      "esName": "Norte de Prefectura de Nara",
      "ptName": "Norte da Província de Nara",
      "thName": "จังหวัดนาระตอนเหนือ",
      "viName": "Miền Bắc tỉnh Nara",
      "inName": "Bagian Utara Prefektur Nara",
      "tlName": "Hilagang bahagi ng Nara Prefecture",
      "moName": "Хойд Нара аймаг",
      "buName": "နယစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដណារ៉ា",
      "neName": "नारा जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "290012",
      "name": "北東部",
      "enName": "North-eastern Region"
    },
    "class20": {
      "code": "2932200",
      "name": "山添村",
      "enName": "Yamazoe Village",
      "kana": "やまぞえむら",
      "chName": "山添村",
      "zhName": "山添村",
      "koName": "야마조에 촌",
      "esName": "Aldea de Yamazoe",
      "ptName": "povoado de Yamazoe",
      "thName": "หมู่บ้านยามาโซเอะ",
      "viName": "làng Yamazoe",
      "inName": "desa Yamazoe",
      "tlName": "nayon ng Yamazoe",
      "moName": "Ямaзоэ тосгон",
      "buName": "ယာမဇိုအဲ့ ကျေးရွာ",
      "khName": "ភូមិ យ៉ាម៉ាសូ",
      "neName": "यामाजोए गाउँ"
    }
  },
  "2934200": {
    "office": {
      "code": "290000",
      "name": "奈良県",
      "enName": "Nara",
      "officeName": "奈良地方気象台",
      "chName": "奈良县",
      "zhName": "奈良縣",
      "koName": "나라현",
      "esName": "Prefectura de Nara",
      "ptName": "Província de Nara",
      "thName": "จังหวัดนาระ",
      "viName": "Tỉnh Nara",
      "inName": "Prefektur Nara",
      "tlName": "Nara Prefecture",
      "moName": "Нара аймаг",
      "buName": "နာရာ ပြည်နယ်",
      "khName": "ខេត្ដ ណារ៉ា",
      "neName": "नारा जिल्ला"
    },
    "class10": {
      "code": "290010",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "奈良县北部",
      "zhName": "奈良縣北部",
      "koName": "나라현 북부",
      "esName": "Norte de Prefectura de Nara",
      "ptName": "Norte da Província de Nara",
      "thName": "จังหวัดนาระตอนเหนือ",
      "viName": "Miền Bắc tỉnh Nara",
      "inName": "Bagian Utara Prefektur Nara",
      "tlName": "Hilagang bahagi ng Nara Prefecture",
      "moName": "Хойд Нара аймаг",
      "buName": "နယစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដណារ៉ា",
      "neName": "नारा जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "290011",
      "name": "北西部",
      "enName": "North-western Region"
    },
    "class20": {
      "code": "2934200",
      "name": "平群町",
      "enName": "Heguri Town",
      "kana": "へぐりちょう",
      "chName": "平群町",
      "zhName": "平群町",
      "koName": "헤구리 정",
      "esName": "Pueblo de Heguri",
      "ptName": "bairro de Heguri",
      "thName": "เมืองเฮกุริ",
      "viName": "thị trấn Heguri",
      "inName": "kota Heguri",
      "tlName": "bayan ng Heguri",
      "moName": "Хэгүри жижиг хот",
      "buName": "ဟဲဂုရိ မြို့နယ်",
      "khName": "ទីប្រជុំជន ហឺហ្គរី",
      "neName": "हेगुरी नगर"
    }
  },
  "2934300": {
    "office": {
      "code": "290000",
      "name": "奈良県",
      "enName": "Nara",
      "officeName": "奈良地方気象台",
      "chName": "奈良县",
      "zhName": "奈良縣",
      "koName": "나라현",
      "esName": "Prefectura de Nara",
      "ptName": "Província de Nara",
      "thName": "จังหวัดนาระ",
      "viName": "Tỉnh Nara",
      "inName": "Prefektur Nara",
      "tlName": "Nara Prefecture",
      "moName": "Нара аймаг",
      "buName": "နာရာ ပြည်နယ်",
      "khName": "ខេត្ដ ណារ៉ា",
      "neName": "नारा जिल्ला"
    },
    "class10": {
      "code": "290010",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "奈良县北部",
      "zhName": "奈良縣北部",
      "koName": "나라현 북부",
      "esName": "Norte de Prefectura de Nara",
      "ptName": "Norte da Província de Nara",
      "thName": "จังหวัดนาระตอนเหนือ",
      "viName": "Miền Bắc tỉnh Nara",
      "inName": "Bagian Utara Prefektur Nara",
      "tlName": "Hilagang bahagi ng Nara Prefecture",
      "moName": "Хойд Нара аймаг",
      "buName": "နယစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដណារ៉ា",
      "neName": "नारा जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "290011",
      "name": "北西部",
      "enName": "North-western Region"
    },
    "class20": {
      "code": "2934300",
      "name": "三郷町",
      "enName": "Sango Town",
      "kana": "さんごうちょう",
      "chName": "三乡町",
      "zhName": "三鄉町",
      "koName": "산고 정",
      "esName": "Pueblo de Sango",
      "ptName": "bairro de Sango",
      "thName": "เมืองซันโงะ",
      "viName": "thị trấn Sango",
      "inName": "kota Sango",
      "tlName": "bayan ng Sango",
      "moName": "Сaнго жижиг хот",
      "buName": "ဆန်းဂို မြို့နယ်",
      "khName": "ទីប្រជុំជន សាងហ្គោ",
      "neName": "साङ्गो नगर"
    }
  },
  "2934400": {
    "office": {
      "code": "290000",
      "name": "奈良県",
      "enName": "Nara",
      "officeName": "奈良地方気象台",
      "chName": "奈良县",
      "zhName": "奈良縣",
      "koName": "나라현",
      "esName": "Prefectura de Nara",
      "ptName": "Província de Nara",
      "thName": "จังหวัดนาระ",
      "viName": "Tỉnh Nara",
      "inName": "Prefektur Nara",
      "tlName": "Nara Prefecture",
      "moName": "Нара аймаг",
      "buName": "နာရာ ပြည်နယ်",
      "khName": "ខេត្ដ ណារ៉ា",
      "neName": "नारा जिल्ला"
    },
    "class10": {
      "code": "290010",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "奈良县北部",
      "zhName": "奈良縣北部",
      "koName": "나라현 북부",
      "esName": "Norte de Prefectura de Nara",
      "ptName": "Norte da Província de Nara",
      "thName": "จังหวัดนาระตอนเหนือ",
      "viName": "Miền Bắc tỉnh Nara",
      "inName": "Bagian Utara Prefektur Nara",
      "tlName": "Hilagang bahagi ng Nara Prefecture",
      "moName": "Хойд Нара аймаг",
      "buName": "နယစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដណារ៉ា",
      "neName": "नारा जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "290011",
      "name": "北西部",
      "enName": "North-western Region"
    },
    "class20": {
      "code": "2934400",
      "name": "斑鳩町",
      "enName": "Ikaruga Town",
      "kana": "いかるがちょう",
      "chName": "斑鸠町",
      "zhName": "斑鳩町",
      "koName": "이카루가 정",
      "esName": "Pueblo de Ikaruga",
      "ptName": "bairro de Ikaruga",
      "thName": "เมืองอิคะรุกะ",
      "viName": "thị trấn Ikaruga",
      "inName": "kota Ikaruga",
      "tlName": "bayan ng Ikaruga",
      "moName": "Икарүгa жижиг хот",
      "buName": "အီကားရုဂ မြို့နယ်",
      "khName": "ទីប្រជុំជន អ៊ីការូកា",
      "neName": "इकारुगा नगर"
    }
  },
  "2934500": {
    "office": {
      "code": "290000",
      "name": "奈良県",
      "enName": "Nara",
      "officeName": "奈良地方気象台",
      "chName": "奈良县",
      "zhName": "奈良縣",
      "koName": "나라현",
      "esName": "Prefectura de Nara",
      "ptName": "Província de Nara",
      "thName": "จังหวัดนาระ",
      "viName": "Tỉnh Nara",
      "inName": "Prefektur Nara",
      "tlName": "Nara Prefecture",
      "moName": "Нара аймаг",
      "buName": "နာရာ ပြည်နယ်",
      "khName": "ខេត្ដ ណារ៉ា",
      "neName": "नारा जिल्ला"
    },
    "class10": {
      "code": "290010",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "奈良县北部",
      "zhName": "奈良縣北部",
      "koName": "나라현 북부",
      "esName": "Norte de Prefectura de Nara",
      "ptName": "Norte da Província de Nara",
      "thName": "จังหวัดนาระตอนเหนือ",
      "viName": "Miền Bắc tỉnh Nara",
      "inName": "Bagian Utara Prefektur Nara",
      "tlName": "Hilagang bahagi ng Nara Prefecture",
      "moName": "Хойд Нара аймаг",
      "buName": "နယစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដណារ៉ា",
      "neName": "नारा जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "290011",
      "name": "北西部",
      "enName": "North-western Region"
    },
    "class20": {
      "code": "2934500",
      "name": "安堵町",
      "enName": "Ando Town",
      "kana": "あんどちょう",
      "chName": "安堵町",
      "zhName": "安堵町",
      "koName": "안도 정",
      "esName": "Pueblo de Ando",
      "ptName": "bairro de Ando",
      "thName": "เมืองอันโะ",
      "viName": "thị trấn Ando",
      "inName": "kota Ando",
      "tlName": "bayan ng Ando",
      "moName": "Aндо жижиг хот",
      "buName": "အန်းဒို မြို့နယ်",
      "khName": "ទីប្រជុំជន អានដូ",
      "neName": "आन्दो नगर"
    }
  },
  "2936100": {
    "office": {
      "code": "290000",
      "name": "奈良県",
      "enName": "Nara",
      "officeName": "奈良地方気象台",
      "chName": "奈良县",
      "zhName": "奈良縣",
      "koName": "나라현",
      "esName": "Prefectura de Nara",
      "ptName": "Província de Nara",
      "thName": "จังหวัดนาระ",
      "viName": "Tỉnh Nara",
      "inName": "Prefektur Nara",
      "tlName": "Nara Prefecture",
      "moName": "Нара аймаг",
      "buName": "နာရာ ပြည်နယ်",
      "khName": "ខេត្ដ ណារ៉ា",
      "neName": "नारा जिल्ला"
    },
    "class10": {
      "code": "290010",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "奈良县北部",
      "zhName": "奈良縣北部",
      "koName": "나라현 북부",
      "esName": "Norte de Prefectura de Nara",
      "ptName": "Norte da Província de Nara",
      "thName": "จังหวัดนาระตอนเหนือ",
      "viName": "Miền Bắc tỉnh Nara",
      "inName": "Bagian Utara Prefektur Nara",
      "tlName": "Hilagang bahagi ng Nara Prefecture",
      "moName": "Хойд Нара аймаг",
      "buName": "နယစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដណារ៉ា",
      "neName": "नारा जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "290011",
      "name": "北西部",
      "enName": "North-western Region"
    },
    "class20": {
      "code": "2936100",
      "name": "川西町",
      "enName": "Kawanishi Town",
      "kana": "かわにしちょう",
      "chName": "奈良川西町",
      "zhName": "奈良川西町",
      "koName": "나라 가와니시 정",
      "esName": "Pueblo de Kawanishi, Nara",
      "ptName": "Nara, bairro de Kawanishi ",
      "thName": "เมืองคาวานิชิ นาระ",
      "viName": "Thị trấn Kawanishi, Nara",
      "inName": "Kota Kawanishi, Nara",
      "tlName": "bayan ng Kawanishi, Nara",
      "moName": "Наракава Ниши жижиг хот",
      "buName": "နယကဝနိရှိမြို့နယ်",
      "khName": "ទីប្រជុំជនកាវ៉ាន់នីស៊ី ណារ៉ា",
      "neName": "नारा कावानिशी नगर"
    }
  },
  "2936200": {
    "office": {
      "code": "290000",
      "name": "奈良県",
      "enName": "Nara",
      "officeName": "奈良地方気象台",
      "chName": "奈良县",
      "zhName": "奈良縣",
      "koName": "나라현",
      "esName": "Prefectura de Nara",
      "ptName": "Província de Nara",
      "thName": "จังหวัดนาระ",
      "viName": "Tỉnh Nara",
      "inName": "Prefektur Nara",
      "tlName": "Nara Prefecture",
      "moName": "Нара аймаг",
      "buName": "နာရာ ပြည်နယ်",
      "khName": "ខេត្ដ ណារ៉ា",
      "neName": "नारा जिल्ला"
    },
    "class10": {
      "code": "290010",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "奈良县北部",
      "zhName": "奈良縣北部",
      "koName": "나라현 북부",
      "esName": "Norte de Prefectura de Nara",
      "ptName": "Norte da Província de Nara",
      "thName": "จังหวัดนาระตอนเหนือ",
      "viName": "Miền Bắc tỉnh Nara",
      "inName": "Bagian Utara Prefektur Nara",
      "tlName": "Hilagang bahagi ng Nara Prefecture",
      "moName": "Хойд Нара аймаг",
      "buName": "နယစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដណារ៉ា",
      "neName": "नारा जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "290011",
      "name": "北西部",
      "enName": "North-western Region"
    },
    "class20": {
      "code": "2936200",
      "name": "三宅町",
      "enName": "Miyake Town",
      "kana": "みやけちょう",
      "chName": "三宅町",
      "zhName": "三宅町",
      "koName": "미야케 정",
      "esName": "Pueblo de Miyake",
      "ptName": "bairro de Miyake",
      "thName": "เมืองมิยาเกะ",
      "viName": "thị trấn Miyake",
      "inName": "kota Miyake",
      "tlName": "bayan ng Miyake",
      "moName": "Миякэ жижиг хот",
      "buName": "မီယားကဲ့ မြို့နယ်",
      "khName": "ទីប្រជុំជន មីយ៉ាកេ",
      "neName": "मियाके नगर"
    }
  },
  "2936300": {
    "office": {
      "code": "290000",
      "name": "奈良県",
      "enName": "Nara",
      "officeName": "奈良地方気象台",
      "chName": "奈良县",
      "zhName": "奈良縣",
      "koName": "나라현",
      "esName": "Prefectura de Nara",
      "ptName": "Província de Nara",
      "thName": "จังหวัดนาระ",
      "viName": "Tỉnh Nara",
      "inName": "Prefektur Nara",
      "tlName": "Nara Prefecture",
      "moName": "Нара аймаг",
      "buName": "နာရာ ပြည်နယ်",
      "khName": "ខេត្ដ ណារ៉ា",
      "neName": "नारा जिल्ला"
    },
    "class10": {
      "code": "290010",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "奈良县北部",
      "zhName": "奈良縣北部",
      "koName": "나라현 북부",
      "esName": "Norte de Prefectura de Nara",
      "ptName": "Norte da Província de Nara",
      "thName": "จังหวัดนาระตอนเหนือ",
      "viName": "Miền Bắc tỉnh Nara",
      "inName": "Bagian Utara Prefektur Nara",
      "tlName": "Hilagang bahagi ng Nara Prefecture",
      "moName": "Хойд Нара аймаг",
      "buName": "နယစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដណារ៉ា",
      "neName": "नारा जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "290011",
      "name": "北西部",
      "enName": "North-western Region"
    },
    "class20": {
      "code": "2936300",
      "name": "田原本町",
      "enName": "Tawaramoto Town",
      "kana": "たわらもとちょう",
      "chName": "田原本町",
      "zhName": "田原本町",
      "koName": "다와라모토 정",
      "esName": "Pueblo de Tawaramoto",
      "ptName": "bairro de Tawaramoto",
      "thName": "เมืองทาวาระโมโต",
      "viName": "thị trấn Tawaramoto",
      "inName": "kota Tawaramoto",
      "tlName": "bayan ng Tawaramoto",
      "moName": "Таварамото жижиг хот",
      "buName": "တာဝါရာမိုတို မြို့နယ်",
      "khName": "ទីប្រជុំជន ថាវ៉ារ៉ាម៉ូតុ",
      "neName": "तावारामोतो नगर"
    }
  },
  "2938500": {
    "office": {
      "code": "290000",
      "name": "奈良県",
      "enName": "Nara",
      "officeName": "奈良地方気象台",
      "chName": "奈良县",
      "zhName": "奈良縣",
      "koName": "나라현",
      "esName": "Prefectura de Nara",
      "ptName": "Província de Nara",
      "thName": "จังหวัดนาระ",
      "viName": "Tỉnh Nara",
      "inName": "Prefektur Nara",
      "tlName": "Nara Prefecture",
      "moName": "Нара аймаг",
      "buName": "နာရာ ပြည်နယ်",
      "khName": "ខេត្ដ ណារ៉ា",
      "neName": "नारा जिल्ला"
    },
    "class10": {
      "code": "290020",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "奈良县南部",
      "zhName": "奈良縣南部",
      "koName": "나라현 남부",
      "esName": "Sur de Prefectura de Nara",
      "ptName": "Sul da Província de Nara",
      "thName": "จังหวัดนาระตอนใต้",
      "viName": "Miền Nam tỉnh Nara",
      "inName": "Bagian Selatan Prefektur Nara",
      "tlName": "Timog na bahagi ng Nara Prefecture",
      "moName": "Өмнөд Нара аймаг",
      "buName": "နယစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដណារ៉ា",
      "neName": "नारा जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "290021",
      "name": "南東部",
      "enName": "South-eastern Region"
    },
    "class20": {
      "code": "2938500",
      "name": "曽爾村",
      "enName": "Soni Village",
      "kana": "そにむら",
      "chName": "曾尔村",
      "zhName": "曾爾村",
      "koName": "소니 촌",
      "esName": "Aldea de Soni",
      "ptName": "povoado de Soni",
      "thName": "หมู่บ้านโซนิ",
      "viName": "làng Soni",
      "inName": "desa Soni",
      "tlName": "nayon ng Soni",
      "moName": "Сони тосгон",
      "buName": "ဆိုးနိ ကျေးရွာ",
      "khName": "ភូមិ សូនី",
      "neName": "सोनी गाउँ"
    }
  },
  "2938600": {
    "office": {
      "code": "290000",
      "name": "奈良県",
      "enName": "Nara",
      "officeName": "奈良地方気象台",
      "chName": "奈良县",
      "zhName": "奈良縣",
      "koName": "나라현",
      "esName": "Prefectura de Nara",
      "ptName": "Província de Nara",
      "thName": "จังหวัดนาระ",
      "viName": "Tỉnh Nara",
      "inName": "Prefektur Nara",
      "tlName": "Nara Prefecture",
      "moName": "Нара аймаг",
      "buName": "နာရာ ပြည်နယ်",
      "khName": "ខេត្ដ ណារ៉ា",
      "neName": "नारा जिल्ला"
    },
    "class10": {
      "code": "290020",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "奈良县南部",
      "zhName": "奈良縣南部",
      "koName": "나라현 남부",
      "esName": "Sur de Prefectura de Nara",
      "ptName": "Sul da Província de Nara",
      "thName": "จังหวัดนาระตอนใต้",
      "viName": "Miền Nam tỉnh Nara",
      "inName": "Bagian Selatan Prefektur Nara",
      "tlName": "Timog na bahagi ng Nara Prefecture",
      "moName": "Өмнөд Нара аймаг",
      "buName": "နယစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដណារ៉ា",
      "neName": "नारा जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "290021",
      "name": "南東部",
      "enName": "South-eastern Region"
    },
    "class20": {
      "code": "2938600",
      "name": "御杖村",
      "enName": "Mitsue Village",
      "kana": "みつえむら",
      "chName": "御杖村",
      "zhName": "御杖村",
      "koName": "미쓰에 촌",
      "esName": "Aldea de Mitsue",
      "ptName": "povoado de Mitsue",
      "thName": "หมู่บ้านมิสึเอะ",
      "viName": "làng Mitsue",
      "inName": "desa Mitsue",
      "tlName": "nayon ng Mitsue",
      "moName": "Мицүэ тосгон",
      "buName": "မီဆုအဲ့ ကျေးရွာ",
      "khName": "ភូមិ មីតស៊ូ",
      "neName": "मित्सुए गाउँ"
    }
  },
  "2940100": {
    "office": {
      "code": "290000",
      "name": "奈良県",
      "enName": "Nara",
      "officeName": "奈良地方気象台",
      "chName": "奈良县",
      "zhName": "奈良縣",
      "koName": "나라현",
      "esName": "Prefectura de Nara",
      "ptName": "Província de Nara",
      "thName": "จังหวัดนาระ",
      "viName": "Tỉnh Nara",
      "inName": "Prefektur Nara",
      "tlName": "Nara Prefecture",
      "moName": "Нара аймаг",
      "buName": "နာရာ ပြည်နယ်",
      "khName": "ខេត្ដ ណារ៉ា",
      "neName": "नारा जिल्ला"
    },
    "class10": {
      "code": "290010",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "奈良县北部",
      "zhName": "奈良縣北部",
      "koName": "나라현 북부",
      "esName": "Norte de Prefectura de Nara",
      "ptName": "Norte da Província de Nara",
      "thName": "จังหวัดนาระตอนเหนือ",
      "viName": "Miền Bắc tỉnh Nara",
      "inName": "Bagian Utara Prefektur Nara",
      "tlName": "Hilagang bahagi ng Nara Prefecture",
      "moName": "Хойд Нара аймаг",
      "buName": "နယစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដណារ៉ា",
      "neName": "नारा जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "290011",
      "name": "北西部",
      "enName": "North-western Region"
    },
    "class20": {
      "code": "2940100",
      "name": "高取町",
      "enName": "Takatori Town",
      "kana": "たかとりちょう",
      "chName": "高取町",
      "zhName": "髙取町",
      "koName": "다카토리 촌",
      "esName": "Pueblo de Takatori",
      "ptName": "bairro de Takatori",
      "thName": "เมืองทากาโทริ",
      "viName": "thị trấn Takatori",
      "inName": "kota Takatori",
      "tlName": "bayan ng Takatori",
      "moName": "Такатори жижиг хот",
      "buName": "တာကာတိုးရိ မြို့နယ်",
      "khName": "ទីប្រជុំជន តាកាតូរី",
      "neName": "ताकातोरी नगर"
    }
  },
  "2940200": {
    "office": {
      "code": "290000",
      "name": "奈良県",
      "enName": "Nara",
      "officeName": "奈良地方気象台",
      "chName": "奈良县",
      "zhName": "奈良縣",
      "koName": "나라현",
      "esName": "Prefectura de Nara",
      "ptName": "Província de Nara",
      "thName": "จังหวัดนาระ",
      "viName": "Tỉnh Nara",
      "inName": "Prefektur Nara",
      "tlName": "Nara Prefecture",
      "moName": "Нара аймаг",
      "buName": "နာရာ ပြည်နယ်",
      "khName": "ខេត្ដ ណារ៉ា",
      "neName": "नारा जिल्ला"
    },
    "class10": {
      "code": "290010",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "奈良县北部",
      "zhName": "奈良縣北部",
      "koName": "나라현 북부",
      "esName": "Norte de Prefectura de Nara",
      "ptName": "Norte da Província de Nara",
      "thName": "จังหวัดนาระตอนเหนือ",
      "viName": "Miền Bắc tỉnh Nara",
      "inName": "Bagian Utara Prefektur Nara",
      "tlName": "Hilagang bahagi ng Nara Prefecture",
      "moName": "Хойд Нара аймаг",
      "buName": "နယစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដណារ៉ា",
      "neName": "नारा जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "290011",
      "name": "北西部",
      "enName": "North-western Region"
    },
    "class20": {
      "code": "2940200",
      "name": "明日香村",
      "enName": "Asuka Village",
      "kana": "あすかむら",
      "chName": "明日香村",
      "zhName": "明日香村",
      "koName": "아스카 촌",
      "esName": "Aldea de Asuka",
      "ptName": "povoado de Asuka",
      "thName": "หมู่บ้านอาสึกะ",
      "viName": "làng Asuka",
      "inName": "desa Asuka",
      "tlName": "nayon ng Asuka",
      "moName": "Aсүка тосгон",
      "buName": "အာဆုက ကျေးရွာ",
      "khName": "ភូមិ អាស៊ូកា",
      "neName": "आसुका गाउँ"
    }
  },
  "2942400": {
    "office": {
      "code": "290000",
      "name": "奈良県",
      "enName": "Nara",
      "officeName": "奈良地方気象台",
      "chName": "奈良县",
      "zhName": "奈良縣",
      "koName": "나라현",
      "esName": "Prefectura de Nara",
      "ptName": "Província de Nara",
      "thName": "จังหวัดนาระ",
      "viName": "Tỉnh Nara",
      "inName": "Prefektur Nara",
      "tlName": "Nara Prefecture",
      "moName": "Нара аймаг",
      "buName": "နာရာ ပြည်နယ်",
      "khName": "ខេត្ដ ណារ៉ា",
      "neName": "नारा जिल्ला"
    },
    "class10": {
      "code": "290010",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "奈良县北部",
      "zhName": "奈良縣北部",
      "koName": "나라현 북부",
      "esName": "Norte de Prefectura de Nara",
      "ptName": "Norte da Província de Nara",
      "thName": "จังหวัดนาระตอนเหนือ",
      "viName": "Miền Bắc tỉnh Nara",
      "inName": "Bagian Utara Prefektur Nara",
      "tlName": "Hilagang bahagi ng Nara Prefecture",
      "moName": "Хойд Нара аймаг",
      "buName": "နယစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដណារ៉ា",
      "neName": "नारा जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "290011",
      "name": "北西部",
      "enName": "North-western Region"
    },
    "class20": {
      "code": "2942400",
      "name": "上牧町",
      "enName": "Kammaki Town",
      "kana": "かんまきちょう",
      "chName": "上牧町",
      "zhName": "上牧町",
      "koName": "간마키 정",
      "esName": "Pueblo de Kanmaki",
      "ptName": "bairro de Kammaki",
      "thName": "เมืองคัมมากิ",
      "viName": "thị trấn Kammaki",
      "inName": "kota Kammaki",
      "tlName": "bayan ng Kammaki",
      "moName": "Каммaки жижиг хот",
      "buName": "ခပ်မားကိ မြို့နယ်",
      "khName": "ទីប្រជុំជន​ កាំម៉ាគី",
      "neName": "काम्माकी नगर"
    }
  },
  "2942500": {
    "office": {
      "code": "290000",
      "name": "奈良県",
      "enName": "Nara",
      "officeName": "奈良地方気象台",
      "chName": "奈良县",
      "zhName": "奈良縣",
      "koName": "나라현",
      "esName": "Prefectura de Nara",
      "ptName": "Província de Nara",
      "thName": "จังหวัดนาระ",
      "viName": "Tỉnh Nara",
      "inName": "Prefektur Nara",
      "tlName": "Nara Prefecture",
      "moName": "Нара аймаг",
      "buName": "နာရာ ပြည်နယ်",
      "khName": "ខេត្ដ ណារ៉ា",
      "neName": "नारा जिल्ला"
    },
    "class10": {
      "code": "290010",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "奈良县北部",
      "zhName": "奈良縣北部",
      "koName": "나라현 북부",
      "esName": "Norte de Prefectura de Nara",
      "ptName": "Norte da Província de Nara",
      "thName": "จังหวัดนาระตอนเหนือ",
      "viName": "Miền Bắc tỉnh Nara",
      "inName": "Bagian Utara Prefektur Nara",
      "tlName": "Hilagang bahagi ng Nara Prefecture",
      "moName": "Хойд Нара аймаг",
      "buName": "နယစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដណារ៉ា",
      "neName": "नारा जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "290011",
      "name": "北西部",
      "enName": "North-western Region"
    },
    "class20": {
      "code": "2942500",
      "name": "王寺町",
      "enName": "Oji Town",
      "kana": "おうじちょう",
      "chName": "王寺町",
      "zhName": "王寺町",
      "koName": "오지 정",
      "esName": "Pueblo de Oji",
      "ptName": "bairro de Oji",
      "thName": "เมืองโอจิ",
      "viName": "thị trấn Oji",
      "inName": "kota Oji",
      "tlName": "bayan ng Oji",
      "moName": "Ожи жижиг хот",
      "buName": "အိုးဂျိ မြို့နယ်",
      "khName": "ទីប្រជុំជន អូជី",
      "neName": "ओजी नगर"
    }
  },
  "2942600": {
    "office": {
      "code": "290000",
      "name": "奈良県",
      "enName": "Nara",
      "officeName": "奈良地方気象台",
      "chName": "奈良县",
      "zhName": "奈良縣",
      "koName": "나라현",
      "esName": "Prefectura de Nara",
      "ptName": "Província de Nara",
      "thName": "จังหวัดนาระ",
      "viName": "Tỉnh Nara",
      "inName": "Prefektur Nara",
      "tlName": "Nara Prefecture",
      "moName": "Нара аймаг",
      "buName": "နာရာ ပြည်နယ်",
      "khName": "ខេត្ដ ណារ៉ា",
      "neName": "नारा जिल्ला"
    },
    "class10": {
      "code": "290010",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "奈良县北部",
      "zhName": "奈良縣北部",
      "koName": "나라현 북부",
      "esName": "Norte de Prefectura de Nara",
      "ptName": "Norte da Província de Nara",
      "thName": "จังหวัดนาระตอนเหนือ",
      "viName": "Miền Bắc tỉnh Nara",
      "inName": "Bagian Utara Prefektur Nara",
      "tlName": "Hilagang bahagi ng Nara Prefecture",
      "moName": "Хойд Нара аймаг",
      "buName": "နယစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដណារ៉ា",
      "neName": "नारा जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "290011",
      "name": "北西部",
      "enName": "North-western Region"
    },
    "class20": {
      "code": "2942600",
      "name": "広陵町",
      "enName": "Koryo Town",
      "kana": "こうりょうちょう",
      "chName": "广陵町",
      "zhName": "廣陵町",
      "koName": "고료 정",
      "esName": "Pueblo de Koryo",
      "ptName": "bairro de Koryo",
      "thName": "เมืองโคเรียว",
      "viName": "thị trấn Koryo",
      "inName": "kota Koryo",
      "tlName": "bayan ng Koryo",
      "moName": "Корио жижиг хот",
      "buName": "ခေါရိယို မြို့နယ်",
      "khName": "ទីប្រជុំជន កូរីយ៉ូ",
      "neName": "कोरयो नगर"
    }
  },
  "2942700": {
    "office": {
      "code": "290000",
      "name": "奈良県",
      "enName": "Nara",
      "officeName": "奈良地方気象台",
      "chName": "奈良县",
      "zhName": "奈良縣",
      "koName": "나라현",
      "esName": "Prefectura de Nara",
      "ptName": "Província de Nara",
      "thName": "จังหวัดนาระ",
      "viName": "Tỉnh Nara",
      "inName": "Prefektur Nara",
      "tlName": "Nara Prefecture",
      "moName": "Нара аймаг",
      "buName": "နာရာ ပြည်နယ်",
      "khName": "ខេត្ដ ណារ៉ា",
      "neName": "नारा जिल्ला"
    },
    "class10": {
      "code": "290010",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "奈良县北部",
      "zhName": "奈良縣北部",
      "koName": "나라현 북부",
      "esName": "Norte de Prefectura de Nara",
      "ptName": "Norte da Província de Nara",
      "thName": "จังหวัดนาระตอนเหนือ",
      "viName": "Miền Bắc tỉnh Nara",
      "inName": "Bagian Utara Prefektur Nara",
      "tlName": "Hilagang bahagi ng Nara Prefecture",
      "moName": "Хойд Нара аймаг",
      "buName": "နယစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដណារ៉ា",
      "neName": "नारा जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "290011",
      "name": "北西部",
      "enName": "North-western Region"
    },
    "class20": {
      "code": "2942700",
      "name": "河合町",
      "enName": "Kawai Town",
      "kana": "かわいちょう",
      "chName": "河合町",
      "zhName": "河合町",
      "koName": "가와이 정",
      "esName": "Pueblo de Kawai",
      "ptName": "bairro de Kawai",
      "thName": "เมืองคาวาอิ",
      "viName": "thị trấn Kawai",
      "inName": "kota Kawai",
      "tlName": "bayan ng Kawai",
      "moName": "Кавай жижиг хот",
      "buName": "ခါဝါးယိ မြို့နယ်",
      "khName": "ទីប្រជុំជន កាវ៉ាយ",
      "neName": "कावाई नगर"
    }
  },
  "2944100": {
    "office": {
      "code": "290000",
      "name": "奈良県",
      "enName": "Nara",
      "officeName": "奈良地方気象台",
      "chName": "奈良县",
      "zhName": "奈良縣",
      "koName": "나라현",
      "esName": "Prefectura de Nara",
      "ptName": "Província de Nara",
      "thName": "จังหวัดนาระ",
      "viName": "Tỉnh Nara",
      "inName": "Prefektur Nara",
      "tlName": "Nara Prefecture",
      "moName": "Нара аймаг",
      "buName": "နာရာ ပြည်နယ်",
      "khName": "ខេត្ដ ណារ៉ា",
      "neName": "नारा जिल्ला"
    },
    "class10": {
      "code": "290010",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "奈良县北部",
      "zhName": "奈良縣北部",
      "koName": "나라현 북부",
      "esName": "Norte de Prefectura de Nara",
      "ptName": "Norte da Província de Nara",
      "thName": "จังหวัดนาระตอนเหนือ",
      "viName": "Miền Bắc tỉnh Nara",
      "inName": "Bagian Utara Prefektur Nara",
      "tlName": "Hilagang bahagi ng Nara Prefecture",
      "moName": "Хойд Нара аймаг",
      "buName": "နယစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដណារ៉ា",
      "neName": "नारा जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "290013",
      "name": "五條・北部吉野",
      "enName": "Gojo and Northern Yoshino"
    },
    "class20": {
      "code": "2944100",
      "name": "吉野町",
      "enName": "Yoshino Town",
      "kana": "よしのちょう",
      "chName": "吉野町",
      "zhName": "吉野町",
      "koName": "요시노 정",
      "esName": "Pueblo de Yoshino",
      "ptName": "bairro de Yoshino",
      "thName": "เมืองโยชิโนะ",
      "viName": "thị trấn Yoshino",
      "inName": "kota Yoshino",
      "tlName": "bayan ng Yoshino",
      "moName": "Ёшино жижиг хот",
      "buName": "ယိုရှိနို မြို့နယ်",
      "khName": "ទីប្រជុំជន យ៉ូស៊ីណូ",
      "neName": "योशिनो नगर"
    }
  },
  "2944200": {
    "office": {
      "code": "290000",
      "name": "奈良県",
      "enName": "Nara",
      "officeName": "奈良地方気象台",
      "chName": "奈良县",
      "zhName": "奈良縣",
      "koName": "나라현",
      "esName": "Prefectura de Nara",
      "ptName": "Província de Nara",
      "thName": "จังหวัดนาระ",
      "viName": "Tỉnh Nara",
      "inName": "Prefektur Nara",
      "tlName": "Nara Prefecture",
      "moName": "Нара аймаг",
      "buName": "နာရာ ပြည်နယ်",
      "khName": "ខេត្ដ ណារ៉ា",
      "neName": "नारा जिल्ला"
    },
    "class10": {
      "code": "290010",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "奈良县北部",
      "zhName": "奈良縣北部",
      "koName": "나라현 북부",
      "esName": "Norte de Prefectura de Nara",
      "ptName": "Norte da Província de Nara",
      "thName": "จังหวัดนาระตอนเหนือ",
      "viName": "Miền Bắc tỉnh Nara",
      "inName": "Bagian Utara Prefektur Nara",
      "tlName": "Hilagang bahagi ng Nara Prefecture",
      "moName": "Хойд Нара аймаг",
      "buName": "နယစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដណារ៉ា",
      "neName": "नारा जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "290013",
      "name": "五條・北部吉野",
      "enName": "Gojo and Northern Yoshino"
    },
    "class20": {
      "code": "2944200",
      "name": "大淀町",
      "enName": "Oyodo Town",
      "kana": "おおよどちょう",
      "chName": "大淀町",
      "zhName": "大淀町",
      "koName": "오요도 정",
      "esName": "Pueblo de Ōyodo",
      "ptName": "bairro de Oyodo",
      "thName": "เมืองโอโยโดะ",
      "viName": "thị trấn Oyodo",
      "inName": "kota Oyodo",
      "tlName": "bayan ng Oyodo",
      "moName": "Оёодо жижиг хот",
      "buName": "အို့ယိုဒို မြို့နယ်",
      "khName": "ទីប្រជុំជន អូយ៉ូដូ",
      "neName": "ओयोदो नगर"
    }
  },
  "2944300": {
    "office": {
      "code": "290000",
      "name": "奈良県",
      "enName": "Nara",
      "officeName": "奈良地方気象台",
      "chName": "奈良县",
      "zhName": "奈良縣",
      "koName": "나라현",
      "esName": "Prefectura de Nara",
      "ptName": "Província de Nara",
      "thName": "จังหวัดนาระ",
      "viName": "Tỉnh Nara",
      "inName": "Prefektur Nara",
      "tlName": "Nara Prefecture",
      "moName": "Нара аймаг",
      "buName": "နာရာ ပြည်နယ်",
      "khName": "ខេត្ដ ណារ៉ា",
      "neName": "नारा जिल्ला"
    },
    "class10": {
      "code": "290010",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "奈良县北部",
      "zhName": "奈良縣北部",
      "koName": "나라현 북부",
      "esName": "Norte de Prefectura de Nara",
      "ptName": "Norte da Província de Nara",
      "thName": "จังหวัดนาระตอนเหนือ",
      "viName": "Miền Bắc tỉnh Nara",
      "inName": "Bagian Utara Prefektur Nara",
      "tlName": "Hilagang bahagi ng Nara Prefecture",
      "moName": "Хойд Нара аймаг",
      "buName": "နယစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដណារ៉ា",
      "neName": "नारा जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "290013",
      "name": "五條・北部吉野",
      "enName": "Gojo and Northern Yoshino"
    },
    "class20": {
      "code": "2944300",
      "name": "下市町",
      "enName": "Shimoichi Town",
      "kana": "しもいちちょう",
      "chName": "下市町",
      "zhName": "下市町",
      "koName": "시모이치 정",
      "esName": "Pueblo de Shimoichi",
      "ptName": "bairro de Shimoichi",
      "thName": "เมืองชิโมอิจิ",
      "viName": "thị trấn Shimoichi",
      "inName": "kota Shimoichi",
      "tlName": "bayan ng Shimoichi",
      "moName": "Шимойчи жижиг хот",
      "buName": "ရှီမောယိကျိ မြို့နယ်",
      "khName": "ទីប្រជុំជន ស៊ីម៉យជី",
      "neName": "शिमोइची नगर"
    }
  },
  "2944400": {
    "office": {
      "code": "290000",
      "name": "奈良県",
      "enName": "Nara",
      "officeName": "奈良地方気象台",
      "chName": "奈良县",
      "zhName": "奈良縣",
      "koName": "나라현",
      "esName": "Prefectura de Nara",
      "ptName": "Província de Nara",
      "thName": "จังหวัดนาระ",
      "viName": "Tỉnh Nara",
      "inName": "Prefektur Nara",
      "tlName": "Nara Prefecture",
      "moName": "Нара аймаг",
      "buName": "နာရာ ပြည်နယ်",
      "khName": "ខេត្ដ ណារ៉ា",
      "neName": "नारा जिल्ला"
    },
    "class10": {
      "code": "290020",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "奈良县南部",
      "zhName": "奈良縣南部",
      "koName": "나라현 남부",
      "esName": "Sur de Prefectura de Nara",
      "ptName": "Sul da Província de Nara",
      "thName": "จังหวัดนาระตอนใต้",
      "viName": "Miền Nam tỉnh Nara",
      "inName": "Bagian Selatan Prefektur Nara",
      "tlName": "Timog na bahagi ng Nara Prefecture",
      "moName": "Өмнөд Нара аймаг",
      "buName": "နယစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដណារ៉ា",
      "neName": "नारा जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "290021",
      "name": "南東部",
      "enName": "South-eastern Region"
    },
    "class20": {
      "code": "2944400",
      "name": "黒滝村",
      "enName": "Kurotaki Village",
      "kana": "くろたきむら",
      "chName": "黑泷村",
      "zhName": "黑瀧村",
      "koName": "구로타키 촌",
      "esName": "Aldea de Kurotaki",
      "ptName": "povoado de Kurotaki",
      "thName": "หมู่บ้านคุโรทากิ",
      "viName": "làng Kurotaki",
      "inName": "desa Kurotaki",
      "tlName": "nayon ng Kurotaki",
      "moName": "Күротаки тосгон",
      "buName": "ခူရိုတာ့ကိ ကျေးရွာ",
      "khName": "ភូមិ គូរ៉ូតាគី",
      "neName": "कुरोताकी गाउँ"
    }
  },
  "2944600": {
    "office": {
      "code": "290000",
      "name": "奈良県",
      "enName": "Nara",
      "officeName": "奈良地方気象台",
      "chName": "奈良县",
      "zhName": "奈良縣",
      "koName": "나라현",
      "esName": "Prefectura de Nara",
      "ptName": "Província de Nara",
      "thName": "จังหวัดนาระ",
      "viName": "Tỉnh Nara",
      "inName": "Prefektur Nara",
      "tlName": "Nara Prefecture",
      "moName": "Нара аймаг",
      "buName": "နာရာ ပြည်နယ်",
      "khName": "ខេត្ដ ណារ៉ា",
      "neName": "नारा जिल्ला"
    },
    "class10": {
      "code": "290020",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "奈良县南部",
      "zhName": "奈良縣南部",
      "koName": "나라현 남부",
      "esName": "Sur de Prefectura de Nara",
      "ptName": "Sul da Província de Nara",
      "thName": "จังหวัดนาระตอนใต้",
      "viName": "Miền Nam tỉnh Nara",
      "inName": "Bagian Selatan Prefektur Nara",
      "tlName": "Timog na bahagi ng Nara Prefecture",
      "moName": "Өмнөд Нара аймаг",
      "buName": "နယစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដណារ៉ា",
      "neName": "नारा जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "290021",
      "name": "南東部",
      "enName": "South-eastern Region"
    },
    "class20": {
      "code": "2944600",
      "name": "天川村",
      "enName": "Tenkawa Village",
      "kana": "てんかわむら",
      "chName": "天川村",
      "zhName": "天川村",
      "koName": "덴카와 촌",
      "esName": "Aldea de Tenkawa",
      "ptName": "povoado de Tenkawa",
      "thName": "หมู่บ้านเทนกาวะ",
      "viName": "làng Tenkawa",
      "inName": "desa Tenkawa",
      "tlName": "nayon ng Tenkawa",
      "moName": "Тэнкава тосгон",
      "buName": "တန်းကာ့ဝ ကျေးရွာ",
      "khName": "ភូមិ ថេនហ្កាវ៉ា",
      "neName": "तेन्कावा गाउँ"
    }
  },
  "2944700": {
    "office": {
      "code": "290000",
      "name": "奈良県",
      "enName": "Nara",
      "officeName": "奈良地方気象台",
      "chName": "奈良县",
      "zhName": "奈良縣",
      "koName": "나라현",
      "esName": "Prefectura de Nara",
      "ptName": "Província de Nara",
      "thName": "จังหวัดนาระ",
      "viName": "Tỉnh Nara",
      "inName": "Prefektur Nara",
      "tlName": "Nara Prefecture",
      "moName": "Нара аймаг",
      "buName": "နာရာ ပြည်နယ်",
      "khName": "ខេត្ដ ណារ៉ា",
      "neName": "नारा जिल्ला"
    },
    "class10": {
      "code": "290020",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "奈良县南部",
      "zhName": "奈良縣南部",
      "koName": "나라현 남부",
      "esName": "Sur de Prefectura de Nara",
      "ptName": "Sul da Província de Nara",
      "thName": "จังหวัดนาระตอนใต้",
      "viName": "Miền Nam tỉnh Nara",
      "inName": "Bagian Selatan Prefektur Nara",
      "tlName": "Timog na bahagi ng Nara Prefecture",
      "moName": "Өмнөд Нара аймаг",
      "buName": "နယစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដណារ៉ា",
      "neName": "नारा जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "290022",
      "name": "南西部",
      "enName": "South-western Region"
    },
    "class20": {
      "code": "2944700",
      "name": "野迫川村",
      "enName": "Nosegawa Village",
      "kana": "のせがわむら",
      "chName": "野迫川村",
      "zhName": "野迫川村",
      "koName": "노세가와 촌",
      "esName": "Aldea de Nosegawa",
      "ptName": "povoado de Nosegawa",
      "thName": "หมู่บ้านโนเซงาวะ",
      "viName": "làng Mũi",
      "inName": "desa Nosegawa",
      "tlName": "nayon ng Nosegawa",
      "moName": "Носэгава тосгон",
      "buName": "နော်ဆဲဂါ့ဝ ကျေးရွာ",
      "khName": "ភូមិ ណូសេហ្គាវ៉ា",
      "neName": "नोसेगावा गाउँ"
    }
  },
  "2944900": {
    "office": {
      "code": "290000",
      "name": "奈良県",
      "enName": "Nara",
      "officeName": "奈良地方気象台",
      "chName": "奈良县",
      "zhName": "奈良縣",
      "koName": "나라현",
      "esName": "Prefectura de Nara",
      "ptName": "Província de Nara",
      "thName": "จังหวัดนาระ",
      "viName": "Tỉnh Nara",
      "inName": "Prefektur Nara",
      "tlName": "Nara Prefecture",
      "moName": "Нара аймаг",
      "buName": "နာရာ ပြည်နယ်",
      "khName": "ខេត្ដ ណារ៉ា",
      "neName": "नारा जिल्ला"
    },
    "class10": {
      "code": "290020",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "奈良县南部",
      "zhName": "奈良縣南部",
      "koName": "나라현 남부",
      "esName": "Sur de Prefectura de Nara",
      "ptName": "Sul da Província de Nara",
      "thName": "จังหวัดนาระตอนใต้",
      "viName": "Miền Nam tỉnh Nara",
      "inName": "Bagian Selatan Prefektur Nara",
      "tlName": "Timog na bahagi ng Nara Prefecture",
      "moName": "Өмнөд Нара аймаг",
      "buName": "နယစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដណារ៉ា",
      "neName": "नारा जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "290022",
      "name": "南西部",
      "enName": "South-western Region"
    },
    "class20": {
      "code": "2944900",
      "name": "十津川村",
      "enName": "Totsukawa Village",
      "kana": "とつかわむら",
      "chName": "十津川村",
      "zhName": "十津川村",
      "koName": "도쓰카와 촌",
      "esName": "Aldea de Totsugawa",
      "ptName": "povoado de Totsukawa",
      "thName": "หมู่บ้านโทสึคาวะ",
      "viName": "làng Totsukawa",
      "inName": "desa Totsukawa",
      "tlName": "nayon ng Totsukawa",
      "moName": "Тоцүкава тосгон",
      "buName": "တိုဆုကာ့ဝ ကျေးရွာ",
      "khName": "ភូមិ តូស៊ូកាវ៉ា",
      "neName": "तोत्सुकावा गाउँ"
    }
  },
  "2945000": {
    "office": {
      "code": "290000",
      "name": "奈良県",
      "enName": "Nara",
      "officeName": "奈良地方気象台",
      "chName": "奈良县",
      "zhName": "奈良縣",
      "koName": "나라현",
      "esName": "Prefectura de Nara",
      "ptName": "Província de Nara",
      "thName": "จังหวัดนาระ",
      "viName": "Tỉnh Nara",
      "inName": "Prefektur Nara",
      "tlName": "Nara Prefecture",
      "moName": "Нара аймаг",
      "buName": "နာရာ ပြည်နယ်",
      "khName": "ខេត្ដ ណារ៉ា",
      "neName": "नारा जिल्ला"
    },
    "class10": {
      "code": "290020",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "奈良县南部",
      "zhName": "奈良縣南部",
      "koName": "나라현 남부",
      "esName": "Sur de Prefectura de Nara",
      "ptName": "Sul da Província de Nara",
      "thName": "จังหวัดนาระตอนใต้",
      "viName": "Miền Nam tỉnh Nara",
      "inName": "Bagian Selatan Prefektur Nara",
      "tlName": "Timog na bahagi ng Nara Prefecture",
      "moName": "Өмнөд Нара аймаг",
      "buName": "နယစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដណារ៉ា",
      "neName": "नारा जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "290021",
      "name": "南東部",
      "enName": "South-eastern Region"
    },
    "class20": {
      "code": "2945000",
      "name": "下北山村",
      "enName": "Shimokitayama Village",
      "kana": "しもきたやまむら",
      "chName": "下北山村",
      "zhName": "下北山村",
      "koName": "시모키타야마 촌",
      "esName": "Aldea de Shimo-kitayama",
      "ptName": "povoado de Shimokitayama",
      "thName": "หมู่บ้านชิโมะคิตะยามะ",
      "viName": "làng Shimokitayama",
      "inName": "desa Shimokitayama",
      "tlName": "nayon ng Shimokitayama",
      "moName": "Шимокитаямa тосгон",
      "buName": "ရှီမိုကိတာယာ့မ ကျေးရွာ",
      "khName": "ភូមិ ស៊ីម៉ុគីតាយ៉ាម៉ា",
      "neName": "शिओकितायामा गाउँ"
    }
  },
  "2945100": {
    "office": {
      "code": "290000",
      "name": "奈良県",
      "enName": "Nara",
      "officeName": "奈良地方気象台",
      "chName": "奈良县",
      "zhName": "奈良縣",
      "koName": "나라현",
      "esName": "Prefectura de Nara",
      "ptName": "Província de Nara",
      "thName": "จังหวัดนาระ",
      "viName": "Tỉnh Nara",
      "inName": "Prefektur Nara",
      "tlName": "Nara Prefecture",
      "moName": "Нара аймаг",
      "buName": "နာရာ ပြည်နယ်",
      "khName": "ខេត្ដ ណារ៉ា",
      "neName": "नारा जिल्ला"
    },
    "class10": {
      "code": "290020",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "奈良县南部",
      "zhName": "奈良縣南部",
      "koName": "나라현 남부",
      "esName": "Sur de Prefectura de Nara",
      "ptName": "Sul da Província de Nara",
      "thName": "จังหวัดนาระตอนใต้",
      "viName": "Miền Nam tỉnh Nara",
      "inName": "Bagian Selatan Prefektur Nara",
      "tlName": "Timog na bahagi ng Nara Prefecture",
      "moName": "Өмнөд Нара аймаг",
      "buName": "နယစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដណារ៉ា",
      "neName": "नारा जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "290021",
      "name": "南東部",
      "enName": "South-eastern Region"
    },
    "class20": {
      "code": "2945100",
      "name": "上北山村",
      "enName": "Kamikitayama Village",
      "kana": "かみきたやまむら",
      "chName": "上北山村",
      "zhName": "上北山村",
      "koName": "가미키타야마 촌",
      "esName": "Aldea de Kami-kitayama",
      "ptName": "povoado de Kamikitayama",
      "thName": "หมู่บ้านคามิคิตะยามะ",
      "viName": "làng Kamikitayama",
      "inName": "desa Kamikitayama",
      "tlName": "nayon ng Kamikitayama",
      "moName": "Камикитаямa тосгон",
      "buName": "ခါမီကိတာယာ့မ ကျေးရွာ",
      "khName": "ភូមិ កាមីគីតាយ៉ាម៉ា",
      "neName": "कामिकितायामा गाउँ"
    }
  },
  "2945200": {
    "office": {
      "code": "290000",
      "name": "奈良県",
      "enName": "Nara",
      "officeName": "奈良地方気象台",
      "chName": "奈良县",
      "zhName": "奈良縣",
      "koName": "나라현",
      "esName": "Prefectura de Nara",
      "ptName": "Província de Nara",
      "thName": "จังหวัดนาระ",
      "viName": "Tỉnh Nara",
      "inName": "Prefektur Nara",
      "tlName": "Nara Prefecture",
      "moName": "Нара аймаг",
      "buName": "နာရာ ပြည်နယ်",
      "khName": "ខេត្ដ ណារ៉ា",
      "neName": "नारा जिल्ला"
    },
    "class10": {
      "code": "290020",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "奈良县南部",
      "zhName": "奈良縣南部",
      "koName": "나라현 남부",
      "esName": "Sur de Prefectura de Nara",
      "ptName": "Sul da Província de Nara",
      "thName": "จังหวัดนาระตอนใต้",
      "viName": "Miền Nam tỉnh Nara",
      "inName": "Bagian Selatan Prefektur Nara",
      "tlName": "Timog na bahagi ng Nara Prefecture",
      "moName": "Өмнөд Нара аймаг",
      "buName": "နယစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដណារ៉ា",
      "neName": "नारा जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "290021",
      "name": "南東部",
      "enName": "South-eastern Region"
    },
    "class20": {
      "code": "2945200",
      "name": "川上村",
      "enName": "Kawakami Village",
      "kana": "かわかみむら",
      "chName": "奈良川上村",
      "zhName": "奈良川上村",
      "koName": "나라 가와카미 촌",
      "esName": "Aldea de Kawakami, Nara",
      "ptName": "Nara, Kawakami-mura",
      "thName": "หมู่บ้านคาวาคามิ นาระ",
      "viName": "Làng Kawakami, Nara",
      "inName": "Desa Kawakami, Nara",
      "tlName": "nayon ng Kawakami, Nara",
      "moName": "Наракава Ками тосгон",
      "buName": "နယကမိရွာ",
      "khName": "ភូមិកាវ៉ាកាមី ណារ៉ា",
      "neName": "नारा कावाकामी गाउँ"
    }
  },
  "2945300": {
    "office": {
      "code": "290000",
      "name": "奈良県",
      "enName": "Nara",
      "officeName": "奈良地方気象台",
      "chName": "奈良县",
      "zhName": "奈良縣",
      "koName": "나라현",
      "esName": "Prefectura de Nara",
      "ptName": "Província de Nara",
      "thName": "จังหวัดนาระ",
      "viName": "Tỉnh Nara",
      "inName": "Prefektur Nara",
      "tlName": "Nara Prefecture",
      "moName": "Нара аймаг",
      "buName": "နာရာ ပြည်နယ်",
      "khName": "ខេត្ដ ណារ៉ា",
      "neName": "नारा जिल्ला"
    },
    "class10": {
      "code": "290020",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "奈良县南部",
      "zhName": "奈良縣南部",
      "koName": "나라현 남부",
      "esName": "Sur de Prefectura de Nara",
      "ptName": "Sul da Província de Nara",
      "thName": "จังหวัดนาระตอนใต้",
      "viName": "Miền Nam tỉnh Nara",
      "inName": "Bagian Selatan Prefektur Nara",
      "tlName": "Timog na bahagi ng Nara Prefecture",
      "moName": "Өмнөд Нара аймаг",
      "buName": "နယစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដណារ៉ា",
      "neName": "नारा जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "290021",
      "name": "南東部",
      "enName": "South-eastern Region"
    },
    "class20": {
      "code": "2945300",
      "name": "東吉野村",
      "enName": "Higashiyoshino Village",
      "kana": "ひがしよしのむら",
      "chName": "东吉野村",
      "zhName": "東吉野村",
      "koName": "히가시요시노 촌",
      "esName": "Aldea de Higashi-yoshino",
      "ptName": "povoado de Higashiyoshino",
      "thName": "หมู่บ้านฮิงาชิโยชิโนะ",
      "viName": "làng Higashiyoshino",
      "inName": "desa Higashiyoshino",
      "tlName": "nayon ng Higashiyoshino",
      "moName": "Хигaшиёшино тосгон",
      "buName": "ဟီဂါရှိယိုရှိနို ကျေးရွာ",
      "khName": "ភូមិ ហ៊ីហ្កាស៊ីយ៉ូស៊ីណូ",
      "neName": "हिगाशियोशिनो गाउँ"
    }
  },
  "3020100": {
    "office": {
      "code": "300000",
      "name": "和歌山県",
      "enName": "Wakayama",
      "officeName": "和歌山地方気象台",
      "chName": "和歌山县",
      "zhName": "和歌山縣",
      "koName": "와카야마현",
      "esName": "Prefectura de Wakayama",
      "ptName": "Província de Wakayama",
      "thName": "จังหวัดวากายามะ",
      "viName": "Tỉnh Wakayama",
      "inName": "Prefektur Wakayama",
      "tlName": "Wakayama Prefecture",
      "moName": "Вакаяма аймаг",
      "buName": "ဝါကားယာ့မ ပြည်နယ်",
      "khName": "ខេត្ដ វ៉ាកាយ៉ាម៉ា",
      "neName": "वाकायामा जिल्ला"
    },
    "class10": {
      "code": "300010",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "和歌山县北部",
      "zhName": "和歌山縣北部",
      "koName": "와카야마 현 북부",
      "esName": "Norte de Prefectura de Wakayama",
      "ptName": "Norte da Província de Wakayama",
      "thName": "จังหวัดวากายามะตอนเหนือ",
      "viName": "Miền Bắc tỉnh Wakayama",
      "inName": "Bagian Utara Prefektur Wakayama",
      "tlName": "Hilagang bahagi ng Wakayama Prefecture",
      "moName": "Хойд Вакаяма аймаг",
      "buName": "ဝကယမစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដវ៉ាកាយ៉ាម៉ា",
      "neName": "वाकायामा जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "300011",
      "name": "紀北",
      "enName": "Kihoku"
    },
    "class20": {
      "code": "3020100",
      "name": "和歌山市",
      "enName": "Wakayama City",
      "kana": "わかやまし",
      "chName": "和歌山市",
      "zhName": "和歌山市",
      "koName": "와카야마 시",
      "esName": "Ciudad de Wakayama",
      "ptName": "cidade de Wakayama",
      "thName": "เมืองวากายามะ",
      "viName": "thành phố Wakayama",
      "inName": "kota Wakayama",
      "tlName": "siyudad ng Wakayama",
      "moName": "Вакаямa хот",
      "buName": "ဝါကားယာ့မ မြို့",
      "khName": "ទីក្រុង វ៉ាកាយ៉ាម៉ា",
      "neName": "वाकायामा सहर"
    }
  },
  "3020200": {
    "office": {
      "code": "300000",
      "name": "和歌山県",
      "enName": "Wakayama",
      "officeName": "和歌山地方気象台",
      "chName": "和歌山县",
      "zhName": "和歌山縣",
      "koName": "와카야마현",
      "esName": "Prefectura de Wakayama",
      "ptName": "Província de Wakayama",
      "thName": "จังหวัดวากายามะ",
      "viName": "Tỉnh Wakayama",
      "inName": "Prefektur Wakayama",
      "tlName": "Wakayama Prefecture",
      "moName": "Вакаяма аймаг",
      "buName": "ဝါကားယာ့မ ပြည်နယ်",
      "khName": "ខេត្ដ វ៉ាកាយ៉ាម៉ា",
      "neName": "वाकायामा जिल्ला"
    },
    "class10": {
      "code": "300010",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "和歌山县北部",
      "zhName": "和歌山縣北部",
      "koName": "와카야마 현 북부",
      "esName": "Norte de Prefectura de Wakayama",
      "ptName": "Norte da Província de Wakayama",
      "thName": "จังหวัดวากายามะตอนเหนือ",
      "viName": "Miền Bắc tỉnh Wakayama",
      "inName": "Bagian Utara Prefektur Wakayama",
      "tlName": "Hilagang bahagi ng Wakayama Prefecture",
      "moName": "Хойд Вакаяма аймаг",
      "buName": "ဝကယမစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដវ៉ាកាយ៉ាម៉ា",
      "neName": "वाकायामा जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "300011",
      "name": "紀北",
      "enName": "Kihoku"
    },
    "class20": {
      "code": "3020200",
      "name": "海南市",
      "enName": "Kainan City",
      "kana": "かいなんし",
      "chName": "海南市",
      "zhName": "海南市",
      "koName": "가이난 시",
      "esName": "Ciudad de Kainan",
      "ptName": "cidade de Kainan",
      "thName": "เมืองไคนัน",
      "viName": "thành phố Kainan",
      "inName": "kota Kainan",
      "tlName": "siyudad ng Kainan",
      "moName": "Кайнaн хот",
      "buName": "ကာယိနန် မြို့",
      "khName": "ទីក្រុង កៃណាន",
      "neName": "काइनान सहर"
    }
  },
  "3020300": {
    "office": {
      "code": "300000",
      "name": "和歌山県",
      "enName": "Wakayama",
      "officeName": "和歌山地方気象台",
      "chName": "和歌山县",
      "zhName": "和歌山縣",
      "koName": "와카야마현",
      "esName": "Prefectura de Wakayama",
      "ptName": "Província de Wakayama",
      "thName": "จังหวัดวากายามะ",
      "viName": "Tỉnh Wakayama",
      "inName": "Prefektur Wakayama",
      "tlName": "Wakayama Prefecture",
      "moName": "Вакаяма аймаг",
      "buName": "ဝါကားယာ့မ ပြည်နယ်",
      "khName": "ខេត្ដ វ៉ាកាយ៉ាម៉ា",
      "neName": "वाकायामा जिल्ला"
    },
    "class10": {
      "code": "300010",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "和歌山县北部",
      "zhName": "和歌山縣北部",
      "koName": "와카야마 현 북부",
      "esName": "Norte de Prefectura de Wakayama",
      "ptName": "Norte da Província de Wakayama",
      "thName": "จังหวัดวากายามะตอนเหนือ",
      "viName": "Miền Bắc tỉnh Wakayama",
      "inName": "Bagian Utara Prefektur Wakayama",
      "tlName": "Hilagang bahagi ng Wakayama Prefecture",
      "moName": "Хойд Вакаяма аймаг",
      "buName": "ဝကယမစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដវ៉ាកាយ៉ាម៉ា",
      "neName": "वाकायामा जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "300011",
      "name": "紀北",
      "enName": "Kihoku"
    },
    "class20": {
      "code": "3020300",
      "name": "橋本市",
      "enName": "Hashimoto City",
      "kana": "はしもとし",
      "chName": "桥本市",
      "zhName": "橋本市",
      "koName": "하시모토 시",
      "esName": "Ciudad de Hashimoto",
      "ptName": "cidade de Hashimoto",
      "thName": "เมืองฮาชิโมโตะ",
      "viName": "thành phố Hashimoto",
      "inName": "kota Hashimoto",
      "tlName": "siyudad ng Hashimoto",
      "moName": "Хaшимото хот",
      "buName": "ဟာရှီမိုတို မြို့",
      "khName": "ទីក្រុង ​ ហាស៊ីម៉ូតុ",
      "neName": "हाशिमोतो सहर"
    }
  },
  "3020400": {
    "office": {
      "code": "300000",
      "name": "和歌山県",
      "enName": "Wakayama",
      "officeName": "和歌山地方気象台",
      "chName": "和歌山县",
      "zhName": "和歌山縣",
      "koName": "와카야마현",
      "esName": "Prefectura de Wakayama",
      "ptName": "Província de Wakayama",
      "thName": "จังหวัดวากายามะ",
      "viName": "Tỉnh Wakayama",
      "inName": "Prefektur Wakayama",
      "tlName": "Wakayama Prefecture",
      "moName": "Вакаяма аймаг",
      "buName": "ဝါကားယာ့မ ပြည်နယ်",
      "khName": "ខេត្ដ វ៉ាកាយ៉ាម៉ា",
      "neName": "वाकायामा जिल्ला"
    },
    "class10": {
      "code": "300010",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "和歌山县北部",
      "zhName": "和歌山縣北部",
      "koName": "와카야마 현 북부",
      "esName": "Norte de Prefectura de Wakayama",
      "ptName": "Norte da Província de Wakayama",
      "thName": "จังหวัดวากายามะตอนเหนือ",
      "viName": "Miền Bắc tỉnh Wakayama",
      "inName": "Bagian Utara Prefektur Wakayama",
      "tlName": "Hilagang bahagi ng Wakayama Prefecture",
      "moName": "Хойд Вакаяма аймаг",
      "buName": "ဝကယမစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដវ៉ាកាយ៉ាម៉ា",
      "neName": "वाकायामा जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "300012",
      "name": "紀中",
      "enName": "Kichu"
    },
    "class20": {
      "code": "3020400",
      "name": "有田市",
      "enName": "Arida City",
      "kana": "ありだし",
      "chName": "有田市",
      "zhName": "有田市",
      "koName": "아리다 시",
      "esName": "Ciudad de Arita",
      "ptName": "cidade de Arida",
      "thName": "เมืองอาริดะ",
      "viName": "thành phố Arida",
      "inName": "kota Arida",
      "tlName": "siyudad ng Arida",
      "moName": "Aрида хот",
      "buName": "အာရိဒ မြို့",
      "khName": "ទីក្រុង អារីដា",
      "neName": "आरिदा सहर"
    }
  },
  "3020500": {
    "office": {
      "code": "300000",
      "name": "和歌山県",
      "enName": "Wakayama",
      "officeName": "和歌山地方気象台",
      "chName": "和歌山县",
      "zhName": "和歌山縣",
      "koName": "와카야마현",
      "esName": "Prefectura de Wakayama",
      "ptName": "Província de Wakayama",
      "thName": "จังหวัดวากายามะ",
      "viName": "Tỉnh Wakayama",
      "inName": "Prefektur Wakayama",
      "tlName": "Wakayama Prefecture",
      "moName": "Вакаяма аймаг",
      "buName": "ဝါကားယာ့မ ပြည်နယ်",
      "khName": "ខេត្ដ វ៉ាកាយ៉ាម៉ា",
      "neName": "वाकायामा जिल्ला"
    },
    "class10": {
      "code": "300010",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "和歌山县北部",
      "zhName": "和歌山縣北部",
      "koName": "와카야마 현 북부",
      "esName": "Norte de Prefectura de Wakayama",
      "ptName": "Norte da Província de Wakayama",
      "thName": "จังหวัดวากายามะตอนเหนือ",
      "viName": "Miền Bắc tỉnh Wakayama",
      "inName": "Bagian Utara Prefektur Wakayama",
      "tlName": "Hilagang bahagi ng Wakayama Prefecture",
      "moName": "Хойд Вакаяма аймаг",
      "buName": "ဝကယမစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដវ៉ាកាយ៉ាម៉ា",
      "neName": "वाकायामा जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "300012",
      "name": "紀中",
      "enName": "Kichu"
    },
    "class20": {
      "code": "3020500",
      "name": "御坊市",
      "enName": "Gobo City",
      "kana": "ごぼうし",
      "chName": "御坊市",
      "zhName": "御坊市",
      "koName": "고보 시",
      "esName": "Ciudad de Gobō",
      "ptName": "cidade de Gobo",
      "thName": "เมืองโกโบ",
      "viName": "thành phố Gobo",
      "inName": "kota Gobo",
      "tlName": "siyudad ng Gobo",
      "moName": "Гобо хот",
      "buName": "ဂိုဘို မြို့",
      "khName": "ទីក្រុង ហ្គូបូ",
      "neName": "गोबो सहर"
    }
  },
  "3020601": {
    "office": {
      "code": "300000",
      "name": "和歌山県",
      "enName": "Wakayama",
      "officeName": "和歌山地方気象台",
      "chName": "和歌山县",
      "zhName": "和歌山縣",
      "koName": "와카야마현",
      "esName": "Prefectura de Wakayama",
      "ptName": "Província de Wakayama",
      "thName": "จังหวัดวากายามะ",
      "viName": "Tỉnh Wakayama",
      "inName": "Prefektur Wakayama",
      "tlName": "Wakayama Prefecture",
      "moName": "Вакаяма аймаг",
      "buName": "ဝါကားယာ့မ ပြည်နယ်",
      "khName": "ខេត្ដ វ៉ាកាយ៉ាម៉ា",
      "neName": "वाकायामा जिल्ला"
    },
    "class10": {
      "code": "300020",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "和歌山县南部",
      "zhName": "和歌山縣南部",
      "koName": "와카야마 현 남부",
      "esName": "Sur de Prefectura de Wakayama",
      "ptName": "Sul da Província de Wakayama",
      "thName": "จังหวัดวากายามะตอนใต้",
      "viName": "Miền Nam tỉnh Wakayama",
      "inName": "Bagian Selatan Prefektur Wakayama",
      "tlName": "Timog na bahagi ng Wakayama Prefecture",
      "moName": "Өмнөд Вакаяма аймаг",
      "buName": "ဝကယမစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដវ៉ាកាយ៉ាម៉ា",
      "neName": "वाकायामा जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "300021",
      "name": "田辺・西牟婁",
      "enName": "Tanabe Nishimuro"
    },
    "class20": {
      "code": "3020601",
      "name": "田辺市田辺",
      "enName": "Tanabe, Tanabe City",
      "kana": "たなべしたなべ",
      "chName": "田边市田边",
      "zhName": "田邊市田邊",
      "koName": "다나베시 다나베",
      "esName": "Tanabe, Ciudad de Tanabe",
      "ptName": "Tanabe, Cidade de Tanabe",
      "thName": "ทานาเบะ เมืองทานาเบะ",
      "viName": "Tanabe, thành phố Tanabe",
      "inName": "Tanabe, Kota Tanabe",
      "tlName": "Tanabe, Lungsod ng Tanabe",
      "moName": "Танабэ, Танабэ хот",
      "buName": "တနဘေမြို့၊ တနဘေ",
      "khName": "តាណាប៉េ, ក្រុងតាណាប៉េ",
      "neName": "तानाबे, तानाबे शहर"
    }
  },
  "3020602": {
    "office": {
      "code": "300000",
      "name": "和歌山県",
      "enName": "Wakayama",
      "officeName": "和歌山地方気象台",
      "chName": "和歌山县",
      "zhName": "和歌山縣",
      "koName": "와카야마현",
      "esName": "Prefectura de Wakayama",
      "ptName": "Província de Wakayama",
      "thName": "จังหวัดวากายามะ",
      "viName": "Tỉnh Wakayama",
      "inName": "Prefektur Wakayama",
      "tlName": "Wakayama Prefecture",
      "moName": "Вакаяма аймаг",
      "buName": "ဝါကားယာ့မ ပြည်နယ်",
      "khName": "ខេត្ដ វ៉ាកាយ៉ាម៉ា",
      "neName": "वाकायामा जिल्ला"
    },
    "class10": {
      "code": "300020",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "和歌山县南部",
      "zhName": "和歌山縣南部",
      "koName": "와카야마 현 남부",
      "esName": "Sur de Prefectura de Wakayama",
      "ptName": "Sul da Província de Wakayama",
      "thName": "จังหวัดวากายามะตอนใต้",
      "viName": "Miền Nam tỉnh Wakayama",
      "inName": "Bagian Selatan Prefektur Wakayama",
      "tlName": "Timog na bahagi ng Wakayama Prefecture",
      "moName": "Өмнөд Вакаяма аймаг",
      "buName": "ဝကယမစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដវ៉ាកាយ៉ាម៉ា",
      "neName": "वाकायामा जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "300021",
      "name": "田辺・西牟婁",
      "enName": "Tanabe Nishimuro"
    },
    "class20": {
      "code": "3020602",
      "name": "田辺市龍神",
      "enName": "Ryujin, Tanabe City",
      "kana": "たなべしりゅうじん",
      "chName": "田边市龙神",
      "zhName": "田边市龙神",
      "koName": "다나베시 류진",
      "esName": "Ryujin, Ciudad de Tanabe",
      "ptName": "Ryujin, Cidade de Tanabe",
      "thName": "ริวจิน, เมืองทานาเบะ",
      "viName": "Ryujin, Thành phố Tanabe",
      "inName": "Ryujin, Kota Tanabe",
      "tlName": "Ryujin, Lungsod ng Tanabe",
      "moName": "Ryujin, Cidade de Tanabe",
      "buName": "ရူဂျင်းမြို့",
      "khName": "ខេត្តរយូជីន",
      "neName": "र्यूजिन, तानाबे सिटी"
    }
  },
  "3020603": {
    "office": {
      "code": "300000",
      "name": "和歌山県",
      "enName": "Wakayama",
      "officeName": "和歌山地方気象台",
      "chName": "和歌山县",
      "zhName": "和歌山縣",
      "koName": "와카야마현",
      "esName": "Prefectura de Wakayama",
      "ptName": "Província de Wakayama",
      "thName": "จังหวัดวากายามะ",
      "viName": "Tỉnh Wakayama",
      "inName": "Prefektur Wakayama",
      "tlName": "Wakayama Prefecture",
      "moName": "Вакаяма аймаг",
      "buName": "ဝါကားယာ့မ ပြည်နယ်",
      "khName": "ខេត្ដ វ៉ាកាយ៉ាម៉ា",
      "neName": "वाकायामा जिल्ला"
    },
    "class10": {
      "code": "300020",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "和歌山县南部",
      "zhName": "和歌山縣南部",
      "koName": "와카야마 현 남부",
      "esName": "Sur de Prefectura de Wakayama",
      "ptName": "Sul da Província de Wakayama",
      "thName": "จังหวัดวากายามะตอนใต้",
      "viName": "Miền Nam tỉnh Wakayama",
      "inName": "Bagian Selatan Prefektur Wakayama",
      "tlName": "Timog na bahagi ng Wakayama Prefecture",
      "moName": "Өмнөд Вакаяма аймаг",
      "buName": "ဝကယမစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដវ៉ាកាយ៉ាម៉ា",
      "neName": "वाकायामा जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "300021",
      "name": "田辺・西牟婁",
      "enName": "Tanabe Nishimuro"
    },
    "class20": {
      "code": "3020603",
      "name": "田辺市中辺路",
      "enName": "Nakahechi, Tanabe City",
      "kana": "たなべしなかへち",
      "chName": "田边市中边路",
      "zhName": "田边市中边路",
      "koName": "다나베시 나카헤치",
      "esName": "Nakahechi, Ciudad de Tanabe",
      "ptName": "Nakahechi, Cidade de Tanabe",
      "thName": "นาคาเฮชิ, เมืองทานาเบะ",
      "viName": "Nakahechi, Thành phố Tanabe",
      "inName": "Nakahechi, Kota Tanabe",
      "tlName": "Nakahechi, Lungsod ng Tanabe",
      "moName": "Nakahechi, Cidade de Tanabe",
      "buName": "နာကဟဲချီမြို့",
      "khName": "ខេត្តណាកហេជី",
      "neName": "नकाहेची, तानाबे सिटी"
    }
  },
  "3020604": {
    "office": {
      "code": "300000",
      "name": "和歌山県",
      "enName": "Wakayama",
      "officeName": "和歌山地方気象台",
      "chName": "和歌山县",
      "zhName": "和歌山縣",
      "koName": "와카야마현",
      "esName": "Prefectura de Wakayama",
      "ptName": "Província de Wakayama",
      "thName": "จังหวัดวากายามะ",
      "viName": "Tỉnh Wakayama",
      "inName": "Prefektur Wakayama",
      "tlName": "Wakayama Prefecture",
      "moName": "Вакаяма аймаг",
      "buName": "ဝါကားယာ့မ ပြည်နယ်",
      "khName": "ខេត្ដ វ៉ាកាយ៉ាម៉ា",
      "neName": "वाकायामा जिल्ला"
    },
    "class10": {
      "code": "300020",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "和歌山县南部",
      "zhName": "和歌山縣南部",
      "koName": "와카야마 현 남부",
      "esName": "Sur de Prefectura de Wakayama",
      "ptName": "Sul da Província de Wakayama",
      "thName": "จังหวัดวากายามะตอนใต้",
      "viName": "Miền Nam tỉnh Wakayama",
      "inName": "Bagian Selatan Prefektur Wakayama",
      "tlName": "Timog na bahagi ng Wakayama Prefecture",
      "moName": "Өмнөд Вакаяма аймаг",
      "buName": "ဝကယမစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដវ៉ាកាយ៉ាម៉ា",
      "neName": "वाकायामा जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "300021",
      "name": "田辺・西牟婁",
      "enName": "Tanabe Nishimuro"
    },
    "class20": {
      "code": "3020604",
      "name": "田辺市大塔",
      "enName": "Oto, Tanabe City",
      "kana": "たなべしおおとう",
      "chName": "田边市大塔",
      "zhName": "田边市大塔",
      "koName": "다나베시 오토",
      "esName": "Oto, Ciudad de Tanabe",
      "ptName": "Oto, Cidade de Tanabe",
      "thName": "โอโต, เมืองทานาเบะ",
      "viName": "Oto, Thành phố Tanabe",
      "inName": "Oto, Kota Tanabe",
      "tlName": "Oto, Lungsod ng Tanabe",
      "moName": "Oto, Cidade de Tanabe",
      "buName": "အိုတိုမြို့",
      "khName": "ខេត្តអូតូ",
      "neName": "ओटो, तानाबे सिटी"
    }
  },
  "3020605": {
    "office": {
      "code": "300000",
      "name": "和歌山県",
      "enName": "Wakayama",
      "officeName": "和歌山地方気象台",
      "chName": "和歌山县",
      "zhName": "和歌山縣",
      "koName": "와카야마현",
      "esName": "Prefectura de Wakayama",
      "ptName": "Província de Wakayama",
      "thName": "จังหวัดวากายามะ",
      "viName": "Tỉnh Wakayama",
      "inName": "Prefektur Wakayama",
      "tlName": "Wakayama Prefecture",
      "moName": "Вакаяма аймаг",
      "buName": "ဝါကားယာ့မ ပြည်နယ်",
      "khName": "ខេត្ដ វ៉ាកាយ៉ាម៉ា",
      "neName": "वाकायामा जिल्ला"
    },
    "class10": {
      "code": "300020",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "和歌山县南部",
      "zhName": "和歌山縣南部",
      "koName": "와카야마 현 남부",
      "esName": "Sur de Prefectura de Wakayama",
      "ptName": "Sul da Província de Wakayama",
      "thName": "จังหวัดวากายามะตอนใต้",
      "viName": "Miền Nam tỉnh Wakayama",
      "inName": "Bagian Selatan Prefektur Wakayama",
      "tlName": "Timog na bahagi ng Wakayama Prefecture",
      "moName": "Өмнөд Вакаяма аймаг",
      "buName": "ဝကယမစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដវ៉ាកាយ៉ាម៉ា",
      "neName": "वाकायामा जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "300021",
      "name": "田辺・西牟婁",
      "enName": "Tanabe Nishimuro"
    },
    "class20": {
      "code": "3020605",
      "name": "田辺市本宮",
      "enName": "Hongu, Tanabe City",
      "kana": "たなべしほんぐう",
      "chName": "田边市本宫",
      "zhName": "田边市本宫",
      "koName": "다나베시 혼구",
      "esName": "Hongu, Ciudad de Tanabe",
      "ptName": "Hongu, Cidade de Tanabe",
      "thName": "ฮงกุ, เมืองทานาเบะ",
      "viName": "Hongu, Thành phố Tanabe",
      "inName": "Hongu, Kota Tanabe",
      "tlName": "Hongu, Lungsod ng Tanabe",
      "moName": "Hongu, Cidade de Tanabe",
      "buName": "ဟောင်ဂူမြို့",
      "khName": "ខេត្តហុងគូ",
      "neName": "होंगु, तानाबे सिटी"
    }
  },
  "3020700": {
    "office": {
      "code": "300000",
      "name": "和歌山県",
      "enName": "Wakayama",
      "officeName": "和歌山地方気象台",
      "chName": "和歌山县",
      "zhName": "和歌山縣",
      "koName": "와카야마현",
      "esName": "Prefectura de Wakayama",
      "ptName": "Província de Wakayama",
      "thName": "จังหวัดวากายามะ",
      "viName": "Tỉnh Wakayama",
      "inName": "Prefektur Wakayama",
      "tlName": "Wakayama Prefecture",
      "moName": "Вакаяма аймаг",
      "buName": "ဝါကားယာ့မ ပြည်နယ်",
      "khName": "ខេត្ដ វ៉ាកាយ៉ាម៉ា",
      "neName": "वाकायामा जिल्ला"
    },
    "class10": {
      "code": "300020",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "和歌山县南部",
      "zhName": "和歌山縣南部",
      "koName": "와카야마 현 남부",
      "esName": "Sur de Prefectura de Wakayama",
      "ptName": "Sul da Província de Wakayama",
      "thName": "จังหวัดวากายามะตอนใต้",
      "viName": "Miền Nam tỉnh Wakayama",
      "inName": "Bagian Selatan Prefektur Wakayama",
      "tlName": "Timog na bahagi ng Wakayama Prefecture",
      "moName": "Өмнөд Вакаяма аймаг",
      "buName": "ဝကယမစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដវ៉ាកាយ៉ាម៉ា",
      "neName": "वाकायामा जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "300022",
      "name": "新宮・東牟婁",
      "enName": "Shingu Higashimuro"
    },
    "class20": {
      "code": "3020700",
      "name": "新宮市",
      "enName": "Shingu City",
      "kana": "しんぐうし",
      "chName": "新宫市",
      "zhName": "新宮市",
      "koName": "신구 시",
      "esName": "Ciudad de Shingū",
      "ptName": "cidade de Shingu",
      "thName": "เมืองชินงุ",
      "viName": "thành phố Shingu",
      "inName": "kota Shingu",
      "tlName": "siyudad ng Shingu",
      "moName": "Шингү хот",
      "buName": "ရှင်းဂု မြို့",
      "khName": "ទីក្រុង ស៊ីងហ្គូ",
      "neName": "शिङ्गु सहर"
    }
  },
  "3020800": {
    "office": {
      "code": "300000",
      "name": "和歌山県",
      "enName": "Wakayama",
      "officeName": "和歌山地方気象台",
      "chName": "和歌山县",
      "zhName": "和歌山縣",
      "koName": "와카야마현",
      "esName": "Prefectura de Wakayama",
      "ptName": "Província de Wakayama",
      "thName": "จังหวัดวากายามะ",
      "viName": "Tỉnh Wakayama",
      "inName": "Prefektur Wakayama",
      "tlName": "Wakayama Prefecture",
      "moName": "Вакаяма аймаг",
      "buName": "ဝါကားယာ့မ ပြည်နယ်",
      "khName": "ខេត្ដ វ៉ាកាយ៉ាម៉ា",
      "neName": "वाकायामा जिल्ला"
    },
    "class10": {
      "code": "300010",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "和歌山县北部",
      "zhName": "和歌山縣北部",
      "koName": "와카야마 현 북부",
      "esName": "Norte de Prefectura de Wakayama",
      "ptName": "Norte da Província de Wakayama",
      "thName": "จังหวัดวากายามะตอนเหนือ",
      "viName": "Miền Bắc tỉnh Wakayama",
      "inName": "Bagian Utara Prefektur Wakayama",
      "tlName": "Hilagang bahagi ng Wakayama Prefecture",
      "moName": "Хойд Вакаяма аймаг",
      "buName": "ဝကယမစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដវ៉ាកាយ៉ាម៉ា",
      "neName": "वाकायामा जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "300011",
      "name": "紀北",
      "enName": "Kihoku"
    },
    "class20": {
      "code": "3020800",
      "name": "紀の川市",
      "enName": "Kinokawa City",
      "kana": "きのかわし",
      "chName": "纪之川市",
      "zhName": "紀之川市",
      "koName": "기노카와 시",
      "esName": "Ciudad de Kinokawa",
      "ptName": "cidade de Kinokawa",
      "thName": "เมืองคิโนะคาวา",
      "viName": "thành phố Kinokawa",
      "inName": "kota Kinokawa",
      "tlName": "siyudad ng Kinokawa",
      "moName": "Кинокава хот",
      "buName": "ကီနော့ကာ့ဝ မြို့",
      "khName": "ទីក្រុង គីណូកាវ៉ា",
      "neName": "किनोकावा सहर"
    }
  },
  "3020900": {
    "office": {
      "code": "300000",
      "name": "和歌山県",
      "enName": "Wakayama",
      "officeName": "和歌山地方気象台",
      "chName": "和歌山县",
      "zhName": "和歌山縣",
      "koName": "와카야마현",
      "esName": "Prefectura de Wakayama",
      "ptName": "Província de Wakayama",
      "thName": "จังหวัดวากายามะ",
      "viName": "Tỉnh Wakayama",
      "inName": "Prefektur Wakayama",
      "tlName": "Wakayama Prefecture",
      "moName": "Вакаяма аймаг",
      "buName": "ဝါကားယာ့မ ပြည်နယ်",
      "khName": "ខេត្ដ វ៉ាកាយ៉ាម៉ា",
      "neName": "वाकायामा जिल्ला"
    },
    "class10": {
      "code": "300010",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "和歌山县北部",
      "zhName": "和歌山縣北部",
      "koName": "와카야마 현 북부",
      "esName": "Norte de Prefectura de Wakayama",
      "ptName": "Norte da Província de Wakayama",
      "thName": "จังหวัดวากายามะตอนเหนือ",
      "viName": "Miền Bắc tỉnh Wakayama",
      "inName": "Bagian Utara Prefektur Wakayama",
      "tlName": "Hilagang bahagi ng Wakayama Prefecture",
      "moName": "Хойд Вакаяма аймаг",
      "buName": "ဝကယမစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដវ៉ាកាយ៉ាម៉ា",
      "neName": "वाकायामा जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "300011",
      "name": "紀北",
      "enName": "Kihoku"
    },
    "class20": {
      "code": "3020900",
      "name": "岩出市",
      "enName": "Iwade City",
      "kana": "いわでし",
      "chName": "岩出市",
      "zhName": "岩出市",
      "koName": "이와데 시",
      "esName": "Ciudad de Iwade",
      "ptName": "cidade de Iwade",
      "thName": "เมืองอิวาเดะ",
      "viName": "thành phố Iwade",
      "inName": "kota Iwade",
      "tlName": "siyudad ng Iwade",
      "moName": "Ивадэ хот",
      "buName": "အီဝါ့ဒဲ့ မြို့",
      "khName": "ទីក្រុង អាយវ៉េដ",
      "neName": "इवादे सहर"
    }
  },
  "3030400": {
    "office": {
      "code": "300000",
      "name": "和歌山県",
      "enName": "Wakayama",
      "officeName": "和歌山地方気象台",
      "chName": "和歌山县",
      "zhName": "和歌山縣",
      "koName": "와카야마현",
      "esName": "Prefectura de Wakayama",
      "ptName": "Província de Wakayama",
      "thName": "จังหวัดวากายามะ",
      "viName": "Tỉnh Wakayama",
      "inName": "Prefektur Wakayama",
      "tlName": "Wakayama Prefecture",
      "moName": "Вакаяма аймаг",
      "buName": "ဝါကားယာ့မ ပြည်နယ်",
      "khName": "ខេត្ដ វ៉ាកាយ៉ាម៉ា",
      "neName": "वाकायामा जिल्ला"
    },
    "class10": {
      "code": "300010",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "和歌山县北部",
      "zhName": "和歌山縣北部",
      "koName": "와카야마 현 북부",
      "esName": "Norte de Prefectura de Wakayama",
      "ptName": "Norte da Província de Wakayama",
      "thName": "จังหวัดวากายามะตอนเหนือ",
      "viName": "Miền Bắc tỉnh Wakayama",
      "inName": "Bagian Utara Prefektur Wakayama",
      "tlName": "Hilagang bahagi ng Wakayama Prefecture",
      "moName": "Хойд Вакаяма аймаг",
      "buName": "ဝကယမစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដវ៉ាកាយ៉ាម៉ា",
      "neName": "वाकायामा जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "300011",
      "name": "紀北",
      "enName": "Kihoku"
    },
    "class20": {
      "code": "3030400",
      "name": "紀美野町",
      "enName": "Kimino Town",
      "kana": "きみのちょう",
      "chName": "纪美野町",
      "zhName": "紀美野町",
      "koName": "기미노 정",
      "esName": "Pueblo de Kimino",
      "ptName": "bairro de Kimino",
      "thName": "เมืองคิมิโนะ",
      "viName": "thị trấn Kimino",
      "inName": "kota Kimino",
      "tlName": "bayan ng Kimino",
      "moName": "Кимино жижиг хот",
      "buName": "ခီမိနို မြို့နယ်",
      "khName": "ទីប្រជុំជន គីមីណូ",
      "neName": "किमिनो नगर"
    }
  },
  "3034101": {
    "office": {
      "code": "300000",
      "name": "和歌山県",
      "enName": "Wakayama",
      "officeName": "和歌山地方気象台",
      "chName": "和歌山县",
      "zhName": "和歌山縣",
      "koName": "와카야마현",
      "esName": "Prefectura de Wakayama",
      "ptName": "Província de Wakayama",
      "thName": "จังหวัดวากายามะ",
      "viName": "Tỉnh Wakayama",
      "inName": "Prefektur Wakayama",
      "tlName": "Wakayama Prefecture",
      "moName": "Вакаяма аймаг",
      "buName": "ဝါကားယာ့မ ပြည်နယ်",
      "khName": "ខេត្ដ វ៉ាកាយ៉ាម៉ា",
      "neName": "वाकायामा जिल्ला"
    },
    "class10": {
      "code": "300010",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "和歌山县北部",
      "zhName": "和歌山縣北部",
      "koName": "와카야마 현 북부",
      "esName": "Norte de Prefectura de Wakayama",
      "ptName": "Norte da Província de Wakayama",
      "thName": "จังหวัดวากายามะตอนเหนือ",
      "viName": "Miền Bắc tỉnh Wakayama",
      "inName": "Bagian Utara Prefektur Wakayama",
      "tlName": "Hilagang bahagi ng Wakayama Prefecture",
      "moName": "Хойд Вакаяма аймаг",
      "buName": "ဝကယမစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដវ៉ាកាយ៉ាម៉ា",
      "neName": "वाकायामा जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "300011",
      "name": "紀北",
      "enName": "Kihoku"
    },
    "class20": {
      "code": "3034101",
      "name": "かつらぎ町かつらぎ",
      "enName": "Katsuragi, Katsuragi Town",
      "kana": "かつらぎちょうかつらぎ",
      "chName": "葛城町葛城",
      "zhName": "葛城町葛城",
      "koName": "카츠라기정 카츠라기",
      "esName": "Katsuragi, Pueblo de Katsuragi",
      "ptName": "Katsuragi, Cidade de Katsuragi",
      "thName": "คัตสึระงิ, เมืองคัตสึระงิ",
      "viName": "Katsuragi, Thị trấn Katsuragi",
      "inName": "Katsuragi, Kota Katsuragi",
      "tlName": "Katsuragi, Bayan ng Katsuragi",
      "moName": "Katsuragi, Cidade de Katsuragi",
      "buName": "ကပ်စူရာဂီမြို့",
      "khName": "ខេត្តកាត់សូរ៉ាគី",
      "neName": "कट्सुरागी, कात्सुरागी टाउन"
    }
  },
  "3034102": {
    "office": {
      "code": "300000",
      "name": "和歌山県",
      "enName": "Wakayama",
      "officeName": "和歌山地方気象台",
      "chName": "和歌山县",
      "zhName": "和歌山縣",
      "koName": "와카야마현",
      "esName": "Prefectura de Wakayama",
      "ptName": "Província de Wakayama",
      "thName": "จังหวัดวากายามะ",
      "viName": "Tỉnh Wakayama",
      "inName": "Prefektur Wakayama",
      "tlName": "Wakayama Prefecture",
      "moName": "Вакаяма аймаг",
      "buName": "ဝါကားယာ့မ ပြည်နယ်",
      "khName": "ខេត្ដ វ៉ាកាយ៉ាម៉ា",
      "neName": "वाकायामा जिल्ला"
    },
    "class10": {
      "code": "300010",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "和歌山县北部",
      "zhName": "和歌山縣北部",
      "koName": "와카야마 현 북부",
      "esName": "Norte de Prefectura de Wakayama",
      "ptName": "Norte da Província de Wakayama",
      "thName": "จังหวัดวากายามะตอนเหนือ",
      "viName": "Miền Bắc tỉnh Wakayama",
      "inName": "Bagian Utara Prefektur Wakayama",
      "tlName": "Hilagang bahagi ng Wakayama Prefecture",
      "moName": "Хойд Вакаяма аймаг",
      "buName": "ဝကယမစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដវ៉ាកាយ៉ាម៉ា",
      "neName": "वाकायामा जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "300011",
      "name": "紀北",
      "enName": "Kihoku"
    },
    "class20": {
      "code": "3034102",
      "name": "かつらぎ町花園",
      "enName": "Hanazono, Katsuragi Town",
      "kana": "かつらぎちょうはなぞの",
      "chName": "葛城町花园",
      "zhName": "葛城町花园",
      "koName": "카츠라기정 하나조노",
      "esName": "Hanazono, Pueblo de Katsuragi",
      "ptName": "Hanazono, Cidade de Katsuragi",
      "thName": "ฮานาโซโน, เมืองคัตสึระงิ",
      "viName": "Hanazono, Thị trấn Katsuragi",
      "inName": "Hanazono, Kota Katsuragi",
      "tlName": "Hanazono, Bayan ng Katsuragi",
      "moName": "Hanazono, Cidade de Katsuragi",
      "buName": "ဟနာဇိုနိုမြို့",
      "khName": "ខេត្តហាណាសូណូ",
      "neName": "हनाजोनो, कात्सुरागी टाउन"
    }
  },
  "3034300": {
    "office": {
      "code": "300000",
      "name": "和歌山県",
      "enName": "Wakayama",
      "officeName": "和歌山地方気象台",
      "chName": "和歌山县",
      "zhName": "和歌山縣",
      "koName": "와카야마현",
      "esName": "Prefectura de Wakayama",
      "ptName": "Província de Wakayama",
      "thName": "จังหวัดวากายามะ",
      "viName": "Tỉnh Wakayama",
      "inName": "Prefektur Wakayama",
      "tlName": "Wakayama Prefecture",
      "moName": "Вакаяма аймаг",
      "buName": "ဝါကားယာ့မ ပြည်နယ်",
      "khName": "ខេត្ដ វ៉ាកាយ៉ាម៉ា",
      "neName": "वाकायामा जिल्ला"
    },
    "class10": {
      "code": "300010",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "和歌山县北部",
      "zhName": "和歌山縣北部",
      "koName": "와카야마 현 북부",
      "esName": "Norte de Prefectura de Wakayama",
      "ptName": "Norte da Província de Wakayama",
      "thName": "จังหวัดวากายามะตอนเหนือ",
      "viName": "Miền Bắc tỉnh Wakayama",
      "inName": "Bagian Utara Prefektur Wakayama",
      "tlName": "Hilagang bahagi ng Wakayama Prefecture",
      "moName": "Хойд Вакаяма аймаг",
      "buName": "ဝကယမစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដវ៉ាកាយ៉ាម៉ា",
      "neName": "वाकायामा जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "300011",
      "name": "紀北",
      "enName": "Kihoku"
    },
    "class20": {
      "code": "3034300",
      "name": "九度山町",
      "enName": "Kudoyama Town",
      "kana": "くどやまちょう",
      "chName": "九度山町",
      "zhName": "九度山町",
      "koName": "구도야마 정",
      "esName": "Pueblo de Kudoyama",
      "ptName": "bairro de Kudoyama",
      "thName": "เมืองคุโดยามะ",
      "viName": "thị trấn Kudoyama",
      "inName": "kota Kudoyama",
      "tlName": "bayan ng Kudoyama",
      "moName": "Күдоямa жижиг хот",
      "buName": "ခူဒိုယာ့မ မြို့နယ်",
      "khName": "ទីប្រជុំជន គូដូយ៉ាម៉ា",
      "neName": "कुदोयामा नगर"
    }
  },
  "3034400": {
    "office": {
      "code": "300000",
      "name": "和歌山県",
      "enName": "Wakayama",
      "officeName": "和歌山地方気象台",
      "chName": "和歌山县",
      "zhName": "和歌山縣",
      "koName": "와카야마현",
      "esName": "Prefectura de Wakayama",
      "ptName": "Província de Wakayama",
      "thName": "จังหวัดวากายามะ",
      "viName": "Tỉnh Wakayama",
      "inName": "Prefektur Wakayama",
      "tlName": "Wakayama Prefecture",
      "moName": "Вакаяма аймаг",
      "buName": "ဝါကားယာ့မ ပြည်နယ်",
      "khName": "ខេត្ដ វ៉ាកាយ៉ាម៉ា",
      "neName": "वाकायामा जिल्ला"
    },
    "class10": {
      "code": "300010",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "和歌山县北部",
      "zhName": "和歌山縣北部",
      "koName": "와카야마 현 북부",
      "esName": "Norte de Prefectura de Wakayama",
      "ptName": "Norte da Província de Wakayama",
      "thName": "จังหวัดวากายามะตอนเหนือ",
      "viName": "Miền Bắc tỉnh Wakayama",
      "inName": "Bagian Utara Prefektur Wakayama",
      "tlName": "Hilagang bahagi ng Wakayama Prefecture",
      "moName": "Хойд Вакаяма аймаг",
      "buName": "ဝကယမစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដវ៉ាកាយ៉ាម៉ា",
      "neName": "वाकायामा जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "300011",
      "name": "紀北",
      "enName": "Kihoku"
    },
    "class20": {
      "code": "3034400",
      "name": "高野町",
      "enName": "Koya Town",
      "kana": "こうやちょう",
      "chName": "高野町",
      "zhName": "髙野町",
      "koName": "고야 정",
      "esName": "Pueblo de Kōya",
      "ptName": "bairro de Koya",
      "thName": "เมืองโคยะ",
      "viName": "thị trấn Koya",
      "inName": "kota Koya",
      "tlName": "bayan ng Koya",
      "moName": "Коя жижиг хот",
      "buName": "ကောယ မြို့နယ်",
      "khName": "ទីប្រជុំជន កូយ៉ា",
      "neName": "कोया नगर"
    }
  },
  "3036100": {
    "office": {
      "code": "300000",
      "name": "和歌山県",
      "enName": "Wakayama",
      "officeName": "和歌山地方気象台",
      "chName": "和歌山县",
      "zhName": "和歌山縣",
      "koName": "와카야마현",
      "esName": "Prefectura de Wakayama",
      "ptName": "Província de Wakayama",
      "thName": "จังหวัดวากายามะ",
      "viName": "Tỉnh Wakayama",
      "inName": "Prefektur Wakayama",
      "tlName": "Wakayama Prefecture",
      "moName": "Вакаяма аймаг",
      "buName": "ဝါကားယာ့မ ပြည်နယ်",
      "khName": "ខេត្ដ វ៉ាកាយ៉ាម៉ា",
      "neName": "वाकायामा जिल्ला"
    },
    "class10": {
      "code": "300010",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "和歌山县北部",
      "zhName": "和歌山縣北部",
      "koName": "와카야마 현 북부",
      "esName": "Norte de Prefectura de Wakayama",
      "ptName": "Norte da Província de Wakayama",
      "thName": "จังหวัดวากายามะตอนเหนือ",
      "viName": "Miền Bắc tỉnh Wakayama",
      "inName": "Bagian Utara Prefektur Wakayama",
      "tlName": "Hilagang bahagi ng Wakayama Prefecture",
      "moName": "Хойд Вакаяма аймаг",
      "buName": "ဝကယမစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដវ៉ាកាយ៉ាម៉ា",
      "neName": "वाकायामा जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "300012",
      "name": "紀中",
      "enName": "Kichu"
    },
    "class20": {
      "code": "3036100",
      "name": "湯浅町",
      "enName": "Yuasa Town",
      "kana": "ゆあさちょう",
      "chName": "汤浅町",
      "zhName": "湯淺町",
      "koName": "유아사 정",
      "esName": "Pueblo de Yuasa",
      "ptName": "bairro de Yuasa",
      "thName": "เมืองยูอาสะ",
      "viName": "thị trấn Yuasa",
      "inName": "kota Yuasa",
      "tlName": "bayan ng Yuasa",
      "moName": "Юaсa жижиг хот",
      "buName": "ယူဟာဆ မြို့နယ်",
      "khName": "ទីប្រជុំជន យូអាសា",
      "neName": "युआसा नगर"
    }
  },
  "3036200": {
    "office": {
      "code": "300000",
      "name": "和歌山県",
      "enName": "Wakayama",
      "officeName": "和歌山地方気象台",
      "chName": "和歌山县",
      "zhName": "和歌山縣",
      "koName": "와카야마현",
      "esName": "Prefectura de Wakayama",
      "ptName": "Província de Wakayama",
      "thName": "จังหวัดวากายามะ",
      "viName": "Tỉnh Wakayama",
      "inName": "Prefektur Wakayama",
      "tlName": "Wakayama Prefecture",
      "moName": "Вакаяма аймаг",
      "buName": "ဝါကားယာ့မ ပြည်နယ်",
      "khName": "ខេត្ដ វ៉ាកាយ៉ាម៉ា",
      "neName": "वाकायामा जिल्ला"
    },
    "class10": {
      "code": "300010",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "和歌山县北部",
      "zhName": "和歌山縣北部",
      "koName": "와카야마 현 북부",
      "esName": "Norte de Prefectura de Wakayama",
      "ptName": "Norte da Província de Wakayama",
      "thName": "จังหวัดวากายามะตอนเหนือ",
      "viName": "Miền Bắc tỉnh Wakayama",
      "inName": "Bagian Utara Prefektur Wakayama",
      "tlName": "Hilagang bahagi ng Wakayama Prefecture",
      "moName": "Хойд Вакаяма аймаг",
      "buName": "ဝကယမစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដវ៉ាកាយ៉ាម៉ា",
      "neName": "वाकायामा जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "300012",
      "name": "紀中",
      "enName": "Kichu"
    },
    "class20": {
      "code": "3036200",
      "name": "広川町",
      "enName": "Hirogawa Town",
      "kana": "ひろがわちょう",
      "chName": "和歌山广川町",
      "zhName": "和歌山廣川町",
      "koName": "와카야마 히로가와 정",
      "esName": "Pueblo de Hirogawa, Wakayama",
      "ptName": "Wakayama, bairro de Hirogawa",
      "thName": "เมืองฮิโรงาวะ วากายามะ",
      "viName": "Thị trấn Hirogawa, Wakayama",
      "inName": "Kota Hirogawa, Wakayama",
      "tlName": "bayan ng Hirogawa, Wakayama",
      "moName": "Вакаяма Хирогава жижиг хот",
      "buName": "ဝကယမဟိယိုဂဝမြို့နယ်",
      "khName": "ទីប្រជុំជនហ៊ីរ៉ូហ្កាវ៉ា វ៉ាកាយ៉ាម៉ា",
      "neName": "वाकायामा हिरोगावा नगर"
    }
  },
  "3036601": {
    "office": {
      "code": "300000",
      "name": "和歌山県",
      "enName": "Wakayama",
      "officeName": "和歌山地方気象台",
      "chName": "和歌山县",
      "zhName": "和歌山縣",
      "koName": "와카야마현",
      "esName": "Prefectura de Wakayama",
      "ptName": "Província de Wakayama",
      "thName": "จังหวัดวากายามะ",
      "viName": "Tỉnh Wakayama",
      "inName": "Prefektur Wakayama",
      "tlName": "Wakayama Prefecture",
      "moName": "Вакаяма аймаг",
      "buName": "ဝါကားယာ့မ ပြည်နယ်",
      "khName": "ខេត្ដ វ៉ាកាយ៉ាម៉ា",
      "neName": "वाकायामा जिल्ला"
    },
    "class10": {
      "code": "300010",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "和歌山县北部",
      "zhName": "和歌山縣北部",
      "koName": "와카야마 현 북부",
      "esName": "Norte de Prefectura de Wakayama",
      "ptName": "Norte da Província de Wakayama",
      "thName": "จังหวัดวากายามะตอนเหนือ",
      "viName": "Miền Bắc tỉnh Wakayama",
      "inName": "Bagian Utara Prefektur Wakayama",
      "tlName": "Hilagang bahagi ng Wakayama Prefecture",
      "moName": "Хойд Вакаяма аймаг",
      "buName": "ဝကယမစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដវ៉ាកាយ៉ាម៉ា",
      "neName": "वाकायामा जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "300012",
      "name": "紀中",
      "enName": "Kichu"
    },
    "class20": {
      "code": "3036601",
      "name": "有田川町吉備金屋",
      "enName": "Kibikanaya, Aridagawa Town",
      "kana": "ありだがわちょうきびかなや",
      "chName": "有田川町吉备金屋",
      "zhName": "有田川町吉備金屋",
      "koName": "아리다가와초 기비카나야",
      "esName": "Kibikanaya, Pueblo de Aridagawa",
      "ptName": "Kibikanaya, Vila de Aridagawa",
      "thName": "คิบิคานายะ เมืองอาริดากาวะ",
      "viName": "Kibikanaya, thị trấn Aridagawa",
      "inName": "Kibikanaya, Kota Aridagawa",
      "tlName": "Kibikanaya, Bayan ng Aridagawa",
      "moName": "Кибиканая, Аридагавын хот",
      "buName": "အာရီဒါဂါဝာမြို့၊ ကီဘီခနယာ",
      "khName": "កិប៊ីកានាយ៉ា, ទីប្រជុំជន អារីដាកាវា",
      "neName": "किबिकानाया, अरिदागावा टाउन"
    }
  },
  "3036602": {
    "office": {
      "code": "300000",
      "name": "和歌山県",
      "enName": "Wakayama",
      "officeName": "和歌山地方気象台",
      "chName": "和歌山县",
      "zhName": "和歌山縣",
      "koName": "와카야마현",
      "esName": "Prefectura de Wakayama",
      "ptName": "Província de Wakayama",
      "thName": "จังหวัดวากายามะ",
      "viName": "Tỉnh Wakayama",
      "inName": "Prefektur Wakayama",
      "tlName": "Wakayama Prefecture",
      "moName": "Вакаяма аймаг",
      "buName": "ဝါကားယာ့မ ပြည်နယ်",
      "khName": "ខេត្ដ វ៉ាកាយ៉ាម៉ា",
      "neName": "वाकायामा जिल्ला"
    },
    "class10": {
      "code": "300010",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "和歌山县北部",
      "zhName": "和歌山縣北部",
      "koName": "와카야마 현 북부",
      "esName": "Norte de Prefectura de Wakayama",
      "ptName": "Norte da Província de Wakayama",
      "thName": "จังหวัดวากายามะตอนเหนือ",
      "viName": "Miền Bắc tỉnh Wakayama",
      "inName": "Bagian Utara Prefektur Wakayama",
      "tlName": "Hilagang bahagi ng Wakayama Prefecture",
      "moName": "Хойд Вакаяма аймаг",
      "buName": "ဝကယမစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដវ៉ាកាយ៉ាម៉ា",
      "neName": "वाकायामा जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "300012",
      "name": "紀中",
      "enName": "Kichu"
    },
    "class20": {
      "code": "3036602",
      "name": "有田川町清水",
      "enName": "Shimizu, Aridagawa Town",
      "kana": "ありだがわちょうしみず",
      "chName": "有田川町清水",
      "zhName": "有田川町清水",
      "koName": "아리다가와초 시미즈",
      "esName": "Shimizu, Pueblo de Aridagawa",
      "ptName": "Shimizu, Vila de Aridagawa",
      "thName": "ชิมิซุ เมืองอาริดากาวะ",
      "viName": "Shimizu, thị trấn Aridagawa",
      "inName": "Shimizu, Kota Aridagawa",
      "tlName": "Shimizu, Bayan ng Aridagawa",
      "moName": "Шимизу, Аридагавын хот",
      "buName": "အာရီဒါဂါဝာမြို့၊ ရှိမစ်ဇု",
      "khName": "ស៊ីមីហ្ស៊ុ, ទីប្រជុំជន អារីដាកាវា",
      "neName": "शिमिज़ु, अरिदागावा टाउन"
    }
  },
  "3038100": {
    "office": {
      "code": "300000",
      "name": "和歌山県",
      "enName": "Wakayama",
      "officeName": "和歌山地方気象台",
      "chName": "和歌山县",
      "zhName": "和歌山縣",
      "koName": "와카야마현",
      "esName": "Prefectura de Wakayama",
      "ptName": "Província de Wakayama",
      "thName": "จังหวัดวากายามะ",
      "viName": "Tỉnh Wakayama",
      "inName": "Prefektur Wakayama",
      "tlName": "Wakayama Prefecture",
      "moName": "Вакаяма аймаг",
      "buName": "ဝါကားယာ့မ ပြည်နယ်",
      "khName": "ខេត្ដ វ៉ាកាយ៉ាម៉ា",
      "neName": "वाकायामा जिल्ला"
    },
    "class10": {
      "code": "300010",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "和歌山县北部",
      "zhName": "和歌山縣北部",
      "koName": "와카야마 현 북부",
      "esName": "Norte de Prefectura de Wakayama",
      "ptName": "Norte da Província de Wakayama",
      "thName": "จังหวัดวากายามะตอนเหนือ",
      "viName": "Miền Bắc tỉnh Wakayama",
      "inName": "Bagian Utara Prefektur Wakayama",
      "tlName": "Hilagang bahagi ng Wakayama Prefecture",
      "moName": "Хойд Вакаяма аймаг",
      "buName": "ဝကယမစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដវ៉ាកាយ៉ាម៉ា",
      "neName": "वाकायामा जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "300012",
      "name": "紀中",
      "enName": "Kichu"
    },
    "class20": {
      "code": "3038100",
      "name": "美浜町",
      "enName": "Mihama Town",
      "kana": "みはまちょう",
      "chName": "和歌山美浜町",
      "zhName": "和歌山美浜町",
      "koName": "와카야마 미하마 정",
      "esName": "Pueblo de Mihama, Wakayama",
      "ptName": "Wakayama, bairro de Mihama",
      "thName": "เมืองมิฮามะ วากายามะ",
      "viName": "Thị trấn Mihama, Wakayama",
      "inName": "Kota Mihama, Wakayama",
      "tlName": "bayan ng Mihama, Wakayama",
      "moName": "Вакаяма Михама жижиг хот",
      "buName": "ဝကယမမိဟမိမြို့နယ်",
      "khName": "ទីប្រជុំជន​មីហាម៉ា វ៉ាកាយ៉ាម៉ា",
      "neName": "वाकायामा मिहामा नगर"
    }
  },
  "3038200": {
    "office": {
      "code": "300000",
      "name": "和歌山県",
      "enName": "Wakayama",
      "officeName": "和歌山地方気象台",
      "chName": "和歌山县",
      "zhName": "和歌山縣",
      "koName": "와카야마현",
      "esName": "Prefectura de Wakayama",
      "ptName": "Província de Wakayama",
      "thName": "จังหวัดวากายามะ",
      "viName": "Tỉnh Wakayama",
      "inName": "Prefektur Wakayama",
      "tlName": "Wakayama Prefecture",
      "moName": "Вакаяма аймаг",
      "buName": "ဝါကားယာ့မ ပြည်နယ်",
      "khName": "ខេត្ដ វ៉ាកាយ៉ាម៉ា",
      "neName": "वाकायामा जिल्ला"
    },
    "class10": {
      "code": "300010",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "和歌山县北部",
      "zhName": "和歌山縣北部",
      "koName": "와카야마 현 북부",
      "esName": "Norte de Prefectura de Wakayama",
      "ptName": "Norte da Província de Wakayama",
      "thName": "จังหวัดวากายามะตอนเหนือ",
      "viName": "Miền Bắc tỉnh Wakayama",
      "inName": "Bagian Utara Prefektur Wakayama",
      "tlName": "Hilagang bahagi ng Wakayama Prefecture",
      "moName": "Хойд Вакаяма аймаг",
      "buName": "ဝကယမစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដវ៉ាកាយ៉ាម៉ា",
      "neName": "वाकायामा जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "300012",
      "name": "紀中",
      "enName": "Kichu"
    },
    "class20": {
      "code": "3038200",
      "name": "日高町",
      "enName": "Hidaka Town",
      "kana": "ひだかちょう",
      "chName": "和歌山日高町",
      "zhName": "和歌山日高町",
      "koName": "와카야마 히다카 정",
      "esName": "Pueblo de Hidaka, Wakayama",
      "ptName": "Wakayama, bairro de Hidaka",
      "thName": "เมืองฮิดากะ วากายามะ",
      "viName": "Thị trấn Hidaka, Wakayama",
      "inName": "Kota Hidaka, Wakayama",
      "tlName": "bayan ng Hidaka, Wakayama",
      "moName": "Вакаяма Хидака жижиг хот",
      "buName": "ဝကယမဟိဒဂမြို့နယ်",
      "khName": "ទីប្រជុំជនហ៊ីដាកា វ៉ាកាយ៉ាម៉ា",
      "neName": "वाकायामा हिदाका नगर"
    }
  },
  "3038300": {
    "office": {
      "code": "300000",
      "name": "和歌山県",
      "enName": "Wakayama",
      "officeName": "和歌山地方気象台",
      "chName": "和歌山县",
      "zhName": "和歌山縣",
      "koName": "와카야마현",
      "esName": "Prefectura de Wakayama",
      "ptName": "Província de Wakayama",
      "thName": "จังหวัดวากายามะ",
      "viName": "Tỉnh Wakayama",
      "inName": "Prefektur Wakayama",
      "tlName": "Wakayama Prefecture",
      "moName": "Вакаяма аймаг",
      "buName": "ဝါကားယာ့မ ပြည်နယ်",
      "khName": "ខេត្ដ វ៉ាកាយ៉ាម៉ា",
      "neName": "वाकायामा जिल्ला"
    },
    "class10": {
      "code": "300010",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "和歌山县北部",
      "zhName": "和歌山縣北部",
      "koName": "와카야마 현 북부",
      "esName": "Norte de Prefectura de Wakayama",
      "ptName": "Norte da Província de Wakayama",
      "thName": "จังหวัดวากายามะตอนเหนือ",
      "viName": "Miền Bắc tỉnh Wakayama",
      "inName": "Bagian Utara Prefektur Wakayama",
      "tlName": "Hilagang bahagi ng Wakayama Prefecture",
      "moName": "Хойд Вакаяма аймаг",
      "buName": "ဝကယမစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដវ៉ាកាយ៉ាម៉ា",
      "neName": "वाकायामा जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "300012",
      "name": "紀中",
      "enName": "Kichu"
    },
    "class20": {
      "code": "3038300",
      "name": "由良町",
      "enName": "Yura Town",
      "kana": "ゆらちょう",
      "chName": "由良町",
      "zhName": "由良町",
      "koName": "유라 정",
      "esName": "Pueblo de Yura",
      "ptName": "bairro de Yura",
      "thName": "เมืองยูระ",
      "viName": "thị trấn Yura",
      "inName": "kota Yura",
      "tlName": "bayan ng Yura",
      "moName": "Юра жижиг хот",
      "buName": "ယူရာ့ မြို့နယ်",
      "khName": "ទីប្រជុំជន យូរ៉ា",
      "neName": "युरा नगर"
    }
  },
  "3039000": {
    "office": {
      "code": "300000",
      "name": "和歌山県",
      "enName": "Wakayama",
      "officeName": "和歌山地方気象台",
      "chName": "和歌山县",
      "zhName": "和歌山縣",
      "koName": "와카야마현",
      "esName": "Prefectura de Wakayama",
      "ptName": "Província de Wakayama",
      "thName": "จังหวัดวากายามะ",
      "viName": "Tỉnh Wakayama",
      "inName": "Prefektur Wakayama",
      "tlName": "Wakayama Prefecture",
      "moName": "Вакаяма аймаг",
      "buName": "ဝါကားယာ့မ ပြည်နယ်",
      "khName": "ខេត្ដ វ៉ាកាយ៉ាម៉ា",
      "neName": "वाकायामा जिल्ला"
    },
    "class10": {
      "code": "300010",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "和歌山县北部",
      "zhName": "和歌山縣北部",
      "koName": "와카야마 현 북부",
      "esName": "Norte de Prefectura de Wakayama",
      "ptName": "Norte da Província de Wakayama",
      "thName": "จังหวัดวากายามะตอนเหนือ",
      "viName": "Miền Bắc tỉnh Wakayama",
      "inName": "Bagian Utara Prefektur Wakayama",
      "tlName": "Hilagang bahagi ng Wakayama Prefecture",
      "moName": "Хойд Вакаяма аймаг",
      "buName": "ဝကယမစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដវ៉ាកាយ៉ាម៉ា",
      "neName": "वाकायामा जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "300012",
      "name": "紀中",
      "enName": "Kichu"
    },
    "class20": {
      "code": "3039000",
      "name": "印南町",
      "enName": "Inami Town",
      "kana": "いなみちょう",
      "chName": "和歌山印南町",
      "zhName": "和歌山印南町",
      "koName": "와카야마 이나미 정",
      "esName": "Pueblo de Inami, Wakayama",
      "ptName": "Wakayama, bairro de Inami",
      "thName": "เมืองอินามิ วากายามะ",
      "viName": "Thị trấn Inami, Wakayama",
      "inName": "Kota Inami, Wakayama",
      "tlName": "bayan ng Inami, Wakayama",
      "moName": "Вакаяма Инами жижиг хот",
      "buName": "ဝကယမအိနမိမြို့နယ်",
      "khName": "ទីប្រជុំជនអ៊ីនណាមិ វ៉ាកាយ៉ាម៉ា",
      "neName": "वाकायामा इनामी नगर"
    }
  },
  "3039100": {
    "office": {
      "code": "300000",
      "name": "和歌山県",
      "enName": "Wakayama",
      "officeName": "和歌山地方気象台",
      "chName": "和歌山县",
      "zhName": "和歌山縣",
      "koName": "와카야마현",
      "esName": "Prefectura de Wakayama",
      "ptName": "Província de Wakayama",
      "thName": "จังหวัดวากายามะ",
      "viName": "Tỉnh Wakayama",
      "inName": "Prefektur Wakayama",
      "tlName": "Wakayama Prefecture",
      "moName": "Вакаяма аймаг",
      "buName": "ဝါကားယာ့မ ပြည်နယ်",
      "khName": "ខេត្ដ វ៉ាកាយ៉ាម៉ា",
      "neName": "वाकायामा जिल्ला"
    },
    "class10": {
      "code": "300010",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "和歌山县北部",
      "zhName": "和歌山縣北部",
      "koName": "와카야마 현 북부",
      "esName": "Norte de Prefectura de Wakayama",
      "ptName": "Norte da Província de Wakayama",
      "thName": "จังหวัดวากายามะตอนเหนือ",
      "viName": "Miền Bắc tỉnh Wakayama",
      "inName": "Bagian Utara Prefektur Wakayama",
      "tlName": "Hilagang bahagi ng Wakayama Prefecture",
      "moName": "Хойд Вакаяма аймаг",
      "buName": "ဝကယမစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដវ៉ាកាយ៉ាម៉ា",
      "neName": "वाकायामा जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "300012",
      "name": "紀中",
      "enName": "Kichu"
    },
    "class20": {
      "code": "3039100",
      "name": "みなべ町",
      "enName": "Minabe Town",
      "kana": "みなべちょう",
      "chName": "南部町",
      "zhName": "南部町",
      "koName": "미나베 정",
      "esName": "Pueblo de Minabe",
      "ptName": "bairro de Minabe",
      "thName": "เมืองมินาเบะ",
      "viName": "thị trấn Minabe",
      "inName": "kota Minabe",
      "tlName": "bayan ng Minabe",
      "moName": "Минaбэ жижиг хот",
      "buName": "မိနာ့ဗဲ့ မြို့နယ်",
      "khName": "ទីប្រជុំជន មីណាបេ",
      "neName": "मिनाबे नगर"
    }
  },
  "3039201": {
    "office": {
      "code": "300000",
      "name": "和歌山県",
      "enName": "Wakayama",
      "officeName": "和歌山地方気象台",
      "chName": "和歌山县",
      "zhName": "和歌山縣",
      "koName": "와카야마현",
      "esName": "Prefectura de Wakayama",
      "ptName": "Província de Wakayama",
      "thName": "จังหวัดวากายามะ",
      "viName": "Tỉnh Wakayama",
      "inName": "Prefektur Wakayama",
      "tlName": "Wakayama Prefecture",
      "moName": "Вакаяма аймаг",
      "buName": "ဝါကားယာ့မ ပြည်နယ်",
      "khName": "ខេត្ដ វ៉ាកាយ៉ាម៉ា",
      "neName": "वाकायामा जिल्ला"
    },
    "class10": {
      "code": "300010",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "和歌山县北部",
      "zhName": "和歌山縣北部",
      "koName": "와카야마 현 북부",
      "esName": "Norte de Prefectura de Wakayama",
      "ptName": "Norte da Província de Wakayama",
      "thName": "จังหวัดวากายามะตอนเหนือ",
      "viName": "Miền Bắc tỉnh Wakayama",
      "inName": "Bagian Utara Prefektur Wakayama",
      "tlName": "Hilagang bahagi ng Wakayama Prefecture",
      "moName": "Хойд Вакаяма аймаг",
      "buName": "ဝကယမစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដវ៉ាកាយ៉ាម៉ា",
      "neName": "वाकायामा जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "300012",
      "name": "紀中",
      "enName": "Kichu"
    },
    "class20": {
      "code": "3039201",
      "name": "日高川町川辺",
      "enName": "Kawabe, Hidakagawa Town",
      "kana": "ひだかがわちょうかわべ",
      "chName": "日高川町川边",
      "zhName": "日高川町川边",
      "koName": "히다카가와정 가와베",
      "esName": "Kawabe, Pueblo de Hidakagawa",
      "ptName": "Kawabe, Cidade de Hidakagawa",
      "thName": "คาวาเบะ, เมืองฮิดากากาวะ",
      "viName": "Kawabe, Thị trấn Hidakagawa",
      "inName": "Kawabe, Kota Hidakagawa",
      "tlName": "Kawabe, Bayan ng Hidakagawa",
      "moName": "Kawabe, Cidade de Hidakagawa",
      "buName": "ကဝဘေမြို့",
      "khName": "ខេត្តកាវាបេ",
      "neName": "कवाबे, हिडाकागावा टाउन"
    }
  },
  "3039202": {
    "office": {
      "code": "300000",
      "name": "和歌山県",
      "enName": "Wakayama",
      "officeName": "和歌山地方気象台",
      "chName": "和歌山县",
      "zhName": "和歌山縣",
      "koName": "와카야마현",
      "esName": "Prefectura de Wakayama",
      "ptName": "Província de Wakayama",
      "thName": "จังหวัดวากายามะ",
      "viName": "Tỉnh Wakayama",
      "inName": "Prefektur Wakayama",
      "tlName": "Wakayama Prefecture",
      "moName": "Вакаяма аймаг",
      "buName": "ဝါကားယာ့မ ပြည်နယ်",
      "khName": "ខេត្ដ វ៉ាកាយ៉ាម៉ា",
      "neName": "वाकायामा जिल्ला"
    },
    "class10": {
      "code": "300010",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "和歌山县北部",
      "zhName": "和歌山縣北部",
      "koName": "와카야마 현 북부",
      "esName": "Norte de Prefectura de Wakayama",
      "ptName": "Norte da Província de Wakayama",
      "thName": "จังหวัดวากายามะตอนเหนือ",
      "viName": "Miền Bắc tỉnh Wakayama",
      "inName": "Bagian Utara Prefektur Wakayama",
      "tlName": "Hilagang bahagi ng Wakayama Prefecture",
      "moName": "Хойд Вакаяма аймаг",
      "buName": "ဝကယမစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដវ៉ាកាយ៉ាម៉ា",
      "neName": "वाकायामा जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "300012",
      "name": "紀中",
      "enName": "Kichu"
    },
    "class20": {
      "code": "3039202",
      "name": "日高川町中津",
      "enName": "Nakatsu, Hidakagawa Town",
      "kana": "ひだかがわちょうなかつ",
      "chName": "日高川町中津",
      "zhName": "日高川町中津",
      "koName": "히다카가와정 나카츠",
      "esName": "Nakatsu, Pueblo de Hidakagawa",
      "ptName": "Nakatsu, Cidade de Hidakagawa",
      "thName": "นาคา츠, เมืองฮิดากากาวะ",
      "viName": "Nakatsu, Thị trấn Hidakagawa",
      "inName": "Nakatsu, Kota Hidakagawa",
      "tlName": "Nakatsu, Bayan ng Hidakagawa",
      "moName": "Nakatsu, Cidade de Hidakagawa",
      "buName": "နာကတ်ဆူးမြို့",
      "khName": "ខេត្តណាកាប់ស៊ូ",
      "neName": "नकात्सु, हिडाकागावा टाउन"
    }
  },
  "3039203": {
    "office": {
      "code": "300000",
      "name": "和歌山県",
      "enName": "Wakayama",
      "officeName": "和歌山地方気象台",
      "chName": "和歌山县",
      "zhName": "和歌山縣",
      "koName": "와카야마현",
      "esName": "Prefectura de Wakayama",
      "ptName": "Província de Wakayama",
      "thName": "จังหวัดวากายามะ",
      "viName": "Tỉnh Wakayama",
      "inName": "Prefektur Wakayama",
      "tlName": "Wakayama Prefecture",
      "moName": "Вакаяма аймаг",
      "buName": "ဝါကားယာ့မ ပြည်နယ်",
      "khName": "ខេត្ដ វ៉ាកាយ៉ាម៉ា",
      "neName": "वाकायामा जिल्ला"
    },
    "class10": {
      "code": "300010",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "和歌山县北部",
      "zhName": "和歌山縣北部",
      "koName": "와카야마 현 북부",
      "esName": "Norte de Prefectura de Wakayama",
      "ptName": "Norte da Província de Wakayama",
      "thName": "จังหวัดวากายามะตอนเหนือ",
      "viName": "Miền Bắc tỉnh Wakayama",
      "inName": "Bagian Utara Prefektur Wakayama",
      "tlName": "Hilagang bahagi ng Wakayama Prefecture",
      "moName": "Хойд Вакаяма аймаг",
      "buName": "ဝကယမစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដវ៉ាកាយ៉ាម៉ា",
      "neName": "वाकायामा जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "300012",
      "name": "紀中",
      "enName": "Kichu"
    },
    "class20": {
      "code": "3039203",
      "name": "日高川町美山",
      "enName": "Miyama, Hidakagawa Town",
      "kana": "ひだかがわちょうみやま",
      "chName": "日高川町美山",
      "zhName": "日高川町美山",
      "koName": "히다카가와정 미야마",
      "esName": "Miyama, Pueblo de Hidakagawa",
      "ptName": "Miyama, Cidade de Hidakagawa",
      "thName": "มิยามะ, เมืองฮิดากากาวะ",
      "viName": "Miyama, Thị trấn Hidakagawa",
      "inName": "Miyama, Kota Hidakagawa",
      "tlName": "Miyama, Bayan ng Hidakagawa",
      "moName": "Miyama, Cidade de Hidakagawa",
      "buName": "မီယာမမြို့",
      "khName": "ខេត្តមីយាម៉ា",
      "neName": "मियामा, हिडाकागावा टाउन"
    }
  },
  "3040100": {
    "office": {
      "code": "300000",
      "name": "和歌山県",
      "enName": "Wakayama",
      "officeName": "和歌山地方気象台",
      "chName": "和歌山县",
      "zhName": "和歌山縣",
      "koName": "와카야마현",
      "esName": "Prefectura de Wakayama",
      "ptName": "Província de Wakayama",
      "thName": "จังหวัดวากายามะ",
      "viName": "Tỉnh Wakayama",
      "inName": "Prefektur Wakayama",
      "tlName": "Wakayama Prefecture",
      "moName": "Вакаяма аймаг",
      "buName": "ဝါကားယာ့မ ပြည်နယ်",
      "khName": "ខេត្ដ វ៉ាកាយ៉ាម៉ា",
      "neName": "वाकायामा जिल्ला"
    },
    "class10": {
      "code": "300020",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "和歌山县南部",
      "zhName": "和歌山縣南部",
      "koName": "와카야마 현 남부",
      "esName": "Sur de Prefectura de Wakayama",
      "ptName": "Sul da Província de Wakayama",
      "thName": "จังหวัดวากายามะตอนใต้",
      "viName": "Miền Nam tỉnh Wakayama",
      "inName": "Bagian Selatan Prefektur Wakayama",
      "tlName": "Timog na bahagi ng Wakayama Prefecture",
      "moName": "Өмнөд Вакаяма аймаг",
      "buName": "ဝကယမစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដវ៉ាកាយ៉ាម៉ា",
      "neName": "वाकायामा जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "300021",
      "name": "田辺・西牟婁",
      "enName": "Tanabe Nishimuro"
    },
    "class20": {
      "code": "3040100",
      "name": "白浜町",
      "enName": "Shirahama Town",
      "kana": "しらはまちょう",
      "chName": "白滨町",
      "zhName": "白濱町",
      "koName": "시라하마 정",
      "esName": "Pueblo de Shirahama",
      "ptName": "bairro de Shirahama",
      "thName": "เมืองชิราฮามะ",
      "viName": "thị trấn Shirahama",
      "inName": "kota Shirahama",
      "tlName": "bayan ng Shirahama",
      "moName": "Ширахaмa жижиг хот",
      "buName": "ရှီရာဟာ့မ မြို့နယ်",
      "khName": "ទីប្រជុំជន ស៊ីរ៉ាហាម៉ា",
      "neName": "शिराहामा नगर"
    }
  },
  "3040400": {
    "office": {
      "code": "300000",
      "name": "和歌山県",
      "enName": "Wakayama",
      "officeName": "和歌山地方気象台",
      "chName": "和歌山县",
      "zhName": "和歌山縣",
      "koName": "와카야마현",
      "esName": "Prefectura de Wakayama",
      "ptName": "Província de Wakayama",
      "thName": "จังหวัดวากายามะ",
      "viName": "Tỉnh Wakayama",
      "inName": "Prefektur Wakayama",
      "tlName": "Wakayama Prefecture",
      "moName": "Вакаяма аймаг",
      "buName": "ဝါကားယာ့မ ပြည်နယ်",
      "khName": "ខេត្ដ វ៉ាកាយ៉ាម៉ា",
      "neName": "वाकायामा जिल्ला"
    },
    "class10": {
      "code": "300020",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "和歌山县南部",
      "zhName": "和歌山縣南部",
      "koName": "와카야마 현 남부",
      "esName": "Sur de Prefectura de Wakayama",
      "ptName": "Sul da Província de Wakayama",
      "thName": "จังหวัดวากายามะตอนใต้",
      "viName": "Miền Nam tỉnh Wakayama",
      "inName": "Bagian Selatan Prefektur Wakayama",
      "tlName": "Timog na bahagi ng Wakayama Prefecture",
      "moName": "Өмнөд Вакаяма аймаг",
      "buName": "ဝကယမစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដវ៉ាកាយ៉ាម៉ា",
      "neName": "वाकायामा जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "300021",
      "name": "田辺・西牟婁",
      "enName": "Tanabe Nishimuro"
    },
    "class20": {
      "code": "3040400",
      "name": "上富田町",
      "enName": "Kamitonda Town",
      "kana": "かみとんだちょう",
      "chName": "上富田町",
      "zhName": "上富田町",
      "koName": "가미톤다 정",
      "esName": "Pueblo de Kamitonda",
      "ptName": "bairro de Kamitonda",
      "thName": "เมืองคามิทนดะ",
      "viName": "thị trấn Kamitonda",
      "inName": "kota Kamitonda",
      "tlName": "bayan ng Kamitonda",
      "moName": "Камитонда жижиг хот",
      "buName": "ခါမိတွန်းဒ မြို့နယ်",
      "khName": "ទីប្រជុំជន កាមីតុនដា",
      "neName": "कामितोन्दा नगर"
    }
  },
  "3040600": {
    "office": {
      "code": "300000",
      "name": "和歌山県",
      "enName": "Wakayama",
      "officeName": "和歌山地方気象台",
      "chName": "和歌山县",
      "zhName": "和歌山縣",
      "koName": "와카야마현",
      "esName": "Prefectura de Wakayama",
      "ptName": "Província de Wakayama",
      "thName": "จังหวัดวากายามะ",
      "viName": "Tỉnh Wakayama",
      "inName": "Prefektur Wakayama",
      "tlName": "Wakayama Prefecture",
      "moName": "Вакаяма аймаг",
      "buName": "ဝါကားယာ့မ ပြည်နယ်",
      "khName": "ខេត្ដ វ៉ាកាយ៉ាម៉ា",
      "neName": "वाकायामा जिल्ला"
    },
    "class10": {
      "code": "300020",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "和歌山县南部",
      "zhName": "和歌山縣南部",
      "koName": "와카야마 현 남부",
      "esName": "Sur de Prefectura de Wakayama",
      "ptName": "Sul da Província de Wakayama",
      "thName": "จังหวัดวากายามะตอนใต้",
      "viName": "Miền Nam tỉnh Wakayama",
      "inName": "Bagian Selatan Prefektur Wakayama",
      "tlName": "Timog na bahagi ng Wakayama Prefecture",
      "moName": "Өмнөд Вакаяма аймаг",
      "buName": "ဝကယမစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដវ៉ាកាយ៉ាម៉ា",
      "neName": "वाकायामा जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "300021",
      "name": "田辺・西牟婁",
      "enName": "Tanabe Nishimuro"
    },
    "class20": {
      "code": "3040600",
      "name": "すさみ町",
      "enName": "Susami Town",
      "kana": "すさみちょう",
      "chName": "周参见町",
      "zhName": "周參見町",
      "koName": "스사미 정",
      "esName": "Pueblo de Susami",
      "ptName": "bairro de Susami",
      "thName": "เมืองซูซามิ",
      "viName": "thị trấn Susami",
      "inName": "kota Susami",
      "tlName": "bayan ng Susami",
      "moName": "Сүсaми жижиг хот",
      "buName": "ဆုဆားမိ မြို့နယ်",
      "khName": "ទីប្រជុំជន ស៊ូសាមិ",
      "neName": "सुसामी नगर"
    }
  },
  "3042100": {
    "office": {
      "code": "300000",
      "name": "和歌山県",
      "enName": "Wakayama",
      "officeName": "和歌山地方気象台",
      "chName": "和歌山县",
      "zhName": "和歌山縣",
      "koName": "와카야마현",
      "esName": "Prefectura de Wakayama",
      "ptName": "Província de Wakayama",
      "thName": "จังหวัดวากายามะ",
      "viName": "Tỉnh Wakayama",
      "inName": "Prefektur Wakayama",
      "tlName": "Wakayama Prefecture",
      "moName": "Вакаяма аймаг",
      "buName": "ဝါကားယာ့မ ပြည်နယ်",
      "khName": "ខេត្ដ វ៉ាកាយ៉ាម៉ា",
      "neName": "वाकायामा जिल्ला"
    },
    "class10": {
      "code": "300020",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "和歌山县南部",
      "zhName": "和歌山縣南部",
      "koName": "와카야마 현 남부",
      "esName": "Sur de Prefectura de Wakayama",
      "ptName": "Sul da Província de Wakayama",
      "thName": "จังหวัดวากายามะตอนใต้",
      "viName": "Miền Nam tỉnh Wakayama",
      "inName": "Bagian Selatan Prefektur Wakayama",
      "tlName": "Timog na bahagi ng Wakayama Prefecture",
      "moName": "Өмнөд Вакаяма аймаг",
      "buName": "ဝကယမစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដវ៉ាកាយ៉ាម៉ា",
      "neName": "वाकायामा जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "300022",
      "name": "新宮・東牟婁",
      "enName": "Shingu Higashimuro"
    },
    "class20": {
      "code": "3042100",
      "name": "那智勝浦町",
      "enName": "Nachikatsuura Town",
      "kana": "なちかつうらちょう",
      "chName": "那智胜浦町",
      "zhName": "那智勝浦町",
      "koName": "나치카쓰우라 정",
      "esName": "Pueblo de Nachikatsuura",
      "ptName": "bairro de Nachikatsuura",
      "thName": "เมืองนะจิคัตสึอุระ",
      "viName": "thị trấn Nachikatsuura",
      "inName": "kota Nachikatsuura",
      "tlName": "bayan ng Nachikatsuura",
      "moName": "Нaчикацүүра жижиг хот",
      "buName": "နာကျိကာဆူးရာ့ မြို့နယ်",
      "khName": "ទីប្រជុំជន ណាជីកាតស៊ូអូ៊រ៉ា",
      "neName": "नाचिकात्सुरा नगर"
    }
  },
  "3042200": {
    "office": {
      "code": "300000",
      "name": "和歌山県",
      "enName": "Wakayama",
      "officeName": "和歌山地方気象台",
      "chName": "和歌山县",
      "zhName": "和歌山縣",
      "koName": "와카야마현",
      "esName": "Prefectura de Wakayama",
      "ptName": "Província de Wakayama",
      "thName": "จังหวัดวากายามะ",
      "viName": "Tỉnh Wakayama",
      "inName": "Prefektur Wakayama",
      "tlName": "Wakayama Prefecture",
      "moName": "Вакаяма аймаг",
      "buName": "ဝါကားယာ့မ ပြည်နယ်",
      "khName": "ខេត្ដ វ៉ាកាយ៉ាម៉ា",
      "neName": "वाकायामा जिल्ला"
    },
    "class10": {
      "code": "300020",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "和歌山县南部",
      "zhName": "和歌山縣南部",
      "koName": "와카야마 현 남부",
      "esName": "Sur de Prefectura de Wakayama",
      "ptName": "Sul da Província de Wakayama",
      "thName": "จังหวัดวากายามะตอนใต้",
      "viName": "Miền Nam tỉnh Wakayama",
      "inName": "Bagian Selatan Prefektur Wakayama",
      "tlName": "Timog na bahagi ng Wakayama Prefecture",
      "moName": "Өмнөд Вакаяма аймаг",
      "buName": "ဝကယမစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដវ៉ាកាយ៉ាម៉ា",
      "neName": "वाकायामा जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "300022",
      "name": "新宮・東牟婁",
      "enName": "Shingu Higashimuro"
    },
    "class20": {
      "code": "3042200",
      "name": "太地町",
      "enName": "Taiji Town",
      "kana": "たいじちょう",
      "chName": "太地町",
      "zhName": "太地町",
      "koName": "다이지 정",
      "esName": "Pueblo de Taiji",
      "ptName": "bairro de Taiji",
      "thName": "เมืองไทจิ",
      "viName": "thị trấn Taiji",
      "inName": "kota Taiji",
      "tlName": "bayan ng Taiji",
      "moName": "Тайжи жижиг хот",
      "buName": "တိုင်ယိဂျိ မြို့နယ်",
      "khName": "ទីប្រជុំជន តៃជី",
      "neName": "ताइजी नगर"
    }
  },
  "3042400": {
    "office": {
      "code": "300000",
      "name": "和歌山県",
      "enName": "Wakayama",
      "officeName": "和歌山地方気象台",
      "chName": "和歌山县",
      "zhName": "和歌山縣",
      "koName": "와카야마현",
      "esName": "Prefectura de Wakayama",
      "ptName": "Província de Wakayama",
      "thName": "จังหวัดวากายามะ",
      "viName": "Tỉnh Wakayama",
      "inName": "Prefektur Wakayama",
      "tlName": "Wakayama Prefecture",
      "moName": "Вакаяма аймаг",
      "buName": "ဝါကားယာ့မ ပြည်နယ်",
      "khName": "ខេត្ដ វ៉ាកាយ៉ាម៉ា",
      "neName": "वाकायामा जिल्ला"
    },
    "class10": {
      "code": "300020",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "和歌山县南部",
      "zhName": "和歌山縣南部",
      "koName": "와카야마 현 남부",
      "esName": "Sur de Prefectura de Wakayama",
      "ptName": "Sul da Província de Wakayama",
      "thName": "จังหวัดวากายามะตอนใต้",
      "viName": "Miền Nam tỉnh Wakayama",
      "inName": "Bagian Selatan Prefektur Wakayama",
      "tlName": "Timog na bahagi ng Wakayama Prefecture",
      "moName": "Өмнөд Вакаяма аймаг",
      "buName": "ဝကယမစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដវ៉ាកាយ៉ាម៉ា",
      "neName": "वाकायामा जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "300022",
      "name": "新宮・東牟婁",
      "enName": "Shingu Higashimuro"
    },
    "class20": {
      "code": "3042400",
      "name": "古座川町",
      "enName": "Kozagawa Town",
      "kana": "こざがわちょう",
      "chName": "古座川町",
      "zhName": "古座川町",
      "koName": "고자가와 정",
      "esName": "Pueblo de Kozagawa",
      "ptName": "bairro de Kozagawa",
      "thName": "เมืองโคซางาวะ",
      "viName": "thị trấn Kozagawa",
      "inName": "kota Kozagawa",
      "tlName": "bayan ng Kozagawa",
      "moName": "Козaгава жижиг хот",
      "buName": "ကိုဇာဂါ့ဝ မြို့နယ်",
      "khName": "ទីប្រជុំជន កូហ្សាកាវ៉ា",
      "neName": "कोजागावा नगर"
    }
  },
  "3042700": {
    "office": {
      "code": "300000",
      "name": "和歌山県",
      "enName": "Wakayama",
      "officeName": "和歌山地方気象台",
      "chName": "和歌山县",
      "zhName": "和歌山縣",
      "koName": "와카야마현",
      "esName": "Prefectura de Wakayama",
      "ptName": "Província de Wakayama",
      "thName": "จังหวัดวากายามะ",
      "viName": "Tỉnh Wakayama",
      "inName": "Prefektur Wakayama",
      "tlName": "Wakayama Prefecture",
      "moName": "Вакаяма аймаг",
      "buName": "ဝါကားယာ့မ ပြည်နယ်",
      "khName": "ខេត្ដ វ៉ាកាយ៉ាម៉ា",
      "neName": "वाकायामा जिल्ला"
    },
    "class10": {
      "code": "300020",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "和歌山县南部",
      "zhName": "和歌山縣南部",
      "koName": "와카야마 현 남부",
      "esName": "Sur de Prefectura de Wakayama",
      "ptName": "Sul da Província de Wakayama",
      "thName": "จังหวัดวากายามะตอนใต้",
      "viName": "Miền Nam tỉnh Wakayama",
      "inName": "Bagian Selatan Prefektur Wakayama",
      "tlName": "Timog na bahagi ng Wakayama Prefecture",
      "moName": "Өмнөд Вакаяма аймаг",
      "buName": "ဝကယမစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដវ៉ាកាយ៉ាម៉ា",
      "neName": "वाकायामा जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "300022",
      "name": "新宮・東牟婁",
      "enName": "Shingu Higashimuro"
    },
    "class20": {
      "code": "3042700",
      "name": "北山村",
      "enName": "Kitayama Village",
      "kana": "きたやまむら",
      "chName": "北山村",
      "zhName": "北山村",
      "koName": "기타야마 촌",
      "esName": "Aldea de Kitayama",
      "ptName": "povoado de Kitayama",
      "thName": "หมู่บ้านคิตะยามะ",
      "viName": "làng Kitayama",
      "inName": "desa Kitayama",
      "tlName": "nayon ng Kitayama",
      "moName": "Китаямa тосгон",
      "buName": "ခီတားယာ့မ ကျေးရွာ",
      "khName": "ភូមិ គីតាយ៉ាម៉ា",
      "neName": "कितायामा गाउँ"
    }
  },
  "3042800": {
    "office": {
      "code": "300000",
      "name": "和歌山県",
      "enName": "Wakayama",
      "officeName": "和歌山地方気象台",
      "chName": "和歌山县",
      "zhName": "和歌山縣",
      "koName": "와카야마현",
      "esName": "Prefectura de Wakayama",
      "ptName": "Província de Wakayama",
      "thName": "จังหวัดวากายามะ",
      "viName": "Tỉnh Wakayama",
      "inName": "Prefektur Wakayama",
      "tlName": "Wakayama Prefecture",
      "moName": "Вакаяма аймаг",
      "buName": "ဝါကားယာ့မ ပြည်နယ်",
      "khName": "ខេត្ដ វ៉ាកាយ៉ាម៉ា",
      "neName": "वाकायामा जिल्ला"
    },
    "class10": {
      "code": "300020",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "和歌山县南部",
      "zhName": "和歌山縣南部",
      "koName": "와카야마 현 남부",
      "esName": "Sur de Prefectura de Wakayama",
      "ptName": "Sul da Província de Wakayama",
      "thName": "จังหวัดวากายามะตอนใต้",
      "viName": "Miền Nam tỉnh Wakayama",
      "inName": "Bagian Selatan Prefektur Wakayama",
      "tlName": "Timog na bahagi ng Wakayama Prefecture",
      "moName": "Өмнөд Вакаяма аймаг",
      "buName": "ဝကယမစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដវ៉ាកាយ៉ាម៉ា",
      "neName": "वाकायामा जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "300022",
      "name": "新宮・東牟婁",
      "enName": "Shingu Higashimuro"
    },
    "class20": {
      "code": "3042800",
      "name": "串本町",
      "enName": "Kushimoto Town",
      "kana": "くし��とちょう",
      "chName": "串本町",
      "zhName": "串本町",
      "koName": "구시모토 정",
      "esName": "Pueblo de Kushimoto",
      "ptName": "bairro de Kushimoto",
      "thName": "เมืองคุชิโมโตะ",
      "viName": "thị trấn Kushimoto",
      "inName": "kota Kushimoto",
      "tlName": "bayan ng Kushimoto",
      "moName": "Күшимото жижиг хот",
      "buName": "ခူရှီမိုတို မြို့နယ်",
      "khName": "ទីប្រជុំជន គូស៊ីម៉ូតូ",
      "neName": "कुशिमोतो नगर"
    }
  },
  "3120101": {
    "office": {
      "code": "310000",
      "name": "鳥取県",
      "enName": "Tottori",
      "officeName": "鳥取地方気象台",
      "chName": "鸟取县",
      "zhName": "鳥取縣",
      "koName": "돗토리현",
      "esName": "Prefectura de Tottori",
      "ptName": "Província de Tottori",
      "thName": "จังหวัดทตโตริ",
      "viName": "Tỉnh Tottori",
      "inName": "Prefektur Tottori",
      "tlName": "Tottori Prefecture",
      "moName": "Тоттори аймаг",
      "buName": "တော်တိုးရိ ပြည်နယ်",
      "khName": "ខេត្ដ តូតូរី",
      "neName": "तोत्तोरी जिल्ला"
    },
    "class10": {
      "code": "310010",
      "name": "東部",
      "enName": "Eastern Region",
      "chName": "鸟取县东部",
      "zhName": "鳥取縣東部",
      "koName": "돗토리 현 동부",
      "esName": "Este de Prefectura de Tottori",
      "ptName": "Leste da Província de Tottori",
      "thName": "จังหวัดทตโตริฟากตะวันออก",
      "viName": "Miền Đông tỉnh Tottori",
      "inName": "Bagian Timur Prefektur Tottori",
      "tlName": "Silangang bahagi ng Tottori Prefecture",
      "moName": "Зүүн Тоттори аймаг",
      "buName": "တို့တိုယိစီရင်စု အရှေ့ပိုင်း",
      "khName": "តំបន់ខាងកើតនៃខេត្ដតុតតូរី",
      "neName": "तोत्तोरी जिल्लाको पूर्वी भाग"
    },
    "class15": {
      "code": "310011",
      "name": "鳥取地区",
      "enName": "Tottori District"
    },
    "class20": {
      "code": "3120101",
      "name": "鳥取市北部",
      "enName": "Northern Tottori City",
      "kana": "とっとりしほくぶ",
      "chName": "鸟取市",
      "zhName": "鸟取市",
      "koName": "돗토리시",
      "esName": "Ciudad de Tottori",
      "ptName": "Cidade de Tottori",
      "thName": "เมืองทอตโทริ",
      "viName": "Thành phố Tottori",
      "inName": "Kota Tottori",
      "tlName": "Lungsod ng Tottori",
      "moName": "Cidade de Tottori",
      "buName": "တိုတိုရီမြို့",
      "khName": "ខេត្តតូតូរី",
      "neName": "तोत्तोरी शहर"
    }
  },
  "3120102": {
    "office": {
      "code": "310000",
      "name": "鳥取県",
      "enName": "Tottori",
      "officeName": "鳥取地方気象台",
      "chName": "鸟取县",
      "zhName": "鳥取縣",
      "koName": "돗토리현",
      "esName": "Prefectura de Tottori",
      "ptName": "Província de Tottori",
      "thName": "จังหวัดทตโตริ",
      "viName": "Tỉnh Tottori",
      "inName": "Prefektur Tottori",
      "tlName": "Tottori Prefecture",
      "moName": "Тоттори аймаг",
      "buName": "တော်တိုးရိ ပြည်နယ်",
      "khName": "ខេត្ដ តូតូរី",
      "neName": "तोत्तोरी जिल्ला"
    },
    "class10": {
      "code": "310010",
      "name": "東部",
      "enName": "Eastern Region",
      "chName": "鸟取县东部",
      "zhName": "鳥取縣東部",
      "koName": "돗토리 현 동부",
      "esName": "Este de Prefectura de Tottori",
      "ptName": "Leste da Província de Tottori",
      "thName": "จังหวัดทตโตริฟากตะวันออก",
      "viName": "Miền Đông tỉnh Tottori",
      "inName": "Bagian Timur Prefektur Tottori",
      "tlName": "Silangang bahagi ng Tottori Prefecture",
      "moName": "Зүүн Тоттори аймаг",
      "buName": "တို့တိုယိစီရင်စု အရှေ့ပိုင်း",
      "khName": "តំបន់ខាងកើតនៃខេត្ដតុតតូរី",
      "neName": "तोत्तोरी जिल्लाको पूर्वी भाग"
    },
    "class15": {
      "code": "310012",
      "name": "八頭地区",
      "enName": "Yazu District"
    },
    "class20": {
      "code": "3120102",
      "name": "鳥取市南部",
      "enName": "Southern Tottori City",
      "kana": "とっとりしなんぶ",
      "chName": "鸟取市",
      "zhName": "鸟取市",
      "koName": "돗토리시",
      "esName": "Ciudad de Tottori",
      "ptName": "Cidade de Tottori",
      "thName": "เมืองทอตโทริ",
      "viName": "Thành phố Tottori",
      "inName": "Kota Tottori",
      "tlName": "Lungsod ng Tottori",
      "moName": "Cidade de Tottori",
      "buName": "တိုတိုရီမြို့",
      "khName": "ខេត្តតូតូរី",
      "neName": "तोत्तोरी शहर"
    }
  },
  "3120200": {
    "office": {
      "code": "310000",
      "name": "鳥取県",
      "enName": "Tottori",
      "officeName": "鳥取地方気象台",
      "chName": "鸟取县",
      "zhName": "鳥取縣",
      "koName": "돗토리현",
      "esName": "Prefectura de Tottori",
      "ptName": "Província de Tottori",
      "thName": "จังหวัดทตโตริ",
      "viName": "Tỉnh Tottori",
      "inName": "Prefektur Tottori",
      "tlName": "Tottori Prefecture",
      "moName": "Тоттори аймаг",
      "buName": "တော်တိုးရိ ပြည်နယ်",
      "khName": "ខេត្ដ តូតូរី",
      "neName": "तोत्तोरी जिल्ला"
    },
    "class10": {
      "code": "310020",
      "name": "中・西部",
      "enName": "Central Western Region",
      "chName": "鸟取县中部",
      "zhName": "鳥取縣中部",
      "koName": "돗토리 현 중부",
      "esName": "Centro de Prefectura de Tottori",
      "ptName": "Região central da Província de Tottori",
      "thName": "จังหวัดทตโตริตอนกลาง",
      "viName": "Miền Trung tỉnh Tottori",
      "inName": "Bagian Tengah Prefektur Tottori",
      "tlName": "Sentral na bahagi ng Tottori Prefecture",
      "moName": "Төв Тоттори аймаг",
      "buName": "တို့တိုယိစီရင်စု အလယ်ပိုင်း",
      "khName": "តំបន់កណ្តាលនៃខេត្ដតុតតូរី",
      "neName": "तोत्तोरी जिल्लाको मध्य भाग"
    },
    "class15": {
      "code": "310022",
      "name": "米子地区",
      "enName": "Yonago District"
    },
    "class20": {
      "code": "3120200",
      "name": "米子市",
      "enName": "Yonago City",
      "kana": "よなごし",
      "chName": "米子市",
      "zhName": "米子市",
      "koName": "요나고 시",
      "esName": "Ciudad de Yonago",
      "ptName": "cidade de Yonago",
      "thName": "เมืองโยนาโงะ",
      "viName": "thành phố Yonago",
      "inName": "kota Yonago",
      "tlName": "siyudad ng Yonago",
      "moName": "Ёонaго хот",
      "buName": "ယိုးနာ့ဂို မြို့",
      "khName": "ទីក្រុង យ៉ុណាហ្គូ",
      "neName": "योनागो सहर"
    }
  },
  "3120300": {
    "office": {
      "code": "310000",
      "name": "鳥取県",
      "enName": "Tottori",
      "officeName": "鳥取地方気象台",
      "chName": "鸟取县",
      "zhName": "鳥取縣",
      "koName": "돗토리현",
      "esName": "Prefectura de Tottori",
      "ptName": "Província de Tottori",
      "thName": "จังหวัดทตโตริ",
      "viName": "Tỉnh Tottori",
      "inName": "Prefektur Tottori",
      "tlName": "Tottori Prefecture",
      "moName": "Тоттори аймаг",
      "buName": "တော်တိုးရိ ပြည်နယ်",
      "khName": "ខេត្ដ តូតូរី",
      "neName": "तोत्तोरी जिल्ला"
    },
    "class10": {
      "code": "310020",
      "name": "中・西部",
      "enName": "Central Western Region",
      "chName": "鸟取县中部",
      "zhName": "鳥取縣中部",
      "koName": "돗토리 현 중부",
      "esName": "Centro de Prefectura de Tottori",
      "ptName": "Região central da Província de Tottori",
      "thName": "จังหวัดทตโตริตอนกลาง",
      "viName": "Miền Trung tỉnh Tottori",
      "inName": "Bagian Tengah Prefektur Tottori",
      "tlName": "Sentral na bahagi ng Tottori Prefecture",
      "moName": "Төв Тоттори аймаг",
      "buName": "တို့တိုယိစီရင်စု အလယ်ပိုင်း",
      "khName": "តំបន់កណ្តាលនៃខេត្ដតុតតូរី",
      "neName": "तोत्तोरी जिल्लाको मध्य भाग"
    },
    "class15": {
      "code": "310021",
      "name": "倉吉地区",
      "enName": "Kurayoshi District"
    },
    "class20": {
      "code": "3120300",
      "name": "倉吉市",
      "enName": "Kurayoshi City",
      "kana": "くらよしし",
      "chName": "仓吉市",
      "zhName": "倉吉市",
      "koName": "구라요시 시",
      "esName": "Ciudad de Kurayoshi",
      "ptName": "cidade de Kurayoshi",
      "thName": "เมืองคุระโยชิ",
      "viName": "thành phố Kurayoshi",
      "inName": "kota Kurayoshi",
      "tlName": "siyudad ng Kurayoshi",
      "moName": "Күраёоши хот",
      "buName": "ကူရာယိုရှိ မြို့",
      "khName": "ទីក្រុង គូរ៉ាយ៉ូស៊ី",
      "neName": "कुरायोसी सहर"
    }
  },
  "3120400": {
    "office": {
      "code": "310000",
      "name": "鳥取県",
      "enName": "Tottori",
      "officeName": "鳥取地方気象台",
      "chName": "鸟取县",
      "zhName": "鳥取縣",
      "koName": "돗토리현",
      "esName": "Prefectura de Tottori",
      "ptName": "Província de Tottori",
      "thName": "จังหวัดทตโตริ",
      "viName": "Tỉnh Tottori",
      "inName": "Prefektur Tottori",
      "tlName": "Tottori Prefecture",
      "moName": "Тоттори аймаг",
      "buName": "တော်တိုးရိ ပြည်နယ်",
      "khName": "ខេត្ដ តូតូរី",
      "neName": "तोत्तोरी जिल्ला"
    },
    "class10": {
      "code": "310020",
      "name": "中・西部",
      "enName": "Central Western Region",
      "chName": "鸟取县中部",
      "zhName": "鳥取縣中部",
      "koName": "돗토리 현 중부",
      "esName": "Centro de Prefectura de Tottori",
      "ptName": "Região central da Província de Tottori",
      "thName": "จังหวัดทตโตริตอนกลาง",
      "viName": "Miền Trung tỉnh Tottori",
      "inName": "Bagian Tengah Prefektur Tottori",
      "tlName": "Sentral na bahagi ng Tottori Prefecture",
      "moName": "Төв Тоттори аймаг",
      "buName": "တို့တိုယိစီရင်စု အလယ်ပိုင်း",
      "khName": "តំបន់កណ្តាលនៃខេត្ដតុតតូរី",
      "neName": "तोत्तोरी जिल्लाको मध्य भाग"
    },
    "class15": {
      "code": "310022",
      "name": "米子地区",
      "enName": "Yonago District"
    },
    "class20": {
      "code": "3120400",
      "name": "境港市",
      "enName": "Sakaiminato City",
      "kana": "さかいみなとし",
      "chName": "境港市",
      "zhName": "境港市",
      "koName": "사카이미나토 시",
      "esName": "Ciudad de Sakaiminato",
      "ptName": "cidade de Sakaiminato",
      "thName": "เมืองซากาอิมินาโตะ",
      "viName": "thành phố Sakaiminato",
      "inName": "kota Sakaiminato",
      "tlName": "siyudad ng Sakaiminato",
      "moName": "Сакайминато хот",
      "buName": "ဆာကာယိမီနားတို မြို့",
      "khName": "ទីក្រុង ​ សាកៃមីណាតូ",
      "neName": "साकाइमिनातो सहर"
    }
  },
  "3130200": {
    "office": {
      "code": "310000",
      "name": "鳥取県",
      "enName": "Tottori",
      "officeName": "鳥取地方気象台",
      "chName": "鸟取县",
      "zhName": "鳥取縣",
      "koName": "돗토리현",
      "esName": "Prefectura de Tottori",
      "ptName": "Província de Tottori",
      "thName": "จังหวัดทตโตริ",
      "viName": "Tỉnh Tottori",
      "inName": "Prefektur Tottori",
      "tlName": "Tottori Prefecture",
      "moName": "Тоттори аймаг",
      "buName": "တော်တိုးရိ ပြည်နယ်",
      "khName": "ខេត្ដ តូតូរី",
      "neName": "तोत्तोरी जिल्ला"
    },
    "class10": {
      "code": "310010",
      "name": "東部",
      "enName": "Eastern Region",
      "chName": "鸟取县东部",
      "zhName": "鳥取縣東部",
      "koName": "돗토리 현 동부",
      "esName": "Este de Prefectura de Tottori",
      "ptName": "Leste da Província de Tottori",
      "thName": "จังหวัดทตโตริฟากตะวันออก",
      "viName": "Miền Đông tỉnh Tottori",
      "inName": "Bagian Timur Prefektur Tottori",
      "tlName": "Silangang bahagi ng Tottori Prefecture",
      "moName": "Зүүн Тоттори аймаг",
      "buName": "တို့တိုယိစီရင်စု အရှေ့ပိုင်း",
      "khName": "តំបន់ខាងកើតនៃខេត្ដតុតតូរី",
      "neName": "तोत्तोरी जिल्लाको पूर्वी भाग"
    },
    "class15": {
      "code": "310011",
      "name": "鳥取地区",
      "enName": "Tottori District"
    },
    "class20": {
      "code": "3130200",
      "name": "岩美町",
      "enName": "Iwami Town",
      "kana": "いわみちょう",
      "chName": "岩美町",
      "zhName": "岩美町",
      "koName": "이와미 정",
      "esName": "Pueblo de Iwami",
      "ptName": "bairro de Iwami",
      "thName": "เมืองอิวามิ",
      "viName": "thị trấn Iwami",
      "inName": "kota Iwami",
      "tlName": "bayan ng Iwami",
      "moName": "Ивами жижиг хот",
      "buName": "အီဝါ့မိ မြို့နယ်",
      "khName": "ទីប្រជុំជន អ៊ីវ៉ាមី",
      "neName": "इवामी नगर"
    }
  },
  "3132500": {
    "office": {
      "code": "310000",
      "name": "鳥取県",
      "enName": "Tottori",
      "officeName": "鳥取地方気象台",
      "chName": "鸟取县",
      "zhName": "鳥取縣",
      "koName": "돗토리현",
      "esName": "Prefectura de Tottori",
      "ptName": "Província de Tottori",
      "thName": "จังหวัดทตโตริ",
      "viName": "Tỉnh Tottori",
      "inName": "Prefektur Tottori",
      "tlName": "Tottori Prefecture",
      "moName": "Тоттори аймаг",
      "buName": "တော်တိုးရိ ပြည်နယ်",
      "khName": "ខេត្ដ តូតូរី",
      "neName": "तोत्तोरी जिल्ला"
    },
    "class10": {
      "code": "310010",
      "name": "東部",
      "enName": "Eastern Region",
      "chName": "鸟取县东部",
      "zhName": "鳥取縣東部",
      "koName": "돗토리 현 동부",
      "esName": "Este de Prefectura de Tottori",
      "ptName": "Leste da Província de Tottori",
      "thName": "จังหวัดทตโตริฟากตะวันออก",
      "viName": "Miền Đông tỉnh Tottori",
      "inName": "Bagian Timur Prefektur Tottori",
      "tlName": "Silangang bahagi ng Tottori Prefecture",
      "moName": "Зүүн Тоттори аймаг",
      "buName": "တို့တိုယိစီရင်စု အရှေ့ပိုင်း",
      "khName": "តំបន់ខាងកើតនៃខេត្ដតុតតូរី",
      "neName": "तोत्तोरी जिल्लाको पूर्वी भाग"
    },
    "class15": {
      "code": "310012",
      "name": "八頭地区",
      "enName": "Yazu District"
    },
    "class20": {
      "code": "3132500",
      "name": "若桜町",
      "enName": "Wakasa Town",
      "kana": "わかさちょう",
      "chName": "鸟取若樱町",
      "zhName": "鳥取若櫻町",
      "koName": "돗토리 와카사 정",
      "esName": "Pueblo de Wakasa, Tottori",
      "ptName": "Tottori, bairro de Wakasa",
      "thName": "เมืองวาคาสะ ทตโตริ",
      "viName": "Thị trấn Wakasa, Tottori",
      "inName": "Kota Wakasa, Tottori",
      "tlName": "bayan ng Wakasa, Tottori",
      "moName": "Тоттори Вакаса жижиг хот",
      "buName": "တို့တို့ယိဝကဆမြို့နယ်",
      "khName": "ទីប្រជុំជនវ៉ាកាសា តុតតូរី",
      "neName": "तोत्तोरी वाकासा नगर"
    }
  },
  "3132800": {
    "office": {
      "code": "310000",
      "name": "鳥取県",
      "enName": "Tottori",
      "officeName": "鳥取地方気象台",
      "chName": "鸟取县",
      "zhName": "鳥取縣",
      "koName": "돗토리현",
      "esName": "Prefectura de Tottori",
      "ptName": "Província de Tottori",
      "thName": "จังหวัดทตโตริ",
      "viName": "Tỉnh Tottori",
      "inName": "Prefektur Tottori",
      "tlName": "Tottori Prefecture",
      "moName": "Тоттори аймаг",
      "buName": "တော်တိုးရိ ပြည်နယ်",
      "khName": "ខេត្ដ តូតូរី",
      "neName": "तोत्तोरी जिल्ला"
    },
    "class10": {
      "code": "310010",
      "name": "東部",
      "enName": "Eastern Region",
      "chName": "鸟取县东部",
      "zhName": "鳥取縣東部",
      "koName": "돗토리 현 동부",
      "esName": "Este de Prefectura de Tottori",
      "ptName": "Leste da Província de Tottori",
      "thName": "จังหวัดทตโตริฟากตะวันออก",
      "viName": "Miền Đông tỉnh Tottori",
      "inName": "Bagian Timur Prefektur Tottori",
      "tlName": "Silangang bahagi ng Tottori Prefecture",
      "moName": "Зүүн Тоттори аймаг",
      "buName": "တို့တိုယိစီရင်စု အရှေ့ပိုင်း",
      "khName": "តំបន់ខាងកើតនៃខេត្ដតុតតូរី",
      "neName": "तोत्तोरी जिल्लाको पूर्वी भाग"
    },
    "class15": {
      "code": "310012",
      "name": "八頭地区",
      "enName": "Yazu District"
    },
    "class20": {
      "code": "3132800",
      "name": "智頭町",
      "enName": "Chizu Town",
      "kana": "ちづちょう",
      "chName": "智头町",
      "zhName": "智頭町",
      "koName": "지즈 정",
      "esName": "Pueblo de Chizu",
      "ptName": "bairro de Chizu",
      "thName": "เมืองจิซุ",
      "viName": "thị trấn Chizu",
      "inName": "kota Chizu",
      "tlName": "bayan ng Chizu",
      "moName": "Чизү жижиг хот",
      "buName": "ကျိဇု မြို့နယ်",
      "khName": "ទីប្រជុំជន ឈីហ្ស៊ូ",
      "neName": "चिजु नगर"
    }
  },
  "3132900": {
    "office": {
      "code": "310000",
      "name": "鳥取県",
      "enName": "Tottori",
      "officeName": "鳥取地方気象台",
      "chName": "鸟取县",
      "zhName": "鳥取縣",
      "koName": "돗토리현",
      "esName": "Prefectura de Tottori",
      "ptName": "Província de Tottori",
      "thName": "จังหวัดทตโตริ",
      "viName": "Tỉnh Tottori",
      "inName": "Prefektur Tottori",
      "tlName": "Tottori Prefecture",
      "moName": "Тоттори аймаг",
      "buName": "တော်တိုးရိ ပြည်နယ်",
      "khName": "ខេត្ដ តូតូរី",
      "neName": "तोत्तोरी जिल्ला"
    },
    "class10": {
      "code": "310010",
      "name": "東部",
      "enName": "Eastern Region",
      "chName": "鸟取县东部",
      "zhName": "鳥取縣東部",
      "koName": "돗토리 현 동부",
      "esName": "Este de Prefectura de Tottori",
      "ptName": "Leste da Província de Tottori",
      "thName": "จังหวัดทตโตริฟากตะวันออก",
      "viName": "Miền Đông tỉnh Tottori",
      "inName": "Bagian Timur Prefektur Tottori",
      "tlName": "Silangang bahagi ng Tottori Prefecture",
      "moName": "Зүүн Тоттори аймаг",
      "buName": "တို့တိုယိစီရင်စု အရှေ့ပိုင်း",
      "khName": "តំបន់ខាងកើតនៃខេត្ដតុតតូរី",
      "neName": "तोत्तोरी जिल्लाको पूर्वी भाग"
    },
    "class15": {
      "code": "310012",
      "name": "八頭地区",
      "enName": "Yazu District"
    },
    "class20": {
      "code": "3132900",
      "name": "八頭町",
      "enName": "Yazu Town",
      "kana": "やずちょう",
      "chName": "八头町",
      "zhName": "八頭町",
      "koName": "야즈 정",
      "esName": "Pueblo de Yazu",
      "ptName": "bairro de Yazu",
      "thName": "เมืองยาสุ",
      "viName": "thị trấn Yemo",
      "inName": "kota Yazu",
      "tlName": "bayan ng Yazu",
      "moName": "Язү жижиг хот",
      "buName": "ယာ့ဇု မြို့နယ်",
      "khName": "ទីប្រជុំជន យ៉ាហ្សូ",
      "neName": "याजु नगर"
    }
  },
  "3136400": {
    "office": {
      "code": "310000",
      "name": "鳥取県",
      "enName": "Tottori",
      "officeName": "鳥取地方気象台",
      "chName": "鸟取县",
      "zhName": "鳥取縣",
      "koName": "돗토리현",
      "esName": "Prefectura de Tottori",
      "ptName": "Província de Tottori",
      "thName": "จังหวัดทตโตริ",
      "viName": "Tỉnh Tottori",
      "inName": "Prefektur Tottori",
      "tlName": "Tottori Prefecture",
      "moName": "Тоттори аймаг",
      "buName": "တော်တိုးရိ ပြည်နယ်",
      "khName": "ខេត្ដ តូតូរី",
      "neName": "तोत्तोरी जिल्ला"
    },
    "class10": {
      "code": "310020",
      "name": "中・西部",
      "enName": "Central Western Region",
      "chName": "鸟取县中部",
      "zhName": "鳥取縣中部",
      "koName": "돗토리 현 중부",
      "esName": "Centro de Prefectura de Tottori",
      "ptName": "Região central da Província de Tottori",
      "thName": "จังหวัดทตโตริตอนกลาง",
      "viName": "Miền Trung tỉnh Tottori",
      "inName": "Bagian Tengah Prefektur Tottori",
      "tlName": "Sentral na bahagi ng Tottori Prefecture",
      "moName": "Төв Тоттори аймаг",
      "buName": "တို့တိုယိစီရင်စု အလယ်ပိုင်း",
      "khName": "តំបន់កណ្តាលនៃខេត្ដតុតតូរី",
      "neName": "तोत्तोरी जिल्लाको मध्य भाग"
    },
    "class15": {
      "code": "310021",
      "name": "倉吉地区",
      "enName": "Kurayoshi District"
    },
    "class20": {
      "code": "3136400",
      "name": "三朝町",
      "enName": "Misasa Town",
      "kana": "みささちょう",
      "chName": "三朝町",
      "zhName": "三朝町",
      "koName": "미사사 정",
      "esName": "Pueblo de Misasa",
      "ptName": "bairro de Misasa",
      "thName": "เมืองมิสะสะ",
      "viName": "thị trấn Misasa",
      "inName": "kota Misasa",
      "tlName": "bayan ng Misasa",
      "moName": "Мисaсa жижиг хот",
      "buName": "မီဆားဆ မြို့နယ်",
      "khName": "ទីប្រជុំជន មីសាសា",
      "neName": "मिसासा नगर"
    }
  },
  "3137000": {
    "office": {
      "code": "310000",
      "name": "鳥取県",
      "enName": "Tottori",
      "officeName": "鳥取地方気象台",
      "chName": "鸟取县",
      "zhName": "鳥取縣",
      "koName": "돗토리현",
      "esName": "Prefectura de Tottori",
      "ptName": "Província de Tottori",
      "thName": "จังหวัดทตโตริ",
      "viName": "Tỉnh Tottori",
      "inName": "Prefektur Tottori",
      "tlName": "Tottori Prefecture",
      "moName": "Тоттори аймаг",
      "buName": "တော်တိုးရိ ပြည်နယ်",
      "khName": "ខេត្ដ តូតូរី",
      "neName": "तोत्तोरी जिल्ला"
    },
    "class10": {
      "code": "310020",
      "name": "中・西部",
      "enName": "Central Western Region",
      "chName": "鸟取县中部",
      "zhName": "鳥取縣中部",
      "koName": "돗토리 현 중부",
      "esName": "Centro de Prefectura de Tottori",
      "ptName": "Região central da Província de Tottori",
      "thName": "จังหวัดทตโตริตอนกลาง",
      "viName": "Miền Trung tỉnh Tottori",
      "inName": "Bagian Tengah Prefektur Tottori",
      "tlName": "Sentral na bahagi ng Tottori Prefecture",
      "moName": "Төв Тоттори аймаг",
      "buName": "တို့တိုယိစီရင်စု အလယ်ပိုင်း",
      "khName": "តំបន់កណ្តាលនៃខេត្ដតុតតូរី",
      "neName": "तोत्तोरी जिल्लाको मध्य भाग"
    },
    "class15": {
      "code": "310021",
      "name": "倉吉地区",
      "enName": "Kurayoshi District"
    },
    "class20": {
      "code": "3137000",
      "name": "湯梨浜町",
      "enName": "Yurihama Town",
      "kana": "ゆりはまちょう",
      "chName": "汤梨滨町",
      "zhName": "湯梨濱町",
      "koName": "유리하마 정",
      "esName": "Pueblo de Yurihama",
      "ptName": "bairro de Yurihama",
      "thName": "เมืองยูริฮามะ",
      "viName": "thị trấn Yurihama",
      "inName": "kota Yurihama",
      "tlName": "bayan ng Yurihama",
      "moName": "Юрихама жижиг хот",
      "buName": "ယူးရိဟာ့မ မြို့နယ်",
      "khName": "ទីប្រជុំជន យូរីហាម៉ា",
      "neName": "युरिहामा नगर"
    }
  },
  "3137100": {
    "office": {
      "code": "310000",
      "name": "鳥取県",
      "enName": "Tottori",
      "officeName": "鳥取地方気象台",
      "chName": "鸟取县",
      "zhName": "鳥取縣",
      "koName": "돗토리현",
      "esName": "Prefectura de Tottori",
      "ptName": "Província de Tottori",
      "thName": "จังหวัดทตโตริ",
      "viName": "Tỉnh Tottori",
      "inName": "Prefektur Tottori",
      "tlName": "Tottori Prefecture",
      "moName": "Тоттори аймаг",
      "buName": "တော်တိုးရိ ပြည်နယ်",
      "khName": "ខេត្ដ តូតូរី",
      "neName": "तोत्तोरी जिल्ला"
    },
    "class10": {
      "code": "310020",
      "name": "中・西部",
      "enName": "Central Western Region",
      "chName": "鸟取县中部",
      "zhName": "鳥取縣中部",
      "koName": "돗토리 현 중부",
      "esName": "Centro de Prefectura de Tottori",
      "ptName": "Região central da Província de Tottori",
      "thName": "จังหวัดทตโตริตอนกลาง",
      "viName": "Miền Trung tỉnh Tottori",
      "inName": "Bagian Tengah Prefektur Tottori",
      "tlName": "Sentral na bahagi ng Tottori Prefecture",
      "moName": "Төв Тоттори аймаг",
      "buName": "တို့တိုယိစီရင်စု အလယ်ပိုင်း",
      "khName": "តំបន់កណ្តាលនៃខេត្ដតុតតូរី",
      "neName": "तोत्तोरी जिल्लाको मध्य भाग"
    },
    "class15": {
      "code": "310021",
      "name": "倉吉地区",
      "enName": "Kurayoshi District"
    },
    "class20": {
      "code": "3137100",
      "name": "琴浦町",
      "enName": "Kotoura Town",
      "kana": "ことうらちょう",
      "chName": "琴浦町",
      "zhName": "琴浦町",
      "koName": "고토우라 정",
      "esName": "Pueblo de Kotoura",
      "ptName": "bairro de Kotoura",
      "thName": "เมืองคุโตอุระ",
      "viName": "thị trấn Kotoura",
      "inName": "kota Kotoura",
      "tlName": "bayan ng Kotoura",
      "moName": "Котоүра жижиг хот",
      "buName": "ခိုတိုးဥရာ့ မြို့နယ်",
      "khName": "ទីប្រជុំជន កូតូរ៉ា",
      "neName": "कोतोउरा नगर"
    }
  },
  "3137200": {
    "office": {
      "code": "310000",
      "name": "鳥取県",
      "enName": "Tottori",
      "officeName": "鳥取地方気象台",
      "chName": "鸟取县",
      "zhName": "鳥取縣",
      "koName": "돗토리현",
      "esName": "Prefectura de Tottori",
      "ptName": "Província de Tottori",
      "thName": "จังหวัดทตโตริ",
      "viName": "Tỉnh Tottori",
      "inName": "Prefektur Tottori",
      "tlName": "Tottori Prefecture",
      "moName": "Тоттори аймаг",
      "buName": "တော်တိုးရိ ပြည်နယ်",
      "khName": "ខេត្ដ តូតូរី",
      "neName": "तोत्तोरी जिल्ला"
    },
    "class10": {
      "code": "310020",
      "name": "中・西部",
      "enName": "Central Western Region",
      "chName": "鸟取县中部",
      "zhName": "鳥取縣中部",
      "koName": "돗토리 현 중부",
      "esName": "Centro de Prefectura de Tottori",
      "ptName": "Região central da Província de Tottori",
      "thName": "จังหวัดทตโตริตอนกลาง",
      "viName": "Miền Trung tỉnh Tottori",
      "inName": "Bagian Tengah Prefektur Tottori",
      "tlName": "Sentral na bahagi ng Tottori Prefecture",
      "moName": "Төв Тоттори аймаг",
      "buName": "တို့တိုယိစီရင်စု အလယ်ပိုင်း",
      "khName": "តំបន់កណ្តាលនៃខេត្ដតុតតូរី",
      "neName": "तोत्तोरी जिल्लाको मध्य भाग"
    },
    "class15": {
      "code": "310021",
      "name": "倉吉地区",
      "enName": "Kurayoshi District"
    },
    "class20": {
      "code": "3137200",
      "name": "北栄町",
      "enName": "Hokuei Town",
      "kana": "ほくえいちょう",
      "chName": "北荣町",
      "zhName": "北榮町",
      "koName": "호쿠에이 정",
      "esName": "Pueblo de Hokuei",
      "ptName": "bairro de Hokuei",
      "thName": "เมืองโฮขุเอะ",
      "viName": "thị trấn Hokuei",
      "inName": "kota Hokuei",
      "tlName": "bayan ng Hokuei",
      "moName": "Хокүэй жижиг хот",
      "buName": "ဟိုကုယဲ့ မြို့နယ်",
      "khName": "ទីប្រជុំជន ហុកកូអេ",
      "neName": "होकुएइ नगर"
    }
  },
  "3138400": {
    "office": {
      "code": "310000",
      "name": "鳥取県",
      "enName": "Tottori",
      "officeName": "鳥取地方気象台",
      "chName": "鸟取县",
      "zhName": "鳥取縣",
      "koName": "돗토리현",
      "esName": "Prefectura de Tottori",
      "ptName": "Província de Tottori",
      "thName": "จังหวัดทตโตริ",
      "viName": "Tỉnh Tottori",
      "inName": "Prefektur Tottori",
      "tlName": "Tottori Prefecture",
      "moName": "Тоттори аймаг",
      "buName": "တော်တိုးရိ ပြည်နယ်",
      "khName": "ខេត្ដ តូតូរី",
      "neName": "तोत्तोरी जिल्ला"
    },
    "class10": {
      "code": "310020",
      "name": "中・西部",
      "enName": "Central Western Region",
      "chName": "鸟取县中部",
      "zhName": "鳥取縣中部",
      "koName": "돗토리 현 중부",
      "esName": "Centro de Prefectura de Tottori",
      "ptName": "Região central da Província de Tottori",
      "thName": "จังหวัดทตโตริตอนกลาง",
      "viName": "Miền Trung tỉnh Tottori",
      "inName": "Bagian Tengah Prefektur Tottori",
      "tlName": "Sentral na bahagi ng Tottori Prefecture",
      "moName": "Төв Тоттори аймаг",
      "buName": "တို့တိုယိစီရင်စု အလယ်ပိုင်း",
      "khName": "តំបន់កណ្តាលនៃខេត្ដតុតតូរី",
      "neName": "तोत्तोरी जिल्लाको मध्य भाग"
    },
    "class15": {
      "code": "310022",
      "name": "米子地区",
      "enName": "Yonago District"
    },
    "class20": {
      "code": "3138400",
      "name": "日吉津村",
      "enName": "Hiezu Village",
      "kana": "ひえづそん",
      "chName": "日吉津村",
      "zhName": "日吉津村",
      "koName": "히에즈 촌",
      "esName": "Aldea de Hiezu",
      "ptName": "povoado de Hiezu",
      "thName": "หมู่บ้านฮิเอะสุ",
      "viName": "làng Hiezu",
      "inName": "desa Hiezu",
      "tlName": "nayon ng Hiezu",
      "moName": "Хиэзү тосгон",
      "buName": "ဟီအဲဇု ကျေးရွာ",
      "khName": "ភូមិ ហ៊ីហ្ស៊ូ",
      "neName": "हिएजु गाउँ"
    }
  },
  "3138600": {
    "office": {
      "code": "310000",
      "name": "鳥取県",
      "enName": "Tottori",
      "officeName": "鳥取地方気象台",
      "chName": "鸟取县",
      "zhName": "鳥取縣",
      "koName": "돗토리현",
      "esName": "Prefectura de Tottori",
      "ptName": "Província de Tottori",
      "thName": "จังหวัดทตโตริ",
      "viName": "Tỉnh Tottori",
      "inName": "Prefektur Tottori",
      "tlName": "Tottori Prefecture",
      "moName": "Тоттори аймаг",
      "buName": "တော်တိုးရိ ပြည်နယ်",
      "khName": "ខេត្ដ តូតូរី",
      "neName": "तोत्तोरी जिल्ला"
    },
    "class10": {
      "code": "310020",
      "name": "中・西部",
      "enName": "Central Western Region",
      "chName": "鸟取县中部",
      "zhName": "鳥取縣中部",
      "koName": "돗토리 현 중부",
      "esName": "Centro de Prefectura de Tottori",
      "ptName": "Região central da Província de Tottori",
      "thName": "จังหวัดทตโตริตอนกลาง",
      "viName": "Miền Trung tỉnh Tottori",
      "inName": "Bagian Tengah Prefektur Tottori",
      "tlName": "Sentral na bahagi ng Tottori Prefecture",
      "moName": "Төв Тоттори аймаг",
      "buName": "တို့တိုယိစီရင်စု အလယ်ပိုင်း",
      "khName": "តំបន់កណ្តាលនៃខេត្ដតុតតូរី",
      "neName": "तोत्तोरी जिल्लाको मध्य भाग"
    },
    "class15": {
      "code": "310022",
      "name": "米子地区",
      "enName": "Yonago District"
    },
    "class20": {
      "code": "3138600",
      "name": "大山町",
      "enName": "Daisen Town",
      "kana": "だいせんちょう",
      "chName": "大山町",
      "zhName": "大山町",
      "koName": "다이센 정",
      "esName": "Pueblo de Daisen",
      "ptName": "bairro de Daisen",
      "thName": "เมืองไดเซน",
      "viName": "thị trấn Daisen",
      "inName": "kota Daisen",
      "tlName": "bayan ng Daisen",
      "moName": "Дайсэн жижиг хот",
      "buName": "ဒိုင်ယိဆန် မြို့နယ်",
      "khName": "ទីប្រជុំជន ដាយសេន",
      "neName": "दाइसेन नगर"
    }
  },
  "3138900": {
    "office": {
      "code": "310000",
      "name": "鳥取県",
      "enName": "Tottori",
      "officeName": "鳥取地方気象台",
      "chName": "鸟取县",
      "zhName": "鳥取縣",
      "koName": "돗토리현",
      "esName": "Prefectura de Tottori",
      "ptName": "Província de Tottori",
      "thName": "จังหวัดทตโตริ",
      "viName": "Tỉnh Tottori",
      "inName": "Prefektur Tottori",
      "tlName": "Tottori Prefecture",
      "moName": "Тоттори аймаг",
      "buName": "တော်တိုးရိ ပြည်နယ်",
      "khName": "ខេត្ដ តូតូរី",
      "neName": "तोत्तोरी जिल्ला"
    },
    "class10": {
      "code": "310020",
      "name": "中・西部",
      "enName": "Central Western Region",
      "chName": "鸟取县中部",
      "zhName": "鳥取縣中部",
      "koName": "돗토리 현 중부",
      "esName": "Centro de Prefectura de Tottori",
      "ptName": "Região central da Província de Tottori",
      "thName": "จังหวัดทตโตริตอนกลาง",
      "viName": "Miền Trung tỉnh Tottori",
      "inName": "Bagian Tengah Prefektur Tottori",
      "tlName": "Sentral na bahagi ng Tottori Prefecture",
      "moName": "Төв Тоттори аймаг",
      "buName": "တို့တိုယိစီရင်စု အလယ်ပိုင်း",
      "khName": "តំបន់កណ្តាលនៃខេត្ដតុតតូរី",
      "neName": "तोत्तोरी जिल्लाको मध्य भाग"
    },
    "class15": {
      "code": "310022",
      "name": "米子地区",
      "enName": "Yonago District"
    },
    "class20": {
      "code": "3138900",
      "name": "南部町",
      "enName": "Nambu Town",
      "kana": "なんぶちょう",
      "chName": "鸟取南部町",
      "zhName": "鳥取南部町",
      "koName": "돗토리 난부 정",
      "esName": "Pueblo de Nambu, Tottori",
      "ptName": "Tottori, bairro de Nambu",
      "thName": "เมืองนัมบุ ทตโตริ",
      "viName": "Thị trấn Nambu, Tottori",
      "inName": "Kota Nambu, Tottori",
      "tlName": "bayan ng Nanbu, Tottori",
      "moName": "Тоттори Нанбү жижиг хот",
      "buName": "တို့တို့ယိနန်းဘုမြို့နယ်",
      "khName": "ទីប្រជុំជនណាំប៊ូ តុតតូរី",
      "neName": "तोत्तोरी नाम्बु नगर"
    }
  },
  "3139000": {
    "office": {
      "code": "310000",
      "name": "鳥取県",
      "enName": "Tottori",
      "officeName": "鳥取地方気象台",
      "chName": "鸟取县",
      "zhName": "鳥取縣",
      "koName": "돗토리현",
      "esName": "Prefectura de Tottori",
      "ptName": "Província de Tottori",
      "thName": "จังหวัดทตโตริ",
      "viName": "Tỉnh Tottori",
      "inName": "Prefektur Tottori",
      "tlName": "Tottori Prefecture",
      "moName": "Тоттори аймаг",
      "buName": "တော်တိုးရိ ပြည်နယ်",
      "khName": "ខេត្ដ តូតូរី",
      "neName": "तोत्तोरी जिल्ला"
    },
    "class10": {
      "code": "310020",
      "name": "中・西部",
      "enName": "Central Western Region",
      "chName": "鸟取县中部",
      "zhName": "鳥取縣中部",
      "koName": "돗토리 현 중부",
      "esName": "Centro de Prefectura de Tottori",
      "ptName": "Região central da Província de Tottori",
      "thName": "จังหวัดทตโตริตอนกลาง",
      "viName": "Miền Trung tỉnh Tottori",
      "inName": "Bagian Tengah Prefektur Tottori",
      "tlName": "Sentral na bahagi ng Tottori Prefecture",
      "moName": "Төв Тоттори аймаг",
      "buName": "တို့တိုယိစီရင်စု အလယ်ပိုင်း",
      "khName": "តំបន់កណ្តាលនៃខេត្ដតុតតូរី",
      "neName": "तोत्तोरी जिल्लाको मध्य भाग"
    },
    "class15": {
      "code": "310022",
      "name": "米子地区",
      "enName": "Yonago District"
    },
    "class20": {
      "code": "3139000",
      "name": "伯耆町",
      "enName": "Hoki Town",
      "kana": "ほうきちょう",
      "chName": "伯耆町",
      "zhName": "伯耆町",
      "koName": "호키 정",
      "esName": "Pueblo de Hoki",
      "ptName": "bairro de Hoki",
      "thName": "เมืองโฮกิ",
      "viName": "thị trấn Hoki",
      "inName": "kota Hoki",
      "tlName": "bayan ng Hoki",
      "moName": "Хоки жижиг хот",
      "buName": "ဟိုကိ မြို့နယ်",
      "khName": "ទីប្រជុំជន ហូគី",
      "neName": "होकी नगर"
    }
  },
  "3140100": {
    "office": {
      "code": "310000",
      "name": "鳥取県",
      "enName": "Tottori",
      "officeName": "鳥取地方気象台",
      "chName": "鸟取县",
      "zhName": "鳥取縣",
      "koName": "돗토리현",
      "esName": "Prefectura de Tottori",
      "ptName": "Província de Tottori",
      "thName": "จังหวัดทตโตริ",
      "viName": "Tỉnh Tottori",
      "inName": "Prefektur Tottori",
      "tlName": "Tottori Prefecture",
      "moName": "Тоттори аймаг",
      "buName": "တော်တိုးရိ ပြည်နယ်",
      "khName": "ខេត្ដ តូតូរី",
      "neName": "तोत्तोरी जिल्ला"
    },
    "class10": {
      "code": "310020",
      "name": "中・西部",
      "enName": "Central Western Region",
      "chName": "鸟取县中部",
      "zhName": "鳥取縣中部",
      "koName": "돗토리 현 중부",
      "esName": "Centro de Prefectura de Tottori",
      "ptName": "Região central da Província de Tottori",
      "thName": "จังหวัดทตโตริตอนกลาง",
      "viName": "Miền Trung tỉnh Tottori",
      "inName": "Bagian Tengah Prefektur Tottori",
      "tlName": "Sentral na bahagi ng Tottori Prefecture",
      "moName": "Төв Тоттори аймаг",
      "buName": "တို့တိုယိစီရင်စု အလယ်ပိုင်း",
      "khName": "តំបន់កណ្តាលនៃខេត្ដតុតតូរី",
      "neName": "तोत्तोरी जिल्लाको मध्य भाग"
    },
    "class15": {
      "code": "310023",
      "name": "日野地区",
      "enName": "Hino District"
    },
    "class20": {
      "code": "3140100",
      "name": "日南町",
      "enName": "Nichinan Town",
      "kana": "にちなんちょう",
      "chName": "日南町",
      "zhName": "日南町",
      "koName": "니치난 정",
      "esName": "Pueblo de Nichinan",
      "ptName": "bairro de Nichinan",
      "thName": "เมืองนิจินัน",
      "viName": "thị trấn Nichinan",
      "inName": "kota Nichinan",
      "tlName": "bayan ng Nichinan",
      "moName": "Ничинaн жижиг хот",
      "buName": "နီကျိနန် မြို့နယ်",
      "khName": "ទីប្រជុំជន នីឈីណាន",
      "neName": "निचिनान नगर"
    }
  },
  "3140200": {
    "office": {
      "code": "310000",
      "name": "鳥取県",
      "enName": "Tottori",
      "officeName": "鳥取地方気象台",
      "chName": "鸟取县",
      "zhName": "鳥取縣",
      "koName": "돗토리현",
      "esName": "Prefectura de Tottori",
      "ptName": "Província de Tottori",
      "thName": "จังหวัดทตโตริ",
      "viName": "Tỉnh Tottori",
      "inName": "Prefektur Tottori",
      "tlName": "Tottori Prefecture",
      "moName": "Тоттори аймаг",
      "buName": "တော်တိုးရိ ပြည်နယ်",
      "khName": "ខេត្ដ តូតូរី",
      "neName": "तोत्तोरी जिल्ला"
    },
    "class10": {
      "code": "310020",
      "name": "中・西部",
      "enName": "Central Western Region",
      "chName": "鸟取县中部",
      "zhName": "鳥取縣中部",
      "koName": "돗토리 현 중부",
      "esName": "Centro de Prefectura de Tottori",
      "ptName": "Região central da Província de Tottori",
      "thName": "จังหวัดทตโตริตอนกลาง",
      "viName": "Miền Trung tỉnh Tottori",
      "inName": "Bagian Tengah Prefektur Tottori",
      "tlName": "Sentral na bahagi ng Tottori Prefecture",
      "moName": "Төв Тоттори аймаг",
      "buName": "တို့တိုယိစီရင်စု အလယ်ပိုင်း",
      "khName": "តំបន់កណ្តាលនៃខេត្ដតុតតូរី",
      "neName": "तोत्तोरी जिल्लाको मध्य भाग"
    },
    "class15": {
      "code": "310023",
      "name": "日野地区",
      "enName": "Hino District"
    },
    "class20": {
      "code": "3140200",
      "name": "日野町",
      "enName": "Hino Town",
      "kana": "ひのちょう",
      "chName": "鸟取日野町",
      "zhName": "鳥取日野町",
      "koName": "돗토리 히노 정",
      "esName": "Pueblo de Hino, Tottori",
      "ptName": "Tottori, bairro de Hino",
      "thName": "เมืองฮิโนะ ทตโตริ",
      "viName": "Thị trấn Hino, Tottori",
      "inName": "Kota Hino, Tottori",
      "tlName": "bayan ng Hino, Tottori",
      "moName": "Тоттори Хино жижиг хот",
      "buName": "တို့တို့ယိဟိနိုမြို့နယ်",
      "khName": "ទីប្រជុំជនហ៊ីណូ តុតតូរី",
      "neName": "तोत्तोरी हिनो नगर"
    }
  },
  "3140300": {
    "office": {
      "code": "310000",
      "name": "鳥取県",
      "enName": "Tottori",
      "officeName": "鳥取地方気象台",
      "chName": "鸟取县",
      "zhName": "鳥取縣",
      "koName": "돗토리현",
      "esName": "Prefectura de Tottori",
      "ptName": "Província de Tottori",
      "thName": "จังหวัดทตโตริ",
      "viName": "Tỉnh Tottori",
      "inName": "Prefektur Tottori",
      "tlName": "Tottori Prefecture",
      "moName": "Тоттори аймаг",
      "buName": "တော်တိုးရိ ပြည်နယ်",
      "khName": "ខេត្ដ តូតូរី",
      "neName": "तोत्तोरी जिल्ला"
    },
    "class10": {
      "code": "310020",
      "name": "中・西部",
      "enName": "Central Western Region",
      "chName": "鸟取县中部",
      "zhName": "鳥取縣中部",
      "koName": "돗토리 현 중부",
      "esName": "Centro de Prefectura de Tottori",
      "ptName": "Região central da Província de Tottori",
      "thName": "จังหวัดทตโตริตอนกลาง",
      "viName": "Miền Trung tỉnh Tottori",
      "inName": "Bagian Tengah Prefektur Tottori",
      "tlName": "Sentral na bahagi ng Tottori Prefecture",
      "moName": "Төв Тоттори аймаг",
      "buName": "တို့တိုယိစီရင်စု အလယ်ပိုင်း",
      "khName": "តំបន់កណ្តាលនៃខេត្ដតុតតូរី",
      "neName": "तोत्तोरी जिल्लाको मध्य भाग"
    },
    "class15": {
      "code": "310023",
      "name": "日野地区",
      "enName": "Hino District"
    },
    "class20": {
      "code": "3140300",
      "name": "江府町",
      "enName": "Kofu Town",
      "kana": "こうふちょう",
      "chName": "江府町",
      "zhName": "江府町",
      "koName": "고후 정",
      "esName": "Pueblo de Kōfu",
      "ptName": "bairro de Kofu",
      "thName": "เมืองโคฟุ",
      "viName": "thị trấn Kofu",
      "inName": "kota Kofu",
      "tlName": "bayan ng Kofu",
      "moName": "Кофү жижиг хот",
      "buName": "ခိုဟု မြို့နယ်",
      "khName": "ទីប្រជុំជន កូហ្វូ",
      "neName": "कोफु नगर"
    }
  },
  "3220100": {
    "office": {
      "code": "320000",
      "name": "島根県",
      "enName": "Shimane",
      "officeName": "松江地方気象台",
      "chName": "岛根县",
      "zhName": "島根縣",
      "koName": "시마네현",
      "esName": "Prefectura de Shimane",
      "ptName": "Província de Shimane",
      "thName": "จังหวัดชิมาเนะ",
      "viName": "Tỉnh Shimane",
      "inName": "Prefektur Shimane",
      "tlName": "Shimane Prefecture",
      "moName": "Шиманэ аймаг",
      "buName": "ရှီးမဏဲ့ ပြည်နယ်",
      "khName": "ខេត្ដ ស៊ីម៉ែន",
      "neName": "सिमाने जिल्ला"
    },
    "class10": {
      "code": "320010",
      "name": "東部",
      "enName": "Eastern Region",
      "chName": "岛根县东部",
      "zhName": "島根縣東部",
      "koName": "시마네 현 동부",
      "esName": "Este de Prefectura de Shimane",
      "ptName": "Leste da Província de Shimane",
      "thName": "จังหวัดชิมาเนะฟากตะวันออก",
      "viName": "Miền Đông tỉnh Shimane",
      "inName": "Bagian Timur Prefektur Shimane",
      "tlName": "Silangang bahagi ng Shimane Prefecture",
      "moName": "Зүүн Шиманэ  аймаг",
      "buName": "ရှိမနဲစီရင်စု အရှေ့ပိုင်း",
      "khName": "តំបន់ខាងកើតនៃខេត្ដស៊ីម៉ាណិ",
      "neName": "सिमाने जिल्लाको पूर्वी भाग"
    },
    "class15": {
      "code": "320011",
      "name": "松江地区",
      "enName": "Matsue District"
    },
    "class20": {
      "code": "3220100",
      "name": "松江市",
      "enName": "Matsue City",
      "kana": "まつえし",
      "chName": "松江市",
      "zhName": "松江市",
      "koName": "마쓰에 시",
      "esName": "Ciudad de Matsue",
      "ptName": "cidade de Matsue",
      "thName": "เมืองมัทสึเนะ",
      "viName": "thành phố Matsue",
      "inName": "kota Matsue",
      "tlName": "siyudad ng Matsue",
      "moName": "Мацүэ хот",
      "buName": "မာ့ဆုအဲ့ မြို့",
      "khName": "ទីក្រុង ម៉ាត់ស៊ូ",
      "neName": "मात्सुए सहर"
    }
  },
  "3220200": {
    "office": {
      "code": "320000",
      "name": "島根県",
      "enName": "Shimane",
      "officeName": "松江地方気象台",
      "chName": "岛根县",
      "zhName": "島根縣",
      "koName": "시마네현",
      "esName": "Prefectura de Shimane",
      "ptName": "Província de Shimane",
      "thName": "จังหวัดชิมาเนะ",
      "viName": "Tỉnh Shimane",
      "inName": "Prefektur Shimane",
      "tlName": "Shimane Prefecture",
      "moName": "Шиманэ аймаг",
      "buName": "ရှီးမဏဲ့ ပြည်နယ်",
      "khName": "ខេត្ដ ស៊ីម៉ែន",
      "neName": "सिमाने जिल्ला"
    },
    "class10": {
      "code": "320020",
      "name": "西部",
      "enName": "Western Region",
      "chName": "岛根县西部",
      "zhName": "島根縣西部",
      "koName": "시마네 현 서부",
      "esName": "Oeste de Prefectura de Shimane",
      "ptName": "Oeste da Província de Shimane",
      "thName": "จังหวัดชิมาเนะฟากตะวันตก",
      "viName": "Miền Tây tỉnh Shimane",
      "inName": "Bagian Barat Prefektur Shimane",
      "tlName": "Kanlurang bahagi ng Shimane Prefecture",
      "moName": "Баруун Шиманэ аймаг",
      "buName": "ရှိမနဲစီရင်စု အနောက်ပိုင်း",
      "khName": "តំបន់ខាងលិចនៃខេត្ដស៊ីម៉ាណ",
      "neName": "सिमाने जिल्लाको पश्चिमी भाग"
    },
    "class15": {
      "code": "320022",
      "name": "浜田地区",
      "enName": "Hamada District"
    },
    "class20": {
      "code": "3220200",
      "name": "浜田市",
      "enName": "Hamada City",
      "kana": "はまだし",
      "chName": "滨田市",
      "zhName": "濱田市",
      "koName": "하마다 시",
      "esName": "Ciudad de Hamada",
      "ptName": "cidade de Hamada",
      "thName": "เมืองฮามาดะ",
      "viName": "thành phố Hamada",
      "inName": "kota Hamada",
      "tlName": "siyudad ng Hamada",
      "moName": "Хaмaда хот",
      "buName": "ဟာမာ့ဒ မြို့",
      "khName": "ទីក្រុង ហាម៉ាដា",
      "neName": "हामादा सहर"
    }
  },
  "3220300": {
    "office": {
      "code": "320000",
      "name": "島根県",
      "enName": "Shimane",
      "officeName": "松江地方気象台",
      "chName": "岛根县",
      "zhName": "島根縣",
      "koName": "시마네현",
      "esName": "Prefectura de Shimane",
      "ptName": "Província de Shimane",
      "thName": "จังหวัดชิมาเนะ",
      "viName": "Tỉnh Shimane",
      "inName": "Prefektur Shimane",
      "tlName": "Shimane Prefecture",
      "moName": "Шиманэ аймаг",
      "buName": "ရှီးမဏဲ့ ပြည်နယ်",
      "khName": "ខេត្ដ ស៊ីម៉ែន",
      "neName": "सिमाने जिल्ला"
    },
    "class10": {
      "code": "320010",
      "name": "東部",
      "enName": "Eastern Region",
      "chName": "岛根县东部",
      "zhName": "島根縣東部",
      "koName": "시마네 현 동부",
      "esName": "Este de Prefectura de Shimane",
      "ptName": "Leste da Província de Shimane",
      "thName": "จังหวัดชิมาเนะฟากตะวันออก",
      "viName": "Miền Đông tỉnh Shimane",
      "inName": "Bagian Timur Prefektur Shimane",
      "tlName": "Silangang bahagi ng Shimane Prefecture",
      "moName": "Зүүн Шиманэ  аймаг",
      "buName": "ရှိမနဲစီရင်စု အရှေ့ပိုင်း",
      "khName": "តំបន់ខាងកើតនៃខេត្ដស៊ីម៉ាណិ",
      "neName": "सिमाने जिल्लाको पूर्वी भाग"
    },
    "class15": {
      "code": "320012",
      "name": "出雲地区",
      "enName": "Izumo District"
    },
    "class20": {
      "code": "3220300",
      "name": "出雲市",
      "enName": "Izumo City",
      "kana": "いずもし",
      "chName": "出云市",
      "zhName": "出雲市",
      "koName": "이즈모 시",
      "esName": "Ciudad de Izumo",
      "ptName": "cidade de Izumo",
      "thName": "เมืองอิสุโมะ",
      "viName": "thành phố Izumo",
      "inName": "kota Izumo",
      "tlName": "siyudad ng Izumo",
      "moName": "Изүмо хот",
      "buName": "အီဇုမို မြို့",
      "khName": "ទីក្រុង អ៊ីហ្សូម៉ូ",
      "neName": "इजुमो सहर"
    }
  },
  "3220400": {
    "office": {
      "code": "320000",
      "name": "島根県",
      "enName": "Shimane",
      "officeName": "松江地方気象台",
      "chName": "岛根县",
      "zhName": "島根縣",
      "koName": "시마네현",
      "esName": "Prefectura de Shimane",
      "ptName": "Província de Shimane",
      "thName": "จังหวัดชิมาเนะ",
      "viName": "Tỉnh Shimane",
      "inName": "Prefektur Shimane",
      "tlName": "Shimane Prefecture",
      "moName": "Шиманэ аймаг",
      "buName": "ရှီးမဏဲ့ ပြည်နယ်",
      "khName": "ខេត្ដ ស៊ីម៉ែន",
      "neName": "सिमाने जिल्ला"
    },
    "class10": {
      "code": "320020",
      "name": "西部",
      "enName": "Western Region",
      "chName": "岛根县西部",
      "zhName": "島根縣西部",
      "koName": "시마네 현 서부",
      "esName": "Oeste de Prefectura de Shimane",
      "ptName": "Oeste da Província de Shimane",
      "thName": "จังหวัดชิมาเนะฟากตะวันตก",
      "viName": "Miền Tây tỉnh Shimane",
      "inName": "Bagian Barat Prefektur Shimane",
      "tlName": "Kanlurang bahagi ng Shimane Prefecture",
      "moName": "Баруун Шиманэ аймаг",
      "buName": "ရှိမနဲစီရင်စု အနောက်ပိုင်း",
      "khName": "តំបន់ខាងលិចនៃខេត្ដស៊ីម៉ាណ",
      "neName": "सिमाने जिल्लाको पश्चिमी भाग"
    },
    "class15": {
      "code": "320023",
      "name": "益田地区",
      "enName": "Masuda District"
    },
    "class20": {
      "code": "3220400",
      "name": "益田市",
      "enName": "Masuda City",
      "kana": "ますだし",
      "chName": "益田市",
      "zhName": "益田市",
      "koName": "마스다 시",
      "esName": "Ciudad de Masuda",
      "ptName": "cidade de Masuda",
      "thName": "เมืองมัทสึดะ",
      "viName": "thành phố Masuda",
      "inName": "kota Masuda",
      "tlName": "siyudad ng Masuda",
      "moName": "Мaсүда хот",
      "buName": "မာဆုဒ မြို့",
      "khName": "ទីក្រុង ​ ម៉ាស៊ូដា",
      "neName": "मासुदा सहर"
    }
  },
  "3220500": {
    "office": {
      "code": "320000",
      "name": "島根県",
      "enName": "Shimane",
      "officeName": "松江地方気象台",
      "chName": "岛根县",
      "zhName": "島根縣",
      "koName": "시마네현",
      "esName": "Prefectura de Shimane",
      "ptName": "Província de Shimane",
      "thName": "จังหวัดชิมาเนะ",
      "viName": "Tỉnh Shimane",
      "inName": "Prefektur Shimane",
      "tlName": "Shimane Prefecture",
      "moName": "Шиманэ аймаг",
      "buName": "ရှီးမဏဲ့ ပြည်နယ်",
      "khName": "ខេត្ដ ស៊ីម៉ែន",
      "neName": "सिमाने जिल्ला"
    },
    "class10": {
      "code": "320020",
      "name": "西部",
      "enName": "Western Region",
      "chName": "岛根县西部",
      "zhName": "島根縣西部",
      "koName": "시마네 현 서부",
      "esName": "Oeste de Prefectura de Shimane",
      "ptName": "Oeste da Província de Shimane",
      "thName": "จังหวัดชิมาเนะฟากตะวันตก",
      "viName": "Miền Tây tỉnh Shimane",
      "inName": "Bagian Barat Prefektur Shimane",
      "tlName": "Kanlurang bahagi ng Shimane Prefecture",
      "moName": "Баруун Шиманэ аймаг",
      "buName": "ရှိမနဲစီရင်စု အနောက်ပိုင်း",
      "khName": "តំបន់ខាងលិចនៃខេត្ដស៊ីម៉ាណ",
      "neName": "सिमाने जिल्लाको पश्चिमी भाग"
    },
    "class15": {
      "code": "320021",
      "name": "大田邑智地区",
      "enName": "Oda Ochi District"
    },
    "class20": {
      "code": "3220500",
      "name": "大田市",
      "enName": "Ohda City",
      "kana": "おおだし",
      "chName": "大田市",
      "zhName": "大田市",
      "koName": "오다 시",
      "esName": "Ciudad de Ōda",
      "ptName": "cidade de Ohda",
      "thName": "เมืองโอดะ",
      "viName": "thành phố Ohda",
      "inName": "kota Ohda",
      "tlName": "siyudad ng Ohda",
      "moName": "Охда хот",
      "buName": "အိုးဒ မြို့",
      "khName": "ទីក្រុង អូដា",
      "neName": "ओहदा सहर"
    }
  },
  "3220600": {
    "office": {
      "code": "320000",
      "name": "島根県",
      "enName": "Shimane",
      "officeName": "松江地方気象台",
      "chName": "岛根县",
      "zhName": "島根縣",
      "koName": "시마네현",
      "esName": "Prefectura de Shimane",
      "ptName": "Província de Shimane",
      "thName": "จังหวัดชิมาเนะ",
      "viName": "Tỉnh Shimane",
      "inName": "Prefektur Shimane",
      "tlName": "Shimane Prefecture",
      "moName": "Шиманэ аймаг",
      "buName": "ရှီးမဏဲ့ ပြည်နယ်",
      "khName": "ខេត្ដ ស៊ីម៉ែន",
      "neName": "सिमाने जिल्ला"
    },
    "class10": {
      "code": "320010",
      "name": "東部",
      "enName": "Eastern Region",
      "chName": "岛根县东部",
      "zhName": "島根縣東部",
      "koName": "시마네 현 동부",
      "esName": "Este de Prefectura de Shimane",
      "ptName": "Leste da Província de Shimane",
      "thName": "จังหวัดชิมาเนะฟากตะวันออก",
      "viName": "Miền Đông tỉnh Shimane",
      "inName": "Bagian Timur Prefektur Shimane",
      "tlName": "Silangang bahagi ng Shimane Prefecture",
      "moName": "Зүүн Шиманэ  аймаг",
      "buName": "ရှိမနဲစီရင်စု အရှေ့ပိုင်း",
      "khName": "តំបន់ខាងកើតនៃខេត្ដស៊ីម៉ាណិ",
      "neName": "सिमाने जिल्लाको पूर्वी भाग"
    },
    "class15": {
      "code": "320011",
      "name": "松江地区",
      "enName": "Matsue District"
    },
    "class20": {
      "code": "3220600",
      "name": "安来市",
      "enName": "Yasugi City",
      "kana": "やすぎし",
      "chName": "安来市",
      "zhName": "安來市",
      "koName": "야스기 시",
      "esName": "Ciudad de Yasugi",
      "ptName": "cidade de Yasugi",
      "thName": "เมืองยาสุงิ",
      "viName": "thành phố Yasugi",
      "inName": "kota Yasugi",
      "tlName": "siyudad ng Yasugi",
      "moName": "Ясүги хот",
      "buName": "ယားဆုဂိ မြို့",
      "khName": "ទីក្រុង ​ យ៉ាស៊ូគី",
      "neName": "यासुगी सहर"
    }
  },
  "3220700": {
    "office": {
      "code": "320000",
      "name": "島根県",
      "enName": "Shimane",
      "officeName": "松江地方気象台",
      "chName": "岛根县",
      "zhName": "島根縣",
      "koName": "시마네현",
      "esName": "Prefectura de Shimane",
      "ptName": "Província de Shimane",
      "thName": "จังหวัดชิมาเนะ",
      "viName": "Tỉnh Shimane",
      "inName": "Prefektur Shimane",
      "tlName": "Shimane Prefecture",
      "moName": "Шиманэ аймаг",
      "buName": "ရှီးမဏဲ့ ပြည်နယ်",
      "khName": "ខេត្ដ ស៊ីម៉ែន",
      "neName": "सिमाने जिल्ला"
    },
    "class10": {
      "code": "320020",
      "name": "西部",
      "enName": "Western Region",
      "chName": "岛根县西部",
      "zhName": "島根縣西部",
      "koName": "시마네 현 서부",
      "esName": "Oeste de Prefectura de Shimane",
      "ptName": "Oeste da Província de Shimane",
      "thName": "จังหวัดชิมาเนะฟากตะวันตก",
      "viName": "Miền Tây tỉnh Shimane",
      "inName": "Bagian Barat Prefektur Shimane",
      "tlName": "Kanlurang bahagi ng Shimane Prefecture",
      "moName": "Баруун Шиманэ аймаг",
      "buName": "ရှိမနဲစီရင်စု အနောက်ပိုင်း",
      "khName": "តំបន់ខាងលិចនៃខេត្ដស៊ីម៉ាណ",
      "neName": "सिमाने जिल्लाको पश्चिमी भाग"
    },
    "class15": {
      "code": "320022",
      "name": "浜田地区",
      "enName": "Hamada District"
    },
    "class20": {
      "code": "3220700",
      "name": "江津市",
      "enName": "Gotsu City",
      "kana": "ごうつし",
      "chName": "江津市",
      "zhName": "江津市",
      "koName": "고쓰 시",
      "esName": "Ciudad de Kōzu",
      "ptName": "cidade de Gotsu",
      "thName": "เมืองโก๊ทสุ",
      "viName": "thành phố Gotsu",
      "inName": "kota Gotsu",
      "tlName": "siyudad ng Gotsu",
      "moName": "Гоцү хот",
      "buName": "ဂေါ်ဆု မြို့",
      "khName": "ទីក្រុង ហ្គូតស៊ូ",
      "neName": "गोत्सु सहर"
    }
  },
  "3220900": {
    "office": {
      "code": "320000",
      "name": "島根県",
      "enName": "Shimane",
      "officeName": "松江地方気象台",
      "chName": "岛根县",
      "zhName": "島根縣",
      "koName": "시마네현",
      "esName": "Prefectura de Shimane",
      "ptName": "Província de Shimane",
      "thName": "จังหวัดชิมาเนะ",
      "viName": "Tỉnh Shimane",
      "inName": "Prefektur Shimane",
      "tlName": "Shimane Prefecture",
      "moName": "Шиманэ аймаг",
      "buName": "ရှီးမဏဲ့ ပြည်နယ်",
      "khName": "ខេត្ដ ស៊ីម៉ែន",
      "neName": "सिमाने जिल्ला"
    },
    "class10": {
      "code": "320010",
      "name": "東部",
      "enName": "Eastern Region",
      "chName": "岛根县东部",
      "zhName": "島根縣東部",
      "koName": "시마네 현 동부",
      "esName": "Este de Prefectura de Shimane",
      "ptName": "Leste da Província de Shimane",
      "thName": "จังหวัดชิมาเนะฟากตะวันออก",
      "viName": "Miền Đông tỉnh Shimane",
      "inName": "Bagian Timur Prefektur Shimane",
      "tlName": "Silangang bahagi ng Shimane Prefecture",
      "moName": "Зүүн Шиманэ  аймаг",
      "buName": "ရှိမနဲစီရင်စု အရှေ့ပိုင်း",
      "khName": "តំបន់ខាងកើតនៃខេត្ដស៊ីម៉ាណិ",
      "neName": "सिमाने जिल्लाको पूर्वी भाग"
    },
    "class15": {
      "code": "320013",
      "name": "雲南地区",
      "enName": "Unnan District"
    },
    "class20": {
      "code": "3220900",
      "name": "雲南市",
      "enName": "Unnan City",
      "kana": "うんなんし",
      "chName": "云南市",
      "zhName": "雲南市",
      "koName": "운난 시",
      "esName": "Ciudad de Unnan ",
      "ptName": "cidade de Unnan",
      "thName": "เมืองแอนนัน",
      "viName": "thành phố Unnan",
      "inName": "kota Unnan",
      "tlName": "siyudad ng Unnan",
      "moName": "Үннaн хот",
      "buName": "ဦးနန် မြို့",
      "khName": "ទីក្រុង អ៊ូណន់",
      "neName": "उन्नान सहर"
    }
  },
  "3234300": {
    "office": {
      "code": "320000",
      "name": "島根県",
      "enName": "Shimane",
      "officeName": "松江地方気象台",
      "chName": "岛根县",
      "zhName": "島根縣",
      "koName": "시마네현",
      "esName": "Prefectura de Shimane",
      "ptName": "Província de Shimane",
      "thName": "จังหวัดชิมาเนะ",
      "viName": "Tỉnh Shimane",
      "inName": "Prefektur Shimane",
      "tlName": "Shimane Prefecture",
      "moName": "Шиманэ аймаг",
      "buName": "ရှီးမဏဲ့ ပြည်နယ်",
      "khName": "ខេត្ដ ស៊ីម៉ែន",
      "neName": "सिमाने जिल्ला"
    },
    "class10": {
      "code": "320010",
      "name": "東部",
      "enName": "Eastern Region",
      "chName": "岛根县东部",
      "zhName": "島根縣東部",
      "koName": "시마네 현 동부",
      "esName": "Este de Prefectura de Shimane",
      "ptName": "Leste da Província de Shimane",
      "thName": "จังหวัดชิมาเนะฟากตะวันออก",
      "viName": "Miền Đông tỉnh Shimane",
      "inName": "Bagian Timur Prefektur Shimane",
      "tlName": "Silangang bahagi ng Shimane Prefecture",
      "moName": "Зүүн Шиманэ  аймаг",
      "buName": "ရှိမနဲစီရင်စု အရှေ့ပိုင်း",
      "khName": "តំបន់ខាងកើតនៃខេត្ដស៊ីម៉ាណិ",
      "neName": "सिमाने जिल्लाको पूर्वी भाग"
    },
    "class15": {
      "code": "320013",
      "name": "雲南地区",
      "enName": "Unnan District"
    },
    "class20": {
      "code": "3234300",
      "name": "奥出雲町",
      "enName": "Okuizumo Town",
      "kana": "おくいずもちょう",
      "chName": "奥出云町",
      "zhName": "奧出雲町",
      "koName": "오쿠이즈모 정",
      "esName": "Pueblo de Okuizumo",
      "ptName": "bairro de Okuizumo",
      "thName": "เมืองโอคุซุโมะ",
      "viName": "thị trấn Okuizumo",
      "inName": "kota Okuizumo",
      "tlName": "bayan ng Okuizumo",
      "moName": "Окүйзүмо жижиг хот",
      "buName": "အိုကုယိဇူမို မြို့နယ်",
      "khName": "ទីប្រជុំជន អូគីហ្សូម៉ូ",
      "neName": "ओकुइजुमो नगर"
    }
  },
  "3238600": {
    "office": {
      "code": "320000",
      "name": "島根県",
      "enName": "Shimane",
      "officeName": "松江地方気象台",
      "chName": "岛根县",
      "zhName": "島根縣",
      "koName": "시마네현",
      "esName": "Prefectura de Shimane",
      "ptName": "Província de Shimane",
      "thName": "จังหวัดชิมาเนะ",
      "viName": "Tỉnh Shimane",
      "inName": "Prefektur Shimane",
      "tlName": "Shimane Prefecture",
      "moName": "Шиманэ аймаг",
      "buName": "ရှီးမဏဲ့ ပြည်နယ်",
      "khName": "ខេត្ដ ស៊ីម៉ែន",
      "neName": "सिमाने जिल्ला"
    },
    "class10": {
      "code": "320010",
      "name": "東部",
      "enName": "Eastern Region",
      "chName": "岛根县东部",
      "zhName": "島根縣東部",
      "koName": "시마네 현 동부",
      "esName": "Este de Prefectura de Shimane",
      "ptName": "Leste da Província de Shimane",
      "thName": "จังหวัดชิมาเนะฟากตะวันออก",
      "viName": "Miền Đông tỉnh Shimane",
      "inName": "Bagian Timur Prefektur Shimane",
      "tlName": "Silangang bahagi ng Shimane Prefecture",
      "moName": "Зүүн Шиманэ  аймаг",
      "buName": "ရှိမနဲစီရင်စု အရှေ့ပိုင်း",
      "khName": "តំបន់ខាងកើតនៃខេត្ដស៊ីម៉ាណិ",
      "neName": "सिमाने जिल्लाको पूर्वी भाग"
    },
    "class15": {
      "code": "320013",
      "name": "雲南地区",
      "enName": "Unnan District"
    },
    "class20": {
      "code": "3238600",
      "name": "飯南町",
      "enName": "Iinan Town",
      "kana": "いいなんちょう",
      "chName": "饭南町",
      "zhName": "飯南町",
      "koName": "이난 정",
      "esName": "Pueblo de Iinan",
      "ptName": "bairro de Iinan",
      "thName": "เมืองอิอินัน",
      "viName": "thị trấn Iinan",
      "inName": "kota Iinan",
      "tlName": "bayan ng Iinan",
      "moName": "Ийнaн жижиг хот",
      "buName": "အီးနန် မြို့နယ်",
      "khName": "ទីប្រជុំជន អ៊ីនណាន",
      "neName": "इनान नगर"
    }
  },
  "3244100": {
    "office": {
      "code": "320000",
      "name": "島根県",
      "enName": "Shimane",
      "officeName": "松江地方気象台",
      "chName": "岛根县",
      "zhName": "島根縣",
      "koName": "시마네현",
      "esName": "Prefectura de Shimane",
      "ptName": "Província de Shimane",
      "thName": "จังหวัดชิมาเนะ",
      "viName": "Tỉnh Shimane",
      "inName": "Prefektur Shimane",
      "tlName": "Shimane Prefecture",
      "moName": "Шиманэ аймаг",
      "buName": "ရှီးမဏဲ့ ပြည်နယ်",
      "khName": "ខេត្ដ ស៊ីម៉ែន",
      "neName": "सिमाने जिल्ला"
    },
    "class10": {
      "code": "320020",
      "name": "西部",
      "enName": "Western Region",
      "chName": "岛根县西部",
      "zhName": "島根縣西部",
      "koName": "시마네 현 서부",
      "esName": "Oeste de Prefectura de Shimane",
      "ptName": "Oeste da Província de Shimane",
      "thName": "จังหวัดชิมาเนะฟากตะวันตก",
      "viName": "Miền Tây tỉnh Shimane",
      "inName": "Bagian Barat Prefektur Shimane",
      "tlName": "Kanlurang bahagi ng Shimane Prefecture",
      "moName": "Баруун Шиманэ аймаг",
      "buName": "ရှိမနဲစီရင်စု အနောက်ပိုင်း",
      "khName": "តំបន់ខាងលិចនៃខេត្ដស៊ីម៉ាណ",
      "neName": "सिमाने जिल्लाको पश्चिमी भाग"
    },
    "class15": {
      "code": "320021",
      "name": "大田邑智地区",
      "enName": "Oda Ochi District"
    },
    "class20": {
      "code": "3244100",
      "name": "川本町",
      "enName": "Kawamoto Town",
      "kana": "かわもとまち",
      "chName": "川本町",
      "zhName": "川本町",
      "koName": "가와모토 정",
      "esName": "Pueblo de Kawamoto",
      "ptName": "bairro de Kawamoto",
      "thName": "เมืองคาวาโมโตะ",
      "viName": "thị trấn Kawamoto",
      "inName": "kota Kawamoto",
      "tlName": "bayan ng Kawamoto",
      "moName": "Кавамото жижиг хот",
      "buName": "ခါဝါမိုတို မြို့နယ်",
      "khName": "ទីប្រជុំជន កាវ៉ាម៉ូតូ",
      "neName": "कावामोतो नगर"
    }
  },
  "3244800": {
    "office": {
      "code": "320000",
      "name": "島根県",
      "enName": "Shimane",
      "officeName": "松江地方気象台",
      "chName": "岛根县",
      "zhName": "島根縣",
      "koName": "시마네현",
      "esName": "Prefectura de Shimane",
      "ptName": "Província de Shimane",
      "thName": "จังหวัดชิมาเนะ",
      "viName": "Tỉnh Shimane",
      "inName": "Prefektur Shimane",
      "tlName": "Shimane Prefecture",
      "moName": "Шиманэ аймаг",
      "buName": "ရှီးမဏဲ့ ပြည်နယ်",
      "khName": "ខេត្ដ ស៊ីម៉ែន",
      "neName": "सिमाने जिल्ला"
    },
    "class10": {
      "code": "320020",
      "name": "西部",
      "enName": "Western Region",
      "chName": "岛根县西部",
      "zhName": "島根縣西部",
      "koName": "시마네 현 서부",
      "esName": "Oeste de Prefectura de Shimane",
      "ptName": "Oeste da Província de Shimane",
      "thName": "จังหวัดชิมาเนะฟากตะวันตก",
      "viName": "Miền Tây tỉnh Shimane",
      "inName": "Bagian Barat Prefektur Shimane",
      "tlName": "Kanlurang bahagi ng Shimane Prefecture",
      "moName": "Баруун Шиманэ аймаг",
      "buName": "ရှိမနဲစီရင်စု အနောက်ပိုင်း",
      "khName": "តំបន់ខាងលិចនៃខេត្ដស៊ីម៉ាណ",
      "neName": "सिमाने जिल्लाको पश्चिमी भाग"
    },
    "class15": {
      "code": "320021",
      "name": "大田邑智地区",
      "enName": "Oda Ochi District"
    },
    "class20": {
      "code": "3244800",
      "name": "美郷町",
      "enName": "Misato Town",
      "kana": "みさとちょう",
      "chName": "岛根美乡町",
      "zhName": "島根美鄉町",
      "koName": "시마네 미사토 정",
      "esName": "Pueblo de Misato, Shimane",
      "ptName": "Shimane, bairro de Misato",
      "thName": "เมืองมิซาโตะ ชิมาเนะ",
      "viName": "Thị trấn Misato, Shimane",
      "inName": "Kota Misato, Shimane",
      "tlName": "bayan ng Misato, Shimane",
      "moName": "Шиманэ Мисато жижиг хот",
      "buName": "ရှိမနဲမိဆတိုမြို့နယ်",
      "khName": "ទីប្រជុំជនមីសាតូ ស៊ីម៉ាណិ",
      "neName": "सिमाने मिसातो नगर"
    }
  },
  "3244900": {
    "office": {
      "code": "320000",
      "name": "島根県",
      "enName": "Shimane",
      "officeName": "松江地方気象台",
      "chName": "岛根县",
      "zhName": "島根縣",
      "koName": "시마네현",
      "esName": "Prefectura de Shimane",
      "ptName": "Província de Shimane",
      "thName": "จังหวัดชิมาเนะ",
      "viName": "Tỉnh Shimane",
      "inName": "Prefektur Shimane",
      "tlName": "Shimane Prefecture",
      "moName": "Шиманэ аймаг",
      "buName": "ရှီးမဏဲ့ ပြည်နယ်",
      "khName": "ខេត្ដ ស៊ីម៉ែន",
      "neName": "सिमाने जिल्ला"
    },
    "class10": {
      "code": "320020",
      "name": "西部",
      "enName": "Western Region",
      "chName": "岛根县西部",
      "zhName": "島根縣西部",
      "koName": "시마네 현 서부",
      "esName": "Oeste de Prefectura de Shimane",
      "ptName": "Oeste da Província de Shimane",
      "thName": "จังหวัดชิมาเนะฟากตะวันตก",
      "viName": "Miền Tây tỉnh Shimane",
      "inName": "Bagian Barat Prefektur Shimane",
      "tlName": "Kanlurang bahagi ng Shimane Prefecture",
      "moName": "Баруун Шиманэ аймаг",
      "buName": "ရှိမနဲစီရင်စု အနောက်ပိုင်း",
      "khName": "តំបន់ខាងលិចនៃខេត្ដស៊ីម៉ាណ",
      "neName": "सिमाने जिल्लाको पश्चिमी भाग"
    },
    "class15": {
      "code": "320021",
      "name": "大田邑智地区",
      "enName": "Oda Ochi District"
    },
    "class20": {
      "code": "3244900",
      "name": "邑南町",
      "enName": "Onan Town",
      "kana": "おおなんちょう",
      "chName": "邑南町",
      "zhName": "邑南町",
      "koName": "오난 정",
      "esName": "Pueblo de Ōnan",
      "ptName": "bairro de Onan",
      "thName": "เมืองโอนัน",
      "viName": "thị trấn Onan",
      "inName": "kota Onan",
      "tlName": "bayan ng Onan",
      "moName": "Онaн жижиг хот",
      "buName": "အိုနန်း မြို့နယ်",
      "khName": "ទីប្រជុំជន អូណាន់",
      "neName": "ओनान नगर"
    }
  },
  "3250100": {
    "office": {
      "code": "320000",
      "name": "島根県",
      "enName": "Shimane",
      "officeName": "松江地方気象台",
      "chName": "岛根县",
      "zhName": "島根縣",
      "koName": "시마네현",
      "esName": "Prefectura de Shimane",
      "ptName": "Província de Shimane",
      "thName": "จังหวัดชิมาเนะ",
      "viName": "Tỉnh Shimane",
      "inName": "Prefektur Shimane",
      "tlName": "Shimane Prefecture",
      "moName": "Шиманэ аймаг",
      "buName": "ရှီးမဏဲ့ ပြည်နယ်",
      "khName": "ខេត្ដ ស៊ីម៉ែន",
      "neName": "सिमाने जिल्ला"
    },
    "class10": {
      "code": "320020",
      "name": "西部",
      "enName": "Western Region",
      "chName": "岛根县西部",
      "zhName": "島根縣西部",
      "koName": "시마네 현 서부",
      "esName": "Oeste de Prefectura de Shimane",
      "ptName": "Oeste da Província de Shimane",
      "thName": "จังหวัดชิมาเนะฟากตะวันตก",
      "viName": "Miền Tây tỉnh Shimane",
      "inName": "Bagian Barat Prefektur Shimane",
      "tlName": "Kanlurang bahagi ng Shimane Prefecture",
      "moName": "Баруун Шиманэ аймаг",
      "buName": "ရှိမနဲစီရင်စု အနောက်ပိုင်း",
      "khName": "តំបន់ខាងលិចនៃខេត្ដស៊ីម៉ាណ",
      "neName": "सिमाने जिल्लाको पश्चिमी भाग"
    },
    "class15": {
      "code": "320023",
      "name": "益田地区",
      "enName": "Masuda District"
    },
    "class20": {
      "code": "3250100",
      "name": "津和野町",
      "enName": "Tsuwano Town",
      "kana": "つわのちょう",
      "chName": "津和野町",
      "zhName": "津和野町",
      "koName": "쓰와노 정",
      "esName": "Pueblo de Tsuwano",
      "ptName": "bairro de Tsuwano",
      "thName": "เมืองสึวาโนะ",
      "viName": "thị trấn Tsuwano",
      "inName": "kota Tsuwano",
      "tlName": "bayan ng Tsuwano",
      "moName": "Цүвано жижиг хот",
      "buName": "ဆုဝါးနို မြို့နယ်",
      "khName": "ទីប្រជុំជន ស៊ូវ៉ាណូ",
      "neName": "त्सुवानो नगर"
    }
  },
  "3250500": {
    "office": {
      "code": "320000",
      "name": "島根県",
      "enName": "Shimane",
      "officeName": "松江地方気象台",
      "chName": "岛根县",
      "zhName": "島根縣",
      "koName": "시마네현",
      "esName": "Prefectura de Shimane",
      "ptName": "Província de Shimane",
      "thName": "จังหวัดชิมาเนะ",
      "viName": "Tỉnh Shimane",
      "inName": "Prefektur Shimane",
      "tlName": "Shimane Prefecture",
      "moName": "Шиманэ аймаг",
      "buName": "ရှီးမဏဲ့ ပြည်နယ်",
      "khName": "ខេត្ដ ស៊ីម៉ែន",
      "neName": "सिमाने जिल्ला"
    },
    "class10": {
      "code": "320020",
      "name": "西部",
      "enName": "Western Region",
      "chName": "岛根县西部",
      "zhName": "島根縣西部",
      "koName": "시마네 현 서부",
      "esName": "Oeste de Prefectura de Shimane",
      "ptName": "Oeste da Província de Shimane",
      "thName": "จังหวัดชิมาเนะฟากตะวันตก",
      "viName": "Miền Tây tỉnh Shimane",
      "inName": "Bagian Barat Prefektur Shimane",
      "tlName": "Kanlurang bahagi ng Shimane Prefecture",
      "moName": "Баруун Шиманэ аймаг",
      "buName": "ရှိမနဲစီရင်စု အနောက်ပိုင်း",
      "khName": "តំបន់ខាងលិចនៃខេត្ដស៊ីម៉ាណ",
      "neName": "सिमाने जिल्लाको पश्चिमी भाग"
    },
    "class15": {
      "code": "320023",
      "name": "益田地区",
      "enName": "Masuda District"
    },
    "class20": {
      "code": "3250500",
      "name": "吉賀町",
      "enName": "Yoshika Town",
      "kana": "よしかちょう",
      "chName": "吉贺町",
      "zhName": "吉賀町",
      "koName": "요시카 정",
      "esName": "Pueblo de Yoshika",
      "ptName": "bairro de Yoshika",
      "thName": "เมืองโยชิกะ",
      "viName": "thị trấn Yoshika",
      "inName": "kota Yoshika",
      "tlName": "bayan ng Yoshika",
      "moName": "Ёшика жижиг хот",
      "buName": "ယိုရှိက မြို့နယ်",
      "khName": "ទីប្រជុំជន យ៉ូស៊ីកា",
      "neName": "योशिका नगर"
    }
  },
  "3252500": {
    "office": {
      "code": "320000",
      "name": "島根県",
      "enName": "Shimane",
      "officeName": "松江地方気象台",
      "chName": "岛根县",
      "zhName": "島根縣",
      "koName": "시마네현",
      "esName": "Prefectura de Shimane",
      "ptName": "Província de Shimane",
      "thName": "จังหวัดชิมาเนะ",
      "viName": "Tỉnh Shimane",
      "inName": "Prefektur Shimane",
      "tlName": "Shimane Prefecture",
      "moName": "Шиманэ аймаг",
      "buName": "ရှီးမဏဲ့ ပြည်နယ်",
      "khName": "ខេត្ដ ស៊ីម៉ែន",
      "neName": "सिमाने जिल्ला"
    },
    "class10": {
      "code": "320030",
      "name": "隠岐",
      "enName": "Oki",
      "chName": "沖木, 島根県",
      "zhName": "冲木, 島根县",
      "koName": "오키, 시마네현",
      "esName": "Región Oki, Prefectura de Shimane",
      "ptName": "Região de Oki da Província de Shimane",
      "thName": "พื้นที่โอคิ จังหวัดชิมาเนะ",
      "viName": "Vùng Oki tỉnh Shimane",
      "inName": "Daerah Oki di Prefektur Shimane",
      "tlName": "Rehiyon ng Oki sa Prefektur ng Shimane",
      "moName": "Шимане аймаг, Оки",
      "buName": "အိုကီ၊ ရှီမနေးမြို့",
      "khName": "តំបន់អូគី ខេត្តស៊ីម៉ានេ",
      "neName": "शिमाने प्रान्त, ओकी क्षेत्र"
    },
    "class15": {
      "code": "320030",
      "name": "隠岐",
      "enName": "Oki"
    },
    "class20": {
      "code": "3252500",
      "name": "海士町",
      "enName": "Ama Town",
      "kana": "あまちょう",
      "chName": "海士町",
      "zhName": "海士町",
      "koName": "아마 정",
      "esName": "Pueblo de Ama",
      "ptName": "bairro de Ama",
      "thName": "เมืองอามะ",
      "viName": "thị trấn Ama",
      "inName": "kota Ama",
      "tlName": "bayan ng Ama",
      "moName": "Aмa жижиг хот",
      "buName": "အားမ မြို့နယ်",
      "khName": "ទីប្រជុំជន អាម៉ា",
      "neName": "आमा नगर"
    }
  },
  "3252600": {
    "office": {
      "code": "320000",
      "name": "島根県",
      "enName": "Shimane",
      "officeName": "松江地方気象台",
      "chName": "岛根县",
      "zhName": "島根縣",
      "koName": "시마네현",
      "esName": "Prefectura de Shimane",
      "ptName": "Província de Shimane",
      "thName": "จังหวัดชิมาเนะ",
      "viName": "Tỉnh Shimane",
      "inName": "Prefektur Shimane",
      "tlName": "Shimane Prefecture",
      "moName": "Шиманэ аймаг",
      "buName": "ရှီးမဏဲ့ ပြည်နယ်",
      "khName": "ខេត្ដ ស៊ីម៉ែន",
      "neName": "सिमाने जिल्ला"
    },
    "class10": {
      "code": "320030",
      "name": "隠岐",
      "enName": "Oki",
      "chName": "沖木, 島根県",
      "zhName": "冲木, 島根县",
      "koName": "오키, 시마네현",
      "esName": "Región Oki, Prefectura de Shimane",
      "ptName": "Região de Oki da Província de Shimane",
      "thName": "พื้นที่โอคิ จังหวัดชิมาเนะ",
      "viName": "Vùng Oki tỉnh Shimane",
      "inName": "Daerah Oki di Prefektur Shimane",
      "tlName": "Rehiyon ng Oki sa Prefektur ng Shimane",
      "moName": "Шимане аймаг, Оки",
      "buName": "အိုကီ၊ ရှီမနေးမြို့",
      "khName": "តំបន់អូគី ខេត្តស៊ីម៉ានេ",
      "neName": "शिमाने प्रान्त, ओकी क्षेत्र"
    },
    "class15": {
      "code": "320030",
      "name": "隠岐",
      "enName": "Oki"
    },
    "class20": {
      "code": "3252600",
      "name": "西ノ島町",
      "enName": "Nishinoshima Town",
      "kana": "にしのしまちょう",
      "chName": "西之岛町",
      "zhName": "西之島町",
      "koName": "니시노시마 정",
      "esName": "Pueblo de Nishinoshima",
      "ptName": "bairro de Nishinoshima",
      "thName": "เมืองนิชิโนะชิมะ",
      "viName": "thị trấn Nishinoshima",
      "inName": "kota Nishinoshima",
      "tlName": "bayan ng Nishinoshima",
      "moName": "Нишиношимa жижиг хот",
      "buName": "နီရှိနောရှိမ မြို့နယ်",
      "khName": "ទីប្រជុំជន នីស៊ីនណូស៊ីម៉ា",
      "neName": "निशिनोशिमा नगर"
    }
  },
  "3252700": {
    "office": {
      "code": "320000",
      "name": "島根県",
      "enName": "Shimane",
      "officeName": "松江地方気象台",
      "chName": "岛根县",
      "zhName": "島根縣",
      "koName": "시마네현",
      "esName": "Prefectura de Shimane",
      "ptName": "Província de Shimane",
      "thName": "จังหวัดชิมาเนะ",
      "viName": "Tỉnh Shimane",
      "inName": "Prefektur Shimane",
      "tlName": "Shimane Prefecture",
      "moName": "Шиманэ аймаг",
      "buName": "ရှီးမဏဲ့ ပြည်နယ်",
      "khName": "ខេត្ដ ស៊ីម៉ែន",
      "neName": "सिमाने जिल्ला"
    },
    "class10": {
      "code": "320030",
      "name": "隠岐",
      "enName": "Oki",
      "chName": "沖木, 島根県",
      "zhName": "冲木, 島根县",
      "koName": "오키, 시마네현",
      "esName": "Región Oki, Prefectura de Shimane",
      "ptName": "Região de Oki da Província de Shimane",
      "thName": "พื้นที่โอคิ จังหวัดชิมาเนะ",
      "viName": "Vùng Oki tỉnh Shimane",
      "inName": "Daerah Oki di Prefektur Shimane",
      "tlName": "Rehiyon ng Oki sa Prefektur ng Shimane",
      "moName": "Шимане аймаг, Оки",
      "buName": "အိုကီ၊ ရှီမနေးမြို့",
      "khName": "តំបន់អូគី ខេត្តស៊ីម៉ានេ",
      "neName": "शिमाने प्रान्त, ओकी क्षेत्र"
    },
    "class15": {
      "code": "320030",
      "name": "隠岐",
      "enName": "Oki"
    },
    "class20": {
      "code": "3252700",
      "name": "知夫村",
      "enName": "Chibu Village",
      "kana": "ちぶむら",
      "chName": "知夫村",
      "zhName": "知夫村",
      "koName": "지부 촌",
      "esName": "Aldea de Chibu",
      "ptName": "povoado de Chibu",
      "thName": "หมู่บ้านจิบุ",
      "viName": "làng Chibu",
      "inName": "desa Chibu",
      "tlName": "nayon ng Chibu",
      "moName": "Чибү тосгон",
      "buName": "ကျိဗု ကျေးရွာ",
      "khName": "ភូមិ ជីប៊ូ",
      "neName": "चिबु गाउँ"
    }
  },
  "3252800": {
    "office": {
      "code": "320000",
      "name": "島根県",
      "enName": "Shimane",
      "officeName": "松江地方気象台",
      "chName": "岛根县",
      "zhName": "島根縣",
      "koName": "시마네현",
      "esName": "Prefectura de Shimane",
      "ptName": "Província de Shimane",
      "thName": "จังหวัดชิมาเนะ",
      "viName": "Tỉnh Shimane",
      "inName": "Prefektur Shimane",
      "tlName": "Shimane Prefecture",
      "moName": "Шиманэ аймаг",
      "buName": "ရှီးမဏဲ့ ပြည်နယ်",
      "khName": "ខេត្ដ ស៊ីម៉ែន",
      "neName": "सिमाने जिल्ला"
    },
    "class10": {
      "code": "320030",
      "name": "隠岐",
      "enName": "Oki",
      "chName": "沖木, 島根県",
      "zhName": "冲木, 島根县",
      "koName": "오키, 시마네현",
      "esName": "Región Oki, Prefectura de Shimane",
      "ptName": "Região de Oki da Província de Shimane",
      "thName": "พื้นที่โอคิ จังหวัดชิมาเนะ",
      "viName": "Vùng Oki tỉnh Shimane",
      "inName": "Daerah Oki di Prefektur Shimane",
      "tlName": "Rehiyon ng Oki sa Prefektur ng Shimane",
      "moName": "Шимане аймаг, Оки",
      "buName": "အိုကီ၊ ရှီမနေးမြို့",
      "khName": "តំបន់អូគី ខេត្តស៊ីម៉ានេ",
      "neName": "शिमाने प्रान्त, ओकी क्षेत्र"
    },
    "class15": {
      "code": "320030",
      "name": "隠岐",
      "enName": "Oki"
    },
    "class20": {
      "code": "3252800",
      "name": "隠岐の島町",
      "enName": "Okinoshima Town",
      "kana": "おきのしまちょう",
      "chName": "隐岐之岛町",
      "zhName": "隱岐之島町",
      "koName": "오키노시마 정",
      "esName": "Pueblo de Okinoshima ",
      "ptName": "bairro de Okinoshima",
      "thName": "เมืองโอคิโนชิมะ",
      "viName": "thị trấn Okinoshima",
      "inName": "kota Okinoshima",
      "tlName": "bayan ng Okinoshima",
      "moName": "Окиношимa жижиг хот",
      "buName": "အိုကီနိုရှိမ မြို့နယ်",
      "khName": "ទីប្រជុំជន អូគីណូហ្ស៊ីម៉ា",
      "neName": "ओकिनोशिमा नगर"
    }
  },
  "3310000": {
    "office": {
      "code": "330000",
      "name": "岡山県",
      "enName": "Okayama",
      "officeName": "岡山地方気象台",
      "chName": "冈山县",
      "zhName": "岡山縣",
      "koName": "오카야마현",
      "esName": "Prefectura de Okayama",
      "ptName": "Província de Okayama",
      "thName": "จังหวัดโอคายามะ",
      "viName": "Tỉnh Okayama",
      "inName": "Prefektur Okayama",
      "tlName": "Okayama Prefecture",
      "moName": "Окаяма аймаг",
      "buName": "အိုကားယာ့မ ပြည်နယ်",
      "khName": "ខេត្ដ អូកាយ៉ាម៉ា",
      "neName": "ओकायामा जिल्ला"
    },
    "class10": {
      "code": "330010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "冈山县南部",
      "zhName": "岡山縣南部",
      "koName": "오카야마 현 남부",
      "esName": "Sur de Prefectura de Okayama",
      "ptName": "Sul da Província de Okayama",
      "thName": "จังหวัดโอกายามะตอนใต้",
      "viName": "Miền Nam tỉnh Okayama",
      "inName": "Bagian Selatan Prefektur Okayama",
      "tlName": "Timog na bahagi ng Okayama Prefecture",
      "moName": "Өмнөд Окаяма аймаг",
      "buName": "အိုကယမစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដអូកាយ៉ាម៉ា",
      "neName": "ओकायामा जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "330011",
      "name": "岡山地域",
      "enName": "Okayama Area"
    },
    "class20": {
      "code": "3310000",
      "name": "岡山市",
      "enName": "Okayama City",
      "kana": "おかやまし",
      "chName": "冈山市",
      "zhName": "岡山市",
      "koName": "오카야마시",
      "esName": "Ciudad de Okayama",
      "ptName": "Cidade de Okayama",
      "thName": "เมืองโอะกะยะมะ",
      "viName": "thành phố Okayama",
      "inName": "Kota Okayama",
      "tlName": "lungsod ng Okayama",
      "moName": "Окаяма хот",
      "buName": "အိုကာယာမားမြို့",
      "khName": "ទីក្រុង អូកាយាមា",
      "neName": "ओकायामा शहर"
    }
  },
  "3320200": {
    "office": {
      "code": "330000",
      "name": "岡山県",
      "enName": "Okayama",
      "officeName": "岡山地方気象台",
      "chName": "冈山县",
      "zhName": "岡山縣",
      "koName": "오카야마현",
      "esName": "Prefectura de Okayama",
      "ptName": "Província de Okayama",
      "thName": "จังหวัดโอคายามะ",
      "viName": "Tỉnh Okayama",
      "inName": "Prefektur Okayama",
      "tlName": "Okayama Prefecture",
      "moName": "Окаяма аймаг",
      "buName": "အိုကားယာ့မ ပြည်နယ်",
      "khName": "ខេត្ដ អូកាយ៉ាម៉ា",
      "neName": "ओकायामा जिल्ला"
    },
    "class10": {
      "code": "330010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "冈山县南部",
      "zhName": "岡山縣南部",
      "koName": "오카야마 현 남부",
      "esName": "Sur de Prefectura de Okayama",
      "ptName": "Sul da Província de Okayama",
      "thName": "จังหวัดโอกายามะตอนใต้",
      "viName": "Miền Nam tỉnh Okayama",
      "inName": "Bagian Selatan Prefektur Okayama",
      "tlName": "Timog na bahagi ng Okayama Prefecture",
      "moName": "Өмнөд Окаяма аймаг",
      "buName": "အိုကယမစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដអូកាយ៉ាម៉ា",
      "neName": "ओकायामा जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "330013",
      "name": "倉敷地域",
      "enName": "Kurashiki Area"
    },
    "class20": {
      "code": "3320200",
      "name": "倉敷市",
      "enName": "Kurashiki City",
      "kana": "くらしきし",
      "chName": "仓敷市",
      "zhName": "倉敷市",
      "koName": "구라시키 시",
      "esName": "Ciudad de Kurashiki",
      "ptName": "cidade de Kurashiki",
      "thName": "เมืองคุระชิกิ",
      "viName": "thành phố Kurashiki",
      "inName": "kota Kurashiki",
      "tlName": "siyudad ng Kurashiki",
      "moName": "Күрашики хот",
      "buName": "ခူရာ့ရှိကိ မြို့",
      "khName": "ទីក្រុង គូរ៉ាស៊ីគី",
      "neName": "कुराशिकी सहर"
    }
  },
  "3320300": {
    "office": {
      "code": "330000",
      "name": "岡山県",
      "enName": "Okayama",
      "officeName": "岡山地方気象台",
      "chName": "冈山县",
      "zhName": "岡山縣",
      "koName": "오카야마현",
      "esName": "Prefectura de Okayama",
      "ptName": "Província de Okayama",
      "thName": "จังหวัดโอคายามะ",
      "viName": "Tỉnh Okayama",
      "inName": "Prefektur Okayama",
      "tlName": "Okayama Prefecture",
      "moName": "Окаяма аймаг",
      "buName": "အိုကားယာ့မ ပြည်နယ်",
      "khName": "ខេត្ដ អូកាយ៉ាម៉ា",
      "neName": "ओकायामा जिल्ला"
    },
    "class10": {
      "code": "330020",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "冈山县北部",
      "zhName": "岡山縣北部",
      "koName": "오카야마 현 북부",
      "esName": "Norte de Prefectura de Okayama",
      "ptName": "Norte da Província de Okayama",
      "thName": "จังหวัดโอกายามะตอนเหนือ",
      "viName": "Miền Bắc tỉnh Okayama",
      "inName": "Bagian Utara Prefektur Okayama",
      "tlName": "Hilagang bahagi ng Okayama Prefecture",
      "moName": "Хойд Окаяма аймаг",
      "buName": "အိုကယမစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដអូកាយ៉ាម៉ា",
      "neName": "ओकायामा जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "330023",
      "name": "津山地域",
      "enName": "Tsuyama Area"
    },
    "class20": {
      "code": "3320300",
      "name": "津山市",
      "enName": "Tsuyama City",
      "kana": "つやまし",
      "chName": "津山市",
      "zhName": "津山市",
      "koName": "쓰야마 시",
      "esName": "Ciudad de Tsuyama",
      "ptName": "cidade de Tsuyama",
      "thName": "เมืองทสึยามะ",
      "viName": "thành phố Tsuyama",
      "inName": "kota Tsuyama",
      "tlName": "siyudad ng Tsuyama",
      "moName": "Цүямa хот",
      "buName": "ဆုယားမ မြို့",
      "khName": "ទីក្រុង ​ ស៊ូយ៉ាម៉ា",
      "neName": "त्सुयामा सहर"
    }
  },
  "3320400": {
    "office": {
      "code": "330000",
      "name": "岡山県",
      "enName": "Okayama",
      "officeName": "岡山地方気象台",
      "chName": "冈山县",
      "zhName": "岡山縣",
      "koName": "오카야마현",
      "esName": "Prefectura de Okayama",
      "ptName": "Província de Okayama",
      "thName": "จังหวัดโอคายามะ",
      "viName": "Tỉnh Okayama",
      "inName": "Prefektur Okayama",
      "tlName": "Okayama Prefecture",
      "moName": "Окаяма аймаг",
      "buName": "အိုကားယာ့မ ပြည်နယ်",
      "khName": "ខេត្ដ អូកាយ៉ាម៉ា",
      "neName": "ओकायामा जिल्ला"
    },
    "class10": {
      "code": "330010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "冈山县南部",
      "zhName": "岡山縣南部",
      "koName": "오카야마 현 남부",
      "esName": "Sur de Prefectura de Okayama",
      "ptName": "Sul da Província de Okayama",
      "thName": "จังหวัดโอกายามะตอนใต้",
      "viName": "Miền Nam tỉnh Okayama",
      "inName": "Bagian Selatan Prefektur Okayama",
      "tlName": "Timog na bahagi ng Okayama Prefecture",
      "moName": "Өмнөд Окаяма аймаг",
      "buName": "အိုကယမစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដអូកាយ៉ាម៉ា",
      "neName": "ओकायामा जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "330011",
      "name": "岡山地域",
      "enName": "Okayama Area"
    },
    "class20": {
      "code": "3320400",
      "name": "玉野市",
      "enName": "Tamano City",
      "kana": "たまのし",
      "chName": "玉野市",
      "zhName": "玉野市",
      "koName": "다마노 시",
      "esName": "Ciudad de Tamano",
      "ptName": "cidade de Tamano",
      "thName": "เมืองทามาโนะ",
      "viName": "thành phố Tamano",
      "inName": "kota Tamano",
      "tlName": "siyudad ng Tamano",
      "moName": "Тамaно хот",
      "buName": "တာမားနို မြို့",
      "khName": "ទីក្រុង តាម៉ាណូ",
      "neName": "तामानो सहर"
    }
  },
  "3320500": {
    "office": {
      "code": "330000",
      "name": "岡山県",
      "enName": "Okayama",
      "officeName": "岡山地方気象台",
      "chName": "冈山县",
      "zhName": "岡山縣",
      "koName": "오카야마현",
      "esName": "Prefectura de Okayama",
      "ptName": "Província de Okayama",
      "thName": "จังหวัดโอคายามะ",
      "viName": "Tỉnh Okayama",
      "inName": "Prefektur Okayama",
      "tlName": "Okayama Prefecture",
      "moName": "Окаяма аймаг",
      "buName": "အိုကားယာ့မ ပြည်နယ်",
      "khName": "ខេត្ដ អូកាយ៉ាម៉ា",
      "neName": "ओकायामा जिल्ला"
    },
    "class10": {
      "code": "330010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "冈山县南部",
      "zhName": "岡山縣南部",
      "koName": "오카야마 현 남부",
      "esName": "Sur de Prefectura de Okayama",
      "ptName": "Sul da Província de Okayama",
      "thName": "จังหวัดโอกายามะตอนใต้",
      "viName": "Miền Nam tỉnh Okayama",
      "inName": "Bagian Selatan Prefektur Okayama",
      "tlName": "Timog na bahagi ng Okayama Prefecture",
      "moName": "Өмнөд Окаяма аймаг",
      "buName": "အိုကယမစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដអូកាយ៉ាម៉ា",
      "neName": "ओकायामा जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "330014",
      "name": "井笠地域",
      "enName": "Ikasa Area"
    },
    "class20": {
      "code": "3320500",
      "name": "笠岡市",
      "enName": "Kasaoka City",
      "kana": "かさおかし",
      "chName": "笠冈市",
      "zhName": "笠岡市",
      "koName": "가사오카 시",
      "esName": "Ciudad de Kasaoka",
      "ptName": "cidade de Kasaoka",
      "thName": "เมืองคาซาโอกะ",
      "viName": "thành phố Kasaoka",
      "inName": "kota Kasaoka",
      "tlName": "siyudad ng Kasaoka",
      "moName": "Касaока хот",
      "buName": "ခါဆာ့အိုးက မြို့",
      "khName": "ទីក្រុង កាសាអូកា",
      "neName": "कासाओका सहर"
    }
  },
  "3320700": {
    "office": {
      "code": "330000",
      "name": "岡山県",
      "enName": "Okayama",
      "officeName": "岡山地方気象台",
      "chName": "冈山县",
      "zhName": "岡山縣",
      "koName": "오카야마현",
      "esName": "Prefectura de Okayama",
      "ptName": "Província de Okayama",
      "thName": "จังหวัดโอคายามะ",
      "viName": "Tỉnh Okayama",
      "inName": "Prefektur Okayama",
      "tlName": "Okayama Prefecture",
      "moName": "Окаяма аймаг",
      "buName": "အိုကားယာ့မ ပြည်နယ်",
      "khName": "ខេត្ដ អូកាយ៉ាម៉ា",
      "neName": "ओकायामा जिल्ला"
    },
    "class10": {
      "code": "330010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "冈山县南部",
      "zhName": "岡山縣南部",
      "koName": "오카야마 현 남부",
      "esName": "Sur de Prefectura de Okayama",
      "ptName": "Sul da Província de Okayama",
      "thName": "จังหวัดโอกายามะตอนใต้",
      "viName": "Miền Nam tỉnh Okayama",
      "inName": "Bagian Selatan Prefektur Okayama",
      "tlName": "Timog na bahagi ng Okayama Prefecture",
      "moName": "Өмнөд Окаяма аймаг",
      "buName": "အိုကယမစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដអូកាយ៉ាម៉ា",
      "neName": "ओकायामा जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "330014",
      "name": "井笠地域",
      "enName": "Ikasa Area"
    },
    "class20": {
      "code": "3320700",
      "name": "井原市",
      "enName": "Ibara City",
      "kana": "いばらし",
      "chName": "井原市",
      "zhName": "井原市",
      "koName": "이바라 시",
      "esName": "Ciudad de Ibara",
      "ptName": "cidade de Ibara",
      "thName": "เมืองอิบาระ",
      "viName": "thành phố Ibara",
      "inName": "kota Ibara",
      "tlName": "siyudad ng Ibara",
      "moName": "Ибара хот",
      "buName": "အီဘားရာ့ မြို့",
      "khName": "ទីក្រុង អ៊ីបារ៉ា",
      "neName": "इबारा सहर"
    }
  },
  "3320800": {
    "office": {
      "code": "330000",
      "name": "岡山県",
      "enName": "Okayama",
      "officeName": "岡山地方気象台",
      "chName": "冈山县",
      "zhName": "岡山縣",
      "koName": "오카야마현",
      "esName": "Prefectura de Okayama",
      "ptName": "Província de Okayama",
      "thName": "จังหวัดโอคายามะ",
      "viName": "Tỉnh Okayama",
      "inName": "Prefektur Okayama",
      "tlName": "Okayama Prefecture",
      "moName": "Окаяма аймаг",
      "buName": "အိုကားယာ့မ ပြည်နယ်",
      "khName": "ខេត្ដ អូកាយ៉ាម៉ា",
      "neName": "ओकायामा जिल्ला"
    },
    "class10": {
      "code": "330010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "冈山县南部",
      "zhName": "岡山縣南部",
      "koName": "오카야마 현 남부",
      "esName": "Sur de Prefectura de Okayama",
      "ptName": "Sul da Província de Okayama",
      "thName": "จังหวัดโอกายามะตอนใต้",
      "viName": "Miền Nam tỉnh Okayama",
      "inName": "Bagian Selatan Prefektur Okayama",
      "tlName": "Timog na bahagi ng Okayama Prefecture",
      "moName": "Өмнөд Окаяма аймаг",
      "buName": "အိုကယမစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដអូកាយ៉ាម៉ា",
      "neName": "ओकायामा जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "330013",
      "name": "倉敷地域",
      "enName": "Kurashiki Area"
    },
    "class20": {
      "code": "3320800",
      "name": "総社市",
      "enName": "Soja City",
      "kana": "そうじゃし",
      "chName": "总社市",
      "zhName": "總社市",
      "koName": "소자 시",
      "esName": "Ciudad de Sojya",
      "ptName": "cidade de Soja",
      "thName": "เมืองโซจะ",
      "viName": "thành phố Soja",
      "inName": "kota Soja",
      "tlName": "siyudad ng Soja",
      "moName": "Сожa хот",
      "buName": "ဆိုဂျာ မြို့",
      "khName": "ទីក្រុង សូចា",
      "neName": "सोजा सहर"
    }
  },
  "3320900": {
    "office": {
      "code": "330000",
      "name": "岡山県",
      "enName": "Okayama",
      "officeName": "岡山地方気象台",
      "chName": "冈山县",
      "zhName": "岡山縣",
      "koName": "오카야마현",
      "esName": "Prefectura de Okayama",
      "ptName": "Província de Okayama",
      "thName": "จังหวัดโอคายามะ",
      "viName": "Tỉnh Okayama",
      "inName": "Prefektur Okayama",
      "tlName": "Okayama Prefecture",
      "moName": "Окаяма аймаг",
      "buName": "အိုကားယာ့မ ပြည်နယ်",
      "khName": "ខេត្ដ អូកាយ៉ាម៉ា",
      "neName": "ओकायामा जिल्ला"
    },
    "class10": {
      "code": "330010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "冈山县南部",
      "zhName": "岡山縣南部",
      "koName": "오카야마 현 남부",
      "esName": "Sur de Prefectura de Okayama",
      "ptName": "Sul da Província de Okayama",
      "thName": "จังหวัดโอกายามะตอนใต้",
      "viName": "Miền Nam tỉnh Okayama",
      "inName": "Bagian Selatan Prefektur Okayama",
      "tlName": "Timog na bahagi ng Okayama Prefecture",
      "moName": "Өмнөд Окаяма аймаг",
      "buName": "အိုကယမစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដអូកាយ៉ាម៉ា",
      "neName": "ओकायामा जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "330015",
      "name": "高梁地域",
      "enName": "Takahashi Area"
    },
    "class20": {
      "code": "3320900",
      "name": "高梁市",
      "enName": "Takahashi City",
      "kana": "たかはしし",
      "chName": "高粱市",
      "zhName": "髙梁市",
      "koName": "다카하시 시",
      "esName": "Ciudad de Takahashi",
      "ptName": "cidade de Takahashi",
      "thName": "เมืองทากาฮาชิ",
      "viName": "thành phố Takahashi",
      "inName": "kota Takahashi",
      "tlName": "siyudad ng Takahashi",
      "moName": "Такахaши хот",
      "buName": "တာကားဟာ့ရှိ မြို့",
      "khName": "ទីក្រុង តាកាហាស៊ី",
      "neName": "ताकाहासी सहर"
    }
  },
  "3321000": {
    "office": {
      "code": "330000",
      "name": "岡山県",
      "enName": "Okayama",
      "officeName": "岡山地方気象台",
      "chName": "冈山县",
      "zhName": "岡山縣",
      "koName": "오카야마현",
      "esName": "Prefectura de Okayama",
      "ptName": "Província de Okayama",
      "thName": "จังหวัดโอคายามะ",
      "viName": "Tỉnh Okayama",
      "inName": "Prefektur Okayama",
      "tlName": "Okayama Prefecture",
      "moName": "Окаяма аймаг",
      "buName": "အိုကားယာ့မ ပြည်နယ်",
      "khName": "ខេត្ដ អូកាយ៉ាម៉ា",
      "neName": "ओकायामा जिल्ला"
    },
    "class10": {
      "code": "330020",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "冈山县北部",
      "zhName": "岡山縣北部",
      "koName": "오카야마 현 북부",
      "esName": "Norte de Prefectura de Okayama",
      "ptName": "Norte da Província de Okayama",
      "thName": "จังหวัดโอกายามะตอนเหนือ",
      "viName": "Miền Bắc tỉnh Okayama",
      "inName": "Bagian Utara Prefektur Okayama",
      "tlName": "Hilagang bahagi ng Okayama Prefecture",
      "moName": "Хойд Окаяма аймаг",
      "buName": "အိုကယမစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដអូកាយ៉ាម៉ា",
      "neName": "ओकायामा जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "330021",
      "name": "新見地域",
      "enName": "Niimi Area"
    },
    "class20": {
      "code": "3321000",
      "name": "新見市",
      "enName": "Niimi City",
      "kana": "にいみし",
      "chName": "新见市",
      "zhName": "新見市",
      "koName": "니미 시",
      "esName": "Ciudad de Niimi",
      "ptName": "cidade de Niimi",
      "thName": "เมืองนิอิมิ",
      "viName": "thành phố Niimi",
      "inName": "kota Niimi",
      "tlName": "siyudad ng Niimi",
      "moName": "Нийми хот",
      "buName": "ဏီးမိ မြို့",
      "khName": "ទីក្រុង នីមី",
      "neName": "निइमी सहर"
    }
  },
  "3321100": {
    "office": {
      "code": "330000",
      "name": "岡山県",
      "enName": "Okayama",
      "officeName": "岡山地方気象台",
      "chName": "冈山县",
      "zhName": "岡山縣",
      "koName": "오카야마현",
      "esName": "Prefectura de Okayama",
      "ptName": "Província de Okayama",
      "thName": "จังหวัดโอคายามะ",
      "viName": "Tỉnh Okayama",
      "inName": "Prefektur Okayama",
      "tlName": "Okayama Prefecture",
      "moName": "Окаяма аймаг",
      "buName": "အိုကားယာ့မ ပြည်နယ်",
      "khName": "ខេត្ដ អូកាយ៉ាម៉ា",
      "neName": "ओकायामा जिल्ला"
    },
    "class10": {
      "code": "330010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "冈山县南部",
      "zhName": "岡山縣南部",
      "koName": "오카야마 현 남부",
      "esName": "Sur de Prefectura de Okayama",
      "ptName": "Sul da Província de Okayama",
      "thName": "จังหวัดโอกายามะตอนใต้",
      "viName": "Miền Nam tỉnh Okayama",
      "inName": "Bagian Selatan Prefektur Okayama",
      "tlName": "Timog na bahagi ng Okayama Prefecture",
      "moName": "Өмнөд Окаяма аймаг",
      "buName": "အိုကယမစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដអូកាយ៉ាម៉ា",
      "neName": "ओकायामा जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "330012",
      "name": "東備地域",
      "enName": "Tobi Area"
    },
    "class20": {
      "code": "3321100",
      "name": "備前市",
      "enName": "Bizen City",
      "kana": "びぜんし",
      "chName": "备前市",
      "zhName": "備前市",
      "koName": "비젠 시",
      "esName": "Ciudad de Bizen",
      "ptName": "cidade de Bizen",
      "thName": "เมืองบิเซน",
      "viName": "thành phố Bizen",
      "inName": "kota Bizen",
      "tlName": "siyudad ng Bizen",
      "moName": "Бизэн хот",
      "buName": "ဘီဇန်း မြို့",
      "khName": "ទីក្រុង ប៊ីហ្សេន",
      "neName": "बिजेन सहर"
    }
  },
  "3321200": {
    "office": {
      "code": "330000",
      "name": "岡山県",
      "enName": "Okayama",
      "officeName": "岡山地方気象台",
      "chName": "冈山县",
      "zhName": "岡山縣",
      "koName": "오카야마현",
      "esName": "Prefectura de Okayama",
      "ptName": "Província de Okayama",
      "thName": "จังหวัดโอคายามะ",
      "viName": "Tỉnh Okayama",
      "inName": "Prefektur Okayama",
      "tlName": "Okayama Prefecture",
      "moName": "Окаяма аймаг",
      "buName": "အိုကားယာ့မ ပြည်နယ်",
      "khName": "ខេត្ដ អូកាយ៉ាម៉ា",
      "neName": "ओकायामा जिल्ला"
    },
    "class10": {
      "code": "330010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "冈山县南部",
      "zhName": "岡山縣南部",
      "koName": "오카야마 현 남부",
      "esName": "Sur de Prefectura de Okayama",
      "ptName": "Sul da Província de Okayama",
      "thName": "จังหวัดโอกายามะตอนใต้",
      "viName": "Miền Nam tỉnh Okayama",
      "inName": "Bagian Selatan Prefektur Okayama",
      "tlName": "Timog na bahagi ng Okayama Prefecture",
      "moName": "Өмнөд Окаяма аймаг",
      "buName": "အိုကယမစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដអូកាយ៉ាម៉ា",
      "neName": "ओकायामा जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "330011",
      "name": "岡山地域",
      "enName": "Okayama Area"
    },
    "class20": {
      "code": "3321200",
      "name": "瀬戸内市",
      "enName": "Setouchi City",
      "kana": "せとうちし",
      "chName": "濑户内市",
      "zhName": "瀨戶內市",
      "koName": "세토우치 시",
      "esName": "Ciudad de Setouchi",
      "ptName": "cidade de Setouchi",
      "thName": "เมืองเซโตะอุจิ",
      "viName": "thành phố Setouchi",
      "inName": "kota Setouchi",
      "tlName": "siyudad ng Setouchi",
      "moName": "Сэтоүчи хот",
      "buName": "ဆီတိုဟူးကျိ မြို့",
      "khName": "ទីក្រុង សេទូជី",
      "neName": "सेतोउची सहर"
    }
  },
  "3321300": {
    "office": {
      "code": "330000",
      "name": "岡山県",
      "enName": "Okayama",
      "officeName": "岡山地方気象台",
      "chName": "冈山县",
      "zhName": "岡山縣",
      "koName": "오카야마현",
      "esName": "Prefectura de Okayama",
      "ptName": "Província de Okayama",
      "thName": "จังหวัดโอคายามะ",
      "viName": "Tỉnh Okayama",
      "inName": "Prefektur Okayama",
      "tlName": "Okayama Prefecture",
      "moName": "Окаяма аймаг",
      "buName": "အိုကားယာ့မ ပြည်နယ်",
      "khName": "ខេត្ដ អូកាយ៉ាម៉ា",
      "neName": "ओकायामा जिल्ला"
    },
    "class10": {
      "code": "330010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "冈山县南部",
      "zhName": "岡山縣南部",
      "koName": "오카야마 현 남부",
      "esName": "Sur de Prefectura de Okayama",
      "ptName": "Sul da Província de Okayama",
      "thName": "จังหวัดโอกายามะตอนใต้",
      "viName": "Miền Nam tỉnh Okayama",
      "inName": "Bagian Selatan Prefektur Okayama",
      "tlName": "Timog na bahagi ng Okayama Prefecture",
      "moName": "Өмнөд Окаяма аймаг",
      "buName": "အိုကယမစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដអូកាយ៉ាម៉ា",
      "neName": "ओकायामा जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "330012",
      "name": "東備地域",
      "enName": "Tobi Area"
    },
    "class20": {
      "code": "3321300",
      "name": "赤磐市",
      "enName": "Akaiwa City",
      "kana": "あかいわし",
      "chName": "赤磐市",
      "zhName": "赤磐市",
      "koName": "아카이와 시",
      "esName": "Ciudad de Akaiwa",
      "ptName": "cidade de Akaiwa",
      "thName": "เมืองอาคาอิวะ",
      "viName": "thành phố Akaiwa",
      "inName": "kota Akaiwa",
      "tlName": "siyudad ng Akaiwa",
      "moName": "Aкайва хот",
      "buName": "အကိုင်းယိဝ မြို့",
      "khName": "ទីក្រុង អាកៃវ៉ា",
      "neName": "आकाइवा सहर"
    }
  },
  "3321400": {
    "office": {
      "code": "330000",
      "name": "岡山県",
      "enName": "Okayama",
      "officeName": "岡山地方気象台",
      "chName": "冈山县",
      "zhName": "岡山縣",
      "koName": "오카야마현",
      "esName": "Prefectura de Okayama",
      "ptName": "Província de Okayama",
      "thName": "จังหวัดโอคายามะ",
      "viName": "Tỉnh Okayama",
      "inName": "Prefektur Okayama",
      "tlName": "Okayama Prefecture",
      "moName": "Окаяма аймаг",
      "buName": "အိုကားယာ့မ ပြည်နယ်",
      "khName": "ខេត្ដ អូកាយ៉ាម៉ា",
      "neName": "ओकायामा जिल्ला"
    },
    "class10": {
      "code": "330020",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "冈山县北部",
      "zhName": "岡山縣北部",
      "koName": "오카야마 현 북부",
      "esName": "Norte de Prefectura de Okayama",
      "ptName": "Norte da Província de Okayama",
      "thName": "จังหวัดโอกายามะตอนเหนือ",
      "viName": "Miền Bắc tỉnh Okayama",
      "inName": "Bagian Utara Prefektur Okayama",
      "tlName": "Hilagang bahagi ng Okayama Prefecture",
      "moName": "Хойд Окаяма аймаг",
      "buName": "အိုကယမစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដអូកាយ៉ាម៉ា",
      "neName": "ओकायामा जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "330022",
      "name": "真庭地域",
      "enName": "Maniwa Area"
    },
    "class20": {
      "code": "3321400",
      "name": "真庭市",
      "enName": "Maniwa City",
      "kana": "まにわし",
      "chName": "真庭市",
      "zhName": "真庭市",
      "koName": "마니와 시",
      "esName": "Ciudad de Maniwa",
      "ptName": "cidade de Maniwa",
      "thName": "เมืองมานิวะ",
      "viName": "thành phố Maniwa",
      "inName": "kota Maniwa",
      "tlName": "siyudad ng Maniwa",
      "moName": "Мaнива хот",
      "buName": "မားနီဝ မြို့",
      "khName": "ទីក្រុង ម៉ានីវ៉ា",
      "neName": "मानिवा सहर"
    }
  },
  "3321500": {
    "office": {
      "code": "330000",
      "name": "岡山県",
      "enName": "Okayama",
      "officeName": "岡山地方気象台",
      "chName": "冈山县",
      "zhName": "岡山縣",
      "koName": "오카야마현",
      "esName": "Prefectura de Okayama",
      "ptName": "Província de Okayama",
      "thName": "จังหวัดโอคายามะ",
      "viName": "Tỉnh Okayama",
      "inName": "Prefektur Okayama",
      "tlName": "Okayama Prefecture",
      "moName": "Окаяма аймаг",
      "buName": "အိုကားယာ့မ ပြည်နယ်",
      "khName": "ខេត្ដ អូកាយ៉ាម៉ា",
      "neName": "ओकायामा जिल्ला"
    },
    "class10": {
      "code": "330020",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "冈山县北部",
      "zhName": "岡山縣北部",
      "koName": "오카야마 현 북부",
      "esName": "Norte de Prefectura de Okayama",
      "ptName": "Norte da Província de Okayama",
      "thName": "จังหวัดโอกายามะตอนเหนือ",
      "viName": "Miền Bắc tỉnh Okayama",
      "inName": "Bagian Utara Prefektur Okayama",
      "tlName": "Hilagang bahagi ng Okayama Prefecture",
      "moName": "Хойд Окаяма аймаг",
      "buName": "အိုကယမစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដអូកាយ៉ាម៉ា",
      "neName": "ओकायामा जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "330024",
      "name": "勝英地域",
      "enName": "Shoei Area"
    },
    "class20": {
      "code": "3321500",
      "name": "美作市",
      "enName": "Mimasaka City",
      "kana": "みまさかし",
      "chName": "美作市",
      "zhName": "美作市",
      "koName": "미마사카 시",
      "esName": "Ciudad de Mimasaka",
      "ptName": "cidade de Mimasaka",
      "thName": "เมืองมิมาซากะ",
      "viName": "thành phố Mimasaka",
      "inName": "kota Mimasaka",
      "tlName": "siyudad ng Mimasaka",
      "moName": "Мимaсaка хот",
      "buName": "မီမားဆာ့က မြို့",
      "khName": "ទីក្រុង មិម៉ាសាកា",
      "neName": "मिमासाका सहर"
    }
  },
  "3321600": {
    "office": {
      "code": "330000",
      "name": "岡山県",
      "enName": "Okayama",
      "officeName": "岡山地方気象台",
      "chName": "冈山县",
      "zhName": "岡山縣",
      "koName": "오카야마현",
      "esName": "Prefectura de Okayama",
      "ptName": "Província de Okayama",
      "thName": "จังหวัดโอคายามะ",
      "viName": "Tỉnh Okayama",
      "inName": "Prefektur Okayama",
      "tlName": "Okayama Prefecture",
      "moName": "Окаяма аймаг",
      "buName": "အိုကားယာ့မ ပြည်နယ်",
      "khName": "ខេត្ដ អូកាយ៉ាម៉ា",
      "neName": "ओकायामा जिल्ला"
    },
    "class10": {
      "code": "330010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "冈山县南部",
      "zhName": "岡山縣南部",
      "koName": "오카야마 현 남부",
      "esName": "Sur de Prefectura de Okayama",
      "ptName": "Sul da Província de Okayama",
      "thName": "จังหวัดโอกายามะตอนใต้",
      "viName": "Miền Nam tỉnh Okayama",
      "inName": "Bagian Selatan Prefektur Okayama",
      "tlName": "Timog na bahagi ng Okayama Prefecture",
      "moName": "Өмнөд Окаяма аймаг",
      "buName": "အိုကယမစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដអូកាយ៉ាម៉ា",
      "neName": "ओकायामा जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "330014",
      "name": "井笠地域",
      "enName": "Ikasa Area"
    },
    "class20": {
      "code": "3321600",
      "name": "浅口市",
      "enName": "Asakuchi City",
      "kana": "あさくちし",
      "chName": "浅口市",
      "zhName": "淺口市",
      "koName": "아사쿠치 시",
      "esName": "Ciudad de Asakuchi",
      "ptName": "cidade de Asakuchi",
      "thName": "เมืองอาซาคุจิ",
      "viName": "thành phố Asakuchi",
      "inName": "kota Asakuchi",
      "tlName": "siyudad ng Asakuchi",
      "moName": "Aсaкүчи хот",
      "buName": "အာဆာ့ကုကျိ မြို့",
      "khName": "ទីក្រុង អាសាគូជី",
      "neName": "आसाकुची सहर"
    }
  },
  "3334600": {
    "office": {
      "code": "330000",
      "name": "岡山県",
      "enName": "Okayama",
      "officeName": "岡山地方気象台",
      "chName": "冈山县",
      "zhName": "岡山縣",
      "koName": "오카야마현",
      "esName": "Prefectura de Okayama",
      "ptName": "Província de Okayama",
      "thName": "จังหวัดโอคายามะ",
      "viName": "Tỉnh Okayama",
      "inName": "Prefektur Okayama",
      "tlName": "Okayama Prefecture",
      "moName": "Окаяма аймаг",
      "buName": "အိုကားယာ့မ ပြည်နယ်",
      "khName": "ខេត្ដ អូកាយ៉ាម៉ា",
      "neName": "ओकायामा जिल्ला"
    },
    "class10": {
      "code": "330010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "冈山县南部",
      "zhName": "岡山縣南部",
      "koName": "오카야마 현 남부",
      "esName": "Sur de Prefectura de Okayama",
      "ptName": "Sul da Província de Okayama",
      "thName": "จังหวัดโอกายามะตอนใต้",
      "viName": "Miền Nam tỉnh Okayama",
      "inName": "Bagian Selatan Prefektur Okayama",
      "tlName": "Timog na bahagi ng Okayama Prefecture",
      "moName": "Өмнөд Окаяма аймаг",
      "buName": "အိုကယမစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដអូកាយ៉ាម៉ា",
      "neName": "ओकायामा जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "330012",
      "name": "東備地域",
      "enName": "Tobi Area"
    },
    "class20": {
      "code": "3334600",
      "name": "和気町",
      "enName": "Wake Town",
      "kana": "わけちょう",
      "chName": "和气町",
      "zhName": "和氣町",
      "koName": "와케 정",
      "esName": "Pueblo de Wake",
      "ptName": "bairro de Wake",
      "thName": "เมืองวาเคะ",
      "viName": "thị trấn Wake",
      "inName": "kota Wake",
      "tlName": "bayan ng Wake",
      "moName": "Вакэ жижиг хот",
      "buName": "ဝေးကု မြို့နယ်",
      "khName": "ទីប្រជុំជន វ៉ាកេ",
      "neName": "वाके नगर"
    }
  },
  "3342300": {
    "office": {
      "code": "330000",
      "name": "岡山県",
      "enName": "Okayama",
      "officeName": "岡山地方気象台",
      "chName": "冈山县",
      "zhName": "岡山縣",
      "koName": "오카야마현",
      "esName": "Prefectura de Okayama",
      "ptName": "Província de Okayama",
      "thName": "จังหวัดโอคายามะ",
      "viName": "Tỉnh Okayama",
      "inName": "Prefektur Okayama",
      "tlName": "Okayama Prefecture",
      "moName": "Окаяма аймаг",
      "buName": "အိုကားယာ့မ ပြည်နယ်",
      "khName": "ខេត្ដ អូកាយ៉ាម៉ា",
      "neName": "ओकायामा जिल्ला"
    },
    "class10": {
      "code": "330010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "冈山县南部",
      "zhName": "岡山縣南部",
      "koName": "오카야마 현 남부",
      "esName": "Sur de Prefectura de Okayama",
      "ptName": "Sul da Província de Okayama",
      "thName": "จังหวัดโอกายามะตอนใต้",
      "viName": "Miền Nam tỉnh Okayama",
      "inName": "Bagian Selatan Prefektur Okayama",
      "tlName": "Timog na bahagi ng Okayama Prefecture",
      "moName": "Өмнөд Окаяма аймаг",
      "buName": "အိုကယမစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដអូកាយ៉ាម៉ា",
      "neName": "ओकायामा जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "330013",
      "name": "倉敷地域",
      "enName": "Kurashiki Area"
    },
    "class20": {
      "code": "3342300",
      "name": "早島町",
      "enName": "Hayashima Town",
      "kana": "はやしまちょう",
      "chName": "早岛町",
      "zhName": "早島町",
      "koName": "하야시마 정",
      "esName": "Pueblo de Hayashima",
      "ptName": "bairro de Hayashima",
      "thName": "เมืองฮายาชิมะ",
      "viName": "thị trấn Hayashima",
      "inName": "kota Hayashima",
      "tlName": "bayan ng Hayashima",
      "moName": "Хaяшимa жижиг хот",
      "buName": "ဟာယားရှိမ မြို့နယ်",
      "khName": "ទីប្រជុំជន ហៃយ៉ាស៊ីម៉ា",
      "neName": "हायाशिमा नगर"
    }
  },
  "3344500": {
    "office": {
      "code": "330000",
      "name": "岡山県",
      "enName": "Okayama",
      "officeName": "岡山地方気象台",
      "chName": "冈山县",
      "zhName": "岡山縣",
      "koName": "오카야마현",
      "esName": "Prefectura de Okayama",
      "ptName": "Província de Okayama",
      "thName": "จังหวัดโอคายามะ",
      "viName": "Tỉnh Okayama",
      "inName": "Prefektur Okayama",
      "tlName": "Okayama Prefecture",
      "moName": "Окаяма аймаг",
      "buName": "အိုကားယာ့မ ပြည်နယ်",
      "khName": "ខេត្ដ អូកាយ៉ាម៉ា",
      "neName": "ओकायामा जिल्ला"
    },
    "class10": {
      "code": "330010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "冈山县南部",
      "zhName": "岡山縣南部",
      "koName": "오카야마 현 남부",
      "esName": "Sur de Prefectura de Okayama",
      "ptName": "Sul da Província de Okayama",
      "thName": "จังหวัดโอกายามะตอนใต้",
      "viName": "Miền Nam tỉnh Okayama",
      "inName": "Bagian Selatan Prefektur Okayama",
      "tlName": "Timog na bahagi ng Okayama Prefecture",
      "moName": "Өмнөд Окаяма аймаг",
      "buName": "အိုကယမစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដអូកាយ៉ាម៉ា",
      "neName": "ओकायामा जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "330014",
      "name": "井笠地域",
      "enName": "Ikasa Area"
    },
    "class20": {
      "code": "3344500",
      "name": "里庄町",
      "enName": "Satosho Town",
      "kana": "さとしょうちょう",
      "chName": "里庄町",
      "zhName": "里庒町",
      "koName": "사토쇼 정",
      "esName": "Pueblo de Satoshō",
      "ptName": "bairro de Satosho",
      "thName": "เมืองซาโตโช",
      "viName": "thị trấn Satosho",
      "inName": "kota Satosho",
      "tlName": "bayan ng Satosho",
      "moName": "Сaтошо жижиг хот",
      "buName": "ဆာတိုးရှို မြို့နယ်",
      "khName": "ទីប្រជុំជន សាតូស៊ូ",
      "neName": "सातोशो नगर"
    }
  },
  "3346100": {
    "office": {
      "code": "330000",
      "name": "岡山県",
      "enName": "Okayama",
      "officeName": "岡山地方気象台",
      "chName": "冈山县",
      "zhName": "岡山縣",
      "koName": "오카야마현",
      "esName": "Prefectura de Okayama",
      "ptName": "Província de Okayama",
      "thName": "จังหวัดโอคายามะ",
      "viName": "Tỉnh Okayama",
      "inName": "Prefektur Okayama",
      "tlName": "Okayama Prefecture",
      "moName": "Окаяма аймаг",
      "buName": "အိုကားယာ့မ ပြည်နယ်",
      "khName": "ខេត្ដ អូកាយ៉ាម៉ា",
      "neName": "ओकायामा जिल्ला"
    },
    "class10": {
      "code": "330010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "冈山县南部",
      "zhName": "岡山縣南部",
      "koName": "오카야마 현 남부",
      "esName": "Sur de Prefectura de Okayama",
      "ptName": "Sul da Província de Okayama",
      "thName": "จังหวัดโอกายามะตอนใต้",
      "viName": "Miền Nam tỉnh Okayama",
      "inName": "Bagian Selatan Prefektur Okayama",
      "tlName": "Timog na bahagi ng Okayama Prefecture",
      "moName": "Өмнөд Окаяма аймаг",
      "buName": "အိုကယမစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដអូកាយ៉ាម៉ា",
      "neName": "ओकायामा जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "330014",
      "name": "井笠地域",
      "enName": "Ikasa Area"
    },
    "class20": {
      "code": "3346100",
      "name": "矢掛町",
      "enName": "Yakage Town",
      "kana": "やかげちょう",
      "chName": "矢挂町",
      "zhName": "矢掛町",
      "koName": "야카게 정",
      "esName": "Pueblo de Yakage",
      "ptName": "bairro de Yakage",
      "thName": "เมืองยาคาเงะ",
      "viName": "thị trấn Yakage",
      "inName": "kota Yakage",
      "tlName": "bayan ng Yakage",
      "moName": "Якагэ жижиг хот",
      "buName": "ယာကာ့ဂဲ့ မြို့နယ်",
      "khName": "ទីប្រជុំជន យ៉ាខេជី",
      "neName": "याकागे नगर"
    }
  },
  "3358600": {
    "office": {
      "code": "330000",
      "name": "岡山県",
      "enName": "Okayama",
      "officeName": "岡山地方気象台",
      "chName": "冈山县",
      "zhName": "岡山縣",
      "koName": "오카야마현",
      "esName": "Prefectura de Okayama",
      "ptName": "Província de Okayama",
      "thName": "จังหวัดโอคายามะ",
      "viName": "Tỉnh Okayama",
      "inName": "Prefektur Okayama",
      "tlName": "Okayama Prefecture",
      "moName": "Окаяма аймаг",
      "buName": "အိုကားယာ့မ ပြည်နယ်",
      "khName": "ខេត្ដ អូកាយ៉ាម៉ា",
      "neName": "ओकायामा जिल्ला"
    },
    "class10": {
      "code": "330020",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "冈山县北部",
      "zhName": "岡山縣北部",
      "koName": "오카야마 현 북부",
      "esName": "Norte de Prefectura de Okayama",
      "ptName": "Norte da Província de Okayama",
      "thName": "จังหวัดโอกายามะตอนเหนือ",
      "viName": "Miền Bắc tỉnh Okayama",
      "inName": "Bagian Utara Prefektur Okayama",
      "tlName": "Hilagang bahagi ng Okayama Prefecture",
      "moName": "Хойд Окаяма аймаг",
      "buName": "အိုကယမစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដអូកាយ៉ាម៉ា",
      "neName": "ओकायामा जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "330022",
      "name": "真庭地域",
      "enName": "Maniwa Area"
    },
    "class20": {
      "code": "3358600",
      "name": "新庄村",
      "enName": "Shinjo Village",
      "kana": "しんじょうそん",
      "chName": "新庄村",
      "zhName": "新庒村",
      "koName": "신조 촌",
      "esName": "Aldea de Shinjyō",
      "ptName": "povoado de Shinjo",
      "thName": "หมู่บ้านชินโจ",
      "viName": "làng Shinjo",
      "inName": "desa Shinjo",
      "tlName": "nayon ng Shinjo",
      "moName": "Шинжо тосгон",
      "buName": "ရှင်းဂျို ကျေးရွာ",
      "khName": "ភូមិ ស៊ិនជូ",
      "neName": "शिन्जो गाउँ"
    }
  },
  "3360600": {
    "office": {
      "code": "330000",
      "name": "岡山県",
      "enName": "Okayama",
      "officeName": "岡山地方気象台",
      "chName": "冈山县",
      "zhName": "岡山縣",
      "koName": "오카야마현",
      "esName": "Prefectura de Okayama",
      "ptName": "Província de Okayama",
      "thName": "จังหวัดโอคายามะ",
      "viName": "Tỉnh Okayama",
      "inName": "Prefektur Okayama",
      "tlName": "Okayama Prefecture",
      "moName": "Окаяма аймаг",
      "buName": "အိုကားယာ့မ ပြည်နယ်",
      "khName": "ខេត្ដ អូកាយ៉ាម៉ា",
      "neName": "ओकायामा जिल्ला"
    },
    "class10": {
      "code": "330020",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "冈山县北部",
      "zhName": "岡山縣北部",
      "koName": "오카야마 현 북부",
      "esName": "Norte de Prefectura de Okayama",
      "ptName": "Norte da Província de Okayama",
      "thName": "จังหวัดโอกายามะตอนเหนือ",
      "viName": "Miền Bắc tỉnh Okayama",
      "inName": "Bagian Utara Prefektur Okayama",
      "tlName": "Hilagang bahagi ng Okayama Prefecture",
      "moName": "Хойд Окаяма аймаг",
      "buName": "အိုကယမစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដអូកាយ៉ាម៉ា",
      "neName": "ओकायामा जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "330023",
      "name": "津山地域",
      "enName": "Tsuyama Area"
    },
    "class20": {
      "code": "3360600",
      "name": "鏡野町",
      "enName": "Kagamino Town",
      "kana": "かがみのちょう",
      "chName": "镜野町",
      "zhName": "鏡野町",
      "koName": "가가미노 정",
      "esName": "Pueblo de Kagamino",
      "ptName": "bairro de Kagamino",
      "thName": "เมืองคางามิโนะ",
      "viName": "thị trấn Kagamino",
      "inName": "kota Kagamino",
      "tlName": "bayan ng Kagamino",
      "moName": "Кагaмино жижиг хот",
      "buName": "ခါဂါမိနို မြို့နယ်",
      "khName": "ទីប្រជុំជន កាហ្គាមីណូ",
      "neName": "कागामिनो नगर"
    }
  },
  "3362200": {
    "office": {
      "code": "330000",
      "name": "岡山県",
      "enName": "Okayama",
      "officeName": "岡山地方気象台",
      "chName": "冈山县",
      "zhName": "岡山縣",
      "koName": "오카야마현",
      "esName": "Prefectura de Okayama",
      "ptName": "Província de Okayama",
      "thName": "จังหวัดโอคายามะ",
      "viName": "Tỉnh Okayama",
      "inName": "Prefektur Okayama",
      "tlName": "Okayama Prefecture",
      "moName": "Окаяма аймаг",
      "buName": "အိုကားယာ့မ ပြည်နယ်",
      "khName": "ខេត្ដ អូកាយ៉ាម៉ា",
      "neName": "ओकायामा जिल्ला"
    },
    "class10": {
      "code": "330020",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "冈山县北部",
      "zhName": "岡山縣北部",
      "koName": "오카야마 현 북부",
      "esName": "Norte de Prefectura de Okayama",
      "ptName": "Norte da Província de Okayama",
      "thName": "จังหวัดโอกายามะตอนเหนือ",
      "viName": "Miền Bắc tỉnh Okayama",
      "inName": "Bagian Utara Prefektur Okayama",
      "tlName": "Hilagang bahagi ng Okayama Prefecture",
      "moName": "Хойд Окаяма аймаг",
      "buName": "အိုကယမစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដអូកាយ៉ាម៉ា",
      "neName": "ओकायामा जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "330024",
      "name": "勝英地域",
      "enName": "Shoei Area"
    },
    "class20": {
      "code": "3362200",
      "name": "勝央町",
      "enName": "Shoo Town",
      "kana": "しょうおうちょう",
      "chName": "胜央町",
      "zhName": "勝央町",
      "koName": "쇼오 정",
      "esName": "Pueblo de Shōō",
      "ptName": "bairro de Shoo",
      "thName": "เมืองโช",
      "viName": "thị trấn Shoo",
      "inName": "kota Shoo",
      "tlName": "bayan ng Shoo",
      "moName": "Шоо жижиг хот",
      "buName": "သျှူး မြို့နယ်",
      "khName": "ទីប្រជុំជន ស៊ូ",
      "neName": "शु नगर"
    }
  },
  "3362300": {
    "office": {
      "code": "330000",
      "name": "岡山県",
      "enName": "Okayama",
      "officeName": "岡山地方気象台",
      "chName": "冈山县",
      "zhName": "岡山縣",
      "koName": "오카야마현",
      "esName": "Prefectura de Okayama",
      "ptName": "Província de Okayama",
      "thName": "จังหวัดโอคายามะ",
      "viName": "Tỉnh Okayama",
      "inName": "Prefektur Okayama",
      "tlName": "Okayama Prefecture",
      "moName": "Окаяма аймаг",
      "buName": "အိုကားယာ့မ ပြည်နယ်",
      "khName": "ខេត្ដ អូកាយ៉ាម៉ា",
      "neName": "ओकायामा जिल्ला"
    },
    "class10": {
      "code": "330020",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "冈山县北部",
      "zhName": "岡山縣北部",
      "koName": "오카야마 현 북부",
      "esName": "Norte de Prefectura de Okayama",
      "ptName": "Norte da Província de Okayama",
      "thName": "จังหวัดโอกายามะตอนเหนือ",
      "viName": "Miền Bắc tỉnh Okayama",
      "inName": "Bagian Utara Prefektur Okayama",
      "tlName": "Hilagang bahagi ng Okayama Prefecture",
      "moName": "Хойд Окаяма аймаг",
      "buName": "အိုကယမစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដអូកាយ៉ាម៉ា",
      "neName": "ओकायामा जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "330024",
      "name": "勝英地域",
      "enName": "Shoei Area"
    },
    "class20": {
      "code": "3362300",
      "name": "奈義町",
      "enName": "Nagi Town",
      "kana": "なぎちょう",
      "chName": "奈义町",
      "zhName": "奈義町",
      "koName": "나기 정",
      "esName": "Pueblo de Nagi",
      "ptName": "bairro de Nagi",
      "thName": "เมืองนางิ",
      "viName": "thị trấn Nagi",
      "inName": "kota Nagi",
      "tlName": "bayan ng Nagi",
      "moName": "Нaги жижиг хот",
      "buName": "နာဂိ မြို့နယ်",
      "khName": "ទីប្រជុំជន ណាហ្គី",
      "neName": "नागी नगर"
    }
  },
  "3364300": {
    "office": {
      "code": "330000",
      "name": "岡山県",
      "enName": "Okayama",
      "officeName": "岡山地方気象台",
      "chName": "冈山县",
      "zhName": "岡山縣",
      "koName": "오카야마현",
      "esName": "Prefectura de Okayama",
      "ptName": "Província de Okayama",
      "thName": "จังหวัดโอคายามะ",
      "viName": "Tỉnh Okayama",
      "inName": "Prefektur Okayama",
      "tlName": "Okayama Prefecture",
      "moName": "Окаяма аймаг",
      "buName": "အိုကားယာ့မ ပြည်နယ်",
      "khName": "ខេត្ដ អូកាយ៉ាម៉ា",
      "neName": "ओकायामा जिल्ला"
    },
    "class10": {
      "code": "330020",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "冈山县北部",
      "zhName": "岡山縣北部",
      "koName": "오카야마 현 북부",
      "esName": "Norte de Prefectura de Okayama",
      "ptName": "Norte da Província de Okayama",
      "thName": "จังหวัดโอกายามะตอนเหนือ",
      "viName": "Miền Bắc tỉnh Okayama",
      "inName": "Bagian Utara Prefektur Okayama",
      "tlName": "Hilagang bahagi ng Okayama Prefecture",
      "moName": "Хойд Окаяма аймаг",
      "buName": "အိုကယမစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដអូកាយ៉ាម៉ា",
      "neName": "ओकायामा जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "330024",
      "name": "勝英地域",
      "enName": "Shoei Area"
    },
    "class20": {
      "code": "3364300",
      "name": "西粟倉村",
      "enName": "Nishiawakura Village",
      "kana": "にしあわくらそん",
      "chName": "西粟仓村",
      "zhName": "西栗倉村",
      "koName": "니시아와쿠라 촌",
      "esName": "Aldea de Nishiawakura",
      "ptName": "povoado de Nishiawakura",
      "thName": "หมู่บ้านนิชิอาวาคารุ",
      "viName": "làng Nishiawakura",
      "inName": "desa Nishiawakura",
      "tlName": "nayon ng Nishiawakura",
      "moName": "Нишиавакүра тосгон",
      "buName": "နီရှိယဝါ့ကုရ ကျေးရွာ",
      "khName": "ភូមិ នីស៊ីអាវ៉ាគូរ៉ា",
      "neName": "निशिआवाकुरा गाउँ"
    }
  },
  "3366300": {
    "office": {
      "code": "330000",
      "name": "岡山県",
      "enName": "Okayama",
      "officeName": "岡山地方気象台",
      "chName": "冈山县",
      "zhName": "岡山縣",
      "koName": "오카야마현",
      "esName": "Prefectura de Okayama",
      "ptName": "Província de Okayama",
      "thName": "จังหวัดโอคายามะ",
      "viName": "Tỉnh Okayama",
      "inName": "Prefektur Okayama",
      "tlName": "Okayama Prefecture",
      "moName": "Окаяма аймаг",
      "buName": "အိုကားယာ့မ ပြည်နယ်",
      "khName": "ខេត្ដ អូកាយ៉ាម៉ា",
      "neName": "ओकायामा जिल्ला"
    },
    "class10": {
      "code": "330020",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "冈山县北部",
      "zhName": "岡山縣北部",
      "koName": "오카야마 현 북부",
      "esName": "Norte de Prefectura de Okayama",
      "ptName": "Norte da Província de Okayama",
      "thName": "จังหวัดโอกายามะตอนเหนือ",
      "viName": "Miền Bắc tỉnh Okayama",
      "inName": "Bagian Utara Prefektur Okayama",
      "tlName": "Hilagang bahagi ng Okayama Prefecture",
      "moName": "Хойд Окаяма аймаг",
      "buName": "အိုကယမစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដអូកាយ៉ាម៉ា",
      "neName": "ओकायामा जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "330023",
      "name": "津山地域",
      "enName": "Tsuyama Area"
    },
    "class20": {
      "code": "3366300",
      "name": "久米南町",
      "enName": "Kumenan Town",
      "kana": "くめなんちょう",
      "chName": "久米南町",
      "zhName": "久米南町",
      "koName": "구메난 정",
      "esName": "Pueblo de Kumenan",
      "ptName": "bairro de Kumenan",
      "thName": "เมืองคุเมนัน",
      "viName": "thị trấn Kumenan",
      "inName": "kota Kumenan",
      "tlName": "bayan ng Kumenan",
      "moName": "Күмэнaн жижиг хот",
      "buName": "ခူမဲ့နန် မြို့နယ်",
      "khName": "ទីប្រជុំជន គូមេណាន",
      "neName": "कुमेनान नगर"
    }
  },
  "3366600": {
    "office": {
      "code": "330000",
      "name": "岡山県",
      "enName": "Okayama",
      "officeName": "岡山地方気象台",
      "chName": "冈山县",
      "zhName": "岡山縣",
      "koName": "오카야마현",
      "esName": "Prefectura de Okayama",
      "ptName": "Província de Okayama",
      "thName": "จังหวัดโอคายามะ",
      "viName": "Tỉnh Okayama",
      "inName": "Prefektur Okayama",
      "tlName": "Okayama Prefecture",
      "moName": "Окаяма аймаг",
      "buName": "အိုကားယာ့မ ပြည်နယ်",
      "khName": "ខេត្ដ អូកាយ៉ាម៉ា",
      "neName": "ओकायामा जिल्ला"
    },
    "class10": {
      "code": "330020",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "冈山县北部",
      "zhName": "岡山縣北部",
      "koName": "오카야마 현 북부",
      "esName": "Norte de Prefectura de Okayama",
      "ptName": "Norte da Província de Okayama",
      "thName": "จังหวัดโอกายามะตอนเหนือ",
      "viName": "Miền Bắc tỉnh Okayama",
      "inName": "Bagian Utara Prefektur Okayama",
      "tlName": "Hilagang bahagi ng Okayama Prefecture",
      "moName": "Хойд Окаяма аймаг",
      "buName": "အိုကယမစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដអូកាយ៉ាម៉ា",
      "neName": "ओकायामा जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "330023",
      "name": "津山地域",
      "enName": "Tsuyama Area"
    },
    "class20": {
      "code": "3366600",
      "name": "美咲町",
      "enName": "Misaki Town",
      "kana": "みさきちょう",
      "chName": "冈山美咲町",
      "zhName": "岡山美咲町",
      "koName": "오카야마 미사키 정",
      "esName": "Pueblo de Misaki, Okayama",
      "ptName": "Okayama, bairro de Misaki",
      "thName": "เมืองมิซากิ โอะกายามะ",
      "viName": "Thị trấn Misaki, Okayama",
      "inName": "Distrik Kota Misaki, Okayama",
      "tlName": "bayan ng Misaki, Okayama",
      "moName": "Окаяма Мисаки жижиг хот",
      "buName": "အိုကယမမိဆခိမြို့နယ် ",
      "khName": "ទីប្រជុំជនមីសាគី អូកាយ៉ាម៉ា",
      "neName": "ओकायामा मिसाकी नगर"
    }
  },
  "3368100": {
    "office": {
      "code": "330000",
      "name": "岡山県",
      "enName": "Okayama",
      "officeName": "岡山地方気象台",
      "chName": "冈山县",
      "zhName": "岡山縣",
      "koName": "오카야마현",
      "esName": "Prefectura de Okayama",
      "ptName": "Província de Okayama",
      "thName": "จังหวัดโอคายามะ",
      "viName": "Tỉnh Okayama",
      "inName": "Prefektur Okayama",
      "tlName": "Okayama Prefecture",
      "moName": "Окаяма аймаг",
      "buName": "အိုကားယာ့မ ပြည်နယ်",
      "khName": "ខេត្ដ អូកាយ៉ាម៉ា",
      "neName": "ओकायामा जिल्ला"
    },
    "class10": {
      "code": "330010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "冈山县南部",
      "zhName": "岡山縣南部",
      "koName": "오카야마 현 남부",
      "esName": "Sur de Prefectura de Okayama",
      "ptName": "Sul da Província de Okayama",
      "thName": "จังหวัดโอกายามะตอนใต้",
      "viName": "Miền Nam tỉnh Okayama",
      "inName": "Bagian Selatan Prefektur Okayama",
      "tlName": "Timog na bahagi ng Okayama Prefecture",
      "moName": "Өмнөд Окаяма аймаг",
      "buName": "အိုကယမစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដអូកាយ៉ាម៉ា",
      "neName": "ओकायामा जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "330011",
      "name": "岡山地域",
      "enName": "Okayama Area"
    },
    "class20": {
      "code": "3368100",
      "name": "吉備中央町",
      "enName": "Kibichuo Town",
      "kana": "きびちゅうおうちょう",
      "chName": "吉备中央町",
      "zhName": "吉備中央町",
      "koName": "기비추오 정",
      "esName": "Pueblo de Kibichūō",
      "ptName": "bairro de Kibichuo",
      "thName": "เมืองคิบิชูโอ",
      "viName": "thị trấn Kibichuo",
      "inName": "kota Kibichuo",
      "tlName": "bayan ng Kibichuo",
      "moName": "Кибичүо жижиг хот",
      "buName": "ခီဘိကျော့ မြို့နယ်",
      "khName": "ទីប្រជុំជន គីប៊ីជួ",
      "neName": "किबिचुओ नगर"
    }
  },
  "3410100": {
    "office": {
      "code": "340000",
      "name": "広島県",
      "enName": "Hiroshima",
      "officeName": "広島地方気象台",
      "chName": "广岛县",
      "zhName": "廣島縣",
      "koName": "히로시마현",
      "esName": "Prefectura de Hiroshima",
      "ptName": "Província de Hiroshima",
      "thName": "จังหวัดฮิโรชิมะ",
      "viName": "Tỉnh Hiroshima",
      "inName": "Prefektur Hiroshima",
      "tlName": "Hiroshima Prefecture",
      "moName": "Хирошима аймаг",
      "buName": "ဟီရိုရှိမ ပြည်နယ်",
      "khName": "ខេត្ដ ហ៊ីរ៉ូស៊ីម៉ា",
      "neName": "हिरोसिमा जिल्ला"
    },
    "class10": {
      "code": "340010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "广岛县南部",
      "zhName": "廣島縣南部",
      "koName": "히로시마 현 남부",
      "esName": "Sur de Prefectura de Hiroshima",
      "ptName": "Sul da Província de Hiroshima",
      "thName": "จังหวัดฮิโรชิมะตอนใต้",
      "viName": "Miền Nam tỉnh Hiroshima",
      "inName": "Bagian Selatan Prefektur Hiroshima",
      "tlName": "Timog bahagi ng Hiroshima Prefecture",
      "moName": "Өмнөд Хирошима аймаг",
      "buName": "ဟိရိုရှီးမားစီရင်စု အရှေ့တောင်ပိုင်း",
      "khName": "តំបន់ជើងខាងត្បូងនៃខេត្ដហ៊ីរ៉ូស៊ីម៉ា",
      "neName": "हिरोसिमा जिल्लाको दक्षिण भाग"
    },
    "class15": {
      "code": "340011",
      "name": "広島・呉",
      "enName": "Hiroshima Kure"
    },
    "class20": {
      "code": "3410100",
      "name": "広島市中区",
      "enName": "Hiroshima City Naka Ward",
      "kana": "ひろしましなかく",
      "chName": "广岛中区",
      "zhName": "廣島中區",
      "koName": "히로시마 나카 구",
      "esName": "Distrito Naka, Hiroshima",
      "ptName": "Hiroshima, distrito de Naka",
      "thName": "เมืองนากะ ฮิโรชิมะ",
      "viName": "phường Naka, Hiroshima",
      "inName": "Distrik Kota Naka, Hiroshima",
      "tlName": "Naka Ward, Hiroshima",
      "moName": "Хирошима Нака дүүрэг",
      "buName": "ဟိရိုရှိမနကရပ်ကွက်",
      "khName": "សង្កាត់ណាកា ហ៊ីរ៉ូស៊ីម៉ា",
      "neName": "हिरोसिमा नाका वडा"
    }
  },
  "3410200": {
    "office": {
      "code": "340000",
      "name": "広島県",
      "enName": "Hiroshima",
      "officeName": "広島地方気象台",
      "chName": "广岛县",
      "zhName": "廣島縣",
      "koName": "히로시마현",
      "esName": "Prefectura de Hiroshima",
      "ptName": "Província de Hiroshima",
      "thName": "จังหวัดฮิโรชิมะ",
      "viName": "Tỉnh Hiroshima",
      "inName": "Prefektur Hiroshima",
      "tlName": "Hiroshima Prefecture",
      "moName": "Хирошима аймаг",
      "buName": "ဟီရိုရှိမ ပြည်နယ်",
      "khName": "ខេត្ដ ហ៊ីរ៉ូស៊ីម៉ា",
      "neName": "हिरोसिमा जिल्ला"
    },
    "class10": {
      "code": "340010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "广岛县南部",
      "zhName": "廣島縣南部",
      "koName": "히로시마 현 남부",
      "esName": "Sur de Prefectura de Hiroshima",
      "ptName": "Sul da Província de Hiroshima",
      "thName": "จังหวัดฮิโรชิมะตอนใต้",
      "viName": "Miền Nam tỉnh Hiroshima",
      "inName": "Bagian Selatan Prefektur Hiroshima",
      "tlName": "Timog bahagi ng Hiroshima Prefecture",
      "moName": "Өмнөд Хирошима аймаг",
      "buName": "ဟိရိုရှီးမားစီရင်စု အရှေ့တောင်ပိုင်း",
      "khName": "តំបន់ជើងខាងត្បូងនៃខេត្ដហ៊ីរ៉ូស៊ីម៉ា",
      "neName": "हिरोसिमा जिल्लाको दक्षिण भाग"
    },
    "class15": {
      "code": "340011",
      "name": "広島・呉",
      "enName": "Hiroshima Kure"
    },
    "class20": {
      "code": "3410200",
      "name": "広島市東区",
      "enName": "Hiroshima City Higashi Ward",
      "kana": "ひろしましひがしく",
      "chName": "广岛东区",
      "zhName": "廣島東區",
      "koName": "히로시마 히가시 구",
      "esName": "Distrito Higashi, Hiroshima",
      "ptName": "Hiroshima, distrito de Higashi",
      "thName": "เมืองฮิงาชิ ฮิโรชิมะ",
      "viName": "phường Higashi, Hiroshima",
      "inName": "Distrik Kota Higashi, Hiroshima",
      "tlName": "Higashi Ward, Hiroshima",
      "moName": "Хироошима Хигаши дүүрэг",
      "buName": "ဟိရိုရှိမဟိဂရှိရပ်ကွက်",
      "khName": "សង្កាត់ហ៊ីហ្កាស៊ី ហ៊ីរ៉ូស៊ីម៉ា",
      "neName": "हिरोसिमा हिगाशी वडा"
    }
  },
  "3410300": {
    "office": {
      "code": "340000",
      "name": "広島県",
      "enName": "Hiroshima",
      "officeName": "広島地方気象台",
      "chName": "广岛县",
      "zhName": "廣島縣",
      "koName": "히로시마현",
      "esName": "Prefectura de Hiroshima",
      "ptName": "Província de Hiroshima",
      "thName": "จังหวัดฮิโรชิมะ",
      "viName": "Tỉnh Hiroshima",
      "inName": "Prefektur Hiroshima",
      "tlName": "Hiroshima Prefecture",
      "moName": "Хирошима аймаг",
      "buName": "ဟီရိုရှိမ ပြည်နယ်",
      "khName": "ខេត្ដ ហ៊ីរ៉ូស៊ីម៉ា",
      "neName": "हिरोसिमा जिल्ला"
    },
    "class10": {
      "code": "340010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "广岛县南部",
      "zhName": "廣島縣南部",
      "koName": "히로시마 현 남부",
      "esName": "Sur de Prefectura de Hiroshima",
      "ptName": "Sul da Província de Hiroshima",
      "thName": "จังหวัดฮิโรชิมะตอนใต้",
      "viName": "Miền Nam tỉnh Hiroshima",
      "inName": "Bagian Selatan Prefektur Hiroshima",
      "tlName": "Timog bahagi ng Hiroshima Prefecture",
      "moName": "Өмнөд Хирошима аймаг",
      "buName": "ဟိရိုရှီးမားစီရင်စု အရှေ့တောင်ပိုင်း",
      "khName": "តំបន់ជើងខាងត្បូងនៃខេត្ដហ៊ីរ៉ូស៊ីម៉ា",
      "neName": "हिरोसिमा जिल्लाको दक्षिण भाग"
    },
    "class15": {
      "code": "340011",
      "name": "広島・呉",
      "enName": "Hiroshima Kure"
    },
    "class20": {
      "code": "3410300",
      "name": "広島市南区",
      "enName": "Hiroshima City Minami Ward",
      "kana": "ひろしましみなみく",
      "chName": "广岛南区",
      "zhName": "廣島南區",
      "koName": "히로시마 미나미 구",
      "esName": "Distrito Minami, Hiroshima",
      "ptName": "Hiroshima, distrito de Minami",
      "thName": "เมืองมินามิ ฮิโรชิมะ",
      "viName": "phường Minami, Hiroshima",
      "inName": "Distrik Kota Minami, Hiroshima",
      "tlName": "Minami Ward, Hiroshima",
      "moName": "Хирошима Минами дүүрэг",
      "buName": "ဟိရိုရှိမမိနမိရပ်ကွက်",
      "khName": "សង្កាត់មីណាមិ ហ៊ីរ៉ូស៊ីម៉ា",
      "neName": "हिरोसिमा मिनामी वडा"
    }
  },
  "3410400": {
    "office": {
      "code": "340000",
      "name": "広島県",
      "enName": "Hiroshima",
      "officeName": "広島地方気象台",
      "chName": "广岛县",
      "zhName": "廣島縣",
      "koName": "히로시마현",
      "esName": "Prefectura de Hiroshima",
      "ptName": "Província de Hiroshima",
      "thName": "จังหวัดฮิโรชิมะ",
      "viName": "Tỉnh Hiroshima",
      "inName": "Prefektur Hiroshima",
      "tlName": "Hiroshima Prefecture",
      "moName": "Хирошима аймаг",
      "buName": "ဟီရိုရှိမ ပြည်နယ်",
      "khName": "ខេត្ដ ហ៊ីរ៉ូស៊ីម៉ា",
      "neName": "हिरोसिमा जिल्ला"
    },
    "class10": {
      "code": "340010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "广岛县南部",
      "zhName": "廣島縣南部",
      "koName": "히로시마 현 남부",
      "esName": "Sur de Prefectura de Hiroshima",
      "ptName": "Sul da Província de Hiroshima",
      "thName": "จังหวัดฮิโรชิมะตอนใต้",
      "viName": "Miền Nam tỉnh Hiroshima",
      "inName": "Bagian Selatan Prefektur Hiroshima",
      "tlName": "Timog bahagi ng Hiroshima Prefecture",
      "moName": "Өмнөд Хирошима аймаг",
      "buName": "ဟိရိုရှီးမားစီရင်စု အရှေ့တောင်ပိုင်း",
      "khName": "តំបន់ជើងខាងត្បូងនៃខេត្ដហ៊ីរ៉ូស៊ីម៉ា",
      "neName": "हिरोसिमा जिल्लाको दक्षिण भाग"
    },
    "class15": {
      "code": "340011",
      "name": "広島・呉",
      "enName": "Hiroshima Kure"
    },
    "class20": {
      "code": "3410400",
      "name": "広島市西区",
      "enName": "Hiroshima City Nishi Ward",
      "kana": "ひろしましにしく",
      "chName": "广岛西区",
      "zhName": "廣島西區",
      "koName": "히로시마 니시 구",
      "esName": "Distrito Nishi, Hiroshima",
      "ptName": "Hiroshima, distrito de Nishi",
      "thName": "เมืองนิชิ ฮิโรชิมะ",
      "viName": "phường Nishi, Hiroshima",
      "inName": "Distrik Kota Nishi, Hiroshima",
      "tlName": "Nishi Ward, Hiroshima",
      "moName": "Хирошима Ниши дүүрэг",
      "buName": "ဟိရိုရှိမနိရှိရပ်ကွက်",
      "khName": "សង្កាត់នីស៊ី ហ៊ីរ៉ូស៊ីម៉ា",
      "neName": "हिरोसिमा निशी वडा"
    }
  },
  "3410500": {
    "office": {
      "code": "340000",
      "name": "広島県",
      "enName": "Hiroshima",
      "officeName": "広島地方気象台",
      "chName": "广岛县",
      "zhName": "廣島縣",
      "koName": "히로시마현",
      "esName": "Prefectura de Hiroshima",
      "ptName": "Província de Hiroshima",
      "thName": "จังหวัดฮิโรชิมะ",
      "viName": "Tỉnh Hiroshima",
      "inName": "Prefektur Hiroshima",
      "tlName": "Hiroshima Prefecture",
      "moName": "Хирошима аймаг",
      "buName": "ဟီရိုရှိမ ပြည်နယ်",
      "khName": "ខេត្ដ ហ៊ីរ៉ូស៊ីម៉ា",
      "neName": "हिरोसिमा जिल्ला"
    },
    "class10": {
      "code": "340010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "广岛县南部",
      "zhName": "廣島縣南部",
      "koName": "히로시마 현 남부",
      "esName": "Sur de Prefectura de Hiroshima",
      "ptName": "Sul da Província de Hiroshima",
      "thName": "จังหวัดฮิโรชิมะตอนใต้",
      "viName": "Miền Nam tỉnh Hiroshima",
      "inName": "Bagian Selatan Prefektur Hiroshima",
      "tlName": "Timog bahagi ng Hiroshima Prefecture",
      "moName": "Өмнөд Хирошима аймаг",
      "buName": "ဟိရိုရှီးမားစီရင်စု အရှေ့တောင်ပိုင်း",
      "khName": "តំបន់ជើងខាងត្បូងនៃខេត្ដហ៊ីរ៉ូស៊ីម៉ា",
      "neName": "हिरोसिमा जिल्लाको दक्षिण भाग"
    },
    "class15": {
      "code": "340011",
      "name": "広島・呉",
      "enName": "Hiroshima Kure"
    },
    "class20": {
      "code": "3410500",
      "name": "広島市安佐南区",
      "enName": "Hiroshima City Asaminami Ward",
      "kana": "ひろしましあさみなみく",
      "chName": "广岛安佐南区",
      "zhName": "廣島安佐南區",
      "koName": "히로시마 아사미나미 구",
      "esName": "Distrito Asaminami, Hiroshima",
      "ptName": "Hiroshima, distrito de Asaminami",
      "thName": "เมืองอาซามินามิ ฮิโรชิมะ",
      "viName": "phường Asaminami, Hiroshima",
      "inName": "Distrik Kota Asaminami, Hiroshima",
      "tlName": "Asaminami Ward, Hiroshima",
      "moName": "Хирошима Аса минами дүүрэг",
      "buName": "ဟိရိုရှိမအဆမိနမိရပ်ကွက်",
      "khName": "សង្កាត់អាសាមិណាមិន ហ៊ីរ៉ូស៊ីម៉ា",
      "neName": "हिरोसिमा आसामिनामी वडा"
    }
  },
  "3410600": {
    "office": {
      "code": "340000",
      "name": "広島県",
      "enName": "Hiroshima",
      "officeName": "広島地方気象台",
      "chName": "广岛县",
      "zhName": "廣島縣",
      "koName": "히로시마현",
      "esName": "Prefectura de Hiroshima",
      "ptName": "Província de Hiroshima",
      "thName": "จังหวัดฮิโรชิมะ",
      "viName": "Tỉnh Hiroshima",
      "inName": "Prefektur Hiroshima",
      "tlName": "Hiroshima Prefecture",
      "moName": "Хирошима аймаг",
      "buName": "ဟီရိုရှိမ ပြည်နယ်",
      "khName": "ខេត្ដ ហ៊ីរ៉ូស៊ីម៉ា",
      "neName": "हिरोसिमा जिल्ला"
    },
    "class10": {
      "code": "340010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "广岛县南部",
      "zhName": "廣島縣南部",
      "koName": "히로시마 현 남부",
      "esName": "Sur de Prefectura de Hiroshima",
      "ptName": "Sul da Província de Hiroshima",
      "thName": "จังหวัดฮิโรชิมะตอนใต้",
      "viName": "Miền Nam tỉnh Hiroshima",
      "inName": "Bagian Selatan Prefektur Hiroshima",
      "tlName": "Timog bahagi ng Hiroshima Prefecture",
      "moName": "Өмнөд Хирошима аймаг",
      "buName": "ဟိရိုရှီးမားစီရင်စု အရှေ့တောင်ပိုင်း",
      "khName": "តំបន់ជើងខាងត្បូងនៃខេត្ដហ៊ីរ៉ូស៊ីម៉ា",
      "neName": "हिरोसिमा जिल्लाको दक्षिण भाग"
    },
    "class15": {
      "code": "340011",
      "name": "広島・呉",
      "enName": "Hiroshima Kure"
    },
    "class20": {
      "code": "3410600",
      "name": "広島市安佐北区",
      "enName": "Hiroshima City Asakita Ward",
      "kana": "ひろしましあさきたく",
      "chName": "广岛安佐北区",
      "zhName": "廣島安佐北區",
      "koName": "히로시마 아사키타 구",
      "esName": "Distrito Asakita, Hiroshima",
      "ptName": "Hiroshima, distrito de Asakita",
      "thName": "เมืองอาซาคิตะ ฮิโรชิมะ",
      "viName": "phường Asakita, Hiroshima",
      "inName": "Distrik Kota Asakita, Hiroshima",
      "tlName": "Asakita Ward, Hiroshima",
      "moName": "Хирошима Аса кита дүүрэг",
      "buName": "ဟိရိုရှိမအဆခိတရပ်ကွက်",
      "khName": "សង្កាត់អាសាគីតា ហ៊ីរ៉ូស៊ីម៉ា",
      "neName": "हिरोसिमा आसाकिता वडा"
    }
  },
  "3410700": {
    "office": {
      "code": "340000",
      "name": "広島県",
      "enName": "Hiroshima",
      "officeName": "広島地方気象台",
      "chName": "广岛县",
      "zhName": "廣島縣",
      "koName": "히로시마현",
      "esName": "Prefectura de Hiroshima",
      "ptName": "Província de Hiroshima",
      "thName": "จังหวัดฮิโรชิมะ",
      "viName": "Tỉnh Hiroshima",
      "inName": "Prefektur Hiroshima",
      "tlName": "Hiroshima Prefecture",
      "moName": "Хирошима аймаг",
      "buName": "ဟီရိုရှိမ ပြည်နယ်",
      "khName": "ខេត្ដ ហ៊ីរ៉ូស៊ីម៉ា",
      "neName": "हिरोसिमा जिल्ला"
    },
    "class10": {
      "code": "340010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "广岛县南部",
      "zhName": "廣島縣南部",
      "koName": "히로시마 현 남부",
      "esName": "Sur de Prefectura de Hiroshima",
      "ptName": "Sul da Província de Hiroshima",
      "thName": "จังหวัดฮิโรชิมะตอนใต้",
      "viName": "Miền Nam tỉnh Hiroshima",
      "inName": "Bagian Selatan Prefektur Hiroshima",
      "tlName": "Timog bahagi ng Hiroshima Prefecture",
      "moName": "Өмнөд Хирошима аймаг",
      "buName": "ဟိရိုရှီးမားစီရင်စု အရှေ့တောင်ပိုင်း",
      "khName": "តំបន់ជើងខាងត្បូងនៃខេត្ដហ៊ីរ៉ូស៊ីម៉ា",
      "neName": "हिरोसिमा जिल्लाको दक्षिण भाग"
    },
    "class15": {
      "code": "340011",
      "name": "広島・呉",
      "enName": "Hiroshima Kure"
    },
    "class20": {
      "code": "3410700",
      "name": "広島市安芸区",
      "enName": "Hiroshima City Aki Ward",
      "kana": "ひろしましあきく",
      "chName": "广岛安芸区",
      "zhName": "廣島安芸區",
      "koName": "히로시마 아키 구",
      "esName": "Distrito Aki, Hiroshima",
      "ptName": "Hiroshima, distrito de Aki",
      "thName": "เมืองอากิ ฮิโรชิมะ",
      "viName": "phường Aki, Hiroshima",
      "inName": "Distrik Kota Aki, Hiroshima",
      "tlName": "Aki Ward, Hiroshima",
      "moName": "Хирошима Аки дүүрэг",
      "buName": "ဟိရိုရှိမအခိခရပ်ကွက်",
      "khName": "សង្កាត់អាគី ហ៊ីរ៉ូស៊ីម៉ា",
      "neName": "हिरोसिमा आकी वडा"
    }
  },
  "3410800": {
    "office": {
      "code": "340000",
      "name": "広島県",
      "enName": "Hiroshima",
      "officeName": "広島地方気象台",
      "chName": "广岛县",
      "zhName": "廣島縣",
      "koName": "히로시마현",
      "esName": "Prefectura de Hiroshima",
      "ptName": "Província de Hiroshima",
      "thName": "จังหวัดฮิโรชิมะ",
      "viName": "Tỉnh Hiroshima",
      "inName": "Prefektur Hiroshima",
      "tlName": "Hiroshima Prefecture",
      "moName": "Хирошима аймаг",
      "buName": "ဟီရိုရှိမ ပြည်နယ်",
      "khName": "ខេត្ដ ហ៊ីរ៉ូស៊ីម៉ា",
      "neName": "हिरोसिमा जिल्ला"
    },
    "class10": {
      "code": "340010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "广岛县南部",
      "zhName": "廣島縣南部",
      "koName": "히로시마 현 남부",
      "esName": "Sur de Prefectura de Hiroshima",
      "ptName": "Sul da Província de Hiroshima",
      "thName": "จังหวัดฮิโรชิมะตอนใต้",
      "viName": "Miền Nam tỉnh Hiroshima",
      "inName": "Bagian Selatan Prefektur Hiroshima",
      "tlName": "Timog bahagi ng Hiroshima Prefecture",
      "moName": "Өмнөд Хирошима аймаг",
      "buName": "ဟိရိုရှီးမားစီရင်စု အရှေ့တောင်ပိုင်း",
      "khName": "តំបន់ជើងខាងត្បូងនៃខេត្ដហ៊ីរ៉ូស៊ីម៉ា",
      "neName": "हिरोसिमा जिल्लाको दक्षिण भाग"
    },
    "class15": {
      "code": "340011",
      "name": "広島・呉",
      "enName": "Hiroshima Kure"
    },
    "class20": {
      "code": "3410800",
      "name": "広島市佐伯区",
      "enName": "Hiroshima City Saeki Ward",
      "kana": "ひろしましさえきく",
      "chName": "广岛佐伯区",
      "zhName": "廣島佐伯區",
      "koName": "히로시마 사에키 구",
      "esName": "Distrito Saeki, Hiroshima",
      "ptName": "Hiroshima, distrito de Saeki",
      "thName": "เมืองซาเอกิ ฮิโรชิมะ",
      "viName": "phường Saeki, Hiroshima",
      "inName": "Distrik Kota Saeki, Hiroshima",
      "tlName": "Saeki Ward, Hiroshima",
      "moName": "Хирошима Сaэки дүүрэг",
      "buName": "ဟိရိုရှိမဆအဲခိရပ်ကွက်",
      "khName": "សង្កាត់សេគី ហ៊ីរ៉ូស៊ីម៉ា",
      "neName": "हिरोसिमा साएकी वडा"
    }
  },
  "3420200": {
    "office": {
      "code": "340000",
      "name": "広島県",
      "enName": "Hiroshima",
      "officeName": "広島地方気象台",
      "chName": "广岛县",
      "zhName": "廣島縣",
      "koName": "히로시마현",
      "esName": "Prefectura de Hiroshima",
      "ptName": "Província de Hiroshima",
      "thName": "จังหวัดฮิโรชิมะ",
      "viName": "Tỉnh Hiroshima",
      "inName": "Prefektur Hiroshima",
      "tlName": "Hiroshima Prefecture",
      "moName": "Хирошима аймаг",
      "buName": "ဟီရိုရှိမ ပြည်နယ်",
      "khName": "ខេត្ដ ហ៊ីរ៉ូស៊ីម៉ា",
      "neName": "हिरोसिमा जिल्ला"
    },
    "class10": {
      "code": "340010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "广岛县南部",
      "zhName": "廣島縣南部",
      "koName": "히로시마 현 남부",
      "esName": "Sur de Prefectura de Hiroshima",
      "ptName": "Sul da Província de Hiroshima",
      "thName": "จังหวัดฮิโรชิมะตอนใต้",
      "viName": "Miền Nam tỉnh Hiroshima",
      "inName": "Bagian Selatan Prefektur Hiroshima",
      "tlName": "Timog bahagi ng Hiroshima Prefecture",
      "moName": "Өмнөд Хирошима аймаг",
      "buName": "ဟိရိုရှီးမားစီရင်စု အရှေ့တောင်ပိုင်း",
      "khName": "តំបន់ជើងខាងត្បូងនៃខេត្ដហ៊ីរ៉ូស៊ីម៉ា",
      "neName": "हिरोसिमा जिल्लाको दक्षिण भाग"
    },
    "class15": {
      "code": "340011",
      "name": "広島・呉",
      "enName": "Hiroshima Kure"
    },
    "class20": {
      "code": "3420200",
      "name": "呉市",
      "enName": "Kure City",
      "kana": "くれし",
      "chName": "吴市",
      "zhName": "吳市",
      "koName": "구레 시",
      "esName": "Ciudad de Kure",
      "ptName": "cidade de Kure",
      "thName": "เมืองคุเระ",
      "viName": "thành phố Kure",
      "inName": "kota Kure",
      "tlName": "siyudad ng Kure",
      "moName": "Күрэ хот",
      "buName": "ခူးရဲ့ မြို့",
      "khName": "ទីក្រុង ឃ័រ",
      "neName": "कुरे सहर"
    }
  },
  "3420300": {
    "office": {
      "code": "340000",
      "name": "広島県",
      "enName": "Hiroshima",
      "officeName": "広島地方気象台",
      "chName": "广岛县",
      "zhName": "廣島縣",
      "koName": "히로시마현",
      "esName": "Prefectura de Hiroshima",
      "ptName": "Província de Hiroshima",
      "thName": "จังหวัดฮิโรชิมะ",
      "viName": "Tỉnh Hiroshima",
      "inName": "Prefektur Hiroshima",
      "tlName": "Hiroshima Prefecture",
      "moName": "Хирошима аймаг",
      "buName": "ဟီရိုရှိမ ပြည်နယ်",
      "khName": "ខេត្ដ ហ៊ីរ៉ូស៊ីម៉ា",
      "neName": "हिरोसिमा जिल्ला"
    },
    "class10": {
      "code": "340010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "广岛县南部",
      "zhName": "廣島縣南部",
      "koName": "히로시마 현 남부",
      "esName": "Sur de Prefectura de Hiroshima",
      "ptName": "Sul da Província de Hiroshima",
      "thName": "จังหวัดฮิโรชิมะตอนใต้",
      "viName": "Miền Nam tỉnh Hiroshima",
      "inName": "Bagian Selatan Prefektur Hiroshima",
      "tlName": "Timog bahagi ng Hiroshima Prefecture",
      "moName": "Өмнөд Хирошима аймаг",
      "buName": "ဟိရိုရှီးမားစီရင်စု အရှေ့တောင်ပိုင်း",
      "khName": "តំបន់ជើងខាងត្បូងនៃខេត្ដហ៊ីរ៉ូស៊ីម៉ា",
      "neName": "हिरोसिमा जिल्लाको दक्षिण भाग"
    },
    "class15": {
      "code": "340013",
      "name": "東広島・竹原",
      "enName": "Higashi-hiroshima Takehara"
    },
    "class20": {
      "code": "3420300",
      "name": "竹原市",
      "enName": "Takehara City",
      "kana": "たけはらし",
      "chName": "竹原市",
      "zhName": "竹原市",
      "koName": "다케하라 시",
      "esName": "Ciudad de Takehara",
      "ptName": "cidade de Takehara",
      "thName": "เมืองทาเคฮาระ",
      "viName": "thành phố Takehara",
      "inName": "kota Takehara",
      "tlName": "siyudad ng Takehara",
      "moName": "Такэхaра хот",
      "buName": "တာကေးဟာ့ရာ့ မြို့",
      "khName": "ទីក្រុង តាកេហារ៉ា",
      "neName": "ताकेहारा सहर"
    }
  },
  "3420400": {
    "office": {
      "code": "340000",
      "name": "広島県",
      "enName": "Hiroshima",
      "officeName": "広島地方気象台",
      "chName": "广岛县",
      "zhName": "廣島縣",
      "koName": "히로시마현",
      "esName": "Prefectura de Hiroshima",
      "ptName": "Província de Hiroshima",
      "thName": "จังหวัดฮิโรชิมะ",
      "viName": "Tỉnh Hiroshima",
      "inName": "Prefektur Hiroshima",
      "tlName": "Hiroshima Prefecture",
      "moName": "Хирошима аймаг",
      "buName": "ဟီရိုရှိမ ပြည်နယ်",
      "khName": "ខេត្ដ ហ៊ីរ៉ូស៊ីម៉ា",
      "neName": "हिरोसिमा जिल्ला"
    },
    "class10": {
      "code": "340010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "广岛县南部",
      "zhName": "廣島縣南部",
      "koName": "히로시마 현 남부",
      "esName": "Sur de Prefectura de Hiroshima",
      "ptName": "Sul da Província de Hiroshima",
      "thName": "จังหวัดฮิโรชิมะตอนใต้",
      "viName": "Miền Nam tỉnh Hiroshima",
      "inName": "Bagian Selatan Prefektur Hiroshima",
      "tlName": "Timog bahagi ng Hiroshima Prefecture",
      "moName": "Өмнөд Хирошима аймаг",
      "buName": "ဟိရိုရှီးမားစီရင်စု အရှေ့တောင်ပိုင်း",
      "khName": "តំបន់ជើងខាងត្បូងនៃខេត្ដហ៊ីរ៉ូស៊ីម៉ា",
      "neName": "हिरोसिमा जिल्लाको दक्षिण भाग"
    },
    "class15": {
      "code": "340012",
      "name": "福山・尾三",
      "enName": "Fukuyama Bisan"
    },
    "class20": {
      "code": "3420400",
      "name": "三原市",
      "enName": "Mihara City",
      "kana": "みはらし",
      "chName": "三原市",
      "zhName": "三原市",
      "koName": "미하라 시",
      "esName": "Ciudad de Mihara",
      "ptName": "cidade de Mihara",
      "thName": "เมืองมิฮาระ",
      "viName": "thành phố Mihara",
      "inName": "kota Mihara",
      "tlName": "siyudad ng Mihara",
      "moName": "Михaра хот",
      "buName": "မီဟာ့ရ မြို့",
      "khName": "ទីក្រុង មីហារ៉ា",
      "neName": "मिहारा सहर"
    }
  },
  "3420500": {
    "office": {
      "code": "340000",
      "name": "広島県",
      "enName": "Hiroshima",
      "officeName": "広島地方気象台",
      "chName": "广岛县",
      "zhName": "廣島縣",
      "koName": "히로시마현",
      "esName": "Prefectura de Hiroshima",
      "ptName": "Província de Hiroshima",
      "thName": "จังหวัดฮิโรชิมะ",
      "viName": "Tỉnh Hiroshima",
      "inName": "Prefektur Hiroshima",
      "tlName": "Hiroshima Prefecture",
      "moName": "Хирошима аймаг",
      "buName": "ဟီရိုရှိမ ပြည်နယ်",
      "khName": "ខេត្ដ ហ៊ីរ៉ូស៊ីម៉ា",
      "neName": "हिरोसिमा जिल्ला"
    },
    "class10": {
      "code": "340010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "广岛县南部",
      "zhName": "廣島縣南部",
      "koName": "히로시마 현 남부",
      "esName": "Sur de Prefectura de Hiroshima",
      "ptName": "Sul da Província de Hiroshima",
      "thName": "จังหวัดฮิโรชิมะตอนใต้",
      "viName": "Miền Nam tỉnh Hiroshima",
      "inName": "Bagian Selatan Prefektur Hiroshima",
      "tlName": "Timog bahagi ng Hiroshima Prefecture",
      "moName": "Өмнөд Хирошима аймаг",
      "buName": "ဟိရိုရှီးမားစီရင်စု အရှေ့တောင်ပိုင်း",
      "khName": "តំបន់ជើងខាងត្បូងនៃខេត្ដហ៊ីរ៉ូស៊ីម៉ា",
      "neName": "हिरोसिमा जिल्लाको दक्षिण भाग"
    },
    "class15": {
      "code": "340012",
      "name": "福山・尾三",
      "enName": "Fukuyama Bisan"
    },
    "class20": {
      "code": "3420500",
      "name": "尾道市",
      "enName": "Onomichi City",
      "kana": "おのみちし",
      "chName": "尾道市",
      "zhName": "尾道市",
      "koName": "오노미치 시",
      "esName": "Ciudad de Onomichi",
      "ptName": "cidade de Onomichi",
      "thName": "เมืองโอโนมิจิ",
      "viName": "thành phố Onomichi",
      "inName": "kota Onomichi",
      "tlName": "siyudad ng Onomichi",
      "moName": "Ономичи хот",
      "buName": "အိုနိုမိကျိ မြို့",
      "khName": "ទីក្រុង អូណូមីឈី",
      "neName": "ओनोमिची सहर"
    }
  },
  "3420700": {
    "office": {
      "code": "340000",
      "name": "広島県",
      "enName": "Hiroshima",
      "officeName": "広島地方気象台",
      "chName": "广岛县",
      "zhName": "廣島縣",
      "koName": "히로시마현",
      "esName": "Prefectura de Hiroshima",
      "ptName": "Província de Hiroshima",
      "thName": "จังหวัดฮิโรชิมะ",
      "viName": "Tỉnh Hiroshima",
      "inName": "Prefektur Hiroshima",
      "tlName": "Hiroshima Prefecture",
      "moName": "Хирошима аймаг",
      "buName": "ဟီရိုရှိမ ပြည်နယ်",
      "khName": "ខេត្ដ ហ៊ីរ៉ូស៊ីម៉ា",
      "neName": "हिरोसिमा जिल्ला"
    },
    "class10": {
      "code": "340010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "广岛县南部",
      "zhName": "廣島縣南部",
      "koName": "히로시마 현 남부",
      "esName": "Sur de Prefectura de Hiroshima",
      "ptName": "Sul da Província de Hiroshima",
      "thName": "จังหวัดฮิโรชิมะตอนใต้",
      "viName": "Miền Nam tỉnh Hiroshima",
      "inName": "Bagian Selatan Prefektur Hiroshima",
      "tlName": "Timog bahagi ng Hiroshima Prefecture",
      "moName": "Өмнөд Хирошима аймаг",
      "buName": "ဟိရိုရှီးမားစီရင်စု အရှေ့တောင်ပိုင်း",
      "khName": "តំបន់ជើងខាងត្បូងនៃខេត្ដហ៊ីរ៉ូស៊ីម៉ា",
      "neName": "हिरोसिमा जिल्लाको दक्षिण भाग"
    },
    "class15": {
      "code": "340012",
      "name": "福山・尾三",
      "enName": "Fukuyama Bisan"
    },
    "class20": {
      "code": "3420700",
      "name": "福山市",
      "enName": "Fukuyama City",
      "kana": "ふくやまし",
      "chName": "福山市",
      "zhName": "福山市",
      "koName": "후쿠야마 시",
      "esName": "Ciudad de Fukuyama",
      "ptName": "cidade de Fukuyama",
      "thName": "เมืองฟุกุยามะ",
      "viName": "thành phố Fukuyama",
      "inName": "kota Fukuyama",
      "tlName": "siyudad ng Fukuyama",
      "moName": "Фүкүяма хот",
      "buName": "ဖူကူယာ့မ မြို့",
      "khName": "ទីក្រុង ហ្វូគូយ៉ាម៉ា",
      "neName": "फुकुयामा सहर"
    }
  },
  "3420800": {
    "office": {
      "code": "340000",
      "name": "広島県",
      "enName": "Hiroshima",
      "officeName": "広島地方気象台",
      "chName": "广岛县",
      "zhName": "廣島縣",
      "koName": "히로시마현",
      "esName": "Prefectura de Hiroshima",
      "ptName": "Província de Hiroshima",
      "thName": "จังหวัดฮิโรชิมะ",
      "viName": "Tỉnh Hiroshima",
      "inName": "Prefektur Hiroshima",
      "tlName": "Hiroshima Prefecture",
      "moName": "Хирошима аймаг",
      "buName": "ဟီရိုရှိမ ပြည်နယ်",
      "khName": "ខេត្ដ ហ៊ីរ៉ូស៊ីម៉ា",
      "neName": "हिरोसिमा जिल्ला"
    },
    "class10": {
      "code": "340010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "广岛县南部",
      "zhName": "廣島縣南部",
      "koName": "히로시마 현 남부",
      "esName": "Sur de Prefectura de Hiroshima",
      "ptName": "Sul da Província de Hiroshima",
      "thName": "จังหวัดฮิโรชิมะตอนใต้",
      "viName": "Miền Nam tỉnh Hiroshima",
      "inName": "Bagian Selatan Prefektur Hiroshima",
      "tlName": "Timog bahagi ng Hiroshima Prefecture",
      "moName": "Өмнөд Хирошима аймаг",
      "buName": "ဟိရိုရှီးမားစီရင်စု အရှေ့တောင်ပိုင်း",
      "khName": "តំបន់ជើងខាងត្បូងនៃខេត្ដហ៊ីរ៉ូស៊ីម៉ា",
      "neName": "हिरोसिमा जिल्लाको दक्षिण भाग"
    },
    "class15": {
      "code": "340012",
      "name": "福山・尾三",
      "enName": "Fukuyama Bisan"
    },
    "class20": {
      "code": "3420800",
      "name": "府中市",
      "enName": "Fuchu City",
      "kana": "ふちゅうし",
      "chName": "广岛府中市",
      "zhName": "廣島府中市",
      "koName": "히로시마 후추 시",
      "esName": "Ciudad de Fuchu, Hiroshima",
      "ptName": "Hiroshima, cidade de Fuchu ",
      "thName": "เมืองฟุชู ฮิโรชิมะ",
      "viName": "Thành phố Fuchu, Hiroshima",
      "inName": "Kota Fuchu, Hiroshima",
      "tlName": "siyudad ng Fuchu, Hiroshima",
      "moName": "Хирошима Фүчү хот",
      "buName": "ဟိရိုရှိမဟုချူးမြို့",
      "khName": "ទីក្រុងហ្វឹជឺ ហ៊ីរ៉ូស៊ីម៉ា",
      "neName": "हिरोसिमा फुच्यु सहर"
    }
  },
  "3420900": {
    "office": {
      "code": "340000",
      "name": "広島県",
      "enName": "Hiroshima",
      "officeName": "広島地方気象台",
      "chName": "广岛县",
      "zhName": "廣島縣",
      "koName": "히로시마현",
      "esName": "Prefectura de Hiroshima",
      "ptName": "Província de Hiroshima",
      "thName": "จังหวัดฮิโรชิมะ",
      "viName": "Tỉnh Hiroshima",
      "inName": "Prefektur Hiroshima",
      "tlName": "Hiroshima Prefecture",
      "moName": "Хирошима аймаг",
      "buName": "ဟီရိုရှိမ ပြည်နယ်",
      "khName": "ខេត្ដ ហ៊ីរ៉ូស៊ីម៉ា",
      "neName": "हिरोसिमा जिल्ला"
    },
    "class10": {
      "code": "340020",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "广岛县北部",
      "zhName": "廣島縣北部",
      "koName": "히로시마 현 북부",
      "esName": "Norte de Prefectura de Hiroshima",
      "ptName": "Norte da Província de Hiroshima",
      "thName": "จังหวัดฮิโรชิมะตอนเหนือ",
      "viName": "Miền Bắc tỉnh Hiroshima",
      "inName": "Bagian Utara Prefektur Hiroshima",
      "tlName": "Hilagang bahagi ng Hiroshima Prefecture",
      "moName": "Хойд Хирошима аймаг",
      "buName": "ဟိရိုရှီးမားစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដហ៊ីរ៉ូស៊ីម៉ា",
      "neName": "हिरोसिमा जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "340021",
      "name": "備北",
      "enName": "Bihoku"
    },
    "class20": {
      "code": "3420900",
      "name": "三次市",
      "enName": "Miyoshi City",
      "kana": "みよしし",
      "chName": "广岛三次市",
      "zhName": "廣島三次市",
      "koName": "히로시마 미요시 시",
      "esName": "Ciudad de Miyoshi, Hiroshima",
      "ptName": "Hiroshima, cidade de Miyoshi",
      "thName": "เมืองมิโยชิ ฮิโรชิมะ",
      "viName": "Thành phố Miyoshi, Hiroshima",
      "inName": "Kota Miyoshi, Hiroshima",
      "tlName": "siyudad ng Miyoshi, Hiroshima",
      "moName": "Хирошима Миёси хот",
      "buName": "ဟိရိုရှိမမနိယိုရှိမြို",
      "khName": "ទីក្រុងមីយោស៊ី ហ៊ីរ៉ូស៊ីម៉ា",
      "neName": "हिरोसिमा मियोसी सहर"
    }
  },
  "3421000": {
    "office": {
      "code": "340000",
      "name": "広島県",
      "enName": "Hiroshima",
      "officeName": "広島地方気象台",
      "chName": "广岛县",
      "zhName": "廣島縣",
      "koName": "히로시마현",
      "esName": "Prefectura de Hiroshima",
      "ptName": "Província de Hiroshima",
      "thName": "จังหวัดฮิโรชิมะ",
      "viName": "Tỉnh Hiroshima",
      "inName": "Prefektur Hiroshima",
      "tlName": "Hiroshima Prefecture",
      "moName": "Хирошима аймаг",
      "buName": "ဟီရိုရှိမ ပြည်နယ်",
      "khName": "ខេត្ដ ហ៊ីរ៉ូស៊ីម៉ា",
      "neName": "हिरोसिमा जिल्ला"
    },
    "class10": {
      "code": "340020",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "广岛县北部",
      "zhName": "廣島縣北部",
      "koName": "히로시마 현 북부",
      "esName": "Norte de Prefectura de Hiroshima",
      "ptName": "Norte da Província de Hiroshima",
      "thName": "จังหวัดฮิโรชิมะตอนเหนือ",
      "viName": "Miền Bắc tỉnh Hiroshima",
      "inName": "Bagian Utara Prefektur Hiroshima",
      "tlName": "Hilagang bahagi ng Hiroshima Prefecture",
      "moName": "Хойд Хирошима аймаг",
      "buName": "ဟိရိုရှီးမားစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដហ៊ីរ៉ូស៊ីម៉ា",
      "neName": "हिरोसिमा जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "340021",
      "name": "備北",
      "enName": "Bihoku"
    },
    "class20": {
      "code": "3421000",
      "name": "庄原市",
      "enName": "Shobara City",
      "kana": "しょうばらし",
      "chName": "庄原市",
      "zhName": "庄原市",
      "koName": "쇼바라 시",
      "esName": "Ciudad de Shobara",
      "ptName": "cidade de Shobara",
      "thName": "เมืองโชบาระ",
      "viName": "thành phố Shobara",
      "inName": "kota Shobara",
      "tlName": "siyudad ng Shobara",
      "moName": "Шобара хот",
      "buName": "ရှိုဘာ့ရာ့ မြို့",
      "khName": "ទីក្រុង សូបារ៉ា",
      "neName": "शोबारा सहर"
    }
  },
  "3421100": {
    "office": {
      "code": "340000",
      "name": "広島県",
      "enName": "Hiroshima",
      "officeName": "広島地方気象台",
      "chName": "广岛县",
      "zhName": "廣島縣",
      "koName": "히로시마현",
      "esName": "Prefectura de Hiroshima",
      "ptName": "Província de Hiroshima",
      "thName": "จังหวัดฮิโรชิมะ",
      "viName": "Tỉnh Hiroshima",
      "inName": "Prefektur Hiroshima",
      "tlName": "Hiroshima Prefecture",
      "moName": "Хирошима аймаг",
      "buName": "ဟီရိုရှိမ ပြည်နယ်",
      "khName": "ខេត្ដ ហ៊ីរ៉ូស៊ីម៉ា",
      "neName": "हिरोसिमा जिल्ला"
    },
    "class10": {
      "code": "340010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "广岛县南部",
      "zhName": "廣島縣南部",
      "koName": "히로시마 현 남부",
      "esName": "Sur de Prefectura de Hiroshima",
      "ptName": "Sul da Província de Hiroshima",
      "thName": "จังหวัดฮิโรชิมะตอนใต้",
      "viName": "Miền Nam tỉnh Hiroshima",
      "inName": "Bagian Selatan Prefektur Hiroshima",
      "tlName": "Timog bahagi ng Hiroshima Prefecture",
      "moName": "Өмнөд Хирошима аймаг",
      "buName": "ဟိရိုရှီးမားစီရင်စု အရှေ့တောင်ပိုင်း",
      "khName": "តំបន់ជើងខាងត្បូងនៃខេត្ដហ៊ីរ៉ូស៊ីម៉ា",
      "neName": "हिरोसिमा जिल्लाको दक्षिण भाग"
    },
    "class15": {
      "code": "340011",
      "name": "広島・呉",
      "enName": "Hiroshima Kure"
    },
    "class20": {
      "code": "3421100",
      "name": "大竹市",
      "enName": "Otake City",
      "kana": "おおたけし",
      "chName": "大竹市",
      "zhName": "大竹市",
      "koName": "오타케 시",
      "esName": "Ciiudad de Otake",
      "ptName": "cidade de Otake",
      "thName": "เมืองโอทาเกะ",
      "viName": "thành phố Otake",
      "inName": "kota Otake",
      "tlName": "siyudad ng Otake",
      "moName": "Отакэ хот",
      "buName": "အိုးတာ့ကဲ့ မြို့",
      "khName": "ទីក្រុង អូថាឃេ",
      "neName": "ओताके सहर"
    }
  },
  "3421200": {
    "office": {
      "code": "340000",
      "name": "広島県",
      "enName": "Hiroshima",
      "officeName": "広島地方気象台",
      "chName": "广岛县",
      "zhName": "廣島縣",
      "koName": "히로시마현",
      "esName": "Prefectura de Hiroshima",
      "ptName": "Província de Hiroshima",
      "thName": "จังหวัดฮิโรชิมะ",
      "viName": "Tỉnh Hiroshima",
      "inName": "Prefektur Hiroshima",
      "tlName": "Hiroshima Prefecture",
      "moName": "Хирошима аймаг",
      "buName": "ဟီရိုရှိမ ပြည်နယ်",
      "khName": "ខេត្ដ ហ៊ីរ៉ូស៊ីម៉ា",
      "neName": "हिरोसिमा जिल्ला"
    },
    "class10": {
      "code": "340010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "广岛县南部",
      "zhName": "廣島縣南部",
      "koName": "히로시마 현 남부",
      "esName": "Sur de Prefectura de Hiroshima",
      "ptName": "Sul da Província de Hiroshima",
      "thName": "จังหวัดฮิโรชิมะตอนใต้",
      "viName": "Miền Nam tỉnh Hiroshima",
      "inName": "Bagian Selatan Prefektur Hiroshima",
      "tlName": "Timog bahagi ng Hiroshima Prefecture",
      "moName": "Өмнөд Хирошима аймаг",
      "buName": "ဟိရိုရှီးမားစီရင်စု အရှေ့တောင်ပိုင်း",
      "khName": "តំបន់ជើងខាងត្បូងនៃខេត្ដហ៊ីរ៉ូស៊ីម៉ា",
      "neName": "हिरोसिमा जिल्लाको दक्षिण भाग"
    },
    "class15": {
      "code": "340013",
      "name": "東広島・竹原",
      "enName": "Higashi-hiroshima Takehara"
    },
    "class20": {
      "code": "3421200",
      "name": "東広島市",
      "enName": "Higashihiroshima City",
      "kana": "ひがしひろしまし",
      "chName": "东广岛市",
      "zhName": "東廣島市",
      "koName": "히가시히로시마 시",
      "esName": "Ciudad de Higashi-hiroshima",
      "ptName": "cidade de Higashihiroshima",
      "thName": "เมืองฮิงาชิฮิโรชิมะ",
      "viName": "thành phố Higashihiroshima",
      "inName": "kota Higashihiroshima",
      "tlName": "siyudad ng Higashihiroshima",
      "moName": "Хигашихирошима хот",
      "buName": "ဟီဂါ့ရှိဟိရို့ရှိမ မြို့",
      "khName": "ទីក្រុង ហ៊ីកាស៊ីហ៊ីរ៉ូស៊ីម៉ា",
      "neName": "हिगाशिहिरोशिमा सहर"
    }
  },
  "3421300": {
    "office": {
      "code": "340000",
      "name": "広島県",
      "enName": "Hiroshima",
      "officeName": "広島地方気象台",
      "chName": "广岛县",
      "zhName": "廣島縣",
      "koName": "히로시마현",
      "esName": "Prefectura de Hiroshima",
      "ptName": "Província de Hiroshima",
      "thName": "จังหวัดฮิโรชิมะ",
      "viName": "Tỉnh Hiroshima",
      "inName": "Prefektur Hiroshima",
      "tlName": "Hiroshima Prefecture",
      "moName": "Хирошима аймаг",
      "buName": "ဟီရိုရှိမ ပြည်နယ်",
      "khName": "ខេត្ដ ហ៊ីរ៉ូស៊ីម៉ា",
      "neName": "हिरोसिमा जिल्ला"
    },
    "class10": {
      "code": "340010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "广岛县南部",
      "zhName": "廣島縣南部",
      "koName": "히로시마 현 남부",
      "esName": "Sur de Prefectura de Hiroshima",
      "ptName": "Sul da Província de Hiroshima",
      "thName": "จังหวัดฮิโรชิมะตอนใต้",
      "viName": "Miền Nam tỉnh Hiroshima",
      "inName": "Bagian Selatan Prefektur Hiroshima",
      "tlName": "Timog bahagi ng Hiroshima Prefecture",
      "moName": "Өмнөд Хирошима аймаг",
      "buName": "ဟိရိုရှီးမားစီရင်စု အရှေ့တောင်ပိုင်း",
      "khName": "តំបន់ជើងខាងត្បូងនៃខេត្ដហ៊ីរ៉ូស៊ីម៉ា",
      "neName": "हिरोसिमा जिल्लाको दक्षिण भाग"
    },
    "class15": {
      "code": "340011",
      "name": "広島・呉",
      "enName": "Hiroshima Kure"
    },
    "class20": {
      "code": "3421300",
      "name": "廿日市市",
      "enName": "Hatsukaichi City",
      "kana": "はつかいちし",
      "chName": "廿日市市",
      "zhName": "廿日市市",
      "koName": "하쓰카이치 시",
      "esName": "Ciudad de Hatsukaichi",
      "ptName": "cidade de Hatsukaichi",
      "thName": "เมืองฮัทสึกะอิจิ",
      "viName": "thành phố Hatsukaichi",
      "inName": "kota Hatsukaichi",
      "tlName": "siyudad ng Hatsukaichi",
      "moName": "Хaцүкайчи хот",
      "buName": "ဟာဆုကားယိရှိ မြို့",
      "khName": "ទីក្រុង ហាត់ស៊ូកៃជី",
      "neName": "हात्सुकाइची सहर"
    }
  },
  "3421400": {
    "office": {
      "code": "340000",
      "name": "広島県",
      "enName": "Hiroshima",
      "officeName": "広島地方気象台",
      "chName": "广岛县",
      "zhName": "廣島縣",
      "koName": "히로시마현",
      "esName": "Prefectura de Hiroshima",
      "ptName": "Província de Hiroshima",
      "thName": "จังหวัดฮิโรชิมะ",
      "viName": "Tỉnh Hiroshima",
      "inName": "Prefektur Hiroshima",
      "tlName": "Hiroshima Prefecture",
      "moName": "Хирошима аймаг",
      "buName": "ဟီရိုရှိမ ပြည်နယ်",
      "khName": "ខេត្ដ ហ៊ីរ៉ូស៊ីម៉ា",
      "neName": "हिरोसिमा जिल्ला"
    },
    "class10": {
      "code": "340020",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "广岛县北部",
      "zhName": "廣島縣北部",
      "koName": "히로시마 현 북부",
      "esName": "Norte de Prefectura de Hiroshima",
      "ptName": "Norte da Província de Hiroshima",
      "thName": "จังหวัดฮิโรชิมะตอนเหนือ",
      "viName": "Miền Bắc tỉnh Hiroshima",
      "inName": "Bagian Utara Prefektur Hiroshima",
      "tlName": "Hilagang bahagi ng Hiroshima Prefecture",
      "moName": "Хойд Хирошима аймаг",
      "buName": "ဟိရိုရှီးမားစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដហ៊ីរ៉ូស៊ីម៉ា",
      "neName": "हिरोसिमा जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "340022",
      "name": "芸北",
      "enName": "Geihoku"
    },
    "class20": {
      "code": "3421400",
      "name": "安芸高田市",
      "enName": "Akitakata City",
      "kana": "あきたかたし",
      "chName": "安芸高田市",
      "zhName": "安藝髙田市",
      "koName": "아키타카타 시",
      "esName": "Ciudad de Aki-Takata",
      "ptName": "cidade de Akitakata",
      "thName": "เมืองอะกิตะคาตะ",
      "viName": "thành phố Akitakata",
      "inName": "kota Akitakata",
      "tlName": "siyudad ng Akitakata",
      "moName": "Акитаката хот",
      "buName": "အာကိတားကာ့တ မြို့",
      "khName": "ទីក្រុង អាគីតាកាតា",
      "neName": "आकिताकाता सहर"
    }
  },
  "3421500": {
    "office": {
      "code": "340000",
      "name": "広島県",
      "enName": "Hiroshima",
      "officeName": "広島地方気象台",
      "chName": "广岛县",
      "zhName": "廣島縣",
      "koName": "히로시마현",
      "esName": "Prefectura de Hiroshima",
      "ptName": "Província de Hiroshima",
      "thName": "จังหวัดฮิโรชิมะ",
      "viName": "Tỉnh Hiroshima",
      "inName": "Prefektur Hiroshima",
      "tlName": "Hiroshima Prefecture",
      "moName": "Хирошима аймаг",
      "buName": "ဟီရိုရှိမ ပြည်နယ်",
      "khName": "ខេត្ដ ហ៊ីរ៉ូស៊ីម៉ា",
      "neName": "हिरोसिमा जिल्ला"
    },
    "class10": {
      "code": "340010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "广岛县南部",
      "zhName": "廣島縣南部",
      "koName": "히로시마 현 남부",
      "esName": "Sur de Prefectura de Hiroshima",
      "ptName": "Sul da Província de Hiroshima",
      "thName": "จังหวัดฮิโรชิมะตอนใต้",
      "viName": "Miền Nam tỉnh Hiroshima",
      "inName": "Bagian Selatan Prefektur Hiroshima",
      "tlName": "Timog bahagi ng Hiroshima Prefecture",
      "moName": "Өмнөд Хирошима аймаг",
      "buName": "ဟိရိုရှီးမားစီရင်စု အရှေ့တောင်ပိုင်း",
      "khName": "តំបន់ជើងខាងត្បូងនៃខេត្ដហ៊ីរ៉ូស៊ីម៉ា",
      "neName": "हिरोसिमा जिल्लाको दक्षिण भाग"
    },
    "class15": {
      "code": "340011",
      "name": "広島・呉",
      "enName": "Hiroshima Kure"
    },
    "class20": {
      "code": "3421500",
      "name": "江田島市",
      "enName": "Etajima City",
      "kana": "えたじまし",
      "chName": "江田岛市",
      "zhName": "江田島市",
      "koName": "에타지마 시",
      "esName": "Ciudad de Etajima",
      "ptName": "cidade de Etajima",
      "thName": "เมืองเอตะจิมะ",
      "viName": "thành phố Etajima",
      "inName": "kota Etajima",
      "tlName": "siyudad ng Etajima",
      "moName": "Этажимa хот",
      "buName": "အဲတားကျိမ မြို့",
      "khName": "ទីក្រុង អ៊ីតាជីម៉ា",
      "neName": "एताजिमा सहर"
    }
  },
  "3430200": {
    "office": {
      "code": "340000",
      "name": "広島県",
      "enName": "Hiroshima",
      "officeName": "広島地方気象台",
      "chName": "广岛县",
      "zhName": "廣島縣",
      "koName": "히로시마현",
      "esName": "Prefectura de Hiroshima",
      "ptName": "Província de Hiroshima",
      "thName": "จังหวัดฮิโรชิมะ",
      "viName": "Tỉnh Hiroshima",
      "inName": "Prefektur Hiroshima",
      "tlName": "Hiroshima Prefecture",
      "moName": "Хирошима аймаг",
      "buName": "ဟီရိုရှိမ ပြည်နယ်",
      "khName": "ខេត្ដ ហ៊ីរ៉ូស៊ីម៉ា",
      "neName": "हिरोसिमा जिल्ला"
    },
    "class10": {
      "code": "340010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "广岛县南部",
      "zhName": "廣島縣南部",
      "koName": "히로시마 현 남부",
      "esName": "Sur de Prefectura de Hiroshima",
      "ptName": "Sul da Província de Hiroshima",
      "thName": "จังหวัดฮิโรชิมะตอนใต้",
      "viName": "Miền Nam tỉnh Hiroshima",
      "inName": "Bagian Selatan Prefektur Hiroshima",
      "tlName": "Timog bahagi ng Hiroshima Prefecture",
      "moName": "Өмнөд Хирошима аймаг",
      "buName": "ဟိရိုရှီးမားစီရင်စု အရှေ့တောင်ပိုင်း",
      "khName": "តំបន់ជើងខាងត្បូងនៃខេត្ដហ៊ីរ៉ូស៊ីម៉ា",
      "neName": "हिरोसिमा जिल्लाको दक्षिण भाग"
    },
    "class15": {
      "code": "340011",
      "name": "広島・呉",
      "enName": "Hiroshima Kure"
    },
    "class20": {
      "code": "3430200",
      "name": "府中町",
      "enName": "Fuchu Town",
      "kana": "ふちゅうちょう",
      "chName": "府中町",
      "zhName": "府中町",
      "koName": "후추 정",
      "esName": "Pueblo de Fuchu",
      "ptName": "bairro de Fuchu",
      "thName": "เมืองฟุชู (ฟุชูโจ)",
      "viName": "thị trấn Fuchu",
      "inName": "kota Fuchu (Fuchu-chō)",
      "tlName": "bayan ng Fuchu",
      "moName": "Фүчү жижиг хот",
      "buName": "ဟုကျု မြို့နယ်",
      "khName": "ទីប្រជុំជន ហ្វូជូ",
      "neName": "फुचु नगर"
    }
  },
  "3430400": {
    "office": {
      "code": "340000",
      "name": "広島県",
      "enName": "Hiroshima",
      "officeName": "広島地方気象台",
      "chName": "广岛县",
      "zhName": "廣島縣",
      "koName": "히로시마현",
      "esName": "Prefectura de Hiroshima",
      "ptName": "Província de Hiroshima",
      "thName": "จังหวัดฮิโรชิมะ",
      "viName": "Tỉnh Hiroshima",
      "inName": "Prefektur Hiroshima",
      "tlName": "Hiroshima Prefecture",
      "moName": "Хирошима аймаг",
      "buName": "ဟီရိုရှိမ ပြည်နယ်",
      "khName": "ខេត្ដ ហ៊ីរ៉ូស៊ីម៉ា",
      "neName": "हिरोसिमा जिल्ला"
    },
    "class10": {
      "code": "340010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "广岛县南部",
      "zhName": "廣島縣南部",
      "koName": "히로시마 현 남부",
      "esName": "Sur de Prefectura de Hiroshima",
      "ptName": "Sul da Província de Hiroshima",
      "thName": "จังหวัดฮิโรชิมะตอนใต้",
      "viName": "Miền Nam tỉnh Hiroshima",
      "inName": "Bagian Selatan Prefektur Hiroshima",
      "tlName": "Timog bahagi ng Hiroshima Prefecture",
      "moName": "Өмнөд Хирошима аймаг",
      "buName": "ဟိရိုရှီးမားစီရင်စု အရှေ့တောင်ပိုင်း",
      "khName": "តំបន់ជើងខាងត្បូងនៃខេត្ដហ៊ីរ៉ូស៊ីម៉ា",
      "neName": "हिरोसिमा जिल्लाको दक्षिण भाग"
    },
    "class15": {
      "code": "340011",
      "name": "広島・呉",
      "enName": "Hiroshima Kure"
    },
    "class20": {
      "code": "3430400",
      "name": "海田町",
      "enName": "Kaita Town",
      "kana": "かいたちょう",
      "chName": "海田町",
      "zhName": "海田町",
      "koName": "가이타 정",
      "esName": "Pueblo de Kaita",
      "ptName": "bairro de Kaita",
      "thName": "เมืองไคตะ",
      "viName": "thị trấn Kaita",
      "inName": "kota Kaita",
      "tlName": "bayan ng Kaita",
      "moName": "Кайта жижиг хот",
      "buName": "ခါယိတ မြို့နယ်",
      "khName": "ទីប្រជុំជន កៃតា",
      "neName": "काइता नगर"
    }
  },
  "3430700": {
    "office": {
      "code": "340000",
      "name": "広島県",
      "enName": "Hiroshima",
      "officeName": "広島地方気象台",
      "chName": "广岛县",
      "zhName": "廣島縣",
      "koName": "히로시마현",
      "esName": "Prefectura de Hiroshima",
      "ptName": "Província de Hiroshima",
      "thName": "จังหวัดฮิโรชิมะ",
      "viName": "Tỉnh Hiroshima",
      "inName": "Prefektur Hiroshima",
      "tlName": "Hiroshima Prefecture",
      "moName": "Хирошима аймаг",
      "buName": "ဟီရိုရှိမ ပြည်နယ်",
      "khName": "ខេត្ដ ហ៊ីរ៉ូស៊ីម៉ា",
      "neName": "हिरोसिमा जिल्ला"
    },
    "class10": {
      "code": "340010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "广岛县南部",
      "zhName": "廣島縣南部",
      "koName": "히로시마 현 남부",
      "esName": "Sur de Prefectura de Hiroshima",
      "ptName": "Sul da Província de Hiroshima",
      "thName": "จังหวัดฮิโรชิมะตอนใต้",
      "viName": "Miền Nam tỉnh Hiroshima",
      "inName": "Bagian Selatan Prefektur Hiroshima",
      "tlName": "Timog bahagi ng Hiroshima Prefecture",
      "moName": "Өмнөд Хирошима аймаг",
      "buName": "ဟိရိုရှီးမားစီရင်စု အရှေ့တောင်ပိုင်း",
      "khName": "តំបន់ជើងខាងត្បូងនៃខេត្ដហ៊ីរ៉ូស៊ីម៉ា",
      "neName": "हिरोसिमा जिल्लाको दक्षिण भाग"
    },
    "class15": {
      "code": "340011",
      "name": "広島・呉",
      "enName": "Hiroshima Kure"
    },
    "class20": {
      "code": "3430700",
      "name": "熊野町",
      "enName": "Kumano Town",
      "kana": "くまのちょう",
      "chName": "熊野町",
      "zhName": "熊野町",
      "koName": "구마노 정",
      "esName": "Pueblo de Kumano",
      "ptName": "bairro de Kumano",
      "thName": "เมืองคุมาโนะ",
      "viName": "thị trấn Kumano",
      "inName": "kota Kumano",
      "tlName": "bayan ng Kumano",
      "moName": "Күмaно жижиг хот",
      "buName": "ခူမားနို မြို့နယ်",
      "khName": "ទីប្រជុំជន គូម៉ាណូ",
      "neName": "कुमानो नगर"
    }
  },
  "3430900": {
    "office": {
      "code": "340000",
      "name": "広島県",
      "enName": "Hiroshima",
      "officeName": "広島地方気象台",
      "chName": "广岛县",
      "zhName": "廣島縣",
      "koName": "히로시마현",
      "esName": "Prefectura de Hiroshima",
      "ptName": "Província de Hiroshima",
      "thName": "จังหวัดฮิโรชิมะ",
      "viName": "Tỉnh Hiroshima",
      "inName": "Prefektur Hiroshima",
      "tlName": "Hiroshima Prefecture",
      "moName": "Хирошима аймаг",
      "buName": "ဟီရိုရှိမ ပြည်နယ်",
      "khName": "ខេត្ដ ហ៊ីរ៉ូស៊ីម៉ា",
      "neName": "हिरोसिमा जिल्ला"
    },
    "class10": {
      "code": "340010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "广岛县南部",
      "zhName": "廣島縣南部",
      "koName": "히로시마 현 남부",
      "esName": "Sur de Prefectura de Hiroshima",
      "ptName": "Sul da Província de Hiroshima",
      "thName": "จังหวัดฮิโรชิมะตอนใต้",
      "viName": "Miền Nam tỉnh Hiroshima",
      "inName": "Bagian Selatan Prefektur Hiroshima",
      "tlName": "Timog bahagi ng Hiroshima Prefecture",
      "moName": "Өмнөд Хирошима аймаг",
      "buName": "ဟိရိုရှီးမားစီရင်စု အရှေ့တောင်ပိုင်း",
      "khName": "តំបន់ជើងខាងត្បូងនៃខេត្ដហ៊ីរ៉ូស៊ីម៉ា",
      "neName": "हिरोसिमा जिल्लाको दक्षिण भाग"
    },
    "class15": {
      "code": "340011",
      "name": "広島・呉",
      "enName": "Hiroshima Kure"
    },
    "class20": {
      "code": "3430900",
      "name": "坂町",
      "enName": "Saka Town",
      "kana": "さかちょう",
      "chName": "坂町",
      "zhName": "坂町",
      "koName": "사카 정",
      "esName": "Pueblo de Saka",
      "ptName": "bairro de Saka",
      "thName": "เมืองซากะ",
      "viName": "thị trấn Saka",
      "inName": "kota Saka",
      "tlName": "bayan ng Saka",
      "moName": "Сaка жижиг хот",
      "buName": "ဆာက မြို့နယ်",
      "khName": "ទីប្រជុំជន សាកា",
      "neName": "साका नगर"
    }
  },
  "3436800": {
    "office": {
      "code": "340000",
      "name": "広島県",
      "enName": "Hiroshima",
      "officeName": "広島地方気象台",
      "chName": "广岛县",
      "zhName": "廣島縣",
      "koName": "히로시마현",
      "esName": "Prefectura de Hiroshima",
      "ptName": "Província de Hiroshima",
      "thName": "จังหวัดฮิโรชิมะ",
      "viName": "Tỉnh Hiroshima",
      "inName": "Prefektur Hiroshima",
      "tlName": "Hiroshima Prefecture",
      "moName": "Хирошима аймаг",
      "buName": "ဟီရိုရှိမ ပြည်နယ်",
      "khName": "ខេត្ដ ហ៊ីរ៉ូស៊ីម៉ា",
      "neName": "हिरोसिमा जिल्ला"
    },
    "class10": {
      "code": "340020",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "广岛县北部",
      "zhName": "廣島縣北部",
      "koName": "히로시마 현 북부",
      "esName": "Norte de Prefectura de Hiroshima",
      "ptName": "Norte da Província de Hiroshima",
      "thName": "จังหวัดฮิโรชิมะตอนเหนือ",
      "viName": "Miền Bắc tỉnh Hiroshima",
      "inName": "Bagian Utara Prefektur Hiroshima",
      "tlName": "Hilagang bahagi ng Hiroshima Prefecture",
      "moName": "Хойд Хирошима аймаг",
      "buName": "ဟိရိုရှီးမားစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដហ៊ីរ៉ូស៊ីម៉ា",
      "neName": "हिरोसिमा जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "340022",
      "name": "芸北",
      "enName": "Geihoku"
    },
    "class20": {
      "code": "3436800",
      "name": "安芸太田町",
      "enName": "Akiota Town",
      "kana": "あきおおたちょう",
      "chName": "安芸太田町",
      "zhName": "安藝太田町",
      "koName": "아키오타 정",
      "esName": "Pueblo de Aki-Ōta",
      "ptName": "bairro de Akiota",
      "thName": "เมืองอาคิโอตะ",
      "viName": "thị trấn Akiota",
      "inName": "kota Akiota",
      "tlName": "bayan ng Akiota",
      "moName": "Aкиота жижиг хот",
      "buName": "အာကိယို့တ မြို့နယ်",
      "khName": "ទីប្រជុំជន អាគីអតា",
      "neName": "आकिओता नगर"
    }
  },
  "3436900": {
    "office": {
      "code": "340000",
      "name": "広島県",
      "enName": "Hiroshima",
      "officeName": "広島地方気象台",
      "chName": "广岛县",
      "zhName": "廣島縣",
      "koName": "히로시마현",
      "esName": "Prefectura de Hiroshima",
      "ptName": "Província de Hiroshima",
      "thName": "จังหวัดฮิโรชิมะ",
      "viName": "Tỉnh Hiroshima",
      "inName": "Prefektur Hiroshima",
      "tlName": "Hiroshima Prefecture",
      "moName": "Хирошима аймаг",
      "buName": "ဟီရိုရှိမ ပြည်နယ်",
      "khName": "ខេត្ដ ហ៊ីរ៉ូស៊ីម៉ា",
      "neName": "हिरोसिमा जिल्ला"
    },
    "class10": {
      "code": "340020",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "广岛县北部",
      "zhName": "廣島縣北部",
      "koName": "히로시마 현 북부",
      "esName": "Norte de Prefectura de Hiroshima",
      "ptName": "Norte da Província de Hiroshima",
      "thName": "จังหวัดฮิโรชิมะตอนเหนือ",
      "viName": "Miền Bắc tỉnh Hiroshima",
      "inName": "Bagian Utara Prefektur Hiroshima",
      "tlName": "Hilagang bahagi ng Hiroshima Prefecture",
      "moName": "Хойд Хирошима аймаг",
      "buName": "ဟိရိုရှီးမားစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដហ៊ីរ៉ូស៊ីម៉ា",
      "neName": "हिरोसिमा जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "340022",
      "name": "芸北",
      "enName": "Geihoku"
    },
    "class20": {
      "code": "3436900",
      "name": "北広島町",
      "enName": "Kitahiroshima Town",
      "kana": "きたひろしまちょう",
      "chName": "北广岛町",
      "zhName": "北廣島町",
      "koName": "기타히로시마 정",
      "esName": "Pueblo de Kita-hiroshima",
      "ptName": "bairro de Kitahiroshima",
      "thName": "เมืองคิตะฮิโรชิมะ",
      "viName": "thị trấn Kitahiroshima",
      "inName": "kota Kitahiroshima",
      "tlName": "bayan ng Kitahiroshima",
      "moName": "Китахирошима жижиг хот",
      "buName": "ခီတာဟိရိုးရှိမ မြို့နယ်",
      "khName": "ទីប្រជុំជន គីតាហ៊ីរ៉ូស៊ីម៉ា",
      "neName": "किताहिरोशिमा नगर"
    }
  },
  "3443100": {
    "office": {
      "code": "340000",
      "name": "広島県",
      "enName": "Hiroshima",
      "officeName": "広島地方気象台",
      "chName": "广岛县",
      "zhName": "廣島縣",
      "koName": "히로시마현",
      "esName": "Prefectura de Hiroshima",
      "ptName": "Província de Hiroshima",
      "thName": "จังหวัดฮิโรชิมะ",
      "viName": "Tỉnh Hiroshima",
      "inName": "Prefektur Hiroshima",
      "tlName": "Hiroshima Prefecture",
      "moName": "Хирошима аймаг",
      "buName": "ဟီရိုရှိမ ပြည်နယ်",
      "khName": "ខេត្ដ ហ៊ីរ៉ូស៊ីម៉ា",
      "neName": "हिरोसिमा जिल्ला"
    },
    "class10": {
      "code": "340010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "广岛县南部",
      "zhName": "廣島縣南部",
      "koName": "히로시마 현 남부",
      "esName": "Sur de Prefectura de Hiroshima",
      "ptName": "Sul da Província de Hiroshima",
      "thName": "จังหวัดฮิโรชิมะตอนใต้",
      "viName": "Miền Nam tỉnh Hiroshima",
      "inName": "Bagian Selatan Prefektur Hiroshima",
      "tlName": "Timog bahagi ng Hiroshima Prefecture",
      "moName": "Өмнөд Хирошима аймаг",
      "buName": "ဟိရိုရှီးမားစီရင်စု အရှေ့တောင်ပိုင်း",
      "khName": "តំបន់ជើងខាងត្បូងនៃខេត្ដហ៊ីរ៉ូស៊ីម៉ា",
      "neName": "हिरोसिमा जिल्लाको दक्षिण भाग"
    },
    "class15": {
      "code": "340013",
      "name": "東広島・竹原",
      "enName": "Higashi-hiroshima Takehara"
    },
    "class20": {
      "code": "3443100",
      "name": "大崎上島町",
      "enName": "Osakikamijima Town",
      "kana": "おおさきかみじまちょう",
      "chName": "大崎上岛町",
      "zhName": "大崎上島町",
      "koName": "오사키카미지마 정",
      "esName": "Pueblo de Ōsaki-kamijima",
      "ptName": "bairro de Osakikamijima",
      "thName": "เมืองโอซากิคามิจิมะ",
      "viName": "thị trấn Osakikamijima",
      "inName": "kota Osakikamijima",
      "tlName": "bayan ng Osakikamijima",
      "moName": "Осaкикамижимa жижиг хот",
      "buName": "အိုဆာကိကားမိဂျိမ မြို့နယ်",
      "khName": "ទីប្រជុំជន អូសាគីកាមីជីម៉ា",
      "neName": "ओसाकिकामिजिमा नगर"
    }
  },
  "3446200": {
    "office": {
      "code": "340000",
      "name": "広島県",
      "enName": "Hiroshima",
      "officeName": "広島地方気象台",
      "chName": "广岛县",
      "zhName": "廣島縣",
      "koName": "히로시마현",
      "esName": "Prefectura de Hiroshima",
      "ptName": "Província de Hiroshima",
      "thName": "จังหวัดฮิโรชิมะ",
      "viName": "Tỉnh Hiroshima",
      "inName": "Prefektur Hiroshima",
      "tlName": "Hiroshima Prefecture",
      "moName": "Хирошима аймаг",
      "buName": "ဟီရိုရှိမ ပြည်နယ်",
      "khName": "ខេត្ដ ហ៊ីរ៉ូស៊ីម៉ា",
      "neName": "हिरोसिमा जिल्ला"
    },
    "class10": {
      "code": "340010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "广岛县南部",
      "zhName": "廣島縣南部",
      "koName": "히로시마 현 남부",
      "esName": "Sur de Prefectura de Hiroshima",
      "ptName": "Sul da Província de Hiroshima",
      "thName": "จังหวัดฮิโรชิมะตอนใต้",
      "viName": "Miền Nam tỉnh Hiroshima",
      "inName": "Bagian Selatan Prefektur Hiroshima",
      "tlName": "Timog bahagi ng Hiroshima Prefecture",
      "moName": "Өмнөд Хирошима аймаг",
      "buName": "ဟိရိုရှီးမားစီရင်စု အရှေ့တောင်ပိုင်း",
      "khName": "តំបន់ជើងខាងត្បូងនៃខេត្ដហ៊ីរ៉ូស៊ីម៉ា",
      "neName": "हिरोसिमा जिल्लाको दक्षिण भाग"
    },
    "class15": {
      "code": "340012",
      "name": "福山・尾三",
      "enName": "Fukuyama Bisan"
    },
    "class20": {
      "code": "3446200",
      "name": "世羅町",
      "enName": "Sera Town",
      "kana": "せらちょう",
      "chName": "世罗町",
      "zhName": "世羅町",
      "koName": "세라 정",
      "esName": "Pueblo de Sera",
      "ptName": "bairro de Sera",
      "thName": "เมืองเซระ",
      "viName": "thị trấn Sera",
      "inName": "kota Sera",
      "tlName": "bayan ng Sera",
      "moName": "Сэра жижиг хот",
      "buName": "ဆဲရာ့ မြို့နယ်",
      "khName": "ទីប្រជុំជន សេរ៉ា",
      "neName": "सेरा नगर"
    }
  },
  "3454500": {
    "office": {
      "code": "340000",
      "name": "広島県",
      "enName": "Hiroshima",
      "officeName": "広島地方気象台",
      "chName": "广岛县",
      "zhName": "廣島縣",
      "koName": "히로시마현",
      "esName": "Prefectura de Hiroshima",
      "ptName": "Província de Hiroshima",
      "thName": "จังหวัดฮิโรชิมะ",
      "viName": "Tỉnh Hiroshima",
      "inName": "Prefektur Hiroshima",
      "tlName": "Hiroshima Prefecture",
      "moName": "Хирошима аймаг",
      "buName": "ဟီရိုရှိမ ပြည်နယ်",
      "khName": "ខេត្ដ ហ៊ីរ៉ូស៊ីម៉ា",
      "neName": "हिरोसिमा जिल्ला"
    },
    "class10": {
      "code": "340010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "广岛县南部",
      "zhName": "廣島縣南部",
      "koName": "히로시마 현 남부",
      "esName": "Sur de Prefectura de Hiroshima",
      "ptName": "Sul da Província de Hiroshima",
      "thName": "จังหวัดฮิโรชิมะตอนใต้",
      "viName": "Miền Nam tỉnh Hiroshima",
      "inName": "Bagian Selatan Prefektur Hiroshima",
      "tlName": "Timog bahagi ng Hiroshima Prefecture",
      "moName": "Өмнөд Хирошима аймаг",
      "buName": "ဟိရိုရှီးမားစီရင်စု အရှေ့တောင်ပိုင်း",
      "khName": "តំបន់ជើងខាងត្បូងនៃខេត្ដហ៊ីរ៉ូស៊ីម៉ា",
      "neName": "हिरोसिमा जिल्लाको दक्षिण भाग"
    },
    "class15": {
      "code": "340012",
      "name": "福山・尾三",
      "enName": "Fukuyama Bisan"
    },
    "class20": {
      "code": "3454500",
      "name": "神石高原町",
      "enName": "Jinsekikogen Town",
      "kana": "じんせきこうげんちょう",
      "chName": "神石高原町",
      "zhName": "神石髙原町",
      "koName": "진세키코겐 정",
      "esName": "Pueblo de Jinseki-Kōgen",
      "ptName": "bairro de Jinsekikogen",
      "thName": "เมืองจินเซกิโคเงน",
      "viName": "thị trấn Jinsekikogen",
      "inName": "kota Jinsekikogen",
      "tlName": "bayan ng Jinsekikogen",
      "moName": "Жинсэкикогэн жижиг хот",
      "buName": "ဂျင်ဆဲခိကိုးဂန် မြို့နယ်",
      "khName": "ទីប្រជុំជន ជីនសេកគីកូជីន",
      "neName": "जिन्सेकिकोगेन नगर"
    }
  },
  "3520100": {
    "office": {
      "code": "350000",
      "name": "山口県",
      "enName": "Yamaguchi",
      "officeName": "下関地方気象台",
      "chName": "山口县",
      "zhName": "山口縣",
      "koName": "야마구치현",
      "esName": "Prefectura de Yamaguchi",
      "ptName": "Província de Yamaguchi",
      "thName": "จังหวัดยามางุจิ",
      "viName": "Tỉnh Yamaguchi",
      "inName": "Prefektur Yamaguchi",
      "tlName": "Yamaguchi Prefecture",
      "moName": "Ямагүчи аймаг",
      "buName": "ယာမဂုကျိ ပြည်နယ်",
      "khName": "ខេត្ដ យ៉ាម៉ាគុជី",
      "neName": "यामागुची जिल्ला"
    },
    "class10": {
      "code": "350010",
      "name": "西部",
      "enName": "Western Region",
      "chName": "山口县西部",
      "zhName": "山口縣西部",
      "koName": "야마구치 현 서부",
      "esName": "Oeste de Prefectura de Yamaguchi",
      "ptName": "Oeste da Província de Yamaguchi",
      "thName": "จังหวัดยามางุจิฟากตะวันตก",
      "viName": "Miền Tây tỉnh Yamaguchi",
      "inName": "Bagian Barat Prefektur Yamaguchi",
      "tlName": "Kanlurang bahagi ng Yamaguchi Prefecture",
      "moName": "Баруун Ямагүчи аймаг",
      "buName": "ယမဂုချိစီရင်စု အနောက်ပိုင်း",
      "khName": "តំបន់ខាងលិចនៃខេត្ដយ៉ាម៉ាហ្គឹឈិ",
      "neName": "यामागुची जिल्लाको पश्चिमी भाग"
    },
    "class15": {
      "code": "350011",
      "name": "下関",
      "enName": "Shimonoseki"
    },
    "class20": {
      "code": "3520100",
      "name": "下関市",
      "enName": "Shimonoseki City",
      "kana": "しものせきし",
      "chName": "下关市",
      "zhName": "下關市",
      "koName": "시모노세키 시",
      "esName": "Ciudad de Shimonoseki",
      "ptName": "cidade de Shimonoseki",
      "thName": "เมืองชิโมโนเซกิ",
      "viName": "thành phố Shimonoseki",
      "inName": "kota Shimonoseki",
      "tlName": "siyudad ng Shimonoseki",
      "moName": "Шимоносэки хот",
      "buName": "ရှီမို့နိုဆေးကိ မြို့",
      "khName": "ទីក្រុង ស៊ីម៉ូណូសេគី",
      "neName": "शिमोनोसेकी सहर"
    }
  },
  "3520200": {
    "office": {
      "code": "350000",
      "name": "山口県",
      "enName": "Yamaguchi",
      "officeName": "下関地方気象台",
      "chName": "山口县",
      "zhName": "山口縣",
      "koName": "야마구치현",
      "esName": "Prefectura de Yamaguchi",
      "ptName": "Província de Yamaguchi",
      "thName": "จังหวัดยามางุจิ",
      "viName": "Tỉnh Yamaguchi",
      "inName": "Prefektur Yamaguchi",
      "tlName": "Yamaguchi Prefecture",
      "moName": "Ямагүчи аймаг",
      "buName": "ယာမဂုကျိ ပြည်နယ်",
      "khName": "ខេត្ដ យ៉ាម៉ាគុជី",
      "neName": "यामागुची जिल्ला"
    },
    "class10": {
      "code": "350010",
      "name": "西部",
      "enName": "Western Region",
      "chName": "山口县西部",
      "zhName": "山口縣西部",
      "koName": "야마구치 현 서부",
      "esName": "Oeste de Prefectura de Yamaguchi",
      "ptName": "Oeste da Província de Yamaguchi",
      "thName": "จังหวัดยามางุจิฟากตะวันตก",
      "viName": "Miền Tây tỉnh Yamaguchi",
      "inName": "Bagian Barat Prefektur Yamaguchi",
      "tlName": "Kanlurang bahagi ng Yamaguchi Prefecture",
      "moName": "Баруун Ямагүчи аймаг",
      "buName": "ယမဂုချိစီရင်စု အနောက်ပိုင်း",
      "khName": "តំបន់ខាងលិចនៃខេត្ដយ៉ាម៉ាហ្គឹឈិ",
      "neName": "यामागुची जिल्लाको पश्चिमी भाग"
    },
    "class15": {
      "code": "350012",
      "name": "宇部・山陽小野田",
      "enName": "Ube and Sanyo Onoda"
    },
    "class20": {
      "code": "3520200",
      "name": "宇部市",
      "enName": "Ube City",
      "kana": "うべし",
      "chName": "宇部市",
      "zhName": "宇部市",
      "koName": "우베 시",
      "esName": "Ciudad de Ube",
      "ptName": "cidade de Ube",
      "thName": "เมืองอุเบะ",
      "viName": "thành phố Ube",
      "inName": "kota Ube",
      "tlName": "siyudad ng Ube",
      "moName": "Үбэ хот",
      "buName": "အူးဗဲ့ မြို့",
      "khName": "ទីក្រុង យូបេ",
      "neName": "उबे सहर"
    }
  },
  "3520300": {
    "office": {
      "code": "350000",
      "name": "山口県",
      "enName": "Yamaguchi",
      "officeName": "下関地方気象台",
      "chName": "山口县",
      "zhName": "山口縣",
      "koName": "야마구치현",
      "esName": "Prefectura de Yamaguchi",
      "ptName": "Província de Yamaguchi",
      "thName": "จังหวัดยามางุจิ",
      "viName": "Tỉnh Yamaguchi",
      "inName": "Prefektur Yamaguchi",
      "tlName": "Yamaguchi Prefecture",
      "moName": "Ямагүчи аймаг",
      "buName": "ယာမဂုကျိ ပြည်နယ်",
      "khName": "ខេត្ដ យ៉ាម៉ាគុជី",
      "neName": "यामागुची जिल्ला"
    },
    "class10": {
      "code": "350020",
      "name": "中部",
      "enName": "Central Region",
      "chName": "山口县中部",
      "zhName": "山口縣中部",
      "koName": "야마구치 현 중부",
      "esName": "Centro de Prefectura de Yamaguchi",
      "ptName": "Região central da Província de Yamaguchi",
      "thName": "จังหวัดยามางุจิตอนกลาง",
      "viName": "Miền Trung tỉnh Yamaguchi",
      "inName": "Bagian Tengah Prefektur Yamaguchi",
      "tlName": "Sentral na bahagi ng Yamaguchi Prefecture",
      "moName": "Төв Ямагүчи аймаг",
      "buName": "ယမဂုချိစီရင်စု အလယ်ပိုင်း",
      "khName": "តំបន់កណ្តាលនៃខេត្ដយ៉ាម៉ាហ្គឹឈិ",
      "neName": "यामागुची जिल्लाको मध्य भाग"
    },
    "class15": {
      "code": "350021",
      "name": "山口・防府",
      "enName": "Yamaguchi Hofu"
    },
    "class20": {
      "code": "3520300",
      "name": "山口市",
      "enName": "Yamaguchi City",
      "kana": "やまぐちし",
      "chName": "山口市",
      "zhName": "山口市",
      "koName": "야마구치 시",
      "esName": "Ciudad de Yamaguchi",
      "ptName": "cidade de Yamaguchi",
      "thName": "เมืองยามางุจิ",
      "viName": "thành phố Yamaguchi",
      "inName": "kota Yamaguchi",
      "tlName": "siyudad ng Yamaguchi",
      "moName": "Ямaгүчи хот",
      "buName": "ယာမာဂုကျိ မြို့",
      "khName": "ទីក្រុង យ៉ាម៉ាគូជី",
      "neName": "यामागुची सहर"
    }
  },
  "3520400": {
    "office": {
      "code": "350000",
      "name": "山口県",
      "enName": "Yamaguchi",
      "officeName": "下関地方気象台",
      "chName": "山口县",
      "zhName": "山口縣",
      "koName": "야마구치현",
      "esName": "Prefectura de Yamaguchi",
      "ptName": "Província de Yamaguchi",
      "thName": "จังหวัดยามางุจิ",
      "viName": "Tỉnh Yamaguchi",
      "inName": "Prefektur Yamaguchi",
      "tlName": "Yamaguchi Prefecture",
      "moName": "Ямагүчи аймаг",
      "buName": "ယာမဂုကျိ ပြည်နယ်",
      "khName": "ខេត្ដ យ៉ាម៉ាគុជី",
      "neName": "यामागुची जिल्ला"
    },
    "class10": {
      "code": "350040",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "山口县北部",
      "zhName": "山口縣北部",
      "koName": "야마구치 현 북부",
      "esName": "Norte de Prefectura de Yamaguchi",
      "ptName": "Norte da Província de Yamaguchi",
      "thName": "จังหวัดยามางุจิตอนเหนือ",
      "viName": "Miền Bắc tỉnh Yamaguchi",
      "inName": "Bagian Utara Prefektur Yamaguchi",
      "tlName": "Hilagang bahagi ng Yamaguchi Prefecture",
      "moName": "Хойд Ямагүчи аймаг",
      "buName": "ယမဂုချိစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដយ៉ាម៉ាហ្គឹឈិ",
      "neName": "यामागुची जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "350041",
      "name": "萩・美祢",
      "enName": "Hagi Mine"
    },
    "class20": {
      "code": "3520400",
      "name": "萩市",
      "enName": "Hagi City",
      "kana": "はぎし",
      "chName": "萩市",
      "zhName": "萩市",
      "koName": "하기시",
      "esName": "Ciudad de Hagi",
      "ptName": "cidade de Hagi",
      "thName": "เมืองฮางิ",
      "viName": "thành phố Hagi",
      "inName": "kota Hagi",
      "tlName": "siyudad ng Hagi",
      "moName": "Хaги хот",
      "buName": "ဟာဂိ မြို့",
      "khName": "ទីក្រុង ហាហ្គី",
      "neName": "हागी सहर"
    }
  },
  "3520600": {
    "office": {
      "code": "350000",
      "name": "山口県",
      "enName": "Yamaguchi",
      "officeName": "下関地方気象台",
      "chName": "山口县",
      "zhName": "山口縣",
      "koName": "야마구치현",
      "esName": "Prefectura de Yamaguchi",
      "ptName": "Província de Yamaguchi",
      "thName": "จังหวัดยามางุจิ",
      "viName": "Tỉnh Yamaguchi",
      "inName": "Prefektur Yamaguchi",
      "tlName": "Yamaguchi Prefecture",
      "moName": "Ямагүчи аймаг",
      "buName": "ယာမဂုကျိ ပြည်နယ်",
      "khName": "ខេត្ដ យ៉ាម៉ាគុជី",
      "neName": "यामागुची जिल्ला"
    },
    "class10": {
      "code": "350020",
      "name": "中部",
      "enName": "Central Region",
      "chName": "山口县中部",
      "zhName": "山口縣中部",
      "koName": "야마구치 현 중부",
      "esName": "Centro de Prefectura de Yamaguchi",
      "ptName": "Região central da Província de Yamaguchi",
      "thName": "จังหวัดยามางุจิตอนกลาง",
      "viName": "Miền Trung tỉnh Yamaguchi",
      "inName": "Bagian Tengah Prefektur Yamaguchi",
      "tlName": "Sentral na bahagi ng Yamaguchi Prefecture",
      "moName": "Төв Ямагүчи аймаг",
      "buName": "ယမဂုချိစီရင်စု အလယ်ပိုင်း",
      "khName": "តំបន់កណ្តាលនៃខេត្ដយ៉ាម៉ាហ្គឹឈិ",
      "neName": "यामागुची जिल्लाको मध्य भाग"
    },
    "class15": {
      "code": "350021",
      "name": "山口・防府",
      "enName": "Yamaguchi Hofu"
    },
    "class20": {
      "code": "3520600",
      "name": "防府市",
      "enName": "Hofu City",
      "kana": "ほうふし",
      "chName": "防府市",
      "zhName": "防府市",
      "koName": "호후 시",
      "esName": "Ciudad de Hofu",
      "ptName": "cidade de Hofu",
      "thName": "เมืองโฮฟุ",
      "viName": "thành phố Hofu",
      "inName": "kota Hofu",
      "tlName": "siyudad ng Hofu",
      "moName": "Хофү хот",
      "buName": "ဟိုးဖူ မြို့",
      "khName": "ទីក្រុង ហូហ្វូ",
      "neName": "होफु सहर"
    }
  },
  "3520700": {
    "office": {
      "code": "350000",
      "name": "山口県",
      "enName": "Yamaguchi",
      "officeName": "下関地方気象台",
      "chName": "山口县",
      "zhName": "山口縣",
      "koName": "야마구치현",
      "esName": "Prefectura de Yamaguchi",
      "ptName": "Província de Yamaguchi",
      "thName": "จังหวัดยามางุจิ",
      "viName": "Tỉnh Yamaguchi",
      "inName": "Prefektur Yamaguchi",
      "tlName": "Yamaguchi Prefecture",
      "moName": "Ямагүчи аймаг",
      "buName": "ယာမဂုကျိ ပြည်နယ်",
      "khName": "ខេត្ដ យ៉ាម៉ាគុជី",
      "neName": "यामागुची जिल्ला"
    },
    "class10": {
      "code": "350020",
      "name": "中部",
      "enName": "Central Region",
      "chName": "山口县中部",
      "zhName": "山口縣中部",
      "koName": "야마구치 현 중부",
      "esName": "Centro de Prefectura de Yamaguchi",
      "ptName": "Região central da Província de Yamaguchi",
      "thName": "จังหวัดยามางุจิตอนกลาง",
      "viName": "Miền Trung tỉnh Yamaguchi",
      "inName": "Bagian Tengah Prefektur Yamaguchi",
      "tlName": "Sentral na bahagi ng Yamaguchi Prefecture",
      "moName": "Төв Ямагүчи аймаг",
      "buName": "ယမဂုချိစီရင်စု အလယ်ပိုင်း",
      "khName": "តំបន់កណ្តាលនៃខេត្ដយ៉ាម៉ាហ្គឹឈិ",
      "neName": "यामागुची जिल्लाको मध्य भाग"
    },
    "class15": {
      "code": "350022",
      "name": "周南・下松",
      "enName": "Shunan Kudamatsu"
    },
    "class20": {
      "code": "3520700",
      "name": "下松市",
      "enName": "Kudamatsu City",
      "kana": "くだまつし",
      "chName": "下松市",
      "zhName": "下松市",
      "koName": "구다마쓰 시",
      "esName": "Ciudad de Kudamatsu",
      "ptName": "cidade de Kudamatsu",
      "thName": "เมืองคุดามัทสึ",
      "viName": "thành phố Kudamatsu",
      "inName": "kota Kudamatsu",
      "tlName": "siyudad ng Kudamatsu",
      "moName": "Күдамацү хот",
      "buName": "ခူဒမာ့ဆု မြို့",
      "khName": "ទីក្រុង គូដាម៉ាតស៊ូ",
      "neName": "कुदामात्सु सहर"
    }
  },
  "3520800": {
    "office": {
      "code": "350000",
      "name": "山口県",
      "enName": "Yamaguchi",
      "officeName": "下関地方気象台",
      "chName": "山口县",
      "zhName": "山口縣",
      "koName": "야마구치현",
      "esName": "Prefectura de Yamaguchi",
      "ptName": "Província de Yamaguchi",
      "thName": "จังหวัดยามางุจิ",
      "viName": "Tỉnh Yamaguchi",
      "inName": "Prefektur Yamaguchi",
      "tlName": "Yamaguchi Prefecture",
      "moName": "Ямагүчи аймаг",
      "buName": "ယာမဂုကျိ ပြည်နယ်",
      "khName": "ខេត្ដ យ៉ាម៉ាគុជី",
      "neName": "यामागुची जिल्ला"
    },
    "class10": {
      "code": "350030",
      "name": "東部",
      "enName": "Eastern Region",
      "chName": "山口县东部",
      "zhName": "山口縣東部",
      "koName": "야마구치 현 동부",
      "esName": "Este de Prefectura de Yamaguchi",
      "ptName": "Leste da Província de Yamaguchi",
      "thName": "จังหวัดยามางุจิฟากตะวันออก",
      "viName": "Miền Đông tỉnh Yamaguchi",
      "inName": "Bagian Timur Prefektur Yamaguchi",
      "tlName": "Silangang bahagi ng Yamaguchi Prefecture",
      "moName": "Зүүн Ямагүчи аймаг",
      "buName": "ယမဂုချိစီရင်စု အရှေ့ပိုင်း",
      "khName": "តំបន់ខាងកើតនៃខេត្ដយ៉ាម៉ាហ្គឹឈិ",
      "neName": "यामागुची जिल्लाको पूर्वी भाग"
    },
    "class15": {
      "code": "350031",
      "name": "岩国",
      "enName": "Iwakuni"
    },
    "class20": {
      "code": "3520800",
      "name": "岩国市",
      "enName": "Iwakuni City",
      "kana": "いわくにし",
      "chName": "岩国市",
      "zhName": "岩國市",
      "koName": "이와쿠니 시",
      "esName": "Ciudad de Iwakuni",
      "ptName": "cidade de Iwakuni",
      "thName": "เมืองอิวะคุนิ",
      "viName": "thành phố Iwakuni",
      "inName": "kota Iwakuni",
      "tlName": "siyudad ng Iwakuni",
      "moName": "Ивакүни хот",
      "buName": "အီဝကုနိ မြို့",
      "khName": "ទីក្រុង អ៊ីវ៉ាគុនី",
      "neName": "इवाकुनी सहर"
    }
  },
  "3521000": {
    "office": {
      "code": "350000",
      "name": "山口県",
      "enName": "Yamaguchi",
      "officeName": "下関地方気象台",
      "chName": "山口县",
      "zhName": "山口縣",
      "koName": "야마구치현",
      "esName": "Prefectura de Yamaguchi",
      "ptName": "Província de Yamaguchi",
      "thName": "จังหวัดยามางุจิ",
      "viName": "Tỉnh Yamaguchi",
      "inName": "Prefektur Yamaguchi",
      "tlName": "Yamaguchi Prefecture",
      "moName": "Ямагүчи аймаг",
      "buName": "ယာမဂုကျိ ပြည်နယ်",
      "khName": "ខេត្ដ យ៉ាម៉ាគុជី",
      "neName": "यामागुची जिल्ला"
    },
    "class10": {
      "code": "350030",
      "name": "東部",
      "enName": "Eastern Region",
      "chName": "山口县东部",
      "zhName": "山口縣東部",
      "koName": "야마구치 현 동부",
      "esName": "Este de Prefectura de Yamaguchi",
      "ptName": "Leste da Província de Yamaguchi",
      "thName": "จังหวัดยามางุจิฟากตะวันออก",
      "viName": "Miền Đông tỉnh Yamaguchi",
      "inName": "Bagian Timur Prefektur Yamaguchi",
      "tlName": "Silangang bahagi ng Yamaguchi Prefecture",
      "moName": "Зүүн Ямагүчи аймаг",
      "buName": "ယမဂုချိစီရင်စု အရှေ့ပိုင်း",
      "khName": "តំបន់ខាងកើតនៃខេត្ដយ៉ាម៉ាហ្គឹឈិ",
      "neName": "यामागुची जिल्लाको पूर्वी भाग"
    },
    "class15": {
      "code": "350032",
      "name": "柳井・光",
      "enName": "Yanai Hikari"
    },
    "class20": {
      "code": "3521000",
      "name": "光市",
      "enName": "Hikari City",
      "kana": "ひかりし",
      "chName": "光市",
      "zhName": "光市",
      "koName": "히카리 시",
      "esName": "Ciudad de Hikari",
      "ptName": "cidade de Hikari",
      "thName": "เมืองฮิคาริ",
      "viName": "thành phố Hikari",
      "inName": "kota Hikari",
      "tlName": "siyudad ng Hikari",
      "moName": "Хикари хот",
      "buName": "ဟီခါးရိ မြို့",
      "khName": "ទីក្រុង ហ៊ីការី",
      "neName": "हिकारी सहर"
    }
  },
  "3521100": {
    "office": {
      "code": "350000",
      "name": "山口県",
      "enName": "Yamaguchi",
      "officeName": "下関地方気象台",
      "chName": "山口县",
      "zhName": "山口縣",
      "koName": "야마구치현",
      "esName": "Prefectura de Yamaguchi",
      "ptName": "Província de Yamaguchi",
      "thName": "จังหวัดยามางุจิ",
      "viName": "Tỉnh Yamaguchi",
      "inName": "Prefektur Yamaguchi",
      "tlName": "Yamaguchi Prefecture",
      "moName": "Ямагүчи аймаг",
      "buName": "ယာမဂုကျိ ပြည်နယ်",
      "khName": "ខេត្ដ យ៉ាម៉ាគុជី",
      "neName": "यामागुची जिल्ला"
    },
    "class10": {
      "code": "350040",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "山口县北部",
      "zhName": "山口縣北部",
      "koName": "야마구치 현 북부",
      "esName": "Norte de Prefectura de Yamaguchi",
      "ptName": "Norte da Província de Yamaguchi",
      "thName": "จังหวัดยามางุจิตอนเหนือ",
      "viName": "Miền Bắc tỉnh Yamaguchi",
      "inName": "Bagian Utara Prefektur Yamaguchi",
      "tlName": "Hilagang bahagi ng Yamaguchi Prefecture",
      "moName": "Хойд Ямагүчи аймаг",
      "buName": "ယမဂုချိစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដយ៉ាម៉ាហ្គឹឈិ",
      "neName": "यामागुची जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "350042",
      "name": "長門",
      "enName": "Nagato"
    },
    "class20": {
      "code": "3521100",
      "name": "長門市",
      "enName": "Nagato City",
      "kana": "ながとし",
      "chName": "长门市",
      "zhName": "長門市",
      "koName": "나가토 시",
      "esName": "Ciudad de Nagato",
      "ptName": "cidade de Nagato",
      "thName": "เมืองนางาโตะ",
      "viName": "thành phố Nagato",
      "inName": "kota Nagato",
      "tlName": "siyudad ng Nagato",
      "moName": "Нaгaто хот",
      "buName": "နာဂါတို မြို့",
      "khName": "ទីក្រុង ណាហ្គាតូ",
      "neName": "नागातो सहर"
    }
  },
  "3521200": {
    "office": {
      "code": "350000",
      "name": "山口県",
      "enName": "Yamaguchi",
      "officeName": "下関地方気象台",
      "chName": "山口县",
      "zhName": "山口縣",
      "koName": "야마구치현",
      "esName": "Prefectura de Yamaguchi",
      "ptName": "Província de Yamaguchi",
      "thName": "จังหวัดยามางุจิ",
      "viName": "Tỉnh Yamaguchi",
      "inName": "Prefektur Yamaguchi",
      "tlName": "Yamaguchi Prefecture",
      "moName": "Ямагүчи аймаг",
      "buName": "ယာမဂုကျိ ပြည်နယ်",
      "khName": "ខេត្ដ យ៉ាម៉ាគុជី",
      "neName": "यामागुची जिल्ला"
    },
    "class10": {
      "code": "350030",
      "name": "東部",
      "enName": "Eastern Region",
      "chName": "山口县东部",
      "zhName": "山口縣東部",
      "koName": "야마구치 현 동부",
      "esName": "Este de Prefectura de Yamaguchi",
      "ptName": "Leste da Província de Yamaguchi",
      "thName": "จังหวัดยามางุจิฟากตะวันออก",
      "viName": "Miền Đông tỉnh Yamaguchi",
      "inName": "Bagian Timur Prefektur Yamaguchi",
      "tlName": "Silangang bahagi ng Yamaguchi Prefecture",
      "moName": "Зүүн Ямагүчи аймаг",
      "buName": "ယမဂုချိစီရင်စု အရှေ့ပိုင်း",
      "khName": "តំបន់ខាងកើតនៃខេត្ដយ៉ាម៉ាហ្គឹឈិ",
      "neName": "यामागुची जिल्लाको पूर्वी भाग"
    },
    "class15": {
      "code": "350032",
      "name": "柳井・光",
      "enName": "Yanai Hikari"
    },
    "class20": {
      "code": "3521200",
      "name": "柳井市",
      "enName": "Yanai City",
      "kana": "やないし",
      "chName": "柳井市",
      "zhName": "柳井市",
      "koName": "야나이 시",
      "esName": "Ciudad de Yanai",
      "ptName": "cidade de Yanai",
      "thName": "เมืองยานาอิ",
      "viName": "thành phố Yanai",
      "inName": "kota Yanai",
      "tlName": "siyudad ng Yanai",
      "moName": "Янaй хот",
      "buName": "ယာနားယိ မြို့",
      "khName": "ទីក្រុង យ៉ាណៃ",
      "neName": "यानाई सहर"
    }
  },
  "3521300": {
    "office": {
      "code": "350000",
      "name": "山口県",
      "enName": "Yamaguchi",
      "officeName": "下関地方気象台",
      "chName": "山口县",
      "zhName": "山口縣",
      "koName": "야마구치현",
      "esName": "Prefectura de Yamaguchi",
      "ptName": "Província de Yamaguchi",
      "thName": "จังหวัดยามางุจิ",
      "viName": "Tỉnh Yamaguchi",
      "inName": "Prefektur Yamaguchi",
      "tlName": "Yamaguchi Prefecture",
      "moName": "Ямагүчи аймаг",
      "buName": "ယာမဂုကျိ ပြည်နယ်",
      "khName": "ខេត្ដ យ៉ាម៉ាគុជី",
      "neName": "यामागुची जिल्ला"
    },
    "class10": {
      "code": "350040",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "山口县北部",
      "zhName": "山口縣北部",
      "koName": "야마구치 현 북부",
      "esName": "Norte de Prefectura de Yamaguchi",
      "ptName": "Norte da Província de Yamaguchi",
      "thName": "จังหวัดยามางุจิตอนเหนือ",
      "viName": "Miền Bắc tỉnh Yamaguchi",
      "inName": "Bagian Utara Prefektur Yamaguchi",
      "tlName": "Hilagang bahagi ng Yamaguchi Prefecture",
      "moName": "Хойд Ямагүчи аймаг",
      "buName": "ယမဂုချိစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដយ៉ាម៉ាហ្គឹឈិ",
      "neName": "यामागुची जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "350041",
      "name": "萩・美祢",
      "enName": "Hagi Mine"
    },
    "class20": {
      "code": "3521300",
      "name": "美祢市",
      "enName": "Mine City",
      "kana": "みねし",
      "chName": "美祢市",
      "zhName": "美禰市",
      "koName": "미네 시",
      "esName": "Ciudad de Mine",
      "ptName": "cidade de Mine",
      "thName": "เมืองมิเนะ",
      "viName": "thành phố Mine",
      "inName": "kota Mine",
      "tlName": "siyudad ng Mine",
      "moName": "Минэ хот",
      "buName": "မိုင်းယင်း မြို့",
      "khName": "ទីក្រុង ម៉ាញ",
      "neName": "मिने सहर"
    }
  },
  "3521500": {
    "office": {
      "code": "350000",
      "name": "山口県",
      "enName": "Yamaguchi",
      "officeName": "下関地方気象台",
      "chName": "山口县",
      "zhName": "山口縣",
      "koName": "야마구치현",
      "esName": "Prefectura de Yamaguchi",
      "ptName": "Província de Yamaguchi",
      "thName": "จังหวัดยามางุจิ",
      "viName": "Tỉnh Yamaguchi",
      "inName": "Prefektur Yamaguchi",
      "tlName": "Yamaguchi Prefecture",
      "moName": "Ямагүчи аймаг",
      "buName": "ယာမဂုကျိ ပြည်နယ်",
      "khName": "ខេត្ដ យ៉ាម៉ាគុជី",
      "neName": "यामागुची जिल्ला"
    },
    "class10": {
      "code": "350020",
      "name": "中部",
      "enName": "Central Region",
      "chName": "山口县中部",
      "zhName": "山口縣中部",
      "koName": "야마구치 현 중부",
      "esName": "Centro de Prefectura de Yamaguchi",
      "ptName": "Região central da Província de Yamaguchi",
      "thName": "จังหวัดยามางุจิตอนกลาง",
      "viName": "Miền Trung tỉnh Yamaguchi",
      "inName": "Bagian Tengah Prefektur Yamaguchi",
      "tlName": "Sentral na bahagi ng Yamaguchi Prefecture",
      "moName": "Төв Ямагүчи аймаг",
      "buName": "ယမဂုချိစီရင်စု အလယ်ပိုင်း",
      "khName": "តំបន់កណ្តាលនៃខេត្ដយ៉ាម៉ាហ្គឹឈិ",
      "neName": "यामागुची जिल्लाको मध्य भाग"
    },
    "class15": {
      "code": "350022",
      "name": "周南・下松",
      "enName": "Shunan Kudamatsu"
    },
    "class20": {
      "code": "3521500",
      "name": "周南市",
      "enName": "Shunan City",
      "kana": "しゅうなんし",
      "chName": "周南市",
      "zhName": "周南市",
      "koName": "슈난 시",
      "esName": "Ciudad de Shunan",
      "ptName": "cidade de Shunan",
      "thName": "เมืองชูนัน",
      "viName": "thành phố Shunan",
      "inName": "kota Shunan",
      "tlName": "siyudad ng Shunan",
      "moName": "Шүнaн хот",
      "buName": "ရှူးနန် မြို့",
      "khName": "ទីក្រុង ស៊ូណាន",
      "neName": "शुनान सहर"
    }
  },
  "3521600": {
    "office": {
      "code": "350000",
      "name": "山口県",
      "enName": "Yamaguchi",
      "officeName": "下関地方気象台",
      "chName": "山口县",
      "zhName": "山口縣",
      "koName": "야마구치현",
      "esName": "Prefectura de Yamaguchi",
      "ptName": "Província de Yamaguchi",
      "thName": "จังหวัดยามางุจิ",
      "viName": "Tỉnh Yamaguchi",
      "inName": "Prefektur Yamaguchi",
      "tlName": "Yamaguchi Prefecture",
      "moName": "Ямагүчи аймаг",
      "buName": "ယာမဂုကျိ ပြည်နယ်",
      "khName": "ខេត្ដ យ៉ាម៉ាគុជី",
      "neName": "यामागुची जिल्ला"
    },
    "class10": {
      "code": "350010",
      "name": "西部",
      "enName": "Western Region",
      "chName": "山口县西部",
      "zhName": "山口縣西部",
      "koName": "야마구치 현 서부",
      "esName": "Oeste de Prefectura de Yamaguchi",
      "ptName": "Oeste da Província de Yamaguchi",
      "thName": "จังหวัดยามางุจิฟากตะวันตก",
      "viName": "Miền Tây tỉnh Yamaguchi",
      "inName": "Bagian Barat Prefektur Yamaguchi",
      "tlName": "Kanlurang bahagi ng Yamaguchi Prefecture",
      "moName": "Баруун Ямагүчи аймаг",
      "buName": "ယမဂုချိစီရင်စု အနောက်ပိုင်း",
      "khName": "តំបន់ខាងលិចនៃខេត្ដយ៉ាម៉ាហ្គឹឈិ",
      "neName": "यामागुची जिल्लाको पश्चिमी भाग"
    },
    "class15": {
      "code": "350012",
      "name": "宇部・山陽小野田",
      "enName": "Ube and Sanyo Onoda"
    },
    "class20": {
      "code": "3521600",
      "name": "山陽小野田市",
      "enName": "Sanyo Onoda City",
      "kana": "さんようおのだし",
      "chName": "山阳小野田市",
      "zhName": "山陽小野田市",
      "koName": "산요오노다 시",
      "esName": "Ciudad de Sanyo-Onoda",
      "ptName": "cidade de Sanyo Onoda",
      "thName": "เมืองซันโย โอโนดะ",
      "viName": "thành phố Sanyo Onoda",
      "inName": "kota Sanyo Onoda",
      "tlName": "siyudad ng Sanyo Onoda",
      "moName": "Сaнёо Онода хот",
      "buName": "ဆန်ယိုး အို့နိုဒ မြို့",
      "khName": "ទីក្រុង សានយ៉ូ អណូដា",
      "neName": "सानयो ओनोदा सहर"
    }
  },
  "3530500": {
    "office": {
      "code": "350000",
      "name": "山口県",
      "enName": "Yamaguchi",
      "officeName": "下関地方気象台",
      "chName": "山口县",
      "zhName": "山口縣",
      "koName": "야마구치현",
      "esName": "Prefectura de Yamaguchi",
      "ptName": "Província de Yamaguchi",
      "thName": "จังหวัดยามางุจิ",
      "viName": "Tỉnh Yamaguchi",
      "inName": "Prefektur Yamaguchi",
      "tlName": "Yamaguchi Prefecture",
      "moName": "Ямагүчи аймаг",
      "buName": "ယာမဂုကျိ ပြည်နယ်",
      "khName": "ខេត្ដ យ៉ាម៉ាគុជី",
      "neName": "यामागुची जिल्ला"
    },
    "class10": {
      "code": "350030",
      "name": "東部",
      "enName": "Eastern Region",
      "chName": "山口县东部",
      "zhName": "山口縣東部",
      "koName": "야마구치 현 동부",
      "esName": "Este de Prefectura de Yamaguchi",
      "ptName": "Leste da Província de Yamaguchi",
      "thName": "จังหวัดยามางุจิฟากตะวันออก",
      "viName": "Miền Đông tỉnh Yamaguchi",
      "inName": "Bagian Timur Prefektur Yamaguchi",
      "tlName": "Silangang bahagi ng Yamaguchi Prefecture",
      "moName": "Зүүн Ямагүчи аймаг",
      "buName": "ယမဂုချိစီရင်စု အရှေ့ပိုင်း",
      "khName": "តំបន់ខាងកើតនៃខេត្ដយ៉ាម៉ាហ្គឹឈិ",
      "neName": "यामागुची जिल्लाको पूर्वी भाग"
    },
    "class15": {
      "code": "350032",
      "name": "柳井・光",
      "enName": "Yanai Hikari"
    },
    "class20": {
      "code": "3530500",
      "name": "周防大島町",
      "enName": "Suo Oshima Town",
      "kana": "すおうおおしまちょう",
      "chName": "周防大岛町",
      "zhName": "周防大島町",
      "koName": "스오오시마 정",
      "esName": "Pueblo deSuō-Ōshima ",
      "ptName": "bairro de Suo-oshima",
      "thName": "เมืองซูโอโอชิมะ",
      "viName": "thị trấn Suo-oshima",
      "inName": "kota Suo-oshima",
      "tlName": "bayan ng Suo-oshima",
      "moName": "Сүо-Ошимa жижиг хот",
      "buName": "ဆူ-အိုရှိမ မြို့နယ်",
      "khName": "ទីប្រជុំជន សួ អូស៊ីម៉ា ",
      "neName": "सुओ-ओशिमा नगर"
    }
  },
  "3532100": {
    "office": {
      "code": "350000",
      "name": "山口県",
      "enName": "Yamaguchi",
      "officeName": "下関地方気象台",
      "chName": "山口县",
      "zhName": "山口縣",
      "koName": "야마구치현",
      "esName": "Prefectura de Yamaguchi",
      "ptName": "Província de Yamaguchi",
      "thName": "จังหวัดยามางุจิ",
      "viName": "Tỉnh Yamaguchi",
      "inName": "Prefektur Yamaguchi",
      "tlName": "Yamaguchi Prefecture",
      "moName": "Ямагүчи аймаг",
      "buName": "ယာမဂုကျိ ပြည်နယ်",
      "khName": "ខេត្ដ យ៉ាម៉ាគុជី",
      "neName": "यामागुची जिल्ला"
    },
    "class10": {
      "code": "350030",
      "name": "東部",
      "enName": "Eastern Region",
      "chName": "山口县东部",
      "zhName": "山口縣東部",
      "koName": "야마구치 현 동부",
      "esName": "Este de Prefectura de Yamaguchi",
      "ptName": "Leste da Província de Yamaguchi",
      "thName": "จังหวัดยามางุจิฟากตะวันออก",
      "viName": "Miền Đông tỉnh Yamaguchi",
      "inName": "Bagian Timur Prefektur Yamaguchi",
      "tlName": "Silangang bahagi ng Yamaguchi Prefecture",
      "moName": "Зүүн Ямагүчи аймаг",
      "buName": "ယမဂုချိစီရင်စု အရှေ့ပိုင်း",
      "khName": "តំបន់ខាងកើតនៃខេត្ដយ៉ាម៉ាហ្គឹឈិ",
      "neName": "यामागुची जिल्लाको पूर्वी भाग"
    },
    "class15": {
      "code": "350031",
      "name": "岩国",
      "enName": "Iwakuni"
    },
    "class20": {
      "code": "3532100",
      "name": "和木町",
      "enName": "Waki Town",
      "kana": "わきちょう",
      "chName": "和木町",
      "zhName": "和木町",
      "koName": "와키 정",
      "esName": "Pueblo de Waki",
      "ptName": "bairro de Waki",
      "thName": "เมืองวากิ",
      "viName": "thị trấn Waki",
      "inName": "kota Waki",
      "tlName": "bayan ng Waki",
      "moName": "Ваки жижиг хот",
      "buName": "ဝါကိ မြို့နယ်",
      "khName": "ទីប្រជុំជន វ៉ាគី",
      "neName": "वाकी नगर"
    }
  },
  "3534100": {
    "office": {
      "code": "350000",
      "name": "山口県",
      "enName": "Yamaguchi",
      "officeName": "下関地方気象台",
      "chName": "山口县",
      "zhName": "山口縣",
      "koName": "야마구치현",
      "esName": "Prefectura de Yamaguchi",
      "ptName": "Província de Yamaguchi",
      "thName": "จังหวัดยามางุจิ",
      "viName": "Tỉnh Yamaguchi",
      "inName": "Prefektur Yamaguchi",
      "tlName": "Yamaguchi Prefecture",
      "moName": "Ямагүчи аймаг",
      "buName": "ယာမဂုကျိ ပြည်နယ်",
      "khName": "ខេត្ដ យ៉ាម៉ាគុជី",
      "neName": "यामागुची जिल्ला"
    },
    "class10": {
      "code": "350030",
      "name": "東部",
      "enName": "Eastern Region",
      "chName": "山口县东部",
      "zhName": "山口縣東部",
      "koName": "야마구치 현 동부",
      "esName": "Este de Prefectura de Yamaguchi",
      "ptName": "Leste da Província de Yamaguchi",
      "thName": "จังหวัดยามางุจิฟากตะวันออก",
      "viName": "Miền Đông tỉnh Yamaguchi",
      "inName": "Bagian Timur Prefektur Yamaguchi",
      "tlName": "Silangang bahagi ng Yamaguchi Prefecture",
      "moName": "Зүүн Ямагүчи аймаг",
      "buName": "ယမဂုချိစီရင်စု အရှေ့ပိုင်း",
      "khName": "តំបន់ខាងកើតនៃខេត្ដយ៉ាម៉ាហ្គឹឈិ",
      "neName": "यामागुची जिल्लाको पूर्वी भाग"
    },
    "class15": {
      "code": "350032",
      "name": "柳井・光",
      "enName": "Yanai Hikari"
    },
    "class20": {
      "code": "3534100",
      "name": "上関町",
      "enName": "Kaminoseki Town",
      "kana": "かみのせきちょう",
      "chName": "上关町",
      "zhName": "上關町",
      "koName": "가미노세키 정",
      "esName": "Pueblo de Kaminoseki",
      "ptName": "bairro de Kaminoseki",
      "thName": "เมืองคามิโนเซกิ",
      "viName": "thị trấn Kaminoseki",
      "inName": "kota Kaminoseki",
      "tlName": "bayan ng Kaminoseki",
      "moName": "Каминосэки жижиг хот",
      "buName": "ခါမိနိုဆဲကိ မြို့နယ်",
      "khName": "ទីប្រជុំជន កាមីណូសេគី",
      "neName": "कामिनोसेकी नगर"
    }
  },
  "3534300": {
    "office": {
      "code": "350000",
      "name": "山口県",
      "enName": "Yamaguchi",
      "officeName": "下関地方気象台",
      "chName": "山口县",
      "zhName": "山口縣",
      "koName": "야마구치현",
      "esName": "Prefectura de Yamaguchi",
      "ptName": "Província de Yamaguchi",
      "thName": "จังหวัดยามางุจิ",
      "viName": "Tỉnh Yamaguchi",
      "inName": "Prefektur Yamaguchi",
      "tlName": "Yamaguchi Prefecture",
      "moName": "Ямагүчи аймаг",
      "buName": "ယာမဂုကျိ ပြည်နယ်",
      "khName": "ខេត្ដ យ៉ាម៉ាគុជី",
      "neName": "यामागुची जिल्ला"
    },
    "class10": {
      "code": "350030",
      "name": "東部",
      "enName": "Eastern Region",
      "chName": "山口县东部",
      "zhName": "山口縣東部",
      "koName": "야마구치 현 동부",
      "esName": "Este de Prefectura de Yamaguchi",
      "ptName": "Leste da Província de Yamaguchi",
      "thName": "จังหวัดยามางุจิฟากตะวันออก",
      "viName": "Miền Đông tỉnh Yamaguchi",
      "inName": "Bagian Timur Prefektur Yamaguchi",
      "tlName": "Silangang bahagi ng Yamaguchi Prefecture",
      "moName": "Зүүн Ямагүчи аймаг",
      "buName": "ယမဂုချိစီရင်စု အရှေ့ပိုင်း",
      "khName": "តំបន់ខាងកើតនៃខេត្ដយ៉ាម៉ាហ្គឹឈិ",
      "neName": "यामागुची जिल्लाको पूर्वी भाग"
    },
    "class15": {
      "code": "350032",
      "name": "柳井・光",
      "enName": "Yanai Hikari"
    },
    "class20": {
      "code": "3534300",
      "name": "田布施町",
      "enName": "Tabuse Town",
      "kana": "たぶせちょう",
      "chName": "田布施町",
      "zhName": "田布施町",
      "koName": "다부세 정",
      "esName": "Pueblo de Tabuse",
      "ptName": "bairro de Tabuse",
      "thName": "เมืองทาบุเสะ",
      "viName": "thị trấn Tabuse",
      "inName": "kota Tabuse",
      "tlName": "bayan ng Tabuse",
      "moName": "Табүсэ жижиг хот",
      "buName": "တာ့ဗုဆဲ့ မြို့နယ်",
      "khName": "ទីប្រជុំជន តាប្យូស",
      "neName": "ताबुसे नगर"
    }
  },
  "3534400": {
    "office": {
      "code": "350000",
      "name": "山口県",
      "enName": "Yamaguchi",
      "officeName": "下関地方気象台",
      "chName": "山口县",
      "zhName": "山口縣",
      "koName": "야마구치현",
      "esName": "Prefectura de Yamaguchi",
      "ptName": "Província de Yamaguchi",
      "thName": "จังหวัดยามางุจิ",
      "viName": "Tỉnh Yamaguchi",
      "inName": "Prefektur Yamaguchi",
      "tlName": "Yamaguchi Prefecture",
      "moName": "Ямагүчи аймаг",
      "buName": "ယာမဂုကျိ ပြည်နယ်",
      "khName": "ខេត្ដ យ៉ាម៉ាគុជី",
      "neName": "यामागुची जिल्ला"
    },
    "class10": {
      "code": "350030",
      "name": "東部",
      "enName": "Eastern Region",
      "chName": "山口县东部",
      "zhName": "山口縣東部",
      "koName": "야마구치 현 동부",
      "esName": "Este de Prefectura de Yamaguchi",
      "ptName": "Leste da Província de Yamaguchi",
      "thName": "จังหวัดยามางุจิฟากตะวันออก",
      "viName": "Miền Đông tỉnh Yamaguchi",
      "inName": "Bagian Timur Prefektur Yamaguchi",
      "tlName": "Silangang bahagi ng Yamaguchi Prefecture",
      "moName": "Зүүн Ямагүчи аймаг",
      "buName": "ယမဂုချိစီရင်စု အရှေ့ပိုင်း",
      "khName": "តំបន់ខាងកើតនៃខេត្ដយ៉ាម៉ាហ្គឹឈិ",
      "neName": "यामागुची जिल्लाको पूर्वी भाग"
    },
    "class15": {
      "code": "350032",
      "name": "柳井・光",
      "enName": "Yanai Hikari"
    },
    "class20": {
      "code": "3534400",
      "name": "平生町",
      "enName": "Hirao Town",
      "kana": "ひらおちょう",
      "chName": "平生町",
      "zhName": "平生町",
      "koName": "히라오 정",
      "esName": "Pueblo de Hirao",
      "ptName": "bairro de Hirao",
      "thName": "เมืองฮิราโอะ",
      "viName": "thị trấn Hirao",
      "inName": "kota Hirao",
      "tlName": "bayan ng Hirao",
      "moName": "Хирао жижиг хот",
      "buName": "ဟီရာအို မြို့နယ်",
      "khName": "ទីប្រជុំជន ហ៊ីរ៉ៅ",
      "neName": "हिराओ नगर"
    }
  },
  "3550200": {
    "office": {
      "code": "350000",
      "name": "山口県",
      "enName": "Yamaguchi",
      "officeName": "下関地方気象台",
      "chName": "山口县",
      "zhName": "山口縣",
      "koName": "야마구치현",
      "esName": "Prefectura de Yamaguchi",
      "ptName": "Província de Yamaguchi",
      "thName": "จังหวัดยามางุจิ",
      "viName": "Tỉnh Yamaguchi",
      "inName": "Prefektur Yamaguchi",
      "tlName": "Yamaguchi Prefecture",
      "moName": "Ямагүчи аймаг",
      "buName": "ယာမဂုကျိ ပြည်နယ်",
      "khName": "ខេត្ដ យ៉ាម៉ាគុជី",
      "neName": "यामागुची जिल्ला"
    },
    "class10": {
      "code": "350040",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "山口县北部",
      "zhName": "山口縣北部",
      "koName": "야마구치 현 북부",
      "esName": "Norte de Prefectura de Yamaguchi",
      "ptName": "Norte da Província de Yamaguchi",
      "thName": "จังหวัดยามางุจิตอนเหนือ",
      "viName": "Miền Bắc tỉnh Yamaguchi",
      "inName": "Bagian Utara Prefektur Yamaguchi",
      "tlName": "Hilagang bahagi ng Yamaguchi Prefecture",
      "moName": "Хойд Ямагүчи аймаг",
      "buName": "ယမဂုချိစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដយ៉ាម៉ាហ្គឹឈិ",
      "neName": "यामागुची जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "350041",
      "name": "萩・美祢",
      "enName": "Hagi Mine"
    },
    "class20": {
      "code": "3550200",
      "name": "阿武町",
      "enName": "Abu Town",
      "kana": "あぶちょう",
      "chName": "阿武町",
      "zhName": "阿武町",
      "koName": "아부 정",
      "esName": "Pueblo de Abu",
      "ptName": "bairro de Abu",
      "thName": "เมืองอาบุ",
      "viName": "thị trấn Abu",
      "inName": "kota Abu",
      "tlName": "bayan ng Abu",
      "moName": "Aбү жижиг хот",
      "buName": "အာဗု မြို့နယ်",
      "khName": "ទីប្រជុំជន អាប៊ូ",
      "neName": "आबु नगर"
    }
  },
  "3620100": {
    "office": {
      "code": "360000",
      "name": "徳島県",
      "enName": "Tokushima",
      "officeName": "徳島地方気象台",
      "chName": "德岛县",
      "zhName": "德島縣",
      "koName": "도쿠시마현",
      "esName": "Prefectura de Tokushima",
      "ptName": "Província de Tokushima",
      "thName": "จังหวัดโทะคุชิมะ",
      "viName": "Tỉnh Tokushima",
      "inName": "Prefektur Tokushima",
      "tlName": "Tokushima Prefecture",
      "moName": "Токүшима аймаг",
      "buName": "တိုကုရှိမ ပြည်နယ်",
      "khName": "ខេត្ដ តូគូស៊ីម៉ា",
      "neName": "तोकुसिमा जिल्ला"
    },
    "class10": {
      "code": "360010",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "德岛县北部",
      "zhName": "徳島縣北部",
      "koName": "도쿠시마 현 북부",
      "esName": "Norte de Prefectura de Tokushima",
      "ptName": "Norte da Província de Tokushima",
      "thName": "จังหวัดโทกุชิมะตอนเหนือ",
      "viName": "Miền Bắc tỉnh Tokushima",
      "inName": "Bagian Utara Prefektur Tokushima",
      "tlName": "Hilagang bahagi ng Tokushima Prefecture",
      "moName": "Хойд Токүшима аймаг",
      "buName": "တိုခုရှိမစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដតុកឹស៊ីម៉ា",
      "neName": "तोकुसिमा जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "360011",
      "name": "徳島・鳴門",
      "enName": "Tokushima Naruto"
    },
    "class20": {
      "code": "3620100",
      "name": "徳島市",
      "enName": "Tokushima City",
      "kana": "とくしまし",
      "chName": "德岛市",
      "zhName": "德島市",
      "koName": "도쿠시마 시",
      "esName": "Ciudad de Tokushima",
      "ptName": "cidade de Tokushima",
      "thName": "เมืองโทคุชิมะ",
      "viName": "thành phố Tokushima",
      "inName": "kota Tokushima",
      "tlName": "siyudad ng Tokushima",
      "moName": "Токүшимa хот",
      "buName": "တိုကုရှိမ မြို့",
      "khName": "ទីក្រុង តូគូស៊ីម៉ា",
      "neName": "तोकुशिमा सहर"
    }
  },
  "3620200": {
    "office": {
      "code": "360000",
      "name": "徳島県",
      "enName": "Tokushima",
      "officeName": "徳島地方気象台",
      "chName": "德岛县",
      "zhName": "德島縣",
      "koName": "도쿠시마현",
      "esName": "Prefectura de Tokushima",
      "ptName": "Província de Tokushima",
      "thName": "จังหวัดโทะคุชิมะ",
      "viName": "Tỉnh Tokushima",
      "inName": "Prefektur Tokushima",
      "tlName": "Tokushima Prefecture",
      "moName": "Токүшима аймаг",
      "buName": "တိုကုရှိမ ပြည်နယ်",
      "khName": "ខេត្ដ តូគូស៊ីម៉ា",
      "neName": "तोकुसिमा जिल्ला"
    },
    "class10": {
      "code": "360010",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "德岛县北部",
      "zhName": "徳島縣北部",
      "koName": "도쿠시마 현 북부",
      "esName": "Norte de Prefectura de Tokushima",
      "ptName": "Norte da Província de Tokushima",
      "thName": "จังหวัดโทกุชิมะตอนเหนือ",
      "viName": "Miền Bắc tỉnh Tokushima",
      "inName": "Bagian Utara Prefektur Tokushima",
      "tlName": "Hilagang bahagi ng Tokushima Prefecture",
      "moName": "Хойд Токүшима аймаг",
      "buName": "တိုခုရှိမစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដតុកឹស៊ីម៉ា",
      "neName": "तोकुसिमा जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "360011",
      "name": "徳島・鳴門",
      "enName": "Tokushima Naruto"
    },
    "class20": {
      "code": "3620200",
      "name": "鳴門市",
      "enName": "Naruto City",
      "kana": "なるとし",
      "chName": "鸣门市",
      "zhName": "鳴門市",
      "koName": "나루토 시",
      "esName": "Ciudad de Naruto",
      "ptName": "cidade de Naruto",
      "thName": "เมืองนารุโตะ",
      "viName": "thành phố Naruto",
      "inName": "kota Naruto",
      "tlName": "siyudad ng Naruto",
      "moName": "Нaрүто хот",
      "buName": "နာရူတို မြို့",
      "khName": "ទីក្រុង ណារូតូ",
      "neName": "नारुतो सहर"
    }
  },
  "3620300": {
    "office": {
      "code": "360000",
      "name": "徳島県",
      "enName": "Tokushima",
      "officeName": "徳島地方気象台",
      "chName": "德岛县",
      "zhName": "德島縣",
      "koName": "도쿠시마현",
      "esName": "Prefectura de Tokushima",
      "ptName": "Província de Tokushima",
      "thName": "จังหวัดโทะคุชิมะ",
      "viName": "Tỉnh Tokushima",
      "inName": "Prefektur Tokushima",
      "tlName": "Tokushima Prefecture",
      "moName": "Токүшима аймаг",
      "buName": "တိုကုရှိမ ပြည်နယ်",
      "khName": "ខេត្ដ តូគូស៊ីម៉ា",
      "neName": "तोकुसिमा जिल्ला"
    },
    "class10": {
      "code": "360010",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "德岛县北部",
      "zhName": "徳島縣北部",
      "koName": "도쿠시마 현 북부",
      "esName": "Norte de Prefectura de Tokushima",
      "ptName": "Norte da Província de Tokushima",
      "thName": "จังหวัดโทกุชิมะตอนเหนือ",
      "viName": "Miền Bắc tỉnh Tokushima",
      "inName": "Bagian Utara Prefektur Tokushima",
      "tlName": "Hilagang bahagi ng Tokushima Prefecture",
      "moName": "Хойд Токүшима аймаг",
      "buName": "တိုခုရှိမစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដតុកឹស៊ីម៉ា",
      "neName": "तोकुसिमा जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "360011",
      "name": "徳島・鳴門",
      "enName": "Tokushima Naruto"
    },
    "class20": {
      "code": "3620300",
      "name": "小松島市",
      "enName": "Komatsushima City",
      "kana": "こまつしまし",
      "chName": "小松岛市",
      "zhName": "小松島市",
      "koName": "고마쓰시마 시",
      "esName": "Ciudad de Komatsushima",
      "ptName": "cidade de Komatsushima",
      "thName": "เมืองโคมัทสึชิมะ",
      "viName": "thành phố Komatsushima",
      "inName": "kota Komatsushima",
      "tlName": "siyudad ng Komatsushima",
      "moName": "Комацүшима хот",
      "buName": "ကိုမာဆုရှိမ မြို့",
      "khName": "ទីក្រុង កូម៉ាតស៊ូស៊ីម៉ា",
      "neName": "कोमात्सुशिमा सहर"
    }
  },
  "3620400": {
    "office": {
      "code": "360000",
      "name": "徳島県",
      "enName": "Tokushima",
      "officeName": "徳島地方気象台",
      "chName": "德岛县",
      "zhName": "德島縣",
      "koName": "도쿠시마현",
      "esName": "Prefectura de Tokushima",
      "ptName": "Província de Tokushima",
      "thName": "จังหวัดโทะคุชิมะ",
      "viName": "Tỉnh Tokushima",
      "inName": "Prefektur Tokushima",
      "tlName": "Tokushima Prefecture",
      "moName": "Токүшима аймаг",
      "buName": "တိုကုရှိမ ပြည်နယ်",
      "khName": "ខេត្ដ តូគូស៊ីម៉ា",
      "neName": "तोकुसिमा जिल्ला"
    },
    "class10": {
      "code": "360020",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "德岛县南部",
      "zhName": "徳島縣南部",
      "koName": "도쿠시마 현 남부",
      "esName": "Sur de Prefectura de Tokushima",
      "ptName": "Sul da Província de Tokushima",
      "thName": "จังหวัดโทกุชิมะตอนใต้",
      "viName": "Miền Nam tỉnh Tokushima",
      "inName": "Bagian Selatan Prefektur Tokushima",
      "tlName": "Timog na bahagi ng Tokushima Prefecture",
      "moName": "Өмнөд Токүшима аймаг",
      "buName": "တိုခုရှိမစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដតុកឹស៊ីម៉ា",
      "neName": "तोकुसिमा जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "360021",
      "name": "阿南",
      "enName": "Anan"
    },
    "class20": {
      "code": "3620400",
      "name": "阿南市",
      "enName": "Anan City",
      "kana": "あなんし",
      "chName": "阿南市",
      "zhName": "阿南市",
      "koName": "아난 시",
      "esName": "Ciudad de Anan",
      "ptName": "cidade de Anan",
      "thName": "เมืองอานัง",
      "viName": "thành phố Anan",
      "inName": "kota Anan",
      "tlName": "siyudad ng Anan",
      "moName": "Aнaн хот",
      "buName": "အာနန် မြို့",
      "khName": "ទីក្រុង អាណាន",
      "neName": "आनान सहर"
    }
  },
  "3620500": {
    "office": {
      "code": "360000",
      "name": "徳島県",
      "enName": "Tokushima",
      "officeName": "徳島地方気象台",
      "chName": "德岛县",
      "zhName": "德島縣",
      "koName": "도쿠시마현",
      "esName": "Prefectura de Tokushima",
      "ptName": "Província de Tokushima",
      "thName": "จังหวัดโทะคุชิมะ",
      "viName": "Tỉnh Tokushima",
      "inName": "Prefektur Tokushima",
      "tlName": "Tokushima Prefecture",
      "moName": "Токүшима аймаг",
      "buName": "တိုကုရှိမ ပြည်နယ်",
      "khName": "ខេត្ដ តូគូស៊ីម៉ា",
      "neName": "तोकुसिमा जिल्ला"
    },
    "class10": {
      "code": "360010",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "德岛县北部",
      "zhName": "徳島縣北部",
      "koName": "도쿠시마 현 북부",
      "esName": "Norte de Prefectura de Tokushima",
      "ptName": "Norte da Província de Tokushima",
      "thName": "จังหวัดโทกุชิมะตอนเหนือ",
      "viName": "Miền Bắc tỉnh Tokushima",
      "inName": "Bagian Utara Prefektur Tokushima",
      "tlName": "Hilagang bahagi ng Tokushima Prefecture",
      "moName": "Хойд Токүшима аймаг",
      "buName": "တိုခုရှိမစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដតុកឹស៊ីម៉ា",
      "neName": "तोकुसिमा जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "360012",
      "name": "美馬北部・阿北",
      "enName": "Northern Mima and Ahoku"
    },
    "class20": {
      "code": "3620500",
      "name": "吉野川市",
      "enName": "Yoshinogawa City",
      "kana": "よしのがわし",
      "chName": "吉野川市",
      "zhName": "吉野川市",
      "koName": "요시노가와 시",
      "esName": "Ciudad de Yoshinogawa",
      "ptName": "cidade de Yoshinogawa",
      "thName": "เมืองโยชิโนะงาวะ",
      "viName": "thành phố Yoshinogawa",
      "inName": "kota Yoshinogawa",
      "tlName": "siyudad ng Yoshinogawa",
      "moName": "Ёошиногава хот",
      "buName": "ယိုရှိနောဂါ့ဝ မြို့",
      "khName": "ទីក្រុង យ៉ូសស៊ីណូហ្គាវ៉ា",
      "neName": "योशिनोगावा सहर"
    }
  },
  "3620600": {
    "office": {
      "code": "360000",
      "name": "徳島県",
      "enName": "Tokushima",
      "officeName": "徳島地方気象台",
      "chName": "德岛县",
      "zhName": "德島縣",
      "koName": "도쿠시마현",
      "esName": "Prefectura de Tokushima",
      "ptName": "Província de Tokushima",
      "thName": "จังหวัดโทะคุชิมะ",
      "viName": "Tỉnh Tokushima",
      "inName": "Prefektur Tokushima",
      "tlName": "Tokushima Prefecture",
      "moName": "Токүшима аймаг",
      "buName": "တိုကုရှိမ ပြည်နယ်",
      "khName": "ខេត្ដ តូគូស៊ីម៉ា",
      "neName": "तोकुसिमा जिल्ला"
    },
    "class10": {
      "code": "360010",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "德岛县北部",
      "zhName": "徳島縣北部",
      "koName": "도쿠시마 현 북부",
      "esName": "Norte de Prefectura de Tokushima",
      "ptName": "Norte da Província de Tokushima",
      "thName": "จังหวัดโทกุชิมะตอนเหนือ",
      "viName": "Miền Bắc tỉnh Tokushima",
      "inName": "Bagian Utara Prefektur Tokushima",
      "tlName": "Hilagang bahagi ng Tokushima Prefecture",
      "moName": "Хойд Токүшима аймаг",
      "buName": "တိုခုရှိမစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដតុកឹស៊ីម៉ា",
      "neName": "तोकुसिमा जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "360012",
      "name": "美馬北部・阿北",
      "enName": "Northern Mima and Ahoku"
    },
    "class20": {
      "code": "3620600",
      "name": "阿波市",
      "enName": "Awa City",
      "kana": "あわし",
      "chName": "阿波市",
      "zhName": "阿波市",
      "koName": "아와 시",
      "esName": "Ciudad de Awa",
      "ptName": "cidade de Awa",
      "thName": "เมืองอาวะ",
      "viName": "thành phố Awa",
      "inName": "kota Awa",
      "tlName": "siyudad ng Awa",
      "moName": "Ава хот",
      "buName": "အာဝါ့ မြို့",
      "khName": "ទីក្រុង អាវ៉ា",
      "neName": "आवा सहर"
    }
  },
  "3620701": {
    "office": {
      "code": "360000",
      "name": "徳島県",
      "enName": "Tokushima",
      "officeName": "徳島地方気象台",
      "chName": "德岛县",
      "zhName": "德島縣",
      "koName": "도쿠시마현",
      "esName": "Prefectura de Tokushima",
      "ptName": "Província de Tokushima",
      "thName": "จังหวัดโทะคุชิมะ",
      "viName": "Tỉnh Tokushima",
      "inName": "Prefektur Tokushima",
      "tlName": "Tokushima Prefecture",
      "moName": "Токүшима аймаг",
      "buName": "တိုကုရှိမ ပြည်နယ်",
      "khName": "ខេត្ដ តូគូស៊ីម៉ា",
      "neName": "तोकुसिमा जिल्ला"
    },
    "class10": {
      "code": "360010",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "德岛县北部",
      "zhName": "徳島縣北部",
      "koName": "도쿠시마 현 북부",
      "esName": "Norte de Prefectura de Tokushima",
      "ptName": "Norte da Província de Tokushima",
      "thName": "จังหวัดโทกุชิมะตอนเหนือ",
      "viName": "Miền Bắc tỉnh Tokushima",
      "inName": "Bagian Utara Prefektur Tokushima",
      "tlName": "Hilagang bahagi ng Tokushima Prefecture",
      "moName": "Хойд Токүшима аймаг",
      "buName": "တိုခုရှိမစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដតុកឹស៊ីម៉ា",
      "neName": "तोकुसिमा जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "360012",
      "name": "美馬北部・阿北",
      "enName": "Northern Mima and Ahoku"
    },
    "class20": {
      "code": "3620701",
      "name": "美馬市脇・美馬・穴吹",
      "enName": "Waki Mima Anabuki, Mima City",
      "kana": "みましわき・みま・あなぶき",
      "chName": "美马市脇・美马・穴吹",
      "zhName": "美马市脇・美马・穴吹",
      "koName": "미마시 와키·미마·아나부키",
      "esName": "Waki Mima Anabuki, Ciudad de Mima",
      "ptName": "Waki Mima Anabuki, Cidade de Mima",
      "thName": "วากิ มิมะ อานาบุกิ, เมืองมิมะ",
      "viName": "Waki Mima Anabuki, Thành phố Mima",
      "inName": "Waki Mima Anabuki, Kota Mima",
      "tlName": "Waki Mima Anabuki, Lungsod ng Mima",
      "moName": "Waki Mima Anabuki, Cidade de Mima",
      "buName": "မီမာမြို့ဝက်နှင့်မီမာ၊ အနာဘူးကီ",
      "khName": "ខេត្តមីម៉ា",
      "neName": "मिमा शहर वाकि・मिमा・अनाबुकी"
    }
  },
  "3620702": {
    "office": {
      "code": "360000",
      "name": "徳島県",
      "enName": "Tokushima",
      "officeName": "徳島地方気象台",
      "chName": "德岛县",
      "zhName": "德島縣",
      "koName": "도쿠시마현",
      "esName": "Prefectura de Tokushima",
      "ptName": "Província de Tokushima",
      "thName": "จังหวัดโทะคุชิมะ",
      "viName": "Tỉnh Tokushima",
      "inName": "Prefektur Tokushima",
      "tlName": "Tokushima Prefecture",
      "moName": "Токүшима аймаг",
      "buName": "တိုကုရှိမ ပြည်နယ်",
      "khName": "ខេត្ដ តូគូស៊ីម៉ា",
      "neName": "तोकुसिमा जिल्ला"
    },
    "class10": {
      "code": "360010",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "德岛县北部",
      "zhName": "徳島縣北部",
      "koName": "도쿠시마 현 북부",
      "esName": "Norte de Prefectura de Tokushima",
      "ptName": "Norte da Província de Tokushima",
      "thName": "จังหวัดโทกุชิมะตอนเหนือ",
      "viName": "Miền Bắc tỉnh Tokushima",
      "inName": "Bagian Utara Prefektur Tokushima",
      "tlName": "Hilagang bahagi ng Tokushima Prefecture",
      "moName": "Хойд Токүшима аймаг",
      "buName": "တိုခုရှိမစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដតុកឹស៊ីម៉ា",
      "neName": "तोकुसिमा जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "360013",
      "name": "美馬南部・神山",
      "enName": "Southern Mima and Kamiyama"
    },
    "class20": {
      "code": "3620702",
      "name": "美馬市木屋平",
      "enName": "Koyadaira, Mima City",
      "kana": "みましこやだいら",
      "chName": "美马市木屋平",
      "zhName": "美马市木屋平",
      "koName": "미마시 코야다이라",
      "esName": "Koyadaira, Ciudad de Mima",
      "ptName": "Koyadaira, Cidade de Mima",
      "thName": "โคยะดาอิระ, เมืองมิมะ",
      "viName": "Koyadaira, Thành phố Mima",
      "inName": "Koyadaira, Kota Mima",
      "tlName": "Koyadaira, Lungsod ng Mima",
      "moName": "Koyadaira, Cidade de Mima",
      "buName": "မီမာမြို့ကိုယာဒိုင်ရာ",
      "khName": "ខេត្តមីម៉ា",
      "neName": "कोयाडैरा, मिमा सिटी"
    }
  },
  "3620800": {
    "office": {
      "code": "360000",
      "name": "徳島県",
      "enName": "Tokushima",
      "officeName": "徳島地方気象台",
      "chName": "德岛县",
      "zhName": "德島縣",
      "koName": "도쿠시마현",
      "esName": "Prefectura de Tokushima",
      "ptName": "Província de Tokushima",
      "thName": "จังหวัดโทะคุชิมะ",
      "viName": "Tỉnh Tokushima",
      "inName": "Prefektur Tokushima",
      "tlName": "Tokushima Prefecture",
      "moName": "Токүшима аймаг",
      "buName": "တိုကုရှိမ ပြည်နယ်",
      "khName": "ខេត្ដ តូគូស៊ីម៉ា",
      "neName": "तोकुसिमा जिल्ला"
    },
    "class10": {
      "code": "360010",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "德岛县北部",
      "zhName": "徳島縣北部",
      "koName": "도쿠시마 현 북부",
      "esName": "Norte de Prefectura de Tokushima",
      "ptName": "Norte da Província de Tokushima",
      "thName": "จังหวัดโทกุชิมะตอนเหนือ",
      "viName": "Miền Bắc tỉnh Tokushima",
      "inName": "Bagian Utara Prefektur Tokushima",
      "tlName": "Hilagang bahagi ng Tokushima Prefecture",
      "moName": "Хойд Токүшима аймаг",
      "buName": "တိုခုရှိမစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដតុកឹស៊ីម៉ា",
      "neName": "तोकुसिमा जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "360014",
      "name": "三好",
      "enName": "Miyoshi"
    },
    "class20": {
      "code": "3620800",
      "name": "三好市",
      "enName": "Miyoshi City",
      "kana": "みよしし",
      "chName": "德岛三好市",
      "zhName": "德島三好市",
      "koName": "도쿠시마 미요시 시",
      "esName": "Ciudad de Miyoshi, Tokushima",
      "ptName": "Tokushima, cidade de Miyoshi",
      "thName": "เมืองมิโยชิ โทคุชิมะ",
      "viName": "Thành phố Miyoshi, Tokushima",
      "inName": "Kota Miyoshi, Tokushima",
      "tlName": "siyudad ng Miyoshi, Tokushima",
      "moName": "Токүшима Миёси хот",
      "buName": "တိုခုရှိမမိယိုရှိမြို့",
      "khName": "ទីក្រុងមីយ៉ូស៊ី តុកឹស៊ីម៉ា",
      "neName": "तोकुसिमा मियोसी सहर"
    }
  },
  "3630100": {
    "office": {
      "code": "360000",
      "name": "徳島県",
      "enName": "Tokushima",
      "officeName": "徳島地方気象台",
      "chName": "德岛县",
      "zhName": "德島縣",
      "koName": "도쿠시마현",
      "esName": "Prefectura de Tokushima",
      "ptName": "Província de Tokushima",
      "thName": "จังหวัดโทะคุชิมะ",
      "viName": "Tỉnh Tokushima",
      "inName": "Prefektur Tokushima",
      "tlName": "Tokushima Prefecture",
      "moName": "Токүшима аймаг",
      "buName": "တိုကုရှိမ ပြည်နယ်",
      "khName": "ខេត្ដ តូគូស៊ីម៉ា",
      "neName": "तोकुसिमा जिल्ला"
    },
    "class10": {
      "code": "360020",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "德岛县南部",
      "zhName": "徳島縣南部",
      "koName": "도쿠시마 현 남부",
      "esName": "Sur de Prefectura de Tokushima",
      "ptName": "Sul da Província de Tokushima",
      "thName": "จังหวัดโทกุชิมะตอนใต้",
      "viName": "Miền Nam tỉnh Tokushima",
      "inName": "Bagian Selatan Prefektur Tokushima",
      "tlName": "Timog na bahagi ng Tokushima Prefecture",
      "moName": "Өмнөд Токүшима аймаг",
      "buName": "တိုခုရှိမစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដតុកឹស៊ីម៉ា",
      "neName": "तोकुसिमा जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "360022",
      "name": "那賀・勝浦",
      "enName": "Naka Katsuura"
    },
    "class20": {
      "code": "3630100",
      "name": "勝浦町",
      "enName": "Katsuura Town",
      "kana": "かつうらちょう",
      "chName": "胜浦町",
      "zhName": "勝浦町",
      "koName": "가쓰우라 정",
      "esName": "Pueblo de Katsuura",
      "ptName": "bairro de Katsuura",
      "thName": "เมืองคัทสึอุระ",
      "viName": "thị trấn Katsuura",
      "inName": "kota Katsuura",
      "tlName": "bayan ng Katsuura",
      "moName": "Кацүүра жижиг хот",
      "buName": "ခါဆူးရာ့ မြို့နယ်",
      "khName": "ទីប្រជុំជន កាតស៊ូអ៊ូរ៉ា",
      "neName": "कात्सुरा नगर"
    }
  },
  "3630200": {
    "office": {
      "code": "360000",
      "name": "徳島県",
      "enName": "Tokushima",
      "officeName": "徳島地方気象台",
      "chName": "德岛县",
      "zhName": "德島縣",
      "koName": "도쿠시마현",
      "esName": "Prefectura de Tokushima",
      "ptName": "Província de Tokushima",
      "thName": "จังหวัดโทะคุชิมะ",
      "viName": "Tỉnh Tokushima",
      "inName": "Prefektur Tokushima",
      "tlName": "Tokushima Prefecture",
      "moName": "Токүшима аймаг",
      "buName": "တိုကုရှိမ ပြည်နယ်",
      "khName": "ខេត្ដ តូគូស៊ីម៉ា",
      "neName": "तोकुसिमा जिल्ला"
    },
    "class10": {
      "code": "360020",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "德岛县南部",
      "zhName": "徳島縣南部",
      "koName": "도쿠시마 현 남부",
      "esName": "Sur de Prefectura de Tokushima",
      "ptName": "Sul da Província de Tokushima",
      "thName": "จังหวัดโทกุชิมะตอนใต้",
      "viName": "Miền Nam tỉnh Tokushima",
      "inName": "Bagian Selatan Prefektur Tokushima",
      "tlName": "Timog na bahagi ng Tokushima Prefecture",
      "moName": "Өмнөд Токүшима аймаг",
      "buName": "တိုခုရှိမစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដតុកឹស៊ីម៉ា",
      "neName": "तोकुसिमा जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "360022",
      "name": "那賀・勝浦",
      "enName": "Naka Katsuura"
    },
    "class20": {
      "code": "3630200",
      "name": "上勝町",
      "enName": "Kamikatsu Town",
      "kana": "かみかつちょう",
      "chName": "上胜町",
      "zhName": "上勝町",
      "koName": "가미카쓰 정",
      "esName": "Pueblo de Kamikatsu",
      "ptName": "bairro de Kamikatsu",
      "thName": "เมืองคามิคัตสึ",
      "viName": "thị trấn Kamikatsu",
      "inName": "kota Kamikatsu",
      "tlName": "bayan ng Kamikatsu",
      "moName": "Камикацү жижиг хот",
      "buName": "ခါမိကာ့ဆု မြို့နယ်",
      "khName": "ទីប្រជុំជន កាមិកាតស៊ូ",
      "neName": "कामिकात्सु नगर"
    }
  },
  "3632100": {
    "office": {
      "code": "360000",
      "name": "徳島県",
      "enName": "Tokushima",
      "officeName": "徳島地方気象台",
      "chName": "德岛县",
      "zhName": "德島縣",
      "koName": "도쿠시마현",
      "esName": "Prefectura de Tokushima",
      "ptName": "Província de Tokushima",
      "thName": "จังหวัดโทะคุชิมะ",
      "viName": "Tỉnh Tokushima",
      "inName": "Prefektur Tokushima",
      "tlName": "Tokushima Prefecture",
      "moName": "Токүшима аймаг",
      "buName": "တိုကုရှိမ ပြည်နယ်",
      "khName": "ខេត្ដ តូគូស៊ីម៉ា",
      "neName": "तोकुसिमा जिल्ला"
    },
    "class10": {
      "code": "360010",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "德岛县北部",
      "zhName": "徳島縣北部",
      "koName": "도쿠시마 현 북부",
      "esName": "Norte de Prefectura de Tokushima",
      "ptName": "Norte da Província de Tokushima",
      "thName": "จังหวัดโทกุชิมะตอนเหนือ",
      "viName": "Miền Bắc tỉnh Tokushima",
      "inName": "Bagian Utara Prefektur Tokushima",
      "tlName": "Hilagang bahagi ng Tokushima Prefecture",
      "moName": "Хойд Токүшима аймаг",
      "buName": "တိုခုရှိမစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដតុកឹស៊ីម៉ា",
      "neName": "तोकुसिमा जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "360013",
      "name": "美馬南部・神山",
      "enName": "Southern Mima and Kamiyama"
    },
    "class20": {
      "code": "3632100",
      "name": "佐那河内村",
      "enName": "Sanagochi Village",
      "kana": "さなごうちそん",
      "chName": "佐那河内村",
      "zhName": "佐那河內村",
      "koName": "사나고치 촌",
      "esName": "Aldea de Sanagouchi",
      "ptName": "povoado de Sanagochi",
      "thName": "หมู่บ้านซาโนโงจิ",
      "viName": "làng Sanagochi",
      "inName": "desa Sanagochi",
      "tlName": "nayon ng Sanagochi",
      "moName": "Сaнaгочи тосгон",
      "buName": "ဆာနာဂေါ့ကျိ ကျေးရွာ",
      "khName": "ភូមិ សាណាហ្គូជី",
      "neName": "सानागोची गाउँ"
    }
  },
  "3634100": {
    "office": {
      "code": "360000",
      "name": "徳島県",
      "enName": "Tokushima",
      "officeName": "徳島地方気象台",
      "chName": "德岛县",
      "zhName": "德島縣",
      "koName": "도쿠시마현",
      "esName": "Prefectura de Tokushima",
      "ptName": "Província de Tokushima",
      "thName": "จังหวัดโทะคุชิมะ",
      "viName": "Tỉnh Tokushima",
      "inName": "Prefektur Tokushima",
      "tlName": "Tokushima Prefecture",
      "moName": "Токүшима аймаг",
      "buName": "တိုကုရှိမ ပြည်နယ်",
      "khName": "ខេត្ដ តូគូស៊ីម៉ា",
      "neName": "तोकुसिमा जिल्ला"
    },
    "class10": {
      "code": "360010",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "德岛县北部",
      "zhName": "徳島縣北部",
      "koName": "도쿠시마 현 북부",
      "esName": "Norte de Prefectura de Tokushima",
      "ptName": "Norte da Província de Tokushima",
      "thName": "จังหวัดโทกุชิมะตอนเหนือ",
      "viName": "Miền Bắc tỉnh Tokushima",
      "inName": "Bagian Utara Prefektur Tokushima",
      "tlName": "Hilagang bahagi ng Tokushima Prefecture",
      "moName": "Хойд Токүшима аймаг",
      "buName": "တိုခုရှိမစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដតុកឹស៊ីម៉ា",
      "neName": "तोकुसिमा जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "360012",
      "name": "美馬北部・阿北",
      "enName": "Northern Mima and Ahoku"
    },
    "class20": {
      "code": "3634100",
      "name": "石井町",
      "enName": "Ishii Town",
      "kana": "いしいちょう",
      "chName": "石井町",
      "zhName": "石井町",
      "koName": "이시이 정",
      "esName": "Pueblo de Ishii",
      "ptName": "bairro de Ishii",
      "thName": "เมืองอิชิอิ",
      "viName": "thị trấn Ishii",
      "inName": "kota Ishii",
      "tlName": "bayan ng Ishii",
      "moName": "Иший жижиг хот",
      "buName": "အီရှိ မြို့နယ်",
      "khName": "ទីប្រជុំជន អ៊ីស៊ី",
      "neName": "इशी नगर"
    }
  },
  "3634200": {
    "office": {
      "code": "360000",
      "name": "徳島県",
      "enName": "Tokushima",
      "officeName": "徳島地方気象台",
      "chName": "德岛县",
      "zhName": "德島縣",
      "koName": "도쿠시마현",
      "esName": "Prefectura de Tokushima",
      "ptName": "Província de Tokushima",
      "thName": "จังหวัดโทะคุชิมะ",
      "viName": "Tỉnh Tokushima",
      "inName": "Prefektur Tokushima",
      "tlName": "Tokushima Prefecture",
      "moName": "Токүшима аймаг",
      "buName": "တိုကုရှိမ ပြည်နယ်",
      "khName": "ខេត្ដ តូគូស៊ីម៉ា",
      "neName": "तोकुसिमा जिल्ला"
    },
    "class10": {
      "code": "360010",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "德岛县北部",
      "zhName": "徳島縣北部",
      "koName": "도쿠시마 현 북부",
      "esName": "Norte de Prefectura de Tokushima",
      "ptName": "Norte da Província de Tokushima",
      "thName": "จังหวัดโทกุชิมะตอนเหนือ",
      "viName": "Miền Bắc tỉnh Tokushima",
      "inName": "Bagian Utara Prefektur Tokushima",
      "tlName": "Hilagang bahagi ng Tokushima Prefecture",
      "moName": "Хойд Токүшима аймаг",
      "buName": "တိုခုရှိမစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដតុកឹស៊ីម៉ា",
      "neName": "तोकुसिमा जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "360013",
      "name": "美馬南部・神山",
      "enName": "Southern Mima and Kamiyama"
    },
    "class20": {
      "code": "3634200",
      "name": "神山町",
      "enName": "Kamiyama Town",
      "kana": "かみやまちょう",
      "chName": "神山町",
      "zhName": "神山町",
      "koName": "가미야마 정",
      "esName": "Pueblo de Kamiyama",
      "ptName": "bairro de Kamiyama",
      "thName": "เมืองคามิยามะ",
      "viName": "thị trấn Kamiyama",
      "inName": "kota Kamiyama",
      "tlName": "bayan ng Kamiyama",
      "moName": "Камиямa жижиг хот",
      "buName": "ခါမိယာ့မ မြို့နယ်",
      "khName": "ទីប្រជុំជន កាមិយ៉ាម៉ា",
      "neName": "कामियामा नगर"
    }
  },
  "3636800": {
    "office": {
      "code": "360000",
      "name": "徳島県",
      "enName": "Tokushima",
      "officeName": "徳島地方気象台",
      "chName": "德岛县",
      "zhName": "德島縣",
      "koName": "도쿠시마현",
      "esName": "Prefectura de Tokushima",
      "ptName": "Província de Tokushima",
      "thName": "จังหวัดโทะคุชิมะ",
      "viName": "Tỉnh Tokushima",
      "inName": "Prefektur Tokushima",
      "tlName": "Tokushima Prefecture",
      "moName": "Токүшима аймаг",
      "buName": "တိုကုရှိမ ပြည်နယ်",
      "khName": "ខេត្ដ តូគូស៊ីម៉ា",
      "neName": "तोकुसिमा जिल्ला"
    },
    "class10": {
      "code": "360020",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "德岛县南部",
      "zhName": "徳島縣南部",
      "koName": "도쿠시마 현 남부",
      "esName": "Sur de Prefectura de Tokushima",
      "ptName": "Sul da Província de Tokushima",
      "thName": "จังหวัดโทกุชิมะตอนใต้",
      "viName": "Miền Nam tỉnh Tokushima",
      "inName": "Bagian Selatan Prefektur Tokushima",
      "tlName": "Timog na bahagi ng Tokushima Prefecture",
      "moName": "Өмнөд Токүшима аймаг",
      "buName": "တိုခုရှိမစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដតុកឹស៊ីម៉ា",
      "neName": "तोकुसिमा जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "360022",
      "name": "那賀・勝浦",
      "enName": "Naka Katsuura"
    },
    "class20": {
      "code": "3636800",
      "name": "那賀町",
      "enName": "Naka Town",
      "kana": "なかちょう",
      "chName": "那贺町",
      "zhName": "那賀町",
      "koName": "나카 정",
      "esName": "Pueblo de Naka",
      "ptName": "bairro de Naka",
      "thName": "เมืองนากะ",
      "viName": "thị trấn Naka",
      "inName": "kota Naka",
      "tlName": "bayan ng Naka",
      "moName": "Нaка жижиг хот",
      "buName": "နာက မြို့နယ်",
      "khName": "ទីប្រជុំជន ណាកា",
      "neName": "नाका नगर"
    }
  },
  "3638300": {
    "office": {
      "code": "360000",
      "name": "徳島県",
      "enName": "Tokushima",
      "officeName": "徳島地方気象台",
      "chName": "德岛县",
      "zhName": "德島縣",
      "koName": "도쿠시마현",
      "esName": "Prefectura de Tokushima",
      "ptName": "Província de Tokushima",
      "thName": "จังหวัดโทะคุชิมะ",
      "viName": "Tỉnh Tokushima",
      "inName": "Prefektur Tokushima",
      "tlName": "Tokushima Prefecture",
      "moName": "Токүшима аймаг",
      "buName": "တိုကုရှိမ ပြည်နယ်",
      "khName": "ខេត្ដ តូគូស៊ីម៉ា",
      "neName": "तोकुसिमा जिल्ला"
    },
    "class10": {
      "code": "360020",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "德岛县南部",
      "zhName": "徳島縣南部",
      "koName": "도쿠시마 현 남부",
      "esName": "Sur de Prefectura de Tokushima",
      "ptName": "Sul da Província de Tokushima",
      "thName": "จังหวัดโทกุชิมะตอนใต้",
      "viName": "Miền Nam tỉnh Tokushima",
      "inName": "Bagian Selatan Prefektur Tokushima",
      "tlName": "Timog na bahagi ng Tokushima Prefecture",
      "moName": "Өмнөд Токүшима аймаг",
      "buName": "တိုခုရှိမစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដតុកឹស៊ីម៉ា",
      "neName": "तोकुसिमा जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "360023",
      "name": "海部",
      "enName": "Kaifu"
    },
    "class20": {
      "code": "3638300",
      "name": "牟岐町",
      "enName": "Mugi Town",
      "kana": "むぎちょう",
      "chName": "牟岐町",
      "zhName": "牟岐町",
      "koName": "무기 정",
      "esName": "Pueblo de Mugi",
      "ptName": "bairro de Mugi",
      "thName": "เมืองมุงิ",
      "viName": "thị trấn Mugi",
      "inName": "kota Mugi",
      "tlName": "bayan ng Mugi",
      "moName": "Мүги жижиг хот",
      "buName": "မူဂိ မြို့နယ်",
      "khName": "ទីប្រជុំជន មូគី",
      "neName": "मुगी नगर"
    }
  },
  "3638700": {
    "office": {
      "code": "360000",
      "name": "徳島県",
      "enName": "Tokushima",
      "officeName": "徳島地方気象台",
      "chName": "德岛县",
      "zhName": "德島縣",
      "koName": "도쿠시마현",
      "esName": "Prefectura de Tokushima",
      "ptName": "Província de Tokushima",
      "thName": "จังหวัดโทะคุชิมะ",
      "viName": "Tỉnh Tokushima",
      "inName": "Prefektur Tokushima",
      "tlName": "Tokushima Prefecture",
      "moName": "Токүшима аймаг",
      "buName": "တိုကုရှိမ ပြည်နယ်",
      "khName": "ខេត្ដ តូគូស៊ីម៉ា",
      "neName": "तोकुसिमा जिल्ला"
    },
    "class10": {
      "code": "360020",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "德岛县南部",
      "zhName": "徳島縣南部",
      "koName": "도쿠시마 현 남부",
      "esName": "Sur de Prefectura de Tokushima",
      "ptName": "Sul da Província de Tokushima",
      "thName": "จังหวัดโทกุชิมะตอนใต้",
      "viName": "Miền Nam tỉnh Tokushima",
      "inName": "Bagian Selatan Prefektur Tokushima",
      "tlName": "Timog na bahagi ng Tokushima Prefecture",
      "moName": "Өмнөд Токүшима аймаг",
      "buName": "တိုခုရှိမစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដតុកឹស៊ីម៉ា",
      "neName": "तोकुसिमा जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "360023",
      "name": "海部",
      "enName": "Kaifu"
    },
    "class20": {
      "code": "3638700",
      "name": "美波町",
      "enName": "Minami Town",
      "kana": "みなみちょう",
      "chName": "美波町",
      "zhName": "美波町",
      "koName": "미나미 정",
      "esName": "Pueblo de Minami",
      "ptName": "bairro de Minami",
      "thName": "เมืองมินามิ",
      "viName": "thị trấn Minami",
      "inName": "kota Minami",
      "tlName": "bayan ng Minami",
      "moName": "Минaми жижиг хот",
      "buName": "မီနားမိ မြို့နယ်",
      "khName": "ទីប្រជុំជន មីណាមី",
      "neName": "मिनामी नगर"
    }
  },
  "3638800": {
    "office": {
      "code": "360000",
      "name": "徳島県",
      "enName": "Tokushima",
      "officeName": "徳島地方気象台",
      "chName": "德岛县",
      "zhName": "德島縣",
      "koName": "도쿠시마현",
      "esName": "Prefectura de Tokushima",
      "ptName": "Província de Tokushima",
      "thName": "จังหวัดโทะคุชิมะ",
      "viName": "Tỉnh Tokushima",
      "inName": "Prefektur Tokushima",
      "tlName": "Tokushima Prefecture",
      "moName": "Токүшима аймаг",
      "buName": "တိုကုရှိမ ပြည်နယ်",
      "khName": "ខេត្ដ តូគូស៊ីម៉ា",
      "neName": "तोकुसिमा जिल्ला"
    },
    "class10": {
      "code": "360020",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "德岛县南部",
      "zhName": "徳島縣南部",
      "koName": "도쿠시마 현 남부",
      "esName": "Sur de Prefectura de Tokushima",
      "ptName": "Sul da Província de Tokushima",
      "thName": "จังหวัดโทกุชิมะตอนใต้",
      "viName": "Miền Nam tỉnh Tokushima",
      "inName": "Bagian Selatan Prefektur Tokushima",
      "tlName": "Timog na bahagi ng Tokushima Prefecture",
      "moName": "Өмнөд Токүшима аймаг",
      "buName": "တိုခုရှိမစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដតុកឹស៊ីម៉ា",
      "neName": "तोकुसिमा जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "360023",
      "name": "海部",
      "enName": "Kaifu"
    },
    "class20": {
      "code": "3638800",
      "name": "海陽町",
      "enName": "Kaiyo Town",
      "kana": "かいようちょう",
      "chName": "海阳町",
      "zhName": "海陽町",
      "koName": "가이요 정",
      "esName": "Pueblo de Kaiyo",
      "ptName": "bairro de Kaiyo",
      "thName": "เมืองไคโย",
      "viName": "thị trấn Kaiyo",
      "inName": "kota Kaiyo",
      "tlName": "bayan ng Kaiyo",
      "moName": "Кайёо жижиг хот",
      "buName": "ခိုင်းယို မြို့နယ်",
      "khName": "ទីប្រជុំជន កៃយ៉ូ",
      "neName": "काइयो नगर"
    }
  },
  "3640100": {
    "office": {
      "code": "360000",
      "name": "徳島県",
      "enName": "Tokushima",
      "officeName": "徳島地方気象台",
      "chName": "德岛县",
      "zhName": "德島縣",
      "koName": "도쿠시마현",
      "esName": "Prefectura de Tokushima",
      "ptName": "Província de Tokushima",
      "thName": "จังหวัดโทะคุชิมะ",
      "viName": "Tỉnh Tokushima",
      "inName": "Prefektur Tokushima",
      "tlName": "Tokushima Prefecture",
      "moName": "Токүшима аймаг",
      "buName": "တိုကုရှိမ ပြည်နယ်",
      "khName": "ខេត្ដ តូគូស៊ីម៉ា",
      "neName": "तोकुसिमा जिल्ला"
    },
    "class10": {
      "code": "360010",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "德岛县北部",
      "zhName": "徳島縣北部",
      "koName": "도쿠시마 현 북부",
      "esName": "Norte de Prefectura de Tokushima",
      "ptName": "Norte da Província de Tokushima",
      "thName": "จังหวัดโทกุชิมะตอนเหนือ",
      "viName": "Miền Bắc tỉnh Tokushima",
      "inName": "Bagian Utara Prefektur Tokushima",
      "tlName": "Hilagang bahagi ng Tokushima Prefecture",
      "moName": "Хойд Токүшима аймаг",
      "buName": "တိုခုရှိမစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដតុកឹស៊ីម៉ា",
      "neName": "तोकुसिमा जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "360011",
      "name": "徳島・鳴門",
      "enName": "Tokushima Naruto"
    },
    "class20": {
      "code": "3640100",
      "name": "松茂町",
      "enName": "Matsushige Town",
      "kana": "まつしげちょう",
      "chName": "松茂町",
      "zhName": "松茂町",
      "koName": "마쓰시게 정",
      "esName": "Pueblo de Matsushige",
      "ptName": "bairro de Matsushige",
      "thName": "เมืองมัตสึชิเงะ",
      "viName": "thị trấn Matsushige",
      "inName": "kota Matsushige",
      "tlName": "bayan ng Matsushige",
      "moName": "Мaцүшигэ жижиг хот",
      "buName": "မာဆုရှိဂဲ့ မြို့နယ်",
      "khName": "ទីប្រជុំជន ម៉ាតស៊ូស៊ីជី",
      "neName": "मात्सुशिगे नगर"
    }
  },
  "3640200": {
    "office": {
      "code": "360000",
      "name": "徳島県",
      "enName": "Tokushima",
      "officeName": "徳島地方気象台",
      "chName": "德岛县",
      "zhName": "德島縣",
      "koName": "도쿠시마현",
      "esName": "Prefectura de Tokushima",
      "ptName": "Província de Tokushima",
      "thName": "จังหวัดโทะคุชิมะ",
      "viName": "Tỉnh Tokushima",
      "inName": "Prefektur Tokushima",
      "tlName": "Tokushima Prefecture",
      "moName": "Токүшима аймаг",
      "buName": "တိုကုရှိမ ပြည်နယ်",
      "khName": "ខេត្ដ តូគូស៊ីម៉ា",
      "neName": "तोकुसिमा जिल्ला"
    },
    "class10": {
      "code": "360010",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "德岛县北部",
      "zhName": "徳島縣北部",
      "koName": "도쿠시마 현 북부",
      "esName": "Norte de Prefectura de Tokushima",
      "ptName": "Norte da Província de Tokushima",
      "thName": "จังหวัดโทกุชิมะตอนเหนือ",
      "viName": "Miền Bắc tỉnh Tokushima",
      "inName": "Bagian Utara Prefektur Tokushima",
      "tlName": "Hilagang bahagi ng Tokushima Prefecture",
      "moName": "Хойд Токүшима аймаг",
      "buName": "တိုခုရှိမစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដតុកឹស៊ីម៉ា",
      "neName": "तोकुसिमा जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "360011",
      "name": "徳島・鳴門",
      "enName": "Tokushima Naruto"
    },
    "class20": {
      "code": "3640200",
      "name": "北島町",
      "enName": "Kitajima Town",
      "kana": "きたじまちょう",
      "chName": "北岛町",
      "zhName": "北島町",
      "koName": "기타지마 정",
      "esName": "Pueblo de Kitajima",
      "ptName": "bairro de Kitajima",
      "thName": "เมืองคิตะจิมะ",
      "viName": "thị trấn Kitajima",
      "inName": "kota Kitajima",
      "tlName": "bayan ng Kitajima",
      "moName": "Китажимa жижиг хот",
      "buName": "ခီတားဂျိမ မြို့နယ်",
      "khName": "ទីប្រជុំជន គីតាហ្សីម៉ា",
      "neName": "किताजिमा नगर"
    }
  },
  "3640300": {
    "office": {
      "code": "360000",
      "name": "徳島県",
      "enName": "Tokushima",
      "officeName": "徳島地方気象台",
      "chName": "德岛县",
      "zhName": "德島縣",
      "koName": "도쿠시마현",
      "esName": "Prefectura de Tokushima",
      "ptName": "Província de Tokushima",
      "thName": "จังหวัดโทะคุชิมะ",
      "viName": "Tỉnh Tokushima",
      "inName": "Prefektur Tokushima",
      "tlName": "Tokushima Prefecture",
      "moName": "Токүшима аймаг",
      "buName": "တိုကုရှိမ ပြည်နယ်",
      "khName": "ខេត្ដ តូគូស៊ីម៉ា",
      "neName": "तोकुसिमा जिल्ला"
    },
    "class10": {
      "code": "360010",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "德岛县北部",
      "zhName": "徳島縣北部",
      "koName": "도쿠시마 현 북부",
      "esName": "Norte de Prefectura de Tokushima",
      "ptName": "Norte da Província de Tokushima",
      "thName": "จังหวัดโทกุชิมะตอนเหนือ",
      "viName": "Miền Bắc tỉnh Tokushima",
      "inName": "Bagian Utara Prefektur Tokushima",
      "tlName": "Hilagang bahagi ng Tokushima Prefecture",
      "moName": "Хойд Токүшима аймаг",
      "buName": "တိုခုရှိမစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដតុកឹស៊ីម៉ា",
      "neName": "तोकुसिमा जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "360011",
      "name": "徳島・鳴門",
      "enName": "Tokushima Naruto"
    },
    "class20": {
      "code": "3640300",
      "name": "藍住町",
      "enName": "Aizumi Town",
      "kana": "あいずみちょう",
      "chName": "蓝住町",
      "zhName": "藍住町",
      "koName": "아이즈미 정",
      "esName": "Pueblo de Aizumi",
      "ptName": "bairro de Aizumi",
      "thName": "เมืองไอสึมิ",
      "viName": "thị trấn Aizumi",
      "inName": "kota Aizumi",
      "tlName": "bayan ng Aizumi",
      "moName": "Aйзүми жижиг хот",
      "buName": "အာယိဇုမိ မြို့နယ်",
      "khName": "ទីប្រជុំជន អាហ្សូមី",
      "neName": "आइजुमी नगर"
    }
  },
  "3640400": {
    "office": {
      "code": "360000",
      "name": "徳島県",
      "enName": "Tokushima",
      "officeName": "徳島地方気象台",
      "chName": "德岛县",
      "zhName": "德島縣",
      "koName": "도쿠시마현",
      "esName": "Prefectura de Tokushima",
      "ptName": "Província de Tokushima",
      "thName": "จังหวัดโทะคุชิมะ",
      "viName": "Tỉnh Tokushima",
      "inName": "Prefektur Tokushima",
      "tlName": "Tokushima Prefecture",
      "moName": "Токүшима аймаг",
      "buName": "တိုကုရှိမ ပြည်နယ်",
      "khName": "ខេត្ដ តូគូស៊ីម៉ា",
      "neName": "तोकुसिमा जिल्ला"
    },
    "class10": {
      "code": "360010",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "德岛县北部",
      "zhName": "徳島縣北部",
      "koName": "도쿠시마 현 북부",
      "esName": "Norte de Prefectura de Tokushima",
      "ptName": "Norte da Província de Tokushima",
      "thName": "จังหวัดโทกุชิมะตอนเหนือ",
      "viName": "Miền Bắc tỉnh Tokushima",
      "inName": "Bagian Utara Prefektur Tokushima",
      "tlName": "Hilagang bahagi ng Tokushima Prefecture",
      "moName": "Хойд Токүшима аймаг",
      "buName": "တိုခုရှိမစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដតុកឹស៊ីម៉ា",
      "neName": "तोकुसिमा जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "360011",
      "name": "徳島・鳴門",
      "enName": "Tokushima Naruto"
    },
    "class20": {
      "code": "3640400",
      "name": "板野町",
      "enName": "Itano Town",
      "kana": "いたのちょう",
      "chName": "板野町",
      "zhName": "板野町",
      "koName": "이타노 정",
      "esName": "Pueblo de Itano",
      "ptName": "bairro de Itano",
      "thName": "เมืองอิตาโนะ",
      "viName": "thị trấn Itano",
      "inName": "kota Itano",
      "tlName": "bayan ng Itano",
      "moName": "Итано жижиг хот",
      "buName": "အိတားနို မြို့နယ်",
      "khName": "ទីប្រជុំជន អាយតាណូ",
      "neName": "इतानो नगर"
    }
  },
  "3640500": {
    "office": {
      "code": "360000",
      "name": "徳島県",
      "enName": "Tokushima",
      "officeName": "徳島地方気象台",
      "chName": "德岛县",
      "zhName": "德島縣",
      "koName": "도쿠시마현",
      "esName": "Prefectura de Tokushima",
      "ptName": "Província de Tokushima",
      "thName": "จังหวัดโทะคุชิมะ",
      "viName": "Tỉnh Tokushima",
      "inName": "Prefektur Tokushima",
      "tlName": "Tokushima Prefecture",
      "moName": "Токүшима аймаг",
      "buName": "တိုကုရှိမ ပြည်နယ်",
      "khName": "ខេត្ដ តូគូស៊ីម៉ា",
      "neName": "तोकुसिमा जिल्ला"
    },
    "class10": {
      "code": "360010",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "德岛县北部",
      "zhName": "徳島縣北部",
      "koName": "도쿠시마 현 북부",
      "esName": "Norte de Prefectura de Tokushima",
      "ptName": "Norte da Província de Tokushima",
      "thName": "จังหวัดโทกุชิมะตอนเหนือ",
      "viName": "Miền Bắc tỉnh Tokushima",
      "inName": "Bagian Utara Prefektur Tokushima",
      "tlName": "Hilagang bahagi ng Tokushima Prefecture",
      "moName": "Хойд Токүшима аймаг",
      "buName": "တိုခုရှိမစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដតុកឹស៊ីម៉ា",
      "neName": "तोकुसिमा जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "360012",
      "name": "美馬北部・阿北",
      "enName": "Northern Mima and Ahoku"
    },
    "class20": {
      "code": "3640500",
      "name": "上板町",
      "enName": "Kamiita Town",
      "kana": "かみいたちょう",
      "chName": "上板町",
      "zhName": "上板町",
      "koName": "가미이타 정",
      "esName": "Pueblo de Kamiita",
      "ptName": "bairro de Kamiita",
      "thName": "เมืองคามิอิตะ",
      "viName": "thị trấn Kamiita",
      "inName": "kota Kamiita",
      "tlName": "bayan ng Kamiita",
      "moName": "Камийта жижиг хот",
      "buName": "ခါမီးတ မြို့နယ်",
      "khName": "ទីប្រជុំជន កាមីតា",
      "neName": "कामिता नगर"
    }
  },
  "3646801": {
    "office": {
      "code": "360000",
      "name": "徳島県",
      "enName": "Tokushima",
      "officeName": "徳島地方気象台",
      "chName": "德岛县",
      "zhName": "德島縣",
      "koName": "도쿠시마현",
      "esName": "Prefectura de Tokushima",
      "ptName": "Província de Tokushima",
      "thName": "จังหวัดโทะคุชิมะ",
      "viName": "Tỉnh Tokushima",
      "inName": "Prefektur Tokushima",
      "tlName": "Tokushima Prefecture",
      "moName": "Токүшима аймаг",
      "buName": "တိုကုရှိမ ပြည်နယ်",
      "khName": "ខេត្ដ តូគូស៊ីម៉ា",
      "neName": "तोकुसिमा जिल्ला"
    },
    "class10": {
      "code": "360010",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "德岛县北部",
      "zhName": "徳島縣北部",
      "koName": "도쿠시마 현 북부",
      "esName": "Norte de Prefectura de Tokushima",
      "ptName": "Norte da Província de Tokushima",
      "thName": "จังหวัดโทกุชิมะตอนเหนือ",
      "viName": "Miền Bắc tỉnh Tokushima",
      "inName": "Bagian Utara Prefektur Tokushima",
      "tlName": "Hilagang bahagi ng Tokushima Prefecture",
      "moName": "Хойд Токүшима аймаг",
      "buName": "တိုခုရှိမစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដតុកឹស៊ីម៉ា",
      "neName": "तोकुसिमा जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "360012",
      "name": "美馬北部・阿北",
      "enName": "Northern Mima and Ahoku"
    },
    "class20": {
      "code": "3646801",
      "name": "つるぎ町半田・貞光",
      "enName": "Handa Sadamitsu, Tsurugi Town",
      "kana": "つるぎちょうはんだ・さだみつ",
      "chName": "剣町半田・贞光",
      "zhName": "剣町半田・贞光",
      "koName": "츠루기 마을 한다·사다미츠",
      "esName": "Handa Sadamitsu, Pueblo de Tsurugi",
      "ptName": "Handa Sadamitsu, Cidade de Tsurugi",
      "thName": "ฮันดะ ซาดามิทสึ, เมืองซึรุงิ",
      "viName": "Handa Sadamitsu, Thị trấn Tsurugi",
      "inName": "Handa Sadamitsu, Kota Tsurugi",
      "tlName": "Handa Sadamitsu, Bayan ng Tsurugi",
      "moName": "Handa Sadamitsu, Cidade de Tsurugi",
      "buName": "ဟန်ဒါစဒမစ်တစ်၊ တစ်ဖက်ကနေရှောင်ပါ",
      "khName": "ខេត្តហានដា, ចង្កូរលាក់",
      "neName": "हांडा सादामित्सु, त्सुरुगी टाउन"
    }
  },
  "3646802": {
    "office": {
      "code": "360000",
      "name": "徳島県",
      "enName": "Tokushima",
      "officeName": "徳島地方気象台",
      "chName": "德岛县",
      "zhName": "德島縣",
      "koName": "도쿠시마현",
      "esName": "Prefectura de Tokushima",
      "ptName": "Província de Tokushima",
      "thName": "จังหวัดโทะคุชิมะ",
      "viName": "Tỉnh Tokushima",
      "inName": "Prefektur Tokushima",
      "tlName": "Tokushima Prefecture",
      "moName": "Токүшима аймаг",
      "buName": "တိုကုရှိမ ပြည်နယ်",
      "khName": "ខេត្ដ តូគូស៊ីម៉ា",
      "neName": "तोकुसिमा जिल्ला"
    },
    "class10": {
      "code": "360010",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "德岛县北部",
      "zhName": "徳島縣北部",
      "koName": "도쿠시마 현 북부",
      "esName": "Norte de Prefectura de Tokushima",
      "ptName": "Norte da Província de Tokushima",
      "thName": "จังหวัดโทกุชิมะตอนเหนือ",
      "viName": "Miền Bắc tỉnh Tokushima",
      "inName": "Bagian Utara Prefektur Tokushima",
      "tlName": "Hilagang bahagi ng Tokushima Prefecture",
      "moName": "Хойд Токүшима аймаг",
      "buName": "တိုခုရှိမစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដតុកឹស៊ីម៉ា",
      "neName": "तोकुसिमा जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "360013",
      "name": "美馬南部・神山",
      "enName": "Southern Mima and Kamiyama"
    },
    "class20": {
      "code": "3646802",
      "name": "つるぎ町一宇",
      "enName": "Ichiu, Tsurugi Town",
      "kana": "つるぎちょういちう",
      "chName": "剣町一宇",
      "zhName": "剣町一宇",
      "koName": "츠루기 마을 이치우",
      "esName": "Ichiu, Pueblo de Tsurugi",
      "ptName": "Ichiu, Cidade de Tsurugi",
      "thName": "อิจิอู, เมืองซึรุงิ",
      "viName": "Ichiu, Thị trấn Tsurugi",
      "inName": "Ichiu, Kota Tsurugi",
      "tlName": "Ichiu, Bayan ng Tsurugi",
      "moName": "Ichiu, Cidade de Tsurugi",
      "buName": "အစ်ချူး၊ တီကွမ်",
      "khName": "ខេត្តအ៊ីជីយូ",
      "neName": "इचियू, त्सुरुगी टाउन"
    }
  },
  "3648900": {
    "office": {
      "code": "360000",
      "name": "徳島県",
      "enName": "Tokushima",
      "officeName": "徳島地方気象台",
      "chName": "德岛县",
      "zhName": "德島縣",
      "koName": "도쿠시마현",
      "esName": "Prefectura de Tokushima",
      "ptName": "Província de Tokushima",
      "thName": "จังหวัดโทะคุชิมะ",
      "viName": "Tỉnh Tokushima",
      "inName": "Prefektur Tokushima",
      "tlName": "Tokushima Prefecture",
      "moName": "Токүшима аймаг",
      "buName": "တိုကုရှိမ ပြည်နယ်",
      "khName": "ខេត្ដ តូគូស៊ីម៉ា",
      "neName": "तोकुसिमा जिल्ला"
    },
    "class10": {
      "code": "360010",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "德岛县北部",
      "zhName": "徳島縣北部",
      "koName": "도쿠시마 현 북부",
      "esName": "Norte de Prefectura de Tokushima",
      "ptName": "Norte da Província de Tokushima",
      "thName": "จังหวัดโทกุชิมะตอนเหนือ",
      "viName": "Miền Bắc tỉnh Tokushima",
      "inName": "Bagian Utara Prefektur Tokushima",
      "tlName": "Hilagang bahagi ng Tokushima Prefecture",
      "moName": "Хойд Токүшима аймаг",
      "buName": "တိုခုရှိမစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដតុកឹស៊ីម៉ា",
      "neName": "तोकुसिमा जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "360014",
      "name": "三好",
      "enName": "Miyoshi"
    },
    "class20": {
      "code": "3648900",
      "name": "東みよし町",
      "enName": "Higashimiyoshi Town",
      "kana": "ひがしみよしちょう",
      "chName": "东三好町",
      "zhName": "東三好町",
      "koName": "히가시미요시 정",
      "esName": "Pueblo de Higashi-miyoshi",
      "ptName": "bairro de Higashimiyoshi",
      "thName": "เมืองฮิงาชิมิโยชิ",
      "viName": "thị trấn Higashimiyoshi",
      "inName": "kota Higashimiyoshi",
      "tlName": "bayan ng Higashimiyoshi",
      "moName": "Хигaшимиёоши жижиг хот",
      "buName": "ဟီဂါရှိမိယောရှိ မြို့နယ်",
      "khName": "ទីប្រជុំជន ហ៊ីកាស្ហ៊ីមីយ៉ូស៊ី",
      "neName": "हिगाशिमियोशी नगर"
    }
  },
  "3720100": {
    "office": {
      "code": "370000",
      "name": "香川県",
      "enName": "Kagawa",
      "officeName": "高松地方気象台",
      "chName": "香川县",
      "zhName": "香川縣",
      "koName": "카가와현",
      "esName": "Prefectura de Kagawa",
      "ptName": "Província de Kagawa",
      "thName": "จังหวัดคางาวะ",
      "viName": "Tỉnh Kagawa",
      "inName": "Prefektur Kagawa",
      "tlName": "Kagawa Prefecture",
      "moName": "Кагава аймаг",
      "buName": "ကာဂါဝါ ပြည်နယ်",
      "khName": "ខេត្ដ កាហ្កាវ៉ា",
      "neName": "खागावा जिल्ला"
    },
    "class10": {
      "code": "370000",
      "name": "香川県",
      "enName": "Kagawa Prefecture",
      "chName": "香川縣",
      "zhName": "香川县",
      "koName": "가가와현",
      "esName": "Prefectura de Kagawa",
      "ptName": "Prefeitura de Kagawa",
      "thName": "จังหวัดคางาวะ",
      "viName": "tỉnh Kagawa",
      "inName": "Prefektur Kagawa",
      "tlName": "Kagawa prefecture",
      "moName": "Кагава муж",
      "buName": "ကာဂါဝါစီရင်စု",
      "khName": "ខេត្ត Kagawa",
      "neName": "कागावा प्रान्त"
    },
    "class15": {
      "code": "370001",
      "name": "高松地域",
      "enName": "Takamatsu Area"
    },
    "class20": {
      "code": "3720100",
      "name": "高松市",
      "enName": "Takamatsu City",
      "kana": "たかまつし",
      "chName": "高松市",
      "zhName": "髙松市",
      "koName": "다카마쓰 시",
      "esName": "Ciudad de Takamatsu",
      "ptName": "cidade de Takamatsu",
      "thName": "เมืองทากามัทสึ",
      "viName": "thành phố Takamatsu",
      "inName": "kota Takamatsu",
      "tlName": "siyudad ng Takamatsu",
      "moName": "Такамацү хот",
      "buName": "တာကားမာ့ဆု မြို့",
      "khName": "ទីក្រុង តាកាម៉ាតស៊ូ",
      "neName": "ताकामात्सु सहर"
    }
  },
  "3720200": {
    "office": {
      "code": "370000",
      "name": "香川県",
      "enName": "Kagawa",
      "officeName": "高松地方気象台",
      "chName": "香川县",
      "zhName": "香川縣",
      "koName": "카가와현",
      "esName": "Prefectura de Kagawa",
      "ptName": "Província de Kagawa",
      "thName": "จังหวัดคางาวะ",
      "viName": "Tỉnh Kagawa",
      "inName": "Prefektur Kagawa",
      "tlName": "Kagawa Prefecture",
      "moName": "Кагава аймаг",
      "buName": "ကာဂါဝါ ပြည်နယ်",
      "khName": "ខេត្ដ កាហ្កាវ៉ា",
      "neName": "खागावा जिल्ला"
    },
    "class10": {
      "code": "370000",
      "name": "香川県",
      "enName": "Kagawa Prefecture",
      "chName": "香川縣",
      "zhName": "香川县",
      "koName": "가가와현",
      "esName": "Prefectura de Kagawa",
      "ptName": "Prefeitura de Kagawa",
      "thName": "จังหวัดคางาวะ",
      "viName": "tỉnh Kagawa",
      "inName": "Prefektur Kagawa",
      "tlName": "Kagawa prefecture",
      "moName": "Кагава муж",
      "buName": "ကာဂါဝါစီရင်စု",
      "khName": "ខេត្ត Kagawa",
      "neName": "कागावा प्रान्त"
    },
    "class15": {
      "code": "370004",
      "name": "中讃",
      "enName": "Chusan"
    },
    "class20": {
      "code": "3720200",
      "name": "丸亀市",
      "enName": "Marugame City",
      "kana": "まるがめし",
      "chName": "丸龟市",
      "zhName": "丸龜市",
      "koName": "마루가메 시",
      "esName": "Ciudad de Marugame",
      "ptName": "cidade de Marugame",
      "thName": "เมืองมาริงาเมะ",
      "viName": "thành phố Marugame",
      "inName": "kota Marugame",
      "tlName": "siyudad ng Marugame",
      "moName": "Мaрүгaмэ хот",
      "buName": "မာရုဂါ့မဲ့ မြို့",
      "khName": "ទីក្រុង ម៉ារូកាមី",
      "neName": "मारुगामे सहर"
    }
  },
  "3720300": {
    "office": {
      "code": "370000",
      "name": "香川県",
      "enName": "Kagawa",
      "officeName": "高松地方気象台",
      "chName": "香川县",
      "zhName": "香川縣",
      "koName": "카가와현",
      "esName": "Prefectura de Kagawa",
      "ptName": "Província de Kagawa",
      "thName": "จังหวัดคางาวะ",
      "viName": "Tỉnh Kagawa",
      "inName": "Prefektur Kagawa",
      "tlName": "Kagawa Prefecture",
      "moName": "Кагава аймаг",
      "buName": "ကာဂါဝါ ပြည်နယ်",
      "khName": "ខេត្ដ កាហ្កាវ៉ា",
      "neName": "खागावा जिल्ला"
    },
    "class10": {
      "code": "370000",
      "name": "香川県",
      "enName": "Kagawa Prefecture",
      "chName": "香川縣",
      "zhName": "香川县",
      "koName": "가가와현",
      "esName": "Prefectura de Kagawa",
      "ptName": "Prefeitura de Kagawa",
      "thName": "จังหวัดคางาวะ",
      "viName": "tỉnh Kagawa",
      "inName": "Prefektur Kagawa",
      "tlName": "Kagawa prefecture",
      "moName": "Кагава муж",
      "buName": "ကာဂါဝါစီရင်စု",
      "khName": "ខេត្ត Kagawa",
      "neName": "कागावा प्रान्त"
    },
    "class15": {
      "code": "370004",
      "name": "中讃",
      "enName": "Chusan"
    },
    "class20": {
      "code": "3720300",
      "name": "坂出市",
      "enName": "Sakaide City",
      "kana": "さかいでし",
      "chName": "坂出市",
      "zhName": "坂出市",
      "koName": "사카이데 시",
      "esName": "Ciudad de Sakaide",
      "ptName": "cidade de Sakaide",
      "thName": "เมืองซากาอิเดะ",
      "viName": "thành phố Sakaide",
      "inName": "kota Sakaide",
      "tlName": "siyudad ng Sakaide",
      "moName": "Сакайдэ хот",
      "buName": "ဆာကိုင်းယိဒဲ့ မြို့",
      "khName": "ទីក្រុង សាខេត",
      "neName": "साकाइदे सहर"
    }
  },
  "3720400": {
    "office": {
      "code": "370000",
      "name": "香川県",
      "enName": "Kagawa",
      "officeName": "高松地方気象台",
      "chName": "香川县",
      "zhName": "香川縣",
      "koName": "카가와현",
      "esName": "Prefectura de Kagawa",
      "ptName": "Província de Kagawa",
      "thName": "จังหวัดคางาวะ",
      "viName": "Tỉnh Kagawa",
      "inName": "Prefektur Kagawa",
      "tlName": "Kagawa Prefecture",
      "moName": "Кагава аймаг",
      "buName": "ကာဂါဝါ ပြည်နယ်",
      "khName": "ខេត្ដ កាហ្កាវ៉ា",
      "neName": "खागावा जिल्ला"
    },
    "class10": {
      "code": "370000",
      "name": "香川県",
      "enName": "Kagawa Prefecture",
      "chName": "香川縣",
      "zhName": "香川县",
      "koName": "가가와현",
      "esName": "Prefectura de Kagawa",
      "ptName": "Prefeitura de Kagawa",
      "thName": "จังหวัดคางาวะ",
      "viName": "tỉnh Kagawa",
      "inName": "Prefektur Kagawa",
      "tlName": "Kagawa prefecture",
      "moName": "Кагава муж",
      "buName": "ကာဂါဝါစီရင်စု",
      "khName": "ខេត្ត Kagawa",
      "neName": "कागावा प्रान्त"
    },
    "class15": {
      "code": "370004",
      "name": "中讃",
      "enName": "Chusan"
    },
    "class20": {
      "code": "3720400",
      "name": "善通寺市",
      "enName": "Zentsuji City",
      "kana": "ぜんつうじし",
      "chName": "善通寺市",
      "zhName": "善通寺市",
      "koName": "젠쓰지 시",
      "esName": "Ciudad de Zentsuji",
      "ptName": "cidade de Zentsuji",
      "thName": "เมืองเซนทสึจิ",
      "viName": "thành phố Zentsuji",
      "inName": "kota Zentsuji",
      "tlName": "siyudad ng Zentsuji",
      "moName": "Зэнцүжи хот",
      "buName": "ဇန်းဆုဂျိ မြို့",
      "khName": "ទីក្រុង សិនស៊ូជី",
      "neName": "जेन्त्सुजी सहर"
    }
  },
  "3720500": {
    "office": {
      "code": "370000",
      "name": "香川県",
      "enName": "Kagawa",
      "officeName": "高松地方気象台",
      "chName": "香川县",
      "zhName": "香川縣",
      "koName": "카가와현",
      "esName": "Prefectura de Kagawa",
      "ptName": "Província de Kagawa",
      "thName": "จังหวัดคางาวะ",
      "viName": "Tỉnh Kagawa",
      "inName": "Prefektur Kagawa",
      "tlName": "Kagawa Prefecture",
      "moName": "Кагава аймаг",
      "buName": "ကာဂါဝါ ပြည်နယ်",
      "khName": "ខេត្ដ កាហ្កាវ៉ា",
      "neName": "खागावा जिल्ला"
    },
    "class10": {
      "code": "370000",
      "name": "香川県",
      "enName": "Kagawa Prefecture",
      "chName": "香川縣",
      "zhName": "香川县",
      "koName": "가가와현",
      "esName": "Prefectura de Kagawa",
      "ptName": "Prefeitura de Kagawa",
      "thName": "จังหวัดคางาวะ",
      "viName": "tỉnh Kagawa",
      "inName": "Prefektur Kagawa",
      "tlName": "Kagawa prefecture",
      "moName": "Кагава муж",
      "buName": "ကာဂါဝါစီရင်စု",
      "khName": "ខេត្ត Kagawa",
      "neName": "कागावा प्रान्त"
    },
    "class15": {
      "code": "370005",
      "name": "西讃",
      "enName": "Seisan"
    },
    "class20": {
      "code": "3720500",
      "name": "観音寺市",
      "enName": "Kanonji City",
      "kana": "かんおんじし",
      "chName": "观音寺市",
      "zhName": "觀音寺市",
      "koName": "간온지 시",
      "esName": "Ciudad de Kan-onji",
      "ptName": "cidade de Kanonji",
      "thName": "เมืองคังออนจิ",
      "viName": "thành phố Kanonji",
      "inName": "kota Kanonji",
      "tlName": "siyudad ng Kanonji",
      "moName": "Канонжи хот",
      "buName": "ခန်နွန်းဂျိ မြို့",
      "khName": "ទីក្រុង កានុនជី",
      "neName": "कानोन्जी सहर"
    }
  },
  "3720600": {
    "office": {
      "code": "370000",
      "name": "香川県",
      "enName": "Kagawa",
      "officeName": "高松地方気象台",
      "chName": "香川县",
      "zhName": "香川縣",
      "koName": "카가와현",
      "esName": "Prefectura de Kagawa",
      "ptName": "Província de Kagawa",
      "thName": "จังหวัดคางาวะ",
      "viName": "Tỉnh Kagawa",
      "inName": "Prefektur Kagawa",
      "tlName": "Kagawa Prefecture",
      "moName": "Кагава аймаг",
      "buName": "ကာဂါဝါ ပြည်နယ်",
      "khName": "ខេត្ដ កាហ្កាវ៉ា",
      "neName": "खागावा जिल्ला"
    },
    "class10": {
      "code": "370000",
      "name": "香川県",
      "enName": "Kagawa Prefecture",
      "chName": "香川縣",
      "zhName": "香川县",
      "koName": "가가와현",
      "esName": "Prefectura de Kagawa",
      "ptName": "Prefeitura de Kagawa",
      "thName": "จังหวัดคางาวะ",
      "viName": "tỉnh Kagawa",
      "inName": "Prefektur Kagawa",
      "tlName": "Kagawa prefecture",
      "moName": "Кагава муж",
      "buName": "ကာဂါဝါစီရင်စု",
      "khName": "ខេត្ត Kagawa",
      "neName": "कागावा प्रान्त"
    },
    "class15": {
      "code": "370003",
      "name": "東讃",
      "enName": "Tosan"
    },
    "class20": {
      "code": "3720600",
      "name": "さぬき市",
      "enName": "Sanuki City",
      "kana": "さぬきし",
      "chName": "赞岐市",
      "zhName": "讃岐市",
      "koName": "사누키 시",
      "esName": "Ciudad de Sanuki",
      "ptName": "cidade de Sanuki",
      "thName": "เมืองซานุกิ",
      "viName": "thành phố Sanuki",
      "inName": "kota Sanuki",
      "tlName": "siyudad ng Sanuki",
      "moName": "Сaнүки хот",
      "buName": "ဆန်နုခိ မြို့",
      "khName": "ទីក្រុង សានុគី",
      "neName": "सानुकी सहर"
    }
  },
  "3720700": {
    "office": {
      "code": "370000",
      "name": "香川県",
      "enName": "Kagawa",
      "officeName": "高松地方気象台",
      "chName": "香川县",
      "zhName": "香川縣",
      "koName": "카가와현",
      "esName": "Prefectura de Kagawa",
      "ptName": "Província de Kagawa",
      "thName": "จังหวัดคางาวะ",
      "viName": "Tỉnh Kagawa",
      "inName": "Prefektur Kagawa",
      "tlName": "Kagawa Prefecture",
      "moName": "Кагава аймаг",
      "buName": "ကာဂါဝါ ပြည်နယ်",
      "khName": "ខេត្ដ កាហ្កាវ៉ា",
      "neName": "खागावा जिल्ला"
    },
    "class10": {
      "code": "370000",
      "name": "香川県",
      "enName": "Kagawa Prefecture",
      "chName": "香川縣",
      "zhName": "香川县",
      "koName": "가가와현",
      "esName": "Prefectura de Kagawa",
      "ptName": "Prefeitura de Kagawa",
      "thName": "จังหวัดคางาวะ",
      "viName": "tỉnh Kagawa",
      "inName": "Prefektur Kagawa",
      "tlName": "Kagawa prefecture",
      "moName": "Кагава муж",
      "buName": "ကာဂါဝါစီရင်စု",
      "khName": "ខេត្ត Kagawa",
      "neName": "कागावा प्रान्त"
    },
    "class15": {
      "code": "370003",
      "name": "東讃",
      "enName": "Tosan"
    },
    "class20": {
      "code": "3720700",
      "name": "東かがわ市",
      "enName": "Higashikagawa City",
      "kana": "ひがしかがわし",
      "chName": "东香川市",
      "zhName": "東香川市",
      "koName": "히가시카가와 시",
      "esName": "Ciudad de Higashi-kagawa",
      "ptName": "cidade de Higashikagawa",
      "thName": "เมืองฮิงาชิคางาวะ",
      "viName": "thành phố Higashikagawa",
      "inName": "kota Higashikagawa",
      "tlName": "siyudad ng Higashikagawa",
      "moName": "Хигaшикагава хот",
      "buName": "ဟီဂါ့ရှိခါဂါ့ဝ မြို့",
      "khName": "ទីក្រុង ហ៊ីសាគីសកាហ្គាវ៉ា",
      "neName": "हिगाशिकागावा सहर"
    }
  },
  "3720800": {
    "office": {
      "code": "370000",
      "name": "香川県",
      "enName": "Kagawa",
      "officeName": "高松地方気象台",
      "chName": "香川县",
      "zhName": "香川縣",
      "koName": "카가와현",
      "esName": "Prefectura de Kagawa",
      "ptName": "Província de Kagawa",
      "thName": "จังหวัดคางาวะ",
      "viName": "Tỉnh Kagawa",
      "inName": "Prefektur Kagawa",
      "tlName": "Kagawa Prefecture",
      "moName": "Кагава аймаг",
      "buName": "ကာဂါဝါ ပြည်နယ်",
      "khName": "ខេត្ដ កាហ្កាវ៉ា",
      "neName": "खागावा जिल्ला"
    },
    "class10": {
      "code": "370000",
      "name": "香川県",
      "enName": "Kagawa Prefecture",
      "chName": "香川縣",
      "zhName": "香川县",
      "koName": "가가와현",
      "esName": "Prefectura de Kagawa",
      "ptName": "Prefeitura de Kagawa",
      "thName": "จังหวัดคางาวะ",
      "viName": "tỉnh Kagawa",
      "inName": "Prefektur Kagawa",
      "tlName": "Kagawa prefecture",
      "moName": "Кагава муж",
      "buName": "ကာဂါဝါစီရင်စု",
      "khName": "ខេត្ត Kagawa",
      "neName": "कागावा प्रान्त"
    },
    "class15": {
      "code": "370005",
      "name": "西讃",
      "enName": "Seisan"
    },
    "class20": {
      "code": "3720800",
      "name": "三豊市",
      "enName": "Mitoyo City",
      "kana": "みとよし",
      "chName": "三丰市",
      "zhName": "三豐市",
      "koName": "미토요 시",
      "esName": "Ciudad de Mitoyo",
      "ptName": "cidade de Mitoyo",
      "thName": "เมืองมิโตโยะ",
      "viName": "thành phố Mitoyo",
      "inName": "kota Mitoyo",
      "tlName": "siyudad ng Mitoyo",
      "moName": "Митоёо хот",
      "buName": "မီတိုးယို မြို့",
      "khName": "ទីក្រុង មីតូយ៉ូ",
      "neName": "मितोयो सहर"
    }
  },
  "3732200": {
    "office": {
      "code": "370000",
      "name": "香川県",
      "enName": "Kagawa",
      "officeName": "高松地方気象台",
      "chName": "香川县",
      "zhName": "香川縣",
      "koName": "카가와현",
      "esName": "Prefectura de Kagawa",
      "ptName": "Província de Kagawa",
      "thName": "จังหวัดคางาวะ",
      "viName": "Tỉnh Kagawa",
      "inName": "Prefektur Kagawa",
      "tlName": "Kagawa Prefecture",
      "moName": "Кагава аймаг",
      "buName": "ကာဂါဝါ ပြည်နယ်",
      "khName": "ខេត្ដ កាហ្កាវ៉ា",
      "neName": "खागावा जिल्ला"
    },
    "class10": {
      "code": "370000",
      "name": "香川県",
      "enName": "Kagawa Prefecture",
      "chName": "香川縣",
      "zhName": "香川县",
      "koName": "가가와현",
      "esName": "Prefectura de Kagawa",
      "ptName": "Prefeitura de Kagawa",
      "thName": "จังหวัดคางาวะ",
      "viName": "tỉnh Kagawa",
      "inName": "Prefektur Kagawa",
      "tlName": "Kagawa prefecture",
      "moName": "Кагава муж",
      "buName": "ကာဂါဝါစီရင်စု",
      "khName": "ខេត្ត Kagawa",
      "neName": "कागावा प्रान्त"
    },
    "class15": {
      "code": "370002",
      "name": "小豆",
      "enName": "Shozu"
    },
    "class20": {
      "code": "3732200",
      "name": "土庄町",
      "enName": "Tonosho Town",
      "kana": "とのしょうちょう",
      "chName": "土庄町",
      "zhName": "土庄町",
      "koName": "도노쇼 정",
      "esName": "Pueblo de Tonosho",
      "ptName": "bairro de Tonosho",
      "thName": "เมืองโตโนะโช",
      "viName": "thị trấn Tonosho",
      "inName": "kota Tonosho",
      "tlName": "bayan ng Tonosho",
      "moName": "Тоношо жижиг хот",
      "buName": "တောနိုရှို မြို့နယ်",
      "khName": "ទីប្រជុំជន តូណូសូ",
      "neName": "तोनोशो नगर"
    }
  },
  "3732400": {
    "office": {
      "code": "370000",
      "name": "香川県",
      "enName": "Kagawa",
      "officeName": "高松地方気象台",
      "chName": "香川县",
      "zhName": "香川縣",
      "koName": "카가와현",
      "esName": "Prefectura de Kagawa",
      "ptName": "Província de Kagawa",
      "thName": "จังหวัดคางาวะ",
      "viName": "Tỉnh Kagawa",
      "inName": "Prefektur Kagawa",
      "tlName": "Kagawa Prefecture",
      "moName": "Кагава аймаг",
      "buName": "ကာဂါဝါ ပြည်နယ်",
      "khName": "ខេត្ដ កាហ្កាវ៉ា",
      "neName": "खागावा जिल्ला"
    },
    "class10": {
      "code": "370000",
      "name": "香川県",
      "enName": "Kagawa Prefecture",
      "chName": "香川縣",
      "zhName": "香川县",
      "koName": "가가와현",
      "esName": "Prefectura de Kagawa",
      "ptName": "Prefeitura de Kagawa",
      "thName": "จังหวัดคางาวะ",
      "viName": "tỉnh Kagawa",
      "inName": "Prefektur Kagawa",
      "tlName": "Kagawa prefecture",
      "moName": "Кагава муж",
      "buName": "ကာဂါဝါစီရင်စု",
      "khName": "ខេត្ត Kagawa",
      "neName": "कागावा प्रान्त"
    },
    "class15": {
      "code": "370002",
      "name": "小豆",
      "enName": "Shozu"
    },
    "class20": {
      "code": "3732400",
      "name": "小豆島町",
      "enName": "Shodoshima Town",
      "kana": "しょうどしまちょう",
      "chName": "小豆岛町",
      "zhName": "小豆島町",
      "koName": "쇼도시마 정",
      "esName": "Pueblo de Shodoshima",
      "ptName": "bairro de Shodoshima",
      "thName": "เมืองโชโดชิมะ",
      "viName": "thị trấn Shodoshima",
      "inName": "kota Shodoshima",
      "tlName": "bayan ng Shodoshima",
      "moName": "Шодошимa жижиг хот",
      "buName": "ရှိုဒိုရှိမ မြို့နယ်",
      "khName": "ទីប្រជុំជន សូដូស៊ីម៉ា",
      "neName": "शोदोशिमा नगर"
    }
  },
  "3734100": {
    "office": {
      "code": "370000",
      "name": "香川県",
      "enName": "Kagawa",
      "officeName": "高松地方気象台",
      "chName": "香川县",
      "zhName": "香川縣",
      "koName": "카가와현",
      "esName": "Prefectura de Kagawa",
      "ptName": "Província de Kagawa",
      "thName": "จังหวัดคางาวะ",
      "viName": "Tỉnh Kagawa",
      "inName": "Prefektur Kagawa",
      "tlName": "Kagawa Prefecture",
      "moName": "Кагава аймаг",
      "buName": "ကာဂါဝါ ပြည်နယ်",
      "khName": "ខេត្ដ កាហ្កាវ៉ា",
      "neName": "खागावा जिल्ला"
    },
    "class10": {
      "code": "370000",
      "name": "香川県",
      "enName": "Kagawa Prefecture",
      "chName": "香川縣",
      "zhName": "香川县",
      "koName": "가가와현",
      "esName": "Prefectura de Kagawa",
      "ptName": "Prefeitura de Kagawa",
      "thName": "จังหวัดคางาวะ",
      "viName": "tỉnh Kagawa",
      "inName": "Prefektur Kagawa",
      "tlName": "Kagawa prefecture",
      "moName": "Кагава муж",
      "buName": "ကာဂါဝါစီရင်စု",
      "khName": "ខេត្ត Kagawa",
      "neName": "कागावा प्रान्त"
    },
    "class15": {
      "code": "370003",
      "name": "東讃",
      "enName": "Tosan"
    },
    "class20": {
      "code": "3734100",
      "name": "三木町",
      "enName": "Miki Town",
      "kana": "みきちょう",
      "chName": "三木町",
      "zhName": "三木町",
      "koName": "미키 정",
      "esName": "Pueblo de Miki",
      "ptName": "bairro de Miki",
      "thName": "เมืองมิกิ",
      "viName": "thị trấn Miki",
      "inName": "kota Miki",
      "tlName": "bayan ng Miki",
      "moName": "Мики жижиг хот",
      "buName": "မီကိ မြို့နယ်",
      "khName": "ទីប្រជុំជន មីគី",
      "neName": "मिकी नगर"
    }
  },
  "3736400": {
    "office": {
      "code": "370000",
      "name": "香川県",
      "enName": "Kagawa",
      "officeName": "高松地方気象台",
      "chName": "香川县",
      "zhName": "香川縣",
      "koName": "카가와현",
      "esName": "Prefectura de Kagawa",
      "ptName": "Província de Kagawa",
      "thName": "จังหวัดคางาวะ",
      "viName": "Tỉnh Kagawa",
      "inName": "Prefektur Kagawa",
      "tlName": "Kagawa Prefecture",
      "moName": "Кагава аймаг",
      "buName": "ကာဂါဝါ ပြည်နယ်",
      "khName": "ខេត្ដ កាហ្កាវ៉ា",
      "neName": "खागावा जिल्ला"
    },
    "class10": {
      "code": "370000",
      "name": "香川県",
      "enName": "Kagawa Prefecture",
      "chName": "香川縣",
      "zhName": "香川县",
      "koName": "가가와현",
      "esName": "Prefectura de Kagawa",
      "ptName": "Prefeitura de Kagawa",
      "thName": "จังหวัดคางาวะ",
      "viName": "tỉnh Kagawa",
      "inName": "Prefektur Kagawa",
      "tlName": "Kagawa prefecture",
      "moName": "Кагава муж",
      "buName": "ကာဂါဝါစီရင်စု",
      "khName": "ខេត្ត Kagawa",
      "neName": "कागावा प्रान्त"
    },
    "class15": {
      "code": "370001",
      "name": "高松地域",
      "enName": "Takamatsu Area"
    },
    "class20": {
      "code": "3736400",
      "name": "直島町",
      "enName": "Naoshima Town",
      "kana": "なおしまちょう",
      "chName": "直岛町",
      "zhName": "直島町",
      "koName": "나오시마 정",
      "esName": "Pueblo de Naoshima",
      "ptName": "bairro de Naoshima",
      "thName": "เมืองนาโอชิมะ",
      "viName": "thị trấn Naoshima",
      "inName": "kota Naoshima",
      "tlName": "bayan ng Naoshima",
      "moName": "Нaошимa жижиг хот",
      "buName": "နာအို့ရှိမ မြို့နယ်",
      "khName": "ទីប្រជុំជន ណៅស៊ីម៉ា",
      "neName": "नाओशिमा नगर"
    }
  },
  "3738600": {
    "office": {
      "code": "370000",
      "name": "香川県",
      "enName": "Kagawa",
      "officeName": "高松地方気象台",
      "chName": "香川县",
      "zhName": "香川縣",
      "koName": "카가와현",
      "esName": "Prefectura de Kagawa",
      "ptName": "Província de Kagawa",
      "thName": "จังหวัดคางาวะ",
      "viName": "Tỉnh Kagawa",
      "inName": "Prefektur Kagawa",
      "tlName": "Kagawa Prefecture",
      "moName": "Кагава аймаг",
      "buName": "ကာဂါဝါ ပြည်နယ်",
      "khName": "ខេត្ដ កាហ្កាវ៉ា",
      "neName": "खागावा जिल्ला"
    },
    "class10": {
      "code": "370000",
      "name": "香川県",
      "enName": "Kagawa Prefecture",
      "chName": "香川縣",
      "zhName": "香川县",
      "koName": "가가와현",
      "esName": "Prefectura de Kagawa",
      "ptName": "Prefeitura de Kagawa",
      "thName": "จังหวัดคางาวะ",
      "viName": "tỉnh Kagawa",
      "inName": "Prefektur Kagawa",
      "tlName": "Kagawa prefecture",
      "moName": "Кагава муж",
      "buName": "ကာဂါဝါစီရင်စု",
      "khName": "ខេត្ត Kagawa",
      "neName": "कागावा प्रान्त"
    },
    "class15": {
      "code": "370004",
      "name": "中讃",
      "enName": "Chusan"
    },
    "class20": {
      "code": "3738600",
      "name": "宇多津町",
      "enName": "Utazu Town",
      "kana": "うたづちょう",
      "chName": "宇多津町",
      "zhName": "宇多津町",
      "koName": "우타즈 정",
      "esName": "Pueblo de Utazu",
      "ptName": "bairro de Utazu",
      "thName": "เมืองอุตะสึ",
      "viName": "thị trấn Utazu",
      "inName": "kota Utazu",
      "tlName": "bayan ng Utazu",
      "moName": "Үтазү жижиг хот",
      "buName": "ဥတာ့ဇု မြို့နယ်",
      "khName": "ទីប្រជុំជន យូតាហ្ស៊ូ",
      "neName": "उताजु नगर"
    }
  },
  "3738700": {
    "office": {
      "code": "370000",
      "name": "香川県",
      "enName": "Kagawa",
      "officeName": "高松地方気象台",
      "chName": "香川县",
      "zhName": "香川縣",
      "koName": "카가와현",
      "esName": "Prefectura de Kagawa",
      "ptName": "Província de Kagawa",
      "thName": "จังหวัดคางาวะ",
      "viName": "Tỉnh Kagawa",
      "inName": "Prefektur Kagawa",
      "tlName": "Kagawa Prefecture",
      "moName": "Кагава аймаг",
      "buName": "ကာဂါဝါ ပြည်နယ်",
      "khName": "ខេត្ដ កាហ្កាវ៉ា",
      "neName": "खागावा जिल्ला"
    },
    "class10": {
      "code": "370000",
      "name": "香川県",
      "enName": "Kagawa Prefecture",
      "chName": "香川縣",
      "zhName": "香川县",
      "koName": "가가와현",
      "esName": "Prefectura de Kagawa",
      "ptName": "Prefeitura de Kagawa",
      "thName": "จังหวัดคางาวะ",
      "viName": "tỉnh Kagawa",
      "inName": "Prefektur Kagawa",
      "tlName": "Kagawa prefecture",
      "moName": "Кагава муж",
      "buName": "ကာဂါဝါစီရင်စု",
      "khName": "ខេត្ត Kagawa",
      "neName": "कागावा प्रान्त"
    },
    "class15": {
      "code": "370004",
      "name": "中讃",
      "enName": "Chusan"
    },
    "class20": {
      "code": "3738700",
      "name": "綾川町",
      "enName": "Ayagawa Town",
      "kana": "あやがわちょう",
      "chName": "绫川町",
      "zhName": "綾川町",
      "koName": "아야가와 정",
      "esName": "Pueblo de Ayakawa",
      "ptName": "bairro de Ayagawa",
      "thName": "เมืองอายากาวะ",
      "viName": "thị trấn Ayagawa",
      "inName": "kota Ayagawa",
      "tlName": "bayan ng Ayagawa",
      "moName": "Aягава жижиг хот",
      "buName": "အာယားဂါ့ဝ မြို့နယ်",
      "khName": "ទីប្រជុំជន អាយហ្គាហ្គាវ៉ា",
      "neName": "आयागावा नगर"
    }
  },
  "3740300": {
    "office": {
      "code": "370000",
      "name": "香川県",
      "enName": "Kagawa",
      "officeName": "高松地方気象台",
      "chName": "香川县",
      "zhName": "香川縣",
      "koName": "카가와현",
      "esName": "Prefectura de Kagawa",
      "ptName": "Província de Kagawa",
      "thName": "จังหวัดคางาวะ",
      "viName": "Tỉnh Kagawa",
      "inName": "Prefektur Kagawa",
      "tlName": "Kagawa Prefecture",
      "moName": "Кагава аймаг",
      "buName": "ကာဂါဝါ ပြည်နယ်",
      "khName": "ខេត្ដ កាហ្កាវ៉ា",
      "neName": "खागावा जिल्ला"
    },
    "class10": {
      "code": "370000",
      "name": "香川県",
      "enName": "Kagawa Prefecture",
      "chName": "香川縣",
      "zhName": "香川县",
      "koName": "가가와현",
      "esName": "Prefectura de Kagawa",
      "ptName": "Prefeitura de Kagawa",
      "thName": "จังหวัดคางาวะ",
      "viName": "tỉnh Kagawa",
      "inName": "Prefektur Kagawa",
      "tlName": "Kagawa prefecture",
      "moName": "Кагава муж",
      "buName": "ကာဂါဝါစီရင်စု",
      "khName": "ខេត្ត Kagawa",
      "neName": "कागावा प्रान्त"
    },
    "class15": {
      "code": "370004",
      "name": "中讃",
      "enName": "Chusan"
    },
    "class20": {
      "code": "3740300",
      "name": "琴平町",
      "enName": "Kotohira Town",
      "kana": "ことひらちょう",
      "chName": "琴平町",
      "zhName": "琴平町",
      "koName": "고토히라 정",
      "esName": "Pueblo de Kotohira",
      "ptName": "bairro de Kotohira",
      "thName": "เมืองโคโตฮิระ",
      "viName": "thị trấn Kotohira",
      "inName": "kota Kotohira",
      "tlName": "bayan ng Kotohira",
      "moName": "Котохира жижиг хот",
      "buName": "ခိုတိုးဟိရာ့ မြို့နယ်",
      "khName": "ទីប្រជុំជន កូតូហ៊ីរ៉ា",
      "neName": "कोतोहिरा नगर"
    }
  },
  "3740400": {
    "office": {
      "code": "370000",
      "name": "香川県",
      "enName": "Kagawa",
      "officeName": "高松地方気象台",
      "chName": "香川县",
      "zhName": "香川縣",
      "koName": "카가와현",
      "esName": "Prefectura de Kagawa",
      "ptName": "Província de Kagawa",
      "thName": "จังหวัดคางาวะ",
      "viName": "Tỉnh Kagawa",
      "inName": "Prefektur Kagawa",
      "tlName": "Kagawa Prefecture",
      "moName": "Кагава аймаг",
      "buName": "ကာဂါဝါ ပြည်နယ်",
      "khName": "ខេត្ដ កាហ្កាវ៉ា",
      "neName": "खागावा जिल्ला"
    },
    "class10": {
      "code": "370000",
      "name": "香川県",
      "enName": "Kagawa Prefecture",
      "chName": "香川縣",
      "zhName": "香川县",
      "koName": "가가와현",
      "esName": "Prefectura de Kagawa",
      "ptName": "Prefeitura de Kagawa",
      "thName": "จังหวัดคางาวะ",
      "viName": "tỉnh Kagawa",
      "inName": "Prefektur Kagawa",
      "tlName": "Kagawa prefecture",
      "moName": "Кагава муж",
      "buName": "ကာဂါဝါစီရင်စု",
      "khName": "ខេត្ត Kagawa",
      "neName": "कागावा प्रान्त"
    },
    "class15": {
      "code": "370004",
      "name": "中讃",
      "enName": "Chusan"
    },
    "class20": {
      "code": "3740400",
      "name": "多度津町",
      "enName": "Tadotsu Town",
      "kana": "たどつちょう",
      "chName": "多度津町",
      "zhName": "多度津町",
      "koName": "다도쓰 정",
      "esName": "Pueblo de Tadotsu",
      "ptName": "bairro de Tadotsu",
      "thName": "เมืองทาโดสึ",
      "viName": "thị trấn Tadotsu",
      "inName": "kota Tadotsu",
      "tlName": "bayan ng Tadotsu",
      "moName": "Тадоцү жижиг хот",
      "buName": "တားဒေါ့စု မြို့နယ်",
      "khName": "ទីប្រជុំជន តាដតស៊ូ",
      "neName": "तादोत्सु नगर"
    }
  },
  "3740600": {
    "office": {
      "code": "370000",
      "name": "香川県",
      "enName": "Kagawa",
      "officeName": "高松地方気象台",
      "chName": "香川县",
      "zhName": "香川縣",
      "koName": "카가와현",
      "esName": "Prefectura de Kagawa",
      "ptName": "Província de Kagawa",
      "thName": "จังหวัดคางาวะ",
      "viName": "Tỉnh Kagawa",
      "inName": "Prefektur Kagawa",
      "tlName": "Kagawa Prefecture",
      "moName": "Кагава аймаг",
      "buName": "ကာဂါဝါ ပြည်နယ်",
      "khName": "ខេត្ដ កាហ្កាវ៉ា",
      "neName": "खागावा जिल्ला"
    },
    "class10": {
      "code": "370000",
      "name": "香川県",
      "enName": "Kagawa Prefecture",
      "chName": "香川縣",
      "zhName": "香川县",
      "koName": "가가와현",
      "esName": "Prefectura de Kagawa",
      "ptName": "Prefeitura de Kagawa",
      "thName": "จังหวัดคางาวะ",
      "viName": "tỉnh Kagawa",
      "inName": "Prefektur Kagawa",
      "tlName": "Kagawa prefecture",
      "moName": "Кагава муж",
      "buName": "ကာဂါဝါစီရင်စု",
      "khName": "ខេត្ត Kagawa",
      "neName": "कागावा प्रान्त"
    },
    "class15": {
      "code": "370004",
      "name": "中讃",
      "enName": "Chusan"
    },
    "class20": {
      "code": "3740600",
      "name": "まんのう町",
      "enName": "Manno Town",
      "kana": "まんのうちょう",
      "chName": "满浓町",
      "zhName": "滿濃町",
      "koName": "만노 정",
      "esName": "Pueblo de Mannō",
      "ptName": "bairro de Manno",
      "thName": "เมืองมันโน",
      "viName": "thị trấn Manno",
      "inName": "kota Manno",
      "tlName": "bayan ng Manno",
      "moName": "Мaнно жижиг хот",
      "buName": "မန်းနို မြို့နယ်",
      "khName": "ទីប្រជុំជន មេនណូ",
      "neName": "मान्नो नगर"
    }
  },
  "3820100": {
    "office": {
      "code": "380000",
      "name": "愛媛県",
      "enName": "Ehime",
      "officeName": "松山地方気象台",
      "chName": "爱媛县",
      "zhName": "愛媛縣",
      "koName": "에히메현",
      "esName": "Prefectura de Ehime",
      "ptName": "Província de Ehime",
      "thName": "จังหวัดเอะฮิเมะ",
      "viName": "Tỉnh Ehime",
      "inName": "Prefektur Ehime",
      "tlName": "Ehime Prefecture",
      "moName": "Эхимэ аймаг",
      "buName": "အဲသျှီမဲ့ ပြည်နယ်",
      "khName": "ខេត្ដ អេហីម",
      "neName": "एहिमे जिल्ला"
    },
    "class10": {
      "code": "380010",
      "name": "中予",
      "enName": "Chuyo",
      "chName": "爱媛县中预",
      "zhName": "愛媛縣中予",
      "koName": "에히메현 중여",
      "esName": "Chuyo, Prefectura de Ehime",
      "ptName": "Região Chūyo da Província de Ehime",
      "thName": "จูโยะ จังหวัดเอะฮิเมะ",
      "viName": "Chuyo, tỉnh Ehime",
      "inName": "Chuyo, Prefektur Ehime",
      "tlName": "Chuyo, Ehime Prefecture",
      "moName": "Эхимэ аймаг, Чүё",
      "buName": "ချူးယို၊ အဲဟိမဲစီရင်စု",
      "khName": "តំបនជូយោនៃខេត្ដអិហិមិ",
      "neName": "एहिमे जिल्ला, च्युयो"
    },
    "class15": {
      "code": "380010",
      "name": "中予",
      "enName": "Chuyo"
    },
    "class20": {
      "code": "3820100",
      "name": "松山市",
      "enName": "Matsuyama City",
      "kana": "まつやまし",
      "chName": "松山市",
      "zhName": "松山市",
      "koName": "마쓰야마 시",
      "esName": "Ciudad de Matsuyama",
      "ptName": "cidade de Matsuyama",
      "thName": "เมืองมัทสึยามะ",
      "viName": "thành phố Matsuyama",
      "inName": "kota Matsuyama",
      "tlName": "siyudad ng Matsuyama",
      "moName": "Мацүяма хот",
      "buName": "မာဆုယာ့မ မြို့",
      "khName": "ទីក្រុង ម៉ាតស៊ូយ៉ាម៉ា",
      "neName": "मात्सुयामा सहर"
    }
  },
  "3820200": {
    "office": {
      "code": "380000",
      "name": "愛媛県",
      "enName": "Ehime",
      "officeName": "松山地方気象台",
      "chName": "爱媛县",
      "zhName": "愛媛縣",
      "koName": "에히메현",
      "esName": "Prefectura de Ehime",
      "ptName": "Província de Ehime",
      "thName": "จังหวัดเอะฮิเมะ",
      "viName": "Tỉnh Ehime",
      "inName": "Prefektur Ehime",
      "tlName": "Ehime Prefecture",
      "moName": "Эхимэ аймаг",
      "buName": "အဲသျှီမဲ့ ပြည်နယ်",
      "khName": "ខេត្ដ អេហីម",
      "neName": "एहिमे जिल्ला"
    },
    "class10": {
      "code": "380020",
      "name": "東予",
      "enName": "Toyo",
      "chName": "爱媛县东预",
      "zhName": "愛媛縣東予",
      "koName": "에히메 현 도요",
      "esName": "Touyo, Prefectura de Ehime",
      "ptName": "Região Tōyo da Província de Ehime",
      "thName": "โทโยะ จังหวัดเอะฮิเมะ",
      "viName": "Toyo, tỉnh Ehime",
      "inName": "Toyo, Prefektur Ehime",
      "tlName": "Toyo, Ehime Prefecture",
      "moName": "Эхимэ аймаг, Тоё",
      "buName": "တိုယို၊ အဲဟိမဲစီရင်စု",
      "khName": "តំបន់តូយោនៃខេត្ដអិហិមិ",
      "neName": "एहिमे जिल्ला, तोयो"
    },
    "class15": {
      "code": "380022",
      "name": "東予西部",
      "enName": "Western Toyo"
    },
    "class20": {
      "code": "3820200",
      "name": "今治市",
      "enName": "Imabari City",
      "kana": "いまばりし",
      "chName": "今治市",
      "zhName": "今治市",
      "koName": "이마바리 시",
      "esName": "Ciudad de Imabari",
      "ptName": "cidade de Imabari",
      "thName": "เมืองอิมะบาริ",
      "viName": "thành phố Imabari",
      "inName": "kota Imabari",
      "tlName": "siyudad ng Imabari",
      "moName": "Имaбари хот",
      "buName": "အီမားဘာ့ရိ မြို့",
      "khName": "ទីក្រុង អ៊ីម៉ាបារី",
      "neName": "इमाबारी सहर"
    }
  },
  "3820300": {
    "office": {
      "code": "380000",
      "name": "愛媛県",
      "enName": "Ehime",
      "officeName": "松山地方気象台",
      "chName": "爱媛县",
      "zhName": "愛媛縣",
      "koName": "에히메현",
      "esName": "Prefectura de Ehime",
      "ptName": "Província de Ehime",
      "thName": "จังหวัดเอะฮิเมะ",
      "viName": "Tỉnh Ehime",
      "inName": "Prefektur Ehime",
      "tlName": "Ehime Prefecture",
      "moName": "Эхимэ аймаг",
      "buName": "အဲသျှီမဲ့ ပြည်နယ်",
      "khName": "ខេត្ដ អេហីម",
      "neName": "एहिमे जिल्ला"
    },
    "class10": {
      "code": "380030",
      "name": "南予",
      "enName": "Nan-yo",
      "chName": "爱媛县南预",
      "zhName": "愛媛縣南予",
      "koName": "에히메현 남여",
      "esName": "Nanyo, Prefectura de Ehime",
      "ptName": "Região Nan-yo da Província de Ehime",
      "thName": "นันโยะ จังหวัดเอะฮิเมะ",
      "viName": "Nanyo, tỉnh Ehime",
      "inName": "Nanyo, Prefektur Ehime",
      "tlName": "Nanyo, Ehime Prefecture",
      "moName": "Эхимэ аймаг, Нанё",
      "buName": "နန်းယို၊ အဲဟိမဲစီရင်စု",
      "khName": "តំបន់ណាន់យោនៃខេត្ដអិហិមិ",
      "neName": "एहिमे जिल्ला, नान्यो"
    },
    "class15": {
      "code": "380032",
      "name": "南予南部",
      "enName": "Southern Nan-yo"
    },
    "class20": {
      "code": "3820300",
      "name": "宇和島市",
      "enName": "Uwajima City",
      "kana": "うわじまし",
      "chName": "宇和岛市",
      "zhName": "宇和島市",
      "koName": "우와지마 시",
      "esName": "Ciudad de Uwajima",
      "ptName": "cidade de Uwajima",
      "thName": "เมืองอิวะจิมะ",
      "viName": "thành phố Uwajima",
      "inName": "kota Uwajima",
      "tlName": "siyudad ng Uwajima",
      "moName": "Үважимa хот",
      "buName": "အုဝါးဂျိမ မြို့",
      "khName": "ទីក្រុង អ៊ូវ៉ាជីម៉ា",
      "neName": "उवाजिमा सहर"
    }
  },
  "3820400": {
    "office": {
      "code": "380000",
      "name": "愛媛県",
      "enName": "Ehime",
      "officeName": "松山地方気象台",
      "chName": "爱媛县",
      "zhName": "愛媛縣",
      "koName": "에히메현",
      "esName": "Prefectura de Ehime",
      "ptName": "Província de Ehime",
      "thName": "จังหวัดเอะฮิเมะ",
      "viName": "Tỉnh Ehime",
      "inName": "Prefektur Ehime",
      "tlName": "Ehime Prefecture",
      "moName": "Эхимэ аймаг",
      "buName": "အဲသျှီမဲ့ ပြည်နယ်",
      "khName": "ខេត្ដ អេហីម",
      "neName": "एहिमे जिल्ला"
    },
    "class10": {
      "code": "380030",
      "name": "南予",
      "enName": "Nan-yo",
      "chName": "爱媛县南预",
      "zhName": "愛媛縣南予",
      "koName": "에히메현 남여",
      "esName": "Nanyo, Prefectura de Ehime",
      "ptName": "Região Nan-yo da Província de Ehime",
      "thName": "นันโยะ จังหวัดเอะฮิเมะ",
      "viName": "Nanyo, tỉnh Ehime",
      "inName": "Nanyo, Prefektur Ehime",
      "tlName": "Nanyo, Ehime Prefecture",
      "moName": "Эхимэ аймаг, Нанё",
      "buName": "နန်းယို၊ အဲဟိမဲစီရင်စု",
      "khName": "តំបន់ណាន់យោនៃខេត្ដអិហិមិ",
      "neName": "एहिमे जिल्ला, नान्यो"
    },
    "class15": {
      "code": "380031",
      "name": "南予北部",
      "enName": "Northern Nan-yo"
    },
    "class20": {
      "code": "3820400",
      "name": "八幡浜市",
      "enName": "Yawatahama City",
      "kana": "やわたはまし",
      "chName": "八幡滨市",
      "zhName": "八幡濱市",
      "koName": "야와타하마 시",
      "esName": "Ciudad de Yawatahama",
      "ptName": "cidade de Yawatahama",
      "thName": "เมืองยาวาตะฮามะ",
      "viName": "thành phố Yawahama",
      "inName": "kota Yawatahama",
      "tlName": "siyudad ng Yawatahama",
      "moName": "Яватахaмa хот",
      "buName": "ယာဝါတားဟာ့မ မြို့",
      "khName": "ទីក្រុង យ៉ាវ៉ាតាហាម៉ា",
      "neName": "यावाताहामा सहर"
    }
  },
  "3820500": {
    "office": {
      "code": "380000",
      "name": "愛媛県",
      "enName": "Ehime",
      "officeName": "松山地方気象台",
      "chName": "爱媛县",
      "zhName": "愛媛縣",
      "koName": "에히메현",
      "esName": "Prefectura de Ehime",
      "ptName": "Província de Ehime",
      "thName": "จังหวัดเอะฮิเมะ",
      "viName": "Tỉnh Ehime",
      "inName": "Prefektur Ehime",
      "tlName": "Ehime Prefecture",
      "moName": "Эхимэ аймаг",
      "buName": "အဲသျှီမဲ့ ပြည်နယ်",
      "khName": "ខេត្ដ អេហីម",
      "neName": "एहिमे जिल्ला"
    },
    "class10": {
      "code": "380020",
      "name": "東予",
      "enName": "Toyo",
      "chName": "爱媛县东预",
      "zhName": "愛媛縣東予",
      "koName": "에히메 현 도요",
      "esName": "Touyo, Prefectura de Ehime",
      "ptName": "Região Tōyo da Província de Ehime",
      "thName": "โทโยะ จังหวัดเอะฮิเมะ",
      "viName": "Toyo, tỉnh Ehime",
      "inName": "Toyo, Prefektur Ehime",
      "tlName": "Toyo, Ehime Prefecture",
      "moName": "Эхимэ аймаг, Тоё",
      "buName": "တိုယို၊ အဲဟိမဲစီရင်စု",
      "khName": "តំបន់តូយោនៃខេត្ដអិហិមិ",
      "neName": "एहिमे जिल्ला, तोयो"
    },
    "class15": {
      "code": "380021",
      "name": "東予東部",
      "enName": "Eastern Toyo"
    },
    "class20": {
      "code": "3820500",
      "name": "新居浜市",
      "enName": "Niihama City",
      "kana": "にいはまし",
      "chName": "新居滨市",
      "zhName": "新居濱市",
      "koName": "니하마 시",
      "esName": "Ciudad de Niihama",
      "ptName": "cidade de Niihama",
      "thName": "เมืองนิอิฮามะ",
      "viName": "thành phố Niihama",
      "inName": "kota Niihama",
      "tlName": "siyudad ng Niihama",
      "moName": "Нийхама хот",
      "buName": "နီးဟာ့မ မြို့",
      "khName": "ទីក្រុង នីហាម៉ា",
      "neName": "निहामा सहर"
    }
  },
  "3820600": {
    "office": {
      "code": "380000",
      "name": "愛媛県",
      "enName": "Ehime",
      "officeName": "松山地方気象台",
      "chName": "爱媛县",
      "zhName": "愛媛縣",
      "koName": "에히메현",
      "esName": "Prefectura de Ehime",
      "ptName": "Província de Ehime",
      "thName": "จังหวัดเอะฮิเมะ",
      "viName": "Tỉnh Ehime",
      "inName": "Prefektur Ehime",
      "tlName": "Ehime Prefecture",
      "moName": "Эхимэ аймаг",
      "buName": "အဲသျှီမဲ့ ပြည်နယ်",
      "khName": "ខេត្ដ អេហីម",
      "neName": "एहिमे जिल्ला"
    },
    "class10": {
      "code": "380020",
      "name": "東予",
      "enName": "Toyo",
      "chName": "爱媛县东预",
      "zhName": "愛媛縣東予",
      "koName": "에히메 현 도요",
      "esName": "Touyo, Prefectura de Ehime",
      "ptName": "Região Tōyo da Província de Ehime",
      "thName": "โทโยะ จังหวัดเอะฮิเมะ",
      "viName": "Toyo, tỉnh Ehime",
      "inName": "Toyo, Prefektur Ehime",
      "tlName": "Toyo, Ehime Prefecture",
      "moName": "Эхимэ аймаг, Тоё",
      "buName": "တိုယို၊ အဲဟိမဲစီရင်စု",
      "khName": "តំបន់តូយោនៃខេត្ដអិហិមិ",
      "neName": "एहिमे जिल्ला, तोयो"
    },
    "class15": {
      "code": "380021",
      "name": "東予東部",
      "enName": "Eastern Toyo"
    },
    "class20": {
      "code": "3820600",
      "name": "西条市",
      "enName": "Saijo City",
      "kana": "さいじょうし",
      "chName": "西条市",
      "zhName": "西條市",
      "koName": "사이조 시",
      "esName": "Ciudad de Saijyo",
      "ptName": "cidade de Saijo",
      "thName": "เมืองไซโจ",
      "viName": "thành phố Saijo",
      "inName": "kota Saijo",
      "tlName": "siyudad ng Saijo",
      "moName": "Сайжо хот",
      "buName": "ဆိုင်ယိဂျို မြို့",
      "khName": "ទីក្រុង សៃចូ",
      "neName": "साइजो सहर"
    }
  },
  "3820700": {
    "office": {
      "code": "380000",
      "name": "愛媛県",
      "enName": "Ehime",
      "officeName": "松山地方気象台",
      "chName": "爱媛县",
      "zhName": "愛媛縣",
      "koName": "에히메현",
      "esName": "Prefectura de Ehime",
      "ptName": "Província de Ehime",
      "thName": "จังหวัดเอะฮิเมะ",
      "viName": "Tỉnh Ehime",
      "inName": "Prefektur Ehime",
      "tlName": "Ehime Prefecture",
      "moName": "Эхимэ аймаг",
      "buName": "အဲသျှီမဲ့ ပြည်နယ်",
      "khName": "ខេត្ដ អេហីម",
      "neName": "एहिमे जिल्ला"
    },
    "class10": {
      "code": "380030",
      "name": "南予",
      "enName": "Nan-yo",
      "chName": "爱媛县南预",
      "zhName": "愛媛縣南予",
      "koName": "에히메현 남여",
      "esName": "Nanyo, Prefectura de Ehime",
      "ptName": "Região Nan-yo da Província de Ehime",
      "thName": "นันโยะ จังหวัดเอะฮิเมะ",
      "viName": "Nanyo, tỉnh Ehime",
      "inName": "Nanyo, Prefektur Ehime",
      "tlName": "Nanyo, Ehime Prefecture",
      "moName": "Эхимэ аймаг, Нанё",
      "buName": "နန်းယို၊ အဲဟိမဲစီရင်စု",
      "khName": "តំបន់ណាន់យោនៃខេត្ដអិហិមិ",
      "neName": "एहिमे जिल्ला, नान्यो"
    },
    "class15": {
      "code": "380031",
      "name": "南予北部",
      "enName": "Northern Nan-yo"
    },
    "class20": {
      "code": "3820700",
      "name": "大洲市",
      "enName": "Ozu City",
      "kana": "おおずし",
      "chName": "大洲市",
      "zhName": "大洲市",
      "koName": "오즈 시",
      "esName": "Ciudad de Ōzu",
      "ptName": "cidade de Ozu",
      "thName": "เมืองโอซุ",
      "viName": "thành phố Ozu",
      "inName": "kota Ozu",
      "tlName": "siyudad ng Ozu",
      "moName": "Озү хот",
      "buName": "အို့ဇု မြို့",
      "khName": "ទីក្រុង អូហ្សូ",
      "neName": "ओजु सहर"
    }
  },
  "3821000": {
    "office": {
      "code": "380000",
      "name": "愛媛県",
      "enName": "Ehime",
      "officeName": "松山地方気象台",
      "chName": "爱媛县",
      "zhName": "愛媛縣",
      "koName": "에히메현",
      "esName": "Prefectura de Ehime",
      "ptName": "Província de Ehime",
      "thName": "จังหวัดเอะฮิเมะ",
      "viName": "Tỉnh Ehime",
      "inName": "Prefektur Ehime",
      "tlName": "Ehime Prefecture",
      "moName": "Эхимэ аймаг",
      "buName": "အဲသျှီမဲ့ ပြည်နယ်",
      "khName": "ខេត្ដ អេហីម",
      "neName": "एहिमे जिल्ला"
    },
    "class10": {
      "code": "380010",
      "name": "中予",
      "enName": "Chuyo",
      "chName": "爱媛县中预",
      "zhName": "愛媛縣中予",
      "koName": "에히메현 중여",
      "esName": "Chuyo, Prefectura de Ehime",
      "ptName": "Região Chūyo da Província de Ehime",
      "thName": "จูโยะ จังหวัดเอะฮิเมะ",
      "viName": "Chuyo, tỉnh Ehime",
      "inName": "Chuyo, Prefektur Ehime",
      "tlName": "Chuyo, Ehime Prefecture",
      "moName": "Эхимэ аймаг, Чүё",
      "buName": "ချူးယို၊ အဲဟိမဲစီရင်စု",
      "khName": "តំបនជូយោនៃខេត្ដអិហិមិ",
      "neName": "एहिमे जिल्ला, च्युयो"
    },
    "class15": {
      "code": "380010",
      "name": "中予",
      "enName": "Chuyo"
    },
    "class20": {
      "code": "3821000",
      "name": "伊予市",
      "enName": "Iyo City",
      "kana": "いよし",
      "chName": "伊予市",
      "zhName": "伊予市",
      "koName": "이요 시",
      "esName": "Ciudad de Iyo",
      "ptName": "cidade de Iyo",
      "thName": "เมืองอิโย",
      "viName": "thành phố Iyo",
      "inName": "kota Iyo",
      "tlName": "siyudad ng Iyo",
      "moName": "Иёо хот",
      "buName": "အီယို မြို့",
      "khName": "ទីក្រុង អាយយ៉ូ",
      "neName": "इयो सहर"
    }
  },
  "3821300": {
    "office": {
      "code": "380000",
      "name": "愛媛県",
      "enName": "Ehime",
      "officeName": "松山地方気象台",
      "chName": "爱媛县",
      "zhName": "愛媛縣",
      "koName": "에히메현",
      "esName": "Prefectura de Ehime",
      "ptName": "Província de Ehime",
      "thName": "จังหวัดเอะฮิเมะ",
      "viName": "Tỉnh Ehime",
      "inName": "Prefektur Ehime",
      "tlName": "Ehime Prefecture",
      "moName": "Эхимэ аймаг",
      "buName": "အဲသျှီမဲ့ ပြည်နယ်",
      "khName": "ខេត្ដ អេហីម",
      "neName": "एहिमे जिल्ला"
    },
    "class10": {
      "code": "380020",
      "name": "東予",
      "enName": "Toyo",
      "chName": "爱媛县东预",
      "zhName": "愛媛縣東予",
      "koName": "에히메 현 도요",
      "esName": "Touyo, Prefectura de Ehime",
      "ptName": "Região Tōyo da Província de Ehime",
      "thName": "โทโยะ จังหวัดเอะฮิเมะ",
      "viName": "Toyo, tỉnh Ehime",
      "inName": "Toyo, Prefektur Ehime",
      "tlName": "Toyo, Ehime Prefecture",
      "moName": "Эхимэ аймаг, Тоё",
      "buName": "တိုယို၊ အဲဟိမဲစီရင်စု",
      "khName": "តំបន់តូយោនៃខេត្ដអិហិមិ",
      "neName": "एहिमे जिल्ला, तोयो"
    },
    "class15": {
      "code": "380021",
      "name": "東予東部",
      "enName": "Eastern Toyo"
    },
    "class20": {
      "code": "3821300",
      "name": "四国中央市",
      "enName": "Shikokuchuo City",
      "kana": "しこくちゅうおうし",
      "chName": "四国中央市",
      "zhName": "四國中央市",
      "koName": "시코쿠추오 시",
      "esName": "Ciudad de Shikoku-Chūō",
      "ptName": "cidade de Shikokuchuo",
      "thName": "เมืองชิโกกุชูโอะ",
      "viName": "thành phố Shikokuchuo",
      "inName": "kota Shikokuchuo",
      "tlName": "siyudad ng Shikokuchuo",
      "moName": "Шикокүчүо хот",
      "buName": "ရှီကို့ခုကျိယို မြို့",
      "khName": "ទីក្រុង ស៊ីខូគូជូ",
      "neName": "शिकोकुच्यो सहर"
    }
  },
  "3821400": {
    "office": {
      "code": "380000",
      "name": "愛媛県",
      "enName": "Ehime",
      "officeName": "松山地方気象台",
      "chName": "爱媛县",
      "zhName": "愛媛縣",
      "koName": "에히메현",
      "esName": "Prefectura de Ehime",
      "ptName": "Província de Ehime",
      "thName": "จังหวัดเอะฮิเมะ",
      "viName": "Tỉnh Ehime",
      "inName": "Prefektur Ehime",
      "tlName": "Ehime Prefecture",
      "moName": "Эхимэ аймаг",
      "buName": "အဲသျှီမဲ့ ပြည်နယ်",
      "khName": "ខេត្ដ អេហីម",
      "neName": "एहिमे जिल्ला"
    },
    "class10": {
      "code": "380030",
      "name": "南予",
      "enName": "Nan-yo",
      "chName": "爱媛县南预",
      "zhName": "愛媛縣南予",
      "koName": "에히메현 남여",
      "esName": "Nanyo, Prefectura de Ehime",
      "ptName": "Região Nan-yo da Província de Ehime",
      "thName": "นันโยะ จังหวัดเอะฮิเมะ",
      "viName": "Nanyo, tỉnh Ehime",
      "inName": "Nanyo, Prefektur Ehime",
      "tlName": "Nanyo, Ehime Prefecture",
      "moName": "Эхимэ аймаг, Нанё",
      "buName": "နန်းယို၊ အဲဟိမဲစီရင်စု",
      "khName": "តំបន់ណាន់យោនៃខេត្ដអិហិមិ",
      "neName": "एहिमे जिल्ला, नान्यो"
    },
    "class15": {
      "code": "380031",
      "name": "南予北部",
      "enName": "Northern Nan-yo"
    },
    "class20": {
      "code": "3821400",
      "name": "西予市",
      "enName": "Seiyo City",
      "kana": "せいよし",
      "chName": "西予市",
      "zhName": "西予市",
      "koName": "세이요 시",
      "esName": "Ciudad de Seiyo",
      "ptName": "cidade de Seiyo",
      "thName": "เมืองเซโย",
      "viName": "thành phố Seiyo",
      "inName": "kota Seiyo",
      "tlName": "siyudad ng Seiyo",
      "moName": "Сэйёо хот",
      "buName": "ဆေးယို မြို့",
      "khName": "ទីក្រុង សីយ៉ូ",
      "neName": "सेइयो सहर"
    }
  },
  "3821500": {
    "office": {
      "code": "380000",
      "name": "愛媛県",
      "enName": "Ehime",
      "officeName": "松山地方気象台",
      "chName": "爱媛县",
      "zhName": "愛媛縣",
      "koName": "에히메현",
      "esName": "Prefectura de Ehime",
      "ptName": "Província de Ehime",
      "thName": "จังหวัดเอะฮิเมะ",
      "viName": "Tỉnh Ehime",
      "inName": "Prefektur Ehime",
      "tlName": "Ehime Prefecture",
      "moName": "Эхимэ аймаг",
      "buName": "အဲသျှီမဲ့ ပြည်နယ်",
      "khName": "ខេត្ដ អេហីម",
      "neName": "एहिमे जिल्ला"
    },
    "class10": {
      "code": "380010",
      "name": "中予",
      "enName": "Chuyo",
      "chName": "爱媛县中预",
      "zhName": "愛媛縣中予",
      "koName": "에히메현 중여",
      "esName": "Chuyo, Prefectura de Ehime",
      "ptName": "Região Chūyo da Província de Ehime",
      "thName": "จูโยะ จังหวัดเอะฮิเมะ",
      "viName": "Chuyo, tỉnh Ehime",
      "inName": "Chuyo, Prefektur Ehime",
      "tlName": "Chuyo, Ehime Prefecture",
      "moName": "Эхимэ аймаг, Чүё",
      "buName": "ချူးယို၊ အဲဟိမဲစီရင်စု",
      "khName": "តំបនជូយោនៃខេត្ដអិហិមិ",
      "neName": "एहिमे जिल्ला, च्युयो"
    },
    "class15": {
      "code": "380010",
      "name": "中予",
      "enName": "Chuyo"
    },
    "class20": {
      "code": "3821500",
      "name": "東温市",
      "enName": "Toon City",
      "kana": "とうおんし",
      "chName": "东温市",
      "zhName": "東溫市",
      "koName": "도온 시",
      "esName": "Ciudad de Tōon",
      "ptName": "cidade de Toon",
      "thName": "เมืองโทอง",
      "viName": "thành phố Toon",
      "inName": "kota Toon",
      "tlName": "siyudad ng Toon",
      "moName": "Тоон хот",
      "buName": "ဓူး မြို့",
      "khName": "ទីក្រុង ថូន",
      "neName": "टुन सहर"
    }
  },
  "3835600": {
    "office": {
      "code": "380000",
      "name": "愛媛県",
      "enName": "Ehime",
      "officeName": "松山地方気象台",
      "chName": "爱媛县",
      "zhName": "愛媛縣",
      "koName": "에히메현",
      "esName": "Prefectura de Ehime",
      "ptName": "Província de Ehime",
      "thName": "จังหวัดเอะฮิเมะ",
      "viName": "Tỉnh Ehime",
      "inName": "Prefektur Ehime",
      "tlName": "Ehime Prefecture",
      "moName": "Эхимэ аймаг",
      "buName": "အဲသျှီမဲ့ ပြည်နယ်",
      "khName": "ខេត្ដ អេហីម",
      "neName": "एहिमे जिल्ला"
    },
    "class10": {
      "code": "380020",
      "name": "東予",
      "enName": "Toyo",
      "chName": "爱媛县东预",
      "zhName": "愛媛縣東予",
      "koName": "에히메 현 도요",
      "esName": "Touyo, Prefectura de Ehime",
      "ptName": "Região Tōyo da Província de Ehime",
      "thName": "โทโยะ จังหวัดเอะฮิเมะ",
      "viName": "Toyo, tỉnh Ehime",
      "inName": "Toyo, Prefektur Ehime",
      "tlName": "Toyo, Ehime Prefecture",
      "moName": "Эхимэ аймаг, Тоё",
      "buName": "တိုယို၊ အဲဟိမဲစီရင်စု",
      "khName": "តំបន់តូយោនៃខេត្ដអិហិមិ",
      "neName": "एहिमे जिल्ला, तोयो"
    },
    "class15": {
      "code": "380022",
      "name": "東予西部",
      "enName": "Western Toyo"
    },
    "class20": {
      "code": "3835600",
      "name": "上島町",
      "enName": "Kamijima Town",
      "kana": "かみじまちょう",
      "chName": "上岛町",
      "zhName": "上島町",
      "koName": "가미지마 정",
      "esName": "Pueblo de Kamijima",
      "ptName": "bairro de Kamijima",
      "thName": "เมืองคามิจิมะ",
      "viName": "thị trấn Kamijima",
      "inName": "kota Kamijima",
      "tlName": "bayan ng Kamijima",
      "moName": "Камижимa жижиг хот",
      "buName": "ခါမိဂျိမ မြို့နယ်",
      "khName": "ទីប្រជុំជន កាមីជីម៉ា",
      "neName": "कामिजिमा नगर"
    }
  },
  "3838600": {
    "office": {
      "code": "380000",
      "name": "愛媛県",
      "enName": "Ehime",
      "officeName": "松山地方気象台",
      "chName": "爱媛县",
      "zhName": "愛媛縣",
      "koName": "에히메현",
      "esName": "Prefectura de Ehime",
      "ptName": "Província de Ehime",
      "thName": "จังหวัดเอะฮิเมะ",
      "viName": "Tỉnh Ehime",
      "inName": "Prefektur Ehime",
      "tlName": "Ehime Prefecture",
      "moName": "Эхимэ аймаг",
      "buName": "အဲသျှီမဲ့ ပြည်နယ်",
      "khName": "ខេត្ដ អេហីម",
      "neName": "एहिमे जिल्ला"
    },
    "class10": {
      "code": "380010",
      "name": "中予",
      "enName": "Chuyo",
      "chName": "爱媛县中预",
      "zhName": "愛媛縣中予",
      "koName": "에히메현 중여",
      "esName": "Chuyo, Prefectura de Ehime",
      "ptName": "Região Chūyo da Província de Ehime",
      "thName": "จูโยะ จังหวัดเอะฮิเมะ",
      "viName": "Chuyo, tỉnh Ehime",
      "inName": "Chuyo, Prefektur Ehime",
      "tlName": "Chuyo, Ehime Prefecture",
      "moName": "Эхимэ аймаг, Чүё",
      "buName": "ချူးယို၊ အဲဟိမဲစီရင်စု",
      "khName": "តំបនជូយោនៃខេត្ដអិហិមិ",
      "neName": "एहिमे जिल्ला, च्युयो"
    },
    "class15": {
      "code": "380010",
      "name": "中予",
      "enName": "Chuyo"
    },
    "class20": {
      "code": "3838600",
      "name": "久万高原町",
      "enName": "Kumakogen Town",
      "kana": "くまこうげんちょう",
      "chName": "久万高原町",
      "zhName": "久萬髙原町",
      "koName": "구마코겐 정",
      "esName": "Pueblo de Kumakogen",
      "ptName": "bairro de Kumakogen",
      "thName": "เมืองคุมาโคเง็น",
      "viName": "thị trấn Kumakogen",
      "inName": "kota Kumakogen",
      "tlName": "bayan ng Kumakogen",
      "moName": "Күмaкогэн жижиг хот",
      "buName": "ခူမားကို့ဂန် မြို့နယ်",
      "khName": "ទីប្រជុំជន គូម៉ាកូជេន",
      "neName": "कुमाकोगेन नगर"
    }
  },
  "3840100": {
    "office": {
      "code": "380000",
      "name": "愛媛県",
      "enName": "Ehime",
      "officeName": "松山地方気象台",
      "chName": "爱媛县",
      "zhName": "愛媛縣",
      "koName": "에히메현",
      "esName": "Prefectura de Ehime",
      "ptName": "Província de Ehime",
      "thName": "จังหวัดเอะฮิเมะ",
      "viName": "Tỉnh Ehime",
      "inName": "Prefektur Ehime",
      "tlName": "Ehime Prefecture",
      "moName": "Эхимэ аймаг",
      "buName": "အဲသျှီမဲ့ ပြည်နယ်",
      "khName": "ខេត្ដ អេហីម",
      "neName": "एहिमे जिल्ला"
    },
    "class10": {
      "code": "380010",
      "name": "中予",
      "enName": "Chuyo",
      "chName": "爱媛县中预",
      "zhName": "愛媛縣中予",
      "koName": "에히메현 중여",
      "esName": "Chuyo, Prefectura de Ehime",
      "ptName": "Região Chūyo da Província de Ehime",
      "thName": "จูโยะ จังหวัดเอะฮิเมะ",
      "viName": "Chuyo, tỉnh Ehime",
      "inName": "Chuyo, Prefektur Ehime",
      "tlName": "Chuyo, Ehime Prefecture",
      "moName": "Эхимэ аймаг, Чүё",
      "buName": "ချူးယို၊ အဲဟိမဲစီရင်စု",
      "khName": "តំបនជូយោនៃខេត្ដអិហិមិ",
      "neName": "एहिमे जिल्ला, च्युयो"
    },
    "class15": {
      "code": "380010",
      "name": "中予",
      "enName": "Chuyo"
    },
    "class20": {
      "code": "3840100",
      "name": "松前町",
      "enName": "Masaki Town",
      "kana": "まさきちょう",
      "chName": "爱媛松前町",
      "zhName": "愛媛松前町",
      "koName": "에히메 마사키 정",
      "esName": "Pueblo de Masaki, Ehime",
      "ptName": "Ehime, bairro de Masaki",
      "thName": "เมืองมัทสึมาเอะ เอะฮิเมะ",
      "viName": "Thị trấn Masaki, Ehime",
      "inName": "Kota Masaki, Ehime",
      "tlName": "bayan ng Masaki, Ehime",
      "moName": "Эхимэ Масаки жижиг хот",
      "buName": "အဲဟိမဲမဆခိမြို့နယ် ",
      "khName": "ទីប្រជុំជនម៉ាសាគិ អិហិមិ",
      "neName": "एहिमे मासाकी नगर"
    }
  },
  "3840200": {
    "office": {
      "code": "380000",
      "name": "愛媛県",
      "enName": "Ehime",
      "officeName": "松山地方気象台",
      "chName": "爱媛县",
      "zhName": "愛媛縣",
      "koName": "에히메현",
      "esName": "Prefectura de Ehime",
      "ptName": "Província de Ehime",
      "thName": "จังหวัดเอะฮิเมะ",
      "viName": "Tỉnh Ehime",
      "inName": "Prefektur Ehime",
      "tlName": "Ehime Prefecture",
      "moName": "Эхимэ аймаг",
      "buName": "အဲသျှီမဲ့ ပြည်နယ်",
      "khName": "ខេត្ដ អេហីម",
      "neName": "एहिमे जिल्ला"
    },
    "class10": {
      "code": "380010",
      "name": "中予",
      "enName": "Chuyo",
      "chName": "爱媛县中预",
      "zhName": "愛媛縣中予",
      "koName": "에히메현 중여",
      "esName": "Chuyo, Prefectura de Ehime",
      "ptName": "Região Chūyo da Província de Ehime",
      "thName": "จูโยะ จังหวัดเอะฮิเมะ",
      "viName": "Chuyo, tỉnh Ehime",
      "inName": "Chuyo, Prefektur Ehime",
      "tlName": "Chuyo, Ehime Prefecture",
      "moName": "Эхимэ аймаг, Чүё",
      "buName": "ချူးယို၊ အဲဟိမဲစီရင်စု",
      "khName": "តំបនជូយោនៃខេត្ដអិហិមិ",
      "neName": "एहिमे जिल्ला, च्युयो"
    },
    "class15": {
      "code": "380010",
      "name": "中予",
      "enName": "Chuyo"
    },
    "class20": {
      "code": "3840200",
      "name": "砥部町",
      "enName": "Tobe Town",
      "kana": "とべちょう",
      "chName": "砥部町",
      "zhName": "砥部町",
      "koName": "도베 정",
      "esName": "Pueblo de Tobe",
      "ptName": "bairro de Tobe",
      "thName": "เมืองโทเบะ",
      "viName": "thị trấn Tobe",
      "inName": "kota Tobe",
      "tlName": "bayan ng Tobe",
      "moName": "Тобэ жижиг хот",
      "buName": "တူးဗိ မြို့နယ်",
      "khName": "ទីប្រជុំជន ធូបេ",
      "neName": "तोबे नगर"
    }
  },
  "3842200": {
    "office": {
      "code": "380000",
      "name": "愛媛県",
      "enName": "Ehime",
      "officeName": "松山地方気象台",
      "chName": "爱媛县",
      "zhName": "愛媛縣",
      "koName": "에히메현",
      "esName": "Prefectura de Ehime",
      "ptName": "Província de Ehime",
      "thName": "จังหวัดเอะฮิเมะ",
      "viName": "Tỉnh Ehime",
      "inName": "Prefektur Ehime",
      "tlName": "Ehime Prefecture",
      "moName": "Эхимэ аймаг",
      "buName": "အဲသျှီမဲ့ ပြည်နယ်",
      "khName": "ខេត្ដ អេហីម",
      "neName": "एहिमे जिल्ला"
    },
    "class10": {
      "code": "380030",
      "name": "南予",
      "enName": "Nan-yo",
      "chName": "爱媛县南预",
      "zhName": "愛媛縣南予",
      "koName": "에히메현 남여",
      "esName": "Nanyo, Prefectura de Ehime",
      "ptName": "Região Nan-yo da Província de Ehime",
      "thName": "นันโยะ จังหวัดเอะฮิเมะ",
      "viName": "Nanyo, tỉnh Ehime",
      "inName": "Nanyo, Prefektur Ehime",
      "tlName": "Nanyo, Ehime Prefecture",
      "moName": "Эхимэ аймаг, Нанё",
      "buName": "နန်းယို၊ အဲဟိမဲစီရင်စု",
      "khName": "តំបន់ណាន់យោនៃខេត្ដអិហិមិ",
      "neName": "एहिमे जिल्ला, नान्यो"
    },
    "class15": {
      "code": "380031",
      "name": "南予北部",
      "enName": "Northern Nan-yo"
    },
    "class20": {
      "code": "3842200",
      "name": "内子町",
      "enName": "Uchiko Town",
      "kana": "うちこちょう",
      "chName": "内子町",
      "zhName": "內子町",
      "koName": "우치코 정",
      "esName": "Pueblo de Uchiko",
      "ptName": "bairro de Uchiko",
      "thName": "เมืองอุจิโกะ",
      "viName": "thị trấn Uchiko",
      "inName": "kota Uchiko",
      "tlName": "bayan ng Uchiko",
      "moName": "Үчико жижиг хот",
      "buName": "ယူချီကို မြို့နယ်",
      "khName": "ទីប្រជុំជន យូឈីកូ",
      "neName": "उचिको नगर"
    }
  },
  "3844200": {
    "office": {
      "code": "380000",
      "name": "愛媛県",
      "enName": "Ehime",
      "officeName": "松山地方気象台",
      "chName": "爱媛县",
      "zhName": "愛媛縣",
      "koName": "에히메현",
      "esName": "Prefectura de Ehime",
      "ptName": "Província de Ehime",
      "thName": "จังหวัดเอะฮิเมะ",
      "viName": "Tỉnh Ehime",
      "inName": "Prefektur Ehime",
      "tlName": "Ehime Prefecture",
      "moName": "Эхимэ аймаг",
      "buName": "အဲသျှီမဲ့ ပြည်နယ်",
      "khName": "ខេត្ដ អេហីម",
      "neName": "एहिमे जिल्ला"
    },
    "class10": {
      "code": "380030",
      "name": "南予",
      "enName": "Nan-yo",
      "chName": "爱媛县南预",
      "zhName": "愛媛縣南予",
      "koName": "에히메현 남여",
      "esName": "Nanyo, Prefectura de Ehime",
      "ptName": "Região Nan-yo da Província de Ehime",
      "thName": "นันโยะ จังหวัดเอะฮิเมะ",
      "viName": "Nanyo, tỉnh Ehime",
      "inName": "Nanyo, Prefektur Ehime",
      "tlName": "Nanyo, Ehime Prefecture",
      "moName": "Эхимэ аймаг, Нанё",
      "buName": "နန်းယို၊ အဲဟိမဲစီရင်စု",
      "khName": "តំបន់ណាន់យោនៃខេត្ដអិហិមិ",
      "neName": "एहिमे जिल्ला, नान्यो"
    },
    "class15": {
      "code": "380031",
      "name": "南予北部",
      "enName": "Northern Nan-yo"
    },
    "class20": {
      "code": "3844200",
      "name": "伊方町",
      "enName": "Ikata Town",
      "kana": "いかたちょう",
      "chName": "伊方町",
      "zhName": "伊方町",
      "koName": "이카타 정",
      "esName": "Pueblo de Ikata",
      "ptName": "bairro de Ikata",
      "thName": "เมืองอิคาตะ",
      "viName": "thị trấn Ikata",
      "inName": "kota Ikata",
      "tlName": "bayan ng Ikata",
      "moName": "Иката жижиг хот",
      "buName": "အိကာ့တ မြို့နယ်",
      "khName": "ទីប្រជុំជន អ៊ីកាតា",
      "neName": "इकाता नगर"
    }
  },
  "3848400": {
    "office": {
      "code": "380000",
      "name": "愛媛県",
      "enName": "Ehime",
      "officeName": "松山地方気象台",
      "chName": "爱媛县",
      "zhName": "愛媛縣",
      "koName": "에히메현",
      "esName": "Prefectura de Ehime",
      "ptName": "Província de Ehime",
      "thName": "จังหวัดเอะฮิเมะ",
      "viName": "Tỉnh Ehime",
      "inName": "Prefektur Ehime",
      "tlName": "Ehime Prefecture",
      "moName": "Эхимэ аймаг",
      "buName": "အဲသျှီမဲ့ ပြည်နယ်",
      "khName": "ខេត្ដ អេហីម",
      "neName": "एहिमे जिल्ला"
    },
    "class10": {
      "code": "380030",
      "name": "南予",
      "enName": "Nan-yo",
      "chName": "爱媛县南预",
      "zhName": "愛媛縣南予",
      "koName": "에히메현 남여",
      "esName": "Nanyo, Prefectura de Ehime",
      "ptName": "Região Nan-yo da Província de Ehime",
      "thName": "นันโยะ จังหวัดเอะฮิเมะ",
      "viName": "Nanyo, tỉnh Ehime",
      "inName": "Nanyo, Prefektur Ehime",
      "tlName": "Nanyo, Ehime Prefecture",
      "moName": "Эхимэ аймаг, Нанё",
      "buName": "နန်းယို၊ အဲဟိမဲစီရင်စု",
      "khName": "តំបន់ណាន់យោនៃខេត្ដអិហិមិ",
      "neName": "एहिमे जिल्ला, नान्यो"
    },
    "class15": {
      "code": "380032",
      "name": "南予南部",
      "enName": "Southern Nan-yo"
    },
    "class20": {
      "code": "3848400",
      "name": "松野町",
      "enName": "Matsuno Town",
      "kana": "まつのちょう",
      "chName": "松野町",
      "zhName": "松野町",
      "koName": "마쓰노 정",
      "esName": "Pueblo de Matsuno",
      "ptName": "bairro de Matsuno",
      "thName": "เมืองมัตสึโนะ",
      "viName": "thị trấn Matsuno",
      "inName": "kota Matsuno",
      "tlName": "bayan ng Matsuno",
      "moName": "Мaцүно жижиг хот",
      "buName": "မတ်ဆူနို မြို့နယ်",
      "khName": "ទីប្រជុំជន ម៉ាត់ស៊ូណូ",
      "neName": "मात्सुनो नगर"
    }
  },
  "3848800": {
    "office": {
      "code": "380000",
      "name": "愛媛県",
      "enName": "Ehime",
      "officeName": "松山地方気象台",
      "chName": "爱媛县",
      "zhName": "愛媛縣",
      "koName": "에히메현",
      "esName": "Prefectura de Ehime",
      "ptName": "Província de Ehime",
      "thName": "จังหวัดเอะฮิเมะ",
      "viName": "Tỉnh Ehime",
      "inName": "Prefektur Ehime",
      "tlName": "Ehime Prefecture",
      "moName": "Эхимэ аймаг",
      "buName": "အဲသျှီမဲ့ ပြည်နယ်",
      "khName": "ខេត្ដ អេហីម",
      "neName": "एहिमे जिल्ला"
    },
    "class10": {
      "code": "380030",
      "name": "南予",
      "enName": "Nan-yo",
      "chName": "爱媛县南预",
      "zhName": "愛媛縣南予",
      "koName": "에히메현 남여",
      "esName": "Nanyo, Prefectura de Ehime",
      "ptName": "Região Nan-yo da Província de Ehime",
      "thName": "นันโยะ จังหวัดเอะฮิเมะ",
      "viName": "Nanyo, tỉnh Ehime",
      "inName": "Nanyo, Prefektur Ehime",
      "tlName": "Nanyo, Ehime Prefecture",
      "moName": "Эхимэ аймаг, Нанё",
      "buName": "နန်းယို၊ အဲဟိမဲစီရင်စု",
      "khName": "តំបន់ណាន់យោនៃខេត្ដអិហិមិ",
      "neName": "एहिमे जिल्ला, नान्यो"
    },
    "class15": {
      "code": "380032",
      "name": "南予南部",
      "enName": "Southern Nan-yo"
    },
    "class20": {
      "code": "3848800",
      "name": "鬼北町",
      "enName": "Kihoku Town",
      "kana": "きほくちょう",
      "chName": "爱媛鬼北町",
      "zhName": "愛媛鬼北町",
      "koName": "에히메 기보쿠 정",
      "esName": "Pueblo de Kihoku, Ehime",
      "ptName": "Ehime, bairro de Kihoku",
      "thName": "เมืองคิโฮขุ เอะฮิเมะ",
      "viName": "Thị trấn Kihoku, Ehime",
      "inName": "Kota Kihoku, Ehime",
      "tlName": "bayan ng Kihoku, Ehime",
      "moName": "Эхимэ Кихокү жижиг хот",
      "buName": "အဲဟိမဲခိဟိုခုမြို့နယ် ",
      "khName": "ទីប្រជុំជនគីហុគូ អិហិមិ",
      "neName": "एहिमे किहोकु नगर"
    }
  },
  "3850600": {
    "office": {
      "code": "380000",
      "name": "愛媛県",
      "enName": "Ehime",
      "officeName": "松山地方気象台",
      "chName": "爱媛县",
      "zhName": "愛媛縣",
      "koName": "에히메현",
      "esName": "Prefectura de Ehime",
      "ptName": "Província de Ehime",
      "thName": "จังหวัดเอะฮิเมะ",
      "viName": "Tỉnh Ehime",
      "inName": "Prefektur Ehime",
      "tlName": "Ehime Prefecture",
      "moName": "Эхимэ аймаг",
      "buName": "အဲသျှီမဲ့ ပြည်နယ်",
      "khName": "ខេត្ដ អេហីម",
      "neName": "एहिमे जिल्ला"
    },
    "class10": {
      "code": "380030",
      "name": "南予",
      "enName": "Nan-yo",
      "chName": "爱媛县南预",
      "zhName": "愛媛縣南予",
      "koName": "에히메현 남여",
      "esName": "Nanyo, Prefectura de Ehime",
      "ptName": "Região Nan-yo da Província de Ehime",
      "thName": "นันโยะ จังหวัดเอะฮิเมะ",
      "viName": "Nanyo, tỉnh Ehime",
      "inName": "Nanyo, Prefektur Ehime",
      "tlName": "Nanyo, Ehime Prefecture",
      "moName": "Эхимэ аймаг, Нанё",
      "buName": "နန်းယို၊ အဲဟိမဲစီရင်စု",
      "khName": "តំបន់ណាន់យោនៃខេត្ដអិហិមិ",
      "neName": "एहिमे जिल्ला, नान्यो"
    },
    "class15": {
      "code": "380032",
      "name": "南予南部",
      "enName": "Southern Nan-yo"
    },
    "class20": {
      "code": "3850600",
      "name": "愛南町",
      "enName": "Ainan Town",
      "kana": "あいなんちょう",
      "chName": "爱南町",
      "zhName": "愛南町",
      "koName": "아이난 정",
      "esName": "Pueblo de Ainan",
      "ptName": "bairro de Ainan",
      "thName": "เมืองไอนัน",
      "viName": "thị trấn Ainan",
      "inName": "kota Ainan",
      "tlName": "bayan ng Ainan",
      "moName": "Aйнaн жижиг хот",
      "buName": "အာယိနာ့ မြို့နယ်",
      "khName": "ទីប្រជុំជន អាយណាន",
      "neName": "आइनान नगर"
    }
  },
  "3920100": {
    "office": {
      "code": "390000",
      "name": "高知県",
      "enName": "Kochi",
      "officeName": "高知地方気象台",
      "chName": "高知县",
      "zhName": "高知縣",
      "koName": "고치현",
      "esName": "Prefectura de Kochi",
      "ptName": "Província de Kōchi",
      "thName": "จังหวัดโคจิ",
      "viName": "Tỉnh Kochi",
      "inName": "Prefektur Kochi",
      "tlName": "Kochi Prefecture",
      "moName": "Кочи аймаг",
      "buName": "ခိုးကျိ ပြည်နယ်",
      "khName": "ខេត្ដ កូជី",
      "neName": "कोची जिल्ला"
    },
    "class10": {
      "code": "390010",
      "name": "中部",
      "enName": "Central Region",
      "chName": "高知县中部",
      "zhName": "高知縣中部",
      "koName": "고치 현 중부",
      "esName": "Centro de Prefectura de Kochi",
      "ptName": "Região central da Província de Kōchi",
      "thName": "จังหวัดโคจิตอนกลาง",
      "viName": "Miền Trung tỉnh Kochi",
      "inName": "Bagian Tengah Prefektur Kochi",
      "tlName": "Sentral na bahagi ng Kochi Prefecture",
      "moName": "Төв Кочи аймаг",
      "buName": "ကိုချိစီရင်စု အလယ်ပိုင်း",
      "khName": "តំបន់កណ្តាលនៃខេត្ដខូឈិ",
      "neName": "कोची जिल्लाको मध्य भाग"
    },
    "class15": {
      "code": "390011",
      "name": "高知中央",
      "enName": "Central Kochi"
    },
    "class20": {
      "code": "3920100",
      "name": "高知市",
      "enName": "Kochi City",
      "kana": "こうちし",
      "chName": "高知市",
      "zhName": "髙知市",
      "koName": "고치 시",
      "esName": "Ciudad de Kochi",
      "ptName": "cidade de Kochi",
      "thName": "เมืองโคจิ",
      "viName": "thành phố Kochi",
      "inName": "kota Kochi",
      "tlName": "siyudad ng Kochi",
      "moName": "Кочи хот",
      "buName": "ကော်ကျိ မြို့",
      "khName": "ទីក្រុង កូជី",
      "neName": "कोची सहर"
    }
  },
  "3920200": {
    "office": {
      "code": "390000",
      "name": "高知県",
      "enName": "Kochi",
      "officeName": "高知地方気象台",
      "chName": "高知县",
      "zhName": "高知縣",
      "koName": "고치현",
      "esName": "Prefectura de Kochi",
      "ptName": "Província de Kōchi",
      "thName": "จังหวัดโคจิ",
      "viName": "Tỉnh Kochi",
      "inName": "Prefektur Kochi",
      "tlName": "Kochi Prefecture",
      "moName": "Кочи аймаг",
      "buName": "ခိုးကျိ ပြည်နယ်",
      "khName": "ខេត្ដ កូជី",
      "neName": "कोची जिल्ला"
    },
    "class10": {
      "code": "390020",
      "name": "東部",
      "enName": "Eastern Region",
      "chName": "高知县东部",
      "zhName": "高知縣東部",
      "koName": "고치 현 동부",
      "esName": "Este de Prefectura de Kochi",
      "ptName": "Leste da Província de Kōchi",
      "thName": "จังหวัดโคจิฟากตะวันออก",
      "viName": "Miền Đông tỉnh Kochi",
      "inName": "Bagian Timur Prefektur Kochi",
      "tlName": "Silangang bahagi ng Kochi Prefecture",
      "moName": "Зүүн Кочи аймаг",
      "buName": "ကိုချိစီရင်စု အရှေ့ပိုင်း",
      "khName": "តំបន់ខាងកើតនៃខេត្ដខូឈិ",
      "neName": "कोची जिल्लाको पूर्वी भाग"
    },
    "class15": {
      "code": "390021",
      "name": "室戸",
      "enName": "Muroto"
    },
    "class20": {
      "code": "3920200",
      "name": "室戸市",
      "enName": "Muroto City",
      "kana": "むろとし",
      "chName": "室户市",
      "zhName": "室戶市",
      "koName": "무로토 시",
      "esName": "Ciudad de Muroto",
      "ptName": "cidade de Muroto",
      "thName": "เมืองมุโระโตะ",
      "viName": "thành phố Muroto",
      "inName": "kota Muroto",
      "tlName": "siyudad ng Muroto",
      "moName": "Мүрото хот",
      "buName": "မုရိုတို မြို့",
      "khName": "ទីក្រុង មុរ៉ូតុ",
      "neName": "मुरोता सहर"
    }
  },
  "3920300": {
    "office": {
      "code": "390000",
      "name": "高知県",
      "enName": "Kochi",
      "officeName": "高知地方気象台",
      "chName": "高知县",
      "zhName": "高知縣",
      "koName": "고치현",
      "esName": "Prefectura de Kochi",
      "ptName": "Província de Kōchi",
      "thName": "จังหวัดโคจิ",
      "viName": "Tỉnh Kochi",
      "inName": "Prefektur Kochi",
      "tlName": "Kochi Prefecture",
      "moName": "Кочи аймаг",
      "buName": "ခိုးကျိ ပြည်နယ်",
      "khName": "ខេត្ដ កូជី",
      "neName": "कोची जिल्ला"
    },
    "class10": {
      "code": "390020",
      "name": "東部",
      "enName": "Eastern Region",
      "chName": "高知县东部",
      "zhName": "高知縣東部",
      "koName": "고치 현 동부",
      "esName": "Este de Prefectura de Kochi",
      "ptName": "Leste da Província de Kōchi",
      "thName": "จังหวัดโคจิฟากตะวันออก",
      "viName": "Miền Đông tỉnh Kochi",
      "inName": "Bagian Timur Prefektur Kochi",
      "tlName": "Silangang bahagi ng Kochi Prefecture",
      "moName": "Зүүн Кочи аймаг",
      "buName": "ကိုချိစီရင်စု အရှေ့ပိုင်း",
      "khName": "តំបន់ខាងកើតនៃខេត្ដខូឈិ",
      "neName": "कोची जिल्लाको पूर्वी भाग"
    },
    "class15": {
      "code": "390022",
      "name": "安芸",
      "enName": "Aki"
    },
    "class20": {
      "code": "3920300",
      "name": "安芸市",
      "enName": "Aki City",
      "kana": "あきし",
      "chName": "安芸市",
      "zhName": "安藝市",
      "koName": "아키 시",
      "esName": "Ciudad de Aki",
      "ptName": "cidade de Aki",
      "thName": "เมืองอากิ",
      "viName": "thành phố Aki",
      "inName": "kota Aki",
      "tlName": "siyudad ng Aki",
      "moName": "Aки хот",
      "buName": "အာကိ မြို့",
      "khName": "ទីក្រុង អាគី",
      "neName": "आकी सहर"
    }
  },
  "3920400": {
    "office": {
      "code": "390000",
      "name": "高知県",
      "enName": "Kochi",
      "officeName": "高知地方気象台",
      "chName": "高知县",
      "zhName": "高知縣",
      "koName": "고치현",
      "esName": "Prefectura de Kochi",
      "ptName": "Província de Kōchi",
      "thName": "จังหวัดโคจิ",
      "viName": "Tỉnh Kochi",
      "inName": "Prefektur Kochi",
      "tlName": "Kochi Prefecture",
      "moName": "Кочи аймаг",
      "buName": "ခိုးကျိ ပြည်နယ်",
      "khName": "ខេត្ដ កូជី",
      "neName": "कोची जिल्ला"
    },
    "class10": {
      "code": "390010",
      "name": "中部",
      "enName": "Central Region",
      "chName": "高知县中部",
      "zhName": "高知縣中部",
      "koName": "고치 현 중부",
      "esName": "Centro de Prefectura de Kochi",
      "ptName": "Região central da Província de Kōchi",
      "thName": "จังหวัดโคจิตอนกลาง",
      "viName": "Miền Trung tỉnh Kochi",
      "inName": "Bagian Tengah Prefektur Kochi",
      "tlName": "Sentral na bahagi ng Kochi Prefecture",
      "moName": "Төв Кочи аймаг",
      "buName": "ကိုချိစီရင်စု အလယ်ပိုင်း",
      "khName": "តំបន់កណ្តាលនៃខេត្ដខូឈិ",
      "neName": "कोची जिल्लाको मध्य भाग"
    },
    "class15": {
      "code": "390011",
      "name": "高知中央",
      "enName": "Central Kochi"
    },
    "class20": {
      "code": "3920400",
      "name": "南国市",
      "enName": "Nankoku City",
      "kana": "なんこくし",
      "chName": "南国市",
      "zhName": "南國市",
      "koName": "난코쿠 시",
      "esName": "Ciudad de Nankoku",
      "ptName": "cidade de Nankoku",
      "thName": "เมืองนันโกกุ",
      "viName": "thành phố Nankoku",
      "inName": "kota Nankoku",
      "tlName": "siyudad ng Nankoku",
      "moName": "Нaнкокү хот",
      "buName": "နန်းကော်ကု မြို့",
      "khName": "ទីក្រុង ណាន់គូហ្គោ",
      "neName": "नानकोकु सहर"
    }
  },
  "3920500": {
    "office": {
      "code": "390000",
      "name": "高知県",
      "enName": "Kochi",
      "officeName": "高知地方気象台",
      "chName": "高知县",
      "zhName": "高知縣",
      "koName": "고치현",
      "esName": "Prefectura de Kochi",
      "ptName": "Província de Kōchi",
      "thName": "จังหวัดโคจิ",
      "viName": "Tỉnh Kochi",
      "inName": "Prefektur Kochi",
      "tlName": "Kochi Prefecture",
      "moName": "Кочи аймаг",
      "buName": "ခိုးကျိ ပြည်နယ်",
      "khName": "ខេត្ដ កូជី",
      "neName": "कोची जिल्ला"
    },
    "class10": {
      "code": "390010",
      "name": "中部",
      "enName": "Central Region",
      "chName": "高知县中部",
      "zhName": "高知縣中部",
      "koName": "고치 현 중부",
      "esName": "Centro de Prefectura de Kochi",
      "ptName": "Região central da Província de Kōchi",
      "thName": "จังหวัดโคจิตอนกลาง",
      "viName": "Miền Trung tỉnh Kochi",
      "inName": "Bagian Tengah Prefektur Kochi",
      "tlName": "Sentral na bahagi ng Kochi Prefecture",
      "moName": "Төв Кочи аймаг",
      "buName": "ကိုချိစီရင်စု အလယ်ပိုင်း",
      "khName": "តំបន់កណ្តាលនៃខេត្ដខូឈិ",
      "neName": "कोची जिल्लाको मध्य भाग"
    },
    "class15": {
      "code": "390011",
      "name": "高知中央",
      "enName": "Central Kochi"
    },
    "class20": {
      "code": "3920500",
      "name": "土佐市",
      "enName": "Tosa City",
      "kana": "とさし",
      "chName": "土佐市",
      "zhName": "土佐市",
      "koName": "도사 시",
      "esName": "Ciudad de Tosa",
      "ptName": "cidade de Tosa",
      "thName": "เมืองโทสะ (โทสะชิ)",
      "viName": "thành phố Tosa",
      "inName": "kota Tosa (Tosa-shi)",
      "tlName": "siyudad ng Tosa",
      "moName": "Тосa хот",
      "buName": "တိုးဆာ့ မြို့",
      "khName": "ទីក្រុង តូសា",
      "neName": "तोसा सहर"
    }
  },
  "3920600": {
    "office": {
      "code": "390000",
      "name": "高知県",
      "enName": "Kochi",
      "officeName": "高知地方気象台",
      "chName": "高知县",
      "zhName": "高知縣",
      "koName": "고치현",
      "esName": "Prefectura de Kochi",
      "ptName": "Província de Kōchi",
      "thName": "จังหวัดโคจิ",
      "viName": "Tỉnh Kochi",
      "inName": "Prefektur Kochi",
      "tlName": "Kochi Prefecture",
      "moName": "Кочи аймаг",
      "buName": "ခိုးကျိ ပြည်နယ်",
      "khName": "ខេត្ដ កូជី",
      "neName": "कोची जिल्ला"
    },
    "class10": {
      "code": "390010",
      "name": "中部",
      "enName": "Central Region",
      "chName": "高知县中部",
      "zhName": "高知縣中部",
      "koName": "고치 현 중부",
      "esName": "Centro de Prefectura de Kochi",
      "ptName": "Região central da Província de Kōchi",
      "thName": "จังหวัดโคจิตอนกลาง",
      "viName": "Miền Trung tỉnh Kochi",
      "inName": "Bagian Tengah Prefektur Kochi",
      "tlName": "Sentral na bahagi ng Kochi Prefecture",
      "moName": "Төв Кочи аймаг",
      "buName": "ကိုချိစီရင်စု အလယ်ပိုင်း",
      "khName": "តំបន់កណ្តាលនៃខេត្ដខូឈិ",
      "neName": "कोची जिल्लाको मध्य भाग"
    },
    "class15": {
      "code": "390011",
      "name": "高知中央",
      "enName": "Central Kochi"
    },
    "class20": {
      "code": "3920600",
      "name": "須崎市",
      "enName": "Susaki City",
      "kana": "すさきし",
      "chName": "须崎市",
      "zhName": "須崎市",
      "koName": "스사키 시",
      "esName": "Ciudad de Suzaki",
      "ptName": "cidade de Susaki",
      "thName": "เมืองสุซากิ",
      "viName": "thành phố Susaki",
      "inName": "kota Susaki",
      "tlName": "siyudad ng Susaki",
      "moName": "Сүсaки хот",
      "buName": "ဆူဆာ့ကိ မြို့",
      "khName": "ទីក្រុង ស៊ូសាគី",
      "neName": "सुसाकी सहर"
    }
  },
  "3920800": {
    "office": {
      "code": "390000",
      "name": "高知県",
      "enName": "Kochi",
      "officeName": "高知地方気象台",
      "chName": "高知县",
      "zhName": "高知縣",
      "koName": "고치현",
      "esName": "Prefectura de Kochi",
      "ptName": "Província de Kōchi",
      "thName": "จังหวัดโคจิ",
      "viName": "Tỉnh Kochi",
      "inName": "Prefektur Kochi",
      "tlName": "Kochi Prefecture",
      "moName": "Кочи аймаг",
      "buName": "ခိုးကျိ ပြည်နယ်",
      "khName": "ខេត្ដ កូជី",
      "neName": "कोची जिल्ला"
    },
    "class10": {
      "code": "390030",
      "name": "西部",
      "enName": "Western Region",
      "chName": "高知县西部",
      "zhName": "高知縣西部",
      "koName": "고치 현 서부",
      "esName": "Oeste de Prefectura de Kochi",
      "ptName": "Oeste da Província de Kōchi",
      "thName": "จังหวัดโคจิฟากตะวันตก",
      "viName": "Miền Tây tỉnh Kochi",
      "inName": "Bagian Barat Prefektur Kochi",
      "tlName": "Kanlurang bahagi ng Kochi Prefecture",
      "moName": "Баруун Кочи аймаг",
      "buName": "ကိုချိစီရင်စု အနောက်ပိုင်း",
      "khName": "តំបន់ខាងលិចនៃខេត្ដខូឈិ",
      "neName": "कोची जिल्लाको पश्चिमी भाग"
    },
    "class15": {
      "code": "390031",
      "name": "幡多",
      "enName": "Hata"
    },
    "class20": {
      "code": "3920800",
      "name": "宿毛市",
      "enName": "Sukumo City",
      "kana": "すくもし",
      "chName": "宿毛市",
      "zhName": "宿毛市",
      "koName": "스쿠모 시",
      "esName": "Ciudad de Sukumo",
      "ptName": "cidade de Sukumo",
      "thName": "เมืองซุคุโมะ",
      "viName": "thành phố Sukumo",
      "inName": "kota Sukumo",
      "tlName": "siyudad ng Sukumo",
      "moName": "Сүкүмо хот",
      "buName": "ဆူကူမို မြို့",
      "khName": "ទីក្រុង ស៊ូកូម៉ុ",
      "neName": "सुकुमो सहर"
    }
  },
  "3920900": {
    "office": {
      "code": "390000",
      "name": "高知県",
      "enName": "Kochi",
      "officeName": "高知地方気象台",
      "chName": "高知县",
      "zhName": "高知縣",
      "koName": "고치현",
      "esName": "Prefectura de Kochi",
      "ptName": "Província de Kōchi",
      "thName": "จังหวัดโคจิ",
      "viName": "Tỉnh Kochi",
      "inName": "Prefektur Kochi",
      "tlName": "Kochi Prefecture",
      "moName": "Кочи аймаг",
      "buName": "ခိုးကျိ ပြည်နယ်",
      "khName": "ខេត្ដ កូជី",
      "neName": "कोची जिल्ला"
    },
    "class10": {
      "code": "390030",
      "name": "西部",
      "enName": "Western Region",
      "chName": "高知县西部",
      "zhName": "高知縣西部",
      "koName": "고치 현 서부",
      "esName": "Oeste de Prefectura de Kochi",
      "ptName": "Oeste da Província de Kōchi",
      "thName": "จังหวัดโคจิฟากตะวันตก",
      "viName": "Miền Tây tỉnh Kochi",
      "inName": "Bagian Barat Prefektur Kochi",
      "tlName": "Kanlurang bahagi ng Kochi Prefecture",
      "moName": "Баруун Кочи аймаг",
      "buName": "ကိုချိစီရင်စု အနောက်ပိုင်း",
      "khName": "តំបន់ខាងលិចនៃខេត្ដខូឈិ",
      "neName": "कोची जिल्लाको पश्चिमी भाग"
    },
    "class15": {
      "code": "390031",
      "name": "幡多",
      "enName": "Hata"
    },
    "class20": {
      "code": "3920900",
      "name": "土佐清水市",
      "enName": "Tosashimizu City",
      "kana": "とさしみずし",
      "chName": "土佐清水市",
      "zhName": "土佐清水市",
      "koName": "도사시미즈 시",
      "esName": "Ciudad de Tosashimizu",
      "ptName": "cidade de Tosashimizu",
      "thName": "เมืองโทสะชิมิสุ",
      "viName": "thành phố Tosashimizu",
      "inName": "kota Tosashimizu",
      "tlName": "siyudad ng Tosashimizu",
      "moName": "Тозaшимизү хот",
      "buName": "တိုဆာရှိမိဇု မြို့",
      "khName": "ទីក្រុង តូសាស៊ីមីស៊ូ",
      "neName": "तोसाशिमिजु सहर"
    }
  },
  "3921000": {
    "office": {
      "code": "390000",
      "name": "高知県",
      "enName": "Kochi",
      "officeName": "高知地方気象台",
      "chName": "高知县",
      "zhName": "高知縣",
      "koName": "고치현",
      "esName": "Prefectura de Kochi",
      "ptName": "Província de Kōchi",
      "thName": "จังหวัดโคจิ",
      "viName": "Tỉnh Kochi",
      "inName": "Prefektur Kochi",
      "tlName": "Kochi Prefecture",
      "moName": "Кочи аймаг",
      "buName": "ခိုးကျိ ပြည်နယ်",
      "khName": "ខេត្ដ កូជី",
      "neName": "कोची जिल्ला"
    },
    "class10": {
      "code": "390030",
      "name": "西部",
      "enName": "Western Region",
      "chName": "高知县西部",
      "zhName": "高知縣西部",
      "koName": "고치 현 서부",
      "esName": "Oeste de Prefectura de Kochi",
      "ptName": "Oeste da Província de Kōchi",
      "thName": "จังหวัดโคจิฟากตะวันตก",
      "viName": "Miền Tây tỉnh Kochi",
      "inName": "Bagian Barat Prefektur Kochi",
      "tlName": "Kanlurang bahagi ng Kochi Prefecture",
      "moName": "Баруун Кочи аймаг",
      "buName": "ကိုချိစီရင်စု အနောက်ပိုင်း",
      "khName": "តំបន់ខាងលិចនៃខេត្ដខូឈិ",
      "neName": "कोची जिल्लाको पश्चिमी भाग"
    },
    "class15": {
      "code": "390031",
      "name": "幡多",
      "enName": "Hata"
    },
    "class20": {
      "code": "3921000",
      "name": "四万十市",
      "enName": "Shimanto City",
      "kana": "しまんとし",
      "chName": "四万十市",
      "zhName": "四萬十市",
      "koName": "시만토 시",
      "esName": "Ciudad de Shimanto",
      "ptName": "cidade de Shimanto",
      "thName": "เมืองชิมันโตะ (ชิมันโตะชิ)",
      "viName": "thành phố Shimanto",
      "inName": "Kota Shimanto (Shimanto-shi)",
      "tlName": "siyudad ng Shimanto",
      "moName": "Шимaнто хот",
      "buName": "ရှီမန်းတို မြို့",
      "khName": "ទីក្រុង ស៊ីមិនតូ",
      "neName": "शिमान्तो सहर"
    }
  },
  "3921100": {
    "office": {
      "code": "390000",
      "name": "高知県",
      "enName": "Kochi",
      "officeName": "高知地方気象台",
      "chName": "高知县",
      "zhName": "高知縣",
      "koName": "고치현",
      "esName": "Prefectura de Kochi",
      "ptName": "Província de Kōchi",
      "thName": "จังหวัดโคจิ",
      "viName": "Tỉnh Kochi",
      "inName": "Prefektur Kochi",
      "tlName": "Kochi Prefecture",
      "moName": "Кочи аймаг",
      "buName": "ခိုးကျိ ပြည်နယ်",
      "khName": "ខេត្ដ កូជី",
      "neName": "कोची जिल्ला"
    },
    "class10": {
      "code": "390010",
      "name": "中部",
      "enName": "Central Region",
      "chName": "高知县中部",
      "zhName": "高知縣中部",
      "koName": "고치 현 중부",
      "esName": "Centro de Prefectura de Kochi",
      "ptName": "Região central da Província de Kōchi",
      "thName": "จังหวัดโคจิตอนกลาง",
      "viName": "Miền Trung tỉnh Kochi",
      "inName": "Bagian Tengah Prefektur Kochi",
      "tlName": "Sentral na bahagi ng Kochi Prefecture",
      "moName": "Төв Кочи аймаг",
      "buName": "ကိုချိစီရင်စု အလယ်ပိုင်း",
      "khName": "តំបន់កណ្តាលនៃខេត្ដខូឈិ",
      "neName": "कोची जिल्लाको मध्य भाग"
    },
    "class15": {
      "code": "390011",
      "name": "高知中央",
      "enName": "Central Kochi"
    },
    "class20": {
      "code": "3921100",
      "name": "香南市",
      "enName": "Konan City",
      "kana": "こうなんし",
      "chName": "高知香南市",
      "zhName": "高知香南市",
      "koName": "고치 고난 시",
      "esName": "Ciudad de Konan, Kochi",
      "ptName": "Kochi, cidade de Konan ",
      "thName": "เมืองโคนัน โคจิ",
      "viName": "Thành phố Konan, Kochi",
      "inName": "Kota Konan, Kochi",
      "tlName": "siyudad ng Konan, Kochi",
      "moName": "Кочи Конан хот",
      "buName": "ကိုးချိကိုးနန်းမြို့",
      "khName": "ទីក្រុងខូណាន ខូឈិ",
      "neName": "कोची कोनान सहर"
    }
  },
  "3921200": {
    "office": {
      "code": "390000",
      "name": "高知県",
      "enName": "Kochi",
      "officeName": "高知地方気象台",
      "chName": "高知县",
      "zhName": "高知縣",
      "koName": "고치현",
      "esName": "Prefectura de Kochi",
      "ptName": "Província de Kōchi",
      "thName": "จังหวัดโคจิ",
      "viName": "Tỉnh Kochi",
      "inName": "Prefektur Kochi",
      "tlName": "Kochi Prefecture",
      "moName": "Кочи аймаг",
      "buName": "ခိုးကျိ ပြည်နယ်",
      "khName": "ខេត្ដ កូជី",
      "neName": "कोची जिल्ला"
    },
    "class10": {
      "code": "390010",
      "name": "中部",
      "enName": "Central Region",
      "chName": "高知县中部",
      "zhName": "高知縣中部",
      "koName": "고치 현 중부",
      "esName": "Centro de Prefectura de Kochi",
      "ptName": "Região central da Província de Kōchi",
      "thName": "จังหวัดโคจิตอนกลาง",
      "viName": "Miền Trung tỉnh Kochi",
      "inName": "Bagian Tengah Prefektur Kochi",
      "tlName": "Sentral na bahagi ng Kochi Prefecture",
      "moName": "Төв Кочи аймаг",
      "buName": "ကိုချိစီရင်စု အလယ်ပိုင်း",
      "khName": "តំបន់កណ្តាលនៃខេត្ដខូឈិ",
      "neName": "कोची जिल्लाको मध्य भाग"
    },
    "class15": {
      "code": "390011",
      "name": "高知中央",
      "enName": "Central Kochi"
    },
    "class20": {
      "code": "3921200",
      "name": "香美市",
      "enName": "Kami City",
      "kana": "かみし",
      "chName": "香美市",
      "zhName": "香美市",
      "koName": "가미 시",
      "esName": "Ciudad de Kami",
      "ptName": "cidade de Kami",
      "thName": "เมืองคามิ",
      "viName": "thành phố Kami",
      "inName": "kota Kami",
      "tlName": "siyudad ng Kami",
      "moName": "Ками хот",
      "buName": "ခါမိ မြို့",
      "khName": "ទីក្រុង កាមី",
      "neName": "कामी सहर"
    }
  },
  "3930100": {
    "office": {
      "code": "390000",
      "name": "高知県",
      "enName": "Kochi",
      "officeName": "高知地方気象台",
      "chName": "高知县",
      "zhName": "高知縣",
      "koName": "고치현",
      "esName": "Prefectura de Kochi",
      "ptName": "Província de Kōchi",
      "thName": "จังหวัดโคจิ",
      "viName": "Tỉnh Kochi",
      "inName": "Prefektur Kochi",
      "tlName": "Kochi Prefecture",
      "moName": "Кочи аймаг",
      "buName": "ခိုးကျိ ပြည်နယ်",
      "khName": "ខេត្ដ កូជី",
      "neName": "कोची जिल्ला"
    },
    "class10": {
      "code": "390020",
      "name": "東部",
      "enName": "Eastern Region",
      "chName": "高知县东部",
      "zhName": "高知縣東部",
      "koName": "고치 현 동부",
      "esName": "Este de Prefectura de Kochi",
      "ptName": "Leste da Província de Kōchi",
      "thName": "จังหวัดโคจิฟากตะวันออก",
      "viName": "Miền Đông tỉnh Kochi",
      "inName": "Bagian Timur Prefektur Kochi",
      "tlName": "Silangang bahagi ng Kochi Prefecture",
      "moName": "Зүүн Кочи аймаг",
      "buName": "ကိုချိစီရင်စု အရှေ့ပိုင်း",
      "khName": "តំបន់ខាងកើតនៃខេត្ដខូឈិ",
      "neName": "कोची जिल्लाको पूर्वी भाग"
    },
    "class15": {
      "code": "390021",
      "name": "室戸",
      "enName": "Muroto"
    },
    "class20": {
      "code": "3930100",
      "name": "東洋町",
      "enName": "Toyo Town",
      "kana": "とうようちょう",
      "chName": "东洋町",
      "zhName": "東洋町",
      "koName": "도요 정",
      "esName": "Pueblo de Toyo",
      "ptName": "bairro de Toyo",
      "thName": "เมืองโทโยะ",
      "viName": "thị trấn Toyo",
      "inName": "kota Toyo",
      "tlName": "bayan ng Toyo",
      "moName": "Тоёо жижиг хот",
      "buName": "တိုယို မြို့နယ်",
      "khName": "ទីប្រជុំជន តូយ៉ូ",
      "neName": "तोयो नगर"
    }
  },
  "3930200": {
    "office": {
      "code": "390000",
      "name": "高知県",
      "enName": "Kochi",
      "officeName": "高知地方気象台",
      "chName": "高知县",
      "zhName": "高知縣",
      "koName": "고치현",
      "esName": "Prefectura de Kochi",
      "ptName": "Província de Kōchi",
      "thName": "จังหวัดโคจิ",
      "viName": "Tỉnh Kochi",
      "inName": "Prefektur Kochi",
      "tlName": "Kochi Prefecture",
      "moName": "Кочи аймаг",
      "buName": "ခိုးကျိ ပြည်နယ်",
      "khName": "ខេត្ដ កូជី",
      "neName": "कोची जिल्ला"
    },
    "class10": {
      "code": "390020",
      "name": "東部",
      "enName": "Eastern Region",
      "chName": "高知县东部",
      "zhName": "高知縣東部",
      "koName": "고치 현 동부",
      "esName": "Este de Prefectura de Kochi",
      "ptName": "Leste da Província de Kōchi",
      "thName": "จังหวัดโคจิฟากตะวันออก",
      "viName": "Miền Đông tỉnh Kochi",
      "inName": "Bagian Timur Prefektur Kochi",
      "tlName": "Silangang bahagi ng Kochi Prefecture",
      "moName": "Зүүн Кочи аймаг",
      "buName": "ကိုချိစီရင်စု အရှေ့ပိုင်း",
      "khName": "តំបន់ខាងកើតនៃខេត្ដខូឈិ",
      "neName": "कोची जिल्लाको पूर्वी भाग"
    },
    "class15": {
      "code": "390022",
      "name": "安芸",
      "enName": "Aki"
    },
    "class20": {
      "code": "3930200",
      "name": "奈半利町",
      "enName": "Nahari Town",
      "kana": "なはりちょう",
      "chName": "奈半利町",
      "zhName": "奈半利町",
      "koName": "나하리 정",
      "esName": "Pueblo de Nahari",
      "ptName": "bairro de Nahari",
      "thName": "เมืองนาฮิริ",
      "viName": "thị trấn Nahari",
      "inName": "kota Nahari",
      "tlName": "bayan ng Nahari",
      "moName": "Нaхaри жижиг хот",
      "buName": "နာဟားရိ မြို့နယ်",
      "khName": "ទីប្រជុំជន ណាហារី",
      "neName": "नाहारी नगर"
    }
  },
  "3930300": {
    "office": {
      "code": "390000",
      "name": "高知県",
      "enName": "Kochi",
      "officeName": "高知地方気象台",
      "chName": "高知县",
      "zhName": "高知縣",
      "koName": "고치현",
      "esName": "Prefectura de Kochi",
      "ptName": "Província de Kōchi",
      "thName": "จังหวัดโคจิ",
      "viName": "Tỉnh Kochi",
      "inName": "Prefektur Kochi",
      "tlName": "Kochi Prefecture",
      "moName": "Кочи аймаг",
      "buName": "ခိုးကျိ ပြည်နယ်",
      "khName": "ខេត្ដ កូជី",
      "neName": "कोची जिल्ला"
    },
    "class10": {
      "code": "390020",
      "name": "東部",
      "enName": "Eastern Region",
      "chName": "高知县东部",
      "zhName": "高知縣東部",
      "koName": "고치 현 동부",
      "esName": "Este de Prefectura de Kochi",
      "ptName": "Leste da Província de Kōchi",
      "thName": "จังหวัดโคจิฟากตะวันออก",
      "viName": "Miền Đông tỉnh Kochi",
      "inName": "Bagian Timur Prefektur Kochi",
      "tlName": "Silangang bahagi ng Kochi Prefecture",
      "moName": "Зүүн Кочи аймаг",
      "buName": "ကိုချိစီရင်စု အရှေ့ပိုင်း",
      "khName": "តំបន់ខាងកើតនៃខេត្ដខូឈិ",
      "neName": "कोची जिल्लाको पूर्वी भाग"
    },
    "class15": {
      "code": "390022",
      "name": "安芸",
      "enName": "Aki"
    },
    "class20": {
      "code": "3930300",
      "name": "田野町",
      "enName": "Tano Town",
      "kana": "たのちょう",
      "chName": "田野町",
      "zhName": "田野町",
      "koName": "다노 정",
      "esName": "Pueblo de Tano",
      "ptName": "bairro de Tano",
      "thName": "เมืองทาโนะ",
      "viName": "thị trấn Tano",
      "inName": "kota Tano",
      "tlName": "bayan ng Tano",
      "moName": "Тано жижиг хот",
      "buName": "တာနို မြို့နယ်",
      "khName": "ទីប្រជុំជន តាណូ",
      "neName": "तानो नगर"
    }
  },
  "3930400": {
    "office": {
      "code": "390000",
      "name": "高知県",
      "enName": "Kochi",
      "officeName": "高知地方気象台",
      "chName": "高知县",
      "zhName": "高知縣",
      "koName": "고치현",
      "esName": "Prefectura de Kochi",
      "ptName": "Província de Kōchi",
      "thName": "จังหวัดโคจิ",
      "viName": "Tỉnh Kochi",
      "inName": "Prefektur Kochi",
      "tlName": "Kochi Prefecture",
      "moName": "Кочи аймаг",
      "buName": "ခိုးကျိ ပြည်နယ်",
      "khName": "ខេត្ដ កូជី",
      "neName": "कोची जिल्ला"
    },
    "class10": {
      "code": "390020",
      "name": "東部",
      "enName": "Eastern Region",
      "chName": "高知县东部",
      "zhName": "高知縣東部",
      "koName": "고치 현 동부",
      "esName": "Este de Prefectura de Kochi",
      "ptName": "Leste da Província de Kōchi",
      "thName": "จังหวัดโคจิฟากตะวันออก",
      "viName": "Miền Đông tỉnh Kochi",
      "inName": "Bagian Timur Prefektur Kochi",
      "tlName": "Silangang bahagi ng Kochi Prefecture",
      "moName": "Зүүн Кочи аймаг",
      "buName": "ကိုချိစီရင်စု အရှေ့ပိုင်း",
      "khName": "តំបន់ខាងកើតនៃខេត្ដខូឈិ",
      "neName": "कोची जिल्लाको पूर्वी भाग"
    },
    "class15": {
      "code": "390022",
      "name": "安芸",
      "enName": "Aki"
    },
    "class20": {
      "code": "3930400",
      "name": "安田町",
      "enName": "Yasuda Town",
      "kana": "やすだちょう",
      "chName": "安田町",
      "zhName": "安田町",
      "koName": "야스다 정",
      "esName": "Pueblo de Yasuda",
      "ptName": "bairro de Yasuda",
      "thName": "เมืองยาสุดะ",
      "viName": "thị trấn Yasuda",
      "inName": "kota Yasuda",
      "tlName": "bayan ng Yasuda",
      "moName": "Ясүда жижиг хот",
      "buName": "ယာဆုဒ မြို့နယ်",
      "khName": "ទីប្រជុំជន យ៉ាស៊ូដា",
      "neName": "यासुदा नगर"
    }
  },
  "3930500": {
    "office": {
      "code": "390000",
      "name": "高知県",
      "enName": "Kochi",
      "officeName": "高知地方気象台",
      "chName": "高知县",
      "zhName": "高知縣",
      "koName": "고치현",
      "esName": "Prefectura de Kochi",
      "ptName": "Província de Kōchi",
      "thName": "จังหวัดโคจิ",
      "viName": "Tỉnh Kochi",
      "inName": "Prefektur Kochi",
      "tlName": "Kochi Prefecture",
      "moName": "Кочи аймаг",
      "buName": "ခိုးကျိ ပြည်နယ်",
      "khName": "ខេត្ដ កូជី",
      "neName": "कोची जिल्ला"
    },
    "class10": {
      "code": "390020",
      "name": "東部",
      "enName": "Eastern Region",
      "chName": "高知县东部",
      "zhName": "高知縣東部",
      "koName": "고치 현 동부",
      "esName": "Este de Prefectura de Kochi",
      "ptName": "Leste da Província de Kōchi",
      "thName": "จังหวัดโคจิฟากตะวันออก",
      "viName": "Miền Đông tỉnh Kochi",
      "inName": "Bagian Timur Prefektur Kochi",
      "tlName": "Silangang bahagi ng Kochi Prefecture",
      "moName": "Зүүн Кочи аймаг",
      "buName": "ကိုချိစီရင်စု အရှေ့ပိုင်း",
      "khName": "តំបន់ខាងកើតនៃខេត្ដខូឈិ",
      "neName": "कोची जिल्लाको पूर्वी भाग"
    },
    "class15": {
      "code": "390022",
      "name": "安芸",
      "enName": "Aki"
    },
    "class20": {
      "code": "3930500",
      "name": "北川村",
      "enName": "Kitagawa Village",
      "kana": "きたがわむら",
      "chName": "北川村",
      "zhName": "北川村",
      "koName": "기타가와 촌",
      "esName": "Pueblo de Kitagawa",
      "ptName": "povoado de Kitagawa",
      "thName": "หมู่บ้านคิตะงาวะ",
      "viName": "làng Kitagawa",
      "inName": "desa Kitagawa",
      "tlName": "nayon ng Kitagawa",
      "moName": "Китагава тосгон",
      "buName": "ခီတာဂါ့ဝ ကျေးရွာ",
      "khName": "ភូមិ គីតាហ្គាវ៉ា",
      "neName": "कितागावा गाउँ"
    }
  },
  "3930600": {
    "office": {
      "code": "390000",
      "name": "高知県",
      "enName": "Kochi",
      "officeName": "高知地方気象台",
      "chName": "高知县",
      "zhName": "高知縣",
      "koName": "고치현",
      "esName": "Prefectura de Kochi",
      "ptName": "Província de Kōchi",
      "thName": "จังหวัดโคจิ",
      "viName": "Tỉnh Kochi",
      "inName": "Prefektur Kochi",
      "tlName": "Kochi Prefecture",
      "moName": "Кочи аймаг",
      "buName": "ခိုးကျိ ပြည်နယ်",
      "khName": "ខេត្ដ កូជី",
      "neName": "कोची जिल्ला"
    },
    "class10": {
      "code": "390020",
      "name": "東部",
      "enName": "Eastern Region",
      "chName": "高知县东部",
      "zhName": "高知縣東部",
      "koName": "고치 현 동부",
      "esName": "Este de Prefectura de Kochi",
      "ptName": "Leste da Província de Kōchi",
      "thName": "จังหวัดโคจิฟากตะวันออก",
      "viName": "Miền Đông tỉnh Kochi",
      "inName": "Bagian Timur Prefektur Kochi",
      "tlName": "Silangang bahagi ng Kochi Prefecture",
      "moName": "Зүүн Кочи аймаг",
      "buName": "ကိုချိစီရင်စု အရှေ့ပိုင်း",
      "khName": "តំបន់ខាងកើតនៃខេត្ដខូឈិ",
      "neName": "कोची जिल्लाको पूर्वी भाग"
    },
    "class15": {
      "code": "390022",
      "name": "安芸",
      "enName": "Aki"
    },
    "class20": {
      "code": "3930600",
      "name": "馬路村",
      "enName": "Umaji Village",
      "kana": "うまじむら",
      "chName": "马路村",
      "zhName": "馬路村",
      "koName": "우마지 촌",
      "esName": "Aldea de Umaji",
      "ptName": "povoado de Umaji",
      "thName": "หมู่บ้านอุมาจิ",
      "viName": "làng Umaji",
      "inName": "desa Umaji",
      "tlName": "nayon ng Umaji",
      "moName": "Үмaжи тосгон",
      "buName": "ဥမာဂျိ ကျေးရွာ",
      "khName": "ភូមិ អ៊ូម៉ាជី",
      "neName": "उमाजी गाउँ"
    }
  },
  "3930700": {
    "office": {
      "code": "390000",
      "name": "高知県",
      "enName": "Kochi",
      "officeName": "高知地方気象台",
      "chName": "高知县",
      "zhName": "高知縣",
      "koName": "고치현",
      "esName": "Prefectura de Kochi",
      "ptName": "Província de Kōchi",
      "thName": "จังหวัดโคจิ",
      "viName": "Tỉnh Kochi",
      "inName": "Prefektur Kochi",
      "tlName": "Kochi Prefecture",
      "moName": "Кочи аймаг",
      "buName": "ခိုးကျိ ပြည်နယ်",
      "khName": "ខេត្ដ កូជី",
      "neName": "कोची जिल्ला"
    },
    "class10": {
      "code": "390020",
      "name": "東部",
      "enName": "Eastern Region",
      "chName": "高知县东部",
      "zhName": "高知縣東部",
      "koName": "고치 현 동부",
      "esName": "Este de Prefectura de Kochi",
      "ptName": "Leste da Província de Kōchi",
      "thName": "จังหวัดโคจิฟากตะวันออก",
      "viName": "Miền Đông tỉnh Kochi",
      "inName": "Bagian Timur Prefektur Kochi",
      "tlName": "Silangang bahagi ng Kochi Prefecture",
      "moName": "Зүүн Кочи аймаг",
      "buName": "ကိုချိစီရင်စု အရှေ့ပိုင်း",
      "khName": "តំបន់ខាងកើតនៃខេត្ដខូឈិ",
      "neName": "कोची जिल्लाको पूर्वी भाग"
    },
    "class15": {
      "code": "390022",
      "name": "安芸",
      "enName": "Aki"
    },
    "class20": {
      "code": "3930700",
      "name": "芸西村",
      "enName": "Geisei Village",
      "kana": "げいせいむら",
      "chName": "芸西村",
      "zhName": "藝西村",
      "koName": "게이세이 촌",
      "esName": "Aldea de Geisei",
      "ptName": "povoado de Geisei",
      "thName": "หมู่บ้านเกเซ",
      "viName": "làng Geisei",
      "inName": "desa Geisei",
      "tlName": "nayon ng Geisei",
      "moName": "Гэйсэй тосгон",
      "buName": "ဂေးယိဆဲယိ ကျေးရွာ",
      "khName": "ភូមិ ជីសី",
      "neName": "गेइसेई गाउँ"
    }
  },
  "3934100": {
    "office": {
      "code": "390000",
      "name": "高知県",
      "enName": "Kochi",
      "officeName": "高知地方気象台",
      "chName": "高知县",
      "zhName": "高知縣",
      "koName": "고치현",
      "esName": "Prefectura de Kochi",
      "ptName": "Província de Kōchi",
      "thName": "จังหวัดโคจิ",
      "viName": "Tỉnh Kochi",
      "inName": "Prefektur Kochi",
      "tlName": "Kochi Prefecture",
      "moName": "Кочи аймаг",
      "buName": "ခိုးကျိ ပြည်နယ်",
      "khName": "ខេត្ដ កូជី",
      "neName": "कोची जिल्ला"
    },
    "class10": {
      "code": "390010",
      "name": "中部",
      "enName": "Central Region",
      "chName": "高知县中部",
      "zhName": "高知縣中部",
      "koName": "고치 현 중부",
      "esName": "Centro de Prefectura de Kochi",
      "ptName": "Região central da Província de Kōchi",
      "thName": "จังหวัดโคจิตอนกลาง",
      "viName": "Miền Trung tỉnh Kochi",
      "inName": "Bagian Tengah Prefektur Kochi",
      "tlName": "Sentral na bahagi ng Kochi Prefecture",
      "moName": "Төв Кочи аймаг",
      "buName": "ကိုချိစီရင်စု အလယ်ပိုင်း",
      "khName": "តំបន់កណ្តាលនៃខេត្ដខូឈិ",
      "neName": "कोची जिल्लाको मध्य भाग"
    },
    "class15": {
      "code": "390012",
      "name": "嶺北",
      "enName": "Reihoku"
    },
    "class20": {
      "code": "3934100",
      "name": "本山町",
      "enName": "Motoyama Town",
      "kana": "もとやまちょう",
      "chName": "本山町",
      "zhName": "本山町",
      "koName": "모토야마 정",
      "esName": "Pueblo de Motoyama",
      "ptName": "bairro de Motoyama",
      "thName": "เมืองโมโตยามะ",
      "viName": "thị trấn Motoyama",
      "inName": "kota Motoyama",
      "tlName": "bayan ng Motoyama",
      "moName": "Мотоямa жижиг хот",
      "buName": "မိုတိုယာ့မ မြို့နယ်",
      "khName": "ទីប្រជុំជន ម៉ូតូយ៉ាម៉ា",
      "neName": "मोतोयामा नगर"
    }
  },
  "3934400": {
    "office": {
      "code": "390000",
      "name": "高知県",
      "enName": "Kochi",
      "officeName": "高知地方気象台",
      "chName": "高知县",
      "zhName": "高知縣",
      "koName": "고치현",
      "esName": "Prefectura de Kochi",
      "ptName": "Província de Kōchi",
      "thName": "จังหวัดโคจิ",
      "viName": "Tỉnh Kochi",
      "inName": "Prefektur Kochi",
      "tlName": "Kochi Prefecture",
      "moName": "Кочи аймаг",
      "buName": "ခိုးကျိ ပြည်နယ်",
      "khName": "ខេត្ដ កូជី",
      "neName": "कोची जिल्ला"
    },
    "class10": {
      "code": "390010",
      "name": "中部",
      "enName": "Central Region",
      "chName": "高知县中部",
      "zhName": "高知縣中部",
      "koName": "고치 현 중부",
      "esName": "Centro de Prefectura de Kochi",
      "ptName": "Região central da Província de Kōchi",
      "thName": "จังหวัดโคจิตอนกลาง",
      "viName": "Miền Trung tỉnh Kochi",
      "inName": "Bagian Tengah Prefektur Kochi",
      "tlName": "Sentral na bahagi ng Kochi Prefecture",
      "moName": "Төв Кочи аймаг",
      "buName": "ကိုချိစီရင်စု အလယ်ပိုင်း",
      "khName": "តំបន់កណ្តាលនៃខេត្ដខូឈិ",
      "neName": "कोची जिल्लाको मध्य भाग"
    },
    "class15": {
      "code": "390012",
      "name": "嶺北",
      "enName": "Reihoku"
    },
    "class20": {
      "code": "3934400",
      "name": "大豊町",
      "enName": "Otoyo Town",
      "kana": "おおとよちょう",
      "chName": "大丰町",
      "zhName": "大豐町",
      "koName": "오토요 정",
      "esName": "Pueblo de Otoyo",
      "ptName": "bairro de Otoyo",
      "thName": "เมืองโอโตยะ",
      "viName": "thị trấn Otoyo",
      "inName": "kota Otoyo",
      "tlName": "bayan ng Otoyo",
      "moName": "Отоёо жижиг хот",
      "buName": "အို့တိုးယို မြို့နယ်",
      "khName": "ទីប្រជុំជន អូតូយ៉ូ",
      "neName": "ओतोयो नगर"
    }
  },
  "3936300": {
    "office": {
      "code": "390000",
      "name": "高知県",
      "enName": "Kochi",
      "officeName": "高知地方気象台",
      "chName": "高知县",
      "zhName": "高知縣",
      "koName": "고치현",
      "esName": "Prefectura de Kochi",
      "ptName": "Província de Kōchi",
      "thName": "จังหวัดโคจิ",
      "viName": "Tỉnh Kochi",
      "inName": "Prefektur Kochi",
      "tlName": "Kochi Prefecture",
      "moName": "Кочи аймаг",
      "buName": "ခိုးကျိ ပြည်နယ်",
      "khName": "ខេត្ដ កូជី",
      "neName": "कोची जिल्ला"
    },
    "class10": {
      "code": "390010",
      "name": "中部",
      "enName": "Central Region",
      "chName": "高知县中部",
      "zhName": "高知縣中部",
      "koName": "고치 현 중부",
      "esName": "Centro de Prefectura de Kochi",
      "ptName": "Região central da Província de Kōchi",
      "thName": "จังหวัดโคจิตอนกลาง",
      "viName": "Miền Trung tỉnh Kochi",
      "inName": "Bagian Tengah Prefektur Kochi",
      "tlName": "Sentral na bahagi ng Kochi Prefecture",
      "moName": "Төв Кочи аймаг",
      "buName": "ကိုချိစီရင်စု အလယ်ပိုင်း",
      "khName": "តំបន់កណ្តាលនៃខេត្ដខូឈិ",
      "neName": "कोची जिल्लाको मध्य भाग"
    },
    "class15": {
      "code": "390012",
      "name": "嶺北",
      "enName": "Reihoku"
    },
    "class20": {
      "code": "3936300",
      "name": "土佐町",
      "enName": "Tosa Town",
      "kana": "とさちょう",
      "chName": "土佐町",
      "zhName": "土佐町",
      "koName": "도사 정",
      "esName": "Pueblo de Tosa",
      "ptName": "bairro de Tosa",
      "thName": "เมืองโทสะ (โทสะโจ)",
      "viName": "thị trấn Tosa",
      "inName": "kota Tosa (Tosa-chō)",
      "tlName": "bayan ng Tosa",
      "moName": "Тосa жижиг хот",
      "buName": "တိုဆာ မြို့နယ်",
      "khName": "ទីប្រជុំជន ថូសា",
      "neName": "तोसा नगर"
    }
  },
  "3936400": {
    "office": {
      "code": "390000",
      "name": "高知県",
      "enName": "Kochi",
      "officeName": "高知地方気象台",
      "chName": "高知县",
      "zhName": "高知縣",
      "koName": "고치현",
      "esName": "Prefectura de Kochi",
      "ptName": "Província de Kōchi",
      "thName": "จังหวัดโคจิ",
      "viName": "Tỉnh Kochi",
      "inName": "Prefektur Kochi",
      "tlName": "Kochi Prefecture",
      "moName": "Кочи аймаг",
      "buName": "ခိုးကျိ ပြည်နယ်",
      "khName": "ខេត្ដ កូជី",
      "neName": "कोची जिल्ला"
    },
    "class10": {
      "code": "390010",
      "name": "中部",
      "enName": "Central Region",
      "chName": "高知县中部",
      "zhName": "高知縣中部",
      "koName": "고치 현 중부",
      "esName": "Centro de Prefectura de Kochi",
      "ptName": "Região central da Província de Kōchi",
      "thName": "จังหวัดโคจิตอนกลาง",
      "viName": "Miền Trung tỉnh Kochi",
      "inName": "Bagian Tengah Prefektur Kochi",
      "tlName": "Sentral na bahagi ng Kochi Prefecture",
      "moName": "Төв Кочи аймаг",
      "buName": "ကိုချိစီရင်စု အလယ်ပိုင်း",
      "khName": "តំបន់កណ្តាលនៃខេត្ដខូឈិ",
      "neName": "कोची जिल्लाको मध्य भाग"
    },
    "class15": {
      "code": "390012",
      "name": "嶺北",
      "enName": "Reihoku"
    },
    "class20": {
      "code": "3936400",
      "name": "大川村",
      "enName": "Okawa Village",
      "kana": "おおかわむら",
      "chName": "大川村",
      "zhName": "大川村",
      "koName": "오카와 촌",
      "esName": "Aldea de Ōkawa",
      "ptName": "povoado de Okawa",
      "thName": "หมู่บ้านโอคาวะ",
      "viName": "làng Okawa",
      "inName": "desa Okawa",
      "tlName": "nayon ng Okawa",
      "moName": "Окава тосгон",
      "buName": "အိုကာ့ဝ မကျးရွာ",
      "khName": "ភូមិ អូកាវ៉ា",
      "neName": "ओकावा गाउँ"
    }
  },
  "3938600": {
    "office": {
      "code": "390000",
      "name": "高知県",
      "enName": "Kochi",
      "officeName": "高知地方気象台",
      "chName": "高知县",
      "zhName": "高知縣",
      "koName": "고치현",
      "esName": "Prefectura de Kochi",
      "ptName": "Província de Kōchi",
      "thName": "จังหวัดโคจิ",
      "viName": "Tỉnh Kochi",
      "inName": "Prefektur Kochi",
      "tlName": "Kochi Prefecture",
      "moName": "Кочи аймаг",
      "buName": "ခိုးကျိ ပြည်နယ်",
      "khName": "ខេត្ដ កូជី",
      "neName": "कोची जिल्ला"
    },
    "class10": {
      "code": "390010",
      "name": "中部",
      "enName": "Central Region",
      "chName": "高知县中部",
      "zhName": "高知縣中部",
      "koName": "고치 현 중부",
      "esName": "Centro de Prefectura de Kochi",
      "ptName": "Região central da Província de Kōchi",
      "thName": "จังหวัดโคจิตอนกลาง",
      "viName": "Miền Trung tỉnh Kochi",
      "inName": "Bagian Tengah Prefektur Kochi",
      "tlName": "Sentral na bahagi ng Kochi Prefecture",
      "moName": "Төв Кочи аймаг",
      "buName": "ကိုချိစီရင်စု အလယ်ပိုင်း",
      "khName": "តំបន់កណ្តាលនៃខេត្ដខូឈិ",
      "neName": "कोची जिल्लाको मध्य भाग"
    },
    "class15": {
      "code": "390011",
      "name": "高知中央",
      "enName": "Central Kochi"
    },
    "class20": {
      "code": "3938600",
      "name": "いの町",
      "enName": "Ino Town",
      "kana": "いのちょう",
      "chName": "伊野町",
      "zhName": "伊野町",
      "koName": "이노 정",
      "esName": "Pueblo de Ino",
      "ptName": "bairro de Ino",
      "thName": "เมืองอิโนะ",
      "viName": "thị trấn Ino",
      "inName": "kota Ino",
      "tlName": "bayan ng Ino",
      "moName": "Ино жижиг хот",
      "buName": "အီနို မြို့နယ်",
      "khName": "ទីប្រជុំជន អ៊ីណូ​​",
      "neName": "इनो नगर"
    }
  },
  "3938700": {
    "office": {
      "code": "390000",
      "name": "高知県",
      "enName": "Kochi",
      "officeName": "高知地方気象台",
      "chName": "高知县",
      "zhName": "高知縣",
      "koName": "고치현",
      "esName": "Prefectura de Kochi",
      "ptName": "Província de Kōchi",
      "thName": "จังหวัดโคจิ",
      "viName": "Tỉnh Kochi",
      "inName": "Prefektur Kochi",
      "tlName": "Kochi Prefecture",
      "moName": "Кочи аймаг",
      "buName": "ခိုးကျိ ပြည်နယ်",
      "khName": "ខេត្ដ កូជី",
      "neName": "कोची जिल्ला"
    },
    "class10": {
      "code": "390010",
      "name": "中部",
      "enName": "Central Region",
      "chName": "高知县中部",
      "zhName": "高知縣中部",
      "koName": "고치 현 중부",
      "esName": "Centro de Prefectura de Kochi",
      "ptName": "Região central da Província de Kōchi",
      "thName": "จังหวัดโคจิตอนกลาง",
      "viName": "Miền Trung tỉnh Kochi",
      "inName": "Bagian Tengah Prefektur Kochi",
      "tlName": "Sentral na bahagi ng Kochi Prefecture",
      "moName": "Төв Кочи аймаг",
      "buName": "ကိုချိစီရင်စု အလယ်ပိုင်း",
      "khName": "តំបន់កណ្តាលនៃខេត្ដខូឈិ",
      "neName": "कोची जिल्लाको मध्य भाग"
    },
    "class15": {
      "code": "390013",
      "name": "高吾北",
      "enName": "Kogohoku"
    },
    "class20": {
      "code": "3938700",
      "name": "仁淀川町",
      "enName": "Niyodogawa Town",
      "kana": "によどがわちょう",
      "chName": "仁淀川町",
      "zhName": "仁淀川町",
      "koName": "니요도가와 정",
      "esName": "Pueblo de Niyodogawa",
      "ptName": "bairro de Niyodogawa",
      "thName": "เมืองนิโยโดงาวะ",
      "viName": "thị trấn Niyodogawa",
      "inName": "kota Niyodogawa",
      "tlName": "bayan ng Niyodogawa",
      "moName": "Ниёдогава жижиг хот",
      "buName": "နီယိုဒိုးဂါ့ဝ မြို့နယ်",
      "khName": "ទីប្រជុំជន នីយ៉ូដូហ្កាវ៉ា",
      "neName": "नियोदोगावा नगर"
    }
  },
  "3940100": {
    "office": {
      "code": "390000",
      "name": "高知県",
      "enName": "Kochi",
      "officeName": "高知地方気象台",
      "chName": "高知县",
      "zhName": "高知縣",
      "koName": "고치현",
      "esName": "Prefectura de Kochi",
      "ptName": "Província de Kōchi",
      "thName": "จังหวัดโคจิ",
      "viName": "Tỉnh Kochi",
      "inName": "Prefektur Kochi",
      "tlName": "Kochi Prefecture",
      "moName": "Кочи аймаг",
      "buName": "ခိုးကျိ ပြည်နယ်",
      "khName": "ខេត្ដ កូជី",
      "neName": "कोची जिल्ला"
    },
    "class10": {
      "code": "390030",
      "name": "西部",
      "enName": "Western Region",
      "chName": "高知县西部",
      "zhName": "高知縣西部",
      "koName": "고치 현 서부",
      "esName": "Oeste de Prefectura de Kochi",
      "ptName": "Oeste da Província de Kōchi",
      "thName": "จังหวัดโคจิฟากตะวันตก",
      "viName": "Miền Tây tỉnh Kochi",
      "inName": "Bagian Barat Prefektur Kochi",
      "tlName": "Kanlurang bahagi ng Kochi Prefecture",
      "moName": "Баруун Кочи аймаг",
      "buName": "ကိုချိစီရင်စု အနောက်ပိုင်း",
      "khName": "តំបន់ខាងលិចនៃខេត្ដខូឈិ",
      "neName": "कोची जिल्लाको पश्चिमी भाग"
    },
    "class15": {
      "code": "390032",
      "name": "高幡",
      "enName": "Koban"
    },
    "class20": {
      "code": "3940100",
      "name": "中土佐町",
      "enName": "Nakatosa Town",
      "kana": "なかとさちょう",
      "chName": "中土佐町",
      "zhName": "中土佐町",
      "koName": "나카토사 정",
      "esName": "Pueblo de Nakatosa",
      "ptName": "bairro de Nakatosa",
      "thName": "เมืองนากะโทสะ",
      "viName": "thị trấn Nakatosa",
      "inName": "kota Nakatosa",
      "tlName": "bayan ng Nakatosa",
      "moName": "Нaкатосa жижиг хот",
      "buName": "နာကာတိုဆာ မြို့နယ်",
      "khName": "ទីប្រជុំជន ណាកាតូសា",
      "neName": "नाकातोसा नगर"
    }
  },
  "3940200": {
    "office": {
      "code": "390000",
      "name": "高知県",
      "enName": "Kochi",
      "officeName": "高知地方気象台",
      "chName": "高知县",
      "zhName": "高知縣",
      "koName": "고치현",
      "esName": "Prefectura de Kochi",
      "ptName": "Província de Kōchi",
      "thName": "จังหวัดโคจิ",
      "viName": "Tỉnh Kochi",
      "inName": "Prefektur Kochi",
      "tlName": "Kochi Prefecture",
      "moName": "Кочи аймаг",
      "buName": "ခိုးကျိ ပြည်နယ်",
      "khName": "ខេត្ដ កូជី",
      "neName": "कोची जिल्ला"
    },
    "class10": {
      "code": "390010",
      "name": "中部",
      "enName": "Central Region",
      "chName": "高知县中部",
      "zhName": "高知縣中部",
      "koName": "고치 현 중부",
      "esName": "Centro de Prefectura de Kochi",
      "ptName": "Região central da Província de Kōchi",
      "thName": "จังหวัดโคจิตอนกลาง",
      "viName": "Miền Trung tỉnh Kochi",
      "inName": "Bagian Tengah Prefektur Kochi",
      "tlName": "Sentral na bahagi ng Kochi Prefecture",
      "moName": "Төв Кочи аймаг",
      "buName": "ကိုချိစီရင်စု အလယ်ပိုင်း",
      "khName": "តំបន់កណ្តាលនៃខេត្ដខូឈិ",
      "neName": "कोची जिल्लाको मध्य भाग"
    },
    "class15": {
      "code": "390013",
      "name": "高吾北",
      "enName": "Kogohoku"
    },
    "class20": {
      "code": "3940200",
      "name": "佐川町",
      "enName": "Sakawa Town",
      "kana": "さかわちょう",
      "chName": "佐川町",
      "zhName": "佐川町",
      "koName": "사카와 정",
      "esName": "Pueblo de Sakawa",
      "ptName": "bairro de Sakawa",
      "thName": "เมืองซาคาวะ",
      "viName": "thị trấn Sakawa",
      "inName": "kota Sakawa",
      "tlName": "bayan ng Sakawa",
      "moName": "Сакава жижиг хот",
      "buName": "ဆားကာ့ဝ မြို့နယ်",
      "khName": "ទីប្រជុំជន សាកាវ៉ា",
      "neName": "साकावा नगर"
    }
  },
  "3940300": {
    "office": {
      "code": "390000",
      "name": "高知県",
      "enName": "Kochi",
      "officeName": "高知地方気象台",
      "chName": "高知县",
      "zhName": "高知縣",
      "koName": "고치현",
      "esName": "Prefectura de Kochi",
      "ptName": "Província de Kōchi",
      "thName": "จังหวัดโคจิ",
      "viName": "Tỉnh Kochi",
      "inName": "Prefektur Kochi",
      "tlName": "Kochi Prefecture",
      "moName": "Кочи аймаг",
      "buName": "ခိုးကျိ ပြည်နယ်",
      "khName": "ខេត្ដ កូជី",
      "neName": "कोची जिल्ला"
    },
    "class10": {
      "code": "390010",
      "name": "中部",
      "enName": "Central Region",
      "chName": "高知县中部",
      "zhName": "高知縣中部",
      "koName": "고치 현 중부",
      "esName": "Centro de Prefectura de Kochi",
      "ptName": "Região central da Província de Kōchi",
      "thName": "จังหวัดโคจิตอนกลาง",
      "viName": "Miền Trung tỉnh Kochi",
      "inName": "Bagian Tengah Prefektur Kochi",
      "tlName": "Sentral na bahagi ng Kochi Prefecture",
      "moName": "Төв Кочи аймаг",
      "buName": "ကိုချိစီရင်စု အလယ်ပိုင်း",
      "khName": "តំបន់កណ្តាលនៃខេត្ដខូឈិ",
      "neName": "कोची जिल्लाको मध्य भाग"
    },
    "class15": {
      "code": "390013",
      "name": "高吾北",
      "enName": "Kogohoku"
    },
    "class20": {
      "code": "3940300",
      "name": "越知町",
      "enName": "Ochi Town",
      "kana": "おちちょう",
      "chName": "越知町",
      "zhName": "越知町",
      "koName": "오치 정",
      "esName": "Pueblo de Ochi",
      "ptName": "bairro de Ochi",
      "thName": "เมืองโอจิ",
      "viName": "thị trấn Ochi",
      "inName": "kota Ochi",
      "tlName": "bayan ng Ochi",
      "moName": "Очи жижиг хот",
      "buName": "အိုကျိ မြို့နယ်",
      "khName": "ទីប្រជុំជន អូជី",
      "neName": "ओची नगर"
    }
  },
  "3940500": {
    "office": {
      "code": "390000",
      "name": "高知県",
      "enName": "Kochi",
      "officeName": "高知地方気象台",
      "chName": "高知县",
      "zhName": "高知縣",
      "koName": "고치현",
      "esName": "Prefectura de Kochi",
      "ptName": "Província de Kōchi",
      "thName": "จังหวัดโคจิ",
      "viName": "Tỉnh Kochi",
      "inName": "Prefektur Kochi",
      "tlName": "Kochi Prefecture",
      "moName": "Кочи аймаг",
      "buName": "ခိုးကျိ ပြည်နယ်",
      "khName": "ខេត្ដ កូជី",
      "neName": "कोची जिल्ला"
    },
    "class10": {
      "code": "390030",
      "name": "西部",
      "enName": "Western Region",
      "chName": "高知县西部",
      "zhName": "高知縣西部",
      "koName": "고치 현 서부",
      "esName": "Oeste de Prefectura de Kochi",
      "ptName": "Oeste da Província de Kōchi",
      "thName": "จังหวัดโคจิฟากตะวันตก",
      "viName": "Miền Tây tỉnh Kochi",
      "inName": "Bagian Barat Prefektur Kochi",
      "tlName": "Kanlurang bahagi ng Kochi Prefecture",
      "moName": "Баруун Кочи аймаг",
      "buName": "ကိုချိစီရင်စု အနောက်ပိုင်း",
      "khName": "តំបន់ខាងលិចនៃខេត្ដខូឈិ",
      "neName": "कोची जिल्लाको पश्चिमी भाग"
    },
    "class15": {
      "code": "390032",
      "name": "高幡",
      "enName": "Koban"
    },
    "class20": {
      "code": "3940500",
      "name": "檮原町",
      "enName": "Yusuhara Town",
      "kana": "ゆすはらちょう",
      "chName": "梼原町",
      "zhName": "檮原町",
      "koName": "유스하라 정",
      "esName": "Pueblo de Yusuhara",
      "ptName": "bairro de Yusuhara",
      "thName": "เมืองยูสุฮาระ",
      "viName": "thị trấn Yusuhara",
      "inName": "kota Yusuhara",
      "tlName": "bayan ng Yusuhara",
      "moName": "Юсүхaра жижиг хот",
      "buName": "ယူဆုဟားရာ့ မြို့နယ်",
      "khName": "ទីប្រជុំជន យូស៊ូហារ៉ា",
      "neName": "युसुहारा नगर"
    }
  },
  "3941000": {
    "office": {
      "code": "390000",
      "name": "高知県",
      "enName": "Kochi",
      "officeName": "高知地方気象台",
      "chName": "高知县",
      "zhName": "高知縣",
      "koName": "고치현",
      "esName": "Prefectura de Kochi",
      "ptName": "Província de Kōchi",
      "thName": "จังหวัดโคจิ",
      "viName": "Tỉnh Kochi",
      "inName": "Prefektur Kochi",
      "tlName": "Kochi Prefecture",
      "moName": "Кочи аймаг",
      "buName": "ခိုးကျိ ပြည်နယ်",
      "khName": "ខេត្ដ កូជី",
      "neName": "कोची जिल्ला"
    },
    "class10": {
      "code": "390010",
      "name": "中部",
      "enName": "Central Region",
      "chName": "高知县中部",
      "zhName": "高知縣中部",
      "koName": "고치 현 중부",
      "esName": "Centro de Prefectura de Kochi",
      "ptName": "Região central da Província de Kōchi",
      "thName": "จังหวัดโคจิตอนกลาง",
      "viName": "Miền Trung tỉnh Kochi",
      "inName": "Bagian Tengah Prefektur Kochi",
      "tlName": "Sentral na bahagi ng Kochi Prefecture",
      "moName": "Төв Кочи аймаг",
      "buName": "ကိုချိစီရင်စု အလယ်ပိုင်း",
      "khName": "តំបន់កណ្តាលនៃខេត្ដខូឈិ",
      "neName": "कोची जिल्लाको मध्य भाग"
    },
    "class15": {
      "code": "390011",
      "name": "高知中央",
      "enName": "Central Kochi"
    },
    "class20": {
      "code": "3941000",
      "name": "日高村",
      "enName": "Hidaka Village",
      "kana": "ひだかむら",
      "chName": "日高村",
      "zhName": "日髙村",
      "koName": "히다카 촌",
      "esName": "Aldea de Hidaka",
      "ptName": "povoado de Hidaka",
      "thName": "หมู่บ้านฮิดากะ",
      "viName": "làng Hidaka",
      "inName": "desa Hidaka",
      "tlName": "nayon ng Hidaka",
      "moName": "Хидака тосгон",
      "buName": "ဟီဒါ့က ကျေးရွာ",
      "khName": "ភូមិ ហ៊ីដាកា",
      "neName": "हिदाका गाउँ"
    }
  },
  "3941100": {
    "office": {
      "code": "390000",
      "name": "高知県",
      "enName": "Kochi",
      "officeName": "高知地方気象台",
      "chName": "高知县",
      "zhName": "高知縣",
      "koName": "고치현",
      "esName": "Prefectura de Kochi",
      "ptName": "Província de Kōchi",
      "thName": "จังหวัดโคจิ",
      "viName": "Tỉnh Kochi",
      "inName": "Prefektur Kochi",
      "tlName": "Kochi Prefecture",
      "moName": "Кочи аймаг",
      "buName": "ခိုးကျိ ပြည်နယ်",
      "khName": "ខេត្ដ កូជី",
      "neName": "कोची जिल्ला"
    },
    "class10": {
      "code": "390030",
      "name": "西部",
      "enName": "Western Region",
      "chName": "高知县西部",
      "zhName": "高知縣西部",
      "koName": "고치 현 서부",
      "esName": "Oeste de Prefectura de Kochi",
      "ptName": "Oeste da Província de Kōchi",
      "thName": "จังหวัดโคจิฟากตะวันตก",
      "viName": "Miền Tây tỉnh Kochi",
      "inName": "Bagian Barat Prefektur Kochi",
      "tlName": "Kanlurang bahagi ng Kochi Prefecture",
      "moName": "Баруун Кочи аймаг",
      "buName": "ကိုချိစီရင်စု အနောက်ပိုင်း",
      "khName": "តំបន់ខាងលិចនៃខេត្ដខូឈិ",
      "neName": "कोची जिल्लाको पश्चिमी भाग"
    },
    "class15": {
      "code": "390032",
      "name": "高幡",
      "enName": "Koban"
    },
    "class20": {
      "code": "3941100",
      "name": "津野町",
      "enName": "Tsuno Town",
      "kana": "つのちょう",
      "chName": "高知津野町",
      "zhName": "高知津野町",
      "koName": "고치 쯔노 정",
      "esName": "Pueblo de Tsuno, Kochi",
      "ptName": "Kochi, bairro de Tsuno",
      "thName": "เมืองสึโนะ โคจิ",
      "viName": "Thị trấn Tsuno, Kochi",
      "inName": "Kota Tsuno, Kochi",
      "tlName": "bayan ng Tsuno, Kochi",
      "moName": "Кочи Цүно жижиг хот",
      "buName": "ကိုးချိဆုနိုမြို့နယ် ",
      "khName": "ទីប្រជុំជនស៊ូណូ ខូឈិ",
      "neName": "कोची त्सुनो नगर"
    }
  },
  "3941200": {
    "office": {
      "code": "390000",
      "name": "高知県",
      "enName": "Kochi",
      "officeName": "高知地方気象台",
      "chName": "高知县",
      "zhName": "高知縣",
      "koName": "고치현",
      "esName": "Prefectura de Kochi",
      "ptName": "Província de Kōchi",
      "thName": "จังหวัดโคจิ",
      "viName": "Tỉnh Kochi",
      "inName": "Prefektur Kochi",
      "tlName": "Kochi Prefecture",
      "moName": "Кочи аймаг",
      "buName": "ခိုးကျိ ပြည်နယ်",
      "khName": "ខេត្ដ កូជី",
      "neName": "कोची जिल्ला"
    },
    "class10": {
      "code": "390030",
      "name": "西部",
      "enName": "Western Region",
      "chName": "高知县西部",
      "zhName": "高知縣西部",
      "koName": "고치 현 서부",
      "esName": "Oeste de Prefectura de Kochi",
      "ptName": "Oeste da Província de Kōchi",
      "thName": "จังหวัดโคจิฟากตะวันตก",
      "viName": "Miền Tây tỉnh Kochi",
      "inName": "Bagian Barat Prefektur Kochi",
      "tlName": "Kanlurang bahagi ng Kochi Prefecture",
      "moName": "Баруун Кочи аймаг",
      "buName": "ကိုချိစီရင်စု အနောက်ပိုင်း",
      "khName": "តំបន់ខាងលិចនៃខេត្ដខូឈិ",
      "neName": "कोची जिल्लाको पश्चिमी भाग"
    },
    "class15": {
      "code": "390032",
      "name": "高幡",
      "enName": "Koban"
    },
    "class20": {
      "code": "3941200",
      "name": "四万十町",
      "enName": "Shimanto Town",
      "kana": "しまんとちょう",
      "chName": "四万十町",
      "zhName": "四萬十町",
      "koName": "시만토 정",
      "esName": "Pueblo de Shimanto",
      "ptName": "bairro de Shimanto",
      "thName": "เมืองชิมันโตะ (ชิมันโตะโจ)",
      "viName": "thị trấn Shimanto",
      "inName": "Kota Shimanto (Shimanto-chō)",
      "tlName": "bayan ng Shimanto",
      "moName": "Шимaнто жижиг хот",
      "buName": "ရှီမန်တို မြို့နယ်",
      "khName": "ទីប្រជុំជន ស៊ីម៉ានតុ",
      "neName": "शिमान्तो नगर"
    }
  },
  "3942400": {
    "office": {
      "code": "390000",
      "name": "高知県",
      "enName": "Kochi",
      "officeName": "高知地方気象台",
      "chName": "高知县",
      "zhName": "高知縣",
      "koName": "고치현",
      "esName": "Prefectura de Kochi",
      "ptName": "Província de Kōchi",
      "thName": "จังหวัดโคจิ",
      "viName": "Tỉnh Kochi",
      "inName": "Prefektur Kochi",
      "tlName": "Kochi Prefecture",
      "moName": "Кочи аймаг",
      "buName": "ခိုးကျိ ပြည်နယ်",
      "khName": "ខេត្ដ កូជី",
      "neName": "कोची जिल्ला"
    },
    "class10": {
      "code": "390030",
      "name": "西部",
      "enName": "Western Region",
      "chName": "高知县西部",
      "zhName": "高知縣西部",
      "koName": "고치 현 서부",
      "esName": "Oeste de Prefectura de Kochi",
      "ptName": "Oeste da Província de Kōchi",
      "thName": "จังหวัดโคจิฟากตะวันตก",
      "viName": "Miền Tây tỉnh Kochi",
      "inName": "Bagian Barat Prefektur Kochi",
      "tlName": "Kanlurang bahagi ng Kochi Prefecture",
      "moName": "Баруун Кочи аймаг",
      "buName": "ကိုချိစီရင်စု အနောက်ပိုင်း",
      "khName": "តំបន់ខាងលិចនៃខេត្ដខូឈិ",
      "neName": "कोची जिल्लाको पश्चिमी भाग"
    },
    "class15": {
      "code": "390031",
      "name": "幡多",
      "enName": "Hata"
    },
    "class20": {
      "code": "3942400",
      "name": "大月町",
      "enName": "Otsuki Town",
      "kana": "おおつきちょう",
      "chName": "大月町",
      "zhName": "大月町",
      "koName": "오쓰키 정",
      "esName": "Pueblo de Otsuki",
      "ptName": "bairro de Otsuki",
      "thName": "เมืองโอ๊ตสึกิ",
      "viName": "thị trấn Otsuki",
      "inName": "kota Otsuki",
      "tlName": "bayan ng Otsuki",
      "moName": "Оцүки жижиг хот",
      "buName": "အိုဆုကိ မြို့နယ်",
      "khName": "ទីប្រជុំជន អតស៊ូគី",
      "neName": "ओत्सुकि नगर"
    }
  },
  "3942700": {
    "office": {
      "code": "390000",
      "name": "高知県",
      "enName": "Kochi",
      "officeName": "高知地方気象台",
      "chName": "高知县",
      "zhName": "高知縣",
      "koName": "고치현",
      "esName": "Prefectura de Kochi",
      "ptName": "Província de Kōchi",
      "thName": "จังหวัดโคจิ",
      "viName": "Tỉnh Kochi",
      "inName": "Prefektur Kochi",
      "tlName": "Kochi Prefecture",
      "moName": "Кочи аймаг",
      "buName": "ခိုးကျိ ပြည်နယ်",
      "khName": "ខេត្ដ កូជី",
      "neName": "कोची जिल्ला"
    },
    "class10": {
      "code": "390030",
      "name": "西部",
      "enName": "Western Region",
      "chName": "高知县西部",
      "zhName": "高知縣西部",
      "koName": "고치 현 서부",
      "esName": "Oeste de Prefectura de Kochi",
      "ptName": "Oeste da Província de Kōchi",
      "thName": "จังหวัดโคจิฟากตะวันตก",
      "viName": "Miền Tây tỉnh Kochi",
      "inName": "Bagian Barat Prefektur Kochi",
      "tlName": "Kanlurang bahagi ng Kochi Prefecture",
      "moName": "Баруун Кочи аймаг",
      "buName": "ကိုချိစီရင်စု အနောက်ပိုင်း",
      "khName": "តំបន់ខាងលិចនៃខេត្ដខូឈិ",
      "neName": "कोची जिल्लाको पश्चिमी भाग"
    },
    "class15": {
      "code": "390031",
      "name": "幡多",
      "enName": "Hata"
    },
    "class20": {
      "code": "3942700",
      "name": "三原村",
      "enName": "Mihara Village",
      "kana": "みはらむら",
      "chName": "三原村",
      "zhName": "三原村",
      "koName": "미하라 촌",
      "esName": "Aldea de Mihara",
      "ptName": "povoado de Mihara",
      "thName": "หมู่บ้านมิฮาระ",
      "viName": "làng Mihara",
      "inName": "desa Mihara",
      "tlName": "nayon ng Mihara",
      "moName": "Михaра тосгон",
      "buName": "မီဟာ့ရာ့ ကျေးရွာ",
      "khName": " ភូមិ មីហារ៉ា",
      "neName": "मिहारा गाउँ"
    }
  },
  "3942800": {
    "office": {
      "code": "390000",
      "name": "高知県",
      "enName": "Kochi",
      "officeName": "高知地方気象台",
      "chName": "高知县",
      "zhName": "高知縣",
      "koName": "고치현",
      "esName": "Prefectura de Kochi",
      "ptName": "Província de Kōchi",
      "thName": "จังหวัดโคจิ",
      "viName": "Tỉnh Kochi",
      "inName": "Prefektur Kochi",
      "tlName": "Kochi Prefecture",
      "moName": "Кочи аймаг",
      "buName": "ခိုးကျိ ပြည်နယ်",
      "khName": "ខេត្ដ កូជី",
      "neName": "कोची जिल्ला"
    },
    "class10": {
      "code": "390030",
      "name": "西部",
      "enName": "Western Region",
      "chName": "高知县西部",
      "zhName": "高知縣西部",
      "koName": "고치 현 서부",
      "esName": "Oeste de Prefectura de Kochi",
      "ptName": "Oeste da Província de Kōchi",
      "thName": "จังหวัดโคจิฟากตะวันตก",
      "viName": "Miền Tây tỉnh Kochi",
      "inName": "Bagian Barat Prefektur Kochi",
      "tlName": "Kanlurang bahagi ng Kochi Prefecture",
      "moName": "Баруун Кочи аймаг",
      "buName": "ကိုချိစီရင်စု အနောက်ပိုင်း",
      "khName": "តំបន់ខាងលិចនៃខេត្ដខូឈិ",
      "neName": "कोची जिल्लाको पश्चिमी भाग"
    },
    "class15": {
      "code": "390031",
      "name": "幡多",
      "enName": "Hata"
    },
    "class20": {
      "code": "3942800",
      "name": "黒潮町",
      "enName": "Kuroshio Town",
      "kana": "くろしおちょう",
      "chName": "黑潮町",
      "zhName": "黑潮町",
      "koName": "구로시오 정",
      "esName": "Pueblo de Kuroshio",
      "ptName": "bairro de Kuroshio",
      "thName": "เมืองคุโรชิโอ",
      "viName": "thị trấn Kuroshio",
      "inName": "kota Kuroshio",
      "tlName": "bayan ng Kuroshio",
      "moName": "Күрошио жижиг хот",
      "buName": "ကူရိုရှိရို မြို့နယ်",
      "khName": "ទីប្រជុំជន គូរ៉ូស៊ីអូ",
      "neName": "कुरोशियो नगर"
    }
  },
  "4010000": {
    "office": {
      "code": "400000",
      "name": "福岡県",
      "enName": "Fukuoka",
      "officeName": "福岡管区気象台",
      "chName": "福冈县",
      "zhName": "福岡縣",
      "koName": "후쿠오카현",
      "esName": "Prefectura de Fukuoka",
      "ptName": "Província de Fukuoka",
      "thName": "จังหวัดฟุกุโอกะ",
      "viName": "Tỉnh Fukuoka",
      "inName": "Prefektur Fukuoka",
      "tlName": "Fukuoka Prefecture",
      "moName": "Фүкүока аймаг",
      "buName": "ဖူကူအိုက ပြည်နယ်",
      "khName": "ខេត្ដ ហ្វូគូកា",
      "neName": "फुकुओका जिल्ला"
    },
    "class10": {
      "code": "400020",
      "name": "北九州地方",
      "enName": "Kitakyushu Region",
      "chName": "福冈县北九州地方",
      "zhName": "福岡縣北九州地方",
      "koName": "후쿠오카 현 기타큐슈 지방",
      "esName": "Región Kitakyushu, Prefectura de Fukuoka",
      "ptName": "Região de Kita-Kyūshū da Província de Fukuoka",
      "thName": "ท้องถิ่นคิตะกิวชู จังหวัดฟุกุโอกะ",
      "viName": "Vùng Kitakyushu, tỉnh Fukuoka",
      "inName": "Daerah Kitakyushu di Prefektur Fukuoka",
      "tlName": "Rehiyon ng Kita-Kyushu sa Fukuoka Prefecture",
      "moName": "Фүкүока аймаг, Китакюшү муж",
      "buName": "ခိတခယူးရှုးဒေသ၊ ဟုခုအိုကစီရင်စု",
      "khName": "តំបន់គីតាក់ខ្យឹហ្សឹនៃខេត្ដហ្វឹគឹអុកា",
      "neName": "फुकुओका जिल्ला, किताक्युस्यु क्षेत्र"
    },
    "class15": {
      "code": "400021",
      "name": "北九州・遠賀地区",
      "enName": "Kitakyushu Onga District"
    },
    "class20": {
      "code": "4010000",
      "name": "北九州市",
      "enName": "Kitakyushu City",
      "kana": "きたきゅうしゅうし",
      "chName": "北九州市",
      "zhName": "北九州市",
      "koName": "기타큐슈시",
      "esName": "Ciudad de Kitakyushu",
      "ptName": "Cidade de Kitakyushu",
      "thName": "เมืองคิตะกิวชู",
      "viName": "Thành phố Kitakyushu",
      "inName": "Kota Kitakyushu",
      "tlName": "Lungsod ng Kitakyushu",
      "moName": "Cidade de Kitakyushu",
      "buName": "ကီတကျူရှူမြို့",
      "khName": "ខេត្តកិតាគ្យូស៊ី",
      "neName": "किताक्यूसु सिटी"
    }
  },
  "4013000": {
    "office": {
      "code": "400000",
      "name": "福岡県",
      "enName": "Fukuoka",
      "officeName": "福岡管区気象台",
      "chName": "福冈县",
      "zhName": "福岡縣",
      "koName": "후쿠오카현",
      "esName": "Prefectura de Fukuoka",
      "ptName": "Província de Fukuoka",
      "thName": "จังหวัดฟุกุโอกะ",
      "viName": "Tỉnh Fukuoka",
      "inName": "Prefektur Fukuoka",
      "tlName": "Fukuoka Prefecture",
      "moName": "Фүкүока аймаг",
      "buName": "ဖူကူအိုက ပြည်နယ်",
      "khName": "ខេត្ដ ហ្វូគូកា",
      "neName": "फुकुओका जिल्ला"
    },
    "class10": {
      "code": "400010",
      "name": "福岡地方",
      "enName": "Fukuoka Region",
      "chName": "福冈县福冈地方",
      "zhName": "福岡縣福岡地方",
      "koName": "후쿠오카 현 후쿠오카 지방",
      "esName": "Región Fukushima, Prefectura de Fukuoka",
      "ptName": "Região de Fukuoka da Província de Fukuoka",
      "thName": "ท้องถิ่นฟุกุโอกะ จังหวัดฟุกุโอกะ",
      "viName": "Vùng Fukuoka, tỉnh Fukuoka",
      "inName": "Daerah Fukuoka di Prefektur Fukuoka",
      "tlName": "Rehiyon ng Fukuoka sa Fukuoka Prefecture",
      "moName": "Фүкүока аймаг, Фүкүока муж",
      "buName": "ဟုခုအိုကဒေသ၊ ဟုခုအိုကစီရင်စု",
      "khName": "តំបន់ហ្វឹគឹអុកានៃខេត្ដហ្វឹគឹអុកា",
      "neName": "फुकुओका जिल्ला, फुकुओका क्षेत्र"
    },
    "class15": {
      "code": "400010",
      "name": "福岡地方",
      "enName": "Fukuoka Region"
    },
    "class20": {
      "code": "4013000",
      "name": "福岡市",
      "enName": "Fukuoka City",
      "kana": "ふくおかし",
      "chName": "福冈市",
      "zhName": "福冈市",
      "koName": "후쿠오카시",
      "esName": "Ciudad de Fukuoka",
      "ptName": "Cidade de Fukuoka",
      "thName": "เมืองฟุกุโอกะ",
      "viName": "Thành phố Fukuoka",
      "inName": "Kota Fukuoka",
      "tlName": "Lungsod ng Fukuoka",
      "moName": "Cidade de Fukuoka",
      "buName": "ဖုကိုကမြို့",
      "khName": "ខេត្តហ្វូកូកា",
      "neName": "फुकुओका सिटी"
    }
  },
  "4020200": {
    "office": {
      "code": "400000",
      "name": "福岡県",
      "enName": "Fukuoka",
      "officeName": "福岡管区気象台",
      "chName": "福冈县",
      "zhName": "福岡縣",
      "koName": "후쿠오카현",
      "esName": "Prefectura de Fukuoka",
      "ptName": "Província de Fukuoka",
      "thName": "จังหวัดฟุกุโอกะ",
      "viName": "Tỉnh Fukuoka",
      "inName": "Prefektur Fukuoka",
      "tlName": "Fukuoka Prefecture",
      "moName": "Фүкүока аймаг",
      "buName": "ဖူကူအိုက ပြည်နယ်",
      "khName": "ខេត្ដ ហ្វូគូកា",
      "neName": "फुकुओका जिल्ला"
    },
    "class10": {
      "code": "400040",
      "name": "筑後地方",
      "enName": "Chikugo Region",
      "chName": "福冈县筑后地方",
      "zhName": "福岡縣筑後地方",
      "koName": "후쿠오카 현 지쿠고 지방",
      "esName": "Región Chikugo, Prefectura de Fukuoka",
      "ptName": "Região de Chikugo da Província de Fukuoka",
      "thName": "ท้องถิ่นจิกุโงะ จังหวัดฟุกุโอกะ",
      "viName": "Vùng Chikugo, tỉnh Fukuoka",
      "inName": "Daerah Chikugo di Prefektur Fukuoka",
      "tlName": "Rehiyon ng Chikugo sa Fukuoka Prefecture",
      "moName": "Фүкүока аймаг, Чикүго муж",
      "buName": "ချူးခုဂိုဒေသ၊ ဟုခုအိုကစီရင်စု",
      "khName": "តំបន់ជីគឹហ្គោនៃខេត្ដហ្វឹគឹអុកា",
      "neName": "फुकुओका जिल्ला, चिकुगो क्षेत्र"
    },
    "class15": {
      "code": "400042",
      "name": "筑後南部",
      "enName": "Southern Chikugo"
    },
    "class20": {
      "code": "4020200",
      "name": "大牟田市",
      "enName": "Omuta City",
      "kana": "おおむたし",
      "chName": "大牟田市",
      "zhName": "大牟田市",
      "koName": "오무타 시",
      "esName": "Ciudad de Ōmuta",
      "ptName": "cidade de Omuta",
      "thName": "เมืองโอมุตะ",
      "viName": "thành phố Omuta",
      "inName": "kota Omuta",
      "tlName": "siyudad ng Omuta",
      "moName": "Омүта хот",
      "buName": "အို့မုတ မြို့",
      "khName": "ទីក្រុង អូមូតា",
      "neName": "ओमुता सहर"
    }
  },
  "4020300": {
    "office": {
      "code": "400000",
      "name": "福岡県",
      "enName": "Fukuoka",
      "officeName": "福岡管区気象台",
      "chName": "福冈县",
      "zhName": "福岡縣",
      "koName": "후쿠오카현",
      "esName": "Prefectura de Fukuoka",
      "ptName": "Província de Fukuoka",
      "thName": "จังหวัดฟุกุโอกะ",
      "viName": "Tỉnh Fukuoka",
      "inName": "Prefektur Fukuoka",
      "tlName": "Fukuoka Prefecture",
      "moName": "Фүкүока аймаг",
      "buName": "ဖူကူအိုက ပြည်နယ်",
      "khName": "ខេត្ដ ហ្វូគូកា",
      "neName": "फुकुओका जिल्ला"
    },
    "class10": {
      "code": "400040",
      "name": "筑後地方",
      "enName": "Chikugo Region",
      "chName": "福冈县筑后地方",
      "zhName": "福岡縣筑後地方",
      "koName": "후쿠오카 현 지쿠고 지방",
      "esName": "Región Chikugo, Prefectura de Fukuoka",
      "ptName": "Região de Chikugo da Província de Fukuoka",
      "thName": "ท้องถิ่นจิกุโงะ จังหวัดฟุกุโอกะ",
      "viName": "Vùng Chikugo, tỉnh Fukuoka",
      "inName": "Daerah Chikugo di Prefektur Fukuoka",
      "tlName": "Rehiyon ng Chikugo sa Fukuoka Prefecture",
      "moName": "Фүкүока аймаг, Чикүго муж",
      "buName": "ချူးခုဂိုဒေသ၊ ဟုခုအိုကစီရင်စု",
      "khName": "តំបន់ជីគឹហ្គោនៃខេត្ដហ្វឹគឹអុកា",
      "neName": "फुकुओका जिल्ला, चिकुगो क्षेत्र"
    },
    "class15": {
      "code": "400041",
      "name": "筑後北部",
      "enName": "Northern Chikugo"
    },
    "class20": {
      "code": "4020300",
      "name": "久留米市",
      "enName": "Kurume City",
      "kana": "くるめし",
      "chName": "久留米市",
      "zhName": "久留米市",
      "koName": "구루메 시",
      "esName": "Ciudad de Kurume",
      "ptName": "cidade de Kurume",
      "thName": "เมืองคุรุเมะ",
      "viName": "thành phố Kurume",
      "inName": "kota Kurume",
      "tlName": "siyudad ng Kurume",
      "moName": "Күрүмэ хот",
      "buName": "ကုရုမဲ့ မြို့",
      "khName": "ទីក្រុង គូរូមមេ",
      "neName": "कुरुमे सहर"
    }
  },
  "4020400": {
    "office": {
      "code": "400000",
      "name": "福岡県",
      "enName": "Fukuoka",
      "officeName": "福岡管区気象台",
      "chName": "福冈县",
      "zhName": "福岡縣",
      "koName": "후쿠오카현",
      "esName": "Prefectura de Fukuoka",
      "ptName": "Província de Fukuoka",
      "thName": "จังหวัดฟุกุโอกะ",
      "viName": "Tỉnh Fukuoka",
      "inName": "Prefektur Fukuoka",
      "tlName": "Fukuoka Prefecture",
      "moName": "Фүкүока аймаг",
      "buName": "ဖူကူအိုက ပြည်နယ်",
      "khName": "ខេត្ដ ហ្វូគូកា",
      "neName": "फुकुओका जिल्ला"
    },
    "class10": {
      "code": "400030",
      "name": "筑豊地方",
      "enName": "Chikuho Region",
      "chName": "福冈县筑丰地方",
      "zhName": "福岡縣筑豐地方",
      "koName": "후쿠오카 현 츠쿠호 지방",
      "esName": "Región Chikuhou, Prefectura de Fukuoka",
      "ptName": "Região de Chikuhō da Província de Fukuoka",
      "thName": "ท้องถิ่นจิกุโฮ จังหวัดฟุกุโอกะ",
      "viName": "Vùng Chikuho, tỉnh Fukuoka",
      "inName": "Daerah Chikuho di Prefektur Fukuoka",
      "tlName": "Rehiyon ng Chikuho sa Fukuoka Prefecture",
      "moName": "Фүкүока аймаг, Чикүхо муж",
      "buName": "ချိခုဟိုဒေသ၊ ဟုခုအိုကစီရင်စု",
      "khName": "តំបន់ជីគឹហូនៃខេត្ដហ្វឹគឹអុកា",
      "neName": "फुकुओका जिल्ला, चिकुहो क्षेत्र"
    },
    "class15": {
      "code": "400030",
      "name": "筑豊地方",
      "enName": "Chikuho Region"
    },
    "class20": {
      "code": "4020400",
      "name": "直方市",
      "enName": "Nogata City",
      "kana": "のおがたし",
      "chName": "直方市",
      "zhName": "直方市",
      "koName": "노가타 시",
      "esName": "Ciudad de Nogata",
      "ptName": "cidade de Nogata",
      "thName": "เมืองโนงาตะ",
      "viName": "thành phố Nogata",
      "inName": "kota Nogata",
      "tlName": "siyudad ng Nogata",
      "moName": "Ногaта хот",
      "buName": "နောဂါ့တ မြို့",
      "khName": "ទីក្រុង ណូកាតា",
      "neName": "नोगाता सहर"
    }
  },
  "4020500": {
    "office": {
      "code": "400000",
      "name": "福岡県",
      "enName": "Fukuoka",
      "officeName": "福岡管区気象台",
      "chName": "福冈县",
      "zhName": "福岡縣",
      "koName": "후쿠오카현",
      "esName": "Prefectura de Fukuoka",
      "ptName": "Província de Fukuoka",
      "thName": "จังหวัดฟุกุโอกะ",
      "viName": "Tỉnh Fukuoka",
      "inName": "Prefektur Fukuoka",
      "tlName": "Fukuoka Prefecture",
      "moName": "Фүкүока аймаг",
      "buName": "ဖူကူအိုက ပြည်နယ်",
      "khName": "ខេត្ដ ហ្វូគូកា",
      "neName": "फुकुओका जिल्ला"
    },
    "class10": {
      "code": "400030",
      "name": "筑豊地方",
      "enName": "Chikuho Region",
      "chName": "福冈县筑丰地方",
      "zhName": "福岡縣筑豐地方",
      "koName": "후쿠오카 현 츠쿠호 지방",
      "esName": "Región Chikuhou, Prefectura de Fukuoka",
      "ptName": "Região de Chikuhō da Província de Fukuoka",
      "thName": "ท้องถิ่นจิกุโฮ จังหวัดฟุกุโอกะ",
      "viName": "Vùng Chikuho, tỉnh Fukuoka",
      "inName": "Daerah Chikuho di Prefektur Fukuoka",
      "tlName": "Rehiyon ng Chikuho sa Fukuoka Prefecture",
      "moName": "Фүкүока аймаг, Чикүхо муж",
      "buName": "ချိခုဟိုဒေသ၊ ဟုခုအိုကစီရင်စု",
      "khName": "តំបន់ជីគឹហូនៃខេត្ដហ្វឹគឹអុកា",
      "neName": "फुकुओका जिल्ला, चिकुहो क्षेत्र"
    },
    "class15": {
      "code": "400030",
      "name": "筑豊地方",
      "enName": "Chikuho Region"
    },
    "class20": {
      "code": "4020500",
      "name": "飯塚市",
      "enName": "Iizuka City",
      "kana": "いいづかし",
      "chName": "饭冢市",
      "zhName": "飯塚市",
      "koName": "이즈카 시",
      "esName": "Ciudad de Iizuka",
      "ptName": "cidade de Iizuka",
      "thName": "เมืองลิซูกะ",
      "viName": "thành phố Iizuka",
      "inName": "kota Iizuka",
      "tlName": "siyudad ng Iizuka",
      "moName": "Ийзүка хот",
      "buName": "အိဇုက မြို့",
      "khName": "ទីក្រុង អ៊ីហ្សូកា",
      "neName": "आइजुका सहर"
    }
  },
  "4020600": {
    "office": {
      "code": "400000",
      "name": "福岡県",
      "enName": "Fukuoka",
      "officeName": "福岡管区気象台",
      "chName": "福冈县",
      "zhName": "福岡縣",
      "koName": "후쿠오카현",
      "esName": "Prefectura de Fukuoka",
      "ptName": "Província de Fukuoka",
      "thName": "จังหวัดฟุกุโอกะ",
      "viName": "Tỉnh Fukuoka",
      "inName": "Prefektur Fukuoka",
      "tlName": "Fukuoka Prefecture",
      "moName": "Фүкүока аймаг",
      "buName": "ဖူကူအိုက ပြည်နယ်",
      "khName": "ខេត្ដ ហ្វូគូកា",
      "neName": "फुकुओका जिल्ला"
    },
    "class10": {
      "code": "400030",
      "name": "筑豊地方",
      "enName": "Chikuho Region",
      "chName": "福冈县筑丰地方",
      "zhName": "福岡縣筑豐地方",
      "koName": "후쿠오카 현 츠쿠호 지방",
      "esName": "Región Chikuhou, Prefectura de Fukuoka",
      "ptName": "Região de Chikuhō da Província de Fukuoka",
      "thName": "ท้องถิ่นจิกุโฮ จังหวัดฟุกุโอกะ",
      "viName": "Vùng Chikuho, tỉnh Fukuoka",
      "inName": "Daerah Chikuho di Prefektur Fukuoka",
      "tlName": "Rehiyon ng Chikuho sa Fukuoka Prefecture",
      "moName": "Фүкүока аймаг, Чикүхо муж",
      "buName": "ချိခုဟိုဒေသ၊ ဟုခုအိုကစီရင်စု",
      "khName": "តំបន់ជីគឹហូនៃខេត្ដហ្វឹគឹអុកា",
      "neName": "फुकुओका जिल्ला, चिकुहो क्षेत्र"
    },
    "class15": {
      "code": "400030",
      "name": "筑豊地方",
      "enName": "Chikuho Region"
    },
    "class20": {
      "code": "4020600",
      "name": "田川市",
      "enName": "Tagawa City",
      "kana": "たがわし",
      "chName": "田川市",
      "zhName": "田川市",
      "koName": "다가와 시",
      "esName": "Ciudad de Tagawa",
      "ptName": "cidade de Tagawa",
      "thName": "เมืองทะงาวะ",
      "viName": "thành phố Tagawa",
      "inName": "kota Tagawa",
      "tlName": "siyudad ng Tagawa",
      "moName": "Тагава хот",
      "buName": "တာဂါ့ဝ မြို့",
      "khName": "ទីក្រុង តាកាវ៉ា",
      "neName": "तागावा सहर"
    }
  },
  "4020700": {
    "office": {
      "code": "400000",
      "name": "福岡県",
      "enName": "Fukuoka",
      "officeName": "福岡管区気象台",
      "chName": "福冈县",
      "zhName": "福岡縣",
      "koName": "후쿠오카현",
      "esName": "Prefectura de Fukuoka",
      "ptName": "Província de Fukuoka",
      "thName": "จังหวัดฟุกุโอกะ",
      "viName": "Tỉnh Fukuoka",
      "inName": "Prefektur Fukuoka",
      "tlName": "Fukuoka Prefecture",
      "moName": "Фүкүока аймаг",
      "buName": "ဖူကူအိုက ပြည်နယ်",
      "khName": "ខេត្ដ ហ្វូគូកា",
      "neName": "फुकुओका जिल्ला"
    },
    "class10": {
      "code": "400040",
      "name": "筑後地方",
      "enName": "Chikugo Region",
      "chName": "福冈县筑后地方",
      "zhName": "福岡縣筑後地方",
      "koName": "후쿠오카 현 지쿠고 지방",
      "esName": "Región Chikugo, Prefectura de Fukuoka",
      "ptName": "Região de Chikugo da Província de Fukuoka",
      "thName": "ท้องถิ่นจิกุโงะ จังหวัดฟุกุโอกะ",
      "viName": "Vùng Chikugo, tỉnh Fukuoka",
      "inName": "Daerah Chikugo di Prefektur Fukuoka",
      "tlName": "Rehiyon ng Chikugo sa Fukuoka Prefecture",
      "moName": "Фүкүока аймаг, Чикүго муж",
      "buName": "ချူးခုဂိုဒေသ၊ ဟုခုအိုကစီရင်စု",
      "khName": "តំបន់ជីគឹហ្គោនៃខេត្ដហ្វឹគឹអុកា",
      "neName": "फुकुओका जिल्ला, चिकुगो क्षेत्र"
    },
    "class15": {
      "code": "400042",
      "name": "筑後南部",
      "enName": "Southern Chikugo"
    },
    "class20": {
      "code": "4020700",
      "name": "柳川市",
      "enName": "Yanagawa City",
      "kana": "やながわし",
      "chName": "柳川市",
      "zhName": "柳川市",
      "koName": "야나가와 시",
      "esName": "Ciudad de Yanagawa",
      "ptName": "cidade de Yanagawa",
      "thName": "เมืองยานางาวะ",
      "viName": "thành phố Yanagawa",
      "inName": "kota Yanagawa",
      "tlName": "siyudad ng Yanagawa",
      "moName": "Янaгава хот",
      "buName": "ယာနားဂါ့ဝ မြို့",
      "khName": "ទីក្រុង យ៉ាណាហ្គាវ៉ា",
      "neName": "यानागावा सहर"
    }
  },
  "4021000": {
    "office": {
      "code": "400000",
      "name": "福岡県",
      "enName": "Fukuoka",
      "officeName": "福岡管区気象台",
      "chName": "福冈县",
      "zhName": "福岡縣",
      "koName": "후쿠오카현",
      "esName": "Prefectura de Fukuoka",
      "ptName": "Província de Fukuoka",
      "thName": "จังหวัดฟุกุโอกะ",
      "viName": "Tỉnh Fukuoka",
      "inName": "Prefektur Fukuoka",
      "tlName": "Fukuoka Prefecture",
      "moName": "Фүкүока аймаг",
      "buName": "ဖူကူအိုက ပြည်နယ်",
      "khName": "ខេត្ដ ហ្វូគូកា",
      "neName": "फुकुओका जिल्ला"
    },
    "class10": {
      "code": "400040",
      "name": "筑後地方",
      "enName": "Chikugo Region",
      "chName": "福冈县筑后地方",
      "zhName": "福岡縣筑後地方",
      "koName": "후쿠오카 현 지쿠고 지방",
      "esName": "Región Chikugo, Prefectura de Fukuoka",
      "ptName": "Região de Chikugo da Província de Fukuoka",
      "thName": "ท้องถิ่นจิกุโงะ จังหวัดฟุกุโอกะ",
      "viName": "Vùng Chikugo, tỉnh Fukuoka",
      "inName": "Daerah Chikugo di Prefektur Fukuoka",
      "tlName": "Rehiyon ng Chikugo sa Fukuoka Prefecture",
      "moName": "Фүкүока аймаг, Чикүго муж",
      "buName": "ချူးခုဂိုဒေသ၊ ဟုခုအိုကစီရင်စု",
      "khName": "តំបន់ជីគឹហ្គោនៃខេត្ដហ្វឹគឹអុកា",
      "neName": "फुकुओका जिल्ला, चिकुगो क्षेत्र"
    },
    "class15": {
      "code": "400042",
      "name": "筑後南部",
      "enName": "Southern Chikugo"
    },
    "class20": {
      "code": "4021000",
      "name": "八女市",
      "enName": "Yame City",
      "kana": "やめし",
      "chName": "八女市",
      "zhName": "八女市",
      "koName": "야메 시",
      "esName": "Ciudad de Yame",
      "ptName": "cidade de Yame",
      "thName": "เมืองยาเมะ",
      "viName": "thành phố Yame",
      "inName": "kota Yame",
      "tlName": "siyudad ng Yame",
      "moName": "Ямэ хот",
      "buName": "ယားမဲ့ မြို့",
      "khName": "ទីក្រុង យ៉េម",
      "neName": "यामे सहर"
    }
  },
  "4021100": {
    "office": {
      "code": "400000",
      "name": "福岡県",
      "enName": "Fukuoka",
      "officeName": "福岡管区気象台",
      "chName": "福冈县",
      "zhName": "福岡縣",
      "koName": "후쿠오카현",
      "esName": "Prefectura de Fukuoka",
      "ptName": "Província de Fukuoka",
      "thName": "จังหวัดฟุกุโอกะ",
      "viName": "Tỉnh Fukuoka",
      "inName": "Prefektur Fukuoka",
      "tlName": "Fukuoka Prefecture",
      "moName": "Фүкүока аймаг",
      "buName": "ဖူကူအိုက ပြည်နယ်",
      "khName": "ខេត្ដ ហ្វូគូកា",
      "neName": "फुकुओका जिल्ला"
    },
    "class10": {
      "code": "400040",
      "name": "筑後地方",
      "enName": "Chikugo Region",
      "chName": "福冈县筑后地方",
      "zhName": "福岡縣筑後地方",
      "koName": "후쿠오카 현 지쿠고 지방",
      "esName": "Región Chikugo, Prefectura de Fukuoka",
      "ptName": "Região de Chikugo da Província de Fukuoka",
      "thName": "ท้องถิ่นจิกุโงะ จังหวัดฟุกุโอกะ",
      "viName": "Vùng Chikugo, tỉnh Fukuoka",
      "inName": "Daerah Chikugo di Prefektur Fukuoka",
      "tlName": "Rehiyon ng Chikugo sa Fukuoka Prefecture",
      "moName": "Фүкүока аймаг, Чикүго муж",
      "buName": "ချူးခုဂိုဒေသ၊ ဟုခုအိုကစီရင်စု",
      "khName": "តំបន់ជីគឹហ្គោនៃខេត្ដហ្វឹគឹអុកា",
      "neName": "फुकुओका जिल्ला, चिकुगो क्षेत्र"
    },
    "class15": {
      "code": "400042",
      "name": "筑後南部",
      "enName": "Southern Chikugo"
    },
    "class20": {
      "code": "4021100",
      "name": "筑後市",
      "enName": "Chikugo City",
      "kana": "ちくごし",
      "chName": "筑后市",
      "zhName": "築後市",
      "koName": "지쿠고 시",
      "esName": "Ciudad de Chikugo",
      "ptName": "cidade de Chikugo",
      "thName": "เมืองชิกุโกะ",
      "viName": "thành phố Chikugo",
      "inName": "kota Chikugo",
      "tlName": "siyudad ng Chikugo",
      "moName": "Чикүго хот",
      "buName": "ကျိကုဂေါ့ မြို့",
      "khName": "ទីក្រុង ឈីកូហ្គូ",
      "neName": "चिकुगो सहर"
    }
  },
  "4021200": {
    "office": {
      "code": "400000",
      "name": "福岡県",
      "enName": "Fukuoka",
      "officeName": "福岡管区気象台",
      "chName": "福冈县",
      "zhName": "福岡縣",
      "koName": "후쿠오카현",
      "esName": "Prefectura de Fukuoka",
      "ptName": "Província de Fukuoka",
      "thName": "จังหวัดฟุกุโอกะ",
      "viName": "Tỉnh Fukuoka",
      "inName": "Prefektur Fukuoka",
      "tlName": "Fukuoka Prefecture",
      "moName": "Фүкүока аймаг",
      "buName": "ဖူကူအိုက ပြည်နယ်",
      "khName": "ខេត្ដ ហ្វូគូកា",
      "neName": "फुकुओका जिल्ला"
    },
    "class10": {
      "code": "400040",
      "name": "筑後地方",
      "enName": "Chikugo Region",
      "chName": "福冈县筑后地方",
      "zhName": "福岡縣筑後地方",
      "koName": "후쿠오카 현 지쿠고 지방",
      "esName": "Región Chikugo, Prefectura de Fukuoka",
      "ptName": "Região de Chikugo da Província de Fukuoka",
      "thName": "ท้องถิ่นจิกุโงะ จังหวัดฟุกุโอกะ",
      "viName": "Vùng Chikugo, tỉnh Fukuoka",
      "inName": "Daerah Chikugo di Prefektur Fukuoka",
      "tlName": "Rehiyon ng Chikugo sa Fukuoka Prefecture",
      "moName": "Фүкүока аймаг, Чикүго муж",
      "buName": "ချူးခုဂိုဒေသ၊ ဟုခုအိုကစီရင်စု",
      "khName": "តំបន់ជីគឹហ្គោនៃខេត្ដហ្វឹគឹអុកា",
      "neName": "फुकुओका जिल्ला, चिकुगो क्षेत्र"
    },
    "class15": {
      "code": "400042",
      "name": "筑後南部",
      "enName": "Southern Chikugo"
    },
    "class20": {
      "code": "4021200",
      "name": "大川市",
      "enName": "Okawa City",
      "kana": "おおかわし",
      "chName": "大川市",
      "zhName": "大川市",
      "koName": "오카와 시",
      "esName": "Ciudad de Okawa",
      "ptName": "cidade de Okawa",
      "thName": "เมืองโอคาวะ",
      "viName": "thành phố Okawa",
      "inName": "kota Okawa",
      "tlName": "siyudad ng Okawa",
      "moName": "Окава хот",
      "buName": "အိုကာ့ဝ မြို့",
      "khName": "ទីក្រុង អូកាវ៉ា",
      "neName": "ओकावा सहर"
    }
  },
  "4021300": {
    "office": {
      "code": "400000",
      "name": "福岡県",
      "enName": "Fukuoka",
      "officeName": "福岡管区気象台",
      "chName": "福冈县",
      "zhName": "福岡縣",
      "koName": "후쿠오카현",
      "esName": "Prefectura de Fukuoka",
      "ptName": "Província de Fukuoka",
      "thName": "จังหวัดฟุกุโอกะ",
      "viName": "Tỉnh Fukuoka",
      "inName": "Prefektur Fukuoka",
      "tlName": "Fukuoka Prefecture",
      "moName": "Фүкүока аймаг",
      "buName": "ဖူကူအိုက ပြည်နယ်",
      "khName": "ខេត្ដ ហ្វូគូកា",
      "neName": "फुकुओका जिल्ला"
    },
    "class10": {
      "code": "400020",
      "name": "北九州地方",
      "enName": "Kitakyushu Region",
      "chName": "福冈县北九州地方",
      "zhName": "福岡縣北九州地方",
      "koName": "후쿠오카 현 기타큐슈 지방",
      "esName": "Región Kitakyushu, Prefectura de Fukuoka",
      "ptName": "Região de Kita-Kyūshū da Província de Fukuoka",
      "thName": "ท้องถิ่นคิตะกิวชู จังหวัดฟุกุโอกะ",
      "viName": "Vùng Kitakyushu, tỉnh Fukuoka",
      "inName": "Daerah Kitakyushu di Prefektur Fukuoka",
      "tlName": "Rehiyon ng Kita-Kyushu sa Fukuoka Prefecture",
      "moName": "Фүкүока аймаг, Китакюшү муж",
      "buName": "ခိတခယူးရှုးဒေသ၊ ဟုခုအိုကစီရင်စု",
      "khName": "តំបន់គីតាក់ខ្យឹហ្សឹនៃខេត្ដហ្វឹគឹអុកា",
      "neName": "फुकुओका जिल्ला, किताक्युस्यु क्षेत्र"
    },
    "class15": {
      "code": "400022",
      "name": "京築",
      "enName": "Keichiku"
    },
    "class20": {
      "code": "4021300",
      "name": "行橋市",
      "enName": "Yukuhashi City",
      "kana": "ゆくはしし",
      "chName": "行桥市",
      "zhName": "行橋市",
      "koName": "유쿠하시 시",
      "esName": "Ciudad de Yukuhashi",
      "ptName": "cidade de Yukuhashi",
      "thName": "เมืองยูคุฮาชิ",
      "viName": "thành phố Yukuhashi",
      "inName": "kota Yukuhashi",
      "tlName": "siyudad ng Yukuhashi",
      "moName": "Юкүхaши хот",
      "buName": "ယူကုဟာ့ရှိ မြို့",
      "khName": "ទីក្រុង យូគុហាស៊ី",
      "neName": "युकुहासी सहर"
    }
  },
  "4021400": {
    "office": {
      "code": "400000",
      "name": "福岡県",
      "enName": "Fukuoka",
      "officeName": "福岡管区気象台",
      "chName": "福冈县",
      "zhName": "福岡縣",
      "koName": "후쿠오카현",
      "esName": "Prefectura de Fukuoka",
      "ptName": "Província de Fukuoka",
      "thName": "จังหวัดฟุกุโอกะ",
      "viName": "Tỉnh Fukuoka",
      "inName": "Prefektur Fukuoka",
      "tlName": "Fukuoka Prefecture",
      "moName": "Фүкүока аймаг",
      "buName": "ဖူကူအိုက ပြည်နယ်",
      "khName": "ខេត្ដ ហ្វូគូកា",
      "neName": "फुकुओका जिल्ला"
    },
    "class10": {
      "code": "400020",
      "name": "北九州地方",
      "enName": "Kitakyushu Region",
      "chName": "福冈县北九州地方",
      "zhName": "福岡縣北九州地方",
      "koName": "후쿠오카 현 기타큐슈 지방",
      "esName": "Región Kitakyushu, Prefectura de Fukuoka",
      "ptName": "Região de Kita-Kyūshū da Província de Fukuoka",
      "thName": "ท้องถิ่นคิตะกิวชู จังหวัดฟุกุโอกะ",
      "viName": "Vùng Kitakyushu, tỉnh Fukuoka",
      "inName": "Daerah Kitakyushu di Prefektur Fukuoka",
      "tlName": "Rehiyon ng Kita-Kyushu sa Fukuoka Prefecture",
      "moName": "Фүкүока аймаг, Китакюшү муж",
      "buName": "ခိတခယူးရှုးဒေသ၊ ဟုခုအိုကစီရင်စု",
      "khName": "តំបន់គីតាក់ខ្យឹហ្សឹនៃខេត្ដហ្វឹគឹអុកា",
      "neName": "फुकुओका जिल्ला, किताक्युस्यु क्षेत्र"
    },
    "class15": {
      "code": "400022",
      "name": "京築",
      "enName": "Keichiku"
    },
    "class20": {
      "code": "4021400",
      "name": "豊前市",
      "enName": "Buzen City",
      "kana": "ぶぜんし",
      "chName": "丰前市",
      "zhName": "豐前市",
      "koName": "부젠 시",
      "esName": "Ciudad de Buzen",
      "ptName": "cidade de Buzen",
      "thName": "เมืองบุเซน",
      "viName": "thành phố Buzen",
      "inName": "kota Buzen",
      "tlName": "siyudad ng Buzen",
      "moName": "Бүзэн хот",
      "buName": "ဘူဇန်း မြို့",
      "khName": "ទីក្រុង ប៊ូហ្សេន",
      "neName": "बुजेन सहर"
    }
  },
  "4021500": {
    "office": {
      "code": "400000",
      "name": "福岡県",
      "enName": "Fukuoka",
      "officeName": "福岡管区気象台",
      "chName": "福冈县",
      "zhName": "福岡縣",
      "koName": "후쿠오카현",
      "esName": "Prefectura de Fukuoka",
      "ptName": "Província de Fukuoka",
      "thName": "จังหวัดฟุกุโอกะ",
      "viName": "Tỉnh Fukuoka",
      "inName": "Prefektur Fukuoka",
      "tlName": "Fukuoka Prefecture",
      "moName": "Фүкүока аймаг",
      "buName": "ဖူကူအိုက ပြည်နယ်",
      "khName": "ខេត្ដ ហ្វូគូកា",
      "neName": "फुकुओका जिल्ला"
    },
    "class10": {
      "code": "400020",
      "name": "北九州地方",
      "enName": "Kitakyushu Region",
      "chName": "福冈县北九州地方",
      "zhName": "福岡縣北九州地方",
      "koName": "후쿠오카 현 기타큐슈 지방",
      "esName": "Región Kitakyushu, Prefectura de Fukuoka",
      "ptName": "Região de Kita-Kyūshū da Província de Fukuoka",
      "thName": "ท้องถิ่นคิตะกิวชู จังหวัดฟุกุโอกะ",
      "viName": "Vùng Kitakyushu, tỉnh Fukuoka",
      "inName": "Daerah Kitakyushu di Prefektur Fukuoka",
      "tlName": "Rehiyon ng Kita-Kyushu sa Fukuoka Prefecture",
      "moName": "Фүкүока аймаг, Китакюшү муж",
      "buName": "ခိတခယူးရှုးဒေသ၊ ဟုခုအိုကစီရင်စု",
      "khName": "តំបន់គីតាក់ខ្យឹហ្សឹនៃខេត្ដហ្វឹគឹអុកា",
      "neName": "फुकुओका जिल्ला, किताक्युस्यु क्षेत्र"
    },
    "class15": {
      "code": "400021",
      "name": "北九州・遠賀地区",
      "enName": "Kitakyushu Onga District"
    },
    "class20": {
      "code": "4021500",
      "name": "中間市",
      "enName": "Nakama City",
      "kana": "なかまし",
      "chName": "中间市",
      "zhName": "中間市",
      "koName": "나카마 시",
      "esName": "Ciudad de Nakama",
      "ptName": "cidade de Nakama",
      "thName": "เมืองนาคามะ",
      "viName": "thành phố Nakama",
      "inName": "kota Nakama",
      "tlName": "siyudad ng Nakama",
      "moName": "Нaкамa хот",
      "buName": "နာကားမ မြို့",
      "khName": "ទីក្រុង ណាកាម៉ា",
      "neName": "नाकामा सहर"
    }
  },
  "4021600": {
    "office": {
      "code": "400000",
      "name": "福岡県",
      "enName": "Fukuoka",
      "officeName": "福岡管区気象台",
      "chName": "福冈县",
      "zhName": "福岡縣",
      "koName": "후쿠오카현",
      "esName": "Prefectura de Fukuoka",
      "ptName": "Província de Fukuoka",
      "thName": "จังหวัดฟุกุโอกะ",
      "viName": "Tỉnh Fukuoka",
      "inName": "Prefektur Fukuoka",
      "tlName": "Fukuoka Prefecture",
      "moName": "Фүкүока аймаг",
      "buName": "ဖူကူအိုက ပြည်နယ်",
      "khName": "ខេត្ដ ហ្វូគូកា",
      "neName": "फुकुओका जिल्ला"
    },
    "class10": {
      "code": "400040",
      "name": "筑後地方",
      "enName": "Chikugo Region",
      "chName": "福冈县筑后地方",
      "zhName": "福岡縣筑後地方",
      "koName": "후쿠오카 현 지쿠고 지방",
      "esName": "Región Chikugo, Prefectura de Fukuoka",
      "ptName": "Região de Chikugo da Província de Fukuoka",
      "thName": "ท้องถิ่นจิกุโงะ จังหวัดฟุกุโอกะ",
      "viName": "Vùng Chikugo, tỉnh Fukuoka",
      "inName": "Daerah Chikugo di Prefektur Fukuoka",
      "tlName": "Rehiyon ng Chikugo sa Fukuoka Prefecture",
      "moName": "Фүкүока аймаг, Чикүго муж",
      "buName": "ချူးခုဂိုဒေသ၊ ဟုခုအိုကစီရင်စု",
      "khName": "តំបន់ជីគឹហ្គោនៃខេត្ដហ្វឹគឹអុកា",
      "neName": "फुकुओका जिल्ला, चिकुगो क्षेत्र"
    },
    "class15": {
      "code": "400041",
      "name": "筑後北部",
      "enName": "Northern Chikugo"
    },
    "class20": {
      "code": "4021600",
      "name": "小郡市",
      "enName": "Ogori City",
      "kana": "おごおりし",
      "chName": "小郡市",
      "zhName": "小郡市",
      "koName": "오고리 시",
      "esName": "Ciudad de Ogōri",
      "ptName": "cidade de Ogori",
      "thName": "เมืองโอโกริ",
      "viName": "thành phố Ogori",
      "inName": "kota Ogori",
      "tlName": "siyudad ng Ogori",
      "moName": "Огори хот",
      "buName": "အိုးဂေါ့ရိ မြို့",
      "khName": "ទីក្រុង អូហ្គរី",
      "neName": "ओगोरी सहर"
    }
  },
  "4021700": {
    "office": {
      "code": "400000",
      "name": "福岡県",
      "enName": "Fukuoka",
      "officeName": "福岡管区気象台",
      "chName": "福冈县",
      "zhName": "福岡縣",
      "koName": "후쿠오카현",
      "esName": "Prefectura de Fukuoka",
      "ptName": "Província de Fukuoka",
      "thName": "จังหวัดฟุกุโอกะ",
      "viName": "Tỉnh Fukuoka",
      "inName": "Prefektur Fukuoka",
      "tlName": "Fukuoka Prefecture",
      "moName": "Фүкүока аймаг",
      "buName": "ဖူကူအိုက ပြည်နယ်",
      "khName": "ខេត្ដ ហ្វូគូកា",
      "neName": "फुकुओका जिल्ला"
    },
    "class10": {
      "code": "400010",
      "name": "福岡地方",
      "enName": "Fukuoka Region",
      "chName": "福冈县福冈地方",
      "zhName": "福岡縣福岡地方",
      "koName": "후쿠오카 현 후쿠오카 지방",
      "esName": "Región Fukushima, Prefectura de Fukuoka",
      "ptName": "Região de Fukuoka da Província de Fukuoka",
      "thName": "ท้องถิ่นฟุกุโอกะ จังหวัดฟุกุโอกะ",
      "viName": "Vùng Fukuoka, tỉnh Fukuoka",
      "inName": "Daerah Fukuoka di Prefektur Fukuoka",
      "tlName": "Rehiyon ng Fukuoka sa Fukuoka Prefecture",
      "moName": "Фүкүока аймаг, Фүкүока муж",
      "buName": "ဟုခုအိုကဒေသ၊ ဟုခုအိုကစီရင်စု",
      "khName": "តំបន់ហ្វឹគឹអុកានៃខេត្ដហ្វឹគឹអុកា",
      "neName": "फुकुओका जिल्ला, फुकुओका क्षेत्र"
    },
    "class15": {
      "code": "400010",
      "name": "福岡地方",
      "enName": "Fukuoka Region"
    },
    "class20": {
      "code": "4021700",
      "name": "筑紫野市",
      "enName": "Chikushino City",
      "kana": "ちくしのし",
      "chName": "筑紫野市",
      "zhName": "築紫野市",
      "koName": "지쿠시노 시",
      "esName": "Ciudad de Chikushino",
      "ptName": "cidade de Chikushino",
      "thName": "เมืองชิกุชิโนะ",
      "viName": "thành phố Chikushino",
      "inName": "kota Chikushino",
      "tlName": "siyudad ng Chikushino",
      "moName": "Чикүшино хот",
      "buName": "ချီကုရှိနို မြို့",
      "khName": "ទីក្រុង ឈីគូស៊ីណូ",
      "neName": "चिकुशिनो सहर"
    }
  },
  "4021800": {
    "office": {
      "code": "400000",
      "name": "福岡県",
      "enName": "Fukuoka",
      "officeName": "福岡管区気象台",
      "chName": "福冈县",
      "zhName": "福岡縣",
      "koName": "후쿠오카현",
      "esName": "Prefectura de Fukuoka",
      "ptName": "Província de Fukuoka",
      "thName": "จังหวัดฟุกุโอกะ",
      "viName": "Tỉnh Fukuoka",
      "inName": "Prefektur Fukuoka",
      "tlName": "Fukuoka Prefecture",
      "moName": "Фүкүока аймаг",
      "buName": "ဖူကူအိုက ပြည်နယ်",
      "khName": "ខេត្ដ ហ្វូគូកា",
      "neName": "फुकुओका जिल्ला"
    },
    "class10": {
      "code": "400010",
      "name": "福岡地方",
      "enName": "Fukuoka Region",
      "chName": "福冈县福冈地方",
      "zhName": "福岡縣福岡地方",
      "koName": "후쿠오카 현 후쿠오카 지방",
      "esName": "Región Fukushima, Prefectura de Fukuoka",
      "ptName": "Região de Fukuoka da Província de Fukuoka",
      "thName": "ท้องถิ่นฟุกุโอกะ จังหวัดฟุกุโอกะ",
      "viName": "Vùng Fukuoka, tỉnh Fukuoka",
      "inName": "Daerah Fukuoka di Prefektur Fukuoka",
      "tlName": "Rehiyon ng Fukuoka sa Fukuoka Prefecture",
      "moName": "Фүкүока аймаг, Фүкүока муж",
      "buName": "ဟုခုအိုကဒေသ၊ ဟုခုအိုကစီရင်စု",
      "khName": "តំបន់ហ្វឹគឹអុកានៃខេត្ដហ្វឹគឹអុកា",
      "neName": "फुकुओका जिल्ला, फुकुओका क्षेत्र"
    },
    "class15": {
      "code": "400010",
      "name": "福岡地方",
      "enName": "Fukuoka Region"
    },
    "class20": {
      "code": "4021800",
      "name": "春日市",
      "enName": "Kasuga City",
      "kana": "かすがし",
      "chName": "春日市",
      "zhName": "春日市",
      "koName": "가스가 시",
      "esName": "Ciudad de Kasuga",
      "ptName": "cidade de Kasuga",
      "thName": "เมืองคะสุกะ",
      "viName": "thành phố Kasuga",
      "inName": "kota Kasuga",
      "tlName": "siyudad ng Kasuga",
      "moName": "Касүгa хот",
      "buName": "ခါဆုဂ မြို့",
      "khName": "ទីក្រុង កាស៊ូហ្គា",
      "neName": "कासुगा सहर"
    }
  },
  "4021900": {
    "office": {
      "code": "400000",
      "name": "福岡県",
      "enName": "Fukuoka",
      "officeName": "福岡管区気象台",
      "chName": "福冈县",
      "zhName": "福岡縣",
      "koName": "후쿠오카현",
      "esName": "Prefectura de Fukuoka",
      "ptName": "Província de Fukuoka",
      "thName": "จังหวัดฟุกุโอกะ",
      "viName": "Tỉnh Fukuoka",
      "inName": "Prefektur Fukuoka",
      "tlName": "Fukuoka Prefecture",
      "moName": "Фүкүока аймаг",
      "buName": "ဖူကူအိုက ပြည်နယ်",
      "khName": "ខេត្ដ ហ្វូគូកា",
      "neName": "फुकुओका जिल्ला"
    },
    "class10": {
      "code": "400010",
      "name": "福岡地方",
      "enName": "Fukuoka Region",
      "chName": "福冈县福冈地方",
      "zhName": "福岡縣福岡地方",
      "koName": "후쿠오카 현 후쿠오카 지방",
      "esName": "Región Fukushima, Prefectura de Fukuoka",
      "ptName": "Região de Fukuoka da Província de Fukuoka",
      "thName": "ท้องถิ่นฟุกุโอกะ จังหวัดฟุกุโอกะ",
      "viName": "Vùng Fukuoka, tỉnh Fukuoka",
      "inName": "Daerah Fukuoka di Prefektur Fukuoka",
      "tlName": "Rehiyon ng Fukuoka sa Fukuoka Prefecture",
      "moName": "Фүкүока аймаг, Фүкүока муж",
      "buName": "ဟုခုအိုကဒေသ၊ ဟုခုအိုကစီရင်စု",
      "khName": "តំបន់ហ្វឹគឹអុកានៃខេត្ដហ្វឹគឹអុកា",
      "neName": "फुकुओका जिल्ला, फुकुओका क्षेत्र"
    },
    "class15": {
      "code": "400010",
      "name": "福岡地方",
      "enName": "Fukuoka Region"
    },
    "class20": {
      "code": "4021900",
      "name": "大野城市",
      "enName": "Onojo City",
      "kana": "おおのじょうし",
      "chName": "大野城市",
      "zhName": "大野城市",
      "koName": "오노조 시",
      "esName": "Ciudad de Onojyo",
      "ptName": "cidade de Onojo",
      "thName": "เมืองโอโนะโจ",
      "viName": "thành phố Onojo",
      "inName": "kota Onojo",
      "tlName": "siyudad ng Onojo",
      "moName": "Оножо хот",
      "buName": "အို့နောဂျို မြို့",
      "khName": "ទីក្រុង អូណូចូ",
      "neName": "ओनोजो सहर"
    }
  },
  "4022000": {
    "office": {
      "code": "400000",
      "name": "福岡県",
      "enName": "Fukuoka",
      "officeName": "福岡管区気象台",
      "chName": "福冈县",
      "zhName": "福岡縣",
      "koName": "후쿠오카현",
      "esName": "Prefectura de Fukuoka",
      "ptName": "Província de Fukuoka",
      "thName": "จังหวัดฟุกุโอกะ",
      "viName": "Tỉnh Fukuoka",
      "inName": "Prefektur Fukuoka",
      "tlName": "Fukuoka Prefecture",
      "moName": "Фүкүока аймаг",
      "buName": "ဖူကူအိုက ပြည်နယ်",
      "khName": "ខេត្ដ ហ្វូគូកា",
      "neName": "फुकुओका जिल्ला"
    },
    "class10": {
      "code": "400010",
      "name": "福岡地方",
      "enName": "Fukuoka Region",
      "chName": "福冈县福冈地方",
      "zhName": "福岡縣福岡地方",
      "koName": "후쿠오카 현 후쿠오카 지방",
      "esName": "Región Fukushima, Prefectura de Fukuoka",
      "ptName": "Região de Fukuoka da Província de Fukuoka",
      "thName": "ท้องถิ่นฟุกุโอกะ จังหวัดฟุกุโอกะ",
      "viName": "Vùng Fukuoka, tỉnh Fukuoka",
      "inName": "Daerah Fukuoka di Prefektur Fukuoka",
      "tlName": "Rehiyon ng Fukuoka sa Fukuoka Prefecture",
      "moName": "Фүкүока аймаг, Фүкүока муж",
      "buName": "ဟုခုအိုကဒေသ၊ ဟုခုအိုကစီရင်စု",
      "khName": "តំបន់ហ្វឹគឹអុកានៃខេត្ដហ្វឹគឹអុកា",
      "neName": "फुकुओका जिल्ला, फुकुओका क्षेत्र"
    },
    "class15": {
      "code": "400010",
      "name": "福岡地方",
      "enName": "Fukuoka Region"
    },
    "class20": {
      "code": "4022000",
      "name": "宗像市",
      "enName": "Munakata City",
      "kana": "むなかたし",
      "chName": "宗像市",
      "zhName": "宗像市",
      "koName": "무나카타 시",
      "esName": "Ciudad de Munakata",
      "ptName": "cidade de Munakata",
      "thName": "เมืองมุนาคาตะ",
      "viName": "thành phố Munakata",
      "inName": "kota Munakata",
      "tlName": "siyudad ng Munakata",
      "moName": "Мүнaката хот",
      "buName": "မူနားကာ့တ မြို့",
      "khName": "ទីក្រុង ​ មូណាកាតា",
      "neName": "मुनाकाता सहर"
    }
  },
  "4022100": {
    "office": {
      "code": "400000",
      "name": "福岡県",
      "enName": "Fukuoka",
      "officeName": "福岡管区気象台",
      "chName": "福冈县",
      "zhName": "福岡縣",
      "koName": "후쿠오카현",
      "esName": "Prefectura de Fukuoka",
      "ptName": "Província de Fukuoka",
      "thName": "จังหวัดฟุกุโอกะ",
      "viName": "Tỉnh Fukuoka",
      "inName": "Prefektur Fukuoka",
      "tlName": "Fukuoka Prefecture",
      "moName": "Фүкүока аймаг",
      "buName": "ဖူကူအိုက ပြည်နယ်",
      "khName": "ខេត្ដ ហ្វូគូកា",
      "neName": "फुकुओका जिल्ला"
    },
    "class10": {
      "code": "400010",
      "name": "福岡地方",
      "enName": "Fukuoka Region",
      "chName": "福冈县福冈地方",
      "zhName": "福岡縣福岡地方",
      "koName": "후쿠오카 현 후쿠오카 지방",
      "esName": "Región Fukushima, Prefectura de Fukuoka",
      "ptName": "Região de Fukuoka da Província de Fukuoka",
      "thName": "ท้องถิ่นฟุกุโอกะ จังหวัดฟุกุโอกะ",
      "viName": "Vùng Fukuoka, tỉnh Fukuoka",
      "inName": "Daerah Fukuoka di Prefektur Fukuoka",
      "tlName": "Rehiyon ng Fukuoka sa Fukuoka Prefecture",
      "moName": "Фүкүока аймаг, Фүкүока муж",
      "buName": "ဟုခုအိုကဒေသ၊ ဟုခုအိုကစီရင်စု",
      "khName": "តំបន់ហ្វឹគឹអុកានៃខេត្ដហ្វឹគឹអុកា",
      "neName": "फुकुओका जिल्ला, फुकुओका क्षेत्र"
    },
    "class15": {
      "code": "400010",
      "name": "福岡地方",
      "enName": "Fukuoka Region"
    },
    "class20": {
      "code": "4022100",
      "name": "太宰府市",
      "enName": "Dazaifu City",
      "kana": "だざいふし",
      "chName": "太宰府市",
      "zhName": "太宰府市",
      "koName": "다자이후 시",
      "esName": "Ciudad de Dazaifu",
      "ptName": "cidade de Dazaifu",
      "thName": "เมืองดาไซฟุ",
      "viName": "thành phố Dazaifu",
      "inName": "kota Dazaifu",
      "tlName": "siyudad ng Dazaifu",
      "moName": "Дазaйфү хот",
      "buName": "ဒါဇားယိဖူ မြို့",
      "khName": "ទីក្រុង ដាហ្សៃហ្វី",
      "neName": "दाजाइफु सहर"
    }
  },
  "4022300": {
    "office": {
      "code": "400000",
      "name": "福岡県",
      "enName": "Fukuoka",
      "officeName": "福岡管区気象台",
      "chName": "福冈县",
      "zhName": "福岡縣",
      "koName": "후쿠오카현",
      "esName": "Prefectura de Fukuoka",
      "ptName": "Província de Fukuoka",
      "thName": "จังหวัดฟุกุโอกะ",
      "viName": "Tỉnh Fukuoka",
      "inName": "Prefektur Fukuoka",
      "tlName": "Fukuoka Prefecture",
      "moName": "Фүкүока аймаг",
      "buName": "ဖူကူအိုက ပြည်နယ်",
      "khName": "ខេត្ដ ហ្វូគូកា",
      "neName": "फुकुओका जिल्ला"
    },
    "class10": {
      "code": "400010",
      "name": "福岡地方",
      "enName": "Fukuoka Region",
      "chName": "福冈县福冈地方",
      "zhName": "福岡縣福岡地方",
      "koName": "후쿠오카 현 후쿠오카 지방",
      "esName": "Región Fukushima, Prefectura de Fukuoka",
      "ptName": "Região de Fukuoka da Província de Fukuoka",
      "thName": "ท้องถิ่นฟุกุโอกะ จังหวัดฟุกุโอกะ",
      "viName": "Vùng Fukuoka, tỉnh Fukuoka",
      "inName": "Daerah Fukuoka di Prefektur Fukuoka",
      "tlName": "Rehiyon ng Fukuoka sa Fukuoka Prefecture",
      "moName": "Фүкүока аймаг, Фүкүока муж",
      "buName": "ဟုခုအိုကဒေသ၊ ဟုခုအိုကစီရင်စု",
      "khName": "តំបន់ហ្វឹគឹអុកានៃខេត្ដហ្វឹគឹអុកា",
      "neName": "फुकुओका जिल्ला, फुकुओका क्षेत्र"
    },
    "class15": {
      "code": "400010",
      "name": "福岡地方",
      "enName": "Fukuoka Region"
    },
    "class20": {
      "code": "4022300",
      "name": "古賀市",
      "enName": "Koga City",
      "kana": "こがし",
      "chName": "福冈古贺市",
      "zhName": "福岡古賀市",
      "koName": "후쿠오카 고가 시",
      "esName": "Ciudad de Koga, Fukuoka",
      "ptName": "Fukuoka, cidade de Koga",
      "thName": "เมืองโคงะ ฟุกุโอกะ",
      "viName": "Thành phố Koga, Fukuoka",
      "inName": "Kota Koga, Fukuoka",
      "tlName": "siyudad ng Koga, Fukuoka",
      "moName": "Фүкүока Кога хот",
      "buName": "ဟုခုအိုကကိုဂမြို့",
      "khName": "ទីក្រុងកូកា ហ្វឹគឹអុកា",
      "neName": "फुकुओका कोगा सहर"
    }
  },
  "4022400": {
    "office": {
      "code": "400000",
      "name": "福岡県",
      "enName": "Fukuoka",
      "officeName": "福岡管区気象台",
      "chName": "福冈县",
      "zhName": "福岡縣",
      "koName": "후쿠오카현",
      "esName": "Prefectura de Fukuoka",
      "ptName": "Província de Fukuoka",
      "thName": "จังหวัดฟุกุโอกะ",
      "viName": "Tỉnh Fukuoka",
      "inName": "Prefektur Fukuoka",
      "tlName": "Fukuoka Prefecture",
      "moName": "Фүкүока аймаг",
      "buName": "ဖူကူအိုက ပြည်နယ်",
      "khName": "ខេត្ដ ហ្វូគូកា",
      "neName": "फुकुओका जिल्ला"
    },
    "class10": {
      "code": "400010",
      "name": "福岡地方",
      "enName": "Fukuoka Region",
      "chName": "福冈县福冈地方",
      "zhName": "福岡縣福岡地方",
      "koName": "후쿠오카 현 후쿠오카 지방",
      "esName": "Región Fukushima, Prefectura de Fukuoka",
      "ptName": "Região de Fukuoka da Província de Fukuoka",
      "thName": "ท้องถิ่นฟุกุโอกะ จังหวัดฟุกุโอกะ",
      "viName": "Vùng Fukuoka, tỉnh Fukuoka",
      "inName": "Daerah Fukuoka di Prefektur Fukuoka",
      "tlName": "Rehiyon ng Fukuoka sa Fukuoka Prefecture",
      "moName": "Фүкүока аймаг, Фүкүока муж",
      "buName": "ဟုခုအိုကဒေသ၊ ဟုခုအိုကစီရင်စု",
      "khName": "តំបន់ហ្វឹគឹអុកានៃខេត្ដហ្វឹគឹអុកា",
      "neName": "फुकुओका जिल्ला, फुकुओका क्षेत्र"
    },
    "class15": {
      "code": "400010",
      "name": "福岡地方",
      "enName": "Fukuoka Region"
    },
    "class20": {
      "code": "4022400",
      "name": "福津市",
      "enName": "Fukutsu City",
      "kana": "ふくつし",
      "chName": "福津市",
      "zhName": "福津市",
      "koName": "후쿠쓰 시",
      "esName": "Ciudad de Fukutsu",
      "ptName": "cidade de Fukutsu",
      "thName": "เมืองฟุคุสึ",
      "viName": "thành phố Fukutsu",
      "inName": "kota Fukutsu",
      "tlName": "siyudad ng Fukutsu",
      "moName": "Фүкүцү хот",
      "buName": "ဖူကုဆု မြို့",
      "khName": "ទីក្រុង ហ្វូគូស៊ូ",
      "neName": "फुकुत्सु सहर"
    }
  },
  "4022500": {
    "office": {
      "code": "400000",
      "name": "福岡県",
      "enName": "Fukuoka",
      "officeName": "福岡管区気象台",
      "chName": "福冈县",
      "zhName": "福岡縣",
      "koName": "후쿠오카현",
      "esName": "Prefectura de Fukuoka",
      "ptName": "Província de Fukuoka",
      "thName": "จังหวัดฟุกุโอกะ",
      "viName": "Tỉnh Fukuoka",
      "inName": "Prefektur Fukuoka",
      "tlName": "Fukuoka Prefecture",
      "moName": "Фүкүока аймаг",
      "buName": "ဖူကူအိုက ပြည်နယ်",
      "khName": "ខេត្ដ ហ្វូគូកា",
      "neName": "फुकुओका जिल्ला"
    },
    "class10": {
      "code": "400040",
      "name": "筑後地方",
      "enName": "Chikugo Region",
      "chName": "福冈县筑后地方",
      "zhName": "福岡縣筑後地方",
      "koName": "후쿠오카 현 지쿠고 지방",
      "esName": "Región Chikugo, Prefectura de Fukuoka",
      "ptName": "Região de Chikugo da Província de Fukuoka",
      "thName": "ท้องถิ่นจิกุโงะ จังหวัดฟุกุโอกะ",
      "viName": "Vùng Chikugo, tỉnh Fukuoka",
      "inName": "Daerah Chikugo di Prefektur Fukuoka",
      "tlName": "Rehiyon ng Chikugo sa Fukuoka Prefecture",
      "moName": "Фүкүока аймаг, Чикүго муж",
      "buName": "ချူးခုဂိုဒေသ၊ ဟုခုအိုကစီရင်စု",
      "khName": "តំបន់ជីគឹហ្គោនៃខេត្ដហ្វឹគឹអុកា",
      "neName": "फुकुओका जिल्ला, चिकुगो क्षेत्र"
    },
    "class15": {
      "code": "400041",
      "name": "筑後北部",
      "enName": "Northern Chikugo"
    },
    "class20": {
      "code": "4022500",
      "name": "うきは市",
      "enName": "Ukiha City",
      "kana": "うきはし",
      "chName": "浮羽市",
      "zhName": "浮羽市",
      "koName": "우키하 시",
      "esName": "Ciudad de Ukiha",
      "ptName": "cidade de Ukiha",
      "thName": "เมืองอุคิฮะ",
      "viName": "thành phố Ukiha",
      "inName": "kota Ukiha",
      "tlName": "siyudad ng Ukiha",
      "moName": "Үкихa хот",
      "buName": "အုကီဟ မြို့",
      "khName": "ទីក្រុង យូគីហា",
      "neName": "उकिहा सहर"
    }
  },
  "4022600": {
    "office": {
      "code": "400000",
      "name": "福岡県",
      "enName": "Fukuoka",
      "officeName": "福岡管区気象台",
      "chName": "福冈县",
      "zhName": "福岡縣",
      "koName": "후쿠오카현",
      "esName": "Prefectura de Fukuoka",
      "ptName": "Província de Fukuoka",
      "thName": "จังหวัดฟุกุโอกะ",
      "viName": "Tỉnh Fukuoka",
      "inName": "Prefektur Fukuoka",
      "tlName": "Fukuoka Prefecture",
      "moName": "Фүкүока аймаг",
      "buName": "ဖူကူအိုက ပြည်နယ်",
      "khName": "ខេត្ដ ហ្វូគូកា",
      "neName": "फुकुओका जिल्ला"
    },
    "class10": {
      "code": "400030",
      "name": "筑豊地方",
      "enName": "Chikuho Region",
      "chName": "福冈县筑丰地方",
      "zhName": "福岡縣筑豐地方",
      "koName": "후쿠오카 현 츠쿠호 지방",
      "esName": "Región Chikuhou, Prefectura de Fukuoka",
      "ptName": "Região de Chikuhō da Província de Fukuoka",
      "thName": "ท้องถิ่นจิกุโฮ จังหวัดฟุกุโอกะ",
      "viName": "Vùng Chikuho, tỉnh Fukuoka",
      "inName": "Daerah Chikuho di Prefektur Fukuoka",
      "tlName": "Rehiyon ng Chikuho sa Fukuoka Prefecture",
      "moName": "Фүкүока аймаг, Чикүхо муж",
      "buName": "ချိခုဟိုဒေသ၊ ဟုခုအိုကစီရင်စု",
      "khName": "តំបន់ជីគឹហូនៃខេត្ដហ្វឹគឹអុកា",
      "neName": "फुकुओका जिल्ला, चिकुहो क्षेत्र"
    },
    "class15": {
      "code": "400030",
      "name": "筑豊地方",
      "enName": "Chikuho Region"
    },
    "class20": {
      "code": "4022600",
      "name": "宮若市",
      "enName": "Miyawaka City",
      "kana": "みやわかし",
      "chName": "宫若市",
      "zhName": "宮若市",
      "koName": "미야와카 시",
      "esName": "Ciudad de Miyawaka",
      "ptName": "cidade de Miyawaka",
      "thName": "เมืองมิยาวากะ",
      "viName": "thành phố Miyawaka",
      "inName": "kota Miyawaka",
      "tlName": "siyudad ng Miyawaka",
      "moName": "Миявака хот",
      "buName": "မီယားဝါ့က မြို့",
      "khName": "ទីក្រុង មីយ៉ាវ៉ាកា",
      "neName": "मियावाका सहर"
    }
  },
  "4022700": {
    "office": {
      "code": "400000",
      "name": "福岡県",
      "enName": "Fukuoka",
      "officeName": "福岡管区気象台",
      "chName": "福冈县",
      "zhName": "福岡縣",
      "koName": "후쿠오카현",
      "esName": "Prefectura de Fukuoka",
      "ptName": "Província de Fukuoka",
      "thName": "จังหวัดฟุกุโอกะ",
      "viName": "Tỉnh Fukuoka",
      "inName": "Prefektur Fukuoka",
      "tlName": "Fukuoka Prefecture",
      "moName": "Фүкүока аймаг",
      "buName": "ဖူကူအိုက ပြည်နယ်",
      "khName": "ខេត្ដ ហ្វូគូកា",
      "neName": "फुकुओका जिल्ला"
    },
    "class10": {
      "code": "400030",
      "name": "筑豊地方",
      "enName": "Chikuho Region",
      "chName": "福冈县筑丰地方",
      "zhName": "福岡縣筑豐地方",
      "koName": "후쿠오카 현 츠쿠호 지방",
      "esName": "Región Chikuhou, Prefectura de Fukuoka",
      "ptName": "Região de Chikuhō da Província de Fukuoka",
      "thName": "ท้องถิ่นจิกุโฮ จังหวัดฟุกุโอกะ",
      "viName": "Vùng Chikuho, tỉnh Fukuoka",
      "inName": "Daerah Chikuho di Prefektur Fukuoka",
      "tlName": "Rehiyon ng Chikuho sa Fukuoka Prefecture",
      "moName": "Фүкүока аймаг, Чикүхо муж",
      "buName": "ချိခုဟိုဒေသ၊ ဟုခုအိုကစီရင်စု",
      "khName": "តំបន់ជីគឹហូនៃខេត្ដហ្វឹគឹអុកា",
      "neName": "फुकुओका जिल्ला, चिकुहो क्षेत्र"
    },
    "class15": {
      "code": "400030",
      "name": "筑豊地方",
      "enName": "Chikuho Region"
    },
    "class20": {
      "code": "4022700",
      "name": "嘉麻市",
      "enName": "Kama City",
      "kana": "かまし",
      "chName": "嘉麻市",
      "zhName": "嘉麻市",
      "koName": "가마 시",
      "esName": "Ciudad de Kama",
      "ptName": "cidade de Kama",
      "thName": "เมืองคามะ",
      "viName": "thành phố Kama",
      "inName": "kota Kama",
      "tlName": "siyudad ng Kama",
      "moName": "Камa хот",
      "buName": "ခါမ မြို့",
      "khName": "ទីក្រុង កាម៉ា",
      "neName": "कामा सहर"
    }
  },
  "4022800": {
    "office": {
      "code": "400000",
      "name": "福岡県",
      "enName": "Fukuoka",
      "officeName": "福岡管区気象台",
      "chName": "福冈县",
      "zhName": "福岡縣",
      "koName": "후쿠오카현",
      "esName": "Prefectura de Fukuoka",
      "ptName": "Província de Fukuoka",
      "thName": "จังหวัดฟุกุโอกะ",
      "viName": "Tỉnh Fukuoka",
      "inName": "Prefektur Fukuoka",
      "tlName": "Fukuoka Prefecture",
      "moName": "Фүкүока аймаг",
      "buName": "ဖူကူအိုက ပြည်နယ်",
      "khName": "ខេត្ដ ហ្វូគូកា",
      "neName": "फुकुओका जिल्ला"
    },
    "class10": {
      "code": "400040",
      "name": "筑後地方",
      "enName": "Chikugo Region",
      "chName": "福冈县筑后地方",
      "zhName": "福岡縣筑後地方",
      "koName": "후쿠오카 현 지쿠고 지방",
      "esName": "Región Chikugo, Prefectura de Fukuoka",
      "ptName": "Região de Chikugo da Província de Fukuoka",
      "thName": "ท้องถิ่นจิกุโงะ จังหวัดฟุกุโอกะ",
      "viName": "Vùng Chikugo, tỉnh Fukuoka",
      "inName": "Daerah Chikugo di Prefektur Fukuoka",
      "tlName": "Rehiyon ng Chikugo sa Fukuoka Prefecture",
      "moName": "Фүкүока аймаг, Чикүго муж",
      "buName": "ချူးခုဂိုဒေသ၊ ဟုခုအိုကစီရင်စု",
      "khName": "តំបន់ជីគឹហ្គោនៃខេត្ដហ្វឹគឹអុកា",
      "neName": "फुकुओका जिल्ला, चिकुगो क्षेत्र"
    },
    "class15": {
      "code": "400041",
      "name": "筑後北部",
      "enName": "Northern Chikugo"
    },
    "class20": {
      "code": "4022800",
      "name": "朝倉市",
      "enName": "Asakura City",
      "kana": "あさくらし",
      "chName": "朝仓市",
      "zhName": "朝倉市",
      "koName": "아사쿠라 시",
      "esName": "Ciudad de Asakura",
      "ptName": "cidade de Asakura",
      "thName": "เมืองอาซาคุระ",
      "viName": "thành phố Asakura",
      "inName": "kota Asakura",
      "tlName": "siyudad ng Asakura",
      "moName": "Aсaкүра хот",
      "buName": "အာဆားကုရ မြို့",
      "khName": "ទីក្រុង អាសាគូរ៉ា",
      "neName": "आसाकुरा सहर"
    }
  },
  "4022900": {
    "office": {
      "code": "400000",
      "name": "福岡県",
      "enName": "Fukuoka",
      "officeName": "福岡管区気象台",
      "chName": "福冈县",
      "zhName": "福岡縣",
      "koName": "후쿠오카현",
      "esName": "Prefectura de Fukuoka",
      "ptName": "Província de Fukuoka",
      "thName": "จังหวัดฟุกุโอกะ",
      "viName": "Tỉnh Fukuoka",
      "inName": "Prefektur Fukuoka",
      "tlName": "Fukuoka Prefecture",
      "moName": "Фүкүока аймаг",
      "buName": "ဖူကူအိုက ပြည်နယ်",
      "khName": "ខេត្ដ ហ្វូគូកា",
      "neName": "फुकुओका जिल्ला"
    },
    "class10": {
      "code": "400040",
      "name": "筑後地方",
      "enName": "Chikugo Region",
      "chName": "福冈县筑后地方",
      "zhName": "福岡縣筑後地方",
      "koName": "후쿠오카 현 지쿠고 지방",
      "esName": "Región Chikugo, Prefectura de Fukuoka",
      "ptName": "Região de Chikugo da Província de Fukuoka",
      "thName": "ท้องถิ่นจิกุโงะ จังหวัดฟุกุโอกะ",
      "viName": "Vùng Chikugo, tỉnh Fukuoka",
      "inName": "Daerah Chikugo di Prefektur Fukuoka",
      "tlName": "Rehiyon ng Chikugo sa Fukuoka Prefecture",
      "moName": "Фүкүока аймаг, Чикүго муж",
      "buName": "ချူးခုဂိုဒေသ၊ ဟုခုအိုကစီရင်စု",
      "khName": "តំបន់ជីគឹហ្គោនៃខេត្ដហ្វឹគឹអុកា",
      "neName": "फुकुओका जिल्ला, चिकुगो क्षेत्र"
    },
    "class15": {
      "code": "400042",
      "name": "筑後南部",
      "enName": "Southern Chikugo"
    },
    "class20": {
      "code": "4022900",
      "name": "みやま市",
      "enName": "Miyama City",
      "kana": "みやまし",
      "chName": "三山市",
      "zhName": "三山市",
      "koName": "미야마 시",
      "esName": "Ciudad de Miyama",
      "ptName": "cidade de Miyama",
      "thName": "เมืองมิยามะ",
      "viName": "thành phố Miyama",
      "inName": "kota Miyama",
      "tlName": "siyudad ng Miyama",
      "moName": "Миямa хот",
      "buName": "မီယားမ မြို့",
      "khName": "ទីក្រុង មីយ៉ាម៉ា",
      "neName": "मियामा सहर"
    }
  },
  "4023000": {
    "office": {
      "code": "400000",
      "name": "福岡県",
      "enName": "Fukuoka",
      "officeName": "福岡管区気象台",
      "chName": "福冈县",
      "zhName": "福岡縣",
      "koName": "후쿠오카현",
      "esName": "Prefectura de Fukuoka",
      "ptName": "Província de Fukuoka",
      "thName": "จังหวัดฟุกุโอกะ",
      "viName": "Tỉnh Fukuoka",
      "inName": "Prefektur Fukuoka",
      "tlName": "Fukuoka Prefecture",
      "moName": "Фүкүока аймаг",
      "buName": "ဖူကူအိုက ပြည်နယ်",
      "khName": "ខេត្ដ ហ្វូគូកា",
      "neName": "फुकुओका जिल्ला"
    },
    "class10": {
      "code": "400010",
      "name": "福岡地方",
      "enName": "Fukuoka Region",
      "chName": "福冈县福冈地方",
      "zhName": "福岡縣福岡地方",
      "koName": "후쿠오카 현 후쿠오카 지방",
      "esName": "Región Fukushima, Prefectura de Fukuoka",
      "ptName": "Região de Fukuoka da Província de Fukuoka",
      "thName": "ท้องถิ่นฟุกุโอกะ จังหวัดฟุกุโอกะ",
      "viName": "Vùng Fukuoka, tỉnh Fukuoka",
      "inName": "Daerah Fukuoka di Prefektur Fukuoka",
      "tlName": "Rehiyon ng Fukuoka sa Fukuoka Prefecture",
      "moName": "Фүкүока аймаг, Фүкүока муж",
      "buName": "ဟုခုအိုကဒေသ၊ ဟုခုအိုကစီရင်စု",
      "khName": "តំបន់ហ្វឹគឹអុកានៃខេត្ដហ្វឹគឹអុកា",
      "neName": "फुकुओका जिल्ला, फुकुओका क्षेत्र"
    },
    "class15": {
      "code": "400010",
      "name": "福岡地方",
      "enName": "Fukuoka Region"
    },
    "class20": {
      "code": "4023000",
      "name": "糸島市",
      "enName": "Itoshima City",
      "kana": "いとしまし",
      "chName": "丝岛市",
      "zhName": "糸島市",
      "koName": "이토시마 시",
      "esName": "Ciudad de Itoshima",
      "ptName": "cidade de Itoshima",
      "thName": "เมืองอิโตชิมะ",
      "viName": "thành phố Itoshima",
      "inName": "kota Itoshima",
      "tlName": "siyudad ng Itoshima",
      "moName": "Итошимa хот",
      "buName": "အီတိုရှိမ မြို့",
      "khName": "ទីក្រុង អ៊ីតូស៊ីម៉ា",
      "neName": "इतोसिमा सहर"
    }
  },
  "4023100": {
    "office": {
      "code": "400000",
      "name": "福岡県",
      "enName": "Fukuoka",
      "officeName": "福岡管区気象台",
      "chName": "福冈县",
      "zhName": "福岡縣",
      "koName": "후쿠오카현",
      "esName": "Prefectura de Fukuoka",
      "ptName": "Província de Fukuoka",
      "thName": "จังหวัดฟุกุโอกะ",
      "viName": "Tỉnh Fukuoka",
      "inName": "Prefektur Fukuoka",
      "tlName": "Fukuoka Prefecture",
      "moName": "Фүкүока аймаг",
      "buName": "ဖူကူအိုက ပြည်နယ်",
      "khName": "ខេត្ដ ហ្វូគូកា",
      "neName": "फुकुओका जिल्ला"
    },
    "class10": {
      "code": "400010",
      "name": "福岡地方",
      "enName": "Fukuoka Region",
      "chName": "福冈县福冈地方",
      "zhName": "福岡縣福岡地方",
      "koName": "후쿠오카 현 후쿠오카 지방",
      "esName": "Región Fukushima, Prefectura de Fukuoka",
      "ptName": "Região de Fukuoka da Província de Fukuoka",
      "thName": "ท้องถิ่นฟุกุโอกะ จังหวัดฟุกุโอกะ",
      "viName": "Vùng Fukuoka, tỉnh Fukuoka",
      "inName": "Daerah Fukuoka di Prefektur Fukuoka",
      "tlName": "Rehiyon ng Fukuoka sa Fukuoka Prefecture",
      "moName": "Фүкүока аймаг, Фүкүока муж",
      "buName": "ဟုခုအိုကဒေသ၊ ဟုခုအိုကစီရင်စု",
      "khName": "តំបន់ហ្វឹគឹអុកានៃខេត្ដហ្វឹគឹអុកា",
      "neName": "फुकुओका जिल्ला, फुकुओका क्षेत्र"
    },
    "class15": {
      "code": "400010",
      "name": "福岡地方",
      "enName": "Fukuoka Region"
    },
    "class20": {
      "code": "4023100",
      "name": "那珂川市",
      "enName": "Nakagawa City",
      "kana": "なかがわし",
      "chName": "那珂川市",
      "zhName": "那珂川市",
      "koName": "나카가와 시",
      "esName": "Ciudad de Nakagawa",
      "ptName": "cidade de Nakagawa",
      "thName": "เมืองนางาคาวะ",
      "viName": "thành phố Nakagawa",
      "inName": "kota Nakagawa",
      "tlName": "siyudad ng Nakagawa",
      "moName": "Нaкагава хот",
      "buName": "နာကာဂါ့ဝ မြို့",
      "khName": "ទីក្រុង ណាហ្គាកាវ៉ា",
      "neName": "नाकागावा सहर"
    }
  },
  "4034100": {
    "office": {
      "code": "400000",
      "name": "福岡県",
      "enName": "Fukuoka",
      "officeName": "福岡管区気象台",
      "chName": "福冈县",
      "zhName": "福岡縣",
      "koName": "후쿠오카현",
      "esName": "Prefectura de Fukuoka",
      "ptName": "Província de Fukuoka",
      "thName": "จังหวัดฟุกุโอกะ",
      "viName": "Tỉnh Fukuoka",
      "inName": "Prefektur Fukuoka",
      "tlName": "Fukuoka Prefecture",
      "moName": "Фүкүока аймаг",
      "buName": "ဖူကူအိုက ပြည်နယ်",
      "khName": "ខេត្ដ ហ្វូគូកា",
      "neName": "फुकुओका जिल्ला"
    },
    "class10": {
      "code": "400010",
      "name": "福岡地方",
      "enName": "Fukuoka Region",
      "chName": "福冈县福冈地方",
      "zhName": "福岡縣福岡地方",
      "koName": "후쿠오카 현 후쿠오카 지방",
      "esName": "Región Fukushima, Prefectura de Fukuoka",
      "ptName": "Região de Fukuoka da Província de Fukuoka",
      "thName": "ท้องถิ่นฟุกุโอกะ จังหวัดฟุกุโอกะ",
      "viName": "Vùng Fukuoka, tỉnh Fukuoka",
      "inName": "Daerah Fukuoka di Prefektur Fukuoka",
      "tlName": "Rehiyon ng Fukuoka sa Fukuoka Prefecture",
      "moName": "Фүкүока аймаг, Фүкүока муж",
      "buName": "ဟုခုအိုကဒေသ၊ ဟုခုအိုကစီရင်စု",
      "khName": "តំបន់ហ្វឹគឹអុកានៃខេត្ដហ្វឹគឹអុកា",
      "neName": "फुकुओका जिल्ला, फुकुओका क्षेत्र"
    },
    "class15": {
      "code": "400010",
      "name": "福岡地方",
      "enName": "Fukuoka Region"
    },
    "class20": {
      "code": "4034100",
      "name": "宇美町",
      "enName": "Umi Town",
      "kana": "うみまち",
      "chName": "宇美町",
      "zhName": "宇美町",
      "koName": "우미 정",
      "esName": "Pueblo de Umi",
      "ptName": "bairro de Umi",
      "thName": "เมืองอุมิ",
      "viName": "thị trấn Umi",
      "inName": "kota Umi",
      "tlName": "bayan ng Umi",
      "moName": "Үми жижиг хот",
      "buName": "ဥမိ မြို့နယ်",
      "khName": "ទីប្រជុំជន អ៊ូមី",
      "neName": "उमी नगर"
    }
  },
  "4034200": {
    "office": {
      "code": "400000",
      "name": "福岡県",
      "enName": "Fukuoka",
      "officeName": "福岡管区気象台",
      "chName": "福冈县",
      "zhName": "福岡縣",
      "koName": "후쿠오카현",
      "esName": "Prefectura de Fukuoka",
      "ptName": "Província de Fukuoka",
      "thName": "จังหวัดฟุกุโอกะ",
      "viName": "Tỉnh Fukuoka",
      "inName": "Prefektur Fukuoka",
      "tlName": "Fukuoka Prefecture",
      "moName": "Фүкүока аймаг",
      "buName": "ဖူကူအိုက ပြည်နယ်",
      "khName": "ខេត្ដ ហ្វូគូកា",
      "neName": "फुकुओका जिल्ला"
    },
    "class10": {
      "code": "400010",
      "name": "福岡地方",
      "enName": "Fukuoka Region",
      "chName": "福冈县福冈地方",
      "zhName": "福岡縣福岡地方",
      "koName": "후쿠오카 현 후쿠오카 지방",
      "esName": "Región Fukushima, Prefectura de Fukuoka",
      "ptName": "Região de Fukuoka da Província de Fukuoka",
      "thName": "ท้องถิ่นฟุกุโอกะ จังหวัดฟุกุโอกะ",
      "viName": "Vùng Fukuoka, tỉnh Fukuoka",
      "inName": "Daerah Fukuoka di Prefektur Fukuoka",
      "tlName": "Rehiyon ng Fukuoka sa Fukuoka Prefecture",
      "moName": "Фүкүока аймаг, Фүкүока муж",
      "buName": "ဟုခုအိုကဒေသ၊ ဟုခုအိုကစီရင်စု",
      "khName": "តំបន់ហ្វឹគឹអុកានៃខេត្ដហ្វឹគឹអុកា",
      "neName": "फुकुओका जिल्ला, फुकुओका क्षेत्र"
    },
    "class15": {
      "code": "400010",
      "name": "福岡地方",
      "enName": "Fukuoka Region"
    },
    "class20": {
      "code": "4034200",
      "name": "篠栗町",
      "enName": "Sasaguri Town",
      "kana": "ささぐりまち",
      "chName": "篠栗町",
      "zhName": "篠栗町",
      "koName": "사사구리 정",
      "esName": "Pueblo de Sasaguri",
      "ptName": "bairro de Sasaguri",
      "thName": "เมืองซาซางุริ",
      "viName": "thị trấn Sasaguri",
      "inName": "kota Sasaguri",
      "tlName": "bayan ng Sasaguri",
      "moName": "Сaсaгүри жижиг хот",
      "buName": "ဆာဆဂုရိ မြို့နယ်",
      "khName": "ទីប្រជុំជន សាសាហ្គូរី",
      "neName": "सासागुरी नगर"
    }
  },
  "4034300": {
    "office": {
      "code": "400000",
      "name": "福岡県",
      "enName": "Fukuoka",
      "officeName": "福岡管区気象台",
      "chName": "福冈县",
      "zhName": "福岡縣",
      "koName": "후쿠오카현",
      "esName": "Prefectura de Fukuoka",
      "ptName": "Província de Fukuoka",
      "thName": "จังหวัดฟุกุโอกะ",
      "viName": "Tỉnh Fukuoka",
      "inName": "Prefektur Fukuoka",
      "tlName": "Fukuoka Prefecture",
      "moName": "Фүкүока аймаг",
      "buName": "ဖူကူအိုက ပြည်နယ်",
      "khName": "ខេត្ដ ហ្វូគូកា",
      "neName": "फुकुओका जिल्ला"
    },
    "class10": {
      "code": "400010",
      "name": "福岡地方",
      "enName": "Fukuoka Region",
      "chName": "福冈县福冈地方",
      "zhName": "福岡縣福岡地方",
      "koName": "후쿠오카 현 후쿠오카 지방",
      "esName": "Región Fukushima, Prefectura de Fukuoka",
      "ptName": "Região de Fukuoka da Província de Fukuoka",
      "thName": "ท้องถิ่นฟุกุโอกะ จังหวัดฟุกุโอกะ",
      "viName": "Vùng Fukuoka, tỉnh Fukuoka",
      "inName": "Daerah Fukuoka di Prefektur Fukuoka",
      "tlName": "Rehiyon ng Fukuoka sa Fukuoka Prefecture",
      "moName": "Фүкүока аймаг, Фүкүока муж",
      "buName": "ဟုခုအိုကဒေသ၊ ဟုခုအိုကစီရင်စု",
      "khName": "តំបន់ហ្វឹគឹអុកានៃខេត្ដហ្វឹគឹអុកា",
      "neName": "फुकुओका जिल्ला, फुकुओका क्षेत्र"
    },
    "class15": {
      "code": "400010",
      "name": "福岡地方",
      "enName": "Fukuoka Region"
    },
    "class20": {
      "code": "4034300",
      "name": "志免町",
      "enName": "Shime Town",
      "kana": "しめまち",
      "chName": "志免町",
      "zhName": "志免町",
      "koName": "시메 정",
      "esName": "Pueblo de Shime",
      "ptName": "bairro de Shime",
      "thName": "เมืองชิเมะ",
      "viName": "thị trấn Shime",
      "inName": "kota Shime",
      "tlName": "bayan ng Shime",
      "moName": "Шимэ жижиг хот",
      "buName": "ရှီမဲ့ မြို့နယ်",
      "khName": "ទីប្រជុំជន ស៊ីមេ",
      "neName": "शिमे नगर"
    }
  },
  "4034400": {
    "office": {
      "code": "400000",
      "name": "福岡県",
      "enName": "Fukuoka",
      "officeName": "福岡管区気象台",
      "chName": "福冈县",
      "zhName": "福岡縣",
      "koName": "후쿠오카현",
      "esName": "Prefectura de Fukuoka",
      "ptName": "Província de Fukuoka",
      "thName": "จังหวัดฟุกุโอกะ",
      "viName": "Tỉnh Fukuoka",
      "inName": "Prefektur Fukuoka",
      "tlName": "Fukuoka Prefecture",
      "moName": "Фүкүока аймаг",
      "buName": "ဖူကူအိုက ပြည်နယ်",
      "khName": "ខេត្ដ ហ្វូគូកា",
      "neName": "फुकुओका जिल्ला"
    },
    "class10": {
      "code": "400010",
      "name": "福岡地方",
      "enName": "Fukuoka Region",
      "chName": "福冈县福冈地方",
      "zhName": "福岡縣福岡地方",
      "koName": "후쿠오카 현 후쿠오카 지방",
      "esName": "Región Fukushima, Prefectura de Fukuoka",
      "ptName": "Região de Fukuoka da Província de Fukuoka",
      "thName": "ท้องถิ่นฟุกุโอกะ จังหวัดฟุกุโอกะ",
      "viName": "Vùng Fukuoka, tỉnh Fukuoka",
      "inName": "Daerah Fukuoka di Prefektur Fukuoka",
      "tlName": "Rehiyon ng Fukuoka sa Fukuoka Prefecture",
      "moName": "Фүкүока аймаг, Фүкүока муж",
      "buName": "ဟုခုအိုကဒေသ၊ ဟုခုအိုကစီရင်စု",
      "khName": "តំបន់ហ្វឹគឹអុកានៃខេត្ដហ្វឹគឹអុកា",
      "neName": "फुकुओका जिल्ला, फुकुओका क्षेत्र"
    },
    "class15": {
      "code": "400010",
      "name": "福岡地方",
      "enName": "Fukuoka Region"
    },
    "class20": {
      "code": "4034400",
      "name": "須恵町",
      "enName": "Sue Town",
      "kana": "すえまち",
      "chName": "须惠町",
      "zhName": "須惠町",
      "koName": "스에 정",
      "esName": "Pueblo de Sue",
      "ptName": "bairro de Sue",
      "thName": "เมืองซุเอะ",
      "viName": "thị trấn Sue",
      "inName": "kota Sue",
      "tlName": "bayan ng Sue",
      "moName": "Сүэ жижиг хот",
      "buName": "ဆူး မြို့နယ်",
      "khName": "ទីប្រជុំជន ស៊ូ",
      "neName": "सुए नगर"
    }
  },
  "4034500": {
    "office": {
      "code": "400000",
      "name": "福岡県",
      "enName": "Fukuoka",
      "officeName": "福岡管区気象台",
      "chName": "福冈县",
      "zhName": "福岡縣",
      "koName": "후쿠오카현",
      "esName": "Prefectura de Fukuoka",
      "ptName": "Província de Fukuoka",
      "thName": "จังหวัดฟุกุโอกะ",
      "viName": "Tỉnh Fukuoka",
      "inName": "Prefektur Fukuoka",
      "tlName": "Fukuoka Prefecture",
      "moName": "Фүкүока аймаг",
      "buName": "ဖူကူအိုက ပြည်နယ်",
      "khName": "ខេត្ដ ហ្វូគូកា",
      "neName": "फुकुओका जिल्ला"
    },
    "class10": {
      "code": "400010",
      "name": "福岡地方",
      "enName": "Fukuoka Region",
      "chName": "福冈县福冈地方",
      "zhName": "福岡縣福岡地方",
      "koName": "후쿠오카 현 후쿠오카 지방",
      "esName": "Región Fukushima, Prefectura de Fukuoka",
      "ptName": "Região de Fukuoka da Província de Fukuoka",
      "thName": "ท้องถิ่นฟุกุโอกะ จังหวัดฟุกุโอกะ",
      "viName": "Vùng Fukuoka, tỉnh Fukuoka",
      "inName": "Daerah Fukuoka di Prefektur Fukuoka",
      "tlName": "Rehiyon ng Fukuoka sa Fukuoka Prefecture",
      "moName": "Фүкүока аймаг, Фүкүока муж",
      "buName": "ဟုခုအိုကဒေသ၊ ဟုခုအိုကစီရင်စု",
      "khName": "តំបន់ហ្វឹគឹអុកានៃខេត្ដហ្វឹគឹអុកា",
      "neName": "फुकुओका जिल्ला, फुकुओका क्षेत्र"
    },
    "class15": {
      "code": "400010",
      "name": "福岡地方",
      "enName": "Fukuoka Region"
    },
    "class20": {
      "code": "4034500",
      "name": "新宮町",
      "enName": "Shingu Town",
      "kana": "しんぐうまち",
      "chName": "新宫町",
      "zhName": "新宮町",
      "koName": "신구 정",
      "esName": "Pueblo de Shingu",
      "ptName": "bairro de Shingu",
      "thName": "เมืองชินงุ",
      "viName": "thị trấn Shingu",
      "inName": "kota Shingu",
      "tlName": "bayan ng Shingu",
      "moName": "Шингү жижиг хот",
      "buName": "ရှင်းဂု မြို့နယ်",
      "khName": "ទីប្រជុំជន ស៊ីងហ្កូ",
      "neName": "शिन्गु नगर"
    }
  },
  "4034800": {
    "office": {
      "code": "400000",
      "name": "福岡県",
      "enName": "Fukuoka",
      "officeName": "福岡管区気象台",
      "chName": "福冈县",
      "zhName": "福岡縣",
      "koName": "후쿠오카현",
      "esName": "Prefectura de Fukuoka",
      "ptName": "Província de Fukuoka",
      "thName": "จังหวัดฟุกุโอกะ",
      "viName": "Tỉnh Fukuoka",
      "inName": "Prefektur Fukuoka",
      "tlName": "Fukuoka Prefecture",
      "moName": "Фүкүока аймаг",
      "buName": "ဖူကူအိုက ပြည်နယ်",
      "khName": "ខេត្ដ ហ្វូគូកា",
      "neName": "फुकुओका जिल्ला"
    },
    "class10": {
      "code": "400010",
      "name": "福岡地方",
      "enName": "Fukuoka Region",
      "chName": "福冈县福冈地方",
      "zhName": "福岡縣福岡地方",
      "koName": "후쿠오카 현 후쿠오카 지방",
      "esName": "Región Fukushima, Prefectura de Fukuoka",
      "ptName": "Região de Fukuoka da Província de Fukuoka",
      "thName": "ท้องถิ่นฟุกุโอกะ จังหวัดฟุกุโอกะ",
      "viName": "Vùng Fukuoka, tỉnh Fukuoka",
      "inName": "Daerah Fukuoka di Prefektur Fukuoka",
      "tlName": "Rehiyon ng Fukuoka sa Fukuoka Prefecture",
      "moName": "Фүкүока аймаг, Фүкүока муж",
      "buName": "ဟုခုအိုကဒေသ၊ ဟုခုအိုကစီရင်စု",
      "khName": "តំបន់ហ្វឹគឹអុកានៃខេត្ដហ្វឹគឹអុកា",
      "neName": "फुकुओका जिल्ला, फुकुओका क्षेत्र"
    },
    "class15": {
      "code": "400010",
      "name": "福岡地方",
      "enName": "Fukuoka Region"
    },
    "class20": {
      "code": "4034800",
      "name": "久山町",
      "enName": "Hisayama Town",
      "kana": "ひさやままち",
      "chName": "久山町",
      "zhName": "久山町",
      "koName": "히사야마 정",
      "esName": "Pueblo de Hisayama",
      "ptName": "bairro de Hisayama",
      "thName": "เมืองฮิสะยามะ",
      "viName": "thị trấn Hisayama",
      "inName": "kota Hisayama",
      "tlName": "bayan ng Hisayama",
      "moName": "Хисaямa жижиг хот",
      "buName": "ဟီဆာယာ့မ မြို့နယ်",
      "khName": "ទីប្រជុំជន ហៃសាយ៉ាម៉ា",
      "neName": "हिसायामा नगर"
    }
  },
  "4034900": {
    "office": {
      "code": "400000",
      "name": "福岡県",
      "enName": "Fukuoka",
      "officeName": "福岡管区気象台",
      "chName": "福冈县",
      "zhName": "福岡縣",
      "koName": "후쿠오카현",
      "esName": "Prefectura de Fukuoka",
      "ptName": "Província de Fukuoka",
      "thName": "จังหวัดฟุกุโอกะ",
      "viName": "Tỉnh Fukuoka",
      "inName": "Prefektur Fukuoka",
      "tlName": "Fukuoka Prefecture",
      "moName": "Фүкүока аймаг",
      "buName": "ဖူကူအိုက ပြည်နယ်",
      "khName": "ខេត្ដ ហ្វូគូកា",
      "neName": "फुकुओका जिल्ला"
    },
    "class10": {
      "code": "400010",
      "name": "福岡地方",
      "enName": "Fukuoka Region",
      "chName": "福冈县福冈地方",
      "zhName": "福岡縣福岡地方",
      "koName": "후쿠오카 현 후쿠오카 지방",
      "esName": "Región Fukushima, Prefectura de Fukuoka",
      "ptName": "Região de Fukuoka da Província de Fukuoka",
      "thName": "ท้องถิ่นฟุกุโอกะ จังหวัดฟุกุโอกะ",
      "viName": "Vùng Fukuoka, tỉnh Fukuoka",
      "inName": "Daerah Fukuoka di Prefektur Fukuoka",
      "tlName": "Rehiyon ng Fukuoka sa Fukuoka Prefecture",
      "moName": "Фүкүока аймаг, Фүкүока муж",
      "buName": "ဟုခုအိုကဒေသ၊ ဟုခုအိုကစီရင်စု",
      "khName": "តំបន់ហ្វឹគឹអុកានៃខេត្ដហ្វឹគឹអុកា",
      "neName": "फुकुओका जिल्ला, फुकुओका क्षेत्र"
    },
    "class15": {
      "code": "400010",
      "name": "福岡地方",
      "enName": "Fukuoka Region"
    },
    "class20": {
      "code": "4034900",
      "name": "粕屋町",
      "enName": "Kasuya Town",
      "kana": "かすやまち",
      "chName": "粕屋町",
      "zhName": "粕屋町",
      "koName": "가스야 정",
      "esName": "Pueblo de Kasuya",
      "ptName": "bairro de Kasuya",
      "thName": "เมืองคะสุยะ",
      "viName": "thị trấn Kasuya",
      "inName": "kota Kasuya",
      "tlName": "bayan ng Kasuya",
      "moName": "Касүя жижиг хот",
      "buName": "ခါဆုရာ့ မြို့နယ်",
      "khName": "ទីប្រជុំជន កាស៊ូយ៉ា",
      "neName": "कासुया नगर"
    }
  },
  "4038100": {
    "office": {
      "code": "400000",
      "name": "福岡県",
      "enName": "Fukuoka",
      "officeName": "福岡管区気象台",
      "chName": "福冈县",
      "zhName": "福岡縣",
      "koName": "후쿠오카현",
      "esName": "Prefectura de Fukuoka",
      "ptName": "Província de Fukuoka",
      "thName": "จังหวัดฟุกุโอกะ",
      "viName": "Tỉnh Fukuoka",
      "inName": "Prefektur Fukuoka",
      "tlName": "Fukuoka Prefecture",
      "moName": "Фүкүока аймаг",
      "buName": "ဖူကူအိုက ပြည်နယ်",
      "khName": "ខេត្ដ ហ្វូគូកា",
      "neName": "फुकुओका जिल्ला"
    },
    "class10": {
      "code": "400020",
      "name": "北九州地方",
      "enName": "Kitakyushu Region",
      "chName": "福冈县北九州地方",
      "zhName": "福岡縣北九州地方",
      "koName": "후쿠오카 현 기타큐슈 지방",
      "esName": "Región Kitakyushu, Prefectura de Fukuoka",
      "ptName": "Região de Kita-Kyūshū da Província de Fukuoka",
      "thName": "ท้องถิ่นคิตะกิวชู จังหวัดฟุกุโอกะ",
      "viName": "Vùng Kitakyushu, tỉnh Fukuoka",
      "inName": "Daerah Kitakyushu di Prefektur Fukuoka",
      "tlName": "Rehiyon ng Kita-Kyushu sa Fukuoka Prefecture",
      "moName": "Фүкүока аймаг, Китакюшү муж",
      "buName": "ခိတခယူးရှုးဒေသ၊ ဟုခုအိုကစီရင်စု",
      "khName": "តំបន់គីតាក់ខ្យឹហ្សឹនៃខេត្ដហ្វឹគឹអុកា",
      "neName": "फुकुओका जिल्ला, किताक्युस्यु क्षेत्र"
    },
    "class15": {
      "code": "400021",
      "name": "北九州・遠賀地区",
      "enName": "Kitakyushu Onga District"
    },
    "class20": {
      "code": "4038100",
      "name": "芦屋町",
      "enName": "Ashiya Town",
      "kana": "あしやまち",
      "chName": "芦屋町",
      "zhName": "蘆屋町",
      "koName": "아시야 정",
      "esName": "Pueblo de Ashiya",
      "ptName": "bairro de Ashiya",
      "thName": "เมืองอาชิยะ",
      "viName": "thị trấn Ashiya",
      "inName": "kota Ashiya",
      "tlName": "bayan ng Ashiya",
      "moName": "Aшия жижиг хот",
      "buName": "အာရှီယ မြို့နယ်",
      "khName": "ទីប្រជុំជន អាស៊ីយ៉ា",
      "neName": "आशिया नगर"
    }
  },
  "4038200": {
    "office": {
      "code": "400000",
      "name": "福岡県",
      "enName": "Fukuoka",
      "officeName": "福岡管区気象台",
      "chName": "福冈县",
      "zhName": "福岡縣",
      "koName": "후쿠오카현",
      "esName": "Prefectura de Fukuoka",
      "ptName": "Província de Fukuoka",
      "thName": "จังหวัดฟุกุโอกะ",
      "viName": "Tỉnh Fukuoka",
      "inName": "Prefektur Fukuoka",
      "tlName": "Fukuoka Prefecture",
      "moName": "Фүкүока аймаг",
      "buName": "ဖူကူအိုက ပြည်နယ်",
      "khName": "ខេត្ដ ហ្វូគូកា",
      "neName": "फुकुओका जिल्ला"
    },
    "class10": {
      "code": "400020",
      "name": "北九州地方",
      "enName": "Kitakyushu Region",
      "chName": "福冈县北九州地方",
      "zhName": "福岡縣北九州地方",
      "koName": "후쿠오카 현 기타큐슈 지방",
      "esName": "Región Kitakyushu, Prefectura de Fukuoka",
      "ptName": "Região de Kita-Kyūshū da Província de Fukuoka",
      "thName": "ท้องถิ่นคิตะกิวชู จังหวัดฟุกุโอกะ",
      "viName": "Vùng Kitakyushu, tỉnh Fukuoka",
      "inName": "Daerah Kitakyushu di Prefektur Fukuoka",
      "tlName": "Rehiyon ng Kita-Kyushu sa Fukuoka Prefecture",
      "moName": "Фүкүока аймаг, Китакюшү муж",
      "buName": "ခိတခယူးရှုးဒေသ၊ ဟုခုအိုကစီရင်စု",
      "khName": "តំបន់គីតាក់ខ្យឹហ្សឹនៃខេត្ដហ្វឹគឹអុកា",
      "neName": "फुकुओका जिल्ला, किताक्युस्यु क्षेत्र"
    },
    "class15": {
      "code": "400021",
      "name": "北九州・遠賀地区",
      "enName": "Kitakyushu Onga District"
    },
    "class20": {
      "code": "4038200",
      "name": "水巻町",
      "enName": "Mizumaki Town",
      "kana": "みずまきまち",
      "chName": "水卷町",
      "zhName": "水卷町",
      "koName": "미즈마키 정",
      "esName": "Pueblo de Mizumaki",
      "ptName": "bairro de Mizumaki",
      "thName": "เมืองมิซึมากิ",
      "viName": "thị trấn Mizumaki",
      "inName": "kota Mizumaki",
      "tlName": "bayan ng Mizumaki",
      "moName": "Мизүмaки жижиг хот",
      "buName": "မီဇုမာ့ကိ မြို့နယ်",
      "khName": "ទីប្រជុំជន មីស៊ូម៉ាគី",
      "neName": "मिज़ुमाकी नगर"
    }
  },
  "4038300": {
    "office": {
      "code": "400000",
      "name": "福岡県",
      "enName": "Fukuoka",
      "officeName": "福岡管区気象台",
      "chName": "福冈县",
      "zhName": "福岡縣",
      "koName": "후쿠오카현",
      "esName": "Prefectura de Fukuoka",
      "ptName": "Província de Fukuoka",
      "thName": "จังหวัดฟุกุโอกะ",
      "viName": "Tỉnh Fukuoka",
      "inName": "Prefektur Fukuoka",
      "tlName": "Fukuoka Prefecture",
      "moName": "Фүкүока аймаг",
      "buName": "ဖူကူအိုက ပြည်နယ်",
      "khName": "ខេត្ដ ហ្វូគូកា",
      "neName": "फुकुओका जिल्ला"
    },
    "class10": {
      "code": "400020",
      "name": "北九州地方",
      "enName": "Kitakyushu Region",
      "chName": "福冈县北九州地方",
      "zhName": "福岡縣北九州地方",
      "koName": "후쿠오카 현 기타큐슈 지방",
      "esName": "Región Kitakyushu, Prefectura de Fukuoka",
      "ptName": "Região de Kita-Kyūshū da Província de Fukuoka",
      "thName": "ท้องถิ่นคิตะกิวชู จังหวัดฟุกุโอกะ",
      "viName": "Vùng Kitakyushu, tỉnh Fukuoka",
      "inName": "Daerah Kitakyushu di Prefektur Fukuoka",
      "tlName": "Rehiyon ng Kita-Kyushu sa Fukuoka Prefecture",
      "moName": "Фүкүока аймаг, Китакюшү муж",
      "buName": "ခိတခယူးရှုးဒေသ၊ ဟုခုအိုကစီရင်စု",
      "khName": "តំបន់គីតាក់ខ្យឹហ្សឹនៃខេត្ដហ្វឹគឹអុកា",
      "neName": "फुकुओका जिल्ला, किताक्युस्यु क्षेत्र"
    },
    "class15": {
      "code": "400021",
      "name": "北九州・遠賀地区",
      "enName": "Kitakyushu Onga District"
    },
    "class20": {
      "code": "4038300",
      "name": "岡垣町",
      "enName": "Okagaki Town",
      "kana": "おかがきまち",
      "chName": "冈垣町",
      "zhName": "岡垣町",
      "koName": "오카가키 정",
      "esName": "Pueblo de Okagaki",
      "ptName": "bairro de Okagaki",
      "thName": "เมืองโอคางากิ",
      "viName": "thị trấn Okagaki",
      "inName": "kota Okagaki",
      "tlName": "bayan ng Okagaki",
      "moName": "Окагaки жижиг хот",
      "buName": "အိုကားဂါ့ကိ မြို့နယ်",
      "khName": "ទីប្រជុំជន អូកាហ្គាគី",
      "neName": "ओकागाकि नगर"
    }
  },
  "4038400": {
    "office": {
      "code": "400000",
      "name": "福岡県",
      "enName": "Fukuoka",
      "officeName": "福岡管区気象台",
      "chName": "福冈县",
      "zhName": "福岡縣",
      "koName": "후쿠오카현",
      "esName": "Prefectura de Fukuoka",
      "ptName": "Província de Fukuoka",
      "thName": "จังหวัดฟุกุโอกะ",
      "viName": "Tỉnh Fukuoka",
      "inName": "Prefektur Fukuoka",
      "tlName": "Fukuoka Prefecture",
      "moName": "Фүкүока аймаг",
      "buName": "ဖူကူအိုက ပြည်နယ်",
      "khName": "ខេត្ដ ហ្វូគូកា",
      "neName": "फुकुओका जिल्ला"
    },
    "class10": {
      "code": "400020",
      "name": "北九州地方",
      "enName": "Kitakyushu Region",
      "chName": "福冈县北九州地方",
      "zhName": "福岡縣北九州地方",
      "koName": "후쿠오카 현 기타큐슈 지방",
      "esName": "Región Kitakyushu, Prefectura de Fukuoka",
      "ptName": "Região de Kita-Kyūshū da Província de Fukuoka",
      "thName": "ท้องถิ่นคิตะกิวชู จังหวัดฟุกุโอกะ",
      "viName": "Vùng Kitakyushu, tỉnh Fukuoka",
      "inName": "Daerah Kitakyushu di Prefektur Fukuoka",
      "tlName": "Rehiyon ng Kita-Kyushu sa Fukuoka Prefecture",
      "moName": "Фүкүока аймаг, Китакюшү муж",
      "buName": "ခိတခယူးရှုးဒေသ၊ ဟုခုအိုကစီရင်စု",
      "khName": "តំបន់គីតាក់ខ្យឹហ្សឹនៃខេត្ដហ្វឹគឹអុកា",
      "neName": "फुकुओका जिल्ला, किताक्युस्यु क्षेत्र"
    },
    "class15": {
      "code": "400021",
      "name": "北九州・遠賀地区",
      "enName": "Kitakyushu Onga District"
    },
    "class20": {
      "code": "4038400",
      "name": "遠賀町",
      "enName": "Onga Town",
      "kana": "おんがちょう",
      "chName": "远贺町",
      "zhName": "遠賀町",
      "koName": "온가 정",
      "esName": "Pueblo de Onga",
      "ptName": "bairro de Onga",
      "thName": "เมืององงะ",
      "viName": "thị trấn Onga",
      "inName": "kota Onga",
      "tlName": "bayan ng Onga",
      "moName": "Онгa жижиг хот",
      "buName": "အွန်းဂ မြို့နယ်",
      "khName": "ទីប្រជុំជន អនហ្កា",
      "neName": "ओन्गा नगर"
    }
  },
  "4040100": {
    "office": {
      "code": "400000",
      "name": "福岡県",
      "enName": "Fukuoka",
      "officeName": "福岡管区気象台",
      "chName": "福冈县",
      "zhName": "福岡縣",
      "koName": "후쿠오카현",
      "esName": "Prefectura de Fukuoka",
      "ptName": "Província de Fukuoka",
      "thName": "จังหวัดฟุกุโอกะ",
      "viName": "Tỉnh Fukuoka",
      "inName": "Prefektur Fukuoka",
      "tlName": "Fukuoka Prefecture",
      "moName": "Фүкүока аймаг",
      "buName": "ဖူကူအိုက ပြည်နယ်",
      "khName": "ខេត្ដ ហ្វូគូកា",
      "neName": "फुकुओका जिल्ला"
    },
    "class10": {
      "code": "400030",
      "name": "筑豊地方",
      "enName": "Chikuho Region",
      "chName": "福冈县筑丰地方",
      "zhName": "福岡縣筑豐地方",
      "koName": "후쿠오카 현 츠쿠호 지방",
      "esName": "Región Chikuhou, Prefectura de Fukuoka",
      "ptName": "Região de Chikuhō da Província de Fukuoka",
      "thName": "ท้องถิ่นจิกุโฮ จังหวัดฟุกุโอกะ",
      "viName": "Vùng Chikuho, tỉnh Fukuoka",
      "inName": "Daerah Chikuho di Prefektur Fukuoka",
      "tlName": "Rehiyon ng Chikuho sa Fukuoka Prefecture",
      "moName": "Фүкүока аймаг, Чикүхо муж",
      "buName": "ချိခုဟိုဒေသ၊ ဟုခုအိုကစီရင်စု",
      "khName": "តំបន់ជីគឹហូនៃខេត្ដហ្វឹគឹអុកា",
      "neName": "फुकुओका जिल्ला, चिकुहो क्षेत्र"
    },
    "class15": {
      "code": "400030",
      "name": "筑豊地方",
      "enName": "Chikuho Region"
    },
    "class20": {
      "code": "4040100",
      "name": "小竹町",
      "enName": "Kotake Town",
      "kana": "こたけまち",
      "chName": "小竹町",
      "zhName": "小竹町",
      "koName": "고타케 정",
      "esName": "Pueblo de Kotake",
      "ptName": "bairro de Kotake",
      "thName": "เมืองโคทาเกะ",
      "viName": "thị trấn Kotake",
      "inName": "kota Kotake",
      "tlName": "bayan ng Kotake",
      "moName": "Котакэ жижиг хот",
      "buName": "ကိုတာ့ကဲ့ မြို့နယ်",
      "khName": "ទីប្រជុំជន កូតាកេ",
      "neName": "कोताके नगर"
    }
  },
  "4040200": {
    "office": {
      "code": "400000",
      "name": "福岡県",
      "enName": "Fukuoka",
      "officeName": "福岡管区気象台",
      "chName": "福冈县",
      "zhName": "福岡縣",
      "koName": "후쿠오카현",
      "esName": "Prefectura de Fukuoka",
      "ptName": "Província de Fukuoka",
      "thName": "จังหวัดฟุกุโอกะ",
      "viName": "Tỉnh Fukuoka",
      "inName": "Prefektur Fukuoka",
      "tlName": "Fukuoka Prefecture",
      "moName": "Фүкүока аймаг",
      "buName": "ဖူကူအိုက ပြည်နယ်",
      "khName": "ខេត្ដ ហ្វូគូកា",
      "neName": "फुकुओका जिल्ला"
    },
    "class10": {
      "code": "400030",
      "name": "筑豊地方",
      "enName": "Chikuho Region",
      "chName": "福冈县筑丰地方",
      "zhName": "福岡縣筑豐地方",
      "koName": "후쿠오카 현 츠쿠호 지방",
      "esName": "Región Chikuhou, Prefectura de Fukuoka",
      "ptName": "Região de Chikuhō da Província de Fukuoka",
      "thName": "ท้องถิ่นจิกุโฮ จังหวัดฟุกุโอกะ",
      "viName": "Vùng Chikuho, tỉnh Fukuoka",
      "inName": "Daerah Chikuho di Prefektur Fukuoka",
      "tlName": "Rehiyon ng Chikuho sa Fukuoka Prefecture",
      "moName": "Фүкүока аймаг, Чикүхо муж",
      "buName": "ချိခုဟိုဒေသ၊ ဟုခုအိုကစီရင်စု",
      "khName": "តំបន់ជីគឹហូនៃខេត្ដហ្វឹគឹអុកា",
      "neName": "फुकुओका जिल्ला, चिकुहो क्षेत्र"
    },
    "class15": {
      "code": "400030",
      "name": "筑豊地方",
      "enName": "Chikuho Region"
    },
    "class20": {
      "code": "4040200",
      "name": "鞍手町",
      "enName": "Kurate Town",
      "kana": "くらてまち",
      "chName": "鞍手町",
      "zhName": "鞍手町",
      "koName": "구라테 정",
      "esName": "Pueblo de Kurate",
      "ptName": "bairro de Kurate",
      "thName": "เมืองคุราเตะ",
      "viName": "thị trấn Kurate",
      "inName": "kota Kurate",
      "tlName": "bayan ng Kurate",
      "moName": "Күратэ жижиг хот",
      "buName": "ကုရားတဲ့ မြို့နယ်",
      "khName": "ទីប្រជុំជន គូរ៉ាតេ",
      "neName": "कुराते नगर"
    }
  },
  "4042100": {
    "office": {
      "code": "400000",
      "name": "福岡県",
      "enName": "Fukuoka",
      "officeName": "福岡管区気象台",
      "chName": "福冈县",
      "zhName": "福岡縣",
      "koName": "후쿠오카현",
      "esName": "Prefectura de Fukuoka",
      "ptName": "Província de Fukuoka",
      "thName": "จังหวัดฟุกุโอกะ",
      "viName": "Tỉnh Fukuoka",
      "inName": "Prefektur Fukuoka",
      "tlName": "Fukuoka Prefecture",
      "moName": "Фүкүока аймаг",
      "buName": "ဖူကူအိုက ပြည်နယ်",
      "khName": "ខេត្ដ ហ្វូគូកា",
      "neName": "फुकुओका जिल्ला"
    },
    "class10": {
      "code": "400030",
      "name": "筑豊地方",
      "enName": "Chikuho Region",
      "chName": "福冈县筑丰地方",
      "zhName": "福岡縣筑豐地方",
      "koName": "후쿠오카 현 츠쿠호 지방",
      "esName": "Región Chikuhou, Prefectura de Fukuoka",
      "ptName": "Região de Chikuhō da Província de Fukuoka",
      "thName": "ท้องถิ่นจิกุโฮ จังหวัดฟุกุโอกะ",
      "viName": "Vùng Chikuho, tỉnh Fukuoka",
      "inName": "Daerah Chikuho di Prefektur Fukuoka",
      "tlName": "Rehiyon ng Chikuho sa Fukuoka Prefecture",
      "moName": "Фүкүока аймаг, Чикүхо муж",
      "buName": "ချိခုဟိုဒေသ၊ ဟုခုအိုကစီရင်စု",
      "khName": "តំបន់ជីគឹហូនៃខេត្ដហ្វឹគឹអុកា",
      "neName": "फुकुओका जिल्ला, चिकुहो क्षेत्र"
    },
    "class15": {
      "code": "400030",
      "name": "筑豊地方",
      "enName": "Chikuho Region"
    },
    "class20": {
      "code": "4042100",
      "name": "桂川町",
      "enName": "Keisen Town",
      "kana": "けいせんまち",
      "chName": "桂川町",
      "zhName": "桂川町",
      "koName": "게이센 정",
      "esName": "Pueblo de Keisen",
      "ptName": "bairro de Keisen",
      "thName": "เมืองเคเซน",
      "viName": "thị trấn Keisen",
      "inName": "kota Keisen",
      "tlName": "bayan ng Keisen",
      "moName": "Кэйсэн жижиг хот",
      "buName": "ခေးယိစန် မြို့နယ်",
      "khName": "ទីប្រជុំជន ឃេសែន",
      "neName": "केइसेन नगर"
    }
  },
  "4044700": {
    "office": {
      "code": "400000",
      "name": "福岡県",
      "enName": "Fukuoka",
      "officeName": "福岡管区気象台",
      "chName": "福冈县",
      "zhName": "福岡縣",
      "koName": "후쿠오카현",
      "esName": "Prefectura de Fukuoka",
      "ptName": "Província de Fukuoka",
      "thName": "จังหวัดฟุกุโอกะ",
      "viName": "Tỉnh Fukuoka",
      "inName": "Prefektur Fukuoka",
      "tlName": "Fukuoka Prefecture",
      "moName": "Фүкүока аймаг",
      "buName": "ဖူကူအိုက ပြည်နယ်",
      "khName": "ខេត្ដ ហ្វូគូកា",
      "neName": "फुकुओका जिल्ला"
    },
    "class10": {
      "code": "400040",
      "name": "筑後地方",
      "enName": "Chikugo Region",
      "chName": "福冈县筑后地方",
      "zhName": "福岡縣筑後地方",
      "koName": "후쿠오카 현 지쿠고 지방",
      "esName": "Región Chikugo, Prefectura de Fukuoka",
      "ptName": "Região de Chikugo da Província de Fukuoka",
      "thName": "ท้องถิ่นจิกุโงะ จังหวัดฟุกุโอกะ",
      "viName": "Vùng Chikugo, tỉnh Fukuoka",
      "inName": "Daerah Chikugo di Prefektur Fukuoka",
      "tlName": "Rehiyon ng Chikugo sa Fukuoka Prefecture",
      "moName": "Фүкүока аймаг, Чикүго муж",
      "buName": "ချူးခုဂိုဒေသ၊ ဟုခုအိုကစီရင်စု",
      "khName": "តំបន់ជីគឹហ្គោនៃខេត្ដហ្វឹគឹអុកា",
      "neName": "फुकुओका जिल्ला, चिकुगो क्षेत्र"
    },
    "class15": {
      "code": "400041",
      "name": "筑後北部",
      "enName": "Northern Chikugo"
    },
    "class20": {
      "code": "4044700",
      "name": "筑前町",
      "enName": "Chikuzen Town",
      "kana": "ちくぜんまち",
      "chName": "筑前町",
      "zhName": "築前町",
      "koName": "지쿠젠 정",
      "esName": "Pueblo de Chikuzen",
      "ptName": "bairro de Chikuzen",
      "thName": "เมืองจิขุเซน",
      "viName": "thị trấn Chikuzen",
      "inName": "kota Chikuzen",
      "tlName": "bayan ng Chikuzen",
      "moName": "Чикүзэн жижиг хот",
      "buName": "ကျိခုဇန် မြို့နယ်",
      "khName": "ទីប្រជុំជន ជីគូសេន",
      "neName": "चिकुजेन नगर"
    }
  },
  "4044800": {
    "office": {
      "code": "400000",
      "name": "福岡県",
      "enName": "Fukuoka",
      "officeName": "福岡管区気象台",
      "chName": "福冈县",
      "zhName": "福岡縣",
      "koName": "후쿠오카현",
      "esName": "Prefectura de Fukuoka",
      "ptName": "Província de Fukuoka",
      "thName": "จังหวัดฟุกุโอกะ",
      "viName": "Tỉnh Fukuoka",
      "inName": "Prefektur Fukuoka",
      "tlName": "Fukuoka Prefecture",
      "moName": "Фүкүока аймаг",
      "buName": "ဖူကူအိုက ပြည်နယ်",
      "khName": "ខេត្ដ ហ្វូគូកា",
      "neName": "फुकुओका जिल्ला"
    },
    "class10": {
      "code": "400040",
      "name": "筑後地方",
      "enName": "Chikugo Region",
      "chName": "福冈县筑后地方",
      "zhName": "福岡縣筑後地方",
      "koName": "후쿠오카 현 지쿠고 지방",
      "esName": "Región Chikugo, Prefectura de Fukuoka",
      "ptName": "Região de Chikugo da Província de Fukuoka",
      "thName": "ท้องถิ่นจิกุโงะ จังหวัดฟุกุโอกะ",
      "viName": "Vùng Chikugo, tỉnh Fukuoka",
      "inName": "Daerah Chikugo di Prefektur Fukuoka",
      "tlName": "Rehiyon ng Chikugo sa Fukuoka Prefecture",
      "moName": "Фүкүока аймаг, Чикүго муж",
      "buName": "ချူးခုဂိုဒေသ၊ ဟုခုအိုကစီရင်စု",
      "khName": "តំបន់ជីគឹហ្គោនៃខេត្ដហ្វឹគឹអុកា",
      "neName": "फुकुओका जिल्ला, चिकुगो क्षेत्र"
    },
    "class15": {
      "code": "400041",
      "name": "筑後北部",
      "enName": "Northern Chikugo"
    },
    "class20": {
      "code": "4044800",
      "name": "東峰村",
      "enName": "Toho Village",
      "kana": "とうほうむら",
      "chName": "东峰村",
      "zhName": "東峰村",
      "koName": "도호 촌",
      "esName": "Aldea de Tōhō",
      "ptName": "povoado de Toho",
      "thName": "หมู่บ้านโทโฮ",
      "viName": "làng Toho",
      "inName": "desa Toho",
      "tlName": "nayon ng Toho",
      "moName": "Тохо тосгон",
      "buName": "တိုဟို ကျေးရွာ",
      "khName": "ភូមិ ថូហូ",
      "neName": "तोहो गाउँ"
    }
  },
  "4050300": {
    "office": {
      "code": "400000",
      "name": "福岡県",
      "enName": "Fukuoka",
      "officeName": "福岡管区気象台",
      "chName": "福冈县",
      "zhName": "福岡縣",
      "koName": "후쿠오카현",
      "esName": "Prefectura de Fukuoka",
      "ptName": "Província de Fukuoka",
      "thName": "จังหวัดฟุกุโอกะ",
      "viName": "Tỉnh Fukuoka",
      "inName": "Prefektur Fukuoka",
      "tlName": "Fukuoka Prefecture",
      "moName": "Фүкүока аймаг",
      "buName": "ဖူကူအိုက ပြည်နယ်",
      "khName": "ខេត្ដ ហ្វូគូកា",
      "neName": "फुकुओका जिल्ला"
    },
    "class10": {
      "code": "400040",
      "name": "筑後地方",
      "enName": "Chikugo Region",
      "chName": "福冈县筑后地方",
      "zhName": "福岡縣筑後地方",
      "koName": "후쿠오카 현 지쿠고 지방",
      "esName": "Región Chikugo, Prefectura de Fukuoka",
      "ptName": "Região de Chikugo da Província de Fukuoka",
      "thName": "ท้องถิ่นจิกุโงะ จังหวัดฟุกุโอกะ",
      "viName": "Vùng Chikugo, tỉnh Fukuoka",
      "inName": "Daerah Chikugo di Prefektur Fukuoka",
      "tlName": "Rehiyon ng Chikugo sa Fukuoka Prefecture",
      "moName": "Фүкүока аймаг, Чикүго муж",
      "buName": "ချူးခုဂိုဒေသ၊ ဟုခုအိုကစီရင်စု",
      "khName": "តំបន់ជីគឹហ្គោនៃខេត្ដហ្វឹគឹអុកា",
      "neName": "फुकुओका जिल्ला, चिकुगो क्षेत्र"
    },
    "class15": {
      "code": "400041",
      "name": "筑後北部",
      "enName": "Northern Chikugo"
    },
    "class20": {
      "code": "4050300",
      "name": "大刀洗町",
      "enName": "Tachiarai Town",
      "kana": "たちあらいまち",
      "chName": "大刀洗町",
      "zhName": "大刀洗町",
      "koName": "다치아라이 정",
      "esName": "Pueblo de Tachiarai",
      "ptName": "bairro de Tachiarai",
      "thName": "เมืองทะจิอาราอิ",
      "viName": "thị trấn Tachiarai",
      "inName": "kota Tachiarai",
      "tlName": "bayan ng Tachiarai",
      "moName": "Тачиaраи жижиг хот",
      "buName": "တာကျိယားရာယိ မြို့နယ်",
      "khName": "ទីប្រជុំជន ថាជីអារ៉ាយ",
      "neName": "ताचिआराई नगर"
    }
  },
  "4052200": {
    "office": {
      "code": "400000",
      "name": "福岡県",
      "enName": "Fukuoka",
      "officeName": "福岡管区気象台",
      "chName": "福冈县",
      "zhName": "福岡縣",
      "koName": "후쿠오카현",
      "esName": "Prefectura de Fukuoka",
      "ptName": "Província de Fukuoka",
      "thName": "จังหวัดฟุกุโอกะ",
      "viName": "Tỉnh Fukuoka",
      "inName": "Prefektur Fukuoka",
      "tlName": "Fukuoka Prefecture",
      "moName": "Фүкүока аймаг",
      "buName": "ဖူကူအိုက ပြည်နယ်",
      "khName": "ខេត្ដ ហ្វូគូកា",
      "neName": "फुकुओका जिल्ला"
    },
    "class10": {
      "code": "400040",
      "name": "筑後地方",
      "enName": "Chikugo Region",
      "chName": "福冈县筑后地方",
      "zhName": "福岡縣筑後地方",
      "koName": "후쿠오카 현 지쿠고 지방",
      "esName": "Región Chikugo, Prefectura de Fukuoka",
      "ptName": "Região de Chikugo da Província de Fukuoka",
      "thName": "ท้องถิ่นจิกุโงะ จังหวัดฟุกุโอกะ",
      "viName": "Vùng Chikugo, tỉnh Fukuoka",
      "inName": "Daerah Chikugo di Prefektur Fukuoka",
      "tlName": "Rehiyon ng Chikugo sa Fukuoka Prefecture",
      "moName": "Фүкүока аймаг, Чикүго муж",
      "buName": "ချူးခုဂိုဒေသ၊ ဟုခုအိုကစီရင်စု",
      "khName": "តំបន់ជីគឹហ្គោនៃខេត្ដហ្វឹគឹអុកា",
      "neName": "फुकुओका जिल्ला, चिकुगो क्षेत्र"
    },
    "class15": {
      "code": "400042",
      "name": "筑後南部",
      "enName": "Southern Chikugo"
    },
    "class20": {
      "code": "4052200",
      "name": "大木町",
      "enName": "Oki Town",
      "kana": "おおきまち",
      "chName": "大木町",
      "zhName": "大木町",
      "koName": "오키 정",
      "esName": "Pueblo de Oki",
      "ptName": "bairro de Oki",
      "thName": "เมืองโอกิ",
      "viName": "thị trấn Oki",
      "inName": "kota Oki",
      "tlName": "bayan ng Oki",
      "moName": "Оки жижиг хот",
      "buName": "အိုကိ မြို့နယ်",
      "khName": "ទីប្រជុំជន អូគី",
      "neName": "ओकी नगर"
    }
  },
  "4054400": {
    "office": {
      "code": "400000",
      "name": "福岡県",
      "enName": "Fukuoka",
      "officeName": "福岡管区気象台",
      "chName": "福冈县",
      "zhName": "福岡縣",
      "koName": "후쿠오카현",
      "esName": "Prefectura de Fukuoka",
      "ptName": "Província de Fukuoka",
      "thName": "จังหวัดฟุกุโอกะ",
      "viName": "Tỉnh Fukuoka",
      "inName": "Prefektur Fukuoka",
      "tlName": "Fukuoka Prefecture",
      "moName": "Фүкүока аймаг",
      "buName": "ဖူကူအိုက ပြည်နယ်",
      "khName": "ខេត្ដ ហ្វូគូកា",
      "neName": "फुकुओका जिल्ला"
    },
    "class10": {
      "code": "400040",
      "name": "筑後地方",
      "enName": "Chikugo Region",
      "chName": "福冈县筑后地方",
      "zhName": "福岡縣筑後地方",
      "koName": "후쿠오카 현 지쿠고 지방",
      "esName": "Región Chikugo, Prefectura de Fukuoka",
      "ptName": "Região de Chikugo da Província de Fukuoka",
      "thName": "ท้องถิ่นจิกุโงะ จังหวัดฟุกุโอกะ",
      "viName": "Vùng Chikugo, tỉnh Fukuoka",
      "inName": "Daerah Chikugo di Prefektur Fukuoka",
      "tlName": "Rehiyon ng Chikugo sa Fukuoka Prefecture",
      "moName": "Фүкүока аймаг, Чикүго муж",
      "buName": "ချူးခုဂိုဒေသ၊ ဟုခုအိုကစီရင်စု",
      "khName": "តំបន់ជីគឹហ្គោនៃខេត្ដហ្វឹគឹអុកា",
      "neName": "फुकुओका जिल्ला, चिकुगो क्षेत्र"
    },
    "class15": {
      "code": "400042",
      "name": "筑後南部",
      "enName": "Southern Chikugo"
    },
    "class20": {
      "code": "4054400",
      "name": "広川町",
      "enName": "Hirokawa Town",
      "kana": "ひろかわまち",
      "chName": "福冈广川町",
      "zhName": "福岡廣川町",
      "koName": "후쿠오카 히로카와 정",
      "esName": "Pueblo de Hirokawa, Fukuoka",
      "ptName": "Fukuoka, bairro de Hirokawa",
      "thName": "เมืองฮิโรงาวะ ฟุกุโอกะ",
      "viName": "Thị trấn Hirokawa, Fukuoka",
      "inName": "Kota Hirokawa, Fukuoka",
      "tlName": "bayan ng Hirokawa, Fukuoka",
      "moName": "Фүкүока Хирокава жижиг хот",
      "buName": "ဟုခုအိုကဟိယိုကဝမြို့နယ်",
      "khName": "ទីប្រជុំជនហ៊ីរ៉ូហ្កាវ៉ា ហ្វឹគឹអុកា",
      "neName": "फुकुओका हिरोकावा नगर"
    }
  },
  "4060100": {
    "office": {
      "code": "400000",
      "name": "福岡県",
      "enName": "Fukuoka",
      "officeName": "福岡管区気象台",
      "chName": "福冈县",
      "zhName": "福岡縣",
      "koName": "후쿠오카현",
      "esName": "Prefectura de Fukuoka",
      "ptName": "Província de Fukuoka",
      "thName": "จังหวัดฟุกุโอกะ",
      "viName": "Tỉnh Fukuoka",
      "inName": "Prefektur Fukuoka",
      "tlName": "Fukuoka Prefecture",
      "moName": "Фүкүока аймаг",
      "buName": "ဖူကူအိုက ပြည်နယ်",
      "khName": "ខេត្ដ ហ្វូគូកា",
      "neName": "फुकुओका जिल्ला"
    },
    "class10": {
      "code": "400030",
      "name": "筑豊地方",
      "enName": "Chikuho Region",
      "chName": "福冈县筑丰地方",
      "zhName": "福岡縣筑豐地方",
      "koName": "후쿠오카 현 츠쿠호 지방",
      "esName": "Región Chikuhou, Prefectura de Fukuoka",
      "ptName": "Região de Chikuhō da Província de Fukuoka",
      "thName": "ท้องถิ่นจิกุโฮ จังหวัดฟุกุโอกะ",
      "viName": "Vùng Chikuho, tỉnh Fukuoka",
      "inName": "Daerah Chikuho di Prefektur Fukuoka",
      "tlName": "Rehiyon ng Chikuho sa Fukuoka Prefecture",
      "moName": "Фүкүока аймаг, Чикүхо муж",
      "buName": "ချိခုဟိုဒေသ၊ ဟုခုအိုကစီရင်စု",
      "khName": "តំបន់ជីគឹហូនៃខេត្ដហ្វឹគឹអុកា",
      "neName": "फुकुओका जिल्ला, चिकुहो क्षेत्र"
    },
    "class15": {
      "code": "400030",
      "name": "筑豊地方",
      "enName": "Chikuho Region"
    },
    "class20": {
      "code": "4060100",
      "name": "香春町",
      "enName": "Kawara Town",
      "kana": "かわらまち",
      "chName": "香春町",
      "zhName": "香春町",
      "koName": "가와라 정",
      "esName": "Pueblo de Kawara",
      "ptName": "bairro de Kawara",
      "thName": "เมืองคาวาระ",
      "viName": "thị trấn Kawara",
      "inName": "kota Kawara",
      "tlName": "bayan ng Kawara",
      "moName": "Кавара жижиг хот",
      "buName": "ခါဝါးရာ့ မြို့နယ်",
      "khName": "ទីប្រជុំជន កាវ៉ារ៉ា",
      "neName": "कावारा नगर"
    }
  },
  "4060200": {
    "office": {
      "code": "400000",
      "name": "福岡県",
      "enName": "Fukuoka",
      "officeName": "福岡管区気象台",
      "chName": "福冈县",
      "zhName": "福岡縣",
      "koName": "후쿠오카현",
      "esName": "Prefectura de Fukuoka",
      "ptName": "Província de Fukuoka",
      "thName": "จังหวัดฟุกุโอกะ",
      "viName": "Tỉnh Fukuoka",
      "inName": "Prefektur Fukuoka",
      "tlName": "Fukuoka Prefecture",
      "moName": "Фүкүока аймаг",
      "buName": "ဖူကူအိုက ပြည်နယ်",
      "khName": "ខេត្ដ ហ្វូគូកា",
      "neName": "फुकुओका जिल्ला"
    },
    "class10": {
      "code": "400030",
      "name": "筑豊地方",
      "enName": "Chikuho Region",
      "chName": "福冈县筑丰地方",
      "zhName": "福岡縣筑豐地方",
      "koName": "후쿠오카 현 츠쿠호 지방",
      "esName": "Región Chikuhou, Prefectura de Fukuoka",
      "ptName": "Região de Chikuhō da Província de Fukuoka",
      "thName": "ท้องถิ่นจิกุโฮ จังหวัดฟุกุโอกะ",
      "viName": "Vùng Chikuho, tỉnh Fukuoka",
      "inName": "Daerah Chikuho di Prefektur Fukuoka",
      "tlName": "Rehiyon ng Chikuho sa Fukuoka Prefecture",
      "moName": "Фүкүока аймаг, Чикүхо муж",
      "buName": "ချိခုဟိုဒေသ၊ ဟုခုအိုကစီရင်စု",
      "khName": "តំបន់ជីគឹហូនៃខេត្ដហ្វឹគឹអុកា",
      "neName": "फुकुओका जिल्ला, चिकुहो क्षेत्र"
    },
    "class15": {
      "code": "400030",
      "name": "筑豊地方",
      "enName": "Chikuho Region"
    },
    "class20": {
      "code": "4060200",
      "name": "添田町",
      "enName": "Soeda Town",
      "kana": "そえだまち",
      "chName": "添田町",
      "zhName": "添田町",
      "koName": "소에다 정",
      "esName": "Pueblo de Soeda",
      "ptName": "bairro de Soeda",
      "thName": "เมืองโซเอดะ",
      "viName": "thị trấn Soeda",
      "inName": "kota Soeda",
      "tlName": "bayan ng Soeda",
      "moName": "Соэда жижиг хот",
      "buName": "ဆိုးအဲဒ မြို့နယ်",
      "khName": "ទីប្រជុំជន សូដា",
      "neName": "सोएदा नगर"
    }
  },
  "4060400": {
    "office": {
      "code": "400000",
      "name": "福岡県",
      "enName": "Fukuoka",
      "officeName": "福岡管区気象台",
      "chName": "福冈县",
      "zhName": "福岡縣",
      "koName": "후쿠오카현",
      "esName": "Prefectura de Fukuoka",
      "ptName": "Província de Fukuoka",
      "thName": "จังหวัดฟุกุโอกะ",
      "viName": "Tỉnh Fukuoka",
      "inName": "Prefektur Fukuoka",
      "tlName": "Fukuoka Prefecture",
      "moName": "Фүкүока аймаг",
      "buName": "ဖူကူအိုက ပြည်နယ်",
      "khName": "ខេត្ដ ហ្វូគូកា",
      "neName": "फुकुओका जिल्ला"
    },
    "class10": {
      "code": "400030",
      "name": "筑豊地方",
      "enName": "Chikuho Region",
      "chName": "福冈县筑丰地方",
      "zhName": "福岡縣筑豐地方",
      "koName": "후쿠오카 현 츠쿠호 지방",
      "esName": "Región Chikuhou, Prefectura de Fukuoka",
      "ptName": "Região de Chikuhō da Província de Fukuoka",
      "thName": "ท้องถิ่นจิกุโฮ จังหวัดฟุกุโอกะ",
      "viName": "Vùng Chikuho, tỉnh Fukuoka",
      "inName": "Daerah Chikuho di Prefektur Fukuoka",
      "tlName": "Rehiyon ng Chikuho sa Fukuoka Prefecture",
      "moName": "Фүкүока аймаг, Чикүхо муж",
      "buName": "ချိခုဟိုဒေသ၊ ဟုခုအိုကစီရင်စု",
      "khName": "តំបន់ជីគឹហូនៃខេត្ដហ្វឹគឹអុកា",
      "neName": "फुकुओका जिल्ला, चिकुहो क्षेत्र"
    },
    "class15": {
      "code": "400030",
      "name": "筑豊地方",
      "enName": "Chikuho Region"
    },
    "class20": {
      "code": "4060400",
      "name": "糸田町",
      "enName": "Itoda Town",
      "kana": "いとだまち",
      "chName": "糸田町",
      "zhName": "糸田町",
      "koName": "이토다 정",
      "esName": "Pueblo de Itoda",
      "ptName": "bairro de Itoda",
      "thName": "เมืองอิโตดะ",
      "viName": "thị trấn Itoda",
      "inName": "kota Itoda",
      "tlName": "bayan ng Itoda",
      "moName": "Итода жижиг хот",
      "buName": "အိတောဒ မြို့နယ်",
      "khName": "ទីប្រជុំជន អ៊ីថូដា",
      "neName": "इतोदा नगर"
    }
  },
  "4060500": {
    "office": {
      "code": "400000",
      "name": "福岡県",
      "enName": "Fukuoka",
      "officeName": "福岡管区気象台",
      "chName": "福冈县",
      "zhName": "福岡縣",
      "koName": "후쿠오카현",
      "esName": "Prefectura de Fukuoka",
      "ptName": "Província de Fukuoka",
      "thName": "จังหวัดฟุกุโอกะ",
      "viName": "Tỉnh Fukuoka",
      "inName": "Prefektur Fukuoka",
      "tlName": "Fukuoka Prefecture",
      "moName": "Фүкүока аймаг",
      "buName": "ဖူကူအိုက ပြည်နယ်",
      "khName": "ខេត្ដ ហ្វូគូកា",
      "neName": "फुकुओका जिल्ला"
    },
    "class10": {
      "code": "400030",
      "name": "筑豊地方",
      "enName": "Chikuho Region",
      "chName": "福冈县筑丰地方",
      "zhName": "福岡縣筑豐地方",
      "koName": "후쿠오카 현 츠쿠호 지방",
      "esName": "Región Chikuhou, Prefectura de Fukuoka",
      "ptName": "Região de Chikuhō da Província de Fukuoka",
      "thName": "ท้องถิ่นจิกุโฮ จังหวัดฟุกุโอกะ",
      "viName": "Vùng Chikuho, tỉnh Fukuoka",
      "inName": "Daerah Chikuho di Prefektur Fukuoka",
      "tlName": "Rehiyon ng Chikuho sa Fukuoka Prefecture",
      "moName": "Фүкүока аймаг, Чикүхо муж",
      "buName": "ချိခုဟိုဒေသ၊ ဟုခုအိုကစီရင်စု",
      "khName": "តំបន់ជីគឹហូនៃខេត្ដហ្វឹគឹអុកា",
      "neName": "फुकुओका जिल्ला, चिकुहो क्षेत्र"
    },
    "class15": {
      "code": "400030",
      "name": "筑豊地方",
      "enName": "Chikuho Region"
    },
    "class20": {
      "code": "4060500",
      "name": "川崎町",
      "enName": "Kawasaki Town",
      "kana": "かわさきまち",
      "chName": "福冈川崎町",
      "zhName": "福岡川崎町",
      "koName": "후쿠오카 가와사키 정",
      "esName": "Pueblo de Kawasaki, Fukuok",
      "ptName": "Fukuoka, bairro de Kawasaki",
      "thName": "เมืองคาวาซากิ ฟุกุโอกะ",
      "viName": "Thị trấn Kawasaki, Fukuoka",
      "inName": "Kota Kawasaki, Fukuoka",
      "tlName": "bayan ng Kawasaki, Fukuoka",
      "moName": "Фүкүока Кавасаки жижиг хот",
      "buName": "ဟုခုအိုကကဝဆခိမြို့နယ်",
      "khName": "ទីប្រជុំជនកាវ៉ាសាគី​ ហ្វឹគឹអុកា",
      "neName": "फुकुओका कावासाकी नगर"
    }
  },
  "4060800": {
    "office": {
      "code": "400000",
      "name": "福岡県",
      "enName": "Fukuoka",
      "officeName": "福岡管区気象台",
      "chName": "福冈县",
      "zhName": "福岡縣",
      "koName": "후쿠오카현",
      "esName": "Prefectura de Fukuoka",
      "ptName": "Província de Fukuoka",
      "thName": "จังหวัดฟุกุโอกะ",
      "viName": "Tỉnh Fukuoka",
      "inName": "Prefektur Fukuoka",
      "tlName": "Fukuoka Prefecture",
      "moName": "Фүкүока аймаг",
      "buName": "ဖူကူအိုက ပြည်နယ်",
      "khName": "ខេត្ដ ហ្វូគូកា",
      "neName": "फुकुओका जिल्ला"
    },
    "class10": {
      "code": "400030",
      "name": "筑豊地方",
      "enName": "Chikuho Region",
      "chName": "福冈县筑丰地方",
      "zhName": "福岡縣筑豐地方",
      "koName": "후쿠오카 현 츠쿠호 지방",
      "esName": "Región Chikuhou, Prefectura de Fukuoka",
      "ptName": "Região de Chikuhō da Província de Fukuoka",
      "thName": "ท้องถิ่นจิกุโฮ จังหวัดฟุกุโอกะ",
      "viName": "Vùng Chikuho, tỉnh Fukuoka",
      "inName": "Daerah Chikuho di Prefektur Fukuoka",
      "tlName": "Rehiyon ng Chikuho sa Fukuoka Prefecture",
      "moName": "Фүкүока аймаг, Чикүхо муж",
      "buName": "ချိခုဟိုဒေသ၊ ဟုခုအိုကစီရင်စု",
      "khName": "តំបន់ជីគឹហូនៃខេត្ដហ្វឹគឹអុកា",
      "neName": "फुकुओका जिल्ला, चिकुहो क्षेत्र"
    },
    "class15": {
      "code": "400030",
      "name": "筑豊地方",
      "enName": "Chikuho Region"
    },
    "class20": {
      "code": "4060800",
      "name": "大任町",
      "enName": "Oto Town",
      "kana": "おおとうまち",
      "chName": "大任町",
      "zhName": "大任町",
      "koName": "오토 정",
      "esName": "Pueblo de Oto",
      "ptName": "bairro de Oto",
      "thName": "เมืองโอตะ",
      "viName": "thị trấn Oto",
      "inName": "kota Oto",
      "tlName": "bayan ng Oto",
      "moName": "Ото жижиг хот",
      "buName": "အိုတို မြို့နယ်",
      "khName": "ទីប្រជុំជន អូតូ",
      "neName": "ओतो नगर"
    }
  },
  "4060900": {
    "office": {
      "code": "400000",
      "name": "福岡県",
      "enName": "Fukuoka",
      "officeName": "福岡管区気象台",
      "chName": "福冈县",
      "zhName": "福岡縣",
      "koName": "후쿠오카현",
      "esName": "Prefectura de Fukuoka",
      "ptName": "Província de Fukuoka",
      "thName": "จังหวัดฟุกุโอกะ",
      "viName": "Tỉnh Fukuoka",
      "inName": "Prefektur Fukuoka",
      "tlName": "Fukuoka Prefecture",
      "moName": "Фүкүока аймаг",
      "buName": "ဖူကူအိုက ပြည်နယ်",
      "khName": "ខេត្ដ ហ្វូគូកា",
      "neName": "फुकुओका जिल्ला"
    },
    "class10": {
      "code": "400030",
      "name": "筑豊地方",
      "enName": "Chikuho Region",
      "chName": "福冈县筑丰地方",
      "zhName": "福岡縣筑豐地方",
      "koName": "후쿠오카 현 츠쿠호 지방",
      "esName": "Región Chikuhou, Prefectura de Fukuoka",
      "ptName": "Região de Chikuhō da Província de Fukuoka",
      "thName": "ท้องถิ่นจิกุโฮ จังหวัดฟุกุโอกะ",
      "viName": "Vùng Chikuho, tỉnh Fukuoka",
      "inName": "Daerah Chikuho di Prefektur Fukuoka",
      "tlName": "Rehiyon ng Chikuho sa Fukuoka Prefecture",
      "moName": "Фүкүока аймаг, Чикүхо муж",
      "buName": "ချိခုဟိုဒေသ၊ ဟုခုအိုကစီရင်စု",
      "khName": "តំបន់ជីគឹហូនៃខេត្ដហ្វឹគឹអុកា",
      "neName": "फुकुओका जिल्ला, चिकुहो क्षेत्र"
    },
    "class15": {
      "code": "400030",
      "name": "筑豊地方",
      "enName": "Chikuho Region"
    },
    "class20": {
      "code": "4060900",
      "name": "赤村",
      "enName": "Aka Village",
      "kana": "あかむら",
      "chName": "赤村",
      "zhName": "赤村",
      "koName": "아카 촌",
      "esName": "Aldea de Aka",
      "ptName": "povoado de Aka",
      "thName": "หมู่บ้านอากะ",
      "viName": "làng Aka",
      "inName": "desa Aka",
      "tlName": "nayon ng Aka",
      "moName": "Aка тосгон",
      "buName": "အေးက ကျေးရွာ",
      "khName": "ភូមិ អាកា",
      "neName": "आका गाउँ"
    }
  },
  "4061000": {
    "office": {
      "code": "400000",
      "name": "福岡県",
      "enName": "Fukuoka",
      "officeName": "福岡管区気象台",
      "chName": "福冈县",
      "zhName": "福岡縣",
      "koName": "후쿠오카현",
      "esName": "Prefectura de Fukuoka",
      "ptName": "Província de Fukuoka",
      "thName": "จังหวัดฟุกุโอกะ",
      "viName": "Tỉnh Fukuoka",
      "inName": "Prefektur Fukuoka",
      "tlName": "Fukuoka Prefecture",
      "moName": "Фүкүока аймаг",
      "buName": "ဖူကူအိုက ပြည်နယ်",
      "khName": "ខេត្ដ ហ្វូគូកា",
      "neName": "फुकुओका जिल्ला"
    },
    "class10": {
      "code": "400030",
      "name": "筑豊地方",
      "enName": "Chikuho Region",
      "chName": "福冈县筑丰地方",
      "zhName": "福岡縣筑豐地方",
      "koName": "후쿠오카 현 츠쿠호 지방",
      "esName": "Región Chikuhou, Prefectura de Fukuoka",
      "ptName": "Região de Chikuhō da Província de Fukuoka",
      "thName": "ท้องถิ่นจิกุโฮ จังหวัดฟุกุโอกะ",
      "viName": "Vùng Chikuho, tỉnh Fukuoka",
      "inName": "Daerah Chikuho di Prefektur Fukuoka",
      "tlName": "Rehiyon ng Chikuho sa Fukuoka Prefecture",
      "moName": "Фүкүока аймаг, Чикүхо муж",
      "buName": "ချိခုဟိုဒေသ၊ ဟုခုအိုကစီရင်စု",
      "khName": "តំបន់ជីគឹហូនៃខេត្ដហ្វឹគឹអុកា",
      "neName": "फुकुओका जिल्ला, चिकुहो क्षेत्र"
    },
    "class15": {
      "code": "400030",
      "name": "筑豊地方",
      "enName": "Chikuho Region"
    },
    "class20": {
      "code": "4061000",
      "name": "福智町",
      "enName": "Fukuchi Town",
      "kana": "ふくちまち",
      "chName": "福智町",
      "zhName": "福智町",
      "koName": "후쿠치 정",
      "esName": "Pueblo de Fukuchi",
      "ptName": "bairro de Fukuchi",
      "thName": "เมืองฟุคุจิ",
      "viName": "thị trấn Fukuchi",
      "inName": "kota Fukuchi",
      "tlName": "bayan ng Fukuchi",
      "moName": "Фүкүчи жижиг хот",
      "buName": "ဖူကုကျိ မြို့နယ်",
      "khName": "ទីប្រជុំជន ហ្វូគូជី",
      "neName": "फुकुची नगर"
    }
  },
  "4062100": {
    "office": {
      "code": "400000",
      "name": "福岡県",
      "enName": "Fukuoka",
      "officeName": "福岡管区気象台",
      "chName": "福冈县",
      "zhName": "福岡縣",
      "koName": "후쿠오카현",
      "esName": "Prefectura de Fukuoka",
      "ptName": "Província de Fukuoka",
      "thName": "จังหวัดฟุกุโอกะ",
      "viName": "Tỉnh Fukuoka",
      "inName": "Prefektur Fukuoka",
      "tlName": "Fukuoka Prefecture",
      "moName": "Фүкүока аймаг",
      "buName": "ဖူကူအိုက ပြည်နယ်",
      "khName": "ខេត្ដ ហ្វូគូកា",
      "neName": "फुकुओका जिल्ला"
    },
    "class10": {
      "code": "400020",
      "name": "北九州地方",
      "enName": "Kitakyushu Region",
      "chName": "福冈县北九州地方",
      "zhName": "福岡縣北九州地方",
      "koName": "후쿠오카 현 기타큐슈 지방",
      "esName": "Región Kitakyushu, Prefectura de Fukuoka",
      "ptName": "Região de Kita-Kyūshū da Província de Fukuoka",
      "thName": "ท้องถิ่นคิตะกิวชู จังหวัดฟุกุโอกะ",
      "viName": "Vùng Kitakyushu, tỉnh Fukuoka",
      "inName": "Daerah Kitakyushu di Prefektur Fukuoka",
      "tlName": "Rehiyon ng Kita-Kyushu sa Fukuoka Prefecture",
      "moName": "Фүкүока аймаг, Китакюшү муж",
      "buName": "ခိတခယူးရှုးဒေသ၊ ဟုခုအိုကစီရင်စု",
      "khName": "តំបន់គីតាក់ខ្យឹហ្សឹនៃខេត្ដហ្វឹគឹអុកា",
      "neName": "फुकुओका जिल्ला, किताक्युस्यु क्षेत्र"
    },
    "class15": {
      "code": "400022",
      "name": "京築",
      "enName": "Keichiku"
    },
    "class20": {
      "code": "4062100",
      "name": "苅田町",
      "enName": "Kanda Town",
      "kana": "かんだまち",
      "chName": "苅田町",
      "zhName": "苅田町",
      "koName": "간다 정",
      "esName": "Pueblo de Kanda",
      "ptName": "bairro de Kanda",
      "thName": "เมืองคันดะ",
      "viName": "thị trấn Kanda",
      "inName": "kota Kanda",
      "tlName": "bayan ng Kanda",
      "moName": "Канда жижиг хот",
      "buName": "ခန်းဒ မြို့နယ်",
      "khName": "ទីប្រជុំជន កានដា",
      "neName": "कान्दा नगर"
    }
  },
  "4062500": {
    "office": {
      "code": "400000",
      "name": "福岡県",
      "enName": "Fukuoka",
      "officeName": "福岡管区気象台",
      "chName": "福冈县",
      "zhName": "福岡縣",
      "koName": "후쿠오카현",
      "esName": "Prefectura de Fukuoka",
      "ptName": "Província de Fukuoka",
      "thName": "จังหวัดฟุกุโอกะ",
      "viName": "Tỉnh Fukuoka",
      "inName": "Prefektur Fukuoka",
      "tlName": "Fukuoka Prefecture",
      "moName": "Фүкүока аймаг",
      "buName": "ဖူကူအိုက ပြည်နယ်",
      "khName": "ខេត្ដ ហ្វូគូកា",
      "neName": "फुकुओका जिल्ला"
    },
    "class10": {
      "code": "400020",
      "name": "北九州地方",
      "enName": "Kitakyushu Region",
      "chName": "福冈县北九州地方",
      "zhName": "福岡縣北九州地方",
      "koName": "후쿠오카 현 기타큐슈 지방",
      "esName": "Región Kitakyushu, Prefectura de Fukuoka",
      "ptName": "Região de Kita-Kyūshū da Província de Fukuoka",
      "thName": "ท้องถิ่นคิตะกิวชู จังหวัดฟุกุโอกะ",
      "viName": "Vùng Kitakyushu, tỉnh Fukuoka",
      "inName": "Daerah Kitakyushu di Prefektur Fukuoka",
      "tlName": "Rehiyon ng Kita-Kyushu sa Fukuoka Prefecture",
      "moName": "Фүкүока аймаг, Китакюшү муж",
      "buName": "ခိတခယူးရှုးဒေသ၊ ဟုခုအိုကစီရင်စု",
      "khName": "តំបន់គីតាក់ខ្យឹហ្សឹនៃខេត្ដហ្វឹគឹអុកា",
      "neName": "फुकुओका जिल्ला, किताक्युस्यु क्षेत्र"
    },
    "class15": {
      "code": "400022",
      "name": "京築",
      "enName": "Keichiku"
    },
    "class20": {
      "code": "4062500",
      "name": "みやこ町",
      "enName": "Miyako Town",
      "kana": "みやこまち",
      "chName": "京都町",
      "zhName": "京都町",
      "koName": "미야코 정",
      "esName": "Pueblo de Miyako",
      "ptName": "bairro de Miyako",
      "thName": "เมืองมิยาโกะ",
      "viName": "thị trấn Miyako",
      "inName": "kota Miyako",
      "tlName": "bayan ng Miyako",
      "moName": "Мияко жижиг хот",
      "buName": "မီယားကို မြို့နယ်",
      "khName": "ទីប្រជុំជន ម៉ីយ៉ាកុ",
      "neName": "मियाको नगर"
    }
  },
  "4064200": {
    "office": {
      "code": "400000",
      "name": "福岡県",
      "enName": "Fukuoka",
      "officeName": "福岡管区気象台",
      "chName": "福冈县",
      "zhName": "福岡縣",
      "koName": "후쿠오카현",
      "esName": "Prefectura de Fukuoka",
      "ptName": "Província de Fukuoka",
      "thName": "จังหวัดฟุกุโอกะ",
      "viName": "Tỉnh Fukuoka",
      "inName": "Prefektur Fukuoka",
      "tlName": "Fukuoka Prefecture",
      "moName": "Фүкүока аймаг",
      "buName": "ဖူကူအိုက ပြည်နယ်",
      "khName": "ខេត្ដ ហ្វូគូកា",
      "neName": "फुकुओका जिल्ला"
    },
    "class10": {
      "code": "400020",
      "name": "北九州地方",
      "enName": "Kitakyushu Region",
      "chName": "福冈县北九州地方",
      "zhName": "福岡縣北九州地方",
      "koName": "후쿠오카 현 기타큐슈 지방",
      "esName": "Región Kitakyushu, Prefectura de Fukuoka",
      "ptName": "Região de Kita-Kyūshū da Província de Fukuoka",
      "thName": "ท้องถิ่นคิตะกิวชู จังหวัดฟุกุโอกะ",
      "viName": "Vùng Kitakyushu, tỉnh Fukuoka",
      "inName": "Daerah Kitakyushu di Prefektur Fukuoka",
      "tlName": "Rehiyon ng Kita-Kyushu sa Fukuoka Prefecture",
      "moName": "Фүкүока аймаг, Китакюшү муж",
      "buName": "ခိတခယူးရှုးဒေသ၊ ဟုခုအိုကစီရင်စု",
      "khName": "តំបន់គីតាក់ខ្យឹហ្សឹនៃខេត្ដហ្វឹគឹអុកា",
      "neName": "फुकुओका जिल्ला, किताक्युस्यु क्षेत्र"
    },
    "class15": {
      "code": "400022",
      "name": "京築",
      "enName": "Keichiku"
    },
    "class20": {
      "code": "4064200",
      "name": "吉富町",
      "enName": "Yoshitomi Town",
      "kana": "よしとみまち",
      "chName": "吉富町",
      "zhName": "吉富町",
      "koName": "요시토미 정",
      "esName": "Pueblo de Yoshitomi",
      "ptName": "bairro de Yoshitomi",
      "thName": "เมืองโยชิโทมิ",
      "viName": "thị trấn Yoshitomi",
      "inName": "kota Yoshitomi",
      "tlName": "bayan ng Yoshitomi",
      "moName": "Ёшитоми жижиг хот",
      "buName": "ယိုရှိတိုမိ မြို့နယ်",
      "khName": "ទីប្រជុំជន យ៉ូស៊ីតុមី",
      "neName": "योशितोमी नगर"
    }
  },
  "4064600": {
    "office": {
      "code": "400000",
      "name": "福岡県",
      "enName": "Fukuoka",
      "officeName": "福岡管区気象台",
      "chName": "福冈县",
      "zhName": "福岡縣",
      "koName": "후쿠오카현",
      "esName": "Prefectura de Fukuoka",
      "ptName": "Província de Fukuoka",
      "thName": "จังหวัดฟุกุโอกะ",
      "viName": "Tỉnh Fukuoka",
      "inName": "Prefektur Fukuoka",
      "tlName": "Fukuoka Prefecture",
      "moName": "Фүкүока аймаг",
      "buName": "ဖူကူအိုက ပြည်နယ်",
      "khName": "ខេត្ដ ហ្វូគូកា",
      "neName": "फुकुओका जिल्ला"
    },
    "class10": {
      "code": "400020",
      "name": "北九州地方",
      "enName": "Kitakyushu Region",
      "chName": "福冈县北九州地方",
      "zhName": "福岡縣北九州地方",
      "koName": "후쿠오카 현 기타큐슈 지방",
      "esName": "Región Kitakyushu, Prefectura de Fukuoka",
      "ptName": "Região de Kita-Kyūshū da Província de Fukuoka",
      "thName": "ท้องถิ่นคิตะกิวชู จังหวัดฟุกุโอกะ",
      "viName": "Vùng Kitakyushu, tỉnh Fukuoka",
      "inName": "Daerah Kitakyushu di Prefektur Fukuoka",
      "tlName": "Rehiyon ng Kita-Kyushu sa Fukuoka Prefecture",
      "moName": "Фүкүока аймаг, Китакюшү муж",
      "buName": "ခိတခယူးရှုးဒေသ၊ ဟုခုအိုကစီရင်စု",
      "khName": "តំបន់គីតាក់ខ្យឹហ្សឹនៃខេត្ដហ្វឹគឹអុកា",
      "neName": "फुकुओका जिल्ला, किताक्युस्यु क्षेत्र"
    },
    "class15": {
      "code": "400022",
      "name": "京築",
      "enName": "Keichiku"
    },
    "class20": {
      "code": "4064600",
      "name": "上毛町",
      "enName": "Koge Town",
      "kana": "こうげまち",
      "chName": "上毛町",
      "zhName": "上毛町",
      "koName": "고게 정",
      "esName": "Pueblo de Koge",
      "ptName": "bairro de Koge",
      "thName": "เมืองโคเงะ",
      "viName": "thị trấn Koge",
      "inName": "kota Koge",
      "tlName": "bayan ng Koge",
      "moName": "Когэ жижиг хот",
      "buName": "ခိုဂဲ့ မြို့နယ်",
      "khName": "ទីប្រជុំជន ខូក",
      "neName": "कोगे नगर"
    }
  },
  "4064700": {
    "office": {
      "code": "400000",
      "name": "福岡県",
      "enName": "Fukuoka",
      "officeName": "福岡管区気象台",
      "chName": "福冈县",
      "zhName": "福岡縣",
      "koName": "후쿠오카현",
      "esName": "Prefectura de Fukuoka",
      "ptName": "Província de Fukuoka",
      "thName": "จังหวัดฟุกุโอกะ",
      "viName": "Tỉnh Fukuoka",
      "inName": "Prefektur Fukuoka",
      "tlName": "Fukuoka Prefecture",
      "moName": "Фүкүока аймаг",
      "buName": "ဖူကူအိုက ပြည်နယ်",
      "khName": "ខេត្ដ ហ្វូគូកា",
      "neName": "फुकुओका जिल्ला"
    },
    "class10": {
      "code": "400020",
      "name": "北九州地方",
      "enName": "Kitakyushu Region",
      "chName": "福冈县北九州地方",
      "zhName": "福岡縣北九州地方",
      "koName": "후쿠오카 현 기타큐슈 지방",
      "esName": "Región Kitakyushu, Prefectura de Fukuoka",
      "ptName": "Região de Kita-Kyūshū da Província de Fukuoka",
      "thName": "ท้องถิ่นคิตะกิวชู จังหวัดฟุกุโอกะ",
      "viName": "Vùng Kitakyushu, tỉnh Fukuoka",
      "inName": "Daerah Kitakyushu di Prefektur Fukuoka",
      "tlName": "Rehiyon ng Kita-Kyushu sa Fukuoka Prefecture",
      "moName": "Фүкүока аймаг, Китакюшү муж",
      "buName": "ခိတခယူးရှုးဒေသ၊ ဟုခုအိုကစီရင်စု",
      "khName": "តំបន់គីតាក់ខ្យឹហ្សឹនៃខេត្ដហ្វឹគឹអុកា",
      "neName": "फुकुओका जिल्ला, किताक्युस्यु क्षेत्र"
    },
    "class15": {
      "code": "400022",
      "name": "京築",
      "enName": "Keichiku"
    },
    "class20": {
      "code": "4064700",
      "name": "築上町",
      "enName": "Chikujo Town",
      "kana": "ちくじょうまち",
      "chName": "筑上町",
      "zhName": "築上町",
      "koName": "지쿠조 정",
      "esName": "Pueblo de Chikujyō",
      "ptName": "bairro de Chikujo",
      "thName": "เมืองจิคุโจ",
      "viName": "thị trấn Chikujo",
      "inName": "kota Chikujo",
      "tlName": "bayan ng Chikujo",
      "moName": "Чикүжо жижиг хот",
      "buName": "ချီကုဂျို မြို့နယ်",
      "khName": "ទីប្រជុំជន ឈីគូជូ",
      "neName": "चिकुजो नगर"
    }
  },
  "4120100": {
    "office": {
      "code": "410000",
      "name": "佐賀県",
      "enName": "Saga",
      "officeName": "佐賀地方気象台",
      "chName": "佐贺县",
      "zhName": "佐賀縣",
      "koName": "사가현",
      "esName": "Prefectura de Saga",
      "ptName": "Província de Saga",
      "thName": "จังหวัดซางะ",
      "viName": "Tỉnh Saga",
      "inName": "Prefektur Saga",
      "tlName": "Saga Prefecture",
      "moName": "Сага аймаг",
      "buName": "ဆာဂါ့ ပြည်နယ်",
      "khName": "ខេត្ដ សាហ្គា",
      "neName": "सागा जिल्ला"
    },
    "class10": {
      "code": "410010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "佐贺县南部",
      "zhName": "佐賀縣南部",
      "koName": "사가 현 남부",
      "esName": "Sur de Prefectura de Saga",
      "ptName": "Sul da Província de Saga",
      "thName": "จังหวัดซางะตอนใต้",
      "viName": "Miền Nam tỉnh Saga",
      "inName": "Bagian Selatan Prefektur Saga",
      "tlName": "Timog na bahagi ng Saga Prefecture",
      "moName": "Өмнөд Сага аймаг",
      "buName": "ဆဂစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដសាហ្គា",
      "neName": "सागा जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "410011",
      "name": "佐賀多久地区",
      "enName": "Saga Taku District"
    },
    "class20": {
      "code": "4120100",
      "name": "佐賀市",
      "enName": "Saga City",
      "kana": "さがし",
      "chName": "佐贺市",
      "zhName": "佐賀市",
      "koName": "사가 시",
      "esName": "Ciudad de Saga",
      "ptName": "cidade de Saga",
      "thName": "เมืองซากะ",
      "viName": "thành phố Saga",
      "inName": "kota Saga",
      "tlName": "siyudad ng Saga",
      "moName": "Сага хот",
      "buName": "ဆာဂ မြို့",
      "khName": "ទីក្រុង សាហ្គា",
      "neName": "सागा सहर"
    }
  },
  "4120200": {
    "office": {
      "code": "410000",
      "name": "佐賀県",
      "enName": "Saga",
      "officeName": "佐賀地方気象台",
      "chName": "佐贺县",
      "zhName": "佐賀縣",
      "koName": "사가현",
      "esName": "Prefectura de Saga",
      "ptName": "Província de Saga",
      "thName": "จังหวัดซางะ",
      "viName": "Tỉnh Saga",
      "inName": "Prefektur Saga",
      "tlName": "Saga Prefecture",
      "moName": "Сага аймаг",
      "buName": "ဆာဂါ့ ပြည်နယ်",
      "khName": "ខេត្ដ សាហ្គា",
      "neName": "सागा जिल्ला"
    },
    "class10": {
      "code": "410020",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "佐贺县北部",
      "zhName": "佐賀縣北部",
      "koName": "사가 현 북부",
      "esName": "Norte de Prefectura de Saga",
      "ptName": "Norte da Província de Saga",
      "thName": "จังหวัดซางะตอนเหนือ",
      "viName": "Miền Bắc tỉnh Saga",
      "inName": "Bagian Utara Prefektur Saga",
      "tlName": "Hilagang bahagi ng Saga Prefecture",
      "moName": "Хойд Сага аймаг",
      "buName": "ဆဂစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដសាហ្គា",
      "neName": "सागा जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "410021",
      "name": "唐津地区",
      "enName": "Karatsu District"
    },
    "class20": {
      "code": "4120200",
      "name": "唐津市",
      "enName": "Karatsu City",
      "kana": "からつし",
      "chName": "唐津市",
      "zhName": "唐津市",
      "koName": "가라쓰 시",
      "esName": "Ciudad de Karatsu",
      "ptName": "cidade de Karatsu",
      "thName": "เมืองคะรัตสึ",
      "viName": "thành phố Karatsu",
      "inName": "kota Karatsu",
      "tlName": "siyudad ng Karatsu",
      "moName": "Карацү хот",
      "buName": "ခါရာ့ဆု မြို့",
      "khName": "ទីក្រុង ការ៉ាតស៊ូ",
      "neName": "कारात्सु सहर"
    }
  },
  "4120300": {
    "office": {
      "code": "410000",
      "name": "佐賀県",
      "enName": "Saga",
      "officeName": "佐賀地方気象台",
      "chName": "佐贺县",
      "zhName": "佐賀縣",
      "koName": "사가현",
      "esName": "Prefectura de Saga",
      "ptName": "Província de Saga",
      "thName": "จังหวัดซางะ",
      "viName": "Tỉnh Saga",
      "inName": "Prefektur Saga",
      "tlName": "Saga Prefecture",
      "moName": "Сага аймаг",
      "buName": "ဆာဂါ့ ပြည်နယ်",
      "khName": "ខេត្ដ សាហ្គា",
      "neName": "सागा जिल्ला"
    },
    "class10": {
      "code": "410010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "佐贺县南部",
      "zhName": "佐賀縣南部",
      "koName": "사가 현 남부",
      "esName": "Sur de Prefectura de Saga",
      "ptName": "Sul da Província de Saga",
      "thName": "จังหวัดซางะตอนใต้",
      "viName": "Miền Nam tỉnh Saga",
      "inName": "Bagian Selatan Prefektur Saga",
      "tlName": "Timog na bahagi ng Saga Prefecture",
      "moName": "Өмнөд Сага аймаг",
      "buName": "ဆဂစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដសាហ្គា",
      "neName": "सागा जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "410012",
      "name": "鳥栖地区",
      "enName": "Tosu District"
    },
    "class20": {
      "code": "4120300",
      "name": "鳥栖市",
      "enName": "Tosu City",
      "kana": "とすし",
      "chName": "鸟栖市",
      "zhName": "鳥棲市",
      "koName": "도스 시",
      "esName": "Ciudad de Tosu",
      "ptName": "cidade de Tosu",
      "thName": "เมืองโทสึ",
      "viName": "thành phố Tosu",
      "inName": "kota Tosu",
      "tlName": "siyudad ng Tosu",
      "moName": "Тосү хот",
      "buName": "တိုဆု မြို့",
      "khName": "ទីក្រុង តូស៊ូ",
      "neName": "तोसु सहर"
    }
  },
  "4120400": {
    "office": {
      "code": "410000",
      "name": "佐賀県",
      "enName": "Saga",
      "officeName": "佐賀地方気象台",
      "chName": "佐贺县",
      "zhName": "佐賀縣",
      "koName": "사가현",
      "esName": "Prefectura de Saga",
      "ptName": "Província de Saga",
      "thName": "จังหวัดซางะ",
      "viName": "Tỉnh Saga",
      "inName": "Prefektur Saga",
      "tlName": "Saga Prefecture",
      "moName": "Сага аймаг",
      "buName": "ဆာဂါ့ ပြည်နယ်",
      "khName": "ខេត្ដ សាហ្គា",
      "neName": "सागा जिल्ला"
    },
    "class10": {
      "code": "410010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "佐贺县南部",
      "zhName": "佐賀縣南部",
      "koName": "사가 현 남부",
      "esName": "Sur de Prefectura de Saga",
      "ptName": "Sul da Província de Saga",
      "thName": "จังหวัดซางะตอนใต้",
      "viName": "Miền Nam tỉnh Saga",
      "inName": "Bagian Selatan Prefektur Saga",
      "tlName": "Timog na bahagi ng Saga Prefecture",
      "moName": "Өмнөд Сага аймаг",
      "buName": "ဆဂစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដសាហ្គា",
      "neName": "सागा जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "410011",
      "name": "佐賀多久地区",
      "enName": "Saga Taku District"
    },
    "class20": {
      "code": "4120400",
      "name": "多久市",
      "enName": "Taku City",
      "kana": "たくし",
      "chName": "多久市",
      "zhName": "多久市",
      "koName": "다쿠 시",
      "esName": "Ciudad de Taku",
      "ptName": "cidade de Taku",
      "thName": "เมืองทาคุ",
      "viName": "thành phố Taku",
      "inName": "kota Taku",
      "tlName": "siyudad ng Taku",
      "moName": "Такү хот",
      "buName": "တာကု မြို့",
      "khName": "ទីក្រុង ថាឃូ",
      "neName": "ताकु सहर"
    }
  },
  "4120500": {
    "office": {
      "code": "410000",
      "name": "佐賀県",
      "enName": "Saga",
      "officeName": "佐賀地方気象台",
      "chName": "佐贺县",
      "zhName": "佐賀縣",
      "koName": "사가현",
      "esName": "Prefectura de Saga",
      "ptName": "Província de Saga",
      "thName": "จังหวัดซางะ",
      "viName": "Tỉnh Saga",
      "inName": "Prefektur Saga",
      "tlName": "Saga Prefecture",
      "moName": "Сага аймаг",
      "buName": "ဆာဂါ့ ပြည်နယ်",
      "khName": "ខេត្ដ សាហ្គា",
      "neName": "सागा जिल्ला"
    },
    "class10": {
      "code": "410020",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "佐贺县北部",
      "zhName": "佐賀縣北部",
      "koName": "사가 현 북부",
      "esName": "Norte de Prefectura de Saga",
      "ptName": "Norte da Província de Saga",
      "thName": "จังหวัดซางะตอนเหนือ",
      "viName": "Miền Bắc tỉnh Saga",
      "inName": "Bagian Utara Prefektur Saga",
      "tlName": "Hilagang bahagi ng Saga Prefecture",
      "moName": "Хойд Сага аймаг",
      "buName": "ဆဂစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដសាហ្គា",
      "neName": "सागा जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "410022",
      "name": "伊万里地区",
      "enName": "Imari District"
    },
    "class20": {
      "code": "4120500",
      "name": "伊万里市",
      "enName": "Imari City",
      "kana": "いまりし",
      "chName": "伊万里市",
      "zhName": "伊萬里市",
      "koName": "이마리 시",
      "esName": "Ciudad de Imari",
      "ptName": "cidade de Imari",
      "thName": "เมืองอิมาริ",
      "viName": "thành phố Imari",
      "inName": "kota Imari",
      "tlName": "siyudad ng Imari",
      "moName": "Имaри хот",
      "buName": "အီမာ့ရိ မြို့",
      "khName": "ទីក្រុង អ៊ីម៉ារី",
      "neName": "इमारी सहर"
    }
  },
  "4120600": {
    "office": {
      "code": "410000",
      "name": "佐賀県",
      "enName": "Saga",
      "officeName": "佐賀地方気象台",
      "chName": "佐贺县",
      "zhName": "佐賀縣",
      "koName": "사가현",
      "esName": "Prefectura de Saga",
      "ptName": "Província de Saga",
      "thName": "จังหวัดซางะ",
      "viName": "Tỉnh Saga",
      "inName": "Prefektur Saga",
      "tlName": "Saga Prefecture",
      "moName": "Сага аймаг",
      "buName": "ဆာဂါ့ ပြည်နယ်",
      "khName": "ខេត្ដ សាហ្គា",
      "neName": "सागा जिल्ला"
    },
    "class10": {
      "code": "410010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "佐贺县南部",
      "zhName": "佐賀縣南部",
      "koName": "사가 현 남부",
      "esName": "Sur de Prefectura de Saga",
      "ptName": "Sul da Província de Saga",
      "thName": "จังหวัดซางะตอนใต้",
      "viName": "Miền Nam tỉnh Saga",
      "inName": "Bagian Selatan Prefektur Saga",
      "tlName": "Timog na bahagi ng Saga Prefecture",
      "moName": "Өмнөд Сага аймаг",
      "buName": "ဆဂစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដសាហ្គា",
      "neName": "सागा जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "410013",
      "name": "武雄地区",
      "enName": "Takeo District"
    },
    "class20": {
      "code": "4120600",
      "name": "武雄市",
      "enName": "Takeo City",
      "kana": "たけおし",
      "chName": "武雄市",
      "zhName": "武雄市",
      "koName": "다케오 시",
      "esName": "Ciudad de Takeo",
      "ptName": "cidade de Takeo",
      "thName": "เมืองทาเคะโอะ",
      "viName": "thành phố Takeo",
      "inName": "kota Takeo",
      "tlName": "siyudad ng Takeo",
      "moName": "Такэо хот",
      "buName": "တာကေ့ယို့ မြို့",
      "khName": "ទីក្រុង តាកែវ",
      "neName": "ताकेओ सहर"
    }
  },
  "4120700": {
    "office": {
      "code": "410000",
      "name": "佐賀県",
      "enName": "Saga",
      "officeName": "佐賀地方気象台",
      "chName": "佐贺县",
      "zhName": "佐賀縣",
      "koName": "사가현",
      "esName": "Prefectura de Saga",
      "ptName": "Província de Saga",
      "thName": "จังหวัดซางะ",
      "viName": "Tỉnh Saga",
      "inName": "Prefektur Saga",
      "tlName": "Saga Prefecture",
      "moName": "Сага аймаг",
      "buName": "ဆာဂါ့ ပြည်နယ်",
      "khName": "ខេត្ដ សាហ្គា",
      "neName": "सागा जिल्ला"
    },
    "class10": {
      "code": "410010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "佐贺县南部",
      "zhName": "佐賀縣南部",
      "koName": "사가 현 남부",
      "esName": "Sur de Prefectura de Saga",
      "ptName": "Sul da Província de Saga",
      "thName": "จังหวัดซางะตอนใต้",
      "viName": "Miền Nam tỉnh Saga",
      "inName": "Bagian Selatan Prefektur Saga",
      "tlName": "Timog na bahagi ng Saga Prefecture",
      "moName": "Өмнөд Сага аймаг",
      "buName": "ဆဂစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដសាហ្គា",
      "neName": "सागा जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "410014",
      "name": "鹿島地区",
      "enName": "Kashima District"
    },
    "class20": {
      "code": "4120700",
      "name": "鹿島市",
      "enName": "Kashima City",
      "kana": "かしまし",
      "chName": "佐贺鹿岛市",
      "zhName": "佐賀鹿島市",
      "koName": "사가 가시마 시",
      "esName": "Ciudad de Kashima, Saga",
      "ptName": "Saga, cidade de Kashima",
      "thName": "เมืองคาชิมะ ซางะ",
      "viName": "Thành phố Kashima, Saga",
      "inName": "Kota Kashima, Saga",
      "tlName": "siyudad ng Kashima, Saga",
      "moName": "Сага Кашима хот",
      "buName": "ဆဂကရှိမမြို့",
      "khName": "ទីក្រុងកាស៊ីម៉ា សាហ្គា",
      "neName": "सागा काशिमा सहर"
    }
  },
  "4120800": {
    "office": {
      "code": "410000",
      "name": "佐賀県",
      "enName": "Saga",
      "officeName": "佐賀地方気象台",
      "chName": "佐贺县",
      "zhName": "佐賀縣",
      "koName": "사가현",
      "esName": "Prefectura de Saga",
      "ptName": "Província de Saga",
      "thName": "จังหวัดซางะ",
      "viName": "Tỉnh Saga",
      "inName": "Prefektur Saga",
      "tlName": "Saga Prefecture",
      "moName": "Сага аймаг",
      "buName": "ဆာဂါ့ ပြည်နယ်",
      "khName": "ខេត្ដ សាហ្គា",
      "neName": "सागा जिल्ला"
    },
    "class10": {
      "code": "410010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "佐贺县南部",
      "zhName": "佐賀縣南部",
      "koName": "사가 현 남부",
      "esName": "Sur de Prefectura de Saga",
      "ptName": "Sul da Província de Saga",
      "thName": "จังหวัดซางะตอนใต้",
      "viName": "Miền Nam tỉnh Saga",
      "inName": "Bagian Selatan Prefektur Saga",
      "tlName": "Timog na bahagi ng Saga Prefecture",
      "moName": "Өмнөд Сага аймаг",
      "buName": "ဆဂစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដសាហ្គា",
      "neName": "सागा जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "410011",
      "name": "佐賀多久地区",
      "enName": "Saga Taku District"
    },
    "class20": {
      "code": "4120800",
      "name": "小城市",
      "enName": "Ogi City",
      "kana": "おぎし",
      "chName": "小城市",
      "zhName": "小城市",
      "koName": "오기 시",
      "esName": "Ciudad de Ogi",
      "ptName": "cidade de Ogi",
      "thName": "เมืองโองิ",
      "viName": "thành phố Ogi",
      "inName": "kota Ogi",
      "tlName": "siyudad ng Ogi",
      "moName": "Оги хот",
      "buName": "အိုဂိ မြို့",
      "khName": "ទីក្រុង អូហ្គី",
      "neName": "ओगी सहर"
    }
  },
  "4120900": {
    "office": {
      "code": "410000",
      "name": "佐賀県",
      "enName": "Saga",
      "officeName": "佐賀地方気象台",
      "chName": "佐贺县",
      "zhName": "佐賀縣",
      "koName": "사가현",
      "esName": "Prefectura de Saga",
      "ptName": "Província de Saga",
      "thName": "จังหวัดซางะ",
      "viName": "Tỉnh Saga",
      "inName": "Prefektur Saga",
      "tlName": "Saga Prefecture",
      "moName": "Сага аймаг",
      "buName": "ဆာဂါ့ ပြည်နယ်",
      "khName": "ខេត្ដ សាហ្គា",
      "neName": "सागा जिल्ला"
    },
    "class10": {
      "code": "410010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "佐贺县南部",
      "zhName": "佐賀縣南部",
      "koName": "사가 현 남부",
      "esName": "Sur de Prefectura de Saga",
      "ptName": "Sul da Província de Saga",
      "thName": "จังหวัดซางะตอนใต้",
      "viName": "Miền Nam tỉnh Saga",
      "inName": "Bagian Selatan Prefektur Saga",
      "tlName": "Timog na bahagi ng Saga Prefecture",
      "moName": "Өмнөд Сага аймаг",
      "buName": "ဆဂစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដសាហ្គា",
      "neName": "सागा जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "410014",
      "name": "鹿島地区",
      "enName": "Kashima District"
    },
    "class20": {
      "code": "4120900",
      "name": "嬉野市",
      "enName": "Ureshino City",
      "kana": "うれしのし",
      "chName": "嬉野市",
      "zhName": "嬉野市",
      "koName": "우레시노 시",
      "esName": "Ciudad de Ureshino",
      "ptName": "cidade de Ureshino",
      "thName": "เมืองอุเรชิโนะ",
      "viName": "thành phố Ureshino",
      "inName": "kota Ureshino",
      "tlName": "siyudad ng Ureshino",
      "moName": "Үрэшино хот",
      "buName": "အူရေးရှိနို မြို့",
      "khName": "ទីក្រុង យូរីស៊ីណូ",
      "neName": "उरेशिनो सहर"
    }
  },
  "4121000": {
    "office": {
      "code": "410000",
      "name": "佐賀県",
      "enName": "Saga",
      "officeName": "佐賀地方気象台",
      "chName": "佐贺县",
      "zhName": "佐賀縣",
      "koName": "사가현",
      "esName": "Prefectura de Saga",
      "ptName": "Província de Saga",
      "thName": "จังหวัดซางะ",
      "viName": "Tỉnh Saga",
      "inName": "Prefektur Saga",
      "tlName": "Saga Prefecture",
      "moName": "Сага аймаг",
      "buName": "ဆာဂါ့ ပြည်နယ်",
      "khName": "ខេត្ដ សាហ្គា",
      "neName": "सागा जिल्ला"
    },
    "class10": {
      "code": "410010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "佐贺县南部",
      "zhName": "佐賀縣南部",
      "koName": "사가 현 남부",
      "esName": "Sur de Prefectura de Saga",
      "ptName": "Sul da Província de Saga",
      "thName": "จังหวัดซางะตอนใต้",
      "viName": "Miền Nam tỉnh Saga",
      "inName": "Bagian Selatan Prefektur Saga",
      "tlName": "Timog na bahagi ng Saga Prefecture",
      "moName": "Өмнөд Сага аймаг",
      "buName": "ဆဂစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដសាហ្គា",
      "neName": "सागा जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "410012",
      "name": "鳥栖地区",
      "enName": "Tosu District"
    },
    "class20": {
      "code": "4121000",
      "name": "神埼市",
      "enName": "Kanzaki City",
      "kana": "かんざきし",
      "chName": "神埼市",
      "zhName": "神崎市",
      "koName": "간자키 시",
      "esName": "Ciudad de Kanzaki",
      "ptName": "cidade de Kanzaki",
      "thName": "เมืองคันซากิ",
      "viName": "thành phố Kanzaki",
      "inName": "kota Kanzaki",
      "tlName": "siyudad ng Kanzaki",
      "moName": "Канзaки хот",
      "buName": "ခန်းဇာ့ကိ မြို့",
      "khName": "ទីក្រុង កាន់សាគី",
      "neName": "कान्जाकी सहर"
    }
  },
  "4132700": {
    "office": {
      "code": "410000",
      "name": "佐賀県",
      "enName": "Saga",
      "officeName": "佐賀地方気象台",
      "chName": "佐贺县",
      "zhName": "佐賀縣",
      "koName": "사가현",
      "esName": "Prefectura de Saga",
      "ptName": "Província de Saga",
      "thName": "จังหวัดซางะ",
      "viName": "Tỉnh Saga",
      "inName": "Prefektur Saga",
      "tlName": "Saga Prefecture",
      "moName": "Сага аймаг",
      "buName": "ဆာဂါ့ ပြည်နယ်",
      "khName": "ខេត្ដ សាហ្គា",
      "neName": "सागा जिल्ला"
    },
    "class10": {
      "code": "410010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "佐贺县南部",
      "zhName": "佐賀縣南部",
      "koName": "사가 현 남부",
      "esName": "Sur de Prefectura de Saga",
      "ptName": "Sul da Província de Saga",
      "thName": "จังหวัดซางะตอนใต้",
      "viName": "Miền Nam tỉnh Saga",
      "inName": "Bagian Selatan Prefektur Saga",
      "tlName": "Timog na bahagi ng Saga Prefecture",
      "moName": "Өмнөд Сага аймаг",
      "buName": "ဆဂစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដសាហ្គា",
      "neName": "सागा जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "410012",
      "name": "鳥栖地区",
      "enName": "Tosu District"
    },
    "class20": {
      "code": "4132700",
      "name": "吉野ヶ里町",
      "enName": "Yoshinogari Town",
      "kana": "よしのがりちょう",
      "chName": "吉野里町",
      "zhName": "吉野里町",
      "koName": "요시노가리 정",
      "esName": "Pueblo de Yoshinogari",
      "ptName": "bairro de Yoshinogari",
      "thName": "เมืองโยชิโนงาริ",
      "viName": "thị trấn Yoshinogari",
      "inName": "kota Yoshinogari",
      "tlName": "bayan ng Yoshinogari",
      "moName": "Ёшиногари жижиг хот",
      "buName": "ယိုရှိနိုဂါ့ရိ မြို့နယ်",
      "khName": "ទីប្រជុំជន យ៉ូស៊ីណូហ្ការី",
      "neName": "योशिनोगारी नगर"
    }
  },
  "4134100": {
    "office": {
      "code": "410000",
      "name": "佐賀県",
      "enName": "Saga",
      "officeName": "佐賀地方気象台",
      "chName": "佐贺县",
      "zhName": "佐賀縣",
      "koName": "사가현",
      "esName": "Prefectura de Saga",
      "ptName": "Província de Saga",
      "thName": "จังหวัดซางะ",
      "viName": "Tỉnh Saga",
      "inName": "Prefektur Saga",
      "tlName": "Saga Prefecture",
      "moName": "Сага аймаг",
      "buName": "ဆာဂါ့ ပြည်နယ်",
      "khName": "ខេត្ដ សាហ្គា",
      "neName": "सागा जिल्ला"
    },
    "class10": {
      "code": "410010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "佐贺县南部",
      "zhName": "佐賀縣南部",
      "koName": "사가 현 남부",
      "esName": "Sur de Prefectura de Saga",
      "ptName": "Sul da Província de Saga",
      "thName": "จังหวัดซางะตอนใต้",
      "viName": "Miền Nam tỉnh Saga",
      "inName": "Bagian Selatan Prefektur Saga",
      "tlName": "Timog na bahagi ng Saga Prefecture",
      "moName": "Өмнөд Сага аймаг",
      "buName": "ဆဂစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដសាហ្គា",
      "neName": "सागा जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "410012",
      "name": "鳥栖地区",
      "enName": "Tosu District"
    },
    "class20": {
      "code": "4134100",
      "name": "基山町",
      "enName": "Kiyama Town",
      "kana": "きやまちょう",
      "chName": "基山町",
      "zhName": "基山町",
      "koName": "기야마 정",
      "esName": "Pueblo de Kiyama",
      "ptName": "bairro de Kiyama",
      "thName": "เมืองคิยามะ",
      "viName": "thị trấn Kiyama",
      "inName": "kota Kiyama",
      "tlName": "bayan ng Kiyama",
      "moName": "Киямa жижиг хот",
      "buName": "ခီယာ့မ မြို့နယ်",
      "khName": "ទីប្រជុំជន គីយ៉ាម៉ា",
      "neName": "कियामा नगर"
    }
  },
  "4134500": {
    "office": {
      "code": "410000",
      "name": "佐賀県",
      "enName": "Saga",
      "officeName": "佐賀地方気象台",
      "chName": "佐贺县",
      "zhName": "佐賀縣",
      "koName": "사가현",
      "esName": "Prefectura de Saga",
      "ptName": "Província de Saga",
      "thName": "จังหวัดซางะ",
      "viName": "Tỉnh Saga",
      "inName": "Prefektur Saga",
      "tlName": "Saga Prefecture",
      "moName": "Сага аймаг",
      "buName": "ဆာဂါ့ ပြည်နယ်",
      "khName": "ខេត្ដ សាហ្គា",
      "neName": "सागा जिल्ला"
    },
    "class10": {
      "code": "410010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "佐贺县南部",
      "zhName": "佐賀縣南部",
      "koName": "사가 현 남부",
      "esName": "Sur de Prefectura de Saga",
      "ptName": "Sul da Província de Saga",
      "thName": "จังหวัดซางะตอนใต้",
      "viName": "Miền Nam tỉnh Saga",
      "inName": "Bagian Selatan Prefektur Saga",
      "tlName": "Timog na bahagi ng Saga Prefecture",
      "moName": "Өмнөд Сага аймаг",
      "buName": "ဆဂစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដសាហ្គា",
      "neName": "सागा जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "410012",
      "name": "鳥栖地区",
      "enName": "Tosu District"
    },
    "class20": {
      "code": "4134500",
      "name": "上峰町",
      "enName": "Kamimine Town",
      "kana": "かみみねちょう",
      "chName": "上峰町",
      "zhName": "上峰町",
      "koName": "가미미네 정",
      "esName": "Pueblo de Kamimine",
      "ptName": "bairro de Kamimine",
      "thName": "เมืองคามามิเนะ",
      "viName": "thị trấn Kamimine",
      "inName": "kota Kamimine",
      "tlName": "bayan ng Kamimine",
      "moName": "Камиминэ жижиг хот",
      "buName": "ခါမိမီနဲ့ မြို့နယ်",
      "khName": "ទីប្រជុំជន ខាំមីមី",
      "neName": "कामिमिने नगर"
    }
  },
  "4134600": {
    "office": {
      "code": "410000",
      "name": "佐賀県",
      "enName": "Saga",
      "officeName": "佐賀地方気象台",
      "chName": "佐贺县",
      "zhName": "佐賀縣",
      "koName": "사가현",
      "esName": "Prefectura de Saga",
      "ptName": "Província de Saga",
      "thName": "จังหวัดซางะ",
      "viName": "Tỉnh Saga",
      "inName": "Prefektur Saga",
      "tlName": "Saga Prefecture",
      "moName": "Сага аймаг",
      "buName": "ဆာဂါ့ ပြည်နယ်",
      "khName": "ខេត្ដ សាហ្គា",
      "neName": "सागा जिल्ला"
    },
    "class10": {
      "code": "410010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "佐贺县南部",
      "zhName": "佐賀縣南部",
      "koName": "사가 현 남부",
      "esName": "Sur de Prefectura de Saga",
      "ptName": "Sul da Província de Saga",
      "thName": "จังหวัดซางะตอนใต้",
      "viName": "Miền Nam tỉnh Saga",
      "inName": "Bagian Selatan Prefektur Saga",
      "tlName": "Timog na bahagi ng Saga Prefecture",
      "moName": "Өмнөд Сага аймаг",
      "buName": "ဆဂစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដសាហ្គា",
      "neName": "सागा जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "410012",
      "name": "鳥栖地区",
      "enName": "Tosu District"
    },
    "class20": {
      "code": "4134600",
      "name": "みやき町",
      "enName": "Miyaki Town",
      "kana": "みやきちょう",
      "chName": "三养基町",
      "zhName": "三養基町",
      "koName": "미야키 정",
      "esName": "Pueblo de Miyaki",
      "ptName": "bairro de Miyaki",
      "thName": "เมืองมายากิ",
      "viName": "thị trấn Miyaki",
      "inName": "kota Miyaki",
      "tlName": "bayan ng Miyaki",
      "moName": "Мияки жижиг хот",
      "buName": "မီယာ့ကိ မြို့နယ်",
      "khName": "ទីប្រជុំជន មីយ៉ាគី",
      "neName": "मियाकी नगर"
    }
  },
  "4138700": {
    "office": {
      "code": "410000",
      "name": "佐賀県",
      "enName": "Saga",
      "officeName": "佐賀地方気象台",
      "chName": "佐贺县",
      "zhName": "佐賀縣",
      "koName": "사가현",
      "esName": "Prefectura de Saga",
      "ptName": "Província de Saga",
      "thName": "จังหวัดซางะ",
      "viName": "Tỉnh Saga",
      "inName": "Prefektur Saga",
      "tlName": "Saga Prefecture",
      "moName": "Сага аймаг",
      "buName": "ဆာဂါ့ ပြည်နယ်",
      "khName": "ខេត្ដ សាហ្គា",
      "neName": "सागा जिल्ला"
    },
    "class10": {
      "code": "410020",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "佐贺县北部",
      "zhName": "佐賀縣北部",
      "koName": "사가 현 북부",
      "esName": "Norte de Prefectura de Saga",
      "ptName": "Norte da Província de Saga",
      "thName": "จังหวัดซางะตอนเหนือ",
      "viName": "Miền Bắc tỉnh Saga",
      "inName": "Bagian Utara Prefektur Saga",
      "tlName": "Hilagang bahagi ng Saga Prefecture",
      "moName": "Хойд Сага аймаг",
      "buName": "ဆဂစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដសាហ្គា",
      "neName": "सागा जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "410021",
      "name": "唐津地区",
      "enName": "Karatsu District"
    },
    "class20": {
      "code": "4138700",
      "name": "玄海町",
      "enName": "Genkai Town",
      "kana": "げんかいちょう",
      "chName": "玄海町",
      "zhName": "玄海町",
      "koName": "겐카이 정",
      "esName": "Pueblo de Genkai",
      "ptName": "bairro de Genkai",
      "thName": "เมืองเก็งไก",
      "viName": "thị trấn Genkai",
      "inName": "kota Genkai",
      "tlName": "bayan ng Genkai",
      "moName": "Гэнкай жижиг хот",
      "buName": "ဂန်းကာ့ယိ မြို့နယ်",
      "khName": "ទីប្រជុំជន ជេនកៃ",
      "neName": "गेन्काई नगर"
    }
  },
  "4140100": {
    "office": {
      "code": "410000",
      "name": "佐賀県",
      "enName": "Saga",
      "officeName": "佐賀地方気象台",
      "chName": "佐贺县",
      "zhName": "佐賀縣",
      "koName": "사가현",
      "esName": "Prefectura de Saga",
      "ptName": "Província de Saga",
      "thName": "จังหวัดซางะ",
      "viName": "Tỉnh Saga",
      "inName": "Prefektur Saga",
      "tlName": "Saga Prefecture",
      "moName": "Сага аймаг",
      "buName": "ဆာဂါ့ ပြည်နယ်",
      "khName": "ខេត្ដ សាហ្គា",
      "neName": "सागा जिल्ला"
    },
    "class10": {
      "code": "410020",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "佐贺县北部",
      "zhName": "佐賀縣北部",
      "koName": "사가 현 북부",
      "esName": "Norte de Prefectura de Saga",
      "ptName": "Norte da Província de Saga",
      "thName": "จังหวัดซางะตอนเหนือ",
      "viName": "Miền Bắc tỉnh Saga",
      "inName": "Bagian Utara Prefektur Saga",
      "tlName": "Hilagang bahagi ng Saga Prefecture",
      "moName": "Хойд Сага аймаг",
      "buName": "ဆဂစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដសាហ្គា",
      "neName": "सागा जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "410022",
      "name": "伊万里地区",
      "enName": "Imari District"
    },
    "class20": {
      "code": "4140100",
      "name": "有田町",
      "enName": "Arita Town",
      "kana": "ありたちょう",
      "chName": "有田町",
      "zhName": "有田町",
      "koName": "아리타 정",
      "esName": "Pueblo de Arita",
      "ptName": "bairro de Arita",
      "thName": "เมืองอาริตะ",
      "viName": "thị trấn Arita",
      "inName": "kota Arita",
      "tlName": "bayan ng Arita",
      "moName": "Aрита жижиг хот",
      "buName": "အာရီတ မြို့နယ်",
      "khName": "ទីប្រជុំជន អារីតា",
      "neName": "अरिता नगर"
    }
  },
  "4142300": {
    "office": {
      "code": "410000",
      "name": "佐賀県",
      "enName": "Saga",
      "officeName": "佐賀地方気象台",
      "chName": "佐贺县",
      "zhName": "佐賀縣",
      "koName": "사가현",
      "esName": "Prefectura de Saga",
      "ptName": "Província de Saga",
      "thName": "จังหวัดซางะ",
      "viName": "Tỉnh Saga",
      "inName": "Prefektur Saga",
      "tlName": "Saga Prefecture",
      "moName": "Сага аймаг",
      "buName": "ဆာဂါ့ ပြည်နယ်",
      "khName": "ខេត្ដ សាហ្គា",
      "neName": "सागा जिल्ला"
    },
    "class10": {
      "code": "410010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "佐贺县南部",
      "zhName": "佐賀縣南部",
      "koName": "사가 현 남부",
      "esName": "Sur de Prefectura de Saga",
      "ptName": "Sul da Província de Saga",
      "thName": "จังหวัดซางะตอนใต้",
      "viName": "Miền Nam tỉnh Saga",
      "inName": "Bagian Selatan Prefektur Saga",
      "tlName": "Timog na bahagi ng Saga Prefecture",
      "moName": "Өмнөд Сага аймаг",
      "buName": "ဆဂစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដសាហ្គា",
      "neName": "सागा जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "410013",
      "name": "武雄地区",
      "enName": "Takeo District"
    },
    "class20": {
      "code": "4142300",
      "name": "大町町",
      "enName": "Omachi Town",
      "kana": "おおまちちょう",
      "chName": "大町町",
      "zhName": "大町町",
      "koName": "오마치 정",
      "esName": "Pueblo de Ōmachi",
      "ptName": "bairro de Omachi",
      "thName": "เมืองโอมะจิ",
      "viName": "thị trấn Omachi",
      "inName": "kota Omachi",
      "tlName": "bayan ng Omachi",
      "moName": "Омaчи жижиг хот",
      "buName": "အို့မားကျိ မြို့နယ်",
      "khName": "ទីប្រជុំជន អូម៉ាឈី",
      "neName": "ओमाची नगर"
    }
  },
  "4142400": {
    "office": {
      "code": "410000",
      "name": "佐賀県",
      "enName": "Saga",
      "officeName": "佐賀地方気象台",
      "chName": "佐贺县",
      "zhName": "佐賀縣",
      "koName": "사가현",
      "esName": "Prefectura de Saga",
      "ptName": "Província de Saga",
      "thName": "จังหวัดซางะ",
      "viName": "Tỉnh Saga",
      "inName": "Prefektur Saga",
      "tlName": "Saga Prefecture",
      "moName": "Сага аймаг",
      "buName": "ဆာဂါ့ ပြည်နယ်",
      "khName": "ខេត្ដ សាហ្គា",
      "neName": "सागा जिल्ला"
    },
    "class10": {
      "code": "410010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "佐贺县南部",
      "zhName": "佐賀縣南部",
      "koName": "사가 현 남부",
      "esName": "Sur de Prefectura de Saga",
      "ptName": "Sul da Província de Saga",
      "thName": "จังหวัดซางะตอนใต้",
      "viName": "Miền Nam tỉnh Saga",
      "inName": "Bagian Selatan Prefektur Saga",
      "tlName": "Timog na bahagi ng Saga Prefecture",
      "moName": "Өмнөд Сага аймаг",
      "buName": "ဆဂစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដសាហ្គា",
      "neName": "सागा जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "410013",
      "name": "武雄地区",
      "enName": "Takeo District"
    },
    "class20": {
      "code": "4142400",
      "name": "江北町",
      "enName": "Kohoku Town",
      "kana": "こうほくまち",
      "chName": "江北町",
      "zhName": "江北町",
      "koName": "고호쿠 정",
      "esName": "Pueblo de Kōhoku",
      "ptName": "bairro de Kohoku",
      "thName": "เมืองโคโฮขุ",
      "viName": "thị trấn Kohoku",
      "inName": "kota Kohoku",
      "tlName": "bayan ng Kohoku",
      "moName": "Кохокү жижиг хот",
      "buName": "ကိုဟိုကု မြို့နယ်",
      "khName": "ទីប្រជុំជន កូហូគូ",
      "neName": "कोहोकु नगर"
    }
  },
  "4142500": {
    "office": {
      "code": "410000",
      "name": "佐賀県",
      "enName": "Saga",
      "officeName": "佐賀地方気象台",
      "chName": "佐贺县",
      "zhName": "佐賀縣",
      "koName": "사가현",
      "esName": "Prefectura de Saga",
      "ptName": "Província de Saga",
      "thName": "จังหวัดซางะ",
      "viName": "Tỉnh Saga",
      "inName": "Prefektur Saga",
      "tlName": "Saga Prefecture",
      "moName": "Сага аймаг",
      "buName": "ဆာဂါ့ ပြည်နယ်",
      "khName": "ខេត្ដ សាហ្គា",
      "neName": "सागा जिल्ला"
    },
    "class10": {
      "code": "410010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "佐贺县南部",
      "zhName": "佐賀縣南部",
      "koName": "사가 현 남부",
      "esName": "Sur de Prefectura de Saga",
      "ptName": "Sul da Província de Saga",
      "thName": "จังหวัดซางะตอนใต้",
      "viName": "Miền Nam tỉnh Saga",
      "inName": "Bagian Selatan Prefektur Saga",
      "tlName": "Timog na bahagi ng Saga Prefecture",
      "moName": "Өмнөд Сага аймаг",
      "buName": "ဆဂစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដសាហ្គា",
      "neName": "सागा जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "410013",
      "name": "武雄地区",
      "enName": "Takeo District"
    },
    "class20": {
      "code": "4142500",
      "name": "白石町",
      "enName": "Shiroishi Town",
      "kana": "しろいしちょう",
      "chName": "白石町",
      "zhName": "白石町",
      "koName": "시로이시 정",
      "esName": "Pueblo de Shiroishi",
      "ptName": "bairro de Shiroishi",
      "thName": "เมืองชิโรอิชิ",
      "viName": "thị trấn Shiroishi",
      "inName": "kota Shiroishi",
      "tlName": "bayan ng Shiroishi",
      "moName": "Широйши жижиг хот",
      "buName": "ရှိရိုးယိရှိ မြို့နယ်",
      "khName": "ទីប្រជុំជន ស៊ីរ៉ូស៊ី",
      "neName": "शिरोइशी नगर"
    }
  },
  "4144100": {
    "office": {
      "code": "410000",
      "name": "佐賀県",
      "enName": "Saga",
      "officeName": "佐賀地方気象台",
      "chName": "佐贺县",
      "zhName": "佐賀縣",
      "koName": "사가현",
      "esName": "Prefectura de Saga",
      "ptName": "Província de Saga",
      "thName": "จังหวัดซางะ",
      "viName": "Tỉnh Saga",
      "inName": "Prefektur Saga",
      "tlName": "Saga Prefecture",
      "moName": "Сага аймаг",
      "buName": "ဆာဂါ့ ပြည်နယ်",
      "khName": "ខេត្ដ សាហ្គា",
      "neName": "सागा जिल्ला"
    },
    "class10": {
      "code": "410010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "佐贺县南部",
      "zhName": "佐賀縣南部",
      "koName": "사가 현 남부",
      "esName": "Sur de Prefectura de Saga",
      "ptName": "Sul da Província de Saga",
      "thName": "จังหวัดซางะตอนใต้",
      "viName": "Miền Nam tỉnh Saga",
      "inName": "Bagian Selatan Prefektur Saga",
      "tlName": "Timog na bahagi ng Saga Prefecture",
      "moName": "Өмнөд Сага аймаг",
      "buName": "ဆဂစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដសាហ្គា",
      "neName": "सागा जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "410014",
      "name": "鹿島地区",
      "enName": "Kashima District"
    },
    "class20": {
      "code": "4144100",
      "name": "太良町",
      "enName": "Tara Town",
      "kana": "たらちょう",
      "chName": "太良町",
      "zhName": "太良町",
      "koName": "다라 정",
      "esName": "Pueblo de Tara",
      "ptName": "bairro de Tara",
      "thName": "เมืองทาระ",
      "viName": "thị trấn Tara",
      "inName": "kota Tara",
      "tlName": "bayan ng Tara",
      "moName": "Тара жижиг хот",
      "buName": "တားရာ့ မြို့နယ်",
      "khName": "ទីប្រជុំជន តារ៉ា",
      "neName": "तारा नगर"
    }
  },
  "4220100": {
    "office": {
      "code": "420000",
      "name": "長崎県",
      "enName": "Nagasaki",
      "officeName": "長崎地方気象台",
      "chName": "长崎县",
      "zhName": "長崎縣",
      "koName": "나가사키현",
      "esName": "Prefectura de Nagasaki",
      "ptName": "Província de Nagasaki",
      "thName": "จังหวัดนางาซากิ",
      "viName": "Tỉnh Nagasaki",
      "inName": "Prefektur Nagasaki",
      "tlName": "Nagasaki Prefecture",
      "moName": "Нагасаки аймаг",
      "buName": "နာဂါဆာကိ ပြည်နယ်",
      "khName": "ខេត្ដ ណាហ្គាសាគី",
      "neName": "नागासाकी जिल्ला"
    },
    "class10": {
      "code": "420010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "长崎县南部",
      "zhName": "長崎縣南部",
      "koName": "나가사키 현 남부",
      "esName": "Sur de Prefectura de Nagasaki",
      "ptName": "Sul da Província de Nagasaki",
      "thName": "จังหวัดนางาซากิตอนใต้",
      "viName": "Miền Nam tỉnh Nagasaki",
      "inName": "Bagian Selatan Prefektur Nagasaki",
      "tlName": "Timog bahagi ng Nagasaki Prefecture",
      "moName": "Өмнөд Нагасаки аймаг",
      "buName": "နာဂါဆာကိစီရင်စု အနောက်တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដណាហ្គាសាគី",
      "neName": "नागासाकी जिल्लाको दक्षिण भाग"
    },
    "class15": {
      "code": "420012",
      "name": "長崎地区",
      "enName": "Nagasaki District"
    },
    "class20": {
      "code": "4220100",
      "name": "長崎市",
      "enName": "Nagasaki City",
      "kana": "ながさきし",
      "chName": "长崎市",
      "zhName": "長崎市",
      "koName": "나가사키 시",
      "esName": "Ciudad de Nagasaki",
      "ptName": "cidade de Nagasaki",
      "thName": "เมืองนางาซากิ",
      "viName": "thành phố Nagasaki",
      "inName": "kota Nagasaki",
      "tlName": "siyudad ng Nagasaki",
      "moName": "Нaгaсaки хот",
      "buName": "နာဂါဆာ့ကိ မြို့",
      "khName": "ទីក្រុង ណាហ្គាសាគី",
      "neName": "नागासाकी सहर"
    }
  },
  "4220201": {
    "office": {
      "code": "420000",
      "name": "長崎県",
      "enName": "Nagasaki",
      "officeName": "長崎地方気象台",
      "chName": "长崎县",
      "zhName": "長崎縣",
      "koName": "나가사키현",
      "esName": "Prefectura de Nagasaki",
      "ptName": "Província de Nagasaki",
      "thName": "จังหวัดนางาซากิ",
      "viName": "Tỉnh Nagasaki",
      "inName": "Prefektur Nagasaki",
      "tlName": "Nagasaki Prefecture",
      "moName": "Нагасаки аймаг",
      "buName": "နာဂါဆာကိ ပြည်နယ်",
      "khName": "ខេត្ដ ណាហ្គាសាគី",
      "neName": "नागासाकी जिल्ला"
    },
    "class10": {
      "code": "420020",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "长崎县北部",
      "zhName": "長崎縣北部",
      "koName": "나가사키 현 북부",
      "esName": "Norte de Prefectura de Nagasaki",
      "ptName": "Norte da Província de Nagasaki",
      "thName": "จังหวัดนางาซากิตอนเหนือ",
      "viName": "Miền Bắc tỉnh Nagasaki",
      "inName": "Bagian Utara Prefektur Nagasaki",
      "tlName": "Hilagang bahagi ng Nagasaki Prefecture ",
      "moName": "Хойд Нагасаки аймаг",
      "buName": "နာဂါဆာကိစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដណាហ្គាសាគី",
      "neName": "नागासाकी जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "420022",
      "name": "佐世保・東彼地区",
      "enName": "Sasebo Tohi District"
    },
    "class20": {
      "code": "4220201",
      "name": "佐世保市（宇久地域を除く）",
      "enName": "Sasebo City (Excluding Uku Area)",
      "kana": "させぼし",
      "chName": "佐世保市",
      "zhName": "佐世保市",
      "koName": "사세보 시",
      "esName": "Ciudad de Sasebo",
      "ptName": "cidade de Sasebo",
      "thName": "เมืองซาเซะโบะ",
      "viName": "thành phố Sasebo",
      "inName": "kota Sasebo",
      "tlName": "siyudad ng Sasebo",
      "moName": "Сaсэбо хот",
      "buName": "ဆာဆေးဘော့ မြို့",
      "khName": "ទីក្រុង សាសេបូ",
      "neName": "सासेबो सहर"
    }
  },
  "4220202": {
    "office": {
      "code": "420000",
      "name": "長崎県",
      "enName": "Nagasaki",
      "officeName": "長崎地方気象台",
      "chName": "长崎县",
      "zhName": "長崎縣",
      "koName": "나가사키현",
      "esName": "Prefectura de Nagasaki",
      "ptName": "Província de Nagasaki",
      "thName": "จังหวัดนางาซากิ",
      "viName": "Tỉnh Nagasaki",
      "inName": "Prefektur Nagasaki",
      "tlName": "Nagasaki Prefecture",
      "moName": "Нагасаки аймаг",
      "buName": "နာဂါဆာကိ ပြည်နယ်",
      "khName": "ខេត្ដ ណាហ្គាសាគី",
      "neName": "नागासाकी जिल्ला"
    },
    "class10": {
      "code": "420040",
      "name": "五島",
      "enName": "Goto",
      "chName": "五岛列岛近海",
      "zhName": "五岛列岛近海",
      "koName": "고토 열도 근해",
      "esName": "Mares cercanos de Islas de Gotou",
      "ptName": "Mar perto das Ilhas Gotō",
      "thName": "ทะเลบริเวณใกล้เคียงหมู่เกาะโกะโต",
      "viName": "Vùng ven biển quần đảo Goto",
      "inName": "Laut yang Berdekatan dengan Kepulauan Goto",
      "tlName": "Malapit na dagat ng Goto Islands",
      "moName": "Гото арлуудад ойр далай",
      "buName": "ဂိုတိုကျွန်း ပင်လယ်အနီး",
      "khName": "តំបន់សមុទ្រក្បែរនៃជួរកោះហ្គូតូ",
      "neName": "गोतो टापुहरू नजिकको समुन्द्र"
    },
    "class15": {
      "code": "420041",
      "name": "上五島",
      "enName": "Kamigoto"
    },
    "class20": {
      "code": "4220202",
      "name": "佐世保市（宇久地域）",
      "enName": "Sasebo City (Uku Area)",
      "kana": "させぼし",
      "chName": "佐世保市",
      "zhName": "佐世保市",
      "koName": "사세보 시",
      "esName": "Ciudad de Sasebo",
      "ptName": "cidade de Sasebo",
      "thName": "เมืองซาเซะโบะ",
      "viName": "thành phố Sasebo",
      "inName": "kota Sasebo",
      "tlName": "siyudad ng Sasebo",
      "moName": "Сaсэбо хот",
      "buName": "ဆာဆေးဘော့ မြို့",
      "khName": "ទីក្រុង សាសេបូ",
      "neName": "सासेबो सहर"
    }
  },
  "4220300": {
    "office": {
      "code": "420000",
      "name": "長崎県",
      "enName": "Nagasaki",
      "officeName": "長崎地方気象台",
      "chName": "长崎县",
      "zhName": "長崎縣",
      "koName": "나가사키현",
      "esName": "Prefectura de Nagasaki",
      "ptName": "Província de Nagasaki",
      "thName": "จังหวัดนางาซากิ",
      "viName": "Tỉnh Nagasaki",
      "inName": "Prefektur Nagasaki",
      "tlName": "Nagasaki Prefecture",
      "moName": "Нагасаки аймаг",
      "buName": "နာဂါဆာကိ ပြည်နယ်",
      "khName": "ខេត្ដ ណាហ្គាសាគី",
      "neName": "नागासाकी जिल्ला"
    },
    "class10": {
      "code": "420010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "长崎县南部",
      "zhName": "長崎縣南部",
      "koName": "나가사키 현 남부",
      "esName": "Sur de Prefectura de Nagasaki",
      "ptName": "Sul da Província de Nagasaki",
      "thName": "จังหวัดนางาซากิตอนใต้",
      "viName": "Miền Nam tỉnh Nagasaki",
      "inName": "Bagian Selatan Prefektur Nagasaki",
      "tlName": "Timog bahagi ng Nagasaki Prefecture",
      "moName": "Өмнөд Нагасаки аймаг",
      "buName": "နာဂါဆာကိစီရင်စု အနောက်တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដណាហ្គាសាគី",
      "neName": "नागासाकी जिल्लाको दक्षिण भाग"
    },
    "class15": {
      "code": "420011",
      "name": "島原半島",
      "enName": "Shimabara Peninsula"
    },
    "class20": {
      "code": "4220300",
      "name": "島原市",
      "enName": "Shimabara City",
      "kana": "しまばらし",
      "chName": "岛原市",
      "zhName": "島原市",
      "koName": "시마바라 시",
      "esName": "Ciudad de Shimabara",
      "ptName": "cidade de Shimabara",
      "thName": "เมืองชิมาบาระ",
      "viName": "thành phố Shimabara",
      "inName": "kota Shimabara",
      "tlName": "siyudad ng Shimabara",
      "moName": "Шимaбара хот",
      "buName": "ရှီမာ့ဘားရာ့ မြို့",
      "khName": "ទីក្រុង ស៊ីម៉ាបារ៉ា",
      "neName": "शिमाबारा सहर"
    }
  },
  "4220400": {
    "office": {
      "code": "420000",
      "name": "長崎県",
      "enName": "Nagasaki",
      "officeName": "長崎地方気象台",
      "chName": "长崎县",
      "zhName": "長崎縣",
      "koName": "나가사키현",
      "esName": "Prefectura de Nagasaki",
      "ptName": "Província de Nagasaki",
      "thName": "จังหวัดนางาซากิ",
      "viName": "Tỉnh Nagasaki",
      "inName": "Prefektur Nagasaki",
      "tlName": "Nagasaki Prefecture",
      "moName": "Нагасаки аймаг",
      "buName": "နာဂါဆာကိ ပြည်နယ်",
      "khName": "ខេត្ដ ណាហ្គាសាគី",
      "neName": "नागासाकी जिल्ला"
    },
    "class10": {
      "code": "420010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "长崎县南部",
      "zhName": "長崎縣南部",
      "koName": "나가사키 현 남부",
      "esName": "Sur de Prefectura de Nagasaki",
      "ptName": "Sul da Província de Nagasaki",
      "thName": "จังหวัดนางาซากิตอนใต้",
      "viName": "Miền Nam tỉnh Nagasaki",
      "inName": "Bagian Selatan Prefektur Nagasaki",
      "tlName": "Timog bahagi ng Nagasaki Prefecture",
      "moName": "Өмнөд Нагасаки аймаг",
      "buName": "နာဂါဆာကိစီရင်စု အနောက်တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដណាហ្គាសាគី",
      "neName": "नागासाकी जिल्लाको दक्षिण भाग"
    },
    "class15": {
      "code": "420013",
      "name": "諫早・大村地区",
      "enName": "Isahaya Omura District"
    },
    "class20": {
      "code": "4220400",
      "name": "諫早市",
      "enName": "Isahaya City",
      "kana": "いさはやし",
      "chName": "谏早市",
      "zhName": "諫早市",
      "koName": "이사하야 시",
      "esName": "Ciudad de Isahaya",
      "ptName": "cidade de Isahaya",
      "thName": "เมืองอิซาฮายะ",
      "viName": "thành phố Isahaya",
      "inName": "kota Isahaya",
      "tlName": "siyudad ng Isahaya",
      "moName": "Исaхaя хот",
      "buName": "အီဆာဟားရာ့ မြို့",
      "khName": "ទីក្រុង អ៊ីសាហាយ៉ា",
      "neName": "इसाहाया सहर"
    }
  },
  "4220500": {
    "office": {
      "code": "420000",
      "name": "長崎県",
      "enName": "Nagasaki",
      "officeName": "長崎地方気象台",
      "chName": "长崎县",
      "zhName": "長崎縣",
      "koName": "나가사키현",
      "esName": "Prefectura de Nagasaki",
      "ptName": "Província de Nagasaki",
      "thName": "จังหวัดนางาซากิ",
      "viName": "Tỉnh Nagasaki",
      "inName": "Prefektur Nagasaki",
      "tlName": "Nagasaki Prefecture",
      "moName": "Нагасаки аймаг",
      "buName": "နာဂါဆာကိ ပြည်နယ်",
      "khName": "ខេត្ដ ណាហ្គាសាគី",
      "neName": "नागासाकी जिल्ला"
    },
    "class10": {
      "code": "420010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "长崎县南部",
      "zhName": "長崎縣南部",
      "koName": "나가사키 현 남부",
      "esName": "Sur de Prefectura de Nagasaki",
      "ptName": "Sul da Província de Nagasaki",
      "thName": "จังหวัดนางาซากิตอนใต้",
      "viName": "Miền Nam tỉnh Nagasaki",
      "inName": "Bagian Selatan Prefektur Nagasaki",
      "tlName": "Timog bahagi ng Nagasaki Prefecture",
      "moName": "Өмнөд Нагасаки аймаг",
      "buName": "နာဂါဆာကိစီရင်စု အနောက်တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដណាហ្គាសាគី",
      "neName": "नागासाकी जिल्लाको दक्षिण भाग"
    },
    "class15": {
      "code": "420013",
      "name": "諫早・大村地区",
      "enName": "Isahaya Omura District"
    },
    "class20": {
      "code": "4220500",
      "name": "大村市",
      "enName": "Omura City",
      "kana": "おおむらし",
      "chName": "大村市",
      "zhName": "大村市",
      "koName": "오무라 시",
      "esName": "Ciudad de Ōmura",
      "ptName": "cidade de Omura",
      "thName": "เมืองโอมุระ",
      "viName": "thành phố Omura",
      "inName": "kota Omura",
      "tlName": "siyudad ng Omura",
      "moName": "Омүра хот",
      "buName": "အို့မုရာ့ မြို့",
      "khName": "ទីក្រុង អូមូរ៉ា",
      "neName": "ओमुरा सहर"
    }
  },
  "4220700": {
    "office": {
      "code": "420000",
      "name": "長崎県",
      "enName": "Nagasaki",
      "officeName": "長崎地方気象台",
      "chName": "长崎县",
      "zhName": "長崎縣",
      "koName": "나가사키현",
      "esName": "Prefectura de Nagasaki",
      "ptName": "Província de Nagasaki",
      "thName": "จังหวัดนางาซากิ",
      "viName": "Tỉnh Nagasaki",
      "inName": "Prefektur Nagasaki",
      "tlName": "Nagasaki Prefecture",
      "moName": "Нагасаки аймаг",
      "buName": "နာဂါဆာကိ ပြည်နယ်",
      "khName": "ខេត្ដ ណាហ្គាសាគី",
      "neName": "नागासाकी जिल्ला"
    },
    "class10": {
      "code": "420020",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "长崎县北部",
      "zhName": "長崎縣北部",
      "koName": "나가사키 현 북부",
      "esName": "Norte de Prefectura de Nagasaki",
      "ptName": "Norte da Província de Nagasaki",
      "thName": "จังหวัดนางาซากิตอนเหนือ",
      "viName": "Miền Bắc tỉnh Nagasaki",
      "inName": "Bagian Utara Prefektur Nagasaki",
      "tlName": "Hilagang bahagi ng Nagasaki Prefecture ",
      "moName": "Хойд Нагасаки аймаг",
      "buName": "နာဂါဆာကိစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដណាហ្គាសាគី",
      "neName": "नागासाकी जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "420021",
      "name": "平戸・松浦地区",
      "enName": "Hirado Matsuura District"
    },
    "class20": {
      "code": "4220700",
      "name": "平戸市",
      "enName": "Hirado City",
      "kana": "ひらどし",
      "chName": "平户市",
      "zhName": "平戶市",
      "koName": "히라도 시",
      "esName": "Ciudad de Hirado",
      "ptName": "cidade de Hirado",
      "thName": "เมืองฮิราโดะ",
      "viName": "thành phố Hirado",
      "inName": "kota Hirado",
      "tlName": "siyudad ng Hirado",
      "moName": "Хирадо хот",
      "buName": "ဟီရားဒေါ့ မြို့",
      "khName": "ទីក្រុង ហ៊ីរ៉ាដូ",
      "neName": "हिरादो सहर"
    }
  },
  "4220800": {
    "office": {
      "code": "420000",
      "name": "長崎県",
      "enName": "Nagasaki",
      "officeName": "長崎地方気象台",
      "chName": "长崎县",
      "zhName": "長崎縣",
      "koName": "나가사키현",
      "esName": "Prefectura de Nagasaki",
      "ptName": "Província de Nagasaki",
      "thName": "จังหวัดนางาซากิ",
      "viName": "Tỉnh Nagasaki",
      "inName": "Prefektur Nagasaki",
      "tlName": "Nagasaki Prefecture",
      "moName": "Нагасаки аймаг",
      "buName": "နာဂါဆာကိ ပြည်နယ်",
      "khName": "ខេត្ដ ណាហ្គាសាគី",
      "neName": "नागासाकी जिल्ला"
    },
    "class10": {
      "code": "420020",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "长崎县北部",
      "zhName": "長崎縣北部",
      "koName": "나가사키 현 북부",
      "esName": "Norte de Prefectura de Nagasaki",
      "ptName": "Norte da Província de Nagasaki",
      "thName": "จังหวัดนางาซากิตอนเหนือ",
      "viName": "Miền Bắc tỉnh Nagasaki",
      "inName": "Bagian Utara Prefektur Nagasaki",
      "tlName": "Hilagang bahagi ng Nagasaki Prefecture ",
      "moName": "Хойд Нагасаки аймаг",
      "buName": "နာဂါဆာကိစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដណាហ្គាសាគី",
      "neName": "नागासाकी जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "420021",
      "name": "平戸・松浦地区",
      "enName": "Hirado Matsuura District"
    },
    "class20": {
      "code": "4220800",
      "name": "松浦市",
      "enName": "Matsuura City",
      "kana": "まつうらし",
      "chName": "松浦市",
      "zhName": "松浦市",
      "koName": "마쓰우라 시",
      "esName": "Ciudad de Matsuura",
      "ptName": "cidade de Matsuura",
      "thName": "เมืองมัทสึอุระ",
      "viName": "thành phố Matsuura",
      "inName": "kota Matsuura",
      "tlName": "siyudad ng Matsuura",
      "moName": "Мaцүүра хот",
      "buName": "မာဆူးရာ့ မြို့",
      "khName": "ទីក្រុង ម៉ាតស៊ូអ៊ូរ៉ា",
      "neName": "मात्सुरा सहर"
    }
  },
  "4220901": {
    "office": {
      "code": "420000",
      "name": "長崎県",
      "enName": "Nagasaki",
      "officeName": "長崎地方気象台",
      "chName": "长崎县",
      "zhName": "長崎縣",
      "koName": "나가사키현",
      "esName": "Prefectura de Nagasaki",
      "ptName": "Província de Nagasaki",
      "thName": "จังหวัดนางาซากิ",
      "viName": "Tỉnh Nagasaki",
      "inName": "Prefektur Nagasaki",
      "tlName": "Nagasaki Prefecture",
      "moName": "Нагасаки аймаг",
      "buName": "နာဂါဆာကိ ပြည်နယ်",
      "khName": "ខេត្ដ ណាហ្គាសាគី",
      "neName": "नागासाकी जिल्ला"
    },
    "class10": {
      "code": "420030",
      "name": "壱岐・対馬",
      "enName": "Iki Tsushima",
      "chName": "壹岐、对马近海",
      "zhName": "壱岐・對馬近海",
      "koName": "이키·대마도 근해",
      "esName": "Mares cercanos de Iki-Tsushima",
      "ptName": "Mar perto de Iki・Tsushima",
      "thName": "ทะเลบริเวณใกล้เคียงอิกิและสึชิมะ",
      "viName": "Vùng ven biển Iki và Tsuhima",
      "inName": "Laut yang Berdekatan dengan Pulau Iki dan Tsushima",
      "tlName": "Malapit na dagat ng Iki at Tsushima Islands",
      "moName": "Икишима・Цүшима аралд ойр далай",
      "buName": "အိခိရှိမကျွန်း၊ ဆုရှိမကျွန်း ပင်လယ်အနီး",
      "khName": "តំបន់សមុទ្រក្បែរអ៊ីគីស៊ីម៉ាក់/ហ្សឹស៊ីម៉ាក់",
      "neName": "इकी र चुसिमा टापुहरू नजिकको समुन्द्र"
    },
    "class15": {
      "code": "420033",
      "name": "下対馬",
      "enName": "Shimotsushima"
    },
    "class20": {
      "code": "4220901",
      "name": "対馬市下対馬",
      "enName": "Shimotsushima, Tsushima City",
      "kana": "つしまししもつしま",
      "chName": "对马市下对马",
      "zhName": "对马市下对马",
      "koName": "쓰시마시 시모쓰시마",
      "esName": "Shimotsushima, Ciudad de Tsushima",
      "ptName": "Shimotsushima, Cidade de Tsushima",
      "thName": "ชิโมะสึชิมะ, เมืองทสึชิมะ",
      "viName": "Shimotsushima, Thành phố Tsushima",
      "inName": "Shimotsushima, Kota Tsushima",
      "tlName": "Shimotsushima, Lungsod ng Tsushima",
      "moName": "Shimotsushima, Cidade de Tsushima",
      "buName": "ရှမိုတိုရှီမား၊ တုရှိမားမြို့",
      "khName": "ខេត្តតូស៊ីម៉ា",
      "neName": "त्सुशिमा सिटी"
    }
  },
  "4220902": {
    "office": {
      "code": "420000",
      "name": "長崎県",
      "enName": "Nagasaki",
      "officeName": "長崎地方気象台",
      "chName": "长崎县",
      "zhName": "長崎縣",
      "koName": "나가사키현",
      "esName": "Prefectura de Nagasaki",
      "ptName": "Província de Nagasaki",
      "thName": "จังหวัดนางาซากิ",
      "viName": "Tỉnh Nagasaki",
      "inName": "Prefektur Nagasaki",
      "tlName": "Nagasaki Prefecture",
      "moName": "Нагасаки аймаг",
      "buName": "နာဂါဆာကိ ပြည်နယ်",
      "khName": "ខេត្ដ ណាហ្គាសាគី",
      "neName": "नागासाकी जिल्ला"
    },
    "class10": {
      "code": "420030",
      "name": "壱岐・対馬",
      "enName": "Iki Tsushima",
      "chName": "壹岐、对马近海",
      "zhName": "壱岐・對馬近海",
      "koName": "이키·대마도 근해",
      "esName": "Mares cercanos de Iki-Tsushima",
      "ptName": "Mar perto de Iki・Tsushima",
      "thName": "ทะเลบริเวณใกล้เคียงอิกิและสึชิมะ",
      "viName": "Vùng ven biển Iki và Tsuhima",
      "inName": "Laut yang Berdekatan dengan Pulau Iki dan Tsushima",
      "tlName": "Malapit na dagat ng Iki at Tsushima Islands",
      "moName": "Икишима・Цүшима аралд ойр далай",
      "buName": "အိခိရှိမကျွန်း၊ ဆုရှိမကျွန်း ပင်လယ်အနီး",
      "khName": "តំបន់សមុទ្រក្បែរអ៊ីគីស៊ីម៉ាក់/ហ្សឹស៊ីម៉ាក់",
      "neName": "इकी र चुसिमा टापुहरू नजिकको समुन्द्र"
    },
    "class15": {
      "code": "420032",
      "name": "上対馬",
      "enName": "Kamitsushima"
    },
    "class20": {
      "code": "4220902",
      "name": "対馬市上対馬",
      "enName": "Kamitsushima, Tsushima City",
      "kana": "つしましかみつしま",
      "chName": "对马市上对马",
      "zhName": "对马市上对马",
      "koName": "쓰시마시 카미쓰시마",
      "esName": "Kamitsushima, Ciudad de Tsushima",
      "ptName": "Kamitsushima, Cidade de Tsushima",
      "thName": "คามิซึชิมะ, เมืองทสึชิมะ",
      "viName": "Kamitsushima, Thành phố Tsushima",
      "inName": "Kamitsushima, Kota Tsushima",
      "tlName": "Kamitsushima, Lungsod ng Tsushima",
      "moName": "Kamitsushima, Cidade de Tsushima",
      "buName": "ကာမီတိုရှီမား၊ တုရှိမားမြို့",
      "khName": "ខេត្តតូស៊ីម៉ា",
      "neName": "कामीत्सुशिमा सिटी"
    }
  },
  "4221000": {
    "office": {
      "code": "420000",
      "name": "長崎県",
      "enName": "Nagasaki",
      "officeName": "長崎地方気象台",
      "chName": "长崎县",
      "zhName": "長崎縣",
      "koName": "나가사키현",
      "esName": "Prefectura de Nagasaki",
      "ptName": "Província de Nagasaki",
      "thName": "จังหวัดนางาซากิ",
      "viName": "Tỉnh Nagasaki",
      "inName": "Prefektur Nagasaki",
      "tlName": "Nagasaki Prefecture",
      "moName": "Нагасаки аймаг",
      "buName": "နာဂါဆာကိ ပြည်နယ်",
      "khName": "ខេត្ដ ណាហ្គាសាគី",
      "neName": "नागासाकी जिल्ला"
    },
    "class10": {
      "code": "420030",
      "name": "壱岐・対馬",
      "enName": "Iki Tsushima",
      "chName": "壹岐、对马近海",
      "zhName": "壱岐・對馬近海",
      "koName": "이키·대마도 근해",
      "esName": "Mares cercanos de Iki-Tsushima",
      "ptName": "Mar perto de Iki・Tsushima",
      "thName": "ทะเลบริเวณใกล้เคียงอิกิและสึชิมะ",
      "viName": "Vùng ven biển Iki và Tsuhima",
      "inName": "Laut yang Berdekatan dengan Pulau Iki dan Tsushima",
      "tlName": "Malapit na dagat ng Iki at Tsushima Islands",
      "moName": "Икишима・Цүшима аралд ойр далай",
      "buName": "အိခိရှိမကျွန်း၊ ဆုရှိမကျွန်း ပင်လယ်အနီး",
      "khName": "តំបន់សមុទ្រក្បែរអ៊ីគីស៊ីម៉ាក់/ហ្សឹស៊ីម៉ាក់",
      "neName": "इकी र चुसिमा टापुहरू नजिकको समुन्द्र"
    },
    "class15": {
      "code": "420031",
      "name": "壱岐",
      "enName": "Iki"
    },
    "class20": {
      "code": "4221000",
      "name": "壱岐市",
      "enName": "Iki City",
      "kana": "いきし",
      "chName": "壹岐市",
      "zhName": "壹岐市",
      "koName": "이키 시",
      "esName": "Ciudad de Iki",
      "ptName": "cidade de Iki",
      "thName": "เมืองอิกิ",
      "viName": "thành phố Iki",
      "inName": "kota Iki",
      "tlName": "siyudad ng Iki",
      "moName": "Ики хот",
      "buName": "အီကိ မြို့",
      "khName": "ទីក្រុង អ៊ីគី",
      "neName": "इकी सहर"
    }
  },
  "4221100": {
    "office": {
      "code": "420000",
      "name": "長崎県",
      "enName": "Nagasaki",
      "officeName": "長崎地方気象台",
      "chName": "长崎县",
      "zhName": "長崎縣",
      "koName": "나가사키현",
      "esName": "Prefectura de Nagasaki",
      "ptName": "Província de Nagasaki",
      "thName": "จังหวัดนางาซากิ",
      "viName": "Tỉnh Nagasaki",
      "inName": "Prefektur Nagasaki",
      "tlName": "Nagasaki Prefecture",
      "moName": "Нагасаки аймаг",
      "buName": "နာဂါဆာကိ ပြည်နယ်",
      "khName": "ខេត្ដ ណាហ្គាសាគី",
      "neName": "नागासाकी जिल्ला"
    },
    "class10": {
      "code": "420040",
      "name": "五島",
      "enName": "Goto",
      "chName": "五岛列岛近海",
      "zhName": "五岛列岛近海",
      "koName": "고토 열도 근해",
      "esName": "Mares cercanos de Islas de Gotou",
      "ptName": "Mar perto das Ilhas Gotō",
      "thName": "ทะเลบริเวณใกล้เคียงหมู่เกาะโกะโต",
      "viName": "Vùng ven biển quần đảo Goto",
      "inName": "Laut yang Berdekatan dengan Kepulauan Goto",
      "tlName": "Malapit na dagat ng Goto Islands",
      "moName": "Гото арлуудад ойр далай",
      "buName": "ဂိုတိုကျွန်း ပင်လယ်အနီး",
      "khName": "តំបន់សមុទ្រក្បែរនៃជួរកោះហ្គូតូ",
      "neName": "गोतो टापुहरू नजिकको समुन्द्र"
    },
    "class15": {
      "code": "420042",
      "name": "下五島",
      "enName": "Shimogoto"
    },
    "class20": {
      "code": "4221100",
      "name": "五島市",
      "enName": "Goto City",
      "kana": "ごとうし",
      "chName": "五岛市",
      "zhName": "五島市",
      "koName": "고토 시",
      "esName": "Ciudad de Goto",
      "ptName": "cidade de Goto",
      "thName": "เมืองโกโตะ",
      "viName": "thành phố Goto",
      "inName": "kota Goto",
      "tlName": "siyudad ng Goto",
      "moName": "Гото хот",
      "buName": "ဂိုတို မြို့",
      "khName": "ទីក្រុង ហ្គូតូ",
      "neName": "गोतो सहर"
    }
  },
  "4221201": {
    "office": {
      "code": "420000",
      "name": "長崎県",
      "enName": "Nagasaki",
      "officeName": "長崎地方気象台",
      "chName": "长崎县",
      "zhName": "長崎縣",
      "koName": "나가사키현",
      "esName": "Prefectura de Nagasaki",
      "ptName": "Província de Nagasaki",
      "thName": "จังหวัดนางาซากิ",
      "viName": "Tỉnh Nagasaki",
      "inName": "Prefektur Nagasaki",
      "tlName": "Nagasaki Prefecture",
      "moName": "Нагасаки аймаг",
      "buName": "နာဂါဆာကိ ပြည်နယ်",
      "khName": "ខេត្ដ ណាហ្គាសាគី",
      "neName": "नागासाकी जिल्ला"
    },
    "class10": {
      "code": "420010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "长崎县南部",
      "zhName": "長崎縣南部",
      "koName": "나가사키 현 남부",
      "esName": "Sur de Prefectura de Nagasaki",
      "ptName": "Sul da Província de Nagasaki",
      "thName": "จังหวัดนางาซากิตอนใต้",
      "viName": "Miền Nam tỉnh Nagasaki",
      "inName": "Bagian Selatan Prefektur Nagasaki",
      "tlName": "Timog bahagi ng Nagasaki Prefecture",
      "moName": "Өмнөд Нагасаки аймаг",
      "buName": "နာဂါဆာကိစီရင်စု အနောက်တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដណាហ្គាសាគី",
      "neName": "नागासाकी जिल्लाको दक्षिण भाग"
    },
    "class15": {
      "code": "420014",
      "name": "西彼杵半島",
      "enName": "Nishisonogi Peninsula"
    },
    "class20": {
      "code": "4221201",
      "name": "西海市（江島・平島を除く）",
      "enName": "Saikai City (Excluding Enoshima and Tairashima)",
      "kana": "さいかいし",
      "chName": "西海市",
      "zhName": "西海市",
      "koName": "사이카이시",
      "esName": "Ciudad de Saikai",
      "ptName": "Cidade de Saikai",
      "thName": "เมืองไซไค",
      "viName": "Thành phố Saikai",
      "inName": "Kota Saikai",
      "tlName": "Lungsod ng Saikai",
      "moName": "Cidade de Saikai",
      "buName": "စိုင်းကွေးမြို့ (အယ်နှင့်ရှေ့မြို့များကိုကျော်ထားပါ)",
      "khName": "ខេត្តសាយខាយ",
      "neName": "साइकोई सिटी"
    }
  },
  "4221202": {
    "office": {
      "code": "420000",
      "name": "長崎県",
      "enName": "Nagasaki",
      "officeName": "長崎地方気象台",
      "chName": "长崎县",
      "zhName": "長崎縣",
      "koName": "나가사키현",
      "esName": "Prefectura de Nagasaki",
      "ptName": "Província de Nagasaki",
      "thName": "จังหวัดนางาซากิ",
      "viName": "Tỉnh Nagasaki",
      "inName": "Prefektur Nagasaki",
      "tlName": "Nagasaki Prefecture",
      "moName": "Нагасаки аймаг",
      "buName": "နာဂါဆာကိ ပြည်နယ်",
      "khName": "ខេត្ដ ណាហ្គាសាគី",
      "neName": "नागासाकी जिल्ला"
    },
    "class10": {
      "code": "420040",
      "name": "五島",
      "enName": "Goto",
      "chName": "五岛列岛近海",
      "zhName": "五岛列岛近海",
      "koName": "고토 열도 근해",
      "esName": "Mares cercanos de Islas de Gotou",
      "ptName": "Mar perto das Ilhas Gotō",
      "thName": "ทะเลบริเวณใกล้เคียงหมู่เกาะโกะโต",
      "viName": "Vùng ven biển quần đảo Goto",
      "inName": "Laut yang Berdekatan dengan Kepulauan Goto",
      "tlName": "Malapit na dagat ng Goto Islands",
      "moName": "Гото арлуудад ойр далай",
      "buName": "ဂိုတိုကျွန်း ပင်လယ်အနီး",
      "khName": "តំបន់សមុទ្រក្បែរនៃជួរកោះហ្គូតូ",
      "neName": "गोतो टापुहरू नजिकको समुन्द्र"
    },
    "class15": {
      "code": "420041",
      "name": "上五島",
      "enName": "Kamigoto"
    },
    "class20": {
      "code": "4221202",
      "name": "西海市（江島・平島）",
      "enName": "Saikai City (Enoshima and Tairashima)",
      "kana": "さいかいし",
      "chName": "西海市",
      "zhName": "西海市",
      "koName": "사이카이시",
      "esName": "Ciudad de Saikai",
      "ptName": "Cidade de Saikai",
      "thName": "เมืองไซไค",
      "viName": "Thành phố Saikai",
      "inName": "Kota Saikai",
      "tlName": "Lungsod ng Saikai",
      "moName": "Cidade de Saikai",
      "buName": "စိုင်းကွေးမြို့ (အယ်နှင့်ရှေ့မြို့များကိုထည့်ပါ)",
      "khName": "ខេត្តសាយខាយ",
      "neName": "साइकोई सिटी"
    }
  },
  "4221300": {
    "office": {
      "code": "420000",
      "name": "長崎県",
      "enName": "Nagasaki",
      "officeName": "長崎地方気象台",
      "chName": "长崎县",
      "zhName": "長崎縣",
      "koName": "나가사키현",
      "esName": "Prefectura de Nagasaki",
      "ptName": "Província de Nagasaki",
      "thName": "จังหวัดนางาซากิ",
      "viName": "Tỉnh Nagasaki",
      "inName": "Prefektur Nagasaki",
      "tlName": "Nagasaki Prefecture",
      "moName": "Нагасаки аймаг",
      "buName": "နာဂါဆာကိ ပြည်နယ်",
      "khName": "ខេត្ដ ណាហ្គាសាគី",
      "neName": "नागासाकी जिल्ला"
    },
    "class10": {
      "code": "420010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "长崎县南部",
      "zhName": "長崎縣南部",
      "koName": "나가사키 현 남부",
      "esName": "Sur de Prefectura de Nagasaki",
      "ptName": "Sul da Província de Nagasaki",
      "thName": "จังหวัดนางาซากิตอนใต้",
      "viName": "Miền Nam tỉnh Nagasaki",
      "inName": "Bagian Selatan Prefektur Nagasaki",
      "tlName": "Timog bahagi ng Nagasaki Prefecture",
      "moName": "Өмнөд Нагасаки аймаг",
      "buName": "နာဂါဆာကိစီရင်စု အနောက်တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដណាហ្គាសាគី",
      "neName": "नागासाकी जिल्लाको दक्षिण भाग"
    },
    "class15": {
      "code": "420011",
      "name": "島原半島",
      "enName": "Shimabara Peninsula"
    },
    "class20": {
      "code": "4221300",
      "name": "雲仙市",
      "enName": "Unzen City",
      "kana": "うんぜんし",
      "chName": "云仙市",
      "zhName": "雲仙市",
      "koName": "운젠 시",
      "esName": "Ciudad de Unzen",
      "ptName": "cidade de Unzen",
      "thName": "เมืองอุนเซ็น",
      "viName": "thành phố Unzen",
      "inName": "kota Unzen",
      "tlName": "siyudad ng Unzen",
      "moName": "Үнзэн хот",
      "buName": "အွန်းဇန် မြို့",
      "khName": "ទីក្រុង អ៊ុនហ្សេន",
      "neName": "उनजेन सहर"
    }
  },
  "4221400": {
    "office": {
      "code": "420000",
      "name": "長崎県",
      "enName": "Nagasaki",
      "officeName": "長崎地方気象台",
      "chName": "长崎县",
      "zhName": "長崎縣",
      "koName": "나가사키현",
      "esName": "Prefectura de Nagasaki",
      "ptName": "Província de Nagasaki",
      "thName": "จังหวัดนางาซากิ",
      "viName": "Tỉnh Nagasaki",
      "inName": "Prefektur Nagasaki",
      "tlName": "Nagasaki Prefecture",
      "moName": "Нагасаки аймаг",
      "buName": "နာဂါဆာကိ ပြည်နယ်",
      "khName": "ខេត្ដ ណាហ្គាសាគី",
      "neName": "नागासाकी जिल्ला"
    },
    "class10": {
      "code": "420010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "长崎县南部",
      "zhName": "長崎縣南部",
      "koName": "나가사키 현 남부",
      "esName": "Sur de Prefectura de Nagasaki",
      "ptName": "Sul da Província de Nagasaki",
      "thName": "จังหวัดนางาซากิตอนใต้",
      "viName": "Miền Nam tỉnh Nagasaki",
      "inName": "Bagian Selatan Prefektur Nagasaki",
      "tlName": "Timog bahagi ng Nagasaki Prefecture",
      "moName": "Өмнөд Нагасаки аймаг",
      "buName": "နာဂါဆာကိစီရင်စု အနောက်တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដណាហ្គាសាគី",
      "neName": "नागासाकी जिल्लाको दक्षिण भाग"
    },
    "class15": {
      "code": "420011",
      "name": "島原半島",
      "enName": "Shimabara Peninsula"
    },
    "class20": {
      "code": "4221400",
      "name": "南島原市",
      "enName": "Minamishimabara City",
      "kana": "みなみしまばらし",
      "chName": "南岛原市",
      "zhName": "南島原市",
      "koName": "미나미시마바라 시",
      "esName": "Ciudad de Minami-shimabara",
      "ptName": "cidade de Minamishimabara",
      "thName": "เมืองมินามิชิมะบาระ",
      "viName": "thành phố Minamishimabara",
      "inName": "kota Minamishimabara",
      "tlName": "siyudad ng Minamishimabara",
      "moName": "Минaмишимaбара хот",
      "buName": "မီနာမိရှိမာ့ဘားရာ့ မြို့",
      "khName": "ទីក្រុង មីណាមីស៊ីម៉ាបារ៉ា",
      "neName": "मिनामिशिमाबारा सहर"
    }
  },
  "4230700": {
    "office": {
      "code": "420000",
      "name": "長崎県",
      "enName": "Nagasaki",
      "officeName": "長崎地方気象台",
      "chName": "长崎县",
      "zhName": "長崎縣",
      "koName": "나가사키현",
      "esName": "Prefectura de Nagasaki",
      "ptName": "Província de Nagasaki",
      "thName": "จังหวัดนางาซากิ",
      "viName": "Tỉnh Nagasaki",
      "inName": "Prefektur Nagasaki",
      "tlName": "Nagasaki Prefecture",
      "moName": "Нагасаки аймаг",
      "buName": "နာဂါဆာကိ ပြည်နယ်",
      "khName": "ខេត្ដ ណាហ្គាសាគី",
      "neName": "नागासाकी जिल्ला"
    },
    "class10": {
      "code": "420010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "长崎县南部",
      "zhName": "長崎縣南部",
      "koName": "나가사키 현 남부",
      "esName": "Sur de Prefectura de Nagasaki",
      "ptName": "Sul da Província de Nagasaki",
      "thName": "จังหวัดนางาซากิตอนใต้",
      "viName": "Miền Nam tỉnh Nagasaki",
      "inName": "Bagian Selatan Prefektur Nagasaki",
      "tlName": "Timog bahagi ng Nagasaki Prefecture",
      "moName": "Өмнөд Нагасаки аймаг",
      "buName": "နာဂါဆာကိစီရင်စု အနောက်တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដណាហ្គាសាគី",
      "neName": "नागासाकी जिल्लाको दक्षिण भाग"
    },
    "class15": {
      "code": "420012",
      "name": "長崎地区",
      "enName": "Nagasaki District"
    },
    "class20": {
      "code": "4230700",
      "name": "長与町",
      "enName": "Nagayo Town",
      "kana": "ながよちょう",
      "chName": "长与町",
      "zhName": "長與町",
      "koName": "나가요 정",
      "esName": "Pueblo de Nagayo",
      "ptName": "bairro de Nagayo",
      "thName": "เมืองนาโกยะ",
      "viName": "thị trấn Nag",
      "inName": "kota Nagayo",
      "tlName": "bayan ng Nagayo",
      "moName": "Нaгaёо жижиг хот",
      "buName": "နာဂါ့ရို မြို့နယ်",
      "khName": "ទីប្រជុំជន ណាហ្គាយ៉ូ",
      "neName": "नागायो नगर"
    }
  },
  "4230800": {
    "office": {
      "code": "420000",
      "name": "長崎県",
      "enName": "Nagasaki",
      "officeName": "長崎地方気象台",
      "chName": "长崎县",
      "zhName": "長崎縣",
      "koName": "나가사키현",
      "esName": "Prefectura de Nagasaki",
      "ptName": "Província de Nagasaki",
      "thName": "จังหวัดนางาซากิ",
      "viName": "Tỉnh Nagasaki",
      "inName": "Prefektur Nagasaki",
      "tlName": "Nagasaki Prefecture",
      "moName": "Нагасаки аймаг",
      "buName": "နာဂါဆာကိ ပြည်နယ်",
      "khName": "ខេត្ដ ណាហ្គាសាគី",
      "neName": "नागासाकी जिल्ला"
    },
    "class10": {
      "code": "420010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "长崎县南部",
      "zhName": "長崎縣南部",
      "koName": "나가사키 현 남부",
      "esName": "Sur de Prefectura de Nagasaki",
      "ptName": "Sul da Província de Nagasaki",
      "thName": "จังหวัดนางาซากิตอนใต้",
      "viName": "Miền Nam tỉnh Nagasaki",
      "inName": "Bagian Selatan Prefektur Nagasaki",
      "tlName": "Timog bahagi ng Nagasaki Prefecture",
      "moName": "Өмнөд Нагасаки аймаг",
      "buName": "နာဂါဆာကိစီရင်စု အနောက်တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដណាហ្គាសាគី",
      "neName": "नागासाकी जिल्लाको दक्षिण भाग"
    },
    "class15": {
      "code": "420012",
      "name": "長崎地区",
      "enName": "Nagasaki District"
    },
    "class20": {
      "code": "4230800",
      "name": "時津町",
      "enName": "Togitsu Town",
      "kana": "とぎつちょう",
      "chName": "时津町",
      "zhName": "時津町",
      "koName": "도기쓰 정",
      "esName": "Pueblo de Togitsu",
      "ptName": "bairro de Togitsu",
      "thName": "เมืองโทจิสึ",
      "viName": "thị trấn Togitsu",
      "inName": "kota Togitsu",
      "tlName": "bayan ng Togitsu",
      "moName": "Тогицү жижиг хот",
      "buName": "တောဂိစု မြို့နယ်",
      "khName": "ទីប្រជុំជន តូជីស៊ូ",
      "neName": "तोगित्सु नगर"
    }
  },
  "4232100": {
    "office": {
      "code": "420000",
      "name": "長崎県",
      "enName": "Nagasaki",
      "officeName": "長崎地方気象台",
      "chName": "长崎县",
      "zhName": "長崎縣",
      "koName": "나가사키현",
      "esName": "Prefectura de Nagasaki",
      "ptName": "Província de Nagasaki",
      "thName": "จังหวัดนางาซากิ",
      "viName": "Tỉnh Nagasaki",
      "inName": "Prefektur Nagasaki",
      "tlName": "Nagasaki Prefecture",
      "moName": "Нагасаки аймаг",
      "buName": "နာဂါဆာကိ ပြည်နယ်",
      "khName": "ខេត្ដ ណាហ្គាសាគី",
      "neName": "नागासाकी जिल्ला"
    },
    "class10": {
      "code": "420020",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "长崎县北部",
      "zhName": "長崎縣北部",
      "koName": "나가사키 현 북부",
      "esName": "Norte de Prefectura de Nagasaki",
      "ptName": "Norte da Província de Nagasaki",
      "thName": "จังหวัดนางาซากิตอนเหนือ",
      "viName": "Miền Bắc tỉnh Nagasaki",
      "inName": "Bagian Utara Prefektur Nagasaki",
      "tlName": "Hilagang bahagi ng Nagasaki Prefecture ",
      "moName": "Хойд Нагасаки аймаг",
      "buName": "နာဂါဆာကိစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដណាហ្គាសាគី",
      "neName": "नागासाकी जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "420022",
      "name": "佐世保・東彼地区",
      "enName": "Sasebo Tohi District"
    },
    "class20": {
      "code": "4232100",
      "name": "東彼杵町",
      "enName": "Higashisonogi Town",
      "kana": "ひがしそのぎちょう",
      "chName": "东彼杵町",
      "zhName": "東彼杵町",
      "koName": "히가시소노기 정",
      "esName": "Pueblo de Higashisonogi",
      "ptName": "bairro de Higashisonogi",
      "thName": "เมืองฮิงาชิโซโนะงิ",
      "viName": "thị trấn Higashisonogi",
      "inName": "kota Higashisonogi",
      "tlName": "bayan ng Higashisonogi",
      "moName": "Хигaшисоноги жижиг хот",
      "buName": "ဟီဂါ့ရှိဆိုနိုဂိ မြို့နယ်",
      "khName": "ទីប្រជុំជន ហ៊ីហ្កាស៊ីសូណូហ្គី",
      "neName": "हिगाशिसोनोगी नगर"
    }
  },
  "4232200": {
    "office": {
      "code": "420000",
      "name": "長崎県",
      "enName": "Nagasaki",
      "officeName": "長崎地方気象台",
      "chName": "长崎县",
      "zhName": "長崎縣",
      "koName": "나가사키현",
      "esName": "Prefectura de Nagasaki",
      "ptName": "Província de Nagasaki",
      "thName": "จังหวัดนางาซากิ",
      "viName": "Tỉnh Nagasaki",
      "inName": "Prefektur Nagasaki",
      "tlName": "Nagasaki Prefecture",
      "moName": "Нагасаки аймаг",
      "buName": "နာဂါဆာကိ ပြည်နယ်",
      "khName": "ខេត្ដ ណាហ្គាសាគី",
      "neName": "नागासाकी जिल्ला"
    },
    "class10": {
      "code": "420020",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "长崎县北部",
      "zhName": "長崎縣北部",
      "koName": "나가사키 현 북부",
      "esName": "Norte de Prefectura de Nagasaki",
      "ptName": "Norte da Província de Nagasaki",
      "thName": "จังหวัดนางาซากิตอนเหนือ",
      "viName": "Miền Bắc tỉnh Nagasaki",
      "inName": "Bagian Utara Prefektur Nagasaki",
      "tlName": "Hilagang bahagi ng Nagasaki Prefecture ",
      "moName": "Хойд Нагасаки аймаг",
      "buName": "နာဂါဆာကိစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដណាហ្គាសាគី",
      "neName": "नागासाकी जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "420022",
      "name": "佐世保・東彼地区",
      "enName": "Sasebo Tohi District"
    },
    "class20": {
      "code": "4232200",
      "name": "川棚町",
      "enName": "Kawatana Town",
      "kana": "かわたなちょう",
      "chName": "川棚町",
      "zhName": "川棚町",
      "koName": "가와타나 정",
      "esName": "Pueblo de Kawatana",
      "ptName": "bairro de Kawatana",
      "thName": "เมืองคาวาทานะ",
      "viName": "thị trấn Kawatana",
      "inName": "kota Kawatana",
      "tlName": "bayan ng Kawatana",
      "moName": "Каватана жижиг хот",
      "buName": "ခါဝါတာ့န မြို့နယ်",
      "khName": "ទីប្រជុំជន កាវ៉ាតាណា",
      "neName": "कावाताना नगर"
    }
  },
  "4232300": {
    "office": {
      "code": "420000",
      "name": "長崎県",
      "enName": "Nagasaki",
      "officeName": "長崎地方気象台",
      "chName": "长崎县",
      "zhName": "長崎縣",
      "koName": "나가사키현",
      "esName": "Prefectura de Nagasaki",
      "ptName": "Província de Nagasaki",
      "thName": "จังหวัดนางาซากิ",
      "viName": "Tỉnh Nagasaki",
      "inName": "Prefektur Nagasaki",
      "tlName": "Nagasaki Prefecture",
      "moName": "Нагасаки аймаг",
      "buName": "နာဂါဆာကိ ပြည်နယ်",
      "khName": "ខេត្ដ ណាហ្គាសាគី",
      "neName": "नागासाकी जिल्ला"
    },
    "class10": {
      "code": "420020",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "长崎县北部",
      "zhName": "長崎縣北部",
      "koName": "나가사키 현 북부",
      "esName": "Norte de Prefectura de Nagasaki",
      "ptName": "Norte da Província de Nagasaki",
      "thName": "จังหวัดนางาซากิตอนเหนือ",
      "viName": "Miền Bắc tỉnh Nagasaki",
      "inName": "Bagian Utara Prefektur Nagasaki",
      "tlName": "Hilagang bahagi ng Nagasaki Prefecture ",
      "moName": "Хойд Нагасаки аймаг",
      "buName": "နာဂါဆာကိစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដណាហ្គាសាគី",
      "neName": "नागासाकी जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "420022",
      "name": "佐世保・東彼地区",
      "enName": "Sasebo Tohi District"
    },
    "class20": {
      "code": "4232300",
      "name": "波佐見町",
      "enName": "Hasami Town",
      "kana": "はさみちょう",
      "chName": "波佐见町",
      "zhName": "波佐見町",
      "koName": "하사미 정",
      "esName": "Pueblo de Hasami",
      "ptName": "bairro de Hasami",
      "thName": "เมืองฮาซามิ",
      "viName": "thị trấn Hasami",
      "inName": "kota Hasami",
      "tlName": "bayan ng Hasami",
      "moName": "Хaсaми жижиг хот",
      "buName": "ဟာဆာ့မိ မြို့နယ်",
      "khName": "ទីប្រជុំជន ហាសាមិ",
      "neName": "हासामी नगर"
    }
  },
  "4238300": {
    "office": {
      "code": "420000",
      "name": "長崎県",
      "enName": "Nagasaki",
      "officeName": "長崎地方気象台",
      "chName": "长崎县",
      "zhName": "長崎縣",
      "koName": "나가사키현",
      "esName": "Prefectura de Nagasaki",
      "ptName": "Província de Nagasaki",
      "thName": "จังหวัดนางาซากิ",
      "viName": "Tỉnh Nagasaki",
      "inName": "Prefektur Nagasaki",
      "tlName": "Nagasaki Prefecture",
      "moName": "Нагасаки аймаг",
      "buName": "နာဂါဆာကိ ပြည်နယ်",
      "khName": "ខេត្ដ ណាហ្គាសាគី",
      "neName": "नागासाकी जिल्ला"
    },
    "class10": {
      "code": "420040",
      "name": "五島",
      "enName": "Goto",
      "chName": "五岛列岛近海",
      "zhName": "五岛列岛近海",
      "koName": "고토 열도 근해",
      "esName": "Mares cercanos de Islas de Gotou",
      "ptName": "Mar perto das Ilhas Gotō",
      "thName": "ทะเลบริเวณใกล้เคียงหมู่เกาะโกะโต",
      "viName": "Vùng ven biển quần đảo Goto",
      "inName": "Laut yang Berdekatan dengan Kepulauan Goto",
      "tlName": "Malapit na dagat ng Goto Islands",
      "moName": "Гото арлуудад ойр далай",
      "buName": "ဂိုတိုကျွန်း ပင်လယ်အနီး",
      "khName": "តំបន់សមុទ្រក្បែរនៃជួរកោះហ្គូតូ",
      "neName": "गोतो टापुहरू नजिकको समुन्द्र"
    },
    "class15": {
      "code": "420041",
      "name": "上五島",
      "enName": "Kamigoto"
    },
    "class20": {
      "code": "4238300",
      "name": "小値賀町",
      "enName": "Ojika Town",
      "kana": "おぢかちょう",
      "chName": "小值贺町",
      "zhName": "小值賀町",
      "koName": "오지카 정",
      "esName": "Pueblo de Ojika",
      "ptName": "bairro de Ojika",
      "thName": "เมืองโอจิกะ",
      "viName": "thị trấn Ojika",
      "inName": "kota Ojika",
      "tlName": "bayan ng Ojika",
      "moName": "Ожика жижиг хот",
      "buName": "အိုဂျိက မြို့နယ်",
      "khName": "ទីប្រជុំជន អូហ្សីកា",
      "neName": "ओजिका नगर"
    }
  },
  "4239100": {
    "office": {
      "code": "420000",
      "name": "長崎県",
      "enName": "Nagasaki",
      "officeName": "長崎地方気象台",
      "chName": "长崎县",
      "zhName": "長崎縣",
      "koName": "나가사키현",
      "esName": "Prefectura de Nagasaki",
      "ptName": "Província de Nagasaki",
      "thName": "จังหวัดนางาซากิ",
      "viName": "Tỉnh Nagasaki",
      "inName": "Prefektur Nagasaki",
      "tlName": "Nagasaki Prefecture",
      "moName": "Нагасаки аймаг",
      "buName": "နာဂါဆာကိ ပြည်နယ်",
      "khName": "ខេត្ដ ណាហ្គាសាគី",
      "neName": "नागासाकी जिल्ला"
    },
    "class10": {
      "code": "420020",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "长崎县北部",
      "zhName": "長崎縣北部",
      "koName": "나가사키 현 북부",
      "esName": "Norte de Prefectura de Nagasaki",
      "ptName": "Norte da Província de Nagasaki",
      "thName": "จังหวัดนางาซากิตอนเหนือ",
      "viName": "Miền Bắc tỉnh Nagasaki",
      "inName": "Bagian Utara Prefektur Nagasaki",
      "tlName": "Hilagang bahagi ng Nagasaki Prefecture ",
      "moName": "Хойд Нагасаки аймаг",
      "buName": "နာဂါဆာကိစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដណាហ្គាសាគី",
      "neName": "नागासाकी जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "420022",
      "name": "佐世保・東彼地区",
      "enName": "Sasebo Tohi District"
    },
    "class20": {
      "code": "4239100",
      "name": "佐々町",
      "enName": "Saza Town",
      "kana": "さざちょう",
      "chName": "佐佐町",
      "zhName": "佐佐町",
      "koName": "사자 정",
      "esName": "Pueblo de Saza",
      "ptName": "bairro de Saza",
      "thName": "เมืองซาสะ",
      "viName": "thị trấn Saza",
      "inName": "kota Saza",
      "tlName": "bayan ng Saza",
      "moName": "Сaзa жижиг хот",
      "buName": "ဆာဇာ့ မြို့နယ်",
      "khName": "ទីប្រជុំជន សាហ្សា",
      "neName": "साजा नगर"
    }
  },
  "4241100": {
    "office": {
      "code": "420000",
      "name": "長崎県",
      "enName": "Nagasaki",
      "officeName": "長崎地方気象台",
      "chName": "长崎县",
      "zhName": "長崎縣",
      "koName": "나가사키현",
      "esName": "Prefectura de Nagasaki",
      "ptName": "Província de Nagasaki",
      "thName": "จังหวัดนางาซากิ",
      "viName": "Tỉnh Nagasaki",
      "inName": "Prefektur Nagasaki",
      "tlName": "Nagasaki Prefecture",
      "moName": "Нагасаки аймаг",
      "buName": "နာဂါဆာကိ ပြည်နယ်",
      "khName": "ខេត្ដ ណាហ្គាសាគី",
      "neName": "नागासाकी जिल्ला"
    },
    "class10": {
      "code": "420040",
      "name": "五島",
      "enName": "Goto",
      "chName": "五岛列岛近海",
      "zhName": "五岛列岛近海",
      "koName": "고토 열도 근해",
      "esName": "Mares cercanos de Islas de Gotou",
      "ptName": "Mar perto das Ilhas Gotō",
      "thName": "ทะเลบริเวณใกล้เคียงหมู่เกาะโกะโต",
      "viName": "Vùng ven biển quần đảo Goto",
      "inName": "Laut yang Berdekatan dengan Kepulauan Goto",
      "tlName": "Malapit na dagat ng Goto Islands",
      "moName": "Гото арлуудад ойр далай",
      "buName": "ဂိုတိုကျွန်း ပင်လယ်အနီး",
      "khName": "តំបន់សមុទ្រក្បែរនៃជួរកោះហ្គូតូ",
      "neName": "गोतो टापुहरू नजिकको समुन्द्र"
    },
    "class15": {
      "code": "420041",
      "name": "上五島",
      "enName": "Kamigoto"
    },
    "class20": {
      "code": "4241100",
      "name": "新上五島町",
      "enName": "Shinkamigoto Town",
      "kana": "しんかみごとうちょう",
      "chName": "新上五岛町",
      "zhName": "新上五島町",
      "koName": "신카미고토 정",
      "esName": "Pueblo de Shin-kamigoto",
      "ptName": "bairro de Shinkamigoto",
      "thName": "เมืองชินคามิโกโตะ",
      "viName": "thị trấn Shinkamigoto",
      "inName": "kota Shinkamigoto",
      "tlName": "bayan ng Shinkamigoto",
      "moName": "Шинкамигото жижиг хот",
      "buName": "ရှင်းခါမိဂိုတို မြို့နယ်",
      "khName": "ទីប្រជុំជន ស៊ីកាមីកាតុ",
      "neName": "शिन्कामिगोतो नगर"
    }
  },
  "4310000": {
    "office": {
      "code": "430000",
      "name": "熊本県",
      "enName": "Kumamoto",
      "officeName": "熊本地方気象台",
      "chName": "熊本县",
      "zhName": "熊本縣",
      "koName": "구마모토현",
      "esName": "Prefectura de Kumamoto",
      "ptName": "Província de Kumamoto",
      "thName": "จังหวัดคุมาโมโตะ",
      "viName": "Tỉnh Kumamoto",
      "inName": "Prefektur Kumamoto",
      "tlName": "Kumamoto Prefecture",
      "moName": "Күматомо аймаг",
      "buName": "ကူမာမိုတို ပြည်နယ်",
      "khName": "ខេត្ដ គូម៉ាម៉ូតូ",
      "neName": "कुमामोतो जिल्ला"
    },
    "class10": {
      "code": "430010",
      "name": "熊本地方",
      "enName": "Kumamoto Region",
      "chName": "熊本县熊本地方",
      "zhName": "熊本縣熊本地方",
      "koName": "구마모토 현 구마모토 지방",
      "esName": "Región Kumamoto, Prefectura de Kumamoto",
      "ptName": "Região de Kumamoto da Província de Kumamoto",
      "thName": "ท้องถิ่นคุมาโมโตะ จังหวัดคุมาโมโตะ",
      "viName": "Vùng Kumamoto, tỉnh Kumamoto",
      "inName": "Daerah Kumamoto di Prefektur Kumamoto",
      "tlName": "Rehiyon ng Kumamoto sa Kumamoto Prefecture ",
      "moName": "Күмамото аймаг, Күмамото муж",
      "buName": "ကုမမိုတိုဒေသ၊ ကုမမိုတိုစီရင်စု",
      "khName": "តំបន់ឃឹម៉ាម៉ុតុនៃខេត្ដឃឹម៉ាម៉ុតុ",
      "neName": "कुमामोतो जिल्ला, कुमामोतो क्षेत्र"
    },
    "class15": {
      "code": "430011",
      "name": "熊本市",
      "enName": "Kumamoto City"
    },
    "class20": {
      "code": "4310000",
      "name": "熊本市",
      "enName": "Kumamoto City",
      "kana": "くまもとし",
      "chName": "熊本市",
      "zhName": "熊本市",
      "koName": "구마모토시",
      "esName": "Ciudad de Kumamoto",
      "ptName": "Cidade de Kumamoto",
      "thName": "เมืองคุมาโมโตะ",
      "viName": "thành phố Kumamoto",
      "inName": "Kota Kumamoto",
      "tlName": "Lungsod ng Kumamoto",
      "moName": "Кумамото хот",
      "buName": "ကူမမိုတိုမြို့",
      "khName": "ទីក្រុង គូមាមូតូ",
      "neName": "कुमामोटो शहर"
    }
  },
  "4320211": {
    "office": {
      "code": "430000",
      "name": "熊本県",
      "enName": "Kumamoto",
      "officeName": "熊本地方気象台",
      "chName": "熊本县",
      "zhName": "熊本縣",
      "koName": "구마모토현",
      "esName": "Prefectura de Kumamoto",
      "ptName": "Província de Kumamoto",
      "thName": "จังหวัดคุมาโมโตะ",
      "viName": "Tỉnh Kumamoto",
      "inName": "Prefektur Kumamoto",
      "tlName": "Kumamoto Prefecture",
      "moName": "Күматомо аймаг",
      "buName": "ကူမာမိုတို ပြည်နယ်",
      "khName": "ខេត្ដ គូម៉ាម៉ូតូ",
      "neName": "कुमामोतो जिल्ला"
    },
    "class10": {
      "code": "430010",
      "name": "熊本地方",
      "enName": "Kumamoto Region",
      "chName": "熊本县熊本地方",
      "zhName": "熊本縣熊本地方",
      "koName": "구마모토 현 구마모토 지방",
      "esName": "Región Kumamoto, Prefectura de Kumamoto",
      "ptName": "Região de Kumamoto da Província de Kumamoto",
      "thName": "ท้องถิ่นคุมาโมโตะ จังหวัดคุมาโมโตะ",
      "viName": "Vùng Kumamoto, tỉnh Kumamoto",
      "inName": "Daerah Kumamoto di Prefektur Kumamoto",
      "tlName": "Rehiyon ng Kumamoto sa Kumamoto Prefecture ",
      "moName": "Күмамото аймаг, Күмамото муж",
      "buName": "ကုမမိုတိုဒေသ၊ ကုမမိုတိုစီရင်စု",
      "khName": "តំបន់ឃឹម៉ាម៉ុតុនៃខេត្ដឃឹម៉ាម៉ុតុ",
      "neName": "कुमामोतो जिल्ला, कुमामोतो क्षेत्र"
    },
    "class15": {
      "code": "430015",
      "name": "宇城八代",
      "enName": "Uki Yatsushiro"
    },
    "class20": {
      "code": "4320211",
      "name": "八代市西部",
      "enName": "Western Yatsushiro City",
      "kana": "やつしろしせいぶ"
    }
  },
  "4320212": {
    "office": {
      "code": "430000",
      "name": "熊本県",
      "enName": "Kumamoto",
      "officeName": "熊本地方気象台",
      "chName": "熊本县",
      "zhName": "熊本縣",
      "koName": "구마모토현",
      "esName": "Prefectura de Kumamoto",
      "ptName": "Província de Kumamoto",
      "thName": "จังหวัดคุมาโมโตะ",
      "viName": "Tỉnh Kumamoto",
      "inName": "Prefektur Kumamoto",
      "tlName": "Kumamoto Prefecture",
      "moName": "Күматомо аймаг",
      "buName": "ကူမာမိုတို ပြည်နယ်",
      "khName": "ខេត្ដ គូម៉ាម៉ូតូ",
      "neName": "कुमामोतो जिल्ला"
    },
    "class10": {
      "code": "430010",
      "name": "熊本地方",
      "enName": "Kumamoto Region",
      "chName": "熊本县熊本地方",
      "zhName": "熊本縣熊本地方",
      "koName": "구마모토 현 구마모토 지방",
      "esName": "Región Kumamoto, Prefectura de Kumamoto",
      "ptName": "Região de Kumamoto da Província de Kumamoto",
      "thName": "ท้องถิ่นคุมาโมโตะ จังหวัดคุมาโมโตะ",
      "viName": "Vùng Kumamoto, tỉnh Kumamoto",
      "inName": "Daerah Kumamoto di Prefektur Kumamoto",
      "tlName": "Rehiyon ng Kumamoto sa Kumamoto Prefecture ",
      "moName": "Күмамото аймаг, Күмамото муж",
      "buName": "ကုမမိုတိုဒေသ၊ ကုမမိုတိုစီရင်စု",
      "khName": "តំបន់ឃឹម៉ាម៉ុតុនៃខេត្ដឃឹម៉ាម៉ុតុ",
      "neName": "कुमामोतो जिल्ला, कुमामोतो क्षेत्र"
    },
    "class15": {
      "code": "430015",
      "name": "宇城八代",
      "enName": "Uki Yatsushiro"
    },
    "class20": {
      "code": "4320212",
      "name": "八代市東部",
      "enName": "Eastern Yatsushiro City",
      "kana": "やつしろしとうぶ"
    }
  },
  "4320300": {
    "office": {
      "code": "430000",
      "name": "熊本県",
      "enName": "Kumamoto",
      "officeName": "熊本地方気象台",
      "chName": "熊本县",
      "zhName": "熊本縣",
      "koName": "구마모토현",
      "esName": "Prefectura de Kumamoto",
      "ptName": "Província de Kumamoto",
      "thName": "จังหวัดคุมาโมโตะ",
      "viName": "Tỉnh Kumamoto",
      "inName": "Prefektur Kumamoto",
      "tlName": "Kumamoto Prefecture",
      "moName": "Күматомо аймаг",
      "buName": "ကူမာမိုတို ပြည်နယ်",
      "khName": "ខេត្ដ គូម៉ាម៉ូតូ",
      "neName": "कुमामोतो जिल्ला"
    },
    "class10": {
      "code": "430040",
      "name": "球磨地方",
      "enName": "Kuma Region",
      "chName": "熊本县球磨地方",
      "zhName": "熊本縣球磨地方",
      "koName": "쿠마모토현 구마 지방",
      "esName": "Región Kuma, Prefectura de Kumamoto",
      "ptName": "Região de Kuma da Província de Kumamoto",
      "thName": "ท้องถิ่นคุมะ จังหวัดคุมาโมโตะ",
      "viName": "Vùng Kuma, tỉnh Kumamoto",
      "inName": "Daerah Kuma di Prefektur Kumamoto",
      "tlName": "Rehiyon ng Kuma sa Kumamoto Prefecture",
      "moName": "Күмамото аймаг, Күма муж",
      "buName": "ကုမဒေသ၊ ကုမမိုတိုစီရင်စု",
      "khName": "តំបន់គឺម៉ានៃខេត្ដឃឹម៉ាម៉ុតុ",
      "neName": "कुमामोतो जिल्ला, कुमा क्षेत्र"
    },
    "class15": {
      "code": "430040",
      "name": "球磨地方",
      "enName": "Kuma Region"
    },
    "class20": {
      "code": "4320300",
      "name": "人吉市",
      "enName": "Hitoyoshi City",
      "kana": "ひとよしし",
      "chName": "人吉市",
      "zhName": "人吉市",
      "koName": "히토요시 시",
      "esName": "Ciudad de Hitoyoshi",
      "ptName": "cidade de Hitoyoshi",
      "thName": "เมืองฮิโตะโยชิ",
      "viName": "thành phố Hitoyoshi",
      "inName": "kota Hitoyoshi",
      "tlName": "siyudad ng Hitoyoshi",
      "moName": "Хитоёоши хот",
      "buName": "ဟီတိုရိုရှိ မြို့",
      "khName": "ទីក្រុង ហ៊ីតូយ៉ូស៊ី",
      "neName": "हितोयोसी सहर"
    }
  },
  "4320400": {
    "office": {
      "code": "430000",
      "name": "熊本県",
      "enName": "Kumamoto",
      "officeName": "熊本地方気象台",
      "chName": "熊本县",
      "zhName": "熊本縣",
      "koName": "구마모토현",
      "esName": "Prefectura de Kumamoto",
      "ptName": "Província de Kumamoto",
      "thName": "จังหวัดคุมาโมโตะ",
      "viName": "Tỉnh Kumamoto",
      "inName": "Prefektur Kumamoto",
      "tlName": "Kumamoto Prefecture",
      "moName": "Күматомо аймаг",
      "buName": "ကူမာမိုတို ပြည်နယ်",
      "khName": "ខេត្ដ គូម៉ាម៉ូតូ",
      "neName": "कुमामोतो जिल्ला"
    },
    "class10": {
      "code": "430010",
      "name": "熊本地方",
      "enName": "Kumamoto Region",
      "chName": "熊本县熊本地方",
      "zhName": "熊本縣熊本地方",
      "koName": "구마모토 현 구마모토 지방",
      "esName": "Región Kumamoto, Prefectura de Kumamoto",
      "ptName": "Região de Kumamoto da Província de Kumamoto",
      "thName": "ท้องถิ่นคุมาโมโตะ จังหวัดคุมาโมโตะ",
      "viName": "Vùng Kumamoto, tỉnh Kumamoto",
      "inName": "Daerah Kumamoto di Prefektur Kumamoto",
      "tlName": "Rehiyon ng Kumamoto sa Kumamoto Prefecture ",
      "moName": "Күмамото аймаг, Күмамото муж",
      "buName": "ကုမမိုတိုဒေသ၊ ကုမမိုတိုစီရင်စု",
      "khName": "តំបន់ឃឹម៉ាម៉ុតុនៃខេត្ដឃឹម៉ាម៉ុតុ",
      "neName": "कुमामोतो जिल्ला, कुमामोतो क्षेत्र"
    },
    "class15": {
      "code": "430013",
      "name": "荒尾玉名",
      "enName": "Arao Tamana"
    },
    "class20": {
      "code": "4320400",
      "name": "荒尾市",
      "enName": "Arao City",
      "kana": "あらおし",
      "chName": "荒尾市",
      "zhName": "荒尾市",
      "koName": "아라오 시",
      "esName": "Ciudad de Arao",
      "ptName": "cidade de Arao",
      "thName": "เมืองอาราโอะ",
      "viName": "thành phố Arao",
      "inName": "kota Arao",
      "tlName": "siyudad ng Arao",
      "moName": "Aрао хот",
      "buName": "အာရာ့အို့ မြို့",
      "khName": "ទីក្រុង អារ៉ៅ",
      "neName": "आराओ सहर"
    }
  },
  "4320500": {
    "office": {
      "code": "430000",
      "name": "熊本県",
      "enName": "Kumamoto",
      "officeName": "熊本地方気象台",
      "chName": "熊本县",
      "zhName": "熊本縣",
      "koName": "구마모토현",
      "esName": "Prefectura de Kumamoto",
      "ptName": "Província de Kumamoto",
      "thName": "จังหวัดคุมาโมโตะ",
      "viName": "Tỉnh Kumamoto",
      "inName": "Prefektur Kumamoto",
      "tlName": "Kumamoto Prefecture",
      "moName": "Күматомо аймаг",
      "buName": "ကူမာမိုတို ပြည်နယ်",
      "khName": "ខេត្ដ គូម៉ាម៉ូតូ",
      "neName": "कुमामोतो जिल्ला"
    },
    "class10": {
      "code": "430030",
      "name": "天草・芦北地方",
      "enName": "Amakusa Ashikita Region",
      "chName": "熊本县天草、芦北地方",
      "zhName": "熊本縣天草・蘆北地方",
      "koName": "구마모토 현 아마쿠사·아시 키타 지방",
      "esName": "Región Amakusa-Ashikita, Prefectura de Kumamoto",
      "ptName": "Região de Amakusa・Ashikita da Província de Kumamoto",
      "thName": "ท้องถิ่นอะมากุสะและอะชิกิตะ จังหวัดคุมาโมโตะ",
      "viName": "Vùng Amakusa và Ashikita, tỉnh Kumamoto",
      "inName": "Daerah Amakusa dan Ashikita di Prefektur Kumamoto",
      "tlName": "Rehiyon ng Amakusa at Ashikita sa Kumamoto Prefecture",
      "moName": "Күмамото аймаг, Амакүса・Ашикита муж",
      "buName": "အမကုဆ၊ အရှိခိတဒေသ၊ ကုမမိုတိုစီရင်စု",
      "khName": "តំបន់អាម៉ាគឹសា/អាស៊ីគីតាក់នៃខេត្ដឃឹម៉ាម៉ុតុ",
      "neName": "कुमामोतो जिल्ला, आमाकुसा र आसिकिता क्षेत्र"
    },
    "class15": {
      "code": "430032",
      "name": "芦北地方",
      "enName": "Ashikita Region"
    },
    "class20": {
      "code": "4320500",
      "name": "水俣市",
      "enName": "Minamata City",
      "kana": "みなまたし",
      "chName": "水俣市",
      "zhName": "水俁市",
      "koName": "미나마타 시",
      "esName": "Ciudad de Minamata",
      "ptName": "cidade de Minamata",
      "thName": "เมืองมินามาตะ",
      "viName": "thành phố Minamata",
      "inName": "kota Minamata",
      "tlName": "siyudad ng Minamata",
      "moName": "Минaмaта хот",
      "buName": "မီနားမာ့တ မြို့",
      "khName": "ទីក្រុង មីណាម៉ាតា",
      "neName": "मिनामाता सहर"
    }
  },
  "4320600": {
    "office": {
      "code": "430000",
      "name": "熊本県",
      "enName": "Kumamoto",
      "officeName": "熊本地方気象台",
      "chName": "熊本县",
      "zhName": "熊本縣",
      "koName": "구마모토현",
      "esName": "Prefectura de Kumamoto",
      "ptName": "Província de Kumamoto",
      "thName": "จังหวัดคุมาโมโตะ",
      "viName": "Tỉnh Kumamoto",
      "inName": "Prefektur Kumamoto",
      "tlName": "Kumamoto Prefecture",
      "moName": "Күматомо аймаг",
      "buName": "ကူမာမိုတို ပြည်နယ်",
      "khName": "ខេត្ដ គូម៉ាម៉ូតូ",
      "neName": "कुमामोतो जिल्ला"
    },
    "class10": {
      "code": "430010",
      "name": "熊本地方",
      "enName": "Kumamoto Region",
      "chName": "熊本县熊本地方",
      "zhName": "熊本縣熊本地方",
      "koName": "구마모토 현 구마모토 지방",
      "esName": "Región Kumamoto, Prefectura de Kumamoto",
      "ptName": "Região de Kumamoto da Província de Kumamoto",
      "thName": "ท้องถิ่นคุมาโมโตะ จังหวัดคุมาโมโตะ",
      "viName": "Vùng Kumamoto, tỉnh Kumamoto",
      "inName": "Daerah Kumamoto di Prefektur Kumamoto",
      "tlName": "Rehiyon ng Kumamoto sa Kumamoto Prefecture ",
      "moName": "Күмамото аймаг, Күмамото муж",
      "buName": "ကုမမိုတိုဒေသ၊ ကုမမိုတိုစီရင်စု",
      "khName": "តំបន់ឃឹម៉ាម៉ុតុនៃខេត្ដឃឹម៉ាម៉ុតុ",
      "neName": "कुमामोतो जिल्ला, कुमामोतो क्षेत्र"
    },
    "class15": {
      "code": "430013",
      "name": "荒尾玉名",
      "enName": "Arao Tamana"
    },
    "class20": {
      "code": "4320600",
      "name": "玉名市",
      "enName": "Tamana City",
      "kana": "たまなし",
      "chName": "玉名市",
      "zhName": "玉名市",
      "koName": "다마나 시",
      "esName": "Ciudad de Tamana",
      "ptName": "cidade de Tamana",
      "thName": "เมืองทามานะ",
      "viName": "thành phố Tamana",
      "inName": "kota Tamana",
      "tlName": "siyudad ng Tamana",
      "moName": "Tамaнa хот",
      "buName": "တားမာ့န မြို့",
      "khName": "ទីក្រុង តាម៉ាណា",
      "neName": "तामाना सहर"
    }
  },
  "4320800": {
    "office": {
      "code": "430000",
      "name": "熊本県",
      "enName": "Kumamoto",
      "officeName": "熊本地方気象台",
      "chName": "熊本县",
      "zhName": "熊本縣",
      "koName": "구마모토현",
      "esName": "Prefectura de Kumamoto",
      "ptName": "Província de Kumamoto",
      "thName": "จังหวัดคุมาโมโตะ",
      "viName": "Tỉnh Kumamoto",
      "inName": "Prefektur Kumamoto",
      "tlName": "Kumamoto Prefecture",
      "moName": "Күматомо аймаг",
      "buName": "ကူမာမိုတို ပြည်နယ်",
      "khName": "ខេត្ដ គូម៉ាម៉ូតូ",
      "neName": "कुमामोतो जिल्ला"
    },
    "class10": {
      "code": "430010",
      "name": "熊本地方",
      "enName": "Kumamoto Region",
      "chName": "熊本县熊本地方",
      "zhName": "熊本縣熊本地方",
      "koName": "구마모토 현 구마모토 지방",
      "esName": "Región Kumamoto, Prefectura de Kumamoto",
      "ptName": "Região de Kumamoto da Província de Kumamoto",
      "thName": "ท้องถิ่นคุมาโมโตะ จังหวัดคุมาโมโตะ",
      "viName": "Vùng Kumamoto, tỉnh Kumamoto",
      "inName": "Daerah Kumamoto di Prefektur Kumamoto",
      "tlName": "Rehiyon ng Kumamoto sa Kumamoto Prefecture ",
      "moName": "Күмамото аймаг, Күмамото муж",
      "buName": "ကုမမိုတိုဒေသ၊ ကုမမိုတိုစီရင်စု",
      "khName": "តំបន់ឃឹម៉ាម៉ុតុនៃខេត្ដឃឹម៉ាម៉ុតុ",
      "neName": "कुमामोतो जिल्ला, कुमामोतो क्षेत्र"
    },
    "class15": {
      "code": "430012",
      "name": "山鹿菊池",
      "enName": "Yamaga Kikuchi"
    },
    "class20": {
      "code": "4320800",
      "name": "山鹿市",
      "enName": "Yamaga City",
      "kana": "やまがし",
      "chName": "山鹿市",
      "zhName": "山鹿市",
      "koName": "야마가 시",
      "esName": "Ciudad de Yamaga",
      "ptName": "cidade de Yamaga",
      "thName": "เมืองยามางะ",
      "viName": "thành phố Yamaga",
      "inName": "kota Yamaga",
      "tlName": "siyudad ng Yamaga",
      "moName": "Ямaгa хот",
      "buName": "ယားမာ့ဂ မြို့",
      "khName": "ទីក្រុង យ៉ាម៉ាហ្គា",
      "neName": "यामागा सहर"
    }
  },
  "4321000": {
    "office": {
      "code": "430000",
      "name": "熊本県",
      "enName": "Kumamoto",
      "officeName": "熊本地方気象台",
      "chName": "熊本县",
      "zhName": "熊本縣",
      "koName": "구마모토현",
      "esName": "Prefectura de Kumamoto",
      "ptName": "Província de Kumamoto",
      "thName": "จังหวัดคุมาโมโตะ",
      "viName": "Tỉnh Kumamoto",
      "inName": "Prefektur Kumamoto",
      "tlName": "Kumamoto Prefecture",
      "moName": "Күматомо аймаг",
      "buName": "ကူမာမိုတို ပြည်နယ်",
      "khName": "ខេត្ដ គូម៉ាម៉ូតូ",
      "neName": "कुमामोतो जिल्ला"
    },
    "class10": {
      "code": "430010",
      "name": "熊本地方",
      "enName": "Kumamoto Region",
      "chName": "熊本县熊本地方",
      "zhName": "熊本縣熊本地方",
      "koName": "구마모토 현 구마모토 지방",
      "esName": "Región Kumamoto, Prefectura de Kumamoto",
      "ptName": "Região de Kumamoto da Província de Kumamoto",
      "thName": "ท้องถิ่นคุมาโมโตะ จังหวัดคุมาโมโตะ",
      "viName": "Vùng Kumamoto, tỉnh Kumamoto",
      "inName": "Daerah Kumamoto di Prefektur Kumamoto",
      "tlName": "Rehiyon ng Kumamoto sa Kumamoto Prefecture ",
      "moName": "Күмамото аймаг, Күмамото муж",
      "buName": "ကုမမိုတိုဒေသ၊ ကုမမိုတိုစီရင်စု",
      "khName": "តំបន់ឃឹម៉ាម៉ុតុនៃខេត្ដឃឹម៉ាម៉ុតុ",
      "neName": "कुमामोतो जिल्ला, कुमामोतो क्षेत्र"
    },
    "class15": {
      "code": "430012",
      "name": "山鹿菊池",
      "enName": "Yamaga Kikuchi"
    },
    "class20": {
      "code": "4321000",
      "name": "菊池市",
      "enName": "Kikuchi City",
      "kana": "きくちし",
      "chName": "菊池市",
      "zhName": "菊池市",
      "koName": "기쿠치 시",
      "esName": "Ciudad de Kikuchi",
      "ptName": "cidade de Kikuchi",
      "thName": "เมืองคิคุจิ",
      "viName": "thành phố Kikuchi",
      "inName": "kota Kikuchi",
      "tlName": "siyudad ng Kikuchi",
      "moName": "Кикүчи хот",
      "buName": "ခီကုကျိ မြို့",
      "khName": "ទីក្រុង គីគុជី",
      "neName": "किकुची सहर"
    }
  },
  "4321100": {
    "office": {
      "code": "430000",
      "name": "熊本県",
      "enName": "Kumamoto",
      "officeName": "熊本地方気象台",
      "chName": "熊本县",
      "zhName": "熊本縣",
      "koName": "구마모토현",
      "esName": "Prefectura de Kumamoto",
      "ptName": "Província de Kumamoto",
      "thName": "จังหวัดคุมาโมโตะ",
      "viName": "Tỉnh Kumamoto",
      "inName": "Prefektur Kumamoto",
      "tlName": "Kumamoto Prefecture",
      "moName": "Күматомо аймаг",
      "buName": "ကူမာမိုတို ပြည်နယ်",
      "khName": "ខេត្ដ គូម៉ាម៉ូតូ",
      "neName": "कुमामोतो जिल्ला"
    },
    "class10": {
      "code": "430010",
      "name": "熊本地方",
      "enName": "Kumamoto Region",
      "chName": "熊本县熊本地方",
      "zhName": "熊本縣熊本地方",
      "koName": "구마모토 현 구마모토 지방",
      "esName": "Región Kumamoto, Prefectura de Kumamoto",
      "ptName": "Região de Kumamoto da Província de Kumamoto",
      "thName": "ท้องถิ่นคุมาโมโตะ จังหวัดคุมาโมโตะ",
      "viName": "Vùng Kumamoto, tỉnh Kumamoto",
      "inName": "Daerah Kumamoto di Prefektur Kumamoto",
      "tlName": "Rehiyon ng Kumamoto sa Kumamoto Prefecture ",
      "moName": "Күмамото аймаг, Күмамото муж",
      "buName": "ကုမမိုတိုဒေသ၊ ကုမမိုတိုစီရင်စု",
      "khName": "តំបន់ឃឹម៉ាម៉ុតុនៃខេត្ដឃឹម៉ាម៉ុតុ",
      "neName": "कुमामोतो जिल्ला, कुमामोतो क्षेत्र"
    },
    "class15": {
      "code": "430015",
      "name": "宇城八代",
      "enName": "Uki Yatsushiro"
    },
    "class20": {
      "code": "4321100",
      "name": "宇土市",
      "enName": "Uto City",
      "kana": "うとし",
      "chName": "宇土市",
      "zhName": "宇土市",
      "koName": "우토 시",
      "esName": "Ciudad de Uto",
      "ptName": "cidade de Uto",
      "thName": "เมืองอุโตะ",
      "viName": "thành phố Uto",
      "inName": "kota Uto",
      "tlName": "siyudad ng Uto",
      "moName": "Үто хот",
      "buName": "အုတို မြို့",
      "khName": "ទីក្រុង យូតូ",
      "neName": "उतो सहर"
    }
  },
  "4321200": {
    "office": {
      "code": "430000",
      "name": "熊本県",
      "enName": "Kumamoto",
      "officeName": "熊本地方気象台",
      "chName": "熊本县",
      "zhName": "熊本縣",
      "koName": "구마모토현",
      "esName": "Prefectura de Kumamoto",
      "ptName": "Província de Kumamoto",
      "thName": "จังหวัดคุมาโมโตะ",
      "viName": "Tỉnh Kumamoto",
      "inName": "Prefektur Kumamoto",
      "tlName": "Kumamoto Prefecture",
      "moName": "Күматомо аймаг",
      "buName": "ကူမာမိုတို ပြည်နယ်",
      "khName": "ខេត្ដ គូម៉ាម៉ូតូ",
      "neName": "कुमामोतो जिल्ला"
    },
    "class10": {
      "code": "430030",
      "name": "天草・芦北地方",
      "enName": "Amakusa Ashikita Region",
      "chName": "熊本县天草、芦北地方",
      "zhName": "熊本縣天草・蘆北地方",
      "koName": "구마모토 현 아마쿠사·아시 키타 지방",
      "esName": "Región Amakusa-Ashikita, Prefectura de Kumamoto",
      "ptName": "Região de Amakusa・Ashikita da Província de Kumamoto",
      "thName": "ท้องถิ่นอะมากุสะและอะชิกิตะ จังหวัดคุมาโมโตะ",
      "viName": "Vùng Amakusa và Ashikita, tỉnh Kumamoto",
      "inName": "Daerah Amakusa dan Ashikita di Prefektur Kumamoto",
      "tlName": "Rehiyon ng Amakusa at Ashikita sa Kumamoto Prefecture",
      "moName": "Күмамото аймаг, Амакүса・Ашикита муж",
      "buName": "အမကုဆ၊ အရှိခိတဒေသ၊ ကုမမိုတိုစီရင်စု",
      "khName": "តំបន់អាម៉ាគឹសា/អាស៊ីគីតាក់នៃខេត្ដឃឹម៉ាម៉ុតុ",
      "neName": "कुमामोतो जिल्ला, आमाकुसा र आसिकिता क्षेत्र"
    },
    "class15": {
      "code": "430031",
      "name": "天草地方",
      "enName": "Amakusa Region"
    },
    "class20": {
      "code": "4321200",
      "name": "上天草市",
      "enName": "Kamiamakusa City",
      "kana": "かみあまくさし",
      "chName": "山天草市",
      "zhName": "上天草市",
      "koName": "가미아마쿠사 시",
      "esName": "Ciudad de Kami-amakusa",
      "ptName": "cidade de Kamiamakusa",
      "thName": "เมืองคามิอามะคุสะ",
      "viName": "thành phố Kamiamakusa",
      "inName": "kota Kamiamakusa",
      "tlName": "siyudad ng Kamiamakusa",
      "moName": "Камкамиaмaкүсa хот",
      "buName": "ခါမီယာမာ့ကုဆ မြို့",
      "khName": "ទីក្រុង កាមីអាម៉ាគូសា",
      "neName": "कामियामाकुसा सहर"
    }
  },
  "4321300": {
    "office": {
      "code": "430000",
      "name": "熊本県",
      "enName": "Kumamoto",
      "officeName": "熊本地方気象台",
      "chName": "熊本县",
      "zhName": "熊本縣",
      "koName": "구마모토현",
      "esName": "Prefectura de Kumamoto",
      "ptName": "Província de Kumamoto",
      "thName": "จังหวัดคุมาโมโตะ",
      "viName": "Tỉnh Kumamoto",
      "inName": "Prefektur Kumamoto",
      "tlName": "Kumamoto Prefecture",
      "moName": "Күматомо аймаг",
      "buName": "ကူမာမိုတို ပြည်နယ်",
      "khName": "ខេត្ដ គូម៉ាម៉ូតូ",
      "neName": "कुमामोतो जिल्ला"
    },
    "class10": {
      "code": "430010",
      "name": "熊本地方",
      "enName": "Kumamoto Region",
      "chName": "熊本县熊本地方",
      "zhName": "熊本縣熊本地方",
      "koName": "구마모토 현 구마모토 지방",
      "esName": "Región Kumamoto, Prefectura de Kumamoto",
      "ptName": "Região de Kumamoto da Província de Kumamoto",
      "thName": "ท้องถิ่นคุมาโมโตะ จังหวัดคุมาโมโตะ",
      "viName": "Vùng Kumamoto, tỉnh Kumamoto",
      "inName": "Daerah Kumamoto di Prefektur Kumamoto",
      "tlName": "Rehiyon ng Kumamoto sa Kumamoto Prefecture ",
      "moName": "Күмамото аймаг, Күмамото муж",
      "buName": "ကုမမိုတိုဒေသ၊ ကုမမိုတိုစီရင်စု",
      "khName": "តំបន់ឃឹម៉ាម៉ុតុនៃខេត្ដឃឹម៉ាម៉ុតុ",
      "neName": "कुमामोतो जिल्ला, कुमामोतो क्षेत्र"
    },
    "class15": {
      "code": "430015",
      "name": "宇城八代",
      "enName": "Uki Yatsushiro"
    },
    "class20": {
      "code": "4321300",
      "name": "宇城市",
      "enName": "Uki City",
      "kana": "うきし",
      "chName": "宇城市",
      "zhName": "宇城市",
      "koName": "우키 시",
      "esName": "Ciudad de Uki",
      "ptName": "cidade de Uki",
      "thName": "เมืองอุกิ",
      "viName": "thành phố Uki",
      "inName": "kota Uki",
      "tlName": "siyudad ng Uki",
      "moName": "Үки хот",
      "buName": "အုကိ မြို့",
      "khName": "ទីក្រុង យូគី",
      "neName": "उकी सहर"
    }
  },
  "4321400": {
    "office": {
      "code": "430000",
      "name": "熊本県",
      "enName": "Kumamoto",
      "officeName": "熊本地方気象台",
      "chName": "熊本县",
      "zhName": "熊本縣",
      "koName": "구마모토현",
      "esName": "Prefectura de Kumamoto",
      "ptName": "Província de Kumamoto",
      "thName": "จังหวัดคุมาโมโตะ",
      "viName": "Tỉnh Kumamoto",
      "inName": "Prefektur Kumamoto",
      "tlName": "Kumamoto Prefecture",
      "moName": "Күматомо аймаг",
      "buName": "ကူမာမိုတို ပြည်နယ်",
      "khName": "ខេត្ដ គូម៉ាម៉ូតូ",
      "neName": "कुमामोतो जिल्ला"
    },
    "class10": {
      "code": "430020",
      "name": "阿蘇地方",
      "enName": "Aso Region",
      "chName": "熊本县阿苏地方",
      "zhName": "熊本縣阿蘇地方",
      "koName": "구마모토 현 아소 지방",
      "esName": "Región Aso, Prefectura de Kumamoto",
      "ptName": "Região de  Aso da Província de Kumamoto",
      "thName": "ท้องถิ่นอะโซะ จังหวัดคุมาโมโตะ",
      "viName": "Vùng Aso, tỉnh Kumamoto",
      "inName": "Daerah Aso di Prefektur Kumamoto",
      "tlName": "Rehiyon ng Aso sa Kumamoto Prefecture",
      "moName": "Күмамото аймаг, Асо муж",
      "buName": "အဆိုဒေသ၊ ကုမမိုတိုစီရင်စု",
      "khName": "តំបន់អាសូនៃខេត្ដឃឹម៉ាម៉ុតុ",
      "neName": "कुमामोतो जिल्ला, आसो क्षेत्र"
    },
    "class15": {
      "code": "430020",
      "name": "阿蘇地方",
      "enName": "Aso Region"
    },
    "class20": {
      "code": "4321400",
      "name": "阿蘇市",
      "enName": "Aso City",
      "kana": "あそし",
      "chName": "阿苏市",
      "zhName": "阿蘇市",
      "koName": "아소 시",
      "esName": "Ciudad de Aso",
      "ptName": "cidade de Aso",
      "thName": "เมืองอะโซ",
      "viName": "thành phố Aso",
      "inName": "kota Aso",
      "tlName": "siyudad ng Aso",
      "moName": "Aсо хот",
      "buName": "အေဆို မြို့",
      "khName": "ទីក្រុង អាសូ",
      "neName": "आसो सहर"
    }
  },
  "4321500": {
    "office": {
      "code": "430000",
      "name": "熊本県",
      "enName": "Kumamoto",
      "officeName": "熊本地方気象台",
      "chName": "熊本县",
      "zhName": "熊本縣",
      "koName": "구마모토현",
      "esName": "Prefectura de Kumamoto",
      "ptName": "Província de Kumamoto",
      "thName": "จังหวัดคุมาโมโตะ",
      "viName": "Tỉnh Kumamoto",
      "inName": "Prefektur Kumamoto",
      "tlName": "Kumamoto Prefecture",
      "moName": "Күматомо аймаг",
      "buName": "ကူမာမိုတို ပြည်နယ်",
      "khName": "ខេត្ដ គូម៉ាម៉ូតូ",
      "neName": "कुमामोतो जिल्ला"
    },
    "class10": {
      "code": "430030",
      "name": "天草・芦北地方",
      "enName": "Amakusa Ashikita Region",
      "chName": "熊本县天草、芦北地方",
      "zhName": "熊本縣天草・蘆北地方",
      "koName": "구마모토 현 아마쿠사·아시 키타 지방",
      "esName": "Región Amakusa-Ashikita, Prefectura de Kumamoto",
      "ptName": "Região de Amakusa・Ashikita da Província de Kumamoto",
      "thName": "ท้องถิ่นอะมากุสะและอะชิกิตะ จังหวัดคุมาโมโตะ",
      "viName": "Vùng Amakusa và Ashikita, tỉnh Kumamoto",
      "inName": "Daerah Amakusa dan Ashikita di Prefektur Kumamoto",
      "tlName": "Rehiyon ng Amakusa at Ashikita sa Kumamoto Prefecture",
      "moName": "Күмамото аймаг, Амакүса・Ашикита муж",
      "buName": "အမကုဆ၊ အရှိခိတဒေသ၊ ကုမမိုတိုစီရင်စု",
      "khName": "តំបន់អាម៉ាគឹសា/អាស៊ីគីតាក់នៃខេត្ដឃឹម៉ាម៉ុតុ",
      "neName": "कुमामोतो जिल्ला, आमाकुसा र आसिकिता क्षेत्र"
    },
    "class15": {
      "code": "430031",
      "name": "天草地方",
      "enName": "Amakusa Region"
    },
    "class20": {
      "code": "4321500",
      "name": "天草市",
      "enName": "Amakusa City",
      "kana": "あまくさし",
      "chName": "天草市",
      "zhName": "天草市",
      "koName": "아마쿠사 시",
      "esName": "Ciudad  de Amakusa",
      "ptName": "cidade de Amakusa",
      "thName": "เมืออะมาคุสะ",
      "viName": "thành phố Amakusa",
      "inName": "kota Amakusa",
      "tlName": "siyudad ng Amakusa",
      "moName": "Aмaкүсa хот",
      "buName": "အာမာ့ကုဆ မြို့",
      "khName": "ទីក្រុង អាម៉ាគូសា",
      "neName": "आमाकुसा सहर"
    }
  },
  "4321600": {
    "office": {
      "code": "430000",
      "name": "熊本県",
      "enName": "Kumamoto",
      "officeName": "熊本地方気象台",
      "chName": "熊本县",
      "zhName": "熊本縣",
      "koName": "구마모토현",
      "esName": "Prefectura de Kumamoto",
      "ptName": "Província de Kumamoto",
      "thName": "จังหวัดคุมาโมโตะ",
      "viName": "Tỉnh Kumamoto",
      "inName": "Prefektur Kumamoto",
      "tlName": "Kumamoto Prefecture",
      "moName": "Күматомо аймаг",
      "buName": "ကူမာမိုတို ပြည်နယ်",
      "khName": "ខេត្ដ គូម៉ាម៉ូតូ",
      "neName": "कुमामोतो जिल्ला"
    },
    "class10": {
      "code": "430010",
      "name": "熊本地方",
      "enName": "Kumamoto Region",
      "chName": "熊本县熊本地方",
      "zhName": "熊本縣熊本地方",
      "koName": "구마모토 현 구마모토 지방",
      "esName": "Región Kumamoto, Prefectura de Kumamoto",
      "ptName": "Região de Kumamoto da Província de Kumamoto",
      "thName": "ท้องถิ่นคุมาโมโตะ จังหวัดคุมาโมโตะ",
      "viName": "Vùng Kumamoto, tỉnh Kumamoto",
      "inName": "Daerah Kumamoto di Prefektur Kumamoto",
      "tlName": "Rehiyon ng Kumamoto sa Kumamoto Prefecture ",
      "moName": "Күмамото аймаг, Күмамото муж",
      "buName": "ကုမမိုတိုဒေသ၊ ကုမမိုတိုစီရင်စု",
      "khName": "តំបន់ឃឹម៉ាម៉ុតុនៃខេត្ដឃឹម៉ាម៉ុតុ",
      "neName": "कुमामोतो जिल्ला, कुमामोतो क्षेत्र"
    },
    "class15": {
      "code": "430012",
      "name": "山鹿菊池",
      "enName": "Yamaga Kikuchi"
    },
    "class20": {
      "code": "4321600",
      "name": "合志市",
      "enName": "Koshi City",
      "kana": "こうしし",
      "chName": "合志市",
      "zhName": "合志市",
      "koName": "고시 시",
      "esName": "Ciudad de Koshi",
      "ptName": "cidade de Koshi",
      "thName": "เมืองโคชิ",
      "viName": "thành phố Koshi",
      "inName": "kota Koshi",
      "tlName": "siyudad ng Koshi",
      "moName": "Коши хот",
      "buName": "ကိုရှိ မြို့",
      "khName": "ទីក្រុង កូស៊ី",
      "neName": "कोशि सहर"
    }
  },
  "4334800": {
    "office": {
      "code": "430000",
      "name": "熊本県",
      "enName": "Kumamoto",
      "officeName": "熊本地方気象台",
      "chName": "熊本县",
      "zhName": "熊本縣",
      "koName": "구마모토현",
      "esName": "Prefectura de Kumamoto",
      "ptName": "Província de Kumamoto",
      "thName": "จังหวัดคุมาโมโตะ",
      "viName": "Tỉnh Kumamoto",
      "inName": "Prefektur Kumamoto",
      "tlName": "Kumamoto Prefecture",
      "moName": "Күматомо аймаг",
      "buName": "ကူမာမိုတို ပြည်နယ်",
      "khName": "ខេត្ដ គូម៉ាម៉ូតូ",
      "neName": "कुमामोतो जिल्ला"
    },
    "class10": {
      "code": "430010",
      "name": "熊本地方",
      "enName": "Kumamoto Region",
      "chName": "熊本县熊本地方",
      "zhName": "熊本縣熊本地方",
      "koName": "구마모토 현 구마모토 지방",
      "esName": "Región Kumamoto, Prefectura de Kumamoto",
      "ptName": "Região de Kumamoto da Província de Kumamoto",
      "thName": "ท้องถิ่นคุมาโมโตะ จังหวัดคุมาโมโตะ",
      "viName": "Vùng Kumamoto, tỉnh Kumamoto",
      "inName": "Daerah Kumamoto di Prefektur Kumamoto",
      "tlName": "Rehiyon ng Kumamoto sa Kumamoto Prefecture ",
      "moName": "Күмамото аймаг, Күмамото муж",
      "buName": "ကုမမိုတိုဒေသ၊ ကုမမိုတိုစီရင်စု",
      "khName": "តំបន់ឃឹម៉ាម៉ុតុនៃខេត្ដឃឹម៉ាម៉ុតុ",
      "neName": "कुमामोतो जिल्ला, कुमामोतो क्षेत्र"
    },
    "class15": {
      "code": "430015",
      "name": "宇城八代",
      "enName": "Uki Yatsushiro"
    },
    "class20": {
      "code": "4334800",
      "name": "美里町",
      "enName": "Misato Town",
      "kana": "みさとまち",
      "chName": "熊本美里町",
      "zhName": "熊本美裡町",
      "koName": "쿠마모토 미사토 정",
      "esName": "Pueblo de Misato, Kumamoto",
      "ptName": "Kumamoto, bairro de Misato",
      "thName": "เมืองมิซาโตะ คุมาโมโตะ",
      "viName": "Thị trấn Misato, Kumamoto",
      "inName": "Kota Misato, Kumamoto",
      "tlName": "bayan ng Misato, Kumamoto",
      "moName": "Күмамото Мисато жижиг хот",
      "buName": "ခုမမိုတိုမဆတိုမြို့နယ်",
      "khName": "ទីប្រជុំជនមីសាតូ ឃឹម៉ាម៉ុតុ",
      "neName": "कुमामोतो मिसातो नगर"
    }
  },
  "4336400": {
    "office": {
      "code": "430000",
      "name": "熊本県",
      "enName": "Kumamoto",
      "officeName": "熊本地方気象台",
      "chName": "熊本县",
      "zhName": "熊本縣",
      "koName": "구마모토현",
      "esName": "Prefectura de Kumamoto",
      "ptName": "Província de Kumamoto",
      "thName": "จังหวัดคุมาโมโตะ",
      "viName": "Tỉnh Kumamoto",
      "inName": "Prefektur Kumamoto",
      "tlName": "Kumamoto Prefecture",
      "moName": "Күматомо аймаг",
      "buName": "ကူမာမိုတို ပြည်နယ်",
      "khName": "ខេត្ដ គូម៉ាម៉ូតូ",
      "neName": "कुमामोतो जिल्ला"
    },
    "class10": {
      "code": "430010",
      "name": "熊本地方",
      "enName": "Kumamoto Region",
      "chName": "熊本县熊本地方",
      "zhName": "熊本縣熊本地方",
      "koName": "구마모토 현 구마모토 지방",
      "esName": "Región Kumamoto, Prefectura de Kumamoto",
      "ptName": "Região de Kumamoto da Província de Kumamoto",
      "thName": "ท้องถิ่นคุมาโมโตะ จังหวัดคุมาโมโตะ",
      "viName": "Vùng Kumamoto, tỉnh Kumamoto",
      "inName": "Daerah Kumamoto di Prefektur Kumamoto",
      "tlName": "Rehiyon ng Kumamoto sa Kumamoto Prefecture ",
      "moName": "Күмамото аймаг, Күмамото муж",
      "buName": "ကုမမိုတိုဒေသ၊ ကုမမိုတိုစီရင်စု",
      "khName": "តំបន់ឃឹម៉ាម៉ុតុនៃខេត្ដឃឹម៉ាម៉ុតុ",
      "neName": "कुमामोतो जिल्ला, कुमामोतो क्षेत्र"
    },
    "class15": {
      "code": "430013",
      "name": "荒尾玉名",
      "enName": "Arao Tamana"
    },
    "class20": {
      "code": "4336400",
      "name": "玉東町",
      "enName": "Gyokuto Town",
      "kana": "ぎょくとうまち",
      "chName": "玉东町",
      "zhName": "玉東町",
      "koName": "교쿠토 정",
      "esName": "Pueblo de Gyokuto",
      "ptName": "bairro de Gyokuto",
      "thName": "เมืองเกียวคุโตะ",
      "viName": "thị trấn Gyokuto",
      "inName": "kota Gyokuto",
      "tlName": "bayan ng Gyokuto",
      "moName": "Гёкүто жижиг хот",
      "buName": "ယိုးခုတို မြို့နယ်",
      "khName": "ទីប្រជុំជន ឃ្យូគុតូ",
      "neName": "ग्योकुतो नगर"
    }
  },
  "4336700": {
    "office": {
      "code": "430000",
      "name": "熊本県",
      "enName": "Kumamoto",
      "officeName": "熊本地方気象台",
      "chName": "熊本县",
      "zhName": "熊本縣",
      "koName": "구마모토현",
      "esName": "Prefectura de Kumamoto",
      "ptName": "Província de Kumamoto",
      "thName": "จังหวัดคุมาโมโตะ",
      "viName": "Tỉnh Kumamoto",
      "inName": "Prefektur Kumamoto",
      "tlName": "Kumamoto Prefecture",
      "moName": "Күматомо аймаг",
      "buName": "ကူမာမိုတို ပြည်နယ်",
      "khName": "ខេត្ដ គូម៉ាម៉ូតូ",
      "neName": "कुमामोतो जिल्ला"
    },
    "class10": {
      "code": "430010",
      "name": "熊本地方",
      "enName": "Kumamoto Region",
      "chName": "熊本县熊本地方",
      "zhName": "熊本縣熊本地方",
      "koName": "구마모토 현 구마모토 지방",
      "esName": "Región Kumamoto, Prefectura de Kumamoto",
      "ptName": "Região de Kumamoto da Província de Kumamoto",
      "thName": "ท้องถิ่นคุมาโมโตะ จังหวัดคุมาโมโตะ",
      "viName": "Vùng Kumamoto, tỉnh Kumamoto",
      "inName": "Daerah Kumamoto di Prefektur Kumamoto",
      "tlName": "Rehiyon ng Kumamoto sa Kumamoto Prefecture ",
      "moName": "Күмамото аймаг, Күмамото муж",
      "buName": "ကုမမိုတိုဒေသ၊ ကုမမိုတိုစီရင်စု",
      "khName": "តំបន់ឃឹម៉ាម៉ុតុនៃខេត្ដឃឹម៉ាម៉ុតុ",
      "neName": "कुमामोतो जिल्ला, कुमामोतो क्षेत्र"
    },
    "class15": {
      "code": "430013",
      "name": "荒尾玉名",
      "enName": "Arao Tamana"
    },
    "class20": {
      "code": "4336700",
      "name": "南関町",
      "enName": "Nankan Town",
      "kana": "なんかんまち",
      "chName": "南关町",
      "zhName": "南關町",
      "koName": "난칸 정",
      "esName": "Pueblo de Nankan",
      "ptName": "bairro de Nankan",
      "thName": "เมืองนันคัง",
      "viName": "thị trấn Nankan",
      "inName": "kota Nankan",
      "tlName": "bayan ng Nankan",
      "moName": "Нaнкан жижиг хот",
      "buName": "နန်ကန်း မြို့နယ်",
      "khName": "ទីប្រជុំជន ណានកាន",
      "neName": "नानकान नगर"
    }
  },
  "4336800": {
    "office": {
      "code": "430000",
      "name": "熊本県",
      "enName": "Kumamoto",
      "officeName": "熊本地方気象台",
      "chName": "熊本县",
      "zhName": "熊本縣",
      "koName": "구마모토현",
      "esName": "Prefectura de Kumamoto",
      "ptName": "Província de Kumamoto",
      "thName": "จังหวัดคุมาโมโตะ",
      "viName": "Tỉnh Kumamoto",
      "inName": "Prefektur Kumamoto",
      "tlName": "Kumamoto Prefecture",
      "moName": "Күматомо аймаг",
      "buName": "ကူမာမိုတို ပြည်နယ်",
      "khName": "ខេត្ដ គូម៉ាម៉ូតូ",
      "neName": "कुमामोतो जिल्ला"
    },
    "class10": {
      "code": "430010",
      "name": "熊本地方",
      "enName": "Kumamoto Region",
      "chName": "熊本县熊本地方",
      "zhName": "熊本縣熊本地方",
      "koName": "구마모토 현 구마모토 지방",
      "esName": "Región Kumamoto, Prefectura de Kumamoto",
      "ptName": "Região de Kumamoto da Província de Kumamoto",
      "thName": "ท้องถิ่นคุมาโมโตะ จังหวัดคุมาโมโตะ",
      "viName": "Vùng Kumamoto, tỉnh Kumamoto",
      "inName": "Daerah Kumamoto di Prefektur Kumamoto",
      "tlName": "Rehiyon ng Kumamoto sa Kumamoto Prefecture ",
      "moName": "Күмамото аймаг, Күмамото муж",
      "buName": "ကုမမိုတိုဒေသ၊ ကုမမိုတိုစီရင်စု",
      "khName": "តំបន់ឃឹម៉ាម៉ុតុនៃខេត្ដឃឹម៉ាម៉ុតុ",
      "neName": "कुमामोतो जिल्ला, कुमामोतो क्षेत्र"
    },
    "class15": {
      "code": "430013",
      "name": "荒尾玉名",
      "enName": "Arao Tamana"
    },
    "class20": {
      "code": "4336800",
      "name": "長洲町",
      "enName": "Nagasu Town",
      "kana": "ながすまち",
      "chName": "长洲町",
      "zhName": "長洲町",
      "koName": "나가스 정",
      "esName": "Pueblo de Nagasu",
      "ptName": "bairro de Nagasu",
      "thName": "เมืองนางาสุ",
      "viName": "thị trấn Nagasu",
      "inName": "kota Nagasu",
      "tlName": "bayan ng Nagasu",
      "moName": "Нaгaсү жижиг хот",
      "buName": "နာဂါ့ဆု မြို့နယ်",
      "khName": "ទីប្រជុំជន ណាហ្គាស៊ូ",
      "neName": "नागासु नगर"
    }
  },
  "4336900": {
    "office": {
      "code": "430000",
      "name": "熊本県",
      "enName": "Kumamoto",
      "officeName": "熊本地方気象台",
      "chName": "熊本县",
      "zhName": "熊本縣",
      "koName": "구마모토현",
      "esName": "Prefectura de Kumamoto",
      "ptName": "Província de Kumamoto",
      "thName": "จังหวัดคุมาโมโตะ",
      "viName": "Tỉnh Kumamoto",
      "inName": "Prefektur Kumamoto",
      "tlName": "Kumamoto Prefecture",
      "moName": "Күматомо аймаг",
      "buName": "ကူမာမိုတို ပြည်နယ်",
      "khName": "ខេត្ដ គូម៉ាម៉ូតូ",
      "neName": "कुमामोतो जिल्ला"
    },
    "class10": {
      "code": "430010",
      "name": "熊本地方",
      "enName": "Kumamoto Region",
      "chName": "熊本县熊本地方",
      "zhName": "熊本縣熊本地方",
      "koName": "구마모토 현 구마모토 지방",
      "esName": "Región Kumamoto, Prefectura de Kumamoto",
      "ptName": "Região de Kumamoto da Província de Kumamoto",
      "thName": "ท้องถิ่นคุมาโมโตะ จังหวัดคุมาโมโตะ",
      "viName": "Vùng Kumamoto, tỉnh Kumamoto",
      "inName": "Daerah Kumamoto di Prefektur Kumamoto",
      "tlName": "Rehiyon ng Kumamoto sa Kumamoto Prefecture ",
      "moName": "Күмамото аймаг, Күмамото муж",
      "buName": "ကုမမိုတိုဒေသ၊ ကုမမိုတိုစီရင်စု",
      "khName": "តំបន់ឃឹម៉ាម៉ុតុនៃខេត្ដឃឹម៉ាម៉ុតុ",
      "neName": "कुमामोतो जिल्ला, कुमामोतो क्षेत्र"
    },
    "class15": {
      "code": "430013",
      "name": "荒尾玉名",
      "enName": "Arao Tamana"
    },
    "class20": {
      "code": "4336900",
      "name": "和水町",
      "enName": "Nagomi Town",
      "kana": "なごみまち",
      "chName": "和水町",
      "zhName": "和水町",
      "koName": "나고미 정",
      "esName": "Pueblo de Nagomi",
      "ptName": "bairro de Nagomi",
      "thName": "เมืองนาโงมิ",
      "viName": "thị trấn Nagomi",
      "inName": "kota Nagomi",
      "tlName": "bayan ng Nagomi",
      "moName": "Нaгоми жижиг хот",
      "buName": "နာဂိုမိ မြို့နယ်",
      "khName": "ទីប្រជុំជន ណាកូមី",
      "neName": "नागोमी नगर"
    }
  },
  "4340300": {
    "office": {
      "code": "430000",
      "name": "熊本県",
      "enName": "Kumamoto",
      "officeName": "熊本地方気象台",
      "chName": "熊本县",
      "zhName": "熊本縣",
      "koName": "구마모토현",
      "esName": "Prefectura de Kumamoto",
      "ptName": "Província de Kumamoto",
      "thName": "จังหวัดคุมาโมโตะ",
      "viName": "Tỉnh Kumamoto",
      "inName": "Prefektur Kumamoto",
      "tlName": "Kumamoto Prefecture",
      "moName": "Күматомо аймаг",
      "buName": "ကူမာမိုတို ပြည်နယ်",
      "khName": "ខេត្ដ គូម៉ាម៉ូតូ",
      "neName": "कुमामोतो जिल्ला"
    },
    "class10": {
      "code": "430010",
      "name": "熊本地方",
      "enName": "Kumamoto Region",
      "chName": "熊本县熊本地方",
      "zhName": "熊本縣熊本地方",
      "koName": "구마모토 현 구마모토 지방",
      "esName": "Región Kumamoto, Prefectura de Kumamoto",
      "ptName": "Região de Kumamoto da Província de Kumamoto",
      "thName": "ท้องถิ่นคุมาโมโตะ จังหวัดคุมาโมโตะ",
      "viName": "Vùng Kumamoto, tỉnh Kumamoto",
      "inName": "Daerah Kumamoto di Prefektur Kumamoto",
      "tlName": "Rehiyon ng Kumamoto sa Kumamoto Prefecture ",
      "moName": "Күмамото аймаг, Күмамото муж",
      "buName": "ကုမမိုတိုဒေသ၊ ကုမမိုတိုစီရင်စု",
      "khName": "តំបន់ឃឹម៉ាម៉ុតុនៃខេត្ដឃឹម៉ាម៉ុតុ",
      "neName": "कुमामोतो जिल्ला, कुमामोतो क्षेत्र"
    },
    "class15": {
      "code": "430012",
      "name": "山鹿菊池",
      "enName": "Yamaga Kikuchi"
    },
    "class20": {
      "code": "4340300",
      "name": "大津町",
      "enName": "Ozu Town",
      "kana": "おおづまち",
      "chName": "大津町",
      "zhName": "大津町",
      "koName": "오즈 정",
      "esName": "Pueblo de Ōzu",
      "ptName": "bairro de Ozu",
      "thName": "เมืองโอซุ",
      "viName": "thị trấn Ozu",
      "inName": "kota Ozu",
      "tlName": "bayan ng Ozu",
      "moName": "Озү жижиг хот",
      "buName": "အို့ဇု မြို့နယ်",
      "khName": "ទីប្រជុំជន អូហ្សូ",
      "neName": "ओजु नगर"
    }
  },
  "4340400": {
    "office": {
      "code": "430000",
      "name": "熊本県",
      "enName": "Kumamoto",
      "officeName": "熊本地方気象台",
      "chName": "熊本县",
      "zhName": "熊本縣",
      "koName": "구마모토현",
      "esName": "Prefectura de Kumamoto",
      "ptName": "Província de Kumamoto",
      "thName": "จังหวัดคุมาโมโตะ",
      "viName": "Tỉnh Kumamoto",
      "inName": "Prefektur Kumamoto",
      "tlName": "Kumamoto Prefecture",
      "moName": "Күматомо аймаг",
      "buName": "ကူမာမိုတို ပြည်နယ်",
      "khName": "ខេត្ដ គូម៉ាម៉ូតូ",
      "neName": "कुमामोतो जिल्ला"
    },
    "class10": {
      "code": "430010",
      "name": "熊本地方",
      "enName": "Kumamoto Region",
      "chName": "熊本县熊本地方",
      "zhName": "熊本縣熊本地方",
      "koName": "구마모토 현 구마모토 지방",
      "esName": "Región Kumamoto, Prefectura de Kumamoto",
      "ptName": "Região de Kumamoto da Província de Kumamoto",
      "thName": "ท้องถิ่นคุมาโมโตะ จังหวัดคุมาโมโตะ",
      "viName": "Vùng Kumamoto, tỉnh Kumamoto",
      "inName": "Daerah Kumamoto di Prefektur Kumamoto",
      "tlName": "Rehiyon ng Kumamoto sa Kumamoto Prefecture ",
      "moName": "Күмамото аймаг, Күмамото муж",
      "buName": "ကုမမိုတိုဒေသ၊ ကုမမိုတိုစီရင်စု",
      "khName": "តំបន់ឃឹម៉ាម៉ុតុនៃខេត្ដឃឹម៉ាម៉ុតុ",
      "neName": "कुमामोतो जिल्ला, कुमामोतो क्षेत्र"
    },
    "class15": {
      "code": "430012",
      "name": "山鹿菊池",
      "enName": "Yamaga Kikuchi"
    },
    "class20": {
      "code": "4340400",
      "name": "菊陽町",
      "enName": "Kikuyo Town",
      "kana": "きくようまち",
      "chName": "菊阳町",
      "zhName": "菊陽町",
      "koName": "기쿠요 정",
      "esName": "Pueblo de Kikuyo",
      "ptName": "bairro de Kikuyo",
      "thName": "เมืองคิคูโยะ",
      "viName": "thị trấn Kikuyo",
      "inName": "kota Kikuyo",
      "tlName": "bayan ng Kikuyo",
      "moName": "Кикүёо жижиг хот",
      "buName": "ခီကုရို မြို့နယ်",
      "khName": "ទីប្រជុំជន គីគូយ៉ូ",
      "neName": "किकुयो नगर"
    }
  },
  "4342300": {
    "office": {
      "code": "430000",
      "name": "熊本県",
      "enName": "Kumamoto",
      "officeName": "熊本地方気象台",
      "chName": "熊本县",
      "zhName": "熊本縣",
      "koName": "구마모토현",
      "esName": "Prefectura de Kumamoto",
      "ptName": "Província de Kumamoto",
      "thName": "จังหวัดคุมาโมโตะ",
      "viName": "Tỉnh Kumamoto",
      "inName": "Prefektur Kumamoto",
      "tlName": "Kumamoto Prefecture",
      "moName": "Күматомо аймаг",
      "buName": "ကူမာမိုတို ပြည်နယ်",
      "khName": "ខេត្ដ គូម៉ាម៉ូតូ",
      "neName": "कुमामोतो जिल्ला"
    },
    "class10": {
      "code": "430020",
      "name": "阿蘇地方",
      "enName": "Aso Region",
      "chName": "熊本县阿苏地方",
      "zhName": "熊本縣阿蘇地方",
      "koName": "구마모토 현 아소 지방",
      "esName": "Región Aso, Prefectura de Kumamoto",
      "ptName": "Região de  Aso da Província de Kumamoto",
      "thName": "ท้องถิ่นอะโซะ จังหวัดคุมาโมโตะ",
      "viName": "Vùng Aso, tỉnh Kumamoto",
      "inName": "Daerah Aso di Prefektur Kumamoto",
      "tlName": "Rehiyon ng Aso sa Kumamoto Prefecture",
      "moName": "Күмамото аймаг, Асо муж",
      "buName": "အဆိုဒေသ၊ ကုမမိုတိုစီရင်စု",
      "khName": "តំបន់អាសូនៃខេត្ដឃឹម៉ាម៉ុតុ",
      "neName": "कुमामोतो जिल्ला, आसो क्षेत्र"
    },
    "class15": {
      "code": "430020",
      "name": "阿蘇地方",
      "enName": "Aso Region"
    },
    "class20": {
      "code": "4342300",
      "name": "南小国町",
      "enName": "Minamioguni Town",
      "kana": "みなみおぐにまち",
      "chName": "南小国町",
      "zhName": "南小國町",
      "koName": "미나미오구니 정",
      "esName": "Pueblo de Minami-oguni",
      "ptName": "bairro de Minamioguni",
      "thName": "เมืองมินามิกุนิ",
      "viName": "thị trấn Minamioguni",
      "inName": "kota Minamioguni",
      "tlName": "bayan ng Minamioguni",
      "moName": "Минaмиогүни жижиг хот",
      "buName": "မီနာမိယိုဂုနိ မြို့နယ်",
      "khName": "ទីប្រជុំជន មីណាមីអូហ្គូនី",
      "neName": "मिनामिओगुनी नगर"
    }
  },
  "4342400": {
    "office": {
      "code": "430000",
      "name": "熊本県",
      "enName": "Kumamoto",
      "officeName": "熊本地方気象台",
      "chName": "熊本县",
      "zhName": "熊本縣",
      "koName": "구마모토현",
      "esName": "Prefectura de Kumamoto",
      "ptName": "Província de Kumamoto",
      "thName": "จังหวัดคุมาโมโตะ",
      "viName": "Tỉnh Kumamoto",
      "inName": "Prefektur Kumamoto",
      "tlName": "Kumamoto Prefecture",
      "moName": "Күматомо аймаг",
      "buName": "ကူမာမိုတို ပြည်နယ်",
      "khName": "ខេត្ដ គូម៉ាម៉ូតូ",
      "neName": "कुमामोतो जिल्ला"
    },
    "class10": {
      "code": "430020",
      "name": "阿蘇地方",
      "enName": "Aso Region",
      "chName": "熊本县阿苏地方",
      "zhName": "熊本縣阿蘇地方",
      "koName": "구마모토 현 아소 지방",
      "esName": "Región Aso, Prefectura de Kumamoto",
      "ptName": "Região de  Aso da Província de Kumamoto",
      "thName": "ท้องถิ่นอะโซะ จังหวัดคุมาโมโตะ",
      "viName": "Vùng Aso, tỉnh Kumamoto",
      "inName": "Daerah Aso di Prefektur Kumamoto",
      "tlName": "Rehiyon ng Aso sa Kumamoto Prefecture",
      "moName": "Күмамото аймаг, Асо муж",
      "buName": "အဆိုဒေသ၊ ကုမမိုတိုစီရင်စု",
      "khName": "តំបន់អាសូនៃខេត្ដឃឹម៉ាម៉ុតុ",
      "neName": "कुमामोतो जिल्ला, आसो क्षेत्र"
    },
    "class15": {
      "code": "430020",
      "name": "阿蘇地方",
      "enName": "Aso Region"
    },
    "class20": {
      "code": "4342400",
      "name": "小国町",
      "enName": "Oguni Town",
      "kana": "おぐにまち",
      "chName": "熊本小国町",
      "zhName": "熊本小國町",
      "koName": "구마모토 오쿠니 정",
      "esName": "Pueblo de Oguni, Kumamoto",
      "ptName": "Kumamoto, bairro de Oguni",
      "thName": "เมืองโองุนิ คุมาโมโตะ",
      "viName": "Thị trấn Oguni, Kumamoto",
      "inName": "Kota Oguni, Kumamoto",
      "tlName": "bayan ng Oguni, Kumamoto",
      "moName": "Күмамото Огүни жижиг хот",
      "buName": "ခုမမိုတိုအိုဂဒနိမြို့နယ်",
      "khName": "ទីប្រជុំជនអូគឹនិ ឃឹម៉ាម៉ុតុ",
      "neName": "कुमामोतो ओगुनि नगर"
    }
  },
  "4342500": {
    "office": {
      "code": "430000",
      "name": "熊本県",
      "enName": "Kumamoto",
      "officeName": "熊本地方気象台",
      "chName": "熊本县",
      "zhName": "熊本縣",
      "koName": "구마모토현",
      "esName": "Prefectura de Kumamoto",
      "ptName": "Província de Kumamoto",
      "thName": "จังหวัดคุมาโมโตะ",
      "viName": "Tỉnh Kumamoto",
      "inName": "Prefektur Kumamoto",
      "tlName": "Kumamoto Prefecture",
      "moName": "Күматомо аймаг",
      "buName": "ကူမာမိုတို ပြည်နယ်",
      "khName": "ខេត្ដ គូម៉ាម៉ូតូ",
      "neName": "कुमामोतो जिल्ला"
    },
    "class10": {
      "code": "430020",
      "name": "阿蘇地方",
      "enName": "Aso Region",
      "chName": "熊本县阿苏地方",
      "zhName": "熊本縣阿蘇地方",
      "koName": "구마모토 현 아소 지방",
      "esName": "Región Aso, Prefectura de Kumamoto",
      "ptName": "Região de  Aso da Província de Kumamoto",
      "thName": "ท้องถิ่นอะโซะ จังหวัดคุมาโมโตะ",
      "viName": "Vùng Aso, tỉnh Kumamoto",
      "inName": "Daerah Aso di Prefektur Kumamoto",
      "tlName": "Rehiyon ng Aso sa Kumamoto Prefecture",
      "moName": "Күмамото аймаг, Асо муж",
      "buName": "အဆိုဒေသ၊ ကုမမိုတိုစီရင်စု",
      "khName": "តំបន់អាសូនៃខេត្ដឃឹម៉ាម៉ុតុ",
      "neName": "कुमामोतो जिल्ला, आसो क्षेत्र"
    },
    "class15": {
      "code": "430020",
      "name": "阿蘇地方",
      "enName": "Aso Region"
    },
    "class20": {
      "code": "4342500",
      "name": "産山村",
      "enName": "Ubuyama Village",
      "kana": "うぶやまむら",
      "chName": "产山村",
      "zhName": "產山村",
      "koName": "우부야마 촌",
      "esName": "Aldea de Ubuyama",
      "ptName": "povoado de Ubuyama",
      "thName": "หมู่บ้านอุบุยามะ",
      "viName": "làng Ubuyama",
      "inName": "desa Ubuyama",
      "tlName": "nayon ng Ubuyama",
      "moName": "Үбүямa тосгон",
      "buName": "ဥဘုယာ့မ ကျေးရွာ",
      "khName": "ភូមិ យូប៊ូយ៉ាម៉ា",
      "neName": "उबुयामा गाउँ"
    }
  },
  "4342800": {
    "office": {
      "code": "430000",
      "name": "熊本県",
      "enName": "Kumamoto",
      "officeName": "熊本地方気象台",
      "chName": "熊本县",
      "zhName": "熊本縣",
      "koName": "구마모토현",
      "esName": "Prefectura de Kumamoto",
      "ptName": "Província de Kumamoto",
      "thName": "จังหวัดคุมาโมโตะ",
      "viName": "Tỉnh Kumamoto",
      "inName": "Prefektur Kumamoto",
      "tlName": "Kumamoto Prefecture",
      "moName": "Күматомо аймаг",
      "buName": "ကူမာမိုတို ပြည်နယ်",
      "khName": "ខេត្ដ គូម៉ាម៉ូតូ",
      "neName": "कुमामोतो जिल्ला"
    },
    "class10": {
      "code": "430020",
      "name": "阿蘇地方",
      "enName": "Aso Region",
      "chName": "熊本县阿苏地方",
      "zhName": "熊本縣阿蘇地方",
      "koName": "구마모토 현 아소 지방",
      "esName": "Región Aso, Prefectura de Kumamoto",
      "ptName": "Região de  Aso da Província de Kumamoto",
      "thName": "ท้องถิ่นอะโซะ จังหวัดคุมาโมโตะ",
      "viName": "Vùng Aso, tỉnh Kumamoto",
      "inName": "Daerah Aso di Prefektur Kumamoto",
      "tlName": "Rehiyon ng Aso sa Kumamoto Prefecture",
      "moName": "Күмамото аймаг, Асо муж",
      "buName": "အဆိုဒေသ၊ ကုမမိုတိုစီရင်စု",
      "khName": "តំបន់អាសូនៃខេត្ដឃឹម៉ាម៉ុតុ",
      "neName": "कुमामोतो जिल्ला, आसो क्षेत्र"
    },
    "class15": {
      "code": "430020",
      "name": "阿蘇地方",
      "enName": "Aso Region"
    },
    "class20": {
      "code": "4342800",
      "name": "高森町",
      "enName": "Takamori Town",
      "kana": "たかもりまち",
      "chName": "熊本高森町",
      "zhName": "熊本高森町",
      "koName": "구마모토 다카모리 정",
      "esName": "Pueblo de Takamori, Kumamoto",
      "ptName": "Kumamoto, bairro de Takamori",
      "thName": "เมืองทากาโมริ คุมาโมโตะ",
      "viName": "Thị trấn Takamori, Kumamoto",
      "inName": "Kota Takamori, Kumamoto",
      "tlName": "bayan ng Takamori, Kumamoto",
      "moName": "Күмамото Такамори жижиг хот",
      "buName": "ခုမမိုတိုတကမိုယိမြို့နယ်",
      "khName": "ទីប្រជុំជនតាកាមូរី ឃឹម៉ាម៉ុតុ",
      "neName": "कुमामोतो ताकामोरी नगर"
    }
  },
  "4343200": {
    "office": {
      "code": "430000",
      "name": "熊本県",
      "enName": "Kumamoto",
      "officeName": "熊本地方気象台",
      "chName": "熊本县",
      "zhName": "熊本縣",
      "koName": "구마모토현",
      "esName": "Prefectura de Kumamoto",
      "ptName": "Província de Kumamoto",
      "thName": "จังหวัดคุมาโมโตะ",
      "viName": "Tỉnh Kumamoto",
      "inName": "Prefektur Kumamoto",
      "tlName": "Kumamoto Prefecture",
      "moName": "Күматомо аймаг",
      "buName": "ကူမာမိုတို ပြည်နယ်",
      "khName": "ខេត្ដ គូម៉ាម៉ូតូ",
      "neName": "कुमामोतो जिल्ला"
    },
    "class10": {
      "code": "430010",
      "name": "熊本地方",
      "enName": "Kumamoto Region",
      "chName": "熊本县熊本地方",
      "zhName": "熊本縣熊本地方",
      "koName": "구마모토 현 구마모토 지방",
      "esName": "Región Kumamoto, Prefectura de Kumamoto",
      "ptName": "Região de Kumamoto da Província de Kumamoto",
      "thName": "ท้องถิ่นคุมาโมโตะ จังหวัดคุมาโมโตะ",
      "viName": "Vùng Kumamoto, tỉnh Kumamoto",
      "inName": "Daerah Kumamoto di Prefektur Kumamoto",
      "tlName": "Rehiyon ng Kumamoto sa Kumamoto Prefecture ",
      "moName": "Күмамото аймаг, Күмамото муж",
      "buName": "ကုမမိုတိုဒေသ၊ ကုမမိုတိုစီရင်စု",
      "khName": "តំបន់ឃឹម៉ាម៉ុតុនៃខេត្ដឃឹម៉ាម៉ុតុ",
      "neName": "कुमामोतो जिल्ला, कुमामोतो क्षेत्र"
    },
    "class15": {
      "code": "430014",
      "name": "上益城",
      "enName": "Kamimashiki"
    },
    "class20": {
      "code": "4343200",
      "name": "西原村",
      "enName": "Nishihara Village",
      "kana": "にしはらむら",
      "chName": "西原村",
      "zhName": "西原村",
      "koName": "니시하라 촌",
      "esName": "Aldea de Nishihara",
      "ptName": "povoado de Nishihara",
      "thName": "หมู่บ้านนิชิฮาระ",
      "viName": "làng Nishihara",
      "inName": "desa Nishihara",
      "tlName": "nayon ng Nishihara",
      "moName": "Нишихaра тосгон",
      "buName": "နီရှိဟာ့ရာ့ ကျေးရွာ",
      "khName": "ភូមិ នីស៊ីហារ៉ា",
      "neName": "निशिहारा गाउँ"
    }
  },
  "4343300": {
    "office": {
      "code": "430000",
      "name": "熊本県",
      "enName": "Kumamoto",
      "officeName": "熊本地方気象台",
      "chName": "熊本县",
      "zhName": "熊本縣",
      "koName": "구마모토현",
      "esName": "Prefectura de Kumamoto",
      "ptName": "Província de Kumamoto",
      "thName": "จังหวัดคุมาโมโตะ",
      "viName": "Tỉnh Kumamoto",
      "inName": "Prefektur Kumamoto",
      "tlName": "Kumamoto Prefecture",
      "moName": "Күматомо аймаг",
      "buName": "ကူမာမိုတို ပြည်နယ်",
      "khName": "ខេត្ដ គូម៉ាម៉ូតូ",
      "neName": "कुमामोतो जिल्ला"
    },
    "class10": {
      "code": "430020",
      "name": "阿蘇地方",
      "enName": "Aso Region",
      "chName": "熊本县阿苏地方",
      "zhName": "熊本縣阿蘇地方",
      "koName": "구마모토 현 아소 지방",
      "esName": "Región Aso, Prefectura de Kumamoto",
      "ptName": "Região de  Aso da Província de Kumamoto",
      "thName": "ท้องถิ่นอะโซะ จังหวัดคุมาโมโตะ",
      "viName": "Vùng Aso, tỉnh Kumamoto",
      "inName": "Daerah Aso di Prefektur Kumamoto",
      "tlName": "Rehiyon ng Aso sa Kumamoto Prefecture",
      "moName": "Күмамото аймаг, Асо муж",
      "buName": "အဆိုဒေသ၊ ကုမမိုတိုစီရင်စု",
      "khName": "តំបន់អាសូនៃខេត្ដឃឹម៉ាម៉ុតុ",
      "neName": "कुमामोतो जिल्ला, आसो क्षेत्र"
    },
    "class15": {
      "code": "430020",
      "name": "阿蘇地方",
      "enName": "Aso Region"
    },
    "class20": {
      "code": "4343300",
      "name": "南阿蘇村",
      "enName": "Minamiaso Village",
      "kana": "みなみあそむら",
      "chName": "南阿苏村",
      "zhName": "南阿蘇村",
      "koName": "미나미아소 촌",
      "esName": "Aldea de Minami-aso",
      "ptName": "povoado de Minamiaso",
      "thName": "หมู่บ้านมินามิอาโซะ",
      "viName": "làng Minamiaso",
      "inName": "desa Minamiaso",
      "tlName": "nayon ng Minamiaso",
      "moName": "Минaмиaсо тосгон",
      "buName": "မီနာမိယားဆို ကျေးရွာ",
      "khName": "ភូមិ មីណាមីយ៉ាសូ",
      "neName": "मिनामियासो गाउँ"
    }
  },
  "4344100": {
    "office": {
      "code": "430000",
      "name": "熊本県",
      "enName": "Kumamoto",
      "officeName": "熊本地方気象台",
      "chName": "熊本县",
      "zhName": "熊本縣",
      "koName": "구마모토현",
      "esName": "Prefectura de Kumamoto",
      "ptName": "Província de Kumamoto",
      "thName": "จังหวัดคุมาโมโตะ",
      "viName": "Tỉnh Kumamoto",
      "inName": "Prefektur Kumamoto",
      "tlName": "Kumamoto Prefecture",
      "moName": "Күматомо аймаг",
      "buName": "ကူမာမိုတို ပြည်နယ်",
      "khName": "ខេត្ដ គូម៉ាម៉ូតូ",
      "neName": "कुमामोतो जिल्ला"
    },
    "class10": {
      "code": "430010",
      "name": "熊本地方",
      "enName": "Kumamoto Region",
      "chName": "熊本县熊本地方",
      "zhName": "熊本縣熊本地方",
      "koName": "구마모토 현 구마모토 지방",
      "esName": "Región Kumamoto, Prefectura de Kumamoto",
      "ptName": "Região de Kumamoto da Província de Kumamoto",
      "thName": "ท้องถิ่นคุมาโมโตะ จังหวัดคุมาโมโตะ",
      "viName": "Vùng Kumamoto, tỉnh Kumamoto",
      "inName": "Daerah Kumamoto di Prefektur Kumamoto",
      "tlName": "Rehiyon ng Kumamoto sa Kumamoto Prefecture ",
      "moName": "Күмамото аймаг, Күмамото муж",
      "buName": "ကုမမိုတိုဒေသ၊ ကုမမိုတိုစီရင်စု",
      "khName": "តំបន់ឃឹម៉ាម៉ុតុនៃខេត្ដឃឹម៉ាម៉ុតុ",
      "neName": "कुमामोतो जिल्ला, कुमामोतो क्षेत्र"
    },
    "class15": {
      "code": "430014",
      "name": "上益城",
      "enName": "Kamimashiki"
    },
    "class20": {
      "code": "4344100",
      "name": "御船町",
      "enName": "Mifune Town",
      "kana": "みふねまち",
      "chName": "御船町",
      "zhName": "御船町",
      "koName": "미후네 정",
      "esName": "Pueblo de Mifune",
      "ptName": "bairro de Mifune",
      "thName": "เมืองมิฟุเนะ",
      "viName": "thị trấn Mifune",
      "inName": "kota Mifune",
      "tlName": "bayan ng Mifune",
      "moName": "Мифүнэ жижиг хот",
      "buName": "မီဖူနဲ့ မြို့နယ်",
      "khName": "ទីប្រជុំជន មីហ្វូ៊ន",
      "neName": "मिफुने नगर"
    }
  },
  "4344200": {
    "office": {
      "code": "430000",
      "name": "熊本県",
      "enName": "Kumamoto",
      "officeName": "熊本地方気象台",
      "chName": "熊本县",
      "zhName": "熊本縣",
      "koName": "구마모토현",
      "esName": "Prefectura de Kumamoto",
      "ptName": "Província de Kumamoto",
      "thName": "จังหวัดคุมาโมโตะ",
      "viName": "Tỉnh Kumamoto",
      "inName": "Prefektur Kumamoto",
      "tlName": "Kumamoto Prefecture",
      "moName": "Күматомо аймаг",
      "buName": "ကူမာမိုတို ပြည်နယ်",
      "khName": "ខេត្ដ គូម៉ាម៉ូតូ",
      "neName": "कुमामोतो जिल्ला"
    },
    "class10": {
      "code": "430010",
      "name": "熊本地方",
      "enName": "Kumamoto Region",
      "chName": "熊本县熊本地方",
      "zhName": "熊本縣熊本地方",
      "koName": "구마모토 현 구마모토 지방",
      "esName": "Región Kumamoto, Prefectura de Kumamoto",
      "ptName": "Região de Kumamoto da Província de Kumamoto",
      "thName": "ท้องถิ่นคุมาโมโตะ จังหวัดคุมาโมโตะ",
      "viName": "Vùng Kumamoto, tỉnh Kumamoto",
      "inName": "Daerah Kumamoto di Prefektur Kumamoto",
      "tlName": "Rehiyon ng Kumamoto sa Kumamoto Prefecture ",
      "moName": "Күмамото аймаг, Күмамото муж",
      "buName": "ကုမမိုတိုဒေသ၊ ကုမမိုတိုစီရင်စု",
      "khName": "តំបន់ឃឹម៉ាម៉ុតុនៃខេត្ដឃឹម៉ាម៉ុតុ",
      "neName": "कुमामोतो जिल्ला, कुमामोतो क्षेत्र"
    },
    "class15": {
      "code": "430014",
      "name": "上益城",
      "enName": "Kamimashiki"
    },
    "class20": {
      "code": "4344200",
      "name": "嘉島町",
      "enName": "Kashima Town",
      "kana": "かしままち",
      "chName": "嘉岛町",
      "zhName": "嘉島町",
      "koName": "가시마 정",
      "esName": "Pueblo de Kashima",
      "ptName": "bairro de Kashima",
      "thName": "เมืองคาชิมะ",
      "viName": "thị trấn Kashima",
      "inName": "kota Kashima",
      "tlName": "bayan ng Kashima",
      "moName": "Кашимa жижиг хот",
      "buName": "ခါရှိမ မြို့နယ်",
      "khName": "ទីប្រជុំជន កាស៊ីម៉ា",
      "neName": "काशिमा नगर"
    }
  },
  "4344300": {
    "office": {
      "code": "430000",
      "name": "熊本県",
      "enName": "Kumamoto",
      "officeName": "熊本地方気象台",
      "chName": "熊本县",
      "zhName": "熊本縣",
      "koName": "구마모토현",
      "esName": "Prefectura de Kumamoto",
      "ptName": "Província de Kumamoto",
      "thName": "จังหวัดคุมาโมโตะ",
      "viName": "Tỉnh Kumamoto",
      "inName": "Prefektur Kumamoto",
      "tlName": "Kumamoto Prefecture",
      "moName": "Күматомо аймаг",
      "buName": "ကူမာမိုတို ပြည်နယ်",
      "khName": "ខេត្ដ គូម៉ាម៉ូតូ",
      "neName": "कुमामोतो जिल्ला"
    },
    "class10": {
      "code": "430010",
      "name": "熊本地方",
      "enName": "Kumamoto Region",
      "chName": "熊本县熊本地方",
      "zhName": "熊本縣熊本地方",
      "koName": "구마모토 현 구마모토 지방",
      "esName": "Región Kumamoto, Prefectura de Kumamoto",
      "ptName": "Região de Kumamoto da Província de Kumamoto",
      "thName": "ท้องถิ่นคุมาโมโตะ จังหวัดคุมาโมโตะ",
      "viName": "Vùng Kumamoto, tỉnh Kumamoto",
      "inName": "Daerah Kumamoto di Prefektur Kumamoto",
      "tlName": "Rehiyon ng Kumamoto sa Kumamoto Prefecture ",
      "moName": "Күмамото аймаг, Күмамото муж",
      "buName": "ကုမမိုတိုဒေသ၊ ကုမမိုတိုစီရင်စု",
      "khName": "តំបន់ឃឹម៉ាម៉ុតុនៃខេត្ដឃឹម៉ាម៉ុតុ",
      "neName": "कुमामोतो जिल्ला, कुमामोतो क्षेत्र"
    },
    "class15": {
      "code": "430014",
      "name": "上益城",
      "enName": "Kamimashiki"
    },
    "class20": {
      "code": "4344300",
      "name": "益城町",
      "enName": "Mashiki Town",
      "kana": "ましきまち",
      "chName": "益城町",
      "zhName": "益城町",
      "koName": "마시키 정",
      "esName": "Pueblo de Mashiki",
      "ptName": "bairro de Mashiki",
      "thName": "เมืองมาชิกิ",
      "viName": "thị trấn Mashiki",
      "inName": "kota Mashiki",
      "tlName": "bayan ng Mashiki",
      "moName": "Мaшики жижиг хот",
      "buName": "မာဆုကိ မြို့နယ်",
      "khName": "ទីប្រជុំជន ម៉ាស៊ីគី",
      "neName": "माशिकी नगर"
    }
  },
  "4344400": {
    "office": {
      "code": "430000",
      "name": "熊本県",
      "enName": "Kumamoto",
      "officeName": "熊本地方気象台",
      "chName": "熊本县",
      "zhName": "熊本縣",
      "koName": "구마모토현",
      "esName": "Prefectura de Kumamoto",
      "ptName": "Província de Kumamoto",
      "thName": "จังหวัดคุมาโมโตะ",
      "viName": "Tỉnh Kumamoto",
      "inName": "Prefektur Kumamoto",
      "tlName": "Kumamoto Prefecture",
      "moName": "Күматомо аймаг",
      "buName": "ကူမာမိုတို ပြည်နယ်",
      "khName": "ខេត្ដ គូម៉ាម៉ូតូ",
      "neName": "कुमामोतो जिल्ला"
    },
    "class10": {
      "code": "430010",
      "name": "熊本地方",
      "enName": "Kumamoto Region",
      "chName": "熊本县熊本地方",
      "zhName": "熊本縣熊本地方",
      "koName": "구마모토 현 구마모토 지방",
      "esName": "Región Kumamoto, Prefectura de Kumamoto",
      "ptName": "Região de Kumamoto da Província de Kumamoto",
      "thName": "ท้องถิ่นคุมาโมโตะ จังหวัดคุมาโมโตะ",
      "viName": "Vùng Kumamoto, tỉnh Kumamoto",
      "inName": "Daerah Kumamoto di Prefektur Kumamoto",
      "tlName": "Rehiyon ng Kumamoto sa Kumamoto Prefecture ",
      "moName": "Күмамото аймаг, Күмамото муж",
      "buName": "ကုမမိုတိုဒေသ၊ ကုမမိုတိုစီရင်စု",
      "khName": "តំបន់ឃឹម៉ាម៉ុតុនៃខេត្ដឃឹម៉ាម៉ុតុ",
      "neName": "कुमामोतो जिल्ला, कुमामोतो क्षेत्र"
    },
    "class15": {
      "code": "430014",
      "name": "上益城",
      "enName": "Kamimashiki"
    },
    "class20": {
      "code": "4344400",
      "name": "甲佐町",
      "enName": "Kosa Town",
      "kana": "こうさまち",
      "chName": "甲佐町",
      "zhName": "甲佐町",
      "koName": "고사 정",
      "esName": "Pueblo de Kosa",
      "ptName": "bairro de Kosa",
      "thName": "เมืองโคสะ",
      "viName": "thị trấn Kosa",
      "inName": "kota Kosa",
      "tlName": "bayan ng Kosa",
      "moName": "Косa жижиг хот",
      "buName": "ကိုဆာ မြို့နယ်",
      "khName": "ទីប្រជុំជន កោសា",
      "neName": "कोसा नगर"
    }
  },
  "4344700": {
    "office": {
      "code": "430000",
      "name": "熊本県",
      "enName": "Kumamoto",
      "officeName": "熊本地方気象台",
      "chName": "熊本县",
      "zhName": "熊本縣",
      "koName": "구마모토현",
      "esName": "Prefectura de Kumamoto",
      "ptName": "Província de Kumamoto",
      "thName": "จังหวัดคุมาโมโตะ",
      "viName": "Tỉnh Kumamoto",
      "inName": "Prefektur Kumamoto",
      "tlName": "Kumamoto Prefecture",
      "moName": "Күматомо аймаг",
      "buName": "ကူမာမိုတို ပြည်နယ်",
      "khName": "ខេត្ដ គូម៉ាម៉ូតូ",
      "neName": "कुमामोतो जिल्ला"
    },
    "class10": {
      "code": "430010",
      "name": "熊本地方",
      "enName": "Kumamoto Region",
      "chName": "熊本县熊本地方",
      "zhName": "熊本縣熊本地方",
      "koName": "구마모토 현 구마모토 지방",
      "esName": "Región Kumamoto, Prefectura de Kumamoto",
      "ptName": "Região de Kumamoto da Província de Kumamoto",
      "thName": "ท้องถิ่นคุมาโมโตะ จังหวัดคุมาโมโตะ",
      "viName": "Vùng Kumamoto, tỉnh Kumamoto",
      "inName": "Daerah Kumamoto di Prefektur Kumamoto",
      "tlName": "Rehiyon ng Kumamoto sa Kumamoto Prefecture ",
      "moName": "Күмамото аймаг, Күмамото муж",
      "buName": "ကုမမိုတိုဒေသ၊ ကုမမိုတိုစီရင်စု",
      "khName": "តំបន់ឃឹម៉ាម៉ុតុនៃខេត្ដឃឹម៉ាម៉ុតុ",
      "neName": "कुमामोतो जिल्ला, कुमामोतो क्षेत्र"
    },
    "class15": {
      "code": "430014",
      "name": "上益城",
      "enName": "Kamimashiki"
    },
    "class20": {
      "code": "4344700",
      "name": "山都町",
      "enName": "Yamato Town",
      "kana": "やまとちょう",
      "chName": "山都町",
      "zhName": "山都町",
      "koName": "야마토 정",
      "esName": "Pueblo de Yamato",
      "ptName": "bairro de Yamato",
      "thName": "เมืองยามาโตะ",
      "viName": "thị trấn Yamato",
      "inName": "kota Yamato",
      "tlName": "bayan ng Yamato",
      "moName": "Ямaто жижиг хот",
      "buName": "ယာမာတို မြို့နယ်",
      "khName": "ទីប្រជុំជន យ៉ាម៉ាតូ",
      "neName": "यामातो नगर"
    }
  },
  "4346800": {
    "office": {
      "code": "430000",
      "name": "熊本県",
      "enName": "Kumamoto",
      "officeName": "熊本地方気象台",
      "chName": "熊本县",
      "zhName": "熊本縣",
      "koName": "구마모토현",
      "esName": "Prefectura de Kumamoto",
      "ptName": "Província de Kumamoto",
      "thName": "จังหวัดคุมาโมโตะ",
      "viName": "Tỉnh Kumamoto",
      "inName": "Prefektur Kumamoto",
      "tlName": "Kumamoto Prefecture",
      "moName": "Күматомо аймаг",
      "buName": "ကူမာမိုတို ပြည်နယ်",
      "khName": "ខេត្ដ គូម៉ាម៉ូតូ",
      "neName": "कुमामोतो जिल्ला"
    },
    "class10": {
      "code": "430010",
      "name": "熊本地方",
      "enName": "Kumamoto Region",
      "chName": "熊本县熊本地方",
      "zhName": "熊本縣熊本地方",
      "koName": "구마모토 현 구마모토 지방",
      "esName": "Región Kumamoto, Prefectura de Kumamoto",
      "ptName": "Região de Kumamoto da Província de Kumamoto",
      "thName": "ท้องถิ่นคุมาโมโตะ จังหวัดคุมาโมโตะ",
      "viName": "Vùng Kumamoto, tỉnh Kumamoto",
      "inName": "Daerah Kumamoto di Prefektur Kumamoto",
      "tlName": "Rehiyon ng Kumamoto sa Kumamoto Prefecture ",
      "moName": "Күмамото аймаг, Күмамото муж",
      "buName": "ကုမမိုတိုဒေသ၊ ကုမမိုတိုစီရင်စု",
      "khName": "តំបន់ឃឹម៉ាម៉ុតុនៃខេត្ដឃឹម៉ាម៉ុតុ",
      "neName": "कुमामोतो जिल्ला, कुमामोतो क्षेत्र"
    },
    "class15": {
      "code": "430015",
      "name": "宇城八代",
      "enName": "Uki Yatsushiro"
    },
    "class20": {
      "code": "4346800",
      "name": "氷川町",
      "enName": "Hikawa Town",
      "kana": "ひかわちょう",
      "chName": "冰川町",
      "zhName": "冰川町",
      "koName": "히카와 정",
      "esName": "Pueblo de Hikawa",
      "ptName": "bairro de Hikawa",
      "thName": "เมืองฮิคาวะ",
      "viName": "thị trấn Hikawa",
      "inName": "kota Hikawa",
      "tlName": "bayan ng Hikawa",
      "moName": "Хикава жижиг хот",
      "buName": "ဟီကာ့ဝ မြို့နယ်",
      "khName": "ទីប្រជុំជន ហ៊ីកាវ៉ា",
      "neName": "हिकावा नगर"
    }
  },
  "4348200": {
    "office": {
      "code": "430000",
      "name": "熊本県",
      "enName": "Kumamoto",
      "officeName": "熊本地方気象台",
      "chName": "熊本县",
      "zhName": "熊本縣",
      "koName": "구마모토현",
      "esName": "Prefectura de Kumamoto",
      "ptName": "Província de Kumamoto",
      "thName": "จังหวัดคุมาโมโตะ",
      "viName": "Tỉnh Kumamoto",
      "inName": "Prefektur Kumamoto",
      "tlName": "Kumamoto Prefecture",
      "moName": "Күматомо аймаг",
      "buName": "ကူမာမိုတို ပြည်နယ်",
      "khName": "ខេត្ដ គូម៉ាម៉ូតូ",
      "neName": "कुमामोतो जिल्ला"
    },
    "class10": {
      "code": "430030",
      "name": "天草・芦北地方",
      "enName": "Amakusa Ashikita Region",
      "chName": "熊本县天草、芦北地方",
      "zhName": "熊本縣天草・蘆北地方",
      "koName": "구마모토 현 아마쿠사·아시 키타 지방",
      "esName": "Región Amakusa-Ashikita, Prefectura de Kumamoto",
      "ptName": "Região de Amakusa・Ashikita da Província de Kumamoto",
      "thName": "ท้องถิ่นอะมากุสะและอะชิกิตะ จังหวัดคุมาโมโตะ",
      "viName": "Vùng Amakusa và Ashikita, tỉnh Kumamoto",
      "inName": "Daerah Amakusa dan Ashikita di Prefektur Kumamoto",
      "tlName": "Rehiyon ng Amakusa at Ashikita sa Kumamoto Prefecture",
      "moName": "Күмамото аймаг, Амакүса・Ашикита муж",
      "buName": "အမကုဆ၊ အရှိခိတဒေသ၊ ကုမမိုတိုစီရင်စု",
      "khName": "តំបន់អាម៉ាគឹសា/អាស៊ីគីតាក់នៃខេត្ដឃឹម៉ាម៉ុតុ",
      "neName": "कुमामोतो जिल्ला, आमाकुसा र आसिकिता क्षेत्र"
    },
    "class15": {
      "code": "430032",
      "name": "芦北地方",
      "enName": "Ashikita Region"
    },
    "class20": {
      "code": "4348200",
      "name": "芦北町",
      "enName": "Ashikita Town",
      "kana": "あしきたまち",
      "chName": "芦北町",
      "zhName": "蘆北町",
      "koName": "아시키타 정",
      "esName": "Pueblo de Ashikita",
      "ptName": "bairro de Ashikita",
      "thName": "เมืองอาชิคิตะ",
      "viName": "thị trấn Ashikita",
      "inName": "kota Ashikita",
      "tlName": "bayan ng Ashikita",
      "moName": "Aшикита жижиг хот",
      "buName": "အရှီကိတ မြို့နယ်",
      "khName": "ទីប្រជុំជន អាស៊ីគីតា",
      "neName": "आशिकिता नगर"
    }
  },
  "4348400": {
    "office": {
      "code": "430000",
      "name": "熊本県",
      "enName": "Kumamoto",
      "officeName": "熊本地方気象台",
      "chName": "熊本县",
      "zhName": "熊本縣",
      "koName": "구마모토현",
      "esName": "Prefectura de Kumamoto",
      "ptName": "Província de Kumamoto",
      "thName": "จังหวัดคุมาโมโตะ",
      "viName": "Tỉnh Kumamoto",
      "inName": "Prefektur Kumamoto",
      "tlName": "Kumamoto Prefecture",
      "moName": "Күматомо аймаг",
      "buName": "ကူမာမိုတို ပြည်နယ်",
      "khName": "ខេត្ដ គូម៉ាម៉ូតូ",
      "neName": "कुमामोतो जिल्ला"
    },
    "class10": {
      "code": "430030",
      "name": "天草・芦北地方",
      "enName": "Amakusa Ashikita Region",
      "chName": "熊本县天草、芦北地方",
      "zhName": "熊本縣天草・蘆北地方",
      "koName": "구마모토 현 아마쿠사·아시 키타 지방",
      "esName": "Región Amakusa-Ashikita, Prefectura de Kumamoto",
      "ptName": "Região de Amakusa・Ashikita da Província de Kumamoto",
      "thName": "ท้องถิ่นอะมากุสะและอะชิกิตะ จังหวัดคุมาโมโตะ",
      "viName": "Vùng Amakusa và Ashikita, tỉnh Kumamoto",
      "inName": "Daerah Amakusa dan Ashikita di Prefektur Kumamoto",
      "tlName": "Rehiyon ng Amakusa at Ashikita sa Kumamoto Prefecture",
      "moName": "Күмамото аймаг, Амакүса・Ашикита муж",
      "buName": "အမကုဆ၊ အရှိခိတဒေသ၊ ကုမမိုတိုစီရင်စု",
      "khName": "តំបន់អាម៉ាគឹសា/អាស៊ីគីតាក់នៃខេត្ដឃឹម៉ាម៉ុតុ",
      "neName": "कुमामोतो जिल्ला, आमाकुसा र आसिकिता क्षेत्र"
    },
    "class15": {
      "code": "430032",
      "name": "芦北地方",
      "enName": "Ashikita Region"
    },
    "class20": {
      "code": "4348400",
      "name": "津奈木町",
      "enName": "Tsunagi Town",
      "kana": "つなぎまち",
      "chName": "津奈木町",
      "zhName": "津奈木町",
      "koName": "쓰나기 정",
      "esName": "Pueblo de Tsunagi",
      "ptName": "bairro de Tsunagi",
      "thName": "เมืองสึนางิ",
      "viName": "thị trấn Tsunagi",
      "inName": "kota Tsunagi",
      "tlName": "bayan ng Tsunagi",
      "moName": "Цүнaги жижиг хот",
      "buName": "ဆူနာ့ဂိ မြို့နယ်",
      "khName": "ទីប្រជុំជន ស៊ុនណាហ្គី",
      "neName": "त्सुनागी नगर"
    }
  },
  "4350100": {
    "office": {
      "code": "430000",
      "name": "熊本県",
      "enName": "Kumamoto",
      "officeName": "熊本地方気象台",
      "chName": "熊本县",
      "zhName": "熊本縣",
      "koName": "구마모토현",
      "esName": "Prefectura de Kumamoto",
      "ptName": "Província de Kumamoto",
      "thName": "จังหวัดคุมาโมโตะ",
      "viName": "Tỉnh Kumamoto",
      "inName": "Prefektur Kumamoto",
      "tlName": "Kumamoto Prefecture",
      "moName": "Күматомо аймаг",
      "buName": "ကူမာမိုတို ပြည်နယ်",
      "khName": "ខេត្ដ គូម៉ាម៉ូតូ",
      "neName": "कुमामोतो जिल्ला"
    },
    "class10": {
      "code": "430040",
      "name": "球磨地方",
      "enName": "Kuma Region",
      "chName": "熊本县球磨地方",
      "zhName": "熊本縣球磨地方",
      "koName": "쿠마모토현 구마 지방",
      "esName": "Región Kuma, Prefectura de Kumamoto",
      "ptName": "Região de Kuma da Província de Kumamoto",
      "thName": "ท้องถิ่นคุมะ จังหวัดคุมาโมโตะ",
      "viName": "Vùng Kuma, tỉnh Kumamoto",
      "inName": "Daerah Kuma di Prefektur Kumamoto",
      "tlName": "Rehiyon ng Kuma sa Kumamoto Prefecture",
      "moName": "Күмамото аймаг, Күма муж",
      "buName": "ကုမဒေသ၊ ကုမမိုတိုစီရင်စု",
      "khName": "តំបន់គឺម៉ានៃខេត្ដឃឹម៉ាម៉ុតុ",
      "neName": "कुमामोतो जिल्ला, कुमा क्षेत्र"
    },
    "class15": {
      "code": "430040",
      "name": "球磨地方",
      "enName": "Kuma Region"
    },
    "class20": {
      "code": "4350100",
      "name": "錦町",
      "enName": "Nishiki Town",
      "kana": "にしきまち",
      "chName": "锦町",
      "zhName": "錦町",
      "koName": "니시키 정",
      "esName": "Pueblo de Nishiki",
      "ptName": "bairro de Nishiki",
      "thName": "เมืองนิชิกิ",
      "viName": "thị trấn Nishiki",
      "inName": "kota Nishiki",
      "tlName": "bayan ng Nishiki",
      "moName": "Нишики жижиг хот",
      "buName": "နီရှိကိ မြို့နယ်",
      "khName": "ទីប្រជុំជន នីស៊ីគី",
      "neName": "निशिकी नगर"
    }
  },
  "4350500": {
    "office": {
      "code": "430000",
      "name": "熊本県",
      "enName": "Kumamoto",
      "officeName": "熊本地方気象台",
      "chName": "熊本县",
      "zhName": "熊本縣",
      "koName": "구마모토현",
      "esName": "Prefectura de Kumamoto",
      "ptName": "Província de Kumamoto",
      "thName": "จังหวัดคุมาโมโตะ",
      "viName": "Tỉnh Kumamoto",
      "inName": "Prefektur Kumamoto",
      "tlName": "Kumamoto Prefecture",
      "moName": "Күматомо аймаг",
      "buName": "ကူမာမိုတို ပြည်နယ်",
      "khName": "ខេត្ដ គូម៉ាម៉ូតូ",
      "neName": "कुमामोतो जिल्ला"
    },
    "class10": {
      "code": "430040",
      "name": "球磨地方",
      "enName": "Kuma Region",
      "chName": "熊本县球磨地方",
      "zhName": "熊本縣球磨地方",
      "koName": "쿠마모토현 구마 지방",
      "esName": "Región Kuma, Prefectura de Kumamoto",
      "ptName": "Região de Kuma da Província de Kumamoto",
      "thName": "ท้องถิ่นคุมะ จังหวัดคุมาโมโตะ",
      "viName": "Vùng Kuma, tỉnh Kumamoto",
      "inName": "Daerah Kuma di Prefektur Kumamoto",
      "tlName": "Rehiyon ng Kuma sa Kumamoto Prefecture",
      "moName": "Күмамото аймаг, Күма муж",
      "buName": "ကုမဒေသ၊ ကုမမိုတိုစီရင်စု",
      "khName": "តំបន់គឺម៉ានៃខេត្ដឃឹម៉ាម៉ុតុ",
      "neName": "कुमामोतो जिल्ला, कुमा क्षेत्र"
    },
    "class15": {
      "code": "430040",
      "name": "球磨地方",
      "enName": "Kuma Region"
    },
    "class20": {
      "code": "4350500",
      "name": "多良木町",
      "enName": "Taragi Town",
      "kana": "たらぎまち",
      "chName": "多良木町",
      "zhName": "多良木町",
      "koName": "다라기 정",
      "esName": "Pueblo de Taragi",
      "ptName": "bairro de Taragi",
      "thName": "เมืองทารางิ",
      "viName": "thị trấn Taragi",
      "inName": "kota Taragi",
      "tlName": "bayan ng Taragi",
      "moName": "Тараги жижиг хот",
      "buName": "တာရာ့ဂိ မြို့နယ်",
      "khName": "ទីប្រជុំជន តារ៉ាជី",
      "neName": "तारागी नगर"
    }
  },
  "4350600": {
    "office": {
      "code": "430000",
      "name": "熊本県",
      "enName": "Kumamoto",
      "officeName": "熊本地方気象台",
      "chName": "熊本县",
      "zhName": "熊本縣",
      "koName": "구마모토현",
      "esName": "Prefectura de Kumamoto",
      "ptName": "Província de Kumamoto",
      "thName": "จังหวัดคุมาโมโตะ",
      "viName": "Tỉnh Kumamoto",
      "inName": "Prefektur Kumamoto",
      "tlName": "Kumamoto Prefecture",
      "moName": "Күматомо аймаг",
      "buName": "ကူမာမိုတို ပြည်နယ်",
      "khName": "ខេត្ដ គូម៉ាម៉ូតូ",
      "neName": "कुमामोतो जिल्ला"
    },
    "class10": {
      "code": "430040",
      "name": "球磨地方",
      "enName": "Kuma Region",
      "chName": "熊本县球磨地方",
      "zhName": "熊本縣球磨地方",
      "koName": "쿠마모토현 구마 지방",
      "esName": "Región Kuma, Prefectura de Kumamoto",
      "ptName": "Região de Kuma da Província de Kumamoto",
      "thName": "ท้องถิ่นคุมะ จังหวัดคุมาโมโตะ",
      "viName": "Vùng Kuma, tỉnh Kumamoto",
      "inName": "Daerah Kuma di Prefektur Kumamoto",
      "tlName": "Rehiyon ng Kuma sa Kumamoto Prefecture",
      "moName": "Күмамото аймаг, Күма муж",
      "buName": "ကုမဒေသ၊ ကုမမိုတိုစီရင်စု",
      "khName": "តំបន់គឺម៉ានៃខេត្ដឃឹម៉ាម៉ុតុ",
      "neName": "कुमामोतो जिल्ला, कुमा क्षेत्र"
    },
    "class15": {
      "code": "430040",
      "name": "球磨地方",
      "enName": "Kuma Region"
    },
    "class20": {
      "code": "4350600",
      "name": "湯前町",
      "enName": "Yunomae Town",
      "kana": "ゆのまえまち",
      "chName": "汤前町",
      "zhName": "湯前町",
      "koName": "유노마에 정",
      "esName": "Pueblo de Yunomae",
      "ptName": "bairro de Yunomae",
      "thName": "เมืองยูโนะมาเอะ",
      "viName": "thị trấn Yunomae",
      "inName": "kota Yunomae",
      "tlName": "bayan ng Yunomae",
      "moName": "Юномaэ жижиг хот",
      "buName": "ယူနိုမားအဲ့ မြို့နယ်",
      "khName": "ទីប្រជុំជន យូណូមេ",
      "neName": "युनोमाए नगर"
    }
  },
  "4350700": {
    "office": {
      "code": "430000",
      "name": "熊本県",
      "enName": "Kumamoto",
      "officeName": "熊本地方気象台",
      "chName": "熊本县",
      "zhName": "熊本縣",
      "koName": "구마모토현",
      "esName": "Prefectura de Kumamoto",
      "ptName": "Província de Kumamoto",
      "thName": "จังหวัดคุมาโมโตะ",
      "viName": "Tỉnh Kumamoto",
      "inName": "Prefektur Kumamoto",
      "tlName": "Kumamoto Prefecture",
      "moName": "Күматомо аймаг",
      "buName": "ကူမာမိုတို ပြည်နယ်",
      "khName": "ខេត្ដ គូម៉ាម៉ូតូ",
      "neName": "कुमामोतो जिल्ला"
    },
    "class10": {
      "code": "430040",
      "name": "球磨地方",
      "enName": "Kuma Region",
      "chName": "熊本县球磨地方",
      "zhName": "熊本縣球磨地方",
      "koName": "쿠마모토현 구마 지방",
      "esName": "Región Kuma, Prefectura de Kumamoto",
      "ptName": "Região de Kuma da Província de Kumamoto",
      "thName": "ท้องถิ่นคุมะ จังหวัดคุมาโมโตะ",
      "viName": "Vùng Kuma, tỉnh Kumamoto",
      "inName": "Daerah Kuma di Prefektur Kumamoto",
      "tlName": "Rehiyon ng Kuma sa Kumamoto Prefecture",
      "moName": "Күмамото аймаг, Күма муж",
      "buName": "ကုမဒေသ၊ ကုမမိုတိုစီရင်စု",
      "khName": "តំបន់គឺម៉ានៃខេត្ដឃឹម៉ាម៉ុតុ",
      "neName": "कुमामोतो जिल्ला, कुमा क्षेत्र"
    },
    "class15": {
      "code": "430040",
      "name": "球磨地方",
      "enName": "Kuma Region"
    },
    "class20": {
      "code": "4350700",
      "name": "水上村",
      "enName": "Mizukami Village",
      "kana": "みずかみむら",
      "chName": "水上村",
      "zhName": "水上村",
      "koName": "미즈카미 촌",
      "esName": "Aldea de Mizukami",
      "ptName": "povoado de Mizukami",
      "thName": "หมู่บ้านมิซุคามิ",
      "viName": "làng Mizukami",
      "inName": "desa Mizukami",
      "tlName": "nayon ng Mizukami",
      "moName": "Мизүками тосгон",
      "buName": "မီဇုကာ့မိ ကျေးရွာ",
      "khName": "ភូមិ មីហ្សុកាមី",
      "neName": "मिज़ुकामी गाउँ"
    }
  },
  "4351000": {
    "office": {
      "code": "430000",
      "name": "熊本県",
      "enName": "Kumamoto",
      "officeName": "熊本地方気象台",
      "chName": "熊本县",
      "zhName": "熊本縣",
      "koName": "구마모토현",
      "esName": "Prefectura de Kumamoto",
      "ptName": "Província de Kumamoto",
      "thName": "จังหวัดคุมาโมโตะ",
      "viName": "Tỉnh Kumamoto",
      "inName": "Prefektur Kumamoto",
      "tlName": "Kumamoto Prefecture",
      "moName": "Күматомо аймаг",
      "buName": "ကူမာမိုတို ပြည်နယ်",
      "khName": "ខេត្ដ គូម៉ាម៉ូតូ",
      "neName": "कुमामोतो जिल्ला"
    },
    "class10": {
      "code": "430040",
      "name": "球磨地方",
      "enName": "Kuma Region",
      "chName": "熊本县球磨地方",
      "zhName": "熊本縣球磨地方",
      "koName": "쿠마모토현 구마 지방",
      "esName": "Región Kuma, Prefectura de Kumamoto",
      "ptName": "Região de Kuma da Província de Kumamoto",
      "thName": "ท้องถิ่นคุมะ จังหวัดคุมาโมโตะ",
      "viName": "Vùng Kuma, tỉnh Kumamoto",
      "inName": "Daerah Kuma di Prefektur Kumamoto",
      "tlName": "Rehiyon ng Kuma sa Kumamoto Prefecture",
      "moName": "Күмамото аймаг, Күма муж",
      "buName": "ကုမဒေသ၊ ကုမမိုတိုစီရင်စု",
      "khName": "តំបន់គឺម៉ានៃខេត្ដឃឹម៉ាម៉ុតុ",
      "neName": "कुमामोतो जिल्ला, कुमा क्षेत्र"
    },
    "class15": {
      "code": "430040",
      "name": "球磨地方",
      "enName": "Kuma Region"
    },
    "class20": {
      "code": "4351000",
      "name": "相良村",
      "enName": "Sagara Village",
      "kana": "さがらむら",
      "chName": "相良村",
      "zhName": "相良村",
      "koName": "사가라 촌",
      "esName": "Aldea de Sagara",
      "ptName": "povoado de Sagara",
      "thName": "หมู่บ้านซางาระ",
      "viName": "làng Sagara",
      "inName": "desa Sagara",
      "tlName": "nayon ng Sagara",
      "moName": "Сaгарa тосгон",
      "buName": "ဆားဂါ့ရာ့ မြို့နယ်",
      "khName": "ភូមិ សាការ៉ា",
      "neName": "सागारा गाउँ"
    }
  },
  "4351100": {
    "office": {
      "code": "430000",
      "name": "熊本県",
      "enName": "Kumamoto",
      "officeName": "熊本地方気象台",
      "chName": "熊本县",
      "zhName": "熊本縣",
      "koName": "구마모토현",
      "esName": "Prefectura de Kumamoto",
      "ptName": "Província de Kumamoto",
      "thName": "จังหวัดคุมาโมโตะ",
      "viName": "Tỉnh Kumamoto",
      "inName": "Prefektur Kumamoto",
      "tlName": "Kumamoto Prefecture",
      "moName": "Күматомо аймаг",
      "buName": "ကူမာမိုတို ပြည်နယ်",
      "khName": "ខេត្ដ គូម៉ាម៉ូតូ",
      "neName": "कुमामोतो जिल्ला"
    },
    "class10": {
      "code": "430040",
      "name": "球磨地方",
      "enName": "Kuma Region",
      "chName": "熊本县球磨地方",
      "zhName": "熊本縣球磨地方",
      "koName": "쿠마모토현 구마 지방",
      "esName": "Región Kuma, Prefectura de Kumamoto",
      "ptName": "Região de Kuma da Província de Kumamoto",
      "thName": "ท้องถิ่นคุมะ จังหวัดคุมาโมโตะ",
      "viName": "Vùng Kuma, tỉnh Kumamoto",
      "inName": "Daerah Kuma di Prefektur Kumamoto",
      "tlName": "Rehiyon ng Kuma sa Kumamoto Prefecture",
      "moName": "Күмамото аймаг, Күма муж",
      "buName": "ကုမဒေသ၊ ကုမမိုတိုစီရင်စု",
      "khName": "តំបន់គឺម៉ានៃខេត្ដឃឹម៉ាម៉ុតុ",
      "neName": "कुमामोतो जिल्ला, कुमा क्षेत्र"
    },
    "class15": {
      "code": "430040",
      "name": "球磨地方",
      "enName": "Kuma Region"
    },
    "class20": {
      "code": "4351100",
      "name": "五木村",
      "enName": "Itsuki Village",
      "kana": "いつきむら",
      "chName": "五木村",
      "zhName": "五木村",
      "koName": "이쓰키 촌",
      "esName": "Aldea de Itsuki",
      "ptName": "povoado de Itsuki",
      "thName": "หมู่บ้านอิสึงิ",
      "viName": "làng Itsuki",
      "inName": "desa Itsuki",
      "tlName": "nayon ng Itsuki",
      "moName": "Ицүки тосгон",
      "buName": "အိဆုကိ ကျေးရွာ",
      "khName": "ភូមិ អ៊ីតស៊ូគី",
      "neName": "इत्सुकी गाउँ"
    }
  },
  "4351200": {
    "office": {
      "code": "430000",
      "name": "熊本県",
      "enName": "Kumamoto",
      "officeName": "熊本地方気象台",
      "chName": "熊本县",
      "zhName": "熊本縣",
      "koName": "구마모토현",
      "esName": "Prefectura de Kumamoto",
      "ptName": "Província de Kumamoto",
      "thName": "จังหวัดคุมาโมโตะ",
      "viName": "Tỉnh Kumamoto",
      "inName": "Prefektur Kumamoto",
      "tlName": "Kumamoto Prefecture",
      "moName": "Күматомо аймаг",
      "buName": "ကူမာမိုတို ပြည်နယ်",
      "khName": "ខេត្ដ គូម៉ាម៉ូតូ",
      "neName": "कुमामोतो जिल्ला"
    },
    "class10": {
      "code": "430040",
      "name": "球磨地方",
      "enName": "Kuma Region",
      "chName": "熊本县球磨地方",
      "zhName": "熊本縣球磨地方",
      "koName": "쿠마모토현 구마 지방",
      "esName": "Región Kuma, Prefectura de Kumamoto",
      "ptName": "Região de Kuma da Província de Kumamoto",
      "thName": "ท้องถิ่นคุมะ จังหวัดคุมาโมโตะ",
      "viName": "Vùng Kuma, tỉnh Kumamoto",
      "inName": "Daerah Kuma di Prefektur Kumamoto",
      "tlName": "Rehiyon ng Kuma sa Kumamoto Prefecture",
      "moName": "Күмамото аймаг, Күма муж",
      "buName": "ကုမဒေသ၊ ကုမမိုတိုစီရင်စု",
      "khName": "តំបន់គឺម៉ានៃខេត្ដឃឹម៉ាម៉ុតុ",
      "neName": "कुमामोतो जिल्ला, कुमा क्षेत्र"
    },
    "class15": {
      "code": "430040",
      "name": "球磨地方",
      "enName": "Kuma Region"
    },
    "class20": {
      "code": "4351200",
      "name": "山江村",
      "enName": "Yamae Village",
      "kana": "やまえむら",
      "chName": "山江村",
      "zhName": "山江村",
      "koName": "야마데 촌",
      "esName": "Aldea de Yamae",
      "ptName": "povoado de Yamae",
      "thName": "หมู่บ้านยามาเอะ",
      "viName": "làng Yamae",
      "inName": "desa Yamae",
      "tlName": "nayon ng Yamae",
      "moName": "Ямaэ тосгон",
      "buName": "ယားမာအဲ့ ကျေးရွာ",
      "khName": "ភូមិ យ៉ាមេ",
      "neName": "यामाए गाउँ"
    }
  },
  "4351300": {
    "office": {
      "code": "430000",
      "name": "熊本県",
      "enName": "Kumamoto",
      "officeName": "熊本地方気象台",
      "chName": "熊本县",
      "zhName": "熊本縣",
      "koName": "구마모토현",
      "esName": "Prefectura de Kumamoto",
      "ptName": "Província de Kumamoto",
      "thName": "จังหวัดคุมาโมโตะ",
      "viName": "Tỉnh Kumamoto",
      "inName": "Prefektur Kumamoto",
      "tlName": "Kumamoto Prefecture",
      "moName": "Күматомо аймаг",
      "buName": "ကူမာမိုတို ပြည်နယ်",
      "khName": "ខេត្ដ គូម៉ាម៉ូតូ",
      "neName": "कुमामोतो जिल्ला"
    },
    "class10": {
      "code": "430040",
      "name": "球磨地方",
      "enName": "Kuma Region",
      "chName": "熊本县球磨地方",
      "zhName": "熊本縣球磨地方",
      "koName": "쿠마모토현 구마 지방",
      "esName": "Región Kuma, Prefectura de Kumamoto",
      "ptName": "Região de Kuma da Província de Kumamoto",
      "thName": "ท้องถิ่นคุมะ จังหวัดคุมาโมโตะ",
      "viName": "Vùng Kuma, tỉnh Kumamoto",
      "inName": "Daerah Kuma di Prefektur Kumamoto",
      "tlName": "Rehiyon ng Kuma sa Kumamoto Prefecture",
      "moName": "Күмамото аймаг, Күма муж",
      "buName": "ကုမဒေသ၊ ကုမမိုတိုစီရင်စု",
      "khName": "តំបន់គឺម៉ានៃខេត្ដឃឹម៉ាម៉ុតុ",
      "neName": "कुमामोतो जिल्ला, कुमा क्षेत्र"
    },
    "class15": {
      "code": "430040",
      "name": "球磨地方",
      "enName": "Kuma Region"
    },
    "class20": {
      "code": "4351300",
      "name": "球磨村",
      "enName": "Kuma Village",
      "kana": "くまむら",
      "chName": "球磨村",
      "zhName": "球磨村",
      "koName": "구마 촌",
      "esName": "Aldea de Kuma",
      "ptName": "povoado de Kuma",
      "thName": "หมู่บ้านคุมะ",
      "viName": "làng Kuma",
      "inName": "desa Kuma",
      "tlName": "nayon ng Kuma",
      "moName": "Күмa тосгон",
      "buName": "ခူမ ကျေးရွာ",
      "khName": "ភូមិ គូម៉ា",
      "neName": "कुमा गाउँ"
    }
  },
  "4351400": {
    "office": {
      "code": "430000",
      "name": "熊本県",
      "enName": "Kumamoto",
      "officeName": "熊本地方気象台",
      "chName": "熊本县",
      "zhName": "熊本縣",
      "koName": "구마모토현",
      "esName": "Prefectura de Kumamoto",
      "ptName": "Província de Kumamoto",
      "thName": "จังหวัดคุมาโมโตะ",
      "viName": "Tỉnh Kumamoto",
      "inName": "Prefektur Kumamoto",
      "tlName": "Kumamoto Prefecture",
      "moName": "Күматомо аймаг",
      "buName": "ကူမာမိုတို ပြည်နယ်",
      "khName": "ខេត្ដ គូម៉ាម៉ូតូ",
      "neName": "कुमामोतो जिल्ला"
    },
    "class10": {
      "code": "430040",
      "name": "球磨地方",
      "enName": "Kuma Region",
      "chName": "熊本县球磨地方",
      "zhName": "熊本縣球磨地方",
      "koName": "쿠마모토현 구마 지방",
      "esName": "Región Kuma, Prefectura de Kumamoto",
      "ptName": "Região de Kuma da Província de Kumamoto",
      "thName": "ท้องถิ่นคุมะ จังหวัดคุมาโมโตะ",
      "viName": "Vùng Kuma, tỉnh Kumamoto",
      "inName": "Daerah Kuma di Prefektur Kumamoto",
      "tlName": "Rehiyon ng Kuma sa Kumamoto Prefecture",
      "moName": "Күмамото аймаг, Күма муж",
      "buName": "ကုမဒေသ၊ ကုမမိုတိုစီရင်စု",
      "khName": "តំបន់គឺម៉ានៃខេត្ដឃឹម៉ាម៉ុតុ",
      "neName": "कुमामोतो जिल्ला, कुमा क्षेत्र"
    },
    "class15": {
      "code": "430040",
      "name": "球磨地方",
      "enName": "Kuma Region"
    },
    "class20": {
      "code": "4351400",
      "name": "あさぎり町",
      "enName": "Asagiri Town",
      "kana": "あさぎりちょう",
      "chName": "朝雾町",
      "zhName": "朝霧町",
      "koName": "아시기리 정",
      "esName": "Pueblo de Asagiri",
      "ptName": "bairro de Asagiri",
      "thName": "เมืองอาซางิริ",
      "viName": "thị trấn Asagiri",
      "inName": "kota Asagiri",
      "tlName": "bayan ng Asagiri",
      "moName": "Aсaгири жижиг хот",
      "buName": "အဆာဂိရိ မြို့နယ်",
      "khName": "ទីប្រជុំជន អាសាហ្គីរី",
      "neName": "आसागिरी नगर"
    }
  },
  "4353100": {
    "office": {
      "code": "430000",
      "name": "熊本県",
      "enName": "Kumamoto",
      "officeName": "熊本地方気象台",
      "chName": "熊本县",
      "zhName": "熊本縣",
      "koName": "구마모토현",
      "esName": "Prefectura de Kumamoto",
      "ptName": "Província de Kumamoto",
      "thName": "จังหวัดคุมาโมโตะ",
      "viName": "Tỉnh Kumamoto",
      "inName": "Prefektur Kumamoto",
      "tlName": "Kumamoto Prefecture",
      "moName": "Күматомо аймаг",
      "buName": "ကူမာမိုတို ပြည်နယ်",
      "khName": "ខេត្ដ គូម៉ាម៉ូតូ",
      "neName": "कुमामोतो जिल्ला"
    },
    "class10": {
      "code": "430030",
      "name": "天草・芦北地方",
      "enName": "Amakusa Ashikita Region",
      "chName": "熊本县天草、芦北地方",
      "zhName": "熊本縣天草・蘆北地方",
      "koName": "구마모토 현 아마쿠사·아시 키타 지방",
      "esName": "Región Amakusa-Ashikita, Prefectura de Kumamoto",
      "ptName": "Região de Amakusa・Ashikita da Província de Kumamoto",
      "thName": "ท้องถิ่นอะมากุสะและอะชิกิตะ จังหวัดคุมาโมโตะ",
      "viName": "Vùng Amakusa và Ashikita, tỉnh Kumamoto",
      "inName": "Daerah Amakusa dan Ashikita di Prefektur Kumamoto",
      "tlName": "Rehiyon ng Amakusa at Ashikita sa Kumamoto Prefecture",
      "moName": "Күмамото аймаг, Амакүса・Ашикита муж",
      "buName": "အမကုဆ၊ အရှိခိတဒေသ၊ ကုမမိုတိုစီရင်စု",
      "khName": "តំបន់អាម៉ាគឹសា/អាស៊ីគីតាក់នៃខេត្ដឃឹម៉ាម៉ុតុ",
      "neName": "कुमामोतो जिल्ला, आमाकुसा र आसिकिता क्षेत्र"
    },
    "class15": {
      "code": "430031",
      "name": "天草地方",
      "enName": "Amakusa Region"
    },
    "class20": {
      "code": "4353100",
      "name": "苓北町",
      "enName": "Reihoku Town",
      "kana": "れいほくまち",
      "chName": "苓北町",
      "zhName": "苓北町",
      "koName": "레이호쿠 정",
      "esName": "Pueblo de Reihoku",
      "ptName": "bairro de Reihoku",
      "thName": "เมืองเรโฮขุ",
      "viName": "thị trấn Reihoku",
      "inName": "kota Reihoku",
      "tlName": "bayan ng Reihoku",
      "moName": "Рэйхокү жижиг хот",
      "buName": "ရေးယိဟိုကု မြို့နယ်",
      "khName": "ទីប្រជុំជន រ៉េហ៊ុគូ",
      "neName": "रेइहोकु नगर"
    }
  },
  "4420100": {
    "office": {
      "code": "440000",
      "name": "大分県",
      "enName": "Oita",
      "officeName": "大分地方気象台",
      "chName": "大分县",
      "zhName": "大分縣",
      "koName": "오이타현",
      "esName": "Prefectura de Oita",
      "ptName": "Província de Ōita",
      "thName": "จังหวัดโออิตะ",
      "viName": "Tỉnh Oita",
      "inName": "Prefektur Oita",
      "tlName": "Oita Prefecture",
      "moName": "Ойта аймаг",
      "buName": "အိုယိတ ပြည်နယ်",
      "khName": "ខេត្ដ អូតា",
      "neName": "ओइता जिल्ला"
    },
    "class10": {
      "code": "440010",
      "name": "中部",
      "enName": "Central Region",
      "chName": "大分县中部",
      "zhName": "大分縣中部",
      "koName": "오이타 현 중부",
      "esName": "Centro de Prefectura de Oita",
      "ptName": "Região central da Província de Ōita",
      "thName": "จังหวัดโออิตะตอนกลาง",
      "viName": "Miền Trung tỉnh Oita",
      "inName": "Bagian Tengah Prefektur Oita",
      "tlName": "Sentral na bahagi ng Oita Prefecture",
      "moName": "Төв Оита аймаг",
      "buName": "အအိုတစီရင်စု အလယ်ပိုင်း",
      "khName": "តំបន់កណ្តាលនៃខេត្ដអយតាក់",
      "neName": "ओइता जिल्लाको मध्य भाग"
    },
    "class15": {
      "code": "440010",
      "name": "中部",
      "enName": "Central Region"
    },
    "class20": {
      "code": "4420100",
      "name": "大分市",
      "enName": "Oita City",
      "kana": "おおいたし",
      "chName": "大分市",
      "zhName": "大分市",
      "koName": "오이타 시",
      "esName": "Ciudad de Oita",
      "ptName": "cidade de Oita",
      "thName": "เมืองโออิตะ",
      "viName": "thành phố Oita",
      "inName": "kota Oita",
      "tlName": "siyudad ng Oita",
      "moName": "Ойта хот",
      "buName": "အိုယိတ မြို့",
      "khName": "ទីក្រុង អយតា",
      "neName": "ओइशि सहर"
    }
  },
  "4420200": {
    "office": {
      "code": "440000",
      "name": "大分県",
      "enName": "Oita",
      "officeName": "大分地方気象台",
      "chName": "大分县",
      "zhName": "大分縣",
      "koName": "오이타현",
      "esName": "Prefectura de Oita",
      "ptName": "Província de Ōita",
      "thName": "จังหวัดโออิตะ",
      "viName": "Tỉnh Oita",
      "inName": "Prefektur Oita",
      "tlName": "Oita Prefecture",
      "moName": "Ойта аймаг",
      "buName": "အိုယိတ ပြည်နယ်",
      "khName": "ខេត្ដ អូតា",
      "neName": "ओइता जिल्ला"
    },
    "class10": {
      "code": "440010",
      "name": "中部",
      "enName": "Central Region",
      "chName": "大分县中部",
      "zhName": "大分縣中部",
      "koName": "오이타 현 중부",
      "esName": "Centro de Prefectura de Oita",
      "ptName": "Região central da Província de Ōita",
      "thName": "จังหวัดโออิตะตอนกลาง",
      "viName": "Miền Trung tỉnh Oita",
      "inName": "Bagian Tengah Prefektur Oita",
      "tlName": "Sentral na bahagi ng Oita Prefecture",
      "moName": "Төв Оита аймаг",
      "buName": "အအိုတစီရင်စု အလယ်ပိုင်း",
      "khName": "តំបន់កណ្តាលនៃខេត្ដអយតាក់",
      "neName": "ओइता जिल्लाको मध्य भाग"
    },
    "class15": {
      "code": "440010",
      "name": "中部",
      "enName": "Central Region"
    },
    "class20": {
      "code": "4420200",
      "name": "別府市",
      "enName": "Beppu City",
      "kana": "べっぷし",
      "chName": "别府市",
      "zhName": "別府市",
      "koName": "벳푸 시",
      "esName": "Ciudad de Beppu",
      "ptName": "cidade de Beppu",
      "thName": "เมืองเบปปุ",
      "viName": "thành phố Beppu",
      "inName": "kota Beppu",
      "tlName": "siyudad ng Beppu",
      "moName": "Бэппү хот",
      "buName": "ဗဲပု မြို့",
      "khName": "ទីក្រុង បេបភូ",
      "neName": "बेप्पु सहर"
    }
  },
  "4420300": {
    "office": {
      "code": "440000",
      "name": "大分県",
      "enName": "Oita",
      "officeName": "大分地方気象台",
      "chName": "大分县",
      "zhName": "大分縣",
      "koName": "오이타현",
      "esName": "Prefectura de Oita",
      "ptName": "Província de Ōita",
      "thName": "จังหวัดโออิตะ",
      "viName": "Tỉnh Oita",
      "inName": "Prefektur Oita",
      "tlName": "Oita Prefecture",
      "moName": "Ойта аймаг",
      "buName": "အိုယိတ ပြည်နယ်",
      "khName": "ខេត្ដ អូតា",
      "neName": "ओइता जिल्ला"
    },
    "class10": {
      "code": "440020",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "大分县北部",
      "zhName": "大分縣北部",
      "koName": "오이타 현 북부",
      "esName": "Norte de Prefectura de Oita",
      "ptName": "Norte da Província de Ōita",
      "thName": "จังหวัดโออิตะตอนเหนือ",
      "viName": "Miền Bắc tỉnh Oita",
      "inName": "Bagian Utara Prefektur Oita",
      "tlName": "Hilagang bahagi ng Oita Prefecture",
      "moName": "Хойд Оита аймаг",
      "buName": "အအိုတစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដអយតាក់",
      "neName": "ओइता जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "440020",
      "name": "北部",
      "enName": "Northern Region"
    },
    "class20": {
      "code": "4420300",
      "name": "中津市",
      "enName": "Nakatsu City",
      "kana": "なかつし",
      "chName": "中津市",
      "zhName": "中津市",
      "koName": "나카쓰 시",
      "esName": "Ciudad de Nakatsu",
      "ptName": "cidade de Nakatsu",
      "thName": "เมืองนางัตสึ",
      "viName": "thành phố Nakatsu",
      "inName": "kota Nakatsu",
      "tlName": "siyudad ng Nakatsu",
      "moName": "Нaкацү хот",
      "buName": "နားကာ့ဆု မြို့",
      "khName": "ទីក្រុង ណាកាតស៊ូ",
      "neName": "नाकात्सु सहर"
    }
  },
  "4420400": {
    "office": {
      "code": "440000",
      "name": "大分県",
      "enName": "Oita",
      "officeName": "大分地方気象台",
      "chName": "大分县",
      "zhName": "大分縣",
      "koName": "오이타현",
      "esName": "Prefectura de Oita",
      "ptName": "Província de Ōita",
      "thName": "จังหวัดโออิตะ",
      "viName": "Tỉnh Oita",
      "inName": "Prefektur Oita",
      "tlName": "Oita Prefecture",
      "moName": "Ойта аймаг",
      "buName": "အိုယိတ ပြည်နယ်",
      "khName": "ខេត្ដ អូតា",
      "neName": "ओइता जिल्ला"
    },
    "class10": {
      "code": "440030",
      "name": "西部",
      "enName": "Western Region",
      "chName": "大分县西部",
      "zhName": "大分縣西部",
      "koName": "오이타 현 서부",
      "esName": "Oeste de Prefectura de Oita",
      "ptName": "Oeste da Província de Ōita",
      "thName": "จังหวัดโออิตะฟากตะวันตก",
      "viName": "Miền Tây tỉnh Oita",
      "inName": "Bagian Barat Prefekture Oita",
      "tlName": "Silangang bahagi ng Oita Prefecture",
      "moName": "Баруун Оита аймаг",
      "buName": "အအိုတစီရင်စု အနောက်ပိုင်း",
      "khName": "តំបន់ខាងលិចនៃខេត្ដអយតាក់",
      "neName": "ओइता जिल्लाको पश्चिमी भाग"
    },
    "class15": {
      "code": "440031",
      "name": "日田玖珠",
      "enName": "Hita Kusu"
    },
    "class20": {
      "code": "4420400",
      "name": "日田市",
      "enName": "Hita City",
      "kana": "ひたし",
      "chName": "日田市",
      "zhName": "日田市",
      "koName": "히타 시",
      "esName": "Ciudad de Hita",
      "ptName": "cidade de Hita",
      "thName": "เมืองฮิตะ",
      "viName": "thành phố Hita",
      "inName": "kota Hita",
      "tlName": "siyudad ng Hita",
      "moName": "Хита хот",
      "buName": "ဟီးတ မြို့",
      "khName": "ទីក្រុង ហ៊ីតា",
      "neName": "हिता सहर"
    }
  },
  "4420500": {
    "office": {
      "code": "440000",
      "name": "大分県",
      "enName": "Oita",
      "officeName": "大分地方気象台",
      "chName": "大分县",
      "zhName": "大分縣",
      "koName": "오이타현",
      "esName": "Prefectura de Oita",
      "ptName": "Província de Ōita",
      "thName": "จังหวัดโออิตะ",
      "viName": "Tỉnh Oita",
      "inName": "Prefektur Oita",
      "tlName": "Oita Prefecture",
      "moName": "Ойта аймаг",
      "buName": "အိုယိတ ပြည်နယ်",
      "khName": "ខេត្ដ អូតា",
      "neName": "ओइता जिल्ला"
    },
    "class10": {
      "code": "440040",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "大分县南部",
      "zhName": "大分縣南部",
      "koName": "오이타 현 남부",
      "esName": "Sur de Prefectura de Oita",
      "ptName": "Sul da Província de Ōita",
      "thName": "จังหวัดโออิตะตอนใต้",
      "viName": "Miền Nam tỉnh Oita",
      "inName": "Bagian Selatan Prefektur Oita",
      "tlName": "Timog na bahagi ng Oita Prefecture",
      "moName": "Өмнөд Оита аймаг",
      "buName": "အအိုတစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដអយតាក់",
      "neName": "ओइता जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "440041",
      "name": "佐伯市",
      "enName": "Saiki City"
    },
    "class20": {
      "code": "4420500",
      "name": "佐伯市",
      "enName": "Saiki City",
      "kana": "さいきし",
      "chName": "佐伯市",
      "zhName": "佐伯市",
      "koName": "사이키 시",
      "esName": "Ciudad de Saiki",
      "ptName": "cidade de Saiki",
      "thName": "เมืองไซกิ",
      "viName": "thành phố Saiki",
      "inName": "kota Saiki",
      "tlName": "siyudad ng Saiki",
      "moName": "Сaйки хот",
      "buName": "ဆိုင်ယိကိ မြို့",
      "khName": "ទីក្រុង សៃគី",
      "neName": "साइकी सहर"
    }
  },
  "4420600": {
    "office": {
      "code": "440000",
      "name": "大分県",
      "enName": "Oita",
      "officeName": "大分地方気象台",
      "chName": "大分县",
      "zhName": "大分縣",
      "koName": "오이타현",
      "esName": "Prefectura de Oita",
      "ptName": "Província de Ōita",
      "thName": "จังหวัดโออิตะ",
      "viName": "Tỉnh Oita",
      "inName": "Prefektur Oita",
      "tlName": "Oita Prefecture",
      "moName": "Ойта аймаг",
      "buName": "အိုယိတ ပြည်နယ်",
      "khName": "ខេត្ដ អូតា",
      "neName": "ओइता जिल्ला"
    },
    "class10": {
      "code": "440010",
      "name": "中部",
      "enName": "Central Region",
      "chName": "大分县中部",
      "zhName": "大分縣中部",
      "koName": "오이타 현 중부",
      "esName": "Centro de Prefectura de Oita",
      "ptName": "Região central da Província de Ōita",
      "thName": "จังหวัดโออิตะตอนกลาง",
      "viName": "Miền Trung tỉnh Oita",
      "inName": "Bagian Tengah Prefektur Oita",
      "tlName": "Sentral na bahagi ng Oita Prefecture",
      "moName": "Төв Оита аймаг",
      "buName": "အအိုတစီရင်စု အလယ်ပိုင်း",
      "khName": "តំបន់កណ្តាលនៃខេត្ដអយតាក់",
      "neName": "ओइता जिल्लाको मध्य भाग"
    },
    "class15": {
      "code": "440010",
      "name": "中部",
      "enName": "Central Region"
    },
    "class20": {
      "code": "4420600",
      "name": "臼杵市",
      "enName": "Usuki City",
      "kana": "うすきし",
      "chName": "臼杵市",
      "zhName": "臼杵市",
      "koName": "우스키 시",
      "esName": "Ciudad de Usuki",
      "ptName": "cidade de Usuki",
      "thName": "เมืองอุสึกิ",
      "viName": "thành phố Usuki",
      "inName": "kota Usuki",
      "tlName": "siyudad ng Usuki",
      "moName": "Үсүки хот",
      "buName": "အူဆုကိ မြို့",
      "khName": "ទីក្រុង យូស៊ូគី",
      "neName": "उसुकी सहर"
    }
  },
  "4420700": {
    "office": {
      "code": "440000",
      "name": "大分県",
      "enName": "Oita",
      "officeName": "大分地方気象台",
      "chName": "大分县",
      "zhName": "大分縣",
      "koName": "오이타현",
      "esName": "Prefectura de Oita",
      "ptName": "Província de Ōita",
      "thName": "จังหวัดโออิตะ",
      "viName": "Tỉnh Oita",
      "inName": "Prefektur Oita",
      "tlName": "Oita Prefecture",
      "moName": "Ойта аймаг",
      "buName": "အိုယိတ ပြည်နယ်",
      "khName": "ខេត្ដ អូតា",
      "neName": "ओइता जिल्ला"
    },
    "class10": {
      "code": "440010",
      "name": "中部",
      "enName": "Central Region",
      "chName": "大分县中部",
      "zhName": "大分縣中部",
      "koName": "오이타 현 중부",
      "esName": "Centro de Prefectura de Oita",
      "ptName": "Região central da Província de Ōita",
      "thName": "จังหวัดโออิตะตอนกลาง",
      "viName": "Miền Trung tỉnh Oita",
      "inName": "Bagian Tengah Prefektur Oita",
      "tlName": "Sentral na bahagi ng Oita Prefecture",
      "moName": "Төв Оита аймаг",
      "buName": "အအိုတစီရင်စု အလယ်ပိုင်း",
      "khName": "តំបន់កណ្តាលនៃខេត្ដអយតាក់",
      "neName": "ओइता जिल्लाको मध्य भाग"
    },
    "class15": {
      "code": "440010",
      "name": "中部",
      "enName": "Central Region"
    },
    "class20": {
      "code": "4420700",
      "name": "津久見市",
      "enName": "Tsukumi City",
      "kana": "つくみし",
      "chName": "津久见市",
      "zhName": "津久見市",
      "koName": "쓰쿠미 시",
      "esName": "Ciudad de Tsukumi",
      "ptName": "cidade de Tsukumi",
      "thName": "เมืองสึคุมิ",
      "viName": "thành phố Tsukumi",
      "inName": "kota Tsukumi",
      "tlName": "siyudad ng Tsukumi",
      "moName": "Цүкүми хот",
      "buName": "ဆုကုမိ မြို့",
      "khName": "ទីក្រុង ស៊ូគូមី",
      "neName": "त्सुकुमी सहर"
    }
  },
  "4420800": {
    "office": {
      "code": "440000",
      "name": "大分県",
      "enName": "Oita",
      "officeName": "大分地方気象台",
      "chName": "大分县",
      "zhName": "大分縣",
      "koName": "오이타현",
      "esName": "Prefectura de Oita",
      "ptName": "Província de Ōita",
      "thName": "จังหวัดโออิตะ",
      "viName": "Tỉnh Oita",
      "inName": "Prefektur Oita",
      "tlName": "Oita Prefecture",
      "moName": "Ойта аймаг",
      "buName": "အိုယိတ ပြည်နယ်",
      "khName": "ខេត្ដ អូតា",
      "neName": "ओइता जिल्ला"
    },
    "class10": {
      "code": "440030",
      "name": "西部",
      "enName": "Western Region",
      "chName": "大分县西部",
      "zhName": "大分縣西部",
      "koName": "오이타 현 서부",
      "esName": "Oeste de Prefectura de Oita",
      "ptName": "Oeste da Província de Ōita",
      "thName": "จังหวัดโออิตะฟากตะวันตก",
      "viName": "Miền Tây tỉnh Oita",
      "inName": "Bagian Barat Prefekture Oita",
      "tlName": "Silangang bahagi ng Oita Prefecture",
      "moName": "Баруун Оита аймаг",
      "buName": "အအိုတစီရင်စု အနောက်ပိုင်း",
      "khName": "តំបន់ខាងលិចនៃខេត្ដអយតាក់",
      "neName": "ओइता जिल्लाको पश्चिमी भाग"
    },
    "class15": {
      "code": "440032",
      "name": "竹田市",
      "enName": "Taketa City"
    },
    "class20": {
      "code": "4420800",
      "name": "竹田市",
      "enName": "Taketa City",
      "kana": "たけたし",
      "chName": "竹田市",
      "zhName": "竹田市",
      "koName": "다케타 시",
      "esName": "Ciudad de Taketa",
      "ptName": "cidade de Taketa",
      "thName": "เมืองทาเคะตะ",
      "viName": "thành phố Taketa",
      "inName": "kota Taketa",
      "tlName": "siyudad ng Taketa",
      "moName": "Такэта хот",
      "buName": "တာ့ကဲ့တ မြို့",
      "khName": "ទីក្រុង តាកេតា",
      "neName": "ताकेता सहर"
    }
  },
  "4420900": {
    "office": {
      "code": "440000",
      "name": "大分県",
      "enName": "Oita",
      "officeName": "大分地方気象台",
      "chName": "大分县",
      "zhName": "大分縣",
      "koName": "오이타현",
      "esName": "Prefectura de Oita",
      "ptName": "Província de Ōita",
      "thName": "จังหวัดโออิตะ",
      "viName": "Tỉnh Oita",
      "inName": "Prefektur Oita",
      "tlName": "Oita Prefecture",
      "moName": "Ойта аймаг",
      "buName": "အိုယိတ ပြည်နယ်",
      "khName": "ខេត្ដ អូតា",
      "neName": "ओइता जिल्ला"
    },
    "class10": {
      "code": "440020",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "大分县北部",
      "zhName": "大分縣北部",
      "koName": "오이타 현 북부",
      "esName": "Norte de Prefectura de Oita",
      "ptName": "Norte da Província de Ōita",
      "thName": "จังหวัดโออิตะตอนเหนือ",
      "viName": "Miền Bắc tỉnh Oita",
      "inName": "Bagian Utara Prefektur Oita",
      "tlName": "Hilagang bahagi ng Oita Prefecture",
      "moName": "Хойд Оита аймаг",
      "buName": "အအိုတစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដអយតាក់",
      "neName": "ओइता जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "440020",
      "name": "北部",
      "enName": "Northern Region"
    },
    "class20": {
      "code": "4420900",
      "name": "豊後高田市",
      "enName": "Bungotakada City",
      "kana": "ぶんごたかだし",
      "chName": "丰后高田市",
      "zhName": "豐後髙田市",
      "koName": "분고타카다 시",
      "esName": "Ciudad de Bungo-takada",
      "ptName": "cidade de Bungotakada",
      "thName": "เมืองบุงโงะทาคาดะ",
      "viName": "thành phố Bungotakada",
      "inName": "kota Bungotakada",
      "tlName": "siyudad ng Bungotakada",
      "moName": "Бүнготакада хот",
      "buName": "ဘွန်ဂိုတားကာ့တ မြို့",
      "khName": "ទីក្រុង ប៊ុងកូតាកាដា",
      "neName": "बुन्गोताकादा सहर"
    }
  },
  "4421000": {
    "office": {
      "code": "440000",
      "name": "大分県",
      "enName": "Oita",
      "officeName": "大分地方気象台",
      "chName": "大分县",
      "zhName": "大分縣",
      "koName": "오이타현",
      "esName": "Prefectura de Oita",
      "ptName": "Província de Ōita",
      "thName": "จังหวัดโออิตะ",
      "viName": "Tỉnh Oita",
      "inName": "Prefektur Oita",
      "tlName": "Oita Prefecture",
      "moName": "Ойта аймаг",
      "buName": "အိုယိတ ပြည်နယ်",
      "khName": "ខេត្ដ អូតា",
      "neName": "ओइता जिल्ला"
    },
    "class10": {
      "code": "440010",
      "name": "中部",
      "enName": "Central Region",
      "chName": "大分县中部",
      "zhName": "大分縣中部",
      "koName": "오이타 현 중부",
      "esName": "Centro de Prefectura de Oita",
      "ptName": "Região central da Província de Ōita",
      "thName": "จังหวัดโออิตะตอนกลาง",
      "viName": "Miền Trung tỉnh Oita",
      "inName": "Bagian Tengah Prefektur Oita",
      "tlName": "Sentral na bahagi ng Oita Prefecture",
      "moName": "Төв Оита аймаг",
      "buName": "အအိုတစီရင်စု အလယ်ပိုင်း",
      "khName": "តំបន់កណ្តាលនៃខេត្ដអយតាក់",
      "neName": "ओइता जिल्लाको मध्य भाग"
    },
    "class15": {
      "code": "440010",
      "name": "中部",
      "enName": "Central Region"
    },
    "class20": {
      "code": "4421000",
      "name": "杵築市",
      "enName": "Kitsuki City",
      "kana": "きつきし",
      "chName": "杵筑市",
      "zhName": "杵築市",
      "koName": "기쓰키 시",
      "esName": "Ciudad de Kitsuki",
      "ptName": "cidade de Kitsuki",
      "thName": "เมืองคิทสึกิ",
      "viName": "thành phố Kitsuki",
      "inName": "kota Kitsuki",
      "tlName": "siyudad ng Kitsuki",
      "moName": "Кицүки хот",
      "buName": "ခီဆုကိ မြို့",
      "khName": "ទីក្រុង គីតស៊ូគី",
      "neName": "कित्सुकी सहर"
    }
  },
  "4421100": {
    "office": {
      "code": "440000",
      "name": "大分県",
      "enName": "Oita",
      "officeName": "大分地方気象台",
      "chName": "大分县",
      "zhName": "大分縣",
      "koName": "오이타현",
      "esName": "Prefectura de Oita",
      "ptName": "Província de Ōita",
      "thName": "จังหวัดโออิตะ",
      "viName": "Tỉnh Oita",
      "inName": "Prefektur Oita",
      "tlName": "Oita Prefecture",
      "moName": "Ойта аймаг",
      "buName": "အိုယိတ ပြည်နယ်",
      "khName": "ខេត្ដ អូតា",
      "neName": "ओइता जिल्ला"
    },
    "class10": {
      "code": "440020",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "大分县北部",
      "zhName": "大分縣北部",
      "koName": "오이타 현 북부",
      "esName": "Norte de Prefectura de Oita",
      "ptName": "Norte da Província de Ōita",
      "thName": "จังหวัดโออิตะตอนเหนือ",
      "viName": "Miền Bắc tỉnh Oita",
      "inName": "Bagian Utara Prefektur Oita",
      "tlName": "Hilagang bahagi ng Oita Prefecture",
      "moName": "Хойд Оита аймаг",
      "buName": "အအိုတစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដអយតាក់",
      "neName": "ओइता जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "440020",
      "name": "北部",
      "enName": "Northern Region"
    },
    "class20": {
      "code": "4421100",
      "name": "宇佐市",
      "enName": "Usa City",
      "kana": "うさし",
      "chName": "宇佐市",
      "zhName": "宇佐市",
      "koName": "우사 시",
      "esName": "Ciudad de Usa",
      "ptName": "cidade de Usa",
      "thName": "เมืองอุสะ",
      "viName": "thành phố Hoa Kỳ",
      "inName": "kota Usa",
      "tlName": "siyudad ng Usa",
      "moName": "Үсa хот",
      "buName": "ဥဆာ့ မြို့",
      "khName": "ទីក្រុង យូសា",
      "neName": "उसा सहर"
    }
  },
  "4421200": {
    "office": {
      "code": "440000",
      "name": "大分県",
      "enName": "Oita",
      "officeName": "大分地方気象台",
      "chName": "大分县",
      "zhName": "大分縣",
      "koName": "오이타현",
      "esName": "Prefectura de Oita",
      "ptName": "Província de Ōita",
      "thName": "จังหวัดโออิตะ",
      "viName": "Tỉnh Oita",
      "inName": "Prefektur Oita",
      "tlName": "Oita Prefecture",
      "moName": "Ойта аймаг",
      "buName": "အိုယိတ ပြည်နယ်",
      "khName": "ខេត្ដ អូតា",
      "neName": "ओइता जिल्ला"
    },
    "class10": {
      "code": "440040",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "大分县南部",
      "zhName": "大分縣南部",
      "koName": "오이타 현 남부",
      "esName": "Sur de Prefectura de Oita",
      "ptName": "Sul da Província de Ōita",
      "thName": "จังหวัดโออิตะตอนใต้",
      "viName": "Miền Nam tỉnh Oita",
      "inName": "Bagian Selatan Prefektur Oita",
      "tlName": "Timog na bahagi ng Oita Prefecture",
      "moName": "Өмнөд Оита аймаг",
      "buName": "အအိုတစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្ដអយតាក់",
      "neName": "ओइता जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "440042",
      "name": "豊後大野市",
      "enName": "Bungoono City"
    },
    "class20": {
      "code": "4421200",
      "name": "豊後大野市",
      "enName": "Bungo Ohno City",
      "kana": "ぶんごおおのし",
      "chName": "丰后大野市",
      "zhName": "豐後大野市",
      "koName": "분고오노 시",
      "esName": "Ciudad de Bungo-Ōno",
      "ptName": "cidade de Bungo Ono",
      "thName": "เมืองบุงโงะ โอโนะ",
      "viName": "thành phố Bungo",
      "inName": "kota Bungo Ono",
      "tlName": "siyudad ng Bungo Ono",
      "moName": "Бүнго Оно хот",
      "buName": "ဘွန်းဂို ဥနို မြို့",
      "khName": "ទីក្រុង ប៊ួងហ្គូអូណូ",
      "neName": "बुन्गो ओनो सहर"
    }
  },
  "4421300": {
    "office": {
      "code": "440000",
      "name": "大分県",
      "enName": "Oita",
      "officeName": "大分地方気象台",
      "chName": "大分县",
      "zhName": "大分縣",
      "koName": "오이타현",
      "esName": "Prefectura de Oita",
      "ptName": "Província de Ōita",
      "thName": "จังหวัดโออิตะ",
      "viName": "Tỉnh Oita",
      "inName": "Prefektur Oita",
      "tlName": "Oita Prefecture",
      "moName": "Ойта аймаг",
      "buName": "အိုယိတ ပြည်နယ်",
      "khName": "ខេត្ដ អូតា",
      "neName": "ओइता जिल्ला"
    },
    "class10": {
      "code": "440010",
      "name": "中部",
      "enName": "Central Region",
      "chName": "大分县中部",
      "zhName": "大分縣中部",
      "koName": "오이타 현 중부",
      "esName": "Centro de Prefectura de Oita",
      "ptName": "Região central da Província de Ōita",
      "thName": "จังหวัดโออิตะตอนกลาง",
      "viName": "Miền Trung tỉnh Oita",
      "inName": "Bagian Tengah Prefektur Oita",
      "tlName": "Sentral na bahagi ng Oita Prefecture",
      "moName": "Төв Оита аймаг",
      "buName": "အအိုတစီရင်စု အလယ်ပိုင်း",
      "khName": "តំបន់កណ្តាលនៃខេត្ដអយតាក់",
      "neName": "ओइता जिल्लाको मध्य भाग"
    },
    "class15": {
      "code": "440010",
      "name": "中部",
      "enName": "Central Region"
    },
    "class20": {
      "code": "4421300",
      "name": "由布市",
      "enName": "Yufu City",
      "kana": "ゆふし",
      "chName": "由布市",
      "zhName": "由布市",
      "koName": "유후 시",
      "esName": "Ciudad de Yufu",
      "ptName": "cidade de Yufu",
      "thName": "เมืองยุฟุ",
      "viName": "thành phố Yufu",
      "inName": "kota Yufu",
      "tlName": "siyudad ng Yufu",
      "moName": "Юфү хот",
      "buName": "ယူဖူ မြို့",
      "khName": "ទីក្រុង យូហ្វូ",
      "neName": "युफु सहर"
    }
  },
  "4421400": {
    "office": {
      "code": "440000",
      "name": "大分県",
      "enName": "Oita",
      "officeName": "大分地方気象台",
      "chName": "大分县",
      "zhName": "大分縣",
      "koName": "오이타현",
      "esName": "Prefectura de Oita",
      "ptName": "Província de Ōita",
      "thName": "จังหวัดโออิตะ",
      "viName": "Tỉnh Oita",
      "inName": "Prefektur Oita",
      "tlName": "Oita Prefecture",
      "moName": "Ойта аймаг",
      "buName": "အိုယိတ ပြည်နယ်",
      "khName": "ខេត្ដ អូតា",
      "neName": "ओइता जिल्ला"
    },
    "class10": {
      "code": "440020",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "大分县北部",
      "zhName": "大分縣北部",
      "koName": "오이타 현 북부",
      "esName": "Norte de Prefectura de Oita",
      "ptName": "Norte da Província de Ōita",
      "thName": "จังหวัดโออิตะตอนเหนือ",
      "viName": "Miền Bắc tỉnh Oita",
      "inName": "Bagian Utara Prefektur Oita",
      "tlName": "Hilagang bahagi ng Oita Prefecture",
      "moName": "Хойд Оита аймаг",
      "buName": "အအိုတစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដអយតាក់",
      "neName": "ओइता जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "440020",
      "name": "北部",
      "enName": "Northern Region"
    },
    "class20": {
      "code": "4421400",
      "name": "国東市",
      "enName": "Kunisaki City",
      "kana": "くにさきし",
      "chName": "国东市",
      "zhName": "國東市",
      "koName": "구니사키 시",
      "esName": "Ciudad de Kunisaki",
      "ptName": "cidade de Kunisaki",
      "thName": "เมืองคุนิซากิ",
      "viName": "thành phố Kunisaki",
      "inName": "kota Kunisaki",
      "tlName": "siyudad ng Kunisaki",
      "moName": "Күнисaки хот",
      "buName": "ခူနီးဆာ့ကိ မြို့",
      "khName": "ទីក្រុង គូនីសាគី",
      "neName": "कुनिसाकी सहर"
    }
  },
  "4432200": {
    "office": {
      "code": "440000",
      "name": "大分県",
      "enName": "Oita",
      "officeName": "大分地方気象台",
      "chName": "大分县",
      "zhName": "大分縣",
      "koName": "오이타현",
      "esName": "Prefectura de Oita",
      "ptName": "Província de Ōita",
      "thName": "จังหวัดโออิตะ",
      "viName": "Tỉnh Oita",
      "inName": "Prefektur Oita",
      "tlName": "Oita Prefecture",
      "moName": "Ойта аймаг",
      "buName": "အိုယိတ ပြည်နယ်",
      "khName": "ខេត្ដ អូតា",
      "neName": "ओइता जिल्ला"
    },
    "class10": {
      "code": "440020",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "大分县北部",
      "zhName": "大分縣北部",
      "koName": "오이타 현 북부",
      "esName": "Norte de Prefectura de Oita",
      "ptName": "Norte da Província de Ōita",
      "thName": "จังหวัดโออิตะตอนเหนือ",
      "viName": "Miền Bắc tỉnh Oita",
      "inName": "Bagian Utara Prefektur Oita",
      "tlName": "Hilagang bahagi ng Oita Prefecture",
      "moName": "Хойд Оита аймаг",
      "buName": "အအိုတစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្ដអយតាក់",
      "neName": "ओइता जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "440020",
      "name": "北部",
      "enName": "Northern Region"
    },
    "class20": {
      "code": "4432200",
      "name": "姫島村",
      "enName": "Himeshima Village",
      "kana": "ひめしまむら",
      "chName": "姬岛村",
      "zhName": "姬島村",
      "koName": "히메시마 촌",
      "esName": "Aldea de Himeshima",
      "ptName": "povoado de Himeshima",
      "thName": "หมู่บ้านฮิเมชิมะ",
      "viName": "làng Himeshima",
      "inName": "desa Himeshima",
      "tlName": "nayon ng Himeshima",
      "moName": "Химэшимa тосгон",
      "buName": "ဟီမဲရှိမ ကျေးရွာ",
      "khName": "ភូមិ ហ៊ីម៉េស៊ីម៉ា",
      "neName": "हिमेशिमा गाउँ"
    }
  },
  "4434100": {
    "office": {
      "code": "440000",
      "name": "大分県",
      "enName": "Oita",
      "officeName": "大分地方気象台",
      "chName": "大分县",
      "zhName": "大分縣",
      "koName": "오이타현",
      "esName": "Prefectura de Oita",
      "ptName": "Província de Ōita",
      "thName": "จังหวัดโออิตะ",
      "viName": "Tỉnh Oita",
      "inName": "Prefektur Oita",
      "tlName": "Oita Prefecture",
      "moName": "Ойта аймаг",
      "buName": "အိုယိတ ပြည်နယ်",
      "khName": "ខេត្ដ អូតា",
      "neName": "ओइता जिल्ला"
    },
    "class10": {
      "code": "440010",
      "name": "中部",
      "enName": "Central Region",
      "chName": "大分县中部",
      "zhName": "大分縣中部",
      "koName": "오이타 현 중부",
      "esName": "Centro de Prefectura de Oita",
      "ptName": "Região central da Província de Ōita",
      "thName": "จังหวัดโออิตะตอนกลาง",
      "viName": "Miền Trung tỉnh Oita",
      "inName": "Bagian Tengah Prefektur Oita",
      "tlName": "Sentral na bahagi ng Oita Prefecture",
      "moName": "Төв Оита аймаг",
      "buName": "အအိုတစီရင်စု အလယ်ပိုင်း",
      "khName": "តំបន់កណ្តាលនៃខេត្ដអយតាក់",
      "neName": "ओइता जिल्लाको मध्य भाग"
    },
    "class15": {
      "code": "440010",
      "name": "中部",
      "enName": "Central Region"
    },
    "class20": {
      "code": "4434100",
      "name": "日出町",
      "enName": "Hiji Town",
      "kana": "ひじまち",
      "chName": "日出町",
      "zhName": "日出町",
      "koName": "히지 정",
      "esName": "Pueblo de Hiji",
      "ptName": "bairro de Hiji",
      "thName": "เมืองฮิจิ",
      "viName": "thị trấn Hiji",
      "inName": "kota Hiji",
      "tlName": "bayan ng Hiji",
      "moName": "Хижи жижиг хот",
      "buName": "ဟီဂျိ မြို့နယ်",
      "khName": "ទីប្រជុំជន ហ៊ីជី",
      "neName": "हिजी नगर"
    }
  },
  "4446100": {
    "office": {
      "code": "440000",
      "name": "大分県",
      "enName": "Oita",
      "officeName": "大分地方気象台",
      "chName": "大分县",
      "zhName": "大分縣",
      "koName": "오이타현",
      "esName": "Prefectura de Oita",
      "ptName": "Província de Ōita",
      "thName": "จังหวัดโออิตะ",
      "viName": "Tỉnh Oita",
      "inName": "Prefektur Oita",
      "tlName": "Oita Prefecture",
      "moName": "Ойта аймаг",
      "buName": "အိုယိတ ပြည်နယ်",
      "khName": "ខេត្ដ អូតា",
      "neName": "ओइता जिल्ला"
    },
    "class10": {
      "code": "440030",
      "name": "西部",
      "enName": "Western Region",
      "chName": "大分县西部",
      "zhName": "大分縣西部",
      "koName": "오이타 현 서부",
      "esName": "Oeste de Prefectura de Oita",
      "ptName": "Oeste da Província de Ōita",
      "thName": "จังหวัดโออิตะฟากตะวันตก",
      "viName": "Miền Tây tỉnh Oita",
      "inName": "Bagian Barat Prefekture Oita",
      "tlName": "Silangang bahagi ng Oita Prefecture",
      "moName": "Баруун Оита аймаг",
      "buName": "အအိုတစီရင်စု အနောက်ပိုင်း",
      "khName": "តំបន់ខាងលិចនៃខេត្ដអយតាក់",
      "neName": "ओइता जिल्लाको पश्चिमी भाग"
    },
    "class15": {
      "code": "440031",
      "name": "日田玖珠",
      "enName": "Hita Kusu"
    },
    "class20": {
      "code": "4446100",
      "name": "九重町",
      "enName": "Kokonoe Town",
      "kana": "ここのえまち",
      "chName": "九重町",
      "zhName": "九重町",
      "koName": "고코노에 정",
      "esName": "Pueblo de Kokonoe",
      "ptName": "bairro de Kokonoe",
      "thName": "เมืองโคโคโนะเอะ",
      "viName": "thị trấn Kokonoe",
      "inName": "kota Kokonoe",
      "tlName": "bayan ng Kokonoe",
      "moName": "Коконоэ жижиг хот",
      "buName": "ကိုကိုးနိုအဲ့ မြို့နယ်",
      "khName": "ទីប្រជុំជន គុគូនេ",
      "neName": "कोकोनोए नगर"
    }
  },
  "4446200": {
    "office": {
      "code": "440000",
      "name": "大分県",
      "enName": "Oita",
      "officeName": "大分地方気象台",
      "chName": "大分县",
      "zhName": "大分縣",
      "koName": "오이타현",
      "esName": "Prefectura de Oita",
      "ptName": "Província de Ōita",
      "thName": "จังหวัดโออิตะ",
      "viName": "Tỉnh Oita",
      "inName": "Prefektur Oita",
      "tlName": "Oita Prefecture",
      "moName": "Ойта аймаг",
      "buName": "အိုယိတ ပြည်နယ်",
      "khName": "ខេត្ដ អូតា",
      "neName": "ओइता जिल्ला"
    },
    "class10": {
      "code": "440030",
      "name": "西部",
      "enName": "Western Region",
      "chName": "大分县西部",
      "zhName": "大分縣西部",
      "koName": "오이타 현 서부",
      "esName": "Oeste de Prefectura de Oita",
      "ptName": "Oeste da Província de Ōita",
      "thName": "จังหวัดโออิตะฟากตะวันตก",
      "viName": "Miền Tây tỉnh Oita",
      "inName": "Bagian Barat Prefekture Oita",
      "tlName": "Silangang bahagi ng Oita Prefecture",
      "moName": "Баруун Оита аймаг",
      "buName": "အအိုတစီရင်စု အနောက်ပိုင်း",
      "khName": "តំបន់ខាងលិចនៃខេត្ដអយតាក់",
      "neName": "ओइता जिल्लाको पश्चिमी भाग"
    },
    "class15": {
      "code": "440031",
      "name": "日田玖珠",
      "enName": "Hita Kusu"
    },
    "class20": {
      "code": "4446200",
      "name": "玖珠町",
      "enName": "Kusu Town",
      "kana": "くすまち",
      "chName": "玖珠町",
      "zhName": "玖珠町",
      "koName": "구스 정",
      "esName": "Pueblo de Kusu",
      "ptName": "bairro de Kusu",
      "thName": "เมืองคุสุ",
      "viName": "thị trấn Kusu",
      "inName": "kota Kusu",
      "tlName": "bayan ng Kusu",
      "moName": "Күсү жижиг хот",
      "buName": "ခူဆု မြို့နယ်",
      "khName": "ទីប្រជុំជន គូស៊ូ",
      "neName": "कुसु नगर"
    }
  },
  "4520100": {
    "office": {
      "code": "450000",
      "name": "宮崎県",
      "enName": "Miyazaki",
      "officeName": "宮崎地方気象台",
      "chName": "宫崎县",
      "zhName": "宮崎縣",
      "koName": "미야자키현",
      "esName": "Prefectura de Miyazaki",
      "ptName": "Província de Miyazaki",
      "thName": "จังหวัดมิยาซากิ",
      "viName": "Tỉnh Miyazaki",
      "inName": "Prefektur Miyagi",
      "tlName": "Miyazaki Prefecture",
      "moName": "Миязаки аймаг",
      "buName": "မီယာဇာကိ ပြည်နယ်",
      "khName": "ខេត្ដ មីយ៉ាហ្សាគី",
      "neName": "मियाजाकी जिल्ला"
    },
    "class10": {
      "code": "450010",
      "name": "南部平野部",
      "enName": "Plain Area of Southern Region",
      "chName": "宫崎县南部平原部",
      "zhName": "宮崎縣南部平野部",
      "koName": "미야자키 현 남부 평야",
      "esName": "Parte llanura de Sur de Prefectura de Miyazaki",
      "ptName": "Área da Planície da Região sul da Província de Miyazaki",
      "thName": "ส่วนพื้นราบของจังหวัดมิยาซากิตอนใต้",
      "viName": "Vùng đồng bằng miền Nam tỉnh Miyazaki",
      "inName": "Dataran di Bagian Selatan Prefektur Miyazaki",
      "tlName": "Kapatagang lugar sa timog na bahagi ng Miyazaki Prefecture",
      "moName": "Миязаки аймгийн өмнөд тал газар",
      "buName": "မိယဇခိစီရင်စု တောင်ပိုင်းလွင်ပြင်",
      "khName": "តំបន់ទំនាបខាងត្បូងនៃខេត្ដមីយ៉ាហ្សាគី",
      "neName": "मियाजाकी जिल्लाको दक्षिणी भागको समथर क्षेत्र"
    },
    "class15": {
      "code": "450011",
      "name": "宮崎地区",
      "enName": "Miyazaki District"
    },
    "class20": {
      "code": "4520100",
      "name": "宮崎市",
      "enName": "Miyazaki City",
      "kana": "みやざきし",
      "chName": "宫崎市",
      "zhName": "宮崎市",
      "koName": "미야자키 시",
      "esName": "Ciudad de Miyazaki",
      "ptName": "cidade de Miyazaki",
      "thName": "เมืองมิยาซากิ",
      "viName": "thành phố Miyazaki",
      "inName": "kota Miyazaki",
      "tlName": "siyudad ng Miyazaki",
      "moName": "Миязaки хот",
      "buName": "မီယာဇာ့ကိ မြို့",
      "khName": "ទីក្រុង មីយ៉ាហ្សាគី",
      "neName": "मियाजाकी सहर"
    }
  },
  "4520200": {
    "office": {
      "code": "450000",
      "name": "宮崎県",
      "enName": "Miyazaki",
      "officeName": "宮崎地方気象台",
      "chName": "宫崎县",
      "zhName": "宮崎縣",
      "koName": "미야자키현",
      "esName": "Prefectura de Miyazaki",
      "ptName": "Província de Miyazaki",
      "thName": "จังหวัดมิยาซากิ",
      "viName": "Tỉnh Miyazaki",
      "inName": "Prefektur Miyagi",
      "tlName": "Miyazaki Prefecture",
      "moName": "Миязаки аймаг",
      "buName": "မီယာဇာကိ ပြည်နယ်",
      "khName": "ខេត្ដ មីយ៉ាហ្សាគី",
      "neName": "मियाजाकी जिल्ला"
    },
    "class10": {
      "code": "450030",
      "name": "南部山沿い",
      "enName": "Area along mountains of Southern Region",
      "chName": "宫崎县南部靠山",
      "zhName": "宮崎縣南部山沿",
      "koName": "미야자키 현 남부 산간 지역",
      "esName": "Sur de Prefectura de Miyazaki a lo largo de las montañas",
      "ptName": "Ao longo das montanhas da Região sul da Província de Miyazaki",
      "thName": "ส่วนเลียบภูเขาของจังหวัดมิยาซากิตอนใต้",
      "viName": "Dọc núi miền Nam tỉnh Miyazaki",
      "inName": "Sepanjang Gunung di Bagian Selatan Prefektur Miyazaki",
      "tlName": "Bulubunduking lugar sa timog na bahagi ng Miyazaki Prefecture",
      "moName": "Миязаки аймгийн өмнөд уулархаг газар",
      "buName": "မိယဇခိစီရင်စု တောင်ပိုင်းတောင်တန်းဒေသ",
      "khName": "តំបន់ដងភ្នំខាងត្បូងនៃខេត្ដមីយ៉ាហ្សាគី",
      "neName": "मियाजाकी जिल्लाको दक्षिणी भागको पहाड छेउको क्षेत्र"
    },
    "class15": {
      "code": "450032",
      "name": "都城地区",
      "enName": "Miyakonojo District"
    },
    "class20": {
      "code": "4520200",
      "name": "都城市",
      "enName": "Miyakonojo City",
      "kana": "みやこのじょうし",
      "chName": "都城市",
      "zhName": "都城市",
      "koName": "미야코노조 시",
      "esName": "Ciudad de Miyakonojyo",
      "ptName": "cidade de Miyakonojo",
      "thName": "เมืองมิยาโคโนะโจ",
      "viName": "thành phố Miyakonojo",
      "inName": "kota Miyakonojo",
      "tlName": "siyudad ng Miyakonojo",
      "moName": "Мияконожо хот",
      "buName": "မီယာကိုးနောဂျို မြို့",
      "khName": "ទីក្រុង មីយ៉ាកូណូចូ",
      "neName": "मियाकोनोजो सहर"
    }
  },
  "4520300": {
    "office": {
      "code": "450000",
      "name": "宮崎県",
      "enName": "Miyazaki",
      "officeName": "宮崎地方気象台",
      "chName": "宫崎县",
      "zhName": "宮崎縣",
      "koName": "미야자키현",
      "esName": "Prefectura de Miyazaki",
      "ptName": "Província de Miyazaki",
      "thName": "จังหวัดมิยาซากิ",
      "viName": "Tỉnh Miyazaki",
      "inName": "Prefektur Miyagi",
      "tlName": "Miyazaki Prefecture",
      "moName": "Миязаки аймаг",
      "buName": "မီယာဇာကိ ပြည်နယ်",
      "khName": "ខេត្ដ មីយ៉ាហ្សាគី",
      "neName": "मियाजाकी जिल्ला"
    },
    "class10": {
      "code": "450020",
      "name": "北部平野部",
      "enName": "Plain Area of Northern Region",
      "chName": "宫崎县北部平原部",
      "zhName": "宮崎縣北部平野部",
      "koName": "미야자키 현 북부 평야",
      "esName": "Parte llanura de Norte de Prefectura de Miyazaki",
      "ptName": "Área da Planície da Região norte da Província de Miyazaki",
      "thName": "ส่วนพื้นราบของจังหวัดมิยาซากิตอนเหนือ",
      "viName": "Vùng đồng bằng miền Bắc tỉnh Miyazaki",
      "inName": "Dataran di Bagian Utara Prefektur Miyazaki",
      "tlName": "Kapatagang lugar sa hilagang bahagi ng Miyazaki Prefecture",
      "moName": "Миязаки аймгийн хойд тал газар",
      "buName": "မိယဇခိစီရင်စု မြောက်ပိုင်းလွင်ပြင်",
      "khName": "តំបន់ទំនាបខាងជើងនៃខេត្ដមីយ៉ាហ្សាគី",
      "neName": "मियाजाकी जिल्लाको उत्तरी भागको समथर क्षेत्र"
    },
    "class15": {
      "code": "450021",
      "name": "延岡・日向地区",
      "enName": "Nobeoka Hyuga District"
    },
    "class20": {
      "code": "4520300",
      "name": "延岡市",
      "enName": "Nobeoka City",
      "kana": "のべおかし",
      "chName": "延冈市",
      "zhName": "延岡市",
      "koName": "노베오카 시",
      "esName": "Ciudad de Nobeoka",
      "ptName": "cidade de Nobeoka",
      "thName": "เมืองโนเบะโอกะ",
      "viName": "thành phố Nobeoka",
      "inName": "kota Nobeoka",
      "tlName": "siyudad ng Nobeoka",
      "moName": "Нобэока хот",
      "buName": "နိုဗဲအို့က မြို့",
      "khName": "ទីក្រុង ណូបេអូកា",
      "neName": "नोबेओका सहर"
    }
  },
  "4520400": {
    "office": {
      "code": "450000",
      "name": "宮崎県",
      "enName": "Miyazaki",
      "officeName": "宮崎地方気象台",
      "chName": "宫崎县",
      "zhName": "宮崎縣",
      "koName": "미야자키현",
      "esName": "Prefectura de Miyazaki",
      "ptName": "Província de Miyazaki",
      "thName": "จังหวัดมิยาซากิ",
      "viName": "Tỉnh Miyazaki",
      "inName": "Prefektur Miyagi",
      "tlName": "Miyazaki Prefecture",
      "moName": "Миязаки аймаг",
      "buName": "မီယာဇာကိ ပြည်နယ်",
      "khName": "ខេត្ដ មីយ៉ាហ្សាគី",
      "neName": "मियाजाकी जिल्ला"
    },
    "class10": {
      "code": "450010",
      "name": "南部平野部",
      "enName": "Plain Area of Southern Region",
      "chName": "宫崎县南部平原部",
      "zhName": "宮崎縣南部平野部",
      "koName": "미야자키 현 남부 평야",
      "esName": "Parte llanura de Sur de Prefectura de Miyazaki",
      "ptName": "Área da Planície da Região sul da Província de Miyazaki",
      "thName": "ส่วนพื้นราบของจังหวัดมิยาซากิตอนใต้",
      "viName": "Vùng đồng bằng miền Nam tỉnh Miyazaki",
      "inName": "Dataran di Bagian Selatan Prefektur Miyazaki",
      "tlName": "Kapatagang lugar sa timog na bahagi ng Miyazaki Prefecture",
      "moName": "Миязаки аймгийн өмнөд тал газар",
      "buName": "မိယဇခိစီရင်စု တောင်ပိုင်းလွင်ပြင်",
      "khName": "តំបន់ទំនាបខាងត្បូងនៃខេត្ដមីយ៉ាហ្សាគី",
      "neName": "मियाजाकी जिल्लाको दक्षिणी भागको समथर क्षेत्र"
    },
    "class15": {
      "code": "450012",
      "name": "日南・串間地区",
      "enName": "Nichinan Kushima District"
    },
    "class20": {
      "code": "4520400",
      "name": "日南市",
      "enName": "Nichinan City",
      "kana": "にちなんし",
      "chName": "日南市",
      "zhName": "日南市",
      "koName": "니치난 시",
      "esName": "Ciudad de Nichinan",
      "ptName": "cidade de Nichinan",
      "thName": "เมืองนิจินัน",
      "viName": "thành phố Nichinan",
      "inName": "kota Nichinan",
      "tlName": "siyudad ng Nichinan",
      "moName": "Ничинaн хот",
      "buName": "နီးကျိနန် မြို့",
      "khName": "ទីក្រុង នីឈីនណាន",
      "neName": "निचिनान सहर"
    }
  },
  "4520500": {
    "office": {
      "code": "450000",
      "name": "宮崎県",
      "enName": "Miyazaki",
      "officeName": "宮崎地方気象台",
      "chName": "宫崎县",
      "zhName": "宮崎縣",
      "koName": "미야자키현",
      "esName": "Prefectura de Miyazaki",
      "ptName": "Província de Miyazaki",
      "thName": "จังหวัดมิยาซากิ",
      "viName": "Tỉnh Miyazaki",
      "inName": "Prefektur Miyagi",
      "tlName": "Miyazaki Prefecture",
      "moName": "Миязаки аймаг",
      "buName": "မီယာဇာကိ ပြည်နယ်",
      "khName": "ខេត្ដ មីយ៉ាហ្សាគី",
      "neName": "मियाजाकी जिल्ला"
    },
    "class10": {
      "code": "450030",
      "name": "南部山沿い",
      "enName": "Area along mountains of Southern Region",
      "chName": "宫崎县南部靠山",
      "zhName": "宮崎縣南部山沿",
      "koName": "미야자키 현 남부 산간 지역",
      "esName": "Sur de Prefectura de Miyazaki a lo largo de las montañas",
      "ptName": "Ao longo das montanhas da Região sul da Província de Miyazaki",
      "thName": "ส่วนเลียบภูเขาของจังหวัดมิยาซากิตอนใต้",
      "viName": "Dọc núi miền Nam tỉnh Miyazaki",
      "inName": "Sepanjang Gunung di Bagian Selatan Prefektur Miyazaki",
      "tlName": "Bulubunduking lugar sa timog na bahagi ng Miyazaki Prefecture",
      "moName": "Миязаки аймгийн өмнөд уулархаг газар",
      "buName": "မိယဇခိစီရင်စု တောင်ပိုင်းတောင်တန်းဒေသ",
      "khName": "តំបន់ដងភ្នំខាងត្បូងនៃខេត្ដមីយ៉ាហ្សាគី",
      "neName": "मियाजाकी जिल्लाको दक्षिणी भागको पहाड छेउको क्षेत्र"
    },
    "class15": {
      "code": "450031",
      "name": "小林・えびの地区",
      "enName": "Kobayashi Ebino District"
    },
    "class20": {
      "code": "4520500",
      "name": "小林市",
      "enName": "Kobayashi City",
      "kana": "こばやしし",
      "chName": "小林市",
      "zhName": "小林市",
      "koName": "고바야시 시",
      "esName": "Ciudad de Kobayashi",
      "ptName": "cidade de Kobayashi",
      "thName": "เมืองโคบายาชิ",
      "viName": "thành phố Kobayashi",
      "inName": "kota Kobayashi",
      "tlName": "siyudad ng Kobayashi",
      "moName": "Кобаяши хот",
      "buName": "ကိုဘားရာ့ရှိ မြို့",
      "khName": "ទីក្រុង កូបាយ៉ាស៊ី",
      "neName": "कोबायाशि सहर"
    }
  },
  "4520600": {
    "office": {
      "code": "450000",
      "name": "宮崎県",
      "enName": "Miyazaki",
      "officeName": "宮崎地方気象台",
      "chName": "宫崎县",
      "zhName": "宮崎縣",
      "koName": "미야자키현",
      "esName": "Prefectura de Miyazaki",
      "ptName": "Província de Miyazaki",
      "thName": "จังหวัดมิยาซากิ",
      "viName": "Tỉnh Miyazaki",
      "inName": "Prefektur Miyagi",
      "tlName": "Miyazaki Prefecture",
      "moName": "Миязаки аймаг",
      "buName": "မီယာဇာကိ ပြည်နယ်",
      "khName": "ខេត្ដ មីយ៉ាហ្សាគី",
      "neName": "मियाजाकी जिल्ला"
    },
    "class10": {
      "code": "450020",
      "name": "北部平野部",
      "enName": "Plain Area of Northern Region",
      "chName": "宫崎县北部平原部",
      "zhName": "宮崎縣北部平野部",
      "koName": "미야자키 현 북부 평야",
      "esName": "Parte llanura de Norte de Prefectura de Miyazaki",
      "ptName": "Área da Planície da Região norte da Província de Miyazaki",
      "thName": "ส่วนพื้นราบของจังหวัดมิยาซากิตอนเหนือ",
      "viName": "Vùng đồng bằng miền Bắc tỉnh Miyazaki",
      "inName": "Dataran di Bagian Utara Prefektur Miyazaki",
      "tlName": "Kapatagang lugar sa hilagang bahagi ng Miyazaki Prefecture",
      "moName": "Миязаки аймгийн хойд тал газар",
      "buName": "မိယဇခိစီရင်စု မြောက်ပိုင်းလွင်ပြင်",
      "khName": "តំបន់ទំនាបខាងជើងនៃខេត្ដមីយ៉ាហ្សាគី",
      "neName": "मियाजाकी जिल्लाको उत्तरी भागको समथर क्षेत्र"
    },
    "class15": {
      "code": "450021",
      "name": "延岡・日向地区",
      "enName": "Nobeoka Hyuga District"
    },
    "class20": {
      "code": "4520600",
      "name": "日向市",
      "enName": "Hyuga City",
      "kana": "ひゅうがし",
      "chName": "日向市",
      "zhName": "日向市",
      "koName": "휴가 시",
      "esName": "Ciudad de Hyuga",
      "ptName": "cidade de Hyuga",
      "thName": "เมืองฮิวกะ",
      "viName": "thành phố Hyuga",
      "inName": "kota Hyuga",
      "tlName": "siyudad ng Hyuga",
      "moName": "Хюгa хот",
      "buName": "ဟျူးဂ မြို့",
      "khName": "ទីក្រុង ហ៊ីយូហ្គា",
      "neName": "ह्युगा सहर"
    }
  },
  "4520700": {
    "office": {
      "code": "450000",
      "name": "宮崎県",
      "enName": "Miyazaki",
      "officeName": "宮崎地方気象台",
      "chName": "宫崎县",
      "zhName": "宮崎縣",
      "koName": "미야자키현",
      "esName": "Prefectura de Miyazaki",
      "ptName": "Província de Miyazaki",
      "thName": "จังหวัดมิยาซากิ",
      "viName": "Tỉnh Miyazaki",
      "inName": "Prefektur Miyagi",
      "tlName": "Miyazaki Prefecture",
      "moName": "Миязаки аймаг",
      "buName": "မီယာဇာကိ ပြည်နယ်",
      "khName": "ខេត្ដ មីយ៉ាហ្សាគី",
      "neName": "मियाजाकी जिल्ला"
    },
    "class10": {
      "code": "450010",
      "name": "南部平野部",
      "enName": "Plain Area of Southern Region",
      "chName": "宫崎县南部平原部",
      "zhName": "宮崎縣南部平野部",
      "koName": "미야자키 현 남부 평야",
      "esName": "Parte llanura de Sur de Prefectura de Miyazaki",
      "ptName": "Área da Planície da Região sul da Província de Miyazaki",
      "thName": "ส่วนพื้นราบของจังหวัดมิยาซากิตอนใต้",
      "viName": "Vùng đồng bằng miền Nam tỉnh Miyazaki",
      "inName": "Dataran di Bagian Selatan Prefektur Miyazaki",
      "tlName": "Kapatagang lugar sa timog na bahagi ng Miyazaki Prefecture",
      "moName": "Миязаки аймгийн өмнөд тал газар",
      "buName": "မိယဇခိစီရင်စု တောင်ပိုင်းလွင်ပြင်",
      "khName": "តំបន់ទំនាបខាងត្បូងនៃខេត្ដមីយ៉ាហ្សាគី",
      "neName": "मियाजाकी जिल्लाको दक्षिणी भागको समथर क्षेत्र"
    },
    "class15": {
      "code": "450012",
      "name": "日南・串間地区",
      "enName": "Nichinan Kushima District"
    },
    "class20": {
      "code": "4520700",
      "name": "串間市",
      "enName": "Kushima City",
      "kana": "くしまし",
      "chName": "串间市",
      "zhName": "串間市",
      "koName": "구시마 시",
      "esName": "Ciudad de Kushima",
      "ptName": "cidade de Kushima",
      "thName": "เมืองคุชิมะ",
      "viName": "thành phố Kushima",
      "inName": "kota Kushima",
      "tlName": "siyudad ng Kushima",
      "moName": "Күшимa хот",
      "buName": "ခူရှိမ မြို့",
      "khName": "ទីក្រុង គូស៊ីម៉ា",
      "neName": "कुशिमा सहर"
    }
  },
  "4520800": {
    "office": {
      "code": "450000",
      "name": "宮崎県",
      "enName": "Miyazaki",
      "officeName": "宮崎地方気象台",
      "chName": "宫崎县",
      "zhName": "宮崎縣",
      "koName": "미야자키현",
      "esName": "Prefectura de Miyazaki",
      "ptName": "Província de Miyazaki",
      "thName": "จังหวัดมิยาซากิ",
      "viName": "Tỉnh Miyazaki",
      "inName": "Prefektur Miyagi",
      "tlName": "Miyazaki Prefecture",
      "moName": "Миязаки аймаг",
      "buName": "မီယာဇာကိ ပြည်နယ်",
      "khName": "ខេត្ដ មីយ៉ាហ្សាគី",
      "neName": "मियाजाकी जिल्ला"
    },
    "class10": {
      "code": "450020",
      "name": "北部平野部",
      "enName": "Plain Area of Northern Region",
      "chName": "宫崎县北部平原部",
      "zhName": "宮崎縣北部平野部",
      "koName": "미야자키 현 북부 평야",
      "esName": "Parte llanura de Norte de Prefectura de Miyazaki",
      "ptName": "Área da Planície da Região norte da Província de Miyazaki",
      "thName": "ส่วนพื้นราบของจังหวัดมิยาซากิตอนเหนือ",
      "viName": "Vùng đồng bằng miền Bắc tỉnh Miyazaki",
      "inName": "Dataran di Bagian Utara Prefektur Miyazaki",
      "tlName": "Kapatagang lugar sa hilagang bahagi ng Miyazaki Prefecture",
      "moName": "Миязаки аймгийн хойд тал газар",
      "buName": "မိယဇခိစီရင်စု မြောက်ပိုင်းလွင်ပြင်",
      "khName": "តំបន់ទំនាបខាងជើងនៃខេត្ដមីយ៉ាហ្សាគី",
      "neName": "मियाजाकी जिल्लाको उत्तरी भागको समथर क्षेत्र"
    },
    "class15": {
      "code": "450022",
      "name": "西都・高鍋地区",
      "enName": "Saito Takanabe District"
    },
    "class20": {
      "code": "4520800",
      "name": "西都市",
      "enName": "Saito City",
      "kana": "さいとし",
      "chName": "西都市",
      "zhName": "西都市",
      "koName": "사이토 시",
      "esName": "Ciudad de Saito",
      "ptName": "cidade de Saito",
      "thName": "เมืองไซโตะ",
      "viName": "thành phố Saito",
      "inName": "kota Saito",
      "tlName": "siyudad ng Saito",
      "moName": "Сайто хот",
      "buName": "ဆာယိတို မြို့",
      "khName": "ទីក្រុង ​ សៃតូ",
      "neName": "साइतो सहर"
    }
  },
  "4520900": {
    "office": {
      "code": "450000",
      "name": "宮崎県",
      "enName": "Miyazaki",
      "officeName": "宮崎地方気象台",
      "chName": "宫崎县",
      "zhName": "宮崎縣",
      "koName": "미야자키현",
      "esName": "Prefectura de Miyazaki",
      "ptName": "Província de Miyazaki",
      "thName": "จังหวัดมิยาซากิ",
      "viName": "Tỉnh Miyazaki",
      "inName": "Prefektur Miyagi",
      "tlName": "Miyazaki Prefecture",
      "moName": "Миязаки аймаг",
      "buName": "မီယာဇာကိ ပြည်နယ်",
      "khName": "ខេត្ដ មីយ៉ាហ្សាគី",
      "neName": "मियाजाकी जिल्ला"
    },
    "class10": {
      "code": "450030",
      "name": "南部山沿い",
      "enName": "Area along mountains of Southern Region",
      "chName": "宫崎县南部靠山",
      "zhName": "宮崎縣南部山沿",
      "koName": "미야자키 현 남부 산간 지역",
      "esName": "Sur de Prefectura de Miyazaki a lo largo de las montañas",
      "ptName": "Ao longo das montanhas da Região sul da Província de Miyazaki",
      "thName": "ส่วนเลียบภูเขาของจังหวัดมิยาซากิตอนใต้",
      "viName": "Dọc núi miền Nam tỉnh Miyazaki",
      "inName": "Sepanjang Gunung di Bagian Selatan Prefektur Miyazaki",
      "tlName": "Bulubunduking lugar sa timog na bahagi ng Miyazaki Prefecture",
      "moName": "Миязаки аймгийн өмнөд уулархаг газар",
      "buName": "မိယဇခိစီရင်စု တောင်ပိုင်းတောင်တန်းဒေသ",
      "khName": "តំបន់ដងភ្នំខាងត្បូងនៃខេត្ដមីយ៉ាហ្សាគី",
      "neName": "मियाजाकी जिल्लाको दक्षिणी भागको पहाड छेउको क्षेत्र"
    },
    "class15": {
      "code": "450031",
      "name": "小林・えびの地区",
      "enName": "Kobayashi Ebino District"
    },
    "class20": {
      "code": "4520900",
      "name": "えびの市",
      "enName": "Ebino City",
      "kana": "えびのし",
      "chName": "虾野市",
      "zhName": "蝦野市",
      "koName": "에비노 시",
      "esName": "Ciudad de Ebino",
      "ptName": "cidade de Ebino",
      "thName": "เมืองเอบิโนะ",
      "viName": "thành phố Ebino",
      "inName": "kota Ebino",
      "tlName": "siyudad ng Ebino",
      "moName": "Эбино хот",
      "buName": "အေးဗိနို မြို့",
      "khName": "ទីក្រុង អ៊ីប៊ីណូ",
      "neName": "एबिनो सहर"
    }
  },
  "4534100": {
    "office": {
      "code": "450000",
      "name": "宮崎県",
      "enName": "Miyazaki",
      "officeName": "宮崎地方気象台",
      "chName": "宫崎县",
      "zhName": "宮崎縣",
      "koName": "미야자키현",
      "esName": "Prefectura de Miyazaki",
      "ptName": "Província de Miyazaki",
      "thName": "จังหวัดมิยาซากิ",
      "viName": "Tỉnh Miyazaki",
      "inName": "Prefektur Miyagi",
      "tlName": "Miyazaki Prefecture",
      "moName": "Миязаки аймаг",
      "buName": "မီယာဇာကိ ပြည်နယ်",
      "khName": "ខេត្ដ មីយ៉ាហ្សាគី",
      "neName": "मियाजाकी जिल्ला"
    },
    "class10": {
      "code": "450030",
      "name": "南部山沿い",
      "enName": "Area along mountains of Southern Region",
      "chName": "宫崎县南部靠山",
      "zhName": "宮崎縣南部山沿",
      "koName": "미야자키 현 남부 산간 지역",
      "esName": "Sur de Prefectura de Miyazaki a lo largo de las montañas",
      "ptName": "Ao longo das montanhas da Região sul da Província de Miyazaki",
      "thName": "ส่วนเลียบภูเขาของจังหวัดมิยาซากิตอนใต้",
      "viName": "Dọc núi miền Nam tỉnh Miyazaki",
      "inName": "Sepanjang Gunung di Bagian Selatan Prefektur Miyazaki",
      "tlName": "Bulubunduking lugar sa timog na bahagi ng Miyazaki Prefecture",
      "moName": "Миязаки аймгийн өмнөд уулархаг газар",
      "buName": "မိယဇခိစီရင်စု တောင်ပိုင်းတောင်တန်းဒေသ",
      "khName": "តំបន់ដងភ្នំខាងត្បូងនៃខេត្ដមីយ៉ាហ្សាគី",
      "neName": "मियाजाकी जिल्लाको दक्षिणी भागको पहाड छेउको क्षेत्र"
    },
    "class15": {
      "code": "450032",
      "name": "都城地区",
      "enName": "Miyakonojo District"
    },
    "class20": {
      "code": "4534100",
      "name": "三股町",
      "enName": "Mimata Town",
      "kana": "みまたちょう",
      "chName": "三股町",
      "zhName": "三股町",
      "koName": "미마타 정",
      "esName": "Pueblo de Mimata",
      "ptName": "bairro de Mimata",
      "thName": "เมืองมิมาตะ",
      "viName": "thị trấn Mimata",
      "inName": "kota Mimata",
      "tlName": "bayan ng Mimata",
      "moName": "Мимaта жижиг хот",
      "buName": "မီးမာ့တ မြို့နယ်",
      "khName": "ទីប្រជុំជន មីម៉ាតា",
      "neName": "मिमाता नगर"
    }
  },
  "4536100": {
    "office": {
      "code": "450000",
      "name": "宮崎県",
      "enName": "Miyazaki",
      "officeName": "宮崎地方気象台",
      "chName": "宫崎县",
      "zhName": "宮崎縣",
      "koName": "미야자키현",
      "esName": "Prefectura de Miyazaki",
      "ptName": "Província de Miyazaki",
      "thName": "จังหวัดมิยาซากิ",
      "viName": "Tỉnh Miyazaki",
      "inName": "Prefektur Miyagi",
      "tlName": "Miyazaki Prefecture",
      "moName": "Миязаки аймаг",
      "buName": "မီယာဇာကိ ပြည်နယ်",
      "khName": "ខេត្ដ មីយ៉ាហ្សាគី",
      "neName": "मियाजाकी जिल्ला"
    },
    "class10": {
      "code": "450030",
      "name": "南部山沿い",
      "enName": "Area along mountains of Southern Region",
      "chName": "宫崎县南部靠山",
      "zhName": "宮崎縣南部山沿",
      "koName": "미야자키 현 남부 산간 지역",
      "esName": "Sur de Prefectura de Miyazaki a lo largo de las montañas",
      "ptName": "Ao longo das montanhas da Região sul da Província de Miyazaki",
      "thName": "ส่วนเลียบภูเขาของจังหวัดมิยาซากิตอนใต้",
      "viName": "Dọc núi miền Nam tỉnh Miyazaki",
      "inName": "Sepanjang Gunung di Bagian Selatan Prefektur Miyazaki",
      "tlName": "Bulubunduking lugar sa timog na bahagi ng Miyazaki Prefecture",
      "moName": "Миязаки аймгийн өмнөд уулархаг газар",
      "buName": "မိယဇခိစီရင်စု တောင်ပိုင်းတောင်တန်းဒေသ",
      "khName": "តំបន់ដងភ្នំខាងត្បូងនៃខេត្ដមីយ៉ាហ្សាគី",
      "neName": "मियाजाकी जिल्लाको दक्षिणी भागको पहाड छेउको क्षेत्र"
    },
    "class15": {
      "code": "450031",
      "name": "小林・えびの地区",
      "enName": "Kobayashi Ebino District"
    },
    "class20": {
      "code": "4536100",
      "name": "高原町",
      "enName": "Takaharu Town",
      "kana": "たかはるちょう",
      "chName": "高原町",
      "zhName": "髙原町",
      "koName": "다카하루 정",
      "esName": "Pueblo de Takaharu",
      "ptName": "bairro de Takaharu",
      "thName": "เมืองทากาฮารุ",
      "viName": "thị trấn Takaharu",
      "inName": "kota Takaharu",
      "tlName": "bayan ng Takaharu",
      "moName": "Такахaрү жижиг хот",
      "buName": "တာကားဟာ့ရု မြို့နယ်",
      "khName": "ទីប្រជុំជន តាកាហារូ",
      "neName": "ताकाहारु नगर"
    }
  },
  "4538200": {
    "office": {
      "code": "450000",
      "name": "宮崎県",
      "enName": "Miyazaki",
      "officeName": "宮崎地方気象台",
      "chName": "宫崎县",
      "zhName": "宮崎縣",
      "koName": "미야자키현",
      "esName": "Prefectura de Miyazaki",
      "ptName": "Província de Miyazaki",
      "thName": "จังหวัดมิยาซากิ",
      "viName": "Tỉnh Miyazaki",
      "inName": "Prefektur Miyagi",
      "tlName": "Miyazaki Prefecture",
      "moName": "Миязаки аймаг",
      "buName": "မီယာဇာကိ ပြည်နယ်",
      "khName": "ខេត្ដ មីយ៉ាហ្សាគី",
      "neName": "मियाजाकी जिल्ला"
    },
    "class10": {
      "code": "450010",
      "name": "南部平野部",
      "enName": "Plain Area of Southern Region",
      "chName": "宫崎县南部平原部",
      "zhName": "宮崎縣南部平野部",
      "koName": "미야자키 현 남부 평야",
      "esName": "Parte llanura de Sur de Prefectura de Miyazaki",
      "ptName": "Área da Planície da Região sul da Província de Miyazaki",
      "thName": "ส่วนพื้นราบของจังหวัดมิยาซากิตอนใต้",
      "viName": "Vùng đồng bằng miền Nam tỉnh Miyazaki",
      "inName": "Dataran di Bagian Selatan Prefektur Miyazaki",
      "tlName": "Kapatagang lugar sa timog na bahagi ng Miyazaki Prefecture",
      "moName": "Миязаки аймгийн өмнөд тал газар",
      "buName": "မိယဇခိစီရင်စု တောင်ပိုင်းလွင်ပြင်",
      "khName": "តំបន់ទំនាបខាងត្បូងនៃខេត្ដមីយ៉ាហ្សាគី",
      "neName": "मियाजाकी जिल्लाको दक्षिणी भागको समथर क्षेत्र"
    },
    "class15": {
      "code": "450011",
      "name": "宮崎地区",
      "enName": "Miyazaki District"
    },
    "class20": {
      "code": "4538200",
      "name": "国富町",
      "enName": "Kunitomi Town",
      "kana": "くにとみちょう",
      "chName": "国富町",
      "zhName": "國富町",
      "koName": "구니토미 정",
      "esName": "Pueblo de Kunitomi",
      "ptName": "bairro de Kunitomi",
      "thName": "เมืองคุนิโทมิ",
      "viName": "thị trấn Kunitomi",
      "inName": "kota Kunitomi",
      "tlName": "bayan ng Kunitomi",
      "moName": "Күнитоми жижиг хот",
      "buName": "ခူနိတိုမိ မြို့နယ်",
      "khName": "ទីប្រជុំជន គូនីតូមី",
      "neName": "कुनितोमी नगर"
    }
  },
  "4538300": {
    "office": {
      "code": "450000",
      "name": "宮崎県",
      "enName": "Miyazaki",
      "officeName": "宮崎地方気象台",
      "chName": "宫崎县",
      "zhName": "宮崎縣",
      "koName": "미야자키현",
      "esName": "Prefectura de Miyazaki",
      "ptName": "Província de Miyazaki",
      "thName": "จังหวัดมิยาซากิ",
      "viName": "Tỉnh Miyazaki",
      "inName": "Prefektur Miyagi",
      "tlName": "Miyazaki Prefecture",
      "moName": "Миязаки аймаг",
      "buName": "မီယာဇာကိ ပြည်နယ်",
      "khName": "ខេត្ដ មីយ៉ាហ្សាគី",
      "neName": "मियाजाकी जिल्ला"
    },
    "class10": {
      "code": "450010",
      "name": "南部平野部",
      "enName": "Plain Area of Southern Region",
      "chName": "宫崎县南部平原部",
      "zhName": "宮崎縣南部平野部",
      "koName": "미야자키 현 남부 평야",
      "esName": "Parte llanura de Sur de Prefectura de Miyazaki",
      "ptName": "Área da Planície da Região sul da Província de Miyazaki",
      "thName": "ส่วนพื้นราบของจังหวัดมิยาซากิตอนใต้",
      "viName": "Vùng đồng bằng miền Nam tỉnh Miyazaki",
      "inName": "Dataran di Bagian Selatan Prefektur Miyazaki",
      "tlName": "Kapatagang lugar sa timog na bahagi ng Miyazaki Prefecture",
      "moName": "Миязаки аймгийн өмнөд тал газар",
      "buName": "မိယဇခိစီရင်စု တောင်ပိုင်းလွင်ပြင်",
      "khName": "តំបន់ទំនាបខាងត្បូងនៃខេត្ដមីយ៉ាហ្សាគី",
      "neName": "मियाजाकी जिल्लाको दक्षिणी भागको समथर क्षेत्र"
    },
    "class15": {
      "code": "450011",
      "name": "宮崎地区",
      "enName": "Miyazaki District"
    },
    "class20": {
      "code": "4538300",
      "name": "綾町",
      "enName": "Aya Town",
      "kana": "あやちょう",
      "chName": "绫町",
      "zhName": "綾町",
      "koName": "아야 정",
      "esName": "Pueblo de Aya",
      "ptName": "bairro de Aya",
      "thName": "เมืองอายะ",
      "viName": "thị trấn Aya",
      "inName": "kota Aya",
      "tlName": "bayan ng Aya",
      "moName": "Aяа жижиг хот",
      "buName": "အာယ မြို့နယ်",
      "khName": "ទីប្រជុំជន អាយ៉ា",
      "neName": "आया नगर"
    }
  },
  "4540100": {
    "office": {
      "code": "450000",
      "name": "宮崎県",
      "enName": "Miyazaki",
      "officeName": "宮崎地方気象台",
      "chName": "宫崎县",
      "zhName": "宮崎縣",
      "koName": "미야자키현",
      "esName": "Prefectura de Miyazaki",
      "ptName": "Província de Miyazaki",
      "thName": "จังหวัดมิยาซากิ",
      "viName": "Tỉnh Miyazaki",
      "inName": "Prefektur Miyagi",
      "tlName": "Miyazaki Prefecture",
      "moName": "Миязаки аймаг",
      "buName": "မီယာဇာကိ ပြည်နယ်",
      "khName": "ខេត្ដ មីយ៉ាហ្សាគី",
      "neName": "मियाजाकी जिल्ला"
    },
    "class10": {
      "code": "450020",
      "name": "北部平野部",
      "enName": "Plain Area of Northern Region",
      "chName": "宫崎县北部平原部",
      "zhName": "宮崎縣北部平野部",
      "koName": "미야자키 현 북부 평야",
      "esName": "Parte llanura de Norte de Prefectura de Miyazaki",
      "ptName": "Área da Planície da Região norte da Província de Miyazaki",
      "thName": "ส่วนพื้นราบของจังหวัดมิยาซากิตอนเหนือ",
      "viName": "Vùng đồng bằng miền Bắc tỉnh Miyazaki",
      "inName": "Dataran di Bagian Utara Prefektur Miyazaki",
      "tlName": "Kapatagang lugar sa hilagang bahagi ng Miyazaki Prefecture",
      "moName": "Миязаки аймгийн хойд тал газар",
      "buName": "မိယဇခိစီရင်စု မြောက်ပိုင်းလွင်ပြင်",
      "khName": "តំបន់ទំនាបខាងជើងនៃខេត្ដមីយ៉ាហ្សាគី",
      "neName": "मियाजाकी जिल्लाको उत्तरी भागको समथर क्षेत्र"
    },
    "class15": {
      "code": "450022",
      "name": "西都・高鍋地区",
      "enName": "Saito Takanabe District"
    },
    "class20": {
      "code": "4540100",
      "name": "高鍋町",
      "enName": "Takanabe Town",
      "kana": "たかなべちょう",
      "chName": "高锅町",
      "zhName": "髙鍋町",
      "koName": "다카나베 정",
      "esName": "Pueblo de Takanabe",
      "ptName": "bairro de Takanabe",
      "thName": "เมืองทากานาเบะ",
      "viName": "thị trấn Takanabe",
      "inName": "kota Takanabe",
      "tlName": "bayan ng Takanabe",
      "moName": "Таканaбэ жижиг хот",
      "buName": "တာကားနာ့ဘဲ့ မြို့နယ်",
      "khName": "ទីប្រជុំជន តាកាណាបេ",
      "neName": "ताकानाबे नगर"
    }
  },
  "4540200": {
    "office": {
      "code": "450000",
      "name": "宮崎県",
      "enName": "Miyazaki",
      "officeName": "宮崎地方気象台",
      "chName": "宫崎县",
      "zhName": "宮崎縣",
      "koName": "미야자키현",
      "esName": "Prefectura de Miyazaki",
      "ptName": "Província de Miyazaki",
      "thName": "จังหวัดมิยาซากิ",
      "viName": "Tỉnh Miyazaki",
      "inName": "Prefektur Miyagi",
      "tlName": "Miyazaki Prefecture",
      "moName": "Миязаки аймаг",
      "buName": "မီယာဇာကိ ပြည်နယ်",
      "khName": "ខេត្ដ មីយ៉ាហ្សាគី",
      "neName": "मियाजाकी जिल्ला"
    },
    "class10": {
      "code": "450020",
      "name": "北部平野部",
      "enName": "Plain Area of Northern Region",
      "chName": "宫崎县北部平原部",
      "zhName": "宮崎縣北部平野部",
      "koName": "미야자키 현 북부 평야",
      "esName": "Parte llanura de Norte de Prefectura de Miyazaki",
      "ptName": "Área da Planície da Região norte da Província de Miyazaki",
      "thName": "ส่วนพื้นราบของจังหวัดมิยาซากิตอนเหนือ",
      "viName": "Vùng đồng bằng miền Bắc tỉnh Miyazaki",
      "inName": "Dataran di Bagian Utara Prefektur Miyazaki",
      "tlName": "Kapatagang lugar sa hilagang bahagi ng Miyazaki Prefecture",
      "moName": "Миязаки аймгийн хойд тал газар",
      "buName": "မိယဇခိစီရင်စု မြောက်ပိုင်းလွင်ပြင်",
      "khName": "តំបន់ទំនាបខាងជើងនៃខេត្ដមីយ៉ាហ្សាគី",
      "neName": "मियाजाकी जिल्लाको उत्तरी भागको समथर क्षेत्र"
    },
    "class15": {
      "code": "450022",
      "name": "西都・高鍋地区",
      "enName": "Saito Takanabe District"
    },
    "class20": {
      "code": "4540200",
      "name": "新富町",
      "enName": "Shintomi Town",
      "kana": "しんとみちょう",
      "chName": "新富町",
      "zhName": "新富町",
      "koName": "신토미 정",
      "esName": "Pueblo de Shintomi",
      "ptName": "bairro de Shintomi",
      "thName": "เมืองชินโทมิ",
      "viName": "thị trấn Shintomi",
      "inName": "kota Shintomi",
      "tlName": "bayan ng Shintomi",
      "moName": "Шинтоми жижиг хот",
      "buName": "ရှင်းတိုမိ မြို့နယ်",
      "khName": "ទីប្រជុំជន ស៊ីតូមិ",
      "neName": "शिन्तोमी नगर"
    }
  },
  "4540300": {
    "office": {
      "code": "450000",
      "name": "宮崎県",
      "enName": "Miyazaki",
      "officeName": "宮崎地方気象台",
      "chName": "宫崎县",
      "zhName": "宮崎縣",
      "koName": "미야자키현",
      "esName": "Prefectura de Miyazaki",
      "ptName": "Província de Miyazaki",
      "thName": "จังหวัดมิยาซากิ",
      "viName": "Tỉnh Miyazaki",
      "inName": "Prefektur Miyagi",
      "tlName": "Miyazaki Prefecture",
      "moName": "Миязаки аймаг",
      "buName": "မီယာဇာကိ ပြည်နယ်",
      "khName": "ខេត្ដ មីយ៉ាហ្សាគី",
      "neName": "मियाजाकी जिल्ला"
    },
    "class10": {
      "code": "450040",
      "name": "北部山沿い",
      "enName": "Area along mountains of Northern Region",
      "chName": "宫崎县北部靠山",
      "zhName": "宮崎縣北部山沿",
      "koName": "미야자키 현 북부 산간 지역",
      "esName": "Norte de Prefectura de Miyazaki a lo largo de las montañas",
      "ptName": "Ao longo das montanhas da Região norte da Província de Miyazaki",
      "thName": "ส่วนเลียบภูเขาของจังหวัดมิยาซากิตอนเหนือ",
      "viName": "Dọc núi miền Bắc tỉnh Miyazaki",
      "inName": "Sepanjang Gunung di Bagian Utara Prefektur Miyazaki",
      "tlName": "Bulubunduking lugar sa hilagang bahagi ng Miyazaki Prefecture",
      "moName": "Миязаки аймгийн хойд уулархаг газар",
      "buName": "မိယဇခိစီရင်စု မြောက်ပိုင်းတောင်တန်းဒေသ",
      "khName": "តំបន់ដងភ្នំខាងជើងនៃខេត្ដមីយ៉ាហ្សាគី",
      "neName": "मियाजाकी जिल्लाको उत्तरी भागको पहाड छेउको क्षेत्र"
    },
    "class15": {
      "code": "450042",
      "name": "椎葉・美郷地区",
      "enName": "Shiiba Misato District"
    },
    "class20": {
      "code": "4540300",
      "name": "西米良村",
      "enName": "Nishimera Village",
      "kana": "にしめらそん",
      "chName": "西米良村",
      "zhName": "西米良村",
      "koName": "니시메라 촌",
      "esName": "Aldea de Nishimera",
      "ptName": "povoado de Nishimera",
      "thName": "หมู่บ้านนิชิเมระ",
      "viName": "làng Nishimera",
      "inName": "desa Nishimera",
      "tlName": "nayon ng Nishimera",
      "moName": "Нишимэра тосгон",
      "buName": "နီရှိမဲရာ့ ကျေးရွာ",
      "khName": "ភូមិ នីស៊ីមេរ៉ា",
      "neName": "निशिमेरा गाउँ"
    }
  },
  "4540400": {
    "office": {
      "code": "450000",
      "name": "宮崎県",
      "enName": "Miyazaki",
      "officeName": "宮崎地方気象台",
      "chName": "宫崎县",
      "zhName": "宮崎縣",
      "koName": "미야자키현",
      "esName": "Prefectura de Miyazaki",
      "ptName": "Província de Miyazaki",
      "thName": "จังหวัดมิยาซากิ",
      "viName": "Tỉnh Miyazaki",
      "inName": "Prefektur Miyagi",
      "tlName": "Miyazaki Prefecture",
      "moName": "Миязаки аймаг",
      "buName": "မီယာဇာကိ ပြည်နယ်",
      "khName": "ខេត្ដ មីយ៉ាហ្សាគី",
      "neName": "मियाजाकी जिल्ला"
    },
    "class10": {
      "code": "450020",
      "name": "北部平野部",
      "enName": "Plain Area of Northern Region",
      "chName": "宫崎县北部平原部",
      "zhName": "宮崎縣北部平野部",
      "koName": "미야자키 현 북부 평야",
      "esName": "Parte llanura de Norte de Prefectura de Miyazaki",
      "ptName": "Área da Planície da Região norte da Província de Miyazaki",
      "thName": "ส่วนพื้นราบของจังหวัดมิยาซากิตอนเหนือ",
      "viName": "Vùng đồng bằng miền Bắc tỉnh Miyazaki",
      "inName": "Dataran di Bagian Utara Prefektur Miyazaki",
      "tlName": "Kapatagang lugar sa hilagang bahagi ng Miyazaki Prefecture",
      "moName": "Миязаки аймгийн хойд тал газар",
      "buName": "မိယဇခိစီရင်စု မြောက်ပိုင်းလွင်ပြင်",
      "khName": "តំបន់ទំនាបខាងជើងនៃខេត្ដមីយ៉ាហ្សាគី",
      "neName": "मियाजाकी जिल्लाको उत्तरी भागको समथर क्षेत्र"
    },
    "class15": {
      "code": "450022",
      "name": "西都・高鍋地区",
      "enName": "Saito Takanabe District"
    },
    "class20": {
      "code": "4540400",
      "name": "木城町",
      "enName": "Kijo Town",
      "kana": "きじょうちょう",
      "chName": "木城町",
      "zhName": "木城町",
      "koName": "기조 정",
      "esName": "Pueblo de Kijyo",
      "ptName": "bairro de Kijo",
      "thName": "เมืองคิโจ",
      "viName": "thị trấn Kijo",
      "inName": "kota Kijo",
      "tlName": "bayan ng Kijo",
      "moName": "Кижо жижиг хот",
      "buName": "ခီးဂျို မြို့နယ်",
      "khName": "ទីប្រជុំជន គីជូ",
      "neName": "किजो नगर"
    }
  },
  "4540500": {
    "office": {
      "code": "450000",
      "name": "宮崎県",
      "enName": "Miyazaki",
      "officeName": "宮崎地方気象台",
      "chName": "宫崎县",
      "zhName": "宮崎縣",
      "koName": "미야자키현",
      "esName": "Prefectura de Miyazaki",
      "ptName": "Província de Miyazaki",
      "thName": "จังหวัดมิยาซากิ",
      "viName": "Tỉnh Miyazaki",
      "inName": "Prefektur Miyagi",
      "tlName": "Miyazaki Prefecture",
      "moName": "Миязаки аймаг",
      "buName": "မီယာဇာကိ ပြည်နယ်",
      "khName": "ខេត្ដ មីយ៉ាហ្សាគី",
      "neName": "मियाजाकी जिल्ला"
    },
    "class10": {
      "code": "450020",
      "name": "北部平野部",
      "enName": "Plain Area of Northern Region",
      "chName": "宫崎县北部平原部",
      "zhName": "宮崎縣北部平野部",
      "koName": "미야자키 현 북부 평야",
      "esName": "Parte llanura de Norte de Prefectura de Miyazaki",
      "ptName": "Área da Planície da Região norte da Província de Miyazaki",
      "thName": "ส่วนพื้นราบของจังหวัดมิยาซากิตอนเหนือ",
      "viName": "Vùng đồng bằng miền Bắc tỉnh Miyazaki",
      "inName": "Dataran di Bagian Utara Prefektur Miyazaki",
      "tlName": "Kapatagang lugar sa hilagang bahagi ng Miyazaki Prefecture",
      "moName": "Миязаки аймгийн хойд тал газар",
      "buName": "မိယဇခိစီရင်စု မြောက်ပိုင်းလွင်ပြင်",
      "khName": "តំបន់ទំនាបខាងជើងនៃខេត្ដមីយ៉ាហ្សាគី",
      "neName": "मियाजाकी जिल्लाको उत्तरी भागको समथर क्षेत्र"
    },
    "class15": {
      "code": "450022",
      "name": "西都・高鍋地区",
      "enName": "Saito Takanabe District"
    },
    "class20": {
      "code": "4540500",
      "name": "川南町",
      "enName": "Kawaminami Town",
      "kana": "かわみなみちょう",
      "chName": "川南町",
      "zhName": "川南町",
      "koName": "가와미나미 정",
      "esName": "Pueblo de Kawaminami",
      "ptName": "bairro de Kawaminami",
      "thName": "เมืองคาวามินามิ",
      "viName": "thị trấn Kawaminami",
      "inName": "kota Kawaminami",
      "tlName": "bayan ng Kawaminami",
      "moName": "Каваминами жижиг хот",
      "buName": "ခါဝါမိနားမိ မြို့နယ်",
      "khName": "ទីប្រជុំជន កាវ៉ាមីមីណាមី",
      "neName": "कावामिनामी नगर"
    }
  },
  "4540600": {
    "office": {
      "code": "450000",
      "name": "宮崎県",
      "enName": "Miyazaki",
      "officeName": "宮崎地方気象台",
      "chName": "宫崎县",
      "zhName": "宮崎縣",
      "koName": "미야자키현",
      "esName": "Prefectura de Miyazaki",
      "ptName": "Província de Miyazaki",
      "thName": "จังหวัดมิยาซากิ",
      "viName": "Tỉnh Miyazaki",
      "inName": "Prefektur Miyagi",
      "tlName": "Miyazaki Prefecture",
      "moName": "Миязаки аймаг",
      "buName": "မီယာဇာကိ ပြည်နယ်",
      "khName": "ខេត្ដ មីយ៉ាហ្សាគី",
      "neName": "मियाजाकी जिल्ला"
    },
    "class10": {
      "code": "450020",
      "name": "北部平野部",
      "enName": "Plain Area of Northern Region",
      "chName": "宫崎县北部平原部",
      "zhName": "宮崎縣北部平野部",
      "koName": "미야자키 현 북부 평야",
      "esName": "Parte llanura de Norte de Prefectura de Miyazaki",
      "ptName": "Área da Planície da Região norte da Província de Miyazaki",
      "thName": "ส่วนพื้นราบของจังหวัดมิยาซากิตอนเหนือ",
      "viName": "Vùng đồng bằng miền Bắc tỉnh Miyazaki",
      "inName": "Dataran di Bagian Utara Prefektur Miyazaki",
      "tlName": "Kapatagang lugar sa hilagang bahagi ng Miyazaki Prefecture",
      "moName": "Миязаки аймгийн хойд тал газар",
      "buName": "မိယဇခိစီရင်စု မြောက်ပိုင်းလွင်ပြင်",
      "khName": "តំបន់ទំនាបខាងជើងនៃខេត្ដមីយ៉ាហ្សាគី",
      "neName": "मियाजाकी जिल्लाको उत्तरी भागको समथर क्षेत्र"
    },
    "class15": {
      "code": "450022",
      "name": "西都・高鍋地区",
      "enName": "Saito Takanabe District"
    },
    "class20": {
      "code": "4540600",
      "name": "都農町",
      "enName": "Tsuno Town",
      "kana": "つのちょう",
      "chName": "宫崎都农町",
      "zhName": "宮崎都農町",
      "koName": "미야자키 쓰노 정",
      "esName": "Pueblo de Tsuno, Miyazaki",
      "ptName": "Miyazaki, bairro de Tsuno",
      "thName": "เมืองสึโนะ มิยาซากิ",
      "viName": "Thị trấn Tsuno, Miyazaki",
      "inName": "Kota Tsuno, Miyazaki",
      "tlName": "bayan ng Tsuno, Miyazaki",
      "moName": "Миязаки Цүно жижиг хот",
      "buName": "မိယဇခိဆုနိုမြို့နယ်",
      "khName": "ទីប្រជុំជនស៊ូណូ មីយ៉ាហ្សាគី",
      "neName": "मियाजाकी त्सुनो नगर"
    }
  },
  "4542100": {
    "office": {
      "code": "450000",
      "name": "宮崎県",
      "enName": "Miyazaki",
      "officeName": "宮崎地方気象台",
      "chName": "宫崎县",
      "zhName": "宮崎縣",
      "koName": "미야자키현",
      "esName": "Prefectura de Miyazaki",
      "ptName": "Província de Miyazaki",
      "thName": "จังหวัดมิยาซากิ",
      "viName": "Tỉnh Miyazaki",
      "inName": "Prefektur Miyagi",
      "tlName": "Miyazaki Prefecture",
      "moName": "Миязаки аймаг",
      "buName": "မီယာဇာကိ ပြည်နယ်",
      "khName": "ខេត្ដ មីយ៉ាហ្សាគី",
      "neName": "मियाजाकी जिल्ला"
    },
    "class10": {
      "code": "450020",
      "name": "北部平野部",
      "enName": "Plain Area of Northern Region",
      "chName": "宫崎县北部平原部",
      "zhName": "宮崎縣北部平野部",
      "koName": "미야자키 현 북부 평야",
      "esName": "Parte llanura de Norte de Prefectura de Miyazaki",
      "ptName": "Área da Planície da Região norte da Província de Miyazaki",
      "thName": "ส่วนพื้นราบของจังหวัดมิยาซากิตอนเหนือ",
      "viName": "Vùng đồng bằng miền Bắc tỉnh Miyazaki",
      "inName": "Dataran di Bagian Utara Prefektur Miyazaki",
      "tlName": "Kapatagang lugar sa hilagang bahagi ng Miyazaki Prefecture",
      "moName": "Миязаки аймгийн хойд тал газар",
      "buName": "မိယဇခိစီရင်စု မြောက်ပိုင်းလွင်ပြင်",
      "khName": "តំបន់ទំនាបខាងជើងនៃខេត្ដមីយ៉ាហ្សាគី",
      "neName": "मियाजाकी जिल्लाको उत्तरी भागको समथर क्षेत्र"
    },
    "class15": {
      "code": "450021",
      "name": "延岡・日向地区",
      "enName": "Nobeoka Hyuga District"
    },
    "class20": {
      "code": "4542100",
      "name": "門川町",
      "enName": "Kadogawa Town",
      "kana": "かどがわちょう",
      "chName": "门川町",
      "zhName": "門川町",
      "koName": "가도가와 정",
      "esName": "Pueblo de Kadogawa",
      "ptName": "bairro de Kadogawa",
      "thName": "เมืองคาโดกาวะ",
      "viName": "thị trấn Kadogawa",
      "inName": "kota Kadogawa",
      "tlName": "bayan ng Kadogawa",
      "moName": "Кадогава жижиг хот",
      "buName": "ခါဒိုးဂါ့ဝ မြို့နယ်",
      "khName": "ទីប្រជុំជន កាឌូកាវ៉ា",
      "neName": "कादोगावा नगर"
    }
  },
  "4542900": {
    "office": {
      "code": "450000",
      "name": "宮崎県",
      "enName": "Miyazaki",
      "officeName": "宮崎地方気象台",
      "chName": "宫崎县",
      "zhName": "宮崎縣",
      "koName": "미야자키현",
      "esName": "Prefectura de Miyazaki",
      "ptName": "Província de Miyazaki",
      "thName": "จังหวัดมิยาซากิ",
      "viName": "Tỉnh Miyazaki",
      "inName": "Prefektur Miyagi",
      "tlName": "Miyazaki Prefecture",
      "moName": "Миязаки аймаг",
      "buName": "မီယာဇာကိ ပြည်နယ်",
      "khName": "ខេត្ដ មីយ៉ាហ្សាគី",
      "neName": "मियाजाकी जिल्ला"
    },
    "class10": {
      "code": "450040",
      "name": "北部山沿い",
      "enName": "Area along mountains of Northern Region",
      "chName": "宫崎县北部靠山",
      "zhName": "宮崎縣北部山沿",
      "koName": "미야자키 현 북부 산간 지역",
      "esName": "Norte de Prefectura de Miyazaki a lo largo de las montañas",
      "ptName": "Ao longo das montanhas da Região norte da Província de Miyazaki",
      "thName": "ส่วนเลียบภูเขาของจังหวัดมิยาซากิตอนเหนือ",
      "viName": "Dọc núi miền Bắc tỉnh Miyazaki",
      "inName": "Sepanjang Gunung di Bagian Utara Prefektur Miyazaki",
      "tlName": "Bulubunduking lugar sa hilagang bahagi ng Miyazaki Prefecture",
      "moName": "Миязаки аймгийн хойд уулархаг газар",
      "buName": "မိယဇခိစီရင်စု မြောက်ပိုင်းတောင်တန်းဒေသ",
      "khName": "តំបន់ដងភ្នំខាងជើងនៃខេត្ដមីយ៉ាហ្សាគី",
      "neName": "मियाजाकी जिल्लाको उत्तरी भागको पहाड छेउको क्षेत्र"
    },
    "class15": {
      "code": "450042",
      "name": "椎葉・美郷地区",
      "enName": "Shiiba Misato District"
    },
    "class20": {
      "code": "4542900",
      "name": "諸塚村",
      "enName": "Morotsuka Village",
      "kana": "もろつかそん",
      "chName": "诸冢村",
      "zhName": "諸塚村",
      "koName": "모로쓰카 촌",
      "esName": "Aldea de Morotsuka",
      "ptName": "povoado de Morotsuka",
      "thName": "หมู่บ้านโมโรสึกะ",
      "viName": "làng Morotsuka",
      "inName": "desa Morotsuka",
      "tlName": "nayon ng Morotsuka",
      "moName": "Мороцүка тосгон",
      "buName": "မိုရိုးဆုက ကျေးရွာ",
      "khName": "ភូមិ ម៉ូរូសូកា",
      "neName": "मोरोत्सुका गाउँ"
    }
  },
  "4543000": {
    "office": {
      "code": "450000",
      "name": "宮崎県",
      "enName": "Miyazaki",
      "officeName": "宮崎地方気象台",
      "chName": "宫崎县",
      "zhName": "宮崎縣",
      "koName": "미야자키현",
      "esName": "Prefectura de Miyazaki",
      "ptName": "Província de Miyazaki",
      "thName": "จังหวัดมิยาซากิ",
      "viName": "Tỉnh Miyazaki",
      "inName": "Prefektur Miyagi",
      "tlName": "Miyazaki Prefecture",
      "moName": "Миязаки аймаг",
      "buName": "မီယာဇာကိ ပြည်နယ်",
      "khName": "ខេត្ដ មីយ៉ាហ្សាគី",
      "neName": "मियाजाकी जिल्ला"
    },
    "class10": {
      "code": "450040",
      "name": "北部山沿い",
      "enName": "Area along mountains of Northern Region",
      "chName": "宫崎县北部靠山",
      "zhName": "宮崎縣北部山沿",
      "koName": "미야자키 현 북부 산간 지역",
      "esName": "Norte de Prefectura de Miyazaki a lo largo de las montañas",
      "ptName": "Ao longo das montanhas da Região norte da Província de Miyazaki",
      "thName": "ส่วนเลียบภูเขาของจังหวัดมิยาซากิตอนเหนือ",
      "viName": "Dọc núi miền Bắc tỉnh Miyazaki",
      "inName": "Sepanjang Gunung di Bagian Utara Prefektur Miyazaki",
      "tlName": "Bulubunduking lugar sa hilagang bahagi ng Miyazaki Prefecture",
      "moName": "Миязаки аймгийн хойд уулархаг газар",
      "buName": "မိယဇခိစီရင်စု မြောက်ပိုင်းတောင်တန်းဒေသ",
      "khName": "តំបន់ដងភ្នំខាងជើងនៃខេត្ដមីយ៉ាហ្សាគី",
      "neName": "मियाजाकी जिल्लाको उत्तरी भागको पहाड छेउको क्षेत्र"
    },
    "class15": {
      "code": "450042",
      "name": "椎葉・美郷地区",
      "enName": "Shiiba Misato District"
    },
    "class20": {
      "code": "4543000",
      "name": "椎葉村",
      "enName": "Shiiba Village",
      "kana": "しいばそん",
      "chName": "椎叶村",
      "zhName": "椎葉村",
      "koName": "시이바 촌",
      "esName": "Aldea de Shiiba",
      "ptName": "povoado de Shiiba",
      "thName": "หมู่บ้านชิอิบะ",
      "viName": "làng Shiiba",
      "inName": "desa Shiiba",
      "tlName": "nayon ng Shiiba",
      "moName": "Шийба тосгон",
      "buName": "ရှီးယိဘ ကျေးရွာ",
      "khName": "ភូមិ ស៊ីអ៊ីបា",
      "neName": "शिइबा गाउँ"
    }
  },
  "4543100": {
    "office": {
      "code": "450000",
      "name": "宮崎県",
      "enName": "Miyazaki",
      "officeName": "宮崎地方気象台",
      "chName": "宫崎县",
      "zhName": "宮崎縣",
      "koName": "미야자키현",
      "esName": "Prefectura de Miyazaki",
      "ptName": "Província de Miyazaki",
      "thName": "จังหวัดมิยาซากิ",
      "viName": "Tỉnh Miyazaki",
      "inName": "Prefektur Miyagi",
      "tlName": "Miyazaki Prefecture",
      "moName": "Миязаки аймаг",
      "buName": "မီယာဇာကိ ပြည်နယ်",
      "khName": "ខេត្ដ មីយ៉ាហ្សាគី",
      "neName": "मियाजाकी जिल्ला"
    },
    "class10": {
      "code": "450040",
      "name": "北部山沿い",
      "enName": "Area along mountains of Northern Region",
      "chName": "宫崎县北部靠山",
      "zhName": "宮崎縣北部山沿",
      "koName": "미야자키 현 북부 산간 지역",
      "esName": "Norte de Prefectura de Miyazaki a lo largo de las montañas",
      "ptName": "Ao longo das montanhas da Região norte da Província de Miyazaki",
      "thName": "ส่วนเลียบภูเขาของจังหวัดมิยาซากิตอนเหนือ",
      "viName": "Dọc núi miền Bắc tỉnh Miyazaki",
      "inName": "Sepanjang Gunung di Bagian Utara Prefektur Miyazaki",
      "tlName": "Bulubunduking lugar sa hilagang bahagi ng Miyazaki Prefecture",
      "moName": "Миязаки аймгийн хойд уулархаг газар",
      "buName": "မိယဇခိစီရင်စု မြောက်ပိုင်းတောင်တန်းဒေသ",
      "khName": "តំបន់ដងភ្នំខាងជើងនៃខេត្ដមីយ៉ាហ្សាគី",
      "neName": "मियाजाकी जिल्लाको उत्तरी भागको पहाड छेउको क्षेत्र"
    },
    "class15": {
      "code": "450042",
      "name": "椎葉・美郷地区",
      "enName": "Shiiba Misato District"
    },
    "class20": {
      "code": "4543100",
      "name": "美郷町",
      "enName": "Misato Town",
      "kana": "みさとちょう",
      "chName": "宫崎美乡町",
      "zhName": "宮崎美鄉町",
      "koName": "미야자키 미사토 정",
      "esName": "Pueblo de Misato, Miyazaki",
      "ptName": "Miyazaki, bairro de Misato ",
      "thName": "เมืองมิซาโตะ มิยาซากิ",
      "viName": "Thị trấn Misato, Miyazaki",
      "inName": "Kota Misato, Miyazaki",
      "tlName": "bayan ng Misato, Miyazaki",
      "moName": "Миязаки Мисато жижиг хот",
      "buName": "မိယဇခိခိမိနိုမြို့နယ်",
      "khName": "ទីប្រជុំជនមីសាតូ មីយ៉ាហ្សាគី",
      "neName": "मियाजाकी मिसातो नगर"
    }
  },
  "4544100": {
    "office": {
      "code": "450000",
      "name": "宮崎県",
      "enName": "Miyazaki",
      "officeName": "宮崎地方気象台",
      "chName": "宫崎县",
      "zhName": "宮崎縣",
      "koName": "미야자키현",
      "esName": "Prefectura de Miyazaki",
      "ptName": "Província de Miyazaki",
      "thName": "จังหวัดมิยาซากิ",
      "viName": "Tỉnh Miyazaki",
      "inName": "Prefektur Miyagi",
      "tlName": "Miyazaki Prefecture",
      "moName": "Миязаки аймаг",
      "buName": "မီယာဇာကိ ပြည်နယ်",
      "khName": "ខេត្ដ មីយ៉ាហ្សាគី",
      "neName": "मियाजाकी जिल्ला"
    },
    "class10": {
      "code": "450040",
      "name": "北部山沿い",
      "enName": "Area along mountains of Northern Region",
      "chName": "宫崎县北部靠山",
      "zhName": "宮崎縣北部山沿",
      "koName": "미야자키 현 북부 산간 지역",
      "esName": "Norte de Prefectura de Miyazaki a lo largo de las montañas",
      "ptName": "Ao longo das montanhas da Região norte da Província de Miyazaki",
      "thName": "ส่วนเลียบภูเขาของจังหวัดมิยาซากิตอนเหนือ",
      "viName": "Dọc núi miền Bắc tỉnh Miyazaki",
      "inName": "Sepanjang Gunung di Bagian Utara Prefektur Miyazaki",
      "tlName": "Bulubunduking lugar sa hilagang bahagi ng Miyazaki Prefecture",
      "moName": "Миязаки аймгийн хойд уулархаг газар",
      "buName": "မိယဇခိစီရင်စု မြောက်ပိုင်းတောင်တန်းဒေသ",
      "khName": "តំបន់ដងភ្នំខាងជើងនៃខេត្ដមីយ៉ាហ្សាគី",
      "neName": "मियाजाकी जिल्लाको उत्तरी भागको पहाड छेउको क्षेत्र"
    },
    "class15": {
      "code": "450041",
      "name": "高千穂地区",
      "enName": "Takachiho District"
    },
    "class20": {
      "code": "4544100",
      "name": "高千穂町",
      "enName": "Takachiho Town",
      "kana": "たかちほちょう",
      "chName": "高千穗町",
      "zhName": "髙千穗町",
      "koName": "다카치호 정",
      "esName": "Pueblo de Takachiho",
      "ptName": "bairro de Takachiho",
      "thName": "เมืองทากาจิโฮะ",
      "viName": "thị trấn Takachiho",
      "inName": "kota Takachiho",
      "tlName": "bayan ng Takachiho",
      "moName": "Такачихо жижиг хот",
      "buName": "တာကားကျိဟို မြို့နယ်",
      "khName": "ទីប្រជុំជន តាកាជីហូ",
      "neName": "ताकाचिहो नगर"
    }
  },
  "4544200": {
    "office": {
      "code": "450000",
      "name": "宮崎県",
      "enName": "Miyazaki",
      "officeName": "宮崎地方気象台",
      "chName": "宫崎县",
      "zhName": "宮崎縣",
      "koName": "미야자키현",
      "esName": "Prefectura de Miyazaki",
      "ptName": "Província de Miyazaki",
      "thName": "จังหวัดมิยาซากิ",
      "viName": "Tỉnh Miyazaki",
      "inName": "Prefektur Miyagi",
      "tlName": "Miyazaki Prefecture",
      "moName": "Миязаки аймаг",
      "buName": "မီယာဇာကိ ပြည်နယ်",
      "khName": "ខេត្ដ មីយ៉ាហ្សាគី",
      "neName": "मियाजाकी जिल्ला"
    },
    "class10": {
      "code": "450040",
      "name": "北部山沿い",
      "enName": "Area along mountains of Northern Region",
      "chName": "宫崎县北部靠山",
      "zhName": "宮崎縣北部山沿",
      "koName": "미야자키 현 북부 산간 지역",
      "esName": "Norte de Prefectura de Miyazaki a lo largo de las montañas",
      "ptName": "Ao longo das montanhas da Região norte da Província de Miyazaki",
      "thName": "ส่วนเลียบภูเขาของจังหวัดมิยาซากิตอนเหนือ",
      "viName": "Dọc núi miền Bắc tỉnh Miyazaki",
      "inName": "Sepanjang Gunung di Bagian Utara Prefektur Miyazaki",
      "tlName": "Bulubunduking lugar sa hilagang bahagi ng Miyazaki Prefecture",
      "moName": "Миязаки аймгийн хойд уулархаг газар",
      "buName": "မိယဇခိစီရင်စု မြောက်ပိုင်းတောင်တန်းဒေသ",
      "khName": "តំបន់ដងភ្នំខាងជើងនៃខេត្ដមីយ៉ាហ្សាគី",
      "neName": "मियाजाकी जिल्लाको उत्तरी भागको पहाड छेउको क्षेत्र"
    },
    "class15": {
      "code": "450041",
      "name": "高千穂地区",
      "enName": "Takachiho District"
    },
    "class20": {
      "code": "4544200",
      "name": "日之影町",
      "enName": "Hinokage Town",
      "kana": "ひのかげちょう",
      "chName": "日之影町",
      "zhName": "日之影町",
      "koName": "히노카게 정",
      "esName": "Pueblo de Hinokage",
      "ptName": "bairro de Hinokage",
      "thName": "เมืองฮิโนะคาเกะ",
      "viName": "thị trấn Hinokage",
      "inName": "kota Hinokage",
      "tlName": "bayan ng Hinokage",
      "moName": "Хинокагэ жижиг хот",
      "buName": "ဟီနောကာ့ဂဲ့ မြို့နယ်",
      "khName": "ទីប្រជុំជន ហ៊ីណូគុជិ",
      "neName": "हिनोकागे नगर"
    }
  },
  "4544300": {
    "office": {
      "code": "450000",
      "name": "宮崎県",
      "enName": "Miyazaki",
      "officeName": "宮崎地方気象台",
      "chName": "宫崎县",
      "zhName": "宮崎縣",
      "koName": "미야자키현",
      "esName": "Prefectura de Miyazaki",
      "ptName": "Província de Miyazaki",
      "thName": "จังหวัดมิยาซากิ",
      "viName": "Tỉnh Miyazaki",
      "inName": "Prefektur Miyagi",
      "tlName": "Miyazaki Prefecture",
      "moName": "Миязаки аймаг",
      "buName": "မီယာဇာကိ ပြည်နယ်",
      "khName": "ខេត្ដ មីយ៉ាហ្សាគី",
      "neName": "मियाजाकी जिल्ला"
    },
    "class10": {
      "code": "450040",
      "name": "北部山沿い",
      "enName": "Area along mountains of Northern Region",
      "chName": "宫崎县北部靠山",
      "zhName": "宮崎縣北部山沿",
      "koName": "미야자키 현 북부 산간 지역",
      "esName": "Norte de Prefectura de Miyazaki a lo largo de las montañas",
      "ptName": "Ao longo das montanhas da Região norte da Província de Miyazaki",
      "thName": "ส่วนเลียบภูเขาของจังหวัดมิยาซากิตอนเหนือ",
      "viName": "Dọc núi miền Bắc tỉnh Miyazaki",
      "inName": "Sepanjang Gunung di Bagian Utara Prefektur Miyazaki",
      "tlName": "Bulubunduking lugar sa hilagang bahagi ng Miyazaki Prefecture",
      "moName": "Миязаки аймгийн хойд уулархаг газар",
      "buName": "မိယဇခိစီရင်စု မြောက်ပိုင်းတောင်တန်းဒေသ",
      "khName": "តំបន់ដងភ្នំខាងជើងនៃខេត្ដមីយ៉ាហ្សាគី",
      "neName": "मियाजाकी जिल्लाको उत्तरी भागको पहाड छेउको क्षेत्र"
    },
    "class15": {
      "code": "450041",
      "name": "高千穂地区",
      "enName": "Takachiho District"
    },
    "class20": {
      "code": "4544300",
      "name": "五ヶ瀬町",
      "enName": "Gokase Town",
      "kana": "ごかせちょう",
      "chName": "五濑町",
      "zhName": "五瀨町",
      "koName": "고카세 정",
      "esName": "Pueblo de Gokase",
      "ptName": "bairro de Gokase",
      "thName": "เมืองโกคาเซะ",
      "viName": "thị trấn Gokase",
      "inName": "kota Gokase",
      "tlName": "bayan ng Gokase",
      "moName": "Гокасэ жижиг хот",
      "buName": "ဂိုးကာ့ဆဲ့ မြို့နယ်",
      "khName": "ទីប្រជុំជន ហ្កូកាសេ",
      "neName": "गोकासे नगर"
    }
  },
  "4620100": {
    "office": {
      "code": "460100",
      "name": "鹿児島県（奄美地方除く）",
      "enName": "Kagoshima (Excluding Amami)",
      "officeName": "鹿児島地方気象台",
      "chName": "鹿兒島縣（奄美地區除外）",
      "zhName": "鹿儿岛县（奄美地区除外）",
      "koName": "가고시마현(아마미 지방 제외)",
      "esName": "Prefectura de Kagoshima (excluyendo la región de Amami)",
      "ptName": "Prefeitura de Kagoshima (excluindo a região de Amami)",
      "thName": "จังหวัดคาโกชิมะ (ไม่รวมภูมิภาคอามามิ)",
      "viName": "Tỉnh Kagoshima (trừ vùng Amami)",
      "inName": "Prefektur Kagoshima (tidak termasuk wilayah Amami)",
      "tlName": "Kagoshima (Excluding Amami)",
      "moName": "Кагошима муж (Амами мужаас бусад)",
      "buName": "Kagoshima စီရင်စု (Amami ဒေသ မပါဝင်)",
      "khName": "ខេត្ត Kagoshima (មិនរាប់បញ្ចូលតំបន់ Amami)",
      "neName": "कागोशिमा प्रीफेक्चर (अमामी क्षेत्र बाहेक)"
    },
    "class10": {
      "code": "460010",
      "name": "薩摩地方",
      "enName": "Satsuma Region",
      "chName": "鹿儿岛县萨摩地方",
      "zhName": "鹿兒島縣薩摩地方",
      "koName": "가고시마 현 사쓰마 지방",
      "esName": "Región Satsuma, Prefectura de Kagoshima",
      "ptName": "Região de Satsuma da Província de Kagoshima",
      "thName": "ท้องถิ่นซัตสึมะ จังหวัดคาโงชิมะ",
      "viName": "Vùng Satsuma, tỉnh Kagoshima",
      "inName": "Daerah Satsuma di Prefektur Kagoshima",
      "tlName": "Rehiyon ng Satsuma sa Kagoshima Prefecture",
      "moName": "Кагошима аймаг, Сацүма муж",
      "buName": "ဆဆုမဒေသ၊ ကဂိုရှိမစီရင်စု",
      "khName": "សាហ្សឹម៉ានៃខេត្ដកាកូស៊ីម៉ា",
      "neName": "खागोसिमा जिल्ला, साचुमा क्षेत्र"
    },
    "class15": {
      "code": "460011",
      "name": "鹿児島・日置",
      "enName": "Kagoshima Hioki"
    },
    "class20": {
      "code": "4620100",
      "name": "鹿児島市",
      "enName": "Kagoshima City",
      "kana": "かごしまし",
      "chName": "鹿儿岛市",
      "zhName": "鹿兒島市",
      "koName": "가고시마 시",
      "esName": "Ciudad de Kagoshima",
      "ptName": "cidade de Kagoshima",
      "thName": "เมืองคาโกชิมะ",
      "viName": "thành phố Kagoshima",
      "inName": "kota Kagoshima",
      "tlName": "siyudad ng Kagoshima",
      "moName": "Кагошимa хот",
      "buName": "ခါဂိုးရှိမ မြို့",
      "khName": "ទីក្រុង កាហ្គូស៊ីម៉ា",
      "neName": "कागोशिमा सहर"
    }
  },
  "4620300": {
    "office": {
      "code": "460100",
      "name": "鹿児島県（奄美地方除く）",
      "enName": "Kagoshima (Excluding Amami)",
      "officeName": "鹿児島地方気象台",
      "chName": "鹿兒島縣（奄美地區除外）",
      "zhName": "鹿儿岛县（奄美地区除外）",
      "koName": "가고시마현(아마미 지방 제외)",
      "esName": "Prefectura de Kagoshima (excluyendo la región de Amami)",
      "ptName": "Prefeitura de Kagoshima (excluindo a região de Amami)",
      "thName": "จังหวัดคาโกชิมะ (ไม่รวมภูมิภาคอามามิ)",
      "viName": "Tỉnh Kagoshima (trừ vùng Amami)",
      "inName": "Prefektur Kagoshima (tidak termasuk wilayah Amami)",
      "tlName": "Kagoshima (Excluding Amami)",
      "moName": "Кагошима муж (Амами мужаас бусад)",
      "buName": "Kagoshima စီရင်စု (Amami ဒေသ မပါဝင်)",
      "khName": "ខេត្ត Kagoshima (មិនរាប់បញ្ចូលតំបន់ Amami)",
      "neName": "कागोशिमा प्रीफेक्चर (अमामी क्षेत्र बाहेक)"
    },
    "class10": {
      "code": "460020",
      "name": "大隅地方",
      "enName": "Osumi Region",
      "chName": "鹿儿岛县大隅地方",
      "zhName": "鹿兒島縣大隅地方",
      "koName": "가고시마 현 오스미 지방",
      "esName": "Región Osumi, Prefectura de Kagoshima",
      "ptName": "Região de Ōsumi de Província de Kagoshima",
      "thName": "ท้องถิ่นโอซุมิ จังหวัดคาโงชิมะ",
      "viName": "Vùng Osumi, tỉnh Kagoshima",
      "inName": "Daerah Osumi di Prefektur Kagoshima",
      "tlName": "Rehiyon ng Osumi sa Kagoshima Prefecture",
      "moName": "Кагошима аймаг, Осүми муж",
      "buName": "အိုဆုမိဒေသ၊ ကဂိုရှိမစီရင်စု",
      "khName": "តំបន់អូសឹមីនៃខេត្ដកាកូស៊ីម៉ា",
      "neName": "खागोसिमा जिल्ला, ओसुमी क्षेत्र"
    },
    "class15": {
      "code": "460022",
      "name": "肝属",
      "enName": "Kimotsuki"
    },
    "class20": {
      "code": "4620300",
      "name": "鹿屋市",
      "enName": "Kanoya City",
      "kana": "かのやし",
      "chName": "鹿屋市",
      "zhName": "鹿屋市",
      "koName": "가노야 시",
      "esName": "Ciudad de Kanoya",
      "ptName": "cidade de Kanoya",
      "thName": "เมืองคาโนะยะ",
      "viName": "thành phố Kanoya",
      "inName": "kota Kanoya",
      "tlName": "siyudad ng Kanoya",
      "moName": "Каноя хот",
      "buName": "ခါနောယ မြို့",
      "khName": "ទីក្រុង កាណូយ៉ា",
      "neName": "कानोया सहर"
    }
  },
  "4620400": {
    "office": {
      "code": "460100",
      "name": "鹿児島県（奄美地方除く）",
      "enName": "Kagoshima (Excluding Amami)",
      "officeName": "鹿児島地方気象台",
      "chName": "鹿兒島縣（奄美地區除外）",
      "zhName": "鹿儿岛县（奄美地区除外）",
      "koName": "가고시마현(아마미 지방 제외)",
      "esName": "Prefectura de Kagoshima (excluyendo la región de Amami)",
      "ptName": "Prefeitura de Kagoshima (excluindo a região de Amami)",
      "thName": "จังหวัดคาโกชิมะ (ไม่รวมภูมิภาคอามามิ)",
      "viName": "Tỉnh Kagoshima (trừ vùng Amami)",
      "inName": "Prefektur Kagoshima (tidak termasuk wilayah Amami)",
      "tlName": "Kagoshima (Excluding Amami)",
      "moName": "Кагошима муж (Амами мужаас бусад)",
      "buName": "Kagoshima စီရင်စု (Amami ဒေသ မပါဝင်)",
      "khName": "ខេត្ត Kagoshima (មិនរាប់បញ្ចូលតំបន់ Amami)",
      "neName": "कागोशिमा प्रीफेक्चर (अमामी क्षेत्र बाहेक)"
    },
    "class10": {
      "code": "460010",
      "name": "薩摩地方",
      "enName": "Satsuma Region",
      "chName": "鹿儿岛县萨摩地方",
      "zhName": "鹿兒島縣薩摩地方",
      "koName": "가고시마 현 사쓰마 지방",
      "esName": "Región Satsuma, Prefectura de Kagoshima",
      "ptName": "Região de Satsuma da Província de Kagoshima",
      "thName": "ท้องถิ่นซัตสึมะ จังหวัดคาโงชิมะ",
      "viName": "Vùng Satsuma, tỉnh Kagoshima",
      "inName": "Daerah Satsuma di Prefektur Kagoshima",
      "tlName": "Rehiyon ng Satsuma sa Kagoshima Prefecture",
      "moName": "Кагошима аймаг, Сацүма муж",
      "buName": "ဆဆုမဒေသ၊ ကဂိုရှိမစီရင်စု",
      "khName": "សាហ្សឹម៉ានៃខេត្ដកាកូស៊ីម៉ា",
      "neName": "खागोसिमा जिल्ला, साचुमा क्षेत्र"
    },
    "class15": {
      "code": "460015",
      "name": "指宿・川辺",
      "enName": "Ibusuki Kawanabe"
    },
    "class20": {
      "code": "4620400",
      "name": "枕崎市",
      "enName": "Makurazaki City",
      "kana": "まくらざきし",
      "chName": "枕崎市",
      "zhName": "枕崎市",
      "koName": "마쿠라자키 시",
      "esName": "Ciudad de Makurazaki",
      "ptName": "cidade de Makurazaki",
      "thName": "เมืองมาคุระซากิ",
      "viName": "thành phố Makurazaki",
      "inName": "kota Makurazaki",
      "tlName": "siyudad ng Makurazaki",
      "moName": "Мaкүразaки хот",
      "buName": "မာကုရဇာ့ကိ မြို့",
      "khName": "ទីក្រុង ម៉ាគូរ៉ាសាគី",
      "neName": "माकुराजाकी सहर"
    }
  },
  "4620600": {
    "office": {
      "code": "460100",
      "name": "鹿児島県（奄美地方除く）",
      "enName": "Kagoshima (Excluding Amami)",
      "officeName": "鹿児島地方気象台",
      "chName": "鹿兒島縣（奄美地區除外）",
      "zhName": "鹿儿岛县（奄美地区除外）",
      "koName": "가고시마현(아마미 지방 제외)",
      "esName": "Prefectura de Kagoshima (excluyendo la región de Amami)",
      "ptName": "Prefeitura de Kagoshima (excluindo a região de Amami)",
      "thName": "จังหวัดคาโกชิมะ (ไม่รวมภูมิภาคอามามิ)",
      "viName": "Tỉnh Kagoshima (trừ vùng Amami)",
      "inName": "Prefektur Kagoshima (tidak termasuk wilayah Amami)",
      "tlName": "Kagoshima (Excluding Amami)",
      "moName": "Кагошима муж (Амами мужаас бусад)",
      "buName": "Kagoshima စီရင်စု (Amami ဒေသ မပါဝင်)",
      "khName": "ខេត្ត Kagoshima (មិនរាប់បញ្ចូលតំបន់ Amami)",
      "neName": "कागोशिमा प्रीफेक्चर (अमामी क्षेत्र बाहेक)"
    },
    "class10": {
      "code": "460010",
      "name": "薩摩地方",
      "enName": "Satsuma Region",
      "chName": "鹿儿岛县萨摩地方",
      "zhName": "鹿兒島縣薩摩地方",
      "koName": "가고시마 현 사쓰마 지방",
      "esName": "Región Satsuma, Prefectura de Kagoshima",
      "ptName": "Região de Satsuma da Província de Kagoshima",
      "thName": "ท้องถิ่นซัตสึมะ จังหวัดคาโงชิมะ",
      "viName": "Vùng Satsuma, tỉnh Kagoshima",
      "inName": "Daerah Satsuma di Prefektur Kagoshima",
      "tlName": "Rehiyon ng Satsuma sa Kagoshima Prefecture",
      "moName": "Кагошима аймаг, Сацүма муж",
      "buName": "ဆဆုမဒေသ၊ ကဂိုရှိမစီရင်စု",
      "khName": "សាហ្សឹម៉ានៃខេត្ដកាកូស៊ីម៉ា",
      "neName": "खागोसिमा जिल्ला, साचुमा क्षेत्र"
    },
    "class15": {
      "code": "460012",
      "name": "出水・伊佐",
      "enName": "Izumi Isa"
    },
    "class20": {
      "code": "4620600",
      "name": "阿久根市",
      "enName": "Akune City",
      "kana": "あくねし",
      "chName": "阿久根市",
      "zhName": "阿久根市",
      "koName": "아쿠네 시",
      "esName": "Ciudad de Akune",
      "ptName": "cidade de Akune",
      "thName": "เมืองอะคุเนะ",
      "viName": "thành phố Akune",
      "inName": "kota Akune",
      "tlName": "siyudad ng Akune",
      "moName": "Aкүнэ хот",
      "buName": "အာကုနဲ့ မြို့",
      "khName": "ទីក្រុង អាឃ្យូន",
      "neName": "आकुने सहर"
    }
  },
  "4620800": {
    "office": {
      "code": "460100",
      "name": "鹿児島県（奄美地方除く）",
      "enName": "Kagoshima (Excluding Amami)",
      "officeName": "鹿児島地方気象台",
      "chName": "鹿兒島縣（奄美地區除外）",
      "zhName": "鹿儿岛县（奄美地区除外）",
      "koName": "가고시마현(아마미 지방 제외)",
      "esName": "Prefectura de Kagoshima (excluyendo la región de Amami)",
      "ptName": "Prefeitura de Kagoshima (excluindo a região de Amami)",
      "thName": "จังหวัดคาโกชิมะ (ไม่รวมภูมิภาคอามามิ)",
      "viName": "Tỉnh Kagoshima (trừ vùng Amami)",
      "inName": "Prefektur Kagoshima (tidak termasuk wilayah Amami)",
      "tlName": "Kagoshima (Excluding Amami)",
      "moName": "Кагошима муж (Амами мужаас бусад)",
      "buName": "Kagoshima စီရင်စု (Amami ဒေသ မပါဝင်)",
      "khName": "ខេត្ត Kagoshima (មិនរាប់បញ្ចូលតំបន់ Amami)",
      "neName": "कागोशिमा प्रीफेक्चर (अमामी क्षेत्र बाहेक)"
    },
    "class10": {
      "code": "460010",
      "name": "薩摩地方",
      "enName": "Satsuma Region",
      "chName": "鹿儿岛县萨摩地方",
      "zhName": "鹿兒島縣薩摩地方",
      "koName": "가고시마 현 사쓰마 지방",
      "esName": "Región Satsuma, Prefectura de Kagoshima",
      "ptName": "Região de Satsuma da Província de Kagoshima",
      "thName": "ท้องถิ่นซัตสึมะ จังหวัดคาโงชิมะ",
      "viName": "Vùng Satsuma, tỉnh Kagoshima",
      "inName": "Daerah Satsuma di Prefektur Kagoshima",
      "tlName": "Rehiyon ng Satsuma sa Kagoshima Prefecture",
      "moName": "Кагошима аймаг, Сацүма муж",
      "buName": "ဆဆုမဒေသ၊ ကဂိုရှိမစီရင်စု",
      "khName": "សាហ្សឹម៉ានៃខេត្ដកាកូស៊ីម៉ា",
      "neName": "खागोसिमा जिल्ला, साचुमा क्षेत्र"
    },
    "class15": {
      "code": "460012",
      "name": "出水・伊佐",
      "enName": "Izumi Isa"
    },
    "class20": {
      "code": "4620800",
      "name": "出水市",
      "enName": "Izumi City",
      "kana": "いずみし",
      "chName": "鹿儿岛出水市",
      "zhName": "鹿兒島出水市",
      "koName": "가고시마 이즈미 시",
      "esName": "Ciudad de Izumi, Kagoshima",
      "ptName": "Kagoshima, cidade de Izumi",
      "thName": "เมืองอิสุมิ คาโกชิมะ",
      "viName": "Thành phố Izumi, Kagoshima",
      "inName": "Kota Izumi, Kagoshima",
      "tlName": "siyudad ng Izumi, Kagoshima",
      "moName": "Кагошима Изүми хот",
      "buName": "ကဂိုရှိမအိဇုမိမြို့",
      "khName": "ទីក្រុងអ៊ីហ្សុមី កាកូស៊ីម៉ា",
      "neName": "खागोसिमा इजुमी सहर"
    }
  },
  "4621000": {
    "office": {
      "code": "460100",
      "name": "鹿児島県（奄美地方除く）",
      "enName": "Kagoshima (Excluding Amami)",
      "officeName": "鹿児島地方気象台",
      "chName": "鹿兒島縣（奄美地區除外）",
      "zhName": "鹿儿岛县（奄美地区除外）",
      "koName": "가고시마현(아마미 지방 제외)",
      "esName": "Prefectura de Kagoshima (excluyendo la región de Amami)",
      "ptName": "Prefeitura de Kagoshima (excluindo a região de Amami)",
      "thName": "จังหวัดคาโกชิมะ (ไม่รวมภูมิภาคอามามิ)",
      "viName": "Tỉnh Kagoshima (trừ vùng Amami)",
      "inName": "Prefektur Kagoshima (tidak termasuk wilayah Amami)",
      "tlName": "Kagoshima (Excluding Amami)",
      "moName": "Кагошима муж (Амами мужаас бусад)",
      "buName": "Kagoshima စီရင်စု (Amami ဒေသ မပါဝင်)",
      "khName": "ខេត្ត Kagoshima (មិនរាប់បញ្ចូលតំបន់ Amami)",
      "neName": "कागोशिमा प्रीफेक्चर (अमामी क्षेत्र बाहेक)"
    },
    "class10": {
      "code": "460010",
      "name": "薩摩地方",
      "enName": "Satsuma Region",
      "chName": "鹿儿岛县萨摩地方",
      "zhName": "鹿兒島縣薩摩地方",
      "koName": "가고시마 현 사쓰마 지방",
      "esName": "Región Satsuma, Prefectura de Kagoshima",
      "ptName": "Região de Satsuma da Província de Kagoshima",
      "thName": "ท้องถิ่นซัตสึมะ จังหวัดคาโงชิมะ",
      "viName": "Vùng Satsuma, tỉnh Kagoshima",
      "inName": "Daerah Satsuma di Prefektur Kagoshima",
      "tlName": "Rehiyon ng Satsuma sa Kagoshima Prefecture",
      "moName": "Кагошима аймаг, Сацүма муж",
      "buName": "ဆဆုမဒေသ၊ ကဂိုရှိမစီရင်စု",
      "khName": "សាហ្សឹម៉ានៃខេត្ដកាកូស៊ីម៉ា",
      "neName": "खागोसिमा जिल्ला, साचुमा क्षेत्र"
    },
    "class15": {
      "code": "460015",
      "name": "指宿・川辺",
      "enName": "Ibusuki Kawanabe"
    },
    "class20": {
      "code": "4621000",
      "name": "指宿市",
      "enName": "Ibusuki City",
      "kana": "いぶすきし",
      "chName": "指宿市",
      "zhName": "指宿市",
      "koName": "이부스키 시",
      "esName": "Ciudad de Ibusuki",
      "ptName": "cidade de Ibusuki",
      "thName": "เมืองอิบุสึกิ",
      "viName": "thành phố Ibusuki",
      "inName": "kota Ibusuki",
      "tlName": "siyudad ng Ibusuki",
      "moName": "Ибүсүки хот",
      "buName": "အီဘုဇုကိ မြို့",
      "khName": "ទីក្រុង អ៊ីប៊ូស៊ូគី",
      "neName": "इबुसुकी सहर"
    }
  },
  "4621300": {
    "office": {
      "code": "460100",
      "name": "鹿児島県（奄美地方除く）",
      "enName": "Kagoshima (Excluding Amami)",
      "officeName": "鹿児島地方気象台",
      "chName": "鹿兒島縣（奄美地區除外）",
      "zhName": "鹿儿岛县（奄美地区除外）",
      "koName": "가고시마현(아마미 지방 제외)",
      "esName": "Prefectura de Kagoshima (excluyendo la región de Amami)",
      "ptName": "Prefeitura de Kagoshima (excluindo a região de Amami)",
      "thName": "จังหวัดคาโกชิมะ (ไม่รวมภูมิภาคอามามิ)",
      "viName": "Tỉnh Kagoshima (trừ vùng Amami)",
      "inName": "Prefektur Kagoshima (tidak termasuk wilayah Amami)",
      "tlName": "Kagoshima (Excluding Amami)",
      "moName": "Кагошима муж (Амами мужаас бусад)",
      "buName": "Kagoshima စီရင်စု (Amami ဒေသ မပါဝင်)",
      "khName": "ខេត្ត Kagoshima (មិនរាប់បញ្ចូលតំបន់ Amami)",
      "neName": "कागोशिमा प्रीफेक्चर (अमामी क्षेत्र बाहेक)"
    },
    "class10": {
      "code": "460030",
      "name": "種子島・屋久島地方",
      "enName": "Tanegashima Yakushima Region",
      "chName": "种子岛、屋久岛地区，鹿儿岛县（奄美地区除外）",
      "zhName": "种子岛、屋久岛地区，鹿儿岛县（奄美地区除外）",
      "koName": "타네시마・야쿠시마 지방, 가고시마현(아마미 지방 제외)",
      "esName": "Región de Tanegashima/Yakushima, Prefectura de Kagoshima (excluyendo la región de Amami)",
      "ptName": "Região de Tanegashima/Yakushima, Prefeitura de Kagoshima (excluindo a região de Amami)",
      "thName": "ภูมิภาคทาเนกาชิมะ/ยากุชิมะ จังหวัดคาโกชิมะ (ไม่รวมภูมิภาคอามามิ)",
      "viName": "Vùng Tanegashima/Yakushima tỉnh Kagoshima (trừ vùng Amami)",
      "inName": "Wilayah Tanegashima/Yakushima, Prefektur Kagoshima (tidak termasuk wilayah Amami)",
      "tlName": "Rehiyon ng Tanegashima/Yakushima, Kagoshima (Excluding Amami)",
      "moName": "Танегашима/Якушима муж, Кагошима муж (Амами мужаас бусад)",
      "buName": "Tanegashima/Yakushima ဒေသ, Kagoshima စီရင်စု (Amami ဒေသ မပါဝင်)",
      "khName": "តំបន់ Tanegashima/Yakushima ខេត្ត Kagoshima (មិនរាប់បញ្ចូលតំបន់ Amami)",
      "neName": "तानेगाशिमा/याकुशिमा क्षेत्र, कागोशिमा प्रीफेक्चर (अमामी क्षेत्र बाहेक)"
    },
    "class15": {
      "code": "460031",
      "name": "種子島地方",
      "enName": "Tanegashima Region"
    },
    "class20": {
      "code": "4621300",
      "name": "西之表市",
      "enName": "Nishinoomote City",
      "kana": "にしのおもてし",
      "chName": "西之表市",
      "zhName": "西之表市",
      "koName": "니시노오모테 시",
      "esName": "Ciudad de Nishinoomote",
      "ptName": "cidade de Nishinoomote",
      "thName": "เมืองนิชาโนะโอโมตเตะ",
      "viName": "thành phố Nishinoomote",
      "inName": "kota Nishinoomote",
      "tlName": "siyudad ng Nishinoomote",
      "moName": "Нишиноомотэ хот",
      "buName": "နီရှိနော်မိုတဲ့ မြို့",
      "khName": "ទីក្រុង នីស៊ីនអូវូម៉ូដ",
      "neName": "निशिनोमोते सहर"
    }
  },
  "4621400": {
    "office": {
      "code": "460100",
      "name": "鹿児島県（奄美地方除く）",
      "enName": "Kagoshima (Excluding Amami)",
      "officeName": "鹿児島地方気象台",
      "chName": "鹿兒島縣（奄美地區除外）",
      "zhName": "鹿儿岛县（奄美地区除外）",
      "koName": "가고시마현(아마미 지방 제외)",
      "esName": "Prefectura de Kagoshima (excluyendo la región de Amami)",
      "ptName": "Prefeitura de Kagoshima (excluindo a região de Amami)",
      "thName": "จังหวัดคาโกชิมะ (ไม่รวมภูมิภาคอามามิ)",
      "viName": "Tỉnh Kagoshima (trừ vùng Amami)",
      "inName": "Prefektur Kagoshima (tidak termasuk wilayah Amami)",
      "tlName": "Kagoshima (Excluding Amami)",
      "moName": "Кагошима муж (Амами мужаас бусад)",
      "buName": "Kagoshima စီရင်စု (Amami ဒေသ မပါဝင်)",
      "khName": "ខេត្ត Kagoshima (មិនរាប់បញ្ចូលតំបន់ Amami)",
      "neName": "कागोशिमा प्रीफेक्चर (अमामी क्षेत्र बाहेक)"
    },
    "class10": {
      "code": "460020",
      "name": "大隅地方",
      "enName": "Osumi Region",
      "chName": "鹿儿岛县大隅地方",
      "zhName": "鹿兒島縣大隅地方",
      "koName": "가고시마 현 오스미 지방",
      "esName": "Región Osumi, Prefectura de Kagoshima",
      "ptName": "Região de Ōsumi de Província de Kagoshima",
      "thName": "ท้องถิ่นโอซุมิ จังหวัดคาโงชิมะ",
      "viName": "Vùng Osumi, tỉnh Kagoshima",
      "inName": "Daerah Osumi di Prefektur Kagoshima",
      "tlName": "Rehiyon ng Osumi sa Kagoshima Prefecture",
      "moName": "Кагошима аймаг, Осүми муж",
      "buName": "အိုဆုမိဒေသ၊ ကဂိုရှိမစီရင်စု",
      "khName": "តំបន់អូសឹមីនៃខេត្ដកាកូស៊ីម៉ា",
      "neName": "खागोसिमा जिल्ला, ओसुमी क्षेत्र"
    },
    "class15": {
      "code": "460022",
      "name": "肝属",
      "enName": "Kimotsuki"
    },
    "class20": {
      "code": "4621400",
      "name": "垂水市",
      "enName": "Tarumizu City",
      "kana": "たるみずし",
      "chName": "垂水市",
      "zhName": "垂水市",
      "koName": "다루미즈 시",
      "esName": "Ciudad de Tarumizu",
      "ptName": "cidade de Tarumizu",
      "thName": "เมืองทารุมีสึ",
      "viName": "thành phố Tarumizu",
      "inName": "kota Tarumizu",
      "tlName": "siyudad ng Tarumizu",
      "moName": "Тарүмизү хот",
      "buName": "တာရုမိဇု မြို့",
      "khName": "ទីក្រុង ​ តារូមីស៊ូ",
      "neName": "तारुमिजु सहर"
    }
  },
  "4621501": {
    "office": {
      "code": "460100",
      "name": "鹿児島県（奄美地方除く）",
      "enName": "Kagoshima (Excluding Amami)",
      "officeName": "鹿児島地方気象台",
      "chName": "鹿兒島縣（奄美地區除外）",
      "zhName": "鹿儿岛县（奄美地区除外）",
      "koName": "가고시마현(아마미 지방 제외)",
      "esName": "Prefectura de Kagoshima (excluyendo la región de Amami)",
      "ptName": "Prefeitura de Kagoshima (excluindo a região de Amami)",
      "thName": "จังหวัดคาโกชิมะ (ไม่รวมภูมิภาคอามามิ)",
      "viName": "Tỉnh Kagoshima (trừ vùng Amami)",
      "inName": "Prefektur Kagoshima (tidak termasuk wilayah Amami)",
      "tlName": "Kagoshima (Excluding Amami)",
      "moName": "Кагошима муж (Амами мужаас бусад)",
      "buName": "Kagoshima စီရင်စု (Amami ဒေသ မပါဝင်)",
      "khName": "ខេត្ត Kagoshima (មិនរាប់បញ្ចូលតំបន់ Amami)",
      "neName": "कागोशिमा प्रीफेक्चर (अमामी क्षेत्र बाहेक)"
    },
    "class10": {
      "code": "460010",
      "name": "薩摩地方",
      "enName": "Satsuma Region",
      "chName": "鹿儿岛县萨摩地方",
      "zhName": "鹿兒島縣薩摩地方",
      "koName": "가고시마 현 사쓰마 지방",
      "esName": "Región Satsuma, Prefectura de Kagoshima",
      "ptName": "Região de Satsuma da Província de Kagoshima",
      "thName": "ท้องถิ่นซัตสึมะ จังหวัดคาโงชิมะ",
      "viName": "Vùng Satsuma, tỉnh Kagoshima",
      "inName": "Daerah Satsuma di Prefektur Kagoshima",
      "tlName": "Rehiyon ng Satsuma sa Kagoshima Prefecture",
      "moName": "Кагошима аймаг, Сацүма муж",
      "buName": "ဆဆုမဒေသ၊ ကဂိုရှိမစီရင်စု",
      "khName": "សាហ្សឹម៉ានៃខេត្ដកាកូស៊ីម៉ា",
      "neName": "खागोसिमा जिल्ला, साचुमा क्षेत्र"
    },
    "class15": {
      "code": "460013",
      "name": "川薩・姶良",
      "enName": "Sensatsu Aira"
    },
    "class20": {
      "code": "4621501",
      "name": "薩摩川内市",
      "enName": "Satsumasendai City",
      "kana": "さつませんだいし",
      "chName": "萨摩川内市",
      "zhName": "薩摩川內市",
      "koName": "사쓰마센다이 시",
      "esName": "Ciudad de Satsuma-Sendai",
      "ptName": "cidade de Satsumasendai",
      "thName": "เมืองซัตสึมะเซนได",
      "viName": "thành phố Satsumasendai",
      "inName": "kota Satsumasendai",
      "tlName": "siyudad ng Satsumasendai",
      "moName": "Сацүмасэндай хот",
      "buName": "ဆာဆုမားဆန်းဒိုင်ယိ မြို့",
      "khName": "ទីក្រុង សាតស៊ូម៉ាសិនដាយ",
      "neName": "सात्सुमा-सेन्दाई सहर"
    }
  },
  "4621502": {
    "office": {
      "code": "460100",
      "name": "鹿児島県（奄美地方除く）",
      "enName": "Kagoshima (Excluding Amami)",
      "officeName": "鹿児島地方気象台",
      "chName": "鹿兒島縣（奄美地區除外）",
      "zhName": "鹿儿岛县（奄美地区除外）",
      "koName": "가고시마현(아마미 지방 제외)",
      "esName": "Prefectura de Kagoshima (excluyendo la región de Amami)",
      "ptName": "Prefeitura de Kagoshima (excluindo a região de Amami)",
      "thName": "จังหวัดคาโกชิมะ (ไม่รวมภูมิภาคอามามิ)",
      "viName": "Tỉnh Kagoshima (trừ vùng Amami)",
      "inName": "Prefektur Kagoshima (tidak termasuk wilayah Amami)",
      "tlName": "Kagoshima (Excluding Amami)",
      "moName": "Кагошима муж (Амами мужаас бусад)",
      "buName": "Kagoshima စီရင်စု (Amami ဒေသ မပါဝင်)",
      "khName": "ខេត្ត Kagoshima (មិនរាប់បញ្ចូលតំបន់ Amami)",
      "neName": "कागोशिमा प्रीफेक्चर (अमामी क्षेत्र बाहेक)"
    },
    "class10": {
      "code": "460010",
      "name": "薩摩地方",
      "enName": "Satsuma Region",
      "chName": "鹿儿岛县萨摩地方",
      "zhName": "鹿兒島縣薩摩地方",
      "koName": "가고시마 현 사쓰마 지방",
      "esName": "Región Satsuma, Prefectura de Kagoshima",
      "ptName": "Região de Satsuma da Província de Kagoshima",
      "thName": "ท้องถิ่นซัตสึมะ จังหวัดคาโงชิมะ",
      "viName": "Vùng Satsuma, tỉnh Kagoshima",
      "inName": "Daerah Satsuma di Prefektur Kagoshima",
      "tlName": "Rehiyon ng Satsuma sa Kagoshima Prefecture",
      "moName": "Кагошима аймаг, Сацүма муж",
      "buName": "ဆဆုမဒေသ၊ ကဂိုရှိမစီရင်စု",
      "khName": "សាហ្សឹម៉ានៃខេត្ដកាកូស៊ីម៉ា",
      "neName": "खागोसिमा जिल्ला, साचुमा क्षेत्र"
    },
    "class15": {
      "code": "460014",
      "name": "甑島",
      "enName": "Koshikishima"
    },
    "class20": {
      "code": "4621502",
      "name": "薩摩川内市甑島",
      "enName": "Koshikishima, Satsumasendai City",
      "kana": "さつませんだいしこしきしま",
      "chName": "萨摩川内市甄岛",
      "zhName": "薩摩川內市甑島",
      "koName": "사쓰마센다이 시 고시키 지마",
      "esName": "Koshikishima, Ciudad de Satsuma-Sendai",
      "ptName": "cidade de Koshiki-Shima, cidade de Satsumasendai",
      "thName": "โคะชิกิชิมะ เมืองสัตสึมะเซ็นได",
      "viName": "Koshikishima, thành phố Satsumasendai",
      "inName": "Koshikishima, Kota Satsumasendai",
      "tlName": "Koshikishima, Lungsod ng Satsumasendai ",
      "moName": "Сацүмасэндай хот, Кошикишима",
      "buName": "ဆဆုမဆန်းဒိုင်း မြို့၊ ခိုရှိခိရှိမ",
      "khName": "កូស៊ីគិស៊ីម៉ាក់ ទីក្រុងសាតស៊ូម៉ាសិនដាយ",
      "neName": "साचुमासेन्दाइ सहर, कोसिकिसिमा"
    }
  },
  "4621600": {
    "office": {
      "code": "460100",
      "name": "鹿児島県（奄美地方除く）",
      "enName": "Kagoshima (Excluding Amami)",
      "officeName": "鹿児島地方気象台",
      "chName": "鹿兒島縣（奄美地區除外）",
      "zhName": "鹿儿岛县（奄美地区除外）",
      "koName": "가고시마현(아마미 지방 제외)",
      "esName": "Prefectura de Kagoshima (excluyendo la región de Amami)",
      "ptName": "Prefeitura de Kagoshima (excluindo a região de Amami)",
      "thName": "จังหวัดคาโกชิมะ (ไม่รวมภูมิภาคอามามิ)",
      "viName": "Tỉnh Kagoshima (trừ vùng Amami)",
      "inName": "Prefektur Kagoshima (tidak termasuk wilayah Amami)",
      "tlName": "Kagoshima (Excluding Amami)",
      "moName": "Кагошима муж (Амами мужаас бусад)",
      "buName": "Kagoshima စီရင်စု (Amami ဒေသ မပါဝင်)",
      "khName": "ខេត្ត Kagoshima (មិនរាប់បញ្ចូលតំបន់ Amami)",
      "neName": "कागोशिमा प्रीफेक्चर (अमामी क्षेत्र बाहेक)"
    },
    "class10": {
      "code": "460010",
      "name": "薩摩地方",
      "enName": "Satsuma Region",
      "chName": "鹿儿岛县萨摩地方",
      "zhName": "鹿兒島縣薩摩地方",
      "koName": "가고시마 현 사쓰마 지방",
      "esName": "Región Satsuma, Prefectura de Kagoshima",
      "ptName": "Região de Satsuma da Província de Kagoshima",
      "thName": "ท้องถิ่นซัตสึมะ จังหวัดคาโงชิมะ",
      "viName": "Vùng Satsuma, tỉnh Kagoshima",
      "inName": "Daerah Satsuma di Prefektur Kagoshima",
      "tlName": "Rehiyon ng Satsuma sa Kagoshima Prefecture",
      "moName": "Кагошима аймаг, Сацүма муж",
      "buName": "ဆဆုမဒေသ၊ ကဂိုရှိမစီရင်စု",
      "khName": "សាហ្សឹម៉ានៃខេត្ដកាកូស៊ីម៉ា",
      "neName": "खागोसिमा जिल्ला, साचुमा क्षेत्र"
    },
    "class15": {
      "code": "460011",
      "name": "鹿児島・日置",
      "enName": "Kagoshima Hioki"
    },
    "class20": {
      "code": "4621600",
      "name": "日置市",
      "enName": "Hioki City",
      "kana": "ひおきし",
      "chName": "日置市",
      "zhName": "日置市",
      "koName": "히오키 시",
      "esName": "Ciudad de Hioki",
      "ptName": "cidade de Hioki",
      "thName": "เมืองฮิโอกิ",
      "viName": "thành phố Hioki",
      "inName": "kota Hioki",
      "tlName": "siyudad ng Hioki",
      "moName": "Хиоки хот",
      "buName": "ဟီရို့ကိ မြို့",
      "khName": "ទីក្រុង ហីយ៉ូគី",
      "neName": "हियोकी सहर"
    }
  },
  "4621700": {
    "office": {
      "code": "460100",
      "name": "鹿児島県（奄美地方除く）",
      "enName": "Kagoshima (Excluding Amami)",
      "officeName": "鹿児島地方気象台",
      "chName": "鹿兒島縣（奄美地區除外）",
      "zhName": "鹿儿岛县（奄美地区除外）",
      "koName": "가고시마현(아마미 지방 제외)",
      "esName": "Prefectura de Kagoshima (excluyendo la región de Amami)",
      "ptName": "Prefeitura de Kagoshima (excluindo a região de Amami)",
      "thName": "จังหวัดคาโกชิมะ (ไม่รวมภูมิภาคอามามิ)",
      "viName": "Tỉnh Kagoshima (trừ vùng Amami)",
      "inName": "Prefektur Kagoshima (tidak termasuk wilayah Amami)",
      "tlName": "Kagoshima (Excluding Amami)",
      "moName": "Кагошима муж (Амами мужаас бусад)",
      "buName": "Kagoshima စီရင်စု (Amami ဒေသ မပါဝင်)",
      "khName": "ខេត្ត Kagoshima (មិនរាប់បញ្ចូលតំបន់ Amami)",
      "neName": "कागोशिमा प्रीफेक्चर (अमामी क्षेत्र बाहेक)"
    },
    "class10": {
      "code": "460020",
      "name": "大隅地方",
      "enName": "Osumi Region",
      "chName": "鹿儿岛县大隅地方",
      "zhName": "鹿兒島縣大隅地方",
      "koName": "가고시마 현 오스미 지방",
      "esName": "Región Osumi, Prefectura de Kagoshima",
      "ptName": "Região de Ōsumi de Província de Kagoshima",
      "thName": "ท้องถิ่นโอซุมิ จังหวัดคาโงชิมะ",
      "viName": "Vùng Osumi, tỉnh Kagoshima",
      "inName": "Daerah Osumi di Prefektur Kagoshima",
      "tlName": "Rehiyon ng Osumi sa Kagoshima Prefecture",
      "moName": "Кагошима аймаг, Осүми муж",
      "buName": "အိုဆုမိဒေသ၊ ကဂိုရှိမစီရင်စု",
      "khName": "តំបន់អូសឹមីនៃខេត្ដកាកូស៊ីម៉ា",
      "neName": "खागोसिमा जिल्ला, ओसुमी क्षेत्र"
    },
    "class15": {
      "code": "460021",
      "name": "曽於",
      "enName": "Soo"
    },
    "class20": {
      "code": "4621700",
      "name": "曽於市",
      "enName": "Soo City",
      "kana": "そおし",
      "chName": "曾于市",
      "zhName": "曾於市",
      "koName": "소오 시",
      "esName": "Ciudad de Soo",
      "ptName": "cidade de Soo",
      "thName": "เมืองโซ",
      "viName": "thành phố Soo",
      "inName": "kota Soo",
      "tlName": "siyudad ng Soo",
      "moName": "Соо хот",
      "buName": "ဆော မြို့",
      "khName": "ទីក្រុង សូ",
      "neName": "सू सहर"
    }
  },
  "4621800": {
    "office": {
      "code": "460100",
      "name": "鹿児島県（奄美地方除く）",
      "enName": "Kagoshima (Excluding Amami)",
      "officeName": "鹿児島地方気象台",
      "chName": "鹿兒島縣（奄美地區除外）",
      "zhName": "鹿儿岛县（奄美地区除外）",
      "koName": "가고시마현(아마미 지방 제외)",
      "esName": "Prefectura de Kagoshima (excluyendo la región de Amami)",
      "ptName": "Prefeitura de Kagoshima (excluindo a região de Amami)",
      "thName": "จังหวัดคาโกชิมะ (ไม่รวมภูมิภาคอามามิ)",
      "viName": "Tỉnh Kagoshima (trừ vùng Amami)",
      "inName": "Prefektur Kagoshima (tidak termasuk wilayah Amami)",
      "tlName": "Kagoshima (Excluding Amami)",
      "moName": "Кагошима муж (Амами мужаас бусад)",
      "buName": "Kagoshima စီရင်စု (Amami ဒေသ မပါဝင်)",
      "khName": "ខេត្ត Kagoshima (មិនរាប់បញ្ចូលតំបន់ Amami)",
      "neName": "कागोशिमा प्रीफेक्चर (अमामी क्षेत्र बाहेक)"
    },
    "class10": {
      "code": "460010",
      "name": "薩摩地方",
      "enName": "Satsuma Region",
      "chName": "鹿儿岛县萨摩地方",
      "zhName": "鹿兒島縣薩摩地方",
      "koName": "가고시마 현 사쓰마 지방",
      "esName": "Región Satsuma, Prefectura de Kagoshima",
      "ptName": "Região de Satsuma da Província de Kagoshima",
      "thName": "ท้องถิ่นซัตสึมะ จังหวัดคาโงชิมะ",
      "viName": "Vùng Satsuma, tỉnh Kagoshima",
      "inName": "Daerah Satsuma di Prefektur Kagoshima",
      "tlName": "Rehiyon ng Satsuma sa Kagoshima Prefecture",
      "moName": "Кагошима аймаг, Сацүма муж",
      "buName": "ဆဆုမဒေသ၊ ကဂိုရှိမစီရင်စု",
      "khName": "សាហ្សឹម៉ានៃខេត្ដកាកូស៊ីម៉ា",
      "neName": "खागोसिमा जिल्ला, साचुमा क्षेत्र"
    },
    "class15": {
      "code": "460013",
      "name": "川薩・姶良",
      "enName": "Sensatsu Aira"
    },
    "class20": {
      "code": "4621800",
      "name": "霧島市",
      "enName": "Kirishima City",
      "kana": "きりしまし",
      "chName": "雾岛市",
      "zhName": "霧島市",
      "koName": "기리시마 시",
      "esName": "Ciudad de Kirishima",
      "ptName": "cidade de Kirishima",
      "thName": "เมืองคิริชิมะ",
      "viName": "thành phố Kirishima",
      "inName": "kota Kirishima",
      "tlName": "siyudad ng Kirishima",
      "moName": "Киришимa хот",
      "buName": "ခီရိရှိမ မြို့",
      "khName": "ទីក្រុង គីរីសីម៉ា",
      "neName": "किरिशिमा सहर"
    }
  },
  "4621900": {
    "office": {
      "code": "460100",
      "name": "鹿児島県（奄美地方除く）",
      "enName": "Kagoshima (Excluding Amami)",
      "officeName": "鹿児島地方気象台",
      "chName": "鹿兒島縣（奄美地區除外）",
      "zhName": "鹿儿岛县（奄美地区除外）",
      "koName": "가고시마현(아마미 지방 제외)",
      "esName": "Prefectura de Kagoshima (excluyendo la región de Amami)",
      "ptName": "Prefeitura de Kagoshima (excluindo a região de Amami)",
      "thName": "จังหวัดคาโกชิมะ (ไม่รวมภูมิภาคอามามิ)",
      "viName": "Tỉnh Kagoshima (trừ vùng Amami)",
      "inName": "Prefektur Kagoshima (tidak termasuk wilayah Amami)",
      "tlName": "Kagoshima (Excluding Amami)",
      "moName": "Кагошима муж (Амами мужаас бусад)",
      "buName": "Kagoshima စီရင်စု (Amami ဒေသ မပါဝင်)",
      "khName": "ខេត្ត Kagoshima (មិនរាប់បញ្ចូលតំបន់ Amami)",
      "neName": "कागोशिमा प्रीफेक्चर (अमामी क्षेत्र बाहेक)"
    },
    "class10": {
      "code": "460010",
      "name": "薩摩地方",
      "enName": "Satsuma Region",
      "chName": "鹿儿岛县萨摩地方",
      "zhName": "鹿兒島縣薩摩地方",
      "koName": "가고시마 현 사쓰마 지방",
      "esName": "Región Satsuma, Prefectura de Kagoshima",
      "ptName": "Região de Satsuma da Província de Kagoshima",
      "thName": "ท้องถิ่นซัตสึมะ จังหวัดคาโงชิมะ",
      "viName": "Vùng Satsuma, tỉnh Kagoshima",
      "inName": "Daerah Satsuma di Prefektur Kagoshima",
      "tlName": "Rehiyon ng Satsuma sa Kagoshima Prefecture",
      "moName": "Кагошима аймаг, Сацүма муж",
      "buName": "ဆဆုမဒေသ၊ ကဂိုရှိမစီရင်စု",
      "khName": "សាហ្សឹម៉ានៃខេត្ដកាកូស៊ីម៉ា",
      "neName": "खागोसिमा जिल्ला, साचुमा क्षेत्र"
    },
    "class15": {
      "code": "460011",
      "name": "鹿児島・日置",
      "enName": "Kagoshima Hioki"
    },
    "class20": {
      "code": "4621900",
      "name": "いちき串木野市",
      "enName": "Ichikikushikino City",
      "kana": "いちきくしきのし",
      "chName": "市来串木野市",
      "zhName": "市來串木野市",
      "koName": "이치키쿠시키노 시",
      "esName": "Ciudad de Ichiki-Kushikino",
      "ptName": "cidade de Ichikikushikino",
      "thName": "เมืองอิจิคิคุชิคิโนะ",
      "viName": "thành phố Ichikikushikino",
      "inName": "kota Ichikikushikino",
      "tlName": "siyudad ng Ichikikushikino",
      "moName": "Ичикикүшикино хот",
      "buName": "အီကျိခိခုရှိကိနော့ မြို့",
      "khName": "ទីក្រុង អ៊ីឈីកគុស៊ីគីណូ",
      "neName": "इचिकिकुशिकिनो सहर"
    }
  },
  "4622000": {
    "office": {
      "code": "460100",
      "name": "鹿児島県（奄美地方除く）",
      "enName": "Kagoshima (Excluding Amami)",
      "officeName": "鹿児島地方気象台",
      "chName": "鹿兒島縣（奄美地區除外）",
      "zhName": "鹿儿岛县（奄美地区除外）",
      "koName": "가고시마현(아마미 지방 제외)",
      "esName": "Prefectura de Kagoshima (excluyendo la región de Amami)",
      "ptName": "Prefeitura de Kagoshima (excluindo a região de Amami)",
      "thName": "จังหวัดคาโกชิมะ (ไม่รวมภูมิภาคอามามิ)",
      "viName": "Tỉnh Kagoshima (trừ vùng Amami)",
      "inName": "Prefektur Kagoshima (tidak termasuk wilayah Amami)",
      "tlName": "Kagoshima (Excluding Amami)",
      "moName": "Кагошима муж (Амами мужаас бусад)",
      "buName": "Kagoshima စီရင်စု (Amami ဒေသ မပါဝင်)",
      "khName": "ខេត្ត Kagoshima (មិនរាប់បញ្ចូលតំបន់ Amami)",
      "neName": "कागोशिमा प्रीफेक्चर (अमामी क्षेत्र बाहेक)"
    },
    "class10": {
      "code": "460010",
      "name": "薩摩地方",
      "enName": "Satsuma Region",
      "chName": "鹿儿岛县萨摩地方",
      "zhName": "鹿兒島縣薩摩地方",
      "koName": "가고시마 현 사쓰마 지방",
      "esName": "Región Satsuma, Prefectura de Kagoshima",
      "ptName": "Região de Satsuma da Província de Kagoshima",
      "thName": "ท้องถิ่นซัตสึมะ จังหวัดคาโงชิมะ",
      "viName": "Vùng Satsuma, tỉnh Kagoshima",
      "inName": "Daerah Satsuma di Prefektur Kagoshima",
      "tlName": "Rehiyon ng Satsuma sa Kagoshima Prefecture",
      "moName": "Кагошима аймаг, Сацүма муж",
      "buName": "ဆဆုမဒေသ၊ ကဂိုရှိမစီရင်စု",
      "khName": "សាហ្សឹម៉ានៃខេត្ដកាកូស៊ីម៉ា",
      "neName": "खागोसिमा जिल्ला, साचुमा क्षेत्र"
    },
    "class15": {
      "code": "460015",
      "name": "指宿・川辺",
      "enName": "Ibusuki Kawanabe"
    },
    "class20": {
      "code": "4622000",
      "name": "南さつま市",
      "enName": "Minamisatsuma City",
      "kana": "みなみさつまし",
      "chName": "南萨摩市",
      "zhName": "南薩摩市",
      "koName": "미나미사쓰마 시",
      "esName": "Ciudad de Minamisatsuma",
      "ptName": "cidade de Minamisatsuma",
      "thName": "เมืองมินามิซัตสึมะ",
      "viName": "thành phố Minamisatsuma",
      "inName": "kota Minamisatsuma",
      "tlName": "siyudad ng Minamisatsuma",
      "moName": "Минaмисaцүмa хот",
      "buName": "မီနာမိဆာ့ဆုမ မြို့",
      "khName": "ទីក្រុង មីណាមីសាតស៊ូម៉ា",
      "neName": "मिनामिसात्सुमा सहर"
    }
  },
  "4622100": {
    "office": {
      "code": "460100",
      "name": "鹿児島県（奄美地方除く）",
      "enName": "Kagoshima (Excluding Amami)",
      "officeName": "鹿児島地方気象台",
      "chName": "鹿兒島縣（奄美地區除外）",
      "zhName": "鹿儿岛县（奄美地区除外）",
      "koName": "가고시마현(아마미 지방 제외)",
      "esName": "Prefectura de Kagoshima (excluyendo la región de Amami)",
      "ptName": "Prefeitura de Kagoshima (excluindo a região de Amami)",
      "thName": "จังหวัดคาโกชิมะ (ไม่รวมภูมิภาคอามามิ)",
      "viName": "Tỉnh Kagoshima (trừ vùng Amami)",
      "inName": "Prefektur Kagoshima (tidak termasuk wilayah Amami)",
      "tlName": "Kagoshima (Excluding Amami)",
      "moName": "Кагошима муж (Амами мужаас бусад)",
      "buName": "Kagoshima စီရင်စု (Amami ဒေသ မပါဝင်)",
      "khName": "ខេត្ត Kagoshima (មិនរាប់បញ្ចូលតំបន់ Amami)",
      "neName": "कागोशिमा प्रीफेक्चर (अमामी क्षेत्र बाहेक)"
    },
    "class10": {
      "code": "460020",
      "name": "大隅地方",
      "enName": "Osumi Region",
      "chName": "鹿儿岛县大隅地方",
      "zhName": "鹿兒島縣大隅地方",
      "koName": "가고시마 현 오스미 지방",
      "esName": "Región Osumi, Prefectura de Kagoshima",
      "ptName": "Região de Ōsumi de Província de Kagoshima",
      "thName": "ท้องถิ่นโอซุมิ จังหวัดคาโงชิมะ",
      "viName": "Vùng Osumi, tỉnh Kagoshima",
      "inName": "Daerah Osumi di Prefektur Kagoshima",
      "tlName": "Rehiyon ng Osumi sa Kagoshima Prefecture",
      "moName": "Кагошима аймаг, Осүми муж",
      "buName": "အိုဆုမိဒေသ၊ ကဂိုရှိမစီရင်စု",
      "khName": "តំបន់អូសឹមីនៃខេត្ដកាកូស៊ីម៉ា",
      "neName": "खागोसिमा जिल्ला, ओसुमी क्षेत्र"
    },
    "class15": {
      "code": "460021",
      "name": "曽於",
      "enName": "Soo"
    },
    "class20": {
      "code": "4622100",
      "name": "志布志市",
      "enName": "Shibushi City",
      "kana": "しぶしし",
      "chName": "志布志市",
      "zhName": "志布志市",
      "koName": "시부시 시",
      "esName": "Ciudad de Shibushi",
      "ptName": "cidade de Shibushi",
      "thName": "เมืองชิบุชิ",
      "viName": "thành phố Shibushi",
      "inName": "kota Shibushi",
      "tlName": "siyudad ng Shibushi",
      "moName": "Шибүши хот",
      "buName": "ရှီဘုရှိ မြို့",
      "khName": "ទីក្រុង ស៊ីប៊ូស៊ី",
      "neName": "शिबुशी सहर"
    }
  },
  "4622200": {
    "office": {
      "code": "460040",
      "name": "奄美地方",
      "enName": "Amami",
      "officeName": "名瀬測候所",
      "chName": "奄美地區",
      "zhName": "奄美地区",
      "koName": "아마미 지방",
      "esName": "Región de Amami",
      "ptName": "Região de Amami",
      "thName": "ภูมิภาคอามามิ",
      "viName": "Tỉnh Amami",
      "inName": "Prefektur Amami",
      "tlName": "Amami Prefecture",
      "moName": "Амами муж",
      "buName": "Amami ဒေသ",
      "khName": "តំបន់អាម៉ាមី",
      "neName": "अमामी क्षेत्र"
    },
    "class10": {
      "code": "460040",
      "name": "奄美地方",
      "enName": "Amami Region",
      "chName": "奄美地區, 奄美地區",
      "zhName": "奄美地区, 奄美地区",
      "koName": "아마미 지방, 아마미 지방",
      "esName": "región amami, Región de Amami",
      "ptName": "Região de Amami, Região de Amami",
      "thName": "ภูมิภาคอามามิ, ภูมิภาคอามามิ",
      "viName": "Vùng Amami tỉnh Amami",
      "inName": "wilayah Amami, Prefektur Amami",
      "tlName": "Rehiyon ng Amami, Amami Prefecture",
      "moName": "Амами муж, Амами муж",
      "buName": "Amami ဒေသ, Amami ဒေသ",
      "khName": "តំបន់អាម៉ាមី, តំបន់អាម៉ាមី",
      "neName": "अमामी क्षेत्र, अमामी क्षेत्र"
    },
    "class15": {
      "code": "460041",
      "name": "北部",
      "enName": "Northern Region"
    },
    "class20": {
      "code": "4622200",
      "name": "奄美市",
      "enName": "Amami City",
      "kana": "あまみし",
      "chName": "奄美市",
      "zhName": "奄美市",
      "koName": "아마미 시",
      "esName": "Ciudad de Amami",
      "ptName": "cidade de Amami",
      "thName": "เมืองอามามิ",
      "viName": "thành phố Amami",
      "inName": "kota Amami",
      "tlName": "siyudad ng Amami",
      "moName": "Aмaми хот",
      "buName": "အာမားမိ မြို့",
      "khName": "ទីក្រុង អាម៉ាមី",
      "neName": "आमामी सहर"
    }
  },
  "4622300": {
    "office": {
      "code": "460100",
      "name": "鹿児島県（奄美地方除く）",
      "enName": "Kagoshima (Excluding Amami)",
      "officeName": "鹿児島地方気象台",
      "chName": "鹿兒島縣（奄美地區除外）",
      "zhName": "鹿儿岛县（奄美地区除外）",
      "koName": "가고시마현(아마미 지방 제외)",
      "esName": "Prefectura de Kagoshima (excluyendo la región de Amami)",
      "ptName": "Prefeitura de Kagoshima (excluindo a região de Amami)",
      "thName": "จังหวัดคาโกชิมะ (ไม่รวมภูมิภาคอามามิ)",
      "viName": "Tỉnh Kagoshima (trừ vùng Amami)",
      "inName": "Prefektur Kagoshima (tidak termasuk wilayah Amami)",
      "tlName": "Kagoshima (Excluding Amami)",
      "moName": "Кагошима муж (Амами мужаас бусад)",
      "buName": "Kagoshima စီရင်စု (Amami ဒေသ မပါဝင်)",
      "khName": "ខេត្ត Kagoshima (មិនរាប់បញ្ចូលតំបន់ Amami)",
      "neName": "कागोशिमा प्रीफेक्चर (अमामी क्षेत्र बाहेक)"
    },
    "class10": {
      "code": "460010",
      "name": "薩摩地方",
      "enName": "Satsuma Region",
      "chName": "鹿儿岛县萨摩地方",
      "zhName": "鹿兒島縣薩摩地方",
      "koName": "가고시마 현 사쓰마 지방",
      "esName": "Región Satsuma, Prefectura de Kagoshima",
      "ptName": "Região de Satsuma da Província de Kagoshima",
      "thName": "ท้องถิ่นซัตสึมะ จังหวัดคาโงชิมะ",
      "viName": "Vùng Satsuma, tỉnh Kagoshima",
      "inName": "Daerah Satsuma di Prefektur Kagoshima",
      "tlName": "Rehiyon ng Satsuma sa Kagoshima Prefecture",
      "moName": "Кагошима аймаг, Сацүма муж",
      "buName": "ဆဆုမဒေသ၊ ကဂိုရှိမစီရင်စု",
      "khName": "សាហ្សឹម៉ានៃខេត្ដកាកូស៊ីម៉ា",
      "neName": "खागोसिमा जिल्ला, साचुमा क्षेत्र"
    },
    "class15": {
      "code": "460015",
      "name": "指宿・川辺",
      "enName": "Ibusuki Kawanabe"
    },
    "class20": {
      "code": "4622300",
      "name": "南九州市",
      "enName": "Minamikyushu City",
      "kana": "みなみきゅうしゅうし",
      "chName": "南九州市",
      "zhName": "南九州市",
      "koName": "미나미큐슈 시",
      "esName": "Ciudad de Minami-Kyūshū",
      "ptName": "cidade de Minamikyushu",
      "thName": "เมืองมินามิคิวชู",
      "viName": "thành phố Minamikyushu",
      "inName": "kota Minamikyushu",
      "tlName": "siyudad ng Minamikyushu",
      "moName": "Минaмикюшү хот",
      "buName": "မီနားမိကျု့ရှု မြို့",
      "khName": "ទីក្រុង មីណាមិគ្យុស៊ូ",
      "neName": "मिनामिक्युश्यु सहर"
    }
  },
  "4622400": {
    "office": {
      "code": "460100",
      "name": "鹿児島県（奄美地方除く）",
      "enName": "Kagoshima (Excluding Amami)",
      "officeName": "鹿児島地方気象台",
      "chName": "鹿兒島縣（奄美地區除外）",
      "zhName": "鹿儿岛县（奄美地区除外）",
      "koName": "가고시마현(아마미 지방 제외)",
      "esName": "Prefectura de Kagoshima (excluyendo la región de Amami)",
      "ptName": "Prefeitura de Kagoshima (excluindo a região de Amami)",
      "thName": "จังหวัดคาโกชิมะ (ไม่รวมภูมิภาคอามามิ)",
      "viName": "Tỉnh Kagoshima (trừ vùng Amami)",
      "inName": "Prefektur Kagoshima (tidak termasuk wilayah Amami)",
      "tlName": "Kagoshima (Excluding Amami)",
      "moName": "Кагошима муж (Амами мужаас бусад)",
      "buName": "Kagoshima စီရင်စု (Amami ဒေသ မပါဝင်)",
      "khName": "ខេត្ត Kagoshima (មិនរាប់បញ្ចូលតំបន់ Amami)",
      "neName": "कागोशिमा प्रीफेक्चर (अमामी क्षेत्र बाहेक)"
    },
    "class10": {
      "code": "460010",
      "name": "薩摩地方",
      "enName": "Satsuma Region",
      "chName": "鹿儿岛县萨摩地方",
      "zhName": "鹿兒島縣薩摩地方",
      "koName": "가고시마 현 사쓰마 지방",
      "esName": "Región Satsuma, Prefectura de Kagoshima",
      "ptName": "Região de Satsuma da Província de Kagoshima",
      "thName": "ท้องถิ่นซัตสึมะ จังหวัดคาโงชิมะ",
      "viName": "Vùng Satsuma, tỉnh Kagoshima",
      "inName": "Daerah Satsuma di Prefektur Kagoshima",
      "tlName": "Rehiyon ng Satsuma sa Kagoshima Prefecture",
      "moName": "Кагошима аймаг, Сацүма муж",
      "buName": "ဆဆုမဒေသ၊ ကဂိုရှိမစီရင်စု",
      "khName": "សាហ្សឹម៉ានៃខេត្ដកាកូស៊ីម៉ា",
      "neName": "खागोसिमा जिल्ला, साचुमा क्षेत्र"
    },
    "class15": {
      "code": "460012",
      "name": "出水・伊佐",
      "enName": "Izumi Isa"
    },
    "class20": {
      "code": "4622400",
      "name": "伊佐市",
      "enName": "Isa City",
      "kana": "いさし",
      "chName": "伊佐市",
      "zhName": "伊佐市",
      "koName": "이사 시",
      "esName": "Ciudad de Isa",
      "ptName": "cidade de Isa",
      "thName": "เมืองอิสะ",
      "viName": "thành phố Isa",
      "inName": "kota Isa",
      "tlName": "siyudad ng Isa",
      "moName": "Исa хот",
      "buName": "အိုင်းဆာ့ မြို့",
      "khName": "ទីក្រុង អ៊ីសា",
      "neName": "इसा सहर"
    }
  },
  "4622500": {
    "office": {
      "code": "460100",
      "name": "鹿児島県（奄美地方除く）",
      "enName": "Kagoshima (Excluding Amami)",
      "officeName": "鹿児島地方気象台",
      "chName": "鹿兒島縣（奄美地區除外）",
      "zhName": "鹿儿岛县（奄美地区除外）",
      "koName": "가고시마현(아마미 지방 제외)",
      "esName": "Prefectura de Kagoshima (excluyendo la región de Amami)",
      "ptName": "Prefeitura de Kagoshima (excluindo a região de Amami)",
      "thName": "จังหวัดคาโกชิมะ (ไม่รวมภูมิภาคอามามิ)",
      "viName": "Tỉnh Kagoshima (trừ vùng Amami)",
      "inName": "Prefektur Kagoshima (tidak termasuk wilayah Amami)",
      "tlName": "Kagoshima (Excluding Amami)",
      "moName": "Кагошима муж (Амами мужаас бусад)",
      "buName": "Kagoshima စီရင်စု (Amami ဒေသ မပါဝင်)",
      "khName": "ខេត្ត Kagoshima (មិនរាប់បញ្ចូលតំបន់ Amami)",
      "neName": "कागोशिमा प्रीफेक्चर (अमामी क्षेत्र बाहेक)"
    },
    "class10": {
      "code": "460010",
      "name": "薩摩地方",
      "enName": "Satsuma Region",
      "chName": "鹿儿岛县萨摩地方",
      "zhName": "鹿兒島縣薩摩地方",
      "koName": "가고시마 현 사쓰마 지방",
      "esName": "Región Satsuma, Prefectura de Kagoshima",
      "ptName": "Região de Satsuma da Província de Kagoshima",
      "thName": "ท้องถิ่นซัตสึมะ จังหวัดคาโงชิมะ",
      "viName": "Vùng Satsuma, tỉnh Kagoshima",
      "inName": "Daerah Satsuma di Prefektur Kagoshima",
      "tlName": "Rehiyon ng Satsuma sa Kagoshima Prefecture",
      "moName": "Кагошима аймаг, Сацүма муж",
      "buName": "ဆဆုမဒေသ၊ ကဂိုရှိမစီရင်စု",
      "khName": "សាហ្សឹម៉ានៃខេត្ដកាកូស៊ីម៉ា",
      "neName": "खागोसिमा जिल्ला, साचुमा क्षेत्र"
    },
    "class15": {
      "code": "460013",
      "name": "川薩・姶良",
      "enName": "Sensatsu Aira"
    },
    "class20": {
      "code": "4622500",
      "name": "姶良市",
      "enName": "Aira City",
      "kana": "あいらし",
      "chName": "姶良市",
      "zhName": "姶良市",
      "koName": "아이라 시",
      "esName": "Ciudad de Aira",
      "ptName": "cidade de Aira",
      "thName": "เมืองไอระ",
      "viName": "thành phố Aira",
      "inName": "kota Aira",
      "tlName": "siyudad ng Aira",
      "moName": "Aйра хот",
      "buName": "အာရိဒ မြို့",
      "khName": "ទីក្រុង អៃរ៉ា",
      "neName": "आइरा सहर"
    }
  },
  "4630300": {
    "office": {
      "code": "460100",
      "name": "鹿児島県（奄美地方除く）",
      "enName": "Kagoshima (Excluding Amami)",
      "officeName": "鹿児島地方気象台",
      "chName": "鹿兒島縣（奄美地區除外）",
      "zhName": "鹿儿岛县（奄美地区除外）",
      "koName": "가고시마현(아마미 지방 제외)",
      "esName": "Prefectura de Kagoshima (excluyendo la región de Amami)",
      "ptName": "Prefeitura de Kagoshima (excluindo a região de Amami)",
      "thName": "จังหวัดคาโกชิมะ (ไม่รวมภูมิภาคอามามิ)",
      "viName": "Tỉnh Kagoshima (trừ vùng Amami)",
      "inName": "Prefektur Kagoshima (tidak termasuk wilayah Amami)",
      "tlName": "Kagoshima (Excluding Amami)",
      "moName": "Кагошима муж (Амами мужаас бусад)",
      "buName": "Kagoshima စီရင်စု (Amami ဒေသ မပါဝင်)",
      "khName": "ខេត្ត Kagoshima (មិនរាប់បញ្ចូលតំបន់ Amami)",
      "neName": "कागोशिमा प्रीफेक्चर (अमामी क्षेत्र बाहेक)"
    },
    "class10": {
      "code": "460030",
      "name": "種子島・屋久島地方",
      "enName": "Tanegashima Yakushima Region",
      "chName": "种子岛、屋久岛地区，鹿儿岛县（奄美地区除外）",
      "zhName": "种子岛、屋久岛地区，鹿儿岛县（奄美地区除外）",
      "koName": "타네시마・야쿠시마 지방, 가고시마현(아마미 지방 제외)",
      "esName": "Región de Tanegashima/Yakushima, Prefectura de Kagoshima (excluyendo la región de Amami)",
      "ptName": "Região de Tanegashima/Yakushima, Prefeitura de Kagoshima (excluindo a região de Amami)",
      "thName": "ภูมิภาคทาเนกาชิมะ/ยากุชิมะ จังหวัดคาโกชิมะ (ไม่รวมภูมิภาคอามามิ)",
      "viName": "Vùng Tanegashima/Yakushima tỉnh Kagoshima (trừ vùng Amami)",
      "inName": "Wilayah Tanegashima/Yakushima, Prefektur Kagoshima (tidak termasuk wilayah Amami)",
      "tlName": "Rehiyon ng Tanegashima/Yakushima, Kagoshima (Excluding Amami)",
      "moName": "Танегашима/Якушима муж, Кагошима муж (Амами мужаас бусад)",
      "buName": "Tanegashima/Yakushima ဒေသ, Kagoshima စီရင်စု (Amami ဒေသ မပါဝင်)",
      "khName": "តំបន់ Tanegashima/Yakushima ខេត្ត Kagoshima (មិនរាប់បញ្ចូលតំបន់ Amami)",
      "neName": "तानेगाशिमा/याकुशिमा क्षेत्र, कागोशिमा प्रीफेक्चर (अमामी क्षेत्र बाहेक)"
    },
    "class15": {
      "code": "460031",
      "name": "種子島地方",
      "enName": "Tanegashima Region"
    },
    "class20": {
      "code": "4630300",
      "name": "三島村",
      "enName": "Mishima Village",
      "kana": "みしまむら",
      "chName": "三岛村",
      "zhName": "三島村",
      "koName": "미시마 촌",
      "esName": "Alde a de Mishima",
      "ptName": "povoado de Mishima",
      "thName": "หมู่บ้านมิชิมะ",
      "viName": "làng Mishima",
      "inName": "desa Mishima",
      "tlName": "nayon ng Mishima",
      "moName": "Мишимa тосгон",
      "buName": "မီရှိမ ကျေးရွာ",
      "khName": "ភូមិ មីស៊ីម៉ា",
      "neName": "मिशिमा गाउँ"
    }
  },
  "4630400": {
    "office": {
      "code": "460040",
      "name": "奄美地方",
      "enName": "Amami",
      "officeName": "名瀬測候所",
      "chName": "奄美地區",
      "zhName": "奄美地区",
      "koName": "아마미 지방",
      "esName": "Región de Amami",
      "ptName": "Região de Amami",
      "thName": "ภูมิภาคอามามิ",
      "viName": "Tỉnh Amami",
      "inName": "Prefektur Amami",
      "tlName": "Amami Prefecture",
      "moName": "Амами муж",
      "buName": "Amami ဒေသ",
      "khName": "តំបន់អាម៉ាមី",
      "neName": "अमामी क्षेत्र"
    },
    "class10": {
      "code": "460040",
      "name": "奄美地方",
      "enName": "Amami Region",
      "chName": "奄美地區, 奄美地區",
      "zhName": "奄美地区, 奄美地区",
      "koName": "아마미 지방, 아마미 지방",
      "esName": "región amami, Región de Amami",
      "ptName": "Região de Amami, Região de Amami",
      "thName": "ภูมิภาคอามามิ, ภูมิภาคอามามิ",
      "viName": "Vùng Amami tỉnh Amami",
      "inName": "wilayah Amami, Prefektur Amami",
      "tlName": "Rehiyon ng Amami, Amami Prefecture",
      "moName": "Амами муж, Амами муж",
      "buName": "Amami ဒေသ, Amami ဒေသ",
      "khName": "តំបន់អាម៉ាមី, តំបន់អាម៉ាមី",
      "neName": "अमामी क्षेत्र, अमामी क्षेत्र"
    },
    "class15": {
      "code": "460043",
      "name": "十島村",
      "enName": "Toshima Village"
    },
    "class20": {
      "code": "4630400",
      "name": "十島村",
      "enName": "Toshima Village",
      "kana": "としまむら",
      "chName": "鹿儿岛十岛村",
      "zhName": "鹿兒島十島村",
      "koName": "가고시마 도시마 촌",
      "esName": "Aldea de Toshima, Kagoshima",
      "ptName": "Kagoshima, povoado de Toshima",
      "thName": "หมู่บ้านโทชิมะ คาโกชิมะ",
      "viName": "Làng Toshima, Kagoshima",
      "inName": "Desa Toshima, Kagoshima",
      "tlName": "nayon ng Toshima, Kagoshima",
      "moName": "Кагошима Тошима тосгон",
      "buName": "ကဂိုရှိမတိုရှိမရွာ",
      "khName": "ភូមិតូស៊ីម៉ា កាកូស៊ីម៉ា",
      "neName": "खागोसिमा तोशिमा गाउँ"
    }
  },
  "4639200": {
    "office": {
      "code": "460100",
      "name": "鹿児島県（奄美地方除く）",
      "enName": "Kagoshima (Excluding Amami)",
      "officeName": "鹿児島地方気象台",
      "chName": "鹿兒島縣（奄美地區除外）",
      "zhName": "鹿儿岛县（奄美地区除外）",
      "koName": "가고시마현(아마미 지방 제외)",
      "esName": "Prefectura de Kagoshima (excluyendo la región de Amami)",
      "ptName": "Prefeitura de Kagoshima (excluindo a região de Amami)",
      "thName": "จังหวัดคาโกชิมะ (ไม่รวมภูมิภาคอามามิ)",
      "viName": "Tỉnh Kagoshima (trừ vùng Amami)",
      "inName": "Prefektur Kagoshima (tidak termasuk wilayah Amami)",
      "tlName": "Kagoshima (Excluding Amami)",
      "moName": "Кагошима муж (Амами мужаас бусад)",
      "buName": "Kagoshima စီရင်စု (Amami ဒေသ မပါဝင်)",
      "khName": "ខេត្ត Kagoshima (មិនរាប់បញ្ចូលតំបន់ Amami)",
      "neName": "कागोशिमा प्रीफेक्चर (अमामी क्षेत्र बाहेक)"
    },
    "class10": {
      "code": "460010",
      "name": "薩摩地方",
      "enName": "Satsuma Region",
      "chName": "鹿儿岛县萨摩地方",
      "zhName": "鹿兒島縣薩摩地方",
      "koName": "가고시마 현 사쓰마 지방",
      "esName": "Región Satsuma, Prefectura de Kagoshima",
      "ptName": "Região de Satsuma da Província de Kagoshima",
      "thName": "ท้องถิ่นซัตสึมะ จังหวัดคาโงชิมะ",
      "viName": "Vùng Satsuma, tỉnh Kagoshima",
      "inName": "Daerah Satsuma di Prefektur Kagoshima",
      "tlName": "Rehiyon ng Satsuma sa Kagoshima Prefecture",
      "moName": "Кагошима аймаг, Сацүма муж",
      "buName": "ဆဆုမဒေသ၊ ကဂိုရှိမစီရင်စု",
      "khName": "សាហ្សឹម៉ានៃខេត្ដកាកូស៊ីម៉ា",
      "neName": "खागोसिमा जिल्ला, साचुमा क्षेत्र"
    },
    "class15": {
      "code": "460013",
      "name": "川薩・姶良",
      "enName": "Sensatsu Aira"
    },
    "class20": {
      "code": "4639200",
      "name": "さつま町",
      "enName": "Satsuma Town",
      "kana": "さつまちょう",
      "chName": "萨摩町",
      "zhName": "薩摩町",
      "koName": "사쓰마 정",
      "esName": "Pueblo de Satsuma",
      "ptName": "bairro de Satsuma",
      "thName": "เมืองซัตสึมะ",
      "viName": "thị trấn Satsuma",
      "inName": "kota Satsuma",
      "tlName": "bayan ng Satsuma",
      "moName": "Сaцүмa жижиг хот",
      "buName": "ဆာဆုမ မြို့နယ်",
      "khName": "ទីប្រជុំជន សាតស៊ូម៉ា",
      "neName": "सात्सुमा नगर"
    }
  },
  "4640400": {
    "office": {
      "code": "460100",
      "name": "鹿児島県（奄美地方除く）",
      "enName": "Kagoshima (Excluding Amami)",
      "officeName": "鹿児島地方気象台",
      "chName": "鹿兒島縣（奄美地區除外）",
      "zhName": "鹿儿岛县（奄美地区除外）",
      "koName": "가고시마현(아마미 지방 제외)",
      "esName": "Prefectura de Kagoshima (excluyendo la región de Amami)",
      "ptName": "Prefeitura de Kagoshima (excluindo a região de Amami)",
      "thName": "จังหวัดคาโกชิมะ (ไม่รวมภูมิภาคอามามิ)",
      "viName": "Tỉnh Kagoshima (trừ vùng Amami)",
      "inName": "Prefektur Kagoshima (tidak termasuk wilayah Amami)",
      "tlName": "Kagoshima (Excluding Amami)",
      "moName": "Кагошима муж (Амами мужаас бусад)",
      "buName": "Kagoshima စီရင်စု (Amami ဒေသ မပါဝင်)",
      "khName": "ខេត្ត Kagoshima (មិនរាប់បញ្ចូលតំបន់ Amami)",
      "neName": "कागोशिमा प्रीफेक्चर (अमामी क्षेत्र बाहेक)"
    },
    "class10": {
      "code": "460010",
      "name": "薩摩地方",
      "enName": "Satsuma Region",
      "chName": "鹿儿岛县萨摩地方",
      "zhName": "鹿兒島縣薩摩地方",
      "koName": "가고시마 현 사쓰마 지방",
      "esName": "Región Satsuma, Prefectura de Kagoshima",
      "ptName": "Região de Satsuma da Província de Kagoshima",
      "thName": "ท้องถิ่นซัตสึมะ จังหวัดคาโงชิมะ",
      "viName": "Vùng Satsuma, tỉnh Kagoshima",
      "inName": "Daerah Satsuma di Prefektur Kagoshima",
      "tlName": "Rehiyon ng Satsuma sa Kagoshima Prefecture",
      "moName": "Кагошима аймаг, Сацүма муж",
      "buName": "ဆဆုမဒေသ၊ ကဂိုရှိမစီရင်စု",
      "khName": "សាហ្សឹម៉ានៃខេត្ដកាកូស៊ីម៉ា",
      "neName": "खागोसिमा जिल्ला, साचुमा क्षेत्र"
    },
    "class15": {
      "code": "460012",
      "name": "出水・伊佐",
      "enName": "Izumi Isa"
    },
    "class20": {
      "code": "4640400",
      "name": "長島町",
      "enName": "Nagashima Town",
      "kana": "ながしまちょう",
      "chName": "长岛町",
      "zhName": "長島町",
      "koName": "나가시마 정",
      "esName": "Pueblo de Nagashima",
      "ptName": "bairro de Nagashima",
      "thName": "เมืองนางาชิมะ",
      "viName": "thị trấn Nagashima",
      "inName": "kota Nagashima",
      "tlName": "bayan ng Nagashima",
      "moName": "Нaгaшимa жижиг хот",
      "buName": "နာဂါရှိမ မြို့နယ်",
      "khName": "ទីប្រជុំជន ណាហ្គាស៊ីម៉ា",
      "neName": "नागाशिमा नगर"
    }
  },
  "4645200": {
    "office": {
      "code": "460100",
      "name": "鹿児島県（奄美地方除く）",
      "enName": "Kagoshima (Excluding Amami)",
      "officeName": "鹿児島地方気象台",
      "chName": "鹿兒島縣（奄美地區除外）",
      "zhName": "鹿儿岛县（奄美地区除外）",
      "koName": "가고시마현(아마미 지방 제외)",
      "esName": "Prefectura de Kagoshima (excluyendo la región de Amami)",
      "ptName": "Prefeitura de Kagoshima (excluindo a região de Amami)",
      "thName": "จังหวัดคาโกชิมะ (ไม่รวมภูมิภาคอามามิ)",
      "viName": "Tỉnh Kagoshima (trừ vùng Amami)",
      "inName": "Prefektur Kagoshima (tidak termasuk wilayah Amami)",
      "tlName": "Kagoshima (Excluding Amami)",
      "moName": "Кагошима муж (Амами мужаас бусад)",
      "buName": "Kagoshima စီရင်စု (Amami ဒေသ မပါဝင်)",
      "khName": "ខេត្ត Kagoshima (មិនរាប់បញ្ចូលតំបន់ Amami)",
      "neName": "कागोशिमा प्रीफेक्चर (अमामी क्षेत्र बाहेक)"
    },
    "class10": {
      "code": "460010",
      "name": "薩摩地方",
      "enName": "Satsuma Region",
      "chName": "鹿儿岛县萨摩地方",
      "zhName": "鹿兒島縣薩摩地方",
      "koName": "가고시마 현 사쓰마 지방",
      "esName": "Región Satsuma, Prefectura de Kagoshima",
      "ptName": "Região de Satsuma da Província de Kagoshima",
      "thName": "ท้องถิ่นซัตสึมะ จังหวัดคาโงชิมะ",
      "viName": "Vùng Satsuma, tỉnh Kagoshima",
      "inName": "Daerah Satsuma di Prefektur Kagoshima",
      "tlName": "Rehiyon ng Satsuma sa Kagoshima Prefecture",
      "moName": "Кагошима аймаг, Сацүма муж",
      "buName": "ဆဆုမဒေသ၊ ကဂိုရှိမစီရင်စု",
      "khName": "សាហ្សឹម៉ានៃខេត្ដកាកូស៊ីម៉ា",
      "neName": "खागोसिमा जिल्ला, साचुमा क्षेत्र"
    },
    "class15": {
      "code": "460013",
      "name": "川薩・姶良",
      "enName": "Sensatsu Aira"
    },
    "class20": {
      "code": "4645200",
      "name": "湧水町",
      "enName": "Yusui Town",
      "kana": "ゆうすいちょう",
      "chName": "涌水町",
      "zhName": "湧水町",
      "koName": "유스이 정",
      "esName": "Pueblo de Yusui",
      "ptName": "bairro de Yusui",
      "thName": "เมืองยูซุอิ",
      "viName": "thị trấn Yusui",
      "inName": "kota Yusui",
      "tlName": "bayan ng Yusui",
      "moName": "Юсүй жижиг хот",
      "buName": "ယူးဆုယိ မြို့နယ်",
      "khName": "ទីប្រជុំជន យូស៊ូ",
      "neName": "युसुई नगर"
    }
  },
  "4646800": {
    "office": {
      "code": "460100",
      "name": "鹿児島県（奄美地方除く）",
      "enName": "Kagoshima (Excluding Amami)",
      "officeName": "鹿児島地方気象台",
      "chName": "鹿兒島縣（奄美地區除外）",
      "zhName": "鹿儿岛县（奄美地区除外）",
      "koName": "가고시마현(아마미 지방 제외)",
      "esName": "Prefectura de Kagoshima (excluyendo la región de Amami)",
      "ptName": "Prefeitura de Kagoshima (excluindo a região de Amami)",
      "thName": "จังหวัดคาโกชิมะ (ไม่รวมภูมิภาคอามามิ)",
      "viName": "Tỉnh Kagoshima (trừ vùng Amami)",
      "inName": "Prefektur Kagoshima (tidak termasuk wilayah Amami)",
      "tlName": "Kagoshima (Excluding Amami)",
      "moName": "Кагошима муж (Амами мужаас бусад)",
      "buName": "Kagoshima စီရင်စု (Amami ဒေသ မပါဝင်)",
      "khName": "ខេត្ត Kagoshima (មិនរាប់បញ្ចូលតំបន់ Amami)",
      "neName": "कागोशिमा प्रीफेक्चर (अमामी क्षेत्र बाहेक)"
    },
    "class10": {
      "code": "460020",
      "name": "大隅地方",
      "enName": "Osumi Region",
      "chName": "鹿儿岛县大隅地方",
      "zhName": "鹿兒島縣大隅地方",
      "koName": "가고시마 현 오스미 지방",
      "esName": "Región Osumi, Prefectura de Kagoshima",
      "ptName": "Região de Ōsumi de Província de Kagoshima",
      "thName": "ท้องถิ่นโอซุมิ จังหวัดคาโงชิมะ",
      "viName": "Vùng Osumi, tỉnh Kagoshima",
      "inName": "Daerah Osumi di Prefektur Kagoshima",
      "tlName": "Rehiyon ng Osumi sa Kagoshima Prefecture",
      "moName": "Кагошима аймаг, Осүми муж",
      "buName": "အိုဆုမိဒေသ၊ ကဂိုရှိမစီရင်စု",
      "khName": "តំបន់អូសឹមីនៃខេត្ដកាកូស៊ីម៉ា",
      "neName": "खागोसिमा जिल्ला, ओसुमी क्षेत्र"
    },
    "class15": {
      "code": "460021",
      "name": "曽於",
      "enName": "Soo"
    },
    "class20": {
      "code": "4646800",
      "name": "大崎町",
      "enName": "Osaki Town",
      "kana": "おおさきちょう",
      "chName": "大崎町",
      "zhName": "大崎町",
      "koName": "오사키 정",
      "esName": "Pueblo de Osaki",
      "ptName": "bairro de Osaki",
      "thName": "เมืองโอซากิ",
      "viName": "thị trấn Osaki",
      "inName": "kota Osaki",
      "tlName": "bayan ng Osaki",
      "moName": "Осaки жижиг хот",
      "buName": "အိုးဆာ့ကိ မြို့နယ်",
      "khName": "ទីប្រជុំជន អូសាគី",
      "neName": "ओसाकी नगर"
    }
  },
  "4648200": {
    "office": {
      "code": "460100",
      "name": "鹿児島県（奄美地方除く）",
      "enName": "Kagoshima (Excluding Amami)",
      "officeName": "鹿児島地方気象台",
      "chName": "鹿兒島縣（奄美地區除外）",
      "zhName": "鹿儿岛县（奄美地区除外）",
      "koName": "가고시마현(아마미 지방 제외)",
      "esName": "Prefectura de Kagoshima (excluyendo la región de Amami)",
      "ptName": "Prefeitura de Kagoshima (excluindo a região de Amami)",
      "thName": "จังหวัดคาโกชิมะ (ไม่รวมภูมิภาคอามามิ)",
      "viName": "Tỉnh Kagoshima (trừ vùng Amami)",
      "inName": "Prefektur Kagoshima (tidak termasuk wilayah Amami)",
      "tlName": "Kagoshima (Excluding Amami)",
      "moName": "Кагошима муж (Амами мужаас бусад)",
      "buName": "Kagoshima စီရင်စု (Amami ဒေသ မပါဝင်)",
      "khName": "ខេត្ត Kagoshima (មិនរាប់បញ្ចូលតំបន់ Amami)",
      "neName": "कागोशिमा प्रीफेक्चर (अमामी क्षेत्र बाहेक)"
    },
    "class10": {
      "code": "460020",
      "name": "大隅地方",
      "enName": "Osumi Region",
      "chName": "鹿儿岛县大隅地方",
      "zhName": "鹿兒島縣大隅地方",
      "koName": "가고시마 현 오스미 지방",
      "esName": "Región Osumi, Prefectura de Kagoshima",
      "ptName": "Região de Ōsumi de Província de Kagoshima",
      "thName": "ท้องถิ่นโอซุมิ จังหวัดคาโงชิมะ",
      "viName": "Vùng Osumi, tỉnh Kagoshima",
      "inName": "Daerah Osumi di Prefektur Kagoshima",
      "tlName": "Rehiyon ng Osumi sa Kagoshima Prefecture",
      "moName": "Кагошима аймаг, Осүми муж",
      "buName": "အိုဆုမိဒေသ၊ ကဂိုရှိမစီရင်စု",
      "khName": "តំបន់អូសឹមីនៃខេត្ដកាកូស៊ីម៉ា",
      "neName": "खागोसिमा जिल्ला, ओसुमी क्षेत्र"
    },
    "class15": {
      "code": "460022",
      "name": "肝属",
      "enName": "Kimotsuki"
    },
    "class20": {
      "code": "4648200",
      "name": "東串良町",
      "enName": "Higashikushira Town",
      "kana": "ひがしくしらちょう",
      "chName": "东串良町",
      "zhName": "東串良町",
      "koName": "히가시쿠시라 정",
      "esName": "Pueblo de Higashikushira",
      "ptName": "bairro de Higashikushira",
      "thName": "เมืองฮางาชิคุชิระ",
      "viName": "thị trấn Higashikushira",
      "inName": "kota Higashikushira",
      "tlName": "bayan ng Higashikushira",
      "moName": "Хигaшикүшира жижиг хот",
      "buName": "ဟီဂါရှိကုရှိရာ့ မြို့နယ်",
      "khName": "ទីប្រជុំជន ហ៊ីហ្កាស៊ីឃូស៊ីរ៉ា",
      "neName": "हिगाशिकुशिरा नगर"
    }
  },
  "4649000": {
    "office": {
      "code": "460100",
      "name": "鹿児島県（奄美地方除く）",
      "enName": "Kagoshima (Excluding Amami)",
      "officeName": "鹿児島地方気象台",
      "chName": "鹿兒島縣（奄美地區除外）",
      "zhName": "鹿儿岛县（奄美地区除外）",
      "koName": "가고시마현(아마미 지방 제외)",
      "esName": "Prefectura de Kagoshima (excluyendo la región de Amami)",
      "ptName": "Prefeitura de Kagoshima (excluindo a região de Amami)",
      "thName": "จังหวัดคาโกชิมะ (ไม่รวมภูมิภาคอามามิ)",
      "viName": "Tỉnh Kagoshima (trừ vùng Amami)",
      "inName": "Prefektur Kagoshima (tidak termasuk wilayah Amami)",
      "tlName": "Kagoshima (Excluding Amami)",
      "moName": "Кагошима муж (Амами мужаас бусад)",
      "buName": "Kagoshima စီရင်စု (Amami ဒေသ မပါဝင်)",
      "khName": "ខេត្ត Kagoshima (មិនរាប់បញ្ចូលតំបន់ Amami)",
      "neName": "कागोशिमा प्रीफेक्चर (अमामी क्षेत्र बाहेक)"
    },
    "class10": {
      "code": "460020",
      "name": "大隅地方",
      "enName": "Osumi Region",
      "chName": "鹿儿岛县大隅地方",
      "zhName": "鹿兒島縣大隅地方",
      "koName": "가고시마 현 오스미 지방",
      "esName": "Región Osumi, Prefectura de Kagoshima",
      "ptName": "Região de Ōsumi de Província de Kagoshima",
      "thName": "ท้องถิ่นโอซุมิ จังหวัดคาโงชิมะ",
      "viName": "Vùng Osumi, tỉnh Kagoshima",
      "inName": "Daerah Osumi di Prefektur Kagoshima",
      "tlName": "Rehiyon ng Osumi sa Kagoshima Prefecture",
      "moName": "Кагошима аймаг, Осүми муж",
      "buName": "အိုဆုမိဒေသ၊ ကဂိုရှိမစီရင်စု",
      "khName": "តំបន់អូសឹមីនៃខេត្ដកាកូស៊ីម៉ា",
      "neName": "खागोसिमा जिल्ला, ओसुमी क्षेत्र"
    },
    "class15": {
      "code": "460022",
      "name": "肝属",
      "enName": "Kimotsuki"
    },
    "class20": {
      "code": "4649000",
      "name": "錦江町",
      "enName": "Kinko Town",
      "kana": "きんこうちょう",
      "chName": "锦江町",
      "zhName": "錦江町",
      "koName": "긴코 정",
      "esName": "Pueblo de Kinkou",
      "ptName": "bairro de Kinko",
      "thName": "เมืองคินโคะ",
      "viName": "thị trấn Kinko",
      "inName": "kota Kinko",
      "tlName": "bayan ng Kinko",
      "moName": "Кинко жижиг хот",
      "buName": "ကင်ကို မြို့နယ်",
      "khName": "ទីប្រជុំជន ឃីនកូ",
      "neName": "किन्को नगर"
    }
  },
  "4649100": {
    "office": {
      "code": "460100",
      "name": "鹿児島県（奄美地方除く）",
      "enName": "Kagoshima (Excluding Amami)",
      "officeName": "鹿児島地方気象台",
      "chName": "鹿兒島縣（奄美地區除外）",
      "zhName": "鹿儿岛县（奄美地区除外）",
      "koName": "가고시마현(아마미 지방 제외)",
      "esName": "Prefectura de Kagoshima (excluyendo la región de Amami)",
      "ptName": "Prefeitura de Kagoshima (excluindo a região de Amami)",
      "thName": "จังหวัดคาโกชิมะ (ไม่รวมภูมิภาคอามามิ)",
      "viName": "Tỉnh Kagoshima (trừ vùng Amami)",
      "inName": "Prefektur Kagoshima (tidak termasuk wilayah Amami)",
      "tlName": "Kagoshima (Excluding Amami)",
      "moName": "Кагошима муж (Амами мужаас бусад)",
      "buName": "Kagoshima စီရင်စု (Amami ဒေသ မပါဝင်)",
      "khName": "ខេត្ត Kagoshima (មិនរាប់បញ្ចូលតំបន់ Amami)",
      "neName": "कागोशिमा प्रीफेक्चर (अमामी क्षेत्र बाहेक)"
    },
    "class10": {
      "code": "460020",
      "name": "大隅地方",
      "enName": "Osumi Region",
      "chName": "鹿儿岛县大隅地方",
      "zhName": "鹿兒島縣大隅地方",
      "koName": "가고시마 현 오스미 지방",
      "esName": "Región Osumi, Prefectura de Kagoshima",
      "ptName": "Região de Ōsumi de Província de Kagoshima",
      "thName": "ท้องถิ่นโอซุมิ จังหวัดคาโงชิมะ",
      "viName": "Vùng Osumi, tỉnh Kagoshima",
      "inName": "Daerah Osumi di Prefektur Kagoshima",
      "tlName": "Rehiyon ng Osumi sa Kagoshima Prefecture",
      "moName": "Кагошима аймаг, Осүми муж",
      "buName": "အိုဆုမိဒေသ၊ ကဂိုရှိမစီရင်စု",
      "khName": "តំបន់អូសឹមីនៃខេត្ដកាកូស៊ីម៉ា",
      "neName": "खागोसिमा जिल्ला, ओसुमी क्षेत्र"
    },
    "class15": {
      "code": "460022",
      "name": "肝属",
      "enName": "Kimotsuki"
    },
    "class20": {
      "code": "4649100",
      "name": "南大隅町",
      "enName": "Minamiosumi Town",
      "kana": "みなみおおすみちょう",
      "chName": "南大隅町",
      "zhName": "南大隅町",
      "koName": "미나미오스미 정",
      "esName": "Pueblo de Minamiosumi",
      "ptName": "bairro de Minamiosumi",
      "thName": "เมืองมินามิโอสึมิ",
      "viName": "thị trấn Minamiosumi",
      "inName": "kota Minamiosumi",
      "tlName": "bayan ng Minamiosumi",
      "moName": "Минaмиосүми жижиг хот",
      "buName": "မီနားမိယောဆုမိ မြို့နယ်",
      "khName": "ទីប្រជុំជន មីណាមីអូស៊ូមិ",
      "neName": "मिनामिओसुमी नगर"
    }
  },
  "4649200": {
    "office": {
      "code": "460100",
      "name": "鹿児島県（奄美地方除く）",
      "enName": "Kagoshima (Excluding Amami)",
      "officeName": "鹿児島地方気象台",
      "chName": "鹿兒島縣（奄美地區除外）",
      "zhName": "鹿儿岛县（奄美地区除外）",
      "koName": "가고시마현(아마미 지방 제외)",
      "esName": "Prefectura de Kagoshima (excluyendo la región de Amami)",
      "ptName": "Prefeitura de Kagoshima (excluindo a região de Amami)",
      "thName": "จังหวัดคาโกชิมะ (ไม่รวมภูมิภาคอามามิ)",
      "viName": "Tỉnh Kagoshima (trừ vùng Amami)",
      "inName": "Prefektur Kagoshima (tidak termasuk wilayah Amami)",
      "tlName": "Kagoshima (Excluding Amami)",
      "moName": "Кагошима муж (Амами мужаас бусад)",
      "buName": "Kagoshima စီရင်စု (Amami ဒေသ မပါဝင်)",
      "khName": "ខេត្ត Kagoshima (មិនរាប់បញ្ចូលតំបន់ Amami)",
      "neName": "कागोशिमा प्रीफेक्चर (अमामी क्षेत्र बाहेक)"
    },
    "class10": {
      "code": "460020",
      "name": "大隅地方",
      "enName": "Osumi Region",
      "chName": "鹿儿岛县大隅地方",
      "zhName": "鹿兒島縣大隅地方",
      "koName": "가고시마 현 오스미 지방",
      "esName": "Región Osumi, Prefectura de Kagoshima",
      "ptName": "Região de Ōsumi de Província de Kagoshima",
      "thName": "ท้องถิ่นโอซุมิ จังหวัดคาโงชิมะ",
      "viName": "Vùng Osumi, tỉnh Kagoshima",
      "inName": "Daerah Osumi di Prefektur Kagoshima",
      "tlName": "Rehiyon ng Osumi sa Kagoshima Prefecture",
      "moName": "Кагошима аймаг, Осүми муж",
      "buName": "အိုဆုမိဒေသ၊ ကဂိုရှိမစီရင်စု",
      "khName": "តំបន់អូសឹមីនៃខេត្ដកាកូស៊ីម៉ា",
      "neName": "खागोसिमा जिल्ला, ओसुमी क्षेत्र"
    },
    "class15": {
      "code": "460022",
      "name": "肝属",
      "enName": "Kimotsuki"
    },
    "class20": {
      "code": "4649200",
      "name": "肝付町",
      "enName": "Kimotsuki Town",
      "kana": "きもつきちょう",
      "chName": "肝付町",
      "zhName": "肝付町",
      "koName": "기모쓰키 정",
      "esName": "Pueblo de Kimotsuki",
      "ptName": "bairro de Kimotsuki",
      "thName": "เมืองคิโมตสึกิ",
      "viName": "thị trấn Kimotsuki",
      "inName": "kota Kimotsuki",
      "tlName": "bayan ng Kimotsuki",
      "moName": "Кимоцүки жижиг хот",
      "buName": "ခီမောဆုကိ မြို့နယ်",
      "khName": "ទីប្រជុំជន គីម៉ូសូគី",
      "neName": "किमोत्सुकी नगर"
    }
  },
  "4650100": {
    "office": {
      "code": "460100",
      "name": "鹿児島県（奄美地方除く）",
      "enName": "Kagoshima (Excluding Amami)",
      "officeName": "鹿児島地方気象台",
      "chName": "鹿兒島縣（奄美地區除外）",
      "zhName": "鹿儿岛县（奄美地区除外）",
      "koName": "가고시마현(아마미 지방 제외)",
      "esName": "Prefectura de Kagoshima (excluyendo la región de Amami)",
      "ptName": "Prefeitura de Kagoshima (excluindo a região de Amami)",
      "thName": "จังหวัดคาโกชิมะ (ไม่รวมภูมิภาคอามามิ)",
      "viName": "Tỉnh Kagoshima (trừ vùng Amami)",
      "inName": "Prefektur Kagoshima (tidak termasuk wilayah Amami)",
      "tlName": "Kagoshima (Excluding Amami)",
      "moName": "Кагошима муж (Амами мужаас бусад)",
      "buName": "Kagoshima စီရင်စု (Amami ဒေသ မပါဝင်)",
      "khName": "ខេត្ត Kagoshima (មិនរាប់បញ្ចូលតំបន់ Amami)",
      "neName": "कागोशिमा प्रीफेक्चर (अमामी क्षेत्र बाहेक)"
    },
    "class10": {
      "code": "460030",
      "name": "種子島・屋久島地方",
      "enName": "Tanegashima Yakushima Region",
      "chName": "种子岛、屋久岛地区，鹿儿岛县（奄美地区除外）",
      "zhName": "种子岛、屋久岛地区，鹿儿岛县（奄美地区除外）",
      "koName": "타네시마・야쿠시마 지방, 가고시마현(아마미 지방 제외)",
      "esName": "Región de Tanegashima/Yakushima, Prefectura de Kagoshima (excluyendo la región de Amami)",
      "ptName": "Região de Tanegashima/Yakushima, Prefeitura de Kagoshima (excluindo a região de Amami)",
      "thName": "ภูมิภาคทาเนกาชิมะ/ยากุชิมะ จังหวัดคาโกชิมะ (ไม่รวมภูมิภาคอามามิ)",
      "viName": "Vùng Tanegashima/Yakushima tỉnh Kagoshima (trừ vùng Amami)",
      "inName": "Wilayah Tanegashima/Yakushima, Prefektur Kagoshima (tidak termasuk wilayah Amami)",
      "tlName": "Rehiyon ng Tanegashima/Yakushima, Kagoshima (Excluding Amami)",
      "moName": "Танегашима/Якушима муж, Кагошима муж (Амами мужаас бусад)",
      "buName": "Tanegashima/Yakushima ဒေသ, Kagoshima စီရင်စု (Amami ဒေသ မပါဝင်)",
      "khName": "តំបន់ Tanegashima/Yakushima ខេត្ត Kagoshima (មិនរាប់បញ្ចូលតំបន់ Amami)",
      "neName": "तानेगाशिमा/याकुशिमा क्षेत्र, कागोशिमा प्रीफेक्चर (अमामी क्षेत्र बाहेक)"
    },
    "class15": {
      "code": "460031",
      "name": "種子島地方",
      "enName": "Tanegashima Region"
    },
    "class20": {
      "code": "4650100",
      "name": "中種子町",
      "enName": "Nakatane Town",
      "kana": "なかたねちょう",
      "chName": "中种子町",
      "zhName": "中種子町",
      "koName": "나카타네 정",
      "esName": "Pueblo de Nakatane",
      "ptName": "bairro de Nakatane",
      "thName": "เมืองนากาทาเนะ",
      "viName": "thị trấn Nakatane",
      "inName": "kota Nakatane",
      "tlName": "bayan ng Nakatane",
      "moName": "Нaкатанэ жижиг хот",
      "buName": "နာဂါတာ့နဲ့ မြို့နယ်",
      "khName": "ទីប្រជុំជន ណាកាថាណេ",
      "neName": "नाकाताने नगर"
    }
  },
  "4650200": {
    "office": {
      "code": "460100",
      "name": "鹿児島県（奄美地方除く）",
      "enName": "Kagoshima (Excluding Amami)",
      "officeName": "鹿児島地方気象台",
      "chName": "鹿兒島縣（奄美地區除外）",
      "zhName": "鹿儿岛县（奄美地区除外）",
      "koName": "가고시마현(아마미 지방 제외)",
      "esName": "Prefectura de Kagoshima (excluyendo la región de Amami)",
      "ptName": "Prefeitura de Kagoshima (excluindo a região de Amami)",
      "thName": "จังหวัดคาโกชิมะ (ไม่รวมภูมิภาคอามามิ)",
      "viName": "Tỉnh Kagoshima (trừ vùng Amami)",
      "inName": "Prefektur Kagoshima (tidak termasuk wilayah Amami)",
      "tlName": "Kagoshima (Excluding Amami)",
      "moName": "Кагошима муж (Амами мужаас бусад)",
      "buName": "Kagoshima စီရင်စု (Amami ဒေသ မပါဝင်)",
      "khName": "ខេត្ត Kagoshima (មិនរាប់បញ្ចូលតំបន់ Amami)",
      "neName": "कागोशिमा प्रीफेक्चर (अमामी क्षेत्र बाहेक)"
    },
    "class10": {
      "code": "460030",
      "name": "種子島・屋久島地方",
      "enName": "Tanegashima Yakushima Region",
      "chName": "种子岛、屋久岛地区，鹿儿岛县（奄美地区除外）",
      "zhName": "种子岛、屋久岛地区，鹿儿岛县（奄美地区除外）",
      "koName": "타네시마・야쿠시마 지방, 가고시마현(아마미 지방 제외)",
      "esName": "Región de Tanegashima/Yakushima, Prefectura de Kagoshima (excluyendo la región de Amami)",
      "ptName": "Região de Tanegashima/Yakushima, Prefeitura de Kagoshima (excluindo a região de Amami)",
      "thName": "ภูมิภาคทาเนกาชิมะ/ยากุชิมะ จังหวัดคาโกชิมะ (ไม่รวมภูมิภาคอามามิ)",
      "viName": "Vùng Tanegashima/Yakushima tỉnh Kagoshima (trừ vùng Amami)",
      "inName": "Wilayah Tanegashima/Yakushima, Prefektur Kagoshima (tidak termasuk wilayah Amami)",
      "tlName": "Rehiyon ng Tanegashima/Yakushima, Kagoshima (Excluding Amami)",
      "moName": "Танегашима/Якушима муж, Кагошима муж (Амами мужаас бусад)",
      "buName": "Tanegashima/Yakushima ဒေသ, Kagoshima စီရင်စု (Amami ဒေသ မပါဝင်)",
      "khName": "តំបន់ Tanegashima/Yakushima ខេត្ត Kagoshima (មិនរាប់បញ្ចូលតំបន់ Amami)",
      "neName": "तानेगाशिमा/याकुशिमा क्षेत्र, कागोशिमा प्रीफेक्चर (अमामी क्षेत्र बाहेक)"
    },
    "class15": {
      "code": "460031",
      "name": "種子島地方",
      "enName": "Tanegashima Region"
    },
    "class20": {
      "code": "4650200",
      "name": "南種子町",
      "enName": "Minamitane Town",
      "kana": "みなみたねちょう",
      "chName": "南种子町",
      "zhName": "南種子町",
      "koName": "미나미타네 정",
      "esName": "Pueblo de Minamitane",
      "ptName": "bairro de Minamitane",
      "thName": "เมืองมานามิทาเนะ",
      "viName": "thị trấn Minamitane",
      "inName": "kota Minamitane",
      "tlName": "bayan ng Minamitane",
      "moName": "Минамитанэ жижиг хот",
      "buName": "မီနားမိတာ့နဲ့ မြို့နယ်",
      "khName": "ទីប្រជុំជន មីណាមីថាណេ",
      "neName": "मिनामिताने नगर"
    }
  },
  "4650500": {
    "office": {
      "code": "460100",
      "name": "鹿児島県（奄美地方除く）",
      "enName": "Kagoshima (Excluding Amami)",
      "officeName": "鹿児島地方気象台",
      "chName": "鹿兒島縣（奄美地區除外）",
      "zhName": "鹿儿岛县（奄美地区除外）",
      "koName": "가고시마현(아마미 지방 제외)",
      "esName": "Prefectura de Kagoshima (excluyendo la región de Amami)",
      "ptName": "Prefeitura de Kagoshima (excluindo a região de Amami)",
      "thName": "จังหวัดคาโกชิมะ (ไม่รวมภูมิภาคอามามิ)",
      "viName": "Tỉnh Kagoshima (trừ vùng Amami)",
      "inName": "Prefektur Kagoshima (tidak termasuk wilayah Amami)",
      "tlName": "Kagoshima (Excluding Amami)",
      "moName": "Кагошима муж (Амами мужаас бусад)",
      "buName": "Kagoshima စီရင်စု (Amami ဒေသ မပါဝင်)",
      "khName": "ខេត្ត Kagoshima (មិនរាប់បញ្ចូលតំបន់ Amami)",
      "neName": "कागोशिमा प्रीफेक्चर (अमामी क्षेत्र बाहेक)"
    },
    "class10": {
      "code": "460030",
      "name": "種子島・屋久島地方",
      "enName": "Tanegashima Yakushima Region",
      "chName": "种子岛、屋久岛地区，鹿儿岛县（奄美地区除外）",
      "zhName": "种子岛、屋久岛地区，鹿儿岛县（奄美地区除外）",
      "koName": "타네시마・야쿠시마 지방, 가고시마현(아마미 지방 제외)",
      "esName": "Región de Tanegashima/Yakushima, Prefectura de Kagoshima (excluyendo la región de Amami)",
      "ptName": "Região de Tanegashima/Yakushima, Prefeitura de Kagoshima (excluindo a região de Amami)",
      "thName": "ภูมิภาคทาเนกาชิมะ/ยากุชิมะ จังหวัดคาโกชิมะ (ไม่รวมภูมิภาคอามามิ)",
      "viName": "Vùng Tanegashima/Yakushima tỉnh Kagoshima (trừ vùng Amami)",
      "inName": "Wilayah Tanegashima/Yakushima, Prefektur Kagoshima (tidak termasuk wilayah Amami)",
      "tlName": "Rehiyon ng Tanegashima/Yakushima, Kagoshima (Excluding Amami)",
      "moName": "Танегашима/Якушима муж, Кагошима муж (Амами мужаас бусад)",
      "buName": "Tanegashima/Yakushima ဒေသ, Kagoshima စီရင်စု (Amami ဒေသ မပါဝင်)",
      "khName": "តំបន់ Tanegashima/Yakushima ខេត្ត Kagoshima (មិនរាប់បញ្ចូលតំបន់ Amami)",
      "neName": "तानेगाशिमा/याकुशिमा क्षेत्र, कागोशिमा प्रीफेक्चर (अमामी क्षेत्र बाहेक)"
    },
    "class15": {
      "code": "460032",
      "name": "屋久島地方",
      "enName": "Yakushima Region"
    },
    "class20": {
      "code": "4650500",
      "name": "屋久島町",
      "enName": "Yakushima Town",
      "kana": "やくしまちょう",
      "chName": "屋久岛町",
      "zhName": "屋久島町",
      "koName": "야쿠시마 정",
      "esName": "Pueblo de Yakushima",
      "ptName": "bairro de Yakushima",
      "thName": "เมืองยาคุชิมะ",
      "viName": "thị trấn Yakushima",
      "inName": "kota Yakushima",
      "tlName": "bayan ng Yakushima",
      "moName": "Якүшимa жижиг хот",
      "buName": "ယာကုရှိမ မြို့နယ်",
      "khName": "ទីប្រជុំជន យ៉ាគុស៊ីម៉ា",
      "neName": "याकुशिमा नगर"
    }
  },
  "4652300": {
    "office": {
      "code": "460040",
      "name": "奄美地方",
      "enName": "Amami",
      "officeName": "名瀬測候所",
      "chName": "奄美地區",
      "zhName": "奄美地区",
      "koName": "아마미 지방",
      "esName": "Región de Amami",
      "ptName": "Região de Amami",
      "thName": "ภูมิภาคอามามิ",
      "viName": "Tỉnh Amami",
      "inName": "Prefektur Amami",
      "tlName": "Amami Prefecture",
      "moName": "Амами муж",
      "buName": "Amami ဒေသ",
      "khName": "តំបន់អាម៉ាមី",
      "neName": "अमामी क्षेत्र"
    },
    "class10": {
      "code": "460040",
      "name": "奄美地方",
      "enName": "Amami Region",
      "chName": "奄美地區, 奄美地區",
      "zhName": "奄美地区, 奄美地区",
      "koName": "아마미 지방, 아마미 지방",
      "esName": "región amami, Región de Amami",
      "ptName": "Região de Amami, Região de Amami",
      "thName": "ภูมิภาคอามามิ, ภูมิภาคอามามิ",
      "viName": "Vùng Amami tỉnh Amami",
      "inName": "wilayah Amami, Prefektur Amami",
      "tlName": "Rehiyon ng Amami, Amami Prefecture",
      "moName": "Амами муж, Амами муж",
      "buName": "Amami ဒေသ, Amami ဒေသ",
      "khName": "តំបន់អាម៉ាមី, តំបន់អាម៉ាមី",
      "neName": "अमामी क्षेत्र, अमामी क्षेत्र"
    },
    "class15": {
      "code": "460041",
      "name": "北部",
      "enName": "Northern Region"
    },
    "class20": {
      "code": "4652300",
      "name": "大和村",
      "enName": "Yamato Village",
      "kana": "やまとそん",
      "chName": "大和村",
      "zhName": "大和村",
      "koName": "야마토 촌",
      "esName": "Aldea de Yamato",
      "ptName": "povoado de Yamato",
      "thName": "หมู่บ้านยามาโตะ",
      "viName": "làng Yamato",
      "inName": "desa Yamato",
      "tlName": "nayon ng Yamato",
      "moName": "Ямaто тосгон",
      "buName": "ယာမာတို ကျေးရွာ",
      "khName": "ភូមិ យ៉ាម៉ាតូ",
      "neName": "यामातो गाउँ"
    }
  },
  "4652400": {
    "office": {
      "code": "460040",
      "name": "奄美地方",
      "enName": "Amami",
      "officeName": "名瀬測候所",
      "chName": "奄美地區",
      "zhName": "奄美地区",
      "koName": "아마미 지방",
      "esName": "Región de Amami",
      "ptName": "Região de Amami",
      "thName": "ภูมิภาคอามามิ",
      "viName": "Tỉnh Amami",
      "inName": "Prefektur Amami",
      "tlName": "Amami Prefecture",
      "moName": "Амами муж",
      "buName": "Amami ဒေသ",
      "khName": "តំបន់អាម៉ាមី",
      "neName": "अमामी क्षेत्र"
    },
    "class10": {
      "code": "460040",
      "name": "奄美地方",
      "enName": "Amami Region",
      "chName": "奄美地區, 奄美地區",
      "zhName": "奄美地区, 奄美地区",
      "koName": "아마미 지방, 아마미 지방",
      "esName": "región amami, Región de Amami",
      "ptName": "Região de Amami, Região de Amami",
      "thName": "ภูมิภาคอามามิ, ภูมิภาคอามามิ",
      "viName": "Vùng Amami tỉnh Amami",
      "inName": "wilayah Amami, Prefektur Amami",
      "tlName": "Rehiyon ng Amami, Amami Prefecture",
      "moName": "Амами муж, Амами муж",
      "buName": "Amami ဒေသ, Amami ဒေသ",
      "khName": "តំបន់អាម៉ាមី, តំបន់អាម៉ាមី",
      "neName": "अमामी क्षेत्र, अमामी क्षेत्र"
    },
    "class15": {
      "code": "460041",
      "name": "北部",
      "enName": "Northern Region"
    },
    "class20": {
      "code": "4652400",
      "name": "宇検村",
      "enName": "Uken Village",
      "kana": "うけんそん",
      "chName": "宇检村",
      "zhName": "宇檢村",
      "koName": "우켄 촌",
      "esName": "Aldea de Uken",
      "ptName": "povoado de Uken",
      "thName": "หมู่บ้านอุเคน",
      "viName": "làng Uken",
      "inName": "desa Uken",
      "tlName": "nayon ng Uken",
      "moName": "Үкэн тосгон",
      "buName": "ဥကန် ကျေးရွာ",
      "khName": "ភូមិ អ៊ូខេន",
      "neName": "उकेन गाउँ"
    }
  },
  "4652500": {
    "office": {
      "code": "460040",
      "name": "奄美地方",
      "enName": "Amami",
      "officeName": "名瀬測候所",
      "chName": "奄美地區",
      "zhName": "奄美地区",
      "koName": "아마미 지방",
      "esName": "Región de Amami",
      "ptName": "Região de Amami",
      "thName": "ภูมิภาคอามามิ",
      "viName": "Tỉnh Amami",
      "inName": "Prefektur Amami",
      "tlName": "Amami Prefecture",
      "moName": "Амами муж",
      "buName": "Amami ဒေသ",
      "khName": "តំបន់អាម៉ាមី",
      "neName": "अमामी क्षेत्र"
    },
    "class10": {
      "code": "460040",
      "name": "奄美地方",
      "enName": "Amami Region",
      "chName": "奄美地區, 奄美地區",
      "zhName": "奄美地区, 奄美地区",
      "koName": "아마미 지방, 아마미 지방",
      "esName": "región amami, Región de Amami",
      "ptName": "Região de Amami, Região de Amami",
      "thName": "ภูมิภาคอามามิ, ภูมิภาคอามามิ",
      "viName": "Vùng Amami tỉnh Amami",
      "inName": "wilayah Amami, Prefektur Amami",
      "tlName": "Rehiyon ng Amami, Amami Prefecture",
      "moName": "Амами муж, Амами муж",
      "buName": "Amami ဒေသ, Amami ဒေသ",
      "khName": "តំបន់អាម៉ាមី, តំបន់អាម៉ាមី",
      "neName": "अमामी क्षेत्र, अमामी क्षेत्र"
    },
    "class15": {
      "code": "460041",
      "name": "北部",
      "enName": "Northern Region"
    },
    "class20": {
      "code": "4652500",
      "name": "瀬戸内町",
      "enName": "Setouchi Town",
      "kana": "せとうちちょう",
      "chName": "濑户内町",
      "zhName": "瀨戶內町",
      "koName": "세토우치 정",
      "esName": "Pueblo de Setouchi",
      "ptName": "bairro de Setouchi",
      "thName": "เมืองเซโตอุจิ",
      "viName": "thị trấn Setouchi",
      "inName": "kota Setouchi",
      "tlName": "bayan ng Setouchi",
      "moName": "Сэтоүчи жижиг хот",
      "buName": "ဆဲတောဥကျိ မြို့နယ်",
      "khName": "ទីប្រជុំជន សេទូជី",
      "neName": "सेतोउची नगर"
    }
  },
  "4652700": {
    "office": {
      "code": "460040",
      "name": "奄美地方",
      "enName": "Amami",
      "officeName": "名瀬測候所",
      "chName": "奄美地區",
      "zhName": "奄美地区",
      "koName": "아마미 지방",
      "esName": "Región de Amami",
      "ptName": "Região de Amami",
      "thName": "ภูมิภาคอามามิ",
      "viName": "Tỉnh Amami",
      "inName": "Prefektur Amami",
      "tlName": "Amami Prefecture",
      "moName": "Амами муж",
      "buName": "Amami ဒေသ",
      "khName": "តំបន់អាម៉ាមី",
      "neName": "अमामी क्षेत्र"
    },
    "class10": {
      "code": "460040",
      "name": "奄美地方",
      "enName": "Amami Region",
      "chName": "奄美地區, 奄美地區",
      "zhName": "奄美地区, 奄美地区",
      "koName": "아마미 지방, 아마미 지방",
      "esName": "región amami, Región de Amami",
      "ptName": "Região de Amami, Região de Amami",
      "thName": "ภูมิภาคอามามิ, ภูมิภาคอามามิ",
      "viName": "Vùng Amami tỉnh Amami",
      "inName": "wilayah Amami, Prefektur Amami",
      "tlName": "Rehiyon ng Amami, Amami Prefecture",
      "moName": "Амами муж, Амами муж",
      "buName": "Amami ဒေသ, Amami ဒေသ",
      "khName": "តំបន់អាម៉ាមី, តំបន់អាម៉ាមី",
      "neName": "अमामी क्षेत्र, अमामी क्षेत्र"
    },
    "class15": {
      "code": "460041",
      "name": "北部",
      "enName": "Northern Region"
    },
    "class20": {
      "code": "4652700",
      "name": "龍郷町",
      "enName": "Tatsugo Town",
      "kana": "たつごうちょう",
      "chName": "龙乡町",
      "zhName": "龍鄉町",
      "koName": "다쓰고 정",
      "esName": "Pueblo de Tatsugou",
      "ptName": "bairro de Tatsugo",
      "thName": "เมืองทัตสึโกะ",
      "viName": "thị trấn Tatsugo",
      "inName": "kota Tatsugo",
      "tlName": "bayan ng Tatsugo",
      "moName": "Тацүго жижиг хот",
      "buName": "တတ်ဆူဂို မြို့နယ်",
      "khName": "ទីប្រជុំជន តាស៊ូហ្កូ",
      "neName": "तात्सुगो नगर"
    }
  },
  "4652900": {
    "office": {
      "code": "460040",
      "name": "奄美地方",
      "enName": "Amami",
      "officeName": "名瀬測候所",
      "chName": "奄美地區",
      "zhName": "奄美地区",
      "koName": "아마미 지방",
      "esName": "Región de Amami",
      "ptName": "Região de Amami",
      "thName": "ภูมิภาคอามามิ",
      "viName": "Tỉnh Amami",
      "inName": "Prefektur Amami",
      "tlName": "Amami Prefecture",
      "moName": "Амами муж",
      "buName": "Amami ဒေသ",
      "khName": "តំបន់អាម៉ាមី",
      "neName": "अमामी क्षेत्र"
    },
    "class10": {
      "code": "460040",
      "name": "奄美地方",
      "enName": "Amami Region",
      "chName": "奄美地區, 奄美地區",
      "zhName": "奄美地区, 奄美地区",
      "koName": "아마미 지방, 아마미 지방",
      "esName": "región amami, Región de Amami",
      "ptName": "Região de Amami, Região de Amami",
      "thName": "ภูมิภาคอามามิ, ภูมิภาคอามามิ",
      "viName": "Vùng Amami tỉnh Amami",
      "inName": "wilayah Amami, Prefektur Amami",
      "tlName": "Rehiyon ng Amami, Amami Prefecture",
      "moName": "Амами муж, Амами муж",
      "buName": "Amami ဒေသ, Amami ဒေသ",
      "khName": "តំបន់អាម៉ាមី, តំបន់អាម៉ាមី",
      "neName": "अमामी क्षेत्र, अमामी क्षेत्र"
    },
    "class15": {
      "code": "460041",
      "name": "北部",
      "enName": "Northern Region"
    },
    "class20": {
      "code": "4652900",
      "name": "喜界町",
      "enName": "Kikai Town",
      "kana": "きかいちょう",
      "chName": "喜界町",
      "zhName": "喜界町",
      "koName": "기카이 정",
      "esName": "Pueblo de Kikai",
      "ptName": "bairro de Kikai",
      "thName": "เมืองคิไค",
      "viName": "thị trấn Kikai",
      "inName": "kota Kikai",
      "tlName": "bayan ng Kikai",
      "moName": "Кикай жижиг хот",
      "buName": "ခီကားယိ မြို့နယ်",
      "khName": "ទីប្រជុំជន គីកៃ",
      "neName": "किकाई नगर"
    }
  },
  "4653000": {
    "office": {
      "code": "460040",
      "name": "奄美地方",
      "enName": "Amami",
      "officeName": "名瀬測候所",
      "chName": "奄美地區",
      "zhName": "奄美地区",
      "koName": "아마미 지방",
      "esName": "Región de Amami",
      "ptName": "Região de Amami",
      "thName": "ภูมิภาคอามามิ",
      "viName": "Tỉnh Amami",
      "inName": "Prefektur Amami",
      "tlName": "Amami Prefecture",
      "moName": "Амами муж",
      "buName": "Amami ဒေသ",
      "khName": "តំបន់អាម៉ាមី",
      "neName": "अमामी क्षेत्र"
    },
    "class10": {
      "code": "460040",
      "name": "奄美地方",
      "enName": "Amami Region",
      "chName": "奄美地區, 奄美地區",
      "zhName": "奄美地区, 奄美地区",
      "koName": "아마미 지방, 아마미 지방",
      "esName": "región amami, Región de Amami",
      "ptName": "Região de Amami, Região de Amami",
      "thName": "ภูมิภาคอามามิ, ภูมิภาคอามามิ",
      "viName": "Vùng Amami tỉnh Amami",
      "inName": "wilayah Amami, Prefektur Amami",
      "tlName": "Rehiyon ng Amami, Amami Prefecture",
      "moName": "Амами муж, Амами муж",
      "buName": "Amami ဒေသ, Amami ဒေသ",
      "khName": "តំបន់អាម៉ាមី, តំបន់អាម៉ាមី",
      "neName": "अमामी क्षेत्र, अमामी क्षेत्र"
    },
    "class15": {
      "code": "460042",
      "name": "南部",
      "enName": "Southern Region"
    },
    "class20": {
      "code": "4653000",
      "name": "徳之島町",
      "enName": "Tokunoshima Town",
      "kana": "とくのしまちょう",
      "chName": "德之岛町",
      "zhName": "德之島町",
      "koName": "도쿠노시마 정",
      "esName": "Pueblo de Tokunoshima",
      "ptName": "bairro de Tokunoshima",
      "thName": "เมืองโทคุโนะชิมะ",
      "viName": "thị trấn Tokunoshima",
      "inName": "kota Tokunoshima",
      "tlName": "bayan ng Tokunoshima",
      "moName": "Токүношимa жижиг хот",
      "buName": "တိုကုနိုရှိမ မြို့နယ်",
      "khName": "ទីប្រជុំជន តូគូណូស៊ីម៉ា",
      "neName": "तोकुनोशिमा नगर"
    }
  },
  "4653100": {
    "office": {
      "code": "460040",
      "name": "奄美地方",
      "enName": "Amami",
      "officeName": "名瀬測候所",
      "chName": "奄美地區",
      "zhName": "奄美地区",
      "koName": "아마미 지방",
      "esName": "Región de Amami",
      "ptName": "Região de Amami",
      "thName": "ภูมิภาคอามามิ",
      "viName": "Tỉnh Amami",
      "inName": "Prefektur Amami",
      "tlName": "Amami Prefecture",
      "moName": "Амами муж",
      "buName": "Amami ဒေသ",
      "khName": "តំបន់អាម៉ាមី",
      "neName": "अमामी क्षेत्र"
    },
    "class10": {
      "code": "460040",
      "name": "奄美地方",
      "enName": "Amami Region",
      "chName": "奄美地區, 奄美地區",
      "zhName": "奄美地区, 奄美地区",
      "koName": "아마미 지방, 아마미 지방",
      "esName": "región amami, Región de Amami",
      "ptName": "Região de Amami, Região de Amami",
      "thName": "ภูมิภาคอามามิ, ภูมิภาคอามามิ",
      "viName": "Vùng Amami tỉnh Amami",
      "inName": "wilayah Amami, Prefektur Amami",
      "tlName": "Rehiyon ng Amami, Amami Prefecture",
      "moName": "Амами муж, Амами муж",
      "buName": "Amami ဒေသ, Amami ဒေသ",
      "khName": "តំបន់អាម៉ាមី, តំបន់អាម៉ាមី",
      "neName": "अमामी क्षेत्र, अमामी क्षेत्र"
    },
    "class15": {
      "code": "460042",
      "name": "南部",
      "enName": "Southern Region"
    },
    "class20": {
      "code": "4653100",
      "name": "天城町",
      "enName": "Amagi Town",
      "kana": "あまぎちょう",
      "chName": "天城町",
      "zhName": "天城町",
      "koName": "아마기 정",
      "esName": "Pueblo de Amagi ",
      "ptName": "bairro de Amagi",
      "thName": "เมืองอามางิ",
      "viName": "thị trấn Amagi",
      "inName": "kota Amagi",
      "tlName": "bayan ng Amagi",
      "moName": "Aмaги жижиг хот",
      "buName": "အာမာ့ဂိ မြို့နယ်",
      "khName": "ទីប្រជុំជន អាម៉ាហ្គី",
      "neName": "आमागी नगर"
    }
  },
  "4653200": {
    "office": {
      "code": "460040",
      "name": "奄美地方",
      "enName": "Amami",
      "officeName": "名瀬測候所",
      "chName": "奄美地區",
      "zhName": "奄美地区",
      "koName": "아마미 지방",
      "esName": "Región de Amami",
      "ptName": "Região de Amami",
      "thName": "ภูมิภาคอามามิ",
      "viName": "Tỉnh Amami",
      "inName": "Prefektur Amami",
      "tlName": "Amami Prefecture",
      "moName": "Амами муж",
      "buName": "Amami ဒေသ",
      "khName": "តំបន់អាម៉ាមី",
      "neName": "अमामी क्षेत्र"
    },
    "class10": {
      "code": "460040",
      "name": "奄美地方",
      "enName": "Amami Region",
      "chName": "奄美地區, 奄美地區",
      "zhName": "奄美地区, 奄美地区",
      "koName": "아마미 지방, 아마미 지방",
      "esName": "región amami, Región de Amami",
      "ptName": "Região de Amami, Região de Amami",
      "thName": "ภูมิภาคอามามิ, ภูมิภาคอามามิ",
      "viName": "Vùng Amami tỉnh Amami",
      "inName": "wilayah Amami, Prefektur Amami",
      "tlName": "Rehiyon ng Amami, Amami Prefecture",
      "moName": "Амами муж, Амами муж",
      "buName": "Amami ဒေသ, Amami ဒေသ",
      "khName": "តំបន់អាម៉ាមី, តំបន់អាម៉ាមី",
      "neName": "अमामी क्षेत्र, अमामी क्षेत्र"
    },
    "class15": {
      "code": "460042",
      "name": "南部",
      "enName": "Southern Region"
    },
    "class20": {
      "code": "4653200",
      "name": "伊仙町",
      "enName": "Isen Town",
      "kana": "いせんちょう",
      "chName": "伊仙町",
      "zhName": "伊仙町",
      "koName": "이센 정",
      "esName": "Pueblo de Isen",
      "ptName": "bairro de Isen",
      "thName": "เมืองอิเซน",
      "viName": "thị trấn Isen",
      "inName": "kota Isen",
      "tlName": "bayan ng Isen",
      "moName": "Исэн жижиг хот",
      "buName": "အိစန် မြို့နယ်",
      "khName": "ទីប្រជុំជន អ៊ីសេន",
      "neName": "इसेन नगर"
    }
  },
  "4653300": {
    "office": {
      "code": "460040",
      "name": "奄美地方",
      "enName": "Amami",
      "officeName": "名瀬測候所",
      "chName": "奄美地區",
      "zhName": "奄美地区",
      "koName": "아마미 지방",
      "esName": "Región de Amami",
      "ptName": "Região de Amami",
      "thName": "ภูมิภาคอามามิ",
      "viName": "Tỉnh Amami",
      "inName": "Prefektur Amami",
      "tlName": "Amami Prefecture",
      "moName": "Амами муж",
      "buName": "Amami ဒေသ",
      "khName": "តំបន់អាម៉ាមី",
      "neName": "अमामी क्षेत्र"
    },
    "class10": {
      "code": "460040",
      "name": "奄美地方",
      "enName": "Amami Region",
      "chName": "奄美地區, 奄美地區",
      "zhName": "奄美地区, 奄美地区",
      "koName": "아마미 지방, 아마미 지방",
      "esName": "región amami, Región de Amami",
      "ptName": "Região de Amami, Região de Amami",
      "thName": "ภูมิภาคอามามิ, ภูมิภาคอามามิ",
      "viName": "Vùng Amami tỉnh Amami",
      "inName": "wilayah Amami, Prefektur Amami",
      "tlName": "Rehiyon ng Amami, Amami Prefecture",
      "moName": "Амами муж, Амами муж",
      "buName": "Amami ဒေသ, Amami ဒေသ",
      "khName": "តំបន់អាម៉ាមី, តំបន់អាម៉ាមី",
      "neName": "अमामी क्षेत्र, अमामी क्षेत्र"
    },
    "class15": {
      "code": "460042",
      "name": "南部",
      "enName": "Southern Region"
    },
    "class20": {
      "code": "4653300",
      "name": "和泊町",
      "enName": "Wadomari Town",
      "kana": "わどまりちょう",
      "chName": "和泊町",
      "zhName": "和泊町",
      "koName": "와도마리 정",
      "esName": "Pueblo de Wadomari",
      "ptName": "bairro de Wadomari",
      "thName": "เมืองวาโดมาริ",
      "viName": "thị trấn Wadomari",
      "inName": "kota Wadomari",
      "tlName": "bayan ng Wadomari",
      "moName": "Вадомaри жижиг хот",
      "buName": "ဝါဒိုမာ့ရိ မြို့နယ်",
      "khName": "ទីប្រជុំជន វ៉ាឌូម៉ារី",
      "neName": "वादोमारी नगर"
    }
  },
  "4653400": {
    "office": {
      "code": "460040",
      "name": "奄美地方",
      "enName": "Amami",
      "officeName": "名瀬測候所",
      "chName": "奄美地區",
      "zhName": "奄美地区",
      "koName": "아마미 지방",
      "esName": "Región de Amami",
      "ptName": "Região de Amami",
      "thName": "ภูมิภาคอามามิ",
      "viName": "Tỉnh Amami",
      "inName": "Prefektur Amami",
      "tlName": "Amami Prefecture",
      "moName": "Амами муж",
      "buName": "Amami ဒေသ",
      "khName": "តំបន់អាម៉ាមី",
      "neName": "अमामी क्षेत्र"
    },
    "class10": {
      "code": "460040",
      "name": "奄美地方",
      "enName": "Amami Region",
      "chName": "奄美地區, 奄美地區",
      "zhName": "奄美地区, 奄美地区",
      "koName": "아마미 지방, 아마미 지방",
      "esName": "región amami, Región de Amami",
      "ptName": "Região de Amami, Região de Amami",
      "thName": "ภูมิภาคอามามิ, ภูมิภาคอามามิ",
      "viName": "Vùng Amami tỉnh Amami",
      "inName": "wilayah Amami, Prefektur Amami",
      "tlName": "Rehiyon ng Amami, Amami Prefecture",
      "moName": "Амами муж, Амами муж",
      "buName": "Amami ဒေသ, Amami ဒေသ",
      "khName": "តំបន់អាម៉ាមី, តំបន់អាម៉ាមី",
      "neName": "अमामी क्षेत्र, अमामी क्षेत्र"
    },
    "class15": {
      "code": "460042",
      "name": "南部",
      "enName": "Southern Region"
    },
    "class20": {
      "code": "4653400",
      "name": "知名町",
      "enName": "China Town",
      "kana": "ちなちょう",
      "chName": "知名町",
      "zhName": "知名町",
      "koName": "지나 정",
      "esName": "Pueblo de China",
      "ptName": "bairro de China",
      "thName": "ไชน่าทาวน์",
      "viName": "thị trấn China",
      "inName": "kota China",
      "tlName": "bayan ng China",
      "moName": "чина жижиг хот",
      "buName": "ချိုင်းနား မြို့နယ်",
      "khName": "ទីប្រជុំជន ឆៃណា",
      "neName": "चाइना नगर"
    }
  },
  "4653500": {
    "office": {
      "code": "460040",
      "name": "奄美地方",
      "enName": "Amami",
      "officeName": "名瀬測候所",
      "chName": "奄美地區",
      "zhName": "奄美地区",
      "koName": "아마미 지방",
      "esName": "Región de Amami",
      "ptName": "Região de Amami",
      "thName": "ภูมิภาคอามามิ",
      "viName": "Tỉnh Amami",
      "inName": "Prefektur Amami",
      "tlName": "Amami Prefecture",
      "moName": "Амами муж",
      "buName": "Amami ဒေသ",
      "khName": "តំបន់អាម៉ាមី",
      "neName": "अमामी क्षेत्र"
    },
    "class10": {
      "code": "460040",
      "name": "奄美地方",
      "enName": "Amami Region",
      "chName": "奄美地區, 奄美地區",
      "zhName": "奄美地区, 奄美地区",
      "koName": "아마미 지방, 아마미 지방",
      "esName": "región amami, Región de Amami",
      "ptName": "Região de Amami, Região de Amami",
      "thName": "ภูมิภาคอามามิ, ภูมิภาคอามามิ",
      "viName": "Vùng Amami tỉnh Amami",
      "inName": "wilayah Amami, Prefektur Amami",
      "tlName": "Rehiyon ng Amami, Amami Prefecture",
      "moName": "Амами муж, Амами муж",
      "buName": "Amami ဒေသ, Amami ဒေသ",
      "khName": "តំបន់អាម៉ាមី, តំបន់អាម៉ាមី",
      "neName": "अमामी क्षेत्र, अमामी क्षेत्र"
    },
    "class15": {
      "code": "460042",
      "name": "南部",
      "enName": "Southern Region"
    },
    "class20": {
      "code": "4653500",
      "name": "与論町",
      "enName": "Yoron Town",
      "kana": "よろんちょう",
      "chName": "与论町",
      "zhName": "與論町",
      "koName": "요론 정",
      "esName": "Pueblo de Yoron",
      "ptName": "bairro de Yoron",
      "thName": "เมืองโยรอน",
      "viName": "thị trấn Yoron",
      "inName": "kota Yoron",
      "tlName": "bayan ng Yoron",
      "moName": "Ёрон жижиг хот",
      "buName": "ယော်ရွန်း မြို့နယ်",
      "khName": "ទីប្រជុំជន យូរ៉ុន",
      "neName": "योरोन नगर"
    }
  },
  "4720100": {
    "office": {
      "code": "471000",
      "name": "沖縄本島地方",
      "enName": "Okinawa Main Island",
      "officeName": "沖縄気象台",
      "chName": "沖繩本島地區",
      "zhName": "冲绳本岛地区",
      "koName": "오키나와 본섬 지방",
      "esName": "Región de la isla principal de Okinawa",
      "ptName": "Região da ilha principal de Okinawa",
      "thName": "ภูมิภาคเกาะหลักของโอกินาว่า",
      "viName": "Vùng đảo chính Okinawa",
      "inName": "Wilayah pulau utama Okinawa",
      "tlName": "Pangunahing isla na rehiyon ng Okinawa",
      "moName": "Окинава арлын гол бүс нутаг",
      "buName": "အိုကီနာဝါ အဓိကကျွန်းဒေသ",
      "khName": "តំបន់កោះសំខាន់របស់អូគីណាវ៉ា",
      "neName": "ओकिनावा मुख्य टापु क्षेत्र"
    },
    "class10": {
      "code": "471010",
      "name": "本島中南部",
      "enName": "Central and Southern Main Island",
      "chName": "主島中部和南部",
      "zhName": "主岛中部和南部",
      "koName": "본섬 중남부",
      "esName": "Isla principal central y sur",
      "ptName": "Ilha principal central e sul",
      "thName": "เกาะหลักตอนกลางและตอนใต้",
      "viName": "Đảo chính miền Trung và miền Nam",
      "inName": "Pulau utama tengah dan selatan",
      "tlName": "Pangunahing isla sa gitna at timog",
      "moName": "Төв ба өмнөд гол арал",
      "buName": "အလယ်ပိုင်းနှင့် တောင်ပိုင်း အဓိကကျွန်း",
      "khName": "កោះកណ្តាលនិងខាងត្បូង",
      "neName": "मध्य र दक्षिणी मुख्य टापु"
    },
    "class15": {
      "code": "471011",
      "name": "南部",
      "enName": "Southern Region"
    },
    "class20": {
      "code": "4720100",
      "name": "那覇市",
      "enName": "Naha City",
      "kana": "なはし",
      "chName": "那霸市",
      "zhName": "那霸市",
      "koName": "나하 시",
      "esName": "Ciudad de Naha",
      "ptName": "cidade de Naha",
      "thName": "เมืองนาฮะ",
      "viName": "thành phố Naha",
      "inName": "kota Naha",
      "tlName": "siyudad ng Naha",
      "moName": "Нaхa хот",
      "buName": "နာဟ မြို့",
      "khName": "ទីក្រុង ណាហា",
      "neName": "नाहा सहर"
    }
  },
  "4720500": {
    "office": {
      "code": "471000",
      "name": "沖縄本島地方",
      "enName": "Okinawa Main Island",
      "officeName": "沖縄気象台",
      "chName": "沖繩本島地區",
      "zhName": "冲绳本岛地区",
      "koName": "오키나와 본섬 지방",
      "esName": "Región de la isla principal de Okinawa",
      "ptName": "Região da ilha principal de Okinawa",
      "thName": "ภูมิภาคเกาะหลักของโอกินาว่า",
      "viName": "Vùng đảo chính Okinawa",
      "inName": "Wilayah pulau utama Okinawa",
      "tlName": "Pangunahing isla na rehiyon ng Okinawa",
      "moName": "Окинава арлын гол бүс нутаг",
      "buName": "အိုကီနာဝါ အဓိကကျွန်းဒေသ",
      "khName": "តំបន់កោះសំខាន់របស់អូគីណាវ៉ា",
      "neName": "ओकिनावा मुख्य टापु क्षेत्र"
    },
    "class10": {
      "code": "471010",
      "name": "本島中南部",
      "enName": "Central and Southern Main Island",
      "chName": "主島中部和南部",
      "zhName": "主岛中部和南部",
      "koName": "본섬 중남부",
      "esName": "Isla principal central y sur",
      "ptName": "Ilha principal central e sul",
      "thName": "เกาะหลักตอนกลางและตอนใต้",
      "viName": "Đảo chính miền Trung và miền Nam",
      "inName": "Pulau utama tengah dan selatan",
      "tlName": "Pangunahing isla sa gitna at timog",
      "moName": "Төв ба өмнөд гол арал",
      "buName": "အလယ်ပိုင်းနှင့် တောင်ပိုင်း အဓိကကျွန်း",
      "khName": "កោះកណ្តាលនិងខាងត្បូង",
      "neName": "मध्य र दक्षिणी मुख्य टापु"
    },
    "class15": {
      "code": "471012",
      "name": "中部",
      "enName": "Central Region"
    },
    "class20": {
      "code": "4720500",
      "name": "宜野湾市",
      "enName": "Ginowan City",
      "kana": "ぎのわんし",
      "chName": "宜野湾市",
      "zhName": "宜野灣市",
      "koName": "기노완 시",
      "esName": "Ciudad de Ginowan",
      "ptName": "cidade de Ginowan",
      "thName": "เมืองกิโนวัง",
      "viName": "thành phố Ginowan",
      "inName": "kota Ginowan",
      "tlName": "siyudad ng Ginowan",
      "moName": "Гинован хот",
      "buName": "ဂီနောဝမ် မြို့",
      "khName": "ទីក្រុង ជីណូវ៉ាន់",
      "neName": "गिनोवान सहर"
    }
  },
  "4720700": {
    "office": {
      "code": "474000",
      "name": "八重山地方",
      "enName": "Yaeyama",
      "officeName": "石垣島地方気象台",
      "chName": "八重山地區",
      "zhName": "八重山地区",
      "koName": "야에야마 지방",
      "esName": "Región de Yaeyama",
      "ptName": "Região de Yaeyama",
      "thName": "ภูมิภาคยาเอยามะ",
      "viName": "vùng Yaeyama",
      "inName": "wilayah Yaeyama",
      "tlName": "rehiyon ng Yaeyama",
      "moName": "Яэйама муж",
      "buName": "Yaeyama ဒေသ",
      "khName": "តំបន់ Yaeyama",
      "neName": "यायामा क्षेत्र"
    },
    "class10": {
      "code": "474010",
      "name": "石垣島地方",
      "enName": "Ishigakijima Region",
      "chName": "石垣島地區, 八重山地區",
      "zhName": "石垣岛地区, 八重山地区",
      "koName": "이시가키지마 지방, 야에야마 지방",
      "esName": "Región de la isla Ishigaki, Región de Yaeyama",
      "ptName": "Região da Ilha Ishigaki, Região de Yaeyama",
      "thName": "ภูมิภาคเกาะอิชิงากิ, ภูมิภาคยาเอยามะ",
      "viName": "Vùng đảo Ishigaki, vùng Yaeyama",
      "inName": "Wilayah Pulau Ishigaki, wilayah Yaeyama",
      "tlName": "Rehiyon ng Isla ng Ishigaki, rehiyon ng Yaeyama",
      "moName": "Ишигаки арлын бүс нутаг, Яэйама муж",
      "buName": "Ishigaki ကျွန်းဒေသ, Yaeyama ဒေသ",
      "khName": "តំបន់កោះ Ishigaki, តំបន់ Yaeyama",
      "neName": "Ishigaki द्वीप क्षेत्र, यायामा क्षेत्र"
    },
    "class15": {
      "code": "474011",
      "name": "石垣市",
      "enName": "Ishigaki City"
    },
    "class20": {
      "code": "4720700",
      "name": "石垣市",
      "enName": "Ishigaki City",
      "kana": "いしがきし",
      "chName": "石垣市",
      "zhName": "石垣市",
      "koName": "이시가키 시",
      "esName": "Ciudad de Ishigaki",
      "ptName": "cidade de Ishigaki",
      "thName": "เมืองอิชิงาคิ",
      "viName": "thành phố Ishigaki",
      "inName": "kota Ishigaki",
      "tlName": "siyudad ng Ishigaki",
      "moName": "Ишигaки хот",
      "buName": "အီရှိဂါ့ကိ မြို့",
      "khName": "ទីក្រុង អ៊ីស៊ីកាគី",
      "neName": "इशिगाकी सहर"
    }
  },
  "4720800": {
    "office": {
      "code": "471000",
      "name": "沖縄本島地方",
      "enName": "Okinawa Main Island",
      "officeName": "沖縄気象台",
      "chName": "沖繩本島地區",
      "zhName": "冲绳本岛地区",
      "koName": "오키나와 본섬 지방",
      "esName": "Región de la isla principal de Okinawa",
      "ptName": "Região da ilha principal de Okinawa",
      "thName": "ภูมิภาคเกาะหลักของโอกินาว่า",
      "viName": "Vùng đảo chính Okinawa",
      "inName": "Wilayah pulau utama Okinawa",
      "tlName": "Pangunahing isla na rehiyon ng Okinawa",
      "moName": "Окинава арлын гол бүс нутаг",
      "buName": "အိုကီနာဝါ အဓိကကျွန်းဒေသ",
      "khName": "តំបន់កោះសំខាន់របស់អូគីណាវ៉ា",
      "neName": "ओकिनावा मुख्य टापु क्षेत्र"
    },
    "class10": {
      "code": "471010",
      "name": "本島中南部",
      "enName": "Central and Southern Main Island",
      "chName": "主島中部和南部",
      "zhName": "主岛中部和南部",
      "koName": "본섬 중남부",
      "esName": "Isla principal central y sur",
      "ptName": "Ilha principal central e sul",
      "thName": "เกาะหลักตอนกลางและตอนใต้",
      "viName": "Đảo chính miền Trung và miền Nam",
      "inName": "Pulau utama tengah dan selatan",
      "tlName": "Pangunahing isla sa gitna at timog",
      "moName": "Төв ба өмнөд гол арал",
      "buName": "အလယ်ပိုင်းနှင့် တောင်ပိုင်း အဓိကကျွန်း",
      "khName": "កោះកណ្តាលនិងខាងត្បូង",
      "neName": "मध्य र दक्षिणी मुख्य टापु"
    },
    "class15": {
      "code": "471011",
      "name": "南部",
      "enName": "Southern Region"
    },
    "class20": {
      "code": "4720800",
      "name": "浦添市",
      "enName": "Urasoe City",
      "kana": "うらそえし",
      "chName": "浦添市",
      "zhName": "浦添市",
      "koName": "우라소에 시",
      "esName": "Ciudad de Urasoe",
      "ptName": "cidade de Urasoe",
      "thName": "เมืองอุระโซเอะ",
      "viName": "thành phố Urasoe",
      "inName": "kota Urasoe",
      "tlName": "siyudad ng Urasoe",
      "moName": "Үрасоэ хот",
      "buName": "ဥရဆော့အဲ့ မြို့",
      "khName": "ទីក្រុង យូរ៉ាសូ",
      "neName": "उरासोए सहर"
    }
  },
  "4720900": {
    "office": {
      "code": "471000",
      "name": "沖縄本島地方",
      "enName": "Okinawa Main Island",
      "officeName": "沖縄気象台",
      "chName": "沖繩本島地區",
      "zhName": "冲绳本岛地区",
      "koName": "오키나와 본섬 지방",
      "esName": "Región de la isla principal de Okinawa",
      "ptName": "Região da ilha principal de Okinawa",
      "thName": "ภูมิภาคเกาะหลักของโอกินาว่า",
      "viName": "Vùng đảo chính Okinawa",
      "inName": "Wilayah pulau utama Okinawa",
      "tlName": "Pangunahing isla na rehiyon ng Okinawa",
      "moName": "Окинава арлын гол бүс нутаг",
      "buName": "အိုကီနာဝါ အဓိကကျွန်းဒေသ",
      "khName": "តំបន់កោះសំខាន់របស់អូគីណាវ៉ា",
      "neName": "ओकिनावा मुख्य टापु क्षेत्र"
    },
    "class10": {
      "code": "471020",
      "name": "本島北部",
      "enName": "Northern Main Island",
      "chName": "北部主島",
      "zhName": "北部主岛",
      "koName": "본섬 북부",
      "esName": "Isla principal del norte",
      "ptName": "Ilha principal do norte",
      "thName": "เกาะหลักทางตอนเหนือ",
      "viName": "Đảo chính phía Bắc",
      "inName": "Pulau utama utara",
      "tlName": "Hilagang pangunahing isla",
      "moName": "Хойд гол арал",
      "buName": "မြောက်ဘက် အဓိကကျွန်း",
      "khName": "កោះសំខាន់ខាងជើង",
      "neName": "उत्तरी मुख्य टापु"
    },
    "class15": {
      "code": "471023",
      "name": "名護地区",
      "enName": "Nago District"
    },
    "class20": {
      "code": "4720900",
      "name": "名護市",
      "enName": "Nago City",
      "kana": "なごし",
      "chName": "名护市",
      "zhName": "名護市",
      "koName": "나고 시",
      "esName": "Ciudad de Nago",
      "ptName": "cidade de Nago",
      "thName": "เมืองนาโงะ",
      "viName": "thành phố Nago",
      "inName": "kota Nago",
      "tlName": "siyudad ng Nago",
      "moName": "Нaго хот",
      "buName": "နာဂေါ့ မြို့",
      "khName": "ទីក្រុង ណាហ្គូ",
      "neName": "नागो सहर"
    }
  },
  "4721000": {
    "office": {
      "code": "471000",
      "name": "沖縄本島地方",
      "enName": "Okinawa Main Island",
      "officeName": "沖縄気象台",
      "chName": "沖繩本島地區",
      "zhName": "冲绳本岛地区",
      "koName": "오키나와 본섬 지방",
      "esName": "Región de la isla principal de Okinawa",
      "ptName": "Região da ilha principal de Okinawa",
      "thName": "ภูมิภาคเกาะหลักของโอกินาว่า",
      "viName": "Vùng đảo chính Okinawa",
      "inName": "Wilayah pulau utama Okinawa",
      "tlName": "Pangunahing isla na rehiyon ng Okinawa",
      "moName": "Окинава арлын гол бүс нутаг",
      "buName": "အိုကီနာဝါ အဓိကကျွန်းဒေသ",
      "khName": "តំបន់កោះសំខាន់របស់អូគីណាវ៉ា",
      "neName": "ओकिनावा मुख्य टापु क्षेत्र"
    },
    "class10": {
      "code": "471010",
      "name": "本島中南部",
      "enName": "Central and Southern Main Island",
      "chName": "主島中部和南部",
      "zhName": "主岛中部和南部",
      "koName": "본섬 중남부",
      "esName": "Isla principal central y sur",
      "ptName": "Ilha principal central e sul",
      "thName": "เกาะหลักตอนกลางและตอนใต้",
      "viName": "Đảo chính miền Trung và miền Nam",
      "inName": "Pulau utama tengah dan selatan",
      "tlName": "Pangunahing isla sa gitna at timog",
      "moName": "Төв ба өмнөд гол арал",
      "buName": "အလယ်ပိုင်းနှင့် တောင်ပိုင်း အဓိကကျွန်း",
      "khName": "កោះកណ្តាលនិងខាងត្បូង",
      "neName": "मध्य र दक्षिणी मुख्य टापु"
    },
    "class15": {
      "code": "471011",
      "name": "南部",
      "enName": "Southern Region"
    },
    "class20": {
      "code": "4721000",
      "name": "糸満市",
      "enName": "Itoman City",
      "kana": "いとまんし",
      "chName": "丝满市",
      "zhName": "糸滿市",
      "koName": "이토만 시",
      "esName": "Ciudad de Itoman",
      "ptName": "cidade de Itoman",
      "thName": "เมืองอิโตะมัง",
      "viName": "thành phố Itoman",
      "inName": "kota Itoman",
      "tlName": "siyudad ng Itoman",
      "moName": "Итомaн хот",
      "buName": "အီတိုးမန် မြို့",
      "khName": "ទីក្រុង អ៊ីតូម៉ាន់",
      "neName": "इतोमान सहर"
    }
  },
  "4721100": {
    "office": {
      "code": "471000",
      "name": "沖縄本島地方",
      "enName": "Okinawa Main Island",
      "officeName": "沖縄気象台",
      "chName": "沖繩本島地區",
      "zhName": "冲绳本岛地区",
      "koName": "오키나와 본섬 지방",
      "esName": "Región de la isla principal de Okinawa",
      "ptName": "Região da ilha principal de Okinawa",
      "thName": "ภูมิภาคเกาะหลักของโอกินาว่า",
      "viName": "Vùng đảo chính Okinawa",
      "inName": "Wilayah pulau utama Okinawa",
      "tlName": "Pangunahing isla na rehiyon ng Okinawa",
      "moName": "Окинава арлын гол бүс нутаг",
      "buName": "အိုကီနာဝါ အဓိကကျွန်းဒေသ",
      "khName": "តំបន់កោះសំខាន់របស់អូគីណាវ៉ា",
      "neName": "ओकिनावा मुख्य टापु क्षेत्र"
    },
    "class10": {
      "code": "471010",
      "name": "本島中南部",
      "enName": "Central and Southern Main Island",
      "chName": "主島中部和南部",
      "zhName": "主岛中部和南部",
      "koName": "본섬 중남부",
      "esName": "Isla principal central y sur",
      "ptName": "Ilha principal central e sul",
      "thName": "เกาะหลักตอนกลางและตอนใต้",
      "viName": "Đảo chính miền Trung và miền Nam",
      "inName": "Pulau utama tengah dan selatan",
      "tlName": "Pangunahing isla sa gitna at timog",
      "moName": "Төв ба өмнөд гол арал",
      "buName": "အလယ်ပိုင်းနှင့် တောင်ပိုင်း အဓိကကျွန်း",
      "khName": "កោះកណ្តាលនិងខាងត្បូង",
      "neName": "मध्य र दक्षिणी मुख्य टापु"
    },
    "class15": {
      "code": "471012",
      "name": "中部",
      "enName": "Central Region"
    },
    "class20": {
      "code": "4721100",
      "name": "沖縄市",
      "enName": "Okinawa City",
      "kana": "おきなわし",
      "chName": "冲绳市",
      "zhName": "沖繩市",
      "koName": "오키나와 시",
      "esName": "Ciudad de Okinawa",
      "ptName": "cidade de Okinawa",
      "thName": "เมืองโอกินาวา",
      "viName": "thành phố Okinawa",
      "inName": "kota Okinawa",
      "tlName": "siyudad ng Okinawa",
      "moName": "Окинава хот",
      "buName": "အိုကီနားဝါ့ မြို့",
      "khName": "ទីក្រុង អូគីណាវ៉ា",
      "neName": "ओकिनावा सहर"
    }
  },
  "4721200": {
    "office": {
      "code": "471000",
      "name": "沖縄本島地方",
      "enName": "Okinawa Main Island",
      "officeName": "沖縄気象台",
      "chName": "沖繩本島地區",
      "zhName": "冲绳本岛地区",
      "koName": "오키나와 본섬 지방",
      "esName": "Región de la isla principal de Okinawa",
      "ptName": "Região da ilha principal de Okinawa",
      "thName": "ภูมิภาคเกาะหลักของโอกินาว่า",
      "viName": "Vùng đảo chính Okinawa",
      "inName": "Wilayah pulau utama Okinawa",
      "tlName": "Pangunahing isla na rehiyon ng Okinawa",
      "moName": "Окинава арлын гол бүс нутаг",
      "buName": "အိုကီနာဝါ အဓိကကျွန်းဒေသ",
      "khName": "តំបន់កោះសំខាន់របស់អូគីណាវ៉ា",
      "neName": "ओकिनावा मुख्य टापु क्षेत्र"
    },
    "class10": {
      "code": "471010",
      "name": "本島中南部",
      "enName": "Central and Southern Main Island",
      "chName": "主島中部和南部",
      "zhName": "主岛中部和南部",
      "koName": "본섬 중남부",
      "esName": "Isla principal central y sur",
      "ptName": "Ilha principal central e sul",
      "thName": "เกาะหลักตอนกลางและตอนใต้",
      "viName": "Đảo chính miền Trung và miền Nam",
      "inName": "Pulau utama tengah dan selatan",
      "tlName": "Pangunahing isla sa gitna at timog",
      "moName": "Төв ба өмнөд гол арал",
      "buName": "အလယ်ပိုင်းနှင့် တောင်ပိုင်း အဓိကကျွန်း",
      "khName": "កោះកណ្តាលនិងខាងត្បូង",
      "neName": "मध्य र दक्षिणी मुख्य टापु"
    },
    "class15": {
      "code": "471011",
      "name": "南部",
      "enName": "Southern Region"
    },
    "class20": {
      "code": "4721200",
      "name": "豊見城市",
      "enName": "Tomigusuku City",
      "kana": "とみぐすくし",
      "chName": "丰见城市",
      "zhName": "豐見城市",
      "koName": "도미구스쿠 시",
      "esName": "Ciudad de Tomigusuku",
      "ptName": "cidade de Tomigusuku",
      "thName": "เมืองโทมิกุสึคุ",
      "viName": "thành phố Tomigusuku",
      "inName": "kota Tomigusuku",
      "tlName": "siyudad ng Tomigusuku",
      "moName": "Томигүсүкү хот",
      "buName": "တိုမီဂူဆုကု မြို့",
      "khName": "ទីក្រុង តូមីគូស៊ូគូ",
      "neName": "तोमिगुश्कु सहर"
    }
  },
  "4721300": {
    "office": {
      "code": "471000",
      "name": "沖縄本島地方",
      "enName": "Okinawa Main Island",
      "officeName": "沖縄気象台",
      "chName": "沖繩本島地區",
      "zhName": "冲绳本岛地区",
      "koName": "오키나와 본섬 지방",
      "esName": "Región de la isla principal de Okinawa",
      "ptName": "Região da ilha principal de Okinawa",
      "thName": "ภูมิภาคเกาะหลักของโอกินาว่า",
      "viName": "Vùng đảo chính Okinawa",
      "inName": "Wilayah pulau utama Okinawa",
      "tlName": "Pangunahing isla na rehiyon ng Okinawa",
      "moName": "Окинава арлын гол бүс нутаг",
      "buName": "အိုကီနာဝါ အဓိကကျွန်းဒေသ",
      "khName": "តំបន់កោះសំខាន់របស់អូគីណាវ៉ា",
      "neName": "ओकिनावा मुख्य टापु क्षेत्र"
    },
    "class10": {
      "code": "471010",
      "name": "本島中南部",
      "enName": "Central and Southern Main Island",
      "chName": "主島中部和南部",
      "zhName": "主岛中部和南部",
      "koName": "본섬 중남부",
      "esName": "Isla principal central y sur",
      "ptName": "Ilha principal central e sul",
      "thName": "เกาะหลักตอนกลางและตอนใต้",
      "viName": "Đảo chính miền Trung và miền Nam",
      "inName": "Pulau utama tengah dan selatan",
      "tlName": "Pangunahing isla sa gitna at timog",
      "moName": "Төв ба өмнөд гол арал",
      "buName": "အလယ်ပိုင်းနှင့် တောင်ပိုင်း အဓိကကျွန်း",
      "khName": "កោះកណ្តាលនិងខាងត្បូង",
      "neName": "मध्य र दक्षिणी मुख्य टापु"
    },
    "class15": {
      "code": "471012",
      "name": "中部",
      "enName": "Central Region"
    },
    "class20": {
      "code": "4721300",
      "name": "うるま市",
      "enName": "Uruma City",
      "kana": "うるまし",
      "chName": "宇流麻市",
      "zhName": "宇流麻市",
      "koName": "우루마 시",
      "esName": "Ciudad de Uruma",
      "ptName": "cidade de Uruma",
      "thName": "เมืองอุรุมะ",
      "viName": "thành phố Uruma",
      "inName": "kota Uruma",
      "tlName": "siyudad ng Uruma",
      "moName": "Үрүмa хот",
      "buName": "ဥရုမ မြို့",
      "khName": "ទីក្រុង អ៊ូរូម៉ា",
      "neName": "उरुमा सहर"
    }
  },
  "4721400": {
    "office": {
      "code": "473000",
      "name": "宮古島地方",
      "enName": "Miyakojima",
      "officeName": "宮古島地方気象台",
      "chName": "宮古島地區",
      "zhName": "宫古岛地区",
      "koName": "미야코지마 지방",
      "esName": "Región de Miyakojima",
      "ptName": "Região de Miyakojima",
      "thName": "ภูมิภาคมิยาโกจิมะ",
      "viName": "vùng Miyakojima",
      "inName": "wilayah Miyakojima",
      "tlName": "Rehiyon ng Miyakojima",
      "moName": "Миякожима муж",
      "buName": "Miyakojima ဒေသ",
      "khName": "តំបន់ Miyakojima",
      "neName": "मियाकोजिमा क्षेत्र"
    },
    "class10": {
      "code": "473000",
      "name": "宮古島地方",
      "enName": "Miyakojima Region",
      "chName": "宮古島地區",
      "zhName": "宫古岛地区",
      "koName": "미야코지마 지방",
      "esName": "Región de Miyakojima",
      "ptName": "Região de Miyakojima",
      "thName": "ภูมิภาคมิยาโกจิมะ",
      "viName": "vùng Miyakojima",
      "inName": "wilayah Miyakojima",
      "tlName": "Rehiyon ng Miyakojima",
      "moName": "Миякожима муж",
      "buName": "Miyakojima ဒေသ",
      "khName": "តំបន់ Miyakojima",
      "neName": "मियाकोजिमा क्षेत्र"
    },
    "class15": {
      "code": "473001",
      "name": "宮古島",
      "enName": "Miyakojima"
    },
    "class20": {
      "code": "4721400",
      "name": "宮古島市",
      "enName": "Miyakojima City",
      "kana": "みやこじまし",
      "chName": "宫古岛市",
      "zhName": "宮古島市",
      "koName": "미야코지마 시",
      "esName": "Ciudad de Miyakojima",
      "ptName": "cidade de Miyakojima",
      "thName": "เมืองมิยาโคะจิมะ",
      "viName": "thành phố Miyakojima",
      "inName": "kota Miyakojima",
      "tlName": "siyudad ng Miyakojima",
      "moName": "Миякожимa хот",
      "buName": "မီယာကိုးဂျိမ မြို့",
      "khName": "ទីក្រុង មីយ៉ាកុជិម៉ា",
      "neName": "मियाकोजीमा सहर"
    }
  },
  "4721500": {
    "office": {
      "code": "471000",
      "name": "沖縄本島地方",
      "enName": "Okinawa Main Island",
      "officeName": "沖縄気象台",
      "chName": "沖繩本島地區",
      "zhName": "冲绳本岛地区",
      "koName": "오키나와 본섬 지방",
      "esName": "Región de la isla principal de Okinawa",
      "ptName": "Região da ilha principal de Okinawa",
      "thName": "ภูมิภาคเกาะหลักของโอกินาว่า",
      "viName": "Vùng đảo chính Okinawa",
      "inName": "Wilayah pulau utama Okinawa",
      "tlName": "Pangunahing isla na rehiyon ng Okinawa",
      "moName": "Окинава арлын гол бүс нутаг",
      "buName": "အိုကီနာဝါ အဓိကကျွန်းဒေသ",
      "khName": "តំបន់កោះសំខាន់របស់អូគីណាវ៉ា",
      "neName": "ओकिनावा मुख्य टापु क्षेत्र"
    },
    "class10": {
      "code": "471010",
      "name": "本島中南部",
      "enName": "Central and Southern Main Island",
      "chName": "主島中部和南部",
      "zhName": "主岛中部和南部",
      "koName": "본섬 중남부",
      "esName": "Isla principal central y sur",
      "ptName": "Ilha principal central e sul",
      "thName": "เกาะหลักตอนกลางและตอนใต้",
      "viName": "Đảo chính miền Trung và miền Nam",
      "inName": "Pulau utama tengah dan selatan",
      "tlName": "Pangunahing isla sa gitna at timog",
      "moName": "Төв ба өмнөд гол арал",
      "buName": "အလယ်ပိုင်းနှင့် တောင်ပိုင်း အဓိကကျွန်း",
      "khName": "កោះកណ្តាលនិងខាងត្បូង",
      "neName": "मध्य र दक्षिणी मुख्य टापु"
    },
    "class15": {
      "code": "471011",
      "name": "南部",
      "enName": "Southern Region"
    },
    "class20": {
      "code": "4721500",
      "name": "南城市",
      "enName": "Nanjo City",
      "kana": "なんじょうし",
      "chName": "南城市",
      "zhName": "南城市",
      "koName": "난조 시",
      "esName": "Ciudad de Nanjyo",
      "ptName": "cidade de Nanjo",
      "thName": "เมืองนันโจ",
      "viName": "thành phố Nanjo",
      "inName": "kota Nanjo",
      "tlName": "siyudad ng Nanjo",
      "moName": "Нанжо хот",
      "buName": "နန်းဂျော့ မြို့",
      "khName": "ទីក្រុង ណានចូ",
      "neName": "नान्जो सहर"
    }
  },
  "4730100": {
    "office": {
      "code": "471000",
      "name": "沖縄本島地方",
      "enName": "Okinawa Main Island",
      "officeName": "沖縄気象台",
      "chName": "沖繩本島地區",
      "zhName": "冲绳本岛地区",
      "koName": "오키나와 본섬 지방",
      "esName": "Región de la isla principal de Okinawa",
      "ptName": "Região da ilha principal de Okinawa",
      "thName": "ภูมิภาคเกาะหลักของโอกินาว่า",
      "viName": "Vùng đảo chính Okinawa",
      "inName": "Wilayah pulau utama Okinawa",
      "tlName": "Pangunahing isla na rehiyon ng Okinawa",
      "moName": "Окинава арлын гол бүс нутаг",
      "buName": "အိုကီနာဝါ အဓိကကျွန်းဒေသ",
      "khName": "តំបន់កោះសំខាន់របស់អូគីណាវ៉ា",
      "neName": "ओकिनावा मुख्य टापु क्षेत्र"
    },
    "class10": {
      "code": "471020",
      "name": "本島北部",
      "enName": "Northern Main Island",
      "chName": "北部主島",
      "zhName": "北部主岛",
      "koName": "본섬 북부",
      "esName": "Isla principal del norte",
      "ptName": "Ilha principal do norte",
      "thName": "เกาะหลักทางตอนเหนือ",
      "viName": "Đảo chính phía Bắc",
      "inName": "Pulau utama utara",
      "tlName": "Hilagang pangunahing isla",
      "moName": "Хойд гол арал",
      "buName": "မြောက်ဘက် အဓိကကျွန်း",
      "khName": "កោះសំខាន់ខាងជើង",
      "neName": "उत्तरी मुख्य टापु"
    },
    "class15": {
      "code": "471022",
      "name": "国頭地区",
      "enName": "Kunigami District"
    },
    "class20": {
      "code": "4730100",
      "name": "国頭村",
      "enName": "Kunigami Village",
      "kana": "くにがみそん",
      "chName": "国头村",
      "zhName": "國頭村",
      "koName": "구니가미 촌",
      "esName": "Aldea de Kunigami",
      "ptName": "povoado de Kunigami",
      "thName": "หมู่บ้านคุนิงามิ",
      "viName": "làng Kunigami",
      "inName": "desa Kunigami",
      "tlName": "nayon ng Kunigami",
      "moName": "Күнигaми тосгон",
      "buName": "ကူနိဂါ့မိ ကျေးရွာ",
      "khName": " ភូមិ គុននីហ្កាមី",
      "neName": "कुनिगामी गाउँ"
    }
  },
  "4730200": {
    "office": {
      "code": "471000",
      "name": "沖縄本島地方",
      "enName": "Okinawa Main Island",
      "officeName": "沖縄気象台",
      "chName": "沖繩本島地區",
      "zhName": "冲绳本岛地区",
      "koName": "오키나와 본섬 지방",
      "esName": "Región de la isla principal de Okinawa",
      "ptName": "Região da ilha principal de Okinawa",
      "thName": "ภูมิภาคเกาะหลักของโอกินาว่า",
      "viName": "Vùng đảo chính Okinawa",
      "inName": "Wilayah pulau utama Okinawa",
      "tlName": "Pangunahing isla na rehiyon ng Okinawa",
      "moName": "Окинава арлын гол бүс нутаг",
      "buName": "အိုကီနာဝါ အဓိကကျွန်းဒေသ",
      "khName": "តំបន់កោះសំខាន់របស់អូគីណាវ៉ា",
      "neName": "ओकिनावा मुख्य टापु क्षेत्र"
    },
    "class10": {
      "code": "471020",
      "name": "本島北部",
      "enName": "Northern Main Island",
      "chName": "北部主島",
      "zhName": "北部主岛",
      "koName": "본섬 북부",
      "esName": "Isla principal del norte",
      "ptName": "Ilha principal do norte",
      "thName": "เกาะหลักทางตอนเหนือ",
      "viName": "Đảo chính phía Bắc",
      "inName": "Pulau utama utara",
      "tlName": "Hilagang pangunahing isla",
      "moName": "Хойд гол арал",
      "buName": "မြောက်ဘက် အဓိကကျွန်း",
      "khName": "កោះសំខាន់ខាងជើង",
      "neName": "उत्तरी मुख्य टापु"
    },
    "class15": {
      "code": "471022",
      "name": "国頭地区",
      "enName": "Kunigami District"
    },
    "class20": {
      "code": "4730200",
      "name": "大宜味村",
      "enName": "Ogimi Village",
      "kana": "おおぎみそん",
      "chName": "大宜味村",
      "zhName": "大宜味村",
      "koName": "오기미 촌",
      "esName": "Aldea de Ogimi",
      "ptName": "povoado de Ogimi",
      "thName": "หมู่บ้านโองิมิ",
      "viName": "làng Ogimi",
      "inName": "desa Ogimi",
      "tlName": "nayon ng Ogimi",
      "moName": "Огими тосгон",
      "buName": "အိုဂိမိ ကျေးရွာ",
      "khName": "ភូមិ អូជីមី",
      "neName": "ओगिमी गाउँ"
    }
  },
  "4730300": {
    "office": {
      "code": "471000",
      "name": "沖縄本島地方",
      "enName": "Okinawa Main Island",
      "officeName": "沖縄気象台",
      "chName": "沖繩本島地區",
      "zhName": "冲绳本岛地区",
      "koName": "오키나와 본섬 지방",
      "esName": "Región de la isla principal de Okinawa",
      "ptName": "Região da ilha principal de Okinawa",
      "thName": "ภูมิภาคเกาะหลักของโอกินาว่า",
      "viName": "Vùng đảo chính Okinawa",
      "inName": "Wilayah pulau utama Okinawa",
      "tlName": "Pangunahing isla na rehiyon ng Okinawa",
      "moName": "Окинава арлын гол бүс нутаг",
      "buName": "အိုကီနာဝါ အဓိကကျွန်းဒေသ",
      "khName": "តំបន់កោះសំខាន់របស់អូគីណាវ៉ា",
      "neName": "ओकिनावा मुख्य टापु क्षेत्र"
    },
    "class10": {
      "code": "471020",
      "name": "本島北部",
      "enName": "Northern Main Island",
      "chName": "北部主島",
      "zhName": "北部主岛",
      "koName": "본섬 북부",
      "esName": "Isla principal del norte",
      "ptName": "Ilha principal do norte",
      "thName": "เกาะหลักทางตอนเหนือ",
      "viName": "Đảo chính phía Bắc",
      "inName": "Pulau utama utara",
      "tlName": "Hilagang pangunahing isla",
      "moName": "Хойд гол арал",
      "buName": "မြောက်ဘက် အဓိကကျွန်း",
      "khName": "កោះសំខាន់ខាងជើង",
      "neName": "उत्तरी मुख्य टापु"
    },
    "class15": {
      "code": "471022",
      "name": "国頭地区",
      "enName": "Kunigami District"
    },
    "class20": {
      "code": "4730300",
      "name": "東村",
      "enName": "Higashi Village",
      "kana": "ひがしそん",
      "chName": "东村",
      "zhName": "東村",
      "koName": "히가시 촌",
      "esName": "Aldea de Higashi",
      "ptName": "povoado de Higashi",
      "thName": "หมู่บ้านฮิงาชิ",
      "viName": "làng Higashi",
      "inName": "desa Higashi",
      "tlName": "nayon ng Higashi",
      "moName": "Хигaши тосгон",
      "buName": "ဟီဂရှိ ကျေးရွာ",
      "khName": "ភូមិ ហ៊ីហ្កាស៊ី",
      "neName": "हिगाशी गाउँ"
    }
  },
  "4730600": {
    "office": {
      "code": "471000",
      "name": "沖縄本島地方",
      "enName": "Okinawa Main Island",
      "officeName": "沖縄気象台",
      "chName": "沖繩本島地區",
      "zhName": "冲绳本岛地区",
      "koName": "오키나와 본섬 지방",
      "esName": "Región de la isla principal de Okinawa",
      "ptName": "Região da ilha principal de Okinawa",
      "thName": "ภูมิภาคเกาะหลักของโอกินาว่า",
      "viName": "Vùng đảo chính Okinawa",
      "inName": "Wilayah pulau utama Okinawa",
      "tlName": "Pangunahing isla na rehiyon ng Okinawa",
      "moName": "Окинава арлын гол бүс нутаг",
      "buName": "အိုကီနာဝါ အဓိကကျွန်းဒေသ",
      "khName": "តំបន់កោះសំខាន់របស់អូគីណាវ៉ា",
      "neName": "ओकिनावा मुख्य टापु क्षेत्र"
    },
    "class10": {
      "code": "471020",
      "name": "本島北部",
      "enName": "Northern Main Island",
      "chName": "北部主島",
      "zhName": "北部主岛",
      "koName": "본섬 북부",
      "esName": "Isla principal del norte",
      "ptName": "Ilha principal do norte",
      "thName": "เกาะหลักทางตอนเหนือ",
      "viName": "Đảo chính phía Bắc",
      "inName": "Pulau utama utara",
      "tlName": "Hilagang pangunahing isla",
      "moName": "Хойд гол арал",
      "buName": "မြောက်ဘက် အဓိကကျွန်း",
      "khName": "កោះសំខាន់ខាងជើង",
      "neName": "उत्तरी मुख्य टापु"
    },
    "class15": {
      "code": "471023",
      "name": "名護地区",
      "enName": "Nago District"
    },
    "class20": {
      "code": "4730600",
      "name": "今帰仁村",
      "enName": "Nakijin Village",
      "kana": "なきじんそん",
      "chName": "今归仁村",
      "zhName": "今歸仁村",
      "koName": "나키진 촌",
      "esName": "Aldea de Nakijin",
      "ptName": "povoado de Nakijin",
      "thName": "หมู่บ้านนิคิจิน",
      "viName": "làng Nakijin",
      "inName": "desa Nakijin",
      "tlName": "nayon ng Nakijin",
      "moName": "Нaкижин тосгон",
      "buName": "နားကိဂျင်း ကျေးရွာ",
      "khName": "ភូមិ ណាគីជីន",
      "neName": "नाकिजिन गाउँ"
    }
  },
  "4730800": {
    "office": {
      "code": "471000",
      "name": "沖縄本島地方",
      "enName": "Okinawa Main Island",
      "officeName": "沖縄気象台",
      "chName": "沖繩本島地區",
      "zhName": "冲绳本岛地区",
      "koName": "오키나와 본섬 지방",
      "esName": "Región de la isla principal de Okinawa",
      "ptName": "Região da ilha principal de Okinawa",
      "thName": "ภูมิภาคเกาะหลักของโอกินาว่า",
      "viName": "Vùng đảo chính Okinawa",
      "inName": "Wilayah pulau utama Okinawa",
      "tlName": "Pangunahing isla na rehiyon ng Okinawa",
      "moName": "Окинава арлын гол бүс нутаг",
      "buName": "အိုကီနာဝါ အဓိကကျွန်းဒေသ",
      "khName": "តំបន់កោះសំខាន់របស់អូគីណាវ៉ា",
      "neName": "ओकिनावा मुख्य टापु क्षेत्र"
    },
    "class10": {
      "code": "471020",
      "name": "本島北部",
      "enName": "Northern Main Island",
      "chName": "北部主島",
      "zhName": "北部主岛",
      "koName": "본섬 북부",
      "esName": "Isla principal del norte",
      "ptName": "Ilha principal do norte",
      "thName": "เกาะหลักทางตอนเหนือ",
      "viName": "Đảo chính phía Bắc",
      "inName": "Pulau utama utara",
      "tlName": "Hilagang pangunahing isla",
      "moName": "Хойд гол арал",
      "buName": "မြောက်ဘက် အဓိကကျွန်း",
      "khName": "កោះសំខាន់ខាងជើង",
      "neName": "उत्तरी मुख्य टापु"
    },
    "class15": {
      "code": "471023",
      "name": "名護地区",
      "enName": "Nago District"
    },
    "class20": {
      "code": "4730800",
      "name": "本部町",
      "enName": "Motobu Town",
      "kana": "もとぶちょう",
      "chName": "本部町",
      "zhName": "本部町",
      "koName": "모토부 정",
      "esName": "Pueblo de Motobu",
      "ptName": "bairro de Motobu",
      "thName": "เมืองโมโทบุ",
      "viName": "thị trấn Motobu",
      "inName": "kota Motobu",
      "tlName": "bayan ng Motobu",
      "moName": "Мотобү жижиг хот",
      "buName": "မိုးတို့ဘု မြို့နယ်",
      "khName": "ទីប្រជុំជន មូតូប៊ូ",
      "neName": "मोतोबु नगर"
    }
  },
  "4731100": {
    "office": {
      "code": "471000",
      "name": "沖縄本島地方",
      "enName": "Okinawa Main Island",
      "officeName": "沖縄気象台",
      "chName": "沖繩本島地區",
      "zhName": "冲绳本岛地区",
      "koName": "오키나와 본섬 지방",
      "esName": "Región de la isla principal de Okinawa",
      "ptName": "Região da ilha principal de Okinawa",
      "thName": "ภูมิภาคเกาะหลักของโอกินาว่า",
      "viName": "Vùng đảo chính Okinawa",
      "inName": "Wilayah pulau utama Okinawa",
      "tlName": "Pangunahing isla na rehiyon ng Okinawa",
      "moName": "Окинава арлын гол бүс нутаг",
      "buName": "အိုကီနာဝါ အဓိကကျွန်းဒေသ",
      "khName": "តំបន់កោះសំខាន់របស់អូគីណាវ៉ា",
      "neName": "ओकिनावा मुख्य टापु क्षेत्र"
    },
    "class10": {
      "code": "471020",
      "name": "本島北部",
      "enName": "Northern Main Island",
      "chName": "北部主島",
      "zhName": "北部主岛",
      "koName": "본섬 북부",
      "esName": "Isla principal del norte",
      "ptName": "Ilha principal do norte",
      "thName": "เกาะหลักทางตอนเหนือ",
      "viName": "Đảo chính phía Bắc",
      "inName": "Pulau utama utara",
      "tlName": "Hilagang pangunahing isla",
      "moName": "Хойд гол арал",
      "buName": "မြောက်ဘက် အဓိကကျွန်း",
      "khName": "កោះសំខាន់ខាងជើង",
      "neName": "उत्तरी मुख्य टापु"
    },
    "class15": {
      "code": "471024",
      "name": "恩納・金武地区",
      "enName": "Onna Kin District"
    },
    "class20": {
      "code": "4731100",
      "name": "恩納村",
      "enName": "Onna Village",
      "kana": "おんなそん",
      "chName": "恩纳村",
      "zhName": "恩納村",
      "koName": "온나 촌",
      "esName": "Aldea de Onna",
      "ptName": "povoado de Onna",
      "thName": "หมู่บ้านออนนะ",
      "viName": "làng Onna",
      "inName": "desa Onna",
      "tlName": "nayon ng Onna",
      "moName": "Оннa тосгон",
      "buName": "အွန်းန ကျေးရွာ",
      "khName": "ភូមិ អូណា",
      "neName": "ओन्ना गाउँ"
    }
  },
  "4731300": {
    "office": {
      "code": "471000",
      "name": "沖縄本島地方",
      "enName": "Okinawa Main Island",
      "officeName": "沖縄気象台",
      "chName": "沖繩本島地區",
      "zhName": "冲绳本岛地区",
      "koName": "오키나와 본섬 지방",
      "esName": "Región de la isla principal de Okinawa",
      "ptName": "Região da ilha principal de Okinawa",
      "thName": "ภูมิภาคเกาะหลักของโอกินาว่า",
      "viName": "Vùng đảo chính Okinawa",
      "inName": "Wilayah pulau utama Okinawa",
      "tlName": "Pangunahing isla na rehiyon ng Okinawa",
      "moName": "Окинава арлын гол бүс нутаг",
      "buName": "အိုကီနာဝါ အဓိကကျွန်းဒေသ",
      "khName": "តំបន់កោះសំខាន់របស់អូគីណាវ៉ា",
      "neName": "ओकिनावा मुख्य टापु क्षेत्र"
    },
    "class10": {
      "code": "471020",
      "name": "本島北部",
      "enName": "Northern Main Island",
      "chName": "北部主島",
      "zhName": "北部主岛",
      "koName": "본섬 북부",
      "esName": "Isla principal del norte",
      "ptName": "Ilha principal do norte",
      "thName": "เกาะหลักทางตอนเหนือ",
      "viName": "Đảo chính phía Bắc",
      "inName": "Pulau utama utara",
      "tlName": "Hilagang pangunahing isla",
      "moName": "Хойд гол арал",
      "buName": "မြောက်ဘက် အဓိကကျွန်း",
      "khName": "កោះសំខាន់ខាងជើង",
      "neName": "उत्तरी मुख्य टापु"
    },
    "class15": {
      "code": "471024",
      "name": "恩納・金武地区",
      "enName": "Onna Kin District"
    },
    "class20": {
      "code": "4731300",
      "name": "宜野座村",
      "enName": "Ginoza Village",
      "kana": "ぎのざそん",
      "chName": "宜野座村",
      "zhName": "宜野座村",
      "koName": "기노자 촌",
      "esName": "Aldea de Ginoza",
      "ptName": "povoado de Ginoza",
      "thName": "หมู่บ้านกิโนะซะ",
      "viName": "làng Ginoza",
      "inName": "desa Ginoza",
      "tlName": "nayon ng Ginoza",
      "moName": "Гинозa тосгон",
      "buName": "ဂီနောဇ ကျေးရွာ",
      "khName": "ភូមិ ជីណូហ្សា",
      "neName": "गिनोजा गाउँ"
    }
  },
  "4731400": {
    "office": {
      "code": "471000",
      "name": "沖縄本島地方",
      "enName": "Okinawa Main Island",
      "officeName": "沖縄気象台",
      "chName": "沖繩本島地區",
      "zhName": "冲绳本岛地区",
      "koName": "오키나와 본섬 지방",
      "esName": "Región de la isla principal de Okinawa",
      "ptName": "Região da ilha principal de Okinawa",
      "thName": "ภูมิภาคเกาะหลักของโอกินาว่า",
      "viName": "Vùng đảo chính Okinawa",
      "inName": "Wilayah pulau utama Okinawa",
      "tlName": "Pangunahing isla na rehiyon ng Okinawa",
      "moName": "Окинава арлын гол бүс нутаг",
      "buName": "အိုကီနာဝါ အဓိကကျွန်းဒေသ",
      "khName": "តំបន់កោះសំខាន់របស់អូគីណាវ៉ា",
      "neName": "ओकिनावा मुख्य टापु क्षेत्र"
    },
    "class10": {
      "code": "471020",
      "name": "本島北部",
      "enName": "Northern Main Island",
      "chName": "北部主島",
      "zhName": "北部主岛",
      "koName": "본섬 북부",
      "esName": "Isla principal del norte",
      "ptName": "Ilha principal do norte",
      "thName": "เกาะหลักทางตอนเหนือ",
      "viName": "Đảo chính phía Bắc",
      "inName": "Pulau utama utara",
      "tlName": "Hilagang pangunahing isla",
      "moName": "Хойд гол арал",
      "buName": "မြောက်ဘက် အဓိကကျွန်း",
      "khName": "កោះសំខាន់ខាងជើង",
      "neName": "उत्तरी मुख्य टापु"
    },
    "class15": {
      "code": "471024",
      "name": "恩納・金武地区",
      "enName": "Onna Kin District"
    },
    "class20": {
      "code": "4731400",
      "name": "金武町",
      "enName": "Kin Town",
      "kana": "きんちょう",
      "chName": "金武町",
      "zhName": "金武町",
      "koName": "긴 정",
      "esName": "Pueblo de Kin",
      "ptName": "bairro de Kin",
      "thName": "เมืองคิน",
      "viName": "thị trấn Kin",
      "inName": "kota Kin",
      "tlName": "bayan ng Kin",
      "moName": "Кин жижиг хот",
      "buName": "ကင်း မြို့နယ်",
      "khName": "ទីប្រជុំជន គីន",
      "neName": "किन नगर"
    }
  },
  "4731500": {
    "office": {
      "code": "471000",
      "name": "沖縄本島地方",
      "enName": "Okinawa Main Island",
      "officeName": "沖縄気象台",
      "chName": "沖繩本島地區",
      "zhName": "冲绳本岛地区",
      "koName": "오키나와 본섬 지방",
      "esName": "Región de la isla principal de Okinawa",
      "ptName": "Região da ilha principal de Okinawa",
      "thName": "ภูมิภาคเกาะหลักของโอกินาว่า",
      "viName": "Vùng đảo chính Okinawa",
      "inName": "Wilayah pulau utama Okinawa",
      "tlName": "Pangunahing isla na rehiyon ng Okinawa",
      "moName": "Окинава арлын гол бүс нутаг",
      "buName": "အိုကီနာဝါ အဓိကကျွန်းဒေသ",
      "khName": "តំបន់កោះសំខាន់របស់អូគីណាវ៉ា",
      "neName": "ओकिनावा मुख्य टापु क्षेत्र"
    },
    "class10": {
      "code": "471020",
      "name": "本島北部",
      "enName": "Northern Main Island",
      "chName": "北部主島",
      "zhName": "北部主岛",
      "koName": "본섬 북부",
      "esName": "Isla principal del norte",
      "ptName": "Ilha principal do norte",
      "thName": "เกาะหลักทางตอนเหนือ",
      "viName": "Đảo chính phía Bắc",
      "inName": "Pulau utama utara",
      "tlName": "Hilagang pangunahing isla",
      "moName": "Хойд гол арал",
      "buName": "မြောက်ဘက် အဓိကကျွန်း",
      "khName": "កោះសំខាន់ខាងជើង",
      "neName": "उत्तरी मुख्य टापु"
    },
    "class15": {
      "code": "471023",
      "name": "名護地区",
      "enName": "Nago District"
    },
    "class20": {
      "code": "4731500",
      "name": "伊江村",
      "enName": "Ie Village",
      "kana": "いえそん",
      "chName": "伊江村",
      "zhName": "伊江村",
      "koName": "이에 촌",
      "esName": "Aldea de Ie",
      "ptName": "povoado de Ie",
      "thName": "หมู่บ้านอิเอะ",
      "viName": "làng Ie",
      "inName": "desa Ie",
      "tlName": "nayon ng Ie",
      "moName": "Иэ тосгон",
      "buName": "အားယိ ကျေးရွာ",
      "khName": "ភូមិ អាយអ៊ី",
      "neName": "आइए गाउँ"
    }
  },
  "4732400": {
    "office": {
      "code": "471000",
      "name": "沖縄本島地方",
      "enName": "Okinawa Main Island",
      "officeName": "沖縄気象台",
      "chName": "沖繩本島地區",
      "zhName": "冲绳本岛地区",
      "koName": "오키나와 본섬 지방",
      "esName": "Región de la isla principal de Okinawa",
      "ptName": "Região da ilha principal de Okinawa",
      "thName": "ภูมิภาคเกาะหลักของโอกินาว่า",
      "viName": "Vùng đảo chính Okinawa",
      "inName": "Wilayah pulau utama Okinawa",
      "tlName": "Pangunahing isla na rehiyon ng Okinawa",
      "moName": "Окинава арлын гол бүс нутаг",
      "buName": "အိုကီနာဝါ အဓိကကျွန်းဒေသ",
      "khName": "តំបន់កោះសំខាន់របស់អូគីណាវ៉ា",
      "neName": "ओकिनावा मुख्य टापु क्षेत्र"
    },
    "class10": {
      "code": "471010",
      "name": "本島中南部",
      "enName": "Central and Southern Main Island",
      "chName": "主島中部和南部",
      "zhName": "主岛中部和南部",
      "koName": "본섬 중남부",
      "esName": "Isla principal central y sur",
      "ptName": "Ilha principal central e sul",
      "thName": "เกาะหลักตอนกลางและตอนใต้",
      "viName": "Đảo chính miền Trung và miền Nam",
      "inName": "Pulau utama tengah dan selatan",
      "tlName": "Pangunahing isla sa gitna at timog",
      "moName": "Төв ба өмнөд гол арал",
      "buName": "အလယ်ပိုင်းနှင့် တောင်ပိုင်း အဓိကကျွန်း",
      "khName": "កោះកណ្តាលនិងខាងត្បូង",
      "neName": "मध्य र दक्षिणी मुख्य टापु"
    },
    "class15": {
      "code": "471012",
      "name": "中部",
      "enName": "Central Region"
    },
    "class20": {
      "code": "4732400",
      "name": "読谷村",
      "enName": "Yomitan Village",
      "kana": "よみたんそん",
      "chName": "读谷村",
      "zhName": "讀谷村",
      "koName": "요미탄 촌",
      "esName": "Aldea de Yomitan",
      "ptName": "povoado de Yomitan",
      "thName": "หมู่บ้านโยมิตัน",
      "viName": "làng Yomitan",
      "inName": "desa Yomitan",
      "tlName": "nayon ng Yomitan",
      "moName": "Ёмитан тосгон",
      "buName": "ယော်မိတန်း ကျေးရွာ",
      "khName": "ភូមិ យ៉ូមីតាន់",
      "neName": "योमितान गाउँ"
    }
  },
  "4732500": {
    "office": {
      "code": "471000",
      "name": "沖縄本島地方",
      "enName": "Okinawa Main Island",
      "officeName": "沖縄気象台",
      "chName": "沖繩本島地區",
      "zhName": "冲绳本岛地区",
      "koName": "오키나와 본섬 지방",
      "esName": "Región de la isla principal de Okinawa",
      "ptName": "Região da ilha principal de Okinawa",
      "thName": "ภูมิภาคเกาะหลักของโอกินาว่า",
      "viName": "Vùng đảo chính Okinawa",
      "inName": "Wilayah pulau utama Okinawa",
      "tlName": "Pangunahing isla na rehiyon ng Okinawa",
      "moName": "Окинава арлын гол бүс нутаг",
      "buName": "အိုကီနာဝါ အဓိကကျွန်းဒေသ",
      "khName": "តំបន់កោះសំខាន់របស់អូគីណាវ៉ា",
      "neName": "ओकिनावा मुख्य टापु क्षेत्र"
    },
    "class10": {
      "code": "471010",
      "name": "本島中南部",
      "enName": "Central and Southern Main Island",
      "chName": "主島中部和南部",
      "zhName": "主岛中部和南部",
      "koName": "본섬 중남부",
      "esName": "Isla principal central y sur",
      "ptName": "Ilha principal central e sul",
      "thName": "เกาะหลักตอนกลางและตอนใต้",
      "viName": "Đảo chính miền Trung và miền Nam",
      "inName": "Pulau utama tengah dan selatan",
      "tlName": "Pangunahing isla sa gitna at timog",
      "moName": "Төв ба өмнөд гол арал",
      "buName": "အလယ်ပိုင်းနှင့် တောင်ပိုင်း အဓိကကျွန်း",
      "khName": "កោះកណ្តាលនិងខាងត្បូង",
      "neName": "मध्य र दक्षिणी मुख्य टापु"
    },
    "class15": {
      "code": "471012",
      "name": "中部",
      "enName": "Central Region"
    },
    "class20": {
      "code": "4732500",
      "name": "嘉手納町",
      "enName": "Kadena Town",
      "kana": "かでなちょう",
      "chName": "嘉手纳町",
      "zhName": "嘉手納町",
      "koName": "가데나 정",
      "esName": "Pueblo de Kadena",
      "ptName": "bairro de Kadena",
      "thName": "เมืองคาเดนะ",
      "viName": "thị trấn Kadena",
      "inName": "kota Kadena",
      "tlName": "bayan ng Kadena",
      "moName": "Кадэнa жижиг хот",
      "buName": "ခါးဒဲ့န မြို့နယ်",
      "khName": "ទីប្រជុំជន កាដេណា",
      "neName": "कादेना नगर"
    }
  },
  "4732600": {
    "office": {
      "code": "471000",
      "name": "沖縄本島地方",
      "enName": "Okinawa Main Island",
      "officeName": "沖縄気象台",
      "chName": "沖繩本島地區",
      "zhName": "冲绳本岛地区",
      "koName": "오키나와 본섬 지방",
      "esName": "Región de la isla principal de Okinawa",
      "ptName": "Região da ilha principal de Okinawa",
      "thName": "ภูมิภาคเกาะหลักของโอกินาว่า",
      "viName": "Vùng đảo chính Okinawa",
      "inName": "Wilayah pulau utama Okinawa",
      "tlName": "Pangunahing isla na rehiyon ng Okinawa",
      "moName": "Окинава арлын гол бүс нутаг",
      "buName": "အိုကီနာဝါ အဓိကကျွန်းဒေသ",
      "khName": "តំបន់កោះសំខាន់របស់អូគីណាវ៉ា",
      "neName": "ओकिनावा मुख्य टापु क्षेत्र"
    },
    "class10": {
      "code": "471010",
      "name": "本島中南部",
      "enName": "Central and Southern Main Island",
      "chName": "主島中部和南部",
      "zhName": "主岛中部和南部",
      "koName": "본섬 중남부",
      "esName": "Isla principal central y sur",
      "ptName": "Ilha principal central e sul",
      "thName": "เกาะหลักตอนกลางและตอนใต้",
      "viName": "Đảo chính miền Trung và miền Nam",
      "inName": "Pulau utama tengah dan selatan",
      "tlName": "Pangunahing isla sa gitna at timog",
      "moName": "Төв ба өмнөд гол арал",
      "buName": "အလယ်ပိုင်းနှင့် တောင်ပိုင်း အဓိကကျွန်း",
      "khName": "កោះកណ្តាលនិងខាងត្បូង",
      "neName": "मध्य र दक्षिणी मुख्य टापु"
    },
    "class15": {
      "code": "471012",
      "name": "中部",
      "enName": "Central Region"
    },
    "class20": {
      "code": "4732600",
      "name": "北谷町",
      "enName": "Chatan Town",
      "kana": "ちゃたんちょう",
      "chName": "北谷町",
      "zhName": "北谷町",
      "koName": "자탄 정",
      "esName": "Pueblo de Chatan",
      "ptName": "bairro de Chatan",
      "thName": "เมืองฉะตัน",
      "viName": "thị trấn Chatan",
      "inName": "kota Chatan",
      "tlName": "bayan ng Chatan",
      "moName": "Чaтан жижиг хот",
      "buName": "ချာတန်း မြို့နယ်",
      "khName": "ទីប្រជុំជន ចាតាន់",
      "neName": "चातान नगर"
    }
  },
  "4732700": {
    "office": {
      "code": "471000",
      "name": "沖縄本島地方",
      "enName": "Okinawa Main Island",
      "officeName": "沖縄気象台",
      "chName": "沖繩本島地區",
      "zhName": "冲绳本岛地区",
      "koName": "오키나와 본섬 지방",
      "esName": "Región de la isla principal de Okinawa",
      "ptName": "Região da ilha principal de Okinawa",
      "thName": "ภูมิภาคเกาะหลักของโอกินาว่า",
      "viName": "Vùng đảo chính Okinawa",
      "inName": "Wilayah pulau utama Okinawa",
      "tlName": "Pangunahing isla na rehiyon ng Okinawa",
      "moName": "Окинава арлын гол бүс нутаг",
      "buName": "အိုကီနာဝါ အဓိကကျွန်းဒေသ",
      "khName": "តំបន់កោះសំខាន់របស់អូគីណាវ៉ា",
      "neName": "ओकिनावा मुख्य टापु क्षेत्र"
    },
    "class10": {
      "code": "471010",
      "name": "本島中南部",
      "enName": "Central and Southern Main Island",
      "chName": "主島中部和南部",
      "zhName": "主岛中部和南部",
      "koName": "본섬 중남부",
      "esName": "Isla principal central y sur",
      "ptName": "Ilha principal central e sul",
      "thName": "เกาะหลักตอนกลางและตอนใต้",
      "viName": "Đảo chính miền Trung và miền Nam",
      "inName": "Pulau utama tengah dan selatan",
      "tlName": "Pangunahing isla sa gitna at timog",
      "moName": "Төв ба өмнөд гол арал",
      "buName": "အလယ်ပိုင်းနှင့် တောင်ပိုင်း အဓိကကျွန်း",
      "khName": "កោះកណ្តាលនិងខាងត្បូង",
      "neName": "मध्य र दक्षिणी मुख्य टापु"
    },
    "class15": {
      "code": "471012",
      "name": "中部",
      "enName": "Central Region"
    },
    "class20": {
      "code": "4732700",
      "name": "北中城村",
      "enName": "Kitanakagusuku Village",
      "kana": "きたなかぐすくそん",
      "chName": "北中城村",
      "zhName": "北中城村",
      "koName": "기타나카구스쿠 촌",
      "esName": "Aldea de Kita-Nakagusuku",
      "ptName": "povoado de Kitanakagusuku",
      "thName": "หมู่บ้านคิตะนากางุสึกุ",
      "viName": "làng Kitanakagusuku",
      "inName": "desa Kitanakagusuku",
      "tlName": "nayon ng Kitanakagusuku",
      "moName": "Китанaкагүсүкү тосгон",
      "buName": "ခီတားနာဂါဂုဆုကု ကျေးရွာ",
      "khName": "ភូមិ គីតាណាកាហ្គូស៊ូគូ",
      "neName": "कितानाकागुसुकु गाउँ"
    }
  },
  "4732800": {
    "office": {
      "code": "471000",
      "name": "沖縄本島地方",
      "enName": "Okinawa Main Island",
      "officeName": "沖縄気象台",
      "chName": "沖繩本島地區",
      "zhName": "冲绳本岛地区",
      "koName": "오키나와 본섬 지방",
      "esName": "Región de la isla principal de Okinawa",
      "ptName": "Região da ilha principal de Okinawa",
      "thName": "ภูมิภาคเกาะหลักของโอกินาว่า",
      "viName": "Vùng đảo chính Okinawa",
      "inName": "Wilayah pulau utama Okinawa",
      "tlName": "Pangunahing isla na rehiyon ng Okinawa",
      "moName": "Окинава арлын гол бүс нутаг",
      "buName": "အိုကီနာဝါ အဓိကကျွန်းဒေသ",
      "khName": "តំបន់កោះសំខាន់របស់អូគីណាវ៉ា",
      "neName": "ओकिनावा मुख्य टापु क्षेत्र"
    },
    "class10": {
      "code": "471010",
      "name": "本島中南部",
      "enName": "Central and Southern Main Island",
      "chName": "主島中部和南部",
      "zhName": "主岛中部和南部",
      "koName": "본섬 중남부",
      "esName": "Isla principal central y sur",
      "ptName": "Ilha principal central e sul",
      "thName": "เกาะหลักตอนกลางและตอนใต้",
      "viName": "Đảo chính miền Trung và miền Nam",
      "inName": "Pulau utama tengah dan selatan",
      "tlName": "Pangunahing isla sa gitna at timog",
      "moName": "Төв ба өмнөд гол арал",
      "buName": "အလယ်ပိုင်းနှင့် တောင်ပိုင်း အဓိကကျွန်း",
      "khName": "កោះកណ្តាលនិងខាងត្បូង",
      "neName": "मध्य र दक्षिणी मुख्य टापु"
    },
    "class15": {
      "code": "471012",
      "name": "中部",
      "enName": "Central Region"
    },
    "class20": {
      "code": "4732800",
      "name": "中城村",
      "enName": "Nakagusuku Village",
      "kana": "なかぐすくそん",
      "chName": "中城村",
      "zhName": "中城村",
      "koName": "나카구스쿠 촌",
      "esName": "Aldea de Nakagusuku",
      "ptName": "povoado de Nakagusuku",
      "thName": "หมู่บ้านนากะงุสึกุ",
      "viName": "làng Nakagusuku",
      "inName": "desa Nakagusuku",
      "tlName": "nayon ng Nakagusuku",
      "moName": "Нaкагүсүкү тосгон",
      "buName": "နာကာဂုဆုကု ကျေးရွာ",
      "khName": "ភូមិ ណាកាគុស៊ូគូ",
      "neName": "नाकागुसुकु गाउँ"
    }
  },
  "4732900": {
    "office": {
      "code": "471000",
      "name": "沖縄本島地方",
      "enName": "Okinawa Main Island",
      "officeName": "沖縄気象台",
      "chName": "沖繩本島地區",
      "zhName": "冲绳本岛地区",
      "koName": "오키나와 본섬 지방",
      "esName": "Región de la isla principal de Okinawa",
      "ptName": "Região da ilha principal de Okinawa",
      "thName": "ภูมิภาคเกาะหลักของโอกินาว่า",
      "viName": "Vùng đảo chính Okinawa",
      "inName": "Wilayah pulau utama Okinawa",
      "tlName": "Pangunahing isla na rehiyon ng Okinawa",
      "moName": "Окинава арлын гол бүс нутаг",
      "buName": "အိုကီနာဝါ အဓိကကျွန်းဒေသ",
      "khName": "តំបន់កោះសំខាន់របស់អូគីណាវ៉ា",
      "neName": "ओकिनावा मुख्य टापु क्षेत्र"
    },
    "class10": {
      "code": "471010",
      "name": "本島中南部",
      "enName": "Central and Southern Main Island",
      "chName": "主島中部和南部",
      "zhName": "主岛中部和南部",
      "koName": "본섬 중남부",
      "esName": "Isla principal central y sur",
      "ptName": "Ilha principal central e sul",
      "thName": "เกาะหลักตอนกลางและตอนใต้",
      "viName": "Đảo chính miền Trung và miền Nam",
      "inName": "Pulau utama tengah dan selatan",
      "tlName": "Pangunahing isla sa gitna at timog",
      "moName": "Төв ба өмнөд гол арал",
      "buName": "အလယ်ပိုင်းနှင့် တောင်ပိုင်း အဓိကကျွန်း",
      "khName": "កោះកណ្តាលនិងខាងត្បូង",
      "neName": "मध्य र दक्षिणी मुख्य टापु"
    },
    "class15": {
      "code": "471011",
      "name": "南部",
      "enName": "Southern Region"
    },
    "class20": {
      "code": "4732900",
      "name": "西原町",
      "enName": "Nishihara Town",
      "kana": "にしはらちょう",
      "chName": "西原町",
      "zhName": "西原町",
      "koName": "니시하라 정",
      "esName": "Pueblo de Nishihara",
      "ptName": "bairro de Nishihara",
      "thName": "เมืองนิชิฮาระ",
      "viName": "thị trấn Nishihara",
      "inName": "kota Nishihara",
      "tlName": "bayan ng Nishihara",
      "moName": "Нишихaра жижиг хот",
      "buName": "နီရှိဟားရာ့ မြို့နယ်",
      "khName": "ទីប្រជុំជន នីស៊ីហារ៉ា",
      "neName": "निशिहारा नगर"
    }
  },
  "4734800": {
    "office": {
      "code": "471000",
      "name": "沖縄本島地方",
      "enName": "Okinawa Main Island",
      "officeName": "沖縄気象台",
      "chName": "沖繩本島地區",
      "zhName": "冲绳本岛地区",
      "koName": "오키나와 본섬 지방",
      "esName": "Región de la isla principal de Okinawa",
      "ptName": "Região da ilha principal de Okinawa",
      "thName": "ภูมิภาคเกาะหลักของโอกินาว่า",
      "viName": "Vùng đảo chính Okinawa",
      "inName": "Wilayah pulau utama Okinawa",
      "tlName": "Pangunahing isla na rehiyon ng Okinawa",
      "moName": "Окинава арлын гол бүс нутаг",
      "buName": "အိုကီနာဝါ အဓိကကျွန်းဒေသ",
      "khName": "តំបន់កោះសំខាន់របស់អូគីណាវ៉ា",
      "neName": "ओकिनावा मुख्य टापु क्षेत्र"
    },
    "class10": {
      "code": "471010",
      "name": "本島中南部",
      "enName": "Central and Southern Main Island",
      "chName": "主島中部和南部",
      "zhName": "主岛中部和南部",
      "koName": "본섬 중남부",
      "esName": "Isla principal central y sur",
      "ptName": "Ilha principal central e sul",
      "thName": "เกาะหลักตอนกลางและตอนใต้",
      "viName": "Đảo chính miền Trung và miền Nam",
      "inName": "Pulau utama tengah dan selatan",
      "tlName": "Pangunahing isla sa gitna at timog",
      "moName": "Төв ба өмнөд гол арал",
      "buName": "အလယ်ပိုင်းနှင့် တောင်ပိုင်း အဓိကကျွန်း",
      "khName": "កោះកណ្តាលនិងខាងត្បូង",
      "neName": "मध्य र दक्षिणी मुख्य टापु"
    },
    "class15": {
      "code": "471011",
      "name": "南部",
      "enName": "Southern Region"
    },
    "class20": {
      "code": "4734800",
      "name": "与那原町",
      "enName": "Yonabaru Town",
      "kana": "よなばるちょう",
      "chName": "与那原町",
      "zhName": "與那原町",
      "koName": "요나바루 정",
      "esName": "Pueblo de Yonabaru",
      "ptName": "bairro de Yonabaru",
      "thName": "เมืองโยนาบารุ",
      "viName": "thị trấn Yonabaru",
      "inName": "kota Yonabaru",
      "tlName": "bayan ng Yonabaru",
      "moName": "Ёнaбарү жижиг хот",
      "buName": "ယော်နာဘာ့ရု မြို့နယ်",
      "khName": "ទីប្រជុំជន យ៉ុនណាបារ៊ូ",
      "neName": "योनाबारु नगर"
    }
  },
  "4735000": {
    "office": {
      "code": "471000",
      "name": "沖縄本島地方",
      "enName": "Okinawa Main Island",
      "officeName": "沖縄気象台",
      "chName": "沖繩本島地區",
      "zhName": "冲绳本岛地区",
      "koName": "오키나와 본섬 지방",
      "esName": "Región de la isla principal de Okinawa",
      "ptName": "Região da ilha principal de Okinawa",
      "thName": "ภูมิภาคเกาะหลักของโอกินาว่า",
      "viName": "Vùng đảo chính Okinawa",
      "inName": "Wilayah pulau utama Okinawa",
      "tlName": "Pangunahing isla na rehiyon ng Okinawa",
      "moName": "Окинава арлын гол бүс нутаг",
      "buName": "အိုကီနာဝါ အဓိကကျွန်းဒေသ",
      "khName": "តំបន់កោះសំខាន់របស់អូគីណាវ៉ា",
      "neName": "ओकिनावा मुख्य टापु क्षेत्र"
    },
    "class10": {
      "code": "471010",
      "name": "本島中南部",
      "enName": "Central and Southern Main Island",
      "chName": "主島中部和南部",
      "zhName": "主岛中部和南部",
      "koName": "본섬 중남부",
      "esName": "Isla principal central y sur",
      "ptName": "Ilha principal central e sul",
      "thName": "เกาะหลักตอนกลางและตอนใต้",
      "viName": "Đảo chính miền Trung và miền Nam",
      "inName": "Pulau utama tengah dan selatan",
      "tlName": "Pangunahing isla sa gitna at timog",
      "moName": "Төв ба өмнөд гол арал",
      "buName": "အလယ်ပိုင်းနှင့် တောင်ပိုင်း အဓိကကျွန်း",
      "khName": "កោះកណ្តាលនិងខាងត្បូង",
      "neName": "मध्य र दक्षिणी मुख्य टापु"
    },
    "class15": {
      "code": "471011",
      "name": "南部",
      "enName": "Southern Region"
    },
    "class20": {
      "code": "4735000",
      "name": "南風原町",
      "enName": "Haebaru Town",
      "kana": "はえばるちょう",
      "chName": "南风原町",
      "zhName": "南風原町",
      "koName": "하에바루 정",
      "esName": "Pueblo de Haebaru",
      "ptName": "bairro de Haebaru",
      "thName": "เมืองฮาเอบารุ",
      "viName": "thị trấn Haebaru",
      "inName": "kota Haebaru",
      "tlName": "bayan ng Haebaru",
      "moName": "Хaэбарү жижиг хот",
      "buName": "ဟာအဲဘာ့ရု မြို့နယ်",
      "khName": "ទីប្រជុំជន ហេបារូ",
      "neName": "हाएबारु नगर"
    }
  },
  "4735300": {
    "office": {
      "code": "471000",
      "name": "沖縄本島地方",
      "enName": "Okinawa Main Island",
      "officeName": "沖縄気象台",
      "chName": "沖繩本島地區",
      "zhName": "冲绳本岛地区",
      "koName": "오키나와 본섬 지방",
      "esName": "Región de la isla principal de Okinawa",
      "ptName": "Região da ilha principal de Okinawa",
      "thName": "ภูมิภาคเกาะหลักของโอกินาว่า",
      "viName": "Vùng đảo chính Okinawa",
      "inName": "Wilayah pulau utama Okinawa",
      "tlName": "Pangunahing isla na rehiyon ng Okinawa",
      "moName": "Окинава арлын гол бүс нутаг",
      "buName": "အိုကီနာဝါ အဓိကကျွန်းဒေသ",
      "khName": "តំបន់កោះសំខាន់របស់អូគីណាវ៉ា",
      "neName": "ओकिनावा मुख्य टापु क्षेत्र"
    },
    "class10": {
      "code": "471010",
      "name": "本島中南部",
      "enName": "Central and Southern Main Island",
      "chName": "主島中部和南部",
      "zhName": "主岛中部和南部",
      "koName": "본섬 중남부",
      "esName": "Isla principal central y sur",
      "ptName": "Ilha principal central e sul",
      "thName": "เกาะหลักตอนกลางและตอนใต้",
      "viName": "Đảo chính miền Trung và miền Nam",
      "inName": "Pulau utama tengah dan selatan",
      "tlName": "Pangunahing isla sa gitna at timog",
      "moName": "Төв ба өмнөд гол арал",
      "buName": "အလယ်ပိုင်းနှင့် တောင်ပိုင်း အဓိကကျွန်း",
      "khName": "កោះកណ្តាលនិងខាងត្បូង",
      "neName": "मध्य र दक्षिणी मुख्य टापु"
    },
    "class15": {
      "code": "471013",
      "name": "慶良間・粟国諸島",
      "enName": "Kerama Aguni Islands"
    },
    "class20": {
      "code": "4735300",
      "name": "渡嘉敷村",
      "enName": "Tokashiki Village",
      "kana": "とかしきそん",
      "chName": "渡嘉敷村",
      "zhName": "渡嘉敷村",
      "koName": "도카시키 촌",
      "esName": "Aldea de Tokashiki",
      "ptName": "povoado de Tokashiki",
      "thName": "หมู่บ้านโทคาชิกิ",
      "viName": "làng Tokashiki",
      "inName": "desa Tokashiki",
      "tlName": "nayon ng Tokashiki",
      "moName": "Токашики тосгон",
      "buName": "တိုကားရှိကိ ကျေးရွာ",
      "khName": "ភូមិ តូកាស៊ីគី",
      "neName": "तोकाशिकी गाउँ"
    }
  },
  "4735400": {
    "office": {
      "code": "471000",
      "name": "沖縄本島地方",
      "enName": "Okinawa Main Island",
      "officeName": "沖縄気象台",
      "chName": "沖繩本島地區",
      "zhName": "冲绳本岛地区",
      "koName": "오키나와 본섬 지방",
      "esName": "Región de la isla principal de Okinawa",
      "ptName": "Região da ilha principal de Okinawa",
      "thName": "ภูมิภาคเกาะหลักของโอกินาว่า",
      "viName": "Vùng đảo chính Okinawa",
      "inName": "Wilayah pulau utama Okinawa",
      "tlName": "Pangunahing isla na rehiyon ng Okinawa",
      "moName": "Окинава арлын гол бүс нутаг",
      "buName": "အိုကီနာဝါ အဓိကကျွန်းဒေသ",
      "khName": "តំបន់កោះសំខាន់របស់អូគីណាវ៉ា",
      "neName": "ओकिनावा मुख्य टापु क्षेत्र"
    },
    "class10": {
      "code": "471010",
      "name": "本島中南部",
      "enName": "Central and Southern Main Island",
      "chName": "主島中部和南部",
      "zhName": "主岛中部和南部",
      "koName": "본섬 중남부",
      "esName": "Isla principal central y sur",
      "ptName": "Ilha principal central e sul",
      "thName": "เกาะหลักตอนกลางและตอนใต้",
      "viName": "Đảo chính miền Trung và miền Nam",
      "inName": "Pulau utama tengah dan selatan",
      "tlName": "Pangunahing isla sa gitna at timog",
      "moName": "Төв ба өмнөд гол арал",
      "buName": "အလယ်ပိုင်းနှင့် တောင်ပိုင်း အဓိကကျွန်း",
      "khName": "កោះកណ្តាលនិងខាងត្បូង",
      "neName": "मध्य र दक्षिणी मुख्य टापु"
    },
    "class15": {
      "code": "471013",
      "name": "慶良間・粟国諸島",
      "enName": "Kerama Aguni Islands"
    },
    "class20": {
      "code": "4735400",
      "name": "座間味村",
      "enName": "Zamami Village",
      "kana": "ざまみそん",
      "chName": "座间味村",
      "zhName": "座間味村",
      "koName": "자마미 촌",
      "esName": "Aldea de Zamami",
      "ptName": "povoado de Zamami",
      "thName": "หมู่บ้านซามามิ",
      "viName": "làng Zamami",
      "inName": "desa Zamami",
      "tlName": "nayon ng Zamami",
      "moName": "Зaмaми тосгон",
      "buName": "ဇာမာ့မိ ကျေးရွာ",
      "khName": "ភូមិ ហ្សាម៉ាមី",
      "neName": "जामामी गाउँ"
    }
  },
  "4735500": {
    "office": {
      "code": "471000",
      "name": "沖縄本島地方",
      "enName": "Okinawa Main Island",
      "officeName": "沖縄気象台",
      "chName": "沖繩本島地區",
      "zhName": "冲绳本岛地区",
      "koName": "오키나와 본섬 지방",
      "esName": "Región de la isla principal de Okinawa",
      "ptName": "Região da ilha principal de Okinawa",
      "thName": "ภูมิภาคเกาะหลักของโอกินาว่า",
      "viName": "Vùng đảo chính Okinawa",
      "inName": "Wilayah pulau utama Okinawa",
      "tlName": "Pangunahing isla na rehiyon ng Okinawa",
      "moName": "Окинава арлын гол бүс нутаг",
      "buName": "အိုကီနာဝါ အဓိကကျွန်းဒေသ",
      "khName": "តំបន់កោះសំខាន់របស់អូគីណាវ៉ា",
      "neName": "ओकिनावा मुख्य टापु क्षेत्र"
    },
    "class10": {
      "code": "471010",
      "name": "本島中南部",
      "enName": "Central and Southern Main Island",
      "chName": "主島中部和南部",
      "zhName": "主岛中部和南部",
      "koName": "본섬 중남부",
      "esName": "Isla principal central y sur",
      "ptName": "Ilha principal central e sul",
      "thName": "เกาะหลักตอนกลางและตอนใต้",
      "viName": "Đảo chính miền Trung và miền Nam",
      "inName": "Pulau utama tengah dan selatan",
      "tlName": "Pangunahing isla sa gitna at timog",
      "moName": "Төв ба өмнөд гол арал",
      "buName": "အလယ်ပိုင်းနှင့် တောင်ပိုင်း အဓိကကျွန်း",
      "khName": "កោះកណ្តាលនិងខាងត្បូង",
      "neName": "मध्य र दक्षिणी मुख्य टापु"
    },
    "class15": {
      "code": "471013",
      "name": "慶良間・粟国諸島",
      "enName": "Kerama Aguni Islands"
    },
    "class20": {
      "code": "4735500",
      "name": "粟国村",
      "enName": "Aguni Village",
      "kana": "あぐにそん",
      "chName": "粟国村",
      "zhName": "粟國村",
      "koName": "아구니 촌",
      "esName": "Aldea de Aguni",
      "ptName": "povoado de Aguni",
      "thName": "หมู่บ้านอางุนิ",
      "viName": "làng Aguni",
      "inName": "desa Aguni",
      "tlName": "nayon ng Aguni",
      "moName": "Aгүни тосгон",
      "buName": "အာဂုနိ ကျေးရွာ",
      "khName": "ភូមិ អាហ្គុនី",
      "neName": "आगुनी गाउँ"
    }
  },
  "4735600": {
    "office": {
      "code": "471000",
      "name": "沖縄本島地方",
      "enName": "Okinawa Main Island",
      "officeName": "沖縄気象台",
      "chName": "沖繩本島地區",
      "zhName": "冲绳本岛地区",
      "koName": "오키나와 본섬 지방",
      "esName": "Región de la isla principal de Okinawa",
      "ptName": "Região da ilha principal de Okinawa",
      "thName": "ภูมิภาคเกาะหลักของโอกินาว่า",
      "viName": "Vùng đảo chính Okinawa",
      "inName": "Wilayah pulau utama Okinawa",
      "tlName": "Pangunahing isla na rehiyon ng Okinawa",
      "moName": "Окинава арлын гол бүс нутаг",
      "buName": "အိုကီနာဝါ အဓိကကျွန်းဒေသ",
      "khName": "តំបន់កោះសំខាន់របស់អូគីណាវ៉ា",
      "neName": "ओकिनावा मुख्य टापु क्षेत्र"
    },
    "class10": {
      "code": "471010",
      "name": "本島中南部",
      "enName": "Central and Southern Main Island",
      "chName": "主島中部和南部",
      "zhName": "主岛中部和南部",
      "koName": "본섬 중남부",
      "esName": "Isla principal central y sur",
      "ptName": "Ilha principal central e sul",
      "thName": "เกาะหลักตอนกลางและตอนใต้",
      "viName": "Đảo chính miền Trung và miền Nam",
      "inName": "Pulau utama tengah dan selatan",
      "tlName": "Pangunahing isla sa gitna at timog",
      "moName": "Төв ба өмнөд гол арал",
      "buName": "အလယ်ပိုင်းနှင့် တောင်ပိုင်း အဓိကကျွန်း",
      "khName": "កោះកណ្តាលនិងខាងត្បូង",
      "neName": "मध्य र दक्षिणी मुख्य टापु"
    },
    "class15": {
      "code": "471013",
      "name": "慶良間・粟国諸島",
      "enName": "Kerama Aguni Islands"
    },
    "class20": {
      "code": "4735600",
      "name": "渡名喜村",
      "enName": "Tonaki Village",
      "kana": "となきそん",
      "chName": "渡名喜村",
      "zhName": "渡名喜村",
      "koName": "도나키 촌",
      "esName": "Aldea de Tonaki",
      "ptName": "povoado de Tonaki",
      "thName": "หมู่บ้านโทนางิ",
      "viName": "làng Tonaki",
      "inName": "desa Tonaki",
      "tlName": "nayon ng Tonaki",
      "moName": "Тонaки тосгон",
      "buName": "တိုးနာ့ကိ ကျေးရွာ",
      "khName": "ភូមិ តុណាគី",
      "neName": "तोनाकी गाउँ"
    }
  },
  "4735700": {
    "office": {
      "code": "472000",
      "name": "大東島地方",
      "enName": "Daitojima",
      "officeName": "南大東島地方気象台",
      "chName": "大東島地方",
      "zhName": "大东岛地方",
      "koName": "대동도 장소",
      "esName": "Lugar de la isla Dadong",
      "ptName": "Lugar na Ilha de Dadong",
      "thName": "สถานที่เกาะต้าตง",
      "viName": "vùng Daitojima",
      "inName": "wilayah Daitojima",
      "tlName": "Rehiyon ng Daitojima",
      "moName": "Дайтожима муж",
      "buName": "Daitojima ဒေသ",
      "khName": "តំបន់ Daitojima",
      "neName": "दैतोजिमा क्षेत्र"
    },
    "class10": {
      "code": "472000",
      "name": "大東島地方",
      "enName": "Daitojima Region",
      "chName": "南大东岛近海",
      "zhName": "南大东岛近海",
      "koName": "미나미 다이토 섬 근해",
      "esName": "Mares cercanos de Isla de Minami-Daito",
      "ptName": "Mar perto de Minami-Daitō-jima",
      "thName": "ทะเลบริเวณใกล้เคียงเกาะมินามิไดโตจิมะ",
      "viName": "Vùng ven biển đảo Minami-daitojima",
      "inName": "Laut yang Berdekatan dengan Pulau Minami-daitojima",
      "tlName": "Malapit na dagat ng Minami-Daitojima Island",
      "moName": "Минами-Дайтожима аралд ойр далай",
      "buName": "မိနမိဒိုင်းတိုဂျိမကျွန်း ပင်လယ်အနီး",
      "khName": "តំបន់សមុទ្រក្បែរកោះដៃតូជីម៉ាក់",
      "neName": "मिनामी-दाइतोजिमा टापु नजिकको समुन्द्र"
    },
    "class15": {
      "code": "472000",
      "name": "大東島地方",
      "enName": "Daitojima Region"
    },
    "class20": {
      "code": "4735700",
      "name": "南大東村",
      "enName": "Minamidaito Village",
      "kana": "みなみだいとうそん",
      "chName": "南大东村",
      "zhName": "南大東村",
      "koName": "미나미다이토 촌",
      "esName": "Aldea de Minami-Daitō",
      "ptName": "povoado de Minamidaito",
      "thName": "หมู่บ้านมินามิไดโตะ",
      "viName": "làng Minamidaito",
      "inName": "desa Minamidaito",
      "tlName": "nayon ng Minamidaito",
      "moName": "Минaмидайто тосгон",
      "buName": "မီနားမိဒါယိတို ကျေးရွာ",
      "khName": "ភូមិ មីណាមីដាយតូ",
      "neName": "मिनामिदाइतो गाउँ"
    }
  },
  "4735800": {
    "office": {
      "code": "472000",
      "name": "大東島地方",
      "enName": "Daitojima",
      "officeName": "南大東島地方気象台",
      "chName": "大東島地方",
      "zhName": "大东岛地方",
      "koName": "대동도 장소",
      "esName": "Lugar de la isla Dadong",
      "ptName": "Lugar na Ilha de Dadong",
      "thName": "สถานที่เกาะต้าตง",
      "viName": "vùng Daitojima",
      "inName": "wilayah Daitojima",
      "tlName": "Rehiyon ng Daitojima",
      "moName": "Дайтожима муж",
      "buName": "Daitojima ဒေသ",
      "khName": "តំបន់ Daitojima",
      "neName": "दैतोजिमा क्षेत्र"
    },
    "class10": {
      "code": "472000",
      "name": "大東島地方",
      "enName": "Daitojima Region",
      "chName": "南大东岛近海",
      "zhName": "南大东岛近海",
      "koName": "미나미 다이토 섬 근해",
      "esName": "Mares cercanos de Isla de Minami-Daito",
      "ptName": "Mar perto de Minami-Daitō-jima",
      "thName": "ทะเลบริเวณใกล้เคียงเกาะมินามิไดโตจิมะ",
      "viName": "Vùng ven biển đảo Minami-daitojima",
      "inName": "Laut yang Berdekatan dengan Pulau Minami-daitojima",
      "tlName": "Malapit na dagat ng Minami-Daitojima Island",
      "moName": "Минами-Дайтожима аралд ойр далай",
      "buName": "မိနမိဒိုင်းတိုဂျိမကျွန်း ပင်လယ်အနီး",
      "khName": "តំបន់សមុទ្រក្បែរកោះដៃតូជីម៉ាក់",
      "neName": "मिनामी-दाइतोजिमा टापु नजिकको समुन्द्र"
    },
    "class15": {
      "code": "472000",
      "name": "大東島地方",
      "enName": "Daitojima Region"
    },
    "class20": {
      "code": "4735800",
      "name": "北大東村",
      "enName": "Kitadaito Village",
      "kana": "きただいとうそん",
      "chName": "北大东村",
      "zhName": "北大東村",
      "koName": "기타다이토 촌",
      "esName": "Aldea de Kita-Daitō",
      "ptName": "povoado de Kitadaito",
      "thName": "หมู่บ้านคิตะไดโตะ",
      "viName": "làng Kitadaito",
      "inName": "desa Kitadaito",
      "tlName": "nayon ng Kitadaito",
      "moName": "Китадайто тосгон",
      "buName": "ခီတာဒါယိတို ကျေးရွာ",
      "khName": "ភូមិ គីតាដាយតូ",
      "neName": "कितादाइतो गाउँ"
    }
  },
  "4735900": {
    "office": {
      "code": "471000",
      "name": "沖縄本島地方",
      "enName": "Okinawa Main Island",
      "officeName": "沖縄気象台",
      "chName": "沖繩本島地區",
      "zhName": "冲绳本岛地区",
      "koName": "오키나와 본섬 지방",
      "esName": "Región de la isla principal de Okinawa",
      "ptName": "Região da ilha principal de Okinawa",
      "thName": "ภูมิภาคเกาะหลักของโอกินาว่า",
      "viName": "Vùng đảo chính Okinawa",
      "inName": "Wilayah pulau utama Okinawa",
      "tlName": "Pangunahing isla na rehiyon ng Okinawa",
      "moName": "Окинава арлын гол бүс нутаг",
      "buName": "အိုကီနာဝါ အဓိကကျွန်းဒေသ",
      "khName": "តំបន់កោះសំខាន់របស់អូគីណាវ៉ា",
      "neName": "ओकिनावा मुख्य टापु क्षेत्र"
    },
    "class10": {
      "code": "471020",
      "name": "本島北部",
      "enName": "Northern Main Island",
      "chName": "北部主島",
      "zhName": "北部主岛",
      "koName": "본섬 북부",
      "esName": "Isla principal del norte",
      "ptName": "Ilha principal do norte",
      "thName": "เกาะหลักทางตอนเหนือ",
      "viName": "Đảo chính phía Bắc",
      "inName": "Pulau utama utara",
      "tlName": "Hilagang pangunahing isla",
      "moName": "Хойд гол арал",
      "buName": "မြောက်ဘက် အဓိကကျွန်း",
      "khName": "កោះសំខាន់ខាងជើង",
      "neName": "उत्तरी मुख्य टापु"
    },
    "class15": {
      "code": "471021",
      "name": "伊是名・伊平屋",
      "enName": "Izena Iheya"
    },
    "class20": {
      "code": "4735900",
      "name": "伊平屋村",
      "enName": "Iheya Village",
      "kana": "いへやそん",
      "chName": "伊平屋村",
      "zhName": "伊平屋村",
      "koName": "이헤야 촌",
      "esName": "Aldea de Iheya",
      "ptName": "povoado de Iheya",
      "thName": "หมู่บ้านอิเฮยะ",
      "viName": "làng Iheya",
      "inName": "desa Iheya",
      "tlName": "nayon ng Iheya",
      "moName": "Ихэя тосгон",
      "buName": "အိဟေးရာ့ ကျေးရွာ",
      "khName": "ភូមិ អៃហេយ៉ា",
      "neName": "इहेया गाउँ"
    }
  },
  "4736000": {
    "office": {
      "code": "471000",
      "name": "沖縄本島地方",
      "enName": "Okinawa Main Island",
      "officeName": "沖縄気象台",
      "chName": "沖繩本島地區",
      "zhName": "冲绳本岛地区",
      "koName": "오키나와 본섬 지방",
      "esName": "Región de la isla principal de Okinawa",
      "ptName": "Região da ilha principal de Okinawa",
      "thName": "ภูมิภาคเกาะหลักของโอกินาว่า",
      "viName": "Vùng đảo chính Okinawa",
      "inName": "Wilayah pulau utama Okinawa",
      "tlName": "Pangunahing isla na rehiyon ng Okinawa",
      "moName": "Окинава арлын гол бүс нутаг",
      "buName": "အိုကီနာဝါ အဓိကကျွန်းဒေသ",
      "khName": "តំបន់កោះសំខាន់របស់អូគីណាវ៉ា",
      "neName": "ओकिनावा मुख्य टापु क्षेत्र"
    },
    "class10": {
      "code": "471020",
      "name": "本島北部",
      "enName": "Northern Main Island",
      "chName": "北部主島",
      "zhName": "北部主岛",
      "koName": "본섬 북부",
      "esName": "Isla principal del norte",
      "ptName": "Ilha principal do norte",
      "thName": "เกาะหลักทางตอนเหนือ",
      "viName": "Đảo chính phía Bắc",
      "inName": "Pulau utama utara",
      "tlName": "Hilagang pangunahing isla",
      "moName": "Хойд гол арал",
      "buName": "မြောက်ဘက် အဓိကကျွန်း",
      "khName": "កោះសំខាន់ខាងជើង",
      "neName": "उत्तरी मुख्य टापु"
    },
    "class15": {
      "code": "471021",
      "name": "伊是名・伊平屋",
      "enName": "Izena Iheya"
    },
    "class20": {
      "code": "4736000",
      "name": "伊是名村",
      "enName": "Izena Village",
      "kana": "いぜなそん",
      "chName": "伊是名村",
      "zhName": "伊是名村",
      "koName": "이제나 촌",
      "esName": "Aldea de Izena",
      "ptName": "povoado de Izena",
      "thName": "หมู่บ้านอิเซนะ",
      "viName": "làng Izena",
      "inName": "desa Izena",
      "tlName": "nayon ng Izena",
      "moName": "Изэнa тосгон",
      "buName": "အိဇဲန ကျေးရွာ",
      "khName": "ភូមិ អាយហ្សេណា",
      "neName": "इजेना गाउँ"
    }
  },
  "4736100": {
    "office": {
      "code": "471000",
      "name": "沖縄本島地方",
      "enName": "Okinawa Main Island",
      "officeName": "沖縄気象台",
      "chName": "沖繩本島地區",
      "zhName": "冲绳本岛地区",
      "koName": "오키나와 본섬 지방",
      "esName": "Región de la isla principal de Okinawa",
      "ptName": "Região da ilha principal de Okinawa",
      "thName": "ภูมิภาคเกาะหลักของโอกินาว่า",
      "viName": "Vùng đảo chính Okinawa",
      "inName": "Wilayah pulau utama Okinawa",
      "tlName": "Pangunahing isla na rehiyon ng Okinawa",
      "moName": "Окинава арлын гол бүс нутаг",
      "buName": "အိုကီနာဝါ အဓိကကျွန်းဒေသ",
      "khName": "តំបន់កោះសំខាន់របស់អូគីណាវ៉ា",
      "neName": "ओकिनावा मुख्य टापु क्षेत्र"
    },
    "class10": {
      "code": "471030",
      "name": "久米島",
      "enName": "Kumejima",
      "chName": "久米島",
      "zhName": "久米岛",
      "koName": "쿠메지마",
      "esName": "Kumejima",
      "ptName": "Kumejima",
      "thName": "คุเมจิมะ",
      "viName": "Kumejima",
      "inName": "Kumejima",
      "tlName": "Kumejima",
      "moName": "Кумежима",
      "buName": "Kumejima",
      "khName": "គូមេជីម៉ា",
      "neName": "कुमेजिमा"
    },
    "class15": {
      "code": "471030",
      "name": "久米島",
      "enName": "Kumejima"
    },
    "class20": {
      "code": "4736100",
      "name": "久米島町",
      "enName": "Kumejima Town",
      "kana": "くめじまちょう",
      "chName": "久米岛町",
      "zhName": "久米島町",
      "koName": "구메지마 정",
      "esName": "Pueblo de Kumejima",
      "ptName": "bairro de Kumejima",
      "thName": "เมืองคุเมจิมะ",
      "viName": "thị trấn Kumejima",
      "inName": "kota Kumejima",
      "tlName": "bayan ng Kumejima",
      "moName": "Күмэжимa жижиг хот",
      "buName": "ကူမဲဂျိမ မြို့နယ်",
      "khName": "ទីប្រជុំជន គូមេជីម៉ា",
      "neName": "कुमेजिमा नगर"
    }
  },
  "4736200": {
    "office": {
      "code": "471000",
      "name": "沖縄本島地方",
      "enName": "Okinawa Main Island",
      "officeName": "沖縄気象台",
      "chName": "沖繩本島地區",
      "zhName": "冲绳本岛地区",
      "koName": "오키나와 본섬 지방",
      "esName": "Región de la isla principal de Okinawa",
      "ptName": "Região da ilha principal de Okinawa",
      "thName": "ภูมิภาคเกาะหลักของโอกินาว่า",
      "viName": "Vùng đảo chính Okinawa",
      "inName": "Wilayah pulau utama Okinawa",
      "tlName": "Pangunahing isla na rehiyon ng Okinawa",
      "moName": "Окинава арлын гол бүс нутаг",
      "buName": "အိုကီနာဝါ အဓိကကျွန်းဒေသ",
      "khName": "តំបន់កោះសំខាន់របស់អូគីណាវ៉ា",
      "neName": "ओकिनावा मुख्य टापु क्षेत्र"
    },
    "class10": {
      "code": "471010",
      "name": "本島中南部",
      "enName": "Central and Southern Main Island",
      "chName": "主島中部和南部",
      "zhName": "主岛中部和南部",
      "koName": "본섬 중남부",
      "esName": "Isla principal central y sur",
      "ptName": "Ilha principal central e sul",
      "thName": "เกาะหลักตอนกลางและตอนใต้",
      "viName": "Đảo chính miền Trung và miền Nam",
      "inName": "Pulau utama tengah dan selatan",
      "tlName": "Pangunahing isla sa gitna at timog",
      "moName": "Төв ба өмнөд гол арал",
      "buName": "အလယ်ပိုင်းနှင့် တောင်ပိုင်း အဓိကကျွန်း",
      "khName": "កោះកណ្តាលនិងខាងត្បូង",
      "neName": "मध्य र दक्षिणी मुख्य टापु"
    },
    "class15": {
      "code": "471011",
      "name": "南部",
      "enName": "Southern Region"
    },
    "class20": {
      "code": "4736200",
      "name": "八重瀬町",
      "enName": "Yaese Town",
      "kana": "やえせちょう",
      "chName": "八重濑町",
      "zhName": "八重瀨町",
      "koName": "야에세 정",
      "esName": "Pueblo de Yaese",
      "ptName": "bairro de Yaese",
      "thName": "เมืองยาเอเสะ",
      "viName": "thị trấn Yaese",
      "inName": "kota Yaese",
      "tlName": "bayan ng Yaese",
      "moName": "Яэсэ жижиг хот",
      "buName": "ယာအဲ့ဆဲ့ မြို့နယ်",
      "khName": "ទីប្រជុំជន យ៉ាសេ",
      "neName": "याएसे नगर"
    }
  },
  "4737500": {
    "office": {
      "code": "473000",
      "name": "宮古島地方",
      "enName": "Miyakojima",
      "officeName": "宮古島地方気象台",
      "chName": "宮古島地區",
      "zhName": "宫古岛地区",
      "koName": "미야코지마 지방",
      "esName": "Región de Miyakojima",
      "ptName": "Região de Miyakojima",
      "thName": "ภูมิภาคมิยาโกจิมะ",
      "viName": "vùng Miyakojima",
      "inName": "wilayah Miyakojima",
      "tlName": "Rehiyon ng Miyakojima",
      "moName": "Миякожима муж",
      "buName": "Miyakojima ဒေသ",
      "khName": "តំបន់ Miyakojima",
      "neName": "मियाकोजिमा क्षेत्र"
    },
    "class10": {
      "code": "473000",
      "name": "宮古島地方",
      "enName": "Miyakojima Region",
      "chName": "宮古島地區",
      "zhName": "宫古岛地区",
      "koName": "미야코지마 지방",
      "esName": "Región de Miyakojima",
      "ptName": "Região de Miyakojima",
      "thName": "ภูมิภาคมิยาโกจิมะ",
      "viName": "vùng Miyakojima",
      "inName": "wilayah Miyakojima",
      "tlName": "Rehiyon ng Miyakojima",
      "moName": "Миякожима муж",
      "buName": "Miyakojima ဒေသ",
      "khName": "តំបន់ Miyakojima",
      "neName": "मियाकोजिमा क्षेत्र"
    },
    "class15": {
      "code": "473002",
      "name": "多良間島",
      "enName": "Taramajima"
    },
    "class20": {
      "code": "4737500",
      "name": "多良間村",
      "enName": "Tarama Village",
      "kana": "たらまそん",
      "chName": "多良间村",
      "zhName": "多良間村",
      "koName": "다라마 촌",
      "esName": "Aldea de Tarama",
      "ptName": "povoado de Tarama",
      "thName": "หมู่บ้านทารามะ",
      "viName": "làng Tarama",
      "inName": "desa Tarama",
      "tlName": "nayon ng Tarama",
      "moName": "Тарамa тосгон",
      "buName": "တာရားမ မြို့နယ်",
      "khName": "ភូមិ តារ៉ាម៉ា",
      "neName": "तारामा गाउँ"
    }
  },
  "4738100": {
    "office": {
      "code": "474000",
      "name": "八重山地方",
      "enName": "Yaeyama",
      "officeName": "石垣島地方気象台",
      "chName": "八重山地區",
      "zhName": "八重山地区",
      "koName": "야에야마 지방",
      "esName": "Región de Yaeyama",
      "ptName": "Região de Yaeyama",
      "thName": "ภูมิภาคยาเอยามะ",
      "viName": "vùng Yaeyama",
      "inName": "wilayah Yaeyama",
      "tlName": "rehiyon ng Yaeyama",
      "moName": "Яэйама муж",
      "buName": "Yaeyama ဒေသ",
      "khName": "តំបន់ Yaeyama",
      "neName": "यायामा क्षेत्र"
    },
    "class10": {
      "code": "474010",
      "name": "石垣島地方",
      "enName": "Ishigakijima Region",
      "chName": "石垣島地區, 八重山地區",
      "zhName": "石垣岛地区, 八重山地区",
      "koName": "이시가키지마 지방, 야에야마 지방",
      "esName": "Región de la isla Ishigaki, Región de Yaeyama",
      "ptName": "Região da Ilha Ishigaki, Região de Yaeyama",
      "thName": "ภูมิภาคเกาะอิชิงากิ, ภูมิภาคยาเอยามะ",
      "viName": "Vùng đảo Ishigaki, vùng Yaeyama",
      "inName": "Wilayah Pulau Ishigaki, wilayah Yaeyama",
      "tlName": "Rehiyon ng Isla ng Ishigaki, rehiyon ng Yaeyama",
      "moName": "Ишигаки арлын бүс нутаг, Яэйама муж",
      "buName": "Ishigaki ကျွန်းဒေသ, Yaeyama ဒေသ",
      "khName": "តំបន់កោះ Ishigaki, តំបន់ Yaeyama",
      "neName": "Ishigaki द्वीप क्षेत्र, यायामा क्षेत्र"
    },
    "class15": {
      "code": "474012",
      "name": "竹富町",
      "enName": "Taketomi Town"
    },
    "class20": {
      "code": "4738100",
      "name": "竹富町",
      "enName": "Taketomi Town",
      "kana": "たけとみちょう",
      "chName": "竹富町",
      "zhName": "竹富町",
      "koName": "다케토미 정",
      "esName": "Pueblo de Taketomi",
      "ptName": "bairro de Taketomi",
      "thName": "เมืองทาเคะโทมิ",
      "viName": "thị trấn Taketomi",
      "inName": "kota Taketomi",
      "tlName": "bayan ng Taketomi",
      "moName": "Такэтоми жижиг хот",
      "buName": "တာကဲ့တိုမိ မြို့နယ်",
      "khName": "ទីប្រជុំជន តាកេតូមិ",
      "neName": "ताकेतोमी नगर"
    }
  },
  "4738200": {
    "office": {
      "code": "474000",
      "name": "八重山地方",
      "enName": "Yaeyama",
      "officeName": "石垣島地方気象台",
      "chName": "八重山地區",
      "zhName": "八重山地区",
      "koName": "야에야마 지방",
      "esName": "Región de Yaeyama",
      "ptName": "Região de Yaeyama",
      "thName": "ภูมิภาคยาเอยามะ",
      "viName": "vùng Yaeyama",
      "inName": "wilayah Yaeyama",
      "tlName": "rehiyon ng Yaeyama",
      "moName": "Яэйама муж",
      "buName": "Yaeyama ဒေသ",
      "khName": "តំបន់ Yaeyama",
      "neName": "यायामा क्षेत्र"
    },
    "class10": {
      "code": "474020",
      "name": "与那国島地方",
      "enName": "Yonagunijima Region",
      "chName": "與那國島地區, 八重山地區",
      "zhName": "与那国岛地区, 八重山地区",
      "koName": "요나고쿠지마 지방, 야에야마 지방",
      "esName": "Región de la isla Yonaguni, Región de Yaeyama",
      "ptName": "Região da Ilha Yonaguni, Região de Yaeyama",
      "thName": "ภูมิภาคเกาะโยนากุนิ, ภูมิภาคยาเอยามะ",
      "viName": "Vùng đảo Yonaguni, vùng Yaeyama",
      "inName": "Wilayah Pulau Yonaguni, wilayah Yaeyama",
      "tlName": "Rehiyon ng Isla ng Yonaguni, rehiyon ng Yaeyama",
      "moName": "Йонагуни арлын бүс нутаг, Яэйама муж",
      "buName": "Yonaguni ကျွန်းဒေသ, Yaeyama ဒေသ",
      "khName": "តំបន់កោះ Yonaguni, តំបន់ Yaeyama",
      "neName": "योनागुनी टापु क्षेत्र, यायामा क्षेत्र"
    },
    "class15": {
      "code": "474020",
      "name": "与那国島地方",
      "enName": "Yonagunijima Region"
    },
    "class20": {
      "code": "4738200",
      "name": "与那国町",
      "enName": "Yonaguni Town",
      "kana": "よなぐにちょう",
      "chName": "与那国町",
      "zhName": "與那國町",
      "koName": "요나구니 정",
      "esName": "Pueblo de Yonaguni",
      "ptName": "bairro de Yonaguni",
      "thName": "เมืองโยนางุนิ",
      "viName": "thị trấn Yonaguni",
      "inName": "kota Yonaguni",
      "tlName": "bayan ng Yonaguni",
      "moName": "Ёнaгүни жижиг хот",
      "buName": "ယော်နဂုနိ မြို့နယ်",
      "khName": "ទីប្រជុំជន យ៉ុណាហ្កូនី",
      "neName": "योनागुनी नगर"
    }
  },
  "0110000": {
    "office": {
      "code": "016000",
      "name": "石狩・空知・後志地方",
      "enName": "Ishikari Sorachi Shiribeshi",
      "officeName": "札幌管区気象台",
      "chName": "石駱、空知、石獅地區",
      "zhName": "石狩、空知、石狮地区",
      "koName": "이시카리・공치・고시 지방",
      "esName": "Ishikari, Sorachi, región de Shishi",
      "ptName": "Ishikari, Sorachi, região de Shishi",
      "thName": "อิชิคาริ, โซราจิ, ภูมิภาคชิชิ",
      "viName": "Ishikari, Sorachi, vùng Shishi",
      "inName": "Ishikari, Sorachi, wilayah Shishi",
      "tlName": "Ishikari, Sorachi, rehiyon ng Shishi",
      "moName": "Ишикари, Сорачи, Шиши муж",
      "buName": "Ishikari၊ Sorachi၊ Shishi ဒေသ",
      "khName": "Ishikari, Sorachi, តំបន់ Shishi",
      "neName": "इशिकारी, सोराची, शिशी क्षेत्र"
    },
    "class10": {
      "code": "016010",
      "name": "石狩地方",
      "enName": "Ishikari Region",
      "chName": "石繹地區",
      "zhName": "石狩地区",
      "koName": "이시카리 지방",
      "esName": "Región de Ishikari",
      "ptName": "Região de Ishikari",
      "thName": "ภูมิภาคอิชิการิ",
      "viName": "vùng Ishikari",
      "inName": "wilayah Ishikari",
      "tlName": "Rehiyon ng Ishikari",
      "moName": "Ишикари муж",
      "buName": "Ishikari ဒေသ",
      "khName": "តំបន់ Ishikari",
      "neName": "इशिकारी क्षेत्र"
    },
    "class15": {
      "code": "016012",
      "name": "石狩中部",
      "enName": "Middle Ishikari"
    },
    "class20": {
      "code": "0110000",
      "name": "札幌市",
      "enName": "Sapporo City",
      "kana": "さっぽろし",
      "chName": "札幌市",
      "zhName": "札幌市",
      "koName": "삿포로시",
      "esName": "Ciudad de Sapporo",
      "ptName": "Cidade de Sapporo",
      "thName": "เมืองซัปโปโร",
      "viName": "Thành phố Sapporo",
      "inName": "Kota Sapporo",
      "tlName": "Lungsod ng Sapporo",
      "moName": "Cidade de Sapporo",
      "buName": "ဆပ်ပိုရိုမြို့",
      "khName": "ខេត្តសាប់ប៉ូរ៉ូ",
      "neName": "साप्पोरो सिटी"
    }
  },
  "0120200": {
    "office": {
      "code": "017000",
      "name": "渡島・檜山地方",
      "enName": "Oshima Hiyama",
      "officeName": "函館地方気象台",
      "chName": "大島/檜山地區",
      "zhName": "大岛/桧山地区",
      "koName": "와타시마・히야마 지방",
      "esName": "Región de Oshima/Hiyama",
      "ptName": "Região de Oshima/Hiyama",
      "thName": "ภูมิภาคโอชิมะ/ฮิยามะ",
      "viName": "Vùng Oshima/Hiyama",
      "inName": "Wilayah Oshima/Hiyama",
      "tlName": "Rehiyon ng Oshima/Hiyama",
      "moName": "Ошима/Хияма муж",
      "buName": "Oshima/Hiyama ဒေသ",
      "khName": "តំបន់ Oshima/Hiyama",
      "neName": "ओशिमा/हियामा क्षेत्र"
    },
    "class10": {
      "code": "017010",
      "name": "渡島地方",
      "enName": "Oshima Region",
      "chName": "大島地區",
      "zhName": "大岛地区",
      "koName": "와타시마 지방",
      "esName": "Región de Ōshima",
      "ptName": "Região de Oshima",
      "thName": "ภูมิภาคโอชิมะ",
      "viName": "vùng Oshima",
      "inName": "wilayah Oshima",
      "tlName": "Rehiyon ng Oshima",
      "moName": "Ошима муж",
      "buName": "Oshima ဒေသ",
      "khName": "តំបន់អូស៊ីម៉ា",
      "neName": "ओशिमा क्षेत्र"
    },
    "class15": {
      "code": "017012",
      "name": "渡島東部",
      "enName": "Eastern Oshima"
    },
    "class20": {
      "code": "0120200",
      "name": "函館市",
      "enName": "Hakodate City",
      "kana": "はこだてし",
      "chName": "函馆市",
      "zhName": "函館市",
      "koName": "하코다테 시",
      "esName": "Ciudad de Hakodate",
      "ptName": "cidade de Hakodate",
      "thName": "เมืองฮาโกะดาเตะ",
      "viName": "thành phố Hakodate",
      "inName": "kota Hakodate",
      "tlName": "siyudad ng Hakodate",
      "moName": "Хакодатэ хот",
      "buName": "ဟာကိုးဒါ့တဲ့ မြို့",
      "khName": "ទីក្រុង ហាក់កូដេត",
      "neName": "हाकोदाते सहर"
    }
  },
  "0120300": {
    "office": {
      "code": "016000",
      "name": "石狩・空知・後志地方",
      "enName": "Ishikari Sorachi Shiribeshi",
      "officeName": "札幌管区気象台",
      "chName": "石駱、空知、石獅地區",
      "zhName": "石狩、空知、石狮地区",
      "koName": "이시카리・공치・고시 지방",
      "esName": "Ishikari, Sorachi, región de Shishi",
      "ptName": "Ishikari, Sorachi, região de Shishi",
      "thName": "อิชิคาริ, โซราจิ, ภูมิภาคชิชิ",
      "viName": "Ishikari, Sorachi, vùng Shishi",
      "inName": "Ishikari, Sorachi, wilayah Shishi",
      "tlName": "Ishikari, Sorachi, rehiyon ng Shishi",
      "moName": "Ишикари, Сорачи, Шиши муж",
      "buName": "Ishikari၊ Sorachi၊ Shishi ဒေသ",
      "khName": "Ishikari, Sorachi, តំបន់ Shishi",
      "neName": "इशिकारी, सोराची, शिशी क्षेत्र"
    },
    "class10": {
      "code": "016030",
      "name": "後志地方",
      "enName": "Shiribeshi Region",
      "chName": "石獅地區",
      "zhName": "石狮地区",
      "koName": "고시 지방",
      "esName": "Región de Shishi",
      "ptName": "Região de Shishi",
      "thName": "ภูมิภาคชิชิ",
      "viName": "vùng Shishi",
      "inName": "wilayah Shishi",
      "tlName": "Rehiyon ng Shishi",
      "moName": "Шиши бүс",
      "buName": "Shishi ဒေသ",
      "khName": "តំបន់ Shishi",
      "neName": "शिशि क्षेत्र"
    },
    "class15": {
      "code": "016031",
      "name": "後志北部",
      "enName": "Northern Shiribeshi"
    },
    "class20": {
      "code": "0120300",
      "name": "小樽市",
      "enName": "Otaru City",
      "kana": "おたるし",
      "chName": "小樽市",
      "zhName": "小樽市",
      "koName": "오타루 시",
      "esName": "Ciudad de Otaru",
      "ptName": "cidade de Otaru",
      "thName": "เมืองโอตารุ",
      "viName": "thành phố Otaru",
      "inName": "kota Otaru",
      "tlName": "siyudad ng Otaru",
      "moName": "Отарү хот",
      "buName": "အိုးတာ့ရု မြို့",
      "khName": "ទីក្រុង អូតារុ",
      "neName": "ओतारु सहर"
    }
  },
  "0120400": {
    "office": {
      "code": "012000",
      "name": "上川・留萌地方",
      "enName": "Kamikawa Rumoi",
      "officeName": "旭川地方気象台",
      "chName": "上川/留萌地區",
      "zhName": "上川/留萌地区",
      "koName": "카미카와·루모에 지방",
      "esName": "Región de Kamikawa/Rumoi",
      "ptName": "Região de Kamikawa/Rumoi",
      "thName": "ภูมิภาคคามิคาวะ/รุโมอิ",
      "viName": "Vùng Kamikawa/Rumoi",
      "inName": "Wilayah Kamikawa/Rumoi",
      "tlName": "Rehiyon ng Kamikawa/Rumoi",
      "moName": "Камикава/Румой бүс нутаг",
      "buName": "Kamikawa/Rumoi ဒေသ",
      "khName": "តំបន់ Kamikawa/Rumoi",
      "neName": "कामिकावा/रुमोई क्षेत्र"
    },
    "class10": {
      "code": "012010",
      "name": "上川地方",
      "enName": "Kamikawa Region",
      "chName": "上川地區",
      "zhName": "上川地区",
      "koName": "카미카와 지방",
      "esName": "Región de Kamikawa",
      "ptName": "Região de Kamikawa",
      "thName": "ภูมิภาคคามิคาวะ",
      "viName": "vùng Kamikawa",
      "inName": "wilayah Kamikawa",
      "tlName": "Rehiyon ng Kamikawa",
      "moName": "Камикава муж",
      "buName": "Kamikawa ဒေသ",
      "khName": "តំបន់ Kamikawa",
      "neName": "कामिकावा क्षेत्र"
    },
    "class15": {
      "code": "012012",
      "name": "上川中部",
      "enName": "Middle Kamikawa"
    },
    "class20": {
      "code": "0120400",
      "name": "旭川市",
      "enName": "Asahikawa City",
      "kana": "あさひかわし",
      "chName": "旭川市",
      "zhName": "旭川市",
      "koName": "아사히카와 시",
      "esName": "Ciudad de Asahikawa",
      "ptName": "cidade de Asahikawa",
      "thName": "เมืองอาซาฮิคาวะ",
      "viName": "thành phố Asahikawa",
      "inName": "kota Asahikawa",
      "tlName": "siyudad ng Asahikawa",
      "moName": "Асахикава хот",
      "buName": "အဆားဟိကာ့ဝ မြို့",
      "khName": "ទីក្រុង អាសាហ៊ីកាវ៉ា",
      "neName": "आसाहिकावा सहर"
    }
  },
  "0120500": {
    "office": {
      "code": "015000",
      "name": "胆振・日高地方",
      "enName": "Iburi Hidaka",
      "officeName": "室蘭地方気象台",
      "chName": "膽振/日高地區",
      "zhName": "胆振/日高地区",
      "koName": "담진·히다카 지방",
      "esName": "Región de Iburi/Hidaka",
      "ptName": "Região de Iburi/Hidaka",
      "thName": "ภูมิภาคอิบูริ/ฮิดากะ",
      "viName": "Vùng Iburi/Hidaka",
      "inName": "Wilayah Iburi/Hidaka",
      "tlName": "Rehiyon ng Iburi/Hidaka",
      "moName": "Ибури/Хидака муж",
      "buName": "Iburi/Hidaka ဒေသ",
      "khName": "តំបន់ Iburi/Hidaka",
      "neName": "इबुरी/हिडाका क्षेत्र"
    },
    "class10": {
      "code": "015010",
      "name": "胆振地方",
      "enName": "Iburi Region",
      "chName": "膽振地區",
      "zhName": "胆振地区",
      "koName": "담진지방",
      "esName": "Región de Iburi",
      "ptName": "Região de Iburi",
      "thName": "ภูมิภาคอิบุรี",
      "viName": "vùng Iburi",
      "inName": "wilayah Iburi",
      "tlName": "Rehiyon ng Iburi",
      "moName": "Ибури муж",
      "buName": "Iburi ဒေသ",
      "khName": "តំបន់ Iburi",
      "neName": "इबुरी क्षेत्र"
    },
    "class15": {
      "code": "015012",
      "name": "胆振中部",
      "enName": "Middle Iburi"
    },
    "class20": {
      "code": "0120500",
      "name": "室蘭市",
      "enName": "Muroran City",
      "kana": "むろらんし",
      "chName": "室兰市",
      "zhName": "室蘭市",
      "koName": "무로란 시",
      "esName": "Ciudad de Muroran",
      "ptName": "cidade de Muroran",
      "thName": "เมืองมุโระรัน",
      "viName": "thành phố Muroran",
      "inName": "kota Muroran",
      "tlName": "siyudad ng Muroran",
      "moName": "Мүроран хот",
      "buName": "မူရိုရမ် မြို့",
      "khName": "ទីក្រុង មូរ៉ូរ៉ាន",
      "neName": "मुरोरान सहर"
    }
  },
  "0120601": {
    "office": {
      "code": "014100",
      "name": "釧路・根室地方",
      "enName": "Kushiro Nemuro",
      "officeName": "釧路地方気象台",
      "chName": "釧路/根室地區",
      "zhName": "钏路/根室地区",
      "koName": "구시로·네무로 지방",
      "esName": "Región de Kushiro/Nemuro",
      "ptName": "Região de Kushiro/Nemuro",
      "thName": "ภูมิภาคคุชิโระ/เนมูโระ",
      "viName": "Vùng Kushiro/Nemuro",
      "inName": "Wilayah Kushiro/Nemuro",
      "tlName": "Rehiyon ng Kushiro/Nemuro",
      "moName": "Куширо/Немуро муж",
      "buName": "Kushiro/Nemuro ဒေသ",
      "khName": "តំបន់ Kushiro/Nemuro",
      "neName": "कुशिरो/नेमुरो क्षेत्र"
    },
    "class10": {
      "code": "014020",
      "name": "釧路地方",
      "enName": "Kushiro Region",
      "chName": "釧路地區",
      "zhName": "钏路地区",
      "koName": "구시로 지방",
      "esName": "Región de Kushiro",
      "ptName": "Região de Kushiro",
      "thName": "ภูมิภาคคุชิโระ",
      "viName": "vùng Kushiro",
      "inName": "wilayah Kushiro",
      "tlName": "Rehiyon ng Kushiro",
      "moName": "Куширо муж",
      "buName": "Kushiro ဒေသ",
      "khName": "តំបន់ Kushiro",
      "neName": "कुशिरो क्षेत्र"
    },
    "class15": {
      "code": "014024",
      "name": "釧路南西部",
      "enName": "South-western Kushiro"
    },
    "class20": {
      "code": "0120601",
      "name": "釧路市釧路",
      "enName": "Kushiro, Kushiro City",
      "kana": "くしろしくしろ",
      "chName": "钏路市钏路",
      "zhName": "钏路市钏路",
      "koName": "쿠시로시 쿠시로",
      "esName": "Kushiro, Ciudad de Kushiro",
      "ptName": "Kushiro, Cidade de Kushiro",
      "thName": "คุชิโระ, เมืองคุชิโระ",
      "viName": "Kushiro, Thành phố Kushiro",
      "inName": "Kushiro, Kota Kushiro",
      "tlName": "Kushiro, Lungsod ng Kushiro",
      "moName": "Kushiro, Cidade de Kushiro",
      "buName": "ကူရှီရို၊ ကူရှီရိုမြို့",
      "khName": "ខេត្តកុស៊ីរ៉ូ",
      "neName": "कुशिरो सिटी"
    }
  },
  "0120602": {
    "office": {
      "code": "014100",
      "name": "釧路・根室地方",
      "enName": "Kushiro Nemuro",
      "officeName": "釧路地方気象台",
      "chName": "釧路/根室地區",
      "zhName": "钏路/根室地区",
      "koName": "구시로·네무로 지방",
      "esName": "Región de Kushiro/Nemuro",
      "ptName": "Região de Kushiro/Nemuro",
      "thName": "ภูมิภาคคุชิโระ/เนมูโระ",
      "viName": "Vùng Kushiro/Nemuro",
      "inName": "Wilayah Kushiro/Nemuro",
      "tlName": "Rehiyon ng Kushiro/Nemuro",
      "moName": "Куширо/Немуро муж",
      "buName": "Kushiro/Nemuro ဒေသ",
      "khName": "តំបន់ Kushiro/Nemuro",
      "neName": "कुशिरो/नेमुरो क्षेत्र"
    },
    "class10": {
      "code": "014020",
      "name": "釧路地方",
      "enName": "Kushiro Region",
      "chName": "釧路地區",
      "zhName": "钏路地区",
      "koName": "구시로 지방",
      "esName": "Región de Kushiro",
      "ptName": "Região de Kushiro",
      "thName": "ภูมิภาคคุชิโระ",
      "viName": "vùng Kushiro",
      "inName": "wilayah Kushiro",
      "tlName": "Rehiyon ng Kushiro",
      "moName": "Куширо муж",
      "buName": "Kushiro ဒေသ",
      "khName": "តំបន់ Kushiro",
      "neName": "कुशिरो क्षेत्र"
    },
    "class15": {
      "code": "014022",
      "name": "釧路中部",
      "enName": "Middle Kushiro"
    },
    "class20": {
      "code": "0120602",
      "name": "釧路市阿寒",
      "enName": "Akan, Kushiro City",
      "kana": "くしろしあかん",
      "chName": "钏路市阿寒",
      "zhName": "钏路市阿寒",
      "koName": "쿠시로시 아칸",
      "esName": "Akan, Ciudad de Kushiro",
      "ptName": "Akan, Cidade de Kushiro",
      "thName": "อะกัน, เมืองคุชิโระ",
      "viName": "Akan, Thành phố Kushiro",
      "inName": "Akan, Kota Kushiro",
      "tlName": "Akan, Lungsod ng Kushiro",
      "moName": "Akan, Cidade de Kushiro",
      "buName": "အာကန်၊ ကူရှီရိုမြို့",
      "khName": "ខេត្តអាកាន",
      "neName": "अकन सिटी"
    }
  },
  "0120603": {
    "office": {
      "code": "014100",
      "name": "釧路・根室地方",
      "enName": "Kushiro Nemuro",
      "officeName": "釧路地方気象台",
      "chName": "釧路/根室地區",
      "zhName": "钏路/根室地区",
      "koName": "구시로·네무로 지방",
      "esName": "Región de Kushiro/Nemuro",
      "ptName": "Região de Kushiro/Nemuro",
      "thName": "ภูมิภาคคุชิโระ/เนมูโระ",
      "viName": "Vùng Kushiro/Nemuro",
      "inName": "Wilayah Kushiro/Nemuro",
      "tlName": "Rehiyon ng Kushiro/Nemuro",
      "moName": "Куширо/Немуро муж",
      "buName": "Kushiro/Nemuro ဒေသ",
      "khName": "តំបន់ Kushiro/Nemuro",
      "neName": "कुशिरो/नेमुरो क्षेत्र"
    },
    "class10": {
      "code": "014020",
      "name": "釧路地方",
      "enName": "Kushiro Region",
      "chName": "釧路地區",
      "zhName": "钏路地区",
      "koName": "구시로 지방",
      "esName": "Región de Kushiro",
      "ptName": "Região de Kushiro",
      "thName": "ภูมิภาคคุชิโระ",
      "viName": "vùng Kushiro",
      "inName": "wilayah Kushiro",
      "tlName": "Rehiyon ng Kushiro",
      "moName": "Куширо муж",
      "buName": "Kushiro ဒေသ",
      "khName": "តំបន់ Kushiro",
      "neName": "कुशिरो क्षेत्र"
    },
    "class15": {
      "code": "014024",
      "name": "釧路南西部",
      "enName": "South-western Kushiro"
    },
    "class20": {
      "code": "0120603",
      "name": "釧路市音別",
      "enName": "Onbetsu, Kushiro City",
      "kana": "くしろしおんべつ",
      "chName": "钏路市音别",
      "zhName": "釧路市音別",
      "koName": "쿠시로시 온베츠",
      "esName": "Onbetsu, Ciudad de Kushiro",
      "ptName": "Onbetsu, Cidade de Kushiro",
      "thName": "ออนเบะสึ เมืองคุชิโระ",
      "viName": "Onbetsu, thành phố Kushiro",
      "inName": "Onbetsu, Kota Kushiro",
      "tlName": "Onbetsu, Lungsod ng Kushiro",
      "moName": "Онбецу, Куширо хот",
      "buName": "ကူရှီရိုမြို့၊ အွန်ဘက်ဆု",
      "khName": "អូនបេតស៊ូ, ទីក្រុង គូស៊ីរ៉ូ",
      "neName": "ओनबेत्सु, कुशिरो शहर"
    }
  },
  "0120700": {
    "office": {
      "code": "014030",
      "name": "十勝地方",
      "enName": "Tokachi",
      "officeName": "帯広測候所",
      "chName": "十勝地區",
      "zhName": "十胜地区",
      "koName": "도카치 지방",
      "esName": "Región de Tokachi",
      "ptName": "Região de Tokachi",
      "thName": "ภูมิภาคโทกาจิ",
      "viName": "vùng Tokachi",
      "inName": "wilayah Tokachi",
      "tlName": "Rehiyon ng Tokachi",
      "moName": "Токачи муж",
      "buName": "Tokachi ဒေသ",
      "khName": "តំបន់ Tokachi",
      "neName": "टोकाची क्षेत्र"
    },
    "class10": {
      "code": "014030",
      "name": "十勝地方",
      "enName": "Tokachi Region",
      "chName": "十勝地區",
      "zhName": "十胜地区",
      "koName": "도카치 지방",
      "esName": "Región de Tokachi",
      "ptName": "Região de Tokachi",
      "thName": "ภูมิภาคโทกาจิ",
      "viName": "vùng Tokachi",
      "inName": "wilayah Tokachi",
      "tlName": "Rehiyon ng Tokachi",
      "moName": "Токачи муж",
      "buName": "Tokachi ဒေသ",
      "khName": "តំបន់ Tokachi",
      "neName": "टोकाची क्षेत्र"
    },
    "class15": {
      "code": "014032",
      "name": "十勝中部",
      "enName": "Middle Tokachi"
    },
    "class20": {
      "code": "0120700",
      "name": "帯広市",
      "enName": "Obihiro City",
      "kana": "おびひろし",
      "chName": "带广市",
      "zhName": "帶廣市",
      "koName": "오비히로 시",
      "esName": "Ciudad de Obihiro",
      "ptName": "cidade de Obihiro",
      "thName": "เมืองโอบิฮิโระ",
      "viName": "thành phố Obihiro",
      "inName": "kota Obihiro",
      "tlName": "siyudad ng Obihiro",
      "moName": "Обихиро хот",
      "buName": "အိုဘီဟီးရော့ မြို့",
      "khName": "ទីក្រុង អូប៊ីហ៊ីរ៉ូ",
      "neName": "ओबिहिरो सहर"
    }
  },
  "0120801": {
    "office": {
      "code": "013000",
      "name": "網走・北見・紋別地方",
      "enName": "Abashiri Kitami Mombetsu",
      "officeName": "網走地方気象台",
      "chName": "網走/北見/紋別地區",
      "zhName": "网走/北见/纹别地区",
      "koName": "아바시리 · 기타미 · 몬 베츠 지방",
      "esName": "Región de Abashiri/Kitami/Monbetsu",
      "ptName": "Região de Abashiri/Kitami/Monbetsu",
      "thName": "ภูมิภาคอะบาชิริ/คิตามิ/มงเบ็ตสึ",
      "viName": "Vùng Abashiri/Kitami/Monbetsu",
      "inName": "Wilayah Abashiri/Kitami/Monbetsu",
      "tlName": "Rehiyon ng Abashiri/Kitami/Monbetsu",
      "moName": "Абашири/Китами/Монбетсу бүс нутаг",
      "buName": "Abashiri/Kitami/Monbetsu ဒေသ",
      "khName": "តំបន់ Abashiri/Kitami/Monbetsu",
      "neName": "अबाशिरी/कितामी/मोन्बेटसु क्षेत्र"
    },
    "class10": {
      "code": "013020",
      "name": "北見地方",
      "enName": "Kitami Region",
      "chName": "北见地方",
      "zhName": "北見地方",
      "koName": "키타미 지방",
      "esName": "Región Kitami",
      "ptName": "Região de Kitami",
      "thName": "ท้องถิ่นคิตามิ",
      "viName": "Vùng Kitami",
      "inName": "Daerah Kitami",
      "tlName": "Rehiyon ng Kitami",
      "moName": "Китами муж",
      "buName": "ခိတမိဒေသ၊ ဟိုကိုင်းဒို",
      "khName": "តំបន់គិតាមិ",
      "neName": "कितामी क्षेत्र"
    },
    "class15": {
      "code": "013020",
      "name": "北見地方",
      "enName": "Kitami Region"
    },
    "class20": {
      "code": "0120801",
      "name": "北見市北見",
      "enName": "Kitami, Kitami City",
      "kana": "きたみしきたみ",
      "chName": "北见市北见",
      "zhName": "北见市北见",
      "koName": "키타미시 키타미",
      "esName": "Kitami, Ciudad de Kitami",
      "ptName": "Kitami, Cidade de Kitami",
      "thName": "คิตามิ, เมืองคิตามิ",
      "viName": "Kitami, Thành phố Kitami",
      "inName": "Kitami, Kota Kitami",
      "tlName": "Kitami, Lungsod ng Kitami",
      "moName": "Kitami, Cidade de Kitami",
      "buName": "ကီတာမီ၊ ကီတာမီမြို့",
      "khName": "ខេត្តគីតាមី",
      "neName": "कितामी सिटी"
    }
  },
  "0120802": {
    "office": {
      "code": "013000",
      "name": "網走・北見・紋別地方",
      "enName": "Abashiri Kitami Mombetsu",
      "officeName": "網走地方気象台",
      "chName": "網走/北見/紋別地區",
      "zhName": "网走/北见/纹别地区",
      "koName": "아바시리 · 기타미 · 몬 베츠 지방",
      "esName": "Región de Abashiri/Kitami/Monbetsu",
      "ptName": "Região de Abashiri/Kitami/Monbetsu",
      "thName": "ภูมิภาคอะบาชิริ/คิตามิ/มงเบ็ตสึ",
      "viName": "Vùng Abashiri/Kitami/Monbetsu",
      "inName": "Wilayah Abashiri/Kitami/Monbetsu",
      "tlName": "Rehiyon ng Abashiri/Kitami/Monbetsu",
      "moName": "Абашири/Китами/Монбетсу бүс нутаг",
      "buName": "Abashiri/Kitami/Monbetsu ဒေသ",
      "khName": "តំបន់ Abashiri/Kitami/Monbetsu",
      "neName": "अबाशिरी/कितामी/मोन्बेटसु क्षेत्र"
    },
    "class10": {
      "code": "013010",
      "name": "網走地方",
      "enName": "Abashiri Region",
      "chName": "网走地方",
      "zhName": "網走地方",
      "koName": "아바시리 지방",
      "esName": "Región Abashiri",
      "ptName": "Região de Abashiri",
      "thName": "ท้องถิ่นอะบาชิริ",
      "viName": "Vùng Abashiri",
      "inName": "Daerah Abashiri",
      "tlName": "Rehiyon ng Abashiri",
      "moName": "Абашири муж",
      "buName": "အဘရှိယိဒေသ၊ ဟိုကိုင်းဒို",
      "khName": "តំបន់អាបាស៊ីរី",
      "neName": "आबासिरी क्षेत्र"
    },
    "class15": {
      "code": "013011",
      "name": "網走西部",
      "enName": "Western Abashiri"
    },
    "class20": {
      "code": "0120802",
      "name": "北見市常呂",
      "enName": "Tokoro, Kitami City",
      "kana": "きたみしところ",
      "chName": "北见市常吕",
      "zhName": "北见市常吕",
      "koName": "키타미시 도코로",
      "esName": "Tokoro, Ciudad de Kitami",
      "ptName": "Tokoro, Cidade de Kitami",
      "thName": "โทโคโร, เมืองคิตามิ",
      "viName": "Tokoro, Thành phố Kitami",
      "inName": "Tokoro, Kota Kitami",
      "tlName": "Tokoro, Lungsod ng Kitami",
      "moName": "Tokoro, Cidade de Kitami",
      "buName": "တိုကိုရို၊ ကီတာမီမြို့",
      "khName": "ខេត្តតូកូរ៉ូ",
      "neName": "टोक़ोरो सिटी"
    }
  },
  "0120900": {
    "office": {
      "code": "016000",
      "name": "石狩・空知・後志地方",
      "enName": "Ishikari Sorachi Shiribeshi",
      "officeName": "札幌管区気象台",
      "chName": "石駱、空知、石獅地區",
      "zhName": "石狩、空知、石狮地区",
      "koName": "이시카리・공치・고시 지방",
      "esName": "Ishikari, Sorachi, región de Shishi",
      "ptName": "Ishikari, Sorachi, região de Shishi",
      "thName": "อิชิคาริ, โซราจิ, ภูมิภาคชิชิ",
      "viName": "Ishikari, Sorachi, vùng Shishi",
      "inName": "Ishikari, Sorachi, wilayah Shishi",
      "tlName": "Ishikari, Sorachi, rehiyon ng Shishi",
      "moName": "Ишикари, Сорачи, Шиши муж",
      "buName": "Ishikari၊ Sorachi၊ Shishi ဒေသ",
      "khName": "Ishikari, Sorachi, តំបន់ Shishi",
      "neName": "इशिकारी, सोराची, शिशी क्षेत्र"
    },
    "class10": {
      "code": "016020",
      "name": "空知地方",
      "enName": "Sorachi Region",
      "chName": "空知地區",
      "zhName": "空知地区",
      "koName": "공치지방",
      "esName": "región de sorachi",
      "ptName": "Região de Sorachi",
      "thName": "ภูมิภาคโซราจี",
      "viName": "vùng Sorachi",
      "inName": "wilayah Sorachi",
      "tlName": "Rehiyon ng Sorachi",
      "moName": "Сорачи муж",
      "buName": "ဆိုရာချီဒေသ",
      "khName": "តំបន់សូរ៉ាជី",
      "neName": "सोराची क्षेत्र"
    },
    "class15": {
      "code": "016023",
      "name": "南空知",
      "enName": "Southern Sorachi"
    },
    "class20": {
      "code": "0120900",
      "name": "夕張市",
      "enName": "Yubari City",
      "kana": "ゆうばりし",
      "chName": "夕张市",
      "zhName": "夕張市",
      "koName": "유바리 시",
      "esName": "Ciudad de Yubari",
      "ptName": "cidade de Yubari",
      "thName": "เมืองยุบาริ",
      "viName": "thành phố Yubari",
      "inName": "kota Yubari",
      "tlName": "siyudad ng Yubari",
      "moName": "Юбари хот",
      "buName": "ယူဘရိ မြို့",
      "khName": "ទីក្រុង យូបារី",
      "neName": "युबारी सहर"
    }
  },
  "0121000": {
    "office": {
      "code": "016000",
      "name": "石狩・空知・後志地方",
      "enName": "Ishikari Sorachi Shiribeshi",
      "officeName": "札幌管区気象台",
      "chName": "石駱、空知、石獅地區",
      "zhName": "石狩、空知、石狮地区",
      "koName": "이시카리・공치・고시 지방",
      "esName": "Ishikari, Sorachi, región de Shishi",
      "ptName": "Ishikari, Sorachi, região de Shishi",
      "thName": "อิชิคาริ, โซราจิ, ภูมิภาคชิชิ",
      "viName": "Ishikari, Sorachi, vùng Shishi",
      "inName": "Ishikari, Sorachi, wilayah Shishi",
      "tlName": "Ishikari, Sorachi, rehiyon ng Shishi",
      "moName": "Ишикари, Сорачи, Шиши муж",
      "buName": "Ishikari၊ Sorachi၊ Shishi ဒေသ",
      "khName": "Ishikari, Sorachi, តំបន់ Shishi",
      "neName": "इशिकारी, सोराची, शिशी क्षेत्र"
    },
    "class10": {
      "code": "016020",
      "name": "空知地方",
      "enName": "Sorachi Region",
      "chName": "空知地區",
      "zhName": "空知地区",
      "koName": "공치지방",
      "esName": "región de sorachi",
      "ptName": "Região de Sorachi",
      "thName": "ภูมิภาคโซราจี",
      "viName": "vùng Sorachi",
      "inName": "wilayah Sorachi",
      "tlName": "Rehiyon ng Sorachi",
      "moName": "Сорачи муж",
      "buName": "ဆိုရာချီဒေသ",
      "khName": "តំបន់សូរ៉ាជី",
      "neName": "सोराची क्षेत्र"
    },
    "class15": {
      "code": "016023",
      "name": "南空知",
      "enName": "Southern Sorachi"
    },
    "class20": {
      "code": "0121000",
      "name": "岩見沢市",
      "enName": "Iwamizawa City",
      "kana": "いわみざわし",
      "chName": "岩见泽市",
      "zhName": "岩見澤市",
      "koName": "이와미자와 시",
      "esName": "Ciudad de Iwamizawa",
      "ptName": "cidade de Iwamizawa",
      "thName": "เมืองอิวามิซาวะ",
      "viName": "thành phố Iwamizawa",
      "inName": "kota Iwamizawa",
      "tlName": "siyudad ng Iwamizawa",
      "moName": "Ивамизава хот",
      "buName": "အီဝါမိဇာဝ မြို့",
      "khName": "ទីក្រុង អ៊ីវ៉ាមីសាវ៉ា",
      "neName": "इवामिजावा सहर"
    }
  },
  "0121100": {
    "office": {
      "code": "013000",
      "name": "網走・北見・紋別地方",
      "enName": "Abashiri Kitami Mombetsu",
      "officeName": "網走地方気象台",
      "chName": "網走/北見/紋別地區",
      "zhName": "网走/北见/纹别地区",
      "koName": "아바시리 · 기타미 · 몬 베츠 지방",
      "esName": "Región de Abashiri/Kitami/Monbetsu",
      "ptName": "Região de Abashiri/Kitami/Monbetsu",
      "thName": "ภูมิภาคอะบาชิริ/คิตามิ/มงเบ็ตสึ",
      "viName": "Vùng Abashiri/Kitami/Monbetsu",
      "inName": "Wilayah Abashiri/Kitami/Monbetsu",
      "tlName": "Rehiyon ng Abashiri/Kitami/Monbetsu",
      "moName": "Абашири/Китами/Монбетсу бүс нутаг",
      "buName": "Abashiri/Kitami/Monbetsu ဒေသ",
      "khName": "តំបន់ Abashiri/Kitami/Monbetsu",
      "neName": "अबाशिरी/कितामी/मोन्बेटसु क्षेत्र"
    },
    "class10": {
      "code": "013010",
      "name": "網走地方",
      "enName": "Abashiri Region",
      "chName": "网走地方",
      "zhName": "網走地方",
      "koName": "아바시리 지방",
      "esName": "Región Abashiri",
      "ptName": "Região de Abashiri",
      "thName": "ท้องถิ่นอะบาชิริ",
      "viName": "Vùng Abashiri",
      "inName": "Daerah Abashiri",
      "tlName": "Rehiyon ng Abashiri",
      "moName": "Абашири муж",
      "buName": "အဘရှိယိဒေသ၊ ဟိုကိုင်းဒို",
      "khName": "តំបន់អាបាស៊ីរី",
      "neName": "आबासिरी क्षेत्र"
    },
    "class15": {
      "code": "013011",
      "name": "網走西部",
      "enName": "Western Abashiri"
    },
    "class20": {
      "code": "0121100",
      "name": "網走市",
      "enName": "Abashiri City",
      "kana": "あばしりし",
      "chName": "网走市",
      "zhName": "網走市",
      "koName": "아바시리 시",
      "esName": "Ciudad de Abashiri",
      "ptName": "cidade de Abashiri",
      "thName": "เมืองอะบาชิริ",
      "viName": "thành phố Abashiri",
      "inName": "kota Abashiri",
      "tlName": "siyudad ng Abashiri",
      "moName": "Абашири хот",
      "buName": "အာဗာ့ရှီးရိ မြို့",
      "khName": "ទីក្រុង អាបាស៊ីរី",
      "neName": "आबाशिरी सहर"
    }
  },
  "0121200": {
    "office": {
      "code": "012000",
      "name": "上川・留萌地方",
      "enName": "Kamikawa Rumoi",
      "officeName": "旭川地方気象台",
      "chName": "上川/留萌地區",
      "zhName": "上川/留萌地区",
      "koName": "카미카와·루모에 지방",
      "esName": "Región de Kamikawa/Rumoi",
      "ptName": "Região de Kamikawa/Rumoi",
      "thName": "ภูมิภาคคามิคาวะ/รุโมอิ",
      "viName": "Vùng Kamikawa/Rumoi",
      "inName": "Wilayah Kamikawa/Rumoi",
      "tlName": "Rehiyon ng Kamikawa/Rumoi",
      "moName": "Камикава/Румой бүс нутаг",
      "buName": "Kamikawa/Rumoi ဒေသ",
      "khName": "តំបន់ Kamikawa/Rumoi",
      "neName": "कामिकावा/रुमोई क्षेत्र"
    },
    "class10": {
      "code": "012020",
      "name": "留萌地方",
      "enName": "Rumoi Region",
      "chName": "留萌地區",
      "zhName": "留萌地区",
      "koName": "루모이 지방",
      "esName": "Región de Rumoi",
      "ptName": "Região de Rumoi",
      "thName": "แคว้นรูมอย",
      "viName": "vùng Rumoi",
      "inName": "wilayah Rumoi",
      "tlName": "Rehiyon ng Rumoi",
      "moName": "Румой бүс",
      "buName": "Rumoi ဒေသ",
      "khName": "តំបន់ Rumoi",
      "neName": "रुमोई क्षेत्र"
    },
    "class15": {
      "code": "012023",
      "name": "留萌南部",
      "enName": "Southern Rumoi"
    },
    "class20": {
      "code": "0121200",
      "name": "留萌市",
      "enName": "Rumoi City",
      "kana": "るもいし",
      "chName": "留萌市",
      "zhName": "留萌市",
      "koName": "루모이 시",
      "esName": "Ciudad de Rumoi",
      "ptName": "cidade de Rumoi",
      "thName": "เมืองรูโมอิ",
      "viName": "thành phố Rumoi",
      "inName": "kota Rumoi",
      "tlName": "siyudad ng Rumoi",
      "moName": "Рүмой хот",
      "buName": "ရူမို့အိ မြို့",
      "khName": "ទីក្រុង រូមួយ",
      "neName": "रुमोई सहर"
    }
  },
  "0121300": {
    "office": {
      "code": "015000",
      "name": "胆振・日高地方",
      "enName": "Iburi Hidaka",
      "officeName": "室蘭地方気象台",
      "chName": "膽振/日高地區",
      "zhName": "胆振/日高地区",
      "koName": "담진·히다카 지방",
      "esName": "Región de Iburi/Hidaka",
      "ptName": "Região de Iburi/Hidaka",
      "thName": "ภูมิภาคอิบูริ/ฮิดากะ",
      "viName": "Vùng Iburi/Hidaka",
      "inName": "Wilayah Iburi/Hidaka",
      "tlName": "Rehiyon ng Iburi/Hidaka",
      "moName": "Ибури/Хидака муж",
      "buName": "Iburi/Hidaka ဒေသ",
      "khName": "តំបន់ Iburi/Hidaka",
      "neName": "इबुरी/हिडाका क्षेत्र"
    },
    "class10": {
      "code": "015010",
      "name": "胆振地方",
      "enName": "Iburi Region",
      "chName": "膽振地區",
      "zhName": "胆振地区",
      "koName": "담진지방",
      "esName": "Región de Iburi",
      "ptName": "Região de Iburi",
      "thName": "ภูมิภาคอิบุรี",
      "viName": "vùng Iburi",
      "inName": "wilayah Iburi",
      "tlName": "Rehiyon ng Iburi",
      "moName": "Ибури муж",
      "buName": "Iburi ဒေသ",
      "khName": "តំបន់ Iburi",
      "neName": "इबुरी क्षेत्र"
    },
    "class15": {
      "code": "015012",
      "name": "胆振中部",
      "enName": "Middle Iburi"
    },
    "class20": {
      "code": "0121300",
      "name": "苫小牧市",
      "enName": "Tomakomai City",
      "kana": "とまこまいし",
      "chName": "苫小牧市",
      "zhName": "苫小牧市",
      "koName": "도마코마이 시",
      "esName": "Ciudad de Tomakomai",
      "ptName": "cidade de Tomakomai",
      "thName": "เมืองโทมะโคะมาอิ",
      "viName": "thành phố Tomakomai",
      "inName": "kota Tomakomai",
      "tlName": "siyudad ng Tomakomai",
      "moName": "Томакомай хот",
      "buName": "တိုမားကို့မိုင်း မြို့",
      "khName": "ទីក្រុង តូម៉ាកូម៉ៃ",
      "neName": "तोकाकोमाई सहर"
    }
  },
  "0121400": {
    "office": {
      "code": "011000",
      "name": "宗谷地方",
      "enName": "Soya",
      "officeName": "稚内地方気象台",
      "chName": "大豆地區",
      "zhName": "大豆地区",
      "koName": "소야 지방",
      "esName": "Región de soja",
      "ptName": "Região da soja",
      "thName": "ภูมิภาคถั่วเหลือง",
      "viName": "vùng đậu nành",
      "inName": "wilayah kedelai",
      "tlName": "Rehiyon ng soya",
      "moName": "Шар буурцагны бүс",
      "buName": "ပဲပိစပ်ဒေသ",
      "khName": "តំបន់សណ្តែក",
      "neName": "सोया क्षेत्र"
    },
    "class10": {
      "code": "011000",
      "name": "宗谷地方",
      "enName": "Soya Region",
      "chName": "大豆地區",
      "zhName": "大豆地区",
      "koName": "소야 지방",
      "esName": "Región de soja",
      "ptName": "Região da soja",
      "thName": "ภูมิภาคถั่วเหลือง",
      "viName": "vùng đậu nành",
      "inName": "wilayah kedelai",
      "tlName": "Rehiyon ng soya",
      "moName": "Шар буурцгийн бүс",
      "buName": "ပဲပိစပ်ဒေသ",
      "khName": "តំបន់សណ្តែក",
      "neName": "सोया क्षेत्र"
    },
    "class15": {
      "code": "011011",
      "name": "宗谷北部",
      "enName": "Northern Soya"
    },
    "class20": {
      "code": "0121400",
      "name": "稚内市",
      "enName": "Wakkanai City",
      "kana": "わっかないし",
      "chName": "稚内市",
      "zhName": "稚內市",
      "koName": "왓카나이 시",
      "esName": "Ciudad de Wakkanai",
      "ptName": "cidade de Wakkanai",
      "thName": "เมืองวะคันไน",
      "viName": "thành phố Wakkanai",
      "inName": "kota Wakkanai",
      "tlName": "siyudad ng Wakkanai",
      "moName": "Вакканай хот",
      "buName": "ဝါကားနာယိ မြို့",
      "khName": "ទីក្រុង វ៉ាកកាណៃ",
      "neName": "वाक्कानाई सहर"
    }
  },
  "0121500": {
    "office": {
      "code": "016000",
      "name": "石狩・空知・後志地方",
      "enName": "Ishikari Sorachi Shiribeshi",
      "officeName": "札幌管区気象台",
      "chName": "石駱、空知、石獅地區",
      "zhName": "石狩、空知、石狮地区",
      "koName": "이시카리・공치・고시 지방",
      "esName": "Ishikari, Sorachi, región de Shishi",
      "ptName": "Ishikari, Sorachi, região de Shishi",
      "thName": "อิชิคาริ, โซราจิ, ภูมิภาคชิชิ",
      "viName": "Ishikari, Sorachi, vùng Shishi",
      "inName": "Ishikari, Sorachi, wilayah Shishi",
      "tlName": "Ishikari, Sorachi, rehiyon ng Shishi",
      "moName": "Ишикари, Сорачи, Шиши муж",
      "buName": "Ishikari၊ Sorachi၊ Shishi ဒေသ",
      "khName": "Ishikari, Sorachi, តំបន់ Shishi",
      "neName": "इशिकारी, सोराची, शिशी क्षेत्र"
    },
    "class10": {
      "code": "016020",
      "name": "空知地方",
      "enName": "Sorachi Region",
      "chName": "空知地區",
      "zhName": "空知地区",
      "koName": "공치지방",
      "esName": "región de sorachi",
      "ptName": "Região de Sorachi",
      "thName": "ภูมิภาคโซราจี",
      "viName": "vùng Sorachi",
      "inName": "wilayah Sorachi",
      "tlName": "Rehiyon ng Sorachi",
      "moName": "Сорачи муж",
      "buName": "ဆိုရာချီဒေသ",
      "khName": "តំបន់សូរ៉ាជី",
      "neName": "सोराची क्षेत्र"
    },
    "class15": {
      "code": "016023",
      "name": "南空知",
      "enName": "Southern Sorachi"
    },
    "class20": {
      "code": "0121500",
      "name": "美唄市",
      "enName": "Bibai City",
      "kana": "びばいし",
      "chName": "美呗市",
      "zhName": "美唄市",
      "koName": "비바이 시",
      "esName": "Ciudad de Bibai",
      "ptName": "cidade de Bibai",
      "thName": "เมืองบิไบ",
      "viName": "thành phố Bibai",
      "inName": "kota Bibai",
      "tlName": "siyudad ng Bibai",
      "moName": "Бибай хот",
      "buName": "ဘီးဘ မြို့",
      "khName": "ទីក្រុង ប៊ីបាយ",
      "neName": "बिबाई सहर"
    }
  },
  "0121600": {
    "office": {
      "code": "016000",
      "name": "石狩・空知・後志地方",
      "enName": "Ishikari Sorachi Shiribeshi",
      "officeName": "札幌管区気象台",
      "chName": "石駱、空知、石獅地區",
      "zhName": "石狩、空知、石狮地区",
      "koName": "이시카리・공치・고시 지방",
      "esName": "Ishikari, Sorachi, región de Shishi",
      "ptName": "Ishikari, Sorachi, região de Shishi",
      "thName": "อิชิคาริ, โซราจิ, ภูมิภาคชิชิ",
      "viName": "Ishikari, Sorachi, vùng Shishi",
      "inName": "Ishikari, Sorachi, wilayah Shishi",
      "tlName": "Ishikari, Sorachi, rehiyon ng Shishi",
      "moName": "Ишикари, Сорачи, Шиши муж",
      "buName": "Ishikari၊ Sorachi၊ Shishi ဒေသ",
      "khName": "Ishikari, Sorachi, តំបន់ Shishi",
      "neName": "इशिकारी, सोराची, शिशी क्षेत्र"
    },
    "class10": {
      "code": "016020",
      "name": "空知地方",
      "enName": "Sorachi Region",
      "chName": "空知地區",
      "zhName": "空知地区",
      "koName": "공치지방",
      "esName": "región de sorachi",
      "ptName": "Região de Sorachi",
      "thName": "ภูมิภาคโซราจี",
      "viName": "vùng Sorachi",
      "inName": "wilayah Sorachi",
      "tlName": "Rehiyon ng Sorachi",
      "moName": "Сорачи муж",
      "buName": "ဆိုရာချီဒေသ",
      "khName": "តំបន់សូរ៉ាជី",
      "neName": "सोराची क्षेत्र"
    },
    "class15": {
      "code": "016022",
      "name": "中空知",
      "enName": "Middle Sorachi"
    },
    "class20": {
      "code": "0121600",
      "name": "芦別市",
      "enName": "Ashibetsu City",
      "kana": "あしべつし",
      "chName": "芦别市",
      "zhName": "蘆別市",
      "koName": "아시베쓰 시",
      "esName": "Ciudad de Ashibetsu",
      "ptName": "cidade de Ashibetsu",
      "thName": "เมืองอะชิเบตสึ",
      "viName": "thành phố Ashibetsu",
      "inName": "kota Ashibetsu",
      "tlName": "siyudad ng Ashibetsu",
      "moName": "Ашибецү хот",
      "buName": "အာရှီဗက်စု မြို့",
      "khName": "ទីក្រុង អាស៊ីបេតស៊ូ",
      "neName": "आशिबेत्सु सहर"
    }
  },
  "0121700": {
    "office": {
      "code": "016000",
      "name": "石狩・空知・後志地方",
      "enName": "Ishikari Sorachi Shiribeshi",
      "officeName": "札幌管区気象台",
      "chName": "石駱、空知、石獅地區",
      "zhName": "石狩、空知、石狮地区",
      "koName": "이시카리・공치・고시 지방",
      "esName": "Ishikari, Sorachi, región de Shishi",
      "ptName": "Ishikari, Sorachi, região de Shishi",
      "thName": "อิชิคาริ, โซราจิ, ภูมิภาคชิชิ",
      "viName": "Ishikari, Sorachi, vùng Shishi",
      "inName": "Ishikari, Sorachi, wilayah Shishi",
      "tlName": "Ishikari, Sorachi, rehiyon ng Shishi",
      "moName": "Ишикари, Сорачи, Шиши муж",
      "buName": "Ishikari၊ Sorachi၊ Shishi ဒေသ",
      "khName": "Ishikari, Sorachi, តំបន់ Shishi",
      "neName": "इशिकारी, सोराची, शिशी क्षेत्र"
    },
    "class10": {
      "code": "016010",
      "name": "石狩地方",
      "enName": "Ishikari Region",
      "chName": "石繹地區",
      "zhName": "石狩地区",
      "koName": "이시카리 지방",
      "esName": "Región de Ishikari",
      "ptName": "Região de Ishikari",
      "thName": "ภูมิภาคอิชิการิ",
      "viName": "vùng Ishikari",
      "inName": "wilayah Ishikari",
      "tlName": "Rehiyon ng Ishikari",
      "moName": "Ишикари муж",
      "buName": "Ishikari ဒေသ",
      "khName": "តំបន់ Ishikari",
      "neName": "इशिकारी क्षेत्र"
    },
    "class15": {
      "code": "016012",
      "name": "石狩中部",
      "enName": "Middle Ishikari"
    },
    "class20": {
      "code": "0121700",
      "name": "江別市",
      "enName": "Ebetsu City",
      "kana": "えべつし",
      "chName": "江别市",
      "zhName": "江別市",
      "koName": "에베쓰 시",
      "esName": "Ciudad de Ebetsu",
      "ptName": "cidade de Ebetsu",
      "thName": "เมืองอีเบทซู",
      "viName": "thành phố Ebetsu",
      "inName": "kota Ebetsu",
      "tlName": "siyudad ng Ebetsu",
      "moName": "Эбэцү хот",
      "buName": "အေဗေ့စု မြို့",
      "khName": "ទីក្រុង អេបិតស៊ូ",
      "neName": "इबेत्सु सहर"
    }
  },
  "0121800": {
    "office": {
      "code": "016000",
      "name": "石狩・空知・後志地方",
      "enName": "Ishikari Sorachi Shiribeshi",
      "officeName": "札幌管区気象台",
      "chName": "石駱、空知、石獅地區",
      "zhName": "石狩、空知、石狮地区",
      "koName": "이시카리・공치・고시 지방",
      "esName": "Ishikari, Sorachi, región de Shishi",
      "ptName": "Ishikari, Sorachi, região de Shishi",
      "thName": "อิชิคาริ, โซราจิ, ภูมิภาคชิชิ",
      "viName": "Ishikari, Sorachi, vùng Shishi",
      "inName": "Ishikari, Sorachi, wilayah Shishi",
      "tlName": "Ishikari, Sorachi, rehiyon ng Shishi",
      "moName": "Ишикари, Сорачи, Шиши муж",
      "buName": "Ishikari၊ Sorachi၊ Shishi ဒေသ",
      "khName": "Ishikari, Sorachi, តំបន់ Shishi",
      "neName": "इशिकारी, सोराची, शिशी क्षेत्र"
    },
    "class10": {
      "code": "016020",
      "name": "空知地方",
      "enName": "Sorachi Region",
      "chName": "空知地區",
      "zhName": "空知地区",
      "koName": "공치지방",
      "esName": "región de sorachi",
      "ptName": "Região de Sorachi",
      "thName": "ภูมิภาคโซราจี",
      "viName": "vùng Sorachi",
      "inName": "wilayah Sorachi",
      "tlName": "Rehiyon ng Sorachi",
      "moName": "Сорачи муж",
      "buName": "ဆိုရာချီဒေသ",
      "khName": "តំបន់សូរ៉ាជី",
      "neName": "सोराची क्षेत्र"
    },
    "class15": {
      "code": "016022",
      "name": "中空知",
      "enName": "Middle Sorachi"
    },
    "class20": {
      "code": "0121800",
      "name": "赤平市",
      "enName": "Akabira City",
      "kana": "あかびらし",
      "chName": "赤平市",
      "zhName": "赤平市",
      "koName": "아카비라 시",
      "esName": "Ciudad de Akabira",
      "ptName": "cidade de Akabira",
      "thName": "เมืองอากาบิระ",
      "viName": "thành phố Akabira",
      "inName": "kota Akabira",
      "tlName": "siyudad ng Akabira",
      "moName": "Акабира хот",
      "buName": "အာကဘိရ မြို့",
      "khName": "ទីក្រុង អាកាប៊ីរ៉ា",
      "neName": "आकाबिरा सहर"
    }
  },
  "0121900": {
    "office": {
      "code": "013000",
      "name": "網走・北見・紋別地方",
      "enName": "Abashiri Kitami Mombetsu",
      "officeName": "網走地方気象台",
      "chName": "網走/北見/紋別地區",
      "zhName": "网走/北见/纹别地区",
      "koName": "아바시리 · 기타미 · 몬 베츠 지방",
      "esName": "Región de Abashiri/Kitami/Monbetsu",
      "ptName": "Região de Abashiri/Kitami/Monbetsu",
      "thName": "ภูมิภาคอะบาชิริ/คิตามิ/มงเบ็ตสึ",
      "viName": "Vùng Abashiri/Kitami/Monbetsu",
      "inName": "Wilayah Abashiri/Kitami/Monbetsu",
      "tlName": "Rehiyon ng Abashiri/Kitami/Monbetsu",
      "moName": "Абашири/Китами/Монбетсу бүс нутаг",
      "buName": "Abashiri/Kitami/Monbetsu ဒေသ",
      "khName": "តំបន់ Abashiri/Kitami/Monbetsu",
      "neName": "अबाशिरी/कितामी/मोन्बेटसु क्षेत्र"
    },
    "class10": {
      "code": "013030",
      "name": "紋別地方",
      "enName": "Mombetsu Region",
      "chName": "纹别地方",
      "zhName": "紋別地方",
      "koName": "몬베쓰 지방",
      "esName": "Región Monbetsu",
      "ptName": "Região de Monbetsu",
      "thName": "ท้องถิ่นมมเบ็ตสึ",
      "viName": "Vùng Monbetsu",
      "inName": "Daerah Monbetsu",
      "tlName": "Rehiyon ng Monbetsu",
      "moName": "Монбэцү муж",
      "buName": "မွန်းဘဲဆုဒေသ၊ ဟိုကိုင်းဒို",
      "khName": "តំបន់មុំបែហ្សឹ",
      "neName": "मोन्बेचु क्षेत्र"
    },
    "class15": {
      "code": "013031",
      "name": "紋別北部",
      "enName": "Northern Mombetsu"
    },
    "class20": {
      "code": "0121900",
      "name": "紋別市",
      "enName": "Mombetsu City",
      "kana": "もんべつし",
      "chName": "纹别市",
      "zhName": "紋別市",
      "koName": "몬베츠 시",
      "esName": "Ciudad de Monbetsu",
      "ptName": "cidade de Mombetsu",
      "thName": "เมืองมอนเบ็ทสึ",
      "viName": "thành phố Mombetsu",
      "inName": "kota Mombetsu",
      "tlName": "siyudad ng Mombetsu",
      "moName": "Момбэцү хот",
      "buName": "မွန်းဗေ့စု မြို့",
      "khName": "ទីក្រុង មុំប៊ិតស៊ុ",
      "neName": "मोम्बेत्सु सहर"
    }
  },
  "0122000": {
    "office": {
      "code": "012000",
      "name": "上川・留萌地方",
      "enName": "Kamikawa Rumoi",
      "officeName": "旭川地方気象台",
      "chName": "上川/留萌地區",
      "zhName": "上川/留萌地区",
      "koName": "카미카와·루모에 지방",
      "esName": "Región de Kamikawa/Rumoi",
      "ptName": "Região de Kamikawa/Rumoi",
      "thName": "ภูมิภาคคามิคาวะ/รุโมอิ",
      "viName": "Vùng Kamikawa/Rumoi",
      "inName": "Wilayah Kamikawa/Rumoi",
      "tlName": "Rehiyon ng Kamikawa/Rumoi",
      "moName": "Камикава/Румой бүс нутаг",
      "buName": "Kamikawa/Rumoi ဒေသ",
      "khName": "តំបន់ Kamikawa/Rumoi",
      "neName": "कामिकावा/रुमोई क्षेत्र"
    },
    "class10": {
      "code": "012010",
      "name": "上川地方",
      "enName": "Kamikawa Region",
      "chName": "上川地區",
      "zhName": "上川地区",
      "koName": "카미카와 지방",
      "esName": "Región de Kamikawa",
      "ptName": "Região de Kamikawa",
      "thName": "ภูมิภาคคามิคาวะ",
      "viName": "vùng Kamikawa",
      "inName": "wilayah Kamikawa",
      "tlName": "Rehiyon ng Kamikawa",
      "moName": "Камикава муж",
      "buName": "Kamikawa ဒေသ",
      "khName": "តំបន់ Kamikawa",
      "neName": "कामिकावा क्षेत्र"
    },
    "class15": {
      "code": "012011",
      "name": "上川北部",
      "enName": "Northern Kamikawa"
    },
    "class20": {
      "code": "0122000",
      "name": "士別市",
      "enName": "Shibetsu City",
      "kana": "しべつし",
      "chName": "士别市",
      "zhName": "士別市",
      "koName": "시베쓰 시",
      "esName": "Ciudad de Shibetsu",
      "ptName": "cidade de Shibetsu",
      "thName": "เมืองชิเบ็ทสึ",
      "viName": "thành phố Shibetsu",
      "inName": "kota Shibetsu",
      "tlName": "siyudad ng Shibetsu",
      "moName": "Шибецү хот",
      "buName": "ရှိဗေ့စု မြို့",
      "khName": "ទីក្រុង ស៊ីបេតស៊ុ",
      "neName": "शिबेत्सु सहर"
    }
  },
  "0122100": {
    "office": {
      "code": "012000",
      "name": "上川・留萌地方",
      "enName": "Kamikawa Rumoi",
      "officeName": "旭川地方気象台",
      "chName": "上川/留萌地區",
      "zhName": "上川/留萌地区",
      "koName": "카미카와·루모에 지방",
      "esName": "Región de Kamikawa/Rumoi",
      "ptName": "Região de Kamikawa/Rumoi",
      "thName": "ภูมิภาคคามิคาวะ/รุโมอิ",
      "viName": "Vùng Kamikawa/Rumoi",
      "inName": "Wilayah Kamikawa/Rumoi",
      "tlName": "Rehiyon ng Kamikawa/Rumoi",
      "moName": "Камикава/Румой бүс нутаг",
      "buName": "Kamikawa/Rumoi ဒေသ",
      "khName": "តំបន់ Kamikawa/Rumoi",
      "neName": "कामिकावा/रुमोई क्षेत्र"
    },
    "class10": {
      "code": "012010",
      "name": "上川地方",
      "enName": "Kamikawa Region",
      "chName": "上川地區",
      "zhName": "上川地区",
      "koName": "카미카와 지방",
      "esName": "Región de Kamikawa",
      "ptName": "Região de Kamikawa",
      "thName": "ภูมิภาคคามิคาวะ",
      "viName": "vùng Kamikawa",
      "inName": "wilayah Kamikawa",
      "tlName": "Rehiyon ng Kamikawa",
      "moName": "Камикава муж",
      "buName": "Kamikawa ဒေသ",
      "khName": "តំបន់ Kamikawa",
      "neName": "कामिकावा क्षेत्र"
    },
    "class15": {
      "code": "012011",
      "name": "上川北部",
      "enName": "Northern Kamikawa"
    },
    "class20": {
      "code": "0122100",
      "name": "名寄市",
      "enName": "Nayoro City",
      "kana": "なよろし",
      "chName": "名寄市",
      "zhName": "名寄市",
      "koName": "나요로 시",
      "esName": "Ciudad de Nayoro",
      "ptName": "cidade de Nayoro",
      "thName": "เมืองนาโยโระ",
      "viName": "thành phố Nayoro",
      "inName": "kota Nayoro",
      "tlName": "siyudad ng Nayoro",
      "moName": "Наёро хот",
      "buName": "နားရိုယို မြို့",
      "khName": "ទីក្រុង ណៃយ៉ូរ៉ូ",
      "neName": "नायोरो सहर"
    }
  },
  "0122200": {
    "office": {
      "code": "016000",
      "name": "石狩・空知・後志地方",
      "enName": "Ishikari Sorachi Shiribeshi",
      "officeName": "札幌管区気象台",
      "chName": "石駱、空知、石獅地區",
      "zhName": "石狩、空知、石狮地区",
      "koName": "이시카리・공치・고시 지방",
      "esName": "Ishikari, Sorachi, región de Shishi",
      "ptName": "Ishikari, Sorachi, região de Shishi",
      "thName": "อิชิคาริ, โซราจิ, ภูมิภาคชิชิ",
      "viName": "Ishikari, Sorachi, vùng Shishi",
      "inName": "Ishikari, Sorachi, wilayah Shishi",
      "tlName": "Ishikari, Sorachi, rehiyon ng Shishi",
      "moName": "Ишикари, Сорачи, Шиши муж",
      "buName": "Ishikari၊ Sorachi၊ Shishi ဒေသ",
      "khName": "Ishikari, Sorachi, តំបន់ Shishi",
      "neName": "इशिकारी, सोराची, शिशी क्षेत्र"
    },
    "class10": {
      "code": "016020",
      "name": "空知地方",
      "enName": "Sorachi Region",
      "chName": "空知地區",
      "zhName": "空知地区",
      "koName": "공치지방",
      "esName": "región de sorachi",
      "ptName": "Região de Sorachi",
      "thName": "ภูมิภาคโซราจี",
      "viName": "vùng Sorachi",
      "inName": "wilayah Sorachi",
      "tlName": "Rehiyon ng Sorachi",
      "moName": "Сорачи муж",
      "buName": "ဆိုရာချီဒေသ",
      "khName": "តំបន់សូរ៉ាជី",
      "neName": "सोराची क्षेत्र"
    },
    "class15": {
      "code": "016023",
      "name": "南空知",
      "enName": "Southern Sorachi"
    },
    "class20": {
      "code": "0122200",
      "name": "三笠市",
      "enName": "Mikasa City",
      "kana": "みかさし",
      "chName": "三笠市",
      "zhName": "三笠市",
      "koName": "미카사 시",
      "esName": "Ciudad de Mikasa",
      "ptName": "cidade de Mikasa",
      "thName": "เมืองมิกะซะ",
      "viName": "thành phố Mikasa",
      "inName": "kota Mikasa",
      "tlName": "siyudad ng Mikasa",
      "moName": "Микаса хот",
      "buName": "မီကာ့ဆ မြို့",
      "khName": "ទីក្រុង មីកាសា",
      "neName": "मिकासा सहर"
    }
  },
  "0122300": {
    "office": {
      "code": "014100",
      "name": "釧路・根室地方",
      "enName": "Kushiro Nemuro",
      "officeName": "釧路地方気象台",
      "chName": "釧路/根室地區",
      "zhName": "钏路/根室地区",
      "koName": "구시로·네무로 지방",
      "esName": "Región de Kushiro/Nemuro",
      "ptName": "Região de Kushiro/Nemuro",
      "thName": "ภูมิภาคคุชิโระ/เนมูโระ",
      "viName": "Vùng Kushiro/Nemuro",
      "inName": "Wilayah Kushiro/Nemuro",
      "tlName": "Rehiyon ng Kushiro/Nemuro",
      "moName": "Куширо/Немуро муж",
      "buName": "Kushiro/Nemuro ဒေသ",
      "khName": "តំបន់ Kushiro/Nemuro",
      "neName": "कुशिरो/नेमुरो क्षेत्र"
    },
    "class10": {
      "code": "014010",
      "name": "根室地方",
      "enName": "Nemuro Region",
      "chName": "根室地區",
      "zhName": "根室地区",
      "koName": "네무로 지방",
      "esName": "Región de Nemuro",
      "ptName": "Região de Nemuro",
      "thName": "ภูมิภาคเนมูโระ",
      "viName": "vùng Nemuro",
      "inName": "wilayah Nemuro",
      "tlName": "Rehiyon ng Nemuro",
      "moName": "Немуро бүс",
      "buName": "Nemuro ဒေသ",
      "khName": "តំបន់ Nemuro",
      "neName": "नेमुरो क्षेत्र"
    },
    "class15": {
      "code": "014013",
      "name": "根室南部",
      "enName": "Southern Nemuro"
    },
    "class20": {
      "code": "0122300",
      "name": "根室市",
      "enName": "Nemuro City",
      "kana": "ねむろし",
      "chName": "根室市",
      "zhName": "根室市",
      "koName": "네무로 시",
      "esName": "Ciudad de Nemuro",
      "ptName": "cidade de Nemuro",
      "thName": "เมืองเนมูโระ",
      "viName": "thành phố Nemuro",
      "inName": "kota Nemuro",
      "tlName": "siyudad ng Nemuro",
      "moName": "Нэмүро хот",
      "buName": "နေမုရော့ မြို့",
      "khName": "ទីក្រុង ណែមូរ៉ូ",
      "neName": "नेमुरो सहर"
    }
  },
  "0122400": {
    "office": {
      "code": "016000",
      "name": "石狩・空知・後志地方",
      "enName": "Ishikari Sorachi Shiribeshi",
      "officeName": "札幌管区気象台",
      "chName": "石駱、空知、石獅地區",
      "zhName": "石狩、空知、石狮地区",
      "koName": "이시카리・공치・고시 지방",
      "esName": "Ishikari, Sorachi, región de Shishi",
      "ptName": "Ishikari, Sorachi, região de Shishi",
      "thName": "อิชิคาริ, โซราจิ, ภูมิภาคชิชิ",
      "viName": "Ishikari, Sorachi, vùng Shishi",
      "inName": "Ishikari, Sorachi, wilayah Shishi",
      "tlName": "Ishikari, Sorachi, rehiyon ng Shishi",
      "moName": "Ишикари, Сорачи, Шиши муж",
      "buName": "Ishikari၊ Sorachi၊ Shishi ဒေသ",
      "khName": "Ishikari, Sorachi, តំបន់ Shishi",
      "neName": "इशिकारी, सोराची, शिशी क्षेत्र"
    },
    "class10": {
      "code": "016010",
      "name": "石狩地方",
      "enName": "Ishikari Region",
      "chName": "石繹地區",
      "zhName": "石狩地区",
      "koName": "이시카리 지방",
      "esName": "Región de Ishikari",
      "ptName": "Região de Ishikari",
      "thName": "ภูมิภาคอิชิการิ",
      "viName": "vùng Ishikari",
      "inName": "wilayah Ishikari",
      "tlName": "Rehiyon ng Ishikari",
      "moName": "Ишикари муж",
      "buName": "Ishikari ဒေသ",
      "khName": "តំបន់ Ishikari",
      "neName": "इशिकारी क्षेत्र"
    },
    "class15": {
      "code": "016013",
      "name": "石狩南部",
      "enName": "Southern Ishikari"
    },
    "class20": {
      "code": "0122400",
      "name": "千歳市",
      "enName": "Chitose City",
      "kana": "ちとせし",
      "chName": "千岁市",
      "zhName": "千歲市",
      "koName": "지토세 시",
      "esName": "Ciudad de Chitose",
      "ptName": "cidade de Chitose",
      "thName": "เมืองชิโตเซะ",
      "viName": "thành phố Chitose",
      "inName": "kota Chitose",
      "tlName": "siyudad ng Chitose",
      "moName": "Читозе хот",
      "buName": "ချီတို့ဆဲ့ မြို့",
      "khName": "ទីក្រុង ឈិតថូស",
      "neName": "चितोसे सहर"
    }
  },
  "0122500": {
    "office": {
      "code": "016000",
      "name": "石狩・空知・後志地方",
      "enName": "Ishikari Sorachi Shiribeshi",
      "officeName": "札幌管区気象台",
      "chName": "石駱、空知、石獅地區",
      "zhName": "石狩、空知、石狮地区",
      "koName": "이시카리・공치・고시 지방",
      "esName": "Ishikari, Sorachi, región de Shishi",
      "ptName": "Ishikari, Sorachi, região de Shishi",
      "thName": "อิชิคาริ, โซราจิ, ภูมิภาคชิชิ",
      "viName": "Ishikari, Sorachi, vùng Shishi",
      "inName": "Ishikari, Sorachi, wilayah Shishi",
      "tlName": "Ishikari, Sorachi, rehiyon ng Shishi",
      "moName": "Ишикари, Сорачи, Шиши муж",
      "buName": "Ishikari၊ Sorachi၊ Shishi ဒေသ",
      "khName": "Ishikari, Sorachi, តំបន់ Shishi",
      "neName": "इशिकारी, सोराची, शिशी क्षेत्र"
    },
    "class10": {
      "code": "016020",
      "name": "空知地方",
      "enName": "Sorachi Region",
      "chName": "空知地區",
      "zhName": "空知地区",
      "koName": "공치지방",
      "esName": "región de sorachi",
      "ptName": "Região de Sorachi",
      "thName": "ภูมิภาคโซราจี",
      "viName": "vùng Sorachi",
      "inName": "wilayah Sorachi",
      "tlName": "Rehiyon ng Sorachi",
      "moName": "Сорачи муж",
      "buName": "ဆိုရာချီဒေသ",
      "khName": "តំបន់សូរ៉ាជី",
      "neName": "सोराची क्षेत्र"
    },
    "class15": {
      "code": "016022",
      "name": "中空知",
      "enName": "Middle Sorachi"
    },
    "class20": {
      "code": "0122500",
      "name": "滝川市",
      "enName": "Takikawa City",
      "kana": "たきかわし",
      "chName": "泷川市",
      "zhName": "瀧川市",
      "koName": "다키카와 시",
      "esName": "Ciudad de Takikawa",
      "ptName": "cidade de Takikawa",
      "thName": "เมืองทากิกาวะ",
      "viName": "thành phố Takikawa",
      "inName": "kota Takikawa",
      "tlName": "siyudad ng Takikawa",
      "moName": "Такикава хот",
      "buName": "တာကီဂါ့ဝ မြို့",
      "khName": "ទីក្រុង តាគីកាវ៉ា",
      "neName": "ताकिकावा सहर"
    }
  },
  "0122600": {
    "office": {
      "code": "016000",
      "name": "石狩・空知・後志地方",
      "enName": "Ishikari Sorachi Shiribeshi",
      "officeName": "札幌管区気象台",
      "chName": "石駱、空知、石獅地區",
      "zhName": "石狩、空知、石狮地区",
      "koName": "이시카리・공치・고시 지방",
      "esName": "Ishikari, Sorachi, región de Shishi",
      "ptName": "Ishikari, Sorachi, região de Shishi",
      "thName": "อิชิคาริ, โซราจิ, ภูมิภาคชิชิ",
      "viName": "Ishikari, Sorachi, vùng Shishi",
      "inName": "Ishikari, Sorachi, wilayah Shishi",
      "tlName": "Ishikari, Sorachi, rehiyon ng Shishi",
      "moName": "Ишикари, Сорачи, Шиши муж",
      "buName": "Ishikari၊ Sorachi၊ Shishi ဒေသ",
      "khName": "Ishikari, Sorachi, តំបន់ Shishi",
      "neName": "इशिकारी, सोराची, शिशी क्षेत्र"
    },
    "class10": {
      "code": "016020",
      "name": "空知地方",
      "enName": "Sorachi Region",
      "chName": "空知地區",
      "zhName": "空知地区",
      "koName": "공치지방",
      "esName": "región de sorachi",
      "ptName": "Região de Sorachi",
      "thName": "ภูมิภาคโซราจี",
      "viName": "vùng Sorachi",
      "inName": "wilayah Sorachi",
      "tlName": "Rehiyon ng Sorachi",
      "moName": "Сорачи муж",
      "buName": "ဆိုရာချီဒေသ",
      "khName": "តំបន់សូរ៉ាជី",
      "neName": "सोराची क्षेत्र"
    },
    "class15": {
      "code": "016022",
      "name": "中空知",
      "enName": "Middle Sorachi"
    },
    "class20": {
      "code": "0122600",
      "name": "砂川市",
      "enName": "Sunagawa City",
      "kana": "すながわし",
      "chName": "砂川市",
      "zhName": "砂川市",
      "koName": "스나가와 시",
      "esName": "Ciudad de Sunagawa",
      "ptName": "cidade de Sunagawa",
      "thName": "เมืองซุกะงะวะ",
      "viName": "thành phố Sunagawa",
      "inName": "kota Sunagawa",
      "tlName": "siyudad ng Sunagawa",
      "moName": "Сунагава хот",
      "buName": "ဆူနာဂါ့ဝ မြို့",
      "khName": "ទីក្រុង សាន់ណាហ្កាវ៉ា",
      "neName": "सुनागावा सहर"
    }
  },
  "0122700": {
    "office": {
      "code": "016000",
      "name": "石狩・空知・後志地方",
      "enName": "Ishikari Sorachi Shiribeshi",
      "officeName": "札幌管区気象台",
      "chName": "石駱、空知、石獅地區",
      "zhName": "石狩、空知、石狮地区",
      "koName": "이시카리・공치・고시 지방",
      "esName": "Ishikari, Sorachi, región de Shishi",
      "ptName": "Ishikari, Sorachi, região de Shishi",
      "thName": "อิชิคาริ, โซราจิ, ภูมิภาคชิชิ",
      "viName": "Ishikari, Sorachi, vùng Shishi",
      "inName": "Ishikari, Sorachi, wilayah Shishi",
      "tlName": "Ishikari, Sorachi, rehiyon ng Shishi",
      "moName": "Ишикари, Сорачи, Шиши муж",
      "buName": "Ishikari၊ Sorachi၊ Shishi ဒေသ",
      "khName": "Ishikari, Sorachi, តំបន់ Shishi",
      "neName": "इशिकारी, सोराची, शिशी क्षेत्र"
    },
    "class10": {
      "code": "016020",
      "name": "空知地方",
      "enName": "Sorachi Region",
      "chName": "空知地區",
      "zhName": "空知地区",
      "koName": "공치지방",
      "esName": "región de sorachi",
      "ptName": "Região de Sorachi",
      "thName": "ภูมิภาคโซราจี",
      "viName": "vùng Sorachi",
      "inName": "wilayah Sorachi",
      "tlName": "Rehiyon ng Sorachi",
      "moName": "Сорачи муж",
      "buName": "ဆိုရာချီဒေသ",
      "khName": "តំបន់សូរ៉ាជី",
      "neName": "सोराची क्षेत्र"
    },
    "class15": {
      "code": "016022",
      "name": "中空知",
      "enName": "Middle Sorachi"
    },
    "class20": {
      "code": "0122700",
      "name": "歌志内市",
      "enName": "Utashinai City",
      "kana": "うたしないし",
      "chName": "歌志内市",
      "zhName": "歌志內市",
      "koName": "우타시나이 시",
      "esName": "Ciudad de Utashinai",
      "ptName": "cidade de Utashinai",
      "thName": "เมืองอูทาชิไน",
      "viName": "thành phố Utashinai",
      "inName": "kota Utashinai",
      "tlName": "siyudad ng Utashinai",
      "moName": "Уташинай хот",
      "buName": "အူတရှိနာ့ရိ မြို့",
      "khName": "ទីក្រុង យូសាស៊ីនណៃ",
      "neName": "उताशिनाई सहर"
    }
  },
  "0122800": {
    "office": {
      "code": "016000",
      "name": "石狩・空知・後志地方",
      "enName": "Ishikari Sorachi Shiribeshi",
      "officeName": "札幌管区気象台",
      "chName": "石駱、空知、石獅地區",
      "zhName": "石狩、空知、石狮地区",
      "koName": "이시카리・공치・고시 지방",
      "esName": "Ishikari, Sorachi, región de Shishi",
      "ptName": "Ishikari, Sorachi, região de Shishi",
      "thName": "อิชิคาริ, โซราจิ, ภูมิภาคชิชิ",
      "viName": "Ishikari, Sorachi, vùng Shishi",
      "inName": "Ishikari, Sorachi, wilayah Shishi",
      "tlName": "Ishikari, Sorachi, rehiyon ng Shishi",
      "moName": "Ишикари, Сорачи, Шиши муж",
      "buName": "Ishikari၊ Sorachi၊ Shishi ဒေသ",
      "khName": "Ishikari, Sorachi, តំបន់ Shishi",
      "neName": "इशिकारी, सोराची, शिशी क्षेत्र"
    },
    "class10": {
      "code": "016020",
      "name": "空知地方",
      "enName": "Sorachi Region",
      "chName": "空知地區",
      "zhName": "空知地区",
      "koName": "공치지방",
      "esName": "región de sorachi",
      "ptName": "Região de Sorachi",
      "thName": "ภูมิภาคโซราจี",
      "viName": "vùng Sorachi",
      "inName": "wilayah Sorachi",
      "tlName": "Rehiyon ng Sorachi",
      "moName": "Сорачи муж",
      "buName": "ဆိုရာချီဒေသ",
      "khName": "តំបន់សូរ៉ាជី",
      "neName": "सोराची क्षेत्र"
    },
    "class15": {
      "code": "016021",
      "name": "北空知",
      "enName": "Northern Sorachi"
    },
    "class20": {
      "code": "0122800",
      "name": "深川市",
      "enName": "Fukagawa City",
      "kana": "ふかがわし",
      "chName": "深川市",
      "zhName": "深川市",
      "koName": "후카가와 시",
      "esName": "Ciudad de Fukagawa",
      "ptName": "cidade de Fukagawa",
      "thName": "เมืองฟูคากาว่า",
      "viName": "thành phố Fukagawa",
      "inName": "kota Fukagawa",
      "tlName": "siyudad ng Fukagawa",
      "moName": "Фүкагава хот",
      "buName": "ဖူကားဂါ့ဝ မြို့",
      "khName": "ទីក្រុង ហ្វុកាហ្គាវ៉ា",
      "neName": "फुकागावा सहर"
    }
  },
  "0122900": {
    "office": {
      "code": "012000",
      "name": "上川・留萌地方",
      "enName": "Kamikawa Rumoi",
      "officeName": "旭川地方気象台",
      "chName": "上川/留萌地區",
      "zhName": "上川/留萌地区",
      "koName": "카미카와·루모에 지방",
      "esName": "Región de Kamikawa/Rumoi",
      "ptName": "Região de Kamikawa/Rumoi",
      "thName": "ภูมิภาคคามิคาวะ/รุโมอิ",
      "viName": "Vùng Kamikawa/Rumoi",
      "inName": "Wilayah Kamikawa/Rumoi",
      "tlName": "Rehiyon ng Kamikawa/Rumoi",
      "moName": "Камикава/Румой бүс нутаг",
      "buName": "Kamikawa/Rumoi ဒေသ",
      "khName": "តំបន់ Kamikawa/Rumoi",
      "neName": "कामिकावा/रुमोई क्षेत्र"
    },
    "class10": {
      "code": "012010",
      "name": "上川地方",
      "enName": "Kamikawa Region",
      "chName": "上川地區",
      "zhName": "上川地区",
      "koName": "카미카와 지방",
      "esName": "Región de Kamikawa",
      "ptName": "Região de Kamikawa",
      "thName": "ภูมิภาคคามิคาวะ",
      "viName": "vùng Kamikawa",
      "inName": "wilayah Kamikawa",
      "tlName": "Rehiyon ng Kamikawa",
      "moName": "Камикава муж",
      "buName": "Kamikawa ဒေသ",
      "khName": "តំបន់ Kamikawa",
      "neName": "कामिकावा क्षेत्र"
    },
    "class15": {
      "code": "012013",
      "name": "上川南部",
      "enName": "Southern Kamikawa"
    },
    "class20": {
      "code": "0122900",
      "name": "富良野市",
      "enName": "Furano City",
      "kana": "ふらのし",
      "chName": "富良野市",
      "zhName": "富良野市",
      "koName": "후라노 시",
      "esName": "Ciudad de Furano",
      "ptName": "cidade de Furano",
      "thName": "เมืองฟุราโนะ",
      "viName": "thành phố Furano",
      "inName": "kota Furano",
      "tlName": "siyudad ng Furano",
      "moName": "Фүрано хот",
      "buName": "ဖူရာ့နော့ မြို့",
      "khName": "ទីក្រុង ហ្វូរ៉ាណូ",
      "neName": "फुरानो सहर"
    }
  },
  "0123000": {
    "office": {
      "code": "015000",
      "name": "胆振・日高地方",
      "enName": "Iburi Hidaka",
      "officeName": "室蘭地方気象台",
      "chName": "膽振/日高地區",
      "zhName": "胆振/日高地区",
      "koName": "담진·히다카 지방",
      "esName": "Región de Iburi/Hidaka",
      "ptName": "Região de Iburi/Hidaka",
      "thName": "ภูมิภาคอิบูริ/ฮิดากะ",
      "viName": "Vùng Iburi/Hidaka",
      "inName": "Wilayah Iburi/Hidaka",
      "tlName": "Rehiyon ng Iburi/Hidaka",
      "moName": "Ибури/Хидака муж",
      "buName": "Iburi/Hidaka ဒေသ",
      "khName": "តំបន់ Iburi/Hidaka",
      "neName": "इबुरी/हिडाका क्षेत्र"
    },
    "class10": {
      "code": "015010",
      "name": "胆振地方",
      "enName": "Iburi Region",
      "chName": "膽振地區",
      "zhName": "胆振地区",
      "koName": "담진지방",
      "esName": "Región de Iburi",
      "ptName": "Região de Iburi",
      "thName": "ภูมิภาคอิบุรี",
      "viName": "vùng Iburi",
      "inName": "wilayah Iburi",
      "tlName": "Rehiyon ng Iburi",
      "moName": "Ибури муж",
      "buName": "Iburi ဒေသ",
      "khName": "តំបន់ Iburi",
      "neName": "इबुरी क्षेत्र"
    },
    "class15": {
      "code": "015012",
      "name": "胆振中部",
      "enName": "Middle Iburi"
    },
    "class20": {
      "code": "0123000",
      "name": "登別市",
      "enName": "Noboribetsu City",
      "kana": "のぼりべつし",
      "chName": "登别市",
      "zhName": "登別市",
      "koName": "노보리베쓰 시",
      "esName": "Ciudad de Noboribetsu",
      "ptName": "cidade de Noboribetsu",
      "thName": "เมืองโนโบริเบ็ตสึ",
      "viName": "thành phố Noboribetsu",
      "inName": "kota Noboribetsu",
      "tlName": "siyudad ng Noboribetsu",
      "moName": "Ноборибецү хот",
      "buName": "နိုဘိုရီးဗေ့စု မြို့",
      "khName": "ទីក្រុង ណូបូរីបិតស៊ុ",
      "neName": "नोबोरिबेत्सु सहर"
    }
  },
  "0123100": {
    "office": {
      "code": "016000",
      "name": "石狩・空知・後志地方",
      "enName": "Ishikari Sorachi Shiribeshi",
      "officeName": "札幌管区気象台",
      "chName": "石駱、空知、石獅地區",
      "zhName": "石狩、空知、石狮地区",
      "koName": "이시카리・공치・고시 지방",
      "esName": "Ishikari, Sorachi, región de Shishi",
      "ptName": "Ishikari, Sorachi, região de Shishi",
      "thName": "อิชิคาริ, โซราจิ, ภูมิภาคชิชิ",
      "viName": "Ishikari, Sorachi, vùng Shishi",
      "inName": "Ishikari, Sorachi, wilayah Shishi",
      "tlName": "Ishikari, Sorachi, rehiyon ng Shishi",
      "moName": "Ишикари, Сорачи, Шиши муж",
      "buName": "Ishikari၊ Sorachi၊ Shishi ဒေသ",
      "khName": "Ishikari, Sorachi, តំបន់ Shishi",
      "neName": "इशिकारी, सोराची, शिशी क्षेत्र"
    },
    "class10": {
      "code": "016010",
      "name": "石狩地方",
      "enName": "Ishikari Region",
      "chName": "石繹地區",
      "zhName": "石狩地区",
      "koName": "이시카리 지방",
      "esName": "Región de Ishikari",
      "ptName": "Região de Ishikari",
      "thName": "ภูมิภาคอิชิการิ",
      "viName": "vùng Ishikari",
      "inName": "wilayah Ishikari",
      "tlName": "Rehiyon ng Ishikari",
      "moName": "Ишикари муж",
      "buName": "Ishikari ဒေသ",
      "khName": "តំបន់ Ishikari",
      "neName": "इशिकारी क्षेत्र"
    },
    "class15": {
      "code": "016013",
      "name": "石狩南部",
      "enName": "Southern Ishikari"
    },
    "class20": {
      "code": "0123100",
      "name": "恵庭市",
      "enName": "Eniwa City",
      "kana": "えにわし",
      "chName": "惠庭市",
      "zhName": "惠庭市",
      "koName": "에니와 시",
      "esName": "Ciudad de Eniwa",
      "ptName": "cidade de Eniwa",
      "thName": "เมืองเอนิวะ",
      "viName": "thành phố Eniwa",
      "inName": "kota Eniwa",
      "tlName": "siyudad ng Eniwa",
      "moName": "Энива хот",
      "buName": "အဲနီဝါ့ မြို့",
      "khName": "ទីក្រុង អេនីវ៉ា",
      "neName": "एनिवा सहर"
    }
  },
  "0123301": {
    "office": {
      "code": "015000",
      "name": "胆振・日高地方",
      "enName": "Iburi Hidaka",
      "officeName": "室蘭地方気象台",
      "chName": "膽振/日高地區",
      "zhName": "胆振/日高地区",
      "koName": "담진·히다카 지방",
      "esName": "Región de Iburi/Hidaka",
      "ptName": "Região de Iburi/Hidaka",
      "thName": "ภูมิภาคอิบูริ/ฮิดากะ",
      "viName": "Vùng Iburi/Hidaka",
      "inName": "Wilayah Iburi/Hidaka",
      "tlName": "Rehiyon ng Iburi/Hidaka",
      "moName": "Ибури/Хидака муж",
      "buName": "Iburi/Hidaka ဒေသ",
      "khName": "តំបន់ Iburi/Hidaka",
      "neName": "इबुरी/हिडाका क्षेत्र"
    },
    "class10": {
      "code": "015010",
      "name": "胆振地方",
      "enName": "Iburi Region",
      "chName": "膽振地區",
      "zhName": "胆振地区",
      "koName": "담진지방",
      "esName": "Región de Iburi",
      "ptName": "Região de Iburi",
      "thName": "ภูมิภาคอิบุรี",
      "viName": "vùng Iburi",
      "inName": "wilayah Iburi",
      "tlName": "Rehiyon ng Iburi",
      "moName": "Ибури муж",
      "buName": "Iburi ဒေသ",
      "khName": "តំបន់ Iburi",
      "neName": "इबुरी क्षेत्र"
    },
    "class15": {
      "code": "015011",
      "name": "胆振西部",
      "enName": "Western Iburi"
    },
    "class20": {
      "code": "0123301",
      "name": "伊達市伊達",
      "enName": "Date, Date City",
      "kana": "だてしだて",
      "chName": "伊达市伊达",
      "zhName": "伊达市伊达",
      "koName": "다테시 다테",
      "esName": "Date, Ciudad de Date",
      "ptName": "Date, Cidade de Date",
      "thName": "ดาเตะ, เมืองดาเตะ",
      "viName": "Date, Thành phố Date",
      "inName": "Date, Kota Date",
      "tlName": "Date, Lungsod ng Date",
      "moName": "Date, Cidade de Date",
      "buName": "ဒိတ်၊ ဒိတ်မြို့",
      "khName": "ខេត្តដេត",
      "neName": "डेट सिटी"
    }
  },
  "0123302": {
    "office": {
      "code": "015000",
      "name": "胆振・日高地方",
      "enName": "Iburi Hidaka",
      "officeName": "室蘭地方気象台",
      "chName": "膽振/日高地區",
      "zhName": "胆振/日高地区",
      "koName": "담진·히다카 지방",
      "esName": "Región de Iburi/Hidaka",
      "ptName": "Região de Iburi/Hidaka",
      "thName": "ภูมิภาคอิบูริ/ฮิดากะ",
      "viName": "Vùng Iburi/Hidaka",
      "inName": "Wilayah Iburi/Hidaka",
      "tlName": "Rehiyon ng Iburi/Hidaka",
      "moName": "Ибури/Хидака муж",
      "buName": "Iburi/Hidaka ဒေသ",
      "khName": "តំបន់ Iburi/Hidaka",
      "neName": "इबुरी/हिडाका क्षेत्र"
    },
    "class10": {
      "code": "015010",
      "name": "胆振地方",
      "enName": "Iburi Region",
      "chName": "膽振地區",
      "zhName": "胆振地区",
      "koName": "담진지방",
      "esName": "Región de Iburi",
      "ptName": "Região de Iburi",
      "thName": "ภูมิภาคอิบุรี",
      "viName": "vùng Iburi",
      "inName": "wilayah Iburi",
      "tlName": "Rehiyon ng Iburi",
      "moName": "Ибури муж",
      "buName": "Iburi ဒေသ",
      "khName": "តំបន់ Iburi",
      "neName": "इबुरी क्षेत्र"
    },
    "class15": {
      "code": "015011",
      "name": "胆振西部",
      "enName": "Western Iburi"
    },
    "class20": {
      "code": "0123302",
      "name": "伊達市大滝",
      "enName": "Otaki, Date City",
      "kana": "だてしおおたき",
      "chName": "伊达市大滝",
      "zhName": "伊达市大滝",
      "koName": "다테시 오타키",
      "esName": "Otaki, Ciudad de Date",
      "ptName": "Otaki, Cidade de Date",
      "thName": "โอตากิ, เมืองดาเตะ",
      "viName": "Otaki, Thành phố Date",
      "inName": "Otaki, Kota Date",
      "tlName": "Otaki, Lungsod ng Date",
      "moName": "Otaki, Cidade de Date",
      "buName": "အိုတာကီ၊ ဒိတ်မြို့",
      "khName": "ខេត្តអូតាកី",
      "neName": "ओटाकी सिटी"
    }
  },
  "0123400": {
    "office": {
      "code": "016000",
      "name": "石狩・空知・後志地方",
      "enName": "Ishikari Sorachi Shiribeshi",
      "officeName": "札幌管区気象台",
      "chName": "石駱、空知、石獅地區",
      "zhName": "石狩、空知、石狮地区",
      "koName": "이시카리・공치・고시 지방",
      "esName": "Ishikari, Sorachi, región de Shishi",
      "ptName": "Ishikari, Sorachi, região de Shishi",
      "thName": "อิชิคาริ, โซราจิ, ภูมิภาคชิชิ",
      "viName": "Ishikari, Sorachi, vùng Shishi",
      "inName": "Ishikari, Sorachi, wilayah Shishi",
      "tlName": "Ishikari, Sorachi, rehiyon ng Shishi",
      "moName": "Ишикари, Сорачи, Шиши муж",
      "buName": "Ishikari၊ Sorachi၊ Shishi ဒေသ",
      "khName": "Ishikari, Sorachi, តំបន់ Shishi",
      "neName": "इशिकारी, सोराची, शिशी क्षेत्र"
    },
    "class10": {
      "code": "016010",
      "name": "石狩地方",
      "enName": "Ishikari Region",
      "chName": "石繹地區",
      "zhName": "石狩地区",
      "koName": "이시카리 지방",
      "esName": "Región de Ishikari",
      "ptName": "Região de Ishikari",
      "thName": "ภูมิภาคอิชิการิ",
      "viName": "vùng Ishikari",
      "inName": "wilayah Ishikari",
      "tlName": "Rehiyon ng Ishikari",
      "moName": "Ишикари муж",
      "buName": "Ishikari ဒေသ",
      "khName": "តំបន់ Ishikari",
      "neName": "इशिकारी क्षेत्र"
    },
    "class15": {
      "code": "016013",
      "name": "石狩南部",
      "enName": "Southern Ishikari"
    },
    "class20": {
      "code": "0123400",
      "name": "北広島市",
      "enName": "Kitahiroshima City",
      "kana": "きたひろしまし",
      "chName": "北广岛市",
      "zhName": "北廣島市",
      "koName": "기타히로시마 시",
      "esName": "Ciudad de Kita-hiroshima",
      "ptName": "cidade de Kitahiroshima",
      "thName": "เมืองคิตะฮิโรชิมะ",
      "viName": "thành phố Kitahiroshima",
      "inName": "kota Kitahiroshima",
      "tlName": "siyudad ng Kitahiroshima",
      "moName": "Китахирошима хот",
      "buName": "ခိတဟိရို့ရှိမ မြို့",
      "khName": "ទីក្រុង គីតាក់ហីរ៉ូស៊ីម៉ា",
      "neName": "किताहिरोशिमा सहर"
    }
  },
  "0123500": {
    "office": {
      "code": "016000",
      "name": "石狩・空知・後志地方",
      "enName": "Ishikari Sorachi Shiribeshi",
      "officeName": "札幌管区気象台",
      "chName": "石駱、空知、石獅地區",
      "zhName": "石狩、空知、石狮地区",
      "koName": "이시카리・공치・고시 지방",
      "esName": "Ishikari, Sorachi, región de Shishi",
      "ptName": "Ishikari, Sorachi, região de Shishi",
      "thName": "อิชิคาริ, โซราจิ, ภูมิภาคชิชิ",
      "viName": "Ishikari, Sorachi, vùng Shishi",
      "inName": "Ishikari, Sorachi, wilayah Shishi",
      "tlName": "Ishikari, Sorachi, rehiyon ng Shishi",
      "moName": "Ишикари, Сорачи, Шиши муж",
      "buName": "Ishikari၊ Sorachi၊ Shishi ဒေသ",
      "khName": "Ishikari, Sorachi, តំបន់ Shishi",
      "neName": "इशिकारी, सोराची, शिशी क्षेत्र"
    },
    "class10": {
      "code": "016010",
      "name": "石狩地方",
      "enName": "Ishikari Region",
      "chName": "石繹地區",
      "zhName": "石狩地区",
      "koName": "이시카리 지방",
      "esName": "Región de Ishikari",
      "ptName": "Região de Ishikari",
      "thName": "ภูมิภาคอิชิการิ",
      "viName": "vùng Ishikari",
      "inName": "wilayah Ishikari",
      "tlName": "Rehiyon ng Ishikari",
      "moName": "Ишикари муж",
      "buName": "Ishikari ဒေသ",
      "khName": "តំបន់ Ishikari",
      "neName": "इशिकारी क्षेत्र"
    },
    "class15": {
      "code": "016011",
      "name": "石狩北部",
      "enName": "Northern Ishikari"
    },
    "class20": {
      "code": "0123500",
      "name": "石狩市",
      "enName": "Ishikari City",
      "kana": "いしかりし",
      "chName": "石狩市",
      "zhName": "石狩市",
      "koName": "이시카리 시",
      "esName": "Ciudad de Ishigari",
      "ptName": "cidade de Ishikari",
      "thName": "เมืองอิชิการิ",
      "viName": "thành phố Ishikari",
      "inName": "kota Ishikari",
      "tlName": "siyudad ng Ishikari",
      "moName": "Ишикари хот",
      "buName": "အီရှီကာ့ရီ မြို့",
      "khName": "ទីក្រុង អ៊ីស៊ីការី",
      "neName": "इशिकारी सहर"
    }
  },
  "0123600": {
    "office": {
      "code": "017000",
      "name": "渡島・檜山地方",
      "enName": "Oshima Hiyama",
      "officeName": "函館地方気象台",
      "chName": "大島/檜山地區",
      "zhName": "大岛/桧山地区",
      "koName": "와타시마・히야마 지방",
      "esName": "Región de Oshima/Hiyama",
      "ptName": "Região de Oshima/Hiyama",
      "thName": "ภูมิภาคโอชิมะ/ฮิยามะ",
      "viName": "Vùng Oshima/Hiyama",
      "inName": "Wilayah Oshima/Hiyama",
      "tlName": "Rehiyon ng Oshima/Hiyama",
      "moName": "Ошима/Хияма муж",
      "buName": "Oshima/Hiyama ဒေသ",
      "khName": "តំបន់ Oshima/Hiyama",
      "neName": "ओशिमा/हियामा क्षेत्र"
    },
    "class10": {
      "code": "017010",
      "name": "渡島地方",
      "enName": "Oshima Region",
      "chName": "大島地區",
      "zhName": "大岛地区",
      "koName": "와타시마 지방",
      "esName": "Región de Ōshima",
      "ptName": "Região de Oshima",
      "thName": "ภูมิภาคโอชิมะ",
      "viName": "vùng Oshima",
      "inName": "wilayah Oshima",
      "tlName": "Rehiyon ng Oshima",
      "moName": "Ошима муж",
      "buName": "Oshima ဒေသ",
      "khName": "តំបន់អូស៊ីម៉ា",
      "neName": "ओशिमा क्षेत्र"
    },
    "class15": {
      "code": "017012",
      "name": "渡島東部",
      "enName": "Eastern Oshima"
    },
    "class20": {
      "code": "0123600",
      "name": "北斗市",
      "enName": "Hokuto City",
      "kana": "ほくとし",
      "chName": "渡岛北斗市",
      "zhName": "渡島北斗市",
      "koName": "오시마 호쿠토 시",
      "esName": "Ciudad de Hokuto, Oshima",
      "ptName": "Oshima, cidade de Hokuto",
      "thName": "เมืองโฮคุโตะ โอะชิมะ",
      "viName": "Thành phố Hokuto, Oshima",
      "inName": "Kota Hokuto, Oshima",
      "tlName": "siyudad ng Hokuto, Oshima",
      "moName": "Ошима Хокүто хот",
      "buName": "အိုရှိမဟိုခုတိုမြို့",
      "khName": "ទីក្រុងហូគូតូ អូស៊ីម៉ាក់",
      "neName": "ओसिमा होकुतो सहर"
    }
  },
  "0130300": {
    "office": {
      "code": "016000",
      "name": "石狩・空知・後志地方",
      "enName": "Ishikari Sorachi Shiribeshi",
      "officeName": "札幌管区気象台",
      "chName": "石駱、空知、石獅地區",
      "zhName": "石狩、空知、石狮地区",
      "koName": "이시카리・공치・고시 지방",
      "esName": "Ishikari, Sorachi, región de Shishi",
      "ptName": "Ishikari, Sorachi, região de Shishi",
      "thName": "อิชิคาริ, โซราจิ, ภูมิภาคชิชิ",
      "viName": "Ishikari, Sorachi, vùng Shishi",
      "inName": "Ishikari, Sorachi, wilayah Shishi",
      "tlName": "Ishikari, Sorachi, rehiyon ng Shishi",
      "moName": "Ишикари, Сорачи, Шиши муж",
      "buName": "Ishikari၊ Sorachi၊ Shishi ဒေသ",
      "khName": "Ishikari, Sorachi, តំបន់ Shishi",
      "neName": "इशिकारी, सोराची, शिशी क्षेत्र"
    },
    "class10": {
      "code": "016010",
      "name": "石狩地方",
      "enName": "Ishikari Region",
      "chName": "石繹地區",
      "zhName": "石狩地区",
      "koName": "이시카리 지방",
      "esName": "Región de Ishikari",
      "ptName": "Região de Ishikari",
      "thName": "ภูมิภาคอิชิการิ",
      "viName": "vùng Ishikari",
      "inName": "wilayah Ishikari",
      "tlName": "Rehiyon ng Ishikari",
      "moName": "Ишикари муж",
      "buName": "Ishikari ဒေသ",
      "khName": "តំបន់ Ishikari",
      "neName": "इशिकारी क्षेत्र"
    },
    "class15": {
      "code": "016011",
      "name": "石狩北部",
      "enName": "Northern Ishikari"
    },
    "class20": {
      "code": "0130300",
      "name": "当別町",
      "enName": "Tobetsu Town",
      "kana": "とうべつちょう",
      "chName": "当别町",
      "zhName": "當別町",
      "koName": "도베쓰 정",
      "esName": "Pueblo de Tobetsu",
      "ptName": "bairro de Tobetsu",
      "thName": "เมืองโทเบ็ตสึ",
      "viName": "thị trấn Tobetsu",
      "inName": "kota Tobetsu",
      "tlName": "bayan ng Tobetsu",
      "moName": "Тобэцу жижиг хот",
      "buName": "တိုးဗေ့စု မြို့နယ်",
      "khName": "ទីប្រជុំជន ថូបេតស៊ូ",
      "neName": "तोबेत्सु नगर"
    }
  },
  "0130400": {
    "office": {
      "code": "016000",
      "name": "石狩・空知・後志地方",
      "enName": "Ishikari Sorachi Shiribeshi",
      "officeName": "札幌管区気象台",
      "chName": "石駱、空知、石獅地區",
      "zhName": "石狩、空知、石狮地区",
      "koName": "이시카리・공치・고시 지방",
      "esName": "Ishikari, Sorachi, región de Shishi",
      "ptName": "Ishikari, Sorachi, região de Shishi",
      "thName": "อิชิคาริ, โซราจิ, ภูมิภาคชิชิ",
      "viName": "Ishikari, Sorachi, vùng Shishi",
      "inName": "Ishikari, Sorachi, wilayah Shishi",
      "tlName": "Ishikari, Sorachi, rehiyon ng Shishi",
      "moName": "Ишикари, Сорачи, Шиши муж",
      "buName": "Ishikari၊ Sorachi၊ Shishi ဒေသ",
      "khName": "Ishikari, Sorachi, តំបន់ Shishi",
      "neName": "इशिकारी, सोराची, शिशी क्षेत्र"
    },
    "class10": {
      "code": "016010",
      "name": "石狩地方",
      "enName": "Ishikari Region",
      "chName": "石繹地區",
      "zhName": "石狩地区",
      "koName": "이시카리 지방",
      "esName": "Región de Ishikari",
      "ptName": "Região de Ishikari",
      "thName": "ภูมิภาคอิชิการิ",
      "viName": "vùng Ishikari",
      "inName": "wilayah Ishikari",
      "tlName": "Rehiyon ng Ishikari",
      "moName": "Ишикари муж",
      "buName": "Ishikari ဒေသ",
      "khName": "តំបន់ Ishikari",
      "neName": "इशिकारी क्षेत्र"
    },
    "class15": {
      "code": "016011",
      "name": "石狩北部",
      "enName": "Northern Ishikari"
    },
    "class20": {
      "code": "0130400",
      "name": "新篠津村",
      "enName": "Shinshinotsu Village",
      "kana": "しんしのつむら",
      "chName": "新篠津村",
      "zhName": "新筱津村",
      "koName": "신시노쓰 촌",
      "esName": "Aldea de Shinshinotsu",
      "ptName": "povoado de Shinshinotsu",
      "thName": "หมู่บ้านชินชิโนสึ",
      "viName": "làng Shinshinotsu",
      "inName": "desa Shinshinotsu",
      "tlName": "nayon ng Shinshinotsu",
      "moName": "Шиншиноцү тосгон",
      "buName": "ရှင်းရှိနော့စု ကျေးရွာ",
      "khName": "ភូមិ ស៊ិនស៊ិនណូតស៊ូ",
      "neName": "शिन्शिनोत्सु गाउँ"
    }
  },
  "0133100": {
    "office": {
      "code": "017000",
      "name": "渡島・檜山地方",
      "enName": "Oshima Hiyama",
      "officeName": "函館地方気象台",
      "chName": "大島/檜山地區",
      "zhName": "大岛/桧山地区",
      "koName": "와타시마・히야마 지방",
      "esName": "Región de Oshima/Hiyama",
      "ptName": "Região de Oshima/Hiyama",
      "thName": "ภูมิภาคโอชิมะ/ฮิยามะ",
      "viName": "Vùng Oshima/Hiyama",
      "inName": "Wilayah Oshima/Hiyama",
      "tlName": "Rehiyon ng Oshima/Hiyama",
      "moName": "Ошима/Хияма муж",
      "buName": "Oshima/Hiyama ဒေသ",
      "khName": "តំបន់ Oshima/Hiyama",
      "neName": "ओशिमा/हियामा क्षेत्र"
    },
    "class10": {
      "code": "017010",
      "name": "渡島地方",
      "enName": "Oshima Region",
      "chName": "大島地區",
      "zhName": "大岛地区",
      "koName": "와타시마 지방",
      "esName": "Región de Ōshima",
      "ptName": "Região de Oshima",
      "thName": "ภูมิภาคโอชิมะ",
      "viName": "vùng Oshima",
      "inName": "wilayah Oshima",
      "tlName": "Rehiyon ng Oshima",
      "moName": "Ошима муж",
      "buName": "Oshima ဒေသ",
      "khName": "តំបន់អូស៊ីម៉ា",
      "neName": "ओशिमा क्षेत्र"
    },
    "class15": {
      "code": "017013",
      "name": "渡島西部",
      "enName": "Western Oshima"
    },
    "class20": {
      "code": "0133100",
      "name": "松前町",
      "enName": "Matsumae Town",
      "kana": "まつまえちょ���",
      "chName": "渡岛松前町",
      "zhName": "渡島松前町",
      "koName": "오시마 마쓰마에 정",
      "esName": "Pueblo de Matsumae, Oshima",
      "ptName": "Oshima, bairro de Matsumae",
      "thName": "เมืองมัทสึมาเอะ โอะชิมะ",
      "viName": "Thị trấn Matsumae, Oshima",
      "inName": "Kota Matsumae, Oshima",
      "tlName": "bayan ng Matsumae, Oshima",
      "moName": "Ошима Мацүмаэ жижиг хот",
      "buName": "အိုရှိမမဆုမအဲမြို့နယ်",
      "khName": "ទីប្រជុំជនម៉ាត់ស៊ូម៉ៃ អូស៊ីម៉ាក់",
      "neName": "ओसिमा मात्सुमाए नगर"
    }
  },
  "0133200": {
    "office": {
      "code": "017000",
      "name": "渡島・檜山地方",
      "enName": "Oshima Hiyama",
      "officeName": "函館地方気象台",
      "chName": "大島/檜山地區",
      "zhName": "大岛/桧山地区",
      "koName": "와타시마・히야마 지방",
      "esName": "Región de Oshima/Hiyama",
      "ptName": "Região de Oshima/Hiyama",
      "thName": "ภูมิภาคโอชิมะ/ฮิยามะ",
      "viName": "Vùng Oshima/Hiyama",
      "inName": "Wilayah Oshima/Hiyama",
      "tlName": "Rehiyon ng Oshima/Hiyama",
      "moName": "Ошима/Хияма муж",
      "buName": "Oshima/Hiyama ဒေသ",
      "khName": "តំបន់ Oshima/Hiyama",
      "neName": "ओशिमा/हियामा क्षेत्र"
    },
    "class10": {
      "code": "017010",
      "name": "渡島地方",
      "enName": "Oshima Region",
      "chName": "大島地區",
      "zhName": "大岛地区",
      "koName": "와타시마 지방",
      "esName": "Región de Ōshima",
      "ptName": "Região de Oshima",
      "thName": "ภูมิภาคโอชิมะ",
      "viName": "vùng Oshima",
      "inName": "wilayah Oshima",
      "tlName": "Rehiyon ng Oshima",
      "moName": "Ошима муж",
      "buName": "Oshima ဒေသ",
      "khName": "តំបន់អូស៊ីម៉ា",
      "neName": "ओशिमा क्षेत्र"
    },
    "class15": {
      "code": "017013",
      "name": "渡島西部",
      "enName": "Western Oshima"
    },
    "class20": {
      "code": "0133200",
      "name": "福島町",
      "enName": "Fukushima Town",
      "kana": "ふくしまちょう",
      "chName": "福岛町",
      "zhName": "福島町",
      "koName": "후쿠시마 정",
      "esName": "Pueblo de Fukushima",
      "ptName": "bairro de Fukushima",
      "thName": "เมืองฟุคุชิมะ",
      "viName": "thị trấn Fukushima",
      "inName": "kota Fukushima",
      "tlName": "bayan ng Fukushima",
      "moName": "Фүкүшима жижиг хот",
      "buName": "ဟူကုရှိမ မြို့နယ်",
      "khName": "ទីប្រជុំជន ហ្វូគូស៊ីម៉ា",
      "neName": "फुकुशिमा नगर"
    }
  },
  "0133300": {
    "office": {
      "code": "017000",
      "name": "渡島・檜山地方",
      "enName": "Oshima Hiyama",
      "officeName": "函館地方気象台",
      "chName": "大島/檜山地區",
      "zhName": "大岛/桧山地区",
      "koName": "와타시마・히야마 지방",
      "esName": "Región de Oshima/Hiyama",
      "ptName": "Região de Oshima/Hiyama",
      "thName": "ภูมิภาคโอชิมะ/ฮิยามะ",
      "viName": "Vùng Oshima/Hiyama",
      "inName": "Wilayah Oshima/Hiyama",
      "tlName": "Rehiyon ng Oshima/Hiyama",
      "moName": "Ошима/Хияма муж",
      "buName": "Oshima/Hiyama ဒေသ",
      "khName": "តំបន់ Oshima/Hiyama",
      "neName": "ओशिमा/हियामा क्षेत्र"
    },
    "class10": {
      "code": "017010",
      "name": "渡島地方",
      "enName": "Oshima Region",
      "chName": "大島地區",
      "zhName": "大岛地区",
      "koName": "와타시마 지방",
      "esName": "Región de Ōshima",
      "ptName": "Região de Oshima",
      "thName": "ภูมิภาคโอชิมะ",
      "viName": "vùng Oshima",
      "inName": "wilayah Oshima",
      "tlName": "Rehiyon ng Oshima",
      "moName": "Ошима муж",
      "buName": "Oshima ဒေသ",
      "khName": "តំបន់អូស៊ីម៉ា",
      "neName": "ओशिमा क्षेत्र"
    },
    "class15": {
      "code": "017013",
      "name": "渡島西部",
      "enName": "Western Oshima"
    },
    "class20": {
      "code": "0133300",
      "name": "知内町",
      "enName": "Shiriuchi Town",
      "kana": "しりうちちょう",
      "chName": "知内町",
      "zhName": "知內町",
      "koName": "시리우치 정",
      "esName": "Pueblo de Shiriuchi",
      "ptName": "bairro de Shiriuchi",
      "thName": "เมืองชิริอุจิ",
      "viName": "thị trấn Shiriuchi",
      "inName": "kota Shiriuchi",
      "tlName": "bayan ng Shiriuchi",
      "moName": "Шириүчи жижиг хот",
      "buName": "ရှီရိယုကျိ မြို့နယ်",
      "khName": "ទីប្រជុំជន ស៊ីរីអ៊ូជី",
      "neName": "शिरिउचि नगर"
    }
  },
  "0133400": {
    "office": {
      "code": "017000",
      "name": "渡島・檜山地方",
      "enName": "Oshima Hiyama",
      "officeName": "函館地方気象台",
      "chName": "大島/檜山地區",
      "zhName": "大岛/桧山地区",
      "koName": "와타시마・히야마 지방",
      "esName": "Región de Oshima/Hiyama",
      "ptName": "Região de Oshima/Hiyama",
      "thName": "ภูมิภาคโอชิมะ/ฮิยามะ",
      "viName": "Vùng Oshima/Hiyama",
      "inName": "Wilayah Oshima/Hiyama",
      "tlName": "Rehiyon ng Oshima/Hiyama",
      "moName": "Ошима/Хияма муж",
      "buName": "Oshima/Hiyama ဒေသ",
      "khName": "តំបន់ Oshima/Hiyama",
      "neName": "ओशिमा/हियामा क्षेत्र"
    },
    "class10": {
      "code": "017010",
      "name": "渡島地方",
      "enName": "Oshima Region",
      "chName": "大島地區",
      "zhName": "大岛地区",
      "koName": "와타시마 지방",
      "esName": "Región de Ōshima",
      "ptName": "Região de Oshima",
      "thName": "ภูมิภาคโอชิมะ",
      "viName": "vùng Oshima",
      "inName": "wilayah Oshima",
      "tlName": "Rehiyon ng Oshima",
      "moName": "Ошима муж",
      "buName": "Oshima ဒေသ",
      "khName": "តំបន់អូស៊ីម៉ា",
      "neName": "ओशिमा क्षेत्र"
    },
    "class15": {
      "code": "017013",
      "name": "渡島西部",
      "enName": "Western Oshima"
    },
    "class20": {
      "code": "0133400",
      "name": "木古内町",
      "enName": "Kikonai Town",
      "kana": "きこないちょう",
      "chName": "木古内町",
      "zhName": "木古內町",
      "koName": "기코나이 정",
      "esName": "Pueblo de Kikonai",
      "ptName": "bairro de Kikonai",
      "thName": "เมืองคิโคไน",
      "viName": "thị trấn Kikonai",
      "inName": "kota Kikonai",
      "tlName": "bayan ng Kikonai",
      "moName": "Киконaй жижиг хот",
      "buName": "ခီကော့နယိ မြို့နယ်",
      "khName": "ទីប្រជុំជន គិគូណៃ",
      "neName": "किकोनाइ नगर"
    }
  },
  "0133700": {
    "office": {
      "code": "017000",
      "name": "渡島・檜山地方",
      "enName": "Oshima Hiyama",
      "officeName": "函館地方気象台",
      "chName": "大島/檜山地區",
      "zhName": "大岛/桧山地区",
      "koName": "와타시마・히야마 지방",
      "esName": "Región de Oshima/Hiyama",
      "ptName": "Região de Oshima/Hiyama",
      "thName": "ภูมิภาคโอชิมะ/ฮิยามะ",
      "viName": "Vùng Oshima/Hiyama",
      "inName": "Wilayah Oshima/Hiyama",
      "tlName": "Rehiyon ng Oshima/Hiyama",
      "moName": "Ошима/Хияма муж",
      "buName": "Oshima/Hiyama ဒေသ",
      "khName": "តំបន់ Oshima/Hiyama",
      "neName": "ओशिमा/हियामा क्षेत्र"
    },
    "class10": {
      "code": "017010",
      "name": "渡島地方",
      "enName": "Oshima Region",
      "chName": "大島地區",
      "zhName": "大岛地区",
      "koName": "와타시마 지방",
      "esName": "Región de Ōshima",
      "ptName": "Região de Oshima",
      "thName": "ภูมิภาคโอชิมะ",
      "viName": "vùng Oshima",
      "inName": "wilayah Oshima",
      "tlName": "Rehiyon ng Oshima",
      "moName": "Ошима муж",
      "buName": "Oshima ဒေသ",
      "khName": "តំបន់អូស៊ីម៉ា",
      "neName": "ओशिमा क्षेत्र"
    },
    "class15": {
      "code": "017012",
      "name": "渡島東部",
      "enName": "Eastern Oshima"
    },
    "class20": {
      "code": "0133700",
      "name": "七飯町",
      "enName": "Nanae Town",
      "kana": "ななえちょう",
      "chName": "七饭町",
      "zhName": "七飯町",
      "koName": "나나에 정",
      "esName": "Pueblo Nanae",
      "ptName": "bairro de Nanae",
      "thName": "เมืองนานาเอะ",
      "viName": "thị trấn Nanae",
      "inName": "kota Nanae",
      "tlName": "bayan ng Nanae",
      "moName": "Нaнaэ жижиг хот",
      "buName": "နာနာ့အဲ့ မြို့နယ်",
      "khName": "ទីប្រជុំជន ណាណេ",
      "neName": "नानाए नगर"
    }
  },
  "0134300": {
    "office": {
      "code": "017000",
      "name": "渡島・檜山地方",
      "enName": "Oshima Hiyama",
      "officeName": "函館地方気象台",
      "chName": "大島/檜山地區",
      "zhName": "大岛/桧山地区",
      "koName": "와타시마・히야마 지방",
      "esName": "Región de Oshima/Hiyama",
      "ptName": "Região de Oshima/Hiyama",
      "thName": "ภูมิภาคโอชิมะ/ฮิยามะ",
      "viName": "Vùng Oshima/Hiyama",
      "inName": "Wilayah Oshima/Hiyama",
      "tlName": "Rehiyon ng Oshima/Hiyama",
      "moName": "Ошима/Хияма муж",
      "buName": "Oshima/Hiyama ဒေသ",
      "khName": "តំបន់ Oshima/Hiyama",
      "neName": "ओशिमा/हियामा क्षेत्र"
    },
    "class10": {
      "code": "017010",
      "name": "渡島地方",
      "enName": "Oshima Region",
      "chName": "大島地區",
      "zhName": "大岛地区",
      "koName": "와타시마 지방",
      "esName": "Región de Ōshima",
      "ptName": "Região de Oshima",
      "thName": "ภูมิภาคโอชิมะ",
      "viName": "vùng Oshima",
      "inName": "wilayah Oshima",
      "tlName": "Rehiyon ng Oshima",
      "moName": "Ошима муж",
      "buName": "Oshima ဒေသ",
      "khName": "តំបន់អូស៊ីម៉ា",
      "neName": "ओशिमा क्षेत्र"
    },
    "class15": {
      "code": "017012",
      "name": "渡島東部",
      "enName": "Eastern Oshima"
    },
    "class20": {
      "code": "0134300",
      "name": "鹿部町",
      "enName": "Shikabe Town",
      "kana": "しかべちょう",
      "chName": "鹿部町",
      "zhName": "鹿部町",
      "koName": "시카베 정",
      "esName": "Pueblo de Shikabe",
      "ptName": "bairro de Shikabe",
      "thName": "เมืองชิคาเบะ",
      "viName": "thị trấn Shikabe",
      "inName": "kota Shikabe",
      "tlName": "bayan ng Shikabe",
      "moName": "Шикабэ жижиг хот",
      "buName": "ရှီကာ့ဘဲ့ မြို့နယ်",
      "khName": "ទីប្រជុំជន ស៊ីកាបេ",
      "neName": "शिकाबे नगर"
    }
  },
  "0134500": {
    "office": {
      "code": "017000",
      "name": "渡島・檜山地方",
      "enName": "Oshima Hiyama",
      "officeName": "函館地方気象台",
      "chName": "大島/檜山地區",
      "zhName": "大岛/桧山地区",
      "koName": "와타시마・히야마 지방",
      "esName": "Región de Oshima/Hiyama",
      "ptName": "Região de Oshima/Hiyama",
      "thName": "ภูมิภาคโอชิมะ/ฮิยามะ",
      "viName": "Vùng Oshima/Hiyama",
      "inName": "Wilayah Oshima/Hiyama",
      "tlName": "Rehiyon ng Oshima/Hiyama",
      "moName": "Ошима/Хияма муж",
      "buName": "Oshima/Hiyama ဒေသ",
      "khName": "តំបន់ Oshima/Hiyama",
      "neName": "ओशिमा/हियामा क्षेत्र"
    },
    "class10": {
      "code": "017010",
      "name": "渡島地方",
      "enName": "Oshima Region",
      "chName": "大島地區",
      "zhName": "大岛地区",
      "koName": "와타시마 지방",
      "esName": "Región de Ōshima",
      "ptName": "Região de Oshima",
      "thName": "ภูมิภาคโอชิมะ",
      "viName": "vùng Oshima",
      "inName": "wilayah Oshima",
      "tlName": "Rehiyon ng Oshima",
      "moName": "Ошима муж",
      "buName": "Oshima ဒေသ",
      "khName": "តំបន់អូស៊ីម៉ា",
      "neName": "ओशिमा क्षेत्र"
    },
    "class15": {
      "code": "017012",
      "name": "渡島東部",
      "enName": "Eastern Oshima"
    },
    "class20": {
      "code": "0134500",
      "name": "森町",
      "enName": "Mori Town",
      "kana": "もりまち",
      "chName": "渡岛森町",
      "zhName": "渡島森町",
      "koName": "오시마 모리 정",
      "esName": "Pueblo de Mori, Oshima",
      "ptName": "Oshima, bairro de Mori",
      "thName": "เมืองโมริ โอะชิมะ",
      "viName": "Thị trấn Mori, Oshima",
      "inName": "Kota Mori, Oshima",
      "tlName": "bayan ng Mori, Oshima",
      "moName": "Ошима Мори жижиг хот",
      "buName": "အိုရှိမမိုယိမြို့နယ်",
      "khName": "ទីប្រជុំជនម៉ូរី អូស៊ីម៉ាក់",
      "neName": "ओसिमा मोरी नगर"
    }
  },
  "0134601": {
    "office": {
      "code": "017000",
      "name": "渡島・檜山地方",
      "enName": "Oshima Hiyama",
      "officeName": "函館地方気象台",
      "chName": "大島/檜山地區",
      "zhName": "大岛/桧山地区",
      "koName": "와타시마・히야마 지방",
      "esName": "Región de Oshima/Hiyama",
      "ptName": "Região de Oshima/Hiyama",
      "thName": "ภูมิภาคโอชิมะ/ฮิยามะ",
      "viName": "Vùng Oshima/Hiyama",
      "inName": "Wilayah Oshima/Hiyama",
      "tlName": "Rehiyon ng Oshima/Hiyama",
      "moName": "Ошима/Хияма муж",
      "buName": "Oshima/Hiyama ဒေသ",
      "khName": "តំបន់ Oshima/Hiyama",
      "neName": "ओशिमा/हियामा क्षेत्र"
    },
    "class10": {
      "code": "017010",
      "name": "渡島地方",
      "enName": "Oshima Region",
      "chName": "大島地區",
      "zhName": "大岛地区",
      "koName": "와타시마 지방",
      "esName": "Región de Ōshima",
      "ptName": "Região de Oshima",
      "thName": "ภูมิภาคโอชิมะ",
      "viName": "vùng Oshima",
      "inName": "wilayah Oshima",
      "tlName": "Rehiyon ng Oshima",
      "moName": "Ошима муж",
      "buName": "Oshima ဒေသ",
      "khName": "តំបន់អូស៊ីម៉ា",
      "neName": "ओशिमा क्षेत्र"
    },
    "class15": {
      "code": "017011",
      "name": "渡島北部",
      "enName": "Northern Oshima"
    },
    "class20": {
      "code": "0134601",
      "name": "八雲町八雲",
      "enName": "Yakumo, Yakumo Town",
      "kana": "やくもちょうやくも",
      "chName": "八云町八云",
      "zhName": "八云町八云",
      "koName": "야쿠모초 야쿠모",
      "esName": "Yakumo, Pueblo de Yakumo",
      "ptName": "Yakumo, Cidade de Yakumo",
      "thName": "ยาคุโมะ, เมืองยาคุโมะ",
      "viName": "Yakumo, Thị trấn Yakumo",
      "inName": "Yakumo, Kota Yakumo",
      "tlName": "Yakumo, Bayan ng Yakumo",
      "moName": "Yakumo, Cidade de Yakumo",
      "buName": "ယက်ခိုမု၊ ယက်ခိုမုမြို့",
      "khName": "ខេត្តយ៉ាកូម៉ូ",
      "neName": "याकुमो नगर"
    }
  },
  "0134602": {
    "office": {
      "code": "017000",
      "name": "渡島・檜山地方",
      "enName": "Oshima Hiyama",
      "officeName": "函館地方気象台",
      "chName": "大島/檜山地區",
      "zhName": "大岛/桧山地区",
      "koName": "와타시마・히야마 지방",
      "esName": "Región de Oshima/Hiyama",
      "ptName": "Região de Oshima/Hiyama",
      "thName": "ภูมิภาคโอชิมะ/ฮิยามะ",
      "viName": "Vùng Oshima/Hiyama",
      "inName": "Wilayah Oshima/Hiyama",
      "tlName": "Rehiyon ng Oshima/Hiyama",
      "moName": "Ошима/Хияма муж",
      "buName": "Oshima/Hiyama ဒေသ",
      "khName": "តំបន់ Oshima/Hiyama",
      "neName": "ओशिमा/हियामा क्षेत्र"
    },
    "class10": {
      "code": "017020",
      "name": "檜山地方",
      "enName": "Hiyama Region",
      "chName": "檜山地區",
      "zhName": "桧山地区",
      "koName": "히야마 지방",
      "esName": "Región de Hiyama",
      "ptName": "Região de Hiyama",
      "thName": "ภูมิภาคฮิยามะ",
      "viName": "vùng Hiyama",
      "inName": "wilayah Hiyama",
      "tlName": "Rehiyon ng Hiyama",
      "moName": "Хияма бүс",
      "buName": "Hiyama ဒေသ",
      "khName": "តំបន់ហ៊ីយ៉ាម៉ា",
      "neName": "हियामा क्षेत्र"
    },
    "class15": {
      "code": "017021",
      "name": "檜山北部",
      "enName": "Northern Hiyama"
    },
    "class20": {
      "code": "0134602",
      "name": "八雲町熊石",
      "enName": "Kumaishi, Yakumo Town",
      "kana": "やくもちょうくまいし",
      "chName": "八云町熊石",
      "zhName": "八云町熊石",
      "koName": "야쿠모초 쿠마이시",
      "esName": "Kumaishi, Pueblo de Yakumo",
      "ptName": "Kumaishi, Cidade de Yakumo",
      "thName": "คูมาอิชิ, เมืองยาคุโมะ",
      "viName": "Kumaishi, Thị trấn Yakumo",
      "inName": "Kumaishi, Kota Yakumo",
      "tlName": "Kumaishi, Bayan ng Yakumo",
      "moName": "Kumaishi, Cidade de Yakumo",
      "buName": "ကူမိုအိုရှီ၊ ယက်ခိုမုမြို့",
      "khName": "ខេត្តគូម៉ាយស៊ី",
      "neName": "कुमाईशी नगर"
    }
  },
  "0134700": {
    "office": {
      "code": "017000",
      "name": "渡島・檜山地方",
      "enName": "Oshima Hiyama",
      "officeName": "函館地方気象台",
      "chName": "大島/檜山地區",
      "zhName": "大岛/桧山地区",
      "koName": "와타시마・히야마 지방",
      "esName": "Región de Oshima/Hiyama",
      "ptName": "Região de Oshima/Hiyama",
      "thName": "ภูมิภาคโอชิมะ/ฮิยามะ",
      "viName": "Vùng Oshima/Hiyama",
      "inName": "Wilayah Oshima/Hiyama",
      "tlName": "Rehiyon ng Oshima/Hiyama",
      "moName": "Ошима/Хияма муж",
      "buName": "Oshima/Hiyama ဒေသ",
      "khName": "តំបន់ Oshima/Hiyama",
      "neName": "ओशिमा/हियामा क्षेत्र"
    },
    "class10": {
      "code": "017010",
      "name": "渡島地方",
      "enName": "Oshima Region",
      "chName": "大島地區",
      "zhName": "大岛地区",
      "koName": "와타시마 지방",
      "esName": "Región de Ōshima",
      "ptName": "Região de Oshima",
      "thName": "ภูมิภาคโอชิมะ",
      "viName": "vùng Oshima",
      "inName": "wilayah Oshima",
      "tlName": "Rehiyon ng Oshima",
      "moName": "Ошима муж",
      "buName": "Oshima ဒေသ",
      "khName": "តំបន់អូស៊ីម៉ា",
      "neName": "ओशिमा क्षेत्र"
    },
    "class15": {
      "code": "017011",
      "name": "渡島北部",
      "enName": "Northern Oshima"
    },
    "class20": {
      "code": "0134700",
      "name": "長万部町",
      "enName": "Oshamambe Town",
      "kana": "おしゃまんべちょう",
      "chName": "长万部町",
      "zhName": "長萬部町",
      "koName": "오샤만베 정",
      "esName": "Pueblo de Oshamanbe",
      "ptName": "bairro de Oshamambe",
      "thName": "เมืองโอฉะมัมเบะ",
      "viName": "thị trấn Oshamambe",
      "inName": "kota Oshamambe",
      "tlName": "bayan ng Oshamambe",
      "moName": "Ошaмaмбэ жижиг хот",
      "buName": "အိုရှားမာ့မဲ့ မြို့နယ်",
      "khName": "ទីប្រជុំជន អូសាម៉ាំបេ",
      "neName": "ओशमाम्बे नगर"
    }
  },
  "0136100": {
    "office": {
      "code": "017000",
      "name": "渡島・檜山地方",
      "enName": "Oshima Hiyama",
      "officeName": "函館地方気象台",
      "chName": "大島/檜山地區",
      "zhName": "大岛/桧山地区",
      "koName": "와타시마・히야마 지방",
      "esName": "Región de Oshima/Hiyama",
      "ptName": "Região de Oshima/Hiyama",
      "thName": "ภูมิภาคโอชิมะ/ฮิยามะ",
      "viName": "Vùng Oshima/Hiyama",
      "inName": "Wilayah Oshima/Hiyama",
      "tlName": "Rehiyon ng Oshima/Hiyama",
      "moName": "Ошима/Хияма муж",
      "buName": "Oshima/Hiyama ဒေသ",
      "khName": "តំបន់ Oshima/Hiyama",
      "neName": "ओशिमा/हियामा क्षेत्र"
    },
    "class10": {
      "code": "017020",
      "name": "檜山地方",
      "enName": "Hiyama Region",
      "chName": "檜山地區",
      "zhName": "桧山地区",
      "koName": "히야마 지방",
      "esName": "Región de Hiyama",
      "ptName": "Região de Hiyama",
      "thName": "ภูมิภาคฮิยามะ",
      "viName": "vùng Hiyama",
      "inName": "wilayah Hiyama",
      "tlName": "Rehiyon ng Hiyama",
      "moName": "Хияма бүс",
      "buName": "Hiyama ဒေသ",
      "khName": "តំបន់ហ៊ីយ៉ាម៉ា",
      "neName": "हियामा क्षेत्र"
    },
    "class15": {
      "code": "017022",
      "name": "檜山南部",
      "enName": "Southern Hiyama"
    },
    "class20": {
      "code": "0136100",
      "name": "江差町",
      "enName": "Esashi Town",
      "kana": "えさしちょう",
      "chName": "桧山江差町",
      "zhName": "檜山江差町",
      "koName": "히야마 에사시 정",
      "esName": "Pueblo de Esashi, Hiyama",
      "ptName": "Hiyama, bairro de Esashi",
      "thName": "เมืองเอซาชิ ฮิยามะ",
      "viName": "Thị trấn Esashi, Hiyama",
      "inName": "Kota Esashi, Hiyama",
      "tlName": "bayan ng Esashi, Hiyama",
      "moName": "Хаяма Эсаши жижиг хот",
      "buName": "ဟိယမအဲဆရှိမြို့နယ်",
      "khName": "ទីប្រជុំជនអេសាស៊ី ហ៊ីយ៉ាម៉ា",
      "neName": "हियामा एसाशी नगर"
    }
  },
  "0136200": {
    "office": {
      "code": "017000",
      "name": "渡島・檜山地方",
      "enName": "Oshima Hiyama",
      "officeName": "函館地方気象台",
      "chName": "大島/檜山地區",
      "zhName": "大岛/桧山地区",
      "koName": "와타시마・히야마 지방",
      "esName": "Región de Oshima/Hiyama",
      "ptName": "Região de Oshima/Hiyama",
      "thName": "ภูมิภาคโอชิมะ/ฮิยามะ",
      "viName": "Vùng Oshima/Hiyama",
      "inName": "Wilayah Oshima/Hiyama",
      "tlName": "Rehiyon ng Oshima/Hiyama",
      "moName": "Ошима/Хияма муж",
      "buName": "Oshima/Hiyama ဒေသ",
      "khName": "តំបន់ Oshima/Hiyama",
      "neName": "ओशिमा/हियामा क्षेत्र"
    },
    "class10": {
      "code": "017020",
      "name": "檜山地方",
      "enName": "Hiyama Region",
      "chName": "檜山地區",
      "zhName": "桧山地区",
      "koName": "히야마 지방",
      "esName": "Región de Hiyama",
      "ptName": "Região de Hiyama",
      "thName": "ภูมิภาคฮิยามะ",
      "viName": "vùng Hiyama",
      "inName": "wilayah Hiyama",
      "tlName": "Rehiyon ng Hiyama",
      "moName": "Хияма бүс",
      "buName": "Hiyama ဒေသ",
      "khName": "តំបន់ហ៊ីយ៉ាម៉ា",
      "neName": "हियामा क्षेत्र"
    },
    "class15": {
      "code": "017022",
      "name": "檜山南部",
      "enName": "Southern Hiyama"
    },
    "class20": {
      "code": "0136200",
      "name": "上ノ国町",
      "enName": "Kaminokuni Town",
      "kana": "かみのくにちょう",
      "chName": "上之国町",
      "zhName": "上之國町",
      "koName": "가미노쿠니 정",
      "esName": "Pueblo de Kikonai",
      "ptName": "bairro de Kaminokuni",
      "thName": "เมืองคามิโนะคุนิ",
      "viName": "thị trấn Kaminokuni",
      "inName": "kota Kaminokuni",
      "tlName": "bayan ng Kaminokuni",
      "moName": "Каминокүни жижиг хот",
      "buName": "ခါမိနော့ကုနိ မြို့နယ်",
      "khName": "ទីប្រជុំជន កាមីណូគូនី",
      "neName": "कामिनोकुनी नगर"
    }
  },
  "0136300": {
    "office": {
      "code": "017000",
      "name": "渡島・檜山地方",
      "enName": "Oshima Hiyama",
      "officeName": "函館地方気象台",
      "chName": "大島/檜山地區",
      "zhName": "大岛/桧山地区",
      "koName": "와타시마・히야마 지방",
      "esName": "Región de Oshima/Hiyama",
      "ptName": "Região de Oshima/Hiyama",
      "thName": "ภูมิภาคโอชิมะ/ฮิยามะ",
      "viName": "Vùng Oshima/Hiyama",
      "inName": "Wilayah Oshima/Hiyama",
      "tlName": "Rehiyon ng Oshima/Hiyama",
      "moName": "Ошима/Хияма муж",
      "buName": "Oshima/Hiyama ဒေသ",
      "khName": "តំបន់ Oshima/Hiyama",
      "neName": "ओशिमा/हियामा क्षेत्र"
    },
    "class10": {
      "code": "017020",
      "name": "檜山地方",
      "enName": "Hiyama Region",
      "chName": "檜山地區",
      "zhName": "桧山地区",
      "koName": "히야마 지방",
      "esName": "Región de Hiyama",
      "ptName": "Região de Hiyama",
      "thName": "ภูมิภาคฮิยามะ",
      "viName": "vùng Hiyama",
      "inName": "wilayah Hiyama",
      "tlName": "Rehiyon ng Hiyama",
      "moName": "Хияма бүс",
      "buName": "Hiyama ဒေသ",
      "khName": "តំបន់ហ៊ីយ៉ាម៉ា",
      "neName": "हियामा क्षेत्र"
    },
    "class15": {
      "code": "017022",
      "name": "檜山南部",
      "enName": "Southern Hiyama"
    },
    "class20": {
      "code": "0136300",
      "name": "厚沢部町",
      "enName": "Assabu Town",
      "kana": "あっさぶちょう",
      "chName": "厚泽部町",
      "zhName": "厚澤部町",
      "koName": "앗사부 정",
      "esName": "Pueblo de Assabu",
      "ptName": "bairro de Assabu",
      "thName": "เมืองอัสซาบุ",
      "viName": "thị trấn Assabu",
      "inName": "kota Assabu",
      "tlName": "bayan ng Assabu",
      "moName": "Ассабү жижиг хот",
      "buName": "အားဆာ့ဘု မြို့နယ်",
      "khName": "ទីប្រជុំជន អាសាប៊ូ",
      "neName": "असाबु नगर"
    }
  },
  "0136400": {
    "office": {
      "code": "017000",
      "name": "渡島・檜山地方",
      "enName": "Oshima Hiyama",
      "officeName": "函館地方気象台",
      "chName": "大島/檜山地區",
      "zhName": "大岛/桧山地区",
      "koName": "와타시마・히야마 지방",
      "esName": "Región de Oshima/Hiyama",
      "ptName": "Região de Oshima/Hiyama",
      "thName": "ภูมิภาคโอชิมะ/ฮิยามะ",
      "viName": "Vùng Oshima/Hiyama",
      "inName": "Wilayah Oshima/Hiyama",
      "tlName": "Rehiyon ng Oshima/Hiyama",
      "moName": "Ошима/Хияма муж",
      "buName": "Oshima/Hiyama ဒေသ",
      "khName": "តំបន់ Oshima/Hiyama",
      "neName": "ओशिमा/हियामा क्षेत्र"
    },
    "class10": {
      "code": "017020",
      "name": "檜山地方",
      "enName": "Hiyama Region",
      "chName": "檜山地區",
      "zhName": "桧山地区",
      "koName": "히야마 지방",
      "esName": "Región de Hiyama",
      "ptName": "Região de Hiyama",
      "thName": "ภูมิภาคฮิยามะ",
      "viName": "vùng Hiyama",
      "inName": "wilayah Hiyama",
      "tlName": "Rehiyon ng Hiyama",
      "moName": "Хияма бүс",
      "buName": "Hiyama ဒေသ",
      "khName": "តំបន់ហ៊ីយ៉ាម៉ា",
      "neName": "हियामा क्षेत्र"
    },
    "class15": {
      "code": "017022",
      "name": "檜山南部",
      "enName": "Southern Hiyama"
    },
    "class20": {
      "code": "0136400",
      "name": "乙部町",
      "enName": "Otobe Town",
      "kana": "おとべちょう",
      "chName": "乙部町",
      "zhName": "乙部町",
      "koName": "오토베 정",
      "esName": "Pueblo de Otobe",
      "ptName": "bairro de Otobe",
      "thName": "เมืองโอโตเบะ",
      "viName": "thị trấn Otobe",
      "inName": "kota Otobe",
      "tlName": "bayan ng Otobe",
      "moName": "Отобэ жижиг хот",
      "buName": "အိုးတို့ဘဲ့ မြို့နယ်",
      "khName": "ទីប្រជុំជន អូតូបេ",
      "neName": "ओतोबे नगर"
    }
  },
  "0136700": {
    "office": {
      "code": "017000",
      "name": "渡島・檜山地方",
      "enName": "Oshima Hiyama",
      "officeName": "函館地方気象台",
      "chName": "大島/檜山地區",
      "zhName": "大岛/桧山地区",
      "koName": "와타시마・히야마 지방",
      "esName": "Región de Oshima/Hiyama",
      "ptName": "Região de Oshima/Hiyama",
      "thName": "ภูมิภาคโอชิมะ/ฮิยามะ",
      "viName": "Vùng Oshima/Hiyama",
      "inName": "Wilayah Oshima/Hiyama",
      "tlName": "Rehiyon ng Oshima/Hiyama",
      "moName": "Ошима/Хияма муж",
      "buName": "Oshima/Hiyama ဒေသ",
      "khName": "តំបន់ Oshima/Hiyama",
      "neName": "ओशिमा/हियामा क्षेत्र"
    },
    "class10": {
      "code": "017020",
      "name": "檜山地方",
      "enName": "Hiyama Region",
      "chName": "檜山地區",
      "zhName": "桧山地区",
      "koName": "히야마 지방",
      "esName": "Región de Hiyama",
      "ptName": "Região de Hiyama",
      "thName": "ภูมิภาคฮิยามะ",
      "viName": "vùng Hiyama",
      "inName": "wilayah Hiyama",
      "tlName": "Rehiyon ng Hiyama",
      "moName": "Хияма бүс",
      "buName": "Hiyama ဒေသ",
      "khName": "តំបន់ហ៊ីយ៉ាម៉ា",
      "neName": "हियामा क्षेत्र"
    },
    "class15": {
      "code": "017023",
      "name": "檜山奥尻島",
      "enName": "Hiyama Okushirito"
    },
    "class20": {
      "code": "0136700",
      "name": "奥尻町",
      "enName": "Okushiri Town",
      "kana": "おくしりちょう",
      "chName": "奥尻町",
      "zhName": "奧尻町",
      "koName": "오쿠시리 정",
      "esName": "Pueblo de Okushiri",
      "ptName": "bairro de Okushiri",
      "thName": "เมืองโอคุชิริ",
      "viName": "thị trấn Okushiri",
      "inName": "kota Okushiri",
      "tlName": "bayan ng Okushiri",
      "moName": "Окүшири жижиг хот",
      "buName": "အိုကုရှိရိ မြို့နယ်",
      "khName": "ទីប្រជុំជន អូឃ្យូស៊ីរី",
      "neName": "ओकुशिरी नगर"
    }
  },
  "0137000": {
    "office": {
      "code": "017000",
      "name": "渡島・檜山地方",
      "enName": "Oshima Hiyama",
      "officeName": "函館地方気象台",
      "chName": "大島/檜山地區",
      "zhName": "大岛/桧山地区",
      "koName": "와타시마・히야마 지방",
      "esName": "Región de Oshima/Hiyama",
      "ptName": "Região de Oshima/Hiyama",
      "thName": "ภูมิภาคโอชิมะ/ฮิยามะ",
      "viName": "Vùng Oshima/Hiyama",
      "inName": "Wilayah Oshima/Hiyama",
      "tlName": "Rehiyon ng Oshima/Hiyama",
      "moName": "Ошима/Хияма муж",
      "buName": "Oshima/Hiyama ဒေသ",
      "khName": "តំបន់ Oshima/Hiyama",
      "neName": "ओशिमा/हियामा क्षेत्र"
    },
    "class10": {
      "code": "017020",
      "name": "檜山地方",
      "enName": "Hiyama Region",
      "chName": "檜山地區",
      "zhName": "桧山地区",
      "koName": "히야마 지방",
      "esName": "Región de Hiyama",
      "ptName": "Região de Hiyama",
      "thName": "ภูมิภาคฮิยามะ",
      "viName": "vùng Hiyama",
      "inName": "wilayah Hiyama",
      "tlName": "Rehiyon ng Hiyama",
      "moName": "Хияма бүс",
      "buName": "Hiyama ဒေသ",
      "khName": "តំបន់ហ៊ីយ៉ាម៉ា",
      "neName": "हियामा क्षेत्र"
    },
    "class15": {
      "code": "017021",
      "name": "檜山北部",
      "enName": "Northern Hiyama"
    },
    "class20": {
      "code": "0137000",
      "name": "今金町",
      "enName": "Imakane Town",
      "kana": "いまかねちょう",
      "chName": "今金町",
      "zhName": "今金町",
      "koName": "이마카네 정",
      "esName": "Pueblo de Imakane",
      "ptName": "bairro de Imakane",
      "thName": "เมืองอิมะคาเนะ",
      "viName": "thị trấn Imakane",
      "inName": "kota Imakane",
      "tlName": "bayan ng Imakane",
      "moName": "Имaканэ жижиг хот",
      "buName": "အီမားကာ့နဲ့ မြို့နယ်",
      "khName": "ទីប្រជុំជន អ៊ីម៉ាខាណេ",
      "neName": "इमाकाने नगर"
    }
  },
  "0137100": {
    "office": {
      "code": "017000",
      "name": "渡島・檜山地方",
      "enName": "Oshima Hiyama",
      "officeName": "函館地方気象台",
      "chName": "大島/檜山地區",
      "zhName": "大岛/桧山地区",
      "koName": "와타시마・히야마 지방",
      "esName": "Región de Oshima/Hiyama",
      "ptName": "Região de Oshima/Hiyama",
      "thName": "ภูมิภาคโอชิมะ/ฮิยามะ",
      "viName": "Vùng Oshima/Hiyama",
      "inName": "Wilayah Oshima/Hiyama",
      "tlName": "Rehiyon ng Oshima/Hiyama",
      "moName": "Ошима/Хияма муж",
      "buName": "Oshima/Hiyama ဒေသ",
      "khName": "តំបន់ Oshima/Hiyama",
      "neName": "ओशिमा/हियामा क्षेत्र"
    },
    "class10": {
      "code": "017020",
      "name": "檜山地方",
      "enName": "Hiyama Region",
      "chName": "檜山地區",
      "zhName": "桧山地区",
      "koName": "히야마 지방",
      "esName": "Región de Hiyama",
      "ptName": "Região de Hiyama",
      "thName": "ภูมิภาคฮิยามะ",
      "viName": "vùng Hiyama",
      "inName": "wilayah Hiyama",
      "tlName": "Rehiyon ng Hiyama",
      "moName": "Хияма бүс",
      "buName": "Hiyama ဒေသ",
      "khName": "តំបន់ហ៊ីយ៉ាម៉ា",
      "neName": "हियामा क्षेत्र"
    },
    "class15": {
      "code": "017021",
      "name": "檜山北部",
      "enName": "Northern Hiyama"
    },
    "class20": {
      "code": "0137100",
      "name": "せたな町",
      "enName": "Setana Town",
      "kana": "せたなちょう",
      "chName": "濑棚町",
      "zhName": "瀨棚町",
      "koName": "세타나 정",
      "esName": "Pueblo de Setana",
      "ptName": "bairro de Setana",
      "thName": "เมืองเซตานะ",
      "viName": "thị trấn Setana",
      "inName": "kota Setana",
      "tlName": "bayan ng Setana",
      "moName": "Сетана жижиг хот",
      "buName": "ဆေးတာ့န မြို့နယ်",
      "khName": "ទីប្រជុំជន សេតាណា",
      "neName": "सेताना नगर"
    }
  },
  "0139100": {
    "office": {
      "code": "016000",
      "name": "石狩・空知・後志地方",
      "enName": "Ishikari Sorachi Shiribeshi",
      "officeName": "札幌管区気象台",
      "chName": "石駱、空知、石獅地區",
      "zhName": "石狩、空知、石狮地区",
      "koName": "이시카리・공치・고시 지방",
      "esName": "Ishikari, Sorachi, región de Shishi",
      "ptName": "Ishikari, Sorachi, região de Shishi",
      "thName": "อิชิคาริ, โซราจิ, ภูมิภาคชิชิ",
      "viName": "Ishikari, Sorachi, vùng Shishi",
      "inName": "Ishikari, Sorachi, wilayah Shishi",
      "tlName": "Ishikari, Sorachi, rehiyon ng Shishi",
      "moName": "Ишикари, Сорачи, Шиши муж",
      "buName": "Ishikari၊ Sorachi၊ Shishi ဒေသ",
      "khName": "Ishikari, Sorachi, តំបន់ Shishi",
      "neName": "इशिकारी, सोराची, शिशी क्षेत्र"
    },
    "class10": {
      "code": "016030",
      "name": "後志地方",
      "enName": "Shiribeshi Region",
      "chName": "石獅地區",
      "zhName": "石狮地区",
      "koName": "고시 지방",
      "esName": "Región de Shishi",
      "ptName": "Região de Shishi",
      "thName": "ภูมิภาคชิชิ",
      "viName": "vùng Shishi",
      "inName": "wilayah Shishi",
      "tlName": "Rehiyon ng Shishi",
      "moName": "Шиши бүс",
      "buName": "Shishi ဒေသ",
      "khName": "តំបន់ Shishi",
      "neName": "शिशि क्षेत्र"
    },
    "class15": {
      "code": "016033",
      "name": "後志西部",
      "enName": "Western Shiribeshi"
    },
    "class20": {
      "code": "0139100",
      "name": "島牧村",
      "enName": "Shimamaki Village",
      "kana": "しままきむら",
      "chName": "岛牧村",
      "zhName": "島牧村",
      "koName": "시마마키 촌",
      "esName": "Aldea de Shimamaki",
      "ptName": "povoado de Shimamaki",
      "thName": "หมู่บ้านชิมะมากิ",
      "viName": "làng Shimamaki",
      "inName": "desa Shimamaki",
      "tlName": "nayon ng Shimamaki",
      "moName": "Шимaмaки тосгон",
      "buName": "ရှီမားမာ့ကိ ကျေးရွာ",
      "khName": "ភូមិ ស៊ីម៉ាម៉ាគី",
      "neName": "शिमामाकी गाउँ"
    }
  },
  "0139200": {
    "office": {
      "code": "016000",
      "name": "石狩・空知・後志地方",
      "enName": "Ishikari Sorachi Shiribeshi",
      "officeName": "札幌管区気象台",
      "chName": "石駱、空知、石獅地區",
      "zhName": "石狩、空知、石狮地区",
      "koName": "이시카리・공치・고시 지방",
      "esName": "Ishikari, Sorachi, región de Shishi",
      "ptName": "Ishikari, Sorachi, região de Shishi",
      "thName": "อิชิคาริ, โซราจิ, ภูมิภาคชิชิ",
      "viName": "Ishikari, Sorachi, vùng Shishi",
      "inName": "Ishikari, Sorachi, wilayah Shishi",
      "tlName": "Ishikari, Sorachi, rehiyon ng Shishi",
      "moName": "Ишикари, Сорачи, Шиши муж",
      "buName": "Ishikari၊ Sorachi၊ Shishi ဒေသ",
      "khName": "Ishikari, Sorachi, តំបន់ Shishi",
      "neName": "इशिकारी, सोराची, शिशी क्षेत्र"
    },
    "class10": {
      "code": "016030",
      "name": "後志地方",
      "enName": "Shiribeshi Region",
      "chName": "石獅地區",
      "zhName": "石狮地区",
      "koName": "고시 지방",
      "esName": "Región de Shishi",
      "ptName": "Região de Shishi",
      "thName": "ภูมิภาคชิชิ",
      "viName": "vùng Shishi",
      "inName": "wilayah Shishi",
      "tlName": "Rehiyon ng Shishi",
      "moName": "Шиши бүс",
      "buName": "Shishi ဒေသ",
      "khName": "តំបន់ Shishi",
      "neName": "शिशि क्षेत्र"
    },
    "class15": {
      "code": "016033",
      "name": "後志西部",
      "enName": "Western Shiribeshi"
    },
    "class20": {
      "code": "0139200",
      "name": "寿都町",
      "enName": "Suttsu Town",
      "kana": "すっつちょう",
      "chName": "寿都町",
      "zhName": "壽都町",
      "koName": "슷쓰 정",
      "esName": "Pueblo de Suttsu",
      "ptName": "bairro de Suttsu",
      "thName": "เมืองซุตสึ",
      "viName": "thị trấn Suttsu",
      "inName": "kota Suttsu",
      "tlName": "bayan ng Suttsu",
      "moName": "Сүццү жижиг хот",
      "buName": "ဆုစု မြို့နယ်",
      "khName": "ទីប្រជុំជន ស៊ុតស៊ូ",
      "neName": "सुत्सु नगर"
    }
  },
  "0139300": {
    "office": {
      "code": "016000",
      "name": "石狩・空知・後志地方",
      "enName": "Ishikari Sorachi Shiribeshi",
      "officeName": "札幌管区気象台",
      "chName": "石駱、空知、石獅地區",
      "zhName": "石狩、空知、石狮地区",
      "koName": "이시카리・공치・고시 지방",
      "esName": "Ishikari, Sorachi, región de Shishi",
      "ptName": "Ishikari, Sorachi, região de Shishi",
      "thName": "อิชิคาริ, โซราจิ, ภูมิภาคชิชิ",
      "viName": "Ishikari, Sorachi, vùng Shishi",
      "inName": "Ishikari, Sorachi, wilayah Shishi",
      "tlName": "Ishikari, Sorachi, rehiyon ng Shishi",
      "moName": "Ишикари, Сорачи, Шиши муж",
      "buName": "Ishikari၊ Sorachi၊ Shishi ဒေသ",
      "khName": "Ishikari, Sorachi, តំបន់ Shishi",
      "neName": "इशिकारी, सोराची, शिशी क्षेत्र"
    },
    "class10": {
      "code": "016030",
      "name": "後志地方",
      "enName": "Shiribeshi Region",
      "chName": "石獅地區",
      "zhName": "石狮地区",
      "koName": "고시 지방",
      "esName": "Región de Shishi",
      "ptName": "Região de Shishi",
      "thName": "ภูมิภาคชิชิ",
      "viName": "vùng Shishi",
      "inName": "wilayah Shishi",
      "tlName": "Rehiyon ng Shishi",
      "moName": "Шиши бүс",
      "buName": "Shishi ဒေသ",
      "khName": "តំបន់ Shishi",
      "neName": "शिशि क्षेत्र"
    },
    "class15": {
      "code": "016033",
      "name": "後志西部",
      "enName": "Western Shiribeshi"
    },
    "class20": {
      "code": "0139300",
      "name": "黒松内町",
      "enName": "Kuromatsunai Town",
      "kana": "くろまつないちょう",
      "chName": "黑松内町",
      "zhName": "黑松內町",
      "koName": "구로마쓰나이 정",
      "esName": "Pueblo de Kuromatsunai",
      "ptName": "bairro de Kuromatsunai",
      "thName": "เมืองคุโระมัตสึไน",
      "viName": "thị trấn Kuromatsunai",
      "inName": "kota Kuromatsunai",
      "tlName": "bayan ng Kuromatsunai",
      "moName": "Күромaцүнaй жижиг хот",
      "buName": "ကူရိုးမာ့ဆုနာ့ယိ မြို့နယ်",
      "khName": "ទីប្រជុំជន គូរុម៉ាត់ស៊ូណៃ",
      "neName": "कुरोमात्सुनाइ नगर"
    }
  },
  "0139400": {
    "office": {
      "code": "016000",
      "name": "石狩・空知・後志地方",
      "enName": "Ishikari Sorachi Shiribeshi",
      "officeName": "札幌管区気象台",
      "chName": "石駱、空知、石獅地區",
      "zhName": "石狩、空知、石狮地区",
      "koName": "이시카리・공치・고시 지방",
      "esName": "Ishikari, Sorachi, región de Shishi",
      "ptName": "Ishikari, Sorachi, região de Shishi",
      "thName": "อิชิคาริ, โซราจิ, ภูมิภาคชิชิ",
      "viName": "Ishikari, Sorachi, vùng Shishi",
      "inName": "Ishikari, Sorachi, wilayah Shishi",
      "tlName": "Ishikari, Sorachi, rehiyon ng Shishi",
      "moName": "Ишикари, Сорачи, Шиши муж",
      "buName": "Ishikari၊ Sorachi၊ Shishi ဒေသ",
      "khName": "Ishikari, Sorachi, តំបន់ Shishi",
      "neName": "इशिकारी, सोराची, शिशी क्षेत्र"
    },
    "class10": {
      "code": "016030",
      "name": "後志地方",
      "enName": "Shiribeshi Region",
      "chName": "石獅地區",
      "zhName": "石狮地区",
      "koName": "고시 지방",
      "esName": "Región de Shishi",
      "ptName": "Região de Shishi",
      "thName": "ภูมิภาคชิชิ",
      "viName": "vùng Shishi",
      "inName": "wilayah Shishi",
      "tlName": "Rehiyon ng Shishi",
      "moName": "Шиши бүс",
      "buName": "Shishi ဒေသ",
      "khName": "តំបន់ Shishi",
      "neName": "शिशि क्षेत्र"
    },
    "class15": {
      "code": "016033",
      "name": "後志西部",
      "enName": "Western Shiribeshi"
    },
    "class20": {
      "code": "0139400",
      "name": "蘭越町",
      "enName": "Rankoshi Town",
      "kana": "らんこしちょう",
      "chName": "兰越町",
      "zhName": "蘭越町",
      "koName": "란코시 정",
      "esName": "Pueblo de Rankoshi",
      "ptName": "bairro de Rankoshi",
      "thName": "เมืองรันโคชิ",
      "viName": "thị trấn Rankoshi",
      "inName": "kota Rankoshi",
      "tlName": "bayan ng Rankoshi",
      "moName": "Ранкоши жижиг хот",
      "buName": "ရန်းကို့ရှိ မြို့နယ်",
      "khName": "ទីប្រជុំជន រ៉ានកុហ្ស៊ី",
      "neName": "रान्कोशी नगर"
    }
  },
  "0139500": {
    "office": {
      "code": "016000",
      "name": "石狩・空知・後志地方",
      "enName": "Ishikari Sorachi Shiribeshi",
      "officeName": "札幌管区気象台",
      "chName": "石駱、空知、石獅地區",
      "zhName": "石狩、空知、石狮地区",
      "koName": "이시카리・공치・고시 지방",
      "esName": "Ishikari, Sorachi, región de Shishi",
      "ptName": "Ishikari, Sorachi, região de Shishi",
      "thName": "อิชิคาริ, โซราจิ, ภูมิภาคชิชิ",
      "viName": "Ishikari, Sorachi, vùng Shishi",
      "inName": "Ishikari, Sorachi, wilayah Shishi",
      "tlName": "Ishikari, Sorachi, rehiyon ng Shishi",
      "moName": "Ишикари, Сорачи, Шиши муж",
      "buName": "Ishikari၊ Sorachi၊ Shishi ဒေသ",
      "khName": "Ishikari, Sorachi, តំបន់ Shishi",
      "neName": "इशिकारी, सोराची, शिशी क्षेत्र"
    },
    "class10": {
      "code": "016030",
      "name": "後志地方",
      "enName": "Shiribeshi Region",
      "chName": "石獅地區",
      "zhName": "石狮地区",
      "koName": "고시 지방",
      "esName": "Región de Shishi",
      "ptName": "Região de Shishi",
      "thName": "ภูมิภาคชิชิ",
      "viName": "vùng Shishi",
      "inName": "wilayah Shishi",
      "tlName": "Rehiyon ng Shishi",
      "moName": "Шиши бүс",
      "buName": "Shishi ဒေသ",
      "khName": "តំបន់ Shishi",
      "neName": "शिशि क्षेत्र"
    },
    "class15": {
      "code": "016032",
      "name": "羊蹄山麓",
      "enName": "The foot of Mt. Yotei"
    },
    "class20": {
      "code": "0139500",
      "name": "ニセコ町",
      "enName": "Niseko Town",
      "kana": "にせこちょう",
      "chName": "新雪谷町",
      "zhName": "新雪谷町",
      "koName": "니세코 정",
      "esName": "Pueblo de Niseko",
      "ptName": "bairro de Niseko",
      "thName": "เมืองนิเซโกะ",
      "viName": "thị trấn Niseko",
      "inName": "kota Niseko",
      "tlName": "bayan ng Niseko",
      "moName": "Нисэко жижиг хот",
      "buName": "နီဆဲ့ကို မြို့နယ်",
      "khName": "ទីប្រជុំជន ណិសេកុ",
      "neName": "निसेको नगर"
    }
  },
  "0139600": {
    "office": {
      "code": "016000",
      "name": "石狩・空知・後志地方",
      "enName": "Ishikari Sorachi Shiribeshi",
      "officeName": "札幌管区気象台",
      "chName": "石駱、空知、石獅地區",
      "zhName": "石狩、空知、石狮地区",
      "koName": "이시카리・공치・고시 지방",
      "esName": "Ishikari, Sorachi, región de Shishi",
      "ptName": "Ishikari, Sorachi, região de Shishi",
      "thName": "อิชิคาริ, โซราจิ, ภูมิภาคชิชิ",
      "viName": "Ishikari, Sorachi, vùng Shishi",
      "inName": "Ishikari, Sorachi, wilayah Shishi",
      "tlName": "Ishikari, Sorachi, rehiyon ng Shishi",
      "moName": "Ишикари, Сорачи, Шиши муж",
      "buName": "Ishikari၊ Sorachi၊ Shishi ဒေသ",
      "khName": "Ishikari, Sorachi, តំបន់ Shishi",
      "neName": "इशिकारी, सोराची, शिशी क्षेत्र"
    },
    "class10": {
      "code": "016030",
      "name": "後志地方",
      "enName": "Shiribeshi Region",
      "chName": "石獅地區",
      "zhName": "石狮地区",
      "koName": "고시 지방",
      "esName": "Región de Shishi",
      "ptName": "Região de Shishi",
      "thName": "ภูมิภาคชิชิ",
      "viName": "vùng Shishi",
      "inName": "wilayah Shishi",
      "tlName": "Rehiyon ng Shishi",
      "moName": "Шиши бүс",
      "buName": "Shishi ဒေသ",
      "khName": "តំបន់ Shishi",
      "neName": "शिशि क्षेत्र"
    },
    "class15": {
      "code": "016032",
      "name": "羊蹄山麓",
      "enName": "The foot of Mt. Yotei"
    },
    "class20": {
      "code": "0139600",
      "name": "真狩村",
      "enName": "Makkari Village",
      "kana": "まっかりむら",
      "chName": "真狩村",
      "zhName": "真狩村",
      "koName": "맛카리 촌",
      "esName": "Aldea de Makkari",
      "ptName": "povoado de Makkari",
      "thName": "หมู่บ้านมัคคาริ",
      "viName": "làng Makkari",
      "inName": "desa Makkari",
      "tlName": "nayon ng Makkari",
      "moName": "Маккари тосгон",
      "buName": "မာကားရိ ကျေးရွာ",
      "khName": "ភូមិ ម៉ាក់ការី",
      "neName": "माक्कारी गाउँ"
    }
  },
  "0139700": {
    "office": {
      "code": "016000",
      "name": "石狩・空知・後志地方",
      "enName": "Ishikari Sorachi Shiribeshi",
      "officeName": "札幌管区気象台",
      "chName": "石駱、空知、石獅地區",
      "zhName": "石狩、空知、石狮地区",
      "koName": "이시카리・공치・고시 지방",
      "esName": "Ishikari, Sorachi, región de Shishi",
      "ptName": "Ishikari, Sorachi, região de Shishi",
      "thName": "อิชิคาริ, โซราจิ, ภูมิภาคชิชิ",
      "viName": "Ishikari, Sorachi, vùng Shishi",
      "inName": "Ishikari, Sorachi, wilayah Shishi",
      "tlName": "Ishikari, Sorachi, rehiyon ng Shishi",
      "moName": "Ишикари, Сорачи, Шиши муж",
      "buName": "Ishikari၊ Sorachi၊ Shishi ဒေသ",
      "khName": "Ishikari, Sorachi, តំបន់ Shishi",
      "neName": "इशिकारी, सोराची, शिशी क्षेत्र"
    },
    "class10": {
      "code": "016030",
      "name": "後志地方",
      "enName": "Shiribeshi Region",
      "chName": "石獅地區",
      "zhName": "石狮地区",
      "koName": "고시 지방",
      "esName": "Región de Shishi",
      "ptName": "Região de Shishi",
      "thName": "ภูมิภาคชิชิ",
      "viName": "vùng Shishi",
      "inName": "wilayah Shishi",
      "tlName": "Rehiyon ng Shishi",
      "moName": "Шиши бүс",
      "buName": "Shishi ဒေသ",
      "khName": "តំបន់ Shishi",
      "neName": "शिशि क्षेत्र"
    },
    "class15": {
      "code": "016032",
      "name": "羊蹄山麓",
      "enName": "The foot of Mt. Yotei"
    },
    "class20": {
      "code": "0139700",
      "name": "留寿都村",
      "enName": "Rusutsu Village",
      "kana": "るすつむら",
      "chName": "留寿都村",
      "zhName": "留壽都村",
      "koName": "루스쓰 촌",
      "esName": "Aldea de Rusutsu",
      "ptName": "povoado de Rusutsu",
      "thName": "หมู่บ้านรุสุสึ",
      "viName": "làng Rusutsu",
      "inName": "desa Rusutsu",
      "tlName": "nayon ng Rusutsu",
      "moName": "Рүсүцү тосгон",
      "buName": "ရူးဆုစု ကျေးရွာ",
      "khName": "ភូមិ រូស៊ុតស៊ូ",
      "neName": "रुसुत्सु गाउँ"
    }
  },
  "0139800": {
    "office": {
      "code": "016000",
      "name": "石狩・空知・後志地方",
      "enName": "Ishikari Sorachi Shiribeshi",
      "officeName": "札幌管区気象台",
      "chName": "石駱、空知、石獅地區",
      "zhName": "石狩、空知、石狮地区",
      "koName": "이시카리・공치・고시 지방",
      "esName": "Ishikari, Sorachi, región de Shishi",
      "ptName": "Ishikari, Sorachi, região de Shishi",
      "thName": "อิชิคาริ, โซราจิ, ภูมิภาคชิชิ",
      "viName": "Ishikari, Sorachi, vùng Shishi",
      "inName": "Ishikari, Sorachi, wilayah Shishi",
      "tlName": "Ishikari, Sorachi, rehiyon ng Shishi",
      "moName": "Ишикари, Сорачи, Шиши муж",
      "buName": "Ishikari၊ Sorachi၊ Shishi ဒေသ",
      "khName": "Ishikari, Sorachi, តំបន់ Shishi",
      "neName": "इशिकारी, सोराची, शिशी क्षेत्र"
    },
    "class10": {
      "code": "016030",
      "name": "後志地方",
      "enName": "Shiribeshi Region",
      "chName": "石獅地區",
      "zhName": "石狮地区",
      "koName": "고시 지방",
      "esName": "Región de Shishi",
      "ptName": "Região de Shishi",
      "thName": "ภูมิภาคชิชิ",
      "viName": "vùng Shishi",
      "inName": "wilayah Shishi",
      "tlName": "Rehiyon ng Shishi",
      "moName": "Шиши бүс",
      "buName": "Shishi ဒေသ",
      "khName": "តំបន់ Shishi",
      "neName": "शिशि क्षेत्र"
    },
    "class15": {
      "code": "016032",
      "name": "羊蹄山麓",
      "enName": "The foot of Mt. Yotei"
    },
    "class20": {
      "code": "0139800",
      "name": "喜茂別町",
      "enName": "Kimobetsu Town",
      "kana": "きもべつちょう",
      "chName": "喜茂别町",
      "zhName": "喜茂別町",
      "koName": "기모베쓰 정",
      "esName": "Pueblo de Kimobetsu",
      "ptName": "bairro de Kimobetsu",
      "thName": "เมืองคิโมเบ็ตสึ",
      "viName": "thị trấn Kimobetsu",
      "inName": "kota Kimobetsu",
      "tlName": "bayan ng Kimobetsu",
      "moName": "Кимобэцү жижиг хот",
      "buName": "ကီမိုးဗေ့စု မြို့နယ်",
      "khName": "ទីប្រជុំជន គីម៉ូបេតស៊ូ",
      "neName": "किमोबेत्सु नगर"
    }
  },
  "0139900": {
    "office": {
      "code": "016000",
      "name": "石狩・空知・後志地方",
      "enName": "Ishikari Sorachi Shiribeshi",
      "officeName": "札幌管区気象台",
      "chName": "石駱、空知、石獅地區",
      "zhName": "石狩、空知、石狮地区",
      "koName": "이시카리・공치・고시 지방",
      "esName": "Ishikari, Sorachi, región de Shishi",
      "ptName": "Ishikari, Sorachi, região de Shishi",
      "thName": "อิชิคาริ, โซราจิ, ภูมิภาคชิชิ",
      "viName": "Ishikari, Sorachi, vùng Shishi",
      "inName": "Ishikari, Sorachi, wilayah Shishi",
      "tlName": "Ishikari, Sorachi, rehiyon ng Shishi",
      "moName": "Ишикари, Сорачи, Шиши муж",
      "buName": "Ishikari၊ Sorachi၊ Shishi ဒေသ",
      "khName": "Ishikari, Sorachi, តំបន់ Shishi",
      "neName": "इशिकारी, सोराची, शिशी क्षेत्र"
    },
    "class10": {
      "code": "016030",
      "name": "後志地方",
      "enName": "Shiribeshi Region",
      "chName": "石獅地區",
      "zhName": "石狮地区",
      "koName": "고시 지방",
      "esName": "Región de Shishi",
      "ptName": "Região de Shishi",
      "thName": "ภูมิภาคชิชิ",
      "viName": "vùng Shishi",
      "inName": "wilayah Shishi",
      "tlName": "Rehiyon ng Shishi",
      "moName": "Шиши бүс",
      "buName": "Shishi ဒေသ",
      "khName": "តំបន់ Shishi",
      "neName": "शिशि क्षेत्र"
    },
    "class15": {
      "code": "016032",
      "name": "羊蹄山麓",
      "enName": "The foot of Mt. Yotei"
    },
    "class20": {
      "code": "0139900",
      "name": "京極町",
      "enName": "Kyogoku Town",
      "kana": "きょうごくちょう",
      "chName": "京极町",
      "zhName": "京極町",
      "koName": "교고쿠 정",
      "esName": "Pueblo de Kyogoku",
      "ptName": "bairro de Kyogoku",
      "thName": "เมืองเกียวโงขุ",
      "viName": "thị trấn Kyogoku",
      "inName": "kota Kyogoku",
      "tlName": "bayan ng Kyogoku",
      "moName": "Киогокү жижиг хот",
      "buName": "ကျိုဂိုးကု မြို့နယ်",
      "khName": "ទីប្រជុំជន ក្យូហ្គូកូ",
      "neName": "क्योगोकु नगर"
    }
  },
  "0140000": {
    "office": {
      "code": "016000",
      "name": "石狩・空知・後志地方",
      "enName": "Ishikari Sorachi Shiribeshi",
      "officeName": "札幌管区気象台",
      "chName": "石駱、空知、石獅地區",
      "zhName": "石狩、空知、石狮地区",
      "koName": "이시카리・공치・고시 지방",
      "esName": "Ishikari, Sorachi, región de Shishi",
      "ptName": "Ishikari, Sorachi, região de Shishi",
      "thName": "อิชิคาริ, โซราจิ, ภูมิภาคชิชิ",
      "viName": "Ishikari, Sorachi, vùng Shishi",
      "inName": "Ishikari, Sorachi, wilayah Shishi",
      "tlName": "Ishikari, Sorachi, rehiyon ng Shishi",
      "moName": "Ишикари, Сорачи, Шиши муж",
      "buName": "Ishikari၊ Sorachi၊ Shishi ဒေသ",
      "khName": "Ishikari, Sorachi, តំបន់ Shishi",
      "neName": "इशिकारी, सोराची, शिशी क्षेत्र"
    },
    "class10": {
      "code": "016030",
      "name": "後志地方",
      "enName": "Shiribeshi Region",
      "chName": "石獅地區",
      "zhName": "石狮地区",
      "koName": "고시 지방",
      "esName": "Región de Shishi",
      "ptName": "Região de Shishi",
      "thName": "ภูมิภาคชิชิ",
      "viName": "vùng Shishi",
      "inName": "wilayah Shishi",
      "tlName": "Rehiyon ng Shishi",
      "moName": "Шиши бүс",
      "buName": "Shishi ဒေသ",
      "khName": "តំបន់ Shishi",
      "neName": "शिशि क्षेत्र"
    },
    "class15": {
      "code": "016032",
      "name": "羊蹄山麓",
      "enName": "The foot of Mt. Yotei"
    },
    "class20": {
      "code": "0140000",
      "name": "倶知安町",
      "enName": "Kutchan Town",
      "kana": "くっちゃんちょう",
      "chName": "俱知安町",
      "zhName": "俱知安町",
      "koName": "쿳챤 정",
      "esName": "Pueblo de Kutchan",
      "ptName": "bairro de Kutchan",
      "thName": "เมืองคุทชาน",
      "viName": "thị trấn Kutchan",
      "inName": "kota Kutchan",
      "tlName": "bayan ng Kutchan",
      "moName": "Күтчaн жижиг хот",
      "buName": "ခပ်ကျန် မြို့နယ်",
      "khName": "ទីប្រជុំជន គូថចាន់",
      "neName": "कुत्चान नगर"
    }
  },
  "0140100": {
    "office": {
      "code": "016000",
      "name": "石狩・空知・後志地方",
      "enName": "Ishikari Sorachi Shiribeshi",
      "officeName": "札幌管区気象台",
      "chName": "石駱、空知、石獅地區",
      "zhName": "石狩、空知、石狮地区",
      "koName": "이시카리・공치・고시 지방",
      "esName": "Ishikari, Sorachi, región de Shishi",
      "ptName": "Ishikari, Sorachi, região de Shishi",
      "thName": "อิชิคาริ, โซราจิ, ภูมิภาคชิชิ",
      "viName": "Ishikari, Sorachi, vùng Shishi",
      "inName": "Ishikari, Sorachi, wilayah Shishi",
      "tlName": "Ishikari, Sorachi, rehiyon ng Shishi",
      "moName": "Ишикари, Сорачи, Шиши муж",
      "buName": "Ishikari၊ Sorachi၊ Shishi ဒေသ",
      "khName": "Ishikari, Sorachi, តំបន់ Shishi",
      "neName": "इशिकारी, सोराची, शिशी क्षेत्र"
    },
    "class10": {
      "code": "016030",
      "name": "後志地方",
      "enName": "Shiribeshi Region",
      "chName": "石獅地區",
      "zhName": "石狮地区",
      "koName": "고시 지방",
      "esName": "Región de Shishi",
      "ptName": "Região de Shishi",
      "thName": "ภูมิภาคชิชิ",
      "viName": "vùng Shishi",
      "inName": "wilayah Shishi",
      "tlName": "Rehiyon ng Shishi",
      "moName": "Шиши бүс",
      "buName": "Shishi ဒေသ",
      "khName": "តំបន់ Shishi",
      "neName": "शिशि क्षेत्र"
    },
    "class15": {
      "code": "016033",
      "name": "後志西部",
      "enName": "Western Shiribeshi"
    },
    "class20": {
      "code": "0140100",
      "name": "共和町",
      "enName": "Kyowa Town",
      "kana": "きょうわちょう",
      "chName": "共和町",
      "zhName": "共和町",
      "koName": "교와 정",
      "esName": "Pueblo de Kyowa",
      "ptName": "bairro de Kyowa",
      "thName": "เมืองเคียววะ",
      "viName": "thị trấn Kyowa",
      "inName": "kota Kyowa",
      "tlName": "bayan ng Kyowa",
      "moName": "Киова жижиг хот",
      "buName": "ကျိုဝ မြို့နယ်",
      "khName": "ទីប្រជុំជន ក្យូវ៉ា",
      "neName": "क्योवा नगर"
    }
  },
  "0140200": {
    "office": {
      "code": "016000",
      "name": "石狩・空知・後志地方",
      "enName": "Ishikari Sorachi Shiribeshi",
      "officeName": "札幌管区気象台",
      "chName": "石駱、空知、石獅地區",
      "zhName": "石狩、空知、石狮地区",
      "koName": "이시카리・공치・고시 지방",
      "esName": "Ishikari, Sorachi, región de Shishi",
      "ptName": "Ishikari, Sorachi, região de Shishi",
      "thName": "อิชิคาริ, โซราจิ, ภูมิภาคชิชิ",
      "viName": "Ishikari, Sorachi, vùng Shishi",
      "inName": "Ishikari, Sorachi, wilayah Shishi",
      "tlName": "Ishikari, Sorachi, rehiyon ng Shishi",
      "moName": "Ишикари, Сорачи, Шиши муж",
      "buName": "Ishikari၊ Sorachi၊ Shishi ဒေသ",
      "khName": "Ishikari, Sorachi, តំបន់ Shishi",
      "neName": "इशिकारी, सोराची, शिशी क्षेत्र"
    },
    "class10": {
      "code": "016030",
      "name": "後志地方",
      "enName": "Shiribeshi Region",
      "chName": "石獅地區",
      "zhName": "石狮地区",
      "koName": "고시 지방",
      "esName": "Región de Shishi",
      "ptName": "Região de Shishi",
      "thName": "ภูมิภาคชิชิ",
      "viName": "vùng Shishi",
      "inName": "wilayah Shishi",
      "tlName": "Rehiyon ng Shishi",
      "moName": "Шиши бүс",
      "buName": "Shishi ဒေသ",
      "khName": "តំបន់ Shishi",
      "neName": "शिशि क्षेत्र"
    },
    "class15": {
      "code": "016033",
      "name": "後志西部",
      "enName": "Western Shiribeshi"
    },
    "class20": {
      "code": "0140200",
      "name": "岩内町",
      "enName": "Iwanai Town",
      "kana": "いわないちょう",
      "chName": "岩内町",
      "zhName": "岩內町",
      "koName": "이와나이 정",
      "esName": "Pueblo de Iwanai",
      "ptName": "bairro de Iwanai",
      "thName": "เมืองอิวาไน",
      "viName": "thị trấn Iwanai",
      "inName": "kota Iwanai",
      "tlName": "bayan ng Iwanai",
      "moName": "Иванaй жижиг хот",
      "buName": "အီဝါ့နယိ မြို့နယ်",
      "khName": "ទីប្រជុំជន អាយវ៉ានណៃ",
      "neName": "इवानाई नगर"
    }
  },
  "0140300": {
    "office": {
      "code": "016000",
      "name": "石狩・空知・後志地方",
      "enName": "Ishikari Sorachi Shiribeshi",
      "officeName": "札幌管区気象台",
      "chName": "石駱、空知、石獅地區",
      "zhName": "石狩、空知、石狮地区",
      "koName": "이시카리・공치・고시 지방",
      "esName": "Ishikari, Sorachi, región de Shishi",
      "ptName": "Ishikari, Sorachi, região de Shishi",
      "thName": "อิชิคาริ, โซราจิ, ภูมิภาคชิชิ",
      "viName": "Ishikari, Sorachi, vùng Shishi",
      "inName": "Ishikari, Sorachi, wilayah Shishi",
      "tlName": "Ishikari, Sorachi, rehiyon ng Shishi",
      "moName": "Ишикари, Сорачи, Шиши муж",
      "buName": "Ishikari၊ Sorachi၊ Shishi ဒေသ",
      "khName": "Ishikari, Sorachi, តំបន់ Shishi",
      "neName": "इशिकारी, सोराची, शिशी क्षेत्र"
    },
    "class10": {
      "code": "016030",
      "name": "後志地方",
      "enName": "Shiribeshi Region",
      "chName": "石獅地區",
      "zhName": "石狮地区",
      "koName": "고시 지방",
      "esName": "Región de Shishi",
      "ptName": "Região de Shishi",
      "thName": "ภูมิภาคชิชิ",
      "viName": "vùng Shishi",
      "inName": "wilayah Shishi",
      "tlName": "Rehiyon ng Shishi",
      "moName": "Шиши бүс",
      "buName": "Shishi ဒေသ",
      "khName": "តំបន់ Shishi",
      "neName": "शिशि क्षेत्र"
    },
    "class15": {
      "code": "016033",
      "name": "後志西部",
      "enName": "Western Shiribeshi"
    },
    "class20": {
      "code": "0140300",
      "name": "泊村",
      "enName": "Tomari Village",
      "kana": "とまりむら",
      "chName": "泊村",
      "zhName": "泊村",
      "koName": "도마리 촌",
      "esName": "Aldea Tomari",
      "ptName": "povoado de Tomari",
      "thName": "หมู่บ้านโมมาริ",
      "viName": "làng Tomari",
      "inName": "desa Tomari",
      "tlName": "nayon ng Tomari",
      "moName": "Томaри тосгон",
      "buName": "တိုမာ့ရိ ကျေးရွာ",
      "khName": "ភូមិ តុម៉ារិ",
      "neName": "तोमारी गाउँ"
    }
  },
  "0140400": {
    "office": {
      "code": "016000",
      "name": "石狩・空知・後志地方",
      "enName": "Ishikari Sorachi Shiribeshi",
      "officeName": "札幌管区気象台",
      "chName": "石駱、空知、石獅地區",
      "zhName": "石狩、空知、石狮地区",
      "koName": "이시카리・공치・고시 지방",
      "esName": "Ishikari, Sorachi, región de Shishi",
      "ptName": "Ishikari, Sorachi, região de Shishi",
      "thName": "อิชิคาริ, โซราจิ, ภูมิภาคชิชิ",
      "viName": "Ishikari, Sorachi, vùng Shishi",
      "inName": "Ishikari, Sorachi, wilayah Shishi",
      "tlName": "Ishikari, Sorachi, rehiyon ng Shishi",
      "moName": "Ишикари, Сорачи, Шиши муж",
      "buName": "Ishikari၊ Sorachi၊ Shishi ဒေသ",
      "khName": "Ishikari, Sorachi, តំបន់ Shishi",
      "neName": "इशिकारी, सोराची, शिशी क्षेत्र"
    },
    "class10": {
      "code": "016030",
      "name": "後志地方",
      "enName": "Shiribeshi Region",
      "chName": "石獅地區",
      "zhName": "石狮地区",
      "koName": "고시 지방",
      "esName": "Región de Shishi",
      "ptName": "Região de Shishi",
      "thName": "ภูมิภาคชิชิ",
      "viName": "vùng Shishi",
      "inName": "wilayah Shishi",
      "tlName": "Rehiyon ng Shishi",
      "moName": "Шиши бүс",
      "buName": "Shishi ဒေသ",
      "khName": "តំបន់ Shishi",
      "neName": "शिशि क्षेत्र"
    },
    "class15": {
      "code": "016033",
      "name": "後志西部",
      "enName": "Western Shiribeshi"
    },
    "class20": {
      "code": "0140400",
      "name": "神恵内村",
      "enName": "Kamoenai Village",
      "kana": "かもえないむら",
      "chName": "神惠内村",
      "zhName": "神惠內村",
      "koName": "가모에나이 촌",
      "esName": "Aldea de Kamoenai",
      "ptName": "povoado de Kamoenai",
      "thName": "หมู่บ้านคาโมเอไน",
      "viName": "làng Kamoenai",
      "inName": "desa Kamoenai",
      "tlName": "nayon ng Kamoenai",
      "moName": "Камоэнaй тосгон",
      "buName": "ခါမို့ရေးနယိ ကျေးရွာ",
      "khName": "ភូមិកាមឿនណៃ",
      "neName": "कामोएनाई गाउँ"
    }
  },
  "0140500": {
    "office": {
      "code": "016000",
      "name": "石狩・空知・後志地方",
      "enName": "Ishikari Sorachi Shiribeshi",
      "officeName": "札幌管区気象台",
      "chName": "石駱、空知、石獅地區",
      "zhName": "石狩、空知、石狮地区",
      "koName": "이시카리・공치・고시 지방",
      "esName": "Ishikari, Sorachi, región de Shishi",
      "ptName": "Ishikari, Sorachi, região de Shishi",
      "thName": "อิชิคาริ, โซราจิ, ภูมิภาคชิชิ",
      "viName": "Ishikari, Sorachi, vùng Shishi",
      "inName": "Ishikari, Sorachi, wilayah Shishi",
      "tlName": "Ishikari, Sorachi, rehiyon ng Shishi",
      "moName": "Ишикари, Сорачи, Шиши муж",
      "buName": "Ishikari၊ Sorachi၊ Shishi ဒေသ",
      "khName": "Ishikari, Sorachi, តំបន់ Shishi",
      "neName": "इशिकारी, सोराची, शिशी क्षेत्र"
    },
    "class10": {
      "code": "016030",
      "name": "後志地方",
      "enName": "Shiribeshi Region",
      "chName": "石獅地區",
      "zhName": "石狮地区",
      "koName": "고시 지방",
      "esName": "Región de Shishi",
      "ptName": "Região de Shishi",
      "thName": "ภูมิภาคชิชิ",
      "viName": "vùng Shishi",
      "inName": "wilayah Shishi",
      "tlName": "Rehiyon ng Shishi",
      "moName": "Шиши бүс",
      "buName": "Shishi ဒေသ",
      "khName": "តំបន់ Shishi",
      "neName": "शिशि क्षेत्र"
    },
    "class15": {
      "code": "016031",
      "name": "後志北部",
      "enName": "Northern Shiribeshi"
    },
    "class20": {
      "code": "0140500",
      "name": "積丹町",
      "enName": "Shakotan Town",
      "kana": "しゃこたんちょう",
      "chName": "积丹町",
      "zhName": "積丹町",
      "koName": "샤코탄 정",
      "esName": "Pueblo de Shakotan",
      "ptName": "bairro de Shakotan",
      "thName": "เมืองชาโคทัน",
      "viName": "thị trấn Shakotan",
      "inName": "kota Shakotan",
      "tlName": "bayan ng Shakotan",
      "moName": "Шaкотан жижиг хот",
      "buName": "ရှားကို့တန် မြို့နယ်",
      "khName": "ទីប្រជុំជន សាកុតាន់",
      "neName": "शाकोतान नगर"
    }
  },
  "0140600": {
    "office": {
      "code": "016000",
      "name": "石狩・空知・後志地方",
      "enName": "Ishikari Sorachi Shiribeshi",
      "officeName": "札幌管区気象台",
      "chName": "石駱、空知、石獅地區",
      "zhName": "石狩、空知、石狮地区",
      "koName": "이시카리・공치・고시 지방",
      "esName": "Ishikari, Sorachi, región de Shishi",
      "ptName": "Ishikari, Sorachi, região de Shishi",
      "thName": "อิชิคาริ, โซราจิ, ภูมิภาคชิชิ",
      "viName": "Ishikari, Sorachi, vùng Shishi",
      "inName": "Ishikari, Sorachi, wilayah Shishi",
      "tlName": "Ishikari, Sorachi, rehiyon ng Shishi",
      "moName": "Ишикари, Сорачи, Шиши муж",
      "buName": "Ishikari၊ Sorachi၊ Shishi ဒေသ",
      "khName": "Ishikari, Sorachi, តំបន់ Shishi",
      "neName": "इशिकारी, सोराची, शिशी क्षेत्र"
    },
    "class10": {
      "code": "016030",
      "name": "後志地方",
      "enName": "Shiribeshi Region",
      "chName": "石獅地區",
      "zhName": "石狮地区",
      "koName": "고시 지방",
      "esName": "Región de Shishi",
      "ptName": "Região de Shishi",
      "thName": "ภูมิภาคชิชิ",
      "viName": "vùng Shishi",
      "inName": "wilayah Shishi",
      "tlName": "Rehiyon ng Shishi",
      "moName": "Шиши бүс",
      "buName": "Shishi ဒေသ",
      "khName": "តំបន់ Shishi",
      "neName": "शिशि क्षेत्र"
    },
    "class15": {
      "code": "016031",
      "name": "後志北部",
      "enName": "Northern Shiribeshi"
    },
    "class20": {
      "code": "0140600",
      "name": "古平町",
      "enName": "Furubira Town",
      "kana": "ふるびらちょう",
      "chName": "古平町",
      "zhName": "古平町",
      "koName": "후루비라 정",
      "esName": "Pueblo de Furubira",
      "ptName": "bairro de Furubira",
      "thName": "เมืองฟุรุบิระ",
      "viName": "thị trấn Furubira",
      "inName": "kota Furubira",
      "tlName": "bayan ng Furubira",
      "moName": "Фүрүбира жижиг хот",
      "buName": "ခူရူးဘိရာ့ မြို့နယ်",
      "khName": "ទីប្រជុំជន ហ្វូរូប៊ីរ៉ា",
      "neName": "फुरुबिरा नगर"
    }
  },
  "0140700": {
    "office": {
      "code": "016000",
      "name": "石狩・空知・後志地方",
      "enName": "Ishikari Sorachi Shiribeshi",
      "officeName": "札幌管区気象台",
      "chName": "石駱、空知、石獅地區",
      "zhName": "石狩、空知、石狮地区",
      "koName": "이시카리・공치・고시 지방",
      "esName": "Ishikari, Sorachi, región de Shishi",
      "ptName": "Ishikari, Sorachi, região de Shishi",
      "thName": "อิชิคาริ, โซราจิ, ภูมิภาคชิชิ",
      "viName": "Ishikari, Sorachi, vùng Shishi",
      "inName": "Ishikari, Sorachi, wilayah Shishi",
      "tlName": "Ishikari, Sorachi, rehiyon ng Shishi",
      "moName": "Ишикари, Сорачи, Шиши муж",
      "buName": "Ishikari၊ Sorachi၊ Shishi ဒေသ",
      "khName": "Ishikari, Sorachi, តំបន់ Shishi",
      "neName": "इशिकारी, सोराची, शिशी क्षेत्र"
    },
    "class10": {
      "code": "016030",
      "name": "後志地方",
      "enName": "Shiribeshi Region",
      "chName": "石獅地區",
      "zhName": "石狮地区",
      "koName": "고시 지방",
      "esName": "Región de Shishi",
      "ptName": "Região de Shishi",
      "thName": "ภูมิภาคชิชิ",
      "viName": "vùng Shishi",
      "inName": "wilayah Shishi",
      "tlName": "Rehiyon ng Shishi",
      "moName": "Шиши бүс",
      "buName": "Shishi ဒေသ",
      "khName": "តំបន់ Shishi",
      "neName": "शिशि क्षेत्र"
    },
    "class15": {
      "code": "016031",
      "name": "後志北部",
      "enName": "Northern Shiribeshi"
    },
    "class20": {
      "code": "0140700",
      "name": "仁木町",
      "enName": "Niki Town",
      "kana": "にきちょう",
      "chName": "仁木町",
      "zhName": "仁木町",
      "koName": "니키 정",
      "esName": "Pueblo de Niki",
      "ptName": "bairro de Niki",
      "thName": "เมืองนิกิ",
      "viName": "thị trấn Niki",
      "inName": "kota Niki",
      "tlName": "bayan ng Niki",
      "moName": "Ники жижиг хот",
      "buName": "နီကိ မြို့နယ်",
      "khName": "ទីប្រជុំជន នីគី",
      "neName": "निकी नगर"
    }
  },
  "0140800": {
    "office": {
      "code": "016000",
      "name": "石狩・空知・後志地方",
      "enName": "Ishikari Sorachi Shiribeshi",
      "officeName": "札幌管区気象台",
      "chName": "石駱、空知、石獅地區",
      "zhName": "石狩、空知、石狮地区",
      "koName": "이시카리・공치・고시 지방",
      "esName": "Ishikari, Sorachi, región de Shishi",
      "ptName": "Ishikari, Sorachi, região de Shishi",
      "thName": "อิชิคาริ, โซราจิ, ภูมิภาคชิชิ",
      "viName": "Ishikari, Sorachi, vùng Shishi",
      "inName": "Ishikari, Sorachi, wilayah Shishi",
      "tlName": "Ishikari, Sorachi, rehiyon ng Shishi",
      "moName": "Ишикари, Сорачи, Шиши муж",
      "buName": "Ishikari၊ Sorachi၊ Shishi ဒေသ",
      "khName": "Ishikari, Sorachi, តំបន់ Shishi",
      "neName": "इशिकारी, सोराची, शिशी क्षेत्र"
    },
    "class10": {
      "code": "016030",
      "name": "後志地方",
      "enName": "Shiribeshi Region",
      "chName": "石獅地區",
      "zhName": "石狮地区",
      "koName": "고시 지방",
      "esName": "Región de Shishi",
      "ptName": "Região de Shishi",
      "thName": "ภูมิภาคชิชิ",
      "viName": "vùng Shishi",
      "inName": "wilayah Shishi",
      "tlName": "Rehiyon ng Shishi",
      "moName": "Шиши бүс",
      "buName": "Shishi ဒေသ",
      "khName": "តំបន់ Shishi",
      "neName": "शिशि क्षेत्र"
    },
    "class15": {
      "code": "016031",
      "name": "後志北部",
      "enName": "Northern Shiribeshi"
    },
    "class20": {
      "code": "0140800",
      "name": "余市町",
      "enName": "Yoichi Town",
      "kana": "よいちちょう",
      "chName": "余市町",
      "zhName": "餘市町",
      "koName": "요이치 정",
      "esName": "Pueblo de Yoichi",
      "ptName": "bairro de Yoichi",
      "thName": "เมืองโยอิจิ",
      "viName": "thị trấn Yoichi",
      "inName": "kota Yoichi",
      "tlName": "bayan ng Yoichi",
      "moName": "Ёойчи жижиг хот",
      "buName": "ယောယိကျိ မြို့နယ်",
      "khName": "ទីប្រជុំជន យូអ៊ីឈី",
      "neName": "योइचि नगर"
    }
  },
  "0140900": {
    "office": {
      "code": "016000",
      "name": "石狩・空知・後志地方",
      "enName": "Ishikari Sorachi Shiribeshi",
      "officeName": "札幌管区気象台",
      "chName": "石駱、空知、石獅地區",
      "zhName": "石狩、空知、石狮地区",
      "koName": "이시카리・공치・고시 지방",
      "esName": "Ishikari, Sorachi, región de Shishi",
      "ptName": "Ishikari, Sorachi, região de Shishi",
      "thName": "อิชิคาริ, โซราจิ, ภูมิภาคชิชิ",
      "viName": "Ishikari, Sorachi, vùng Shishi",
      "inName": "Ishikari, Sorachi, wilayah Shishi",
      "tlName": "Ishikari, Sorachi, rehiyon ng Shishi",
      "moName": "Ишикари, Сорачи, Шиши муж",
      "buName": "Ishikari၊ Sorachi၊ Shishi ဒေသ",
      "khName": "Ishikari, Sorachi, តំបន់ Shishi",
      "neName": "इशिकारी, सोराची, शिशी क्षेत्र"
    },
    "class10": {
      "code": "016030",
      "name": "後志地方",
      "enName": "Shiribeshi Region",
      "chName": "石獅地區",
      "zhName": "石狮地区",
      "koName": "고시 지방",
      "esName": "Región de Shishi",
      "ptName": "Região de Shishi",
      "thName": "ภูมิภาคชิชิ",
      "viName": "vùng Shishi",
      "inName": "wilayah Shishi",
      "tlName": "Rehiyon ng Shishi",
      "moName": "Шиши бүс",
      "buName": "Shishi ဒေသ",
      "khName": "តំបន់ Shishi",
      "neName": "शिशि क्षेत्र"
    },
    "class15": {
      "code": "016031",
      "name": "後志北部",
      "enName": "Northern Shiribeshi"
    },
    "class20": {
      "code": "0140900",
      "name": "赤井川村",
      "enName": "Akaigawa Village",
      "kana": "あかいがわむら",
      "chName": "赤井川村",
      "zhName": "赤井川村",
      "koName": "아카이가와 촌",
      "esName": "Aldea de Akaigawa",
      "ptName": "povoado de Akaigawa",
      "thName": "หมู่บ้านอาไคกาวะ",
      "viName": "làng Akaigawa",
      "inName": "desa Akaigawa",
      "tlName": "nayon ng Akaigawa",
      "moName": "Aкайгава тосгон",
      "buName": "အာကိုင်းယိဂါ့ဝ ကျေးရွာ",
      "khName": "ភូមិ អាកៃហ្កាវ៉ា",
      "neName": "आकाईगावा गाउँ"
    }
  },
  "0142300": {
    "office": {
      "code": "016000",
      "name": "石狩・空知・後志地方",
      "enName": "Ishikari Sorachi Shiribeshi",
      "officeName": "札幌管区気象台",
      "chName": "石駱、空知、石獅地區",
      "zhName": "石狩、空知、石狮地区",
      "koName": "이시카리・공치・고시 지방",
      "esName": "Ishikari, Sorachi, región de Shishi",
      "ptName": "Ishikari, Sorachi, região de Shishi",
      "thName": "อิชิคาริ, โซราจิ, ภูมิภาคชิชิ",
      "viName": "Ishikari, Sorachi, vùng Shishi",
      "inName": "Ishikari, Sorachi, wilayah Shishi",
      "tlName": "Ishikari, Sorachi, rehiyon ng Shishi",
      "moName": "Ишикари, Сорачи, Шиши муж",
      "buName": "Ishikari၊ Sorachi၊ Shishi ဒေသ",
      "khName": "Ishikari, Sorachi, តំបន់ Shishi",
      "neName": "इशिकारी, सोराची, शिशी क्षेत्र"
    },
    "class10": {
      "code": "016020",
      "name": "空知地方",
      "enName": "Sorachi Region",
      "chName": "空知地區",
      "zhName": "空知地区",
      "koName": "공치지방",
      "esName": "región de sorachi",
      "ptName": "Região de Sorachi",
      "thName": "ภูมิภาคโซราจี",
      "viName": "vùng Sorachi",
      "inName": "wilayah Sorachi",
      "tlName": "Rehiyon ng Sorachi",
      "moName": "Сорачи муж",
      "buName": "ဆိုရာချီဒေသ",
      "khName": "តំបន់សូរ៉ាជី",
      "neName": "सोराची क्षेत्र"
    },
    "class15": {
      "code": "016023",
      "name": "南空知",
      "enName": "Southern Sorachi"
    },
    "class20": {
      "code": "0142300",
      "name": "南幌町",
      "enName": "Namporo Town",
      "kana": "なんぽろちょう",
      "chName": "南幌町",
      "zhName": "南幌町",
      "koName": "난포로 정",
      "esName": "Pueblo de Nanporo",
      "ptName": "bairro de Namporo",
      "thName": "เมืองนัมโปโระ",
      "viName": "thị trấn Namporo",
      "inName": "kota Namporo",
      "tlName": "bayan ng Namporo",
      "moName": "Нaмпоро жижиг хот",
      "buName": "နမ်ပိုရို မြို့နယ်",
      "khName": "ទីប្រជុំជន ណាំភូរ៉ូ",
      "neName": "नाम्पोरो नगर"
    }
  },
  "0142400": {
    "office": {
      "code": "016000",
      "name": "石狩・空知・後志地方",
      "enName": "Ishikari Sorachi Shiribeshi",
      "officeName": "札幌管区気象台",
      "chName": "石駱、空知、石獅地區",
      "zhName": "石狩、空知、石狮地区",
      "koName": "이시카리・공치・고시 지방",
      "esName": "Ishikari, Sorachi, región de Shishi",
      "ptName": "Ishikari, Sorachi, região de Shishi",
      "thName": "อิชิคาริ, โซราจิ, ภูมิภาคชิชิ",
      "viName": "Ishikari, Sorachi, vùng Shishi",
      "inName": "Ishikari, Sorachi, wilayah Shishi",
      "tlName": "Ishikari, Sorachi, rehiyon ng Shishi",
      "moName": "Ишикари, Сорачи, Шиши муж",
      "buName": "Ishikari၊ Sorachi၊ Shishi ဒေသ",
      "khName": "Ishikari, Sorachi, តំបន់ Shishi",
      "neName": "इशिकारी, सोराची, शिशी क्षेत्र"
    },
    "class10": {
      "code": "016020",
      "name": "空知地方",
      "enName": "Sorachi Region",
      "chName": "空知地區",
      "zhName": "空知地区",
      "koName": "공치지방",
      "esName": "región de sorachi",
      "ptName": "Região de Sorachi",
      "thName": "ภูมิภาคโซราจี",
      "viName": "vùng Sorachi",
      "inName": "wilayah Sorachi",
      "tlName": "Rehiyon ng Sorachi",
      "moName": "Сорачи муж",
      "buName": "ဆိုရာချီဒေသ",
      "khName": "តំបន់សូរ៉ាជី",
      "neName": "सोराची क्षेत्र"
    },
    "class15": {
      "code": "016022",
      "name": "中空知",
      "enName": "Middle Sorachi"
    },
    "class20": {
      "code": "0142400",
      "name": "奈井江町",
      "enName": "Naie Town",
      "kana": "ないえちょう",
      "chName": "奈井江町",
      "zhName": "奈井江町",
      "koName": "나이에 정",
      "esName": "Pueblo de Naie",
      "ptName": "bairro de Naie",
      "thName": "เมืองไนเอะ",
      "viName": "thị trấn Naie",
      "inName": "kota Naie",
      "tlName": "bayan ng Naie",
      "moName": "Нaйэ жижиг хот",
      "buName": "နိုင်းယဲ့ မြို့နယ်",
      "khName": "ទីប្រជុំជន ណេ",
      "neName": "नाइए नगर"
    }
  },
  "0142500": {
    "office": {
      "code": "016000",
      "name": "石狩・空知・後志地方",
      "enName": "Ishikari Sorachi Shiribeshi",
      "officeName": "札幌管区気象台",
      "chName": "石駱、空知、石獅地區",
      "zhName": "石狩、空知、石狮地区",
      "koName": "이시카리・공치・고시 지방",
      "esName": "Ishikari, Sorachi, región de Shishi",
      "ptName": "Ishikari, Sorachi, região de Shishi",
      "thName": "อิชิคาริ, โซราจิ, ภูมิภาคชิชิ",
      "viName": "Ishikari, Sorachi, vùng Shishi",
      "inName": "Ishikari, Sorachi, wilayah Shishi",
      "tlName": "Ishikari, Sorachi, rehiyon ng Shishi",
      "moName": "Ишикари, Сорачи, Шиши муж",
      "buName": "Ishikari၊ Sorachi၊ Shishi ဒေသ",
      "khName": "Ishikari, Sorachi, តំបន់ Shishi",
      "neName": "इशिकारी, सोराची, शिशी क्षेत्र"
    },
    "class10": {
      "code": "016020",
      "name": "空知地方",
      "enName": "Sorachi Region",
      "chName": "空知地區",
      "zhName": "空知地区",
      "koName": "공치지방",
      "esName": "región de sorachi",
      "ptName": "Região de Sorachi",
      "thName": "ภูมิภาคโซราจี",
      "viName": "vùng Sorachi",
      "inName": "wilayah Sorachi",
      "tlName": "Rehiyon ng Sorachi",
      "moName": "Сорачи муж",
      "buName": "ဆိုရာချီဒေသ",
      "khName": "តំបន់សូរ៉ាជី",
      "neName": "सोराची क्षेत्र"
    },
    "class15": {
      "code": "016022",
      "name": "中空知",
      "enName": "Middle Sorachi"
    },
    "class20": {
      "code": "0142500",
      "name": "上砂川町",
      "enName": "Kamisunagawa Town",
      "kana": "かみすながわちょう",
      "chName": "上砂川町",
      "zhName": "上砂川町",
      "koName": "가미스나가와 정",
      "esName": "Pueblo de Kamisunagawa",
      "ptName": "bairro de Kamisunagawa",
      "thName": "เมืองคามาสึนะกาวา",
      "viName": "thị trấn Kamisunagawa",
      "inName": "kota Kamisunagawa",
      "tlName": "bayan ng Kamisunagawa",
      "moName": "Камисүнaгава жижиг хот",
      "buName": "ခါမိဆုနားဂါ့ဝ မြို့နယ်",
      "khName": "ទីប្រជុំជន កាមិសូណាហ្កាវ៉ា",
      "neName": "कामिसुनागावा नगर"
    }
  },
  "0142700": {
    "office": {
      "code": "016000",
      "name": "石狩・空知・後志地方",
      "enName": "Ishikari Sorachi Shiribeshi",
      "officeName": "札幌管区気象台",
      "chName": "石駱、空知、石獅地區",
      "zhName": "石狩、空知、石狮地区",
      "koName": "이시카리・공치・고시 지방",
      "esName": "Ishikari, Sorachi, región de Shishi",
      "ptName": "Ishikari, Sorachi, região de Shishi",
      "thName": "อิชิคาริ, โซราจิ, ภูมิภาคชิชิ",
      "viName": "Ishikari, Sorachi, vùng Shishi",
      "inName": "Ishikari, Sorachi, wilayah Shishi",
      "tlName": "Ishikari, Sorachi, rehiyon ng Shishi",
      "moName": "Ишикари, Сорачи, Шиши муж",
      "buName": "Ishikari၊ Sorachi၊ Shishi ဒေသ",
      "khName": "Ishikari, Sorachi, តំបន់ Shishi",
      "neName": "इशिकारी, सोराची, शिशी क्षेत्र"
    },
    "class10": {
      "code": "016020",
      "name": "空知地方",
      "enName": "Sorachi Region",
      "chName": "空知地區",
      "zhName": "空知地区",
      "koName": "공치지방",
      "esName": "región de sorachi",
      "ptName": "Região de Sorachi",
      "thName": "ภูมิภาคโซราจี",
      "viName": "vùng Sorachi",
      "inName": "wilayah Sorachi",
      "tlName": "Rehiyon ng Sorachi",
      "moName": "Сорачи муж",
      "buName": "ဆိုရာချီဒေသ",
      "khName": "តំបន់សូរ៉ាជី",
      "neName": "सोराची क्षेत्र"
    },
    "class15": {
      "code": "016023",
      "name": "南空知",
      "enName": "Southern Sorachi"
    },
    "class20": {
      "code": "0142700",
      "name": "由仁町",
      "enName": "Yuni Town",
      "kana": "ゆにちょう",
      "chName": "由仁町",
      "zhName": "由仁町",
      "koName": "유니 정",
      "esName": "Pueblo de Yuni",
      "ptName": "bairro de Yuni",
      "thName": "เมืองยูนิ",
      "viName": "thị trấn Yuni",
      "inName": "kota Yuni",
      "tlName": "bayan ng Yuni",
      "moName": "Юни жижиг хот",
      "buName": "ယူနိ မြို့နယ်",
      "khName": "ទីប្រជុំជន យូនី",
      "neName": "युनी नगर"
    }
  },
  "0142800": {
    "office": {
      "code": "016000",
      "name": "石狩・空知・後志地方",
      "enName": "Ishikari Sorachi Shiribeshi",
      "officeName": "札幌管区気象台",
      "chName": "石駱、空知、石獅地區",
      "zhName": "石狩、空知、石狮地区",
      "koName": "이시카리・공치・고시 지방",
      "esName": "Ishikari, Sorachi, región de Shishi",
      "ptName": "Ishikari, Sorachi, região de Shishi",
      "thName": "อิชิคาริ, โซราจิ, ภูมิภาคชิชิ",
      "viName": "Ishikari, Sorachi, vùng Shishi",
      "inName": "Ishikari, Sorachi, wilayah Shishi",
      "tlName": "Ishikari, Sorachi, rehiyon ng Shishi",
      "moName": "Ишикари, Сорачи, Шиши муж",
      "buName": "Ishikari၊ Sorachi၊ Shishi ဒေသ",
      "khName": "Ishikari, Sorachi, តំបន់ Shishi",
      "neName": "इशिकारी, सोराची, शिशी क्षेत्र"
    },
    "class10": {
      "code": "016020",
      "name": "空知地方",
      "enName": "Sorachi Region",
      "chName": "空知地區",
      "zhName": "空知地区",
      "koName": "공치지방",
      "esName": "región de sorachi",
      "ptName": "Região de Sorachi",
      "thName": "ภูมิภาคโซราจี",
      "viName": "vùng Sorachi",
      "inName": "wilayah Sorachi",
      "tlName": "Rehiyon ng Sorachi",
      "moName": "Сорачи муж",
      "buName": "ဆိုရာချီဒေသ",
      "khName": "តំបន់សូរ៉ាជី",
      "neName": "सोराची क्षेत्र"
    },
    "class15": {
      "code": "016023",
      "name": "南空知",
      "enName": "Southern Sorachi"
    },
    "class20": {
      "code": "0142800",
      "name": "長沼町",
      "enName": "Naganuma Town",
      "kana": "ながぬまちょう",
      "chName": "长沼町",
      "zhName": "長沼町",
      "koName": "나가누마 정",
      "esName": "Pueblo de Naganuma",
      "ptName": "bairro de Naganuma",
      "thName": "เมืองนางานุมะ",
      "viName": "thị trấn Naganuma",
      "inName": "kota Naganuma",
      "tlName": "bayan ng Naganuma",
      "moName": "Наганүма жижиг хот",
      "buName": "နာဂါ့နုမ မြို့နယ်",
      "khName": "ទីប្រជុំជន ណាហ្កានូម៉ា",
      "neName": "नागानुमा नगर"
    }
  },
  "0142900": {
    "office": {
      "code": "016000",
      "name": "石狩・空知・後志地方",
      "enName": "Ishikari Sorachi Shiribeshi",
      "officeName": "札幌管区気象台",
      "chName": "石駱、空知、石獅地區",
      "zhName": "石狩、空知、石狮地区",
      "koName": "이시카리・공치・고시 지방",
      "esName": "Ishikari, Sorachi, región de Shishi",
      "ptName": "Ishikari, Sorachi, região de Shishi",
      "thName": "อิชิคาริ, โซราจิ, ภูมิภาคชิชิ",
      "viName": "Ishikari, Sorachi, vùng Shishi",
      "inName": "Ishikari, Sorachi, wilayah Shishi",
      "tlName": "Ishikari, Sorachi, rehiyon ng Shishi",
      "moName": "Ишикари, Сорачи, Шиши муж",
      "buName": "Ishikari၊ Sorachi၊ Shishi ဒေသ",
      "khName": "Ishikari, Sorachi, តំបន់ Shishi",
      "neName": "इशिकारी, सोराची, शिशी क्षेत्र"
    },
    "class10": {
      "code": "016020",
      "name": "空知地方",
      "enName": "Sorachi Region",
      "chName": "空知地區",
      "zhName": "空知地区",
      "koName": "공치지방",
      "esName": "región de sorachi",
      "ptName": "Região de Sorachi",
      "thName": "ภูมิภาคโซราจี",
      "viName": "vùng Sorachi",
      "inName": "wilayah Sorachi",
      "tlName": "Rehiyon ng Sorachi",
      "moName": "Сорачи муж",
      "buName": "ဆိုရာချီဒေသ",
      "khName": "តំបន់សូរ៉ាជី",
      "neName": "सोराची क्षेत्र"
    },
    "class15": {
      "code": "016023",
      "name": "南空知",
      "enName": "Southern Sorachi"
    },
    "class20": {
      "code": "0142900",
      "name": "栗山町",
      "enName": "Kuriyama Town",
      "kana": "くりやまちょう",
      "chName": "栗山町",
      "zhName": "栗山町",
      "koName": "구리야마 정",
      "esName": "Pueblo de Kuriyama",
      "ptName": "bairro de Kuriyama",
      "thName": "เมืองคุริยามะ",
      "viName": "thị trấn Kuriyama",
      "inName": "kota Kuriyama",
      "tlName": "bayan ng Kuriyama",
      "moName": "Күриямa жижиг хот",
      "buName": "ခူရိယာ့မ မြို့နယ်",
      "khName": "ទីប្រជុំជន គូរីយ៉ាម៉ា",
      "neName": "कुरियामा नगर"
    }
  },
  "0143000": {
    "office": {
      "code": "016000",
      "name": "石狩・空知・後志地方",
      "enName": "Ishikari Sorachi Shiribeshi",
      "officeName": "札幌管区気象台",
      "chName": "石駱、空知、石獅地區",
      "zhName": "石狩、空知、石狮地区",
      "koName": "이시카리・공치・고시 지방",
      "esName": "Ishikari, Sorachi, región de Shishi",
      "ptName": "Ishikari, Sorachi, região de Shishi",
      "thName": "อิชิคาริ, โซราจิ, ภูมิภาคชิชิ",
      "viName": "Ishikari, Sorachi, vùng Shishi",
      "inName": "Ishikari, Sorachi, wilayah Shishi",
      "tlName": "Ishikari, Sorachi, rehiyon ng Shishi",
      "moName": "Ишикари, Сорачи, Шиши муж",
      "buName": "Ishikari၊ Sorachi၊ Shishi ဒေသ",
      "khName": "Ishikari, Sorachi, តំបន់ Shishi",
      "neName": "इशिकारी, सोराची, शिशी क्षेत्र"
    },
    "class10": {
      "code": "016020",
      "name": "空知地方",
      "enName": "Sorachi Region",
      "chName": "空知地區",
      "zhName": "空知地区",
      "koName": "공치지방",
      "esName": "región de sorachi",
      "ptName": "Região de Sorachi",
      "thName": "ภูมิภาคโซราจี",
      "viName": "vùng Sorachi",
      "inName": "wilayah Sorachi",
      "tlName": "Rehiyon ng Sorachi",
      "moName": "Сорачи муж",
      "buName": "ဆိုရာချီဒေသ",
      "khName": "តំបន់សូរ៉ាជី",
      "neName": "सोराची क्षेत्र"
    },
    "class15": {
      "code": "016023",
      "name": "南空知",
      "enName": "Southern Sorachi"
    },
    "class20": {
      "code": "0143000",
      "name": "月形町",
      "enName": "Tsukigata Town",
      "kana": "つきがたちょう",
      "chName": "月形町",
      "zhName": "月形町",
      "koName": "쓰키가타 정",
      "esName": "Pueblo de Tsukigata",
      "ptName": "bairro de Tsukigata",
      "thName": "เมืองสึกิกาตะ",
      "viName": "thị trấn Tsukigata",
      "inName": "kota Tsukigata",
      "tlName": "bayan ng Tsukigata",
      "moName": "Цүкигaта жижиг хот",
      "buName": "ဆုကီဂါ့တ မြို့နယ်",
      "khName": "ទីប្រជុំជន ស៊ូគីកាតា",
      "neName": "त्सुकिगाता नगर"
    }
  },
  "0143100": {
    "office": {
      "code": "016000",
      "name": "石狩・空知・後志地方",
      "enName": "Ishikari Sorachi Shiribeshi",
      "officeName": "札幌管区気象台",
      "chName": "石駱、空知、石獅地區",
      "zhName": "石狩、空知、石狮地区",
      "koName": "이시카리・공치・고시 지방",
      "esName": "Ishikari, Sorachi, región de Shishi",
      "ptName": "Ishikari, Sorachi, região de Shishi",
      "thName": "อิชิคาริ, โซราจิ, ภูมิภาคชิชิ",
      "viName": "Ishikari, Sorachi, vùng Shishi",
      "inName": "Ishikari, Sorachi, wilayah Shishi",
      "tlName": "Ishikari, Sorachi, rehiyon ng Shishi",
      "moName": "Ишикари, Сорачи, Шиши муж",
      "buName": "Ishikari၊ Sorachi၊ Shishi ဒေသ",
      "khName": "Ishikari, Sorachi, តំបន់ Shishi",
      "neName": "इशिकारी, सोराची, शिशी क्षेत्र"
    },
    "class10": {
      "code": "016020",
      "name": "空知地方",
      "enName": "Sorachi Region",
      "chName": "空知地區",
      "zhName": "空知地区",
      "koName": "공치지방",
      "esName": "región de sorachi",
      "ptName": "Região de Sorachi",
      "thName": "ภูมิภาคโซราจี",
      "viName": "vùng Sorachi",
      "inName": "wilayah Sorachi",
      "tlName": "Rehiyon ng Sorachi",
      "moName": "Сорачи муж",
      "buName": "ဆိုရာချီဒေသ",
      "khName": "តំបន់សូរ៉ាជី",
      "neName": "सोराची क्षेत्र"
    },
    "class15": {
      "code": "016022",
      "name": "中空知",
      "enName": "Middle Sorachi"
    },
    "class20": {
      "code": "0143100",
      "name": "浦臼町",
      "enName": "Urausu Town",
      "kana": "うらうすちょう",
      "chName": "浦臼町",
      "zhName": "浦臼町",
      "koName": "우라우스 정",
      "esName": "Pueblo de Urausu",
      "ptName": "bairro de Urausu",
      "thName": "เมืองอุระอุสึ",
      "viName": "thị trấn Urausu",
      "inName": "kota Urausu",
      "tlName": "bayan ng Urausu",
      "moName": "Үраүсү жижиг хот",
      "buName": "ဦရားဆု မြို့နယ်",
      "khName": "ទីប្រជុំជន យូរ៉ាស៊ូ",
      "neName": "उराउसु नगर"
    }
  },
  "0143200": {
    "office": {
      "code": "016000",
      "name": "石狩・空知・後志地方",
      "enName": "Ishikari Sorachi Shiribeshi",
      "officeName": "札幌管区気象台",
      "chName": "石駱、空知、石獅地區",
      "zhName": "石狩、空知、石狮地区",
      "koName": "이시카리・공치・고시 지방",
      "esName": "Ishikari, Sorachi, región de Shishi",
      "ptName": "Ishikari, Sorachi, região de Shishi",
      "thName": "อิชิคาริ, โซราจิ, ภูมิภาคชิชิ",
      "viName": "Ishikari, Sorachi, vùng Shishi",
      "inName": "Ishikari, Sorachi, wilayah Shishi",
      "tlName": "Ishikari, Sorachi, rehiyon ng Shishi",
      "moName": "Ишикари, Сорачи, Шиши муж",
      "buName": "Ishikari၊ Sorachi၊ Shishi ဒေသ",
      "khName": "Ishikari, Sorachi, តំបន់ Shishi",
      "neName": "इशिकारी, सोराची, शिशी क्षेत्र"
    },
    "class10": {
      "code": "016020",
      "name": "空知地方",
      "enName": "Sorachi Region",
      "chName": "空知地區",
      "zhName": "空知地区",
      "koName": "공치지방",
      "esName": "región de sorachi",
      "ptName": "Região de Sorachi",
      "thName": "ภูมิภาคโซราจี",
      "viName": "vùng Sorachi",
      "inName": "wilayah Sorachi",
      "tlName": "Rehiyon ng Sorachi",
      "moName": "Сорачи муж",
      "buName": "ဆိုရာချီဒေသ",
      "khName": "តំបន់សូរ៉ាជី",
      "neName": "सोराची क्षेत्र"
    },
    "class15": {
      "code": "016022",
      "name": "中空知",
      "enName": "Middle Sorachi"
    },
    "class20": {
      "code": "0143200",
      "name": "新十津川町",
      "enName": "Shintotsukawa Town",
      "kana": "しんとつかわちょう",
      "chName": "新十津川町",
      "zhName": "新十津川町",
      "koName": "신토쓰카와 정",
      "esName": "Pueblo de Shintotsugawa",
      "ptName": "bairro de Shintotsukawa",
      "thName": "เมืองชินโตสึคาวะ",
      "viName": "thị trấn Shintotsukawa",
      "inName": "kota Shintotsukawa",
      "tlName": "bayan ng Shintotsukawa",
      "moName": "Шинтоцүкава жижиг хот",
      "buName": "ရှင်းတို့ဆုကာ့ဝ မြို့နယ်",
      "khName": "ទីប្រជុំជន ស៊ីនតុស៊ូកាវ៉ា",
      "neName": "शिन्तोत्सुकावा नगर"
    }
  },
  "0143300": {
    "office": {
      "code": "016000",
      "name": "石狩・空知・後志地方",
      "enName": "Ishikari Sorachi Shiribeshi",
      "officeName": "札幌管区気象台",
      "chName": "石駱、空知、石獅地區",
      "zhName": "石狩、空知、石狮地区",
      "koName": "이시카리・공치・고시 지방",
      "esName": "Ishikari, Sorachi, región de Shishi",
      "ptName": "Ishikari, Sorachi, região de Shishi",
      "thName": "อิชิคาริ, โซราจิ, ภูมิภาคชิชิ",
      "viName": "Ishikari, Sorachi, vùng Shishi",
      "inName": "Ishikari, Sorachi, wilayah Shishi",
      "tlName": "Ishikari, Sorachi, rehiyon ng Shishi",
      "moName": "Ишикари, Сорачи, Шиши муж",
      "buName": "Ishikari၊ Sorachi၊ Shishi ဒေသ",
      "khName": "Ishikari, Sorachi, តំបន់ Shishi",
      "neName": "इशिकारी, सोराची, शिशी क्षेत्र"
    },
    "class10": {
      "code": "016020",
      "name": "空知地方",
      "enName": "Sorachi Region",
      "chName": "空知地區",
      "zhName": "空知地区",
      "koName": "공치지방",
      "esName": "región de sorachi",
      "ptName": "Região de Sorachi",
      "thName": "ภูมิภาคโซราจี",
      "viName": "vùng Sorachi",
      "inName": "wilayah Sorachi",
      "tlName": "Rehiyon ng Sorachi",
      "moName": "Сорачи муж",
      "buName": "ဆိုရာချီဒေသ",
      "khName": "តំបន់សូរ៉ាជី",
      "neName": "सोराची क्षेत्र"
    },
    "class15": {
      "code": "016021",
      "name": "北空知",
      "enName": "Northern Sorachi"
    },
    "class20": {
      "code": "0143300",
      "name": "妹背牛町",
      "enName": "Moseushi Town",
      "kana": "もせうしちょう",
      "chName": "妹背牛町",
      "zhName": "妹背牛町",
      "koName": "모세우시 정",
      "esName": "Pueblo de Moseushi",
      "ptName": "bairro de Moseushi",
      "thName": "เมืองโมเซอุชิ",
      "viName": "thị trấn Moseushi",
      "inName": "kota Moseushi",
      "tlName": "bayan ng Moseushi",
      "moName": "Мосэүши жижиг хот",
      "buName": "မိုဆေးယုရှိ မြို့နယ်",
      "khName": "ទីប្រជុំជន ម៉ូសស៊ូស៊ី",
      "neName": "मोसेउशी नगर"
    }
  },
  "0143400": {
    "office": {
      "code": "016000",
      "name": "石狩・空知・後志地方",
      "enName": "Ishikari Sorachi Shiribeshi",
      "officeName": "札幌管区気象台",
      "chName": "石駱、空知、石獅地區",
      "zhName": "石狩、空知、石狮地区",
      "koName": "이시카리・공치・고시 지방",
      "esName": "Ishikari, Sorachi, región de Shishi",
      "ptName": "Ishikari, Sorachi, região de Shishi",
      "thName": "อิชิคาริ, โซราจิ, ภูมิภาคชิชิ",
      "viName": "Ishikari, Sorachi, vùng Shishi",
      "inName": "Ishikari, Sorachi, wilayah Shishi",
      "tlName": "Ishikari, Sorachi, rehiyon ng Shishi",
      "moName": "Ишикари, Сорачи, Шиши муж",
      "buName": "Ishikari၊ Sorachi၊ Shishi ဒေသ",
      "khName": "Ishikari, Sorachi, តំបន់ Shishi",
      "neName": "इशिकारी, सोराची, शिशी क्षेत्र"
    },
    "class10": {
      "code": "016020",
      "name": "空知地方",
      "enName": "Sorachi Region",
      "chName": "空知地區",
      "zhName": "空知地区",
      "koName": "공치지방",
      "esName": "región de sorachi",
      "ptName": "Região de Sorachi",
      "thName": "ภูมิภาคโซราจี",
      "viName": "vùng Sorachi",
      "inName": "wilayah Sorachi",
      "tlName": "Rehiyon ng Sorachi",
      "moName": "Сорачи муж",
      "buName": "ဆိုရာချီဒေသ",
      "khName": "តំបន់សូរ៉ាជី",
      "neName": "सोराची क्षेत्र"
    },
    "class15": {
      "code": "016021",
      "name": "北空知",
      "enName": "Northern Sorachi"
    },
    "class20": {
      "code": "0143400",
      "name": "秩父別町",
      "enName": "Chippubetsu Town",
      "kana": "ちっぷべつちょう",
      "chName": "秩父别町",
      "zhName": "秩父別町",
      "koName": "짓푸베쓰 정",
      "esName": "Pueblo de Chippubetsu",
      "ptName": "bairro de Chippubetsu",
      "thName": "เมืองชิปปุเบ็ตสึ",
      "viName": "thị trấn Chippubetsu",
      "inName": "kota Chippubetsu",
      "tlName": "bayan ng Chippubetsu",
      "moName": "Чиппүбэцү жижиг хот",
      "buName": "ကျီပုဗေ့စု မြို့နယ်",
      "khName": "ទីប្រជុំជន​ ជីពូបេតស៊ូ",
      "neName": "चिप्पुबेत्सु नगर"
    }
  },
  "0143600": {
    "office": {
      "code": "016000",
      "name": "石狩・空知・後志地方",
      "enName": "Ishikari Sorachi Shiribeshi",
      "officeName": "札幌管区気象台",
      "chName": "石駱、空知、石獅地區",
      "zhName": "石狩、空知、石狮地区",
      "koName": "이시카리・공치・고시 지방",
      "esName": "Ishikari, Sorachi, región de Shishi",
      "ptName": "Ishikari, Sorachi, região de Shishi",
      "thName": "อิชิคาริ, โซราจิ, ภูมิภาคชิชิ",
      "viName": "Ishikari, Sorachi, vùng Shishi",
      "inName": "Ishikari, Sorachi, wilayah Shishi",
      "tlName": "Ishikari, Sorachi, rehiyon ng Shishi",
      "moName": "Ишикари, Сорачи, Шиши муж",
      "buName": "Ishikari၊ Sorachi၊ Shishi ဒေသ",
      "khName": "Ishikari, Sorachi, តំបន់ Shishi",
      "neName": "इशिकारी, सोराची, शिशी क्षेत्र"
    },
    "class10": {
      "code": "016020",
      "name": "空知地方",
      "enName": "Sorachi Region",
      "chName": "空知地區",
      "zhName": "空知地区",
      "koName": "공치지방",
      "esName": "región de sorachi",
      "ptName": "Região de Sorachi",
      "thName": "ภูมิภาคโซราจี",
      "viName": "vùng Sorachi",
      "inName": "wilayah Sorachi",
      "tlName": "Rehiyon ng Sorachi",
      "moName": "Сорачи муж",
      "buName": "ဆိုရာချီဒေသ",
      "khName": "តំបន់សូរ៉ាជី",
      "neName": "सोराची क्षेत्र"
    },
    "class15": {
      "code": "016022",
      "name": "中空知",
      "enName": "Middle Sorachi"
    },
    "class20": {
      "code": "0143600",
      "name": "雨竜町",
      "enName": "Uryu Town",
      "kana": "うりゅうちょう",
      "chName": "雨龙町",
      "zhName": "雨龍町",
      "koName": "우류 정",
      "esName": "Pueblo de Uryu",
      "ptName": "bairro de Uryu",
      "thName": "เมืองอุริว",
      "viName": "thị trấn Uryu",
      "inName": "kota Uryu",
      "tlName": "bayan ng Uryu",
      "moName": "Үрю жижиг хот",
      "buName": "ဦဒယု မြို့နယ်",
      "khName": "ទីប្រជុំជន អ៊ូរ៉ាយូ",
      "neName": "उरयु नगर"
    }
  },
  "0143700": {
    "office": {
      "code": "016000",
      "name": "石狩・空知・後志地方",
      "enName": "Ishikari Sorachi Shiribeshi",
      "officeName": "札幌管区気象台",
      "chName": "石駱、空知、石獅地區",
      "zhName": "石狩、空知、石狮地区",
      "koName": "이시카리・공치・고시 지방",
      "esName": "Ishikari, Sorachi, región de Shishi",
      "ptName": "Ishikari, Sorachi, região de Shishi",
      "thName": "อิชิคาริ, โซราจิ, ภูมิภาคชิชิ",
      "viName": "Ishikari, Sorachi, vùng Shishi",
      "inName": "Ishikari, Sorachi, wilayah Shishi",
      "tlName": "Ishikari, Sorachi, rehiyon ng Shishi",
      "moName": "Ишикари, Сорачи, Шиши муж",
      "buName": "Ishikari၊ Sorachi၊ Shishi ဒေသ",
      "khName": "Ishikari, Sorachi, តំបន់ Shishi",
      "neName": "इशिकारी, सोराची, शिशी क्षेत्र"
    },
    "class10": {
      "code": "016020",
      "name": "空知地方",
      "enName": "Sorachi Region",
      "chName": "空知地區",
      "zhName": "空知地区",
      "koName": "공치지방",
      "esName": "región de sorachi",
      "ptName": "Região de Sorachi",
      "thName": "ภูมิภาคโซราจี",
      "viName": "vùng Sorachi",
      "inName": "wilayah Sorachi",
      "tlName": "Rehiyon ng Sorachi",
      "moName": "Сорачи муж",
      "buName": "ဆိုရာချီဒေသ",
      "khName": "តំបន់សូរ៉ាជី",
      "neName": "सोराची क्षेत्र"
    },
    "class15": {
      "code": "016021",
      "name": "北空知",
      "enName": "Northern Sorachi"
    },
    "class20": {
      "code": "0143700",
      "name": "北竜町",
      "enName": "Hokuryu Town",
      "kana": "ほくりゅうちょう",
      "chName": "北龙町",
      "zhName": "北龍町",
      "koName": "호쿠류우 정",
      "esName": "Pueblo de Kokuryu",
      "ptName": "bairro de Hokuryu",
      "thName": "เมืองโฮคุริว",
      "viName": "thị trấn Hokuryu",
      "inName": "kota Hokuryu",
      "tlName": "bayan ng Hokuryu",
      "moName": "Хокүрю жижиг хот",
      "buName": "ဟိုးကို့ယု မြို့နယ်",
      "khName": "ទីប្រជុំជន ហុកគុរីយូ",
      "neName": "होकुरयु नगर"
    }
  },
  "0143800": {
    "office": {
      "code": "016000",
      "name": "石狩・空知・後志地方",
      "enName": "Ishikari Sorachi Shiribeshi",
      "officeName": "札幌管区気象台",
      "chName": "石駱、空知、石獅地區",
      "zhName": "石狩、空知、石狮地区",
      "koName": "이시카리・공치・고시 지방",
      "esName": "Ishikari, Sorachi, región de Shishi",
      "ptName": "Ishikari, Sorachi, região de Shishi",
      "thName": "อิชิคาริ, โซราจิ, ภูมิภาคชิชิ",
      "viName": "Ishikari, Sorachi, vùng Shishi",
      "inName": "Ishikari, Sorachi, wilayah Shishi",
      "tlName": "Ishikari, Sorachi, rehiyon ng Shishi",
      "moName": "Ишикари, Сорачи, Шиши муж",
      "buName": "Ishikari၊ Sorachi၊ Shishi ဒေသ",
      "khName": "Ishikari, Sorachi, តំបន់ Shishi",
      "neName": "इशिकारी, सोराची, शिशी क्षेत्र"
    },
    "class10": {
      "code": "016020",
      "name": "空知地方",
      "enName": "Sorachi Region",
      "chName": "空知地區",
      "zhName": "空知地区",
      "koName": "공치지방",
      "esName": "región de sorachi",
      "ptName": "Região de Sorachi",
      "thName": "ภูมิภาคโซราจี",
      "viName": "vùng Sorachi",
      "inName": "wilayah Sorachi",
      "tlName": "Rehiyon ng Sorachi",
      "moName": "Сорачи муж",
      "buName": "ဆိုရာချီဒေသ",
      "khName": "តំបន់សូរ៉ាជី",
      "neName": "सोराची क्षेत्र"
    },
    "class15": {
      "code": "016021",
      "name": "北空知",
      "enName": "Northern Sorachi"
    },
    "class20": {
      "code": "0143800",
      "name": "沼田町",
      "enName": "Numata Town",
      "kana": "ぬまたちょう",
      "chName": "沼田町",
      "zhName": "沼田町",
      "koName": "누마타 정",
      "esName": "Pueblo de Numata",
      "ptName": "bairro de Numata",
      "thName": "เมืองนุมาตะ",
      "viName": "thị trấn Numata",
      "inName": "kota Numata",
      "tlName": "bayan ng Numata",
      "moName": "Нүмaта жижиг хот",
      "buName": "နူမာ့တ မြို့နယ်",
      "khName": "ទីប្រជុំជន នូម៉ាតា",
      "neName": "नुमाता नगर"
    }
  },
  "0145200": {
    "office": {
      "code": "012000",
      "name": "上川・留萌地方",
      "enName": "Kamikawa Rumoi",
      "officeName": "旭川地方気象台",
      "chName": "上川/留萌地區",
      "zhName": "上川/留萌地区",
      "koName": "카미카와·루모에 지방",
      "esName": "Región de Kamikawa/Rumoi",
      "ptName": "Região de Kamikawa/Rumoi",
      "thName": "ภูมิภาคคามิคาวะ/รุโมอิ",
      "viName": "Vùng Kamikawa/Rumoi",
      "inName": "Wilayah Kamikawa/Rumoi",
      "tlName": "Rehiyon ng Kamikawa/Rumoi",
      "moName": "Камикава/Румой бүс нутаг",
      "buName": "Kamikawa/Rumoi ဒေသ",
      "khName": "តំបន់ Kamikawa/Rumoi",
      "neName": "कामिकावा/रुमोई क्षेत्र"
    },
    "class10": {
      "code": "012010",
      "name": "上川地方",
      "enName": "Kamikawa Region",
      "chName": "上川地區",
      "zhName": "上川地区",
      "koName": "카미카와 지방",
      "esName": "Región de Kamikawa",
      "ptName": "Região de Kamikawa",
      "thName": "ภูมิภาคคามิคาวะ",
      "viName": "vùng Kamikawa",
      "inName": "wilayah Kamikawa",
      "tlName": "Rehiyon ng Kamikawa",
      "moName": "Камикава муж",
      "buName": "Kamikawa ဒေသ",
      "khName": "តំបន់ Kamikawa",
      "neName": "कामिकावा क्षेत्र"
    },
    "class15": {
      "code": "012012",
      "name": "上川中部",
      "enName": "Middle Kamikawa"
    },
    "class20": {
      "code": "0145200",
      "name": "鷹栖町",
      "enName": "Takasu Town",
      "kana": "たかすちょう",
      "chName": "鹰栖町",
      "zhName": "鷹棲町",
      "koName": "다카스 정",
      "esName": "Pueblo de Takasu",
      "ptName": "bairro de Takasu",
      "thName": "เมืองทากาสุ",
      "viName": "thị trấn Takasu",
      "inName": "kota Takasu",
      "tlName": "bayan ng Takasu",
      "moName": "Такасү жижиг хот",
      "buName": "တာကာ့ဆု မြို့နယ်",
      "khName": "ទីប្រជុំជន តាកាស៊ូ",
      "neName": "ताकासु नगर"
    }
  },
  "0145300": {
    "office": {
      "code": "012000",
      "name": "上川・留萌地方",
      "enName": "Kamikawa Rumoi",
      "officeName": "旭川地方気象台",
      "chName": "上川/留萌地區",
      "zhName": "上川/留萌地区",
      "koName": "카미카와·루모에 지방",
      "esName": "Región de Kamikawa/Rumoi",
      "ptName": "Região de Kamikawa/Rumoi",
      "thName": "ภูมิภาคคามิคาวะ/รุโมอิ",
      "viName": "Vùng Kamikawa/Rumoi",
      "inName": "Wilayah Kamikawa/Rumoi",
      "tlName": "Rehiyon ng Kamikawa/Rumoi",
      "moName": "Камикава/Румой бүс нутаг",
      "buName": "Kamikawa/Rumoi ဒေသ",
      "khName": "តំបន់ Kamikawa/Rumoi",
      "neName": "कामिकावा/रुमोई क्षेत्र"
    },
    "class10": {
      "code": "012010",
      "name": "上川地方",
      "enName": "Kamikawa Region",
      "chName": "上川地區",
      "zhName": "上川地区",
      "koName": "카미카와 지방",
      "esName": "Región de Kamikawa",
      "ptName": "Região de Kamikawa",
      "thName": "ภูมิภาคคามิคาวะ",
      "viName": "vùng Kamikawa",
      "inName": "wilayah Kamikawa",
      "tlName": "Rehiyon ng Kamikawa",
      "moName": "Камикава муж",
      "buName": "Kamikawa ဒေသ",
      "khName": "តំបន់ Kamikawa",
      "neName": "कामिकावा क्षेत्र"
    },
    "class15": {
      "code": "012012",
      "name": "上川中部",
      "enName": "Middle Kamikawa"
    },
    "class20": {
      "code": "0145300",
      "name": "東神楽町",
      "enName": "Higashikagura Town",
      "kana": "ひがしかぐらちょう",
      "chName": "东神乐町",
      "zhName": "東神樂町",
      "koName": "히가시카구라 정",
      "esName": "Pueblo de Higashikagura",
      "ptName": "bairro de Higashikagura",
      "thName": "เมืองฮิงาชิคากุระ",
      "viName": "thị trấn Higashikagura",
      "inName": "kota Higashikagura",
      "tlName": "bayan ng Higashikagura",
      "moName": "Хигaшикагүра жижиг хот",
      "buName": "ဟီဂါ့ရှိကားဂုရ မြို့နယ်",
      "khName": "ទីប្រជុំជន ហ៊ីហ្កាស៊ីកាហ្កូរ៉ា",
      "neName": "हिगाशिकागुरा नगर"
    }
  },
  "0145400": {
    "office": {
      "code": "012000",
      "name": "上川・留萌地方",
      "enName": "Kamikawa Rumoi",
      "officeName": "旭川地方気象台",
      "chName": "上川/留萌地區",
      "zhName": "上川/留萌地区",
      "koName": "카미카와·루모에 지방",
      "esName": "Región de Kamikawa/Rumoi",
      "ptName": "Região de Kamikawa/Rumoi",
      "thName": "ภูมิภาคคามิคาวะ/รุโมอิ",
      "viName": "Vùng Kamikawa/Rumoi",
      "inName": "Wilayah Kamikawa/Rumoi",
      "tlName": "Rehiyon ng Kamikawa/Rumoi",
      "moName": "Камикава/Румой бүс нутаг",
      "buName": "Kamikawa/Rumoi ဒေသ",
      "khName": "តំបន់ Kamikawa/Rumoi",
      "neName": "कामिकावा/रुमोई क्षेत्र"
    },
    "class10": {
      "code": "012010",
      "name": "上川地方",
      "enName": "Kamikawa Region",
      "chName": "上川地區",
      "zhName": "上川地区",
      "koName": "카미카와 지방",
      "esName": "Región de Kamikawa",
      "ptName": "Região de Kamikawa",
      "thName": "ภูมิภาคคามิคาวะ",
      "viName": "vùng Kamikawa",
      "inName": "wilayah Kamikawa",
      "tlName": "Rehiyon ng Kamikawa",
      "moName": "Камикава муж",
      "buName": "Kamikawa ဒေသ",
      "khName": "តំបន់ Kamikawa",
      "neName": "कामिकावा क्षेत्र"
    },
    "class15": {
      "code": "012012",
      "name": "上川中部",
      "enName": "Middle Kamikawa"
    },
    "class20": {
      "code": "0145400",
      "name": "当麻町",
      "enName": "Toma Town",
      "kana": "とうまちょう",
      "chName": "当麻町",
      "zhName": "當麻町",
      "koName": "도마 정",
      "esName": "Pueblo de Toma",
      "ptName": "bairro de Toma",
      "thName": "เมืองโทมะ",
      "viName": "thị trấn Toma",
      "inName": "kota Toma",
      "tlName": "bayan ng Toma",
      "moName": "Томa жижиг хот",
      "buName": "တိုမာ မြို့နယ်",
      "khName": "ទីប្រជុំជន តូម៉ា",
      "neName": "तोमा नगर"
    }
  },
  "0145500": {
    "office": {
      "code": "012000",
      "name": "上川・留萌地方",
      "enName": "Kamikawa Rumoi",
      "officeName": "旭川地方気象台",
      "chName": "上川/留萌地區",
      "zhName": "上川/留萌地区",
      "koName": "카미카와·루모에 지방",
      "esName": "Región de Kamikawa/Rumoi",
      "ptName": "Região de Kamikawa/Rumoi",
      "thName": "ภูมิภาคคามิคาวะ/รุโมอิ",
      "viName": "Vùng Kamikawa/Rumoi",
      "inName": "Wilayah Kamikawa/Rumoi",
      "tlName": "Rehiyon ng Kamikawa/Rumoi",
      "moName": "Камикава/Румой бүс нутаг",
      "buName": "Kamikawa/Rumoi ဒေသ",
      "khName": "តំបន់ Kamikawa/Rumoi",
      "neName": "कामिकावा/रुमोई क्षेत्र"
    },
    "class10": {
      "code": "012010",
      "name": "上川地方",
      "enName": "Kamikawa Region",
      "chName": "上川地區",
      "zhName": "上川地区",
      "koName": "카미카와 지방",
      "esName": "Región de Kamikawa",
      "ptName": "Região de Kamikawa",
      "thName": "ภูมิภาคคามิคาวะ",
      "viName": "vùng Kamikawa",
      "inName": "wilayah Kamikawa",
      "tlName": "Rehiyon ng Kamikawa",
      "moName": "Камикава муж",
      "buName": "Kamikawa ဒေသ",
      "khName": "តំបន់ Kamikawa",
      "neName": "कामिकावा क्षेत्र"
    },
    "class15": {
      "code": "012012",
      "name": "上川中部",
      "enName": "Middle Kamikawa"
    },
    "class20": {
      "code": "0145500",
      "name": "比布町",
      "enName": "Pippu Town",
      "kana": "ぴっぷちょう",
      "chName": "比布町",
      "zhName": "比布町",
      "koName": "핏푸 정",
      "esName": "Pueblo de Pippu",
      "ptName": "bairro de Pippu",
      "thName": "เมืองปิ๊บปุ",
      "viName": "thị trấn Pippu",
      "inName": "kota Pippu",
      "tlName": "bayan ng Pippu",
      "moName": "Пиппү жижиг хот",
      "buName": "ပီးပု မြို့နယ်",
      "khName": "ទីប្រជុំជន ពីបភូ",
      "neName": "पिप्पु नगर"
    }
  },
  "0145600": {
    "office": {
      "code": "012000",
      "name": "上川・留萌地方",
      "enName": "Kamikawa Rumoi",
      "officeName": "旭川地方気象台",
      "chName": "上川/留萌地區",
      "zhName": "上川/留萌地区",
      "koName": "카미카와·루모에 지방",
      "esName": "Región de Kamikawa/Rumoi",
      "ptName": "Região de Kamikawa/Rumoi",
      "thName": "ภูมิภาคคามิคาวะ/รุโมอิ",
      "viName": "Vùng Kamikawa/Rumoi",
      "inName": "Wilayah Kamikawa/Rumoi",
      "tlName": "Rehiyon ng Kamikawa/Rumoi",
      "moName": "Камикава/Румой бүс нутаг",
      "buName": "Kamikawa/Rumoi ဒေသ",
      "khName": "តំបន់ Kamikawa/Rumoi",
      "neName": "कामिकावा/रुमोई क्षेत्र"
    },
    "class10": {
      "code": "012010",
      "name": "上川地方",
      "enName": "Kamikawa Region",
      "chName": "上川地區",
      "zhName": "上川地区",
      "koName": "카미카와 지방",
      "esName": "Región de Kamikawa",
      "ptName": "Região de Kamikawa",
      "thName": "ภูมิภาคคามิคาวะ",
      "viName": "vùng Kamikawa",
      "inName": "wilayah Kamikawa",
      "tlName": "Rehiyon ng Kamikawa",
      "moName": "Камикава муж",
      "buName": "Kamikawa ဒေသ",
      "khName": "តំបន់ Kamikawa",
      "neName": "कामिकावा क्षेत्र"
    },
    "class15": {
      "code": "012012",
      "name": "上川中部",
      "enName": "Middle Kamikawa"
    },
    "class20": {
      "code": "0145600",
      "name": "愛別町",
      "enName": "Aibetsu Town",
      "kana": "あいべつちょう",
      "chName": "爱别町",
      "zhName": "愛別町",
      "koName": "아이베쓰 정",
      "esName": "Pueblo de Aibetsu",
      "ptName": "bairro de Aibetsu",
      "thName": "เมืองไอเบทสึ",
      "viName": "thị trấn Aibetsu",
      "inName": "kota Aibetsu",
      "tlName": "bayan ng Aibetsu",
      "moName": "Aйбэцү жижиг хот",
      "buName": "အိုင်းယိဗေ့စု မြို့နယ်",
      "khName": "ទីប្រជុំជន អាយបិតស៊ូ",
      "neName": "आइबेत्सु नगर"
    }
  },
  "0145700": {
    "office": {
      "code": "012000",
      "name": "上川・留萌地方",
      "enName": "Kamikawa Rumoi",
      "officeName": "旭川地方気象台",
      "chName": "上川/留萌地區",
      "zhName": "上川/留萌地区",
      "koName": "카미카와·루모에 지방",
      "esName": "Región de Kamikawa/Rumoi",
      "ptName": "Região de Kamikawa/Rumoi",
      "thName": "ภูมิภาคคามิคาวะ/รุโมอิ",
      "viName": "Vùng Kamikawa/Rumoi",
      "inName": "Wilayah Kamikawa/Rumoi",
      "tlName": "Rehiyon ng Kamikawa/Rumoi",
      "moName": "Камикава/Румой бүс нутаг",
      "buName": "Kamikawa/Rumoi ဒေသ",
      "khName": "តំបន់ Kamikawa/Rumoi",
      "neName": "कामिकावा/रुमोई क्षेत्र"
    },
    "class10": {
      "code": "012010",
      "name": "上川地方",
      "enName": "Kamikawa Region",
      "chName": "上川地區",
      "zhName": "上川地区",
      "koName": "카미카와 지방",
      "esName": "Región de Kamikawa",
      "ptName": "Região de Kamikawa",
      "thName": "ภูมิภาคคามิคาวะ",
      "viName": "vùng Kamikawa",
      "inName": "wilayah Kamikawa",
      "tlName": "Rehiyon ng Kamikawa",
      "moName": "Камикава муж",
      "buName": "Kamikawa ဒေသ",
      "khName": "តំបន់ Kamikawa",
      "neName": "कामिकावा क्षेत्र"
    },
    "class15": {
      "code": "012012",
      "name": "上川中部",
      "enName": "Middle Kamikawa"
    },
    "class20": {
      "code": "0145700",
      "name": "上川町",
      "enName": "Kamikawa Town",
      "kana": "かみかわちょう",
      "chName": "上川地方上川町",
      "zhName": "上川地方上川町",
      "koName": "가미카와지방 가미카와 정",
      "esName": "Pueblo de Kamikawa, Región Kamikawa ",
      "ptName": "Região de Kamikawa, bairro de Kamikawa",
      "thName": "เมืองคามิคาวะ ท้องถิ่นคามิกาวะ",
      "viName": "Thị trấn Kamikawa, vùng Kamikawa",
      "inName": "Kota Kamikawa, Daerah Kamikawa",
      "tlName": "bayan ng Kamikawa, Rehiyon ng Kamikawa",
      "moName": "Камикава муж Камикава жижиг хот",
      "buName": "ခမိခဝဒေသခိမိခဝမြို့နယ်",
      "khName": "ទីប្រជុំជនកាមីកាវ៉ាក់ តំបន់កាមីកាវ៉ាក់",
      "neName": "खामिखावा क्षेत्र खामिखावा नगर"
    }
  },
  "0145800": {
    "office": {
      "code": "012000",
      "name": "上川・留萌地方",
      "enName": "Kamikawa Rumoi",
      "officeName": "旭川地方気象台",
      "chName": "上川/留萌地區",
      "zhName": "上川/留萌地区",
      "koName": "카미카와·루모에 지방",
      "esName": "Región de Kamikawa/Rumoi",
      "ptName": "Região de Kamikawa/Rumoi",
      "thName": "ภูมิภาคคามิคาวะ/รุโมอิ",
      "viName": "Vùng Kamikawa/Rumoi",
      "inName": "Wilayah Kamikawa/Rumoi",
      "tlName": "Rehiyon ng Kamikawa/Rumoi",
      "moName": "Камикава/Румой бүс нутаг",
      "buName": "Kamikawa/Rumoi ဒေသ",
      "khName": "តំបន់ Kamikawa/Rumoi",
      "neName": "कामिकावा/रुमोई क्षेत्र"
    },
    "class10": {
      "code": "012010",
      "name": "上川地方",
      "enName": "Kamikawa Region",
      "chName": "上川地區",
      "zhName": "上川地区",
      "koName": "카미카와 지방",
      "esName": "Región de Kamikawa",
      "ptName": "Região de Kamikawa",
      "thName": "ภูมิภาคคามิคาวะ",
      "viName": "vùng Kamikawa",
      "inName": "wilayah Kamikawa",
      "tlName": "Rehiyon ng Kamikawa",
      "moName": "Камикава муж",
      "buName": "Kamikawa ဒေသ",
      "khName": "តំបន់ Kamikawa",
      "neName": "कामिकावा क्षेत्र"
    },
    "class15": {
      "code": "012012",
      "name": "上川中部",
      "enName": "Middle Kamikawa"
    },
    "class20": {
      "code": "0145800",
      "name": "東川町",
      "enName": "Higashikawa Town",
      "kana": "ひがしかわちょう",
      "chName": "东川町",
      "zhName": "東川町",
      "koName": "히가시카와 정",
      "esName": "Pueblo de Higashikawa",
      "ptName": "bairro de Higashikawa",
      "thName": "เมืองฮิงาชิคาวะ",
      "viName": "thị trấn Higashikawa",
      "inName": "kota Higashikawa",
      "tlName": "bayan ng Higashikawa",
      "moName": "Хигaшикава жижиг хот",
      "buName": "ဟီဂါ့ရှိကာ့ဝ မြို့နယ်",
      "khName": "ទីប្រជុំជន ហ៊ីកាស៊ីកាវ៉ា",
      "neName": "हिगाशिकावा नगर"
    }
  },
  "0145900": {
    "office": {
      "code": "012000",
      "name": "上川・留萌地方",
      "enName": "Kamikawa Rumoi",
      "officeName": "旭川地方気象台",
      "chName": "上川/留萌地區",
      "zhName": "上川/留萌地区",
      "koName": "카미카와·루모에 지방",
      "esName": "Región de Kamikawa/Rumoi",
      "ptName": "Região de Kamikawa/Rumoi",
      "thName": "ภูมิภาคคามิคาวะ/รุโมอิ",
      "viName": "Vùng Kamikawa/Rumoi",
      "inName": "Wilayah Kamikawa/Rumoi",
      "tlName": "Rehiyon ng Kamikawa/Rumoi",
      "moName": "Камикава/Румой бүс нутаг",
      "buName": "Kamikawa/Rumoi ဒေသ",
      "khName": "តំបន់ Kamikawa/Rumoi",
      "neName": "कामिकावा/रुमोई क्षेत्र"
    },
    "class10": {
      "code": "012010",
      "name": "上川地方",
      "enName": "Kamikawa Region",
      "chName": "上川地區",
      "zhName": "上川地区",
      "koName": "카미카와 지방",
      "esName": "Región de Kamikawa",
      "ptName": "Região de Kamikawa",
      "thName": "ภูมิภาคคามิคาวะ",
      "viName": "vùng Kamikawa",
      "inName": "wilayah Kamikawa",
      "tlName": "Rehiyon ng Kamikawa",
      "moName": "Камикава муж",
      "buName": "Kamikawa ဒေသ",
      "khName": "តំបន់ Kamikawa",
      "neName": "कामिकावा क्षेत्र"
    },
    "class15": {
      "code": "012012",
      "name": "上川中部",
      "enName": "Middle Kamikawa"
    },
    "class20": {
      "code": "0145900",
      "name": "美瑛町",
      "enName": "Biei Town",
      "kana": "びえいちょう",
      "chName": "美瑛町",
      "zhName": "美瑛町",
      "koName": "비에이 정",
      "esName": "Pueblo de Biei",
      "ptName": "bairro de Biei",
      "thName": "เมืองบิเอะ",
      "viName": "thị trấn Biei",
      "inName": "kota Biei",
      "tlName": "bayan ng Biei",
      "moName": "Биэй жижиг хот",
      "buName": "ဗီယဲ့ မြို့နယ်",
      "khName": "ទីប្រជុំជន ប៊ី",
      "neName": "बिएई नगर"
    }
  },
  "0146000": {
    "office": {
      "code": "012000",
      "name": "上川・留萌地方",
      "enName": "Kamikawa Rumoi",
      "officeName": "旭川地方気象台",
      "chName": "上川/留萌地區",
      "zhName": "上川/留萌地区",
      "koName": "카미카와·루모에 지방",
      "esName": "Región de Kamikawa/Rumoi",
      "ptName": "Região de Kamikawa/Rumoi",
      "thName": "ภูมิภาคคามิคาวะ/รุโมอิ",
      "viName": "Vùng Kamikawa/Rumoi",
      "inName": "Wilayah Kamikawa/Rumoi",
      "tlName": "Rehiyon ng Kamikawa/Rumoi",
      "moName": "Камикава/Румой бүс нутаг",
      "buName": "Kamikawa/Rumoi ဒေသ",
      "khName": "តំបន់ Kamikawa/Rumoi",
      "neName": "कामिकावा/रुमोई क्षेत्र"
    },
    "class10": {
      "code": "012010",
      "name": "上川地方",
      "enName": "Kamikawa Region",
      "chName": "上川地區",
      "zhName": "上川地区",
      "koName": "카미카와 지방",
      "esName": "Región de Kamikawa",
      "ptName": "Região de Kamikawa",
      "thName": "ภูมิภาคคามิคาวะ",
      "viName": "vùng Kamikawa",
      "inName": "wilayah Kamikawa",
      "tlName": "Rehiyon ng Kamikawa",
      "moName": "Камикава муж",
      "buName": "Kamikawa ဒေသ",
      "khName": "តំបន់ Kamikawa",
      "neName": "कामिकावा क्षेत्र"
    },
    "class15": {
      "code": "012013",
      "name": "上川南部",
      "enName": "Southern Kamikawa"
    },
    "class20": {
      "code": "0146000",
      "name": "上富良野町",
      "enName": "Kamifurano Town",
      "kana": "かみふらのちょう",
      "chName": "上富良野町",
      "zhName": "上富良野町",
      "koName": "가미후라노 정",
      "esName": "Pueblo de Kamifurano",
      "ptName": "bairro de Kamifurano",
      "thName": "เมืองคามิฟุราโนะ",
      "viName": "thị trấn Kamifurano",
      "inName": "kota Kamifurano",
      "tlName": "bayan ng Kamifurano",
      "moName": "Камифүрано жижиг хот",
      "buName": "ခါမီးဖူရာနို မြို့နယ်",
      "khName": "ទីប្រជុំជន កាមីហ្វូរ៉ាណូ",
      "neName": "कामिफुरानो नगर"
    }
  },
  "0146100": {
    "office": {
      "code": "012000",
      "name": "上川・留萌地方",
      "enName": "Kamikawa Rumoi",
      "officeName": "旭川地方気象台",
      "chName": "上川/留萌地區",
      "zhName": "上川/留萌地区",
      "koName": "카미카와·루모에 지방",
      "esName": "Región de Kamikawa/Rumoi",
      "ptName": "Região de Kamikawa/Rumoi",
      "thName": "ภูมิภาคคามิคาวะ/รุโมอิ",
      "viName": "Vùng Kamikawa/Rumoi",
      "inName": "Wilayah Kamikawa/Rumoi",
      "tlName": "Rehiyon ng Kamikawa/Rumoi",
      "moName": "Камикава/Румой бүс нутаг",
      "buName": "Kamikawa/Rumoi ဒေသ",
      "khName": "តំបន់ Kamikawa/Rumoi",
      "neName": "कामिकावा/रुमोई क्षेत्र"
    },
    "class10": {
      "code": "012010",
      "name": "上川地方",
      "enName": "Kamikawa Region",
      "chName": "上川地區",
      "zhName": "上川地区",
      "koName": "카미카와 지방",
      "esName": "Región de Kamikawa",
      "ptName": "Região de Kamikawa",
      "thName": "ภูมิภาคคามิคาวะ",
      "viName": "vùng Kamikawa",
      "inName": "wilayah Kamikawa",
      "tlName": "Rehiyon ng Kamikawa",
      "moName": "Камикава муж",
      "buName": "Kamikawa ဒေသ",
      "khName": "តំបន់ Kamikawa",
      "neName": "कामिकावा क्षेत्र"
    },
    "class15": {
      "code": "012013",
      "name": "上川南部",
      "enName": "Southern Kamikawa"
    },
    "class20": {
      "code": "0146100",
      "name": "中富良野町",
      "enName": "Nakafurano Town",
      "kana": "なかふらのちょう",
      "chName": "中富良野町",
      "zhName": "中富良野町",
      "koName": "나카후라노 정",
      "esName": "Pueblo de Nakafurano",
      "ptName": "bairro de Nakafurano",
      "thName": "เมืองนาคาฟุราโนะ",
      "viName": "thị trấn Nakafurano",
      "inName": "kota Nakafurano",
      "tlName": "bayan ng Nakafurano",
      "moName": "Нaкафүрано жижиг хот",
      "buName": "နာကားဖူရာနို မြို့နယ်",
      "khName": "ទីប្រជុំជន ណាហ្កាហ្វូរ៉ាណូ",
      "neName": "नाकाफुरानो नगर"
    }
  },
  "0146200": {
    "office": {
      "code": "012000",
      "name": "上川・留萌地方",
      "enName": "Kamikawa Rumoi",
      "officeName": "旭川地方気象台",
      "chName": "上川/留萌地區",
      "zhName": "上川/留萌地区",
      "koName": "카미카와·루모에 지방",
      "esName": "Región de Kamikawa/Rumoi",
      "ptName": "Região de Kamikawa/Rumoi",
      "thName": "ภูมิภาคคามิคาวะ/รุโมอิ",
      "viName": "Vùng Kamikawa/Rumoi",
      "inName": "Wilayah Kamikawa/Rumoi",
      "tlName": "Rehiyon ng Kamikawa/Rumoi",
      "moName": "Камикава/Румой бүс нутаг",
      "buName": "Kamikawa/Rumoi ဒေသ",
      "khName": "តំបន់ Kamikawa/Rumoi",
      "neName": "कामिकावा/रुमोई क्षेत्र"
    },
    "class10": {
      "code": "012010",
      "name": "上川地方",
      "enName": "Kamikawa Region",
      "chName": "上川地區",
      "zhName": "上川地区",
      "koName": "카미카와 지방",
      "esName": "Región de Kamikawa",
      "ptName": "Região de Kamikawa",
      "thName": "ภูมิภาคคามิคาวะ",
      "viName": "vùng Kamikawa",
      "inName": "wilayah Kamikawa",
      "tlName": "Rehiyon ng Kamikawa",
      "moName": "Камикава муж",
      "buName": "Kamikawa ဒေသ",
      "khName": "តំបន់ Kamikawa",
      "neName": "कामिकावा क्षेत्र"
    },
    "class15": {
      "code": "012013",
      "name": "上川南部",
      "enName": "Southern Kamikawa"
    },
    "class20": {
      "code": "0146200",
      "name": "南富良野町",
      "enName": "Minamifurano Town",
      "kana": "みなみふらのちょう",
      "chName": "南富良野町",
      "zhName": "南富良野町",
      "koName": "미나미후라노 정",
      "esName": "Pueblo de Minamifurano",
      "ptName": "bairro de Minamifurano",
      "thName": "เมืองมินามิฟุราดนะ",
      "viName": "thị trấn Minamifurano",
      "inName": "kota Minamifurano",
      "tlName": "bayan ng Minamifurano",
      "moName": "Минaмифүрано жижиг хот",
      "buName": "မီနာ့မီးဖူရာနို မြို့နယ်",
      "khName": "ទីប្រជុំជន មីណាមីហ្វូរ៉ាណូ",
      "neName": "मिनामिफुरानो नगर"
    }
  },
  "0146300": {
    "office": {
      "code": "012000",
      "name": "上川・留萌地方",
      "enName": "Kamikawa Rumoi",
      "officeName": "旭川地方気象台",
      "chName": "上川/留萌地區",
      "zhName": "上川/留萌地区",
      "koName": "카미카와·루모에 지방",
      "esName": "Región de Kamikawa/Rumoi",
      "ptName": "Região de Kamikawa/Rumoi",
      "thName": "ภูมิภาคคามิคาวะ/รุโมอิ",
      "viName": "Vùng Kamikawa/Rumoi",
      "inName": "Wilayah Kamikawa/Rumoi",
      "tlName": "Rehiyon ng Kamikawa/Rumoi",
      "moName": "Камикава/Румой бүс нутаг",
      "buName": "Kamikawa/Rumoi ဒေသ",
      "khName": "តំបន់ Kamikawa/Rumoi",
      "neName": "कामिकावा/रुमोई क्षेत्र"
    },
    "class10": {
      "code": "012010",
      "name": "上川地方",
      "enName": "Kamikawa Region",
      "chName": "上川地區",
      "zhName": "上川地区",
      "koName": "카미카와 지방",
      "esName": "Región de Kamikawa",
      "ptName": "Região de Kamikawa",
      "thName": "ภูมิภาคคามิคาวะ",
      "viName": "vùng Kamikawa",
      "inName": "wilayah Kamikawa",
      "tlName": "Rehiyon ng Kamikawa",
      "moName": "Камикава муж",
      "buName": "Kamikawa ဒေသ",
      "khName": "តំបន់ Kamikawa",
      "neName": "कामिकावा क्षेत्र"
    },
    "class15": {
      "code": "012013",
      "name": "上川南部",
      "enName": "Southern Kamikawa"
    },
    "class20": {
      "code": "0146300",
      "name": "占冠村",
      "enName": "Shimukappu Village",
      "kana": "しむかっぷむら",
      "chName": "占冠村",
      "zhName": "占冠村",
      "koName": "시무캇푸 촌",
      "esName": "Aldea de Shimukappu",
      "ptName": "povoado de Shimukappu",
      "thName": "หมู่บ้านชิมุคัปปะ",
      "viName": "làng Shimukappu",
      "inName": "desa Shimukappu",
      "tlName": "nayon ng Shimukappu",
      "moName": "Шимүкаппү тосгон",
      "buName": "ရှီမုကားပု ကျေးရွာ",
      "khName": "ភូមិ ស៊ីមូកាប់ភូ",
      "neName": "शिमुकाप्पु गाउँ"
    }
  },
  "0146400": {
    "office": {
      "code": "012000",
      "name": "上川・留萌地方",
      "enName": "Kamikawa Rumoi",
      "officeName": "旭川地方気象台",
      "chName": "上川/留萌地區",
      "zhName": "上川/留萌地区",
      "koName": "카미카와·루모에 지방",
      "esName": "Región de Kamikawa/Rumoi",
      "ptName": "Região de Kamikawa/Rumoi",
      "thName": "ภูมิภาคคามิคาวะ/รุโมอิ",
      "viName": "Vùng Kamikawa/Rumoi",
      "inName": "Wilayah Kamikawa/Rumoi",
      "tlName": "Rehiyon ng Kamikawa/Rumoi",
      "moName": "Камикава/Румой бүс нутаг",
      "buName": "Kamikawa/Rumoi ဒေသ",
      "khName": "តំបន់ Kamikawa/Rumoi",
      "neName": "कामिकावा/रुमोई क्षेत्र"
    },
    "class10": {
      "code": "012010",
      "name": "上川地方",
      "enName": "Kamikawa Region",
      "chName": "上川地區",
      "zhName": "上川地区",
      "koName": "카미카와 지방",
      "esName": "Región de Kamikawa",
      "ptName": "Região de Kamikawa",
      "thName": "ภูมิภาคคามิคาวะ",
      "viName": "vùng Kamikawa",
      "inName": "wilayah Kamikawa",
      "tlName": "Rehiyon ng Kamikawa",
      "moName": "Камикава муж",
      "buName": "Kamikawa ဒေသ",
      "khName": "តំបន់ Kamikawa",
      "neName": "कामिकावा क्षेत्र"
    },
    "class15": {
      "code": "012011",
      "name": "上川北部",
      "enName": "Northern Kamikawa"
    },
    "class20": {
      "code": "0146400",
      "name": "和寒町",
      "enName": "Wassamu Town",
      "kana": "わっさむちょう",
      "chName": "和寒町",
      "zhName": "和寒町",
      "koName": "왓사무 정",
      "esName": "Pueblo de Wassamu",
      "ptName": "bairro de Wassamu",
      "thName": "เมืองวัสซามุ",
      "viName": "thị trấn Wassamu",
      "inName": "kota Wassamu",
      "tlName": "bayan ng Wassamu",
      "moName": "Вассaмү жижиг хот",
      "buName": "ဝါးဆာ့မဲ့ မြို့နယ်",
      "khName": "ទីប្រជុំជន វ៉ាសាម៉ុ",
      "neName": "वासामु नगर"
    }
  },
  "0146500": {
    "office": {
      "code": "012000",
      "name": "上川・留萌地方",
      "enName": "Kamikawa Rumoi",
      "officeName": "旭川地方気象台",
      "chName": "上川/留萌地區",
      "zhName": "上川/留萌地区",
      "koName": "카미카와·루모에 지방",
      "esName": "Región de Kamikawa/Rumoi",
      "ptName": "Região de Kamikawa/Rumoi",
      "thName": "ภูมิภาคคามิคาวะ/รุโมอิ",
      "viName": "Vùng Kamikawa/Rumoi",
      "inName": "Wilayah Kamikawa/Rumoi",
      "tlName": "Rehiyon ng Kamikawa/Rumoi",
      "moName": "Камикава/Румой бүс нутаг",
      "buName": "Kamikawa/Rumoi ဒေသ",
      "khName": "តំបន់ Kamikawa/Rumoi",
      "neName": "कामिकावा/रुमोई क्षेत्र"
    },
    "class10": {
      "code": "012010",
      "name": "上川地方",
      "enName": "Kamikawa Region",
      "chName": "上川地區",
      "zhName": "上川地区",
      "koName": "카미카와 지방",
      "esName": "Región de Kamikawa",
      "ptName": "Região de Kamikawa",
      "thName": "ภูมิภาคคามิคาวะ",
      "viName": "vùng Kamikawa",
      "inName": "wilayah Kamikawa",
      "tlName": "Rehiyon ng Kamikawa",
      "moName": "Камикава муж",
      "buName": "Kamikawa ဒေသ",
      "khName": "តំបន់ Kamikawa",
      "neName": "कामिकावा क्षेत्र"
    },
    "class15": {
      "code": "012011",
      "name": "上川北部",
      "enName": "Northern Kamikawa"
    },
    "class20": {
      "code": "0146500",
      "name": "剣淵町",
      "enName": "Kembuchi Town",
      "kana": "けんぶちちょう",
      "chName": "剑渊町",
      "zhName": "劍淵町",
      "koName": "겐부치 정",
      "esName": "Pueblo de Kenbuchi",
      "ptName": "bairro de Kembuchi",
      "thName": "เมืองเคมบุจิ",
      "viName": "thị trấn Kembuchi",
      "inName": "kota Kembuchi",
      "tlName": "bayan ng Kembuchi",
      "moName": "Кэмбүчи жижиг хот",
      "buName": "ခင်းဘုဟိ မြို့နယ်",
      "khName": "ទីប្រជុំជន ខេមប៊ូជី",
      "neName": "केम्बुची नगर"
    }
  },
  "0146800": {
    "office": {
      "code": "012000",
      "name": "上川・留萌地方",
      "enName": "Kamikawa Rumoi",
      "officeName": "旭川地方気象台",
      "chName": "上川/留萌地區",
      "zhName": "上川/留萌地区",
      "koName": "카미카와·루모에 지방",
      "esName": "Región de Kamikawa/Rumoi",
      "ptName": "Região de Kamikawa/Rumoi",
      "thName": "ภูมิภาคคามิคาวะ/รุโมอิ",
      "viName": "Vùng Kamikawa/Rumoi",
      "inName": "Wilayah Kamikawa/Rumoi",
      "tlName": "Rehiyon ng Kamikawa/Rumoi",
      "moName": "Камикава/Румой бүс нутаг",
      "buName": "Kamikawa/Rumoi ဒေသ",
      "khName": "តំបន់ Kamikawa/Rumoi",
      "neName": "कामिकावा/रुमोई क्षेत्र"
    },
    "class10": {
      "code": "012010",
      "name": "上川地方",
      "enName": "Kamikawa Region",
      "chName": "上川地區",
      "zhName": "上川地区",
      "koName": "카미카와 지방",
      "esName": "Región de Kamikawa",
      "ptName": "Região de Kamikawa",
      "thName": "ภูมิภาคคามิคาวะ",
      "viName": "vùng Kamikawa",
      "inName": "wilayah Kamikawa",
      "tlName": "Rehiyon ng Kamikawa",
      "moName": "Камикава муж",
      "buName": "Kamikawa ဒေသ",
      "khName": "តំបន់ Kamikawa",
      "neName": "कामिकावा क्षेत्र"
    },
    "class15": {
      "code": "012011",
      "name": "上川北部",
      "enName": "Northern Kamikawa"
    },
    "class20": {
      "code": "0146800",
      "name": "下川町",
      "enName": "Shimokawa Town",
      "kana": "しもかわちょう",
      "chName": "下川町",
      "zhName": "下川町",
      "koName": "시모카와 정",
      "esName": "Pueblo de Shimokawa",
      "ptName": "bairro de Shimokawa",
      "thName": "เมืองชิโมคาวะ",
      "viName": "thị trấn Shimokawa",
      "inName": "kota Shimokawa",
      "tlName": "bayan ng Shimokawa",
      "moName": "Шимокава жижиг хот",
      "buName": "ရှီမိုးကာ့ဝ မြို့နယ်",
      "khName": "ទីប្រជុំជន ស៊ីម៉ុកាវ៉ា",
      "neName": "शिमोकावा नगर"
    }
  },
  "0146900": {
    "office": {
      "code": "012000",
      "name": "上川・留萌地方",
      "enName": "Kamikawa Rumoi",
      "officeName": "旭川地方気象台",
      "chName": "上川/留萌地區",
      "zhName": "上川/留萌地区",
      "koName": "카미카와·루모에 지방",
      "esName": "Región de Kamikawa/Rumoi",
      "ptName": "Região de Kamikawa/Rumoi",
      "thName": "ภูมิภาคคามิคาวะ/รุโมอิ",
      "viName": "Vùng Kamikawa/Rumoi",
      "inName": "Wilayah Kamikawa/Rumoi",
      "tlName": "Rehiyon ng Kamikawa/Rumoi",
      "moName": "Камикава/Румой бүс нутаг",
      "buName": "Kamikawa/Rumoi ဒေသ",
      "khName": "តំបន់ Kamikawa/Rumoi",
      "neName": "कामिकावा/रुमोई क्षेत्र"
    },
    "class10": {
      "code": "012010",
      "name": "上川地方",
      "enName": "Kamikawa Region",
      "chName": "上川地區",
      "zhName": "上川地区",
      "koName": "카미카와 지방",
      "esName": "Región de Kamikawa",
      "ptName": "Região de Kamikawa",
      "thName": "ภูมิภาคคามิคาวะ",
      "viName": "vùng Kamikawa",
      "inName": "wilayah Kamikawa",
      "tlName": "Rehiyon ng Kamikawa",
      "moName": "Камикава муж",
      "buName": "Kamikawa ဒေသ",
      "khName": "តំបន់ Kamikawa",
      "neName": "कामिकावा क्षेत्र"
    },
    "class15": {
      "code": "012011",
      "name": "上川北部",
      "enName": "Northern Kamikawa"
    },
    "class20": {
      "code": "0146900",
      "name": "美深町",
      "enName": "Bifuka Town",
      "kana": "びふかちょう",
      "chName": "美深町",
      "zhName": "美深町",
      "koName": "비후카 정",
      "esName": "Pueblo de Bifuka",
      "ptName": "bairro de Bifuka",
      "thName": "เมืองบิฟุกะ",
      "viName": "thị trấn Bifuka",
      "inName": "kota Bifuka",
      "tlName": "bayan ng Bifuka",
      "moName": "Бифүка жижиг хот",
      "buName": "ဗိဖူကာ မြို့နယ်",
      "khName": "ទីប្រជុំជន ប៊ីហ្វូកា",
      "neName": "बिफुका नगर"
    }
  },
  "0147000": {
    "office": {
      "code": "012000",
      "name": "上川・留萌地方",
      "enName": "Kamikawa Rumoi",
      "officeName": "旭川地方気象台",
      "chName": "上川/留萌地區",
      "zhName": "上川/留萌地区",
      "koName": "카미카와·루모에 지방",
      "esName": "Región de Kamikawa/Rumoi",
      "ptName": "Região de Kamikawa/Rumoi",
      "thName": "ภูมิภาคคามิคาวะ/รุโมอิ",
      "viName": "Vùng Kamikawa/Rumoi",
      "inName": "Wilayah Kamikawa/Rumoi",
      "tlName": "Rehiyon ng Kamikawa/Rumoi",
      "moName": "Камикава/Румой бүс нутаг",
      "buName": "Kamikawa/Rumoi ဒေသ",
      "khName": "តំបន់ Kamikawa/Rumoi",
      "neName": "कामिकावा/रुमोई क्षेत्र"
    },
    "class10": {
      "code": "012010",
      "name": "上川地方",
      "enName": "Kamikawa Region",
      "chName": "上川地區",
      "zhName": "上川地区",
      "koName": "카미카와 지방",
      "esName": "Región de Kamikawa",
      "ptName": "Região de Kamikawa",
      "thName": "ภูมิภาคคามิคาวะ",
      "viName": "vùng Kamikawa",
      "inName": "wilayah Kamikawa",
      "tlName": "Rehiyon ng Kamikawa",
      "moName": "Камикава муж",
      "buName": "Kamikawa ဒေသ",
      "khName": "តំបន់ Kamikawa",
      "neName": "कामिकावा क्षेत्र"
    },
    "class15": {
      "code": "012011",
      "name": "上川北部",
      "enName": "Northern Kamikawa"
    },
    "class20": {
      "code": "0147000",
      "name": "音威子府村",
      "enName": "Otoineppu Village",
      "kana": "おといねっぷむら",
      "chName": "音威子府村",
      "zhName": "音威子府村",
      "koName": "오토이넷푸 촌",
      "esName": "Aldea de Otoineppu",
      "ptName": "povoado de Otoineppu",
      "thName": "หมู่บ้านโอโตอิเนปปุ",
      "viName": "làng Otoineppu",
      "inName": "desa Otoineppu",
      "tlName": "nayon ng Otoineppu",
      "moName": "Отойнэппү тосгон",
      "buName": "အိုတိုးယိနဲ့ပု မြို့နယ်",
      "khName": "ភូមិ អូតូនីពីពូ",
      "neName": "ओतोइनेप्पु गाउँ"
    }
  },
  "0147100": {
    "office": {
      "code": "012000",
      "name": "上川・留萌地方",
      "enName": "Kamikawa Rumoi",
      "officeName": "旭川地方気象台",
      "chName": "上川/留萌地區",
      "zhName": "上川/留萌地区",
      "koName": "카미카와·루모에 지방",
      "esName": "Región de Kamikawa/Rumoi",
      "ptName": "Região de Kamikawa/Rumoi",
      "thName": "ภูมิภาคคามิคาวะ/รุโมอิ",
      "viName": "Vùng Kamikawa/Rumoi",
      "inName": "Wilayah Kamikawa/Rumoi",
      "tlName": "Rehiyon ng Kamikawa/Rumoi",
      "moName": "Камикава/Румой бүс нутаг",
      "buName": "Kamikawa/Rumoi ဒေသ",
      "khName": "តំបន់ Kamikawa/Rumoi",
      "neName": "कामिकावा/रुमोई क्षेत्र"
    },
    "class10": {
      "code": "012010",
      "name": "上川地方",
      "enName": "Kamikawa Region",
      "chName": "上川地區",
      "zhName": "上川地区",
      "koName": "카미카와 지방",
      "esName": "Región de Kamikawa",
      "ptName": "Região de Kamikawa",
      "thName": "ภูมิภาคคามิคาวะ",
      "viName": "vùng Kamikawa",
      "inName": "wilayah Kamikawa",
      "tlName": "Rehiyon ng Kamikawa",
      "moName": "Камикава муж",
      "buName": "Kamikawa ဒေသ",
      "khName": "តំបន់ Kamikawa",
      "neName": "कामिकावा क्षेत्र"
    },
    "class15": {
      "code": "012011",
      "name": "上川北部",
      "enName": "Northern Kamikawa"
    },
    "class20": {
      "code": "0147100",
      "name": "中川町",
      "enName": "Nakagawa Town",
      "kana": "なかがわちょう",
      "chName": "上川中川町",
      "zhName": "上川中川町",
      "koName": "가미카와 나카가와 정",
      "esName": "Pueblo de Nakagawa, Kamikawa",
      "ptName": "Kamikawa, bairro de Nakagawa",
      "thName": "เมืองนาคากาวะ คามิกาวะ",
      "viName": "Thị trấn Nakagawa, Kamikawa",
      "inName": "Kota Nakagawa, Kamikawa",
      "tlName": "bayan ng Nakagawa, Kamikawa",
      "moName": "Камикава Накакава жижиг хот",
      "buName": "ခမိခဝနကခိမိခဝမြို့နယ်",
      "khName": "ទីប្រជុំជនណាកាហ្គាវ៉ាក់ កាមីកាវ៉ាក់",
      "neName": "खामिखावा नाकागावा नगर"
    }
  },
  "0147200": {
    "office": {
      "code": "012000",
      "name": "上川・留萌地方",
      "enName": "Kamikawa Rumoi",
      "officeName": "旭川地方気象台",
      "chName": "上川/留萌地區",
      "zhName": "上川/留萌地区",
      "koName": "카미카와·루모에 지방",
      "esName": "Región de Kamikawa/Rumoi",
      "ptName": "Região de Kamikawa/Rumoi",
      "thName": "ภูมิภาคคามิคาวะ/รุโมอิ",
      "viName": "Vùng Kamikawa/Rumoi",
      "inName": "Wilayah Kamikawa/Rumoi",
      "tlName": "Rehiyon ng Kamikawa/Rumoi",
      "moName": "Камикава/Румой бүс нутаг",
      "buName": "Kamikawa/Rumoi ဒေသ",
      "khName": "តំបន់ Kamikawa/Rumoi",
      "neName": "कामिकावा/रुमोई क्षेत्र"
    },
    "class10": {
      "code": "012010",
      "name": "上川地方",
      "enName": "Kamikawa Region",
      "chName": "上川地區",
      "zhName": "上川地区",
      "koName": "카미카와 지방",
      "esName": "Región de Kamikawa",
      "ptName": "Região de Kamikawa",
      "thName": "ภูมิภาคคามิคาวะ",
      "viName": "vùng Kamikawa",
      "inName": "wilayah Kamikawa",
      "tlName": "Rehiyon ng Kamikawa",
      "moName": "Камикава муж",
      "buName": "Kamikawa ဒေသ",
      "khName": "តំបន់ Kamikawa",
      "neName": "कामिकावा क्षेत्र"
    },
    "class15": {
      "code": "012011",
      "name": "上川北部",
      "enName": "Northern Kamikawa"
    },
    "class20": {
      "code": "0147200",
      "name": "幌加内町",
      "enName": "Horokanai Town",
      "kana": "ほろかないちょう",
      "chName": "幌加内町",
      "zhName": "幌加內町",
      "koName": "호로카나이 정",
      "esName": "Pueblo de Horokanai",
      "ptName": "bairro de Horokanai",
      "thName": "เมืองโฮโระคาไน",
      "viName": "thị trấn Horokanai",
      "inName": "kota Horokanai",
      "tlName": "bayan ng Horokanai",
      "moName": "Хороканaй жижиг хот",
      "buName": "ဟိုရိုကာ့နယိ မြို့နယ်",
      "khName": "ទីប្រជុំជន ហោរ៉ូកាណៃ",
      "neName": "होरोकानाइ नगर"
    }
  },
  "0148100": {
    "office": {
      "code": "012000",
      "name": "上川・留萌地方",
      "enName": "Kamikawa Rumoi",
      "officeName": "旭川地方気象台",
      "chName": "上川/留萌地區",
      "zhName": "上川/留萌地区",
      "koName": "카미카와·루모에 지방",
      "esName": "Región de Kamikawa/Rumoi",
      "ptName": "Região de Kamikawa/Rumoi",
      "thName": "ภูมิภาคคามิคาวะ/รุโมอิ",
      "viName": "Vùng Kamikawa/Rumoi",
      "inName": "Wilayah Kamikawa/Rumoi",
      "tlName": "Rehiyon ng Kamikawa/Rumoi",
      "moName": "Камикава/Румой бүс нутаг",
      "buName": "Kamikawa/Rumoi ဒေသ",
      "khName": "តំបន់ Kamikawa/Rumoi",
      "neName": "कामिकावा/रुमोई क्षेत्र"
    },
    "class10": {
      "code": "012020",
      "name": "留萌地方",
      "enName": "Rumoi Region",
      "chName": "留萌地區",
      "zhName": "留萌地区",
      "koName": "루모이 지방",
      "esName": "Región de Rumoi",
      "ptName": "Região de Rumoi",
      "thName": "แคว้นรูมอย",
      "viName": "vùng Rumoi",
      "inName": "wilayah Rumoi",
      "tlName": "Rehiyon ng Rumoi",
      "moName": "Румой бүс",
      "buName": "Rumoi ဒေသ",
      "khName": "តំបន់ Rumoi",
      "neName": "रुमोई क्षेत्र"
    },
    "class15": {
      "code": "012023",
      "name": "留萌南部",
      "enName": "Southern Rumoi"
    },
    "class20": {
      "code": "0148100",
      "name": "増毛町",
      "enName": "Mashike Town",
      "kana": "ましけちょう",
      "chName": "增毛町",
      "zhName": "增毛町",
      "koName": "마시케 정",
      "esName": "Pueblo de Mashike",
      "ptName": "bairro de Mashike",
      "thName": "เมืองมาชิเกะ",
      "viName": "thị trấn Mashike",
      "inName": "kota Mashike",
      "tlName": "bayan ng Mashike",
      "moName": "Мaшикэ жижиг хот",
      "buName": "မားရှိကဲ့ မြို့နယ်",
      "khName": "ទីប្រជុំជន ម៉ាស៊ិកេ",
      "neName": "माशिके नगर"
    }
  },
  "0148200": {
    "office": {
      "code": "012000",
      "name": "上川・留萌地方",
      "enName": "Kamikawa Rumoi",
      "officeName": "旭川地方気象台",
      "chName": "上川/留萌地區",
      "zhName": "上川/留萌地区",
      "koName": "카미카와·루모에 지방",
      "esName": "Región de Kamikawa/Rumoi",
      "ptName": "Região de Kamikawa/Rumoi",
      "thName": "ภูมิภาคคามิคาวะ/รุโมอิ",
      "viName": "Vùng Kamikawa/Rumoi",
      "inName": "Wilayah Kamikawa/Rumoi",
      "tlName": "Rehiyon ng Kamikawa/Rumoi",
      "moName": "Камикава/Румой бүс нутаг",
      "buName": "Kamikawa/Rumoi ဒေသ",
      "khName": "តំបន់ Kamikawa/Rumoi",
      "neName": "कामिकावा/रुमोई क्षेत्र"
    },
    "class10": {
      "code": "012020",
      "name": "留萌地方",
      "enName": "Rumoi Region",
      "chName": "留萌地區",
      "zhName": "留萌地区",
      "koName": "루모이 지방",
      "esName": "Región de Rumoi",
      "ptName": "Região de Rumoi",
      "thName": "แคว้นรูมอย",
      "viName": "vùng Rumoi",
      "inName": "wilayah Rumoi",
      "tlName": "Rehiyon ng Rumoi",
      "moName": "Румой бүс",
      "buName": "Rumoi ဒေသ",
      "khName": "តំបន់ Rumoi",
      "neName": "रुमोई क्षेत्र"
    },
    "class15": {
      "code": "012023",
      "name": "留萌南部",
      "enName": "Southern Rumoi"
    },
    "class20": {
      "code": "0148200",
      "name": "小平町",
      "enName": "Obira Town",
      "kana": "おびらちょう",
      "chName": "小平町",
      "zhName": "小平町",
      "koName": "오비라 정",
      "esName": "Pueblo de Obira",
      "ptName": "bairro de Obira",
      "thName": "เมืองโอบิระ",
      "viName": "thị trấn Obira",
      "inName": "kota Obira",
      "tlName": "bayan ng Obira",
      "moName": "Обира жижиг хот",
      "buName": "အို့ဘိရာ့ မြို့နယ်",
      "khName": "ទីប្រជុំជន អូប៊ីរ៉ា",
      "neName": "ओबिरा नगर"
    }
  },
  "0148300": {
    "office": {
      "code": "012000",
      "name": "上川・留萌地方",
      "enName": "Kamikawa Rumoi",
      "officeName": "旭川地方気象台",
      "chName": "上川/留萌地區",
      "zhName": "上川/留萌地区",
      "koName": "카미카와·루모에 지방",
      "esName": "Región de Kamikawa/Rumoi",
      "ptName": "Região de Kamikawa/Rumoi",
      "thName": "ภูมิภาคคามิคาวะ/รุโมอิ",
      "viName": "Vùng Kamikawa/Rumoi",
      "inName": "Wilayah Kamikawa/Rumoi",
      "tlName": "Rehiyon ng Kamikawa/Rumoi",
      "moName": "Камикава/Румой бүс нутаг",
      "buName": "Kamikawa/Rumoi ဒေသ",
      "khName": "តំបន់ Kamikawa/Rumoi",
      "neName": "कामिकावा/रुमोई क्षेत्र"
    },
    "class10": {
      "code": "012020",
      "name": "留萌地方",
      "enName": "Rumoi Region",
      "chName": "留萌地區",
      "zhName": "留萌地区",
      "koName": "루모이 지방",
      "esName": "Región de Rumoi",
      "ptName": "Região de Rumoi",
      "thName": "แคว้นรูมอย",
      "viName": "vùng Rumoi",
      "inName": "wilayah Rumoi",
      "tlName": "Rehiyon ng Rumoi",
      "moName": "Румой бүс",
      "buName": "Rumoi ဒေသ",
      "khName": "តំបន់ Rumoi",
      "neName": "रुमोई क्षेत्र"
    },
    "class15": {
      "code": "012022",
      "name": "留萌中部",
      "enName": "Middle Rumoi"
    },
    "class20": {
      "code": "0148300",
      "name": "苫前町",
      "enName": "Tomamae Town",
      "kana": "とままえちょう",
      "chName": "苫前町",
      "zhName": "苫前町",
      "koName": "도마마에 정",
      "esName": "Pueblo de Tomamae",
      "ptName": "bairro de Tomamae",
      "thName": "เมือโทมามาเมะ",
      "viName": "thị trấn Tomamae",
      "inName": "kota Tomamae",
      "tlName": "bayan ng Tomamae",
      "moName": "Томaмaэ жижиг хот",
      "buName": "တိုမမားအဲ့ မြို့နယ်",
      "khName": "ទីប្រជុំជន ថូម៉ាម៉េ",
      "neName": "तोमामाए नगर"
    }
  },
  "0148401": {
    "office": {
      "code": "012000",
      "name": "上川・留萌地方",
      "enName": "Kamikawa Rumoi",
      "officeName": "旭川地方気象台",
      "chName": "上川/留萌地區",
      "zhName": "上川/留萌地区",
      "koName": "카미카와·루모에 지방",
      "esName": "Región de Kamikawa/Rumoi",
      "ptName": "Região de Kamikawa/Rumoi",
      "thName": "ภูมิภาคคามิคาวะ/รุโมอิ",
      "viName": "Vùng Kamikawa/Rumoi",
      "inName": "Wilayah Kamikawa/Rumoi",
      "tlName": "Rehiyon ng Kamikawa/Rumoi",
      "moName": "Камикава/Румой бүс нутаг",
      "buName": "Kamikawa/Rumoi ဒေသ",
      "khName": "តំបន់ Kamikawa/Rumoi",
      "neName": "कामिकावा/रुमोई क्षेत्र"
    },
    "class10": {
      "code": "012020",
      "name": "留萌地方",
      "enName": "Rumoi Region",
      "chName": "留萌地區",
      "zhName": "留萌地区",
      "koName": "루모이 지방",
      "esName": "Región de Rumoi",
      "ptName": "Região de Rumoi",
      "thName": "แคว้นรูมอย",
      "viName": "vùng Rumoi",
      "inName": "wilayah Rumoi",
      "tlName": "Rehiyon ng Rumoi",
      "moName": "Румой бүс",
      "buName": "Rumoi ဒေသ",
      "khName": "តំបន់ Rumoi",
      "neName": "रुमोई क्षेत्र"
    },
    "class15": {
      "code": "012022",
      "name": "留萌中部",
      "enName": "Middle Rumoi"
    },
    "class20": {
      "code": "0148401",
      "name": "羽幌町",
      "enName": "Haboro Town",
      "kana": "はぼろちょう",
      "chName": "羽幌町",
      "zhName": "羽幌町",
      "koName": "하보로 마을",
      "esName": "Haboro, Pueblo de Haboro",
      "ptName": "Haboro, Cidade de Haboro",
      "thName": "เมืองฮาบอโร",
      "viName": "Haboro, Thị trấn Haboro",
      "inName": "Haboro, Kota Haboro",
      "tlName": "Haboro, Bayan ng Haboro",
      "moName": "Haboro, Cidade de Haboro",
      "buName": "ဟာဘိုရိုမြို့",
      "khName": "ខេត្តហាបូរ៉ូ",
      "neName": "हाबोरो नगर"
    }
  },
  "0148402": {
    "office": {
      "code": "012000",
      "name": "上川・留萌地方",
      "enName": "Kamikawa Rumoi",
      "officeName": "旭川地方気象台",
      "chName": "上川/留萌地區",
      "zhName": "上川/留萌地区",
      "koName": "카미카와·루모에 지방",
      "esName": "Región de Kamikawa/Rumoi",
      "ptName": "Região de Kamikawa/Rumoi",
      "thName": "ภูมิภาคคามิคาวะ/รุโมอิ",
      "viName": "Vùng Kamikawa/Rumoi",
      "inName": "Wilayah Kamikawa/Rumoi",
      "tlName": "Rehiyon ng Kamikawa/Rumoi",
      "moName": "Камикава/Румой бүс нутаг",
      "buName": "Kamikawa/Rumoi ဒေသ",
      "khName": "តំបន់ Kamikawa/Rumoi",
      "neName": "कामिकावा/रुमोई क्षेत्र"
    },
    "class10": {
      "code": "012020",
      "name": "留萌地方",
      "enName": "Rumoi Region",
      "chName": "留萌地區",
      "zhName": "留萌地区",
      "koName": "루모이 지방",
      "esName": "Región de Rumoi",
      "ptName": "Região de Rumoi",
      "thName": "แคว้นรูมอย",
      "viName": "vùng Rumoi",
      "inName": "wilayah Rumoi",
      "tlName": "Rehiyon ng Rumoi",
      "moName": "Румой бүс",
      "buName": "Rumoi ဒေသ",
      "khName": "តំបន់ Rumoi",
      "neName": "रुमोई क्षेत्र"
    },
    "class15": {
      "code": "012022",
      "name": "留萌中部",
      "enName": "Middle Rumoi"
    },
    "class20": {
      "code": "0148402",
      "name": "羽幌町天売焼尻",
      "enName": "Teuri Yagishiri, Haboro Town",
      "kana": "はぼろちょうてうりやぎしり",
      "chName": "羽幌町天卖烧尻",
      "zhName": "羽幌町天卖烧尻",
      "koName": "하보로 마을 테우리 야기시리",
      "esName": "Teuri Yagishiri, Pueblo de Haboro",
      "ptName": "Teuri Yagishiri, Cidade de Haboro",
      "thName": "เมืองฮาบอโร เทอุริ ยากิชิริ",
      "viName": "Teuri Yagishiri, Thị trấn Haboro",
      "inName": "Teuri Yagishiri, Kota Haboro",
      "tlName": "Teuri Yagishiri, Bayan ng Haboro",
      "moName": "Teuri Yagishiri, Cidade de Haboro",
      "buName": "တူရီယာဂီရှရီ၊ ဟာဘိုရိုမြို့",
      "khName": "ខេត្តទេអូរីយ៉ាគីស៊ីរី",
      "neName": "तेउरी यागिशिरी नगर"
    }
  },
  "0148500": {
    "office": {
      "code": "012000",
      "name": "上川・留萌地方",
      "enName": "Kamikawa Rumoi",
      "officeName": "旭川地方気象台",
      "chName": "上川/留萌地區",
      "zhName": "上川/留萌地区",
      "koName": "카미카와·루모에 지방",
      "esName": "Región de Kamikawa/Rumoi",
      "ptName": "Região de Kamikawa/Rumoi",
      "thName": "ภูมิภาคคามิคาวะ/รุโมอิ",
      "viName": "Vùng Kamikawa/Rumoi",
      "inName": "Wilayah Kamikawa/Rumoi",
      "tlName": "Rehiyon ng Kamikawa/Rumoi",
      "moName": "Камикава/Румой бүс нутаг",
      "buName": "Kamikawa/Rumoi ဒေသ",
      "khName": "តំបន់ Kamikawa/Rumoi",
      "neName": "कामिकावा/रुमोई क्षेत्र"
    },
    "class10": {
      "code": "012020",
      "name": "留萌地方",
      "enName": "Rumoi Region",
      "chName": "留萌地區",
      "zhName": "留萌地区",
      "koName": "루모이 지방",
      "esName": "Región de Rumoi",
      "ptName": "Região de Rumoi",
      "thName": "แคว้นรูมอย",
      "viName": "vùng Rumoi",
      "inName": "wilayah Rumoi",
      "tlName": "Rehiyon ng Rumoi",
      "moName": "Румой бүс",
      "buName": "Rumoi ဒေသ",
      "khName": "តំបន់ Rumoi",
      "neName": "रुमोई क्षेत्र"
    },
    "class15": {
      "code": "012022",
      "name": "留萌中部",
      "enName": "Middle Rumoi"
    },
    "class20": {
      "code": "0148500",
      "name": "初山別村",
      "enName": "Shosambetsu Village",
      "kana": "しょさんべつむら",
      "chName": "初山别村",
      "zhName": "初山別村",
      "koName": "쇼산베쓰 촌",
      "esName": "Aldea de Shosanbetsu",
      "ptName": "povoado de Shosambetsu",
      "thName": "หมู่บ้านโชซัมเบทสึ",
      "viName": "làng Shosambetsu",
      "inName": "desa Shosambetsu",
      "tlName": "nayon ng Shosambetsu",
      "moName": "Шосамбэцү тосгон",
      "buName": "ချိုဆမ်းဗေ့စု ကျေးရွာ",
      "khName": "ភូមិ ស៊ូសាមបិតស៊ូ",
      "neName": "शोसाम्बेत्सु गाउँ"
    }
  },
  "0148600": {
    "office": {
      "code": "012000",
      "name": "上川・留萌地方",
      "enName": "Kamikawa Rumoi",
      "officeName": "旭川地方気象台",
      "chName": "上川/留萌地區",
      "zhName": "上川/留萌地区",
      "koName": "카미카와·루모에 지방",
      "esName": "Región de Kamikawa/Rumoi",
      "ptName": "Região de Kamikawa/Rumoi",
      "thName": "ภูมิภาคคามิคาวะ/รุโมอิ",
      "viName": "Vùng Kamikawa/Rumoi",
      "inName": "Wilayah Kamikawa/Rumoi",
      "tlName": "Rehiyon ng Kamikawa/Rumoi",
      "moName": "Камикава/Румой бүс нутаг",
      "buName": "Kamikawa/Rumoi ဒေသ",
      "khName": "តំបន់ Kamikawa/Rumoi",
      "neName": "कामिकावा/रुमोई क्षेत्र"
    },
    "class10": {
      "code": "012020",
      "name": "留萌地方",
      "enName": "Rumoi Region",
      "chName": "留萌地區",
      "zhName": "留萌地区",
      "koName": "루모이 지방",
      "esName": "Región de Rumoi",
      "ptName": "Região de Rumoi",
      "thName": "แคว้นรูมอย",
      "viName": "vùng Rumoi",
      "inName": "wilayah Rumoi",
      "tlName": "Rehiyon ng Rumoi",
      "moName": "Румой бүс",
      "buName": "Rumoi ဒေသ",
      "khName": "តំបន់ Rumoi",
      "neName": "रुमोई क्षेत्र"
    },
    "class15": {
      "code": "012021",
      "name": "留萌北部",
      "enName": "Northern Rumoi"
    },
    "class20": {
      "code": "0148600",
      "name": "遠別町",
      "enName": "Embetsu Town",
      "kana": "えんべつちょう",
      "chName": "远别町",
      "zhName": "遠別町",
      "koName": "엔베쓰 정",
      "esName": "Pueblo de Enbetsu",
      "ptName": "bairro de Embetsu",
      "thName": "เมืองเอมเบทสึ",
      "viName": "thị trấn Embetsu",
      "inName": "kota Embetsu",
      "tlName": "bayan ng Embetsu",
      "moName": "Эмбэцү жижиг хот",
      "buName": "အမ်းဗေ့စု မြို့နယ်",
      "khName": "ទីប្រជុំជន អេមបិតស៊ូ",
      "neName": "एम्बेत्सु नगर"
    }
  },
  "0148700": {
    "office": {
      "code": "012000",
      "name": "上川・留萌地方",
      "enName": "Kamikawa Rumoi",
      "officeName": "旭川地方気象台",
      "chName": "上川/留萌地區",
      "zhName": "上川/留萌地区",
      "koName": "카미카와·루모에 지방",
      "esName": "Región de Kamikawa/Rumoi",
      "ptName": "Região de Kamikawa/Rumoi",
      "thName": "ภูมิภาคคามิคาวะ/รุโมอิ",
      "viName": "Vùng Kamikawa/Rumoi",
      "inName": "Wilayah Kamikawa/Rumoi",
      "tlName": "Rehiyon ng Kamikawa/Rumoi",
      "moName": "Камикава/Румой бүс нутаг",
      "buName": "Kamikawa/Rumoi ဒေသ",
      "khName": "តំបន់ Kamikawa/Rumoi",
      "neName": "कामिकावा/रुमोई क्षेत्र"
    },
    "class10": {
      "code": "012020",
      "name": "留萌地方",
      "enName": "Rumoi Region",
      "chName": "留萌地區",
      "zhName": "留萌地区",
      "koName": "루모이 지방",
      "esName": "Región de Rumoi",
      "ptName": "Região de Rumoi",
      "thName": "แคว้นรูมอย",
      "viName": "vùng Rumoi",
      "inName": "wilayah Rumoi",
      "tlName": "Rehiyon ng Rumoi",
      "moName": "Румой бүс",
      "buName": "Rumoi ဒေသ",
      "khName": "តំបន់ Rumoi",
      "neName": "रुमोई क्षेत्र"
    },
    "class15": {
      "code": "012021",
      "name": "留萌北部",
      "enName": "Northern Rumoi"
    },
    "class20": {
      "code": "0148700",
      "name": "天塩町",
      "enName": "Teshio Town",
      "kana": "てしおちょう",
      "chName": "天盐町",
      "zhName": "天鹽町",
      "koName": "데시오 정",
      "esName": "Pueblo de Teshio",
      "ptName": "bairro de Teshio",
      "thName": "เมืองเทชิโอะ",
      "viName": "thị trấn Teshio",
      "inName": "kota Teshio",
      "tlName": "bayan ng Teshio",
      "moName": "Тэшио жижиг хот",
      "buName": "တယ်ရှိရို မြို့နယ်",
      "khName": "ទីប្រជុំជន តេស៊ីអូ",
      "neName": "तेशिओ नगर"
    }
  },
  "0151100": {
    "office": {
      "code": "011000",
      "name": "宗谷地方",
      "enName": "Soya",
      "officeName": "稚内地方気象台",
      "chName": "大豆地區",
      "zhName": "大豆地区",
      "koName": "소야 지방",
      "esName": "Región de soja",
      "ptName": "Região da soja",
      "thName": "ภูมิภาคถั่วเหลือง",
      "viName": "vùng đậu nành",
      "inName": "wilayah kedelai",
      "tlName": "Rehiyon ng soya",
      "moName": "Шар буурцагны бүс",
      "buName": "ပဲပိစပ်ဒေသ",
      "khName": "តំបន់សណ្តែក",
      "neName": "सोया क्षेत्र"
    },
    "class10": {
      "code": "011000",
      "name": "宗谷地方",
      "enName": "Soya Region",
      "chName": "大豆地區",
      "zhName": "大豆地区",
      "koName": "소야 지방",
      "esName": "Región de soja",
      "ptName": "Região da soja",
      "thName": "ภูมิภาคถั่วเหลือง",
      "viName": "vùng đậu nành",
      "inName": "wilayah kedelai",
      "tlName": "Rehiyon ng soya",
      "moName": "Шар буурцгийн бүс",
      "buName": "ပဲပိစပ်ဒေသ",
      "khName": "តំបន់សណ្តែក",
      "neName": "सोया क्षेत्र"
    },
    "class15": {
      "code": "011011",
      "name": "宗谷北部",
      "enName": "Northern Soya"
    },
    "class20": {
      "code": "0151100",
      "name": "猿払村",
      "enName": "Sarufutsu Village",
      "kana": "さるふつむら",
      "chName": "猿拂村",
      "zhName": "猿拂村",
      "koName": "사루후쓰 촌",
      "esName": "Aldea de Sarufutsu",
      "ptName": "povoado de Sarufutsu",
      "thName": "หมู่บ้านซารุฟุตสึ",
      "viName": "làng Sarufutsu",
      "inName": "desa Sarufutsu",
      "tlName": "nayon ng Sarufutsu",
      "moName": "Сaрүфүцү тосгон",
      "buName": "ဆာရုဟုစု ကျေးရွာ",
      "khName": "ភូមិ សារូហ្វូតស៊ូ",
      "neName": "सारुफुत्सु गाउँ"
    }
  },
  "0151200": {
    "office": {
      "code": "011000",
      "name": "宗谷地方",
      "enName": "Soya",
      "officeName": "稚内地方気象台",
      "chName": "大豆地區",
      "zhName": "大豆地区",
      "koName": "소야 지방",
      "esName": "Región de soja",
      "ptName": "Região da soja",
      "thName": "ภูมิภาคถั่วเหลือง",
      "viName": "vùng đậu nành",
      "inName": "wilayah kedelai",
      "tlName": "Rehiyon ng soya",
      "moName": "Шар буурцагны бүс",
      "buName": "ပဲပိစပ်ဒေသ",
      "khName": "តំបន់សណ្តែក",
      "neName": "सोया क्षेत्र"
    },
    "class10": {
      "code": "011000",
      "name": "宗谷地方",
      "enName": "Soya Region",
      "chName": "大豆地區",
      "zhName": "大豆地区",
      "koName": "소야 지방",
      "esName": "Región de soja",
      "ptName": "Região da soja",
      "thName": "ภูมิภาคถั่วเหลือง",
      "viName": "vùng đậu nành",
      "inName": "wilayah kedelai",
      "tlName": "Rehiyon ng soya",
      "moName": "Шар буурцгийн бүс",
      "buName": "ပဲပိစပ်ဒေသ",
      "khName": "តំបន់សណ្តែក",
      "neName": "सोया क्षेत्र"
    },
    "class15": {
      "code": "011012",
      "name": "宗谷南部",
      "enName": "Southern Soya"
    },
    "class20": {
      "code": "0151200",
      "name": "浜頓別町",
      "enName": "Hamatombetsu Town",
      "kana": "はまとんべつちょう",
      "chName": "滨顿别町",
      "zhName": "濱頓別町",
      "koName": "하마톤베쓰 정",
      "esName": "Pueblo de Hamatonbetsu",
      "ptName": "bairro de Hamatombetsu",
      "thName": "เมืองฮามะทอมเบตสึ",
      "viName": "thị trấn Hamatombetsu",
      "inName": "kota Hamatombetsu",
      "tlName": "bayan ng Hamatombetsu",
      "moName": "Хaмaтомбэцү жижиг хот",
      "buName": "ဟာမာတွမ်ဗေ့စု မြို့နယ်",
      "khName": "ទីប្រជុំជន ហាម៉ាតតុមបេតស៊ូ",
      "neName": "हामातोम्बेत्सु नगर"
    }
  },
  "0151300": {
    "office": {
      "code": "011000",
      "name": "宗谷地方",
      "enName": "Soya",
      "officeName": "稚内地方気象台",
      "chName": "大豆地區",
      "zhName": "大豆地区",
      "koName": "소야 지방",
      "esName": "Región de soja",
      "ptName": "Região da soja",
      "thName": "ภูมิภาคถั่วเหลือง",
      "viName": "vùng đậu nành",
      "inName": "wilayah kedelai",
      "tlName": "Rehiyon ng soya",
      "moName": "Шар буурцагны бүс",
      "buName": "ပဲပိစပ်ဒေသ",
      "khName": "តំបន់សណ្តែក",
      "neName": "सोया क्षेत्र"
    },
    "class10": {
      "code": "011000",
      "name": "宗谷地方",
      "enName": "Soya Region",
      "chName": "大豆地區",
      "zhName": "大豆地区",
      "koName": "소야 지방",
      "esName": "Región de soja",
      "ptName": "Região da soja",
      "thName": "ภูมิภาคถั่วเหลือง",
      "viName": "vùng đậu nành",
      "inName": "wilayah kedelai",
      "tlName": "Rehiyon ng soya",
      "moName": "Шар буурцгийн бүс",
      "buName": "ပဲပိစပ်ဒေသ",
      "khName": "តំបន់សណ្តែក",
      "neName": "सोया क्षेत्र"
    },
    "class15": {
      "code": "011012",
      "name": "宗谷南部",
      "enName": "Southern Soya"
    },
    "class20": {
      "code": "0151300",
      "name": "中頓別町",
      "enName": "Nakatombetsu Town",
      "kana": "なかとんべつちょう",
      "chName": "中顿别町",
      "zhName": "中頓別町",
      "koName": "나카톤베쓰 정",
      "esName": "Pueblo de Nakatonbetsu",
      "ptName": "bairro de Nakatombetsu",
      "thName": "เมืองนากะทอมเบตสึ",
      "viName": "thị trấn Nakatombetsu",
      "inName": "kota Nakatombetsu",
      "tlName": "bayan ng Nakatombetsu",
      "moName": "Нaкатомбэцү жижиг хот",
      "buName": "နာကာတွမ်ဗေ့စု မြို့နယ်",
      "khName": "ទីប្រជុំជន ណាកាតុមបេតស៊ូ",
      "neName": "नाकातोम्बेत्सु नगर"
    }
  },
  "0151400": {
    "office": {
      "code": "011000",
      "name": "宗谷地方",
      "enName": "Soya",
      "officeName": "稚内地方気象台",
      "chName": "大豆地區",
      "zhName": "大豆地区",
      "koName": "소야 지방",
      "esName": "Región de soja",
      "ptName": "Região da soja",
      "thName": "ภูมิภาคถั่วเหลือง",
      "viName": "vùng đậu nành",
      "inName": "wilayah kedelai",
      "tlName": "Rehiyon ng soya",
      "moName": "Шар буурцагны бүс",
      "buName": "ပဲပိစပ်ဒေသ",
      "khName": "តំបន់សណ្តែក",
      "neName": "सोया क्षेत्र"
    },
    "class10": {
      "code": "011000",
      "name": "宗谷地方",
      "enName": "Soya Region",
      "chName": "大豆地區",
      "zhName": "大豆地区",
      "koName": "소야 지방",
      "esName": "Región de soja",
      "ptName": "Região da soja",
      "thName": "ภูมิภาคถั่วเหลือง",
      "viName": "vùng đậu nành",
      "inName": "wilayah kedelai",
      "tlName": "Rehiyon ng soya",
      "moName": "Шар буурцгийн бүс",
      "buName": "ပဲပိစပ်ဒေသ",
      "khName": "តំបន់សណ្តែក",
      "neName": "सोया क्षेत्र"
    },
    "class15": {
      "code": "011012",
      "name": "宗谷南部",
      "enName": "Southern Soya"
    },
    "class20": {
      "code": "0151400",
      "name": "枝幸町",
      "enName": "Esashi Town",
      "kana": "えさしちょう",
      "chName": "宗谷枝幸町",
      "zhName": "宗穀枝幸町",
      "koName": "소야 에사시 정",
      "esName": "Pueblo de Esashi, Soya",
      "ptName": "Soya, bairro de Esashi",
      "thName": "เมืองเอซาชิ โซยะ",
      "viName": "Thị trấn Esashi, Soya",
      "inName": "Kota Esashi, Soya",
      "tlName": "bayan ng Esashi, Soya",
      "moName": "Соя Эсаши жижиг хот",
      "buName": "ဆိုးယအဲဆရှိမြို့နယ်",
      "khName": "ទីប្រជុំជនអេសាស៊ី សូយ៉ា",
      "neName": "सोया एसाशी नगर "
    }
  },
  "0151600": {
    "office": {
      "code": "011000",
      "name": "宗谷地方",
      "enName": "Soya",
      "officeName": "稚内地方気象台",
      "chName": "大豆地區",
      "zhName": "大豆地区",
      "koName": "소야 지방",
      "esName": "Región de soja",
      "ptName": "Região da soja",
      "thName": "ภูมิภาคถั่วเหลือง",
      "viName": "vùng đậu nành",
      "inName": "wilayah kedelai",
      "tlName": "Rehiyon ng soya",
      "moName": "Шар буурцагны бүс",
      "buName": "ပဲပိစပ်ဒေသ",
      "khName": "តំបន់សណ្តែក",
      "neName": "सोया क्षेत्र"
    },
    "class10": {
      "code": "011000",
      "name": "宗谷地方",
      "enName": "Soya Region",
      "chName": "大豆地區",
      "zhName": "大豆地区",
      "koName": "소야 지방",
      "esName": "Región de soja",
      "ptName": "Região da soja",
      "thName": "ภูมิภาคถั่วเหลือง",
      "viName": "vùng đậu nành",
      "inName": "wilayah kedelai",
      "tlName": "Rehiyon ng soya",
      "moName": "Шар буурцгийн бүс",
      "buName": "ပဲပိစပ်ဒေသ",
      "khName": "តំបន់សណ្តែក",
      "neName": "सोया क्षेत्र"
    },
    "class15": {
      "code": "011011",
      "name": "宗谷北部",
      "enName": "Northern Soya"
    },
    "class20": {
      "code": "0151600",
      "name": "豊富町",
      "enName": "Toyotomi Town",
      "kana": "とよとみちょう",
      "chName": "丰富町",
      "zhName": "豐富町",
      "koName": "도요토미 정",
      "esName": "Pueblo de Toyotomi",
      "ptName": "bairro de Toyotomi",
      "thName": "เมืองโทโยโทมิ",
      "viName": "thị trấn Toyotomi",
      "inName": "kota Toyotomi",
      "tlName": "bayan ng Toyotomi",
      "moName": "Тоёотоми жижиг хот",
      "buName": "တိုရိုတောမိ မြို့နယ်",
      "khName": "ទីប្រជុំជន តូយ៉ូតូមី",
      "neName": "तोयोतोमी नगर"
    }
  },
  "0151700": {
    "office": {
      "code": "011000",
      "name": "宗谷地方",
      "enName": "Soya",
      "officeName": "稚内地方気象台",
      "chName": "大豆地區",
      "zhName": "大豆地区",
      "koName": "소야 지방",
      "esName": "Región de soja",
      "ptName": "Região da soja",
      "thName": "ภูมิภาคถั่วเหลือง",
      "viName": "vùng đậu nành",
      "inName": "wilayah kedelai",
      "tlName": "Rehiyon ng soya",
      "moName": "Шар буурцагны бүс",
      "buName": "ပဲပိစပ်ဒေသ",
      "khName": "តំបន់សណ្តែក",
      "neName": "सोया क्षेत्र"
    },
    "class10": {
      "code": "011000",
      "name": "宗谷地方",
      "enName": "Soya Region",
      "chName": "大豆地區",
      "zhName": "大豆地区",
      "koName": "소야 지방",
      "esName": "Región de soja",
      "ptName": "Região da soja",
      "thName": "ภูมิภาคถั่วเหลือง",
      "viName": "vùng đậu nành",
      "inName": "wilayah kedelai",
      "tlName": "Rehiyon ng soya",
      "moName": "Шар буурцгийн бүс",
      "buName": "ပဲပိစပ်ဒေသ",
      "khName": "តំបន់សណ្តែក",
      "neName": "सोया क्षेत्र"
    },
    "class15": {
      "code": "011013",
      "name": "利尻・礼文",
      "enName": "Rishiri Rebun"
    },
    "class20": {
      "code": "0151700",
      "name": "礼文町",
      "enName": "Rebun Town",
      "kana": "れぶんちょう",
      "chName": "礼文町",
      "zhName": "禮文町",
      "koName": "레분 정",
      "esName": "Pueblo de Rubun",
      "ptName": "bairro de Rebun",
      "thName": "เมืองเรบุน",
      "viName": "thị trấn Rebun",
      "inName": "kota Rebun",
      "tlName": "bayan ng Rebun",
      "moName": "Рэбүн жижиг хот",
      "buName": "ရေးဘွန် မြို့နယ်",
      "khName": "ទីប្រជុំជន រីប៊ុន",
      "neName": "रेबुन नगर"
    }
  },
  "0151800": {
    "office": {
      "code": "011000",
      "name": "宗谷地方",
      "enName": "Soya",
      "officeName": "稚内地方気象台",
      "chName": "大豆地區",
      "zhName": "大豆地区",
      "koName": "소야 지방",
      "esName": "Región de soja",
      "ptName": "Região da soja",
      "thName": "ภูมิภาคถั่วเหลือง",
      "viName": "vùng đậu nành",
      "inName": "wilayah kedelai",
      "tlName": "Rehiyon ng soya",
      "moName": "Шар буурцагны бүс",
      "buName": "ပဲပိစပ်ဒေသ",
      "khName": "តំបន់សណ្តែក",
      "neName": "सोया क्षेत्र"
    },
    "class10": {
      "code": "011000",
      "name": "宗谷地方",
      "enName": "Soya Region",
      "chName": "大豆地區",
      "zhName": "大豆地区",
      "koName": "소야 지방",
      "esName": "Región de soja",
      "ptName": "Região da soja",
      "thName": "ภูมิภาคถั่วเหลือง",
      "viName": "vùng đậu nành",
      "inName": "wilayah kedelai",
      "tlName": "Rehiyon ng soya",
      "moName": "Шар буурцгийн бүс",
      "buName": "ပဲပိစပ်ဒေသ",
      "khName": "តំបន់សណ្តែក",
      "neName": "सोया क्षेत्र"
    },
    "class15": {
      "code": "011013",
      "name": "利尻・礼文",
      "enName": "Rishiri Rebun"
    },
    "class20": {
      "code": "0151800",
      "name": "利尻町",
      "enName": "Rishiri Town",
      "kana": "りしりちょう",
      "chName": "利尻町",
      "zhName": "利尻町",
      "koName": "리시리 정",
      "esName": "Pueblo de Rishiri",
      "ptName": "bairro de Rishiri",
      "thName": "เมืองริชิริ",
      "viName": "thị trấn Rishiri",
      "inName": "kota Rishiri",
      "tlName": "bayan ng Rishiri",
      "moName": "Ришири жижиг хот",
      "buName": "ရီးရှီရိ မြို့နယ်",
      "khName": "ទីប្រជុំជន រីស៊ីរី",
      "neName": "रिसिरी नगर"
    }
  },
  "0151900": {
    "office": {
      "code": "011000",
      "name": "宗谷地方",
      "enName": "Soya",
      "officeName": "稚内地方気象台",
      "chName": "大豆地區",
      "zhName": "大豆地区",
      "koName": "소야 지방",
      "esName": "Región de soja",
      "ptName": "Região da soja",
      "thName": "ภูมิภาคถั่วเหลือง",
      "viName": "vùng đậu nành",
      "inName": "wilayah kedelai",
      "tlName": "Rehiyon ng soya",
      "moName": "Шар буурцагны бүс",
      "buName": "ပဲပိစပ်ဒေသ",
      "khName": "តំបន់សណ្តែក",
      "neName": "सोया क्षेत्र"
    },
    "class10": {
      "code": "011000",
      "name": "宗谷地方",
      "enName": "Soya Region",
      "chName": "大豆地區",
      "zhName": "大豆地区",
      "koName": "소야 지방",
      "esName": "Región de soja",
      "ptName": "Região da soja",
      "thName": "ภูมิภาคถั่วเหลือง",
      "viName": "vùng đậu nành",
      "inName": "wilayah kedelai",
      "tlName": "Rehiyon ng soya",
      "moName": "Шар буурцгийн бүс",
      "buName": "ပဲပိစပ်ဒေသ",
      "khName": "តំបន់សណ្តែក",
      "neName": "सोया क्षेत्र"
    },
    "class15": {
      "code": "011013",
      "name": "利尻・礼文",
      "enName": "Rishiri Rebun"
    },
    "class20": {
      "code": "0151900",
      "name": "利尻富士町",
      "enName": "Rishirifuji Town",
      "kana": "りしりふじちょう",
      "chName": "利尻富士町",
      "zhName": "利尻富士町",
      "koName": "리시리후지 정",
      "esName": "Pueblo de Rishirifuji",
      "ptName": "bairro de Rishirifuji",
      "thName": "เมืองริชิริฟุจิ",
      "viName": "thị trấn Rishirifuji",
      "inName": "kota Rishirifuji",
      "tlName": "bayan ng Rishirifuji",
      "moName": "Риширифүжи жижиг хот",
      "buName": "ရီရှိရိဟုဂျိ မြို့နယ်",
      "khName": "ទីប្រជុំជន រីស៊ីរីហ្វូជី",
      "neName": "रिसिरिफुजी नगर"
    }
  },
  "0152000": {
    "office": {
      "code": "011000",
      "name": "宗谷地方",
      "enName": "Soya",
      "officeName": "稚内地方気象台",
      "chName": "大豆地區",
      "zhName": "大豆地区",
      "koName": "소야 지방",
      "esName": "Región de soja",
      "ptName": "Região da soja",
      "thName": "ภูมิภาคถั่วเหลือง",
      "viName": "vùng đậu nành",
      "inName": "wilayah kedelai",
      "tlName": "Rehiyon ng soya",
      "moName": "Шар буурцагны бүс",
      "buName": "ပဲပိစပ်ဒေသ",
      "khName": "តំបន់សណ្តែក",
      "neName": "सोया क्षेत्र"
    },
    "class10": {
      "code": "011000",
      "name": "宗谷地方",
      "enName": "Soya Region",
      "chName": "大豆地區",
      "zhName": "大豆地区",
      "koName": "소야 지방",
      "esName": "Región de soja",
      "ptName": "Região da soja",
      "thName": "ภูมิภาคถั่วเหลือง",
      "viName": "vùng đậu nành",
      "inName": "wilayah kedelai",
      "tlName": "Rehiyon ng soya",
      "moName": "Шар буурцгийн бүс",
      "buName": "ပဲပိစပ်ဒေသ",
      "khName": "តំបន់សណ្តែក",
      "neName": "सोया क्षेत्र"
    },
    "class15": {
      "code": "011011",
      "name": "宗谷北部",
      "enName": "Northern Soya"
    },
    "class20": {
      "code": "0152000",
      "name": "幌延町",
      "enName": "Horonobe Town",
      "kana": "ほろのべちょう",
      "chName": "幌延町",
      "zhName": "幌延町",
      "koName": "호로노베 정",
      "esName": "Pueblo de Horonobe",
      "ptName": "bairro de Horonobe",
      "thName": "เมืองโฮโระโนเบะ",
      "viName": "thị trấn Horonobe",
      "inName": "kota Horonobe",
      "tlName": "bayan ng Horonobe",
      "moName": "Хоронобэ жижиг хот",
      "buName": "ဟိုရိုးနို့ဘဲ့ မြို့နယ်",
      "khName": "ទីប្រជុំជន ហរ៉ូនណូបេ",
      "neName": "होरोनोबे नगर"
    }
  },
  "0154300": {
    "office": {
      "code": "013000",
      "name": "網走・北見・紋別地方",
      "enName": "Abashiri Kitami Mombetsu",
      "officeName": "網走地方気象台",
      "chName": "網走/北見/紋別地區",
      "zhName": "网走/北见/纹别地区",
      "koName": "아바시리 · 기타미 · 몬 베츠 지방",
      "esName": "Región de Abashiri/Kitami/Monbetsu",
      "ptName": "Região de Abashiri/Kitami/Monbetsu",
      "thName": "ภูมิภาคอะบาชิริ/คิตามิ/มงเบ็ตสึ",
      "viName": "Vùng Abashiri/Kitami/Monbetsu",
      "inName": "Wilayah Abashiri/Kitami/Monbetsu",
      "tlName": "Rehiyon ng Abashiri/Kitami/Monbetsu",
      "moName": "Абашири/Китами/Монбетсу бүс нутаг",
      "buName": "Abashiri/Kitami/Monbetsu ဒေသ",
      "khName": "តំបន់ Abashiri/Kitami/Monbetsu",
      "neName": "अबाशिरी/कितामी/मोन्बेटसु क्षेत्र"
    },
    "class10": {
      "code": "013010",
      "name": "網走地方",
      "enName": "Abashiri Region",
      "chName": "网走地方",
      "zhName": "網走地方",
      "koName": "아바시리 지방",
      "esName": "Región Abashiri",
      "ptName": "Região de Abashiri",
      "thName": "ท้องถิ่นอะบาชิริ",
      "viName": "Vùng Abashiri",
      "inName": "Daerah Abashiri",
      "tlName": "Rehiyon ng Abashiri",
      "moName": "Абашири муж",
      "buName": "အဘရှိယိဒေသ၊ ဟိုကိုင်းဒို",
      "khName": "តំបន់អាបាស៊ីរី",
      "neName": "आबासिरी क्षेत्र"
    },
    "class15": {
      "code": "013013",
      "name": "網走南部",
      "enName": "Southern Abashiri"
    },
    "class20": {
      "code": "0154300",
      "name": "美幌町",
      "enName": "Bihoro Town",
      "kana": "びほろちょう",
      "chName": "美幌町",
      "zhName": "美幌町",
      "koName": "비호로 정",
      "esName": "Pueblo de Bihoro",
      "ptName": "bairro de Bihoro",
      "thName": "เมืองบิโฮโระ",
      "viName": "thị trấn Bihoro",
      "inName": "kota Bihoro",
      "tlName": "bayan ng Bihoro",
      "moName": "Бихоро жижиг хот",
      "buName": "ဘီဟိုရို မြို့နယ်",
      "khName": "ទីប្រជុំជន ប៊ីហូរ៉ូ",
      "neName": "बिहोरो नगर"
    }
  },
  "0154400": {
    "office": {
      "code": "013000",
      "name": "網走・北見・紋別地方",
      "enName": "Abashiri Kitami Mombetsu",
      "officeName": "網走地方気象台",
      "chName": "網走/北見/紋別地區",
      "zhName": "网走/北见/纹别地区",
      "koName": "아바시리 · 기타미 · 몬 베츠 지방",
      "esName": "Región de Abashiri/Kitami/Monbetsu",
      "ptName": "Região de Abashiri/Kitami/Monbetsu",
      "thName": "ภูมิภาคอะบาชิริ/คิตามิ/มงเบ็ตสึ",
      "viName": "Vùng Abashiri/Kitami/Monbetsu",
      "inName": "Wilayah Abashiri/Kitami/Monbetsu",
      "tlName": "Rehiyon ng Abashiri/Kitami/Monbetsu",
      "moName": "Абашири/Китами/Монбетсу бүс нутаг",
      "buName": "Abashiri/Kitami/Monbetsu ဒေသ",
      "khName": "តំបន់ Abashiri/Kitami/Monbetsu",
      "neName": "अबाशिरी/कितामी/मोन्बेटसु क्षेत्र"
    },
    "class10": {
      "code": "013010",
      "name": "網走地方",
      "enName": "Abashiri Region",
      "chName": "网走地方",
      "zhName": "網走地方",
      "koName": "아바시리 지방",
      "esName": "Región Abashiri",
      "ptName": "Região de Abashiri",
      "thName": "ท้องถิ่นอะบาชิริ",
      "viName": "Vùng Abashiri",
      "inName": "Daerah Abashiri",
      "tlName": "Rehiyon ng Abashiri",
      "moName": "Абашири муж",
      "buName": "အဘရှိယိဒေသ၊ ဟိုကိုင်းဒို",
      "khName": "តំបន់អាបាស៊ីរី",
      "neName": "आबासिरी क्षेत्र"
    },
    "class15": {
      "code": "013013",
      "name": "網走南部",
      "enName": "Southern Abashiri"
    },
    "class20": {
      "code": "0154400",
      "name": "津別町",
      "enName": "Tsubetsu Town",
      "kana": "つべつちょう",
      "chName": "津别町",
      "zhName": "津別町",
      "koName": "쓰베쓰 정",
      "esName": "Pueblo de Tsubetsu",
      "ptName": "bairro de Tsubetsu",
      "thName": "เมืองสึเบทสึ",
      "viName": "thị trấn Tsubetsu",
      "inName": "kota Tsubetsu",
      "tlName": "bayan ng Tsubetsu",
      "moName": "Цүбэцү жижиг хот",
      "buName": "ဆုဗေ့စု မြို့နယ်",
      "khName": "ទីប្រជុំជន ស៊ូបេតស៊ូ",
      "neName": "त्सुबेत्सु नगर"
    }
  },
  "0154500": {
    "office": {
      "code": "013000",
      "name": "網走・北見・紋別地方",
      "enName": "Abashiri Kitami Mombetsu",
      "officeName": "網走地方気象台",
      "chName": "網走/北見/紋別地區",
      "zhName": "网走/北见/纹别地区",
      "koName": "아바시리 · 기타미 · 몬 베츠 지방",
      "esName": "Región de Abashiri/Kitami/Monbetsu",
      "ptName": "Região de Abashiri/Kitami/Monbetsu",
      "thName": "ภูมิภาคอะบาชิริ/คิตามิ/มงเบ็ตสึ",
      "viName": "Vùng Abashiri/Kitami/Monbetsu",
      "inName": "Wilayah Abashiri/Kitami/Monbetsu",
      "tlName": "Rehiyon ng Abashiri/Kitami/Monbetsu",
      "moName": "Абашири/Китами/Монбетсу бүс нутаг",
      "buName": "Abashiri/Kitami/Monbetsu ဒေသ",
      "khName": "តំបន់ Abashiri/Kitami/Monbetsu",
      "neName": "अबाशिरी/कितामी/मोन्बेटसु क्षेत्र"
    },
    "class10": {
      "code": "013010",
      "name": "網走地方",
      "enName": "Abashiri Region",
      "chName": "网走地方",
      "zhName": "網走地方",
      "koName": "아바시리 지방",
      "esName": "Región Abashiri",
      "ptName": "Região de Abashiri",
      "thName": "ท้องถิ่นอะบาชิริ",
      "viName": "Vùng Abashiri",
      "inName": "Daerah Abashiri",
      "tlName": "Rehiyon ng Abashiri",
      "moName": "Абашири муж",
      "buName": "အဘရှိယိဒေသ၊ ဟိုကိုင်းဒို",
      "khName": "តំបន់អាបាស៊ីរី",
      "neName": "आबासिरी क्षेत्र"
    },
    "class15": {
      "code": "013012",
      "name": "網走東部",
      "enName": "Eastern Abashiri"
    },
    "class20": {
      "code": "0154500",
      "name": "斜里町",
      "enName": "Shari Town",
      "kana": "しゃりちょう",
      "chName": "斜里町",
      "zhName": "斜里町",
      "koName": "샤리 정",
      "esName": "Pueblo de Shari",
      "ptName": "bairro de Shari",
      "thName": "เมืองชาริ",
      "viName": "thị trấn Shari",
      "inName": "kota Shari",
      "tlName": "bayan ng Shari",
      "moName": "Шaри жижиг хот",
      "buName": "ရှေရိ မြို့နယ်",
      "khName": "ទីប្រជុំជន សារិ",
      "neName": "शारी नगर"
    }
  },
  "0154600": {
    "office": {
      "code": "013000",
      "name": "網走・北見・紋別地方",
      "enName": "Abashiri Kitami Mombetsu",
      "officeName": "網走地方気象台",
      "chName": "網走/北見/紋別地區",
      "zhName": "网走/北见/纹别地区",
      "koName": "아바시리 · 기타미 · 몬 베츠 지방",
      "esName": "Región de Abashiri/Kitami/Monbetsu",
      "ptName": "Região de Abashiri/Kitami/Monbetsu",
      "thName": "ภูมิภาคอะบาชิริ/คิตามิ/มงเบ็ตสึ",
      "viName": "Vùng Abashiri/Kitami/Monbetsu",
      "inName": "Wilayah Abashiri/Kitami/Monbetsu",
      "tlName": "Rehiyon ng Abashiri/Kitami/Monbetsu",
      "moName": "Абашири/Китами/Монбетсу бүс нутаг",
      "buName": "Abashiri/Kitami/Monbetsu ဒေသ",
      "khName": "តំបន់ Abashiri/Kitami/Monbetsu",
      "neName": "अबाशिरी/कितामी/मोन्बेटसु क्षेत्र"
    },
    "class10": {
      "code": "013010",
      "name": "網走地方",
      "enName": "Abashiri Region",
      "chName": "网走地方",
      "zhName": "網走地方",
      "koName": "아바시리 지방",
      "esName": "Región Abashiri",
      "ptName": "Região de Abashiri",
      "thName": "ท้องถิ่นอะบาชิริ",
      "viName": "Vùng Abashiri",
      "inName": "Daerah Abashiri",
      "tlName": "Rehiyon ng Abashiri",
      "moName": "Абашири муж",
      "buName": "အဘရှိယိဒေသ၊ ဟိုကိုင်းဒို",
      "khName": "តំបន់អាបាស៊ីរី",
      "neName": "आबासिरी क्षेत्र"
    },
    "class15": {
      "code": "013012",
      "name": "網走東部",
      "enName": "Eastern Abashiri"
    },
    "class20": {
      "code": "0154600",
      "name": "清里町",
      "enName": "Kiyosato Town",
      "kana": "きよさとちょう",
      "chName": "清里町",
      "zhName": "清里町",
      "koName": "기요사토 정",
      "esName": "Pueblo de Kiyosato",
      "ptName": "bairro de Kiyosato",
      "thName": "เมืองคิโยซาโตะ",
      "viName": "thị trấn Kiyosato",
      "inName": "kota Kiyosato",
      "tlName": "bayan ng Kiyosato",
      "moName": "Киёосaто жижиг хот",
      "buName": "ခီယိုဆာတို မြို့နယ်",
      "khName": "ទីប្រជុំជន គីយ៉ូសាតុ",
      "neName": "कियोसातो नगर"
    }
  },
  "0154700": {
    "office": {
      "code": "013000",
      "name": "網走・北見・紋別地方",
      "enName": "Abashiri Kitami Mombetsu",
      "officeName": "網走地方気象台",
      "chName": "網走/北見/紋別地區",
      "zhName": "网走/北见/纹别地区",
      "koName": "아바시리 · 기타미 · 몬 베츠 지방",
      "esName": "Región de Abashiri/Kitami/Monbetsu",
      "ptName": "Região de Abashiri/Kitami/Monbetsu",
      "thName": "ภูมิภาคอะบาชิริ/คิตามิ/มงเบ็ตสึ",
      "viName": "Vùng Abashiri/Kitami/Monbetsu",
      "inName": "Wilayah Abashiri/Kitami/Monbetsu",
      "tlName": "Rehiyon ng Abashiri/Kitami/Monbetsu",
      "moName": "Абашири/Китами/Монбетсу бүс нутаг",
      "buName": "Abashiri/Kitami/Monbetsu ဒေသ",
      "khName": "តំបន់ Abashiri/Kitami/Monbetsu",
      "neName": "अबाशिरी/कितामी/मोन्बेटसु क्षेत्र"
    },
    "class10": {
      "code": "013010",
      "name": "網走地方",
      "enName": "Abashiri Region",
      "chName": "网走地方",
      "zhName": "網走地方",
      "koName": "아바시리 지방",
      "esName": "Región Abashiri",
      "ptName": "Região de Abashiri",
      "thName": "ท้องถิ่นอะบาชิริ",
      "viName": "Vùng Abashiri",
      "inName": "Daerah Abashiri",
      "tlName": "Rehiyon ng Abashiri",
      "moName": "Абашири муж",
      "buName": "အဘရှိယိဒေသ၊ ဟိုကိုင်းဒို",
      "khName": "តំបន់អាបាស៊ីរី",
      "neName": "आबासिरी क्षेत्र"
    },
    "class15": {
      "code": "013012",
      "name": "網走東部",
      "enName": "Eastern Abashiri"
    },
    "class20": {
      "code": "0154700",
      "name": "小清水町",
      "enName": "Koshimizu Town",
      "kana": "こしみずちょう",
      "chName": "小清水町",
      "zhName": "小清水町",
      "koName": "고시미즈 정",
      "esName": "Pueblo de Koshimizu",
      "ptName": "bairro de Koshimizu",
      "thName": "เมืองโคชิมิสึ",
      "viName": "thị trấn Koshimizu",
      "inName": "kota Koshimizu",
      "tlName": "bayan ng Koshimizu",
      "moName": "Кошимизү жижиг хот",
      "buName": "ကိုရှိမိဇု မြို့နယ်",
      "khName": "ទីប្រជុំជន កូស៊ីមីហ្សូ",
      "neName": "कोशिमिजु नगर"
    }
  },
  "0154900": {
    "office": {
      "code": "013000",
      "name": "網走・北見・紋別地方",
      "enName": "Abashiri Kitami Mombetsu",
      "officeName": "網走地方気象台",
      "chName": "網走/北見/紋別地區",
      "zhName": "网走/北见/纹别地区",
      "koName": "아바시리 · 기타미 · 몬 베츠 지방",
      "esName": "Región de Abashiri/Kitami/Monbetsu",
      "ptName": "Região de Abashiri/Kitami/Monbetsu",
      "thName": "ภูมิภาคอะบาชิริ/คิตามิ/มงเบ็ตสึ",
      "viName": "Vùng Abashiri/Kitami/Monbetsu",
      "inName": "Wilayah Abashiri/Kitami/Monbetsu",
      "tlName": "Rehiyon ng Abashiri/Kitami/Monbetsu",
      "moName": "Абашири/Китами/Монбетсу бүс нутаг",
      "buName": "Abashiri/Kitami/Monbetsu ဒေသ",
      "khName": "តំបន់ Abashiri/Kitami/Monbetsu",
      "neName": "अबाशिरी/कितामी/मोन्बेटसु क्षेत्र"
    },
    "class10": {
      "code": "013020",
      "name": "北見地方",
      "enName": "Kitami Region",
      "chName": "北见地方",
      "zhName": "北見地方",
      "koName": "키타미 지방",
      "esName": "Región Kitami",
      "ptName": "Região de Kitami",
      "thName": "ท้องถิ่นคิตามิ",
      "viName": "Vùng Kitami",
      "inName": "Daerah Kitami",
      "tlName": "Rehiyon ng Kitami",
      "moName": "Китами муж",
      "buName": "ခိတမိဒေသ၊ ဟိုကိုင်းဒို",
      "khName": "តំបន់គិតាមិ",
      "neName": "कितामी क्षेत्र"
    },
    "class15": {
      "code": "013020",
      "name": "北見地方",
      "enName": "Kitami Region"
    },
    "class20": {
      "code": "0154900",
      "name": "訓子府町",
      "enName": "Kunneppu Town",
      "kana": "くんねっぷちょう",
      "chName": "训子府町",
      "zhName": "訓子府町",
      "koName": "군넷푸 정",
      "esName": "Pueblo de Kunneppu",
      "ptName": "bairro de Kunneppu",
      "thName": "เมืองคุนเนปปุ",
      "viName": "thị trấn Kunneppu",
      "inName": "kota Kunneppu",
      "tlName": "bayan ng Kunneppu",
      "moName": "Күннэппү жижиг хот",
      "buName": "ခူနဲပု မြို့နယ်",
      "khName": "ទីប្រជុំជន គុនណេពូ",
      "neName": "कुन्नेप्पु नगर"
    }
  },
  "0155000": {
    "office": {
      "code": "013000",
      "name": "網走・北見・紋別地方",
      "enName": "Abashiri Kitami Mombetsu",
      "officeName": "網走地方気象台",
      "chName": "網走/北見/紋別地區",
      "zhName": "网走/北见/纹别地区",
      "koName": "아바시리 · 기타미 · 몬 베츠 지방",
      "esName": "Región de Abashiri/Kitami/Monbetsu",
      "ptName": "Região de Abashiri/Kitami/Monbetsu",
      "thName": "ภูมิภาคอะบาชิริ/คิตามิ/มงเบ็ตสึ",
      "viName": "Vùng Abashiri/Kitami/Monbetsu",
      "inName": "Wilayah Abashiri/Kitami/Monbetsu",
      "tlName": "Rehiyon ng Abashiri/Kitami/Monbetsu",
      "moName": "Абашири/Китами/Монбетсу бүс нутаг",
      "buName": "Abashiri/Kitami/Monbetsu ဒေသ",
      "khName": "តំបន់ Abashiri/Kitami/Monbetsu",
      "neName": "अबाशिरी/कितामी/मोन्बेटसु क्षेत्र"
    },
    "class10": {
      "code": "013020",
      "name": "北見地方",
      "enName": "Kitami Region",
      "chName": "北见地方",
      "zhName": "北見地方",
      "koName": "키타미 지방",
      "esName": "Región Kitami",
      "ptName": "Região de Kitami",
      "thName": "ท้องถิ่นคิตามิ",
      "viName": "Vùng Kitami",
      "inName": "Daerah Kitami",
      "tlName": "Rehiyon ng Kitami",
      "moName": "Китами муж",
      "buName": "ခိတမိဒေသ၊ ဟိုကိုင်းဒို",
      "khName": "តំបន់គិតាមិ",
      "neName": "कितामी क्षेत्र"
    },
    "class15": {
      "code": "013020",
      "name": "北見地方",
      "enName": "Kitami Region"
    },
    "class20": {
      "code": "0155000",
      "name": "置戸町",
      "enName": "Oketo Town",
      "kana": "おけとちょう",
      "chName": "置户町",
      "zhName": "置戶町",
      "koName": "오케토 정",
      "esName": "Pueblo de Oketo",
      "ptName": "bairro de Oketo",
      "thName": "เมืองโอเคโตะ",
      "viName": "thị trấn Oketo",
      "inName": "kota Oketo",
      "tlName": "bayan ng Oketo",
      "moName": "Окэто жижиг хот",
      "buName": "အိုကီတို မြို့နယ်",
      "khName": "ទីប្រជុំជន អូកេតូ",
      "neName": "ओकेतो नगर"
    }
  },
  "0155200": {
    "office": {
      "code": "013000",
      "name": "網走・北見・紋別地方",
      "enName": "Abashiri Kitami Mombetsu",
      "officeName": "網走地方気象台",
      "chName": "網走/北見/紋別地區",
      "zhName": "网走/北见/纹别地区",
      "koName": "아바시리 · 기타미 · 몬 베츠 지방",
      "esName": "Región de Abashiri/Kitami/Monbetsu",
      "ptName": "Região de Abashiri/Kitami/Monbetsu",
      "thName": "ภูมิภาคอะบาชิริ/คิตามิ/มงเบ็ตสึ",
      "viName": "Vùng Abashiri/Kitami/Monbetsu",
      "inName": "Wilayah Abashiri/Kitami/Monbetsu",
      "tlName": "Rehiyon ng Abashiri/Kitami/Monbetsu",
      "moName": "Абашири/Китами/Монбетсу бүс нутаг",
      "buName": "Abashiri/Kitami/Monbetsu ဒေသ",
      "khName": "តំបន់ Abashiri/Kitami/Monbetsu",
      "neName": "अबाशिरी/कितामी/मोन्बेटसु क्षेत्र"
    },
    "class10": {
      "code": "013010",
      "name": "網走地方",
      "enName": "Abashiri Region",
      "chName": "网走地方",
      "zhName": "網走地方",
      "koName": "아바시리 지방",
      "esName": "Región Abashiri",
      "ptName": "Região de Abashiri",
      "thName": "ท้องถิ่นอะบาชิริ",
      "viName": "Vùng Abashiri",
      "inName": "Daerah Abashiri",
      "tlName": "Rehiyon ng Abashiri",
      "moName": "Абашири муж",
      "buName": "အဘရှိယိဒေသ၊ ဟိုကိုင်းဒို",
      "khName": "តំបន់អាបាស៊ីរី",
      "neName": "आबासिरी क्षेत्र"
    },
    "class15": {
      "code": "013011",
      "name": "網走西部",
      "enName": "Western Abashiri"
    },
    "class20": {
      "code": "0155200",
      "name": "佐呂間町",
      "enName": "Saroma Town",
      "kana": "さろまちょう",
      "chName": "佐吕间町",
      "zhName": "佐呂間町",
      "koName": "사로마 정",
      "esName": "Pueblo de Saroma",
      "ptName": "bairro de Saroma",
      "thName": "เมืองซาโระมะ",
      "viName": "thị trấn Saroma",
      "inName": "kota Saroma",
      "tlName": "bayan ng Saroma",
      "moName": "Сaромa жижиг хот",
      "buName": "ဆားရို့မ မြို့နယ်",
      "khName": "ទីប្រជុំជន សារ៉ូម៉ា",
      "neName": "सारोमा नगर"
    }
  },
  "0155500": {
    "office": {
      "code": "013000",
      "name": "網走・北見・紋別地方",
      "enName": "Abashiri Kitami Mombetsu",
      "officeName": "網走地方気象台",
      "chName": "網走/北見/紋別地區",
      "zhName": "网走/北见/纹别地区",
      "koName": "아바시리 · 기타미 · 몬 베츠 지방",
      "esName": "Región de Abashiri/Kitami/Monbetsu",
      "ptName": "Região de Abashiri/Kitami/Monbetsu",
      "thName": "ภูมิภาคอะบาชิริ/คิตามิ/มงเบ็ตสึ",
      "viName": "Vùng Abashiri/Kitami/Monbetsu",
      "inName": "Wilayah Abashiri/Kitami/Monbetsu",
      "tlName": "Rehiyon ng Abashiri/Kitami/Monbetsu",
      "moName": "Абашири/Китами/Монбетсу бүс нутаг",
      "buName": "Abashiri/Kitami/Monbetsu ဒေသ",
      "khName": "តំបន់ Abashiri/Kitami/Monbetsu",
      "neName": "अबाशिरी/कितामी/मोन्बेटसु क्षेत्र"
    },
    "class10": {
      "code": "013030",
      "name": "紋別地方",
      "enName": "Mombetsu Region",
      "chName": "纹别地方",
      "zhName": "紋別地方",
      "koName": "몬베쓰 지방",
      "esName": "Región Monbetsu",
      "ptName": "Região de Monbetsu",
      "thName": "ท้องถิ่นมมเบ็ตสึ",
      "viName": "Vùng Monbetsu",
      "inName": "Daerah Monbetsu",
      "tlName": "Rehiyon ng Monbetsu",
      "moName": "Монбэцү муж",
      "buName": "မွန်းဘဲဆုဒေသ၊ ဟိုကိုင်းဒို",
      "khName": "តំបន់មុំបែហ្សឹ",
      "neName": "मोन्बेचु क्षेत्र"
    },
    "class15": {
      "code": "013032",
      "name": "紋別南部",
      "enName": "Southern Mombetsu"
    },
    "class20": {
      "code": "0155500",
      "name": "遠軽町",
      "enName": "Engaru Town",
      "kana": "えんがるちょう",
      "chName": "远轻町",
      "zhName": "遠輕町",
      "koName": "엔가루 정",
      "esName": "Pueblo de Engaru",
      "ptName": "bairro de Engaru",
      "thName": "เมืองเอ็นการุ",
      "viName": "thị trấn Engaru",
      "inName": "kota Engaru",
      "tlName": "bayan ng Engaru",
      "moName": "Энгарү жижиг хот",
      "buName": "အိန်းဂါ့ရု မြို့နယ်",
      "khName": "ទីប្រជុំជន អេនហ្គារូ",
      "neName": "एनगारु नगर"
    }
  },
  "0155900": {
    "office": {
      "code": "013000",
      "name": "網走・北見・紋別地方",
      "enName": "Abashiri Kitami Mombetsu",
      "officeName": "網走地方気象台",
      "chName": "網走/北見/紋別地區",
      "zhName": "网走/北见/纹别地区",
      "koName": "아바시리 · 기타미 · 몬 베츠 지방",
      "esName": "Región de Abashiri/Kitami/Monbetsu",
      "ptName": "Região de Abashiri/Kitami/Monbetsu",
      "thName": "ภูมิภาคอะบาชิริ/คิตามิ/มงเบ็ตสึ",
      "viName": "Vùng Abashiri/Kitami/Monbetsu",
      "inName": "Wilayah Abashiri/Kitami/Monbetsu",
      "tlName": "Rehiyon ng Abashiri/Kitami/Monbetsu",
      "moName": "Абашири/Китами/Монбетсу бүс нутаг",
      "buName": "Abashiri/Kitami/Monbetsu ဒေသ",
      "khName": "តំបន់ Abashiri/Kitami/Monbetsu",
      "neName": "अबाशिरी/कितामी/मोन्बेटसु क्षेत्र"
    },
    "class10": {
      "code": "013030",
      "name": "紋別地方",
      "enName": "Mombetsu Region",
      "chName": "纹别地方",
      "zhName": "紋別地方",
      "koName": "몬베쓰 지방",
      "esName": "Región Monbetsu",
      "ptName": "Região de Monbetsu",
      "thName": "ท้องถิ่นมมเบ็ตสึ",
      "viName": "Vùng Monbetsu",
      "inName": "Daerah Monbetsu",
      "tlName": "Rehiyon ng Monbetsu",
      "moName": "Монбэцү муж",
      "buName": "မွန်းဘဲဆုဒေသ၊ ဟိုကိုင်းဒို",
      "khName": "តំបន់មុំបែហ្សឹ",
      "neName": "मोन्बेचु क्षेत्र"
    },
    "class15": {
      "code": "013032",
      "name": "紋別南部",
      "enName": "Southern Mombetsu"
    },
    "class20": {
      "code": "0155900",
      "name": "湧別町",
      "enName": "Yubetsu Town",
      "kana": "ゆうべつちょう",
      "chName": "涌别町",
      "zhName": "湧別町",
      "koName": "유베쓰 정",
      "esName": "Pueblo de Yubetsu",
      "ptName": "bairro de Yubetsu",
      "thName": "เมืองยุเบ็ทสึ",
      "viName": "thị trấn Yubetsu",
      "inName": "kota Yubetsu",
      "tlName": "bayan ng Yubetsu",
      "moName": "Юбэцү жижиг хот",
      "buName": "ယုဗေ့စု မြို့နယ်",
      "khName": "ទីប្រជុំជន​ យូបេតស៊ូ",
      "neName": "युबेत्सु नगर"
    }
  },
  "0156000": {
    "office": {
      "code": "013000",
      "name": "網走・北見・紋別地方",
      "enName": "Abashiri Kitami Mombetsu",
      "officeName": "網走地方気象台",
      "chName": "網走/北見/紋別地區",
      "zhName": "网走/北见/纹别地区",
      "koName": "아바시리 · 기타미 · 몬 베츠 지방",
      "esName": "Región de Abashiri/Kitami/Monbetsu",
      "ptName": "Região de Abashiri/Kitami/Monbetsu",
      "thName": "ภูมิภาคอะบาชิริ/คิตามิ/มงเบ็ตสึ",
      "viName": "Vùng Abashiri/Kitami/Monbetsu",
      "inName": "Wilayah Abashiri/Kitami/Monbetsu",
      "tlName": "Rehiyon ng Abashiri/Kitami/Monbetsu",
      "moName": "Абашири/Китами/Монбетсу бүс нутаг",
      "buName": "Abashiri/Kitami/Monbetsu ဒေသ",
      "khName": "តំបន់ Abashiri/Kitami/Monbetsu",
      "neName": "अबाशिरी/कितामी/मोन्बेटसु क्षेत्र"
    },
    "class10": {
      "code": "013030",
      "name": "紋別地方",
      "enName": "Mombetsu Region",
      "chName": "纹别地方",
      "zhName": "紋別地方",
      "koName": "몬베쓰 지방",
      "esName": "Región Monbetsu",
      "ptName": "Região de Monbetsu",
      "thName": "ท้องถิ่นมมเบ็ตสึ",
      "viName": "Vùng Monbetsu",
      "inName": "Daerah Monbetsu",
      "tlName": "Rehiyon ng Monbetsu",
      "moName": "Монбэцү муж",
      "buName": "မွန်းဘဲဆုဒေသ၊ ဟိုကိုင်းဒို",
      "khName": "តំបន់មុំបែហ្សឹ",
      "neName": "मोन्बेचु क्षेत्र"
    },
    "class15": {
      "code": "013031",
      "name": "紋別北部",
      "enName": "Northern Mombetsu"
    },
    "class20": {
      "code": "0156000",
      "name": "滝上町",
      "enName": "Takinoue Town",
      "kana": "たきのうえちょう",
      "chName": "泷上町",
      "zhName": "瀧上町",
      "koName": "다키노우에 정",
      "esName": "Pueblo deTakinoue",
      "ptName": "bairro de Takinoue",
      "thName": "เมืองทาคิโนะอุเอะ",
      "viName": "thị trấn Takinoue",
      "inName": "kota Takinoue",
      "tlName": "bayan ng Takinoue",
      "moName": "Такиноүэ жижиг хот",
      "buName": "တာကိနို့ဥအဲ့ မြို့နယ်",
      "khName": "ទីប្រជុំជន តាគីណូអេ",
      "neName": "ताकिनोउए नगर"
    }
  },
  "0156100": {
    "office": {
      "code": "013000",
      "name": "網走・北見・紋別地方",
      "enName": "Abashiri Kitami Mombetsu",
      "officeName": "網走地方気象台",
      "chName": "網走/北見/紋別地區",
      "zhName": "网走/北见/纹别地区",
      "koName": "아바시리 · 기타미 · 몬 베츠 지방",
      "esName": "Región de Abashiri/Kitami/Monbetsu",
      "ptName": "Região de Abashiri/Kitami/Monbetsu",
      "thName": "ภูมิภาคอะบาชิริ/คิตามิ/มงเบ็ตสึ",
      "viName": "Vùng Abashiri/Kitami/Monbetsu",
      "inName": "Wilayah Abashiri/Kitami/Monbetsu",
      "tlName": "Rehiyon ng Abashiri/Kitami/Monbetsu",
      "moName": "Абашири/Китами/Монбетсу бүс нутаг",
      "buName": "Abashiri/Kitami/Monbetsu ဒေသ",
      "khName": "តំបន់ Abashiri/Kitami/Monbetsu",
      "neName": "अबाशिरी/कितामी/मोन्बेटसु क्षेत्र"
    },
    "class10": {
      "code": "013030",
      "name": "紋別地方",
      "enName": "Mombetsu Region",
      "chName": "纹别地方",
      "zhName": "紋別地方",
      "koName": "몬베쓰 지방",
      "esName": "Región Monbetsu",
      "ptName": "Região de Monbetsu",
      "thName": "ท้องถิ่นมมเบ็ตสึ",
      "viName": "Vùng Monbetsu",
      "inName": "Daerah Monbetsu",
      "tlName": "Rehiyon ng Monbetsu",
      "moName": "Монбэцү муж",
      "buName": "မွန်းဘဲဆုဒေသ၊ ဟိုကိုင်းဒို",
      "khName": "តំបន់មុំបែហ្សឹ",
      "neName": "मोन्बेचु क्षेत्र"
    },
    "class15": {
      "code": "013031",
      "name": "紋別北部",
      "enName": "Northern Mombetsu"
    },
    "class20": {
      "code": "0156100",
      "name": "興部町",
      "enName": "Okoppe Town",
      "kana": "おこっぺちょう",
      "chName": "兴部町",
      "zhName": "興部町",
      "koName": "오콧페 정",
      "esName": "Pueblo de Okoppe",
      "ptName": "bairro de Okoppe",
      "thName": "เมืองโอโคปเปะ",
      "viName": "thị trấn Okoppe",
      "inName": "kota Okoppe",
      "tlName": "bayan ng Okoppe",
      "moName": "Окоппэ жижиг хот",
      "buName": "အိုကော့ပဲ့ မြို့နယ်",
      "khName": "ទីប្រជុំជន អូខបពី",
      "neName": "ओकोप्पे नगर"
    }
  },
  "0156200": {
    "office": {
      "code": "013000",
      "name": "網走・北見・紋別地方",
      "enName": "Abashiri Kitami Mombetsu",
      "officeName": "網走地方気象台",
      "chName": "網走/北見/紋別地區",
      "zhName": "网走/北见/纹别地区",
      "koName": "아바시리 · 기타미 · 몬 베츠 지방",
      "esName": "Región de Abashiri/Kitami/Monbetsu",
      "ptName": "Região de Abashiri/Kitami/Monbetsu",
      "thName": "ภูมิภาคอะบาชิริ/คิตามิ/มงเบ็ตสึ",
      "viName": "Vùng Abashiri/Kitami/Monbetsu",
      "inName": "Wilayah Abashiri/Kitami/Monbetsu",
      "tlName": "Rehiyon ng Abashiri/Kitami/Monbetsu",
      "moName": "Абашири/Китами/Монбетсу бүс нутаг",
      "buName": "Abashiri/Kitami/Monbetsu ဒေသ",
      "khName": "តំបន់ Abashiri/Kitami/Monbetsu",
      "neName": "अबाशिरी/कितामी/मोन्बेटसु क्षेत्र"
    },
    "class10": {
      "code": "013030",
      "name": "紋別地方",
      "enName": "Mombetsu Region",
      "chName": "纹别地方",
      "zhName": "紋別地方",
      "koName": "몬베쓰 지방",
      "esName": "Región Monbetsu",
      "ptName": "Região de Monbetsu",
      "thName": "ท้องถิ่นมมเบ็ตสึ",
      "viName": "Vùng Monbetsu",
      "inName": "Daerah Monbetsu",
      "tlName": "Rehiyon ng Monbetsu",
      "moName": "Монбэцү муж",
      "buName": "မွန်းဘဲဆုဒေသ၊ ဟိုကိုင်းဒို",
      "khName": "តំបន់មុំបែហ្សឹ",
      "neName": "मोन्बेचु क्षेत्र"
    },
    "class15": {
      "code": "013031",
      "name": "紋別北部",
      "enName": "Northern Mombetsu"
    },
    "class20": {
      "code": "0156200",
      "name": "西興部村",
      "enName": "Nishiokoppe Village",
      "kana": "にしおこっぺむら",
      "chName": "西兴部村",
      "zhName": "西興部村",
      "koName": "니시오콧페 촌",
      "esName": "Pueblo de Nishi-okoppe",
      "ptName": "povoado de Nishiokoppe",
      "thName": "หมู่บ้านนิชิโอะโคปเปะ",
      "viName": "làng Nishiokoppe",
      "inName": "desa Nishiokoppe",
      "tlName": "nayon ng Nishiokoppe",
      "moName": "Нишиокоппэ тосгон",
      "buName": "နီရှီယိုကော့ပဲ့ ကျေးရွာ",
      "khName": "ភូមិ នីស៊ីអូខបពី",
      "neName": "निशिओकोप्पे गाउँ"
    }
  },
  "0156300": {
    "office": {
      "code": "013000",
      "name": "網走・北見・紋別地方",
      "enName": "Abashiri Kitami Mombetsu",
      "officeName": "網走地方気象台",
      "chName": "網走/北見/紋別地區",
      "zhName": "网走/北见/纹别地区",
      "koName": "아바시리 · 기타미 · 몬 베츠 지방",
      "esName": "Región de Abashiri/Kitami/Monbetsu",
      "ptName": "Região de Abashiri/Kitami/Monbetsu",
      "thName": "ภูมิภาคอะบาชิริ/คิตามิ/มงเบ็ตสึ",
      "viName": "Vùng Abashiri/Kitami/Monbetsu",
      "inName": "Wilayah Abashiri/Kitami/Monbetsu",
      "tlName": "Rehiyon ng Abashiri/Kitami/Monbetsu",
      "moName": "Абашири/Китами/Монбетсу бүс нутаг",
      "buName": "Abashiri/Kitami/Monbetsu ဒေသ",
      "khName": "តំបន់ Abashiri/Kitami/Monbetsu",
      "neName": "अबाशिरी/कितामी/मोन्बेटसु क्षेत्र"
    },
    "class10": {
      "code": "013030",
      "name": "紋別地方",
      "enName": "Mombetsu Region",
      "chName": "纹别地方",
      "zhName": "紋別地方",
      "koName": "몬베쓰 지방",
      "esName": "Región Monbetsu",
      "ptName": "Região de Monbetsu",
      "thName": "ท้องถิ่นมมเบ็ตสึ",
      "viName": "Vùng Monbetsu",
      "inName": "Daerah Monbetsu",
      "tlName": "Rehiyon ng Monbetsu",
      "moName": "Монбэцү муж",
      "buName": "မွန်းဘဲဆုဒေသ၊ ဟိုကိုင်းဒို",
      "khName": "តំបន់មុំបែហ្សឹ",
      "neName": "मोन्बेचु क्षेत्र"
    },
    "class15": {
      "code": "013031",
      "name": "紋別北部",
      "enName": "Northern Mombetsu"
    },
    "class20": {
      "code": "0156300",
      "name": "雄武町",
      "enName": "Omu Town",
      "kana": "おうむちょう",
      "chName": "雄武町",
      "zhName": "雄武町",
      "koName": "오무 정",
      "esName": "Pueblo de Omu",
      "ptName": "bairro de Omu",
      "thName": "เมืองโอมุ",
      "viName": "thị trấn Omu",
      "inName": "kota Omu",
      "tlName": "bayan ng Omu",
      "moName": "Омү жижиг хот",
      "buName": "အိုမု မြို့နယ်",
      "khName": "ទីប្រជុំជន អូមុ",
      "neName": "ओमु नगर"
    }
  },
  "0156400": {
    "office": {
      "code": "013000",
      "name": "網走・北見・紋別地方",
      "enName": "Abashiri Kitami Mombetsu",
      "officeName": "網走地方気象台",
      "chName": "網走/北見/紋別地區",
      "zhName": "网走/北见/纹别地区",
      "koName": "아바시리 · 기타미 · 몬 베츠 지방",
      "esName": "Región de Abashiri/Kitami/Monbetsu",
      "ptName": "Região de Abashiri/Kitami/Monbetsu",
      "thName": "ภูมิภาคอะบาชิริ/คิตามิ/มงเบ็ตสึ",
      "viName": "Vùng Abashiri/Kitami/Monbetsu",
      "inName": "Wilayah Abashiri/Kitami/Monbetsu",
      "tlName": "Rehiyon ng Abashiri/Kitami/Monbetsu",
      "moName": "Абашири/Китами/Монбетсу бүс нутаг",
      "buName": "Abashiri/Kitami/Monbetsu ဒေသ",
      "khName": "តំបន់ Abashiri/Kitami/Monbetsu",
      "neName": "अबाशिरी/कितामी/मोन्बेटसु क्षेत्र"
    },
    "class10": {
      "code": "013010",
      "name": "網走地方",
      "enName": "Abashiri Region",
      "chName": "网走地方",
      "zhName": "網走地方",
      "koName": "아바시리 지방",
      "esName": "Región Abashiri",
      "ptName": "Região de Abashiri",
      "thName": "ท้องถิ่นอะบาชิริ",
      "viName": "Vùng Abashiri",
      "inName": "Daerah Abashiri",
      "tlName": "Rehiyon ng Abashiri",
      "moName": "Абашири муж",
      "buName": "အဘရှိယိဒေသ၊ ဟိုကိုင်းဒို",
      "khName": "តំបន់អាបាស៊ីរី",
      "neName": "आबासिरी क्षेत्र"
    },
    "class15": {
      "code": "013011",
      "name": "網走西部",
      "enName": "Western Abashiri"
    },
    "class20": {
      "code": "0156400",
      "name": "大空町",
      "enName": "Ozora Town",
      "kana": "おおぞらちょう",
      "chName": "大空町",
      "zhName": "大空町",
      "koName": "오조라 정",
      "esName": "Pueblo de Ōzora",
      "ptName": "bairro de Ozora",
      "thName": "เมืองโอโซระ",
      "viName": "thị trấn Ozora",
      "inName": "kota Ozora",
      "tlName": "bayan ng Ozora",
      "moName": "Озора жижиг хот",
      "buName": "အိုဇောရာ့ မြို့နယ်",
      "khName": "ទីប្រជុំជន អូហ្សូរ៉ា",
      "neName": "ओजोरा नगर"
    }
  },
  "0157100": {
    "office": {
      "code": "015000",
      "name": "胆振・日高地方",
      "enName": "Iburi Hidaka",
      "officeName": "室蘭地方気象台",
      "chName": "膽振/日高地區",
      "zhName": "胆振/日高地区",
      "koName": "담진·히다카 지방",
      "esName": "Región de Iburi/Hidaka",
      "ptName": "Região de Iburi/Hidaka",
      "thName": "ภูมิภาคอิบูริ/ฮิดากะ",
      "viName": "Vùng Iburi/Hidaka",
      "inName": "Wilayah Iburi/Hidaka",
      "tlName": "Rehiyon ng Iburi/Hidaka",
      "moName": "Ибури/Хидака муж",
      "buName": "Iburi/Hidaka ဒေသ",
      "khName": "តំបន់ Iburi/Hidaka",
      "neName": "इबुरी/हिडाका क्षेत्र"
    },
    "class10": {
      "code": "015010",
      "name": "胆振地方",
      "enName": "Iburi Region",
      "chName": "膽振地區",
      "zhName": "胆振地区",
      "koName": "담진지방",
      "esName": "Región de Iburi",
      "ptName": "Região de Iburi",
      "thName": "ภูมิภาคอิบุรี",
      "viName": "vùng Iburi",
      "inName": "wilayah Iburi",
      "tlName": "Rehiyon ng Iburi",
      "moName": "Ибури муж",
      "buName": "Iburi ဒေသ",
      "khName": "តំបន់ Iburi",
      "neName": "इबुरी क्षेत्र"
    },
    "class15": {
      "code": "015011",
      "name": "胆振西部",
      "enName": "Western Iburi"
    },
    "class20": {
      "code": "0157100",
      "name": "豊浦町",
      "enName": "Toyoura Town",
      "kana": "とようらちょう",
      "chName": "丰浦町",
      "zhName": "豐浦町",
      "koName": "도요우라 정",
      "esName": "Pueblo deToyoura",
      "ptName": "bairro de Toyoura",
      "thName": "เมืองโทโยอุระ",
      "viName": "thị trấn Toyoura",
      "inName": "kota Toyoura",
      "tlName": "bayan ng Toyoura",
      "moName": "Тоёоүра жижиг хот",
      "buName": "တိုရိုးဥရာ့ မြို့နယ်",
      "khName": "ទីប្រជុំជន តូយូរ៉ា",
      "neName": "तोयोउरा नगर"
    }
  },
  "0157500": {
    "office": {
      "code": "015000",
      "name": "胆振・日高地方",
      "enName": "Iburi Hidaka",
      "officeName": "室蘭地方気象台",
      "chName": "膽振/日高地區",
      "zhName": "胆振/日高地区",
      "koName": "담진·히다카 지방",
      "esName": "Región de Iburi/Hidaka",
      "ptName": "Região de Iburi/Hidaka",
      "thName": "ภูมิภาคอิบูริ/ฮิดากะ",
      "viName": "Vùng Iburi/Hidaka",
      "inName": "Wilayah Iburi/Hidaka",
      "tlName": "Rehiyon ng Iburi/Hidaka",
      "moName": "Ибури/Хидака муж",
      "buName": "Iburi/Hidaka ဒေသ",
      "khName": "តំបន់ Iburi/Hidaka",
      "neName": "इबुरी/हिडाका क्षेत्र"
    },
    "class10": {
      "code": "015010",
      "name": "胆振地方",
      "enName": "Iburi Region",
      "chName": "膽振地區",
      "zhName": "胆振地区",
      "koName": "담진지방",
      "esName": "Región de Iburi",
      "ptName": "Região de Iburi",
      "thName": "ภูมิภาคอิบุรี",
      "viName": "vùng Iburi",
      "inName": "wilayah Iburi",
      "tlName": "Rehiyon ng Iburi",
      "moName": "Ибури муж",
      "buName": "Iburi ဒေသ",
      "khName": "តំបន់ Iburi",
      "neName": "इबुरी क्षेत्र"
    },
    "class15": {
      "code": "015011",
      "name": "胆振西部",
      "enName": "Western Iburi"
    },
    "class20": {
      "code": "0157500",
      "name": "壮瞥町",
      "enName": "Sobetsu Town",
      "kana": "そうべつちょう",
      "chName": "壮瞥町",
      "zhName": "壯瞥町",
      "koName": "소베쓰 정",
      "esName": "Pueblo de Sobetsu",
      "ptName": "bairro de Sobetsu",
      "thName": "เมืองโซเบ็ทสึ",
      "viName": "thị trấn Sobetsu",
      "inName": "kota Sobetsu",
      "tlName": "bayan ng Sobetsu",
      "moName": "Собэцү жижиг хот",
      "buName": "ဆောဗေ့စု မြို့နယ်",
      "khName": "ទីប្រជុំជន សូបាតស៊ូ",
      "neName": "सोबेत्सु नगर"
    }
  },
  "0157800": {
    "office": {
      "code": "015000",
      "name": "胆振・日高地方",
      "enName": "Iburi Hidaka",
      "officeName": "室蘭地方気象台",
      "chName": "膽振/日高地區",
      "zhName": "胆振/日高地区",
      "koName": "담진·히다카 지방",
      "esName": "Región de Iburi/Hidaka",
      "ptName": "Região de Iburi/Hidaka",
      "thName": "ภูมิภาคอิบูริ/ฮิดากะ",
      "viName": "Vùng Iburi/Hidaka",
      "inName": "Wilayah Iburi/Hidaka",
      "tlName": "Rehiyon ng Iburi/Hidaka",
      "moName": "Ибури/Хидака муж",
      "buName": "Iburi/Hidaka ဒေသ",
      "khName": "តំបន់ Iburi/Hidaka",
      "neName": "इबुरी/हिडाका क्षेत्र"
    },
    "class10": {
      "code": "015010",
      "name": "胆振地方",
      "enName": "Iburi Region",
      "chName": "膽振地區",
      "zhName": "胆振地区",
      "koName": "담진지방",
      "esName": "Región de Iburi",
      "ptName": "Região de Iburi",
      "thName": "ภูมิภาคอิบุรี",
      "viName": "vùng Iburi",
      "inName": "wilayah Iburi",
      "tlName": "Rehiyon ng Iburi",
      "moName": "Ибури муж",
      "buName": "Iburi ဒေသ",
      "khName": "តំបន់ Iburi",
      "neName": "इबुरी क्षेत्र"
    },
    "class15": {
      "code": "015012",
      "name": "胆振中部",
      "enName": "Middle Iburi"
    },
    "class20": {
      "code": "0157800",
      "name": "白老町",
      "enName": "Shiraoi Town",
      "kana": "しらおいちょう",
      "chName": "白老町",
      "zhName": "白老町",
      "koName": "시라오이 정",
      "esName": "Pueblo de Shiraoi",
      "ptName": "bairro de Shiraoi",
      "thName": "เมืองชิราโออิ",
      "viName": "thị trấn Shiraoi",
      "inName": "kota Shiraoi",
      "tlName": "bayan ng Shiraoi",
      "moName": "Шираой жижиг хот",
      "buName": "ရှီရာအို့ယိ မြို့နယ်",
      "khName": "ទីប្រជុំជន ស៊ីរ៉យ",
      "neName": "शिराओइ नगर"
    }
  },
  "0158100": {
    "office": {
      "code": "015000",
      "name": "胆振・日高地方",
      "enName": "Iburi Hidaka",
      "officeName": "室蘭地方気象台",
      "chName": "膽振/日高地區",
      "zhName": "胆振/日高地区",
      "koName": "담진·히다카 지방",
      "esName": "Región de Iburi/Hidaka",
      "ptName": "Região de Iburi/Hidaka",
      "thName": "ภูมิภาคอิบูริ/ฮิดากะ",
      "viName": "Vùng Iburi/Hidaka",
      "inName": "Wilayah Iburi/Hidaka",
      "tlName": "Rehiyon ng Iburi/Hidaka",
      "moName": "Ибури/Хидака муж",
      "buName": "Iburi/Hidaka ဒေသ",
      "khName": "តំបន់ Iburi/Hidaka",
      "neName": "इबुरी/हिडाका क्षेत्र"
    },
    "class10": {
      "code": "015010",
      "name": "胆振地方",
      "enName": "Iburi Region",
      "chName": "膽振地區",
      "zhName": "胆振地区",
      "koName": "담진지방",
      "esName": "Región de Iburi",
      "ptName": "Região de Iburi",
      "thName": "ภูมิภาคอิบุรี",
      "viName": "vùng Iburi",
      "inName": "wilayah Iburi",
      "tlName": "Rehiyon ng Iburi",
      "moName": "Ибури муж",
      "buName": "Iburi ဒေသ",
      "khName": "តំបន់ Iburi",
      "neName": "इबुरी क्षेत्र"
    },
    "class15": {
      "code": "015013",
      "name": "胆振東部",
      "enName": "Eastern Iburi"
    },
    "class20": {
      "code": "0158100",
      "name": "厚真町",
      "enName": "Atsuma Town",
      "kana": "あつまちょう",
      "chName": "厚真町",
      "zhName": "厚真町",
      "koName": "아쓰마 정",
      "esName": "Pueblo de Atsuma",
      "ptName": "bairro de Atsuma",
      "thName": "เมืองอัทสึมะ",
      "viName": "thị trấn Atsuma",
      "inName": "kota Atsuma",
      "tlName": "bayan ng Atsuma",
      "moName": "Aцүмa жижиг хот",
      "buName": "အာ့ဆုမ မြို့နယ်",
      "khName": "ទីប្រជុំជន អាត់ស៊ូម៉ា",
      "neName": "आत्सुमा नगर"
    }
  },
  "0158400": {
    "office": {
      "code": "015000",
      "name": "胆振・日高地方",
      "enName": "Iburi Hidaka",
      "officeName": "室蘭地方気象台",
      "chName": "膽振/日高地區",
      "zhName": "胆振/日高地区",
      "koName": "담진·히다카 지방",
      "esName": "Región de Iburi/Hidaka",
      "ptName": "Região de Iburi/Hidaka",
      "thName": "ภูมิภาคอิบูริ/ฮิดากะ",
      "viName": "Vùng Iburi/Hidaka",
      "inName": "Wilayah Iburi/Hidaka",
      "tlName": "Rehiyon ng Iburi/Hidaka",
      "moName": "Ибури/Хидака муж",
      "buName": "Iburi/Hidaka ဒေသ",
      "khName": "តំបន់ Iburi/Hidaka",
      "neName": "इबुरी/हिडाका क्षेत्र"
    },
    "class10": {
      "code": "015010",
      "name": "胆振地方",
      "enName": "Iburi Region",
      "chName": "膽振地區",
      "zhName": "胆振地区",
      "koName": "담진지방",
      "esName": "Región de Iburi",
      "ptName": "Região de Iburi",
      "thName": "ภูมิภาคอิบุรี",
      "viName": "vùng Iburi",
      "inName": "wilayah Iburi",
      "tlName": "Rehiyon ng Iburi",
      "moName": "Ибури муж",
      "buName": "Iburi ဒေသ",
      "khName": "តំបន់ Iburi",
      "neName": "इबुरी क्षेत्र"
    },
    "class15": {
      "code": "015011",
      "name": "胆振西部",
      "enName": "Western Iburi"
    },
    "class20": {
      "code": "0158400",
      "name": "洞爺湖町",
      "enName": "Toyako Town",
      "kana": "とうやこちょう",
      "chName": "洞爷湖町",
      "zhName": "洞爺湖町",
      "koName": "도야코 정",
      "esName": "Pueblo deToyako",
      "ptName": "bairro de Toyako",
      "thName": "เมืองโทยาโกะ",
      "viName": "thị trấn Toyako",
      "inName": "kota Toyako",
      "tlName": "bayan ng Toyako",
      "moName": "Тояко жижиг хот",
      "buName": "တိုရာကို မြို့နယ်",
      "khName": "ទីប្រជុំជន តូយ៉ាកុ",
      "neName": "तोयाको नगर"
    }
  },
  "0158500": {
    "office": {
      "code": "015000",
      "name": "胆振・日高地方",
      "enName": "Iburi Hidaka",
      "officeName": "室蘭地方気象台",
      "chName": "膽振/日高地區",
      "zhName": "胆振/日高地区",
      "koName": "담진·히다카 지방",
      "esName": "Región de Iburi/Hidaka",
      "ptName": "Região de Iburi/Hidaka",
      "thName": "ภูมิภาคอิบูริ/ฮิดากะ",
      "viName": "Vùng Iburi/Hidaka",
      "inName": "Wilayah Iburi/Hidaka",
      "tlName": "Rehiyon ng Iburi/Hidaka",
      "moName": "Ибури/Хидака муж",
      "buName": "Iburi/Hidaka ဒေသ",
      "khName": "តំបន់ Iburi/Hidaka",
      "neName": "इबुरी/हिडाका क्षेत्र"
    },
    "class10": {
      "code": "015010",
      "name": "胆振地方",
      "enName": "Iburi Region",
      "chName": "膽振地區",
      "zhName": "胆振地区",
      "koName": "담진지방",
      "esName": "Región de Iburi",
      "ptName": "Região de Iburi",
      "thName": "ภูมิภาคอิบุรี",
      "viName": "vùng Iburi",
      "inName": "wilayah Iburi",
      "tlName": "Rehiyon ng Iburi",
      "moName": "Ибури муж",
      "buName": "Iburi ဒေသ",
      "khName": "តំបន់ Iburi",
      "neName": "इबुरी क्षेत्र"
    },
    "class15": {
      "code": "015013",
      "name": "胆振東部",
      "enName": "Eastern Iburi"
    },
    "class20": {
      "code": "0158500",
      "name": "安平町",
      "enName": "Abira Town",
      "kana": "あびらちょう",
      "chName": "安平町",
      "zhName": "安平町",
      "koName": "아비라 정",
      "esName": "Pueblo de Abira",
      "ptName": "bairro de Abira",
      "thName": "เมืองอาบิระ",
      "viName": "thị trấn Abira",
      "inName": "kota Abira",
      "tlName": "bayan ng Abira",
      "moName": "Aбира жижиг хот",
      "buName": "အာ့ဘိရာ့ မြို့နယ်",
      "khName": "ទីប្រជុំជន អាប៊ីរ៉ា",
      "neName": "आबिरा नगर"
    }
  },
  "0158600": {
    "office": {
      "code": "015000",
      "name": "胆振・日高地方",
      "enName": "Iburi Hidaka",
      "officeName": "室蘭地方気象台",
      "chName": "膽振/日高地區",
      "zhName": "胆振/日高地区",
      "koName": "담진·히다카 지방",
      "esName": "Región de Iburi/Hidaka",
      "ptName": "Região de Iburi/Hidaka",
      "thName": "ภูมิภาคอิบูริ/ฮิดากะ",
      "viName": "Vùng Iburi/Hidaka",
      "inName": "Wilayah Iburi/Hidaka",
      "tlName": "Rehiyon ng Iburi/Hidaka",
      "moName": "Ибури/Хидака муж",
      "buName": "Iburi/Hidaka ဒေသ",
      "khName": "តំបន់ Iburi/Hidaka",
      "neName": "इबुरी/हिडाका क्षेत्र"
    },
    "class10": {
      "code": "015010",
      "name": "胆振地方",
      "enName": "Iburi Region",
      "chName": "膽振地區",
      "zhName": "胆振地区",
      "koName": "담진지방",
      "esName": "Región de Iburi",
      "ptName": "Região de Iburi",
      "thName": "ภูมิภาคอิบุรี",
      "viName": "vùng Iburi",
      "inName": "wilayah Iburi",
      "tlName": "Rehiyon ng Iburi",
      "moName": "Ибури муж",
      "buName": "Iburi ဒေသ",
      "khName": "តំបន់ Iburi",
      "neName": "इबुरी क्षेत्र"
    },
    "class15": {
      "code": "015013",
      "name": "胆振東部",
      "enName": "Eastern Iburi"
    },
    "class20": {
      "code": "0158600",
      "name": "むかわ町",
      "enName": "Mukawa Town",
      "kana": "むかわちょう",
      "chName": "鹉川町",
      "zhName": "鵡川町",
      "koName": "무카와 정",
      "esName": "Pueblo de Mukawa",
      "ptName": "bairro de Mukawa",
      "thName": "เมืองมุคาวะ",
      "viName": "thị trấn Mukawa",
      "inName": "kota Mukawa",
      "tlName": "bayan ng Mukawa",
      "moName": "Мүкава жижиг хот",
      "buName": "မုကားဝ မြို့နယ်",
      "khName": "ទីប្រជុំជន មូកាវ៉ា",
      "neName": "मुकावा नगर"
    }
  },
  "0160101": {
    "office": {
      "code": "015000",
      "name": "胆振・日高地方",
      "enName": "Iburi Hidaka",
      "officeName": "室蘭地方気象台",
      "chName": "膽振/日高地區",
      "zhName": "胆振/日高地区",
      "koName": "담진·히다카 지방",
      "esName": "Región de Iburi/Hidaka",
      "ptName": "Região de Iburi/Hidaka",
      "thName": "ภูมิภาคอิบูริ/ฮิดากะ",
      "viName": "Vùng Iburi/Hidaka",
      "inName": "Wilayah Iburi/Hidaka",
      "tlName": "Rehiyon ng Iburi/Hidaka",
      "moName": "Ибури/Хидака муж",
      "buName": "Iburi/Hidaka ဒေသ",
      "khName": "តំបន់ Iburi/Hidaka",
      "neName": "इबुरी/हिडाका क्षेत्र"
    },
    "class10": {
      "code": "015020",
      "name": "日高地方",
      "enName": "Hidaka Region",
      "chName": "日高地區",
      "zhName": "日高地区",
      "koName": "히다카 지방",
      "esName": "Región de Hidaka",
      "ptName": "Região de Hidaka",
      "thName": "ภูมิภาคฮิดากะ",
      "viName": "vùng Hidaka",
      "inName": "wilayah Hidaka",
      "tlName": "Rehiyon ng Hidaka",
      "moName": "Хидака бүс",
      "buName": "Hidaka ဒေသ",
      "khName": "តំបន់ Hidaka",
      "neName": "हिडाका क्षेत्र"
    },
    "class15": {
      "code": "015021",
      "name": "日高西部",
      "enName": "Western Hidaka"
    },
    "class20": {
      "code": "0160101",
      "name": "日高町日高",
      "enName": "Hidaka, Hidaka Town",
      "kana": "ひだかちょうひだか",
      "chName": "日高町日高",
      "zhName": "日高町日高",
      "koName": "히다카마을 히다카",
      "esName": "Hidaka, Pueblo de Hidaka",
      "ptName": "Hidaka, Cidade de Hidaka",
      "thName": "เมืองฮิดากะ ฮิดากะ",
      "viName": "Hidaka, Thị trấn Hidaka",
      "inName": "Hidaka, Kota Hidaka",
      "tlName": "Hidaka, Bayan ng Hidaka",
      "moName": "Hidaka, Cidade de Hidaka",
      "buName": "ဟိဒာကာ၊ ဟိဒာကာမြို့",
      "khName": "ខេត្តហ៊ីដាកា",
      "neName": "हिडाका नगर"
    }
  },
  "0160102": {
    "office": {
      "code": "015000",
      "name": "胆振・日高地方",
      "enName": "Iburi Hidaka",
      "officeName": "室蘭地方気象台",
      "chName": "膽振/日高地區",
      "zhName": "胆振/日高地区",
      "koName": "담진·히다카 지방",
      "esName": "Región de Iburi/Hidaka",
      "ptName": "Região de Iburi/Hidaka",
      "thName": "ภูมิภาคอิบูริ/ฮิดากะ",
      "viName": "Vùng Iburi/Hidaka",
      "inName": "Wilayah Iburi/Hidaka",
      "tlName": "Rehiyon ng Iburi/Hidaka",
      "moName": "Ибури/Хидака муж",
      "buName": "Iburi/Hidaka ဒေသ",
      "khName": "តំបន់ Iburi/Hidaka",
      "neName": "इबुरी/हिडाका क्षेत्र"
    },
    "class10": {
      "code": "015020",
      "name": "日高地方",
      "enName": "Hidaka Region",
      "chName": "日高地區",
      "zhName": "日高地区",
      "koName": "히다카 지방",
      "esName": "Región de Hidaka",
      "ptName": "Região de Hidaka",
      "thName": "ภูมิภาคฮิดากะ",
      "viName": "vùng Hidaka",
      "inName": "wilayah Hidaka",
      "tlName": "Rehiyon ng Hidaka",
      "moName": "Хидака бүс",
      "buName": "Hidaka ဒေသ",
      "khName": "តំបន់ Hidaka",
      "neName": "हिडाका क्षेत्र"
    },
    "class15": {
      "code": "015021",
      "name": "日高西部",
      "enName": "Western Hidaka"
    },
    "class20": {
      "code": "0160102",
      "name": "日高町門別",
      "enName": "Monbetsu, Hidaka Town",
      "kana": "ひだかちょうもんべつ",
      "chName": "日高町门别",
      "zhName": "日高町门别",
      "koName": "히다카마을 몬베츠",
      "esName": "Monbetsu, Pueblo de Hidaka",
      "ptName": "Monbetsu, Cidade de Hidaka",
      "thName": "มอนเบ็ทซู, เมืองฮิดากะ",
      "viName": "Monbetsu, Thị trấn Hidaka",
      "inName": "Monbetsu, Kota Hidaka",
      "tlName": "Monbetsu, Bayan ng Hidaka",
      "moName": "Monbetsu, Cidade de Hidaka",
      "buName": "မုန်းဘက်၊ ဟိဒာကာမြို့",
      "khName": "ខេត្តម៉ូនបែត",
      "neName": "मोनबेत नगर"
    }
  },
  "0160200": {
    "office": {
      "code": "015000",
      "name": "胆振・日高地方",
      "enName": "Iburi Hidaka",
      "officeName": "室蘭地方気象台",
      "chName": "膽振/日高地區",
      "zhName": "胆振/日高地区",
      "koName": "담진·히다카 지방",
      "esName": "Región de Iburi/Hidaka",
      "ptName": "Região de Iburi/Hidaka",
      "thName": "ภูมิภาคอิบูริ/ฮิดากะ",
      "viName": "Vùng Iburi/Hidaka",
      "inName": "Wilayah Iburi/Hidaka",
      "tlName": "Rehiyon ng Iburi/Hidaka",
      "moName": "Ибури/Хидака муж",
      "buName": "Iburi/Hidaka ဒေသ",
      "khName": "តំបន់ Iburi/Hidaka",
      "neName": "इबुरी/हिडाका क्षेत्र"
    },
    "class10": {
      "code": "015020",
      "name": "日高地方",
      "enName": "Hidaka Region",
      "chName": "日高地區",
      "zhName": "日高地区",
      "koName": "히다카 지방",
      "esName": "Región de Hidaka",
      "ptName": "Região de Hidaka",
      "thName": "ภูมิภาคฮิดากะ",
      "viName": "vùng Hidaka",
      "inName": "wilayah Hidaka",
      "tlName": "Rehiyon ng Hidaka",
      "moName": "Хидака бүс",
      "buName": "Hidaka ဒေသ",
      "khName": "តំបន់ Hidaka",
      "neName": "हिडाका क्षेत्र"
    },
    "class15": {
      "code": "015021",
      "name": "日高西部",
      "enName": "Western Hidaka"
    },
    "class20": {
      "code": "0160200",
      "name": "平取町",
      "enName": "Biratori Town",
      "kana": "びらとりちょう",
      "chName": "平取町",
      "zhName": "平取町",
      "koName": "비라토리 정",
      "esName": "Pueblo de Biratori",
      "ptName": "bairro de Biratori",
      "thName": "เมืองบิราโทริ",
      "viName": "thị trấn Biratori",
      "inName": "kota Biratori",
      "tlName": "bayan ng Biratori",
      "moName": "Биратори жижиг хот",
      "buName": "ဘီရတော့ရိ မြို့နယ်",
      "khName": "ទីប្រជុំជន ប៊ីរ៉ាតូរី",
      "neName": "बिरातोरी नगर"
    }
  },
  "0160400": {
    "office": {
      "code": "015000",
      "name": "胆振・日高地方",
      "enName": "Iburi Hidaka",
      "officeName": "室蘭地方気象台",
      "chName": "膽振/日高地區",
      "zhName": "胆振/日高地区",
      "koName": "담진·히다카 지방",
      "esName": "Región de Iburi/Hidaka",
      "ptName": "Região de Iburi/Hidaka",
      "thName": "ภูมิภาคอิบูริ/ฮิดากะ",
      "viName": "Vùng Iburi/Hidaka",
      "inName": "Wilayah Iburi/Hidaka",
      "tlName": "Rehiyon ng Iburi/Hidaka",
      "moName": "Ибури/Хидака муж",
      "buName": "Iburi/Hidaka ဒေသ",
      "khName": "តំបន់ Iburi/Hidaka",
      "neName": "इबुरी/हिडाका क्षेत्र"
    },
    "class10": {
      "code": "015020",
      "name": "日高地方",
      "enName": "Hidaka Region",
      "chName": "日高地區",
      "zhName": "日高地区",
      "koName": "히다카 지방",
      "esName": "Región de Hidaka",
      "ptName": "Região de Hidaka",
      "thName": "ภูมิภาคฮิดากะ",
      "viName": "vùng Hidaka",
      "inName": "wilayah Hidaka",
      "tlName": "Rehiyon ng Hidaka",
      "moName": "Хидака бүс",
      "buName": "Hidaka ဒေသ",
      "khName": "តំបន់ Hidaka",
      "neName": "हिडाका क्षेत्र"
    },
    "class15": {
      "code": "015022",
      "name": "日高中部",
      "enName": "Middle Hidaka"
    },
    "class20": {
      "code": "0160400",
      "name": "新冠町",
      "enName": "Niikappu Town",
      "kana": "にいかっぷちょう",
      "chName": "新冠町",
      "zhName": "新冠町",
      "koName": "니캇푸 정",
      "esName": "Pueblo de Niikappu",
      "ptName": "bairro de Niikappu",
      "thName": "เมืองนิอิคัปปุ",
      "viName": "thị trấn Niikappu",
      "inName": "kota Niikappu",
      "tlName": "bayan ng Niikappu",
      "moName": "Нийкаппү жижиг хот",
      "buName": "နီးကာ့ပု မြို့နယ်",
      "khName": "ទីប្រជុំជន នីកាបពូ",
      "neName": "नीईकाप्पु नगर"
    }
  },
  "0160700": {
    "office": {
      "code": "015000",
      "name": "胆振・日高地方",
      "enName": "Iburi Hidaka",
      "officeName": "室蘭地方気象台",
      "chName": "膽振/日高地區",
      "zhName": "胆振/日高地区",
      "koName": "담진·히다카 지방",
      "esName": "Región de Iburi/Hidaka",
      "ptName": "Região de Iburi/Hidaka",
      "thName": "ภูมิภาคอิบูริ/ฮิดากะ",
      "viName": "Vùng Iburi/Hidaka",
      "inName": "Wilayah Iburi/Hidaka",
      "tlName": "Rehiyon ng Iburi/Hidaka",
      "moName": "Ибури/Хидака муж",
      "buName": "Iburi/Hidaka ဒေသ",
      "khName": "តំបន់ Iburi/Hidaka",
      "neName": "इबुरी/हिडाका क्षेत्र"
    },
    "class10": {
      "code": "015020",
      "name": "日高地方",
      "enName": "Hidaka Region",
      "chName": "日高地區",
      "zhName": "日高地区",
      "koName": "히다카 지방",
      "esName": "Región de Hidaka",
      "ptName": "Região de Hidaka",
      "thName": "ภูมิภาคฮิดากะ",
      "viName": "vùng Hidaka",
      "inName": "wilayah Hidaka",
      "tlName": "Rehiyon ng Hidaka",
      "moName": "Хидака бүс",
      "buName": "Hidaka ဒေသ",
      "khName": "តំបន់ Hidaka",
      "neName": "हिडाका क्षेत्र"
    },
    "class15": {
      "code": "015023",
      "name": "日高東部",
      "enName": "Eastern Hidaka"
    },
    "class20": {
      "code": "0160700",
      "name": "浦河町",
      "enName": "Urakawa Town",
      "kana": "うらかわちょう",
      "chName": "浦河町",
      "zhName": "浦河町",
      "koName": "우라카와 정",
      "esName": "Pueblo de Urakawa",
      "ptName": "bairro de Urakawa",
      "thName": "เมืองอุระคาวะ",
      "viName": "thị trấn Urakawa",
      "inName": "kota Urakawa",
      "tlName": "bayan ng Urakawa",
      "moName": "Үракава жижиг хот",
      "buName": "ဦရာကာ့ဝ မြို့နယ်",
      "khName": "ទីប្រជុំជន យូរ៉ាកាវ៉ា",
      "neName": "उराकावा नगर"
    }
  },
  "0160800": {
    "office": {
      "code": "015000",
      "name": "胆振・日高地方",
      "enName": "Iburi Hidaka",
      "officeName": "室蘭地方気象台",
      "chName": "膽振/日高地區",
      "zhName": "胆振/日高地区",
      "koName": "담진·히다카 지방",
      "esName": "Región de Iburi/Hidaka",
      "ptName": "Região de Iburi/Hidaka",
      "thName": "ภูมิภาคอิบูริ/ฮิดากะ",
      "viName": "Vùng Iburi/Hidaka",
      "inName": "Wilayah Iburi/Hidaka",
      "tlName": "Rehiyon ng Iburi/Hidaka",
      "moName": "Ибури/Хидака муж",
      "buName": "Iburi/Hidaka ဒေသ",
      "khName": "តំបន់ Iburi/Hidaka",
      "neName": "इबुरी/हिडाका क्षेत्र"
    },
    "class10": {
      "code": "015020",
      "name": "日高地方",
      "enName": "Hidaka Region",
      "chName": "日高地區",
      "zhName": "日高地区",
      "koName": "히다카 지방",
      "esName": "Región de Hidaka",
      "ptName": "Região de Hidaka",
      "thName": "ภูมิภาคฮิดากะ",
      "viName": "vùng Hidaka",
      "inName": "wilayah Hidaka",
      "tlName": "Rehiyon ng Hidaka",
      "moName": "Хидака бүс",
      "buName": "Hidaka ဒေသ",
      "khName": "តំបន់ Hidaka",
      "neName": "हिडाका क्षेत्र"
    },
    "class15": {
      "code": "015023",
      "name": "日高東部",
      "enName": "Eastern Hidaka"
    },
    "class20": {
      "code": "0160800",
      "name": "様似町",
      "enName": "Samani Town",
      "kana": "さまにちょう",
      "chName": "样似町",
      "zhName": "樣似町",
      "koName": "사마니 정",
      "esName": "Pueblo de Samani",
      "ptName": "bairro de Samani",
      "thName": "เมืองซามานิ",
      "viName": "thị trấn Samani",
      "inName": "kota Samani",
      "tlName": "bayan ng Samani",
      "moName": "Сaмaни жижиг хот",
      "buName": "ဆာမာ့နိ မြို့နယ်",
      "khName": "ទីប្រជុំជន សាម៉ានី",
      "neName": "सामानी नगर"
    }
  },
  "0160900": {
    "office": {
      "code": "015000",
      "name": "胆振・日高地方",
      "enName": "Iburi Hidaka",
      "officeName": "室蘭地方気象台",
      "chName": "膽振/日高地區",
      "zhName": "胆振/日高地区",
      "koName": "담진·히다카 지방",
      "esName": "Región de Iburi/Hidaka",
      "ptName": "Região de Iburi/Hidaka",
      "thName": "ภูมิภาคอิบูริ/ฮิดากะ",
      "viName": "Vùng Iburi/Hidaka",
      "inName": "Wilayah Iburi/Hidaka",
      "tlName": "Rehiyon ng Iburi/Hidaka",
      "moName": "Ибури/Хидака муж",
      "buName": "Iburi/Hidaka ဒေသ",
      "khName": "តំបន់ Iburi/Hidaka",
      "neName": "इबुरी/हिडाका क्षेत्र"
    },
    "class10": {
      "code": "015020",
      "name": "日高地方",
      "enName": "Hidaka Region",
      "chName": "日高地區",
      "zhName": "日高地区",
      "koName": "히다카 지방",
      "esName": "Región de Hidaka",
      "ptName": "Região de Hidaka",
      "thName": "ภูมิภาคฮิดากะ",
      "viName": "vùng Hidaka",
      "inName": "wilayah Hidaka",
      "tlName": "Rehiyon ng Hidaka",
      "moName": "Хидака бүс",
      "buName": "Hidaka ဒေသ",
      "khName": "តំបន់ Hidaka",
      "neName": "हिडाका क्षेत्र"
    },
    "class15": {
      "code": "015023",
      "name": "日高東部",
      "enName": "Eastern Hidaka"
    },
    "class20": {
      "code": "0160900",
      "name": "えりも町",
      "enName": "Erimo Town",
      "kana": "えりもちょう",
      "chName": "襟裳町",
      "zhName": "襟裳町",
      "koName": "에리모 정",
      "esName": "Pueblo de Erimo",
      "ptName": "bairro de Erimo",
      "thName": "เมืองเอริโมะ",
      "viName": "thị trấn Erimo",
      "inName": "kota Erimo",
      "tlName": "bayan ng Erimo",
      "moName": "Эримо жижиг хот",
      "buName": "အယ်ရိမို မြို့နယ်",
      "khName": "ទីប្រជុំជន អ៊ីរីម៉ុ",
      "neName": "एरिमो नगर"
    }
  },
  "0161000": {
    "office": {
      "code": "015000",
      "name": "胆振・日高地方",
      "enName": "Iburi Hidaka",
      "officeName": "室蘭地方気象台",
      "chName": "膽振/日高地區",
      "zhName": "胆振/日高地区",
      "koName": "담진·히다카 지방",
      "esName": "Región de Iburi/Hidaka",
      "ptName": "Região de Iburi/Hidaka",
      "thName": "ภูมิภาคอิบูริ/ฮิดากะ",
      "viName": "Vùng Iburi/Hidaka",
      "inName": "Wilayah Iburi/Hidaka",
      "tlName": "Rehiyon ng Iburi/Hidaka",
      "moName": "Ибури/Хидака муж",
      "buName": "Iburi/Hidaka ဒေသ",
      "khName": "តំបន់ Iburi/Hidaka",
      "neName": "इबुरी/हिडाका क्षेत्र"
    },
    "class10": {
      "code": "015020",
      "name": "日高地方",
      "enName": "Hidaka Region",
      "chName": "日高地區",
      "zhName": "日高地区",
      "koName": "히다카 지방",
      "esName": "Región de Hidaka",
      "ptName": "Região de Hidaka",
      "thName": "ภูมิภาคฮิดากะ",
      "viName": "vùng Hidaka",
      "inName": "wilayah Hidaka",
      "tlName": "Rehiyon ng Hidaka",
      "moName": "Хидака бүс",
      "buName": "Hidaka ဒေသ",
      "khName": "តំបន់ Hidaka",
      "neName": "हिडाका क्षेत्र"
    },
    "class15": {
      "code": "015022",
      "name": "日高中部",
      "enName": "Middle Hidaka"
    },
    "class20": {
      "code": "0161000",
      "name": "新ひだか町",
      "enName": "Shinhidaka Town",
      "kana": "しんひだかちょう",
      "chName": "新日高町",
      "zhName": "新日髙町",
      "koName": "신히다카 정",
      "esName": "Pueblo de Shin-Hidaka",
      "ptName": "bairro de Shinhidaka",
      "thName": "เมืองชินฮิดากะ",
      "viName": "thị trấn Shinhidaka",
      "inName": "kota Shinhidaka",
      "tlName": "bayan ng Shinhidaka",
      "moName": "Шинхидака жижиг хот",
      "buName": "ရှင်းယိဟီဒါ့က မြို့နယ်",
      "khName": "ទីប្រជុំជន ស៊ីនហ៊ីដាកា",
      "neName": "शिन्हीदाका नगर"
    }
  },
  "0163100": {
    "office": {
      "code": "014030",
      "name": "十勝地方",
      "enName": "Tokachi",
      "officeName": "帯広測候所",
      "chName": "十勝地區",
      "zhName": "十胜地区",
      "koName": "도카치 지방",
      "esName": "Región de Tokachi",
      "ptName": "Região de Tokachi",
      "thName": "ภูมิภาคโทกาจิ",
      "viName": "vùng Tokachi",
      "inName": "wilayah Tokachi",
      "tlName": "Rehiyon ng Tokachi",
      "moName": "Токачи муж",
      "buName": "Tokachi ဒေသ",
      "khName": "តំបន់ Tokachi",
      "neName": "टोकाची क्षेत्र"
    },
    "class10": {
      "code": "014030",
      "name": "十勝地方",
      "enName": "Tokachi Region",
      "chName": "十勝地區",
      "zhName": "十胜地区",
      "koName": "도카치 지방",
      "esName": "Región de Tokachi",
      "ptName": "Região de Tokachi",
      "thName": "ภูมิภาคโทกาจิ",
      "viName": "vùng Tokachi",
      "inName": "wilayah Tokachi",
      "tlName": "Rehiyon ng Tokachi",
      "moName": "Токачи муж",
      "buName": "Tokachi ဒေသ",
      "khName": "តំបន់ Tokachi",
      "neName": "टोकाची क्षेत्र"
    },
    "class15": {
      "code": "014032",
      "name": "十勝中部",
      "enName": "Middle Tokachi"
    },
    "class20": {
      "code": "0163100",
      "name": "音更町",
      "enName": "Otofuke Town",
      "kana": "おとふけちょう",
      "chName": "音更町",
      "zhName": "音更町",
      "koName": "오토후케 정",
      "esName": "Pueblo de Otofuke",
      "ptName": "bairro de Otofuke",
      "thName": "เมืองโอโตฟุเคะ",
      "viName": "thị trấn Otofuke",
      "inName": "kota Otofuke",
      "tlName": "bayan ng Otofuke",
      "moName": "Отофүкэ жижиг хот",
      "buName": "အိုတိုးဟုကဲ့ မြို့နယ်",
      "khName": "ទីប្រជុំជន អូតូហ្វូក",
      "neName": "ओतोफ़ुके नगर"
    }
  },
  "0163200": {
    "office": {
      "code": "014030",
      "name": "十勝地方",
      "enName": "Tokachi",
      "officeName": "帯広測候所",
      "chName": "十勝地區",
      "zhName": "十胜地区",
      "koName": "도카치 지방",
      "esName": "Región de Tokachi",
      "ptName": "Região de Tokachi",
      "thName": "ภูมิภาคโทกาจิ",
      "viName": "vùng Tokachi",
      "inName": "wilayah Tokachi",
      "tlName": "Rehiyon ng Tokachi",
      "moName": "Токачи муж",
      "buName": "Tokachi ဒေသ",
      "khName": "តំបន់ Tokachi",
      "neName": "टोकाची क्षेत्र"
    },
    "class10": {
      "code": "014030",
      "name": "十勝地方",
      "enName": "Tokachi Region",
      "chName": "十勝地區",
      "zhName": "十胜地区",
      "koName": "도카치 지방",
      "esName": "Región de Tokachi",
      "ptName": "Região de Tokachi",
      "thName": "ภูมิภาคโทกาจิ",
      "viName": "vùng Tokachi",
      "inName": "wilayah Tokachi",
      "tlName": "Rehiyon ng Tokachi",
      "moName": "Токачи муж",
      "buName": "Tokachi ဒေသ",
      "khName": "តំបន់ Tokachi",
      "neName": "टोकाची क्षेत्र"
    },
    "class15": {
      "code": "014032",
      "name": "十勝中部",
      "enName": "Middle Tokachi"
    },
    "class20": {
      "code": "0163200",
      "name": "士幌町",
      "enName": "Shihoro Town",
      "kana": "しほろちょう",
      "chName": "士幌町",
      "zhName": "士幌町",
      "koName": "시호로 정",
      "esName": "Pueblo de Shihoro",
      "ptName": "bairro de Shihoro",
      "thName": "เมืองชิโฮโระ",
      "viName": "thị trấn Shihoro",
      "inName": "kota Shihoro",
      "tlName": "bayan ng Shihoro",
      "moName": "Шихоро жижиг хот",
      "buName": "ရှီဟိုရို မြို့နယ်",
      "khName": "ទីប្រជុំជន ស៊ីហូរ៉ូ",
      "neName": "शिहोरो नगर"
    }
  },
  "0163300": {
    "office": {
      "code": "014030",
      "name": "十勝地方",
      "enName": "Tokachi",
      "officeName": "帯広測候所",
      "chName": "十勝地區",
      "zhName": "十胜地区",
      "koName": "도카치 지방",
      "esName": "Región de Tokachi",
      "ptName": "Região de Tokachi",
      "thName": "ภูมิภาคโทกาจิ",
      "viName": "vùng Tokachi",
      "inName": "wilayah Tokachi",
      "tlName": "Rehiyon ng Tokachi",
      "moName": "Токачи муж",
      "buName": "Tokachi ဒေသ",
      "khName": "តំបន់ Tokachi",
      "neName": "टोकाची क्षेत्र"
    },
    "class10": {
      "code": "014030",
      "name": "十勝地方",
      "enName": "Tokachi Region",
      "chName": "十勝地區",
      "zhName": "十胜地区",
      "koName": "도카치 지방",
      "esName": "Región de Tokachi",
      "ptName": "Região de Tokachi",
      "thName": "ภูมิภาคโทกาจิ",
      "viName": "vùng Tokachi",
      "inName": "wilayah Tokachi",
      "tlName": "Rehiyon ng Tokachi",
      "moName": "Токачи муж",
      "buName": "Tokachi ဒေသ",
      "khName": "តំបន់ Tokachi",
      "neName": "टोकाची क्षेत्र"
    },
    "class15": {
      "code": "014031",
      "name": "十勝北部",
      "enName": "Northern Tokachi"
    },
    "class20": {
      "code": "0163300",
      "name": "上士幌町",
      "enName": "Kamishihoro Town",
      "kana": "かみしほろちょう",
      "chName": "上士幌町",
      "zhName": "上士幌町",
      "koName": "가미시호로 정",
      "esName": "Pueblo de Kamishihoro",
      "ptName": "bairro de Kamishihoro",
      "thName": "เมืองคามาชิโฮโระ",
      "viName": "thị trấn Kamishihoro",
      "inName": "kota Kamishihoro",
      "tlName": "bayan ng Kamishihoro",
      "moName": "Камишихоро жижиг хот",
      "buName": "ခါမီရှိဟိုရို မြို့နယ်",
      "khName": "ទីប្រជុំជន​ កាមីស៊ីហូរ៉ុ",
      "neName": "कामिशिहोरो नगर"
    }
  },
  "0163400": {
    "office": {
      "code": "014030",
      "name": "十勝地方",
      "enName": "Tokachi",
      "officeName": "帯広測候所",
      "chName": "十勝地區",
      "zhName": "十胜地区",
      "koName": "도카치 지방",
      "esName": "Región de Tokachi",
      "ptName": "Região de Tokachi",
      "thName": "ภูมิภาคโทกาจิ",
      "viName": "vùng Tokachi",
      "inName": "wilayah Tokachi",
      "tlName": "Rehiyon ng Tokachi",
      "moName": "Токачи муж",
      "buName": "Tokachi ဒေသ",
      "khName": "តំបន់ Tokachi",
      "neName": "टोकाची क्षेत्र"
    },
    "class10": {
      "code": "014030",
      "name": "十勝地方",
      "enName": "Tokachi Region",
      "chName": "十勝地區",
      "zhName": "十胜地区",
      "koName": "도카치 지방",
      "esName": "Región de Tokachi",
      "ptName": "Região de Tokachi",
      "thName": "ภูมิภาคโทกาจิ",
      "viName": "vùng Tokachi",
      "inName": "wilayah Tokachi",
      "tlName": "Rehiyon ng Tokachi",
      "moName": "Токачи муж",
      "buName": "Tokachi ဒေသ",
      "khName": "តំបន់ Tokachi",
      "neName": "टोकाची क्षेत्र"
    },
    "class15": {
      "code": "014031",
      "name": "十勝北部",
      "enName": "Northern Tokachi"
    },
    "class20": {
      "code": "0163400",
      "name": "鹿追町",
      "enName": "Shikaoi Town",
      "kana": "しかおいちょう",
      "chName": "鹿追町",
      "zhName": "鹿追町",
      "koName": "시카오이 정",
      "esName": "Pueblo de Shikaoi",
      "ptName": "bairro de Shikaoi",
      "thName": "เมืองชิคาโออิ",
      "viName": "thị trấn Shikaoi",
      "inName": "kota Shikaoi",
      "tlName": "bayan ng Shikaoi",
      "moName": "Шикаой жижиг хот",
      "buName": "ရှီကားအို့ယိ မြို့နယ်",
      "khName": "ទីប្រជុំជន ស៊ីខោយ",
      "neName": "शिकाओइ नगर"
    }
  },
  "0163500": {
    "office": {
      "code": "014030",
      "name": "十勝地方",
      "enName": "Tokachi",
      "officeName": "帯広測候所",
      "chName": "十勝地區",
      "zhName": "十胜地区",
      "koName": "도카치 지방",
      "esName": "Región de Tokachi",
      "ptName": "Região de Tokachi",
      "thName": "ภูมิภาคโทกาจิ",
      "viName": "vùng Tokachi",
      "inName": "wilayah Tokachi",
      "tlName": "Rehiyon ng Tokachi",
      "moName": "Токачи муж",
      "buName": "Tokachi ဒေသ",
      "khName": "តំបន់ Tokachi",
      "neName": "टोकाची क्षेत्र"
    },
    "class10": {
      "code": "014030",
      "name": "十勝地方",
      "enName": "Tokachi Region",
      "chName": "十勝地區",
      "zhName": "十胜地区",
      "koName": "도카치 지방",
      "esName": "Región de Tokachi",
      "ptName": "Região de Tokachi",
      "thName": "ภูมิภาคโทกาจิ",
      "viName": "vùng Tokachi",
      "inName": "wilayah Tokachi",
      "tlName": "Rehiyon ng Tokachi",
      "moName": "Токачи муж",
      "buName": "Tokachi ဒေသ",
      "khName": "តំបន់ Tokachi",
      "neName": "टोकाची क्षेत्र"
    },
    "class15": {
      "code": "014031",
      "name": "十勝北部",
      "enName": "Northern Tokachi"
    },
    "class20": {
      "code": "0163500",
      "name": "新得町",
      "enName": "Shintoku Town",
      "kana": "しんとくちょう",
      "chName": "新得町",
      "zhName": "新得町",
      "koName": "신토쿠 정",
      "esName": "Pueblo de Shintoku",
      "ptName": "bairro de Shintoku",
      "thName": "เมืองชินโตขุ",
      "viName": "thị trấn Shintoku",
      "inName": "kota Shintoku",
      "tlName": "bayan ng Shintoku",
      "moName": "Шинтокү жижиг хот",
      "buName": "ရှင်းတိုကု မြို့နယ်",
      "khName": "ទីប្រជុំជន ស៊ិនតុគូ",
      "neName": "शिन्तोकु नगर"
    }
  },
  "0163600": {
    "office": {
      "code": "014030",
      "name": "十勝地方",
      "enName": "Tokachi",
      "officeName": "帯広測候所",
      "chName": "十勝地區",
      "zhName": "十胜地区",
      "koName": "도카치 지방",
      "esName": "Región de Tokachi",
      "ptName": "Região de Tokachi",
      "thName": "ภูมิภาคโทกาจิ",
      "viName": "vùng Tokachi",
      "inName": "wilayah Tokachi",
      "tlName": "Rehiyon ng Tokachi",
      "moName": "Токачи муж",
      "buName": "Tokachi ဒေသ",
      "khName": "តំបន់ Tokachi",
      "neName": "टोकाची क्षेत्र"
    },
    "class10": {
      "code": "014030",
      "name": "十勝地方",
      "enName": "Tokachi Region",
      "chName": "十勝地區",
      "zhName": "十胜地区",
      "koName": "도카치 지방",
      "esName": "Región de Tokachi",
      "ptName": "Região de Tokachi",
      "thName": "ภูมิภาคโทกาจิ",
      "viName": "vùng Tokachi",
      "inName": "wilayah Tokachi",
      "tlName": "Rehiyon ng Tokachi",
      "moName": "Токачи муж",
      "buName": "Tokachi ဒေသ",
      "khName": "តំបន់ Tokachi",
      "neName": "टोकाची क्षेत्र"
    },
    "class15": {
      "code": "014032",
      "name": "十勝中部",
      "enName": "Middle Tokachi"
    },
    "class20": {
      "code": "0163600",
      "name": "清水町",
      "enName": "Shimizu Town",
      "kana": "しみずちょう",
      "chName": "十胜清水町",
      "zhName": "十勝清水町",
      "koName": "도카치 시미즈 정",
      "esName": "Pueblo de Shimizu, Tokachi",
      "ptName": "Tokachi, bairro de Shimizu",
      "thName": "เมืองชิมิสึ โทคาจิ",
      "viName": "Thị trấn Shimizu, Tokachi",
      "inName": "Kota Shimizu, Tokachi",
      "tlName": "bayan ng Shimizu, Tokachi",
      "moName": "Токачи Шимизү жижиг хот",
      "buName": "တိုခချိရှိမိဇုမြို့နယ်",
      "khName": "ទីប្រជុំជនស៊ីមិស៊ូ តូកាជី",
      "neName": "तोकाची शिमिजु नगर"
    }
  },
  "0163700": {
    "office": {
      "code": "014030",
      "name": "十勝地方",
      "enName": "Tokachi",
      "officeName": "帯広測候所",
      "chName": "十勝地區",
      "zhName": "十胜地区",
      "koName": "도카치 지방",
      "esName": "Región de Tokachi",
      "ptName": "Região de Tokachi",
      "thName": "ภูมิภาคโทกาจิ",
      "viName": "vùng Tokachi",
      "inName": "wilayah Tokachi",
      "tlName": "Rehiyon ng Tokachi",
      "moName": "Токачи муж",
      "buName": "Tokachi ဒေသ",
      "khName": "តំបន់ Tokachi",
      "neName": "टोकाची क्षेत्र"
    },
    "class10": {
      "code": "014030",
      "name": "十勝地方",
      "enName": "Tokachi Region",
      "chName": "十勝地區",
      "zhName": "十胜地区",
      "koName": "도카치 지방",
      "esName": "Región de Tokachi",
      "ptName": "Região de Tokachi",
      "thName": "ภูมิภาคโทกาจิ",
      "viName": "vùng Tokachi",
      "inName": "wilayah Tokachi",
      "tlName": "Rehiyon ng Tokachi",
      "moName": "Токачи муж",
      "buName": "Tokachi ဒေသ",
      "khName": "តំបន់ Tokachi",
      "neName": "टोकाची क्षेत्र"
    },
    "class15": {
      "code": "014032",
      "name": "十勝中部",
      "enName": "Middle Tokachi"
    },
    "class20": {
      "code": "0163700",
      "name": "芽室町",
      "enName": "Memuro Town",
      "kana": "めむろちょう",
      "chName": "芽室町",
      "zhName": "芽室町",
      "koName": "메무로 정",
      "esName": "Pueblo de Memuro",
      "ptName": "bairro de Memuro",
      "thName": "เมืองเมโมรุ",
      "viName": "thị trấn Memuro",
      "inName": "kota Memuro",
      "tlName": "bayan ng Memuro",
      "moName": "Мэмүро жижиг хот",
      "buName": "မဲမုရော့ မြို့နယ်",
      "khName": "ទីប្រជុំជន មេមូរ៉ូ",
      "neName": "मेमुरो नगर"
    }
  },
  "0163800": {
    "office": {
      "code": "014030",
      "name": "十勝地方",
      "enName": "Tokachi",
      "officeName": "帯広測候所",
      "chName": "十勝地區",
      "zhName": "十胜地区",
      "koName": "도카치 지방",
      "esName": "Región de Tokachi",
      "ptName": "Região de Tokachi",
      "thName": "ภูมิภาคโทกาจิ",
      "viName": "vùng Tokachi",
      "inName": "wilayah Tokachi",
      "tlName": "Rehiyon ng Tokachi",
      "moName": "Токачи муж",
      "buName": "Tokachi ဒေသ",
      "khName": "តំបន់ Tokachi",
      "neName": "टोकाची क्षेत्र"
    },
    "class10": {
      "code": "014030",
      "name": "十勝地方",
      "enName": "Tokachi Region",
      "chName": "十勝地區",
      "zhName": "十胜地区",
      "koName": "도카치 지방",
      "esName": "Región de Tokachi",
      "ptName": "Região de Tokachi",
      "thName": "ภูมิภาคโทกาจิ",
      "viName": "vùng Tokachi",
      "inName": "wilayah Tokachi",
      "tlName": "Rehiyon ng Tokachi",
      "moName": "Токачи муж",
      "buName": "Tokachi ဒေသ",
      "khName": "តំបន់ Tokachi",
      "neName": "टोकाची क्षेत्र"
    },
    "class15": {
      "code": "014033",
      "name": "十勝南部",
      "enName": "Southern Tokachi"
    },
    "class20": {
      "code": "0163800",
      "name": "中札内村",
      "enName": "Nakasatsunai Village",
      "kana": "なかさつないむら",
      "chName": "中札内村",
      "zhName": "中軋內村",
      "koName": "나카사쓰나이 촌",
      "esName": "Pueblo de Nakasatsunai",
      "ptName": "povoado de Nakasatsunai",
      "thName": "หมู่บ้านนากะซัตสึนาอิ",
      "viName": "làng Nakasatsunai",
      "inName": "desa Nakasatsunai",
      "tlName": "nayon ng Nakasatsunai",
      "moName": "Нaкасaцүнaй тосгон",
      "buName": "နာကာ့ဆားဆုနယိ ကျေးရွာ",
      "khName": "ភូមិ ណាកាសាសុ៊ណៃ",
      "neName": "नाकासात्सुनाई गाउँ"
    }
  },
  "0163900": {
    "office": {
      "code": "014030",
      "name": "十勝地方",
      "enName": "Tokachi",
      "officeName": "帯広測候所",
      "chName": "十勝地區",
      "zhName": "十胜地区",
      "koName": "도카치 지방",
      "esName": "Región de Tokachi",
      "ptName": "Região de Tokachi",
      "thName": "ภูมิภาคโทกาจิ",
      "viName": "vùng Tokachi",
      "inName": "wilayah Tokachi",
      "tlName": "Rehiyon ng Tokachi",
      "moName": "Токачи муж",
      "buName": "Tokachi ဒေသ",
      "khName": "តំបន់ Tokachi",
      "neName": "टोकाची क्षेत्र"
    },
    "class10": {
      "code": "014030",
      "name": "十勝地方",
      "enName": "Tokachi Region",
      "chName": "十勝地區",
      "zhName": "十胜地区",
      "koName": "도카치 지방",
      "esName": "Región de Tokachi",
      "ptName": "Região de Tokachi",
      "thName": "ภูมิภาคโทกาจิ",
      "viName": "vùng Tokachi",
      "inName": "wilayah Tokachi",
      "tlName": "Rehiyon ng Tokachi",
      "moName": "Токачи муж",
      "buName": "Tokachi ဒေသ",
      "khName": "តំបន់ Tokachi",
      "neName": "टोकाची क्षेत्र"
    },
    "class15": {
      "code": "014033",
      "name": "十勝南部",
      "enName": "Southern Tokachi"
    },
    "class20": {
      "code": "0163900",
      "name": "更別村",
      "enName": "Sarabetsu Village",
      "kana": "さらべつむら",
      "chName": "更别村",
      "zhName": "更別村",
      "koName": "사라베쓰 촌",
      "esName": "Pueblo de Sarabetsu",
      "ptName": "povoado de Sarabetsu",
      "thName": "หมู่บ้านซาระเบ็ทสึ",
      "viName": "làng Sarabetsu",
      "inName": "desa Sarabetsu",
      "tlName": "nayon ng Sarabetsu",
      "moName": "Сaрабэцү тосгон",
      "buName": "ဆာရဗေ့စု ကျေးရွာ",
      "khName": "ភូមិ សារ៉ាបេតស៊ូ",
      "neName": "साराबेत्सु गाउँ"
    }
  },
  "0164100": {
    "office": {
      "code": "014030",
      "name": "十勝地方",
      "enName": "Tokachi",
      "officeName": "帯広測候所",
      "chName": "十勝地區",
      "zhName": "十胜地区",
      "koName": "도카치 지방",
      "esName": "Región de Tokachi",
      "ptName": "Região de Tokachi",
      "thName": "ภูมิภาคโทกาจิ",
      "viName": "vùng Tokachi",
      "inName": "wilayah Tokachi",
      "tlName": "Rehiyon ng Tokachi",
      "moName": "Токачи муж",
      "buName": "Tokachi ဒေသ",
      "khName": "តំបន់ Tokachi",
      "neName": "टोकाची क्षेत्र"
    },
    "class10": {
      "code": "014030",
      "name": "十勝地方",
      "enName": "Tokachi Region",
      "chName": "十勝地區",
      "zhName": "十胜地区",
      "koName": "도카치 지방",
      "esName": "Región de Tokachi",
      "ptName": "Região de Tokachi",
      "thName": "ภูมิภาคโทกาจิ",
      "viName": "vùng Tokachi",
      "inName": "wilayah Tokachi",
      "tlName": "Rehiyon ng Tokachi",
      "moName": "Токачи муж",
      "buName": "Tokachi ဒေသ",
      "khName": "តំបន់ Tokachi",
      "neName": "टोकाची क्षेत्र"
    },
    "class15": {
      "code": "014033",
      "name": "十勝南部",
      "enName": "Southern Tokachi"
    },
    "class20": {
      "code": "0164100",
      "name": "大樹町",
      "enName": "Taiki Town",
      "kana": "たいきちょう",
      "chName": "十胜大树町",
      "zhName": "十勝大樹町",
      "koName": "도카치 다이키 정",
      "esName": "Pueblo de Taiki, Tokachi",
      "ptName": "Tokachi, bairro de Taiki",
      "thName": "เมืองไทกิ โทคาจิ",
      "viName": "Thị trấn Taiki, Tokachi",
      "inName": "Kota Taiki, Tokachi",
      "tlName": "bayan ng Taiki, Tokachi",
      "moName": "Токачи тайки жижиг хот",
      "buName": "တိုခချိတိုင်းခိမြို့နယ်",
      "khName": "ទីប្រជុំជនតៃគី តូកាជី",
      "neName": "तोकाची ताइकी नगर"
    }
  },
  "0164200": {
    "office": {
      "code": "014030",
      "name": "十勝地方",
      "enName": "Tokachi",
      "officeName": "帯広測候所",
      "chName": "十勝地區",
      "zhName": "十胜地区",
      "koName": "도카치 지방",
      "esName": "Región de Tokachi",
      "ptName": "Região de Tokachi",
      "thName": "ภูมิภาคโทกาจิ",
      "viName": "vùng Tokachi",
      "inName": "wilayah Tokachi",
      "tlName": "Rehiyon ng Tokachi",
      "moName": "Токачи муж",
      "buName": "Tokachi ဒေသ",
      "khName": "តំបន់ Tokachi",
      "neName": "टोकाची क्षेत्र"
    },
    "class10": {
      "code": "014030",
      "name": "十勝地方",
      "enName": "Tokachi Region",
      "chName": "十勝地區",
      "zhName": "十胜地区",
      "koName": "도카치 지방",
      "esName": "Región de Tokachi",
      "ptName": "Região de Tokachi",
      "thName": "ภูมิภาคโทกาจิ",
      "viName": "vùng Tokachi",
      "inName": "wilayah Tokachi",
      "tlName": "Rehiyon ng Tokachi",
      "moName": "Токачи муж",
      "buName": "Tokachi ဒေသ",
      "khName": "តំបន់ Tokachi",
      "neName": "टोकाची क्षेत्र"
    },
    "class15": {
      "code": "014033",
      "name": "十勝南部",
      "enName": "Southern Tokachi"
    },
    "class20": {
      "code": "0164200",
      "name": "広尾町",
      "enName": "Hiroo Town",
      "kana": "ひろおちょう",
      "chName": "广尾町",
      "zhName": "廣尾町",
      "koName": "히로오 정",
      "esName": "Pueblo de Hiroo",
      "ptName": "bairro de Hiroo",
      "thName": "เมืองฮิโร",
      "viName": "thị trấn Hiroo",
      "inName": "kota Hiroo",
      "tlName": "bayan ng Hiroo",
      "moName": "Хироо жижиг хот",
      "buName": "ဟီရူး မြို့နယ်",
      "khName": "ទីប្រជុំជន ហ៊ីរូ",
      "neName": "हिरो नगर"
    }
  },
  "0164300": {
    "office": {
      "code": "014030",
      "name": "十勝地方",
      "enName": "Tokachi",
      "officeName": "帯広測候所",
      "chName": "十勝地區",
      "zhName": "十胜地区",
      "koName": "도카치 지방",
      "esName": "Región de Tokachi",
      "ptName": "Região de Tokachi",
      "thName": "ภูมิภาคโทกาจิ",
      "viName": "vùng Tokachi",
      "inName": "wilayah Tokachi",
      "tlName": "Rehiyon ng Tokachi",
      "moName": "Токачи муж",
      "buName": "Tokachi ဒေသ",
      "khName": "តំបន់ Tokachi",
      "neName": "टोकाची क्षेत्र"
    },
    "class10": {
      "code": "014030",
      "name": "十勝地方",
      "enName": "Tokachi Region",
      "chName": "十勝地區",
      "zhName": "十胜地区",
      "koName": "도카치 지방",
      "esName": "Región de Tokachi",
      "ptName": "Região de Tokachi",
      "thName": "ภูมิภาคโทกาจิ",
      "viName": "vùng Tokachi",
      "inName": "wilayah Tokachi",
      "tlName": "Rehiyon ng Tokachi",
      "moName": "Токачи муж",
      "buName": "Tokachi ဒေသ",
      "khName": "តំបន់ Tokachi",
      "neName": "टोकाची क्षेत्र"
    },
    "class15": {
      "code": "014032",
      "name": "十勝中部",
      "enName": "Middle Tokachi"
    },
    "class20": {
      "code": "0164300",
      "name": "幕別町",
      "enName": "Makubetsu Town",
      "kana": "まくべつちょう",
      "chName": "幕别町",
      "zhName": "幕別町",
      "koName": "마쿠베쓰 정",
      "esName": "Pueblo de Makubetsu",
      "ptName": "bairro de Makubetsu",
      "thName": "เมืองมาคุเบ็ทสึ",
      "viName": "thị trấn Makubetsu",
      "inName": "kota Makubetsu",
      "tlName": "bayan ng Makubetsu",
      "moName": "Мaкүбэцү жижиг хот",
      "buName": "မာကုဗေ့စု မြို့နယ်",
      "khName": "ទីប្រជុំជន ម៉ាក់គូបេតស៊ូ",
      "neName": "माकुबेत्सु नगर"
    }
  },
  "0164400": {
    "office": {
      "code": "014030",
      "name": "十勝地方",
      "enName": "Tokachi",
      "officeName": "帯広測候所",
      "chName": "十勝地區",
      "zhName": "十胜地区",
      "koName": "도카치 지방",
      "esName": "Región de Tokachi",
      "ptName": "Região de Tokachi",
      "thName": "ภูมิภาคโทกาจิ",
      "viName": "vùng Tokachi",
      "inName": "wilayah Tokachi",
      "tlName": "Rehiyon ng Tokachi",
      "moName": "Токачи муж",
      "buName": "Tokachi ဒေသ",
      "khName": "តំបន់ Tokachi",
      "neName": "टोकाची क्षेत्र"
    },
    "class10": {
      "code": "014030",
      "name": "十勝地方",
      "enName": "Tokachi Region",
      "chName": "十勝地區",
      "zhName": "十胜地区",
      "koName": "도카치 지방",
      "esName": "Región de Tokachi",
      "ptName": "Região de Tokachi",
      "thName": "ภูมิภาคโทกาจิ",
      "viName": "vùng Tokachi",
      "inName": "wilayah Tokachi",
      "tlName": "Rehiyon ng Tokachi",
      "moName": "Токачи муж",
      "buName": "Tokachi ဒေသ",
      "khName": "តំបន់ Tokachi",
      "neName": "टोकाची क्षेत्र"
    },
    "class15": {
      "code": "014032",
      "name": "十勝中部",
      "enName": "Middle Tokachi"
    },
    "class20": {
      "code": "0164400",
      "name": "池田町",
      "enName": "Ikeda Town",
      "kana": "いけだちょう",
      "chName": "十胜池田町",
      "zhName": "十勝池田町",
      "koName": "토카치 이케다 정",
      "esName": "Pueblo de Ikeda, Tokachi",
      "ptName": "Tokachi, bairro de Ikeda",
      "thName": "เมืองอิเคดะ โทคาจิ",
      "viName": "Thị trấn Ikeda, Tokachi",
      "inName": "Kota Ikeda, Tokachi",
      "tlName": "bayan ng Ikeda, Tokachi",
      "moName": "Токачи Икэда жижиг хот",
      "buName": "တိုခချိအိခဲဒုမြို့နယ်",
      "khName": "ទីប្រជុំជនអាយកេដា តូកាជី",
      "neName": "तोकाची इकेदा नगर"
    }
  },
  "0164500": {
    "office": {
      "code": "014030",
      "name": "十勝地方",
      "enName": "Tokachi",
      "officeName": "帯広測候所",
      "chName": "十勝地區",
      "zhName": "十胜地区",
      "koName": "도카치 지방",
      "esName": "Región de Tokachi",
      "ptName": "Região de Tokachi",
      "thName": "ภูมิภาคโทกาจิ",
      "viName": "vùng Tokachi",
      "inName": "wilayah Tokachi",
      "tlName": "Rehiyon ng Tokachi",
      "moName": "Токачи муж",
      "buName": "Tokachi ဒေသ",
      "khName": "តំបន់ Tokachi",
      "neName": "टोकाची क्षेत्र"
    },
    "class10": {
      "code": "014030",
      "name": "十勝地方",
      "enName": "Tokachi Region",
      "chName": "十勝地區",
      "zhName": "十胜地区",
      "koName": "도카치 지방",
      "esName": "Región de Tokachi",
      "ptName": "Região de Tokachi",
      "thName": "ภูมิภาคโทกาจิ",
      "viName": "vùng Tokachi",
      "inName": "wilayah Tokachi",
      "tlName": "Rehiyon ng Tokachi",
      "moName": "Токачи муж",
      "buName": "Tokachi ဒေသ",
      "khName": "តំបន់ Tokachi",
      "neName": "टोकाची क्षेत्र"
    },
    "class15": {
      "code": "014032",
      "name": "十勝中部",
      "enName": "Middle Tokachi"
    },
    "class20": {
      "code": "0164500",
      "name": "豊頃町",
      "enName": "Toyokoro Town",
      "kana": "とよころちょう",
      "chName": "丰顷町",
      "zhName": "豐頃町",
      "koName": "도요코로 정",
      "esName": "Pueblo de Toyokoro",
      "ptName": "bairro de Toyokoro",
      "thName": "เมืองโตโยโคโระ",
      "viName": "thị trấn Toyokoro",
      "inName": "kota Toyokoro",
      "tlName": "bayan ng Toyokoro",
      "moName": "Тоёокоро жижиг хот",
      "buName": "တိုရိုကိုယို မြို့နယ်",
      "khName": "ទីប្រជុំជន តូយ៉ូកូរ៉ូ",
      "neName": "तोयोकोरो नगर"
    }
  },
  "0164600": {
    "office": {
      "code": "014030",
      "name": "十勝地方",
      "enName": "Tokachi",
      "officeName": "帯広測候所",
      "chName": "十勝地區",
      "zhName": "十胜地区",
      "koName": "도카치 지방",
      "esName": "Región de Tokachi",
      "ptName": "Região de Tokachi",
      "thName": "ภูมิภาคโทกาจิ",
      "viName": "vùng Tokachi",
      "inName": "wilayah Tokachi",
      "tlName": "Rehiyon ng Tokachi",
      "moName": "Токачи муж",
      "buName": "Tokachi ဒေသ",
      "khName": "តំបន់ Tokachi",
      "neName": "टोकाची क्षेत्र"
    },
    "class10": {
      "code": "014030",
      "name": "十勝地方",
      "enName": "Tokachi Region",
      "chName": "十勝地區",
      "zhName": "十胜地区",
      "koName": "도카치 지방",
      "esName": "Región de Tokachi",
      "ptName": "Região de Tokachi",
      "thName": "ภูมิภาคโทกาจิ",
      "viName": "vùng Tokachi",
      "inName": "wilayah Tokachi",
      "tlName": "Rehiyon ng Tokachi",
      "moName": "Токачи муж",
      "buName": "Tokachi ဒေသ",
      "khName": "តំបន់ Tokachi",
      "neName": "टोकाची क्षेत्र"
    },
    "class15": {
      "code": "014032",
      "name": "十勝中部",
      "enName": "Middle Tokachi"
    },
    "class20": {
      "code": "0164600",
      "name": "本別町",
      "enName": "Hombetsu Town",
      "kana": "ほんべつちょう",
      "chName": "本别町",
      "zhName": "本別町",
      "koName": "혼베쓰 정",
      "esName": "Pueblo de Honbetsu",
      "ptName": "bairro de Hombetsu",
      "thName": "เมืองฮอมเบ็ทสึ",
      "viName": "thị trấn Hombetsu",
      "inName": "kota Hombetsu",
      "tlName": "bayan ng Hombetsu",
      "moName": "Хомбэцү жижиг хот",
      "buName": "ဟွမ်ဗေ့စု မြို့နယ်",
      "khName": "ទីប្រជុំជន ហុំបេតស៊ូ",
      "neName": "होम्बेत्सु नगर"
    }
  },
  "0164700": {
    "office": {
      "code": "014030",
      "name": "十勝地方",
      "enName": "Tokachi",
      "officeName": "帯広測候所",
      "chName": "十勝地區",
      "zhName": "十胜地区",
      "koName": "도카치 지방",
      "esName": "Región de Tokachi",
      "ptName": "Região de Tokachi",
      "thName": "ภูมิภาคโทกาจิ",
      "viName": "vùng Tokachi",
      "inName": "wilayah Tokachi",
      "tlName": "Rehiyon ng Tokachi",
      "moName": "Токачи муж",
      "buName": "Tokachi ဒေသ",
      "khName": "តំបន់ Tokachi",
      "neName": "टोकाची क्षेत्र"
    },
    "class10": {
      "code": "014030",
      "name": "十勝地方",
      "enName": "Tokachi Region",
      "chName": "十勝地區",
      "zhName": "十胜地区",
      "koName": "도카치 지방",
      "esName": "Región de Tokachi",
      "ptName": "Região de Tokachi",
      "thName": "ภูมิภาคโทกาจิ",
      "viName": "vùng Tokachi",
      "inName": "wilayah Tokachi",
      "tlName": "Rehiyon ng Tokachi",
      "moName": "Токачи муж",
      "buName": "Tokachi ဒေသ",
      "khName": "តំបន់ Tokachi",
      "neName": "टोकाची क्षेत्र"
    },
    "class15": {
      "code": "014031",
      "name": "十勝北部",
      "enName": "Northern Tokachi"
    },
    "class20": {
      "code": "0164700",
      "name": "足寄町",
      "enName": "Ashoro Town",
      "kana": "あしょろちょう",
      "chName": "足寄町",
      "zhName": "足寄町",
      "koName": "아쇼로 정",
      "esName": "Pueblo de Ashoro",
      "ptName": "bairro de Ashoro",
      "thName": "เมืองอะโชโระ",
      "viName": "thị trấn Ashoro",
      "inName": "kota Ashoro",
      "tlName": "bayan ng Ashoro",
      "moName": "Aшоро жижиг хот",
      "buName": "အာရှိုရို မြို့နယ်",
      "khName": "ទីប្រជុំជន អាស៊ូរ៉ុ",
      "neName": "आशोरो नगर"
    }
  },
  "0164800": {
    "office": {
      "code": "014030",
      "name": "十勝地方",
      "enName": "Tokachi",
      "officeName": "帯広測候所",
      "chName": "十勝地區",
      "zhName": "十胜地区",
      "koName": "도카치 지방",
      "esName": "Región de Tokachi",
      "ptName": "Região de Tokachi",
      "thName": "ภูมิภาคโทกาจิ",
      "viName": "vùng Tokachi",
      "inName": "wilayah Tokachi",
      "tlName": "Rehiyon ng Tokachi",
      "moName": "Токачи муж",
      "buName": "Tokachi ဒေသ",
      "khName": "តំបន់ Tokachi",
      "neName": "टोकाची क्षेत्र"
    },
    "class10": {
      "code": "014030",
      "name": "十勝地方",
      "enName": "Tokachi Region",
      "chName": "十勝地區",
      "zhName": "十胜地区",
      "koName": "도카치 지방",
      "esName": "Región de Tokachi",
      "ptName": "Região de Tokachi",
      "thName": "ภูมิภาคโทกาจิ",
      "viName": "vùng Tokachi",
      "inName": "wilayah Tokachi",
      "tlName": "Rehiyon ng Tokachi",
      "moName": "Токачи муж",
      "buName": "Tokachi ဒေသ",
      "khName": "តំបន់ Tokachi",
      "neName": "टोकाची क्षेत्र"
    },
    "class15": {
      "code": "014031",
      "name": "十勝北部",
      "enName": "Northern Tokachi"
    },
    "class20": {
      "code": "0164800",
      "name": "陸別町",
      "enName": "Rikubetsu Town",
      "kana": "りくべつちょう",
      "chName": "陆别町",
      "zhName": "陸別町",
      "koName": "리쿠베쓰 정",
      "esName": "Pueblo de Rikubetsu",
      "ptName": "bairro de Rikubetsu",
      "thName": "เมืองริคุเบ็ทสึ",
      "viName": "thị trấn Rikubetsu",
      "inName": "kota Rikubetsu",
      "tlName": "bayan ng Rikubetsu",
      "moName": "Рикүбэцү жижиг хот",
      "buName": "ရီကုဗေ့စု မြို့နယ်",
      "khName": "ទីប្រជុំជន រីគុបេតស៊ុ",
      "neName": "रिकुबेत्सु नगर"
    }
  },
  "0164900": {
    "office": {
      "code": "014030",
      "name": "十勝地方",
      "enName": "Tokachi",
      "officeName": "帯広測候所",
      "chName": "十勝地區",
      "zhName": "十胜地区",
      "koName": "도카치 지방",
      "esName": "Región de Tokachi",
      "ptName": "Região de Tokachi",
      "thName": "ภูมิภาคโทกาจิ",
      "viName": "vùng Tokachi",
      "inName": "wilayah Tokachi",
      "tlName": "Rehiyon ng Tokachi",
      "moName": "Токачи муж",
      "buName": "Tokachi ဒေသ",
      "khName": "តំបន់ Tokachi",
      "neName": "टोकाची क्षेत्र"
    },
    "class10": {
      "code": "014030",
      "name": "十勝地方",
      "enName": "Tokachi Region",
      "chName": "十勝地區",
      "zhName": "十胜地区",
      "koName": "도카치 지방",
      "esName": "Región de Tokachi",
      "ptName": "Região de Tokachi",
      "thName": "ภูมิภาคโทกาจิ",
      "viName": "vùng Tokachi",
      "inName": "wilayah Tokachi",
      "tlName": "Rehiyon ng Tokachi",
      "moName": "Токачи муж",
      "buName": "Tokachi ဒေသ",
      "khName": "តំបន់ Tokachi",
      "neName": "टोकाची क्षेत्र"
    },
    "class15": {
      "code": "014032",
      "name": "十勝中部",
      "enName": "Middle Tokachi"
    },
    "class20": {
      "code": "0164900",
      "name": "浦幌町",
      "enName": "Urahoro Town",
      "kana": "うらほろちょう",
      "chName": "浦幌町",
      "zhName": "浦幌町",
      "koName": "우라호로 정",
      "esName": "Pueblo de Urahoro",
      "ptName": "bairro de Urahoro",
      "thName": "เมืองอุระโฮโระ",
      "viName": "thị trấn Urahoro",
      "inName": "kota Urahoro",
      "tlName": "bayan ng Urahoro",
      "moName": "Үрахоро жижиг хот",
      "buName": "ဦရာ့ဟိုရို မြို့နယ်",
      "khName": "ទីប្រជុំជន យូរ៉ាហូរ៉ុ",
      "neName": "उराहोरो नगर"
    }
  },
  "0166100": {
    "office": {
      "code": "014100",
      "name": "釧路・根室地方",
      "enName": "Kushiro Nemuro",
      "officeName": "釧路地方気象台",
      "chName": "釧路/根室地區",
      "zhName": "钏路/根室地区",
      "koName": "구시로·네무로 지방",
      "esName": "Región de Kushiro/Nemuro",
      "ptName": "Região de Kushiro/Nemuro",
      "thName": "ภูมิภาคคุชิโระ/เนมูโระ",
      "viName": "Vùng Kushiro/Nemuro",
      "inName": "Wilayah Kushiro/Nemuro",
      "tlName": "Rehiyon ng Kushiro/Nemuro",
      "moName": "Куширо/Немуро муж",
      "buName": "Kushiro/Nemuro ဒေသ",
      "khName": "តំបន់ Kushiro/Nemuro",
      "neName": "कुशिरो/नेमुरो क्षेत्र"
    },
    "class10": {
      "code": "014020",
      "name": "釧路地方",
      "enName": "Kushiro Region",
      "chName": "釧路地區",
      "zhName": "钏路地区",
      "koName": "구시로 지방",
      "esName": "Región de Kushiro",
      "ptName": "Região de Kushiro",
      "thName": "ภูมิภาคคุชิโระ",
      "viName": "vùng Kushiro",
      "inName": "wilayah Kushiro",
      "tlName": "Rehiyon ng Kushiro",
      "moName": "Куширо муж",
      "buName": "Kushiro ဒေသ",
      "khName": "តំបន់ Kushiro",
      "neName": "कुशिरो क्षेत्र"
    },
    "class15": {
      "code": "014024",
      "name": "釧路南西部",
      "enName": "South-western Kushiro"
    },
    "class20": {
      "code": "0166100",
      "name": "釧路町",
      "enName": "Kushiro Town",
      "kana": "くしろちょう",
      "chName": "钏路町",
      "zhName": "釧路町",
      "koName": "구시로 정",
      "esName": "Pueblo de Kushiro",
      "ptName": "bairro de Kushiro",
      "thName": "เมืองคุชิโระ (คุชิโระโจ)",
      "viName": "thị trấn Kushiro",
      "inName": "kota Kushiro (Kushiro-chō)",
      "tlName": "bayan ng Kushiro",
      "moName": "Күширо жижиг хот",
      "buName": "ကုရှိရို မြို့နယ်",
      "khName": "ទីប្រជុំជន គូស៊ីរ៉ូ",
      "neName": "कुशिरो नगर"
    }
  },
  "0166200": {
    "office": {
      "code": "014100",
      "name": "釧路・根室地方",
      "enName": "Kushiro Nemuro",
      "officeName": "釧路地方気象台",
      "chName": "釧路/根室地區",
      "zhName": "钏路/根室地区",
      "koName": "구시로·네무로 지방",
      "esName": "Región de Kushiro/Nemuro",
      "ptName": "Região de Kushiro/Nemuro",
      "thName": "ภูมิภาคคุชิโระ/เนมูโระ",
      "viName": "Vùng Kushiro/Nemuro",
      "inName": "Wilayah Kushiro/Nemuro",
      "tlName": "Rehiyon ng Kushiro/Nemuro",
      "moName": "Куширо/Немуро муж",
      "buName": "Kushiro/Nemuro ဒေသ",
      "khName": "តំបន់ Kushiro/Nemuro",
      "neName": "कुशिरो/नेमुरो क्षेत्र"
    },
    "class10": {
      "code": "014020",
      "name": "釧路地方",
      "enName": "Kushiro Region",
      "chName": "釧路地區",
      "zhName": "钏路地区",
      "koName": "구시로 지방",
      "esName": "Región de Kushiro",
      "ptName": "Região de Kushiro",
      "thName": "ภูมิภาคคุชิโระ",
      "viName": "vùng Kushiro",
      "inName": "wilayah Kushiro",
      "tlName": "Rehiyon ng Kushiro",
      "moName": "Куширо муж",
      "buName": "Kushiro ဒေသ",
      "khName": "តំបន់ Kushiro",
      "neName": "कुशिरो क्षेत्र"
    },
    "class15": {
      "code": "014023",
      "name": "釧路南東部",
      "enName": "South-eastern Kushiro"
    },
    "class20": {
      "code": "0166200",
      "name": "厚岸町",
      "enName": "Akkeshi Town",
      "kana": "あっけしちょう",
      "chName": "厚岸町",
      "zhName": "厚岸町",
      "koName": "앗케시 정",
      "esName": "Pueblo de Akkeshi",
      "ptName": "bairro de Akkeshi",
      "thName": "เมืองอัคเคชิ",
      "viName": "thị trấn Akkeshi",
      "inName": "kota Akkeshi",
      "tlName": "bayan ng Akkeshi",
      "moName": "Aккэши жижиг хот",
      "buName": "အားကိရှိ မြို့နယ်",
      "khName": "ទីប្រជុំជន អាកេស៊ី",
      "neName": "अक्केशी नगर"
    }
  },
  "0166300": {
    "office": {
      "code": "014100",
      "name": "釧路・根室地方",
      "enName": "Kushiro Nemuro",
      "officeName": "釧路地方気象台",
      "chName": "釧路/根室地區",
      "zhName": "钏路/根室地区",
      "koName": "구시로·네무로 지방",
      "esName": "Región de Kushiro/Nemuro",
      "ptName": "Região de Kushiro/Nemuro",
      "thName": "ภูมิภาคคุชิโระ/เนมูโระ",
      "viName": "Vùng Kushiro/Nemuro",
      "inName": "Wilayah Kushiro/Nemuro",
      "tlName": "Rehiyon ng Kushiro/Nemuro",
      "moName": "Куширо/Немуро муж",
      "buName": "Kushiro/Nemuro ဒေသ",
      "khName": "តំបន់ Kushiro/Nemuro",
      "neName": "कुशिरो/नेमुरो क्षेत्र"
    },
    "class10": {
      "code": "014020",
      "name": "釧路地方",
      "enName": "Kushiro Region",
      "chName": "釧路地區",
      "zhName": "钏路地区",
      "koName": "구시로 지방",
      "esName": "Región de Kushiro",
      "ptName": "Região de Kushiro",
      "thName": "ภูมิภาคคุชิโระ",
      "viName": "vùng Kushiro",
      "inName": "wilayah Kushiro",
      "tlName": "Rehiyon ng Kushiro",
      "moName": "Куширо муж",
      "buName": "Kushiro ဒေသ",
      "khName": "តំបន់ Kushiro",
      "neName": "कुशिरो क्षेत्र"
    },
    "class15": {
      "code": "014023",
      "name": "釧路南東部",
      "enName": "South-eastern Kushiro"
    },
    "class20": {
      "code": "0166300",
      "name": "浜中町",
      "enName": "Hamanaka Town",
      "kana": "はまなかちょう",
      "chName": "滨中町",
      "zhName": "濱中町",
      "koName": "하마나카 정",
      "esName": "Pueblo de Hamanaka",
      "ptName": "bairro de Hamanaka",
      "thName": "เมืองฮามานากะ",
      "viName": "thị trấn Hamanaka",
      "inName": "kota Hamanaka",
      "tlName": "bayan ng Hamanaka",
      "moName": "Хaмaнaка жижиг хот",
      "buName": "ဟမ်မာနာ့က မြို့နယ်",
      "khName": "ទីប្រជុំជន ហាម៉ាណាកា",
      "neName": "हामानाका नगर"
    }
  },
  "0166400": {
    "office": {
      "code": "014100",
      "name": "釧路・根室地方",
      "enName": "Kushiro Nemuro",
      "officeName": "釧路地方気象台",
      "chName": "釧路/根室地區",
      "zhName": "钏路/根室地区",
      "koName": "구시로·네무로 지방",
      "esName": "Región de Kushiro/Nemuro",
      "ptName": "Região de Kushiro/Nemuro",
      "thName": "ภูมิภาคคุชิโระ/เนมูโระ",
      "viName": "Vùng Kushiro/Nemuro",
      "inName": "Wilayah Kushiro/Nemuro",
      "tlName": "Rehiyon ng Kushiro/Nemuro",
      "moName": "Куширо/Немуро муж",
      "buName": "Kushiro/Nemuro ဒေသ",
      "khName": "តំបន់ Kushiro/Nemuro",
      "neName": "कुशिरो/नेमुरो क्षेत्र"
    },
    "class10": {
      "code": "014020",
      "name": "釧路地方",
      "enName": "Kushiro Region",
      "chName": "釧路地區",
      "zhName": "钏路地区",
      "koName": "구시로 지방",
      "esName": "Región de Kushiro",
      "ptName": "Região de Kushiro",
      "thName": "ภูมิภาคคุชิโระ",
      "viName": "vùng Kushiro",
      "inName": "wilayah Kushiro",
      "tlName": "Rehiyon ng Kushiro",
      "moName": "Куширо муж",
      "buName": "Kushiro ဒေသ",
      "khName": "តំបន់ Kushiro",
      "neName": "कुशिरो क्षेत्र"
    },
    "class15": {
      "code": "014022",
      "name": "釧路中部",
      "enName": "Middle Kushiro"
    },
    "class20": {
      "code": "0166400",
      "name": "標茶町",
      "enName": "Shibecha Town",
      "kana": "しべちゃちょう",
      "chName": "标茶町",
      "zhName": "標茶町",
      "koName": "시베차 정",
      "esName": "Pueblo de Shibecha",
      "ptName": "bairro de Shibecha",
      "thName": "เมืองชิเบจะ",
      "viName": "thị trấn Shibecha",
      "inName": "kota Shibecha",
      "tlName": "bayan ng Shibecha",
      "moName": "Шибэчa жижиг хот",
      "buName": "ရှီဘဲ့ကျ မြို့နယ်",
      "khName": "ទីប្រជុំជន ស៊ីបេចា",
      "neName": "शिबेचा नगर"
    }
  },
  "0166500": {
    "office": {
      "code": "014100",
      "name": "釧路・根室地方",
      "enName": "Kushiro Nemuro",
      "officeName": "釧路地方気象台",
      "chName": "釧路/根室地區",
      "zhName": "钏路/根室地区",
      "koName": "구시로·네무로 지방",
      "esName": "Región de Kushiro/Nemuro",
      "ptName": "Região de Kushiro/Nemuro",
      "thName": "ภูมิภาคคุชิโระ/เนมูโระ",
      "viName": "Vùng Kushiro/Nemuro",
      "inName": "Wilayah Kushiro/Nemuro",
      "tlName": "Rehiyon ng Kushiro/Nemuro",
      "moName": "Куширо/Немуро муж",
      "buName": "Kushiro/Nemuro ဒေသ",
      "khName": "តំបន់ Kushiro/Nemuro",
      "neName": "कुशिरो/नेमुरो क्षेत्र"
    },
    "class10": {
      "code": "014020",
      "name": "釧路地方",
      "enName": "Kushiro Region",
      "chName": "釧路地區",
      "zhName": "钏路地区",
      "koName": "구시로 지방",
      "esName": "Región de Kushiro",
      "ptName": "Região de Kushiro",
      "thName": "ภูมิภาคคุชิโระ",
      "viName": "vùng Kushiro",
      "inName": "wilayah Kushiro",
      "tlName": "Rehiyon ng Kushiro",
      "moName": "Куширо муж",
      "buName": "Kushiro ဒေသ",
      "khName": "តំបន់ Kushiro",
      "neName": "कुशिरो क्षेत्र"
    },
    "class15": {
      "code": "014021",
      "name": "釧路北部",
      "enName": "Northern Kushiro"
    },
    "class20": {
      "code": "0166500",
      "name": "弟子屈町",
      "enName": "Teshikaga Town",
      "kana": "てしかがちょう",
      "chName": "弟子屈町",
      "zhName": "弟子屈町",
      "koName": "데시카가 정",
      "esName": "Pueblo de Teshikaga",
      "ptName": "bairro de Teshikaga",
      "thName": "เมืองเทชิคางะ",
      "viName": "thị trấn Teshikaga",
      "inName": "kota Teshikaga",
      "tlName": "bayan ng Teshikaga",
      "moName": "Тэшикагa жижиг хот",
      "buName": "တယ်ရှိကာ့ဂ မြို့နယ်",
      "khName": "ទីប្រជុំជន ថេស៊ីកាវ៉ា",
      "neName": "तेशिकागा नगर"
    }
  },
  "0166700": {
    "office": {
      "code": "014100",
      "name": "釧路・根室地方",
      "enName": "Kushiro Nemuro",
      "officeName": "釧路地方気象台",
      "chName": "釧路/根室地區",
      "zhName": "钏路/根室地区",
      "koName": "구시로·네무로 지방",
      "esName": "Región de Kushiro/Nemuro",
      "ptName": "Região de Kushiro/Nemuro",
      "thName": "ภูมิภาคคุชิโระ/เนมูโระ",
      "viName": "Vùng Kushiro/Nemuro",
      "inName": "Wilayah Kushiro/Nemuro",
      "tlName": "Rehiyon ng Kushiro/Nemuro",
      "moName": "Куширо/Немуро муж",
      "buName": "Kushiro/Nemuro ဒေသ",
      "khName": "តំបន់ Kushiro/Nemuro",
      "neName": "कुशिरो/नेमुरो क्षेत्र"
    },
    "class10": {
      "code": "014020",
      "name": "釧路地方",
      "enName": "Kushiro Region",
      "chName": "釧路地區",
      "zhName": "钏路地区",
      "koName": "구시로 지방",
      "esName": "Región de Kushiro",
      "ptName": "Região de Kushiro",
      "thName": "ภูมิภาคคุชิโระ",
      "viName": "vùng Kushiro",
      "inName": "wilayah Kushiro",
      "tlName": "Rehiyon ng Kushiro",
      "moName": "Куширо муж",
      "buName": "Kushiro ဒေသ",
      "khName": "តំបន់ Kushiro",
      "neName": "कुशिरो क्षेत्र"
    },
    "class15": {
      "code": "014022",
      "name": "釧路中部",
      "enName": "Middle Kushiro"
    },
    "class20": {
      "code": "0166700",
      "name": "鶴居村",
      "enName": "Tsurui Village",
      "kana": "つるいむら",
      "chName": "鹤居村",
      "zhName": "鶴居村",
      "koName": "쓰루이 촌",
      "esName": "Aldea de Tsurui",
      "ptName": "povoado de Tsurui",
      "thName": "หมู่บ้านสึรุอิ",
      "viName": "làng Tsurui",
      "inName": "desa Tsurui",
      "tlName": "nayon ng Tsurui",
      "moName": "Цүрүй тосгон",
      "buName": "ဆုရုရိ ကျေးရွာ",
      "khName": "ភូមិ ស៊ូរ៊ុយ",
      "neName": "त्सुरुई गाउँ"
    }
  },
  "0166800": {
    "office": {
      "code": "014100",
      "name": "釧路・根室地方",
      "enName": "Kushiro Nemuro",
      "officeName": "釧路地方気象台",
      "chName": "釧路/根室地區",
      "zhName": "钏路/根室地区",
      "koName": "구시로·네무로 지방",
      "esName": "Región de Kushiro/Nemuro",
      "ptName": "Região de Kushiro/Nemuro",
      "thName": "ภูมิภาคคุชิโระ/เนมูโระ",
      "viName": "Vùng Kushiro/Nemuro",
      "inName": "Wilayah Kushiro/Nemuro",
      "tlName": "Rehiyon ng Kushiro/Nemuro",
      "moName": "Куширо/Немуро муж",
      "buName": "Kushiro/Nemuro ဒေသ",
      "khName": "តំបន់ Kushiro/Nemuro",
      "neName": "कुशिरो/नेमुरो क्षेत्र"
    },
    "class10": {
      "code": "014020",
      "name": "釧路地方",
      "enName": "Kushiro Region",
      "chName": "釧路地區",
      "zhName": "钏路地区",
      "koName": "구시로 지방",
      "esName": "Región de Kushiro",
      "ptName": "Região de Kushiro",
      "thName": "ภูมิภาคคุชิโระ",
      "viName": "vùng Kushiro",
      "inName": "wilayah Kushiro",
      "tlName": "Rehiyon ng Kushiro",
      "moName": "Куширо муж",
      "buName": "Kushiro ဒေသ",
      "khName": "តំបន់ Kushiro",
      "neName": "कुशिरो क्षेत्र"
    },
    "class15": {
      "code": "014024",
      "name": "釧路南西部",
      "enName": "South-western Kushiro"
    },
    "class20": {
      "code": "0166800",
      "name": "白糠町",
      "enName": "Shiranuka Town",
      "kana": "しらぬかちょう",
      "chName": "白糠町",
      "zhName": "白糠町",
      "koName": "시라누카 정",
      "esName": "Pueblo de Shiranuka",
      "ptName": "bairro de Shiranuka",
      "thName": "เมืองชิรานุกะ",
      "viName": "thị trấn Shiranuka",
      "inName": "kota Shiranuka",
      "tlName": "bayan ng Shiranuka",
      "moName": "Ширанүка жижиг хот",
      "buName": "ရှီရာ့နုက မြို့နယ်",
      "khName": "ទីប្រជុំជន ស៊ីរ៉ានូកា",
      "neName": "शिरानुका नगर"
    }
  },
  "0169100": {
    "office": {
      "code": "014100",
      "name": "釧路・根室地方",
      "enName": "Kushiro Nemuro",
      "officeName": "釧路地方気象台",
      "chName": "釧路/根室地區",
      "zhName": "钏路/根室地区",
      "koName": "구시로·네무로 지방",
      "esName": "Región de Kushiro/Nemuro",
      "ptName": "Região de Kushiro/Nemuro",
      "thName": "ภูมิภาคคุชิโระ/เนมูโระ",
      "viName": "Vùng Kushiro/Nemuro",
      "inName": "Wilayah Kushiro/Nemuro",
      "tlName": "Rehiyon ng Kushiro/Nemuro",
      "moName": "Куширо/Немуро муж",
      "buName": "Kushiro/Nemuro ဒေသ",
      "khName": "តំបន់ Kushiro/Nemuro",
      "neName": "कुशिरो/नेमुरो क्षेत्र"
    },
    "class10": {
      "code": "014010",
      "name": "根室地方",
      "enName": "Nemuro Region",
      "chName": "根室地區",
      "zhName": "根室地区",
      "koName": "네무로 지방",
      "esName": "Región de Nemuro",
      "ptName": "Região de Nemuro",
      "thName": "ภูมิภาคเนมูโระ",
      "viName": "vùng Nemuro",
      "inName": "wilayah Nemuro",
      "tlName": "Rehiyon ng Nemuro",
      "moName": "Немуро бүс",
      "buName": "Nemuro ဒေသ",
      "khName": "តំបន់ Nemuro",
      "neName": "नेमुरो क्षेत्र"
    },
    "class15": {
      "code": "014012",
      "name": "根室中部",
      "enName": "Middle Central"
    },
    "class20": {
      "code": "0169100",
      "name": "別海町",
      "enName": "Betsukai Town",
      "kana": "べつかいちょう",
      "chName": "别海町",
      "zhName": "別海町",
      "koName": "베쓰카이 정",
      "esName": "Pueblo de Betsukai",
      "ptName": "bairro de Betsukai",
      "thName": "เมืองเบ็ทสึคาอิ",
      "viName": "thị trấn Betsukai",
      "inName": "kota Betsukai",
      "tlName": "bayan ng Betsukai",
      "moName": "Бэцүкай жижиг хот",
      "buName": "ဗယ်ဆုကာ့ယိ မြို့နယ်",
      "khName": "ទីប្រជុំជន បិតស៊ូកៃ",
      "neName": "बेत्सुकाई नगर"
    }
  },
  "0169200": {
    "office": {
      "code": "014100",
      "name": "釧路・根室地方",
      "enName": "Kushiro Nemuro",
      "officeName": "釧路地方気象台",
      "chName": "釧路/根室地區",
      "zhName": "钏路/根室地区",
      "koName": "구시로·네무로 지방",
      "esName": "Región de Kushiro/Nemuro",
      "ptName": "Região de Kushiro/Nemuro",
      "thName": "ภูมิภาคคุชิโระ/เนมูโระ",
      "viName": "Vùng Kushiro/Nemuro",
      "inName": "Wilayah Kushiro/Nemuro",
      "tlName": "Rehiyon ng Kushiro/Nemuro",
      "moName": "Куширо/Немуро муж",
      "buName": "Kushiro/Nemuro ဒေသ",
      "khName": "តំបន់ Kushiro/Nemuro",
      "neName": "कुशिरो/नेमुरो क्षेत्र"
    },
    "class10": {
      "code": "014010",
      "name": "根室地方",
      "enName": "Nemuro Region",
      "chName": "根室地區",
      "zhName": "根室地区",
      "koName": "네무로 지방",
      "esName": "Región de Nemuro",
      "ptName": "Região de Nemuro",
      "thName": "ภูมิภาคเนมูโระ",
      "viName": "vùng Nemuro",
      "inName": "wilayah Nemuro",
      "tlName": "Rehiyon ng Nemuro",
      "moName": "Немуро бүс",
      "buName": "Nemuro ဒေသ",
      "khName": "តំបន់ Nemuro",
      "neName": "नेमुरो क्षेत्र"
    },
    "class15": {
      "code": "014011",
      "name": "根室北部",
      "enName": "Northern Nemuro"
    },
    "class20": {
      "code": "0169200",
      "name": "中標津町",
      "enName": "Nakashibetsu Town",
      "kana": "なかしべつちょう",
      "chName": "中标津町",
      "zhName": "中標津町",
      "koName": "나카시베쓰 정",
      "esName": "Pueblo de Nakashibetsu",
      "ptName": "bairro de Nakashibetsu",
      "thName": "เมืองนากาชิเบ็ทสึ",
      "viName": "thị trấn Nakashibetsu",
      "inName": "kota Nakashibetsu",
      "tlName": "bayan ng Nakashibetsu",
      "moName": "Нaкашибэцү жижиг хот",
      "buName": "နာကာ့ရှိဗေ့စု မြို့နယ်",
      "khName": "ទីប្រជុំជន ណាកាស៊ីបេតស៊ូ",
      "neName": "नाकाशिबेत्सु नगर"
    }
  },
  "0169300": {
    "office": {
      "code": "014100",
      "name": "釧路・根室地方",
      "enName": "Kushiro Nemuro",
      "officeName": "釧路地方気象台",
      "chName": "釧路/根室地區",
      "zhName": "钏路/根室地区",
      "koName": "구시로·네무로 지방",
      "esName": "Región de Kushiro/Nemuro",
      "ptName": "Região de Kushiro/Nemuro",
      "thName": "ภูมิภาคคุชิโระ/เนมูโระ",
      "viName": "Vùng Kushiro/Nemuro",
      "inName": "Wilayah Kushiro/Nemuro",
      "tlName": "Rehiyon ng Kushiro/Nemuro",
      "moName": "Куширо/Немуро муж",
      "buName": "Kushiro/Nemuro ဒေသ",
      "khName": "តំបន់ Kushiro/Nemuro",
      "neName": "कुशिरो/नेमुरो क्षेत्र"
    },
    "class10": {
      "code": "014010",
      "name": "根室地方",
      "enName": "Nemuro Region",
      "chName": "根室地區",
      "zhName": "根室地区",
      "koName": "네무로 지방",
      "esName": "Región de Nemuro",
      "ptName": "Região de Nemuro",
      "thName": "ภูมิภาคเนมูโระ",
      "viName": "vùng Nemuro",
      "inName": "wilayah Nemuro",
      "tlName": "Rehiyon ng Nemuro",
      "moName": "Немуро бүс",
      "buName": "Nemuro ဒေသ",
      "khName": "តំបន់ Nemuro",
      "neName": "नेमुरो क्षेत्र"
    },
    "class15": {
      "code": "014011",
      "name": "根室北部",
      "enName": "Northern Nemuro"
    },
    "class20": {
      "code": "0169300",
      "name": "標津町",
      "enName": "Shibetsu Town",
      "kana": "しべつちょう",
      "chName": "标津町",
      "zhName": "標津町",
      "koName": "시베쓰 정",
      "esName": "Pueblo de Shibetsu",
      "ptName": "bairro de Shibetsu",
      "thName": "เมืองชิเบ็ทสึ",
      "viName": "thị trấn Shibetsu",
      "inName": "kota Shibetsu",
      "tlName": "bayan ng Shibetsu",
      "moName": "Шибэцү жижиг хот",
      "buName": "ရှိဗေ့စု မြို့နယ်",
      "khName": "ទីប្រជុំជន ស៊ីបេតស៊ូ",
      "neName": "शिबेत्सु नगर"
    }
  },
  "0169400": {
    "office": {
      "code": "014100",
      "name": "釧路・根室地方",
      "enName": "Kushiro Nemuro",
      "officeName": "釧路地方気象台",
      "chName": "釧路/根室地區",
      "zhName": "钏路/根室地区",
      "koName": "구시로·네무로 지방",
      "esName": "Región de Kushiro/Nemuro",
      "ptName": "Região de Kushiro/Nemuro",
      "thName": "ภูมิภาคคุชิโระ/เนมูโระ",
      "viName": "Vùng Kushiro/Nemuro",
      "inName": "Wilayah Kushiro/Nemuro",
      "tlName": "Rehiyon ng Kushiro/Nemuro",
      "moName": "Куширо/Немуро муж",
      "buName": "Kushiro/Nemuro ဒေသ",
      "khName": "តំបន់ Kushiro/Nemuro",
      "neName": "कुशिरो/नेमुरो क्षेत्र"
    },
    "class10": {
      "code": "014010",
      "name": "根室地方",
      "enName": "Nemuro Region",
      "chName": "根室地區",
      "zhName": "根室地区",
      "koName": "네무로 지방",
      "esName": "Región de Nemuro",
      "ptName": "Região de Nemuro",
      "thName": "ภูมิภาคเนมูโระ",
      "viName": "vùng Nemuro",
      "inName": "wilayah Nemuro",
      "tlName": "Rehiyon ng Nemuro",
      "moName": "Немуро бүс",
      "buName": "Nemuro ဒေသ",
      "khName": "តំបន់ Nemuro",
      "neName": "नेमुरो क्षेत्र"
    },
    "class15": {
      "code": "014011",
      "name": "根室北部",
      "enName": "Northern Nemuro"
    },
    "class20": {
      "code": "0169400",
      "name": "羅臼町",
      "enName": "Rausu Town",
      "kana": "らうすちょう",
      "chName": "罗臼町",
      "zhName": "羅臼町",
      "koName": "라우스 정",
      "esName": "Pueblo de Rausu",
      "ptName": "bairro de Rausu",
      "thName": "เมืองราอุสุ",
      "viName": "thị trấn Rausu",
      "inName": "kota Rausu",
      "tlName": "bayan ng Rausu",
      "moName": "Раүсү жижиг хот",
      "buName": "ရားဥဇု မြို့နယ်",
      "khName": "ទីប្រជុំជន រ៉ៅស៊ូ",
      "neName": "राउसु नगर"
    }
  },
  "0220100": {
    "office": {
      "code": "020000",
      "name": "青森県",
      "enName": "Aomori",
      "officeName": "青森地方気象台",
      "chName": "青森县",
      "zhName": "青森縣",
      "koName": "아오모리현",
      "esName": "Prefectura de Aomori",
      "ptName": "Província de Aomori",
      "thName": "จังหวัดอะโอโมริ",
      "viName": "Tỉnh Aomori",
      "inName": "Prefektur Aomori",
      "tlName": "Aomori Prefecture",
      "moName": "Аомори аймаг",
      "buName": "အာအိုးမိုးရိ ပြည်နယ်",
      "khName": "ខេត្ត អាអូម៉ូរី",
      "neName": "आओमोरी जिल्ला"
    },
    "class10": {
      "code": "020010",
      "name": "津軽",
      "enName": "Tsugaru",
      "chName": "青森县津轻北部",
      "zhName": "青森縣津軽北部",
      "koName": "아오모리 현 쓰가루 북부",
      "esName": "Tsugaru, Prefectura de Aomori",
      "ptName": "Tsugaru da Província de Aomori",
      "thName": "สึงารุ จังหวัดอะโอโมริ",
      "viName": "Tsugaru, tỉnh Aomori",
      "inName": "Tsugaru di Prefektur Aomori",
      "tlName": "Bahagi ng Tsugaru, Aomori Prefecture",
      "moName": "Аомори аймаг, Цүгарү",
      "buName": "ဆုဂယု၊ အအိုမိုယိစီရင်စု",
      "khName": "តំបន់ហ្សឹហ្គារឹ នៃខេត្តអាអូម៉ូរី",
      "neName": "आओमोरी जिल्ला, चुगारु भाग"
    },
    "class15": {
      "code": "020011",
      "name": "東青津軽",
      "enName": "Tosei Tsugaru"
    },
    "class20": {
      "code": "0220100",
      "name": "青森市",
      "enName": "Aomori City",
      "kana": "あおもりし",
      "chName": "青森市",
      "zhName": "青森市",
      "koName": "아오모리 시",
      "esName": "Ciudad de Aomori",
      "ptName": "cidade de Aomori",
      "thName": "เมืองอาโอโมริ",
      "viName": "thành phố Aomori",
      "inName": "kota Aomori",
      "tlName": "siyudad ng Aomori",
      "moName": "Аомори хот",
      "buName": "အာအိုမိုးရိ မြို့",
      "khName": "ទីក្រុង អាមូរី",
      "neName": "आओमोरी सहर"
    }
  },
  "0220200": {
    "office": {
      "code": "020000",
      "name": "青森県",
      "enName": "Aomori",
      "officeName": "青森地方気象台",
      "chName": "青森县",
      "zhName": "青森縣",
      "koName": "아오모리현",
      "esName": "Prefectura de Aomori",
      "ptName": "Província de Aomori",
      "thName": "จังหวัดอะโอโมริ",
      "viName": "Tỉnh Aomori",
      "inName": "Prefektur Aomori",
      "tlName": "Aomori Prefecture",
      "moName": "Аомори аймаг",
      "buName": "အာအိုးမိုးရိ ပြည်နယ်",
      "khName": "ខេត្ត អាអូម៉ូរី",
      "neName": "आओमोरी जिल्ला"
    },
    "class10": {
      "code": "020010",
      "name": "津軽",
      "enName": "Tsugaru",
      "chName": "青森县津轻北部",
      "zhName": "青森縣津軽北部",
      "koName": "아오모리 현 쓰가루 북부",
      "esName": "Tsugaru, Prefectura de Aomori",
      "ptName": "Tsugaru da Província de Aomori",
      "thName": "สึงารุ จังหวัดอะโอโมริ",
      "viName": "Tsugaru, tỉnh Aomori",
      "inName": "Tsugaru di Prefektur Aomori",
      "tlName": "Bahagi ng Tsugaru, Aomori Prefecture",
      "moName": "Аомори аймаг, Цүгарү",
      "buName": "ဆုဂယု၊ အအိုမိုယိစီရင်စု",
      "khName": "តំបន់ហ្សឹហ្គារឹ នៃខេត្តអាអូម៉ូរី",
      "neName": "आओमोरी जिल्ला, चुगारु भाग"
    },
    "class15": {
      "code": "020014",
      "name": "中南津軽",
      "enName": "Chunan Tsugaru"
    },
    "class20": {
      "code": "0220200",
      "name": "弘前市",
      "enName": "Hirosaki City",
      "kana": "ひろさきし",
      "chName": "弘前市",
      "zhName": "弘前市",
      "koName": "히로사키 시",
      "esName": "Ciudad de Hirosaki",
      "ptName": "cidade de Hirosaki",
      "thName": "เมืองฮิโรซากิ",
      "viName": "thành phố Hirosaki",
      "inName": "kota Hirosaki",
      "tlName": "siyudad ng Hirosaki",
      "moName": "Хиросаки хот",
      "buName": "ဟီရိုးဆာ့ကိ မြို့",
      "khName": "ទីក្រុង ហ៊ីរ៉ូសាគី",
      "neName": "हिरोसाकी सहर"
    }
  },
  "0220300": {
    "office": {
      "code": "020000",
      "name": "青森県",
      "enName": "Aomori",
      "officeName": "青森地方気象台",
      "chName": "青森县",
      "zhName": "青森縣",
      "koName": "아오모리현",
      "esName": "Prefectura de Aomori",
      "ptName": "Província de Aomori",
      "thName": "จังหวัดอะโอโมริ",
      "viName": "Tỉnh Aomori",
      "inName": "Prefektur Aomori",
      "tlName": "Aomori Prefecture",
      "moName": "Аомори аймаг",
      "buName": "အာအိုးမိုးရိ ပြည်နယ်",
      "khName": "ខេត្ត អាអូម៉ូរី",
      "neName": "आओमोरी जिल्ला"
    },
    "class10": {
      "code": "020030",
      "name": "三八上北",
      "enName": "Sanpachi Kamikita",
      "chName": "青森县三八上北地方",
      "zhName": "青森縣三八上北地方",
      "koName": "아오모리 현 산파치 카미 키타 지방",
      "esName": "Región de Sanpachi-Kamikita, Prefectura de Aomori",
      "ptName": "Região de Sanpachi-Kamikita da Província de Aomori",
      "thName": "ท้องถิ่นซัมปาจิ คามิกิตะ จังหวัดอะโอโมริ",
      "viName": "Vùng Sanpachi Kamikita, tỉnh Aomori",
      "inName": "Daerah Sanpachi Kamikita di Prefektur Aomori",
      "tlName": "Rehiyon ng Sanpachi-Kamikita sa Aomori Prefecture",
      "moName": "Аомори аймаг, Санпачи-Камикита",
      "buName": "ဆန်းပချိ ခမိခိတဒေသ၊အအိုမိုယိစီရင်စု",
      "khName": "តំបន់សានប៉ាជីកាមីគីតាក់នៃខេត្តអាអូម៉ូរី",
      "neName": "आओमोरी जिल्ला, सान्पाची खामिकिता क्षेत्र"
    },
    "class15": {
      "code": "020031",
      "name": "三八",
      "enName": "Sanpachi"
    },
    "class20": {
      "code": "0220300",
      "name": "八戸市",
      "enName": "Hachinohe City",
      "kana": "はちのへし",
      "chName": "八户市",
      "zhName": "八戶市",
      "koName": "하치노헤 시",
      "esName": "Ciudad de Hachinohe",
      "ptName": "cidade de Hachinohe",
      "thName": "เมืองฮะจิโนะเฮะ",
      "viName": "thành phố Hachinohe",
      "inName": "kota Hachinohe",
      "tlName": "siyudad ng Hachinohe",
      "moName": "Хачинохэ хот",
      "buName": "ဟာကျီနော့ဟဲ့ မြို့",
      "khName": "ទីក្រុង ហាជីណូហេ",
      "neName": "हाचिनोहे सहर"
    }
  },
  "0220400": {
    "office": {
      "code": "020000",
      "name": "青森県",
      "enName": "Aomori",
      "officeName": "青森地方気象台",
      "chName": "青森县",
      "zhName": "青森縣",
      "koName": "아오모리현",
      "esName": "Prefectura de Aomori",
      "ptName": "Província de Aomori",
      "thName": "จังหวัดอะโอโมริ",
      "viName": "Tỉnh Aomori",
      "inName": "Prefektur Aomori",
      "tlName": "Aomori Prefecture",
      "moName": "Аомори аймаг",
      "buName": "အာအိုးမိုးရိ ပြည်နယ်",
      "khName": "ខេត្ត អាអូម៉ូរី",
      "neName": "आओमोरी जिल्ला"
    },
    "class10": {
      "code": "020010",
      "name": "津軽",
      "enName": "Tsugaru",
      "chName": "青森县津轻北部",
      "zhName": "青森縣津軽北部",
      "koName": "아오모리 현 쓰가루 북부",
      "esName": "Tsugaru, Prefectura de Aomori",
      "ptName": "Tsugaru da Província de Aomori",
      "thName": "สึงารุ จังหวัดอะโอโมริ",
      "viName": "Tsugaru, tỉnh Aomori",
      "inName": "Tsugaru di Prefektur Aomori",
      "tlName": "Bahagi ng Tsugaru, Aomori Prefecture",
      "moName": "Аомори аймаг, Цүгарү",
      "buName": "ဆုဂယု၊ အအိုမိုယိစီရင်စု",
      "khName": "តំបន់ហ្សឹហ្គារឹ នៃខេត្តអាអូម៉ូរី",
      "neName": "आओमोरी जिल्ला, चुगारु भाग"
    },
    "class15": {
      "code": "020014",
      "name": "中南津軽",
      "enName": "Chunan Tsugaru"
    },
    "class20": {
      "code": "0220400",
      "name": "黒石市",
      "enName": "Kuroishi City",
      "kana": "くろいしし",
      "chName": "黑石市",
      "zhName": "黑石市",
      "koName": "구로이시 시",
      "esName": "Ciudad de Kuroishi",
      "ptName": "cidade de Kuroishi",
      "thName": "เมืองคุโรอิชิ",
      "viName": "thành phố Kuroishi",
      "inName": "kota Kuroishi",
      "tlName": "siyudad ng Kuroishi",
      "moName": "Күройши хот",
      "buName": "ကူရိုးအိရှိ မြို့",
      "khName": "ទីក្រុង កូរ៉ូអ៊ីស៊ី",
      "neName": "कुरोइशी सहर"
    }
  },
  "0220500": {
    "office": {
      "code": "020000",
      "name": "青森県",
      "enName": "Aomori",
      "officeName": "青森地方気象台",
      "chName": "青森县",
      "zhName": "青森縣",
      "koName": "아오모리현",
      "esName": "Prefectura de Aomori",
      "ptName": "Província de Aomori",
      "thName": "จังหวัดอะโอโมริ",
      "viName": "Tỉnh Aomori",
      "inName": "Prefektur Aomori",
      "tlName": "Aomori Prefecture",
      "moName": "Аомори аймаг",
      "buName": "အာအိုးမိုးရိ ပြည်နယ်",
      "khName": "ខេត្ត អាអូម៉ូរី",
      "neName": "आओमोरी जिल्ला"
    },
    "class10": {
      "code": "020010",
      "name": "津軽",
      "enName": "Tsugaru",
      "chName": "青森县津轻北部",
      "zhName": "青森縣津軽北部",
      "koName": "아오모리 현 쓰가루 북부",
      "esName": "Tsugaru, Prefectura de Aomori",
      "ptName": "Tsugaru da Província de Aomori",
      "thName": "สึงารุ จังหวัดอะโอโมริ",
      "viName": "Tsugaru, tỉnh Aomori",
      "inName": "Tsugaru di Prefektur Aomori",
      "tlName": "Bahagi ng Tsugaru, Aomori Prefecture",
      "moName": "Аомори аймаг, Цүгарү",
      "buName": "ဆုဂယု၊ အအိုမိုယိစီရင်စု",
      "khName": "តំបន់ហ្សឹហ្គារឹ នៃខេត្តអាអូម៉ូរី",
      "neName": "आओमोरी जिल्ला, चुगारु भाग"
    },
    "class15": {
      "code": "020012",
      "name": "北五津軽",
      "enName": "Kitago Tsugaru"
    },
    "class20": {
      "code": "0220500",
      "name": "五所川原市",
      "enName": "Goshogawara City",
      "kana": "ごしょがわらし",
      "chName": "五所川原市",
      "zhName": "五所川原市",
      "koName": "고쇼가와라 시",
      "esName": "Ciudad de Goshogawara",
      "ptName": "cidade de Goshogawara",
      "thName": "เมืองโกโชงาวาระ",
      "viName": "thành phố Goshogawara",
      "inName": "kota Goshogawara",
      "tlName": "siyudad ng Goshogawara",
      "moName": "Гошогавара хот",
      "buName": "ဂိုရှိုဂါဝါရာ မြို့",
      "khName": "ទីក្រុង កូសូកាវ៉ារ៉ា",
      "neName": "गोशोगावारा सहर"
    }
  },
  "0220600": {
    "office": {
      "code": "020000",
      "name": "青森県",
      "enName": "Aomori",
      "officeName": "青森地方気象台",
      "chName": "青森县",
      "zhName": "青森縣",
      "koName": "아오모리현",
      "esName": "Prefectura de Aomori",
      "ptName": "Província de Aomori",
      "thName": "จังหวัดอะโอโมริ",
      "viName": "Tỉnh Aomori",
      "inName": "Prefektur Aomori",
      "tlName": "Aomori Prefecture",
      "moName": "Аомори аймаг",
      "buName": "အာအိုးမိုးရိ ပြည်နယ်",
      "khName": "ខេត្ត អាអូម៉ូរី",
      "neName": "आओमोरी जिल्ला"
    },
    "class10": {
      "code": "020030",
      "name": "三八上北",
      "enName": "Sanpachi Kamikita",
      "chName": "青森县三八上北地方",
      "zhName": "青森縣三八上北地方",
      "koName": "아오모리 현 산파치 카미 키타 지방",
      "esName": "Región de Sanpachi-Kamikita, Prefectura de Aomori",
      "ptName": "Região de Sanpachi-Kamikita da Província de Aomori",
      "thName": "ท้องถิ่นซัมปาจิ คามิกิตะ จังหวัดอะโอโมริ",
      "viName": "Vùng Sanpachi Kamikita, tỉnh Aomori",
      "inName": "Daerah Sanpachi Kamikita di Prefektur Aomori",
      "tlName": "Rehiyon ng Sanpachi-Kamikita sa Aomori Prefecture",
      "moName": "Аомори аймаг, Санпачи-Камикита",
      "buName": "ဆန်းပချိ ခမိခိတဒေသ၊အအိုမိုယိစီရင်စု",
      "khName": "តំបន់សានប៉ាជីកាមីគីតាក់នៃខេត្តអាអូម៉ូរី",
      "neName": "आओमोरी जिल्ला, सान्पाची खामिकिता क्षेत्र"
    },
    "class15": {
      "code": "020032",
      "name": "上北",
      "enName": "Kamikita"
    },
    "class20": {
      "code": "0220600",
      "name": "十和田市",
      "enName": "Towada City",
      "kana": "とわだし",
      "chName": "十和田市",
      "zhName": "十和田市",
      "koName": "도와다 시",
      "esName": "Ciudad de Towada",
      "ptName": "cidade de Towada",
      "thName": "เมืองโทวาดะ",
      "viName": "thành phố Towada",
      "inName": "kota Towada",
      "tlName": "siyudad ng Towada",
      "moName": "Товада хот",
      "buName": "တိုဝါ့ဒ မြို့",
      "khName": "ទីក្រុង តូវ៉ាដា",
      "neName": "तोवादा सहर"
    }
  },
  "0220700": {
    "office": {
      "code": "020000",
      "name": "青森県",
      "enName": "Aomori",
      "officeName": "青森地方気象台",
      "chName": "青森县",
      "zhName": "青森縣",
      "koName": "아오모리현",
      "esName": "Prefectura de Aomori",
      "ptName": "Província de Aomori",
      "thName": "จังหวัดอะโอโมริ",
      "viName": "Tỉnh Aomori",
      "inName": "Prefektur Aomori",
      "tlName": "Aomori Prefecture",
      "moName": "Аомори аймаг",
      "buName": "အာအိုးမိုးရိ ပြည်နယ်",
      "khName": "ខេត្ត អាអូម៉ូរី",
      "neName": "आओमोरी जिल्ला"
    },
    "class10": {
      "code": "020030",
      "name": "三八上北",
      "enName": "Sanpachi Kamikita",
      "chName": "青森县三八上北地方",
      "zhName": "青森縣三八上北地方",
      "koName": "아오모리 현 산파치 카미 키타 지방",
      "esName": "Región de Sanpachi-Kamikita, Prefectura de Aomori",
      "ptName": "Região de Sanpachi-Kamikita da Província de Aomori",
      "thName": "ท้องถิ่นซัมปาจิ คามิกิตะ จังหวัดอะโอโมริ",
      "viName": "Vùng Sanpachi Kamikita, tỉnh Aomori",
      "inName": "Daerah Sanpachi Kamikita di Prefektur Aomori",
      "tlName": "Rehiyon ng Sanpachi-Kamikita sa Aomori Prefecture",
      "moName": "Аомори аймаг, Санпачи-Камикита",
      "buName": "ဆန်းပချိ ခမိခိတဒေသ၊အအိုမိုယိစီရင်စု",
      "khName": "តំបន់សានប៉ាជីកាមីគីតាក់នៃខេត្តអាអូម៉ូរី",
      "neName": "आओमोरी जिल्ला, सान्पाची खामिकिता क्षेत्र"
    },
    "class15": {
      "code": "020031",
      "name": "三八",
      "enName": "Sanpachi"
    },
    "class20": {
      "code": "0220700",
      "name": "三沢市",
      "enName": "Misawa City",
      "kana": "みさわし",
      "chName": "三泽市",
      "zhName": "三澤市",
      "koName": "미사와 시",
      "esName": "Ciudad de Misawa",
      "ptName": "cidade de Misawa",
      "thName": "เมืองมิซาวะ",
      "viName": "thành phố Misawa",
      "inName": "kota Misawa",
      "tlName": "siyudad ng Misawa",
      "moName": "Мисава хот",
      "buName": "မီဆာ့ဝ မြို့",
      "khName": "ទីក្រុង មីសាវ៉ា",
      "neName": "मिसावा सहर"
    }
  },
  "0220800": {
    "office": {
      "code": "020000",
      "name": "青森県",
      "enName": "Aomori",
      "officeName": "青森地方気象台",
      "chName": "青森县",
      "zhName": "青森縣",
      "koName": "아오모리현",
      "esName": "Prefectura de Aomori",
      "ptName": "Província de Aomori",
      "thName": "จังหวัดอะโอโมริ",
      "viName": "Tỉnh Aomori",
      "inName": "Prefektur Aomori",
      "tlName": "Aomori Prefecture",
      "moName": "Аомори аймаг",
      "buName": "အာအိုးမိုးရိ ပြည်နယ်",
      "khName": "ខេត្ត អាអូម៉ូរី",
      "neName": "आओमोरी जिल्ला"
    },
    "class10": {
      "code": "020020",
      "name": "下北",
      "enName": "Shimokita",
      "chName": "青森县下北地方",
      "zhName": "青森縣下北地方",
      "koName": "아오모리 현 시모키타 지방",
      "esName": "Región Shimokita, Prefectura de Aomori",
      "ptName": "Região de Shimokita da Província de Aomori",
      "thName": "ท้องถิ่นชิโมะคิตะ จังหวัดอะโอโมริ",
      "viName": "Vùng Shimokita, tỉnh Aomori",
      "inName": "Daerah Shimokita di Prefektur Aomori",
      "tlName": "Rehiyon ng Shimokita sa Aomori Prefecture",
      "moName": "Аомори аймаг, Шимокита",
      "buName": "ရှိမိုခိတဒေသ၊ အအိုမိုယိစီရင်စု",
      "khName": "តំបន់ស៊ីម៉ូគីតាក់ខេត្តអាអូម៉ូរី",
      "neName": "आओमोरी जिल्ला, सिमोकिता क्षेत्र"
    },
    "class15": {
      "code": "020020",
      "name": "下北",
      "enName": "Shimokita"
    },
    "class20": {
      "code": "0220800",
      "name": "むつ市",
      "enName": "Mutsu City",
      "kana": "むつし",
      "chName": "陆奥市",
      "zhName": "陸奧市",
      "koName": "무쓰 시",
      "esName": "Ciudad de Mutsu",
      "ptName": "cidade de Mutsu",
      "thName": "เมืองมุทสึ",
      "viName": "thành phố Mutsu",
      "inName": "kota Mutsu",
      "tlName": "siyudad ng Mutsu",
      "moName": "Мүцү хот",
      "buName": "မယ်စု မြို့",
      "khName": "ទីក្រុង មុតស៊ុ",
      "neName": "मुत्सु सहर"
    }
  },
  "0220900": {
    "office": {
      "code": "020000",
      "name": "青森県",
      "enName": "Aomori",
      "officeName": "青森地方気象台",
      "chName": "青森县",
      "zhName": "青森縣",
      "koName": "아오모리현",
      "esName": "Prefectura de Aomori",
      "ptName": "Província de Aomori",
      "thName": "จังหวัดอะโอโมริ",
      "viName": "Tỉnh Aomori",
      "inName": "Prefektur Aomori",
      "tlName": "Aomori Prefecture",
      "moName": "Аомори аймаг",
      "buName": "အာအိုးမိုးရိ ပြည်နယ်",
      "khName": "ខេត្ត អាអូម៉ូរី",
      "neName": "आओमोरी जिल्ला"
    },
    "class10": {
      "code": "020010",
      "name": "津軽",
      "enName": "Tsugaru",
      "chName": "青森县津轻北部",
      "zhName": "青森縣津軽北部",
      "koName": "아오모리 현 쓰가루 북부",
      "esName": "Tsugaru, Prefectura de Aomori",
      "ptName": "Tsugaru da Província de Aomori",
      "thName": "สึงารุ จังหวัดอะโอโมริ",
      "viName": "Tsugaru, tỉnh Aomori",
      "inName": "Tsugaru di Prefektur Aomori",
      "tlName": "Bahagi ng Tsugaru, Aomori Prefecture",
      "moName": "Аомори аймаг, Цүгарү",
      "buName": "ဆုဂယု၊ အအိုမိုယိစီရင်စု",
      "khName": "តំបន់ហ្សឹហ្គារឹ នៃខេត្តអាអូម៉ូរី",
      "neName": "आओमोरी जिल्ला, चुगारु भाग"
    },
    "class15": {
      "code": "020013",
      "name": "西津軽",
      "enName": "Nishitsugaru"
    },
    "class20": {
      "code": "0220900",
      "name": "つがる市",
      "enName": "Tsugaru City",
      "kana": "つがるし",
      "chName": "津轻市",
      "zhName": "津輕市",
      "koName": "쓰가루 시",
      "esName": "Ciudad de Tsugaru",
      "ptName": "cidade de Tsugaru",
      "thName": "เมืองสึงารุ",
      "viName": "thành phố Tsugaru",
      "inName": "kota Tsugaru",
      "tlName": "siyudad ng Tsugaru",
      "moName": "Цүгарү хот",
      "buName": "ဆူဂါ့ရု မြို့",
      "khName": "ទីក្រុង ស៊ូការូ",
      "neName": "त्सुगारु सहर"
    }
  },
  "0221000": {
    "office": {
      "code": "020000",
      "name": "青森県",
      "enName": "Aomori",
      "officeName": "青森地方気象台",
      "chName": "青森县",
      "zhName": "青森縣",
      "koName": "아오모리현",
      "esName": "Prefectura de Aomori",
      "ptName": "Província de Aomori",
      "thName": "จังหวัดอะโอโมริ",
      "viName": "Tỉnh Aomori",
      "inName": "Prefektur Aomori",
      "tlName": "Aomori Prefecture",
      "moName": "Аомори аймаг",
      "buName": "အာအိုးမိုးရိ ပြည်နယ်",
      "khName": "ខេត្ត អាអូម៉ូរី",
      "neName": "आओमोरी जिल्ला"
    },
    "class10": {
      "code": "020010",
      "name": "津軽",
      "enName": "Tsugaru",
      "chName": "青森县津轻北部",
      "zhName": "青森縣津軽北部",
      "koName": "아오모리 현 쓰가루 북부",
      "esName": "Tsugaru, Prefectura de Aomori",
      "ptName": "Tsugaru da Província de Aomori",
      "thName": "สึงารุ จังหวัดอะโอโมริ",
      "viName": "Tsugaru, tỉnh Aomori",
      "inName": "Tsugaru di Prefektur Aomori",
      "tlName": "Bahagi ng Tsugaru, Aomori Prefecture",
      "moName": "Аомори аймаг, Цүгарү",
      "buName": "ဆုဂယု၊ အအိုမိုယိစီရင်စု",
      "khName": "តំបន់ហ្សឹហ្គារឹ នៃខេត្តអាអូម៉ូរី",
      "neName": "आओमोरी जिल्ला, चुगारु भाग"
    },
    "class15": {
      "code": "020014",
      "name": "中南津軽",
      "enName": "Chunan Tsugaru"
    },
    "class20": {
      "code": "0221000",
      "name": "平川市",
      "enName": "Hirakawa City",
      "kana": "ひらかわし",
      "chName": "平川市",
      "zhName": "平川市",
      "koName": "히라카와 시",
      "esName": "Ciudad de Hirakawa",
      "ptName": "cidade de Hirakawa",
      "thName": "เมืองฮิราคาวะ",
      "viName": "thành phố Hirakawa",
      "inName": "kota Hirakawa",
      "tlName": "siyudad ng Hirakawa",
      "moName": "Хиракава хот",
      "buName": "ဟီရကာ့ဝ မြို့",
      "khName": "ទីក្រុង ហ៊ីរ៉ាកាវ៉ា",
      "neName": "हिराकावा सहर"
    }
  },
  "0230100": {
    "office": {
      "code": "020000",
      "name": "青森県",
      "enName": "Aomori",
      "officeName": "青森地方気象台",
      "chName": "青森县",
      "zhName": "青森縣",
      "koName": "아오모리현",
      "esName": "Prefectura de Aomori",
      "ptName": "Província de Aomori",
      "thName": "จังหวัดอะโอโมริ",
      "viName": "Tỉnh Aomori",
      "inName": "Prefektur Aomori",
      "tlName": "Aomori Prefecture",
      "moName": "Аомори аймаг",
      "buName": "အာအိုးမိုးရိ ပြည်နယ်",
      "khName": "ខេត្ត អាអូម៉ូរី",
      "neName": "आओमोरी जिल्ला"
    },
    "class10": {
      "code": "020010",
      "name": "津軽",
      "enName": "Tsugaru",
      "chName": "青森县津轻北部",
      "zhName": "青森縣津軽北部",
      "koName": "아오모리 현 쓰가루 북부",
      "esName": "Tsugaru, Prefectura de Aomori",
      "ptName": "Tsugaru da Província de Aomori",
      "thName": "สึงารุ จังหวัดอะโอโมริ",
      "viName": "Tsugaru, tỉnh Aomori",
      "inName": "Tsugaru di Prefektur Aomori",
      "tlName": "Bahagi ng Tsugaru, Aomori Prefecture",
      "moName": "Аомори аймаг, Цүгарү",
      "buName": "ဆုဂယု၊ အအိုမိုယိစီရင်စု",
      "khName": "តំបន់ហ្សឹហ្គារឹ នៃខេត្តអាអូម៉ូរី",
      "neName": "आओमोरी जिल्ला, चुगारु भाग"
    },
    "class15": {
      "code": "020011",
      "name": "東青津軽",
      "enName": "Tosei Tsugaru"
    },
    "class20": {
      "code": "0230100",
      "name": "平内町",
      "enName": "Hiranai Town",
      "kana": "ひらないまち",
      "chName": "平内町",
      "zhName": "平內町",
      "koName": "히라나이 정",
      "esName": "Pueblo de Hiranai",
      "ptName": "bairro de Hiranai",
      "thName": "เมืองฮิรานาอิ",
      "viName": "thị trấn Hiranai",
      "inName": "kota Hiranai",
      "tlName": "bayan ng Hiranai",
      "moName": "Хиранaй жижиг хот",
      "buName": "ဟီရာနာ့ယိ မြို့နယ်",
      "khName": "ទីប្រជុំជន ហ៊ីរ៉ាណៃ",
      "neName": "हिरानाई नगर"
    }
  },
  "0230300": {
    "office": {
      "code": "020000",
      "name": "青森県",
      "enName": "Aomori",
      "officeName": "青森地方気象台",
      "chName": "青森县",
      "zhName": "青森縣",
      "koName": "아오모리현",
      "esName": "Prefectura de Aomori",
      "ptName": "Província de Aomori",
      "thName": "จังหวัดอะโอโมริ",
      "viName": "Tỉnh Aomori",
      "inName": "Prefektur Aomori",
      "tlName": "Aomori Prefecture",
      "moName": "Аомори аймаг",
      "buName": "အာအိုးမိုးရိ ပြည်နယ်",
      "khName": "ខេត្ត អាអូម៉ូរី",
      "neName": "आओमोरी जिल्ला"
    },
    "class10": {
      "code": "020010",
      "name": "津軽",
      "enName": "Tsugaru",
      "chName": "青森县津轻北部",
      "zhName": "青森縣津軽北部",
      "koName": "아오모리 현 쓰가루 북부",
      "esName": "Tsugaru, Prefectura de Aomori",
      "ptName": "Tsugaru da Província de Aomori",
      "thName": "สึงารุ จังหวัดอะโอโมริ",
      "viName": "Tsugaru, tỉnh Aomori",
      "inName": "Tsugaru di Prefektur Aomori",
      "tlName": "Bahagi ng Tsugaru, Aomori Prefecture",
      "moName": "Аомори аймаг, Цүгарү",
      "buName": "ဆုဂယု၊ အအိုမိုယိစီရင်စု",
      "khName": "តំបន់ហ្សឹហ្គារឹ នៃខេត្តអាអូម៉ូរី",
      "neName": "आओमोरी जिल्ला, चुगारु भाग"
    },
    "class15": {
      "code": "020011",
      "name": "東青津軽",
      "enName": "Tosei Tsugaru"
    },
    "class20": {
      "code": "0230300",
      "name": "今別町",
      "enName": "Imabetsu Town",
      "kana": "いまべつまち",
      "chName": "今别町",
      "zhName": "今別町",
      "koName": "이마베쓰 정",
      "esName": "Pueblo de Imabetsu",
      "ptName": "bairro de Imabetsu",
      "thName": "เมืองอิมาเบ็ทสึ",
      "viName": "thị trấn Imabetsu",
      "inName": "kota Imabetsu",
      "tlName": "bayan ng Imabetsu",
      "moName": "Имaбэцү жижиг хот",
      "buName": "အီမာဗေ့စု မြို့နယ်",
      "khName": "ទីប្រជុំជន អ៊ីម៉ាបេតស៊ូ",
      "neName": "इमाबेत्सु नगर"
    }
  },
  "0230400": {
    "office": {
      "code": "020000",
      "name": "青森県",
      "enName": "Aomori",
      "officeName": "青森地方気象台",
      "chName": "青森县",
      "zhName": "青森縣",
      "koName": "아오모리현",
      "esName": "Prefectura de Aomori",
      "ptName": "Província de Aomori",
      "thName": "จังหวัดอะโอโมริ",
      "viName": "Tỉnh Aomori",
      "inName": "Prefektur Aomori",
      "tlName": "Aomori Prefecture",
      "moName": "Аомори аймаг",
      "buName": "အာအိုးမိုးရိ ပြည်နယ်",
      "khName": "ខេត្ត អាអូម៉ូរី",
      "neName": "आओमोरी जिल्ला"
    },
    "class10": {
      "code": "020010",
      "name": "津軽",
      "enName": "Tsugaru",
      "chName": "青森县津轻北部",
      "zhName": "青森縣津軽北部",
      "koName": "아오모리 현 쓰가루 북부",
      "esName": "Tsugaru, Prefectura de Aomori",
      "ptName": "Tsugaru da Província de Aomori",
      "thName": "สึงารุ จังหวัดอะโอโมริ",
      "viName": "Tsugaru, tỉnh Aomori",
      "inName": "Tsugaru di Prefektur Aomori",
      "tlName": "Bahagi ng Tsugaru, Aomori Prefecture",
      "moName": "Аомори аймаг, Цүгарү",
      "buName": "ဆုဂယု၊ အအိုမိုယိစီရင်စု",
      "khName": "តំបន់ហ្សឹហ្គារឹ នៃខេត្តអាអូម៉ូរី",
      "neName": "आओमोरी जिल्ला, चुगारु भाग"
    },
    "class15": {
      "code": "020011",
      "name": "東青津軽",
      "enName": "Tosei Tsugaru"
    },
    "class20": {
      "code": "0230400",
      "name": "蓬田村",
      "enName": "Yomogita Village",
      "kana": "よもぎたむら",
      "chName": "蓬田村",
      "zhName": "蓬田村",
      "koName": "요모기타 촌",
      "esName": "Aldea de Yomogita",
      "ptName": "povoado de Yomogita",
      "thName": "หมู่บ้านโยโมงิตะ",
      "viName": "làng Yomogita",
      "inName": "desa Yomogita",
      "tlName": "nayon ng Yomogita",
      "moName": "Ёомогита тосгон",
      "buName": "ယိုမိုးဂိတ ကျေးရွာ",
      "khName": "ភូមិ យ៉ូម៉ូជីតា",
      "neName": "योमोगिता गाउँ"
    }
  },
  "0230700": {
    "office": {
      "code": "020000",
      "name": "青森県",
      "enName": "Aomori",
      "officeName": "青森地方気象台",
      "chName": "青森县",
      "zhName": "青森縣",
      "koName": "아오모리현",
      "esName": "Prefectura de Aomori",
      "ptName": "Província de Aomori",
      "thName": "จังหวัดอะโอโมริ",
      "viName": "Tỉnh Aomori",
      "inName": "Prefektur Aomori",
      "tlName": "Aomori Prefecture",
      "moName": "Аомори аймаг",
      "buName": "အာအိုးမိုးရိ ပြည်နယ်",
      "khName": "ខេត្ត អាអូម៉ូរី",
      "neName": "आओमोरी जिल्ला"
    },
    "class10": {
      "code": "020010",
      "name": "津軽",
      "enName": "Tsugaru",
      "chName": "青森县津轻北部",
      "zhName": "青森縣津軽北部",
      "koName": "아오모리 현 쓰가루 북부",
      "esName": "Tsugaru, Prefectura de Aomori",
      "ptName": "Tsugaru da Província de Aomori",
      "thName": "สึงารุ จังหวัดอะโอโมริ",
      "viName": "Tsugaru, tỉnh Aomori",
      "inName": "Tsugaru di Prefektur Aomori",
      "tlName": "Bahagi ng Tsugaru, Aomori Prefecture",
      "moName": "Аомори аймаг, Цүгарү",
      "buName": "ဆုဂယု၊ အအိုမိုယိစီရင်စု",
      "khName": "តំបន់ហ្សឹហ្គារឹ នៃខេត្តអាអូម៉ូរី",
      "neName": "आओमोरी जिल्ला, चुगारु भाग"
    },
    "class15": {
      "code": "020011",
      "name": "東青津軽",
      "enName": "Tosei Tsugaru"
    },
    "class20": {
      "code": "0230700",
      "name": "外ヶ浜町",
      "enName": "Sotogahama Town",
      "kana": "そとがはままち",
      "chName": "外滨町",
      "zhName": "外濱町",
      "koName": "소토가하마 정",
      "esName": "Pueblo de Sotogahama",
      "ptName": "bairro de Sotogahama",
      "thName": "เมืองโซโตะงะฮามะ",
      "viName": "thị trấn Sotogahama",
      "inName": "kota Sotogahama",
      "tlName": "bayan ng Sotogahama",
      "moName": "Сотогaхaмa жижиг хот",
      "buName": "ဆိုတိုဂါဟာ့မ မြို့နယ်",
      "khName": "ទីប្រជុំជន សូតូហ្កាហាម៉ា",
      "neName": "सोतोगाहामा नगर"
    }
  },
  "0232100": {
    "office": {
      "code": "020000",
      "name": "青森県",
      "enName": "Aomori",
      "officeName": "青森地方気象台",
      "chName": "青森县",
      "zhName": "青森縣",
      "koName": "아오모리현",
      "esName": "Prefectura de Aomori",
      "ptName": "Província de Aomori",
      "thName": "จังหวัดอะโอโมริ",
      "viName": "Tỉnh Aomori",
      "inName": "Prefektur Aomori",
      "tlName": "Aomori Prefecture",
      "moName": "Аомори аймаг",
      "buName": "အာအိုးမိုးရိ ပြည်နယ်",
      "khName": "ខេត្ត អាអូម៉ូរី",
      "neName": "आओमोरी जिल्ला"
    },
    "class10": {
      "code": "020010",
      "name": "津軽",
      "enName": "Tsugaru",
      "chName": "青森县津轻北部",
      "zhName": "青森縣津軽北部",
      "koName": "아오모리 현 쓰가루 북부",
      "esName": "Tsugaru, Prefectura de Aomori",
      "ptName": "Tsugaru da Província de Aomori",
      "thName": "สึงารุ จังหวัดอะโอโมริ",
      "viName": "Tsugaru, tỉnh Aomori",
      "inName": "Tsugaru di Prefektur Aomori",
      "tlName": "Bahagi ng Tsugaru, Aomori Prefecture",
      "moName": "Аомори аймаг, Цүгарү",
      "buName": "ဆုဂယု၊ အအိုမိုယိစီရင်စု",
      "khName": "តំបន់ហ្សឹហ្គារឹ នៃខេត្តអាអូម៉ូរី",
      "neName": "आओमोरी जिल्ला, चुगारु भाग"
    },
    "class15": {
      "code": "020013",
      "name": "西津軽",
      "enName": "Nishitsugaru"
    },
    "class20": {
      "code": "0232100",
      "name": "鰺ヶ沢町",
      "enName": "Ajigasawa Town",
      "kana": "あじがさわまち",
      "chName": "鲹泽町",
      "zhName": "鰺澤町",
      "koName": "아지가사와 정",
      "esName": "Pueblo de Ajigasawa",
      "ptName": "bairro de Ajigasawa",
      "thName": "เมืองอาจิงาซาวา",
      "viName": "thị trấn Ajigasawa",
      "inName": "kota Ajigasawa",
      "tlName": "bayan ng Ajigasawa",
      "moName": "Aжигaсава жижиг хот",
      "buName": "အာဂျိဂါးဆာ့ဝ မြို့နယ်",
      "khName": "ទីប្រជុំជន អាជីកាសាវ៉ា",
      "neName": "आजिगासावा नगर"
    }
  },
  "0232300": {
    "office": {
      "code": "020000",
      "name": "青森県",
      "enName": "Aomori",
      "officeName": "青森地方気象台",
      "chName": "青森县",
      "zhName": "青森縣",
      "koName": "아오모리현",
      "esName": "Prefectura de Aomori",
      "ptName": "Província de Aomori",
      "thName": "จังหวัดอะโอโมริ",
      "viName": "Tỉnh Aomori",
      "inName": "Prefektur Aomori",
      "tlName": "Aomori Prefecture",
      "moName": "Аомори аймаг",
      "buName": "အာအိုးမိုးရိ ပြည်နယ်",
      "khName": "ខេត្ត អាអូម៉ូរី",
      "neName": "आओमोरी जिल्ला"
    },
    "class10": {
      "code": "020010",
      "name": "津軽",
      "enName": "Tsugaru",
      "chName": "青森县津轻北部",
      "zhName": "青森縣津軽北部",
      "koName": "아오모리 현 쓰가루 북부",
      "esName": "Tsugaru, Prefectura de Aomori",
      "ptName": "Tsugaru da Província de Aomori",
      "thName": "สึงารุ จังหวัดอะโอโมริ",
      "viName": "Tsugaru, tỉnh Aomori",
      "inName": "Tsugaru di Prefektur Aomori",
      "tlName": "Bahagi ng Tsugaru, Aomori Prefecture",
      "moName": "Аомори аймаг, Цүгарү",
      "buName": "ဆုဂယု၊ အအိုမိုယိစီရင်စု",
      "khName": "តំបន់ហ្សឹហ្គារឹ នៃខេត្តអាអូម៉ូរី",
      "neName": "आओमोरी जिल्ला, चुगारु भाग"
    },
    "class15": {
      "code": "020013",
      "name": "西津軽",
      "enName": "Nishitsugaru"
    },
    "class20": {
      "code": "0232300",
      "name": "深浦町",
      "enName": "Fukaura Town",
      "kana": "ふかうらまち",
      "chName": "深浦町",
      "zhName": "深浦町",
      "koName": "후카우라 정",
      "esName": "Pueblo de Fukaura",
      "ptName": "bairro de Fukaura",
      "thName": "เมืองฟุคาอุระ",
      "viName": "thị trấn Fukaura",
      "inName": "kota Fukaura",
      "tlName": "bayan ng Fukaura",
      "moName": "Фүкаүра жижиг хот",
      "buName": "ဖူကားဥရာ့ မြို့နယ်",
      "khName": "ទីប្រជុំជន ហ្វូគូអូរ៉ា",
      "neName": "फुकाउरा नगर"
    }
  },
  "0234300": {
    "office": {
      "code": "020000",
      "name": "青森県",
      "enName": "Aomori",
      "officeName": "青森地方気象台",
      "chName": "青森县",
      "zhName": "青森縣",
      "koName": "아오모리현",
      "esName": "Prefectura de Aomori",
      "ptName": "Província de Aomori",
      "thName": "จังหวัดอะโอโมริ",
      "viName": "Tỉnh Aomori",
      "inName": "Prefektur Aomori",
      "tlName": "Aomori Prefecture",
      "moName": "Аомори аймаг",
      "buName": "အာအိုးမိုးရိ ပြည်နယ်",
      "khName": "ខេត្ត អាអូម៉ូរី",
      "neName": "आओमोरी जिल्ला"
    },
    "class10": {
      "code": "020010",
      "name": "津軽",
      "enName": "Tsugaru",
      "chName": "青森县津轻北部",
      "zhName": "青森縣津軽北部",
      "koName": "아오모리 현 쓰가루 북부",
      "esName": "Tsugaru, Prefectura de Aomori",
      "ptName": "Tsugaru da Província de Aomori",
      "thName": "สึงารุ จังหวัดอะโอโมริ",
      "viName": "Tsugaru, tỉnh Aomori",
      "inName": "Tsugaru di Prefektur Aomori",
      "tlName": "Bahagi ng Tsugaru, Aomori Prefecture",
      "moName": "Аомори аймаг, Цүгарү",
      "buName": "ဆုဂယု၊ အအိုမိုယိစီရင်စု",
      "khName": "តំបន់ហ្សឹហ្គារឹ នៃខេត្តអាអូម៉ូរី",
      "neName": "आओमोरी जिल्ला, चुगारु भाग"
    },
    "class15": {
      "code": "020014",
      "name": "中南津軽",
      "enName": "Chunan Tsugaru"
    },
    "class20": {
      "code": "0234300",
      "name": "西目屋村",
      "enName": "Nishimeya Village",
      "kana": "にしめやむら",
      "chName": "西目屋村",
      "zhName": "西目屋村",
      "koName": "니시메야 촌",
      "esName": "Aldea de Nishimeya",
      "ptName": "povoado de Nishimeya",
      "thName": "หมู่บ้านนิชิเมยะ",
      "viName": "làng Nishimeya",
      "inName": "desa Nishimeya",
      "tlName": "nayon ng Nishimeya",
      "moName": "Нишимэя тосгон",
      "buName": "နီရှိမေ့ယ ကျေးရွာ",
      "khName": "ភូមិ នីស៊ីម៉ីយ៉ា",
      "neName": "निशिमेया गाउँ"
    }
  },
  "0236100": {
    "office": {
      "code": "020000",
      "name": "青森県",
      "enName": "Aomori",
      "officeName": "青森地方気象台",
      "chName": "青森县",
      "zhName": "青森縣",
      "koName": "아오모리현",
      "esName": "Prefectura de Aomori",
      "ptName": "Província de Aomori",
      "thName": "จังหวัดอะโอโมริ",
      "viName": "Tỉnh Aomori",
      "inName": "Prefektur Aomori",
      "tlName": "Aomori Prefecture",
      "moName": "Аомори аймаг",
      "buName": "အာအိုးမိုးရိ ပြည်နယ်",
      "khName": "ខេត្ត អាអូម៉ូរី",
      "neName": "आओमोरी जिल्ला"
    },
    "class10": {
      "code": "020010",
      "name": "津軽",
      "enName": "Tsugaru",
      "chName": "青森县津轻北部",
      "zhName": "青森縣津軽北部",
      "koName": "아오모리 현 쓰가루 북부",
      "esName": "Tsugaru, Prefectura de Aomori",
      "ptName": "Tsugaru da Província de Aomori",
      "thName": "สึงารุ จังหวัดอะโอโมริ",
      "viName": "Tsugaru, tỉnh Aomori",
      "inName": "Tsugaru di Prefektur Aomori",
      "tlName": "Bahagi ng Tsugaru, Aomori Prefecture",
      "moName": "Аомори аймаг, Цүгарү",
      "buName": "ဆုဂယု၊ အအိုမိုယိစီရင်စု",
      "khName": "តំបន់ហ្សឹហ្គារឹ នៃខេត្តអាអូម៉ូរី",
      "neName": "आओमोरी जिल्ला, चुगारु भाग"
    },
    "class15": {
      "code": "020014",
      "name": "中南津軽",
      "enName": "Chunan Tsugaru"
    },
    "class20": {
      "code": "0236100",
      "name": "藤崎町",
      "enName": "Fujisaki Town",
      "kana": "ふじさきまち",
      "chName": "藤崎町",
      "zhName": "藤崎町",
      "koName": "후지사키 정",
      "esName": "Pueblo de Fujisaki",
      "ptName": "bairro de Fujisaki",
      "thName": "เมืองฟุจิซากิ",
      "viName": "thị trấn Fujisaki",
      "inName": "kota Fujisaki",
      "tlName": "bayan ng Fujisaki",
      "moName": "Фүжисaки жижиг хот",
      "buName": "ဖူဂျိဆာ့ကိ မြို့နယ်",
      "khName": "ទីប្រជុំជន ហ្វូជីសាគី",
      "neName": "फुजिसाकी नगर"
    }
  },
  "0236200": {
    "office": {
      "code": "020000",
      "name": "青森県",
      "enName": "Aomori",
      "officeName": "青森地方気象台",
      "chName": "青森县",
      "zhName": "青森縣",
      "koName": "아오모리현",
      "esName": "Prefectura de Aomori",
      "ptName": "Província de Aomori",
      "thName": "จังหวัดอะโอโมริ",
      "viName": "Tỉnh Aomori",
      "inName": "Prefektur Aomori",
      "tlName": "Aomori Prefecture",
      "moName": "Аомори аймаг",
      "buName": "အာအိုးမိုးရိ ပြည်နယ်",
      "khName": "ខេត្ត អាអូម៉ូរី",
      "neName": "आओमोरी जिल्ला"
    },
    "class10": {
      "code": "020010",
      "name": "津軽",
      "enName": "Tsugaru",
      "chName": "青森县津轻北部",
      "zhName": "青森縣津軽北部",
      "koName": "아오모리 현 쓰가루 북부",
      "esName": "Tsugaru, Prefectura de Aomori",
      "ptName": "Tsugaru da Província de Aomori",
      "thName": "สึงารุ จังหวัดอะโอโมริ",
      "viName": "Tsugaru, tỉnh Aomori",
      "inName": "Tsugaru di Prefektur Aomori",
      "tlName": "Bahagi ng Tsugaru, Aomori Prefecture",
      "moName": "Аомори аймаг, Цүгарү",
      "buName": "ဆုဂယု၊ အအိုမိုယိစီရင်စု",
      "khName": "តំបន់ហ្សឹហ្គារឹ នៃខេត្តអាអូម៉ូរី",
      "neName": "आओमोरी जिल्ला, चुगारु भाग"
    },
    "class15": {
      "code": "020014",
      "name": "中南津軽",
      "enName": "Chunan Tsugaru"
    },
    "class20": {
      "code": "0236200",
      "name": "大鰐町",
      "enName": "Owani Town",
      "kana": "おおわにまち",
      "chName": "大鳄町",
      "zhName": "大鱷町",
      "koName": "오와니 정",
      "esName": "Pueblo de Owani",
      "ptName": "bairro de Owani",
      "thName": "เมืองโอวานิ",
      "viName": "thị trấn Owani",
      "inName": "kota Owani",
      "tlName": "bayan ng Owani",
      "moName": "Овани жижиг хот",
      "buName": "အိုဝါးနိ မြို့နယ်",
      "khName": "ទីប្រជុំជន អូវ៉ានី ",
      "neName": "ओवानी नगर"
    }
  },
  "0236700": {
    "office": {
      "code": "020000",
      "name": "青森県",
      "enName": "Aomori",
      "officeName": "青森地方気象台",
      "chName": "青森县",
      "zhName": "青森縣",
      "koName": "아오모리현",
      "esName": "Prefectura de Aomori",
      "ptName": "Província de Aomori",
      "thName": "จังหวัดอะโอโมริ",
      "viName": "Tỉnh Aomori",
      "inName": "Prefektur Aomori",
      "tlName": "Aomori Prefecture",
      "moName": "Аомори аймаг",
      "buName": "အာအိုးမိုးရိ ပြည်နယ်",
      "khName": "ខេត្ត អាអូម៉ូរី",
      "neName": "आओमोरी जिल्ला"
    },
    "class10": {
      "code": "020010",
      "name": "津軽",
      "enName": "Tsugaru",
      "chName": "青森县津轻北部",
      "zhName": "青森縣津軽北部",
      "koName": "아오모리 현 쓰가루 북부",
      "esName": "Tsugaru, Prefectura de Aomori",
      "ptName": "Tsugaru da Província de Aomori",
      "thName": "สึงารุ จังหวัดอะโอโมริ",
      "viName": "Tsugaru, tỉnh Aomori",
      "inName": "Tsugaru di Prefektur Aomori",
      "tlName": "Bahagi ng Tsugaru, Aomori Prefecture",
      "moName": "Аомори аймаг, Цүгарү",
      "buName": "ဆုဂယု၊ အအိုမိုယိစီရင်စု",
      "khName": "តំបន់ហ្សឹហ្គារឹ នៃខេត្តអាអូម៉ូរី",
      "neName": "आओमोरी जिल्ला, चुगारु भाग"
    },
    "class15": {
      "code": "020014",
      "name": "中南津軽",
      "enName": "Chunan Tsugaru"
    },
    "class20": {
      "code": "0236700",
      "name": "田舎館村",
      "enName": "Inakadate Village",
      "kana": "いなかだてむら",
      "chName": "田舍馆村",
      "zhName": "田舍館村",
      "koName": "이나카다테 촌",
      "esName": "Aldea de Inakadate",
      "ptName": "povoado de Inakadate",
      "thName": "หมู่บ้านอินากะดาเตะ",
      "viName": "làng Inakadate",
      "inName": "desa Inakadate",
      "tlName": "nayon ng Inakadate",
      "moName": "Инaкадатэ тосгон",
      "buName": "အီနားကာ့ဒါးတဲ့ ကျေးရွာ",
      "khName": "ភូមិ អ៊ីណាកាដេតេ",
      "neName": "इनाकादाते गाउँ"
    }
  },
  "0238100": {
    "office": {
      "code": "020000",
      "name": "青森県",
      "enName": "Aomori",
      "officeName": "青森地方気象台",
      "chName": "青森县",
      "zhName": "青森縣",
      "koName": "아오모리현",
      "esName": "Prefectura de Aomori",
      "ptName": "Província de Aomori",
      "thName": "จังหวัดอะโอโมริ",
      "viName": "Tỉnh Aomori",
      "inName": "Prefektur Aomori",
      "tlName": "Aomori Prefecture",
      "moName": "Аомори аймаг",
      "buName": "အာအိုးမိုးရိ ပြည်နယ်",
      "khName": "ខេត្ត អាអូម៉ូរី",
      "neName": "आओमोरी जिल्ला"
    },
    "class10": {
      "code": "020010",
      "name": "津軽",
      "enName": "Tsugaru",
      "chName": "青森县津轻北部",
      "zhName": "青森縣津軽北部",
      "koName": "아오모리 현 쓰가루 북부",
      "esName": "Tsugaru, Prefectura de Aomori",
      "ptName": "Tsugaru da Província de Aomori",
      "thName": "สึงารุ จังหวัดอะโอโมริ",
      "viName": "Tsugaru, tỉnh Aomori",
      "inName": "Tsugaru di Prefektur Aomori",
      "tlName": "Bahagi ng Tsugaru, Aomori Prefecture",
      "moName": "Аомори аймаг, Цүгарү",
      "buName": "ဆုဂယု၊ အအိုမိုယိစီရင်စု",
      "khName": "តំបន់ហ្សឹហ្គារឹ នៃខេត្តអាអូម៉ូរី",
      "neName": "आओमोरी जिल्ला, चुगारु भाग"
    },
    "class15": {
      "code": "020012",
      "name": "北五津軽",
      "enName": "Kitago Tsugaru"
    },
    "class20": {
      "code": "0238100",
      "name": "板柳町",
      "enName": "Itayanagi Town",
      "kana": "いたやなぎまち",
      "chName": "板柳町",
      "zhName": "板柳町",
      "koName": "이타야나기 정",
      "esName": "Pueblo de Itayanagi",
      "ptName": "bairro de Itayanagi",
      "thName": "เมืองอิตะยานางิ",
      "viName": "thị trấn Itayaagi",
      "inName": "kota Itayanagi",
      "tlName": "bayan ng Itayanagi",
      "moName": "Итаянaги жижиг хот",
      "buName": "အီတားယာ့နားဂိ မြို့နယ်",
      "khName": "ទីប្រជុំជន អ៊ីតាយ៉ាណាគី",
      "neName": "इतायानागि नगर"
    }
  },
  "0238400": {
    "office": {
      "code": "020000",
      "name": "青森県",
      "enName": "Aomori",
      "officeName": "青森地方気象台",
      "chName": "青森县",
      "zhName": "青森縣",
      "koName": "아오모리현",
      "esName": "Prefectura de Aomori",
      "ptName": "Província de Aomori",
      "thName": "จังหวัดอะโอโมริ",
      "viName": "Tỉnh Aomori",
      "inName": "Prefektur Aomori",
      "tlName": "Aomori Prefecture",
      "moName": "Аомори аймаг",
      "buName": "အာအိုးမိုးရိ ပြည်နယ်",
      "khName": "ខេត្ត អាអូម៉ូរី",
      "neName": "आओमोरी जिल्ला"
    },
    "class10": {
      "code": "020010",
      "name": "津軽",
      "enName": "Tsugaru",
      "chName": "青森县津轻北部",
      "zhName": "青森縣津軽北部",
      "koName": "아오모리 현 쓰가루 북부",
      "esName": "Tsugaru, Prefectura de Aomori",
      "ptName": "Tsugaru da Província de Aomori",
      "thName": "สึงารุ จังหวัดอะโอโมริ",
      "viName": "Tsugaru, tỉnh Aomori",
      "inName": "Tsugaru di Prefektur Aomori",
      "tlName": "Bahagi ng Tsugaru, Aomori Prefecture",
      "moName": "Аомори аймаг, Цүгарү",
      "buName": "ဆုဂယု၊ အအိုမိုယိစီရင်စု",
      "khName": "តំបន់ហ្សឹហ្គារឹ នៃខេត្តអាអូម៉ូរី",
      "neName": "आओमोरी जिल्ला, चुगारु भाग"
    },
    "class15": {
      "code": "020012",
      "name": "北五津軽",
      "enName": "Kitago Tsugaru"
    },
    "class20": {
      "code": "0238400",
      "name": "鶴田町",
      "enName": "Tsuruta Town",
      "kana": "つるたまち",
      "chName": "鹤田町",
      "zhName": "鶴田町",
      "koName": "쓰루타 정",
      "esName": "Pueblo de Tsuruta",
      "ptName": "bairro de Tsuruta",
      "thName": "เมืองสึรุตะ",
      "viName": "thị trấn Tsuruta",
      "inName": "kota Tsuruta",
      "tlName": "bayan ng Tsuruta",
      "moName": "Цүрүта жижиг хот",
      "buName": "ဆူရုတ မြို့နယ်",
      "khName": "ទីប្រជុំជន ស៊ូរ៉ូតា",
      "neName": "त्सुरुता नगर"
    }
  },
  "0238700": {
    "office": {
      "code": "020000",
      "name": "青森県",
      "enName": "Aomori",
      "officeName": "青森地方気象台",
      "chName": "青森县",
      "zhName": "青森縣",
      "koName": "아오모리현",
      "esName": "Prefectura de Aomori",
      "ptName": "Província de Aomori",
      "thName": "จังหวัดอะโอโมริ",
      "viName": "Tỉnh Aomori",
      "inName": "Prefektur Aomori",
      "tlName": "Aomori Prefecture",
      "moName": "Аомори аймаг",
      "buName": "အာအိုးမိုးရိ ပြည်နယ်",
      "khName": "ខេត្ត អាអូម៉ូរី",
      "neName": "आओमोरी जिल्ला"
    },
    "class10": {
      "code": "020010",
      "name": "津軽",
      "enName": "Tsugaru",
      "chName": "青森县津轻北部",
      "zhName": "青森縣津軽北部",
      "koName": "아오모리 현 쓰가루 북부",
      "esName": "Tsugaru, Prefectura de Aomori",
      "ptName": "Tsugaru da Província de Aomori",
      "thName": "สึงารุ จังหวัดอะโอโมริ",
      "viName": "Tsugaru, tỉnh Aomori",
      "inName": "Tsugaru di Prefektur Aomori",
      "tlName": "Bahagi ng Tsugaru, Aomori Prefecture",
      "moName": "Аомори аймаг, Цүгарү",
      "buName": "ဆုဂယု၊ အအိုမိုယိစီရင်စု",
      "khName": "តំបន់ហ្សឹហ្គារឹ នៃខេត្តអាអូម៉ូរី",
      "neName": "आओमोरी जिल्ला, चुगारु भाग"
    },
    "class15": {
      "code": "020012",
      "name": "北五津軽",
      "enName": "Kitago Tsugaru"
    },
    "class20": {
      "code": "0238700",
      "name": "中泊町",
      "enName": "Nakadomari Town",
      "kana": "なかどまりまち",
      "chName": "中泊町",
      "zhName": "中泊町",
      "koName": "나카도마리 정",
      "esName": "Pueblo de Nakadomari",
      "ptName": "bairro de Nakadomari",
      "thName": "เมืองนาคาโดมาริ",
      "viName": "thị trấn Nakadomari",
      "inName": "kota Nakadomari",
      "tlName": "bayan ng Nakadomari",
      "moName": "Нaкадомaри жижиг хот",
      "buName": "နာကာဒိုမာ့ရိ မြို့နယ်",
      "khName": "ទីប្រជុំជន ណាកាដូម៉ារី",
      "neName": "नाकादोमारी नगर"
    }
  },
  "0240100": {
    "office": {
      "code": "020000",
      "name": "青森県",
      "enName": "Aomori",
      "officeName": "青森地方気象台",
      "chName": "青森县",
      "zhName": "青森縣",
      "koName": "아오모리현",
      "esName": "Prefectura de Aomori",
      "ptName": "Província de Aomori",
      "thName": "จังหวัดอะโอโมริ",
      "viName": "Tỉnh Aomori",
      "inName": "Prefektur Aomori",
      "tlName": "Aomori Prefecture",
      "moName": "Аомори аймаг",
      "buName": "အာအိုးမိုးရိ ပြည်နယ်",
      "khName": "ខេត្ត អាអូម៉ូរី",
      "neName": "आओमोरी जिल्ला"
    },
    "class10": {
      "code": "020030",
      "name": "三八上北",
      "enName": "Sanpachi Kamikita",
      "chName": "青森县三八上北地方",
      "zhName": "青森縣三八上北地方",
      "koName": "아오모리 현 산파치 카미 키타 지방",
      "esName": "Región de Sanpachi-Kamikita, Prefectura de Aomori",
      "ptName": "Região de Sanpachi-Kamikita da Província de Aomori",
      "thName": "ท้องถิ่นซัมปาจิ คามิกิตะ จังหวัดอะโอโมริ",
      "viName": "Vùng Sanpachi Kamikita, tỉnh Aomori",
      "inName": "Daerah Sanpachi Kamikita di Prefektur Aomori",
      "tlName": "Rehiyon ng Sanpachi-Kamikita sa Aomori Prefecture",
      "moName": "Аомори аймаг, Санпачи-Камикита",
      "buName": "ဆန်းပချိ ခမိခိတဒေသ၊အအိုမိုယိစီရင်စု",
      "khName": "តំបន់សានប៉ាជីកាមីគីតាក់នៃខេត្តអាអូម៉ូរី",
      "neName": "आओमोरी जिल्ला, सान्पाची खामिकिता क्षेत्र"
    },
    "class15": {
      "code": "020032",
      "name": "上北",
      "enName": "Kamikita"
    },
    "class20": {
      "code": "0240100",
      "name": "野辺地町",
      "enName": "Noheji Town",
      "kana": "のへじまち",
      "chName": "野边地町",
      "zhName": "野邊地町",
      "koName": "노헤지 정",
      "esName": "Pueblo de Noheji",
      "ptName": "bairro de Noheji",
      "thName": "เมืองโนเฮจิ",
      "viName": "thị trấn Noheji",
      "inName": "kota Noheji",
      "tlName": "bayan ng Noheji",
      "moName": "Нохэжи жижиг хот",
      "buName": "နောဟဲဂျိ မြို့နယ်",
      "khName": "ទីប្រជុំជន ណូហៃជី",
      "neName": "नोहेजी नगर"
    }
  },
  "0240200": {
    "office": {
      "code": "020000",
      "name": "青森県",
      "enName": "Aomori",
      "officeName": "青森地方気象台",
      "chName": "青森县",
      "zhName": "青森縣",
      "koName": "아오모리현",
      "esName": "Prefectura de Aomori",
      "ptName": "Província de Aomori",
      "thName": "จังหวัดอะโอโมริ",
      "viName": "Tỉnh Aomori",
      "inName": "Prefektur Aomori",
      "tlName": "Aomori Prefecture",
      "moName": "Аомори аймаг",
      "buName": "အာအိုးမိုးရိ ပြည်နယ်",
      "khName": "ខេត្ត អាអូម៉ូរី",
      "neName": "आओमोरी जिल्ला"
    },
    "class10": {
      "code": "020030",
      "name": "三八上北",
      "enName": "Sanpachi Kamikita",
      "chName": "青森县三八上北地方",
      "zhName": "青森縣三八上北地方",
      "koName": "아오모리 현 산파치 카미 키타 지방",
      "esName": "Región de Sanpachi-Kamikita, Prefectura de Aomori",
      "ptName": "Região de Sanpachi-Kamikita da Província de Aomori",
      "thName": "ท้องถิ่นซัมปาจิ คามิกิตะ จังหวัดอะโอโมริ",
      "viName": "Vùng Sanpachi Kamikita, tỉnh Aomori",
      "inName": "Daerah Sanpachi Kamikita di Prefektur Aomori",
      "tlName": "Rehiyon ng Sanpachi-Kamikita sa Aomori Prefecture",
      "moName": "Аомори аймаг, Санпачи-Камикита",
      "buName": "ဆန်းပချိ ခမိခိတဒေသ၊အအိုမိုယိစီရင်စု",
      "khName": "តំបន់សានប៉ាជីកាមីគីតាក់នៃខេត្តអាអូម៉ូរី",
      "neName": "आओमोरी जिल्ला, सान्पाची खामिकिता क्षेत्र"
    },
    "class15": {
      "code": "020032",
      "name": "上北",
      "enName": "Kamikita"
    },
    "class20": {
      "code": "0240200",
      "name": "七戸町",
      "enName": "Shichinohe Town",
      "kana": "しちのへまち",
      "chName": "七户町",
      "zhName": "七戶町",
      "koName": "시치노헤 정",
      "esName": "Pueblo de Shichinohe",
      "ptName": "bairro de Shichinohe",
      "thName": "เมืองชิจิโนะเฮะ",
      "viName": "thị trấn Shichinohe",
      "inName": "kota Shichinohe",
      "tlName": "bayan ng Shichinohe",
      "moName": "Шичинохэ жижиг хот",
      "buName": "ရှီကျိနောဟဲ့ မြို့နယ်",
      "khName": "ទីប្រជុំជន ស៊ីឈីណូហេ",
      "neName": "शिचिनोहे नगर"
    }
  },
  "0240500": {
    "office": {
      "code": "020000",
      "name": "青森県",
      "enName": "Aomori",
      "officeName": "青森地方気象台",
      "chName": "青森县",
      "zhName": "青森縣",
      "koName": "아오모리현",
      "esName": "Prefectura de Aomori",
      "ptName": "Província de Aomori",
      "thName": "จังหวัดอะโอโมริ",
      "viName": "Tỉnh Aomori",
      "inName": "Prefektur Aomori",
      "tlName": "Aomori Prefecture",
      "moName": "Аомори аймаг",
      "buName": "အာအိုးမိုးရိ ပြည်နယ်",
      "khName": "ខេត្ត អាអូម៉ូរី",
      "neName": "आओमोरी जिल्ला"
    },
    "class10": {
      "code": "020030",
      "name": "三八上北",
      "enName": "Sanpachi Kamikita",
      "chName": "青森县三八上北地方",
      "zhName": "青森縣三八上北地方",
      "koName": "아오모리 현 산파치 카미 키타 지방",
      "esName": "Región de Sanpachi-Kamikita, Prefectura de Aomori",
      "ptName": "Região de Sanpachi-Kamikita da Província de Aomori",
      "thName": "ท้องถิ่นซัมปาจิ คามิกิตะ จังหวัดอะโอโมริ",
      "viName": "Vùng Sanpachi Kamikita, tỉnh Aomori",
      "inName": "Daerah Sanpachi Kamikita di Prefektur Aomori",
      "tlName": "Rehiyon ng Sanpachi-Kamikita sa Aomori Prefecture",
      "moName": "Аомори аймаг, Санпачи-Камикита",
      "buName": "ဆန်းပချိ ခမိခိတဒေသ၊အအိုမိုယိစီရင်စု",
      "khName": "តំបន់សានប៉ាជីកាមីគីតាក់នៃខេត្តអាអូម៉ូរី",
      "neName": "आओमोरी जिल्ला, सान्पाची खामिकिता क्षेत्र"
    },
    "class15": {
      "code": "020031",
      "name": "三八",
      "enName": "Sanpachi"
    },
    "class20": {
      "code": "0240500",
      "name": "六戸町",
      "enName": "Rokunohe Town",
      "kana": "ろくのへまち",
      "chName": "六户町",
      "zhName": "六戶町",
      "koName": "로쿠노헤 정",
      "esName": "Pueblo de Rokunohe",
      "ptName": "bairro de Rokunohe",
      "thName": "เมืองโรคุโนะเฮะ",
      "viName": "thị trấn Rokunohe",
      "inName": "kota Rokunohe",
      "tlName": "bayan ng Rokunohe",
      "moName": "Рокүнохэ жижиг хот",
      "buName": "ရိုကုနောဟဲ့ မြို့နယ်",
      "khName": "ទីប្រជុំជន រ៉ូគុណូហេ",
      "neName": "रोकुनोहे नगर"
    }
  },
  "0240600": {
    "office": {
      "code": "020000",
      "name": "青森県",
      "enName": "Aomori",
      "officeName": "青森地方気象台",
      "chName": "青森县",
      "zhName": "青森縣",
      "koName": "아오모리현",
      "esName": "Prefectura de Aomori",
      "ptName": "Província de Aomori",
      "thName": "จังหวัดอะโอโมริ",
      "viName": "Tỉnh Aomori",
      "inName": "Prefektur Aomori",
      "tlName": "Aomori Prefecture",
      "moName": "Аомори аймаг",
      "buName": "အာအိုးမိုးရိ ပြည်နယ်",
      "khName": "ខេត្ត អាអូម៉ូរី",
      "neName": "आओमोरी जिल्ला"
    },
    "class10": {
      "code": "020030",
      "name": "三八上北",
      "enName": "Sanpachi Kamikita",
      "chName": "青森县三八上北地方",
      "zhName": "青森縣三八上北地方",
      "koName": "아오모리 현 산파치 카미 키타 지방",
      "esName": "Región de Sanpachi-Kamikita, Prefectura de Aomori",
      "ptName": "Região de Sanpachi-Kamikita da Província de Aomori",
      "thName": "ท้องถิ่นซัมปาจิ คามิกิตะ จังหวัดอะโอโมริ",
      "viName": "Vùng Sanpachi Kamikita, tỉnh Aomori",
      "inName": "Daerah Sanpachi Kamikita di Prefektur Aomori",
      "tlName": "Rehiyon ng Sanpachi-Kamikita sa Aomori Prefecture",
      "moName": "Аомори аймаг, Санпачи-Камикита",
      "buName": "ဆန်းပချိ ခမိခိတဒေသ၊အအိုမိုယိစီရင်စု",
      "khName": "តំបន់សានប៉ាជីកាមីគីតាក់នៃខេត្តអាអូម៉ូរី",
      "neName": "आओमोरी जिल्ला, सान्पाची खामिकिता क्षेत्र"
    },
    "class15": {
      "code": "020032",
      "name": "上北",
      "enName": "Kamikita"
    },
    "class20": {
      "code": "0240600",
      "name": "横浜町",
      "enName": "Yokohama Town",
      "kana": "よこはままち",
      "chName": "横滨町",
      "zhName": "橫濱町",
      "koName": "요코하마 정",
      "esName": "Pueblo de Yokohama",
      "ptName": "bairro de Yokohama",
      "thName": "เมืองโอโกฮามา",
      "viName": "thị trấn Yokohama",
      "inName": "kota Yokohama",
      "tlName": "bayan ng Yokohama",
      "moName": "Ёкохама жижиг хот",
      "buName": "ရိုကိုဟားမား မြို့နယ်",
      "khName": "ទីប្រជុំជន យូកូហាម៉ា",
      "neName": "योकोहामा नगर"
    }
  },
  "0240800": {
    "office": {
      "code": "020000",
      "name": "青森県",
      "enName": "Aomori",
      "officeName": "青森地方気象台",
      "chName": "青森县",
      "zhName": "青森縣",
      "koName": "아오모리현",
      "esName": "Prefectura de Aomori",
      "ptName": "Província de Aomori",
      "thName": "จังหวัดอะโอโมริ",
      "viName": "Tỉnh Aomori",
      "inName": "Prefektur Aomori",
      "tlName": "Aomori Prefecture",
      "moName": "Аомори аймаг",
      "buName": "အာအိုးမိုးရိ ပြည်နယ်",
      "khName": "ខេត្ត អាអូម៉ូរី",
      "neName": "आओमोरी जिल्ला"
    },
    "class10": {
      "code": "020030",
      "name": "三八上北",
      "enName": "Sanpachi Kamikita",
      "chName": "青森县三八上北地方",
      "zhName": "青森縣三八上北地方",
      "koName": "아오모리 현 산파치 카미 키타 지방",
      "esName": "Región de Sanpachi-Kamikita, Prefectura de Aomori",
      "ptName": "Região de Sanpachi-Kamikita da Província de Aomori",
      "thName": "ท้องถิ่นซัมปาจิ คามิกิตะ จังหวัดอะโอโมริ",
      "viName": "Vùng Sanpachi Kamikita, tỉnh Aomori",
      "inName": "Daerah Sanpachi Kamikita di Prefektur Aomori",
      "tlName": "Rehiyon ng Sanpachi-Kamikita sa Aomori Prefecture",
      "moName": "Аомори аймаг, Санпачи-Камикита",
      "buName": "ဆန်းပချိ ခမိခိတဒေသ၊အအိုမိုယိစီရင်စု",
      "khName": "តំបន់សានប៉ាជីកាមីគីតាក់នៃខេត្តអាអូម៉ូរី",
      "neName": "आओमोरी जिल्ला, सान्पाची खामिकिता क्षेत्र"
    },
    "class15": {
      "code": "020032",
      "name": "上北",
      "enName": "Kamikita"
    },
    "class20": {
      "code": "0240800",
      "name": "東北町",
      "enName": "Tohoku Town",
      "kana": "とうほくまち",
      "chName": "东北町",
      "zhName": "東北町",
      "koName": "도호쿠 정",
      "esName": "Pueblo de Tohoku",
      "ptName": "bairro de Tohoku",
      "thName": "เมืองโทโฮขุ",
      "viName": "thị trấn Tohoku",
      "inName": "kota Tohoku",
      "tlName": "bayan ng Tohoku",
      "moName": "Тохокү жижиг хот",
      "buName": "တိုဟိုကု မြို့နယ်",
      "khName": "ទីប្រជុំជន តូហូគូ",
      "neName": "तोहोकु नगर"
    }
  },
  "0241100": {
    "office": {
      "code": "020000",
      "name": "青森県",
      "enName": "Aomori",
      "officeName": "青森地方気象台",
      "chName": "青森县",
      "zhName": "青森縣",
      "koName": "아오모리현",
      "esName": "Prefectura de Aomori",
      "ptName": "Província de Aomori",
      "thName": "จังหวัดอะโอโมริ",
      "viName": "Tỉnh Aomori",
      "inName": "Prefektur Aomori",
      "tlName": "Aomori Prefecture",
      "moName": "Аомори аймаг",
      "buName": "အာအိုးမိုးရိ ပြည်နယ်",
      "khName": "ខេត្ត អាអូម៉ូរី",
      "neName": "आओमोरी जिल्ला"
    },
    "class10": {
      "code": "020030",
      "name": "三八上北",
      "enName": "Sanpachi Kamikita",
      "chName": "青森县三八上北地方",
      "zhName": "青森縣三八上北地方",
      "koName": "아오모리 현 산파치 카미 키타 지방",
      "esName": "Región de Sanpachi-Kamikita, Prefectura de Aomori",
      "ptName": "Região de Sanpachi-Kamikita da Província de Aomori",
      "thName": "ท้องถิ่นซัมปาจิ คามิกิตะ จังหวัดอะโอโมริ",
      "viName": "Vùng Sanpachi Kamikita, tỉnh Aomori",
      "inName": "Daerah Sanpachi Kamikita di Prefektur Aomori",
      "tlName": "Rehiyon ng Sanpachi-Kamikita sa Aomori Prefecture",
      "moName": "Аомори аймаг, Санпачи-Камикита",
      "buName": "ဆန်းပချိ ခမိခိတဒေသ၊အအိုမိုယိစီရင်စု",
      "khName": "តំបន់សានប៉ាជីកាមីគីតាក់នៃខេត្តអាអូម៉ូរី",
      "neName": "आओमोरी जिल्ला, सान्पाची खामिकिता क्षेत्र"
    },
    "class15": {
      "code": "020032",
      "name": "上北",
      "enName": "Kamikita"
    },
    "class20": {
      "code": "0241100",
      "name": "六ヶ所村",
      "enName": "Rokkasho Village",
      "kana": "ろっかしょむら",
      "chName": "六所村",
      "zhName": "六所村",
      "koName": "롯카쇼 촌",
      "esName": "Aldea de Rokkasho",
      "ptName": "povoado de Rokkasho",
      "thName": "หมู่บ้านโร๊คคะโช",
      "viName": "làng Rokkasho",
      "inName": "desa Rokkasho",
      "tlName": "nayon ng Rokkasho",
      "moName": "Роккашо тосгон",
      "buName": "ရော့ကာ့ရှို ကျေးရွာ",
      "khName": "ភូមិ រ៉ូកាស៊ូ",
      "neName": "रोक्काशो गाउँ"
    }
  },
  "0241200": {
    "office": {
      "code": "020000",
      "name": "青森県",
      "enName": "Aomori",
      "officeName": "青森地方気象台",
      "chName": "青森县",
      "zhName": "青森縣",
      "koName": "아오모리현",
      "esName": "Prefectura de Aomori",
      "ptName": "Província de Aomori",
      "thName": "จังหวัดอะโอโมริ",
      "viName": "Tỉnh Aomori",
      "inName": "Prefektur Aomori",
      "tlName": "Aomori Prefecture",
      "moName": "Аомори аймаг",
      "buName": "အာအိုးမိုးရိ ပြည်နယ်",
      "khName": "ខេត្ត អាអូម៉ូរី",
      "neName": "आओमोरी जिल्ला"
    },
    "class10": {
      "code": "020030",
      "name": "三八上北",
      "enName": "Sanpachi Kamikita",
      "chName": "青森县三八上北地方",
      "zhName": "青森縣三八上北地方",
      "koName": "아오모리 현 산파치 카미 키타 지방",
      "esName": "Región de Sanpachi-Kamikita, Prefectura de Aomori",
      "ptName": "Região de Sanpachi-Kamikita da Província de Aomori",
      "thName": "ท้องถิ่นซัมปาจิ คามิกิตะ จังหวัดอะโอโมริ",
      "viName": "Vùng Sanpachi Kamikita, tỉnh Aomori",
      "inName": "Daerah Sanpachi Kamikita di Prefektur Aomori",
      "tlName": "Rehiyon ng Sanpachi-Kamikita sa Aomori Prefecture",
      "moName": "Аомори аймаг, Санпачи-Камикита",
      "buName": "ဆန်းပချိ ခမိခိတဒေသ၊အအိုမိုယိစီရင်စု",
      "khName": "តំបន់សានប៉ាជីកាមីគីតាក់នៃខេត្តអាអូម៉ូរី",
      "neName": "आओमोरी जिल्ला, सान्पाची खामिकिता क्षेत्र"
    },
    "class15": {
      "code": "020031",
      "name": "三八",
      "enName": "Sanpachi"
    },
    "class20": {
      "code": "0241200",
      "name": "おいらせ町",
      "enName": "Oirase Town",
      "kana": "おいらせちょう",
      "chName": "奥入濑町",
      "zhName": "奧入瀨町",
      "koName": "오이라세 정",
      "esName": "Pueblo de Oirase",
      "ptName": "bairro de Oirase",
      "thName": "เมืองโออิระเซ",
      "viName": "thị trấn Oirase",
      "inName": "kota Oirase",
      "tlName": "bayan ng Oirase",
      "moName": "Ойрасэ жижиг хот",
      "buName": "အိုယိရာ့ဆဲ့ မြို့နယ်",
      "khName": "ទីប្រជុំជន អយរ៉េស",
      "neName": "ओइरासे नगर"
    }
  },
  "0242300": {
    "office": {
      "code": "020000",
      "name": "青森県",
      "enName": "Aomori",
      "officeName": "青森地方気象台",
      "chName": "青森县",
      "zhName": "青森縣",
      "koName": "아오모리현",
      "esName": "Prefectura de Aomori",
      "ptName": "Província de Aomori",
      "thName": "จังหวัดอะโอโมริ",
      "viName": "Tỉnh Aomori",
      "inName": "Prefektur Aomori",
      "tlName": "Aomori Prefecture",
      "moName": "Аомори аймаг",
      "buName": "အာအိုးမိုးရိ ပြည်နယ်",
      "khName": "ខេត្ត អាអូម៉ូរី",
      "neName": "आओमोरी जिल्ला"
    },
    "class10": {
      "code": "020020",
      "name": "下北",
      "enName": "Shimokita",
      "chName": "青森县下北地方",
      "zhName": "青森縣下北地方",
      "koName": "아오모리 현 시모키타 지방",
      "esName": "Región Shimokita, Prefectura de Aomori",
      "ptName": "Região de Shimokita da Província de Aomori",
      "thName": "ท้องถิ่นชิโมะคิตะ จังหวัดอะโอโมริ",
      "viName": "Vùng Shimokita, tỉnh Aomori",
      "inName": "Daerah Shimokita di Prefektur Aomori",
      "tlName": "Rehiyon ng Shimokita sa Aomori Prefecture",
      "moName": "Аомори аймаг, Шимокита",
      "buName": "ရှိမိုခိတဒေသ၊ အအိုမိုယိစီရင်စု",
      "khName": "តំបន់ស៊ីម៉ូគីតាក់ខេត្តអាអូម៉ូរី",
      "neName": "आओमोरी जिल्ला, सिमोकिता क्षेत्र"
    },
    "class15": {
      "code": "020020",
      "name": "下北",
      "enName": "Shimokita"
    },
    "class20": {
      "code": "0242300",
      "name": "大間町",
      "enName": "Oma Town",
      "kana": "おおままち",
      "chName": "大间町",
      "zhName": "大間町",
      "koName": "오마 정",
      "esName": "Pueblo de Oma",
      "ptName": "bairro de Oma",
      "thName": "เมืองโอมะ",
      "viName": "thị trấn Oma",
      "inName": "kota Oma",
      "tlName": "bayan ng Oma",
      "moName": "Омa жижиг хот",
      "buName": "အိုးမ မြို့နယ်",
      "khName": "ទីប្រជុំជន អូម៉ា",
      "neName": "ओमा नगर"
    }
  },
  "0242400": {
    "office": {
      "code": "020000",
      "name": "青森県",
      "enName": "Aomori",
      "officeName": "青森地方気象台",
      "chName": "青森县",
      "zhName": "青森縣",
      "koName": "아오모리현",
      "esName": "Prefectura de Aomori",
      "ptName": "Província de Aomori",
      "thName": "จังหวัดอะโอโมริ",
      "viName": "Tỉnh Aomori",
      "inName": "Prefektur Aomori",
      "tlName": "Aomori Prefecture",
      "moName": "Аомори аймаг",
      "buName": "အာအိုးမိုးရိ ပြည်နယ်",
      "khName": "ខេត្ត អាអូម៉ូរី",
      "neName": "आओमोरी जिल्ला"
    },
    "class10": {
      "code": "020020",
      "name": "下北",
      "enName": "Shimokita",
      "chName": "青森县下北地方",
      "zhName": "青森縣下北地方",
      "koName": "아오모리 현 시모키타 지방",
      "esName": "Región Shimokita, Prefectura de Aomori",
      "ptName": "Região de Shimokita da Província de Aomori",
      "thName": "ท้องถิ่นชิโมะคิตะ จังหวัดอะโอโมริ",
      "viName": "Vùng Shimokita, tỉnh Aomori",
      "inName": "Daerah Shimokita di Prefektur Aomori",
      "tlName": "Rehiyon ng Shimokita sa Aomori Prefecture",
      "moName": "Аомори аймаг, Шимокита",
      "buName": "ရှိမိုခိတဒေသ၊ အအိုမိုယိစီရင်စု",
      "khName": "តំបន់ស៊ីម៉ូគីតាក់ខេត្តអាអូម៉ូរី",
      "neName": "आओमोरी जिल्ला, सिमोकिता क्षेत्र"
    },
    "class15": {
      "code": "020020",
      "name": "下北",
      "enName": "Shimokita"
    },
    "class20": {
      "code": "0242400",
      "name": "東通村",
      "enName": "Higashidori Village",
      "kana": "ひがしどおりむら",
      "chName": "东通村",
      "zhName": "東通村",
      "koName": "히가시도리 촌",
      "esName": "Aldea de Higashidori",
      "ptName": "povoado de Higashidori",
      "thName": "หมู่บ้านฮิงาชิโดริ",
      "viName": "làng Higashidori",
      "inName": "desa Higashidori",
      "tlName": "nayon ng Higashidori",
      "moName": "Хигaшидори тосгон",
      "buName": "ဟီဂရှိတိုးရိ ကျေးရွာ",
      "khName": "ភូមិ ហ៊ីហ្កាស៊ីដូរី",
      "neName": "हिगाशिदोरी गाउँ"
    }
  },
  "0242500": {
    "office": {
      "code": "020000",
      "name": "青森県",
      "enName": "Aomori",
      "officeName": "青森地方気象台",
      "chName": "青森县",
      "zhName": "青森縣",
      "koName": "아오모리현",
      "esName": "Prefectura de Aomori",
      "ptName": "Província de Aomori",
      "thName": "จังหวัดอะโอโมริ",
      "viName": "Tỉnh Aomori",
      "inName": "Prefektur Aomori",
      "tlName": "Aomori Prefecture",
      "moName": "Аомори аймаг",
      "buName": "အာအိုးမိုးရိ ပြည်နယ်",
      "khName": "ខេត្ត អាអូម៉ូរី",
      "neName": "आओमोरी जिल्ला"
    },
    "class10": {
      "code": "020020",
      "name": "下北",
      "enName": "Shimokita",
      "chName": "青森县下北地方",
      "zhName": "青森縣下北地方",
      "koName": "아오모리 현 시모키타 지방",
      "esName": "Región Shimokita, Prefectura de Aomori",
      "ptName": "Região de Shimokita da Província de Aomori",
      "thName": "ท้องถิ่นชิโมะคิตะ จังหวัดอะโอโมริ",
      "viName": "Vùng Shimokita, tỉnh Aomori",
      "inName": "Daerah Shimokita di Prefektur Aomori",
      "tlName": "Rehiyon ng Shimokita sa Aomori Prefecture",
      "moName": "Аомори аймаг, Шимокита",
      "buName": "ရှိမိုခိတဒေသ၊ အအိုမိုယိစီရင်စု",
      "khName": "តំបន់ស៊ីម៉ូគីតាក់ខេត្តអាអូម៉ូរី",
      "neName": "आओमोरी जिल्ला, सिमोकिता क्षेत्र"
    },
    "class15": {
      "code": "020020",
      "name": "下北",
      "enName": "Shimokita"
    },
    "class20": {
      "code": "0242500",
      "name": "風間浦村",
      "enName": "Kazamaura Village",
      "kana": "かざまうらむら",
      "chName": "风间浦村",
      "zhName": "風間浦村",
      "koName": "가자마우라 촌",
      "esName": "Aldea de Kazamaura",
      "ptName": "povoado de Kazamaura",
      "thName": "หมู่บ้านคาซุมะอุระ",
      "viName": "làng Kazamaura",
      "inName": "desa Kazamaura",
      "tlName": "nayon ng Kazamaura",
      "moName": "Казaмaүра тосгон",
      "buName": "ခါဇာ့မားဥရာ့ ကျေးရွာ",
      "khName": "ភូមិ កាហ្សាម៉ាអ៊ូរ៉ា",
      "neName": "काजामाउरा गाउँ"
    }
  },
  "0242600": {
    "office": {
      "code": "020000",
      "name": "青森県",
      "enName": "Aomori",
      "officeName": "青森地方気象台",
      "chName": "青森县",
      "zhName": "青森縣",
      "koName": "아오모리현",
      "esName": "Prefectura de Aomori",
      "ptName": "Província de Aomori",
      "thName": "จังหวัดอะโอโมริ",
      "viName": "Tỉnh Aomori",
      "inName": "Prefektur Aomori",
      "tlName": "Aomori Prefecture",
      "moName": "Аомори аймаг",
      "buName": "အာအိုးမိုးရိ ပြည်နယ်",
      "khName": "ខេត្ត អាអូម៉ូរី",
      "neName": "आओमोरी जिल्ला"
    },
    "class10": {
      "code": "020020",
      "name": "下北",
      "enName": "Shimokita",
      "chName": "青森县下北地方",
      "zhName": "青森縣下北地方",
      "koName": "아오모리 현 시모키타 지방",
      "esName": "Región Shimokita, Prefectura de Aomori",
      "ptName": "Região de Shimokita da Província de Aomori",
      "thName": "ท้องถิ่นชิโมะคิตะ จังหวัดอะโอโมริ",
      "viName": "Vùng Shimokita, tỉnh Aomori",
      "inName": "Daerah Shimokita di Prefektur Aomori",
      "tlName": "Rehiyon ng Shimokita sa Aomori Prefecture",
      "moName": "Аомори аймаг, Шимокита",
      "buName": "ရှိမိုခိတဒေသ၊ အအိုမိုယိစီရင်စု",
      "khName": "តំបន់ស៊ីម៉ូគីតាក់ខេត្តអាអូម៉ូរី",
      "neName": "आओमोरी जिल्ला, सिमोकिता क्षेत्र"
    },
    "class15": {
      "code": "020020",
      "name": "下北",
      "enName": "Shimokita"
    },
    "class20": {
      "code": "0242600",
      "name": "佐井村",
      "enName": "Sai Village",
      "kana": "さいむら",
      "chName": "佐井村",
      "zhName": "佐井村",
      "koName": "사이 촌",
      "esName": "Aldea de Sai",
      "ptName": "povoado de Sai",
      "thName": "หมู่บ้านซาอิ",
      "viName": "làng Sai",
      "inName": "desa Village",
      "tlName": "nayon ng Sai",
      "moName": "Сай тосгон",
      "buName": "ဆိုင်းယိ ကျေးရွာ",
      "khName": "ភូមិ សាយ",
      "neName": "साई गाउँ"
    }
  },
  "0244100": {
    "office": {
      "code": "020000",
      "name": "青森県",
      "enName": "Aomori",
      "officeName": "青森地方気象台",
      "chName": "青森县",
      "zhName": "青森縣",
      "koName": "아오모리현",
      "esName": "Prefectura de Aomori",
      "ptName": "Província de Aomori",
      "thName": "จังหวัดอะโอโมริ",
      "viName": "Tỉnh Aomori",
      "inName": "Prefektur Aomori",
      "tlName": "Aomori Prefecture",
      "moName": "Аомори аймаг",
      "buName": "အာအိုးမိုးရိ ပြည်နယ်",
      "khName": "ខេត្ត អាអូម៉ូរី",
      "neName": "आओमोरी जिल्ला"
    },
    "class10": {
      "code": "020030",
      "name": "三八上北",
      "enName": "Sanpachi Kamikita",
      "chName": "青森县三八上北地方",
      "zhName": "青森縣三八上北地方",
      "koName": "아오모리 현 산파치 카미 키타 지방",
      "esName": "Región de Sanpachi-Kamikita, Prefectura de Aomori",
      "ptName": "Região de Sanpachi-Kamikita da Província de Aomori",
      "thName": "ท้องถิ่นซัมปาจิ คามิกิตะ จังหวัดอะโอโมริ",
      "viName": "Vùng Sanpachi Kamikita, tỉnh Aomori",
      "inName": "Daerah Sanpachi Kamikita di Prefektur Aomori",
      "tlName": "Rehiyon ng Sanpachi-Kamikita sa Aomori Prefecture",
      "moName": "Аомори аймаг, Санпачи-Камикита",
      "buName": "ဆန်းပချိ ခမိခိတဒေသ၊အအိုမိုယိစီရင်စု",
      "khName": "តំបន់សានប៉ាជីកាមីគីតាក់នៃខេត្តអាអូម៉ូរី",
      "neName": "आओमोरी जिल्ला, सान्पाची खामिकिता क्षेत्र"
    },
    "class15": {
      "code": "020031",
      "name": "三八",
      "enName": "Sanpachi"
    },
    "class20": {
      "code": "0244100",
      "name": "三戸町",
      "enName": "Sannohe Town",
      "kana": "さんのへまち",
      "chName": "三户町",
      "zhName": "三戶町",
      "koName": "산노헤 정",
      "esName": "Pueblo de Sannohe",
      "ptName": "bairro de Sannohe",
      "thName": "เมืองซันโนะเฮะ",
      "viName": "thị trấn Sannohe",
      "inName": "kota Sannohe",
      "tlName": "bayan ng Sannohe",
      "moName": "Саннохэ жижиг хот",
      "buName": "ဆန်းဟိုဟဲ့ မြို့နယ်",
      "khName": "ទីប្រជុំជន សាន់ណូហេ ",
      "neName": "सान्नोहे नगर"
    }
  },
  "0244200": {
    "office": {
      "code": "020000",
      "name": "青森県",
      "enName": "Aomori",
      "officeName": "青森地方気象台",
      "chName": "青森县",
      "zhName": "青森縣",
      "koName": "아오모리현",
      "esName": "Prefectura de Aomori",
      "ptName": "Província de Aomori",
      "thName": "จังหวัดอะโอโมริ",
      "viName": "Tỉnh Aomori",
      "inName": "Prefektur Aomori",
      "tlName": "Aomori Prefecture",
      "moName": "Аомори аймаг",
      "buName": "အာအိုးမိုးရိ ပြည်နယ်",
      "khName": "ខេត្ត អាអូម៉ូរី",
      "neName": "आओमोरी जिल्ला"
    },
    "class10": {
      "code": "020030",
      "name": "三八上北",
      "enName": "Sanpachi Kamikita",
      "chName": "青森县三八上北地方",
      "zhName": "青森縣三八上北地方",
      "koName": "아오모리 현 산파치 카미 키타 지방",
      "esName": "Región de Sanpachi-Kamikita, Prefectura de Aomori",
      "ptName": "Região de Sanpachi-Kamikita da Província de Aomori",
      "thName": "ท้องถิ่นซัมปาจิ คามิกิตะ จังหวัดอะโอโมริ",
      "viName": "Vùng Sanpachi Kamikita, tỉnh Aomori",
      "inName": "Daerah Sanpachi Kamikita di Prefektur Aomori",
      "tlName": "Rehiyon ng Sanpachi-Kamikita sa Aomori Prefecture",
      "moName": "Аомори аймаг, Санпачи-Камикита",
      "buName": "ဆန်းပချိ ခမိခိတဒေသ၊အအိုမိုယိစီရင်စု",
      "khName": "តំបន់សានប៉ាជីកាមីគីតាក់នៃខេត្តអាអូម៉ូរី",
      "neName": "आओमोरी जिल्ला, सान्पाची खामिकिता क्षेत्र"
    },
    "class15": {
      "code": "020031",
      "name": "三八",
      "enName": "Sanpachi"
    },
    "class20": {
      "code": "0244200",
      "name": "五戸町",
      "enName": "Gonohe Town",
      "kana": "ごのへまち",
      "chName": "五户町",
      "zhName": "五戶町",
      "koName": "고노헤 정",
      "esName": "Pueblo de Gonohe",
      "ptName": "bairro de Gonohe",
      "thName": "เมืองโกะโนเฮะ",
      "viName": "thị trấn Gonohe",
      "inName": "kota Gonohe",
      "tlName": "bayan ng Gonohe",
      "moName": "Гонохэ жижиг хот",
      "buName": "ဂိုးနောဟဲ့ မြို့နယ်",
      "khName": "ទីប្រជុំជន កូណូហេ",
      "neName": "गोनोहे नगर"
    }
  },
  "0244300": {
    "office": {
      "code": "020000",
      "name": "青森県",
      "enName": "Aomori",
      "officeName": "青森地方気象台",
      "chName": "青森县",
      "zhName": "青森縣",
      "koName": "아오모리현",
      "esName": "Prefectura de Aomori",
      "ptName": "Província de Aomori",
      "thName": "จังหวัดอะโอโมริ",
      "viName": "Tỉnh Aomori",
      "inName": "Prefektur Aomori",
      "tlName": "Aomori Prefecture",
      "moName": "Аомори аймаг",
      "buName": "အာအိုးမိုးရိ ပြည်နယ်",
      "khName": "ខេត្ត អាអូម៉ូរី",
      "neName": "आओमोरी जिल्ला"
    },
    "class10": {
      "code": "020030",
      "name": "三八上北",
      "enName": "Sanpachi Kamikita",
      "chName": "青森县三八上北地方",
      "zhName": "青森縣三八上北地方",
      "koName": "아오모리 현 산파치 카미 키타 지방",
      "esName": "Región de Sanpachi-Kamikita, Prefectura de Aomori",
      "ptName": "Região de Sanpachi-Kamikita da Província de Aomori",
      "thName": "ท้องถิ่นซัมปาจิ คามิกิตะ จังหวัดอะโอโมริ",
      "viName": "Vùng Sanpachi Kamikita, tỉnh Aomori",
      "inName": "Daerah Sanpachi Kamikita di Prefektur Aomori",
      "tlName": "Rehiyon ng Sanpachi-Kamikita sa Aomori Prefecture",
      "moName": "Аомори аймаг, Санпачи-Камикита",
      "buName": "ဆန်းပချိ ခမိခိတဒေသ၊အအိုမိုယိစီရင်စု",
      "khName": "តំបន់សានប៉ាជីកាមីគីតាក់នៃខេត្តអាអូម៉ូរី",
      "neName": "आओमोरी जिल्ला, सान्पाची खामिकिता क्षेत्र"
    },
    "class15": {
      "code": "020031",
      "name": "三八",
      "enName": "Sanpachi"
    },
    "class20": {
      "code": "0244300",
      "name": "田子町",
      "enName": "Takko Town",
      "kana": "たっこまち",
      "chName": "田子町",
      "zhName": "田子町",
      "koName": "닷코 정",
      "esName": "Pueblo de Takko",
      "ptName": "bairro de Takko",
      "thName": "เมืองทัคโกะ",
      "viName": "thị trấn Takko",
      "inName": "kota Takko",
      "tlName": "bayan ng Takko",
      "moName": "Такко жижиг хот",
      "buName": "တက်ကို မြို့နယ်",
      "khName": "ទីប្រជុំជន តាក់កូ",
      "neName": "ताक्को नगर"
    }
  },
  "0244500": {
    "office": {
      "code": "020000",
      "name": "青森県",
      "enName": "Aomori",
      "officeName": "青森地方気象台",
      "chName": "青森县",
      "zhName": "青森縣",
      "koName": "아오모리현",
      "esName": "Prefectura de Aomori",
      "ptName": "Província de Aomori",
      "thName": "จังหวัดอะโอโมริ",
      "viName": "Tỉnh Aomori",
      "inName": "Prefektur Aomori",
      "tlName": "Aomori Prefecture",
      "moName": "Аомори аймаг",
      "buName": "အာအိုးမိုးရိ ပြည်နယ်",
      "khName": "ខេត្ត អាអូម៉ូរី",
      "neName": "आओमोरी जिल्ला"
    },
    "class10": {
      "code": "020030",
      "name": "三八上北",
      "enName": "Sanpachi Kamikita",
      "chName": "青森县三八上北地方",
      "zhName": "青森縣三八上北地方",
      "koName": "아오모리 현 산파치 카미 키타 지방",
      "esName": "Región de Sanpachi-Kamikita, Prefectura de Aomori",
      "ptName": "Região de Sanpachi-Kamikita da Província de Aomori",
      "thName": "ท้องถิ่นซัมปาจิ คามิกิตะ จังหวัดอะโอโมริ",
      "viName": "Vùng Sanpachi Kamikita, tỉnh Aomori",
      "inName": "Daerah Sanpachi Kamikita di Prefektur Aomori",
      "tlName": "Rehiyon ng Sanpachi-Kamikita sa Aomori Prefecture",
      "moName": "Аомори аймаг, Санпачи-Камикита",
      "buName": "ဆန်းပချိ ခမိခိတဒေသ၊အအိုမိုယိစီရင်စု",
      "khName": "តំបន់សានប៉ាជីកាមីគីតាក់នៃខេត្តអាអូម៉ូរី",
      "neName": "आओमोरी जिल्ला, सान्पाची खामिकिता क्षेत्र"
    },
    "class15": {
      "code": "020031",
      "name": "三八",
      "enName": "Sanpachi"
    },
    "class20": {
      "code": "0244500",
      "name": "南部町",
      "enName": "Nambu Town",
      "kana": "なんぶちょう",
      "chName": "青森南部町",
      "zhName": "青森南部町",
      "koName": "아오모리 난부 정",
      "esName": "Pueblo de Nambu, Aomori",
      "ptName": "Aomori, bairro de Nambu",
      "thName": "เมืองนัมบุ อะโอโมริ",
      "viName": "Thị trấn Nambu, Aomori",
      "inName": "Kota Nambu, Aomori",
      "tlName": "bayan ng Nanbu, Aomori",
      "moName": "Аомори Нанбү жижиг хот",
      "buName": "အအိုမိုယိနန်းဘုမြို့နယ်",
      "khName": "ទីប្រជុំជនណាំប៊ូ អាអូម៉ូរី",
      "neName": "आओमोरी नाम्बु नगर"
    }
  },
  "0244600": {
    "office": {
      "code": "020000",
      "name": "青森県",
      "enName": "Aomori",
      "officeName": "青森地方気象台",
      "chName": "青森县",
      "zhName": "青森縣",
      "koName": "아오모리현",
      "esName": "Prefectura de Aomori",
      "ptName": "Província de Aomori",
      "thName": "จังหวัดอะโอโมริ",
      "viName": "Tỉnh Aomori",
      "inName": "Prefektur Aomori",
      "tlName": "Aomori Prefecture",
      "moName": "Аомори аймаг",
      "buName": "အာအိုးမိုးရိ ပြည်နယ်",
      "khName": "ខេត្ត អាអូម៉ូរី",
      "neName": "आओमोरी जिल्ला"
    },
    "class10": {
      "code": "020030",
      "name": "三八上北",
      "enName": "Sanpachi Kamikita",
      "chName": "青森县三八上北地方",
      "zhName": "青森縣三八上北地方",
      "koName": "아오모리 현 산파치 카미 키타 지방",
      "esName": "Región de Sanpachi-Kamikita, Prefectura de Aomori",
      "ptName": "Região de Sanpachi-Kamikita da Província de Aomori",
      "thName": "ท้องถิ่นซัมปาจิ คามิกิตะ จังหวัดอะโอโมริ",
      "viName": "Vùng Sanpachi Kamikita, tỉnh Aomori",
      "inName": "Daerah Sanpachi Kamikita di Prefektur Aomori",
      "tlName": "Rehiyon ng Sanpachi-Kamikita sa Aomori Prefecture",
      "moName": "Аомори аймаг, Санпачи-Камикита",
      "buName": "ဆန်းပချိ ခမိခိတဒေသ၊အအိုမိုယိစီရင်စု",
      "khName": "តំបន់សានប៉ាជីកាមីគីតាក់នៃខេត្តអាអូម៉ូរី",
      "neName": "आओमोरी जिल्ला, सान्पाची खामिकिता क्षेत्र"
    },
    "class15": {
      "code": "020031",
      "name": "三八",
      "enName": "Sanpachi"
    },
    "class20": {
      "code": "0244600",
      "name": "階上町",
      "enName": "Hashikami Town",
      "kana": "はしかみちょう",
      "chName": "阶上町",
      "zhName": "階上町",
      "koName": "하시카미 정",
      "esName": "Pueblo de Hashikami",
      "ptName": "bairro de Hashikami",
      "thName": "เมืองฮาชิคามิ",
      "viName": "thị trấn Hashikami",
      "inName": "kota Hashikami",
      "tlName": "bayan ng Hashikami",
      "moName": "Хaшиками жижиг хот",
      "buName": "ဟာရှိကာ့မိ မြို့နယ်",
      "khName": "ទីប្រជុំជន ហាស៊ីកាមី",
      "neName": "हाशिकामी नगर"
    }
  },
  "0245000": {
    "office": {
      "code": "020000",
      "name": "青森県",
      "enName": "Aomori",
      "officeName": "青森地方気象台",
      "chName": "青森县",
      "zhName": "青森縣",
      "koName": "아오모리현",
      "esName": "Prefectura de Aomori",
      "ptName": "Província de Aomori",
      "thName": "จังหวัดอะโอโมริ",
      "viName": "Tỉnh Aomori",
      "inName": "Prefektur Aomori",
      "tlName": "Aomori Prefecture",
      "moName": "Аомори аймаг",
      "buName": "အာအိုးမိုးရိ ပြည်နယ်",
      "khName": "ខេត្ត អាអូម៉ូរី",
      "neName": "आओमोरी जिल्ला"
    },
    "class10": {
      "code": "020030",
      "name": "三八上北",
      "enName": "Sanpachi Kamikita",
      "chName": "青森县三八上北地方",
      "zhName": "青森縣三八上北地方",
      "koName": "아오모리 현 산파치 카미 키타 지방",
      "esName": "Región de Sanpachi-Kamikita, Prefectura de Aomori",
      "ptName": "Região de Sanpachi-Kamikita da Província de Aomori",
      "thName": "ท้องถิ่นซัมปาจิ คามิกิตะ จังหวัดอะโอโมริ",
      "viName": "Vùng Sanpachi Kamikita, tỉnh Aomori",
      "inName": "Daerah Sanpachi Kamikita di Prefektur Aomori",
      "tlName": "Rehiyon ng Sanpachi-Kamikita sa Aomori Prefecture",
      "moName": "Аомори аймаг, Санпачи-Камикита",
      "buName": "ဆန်းပချိ ခမိခိတဒေသ၊အအိုမိုယိစီရင်စု",
      "khName": "តំបន់សានប៉ាជីកាមីគីតាក់នៃខេត្តអាអូម៉ូរី",
      "neName": "आओमोरी जिल्ला, सान्पाची खामिकिता क्षेत्र"
    },
    "class15": {
      "code": "020031",
      "name": "三八",
      "enName": "Sanpachi"
    },
    "class20": {
      "code": "0245000",
      "name": "新郷村",
      "enName": "Shingo Village",
      "kana": "しんごうむら",
      "chName": "新乡村",
      "zhName": "新鄉村",
      "koName": "신고 촌",
      "esName": "Aldea de Shingo",
      "ptName": "povoado de Shingo",
      "thName": "หมู่บ้านชินโงะ",
      "viName": "làng Shingo",
      "inName": "desa Shingo",
      "tlName": "nayon ng Shingo",
      "moName": "Шинго тосгон",
      "buName": "ရှင်ဂို ကျေးရွာ",
      "khName": "ភូមិ ស៊ីងហ្គូ",
      "neName": "शिन्गो गाउँ"
    }
  },
  "0320100": {
    "office": {
      "code": "030000",
      "name": "岩手県",
      "enName": "Iwate",
      "officeName": "盛岡地方気象台",
      "chName": "岩手县",
      "zhName": "岩手縣",
      "koName": "이와테현",
      "esName": "Prefectura de Iwate",
      "ptName": "Província de Iwate",
      "thName": "จังหวัดอิวาเตะ",
      "viName": "Tỉnh Iwate",
      "inName": "Prefektur Iwate",
      "tlName": "Iwate Prefecture",
      "moName": "Иватэ аймаг",
      "buName": "အီဝတဲ့ ပြည်နယ်",
      "khName": "ខេត្ត អ៊ីវ៉ាតេ",
      "neName": "इवाते जिल्ला"
    },
    "class10": {
      "code": "030010",
      "name": "内陸",
      "enName": "Inland",
      "chName": "岩手县内陆地北部",
      "zhName": "岩手縣內陸北部",
      "koName": "이와테 현 내륙",
      "esName": "Interior de la Prefectura de Iwate",
      "ptName": "Região Interior da Província de Iwate",
      "thName": "ด้านในแผ่นดินของจังหวัดอิวาเตะ",
      "viName": "Vùng nội địa tỉnh Iwate",
      "inName": "Bagian Pedalaman di Prefektur Iwate",
      "tlName": "Bahagi ng lupain ng Iwate Prefecture",
      "moName": "Иватэ аймаг, дотоод нутаг",
      "buName": "အိဝတဲစီရင်စုကုန်းတွင်းဒေသ",
      "khName": "តំបន់ដីឆ្ងាយពីឆ្នេរនៃខេត្តអ៊ីវ៉ាទេ",
      "neName": "इवाते जिल्लाको भित्री (समुद्री किनारबाट टाढा) क्षेत्र"
    },
    "class15": {
      "code": "030011",
      "name": "盛岡地域",
      "enName": "Morioka Area"
    },
    "class20": {
      "code": "0320100",
      "name": "盛岡市",
      "enName": "Morioka City",
      "kana": "もりおかし",
      "chName": "盛冈市",
      "zhName": "盛岡市",
      "koName": "모리오카 시",
      "esName": "Ciudad de Morioka",
      "ptName": "cidade de Morioka",
      "thName": "เมืองโมริโอกะ",
      "viName": "thành phố Morioka",
      "inName": "kota Morioka",
      "tlName": "siyudad ng Morioka",
      "moName": "Мориока хот",
      "buName": "မိုရီယိုကာ့ မြို့",
      "khName": "ទីក្រុង ម៉ូរីអូកា",
      "neName": "मोरिओका सहर"
    }
  },
  "0320200": {
    "office": {
      "code": "030000",
      "name": "岩手県",
      "enName": "Iwate",
      "officeName": "盛岡地方気象台",
      "chName": "岩手县",
      "zhName": "岩手縣",
      "koName": "이와테현",
      "esName": "Prefectura de Iwate",
      "ptName": "Província de Iwate",
      "thName": "จังหวัดอิวาเตะ",
      "viName": "Tỉnh Iwate",
      "inName": "Prefektur Iwate",
      "tlName": "Iwate Prefecture",
      "moName": "Иватэ аймаг",
      "buName": "အီဝတဲ့ ပြည်နယ်",
      "khName": "ខេត្ត អ៊ីវ៉ាតេ",
      "neName": "इवाते जिल्ला"
    },
    "class10": {
      "code": "030020",
      "name": "沿岸北部",
      "enName": "Northern Coast",
      "chName": "岩手县沿岸北部",
      "zhName": "岩手縣沿岸北部",
      "koName": "이와테 현 연안 북부",
      "esName": "Costa norte de Prefectura de Iwate",
      "ptName": "Litoral Norte da Província de Iwate",
      "thName": "ชายฝั่งตอนเหนือของจังหวัดอิวาเตะ",
      "viName": "Miền Bắc bờ biển tỉnh Iwate",
      "inName": "Pantai Utara di Prefektur Iwate",
      "tlName": "Hilagang bahagi ng baybayin ng Iwate Prefecture",
      "moName": "Иватэ аймаг, хойд эрэг",
      "buName": "အိဝတဲစီရင်စု မြောက်ပိုင်းကမ်းခြေ",
      "khName": "តំបន់ខាងជើងឆ្នេរសមុទ្រនៃខេត្តអ៊ីវ៉ាតិ",
      "neName": " इवाते जिल्लाको समुद्री किनारको उत्तरी भाग "
    },
    "class15": {
      "code": "030022",
      "name": "宮古地域",
      "enName": "Miyako Area"
    },
    "class20": {
      "code": "0320200",
      "name": "宮古市",
      "enName": "Miyako City",
      "kana": "みやこし",
      "chName": "宫古市",
      "zhName": "宮古市",
      "koName": "미야코 시",
      "esName": "Ciudad de Miyako",
      "ptName": "cidade de Miyako",
      "thName": "เมืองมิยาโกะ",
      "viName": "thành phố Miyako",
      "inName": "kota Miyako",
      "tlName": "siyudad ng Miyako",
      "moName": "Мияко хот",
      "buName": "မီယာကော့ မြို့",
      "khName": "ទីក្រុង មីយ៉ាកុ",
      "neName": "मियाको सहर"
    }
  },
  "0320300": {
    "office": {
      "code": "030000",
      "name": "岩手県",
      "enName": "Iwate",
      "officeName": "盛岡地方気象台",
      "chName": "岩手县",
      "zhName": "岩手縣",
      "koName": "이와테현",
      "esName": "Prefectura de Iwate",
      "ptName": "Província de Iwate",
      "thName": "จังหวัดอิวาเตะ",
      "viName": "Tỉnh Iwate",
      "inName": "Prefektur Iwate",
      "tlName": "Iwate Prefecture",
      "moName": "Иватэ аймаг",
      "buName": "အီဝတဲ့ ပြည်နယ်",
      "khName": "ខេត្ត អ៊ីវ៉ាតេ",
      "neName": "इवाते जिल्ला"
    },
    "class10": {
      "code": "030030",
      "name": "沿岸南部",
      "enName": "Southern Coast",
      "chName": "岩手县沿岸南部",
      "zhName": "岩手縣沿岸南部",
      "koName": "이와테 현 연안 남부",
      "esName": "Costa sur de Prefectura de Iwate",
      "ptName": "Litoral Sul da Província de Iwate",
      "thName": "ชายฝั่งตอนใต้ของจังหวัดอิวาเตะ",
      "viName": "Miền Nam bờ biển tỉnh Iwate",
      "inName": "Pantai Selatan di Prefektur Iwate",
      "tlName": "Timog na bahagi ng baybayin ng Iwate Prefecture",
      "moName": "Иватэ аймаг, өмнөд эрэг",
      "buName": "အိဝတဲစီရင်စု တောင်ပိုင်းကမ်းခြေ",
      "khName": "តំបន់ខាងត្បូងឆ្នេរសមុទ្រនៃខេត្តអ៊ីវ៉ាតិ",
      "neName": " इवाते जिल्लाको समुद्री किनारको दक्षिणी "
    },
    "class15": {
      "code": "030032",
      "name": "大船渡地域",
      "enName": "Ofunato Area"
    },
    "class20": {
      "code": "0320300",
      "name": "大船渡市",
      "enName": "Ofunato City",
      "kana": "おおふなとし",
      "chName": "大船渡市",
      "zhName": "大船渡市",
      "koName": "오후나토 시",
      "esName": "Ciudad de Ofunato",
      "ptName": "cidade de Ofunato",
      "thName": "เมืองโอฟุนาโตะ",
      "viName": "thành phố Ofunato",
      "inName": "kota Ofunato",
      "tlName": "siyudad ng Ofunato",
      "moName": "Офүнато хот",
      "buName": "အိုဖူနာ့တော့ မြို့",
      "khName": "ទីក្រុង អូហ្វូនេតុ",
      "neName": "ओफुनातो सहर"
    }
  },
  "0320500": {
    "office": {
      "code": "030000",
      "name": "岩手県",
      "enName": "Iwate",
      "officeName": "盛岡地方気象台",
      "chName": "岩手县",
      "zhName": "岩手縣",
      "koName": "이와테현",
      "esName": "Prefectura de Iwate",
      "ptName": "Província de Iwate",
      "thName": "จังหวัดอิวาเตะ",
      "viName": "Tỉnh Iwate",
      "inName": "Prefektur Iwate",
      "tlName": "Iwate Prefecture",
      "moName": "Иватэ аймаг",
      "buName": "အီဝတဲ့ ပြည်နယ်",
      "khName": "ខេត្ត អ៊ីវ៉ាតេ",
      "neName": "इवाते जिल्ला"
    },
    "class10": {
      "code": "030010",
      "name": "内陸",
      "enName": "Inland",
      "chName": "岩手县内陆地北部",
      "zhName": "岩手縣內陸北部",
      "koName": "이와테 현 내륙",
      "esName": "Interior de la Prefectura de Iwate",
      "ptName": "Região Interior da Província de Iwate",
      "thName": "ด้านในแผ่นดินของจังหวัดอิวาเตะ",
      "viName": "Vùng nội địa tỉnh Iwate",
      "inName": "Bagian Pedalaman di Prefektur Iwate",
      "tlName": "Bahagi ng lupain ng Iwate Prefecture",
      "moName": "Иватэ аймаг, дотоод нутаг",
      "buName": "အိဝတဲစီရင်စုကုန်းတွင်းဒေသ",
      "khName": "តំបន់ដីឆ្ងាយពីឆ្នេរនៃខេត្តអ៊ីវ៉ាទេ",
      "neName": "इवाते जिल्लाको भित्री (समुद्री किनारबाट टाढा) क्षेत्र"
    },
    "class15": {
      "code": "030013",
      "name": "花北地域",
      "enName": "Hanakita Area"
    },
    "class20": {
      "code": "0320500",
      "name": "花巻市",
      "enName": "Hanamaki City",
      "kana": "はなまきし",
      "chName": "花卷市",
      "zhName": "花卷市",
      "koName": "하나마키 시",
      "esName": "Ciudad de Hanamaki",
      "ptName": "cidade de Hanamaki",
      "thName": "เมืองฮานามากิ",
      "viName": "thành phố Hanamaki",
      "inName": "kota Hanamaki",
      "tlName": "siyudad ng Hanamaki",
      "moName": "Ханамаки хот",
      "buName": "ဟာနာမာ့ကိ မြို့",
      "khName": "ទីក្រុង ហាណាម៉ាគី",
      "neName": "हानामाकी सहर"
    }
  },
  "0320600": {
    "office": {
      "code": "030000",
      "name": "岩手県",
      "enName": "Iwate",
      "officeName": "盛岡地方気象台",
      "chName": "岩手县",
      "zhName": "岩手縣",
      "koName": "이와테현",
      "esName": "Prefectura de Iwate",
      "ptName": "Província de Iwate",
      "thName": "จังหวัดอิวาเตะ",
      "viName": "Tỉnh Iwate",
      "inName": "Prefektur Iwate",
      "tlName": "Iwate Prefecture",
      "moName": "Иватэ аймаг",
      "buName": "အီဝတဲ့ ပြည်နယ်",
      "khName": "ខេត្ត អ៊ីវ៉ាតេ",
      "neName": "इवाते जिल्ला"
    },
    "class10": {
      "code": "030010",
      "name": "内陸",
      "enName": "Inland",
      "chName": "岩手县内陆地北部",
      "zhName": "岩手縣內陸北部",
      "koName": "이와테 현 내륙",
      "esName": "Interior de la Prefectura de Iwate",
      "ptName": "Região Interior da Província de Iwate",
      "thName": "ด้านในแผ่นดินของจังหวัดอิวาเตะ",
      "viName": "Vùng nội địa tỉnh Iwate",
      "inName": "Bagian Pedalaman di Prefektur Iwate",
      "tlName": "Bahagi ng lupain ng Iwate Prefecture",
      "moName": "Иватэ аймаг, дотоод нутаг",
      "buName": "အိဝတဲစီရင်စုကုန်းတွင်းဒေသ",
      "khName": "តំបន់ដីឆ្ងាយពីឆ្នេរនៃខេត្តអ៊ីវ៉ាទេ",
      "neName": "इवाते जिल्लाको भित्री (समुद्री किनारबाट टाढा) क्षेत्र"
    },
    "class15": {
      "code": "030013",
      "name": "花北地域",
      "enName": "Hanakita Area"
    },
    "class20": {
      "code": "0320600",
      "name": "北上市",
      "enName": "Kitakami City",
      "kana": "きたかみし",
      "chName": "北上市",
      "zhName": "北上市",
      "koName": "기타카미 시",
      "esName": "Ciudad de Kitakami",
      "ptName": "cidade de Kitakami",
      "thName": "เมืองคิตะคามิ",
      "viName": "thành phố Kitakami",
      "inName": "kota Kitakami",
      "tlName": "siyudad ng Kitakami",
      "moName": "Китаками хот",
      "buName": "ကီတာကာ့မိ မြို့",
      "khName": "ទីក្រុង គីតាកាមិ",
      "neName": "किताकामी सहर"
    }
  },
  "0320700": {
    "office": {
      "code": "030000",
      "name": "岩手県",
      "enName": "Iwate",
      "officeName": "盛岡地方気象台",
      "chName": "岩手县",
      "zhName": "岩手縣",
      "koName": "이와테현",
      "esName": "Prefectura de Iwate",
      "ptName": "Província de Iwate",
      "thName": "จังหวัดอิวาเตะ",
      "viName": "Tỉnh Iwate",
      "inName": "Prefektur Iwate",
      "tlName": "Iwate Prefecture",
      "moName": "Иватэ аймаг",
      "buName": "အီဝတဲ့ ပြည်နယ်",
      "khName": "ខេត្ត អ៊ីវ៉ាតេ",
      "neName": "इवाते जिल्ला"
    },
    "class10": {
      "code": "030020",
      "name": "沿岸北部",
      "enName": "Northern Coast",
      "chName": "岩手县沿岸北部",
      "zhName": "岩手縣沿岸北部",
      "koName": "이와테 현 연안 북부",
      "esName": "Costa norte de Prefectura de Iwate",
      "ptName": "Litoral Norte da Província de Iwate",
      "thName": "ชายฝั่งตอนเหนือของจังหวัดอิวาเตะ",
      "viName": "Miền Bắc bờ biển tỉnh Iwate",
      "inName": "Pantai Utara di Prefektur Iwate",
      "tlName": "Hilagang bahagi ng baybayin ng Iwate Prefecture",
      "moName": "Иватэ аймаг, хойд эрэг",
      "buName": "အိဝတဲစီရင်စု မြောက်ပိုင်းကမ်းခြေ",
      "khName": "តំបន់ខាងជើងឆ្នេរសមុទ្រនៃខេត្តអ៊ីវ៉ាតិ",
      "neName": " इवाते जिल्लाको समुद्री किनारको उत्तरी भाग "
    },
    "class15": {
      "code": "030021",
      "name": "久慈地域",
      "enName": "Kuji Area"
    },
    "class20": {
      "code": "0320700",
      "name": "久慈市",
      "enName": "Kuji City",
      "kana": "くじし",
      "chName": "久慈市",
      "zhName": "久慈市",
      "koName": "구지 시",
      "esName": "Ciudad de Kuji",
      "ptName": "cidade de Kuji",
      "thName": "เมืองคุจิ",
      "viName": "thành phố Kuji",
      "inName": "kota Kuji",
      "tlName": "siyudad ng Kuji",
      "moName": "Күжи хот",
      "buName": "ခူကျိ မြို့",
      "khName": "ទីក្រុង គូជី",
      "neName": "कुजी सहर"
    }
  },
  "0320800": {
    "office": {
      "code": "030000",
      "name": "岩手県",
      "enName": "Iwate",
      "officeName": "盛岡地方気象台",
      "chName": "岩手县",
      "zhName": "岩手縣",
      "koName": "이와테현",
      "esName": "Prefectura de Iwate",
      "ptName": "Província de Iwate",
      "thName": "จังหวัดอิวาเตะ",
      "viName": "Tỉnh Iwate",
      "inName": "Prefektur Iwate",
      "tlName": "Iwate Prefecture",
      "moName": "Иватэ аймаг",
      "buName": "အီဝတဲ့ ပြည်နယ်",
      "khName": "ខេត្ត អ៊ីវ៉ាតេ",
      "neName": "इवाते जिल्ला"
    },
    "class10": {
      "code": "030010",
      "name": "内陸",
      "enName": "Inland",
      "chName": "岩手县内陆地北部",
      "zhName": "岩手縣內陸北部",
      "koName": "이와테 현 내륙",
      "esName": "Interior de la Prefectura de Iwate",
      "ptName": "Região Interior da Província de Iwate",
      "thName": "ด้านในแผ่นดินของจังหวัดอิวาเตะ",
      "viName": "Vùng nội địa tỉnh Iwate",
      "inName": "Bagian Pedalaman di Prefektur Iwate",
      "tlName": "Bahagi ng lupain ng Iwate Prefecture",
      "moName": "Иватэ аймаг, дотоод нутаг",
      "buName": "အိဝတဲစီရင်စုကုန်းတွင်းဒေသ",
      "khName": "តំបន់ដីឆ្ងាយពីឆ្នេរនៃខេត្តអ៊ីវ៉ាទេ",
      "neName": "इवाते जिल्लाको भित्री (समुद्री किनारबाट टाढा) क्षेत्र"
    },
    "class15": {
      "code": "030014",
      "name": "遠野地域",
      "enName": "Tono Area"
    },
    "class20": {
      "code": "0320800",
      "name": "遠野市",
      "enName": "Tono City",
      "kana": "とおのし",
      "chName": "远野市",
      "zhName": "遠野市",
      "koName": "도노 시",
      "esName": "Ciudad de Tōno",
      "ptName": "cidade de Tono",
      "thName": "เมืองโทโนะ",
      "viName": "thành phố Tono",
      "inName": "kota Tono",
      "tlName": "siyudad ng Tono",
      "moName": "Тоно хот",
      "buName": "တိုနော့ မြို့",
      "khName": "ទីក្រុង តូណូ",
      "neName": "तोनो सहर"
    }
  },
  "0320900": {
    "office": {
      "code": "030000",
      "name": "岩手県",
      "enName": "Iwate",
      "officeName": "盛岡地方気象台",
      "chName": "岩手县",
      "zhName": "岩手縣",
      "koName": "이와테현",
      "esName": "Prefectura de Iwate",
      "ptName": "Província de Iwate",
      "thName": "จังหวัดอิวาเตะ",
      "viName": "Tỉnh Iwate",
      "inName": "Prefektur Iwate",
      "tlName": "Iwate Prefecture",
      "moName": "Иватэ аймаг",
      "buName": "အီဝတဲ့ ပြည်နယ်",
      "khName": "ខេត្ត អ៊ីវ៉ាតេ",
      "neName": "इवाते जिल्ला"
    },
    "class10": {
      "code": "030010",
      "name": "内陸",
      "enName": "Inland",
      "chName": "岩手县内陆地北部",
      "zhName": "岩手縣內陸北部",
      "koName": "이와테 현 내륙",
      "esName": "Interior de la Prefectura de Iwate",
      "ptName": "Região Interior da Província de Iwate",
      "thName": "ด้านในแผ่นดินของจังหวัดอิวาเตะ",
      "viName": "Vùng nội địa tỉnh Iwate",
      "inName": "Bagian Pedalaman di Prefektur Iwate",
      "tlName": "Bahagi ng lupain ng Iwate Prefecture",
      "moName": "Иватэ аймаг, дотоод нутаг",
      "buName": "အိဝတဲစီရင်စုကုန်းတွင်းဒေသ",
      "khName": "តំបន់ដីឆ្ងាយពីឆ្នេរនៃខេត្តអ៊ីវ៉ាទេ",
      "neName": "इवाते जिल्लाको भित्री (समुद्री किनारबाट टाढा) क्षेत्र"
    },
    "class15": {
      "code": "030016",
      "name": "両磐地域",
      "enName": "Ryoban Area"
    },
    "class20": {
      "code": "0320900",
      "name": "一関市",
      "enName": "Ichinoseki City",
      "kana": "いちのせきし",
      "chName": "一关市",
      "zhName": "一關市",
      "koName": "이치노세키 시",
      "esName": "Ciudad de Ichinoseki",
      "ptName": "cidade de Ichinoseki",
      "thName": "เมืองอิจิโนะเซกิ",
      "viName": "thành phố Ichinoseki",
      "inName": "kota Ichinoseki",
      "tlName": "siyudad ng Ichinoseki",
      "moName": "Ичиносеки хот",
      "buName": "အီကျိနောဆေ့ကိ မြို့",
      "khName": "ទីក្រុង អ៊ីឈីនណូសេគី",
      "neName": "इचिनोसेकी सहर"
    }
  },
  "0321000": {
    "office": {
      "code": "030000",
      "name": "岩手県",
      "enName": "Iwate",
      "officeName": "盛岡地方気象台",
      "chName": "岩手县",
      "zhName": "岩手縣",
      "koName": "이와테현",
      "esName": "Prefectura de Iwate",
      "ptName": "Província de Iwate",
      "thName": "จังหวัดอิวาเตะ",
      "viName": "Tỉnh Iwate",
      "inName": "Prefektur Iwate",
      "tlName": "Iwate Prefecture",
      "moName": "Иватэ аймаг",
      "buName": "အီဝတဲ့ ပြည်နယ်",
      "khName": "ខេត្ត អ៊ីវ៉ាតេ",
      "neName": "इवाते जिल्ला"
    },
    "class10": {
      "code": "030030",
      "name": "沿岸南部",
      "enName": "Southern Coast",
      "chName": "岩手县沿岸南部",
      "zhName": "岩手縣沿岸南部",
      "koName": "이와테 현 연안 남부",
      "esName": "Costa sur de Prefectura de Iwate",
      "ptName": "Litoral Sul da Província de Iwate",
      "thName": "ชายฝั่งตอนใต้ของจังหวัดอิวาเตะ",
      "viName": "Miền Nam bờ biển tỉnh Iwate",
      "inName": "Pantai Selatan di Prefektur Iwate",
      "tlName": "Timog na bahagi ng baybayin ng Iwate Prefecture",
      "moName": "Иватэ аймаг, өмнөд эрэг",
      "buName": "အိဝတဲစီရင်စု တောင်ပိုင်းကမ်းခြေ",
      "khName": "តំបន់ខាងត្បូងឆ្នេរសមុទ្រនៃខេត្តអ៊ីវ៉ាតិ",
      "neName": " इवाते जिल्लाको समुद्री किनारको दक्षिणी "
    },
    "class15": {
      "code": "030032",
      "name": "大船渡地域",
      "enName": "Ofunato Area"
    },
    "class20": {
      "code": "0321000",
      "name": "陸前高田市",
      "enName": "Rikuzentakata City",
      "kana": "りくぜんたかたし",
      "chName": "陆前高田市",
      "zhName": "陸前髙田市",
      "koName": "리쿠젠타카타 시",
      "esName": "Ciudad de Rikuzen-Takata",
      "ptName": "cidade de Rikuzentakata",
      "thName": "เมืองริคุเซนทากาตะ",
      "viName": "thành phố Rikuzentakata",
      "inName": "kota Rikuzentakata",
      "tlName": "siyudad ng Rikuzentakata",
      "moName": "Рикүзэнтаката хот",
      "buName": "ရီကူဇန်ဒါ့ကာ့တ မြို့",
      "khName": "ទីក្រុង រីគុហ្សេនតាកាតា",
      "neName": "रिकुजेन्ताकाता सहर"
    }
  },
  "0321100": {
    "office": {
      "code": "030000",
      "name": "岩手県",
      "enName": "Iwate",
      "officeName": "盛岡地方気象台",
      "chName": "岩手县",
      "zhName": "岩手縣",
      "koName": "이와테현",
      "esName": "Prefectura de Iwate",
      "ptName": "Província de Iwate",
      "thName": "จังหวัดอิวาเตะ",
      "viName": "Tỉnh Iwate",
      "inName": "Prefektur Iwate",
      "tlName": "Iwate Prefecture",
      "moName": "Иватэ аймаг",
      "buName": "အီဝတဲ့ ပြည်နယ်",
      "khName": "ខេត្ត អ៊ីវ៉ាតេ",
      "neName": "इवाते जिल्ला"
    },
    "class10": {
      "code": "030030",
      "name": "沿岸南部",
      "enName": "Southern Coast",
      "chName": "岩手县沿岸南部",
      "zhName": "岩手縣沿岸南部",
      "koName": "이와테 현 연안 남부",
      "esName": "Costa sur de Prefectura de Iwate",
      "ptName": "Litoral Sul da Província de Iwate",
      "thName": "ชายฝั่งตอนใต้ของจังหวัดอิวาเตะ",
      "viName": "Miền Nam bờ biển tỉnh Iwate",
      "inName": "Pantai Selatan di Prefektur Iwate",
      "tlName": "Timog na bahagi ng baybayin ng Iwate Prefecture",
      "moName": "Иватэ аймаг, өмнөд эрэг",
      "buName": "အိဝတဲစီရင်စု တောင်ပိုင်းကမ်းခြေ",
      "khName": "តំបន់ខាងត្បូងឆ្នេរសមុទ្រនៃខេត្តអ៊ីវ៉ាតិ",
      "neName": " इवाते जिल्लाको समुद्री किनारको दक्षिणी "
    },
    "class15": {
      "code": "030031",
      "name": "釜石地域",
      "enName": "Kamaishi Area"
    },
    "class20": {
      "code": "0321100",
      "name": "釜石市",
      "enName": "Kamaishi City",
      "kana": "かまいしし",
      "chName": "釜石市",
      "zhName": "釜石市",
      "koName": "가마이 시",
      "esName": "Ciudad de Kamaishi",
      "ptName": "cidade de Kamaishi",
      "thName": "เมืองคามาอิชิ",
      "viName": "thành phố Kamaishi",
      "inName": "kota Kamaishi",
      "tlName": "siyudad ng Kamaishi",
      "moName": "Камайши хот",
      "buName": "ခါမားအိရှိ မြို့",
      "khName": "ទីក្រុង កាម៉ៃស៊ី",
      "neName": "कामाइशि सहर"
    }
  },
  "0321300": {
    "office": {
      "code": "030000",
      "name": "岩手県",
      "enName": "Iwate",
      "officeName": "盛岡地方気象台",
      "chName": "岩手县",
      "zhName": "岩手縣",
      "koName": "이와테현",
      "esName": "Prefectura de Iwate",
      "ptName": "Província de Iwate",
      "thName": "จังหวัดอิวาเตะ",
      "viName": "Tỉnh Iwate",
      "inName": "Prefektur Iwate",
      "tlName": "Iwate Prefecture",
      "moName": "Иватэ аймаг",
      "buName": "အီဝတဲ့ ပြည်နယ်",
      "khName": "ខេត្ត អ៊ីវ៉ាតេ",
      "neName": "इवाते जिल्ला"
    },
    "class10": {
      "code": "030010",
      "name": "内陸",
      "enName": "Inland",
      "chName": "岩手县内陆地北部",
      "zhName": "岩手縣內陸北部",
      "koName": "이와테 현 내륙",
      "esName": "Interior de la Prefectura de Iwate",
      "ptName": "Região Interior da Província de Iwate",
      "thName": "ด้านในแผ่นดินของจังหวัดอิวาเตะ",
      "viName": "Vùng nội địa tỉnh Iwate",
      "inName": "Bagian Pedalaman di Prefektur Iwate",
      "tlName": "Bahagi ng lupain ng Iwate Prefecture",
      "moName": "Иватэ аймаг, дотоод нутаг",
      "buName": "အိဝတဲစီရင်စုကုန်းတွင်းဒေသ",
      "khName": "តំបន់ដីឆ្ងាយពីឆ្នេរនៃខេត្តអ៊ីវ៉ាទេ",
      "neName": "इवाते जिल्लाको भित्री (समुद्री किनारबाट टाढा) क्षेत्र"
    },
    "class15": {
      "code": "030012",
      "name": "二戸地域",
      "enName": "Ninohe Area"
    },
    "class20": {
      "code": "0321300",
      "name": "二戸市",
      "enName": "Ninohe City",
      "kana": "にのへし",
      "chName": "二户市",
      "zhName": "二戶市",
      "koName": "니노헤 시",
      "esName": "Ciudad de Nihohe",
      "ptName": "cidade de Ninohe",
      "thName": "เมืองนิโนะเฮะ",
      "viName": "thành phố Ninohe",
      "inName": "kota Ninohe",
      "tlName": "siyudad ng Ninohe",
      "moName": "Нинохэ хот",
      "buName": "နီးနော့ဟဲ့ မြို့",
      "khName": "ទីក្រុង នីណូហេ",
      "neName": "निनोहे सहर"
    }
  },
  "0321400": {
    "office": {
      "code": "030000",
      "name": "岩手県",
      "enName": "Iwate",
      "officeName": "盛岡地方気象台",
      "chName": "岩手县",
      "zhName": "岩手縣",
      "koName": "이와테현",
      "esName": "Prefectura de Iwate",
      "ptName": "Província de Iwate",
      "thName": "จังหวัดอิวาเตะ",
      "viName": "Tỉnh Iwate",
      "inName": "Prefektur Iwate",
      "tlName": "Iwate Prefecture",
      "moName": "Иватэ аймаг",
      "buName": "အီဝတဲ့ ပြည်နယ်",
      "khName": "ខេត្ត អ៊ីវ៉ាតេ",
      "neName": "इवाते जिल्ला"
    },
    "class10": {
      "code": "030010",
      "name": "内陸",
      "enName": "Inland",
      "chName": "岩手县内陆地北部",
      "zhName": "岩手縣內陸北部",
      "koName": "이와테 현 내륙",
      "esName": "Interior de la Prefectura de Iwate",
      "ptName": "Região Interior da Província de Iwate",
      "thName": "ด้านในแผ่นดินของจังหวัดอิวาเตะ",
      "viName": "Vùng nội địa tỉnh Iwate",
      "inName": "Bagian Pedalaman di Prefektur Iwate",
      "tlName": "Bahagi ng lupain ng Iwate Prefecture",
      "moName": "Иватэ аймаг, дотоод нутаг",
      "buName": "အိဝတဲစီရင်စုကုန်းတွင်းဒေသ",
      "khName": "តំបន់ដីឆ្ងាយពីឆ្នេរនៃខេត្តអ៊ីវ៉ាទេ",
      "neName": "इवाते जिल्लाको भित्री (समुद्री किनारबाट टाढा) क्षेत्र"
    },
    "class15": {
      "code": "030011",
      "name": "盛岡地域",
      "enName": "Morioka Area"
    },
    "class20": {
      "code": "0321400",
      "name": "八幡平市",
      "enName": "Hachimantai City",
      "kana": "はちまんたいし",
      "chName": "八幡平市",
      "zhName": "八幡平市",
      "koName": "하치만타이 시",
      "esName": "Ciudad de Hachimantai",
      "ptName": "cidade de Hachimantai",
      "thName": "เมืองฮาจิมันไต",
      "viName": "thành phố Hachimantai",
      "inName": "kota Hachimantai",
      "tlName": "siyudad ng Hachimantai",
      "moName": "Хачимантай хот",
      "buName": "ဟာကျိမန်းတိုင် မြို့",
      "khName": "ទីក្រុង ហាជីម៉ានតាយ",
      "neName": "हाचिमान्ताई सहर"
    }
  },
  "0321500": {
    "office": {
      "code": "030000",
      "name": "岩手県",
      "enName": "Iwate",
      "officeName": "盛岡地方気象台",
      "chName": "岩手县",
      "zhName": "岩手縣",
      "koName": "이와테현",
      "esName": "Prefectura de Iwate",
      "ptName": "Província de Iwate",
      "thName": "จังหวัดอิวาเตะ",
      "viName": "Tỉnh Iwate",
      "inName": "Prefektur Iwate",
      "tlName": "Iwate Prefecture",
      "moName": "Иватэ аймаг",
      "buName": "အီဝတဲ့ ပြည်နယ်",
      "khName": "ខេត្ត អ៊ីវ៉ាតេ",
      "neName": "इवाते जिल्ला"
    },
    "class10": {
      "code": "030010",
      "name": "内陸",
      "enName": "Inland",
      "chName": "岩手县内陆地北部",
      "zhName": "岩手縣內陸北部",
      "koName": "이와테 현 내륙",
      "esName": "Interior de la Prefectura de Iwate",
      "ptName": "Região Interior da Província de Iwate",
      "thName": "ด้านในแผ่นดินของจังหวัดอิวาเตะ",
      "viName": "Vùng nội địa tỉnh Iwate",
      "inName": "Bagian Pedalaman di Prefektur Iwate",
      "tlName": "Bahagi ng lupain ng Iwate Prefecture",
      "moName": "Иватэ аймаг, дотоод нутаг",
      "buName": "အိဝတဲစီရင်စုကုန်းတွင်းဒေသ",
      "khName": "តំបន់ដីឆ្ងាយពីឆ្នេរនៃខេត្តអ៊ីវ៉ាទេ",
      "neName": "इवाते जिल्लाको भित्री (समुद्री किनारबाट टाढा) क्षेत्र"
    },
    "class15": {
      "code": "030015",
      "name": "奥州金ケ崎地域",
      "enName": "Oshu Kanegasaki Area"
    },
    "class20": {
      "code": "0321500",
      "name": "奥州市",
      "enName": "Oshu City",
      "kana": "おうしゅうし",
      "chName": "奥州市",
      "zhName": "奧州市",
      "koName": "오슈 시",
      "esName": "Ciudad de Oshu",
      "ptName": "cidade de Oshu",
      "thName": "เมืองโอชุ",
      "viName": "thành phố Oshu",
      "inName": "kota Oshu",
      "tlName": "siyudad ng Oshu",
      "moName": "Ошү хот",
      "buName": "အိုရှု မြို့",
      "khName": "ទីក្រុង អូស៊ុ",
      "neName": "ओसु सहर"
    }
  },
  "0321600": {
    "office": {
      "code": "030000",
      "name": "岩手県",
      "enName": "Iwate",
      "officeName": "盛岡地方気象台",
      "chName": "岩手县",
      "zhName": "岩手縣",
      "koName": "이와테현",
      "esName": "Prefectura de Iwate",
      "ptName": "Província de Iwate",
      "thName": "จังหวัดอิวาเตะ",
      "viName": "Tỉnh Iwate",
      "inName": "Prefektur Iwate",
      "tlName": "Iwate Prefecture",
      "moName": "Иватэ аймаг",
      "buName": "အီဝတဲ့ ပြည်နယ်",
      "khName": "ខេត្ត អ៊ីវ៉ាតេ",
      "neName": "इवाते जिल्ला"
    },
    "class10": {
      "code": "030010",
      "name": "内陸",
      "enName": "Inland",
      "chName": "岩手县内陆地北部",
      "zhName": "岩手縣內陸北部",
      "koName": "이와테 현 내륙",
      "esName": "Interior de la Prefectura de Iwate",
      "ptName": "Região Interior da Província de Iwate",
      "thName": "ด้านในแผ่นดินของจังหวัดอิวาเตะ",
      "viName": "Vùng nội địa tỉnh Iwate",
      "inName": "Bagian Pedalaman di Prefektur Iwate",
      "tlName": "Bahagi ng lupain ng Iwate Prefecture",
      "moName": "Иватэ аймаг, дотоод нутаг",
      "buName": "အိဝတဲစီရင်စုကုန်းတွင်းဒေသ",
      "khName": "តំបន់ដីឆ្ងាយពីឆ្នេរនៃខេត្តអ៊ីវ៉ាទេ",
      "neName": "इवाते जिल्लाको भित्री (समुद्री किनारबाट टाढा) क्षेत्र"
    },
    "class15": {
      "code": "030011",
      "name": "盛岡地域",
      "enName": "Morioka Area"
    },
    "class20": {
      "code": "0321600",
      "name": "滝沢市",
      "enName": "Takizawa City",
      "kana": "たきざわし",
      "chName": "泷泽市",
      "zhName": "瀧澤市",
      "koName": "다키자와 시",
      "esName": "Ciudad de Takizawa",
      "ptName": "cidade de Takizawa",
      "thName": "เมืองทากิซาวะ",
      "viName": "Thành phố Takizawa",
      "inName": "Kota Takizawa",
      "tlName": "Lungsod ng Takizawa",
      "moName": "Такисава хот",
      "buName": "တာကိဇာ့ဝ မြို့",
      "khName": "ទីក្រុង តាគីហ្សាវ៉ា",
      "neName": "ताकिजावा सहर"
    }
  },
  "0330100": {
    "office": {
      "code": "030000",
      "name": "岩手県",
      "enName": "Iwate",
      "officeName": "盛岡地方気象台",
      "chName": "岩手县",
      "zhName": "岩手縣",
      "koName": "이와테현",
      "esName": "Prefectura de Iwate",
      "ptName": "Província de Iwate",
      "thName": "จังหวัดอิวาเตะ",
      "viName": "Tỉnh Iwate",
      "inName": "Prefektur Iwate",
      "tlName": "Iwate Prefecture",
      "moName": "Иватэ аймаг",
      "buName": "အီဝတဲ့ ပြည်နယ်",
      "khName": "ខេត្ត អ៊ីវ៉ាតេ",
      "neName": "इवाते जिल्ला"
    },
    "class10": {
      "code": "030010",
      "name": "内陸",
      "enName": "Inland",
      "chName": "岩手县内陆地北部",
      "zhName": "岩手縣內陸北部",
      "koName": "이와테 현 내륙",
      "esName": "Interior de la Prefectura de Iwate",
      "ptName": "Região Interior da Província de Iwate",
      "thName": "ด้านในแผ่นดินของจังหวัดอิวาเตะ",
      "viName": "Vùng nội địa tỉnh Iwate",
      "inName": "Bagian Pedalaman di Prefektur Iwate",
      "tlName": "Bahagi ng lupain ng Iwate Prefecture",
      "moName": "Иватэ аймаг, дотоод нутаг",
      "buName": "အိဝတဲစီရင်စုကုန်းတွင်းဒေသ",
      "khName": "តំបន់ដីឆ្ងាយពីឆ្នេរនៃខេត្តអ៊ីវ៉ាទេ",
      "neName": "इवाते जिल्लाको भित्री (समुद्री किनारबाट टाढा) क्षेत्र"
    },
    "class15": {
      "code": "030011",
      "name": "盛岡地域",
      "enName": "Morioka Area"
    },
    "class20": {
      "code": "0330100",
      "name": "雫石町",
      "enName": "Shizukuishi Town",
      "kana": "しずくいしちょう",
      "chName": "雫石町",
      "zhName": "雫石町",
      "koName": "시즈쿠이시 정",
      "esName": "Pueblo de Shizukuishi",
      "ptName": "bairro de Shizukuishi",
      "thName": "เมืองชิสึคุอิชิ",
      "viName": "thị trấn Shizukuishi",
      "inName": "kota Shizukuishi",
      "tlName": "bayan ng Shizukuishi",
      "moName": "Шизүкүиши жижиг хот",
      "buName": "ရှီဇုကုယိရှိ မြို့နယ်",
      "khName": "ទីប្រជុំជន ស៊ីហ្សូគុយស៊ី",
      "neName": "शिजुकुइशी नगर"
    }
  },
  "0330200": {
    "office": {
      "code": "030000",
      "name": "岩手県",
      "enName": "Iwate",
      "officeName": "盛岡地方気象台",
      "chName": "岩手县",
      "zhName": "岩手縣",
      "koName": "이와테현",
      "esName": "Prefectura de Iwate",
      "ptName": "Província de Iwate",
      "thName": "จังหวัดอิวาเตะ",
      "viName": "Tỉnh Iwate",
      "inName": "Prefektur Iwate",
      "tlName": "Iwate Prefecture",
      "moName": "Иватэ аймаг",
      "buName": "အီဝတဲ့ ပြည်နယ်",
      "khName": "ខេត្ត អ៊ីវ៉ាតេ",
      "neName": "इवाते जिल्ला"
    },
    "class10": {
      "code": "030010",
      "name": "内陸",
      "enName": "Inland",
      "chName": "岩手县内陆地北部",
      "zhName": "岩手縣內陸北部",
      "koName": "이와테 현 내륙",
      "esName": "Interior de la Prefectura de Iwate",
      "ptName": "Região Interior da Província de Iwate",
      "thName": "ด้านในแผ่นดินของจังหวัดอิวาเตะ",
      "viName": "Vùng nội địa tỉnh Iwate",
      "inName": "Bagian Pedalaman di Prefektur Iwate",
      "tlName": "Bahagi ng lupain ng Iwate Prefecture",
      "moName": "Иватэ аймаг, дотоод нутаг",
      "buName": "အိဝတဲစီရင်စုကုန်းတွင်းဒေသ",
      "khName": "តំបន់ដីឆ្ងាយពីឆ្នេរនៃខេត្តអ៊ីវ៉ាទេ",
      "neName": "इवाते जिल्लाको भित्री (समुद्री किनारबाट टाढा) क्षेत्र"
    },
    "class15": {
      "code": "030011",
      "name": "盛岡地域",
      "enName": "Morioka Area"
    },
    "class20": {
      "code": "0330200",
      "name": "葛巻町",
      "enName": "Kuzumaki Town",
      "kana": "くずまきまち",
      "chName": "葛卷町",
      "zhName": "葛卷町",
      "koName": "구즈마키 정",
      "esName": "Pueblo de Kuzumaki",
      "ptName": "bairro de Kuzumaki",
      "thName": "เมืองคุสุมากิ",
      "viName": "thị trấn Kuzumaki",
      "inName": "kota Kuzumaki",
      "tlName": "bayan ng Kuzumaki",
      "moName": "Күсүмaки жижиг хот",
      "buName": "ကူဇုမာ့ကိ မြို့နယ်",
      "khName": "ទីប្រជុំជន គូហ្សុម៉ាគី",
      "neName": "कुजुमाकी नगर"
    }
  },
  "0330300": {
    "office": {
      "code": "030000",
      "name": "岩手県",
      "enName": "Iwate",
      "officeName": "盛岡地方気象台",
      "chName": "岩手县",
      "zhName": "岩手縣",
      "koName": "이와테현",
      "esName": "Prefectura de Iwate",
      "ptName": "Província de Iwate",
      "thName": "จังหวัดอิวาเตะ",
      "viName": "Tỉnh Iwate",
      "inName": "Prefektur Iwate",
      "tlName": "Iwate Prefecture",
      "moName": "Иватэ аймаг",
      "buName": "အီဝတဲ့ ပြည်နယ်",
      "khName": "ខេត្ត អ៊ីវ៉ាតេ",
      "neName": "इवाते जिल्ला"
    },
    "class10": {
      "code": "030010",
      "name": "内陸",
      "enName": "Inland",
      "chName": "岩手县内陆地北部",
      "zhName": "岩手縣內陸北部",
      "koName": "이와테 현 내륙",
      "esName": "Interior de la Prefectura de Iwate",
      "ptName": "Região Interior da Província de Iwate",
      "thName": "ด้านในแผ่นดินของจังหวัดอิวาเตะ",
      "viName": "Vùng nội địa tỉnh Iwate",
      "inName": "Bagian Pedalaman di Prefektur Iwate",
      "tlName": "Bahagi ng lupain ng Iwate Prefecture",
      "moName": "Иватэ аймаг, дотоод нутаг",
      "buName": "အိဝတဲစီရင်စုကုန်းတွင်းဒေသ",
      "khName": "តំបន់ដីឆ្ងាយពីឆ្នេរនៃខេត្តអ៊ីវ៉ាទេ",
      "neName": "इवाते जिल्लाको भित्री (समुद्री किनारबाट टाढा) क्षेत्र"
    },
    "class15": {
      "code": "030011",
      "name": "盛岡地域",
      "enName": "Morioka Area"
    },
    "class20": {
      "code": "0330300",
      "name": "岩手町",
      "enName": "Iwate Town",
      "kana": "いわてまち",
      "chName": "岩手町",
      "zhName": "岩手町",
      "koName": "이와테 정",
      "esName": "Pueblo de Iwate",
      "ptName": "bairro de Iwate",
      "thName": "เมืองอิวาเตะ",
      "viName": "thị trấn Iwate",
      "inName": "kota Iwate",
      "tlName": "bayan ng Iwate",
      "moName": "Иватэ жижиг хот",
      "buName": "အီဝါ့တဲ့ မြို့နယ်",
      "khName": "ទីប្រជុំជន​ អាយវ៉ាតេ",
      "neName": "इवाते नगर"
    }
  },
  "0332100": {
    "office": {
      "code": "030000",
      "name": "岩手県",
      "enName": "Iwate",
      "officeName": "盛岡地方気象台",
      "chName": "岩手县",
      "zhName": "岩手縣",
      "koName": "이와테현",
      "esName": "Prefectura de Iwate",
      "ptName": "Província de Iwate",
      "thName": "จังหวัดอิวาเตะ",
      "viName": "Tỉnh Iwate",
      "inName": "Prefektur Iwate",
      "tlName": "Iwate Prefecture",
      "moName": "Иватэ аймаг",
      "buName": "အီဝတဲ့ ပြည်နယ်",
      "khName": "ខេត្ត អ៊ីវ៉ាតេ",
      "neName": "इवाते जिल्ला"
    },
    "class10": {
      "code": "030010",
      "name": "内陸",
      "enName": "Inland",
      "chName": "岩手县内陆地北部",
      "zhName": "岩手縣內陸北部",
      "koName": "이와테 현 내륙",
      "esName": "Interior de la Prefectura de Iwate",
      "ptName": "Região Interior da Província de Iwate",
      "thName": "ด้านในแผ่นดินของจังหวัดอิวาเตะ",
      "viName": "Vùng nội địa tỉnh Iwate",
      "inName": "Bagian Pedalaman di Prefektur Iwate",
      "tlName": "Bahagi ng lupain ng Iwate Prefecture",
      "moName": "Иватэ аймаг, дотоод нутаг",
      "buName": "အိဝတဲစီရင်စုကုန်းတွင်းဒေသ",
      "khName": "តំបន់ដីឆ្ងាយពីឆ្នេរនៃខេត្តអ៊ីវ៉ាទេ",
      "neName": "इवाते जिल्लाको भित्री (समुद्री किनारबाट टाढा) क्षेत्र"
    },
    "class15": {
      "code": "030011",
      "name": "盛岡地域",
      "enName": "Morioka Area"
    },
    "class20": {
      "code": "0332100",
      "name": "紫波町",
      "enName": "Shiwa Town",
      "kana": "しわちょう",
      "chName": "紫波町",
      "zhName": "紫波町",
      "koName": "시와 정",
      "esName": "Pueblo de Shiwa",
      "ptName": "bairro de Shiwa",
      "thName": "เมืองชิวะ",
      "viName": "thị trấn Shiwa",
      "inName": "kota Shiwa",
      "tlName": "bayan ng Shiwa",
      "moName": "Шива жижиг хот",
      "buName": "ရှီဝ မြို့နယ်",
      "khName": "ទីប្រជុំជន ស៊ីវ៉ា",
      "neName": "शिवा नगर"
    }
  },
  "0332200": {
    "office": {
      "code": "030000",
      "name": "岩手県",
      "enName": "Iwate",
      "officeName": "盛岡地方気象台",
      "chName": "岩手县",
      "zhName": "岩手縣",
      "koName": "이와테현",
      "esName": "Prefectura de Iwate",
      "ptName": "Província de Iwate",
      "thName": "จังหวัดอิวาเตะ",
      "viName": "Tỉnh Iwate",
      "inName": "Prefektur Iwate",
      "tlName": "Iwate Prefecture",
      "moName": "Иватэ аймаг",
      "buName": "အီဝတဲ့ ပြည်နယ်",
      "khName": "ខេត្ត អ៊ីវ៉ាតេ",
      "neName": "इवाते जिल्ला"
    },
    "class10": {
      "code": "030010",
      "name": "内陸",
      "enName": "Inland",
      "chName": "岩手县内陆地北部",
      "zhName": "岩手縣內陸北部",
      "koName": "이와테 현 내륙",
      "esName": "Interior de la Prefectura de Iwate",
      "ptName": "Região Interior da Província de Iwate",
      "thName": "ด้านในแผ่นดินของจังหวัดอิวาเตะ",
      "viName": "Vùng nội địa tỉnh Iwate",
      "inName": "Bagian Pedalaman di Prefektur Iwate",
      "tlName": "Bahagi ng lupain ng Iwate Prefecture",
      "moName": "Иватэ аймаг, дотоод нутаг",
      "buName": "အိဝတဲစီရင်စုကုန်းတွင်းဒေသ",
      "khName": "តំបន់ដីឆ្ងាយពីឆ្នេរនៃខេត្តអ៊ីវ៉ាទេ",
      "neName": "इवाते जिल्लाको भित्री (समुद्री किनारबाट टाढा) क्षेत्र"
    },
    "class15": {
      "code": "030011",
      "name": "盛岡地域",
      "enName": "Morioka Area"
    },
    "class20": {
      "code": "0332200",
      "name": "矢巾町",
      "enName": "Yahaba Town",
      "kana": "やはばちょう",
      "chName": "矢巾町",
      "zhName": "矢巾町",
      "koName": "야하바 정",
      "esName": "Pueblo de Yahaba",
      "ptName": "bairro de Yahaba",
      "thName": "เมืองยาฮาบะ",
      "viName": "thị trấn Yahaba",
      "inName": "kota Yahaba",
      "tlName": "bayan ng Yahaba",
      "moName": "Яхaба жижиг хот",
      "buName": "ယာဟာ့ဗ မြို့နယ်",
      "khName": "ទីប្រជុំជន យ៉ាហាបា",
      "neName": "याहाबा नगर"
    }
  },
  "0336600": {
    "office": {
      "code": "030000",
      "name": "岩手県",
      "enName": "Iwate",
      "officeName": "盛岡地方気象台",
      "chName": "岩手县",
      "zhName": "岩手縣",
      "koName": "이와테현",
      "esName": "Prefectura de Iwate",
      "ptName": "Província de Iwate",
      "thName": "จังหวัดอิวาเตะ",
      "viName": "Tỉnh Iwate",
      "inName": "Prefektur Iwate",
      "tlName": "Iwate Prefecture",
      "moName": "Иватэ аймаг",
      "buName": "အီဝတဲ့ ပြည်နယ်",
      "khName": "ខេត្ត អ៊ីវ៉ាតេ",
      "neName": "इवाते जिल्ला"
    },
    "class10": {
      "code": "030010",
      "name": "内陸",
      "enName": "Inland",
      "chName": "岩手县内陆地北部",
      "zhName": "岩手縣內陸北部",
      "koName": "이와테 현 내륙",
      "esName": "Interior de la Prefectura de Iwate",
      "ptName": "Região Interior da Província de Iwate",
      "thName": "ด้านในแผ่นดินของจังหวัดอิวาเตะ",
      "viName": "Vùng nội địa tỉnh Iwate",
      "inName": "Bagian Pedalaman di Prefektur Iwate",
      "tlName": "Bahagi ng lupain ng Iwate Prefecture",
      "moName": "Иватэ аймаг, дотоод нутаг",
      "buName": "အိဝတဲစီရင်စုကုန်းတွင်းဒေသ",
      "khName": "តំបន់ដីឆ្ងាយពីឆ្នេរនៃខេត្តអ៊ីវ៉ាទេ",
      "neName": "इवाते जिल्लाको भित्री (समुद्री किनारबाट टाढा) क्षेत्र"
    },
    "class15": {
      "code": "030013",
      "name": "花北地域",
      "enName": "Hanakita Area"
    },
    "class20": {
      "code": "0336600",
      "name": "西和賀町",
      "enName": "Nishiwaga Town",
      "kana": "にしわがまち",
      "chName": "西和贺町",
      "zhName": "西和賀町",
      "koName": "니시와가 정",
      "esName": "Pueblo de Nishiwaga",
      "ptName": "bairro de Nishiwaga",
      "thName": "เมืองนิชิวางะ",
      "viName": "thị trấn Nishiwaga",
      "inName": "kota Nishiwaga",
      "tlName": "bayan ng Nishiwaga",
      "moName": "Нишивагa жижиг хот",
      "buName": "နီရှိဝါ့ဂ မြို့နယ်",
      "khName": "ទីប្រជុំជន នីស៊ីវ៉ាហ្គា",
      "neName": "निशिवागा नगर"
    }
  },
  "0338100": {
    "office": {
      "code": "030000",
      "name": "岩手県",
      "enName": "Iwate",
      "officeName": "盛岡地方気象台",
      "chName": "岩手县",
      "zhName": "岩手縣",
      "koName": "이와테현",
      "esName": "Prefectura de Iwate",
      "ptName": "Província de Iwate",
      "thName": "จังหวัดอิวาเตะ",
      "viName": "Tỉnh Iwate",
      "inName": "Prefektur Iwate",
      "tlName": "Iwate Prefecture",
      "moName": "Иватэ аймаг",
      "buName": "အီဝတဲ့ ပြည်နယ်",
      "khName": "ខេត្ត អ៊ីវ៉ាតេ",
      "neName": "इवाते जिल्ला"
    },
    "class10": {
      "code": "030010",
      "name": "内陸",
      "enName": "Inland",
      "chName": "岩手县内陆地北部",
      "zhName": "岩手縣內陸北部",
      "koName": "이와테 현 내륙",
      "esName": "Interior de la Prefectura de Iwate",
      "ptName": "Região Interior da Província de Iwate",
      "thName": "ด้านในแผ่นดินของจังหวัดอิวาเตะ",
      "viName": "Vùng nội địa tỉnh Iwate",
      "inName": "Bagian Pedalaman di Prefektur Iwate",
      "tlName": "Bahagi ng lupain ng Iwate Prefecture",
      "moName": "Иватэ аймаг, дотоод нутаг",
      "buName": "အိဝတဲစီရင်စုကုန်းတွင်းဒေသ",
      "khName": "តំបន់ដីឆ្ងាយពីឆ្នេរនៃខេត្តអ៊ីវ៉ាទេ",
      "neName": "इवाते जिल्लाको भित्री (समुद्री किनारबाट टाढा) क्षेत्र"
    },
    "class15": {
      "code": "030015",
      "name": "奥州金ケ崎地域",
      "enName": "Oshu Kanegasaki Area"
    },
    "class20": {
      "code": "0338100",
      "name": "金ケ崎町",
      "enName": "Kanegasaki Town",
      "kana": "かねがさきちょう",
      "chName": "金崎町",
      "zhName": "金崎町",
      "koName": "가네가사키 정",
      "esName": "Pueblo de Kanegasaki",
      "ptName": "bairro de Kanegasaki",
      "thName": "เมืองคาเนะงะซากิ",
      "viName": "thị trấn Kanegasaki",
      "inName": "kota Kanegasaki",
      "tlName": "bayan ng Kanegasaki",
      "moName": "Канэгaсaки жижиг хот",
      "buName": "ခါနဲဂါးဆာ့ကိ မြို့နယ်",
      "khName": "ទីប្រជុំជន កានេកាសាគី",
      "neName": "कानेगासाकी नगर"
    }
  },
  "0340200": {
    "office": {
      "code": "030000",
      "name": "岩手県",
      "enName": "Iwate",
      "officeName": "盛岡地方気象台",
      "chName": "岩手县",
      "zhName": "岩手縣",
      "koName": "이와테현",
      "esName": "Prefectura de Iwate",
      "ptName": "Província de Iwate",
      "thName": "จังหวัดอิวาเตะ",
      "viName": "Tỉnh Iwate",
      "inName": "Prefektur Iwate",
      "tlName": "Iwate Prefecture",
      "moName": "Иватэ аймаг",
      "buName": "အီဝတဲ့ ပြည်နယ်",
      "khName": "ខេត្ត អ៊ីវ៉ាតេ",
      "neName": "इवाते जिल्ला"
    },
    "class10": {
      "code": "030010",
      "name": "内陸",
      "enName": "Inland",
      "chName": "岩手县内陆地北部",
      "zhName": "岩手縣內陸北部",
      "koName": "이와테 현 내륙",
      "esName": "Interior de la Prefectura de Iwate",
      "ptName": "Região Interior da Província de Iwate",
      "thName": "ด้านในแผ่นดินของจังหวัดอิวาเตะ",
      "viName": "Vùng nội địa tỉnh Iwate",
      "inName": "Bagian Pedalaman di Prefektur Iwate",
      "tlName": "Bahagi ng lupain ng Iwate Prefecture",
      "moName": "Иватэ аймаг, дотоод нутаг",
      "buName": "အိဝတဲစီရင်စုကုန်းတွင်းဒေသ",
      "khName": "តំបន់ដីឆ្ងាយពីឆ្នេរនៃខេត្តអ៊ីវ៉ាទេ",
      "neName": "इवाते जिल्लाको भित्री (समुद्री किनारबाट टाढा) क्षेत्र"
    },
    "class15": {
      "code": "030016",
      "name": "両磐地域",
      "enName": "Ryoban Area"
    },
    "class20": {
      "code": "0340200",
      "name": "平泉町",
      "enName": "Hiraizumi Town",
      "kana": "ひらいずみちょう",
      "chName": "平泉町",
      "zhName": "平泉町",
      "koName": "히라이즈미 정",
      "esName": "Pueblo de Hiraizumi",
      "ptName": "bairro de Hiraizumi",
      "thName": "เมืองฮิระอิสุมิ",
      "viName": "thị trấn Hiraizumi",
      "inName": "kota Hiraizumi",
      "tlName": "bayan ng Hiraizumi",
      "moName": "Хирайзүми жижиг хот",
      "buName": "ဟီရာ့ယိဇုမိ မြို့နယ်",
      "khName": "ទីប្រជុំជន ហ៊ីរ៉ាហ្សូមី",
      "neName": "हिराइजुमी नगर"
    }
  },
  "0344100": {
    "office": {
      "code": "030000",
      "name": "岩手県",
      "enName": "Iwate",
      "officeName": "盛岡地方気象台",
      "chName": "岩手县",
      "zhName": "岩手縣",
      "koName": "이와테현",
      "esName": "Prefectura de Iwate",
      "ptName": "Província de Iwate",
      "thName": "จังหวัดอิวาเตะ",
      "viName": "Tỉnh Iwate",
      "inName": "Prefektur Iwate",
      "tlName": "Iwate Prefecture",
      "moName": "Иватэ аймаг",
      "buName": "အီဝတဲ့ ပြည်နယ်",
      "khName": "ខេត្ត អ៊ីវ៉ាតេ",
      "neName": "इवाते जिल्ला"
    },
    "class10": {
      "code": "030030",
      "name": "沿岸南部",
      "enName": "Southern Coast",
      "chName": "岩手县沿岸南部",
      "zhName": "岩手縣沿岸南部",
      "koName": "이와테 현 연안 남부",
      "esName": "Costa sur de Prefectura de Iwate",
      "ptName": "Litoral Sul da Província de Iwate",
      "thName": "ชายฝั่งตอนใต้ของจังหวัดอิวาเตะ",
      "viName": "Miền Nam bờ biển tỉnh Iwate",
      "inName": "Pantai Selatan di Prefektur Iwate",
      "tlName": "Timog na bahagi ng baybayin ng Iwate Prefecture",
      "moName": "Иватэ аймаг, өмнөд эрэг",
      "buName": "အိဝတဲစီရင်စု တောင်ပိုင်းကမ်းခြေ",
      "khName": "តំបន់ខាងត្បូងឆ្នេរសមុទ្រនៃខេត្តអ៊ីវ៉ាតិ",
      "neName": " इवाते जिल्लाको समुद्री किनारको दक्षिणी "
    },
    "class15": {
      "code": "030032",
      "name": "大船渡地域",
      "enName": "Ofunato Area"
    },
    "class20": {
      "code": "0344100",
      "name": "住田町",
      "enName": "Sumita Town",
      "kana": "すみたちょう",
      "chName": "住田町",
      "zhName": "住田町",
      "koName": "스미타 정",
      "esName": "Pueblo de Sumita",
      "ptName": "bairro de Sumita",
      "thName": "เมืองสุมิตะ",
      "viName": "thị trấn Sumita",
      "inName": "kota Sumita",
      "tlName": "bayan ng Sumita",
      "moName": "Сүмита жижиг хот",
      "buName": "ဆူမိတ မြို့နယ်",
      "khName": "ទីប្រជុំជន ស៊ូមីតា",
      "neName": "सुमिता नगर"
    }
  },
  "0346100": {
    "office": {
      "code": "030000",
      "name": "岩手県",
      "enName": "Iwate",
      "officeName": "盛岡地方気象台",
      "chName": "岩手县",
      "zhName": "岩手縣",
      "koName": "이와테현",
      "esName": "Prefectura de Iwate",
      "ptName": "Província de Iwate",
      "thName": "จังหวัดอิวาเตะ",
      "viName": "Tỉnh Iwate",
      "inName": "Prefektur Iwate",
      "tlName": "Iwate Prefecture",
      "moName": "Иватэ аймаг",
      "buName": "အီဝတဲ့ ပြည်နယ်",
      "khName": "ខេត្ត អ៊ីវ៉ាតេ",
      "neName": "इवाते जिल्ला"
    },
    "class10": {
      "code": "030030",
      "name": "沿岸南部",
      "enName": "Southern Coast",
      "chName": "岩手县沿岸南部",
      "zhName": "岩手縣沿岸南部",
      "koName": "이와테 현 연안 남부",
      "esName": "Costa sur de Prefectura de Iwate",
      "ptName": "Litoral Sul da Província de Iwate",
      "thName": "ชายฝั่งตอนใต้ของจังหวัดอิวาเตะ",
      "viName": "Miền Nam bờ biển tỉnh Iwate",
      "inName": "Pantai Selatan di Prefektur Iwate",
      "tlName": "Timog na bahagi ng baybayin ng Iwate Prefecture",
      "moName": "Иватэ аймаг, өмнөд эрэг",
      "buName": "အိဝတဲစီရင်စု တောင်ပိုင်းကမ်းခြေ",
      "khName": "តំបន់ខាងត្បូងឆ្នេរសមុទ្រនៃខេត្តអ៊ីវ៉ាតិ",
      "neName": " इवाते जिल्लाको समुद्री किनारको दक्षिणी "
    },
    "class15": {
      "code": "030031",
      "name": "釜石地域",
      "enName": "Kamaishi Area"
    },
    "class20": {
      "code": "0346100",
      "name": "大槌町",
      "enName": "Otsuchi Town",
      "kana": "おおつちちょう",
      "chName": "大槌町",
      "zhName": "大槌町",
      "koName": "오쓰치 정",
      "esName": "Pueblo de Ōtsuchi",
      "ptName": "bairro de Otsuchi",
      "thName": "เมืองโอ๊ตสึจิ",
      "viName": "thị trấn Otsuchi",
      "inName": "kota Otsuchi",
      "tlName": "bayan ng Otsuchi",
      "moName": "Оцүчи жижиг хот",
      "buName": "အော့ဆုကျိ မြို့နယ်",
      "khName": "ទីប្រជុំជន អូស៊ូជី",
      "neName": "ओत्सुची नगर"
    }
  },
  "0348200": {
    "office": {
      "code": "030000",
      "name": "岩手県",
      "enName": "Iwate",
      "officeName": "盛岡地方気象台",
      "chName": "岩手县",
      "zhName": "岩手縣",
      "koName": "이와테현",
      "esName": "Prefectura de Iwate",
      "ptName": "Província de Iwate",
      "thName": "จังหวัดอิวาเตะ",
      "viName": "Tỉnh Iwate",
      "inName": "Prefektur Iwate",
      "tlName": "Iwate Prefecture",
      "moName": "Иватэ аймаг",
      "buName": "အီဝတဲ့ ပြည်နယ်",
      "khName": "ខេត្ត អ៊ីវ៉ាតេ",
      "neName": "इवाते जिल्ला"
    },
    "class10": {
      "code": "030020",
      "name": "沿岸北部",
      "enName": "Northern Coast",
      "chName": "岩手县沿岸北部",
      "zhName": "岩手縣沿岸北部",
      "koName": "이와테 현 연안 북부",
      "esName": "Costa norte de Prefectura de Iwate",
      "ptName": "Litoral Norte da Província de Iwate",
      "thName": "ชายฝั่งตอนเหนือของจังหวัดอิวาเตะ",
      "viName": "Miền Bắc bờ biển tỉnh Iwate",
      "inName": "Pantai Utara di Prefektur Iwate",
      "tlName": "Hilagang bahagi ng baybayin ng Iwate Prefecture",
      "moName": "Иватэ аймаг, хойд эрэг",
      "buName": "အိဝတဲစီရင်စု မြောက်ပိုင်းကမ်းခြေ",
      "khName": "តំបន់ខាងជើងឆ្នេរសមុទ្រនៃខេត្តអ៊ីវ៉ាតិ",
      "neName": " इवाते जिल्लाको समुद्री किनारको उत्तरी भाग "
    },
    "class15": {
      "code": "030022",
      "name": "宮古地域",
      "enName": "Miyako Area"
    },
    "class20": {
      "code": "0348200",
      "name": "山田町",
      "enName": "Yamada Town",
      "kana": "やまだまち",
      "chName": "山田町",
      "zhName": "山田町",
      "koName": "야마다 정",
      "esName": "Pueblo de Yamada",
      "ptName": "bairro de Yamada",
      "thName": "เมืองยามาดะ",
      "viName": "thị trấn Yamada",
      "inName": "kota Yamada",
      "tlName": "bayan ng Yamada",
      "moName": "Ямaда жижиг хот",
      "buName": "ယာမာ့ဒ မြို့နယ်",
      "khName": "ទីប្រជុំជន យ៉ាម៉ាដា",
      "neName": "यामादा नगर"
    }
  },
  "0348300": {
    "office": {
      "code": "030000",
      "name": "岩手県",
      "enName": "Iwate",
      "officeName": "盛岡地方気象台",
      "chName": "岩手县",
      "zhName": "岩手縣",
      "koName": "이와테현",
      "esName": "Prefectura de Iwate",
      "ptName": "Província de Iwate",
      "thName": "จังหวัดอิวาเตะ",
      "viName": "Tỉnh Iwate",
      "inName": "Prefektur Iwate",
      "tlName": "Iwate Prefecture",
      "moName": "Иватэ аймаг",
      "buName": "အီဝတဲ့ ပြည်နယ်",
      "khName": "ខេត្ត អ៊ីវ៉ាតេ",
      "neName": "इवाते जिल्ला"
    },
    "class10": {
      "code": "030020",
      "name": "沿岸北部",
      "enName": "Northern Coast",
      "chName": "岩手县沿岸北部",
      "zhName": "岩手縣沿岸北部",
      "koName": "이와테 현 연안 북부",
      "esName": "Costa norte de Prefectura de Iwate",
      "ptName": "Litoral Norte da Província de Iwate",
      "thName": "ชายฝั่งตอนเหนือของจังหวัดอิวาเตะ",
      "viName": "Miền Bắc bờ biển tỉnh Iwate",
      "inName": "Pantai Utara di Prefektur Iwate",
      "tlName": "Hilagang bahagi ng baybayin ng Iwate Prefecture",
      "moName": "Иватэ аймаг, хойд эрэг",
      "buName": "အိဝတဲစီရင်စု မြောက်ပိုင်းကမ်းခြေ",
      "khName": "តំបន់ខាងជើងឆ្នេរសមុទ្រនៃខេត្តអ៊ីវ៉ាតិ",
      "neName": " इवाते जिल्लाको समुद्री किनारको उत्तरी भाग "
    },
    "class15": {
      "code": "030022",
      "name": "宮古地域",
      "enName": "Miyako Area"
    },
    "class20": {
      "code": "0348300",
      "name": "岩泉町",
      "enName": "Iwaizumi Town",
      "kana": "いわいずみちょう",
      "chName": "岩泉町",
      "zhName": "岩泉町",
      "koName": "이와이즈미 정",
      "esName": "Pueblo de Iwazumi",
      "ptName": "bairro de Iwaizumi",
      "thName": "เมืองอิวาอิสุมิ",
      "viName": "thị trấn Iwaizumi",
      "inName": "kota Iwaizumi",
      "tlName": "bayan ng Iwaizumi",
      "moName": "Ивайзүми жижиг хот",
      "buName": "အီဝါးယိဇုမိ မြို့နယ်",
      "khName": "ទីប្រជុំជន អាយវ៉ាហ្សូមី",
      "neName": "इवाइजुमि नगर"
    }
  },
  "0348400": {
    "office": {
      "code": "030000",
      "name": "岩手県",
      "enName": "Iwate",
      "officeName": "盛岡地方気象台",
      "chName": "岩手县",
      "zhName": "岩手縣",
      "koName": "이와테현",
      "esName": "Prefectura de Iwate",
      "ptName": "Província de Iwate",
      "thName": "จังหวัดอิวาเตะ",
      "viName": "Tỉnh Iwate",
      "inName": "Prefektur Iwate",
      "tlName": "Iwate Prefecture",
      "moName": "Иватэ аймаг",
      "buName": "အီဝတဲ့ ပြည်နယ်",
      "khName": "ខេត្ត អ៊ីវ៉ាតេ",
      "neName": "इवाते जिल्ला"
    },
    "class10": {
      "code": "030020",
      "name": "沿岸北部",
      "enName": "Northern Coast",
      "chName": "岩手县沿岸北部",
      "zhName": "岩手縣沿岸北部",
      "koName": "이와테 현 연안 북부",
      "esName": "Costa norte de Prefectura de Iwate",
      "ptName": "Litoral Norte da Província de Iwate",
      "thName": "ชายฝั่งตอนเหนือของจังหวัดอิวาเตะ",
      "viName": "Miền Bắc bờ biển tỉnh Iwate",
      "inName": "Pantai Utara di Prefektur Iwate",
      "tlName": "Hilagang bahagi ng baybayin ng Iwate Prefecture",
      "moName": "Иватэ аймаг, хойд эрэг",
      "buName": "အိဝတဲစီရင်စု မြောက်ပိုင်းကမ်းခြေ",
      "khName": "តំបន់ខាងជើងឆ្នេរសមុទ្រនៃខេត្តអ៊ីវ៉ាតិ",
      "neName": " इवाते जिल्लाको समुद्री किनारको उत्तरी भाग "
    },
    "class15": {
      "code": "030022",
      "name": "宮古地域",
      "enName": "Miyako Area"
    },
    "class20": {
      "code": "0348400",
      "name": "田野畑村",
      "enName": "Tanohata Village",
      "kana": "たのはたむら",
      "chName": "田野畑村",
      "zhName": "田野畑村",
      "koName": "다노하타 촌",
      "esName": "Aldea de Tanohata",
      "ptName": "povoado de Tanohata",
      "thName": "หมู่บ้านทาโนะฮาตะ",
      "viName": "làng Tanohata",
      "inName": "desa Tanohata",
      "tlName": "nayon ng Tanohata",
      "moName": "Танохaта тосгон",
      "buName": "တာနိုဟာ့တ ကျေးရွာ",
      "khName": "ភូមិ តាណូហាតា",
      "neName": "तानोहाता गाउँ"
    }
  },
  "0348500": {
    "office": {
      "code": "030000",
      "name": "岩手県",
      "enName": "Iwate",
      "officeName": "盛岡地方気象台",
      "chName": "岩手县",
      "zhName": "岩手縣",
      "koName": "이와테현",
      "esName": "Prefectura de Iwate",
      "ptName": "Província de Iwate",
      "thName": "จังหวัดอิวาเตะ",
      "viName": "Tỉnh Iwate",
      "inName": "Prefektur Iwate",
      "tlName": "Iwate Prefecture",
      "moName": "Иватэ аймаг",
      "buName": "အီဝတဲ့ ပြည်နယ်",
      "khName": "ខេត្ត អ៊ីវ៉ាតេ",
      "neName": "इवाते जिल्ला"
    },
    "class10": {
      "code": "030020",
      "name": "沿岸北部",
      "enName": "Northern Coast",
      "chName": "岩手县沿岸北部",
      "zhName": "岩手縣沿岸北部",
      "koName": "이와테 현 연안 북부",
      "esName": "Costa norte de Prefectura de Iwate",
      "ptName": "Litoral Norte da Província de Iwate",
      "thName": "ชายฝั่งตอนเหนือของจังหวัดอิวาเตะ",
      "viName": "Miền Bắc bờ biển tỉnh Iwate",
      "inName": "Pantai Utara di Prefektur Iwate",
      "tlName": "Hilagang bahagi ng baybayin ng Iwate Prefecture",
      "moName": "Иватэ аймаг, хойд эрэг",
      "buName": "အိဝတဲစီရင်စု မြောက်ပိုင်းကမ်းခြေ",
      "khName": "តំបន់ខាងជើងឆ្នេរសមុទ្រនៃខេត្តអ៊ីវ៉ាតិ",
      "neName": " इवाते जिल्लाको समुद्री किनारको उत्तरी भाग "
    },
    "class15": {
      "code": "030021",
      "name": "久慈地域",
      "enName": "Kuji Area"
    },
    "class20": {
      "code": "0348500",
      "name": "普代村",
      "enName": "Fudai Village",
      "kana": "ふだいむら",
      "chName": "普代村",
      "zhName": "普代村",
      "koName": "후다이 촌",
      "esName": "Aldea de Fudai",
      "ptName": "povoado de Fudai",
      "thName": "หมู่บ้านฟุได",
      "viName": "làng Fudai",
      "inName": "desa Fudai",
      "tlName": "nayon ng Fudai",
      "moName": "Фүдай тосгон",
      "buName": "ဖူဒိုင်းယိ ကျေးရွာ",
      "khName": "ភូមិ ហ្វូដាយ",
      "neName": "फुदाई गाउँ"
    }
  },
  "0350100": {
    "office": {
      "code": "030000",
      "name": "岩手県",
      "enName": "Iwate",
      "officeName": "盛岡地方気象台",
      "chName": "岩手县",
      "zhName": "岩手縣",
      "koName": "이와테현",
      "esName": "Prefectura de Iwate",
      "ptName": "Província de Iwate",
      "thName": "จังหวัดอิวาเตะ",
      "viName": "Tỉnh Iwate",
      "inName": "Prefektur Iwate",
      "tlName": "Iwate Prefecture",
      "moName": "Иватэ аймаг",
      "buName": "အီဝတဲ့ ပြည်နယ်",
      "khName": "ខេត្ត អ៊ីវ៉ាតេ",
      "neName": "इवाते जिल्ला"
    },
    "class10": {
      "code": "030010",
      "name": "内陸",
      "enName": "Inland",
      "chName": "岩手县内陆地北部",
      "zhName": "岩手縣內陸北部",
      "koName": "이와테 현 내륙",
      "esName": "Interior de la Prefectura de Iwate",
      "ptName": "Região Interior da Província de Iwate",
      "thName": "ด้านในแผ่นดินของจังหวัดอิวาเตะ",
      "viName": "Vùng nội địa tỉnh Iwate",
      "inName": "Bagian Pedalaman di Prefektur Iwate",
      "tlName": "Bahagi ng lupain ng Iwate Prefecture",
      "moName": "Иватэ аймаг, дотоод нутаг",
      "buName": "အိဝတဲစီရင်စုကုန်းတွင်းဒေသ",
      "khName": "តំបន់ដីឆ្ងាយពីឆ្នេរនៃខេត្តអ៊ីវ៉ាទេ",
      "neName": "इवाते जिल्लाको भित्री (समुद्री किनारबाट टाढा) क्षेत्र"
    },
    "class15": {
      "code": "030012",
      "name": "二戸地域",
      "enName": "Ninohe Area"
    },
    "class20": {
      "code": "0350100",
      "name": "軽米町",
      "enName": "Karumai Town",
      "kana": "かるまいまち",
      "chName": "轻米町",
      "zhName": "輕米町",
      "koName": "가루마이 정",
      "esName": "Pueblo de Karumai",
      "ptName": "bairro de Karumai",
      "thName": "เมืองคารุมาอิ",
      "viName": "thị trấn Karumai",
      "inName": "kota Karumai",
      "tlName": "bayan ng Karumai",
      "moName": "Карүмaй жижиг хот",
      "buName": "ခါရုမိုင်း မြို့နယ်",
      "khName": "ទីប្រជុំជន ការូម៉ាយ",
      "neName": "करुमाई नगर"
    }
  },
  "0350300": {
    "office": {
      "code": "030000",
      "name": "岩手県",
      "enName": "Iwate",
      "officeName": "盛岡地方気象台",
      "chName": "岩手县",
      "zhName": "岩手縣",
      "koName": "이와테현",
      "esName": "Prefectura de Iwate",
      "ptName": "Província de Iwate",
      "thName": "จังหวัดอิวาเตะ",
      "viName": "Tỉnh Iwate",
      "inName": "Prefektur Iwate",
      "tlName": "Iwate Prefecture",
      "moName": "Иватэ аймаг",
      "buName": "အီဝတဲ့ ပြည်နယ်",
      "khName": "ខេត្ត អ៊ីវ៉ាតេ",
      "neName": "इवाते जिल्ला"
    },
    "class10": {
      "code": "030020",
      "name": "沿岸北部",
      "enName": "Northern Coast",
      "chName": "岩手县沿岸北部",
      "zhName": "岩手縣沿岸北部",
      "koName": "이와테 현 연안 북부",
      "esName": "Costa norte de Prefectura de Iwate",
      "ptName": "Litoral Norte da Província de Iwate",
      "thName": "ชายฝั่งตอนเหนือของจังหวัดอิวาเตะ",
      "viName": "Miền Bắc bờ biển tỉnh Iwate",
      "inName": "Pantai Utara di Prefektur Iwate",
      "tlName": "Hilagang bahagi ng baybayin ng Iwate Prefecture",
      "moName": "Иватэ аймаг, хойд эрэг",
      "buName": "အိဝတဲစီရင်စု မြောက်ပိုင်းကမ်းခြေ",
      "khName": "តំបន់ខាងជើងឆ្នេរសមុទ្រនៃខេត្តអ៊ីវ៉ាតិ",
      "neName": " इवाते जिल्लाको समुद्री किनारको उत्तरी भाग "
    },
    "class15": {
      "code": "030021",
      "name": "久慈地域",
      "enName": "Kuji Area"
    },
    "class20": {
      "code": "0350300",
      "name": "野田村",
      "enName": "Noda Village",
      "kana": "のだむら",
      "chName": "野田村",
      "zhName": "野田村",
      "koName": "노다 촌",
      "esName": "Aldea de Noda",
      "ptName": "povoado de Noda",
      "thName": "หมู่บ้านโนดะ",
      "viName": "làng Noda",
      "inName": "desa Noda",
      "tlName": "nayon ng Noda",
      "moName": "Нода тосгон",
      "buName": "နိုဒ ကျေးရွာ",
      "khName": "ភូមិ​ ណូដា",
      "neName": "नोदा गाउँ"
    }
  },
  "0350600": {
    "office": {
      "code": "030000",
      "name": "岩手県",
      "enName": "Iwate",
      "officeName": "盛岡地方気象台",
      "chName": "岩手县",
      "zhName": "岩手縣",
      "koName": "이와테현",
      "esName": "Prefectura de Iwate",
      "ptName": "Província de Iwate",
      "thName": "จังหวัดอิวาเตะ",
      "viName": "Tỉnh Iwate",
      "inName": "Prefektur Iwate",
      "tlName": "Iwate Prefecture",
      "moName": "Иватэ аймаг",
      "buName": "အီဝတဲ့ ပြည်နယ်",
      "khName": "ខេត្ត អ៊ីវ៉ាតេ",
      "neName": "इवाते जिल्ला"
    },
    "class10": {
      "code": "030010",
      "name": "内陸",
      "enName": "Inland",
      "chName": "岩手县内陆地北部",
      "zhName": "岩手縣內陸北部",
      "koName": "이와테 현 내륙",
      "esName": "Interior de la Prefectura de Iwate",
      "ptName": "Região Interior da Província de Iwate",
      "thName": "ด้านในแผ่นดินของจังหวัดอิวาเตะ",
      "viName": "Vùng nội địa tỉnh Iwate",
      "inName": "Bagian Pedalaman di Prefektur Iwate",
      "tlName": "Bahagi ng lupain ng Iwate Prefecture",
      "moName": "Иватэ аймаг, дотоод нутаг",
      "buName": "အိဝတဲစီရင်စုကုန်းတွင်းဒေသ",
      "khName": "តំបន់ដីឆ្ងាយពីឆ្នេរនៃខេត្តអ៊ីវ៉ាទេ",
      "neName": "इवाते जिल्लाको भित्री (समुद्री किनारबाट टाढा) क्षेत्र"
    },
    "class15": {
      "code": "030012",
      "name": "二戸地域",
      "enName": "Ninohe Area"
    },
    "class20": {
      "code": "0350600",
      "name": "九戸村",
      "enName": "Kunohe Village",
      "kana": "くのへむら",
      "chName": "九户村",
      "zhName": "九戶村",
      "koName": "구노헤 촌",
      "esName": "Aldea de Kunohe",
      "ptName": "povoado de Kunohe",
      "thName": "หมู่บ้านคุโนะเฮะ",
      "viName": "làng Kunohe",
      "inName": "desa Kunohe",
      "tlName": "nayon ng Kunohe",
      "moName": "Күнохэ тосгон",
      "buName": "ကုနောဟဲ့ ကျေးရွာ",
      "khName": "ភូមិ គុណូហេ",
      "neName": "कुनोहे गाउँ"
    }
  },
  "0350700": {
    "office": {
      "code": "030000",
      "name": "岩手県",
      "enName": "Iwate",
      "officeName": "盛岡地方気象台",
      "chName": "岩手县",
      "zhName": "岩手縣",
      "koName": "이와테현",
      "esName": "Prefectura de Iwate",
      "ptName": "Província de Iwate",
      "thName": "จังหวัดอิวาเตะ",
      "viName": "Tỉnh Iwate",
      "inName": "Prefektur Iwate",
      "tlName": "Iwate Prefecture",
      "moName": "Иватэ аймаг",
      "buName": "အီဝတဲ့ ပြည်နယ်",
      "khName": "ខេត្ត អ៊ីវ៉ាតេ",
      "neName": "इवाते जिल्ला"
    },
    "class10": {
      "code": "030020",
      "name": "沿岸北部",
      "enName": "Northern Coast",
      "chName": "岩手县沿岸北部",
      "zhName": "岩手縣沿岸北部",
      "koName": "이와테 현 연안 북부",
      "esName": "Costa norte de Prefectura de Iwate",
      "ptName": "Litoral Norte da Província de Iwate",
      "thName": "ชายฝั่งตอนเหนือของจังหวัดอิวาเตะ",
      "viName": "Miền Bắc bờ biển tỉnh Iwate",
      "inName": "Pantai Utara di Prefektur Iwate",
      "tlName": "Hilagang bahagi ng baybayin ng Iwate Prefecture",
      "moName": "Иватэ аймаг, хойд эрэг",
      "buName": "အိဝတဲစီရင်စု မြောက်ပိုင်းကမ်းခြေ",
      "khName": "តំបន់ខាងជើងឆ្នេរសមុទ្រនៃខេត្តអ៊ីវ៉ាតិ",
      "neName": " इवाते जिल्लाको समुद्री किनारको उत्तरी भाग "
    },
    "class15": {
      "code": "030021",
      "name": "久慈地域",
      "enName": "Kuji Area"
    },
    "class20": {
      "code": "0350700",
      "name": "洋野町",
      "enName": "Hirono Town",
      "kana": "ひろのちょう",
      "chName": "岩手洋野町",
      "zhName": "岩手洋野町",
      "koName": "이와테 히로노 정",
      "esName": "Pueblo de Hirono, Iwate",
      "ptName": "Iwate, bairro de Hirono",
      "thName": "เมืองฮิโรโนะ อิวาเตะ",
      "viName": "Thị trấn Hirono, Iwate",
      "inName": "Kota Hirono, Iwate",
      "tlName": "bayan ng Hirono, Iwate",
      "moName": "Иватэ Хироно жижиг хот",
      "buName": "အိဝတဲဟိယိုနိုမြို့နယ်",
      "khName": "ទីប្រជុំជនហ៊ីរ៉ូណូ អ៊ីវ៉ាតិ",
      "neName": "इवाते हिरोनो नगर"
    }
  },
  "0352400": {
    "office": {
      "code": "030000",
      "name": "岩手県",
      "enName": "Iwate",
      "officeName": "盛岡地方気象台",
      "chName": "岩手县",
      "zhName": "岩手縣",
      "koName": "이와테현",
      "esName": "Prefectura de Iwate",
      "ptName": "Província de Iwate",
      "thName": "จังหวัดอิวาเตะ",
      "viName": "Tỉnh Iwate",
      "inName": "Prefektur Iwate",
      "tlName": "Iwate Prefecture",
      "moName": "Иватэ аймаг",
      "buName": "အီဝတဲ့ ပြည်နယ်",
      "khName": "ខេត្ត អ៊ីវ៉ាតេ",
      "neName": "इवाते जिल्ला"
    },
    "class10": {
      "code": "030010",
      "name": "内陸",
      "enName": "Inland",
      "chName": "岩手县内陆地北部",
      "zhName": "岩手縣內陸北部",
      "koName": "이와테 현 내륙",
      "esName": "Interior de la Prefectura de Iwate",
      "ptName": "Região Interior da Província de Iwate",
      "thName": "ด้านในแผ่นดินของจังหวัดอิวาเตะ",
      "viName": "Vùng nội địa tỉnh Iwate",
      "inName": "Bagian Pedalaman di Prefektur Iwate",
      "tlName": "Bahagi ng lupain ng Iwate Prefecture",
      "moName": "Иватэ аймаг, дотоод нутаг",
      "buName": "အိဝတဲစီရင်စုကုန်းတွင်းဒေသ",
      "khName": "តំបន់ដីឆ្ងាយពីឆ្នេរនៃខេត្តអ៊ីវ៉ាទេ",
      "neName": "इवाते जिल्लाको भित्री (समुद्री किनारबाट टाढा) क्षेत्र"
    },
    "class15": {
      "code": "030012",
      "name": "二戸地域",
      "enName": "Ninohe Area"
    },
    "class20": {
      "code": "0352400",
      "name": "一戸町",
      "enName": "Ichinohe Town",
      "kana": "いちのへまち",
      "chName": "一户町",
      "zhName": "一戶町",
      "koName": "이치노헤 정",
      "esName": "Pueblo de Ichinohe",
      "ptName": "bairro de Ichinohe",
      "thName": "เมืองอิจิโนะเฮะ",
      "viName": "thị trấn Ichinohe",
      "inName": "kota Ichinohe",
      "tlName": "bayan ng Ichinohe",
      "moName": "Ичинохэ жижиг хот",
      "buName": "အီချီနိုဟီ မြို့နယ်",
      "khName": "ទីប្រជុំជន អ៊ីឈីណូហេ",
      "neName": "इचिनोहे नगर"
    }
  },
  "0410001": {
    "office": {
      "code": "040000",
      "name": "宮城県",
      "enName": "Miyagi",
      "officeName": "仙台管区気象台",
      "chName": "宫城县",
      "zhName": "宮城縣",
      "koName": "미야기현",
      "esName": "Prefectura de Miyagi",
      "ptName": "Província de Miyagi",
      "thName": "จังหวัดมิยางิ",
      "viName": "Tỉnh Miyagi",
      "inName": "Prefektur Miyagi",
      "tlName": "Miyagi Prefecture",
      "moName": "Мияги аймаг",
      "buName": "မီယာဂီ ပြည်နယ်",
      "khName": "ខេត្ត មីយ៉ាហ្គី",
      "neName": "मियागी जिल्ला"
    },
    "class10": {
      "code": "040010",
      "name": "東部",
      "enName": "Eastern Region",
      "chName": "宫城县北部",
      "zhName": "宮城縣北部",
      "koName": "미야기 현 동부",
      "esName": "Este de la Prefectura de Miyagi",
      "ptName": "Leste da Província de Miyagi",
      "thName": "จังหวัดมิยางิตอนตะวันออก",
      "viName": "Miền Đông tỉnh Miyagi",
      "inName": "Bagian Timur di Prefektur Miyagi",
      "tlName": "Silangang bahagi ng Miyagi Prefecture",
      "moName": "Зүүн Мияги аймаг",
      "buName": "မိယဂိစီရင်စုအရှေ့ပိုင်း",
      "khName": "តំបន់ខាងកើតនៃខេត្តមីយ៉ាហ្គិ",
      "neName": "मियागी जिल्लाको पूर्वी भाग"
    },
    "class15": {
      "code": "040011",
      "name": "東部仙台",
      "enName": "Eastern Sendai"
    },
    "class20": {
      "code": "0410001",
      "name": "仙台市東部",
      "enName": "Eastern Sendai City",
      "kana": "せんだいしとうぶ",
      "chName": "仙台市",
      "zhName": "仙台市",
      "koName": "센다이시",
      "esName": "Ciudad de Sendai",
      "ptName": "Cidade de Sendai",
      "thName": "เมืองเซนได",
      "viName": "Thành phố Sendai",
      "inName": "Kota Sendai",
      "tlName": "Lungsod ng Sendai",
      "moName": "Cidade de Sendai",
      "buName": "ဆဲန်ဒါးမြို့",
      "khName": "ខេត្តឌីហ្សាឌែ",
      "neName": "सेनडाई सिटी"
    }
  },
  "0410002": {
    "office": {
      "code": "040000",
      "name": "宮城県",
      "enName": "Miyagi",
      "officeName": "仙台管区気象台",
      "chName": "宫城县",
      "zhName": "宮城縣",
      "koName": "미야기현",
      "esName": "Prefectura de Miyagi",
      "ptName": "Província de Miyagi",
      "thName": "จังหวัดมิยางิ",
      "viName": "Tỉnh Miyagi",
      "inName": "Prefektur Miyagi",
      "tlName": "Miyagi Prefecture",
      "moName": "Мияги аймаг",
      "buName": "မီယာဂီ ပြည်နယ်",
      "khName": "ខេត្ត មីយ៉ាហ្គី",
      "neName": "मियागी जिल्ला"
    },
    "class10": {
      "code": "040020",
      "name": "西部",
      "enName": "Western Region",
      "chName": "宫城县北部",
      "zhName": "宮城縣北部",
      "koName": "미야기 현 서부",
      "esName": "Oeste de la Prefectura de Miyagi",
      "ptName": "Oeste da Província de Miyagi",
      "thName": "จังหวัดมิยากิตอนตะวันตก",
      "viName": "Miền Tây tỉnh Miyagi",
      "inName": "Bagian Barat di Prefektur Miyagi",
      "tlName": "Kanlurang bahagi ng Miyagi Prefecture",
      "moName": "Баруун Мияги аймаг",
      "buName": "မိယဂိစီရင်စုအပေါ်ပိုင်း",
      "khName": "តំបន់ខាងលិចនៃខេត្តមីយ៉ាហ្គិ",
      "neName": "मियागी जिल्लाको पश्चिमी भाग"
    },
    "class15": {
      "code": "040021",
      "name": "西部仙台",
      "enName": "Western Sendai"
    },
    "class20": {
      "code": "0410002",
      "name": "仙台市西部",
      "enName": "Western Sendai City",
      "kana": "せんだいしせいぶ",
      "chName": "仙台市",
      "zhName": "仙台市",
      "koName": "센다이시",
      "esName": "Ciudad de Sendai",
      "ptName": "Cidade de Sendai",
      "thName": "เมืองเซนได",
      "viName": "Thành phố Sendai",
      "inName": "Kota Sendai",
      "tlName": "Lungsod ng Sendai",
      "moName": "Cidade de Sendai",
      "buName": "ဆဲန်ဒါးမြို့",
      "khName": "ខេត្តឌីហ្សាឌែ",
      "neName": "सेनडाई सिटी"
    }
  },
  "0420200": {
    "office": {
      "code": "040000",
      "name": "宮城県",
      "enName": "Miyagi",
      "officeName": "仙台管区気象台",
      "chName": "宫城县",
      "zhName": "宮城縣",
      "koName": "미야기현",
      "esName": "Prefectura de Miyagi",
      "ptName": "Província de Miyagi",
      "thName": "จังหวัดมิยางิ",
      "viName": "Tỉnh Miyagi",
      "inName": "Prefektur Miyagi",
      "tlName": "Miyagi Prefecture",
      "moName": "Мияги аймаг",
      "buName": "မီယာဂီ ပြည်နယ်",
      "khName": "ខេត្ត មីយ៉ាហ្គី",
      "neName": "मियागी जिल्ला"
    },
    "class10": {
      "code": "040010",
      "name": "東部",
      "enName": "Eastern Region",
      "chName": "宫城县北部",
      "zhName": "宮城縣北部",
      "koName": "미야기 현 동부",
      "esName": "Este de la Prefectura de Miyagi",
      "ptName": "Leste da Província de Miyagi",
      "thName": "จังหวัดมิยางิตอนตะวันออก",
      "viName": "Miền Đông tỉnh Miyagi",
      "inName": "Bagian Timur di Prefektur Miyagi",
      "tlName": "Silangang bahagi ng Miyagi Prefecture",
      "moName": "Зүүн Мияги аймаг",
      "buName": "မိယဂိစီရင်စုအရှေ့ပိုင်း",
      "khName": "តំបន់ខាងកើតនៃខេត្តមីយ៉ាហ្គិ",
      "neName": "मियागी जिल्लाको पूर्वी भाग"
    },
    "class15": {
      "code": "040012",
      "name": "石巻地域",
      "enName": "Ishinomaki Area"
    },
    "class20": {
      "code": "0420200",
      "name": "石巻市",
      "enName": "Ishinomaki City",
      "kana": "いしのまきし",
      "chName": "石卷市",
      "zhName": "石卷市",
      "koName": "이시노마키 시",
      "esName": "Ciudad de Ishinomaki",
      "ptName": "cidade de Ishinomaki",
      "thName": "เมืองอิชิโนะมากิ",
      "viName": "thành phố Ishinomaki",
      "inName": "kota Ishinomaki",
      "tlName": "siyudad ng Ishinomaki",
      "moName": "Ишиномаки хот",
      "buName": "အီရှီနော့မာ့ကိ မြို့",
      "khName": "ទីក្រុង អ៊ីស៊ីនណូម៉ាគី",
      "neName": "इशीनोमाकी सहर"
    }
  },
  "0420300": {
    "office": {
      "code": "040000",
      "name": "宮城県",
      "enName": "Miyagi",
      "officeName": "仙台管区気象台",
      "chName": "宫城县",
      "zhName": "宮城縣",
      "koName": "미야기현",
      "esName": "Prefectura de Miyagi",
      "ptName": "Província de Miyagi",
      "thName": "จังหวัดมิยางิ",
      "viName": "Tỉnh Miyagi",
      "inName": "Prefektur Miyagi",
      "tlName": "Miyagi Prefecture",
      "moName": "Мияги аймаг",
      "buName": "မီယာဂီ ပြည်နယ်",
      "khName": "ខេត្ត មីយ៉ាហ្គី",
      "neName": "मियागी जिल्ला"
    },
    "class10": {
      "code": "040010",
      "name": "東部",
      "enName": "Eastern Region",
      "chName": "宫城县北部",
      "zhName": "宮城縣北部",
      "koName": "미야기 현 동부",
      "esName": "Este de la Prefectura de Miyagi",
      "ptName": "Leste da Província de Miyagi",
      "thName": "จังหวัดมิยางิตอนตะวันออก",
      "viName": "Miền Đông tỉnh Miyagi",
      "inName": "Bagian Timur di Prefektur Miyagi",
      "tlName": "Silangang bahagi ng Miyagi Prefecture",
      "moName": "Зүүн Мияги аймаг",
      "buName": "မိယဂိစီရင်စုအရှေ့ပိုင်း",
      "khName": "តំបន់ខាងកើតនៃខេត្តមីយ៉ាហ្គិ",
      "neName": "मियागी जिल्लाको पूर्वी भाग"
    },
    "class15": {
      "code": "040011",
      "name": "東部仙台",
      "enName": "Eastern Sendai"
    },
    "class20": {
      "code": "0420300",
      "name": "塩竈市",
      "enName": "Shiogama City",
      "kana": "しおがまし",
      "chName": "盐灶市",
      "zhName": "鹽竈市",
      "koName": "시오가마 시",
      "esName": "Ciudad de Shiogama",
      "ptName": "cidade de Shiogama",
      "thName": "เมืองชิโอกามะ",
      "viName": "thành phố Shiogama",
      "inName": "kota Shiogama",
      "tlName": "siyudad ng Shiogama",
      "moName": "Шиогама хот",
      "buName": "ရှီယိုဂါ့မ မြို့",
      "khName": "ទីក្រុង ស៊ីអូហ្គាម៉ា",
      "neName": "शियोगामा सहर"
    }
  },
  "0420500": {
    "office": {
      "code": "040000",
      "name": "宮城県",
      "enName": "Miyagi",
      "officeName": "仙台管区気象台",
      "chName": "宫城县",
      "zhName": "宮城縣",
      "koName": "미야기현",
      "esName": "Prefectura de Miyagi",
      "ptName": "Província de Miyagi",
      "thName": "จังหวัดมิยางิ",
      "viName": "Tỉnh Miyagi",
      "inName": "Prefektur Miyagi",
      "tlName": "Miyagi Prefecture",
      "moName": "Мияги аймаг",
      "buName": "မီယာဂီ ပြည်နယ်",
      "khName": "ខេត្ត មីយ៉ាហ្គី",
      "neName": "मियागी जिल्ला"
    },
    "class10": {
      "code": "040010",
      "name": "東部",
      "enName": "Eastern Region",
      "chName": "宫城县北部",
      "zhName": "宮城縣北部",
      "koName": "미야기 현 동부",
      "esName": "Este de la Prefectura de Miyagi",
      "ptName": "Leste da Província de Miyagi",
      "thName": "จังหวัดมิยางิตอนตะวันออก",
      "viName": "Miền Đông tỉnh Miyagi",
      "inName": "Bagian Timur di Prefektur Miyagi",
      "tlName": "Silangang bahagi ng Miyagi Prefecture",
      "moName": "Зүүн Мияги аймаг",
      "buName": "မိယဂိစီရင်စုအရှေ့ပိုင်း",
      "khName": "តំបន់ខាងកើតនៃខេត្តមីយ៉ាហ្គិ",
      "neName": "मियागी जिल्लाको पूर्वी भाग"
    },
    "class15": {
      "code": "040014",
      "name": "気仙沼地域",
      "enName": "Kesennuma Area"
    },
    "class20": {
      "code": "0420500",
      "name": "気仙沼市",
      "enName": "Kesennuma City",
      "kana": "けせんぬまし",
      "chName": "气仙沼市",
      "zhName": "氣仙沼市",
      "koName": "게센누마 시",
      "esName": "Ciudad de Kesennuma",
      "ptName": "cidade de Kesennuma",
      "thName": "เมืองเคเซนนุมะ",
      "viName": "thành phố Kesennuma",
      "inName": "kota Kesennuma",
      "tlName": "siyudad ng Kesennuma",
      "moName": "Кэсэннүма хот",
      "buName": "ကီဆန်နူမ မြို့",
      "khName": "ទីក្រុង កេសសិននូម៉ា",
      "neName": "केसेन्नुमा सहर"
    }
  },
  "0420600": {
    "office": {
      "code": "040000",
      "name": "宮城県",
      "enName": "Miyagi",
      "officeName": "仙台管区気象台",
      "chName": "宫城县",
      "zhName": "宮城縣",
      "koName": "미야기현",
      "esName": "Prefectura de Miyagi",
      "ptName": "Província de Miyagi",
      "thName": "จังหวัดมิยางิ",
      "viName": "Tỉnh Miyagi",
      "inName": "Prefektur Miyagi",
      "tlName": "Miyagi Prefecture",
      "moName": "Мияги аймаг",
      "buName": "မီယာဂီ ပြည်နယ်",
      "khName": "ខេត្ត មីយ៉ាហ្គី",
      "neName": "मियागी जिल्ला"
    },
    "class10": {
      "code": "040020",
      "name": "西部",
      "enName": "Western Region",
      "chName": "宫城县北部",
      "zhName": "宮城縣北部",
      "koName": "미야기 현 서부",
      "esName": "Oeste de la Prefectura de Miyagi",
      "ptName": "Oeste da Província de Miyagi",
      "thName": "จังหวัดมิยากิตอนตะวันตก",
      "viName": "Miền Tây tỉnh Miyagi",
      "inName": "Bagian Barat di Prefektur Miyagi",
      "tlName": "Kanlurang bahagi ng Miyagi Prefecture",
      "moName": "Баруун Мияги аймаг",
      "buName": "မိယဂိစီရင်စုအပေါ်ပိုင်း",
      "khName": "តំបន់ខាងលិចនៃខេត្តមីយ៉ាហ្គិ",
      "neName": "मियागी जिल्लाको पश्चिमी भाग"
    },
    "class15": {
      "code": "040022",
      "name": "西部仙南",
      "enName": "Western Sennan"
    },
    "class20": {
      "code": "0420600",
      "name": "白石市",
      "enName": "Shiroishi City",
      "kana": "しろいしし",
      "chName": "白石市",
      "zhName": "白石市",
      "koName": "시로이시 시",
      "esName": "Ciudad de Shiroishi",
      "ptName": "cidade de Shiroishi",
      "thName": "เมืองชิโระอิชิ",
      "viName": "thành phố Shiroishi",
      "inName": "kota Shiroishi",
      "tlName": "siyudad ng Shiroishi",
      "moName": "Широйши хот",
      "buName": "ရှီရိုယိရှိ မြို့",
      "khName": "ទីក្រុង ស៊ីរ៉ូអ៊ីស៊ី",
      "neName": "शिरोइशी सहर"
    }
  },
  "0420700": {
    "office": {
      "code": "040000",
      "name": "宮城県",
      "enName": "Miyagi",
      "officeName": "仙台管区気象台",
      "chName": "宫城县",
      "zhName": "宮城縣",
      "koName": "미야기현",
      "esName": "Prefectura de Miyagi",
      "ptName": "Província de Miyagi",
      "thName": "จังหวัดมิยางิ",
      "viName": "Tỉnh Miyagi",
      "inName": "Prefektur Miyagi",
      "tlName": "Miyagi Prefecture",
      "moName": "Мияги аймаг",
      "buName": "မီယာဂီ ပြည်နယ်",
      "khName": "ខេត្ត មីយ៉ាហ្គី",
      "neName": "मियागी जिल्ला"
    },
    "class10": {
      "code": "040010",
      "name": "東部",
      "enName": "Eastern Region",
      "chName": "宫城县北部",
      "zhName": "宮城縣北部",
      "koName": "미야기 현 동부",
      "esName": "Este de la Prefectura de Miyagi",
      "ptName": "Leste da Província de Miyagi",
      "thName": "จังหวัดมิยางิตอนตะวันออก",
      "viName": "Miền Đông tỉnh Miyagi",
      "inName": "Bagian Timur di Prefektur Miyagi",
      "tlName": "Silangang bahagi ng Miyagi Prefecture",
      "moName": "Зүүн Мияги аймаг",
      "buName": "မိယဂိစီရင်စုအရှေ့ပိုင်း",
      "khName": "តំបន់ខាងកើតនៃខេត្តមីយ៉ាហ្គិ",
      "neName": "मियागी जिल्लाको पूर्वी भाग"
    },
    "class15": {
      "code": "040011",
      "name": "東部仙台",
      "enName": "Eastern Sendai"
    },
    "class20": {
      "code": "0420700",
      "name": "名取市",
      "enName": "Natori City",
      "kana": "なとりし",
      "chName": "名取市",
      "zhName": "名取市",
      "koName": "나토리 시",
      "esName": "Ciudad de Natori",
      "ptName": "cidade de Natori",
      "thName": "เมืองนาโทริ",
      "viName": "thành phố Natori",
      "inName": "kota Natori",
      "tlName": "siyudad ng Natori",
      "moName": "Натори хот",
      "buName": "နာတိုးရိ မြို့",
      "khName": "ទីក្រុង ណាតូរី",
      "neName": "नातोरी सहर"
    }
  },
  "0420800": {
    "office": {
      "code": "040000",
      "name": "宮城県",
      "enName": "Miyagi",
      "officeName": "仙台管区気象台",
      "chName": "宫城县",
      "zhName": "宮城縣",
      "koName": "미야기현",
      "esName": "Prefectura de Miyagi",
      "ptName": "Província de Miyagi",
      "thName": "จังหวัดมิยางิ",
      "viName": "Tỉnh Miyagi",
      "inName": "Prefektur Miyagi",
      "tlName": "Miyagi Prefecture",
      "moName": "Мияги аймаг",
      "buName": "မီယာဂီ ပြည်နယ်",
      "khName": "ខេត្ត មីយ៉ាហ្គី",
      "neName": "मियागी जिल्ला"
    },
    "class10": {
      "code": "040010",
      "name": "東部",
      "enName": "Eastern Region",
      "chName": "宫城县北部",
      "zhName": "宮城縣北部",
      "koName": "미야기 현 동부",
      "esName": "Este de la Prefectura de Miyagi",
      "ptName": "Leste da Província de Miyagi",
      "thName": "จังหวัดมิยางิตอนตะวันออก",
      "viName": "Miền Đông tỉnh Miyagi",
      "inName": "Bagian Timur di Prefektur Miyagi",
      "tlName": "Silangang bahagi ng Miyagi Prefecture",
      "moName": "Зүүн Мияги аймаг",
      "buName": "မိယဂိစီရင်စုအရှေ့ပိုင်း",
      "khName": "តំបន់ខាងកើតនៃខេត្តមីយ៉ាហ្គិ",
      "neName": "मियागी जिल्लाको पूर्वी भाग"
    },
    "class15": {
      "code": "040015",
      "name": "東部仙南",
      "enName": "Eastern Sennan"
    },
    "class20": {
      "code": "0420800",
      "name": "角田市",
      "enName": "Kakuda City",
      "kana": "かくだし",
      "chName": "角田市",
      "zhName": "角田市",
      "koName": "가쿠다 시",
      "esName": "Ciudad de Kakuda",
      "ptName": "cidade de Kakuda",
      "thName": "เมืองคะคุดะ",
      "viName": "thành phố Kakuda",
      "inName": "kota Kakuda",
      "tlName": "siyudad ng Kakuda",
      "moName": "Какүда хот",
      "buName": "ခါကုဒါ့ မြို့",
      "khName": "ទីក្រុង កាគូដា",
      "neName": "काकुदा सहर"
    }
  },
  "0420900": {
    "office": {
      "code": "040000",
      "name": "宮城県",
      "enName": "Miyagi",
      "officeName": "仙台管区気象台",
      "chName": "宫城县",
      "zhName": "宮城縣",
      "koName": "미야기현",
      "esName": "Prefectura de Miyagi",
      "ptName": "Província de Miyagi",
      "thName": "จังหวัดมิยางิ",
      "viName": "Tỉnh Miyagi",
      "inName": "Prefektur Miyagi",
      "tlName": "Miyagi Prefecture",
      "moName": "Мияги аймаг",
      "buName": "မီယာဂီ ပြည်နယ်",
      "khName": "ខេត្ត មីយ៉ាហ្គី",
      "neName": "मियागी जिल्ला"
    },
    "class10": {
      "code": "040010",
      "name": "東部",
      "enName": "Eastern Region",
      "chName": "宫城县北部",
      "zhName": "宮城縣北部",
      "koName": "미야기 현 동부",
      "esName": "Este de la Prefectura de Miyagi",
      "ptName": "Leste da Província de Miyagi",
      "thName": "จังหวัดมิยางิตอนตะวันออก",
      "viName": "Miền Đông tỉnh Miyagi",
      "inName": "Bagian Timur di Prefektur Miyagi",
      "tlName": "Silangang bahagi ng Miyagi Prefecture",
      "moName": "Зүүн Мияги аймаг",
      "buName": "မိယဂိစီရင်စုအရှေ့ပိုင်း",
      "khName": "តំបន់ខាងកើតនៃខេត្តមីយ៉ាហ្គិ",
      "neName": "मियागी जिल्लाको पूर्वी भाग"
    },
    "class15": {
      "code": "040011",
      "name": "東部仙台",
      "enName": "Eastern Sendai"
    },
    "class20": {
      "code": "0420900",
      "name": "多賀城市",
      "enName": "Tagajo City",
      "kana": "たがじょうし",
      "chName": "多贺城市",
      "zhName": "多賀城市",
      "koName": "다가죠 시",
      "esName": "Ciudad deTagajō",
      "ptName": "cidade de Tagajo",
      "thName": "เมืองทะกะโจ",
      "viName": "thành phố Tagajo",
      "inName": "kota Tagajo",
      "tlName": "siyudad ng Tagajo",
      "moName": "Тагажо хот",
      "buName": "တားဂါ့ဂျို မြို့",
      "khName": "ទីក្រុង តាកាជុ",
      "neName": "तागाजो सहर"
    }
  },
  "0421100": {
    "office": {
      "code": "040000",
      "name": "宮城県",
      "enName": "Miyagi",
      "officeName": "仙台管区気象台",
      "chName": "宫城县",
      "zhName": "宮城縣",
      "koName": "미야기현",
      "esName": "Prefectura de Miyagi",
      "ptName": "Província de Miyagi",
      "thName": "จังหวัดมิยางิ",
      "viName": "Tỉnh Miyagi",
      "inName": "Prefektur Miyagi",
      "tlName": "Miyagi Prefecture",
      "moName": "Мияги аймаг",
      "buName": "မီယာဂီ ပြည်နယ်",
      "khName": "ខេត្ត មីយ៉ាហ្គី",
      "neName": "मियागी जिल्ला"
    },
    "class10": {
      "code": "040010",
      "name": "東部",
      "enName": "Eastern Region",
      "chName": "宫城县北部",
      "zhName": "宮城縣北部",
      "koName": "미야기 현 동부",
      "esName": "Este de la Prefectura de Miyagi",
      "ptName": "Leste da Província de Miyagi",
      "thName": "จังหวัดมิยางิตอนตะวันออก",
      "viName": "Miền Đông tỉnh Miyagi",
      "inName": "Bagian Timur di Prefektur Miyagi",
      "tlName": "Silangang bahagi ng Miyagi Prefecture",
      "moName": "Зүүн Мияги аймаг",
      "buName": "မိယဂိစီရင်စုအရှေ့ပိုင်း",
      "khName": "តំបន់ខាងកើតនៃខេត្តមីយ៉ាហ្គិ",
      "neName": "मियागी जिल्लाको पूर्वी भाग"
    },
    "class15": {
      "code": "040011",
      "name": "東部仙台",
      "enName": "Eastern Sendai"
    },
    "class20": {
      "code": "0421100",
      "name": "岩沼市",
      "enName": "Iwanuma City",
      "kana": "いわぬまし",
      "chName": "岩沼市",
      "zhName": "岩沼市",
      "koName": "이와누마 시",
      "esName": "Ciudad de Iwanuma",
      "ptName": "cidade de Iwanuma",
      "thName": "เมืองอิวะนุมะ",
      "viName": "thành phố Iwanuma",
      "inName": "kota Iwanuma",
      "tlName": "siyudad ng Iwanuma",
      "moName": "Иванүма хот",
      "buName": "အီဝါ့နူမ မြို့",
      "khName": "ទីក្រុង អ៊ីវ៉ានូម៉ា",
      "neName": "इवानुमा सहर"
    }
  },
  "0421200": {
    "office": {
      "code": "040000",
      "name": "宮城県",
      "enName": "Miyagi",
      "officeName": "仙台管区気象台",
      "chName": "宫城县",
      "zhName": "宮城縣",
      "koName": "미야기현",
      "esName": "Prefectura de Miyagi",
      "ptName": "Província de Miyagi",
      "thName": "จังหวัดมิยางิ",
      "viName": "Tỉnh Miyagi",
      "inName": "Prefektur Miyagi",
      "tlName": "Miyagi Prefecture",
      "moName": "Мияги аймаг",
      "buName": "မီယာဂီ ပြည်နယ်",
      "khName": "ខេត្ត មីយ៉ាហ្គី",
      "neName": "मियागी जिल्ला"
    },
    "class10": {
      "code": "040010",
      "name": "東部",
      "enName": "Eastern Region",
      "chName": "宫城县北部",
      "zhName": "宮城縣北部",
      "koName": "미야기 현 동부",
      "esName": "Este de la Prefectura de Miyagi",
      "ptName": "Leste da Província de Miyagi",
      "thName": "จังหวัดมิยางิตอนตะวันออก",
      "viName": "Miền Đông tỉnh Miyagi",
      "inName": "Bagian Timur di Prefektur Miyagi",
      "tlName": "Silangang bahagi ng Miyagi Prefecture",
      "moName": "Зүүн Мияги аймаг",
      "buName": "မိယဂိစီရင်စုအရှေ့ပိုင်း",
      "khName": "តំបន់ខាងកើតនៃខេត្តមីយ៉ាហ្គិ",
      "neName": "मियागी जिल्लाको पूर्वी भाग"
    },
    "class15": {
      "code": "040016",
      "name": "登米・東部栗原",
      "enName": "Tome and Eastern Kurihara"
    },
    "class20": {
      "code": "0421200",
      "name": "登米市",
      "enName": "Tome City",
      "kana": "とめし",
      "chName": "登米市",
      "zhName": "登米市",
      "koName": "도메 시",
      "esName": "Ciudad de Tome",
      "ptName": "cidade de Tome",
      "thName": "เมืองโทเมะ",
      "viName": "thành phố Tome",
      "inName": "kota Tome",
      "tlName": "siyudad ng Tome",
      "moName": "Томэ хот",
      "buName": "တိုမု မြို့",
      "khName": "ទីក្រុង ថូម",
      "neName": "तोमे सहर"
    }
  },
  "0421301": {
    "office": {
      "code": "040000",
      "name": "宮城県",
      "enName": "Miyagi",
      "officeName": "仙台管区気象台",
      "chName": "宫城县",
      "zhName": "宮城縣",
      "koName": "미야기현",
      "esName": "Prefectura de Miyagi",
      "ptName": "Província de Miyagi",
      "thName": "จังหวัดมิยางิ",
      "viName": "Tỉnh Miyagi",
      "inName": "Prefektur Miyagi",
      "tlName": "Miyagi Prefecture",
      "moName": "Мияги аймаг",
      "buName": "မီယာဂီ ပြည်နယ်",
      "khName": "ខេត្ត មីយ៉ាហ្គី",
      "neName": "मियागी जिल्ला"
    },
    "class10": {
      "code": "040010",
      "name": "東部",
      "enName": "Eastern Region",
      "chName": "宫城县北部",
      "zhName": "宮城縣北部",
      "koName": "미야기 현 동부",
      "esName": "Este de la Prefectura de Miyagi",
      "ptName": "Leste da Província de Miyagi",
      "thName": "จังหวัดมิยางิตอนตะวันออก",
      "viName": "Miền Đông tỉnh Miyagi",
      "inName": "Bagian Timur di Prefektur Miyagi",
      "tlName": "Silangang bahagi ng Miyagi Prefecture",
      "moName": "Зүүн Мияги аймаг",
      "buName": "မိယဂိစီရင်စုအရှေ့ပိုင်း",
      "khName": "តំបន់ខាងកើតនៃខេត្តមីយ៉ាហ្គិ",
      "neName": "मियागी जिल्लाको पूर्वी भाग"
    },
    "class15": {
      "code": "040016",
      "name": "登米・東部栗原",
      "enName": "Tome and Eastern Kurihara"
    },
    "class20": {
      "code": "0421301",
      "name": "栗原市東部",
      "enName": "Eastern Kurihara City",
      "kana": "くりはらしとうぶ",
      "chName": "栗原市",
      "zhName": "栗原市",
      "koName": "쿠리하라시",
      "esName": "Ciudad de Kurihara",
      "ptName": "Cidade de Kurihara",
      "thName": "เมืองคุริฮารา",
      "viName": "Thành phố Kurihara",
      "inName": "Kota Kurihara",
      "tlName": "Lungsod ng Kurihara",
      "moName": "Cidade de Kurihara",
      "buName": "ကွီဟာရာမြို့",
      "khName": "ខេត្តគូរីហារ",
      "neName": "कुरिहारा नगर"
    }
  },
  "0421302": {
    "office": {
      "code": "040000",
      "name": "宮城県",
      "enName": "Miyagi",
      "officeName": "仙台管区気象台",
      "chName": "宫城县",
      "zhName": "宮城縣",
      "koName": "미야기현",
      "esName": "Prefectura de Miyagi",
      "ptName": "Província de Miyagi",
      "thName": "จังหวัดมิยางิ",
      "viName": "Tỉnh Miyagi",
      "inName": "Prefektur Miyagi",
      "tlName": "Miyagi Prefecture",
      "moName": "Мияги аймаг",
      "buName": "မီယာဂီ ပြည်နယ်",
      "khName": "ខេត្ត មីយ៉ាហ្គី",
      "neName": "मियागी जिल्ला"
    },
    "class10": {
      "code": "040020",
      "name": "西部",
      "enName": "Western Region",
      "chName": "宫城县北部",
      "zhName": "宮城縣北部",
      "koName": "미야기 현 서부",
      "esName": "Oeste de la Prefectura de Miyagi",
      "ptName": "Oeste da Província de Miyagi",
      "thName": "จังหวัดมิยากิตอนตะวันตก",
      "viName": "Miền Tây tỉnh Miyagi",
      "inName": "Bagian Barat di Prefektur Miyagi",
      "tlName": "Kanlurang bahagi ng Miyagi Prefecture",
      "moName": "Баруун Мияги аймаг",
      "buName": "မိယဂိစီရင်စုအပေါ်ပိုင်း",
      "khName": "តំបន់ខាងលិចនៃខេត្តមីយ៉ាហ្គិ",
      "neName": "मियागी जिल्लाको पश्चिमी भाग"
    },
    "class15": {
      "code": "040024",
      "name": "西部栗原",
      "enName": "Western Kurihara"
    },
    "class20": {
      "code": "0421302",
      "name": "栗原市西部",
      "enName": "Western Kurihara City",
      "kana": "くりはらしせいぶ",
      "chName": "栗原市",
      "zhName": "栗原市",
      "koName": "쿠리하라시",
      "esName": "Ciudad de Kurihara",
      "ptName": "Cidade de Kurihara",
      "thName": "เมืองคุริฮารา",
      "viName": "Thành phố Kurihara",
      "inName": "Kota Kurihara",
      "tlName": "Lungsod ng Kurihara",
      "moName": "Cidade de Kurihara",
      "buName": "ကွီဟာရာမြို့",
      "khName": "ខេត្តគូរីហារ",
      "neName": "कुरिहारा नगर"
    }
  },
  "0421400": {
    "office": {
      "code": "040000",
      "name": "宮城県",
      "enName": "Miyagi",
      "officeName": "仙台管区気象台",
      "chName": "宫城县",
      "zhName": "宮城縣",
      "koName": "미야기현",
      "esName": "Prefectura de Miyagi",
      "ptName": "Província de Miyagi",
      "thName": "จังหวัดมิยางิ",
      "viName": "Tỉnh Miyagi",
      "inName": "Prefektur Miyagi",
      "tlName": "Miyagi Prefecture",
      "moName": "Мияги аймаг",
      "buName": "မီယာဂီ ပြည်နယ်",
      "khName": "ខេត្ត មីយ៉ាហ្គី",
      "neName": "मियागी जिल्ला"
    },
    "class10": {
      "code": "040010",
      "name": "東部",
      "enName": "Eastern Region",
      "chName": "宫城县北部",
      "zhName": "宮城縣北部",
      "koName": "미야기 현 동부",
      "esName": "Este de la Prefectura de Miyagi",
      "ptName": "Leste da Província de Miyagi",
      "thName": "จังหวัดมิยางิตอนตะวันออก",
      "viName": "Miền Đông tỉnh Miyagi",
      "inName": "Bagian Timur di Prefektur Miyagi",
      "tlName": "Silangang bahagi ng Miyagi Prefecture",
      "moName": "Зүүн Мияги аймаг",
      "buName": "မိယဂိစီရင်စုအရှေ့ပိုင်း",
      "khName": "តំបន់ខាងកើតនៃខេត្តមីយ៉ាហ្គិ",
      "neName": "मियागी जिल्लाको पूर्वी भाग"
    },
    "class15": {
      "code": "040012",
      "name": "石巻地域",
      "enName": "Ishinomaki Area"
    },
    "class20": {
      "code": "0421400",
      "name": "東松島市",
      "enName": "Higashimatsushima City",
      "kana": "ひがしまつしまし",
      "chName": "东松岛市",
      "zhName": "東松島市",
      "koName": "히가시마쓰시마 시",
      "esName": "Ciudad de Higashimatsushima",
      "ptName": "cidade de Higashimatsushima",
      "thName": "เมืองฮิงาชิมัทสึชิมา",
      "viName": "thành phố Higashimatsushima",
      "inName": "kota Higashimatsushima",
      "tlName": "siyudad ng Higashimatsushima",
      "moName": "Хигашимацүшима хот",
      "buName": "ဟီဂါးရှီမဆူရှိမ မြို့",
      "khName": "ទីក្រុង ហ៊ីកាស៊ីម៉ាស៊ូស៊ីម៉ា",
      "neName": "हिगाशिमात्सुशिमा सहर"
    }
  },
  "0421501": {
    "office": {
      "code": "040000",
      "name": "宮城県",
      "enName": "Miyagi",
      "officeName": "仙台管区気象台",
      "chName": "宫城县",
      "zhName": "宮城縣",
      "koName": "미야기현",
      "esName": "Prefectura de Miyagi",
      "ptName": "Província de Miyagi",
      "thName": "จังหวัดมิยางิ",
      "viName": "Tỉnh Miyagi",
      "inName": "Prefektur Miyagi",
      "tlName": "Miyagi Prefecture",
      "moName": "Мияги аймаг",
      "buName": "မီယာဂီ ပြည်နယ်",
      "khName": "ខេត្ត មីយ៉ាហ្គី",
      "neName": "मियागी जिल्ला"
    },
    "class10": {
      "code": "040010",
      "name": "東部",
      "enName": "Eastern Region",
      "chName": "宫城县北部",
      "zhName": "宮城縣北部",
      "koName": "미야기 현 동부",
      "esName": "Este de la Prefectura de Miyagi",
      "ptName": "Leste da Província de Miyagi",
      "thName": "จังหวัดมิยางิตอนตะวันออก",
      "viName": "Miền Đông tỉnh Miyagi",
      "inName": "Bagian Timur di Prefektur Miyagi",
      "tlName": "Silangang bahagi ng Miyagi Prefecture",
      "moName": "Зүүн Мияги аймаг",
      "buName": "မိယဂိစီရင်စုအရှေ့ပိုင်း",
      "khName": "តំបន់ខាងកើតនៃខេត្តមីយ៉ាហ្គិ",
      "neName": "मियागी जिल्लाको पूर्वी भाग"
    },
    "class15": {
      "code": "040013",
      "name": "東部大崎",
      "enName": "Eastern Osaki"
    },
    "class20": {
      "code": "0421501",
      "name": "大崎市東部",
      "enName": "Eastern Osaki City",
      "kana": "おおさきしとうぶ",
      "chName": "大崎市",
      "zhName": "大崎市",
      "koName": "오사키시",
      "esName": "Ciudad de Osaki",
      "ptName": "Cidade de Osaki",
      "thName": "เมืองโอซากิ",
      "viName": "Thành phố Osaki",
      "inName": "Kota Osaki",
      "tlName": "Lungsod ng Osaki",
      "moName": "Cidade de Osaki",
      "buName": "အိုဇာကီမြို့",
      "khName": "ខេត្តអូសាគី",
      "neName": "ओसाकी नगर"
    }
  },
  "0421502": {
    "office": {
      "code": "040000",
      "name": "宮城県",
      "enName": "Miyagi",
      "officeName": "仙台管区気象台",
      "chName": "宫城县",
      "zhName": "宮城縣",
      "koName": "미야기현",
      "esName": "Prefectura de Miyagi",
      "ptName": "Província de Miyagi",
      "thName": "จังหวัดมิยางิ",
      "viName": "Tỉnh Miyagi",
      "inName": "Prefektur Miyagi",
      "tlName": "Miyagi Prefecture",
      "moName": "Мияги аймаг",
      "buName": "မီယာဂီ ပြည်နယ်",
      "khName": "ខេត្ត មីយ៉ាហ្គី",
      "neName": "मियागी जिल्ला"
    },
    "class10": {
      "code": "040020",
      "name": "西部",
      "enName": "Western Region",
      "chName": "宫城县北部",
      "zhName": "宮城縣北部",
      "koName": "미야기 현 서부",
      "esName": "Oeste de la Prefectura de Miyagi",
      "ptName": "Oeste da Província de Miyagi",
      "thName": "จังหวัดมิยากิตอนตะวันตก",
      "viName": "Miền Tây tỉnh Miyagi",
      "inName": "Bagian Barat di Prefektur Miyagi",
      "tlName": "Kanlurang bahagi ng Miyagi Prefecture",
      "moName": "Баруун Мияги аймаг",
      "buName": "မိယဂိစီရင်စုအပေါ်ပိုင်း",
      "khName": "តំបន់ខាងលិចនៃខេត្តមីយ៉ាហ្គិ",
      "neName": "मियागी जिल्लाको पश्चिमी भाग"
    },
    "class15": {
      "code": "040023",
      "name": "西部大崎",
      "enName": "Western Osaki"
    },
    "class20": {
      "code": "0421502",
      "name": "大崎市西部",
      "enName": "Western Osaki City",
      "kana": "おおさきしせいぶ",
      "chName": "大崎市",
      "zhName": "大崎市",
      "koName": "오사키시",
      "esName": "Ciudad de Osaki",
      "ptName": "Cidade de Osaki",
      "thName": "เมืองโอซากิ",
      "viName": "Thành phố Osaki",
      "inName": "Kota Osaki",
      "tlName": "Lungsod ng Osaki",
      "moName": "Cidade de Osaki",
      "buName": "အိုဇာကီမြို့",
      "khName": "ខេត្តអូសាគី",
      "neName": "ओसाकी नगर"
    }
  },
  "0421600": {
    "office": {
      "code": "040000",
      "name": "宮城県",
      "enName": "Miyagi",
      "officeName": "仙台管区気象台",
      "chName": "宫城县",
      "zhName": "宮城縣",
      "koName": "미야기현",
      "esName": "Prefectura de Miyagi",
      "ptName": "Província de Miyagi",
      "thName": "จังหวัดมิยางิ",
      "viName": "Tỉnh Miyagi",
      "inName": "Prefektur Miyagi",
      "tlName": "Miyagi Prefecture",
      "moName": "Мияги аймаг",
      "buName": "မီယာဂီ ပြည်နယ်",
      "khName": "ខេត្ត មីយ៉ាហ្គី",
      "neName": "मियागी जिल्ला"
    },
    "class10": {
      "code": "040010",
      "name": "東部",
      "enName": "Eastern Region",
      "chName": "宫城县北部",
      "zhName": "宮城縣北部",
      "koName": "미야기 현 동부",
      "esName": "Este de la Prefectura de Miyagi",
      "ptName": "Leste da Província de Miyagi",
      "thName": "จังหวัดมิยางิตอนตะวันออก",
      "viName": "Miền Đông tỉnh Miyagi",
      "inName": "Bagian Timur di Prefektur Miyagi",
      "tlName": "Silangang bahagi ng Miyagi Prefecture",
      "moName": "Зүүн Мияги аймаг",
      "buName": "မိယဂိစီရင်စုအရှေ့ပိုင်း",
      "khName": "តំបន់ខាងកើតនៃខេត្តមីយ៉ាហ្គិ",
      "neName": "मियागी जिल्लाको पूर्वी भाग"
    },
    "class15": {
      "code": "040011",
      "name": "東部仙台",
      "enName": "Eastern Sendai"
    },
    "class20": {
      "code": "0421600",
      "name": "富谷市",
      "enName": "Tomiya City",
      "kana": "とみやし",
      "chName": "富谷市",
      "zhName": "富谷市",
      "koName": "도미야 시",
      "esName": "Ciudad de Tomiya",
      "ptName": "cidade de Tomiya",
      "thName": "เมืองโทะมิยะ",
      "viName": "Thành phố Tomiya",
      "inName": "Kota Tomiya",
      "tlName": "Lungsod ng Tomiya",
      "moName": "Томия хот",
      "buName": "တိုမိရ မြို့",
      "khName": "ទីក្រុង ថូមីយ៉ា",
      "neName": "तोमिया सहर"
    }
  },
  "0430100": {
    "office": {
      "code": "040000",
      "name": "宮城県",
      "enName": "Miyagi",
      "officeName": "仙台管区気象台",
      "chName": "宫城县",
      "zhName": "宮城縣",
      "koName": "미야기현",
      "esName": "Prefectura de Miyagi",
      "ptName": "Província de Miyagi",
      "thName": "จังหวัดมิยางิ",
      "viName": "Tỉnh Miyagi",
      "inName": "Prefektur Miyagi",
      "tlName": "Miyagi Prefecture",
      "moName": "Мияги аймаг",
      "buName": "မီယာဂီ ပြည်နယ်",
      "khName": "ខេត្ត មីយ៉ាហ្គី",
      "neName": "मियागी जिल्ला"
    },
    "class10": {
      "code": "040020",
      "name": "西部",
      "enName": "Western Region",
      "chName": "宫城县北部",
      "zhName": "宮城縣北部",
      "koName": "미야기 현 서부",
      "esName": "Oeste de la Prefectura de Miyagi",
      "ptName": "Oeste da Província de Miyagi",
      "thName": "จังหวัดมิยากิตอนตะวันตก",
      "viName": "Miền Tây tỉnh Miyagi",
      "inName": "Bagian Barat di Prefektur Miyagi",
      "tlName": "Kanlurang bahagi ng Miyagi Prefecture",
      "moName": "Баруун Мияги аймаг",
      "buName": "မိယဂိစီရင်စုအပေါ်ပိုင်း",
      "khName": "តំបន់ខាងលិចនៃខេត្តមីយ៉ាហ្គិ",
      "neName": "मियागी जिल्लाको पश्चिमी भाग"
    },
    "class15": {
      "code": "040022",
      "name": "西部仙南",
      "enName": "Western Sennan"
    },
    "class20": {
      "code": "0430100",
      "name": "蔵王町",
      "enName": "Zao Town",
      "kana": "ざおうまち",
      "chName": "藏王町",
      "zhName": "藏王町",
      "koName": "자오 정",
      "esName": "Pueblo de Zao",
      "ptName": "bairro de Zao",
      "thName": "เมืองซาโอะ",
      "viName": "thị trấn Zao",
      "inName": "kota Zao",
      "tlName": "bayan ng Zao",
      "moName": "Зaо жижиг хот",
      "buName": "ဇျောင် မြို့နယ်",
      "khName": "ទីប្រជុំជន ហ្សាវ",
      "neName": "जाओ नगर"
    }
  },
  "0430200": {
    "office": {
      "code": "040000",
      "name": "宮城県",
      "enName": "Miyagi",
      "officeName": "仙台管区気象台",
      "chName": "宫城县",
      "zhName": "宮城縣",
      "koName": "미야기현",
      "esName": "Prefectura de Miyagi",
      "ptName": "Província de Miyagi",
      "thName": "จังหวัดมิยางิ",
      "viName": "Tỉnh Miyagi",
      "inName": "Prefektur Miyagi",
      "tlName": "Miyagi Prefecture",
      "moName": "Мияги аймаг",
      "buName": "မီယာဂီ ပြည်နယ်",
      "khName": "ខេត្ត មីយ៉ាហ្គី",
      "neName": "मियागी जिल्ला"
    },
    "class10": {
      "code": "040020",
      "name": "西部",
      "enName": "Western Region",
      "chName": "宫城县北部",
      "zhName": "宮城縣北部",
      "koName": "미야기 현 서부",
      "esName": "Oeste de la Prefectura de Miyagi",
      "ptName": "Oeste da Província de Miyagi",
      "thName": "จังหวัดมิยากิตอนตะวันตก",
      "viName": "Miền Tây tỉnh Miyagi",
      "inName": "Bagian Barat di Prefektur Miyagi",
      "tlName": "Kanlurang bahagi ng Miyagi Prefecture",
      "moName": "Баруун Мияги аймаг",
      "buName": "မိယဂိစီရင်စုအပေါ်ပိုင်း",
      "khName": "តំបន់ខាងលិចនៃខេត្តមីយ៉ាហ្គិ",
      "neName": "मियागी जिल्लाको पश्चिमी भाग"
    },
    "class15": {
      "code": "040022",
      "name": "西部仙南",
      "enName": "Western Sennan"
    },
    "class20": {
      "code": "0430200",
      "name": "七ヶ宿町",
      "enName": "Shichikashuku Town",
      "kana": "しちかしゅくまち",
      "chName": "七宿町",
      "zhName": "七宿町",
      "koName": "시치카슈쿠 정",
      "esName": "Pueblo de Shichikashuku",
      "ptName": "bairro de Shichikashuku",
      "thName": "เมืองชิจิคะชูกุ",
      "viName": "thị trấn Shichikashuku",
      "inName": "kota Shichikashuku",
      "tlName": "bayan ng Shichikashuku",
      "moName": "Шичикашүкү жижиг хот",
      "buName": "ရှီကျိကရှုကု မြို့နယ်",
      "khName": "ទីប្រជុំជន ស៊ីឈីកាស៊ូគូ",
      "neName": "शिचिकाशुकु नगर"
    }
  },
  "0432100": {
    "office": {
      "code": "040000",
      "name": "宮城県",
      "enName": "Miyagi",
      "officeName": "仙台管区気象台",
      "chName": "宫城县",
      "zhName": "宮城縣",
      "koName": "미야기현",
      "esName": "Prefectura de Miyagi",
      "ptName": "Província de Miyagi",
      "thName": "จังหวัดมิยางิ",
      "viName": "Tỉnh Miyagi",
      "inName": "Prefektur Miyagi",
      "tlName": "Miyagi Prefecture",
      "moName": "Мияги аймаг",
      "buName": "မီယာဂီ ပြည်နယ်",
      "khName": "ខេត្ត មីយ៉ាហ្គី",
      "neName": "मियागी जिल्ला"
    },
    "class10": {
      "code": "040010",
      "name": "東部",
      "enName": "Eastern Region",
      "chName": "宫城县北部",
      "zhName": "宮城縣北部",
      "koName": "미야기 현 동부",
      "esName": "Este de la Prefectura de Miyagi",
      "ptName": "Leste da Província de Miyagi",
      "thName": "จังหวัดมิยางิตอนตะวันออก",
      "viName": "Miền Đông tỉnh Miyagi",
      "inName": "Bagian Timur di Prefektur Miyagi",
      "tlName": "Silangang bahagi ng Miyagi Prefecture",
      "moName": "Зүүн Мияги аймаг",
      "buName": "မိယဂိစီရင်စုအရှေ့ပိုင်း",
      "khName": "តំបន់ខាងកើតនៃខេត្តមីយ៉ាហ្គិ",
      "neName": "मियागी जिल्लाको पूर्वी भाग"
    },
    "class15": {
      "code": "040015",
      "name": "東部仙南",
      "enName": "Eastern Sennan"
    },
    "class20": {
      "code": "0432100",
      "name": "大河原町",
      "enName": "Ogawara Town",
      "kana": "おおがわらまち",
      "chName": "大河原町",
      "zhName": "大河原町",
      "koName": "오가와라 정",
      "esName": "Pueblo de Ōgawara",
      "ptName": "bairro de Ogawara",
      "thName": "เมืองโองาวาระ",
      "viName": "thị trấn Ogawara",
      "inName": "kota Ogawara",
      "tlName": "bayan ng Ogawara",
      "moName": "Огавара жижиг хот",
      "buName": "အိုဂါဝါးရာ့ မြို့နယ်",
      "khName": "ទីប្រជុំជន អូហ្កាវ៉ារ៉ា",
      "neName": "ओगावारा नगर"
    }
  },
  "0432200": {
    "office": {
      "code": "040000",
      "name": "宮城県",
      "enName": "Miyagi",
      "officeName": "仙台管区気象台",
      "chName": "宫城县",
      "zhName": "宮城縣",
      "koName": "미야기현",
      "esName": "Prefectura de Miyagi",
      "ptName": "Província de Miyagi",
      "thName": "จังหวัดมิยางิ",
      "viName": "Tỉnh Miyagi",
      "inName": "Prefektur Miyagi",
      "tlName": "Miyagi Prefecture",
      "moName": "Мияги аймаг",
      "buName": "မီယာဂီ ပြည်နယ်",
      "khName": "ខេត្ត មីយ៉ាហ្គី",
      "neName": "मियागी जिल्ला"
    },
    "class10": {
      "code": "040010",
      "name": "東部",
      "enName": "Eastern Region",
      "chName": "宫城县北部",
      "zhName": "宮城縣北部",
      "koName": "미야기 현 동부",
      "esName": "Este de la Prefectura de Miyagi",
      "ptName": "Leste da Província de Miyagi",
      "thName": "จังหวัดมิยางิตอนตะวันออก",
      "viName": "Miền Đông tỉnh Miyagi",
      "inName": "Bagian Timur di Prefektur Miyagi",
      "tlName": "Silangang bahagi ng Miyagi Prefecture",
      "moName": "Зүүн Мияги аймаг",
      "buName": "မိယဂိစီရင်စုအရှေ့ပိုင်း",
      "khName": "តំបន់ខាងកើតនៃខេត្តមីយ៉ាហ្គិ",
      "neName": "मियागी जिल्लाको पूर्वी भाग"
    },
    "class15": {
      "code": "040015",
      "name": "東部仙南",
      "enName": "Eastern Sennan"
    },
    "class20": {
      "code": "0432200",
      "name": "村田町",
      "enName": "Murata Town",
      "kana": "むらたまち",
      "chName": "村田町",
      "zhName": "村田町",
      "koName": "무라타 정",
      "esName": "Pueblo de Murata",
      "ptName": "bairro de Murata",
      "thName": "เมืองมุราตะ",
      "viName": "thị trấn Murata",
      "inName": "kota Murata",
      "tlName": "bayan ng Murata",
      "moName": "Мүрата жижиг хот",
      "buName": "မူရာ့တ မြို့နယ်",
      "khName": "ទីប្រជុំជន​ មូរ៉ាតា",
      "neName": "मुराता नगर"
    }
  },
  "0432300": {
    "office": {
      "code": "040000",
      "name": "宮城県",
      "enName": "Miyagi",
      "officeName": "仙台管区気象台",
      "chName": "宫城县",
      "zhName": "宮城縣",
      "koName": "미야기현",
      "esName": "Prefectura de Miyagi",
      "ptName": "Província de Miyagi",
      "thName": "จังหวัดมิยางิ",
      "viName": "Tỉnh Miyagi",
      "inName": "Prefektur Miyagi",
      "tlName": "Miyagi Prefecture",
      "moName": "Мияги аймаг",
      "buName": "မီယာဂီ ပြည်နယ်",
      "khName": "ខេត្ត មីយ៉ាហ្គី",
      "neName": "मियागी जिल्ला"
    },
    "class10": {
      "code": "040010",
      "name": "東部",
      "enName": "Eastern Region",
      "chName": "宫城县北部",
      "zhName": "宮城縣北部",
      "koName": "미야기 현 동부",
      "esName": "Este de la Prefectura de Miyagi",
      "ptName": "Leste da Província de Miyagi",
      "thName": "จังหวัดมิยางิตอนตะวันออก",
      "viName": "Miền Đông tỉnh Miyagi",
      "inName": "Bagian Timur di Prefektur Miyagi",
      "tlName": "Silangang bahagi ng Miyagi Prefecture",
      "moName": "Зүүн Мияги аймаг",
      "buName": "မိယဂိစီရင်စုအရှေ့ပိုင်း",
      "khName": "តំបន់ខាងកើតនៃខេត្តមីយ៉ាហ្គិ",
      "neName": "मियागी जिल्लाको पूर्वी भाग"
    },
    "class15": {
      "code": "040015",
      "name": "東部仙南",
      "enName": "Eastern Sennan"
    },
    "class20": {
      "code": "0432300",
      "name": "柴田町",
      "enName": "Shibata Town",
      "kana": "しばたまち",
      "chName": "柴田町",
      "zhName": "柴田町",
      "koName": "시바타 정",
      "esName": "Pueblo de Shibata",
      "ptName": "bairro de Shibata",
      "thName": "เมืองชิบาตะ",
      "viName": "thị trấn Shibata",
      "inName": "kota Shibata",
      "tlName": "bayan ng Shibata",
      "moName": "Шибата жижиг хот",
      "buName": "ရှီဘာ့တ မြို့နယ်",
      "khName": "ទីប្រជុំជន ស៊ីបាតា",
      "neName": "शिबाता नगर"
    }
  },
  "0432400": {
    "office": {
      "code": "040000",
      "name": "宮城県",
      "enName": "Miyagi",
      "officeName": "仙台管区気象台",
      "chName": "宫城县",
      "zhName": "宮城縣",
      "koName": "미야기현",
      "esName": "Prefectura de Miyagi",
      "ptName": "Província de Miyagi",
      "thName": "จังหวัดมิยางิ",
      "viName": "Tỉnh Miyagi",
      "inName": "Prefektur Miyagi",
      "tlName": "Miyagi Prefecture",
      "moName": "Мияги аймаг",
      "buName": "မီယာဂီ ပြည်နယ်",
      "khName": "ខេត្ត មីយ៉ាហ្គី",
      "neName": "मियागी जिल्ला"
    },
    "class10": {
      "code": "040020",
      "name": "西部",
      "enName": "Western Region",
      "chName": "宫城县北部",
      "zhName": "宮城縣北部",
      "koName": "미야기 현 서부",
      "esName": "Oeste de la Prefectura de Miyagi",
      "ptName": "Oeste da Província de Miyagi",
      "thName": "จังหวัดมิยากิตอนตะวันตก",
      "viName": "Miền Tây tỉnh Miyagi",
      "inName": "Bagian Barat di Prefektur Miyagi",
      "tlName": "Kanlurang bahagi ng Miyagi Prefecture",
      "moName": "Баруун Мияги аймаг",
      "buName": "မိယဂိစီရင်စုအပေါ်ပိုင်း",
      "khName": "តំបន់ខាងលិចនៃខេត្តមីយ៉ាហ្គិ",
      "neName": "मियागी जिल्लाको पश्चिमी भाग"
    },
    "class15": {
      "code": "040022",
      "name": "西部仙南",
      "enName": "Western Sennan"
    },
    "class20": {
      "code": "0432400",
      "name": "川崎町",
      "enName": "Kawasaki Town",
      "kana": "かわさきまち",
      "chName": "宫城川崎町",
      "zhName": "宮城川崎町",
      "koName": "미야기 가와사키 정",
      "esName": "Pueblo de Kawasaki, Miyagi",
      "ptName": "Miyagi, bairro de Kawasaki",
      "thName": "เมืองคาวาซากิ มิยางิ",
      "viName": "Thị trấn Kawasaki, Miyagi",
      "inName": "Kota Kawasaki, Miyagi",
      "tlName": "bayan ng Kawasaki, Miyagi",
      "moName": "Мияги Кавасаки жижиг хот",
      "buName": "မိယဂိကဝဆခိမြို့နယ် ",
      "khName": "ទីប្រជុំជនកាវ៉ាសាគី​ មីយ៉ាហ្គិ",
      "neName": "मियागी कावासाकी नगर"
    }
  },
  "0434100": {
    "office": {
      "code": "040000",
      "name": "宮城県",
      "enName": "Miyagi",
      "officeName": "仙台管区気象台",
      "chName": "宫城县",
      "zhName": "宮城縣",
      "koName": "미야기현",
      "esName": "Prefectura de Miyagi",
      "ptName": "Província de Miyagi",
      "thName": "จังหวัดมิยางิ",
      "viName": "Tỉnh Miyagi",
      "inName": "Prefektur Miyagi",
      "tlName": "Miyagi Prefecture",
      "moName": "Мияги аймаг",
      "buName": "မီယာဂီ ပြည်နယ်",
      "khName": "ខេត្ត មីយ៉ាហ្គី",
      "neName": "मियागी जिल्ला"
    },
    "class10": {
      "code": "040010",
      "name": "東部",
      "enName": "Eastern Region",
      "chName": "宫城县北部",
      "zhName": "宮城縣北部",
      "koName": "미야기 현 동부",
      "esName": "Este de la Prefectura de Miyagi",
      "ptName": "Leste da Província de Miyagi",
      "thName": "จังหวัดมิยางิตอนตะวันออก",
      "viName": "Miền Đông tỉnh Miyagi",
      "inName": "Bagian Timur di Prefektur Miyagi",
      "tlName": "Silangang bahagi ng Miyagi Prefecture",
      "moName": "Зүүн Мияги аймаг",
      "buName": "မိယဂိစီရင်စုအရှေ့ပိုင်း",
      "khName": "តំបន់ខាងកើតនៃខេត្តមីយ៉ាហ្គិ",
      "neName": "मियागी जिल्लाको पूर्वी भाग"
    },
    "class15": {
      "code": "040015",
      "name": "東部仙南",
      "enName": "Eastern Sennan"
    },
    "class20": {
      "code": "0434100",
      "name": "丸森町",
      "enName": "Marumori Town",
      "kana": "まるもりまち",
      "chName": "丸森町",
      "zhName": "丸森町",
      "koName": "마루모리 정",
      "esName": "Pueblo de Marumori",
      "ptName": "bairro de Marumori",
      "thName": "เมืองมารุโมริ",
      "viName": "thị trấn Marumori",
      "inName": "kota Marumori",
      "tlName": "bayan ng Marumori",
      "moName": "Маримори жижиг хот",
      "buName": "မာရုမောရိ မြို့နယ်",
      "khName": "ទីប្រជុំជន ម៉ារូម៉ូរី",
      "neName": "मारुमोरी नगर"
    }
  },
  "0436100": {
    "office": {
      "code": "040000",
      "name": "宮城県",
      "enName": "Miyagi",
      "officeName": "仙台管区気象台",
      "chName": "宫城县",
      "zhName": "宮城縣",
      "koName": "미야기현",
      "esName": "Prefectura de Miyagi",
      "ptName": "Província de Miyagi",
      "thName": "จังหวัดมิยางิ",
      "viName": "Tỉnh Miyagi",
      "inName": "Prefektur Miyagi",
      "tlName": "Miyagi Prefecture",
      "moName": "Мияги аймаг",
      "buName": "မီယာဂီ ပြည်နယ်",
      "khName": "ខេត្ត មីយ៉ាហ្គី",
      "neName": "मियागी जिल्ला"
    },
    "class10": {
      "code": "040010",
      "name": "東部",
      "enName": "Eastern Region",
      "chName": "宫城县北部",
      "zhName": "宮城縣北部",
      "koName": "미야기 현 동부",
      "esName": "Este de la Prefectura de Miyagi",
      "ptName": "Leste da Província de Miyagi",
      "thName": "จังหวัดมิยางิตอนตะวันออก",
      "viName": "Miền Đông tỉnh Miyagi",
      "inName": "Bagian Timur di Prefektur Miyagi",
      "tlName": "Silangang bahagi ng Miyagi Prefecture",
      "moName": "Зүүн Мияги аймаг",
      "buName": "မိယဂိစီရင်စုအရှေ့ပိုင်း",
      "khName": "តំបន់ខាងកើតនៃខេត្តមីយ៉ាហ្គិ",
      "neName": "मियागी जिल्लाको पूर्वी भाग"
    },
    "class15": {
      "code": "040011",
      "name": "東部仙台",
      "enName": "Eastern Sendai"
    },
    "class20": {
      "code": "0436100",
      "name": "亘理町",
      "enName": "Watari Town",
      "kana": "わたりちょう",
      "chName": "亘理町",
      "zhName": "亘理町",
      "koName": "와타리 정",
      "esName": "Pueblo de Watari",
      "ptName": "bairro de Watari",
      "thName": "เมืองวาตาริ",
      "viName": "thị trấn Watari",
      "inName": "kota Watari",
      "tlName": "bayan ng Watari",
      "moName": "Ватари жижиг хот",
      "buName": "ဝါတားရိ မြို့နယ်",
      "khName": "ទីប្រជុំជន វ៉ាតារី ",
      "neName": "वातारी नगर"
    }
  },
  "0436200": {
    "office": {
      "code": "040000",
      "name": "宮城県",
      "enName": "Miyagi",
      "officeName": "仙台管区気象台",
      "chName": "宫城县",
      "zhName": "宮城縣",
      "koName": "미야기현",
      "esName": "Prefectura de Miyagi",
      "ptName": "Província de Miyagi",
      "thName": "จังหวัดมิยางิ",
      "viName": "Tỉnh Miyagi",
      "inName": "Prefektur Miyagi",
      "tlName": "Miyagi Prefecture",
      "moName": "Мияги аймаг",
      "buName": "မီယာဂီ ပြည်နယ်",
      "khName": "ខេត្ត មីយ៉ាហ្គី",
      "neName": "मियागी जिल्ला"
    },
    "class10": {
      "code": "040010",
      "name": "東部",
      "enName": "Eastern Region",
      "chName": "宫城县北部",
      "zhName": "宮城縣北部",
      "koName": "미야기 현 동부",
      "esName": "Este de la Prefectura de Miyagi",
      "ptName": "Leste da Província de Miyagi",
      "thName": "จังหวัดมิยางิตอนตะวันออก",
      "viName": "Miền Đông tỉnh Miyagi",
      "inName": "Bagian Timur di Prefektur Miyagi",
      "tlName": "Silangang bahagi ng Miyagi Prefecture",
      "moName": "Зүүн Мияги аймаг",
      "buName": "မိယဂိစီရင်စုအရှေ့ပိုင်း",
      "khName": "តំបន់ខាងកើតនៃខេត្តមីយ៉ាហ្គិ",
      "neName": "मियागी जिल्लाको पूर्वी भाग"
    },
    "class15": {
      "code": "040011",
      "name": "東部仙台",
      "enName": "Eastern Sendai"
    },
    "class20": {
      "code": "0436200",
      "name": "山元町",
      "enName": "Yamamoto Town",
      "kana": "やまもとちょう",
      "chName": "山元町",
      "zhName": "山元町",
      "koName": "야마모토 정",
      "esName": "Pueblo de Yamamoto",
      "ptName": "bairro de Yamamoto",
      "thName": "เมืองยามาโมโตะ",
      "viName": "thị trấn Yamamoto",
      "inName": "kota Yamamoto",
      "tlName": "bayan ng Yamamoto",
      "moName": "Ямамото жижиг хот",
      "buName": "ယာမာမိုတို မြို့နယ်",
      "khName": "ទីប្រជុំជន យ៉ាម៉ាម៉ាតូ",
      "neName": "यामामोतो नगर"
    }
  },
  "0440100": {
    "office": {
      "code": "040000",
      "name": "宮城県",
      "enName": "Miyagi",
      "officeName": "仙台管区気象台",
      "chName": "宫城县",
      "zhName": "宮城縣",
      "koName": "미야기현",
      "esName": "Prefectura de Miyagi",
      "ptName": "Província de Miyagi",
      "thName": "จังหวัดมิยางิ",
      "viName": "Tỉnh Miyagi",
      "inName": "Prefektur Miyagi",
      "tlName": "Miyagi Prefecture",
      "moName": "Мияги аймаг",
      "buName": "မီယာဂီ ပြည်နယ်",
      "khName": "ខេត្ត មីយ៉ាហ្គី",
      "neName": "मियागी जिल्ला"
    },
    "class10": {
      "code": "040010",
      "name": "東部",
      "enName": "Eastern Region",
      "chName": "宫城县北部",
      "zhName": "宮城縣北部",
      "koName": "미야기 현 동부",
      "esName": "Este de la Prefectura de Miyagi",
      "ptName": "Leste da Província de Miyagi",
      "thName": "จังหวัดมิยางิตอนตะวันออก",
      "viName": "Miền Đông tỉnh Miyagi",
      "inName": "Bagian Timur di Prefektur Miyagi",
      "tlName": "Silangang bahagi ng Miyagi Prefecture",
      "moName": "Зүүн Мияги аймаг",
      "buName": "မိယဂိစီရင်စုအရှေ့ပိုင်း",
      "khName": "តំបន់ខាងកើតនៃខេត្តមីយ៉ាហ្គិ",
      "neName": "मियागी जिल्लाको पूर्वी भाग"
    },
    "class15": {
      "code": "040011",
      "name": "東部仙台",
      "enName": "Eastern Sendai"
    },
    "class20": {
      "code": "0440100",
      "name": "松島町",
      "enName": "Matsushima Town",
      "kana": "まつしままち",
      "chName": "松岛町",
      "zhName": "松島町",
      "koName": "마쓰시마 정",
      "esName": "Pueblo de Matsushima",
      "ptName": "bairro de Matsushima",
      "thName": "เมืองมัตสึชิมะ",
      "viName": "thị trấn Matsushima",
      "inName": "kota Matsushima",
      "tlName": "bayan ng Matsushima",
      "moName": "Мaцүшимa жижиг хот",
      "buName": "မာဆုရှိမ မြို့နယ်",
      "khName": "ទីប្រជុំជន ម៉ាស៊ូស៊ីម៉ា",
      "neName": "मात्सुशिमा नगर"
    }
  },
  "0440400": {
    "office": {
      "code": "040000",
      "name": "宮城県",
      "enName": "Miyagi",
      "officeName": "仙台管区気象台",
      "chName": "宫城县",
      "zhName": "宮城縣",
      "koName": "미야기현",
      "esName": "Prefectura de Miyagi",
      "ptName": "Província de Miyagi",
      "thName": "จังหวัดมิยางิ",
      "viName": "Tỉnh Miyagi",
      "inName": "Prefektur Miyagi",
      "tlName": "Miyagi Prefecture",
      "moName": "Мияги аймаг",
      "buName": "မီယာဂီ ပြည်နယ်",
      "khName": "ខេត្ត មីយ៉ាហ្គី",
      "neName": "मियागी जिल्ला"
    },
    "class10": {
      "code": "040010",
      "name": "東部",
      "enName": "Eastern Region",
      "chName": "宫城县北部",
      "zhName": "宮城縣北部",
      "koName": "미야기 현 동부",
      "esName": "Este de la Prefectura de Miyagi",
      "ptName": "Leste da Província de Miyagi",
      "thName": "จังหวัดมิยางิตอนตะวันออก",
      "viName": "Miền Đông tỉnh Miyagi",
      "inName": "Bagian Timur di Prefektur Miyagi",
      "tlName": "Silangang bahagi ng Miyagi Prefecture",
      "moName": "Зүүн Мияги аймаг",
      "buName": "မိယဂိစီရင်စုအရှေ့ပိုင်း",
      "khName": "តំបន់ខាងកើតនៃខេត្តមីយ៉ាហ្គិ",
      "neName": "मियागी जिल्लाको पूर्वी भाग"
    },
    "class15": {
      "code": "040011",
      "name": "東部仙台",
      "enName": "Eastern Sendai"
    },
    "class20": {
      "code": "0440400",
      "name": "七ヶ浜町",
      "enName": "Shichigahama Town",
      "kana": "しちがはままち",
      "chName": "七滨町",
      "zhName": "七濱町",
      "koName": "시치가하마 정",
      "esName": "Pueblo de Shichigahama",
      "ptName": "bairro de Shichigahama",
      "thName": "เมืองชิจิงาฮามะ",
      "viName": "thị trấn Shichigahama",
      "inName": "kota Shichigahama",
      "tlName": "bayan ng Shichigahama",
      "moName": "Шичигaхaмa жижиг хот",
      "buName": "ရှီကျိဂါးဟာ့မ မြို့နယ်",
      "khName": "ទីប្រជុំជន ស៊ីឈីហ្គាម៉ាហា",
      "neName": "शिचिगाहामा नगर"
    }
  },
  "0440600": {
    "office": {
      "code": "040000",
      "name": "宮城県",
      "enName": "Miyagi",
      "officeName": "仙台管区気象台",
      "chName": "宫城县",
      "zhName": "宮城縣",
      "koName": "미야기현",
      "esName": "Prefectura de Miyagi",
      "ptName": "Província de Miyagi",
      "thName": "จังหวัดมิยางิ",
      "viName": "Tỉnh Miyagi",
      "inName": "Prefektur Miyagi",
      "tlName": "Miyagi Prefecture",
      "moName": "Мияги аймаг",
      "buName": "မီယာဂီ ပြည်နယ်",
      "khName": "ខេត្ត មីយ៉ាហ្គី",
      "neName": "मियागी जिल्ला"
    },
    "class10": {
      "code": "040010",
      "name": "東部",
      "enName": "Eastern Region",
      "chName": "宫城县北部",
      "zhName": "宮城縣北部",
      "koName": "미야기 현 동부",
      "esName": "Este de la Prefectura de Miyagi",
      "ptName": "Leste da Província de Miyagi",
      "thName": "จังหวัดมิยางิตอนตะวันออก",
      "viName": "Miền Đông tỉnh Miyagi",
      "inName": "Bagian Timur di Prefektur Miyagi",
      "tlName": "Silangang bahagi ng Miyagi Prefecture",
      "moName": "Зүүн Мияги аймаг",
      "buName": "မိယဂိစီရင်စုအရှေ့ပိုင်း",
      "khName": "តំបន់ខាងកើតនៃខេត្តមីយ៉ាហ្គិ",
      "neName": "मियागी जिल्लाको पूर्वी भाग"
    },
    "class15": {
      "code": "040011",
      "name": "東部仙台",
      "enName": "Eastern Sendai"
    },
    "class20": {
      "code": "0440600",
      "name": "利府町",
      "enName": "Rifu Town",
      "kana": "りふちょう",
      "chName": "利府町",
      "zhName": "利府町",
      "koName": "리후 정",
      "esName": "Pueblo de Rifu",
      "ptName": "bairro de Rifu",
      "thName": "เมืองริฟุ",
      "viName": "thị trấn Rifu",
      "inName": "kota Rifu",
      "tlName": "bayan ng Rifu",
      "moName": "Рифү жижиг хот",
      "buName": "အီဟု မြို့နယ်",
      "khName": "ទីប្រជុំជន រីហ្វូ",
      "neName": "रिफु नगर"
    }
  },
  "0442101": {
    "office": {
      "code": "040000",
      "name": "宮城県",
      "enName": "Miyagi",
      "officeName": "仙台管区気象台",
      "chName": "宫城县",
      "zhName": "宮城縣",
      "koName": "미야기현",
      "esName": "Prefectura de Miyagi",
      "ptName": "Província de Miyagi",
      "thName": "จังหวัดมิยางิ",
      "viName": "Tỉnh Miyagi",
      "inName": "Prefektur Miyagi",
      "tlName": "Miyagi Prefecture",
      "moName": "Мияги аймаг",
      "buName": "မီယာဂီ ပြည်နယ်",
      "khName": "ខេត្ត មីយ៉ាហ្គី",
      "neName": "मियागी जिल्ला"
    },
    "class10": {
      "code": "040010",
      "name": "東部",
      "enName": "Eastern Region",
      "chName": "宫城县北部",
      "zhName": "宮城縣北部",
      "koName": "미야기 현 동부",
      "esName": "Este de la Prefectura de Miyagi",
      "ptName": "Leste da Província de Miyagi",
      "thName": "จังหวัดมิยางิตอนตะวันออก",
      "viName": "Miền Đông tỉnh Miyagi",
      "inName": "Bagian Timur di Prefektur Miyagi",
      "tlName": "Silangang bahagi ng Miyagi Prefecture",
      "moName": "Зүүн Мияги аймаг",
      "buName": "မိယဂိစီရင်စုအရှေ့ပိုင်း",
      "khName": "តំបន់ខាងកើតនៃខេត្តមីយ៉ាហ្គិ",
      "neName": "मियागी जिल्लाको पूर्वी भाग"
    },
    "class15": {
      "code": "040011",
      "name": "東部仙台",
      "enName": "Eastern Sendai"
    },
    "class20": {
      "code": "0442101",
      "name": "大和町東部",
      "enName": "Eastern Taiwa Town",
      "kana": "たいわちょうとうぶ",
      "chName": "大和町",
      "zhName": "大和町",
      "koName": "타이와마을",
      "esName": "Pueblo de Taiwa",
      "ptName": "Cidade de Taiwa",
      "thName": "เมืองไทวา",
      "viName": "thị trấn Taiwa",
      "inName": "Kota Taiwa",
      "tlName": "Bayan ng Taiwa",
      "moName": "Cidade de Taiwa",
      "buName": "တိုင်ဝါမြို့",
      "khName": "ខេត្តតៃវ៉ា",
      "neName": "ताइवा नगर"
    }
  },
  "0442102": {
    "office": {
      "code": "040000",
      "name": "宮城県",
      "enName": "Miyagi",
      "officeName": "仙台管区気象台",
      "chName": "宫城县",
      "zhName": "宮城縣",
      "koName": "미야기현",
      "esName": "Prefectura de Miyagi",
      "ptName": "Província de Miyagi",
      "thName": "จังหวัดมิยางิ",
      "viName": "Tỉnh Miyagi",
      "inName": "Prefektur Miyagi",
      "tlName": "Miyagi Prefecture",
      "moName": "Мияги аймаг",
      "buName": "မီယာဂီ ပြည်နယ်",
      "khName": "ខេត្ត មីយ៉ាហ្គី",
      "neName": "मियागी जिल्ला"
    },
    "class10": {
      "code": "040020",
      "name": "西部",
      "enName": "Western Region",
      "chName": "宫城县北部",
      "zhName": "宮城縣北部",
      "koName": "미야기 현 서부",
      "esName": "Oeste de la Prefectura de Miyagi",
      "ptName": "Oeste da Província de Miyagi",
      "thName": "จังหวัดมิยากิตอนตะวันตก",
      "viName": "Miền Tây tỉnh Miyagi",
      "inName": "Bagian Barat di Prefektur Miyagi",
      "tlName": "Kanlurang bahagi ng Miyagi Prefecture",
      "moName": "Баруун Мияги аймаг",
      "buName": "မိယဂိစီရင်စုအပေါ်ပိုင်း",
      "khName": "តំបន់ខាងលិចនៃខេត្តមីយ៉ាហ្គិ",
      "neName": "मियागी जिल्लाको पश्चिमी भाग"
    },
    "class15": {
      "code": "040021",
      "name": "西部仙台",
      "enName": "Western Sendai"
    },
    "class20": {
      "code": "0442102",
      "name": "大和町西部",
      "enName": "Western Taiwa Town",
      "kana": "たいわちょうせいぶ",
      "chName": "大和町",
      "zhName": "大和町",
      "koName": "타이와마을",
      "esName": "Pueblo de Taiwa",
      "ptName": "Cidade de Taiwa",
      "thName": "เมืองไทวา",
      "viName": "thị trấn Taiwa",
      "inName": "Kota Taiwa",
      "tlName": "Bayan ng Taiwa",
      "moName": "Cidade de Taiwa",
      "buName": "တိုင်ဝါမြို့",
      "khName": "ខេត្តតៃវ៉ា",
      "neName": "ताइवा नगर"
    }
  },
  "0442200": {
    "office": {
      "code": "040000",
      "name": "宮城県",
      "enName": "Miyagi",
      "officeName": "仙台管区気象台",
      "chName": "宫城县",
      "zhName": "宮城縣",
      "koName": "미야기현",
      "esName": "Prefectura de Miyagi",
      "ptName": "Província de Miyagi",
      "thName": "จังหวัดมิยางิ",
      "viName": "Tỉnh Miyagi",
      "inName": "Prefektur Miyagi",
      "tlName": "Miyagi Prefecture",
      "moName": "Мияги аймаг",
      "buName": "မီယာဂီ ပြည်နယ်",
      "khName": "ខេត្ត មីយ៉ាហ្គី",
      "neName": "मियागी जिल्ला"
    },
    "class10": {
      "code": "040010",
      "name": "東部",
      "enName": "Eastern Region",
      "chName": "宫城县北部",
      "zhName": "宮城縣北部",
      "koName": "미야기 현 동부",
      "esName": "Este de la Prefectura de Miyagi",
      "ptName": "Leste da Província de Miyagi",
      "thName": "จังหวัดมิยางิตอนตะวันออก",
      "viName": "Miền Đông tỉnh Miyagi",
      "inName": "Bagian Timur di Prefektur Miyagi",
      "tlName": "Silangang bahagi ng Miyagi Prefecture",
      "moName": "Зүүн Мияги аймаг",
      "buName": "မိယဂိစီရင်စုအရှေ့ပိုင်း",
      "khName": "តំបន់ខាងកើតនៃខេត្តមីយ៉ាហ្គិ",
      "neName": "मियागी जिल्लाको पूर्वी भाग"
    },
    "class15": {
      "code": "040011",
      "name": "東部仙台",
      "enName": "Eastern Sendai"
    },
    "class20": {
      "code": "0442200",
      "name": "大郷町",
      "enName": "Osato Town",
      "kana": "おおさとちょう",
      "chName": "大乡町",
      "zhName": "大鄉町",
      "koName": "오사토 정",
      "esName": "Pueblo de Ōsato",
      "ptName": "bairro de Osato",
      "thName": "เมืองโอซาโตะ",
      "viName": "thị trấn Osato",
      "inName": "kota Osato",
      "tlName": "bayan ng Osato",
      "moName": "Осaто жижиг хот",
      "buName": "အိုဆာတို မြို့နယ်",
      "khName": "ទីប្រជុំជន អូសាតូ",
      "neName": "ओसातो नगर"
    }
  },
  "0442400": {
    "office": {
      "code": "040000",
      "name": "宮城県",
      "enName": "Miyagi",
      "officeName": "仙台管区気象台",
      "chName": "宫城县",
      "zhName": "宮城縣",
      "koName": "미야기현",
      "esName": "Prefectura de Miyagi",
      "ptName": "Província de Miyagi",
      "thName": "จังหวัดมิยางิ",
      "viName": "Tỉnh Miyagi",
      "inName": "Prefektur Miyagi",
      "tlName": "Miyagi Prefecture",
      "moName": "Мияги аймаг",
      "buName": "မီယာဂီ ပြည်နယ်",
      "khName": "ខេត្ត មីយ៉ាហ្គី",
      "neName": "मियागी जिल्ला"
    },
    "class10": {
      "code": "040020",
      "name": "西部",
      "enName": "Western Region",
      "chName": "宫城县北部",
      "zhName": "宮城縣北部",
      "koName": "미야기 현 서부",
      "esName": "Oeste de la Prefectura de Miyagi",
      "ptName": "Oeste da Província de Miyagi",
      "thName": "จังหวัดมิยากิตอนตะวันตก",
      "viName": "Miền Tây tỉnh Miyagi",
      "inName": "Bagian Barat di Prefektur Miyagi",
      "tlName": "Kanlurang bahagi ng Miyagi Prefecture",
      "moName": "Баруун Мияги аймаг",
      "buName": "မိယဂိစီရင်စုအပေါ်ပိုင်း",
      "khName": "តំបន់ខាងលិចនៃខេត្តមីយ៉ាហ្គិ",
      "neName": "मियागी जिल्लाको पश्चिमी भाग"
    },
    "class15": {
      "code": "040021",
      "name": "西部仙台",
      "enName": "Western Sendai"
    },
    "class20": {
      "code": "0442400",
      "name": "大衡村",
      "enName": "Ohira Village",
      "kana": "おおひらむら",
      "chName": "大衡村",
      "zhName": "大衡村",
      "koName": "오히라 촌",
      "esName": "Aldea de Ōhira",
      "ptName": "povoado de Ohira",
      "thName": "หมู่บ้านโอฮิระ",
      "viName": "làng Ohira",
      "inName": "desa Ohira",
      "tlName": "nayon ng Ohira",
      "moName": "Охира тосгон",
      "buName": "အိုဟိရ ကျေးရွာ",
      "khName": "ភូមិ អូហ៊ីរ៉ា",
      "neName": "ओहिरा गाउँ"
    }
  },
  "0444400": {
    "office": {
      "code": "040000",
      "name": "宮城県",
      "enName": "Miyagi",
      "officeName": "仙台管区気象台",
      "chName": "宫城县",
      "zhName": "宮城縣",
      "koName": "미야기현",
      "esName": "Prefectura de Miyagi",
      "ptName": "Província de Miyagi",
      "thName": "จังหวัดมิยางิ",
      "viName": "Tỉnh Miyagi",
      "inName": "Prefektur Miyagi",
      "tlName": "Miyagi Prefecture",
      "moName": "Мияги аймаг",
      "buName": "မီယာဂီ ပြည်နယ်",
      "khName": "ខេត្ត មីយ៉ាហ្គី",
      "neName": "मियागी जिल्ला"
    },
    "class10": {
      "code": "040020",
      "name": "西部",
      "enName": "Western Region",
      "chName": "宫城县北部",
      "zhName": "宮城縣北部",
      "koName": "미야기 현 서부",
      "esName": "Oeste de la Prefectura de Miyagi",
      "ptName": "Oeste da Província de Miyagi",
      "thName": "จังหวัดมิยากิตอนตะวันตก",
      "viName": "Miền Tây tỉnh Miyagi",
      "inName": "Bagian Barat di Prefektur Miyagi",
      "tlName": "Kanlurang bahagi ng Miyagi Prefecture",
      "moName": "Баруун Мияги аймаг",
      "buName": "မိယဂိစီရင်စုအပေါ်ပိုင်း",
      "khName": "តំបន់ខាងលិចនៃខេត្តមីយ៉ាហ្គិ",
      "neName": "मियागी जिल्लाको पश्चिमी भाग"
    },
    "class15": {
      "code": "040023",
      "name": "西部大崎",
      "enName": "Western Osaki"
    },
    "class20": {
      "code": "0444400",
      "name": "色麻町",
      "enName": "Shikama Town",
      "kana": "しかまちょう",
      "chName": "色麻町",
      "zhName": "色麻町",
      "koName": "시카마 정",
      "esName": "Pueblo de Shikama",
      "ptName": "bairro de Shikama",
      "thName": "เมืองชิคามะ",
      "viName": "thị trấn Shikama",
      "inName": "kota Shikama",
      "tlName": "bayan ng Shikama",
      "moName": "Шикамa жижиг хот",
      "buName": "ရှီကာ့မ မြို့နယ်",
      "khName": "ទីប្រជុំជន ស៊ីកាម៉ា",
      "neName": "शिकामा नगर"
    }
  },
  "0444500": {
    "office": {
      "code": "040000",
      "name": "宮城県",
      "enName": "Miyagi",
      "officeName": "仙台管区気象台",
      "chName": "宫城县",
      "zhName": "宮城縣",
      "koName": "미야기현",
      "esName": "Prefectura de Miyagi",
      "ptName": "Província de Miyagi",
      "thName": "จังหวัดมิยางิ",
      "viName": "Tỉnh Miyagi",
      "inName": "Prefektur Miyagi",
      "tlName": "Miyagi Prefecture",
      "moName": "Мияги аймаг",
      "buName": "မီယာဂီ ပြည်နယ်",
      "khName": "ខេត្ត មីយ៉ាហ្គី",
      "neName": "मियागी जिल्ला"
    },
    "class10": {
      "code": "040020",
      "name": "西部",
      "enName": "Western Region",
      "chName": "宫城县北部",
      "zhName": "宮城縣北部",
      "koName": "미야기 현 서부",
      "esName": "Oeste de la Prefectura de Miyagi",
      "ptName": "Oeste da Província de Miyagi",
      "thName": "จังหวัดมิยากิตอนตะวันตก",
      "viName": "Miền Tây tỉnh Miyagi",
      "inName": "Bagian Barat di Prefektur Miyagi",
      "tlName": "Kanlurang bahagi ng Miyagi Prefecture",
      "moName": "Баруун Мияги аймаг",
      "buName": "မိယဂိစီရင်စုအပေါ်ပိုင်း",
      "khName": "តំបន់ខាងលិចនៃខេត្តមីយ៉ាហ្គិ",
      "neName": "मियागी जिल्लाको पश्चिमी भाग"
    },
    "class15": {
      "code": "040023",
      "name": "西部大崎",
      "enName": "Western Osaki"
    },
    "class20": {
      "code": "0444500",
      "name": "加美町",
      "enName": "Kami Town",
      "kana": "かみまち",
      "chName": "宫城加美町",
      "zhName": "宮城加美町",
      "koName": "미야기 가미 정",
      "esName": "Pueblo de Kami, Miyagi",
      "ptName": "Miyagi, bairro de Kami",
      "thName": "เมืองคามิ มิยางิ",
      "viName": "Thị trấn Kami, Miyagi",
      "inName": "Kota Kami, Miyagi",
      "tlName": "bayan ng Kami, Miyagi",
      "moName": "Мияги Ками жижиг хот",
      "buName": "မိယဂိကမိမြို့နယ် ",
      "khName": "ទីប្រជុំជនកាមិ មីយ៉ាហ្គិ",
      "neName": "मियागी कामि नगर"
    }
  },
  "0450100": {
    "office": {
      "code": "040000",
      "name": "宮城県",
      "enName": "Miyagi",
      "officeName": "仙台管区気象台",
      "chName": "宫城县",
      "zhName": "宮城縣",
      "koName": "미야기현",
      "esName": "Prefectura de Miyagi",
      "ptName": "Província de Miyagi",
      "thName": "จังหวัดมิยางิ",
      "viName": "Tỉnh Miyagi",
      "inName": "Prefektur Miyagi",
      "tlName": "Miyagi Prefecture",
      "moName": "Мияги аймаг",
      "buName": "မီယာဂီ ပြည်နယ်",
      "khName": "ខេត្ត មីយ៉ាហ្គី",
      "neName": "मियागी जिल्ला"
    },
    "class10": {
      "code": "040010",
      "name": "東部",
      "enName": "Eastern Region",
      "chName": "宫城县北部",
      "zhName": "宮城縣北部",
      "koName": "미야기 현 동부",
      "esName": "Este de la Prefectura de Miyagi",
      "ptName": "Leste da Província de Miyagi",
      "thName": "จังหวัดมิยางิตอนตะวันออก",
      "viName": "Miền Đông tỉnh Miyagi",
      "inName": "Bagian Timur di Prefektur Miyagi",
      "tlName": "Silangang bahagi ng Miyagi Prefecture",
      "moName": "Зүүн Мияги аймаг",
      "buName": "မိယဂိစီရင်စုအရှေ့ပိုင်း",
      "khName": "តំបន់ខាងកើតនៃខេត្តមីយ៉ាហ្គិ",
      "neName": "मियागी जिल्लाको पूर्वी भाग"
    },
    "class15": {
      "code": "040013",
      "name": "東部大崎",
      "enName": "Eastern Osaki"
    },
    "class20": {
      "code": "0450100",
      "name": "涌谷町",
      "enName": "Wakuya Town",
      "kana": "わくやちょう",
      "chName": "涌谷町",
      "zhName": "湧谷町",
      "koName": "와쿠야 정",
      "esName": "Pueblo de Wakuya",
      "ptName": "bairro de Wakuya",
      "thName": "เมืองวาคุยะ",
      "viName": "thị trấn Wakuya",
      "inName": "kota Wakuya",
      "tlName": "bayan ng Wakuya",
      "moName": "Вакуя жижиг хот",
      "buName": "ဝါးကုယ မြို့နယ်",
      "khName": "ទីប្រជុំជន វ៉ាគូយ៉ា",
      "neName": "वाकुया नगर"
    }
  },
  "0450500": {
    "office": {
      "code": "040000",
      "name": "宮城県",
      "enName": "Miyagi",
      "officeName": "仙台管区気象台",
      "chName": "宫城县",
      "zhName": "宮城縣",
      "koName": "미야기현",
      "esName": "Prefectura de Miyagi",
      "ptName": "Província de Miyagi",
      "thName": "จังหวัดมิยางิ",
      "viName": "Tỉnh Miyagi",
      "inName": "Prefektur Miyagi",
      "tlName": "Miyagi Prefecture",
      "moName": "Мияги аймаг",
      "buName": "မီယာဂီ ပြည်နယ်",
      "khName": "ខេត្ត មីយ៉ាហ្គី",
      "neName": "मियागी जिल्ला"
    },
    "class10": {
      "code": "040010",
      "name": "東部",
      "enName": "Eastern Region",
      "chName": "宫城县北部",
      "zhName": "宮城縣北部",
      "koName": "미야기 현 동부",
      "esName": "Este de la Prefectura de Miyagi",
      "ptName": "Leste da Província de Miyagi",
      "thName": "จังหวัดมิยางิตอนตะวันออก",
      "viName": "Miền Đông tỉnh Miyagi",
      "inName": "Bagian Timur di Prefektur Miyagi",
      "tlName": "Silangang bahagi ng Miyagi Prefecture",
      "moName": "Зүүн Мияги аймаг",
      "buName": "မိယဂိစီရင်စုအရှေ့ပိုင်း",
      "khName": "តំបន់ខាងកើតនៃខេត្តមីយ៉ាហ្គិ",
      "neName": "मियागी जिल्लाको पूर्वी भाग"
    },
    "class15": {
      "code": "040013",
      "name": "東部大崎",
      "enName": "Eastern Osaki"
    },
    "class20": {
      "code": "0450500",
      "name": "美里町",
      "enName": "Misato Town",
      "kana": "みさとまち",
      "chName": "宫城美里町",
      "zhName": "宮城美裡町",
      "koName": "미야기 미사토 정",
      "esName": "Pueblo de Misato, Miyagi",
      "ptName": "Miyagi, bairro de Misato",
      "thName": "เมืองมิซาโตะ มิยางิ",
      "viName": "Thị trấn Misato, Miyagi",
      "inName": "Kota Misato, Miyagi",
      "tlName": "bayan ng Misato, Miyagi",
      "moName": "Мияги Мисато жижиг хот",
      "buName": "မိယဂိမဆတိုမြို့နယ် ",
      "khName": "ទីប្រជុំជនមីសាតូ មីយ៉ាហ្គិ",
      "neName": "मियागी मिसातो नगर"
    }
  },
  "0458100": {
    "office": {
      "code": "040000",
      "name": "宮城県",
      "enName": "Miyagi",
      "officeName": "仙台管区気象台",
      "chName": "宫城县",
      "zhName": "宮城縣",
      "koName": "미야기현",
      "esName": "Prefectura de Miyagi",
      "ptName": "Província de Miyagi",
      "thName": "จังหวัดมิยางิ",
      "viName": "Tỉnh Miyagi",
      "inName": "Prefektur Miyagi",
      "tlName": "Miyagi Prefecture",
      "moName": "Мияги аймаг",
      "buName": "မီယာဂီ ပြည်နယ်",
      "khName": "ខេត្ត មីយ៉ាហ្គី",
      "neName": "मियागी जिल्ला"
    },
    "class10": {
      "code": "040010",
      "name": "東部",
      "enName": "Eastern Region",
      "chName": "宫城县北部",
      "zhName": "宮城縣北部",
      "koName": "미야기 현 동부",
      "esName": "Este de la Prefectura de Miyagi",
      "ptName": "Leste da Província de Miyagi",
      "thName": "จังหวัดมิยางิตอนตะวันออก",
      "viName": "Miền Đông tỉnh Miyagi",
      "inName": "Bagian Timur di Prefektur Miyagi",
      "tlName": "Silangang bahagi ng Miyagi Prefecture",
      "moName": "Зүүн Мияги аймаг",
      "buName": "မိယဂိစီရင်စုအရှေ့ပိုင်း",
      "khName": "តំបន់ខាងកើតនៃខេត្តមីយ៉ាហ្គិ",
      "neName": "मियागी जिल्लाको पूर्वी भाग"
    },
    "class15": {
      "code": "040012",
      "name": "石巻地域",
      "enName": "Ishinomaki Area"
    },
    "class20": {
      "code": "0458100",
      "name": "女川町",
      "enName": "Onagawa Town",
      "kana": "おながわちょう",
      "chName": "女川町",
      "zhName": "女川町",
      "koName": "오나가와 정",
      "esName": "Pueblo de Onagawa",
      "ptName": "bairro de Onagawa",
      "thName": "เมืองโอนางาวะ",
      "viName": "thị trấn Onagawa",
      "inName": "kota Onagawa",
      "tlName": "bayan ng Onagawa",
      "moName": "Онaгава жижиг хот",
      "buName": "အိုနားဂါ့ဝ မြို့နယ်",
      "khName": "ទីប្រជុំជន អូណាហ្គាវ៉ា",
      "neName": "ओनागावा नगर"
    }
  },
  "0460600": {
    "office": {
      "code": "040000",
      "name": "宮城県",
      "enName": "Miyagi",
      "officeName": "仙台管区気象台",
      "chName": "宫城县",
      "zhName": "宮城縣",
      "koName": "미야기현",
      "esName": "Prefectura de Miyagi",
      "ptName": "Província de Miyagi",
      "thName": "จังหวัดมิยางิ",
      "viName": "Tỉnh Miyagi",
      "inName": "Prefektur Miyagi",
      "tlName": "Miyagi Prefecture",
      "moName": "Мияги аймаг",
      "buName": "မီယာဂီ ပြည်နယ်",
      "khName": "ខេត្ត មីយ៉ាហ្គី",
      "neName": "मियागी जिल्ला"
    },
    "class10": {
      "code": "040010",
      "name": "東部",
      "enName": "Eastern Region",
      "chName": "宫城县北部",
      "zhName": "宮城縣北部",
      "koName": "미야기 현 동부",
      "esName": "Este de la Prefectura de Miyagi",
      "ptName": "Leste da Província de Miyagi",
      "thName": "จังหวัดมิยางิตอนตะวันออก",
      "viName": "Miền Đông tỉnh Miyagi",
      "inName": "Bagian Timur di Prefektur Miyagi",
      "tlName": "Silangang bahagi ng Miyagi Prefecture",
      "moName": "Зүүн Мияги аймаг",
      "buName": "မိယဂိစီရင်စုအရှေ့ပိုင်း",
      "khName": "តំបន់ខាងកើតនៃខេត្តមីយ៉ាហ្គិ",
      "neName": "मियागी जिल्लाको पूर्वी भाग"
    },
    "class15": {
      "code": "040014",
      "name": "気仙沼地域",
      "enName": "Kesennuma Area"
    },
    "class20": {
      "code": "0460600",
      "name": "南三陸町",
      "enName": "Minamisanriku Town",
      "kana": "みなみさんりくちょう",
      "chName": "南三陆町",
      "zhName": "南三陸町",
      "koName": "미나미산리쿠 정",
      "esName": "Pueblo de Minami-sanriku",
      "ptName": "bairro de Minamisanriku",
      "thName": "เมืองมานามิซันริกุ",
      "viName": "thị trấn Minamisanriku",
      "inName": "kota Minamisanriku",
      "tlName": "bayan ng Minamisanriku",
      "moName": "Минaмисaнрикү жижиг хот",
      "buName": "မီနာမိဆန်းရိကု မြို့နယ်",
      "khName": "ទីប្រជុំជន មីណាមីសានរីគូ",
      "neName": "मिनामिसानरिकु नगर"
    }
  },
  "0520100": {
    "office": {
      "code": "050000",
      "name": "秋田県",
      "enName": "Akita",
      "officeName": "秋田地方気象台",
      "chName": "秋田县",
      "zhName": "秋田縣",
      "koName": "아키타현",
      "esName": "Prefectura de Akita",
      "ptName": "Província de Akita",
      "thName": "จังหวัดอากิตะ",
      "viName": "Tỉnh Akita",
      "inName": "Prefektur Akita",
      "tlName": "Akita Prefecture",
      "moName": "Акита аймаг",
      "buName": "အခီတ ပြည်နယ်",
      "khName": "ខេត្ដ អាគីតា",
      "neName": "आकिता जिल्ला"
    },
    "class10": {
      "code": "050010",
      "name": "沿岸",
      "enName": "Coast",
      "chName": "秋田县沿岸",
      "zhName": "秋田縣沿岸",
      "koName": "아키타 현 연안",
      "esName": "Costa de la Prefectura de Akita",
      "ptName": "Litoral da Província de Akita",
      "thName": "ชายฝั่งของจังหวัดอากิตะ",
      "viName": "Bờ biển tỉnh Akita",
      "inName": "Pantai di Prefektur Akita",
      "tlName": "Bahagi ng baybayin ng Akita Prefecture",
      "moName": "Акита аймаг, эрэг",
      "buName": "အခိတစီရင်စုကမ်းခြေ",
      "khName": "តំបន់ឆ្នេរសមុទ្រនៃខេត្ដអាគីតា",
      "neName": "आकिता जिल्लाको समुद्री किनारको भाग"
    },
    "class15": {
      "code": "050011",
      "name": "秋田中央地域",
      "enName": "Akita Central Area"
    },
    "class20": {
      "code": "0520100",
      "name": "秋田市",
      "enName": "Akita City",
      "kana": "あきたし",
      "chName": "秋田市",
      "zhName": "秋田市",
      "koName": "아키타 시",
      "esName": "Ciudad de Akita",
      "ptName": "cidade de Akita",
      "thName": "เมืองอะกิตะ",
      "viName": "thành phố Akita",
      "inName": "kota Akita",
      "tlName": "siyudad ng Akita",
      "moName": "Акита хот",
      "buName": "အာခီတ မြို့",
      "khName": "ទីក្រុង អាគីតា",
      "neName": "आकिता सहर"
    }
  },
  "0520200": {
    "office": {
      "code": "050000",
      "name": "秋田県",
      "enName": "Akita",
      "officeName": "秋田地方気象台",
      "chName": "秋田县",
      "zhName": "秋田縣",
      "koName": "아키타현",
      "esName": "Prefectura de Akita",
      "ptName": "Província de Akita",
      "thName": "จังหวัดอากิตะ",
      "viName": "Tỉnh Akita",
      "inName": "Prefektur Akita",
      "tlName": "Akita Prefecture",
      "moName": "Акита аймаг",
      "buName": "အခီတ ပြည်နယ်",
      "khName": "ខេត្ដ អាគីតា",
      "neName": "आकिता जिल्ला"
    },
    "class10": {
      "code": "050010",
      "name": "沿岸",
      "enName": "Coast",
      "chName": "秋田县沿岸",
      "zhName": "秋田縣沿岸",
      "koName": "아키타 현 연안",
      "esName": "Costa de la Prefectura de Akita",
      "ptName": "Litoral da Província de Akita",
      "thName": "ชายฝั่งของจังหวัดอากิตะ",
      "viName": "Bờ biển tỉnh Akita",
      "inName": "Pantai di Prefektur Akita",
      "tlName": "Bahagi ng baybayin ng Akita Prefecture",
      "moName": "Акита аймаг, эрэг",
      "buName": "အခိတစီရင်စုကမ်းခြေ",
      "khName": "តំបន់ឆ្នេរសមុទ្រនៃខេត្ដអាគីតា",
      "neName": "आकिता जिल्लाको समुद्री किनारको भाग"
    },
    "class15": {
      "code": "050012",
      "name": "能代山本地域",
      "enName": "Noshiro Yamamoto Area"
    },
    "class20": {
      "code": "0520200",
      "name": "能代市",
      "enName": "Noshiro City",
      "kana": "のしろし",
      "chName": "能代市",
      "zhName": "能代市",
      "koName": "노시로 시",
      "esName": "Ciudad de Noshiro",
      "ptName": "cidade de Noshiro",
      "thName": "เมืองโนชิโระ",
      "viName": "thành phố Noshiro",
      "inName": "kota Noshiro",
      "tlName": "siyudad ng Noshiro",
      "moName": "Ноширо хот",
      "buName": "နော်ရှီရော့ မြို့",
      "khName": "ទីក្រុង ណូស៊ីរ៉ូ",
      "neName": "नोशिरो सहर"
    }
  },
  "0520300": {
    "office": {
      "code": "050000",
      "name": "秋田県",
      "enName": "Akita",
      "officeName": "秋田地方気象台",
      "chName": "秋田县",
      "zhName": "秋田縣",
      "koName": "아키타현",
      "esName": "Prefectura de Akita",
      "ptName": "Província de Akita",
      "thName": "จังหวัดอากิตะ",
      "viName": "Tỉnh Akita",
      "inName": "Prefektur Akita",
      "tlName": "Akita Prefecture",
      "moName": "Акита аймаг",
      "buName": "အခီတ ပြည်နယ်",
      "khName": "ខេត្ដ អាគីតា",
      "neName": "आकिता जिल्ला"
    },
    "class10": {
      "code": "050020",
      "name": "内陸",
      "enName": "Inland",
      "chName": "秋田县内陆地",
      "zhName": "秋田縣內陸",
      "koName": "아키타 현 내륙",
      "esName": "Interior de la Prefectura de Akita",
      "ptName": "Região Interior da Província de Akita",
      "thName": "ด้านในแผ่นดินของจังหวัดอากิตะ",
      "viName": "Vùng nội địa tỉnh Akita",
      "inName": "Bagian Pedalaman di Prefektur Akita",
      "tlName": "Bahagi ng lupain ng Akita Prefecture",
      "moName": "Акита аймаг, дотоод нутаг",
      "buName": "အခိတစီရင်စုကုန်းတွင်းဒေသ",
      "khName": "តំបន់ដីឆ្ងាយពីឆ្នេរនៃខេត្ដអាគីតា",
      "neName": "आकिता जिल्लाको भित्री (समुद्री किनारबाट टाढा) क्षेत्र"
    },
    "class15": {
      "code": "050022",
      "name": "仙北平鹿地域",
      "enName": "Semboku Hiraka Area"
    },
    "class20": {
      "code": "0520300",
      "name": "横手市",
      "enName": "Yokote City",
      "kana": "よこてし",
      "chName": "横手市",
      "zhName": "橫手市",
      "koName": "요코테 시",
      "esName": "Ciudad de Yokote",
      "ptName": "cidade de Yokote",
      "thName": "เมืองโยโคเตะ",
      "viName": "thành phố Yokote",
      "inName": "kota Yokote",
      "tlName": "siyudad ng Yokote",
      "moName": "Ёкотэ хот",
      "buName": "ရိုးကိုးတဲ့ မြို့",
      "khName": "ទីក្រុង យូ៉ខូត",
      "neName": "योकोते सहर"
    }
  },
  "0520400": {
    "office": {
      "code": "050000",
      "name": "秋田県",
      "enName": "Akita",
      "officeName": "秋田地方気象台",
      "chName": "秋田县",
      "zhName": "秋田縣",
      "koName": "아키타현",
      "esName": "Prefectura de Akita",
      "ptName": "Província de Akita",
      "thName": "จังหวัดอากิตะ",
      "viName": "Tỉnh Akita",
      "inName": "Prefektur Akita",
      "tlName": "Akita Prefecture",
      "moName": "Акита аймаг",
      "buName": "အခီတ ပြည်နယ်",
      "khName": "ខេត្ដ អាគីតា",
      "neName": "आकिता जिल्ला"
    },
    "class10": {
      "code": "050020",
      "name": "内陸",
      "enName": "Inland",
      "chName": "秋田县内陆地",
      "zhName": "秋田縣內陸",
      "koName": "아키타 현 내륙",
      "esName": "Interior de la Prefectura de Akita",
      "ptName": "Região Interior da Província de Akita",
      "thName": "ด้านในแผ่นดินของจังหวัดอากิตะ",
      "viName": "Vùng nội địa tỉnh Akita",
      "inName": "Bagian Pedalaman di Prefektur Akita",
      "tlName": "Bahagi ng lupain ng Akita Prefecture",
      "moName": "Акита аймаг, дотоод нутаг",
      "buName": "အခိတစီရင်စုကုန်းတွင်းဒေသ",
      "khName": "តំបន់ដីឆ្ងាយពីឆ្នេរនៃខេត្ដអាគីតា",
      "neName": "आकिता जिल्लाको भित्री (समुद्री किनारबाट टाढा) क्षेत्र"
    },
    "class15": {
      "code": "050021",
      "name": "北秋鹿角地域",
      "enName": "Hokusyu Kazuno Area"
    },
    "class20": {
      "code": "0520400",
      "name": "大館市",
      "enName": "Odate City",
      "kana": "おおだてし",
      "chName": "大馆市",
      "zhName": "大館市",
      "koName": "오다테 시",
      "esName": "Ciudad de Odate",
      "ptName": "cidade de Odate",
      "thName": "เมืองโอดาเตะ",
      "viName": "thành phố Odate",
      "inName": "kota Odate",
      "tlName": "siyudad ng Odate",
      "moName": "Одатэ хот",
      "buName": "အိုဒါးတဲ့ မြို့",
      "khName": "ទីក្រុង អូដេត",
      "neName": "ओदाते सहर"
    }
  },
  "0520600": {
    "office": {
      "code": "050000",
      "name": "秋田県",
      "enName": "Akita",
      "officeName": "秋田地方気象台",
      "chName": "秋田县",
      "zhName": "秋田縣",
      "koName": "아키타현",
      "esName": "Prefectura de Akita",
      "ptName": "Província de Akita",
      "thName": "จังหวัดอากิตะ",
      "viName": "Tỉnh Akita",
      "inName": "Prefektur Akita",
      "tlName": "Akita Prefecture",
      "moName": "Акита аймаг",
      "buName": "အခီတ ပြည်နယ်",
      "khName": "ខេត្ដ អាគីតា",
      "neName": "आकिता जिल्ला"
    },
    "class10": {
      "code": "050010",
      "name": "沿岸",
      "enName": "Coast",
      "chName": "秋田县沿岸",
      "zhName": "秋田縣沿岸",
      "koName": "아키타 현 연안",
      "esName": "Costa de la Prefectura de Akita",
      "ptName": "Litoral da Província de Akita",
      "thName": "ชายฝั่งของจังหวัดอากิตะ",
      "viName": "Bờ biển tỉnh Akita",
      "inName": "Pantai di Prefektur Akita",
      "tlName": "Bahagi ng baybayin ng Akita Prefecture",
      "moName": "Акита аймаг, эрэг",
      "buName": "အခိတစီရင်စုကမ်းခြေ",
      "khName": "តំបន់ឆ្នេរសមុទ្រនៃខេត្ដអាគីតា",
      "neName": "आकिता जिल्लाको समुद्री किनारको भाग"
    },
    "class15": {
      "code": "050011",
      "name": "秋田中央地域",
      "enName": "Akita Central Area"
    },
    "class20": {
      "code": "0520600",
      "name": "男鹿市",
      "enName": "Oga City",
      "kana": "おがし",
      "chName": "男鹿市",
      "zhName": "男鹿市",
      "koName": "오가 시",
      "esName": "Ciudad de Oga",
      "ptName": "cidade de Oga",
      "thName": "เมืองโองะ",
      "viName": "thành phố Oga",
      "inName": "kota Oga",
      "tlName": "siyudad ng Oga",
      "moName": "Ога хот",
      "buName": "အိုးဂါ့ မြို့",
      "khName": "ទីក្រុង អូកា",
      "neName": "ओगा सहर"
    }
  },
  "0520700": {
    "office": {
      "code": "050000",
      "name": "秋田県",
      "enName": "Akita",
      "officeName": "秋田地方気象台",
      "chName": "秋田县",
      "zhName": "秋田縣",
      "koName": "아키타현",
      "esName": "Prefectura de Akita",
      "ptName": "Província de Akita",
      "thName": "จังหวัดอากิตะ",
      "viName": "Tỉnh Akita",
      "inName": "Prefektur Akita",
      "tlName": "Akita Prefecture",
      "moName": "Акита аймаг",
      "buName": "အခီတ ပြည်နယ်",
      "khName": "ខេត្ដ អាគីតា",
      "neName": "आकिता जिल्ला"
    },
    "class10": {
      "code": "050020",
      "name": "内陸",
      "enName": "Inland",
      "chName": "秋田县内陆地",
      "zhName": "秋田縣內陸",
      "koName": "아키타 현 내륙",
      "esName": "Interior de la Prefectura de Akita",
      "ptName": "Região Interior da Província de Akita",
      "thName": "ด้านในแผ่นดินของจังหวัดอากิตะ",
      "viName": "Vùng nội địa tỉnh Akita",
      "inName": "Bagian Pedalaman di Prefektur Akita",
      "tlName": "Bahagi ng lupain ng Akita Prefecture",
      "moName": "Акита аймаг, дотоод нутаг",
      "buName": "အခိတစီရင်စုကုန်းတွင်းဒေသ",
      "khName": "តំបន់ដីឆ្ងាយពីឆ្នេរនៃខេត្ដអាគីតា",
      "neName": "आकिता जिल्लाको भित्री (समुद्री किनारबाट टाढा) क्षेत्र"
    },
    "class15": {
      "code": "050023",
      "name": "湯沢雄勝地域",
      "enName": "Yuzawa Ogachi Area"
    },
    "class20": {
      "code": "0520700",
      "name": "湯沢市",
      "enName": "Yuzawa City",
      "kana": "ゆざわし",
      "chName": "汤泽市",
      "zhName": "湯澤市",
      "koName": "유자와 시",
      "esName": "Ciudad de Yuzawa",
      "ptName": "cidade de Yuzawa",
      "thName": "เมืองยุซาวา",
      "viName": "thành phố Yuzawa",
      "inName": "kota Yuzawa",
      "tlName": "siyudad ng Yuzawa",
      "moName": "Юзава хот",
      "buName": "ယူဇာဝါ့ မြို့",
      "khName": "ទីក្រុង យូហ្សាវ៉ា",
      "neName": "युजावा सहर"
    }
  },
  "0520900": {
    "office": {
      "code": "050000",
      "name": "秋田県",
      "enName": "Akita",
      "officeName": "秋田地方気象台",
      "chName": "秋田县",
      "zhName": "秋田縣",
      "koName": "아키타현",
      "esName": "Prefectura de Akita",
      "ptName": "Província de Akita",
      "thName": "จังหวัดอากิตะ",
      "viName": "Tỉnh Akita",
      "inName": "Prefektur Akita",
      "tlName": "Akita Prefecture",
      "moName": "Акита аймаг",
      "buName": "အခီတ ပြည်နယ်",
      "khName": "ខេត្ដ អាគីតា",
      "neName": "आकिता जिल्ला"
    },
    "class10": {
      "code": "050020",
      "name": "内陸",
      "enName": "Inland",
      "chName": "秋田县内陆地",
      "zhName": "秋田縣內陸",
      "koName": "아키타 현 내륙",
      "esName": "Interior de la Prefectura de Akita",
      "ptName": "Região Interior da Província de Akita",
      "thName": "ด้านในแผ่นดินของจังหวัดอากิตะ",
      "viName": "Vùng nội địa tỉnh Akita",
      "inName": "Bagian Pedalaman di Prefektur Akita",
      "tlName": "Bahagi ng lupain ng Akita Prefecture",
      "moName": "Акита аймаг, дотоод нутаг",
      "buName": "အခိတစီရင်စုကုန်းတွင်းဒေသ",
      "khName": "តំបន់ដីឆ្ងាយពីឆ្នេរនៃខេត្ដអាគីតា",
      "neName": "आकिता जिल्लाको भित्री (समुद्री किनारबाट टाढा) क्षेत्र"
    },
    "class15": {
      "code": "050021",
      "name": "北秋鹿角地域",
      "enName": "Hokusyu Kazuno Area"
    },
    "class20": {
      "code": "0520900",
      "name": "鹿角市",
      "enName": "Kazuno City",
      "kana": "かづのし",
      "chName": "鹿角市",
      "zhName": "鹿角市",
      "koName": "가즈노 시",
      "esName": "Ciudad de Kazuno",
      "ptName": "cidade de Kazuno",
      "thName": "เมืองคาซูโนะ",
      "viName": "thành phố Kazuno",
      "inName": "kota Kazuno",
      "tlName": "siyudad ng Kazuno",
      "moName": "Казүно хот",
      "buName": "ခါဇူနော့ မြို့",
      "khName": "ទីក្រុង កាហ្សូណូ",
      "neName": "काजुनो सहर"
    }
  },
  "0521000": {
    "office": {
      "code": "050000",
      "name": "秋田県",
      "enName": "Akita",
      "officeName": "秋田地方気象台",
      "chName": "秋田县",
      "zhName": "秋田縣",
      "koName": "아키타현",
      "esName": "Prefectura de Akita",
      "ptName": "Província de Akita",
      "thName": "จังหวัดอากิตะ",
      "viName": "Tỉnh Akita",
      "inName": "Prefektur Akita",
      "tlName": "Akita Prefecture",
      "moName": "Акита аймаг",
      "buName": "အခီတ ပြည်နယ်",
      "khName": "ខេត្ដ អាគីតា",
      "neName": "आकिता जिल्ला"
    },
    "class10": {
      "code": "050010",
      "name": "沿岸",
      "enName": "Coast",
      "chName": "秋田县沿岸",
      "zhName": "秋田縣沿岸",
      "koName": "아키타 현 연안",
      "esName": "Costa de la Prefectura de Akita",
      "ptName": "Litoral da Província de Akita",
      "thName": "ชายฝั่งของจังหวัดอากิตะ",
      "viName": "Bờ biển tỉnh Akita",
      "inName": "Pantai di Prefektur Akita",
      "tlName": "Bahagi ng baybayin ng Akita Prefecture",
      "moName": "Акита аймаг, эрэг",
      "buName": "အခိတစီရင်စုကမ်းခြေ",
      "khName": "តំបន់ឆ្នេរសមុទ្រនៃខេត្ដអាគីតា",
      "neName": "आकिता जिल्लाको समुद्री किनारको भाग"
    },
    "class15": {
      "code": "050013",
      "name": "本荘由利地域",
      "enName": "Honjo Yuri Area"
    },
    "class20": {
      "code": "0521000",
      "name": "由利本荘市",
      "enName": "Yurihonjo City",
      "kana": "ゆりほんじょうし",
      "chName": "由利本庄市",
      "zhName": "由利本莊市",
      "koName": "유리혼조 시",
      "esName": "Ciudad de Yurihonjyo",
      "ptName": "cidade de Yurihonjo",
      "thName": "เมืองยูริฮอนโจ",
      "viName": "thành phố Yurihonjo",
      "inName": "kota Yurihonjo",
      "tlName": "siyudad ng Yurihonjo",
      "moName": "Юрихонжо хот",
      "buName": "ယူရီဟွန်းဂျော့ မြို့",
      "khName": "ទីក្រុង យូរីហុនចូ",
      "neName": "युरिहोन्जो सहर"
    }
  },
  "0521100": {
    "office": {
      "code": "050000",
      "name": "秋田県",
      "enName": "Akita",
      "officeName": "秋田地方気象台",
      "chName": "秋田县",
      "zhName": "秋田縣",
      "koName": "아키타현",
      "esName": "Prefectura de Akita",
      "ptName": "Província de Akita",
      "thName": "จังหวัดอากิตะ",
      "viName": "Tỉnh Akita",
      "inName": "Prefektur Akita",
      "tlName": "Akita Prefecture",
      "moName": "Акита аймаг",
      "buName": "အခီတ ပြည်နယ်",
      "khName": "ខេត្ដ អាគីតា",
      "neName": "आकिता जिल्ला"
    },
    "class10": {
      "code": "050010",
      "name": "沿岸",
      "enName": "Coast",
      "chName": "秋田县沿岸",
      "zhName": "秋田縣沿岸",
      "koName": "아키타 현 연안",
      "esName": "Costa de la Prefectura de Akita",
      "ptName": "Litoral da Província de Akita",
      "thName": "ชายฝั่งของจังหวัดอากิตะ",
      "viName": "Bờ biển tỉnh Akita",
      "inName": "Pantai di Prefektur Akita",
      "tlName": "Bahagi ng baybayin ng Akita Prefecture",
      "moName": "Акита аймаг, эрэг",
      "buName": "အခိတစီရင်စုကမ်းခြေ",
      "khName": "តំបន់ឆ្នេរសមុទ្រនៃខេត្ដអាគីតា",
      "neName": "आकिता जिल्लाको समुद्री किनारको भाग"
    },
    "class15": {
      "code": "050011",
      "name": "秋田中央地域",
      "enName": "Akita Central Area"
    },
    "class20": {
      "code": "0521100",
      "name": "潟上市",
      "enName": "Katagami City",
      "kana": "かたがみし",
      "chName": "潟上市",
      "zhName": "潟上市",
      "koName": "가타가미 시",
      "esName": "Ciudad de Katagami",
      "ptName": "cidade de Katagami",
      "thName": "เมืองคาตากามิ",
      "viName": "thành phố Katagami",
      "inName": "kota Katagami",
      "tlName": "siyudad ng Katagami",
      "moName": "Катагами хот",
      "buName": "ခါတာ့ဂါးမိ မြို့",
      "khName": "ទីក្រុង កាតាកាមី",
      "neName": "कातागामी सहर"
    }
  },
  "0521200": {
    "office": {
      "code": "050000",
      "name": "秋田県",
      "enName": "Akita",
      "officeName": "秋田地方気象台",
      "chName": "秋田县",
      "zhName": "秋田縣",
      "koName": "아키타현",
      "esName": "Prefectura de Akita",
      "ptName": "Província de Akita",
      "thName": "จังหวัดอากิตะ",
      "viName": "Tỉnh Akita",
      "inName": "Prefektur Akita",
      "tlName": "Akita Prefecture",
      "moName": "Акита аймаг",
      "buName": "အခီတ ပြည်နယ်",
      "khName": "ខេត្ដ អាគីតា",
      "neName": "आकिता जिल्ला"
    },
    "class10": {
      "code": "050020",
      "name": "内陸",
      "enName": "Inland",
      "chName": "秋田县内陆地",
      "zhName": "秋田縣內陸",
      "koName": "아키타 현 내륙",
      "esName": "Interior de la Prefectura de Akita",
      "ptName": "Região Interior da Província de Akita",
      "thName": "ด้านในแผ่นดินของจังหวัดอากิตะ",
      "viName": "Vùng nội địa tỉnh Akita",
      "inName": "Bagian Pedalaman di Prefektur Akita",
      "tlName": "Bahagi ng lupain ng Akita Prefecture",
      "moName": "Акита аймаг, дотоод нутаг",
      "buName": "အခိတစီရင်စုကုန်းတွင်းဒေသ",
      "khName": "តំបន់ដីឆ្ងាយពីឆ្នេរនៃខេត្ដអាគីតា",
      "neName": "आकिता जिल्लाको भित्री (समुद्री किनारबाट टाढा) क्षेत्र"
    },
    "class15": {
      "code": "050022",
      "name": "仙北平鹿地域",
      "enName": "Semboku Hiraka Area"
    },
    "class20": {
      "code": "0521200",
      "name": "大仙市",
      "enName": "Daisen City",
      "kana": "だいせんし",
      "chName": "大仙市",
      "zhName": "大仙市",
      "koName": "다이센 시",
      "esName": "Ciudad de Daisen",
      "ptName": "cidade de Daisen",
      "thName": "เมืองไดเซน",
      "viName": "thành phố Daisen",
      "inName": "kota Daisen",
      "tlName": "siyudad ng Daisen",
      "moName": "Дайсэн хот",
      "buName": "ဒိုင်ဆန် မြို့",
      "khName": "ទីក្រុង ដេសេន",
      "neName": "दाइसेन सहर"
    }
  },
  "0521300": {
    "office": {
      "code": "050000",
      "name": "秋田県",
      "enName": "Akita",
      "officeName": "秋田地方気象台",
      "chName": "秋田县",
      "zhName": "秋田縣",
      "koName": "아키타현",
      "esName": "Prefectura de Akita",
      "ptName": "Província de Akita",
      "thName": "จังหวัดอากิตะ",
      "viName": "Tỉnh Akita",
      "inName": "Prefektur Akita",
      "tlName": "Akita Prefecture",
      "moName": "Акита аймаг",
      "buName": "အခီတ ပြည်နယ်",
      "khName": "ខេត្ដ អាគីតា",
      "neName": "आकिता जिल्ला"
    },
    "class10": {
      "code": "050020",
      "name": "内陸",
      "enName": "Inland",
      "chName": "秋田县内陆地",
      "zhName": "秋田縣內陸",
      "koName": "아키타 현 내륙",
      "esName": "Interior de la Prefectura de Akita",
      "ptName": "Região Interior da Província de Akita",
      "thName": "ด้านในแผ่นดินของจังหวัดอากิตะ",
      "viName": "Vùng nội địa tỉnh Akita",
      "inName": "Bagian Pedalaman di Prefektur Akita",
      "tlName": "Bahagi ng lupain ng Akita Prefecture",
      "moName": "Акита аймаг, дотоод нутаг",
      "buName": "အခိတစီရင်စုကုန်းတွင်းဒေသ",
      "khName": "តំបន់ដីឆ្ងាយពីឆ្នេរនៃខេត្ដអាគីតា",
      "neName": "आकिता जिल्लाको भित्री (समुद्री किनारबाट टाढा) क्षेत्र"
    },
    "class15": {
      "code": "050021",
      "name": "北秋鹿角地域",
      "enName": "Hokusyu Kazuno Area"
    },
    "class20": {
      "code": "0521300",
      "name": "北秋田市",
      "enName": "Kitaakita City",
      "kana": "きたあきたし",
      "chName": "北秋田市",
      "zhName": "北秋田市",
      "koName": "기타아키타 시",
      "esName": "Ciudad de Kita-akita",
      "ptName": "cidade de Kitaakita",
      "thName": "เมืองคิตะอากิตะ",
      "viName": "thành phố Kitaakita",
      "inName": "kota Kitaakita",
      "tlName": "siyudad ng Kitaakita",
      "moName": "Китаакита хот",
      "buName": "ခီတားခီတ မြို့",
      "khName": "ទីក្រុង គីតាអាគីតា",
      "neName": "किताआकिता सहर"
    }
  },
  "0521400": {
    "office": {
      "code": "050000",
      "name": "秋田県",
      "enName": "Akita",
      "officeName": "秋田地方気象台",
      "chName": "秋田县",
      "zhName": "秋田縣",
      "koName": "아키타현",
      "esName": "Prefectura de Akita",
      "ptName": "Província de Akita",
      "thName": "จังหวัดอากิตะ",
      "viName": "Tỉnh Akita",
      "inName": "Prefektur Akita",
      "tlName": "Akita Prefecture",
      "moName": "Акита аймаг",
      "buName": "အခီတ ပြည်နယ်",
      "khName": "ខេត្ដ អាគីតា",
      "neName": "आकिता जिल्ला"
    },
    "class10": {
      "code": "050010",
      "name": "沿岸",
      "enName": "Coast",
      "chName": "秋田县沿岸",
      "zhName": "秋田縣沿岸",
      "koName": "아키타 현 연안",
      "esName": "Costa de la Prefectura de Akita",
      "ptName": "Litoral da Província de Akita",
      "thName": "ชายฝั่งของจังหวัดอากิตะ",
      "viName": "Bờ biển tỉnh Akita",
      "inName": "Pantai di Prefektur Akita",
      "tlName": "Bahagi ng baybayin ng Akita Prefecture",
      "moName": "Акита аймаг, эрэг",
      "buName": "အခိတစီရင်စုကမ်းခြေ",
      "khName": "តំបន់ឆ្នេរសមុទ្រនៃខេត្ដអាគីតា",
      "neName": "आकिता जिल्लाको समुद्री किनारको भाग"
    },
    "class15": {
      "code": "050013",
      "name": "本荘由利地域",
      "enName": "Honjo Yuri Area"
    },
    "class20": {
      "code": "0521400",
      "name": "にかほ市",
      "enName": "Nikaho City",
      "kana": "にかほし",
      "chName": "仁贺保市",
      "zhName": "仁賀保市",
      "koName": "니카호 시",
      "esName": "Ciudad de Nokaho",
      "ptName": "cidade de Nikaho",
      "thName": "เมืองนิคาโฮะ",
      "viName": "thành phố Nikaho",
      "inName": "kota Nikaho",
      "tlName": "siyudad ng Nikaho",
      "moName": "Никахо хот",
      "buName": "နီးကားဟို မြို့",
      "khName": "ទីក្រុង នីកាហូ",
      "neName": "नोकाहो सहर"
    }
  },
  "0521500": {
    "office": {
      "code": "050000",
      "name": "秋田県",
      "enName": "Akita",
      "officeName": "秋田地方気象台",
      "chName": "秋田县",
      "zhName": "秋田縣",
      "koName": "아키타현",
      "esName": "Prefectura de Akita",
      "ptName": "Província de Akita",
      "thName": "จังหวัดอากิตะ",
      "viName": "Tỉnh Akita",
      "inName": "Prefektur Akita",
      "tlName": "Akita Prefecture",
      "moName": "Акита аймаг",
      "buName": "အခီတ ပြည်နယ်",
      "khName": "ខេត្ដ អាគីតា",
      "neName": "आकिता जिल्ला"
    },
    "class10": {
      "code": "050020",
      "name": "内陸",
      "enName": "Inland",
      "chName": "秋田县内陆地",
      "zhName": "秋田縣內陸",
      "koName": "아키타 현 내륙",
      "esName": "Interior de la Prefectura de Akita",
      "ptName": "Região Interior da Província de Akita",
      "thName": "ด้านในแผ่นดินของจังหวัดอากิตะ",
      "viName": "Vùng nội địa tỉnh Akita",
      "inName": "Bagian Pedalaman di Prefektur Akita",
      "tlName": "Bahagi ng lupain ng Akita Prefecture",
      "moName": "Акита аймаг, дотоод нутаг",
      "buName": "အခိတစီရင်စုကုန်းတွင်းဒေသ",
      "khName": "តំបន់ដីឆ្ងាយពីឆ្នេរនៃខេត្ដអាគីតា",
      "neName": "आकिता जिल्लाको भित्री (समुद्री किनारबाट टाढा) क्षेत्र"
    },
    "class15": {
      "code": "050022",
      "name": "仙北平鹿地域",
      "enName": "Semboku Hiraka Area"
    },
    "class20": {
      "code": "0521500",
      "name": "仙北市",
      "enName": "Semboku City",
      "kana": "せんぼくし",
      "chName": "仙北市",
      "zhName": "仙北市",
      "koName": "센보쿠 시",
      "esName": "Ciudad de Senboku",
      "ptName": "cidade de Semboku",
      "thName": "เมืองเซมโบคุ",
      "viName": "thành phố Semboku",
      "inName": "kota Semboku",
      "tlName": "siyudad ng Semboku",
      "moName": "Сэнбокү хот",
      "buName": "ဆန်ဘိုးကု မြို့",
      "khName": "ទីក្រុង សាំបូឃូ",
      "neName": "सेम्बोकु सहर"
    }
  },
  "0530300": {
    "office": {
      "code": "050000",
      "name": "秋田県",
      "enName": "Akita",
      "officeName": "秋田地方気象台",
      "chName": "秋田县",
      "zhName": "秋田縣",
      "koName": "아키타현",
      "esName": "Prefectura de Akita",
      "ptName": "Província de Akita",
      "thName": "จังหวัดอากิตะ",
      "viName": "Tỉnh Akita",
      "inName": "Prefektur Akita",
      "tlName": "Akita Prefecture",
      "moName": "Акита аймаг",
      "buName": "အခီတ ပြည်နယ်",
      "khName": "ខេត្ដ អាគីតា",
      "neName": "आकिता जिल्ला"
    },
    "class10": {
      "code": "050020",
      "name": "内陸",
      "enName": "Inland",
      "chName": "秋田县内陆地",
      "zhName": "秋田縣內陸",
      "koName": "아키타 현 내륙",
      "esName": "Interior de la Prefectura de Akita",
      "ptName": "Região Interior da Província de Akita",
      "thName": "ด้านในแผ่นดินของจังหวัดอากิตะ",
      "viName": "Vùng nội địa tỉnh Akita",
      "inName": "Bagian Pedalaman di Prefektur Akita",
      "tlName": "Bahagi ng lupain ng Akita Prefecture",
      "moName": "Акита аймаг, дотоод нутаг",
      "buName": "အခိတစီရင်စုကုန်းတွင်းဒေသ",
      "khName": "តំបន់ដីឆ្ងាយពីឆ្នេរនៃខេត្ដអាគីតា",
      "neName": "आकिता जिल्लाको भित्री (समुद्री किनारबाट टाढा) क्षेत्र"
    },
    "class15": {
      "code": "050021",
      "name": "北秋鹿角地域",
      "enName": "Hokusyu Kazuno Area"
    },
    "class20": {
      "code": "0530300",
      "name": "小坂町",
      "enName": "Kosaka Town",
      "kana": "こさかまち",
      "chName": "小坂町",
      "zhName": "小坂町",
      "koName": "고사카 정",
      "esName": "Pueblo de Kosaka",
      "ptName": "bairro de Kosaka",
      "thName": "เมืองโคซากะ",
      "viName": "thị trấn Kosaka",
      "inName": "kota Kosaka",
      "tlName": "bayan ng Kosaka",
      "moName": "Косака жижиг хот",
      "buName": "ကိုဆားက မြို့နယ်",
      "khName": "ទីប្រជុំជន កូសាកា",
      "neName": "कोसाका नगर"
    }
  },
  "0532700": {
    "office": {
      "code": "050000",
      "name": "秋田県",
      "enName": "Akita",
      "officeName": "秋田地方気象台",
      "chName": "秋田县",
      "zhName": "秋田縣",
      "koName": "아키타현",
      "esName": "Prefectura de Akita",
      "ptName": "Província de Akita",
      "thName": "จังหวัดอากิตะ",
      "viName": "Tỉnh Akita",
      "inName": "Prefektur Akita",
      "tlName": "Akita Prefecture",
      "moName": "Акита аймаг",
      "buName": "အခီတ ပြည်နယ်",
      "khName": "ខេត្ដ អាគីតា",
      "neName": "आकिता जिल्ला"
    },
    "class10": {
      "code": "050020",
      "name": "内陸",
      "enName": "Inland",
      "chName": "秋田县内陆地",
      "zhName": "秋田縣內陸",
      "koName": "아키타 현 내륙",
      "esName": "Interior de la Prefectura de Akita",
      "ptName": "Região Interior da Província de Akita",
      "thName": "ด้านในแผ่นดินของจังหวัดอากิตะ",
      "viName": "Vùng nội địa tỉnh Akita",
      "inName": "Bagian Pedalaman di Prefektur Akita",
      "tlName": "Bahagi ng lupain ng Akita Prefecture",
      "moName": "Акита аймаг, дотоод нутаг",
      "buName": "အခိတစီရင်စုကုန်းတွင်းဒေသ",
      "khName": "តំបន់ដីឆ្ងាយពីឆ្នេរនៃខេត្ដអាគីតា",
      "neName": "आकिता जिल्लाको भित्री (समुद्री किनारबाट टाढा) क्षेत्र"
    },
    "class15": {
      "code": "050021",
      "name": "北秋鹿角地域",
      "enName": "Hokusyu Kazuno Area"
    },
    "class20": {
      "code": "0532700",
      "name": "上小阿仁村",
      "enName": "Kamikoani Village",
      "kana": "かみこあにむら",
      "chName": "上小阿仁村",
      "zhName": "上小阿仁村",
      "koName": "가미코아니 촌",
      "esName": "Aldea de Kamikoani",
      "ptName": "povoado de Kamikoani",
      "thName": "หมู่บ้านคามิโคอานิ",
      "viName": "làng Kamikoani",
      "inName": "desa Kamikoani",
      "tlName": "nayon ng Kamikoani",
      "moName": "Камикоaни тосгон",
      "buName": "ခါမိကိုးအာနိ ကျေးရွာ",
      "khName": "ភូមិ កាមិកូអានី",
      "neName": "कामिकोआनी गाउँ"
    }
  },
  "0534600": {
    "office": {
      "code": "050000",
      "name": "秋田県",
      "enName": "Akita",
      "officeName": "秋田地方気象台",
      "chName": "秋田县",
      "zhName": "秋田縣",
      "koName": "아키타현",
      "esName": "Prefectura de Akita",
      "ptName": "Província de Akita",
      "thName": "จังหวัดอากิตะ",
      "viName": "Tỉnh Akita",
      "inName": "Prefektur Akita",
      "tlName": "Akita Prefecture",
      "moName": "Акита аймаг",
      "buName": "အခီတ ပြည်နယ်",
      "khName": "ខេត្ដ អាគីតា",
      "neName": "आकिता जिल्ला"
    },
    "class10": {
      "code": "050010",
      "name": "沿岸",
      "enName": "Coast",
      "chName": "秋田县沿岸",
      "zhName": "秋田縣沿岸",
      "koName": "아키타 현 연안",
      "esName": "Costa de la Prefectura de Akita",
      "ptName": "Litoral da Província de Akita",
      "thName": "ชายฝั่งของจังหวัดอากิตะ",
      "viName": "Bờ biển tỉnh Akita",
      "inName": "Pantai di Prefektur Akita",
      "tlName": "Bahagi ng baybayin ng Akita Prefecture",
      "moName": "Акита аймаг, эрэг",
      "buName": "အခိတစီရင်စုကမ်းခြေ",
      "khName": "តំបន់ឆ្នេរសមុទ្រនៃខេត្ដអាគីតា",
      "neName": "आकिता जिल्लाको समुद्री किनारको भाग"
    },
    "class15": {
      "code": "050012",
      "name": "能代山本地域",
      "enName": "Noshiro Yamamoto Area"
    },
    "class20": {
      "code": "0534600",
      "name": "藤里町",
      "enName": "Fujisato Town",
      "kana": "ふじさとまち",
      "chName": "藤里町",
      "zhName": "藤町",
      "koName": "후지사토 정",
      "esName": "Pueblo de Fujisato",
      "ptName": "bairro de Fujisato",
      "thName": "เมืองฟุจิซาตะ",
      "viName": "thị trấn Fujisato",
      "inName": "kota Fujisato",
      "tlName": "bayan ng Fujisato",
      "moName": "Фүжисато жижиг хот",
      "buName": "ဖူဂျီဆာတို မြို့နယ်",
      "khName": "ទីប្រជុំជន ហ្វូជីសាតូ",
      "neName": "फुजिसातो नगर"
    }
  },
  "0534800": {
    "office": {
      "code": "050000",
      "name": "秋田県",
      "enName": "Akita",
      "officeName": "秋田地方気象台",
      "chName": "秋田县",
      "zhName": "秋田縣",
      "koName": "아키타현",
      "esName": "Prefectura de Akita",
      "ptName": "Província de Akita",
      "thName": "จังหวัดอากิตะ",
      "viName": "Tỉnh Akita",
      "inName": "Prefektur Akita",
      "tlName": "Akita Prefecture",
      "moName": "Акита аймаг",
      "buName": "အခီတ ပြည်နယ်",
      "khName": "ខេត្ដ អាគីតា",
      "neName": "आकिता जिल्ला"
    },
    "class10": {
      "code": "050010",
      "name": "沿岸",
      "enName": "Coast",
      "chName": "秋田县沿岸",
      "zhName": "秋田縣沿岸",
      "koName": "아키타 현 연안",
      "esName": "Costa de la Prefectura de Akita",
      "ptName": "Litoral da Província de Akita",
      "thName": "ชายฝั่งของจังหวัดอากิตะ",
      "viName": "Bờ biển tỉnh Akita",
      "inName": "Pantai di Prefektur Akita",
      "tlName": "Bahagi ng baybayin ng Akita Prefecture",
      "moName": "Акита аймаг, эрэг",
      "buName": "အခိတစီရင်စုကမ်းခြေ",
      "khName": "តំបន់ឆ្នេរសមុទ្រនៃខេត្ដអាគីតា",
      "neName": "आकिता जिल्लाको समुद्री किनारको भाग"
    },
    "class15": {
      "code": "050012",
      "name": "能代山本地域",
      "enName": "Noshiro Yamamoto Area"
    },
    "class20": {
      "code": "0534800",
      "name": "三種町",
      "enName": "Mitane Town",
      "kana": "みたねちょう",
      "chName": "三种町",
      "zhName": "三種町",
      "koName": "미타네 정",
      "esName": "Pueblo de Mitane",
      "ptName": "bairro de Mitane",
      "thName": "เมืองมิทาเนะ",
      "viName": "thị trấn Mitane",
      "inName": "kota Mitane",
      "tlName": "bayan ng Mitane",
      "moName": "Митанэ жижиг хот",
      "buName": "မိတာ့နဲ့ မြို့နယ်",
      "khName": "ទីប្រជុំជន មីតាណេ",
      "neName": "मिताने नगर"
    }
  },
  "0534900": {
    "office": {
      "code": "050000",
      "name": "秋田県",
      "enName": "Akita",
      "officeName": "秋田地方気象台",
      "chName": "秋田县",
      "zhName": "秋田縣",
      "koName": "아키타현",
      "esName": "Prefectura de Akita",
      "ptName": "Província de Akita",
      "thName": "จังหวัดอากิตะ",
      "viName": "Tỉnh Akita",
      "inName": "Prefektur Akita",
      "tlName": "Akita Prefecture",
      "moName": "Акита аймаг",
      "buName": "အခီတ ပြည်နယ်",
      "khName": "ខេត្ដ អាគីតា",
      "neName": "आकिता जिल्ला"
    },
    "class10": {
      "code": "050010",
      "name": "沿岸",
      "enName": "Coast",
      "chName": "秋田县沿岸",
      "zhName": "秋田縣沿岸",
      "koName": "아키타 현 연안",
      "esName": "Costa de la Prefectura de Akita",
      "ptName": "Litoral da Província de Akita",
      "thName": "ชายฝั่งของจังหวัดอากิตะ",
      "viName": "Bờ biển tỉnh Akita",
      "inName": "Pantai di Prefektur Akita",
      "tlName": "Bahagi ng baybayin ng Akita Prefecture",
      "moName": "Акита аймаг, эрэг",
      "buName": "အခိတစီရင်စုကမ်းခြေ",
      "khName": "តំបន់ឆ្នេរសមុទ្រនៃខេត្ដអាគីតា",
      "neName": "आकिता जिल्लाको समुद्री किनारको भाग"
    },
    "class15": {
      "code": "050012",
      "name": "能代山本地域",
      "enName": "Noshiro Yamamoto Area"
    },
    "class20": {
      "code": "0534900",
      "name": "八峰町",
      "enName": "Happou Town",
      "kana": "はっぽうちょう",
      "chName": "八峰町",
      "zhName": "八峰町",
      "koName": "핫포 정",
      "esName": "Pueblo de Happo",
      "ptName": "bairro de Happou",
      "thName": "เมืองฮัปโป",
      "viName": "thị trấn Happou",
      "inName": "kota Happou",
      "tlName": "bayan ng Happou",
      "moName": "Хaппоү жижиг хот",
      "buName": "ဟက်ပေါ့ မြို့နယ်",
      "khName": "ទីប្រជុំជន ហាប់ពូ",
      "neName": "हाप्पोउ नगर"
    }
  },
  "0536100": {
    "office": {
      "code": "050000",
      "name": "秋田県",
      "enName": "Akita",
      "officeName": "秋田地方気象台",
      "chName": "秋田县",
      "zhName": "秋田縣",
      "koName": "아키타현",
      "esName": "Prefectura de Akita",
      "ptName": "Província de Akita",
      "thName": "จังหวัดอากิตะ",
      "viName": "Tỉnh Akita",
      "inName": "Prefektur Akita",
      "tlName": "Akita Prefecture",
      "moName": "Акита аймаг",
      "buName": "အခီတ ပြည်နယ်",
      "khName": "ខេត្ដ អាគីតា",
      "neName": "आकिता जिल्ला"
    },
    "class10": {
      "code": "050010",
      "name": "沿岸",
      "enName": "Coast",
      "chName": "秋田县沿岸",
      "zhName": "秋田縣沿岸",
      "koName": "아키타 현 연안",
      "esName": "Costa de la Prefectura de Akita",
      "ptName": "Litoral da Província de Akita",
      "thName": "ชายฝั่งของจังหวัดอากิตะ",
      "viName": "Bờ biển tỉnh Akita",
      "inName": "Pantai di Prefektur Akita",
      "tlName": "Bahagi ng baybayin ng Akita Prefecture",
      "moName": "Акита аймаг, эрэг",
      "buName": "အခိတစီရင်စုကမ်းခြေ",
      "khName": "តំបន់ឆ្នេរសមុទ្រនៃខេត្ដអាគីតា",
      "neName": "आकिता जिल्लाको समुद्री किनारको भाग"
    },
    "class15": {
      "code": "050011",
      "name": "秋田中央地域",
      "enName": "Akita Central Area"
    },
    "class20": {
      "code": "0536100",
      "name": "五城目町",
      "enName": "Gojome Town",
      "kana": "ごじょうめまち",
      "chName": "五城目町",
      "zhName": "五城目町",
      "koName": "고조메 정",
      "esName": "Pueblo de Gojyome",
      "ptName": "bairro de Gojome",
      "thName": "เมืองโกโจเมะ",
      "viName": "thị trấn Gojome",
      "inName": "kota Gojome",
      "tlName": "bayan ng Gojome",
      "moName": "Гожомэ жижиг хот",
      "buName": "ဂိုးဂျော့မဲ့ မြို့နယ်",
      "khName": "ទីប្រជុំជន ហ្គោជូមេ",
      "neName": "गोजोमे नगर"
    }
  },
  "0536300": {
    "office": {
      "code": "050000",
      "name": "秋田県",
      "enName": "Akita",
      "officeName": "秋田地方気象台",
      "chName": "秋田县",
      "zhName": "秋田縣",
      "koName": "아키타현",
      "esName": "Prefectura de Akita",
      "ptName": "Província de Akita",
      "thName": "จังหวัดอากิตะ",
      "viName": "Tỉnh Akita",
      "inName": "Prefektur Akita",
      "tlName": "Akita Prefecture",
      "moName": "Акита аймаг",
      "buName": "အခီတ ပြည်နယ်",
      "khName": "ខេត្ដ អាគីតា",
      "neName": "आकिता जिल्ला"
    },
    "class10": {
      "code": "050010",
      "name": "沿岸",
      "enName": "Coast",
      "chName": "秋田县沿岸",
      "zhName": "秋田縣沿岸",
      "koName": "아키타 현 연안",
      "esName": "Costa de la Prefectura de Akita",
      "ptName": "Litoral da Província de Akita",
      "thName": "ชายฝั่งของจังหวัดอากิตะ",
      "viName": "Bờ biển tỉnh Akita",
      "inName": "Pantai di Prefektur Akita",
      "tlName": "Bahagi ng baybayin ng Akita Prefecture",
      "moName": "Акита аймаг, эрэг",
      "buName": "အခိတစီရင်စုကမ်းခြေ",
      "khName": "តំបន់ឆ្នេរសមុទ្រនៃខេត្ដអាគីតា",
      "neName": "आकिता जिल्लाको समुद्री किनारको भाग"
    },
    "class15": {
      "code": "050011",
      "name": "秋田中央地域",
      "enName": "Akita Central Area"
    },
    "class20": {
      "code": "0536300",
      "name": "八郎潟町",
      "enName": "Hachirogata Town",
      "kana": "はちろうがたまち",
      "chName": "八郎泻町",
      "zhName": "八郎瀉町",
      "koName": "하치로가타 정",
      "esName": "Pueblo de Hachirogata",
      "ptName": "bairro de Hachirogata",
      "thName": "เมืองฮะจิโระคาตะ",
      "viName": "thị trấn Hachirogata",
      "inName": "kota Hachirogata",
      "tlName": "bayan ng Hachirogata",
      "moName": "Хaчирогaта жижиг хот",
      "buName": "ဟာကျိရိုဂါ့တ မြို့နယ်",
      "khName": "ទីប្រជុំជន ហាជីរ៉ូកាតា",
      "neName": "हाचिरोगाता नगर"
    }
  },
  "0536600": {
    "office": {
      "code": "050000",
      "name": "秋田県",
      "enName": "Akita",
      "officeName": "秋田地方気象台",
      "chName": "秋田县",
      "zhName": "秋田縣",
      "koName": "아키타현",
      "esName": "Prefectura de Akita",
      "ptName": "Província de Akita",
      "thName": "จังหวัดอากิตะ",
      "viName": "Tỉnh Akita",
      "inName": "Prefektur Akita",
      "tlName": "Akita Prefecture",
      "moName": "Акита аймаг",
      "buName": "အခီတ ပြည်နယ်",
      "khName": "ខេត្ដ អាគីតា",
      "neName": "आकिता जिल्ला"
    },
    "class10": {
      "code": "050010",
      "name": "沿岸",
      "enName": "Coast",
      "chName": "秋田县沿岸",
      "zhName": "秋田縣沿岸",
      "koName": "아키타 현 연안",
      "esName": "Costa de la Prefectura de Akita",
      "ptName": "Litoral da Província de Akita",
      "thName": "ชายฝั่งของจังหวัดอากิตะ",
      "viName": "Bờ biển tỉnh Akita",
      "inName": "Pantai di Prefektur Akita",
      "tlName": "Bahagi ng baybayin ng Akita Prefecture",
      "moName": "Акита аймаг, эрэг",
      "buName": "အခိတစီရင်စုကမ်းခြေ",
      "khName": "តំបន់ឆ្នេរសមុទ្រនៃខេត្ដអាគីតា",
      "neName": "आकिता जिल्लाको समुद्री किनारको भाग"
    },
    "class15": {
      "code": "050011",
      "name": "秋田中央地域",
      "enName": "Akita Central Area"
    },
    "class20": {
      "code": "0536600",
      "name": "井川町",
      "enName": "Ikawa Town",
      "kana": "いかわまち",
      "chName": "井川町",
      "zhName": "井川町",
      "koName": "이카와 정",
      "esName": "Pueblo de Ikawa",
      "ptName": "bairro de Ikawa",
      "thName": "เมืองอิคาวะ",
      "viName": "thị trấn ikawa",
      "inName": "kota Ikawa",
      "tlName": "bayan ng Ikawa",
      "moName": "Икава жижиг хот",
      "buName": "အီကာ့ဝ မြို့နယ်",
      "khName": "ទីប្រជុំជន អាយកាវ៉ា",
      "neName": "इकावा नगर"
    }
  },
  "0536800": {
    "office": {
      "code": "050000",
      "name": "秋田県",
      "enName": "Akita",
      "officeName": "秋田地方気象台",
      "chName": "秋田县",
      "zhName": "秋田縣",
      "koName": "아키타현",
      "esName": "Prefectura de Akita",
      "ptName": "Província de Akita",
      "thName": "จังหวัดอากิตะ",
      "viName": "Tỉnh Akita",
      "inName": "Prefektur Akita",
      "tlName": "Akita Prefecture",
      "moName": "Акита аймаг",
      "buName": "အခီတ ပြည်နယ်",
      "khName": "ខេត្ដ អាគីតា",
      "neName": "आकिता जिल्ला"
    },
    "class10": {
      "code": "050010",
      "name": "沿岸",
      "enName": "Coast",
      "chName": "秋田县沿岸",
      "zhName": "秋田縣沿岸",
      "koName": "아키타 현 연안",
      "esName": "Costa de la Prefectura de Akita",
      "ptName": "Litoral da Província de Akita",
      "thName": "ชายฝั่งของจังหวัดอากิตะ",
      "viName": "Bờ biển tỉnh Akita",
      "inName": "Pantai di Prefektur Akita",
      "tlName": "Bahagi ng baybayin ng Akita Prefecture",
      "moName": "Акита аймаг, эрэг",
      "buName": "အခိတစီရင်စုကမ်းခြေ",
      "khName": "តំបន់ឆ្នេរសមុទ្រនៃខេត្ដអាគីតា",
      "neName": "आकिता जिल्लाको समुद्री किनारको भाग"
    },
    "class15": {
      "code": "050011",
      "name": "秋田中央地域",
      "enName": "Akita Central Area"
    },
    "class20": {
      "code": "0536800",
      "name": "大潟村",
      "enName": "Ogata Village",
      "kana": "おおがたむら",
      "chName": "大泻村",
      "zhName": "大瀉町",
      "koName": "오가타 촌",
      "esName": "Pueblo de Ogata",
      "ptName": "povoado de Ogata",
      "thName": "หมู่บ้านโองาตะ",
      "viName": "làng Ogata",
      "inName": "desa Ogata",
      "tlName": "nayon ng Ogata",
      "moName": "Огaта тосгон",
      "buName": "အိုဂါ့တ ကျေးရွာ",
      "khName": "ភូមិ អូហ្គាតា",
      "neName": "ओगाता गाउँ"
    }
  },
  "0543400": {
    "office": {
      "code": "050000",
      "name": "秋田県",
      "enName": "Akita",
      "officeName": "秋田地方気象台",
      "chName": "秋田县",
      "zhName": "秋田縣",
      "koName": "아키타현",
      "esName": "Prefectura de Akita",
      "ptName": "Província de Akita",
      "thName": "จังหวัดอากิตะ",
      "viName": "Tỉnh Akita",
      "inName": "Prefektur Akita",
      "tlName": "Akita Prefecture",
      "moName": "Акита аймаг",
      "buName": "အခီတ ပြည်နယ်",
      "khName": "ខេត្ដ អាគីតា",
      "neName": "आकिता जिल्ला"
    },
    "class10": {
      "code": "050020",
      "name": "内陸",
      "enName": "Inland",
      "chName": "秋田县内陆地",
      "zhName": "秋田縣內陸",
      "koName": "아키타 현 내륙",
      "esName": "Interior de la Prefectura de Akita",
      "ptName": "Região Interior da Província de Akita",
      "thName": "ด้านในแผ่นดินของจังหวัดอากิตะ",
      "viName": "Vùng nội địa tỉnh Akita",
      "inName": "Bagian Pedalaman di Prefektur Akita",
      "tlName": "Bahagi ng lupain ng Akita Prefecture",
      "moName": "Акита аймаг, дотоод нутаг",
      "buName": "အခိတစီရင်စုကုန်းတွင်းဒေသ",
      "khName": "តំបន់ដីឆ្ងាយពីឆ្នេរនៃខេត្ដអាគីតា",
      "neName": "आकिता जिल्लाको भित्री (समुद्री किनारबाट टाढा) क्षेत्र"
    },
    "class15": {
      "code": "050022",
      "name": "仙北平鹿地域",
      "enName": "Semboku Hiraka Area"
    },
    "class20": {
      "code": "0543400",
      "name": "美郷町",
      "enName": "Misato Town",
      "kana": "みさとちょう",
      "chName": "秋田美乡町",
      "zhName": "秋田美鄉町",
      "koName": "아키타 미사토 정",
      "esName": "Pueblo de Misato, Akita",
      "ptName": "Akita, bairro de Misato",
      "thName": "เมืองมิซาโตะ อะกิตะ",
      "viName": "Thị trấn Misato, Akita",
      "inName": "Kota Misato, Akita",
      "tlName": "bayan ng Misato, Akita",
      "moName": "Акита Мисато жижиг хот",
      "buName": "ဆခိတမိဆတိုမြို့နယ် ",
      "khName": "ទីប្រជុំជនមីសាតូ អាគីតា",
      "neName": "आकिता मिसातो नगर"
    }
  },
  "0546300": {
    "office": {
      "code": "050000",
      "name": "秋田県",
      "enName": "Akita",
      "officeName": "秋田地方気象台",
      "chName": "秋田县",
      "zhName": "秋田縣",
      "koName": "아키타현",
      "esName": "Prefectura de Akita",
      "ptName": "Província de Akita",
      "thName": "จังหวัดอากิตะ",
      "viName": "Tỉnh Akita",
      "inName": "Prefektur Akita",
      "tlName": "Akita Prefecture",
      "moName": "Акита аймаг",
      "buName": "အခီတ ပြည်နယ်",
      "khName": "ខេត្ដ អាគីតា",
      "neName": "आकिता जिल्ला"
    },
    "class10": {
      "code": "050020",
      "name": "内陸",
      "enName": "Inland",
      "chName": "秋田县内陆地",
      "zhName": "秋田縣內陸",
      "koName": "아키타 현 내륙",
      "esName": "Interior de la Prefectura de Akita",
      "ptName": "Região Interior da Província de Akita",
      "thName": "ด้านในแผ่นดินของจังหวัดอากิตะ",
      "viName": "Vùng nội địa tỉnh Akita",
      "inName": "Bagian Pedalaman di Prefektur Akita",
      "tlName": "Bahagi ng lupain ng Akita Prefecture",
      "moName": "Акита аймаг, дотоод нутаг",
      "buName": "အခိတစီရင်စုကုန်းတွင်းဒေသ",
      "khName": "តំបន់ដីឆ្ងាយពីឆ្នេរនៃខេត្ដអាគីតា",
      "neName": "आकिता जिल्लाको भित्री (समुद्री किनारबाट टाढा) क्षेत्र"
    },
    "class15": {
      "code": "050023",
      "name": "湯沢雄勝地域",
      "enName": "Yuzawa Ogachi Area"
    },
    "class20": {
      "code": "0546300",
      "name": "羽後町",
      "enName": "Ugo Town",
      "kana": "うごまち",
      "chName": "羽后町",
      "zhName": "羽後町",
      "koName": "우고 정",
      "esName": "Pueblo de Ugo",
      "ptName": "bairro de Ugo",
      "thName": "เมืองอุโงะ",
      "viName": "thị trấn Ugo",
      "inName": "kota Ugo",
      "tlName": "bayan ng Ugo",
      "moName": "Үго жижиг хот",
      "buName": "ဦဂေါ့ မြို့နယ်",
      "khName": "ទីប្រជុំជន យូហ្គោ",
      "neName": "उगो नगर"
    }
  },
  "0546400": {
    "office": {
      "code": "050000",
      "name": "秋田県",
      "enName": "Akita",
      "officeName": "秋田地方気象台",
      "chName": "秋田县",
      "zhName": "秋田縣",
      "koName": "아키타현",
      "esName": "Prefectura de Akita",
      "ptName": "Província de Akita",
      "thName": "จังหวัดอากิตะ",
      "viName": "Tỉnh Akita",
      "inName": "Prefektur Akita",
      "tlName": "Akita Prefecture",
      "moName": "Акита аймаг",
      "buName": "အခီတ ပြည်နယ်",
      "khName": "ខេត្ដ អាគីតា",
      "neName": "आकिता जिल्ला"
    },
    "class10": {
      "code": "050020",
      "name": "内陸",
      "enName": "Inland",
      "chName": "秋田县内陆地",
      "zhName": "秋田縣內陸",
      "koName": "아키타 현 내륙",
      "esName": "Interior de la Prefectura de Akita",
      "ptName": "Região Interior da Província de Akita",
      "thName": "ด้านในแผ่นดินของจังหวัดอากิตะ",
      "viName": "Vùng nội địa tỉnh Akita",
      "inName": "Bagian Pedalaman di Prefektur Akita",
      "tlName": "Bahagi ng lupain ng Akita Prefecture",
      "moName": "Акита аймаг, дотоод нутаг",
      "buName": "အခိတစီရင်စုကုန်းတွင်းဒေသ",
      "khName": "តំបន់ដីឆ្ងាយពីឆ្នេរនៃខេត្ដអាគីតា",
      "neName": "आकिता जिल्लाको भित्री (समुद्री किनारबाट टाढा) क्षेत्र"
    },
    "class15": {
      "code": "050023",
      "name": "湯沢雄勝地域",
      "enName": "Yuzawa Ogachi Area"
    },
    "class20": {
      "code": "0546400",
      "name": "東成瀬村",
      "enName": "Higashinaruse Village",
      "kana": "ひがしなるせむら",
      "chName": "东成濑村",
      "zhName": "東成瀨村",
      "koName": "히가시나루세 촌",
      "esName": "Aldea de Higashi-naruse",
      "ptName": "povoado de Higashinaruse",
      "thName": "หมู่บ้านฮิงาชินารุเสะ",
      "viName": "làng Higashinaruse",
      "inName": "desa Higashinaruse",
      "tlName": "nayon ng Higashinaruse",
      "moName": "Хигашинарүсэ тосгон",
      "buName": "ဟီဂါ့ရှိနားရုဆဲ့ ကျေးရွာ",
      "khName": "ភូមិ ហ៊ីហ្កាស៊ីណាអារូសេ",
      "neName": "हिगाशिनारुसे गाउँ"
    }
  },
  "0620100": {
    "office": {
      "code": "060000",
      "name": "山形県",
      "enName": "Yamagata",
      "officeName": "山形地方気象台",
      "chName": "山形县",
      "zhName": "山形縣",
      "koName": "야마가타현",
      "esName": "Prefectura de Yamagata",
      "ptName": "Província de Yamagata",
      "thName": "จังหวัดยามางาตะ",
      "viName": "Tỉnh Yamagata",
      "inName": "Prefektur Yamagata",
      "tlName": "Yamagata Prefecture",
      "moName": "Ямагата аймаг",
      "buName": "ယာမာဂါတာ ပြည်နယ်",
      "khName": "ខេត្ដ យ៉ាម៉ាហ្គាតា",
      "neName": "यामागाता जिल्ला"
    },
    "class10": {
      "code": "060010",
      "name": "村山",
      "enName": "Murayama",
      "chName": "山形县村山地方",
      "zhName": "山形縣村山地方",
      "koName": "야마가타 현 무라야마 지방",
      "esName": "Región Murayama, Prefectura de Yamagata",
      "ptName": "Região de Murayama da Província de Yamagata",
      "thName": "ท้องถิ่นมุรายามะ จังหวัดยามางาตะ",
      "viName": "Vùng Murayama tỉnh Yamagata",
      "inName": "Daerah Murayama di Prefektur Yamagata",
      "tlName": "Rehiyon ng Murayama sa Yamagata Prefecture",
      "moName": "Ямагата аймаг, Мүраяма муж",
      "buName": "မုယယမဒေသ၊ ယမဂတစီရင်စု",
      "khName": "តំបន់មឹរ៉ាយ៉ាម៉ាក់នៃខេត្ដយ៉ាម៉ាហ្គាតា",
      "neName": "यामागाता जिल्ला, मुरायामा क्षेत्र"
    },
    "class15": {
      "code": "060011",
      "name": "東南村山",
      "enName": "South-eastern Murayama"
    },
    "class20": {
      "code": "0620100",
      "name": "山形市",
      "enName": "Yamagata City",
      "kana": "やまがたし",
      "chName": "山形市",
      "zhName": "山形市",
      "koName": "야마가타 시",
      "esName": "Ciudad de Yamagata",
      "ptName": "cidade de Yamagata",
      "thName": "เมืองยามางาตะ",
      "viName": "thành phố Yamagata",
      "inName": "kota Yamagata",
      "tlName": "siyudad ng Yamagata",
      "moName": "Ямагата хот",
      "buName": "ယာမာဂါးတ မြို့",
      "khName": "ទីក្រុង យ៉ាម៉ាហ្គាតា",
      "neName": "यामागाता सहर"
    }
  },
  "0620200": {
    "office": {
      "code": "060000",
      "name": "山形県",
      "enName": "Yamagata",
      "officeName": "山形地方気象台",
      "chName": "山形县",
      "zhName": "山形縣",
      "koName": "야마가타현",
      "esName": "Prefectura de Yamagata",
      "ptName": "Província de Yamagata",
      "thName": "จังหวัดยามางาตะ",
      "viName": "Tỉnh Yamagata",
      "inName": "Prefektur Yamagata",
      "tlName": "Yamagata Prefecture",
      "moName": "Ямагата аймаг",
      "buName": "ယာမာဂါတာ ပြည်နယ်",
      "khName": "ខេត្ដ យ៉ាម៉ាហ្គាតា",
      "neName": "यामागाता जिल्ला"
    },
    "class10": {
      "code": "060020",
      "name": "置賜",
      "enName": "Okitama",
      "chName": "山形县置赐地方",
      "zhName": "山形縣置賜地方",
      "koName": "야마가타 현 오키 타마 지방",
      "esName": "Región Okitama, Prefectura de Yamagata",
      "ptName": "Região de Okitama da Província de Yamagata",
      "thName": "ท้องถิ่นโอกิตามะ จังหวัดยามางาตะ",
      "viName": "Vùng Okitama tỉnh Yamagata",
      "inName": "Daerah Okitama di Prefektur Yamagata",
      "tlName": "Rehiyon ng Okitama sa Yamagata Prefecture",
      "moName": "Ямагата аймаг, Окитама муж",
      "buName": "အိုခိတမဒေသ၊ ယမဂတစီရင်စု",
      "khName": "តំបនអូគីតាម៉ា់នៃខេត្ដយ៉ាម៉ាហ្គាតា",
      "neName": "यामागाता जिल्ला, ओकितामा क्षेत्र"
    },
    "class15": {
      "code": "060021",
      "name": "東南置賜",
      "enName": "South-eastern Okitama"
    },
    "class20": {
      "code": "0620200",
      "name": "米沢市",
      "enName": "Yonezawa City",
      "kana": "よねざわし",
      "chName": "米泽市",
      "zhName": "米澤市",
      "koName": "요네자와 시",
      "esName": "Ciudad de Yonezawa",
      "ptName": "cidade de Yonezawa",
      "thName": "เมืองโยเนะซาวา",
      "viName": "thành phố Yonezawa",
      "inName": "kota Yonezawa",
      "tlName": "siyudad ng Yonezawa",
      "moName": "Ёнэзава хот",
      "buName": "ယိုနဲ့ဇာ့ဝ မြို့",
      "khName": "ទីក្រុង យ៉ុននេហ្សាវ៉ា",
      "neName": "योनेजावा सहर"
    }
  },
  "0620300": {
    "office": {
      "code": "060000",
      "name": "山形県",
      "enName": "Yamagata",
      "officeName": "山形地方気象台",
      "chName": "山形县",
      "zhName": "山形縣",
      "koName": "야마가타현",
      "esName": "Prefectura de Yamagata",
      "ptName": "Província de Yamagata",
      "thName": "จังหวัดยามางาตะ",
      "viName": "Tỉnh Yamagata",
      "inName": "Prefektur Yamagata",
      "tlName": "Yamagata Prefecture",
      "moName": "Ямагата аймаг",
      "buName": "ယာမာဂါတာ ပြည်နယ်",
      "khName": "ខេត្ដ យ៉ាម៉ាហ្គាតា",
      "neName": "यामागाता जिल्ला"
    },
    "class10": {
      "code": "060030",
      "name": "庄内",
      "enName": "Shonai",
      "chName": "山形县庄内地方",
      "zhName": "山形縣莊內地方",
      "koName": "야마가타 현 쇼나이 지방",
      "esName": "Región Shonai, Prefectura de Yamagata",
      "ptName": "Região de Shōnai da Província de Yamagata",
      "thName": "ท้องถิ่นโชไน จังหวัดยามางาตะ",
      "viName": "Vùng Shonai tỉnh Yamagata",
      "inName": "Daerah Shonai di Prefektur Yamagata",
      "tlName": "Rehiyon ng Shonai sa Yamagata Prefecture",
      "moName": "Ямагата аймаг, Шонай муж",
      "buName": "ရိုနိုင်းဒေသ၊ ယမဂတစီရင်စု",
      "khName": "តំបន់ស្យូណៃនៃខេត្ដយ៉ាម៉ាហ្គាតា",
      "neName": "यामागाता जिल्ला, स्योनाइ क्षेत्र"
    },
    "class15": {
      "code": "060032",
      "name": "庄内南部",
      "enName": "Southern Shonai"
    },
    "class20": {
      "code": "0620300",
      "name": "鶴岡市",
      "enName": "Tsuruoka City",
      "kana": "つるおかし",
      "chName": "鹤冈市",
      "zhName": "鶴岡市",
      "koName": "쓰루오카 시",
      "esName": "Ciudad de Tsuruoka",
      "ptName": "cidade de Tsuruoka",
      "thName": "เมืองซึรุโอกะ",
      "viName": "thành phố Tsuruoka",
      "inName": "kota Tsuruoka",
      "tlName": "siyudad ng Tsuruoka",
      "moName": "Цүрүока хот",
      "buName": "ဆူရူယို့က မြို့",
      "khName": "ទីក្រុង ស៊ូរូអូកា",
      "neName": "त्सुरुओका सहर"
    }
  },
  "0620400": {
    "office": {
      "code": "060000",
      "name": "山形県",
      "enName": "Yamagata",
      "officeName": "山形地方気象台",
      "chName": "山形县",
      "zhName": "山形縣",
      "koName": "야마가타현",
      "esName": "Prefectura de Yamagata",
      "ptName": "Província de Yamagata",
      "thName": "จังหวัดยามางาตะ",
      "viName": "Tỉnh Yamagata",
      "inName": "Prefektur Yamagata",
      "tlName": "Yamagata Prefecture",
      "moName": "Ямагата аймаг",
      "buName": "ယာမာဂါတာ ပြည်နယ်",
      "khName": "ខេត្ដ យ៉ាម៉ាហ្គាតា",
      "neName": "यामागाता जिल्ला"
    },
    "class10": {
      "code": "060030",
      "name": "庄内",
      "enName": "Shonai",
      "chName": "山形县庄内地方",
      "zhName": "山形縣莊內地方",
      "koName": "야마가타 현 쇼나이 지방",
      "esName": "Región Shonai, Prefectura de Yamagata",
      "ptName": "Região de Shōnai da Província de Yamagata",
      "thName": "ท้องถิ่นโชไน จังหวัดยามางาตะ",
      "viName": "Vùng Shonai tỉnh Yamagata",
      "inName": "Daerah Shonai di Prefektur Yamagata",
      "tlName": "Rehiyon ng Shonai sa Yamagata Prefecture",
      "moName": "Ямагата аймаг, Шонай муж",
      "buName": "ရိုနိုင်းဒေသ၊ ယမဂတစီရင်စု",
      "khName": "តំបន់ស្យូណៃនៃខេត្ដយ៉ាម៉ាហ្គាតា",
      "neName": "यामागाता जिल्ला, स्योनाइ क्षेत्र"
    },
    "class15": {
      "code": "060031",
      "name": "庄内北部",
      "enName": "Northern Shonai"
    },
    "class20": {
      "code": "0620400",
      "name": "酒田市",
      "enName": "Sakata City",
      "kana": "さかたし",
      "chName": "酒田市",
      "zhName": "酒田市",
      "koName": "사카타 시",
      "esName": "Ciudad de Sakata",
      "ptName": "cidade de Sakata",
      "thName": "เมืองซากาตะ",
      "viName": "thành phố Sakata",
      "inName": "kota Sakata",
      "tlName": "siyudad ng Sakata",
      "moName": "Саката хот",
      "buName": "ဆာကာတ မြို့",
      "khName": "ទីក្រុង សាកាតា",
      "neName": "साकाता सहर"
    }
  },
  "0620500": {
    "office": {
      "code": "060000",
      "name": "山形県",
      "enName": "Yamagata",
      "officeName": "山形地方気象台",
      "chName": "山形县",
      "zhName": "山形縣",
      "koName": "야마가타현",
      "esName": "Prefectura de Yamagata",
      "ptName": "Província de Yamagata",
      "thName": "จังหวัดยามางาตะ",
      "viName": "Tỉnh Yamagata",
      "inName": "Prefektur Yamagata",
      "tlName": "Yamagata Prefecture",
      "moName": "Ямагата аймаг",
      "buName": "ယာမာဂါတာ ပြည်နယ်",
      "khName": "ខេត្ដ យ៉ាម៉ាហ្គាតា",
      "neName": "यामागाता जिल्ला"
    },
    "class10": {
      "code": "060040",
      "name": "最上",
      "enName": "Mogami",
      "chName": "山形县最上地方",
      "zhName": "山形縣最上地方",
      "koName": "야마가타현 모가미 지방",
      "esName": "Región Mogami, Prefectura de Yamagata",
      "ptName": "Região de Mogami da Província de Yamagata",
      "thName": "ท้องถิ่นโมะงามิ จังหวัดยามางาตะ",
      "viName": "Vùng Mogami tỉnh Yamagata",
      "inName": "Daerah Mogami di Prefektur Yamagata",
      "tlName": "Rehiyon ng Mogami sa Yamagata Prefecture",
      "moName": "Ямагата аймаг, Могами муж",
      "buName": "မိုဂမိဒေသ၊ ယမဂတစီရင်စု",
      "khName": "តំបន់ម៉ូហ្កាមីនៃខេត្ដយ៉ាម៉ាហ្គាតា",
      "neName": "यामागाता जिल्ला, मोगामी क्षेत्र"
    },
    "class15": {
      "code": "060040",
      "name": "最上",
      "enName": "Mogami"
    },
    "class20": {
      "code": "0620500",
      "name": "新庄市",
      "enName": "Shinjo City",
      "kana": "しんじょうし",
      "chName": "新庄市",
      "zhName": "新庄市",
      "koName": "신조 시",
      "esName": "Ciudad de Shinjō",
      "ptName": "cidade de Shinjo",
      "thName": "เมืองชินโจ",
      "viName": "thành phố Shinjo",
      "inName": "kota Shinjo",
      "tlName": "siyudad ng Shinjo",
      "moName": "Шинжо хот",
      "buName": "ရှင်းဂျော့ မြို့",
      "khName": "ទីក្រុង ស៊ីនជូ",
      "neName": "शिन्जो सहर"
    }
  },
  "0620600": {
    "office": {
      "code": "060000",
      "name": "山形県",
      "enName": "Yamagata",
      "officeName": "山形地方気象台",
      "chName": "山形县",
      "zhName": "山形縣",
      "koName": "야마가타현",
      "esName": "Prefectura de Yamagata",
      "ptName": "Província de Yamagata",
      "thName": "จังหวัดยามางาตะ",
      "viName": "Tỉnh Yamagata",
      "inName": "Prefektur Yamagata",
      "tlName": "Yamagata Prefecture",
      "moName": "Ямагата аймаг",
      "buName": "ယာမာဂါတာ ပြည်နယ်",
      "khName": "ខេត្ដ យ៉ាម៉ាហ្គាតា",
      "neName": "यामागाता जिल्ला"
    },
    "class10": {
      "code": "060010",
      "name": "村山",
      "enName": "Murayama",
      "chName": "山形县村山地方",
      "zhName": "山形縣村山地方",
      "koName": "야마가타 현 무라야마 지방",
      "esName": "Región Murayama, Prefectura de Yamagata",
      "ptName": "Região de Murayama da Província de Yamagata",
      "thName": "ท้องถิ่นมุรายามะ จังหวัดยามางาตะ",
      "viName": "Vùng Murayama tỉnh Yamagata",
      "inName": "Daerah Murayama di Prefektur Yamagata",
      "tlName": "Rehiyon ng Murayama sa Yamagata Prefecture",
      "moName": "Ямагата аймаг, Мүраяма муж",
      "buName": "မုယယမဒေသ၊ ယမဂတစီရင်စု",
      "khName": "តំបន់មឹរ៉ាយ៉ាម៉ាក់នៃខេត្ដយ៉ាម៉ាហ្គាតា",
      "neName": "यामागाता जिल्ला, मुरायामा क्षेत्र"
    },
    "class15": {
      "code": "060013",
      "name": "西村山",
      "enName": "Western Murayama"
    },
    "class20": {
      "code": "0620600",
      "name": "寒河江市",
      "enName": "Sagae City",
      "kana": "さがえし",
      "chName": "寒河江市",
      "zhName": "寒河江市",
      "koName": "사가에 시",
      "esName": "Ciudad de Sagae",
      "ptName": "cidade de Sagae",
      "thName": "เมืองซากาเอะ",
      "viName": "thành phố Sagae",
      "inName": "kota Sagae",
      "tlName": "siyudad ng Sagae",
      "moName": "Сагаэ хот",
      "buName": "ဆာဂါအဲ့ မြို့",
      "khName": "ទីក្រុង សាហ្គា",
      "neName": "सागाए सहर"
    }
  },
  "0620700": {
    "office": {
      "code": "060000",
      "name": "山形県",
      "enName": "Yamagata",
      "officeName": "山形地方気象台",
      "chName": "山形县",
      "zhName": "山形縣",
      "koName": "야마가타현",
      "esName": "Prefectura de Yamagata",
      "ptName": "Província de Yamagata",
      "thName": "จังหวัดยามางาตะ",
      "viName": "Tỉnh Yamagata",
      "inName": "Prefektur Yamagata",
      "tlName": "Yamagata Prefecture",
      "moName": "Ямагата аймаг",
      "buName": "ယာမာဂါတာ ပြည်နယ်",
      "khName": "ខេត្ដ យ៉ាម៉ាហ្គាតា",
      "neName": "यामागाता जिल्ला"
    },
    "class10": {
      "code": "060010",
      "name": "村山",
      "enName": "Murayama",
      "chName": "山形县村山地方",
      "zhName": "山形縣村山地方",
      "koName": "야마가타 현 무라야마 지방",
      "esName": "Región Murayama, Prefectura de Yamagata",
      "ptName": "Região de Murayama da Província de Yamagata",
      "thName": "ท้องถิ่นมุรายามะ จังหวัดยามางาตะ",
      "viName": "Vùng Murayama tỉnh Yamagata",
      "inName": "Daerah Murayama di Prefektur Yamagata",
      "tlName": "Rehiyon ng Murayama sa Yamagata Prefecture",
      "moName": "Ямагата аймаг, Мүраяма муж",
      "buName": "မုယယမဒေသ၊ ယမဂတစီရင်စု",
      "khName": "តំបន់មឹរ៉ាយ៉ាម៉ាក់នៃខេត្ដយ៉ាម៉ាហ្គាតា",
      "neName": "यामागाता जिल्ला, मुरायामा क्षेत्र"
    },
    "class15": {
      "code": "060011",
      "name": "東南村山",
      "enName": "South-eastern Murayama"
    },
    "class20": {
      "code": "0620700",
      "name": "上山市",
      "enName": "Kaminoyama City",
      "kana": "かみのやまし",
      "chName": "上山市",
      "zhName": "上山市",
      "koName": "가미노야마 시",
      "esName": "Ciudad de Kaminoyama",
      "ptName": "cidade de Kaminoyama",
      "thName": "เมืองคามิโนะยามะ",
      "viName": "thành phố Kaminoyama",
      "inName": "kota Kaminoyama",
      "tlName": "siyudad ng Kaminoyama",
      "moName": "Каминояма хот",
      "buName": "ခါမိနိုးယာ့မ မြို့",
      "khName": "ទីក្រុង កាមីណូយ៉ាម៉ា",
      "neName": "कामिनोयोमा सहर"
    }
  },
  "0620800": {
    "office": {
      "code": "060000",
      "name": "山形県",
      "enName": "Yamagata",
      "officeName": "山形地方気象台",
      "chName": "山形县",
      "zhName": "山形縣",
      "koName": "야마가타현",
      "esName": "Prefectura de Yamagata",
      "ptName": "Província de Yamagata",
      "thName": "จังหวัดยามางาตะ",
      "viName": "Tỉnh Yamagata",
      "inName": "Prefektur Yamagata",
      "tlName": "Yamagata Prefecture",
      "moName": "Ямагата аймаг",
      "buName": "ယာမာဂါတာ ပြည်နယ်",
      "khName": "ខេត្ដ យ៉ាម៉ាហ្គាតា",
      "neName": "यामागाता जिल्ला"
    },
    "class10": {
      "code": "060010",
      "name": "村山",
      "enName": "Murayama",
      "chName": "山形县村山地方",
      "zhName": "山形縣村山地方",
      "koName": "야마가타 현 무라야마 지방",
      "esName": "Región Murayama, Prefectura de Yamagata",
      "ptName": "Região de Murayama da Província de Yamagata",
      "thName": "ท้องถิ่นมุรายามะ จังหวัดยามางาตะ",
      "viName": "Vùng Murayama tỉnh Yamagata",
      "inName": "Daerah Murayama di Prefektur Yamagata",
      "tlName": "Rehiyon ng Murayama sa Yamagata Prefecture",
      "moName": "Ямагата аймаг, Мүраяма муж",
      "buName": "မုယယမဒေသ၊ ယမဂတစီရင်စု",
      "khName": "តំបន់មឹរ៉ាយ៉ាម៉ាក់នៃខេត្ដយ៉ាម៉ាហ្គាតា",
      "neName": "यामागाता जिल्ला, मुरायामा क्षेत्र"
    },
    "class15": {
      "code": "060012",
      "name": "北村山",
      "enName": "Northern Murayama"
    },
    "class20": {
      "code": "0620800",
      "name": "村山市",
      "enName": "Murayama City",
      "kana": "むらやまし",
      "chName": "村山市",
      "zhName": "村山市",
      "koName": "무라야마 시",
      "esName": "Ciudad de Murayama",
      "ptName": "cidade de Murayama",
      "thName": "เมืองมิรายามะ",
      "viName": "thành phố Murayama",
      "inName": "kota Murayama",
      "tlName": "siyudad ng Murayama",
      "moName": "Мүраяма хот",
      "buName": "မူရာယာ့မ မြို့",
      "khName": "ទីក្រុង មូរ៉ាយ៉ាម៉ា",
      "neName": "मुरायामा सहर"
    }
  },
  "0620900": {
    "office": {
      "code": "060000",
      "name": "山形県",
      "enName": "Yamagata",
      "officeName": "山形地方気象台",
      "chName": "山形县",
      "zhName": "山形縣",
      "koName": "야마가타현",
      "esName": "Prefectura de Yamagata",
      "ptName": "Província de Yamagata",
      "thName": "จังหวัดยามางาตะ",
      "viName": "Tỉnh Yamagata",
      "inName": "Prefektur Yamagata",
      "tlName": "Yamagata Prefecture",
      "moName": "Ямагата аймаг",
      "buName": "ယာမာဂါတာ ပြည်နယ်",
      "khName": "ខេត្ដ យ៉ាម៉ាហ្គាតា",
      "neName": "यामागाता जिल्ला"
    },
    "class10": {
      "code": "060020",
      "name": "置賜",
      "enName": "Okitama",
      "chName": "山形县置赐地方",
      "zhName": "山形縣置賜地方",
      "koName": "야마가타 현 오키 타마 지방",
      "esName": "Región Okitama, Prefectura de Yamagata",
      "ptName": "Região de Okitama da Província de Yamagata",
      "thName": "ท้องถิ่นโอกิตามะ จังหวัดยามางาตะ",
      "viName": "Vùng Okitama tỉnh Yamagata",
      "inName": "Daerah Okitama di Prefektur Yamagata",
      "tlName": "Rehiyon ng Okitama sa Yamagata Prefecture",
      "moName": "Ямагата аймаг, Окитама муж",
      "buName": "အိုခိတမဒေသ၊ ယမဂတစီရင်စု",
      "khName": "តំបនអូគីតាម៉ា់នៃខេត្ដយ៉ាម៉ាហ្គាតា",
      "neName": "यामागाता जिल्ला, ओकितामा क्षेत्र"
    },
    "class15": {
      "code": "060022",
      "name": "西置賜",
      "enName": "Western Okitama"
    },
    "class20": {
      "code": "0620900",
      "name": "長井市",
      "enName": "Nagai City",
      "kana": "ながいし",
      "chName": "长井市",
      "zhName": "長井市",
      "koName": "나가이 시",
      "esName": "Ciudad de Nagai",
      "ptName": "cidade de Nagai",
      "thName": "เมืองนะงะอิ",
      "viName": "thành phố Nagai",
      "inName": "kota Nagai",
      "tlName": "siyudad ng Nagai",
      "moName": "Нагай хот",
      "buName": "နာဂါယိ မြို့",
      "khName": "ទីក្រុង ណាហ្គាយ",
      "neName": "नागाई सहर"
    }
  },
  "0621000": {
    "office": {
      "code": "060000",
      "name": "山形県",
      "enName": "Yamagata",
      "officeName": "山形地方気象台",
      "chName": "山形县",
      "zhName": "山形縣",
      "koName": "야마가타현",
      "esName": "Prefectura de Yamagata",
      "ptName": "Província de Yamagata",
      "thName": "จังหวัดยามางาตะ",
      "viName": "Tỉnh Yamagata",
      "inName": "Prefektur Yamagata",
      "tlName": "Yamagata Prefecture",
      "moName": "Ямагата аймаг",
      "buName": "ယာမာဂါတာ ပြည်နယ်",
      "khName": "ខេត្ដ យ៉ាម៉ាហ្គាតា",
      "neName": "यामागाता जिल्ला"
    },
    "class10": {
      "code": "060010",
      "name": "村山",
      "enName": "Murayama",
      "chName": "山形县村山地方",
      "zhName": "山形縣村山地方",
      "koName": "야마가타 현 무라야마 지방",
      "esName": "Región Murayama, Prefectura de Yamagata",
      "ptName": "Região de Murayama da Província de Yamagata",
      "thName": "ท้องถิ่นมุรายามะ จังหวัดยามางาตะ",
      "viName": "Vùng Murayama tỉnh Yamagata",
      "inName": "Daerah Murayama di Prefektur Yamagata",
      "tlName": "Rehiyon ng Murayama sa Yamagata Prefecture",
      "moName": "Ямагата аймаг, Мүраяма муж",
      "buName": "မုယယမဒေသ၊ ယမဂတစီရင်စု",
      "khName": "តំបន់មឹរ៉ាយ៉ាម៉ាក់នៃខេត្ដយ៉ាម៉ាហ្គាតា",
      "neName": "यामागाता जिल्ला, मुरायामा क्षेत्र"
    },
    "class15": {
      "code": "060011",
      "name": "東南村山",
      "enName": "South-eastern Murayama"
    },
    "class20": {
      "code": "0621000",
      "name": "天童市",
      "enName": "Tendo City",
      "kana": "てんどうし",
      "chName": "天童市",
      "zhName": "天童市",
      "koName": "덴도 시",
      "esName": "Ciudad de Tendō",
      "ptName": "cidade de Tendo",
      "thName": "เมืองเทนโด",
      "viName": "thành phố Tendo",
      "inName": "kota Tendo",
      "tlName": "siyudad ng Tendo",
      "moName": "Тэндо хот",
      "buName": "တန်ဒို မြို့",
      "khName": "ទីក្រុង តេនដូ",
      "neName": "तेन्दो सहर"
    }
  },
  "0621100": {
    "office": {
      "code": "060000",
      "name": "山形県",
      "enName": "Yamagata",
      "officeName": "山形地方気象台",
      "chName": "山形县",
      "zhName": "山形縣",
      "koName": "야마가타현",
      "esName": "Prefectura de Yamagata",
      "ptName": "Província de Yamagata",
      "thName": "จังหวัดยามางาตะ",
      "viName": "Tỉnh Yamagata",
      "inName": "Prefektur Yamagata",
      "tlName": "Yamagata Prefecture",
      "moName": "Ямагата аймаг",
      "buName": "ယာမာဂါတာ ပြည်နယ်",
      "khName": "ខេត្ដ យ៉ាម៉ាហ្គាតា",
      "neName": "यामागाता जिल्ला"
    },
    "class10": {
      "code": "060010",
      "name": "村山",
      "enName": "Murayama",
      "chName": "山形县村山地方",
      "zhName": "山形縣村山地方",
      "koName": "야마가타 현 무라야마 지방",
      "esName": "Región Murayama, Prefectura de Yamagata",
      "ptName": "Região de Murayama da Província de Yamagata",
      "thName": "ท้องถิ่นมุรายามะ จังหวัดยามางาตะ",
      "viName": "Vùng Murayama tỉnh Yamagata",
      "inName": "Daerah Murayama di Prefektur Yamagata",
      "tlName": "Rehiyon ng Murayama sa Yamagata Prefecture",
      "moName": "Ямагата аймаг, Мүраяма муж",
      "buName": "မုယယမဒေသ၊ ယမဂတစီရင်စု",
      "khName": "តំបន់មឹរ៉ាយ៉ាម៉ាក់នៃខេត្ដយ៉ាម៉ាហ្គាតា",
      "neName": "यामागाता जिल्ला, मुरायामा क्षेत्र"
    },
    "class15": {
      "code": "060012",
      "name": "北村山",
      "enName": "Northern Murayama"
    },
    "class20": {
      "code": "0621100",
      "name": "東根市",
      "enName": "Higashine City",
      "kana": "ひがしねし",
      "chName": "东根市",
      "zhName": "東根市",
      "koName": "히가시네 시",
      "esName": "Ciudad de Higashine",
      "ptName": "cidade de Higashine",
      "thName": "เมืองฮิงาชิเนะ",
      "viName": "thành phố Higashine",
      "inName": "kota Higashine",
      "tlName": "siyudad ng Higashine",
      "moName": "Хигашинэ хот",
      "buName": "ဟီဂါးရှီနဲ မြို့",
      "khName": "ទីក្រុង ហ៊ីកាសាញ",
      "neName": "हिगाशिने सहर"
    }
  },
  "0621200": {
    "office": {
      "code": "060000",
      "name": "山形県",
      "enName": "Yamagata",
      "officeName": "山形地方気象台",
      "chName": "山形县",
      "zhName": "山形縣",
      "koName": "야마가타현",
      "esName": "Prefectura de Yamagata",
      "ptName": "Província de Yamagata",
      "thName": "จังหวัดยามางาตะ",
      "viName": "Tỉnh Yamagata",
      "inName": "Prefektur Yamagata",
      "tlName": "Yamagata Prefecture",
      "moName": "Ямагата аймаг",
      "buName": "ယာမာဂါတာ ပြည်နယ်",
      "khName": "ខេត្ដ យ៉ាម៉ាហ្គាតា",
      "neName": "यामागाता जिल्ला"
    },
    "class10": {
      "code": "060010",
      "name": "村山",
      "enName": "Murayama",
      "chName": "山形县村山地方",
      "zhName": "山形縣村山地方",
      "koName": "야마가타 현 무라야마 지방",
      "esName": "Región Murayama, Prefectura de Yamagata",
      "ptName": "Região de Murayama da Província de Yamagata",
      "thName": "ท้องถิ่นมุรายามะ จังหวัดยามางาตะ",
      "viName": "Vùng Murayama tỉnh Yamagata",
      "inName": "Daerah Murayama di Prefektur Yamagata",
      "tlName": "Rehiyon ng Murayama sa Yamagata Prefecture",
      "moName": "Ямагата аймаг, Мүраяма муж",
      "buName": "မုယယမဒေသ၊ ယမဂတစီရင်စု",
      "khName": "តំបន់មឹរ៉ាយ៉ាម៉ាក់នៃខេត្ដយ៉ាម៉ាហ្គាតា",
      "neName": "यामागाता जिल्ला, मुरायामा क्षेत्र"
    },
    "class15": {
      "code": "060012",
      "name": "北村山",
      "enName": "Northern Murayama"
    },
    "class20": {
      "code": "0621200",
      "name": "尾花沢市",
      "enName": "Obanazawa City",
      "kana": "おばなざわし",
      "chName": "尾花泽市",
      "zhName": "尾花澤市",
      "koName": "오바나자와 시",
      "esName": "Ciudad de Obanazawa",
      "ptName": "cidade de Obanazawa",
      "thName": "เมืองโอบานาซาวา",
      "viName": "thành phố Obanazawa",
      "inName": "kota Obanazawa",
      "tlName": "siyudad ng Obanazawa",
      "moName": "Обанaзава хот",
      "buName": "အိုဘာနဇာ့ဝ မြို့",
      "khName": "ទីក្រុង អូបាណាសាវ៉ា",
      "neName": "ओबानाजावा सहर"
    }
  },
  "0621300": {
    "office": {
      "code": "060000",
      "name": "山形県",
      "enName": "Yamagata",
      "officeName": "山形地方気象台",
      "chName": "山形县",
      "zhName": "山形縣",
      "koName": "야마가타현",
      "esName": "Prefectura de Yamagata",
      "ptName": "Província de Yamagata",
      "thName": "จังหวัดยามางาตะ",
      "viName": "Tỉnh Yamagata",
      "inName": "Prefektur Yamagata",
      "tlName": "Yamagata Prefecture",
      "moName": "Ямагата аймаг",
      "buName": "ယာမာဂါတာ ပြည်နယ်",
      "khName": "ខេត្ដ យ៉ាម៉ាហ្គាតា",
      "neName": "यामागाता जिल्ला"
    },
    "class10": {
      "code": "060020",
      "name": "置賜",
      "enName": "Okitama",
      "chName": "山形县置赐地方",
      "zhName": "山形縣置賜地方",
      "koName": "야마가타 현 오키 타마 지방",
      "esName": "Región Okitama, Prefectura de Yamagata",
      "ptName": "Região de Okitama da Província de Yamagata",
      "thName": "ท้องถิ่นโอกิตามะ จังหวัดยามางาตะ",
      "viName": "Vùng Okitama tỉnh Yamagata",
      "inName": "Daerah Okitama di Prefektur Yamagata",
      "tlName": "Rehiyon ng Okitama sa Yamagata Prefecture",
      "moName": "Ямагата аймаг, Окитама муж",
      "buName": "အိုခိတမဒေသ၊ ယမဂတစီရင်စု",
      "khName": "តំបនអូគីតាម៉ា់នៃខេត្ដយ៉ាម៉ាហ្គាតា",
      "neName": "यामागाता जिल्ला, ओकितामा क्षेत्र"
    },
    "class15": {
      "code": "060021",
      "name": "東南置賜",
      "enName": "South-eastern Okitama"
    },
    "class20": {
      "code": "0621300",
      "name": "南陽市",
      "enName": "Nanyo City",
      "kana": "なんようし",
      "chName": "南阳市",
      "zhName": "南陽市",
      "koName": "난요 시",
      "esName": "Ciudad de Nanyō",
      "ptName": "cidade de Nanyo",
      "thName": "เมืองนันโย",
      "viName": "thành phố Nanyo",
      "inName": "kota Nanyo",
      "tlName": "siyudad ng Nanyo",
      "moName": "Нанёо хот",
      "buName": "နာညို မြို့",
      "khName": "ទីក្រុង ណាន់យ៉ូ",
      "neName": "नान्यो सहर"
    }
  },
  "0630100": {
    "office": {
      "code": "060000",
      "name": "山形県",
      "enName": "Yamagata",
      "officeName": "山形地方気象台",
      "chName": "山形县",
      "zhName": "山形縣",
      "koName": "야마가타현",
      "esName": "Prefectura de Yamagata",
      "ptName": "Província de Yamagata",
      "thName": "จังหวัดยามางาตะ",
      "viName": "Tỉnh Yamagata",
      "inName": "Prefektur Yamagata",
      "tlName": "Yamagata Prefecture",
      "moName": "Ямагата аймаг",
      "buName": "ယာမာဂါတာ ပြည်နယ်",
      "khName": "ខេត្ដ យ៉ាម៉ាហ្គាតា",
      "neName": "यामागाता जिल्ला"
    },
    "class10": {
      "code": "060010",
      "name": "村山",
      "enName": "Murayama",
      "chName": "山形县村山地方",
      "zhName": "山形縣村山地方",
      "koName": "야마가타 현 무라야마 지방",
      "esName": "Región Murayama, Prefectura de Yamagata",
      "ptName": "Região de Murayama da Província de Yamagata",
      "thName": "ท้องถิ่นมุรายามะ จังหวัดยามางาตะ",
      "viName": "Vùng Murayama tỉnh Yamagata",
      "inName": "Daerah Murayama di Prefektur Yamagata",
      "tlName": "Rehiyon ng Murayama sa Yamagata Prefecture",
      "moName": "Ямагата аймаг, Мүраяма муж",
      "buName": "မုယယမဒေသ၊ ယမဂတစီရင်စု",
      "khName": "តំបន់មឹរ៉ាយ៉ាម៉ាក់នៃខេត្ដយ៉ាម៉ាហ្គាតា",
      "neName": "यामागाता जिल्ला, मुरायामा क्षेत्र"
    },
    "class15": {
      "code": "060011",
      "name": "東南村山",
      "enName": "South-eastern Murayama"
    },
    "class20": {
      "code": "0630100",
      "name": "山辺町",
      "enName": "Yamanobe Town",
      "kana": "やまのべまち",
      "chName": "山边町",
      "zhName": "山邊町",
      "koName": "야마노베 정",
      "esName": "Pueblo de Yamanobe",
      "ptName": "bairro de Yamanobe",
      "thName": "เมืองยามาโนะเบะ",
      "viName": "thị trấn Yamanobe",
      "inName": "kota Yamanobe",
      "tlName": "bayan ng Yamanobe",
      "moName": "Ямaнобэ жижиг хот",
      "buName": "ယာမာ့နောဘဲ့ မြို့နယ်",
      "khName": "ទីប្រជុំជន យ៉ាម៉ាណាបូ",
      "neName": "यामानोबे नगर"
    }
  },
  "0630200": {
    "office": {
      "code": "060000",
      "name": "山形県",
      "enName": "Yamagata",
      "officeName": "山形地方気象台",
      "chName": "山形县",
      "zhName": "山形縣",
      "koName": "야마가타현",
      "esName": "Prefectura de Yamagata",
      "ptName": "Província de Yamagata",
      "thName": "จังหวัดยามางาตะ",
      "viName": "Tỉnh Yamagata",
      "inName": "Prefektur Yamagata",
      "tlName": "Yamagata Prefecture",
      "moName": "Ямагата аймаг",
      "buName": "ယာမာဂါတာ ပြည်နယ်",
      "khName": "ខេត្ដ យ៉ាម៉ាហ្គាតា",
      "neName": "यामागाता जिल्ला"
    },
    "class10": {
      "code": "060010",
      "name": "村山",
      "enName": "Murayama",
      "chName": "山形县村山地方",
      "zhName": "山形縣村山地方",
      "koName": "야마가타 현 무라야마 지방",
      "esName": "Región Murayama, Prefectura de Yamagata",
      "ptName": "Região de Murayama da Província de Yamagata",
      "thName": "ท้องถิ่นมุรายามะ จังหวัดยามางาตะ",
      "viName": "Vùng Murayama tỉnh Yamagata",
      "inName": "Daerah Murayama di Prefektur Yamagata",
      "tlName": "Rehiyon ng Murayama sa Yamagata Prefecture",
      "moName": "Ямагата аймаг, Мүраяма муж",
      "buName": "မုယယမဒေသ၊ ယမဂတစီရင်စု",
      "khName": "តំបន់មឹរ៉ាយ៉ាម៉ាក់នៃខេត្ដយ៉ាម៉ាហ្គាតា",
      "neName": "यामागाता जिल्ला, मुरायामा क्षेत्र"
    },
    "class15": {
      "code": "060011",
      "name": "東南村山",
      "enName": "South-eastern Murayama"
    },
    "class20": {
      "code": "0630200",
      "name": "中山町",
      "enName": "Nakayama Town",
      "kana": "なかやままち",
      "chName": "中山町",
      "zhName": "中山町",
      "koName": "나카야마 정",
      "esName": "Pueblo de Nakayama",
      "ptName": "bairro de Nakayama",
      "thName": "เมืองนากายามะ",
      "viName": "thị trấn Nakayama",
      "inName": "kota Nakayama",
      "tlName": "bayan ng Nakayama",
      "moName": "Нaкаямa жижиг хот",
      "buName": "နာကားယာ့မ မြို့နယ်",
      "khName": "ទីប្រជុំជន ណាកាយ៉ាម៉ា",
      "neName": "नाकायामा नगर"
    }
  },
  "0632100": {
    "office": {
      "code": "060000",
      "name": "山形県",
      "enName": "Yamagata",
      "officeName": "山形地方気象台",
      "chName": "山形县",
      "zhName": "山形縣",
      "koName": "야마가타현",
      "esName": "Prefectura de Yamagata",
      "ptName": "Província de Yamagata",
      "thName": "จังหวัดยามางาตะ",
      "viName": "Tỉnh Yamagata",
      "inName": "Prefektur Yamagata",
      "tlName": "Yamagata Prefecture",
      "moName": "Ямагата аймаг",
      "buName": "ယာမာဂါတာ ပြည်နယ်",
      "khName": "ខេត្ដ យ៉ាម៉ាហ្គាតា",
      "neName": "यामागाता जिल्ला"
    },
    "class10": {
      "code": "060010",
      "name": "村山",
      "enName": "Murayama",
      "chName": "山形县村山地方",
      "zhName": "山形縣村山地方",
      "koName": "야마가타 현 무라야마 지방",
      "esName": "Región Murayama, Prefectura de Yamagata",
      "ptName": "Região de Murayama da Província de Yamagata",
      "thName": "ท้องถิ่นมุรายามะ จังหวัดยามางาตะ",
      "viName": "Vùng Murayama tỉnh Yamagata",
      "inName": "Daerah Murayama di Prefektur Yamagata",
      "tlName": "Rehiyon ng Murayama sa Yamagata Prefecture",
      "moName": "Ямагата аймаг, Мүраяма муж",
      "buName": "မုယယမဒေသ၊ ယမဂတစီရင်စု",
      "khName": "តំបន់មឹរ៉ាយ៉ាម៉ាក់នៃខេត្ដយ៉ាម៉ាហ្គាតា",
      "neName": "यामागाता जिल्ला, मुरायामा क्षेत्र"
    },
    "class15": {
      "code": "060013",
      "name": "西村山",
      "enName": "Western Murayama"
    },
    "class20": {
      "code": "0632100",
      "name": "河北町",
      "enName": "Kahoku Town",
      "kana": "かほくちょう",
      "chName": "河北町",
      "zhName": "河北町",
      "koName": "가호쿠 정",
      "esName": "Pueblo de Kahoku",
      "ptName": "bairro de Kahoku",
      "thName": "เมืองคาโฮขุ",
      "viName": "thị trấn Kahoku",
      "inName": "kota Kahoku",
      "tlName": "bayan ng Kahoku",
      "moName": "Кахокү жижиг хот",
      "buName": "ခါဟိုးကု မြို့နယ်",
      "khName": "ទីប្រជុំជន កាហុគូ",
      "neName": "काहोकु नगर"
    }
  },
  "0632200": {
    "office": {
      "code": "060000",
      "name": "山形県",
      "enName": "Yamagata",
      "officeName": "山形地方気象台",
      "chName": "山形县",
      "zhName": "山形縣",
      "koName": "야마가타현",
      "esName": "Prefectura de Yamagata",
      "ptName": "Província de Yamagata",
      "thName": "จังหวัดยามางาตะ",
      "viName": "Tỉnh Yamagata",
      "inName": "Prefektur Yamagata",
      "tlName": "Yamagata Prefecture",
      "moName": "Ямагата аймаг",
      "buName": "ယာမာဂါတာ ပြည်နယ်",
      "khName": "ខេត្ដ យ៉ាម៉ាហ្គាតា",
      "neName": "यामागाता जिल्ला"
    },
    "class10": {
      "code": "060010",
      "name": "村山",
      "enName": "Murayama",
      "chName": "山形县村山地方",
      "zhName": "山形縣村山地方",
      "koName": "야마가타 현 무라야마 지방",
      "esName": "Región Murayama, Prefectura de Yamagata",
      "ptName": "Região de Murayama da Província de Yamagata",
      "thName": "ท้องถิ่นมุรายามะ จังหวัดยามางาตะ",
      "viName": "Vùng Murayama tỉnh Yamagata",
      "inName": "Daerah Murayama di Prefektur Yamagata",
      "tlName": "Rehiyon ng Murayama sa Yamagata Prefecture",
      "moName": "Ямагата аймаг, Мүраяма муж",
      "buName": "မုယယမဒေသ၊ ယမဂတစီရင်စု",
      "khName": "តំបន់មឹរ៉ាយ៉ាម៉ាក់នៃខេត្ដយ៉ាម៉ាហ្គាតា",
      "neName": "यामागाता जिल्ला, मुरायामा क्षेत्र"
    },
    "class15": {
      "code": "060013",
      "name": "西村山",
      "enName": "Western Murayama"
    },
    "class20": {
      "code": "0632200",
      "name": "西川町",
      "enName": "Nishikawa Town",
      "kana": "にしかわまち",
      "chName": "西川町",
      "zhName": "西川町",
      "koName": "니시카와 정",
      "esName": "Pueblo de Nishikawa",
      "ptName": "bairro de Nishikawa",
      "thName": "เมืองนิชิคาวะ",
      "viName": "thị trấn Nishikawa",
      "inName": "kota Nishikawa",
      "tlName": "bayan ng Nishikawa",
      "moName": "Нишикава жижиг хот",
      "buName": "နီရှိကာ့ဝ မြို့နယ်",
      "khName": "ទីប្រជុំជន នីស៊ីកាវ៉ា",
      "neName": "निशिकावा नगर"
    }
  },
  "0632300": {
    "office": {
      "code": "060000",
      "name": "山形県",
      "enName": "Yamagata",
      "officeName": "山形地方気象台",
      "chName": "山形县",
      "zhName": "山形縣",
      "koName": "야마가타현",
      "esName": "Prefectura de Yamagata",
      "ptName": "Província de Yamagata",
      "thName": "จังหวัดยามางาตะ",
      "viName": "Tỉnh Yamagata",
      "inName": "Prefektur Yamagata",
      "tlName": "Yamagata Prefecture",
      "moName": "Ямагата аймаг",
      "buName": "ယာမာဂါတာ ပြည်နယ်",
      "khName": "ខេត្ដ យ៉ាម៉ាហ្គាតា",
      "neName": "यामागाता जिल्ला"
    },
    "class10": {
      "code": "060010",
      "name": "村山",
      "enName": "Murayama",
      "chName": "山形县村山地方",
      "zhName": "山形縣村山地方",
      "koName": "야마가타 현 무라야마 지방",
      "esName": "Región Murayama, Prefectura de Yamagata",
      "ptName": "Região de Murayama da Província de Yamagata",
      "thName": "ท้องถิ่นมุรายามะ จังหวัดยามางาตะ",
      "viName": "Vùng Murayama tỉnh Yamagata",
      "inName": "Daerah Murayama di Prefektur Yamagata",
      "tlName": "Rehiyon ng Murayama sa Yamagata Prefecture",
      "moName": "Ямагата аймаг, Мүраяма муж",
      "buName": "မုယယမဒေသ၊ ယမဂတစီရင်စု",
      "khName": "តំបន់មឹរ៉ាយ៉ាម៉ាក់នៃខេត្ដយ៉ាម៉ាហ្គាតា",
      "neName": "यामागाता जिल्ला, मुरायामा क्षेत्र"
    },
    "class15": {
      "code": "060013",
      "name": "西村山",
      "enName": "Western Murayama"
    },
    "class20": {
      "code": "0632300",
      "name": "朝日町",
      "enName": "Asahi Town",
      "kana": "あさひまち",
      "chName": "山形朝日町",
      "zhName": "山形朝日町",
      "koName": "야마가타 아사히 정",
      "esName": "Pueblo de Asahi, Yamagata",
      "ptName": "Yamagata, bairro de Asahi ",
      "thName": "เมืองอาซาฮิ ยามางาตะ",
      "viName": "Thị trấn Asahi, Yamagata",
      "inName": "Kota Asahi, Yamagata",
      "tlName": "bayan ng Asahi, Yamagata",
      "moName": "Ямагата Асахи жижиг хот",
      "buName": "ယမဂတဆဟိမြို့နယ် ",
      "khName": "ទីប្រជុំជនអាសាហ៊ី យ៉ាម៉ាហ្គាតា",
      "neName": "यामागाता आसाही नगर"
    }
  },
  "0632400": {
    "office": {
      "code": "060000",
      "name": "山形県",
      "enName": "Yamagata",
      "officeName": "山形地方気象台",
      "chName": "山形县",
      "zhName": "山形縣",
      "koName": "야마가타현",
      "esName": "Prefectura de Yamagata",
      "ptName": "Província de Yamagata",
      "thName": "จังหวัดยามางาตะ",
      "viName": "Tỉnh Yamagata",
      "inName": "Prefektur Yamagata",
      "tlName": "Yamagata Prefecture",
      "moName": "Ямагата аймаг",
      "buName": "ယာမာဂါတာ ပြည်နယ်",
      "khName": "ខេត្ដ យ៉ាម៉ាហ្គាតា",
      "neName": "यामागाता जिल्ला"
    },
    "class10": {
      "code": "060010",
      "name": "村山",
      "enName": "Murayama",
      "chName": "山形县村山地方",
      "zhName": "山形縣村山地方",
      "koName": "야마가타 현 무라야마 지방",
      "esName": "Región Murayama, Prefectura de Yamagata",
      "ptName": "Região de Murayama da Província de Yamagata",
      "thName": "ท้องถิ่นมุรายามะ จังหวัดยามางาตะ",
      "viName": "Vùng Murayama tỉnh Yamagata",
      "inName": "Daerah Murayama di Prefektur Yamagata",
      "tlName": "Rehiyon ng Murayama sa Yamagata Prefecture",
      "moName": "Ямагата аймаг, Мүраяма муж",
      "buName": "မုယယမဒေသ၊ ယမဂတစီရင်စု",
      "khName": "តំបន់មឹរ៉ាយ៉ាម៉ាក់នៃខេត្ដយ៉ាម៉ាហ្គាតា",
      "neName": "यामागाता जिल्ला, मुरायामा क्षेत्र"
    },
    "class15": {
      "code": "060013",
      "name": "西村山",
      "enName": "Western Murayama"
    },
    "class20": {
      "code": "0632400",
      "name": "大江町",
      "enName": "Oe Town",
      "kana": "おおえまち",
      "chName": "大江町",
      "zhName": "大江町",
      "koName": "오에 정",
      "esName": "Pueblo de Ōe",
      "ptName": "bairro de Oe",
      "thName": "เมืองโอเอะ",
      "viName": "thị trấn Oe",
      "inName": "kota Oe",
      "tlName": "bayan ng Oe",
      "moName": "Оэ жижиг хот",
      "buName": "အိုးယိ မြို့နယ်",
      "khName": "ទីប្រជុំជន អូ",
      "neName": "ओए नगर"
    }
  },
  "0634100": {
    "office": {
      "code": "060000",
      "name": "山形県",
      "enName": "Yamagata",
      "officeName": "山形地方気象台",
      "chName": "山形县",
      "zhName": "山形縣",
      "koName": "야마가타현",
      "esName": "Prefectura de Yamagata",
      "ptName": "Província de Yamagata",
      "thName": "จังหวัดยามางาตะ",
      "viName": "Tỉnh Yamagata",
      "inName": "Prefektur Yamagata",
      "tlName": "Yamagata Prefecture",
      "moName": "Ямагата аймаг",
      "buName": "ယာမာဂါတာ ပြည်နယ်",
      "khName": "ខេត្ដ យ៉ាម៉ាហ្គាតា",
      "neName": "यामागाता जिल्ला"
    },
    "class10": {
      "code": "060010",
      "name": "村山",
      "enName": "Murayama",
      "chName": "山形县村山地方",
      "zhName": "山形縣村山地方",
      "koName": "야마가타 현 무라야마 지방",
      "esName": "Región Murayama, Prefectura de Yamagata",
      "ptName": "Região de Murayama da Província de Yamagata",
      "thName": "ท้องถิ่นมุรายามะ จังหวัดยามางาตะ",
      "viName": "Vùng Murayama tỉnh Yamagata",
      "inName": "Daerah Murayama di Prefektur Yamagata",
      "tlName": "Rehiyon ng Murayama sa Yamagata Prefecture",
      "moName": "Ямагата аймаг, Мүраяма муж",
      "buName": "မုယယမဒေသ၊ ယမဂတစီရင်စု",
      "khName": "តំបន់មឹរ៉ាយ៉ាម៉ាក់នៃខេត្ដយ៉ាម៉ាហ្គាតា",
      "neName": "यामागाता जिल्ला, मुरायामा क्षेत्र"
    },
    "class15": {
      "code": "060012",
      "name": "北村山",
      "enName": "Northern Murayama"
    },
    "class20": {
      "code": "0634100",
      "name": "大石田町",
      "enName": "Oishida Town",
      "kana": "おおいしだまち",
      "chName": "大石田町",
      "zhName": "大石田町",
      "koName": "오이시다 정",
      "esName": "Pueblo de Ōishida",
      "ptName": "bairro de Oishida",
      "thName": "เมืองโออิชิดะ",
      "viName": "thị trấn Oishida",
      "inName": "kota Oishida",
      "tlName": "bayan ng Oishida",
      "moName": "Ойшида жижиг хот",
      "buName": "အိုယိရှိဒ မြို့နယ်",
      "khName": "ទីប្រជុំជន អយស៊ីដា",
      "neName": "ओइशिदा नगर"
    }
  },
  "0636100": {
    "office": {
      "code": "060000",
      "name": "山形県",
      "enName": "Yamagata",
      "officeName": "山形地方気象台",
      "chName": "山形县",
      "zhName": "山形縣",
      "koName": "야마가타현",
      "esName": "Prefectura de Yamagata",
      "ptName": "Província de Yamagata",
      "thName": "จังหวัดยามางาตะ",
      "viName": "Tỉnh Yamagata",
      "inName": "Prefektur Yamagata",
      "tlName": "Yamagata Prefecture",
      "moName": "Ямагата аймаг",
      "buName": "ယာမာဂါတာ ပြည်နယ်",
      "khName": "ខេត្ដ យ៉ាម៉ាហ្គាតា",
      "neName": "यामागाता जिल्ला"
    },
    "class10": {
      "code": "060040",
      "name": "最上",
      "enName": "Mogami",
      "chName": "山形县最上地方",
      "zhName": "山形縣最上地方",
      "koName": "야마가타현 모가미 지방",
      "esName": "Región Mogami, Prefectura de Yamagata",
      "ptName": "Região de Mogami da Província de Yamagata",
      "thName": "ท้องถิ่นโมะงามิ จังหวัดยามางาตะ",
      "viName": "Vùng Mogami tỉnh Yamagata",
      "inName": "Daerah Mogami di Prefektur Yamagata",
      "tlName": "Rehiyon ng Mogami sa Yamagata Prefecture",
      "moName": "Ямагата аймаг, Могами муж",
      "buName": "မိုဂမိဒေသ၊ ယမဂတစီရင်စု",
      "khName": "តំបន់ម៉ូហ្កាមីនៃខេត្ដយ៉ាម៉ាហ្គាតា",
      "neName": "यामागाता जिल्ला, मोगामी क्षेत्र"
    },
    "class15": {
      "code": "060040",
      "name": "最上",
      "enName": "Mogami"
    },
    "class20": {
      "code": "0636100",
      "name": "金山町",
      "enName": "Kaneyama Town",
      "kana": "かねやままち",
      "chName": "山形金山町",
      "zhName": "山形金山町",
      "koName": "야마가타 가네야마 정",
      "esName": "Pueblo de Kaneyama, Yamagata",
      "ptName": "Yamagata, bairro de Kaneyama",
      "thName": "เมืองคาเนยามะ ยามางาตะ",
      "viName": "Thị trấn Kaneyama, Yamagata",
      "inName": "Kota Kaneyama, Yamagata",
      "tlName": "bayan ng Kaneyama, Yamagata",
      "moName": "Ямагатата Канэяма жижиг хот",
      "buName": "ယမဂတခနဲယမမြို့နယ် ",
      "khName": "ទីប្រជុំជនកាណេយ៉ាម៉ា យ៉ាម៉ាហ្គាតា",
      "neName": "यामागाता कानेयामा नगर"
    }
  },
  "0636200": {
    "office": {
      "code": "060000",
      "name": "山形県",
      "enName": "Yamagata",
      "officeName": "山形地方気象台",
      "chName": "山形县",
      "zhName": "山形縣",
      "koName": "야마가타현",
      "esName": "Prefectura de Yamagata",
      "ptName": "Província de Yamagata",
      "thName": "จังหวัดยามางาตะ",
      "viName": "Tỉnh Yamagata",
      "inName": "Prefektur Yamagata",
      "tlName": "Yamagata Prefecture",
      "moName": "Ямагата аймаг",
      "buName": "ယာမာဂါတာ ပြည်နယ်",
      "khName": "ខេត្ដ យ៉ាម៉ាហ្គាតា",
      "neName": "यामागाता जिल्ला"
    },
    "class10": {
      "code": "060040",
      "name": "最上",
      "enName": "Mogami",
      "chName": "山形县最上地方",
      "zhName": "山形縣最上地方",
      "koName": "야마가타현 모가미 지방",
      "esName": "Región Mogami, Prefectura de Yamagata",
      "ptName": "Região de Mogami da Província de Yamagata",
      "thName": "ท้องถิ่นโมะงามิ จังหวัดยามางาตะ",
      "viName": "Vùng Mogami tỉnh Yamagata",
      "inName": "Daerah Mogami di Prefektur Yamagata",
      "tlName": "Rehiyon ng Mogami sa Yamagata Prefecture",
      "moName": "Ямагата аймаг, Могами муж",
      "buName": "မိုဂမိဒေသ၊ ယမဂတစီရင်စု",
      "khName": "តំបន់ម៉ូហ្កាមីនៃខេត្ដយ៉ាម៉ាហ្គាតា",
      "neName": "यामागाता जिल्ला, मोगामी क्षेत्र"
    },
    "class15": {
      "code": "060040",
      "name": "最上",
      "enName": "Mogami"
    },
    "class20": {
      "code": "0636200",
      "name": "最上町",
      "enName": "Mogami Town",
      "kana": "もがみまち",
      "chName": "最上町",
      "zhName": "最上町",
      "koName": "모가미 정",
      "esName": "Pueblo de Mogami",
      "ptName": "bairro de Mogami",
      "thName": "เมืองโมงามิ",
      "viName": "thị trấn Mogami",
      "inName": "kota Mogami",
      "tlName": "bayan ng Mogami",
      "moName": "Могaми жижиг хот",
      "buName": "မိုဂါ့မိ မြို့နယ်",
      "khName": "ទីប្រជុំជន ម៉ូហ្កាមី",
      "neName": "मोगामी नगर"
    }
  },
  "0636300": {
    "office": {
      "code": "060000",
      "name": "山形県",
      "enName": "Yamagata",
      "officeName": "山形地方気象台",
      "chName": "山形县",
      "zhName": "山形縣",
      "koName": "야마가타현",
      "esName": "Prefectura de Yamagata",
      "ptName": "Província de Yamagata",
      "thName": "จังหวัดยามางาตะ",
      "viName": "Tỉnh Yamagata",
      "inName": "Prefektur Yamagata",
      "tlName": "Yamagata Prefecture",
      "moName": "Ямагата аймаг",
      "buName": "ယာမာဂါတာ ပြည်နယ်",
      "khName": "ខេត្ដ យ៉ាម៉ាហ្គាតា",
      "neName": "यामागाता जिल्ला"
    },
    "class10": {
      "code": "060040",
      "name": "最上",
      "enName": "Mogami",
      "chName": "山形县最上地方",
      "zhName": "山形縣最上地方",
      "koName": "야마가타현 모가미 지방",
      "esName": "Región Mogami, Prefectura de Yamagata",
      "ptName": "Região de Mogami da Província de Yamagata",
      "thName": "ท้องถิ่นโมะงามิ จังหวัดยามางาตะ",
      "viName": "Vùng Mogami tỉnh Yamagata",
      "inName": "Daerah Mogami di Prefektur Yamagata",
      "tlName": "Rehiyon ng Mogami sa Yamagata Prefecture",
      "moName": "Ямагата аймаг, Могами муж",
      "buName": "မိုဂမိဒေသ၊ ယမဂတစီရင်စု",
      "khName": "តំបន់ម៉ូហ្កាមីនៃខេត្ដយ៉ាម៉ាហ្គាតា",
      "neName": "यामागाता जिल्ला, मोगामी क्षेत्र"
    },
    "class15": {
      "code": "060040",
      "name": "最上",
      "enName": "Mogami"
    },
    "class20": {
      "code": "0636300",
      "name": "舟形町",
      "enName": "Funagata Town",
      "kana": "ふながたまち",
      "chName": "舟形町",
      "zhName": "舟形町",
      "koName": "후나가타 정",
      "esName": "Pueblo de Funagata",
      "ptName": "bairro de Funagata",
      "thName": "เมืองฟุนางาตะ",
      "viName": "thị trấn Funagata",
      "inName": "kota Funagata",
      "tlName": "bayan ng Funagata",
      "moName": "Фүнaгaта жижиг хот",
      "buName": "ဖူနားဂါ့တ မြို့နယ်",
      "khName": "ទីប្រជុំជន ហ្វូណាហ្គាតា",
      "neName": "फुनागाता नगर"
    }
  },
  "0636400": {
    "office": {
      "code": "060000",
      "name": "山形県",
      "enName": "Yamagata",
      "officeName": "山形地方気象台",
      "chName": "山形县",
      "zhName": "山形縣",
      "koName": "야마가타현",
      "esName": "Prefectura de Yamagata",
      "ptName": "Província de Yamagata",
      "thName": "จังหวัดยามางาตะ",
      "viName": "Tỉnh Yamagata",
      "inName": "Prefektur Yamagata",
      "tlName": "Yamagata Prefecture",
      "moName": "Ямагата аймаг",
      "buName": "ယာမာဂါတာ ပြည်နယ်",
      "khName": "ខេត្ដ យ៉ាម៉ាហ្គាតា",
      "neName": "यामागाता जिल्ला"
    },
    "class10": {
      "code": "060040",
      "name": "最上",
      "enName": "Mogami",
      "chName": "山形县最上地方",
      "zhName": "山形縣最上地方",
      "koName": "야마가타현 모가미 지방",
      "esName": "Región Mogami, Prefectura de Yamagata",
      "ptName": "Região de Mogami da Província de Yamagata",
      "thName": "ท้องถิ่นโมะงามิ จังหวัดยามางาตะ",
      "viName": "Vùng Mogami tỉnh Yamagata",
      "inName": "Daerah Mogami di Prefektur Yamagata",
      "tlName": "Rehiyon ng Mogami sa Yamagata Prefecture",
      "moName": "Ямагата аймаг, Могами муж",
      "buName": "မိုဂမိဒေသ၊ ယမဂတစီရင်စု",
      "khName": "តំបន់ម៉ូហ្កាមីនៃខេត្ដយ៉ាម៉ាហ្គាតា",
      "neName": "यामागाता जिल्ला, मोगामी क्षेत्र"
    },
    "class15": {
      "code": "060040",
      "name": "最上",
      "enName": "Mogami"
    },
    "class20": {
      "code": "0636400",
      "name": "真室川町",
      "enName": "Mamurogawa Town",
      "kana": "まむろがわまち",
      "chName": "真室川町",
      "zhName": "真室川町",
      "koName": "마무로가와 정",
      "esName": "Pueblo de Mamurogawa",
      "ptName": "bairro de Mamurogawa",
      "thName": "เมืองมารุโระงาวะ",
      "viName": "thị trấn Mamurogawa",
      "inName": "kota Mamurogawa",
      "tlName": "bayan ng Mamurogawa",
      "moName": "Мaмүрогава жижиг хот",
      "buName": "မာမူးရိုးဂါ့ဝ မြို့နယ်",
      "khName": "ទីប្រជុំជន ម៉ាមមូរ៉ូហ្កាវ៉ា",
      "neName": "मामुरोगावा नगर"
    }
  },
  "0636500": {
    "office": {
      "code": "060000",
      "name": "山形県",
      "enName": "Yamagata",
      "officeName": "山形地方気象台",
      "chName": "山形县",
      "zhName": "山形縣",
      "koName": "야마가타현",
      "esName": "Prefectura de Yamagata",
      "ptName": "Província de Yamagata",
      "thName": "จังหวัดยามางาตะ",
      "viName": "Tỉnh Yamagata",
      "inName": "Prefektur Yamagata",
      "tlName": "Yamagata Prefecture",
      "moName": "Ямагата аймаг",
      "buName": "ယာမာဂါတာ ပြည်နယ်",
      "khName": "ខេត្ដ យ៉ាម៉ាហ្គាតា",
      "neName": "यामागाता जिल्ला"
    },
    "class10": {
      "code": "060040",
      "name": "最上",
      "enName": "Mogami",
      "chName": "山形县最上地方",
      "zhName": "山形縣最上地方",
      "koName": "야마가타현 모가미 지방",
      "esName": "Región Mogami, Prefectura de Yamagata",
      "ptName": "Região de Mogami da Província de Yamagata",
      "thName": "ท้องถิ่นโมะงามิ จังหวัดยามางาตะ",
      "viName": "Vùng Mogami tỉnh Yamagata",
      "inName": "Daerah Mogami di Prefektur Yamagata",
      "tlName": "Rehiyon ng Mogami sa Yamagata Prefecture",
      "moName": "Ямагата аймаг, Могами муж",
      "buName": "မိုဂမိဒေသ၊ ယမဂတစီရင်စု",
      "khName": "តំបន់ម៉ូហ្កាមីនៃខេត្ដយ៉ាម៉ាហ្គាតា",
      "neName": "यामागाता जिल्ला, मोगामी क्षेत्र"
    },
    "class15": {
      "code": "060040",
      "name": "最上",
      "enName": "Mogami"
    },
    "class20": {
      "code": "0636500",
      "name": "大蔵村",
      "enName": "Okura Village",
      "kana": "おおくらむら",
      "chName": "大藏村",
      "zhName": "大藏村",
      "koName": "오쿠라 촌",
      "esName": "Aldea de Ōkura",
      "ptName": "povoado de Okura",
      "thName": "หมู่บ้านโอคุระ",
      "viName": "làng Okura",
      "inName": "desa Okura",
      "tlName": "nayon ng Okura",
      "moName": "Окүра тосгон",
      "buName": "အိုးကုရာ့ ကျေးရွာ",
      "khName": "ភូមិ អូគូរ៉ា",
      "neName": "ओकुरा गाउँ"
    }
  },
  "0636600": {
    "office": {
      "code": "060000",
      "name": "山形県",
      "enName": "Yamagata",
      "officeName": "山形地方気象台",
      "chName": "山形县",
      "zhName": "山形縣",
      "koName": "야마가타현",
      "esName": "Prefectura de Yamagata",
      "ptName": "Província de Yamagata",
      "thName": "จังหวัดยามางาตะ",
      "viName": "Tỉnh Yamagata",
      "inName": "Prefektur Yamagata",
      "tlName": "Yamagata Prefecture",
      "moName": "Ямагата аймаг",
      "buName": "ယာမာဂါတာ ပြည်နယ်",
      "khName": "ខេត្ដ យ៉ាម៉ាហ្គាតា",
      "neName": "यामागाता जिल्ला"
    },
    "class10": {
      "code": "060040",
      "name": "最上",
      "enName": "Mogami",
      "chName": "山形县最上地方",
      "zhName": "山形縣最上地方",
      "koName": "야마가타현 모가미 지방",
      "esName": "Región Mogami, Prefectura de Yamagata",
      "ptName": "Região de Mogami da Província de Yamagata",
      "thName": "ท้องถิ่นโมะงามิ จังหวัดยามางาตะ",
      "viName": "Vùng Mogami tỉnh Yamagata",
      "inName": "Daerah Mogami di Prefektur Yamagata",
      "tlName": "Rehiyon ng Mogami sa Yamagata Prefecture",
      "moName": "Ямагата аймаг, Могами муж",
      "buName": "မိုဂမိဒေသ၊ ယမဂတစီရင်စု",
      "khName": "តំបន់ម៉ូហ្កាមីនៃខេត្ដយ៉ាម៉ាហ្គាតា",
      "neName": "यामागाता जिल्ला, मोगामी क्षेत्र"
    },
    "class15": {
      "code": "060040",
      "name": "最上",
      "enName": "Mogami"
    },
    "class20": {
      "code": "0636600",
      "name": "鮭川村",
      "enName": "Sakegawa Village",
      "kana": "さけがわむら",
      "chName": "鲑川村",
      "zhName": "鮭川村",
      "koName": "사케가와 촌",
      "esName": "Aldea de Sakegawa",
      "ptName": "povoado de Sakegawa",
      "thName": "หมู่บ้านซาเคกาวา",
      "viName": "làng Sakegawa",
      "inName": "desa Sakegawa",
      "tlName": "nayon ng Sakegawa",
      "moName": "Сaкэгава тосгон",
      "buName": "ဆာကေးဂါ့ဝ ကျေးရွာ",
      "khName": "ភូមិ សាកេហ្កាវ៉ា",
      "neName": "साकेगावा गाउँ"
    }
  },
  "0636700": {
    "office": {
      "code": "060000",
      "name": "山形県",
      "enName": "Yamagata",
      "officeName": "山形地方気象台",
      "chName": "山形县",
      "zhName": "山形縣",
      "koName": "야마가타현",
      "esName": "Prefectura de Yamagata",
      "ptName": "Província de Yamagata",
      "thName": "จังหวัดยามางาตะ",
      "viName": "Tỉnh Yamagata",
      "inName": "Prefektur Yamagata",
      "tlName": "Yamagata Prefecture",
      "moName": "Ямагата аймаг",
      "buName": "ယာမာဂါတာ ပြည်နယ်",
      "khName": "ខេត្ដ យ៉ាម៉ាហ្គាតា",
      "neName": "यामागाता जिल्ला"
    },
    "class10": {
      "code": "060040",
      "name": "最上",
      "enName": "Mogami",
      "chName": "山形县最上地方",
      "zhName": "山形縣最上地方",
      "koName": "야마가타현 모가미 지방",
      "esName": "Región Mogami, Prefectura de Yamagata",
      "ptName": "Região de Mogami da Província de Yamagata",
      "thName": "ท้องถิ่นโมะงามิ จังหวัดยามางาตะ",
      "viName": "Vùng Mogami tỉnh Yamagata",
      "inName": "Daerah Mogami di Prefektur Yamagata",
      "tlName": "Rehiyon ng Mogami sa Yamagata Prefecture",
      "moName": "Ямагата аймаг, Могами муж",
      "buName": "မိုဂမိဒေသ၊ ယမဂတစီရင်စု",
      "khName": "តំបន់ម៉ូហ្កាមីនៃខេត្ដយ៉ាម៉ាហ្គាតា",
      "neName": "यामागाता जिल्ला, मोगामी क्षेत्र"
    },
    "class15": {
      "code": "060040",
      "name": "最上",
      "enName": "Mogami"
    },
    "class20": {
      "code": "0636700",
      "name": "戸沢村",
      "enName": "Tozawa Village",
      "kana": "とざわむら",
      "chName": "户泽村",
      "zhName": "戶澤村",
      "koName": "도자와 촌",
      "esName": "Aldea de Tozawa",
      "ptName": "povoado de Tozawa",
      "thName": "หมู่บ้านโทซาวะ",
      "viName": "làng Tozawa",
      "inName": "desa Tozawa",
      "tlName": "nayon ng Tozawa",
      "moName": "Тозава тосгон",
      "buName": "တိုဇာ့ဝ ကျေးရွာ",
      "khName": "ភូមិ តូហ្សាវ៉ា",
      "neName": "तोजावा गाउँ"
    }
  },
  "0638100": {
    "office": {
      "code": "060000",
      "name": "山形県",
      "enName": "Yamagata",
      "officeName": "山形地方気象台",
      "chName": "山形县",
      "zhName": "山形縣",
      "koName": "야마가타현",
      "esName": "Prefectura de Yamagata",
      "ptName": "Província de Yamagata",
      "thName": "จังหวัดยามางาตะ",
      "viName": "Tỉnh Yamagata",
      "inName": "Prefektur Yamagata",
      "tlName": "Yamagata Prefecture",
      "moName": "Ямагата аймаг",
      "buName": "ယာမာဂါတာ ပြည်နယ်",
      "khName": "ខេត្ដ យ៉ាម៉ាហ្គាតា",
      "neName": "यामागाता जिल्ला"
    },
    "class10": {
      "code": "060020",
      "name": "置賜",
      "enName": "Okitama",
      "chName": "山形县置赐地方",
      "zhName": "山形縣置賜地方",
      "koName": "야마가타 현 오키 타마 지방",
      "esName": "Región Okitama, Prefectura de Yamagata",
      "ptName": "Região de Okitama da Província de Yamagata",
      "thName": "ท้องถิ่นโอกิตามะ จังหวัดยามางาตะ",
      "viName": "Vùng Okitama tỉnh Yamagata",
      "inName": "Daerah Okitama di Prefektur Yamagata",
      "tlName": "Rehiyon ng Okitama sa Yamagata Prefecture",
      "moName": "Ямагата аймаг, Окитама муж",
      "buName": "အိုခိတမဒေသ၊ ယမဂတစီရင်စု",
      "khName": "តំបនអូគីតាម៉ា់នៃខេត្ដយ៉ាម៉ាហ្គាតា",
      "neName": "यामागाता जिल्ला, ओकितामा क्षेत्र"
    },
    "class15": {
      "code": "060021",
      "name": "東南置賜",
      "enName": "South-eastern Okitama"
    },
    "class20": {
      "code": "0638100",
      "name": "高畠町",
      "enName": "Takahata Town",
      "kana": "たかはたまち",
      "chName": "高畠町",
      "zhName": "髙畠町",
      "koName": "다카하타 정",
      "esName": "Pueblo de Takahata",
      "ptName": "bairro de Takahata",
      "thName": "เมืองทากาฮาตะ",
      "viName": "thị trấn Takahata",
      "inName": "kota Takahata",
      "tlName": "bayan ng Takahata",
      "moName": "Такахaта жижиг хот",
      "buName": "တာကားဟာ့တ မြို့နယ်",
      "khName": "ទីប្រជុំជន តាកាហាតា",
      "neName": "ताकाहाता नगर"
    }
  },
  "0638200": {
    "office": {
      "code": "060000",
      "name": "山形県",
      "enName": "Yamagata",
      "officeName": "山形地方気象台",
      "chName": "山形县",
      "zhName": "山形縣",
      "koName": "야마가타현",
      "esName": "Prefectura de Yamagata",
      "ptName": "Província de Yamagata",
      "thName": "จังหวัดยามางาตะ",
      "viName": "Tỉnh Yamagata",
      "inName": "Prefektur Yamagata",
      "tlName": "Yamagata Prefecture",
      "moName": "Ямагата аймаг",
      "buName": "ယာမာဂါတာ ပြည်နယ်",
      "khName": "ខេត្ដ យ៉ាម៉ាហ្គាតា",
      "neName": "यामागाता जिल्ला"
    },
    "class10": {
      "code": "060020",
      "name": "置賜",
      "enName": "Okitama",
      "chName": "山形县置赐地方",
      "zhName": "山形縣置賜地方",
      "koName": "야마가타 현 오키 타마 지방",
      "esName": "Región Okitama, Prefectura de Yamagata",
      "ptName": "Região de Okitama da Província de Yamagata",
      "thName": "ท้องถิ่นโอกิตามะ จังหวัดยามางาตะ",
      "viName": "Vùng Okitama tỉnh Yamagata",
      "inName": "Daerah Okitama di Prefektur Yamagata",
      "tlName": "Rehiyon ng Okitama sa Yamagata Prefecture",
      "moName": "Ямагата аймаг, Окитама муж",
      "buName": "အိုခိတမဒေသ၊ ယမဂတစီရင်စု",
      "khName": "តំបនអូគីតាម៉ា់នៃខេត្ដយ៉ាម៉ាហ្គាតា",
      "neName": "यामागाता जिल्ला, ओकितामा क्षेत्र"
    },
    "class15": {
      "code": "060021",
      "name": "東南置賜",
      "enName": "South-eastern Okitama"
    },
    "class20": {
      "code": "0638200",
      "name": "川西町",
      "enName": "Kawanishi Town",
      "kana": "かわにしまち",
      "chName": "山形川西町",
      "zhName": "山形川西町",
      "koName": "야마가타 가와니시 정",
      "esName": "Pueblo de Kawanishi, Yamagata",
      "ptName": "Yamagata, bairro de Kawanishi",
      "thName": "เมืองคาวานิชิ ยามางาตะ",
      "viName": "Thị trấn Kawanishi, Yamagata",
      "inName": "Kota Kawanishi, Yamagata",
      "tlName": "bayan ng Kawanishi, Yamagata",
      "moName": "Ямагата Каваниши жижиг хот",
      "buName": "ယမဂတကဝနိရှိမြို့နယ် ",
      "khName": "ទីប្រជុំជនកាវ៉ានីស៊ី យ៉ាម៉ាហ្គាតា",
      "neName": "यामागाता कावानिशी नगर"
    }
  },
  "0640100": {
    "office": {
      "code": "060000",
      "name": "山形県",
      "enName": "Yamagata",
      "officeName": "山形地方気象台",
      "chName": "山形县",
      "zhName": "山形縣",
      "koName": "야마가타현",
      "esName": "Prefectura de Yamagata",
      "ptName": "Província de Yamagata",
      "thName": "จังหวัดยามางาตะ",
      "viName": "Tỉnh Yamagata",
      "inName": "Prefektur Yamagata",
      "tlName": "Yamagata Prefecture",
      "moName": "Ямагата аймаг",
      "buName": "ယာမာဂါတာ ပြည်နယ်",
      "khName": "ខេត្ដ យ៉ាម៉ាហ្គាតា",
      "neName": "यामागाता जिल्ला"
    },
    "class10": {
      "code": "060020",
      "name": "置賜",
      "enName": "Okitama",
      "chName": "山形县置赐地方",
      "zhName": "山形縣置賜地方",
      "koName": "야마가타 현 오키 타마 지방",
      "esName": "Región Okitama, Prefectura de Yamagata",
      "ptName": "Região de Okitama da Província de Yamagata",
      "thName": "ท้องถิ่นโอกิตามะ จังหวัดยามางาตะ",
      "viName": "Vùng Okitama tỉnh Yamagata",
      "inName": "Daerah Okitama di Prefektur Yamagata",
      "tlName": "Rehiyon ng Okitama sa Yamagata Prefecture",
      "moName": "Ямагата аймаг, Окитама муж",
      "buName": "အိုခိတမဒေသ၊ ယမဂတစီရင်စု",
      "khName": "តំបនអូគីតាម៉ា់នៃខេត្ដយ៉ាម៉ាហ្គាតា",
      "neName": "यामागाता जिल्ला, ओकितामा क्षेत्र"
    },
    "class15": {
      "code": "060022",
      "name": "西置賜",
      "enName": "Western Okitama"
    },
    "class20": {
      "code": "0640100",
      "name": "小国町",
      "enName": "Oguni Town",
      "kana": "おぐにまち",
      "chName": "山形小国町",
      "zhName": "山形小國町",
      "koName": "야마가타 오구니 정",
      "esName": "Pueblo de Oguni, Yamagata",
      "ptName": "Yamagata, bairro de Oguni",
      "thName": "เมืองโองุนิ ยามางาตะ",
      "viName": "Thị trấn Oguni, Yamagata",
      "inName": "Kota Oguni, Yamagata",
      "tlName": "bayan ng Oguni, Yamagata",
      "moName": "Ямагата Огүни жижиг хот",
      "buName": "ယမဂတအိုဂုနိမြို့နယ် ",
      "khName": "ទីប្រជុំជនអូគឹនិ យ៉ាម៉ាហ្គាតា",
      "neName": "यामागाता ओगुनि नगर"
    }
  },
  "0640200": {
    "office": {
      "code": "060000",
      "name": "山形県",
      "enName": "Yamagata",
      "officeName": "山形地方気象台",
      "chName": "山形县",
      "zhName": "山形縣",
      "koName": "야마가타현",
      "esName": "Prefectura de Yamagata",
      "ptName": "Província de Yamagata",
      "thName": "จังหวัดยามางาตะ",
      "viName": "Tỉnh Yamagata",
      "inName": "Prefektur Yamagata",
      "tlName": "Yamagata Prefecture",
      "moName": "Ямагата аймаг",
      "buName": "ယာမာဂါတာ ပြည်နယ်",
      "khName": "ខេត្ដ យ៉ាម៉ាហ្គាតា",
      "neName": "यामागाता जिल्ला"
    },
    "class10": {
      "code": "060020",
      "name": "置賜",
      "enName": "Okitama",
      "chName": "山形县置赐地方",
      "zhName": "山形縣置賜地方",
      "koName": "야마가타 현 오키 타마 지방",
      "esName": "Región Okitama, Prefectura de Yamagata",
      "ptName": "Região de Okitama da Província de Yamagata",
      "thName": "ท้องถิ่นโอกิตามะ จังหวัดยามางาตะ",
      "viName": "Vùng Okitama tỉnh Yamagata",
      "inName": "Daerah Okitama di Prefektur Yamagata",
      "tlName": "Rehiyon ng Okitama sa Yamagata Prefecture",
      "moName": "Ямагата аймаг, Окитама муж",
      "buName": "အိုခိတမဒေသ၊ ယမဂတစီရင်စု",
      "khName": "តំបនអូគីតាម៉ា់នៃខេត្ដយ៉ាម៉ាហ្គាតា",
      "neName": "यामागाता जिल्ला, ओकितामा क्षेत्र"
    },
    "class15": {
      "code": "060022",
      "name": "西置賜",
      "enName": "Western Okitama"
    },
    "class20": {
      "code": "0640200",
      "name": "白鷹町",
      "enName": "Shirataka Town",
      "kana": "しらたかまち",
      "chName": "白鹰町",
      "zhName": "白鷹町",
      "koName": "시라타카 정",
      "esName": "Pueblo de Shirataka",
      "ptName": "bairro de Shirataka",
      "thName": "เมืองชิราทากะ",
      "viName": "thị trấn Shirataka",
      "inName": "kota Shirataka",
      "tlName": "bayan ng Shirataka",
      "moName": "Ширатака жижиг хот",
      "buName": "ရှီရာတာ့က မြို့နယ်",
      "khName": "ទីប្រជុំជន ស៊ីរ៉ាតាកា",
      "neName": "शिराताका नगर"
    }
  },
  "0640300": {
    "office": {
      "code": "060000",
      "name": "山形県",
      "enName": "Yamagata",
      "officeName": "山形地方気象台",
      "chName": "山形县",
      "zhName": "山形縣",
      "koName": "야마가타현",
      "esName": "Prefectura de Yamagata",
      "ptName": "Província de Yamagata",
      "thName": "จังหวัดยามางาตะ",
      "viName": "Tỉnh Yamagata",
      "inName": "Prefektur Yamagata",
      "tlName": "Yamagata Prefecture",
      "moName": "Ямагата аймаг",
      "buName": "ယာမာဂါတာ ပြည်နယ်",
      "khName": "ខេត្ដ យ៉ាម៉ាហ្គាតា",
      "neName": "यामागाता जिल्ला"
    },
    "class10": {
      "code": "060020",
      "name": "置賜",
      "enName": "Okitama",
      "chName": "山形县置赐地方",
      "zhName": "山形縣置賜地方",
      "koName": "야마가타 현 오키 타마 지방",
      "esName": "Región Okitama, Prefectura de Yamagata",
      "ptName": "Região de Okitama da Província de Yamagata",
      "thName": "ท้องถิ่นโอกิตามะ จังหวัดยามางาตะ",
      "viName": "Vùng Okitama tỉnh Yamagata",
      "inName": "Daerah Okitama di Prefektur Yamagata",
      "tlName": "Rehiyon ng Okitama sa Yamagata Prefecture",
      "moName": "Ямагата аймаг, Окитама муж",
      "buName": "အိုခိတမဒေသ၊ ယမဂတစီရင်စု",
      "khName": "តំបនអូគីតាម៉ា់នៃខេត្ដយ៉ាម៉ាហ្គាតា",
      "neName": "यामागाता जिल्ला, ओकितामा क्षेत्र"
    },
    "class15": {
      "code": "060022",
      "name": "西置賜",
      "enName": "Western Okitama"
    },
    "class20": {
      "code": "0640300",
      "name": "飯豊町",
      "enName": "Iide Town",
      "kana": "いいでまち",
      "chName": "饭丰町",
      "zhName": "飯豐町",
      "koName": "이데 정",
      "esName": "Pueblo de Iide",
      "ptName": "bairro de Iide",
      "thName": "เมืองอิเดะ",
      "viName": "thị trấn Iide",
      "inName": "kota Iide",
      "tlName": "bayan ng Iide",
      "moName": "Ийдэ жижиг хот",
      "buName": "အီးဒဲ့ မြို့နယ်",
      "khName": "ទីប្រជុំជន អ៊ីអ៊ីដេ",
      "neName": "आइदे नगर"
    }
  },
  "0642600": {
    "office": {
      "code": "060000",
      "name": "山形県",
      "enName": "Yamagata",
      "officeName": "山形地方気象台",
      "chName": "山形县",
      "zhName": "山形縣",
      "koName": "야마가타현",
      "esName": "Prefectura de Yamagata",
      "ptName": "Província de Yamagata",
      "thName": "จังหวัดยามางาตะ",
      "viName": "Tỉnh Yamagata",
      "inName": "Prefektur Yamagata",
      "tlName": "Yamagata Prefecture",
      "moName": "Ямагата аймаг",
      "buName": "ယာမာဂါတာ ပြည်နယ်",
      "khName": "ខេត្ដ យ៉ាម៉ាហ្គាតា",
      "neName": "यामागाता जिल्ला"
    },
    "class10": {
      "code": "060030",
      "name": "庄内",
      "enName": "Shonai",
      "chName": "山形县庄内地方",
      "zhName": "山形縣莊內地方",
      "koName": "야마가타 현 쇼나이 지방",
      "esName": "Región Shonai, Prefectura de Yamagata",
      "ptName": "Região de Shōnai da Província de Yamagata",
      "thName": "ท้องถิ่นโชไน จังหวัดยามางาตะ",
      "viName": "Vùng Shonai tỉnh Yamagata",
      "inName": "Daerah Shonai di Prefektur Yamagata",
      "tlName": "Rehiyon ng Shonai sa Yamagata Prefecture",
      "moName": "Ямагата аймаг, Шонай муж",
      "buName": "ရိုနိုင်းဒေသ၊ ယမဂတစီရင်စု",
      "khName": "តំបន់ស្យូណៃនៃខេត្ដយ៉ាម៉ាហ្គាតា",
      "neName": "यामागाता जिल्ला, स्योनाइ क्षेत्र"
    },
    "class15": {
      "code": "060032",
      "name": "庄内南部",
      "enName": "Southern Shonai"
    },
    "class20": {
      "code": "0642600",
      "name": "三川町",
      "enName": "Mikawa Town",
      "kana": "みかわまち",
      "chName": "三川町",
      "zhName": "三川町",
      "koName": "미카와 정",
      "esName": "Pueblo de Mikawa",
      "ptName": "bairro de Mikawa",
      "thName": "เมืองมิคาวะ",
      "viName": "thị trấn Mikawa",
      "inName": "kota Mikawa",
      "tlName": "bayan ng Mikawa",
      "moName": "Микава жижиг хот",
      "buName": "မီကာ့ဝ မြို့နယ်",
      "khName": "ទីប្រជុំជន មីកាវ៉ា",
      "neName": "मिकावा नगर"
    }
  },
  "0642800": {
    "office": {
      "code": "060000",
      "name": "山形県",
      "enName": "Yamagata",
      "officeName": "山形地方気象台",
      "chName": "山形县",
      "zhName": "山形縣",
      "koName": "야마가타현",
      "esName": "Prefectura de Yamagata",
      "ptName": "Província de Yamagata",
      "thName": "จังหวัดยามางาตะ",
      "viName": "Tỉnh Yamagata",
      "inName": "Prefektur Yamagata",
      "tlName": "Yamagata Prefecture",
      "moName": "Ямагата аймаг",
      "buName": "ယာမာဂါတာ ပြည်နယ်",
      "khName": "ខេត្ដ យ៉ាម៉ាហ្គាតា",
      "neName": "यामागाता जिल्ला"
    },
    "class10": {
      "code": "060030",
      "name": "庄内",
      "enName": "Shonai",
      "chName": "山形县庄内地方",
      "zhName": "山形縣莊內地方",
      "koName": "야마가타 현 쇼나이 지방",
      "esName": "Región Shonai, Prefectura de Yamagata",
      "ptName": "Região de Shōnai da Província de Yamagata",
      "thName": "ท้องถิ่นโชไน จังหวัดยามางาตะ",
      "viName": "Vùng Shonai tỉnh Yamagata",
      "inName": "Daerah Shonai di Prefektur Yamagata",
      "tlName": "Rehiyon ng Shonai sa Yamagata Prefecture",
      "moName": "Ямагата аймаг, Шонай муж",
      "buName": "ရိုနိုင်းဒေသ၊ ယမဂတစီရင်စု",
      "khName": "តំបន់ស្យូណៃនៃខេត្ដយ៉ាម៉ាហ្គាតា",
      "neName": "यामागाता जिल्ला, स्योनाइ क्षेत्र"
    },
    "class15": {
      "code": "060032",
      "name": "庄内南部",
      "enName": "Southern Shonai"
    },
    "class20": {
      "code": "0642800",
      "name": "庄内町",
      "enName": "Shonai Town",
      "kana": "しょうないまち",
      "chName": "庄内町",
      "zhName": "庄內町",
      "koName": "쇼나이 정",
      "esName": "Pueblo de Shōnai",
      "ptName": "bairro de Shonai",
      "thName": "เมืองโชนาอิ",
      "viName": "thị trấn Shonai",
      "inName": "kota Shonai",
      "tlName": "bayan ng Shonai",
      "moName": "Шонaй жижиг хот",
      "buName": "ရှိုးနာ့ယိ မြို့နယ်",
      "khName": "ទីប្រជុំជន សូណៃ",
      "neName": "शोनाइ नगर"
    }
  },
  "0646100": {
    "office": {
      "code": "060000",
      "name": "山形県",
      "enName": "Yamagata",
      "officeName": "山形地方気象台",
      "chName": "山形县",
      "zhName": "山形縣",
      "koName": "야마가타현",
      "esName": "Prefectura de Yamagata",
      "ptName": "Província de Yamagata",
      "thName": "จังหวัดยามางาตะ",
      "viName": "Tỉnh Yamagata",
      "inName": "Prefektur Yamagata",
      "tlName": "Yamagata Prefecture",
      "moName": "Ямагата аймаг",
      "buName": "ယာမာဂါတာ ပြည်နယ်",
      "khName": "ខេត្ដ យ៉ាម៉ាហ្គាតា",
      "neName": "यामागाता जिल्ला"
    },
    "class10": {
      "code": "060030",
      "name": "庄内",
      "enName": "Shonai",
      "chName": "山形县庄内地方",
      "zhName": "山形縣莊內地方",
      "koName": "야마가타 현 쇼나이 지방",
      "esName": "Región Shonai, Prefectura de Yamagata",
      "ptName": "Região de Shōnai da Província de Yamagata",
      "thName": "ท้องถิ่นโชไน จังหวัดยามางาตะ",
      "viName": "Vùng Shonai tỉnh Yamagata",
      "inName": "Daerah Shonai di Prefektur Yamagata",
      "tlName": "Rehiyon ng Shonai sa Yamagata Prefecture",
      "moName": "Ямагата аймаг, Шонай муж",
      "buName": "ရိုနိုင်းဒေသ၊ ယမဂတစီရင်စု",
      "khName": "តំបន់ស្យូណៃនៃខេត្ដយ៉ាម៉ាហ្គាតា",
      "neName": "यामागाता जिल्ला, स्योनाइ क्षेत्र"
    },
    "class15": {
      "code": "060031",
      "name": "庄内北部",
      "enName": "Northern Shonai"
    },
    "class20": {
      "code": "0646100",
      "name": "遊佐町",
      "enName": "Yuza Town",
      "kana": "ゆざまち",
      "chName": "游佐町",
      "zhName": "游佐町",
      "koName": "유자 정",
      "esName": "Pueblo de Yuza",
      "ptName": "bairro de Yuza",
      "thName": "เมืองยุสะ",
      "viName": "thị trấn Yuza",
      "inName": "kota Yuza",
      "tlName": "bayan ng Yuza",
      "moName": "Юзa жижиг хот",
      "buName": "ယုဇ မြို့နယ်",
      "khName": "ទីប្រជុំជន យូហ្សា",
      "neName": "युजा नगर"
    }
  },
  "0720100": {
    "office": {
      "code": "070000",
      "name": "福島県",
      "enName": "Fukushima",
      "officeName": "福島地方気象台",
      "chName": "福岛县",
      "zhName": "福島縣",
      "koName": "후쿠시마현",
      "esName": "Prefectura de Fukushima",
      "ptName": "Província de Fukushima",
      "thName": "จังหวัดฟุกุชิมะ",
      "viName": "Tỉnh Fukushima",
      "inName": "Prefektur Fukushima",
      "tlName": "Fukushima Prefecture",
      "moName": "Фүкүшима аймаг",
      "buName": "ဖူကူရှီမ ပြည်နယ်",
      "khName": "ខេត្ត ហ្វូគូស៊ីម៉ា",
      "neName": "फुकुसिमा जिल्ला"
    },
    "class10": {
      "code": "070010",
      "name": "中通り",
      "enName": "Nakadori",
      "chName": "福岛县中通道",
      "zhName": "福島縣中通",
      "koName": "후쿠시마 현 나카도리",
      "esName": "Nakadori, Prefectura de Fukushima",
      "ptName": "Naka-dōri da Província de Fukushima",
      "thName": "นากะโดริ จังหวัดฟุกุชิมะ",
      "viName": "Nakadori, tỉnh Fukushima",
      "inName": "Nakadori, Prefektur Fukushima",
      "tlName": "Nakadori, Fukushima Prefecture",
      "moName": "Фүкүшима аймаг, Накадори",
      "buName": "နကိုဒိုယိ၊ ဟုခုရှိမစီရင်စု",
      "khName": "តំបន់ណាកាដូរីនៃខេត្តហ្វឹគឹស៊ីម៉ា",
      "neName": "फुकुसिमा जिल्ला, नाकादोरी"
    },
    "class15": {
      "code": "070011",
      "name": "中通り北部",
      "enName": "Northern Nakadori"
    },
    "class20": {
      "code": "0720100",
      "name": "福島市",
      "enName": "Fukushima City",
      "kana": "ふくしまし",
      "chName": "福岛市",
      "zhName": "福島市",
      "koName": "후쿠시마 시",
      "esName": "Ciudad de Fukushima",
      "ptName": "cidade de Fukushima",
      "thName": "เมืองฟุคุชิมะ",
      "viName": "thành phố Fukushima",
      "inName": "kota Fukushima",
      "tlName": "siyudad ng Fukushima",
      "moName": "Фүкүшима хот",
      "buName": "ဖူကုရှိမ မြို့",
      "khName": "ទីក្រុង ហ្វូគូស៊ីម៉ា",
      "neName": "फुकुशिमा सहर"
    }
  },
  "0720200": {
    "office": {
      "code": "070000",
      "name": "福島県",
      "enName": "Fukushima",
      "officeName": "福島地方気象台",
      "chName": "福岛县",
      "zhName": "福島縣",
      "koName": "후쿠시마현",
      "esName": "Prefectura de Fukushima",
      "ptName": "Província de Fukushima",
      "thName": "จังหวัดฟุกุชิมะ",
      "viName": "Tỉnh Fukushima",
      "inName": "Prefektur Fukushima",
      "tlName": "Fukushima Prefecture",
      "moName": "Фүкүшима аймаг",
      "buName": "ဖူကူရှီမ ပြည်နယ်",
      "khName": "ខេត្ត ហ្វូគូស៊ីម៉ា",
      "neName": "फुकुसिमा जिल्ला"
    },
    "class10": {
      "code": "070030",
      "name": "会津",
      "enName": "Aizu",
      "chName": "福岛县会津",
      "zhName": "福島縣會津",
      "koName": "후쿠시마 현 아이즈",
      "esName": "Aizu, Prefectura de Fukushima",
      "ptName": "Aizu da Província de Fukushima",
      "thName": "ไอซุ จังหวัดฟุกุชิมะ",
      "viName": "Aizu, tỉnh Fukushima",
      "inName": "Aizu, Prefektur Fukushima",
      "tlName": "Aizu, Fukushima Prefecture",
      "moName": "Фүкүшима аймаг, Айзү",
      "buName": "အအိဇု၊ ဟုခုရှိမစီရင်စု",
      "khName": "តំបន់អៃហ្សីនៃខេត្តហ្វឹគឹស៊ីម៉ា",
      "neName": "फुकुसिमा जिल्ला, आइजु"
    },
    "class15": {
      "code": "070032",
      "name": "会津中部",
      "enName": "Central Aizu"
    },
    "class20": {
      "code": "0720200",
      "name": "会津若松市",
      "enName": "Aizuwakamatsu City",
      "kana": "あいづわかまつし",
      "chName": "会津若松市",
      "zhName": "會津若松市",
      "koName": "아이즈와카마츠 시",
      "esName": "Ciudad de Aizuwakamatsu",
      "ptName": "cidade de Aizuwakamatsu",
      "thName": "เมืองไอสึวากามัตสึ",
      "viName": "thành phố Aizuwakamatsu",
      "inName": "kota Aizuwakamatsu",
      "tlName": "siyudad ng Aizuwakamatsu",
      "moName": "Айзүвакамацү хот",
      "buName": "အိုင်ယိဇုဝကာ့မာစု မြို့",
      "khName": "ទីក្រុង អាហ្ស៊ូវ៉ាវ៉ាកាម៉ាតស៊ុ",
      "neName": "आइजुवाकामात्सु सहर"
    }
  },
  "0720301": {
    "office": {
      "code": "070000",
      "name": "福島県",
      "enName": "Fukushima",
      "officeName": "福島地方気象台",
      "chName": "福岛县",
      "zhName": "福島縣",
      "koName": "후쿠시마현",
      "esName": "Prefectura de Fukushima",
      "ptName": "Província de Fukushima",
      "thName": "จังหวัดฟุกุชิมะ",
      "viName": "Tỉnh Fukushima",
      "inName": "Prefektur Fukushima",
      "tlName": "Fukushima Prefecture",
      "moName": "Фүкүшима аймаг",
      "buName": "ဖူကူရှီမ ပြည်နယ်",
      "khName": "ខេត្ត ហ្វូគូស៊ីម៉ា",
      "neName": "फुकुसिमा जिल्ला"
    },
    "class10": {
      "code": "070010",
      "name": "中通り",
      "enName": "Nakadori",
      "chName": "福岛县中通道",
      "zhName": "福島縣中通",
      "koName": "후쿠시마 현 나카도리",
      "esName": "Nakadori, Prefectura de Fukushima",
      "ptName": "Naka-dōri da Província de Fukushima",
      "thName": "นากะโดริ จังหวัดฟุกุชิมะ",
      "viName": "Nakadori, tỉnh Fukushima",
      "inName": "Nakadori, Prefektur Fukushima",
      "tlName": "Nakadori, Fukushima Prefecture",
      "moName": "Фүкүшима аймаг, Накадори",
      "buName": "နကိုဒိုယိ၊ ဟုခုရှိမစီရင်စု",
      "khName": "តំបន់ណាកាដូរីនៃខេត្តហ្វឹគឹស៊ីម៉ា",
      "neName": "फुकुसिमा जिल्ला, नाकादोरी"
    },
    "class15": {
      "code": "070012",
      "name": "中通り中部",
      "enName": "Central Nakadori"
    },
    "class20": {
      "code": "0720301",
      "name": "郡山市",
      "enName": "Koriyama City",
      "kana": "こおりやまし",
      "chName": "郡山市",
      "zhName": "郡山市",
      "koName": "고리야마시",
      "esName": "Ciudad de Koriyama",
      "ptName": "Cidade de Koriyama",
      "thName": "เมืองโคเรียมะ",
      "viName": "Thành phố Koriyama",
      "inName": "Koriyama, Kota Koriyama",
      "tlName": "Lungsod ng Koriyama",
      "moName": "Cidade de Koriyama",
      "buName": "ကိုရီးယားမြို့",
      "khName": "ខេត្តកូរីយ៉ាមា",
      "neName": "कोरियामा नगर"
    }
  },
  "0720302": {
    "office": {
      "code": "070000",
      "name": "福島県",
      "enName": "Fukushima",
      "officeName": "福島地方気象台",
      "chName": "福岛县",
      "zhName": "福島縣",
      "koName": "후쿠시마현",
      "esName": "Prefectura de Fukushima",
      "ptName": "Província de Fukushima",
      "thName": "จังหวัดฟุกุชิมะ",
      "viName": "Tỉnh Fukushima",
      "inName": "Prefektur Fukushima",
      "tlName": "Fukushima Prefecture",
      "moName": "Фүкүшима аймаг",
      "buName": "ဖူကူရှီမ ပြည်နယ်",
      "khName": "ខេត្ត ហ្វូគូស៊ីម៉ា",
      "neName": "फुकुसिमा जिल्ला"
    },
    "class10": {
      "code": "070030",
      "name": "会津",
      "enName": "Aizu",
      "chName": "福岛县会津",
      "zhName": "福島縣會津",
      "koName": "후쿠시마 현 아이즈",
      "esName": "Aizu, Prefectura de Fukushima",
      "ptName": "Aizu da Província de Fukushima",
      "thName": "ไอซุ จังหวัดฟุกุชิมะ",
      "viName": "Aizu, tỉnh Fukushima",
      "inName": "Aizu, Prefektur Fukushima",
      "tlName": "Aizu, Fukushima Prefecture",
      "moName": "Фүкүшима аймаг, Айзү",
      "buName": "အအိဇု၊ ဟုခုရှိမစီရင်စု",
      "khName": "តំបន់អៃហ្សីនៃខេត្តហ្វឹគឹស៊ីម៉ា",
      "neName": "फुकुसिमा जिल्ला, आइजु"
    },
    "class15": {
      "code": "070032",
      "name": "会津中部",
      "enName": "Central Aizu"
    },
    "class20": {
      "code": "0720302",
      "name": "郡山市湖南",
      "enName": "Konan, Koriyama City",
      "kana": "こおりやましこなん",
      "chName": "郡山市湖南",
      "zhName": "郡山市湖南",
      "koName": "고리야마시 코난",
      "esName": "Konan, Ciudad de Koriyama",
      "ptName": "Konan, Cidade de Koriyama",
      "thName": "เมืองโคเรียมะ โคนัน",
      "viName": "Konan, Thành phố Koriyama",
      "inName": "Konan, Kota Koriyama",
      "tlName": "Konan, Lungsod ng Koriyama",
      "moName": "Konan, Cidade de Koriyama",
      "buName": "ကိုရီးယားမြို့ကိုနန်း",
      "khName": "ខេត្តកូរីយ៉ាមាកូណាន",
      "neName": "कोरियामा कोनान नगर"
    }
  },
  "0720400": {
    "office": {
      "code": "070000",
      "name": "福島県",
      "enName": "Fukushima",
      "officeName": "福島地方気象台",
      "chName": "福岛县",
      "zhName": "福島縣",
      "koName": "후쿠시마현",
      "esName": "Prefectura de Fukushima",
      "ptName": "Província de Fukushima",
      "thName": "จังหวัดฟุกุชิมะ",
      "viName": "Tỉnh Fukushima",
      "inName": "Prefektur Fukushima",
      "tlName": "Fukushima Prefecture",
      "moName": "Фүкүшима аймаг",
      "buName": "ဖူကူရှီမ ပြည်နယ်",
      "khName": "ខេត្ត ហ្វូគូស៊ីម៉ា",
      "neName": "फुकुसिमा जिल्ला"
    },
    "class10": {
      "code": "070020",
      "name": "浜通り",
      "enName": "Hamadori",
      "chName": "福岛县滨通道",
      "zhName": "福島縣濱通",
      "koName": "후쿠시마 현 하마 도리",
      "esName": "Hamadori, Prefectura de Fukushima",
      "ptName": "Hama-dōri da Província de Fukushima",
      "thName": "ฮามะโดริ จังหวัดฟุกุชิมะ",
      "viName": "Hamadori, tỉnh Fukushima",
      "inName": "Hamadori, Prefektur Fukushima",
      "tlName": "Hamadori, Fukushima Prefecture",
      "moName": "Фүкүшима аймаг, Хамадори",
      "buName": "ဟမဒိုယိ၊ ဟုခုရှိမစီရင်စု",
      "khName": "តំបន់ហាម៉ាដូរីនៃខេត្តហ្វឹគឹស៊ីម៉ា",
      "neName": "फुकुसिमा जिल्ला, हामादोरी"
    },
    "class15": {
      "code": "070023",
      "name": "浜通り南部",
      "enName": "Southern Hamadori"
    },
    "class20": {
      "code": "0720400",
      "name": "いわき市",
      "enName": "Iwaki City",
      "kana": "いわきし",
      "chName": "磐城市",
      "zhName": "磐城市",
      "koName": "이와키 시",
      "esName": "Ciudad de Iwaki",
      "ptName": "cidade de Iwaki",
      "thName": "เมืองอิวากิ",
      "viName": "thành phố Iwaki",
      "inName": "kota Iwaki",
      "tlName": "siyudad ng Iwaki",
      "moName": "Иваки хот",
      "buName": "အီဝါ့ကိ မြို့",
      "khName": "ទីក្រុង អ៊ីវ៉ាគី",
      "neName": "इवाकी सहर"
    }
  },
  "0720500": {
    "office": {
      "code": "070000",
      "name": "福島県",
      "enName": "Fukushima",
      "officeName": "福島地方気象台",
      "chName": "福岛县",
      "zhName": "福島縣",
      "koName": "후쿠시마현",
      "esName": "Prefectura de Fukushima",
      "ptName": "Província de Fukushima",
      "thName": "จังหวัดฟุกุชิมะ",
      "viName": "Tỉnh Fukushima",
      "inName": "Prefektur Fukushima",
      "tlName": "Fukushima Prefecture",
      "moName": "Фүкүшима аймаг",
      "buName": "ဖူကူရှီမ ပြည်နယ်",
      "khName": "ខេត្ត ហ្វូគូស៊ីម៉ា",
      "neName": "फुकुसिमा जिल्ला"
    },
    "class10": {
      "code": "070010",
      "name": "中通り",
      "enName": "Nakadori",
      "chName": "福岛县中通道",
      "zhName": "福島縣中通",
      "koName": "후쿠시마 현 나카도리",
      "esName": "Nakadori, Prefectura de Fukushima",
      "ptName": "Naka-dōri da Província de Fukushima",
      "thName": "นากะโดริ จังหวัดฟุกุชิมะ",
      "viName": "Nakadori, tỉnh Fukushima",
      "inName": "Nakadori, Prefektur Fukushima",
      "tlName": "Nakadori, Fukushima Prefecture",
      "moName": "Фүкүшима аймаг, Накадори",
      "buName": "နကိုဒိုယိ၊ ဟုခုရှိမစီရင်စု",
      "khName": "តំបន់ណាកាដូរីនៃខេត្តហ្វឹគឹស៊ីម៉ា",
      "neName": "फुकुसिमा जिल्ला, नाकादोरी"
    },
    "class15": {
      "code": "070013",
      "name": "中通り南部",
      "enName": "Southern Nakadori"
    },
    "class20": {
      "code": "0720500",
      "name": "白河市",
      "enName": "Shirakawa City",
      "kana": "しらかわし",
      "chName": "白河市",
      "zhName": "白河市",
      "koName": "시라카와 시",
      "esName": "Ciudad de Shirakawa",
      "ptName": "cidade de Shirakawa",
      "thName": "เมืองชิราคาวะ",
      "viName": "thành phố Shirakawa",
      "inName": "kota Shirakawa",
      "tlName": "siyudad ng Shirakawa",
      "moName": "Ширакава хот",
      "buName": "ရှီရာကာ့ဝ မြို့",
      "khName": "ទីក្រុង ស៊ីរ៉ាកាវ៉ា",
      "neName": "शिराकावा सहर"
    }
  },
  "0720700": {
    "office": {
      "code": "070000",
      "name": "福島県",
      "enName": "Fukushima",
      "officeName": "福島地方気象台",
      "chName": "福岛县",
      "zhName": "福島縣",
      "koName": "후쿠시마현",
      "esName": "Prefectura de Fukushima",
      "ptName": "Província de Fukushima",
      "thName": "จังหวัดฟุกุชิมะ",
      "viName": "Tỉnh Fukushima",
      "inName": "Prefektur Fukushima",
      "tlName": "Fukushima Prefecture",
      "moName": "Фүкүшима аймаг",
      "buName": "ဖူကူရှီမ ပြည်နယ်",
      "khName": "ខេត្ត ហ្វូគូស៊ីម៉ា",
      "neName": "फुकुसिमा जिल्ला"
    },
    "class10": {
      "code": "070010",
      "name": "中通り",
      "enName": "Nakadori",
      "chName": "福岛县中通道",
      "zhName": "福島縣中通",
      "koName": "후쿠시마 현 나카도리",
      "esName": "Nakadori, Prefectura de Fukushima",
      "ptName": "Naka-dōri da Província de Fukushima",
      "thName": "นากะโดริ จังหวัดฟุกุชิมะ",
      "viName": "Nakadori, tỉnh Fukushima",
      "inName": "Nakadori, Prefektur Fukushima",
      "tlName": "Nakadori, Fukushima Prefecture",
      "moName": "Фүкүшима аймаг, Накадори",
      "buName": "နကိုဒိုယိ၊ ဟုခုရှိမစီရင်စု",
      "khName": "តំបន់ណាកាដូរីនៃខេត្តហ្វឹគឹស៊ីម៉ា",
      "neName": "फुकुसिमा जिल्ला, नाकादोरी"
    },
    "class15": {
      "code": "070012",
      "name": "中通り中部",
      "enName": "Central Nakadori"
    },
    "class20": {
      "code": "0720700",
      "name": "須賀川市",
      "enName": "Sukagawa City",
      "kana": "すかがわし",
      "chName": "须贺川市",
      "zhName": "須賀川市",
      "koName": "스카가와 시",
      "esName": "Ciudad de Sukagawa",
      "ptName": "cidade de Sukagawa",
      "thName": "เมืองซูคะกาวา",
      "viName": "thành phố Sukagawa",
      "inName": "kota Sukagawa",
      "tlName": "siyudad ng Sukagawa",
      "moName": "Сукагава хот",
      "buName": "ဆူကာဂါဝ မြို့",
      "khName": "ទីក្រុង ស៊ូកាកាវ៉ា",
      "neName": "सुकागावा सहर"
    }
  },
  "0720800": {
    "office": {
      "code": "070000",
      "name": "福島県",
      "enName": "Fukushima",
      "officeName": "福島地方気象台",
      "chName": "福岛县",
      "zhName": "福島縣",
      "koName": "후쿠시마현",
      "esName": "Prefectura de Fukushima",
      "ptName": "Província de Fukushima",
      "thName": "จังหวัดฟุกุชิมะ",
      "viName": "Tỉnh Fukushima",
      "inName": "Prefektur Fukushima",
      "tlName": "Fukushima Prefecture",
      "moName": "Фүкүшима аймаг",
      "buName": "ဖူကူရှီမ ပြည်နယ်",
      "khName": "ខេត្ត ហ្វូគូស៊ីម៉ា",
      "neName": "फुकुसिमा जिल्ला"
    },
    "class10": {
      "code": "070030",
      "name": "会津",
      "enName": "Aizu",
      "chName": "福岛县会津",
      "zhName": "福島縣會津",
      "koName": "후쿠시마 현 아이즈",
      "esName": "Aizu, Prefectura de Fukushima",
      "ptName": "Aizu da Província de Fukushima",
      "thName": "ไอซุ จังหวัดฟุกุชิมะ",
      "viName": "Aizu, tỉnh Fukushima",
      "inName": "Aizu, Prefektur Fukushima",
      "tlName": "Aizu, Fukushima Prefecture",
      "moName": "Фүкүшима аймаг, Айзү",
      "buName": "အအိဇု၊ ဟုခုရှိမစီရင်စု",
      "khName": "តំបន់អៃហ្សីនៃខេត្តហ្វឹគឹស៊ីម៉ា",
      "neName": "फुकुसिमा जिल्ला, आइजु"
    },
    "class15": {
      "code": "070031",
      "name": "会津北部",
      "enName": "Northern Aizu"
    },
    "class20": {
      "code": "0720800",
      "name": "喜多方市",
      "enName": "Kitakata City",
      "kana": "きたかたし",
      "chName": "喜多方市",
      "zhName": "喜多方市",
      "koName": "기타카타 시",
      "esName": "Ciudad de Kitakata",
      "ptName": "cidade de Kitakata",
      "thName": "เมืองคิตะกาตะ",
      "viName": "thành phố Kitakata",
      "inName": "kota Kitakata",
      "tlName": "siyudad ng Kitakata",
      "moName": "Китаката хот",
      "buName": "ခီတာကာ့တ မြို့",
      "khName": "ទីក្រុង គីតាកាតា",
      "neName": "किताकाता सहर"
    }
  },
  "0720900": {
    "office": {
      "code": "070000",
      "name": "福島県",
      "enName": "Fukushima",
      "officeName": "福島地方気象台",
      "chName": "福岛县",
      "zhName": "福島縣",
      "koName": "후쿠시마현",
      "esName": "Prefectura de Fukushima",
      "ptName": "Província de Fukushima",
      "thName": "จังหวัดฟุกุชิมะ",
      "viName": "Tỉnh Fukushima",
      "inName": "Prefektur Fukushima",
      "tlName": "Fukushima Prefecture",
      "moName": "Фүкүшима аймаг",
      "buName": "ဖူကူရှီမ ပြည်နယ်",
      "khName": "ខេត្ត ហ្វូគូស៊ីម៉ា",
      "neName": "फुकुसिमा जिल्ला"
    },
    "class10": {
      "code": "070020",
      "name": "浜通り",
      "enName": "Hamadori",
      "chName": "福岛县滨通道",
      "zhName": "福島縣濱通",
      "koName": "후쿠시마 현 하마 도리",
      "esName": "Hamadori, Prefectura de Fukushima",
      "ptName": "Hama-dōri da Província de Fukushima",
      "thName": "ฮามะโดริ จังหวัดฟุกุชิมะ",
      "viName": "Hamadori, tỉnh Fukushima",
      "inName": "Hamadori, Prefektur Fukushima",
      "tlName": "Hamadori, Fukushima Prefecture",
      "moName": "Фүкүшима аймаг, Хамадори",
      "buName": "ဟမဒိုယိ၊ ဟုခုရှိမစီရင်စု",
      "khName": "តំបន់ហាម៉ាដូរីនៃខេត្តហ្វឹគឹស៊ីម៉ា",
      "neName": "फुकुसिमा जिल्ला, हामादोरी"
    },
    "class15": {
      "code": "070021",
      "name": "浜通り北部",
      "enName": "Northern Hamadori"
    },
    "class20": {
      "code": "0720900",
      "name": "相馬市",
      "enName": "Soma City",
      "kana": "そうまし",
      "chName": "相马市",
      "zhName": "相馬市",
      "koName": "소마 시",
      "esName": "Ciudad de Soma",
      "ptName": "cidade de Soma",
      "thName": "เมืองโซมะ",
      "viName": "thành phố Soma",
      "inName": "kota Soma",
      "tlName": "siyudad ng Soma",
      "moName": "Сома хот",
      "buName": "ဆိုမ မြို့",
      "khName": "ទីក្រុង សូម៉ា",
      "neName": "सोमा सहर"
    }
  },
  "0721000": {
    "office": {
      "code": "070000",
      "name": "福島県",
      "enName": "Fukushima",
      "officeName": "福島地方気象台",
      "chName": "福岛县",
      "zhName": "福島縣",
      "koName": "후쿠시마현",
      "esName": "Prefectura de Fukushima",
      "ptName": "Província de Fukushima",
      "thName": "จังหวัดฟุกุชิมะ",
      "viName": "Tỉnh Fukushima",
      "inName": "Prefektur Fukushima",
      "tlName": "Fukushima Prefecture",
      "moName": "Фүкүшима аймаг",
      "buName": "ဖူကူရှီမ ပြည်နယ်",
      "khName": "ខេត្ត ហ្វូគូស៊ីម៉ា",
      "neName": "फुकुसिमा जिल्ला"
    },
    "class10": {
      "code": "070010",
      "name": "中通り",
      "enName": "Nakadori",
      "chName": "福岛县中通道",
      "zhName": "福島縣中通",
      "koName": "후쿠시마 현 나카도리",
      "esName": "Nakadori, Prefectura de Fukushima",
      "ptName": "Naka-dōri da Província de Fukushima",
      "thName": "นากะโดริ จังหวัดฟุกุชิมะ",
      "viName": "Nakadori, tỉnh Fukushima",
      "inName": "Nakadori, Prefektur Fukushima",
      "tlName": "Nakadori, Fukushima Prefecture",
      "moName": "Фүкүшима аймаг, Накадори",
      "buName": "နကိုဒိုယိ၊ ဟုခုရှိမစီရင်စု",
      "khName": "តំបន់ណាកាដូរីនៃខេត្តហ្វឹគឹស៊ីម៉ា",
      "neName": "फुकुसिमा जिल्ला, नाकादोरी"
    },
    "class15": {
      "code": "070012",
      "name": "中通り中部",
      "enName": "Central Nakadori"
    },
    "class20": {
      "code": "0721000",
      "name": "二本松市",
      "enName": "Nihonmatsu City",
      "kana": "にほんまつし",
      "chName": "二本松市",
      "zhName": "二本松市",
      "koName": "니혼마쓰 시",
      "esName": "Ciudad de Nihonmatsu",
      "ptName": "cidade de Nihonmatsu",
      "thName": "เมืองนิฮอนมัทสิ",
      "viName": "thành phố Nihonmatsu",
      "inName": "kota Nihonmatsu",
      "tlName": "siyudad ng Nihonmatsu",
      "moName": "Нихонмацү хот",
      "buName": "နီဟိုးမာ့စု မြို့",
      "khName": "ទីក្រុង នីហុនម៉ាត់ស៊ុ",
      "neName": "निहोन्मात्सु सहर"
    }
  },
  "0721100": {
    "office": {
      "code": "070000",
      "name": "福島県",
      "enName": "Fukushima",
      "officeName": "福島地方気象台",
      "chName": "福岛县",
      "zhName": "福島縣",
      "koName": "후쿠시마현",
      "esName": "Prefectura de Fukushima",
      "ptName": "Província de Fukushima",
      "thName": "จังหวัดฟุกุชิมะ",
      "viName": "Tỉnh Fukushima",
      "inName": "Prefektur Fukushima",
      "tlName": "Fukushima Prefecture",
      "moName": "Фүкүшима аймаг",
      "buName": "ဖူကူရှီမ ပြည်နယ်",
      "khName": "ខេត្ត ហ្វូគូស៊ីម៉ា",
      "neName": "फुकुसिमा जिल्ला"
    },
    "class10": {
      "code": "070010",
      "name": "中通り",
      "enName": "Nakadori",
      "chName": "福岛县中通道",
      "zhName": "福島縣中通",
      "koName": "후쿠시마 현 나카도리",
      "esName": "Nakadori, Prefectura de Fukushima",
      "ptName": "Naka-dōri da Província de Fukushima",
      "thName": "นากะโดริ จังหวัดฟุกุชิมะ",
      "viName": "Nakadori, tỉnh Fukushima",
      "inName": "Nakadori, Prefektur Fukushima",
      "tlName": "Nakadori, Fukushima Prefecture",
      "moName": "Фүкүшима аймаг, Накадори",
      "buName": "နကိုဒိုယိ၊ ဟုခုရှိမစီရင်စု",
      "khName": "តំបន់ណាកាដូរីនៃខេត្តហ្វឹគឹស៊ីម៉ា",
      "neName": "फुकुसिमा जिल्ला, नाकादोरी"
    },
    "class15": {
      "code": "070012",
      "name": "中通り中部",
      "enName": "Central Nakadori"
    },
    "class20": {
      "code": "0721100",
      "name": "田村市",
      "enName": "Tamura City",
      "kana": "たむらし",
      "chName": "田村市",
      "zhName": "田村市",
      "koName": "다무라 시",
      "esName": "Ciudad de Tamura",
      "ptName": "cidade de Tamura ",
      "thName": "เมืองทามูระ",
      "viName": "thành phố Tamura",
      "inName": "kota Tamura",
      "tlName": "siyudad ng Tamura",
      "moName": "Тамүра хот",
      "buName": "တာမုရ မြို့",
      "khName": "ទីក្រុង តាមូរ៉ា",
      "neName": "तामुरा सहर"
    }
  },
  "0721200": {
    "office": {
      "code": "070000",
      "name": "福島県",
      "enName": "Fukushima",
      "officeName": "福島地方気象台",
      "chName": "福岛县",
      "zhName": "福島縣",
      "koName": "후쿠시마현",
      "esName": "Prefectura de Fukushima",
      "ptName": "Província de Fukushima",
      "thName": "จังหวัดฟุกุชิมะ",
      "viName": "Tỉnh Fukushima",
      "inName": "Prefektur Fukushima",
      "tlName": "Fukushima Prefecture",
      "moName": "Фүкүшима аймаг",
      "buName": "ဖူကူရှီမ ပြည်နယ်",
      "khName": "ខេត្ត ហ្វូគូស៊ីម៉ា",
      "neName": "फुकुसिमा जिल्ला"
    },
    "class10": {
      "code": "070020",
      "name": "浜通り",
      "enName": "Hamadori",
      "chName": "福岛县滨通道",
      "zhName": "福島縣濱通",
      "koName": "후쿠시마 현 하마 도리",
      "esName": "Hamadori, Prefectura de Fukushima",
      "ptName": "Hama-dōri da Província de Fukushima",
      "thName": "ฮามะโดริ จังหวัดฟุกุชิมะ",
      "viName": "Hamadori, tỉnh Fukushima",
      "inName": "Hamadori, Prefektur Fukushima",
      "tlName": "Hamadori, Fukushima Prefecture",
      "moName": "Фүкүшима аймаг, Хамадори",
      "buName": "ဟမဒိုယိ၊ ဟုခုရှိမစီရင်စု",
      "khName": "តំបន់ហាម៉ាដូរីនៃខេត្តហ្វឹគឹស៊ីម៉ា",
      "neName": "फुकुसिमा जिल्ला, हामादोरी"
    },
    "class15": {
      "code": "070021",
      "name": "浜通り北部",
      "enName": "Northern Hamadori"
    },
    "class20": {
      "code": "0721200",
      "name": "南相馬市",
      "enName": "Minamisoma City",
      "kana": "みなみそうまし",
      "chName": "南相马市",
      "zhName": "南相馬市",
      "koName": "미나미소우마 시",
      "esName": "Ciudad de Minamisōma",
      "ptName": "cidade de Minamisoma",
      "thName": "เมืองมินามิโซมะ",
      "viName": "thành phố Minamisoma",
      "inName": "kota Minamisoma",
      "tlName": "siyudad ng Minamisoma",
      "moName": "Минaмисомa хот",
      "buName": "မူနာမိဆိုးမာ့ မြို့",
      "khName": "ទីក្រុង មីណាមីសូម៉ា",
      "neName": "मिनामिसोमा सहर"
    }
  },
  "0721300": {
    "office": {
      "code": "070000",
      "name": "福島県",
      "enName": "Fukushima",
      "officeName": "福島地方気象台",
      "chName": "福岛县",
      "zhName": "福島縣",
      "koName": "후쿠시마현",
      "esName": "Prefectura de Fukushima",
      "ptName": "Província de Fukushima",
      "thName": "จังหวัดฟุกุชิมะ",
      "viName": "Tỉnh Fukushima",
      "inName": "Prefektur Fukushima",
      "tlName": "Fukushima Prefecture",
      "moName": "Фүкүшима аймаг",
      "buName": "ဖူကူရှီမ ပြည်နယ်",
      "khName": "ខេត្ត ហ្វូគូស៊ីម៉ា",
      "neName": "फुकुसिमा जिल्ला"
    },
    "class10": {
      "code": "070010",
      "name": "中通り",
      "enName": "Nakadori",
      "chName": "福岛县中通道",
      "zhName": "福島縣中通",
      "koName": "후쿠시마 현 나카도리",
      "esName": "Nakadori, Prefectura de Fukushima",
      "ptName": "Naka-dōri da Província de Fukushima",
      "thName": "นากะโดริ จังหวัดฟุกุชิมะ",
      "viName": "Nakadori, tỉnh Fukushima",
      "inName": "Nakadori, Prefektur Fukushima",
      "tlName": "Nakadori, Fukushima Prefecture",
      "moName": "Фүкүшима аймаг, Накадори",
      "buName": "နကိုဒိုယိ၊ ဟုခုရှိမစီရင်စု",
      "khName": "តំបន់ណាកាដូរីនៃខេត្តហ្វឹគឹស៊ីម៉ា",
      "neName": "फुकुसिमा जिल्ला, नाकादोरी"
    },
    "class15": {
      "code": "070011",
      "name": "中通り北部",
      "enName": "Northern Nakadori"
    },
    "class20": {
      "code": "0721300",
      "name": "伊達市",
      "enName": "Date City",
      "kana": "だてし",
      "chName": "福岛伊达市",
      "zhName": "福島伊達市",
      "koName": "후쿠시마 다테 시",
      "esName": "Ciudad de Date, Fukushima",
      "ptName": "Fukushima, cidade de Date",
      "thName": "เมืองดาเตะ ฟุกุชิมะ",
      "viName": "Thành phố Date, Fukushima",
      "inName": "Kota Date, Fukushima",
      "tlName": "siyudad ng Date, Fukushima",
      "moName": "Фукушима Датэ хот",
      "buName": "ဟုခုရှိမဒတဲမြို့",
      "khName": "ទីក្រុងដាតេ ហ្វឹគឹស៊ីម៉ា",
      "neName": "फुकुसिमा दाते सहर"
    }
  },
  "0721400": {
    "office": {
      "code": "070000",
      "name": "福島県",
      "enName": "Fukushima",
      "officeName": "福島地方気象台",
      "chName": "福岛县",
      "zhName": "福島縣",
      "koName": "후쿠시마현",
      "esName": "Prefectura de Fukushima",
      "ptName": "Província de Fukushima",
      "thName": "จังหวัดฟุกุชิมะ",
      "viName": "Tỉnh Fukushima",
      "inName": "Prefektur Fukushima",
      "tlName": "Fukushima Prefecture",
      "moName": "Фүкүшима аймаг",
      "buName": "ဖူကူရှီမ ပြည်နယ်",
      "khName": "ខេត្ត ហ្វូគូស៊ីម៉ា",
      "neName": "फुकुसिमा जिल्ला"
    },
    "class10": {
      "code": "070010",
      "name": "中通り",
      "enName": "Nakadori",
      "chName": "福岛县中通道",
      "zhName": "福島縣中通",
      "koName": "후쿠시마 현 나카도리",
      "esName": "Nakadori, Prefectura de Fukushima",
      "ptName": "Naka-dōri da Província de Fukushima",
      "thName": "นากะโดริ จังหวัดฟุกุชิมะ",
      "viName": "Nakadori, tỉnh Fukushima",
      "inName": "Nakadori, Prefektur Fukushima",
      "tlName": "Nakadori, Fukushima Prefecture",
      "moName": "Фүкүшима аймаг, Накадори",
      "buName": "နကိုဒိုယိ၊ ဟုခုရှိမစီရင်စု",
      "khName": "តំបន់ណាកាដូរីនៃខេត្តហ្វឹគឹស៊ីម៉ា",
      "neName": "फुकुसिमा जिल्ला, नाकादोरी"
    },
    "class15": {
      "code": "070012",
      "name": "中通り中部",
      "enName": "Central Nakadori"
    },
    "class20": {
      "code": "0721400",
      "name": "本宮市",
      "enName": "Motomiya City",
      "kana": "もとみやし",
      "chName": "本宫市",
      "zhName": "本宮市",
      "koName": "모토미야 시",
      "esName": "Ciudad de Motomiya",
      "ptName": "cidade de Motomiya",
      "thName": "เมืองโมโตมิยะ",
      "viName": "thành phố Motomiya",
      "inName": "kota Motomiya",
      "tlName": "siyudad ng Motomiya",
      "moName": "Мотомия хот",
      "buName": "မိုတိုမီးယ မြို့",
      "khName": "ទីក្រុង ម៉ូតូមីយ៉ា",
      "neName": "मोतोमिया सहर"
    }
  },
  "0730100": {
    "office": {
      "code": "070000",
      "name": "福島県",
      "enName": "Fukushima",
      "officeName": "福島地方気象台",
      "chName": "福岛县",
      "zhName": "福島縣",
      "koName": "후쿠시마현",
      "esName": "Prefectura de Fukushima",
      "ptName": "Província de Fukushima",
      "thName": "จังหวัดฟุกุชิมะ",
      "viName": "Tỉnh Fukushima",
      "inName": "Prefektur Fukushima",
      "tlName": "Fukushima Prefecture",
      "moName": "Фүкүшима аймаг",
      "buName": "ဖူကူရှီမ ပြည်နယ်",
      "khName": "ខេត្ត ហ្វូគូស៊ីម៉ា",
      "neName": "फुकुसिमा जिल्ला"
    },
    "class10": {
      "code": "070010",
      "name": "中通り",
      "enName": "Nakadori",
      "chName": "福岛县中通道",
      "zhName": "福島縣中通",
      "koName": "후쿠시마 현 나카도리",
      "esName": "Nakadori, Prefectura de Fukushima",
      "ptName": "Naka-dōri da Província de Fukushima",
      "thName": "นากะโดริ จังหวัดฟุกุชิมะ",
      "viName": "Nakadori, tỉnh Fukushima",
      "inName": "Nakadori, Prefektur Fukushima",
      "tlName": "Nakadori, Fukushima Prefecture",
      "moName": "Фүкүшима аймаг, Накадори",
      "buName": "နကိုဒိုယိ၊ ဟုခုရှိမစီရင်စု",
      "khName": "តំបន់ណាកាដូរីនៃខេត្តហ្វឹគឹស៊ីម៉ា",
      "neName": "फुकुसिमा जिल्ला, नाकादोरी"
    },
    "class15": {
      "code": "070011",
      "name": "中通り北部",
      "enName": "Northern Nakadori"
    },
    "class20": {
      "code": "0730100",
      "name": "桑折町",
      "enName": "Koori Town",
      "kana": "こおりまち",
      "chName": "桑折町",
      "zhName": "桑折町",
      "koName": "고오리 정",
      "esName": "Pueblo de Kori",
      "ptName": "bairro de Koori",
      "thName": "เมืองโคริ",
      "viName": "thị trấn Koori",
      "inName": "kota Koori",
      "tlName": "bayan ng Koori",
      "moName": "Коори жижиг хот",
      "buName": "ကောရိ မြို့နယ်",
      "khName": "ទីប្រជុំជន កូអូរី",
      "neName": "कोओरी नगर"
    }
  },
  "0730300": {
    "office": {
      "code": "070000",
      "name": "福島県",
      "enName": "Fukushima",
      "officeName": "福島地方気象台",
      "chName": "福岛县",
      "zhName": "福島縣",
      "koName": "후쿠시마현",
      "esName": "Prefectura de Fukushima",
      "ptName": "Província de Fukushima",
      "thName": "จังหวัดฟุกุชิมะ",
      "viName": "Tỉnh Fukushima",
      "inName": "Prefektur Fukushima",
      "tlName": "Fukushima Prefecture",
      "moName": "Фүкүшима аймаг",
      "buName": "ဖူကူရှီမ ပြည်နယ်",
      "khName": "ខេត្ត ហ្វូគូស៊ីម៉ា",
      "neName": "फुकुसिमा जिल्ला"
    },
    "class10": {
      "code": "070010",
      "name": "中通り",
      "enName": "Nakadori",
      "chName": "福岛县中通道",
      "zhName": "福島縣中通",
      "koName": "후쿠시마 현 나카도리",
      "esName": "Nakadori, Prefectura de Fukushima",
      "ptName": "Naka-dōri da Província de Fukushima",
      "thName": "นากะโดริ จังหวัดฟุกุชิมะ",
      "viName": "Nakadori, tỉnh Fukushima",
      "inName": "Nakadori, Prefektur Fukushima",
      "tlName": "Nakadori, Fukushima Prefecture",
      "moName": "Фүкүшима аймаг, Накадори",
      "buName": "နကိုဒိုယိ၊ ဟုခုရှိမစီရင်စု",
      "khName": "តំបន់ណាកាដូរីនៃខេត្តហ្វឹគឹស៊ីម៉ា",
      "neName": "फुकुसिमा जिल्ला, नाकादोरी"
    },
    "class15": {
      "code": "070011",
      "name": "中通り北部",
      "enName": "Northern Nakadori"
    },
    "class20": {
      "code": "0730300",
      "name": "国見町",
      "enName": "Kunimi Town",
      "kana": "くにみまち",
      "chName": "国见町",
      "zhName": "國見町",
      "koName": "구니미 정",
      "esName": "Pueblo de Kunimi",
      "ptName": "bairro de Kunimi",
      "thName": "เมืองคุนิมิ",
      "viName": "thị trấn Kunimi",
      "inName": "kota Kunimi",
      "tlName": "bayan ng Kunimi",
      "moName": "Күними жижиг хот",
      "buName": "ကူနိမိ မြို့နယ်",
      "khName": "ទីប្រជុំជន គុនីមី",
      "neName": "कुनिमी नगर"
    }
  },
  "0730800": {
    "office": {
      "code": "070000",
      "name": "福島県",
      "enName": "Fukushima",
      "officeName": "福島地方気象台",
      "chName": "福岛县",
      "zhName": "福島縣",
      "koName": "후쿠시마현",
      "esName": "Prefectura de Fukushima",
      "ptName": "Província de Fukushima",
      "thName": "จังหวัดฟุกุชิมะ",
      "viName": "Tỉnh Fukushima",
      "inName": "Prefektur Fukushima",
      "tlName": "Fukushima Prefecture",
      "moName": "Фүкүшима аймаг",
      "buName": "ဖူကူရှီမ ပြည်နယ်",
      "khName": "ខេត្ត ហ្វូគូស៊ីម៉ា",
      "neName": "फुकुसिमा जिल्ला"
    },
    "class10": {
      "code": "070010",
      "name": "中通り",
      "enName": "Nakadori",
      "chName": "福岛县中通道",
      "zhName": "福島縣中通",
      "koName": "후쿠시마 현 나카도리",
      "esName": "Nakadori, Prefectura de Fukushima",
      "ptName": "Naka-dōri da Província de Fukushima",
      "thName": "นากะโดริ จังหวัดฟุกุชิมะ",
      "viName": "Nakadori, tỉnh Fukushima",
      "inName": "Nakadori, Prefektur Fukushima",
      "tlName": "Nakadori, Fukushima Prefecture",
      "moName": "Фүкүшима аймаг, Накадори",
      "buName": "နကိုဒိုယိ၊ ဟုခုရှိမစီရင်စု",
      "khName": "តំបន់ណាកាដូរីនៃខេត្តហ្វឹគឹស៊ីម៉ា",
      "neName": "फुकुसिमा जिल्ला, नाकादोरी"
    },
    "class15": {
      "code": "070011",
      "name": "中通り北部",
      "enName": "Northern Nakadori"
    },
    "class20": {
      "code": "0730800",
      "name": "川俣町",
      "enName": "Kawamata Town",
      "kana": "かわまたまち",
      "chName": "川俣町",
      "zhName": "川俁町",
      "koName": "가와마타 정",
      "esName": "Pueblo de Kawamata",
      "ptName": "bairro de Kawamata",
      "thName": "เมืองคาวามาตะ",
      "viName": "thị trấn Kawamata",
      "inName": "kota Kawamata",
      "tlName": "bayan ng Kawamata",
      "moName": "Кавамата жижиг хот",
      "buName": "ခါဝါးမာ့တ မြို့နယ်",
      "khName": "ទីប្រជុំជន កាវ៉ាម៉ាតា",
      "neName": "कावामाता नगर"
    }
  },
  "0732200": {
    "office": {
      "code": "070000",
      "name": "福島県",
      "enName": "Fukushima",
      "officeName": "福島地方気象台",
      "chName": "福岛县",
      "zhName": "福島縣",
      "koName": "후쿠시마현",
      "esName": "Prefectura de Fukushima",
      "ptName": "Província de Fukushima",
      "thName": "จังหวัดฟุกุชิมะ",
      "viName": "Tỉnh Fukushima",
      "inName": "Prefektur Fukushima",
      "tlName": "Fukushima Prefecture",
      "moName": "Фүкүшима аймаг",
      "buName": "ဖူကူရှီမ ပြည်နယ်",
      "khName": "ខេត្ត ហ្វូគូស៊ីម៉ា",
      "neName": "फुकुसिमा जिल्ला"
    },
    "class10": {
      "code": "070010",
      "name": "中通り",
      "enName": "Nakadori",
      "chName": "福岛县中通道",
      "zhName": "福島縣中通",
      "koName": "후쿠시마 현 나카도리",
      "esName": "Nakadori, Prefectura de Fukushima",
      "ptName": "Naka-dōri da Província de Fukushima",
      "thName": "นากะโดริ จังหวัดฟุกุชิมะ",
      "viName": "Nakadori, tỉnh Fukushima",
      "inName": "Nakadori, Prefektur Fukushima",
      "tlName": "Nakadori, Fukushima Prefecture",
      "moName": "Фүкүшима аймаг, Накадори",
      "buName": "နကိုဒိုယိ၊ ဟုခုရှိမစီရင်စု",
      "khName": "តំបន់ណាកាដូរីនៃខេត្តហ្វឹគឹស៊ីម៉ា",
      "neName": "फुकुसिमा जिल्ला, नाकादोरी"
    },
    "class15": {
      "code": "070012",
      "name": "中通り中部",
      "enName": "Central Nakadori"
    },
    "class20": {
      "code": "0732200",
      "name": "大玉村",
      "enName": "Otama Village",
      "kana": "おおたまむら",
      "chName": "大玉村",
      "zhName": "大玉村",
      "koName": "오타마 촌",
      "esName": "Aldea de Otama",
      "ptName": "povoado de Otama",
      "thName": "หมู่บ้านโอตามะ",
      "viName": "làng Otama",
      "inName": "desa Otama",
      "tlName": "nayon ng Otama",
      "moName": "Отамa тосгон",
      "buName": "အိုတားမ ကျေးရွာ",
      "khName": "ភូមិ អូតាម៉ា",
      "neName": "ओतामा गाउँ"
    }
  },
  "0734200": {
    "office": {
      "code": "070000",
      "name": "福島県",
      "enName": "Fukushima",
      "officeName": "福島地方気象台",
      "chName": "福岛县",
      "zhName": "福島縣",
      "koName": "후쿠시마현",
      "esName": "Prefectura de Fukushima",
      "ptName": "Província de Fukushima",
      "thName": "จังหวัดฟุกุชิมะ",
      "viName": "Tỉnh Fukushima",
      "inName": "Prefektur Fukushima",
      "tlName": "Fukushima Prefecture",
      "moName": "Фүкүшима аймаг",
      "buName": "ဖူကူရှီမ ပြည်နယ်",
      "khName": "ខេត្ត ហ្វូគូស៊ីម៉ា",
      "neName": "फुकुसिमा जिल्ला"
    },
    "class10": {
      "code": "070010",
      "name": "中通り",
      "enName": "Nakadori",
      "chName": "福岛县中通道",
      "zhName": "福島縣中通",
      "koName": "후쿠시마 현 나카도리",
      "esName": "Nakadori, Prefectura de Fukushima",
      "ptName": "Naka-dōri da Província de Fukushima",
      "thName": "นากะโดริ จังหวัดฟุกุชิมะ",
      "viName": "Nakadori, tỉnh Fukushima",
      "inName": "Nakadori, Prefektur Fukushima",
      "tlName": "Nakadori, Fukushima Prefecture",
      "moName": "Фүкүшима аймаг, Накадори",
      "buName": "နကိုဒိုယိ၊ ဟုခုရှိမစီရင်စု",
      "khName": "តំបន់ណាកាដូរីនៃខេត្តហ្វឹគឹស៊ីម៉ា",
      "neName": "फुकुसिमा जिल्ला, नाकादोरी"
    },
    "class15": {
      "code": "070012",
      "name": "中通り中部",
      "enName": "Central Nakadori"
    },
    "class20": {
      "code": "0734200",
      "name": "鏡石町",
      "enName": "Kagamiishi Town",
      "kana": "かがみいしまち",
      "chName": "镜石町",
      "zhName": "鏡石町",
      "koName": "가가미이시 정",
      "esName": "Pueblo de Kagamiishi",
      "ptName": "bairro de Kagamiishi",
      "thName": "เมืองคางามิอิชิ",
      "viName": "thị trấn Kagamiishi",
      "inName": "kota Kagamiishi",
      "tlName": "bayan ng Kagamiishi",
      "moName": "Кагaмийши жижиг хот",
      "buName": "ခါဂါမီးယိရှိ မြို့နယ်",
      "khName": "ទីប្រជុំជន កាហ្គាមីស៊ី",
      "neName": "कागामीइशी नगर"
    }
  },
  "0734401": {
    "office": {
      "code": "070000",
      "name": "福島県",
      "enName": "Fukushima",
      "officeName": "福島地方気象台",
      "chName": "福岛县",
      "zhName": "福島縣",
      "koName": "후쿠시마현",
      "esName": "Prefectura de Fukushima",
      "ptName": "Província de Fukushima",
      "thName": "จังหวัดฟุกุชิมะ",
      "viName": "Tỉnh Fukushima",
      "inName": "Prefektur Fukushima",
      "tlName": "Fukushima Prefecture",
      "moName": "Фүкүшима аймаг",
      "buName": "ဖူကူရှီမ ပြည်နယ်",
      "khName": "ខេត្ត ហ្វូគូស៊ីម៉ា",
      "neName": "फुकुसिमा जिल्ला"
    },
    "class10": {
      "code": "070010",
      "name": "中通り",
      "enName": "Nakadori",
      "chName": "福岛县中通道",
      "zhName": "福島縣中通",
      "koName": "후쿠시마 현 나카도리",
      "esName": "Nakadori, Prefectura de Fukushima",
      "ptName": "Naka-dōri da Província de Fukushima",
      "thName": "นากะโดริ จังหวัดฟุกุชิมะ",
      "viName": "Nakadori, tỉnh Fukushima",
      "inName": "Nakadori, Prefektur Fukushima",
      "tlName": "Nakadori, Fukushima Prefecture",
      "moName": "Фүкүшима аймаг, Накадори",
      "buName": "နကိုဒိုယိ၊ ဟုခုရှိမစီရင်စု",
      "khName": "តំបន់ណាកាដូរីនៃខេត្តហ្វឹគឹស៊ីម៉ា",
      "neName": "फुकुसिमा जिल्ला, नाकादोरी"
    },
    "class15": {
      "code": "070012",
      "name": "中通り中部",
      "enName": "Central Nakadori"
    },
    "class20": {
      "code": "0734401",
      "name": "天栄村",
      "enName": "Tenei Village",
      "kana": "てんえいむら",
      "chName": "天栄村",
      "zhName": "天栄村",
      "koName": "텐에이촌",
      "esName": "Aldea Tenei",
      "ptName": "Aldeia de Tenei",
      "thName": "หมู่บ้านเทเนอี",
      "viName": "Làng Tenei",
      "inName": "Tenei, Desa Tenei",
      "tlName": "Bayan ng Tenei",
      "moName": "Aldeia de Tenei",
      "buName": "တင်အဲမြို့",
      "khName": "ភូមិតេនអេ",
      "neName": "तेनई गाउँ"
    }
  },
  "0734402": {
    "office": {
      "code": "070000",
      "name": "福島県",
      "enName": "Fukushima",
      "officeName": "福島地方気象台",
      "chName": "福岛县",
      "zhName": "福島縣",
      "koName": "후쿠시마현",
      "esName": "Prefectura de Fukushima",
      "ptName": "Província de Fukushima",
      "thName": "จังหวัดฟุกุชิมะ",
      "viName": "Tỉnh Fukushima",
      "inName": "Prefektur Fukushima",
      "tlName": "Fukushima Prefecture",
      "moName": "Фүкүшима аймаг",
      "buName": "ဖူကူရှီမ ပြည်နယ်",
      "khName": "ខេត្ត ហ្វូគូស៊ីម៉ា",
      "neName": "फुकुसिमा जिल्ला"
    },
    "class10": {
      "code": "070030",
      "name": "会津",
      "enName": "Aizu",
      "chName": "福岛县会津",
      "zhName": "福島縣會津",
      "koName": "후쿠시마 현 아이즈",
      "esName": "Aizu, Prefectura de Fukushima",
      "ptName": "Aizu da Província de Fukushima",
      "thName": "ไอซุ จังหวัดฟุกุชิมะ",
      "viName": "Aizu, tỉnh Fukushima",
      "inName": "Aizu, Prefektur Fukushima",
      "tlName": "Aizu, Fukushima Prefecture",
      "moName": "Фүкүшима аймаг, Айзү",
      "buName": "အအိဇု၊ ဟုခုရှိမစီရင်စု",
      "khName": "តំបន់អៃហ្សីនៃខេត្តហ្វឹគឹស៊ីម៉ា",
      "neName": "फुकुसिमा जिल्ला, आइजु"
    },
    "class15": {
      "code": "070033",
      "name": "会津南部",
      "enName": "Southern Aizu"
    },
    "class20": {
      "code": "0734402",
      "name": "天栄村湯本",
      "enName": "Yumoto, Tenei Village",
      "kana": "てんえいむらゆもと",
      "chName": "天栄村汤本",
      "zhName": "天栄村汤本",
      "koName": "텐에이촌 유모토",
      "esName": "Yumoto, Aldea Tenei",
      "ptName": "Yumoto, Aldeia de Tenei",
      "thName": "ยูโมโต, หมู่บ้านเทเนอี",
      "viName": "Yumoto, Làng Tenei",
      "inName": "Yumoto, Desa Tenei",
      "tlName": "Yumoto, Bayan ng Tenei",
      "moName": "Yumoto, Aldeia de Tenei",
      "buName": "ယူမိုတို၊ တင်အဲမြို့",
      "khName": "ភូមិតេនអេយូមូត",
      "neName": "युमोटो तेनई गाउँ"
    }
  },
  "0736200": {
    "office": {
      "code": "070000",
      "name": "福島県",
      "enName": "Fukushima",
      "officeName": "福島地方気象台",
      "chName": "福岛县",
      "zhName": "福島縣",
      "koName": "후쿠시마현",
      "esName": "Prefectura de Fukushima",
      "ptName": "Província de Fukushima",
      "thName": "จังหวัดฟุกุชิมะ",
      "viName": "Tỉnh Fukushima",
      "inName": "Prefektur Fukushima",
      "tlName": "Fukushima Prefecture",
      "moName": "Фүкүшима аймаг",
      "buName": "ဖူကူရှီမ ပြည်နယ်",
      "khName": "ខេត្ត ហ្វូគូស៊ីម៉ា",
      "neName": "फुकुसिमा जिल्ला"
    },
    "class10": {
      "code": "070030",
      "name": "会津",
      "enName": "Aizu",
      "chName": "福岛县会津",
      "zhName": "福島縣會津",
      "koName": "후쿠시마 현 아이즈",
      "esName": "Aizu, Prefectura de Fukushima",
      "ptName": "Aizu da Província de Fukushima",
      "thName": "ไอซุ จังหวัดฟุกุชิมะ",
      "viName": "Aizu, tỉnh Fukushima",
      "inName": "Aizu, Prefektur Fukushima",
      "tlName": "Aizu, Fukushima Prefecture",
      "moName": "Фүкүшима аймаг, Айзү",
      "buName": "အအိဇု၊ ဟုခုရှိမစီရင်စု",
      "khName": "តំបន់អៃហ្សីនៃខេត្តហ្វឹគឹស៊ីម៉ា",
      "neName": "फुकुसिमा जिल्ला, आइजु"
    },
    "class15": {
      "code": "070033",
      "name": "会津南部",
      "enName": "Southern Aizu"
    },
    "class20": {
      "code": "0736200",
      "name": "下郷町",
      "enName": "Shimogo Town",
      "kana": "しもごうまち",
      "chName": "下乡町",
      "zhName": "下鄉町",
      "koName": "시모고 정",
      "esName": "Pueblo de Shimogou",
      "ptName": "bairro de Shimogo",
      "thName": "เมืองชิโมโงะ",
      "viName": "thị trấn Shimogo",
      "inName": "kota Shimogo",
      "tlName": "bayan ng Shimogo",
      "moName": "Шимого жижиг хот",
      "buName": "ရှီးမိုဂေါ့ မြို့နယ်",
      "khName": "ទីប្រជុំជន ស៊ីមូហ្កូ",
      "neName": "शिमोगो नगर"
    }
  },
  "0736400": {
    "office": {
      "code": "070000",
      "name": "福島県",
      "enName": "Fukushima",
      "officeName": "福島地方気象台",
      "chName": "福岛县",
      "zhName": "福島縣",
      "koName": "후쿠시마현",
      "esName": "Prefectura de Fukushima",
      "ptName": "Província de Fukushima",
      "thName": "จังหวัดฟุกุชิมะ",
      "viName": "Tỉnh Fukushima",
      "inName": "Prefektur Fukushima",
      "tlName": "Fukushima Prefecture",
      "moName": "Фүкүшима аймаг",
      "buName": "ဖူကူရှီမ ပြည်နယ်",
      "khName": "ខេត្ត ហ្វូគូស៊ីម៉ា",
      "neName": "फुकुसिमा जिल्ला"
    },
    "class10": {
      "code": "070030",
      "name": "会津",
      "enName": "Aizu",
      "chName": "福岛县会津",
      "zhName": "福島縣會津",
      "koName": "후쿠시마 현 아이즈",
      "esName": "Aizu, Prefectura de Fukushima",
      "ptName": "Aizu da Província de Fukushima",
      "thName": "ไอซุ จังหวัดฟุกุชิมะ",
      "viName": "Aizu, tỉnh Fukushima",
      "inName": "Aizu, Prefektur Fukushima",
      "tlName": "Aizu, Fukushima Prefecture",
      "moName": "Фүкүшима аймаг, Айзү",
      "buName": "အအိဇု၊ ဟုခုရှိမစီရင်စု",
      "khName": "តំបន់អៃហ្សីនៃខេត្តហ្វឹគឹស៊ីម៉ា",
      "neName": "फुकुसिमा जिल्ला, आइजु"
    },
    "class15": {
      "code": "070033",
      "name": "会津南部",
      "enName": "Southern Aizu"
    },
    "class20": {
      "code": "0736400",
      "name": "檜枝岐村",
      "enName": "Hinoemata Village",
      "kana": "ひのえまたむら",
      "chName": "桧枝岐村",
      "zhName": "檜枝岐村",
      "koName": "히노에마타 촌",
      "esName": "Aldea de Hinoemata",
      "ptName": "povoado de Hinoemata",
      "thName": "หมู่บ้านฮิโนเอะมาตะ",
      "viName": "làng Hinoemata",
      "inName": "desa Hinoemata",
      "tlName": "nayon ng Hinoemata",
      "moName": "Хиноэмaта тосгон",
      "buName": "ဟီနောအဲမာ့တ ကျေးရွာ",
      "khName": "ភូមិ ហ៊ីណូមេតា",
      "neName": "हिनोएमाता गाउँ"
    }
  },
  "0736700": {
    "office": {
      "code": "070000",
      "name": "福島県",
      "enName": "Fukushima",
      "officeName": "福島地方気象台",
      "chName": "福岛县",
      "zhName": "福島縣",
      "koName": "후쿠시마현",
      "esName": "Prefectura de Fukushima",
      "ptName": "Província de Fukushima",
      "thName": "จังหวัดฟุกุชิมะ",
      "viName": "Tỉnh Fukushima",
      "inName": "Prefektur Fukushima",
      "tlName": "Fukushima Prefecture",
      "moName": "Фүкүшима аймаг",
      "buName": "ဖူကူရှီမ ပြည်နယ်",
      "khName": "ខេត្ត ហ្វូគូស៊ីម៉ា",
      "neName": "फुकुसिमा जिल्ला"
    },
    "class10": {
      "code": "070030",
      "name": "会津",
      "enName": "Aizu",
      "chName": "福岛县会津",
      "zhName": "福島縣會津",
      "koName": "후쿠시마 현 아이즈",
      "esName": "Aizu, Prefectura de Fukushima",
      "ptName": "Aizu da Província de Fukushima",
      "thName": "ไอซุ จังหวัดฟุกุชิมะ",
      "viName": "Aizu, tỉnh Fukushima",
      "inName": "Aizu, Prefektur Fukushima",
      "tlName": "Aizu, Fukushima Prefecture",
      "moName": "Фүкүшима аймаг, Айзү",
      "buName": "အအိဇု၊ ဟုခုရှိမစီရင်စု",
      "khName": "តំបន់អៃហ្សីនៃខេត្តហ្វឹគឹស៊ីម៉ា",
      "neName": "फुकुसिमा जिल्ला, आइजु"
    },
    "class15": {
      "code": "070033",
      "name": "会津南部",
      "enName": "Southern Aizu"
    },
    "class20": {
      "code": "0736700",
      "name": "只見町",
      "enName": "Tadami Town",
      "kana": "ただみまち",
      "chName": "只见町",
      "zhName": "只見町",
      "koName": "다다미 정",
      "esName": "Pueblo de Tadami",
      "ptName": "bairro de Tadami",
      "thName": "เมืองทาดามิ",
      "viName": "thị trấn Tadami",
      "inName": "kota Tadami",
      "tlName": "bayan ng Tadami",
      "moName": "Тадами жижиг хот",
      "buName": "တားဒါ့မိ မြို့နယ်",
      "khName": "ទីប្រជុំជន តាដាមី",
      "neName": "तादामी नगर"
    }
  },
  "0736800": {
    "office": {
      "code": "070000",
      "name": "福島県",
      "enName": "Fukushima",
      "officeName": "福島地方気象台",
      "chName": "福岛县",
      "zhName": "福島縣",
      "koName": "후쿠시마현",
      "esName": "Prefectura de Fukushima",
      "ptName": "Província de Fukushima",
      "thName": "จังหวัดฟุกุชิมะ",
      "viName": "Tỉnh Fukushima",
      "inName": "Prefektur Fukushima",
      "tlName": "Fukushima Prefecture",
      "moName": "Фүкүшима аймаг",
      "buName": "ဖူကူရှီမ ပြည်နယ်",
      "khName": "ខេត្ត ហ្វូគូស៊ីម៉ា",
      "neName": "फुकुसिमा जिल्ला"
    },
    "class10": {
      "code": "070030",
      "name": "会津",
      "enName": "Aizu",
      "chName": "福岛县会津",
      "zhName": "福島縣會津",
      "koName": "후쿠시마 현 아이즈",
      "esName": "Aizu, Prefectura de Fukushima",
      "ptName": "Aizu da Província de Fukushima",
      "thName": "ไอซุ จังหวัดฟุกุชิมะ",
      "viName": "Aizu, tỉnh Fukushima",
      "inName": "Aizu, Prefektur Fukushima",
      "tlName": "Aizu, Fukushima Prefecture",
      "moName": "Фүкүшима аймаг, Айзү",
      "buName": "အအိဇု၊ ဟုခုရှိမစီရင်စု",
      "khName": "តំបន់អៃហ្សីនៃខេត្តហ្វឹគឹស៊ីម៉ា",
      "neName": "फुकुसिमा जिल्ला, आइजु"
    },
    "class15": {
      "code": "070033",
      "name": "会津南部",
      "enName": "Southern Aizu"
    },
    "class20": {
      "code": "0736800",
      "name": "南会津町",
      "enName": "Minamiaizu Town",
      "kana": "みなみあいづまち",
      "chName": "南会津町",
      "zhName": "南會津町",
      "koName": "미나미아이즈 정",
      "esName": "Pueblo de Minamiaizu",
      "ptName": "bairro de Minamiaizu",
      "thName": "เมืองมินามิไอสุ",
      "viName": "thị trấn Minamiaizu",
      "inName": "kota Minamiaizu",
      "tlName": "bayan ng Minamiaizu",
      "moName": "Минaмиaйзү жижиг хот",
      "buName": "မီနားမိယားဇု မြို့နယ်",
      "khName": "ទីប្រជុំជន មីណាមីអាអ៊ីហ្សូ៊",
      "neName": "मिनामिआइजु नगर"
    }
  },
  "0740200": {
    "office": {
      "code": "070000",
      "name": "福島県",
      "enName": "Fukushima",
      "officeName": "福島地方気象台",
      "chName": "福岛县",
      "zhName": "福島縣",
      "koName": "후쿠시마현",
      "esName": "Prefectura de Fukushima",
      "ptName": "Província de Fukushima",
      "thName": "จังหวัดฟุกุชิมะ",
      "viName": "Tỉnh Fukushima",
      "inName": "Prefektur Fukushima",
      "tlName": "Fukushima Prefecture",
      "moName": "Фүкүшима аймаг",
      "buName": "ဖူကူရှီမ ပြည်နယ်",
      "khName": "ខេត្ត ហ្វូគូស៊ីម៉ា",
      "neName": "फुकुसिमा जिल्ला"
    },
    "class10": {
      "code": "070030",
      "name": "会津",
      "enName": "Aizu",
      "chName": "福岛县会津",
      "zhName": "福島縣會津",
      "koName": "후쿠시마 현 아이즈",
      "esName": "Aizu, Prefectura de Fukushima",
      "ptName": "Aizu da Província de Fukushima",
      "thName": "ไอซุ จังหวัดฟุกุชิมะ",
      "viName": "Aizu, tỉnh Fukushima",
      "inName": "Aizu, Prefektur Fukushima",
      "tlName": "Aizu, Fukushima Prefecture",
      "moName": "Фүкүшима аймаг, Айзү",
      "buName": "အအိဇု၊ ဟုခုရှိမစီရင်စု",
      "khName": "តំបន់អៃហ្សីនៃខេត្តហ្វឹគឹស៊ីម៉ា",
      "neName": "फुकुसिमा जिल्ला, आइजु"
    },
    "class15": {
      "code": "070031",
      "name": "会津北部",
      "enName": "Northern Aizu"
    },
    "class20": {
      "code": "0740200",
      "name": "北塩原村",
      "enName": "Kitashiobara Village",
      "kana": "きたしおばらむら",
      "chName": "北盐原村",
      "zhName": "北鹽原村",
      "koName": "기타시오바라 촌",
      "esName": "Aldea de Kitashiobara",
      "ptName": "povoado de Kitashiobara",
      "thName": "หมู่บ้านคิตะชิโอบาระ",
      "viName": "làng Kitashiobara",
      "inName": "desa Kitashiobara",
      "tlName": "nayon ng Kitashiobara",
      "moName": "Киташиобара тосгон",
      "buName": "ခီတာရှိရိုးဘာ့တ ကျေးရွာ",
      "khName": "ភូមិ គីតាស៊ីអូបារ៉ា",
      "neName": "किताशिओबारा गाउँ"
    }
  },
  "0740500": {
    "office": {
      "code": "070000",
      "name": "福島県",
      "enName": "Fukushima",
      "officeName": "福島地方気象台",
      "chName": "福岛县",
      "zhName": "福島縣",
      "koName": "후쿠시마현",
      "esName": "Prefectura de Fukushima",
      "ptName": "Província de Fukushima",
      "thName": "จังหวัดฟุกุชิมะ",
      "viName": "Tỉnh Fukushima",
      "inName": "Prefektur Fukushima",
      "tlName": "Fukushima Prefecture",
      "moName": "Фүкүшима аймаг",
      "buName": "ဖူကူရှီမ ပြည်နယ်",
      "khName": "ខេត្ត ហ្វូគូស៊ីម៉ា",
      "neName": "फुकुसिमा जिल्ला"
    },
    "class10": {
      "code": "070030",
      "name": "会津",
      "enName": "Aizu",
      "chName": "福岛县会津",
      "zhName": "福島縣會津",
      "koName": "후쿠시마 현 아이즈",
      "esName": "Aizu, Prefectura de Fukushima",
      "ptName": "Aizu da Província de Fukushima",
      "thName": "ไอซุ จังหวัดฟุกุชิมะ",
      "viName": "Aizu, tỉnh Fukushima",
      "inName": "Aizu, Prefektur Fukushima",
      "tlName": "Aizu, Fukushima Prefecture",
      "moName": "Фүкүшима аймаг, Айзү",
      "buName": "အအိဇု၊ ဟုခုရှိမစီရင်စု",
      "khName": "តំបន់អៃហ្សីនៃខេត្តហ្វឹគឹស៊ីម៉ា",
      "neName": "फुकुसिमा जिल्ला, आइजु"
    },
    "class15": {
      "code": "070031",
      "name": "会津北部",
      "enName": "Northern Aizu"
    },
    "class20": {
      "code": "0740500",
      "name": "西会津町",
      "enName": "Nishiaizu Town",
      "kana": "にしあいづまち",
      "chName": "西会津町",
      "zhName": "西會津町",
      "koName": "니시아이즈 정",
      "esName": "Pueblo de Nishiaizu",
      "ptName": "bairro de Nishiaizu",
      "thName": "เมืองนิชิไอสุ",
      "viName": "thị trấn Nishiaizu",
      "inName": "kota Nishiaizu",
      "tlName": "bayan ng Nishiaizu",
      "moName": "Нишиaйзү жижиг хот",
      "buName": "နီရှိယားဇု မြို့နယ်",
      "khName": "ទីប្រជុំជន នីស៊ីអៃហ្សូ",
      "neName": "निशिआइजु नगर"
    }
  },
  "0740700": {
    "office": {
      "code": "070000",
      "name": "福島県",
      "enName": "Fukushima",
      "officeName": "福島地方気象台",
      "chName": "福岛县",
      "zhName": "福島縣",
      "koName": "후쿠시마현",
      "esName": "Prefectura de Fukushima",
      "ptName": "Província de Fukushima",
      "thName": "จังหวัดฟุกุชิมะ",
      "viName": "Tỉnh Fukushima",
      "inName": "Prefektur Fukushima",
      "tlName": "Fukushima Prefecture",
      "moName": "Фүкүшима аймаг",
      "buName": "ဖူကူရှီမ ပြည်နယ်",
      "khName": "ខេត្ត ហ្វូគូស៊ីម៉ា",
      "neName": "फुकुसिमा जिल्ला"
    },
    "class10": {
      "code": "070030",
      "name": "会津",
      "enName": "Aizu",
      "chName": "福岛县会津",
      "zhName": "福島縣會津",
      "koName": "후쿠시마 현 아이즈",
      "esName": "Aizu, Prefectura de Fukushima",
      "ptName": "Aizu da Província de Fukushima",
      "thName": "ไอซุ จังหวัดฟุกุชิมะ",
      "viName": "Aizu, tỉnh Fukushima",
      "inName": "Aizu, Prefektur Fukushima",
      "tlName": "Aizu, Fukushima Prefecture",
      "moName": "Фүкүшима аймаг, Айзү",
      "buName": "အအိဇု၊ ဟုခုရှိမစီရင်စု",
      "khName": "តំបន់អៃហ្សីនៃខេត្តហ្វឹគឹស៊ីម៉ា",
      "neName": "फुकुसिमा जिल्ला, आइजु"
    },
    "class15": {
      "code": "070031",
      "name": "会津北部",
      "enName": "Northern Aizu"
    },
    "class20": {
      "code": "0740700",
      "name": "磐梯町",
      "enName": "Bandai Town",
      "kana": "ばんだいまち",
      "chName": "磐梯町",
      "zhName": "磐梯町",
      "koName": "반다이 정",
      "esName": "Pueblo de Bandai",
      "ptName": "bairro de Bandai",
      "thName": "เมืองบันได",
      "viName": "thị trấn Bandai",
      "inName": "kota Bandai",
      "tlName": "bayan ng Bandai",
      "moName": "Бандай жижиг хот",
      "buName": "ဘန်းဒိုင်ယိ မြို့နယ်",
      "khName": "ទីប្រជុំជន បានដៃ",
      "neName": "बान्दाई नगर"
    }
  },
  "0740800": {
    "office": {
      "code": "070000",
      "name": "福島県",
      "enName": "Fukushima",
      "officeName": "福島地方気象台",
      "chName": "福岛县",
      "zhName": "福島縣",
      "koName": "후쿠시마현",
      "esName": "Prefectura de Fukushima",
      "ptName": "Província de Fukushima",
      "thName": "จังหวัดฟุกุชิมะ",
      "viName": "Tỉnh Fukushima",
      "inName": "Prefektur Fukushima",
      "tlName": "Fukushima Prefecture",
      "moName": "Фүкүшима аймаг",
      "buName": "ဖူကူရှီမ ပြည်နယ်",
      "khName": "ខេត្ត ហ្វូគូស៊ីម៉ា",
      "neName": "फुकुसिमा जिल्ला"
    },
    "class10": {
      "code": "070030",
      "name": "会津",
      "enName": "Aizu",
      "chName": "福岛县会津",
      "zhName": "福島縣會津",
      "koName": "후쿠시마 현 아이즈",
      "esName": "Aizu, Prefectura de Fukushima",
      "ptName": "Aizu da Província de Fukushima",
      "thName": "ไอซุ จังหวัดฟุกุชิมะ",
      "viName": "Aizu, tỉnh Fukushima",
      "inName": "Aizu, Prefektur Fukushima",
      "tlName": "Aizu, Fukushima Prefecture",
      "moName": "Фүкүшима аймаг, Айзү",
      "buName": "အအိဇု၊ ဟုခုရှိမစီရင်စု",
      "khName": "តំបន់អៃហ្សីនៃខេត្តហ្វឹគឹស៊ីម៉ា",
      "neName": "फुकुसिमा जिल्ला, आइजु"
    },
    "class15": {
      "code": "070031",
      "name": "会津北部",
      "enName": "Northern Aizu"
    },
    "class20": {
      "code": "0740800",
      "name": "猪苗代町",
      "enName": "Inawashiro Town",
      "kana": "いなわしろまち",
      "chName": "猪苗代町",
      "zhName": "豬苗代町",
      "koName": "이나와시로 정",
      "esName": "Pueblo de Inawashiro",
      "ptName": "bairro de Inawashiro",
      "thName": "เมืองอินาวาชิโระ",
      "viName": "thị trấn Inawashiro",
      "inName": "kota Inawashiro",
      "tlName": "bayan ng Inawashiro",
      "moName": "Инаваширо жижиг хот",
      "buName": "အီနားဝါ့ရှိရို မြို့နယ်",
      "khName": "ទីប្រជុំជន អ៊ីណាវ៉ាស៊ីរ៉ូ",
      "neName": "इनावाशिरो नगर"
    }
  },
  "0742100": {
    "office": {
      "code": "070000",
      "name": "福島県",
      "enName": "Fukushima",
      "officeName": "福島地方気象台",
      "chName": "福岛县",
      "zhName": "福島縣",
      "koName": "후쿠시마현",
      "esName": "Prefectura de Fukushima",
      "ptName": "Província de Fukushima",
      "thName": "จังหวัดฟุกุชิมะ",
      "viName": "Tỉnh Fukushima",
      "inName": "Prefektur Fukushima",
      "tlName": "Fukushima Prefecture",
      "moName": "Фүкүшима аймаг",
      "buName": "ဖူကူရှီမ ပြည်နယ်",
      "khName": "ខេត្ត ហ្វូគូស៊ីម៉ា",
      "neName": "फुकुसिमा जिल्ला"
    },
    "class10": {
      "code": "070030",
      "name": "会津",
      "enName": "Aizu",
      "chName": "福岛县会津",
      "zhName": "福島縣會津",
      "koName": "후쿠시마 현 아이즈",
      "esName": "Aizu, Prefectura de Fukushima",
      "ptName": "Aizu da Província de Fukushima",
      "thName": "ไอซุ จังหวัดฟุกุชิมะ",
      "viName": "Aizu, tỉnh Fukushima",
      "inName": "Aizu, Prefektur Fukushima",
      "tlName": "Aizu, Fukushima Prefecture",
      "moName": "Фүкүшима аймаг, Айзү",
      "buName": "အအိဇု၊ ဟုခုရှိမစီရင်စု",
      "khName": "តំបន់អៃហ្សីនៃខេត្តហ្វឹគឹស៊ីម៉ា",
      "neName": "फुकुसिमा जिल्ला, आइजु"
    },
    "class15": {
      "code": "070032",
      "name": "会津中部",
      "enName": "Central Aizu"
    },
    "class20": {
      "code": "0742100",
      "name": "会津坂下町",
      "enName": "Aizubange Town",
      "kana": "あいづばんげまち",
      "chName": "会津坂下町",
      "zhName": "會津坂下町",
      "koName": "아이즈반게 정",
      "esName": "Pueblo de Aizubange",
      "ptName": "bairro de Aizubange",
      "thName": "เมืองไอสุบังเงะ",
      "viName": "thị trấn Aizubange",
      "inName": "kota Aizubange",
      "tlName": "bayan ng Aizubange",
      "moName": "Aйзүбангэ жижиг хот",
      "buName": "အိုင်ယိဇုဘန်းဂဲ့ မြို့နယ်",
      "khName": "ទីប្រជុំជន អៃស៊ូបាំងជី",
      "neName": "आइजुबान्गे नगर"
    }
  },
  "0742200": {
    "office": {
      "code": "070000",
      "name": "福島県",
      "enName": "Fukushima",
      "officeName": "福島地方気象台",
      "chName": "福岛县",
      "zhName": "福島縣",
      "koName": "후쿠시마현",
      "esName": "Prefectura de Fukushima",
      "ptName": "Província de Fukushima",
      "thName": "จังหวัดฟุกุชิมะ",
      "viName": "Tỉnh Fukushima",
      "inName": "Prefektur Fukushima",
      "tlName": "Fukushima Prefecture",
      "moName": "Фүкүшима аймаг",
      "buName": "ဖူကူရှီမ ပြည်နယ်",
      "khName": "ខេត្ត ហ្វូគូស៊ីម៉ា",
      "neName": "फुकुसिमा जिल्ला"
    },
    "class10": {
      "code": "070030",
      "name": "会津",
      "enName": "Aizu",
      "chName": "福岛县会津",
      "zhName": "福島縣會津",
      "koName": "후쿠시마 현 아이즈",
      "esName": "Aizu, Prefectura de Fukushima",
      "ptName": "Aizu da Província de Fukushima",
      "thName": "ไอซุ จังหวัดฟุกุชิมะ",
      "viName": "Aizu, tỉnh Fukushima",
      "inName": "Aizu, Prefektur Fukushima",
      "tlName": "Aizu, Fukushima Prefecture",
      "moName": "Фүкүшима аймаг, Айзү",
      "buName": "အအိဇု၊ ဟုခုရှိမစီရင်စု",
      "khName": "តំបន់អៃហ្សីនៃខេត្តហ្វឹគឹស៊ីម៉ា",
      "neName": "फुकुसिमा जिल्ला, आइजु"
    },
    "class15": {
      "code": "070032",
      "name": "会津中部",
      "enName": "Central Aizu"
    },
    "class20": {
      "code": "0742200",
      "name": "湯川村",
      "enName": "Yugawa Village",
      "kana": "ゆがわむら",
      "chName": "汤川村",
      "zhName": "湯川村",
      "koName": "유가와 촌",
      "esName": "Aldea de Yugawa",
      "ptName": "povoado de Yugawa",
      "thName": "หมู่บ้านยุกาวะ",
      "viName": "làng Yugawa",
      "inName": "desa Yugawa",
      "tlName": "nayon ng Yugawa",
      "moName": "Югава тосгон",
      "buName": "ယုဂါ့ဝ ကျေးရွာ",
      "khName": "ភូមិ យូហ្កាវ៉ា",
      "neName": "युगावा गाउँ"
    }
  },
  "0742300": {
    "office": {
      "code": "070000",
      "name": "福島県",
      "enName": "Fukushima",
      "officeName": "福島地方気象台",
      "chName": "福岛县",
      "zhName": "福島縣",
      "koName": "후쿠시마현",
      "esName": "Prefectura de Fukushima",
      "ptName": "Província de Fukushima",
      "thName": "จังหวัดฟุกุชิมะ",
      "viName": "Tỉnh Fukushima",
      "inName": "Prefektur Fukushima",
      "tlName": "Fukushima Prefecture",
      "moName": "Фүкүшима аймаг",
      "buName": "ဖူကူရှီမ ပြည်နယ်",
      "khName": "ខេត្ត ហ្វូគូស៊ីម៉ា",
      "neName": "फुकुसिमा जिल्ला"
    },
    "class10": {
      "code": "070030",
      "name": "会津",
      "enName": "Aizu",
      "chName": "福岛县会津",
      "zhName": "福島縣會津",
      "koName": "후쿠시마 현 아이즈",
      "esName": "Aizu, Prefectura de Fukushima",
      "ptName": "Aizu da Província de Fukushima",
      "thName": "ไอซุ จังหวัดฟุกุชิมะ",
      "viName": "Aizu, tỉnh Fukushima",
      "inName": "Aizu, Prefektur Fukushima",
      "tlName": "Aizu, Fukushima Prefecture",
      "moName": "Фүкүшима аймаг, Айзү",
      "buName": "အအိဇု၊ ဟုခုရှိမစီရင်စု",
      "khName": "តំបន់អៃហ្សីនៃខេត្តហ្វឹគឹស៊ីម៉ា",
      "neName": "फुकुसिमा जिल्ला, आइजु"
    },
    "class15": {
      "code": "070032",
      "name": "会津中部",
      "enName": "Central Aizu"
    },
    "class20": {
      "code": "0742300",
      "name": "柳津町",
      "enName": "Yanaizu Town",
      "kana": "やないづまち",
      "chName": "柳津町",
      "zhName": "柳津町",
      "koName": "야나이즈 정",
      "esName": "Pueblo de Yanaizu",
      "ptName": "bairro de Yanaizu",
      "thName": "เมืองยานาอิสุ",
      "viName": "thị trấn Yanaizu",
      "inName": "kota Yanaizu",
      "tlName": "bayan ng Yanaizu",
      "moName": "Янaйзү жижиг хот",
      "buName": "ယာနားယိဇု မြို့နယ်",
      "khName": "ទីប្រជុំជន យ៉ាណៃហ្សូ៊",
      "neName": "यानाइजु नगर"
    }
  },
  "0744400": {
    "office": {
      "code": "070000",
      "name": "福島県",
      "enName": "Fukushima",
      "officeName": "福島地方気象台",
      "chName": "福岛县",
      "zhName": "福島縣",
      "koName": "후쿠시마현",
      "esName": "Prefectura de Fukushima",
      "ptName": "Província de Fukushima",
      "thName": "จังหวัดฟุกุชิมะ",
      "viName": "Tỉnh Fukushima",
      "inName": "Prefektur Fukushima",
      "tlName": "Fukushima Prefecture",
      "moName": "Фүкүшима аймаг",
      "buName": "ဖူကူရှီမ ပြည်နယ်",
      "khName": "ខេត្ត ហ្វូគូស៊ីម៉ា",
      "neName": "फुकुसिमा जिल्ला"
    },
    "class10": {
      "code": "070030",
      "name": "会津",
      "enName": "Aizu",
      "chName": "福岛县会津",
      "zhName": "福島縣會津",
      "koName": "후쿠시마 현 아이즈",
      "esName": "Aizu, Prefectura de Fukushima",
      "ptName": "Aizu da Província de Fukushima",
      "thName": "ไอซุ จังหวัดฟุกุชิมะ",
      "viName": "Aizu, tỉnh Fukushima",
      "inName": "Aizu, Prefektur Fukushima",
      "tlName": "Aizu, Fukushima Prefecture",
      "moName": "Фүкүшима аймаг, Айзү",
      "buName": "အအိဇု၊ ဟုခုရှိမစီရင်စု",
      "khName": "តំបន់អៃហ្សីនៃខេត្តហ្វឹគឹស៊ីម៉ា",
      "neName": "फुकुसिमा जिल्ला, आइजु"
    },
    "class15": {
      "code": "070032",
      "name": "会津中部",
      "enName": "Central Aizu"
    },
    "class20": {
      "code": "0744400",
      "name": "三島町",
      "enName": "Mishima Town",
      "kana": "みしままち",
      "chName": "三岛町",
      "zhName": "三島町",
      "koName": "미시마 정",
      "esName": "Pueblo de Mishima",
      "ptName": "bairro de Mishima",
      "thName": "เมืองมิชิมะ",
      "viName": "thị trấn Mishima",
      "inName": "kota Mishima",
      "tlName": "bayan ng Mishima",
      "moName": "Мишимa жижиг хот",
      "buName": "မီရှိမ မြို့နယ်",
      "khName": "ទីប្រជុំជន មីស៊ីម៉ា",
      "neName": "मिशिमा नगर"
    }
  },
  "0744500": {
    "office": {
      "code": "070000",
      "name": "福島県",
      "enName": "Fukushima",
      "officeName": "福島地方気象台",
      "chName": "福岛县",
      "zhName": "福島縣",
      "koName": "후쿠시마현",
      "esName": "Prefectura de Fukushima",
      "ptName": "Província de Fukushima",
      "thName": "จังหวัดฟุกุชิมะ",
      "viName": "Tỉnh Fukushima",
      "inName": "Prefektur Fukushima",
      "tlName": "Fukushima Prefecture",
      "moName": "Фүкүшима аймаг",
      "buName": "ဖူကူရှီမ ပြည်နယ်",
      "khName": "ខេត្ត ហ្វូគូស៊ីម៉ា",
      "neName": "फुकुसिमा जिल्ला"
    },
    "class10": {
      "code": "070030",
      "name": "会津",
      "enName": "Aizu",
      "chName": "福岛县会津",
      "zhName": "福島縣會津",
      "koName": "후쿠시마 현 아이즈",
      "esName": "Aizu, Prefectura de Fukushima",
      "ptName": "Aizu da Província de Fukushima",
      "thName": "ไอซุ จังหวัดฟุกุชิมะ",
      "viName": "Aizu, tỉnh Fukushima",
      "inName": "Aizu, Prefektur Fukushima",
      "tlName": "Aizu, Fukushima Prefecture",
      "moName": "Фүкүшима аймаг, Айзү",
      "buName": "အအိဇု၊ ဟုခုရှိမစီရင်စု",
      "khName": "តំបន់អៃហ្សីនៃខេត្តហ្វឹគឹស៊ីម៉ា",
      "neName": "फुकुसिमा जिल्ला, आइजु"
    },
    "class15": {
      "code": "070032",
      "name": "会津中部",
      "enName": "Central Aizu"
    },
    "class20": {
      "code": "0744500",
      "name": "金山町",
      "enName": "Kaneyama Town",
      "kana": "かねやままち",
      "chName": "福岛金山町",
      "zhName": "福島金山町",
      "koName": "후쿠시마 가네야마 정",
      "esName": "Pueblo de Kaneyama, Fukushima",
      "ptName": "Fukushima, bairro de Kaneyama",
      "thName": "เมืองคาเนยามะ ฟุกุชิมะ",
      "viName": "Thị trấn Kaneyama, Fukushima",
      "inName": "Kota Kaneyama, Fukushima",
      "tlName": "bayan ng Kaneyama, Fukushima",
      "moName": "Фукушима Канаяма жижиг хот",
      "buName": "ဟုခုရှိမခနဲယမမြို့နယ်",
      "khName": "ទីប្រជុំជនកាណេយ៉ាម៉ា ហ្វឹគឹស៊ីម៉ា",
      "neName": "फुकुसिमा कानेयामा नगर"
    }
  },
  "0744600": {
    "office": {
      "code": "070000",
      "name": "福島県",
      "enName": "Fukushima",
      "officeName": "福島地方気象台",
      "chName": "福岛县",
      "zhName": "福島縣",
      "koName": "후쿠시마현",
      "esName": "Prefectura de Fukushima",
      "ptName": "Província de Fukushima",
      "thName": "จังหวัดฟุกุชิมะ",
      "viName": "Tỉnh Fukushima",
      "inName": "Prefektur Fukushima",
      "tlName": "Fukushima Prefecture",
      "moName": "Фүкүшима аймаг",
      "buName": "ဖူကူရှီမ ပြည်နယ်",
      "khName": "ខេត្ត ហ្វូគូស៊ីម៉ា",
      "neName": "फुकुसिमा जिल्ला"
    },
    "class10": {
      "code": "070030",
      "name": "会津",
      "enName": "Aizu",
      "chName": "福岛县会津",
      "zhName": "福島縣會津",
      "koName": "후쿠시마 현 아이즈",
      "esName": "Aizu, Prefectura de Fukushima",
      "ptName": "Aizu da Província de Fukushima",
      "thName": "ไอซุ จังหวัดฟุกุชิมะ",
      "viName": "Aizu, tỉnh Fukushima",
      "inName": "Aizu, Prefektur Fukushima",
      "tlName": "Aizu, Fukushima Prefecture",
      "moName": "Фүкүшима аймаг, Айзү",
      "buName": "အအိဇု၊ ဟုခုရှိမစီရင်စု",
      "khName": "តំបន់អៃហ្សីនៃខេត្តហ្វឹគឹស៊ីម៉ា",
      "neName": "फुकुसिमा जिल्ला, आइजु"
    },
    "class15": {
      "code": "070032",
      "name": "会津中部",
      "enName": "Central Aizu"
    },
    "class20": {
      "code": "0744600",
      "name": "昭和村",
      "enName": "Showa Village",
      "kana": "しょうわむら",
      "chName": "福岛昭和村",
      "zhName": "福島昭和村",
      "koName": "후쿠시마 쇼와 촌",
      "esName": "Aldea de  Showa, Fukushima",
      "ptName": "Fukushima, povoado de Showa",
      "thName": "หมู่บ้านโชวะ ฟุกุชิมะ",
      "viName": "Làng Showa, Fukushima",
      "inName": "Desa Showa, Fukushima",
      "tlName": "nayon ng Showa, Fukushima",
      "moName": "Фукушима Шова тосгон",
      "buName": "ဟုခုရှိမရှောဝရွာ",
      "khName": "ភូមិសូវ៉ា ហ្វឹគឹស៊ីម៉ា",
      "neName": "फुकुसिमा शोवा गाउँ"
    }
  },
  "0744700": {
    "office": {
      "code": "070000",
      "name": "福島県",
      "enName": "Fukushima",
      "officeName": "福島地方気象台",
      "chName": "福岛县",
      "zhName": "福島縣",
      "koName": "후쿠시마현",
      "esName": "Prefectura de Fukushima",
      "ptName": "Província de Fukushima",
      "thName": "จังหวัดฟุกุชิมะ",
      "viName": "Tỉnh Fukushima",
      "inName": "Prefektur Fukushima",
      "tlName": "Fukushima Prefecture",
      "moName": "Фүкүшима аймаг",
      "buName": "ဖူကူရှီမ ပြည်နယ်",
      "khName": "ខេត្ត ហ្វូគូស៊ីម៉ា",
      "neName": "फुकुसिमा जिल्ला"
    },
    "class10": {
      "code": "070030",
      "name": "会津",
      "enName": "Aizu",
      "chName": "福岛县会津",
      "zhName": "福島縣會津",
      "koName": "후쿠시마 현 아이즈",
      "esName": "Aizu, Prefectura de Fukushima",
      "ptName": "Aizu da Província de Fukushima",
      "thName": "ไอซุ จังหวัดฟุกุชิมะ",
      "viName": "Aizu, tỉnh Fukushima",
      "inName": "Aizu, Prefektur Fukushima",
      "tlName": "Aizu, Fukushima Prefecture",
      "moName": "Фүкүшима аймаг, Айзү",
      "buName": "အအိဇု၊ ဟုခုရှိမစီရင်စု",
      "khName": "តំបន់អៃហ្សីនៃខេត្តហ្វឹគឹស៊ីម៉ា",
      "neName": "फुकुसिमा जिल्ला, आइजु"
    },
    "class15": {
      "code": "070032",
      "name": "会津中部",
      "enName": "Central Aizu"
    },
    "class20": {
      "code": "0744700",
      "name": "会津美里町",
      "enName": "Aizumisato Town",
      "kana": "あいづみさとまち",
      "chName": "会津美里町",
      "zhName": "會津美里町",
      "koName": "아이즈미사토 정",
      "esName": "Pueblo de aizumisato",
      "ptName": "bairro de Aizumisato",
      "thName": "เมืองไอสุมิซาโตะ",
      "viName": "thị trấn Aizumisato",
      "inName": "kota Aizumisato",
      "tlName": "bayan ng Aizumisato",
      "moName": "Aйзүмизaто жижиг хот",
      "buName": "အာယိဇုမိဆာတို မြို့နယ်",
      "khName": "ទីប្រជុំជន អាយស៊ូមីសាតូ",
      "neName": "आइजुमिसातो नगर"
    }
  },
  "0746100": {
    "office": {
      "code": "070000",
      "name": "福島県",
      "enName": "Fukushima",
      "officeName": "福島地方気象台",
      "chName": "福岛县",
      "zhName": "福島縣",
      "koName": "후쿠시마현",
      "esName": "Prefectura de Fukushima",
      "ptName": "Província de Fukushima",
      "thName": "จังหวัดฟุกุชิมะ",
      "viName": "Tỉnh Fukushima",
      "inName": "Prefektur Fukushima",
      "tlName": "Fukushima Prefecture",
      "moName": "Фүкүшима аймаг",
      "buName": "ဖူကူရှီမ ပြည်နယ်",
      "khName": "ខេត្ត ហ្វូគូស៊ីម៉ា",
      "neName": "फुकुसिमा जिल्ला"
    },
    "class10": {
      "code": "070010",
      "name": "中通り",
      "enName": "Nakadori",
      "chName": "福岛县中通道",
      "zhName": "福島縣中通",
      "koName": "후쿠시마 현 나카도리",
      "esName": "Nakadori, Prefectura de Fukushima",
      "ptName": "Naka-dōri da Província de Fukushima",
      "thName": "นากะโดริ จังหวัดฟุกุชิมะ",
      "viName": "Nakadori, tỉnh Fukushima",
      "inName": "Nakadori, Prefektur Fukushima",
      "tlName": "Nakadori, Fukushima Prefecture",
      "moName": "Фүкүшима аймаг, Накадори",
      "buName": "နကိုဒိုယိ၊ ဟုခုရှိမစီရင်စု",
      "khName": "តំបន់ណាកាដូរីនៃខេត្តហ្វឹគឹស៊ីម៉ា",
      "neName": "फुकुसिमा जिल्ला, नाकादोरी"
    },
    "class15": {
      "code": "070013",
      "name": "中通り南部",
      "enName": "Southern Nakadori"
    },
    "class20": {
      "code": "0746100",
      "name": "西郷村",
      "enName": "Nishigo Village",
      "kana": "にしごうむら",
      "chName": "西乡村",
      "zhName": "西鄉村",
      "koName": "니시고 촌",
      "esName": "Aldea de Nishigo",
      "ptName": "povoado de Nishigo",
      "thName": "หมู่บ้านนิชิโงะ",
      "viName": "làng Nishigo",
      "inName": "desa Nishigo",
      "tlName": "nayon ng Nishigo",
      "moName": "Нишиго тосгон",
      "buName": "နီရှိဂို ကျေးရွာ",
      "khName": "ភូមិ នីស៊ីហ្កូ",
      "neName": "निशिगो गाउँ"
    }
  },
  "0746400": {
    "office": {
      "code": "070000",
      "name": "福島県",
      "enName": "Fukushima",
      "officeName": "福島地方気象台",
      "chName": "福岛县",
      "zhName": "福島縣",
      "koName": "후쿠시마현",
      "esName": "Prefectura de Fukushima",
      "ptName": "Província de Fukushima",
      "thName": "จังหวัดฟุกุชิมะ",
      "viName": "Tỉnh Fukushima",
      "inName": "Prefektur Fukushima",
      "tlName": "Fukushima Prefecture",
      "moName": "Фүкүшима аймаг",
      "buName": "ဖူကူရှီမ ပြည်နယ်",
      "khName": "ខេត្ត ហ្វូគូស៊ីម៉ា",
      "neName": "फुकुसिमा जिल्ला"
    },
    "class10": {
      "code": "070010",
      "name": "中通り",
      "enName": "Nakadori",
      "chName": "福岛县中通道",
      "zhName": "福島縣中通",
      "koName": "후쿠시마 현 나카도리",
      "esName": "Nakadori, Prefectura de Fukushima",
      "ptName": "Naka-dōri da Província de Fukushima",
      "thName": "นากะโดริ จังหวัดฟุกุชิมะ",
      "viName": "Nakadori, tỉnh Fukushima",
      "inName": "Nakadori, Prefektur Fukushima",
      "tlName": "Nakadori, Fukushima Prefecture",
      "moName": "Фүкүшима аймаг, Накадори",
      "buName": "နကိုဒိုယိ၊ ဟုခုရှိမစီရင်စု",
      "khName": "តំបន់ណាកាដូរីនៃខេត្តហ្វឹគឹស៊ីម៉ា",
      "neName": "फुकुसिमा जिल्ला, नाकादोरी"
    },
    "class15": {
      "code": "070013",
      "name": "中通り南部",
      "enName": "Southern Nakadori"
    },
    "class20": {
      "code": "0746400",
      "name": "泉崎村",
      "enName": "Izumizaki Village",
      "kana": "いずみざきむら",
      "chName": "泉崎村",
      "zhName": "泉崎村",
      "koName": "이즈미자키 촌",
      "esName": "Aldea de Izumizaki",
      "ptName": "povoado de Izumizaki",
      "thName": "หมู่บ้านอิสุมิซากิ",
      "viName": "làng Izumizaki",
      "inName": "desa Izumizaki",
      "tlName": "nayon ng Izumizaki",
      "moName": "Изүмизаки тосгон",
      "buName": "အီဇုမိဇာ့ကိ ကျေးရွာ",
      "khName": "ភូមិ អ៊ីហ្ស៊ូមីហ្ស៊ាគី",
      "neName": "इज़ुमिजाकी गाउँ"
    }
  },
  "0746500": {
    "office": {
      "code": "070000",
      "name": "福島県",
      "enName": "Fukushima",
      "officeName": "福島地方気象台",
      "chName": "福岛县",
      "zhName": "福島縣",
      "koName": "후쿠시마현",
      "esName": "Prefectura de Fukushima",
      "ptName": "Província de Fukushima",
      "thName": "จังหวัดฟุกุชิมะ",
      "viName": "Tỉnh Fukushima",
      "inName": "Prefektur Fukushima",
      "tlName": "Fukushima Prefecture",
      "moName": "Фүкүшима аймаг",
      "buName": "ဖူကူရှီမ ပြည်နယ်",
      "khName": "ខេត្ត ហ្វូគូស៊ីម៉ា",
      "neName": "फुकुसिमा जिल्ला"
    },
    "class10": {
      "code": "070010",
      "name": "中通り",
      "enName": "Nakadori",
      "chName": "福岛县中通道",
      "zhName": "福島縣中通",
      "koName": "후쿠시마 현 나카도리",
      "esName": "Nakadori, Prefectura de Fukushima",
      "ptName": "Naka-dōri da Província de Fukushima",
      "thName": "นากะโดริ จังหวัดฟุกุชิมะ",
      "viName": "Nakadori, tỉnh Fukushima",
      "inName": "Nakadori, Prefektur Fukushima",
      "tlName": "Nakadori, Fukushima Prefecture",
      "moName": "Фүкүшима аймаг, Накадори",
      "buName": "နကိုဒိုယိ၊ ဟုခုရှိမစီရင်စု",
      "khName": "តំបន់ណាកាដូរីនៃខេត្តហ្វឹគឹស៊ីម៉ា",
      "neName": "फुकुसिमा जिल्ला, नाकादोरी"
    },
    "class15": {
      "code": "070013",
      "name": "中通り南部",
      "enName": "Southern Nakadori"
    },
    "class20": {
      "code": "0746500",
      "name": "中島村",
      "enName": "Nakajima Village",
      "kana": "なかじまむら",
      "chName": "中岛村",
      "zhName": "中島村",
      "koName": "나카지마 촌",
      "esName": "Aldea de Nakajima",
      "ptName": "povoado de Nakajima",
      "thName": "หมู่บ้านนากาจิมะ",
      "viName": "làng Nakajima",
      "inName": "desa Nakajima",
      "tlName": "nayon ng Nakajima",
      "moName": "Нaкажимa тосгон",
      "buName": "နာကားဂျိမ ကျေးရွာ",
      "khName": "ភូមិ ណាកាជីម៉ា",
      "neName": "नाकाजिमा गाउँ"
    }
  },
  "0746600": {
    "office": {
      "code": "070000",
      "name": "福島県",
      "enName": "Fukushima",
      "officeName": "福島地方気象台",
      "chName": "福岛县",
      "zhName": "福島縣",
      "koName": "후쿠시마현",
      "esName": "Prefectura de Fukushima",
      "ptName": "Província de Fukushima",
      "thName": "จังหวัดฟุกุชิมะ",
      "viName": "Tỉnh Fukushima",
      "inName": "Prefektur Fukushima",
      "tlName": "Fukushima Prefecture",
      "moName": "Фүкүшима аймаг",
      "buName": "ဖူကူရှီမ ပြည်နယ်",
      "khName": "ខេត្ត ហ្វូគូស៊ីម៉ា",
      "neName": "फुकुसिमा जिल्ला"
    },
    "class10": {
      "code": "070010",
      "name": "中通り",
      "enName": "Nakadori",
      "chName": "福岛县中通道",
      "zhName": "福島縣中通",
      "koName": "후쿠시마 현 나카도리",
      "esName": "Nakadori, Prefectura de Fukushima",
      "ptName": "Naka-dōri da Província de Fukushima",
      "thName": "นากะโดริ จังหวัดฟุกุชิมะ",
      "viName": "Nakadori, tỉnh Fukushima",
      "inName": "Nakadori, Prefektur Fukushima",
      "tlName": "Nakadori, Fukushima Prefecture",
      "moName": "Фүкүшима аймаг, Накадори",
      "buName": "နကိုဒိုယိ၊ ဟုခုရှိမစီရင်စု",
      "khName": "តំបន់ណាកាដូរីនៃខេត្តហ្វឹគឹស៊ីម៉ា",
      "neName": "फुकुसिमा जिल्ला, नाकादोरी"
    },
    "class15": {
      "code": "070013",
      "name": "中通り南部",
      "enName": "Southern Nakadori"
    },
    "class20": {
      "code": "0746600",
      "name": "矢吹町",
      "enName": "Yabuki Town",
      "kana": "やぶきまち",
      "chName": "矢吹町",
      "zhName": "矢吹町",
      "koName": "야부키 정",
      "esName": "Pueblo de Yabuki",
      "ptName": "bairro de Yabuki",
      "thName": "เมืองยาบุกิ",
      "viName": "thị trấn Yabuki",
      "inName": "kota Yabuki",
      "tlName": "bayan ng Yabuki",
      "moName": "Ябүки жижиг хот",
      "buName": "ယာဘုကိ မြို့နယ်",
      "khName": "ទីប្រជុំជន យ៉ាប៊ូគី",
      "neName": "याबुकी नगर"
    }
  },
  "0748100": {
    "office": {
      "code": "070000",
      "name": "福島県",
      "enName": "Fukushima",
      "officeName": "福島地方気象台",
      "chName": "福岛县",
      "zhName": "福島縣",
      "koName": "후쿠시마현",
      "esName": "Prefectura de Fukushima",
      "ptName": "Província de Fukushima",
      "thName": "จังหวัดฟุกุชิมะ",
      "viName": "Tỉnh Fukushima",
      "inName": "Prefektur Fukushima",
      "tlName": "Fukushima Prefecture",
      "moName": "Фүкүшима аймаг",
      "buName": "ဖူကူရှီမ ပြည်နယ်",
      "khName": "ខេត្ត ហ្វូគូស៊ីម៉ា",
      "neName": "फुकुसिमा जिल्ला"
    },
    "class10": {
      "code": "070010",
      "name": "中通り",
      "enName": "Nakadori",
      "chName": "福岛县中通道",
      "zhName": "福島縣中通",
      "koName": "후쿠시마 현 나카도리",
      "esName": "Nakadori, Prefectura de Fukushima",
      "ptName": "Naka-dōri da Província de Fukushima",
      "thName": "นากะโดริ จังหวัดฟุกุชิมะ",
      "viName": "Nakadori, tỉnh Fukushima",
      "inName": "Nakadori, Prefektur Fukushima",
      "tlName": "Nakadori, Fukushima Prefecture",
      "moName": "Фүкүшима аймаг, Накадори",
      "buName": "နကိုဒိုယိ၊ ဟုခုရှိမစီရင်စု",
      "khName": "តំបន់ណាកាដូរីនៃខេត្តហ្វឹគឹស៊ីម៉ា",
      "neName": "फुकुसिमा जिल्ला, नाकादोरी"
    },
    "class15": {
      "code": "070013",
      "name": "中通り南部",
      "enName": "Southern Nakadori"
    },
    "class20": {
      "code": "0748100",
      "name": "棚倉町",
      "enName": "Tanagura Town",
      "kana": "たなぐらまち",
      "chName": "棚仓町",
      "zhName": "棚倉町",
      "koName": "다나구라 정",
      "esName": "Pueblo de Tanagura",
      "ptName": "bairro de Tanagura",
      "thName": "เมืองทานากุระ",
      "viName": "thị trấn Tanagura",
      "inName": "kota Tanagura",
      "tlName": "bayan ng Tanagura",
      "moName": "Танaгүра жижиг хот",
      "buName": "တာနားဂုရ မြို့နယ်",
      "khName": "ទីប្រជុំជន តាណាហ្គូរ៉ា",
      "neName": "तानागुरा नगर"
    }
  },
  "0748200": {
    "office": {
      "code": "070000",
      "name": "福島県",
      "enName": "Fukushima",
      "officeName": "福島地方気象台",
      "chName": "福岛县",
      "zhName": "福島縣",
      "koName": "후쿠시마현",
      "esName": "Prefectura de Fukushima",
      "ptName": "Província de Fukushima",
      "thName": "จังหวัดฟุกุชิมะ",
      "viName": "Tỉnh Fukushima",
      "inName": "Prefektur Fukushima",
      "tlName": "Fukushima Prefecture",
      "moName": "Фүкүшима аймаг",
      "buName": "ဖူကူရှီမ ပြည်နယ်",
      "khName": "ខេត្ត ហ្វូគូស៊ីម៉ា",
      "neName": "फुकुसिमा जिल्ला"
    },
    "class10": {
      "code": "070010",
      "name": "中通り",
      "enName": "Nakadori",
      "chName": "福岛县中通道",
      "zhName": "福島縣中通",
      "koName": "후쿠시마 현 나카도리",
      "esName": "Nakadori, Prefectura de Fukushima",
      "ptName": "Naka-dōri da Província de Fukushima",
      "thName": "นากะโดริ จังหวัดฟุกุชิมะ",
      "viName": "Nakadori, tỉnh Fukushima",
      "inName": "Nakadori, Prefektur Fukushima",
      "tlName": "Nakadori, Fukushima Prefecture",
      "moName": "Фүкүшима аймаг, Накадори",
      "buName": "နကိုဒိုယိ၊ ဟုခုရှိမစီရင်စု",
      "khName": "តំបន់ណាកាដូរីនៃខេត្តហ្វឹគឹស៊ីម៉ា",
      "neName": "फुकुसिमा जिल्ला, नाकादोरी"
    },
    "class15": {
      "code": "070013",
      "name": "中通り南部",
      "enName": "Southern Nakadori"
    },
    "class20": {
      "code": "0748200",
      "name": "矢祭町",
      "enName": "Yamatsuri Town",
      "kana": "やまつりまち",
      "chName": "矢祭町",
      "zhName": "矢祭町",
      "koName": "야마쓰리 정",
      "esName": "Pueblo de Yamatsuri",
      "ptName": "bairro de Yamatsuri",
      "thName": "เมืองยามะสึริ",
      "viName": "thị trấn Yamatsuri",
      "inName": "kota Yamatsuri",
      "tlName": "bayan ng Yamatsuri",
      "moName": "Ямацүри жижиг хот",
      "buName": "ယာမာ့ဆုရိ မြို့နယ်",
      "khName": "ទីប្រជុំជន យ៉ាម៉ាស៊ូរី",
      "neName": "यामात्सुरी नगर"
    }
  },
  "0748300": {
    "office": {
      "code": "070000",
      "name": "福島県",
      "enName": "Fukushima",
      "officeName": "福島地方気象台",
      "chName": "福岛县",
      "zhName": "福島縣",
      "koName": "후쿠시마현",
      "esName": "Prefectura de Fukushima",
      "ptName": "Província de Fukushima",
      "thName": "จังหวัดฟุกุชิมะ",
      "viName": "Tỉnh Fukushima",
      "inName": "Prefektur Fukushima",
      "tlName": "Fukushima Prefecture",
      "moName": "Фүкүшима аймаг",
      "buName": "ဖူကူရှီမ ပြည်နယ်",
      "khName": "ខេត្ត ហ្វូគូស៊ីម៉ា",
      "neName": "फुकुसिमा जिल्ला"
    },
    "class10": {
      "code": "070010",
      "name": "中通り",
      "enName": "Nakadori",
      "chName": "福岛县中通道",
      "zhName": "福島縣中通",
      "koName": "후쿠시마 현 나카도리",
      "esName": "Nakadori, Prefectura de Fukushima",
      "ptName": "Naka-dōri da Província de Fukushima",
      "thName": "นากะโดริ จังหวัดฟุกุชิมะ",
      "viName": "Nakadori, tỉnh Fukushima",
      "inName": "Nakadori, Prefektur Fukushima",
      "tlName": "Nakadori, Fukushima Prefecture",
      "moName": "Фүкүшима аймаг, Накадори",
      "buName": "နကိုဒိုယိ၊ ဟုခုရှိမစီရင်စု",
      "khName": "តំបន់ណាកាដូរីនៃខេត្តហ្វឹគឹស៊ីម៉ា",
      "neName": "फुकुसिमा जिल्ला, नाकादोरी"
    },
    "class15": {
      "code": "070013",
      "name": "中通り南部",
      "enName": "Southern Nakadori"
    },
    "class20": {
      "code": "0748300",
      "name": "塙町",
      "enName": "Hanawa Town",
      "kana": "はなわまち",
      "chName": "塙町",
      "zhName": "塙町",
      "koName": "하나와 정",
      "esName": "Pueblo de Hanawa",
      "ptName": "bairro de Hanawa",
      "thName": "เมืองฮานาอะ",
      "viName": "thị trấn Hanawa",
      "inName": "kota Hanawa",
      "tlName": "bayan ng Hanawa",
      "moName": "Хaнава жижиг хот",
      "buName": "ဟန်နာ့ဝ မြို့နယ်",
      "khName": "ទីប្រជុំជន ហាណាវ៉ា",
      "neName": "हानावा नगर"
    }
  },
  "0748400": {
    "office": {
      "code": "070000",
      "name": "福島県",
      "enName": "Fukushima",
      "officeName": "福島地方気象台",
      "chName": "福岛县",
      "zhName": "福島縣",
      "koName": "후쿠시마현",
      "esName": "Prefectura de Fukushima",
      "ptName": "Província de Fukushima",
      "thName": "จังหวัดฟุกุชิมะ",
      "viName": "Tỉnh Fukushima",
      "inName": "Prefektur Fukushima",
      "tlName": "Fukushima Prefecture",
      "moName": "Фүкүшима аймаг",
      "buName": "ဖူကူရှီမ ပြည်နယ်",
      "khName": "ខេត្ត ហ្វូគូស៊ីម៉ា",
      "neName": "फुकुसिमा जिल्ला"
    },
    "class10": {
      "code": "070010",
      "name": "中通り",
      "enName": "Nakadori",
      "chName": "福岛县中通道",
      "zhName": "福島縣中通",
      "koName": "후쿠시마 현 나카도리",
      "esName": "Nakadori, Prefectura de Fukushima",
      "ptName": "Naka-dōri da Província de Fukushima",
      "thName": "นากะโดริ จังหวัดฟุกุชิมะ",
      "viName": "Nakadori, tỉnh Fukushima",
      "inName": "Nakadori, Prefektur Fukushima",
      "tlName": "Nakadori, Fukushima Prefecture",
      "moName": "Фүкүшима аймаг, Накадори",
      "buName": "နကိုဒိုယိ၊ ဟုခုရှိမစီရင်စု",
      "khName": "តំបន់ណាកាដូរីនៃខេត្តហ្វឹគឹស៊ីម៉ា",
      "neName": "फुकुसिमा जिल्ला, नाकादोरी"
    },
    "class15": {
      "code": "070013",
      "name": "中通り南部",
      "enName": "Southern Nakadori"
    },
    "class20": {
      "code": "0748400",
      "name": "鮫川村",
      "enName": "Samegawa Village",
      "kana": "さめがわむら",
      "chName": "鲛川村",
      "zhName": "鮫川村",
      "koName": "사메가와 촌",
      "esName": "Aldea de Samegawa",
      "ptName": "povoado de Samegawa",
      "thName": "หมู่บ้านซาเมะงาวะ",
      "viName": "làng Samegawa",
      "inName": "desa Samegawa",
      "tlName": "nayon ng Samegawa",
      "moName": "Сaмэгава тосгон",
      "buName": "ဆမ်မဲ့ဂါ့ဝ ကျေးရွာ",
      "khName": "ភូមិ សាមេហ្កាវ៉ា",
      "neName": "सामेगावा गाउँ"
    }
  },
  "0750100": {
    "office": {
      "code": "070000",
      "name": "福島県",
      "enName": "Fukushima",
      "officeName": "福島地方気象台",
      "chName": "福岛县",
      "zhName": "福島縣",
      "koName": "후쿠시마현",
      "esName": "Prefectura de Fukushima",
      "ptName": "Província de Fukushima",
      "thName": "จังหวัดฟุกุชิมะ",
      "viName": "Tỉnh Fukushima",
      "inName": "Prefektur Fukushima",
      "tlName": "Fukushima Prefecture",
      "moName": "Фүкүшима аймаг",
      "buName": "ဖူကူရှီမ ပြည်နယ်",
      "khName": "ខេត្ត ហ្វូគូស៊ីម៉ា",
      "neName": "फुकुसिमा जिल्ला"
    },
    "class10": {
      "code": "070010",
      "name": "中通り",
      "enName": "Nakadori",
      "chName": "福岛县中通道",
      "zhName": "福島縣中通",
      "koName": "후쿠시마 현 나카도리",
      "esName": "Nakadori, Prefectura de Fukushima",
      "ptName": "Naka-dōri da Província de Fukushima",
      "thName": "นากะโดริ จังหวัดฟุกุชิมะ",
      "viName": "Nakadori, tỉnh Fukushima",
      "inName": "Nakadori, Prefektur Fukushima",
      "tlName": "Nakadori, Fukushima Prefecture",
      "moName": "Фүкүшима аймаг, Накадори",
      "buName": "နကိုဒိုယိ၊ ဟုခုရှိမစီရင်စု",
      "khName": "តំបន់ណាកាដូរីនៃខេត្តហ្វឹគឹស៊ីម៉ា",
      "neName": "फुकुसिमा जिल्ला, नाकादोरी"
    },
    "class15": {
      "code": "070013",
      "name": "中通り南部",
      "enName": "Southern Nakadori"
    },
    "class20": {
      "code": "0750100",
      "name": "石川町",
      "enName": "Ishikawa Town",
      "kana": "いしかわまち",
      "chName": "石川町",
      "zhName": "石川町",
      "koName": "이시카와 정",
      "esName": "Pueblo de Ishikawa",
      "ptName": "bairro de Ishikawa",
      "thName": "เมืองอิชิคาวะ",
      "viName": "thị trấn Ishikawa",
      "inName": "kota Ishikawa",
      "tlName": "bayan ng Ishikawa",
      "moName": "Ишикава жижиг хот",
      "buName": "အီရှိကာ့ဝ မြို့နယ်",
      "khName": "ទីប្រជុំជន អ៊ីស៊ីកាវ៉ា",
      "neName": "इशिकावा नगर"
    }
  },
  "0750200": {
    "office": {
      "code": "070000",
      "name": "福島県",
      "enName": "Fukushima",
      "officeName": "福島地方気象台",
      "chName": "福岛县",
      "zhName": "福島縣",
      "koName": "후쿠시마현",
      "esName": "Prefectura de Fukushima",
      "ptName": "Província de Fukushima",
      "thName": "จังหวัดฟุกุชิมะ",
      "viName": "Tỉnh Fukushima",
      "inName": "Prefektur Fukushima",
      "tlName": "Fukushima Prefecture",
      "moName": "Фүкүшима аймаг",
      "buName": "ဖူကူရှီမ ပြည်နယ်",
      "khName": "ខេត្ត ហ្វូគូស៊ីម៉ា",
      "neName": "फुकुसिमा जिल्ला"
    },
    "class10": {
      "code": "070010",
      "name": "中通り",
      "enName": "Nakadori",
      "chName": "福岛县中通道",
      "zhName": "福島縣中通",
      "koName": "후쿠시마 현 나카도리",
      "esName": "Nakadori, Prefectura de Fukushima",
      "ptName": "Naka-dōri da Província de Fukushima",
      "thName": "นากะโดริ จังหวัดฟุกุชิมะ",
      "viName": "Nakadori, tỉnh Fukushima",
      "inName": "Nakadori, Prefektur Fukushima",
      "tlName": "Nakadori, Fukushima Prefecture",
      "moName": "Фүкүшима аймаг, Накадори",
      "buName": "နကိုဒိုယိ၊ ဟုခုရှိမစီရင်စု",
      "khName": "តំបន់ណាកាដូរីនៃខេត្តហ្វឹគឹស៊ីម៉ា",
      "neName": "फुकुसिमा जिल्ला, नाकादोरी"
    },
    "class15": {
      "code": "070013",
      "name": "中通り南部",
      "enName": "Southern Nakadori"
    },
    "class20": {
      "code": "0750200",
      "name": "玉川村",
      "enName": "Tamakawa Village",
      "kana": "たまかわむら",
      "chName": "玉川村",
      "zhName": "玉川村",
      "koName": "다마카와 촌",
      "esName": "Aldea de Tamakawa",
      "ptName": "povoado de Tamakawa",
      "thName": "หมู่บ้านทามางาวะ",
      "viName": "làng Tamakawa",
      "inName": "desa Tamakawa",
      "tlName": "nayon ng Tamakawa",
      "moName": "Тамакава тосгон",
      "buName": "တာမားကာ့ဝ ကျေးရွာ",
      "khName": "ភូមិ តាម៉ាកាវ៉ា",
      "neName": "तामाकावा गाउँ"
    }
  },
  "0750300": {
    "office": {
      "code": "070000",
      "name": "福島県",
      "enName": "Fukushima",
      "officeName": "福島地方気象台",
      "chName": "福岛县",
      "zhName": "福島縣",
      "koName": "후쿠시마현",
      "esName": "Prefectura de Fukushima",
      "ptName": "Província de Fukushima",
      "thName": "จังหวัดฟุกุชิมะ",
      "viName": "Tỉnh Fukushima",
      "inName": "Prefektur Fukushima",
      "tlName": "Fukushima Prefecture",
      "moName": "Фүкүшима аймаг",
      "buName": "ဖူကူရှီမ ပြည်နယ်",
      "khName": "ខេត្ត ហ្វូគូស៊ីម៉ា",
      "neName": "फुकुसिमा जिल्ला"
    },
    "class10": {
      "code": "070010",
      "name": "中通り",
      "enName": "Nakadori",
      "chName": "福岛县中通道",
      "zhName": "福島縣中通",
      "koName": "후쿠시마 현 나카도리",
      "esName": "Nakadori, Prefectura de Fukushima",
      "ptName": "Naka-dōri da Província de Fukushima",
      "thName": "นากะโดริ จังหวัดฟุกุชิมะ",
      "viName": "Nakadori, tỉnh Fukushima",
      "inName": "Nakadori, Prefektur Fukushima",
      "tlName": "Nakadori, Fukushima Prefecture",
      "moName": "Фүкүшима аймаг, Накадори",
      "buName": "နကိုဒိုယိ၊ ဟုခုရှိမစီရင်စု",
      "khName": "តំបន់ណាកាដូរីនៃខេត្តហ្វឹគឹស៊ីម៉ា",
      "neName": "फुकुसिमा जिल्ला, नाकादोरी"
    },
    "class15": {
      "code": "070013",
      "name": "中通り南部",
      "enName": "Southern Nakadori"
    },
    "class20": {
      "code": "0750300",
      "name": "平田村",
      "enName": "Hirata Village",
      "kana": "ひらたむら",
      "chName": "平田村",
      "zhName": "平田村",
      "koName": "히라타 촌",
      "esName": "Aldea de Hirata",
      "ptName": "povoado de Hirata",
      "thName": "หมู่บ้านฮิราตะ",
      "viName": "làng Hirata",
      "inName": "desa Hirata",
      "tlName": "nayon ng Hirata",
      "moName": "Хирата тосгон",
      "buName": "ဟီရာ့တ ကျေးရွာ",
      "khName": "ភូមិ ហ៊ីរ៉ាតា",
      "neName": "हिराता गाउँ"
    }
  },
  "0750400": {
    "office": {
      "code": "070000",
      "name": "福島県",
      "enName": "Fukushima",
      "officeName": "福島地方気象台",
      "chName": "福岛县",
      "zhName": "福島縣",
      "koName": "후쿠시마현",
      "esName": "Prefectura de Fukushima",
      "ptName": "Província de Fukushima",
      "thName": "จังหวัดฟุกุชิมะ",
      "viName": "Tỉnh Fukushima",
      "inName": "Prefektur Fukushima",
      "tlName": "Fukushima Prefecture",
      "moName": "Фүкүшима аймаг",
      "buName": "ဖူကူရှီမ ပြည်နယ်",
      "khName": "ខេត្ត ហ្វូគូស៊ីម៉ា",
      "neName": "फुकुसिमा जिल्ला"
    },
    "class10": {
      "code": "070010",
      "name": "中通り",
      "enName": "Nakadori",
      "chName": "福岛县中通道",
      "zhName": "福島縣中通",
      "koName": "후쿠시마 현 나카도리",
      "esName": "Nakadori, Prefectura de Fukushima",
      "ptName": "Naka-dōri da Província de Fukushima",
      "thName": "นากะโดริ จังหวัดฟุกุชิมะ",
      "viName": "Nakadori, tỉnh Fukushima",
      "inName": "Nakadori, Prefektur Fukushima",
      "tlName": "Nakadori, Fukushima Prefecture",
      "moName": "Фүкүшима аймаг, Накадори",
      "buName": "နကိုဒိုယိ၊ ဟုခုရှိမစီရင်စု",
      "khName": "តំបន់ណាកាដូរីនៃខេត្តហ្វឹគឹស៊ីម៉ា",
      "neName": "फुकुसिमा जिल्ला, नाकादोरी"
    },
    "class15": {
      "code": "070013",
      "name": "中通り南部",
      "enName": "Southern Nakadori"
    },
    "class20": {
      "code": "0750400",
      "name": "浅川町",
      "enName": "Asakawa Town",
      "kana": "あさかわまち",
      "chName": "浅川町",
      "zhName": "淺川町",
      "koName": "아사카와 정",
      "esName": "Pueblo de Asakawa",
      "ptName": "bairro de Asakawa",
      "thName": "เมืองอาซาคาวะ",
      "viName": "thị trấn Asakawa",
      "inName": "kota Asakawa",
      "tlName": "bayan ng Asakawa",
      "moName": "Асакава жижиг хот",
      "buName": "အဆားကာ့ဝ မြို့နယ်",
      "khName": "ទីប្រជុំជន អាសាកាវ៉ា",
      "neName": "आसाकावा नगर"
    }
  },
  "0750500": {
    "office": {
      "code": "070000",
      "name": "福島県",
      "enName": "Fukushima",
      "officeName": "福島地方気象台",
      "chName": "福岛县",
      "zhName": "福島縣",
      "koName": "후쿠시마현",
      "esName": "Prefectura de Fukushima",
      "ptName": "Província de Fukushima",
      "thName": "จังหวัดฟุกุชิมะ",
      "viName": "Tỉnh Fukushima",
      "inName": "Prefektur Fukushima",
      "tlName": "Fukushima Prefecture",
      "moName": "Фүкүшима аймаг",
      "buName": "ဖူကူရှီမ ပြည်နယ်",
      "khName": "ខេត្ត ហ្វូគូស៊ីម៉ា",
      "neName": "फुकुसिमा जिल्ला"
    },
    "class10": {
      "code": "070010",
      "name": "中通り",
      "enName": "Nakadori",
      "chName": "福岛县中通道",
      "zhName": "福島縣中通",
      "koName": "후쿠시마 현 나카도리",
      "esName": "Nakadori, Prefectura de Fukushima",
      "ptName": "Naka-dōri da Província de Fukushima",
      "thName": "นากะโดริ จังหวัดฟุกุชิมะ",
      "viName": "Nakadori, tỉnh Fukushima",
      "inName": "Nakadori, Prefektur Fukushima",
      "tlName": "Nakadori, Fukushima Prefecture",
      "moName": "Фүкүшима аймаг, Накадори",
      "buName": "နကိုဒိုယိ၊ ဟုခုရှိမစီရင်စု",
      "khName": "តំបន់ណាកាដូរីនៃខេត្តហ្វឹគឹស៊ីម៉ា",
      "neName": "फुकुसिमा जिल्ला, नाकादोरी"
    },
    "class15": {
      "code": "070013",
      "name": "中通り南部",
      "enName": "Southern Nakadori"
    },
    "class20": {
      "code": "0750500",
      "name": "古殿町",
      "enName": "Furudono Town",
      "kana": "ふるどのまち",
      "chName": "古殿町",
      "zhName": "古殿町",
      "koName": "후루도노 정",
      "esName": "Pueblo de Furudono",
      "ptName": "bairro de Furudono",
      "thName": "เมืองุรุโดโนะ",
      "viName": "thị trấn Furudono",
      "inName": "kota Furudono",
      "tlName": "bayan ng Furudono",
      "moName": "Фүрүдоно жижиг хот",
      "buName": "ဖူရူဒိုနို မြို့နယ်",
      "khName": "ទីប្រជុំជន ហ្វូរូដូណូ",
      "neName": "फुरुदोनो नगर"
    }
  },
  "0752100": {
    "office": {
      "code": "070000",
      "name": "福島県",
      "enName": "Fukushima",
      "officeName": "福島地方気象台",
      "chName": "福岛县",
      "zhName": "福島縣",
      "koName": "후쿠시마현",
      "esName": "Prefectura de Fukushima",
      "ptName": "Província de Fukushima",
      "thName": "จังหวัดฟุกุชิมะ",
      "viName": "Tỉnh Fukushima",
      "inName": "Prefektur Fukushima",
      "tlName": "Fukushima Prefecture",
      "moName": "Фүкүшима аймаг",
      "buName": "ဖူကူရှီမ ပြည်နယ်",
      "khName": "ខេត្ត ហ្វូគូស៊ីម៉ា",
      "neName": "फुकुसिमा जिल्ला"
    },
    "class10": {
      "code": "070010",
      "name": "中通り",
      "enName": "Nakadori",
      "chName": "福岛县中通道",
      "zhName": "福島縣中通",
      "koName": "후쿠시마 현 나카도리",
      "esName": "Nakadori, Prefectura de Fukushima",
      "ptName": "Naka-dōri da Província de Fukushima",
      "thName": "นากะโดริ จังหวัดฟุกุชิมะ",
      "viName": "Nakadori, tỉnh Fukushima",
      "inName": "Nakadori, Prefektur Fukushima",
      "tlName": "Nakadori, Fukushima Prefecture",
      "moName": "Фүкүшима аймаг, Накадори",
      "buName": "နကိုဒိုယိ၊ ဟုခုရှိမစီရင်စု",
      "khName": "តំបន់ណាកាដូរីនៃខេត្តហ្វឹគឹស៊ីម៉ា",
      "neName": "फुकुसिमा जिल्ला, नाकादोरी"
    },
    "class15": {
      "code": "070012",
      "name": "中通り中部",
      "enName": "Central Nakadori"
    },
    "class20": {
      "code": "0752100",
      "name": "三春町",
      "enName": "Miharu Town",
      "kana": "みはるまち",
      "chName": "三春町",
      "zhName": "三春町",
      "koName": "미하루 정",
      "esName": "Pueblo de Miharu",
      "ptName": "bairro de Miharu",
      "thName": "เมืองมิฮารุ",
      "viName": "thị trấn Miharu",
      "inName": "kota Miharu",
      "tlName": "bayan ng Miharu",
      "moName": "Михaрү жижиг хот",
      "buName": "မီဟားရု မြို့နယ်",
      "khName": "ទីប្រជុំជន មីហារុ",
      "neName": "मिहारु नगर"
    }
  },
  "0752200": {
    "office": {
      "code": "070000",
      "name": "福島県",
      "enName": "Fukushima",
      "officeName": "福島地方気象台",
      "chName": "福岛县",
      "zhName": "福島縣",
      "koName": "후쿠시마현",
      "esName": "Prefectura de Fukushima",
      "ptName": "Província de Fukushima",
      "thName": "จังหวัดฟุกุชิมะ",
      "viName": "Tỉnh Fukushima",
      "inName": "Prefektur Fukushima",
      "tlName": "Fukushima Prefecture",
      "moName": "Фүкүшима аймаг",
      "buName": "ဖူကူရှီမ ပြည်နယ်",
      "khName": "ខេត្ត ហ្វូគូស៊ីម៉ា",
      "neName": "फुकुसिमा जिल्ला"
    },
    "class10": {
      "code": "070010",
      "name": "中通り",
      "enName": "Nakadori",
      "chName": "福岛县中通道",
      "zhName": "福島縣中通",
      "koName": "후쿠시마 현 나카도리",
      "esName": "Nakadori, Prefectura de Fukushima",
      "ptName": "Naka-dōri da Província de Fukushima",
      "thName": "นากะโดริ จังหวัดฟุกุชิมะ",
      "viName": "Nakadori, tỉnh Fukushima",
      "inName": "Nakadori, Prefektur Fukushima",
      "tlName": "Nakadori, Fukushima Prefecture",
      "moName": "Фүкүшима аймаг, Накадори",
      "buName": "နကိုဒိုယိ၊ ဟုခုရှိမစီရင်စု",
      "khName": "តំបន់ណាកាដូរីនៃខេត្តហ្វឹគឹស៊ីម៉ា",
      "neName": "फुकुसिमा जिल्ला, नाकादोरी"
    },
    "class15": {
      "code": "070012",
      "name": "中通り中部",
      "enName": "Central Nakadori"
    },
    "class20": {
      "code": "0752200",
      "name": "小野町",
      "enName": "Ono Town",
      "kana": "おのまち",
      "chName": "小野町",
      "zhName": "小野町",
      "koName": "오노 정",
      "esName": "Pueblo de Ono",
      "ptName": "bairro de Ono",
      "thName": "เมืองโอโนะ",
      "viName": "thị trấn Ono",
      "inName": "kota Ono",
      "tlName": "bayan ng Ono",
      "moName": "Оно жижиг хот",
      "buName": "အိုနို မြို့နယ်",
      "khName": "ទីប្រជុំជន អូណូ",
      "neName": "ओनो नगर"
    }
  },
  "0754100": {
    "office": {
      "code": "070000",
      "name": "福島県",
      "enName": "Fukushima",
      "officeName": "福島地方気象台",
      "chName": "福岛县",
      "zhName": "福島縣",
      "koName": "후쿠시마현",
      "esName": "Prefectura de Fukushima",
      "ptName": "Província de Fukushima",
      "thName": "จังหวัดฟุกุชิมะ",
      "viName": "Tỉnh Fukushima",
      "inName": "Prefektur Fukushima",
      "tlName": "Fukushima Prefecture",
      "moName": "Фүкүшима аймаг",
      "buName": "ဖူကူရှီမ ပြည်နယ်",
      "khName": "ខេត្ត ហ្វូគូស៊ីម៉ា",
      "neName": "फुकुसिमा जिल्ला"
    },
    "class10": {
      "code": "070020",
      "name": "浜通り",
      "enName": "Hamadori",
      "chName": "福岛县滨通道",
      "zhName": "福島縣濱通",
      "koName": "후쿠시마 현 하마 도리",
      "esName": "Hamadori, Prefectura de Fukushima",
      "ptName": "Hama-dōri da Província de Fukushima",
      "thName": "ฮามะโดริ จังหวัดฟุกุชิมะ",
      "viName": "Hamadori, tỉnh Fukushima",
      "inName": "Hamadori, Prefektur Fukushima",
      "tlName": "Hamadori, Fukushima Prefecture",
      "moName": "Фүкүшима аймаг, Хамадори",
      "buName": "ဟမဒိုယိ၊ ဟုခုရှိမစီရင်စု",
      "khName": "តំបន់ហាម៉ាដូរីនៃខេត្តហ្វឹគឹស៊ីម៉ា",
      "neName": "फुकुसिमा जिल्ला, हामादोरी"
    },
    "class15": {
      "code": "070022",
      "name": "浜通り中部",
      "enName": "Central Hamadori"
    },
    "class20": {
      "code": "0754100",
      "name": "広野町",
      "enName": "Hirono Town",
      "kana": "ひろのまち",
      "chName": "福岛广野町",
      "zhName": "福島廣野町",
      "koName": "후쿠시마 히로노 정",
      "esName": "Pueblo de Hirono, Fukushima",
      "ptName": "Fukushima, bairro de Hirono",
      "thName": "เมืองฮิโรโนะ ฟุกุชิมะ",
      "viName": "Thị trấn Hirono, Fukushima",
      "inName": "Kota Hirono, Fukushima",
      "tlName": "bayan ng Hirono, Fukushima",
      "moName": "Фукушима Хироно жижиг хот",
      "buName": "ဟုခုရှိမဟိရိုနိုမြို့နယ်",
      "khName": "ទីប្រជុំជនហ៊ីរ៉ូណូ ហ្វឹគឹស៊ីម៉ា",
      "neName": "फुकुसिमा हिरोनो नगर"
    }
  },
  "0754200": {
    "office": {
      "code": "070000",
      "name": "福島県",
      "enName": "Fukushima",
      "officeName": "福島地方気象台",
      "chName": "福岛县",
      "zhName": "福島縣",
      "koName": "후쿠시마현",
      "esName": "Prefectura de Fukushima",
      "ptName": "Província de Fukushima",
      "thName": "จังหวัดฟุกุชิมะ",
      "viName": "Tỉnh Fukushima",
      "inName": "Prefektur Fukushima",
      "tlName": "Fukushima Prefecture",
      "moName": "Фүкүшима аймаг",
      "buName": "ဖူကူရှီမ ပြည်နယ်",
      "khName": "ខេត្ត ហ្វូគូស៊ីម៉ា",
      "neName": "फुकुसिमा जिल्ला"
    },
    "class10": {
      "code": "070020",
      "name": "浜通り",
      "enName": "Hamadori",
      "chName": "福岛县滨通道",
      "zhName": "福島縣濱通",
      "koName": "후쿠시마 현 하마 도리",
      "esName": "Hamadori, Prefectura de Fukushima",
      "ptName": "Hama-dōri da Província de Fukushima",
      "thName": "ฮามะโดริ จังหวัดฟุกุชิมะ",
      "viName": "Hamadori, tỉnh Fukushima",
      "inName": "Hamadori, Prefektur Fukushima",
      "tlName": "Hamadori, Fukushima Prefecture",
      "moName": "Фүкүшима аймаг, Хамадори",
      "buName": "ဟမဒိုယိ၊ ဟုခုရှိမစီရင်စု",
      "khName": "តំបន់ហាម៉ាដូរីនៃខេត្តហ្វឹគឹស៊ីម៉ា",
      "neName": "फुकुसिमा जिल्ला, हामादोरी"
    },
    "class15": {
      "code": "070022",
      "name": "浜通り中部",
      "enName": "Central Hamadori"
    },
    "class20": {
      "code": "0754200",
      "name": "楢葉町",
      "enName": "Naraha Town",
      "kana": "ならはまち",
      "chName": "楢叶町",
      "zhName": "楢葉町",
      "koName": "나라하 정",
      "esName": "Pueblo de Naraha",
      "ptName": "bairro de Naraha",
      "thName": "เมืองนาราฮะ",
      "viName": "thị trấn Naraha",
      "inName": "kota Naraha",
      "tlName": "bayan ng Naraha",
      "moName": "Нaрахa жижиг хот",
      "buName": "နားရာ့ဟ မြို့နယ်",
      "khName": "ទីប្រជុំជន ណារ៉ាហា",
      "neName": "नाराहा नगर"
    }
  },
  "0754300": {
    "office": {
      "code": "070000",
      "name": "福島県",
      "enName": "Fukushima",
      "officeName": "福島地方気象台",
      "chName": "福岛县",
      "zhName": "福島縣",
      "koName": "후쿠시마현",
      "esName": "Prefectura de Fukushima",
      "ptName": "Província de Fukushima",
      "thName": "จังหวัดฟุกุชิมะ",
      "viName": "Tỉnh Fukushima",
      "inName": "Prefektur Fukushima",
      "tlName": "Fukushima Prefecture",
      "moName": "Фүкүшима аймаг",
      "buName": "ဖူကူရှီမ ပြည်နယ်",
      "khName": "ខេត្ត ហ្វូគូស៊ីម៉ា",
      "neName": "फुकुसिमा जिल्ला"
    },
    "class10": {
      "code": "070020",
      "name": "浜通り",
      "enName": "Hamadori",
      "chName": "福岛县滨通道",
      "zhName": "福島縣濱通",
      "koName": "후쿠시마 현 하마 도리",
      "esName": "Hamadori, Prefectura de Fukushima",
      "ptName": "Hama-dōri da Província de Fukushima",
      "thName": "ฮามะโดริ จังหวัดฟุกุชิมะ",
      "viName": "Hamadori, tỉnh Fukushima",
      "inName": "Hamadori, Prefektur Fukushima",
      "tlName": "Hamadori, Fukushima Prefecture",
      "moName": "Фүкүшима аймаг, Хамадори",
      "buName": "ဟမဒိုယိ၊ ဟုခုရှိမစီရင်စု",
      "khName": "តំបន់ហាម៉ាដូរីនៃខេត្តហ្វឹគឹស៊ីម៉ា",
      "neName": "फुकुसिमा जिल्ला, हामादोरी"
    },
    "class15": {
      "code": "070022",
      "name": "浜通り中部",
      "enName": "Central Hamadori"
    },
    "class20": {
      "code": "0754300",
      "name": "富岡町",
      "enName": "Tomioka Town",
      "kana": "とみおかまち",
      "chName": "富冈町",
      "zhName": "富岡町",
      "koName": "도미오카 정",
      "esName": "Pueblo de Tomioka",
      "ptName": "bairro de Tomioka",
      "thName": "เมืองโทมิโอกะ",
      "viName": "thị trấn Tomioka",
      "inName": "kota Tomioka",
      "tlName": "bayan ng Tomioka",
      "moName": "Томиока жижиг хот",
      "buName": "တိုမီယို့က မြို့နယ်",
      "khName": "ទីប្រជុំជន ថូមីអូកា",
      "neName": "तोमिओका नगर"
    }
  },
  "0754400": {
    "office": {
      "code": "070000",
      "name": "福島県",
      "enName": "Fukushima",
      "officeName": "福島地方気象台",
      "chName": "福岛县",
      "zhName": "福島縣",
      "koName": "후쿠시마현",
      "esName": "Prefectura de Fukushima",
      "ptName": "Província de Fukushima",
      "thName": "จังหวัดฟุกุชิมะ",
      "viName": "Tỉnh Fukushima",
      "inName": "Prefektur Fukushima",
      "tlName": "Fukushima Prefecture",
      "moName": "Фүкүшима аймаг",
      "buName": "ဖူကူရှီမ ပြည်နယ်",
      "khName": "ខេត្ត ហ្វូគូស៊ីម៉ា",
      "neName": "फुकुसिमा जिल्ला"
    },
    "class10": {
      "code": "070020",
      "name": "浜通り",
      "enName": "Hamadori",
      "chName": "福岛县滨通道",
      "zhName": "福島縣濱通",
      "koName": "후쿠시마 현 하마 도리",
      "esName": "Hamadori, Prefectura de Fukushima",
      "ptName": "Hama-dōri da Província de Fukushima",
      "thName": "ฮามะโดริ จังหวัดฟุกุชิมะ",
      "viName": "Hamadori, tỉnh Fukushima",
      "inName": "Hamadori, Prefektur Fukushima",
      "tlName": "Hamadori, Fukushima Prefecture",
      "moName": "Фүкүшима аймаг, Хамадори",
      "buName": "ဟမဒိုယိ၊ ဟုခုရှိမစီရင်စု",
      "khName": "តំបន់ហាម៉ាដូរីនៃខេត្តហ្វឹគឹស៊ីម៉ា",
      "neName": "फुकुसिमा जिल्ला, हामादोरी"
    },
    "class15": {
      "code": "070022",
      "name": "浜通り中部",
      "enName": "Central Hamadori"
    },
    "class20": {
      "code": "0754400",
      "name": "川内村",
      "enName": "Kawauchi Village",
      "kana": "かわうちむら",
      "chName": "川内村",
      "zhName": "川內村",
      "koName": "가와우치 촌",
      "esName": "Aldea de Kawauchi",
      "ptName": "povoado de Kawauchi",
      "thName": "หมู่บ้านคาวากุจิ",
      "viName": "làng Kawauchi",
      "inName": "desa Kawauchi",
      "tlName": "nayon ng Kawauchi",
      "moName": "Каваүчи тосгон",
      "buName": "ကာဝါးဥကျိ ကျေးရွာ",
      "khName": "ភូមិ កូវ៉ាជី",
      "neName": "कावाउचि गाउँ"
    }
  },
  "0754500": {
    "office": {
      "code": "070000",
      "name": "福島県",
      "enName": "Fukushima",
      "officeName": "福島地方気象台",
      "chName": "福岛县",
      "zhName": "福島縣",
      "koName": "후쿠시마현",
      "esName": "Prefectura de Fukushima",
      "ptName": "Província de Fukushima",
      "thName": "จังหวัดฟุกุชิมะ",
      "viName": "Tỉnh Fukushima",
      "inName": "Prefektur Fukushima",
      "tlName": "Fukushima Prefecture",
      "moName": "Фүкүшима аймаг",
      "buName": "ဖူကူရှီမ ပြည်နယ်",
      "khName": "ខេត្ត ហ្វូគូស៊ីម៉ា",
      "neName": "फुकुसिमा जिल्ला"
    },
    "class10": {
      "code": "070020",
      "name": "浜通り",
      "enName": "Hamadori",
      "chName": "福岛县滨通道",
      "zhName": "福島縣濱通",
      "koName": "후쿠시마 현 하마 도리",
      "esName": "Hamadori, Prefectura de Fukushima",
      "ptName": "Hama-dōri da Província de Fukushima",
      "thName": "ฮามะโดริ จังหวัดฟุกุชิมะ",
      "viName": "Hamadori, tỉnh Fukushima",
      "inName": "Hamadori, Prefektur Fukushima",
      "tlName": "Hamadori, Fukushima Prefecture",
      "moName": "Фүкүшима аймаг, Хамадори",
      "buName": "ဟမဒိုယိ၊ ဟုခုရှိမစီရင်စု",
      "khName": "តំបន់ហាម៉ាដូរីនៃខេត្តហ្វឹគឹស៊ីម៉ា",
      "neName": "फुकुसिमा जिल्ला, हामादोरी"
    },
    "class15": {
      "code": "070022",
      "name": "浜通り中部",
      "enName": "Central Hamadori"
    },
    "class20": {
      "code": "0754500",
      "name": "大熊町",
      "enName": "Okuma Town",
      "kana": "おおくままち",
      "chName": "大熊町",
      "zhName": "大熊町",
      "koName": "오쿠마 정",
      "esName": "Pueblo de Okuma",
      "ptName": "bairro de Okuma",
      "thName": "เมืองโอคุมะ",
      "viName": "thị trấn Okuma",
      "inName": "kota Okuma",
      "tlName": "bayan ng Okuma",
      "moName": "Окүмa жижиг хот",
      "buName": "အိုးကုမ မြို့နယ်",
      "khName": "ទីប្រជុំជន អូគុម៉ា",
      "neName": "ओकुमा नगर"
    }
  },
  "0754600": {
    "office": {
      "code": "070000",
      "name": "福島県",
      "enName": "Fukushima",
      "officeName": "福島地方気象台",
      "chName": "福岛县",
      "zhName": "福島縣",
      "koName": "후쿠시마현",
      "esName": "Prefectura de Fukushima",
      "ptName": "Província de Fukushima",
      "thName": "จังหวัดฟุกุชิมะ",
      "viName": "Tỉnh Fukushima",
      "inName": "Prefektur Fukushima",
      "tlName": "Fukushima Prefecture",
      "moName": "Фүкүшима аймаг",
      "buName": "ဖူကူရှီမ ပြည်နယ်",
      "khName": "ខេត្ត ហ្វូគូស៊ីម៉ា",
      "neName": "फुकुसिमा जिल्ला"
    },
    "class10": {
      "code": "070020",
      "name": "浜通り",
      "enName": "Hamadori",
      "chName": "福岛县滨通道",
      "zhName": "福島縣濱通",
      "koName": "후쿠시마 현 하마 도리",
      "esName": "Hamadori, Prefectura de Fukushima",
      "ptName": "Hama-dōri da Província de Fukushima",
      "thName": "ฮามะโดริ จังหวัดฟุกุชิมะ",
      "viName": "Hamadori, tỉnh Fukushima",
      "inName": "Hamadori, Prefektur Fukushima",
      "tlName": "Hamadori, Fukushima Prefecture",
      "moName": "Фүкүшима аймаг, Хамадори",
      "buName": "ဟမဒိုယိ၊ ဟုခုရှိမစီရင်စု",
      "khName": "តំបន់ហាម៉ាដូរីនៃខេត្តហ្វឹគឹស៊ីម៉ា",
      "neName": "फुकुसिमा जिल्ला, हामादोरी"
    },
    "class15": {
      "code": "070022",
      "name": "浜通り中部",
      "enName": "Central Hamadori"
    },
    "class20": {
      "code": "0754600",
      "name": "双葉町",
      "enName": "Futaba Town",
      "kana": "ふたばまち",
      "chName": "双叶町",
      "zhName": "雙葉町",
      "koName": "후타바 정",
      "esName": "Pueblo de Futaba",
      "ptName": "bairro de Futaba",
      "thName": "เมืองฟุตาบะ",
      "viName": "thị trấn Futaba",
      "inName": "kota Futaba",
      "tlName": "bayan ng Futaba",
      "moName": "Фүтаба жижиг хот",
      "buName": "ဟုတားဗ မြို့နယ်",
      "khName": "ទីប្រជុំជន ហ្វូតាបា",
      "neName": "फुताबा नगर"
    }
  },
  "0754700": {
    "office": {
      "code": "070000",
      "name": "福島県",
      "enName": "Fukushima",
      "officeName": "福島地方気象台",
      "chName": "福岛县",
      "zhName": "福島縣",
      "koName": "후쿠시마현",
      "esName": "Prefectura de Fukushima",
      "ptName": "Província de Fukushima",
      "thName": "จังหวัดฟุกุชิมะ",
      "viName": "Tỉnh Fukushima",
      "inName": "Prefektur Fukushima",
      "tlName": "Fukushima Prefecture",
      "moName": "Фүкүшима аймаг",
      "buName": "ဖူကူရှီမ ပြည်နယ်",
      "khName": "ខេត្ត ហ្វូគូស៊ីម៉ា",
      "neName": "फुकुसिमा जिल्ला"
    },
    "class10": {
      "code": "070020",
      "name": "浜通り",
      "enName": "Hamadori",
      "chName": "福岛县滨通道",
      "zhName": "福島縣濱通",
      "koName": "후쿠시마 현 하마 도리",
      "esName": "Hamadori, Prefectura de Fukushima",
      "ptName": "Hama-dōri da Província de Fukushima",
      "thName": "ฮามะโดริ จังหวัดฟุกุชิมะ",
      "viName": "Hamadori, tỉnh Fukushima",
      "inName": "Hamadori, Prefektur Fukushima",
      "tlName": "Hamadori, Fukushima Prefecture",
      "moName": "Фүкүшима аймаг, Хамадори",
      "buName": "ဟမဒိုယိ၊ ဟုခုရှိမစီရင်စု",
      "khName": "តំបន់ហាម៉ាដូរីនៃខេត្តហ្វឹគឹស៊ីម៉ា",
      "neName": "फुकुसिमा जिल्ला, हामादोरी"
    },
    "class15": {
      "code": "070022",
      "name": "浜通り中部",
      "enName": "Central Hamadori"
    },
    "class20": {
      "code": "0754700",
      "name": "浪江町",
      "enName": "Namie Town",
      "kana": "なみえまち",
      "chName": "浪江町",
      "zhName": "浪江町",
      "koName": "나미에 정",
      "esName": "Pueblo de Namie",
      "ptName": "bairro de Namie",
      "thName": "เมืองนามิเอะ",
      "viName": "thị trấn Namie",
      "inName": "kota Namie",
      "tlName": "bayan ng Namie",
      "moName": "Нaмиэ жижиг хот",
      "buName": "နာမိယဲ့ မြို့နယ်",
      "khName": "ទីប្រជុំជន ណាំមី",
      "neName": "नामिए नगर"
    }
  },
  "0754800": {
    "office": {
      "code": "070000",
      "name": "福島県",
      "enName": "Fukushima",
      "officeName": "福島地方気象台",
      "chName": "福岛县",
      "zhName": "福島縣",
      "koName": "후쿠시마현",
      "esName": "Prefectura de Fukushima",
      "ptName": "Província de Fukushima",
      "thName": "จังหวัดฟุกุชิมะ",
      "viName": "Tỉnh Fukushima",
      "inName": "Prefektur Fukushima",
      "tlName": "Fukushima Prefecture",
      "moName": "Фүкүшима аймаг",
      "buName": "ဖူကူရှီမ ပြည်နယ်",
      "khName": "ខេត្ត ហ្វូគូស៊ីម៉ា",
      "neName": "फुकुसिमा जिल्ला"
    },
    "class10": {
      "code": "070020",
      "name": "浜通り",
      "enName": "Hamadori",
      "chName": "福岛县滨通道",
      "zhName": "福島縣濱通",
      "koName": "후쿠시마 현 하마 도리",
      "esName": "Hamadori, Prefectura de Fukushima",
      "ptName": "Hama-dōri da Província de Fukushima",
      "thName": "ฮามะโดริ จังหวัดฟุกุชิมะ",
      "viName": "Hamadori, tỉnh Fukushima",
      "inName": "Hamadori, Prefektur Fukushima",
      "tlName": "Hamadori, Fukushima Prefecture",
      "moName": "Фүкүшима аймаг, Хамадори",
      "buName": "ဟမဒိုယိ၊ ဟုခုရှိမစီရင်စု",
      "khName": "តំបន់ហាម៉ាដូរីនៃខេត្តហ្វឹគឹស៊ីម៉ា",
      "neName": "फुकुसिमा जिल्ला, हामादोरी"
    },
    "class15": {
      "code": "070022",
      "name": "浜通り中部",
      "enName": "Central Hamadori"
    },
    "class20": {
      "code": "0754800",
      "name": "葛尾村",
      "enName": "Katsurao Village",
      "kana": "かつらおむら",
      "chName": "葛尾村",
      "zhName": "葛尾村",
      "koName": "가쓰라오 촌",
      "esName": "Aldea de Katsurao",
      "ptName": "povoado de Katsurao",
      "thName": "หมู่บ้านคัทสึราโอ",
      "viName": "làng Katsurao",
      "inName": "desa Katsurao",
      "tlName": "nayon ng Katsurao",
      "moName": "Кацүрао тосгон",
      "buName": "ကာဆုရောင် ကျေးရွာ",
      "khName": "ភូមិ កាតស៊ូរ៉ៅ ",
      "neName": "कात्सुराओ गाउँ"
    }
  },
  "0756100": {
    "office": {
      "code": "070000",
      "name": "福島県",
      "enName": "Fukushima",
      "officeName": "福島地方気象台",
      "chName": "福岛县",
      "zhName": "福島縣",
      "koName": "후쿠시마현",
      "esName": "Prefectura de Fukushima",
      "ptName": "Província de Fukushima",
      "thName": "จังหวัดฟุกุชิมะ",
      "viName": "Tỉnh Fukushima",
      "inName": "Prefektur Fukushima",
      "tlName": "Fukushima Prefecture",
      "moName": "Фүкүшима аймаг",
      "buName": "ဖူကူရှီမ ပြည်နယ်",
      "khName": "ខេត្ត ហ្វូគូស៊ីម៉ា",
      "neName": "फुकुसिमा जिल्ला"
    },
    "class10": {
      "code": "070020",
      "name": "浜通り",
      "enName": "Hamadori",
      "chName": "福岛县滨通道",
      "zhName": "福島縣濱通",
      "koName": "후쿠시마 현 하마 도리",
      "esName": "Hamadori, Prefectura de Fukushima",
      "ptName": "Hama-dōri da Província de Fukushima",
      "thName": "ฮามะโดริ จังหวัดฟุกุชิมะ",
      "viName": "Hamadori, tỉnh Fukushima",
      "inName": "Hamadori, Prefektur Fukushima",
      "tlName": "Hamadori, Fukushima Prefecture",
      "moName": "Фүкүшима аймаг, Хамадори",
      "buName": "ဟမဒိုယိ၊ ဟုခုရှိမစီရင်စု",
      "khName": "តំបន់ហាម៉ាដូរីនៃខេត្តហ្វឹគឹស៊ីម៉ា",
      "neName": "फुकुसिमा जिल्ला, हामादोरी"
    },
    "class15": {
      "code": "070021",
      "name": "浜通り北部",
      "enName": "Northern Hamadori"
    },
    "class20": {
      "code": "0756100",
      "name": "新地町",
      "enName": "Shinchi Town",
      "kana": "しんちまち",
      "chName": "新地町",
      "zhName": "新地町",
      "koName": "신치 정",
      "esName": "Pueblo de Shinchi",
      "ptName": "bairro de Shinchi",
      "thName": "เมืองชินจิ",
      "viName": "thị trấn Shinchi",
      "inName": "kota Shinchi",
      "tlName": "bayan ng Shinchi",
      "moName": "Шинчи жижиг хот",
      "buName": "ရှင်းကျိ မြို့နယ်",
      "khName": " ទីប្រជុំជន ស៊ីនជី",
      "neName": "शिन्ची नगर"
    }
  },
  "0756400": {
    "office": {
      "code": "070000",
      "name": "福島県",
      "enName": "Fukushima",
      "officeName": "福島地方気象台",
      "chName": "福岛县",
      "zhName": "福島縣",
      "koName": "후쿠시마현",
      "esName": "Prefectura de Fukushima",
      "ptName": "Província de Fukushima",
      "thName": "จังหวัดฟุกุชิมะ",
      "viName": "Tỉnh Fukushima",
      "inName": "Prefektur Fukushima",
      "tlName": "Fukushima Prefecture",
      "moName": "Фүкүшима аймаг",
      "buName": "ဖူကူရှီမ ပြည်နယ်",
      "khName": "ខេត្ត ហ្វូគូស៊ីម៉ា",
      "neName": "फुकुसिमा जिल्ला"
    },
    "class10": {
      "code": "070020",
      "name": "浜通り",
      "enName": "Hamadori",
      "chName": "福岛县滨通道",
      "zhName": "福島縣濱通",
      "koName": "후쿠시마 현 하마 도리",
      "esName": "Hamadori, Prefectura de Fukushima",
      "ptName": "Hama-dōri da Província de Fukushima",
      "thName": "ฮามะโดริ จังหวัดฟุกุชิมะ",
      "viName": "Hamadori, tỉnh Fukushima",
      "inName": "Hamadori, Prefektur Fukushima",
      "tlName": "Hamadori, Fukushima Prefecture",
      "moName": "Фүкүшима аймаг, Хамадори",
      "buName": "ဟမဒိုယိ၊ ဟုခုရှိမစီရင်စု",
      "khName": "តំបន់ហាម៉ាដូរីនៃខេត្តហ្វឹគឹស៊ីម៉ា",
      "neName": "फुकुसिमा जिल्ला, हामादोरी"
    },
    "class15": {
      "code": "070021",
      "name": "浜通り北部",
      "enName": "Northern Hamadori"
    },
    "class20": {
      "code": "0756400",
      "name": "飯舘村",
      "enName": "Iitate Village",
      "kana": "いいたてむら",
      "chName": "饭馆村",
      "zhName": "飯館村",
      "koName": "이타테 촌",
      "esName": "Aldea de Iitate",
      "ptName": "povoado de Iitate",
      "thName": "หมู่บ้านอิอิทาเตะ",
      "viName": "làng Iitate",
      "inName": "desa Iitate",
      "tlName": "nayon ng Iitate",
      "moName": "Ийтатэ тосгон",
      "buName": "အီးတာ့တဲ့ ကျေးရွာ",
      "khName": "ភូមិ លីថាតេ",
      "neName": "आइताते गाउँ"
    }
  },
  "0820100": {
    "office": {
      "code": "080000",
      "name": "茨城県",
      "enName": "Ibaraki",
      "officeName": "水戸地方気象台",
      "chName": "茨城县",
      "zhName": "茨城縣",
      "koName": "이바라키현",
      "esName": "Prefectura de Ibaraki",
      "ptName": "Província de Ibaraki",
      "thName": "จังหวัดอิบารากิ",
      "viName": "Tỉnh Ibaraki",
      "inName": "Prefektur Ibaraki",
      "tlName": "Ibaraki Prefecture",
      "moName": "Ибараки аймаг",
      "buName": "အီဘာရာကိ ပြည်နယ်",
      "khName": "ខេត្ត អ៊ីបារ៉ាគី",
      "neName": "इबाराकी जिल्ला"
    },
    "class10": {
      "code": "080010",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "茨城县北部",
      "zhName": "茨城縣北部",
      "koName": "이바라키 현 북부",
      "esName": "Norte de Prefectura de Ibaraki",
      "ptName": "Norte da Província de Ibaraki",
      "thName": "จังหวัดอิบารากิตอนเหนือ",
      "viName": "Miền Bắc tỉnh Ibaraki",
      "inName": "Bagian Utara Prefektur Ibaraki",
      "tlName": "Hilagang bahagi ng Ibaraki Prefecture",
      "moName": "Хойд Ибараки аймаг",
      "buName": "အိဘယခိစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្តអ៊ីបារ៉ាគី",
      "neName": "इबाराकी जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "080011",
      "name": "県央地域",
      "enName": "Ken-o Area"
    },
    "class20": {
      "code": "0820100",
      "name": "水戸市",
      "enName": "Mito City",
      "kana": "みとし",
      "chName": "水户市",
      "zhName": "水戶市",
      "koName": "미토 시",
      "esName": "Ciudad de Mito",
      "ptName": "cidade de Mito",
      "thName": "เมืองมิโตะ",
      "viName": "thành phố Mito",
      "inName": "kota Mito",
      "tlName": "siyudad ng Mito",
      "moName": "Мито хот",
      "buName": "မီတို မြို့",
      "khName": "ទីក្រុង មីតូ",
      "neName": "मितो सहर"
    }
  },
  "0820200": {
    "office": {
      "code": "080000",
      "name": "茨城県",
      "enName": "Ibaraki",
      "officeName": "水戸地方気象台",
      "chName": "茨城县",
      "zhName": "茨城縣",
      "koName": "이바라키현",
      "esName": "Prefectura de Ibaraki",
      "ptName": "Província de Ibaraki",
      "thName": "จังหวัดอิบารากิ",
      "viName": "Tỉnh Ibaraki",
      "inName": "Prefektur Ibaraki",
      "tlName": "Ibaraki Prefecture",
      "moName": "Ибараки аймаг",
      "buName": "အီဘာရာကိ ပြည်နယ်",
      "khName": "ខេត្ត អ៊ីបារ៉ាគី",
      "neName": "इबाराकी जिल्ला"
    },
    "class10": {
      "code": "080010",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "茨城县北部",
      "zhName": "茨城縣北部",
      "koName": "이바라키 현 북부",
      "esName": "Norte de Prefectura de Ibaraki",
      "ptName": "Norte da Província de Ibaraki",
      "thName": "จังหวัดอิบารากิตอนเหนือ",
      "viName": "Miền Bắc tỉnh Ibaraki",
      "inName": "Bagian Utara Prefektur Ibaraki",
      "tlName": "Hilagang bahagi ng Ibaraki Prefecture",
      "moName": "Хойд Ибараки аймаг",
      "buName": "အိဘယခိစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្តអ៊ីបារ៉ាគី",
      "neName": "इबाराकी जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "080012",
      "name": "県北地域",
      "enName": "Kempoku Area"
    },
    "class20": {
      "code": "0820200",
      "name": "日立市",
      "enName": "Hitachi City",
      "kana": "ひたちし",
      "chName": "日立市",
      "zhName": "日立市",
      "koName": "히타치 시",
      "esName": "Ciudad de Hitachi",
      "ptName": "cidade de Hitachi",
      "thName": "เมืองฮิตาจิ",
      "viName": "thành phố Hitachi",
      "inName": "kota Hitachi",
      "tlName": "siyudad ng Hitachi",
      "moName": "Хитачи хот",
      "buName": "ဟီတာကျိ မြို့",
      "khName": "ទីក្រុង ហ៊ីតាជី",
      "neName": "हिताची सहर"
    }
  },
  "0820300": {
    "office": {
      "code": "080000",
      "name": "茨城県",
      "enName": "Ibaraki",
      "officeName": "水戸地方気象台",
      "chName": "茨城县",
      "zhName": "茨城縣",
      "koName": "이바라키현",
      "esName": "Prefectura de Ibaraki",
      "ptName": "Província de Ibaraki",
      "thName": "จังหวัดอิบารากิ",
      "viName": "Tỉnh Ibaraki",
      "inName": "Prefektur Ibaraki",
      "tlName": "Ibaraki Prefecture",
      "moName": "Ибараки аймаг",
      "buName": "အီဘာရာကိ ပြည်နယ်",
      "khName": "ខេត្ត អ៊ីបារ៉ាគី",
      "neName": "इबाराकी जिल्ला"
    },
    "class10": {
      "code": "080020",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "茨城县南部",
      "zhName": "茨城縣南部",
      "koName": "이바라키 현 남부",
      "esName": "Sur de Prefectura de Ibaraki",
      "ptName": "Sul da Província de Ibaraki",
      "thName": "จังหวัดอิบารากิตอนใต้",
      "viName": "Miền Nam tỉnh Ibaraki",
      "inName": "Bagian Selatan Prefektur Ibaraki",
      "tlName": "Timog na bahagi ng Ibaraki Prefecture",
      "moName": "Өмнөд Ибараки аймаг",
      "buName": "အိဘယခိစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្តអ៊ីបារ៉ាគី",
      "neName": "इबाराकी जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "080022",
      "name": "県南地域",
      "enName": "Kennan Area"
    },
    "class20": {
      "code": "0820300",
      "name": "土浦市",
      "enName": "Tsuchiura City",
      "kana": "つちうらし",
      "chName": "土浦市",
      "zhName": "土浦市",
      "koName": "쓰치우라 시",
      "esName": "Ciudad de Tsuchiura",
      "ptName": "cidade de Tsuchiura",
      "thName": "เมืองสึจิอุระ",
      "viName": "thành phố Tsuchiura",
      "inName": "kota Tsuchiura",
      "tlName": "siyudad ng Tsuchiura",
      "moName": "Цүчиүра хот",
      "buName": "ဆူချီအူရ မြို့",
      "khName": "ទីក្រុង ស៊ូជីរ៉ា",
      "neName": "त्सुचिउरा सहर"
    }
  },
  "0820400": {
    "office": {
      "code": "080000",
      "name": "茨城県",
      "enName": "Ibaraki",
      "officeName": "水戸地方気象台",
      "chName": "茨城县",
      "zhName": "茨城縣",
      "koName": "이바라키현",
      "esName": "Prefectura de Ibaraki",
      "ptName": "Província de Ibaraki",
      "thName": "จังหวัดอิบารากิ",
      "viName": "Tỉnh Ibaraki",
      "inName": "Prefektur Ibaraki",
      "tlName": "Ibaraki Prefecture",
      "moName": "Ибараки аймаг",
      "buName": "အီဘာရာကိ ပြည်နယ်",
      "khName": "ខេត្ត អ៊ីបារ៉ាគី",
      "neName": "इबाराकी जिल्ला"
    },
    "class10": {
      "code": "080020",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "茨城县南部",
      "zhName": "茨城縣南部",
      "koName": "이바라키 현 남부",
      "esName": "Sur de Prefectura de Ibaraki",
      "ptName": "Sul da Província de Ibaraki",
      "thName": "จังหวัดอิบารากิตอนใต้",
      "viName": "Miền Nam tỉnh Ibaraki",
      "inName": "Bagian Selatan Prefektur Ibaraki",
      "tlName": "Timog na bahagi ng Ibaraki Prefecture",
      "moName": "Өмнөд Ибараки аймаг",
      "buName": "အိဘယခိစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្តអ៊ីបារ៉ាគី",
      "neName": "इबाराकी जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "080023",
      "name": "県西地域",
      "enName": "Kensei Area"
    },
    "class20": {
      "code": "0820400",
      "name": "古河市",
      "enName": "Koga City",
      "kana": "こがし",
      "chName": "茨城古河市",
      "zhName": "茨城古河市",
      "koName": "이바라키 고가 시",
      "esName": "Ciudad de Koga, Ibaraki",
      "ptName": "Ibaraki, cidade de Koga ",
      "thName": "เมืองโคงะ อิบารากิ",
      "viName": "Thành phố Koga, Ibaraki",
      "inName": "Kota Koga, Ibaraki",
      "tlName": "siyudad ng Koga, Ibaraki",
      "moName": "Ибарики Кога хот",
      "buName": "အိဘချိခိခိုဂမြို့",
      "khName": "ទីក្រុងកូហ្គាក់ អ៊ីបារ៉ាគី",
      "neName": "इबाराकी कोगा सहर"
    }
  },
  "0820500": {
    "office": {
      "code": "080000",
      "name": "茨城県",
      "enName": "Ibaraki",
      "officeName": "水戸地方気象台",
      "chName": "茨城县",
      "zhName": "茨城縣",
      "koName": "이바라키현",
      "esName": "Prefectura de Ibaraki",
      "ptName": "Província de Ibaraki",
      "thName": "จังหวัดอิบารากิ",
      "viName": "Tỉnh Ibaraki",
      "inName": "Prefektur Ibaraki",
      "tlName": "Ibaraki Prefecture",
      "moName": "Ибараки аймаг",
      "buName": "အီဘာရာကိ ပြည်နယ်",
      "khName": "ខេត្ត អ៊ីបារ៉ាគី",
      "neName": "इबाराकी जिल्ला"
    },
    "class10": {
      "code": "080020",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "茨城县南部",
      "zhName": "茨城縣南部",
      "koName": "이바라키 현 남부",
      "esName": "Sur de Prefectura de Ibaraki",
      "ptName": "Sul da Província de Ibaraki",
      "thName": "จังหวัดอิบารากิตอนใต้",
      "viName": "Miền Nam tỉnh Ibaraki",
      "inName": "Bagian Selatan Prefektur Ibaraki",
      "tlName": "Timog na bahagi ng Ibaraki Prefecture",
      "moName": "Өмнөд Ибараки аймаг",
      "buName": "အိဘယခိစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្តអ៊ីបារ៉ាគី",
      "neName": "इबाराकी जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "080022",
      "name": "県南地域",
      "enName": "Kennan Area"
    },
    "class20": {
      "code": "0820500",
      "name": "石岡市",
      "enName": "Ishioka City",
      "kana": "いしおかし",
      "chName": "石冈市",
      "zhName": "石岡市",
      "koName": "이시오카 시",
      "esName": "Ciudad de Ishioka",
      "ptName": "cidade de Ishioka",
      "thName": "เมืองอิชิโอกะ",
      "viName": "thành phố Ishioka",
      "inName": "kota Ishioka",
      "tlName": "siyudad ng Ishioka",
      "moName": "Ишиока хот",
      "buName": "အီရှီယို့က မြို့",
      "khName": "ទីក្រុង អ៊ីស៊ីអីកា",
      "neName": "इशियोका सहर"
    }
  },
  "0820700": {
    "office": {
      "code": "080000",
      "name": "茨城県",
      "enName": "Ibaraki",
      "officeName": "水戸地方気象台",
      "chName": "茨城县",
      "zhName": "茨城縣",
      "koName": "이바라키현",
      "esName": "Prefectura de Ibaraki",
      "ptName": "Província de Ibaraki",
      "thName": "จังหวัดอิบารากิ",
      "viName": "Tỉnh Ibaraki",
      "inName": "Prefektur Ibaraki",
      "tlName": "Ibaraki Prefecture",
      "moName": "Ибараки аймаг",
      "buName": "အီဘာရာကိ ပြည်နယ်",
      "khName": "ខេត្ត អ៊ីបារ៉ាគី",
      "neName": "इबाराकी जिल्ला"
    },
    "class10": {
      "code": "080020",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "茨城县南部",
      "zhName": "茨城縣南部",
      "koName": "이바라키 현 남부",
      "esName": "Sur de Prefectura de Ibaraki",
      "ptName": "Sul da Província de Ibaraki",
      "thName": "จังหวัดอิบารากิตอนใต้",
      "viName": "Miền Nam tỉnh Ibaraki",
      "inName": "Bagian Selatan Prefektur Ibaraki",
      "tlName": "Timog na bahagi ng Ibaraki Prefecture",
      "moName": "Өмнөд Ибараки аймаг",
      "buName": "အိဘယခိစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្តអ៊ីបារ៉ាគី",
      "neName": "इबाराकी जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "080023",
      "name": "県西地域",
      "enName": "Kensei Area"
    },
    "class20": {
      "code": "0820700",
      "name": "結城市",
      "enName": "Yuki City",
      "kana": "ゆうきし",
      "chName": "结城市",
      "zhName": "結城市",
      "koName": "유키 시",
      "esName": "Ciudad de Yuki",
      "ptName": "cidade de Yuki",
      "thName": "เมืองยูกิ",
      "viName": "thành phố Yuki",
      "inName": "kota Yuki",
      "tlName": "siyudad ng Yuki",
      "moName": "Юүки хот",
      "buName": "ယူကိ မြို့",
      "khName": "ទីក្រុង យូគី",
      "neName": "युकी सहर"
    }
  },
  "0820800": {
    "office": {
      "code": "080000",
      "name": "茨城県",
      "enName": "Ibaraki",
      "officeName": "水戸地方気象台",
      "chName": "茨城县",
      "zhName": "茨城縣",
      "koName": "이바라키현",
      "esName": "Prefectura de Ibaraki",
      "ptName": "Província de Ibaraki",
      "thName": "จังหวัดอิบารากิ",
      "viName": "Tỉnh Ibaraki",
      "inName": "Prefektur Ibaraki",
      "tlName": "Ibaraki Prefecture",
      "moName": "Ибараки аймаг",
      "buName": "အီဘာရာကိ ပြည်နယ်",
      "khName": "ខេត្ត អ៊ីបារ៉ាគី",
      "neName": "इबाराकी जिल्ला"
    },
    "class10": {
      "code": "080020",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "茨城县南部",
      "zhName": "茨城縣南部",
      "koName": "이바라키 현 남부",
      "esName": "Sur de Prefectura de Ibaraki",
      "ptName": "Sul da Província de Ibaraki",
      "thName": "จังหวัดอิบารากิตอนใต้",
      "viName": "Miền Nam tỉnh Ibaraki",
      "inName": "Bagian Selatan Prefektur Ibaraki",
      "tlName": "Timog na bahagi ng Ibaraki Prefecture",
      "moName": "Өмнөд Ибараки аймаг",
      "buName": "အိဘယခိစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្តអ៊ីបារ៉ាគី",
      "neName": "इबाराकी जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "080022",
      "name": "県南地域",
      "enName": "Kennan Area"
    },
    "class20": {
      "code": "0820800",
      "name": "龍ケ崎市",
      "enName": "Ryugasaki City",
      "kana": "りゅうがさきし",
      "chName": "龙崎市",
      "zhName": "龍崎市",
      "koName": "류가사키 시",
      "esName": "Ciudad de Ryugasaki",
      "ptName": "cidade de Ryugasaki",
      "thName": "เมืองรีวงาซากิ",
      "viName": "thành phố Ryugasaki",
      "inName": "kota Ryugasaki",
      "tlName": "siyudad ng Ryugasaki",
      "moName": "Рюгасаки хот",
      "buName": "ရူဂဆာ့ကိ မြို့",
      "khName": "ទីក្រុង រ៉ាយូកាសាគី",
      "neName": "ऋउगासाकी सहर"
    }
  },
  "0821000": {
    "office": {
      "code": "080000",
      "name": "茨城県",
      "enName": "Ibaraki",
      "officeName": "水戸地方気象台",
      "chName": "茨城县",
      "zhName": "茨城縣",
      "koName": "이바라키현",
      "esName": "Prefectura de Ibaraki",
      "ptName": "Província de Ibaraki",
      "thName": "จังหวัดอิบารากิ",
      "viName": "Tỉnh Ibaraki",
      "inName": "Prefektur Ibaraki",
      "tlName": "Ibaraki Prefecture",
      "moName": "Ибараки аймаг",
      "buName": "အီဘာရာကိ ပြည်နယ်",
      "khName": "ខេត្ត អ៊ីបារ៉ាគី",
      "neName": "इबाराकी जिल्ला"
    },
    "class10": {
      "code": "080020",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "茨城县南部",
      "zhName": "茨城縣南部",
      "koName": "이바라키 현 남부",
      "esName": "Sur de Prefectura de Ibaraki",
      "ptName": "Sul da Província de Ibaraki",
      "thName": "จังหวัดอิบารากิตอนใต้",
      "viName": "Miền Nam tỉnh Ibaraki",
      "inName": "Bagian Selatan Prefektur Ibaraki",
      "tlName": "Timog na bahagi ng Ibaraki Prefecture",
      "moName": "Өмнөд Ибараки аймаг",
      "buName": "အိဘယခိစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្តអ៊ីបារ៉ាគី",
      "neName": "इबाराकी जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "080023",
      "name": "県西地域",
      "enName": "Kensei Area"
    },
    "class20": {
      "code": "0821000",
      "name": "下妻市",
      "enName": "Shimotsuma City",
      "kana": "しもつまし",
      "chName": "下妻市",
      "zhName": "下妻市",
      "koName": "시모쓰마 시",
      "esName": "Ciudad de Shimotsuma",
      "ptName": "cidade de Shimotsuma",
      "thName": "เมืองชิโมสึมะ",
      "viName": "thành phố Shimotsuma",
      "inName": "kota Shimotsuma",
      "tlName": "siyudad ng Shimotsuma",
      "moName": "Шимоцүма хот",
      "buName": "ရှီမိုဆုမ မြို့",
      "khName": "ទីក្រុង ស៊ីម៉ូតសូម៉ា",
      "neName": "शिमोत्सुमा सहर"
    }
  },
  "0821100": {
    "office": {
      "code": "080000",
      "name": "茨城県",
      "enName": "Ibaraki",
      "officeName": "水戸地方気象台",
      "chName": "茨城县",
      "zhName": "茨城縣",
      "koName": "이바라키현",
      "esName": "Prefectura de Ibaraki",
      "ptName": "Província de Ibaraki",
      "thName": "จังหวัดอิบารากิ",
      "viName": "Tỉnh Ibaraki",
      "inName": "Prefektur Ibaraki",
      "tlName": "Ibaraki Prefecture",
      "moName": "Ибараки аймаг",
      "buName": "အီဘာရာကိ ပြည်နယ်",
      "khName": "ខេត្ត អ៊ីបារ៉ាគី",
      "neName": "इबाराकी जिल्ला"
    },
    "class10": {
      "code": "080020",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "茨城县南部",
      "zhName": "茨城縣南部",
      "koName": "이바라키 현 남부",
      "esName": "Sur de Prefectura de Ibaraki",
      "ptName": "Sul da Província de Ibaraki",
      "thName": "จังหวัดอิบารากิตอนใต้",
      "viName": "Miền Nam tỉnh Ibaraki",
      "inName": "Bagian Selatan Prefektur Ibaraki",
      "tlName": "Timog na bahagi ng Ibaraki Prefecture",
      "moName": "Өмнөд Ибараки аймаг",
      "buName": "အိဘယခိစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្តអ៊ីបារ៉ាគី",
      "neName": "इबाराकी जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "080023",
      "name": "県西地域",
      "enName": "Kensei Area"
    },
    "class20": {
      "code": "0821100",
      "name": "常総市",
      "enName": "Joso City",
      "kana": "じょうそうし",
      "chName": "常总市",
      "zhName": "常總市",
      "koName": "조소 시",
      "esName": "Ciudad de Hitachi",
      "ptName": "cidade de Joso",
      "thName": "เมืองโจโสะ",
      "viName": "thành phố Joso",
      "inName": "kota Joso",
      "tlName": "siyudad ng Joso",
      "moName": "Жосо хот",
      "buName": "ဂျိုဆော့ မြို့",
      "khName": "ទីក្រុង ជូសូ",
      "neName": "जोसो सहर"
    }
  },
  "0821200": {
    "office": {
      "code": "080000",
      "name": "茨城県",
      "enName": "Ibaraki",
      "officeName": "水戸地方気象台",
      "chName": "茨城县",
      "zhName": "茨城縣",
      "koName": "이바라키현",
      "esName": "Prefectura de Ibaraki",
      "ptName": "Província de Ibaraki",
      "thName": "จังหวัดอิบารากิ",
      "viName": "Tỉnh Ibaraki",
      "inName": "Prefektur Ibaraki",
      "tlName": "Ibaraki Prefecture",
      "moName": "Ибараки аймаг",
      "buName": "အီဘာရာကိ ပြည်နယ်",
      "khName": "ខេត្ត អ៊ីបារ៉ាគី",
      "neName": "इबाराकी जिल्ला"
    },
    "class10": {
      "code": "080010",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "茨城县北部",
      "zhName": "茨城縣北部",
      "koName": "이바라키 현 북부",
      "esName": "Norte de Prefectura de Ibaraki",
      "ptName": "Norte da Província de Ibaraki",
      "thName": "จังหวัดอิบารากิตอนเหนือ",
      "viName": "Miền Bắc tỉnh Ibaraki",
      "inName": "Bagian Utara Prefektur Ibaraki",
      "tlName": "Hilagang bahagi ng Ibaraki Prefecture",
      "moName": "Хойд Ибараки аймаг",
      "buName": "အိဘယခိစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្តអ៊ីបារ៉ាគី",
      "neName": "इबाराकी जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "080012",
      "name": "県北地域",
      "enName": "Kempoku Area"
    },
    "class20": {
      "code": "0821200",
      "name": "常陸太田市",
      "enName": "Hitachiota City",
      "kana": "ひたちおおたし",
      "chName": "常陆太田市",
      "zhName": "常陸太田市",
      "koName": "히타치오타 시",
      "esName": "Ciudad de Hitachiota",
      "ptName": "cidade de Hitachiota",
      "thName": "เมืองฮิตาจิโอตะ",
      "viName": "thành phố Hitachiota",
      "inName": "kota Hitachiota",
      "tlName": "siyudad ng Hitachiota",
      "moName": "Хитачиота хот",
      "buName": "ဟီတာကျိယို့တ မြို့",
      "khName": "ទីក្រុង ហ៊ីតីតចាយអូតា",
      "neName": "हिताचियोता सहर"
    }
  },
  "0821400": {
    "office": {
      "code": "080000",
      "name": "茨城県",
      "enName": "Ibaraki",
      "officeName": "水戸地方気象台",
      "chName": "茨城县",
      "zhName": "茨城縣",
      "koName": "이바라키현",
      "esName": "Prefectura de Ibaraki",
      "ptName": "Província de Ibaraki",
      "thName": "จังหวัดอิบารากิ",
      "viName": "Tỉnh Ibaraki",
      "inName": "Prefektur Ibaraki",
      "tlName": "Ibaraki Prefecture",
      "moName": "Ибараки аймаг",
      "buName": "အီဘာရာကိ ပြည်နယ်",
      "khName": "ខេត្ត អ៊ីបារ៉ាគី",
      "neName": "इबाराकी जिल्ला"
    },
    "class10": {
      "code": "080010",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "茨城县北部",
      "zhName": "茨城縣北部",
      "koName": "이바라키 현 북부",
      "esName": "Norte de Prefectura de Ibaraki",
      "ptName": "Norte da Província de Ibaraki",
      "thName": "จังหวัดอิบารากิตอนเหนือ",
      "viName": "Miền Bắc tỉnh Ibaraki",
      "inName": "Bagian Utara Prefektur Ibaraki",
      "tlName": "Hilagang bahagi ng Ibaraki Prefecture",
      "moName": "Хойд Ибараки аймаг",
      "buName": "အိဘယခိစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្តអ៊ីបារ៉ាគី",
      "neName": "इबाराकी जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "080012",
      "name": "県北地域",
      "enName": "Kempoku Area"
    },
    "class20": {
      "code": "0821400",
      "name": "高萩市",
      "enName": "Takahagi City",
      "kana": "たかはぎし",
      "chName": "高荻市",
      "zhName": "髙萩市",
      "koName": "다카하기 시",
      "esName": "Ciudad de Takahagi",
      "ptName": "cidade de Takahagi",
      "thName": "เมืองทากาฮากิ",
      "viName": "thành phố Takahagi",
      "inName": "kota Takahagi",
      "tlName": "siyudad ng Takahagi",
      "moName": "Такахаги хот",
      "buName": "တာကာဟဂိ မြို့",
      "khName": "ទីក្រុង តាកាហាជី",
      "neName": "ताकाहागी सहर"
    }
  },
  "0821500": {
    "office": {
      "code": "080000",
      "name": "茨城県",
      "enName": "Ibaraki",
      "officeName": "水戸地方気象台",
      "chName": "茨城县",
      "zhName": "茨城縣",
      "koName": "이바라키현",
      "esName": "Prefectura de Ibaraki",
      "ptName": "Província de Ibaraki",
      "thName": "จังหวัดอิบารากิ",
      "viName": "Tỉnh Ibaraki",
      "inName": "Prefektur Ibaraki",
      "tlName": "Ibaraki Prefecture",
      "moName": "Ибараки аймаг",
      "buName": "အီဘာရာကိ ပြည်နယ်",
      "khName": "ខេត្ត អ៊ីបារ៉ាគី",
      "neName": "इबाराकी जिल्ला"
    },
    "class10": {
      "code": "080010",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "茨城县北部",
      "zhName": "茨城縣北部",
      "koName": "이바라키 현 북부",
      "esName": "Norte de Prefectura de Ibaraki",
      "ptName": "Norte da Província de Ibaraki",
      "thName": "จังหวัดอิบารากิตอนเหนือ",
      "viName": "Miền Bắc tỉnh Ibaraki",
      "inName": "Bagian Utara Prefektur Ibaraki",
      "tlName": "Hilagang bahagi ng Ibaraki Prefecture",
      "moName": "Хойд Ибараки аймаг",
      "buName": "အိဘယခိစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្តអ៊ីបារ៉ាគី",
      "neName": "इबाराकी जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "080012",
      "name": "県北地域",
      "enName": "Kempoku Area"
    },
    "class20": {
      "code": "0821500",
      "name": "北茨城市",
      "enName": "Kitaibaraki City",
      "kana": "きたいばらきし",
      "chName": "北茨城市",
      "zhName": "北茨城市",
      "koName": "기타이바라키 시",
      "esName": "Ciudad de Kitaibaraki",
      "ptName": "cidade de Kitaibaraki",
      "thName": "เมืองคิตะอิบารากิ",
      "viName": "thành phố Kitaibaraki",
      "inName": "kota Kitaibaraki",
      "tlName": "siyudad ng Kitaibaraki",
      "moName": "Китайюараки хот",
      "buName": "ခီတာယိဘာရာကိ မြို့",
      "khName": "ទីក្រុង គីតាយបារ៉ាគី",
      "neName": "किताइबाराकी सहर"
    }
  },
  "0821600": {
    "office": {
      "code": "080000",
      "name": "茨城県",
      "enName": "Ibaraki",
      "officeName": "水戸地方気象台",
      "chName": "茨城县",
      "zhName": "茨城縣",
      "koName": "이바라키현",
      "esName": "Prefectura de Ibaraki",
      "ptName": "Província de Ibaraki",
      "thName": "จังหวัดอิบารากิ",
      "viName": "Tỉnh Ibaraki",
      "inName": "Prefektur Ibaraki",
      "tlName": "Ibaraki Prefecture",
      "moName": "Ибараки аймаг",
      "buName": "အီဘာရာကိ ပြည်နယ်",
      "khName": "ខេត្ត អ៊ីបារ៉ាគី",
      "neName": "इबाराकी जिल्ला"
    },
    "class10": {
      "code": "080010",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "茨城县北部",
      "zhName": "茨城縣北部",
      "koName": "이바라키 현 북부",
      "esName": "Norte de Prefectura de Ibaraki",
      "ptName": "Norte da Província de Ibaraki",
      "thName": "จังหวัดอิบารากิตอนเหนือ",
      "viName": "Miền Bắc tỉnh Ibaraki",
      "inName": "Bagian Utara Prefektur Ibaraki",
      "tlName": "Hilagang bahagi ng Ibaraki Prefecture",
      "moName": "Хойд Ибараки аймаг",
      "buName": "အိဘယခိစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្តអ៊ីបារ៉ាគី",
      "neName": "इबाराकी जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "080011",
      "name": "県央地域",
      "enName": "Ken-o Area"
    },
    "class20": {
      "code": "0821600",
      "name": "笠間市",
      "enName": "Kasama City",
      "kana": "かさまし",
      "chName": "笠间市",
      "zhName": "笠間市",
      "koName": "가사마 시",
      "esName": "Ciudad de Kasama",
      "ptName": "cidade de Kasama",
      "thName": "เมืองคาซามะ",
      "viName": "thành phố Kasama",
      "inName": "kota Kasama",
      "tlName": "siyudad ng Kasama",
      "moName": "Касама хот",
      "buName": "ကာဆာ့မ မြို့",
      "khName": "ទីក្រុង កាសាម៉ា",
      "neName": "कासामा सहर"
    }
  },
  "0821700": {
    "office": {
      "code": "080000",
      "name": "茨城県",
      "enName": "Ibaraki",
      "officeName": "水戸地方気象台",
      "chName": "茨城县",
      "zhName": "茨城縣",
      "koName": "이바라키현",
      "esName": "Prefectura de Ibaraki",
      "ptName": "Província de Ibaraki",
      "thName": "จังหวัดอิบารากิ",
      "viName": "Tỉnh Ibaraki",
      "inName": "Prefektur Ibaraki",
      "tlName": "Ibaraki Prefecture",
      "moName": "Ибараки аймаг",
      "buName": "အီဘာရာကိ ပြည်နယ်",
      "khName": "ខេត្ត អ៊ីបារ៉ាគី",
      "neName": "इबाराकी जिल्ला"
    },
    "class10": {
      "code": "080020",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "茨城县南部",
      "zhName": "茨城縣南部",
      "koName": "이바라키 현 남부",
      "esName": "Sur de Prefectura de Ibaraki",
      "ptName": "Sul da Província de Ibaraki",
      "thName": "จังหวัดอิบารากิตอนใต้",
      "viName": "Miền Nam tỉnh Ibaraki",
      "inName": "Bagian Selatan Prefektur Ibaraki",
      "tlName": "Timog na bahagi ng Ibaraki Prefecture",
      "moName": "Өмнөд Ибараки аймаг",
      "buName": "အိဘယခိစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្តអ៊ីបារ៉ាគី",
      "neName": "इबाराकी जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "080022",
      "name": "県南地域",
      "enName": "Kennan Area"
    },
    "class20": {
      "code": "0821700",
      "name": "取手市",
      "enName": "Toride City",
      "kana": "とりでし",
      "chName": "取手市",
      "zhName": "取手市",
      "koName": "도리데 시",
      "esName": "Ciudad de Toride",
      "ptName": "cidade de Toride",
      "thName": "เมืองโทริเดะ",
      "viName": "thành phố Toride",
      "inName": "kota Toride",
      "tlName": "siyudad ng Toride",
      "moName": "Торидэ хот",
      "buName": "တိုရီဒဲ့ မြို့",
      "khName": "ទីក្រុង ធូរ៉ាយ",
      "neName": "तोरिदे सहर"
    }
  },
  "0821900": {
    "office": {
      "code": "080000",
      "name": "茨城県",
      "enName": "Ibaraki",
      "officeName": "水戸地方気象台",
      "chName": "茨城县",
      "zhName": "茨城縣",
      "koName": "이바라키현",
      "esName": "Prefectura de Ibaraki",
      "ptName": "Província de Ibaraki",
      "thName": "จังหวัดอิบารากิ",
      "viName": "Tỉnh Ibaraki",
      "inName": "Prefektur Ibaraki",
      "tlName": "Ibaraki Prefecture",
      "moName": "Ибараки аймаг",
      "buName": "အီဘာရာကိ ပြည်နယ်",
      "khName": "ខេត្ត អ៊ីបារ៉ាគី",
      "neName": "इबाराकी जिल्ला"
    },
    "class10": {
      "code": "080020",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "茨城县南部",
      "zhName": "茨城縣南部",
      "koName": "이바라키 현 남부",
      "esName": "Sur de Prefectura de Ibaraki",
      "ptName": "Sul da Província de Ibaraki",
      "thName": "จังหวัดอิบารากิตอนใต้",
      "viName": "Miền Nam tỉnh Ibaraki",
      "inName": "Bagian Selatan Prefektur Ibaraki",
      "tlName": "Timog na bahagi ng Ibaraki Prefecture",
      "moName": "Өмнөд Ибараки аймаг",
      "buName": "အိဘယခိစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្តអ៊ីបារ៉ាគី",
      "neName": "इबाराकी जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "080022",
      "name": "県南地域",
      "enName": "Kennan Area"
    },
    "class20": {
      "code": "0821900",
      "name": "牛久市",
      "enName": "Ushiku City",
      "kana": "うしくし",
      "chName": "牛久市",
      "zhName": "牛久市",
      "koName": "우시쿠 시",
      "esName": "Ciudad de Ushiku",
      "ptName": "cidade de Ushiku",
      "thName": "เมืองอุชิกุ",
      "viName": "thành phố Ushiku",
      "inName": "kota Ushiku",
      "tlName": "siyudad ng Ushiku",
      "moName": "Үшикү хот",
      "buName": "အုရှီကု မြို့",
      "khName": "ទីក្រុង យូស៊ីគុ",
      "neName": "उशिकु सहर"
    }
  },
  "0822000": {
    "office": {
      "code": "080000",
      "name": "茨城県",
      "enName": "Ibaraki",
      "officeName": "水戸地方気象台",
      "chName": "茨城县",
      "zhName": "茨城縣",
      "koName": "이바라키현",
      "esName": "Prefectura de Ibaraki",
      "ptName": "Província de Ibaraki",
      "thName": "จังหวัดอิบารากิ",
      "viName": "Tỉnh Ibaraki",
      "inName": "Prefektur Ibaraki",
      "tlName": "Ibaraki Prefecture",
      "moName": "Ибараки аймаг",
      "buName": "အီဘာရာကိ ပြည်နယ်",
      "khName": "ខេត្ត អ៊ីបារ៉ាគី",
      "neName": "इबाराकी जिल्ला"
    },
    "class10": {
      "code": "080020",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "茨城县南部",
      "zhName": "茨城縣南部",
      "koName": "이바라키 현 남부",
      "esName": "Sur de Prefectura de Ibaraki",
      "ptName": "Sul da Província de Ibaraki",
      "thName": "จังหวัดอิบารากิตอนใต้",
      "viName": "Miền Nam tỉnh Ibaraki",
      "inName": "Bagian Selatan Prefektur Ibaraki",
      "tlName": "Timog na bahagi ng Ibaraki Prefecture",
      "moName": "Өмнөд Ибараки аймаг",
      "buName": "အိဘယခိစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្តអ៊ីបារ៉ាគី",
      "neName": "इबाराकी जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "080022",
      "name": "県南地域",
      "enName": "Kennan Area"
    },
    "class20": {
      "code": "0822000",
      "name": "つくば市",
      "enName": "Tsukuba City",
      "kana": "つくばし",
      "chName": "筑波市",
      "zhName": "筑波市",
      "koName": "쓰쿠바 시",
      "esName": "Ciudad de Tsukuba",
      "ptName": "cidade de Tsukuba",
      "thName": "เมืองสึคุบะ",
      "viName": "thành phố Tsukuba",
      "inName": "kota Tsukuba",
      "tlName": "siyudad ng Tsukuba",
      "moName": "Цүкүба хот",
      "buName": "ဆူကူးဘ မြို့",
      "khName": "ទីក្រុង ស៊ូគូបា",
      "neName": "त्सुकुबा सहर"
    }
  },
  "0822100": {
    "office": {
      "code": "080000",
      "name": "茨城県",
      "enName": "Ibaraki",
      "officeName": "水戸地方気象台",
      "chName": "茨城县",
      "zhName": "茨城縣",
      "koName": "이바라키현",
      "esName": "Prefectura de Ibaraki",
      "ptName": "Província de Ibaraki",
      "thName": "จังหวัดอิบารากิ",
      "viName": "Tỉnh Ibaraki",
      "inName": "Prefektur Ibaraki",
      "tlName": "Ibaraki Prefecture",
      "moName": "Ибараки аймаг",
      "buName": "အီဘာရာကိ ပြည်နယ်",
      "khName": "ខេត្ត អ៊ីបារ៉ាគី",
      "neName": "इबाराकी जिल्ला"
    },
    "class10": {
      "code": "080010",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "茨城县北部",
      "zhName": "茨城縣北部",
      "koName": "이바라키 현 북부",
      "esName": "Norte de Prefectura de Ibaraki",
      "ptName": "Norte da Província de Ibaraki",
      "thName": "จังหวัดอิบารากิตอนเหนือ",
      "viName": "Miền Bắc tỉnh Ibaraki",
      "inName": "Bagian Utara Prefektur Ibaraki",
      "tlName": "Hilagang bahagi ng Ibaraki Prefecture",
      "moName": "Хойд Ибараки аймаг",
      "buName": "အိဘယခိစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្តអ៊ីបារ៉ាគី",
      "neName": "इबाराकी जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "080012",
      "name": "県北地域",
      "enName": "Kempoku Area"
    },
    "class20": {
      "code": "0822100",
      "name": "ひたちなか市",
      "enName": "Hitachinaka City",
      "kana": "ひたちなかし",
      "chName": "常陆那珂市",
      "zhName": "常陸那珂市",
      "koName": "히타치나카 시",
      "esName": "Ciudad de hitachinaka",
      "ptName": "cidade de Hitachinaka",
      "thName": "เมืองฮิตาจินากะ",
      "viName": "thành phố Hitachinaka",
      "inName": "kota Hitachinaka",
      "tlName": "siyudad ng Hitachinaka",
      "moName": "Хитачинaка хот",
      "buName": "ဟီတာကျိနာ့က မြို့",
      "khName": "ទីក្រុង ហ៊ីតាឈិនណាកា",
      "neName": "हिताचिनाका सहर"
    }
  },
  "0822200": {
    "office": {
      "code": "080000",
      "name": "茨城県",
      "enName": "Ibaraki",
      "officeName": "水戸地方気象台",
      "chName": "茨城县",
      "zhName": "茨城縣",
      "koName": "이바라키현",
      "esName": "Prefectura de Ibaraki",
      "ptName": "Província de Ibaraki",
      "thName": "จังหวัดอิบารากิ",
      "viName": "Tỉnh Ibaraki",
      "inName": "Prefektur Ibaraki",
      "tlName": "Ibaraki Prefecture",
      "moName": "Ибараки аймаг",
      "buName": "အီဘာရာကိ ပြည်နယ်",
      "khName": "ខេត្ត អ៊ីបារ៉ាគី",
      "neName": "इबाराकी जिल्ला"
    },
    "class10": {
      "code": "080020",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "茨城县南部",
      "zhName": "茨城縣南部",
      "koName": "이바라키 현 남부",
      "esName": "Sur de Prefectura de Ibaraki",
      "ptName": "Sul da Província de Ibaraki",
      "thName": "จังหวัดอิบารากิตอนใต้",
      "viName": "Miền Nam tỉnh Ibaraki",
      "inName": "Bagian Selatan Prefektur Ibaraki",
      "tlName": "Timog na bahagi ng Ibaraki Prefecture",
      "moName": "Өмнөд Ибараки аймаг",
      "buName": "အိဘယခိစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្តអ៊ីបារ៉ាគី",
      "neName": "इबाराकी जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "080021",
      "name": "鹿行地域",
      "enName": "Rokko Area"
    },
    "class20": {
      "code": "0822200",
      "name": "鹿嶋市",
      "enName": "Kashima City",
      "kana": "かしまし",
      "chName": "茨城鹿嶋市",
      "zhName": "茨城鹿嶋市",
      "koName": "이바라키 가시마 시",
      "esName": "Ciudad de Kashima, Ibaraki",
      "ptName": "Ibaraki, cidade de Kashima ",
      "thName": "เมืองคาชิมะ อิบารากิ",
      "viName": "Thành phố Kashima, Ibaraki",
      "inName": "Kota Kashima, Ibaraki",
      "tlName": "siyudad ng Kashima, Ibaraki",
      "moName": "Ибарики Кашима хот",
      "buName": "အိဘချိခိရှိမမြို့",
      "khName": "ទីក្រុងកាស៊ីម៉ា អ៊ីបារ៉ាគី",
      "neName": "इबाराकी काशिमा सहर"
    }
  },
  "0822300": {
    "office": {
      "code": "080000",
      "name": "茨城県",
      "enName": "Ibaraki",
      "officeName": "水戸地方気象台",
      "chName": "茨城县",
      "zhName": "茨城縣",
      "koName": "이바라키현",
      "esName": "Prefectura de Ibaraki",
      "ptName": "Província de Ibaraki",
      "thName": "จังหวัดอิบารากิ",
      "viName": "Tỉnh Ibaraki",
      "inName": "Prefektur Ibaraki",
      "tlName": "Ibaraki Prefecture",
      "moName": "Ибараки аймаг",
      "buName": "အီဘာရာကိ ပြည်နယ်",
      "khName": "ខេត្ត អ៊ីបារ៉ាគី",
      "neName": "इबाराकी जिल्ला"
    },
    "class10": {
      "code": "080020",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "茨城县南部",
      "zhName": "茨城縣南部",
      "koName": "이바라키 현 남부",
      "esName": "Sur de Prefectura de Ibaraki",
      "ptName": "Sul da Província de Ibaraki",
      "thName": "จังหวัดอิบารากิตอนใต้",
      "viName": "Miền Nam tỉnh Ibaraki",
      "inName": "Bagian Selatan Prefektur Ibaraki",
      "tlName": "Timog na bahagi ng Ibaraki Prefecture",
      "moName": "Өмнөд Ибараки аймаг",
      "buName": "အိဘယခိစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្តអ៊ីបារ៉ាគី",
      "neName": "इबाराकी जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "080021",
      "name": "鹿行地域",
      "enName": "Rokko Area"
    },
    "class20": {
      "code": "0822300",
      "name": "潮来市",
      "enName": "Itako City",
      "kana": "いたこし",
      "chName": "潮来市",
      "zhName": "潮來市",
      "koName": "이타코 시",
      "esName": "Ciudad de Itako",
      "ptName": "cidade de Itako",
      "thName": "เมืองอิตาโกะ",
      "viName": "thành phố Itako",
      "inName": "kota Itako",
      "tlName": "siyudad ng Itako",
      "moName": "Итако хот",
      "buName": "အီတာကို မြို့",
      "khName": "ទីក្រុង អ៊ីតាកូ",
      "neName": "इताको सहर"
    }
  },
  "0822400": {
    "office": {
      "code": "080000",
      "name": "茨城県",
      "enName": "Ibaraki",
      "officeName": "水戸地方気象台",
      "chName": "茨城县",
      "zhName": "茨城縣",
      "koName": "이바라키현",
      "esName": "Prefectura de Ibaraki",
      "ptName": "Província de Ibaraki",
      "thName": "จังหวัดอิบารากิ",
      "viName": "Tỉnh Ibaraki",
      "inName": "Prefektur Ibaraki",
      "tlName": "Ibaraki Prefecture",
      "moName": "Ибараки аймаг",
      "buName": "အီဘာရာကိ ပြည်နယ်",
      "khName": "ខេត្ត អ៊ីបារ៉ាគី",
      "neName": "इबाराकी जिल्ला"
    },
    "class10": {
      "code": "080020",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "茨城县南部",
      "zhName": "茨城縣南部",
      "koName": "이바라키 현 남부",
      "esName": "Sur de Prefectura de Ibaraki",
      "ptName": "Sul da Província de Ibaraki",
      "thName": "จังหวัดอิบารากิตอนใต้",
      "viName": "Miền Nam tỉnh Ibaraki",
      "inName": "Bagian Selatan Prefektur Ibaraki",
      "tlName": "Timog na bahagi ng Ibaraki Prefecture",
      "moName": "Өмнөд Ибараки аймаг",
      "buName": "အိဘယခိစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្តអ៊ីបារ៉ាគី",
      "neName": "इबाराकी जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "080022",
      "name": "県南地域",
      "enName": "Kennan Area"
    },
    "class20": {
      "code": "0822400",
      "name": "守谷市",
      "enName": "Moriya City",
      "kana": "もりやし",
      "chName": "守谷市",
      "zhName": "守谷市",
      "koName": "모리야 시",
      "esName": "Ciudad de Moriya",
      "ptName": "cidade de Moriya",
      "thName": "เมืองโมริยะ",
      "viName": "thành phố Moriya",
      "inName": "kota Moriya",
      "tlName": "siyudad ng Moriya",
      "moName": "Мория хот",
      "buName": "မောရိယ မြို့",
      "khName": "ទីក្រុង ម៉ូរីយ៉ា",
      "neName": "मोरिया सहर"
    }
  },
  "0822500": {
    "office": {
      "code": "080000",
      "name": "茨城県",
      "enName": "Ibaraki",
      "officeName": "水戸地方気象台",
      "chName": "茨城县",
      "zhName": "茨城縣",
      "koName": "이바라키현",
      "esName": "Prefectura de Ibaraki",
      "ptName": "Província de Ibaraki",
      "thName": "จังหวัดอิบารากิ",
      "viName": "Tỉnh Ibaraki",
      "inName": "Prefektur Ibaraki",
      "tlName": "Ibaraki Prefecture",
      "moName": "Ибараки аймаг",
      "buName": "အီဘာရာကိ ပြည်နယ်",
      "khName": "ខេត្ត អ៊ីបារ៉ាគី",
      "neName": "इबाराकी जिल्ला"
    },
    "class10": {
      "code": "080010",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "茨城县北部",
      "zhName": "茨城縣北部",
      "koName": "이바라키 현 북부",
      "esName": "Norte de Prefectura de Ibaraki",
      "ptName": "Norte da Província de Ibaraki",
      "thName": "จังหวัดอิบารากิตอนเหนือ",
      "viName": "Miền Bắc tỉnh Ibaraki",
      "inName": "Bagian Utara Prefektur Ibaraki",
      "tlName": "Hilagang bahagi ng Ibaraki Prefecture",
      "moName": "Хойд Ибараки аймаг",
      "buName": "အိဘယခိစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្តអ៊ីបារ៉ាគី",
      "neName": "इबाराकी जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "080012",
      "name": "県北地域",
      "enName": "Kempoku Area"
    },
    "class20": {
      "code": "0822500",
      "name": "常陸大宮市",
      "enName": "Hitachiomiya City",
      "kana": "ひたちおおみやし",
      "chName": "常陆大宫市",
      "zhName": "常陸大宮市",
      "koName": "히타치오미야 시",
      "esName": "Ciudad de hitachiomiya",
      "ptName": "cidade de Hitachiomiya",
      "thName": "เมืองฮิตาชิโอมิยะ",
      "viName": "thành phố Hitachiomiya",
      "inName": "kota Hitachiomiya",
      "tlName": "siyudad ng Hitachiomiya",
      "moName": "Хитачиомия хот",
      "buName": "ဟီတကျိယို့မိယ မြို့",
      "khName": "ទីក្រុង ហ៊ីតាជីអូមីយ៉ា",
      "neName": "हिताचियोमिया सहर"
    }
  },
  "0822600": {
    "office": {
      "code": "080000",
      "name": "茨城県",
      "enName": "Ibaraki",
      "officeName": "水戸地方気象台",
      "chName": "茨城县",
      "zhName": "茨城縣",
      "koName": "이바라키현",
      "esName": "Prefectura de Ibaraki",
      "ptName": "Província de Ibaraki",
      "thName": "จังหวัดอิบารากิ",
      "viName": "Tỉnh Ibaraki",
      "inName": "Prefektur Ibaraki",
      "tlName": "Ibaraki Prefecture",
      "moName": "Ибараки аймаг",
      "buName": "အီဘာရာကိ ပြည်နယ်",
      "khName": "ខេត្ត អ៊ីបារ៉ាគី",
      "neName": "इबाराकी जिल्ला"
    },
    "class10": {
      "code": "080010",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "茨城县北部",
      "zhName": "茨城縣北部",
      "koName": "이바라키 현 북부",
      "esName": "Norte de Prefectura de Ibaraki",
      "ptName": "Norte da Província de Ibaraki",
      "thName": "จังหวัดอิบารากิตอนเหนือ",
      "viName": "Miền Bắc tỉnh Ibaraki",
      "inName": "Bagian Utara Prefektur Ibaraki",
      "tlName": "Hilagang bahagi ng Ibaraki Prefecture",
      "moName": "Хойд Ибараки аймаг",
      "buName": "အိဘယခိစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្តអ៊ីបារ៉ាគី",
      "neName": "इबाराकी जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "080012",
      "name": "県北地域",
      "enName": "Kempoku Area"
    },
    "class20": {
      "code": "0822600",
      "name": "那珂市",
      "enName": "Naka City",
      "kana": "なかし",
      "chName": "那珂市",
      "zhName": "那珂市",
      "koName": "나카 시",
      "esName": "Ciudad de Naka",
      "ptName": "cidade de Naka",
      "thName": "เมืองนากะ",
      "viName": "thành phố Naka",
      "inName": "kota Naka",
      "tlName": "siyudad ng Naka",
      "moName": "Нака хот",
      "buName": "နာက မြို့",
      "khName": "ទីក្រុង ណាកា",
      "neName": "नाका सहर"
    }
  },
  "0822700": {
    "office": {
      "code": "080000",
      "name": "茨城県",
      "enName": "Ibaraki",
      "officeName": "水戸地方気象台",
      "chName": "茨城县",
      "zhName": "茨城縣",
      "koName": "이바라키현",
      "esName": "Prefectura de Ibaraki",
      "ptName": "Província de Ibaraki",
      "thName": "จังหวัดอิบารากิ",
      "viName": "Tỉnh Ibaraki",
      "inName": "Prefektur Ibaraki",
      "tlName": "Ibaraki Prefecture",
      "moName": "Ибараки аймаг",
      "buName": "အီဘာရာကိ ပြည်နယ်",
      "khName": "ខេត្ត អ៊ីបារ៉ាគី",
      "neName": "इबाराकी जिल्ला"
    },
    "class10": {
      "code": "080020",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "茨城县南部",
      "zhName": "茨城縣南部",
      "koName": "이바라키 현 남부",
      "esName": "Sur de Prefectura de Ibaraki",
      "ptName": "Sul da Província de Ibaraki",
      "thName": "จังหวัดอิบารากิตอนใต้",
      "viName": "Miền Nam tỉnh Ibaraki",
      "inName": "Bagian Selatan Prefektur Ibaraki",
      "tlName": "Timog na bahagi ng Ibaraki Prefecture",
      "moName": "Өмнөд Ибараки аймаг",
      "buName": "အိဘယခိစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្តអ៊ីបារ៉ាគី",
      "neName": "इबाराकी जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "080023",
      "name": "県西地域",
      "enName": "Kensei Area"
    },
    "class20": {
      "code": "0822700",
      "name": "筑西市",
      "enName": "Chikusei City",
      "kana": "ちくせいし",
      "chName": "筑西市",
      "zhName": "築西市",
      "koName": "지쿠세이 시",
      "esName": "Ciudad de Chikusei",
      "ptName": "cidade de Chikusei",
      "thName": "เมืองจิคุเซ",
      "viName": "thành phố Chikusei",
      "inName": "kota Chikusei",
      "tlName": "siyudad ng Chikusei",
      "moName": "Чикүсэй хот",
      "buName": "ရှီကုဆေ့ မြို့",
      "khName": "ទីក្រុង ជីគូសី",
      "neName": "चिकुसेई सहर"
    }
  },
  "0822800": {
    "office": {
      "code": "080000",
      "name": "茨城県",
      "enName": "Ibaraki",
      "officeName": "水戸地方気象台",
      "chName": "茨城县",
      "zhName": "茨城縣",
      "koName": "이바라키현",
      "esName": "Prefectura de Ibaraki",
      "ptName": "Província de Ibaraki",
      "thName": "จังหวัดอิบารากิ",
      "viName": "Tỉnh Ibaraki",
      "inName": "Prefektur Ibaraki",
      "tlName": "Ibaraki Prefecture",
      "moName": "Ибараки аймаг",
      "buName": "အီဘာရာကိ ပြည်နယ်",
      "khName": "ខេត្ត អ៊ីបារ៉ាគី",
      "neName": "इबाराकी जिल्ला"
    },
    "class10": {
      "code": "080020",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "茨城县南部",
      "zhName": "茨城縣南部",
      "koName": "이바라키 현 남부",
      "esName": "Sur de Prefectura de Ibaraki",
      "ptName": "Sul da Província de Ibaraki",
      "thName": "จังหวัดอิบารากิตอนใต้",
      "viName": "Miền Nam tỉnh Ibaraki",
      "inName": "Bagian Selatan Prefektur Ibaraki",
      "tlName": "Timog na bahagi ng Ibaraki Prefecture",
      "moName": "Өмнөд Ибараки аймаг",
      "buName": "အိဘယခိစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្តអ៊ីបារ៉ាគី",
      "neName": "इबाराकी जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "080023",
      "name": "県西地域",
      "enName": "Kensei Area"
    },
    "class20": {
      "code": "0822800",
      "name": "坂東市",
      "enName": "Bando City",
      "kana": "ばんどうし",
      "chName": "坂东市",
      "zhName": "坂東市",
      "koName": "반도 시",
      "esName": "Ciudad de Bando",
      "ptName": "cidade de Bando",
      "thName": "เมืองบันโดะ",
      "viName": "thành phố Bando",
      "inName": "kota Bando",
      "tlName": "siyudad ng Bando",
      "moName": "Бандо хот",
      "buName": "ဘန်းဒေါ့ မြို့",
      "khName": "ទីក្រុង បានដូ",
      "neName": "बान्दो सहर"
    }
  },
  "0822900": {
    "office": {
      "code": "080000",
      "name": "茨城県",
      "enName": "Ibaraki",
      "officeName": "水戸地方気象台",
      "chName": "茨城县",
      "zhName": "茨城縣",
      "koName": "이바라키현",
      "esName": "Prefectura de Ibaraki",
      "ptName": "Província de Ibaraki",
      "thName": "จังหวัดอิบารากิ",
      "viName": "Tỉnh Ibaraki",
      "inName": "Prefektur Ibaraki",
      "tlName": "Ibaraki Prefecture",
      "moName": "Ибараки аймаг",
      "buName": "အီဘာရာကိ ပြည်နယ်",
      "khName": "ខេត្ត អ៊ីបារ៉ាគី",
      "neName": "इबाराकी जिल्ला"
    },
    "class10": {
      "code": "080020",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "茨城县南部",
      "zhName": "茨城縣南部",
      "koName": "이바라키 현 남부",
      "esName": "Sur de Prefectura de Ibaraki",
      "ptName": "Sul da Província de Ibaraki",
      "thName": "จังหวัดอิบารากิตอนใต้",
      "viName": "Miền Nam tỉnh Ibaraki",
      "inName": "Bagian Selatan Prefektur Ibaraki",
      "tlName": "Timog na bahagi ng Ibaraki Prefecture",
      "moName": "Өмнөд Ибараки аймаг",
      "buName": "အိဘယခိစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្តអ៊ីបារ៉ាគី",
      "neName": "इबाराकी जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "080022",
      "name": "県南地域",
      "enName": "Kennan Area"
    },
    "class20": {
      "code": "0822900",
      "name": "稲敷市",
      "enName": "Inashiki City",
      "kana": "いなしきし",
      "chName": "稻敷市",
      "zhName": "稻敷市",
      "koName": "이나시키 시",
      "esName": "Ciudad de Inashiki",
      "ptName": "cidade de Inashiki",
      "thName": "เมืองอินาชิกิ",
      "viName": "thành phố Inashiki",
      "inName": "kota Inashiki",
      "tlName": "siyudad ng Inashiki",
      "moName": "Инашики хот",
      "buName": "အီနာရှီကိ မြို့",
      "khName": "ទីក្រុង អ៊ីណាស៊ីគី",
      "neName": "इनाशिकी सहर"
    }
  },
  "0823000": {
    "office": {
      "code": "080000",
      "name": "茨城県",
      "enName": "Ibaraki",
      "officeName": "水戸地方気象台",
      "chName": "茨城县",
      "zhName": "茨城縣",
      "koName": "이바라키현",
      "esName": "Prefectura de Ibaraki",
      "ptName": "Província de Ibaraki",
      "thName": "จังหวัดอิบารากิ",
      "viName": "Tỉnh Ibaraki",
      "inName": "Prefektur Ibaraki",
      "tlName": "Ibaraki Prefecture",
      "moName": "Ибараки аймаг",
      "buName": "အီဘာရာကိ ပြည်နယ်",
      "khName": "ខេត្ត អ៊ីបារ៉ាគី",
      "neName": "इबाराकी जिल्ला"
    },
    "class10": {
      "code": "080020",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "茨城县南部",
      "zhName": "茨城縣南部",
      "koName": "이바라키 현 남부",
      "esName": "Sur de Prefectura de Ibaraki",
      "ptName": "Sul da Província de Ibaraki",
      "thName": "จังหวัดอิบารากิตอนใต้",
      "viName": "Miền Nam tỉnh Ibaraki",
      "inName": "Bagian Selatan Prefektur Ibaraki",
      "tlName": "Timog na bahagi ng Ibaraki Prefecture",
      "moName": "Өмнөд Ибараки аймаг",
      "buName": "အိဘယခိစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្តអ៊ីបារ៉ាគី",
      "neName": "इबाराकी जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "080022",
      "name": "県南地域",
      "enName": "Kennan Area"
    },
    "class20": {
      "code": "0823000",
      "name": "かすみがうら市",
      "enName": "Kasumigaura City",
      "kana": "かすみがうらし",
      "chName": "霞浦市",
      "zhName": "霞浦市",
      "koName": "가스미가우라 시",
      "esName": "Ciudad de Kasumigaura",
      "ptName": "cidade de Kasumigaura",
      "thName": "เมืองคาสุมิงะอุระ",
      "viName": "thành phố Kasumigaura",
      "inName": "kota Kasumigaura",
      "tlName": "siyudad ng Kasumigaura",
      "moName": "Касүмигаура хот",
      "buName": "ခါဆူမီဂိုးရာ့ မြို့",
      "khName": "ទីក្រុង កាស៊ូមីគូរ៉ា",
      "neName": "कासुमिगाउरा सहर"
    }
  },
  "0823100": {
    "office": {
      "code": "080000",
      "name": "茨城県",
      "enName": "Ibaraki",
      "officeName": "水戸地方気象台",
      "chName": "茨城县",
      "zhName": "茨城縣",
      "koName": "이바라키현",
      "esName": "Prefectura de Ibaraki",
      "ptName": "Província de Ibaraki",
      "thName": "จังหวัดอิบารากิ",
      "viName": "Tỉnh Ibaraki",
      "inName": "Prefektur Ibaraki",
      "tlName": "Ibaraki Prefecture",
      "moName": "Ибараки аймаг",
      "buName": "အီဘာရာကိ ပြည်နယ်",
      "khName": "ខេត្ត អ៊ីបារ៉ាគី",
      "neName": "इबाराकी जिल्ला"
    },
    "class10": {
      "code": "080020",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "茨城县南部",
      "zhName": "茨城縣南部",
      "koName": "이바라키 현 남부",
      "esName": "Sur de Prefectura de Ibaraki",
      "ptName": "Sul da Província de Ibaraki",
      "thName": "จังหวัดอิบารากิตอนใต้",
      "viName": "Miền Nam tỉnh Ibaraki",
      "inName": "Bagian Selatan Prefektur Ibaraki",
      "tlName": "Timog na bahagi ng Ibaraki Prefecture",
      "moName": "Өмнөд Ибараки аймаг",
      "buName": "အိဘယခိစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្តអ៊ីបារ៉ាគី",
      "neName": "इबाराकी जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "080023",
      "name": "県西地域",
      "enName": "Kensei Area"
    },
    "class20": {
      "code": "0823100",
      "name": "桜川市",
      "enName": "Sakuragawa City",
      "kana": "さくらがわし",
      "chName": "樱川市",
      "zhName": "櫻川市",
      "koName": "사쿠라가와 시",
      "esName": "Ciudad de Sakuragawa",
      "ptName": "cidade de Sakuragawa",
      "thName": "เมืองซากุระคาวา",
      "viName": "thành phố Sakuragawa",
      "inName": "kota Sakuragawa",
      "tlName": "siyudad ng Sakuragawa",
      "moName": "Сакүрагава хот",
      "buName": "ဆာကူရာဂါ့ဝ မြို့",
      "khName": "ទីក្រុង សាគូរ៉ាកាវ៉ា",
      "neName": "साकुरागावा सहर"
    }
  },
  "0823200": {
    "office": {
      "code": "080000",
      "name": "茨城県",
      "enName": "Ibaraki",
      "officeName": "水戸地方気象台",
      "chName": "茨城县",
      "zhName": "茨城縣",
      "koName": "이바라키현",
      "esName": "Prefectura de Ibaraki",
      "ptName": "Província de Ibaraki",
      "thName": "จังหวัดอิบารากิ",
      "viName": "Tỉnh Ibaraki",
      "inName": "Prefektur Ibaraki",
      "tlName": "Ibaraki Prefecture",
      "moName": "Ибараки аймаг",
      "buName": "အီဘာရာကိ ပြည်နယ်",
      "khName": "ខេត្ត អ៊ីបារ៉ាគី",
      "neName": "इबाराकी जिल्ला"
    },
    "class10": {
      "code": "080020",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "茨城县南部",
      "zhName": "茨城縣南部",
      "koName": "이바라키 현 남부",
      "esName": "Sur de Prefectura de Ibaraki",
      "ptName": "Sul da Província de Ibaraki",
      "thName": "จังหวัดอิบารากิตอนใต้",
      "viName": "Miền Nam tỉnh Ibaraki",
      "inName": "Bagian Selatan Prefektur Ibaraki",
      "tlName": "Timog na bahagi ng Ibaraki Prefecture",
      "moName": "Өмнөд Ибараки аймаг",
      "buName": "အိဘယခိစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្តអ៊ីបារ៉ាគី",
      "neName": "इबाराकी जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "080021",
      "name": "鹿行地域",
      "enName": "Rokko Area"
    },
    "class20": {
      "code": "0823200",
      "name": "神栖市",
      "enName": "Kamisu City",
      "kana": "かみすし",
      "chName": "神栖市",
      "zhName": "神栖市",
      "koName": "가미스 시",
      "esName": "Ciudad de Kamisu",
      "ptName": "cidade de Kamisu",
      "thName": "เมืองคามิสุ",
      "viName": "thành phố Kamisu",
      "inName": "kota Kamisu",
      "tlName": "siyudad ng Kamisu",
      "moName": "Камисү хот",
      "buName": "ကာမိဆု မြို့",
      "khName": "ទីក្រុង កាមិស៊ុ",
      "neName": "कामिसु सहर"
    }
  },
  "0823300": {
    "office": {
      "code": "080000",
      "name": "茨城県",
      "enName": "Ibaraki",
      "officeName": "水戸地方気象台",
      "chName": "茨城县",
      "zhName": "茨城縣",
      "koName": "이바라키현",
      "esName": "Prefectura de Ibaraki",
      "ptName": "Província de Ibaraki",
      "thName": "จังหวัดอิบารากิ",
      "viName": "Tỉnh Ibaraki",
      "inName": "Prefektur Ibaraki",
      "tlName": "Ibaraki Prefecture",
      "moName": "Ибараки аймаг",
      "buName": "အီဘာရာကိ ပြည်နယ်",
      "khName": "ខេត្ត អ៊ីបារ៉ាគី",
      "neName": "इबाराकी जिल्ला"
    },
    "class10": {
      "code": "080020",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "茨城县南部",
      "zhName": "茨城縣南部",
      "koName": "이바라키 현 남부",
      "esName": "Sur de Prefectura de Ibaraki",
      "ptName": "Sul da Província de Ibaraki",
      "thName": "จังหวัดอิบารากิตอนใต้",
      "viName": "Miền Nam tỉnh Ibaraki",
      "inName": "Bagian Selatan Prefektur Ibaraki",
      "tlName": "Timog na bahagi ng Ibaraki Prefecture",
      "moName": "Өмнөд Ибараки аймаг",
      "buName": "အိဘယခိစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្តអ៊ីបារ៉ាគី",
      "neName": "इबाराकी जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "080021",
      "name": "鹿行地域",
      "enName": "Rokko Area"
    },
    "class20": {
      "code": "0823300",
      "name": "行方市",
      "enName": "Namegata City",
      "kana": "なめがたし",
      "chName": "行方市",
      "zhName": "行方市",
      "koName": "나메가타 시",
      "esName": "Ciudad de Namegata",
      "ptName": "cidade de Namegata",
      "thName": "เมืองนาเมงาตะ",
      "viName": "thành phố Namegata",
      "inName": "kota Namegata",
      "tlName": "siyudad ng Namegata",
      "moName": "Намэгата хот",
      "buName": "နာမဲဂါ့တ မြို့",
      "khName": "ទីក្រុង ណាមេហ្គាតា",
      "neName": "नामेगाता सहर"
    }
  },
  "0823400": {
    "office": {
      "code": "080000",
      "name": "茨城県",
      "enName": "Ibaraki",
      "officeName": "水戸地方気象台",
      "chName": "茨城县",
      "zhName": "茨城縣",
      "koName": "이바라키현",
      "esName": "Prefectura de Ibaraki",
      "ptName": "Província de Ibaraki",
      "thName": "จังหวัดอิบารากิ",
      "viName": "Tỉnh Ibaraki",
      "inName": "Prefektur Ibaraki",
      "tlName": "Ibaraki Prefecture",
      "moName": "Ибараки аймаг",
      "buName": "အီဘာရာကိ ပြည်နယ်",
      "khName": "ខេត្ត អ៊ីបារ៉ាគី",
      "neName": "इबाराकी जिल्ला"
    },
    "class10": {
      "code": "080020",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "茨城县南部",
      "zhName": "茨城縣南部",
      "koName": "이바라키 현 남부",
      "esName": "Sur de Prefectura de Ibaraki",
      "ptName": "Sul da Província de Ibaraki",
      "thName": "จังหวัดอิบารากิตอนใต้",
      "viName": "Miền Nam tỉnh Ibaraki",
      "inName": "Bagian Selatan Prefektur Ibaraki",
      "tlName": "Timog na bahagi ng Ibaraki Prefecture",
      "moName": "Өмнөд Ибараки аймаг",
      "buName": "အိဘယခိစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្តអ៊ីបារ៉ាគី",
      "neName": "इबाराकी जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "080021",
      "name": "鹿行地域",
      "enName": "Rokko Area"
    },
    "class20": {
      "code": "0823400",
      "name": "鉾田市",
      "enName": "Hokota City",
      "kana": "ほこたし",
      "chName": "鉾田市",
      "zhName": "鉾田市",
      "koName": "호코타 시",
      "esName": "Ciudad de Hokota",
      "ptName": "cidade de Hokota",
      "thName": "เมืองโฮโคตะ",
      "viName": "thành phố Hokota",
      "inName": "kota Hokota",
      "tlName": "siyudad ng Hokota",
      "moName": "Хокота хот",
      "buName": "ဟိုးကိုးတ မြို့",
      "khName": "ទីក្រុង ហូកូតា",
      "neName": "होकोता सहर"
    }
  },
  "0823500": {
    "office": {
      "code": "080000",
      "name": "茨城県",
      "enName": "Ibaraki",
      "officeName": "水戸地方気象台",
      "chName": "茨城县",
      "zhName": "茨城縣",
      "koName": "이바라키현",
      "esName": "Prefectura de Ibaraki",
      "ptName": "Província de Ibaraki",
      "thName": "จังหวัดอิบารากิ",
      "viName": "Tỉnh Ibaraki",
      "inName": "Prefektur Ibaraki",
      "tlName": "Ibaraki Prefecture",
      "moName": "Ибараки аймаг",
      "buName": "အီဘာရာကိ ပြည်နယ်",
      "khName": "ខេត្ត អ៊ីបារ៉ាគី",
      "neName": "इबाराकी जिल्ला"
    },
    "class10": {
      "code": "080020",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "茨城县南部",
      "zhName": "茨城縣南部",
      "koName": "이바라키 현 남부",
      "esName": "Sur de Prefectura de Ibaraki",
      "ptName": "Sul da Província de Ibaraki",
      "thName": "จังหวัดอิบารากิตอนใต้",
      "viName": "Miền Nam tỉnh Ibaraki",
      "inName": "Bagian Selatan Prefektur Ibaraki",
      "tlName": "Timog na bahagi ng Ibaraki Prefecture",
      "moName": "Өмнөд Ибараки аймаг",
      "buName": "အိဘယခိစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្តអ៊ីបារ៉ាគី",
      "neName": "इबाराकी जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "080022",
      "name": "県南地域",
      "enName": "Kennan Area"
    },
    "class20": {
      "code": "0823500",
      "name": "つくばみらい市",
      "enName": "Tsukubamirai City",
      "kana": "つくばみらいし",
      "chName": "筑波未来市",
      "zhName": "筑波未來市",
      "koName": "쓰쿠바미라이 시",
      "esName": "Ciudad de Tsukubamirai",
      "ptName": "cidade de Tsukubamirai",
      "thName": "เมืองสึกุบะมิไร",
      "viName": "thành phố Tsukubamirai",
      "inName": "kota Tsukubamirai",
      "tlName": "siyudad ng Tsukubamirai",
      "moName": "Цүкүбамирай хот",
      "buName": "စကူဘာ့မိရာ့ယိ မြို့",
      "khName": "ទីក្រុង ស៊ុគូបាមីរ៉ាយ",
      "neName": "त्सुकुबामिराई सहर"
    }
  },
  "0823600": {
    "office": {
      "code": "080000",
      "name": "茨城県",
      "enName": "Ibaraki",
      "officeName": "水戸地方気象台",
      "chName": "茨城县",
      "zhName": "茨城縣",
      "koName": "이바라키현",
      "esName": "Prefectura de Ibaraki",
      "ptName": "Província de Ibaraki",
      "thName": "จังหวัดอิบารากิ",
      "viName": "Tỉnh Ibaraki",
      "inName": "Prefektur Ibaraki",
      "tlName": "Ibaraki Prefecture",
      "moName": "Ибараки аймаг",
      "buName": "အီဘာရာကိ ပြည်နယ်",
      "khName": "ខេត្ត អ៊ីបារ៉ាគី",
      "neName": "इबाराकी जिल्ला"
    },
    "class10": {
      "code": "080010",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "茨城县北部",
      "zhName": "茨城縣北部",
      "koName": "이바라키 현 북부",
      "esName": "Norte de Prefectura de Ibaraki",
      "ptName": "Norte da Província de Ibaraki",
      "thName": "จังหวัดอิบารากิตอนเหนือ",
      "viName": "Miền Bắc tỉnh Ibaraki",
      "inName": "Bagian Utara Prefektur Ibaraki",
      "tlName": "Hilagang bahagi ng Ibaraki Prefecture",
      "moName": "Хойд Ибараки аймаг",
      "buName": "အိဘယခိစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្តអ៊ីបារ៉ាគី",
      "neName": "इबाराकी जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "080011",
      "name": "県央地域",
      "enName": "Ken-o Area"
    },
    "class20": {
      "code": "0823600",
      "name": "小美玉市",
      "enName": "Omitama City",
      "kana": "おみたまし",
      "chName": "小美玉市",
      "zhName": "小美玉市",
      "koName": "오미타마 시",
      "esName": "Ciudad de Omitama",
      "ptName": "cidade de Omitama",
      "thName": "เมืองโอมิตามะ",
      "viName": "thành phố Omitama",
      "inName": "kota Omitama",
      "tlName": "siyudad ng Omitama",
      "moName": "Омитама хот",
      "buName": "အိုမိတာ့မ မြို့",
      "khName": "ទីក្រុង អូមីតាម៉ា",
      "neName": "ओमितामा सहर"
    }
  },
  "0830200": {
    "office": {
      "code": "080000",
      "name": "茨城県",
      "enName": "Ibaraki",
      "officeName": "水戸地方気象台",
      "chName": "茨城县",
      "zhName": "茨城縣",
      "koName": "이바라키현",
      "esName": "Prefectura de Ibaraki",
      "ptName": "Província de Ibaraki",
      "thName": "จังหวัดอิบารากิ",
      "viName": "Tỉnh Ibaraki",
      "inName": "Prefektur Ibaraki",
      "tlName": "Ibaraki Prefecture",
      "moName": "Ибараки аймаг",
      "buName": "အီဘာရာကိ ပြည်နယ်",
      "khName": "ខេត្ត អ៊ីបារ៉ាគី",
      "neName": "इबाराकी जिल्ला"
    },
    "class10": {
      "code": "080010",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "茨城县北部",
      "zhName": "茨城縣北部",
      "koName": "이바라키 현 북부",
      "esName": "Norte de Prefectura de Ibaraki",
      "ptName": "Norte da Província de Ibaraki",
      "thName": "จังหวัดอิบารากิตอนเหนือ",
      "viName": "Miền Bắc tỉnh Ibaraki",
      "inName": "Bagian Utara Prefektur Ibaraki",
      "tlName": "Hilagang bahagi ng Ibaraki Prefecture",
      "moName": "Хойд Ибараки аймаг",
      "buName": "အိဘယခိစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្តអ៊ីបារ៉ាគី",
      "neName": "इबाराकी जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "080011",
      "name": "県央地域",
      "enName": "Ken-o Area"
    },
    "class20": {
      "code": "0830200",
      "name": "茨城町",
      "enName": "Ibaraki Town",
      "kana": "いばらきまち",
      "chName": "茨城町",
      "zhName": "茨城町",
      "koName": "이바라키 정",
      "esName": "Pueblo de Ibaraki",
      "ptName": "bairro de Ibaraki",
      "thName": "เมืองอิบารากิ",
      "viName": "thị trấn Ibaraki",
      "inName": "kota Ibaraki",
      "tlName": "bayan ng Ibaraki",
      "moName": "Ибараки жижиг хот",
      "buName": "အီဘာရာ့ကိ မြို့နယ်",
      "khName": "ទីប្រជុំជន អ៊ីបារ៉ាគី",
      "neName": "इबाराकी नगर"
    }
  },
  "0830900": {
    "office": {
      "code": "080000",
      "name": "茨城県",
      "enName": "Ibaraki",
      "officeName": "水戸地方気象台",
      "chName": "茨城县",
      "zhName": "茨城縣",
      "koName": "이바라키현",
      "esName": "Prefectura de Ibaraki",
      "ptName": "Província de Ibaraki",
      "thName": "จังหวัดอิบารากิ",
      "viName": "Tỉnh Ibaraki",
      "inName": "Prefektur Ibaraki",
      "tlName": "Ibaraki Prefecture",
      "moName": "Ибараки аймаг",
      "buName": "အီဘာရာကိ ပြည်နယ်",
      "khName": "ខេត្ត អ៊ីបារ៉ាគី",
      "neName": "इबाराकी जिल्ला"
    },
    "class10": {
      "code": "080010",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "茨城县北部",
      "zhName": "茨城縣北部",
      "koName": "이바라키 현 북부",
      "esName": "Norte de Prefectura de Ibaraki",
      "ptName": "Norte da Província de Ibaraki",
      "thName": "จังหวัดอิบารากิตอนเหนือ",
      "viName": "Miền Bắc tỉnh Ibaraki",
      "inName": "Bagian Utara Prefektur Ibaraki",
      "tlName": "Hilagang bahagi ng Ibaraki Prefecture",
      "moName": "Хойд Ибараки аймаг",
      "buName": "အိဘယခိစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្តអ៊ីបារ៉ាគី",
      "neName": "इबाराकी जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "080011",
      "name": "県央地域",
      "enName": "Ken-o Area"
    },
    "class20": {
      "code": "0830900",
      "name": "大洗町",
      "enName": "Oarai Town",
      "kana": "おおあらいまち",
      "chName": "大洗町",
      "zhName": "大洗町",
      "koName": "오아라이 정",
      "esName": "Pueblo de Oarai",
      "ptName": "bairro de Oarai",
      "thName": "เมืองโออาราอิ",
      "viName": "thị trấn Oarai",
      "inName": "kota Oarai",
      "tlName": "bayan ng Oarai",
      "moName": "Оaрай жижиг хот",
      "buName": "အိုအားရိုင်ယိ မြို့နယ်",
      "khName": "ទីប្រជុំជន អូរ៉ាយ",
      "neName": "ओआराई नगर"
    }
  },
  "0831000": {
    "office": {
      "code": "080000",
      "name": "茨城県",
      "enName": "Ibaraki",
      "officeName": "水戸地方気象台",
      "chName": "茨城县",
      "zhName": "茨城縣",
      "koName": "이바라키현",
      "esName": "Prefectura de Ibaraki",
      "ptName": "Província de Ibaraki",
      "thName": "จังหวัดอิบารากิ",
      "viName": "Tỉnh Ibaraki",
      "inName": "Prefektur Ibaraki",
      "tlName": "Ibaraki Prefecture",
      "moName": "Ибараки аймаг",
      "buName": "အီဘာရာကိ ပြည်နယ်",
      "khName": "ខេត្ត អ៊ីបារ៉ាគី",
      "neName": "इबाराकी जिल्ला"
    },
    "class10": {
      "code": "080010",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "茨城县北部",
      "zhName": "茨城縣北部",
      "koName": "이바라키 현 북부",
      "esName": "Norte de Prefectura de Ibaraki",
      "ptName": "Norte da Província de Ibaraki",
      "thName": "จังหวัดอิบารากิตอนเหนือ",
      "viName": "Miền Bắc tỉnh Ibaraki",
      "inName": "Bagian Utara Prefektur Ibaraki",
      "tlName": "Hilagang bahagi ng Ibaraki Prefecture",
      "moName": "Хойд Ибараки аймаг",
      "buName": "အိဘယခိစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្តអ៊ីបារ៉ាគី",
      "neName": "इबाराकी जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "080011",
      "name": "県央地域",
      "enName": "Ken-o Area"
    },
    "class20": {
      "code": "0831000",
      "name": "城里町",
      "enName": "Shirosato Town",
      "kana": "しろさとまち",
      "chName": "城里町",
      "zhName": "城里町",
      "koName": "시로사토 정",
      "esName": "Pueblo de Shirosato",
      "ptName": "bairro de Shirosato",
      "thName": "เมืองชิโระซาโตะ",
      "viName": "thị trấn Shirosato",
      "inName": "kota Shirosato",
      "tlName": "bayan ng Shirosato",
      "moName": "Широсaто жижиг хот",
      "buName": "ရှီရိုဆာတို မြို့နယ်",
      "khName": "ទីប្រជុំជន ស៊ីរ៉ូសាតូ",
      "neName": "शिरोसातो नगर"
    }
  },
  "0834100": {
    "office": {
      "code": "080000",
      "name": "茨城県",
      "enName": "Ibaraki",
      "officeName": "水戸地方気象台",
      "chName": "茨城县",
      "zhName": "茨城縣",
      "koName": "이바라키현",
      "esName": "Prefectura de Ibaraki",
      "ptName": "Província de Ibaraki",
      "thName": "จังหวัดอิบารากิ",
      "viName": "Tỉnh Ibaraki",
      "inName": "Prefektur Ibaraki",
      "tlName": "Ibaraki Prefecture",
      "moName": "Ибараки аймаг",
      "buName": "အီဘာရာကိ ပြည်နယ်",
      "khName": "ខេត្ត អ៊ីបារ៉ាគី",
      "neName": "इबाराकी जिल्ला"
    },
    "class10": {
      "code": "080010",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "茨城县北部",
      "zhName": "茨城縣北部",
      "koName": "이바라키 현 북부",
      "esName": "Norte de Prefectura de Ibaraki",
      "ptName": "Norte da Província de Ibaraki",
      "thName": "จังหวัดอิบารากิตอนเหนือ",
      "viName": "Miền Bắc tỉnh Ibaraki",
      "inName": "Bagian Utara Prefektur Ibaraki",
      "tlName": "Hilagang bahagi ng Ibaraki Prefecture",
      "moName": "Хойд Ибараки аймаг",
      "buName": "အိဘယခိစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្តអ៊ីបារ៉ាគី",
      "neName": "इबाराकी जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "080012",
      "name": "県北地域",
      "enName": "Kempoku Area"
    },
    "class20": {
      "code": "0834100",
      "name": "東海村",
      "enName": "Tokai Village",
      "kana": "とうかいむら",
      "chName": "东海村",
      "zhName": "東海村",
      "koName": "도카이 촌",
      "esName": "Aldea de Tokai",
      "ptName": "povoado de Tokai",
      "thName": "หมู่บ้านโทไก",
      "viName": "làng Tokai",
      "inName": "desa Tokai",
      "tlName": "nayon ng Tokai",
      "moName": "Токай тосгон",
      "buName": "တိုကိုင်းယိ ကျေးရွာ",
      "khName": "ភូមិ តូកៃ ",
      "neName": "तोकाई गाउँ"
    }
  },
  "0836400": {
    "office": {
      "code": "080000",
      "name": "茨城県",
      "enName": "Ibaraki",
      "officeName": "水戸地方気象台",
      "chName": "茨城县",
      "zhName": "茨城縣",
      "koName": "이바라키현",
      "esName": "Prefectura de Ibaraki",
      "ptName": "Província de Ibaraki",
      "thName": "จังหวัดอิบารากิ",
      "viName": "Tỉnh Ibaraki",
      "inName": "Prefektur Ibaraki",
      "tlName": "Ibaraki Prefecture",
      "moName": "Ибараки аймаг",
      "buName": "အီဘာရာကိ ပြည်နယ်",
      "khName": "ខេត្ត អ៊ីបារ៉ាគី",
      "neName": "इबाराकी जिल्ला"
    },
    "class10": {
      "code": "080010",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "茨城县北部",
      "zhName": "茨城縣北部",
      "koName": "이바라키 현 북부",
      "esName": "Norte de Prefectura de Ibaraki",
      "ptName": "Norte da Província de Ibaraki",
      "thName": "จังหวัดอิบารากิตอนเหนือ",
      "viName": "Miền Bắc tỉnh Ibaraki",
      "inName": "Bagian Utara Prefektur Ibaraki",
      "tlName": "Hilagang bahagi ng Ibaraki Prefecture",
      "moName": "Хойд Ибараки аймаг",
      "buName": "အိဘယခိစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្តអ៊ីបារ៉ាគី",
      "neName": "इबाराकी जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "080012",
      "name": "県北地域",
      "enName": "Kempoku Area"
    },
    "class20": {
      "code": "0836400",
      "name": "大子町",
      "enName": "Daigo Town",
      "kana": "だいごまち",
      "chName": "大子町",
      "zhName": "大子町",
      "koName": "다이고 정",
      "esName": "Pueblo de Daigo",
      "ptName": "bairro de Daigo",
      "thName": "เมืองไดโงะ",
      "viName": "thị trấn Daigo",
      "inName": "kota Daigo",
      "tlName": "bayan ng Daigo",
      "moName": "Дайго жижиг хот",
      "buName": "ဒိုင်ယိဂို မြို့နယ်",
      "khName": "ទីប្រជុំជន ដាយហ្គោ",
      "neName": "दाइगो नगर"
    }
  },
  "0844200": {
    "office": {
      "code": "080000",
      "name": "茨城県",
      "enName": "Ibaraki",
      "officeName": "水戸地方気象台",
      "chName": "茨城县",
      "zhName": "茨城縣",
      "koName": "이바라키현",
      "esName": "Prefectura de Ibaraki",
      "ptName": "Província de Ibaraki",
      "thName": "จังหวัดอิบารากิ",
      "viName": "Tỉnh Ibaraki",
      "inName": "Prefektur Ibaraki",
      "tlName": "Ibaraki Prefecture",
      "moName": "Ибараки аймаг",
      "buName": "အီဘာရာကိ ပြည်နယ်",
      "khName": "ខេត្ត អ៊ីបារ៉ាគី",
      "neName": "इबाराकी जिल्ला"
    },
    "class10": {
      "code": "080020",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "茨城县南部",
      "zhName": "茨城縣南部",
      "koName": "이바라키 현 남부",
      "esName": "Sur de Prefectura de Ibaraki",
      "ptName": "Sul da Província de Ibaraki",
      "thName": "จังหวัดอิบารากิตอนใต้",
      "viName": "Miền Nam tỉnh Ibaraki",
      "inName": "Bagian Selatan Prefektur Ibaraki",
      "tlName": "Timog na bahagi ng Ibaraki Prefecture",
      "moName": "Өмнөд Ибараки аймаг",
      "buName": "အိဘယခိစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្តអ៊ីបារ៉ាគី",
      "neName": "इबाराकी जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "080022",
      "name": "県南地域",
      "enName": "Kennan Area"
    },
    "class20": {
      "code": "0844200",
      "name": "美浦村",
      "enName": "Miho Village",
      "kana": "みほむら",
      "chName": "美浦村",
      "zhName": "美浦村",
      "koName": "미호 촌",
      "esName": "Aldea de Miura",
      "ptName": "povoado de Miho",
      "thName": "หมู่บ้านมิโฮะ",
      "viName": "làng Miho",
      "inName": "desa Miho",
      "tlName": "nayon ng Miho",
      "moName": "Михо тосгон",
      "buName": "မီဟို ကျေးရွာ",
      "khName": "ភូមិ មីហូ",
      "neName": "मिहो गाउँ"
    }
  },
  "0844300": {
    "office": {
      "code": "080000",
      "name": "茨城県",
      "enName": "Ibaraki",
      "officeName": "水戸地方気象台",
      "chName": "茨城县",
      "zhName": "茨城縣",
      "koName": "이바라키현",
      "esName": "Prefectura de Ibaraki",
      "ptName": "Província de Ibaraki",
      "thName": "จังหวัดอิบารากิ",
      "viName": "Tỉnh Ibaraki",
      "inName": "Prefektur Ibaraki",
      "tlName": "Ibaraki Prefecture",
      "moName": "Ибараки аймаг",
      "buName": "အီဘာရာကိ ပြည်နယ်",
      "khName": "ខេត្ត អ៊ីបារ៉ាគី",
      "neName": "इबाराकी जिल्ला"
    },
    "class10": {
      "code": "080020",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "茨城县南部",
      "zhName": "茨城縣南部",
      "koName": "이바라키 현 남부",
      "esName": "Sur de Prefectura de Ibaraki",
      "ptName": "Sul da Província de Ibaraki",
      "thName": "จังหวัดอิบารากิตอนใต้",
      "viName": "Miền Nam tỉnh Ibaraki",
      "inName": "Bagian Selatan Prefektur Ibaraki",
      "tlName": "Timog na bahagi ng Ibaraki Prefecture",
      "moName": "Өмнөд Ибараки аймаг",
      "buName": "အိဘယခိစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្តអ៊ីបារ៉ាគី",
      "neName": "इबाराकी जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "080022",
      "name": "県南地域",
      "enName": "Kennan Area"
    },
    "class20": {
      "code": "0844300",
      "name": "阿見町",
      "enName": "Ami Town",
      "kana": "あみまち",
      "chName": "阿见町",
      "zhName": "阿見町",
      "koName": "아미 정",
      "esName": "Pueblo de Ami",
      "ptName": "bairro de Ami",
      "thName": "เมืองอามิ",
      "viName": "thị trấn Ami",
      "inName": "kota Ami",
      "tlName": "bayan ng Ami",
      "moName": "Aми жижиг хот",
      "buName": "အာမိ မြို့နယ်",
      "khName": "ទីប្រជុំជន អាមី",
      "neName": "आमी नगर"
    }
  },
  "0844700": {
    "office": {
      "code": "080000",
      "name": "茨城県",
      "enName": "Ibaraki",
      "officeName": "水戸地方気象台",
      "chName": "茨城县",
      "zhName": "茨城縣",
      "koName": "이바라키현",
      "esName": "Prefectura de Ibaraki",
      "ptName": "Província de Ibaraki",
      "thName": "จังหวัดอิบารากิ",
      "viName": "Tỉnh Ibaraki",
      "inName": "Prefektur Ibaraki",
      "tlName": "Ibaraki Prefecture",
      "moName": "Ибараки аймаг",
      "buName": "အီဘာရာကိ ပြည်နယ်",
      "khName": "ខេត្ត អ៊ីបារ៉ាគី",
      "neName": "इबाराकी जिल्ला"
    },
    "class10": {
      "code": "080020",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "茨城县南部",
      "zhName": "茨城縣南部",
      "koName": "이바라키 현 남부",
      "esName": "Sur de Prefectura de Ibaraki",
      "ptName": "Sul da Província de Ibaraki",
      "thName": "จังหวัดอิบารากิตอนใต้",
      "viName": "Miền Nam tỉnh Ibaraki",
      "inName": "Bagian Selatan Prefektur Ibaraki",
      "tlName": "Timog na bahagi ng Ibaraki Prefecture",
      "moName": "Өмнөд Ибараки аймаг",
      "buName": "အိဘယခိစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្តអ៊ីបារ៉ាគី",
      "neName": "इबाराकी जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "080022",
      "name": "県南地域",
      "enName": "Kennan Area"
    },
    "class20": {
      "code": "0844700",
      "name": "河内町",
      "enName": "Kawachi Town",
      "kana": "かわちまち",
      "chName": "河内町",
      "zhName": "河內町",
      "koName": "가와치 정",
      "esName": "Pueblo de Kawachi",
      "ptName": "bairro de Kawachi",
      "thName": "เมืองคาวาจิ",
      "viName": "thị trấn Kawachi",
      "inName": "kota Kawachi",
      "tlName": "bayan ng Kawachi",
      "moName": "Кавачи жижиг хот",
      "buName": "ခါဝါ့ကျိ မြို့နယ်",
      "khName": "ទីប្រជុំជន កាវ៉ាជី",
      "neName": "कावाची नगर"
    }
  },
  "0852100": {
    "office": {
      "code": "080000",
      "name": "茨城県",
      "enName": "Ibaraki",
      "officeName": "水戸地方気象台",
      "chName": "茨城县",
      "zhName": "茨城縣",
      "koName": "이바라키현",
      "esName": "Prefectura de Ibaraki",
      "ptName": "Província de Ibaraki",
      "thName": "จังหวัดอิบารากิ",
      "viName": "Tỉnh Ibaraki",
      "inName": "Prefektur Ibaraki",
      "tlName": "Ibaraki Prefecture",
      "moName": "Ибараки аймаг",
      "buName": "အီဘာရာကိ ပြည်နယ်",
      "khName": "ខេត្ត អ៊ីបារ៉ាគី",
      "neName": "इबाराकी जिल्ला"
    },
    "class10": {
      "code": "080020",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "茨城县南部",
      "zhName": "茨城縣南部",
      "koName": "이바라키 현 남부",
      "esName": "Sur de Prefectura de Ibaraki",
      "ptName": "Sul da Província de Ibaraki",
      "thName": "จังหวัดอิบารากิตอนใต้",
      "viName": "Miền Nam tỉnh Ibaraki",
      "inName": "Bagian Selatan Prefektur Ibaraki",
      "tlName": "Timog na bahagi ng Ibaraki Prefecture",
      "moName": "Өмнөд Ибараки аймаг",
      "buName": "အိဘယခိစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្តអ៊ីបារ៉ាគី",
      "neName": "इबाराकी जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "080023",
      "name": "県西地域",
      "enName": "Kensei Area"
    },
    "class20": {
      "code": "0852100",
      "name": "八千代町",
      "enName": "Yachiyo Town",
      "kana": "やちよまち",
      "chName": "八千代町",
      "zhName": "八千代町",
      "koName": "야치요 정",
      "esName": "Pueblo de Yachiyo",
      "ptName": "bairro de Yachiyo",
      "thName": "เมืองยาจิโยะ",
      "viName": "thị trấn Yachiyo",
      "inName": "kota Yachiyo",
      "tlName": "bayan ng Yachiyo",
      "moName": "Ячиёо жижиг хот",
      "buName": "ယားကျိရို မြို့နယ်",
      "khName": "ទីប្រជុំជន យ៉ាជីយ៉ូ",
      "neName": "याचियो नगर"
    }
  },
  "0854200": {
    "office": {
      "code": "080000",
      "name": "茨城県",
      "enName": "Ibaraki",
      "officeName": "水戸地方気象台",
      "chName": "茨城县",
      "zhName": "茨城縣",
      "koName": "이바라키현",
      "esName": "Prefectura de Ibaraki",
      "ptName": "Província de Ibaraki",
      "thName": "จังหวัดอิบารากิ",
      "viName": "Tỉnh Ibaraki",
      "inName": "Prefektur Ibaraki",
      "tlName": "Ibaraki Prefecture",
      "moName": "Ибараки аймаг",
      "buName": "အီဘာရာကိ ပြည်နယ်",
      "khName": "ខេត្ត អ៊ីបារ៉ាគី",
      "neName": "इबाराकी जिल्ला"
    },
    "class10": {
      "code": "080020",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "茨城县南部",
      "zhName": "茨城縣南部",
      "koName": "이바라키 현 남부",
      "esName": "Sur de Prefectura de Ibaraki",
      "ptName": "Sul da Província de Ibaraki",
      "thName": "จังหวัดอิบารากิตอนใต้",
      "viName": "Miền Nam tỉnh Ibaraki",
      "inName": "Bagian Selatan Prefektur Ibaraki",
      "tlName": "Timog na bahagi ng Ibaraki Prefecture",
      "moName": "Өмнөд Ибараки аймаг",
      "buName": "အိဘယခိစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្តអ៊ីបារ៉ាគី",
      "neName": "इबाराकी जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "080023",
      "name": "県西地域",
      "enName": "Kensei Area"
    },
    "class20": {
      "code": "0854200",
      "name": "五霞町",
      "enName": "Goka Town",
      "kana": "ごかまち",
      "chName": "五霞町",
      "zhName": "五霞町",
      "koName": "고카 정",
      "esName": "Pueblo de Goka",
      "ptName": "bairro de Goka",
      "thName": "เมืองโกกะ",
      "viName": "thị trấn Goka",
      "inName": "kota Goka",
      "tlName": "bayan ng Goka",
      "moName": "Гока жижиг хот",
      "buName": "ဂိုးက မြို့နယ်",
      "khName": "ទីប្រជុំជន ហ្កូកា",
      "neName": "गोका नगर"
    }
  },
  "0854600": {
    "office": {
      "code": "080000",
      "name": "茨城県",
      "enName": "Ibaraki",
      "officeName": "水戸地方気象台",
      "chName": "茨城县",
      "zhName": "茨城縣",
      "koName": "이바라키현",
      "esName": "Prefectura de Ibaraki",
      "ptName": "Província de Ibaraki",
      "thName": "จังหวัดอิบารากิ",
      "viName": "Tỉnh Ibaraki",
      "inName": "Prefektur Ibaraki",
      "tlName": "Ibaraki Prefecture",
      "moName": "Ибараки аймаг",
      "buName": "အီဘာရာကိ ပြည်နယ်",
      "khName": "ខេត្ត អ៊ីបារ៉ាគី",
      "neName": "इबाराकी जिल्ला"
    },
    "class10": {
      "code": "080020",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "茨城县南部",
      "zhName": "茨城縣南部",
      "koName": "이바라키 현 남부",
      "esName": "Sur de Prefectura de Ibaraki",
      "ptName": "Sul da Província de Ibaraki",
      "thName": "จังหวัดอิบารากิตอนใต้",
      "viName": "Miền Nam tỉnh Ibaraki",
      "inName": "Bagian Selatan Prefektur Ibaraki",
      "tlName": "Timog na bahagi ng Ibaraki Prefecture",
      "moName": "Өмнөд Ибараки аймаг",
      "buName": "အိဘယခိစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្តអ៊ីបារ៉ាគី",
      "neName": "इबाराकी जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "080023",
      "name": "県西地域",
      "enName": "Kensei Area"
    },
    "class20": {
      "code": "0854600",
      "name": "境町",
      "enName": "Sakai Town",
      "kana": "さかいまち",
      "chName": "境町",
      "zhName": "境町",
      "koName": "사카이 정",
      "esName": "Pueblo de sakai",
      "ptName": "bairro de Sakai",
      "thName": "เมืองซาไก",
      "viName": "thị trấn Sakai",
      "inName": "kota Sakai",
      "tlName": "bayan ng Sakai",
      "moName": "Сакай жижиг хот",
      "buName": "ဆာကိုင်းယိ မြို့နယ်",
      "khName": "ទីប្រជុំជន សាកៃ",
      "neName": "साकाई नगर"
    }
  },
  "0856400": {
    "office": {
      "code": "080000",
      "name": "茨城県",
      "enName": "Ibaraki",
      "officeName": "水戸地方気象台",
      "chName": "茨城县",
      "zhName": "茨城縣",
      "koName": "이바라키현",
      "esName": "Prefectura de Ibaraki",
      "ptName": "Província de Ibaraki",
      "thName": "จังหวัดอิบารากิ",
      "viName": "Tỉnh Ibaraki",
      "inName": "Prefektur Ibaraki",
      "tlName": "Ibaraki Prefecture",
      "moName": "Ибараки аймаг",
      "buName": "အီဘာရာကိ ပြည်နယ်",
      "khName": "ខេត្ត អ៊ីបារ៉ាគី",
      "neName": "इबाराकी जिल्ला"
    },
    "class10": {
      "code": "080020",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "茨城县南部",
      "zhName": "茨城縣南部",
      "koName": "이바라키 현 남부",
      "esName": "Sur de Prefectura de Ibaraki",
      "ptName": "Sul da Província de Ibaraki",
      "thName": "จังหวัดอิบารากิตอนใต้",
      "viName": "Miền Nam tỉnh Ibaraki",
      "inName": "Bagian Selatan Prefektur Ibaraki",
      "tlName": "Timog na bahagi ng Ibaraki Prefecture",
      "moName": "Өмнөд Ибараки аймаг",
      "buName": "အိဘယခိစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្តអ៊ីបារ៉ាគី",
      "neName": "इबाराकी जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "080022",
      "name": "県南地域",
      "enName": "Kennan Area"
    },
    "class20": {
      "code": "0856400",
      "name": "利根町",
      "enName": "Tone Town",
      "kana": "とねまち",
      "chName": "利根町",
      "zhName": "利根町",
      "koName": "도네 정",
      "esName": "Pueblo de Tone",
      "ptName": "bairro de Tone",
      "thName": "เมืองโทเนะ",
      "viName": "thị trấn Tone",
      "inName": "kota Tone",
      "tlName": "bayan ng Tone",
      "moName": "Тонэ жижиг хот",
      "buName": "တုန်း မြို့နယ်",
      "khName": "ទីប្រជុំជន ថូន",
      "neName": "तोने नगर"
    }
  },
  "0920100": {
    "office": {
      "code": "090000",
      "name": "栃木県",
      "enName": "Tochigi",
      "officeName": "宇都宮地方気象台",
      "chName": "栃木县",
      "zhName": "櫔木縣",
      "koName": "도치기현",
      "esName": "Prefectura de Tochigi",
      "ptName": "Província de Tochigi",
      "thName": "จังหวัดโทะจิงิ",
      "viName": "Tỉnh Tochigi",
      "inName": "Prefektur Tochigi",
      "tlName": "Tochigi Prefecture",
      "moName": "Точиги аймаг",
      "buName": "တိုချီဂိ ပြည်နယ်",
      "khName": "ខេត្ត តូឈីជី",
      "neName": "तोचिगी जिल्ला"
    },
    "class10": {
      "code": "090010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "栃木县南部",
      "zhName": "櫪木縣南部",
      "koName": "도치기 현 남부",
      "esName": "Sur de Prefectura de Tochigi",
      "ptName": "Sul da Província de Tochigi",
      "thName": "จังหวัดโทะจิงิตอนใต้",
      "viName": "Miền Nam tỉnh Tochigi",
      "inName": "Bagian Selatan Prefektur Ibaraki",
      "tlName": "Timog na bahagi ng Tochigi Prefecture",
      "moName": "Өмнөд Точиги аймаг",
      "buName": "တုချိဂိစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្តតុឈីហ្គិ",
      "neName": "तोचिगी जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "090011",
      "name": "県央部",
      "enName": "Ken-o part"
    },
    "class20": {
      "code": "0920100",
      "name": "宇都宮市",
      "enName": "Utsunomiya City",
      "kana": "うつのみやし",
      "chName": "宇都宫市",
      "zhName": "宇都宮市",
      "koName": "우츠노미야 시",
      "esName": "Ciudad de Utsunomiya",
      "ptName": "cidade de Utsunomiya",
      "thName": "เมืองอุสึโนะมิยะ",
      "viName": "thành phố Utsunomiya",
      "inName": "kota Utsunomiya",
      "tlName": "siyudad ng Utsunomiya",
      "moName": "Үцүномия хот",
      "buName": "အုဆုနို့မီးယ မြို့",
      "khName": "ទីក្រុង អ៊ូស៊ូនីមីយ៉ា",
      "neName": "उत्सुनोमिया सहर"
    }
  },
  "0920200": {
    "office": {
      "code": "090000",
      "name": "栃木県",
      "enName": "Tochigi",
      "officeName": "宇都宮地方気象台",
      "chName": "栃木县",
      "zhName": "櫔木縣",
      "koName": "도치기현",
      "esName": "Prefectura de Tochigi",
      "ptName": "Província de Tochigi",
      "thName": "จังหวัดโทะจิงิ",
      "viName": "Tỉnh Tochigi",
      "inName": "Prefektur Tochigi",
      "tlName": "Tochigi Prefecture",
      "moName": "Точиги аймаг",
      "buName": "တိုချီဂိ ပြည်နယ်",
      "khName": "ខេត្ត តូឈីជី",
      "neName": "तोचिगी जिल्ला"
    },
    "class10": {
      "code": "090010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "栃木县南部",
      "zhName": "櫪木縣南部",
      "koName": "도치기 현 남부",
      "esName": "Sur de Prefectura de Tochigi",
      "ptName": "Sul da Província de Tochigi",
      "thName": "จังหวัดโทะจิงิตอนใต้",
      "viName": "Miền Nam tỉnh Tochigi",
      "inName": "Bagian Selatan Prefektur Ibaraki",
      "tlName": "Timog na bahagi ng Tochigi Prefecture",
      "moName": "Өмнөд Точиги аймаг",
      "buName": "တုချိဂိစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្តតុឈីហ្គិ",
      "neName": "तोचिगी जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "090013",
      "name": "南西部",
      "enName": "South-western Region"
    },
    "class20": {
      "code": "0920200",
      "name": "足利市",
      "enName": "Ashikaga City",
      "kana": "あしかがし",
      "chName": "足利市",
      "zhName": "足利市",
      "koName": "아시카가 시",
      "esName": "Ciudad de Ashikaga",
      "ptName": "cidade de Ashikaga",
      "thName": "เมืองอาชิคางะ",
      "viName": "thành phố Ashikaga",
      "inName": "kota Ashikaga",
      "tlName": "siyudad ng Ashikaga",
      "moName": "Ашикага хот",
      "buName": "အာရှီခါးဂ မြို့",
      "khName": "ទីក្រុង អាស៊ីកាកា",
      "neName": "आशिकागा सहर"
    }
  },
  "0920300": {
    "office": {
      "code": "090000",
      "name": "栃木県",
      "enName": "Tochigi",
      "officeName": "宇都宮地方気象台",
      "chName": "栃木县",
      "zhName": "櫔木縣",
      "koName": "도치기현",
      "esName": "Prefectura de Tochigi",
      "ptName": "Província de Tochigi",
      "thName": "จังหวัดโทะจิงิ",
      "viName": "Tỉnh Tochigi",
      "inName": "Prefektur Tochigi",
      "tlName": "Tochigi Prefecture",
      "moName": "Точиги аймаг",
      "buName": "တိုချီဂိ ပြည်နယ်",
      "khName": "ខេត្ត តូឈីជី",
      "neName": "तोचिगी जिल्ला"
    },
    "class10": {
      "code": "090010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "栃木县南部",
      "zhName": "櫪木縣南部",
      "koName": "도치기 현 남부",
      "esName": "Sur de Prefectura de Tochigi",
      "ptName": "Sul da Província de Tochigi",
      "thName": "จังหวัดโทะจิงิตอนใต้",
      "viName": "Miền Nam tỉnh Tochigi",
      "inName": "Bagian Selatan Prefektur Ibaraki",
      "tlName": "Timog na bahagi ng Tochigi Prefecture",
      "moName": "Өмнөд Точиги аймаг",
      "buName": "တုချိဂိစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្តតុឈីហ្គិ",
      "neName": "तोचिगी जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "090013",
      "name": "南西部",
      "enName": "South-western Region"
    },
    "class20": {
      "code": "0920300",
      "name": "栃木市",
      "enName": "Tochigi City",
      "kana": "とちぎし",
      "chName": "栃木市",
      "zhName": "栃木市",
      "koName": "도치기 시",
      "esName": "Ciudad de Tochigi",
      "ptName": "cidade de Tochigi",
      "thName": "เมืองโทจิงิ",
      "viName": "thành phố Tochigi",
      "inName": "kota Tochigi",
      "tlName": "siyudad ng Tochigi",
      "moName": "Точиги хот",
      "buName": "တိုကျီးဂိ မြို့",
      "khName": "ទីក្រុង តូឈីហ្គី",
      "neName": "तोचिगी सहर"
    }
  },
  "0920400": {
    "office": {
      "code": "090000",
      "name": "栃木県",
      "enName": "Tochigi",
      "officeName": "宇都宮地方気象台",
      "chName": "栃木县",
      "zhName": "櫔木縣",
      "koName": "도치기현",
      "esName": "Prefectura de Tochigi",
      "ptName": "Província de Tochigi",
      "thName": "จังหวัดโทะจิงิ",
      "viName": "Tỉnh Tochigi",
      "inName": "Prefektur Tochigi",
      "tlName": "Tochigi Prefecture",
      "moName": "Точиги аймаг",
      "buName": "တိုချီဂိ ပြည်နယ်",
      "khName": "ខេត្ត តូឈីជី",
      "neName": "तोचिगी जिल्ला"
    },
    "class10": {
      "code": "090010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "栃木县南部",
      "zhName": "櫪木縣南部",
      "koName": "도치기 현 남부",
      "esName": "Sur de Prefectura de Tochigi",
      "ptName": "Sul da Província de Tochigi",
      "thName": "จังหวัดโทะจิงิตอนใต้",
      "viName": "Miền Nam tỉnh Tochigi",
      "inName": "Bagian Selatan Prefektur Ibaraki",
      "tlName": "Timog na bahagi ng Tochigi Prefecture",
      "moName": "Өмнөд Точиги аймаг",
      "buName": "တုချိဂိစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្តតុឈីហ្គិ",
      "neName": "तोचिगी जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "090013",
      "name": "南西部",
      "enName": "South-western Region"
    },
    "class20": {
      "code": "0920400",
      "name": "佐野市",
      "enName": "Sano City",
      "kana": "さのし",
      "chName": "佐野市",
      "zhName": "佐野市",
      "koName": "사노 시",
      "esName": "Ciudad de Sano",
      "ptName": "cidade de Sano",
      "thName": "เมืองซาโนะ",
      "viName": "thành phố Sano",
      "inName": "kota Sano",
      "tlName": "siyudad ng Sano",
      "moName": "Сано хот",
      "buName": "ဆာနော့ မြို့",
      "khName": "ទីក្រុង សាណូ",
      "neName": "सानो सहर"
    }
  },
  "0920500": {
    "office": {
      "code": "090000",
      "name": "栃木県",
      "enName": "Tochigi",
      "officeName": "宇都宮地方気象台",
      "chName": "栃木县",
      "zhName": "櫔木縣",
      "koName": "도치기현",
      "esName": "Prefectura de Tochigi",
      "ptName": "Província de Tochigi",
      "thName": "จังหวัดโทะจิงิ",
      "viName": "Tỉnh Tochigi",
      "inName": "Prefektur Tochigi",
      "tlName": "Tochigi Prefecture",
      "moName": "Точиги аймаг",
      "buName": "တိုချီဂိ ပြည်နယ်",
      "khName": "ខេត្ត តូឈីជី",
      "neName": "तोचिगी जिल्ला"
    },
    "class10": {
      "code": "090010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "栃木县南部",
      "zhName": "櫪木縣南部",
      "koName": "도치기 현 남부",
      "esName": "Sur de Prefectura de Tochigi",
      "ptName": "Sul da Província de Tochigi",
      "thName": "จังหวัดโทะจิงิตอนใต้",
      "viName": "Miền Nam tỉnh Tochigi",
      "inName": "Bagian Selatan Prefektur Ibaraki",
      "tlName": "Timog na bahagi ng Tochigi Prefecture",
      "moName": "Өмнөд Точиги аймаг",
      "buName": "တုချိဂိစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្តតុឈីហ្គិ",
      "neName": "तोचिगी जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "090013",
      "name": "南西部",
      "enName": "South-western Region"
    },
    "class20": {
      "code": "0920500",
      "name": "鹿沼市",
      "enName": "Kanuma City",
      "kana": "かぬまし",
      "chName": "鹿沼市",
      "zhName": "鹿沼市",
      "koName": "가누마 시",
      "esName": "Ciudad de Kanuma",
      "ptName": "cidade de Kanuma",
      "thName": "เมืองคานุมะ",
      "viName": "thành phố Kanuma",
      "inName": "kota Kanuma",
      "tlName": "siyudad ng Kanuma",
      "moName": "Канүма хот",
      "buName": "ခါးနုမာ့ မြို့",
      "khName": "ទីក្រុង កាណុម៉ា",
      "neName": "कानुमा सहर"
    }
  },
  "0920601": {
    "office": {
      "code": "090000",
      "name": "栃木県",
      "enName": "Tochigi",
      "officeName": "宇都宮地方気象台",
      "chName": "栃木县",
      "zhName": "櫔木縣",
      "koName": "도치기현",
      "esName": "Prefectura de Tochigi",
      "ptName": "Província de Tochigi",
      "thName": "จังหวัดโทะจิงิ",
      "viName": "Tỉnh Tochigi",
      "inName": "Prefektur Tochigi",
      "tlName": "Tochigi Prefecture",
      "moName": "Точиги аймаг",
      "buName": "တိုချီဂိ ပြည်နယ်",
      "khName": "ខេត្ត តូឈីជី",
      "neName": "तोचिगी जिल्ला"
    },
    "class10": {
      "code": "090020",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "栃木县北部",
      "zhName": "櫪木縣北部",
      "koName": "도치기 현 북부",
      "esName": "Norte de Prefectura de Tochigi",
      "ptName": "Norte da Província de Tochigi",
      "thName": "จังหวัดโทะจิงิตอนเหนือ",
      "viName": "Miền Bắc tỉnh Tochigi",
      "inName": "Bagian Utara Prefektur Ibaraki",
      "tlName": "Hilagang bahagi ng Tochigi Prefecture",
      "moName": "Хойд Точиги аймаг",
      "buName": "တုချိဂိစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្តតុឈីហ្គិ",
      "neName": "तोचिगी जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "090022",
      "name": "日光市",
      "enName": "Nikko City"
    },
    "class20": {
      "code": "0920601",
      "name": "日光市今市",
      "enName": "Imaichi, Nikko City",
      "kana": "にっこうしいまいち",
      "chName": "日光市今市",
      "zhName": "日光市今市",
      "koName": "닛코시 이마이치",
      "esName": "Imaichi, Ciudad de Nikko",
      "ptName": "Imaichi, Cidade de Nikko",
      "thName": "เมืองนิกโกอิมาอิชิ",
      "viName": "Imaichi, Thành phố Nikko",
      "inName": "Imaichi, Kota Nikko",
      "tlName": "Imaichi, Lungsod ng Nikko",
      "moName": "Imaichi, Cidade de Nikko",
      "buName": "နစ်ကိုမြို့ အီမိုင်ချီ",
      "khName": "ខេត្តនិគ្គូអ៊ីម៉ាយចី",
      "neName": "इमाइची नगर"
    }
  },
  "0920602": {
    "office": {
      "code": "090000",
      "name": "栃木県",
      "enName": "Tochigi",
      "officeName": "宇都宮地方気象台",
      "chName": "栃木县",
      "zhName": "櫔木縣",
      "koName": "도치기현",
      "esName": "Prefectura de Tochigi",
      "ptName": "Província de Tochigi",
      "thName": "จังหวัดโทะจิงิ",
      "viName": "Tỉnh Tochigi",
      "inName": "Prefektur Tochigi",
      "tlName": "Tochigi Prefecture",
      "moName": "Точиги аймаг",
      "buName": "တိုချီဂိ ပြည်နယ်",
      "khName": "ខេត្ត តូឈីជី",
      "neName": "तोचिगी जिल्ला"
    },
    "class10": {
      "code": "090020",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "栃木县北部",
      "zhName": "櫪木縣北部",
      "koName": "도치기 현 북부",
      "esName": "Norte de Prefectura de Tochigi",
      "ptName": "Norte da Província de Tochigi",
      "thName": "จังหวัดโทะจิงิตอนเหนือ",
      "viName": "Miền Bắc tỉnh Tochigi",
      "inName": "Bagian Utara Prefektur Ibaraki",
      "tlName": "Hilagang bahagi ng Tochigi Prefecture",
      "moName": "Хойд Точиги аймаг",
      "buName": "တုချိဂိစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្តតុឈីហ្គិ",
      "neName": "तोचिगी जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "090022",
      "name": "日光市",
      "enName": "Nikko City"
    },
    "class20": {
      "code": "0920602",
      "name": "日光市日光",
      "enName": "Nikko, Nikko City",
      "kana": "にっこうしにっこう",
      "chName": "日光市日光",
      "zhName": "日光市日光",
      "koName": "닛코시 닛코",
      "esName": "Nikko, Ciudad de Nikko",
      "ptName": "Nikko, Cidade de Nikko",
      "thName": "เมืองนิกโกนิกโก",
      "viName": "Nikko, Thành phố Nikko",
      "inName": "Nikko, Kota Nikko",
      "tlName": "Nikko, Lungsod ng Nikko",
      "moName": "Nikko, Cidade de Nikko",
      "buName": "နစ်ကိုမြို့ နစ်ကို",
      "khName": "ខេត្តនិគ្គូនិគ្គូ",
      "neName": "निको नगर"
    }
  },
  "0920603": {
    "office": {
      "code": "090000",
      "name": "栃木県",
      "enName": "Tochigi",
      "officeName": "宇都宮地方気象台",
      "chName": "栃木县",
      "zhName": "櫔木縣",
      "koName": "도치기현",
      "esName": "Prefectura de Tochigi",
      "ptName": "Província de Tochigi",
      "thName": "จังหวัดโทะจิงิ",
      "viName": "Tỉnh Tochigi",
      "inName": "Prefektur Tochigi",
      "tlName": "Tochigi Prefecture",
      "moName": "Точиги аймаг",
      "buName": "တိုချီဂိ ပြည်နယ်",
      "khName": "ខេត្ត តូឈីជី",
      "neName": "तोचिगी जिल्ला"
    },
    "class10": {
      "code": "090020",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "栃木县北部",
      "zhName": "櫪木縣北部",
      "koName": "도치기 현 북부",
      "esName": "Norte de Prefectura de Tochigi",
      "ptName": "Norte da Província de Tochigi",
      "thName": "จังหวัดโทะจิงิตอนเหนือ",
      "viName": "Miền Bắc tỉnh Tochigi",
      "inName": "Bagian Utara Prefektur Ibaraki",
      "tlName": "Hilagang bahagi ng Tochigi Prefecture",
      "moName": "Хойд Точиги аймаг",
      "buName": "တုချိဂိစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្តតុឈីហ្គិ",
      "neName": "तोचिगी जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "090022",
      "name": "日光市",
      "enName": "Nikko City"
    },
    "class20": {
      "code": "0920603",
      "name": "日光市藤原",
      "enName": "Fujihara, Nikko City",
      "kana": "にっこうしふじわら",
      "chName": "日光市藤原",
      "zhName": "日光市藤原",
      "koName": "닛코시 후지하라",
      "esName": "Fujihara, Ciudad de Nikko",
      "ptName": "Fujihara, Cidade de Nikko",
      "thName": "เมืองนิกโกฟูจิฮาระ",
      "viName": "Fujihara, Thành phố Nikko",
      "inName": "Fujihara, Kota Nikko",
      "tlName": "Fujihara, Lungsod ng Nikko",
      "moName": "Fujihara, Cidade de Nikko",
      "buName": "နစ်ကိုမြို့ ဖူဂျီဟာရာ",
      "khName": "ខេត្តនិគ្គូហ្វុជីហារ",
      "neName": "फुजिहारा नगर"
    }
  },
  "0920604": {
    "office": {
      "code": "090000",
      "name": "栃木県",
      "enName": "Tochigi",
      "officeName": "宇都宮地方気象台",
      "chName": "栃木县",
      "zhName": "櫔木縣",
      "koName": "도치기현",
      "esName": "Prefectura de Tochigi",
      "ptName": "Província de Tochigi",
      "thName": "จังหวัดโทะจิงิ",
      "viName": "Tỉnh Tochigi",
      "inName": "Prefektur Tochigi",
      "tlName": "Tochigi Prefecture",
      "moName": "Точиги аймаг",
      "buName": "တိုချီဂိ ပြည်နယ်",
      "khName": "ខេត្ត តូឈីជី",
      "neName": "तोचिगी जिल्ला"
    },
    "class10": {
      "code": "090020",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "栃木县北部",
      "zhName": "櫪木縣北部",
      "koName": "도치기 현 북부",
      "esName": "Norte de Prefectura de Tochigi",
      "ptName": "Norte da Província de Tochigi",
      "thName": "จังหวัดโทะจิงิตอนเหนือ",
      "viName": "Miền Bắc tỉnh Tochigi",
      "inName": "Bagian Utara Prefektur Ibaraki",
      "tlName": "Hilagang bahagi ng Tochigi Prefecture",
      "moName": "Хойд Точиги аймаг",
      "buName": "တုချိဂိစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្តតុឈីហ្គិ",
      "neName": "तोचिगी जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "090022",
      "name": "日光市",
      "enName": "Nikko City"
    },
    "class20": {
      "code": "0920604",
      "name": "日光市足尾",
      "enName": "Ashio, Nikko City",
      "kana": "にっこうしあしお",
      "chName": "日光市足尾",
      "zhName": "日光市足尾",
      "koName": "닛코시 아시오",
      "esName": "Ashio, Ciudad de Nikko",
      "ptName": "Ashio, Cidade de Nikko",
      "thName": "เมืองนิกโกอาชิโอ",
      "viName": "Ashio, Thành phố Nikko",
      "inName": "Ashio, Kota Nikko",
      "tlName": "Ashio, Lungsod ng Nikko",
      "moName": "Ashio, Cidade de Nikko",
      "buName": "နစ်ကိုမြို့ အာရှို",
      "khName": "ខេត្តនិគ្គូអាស៊ីအို",
      "neName": "आशीओ नगर"
    }
  },
  "0920605": {
    "office": {
      "code": "090000",
      "name": "栃木県",
      "enName": "Tochigi",
      "officeName": "宇都宮地方気象台",
      "chName": "栃木县",
      "zhName": "櫔木縣",
      "koName": "도치기현",
      "esName": "Prefectura de Tochigi",
      "ptName": "Província de Tochigi",
      "thName": "จังหวัดโทะจิงิ",
      "viName": "Tỉnh Tochigi",
      "inName": "Prefektur Tochigi",
      "tlName": "Tochigi Prefecture",
      "moName": "Точиги аймаг",
      "buName": "တိုချီဂိ ပြည်နယ်",
      "khName": "ខេត្ត តូឈីជី",
      "neName": "तोचिगी जिल्ला"
    },
    "class10": {
      "code": "090020",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "栃木县北部",
      "zhName": "櫪木縣北部",
      "koName": "도치기 현 북부",
      "esName": "Norte de Prefectura de Tochigi",
      "ptName": "Norte da Província de Tochigi",
      "thName": "จังหวัดโทะจิงิตอนเหนือ",
      "viName": "Miền Bắc tỉnh Tochigi",
      "inName": "Bagian Utara Prefektur Ibaraki",
      "tlName": "Hilagang bahagi ng Tochigi Prefecture",
      "moName": "Хойд Точиги аймаг",
      "buName": "တုချိဂိစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្តតុឈីហ្គិ",
      "neName": "तोचिगी जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "090022",
      "name": "日光市",
      "enName": "Nikko City"
    },
    "class20": {
      "code": "0920605",
      "name": "日光市栗山",
      "enName": "Kuriyama, Nikko City",
      "kana": "にっこうしくりやま",
      "chName": "日光市栗山",
      "zhName": "日光市栗山",
      "koName": "닛코시 구리야마",
      "esName": "Kuriyama, Ciudad de Nikko",
      "ptName": "Kuriyama, Cidade de Nikko",
      "thName": "เมืองนิกโกคุริยามะ",
      "viName": "Kuriyama, Thành phố Nikko",
      "inName": "Kuriyama, Kota Nikko",
      "tlName": "Kuriyama, Lungsod ng Nikko",
      "moName": "Kuriyama, Cidade de Nikko",
      "buName": "နစ်ကိုမြို့ ကူရီယားမ",
      "khName": "ខេត្តនិគ្គូគូរីយ៉ាម៉ា",
      "neName": "कुरियामा नगर"
    }
  },
  "0920800": {
    "office": {
      "code": "090000",
      "name": "栃木県",
      "enName": "Tochigi",
      "officeName": "宇都宮地方気象台",
      "chName": "栃木县",
      "zhName": "櫔木縣",
      "koName": "도치기현",
      "esName": "Prefectura de Tochigi",
      "ptName": "Província de Tochigi",
      "thName": "จังหวัดโทะจิงิ",
      "viName": "Tỉnh Tochigi",
      "inName": "Prefektur Tochigi",
      "tlName": "Tochigi Prefecture",
      "moName": "Точиги аймаг",
      "buName": "တိုချီဂိ ပြည်နယ်",
      "khName": "ខេត្ត តូឈីជី",
      "neName": "तोचिगी जिल्ला"
    },
    "class10": {
      "code": "090010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "栃木县南部",
      "zhName": "櫪木縣南部",
      "koName": "도치기 현 남부",
      "esName": "Sur de Prefectura de Tochigi",
      "ptName": "Sul da Província de Tochigi",
      "thName": "จังหวัดโทะจิงิตอนใต้",
      "viName": "Miền Nam tỉnh Tochigi",
      "inName": "Bagian Selatan Prefektur Ibaraki",
      "tlName": "Timog na bahagi ng Tochigi Prefecture",
      "moName": "Өмнөд Точиги аймаг",
      "buName": "တုချိဂိစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្តតុឈីហ្គិ",
      "neName": "तोचिगी जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "090013",
      "name": "南西部",
      "enName": "South-western Region"
    },
    "class20": {
      "code": "0920800",
      "name": "小山市",
      "enName": "Oyama City",
      "kana": "おやまし",
      "chName": "小山市",
      "zhName": "小山市",
      "koName": "오야마 시",
      "esName": "Ciudad de Oyama",
      "ptName": "cidade de Oyama",
      "thName": "เมืองโอยามะ",
      "viName": "thành phố Oyama",
      "inName": "kota Oyama",
      "tlName": "siyudad ng Oyama",
      "moName": "Ояма хот",
      "buName": "အိုးယာ့မ မြို့",
      "khName": "ទីក្រុង អូយ៉ាម៉ា",
      "neName": "ओयामा सहर"
    }
  },
  "0920900": {
    "office": {
      "code": "090000",
      "name": "栃木県",
      "enName": "Tochigi",
      "officeName": "宇都宮地方気象台",
      "chName": "栃木县",
      "zhName": "櫔木縣",
      "koName": "도치기현",
      "esName": "Prefectura de Tochigi",
      "ptName": "Província de Tochigi",
      "thName": "จังหวัดโทะจิงิ",
      "viName": "Tỉnh Tochigi",
      "inName": "Prefektur Tochigi",
      "tlName": "Tochigi Prefecture",
      "moName": "Точиги аймаг",
      "buName": "တိုချီဂိ ပြည်နယ်",
      "khName": "ខេត្ត តូឈីជី",
      "neName": "तोचिगी जिल्ला"
    },
    "class10": {
      "code": "090010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "栃木县南部",
      "zhName": "櫪木縣南部",
      "koName": "도치기 현 남부",
      "esName": "Sur de Prefectura de Tochigi",
      "ptName": "Sul da Província de Tochigi",
      "thName": "จังหวัดโทะจิงิตอนใต้",
      "viName": "Miền Nam tỉnh Tochigi",
      "inName": "Bagian Selatan Prefektur Ibaraki",
      "tlName": "Timog na bahagi ng Tochigi Prefecture",
      "moName": "Өмнөд Точиги аймаг",
      "buName": "တုချိဂိစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្តតុឈីហ្គិ",
      "neName": "तोचिगी जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "090012",
      "name": "南東部",
      "enName": "South-eastern Region"
    },
    "class20": {
      "code": "0920900",
      "name": "真岡市",
      "enName": "Moka City",
      "kana": "もおかし",
      "chName": "真冈市",
      "zhName": "真岡市",
      "koName": "모카 시",
      "esName": "Ciudad de Mooka",
      "ptName": "cidade de Moka",
      "thName": "เมืองโมกะ",
      "viName": "thành phố Moka",
      "inName": "kota Moka",
      "tlName": "siyudad ng Moka",
      "moName": "Мока хот",
      "buName": "မိုကာ မြို့",
      "khName": "ទីក្រុង ម៉ុកា",
      "neName": "मोका सहर"
    }
  },
  "0921000": {
    "office": {
      "code": "090000",
      "name": "栃木県",
      "enName": "Tochigi",
      "officeName": "宇都宮地方気象台",
      "chName": "栃木县",
      "zhName": "櫔木縣",
      "koName": "도치기현",
      "esName": "Prefectura de Tochigi",
      "ptName": "Província de Tochigi",
      "thName": "จังหวัดโทะจิงิ",
      "viName": "Tỉnh Tochigi",
      "inName": "Prefektur Tochigi",
      "tlName": "Tochigi Prefecture",
      "moName": "Точиги аймаг",
      "buName": "တိုချီဂိ ပြည်နယ်",
      "khName": "ខេត្ត តូឈីជី",
      "neName": "तोचिगी जिल्ला"
    },
    "class10": {
      "code": "090020",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "栃木县北部",
      "zhName": "櫪木縣北部",
      "koName": "도치기 현 북부",
      "esName": "Norte de Prefectura de Tochigi",
      "ptName": "Norte da Província de Tochigi",
      "thName": "จังหวัดโทะจิงิตอนเหนือ",
      "viName": "Miền Bắc tỉnh Tochigi",
      "inName": "Bagian Utara Prefektur Ibaraki",
      "tlName": "Hilagang bahagi ng Tochigi Prefecture",
      "moName": "Хойд Точиги аймаг",
      "buName": "တုချိဂိစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្តតុឈីហ្គិ",
      "neName": "तोचिगी जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "090021",
      "name": "那須地域",
      "enName": "Nasu Area"
    },
    "class20": {
      "code": "0921000",
      "name": "大田原市",
      "enName": "Ohtawara City",
      "kana": "おおたわらし",
      "chName": "大田原市",
      "zhName": "大田原市",
      "koName": "오타와라 시",
      "esName": "Ciudad de Otawara",
      "ptName": "cidade de Ohtawara",
      "thName": "เมืองโอตาวาระ",
      "viName": "thành phố Ohtawara",
      "inName": "kota Ohtawara",
      "tlName": "siyudad ng Ohtawara",
      "moName": "Охтавара хот",
      "buName": "အိုတားဝရာ့ မြို့",
      "khName": "ទីក្រុង អូថាវ៉ារ៉ា",
      "neName": "ओतावारा सहर"
    }
  },
  "0921100": {
    "office": {
      "code": "090000",
      "name": "栃木県",
      "enName": "Tochigi",
      "officeName": "宇都宮地方気象台",
      "chName": "栃木县",
      "zhName": "櫔木縣",
      "koName": "도치기현",
      "esName": "Prefectura de Tochigi",
      "ptName": "Província de Tochigi",
      "thName": "จังหวัดโทะจิงิ",
      "viName": "Tỉnh Tochigi",
      "inName": "Prefektur Tochigi",
      "tlName": "Tochigi Prefecture",
      "moName": "Точиги аймаг",
      "buName": "တိုချီဂိ ပြည်နယ်",
      "khName": "ខេត្ត តូឈីជី",
      "neName": "तोचिगी जिल्ला"
    },
    "class10": {
      "code": "090020",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "栃木县北部",
      "zhName": "櫪木縣北部",
      "koName": "도치기 현 북부",
      "esName": "Norte de Prefectura de Tochigi",
      "ptName": "Norte da Província de Tochigi",
      "thName": "จังหวัดโทะจิงิตอนเหนือ",
      "viName": "Miền Bắc tỉnh Tochigi",
      "inName": "Bagian Utara Prefektur Ibaraki",
      "tlName": "Hilagang bahagi ng Tochigi Prefecture",
      "moName": "Хойд Точиги аймаг",
      "buName": "တုချိဂိစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្តតុឈីហ្គិ",
      "neName": "तोचिगी जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "090021",
      "name": "那須地域",
      "enName": "Nasu Area"
    },
    "class20": {
      "code": "0921100",
      "name": "矢板市",
      "enName": "Yaita City",
      "kana": "やいたし",
      "chName": "矢板市",
      "zhName": "矢板市",
      "koName": "야이타 시",
      "esName": "Ciudad de Yaita",
      "ptName": "cidade de Yaita",
      "thName": "เมืองยะอิตะ",
      "viName": "thành phố Yaita",
      "inName": "kota Yaita",
      "tlName": "siyudad ng Yaita",
      "moName": "Яйта хот",
      "buName": "ယအိတ မြို့",
      "khName": "ទីក្រុង យ៉ាអ៊ីដា",
      "neName": "याइता सहर"
    }
  },
  "0921300": {
    "office": {
      "code": "090000",
      "name": "栃木県",
      "enName": "Tochigi",
      "officeName": "宇都宮地方気象台",
      "chName": "栃木县",
      "zhName": "櫔木縣",
      "koName": "도치기현",
      "esName": "Prefectura de Tochigi",
      "ptName": "Província de Tochigi",
      "thName": "จังหวัดโทะจิงิ",
      "viName": "Tỉnh Tochigi",
      "inName": "Prefektur Tochigi",
      "tlName": "Tochigi Prefecture",
      "moName": "Точиги аймаг",
      "buName": "တိုချီဂိ ပြည်နယ်",
      "khName": "ខេត្ត តូឈីជី",
      "neName": "तोचिगी जिल्ला"
    },
    "class10": {
      "code": "090020",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "栃木县北部",
      "zhName": "櫪木縣北部",
      "koName": "도치기 현 북부",
      "esName": "Norte de Prefectura de Tochigi",
      "ptName": "Norte da Província de Tochigi",
      "thName": "จังหวัดโทะจิงิตอนเหนือ",
      "viName": "Miền Bắc tỉnh Tochigi",
      "inName": "Bagian Utara Prefektur Ibaraki",
      "tlName": "Hilagang bahagi ng Tochigi Prefecture",
      "moName": "Хойд Точиги аймаг",
      "buName": "တုချိဂိစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្តតុឈីហ្គិ",
      "neName": "तोचिगी जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "090021",
      "name": "那須地域",
      "enName": "Nasu Area"
    },
    "class20": {
      "code": "0921300",
      "name": "那須塩原市",
      "enName": "Nasushiobara City",
      "kana": "なすしおばらし",
      "chName": "那须盐原市",
      "zhName": "那須鹽原市",
      "koName": "나스시오바라 시",
      "esName": "Ciudad de Nasushiobara",
      "ptName": "cidade de Nasushiobara",
      "thName": "เมืองนะสุชิโอบาระ",
      "viName": "thành phố Nasushiobara",
      "inName": "kota Nasushiobara",
      "tlName": "siyudad ng Nasushiobara",
      "moName": "Насүшиобара хот",
      "buName": "နာဆုရှီအိုဘာ့ရ မြို့",
      "khName": "ទីក្រុង ណាស៊ូស៊ីអូបារ៉ា",
      "neName": "नासुशियोबारा सहर"
    }
  },
  "0921400": {
    "office": {
      "code": "090000",
      "name": "栃木県",
      "enName": "Tochigi",
      "officeName": "宇都宮地方気象台",
      "chName": "栃木县",
      "zhName": "櫔木縣",
      "koName": "도치기현",
      "esName": "Prefectura de Tochigi",
      "ptName": "Província de Tochigi",
      "thName": "จังหวัดโทะจิงิ",
      "viName": "Tỉnh Tochigi",
      "inName": "Prefektur Tochigi",
      "tlName": "Tochigi Prefecture",
      "moName": "Точиги аймаг",
      "buName": "တိုချီဂိ ပြည်နယ်",
      "khName": "ខេត្ត តូឈីជី",
      "neName": "तोचिगी जिल्ला"
    },
    "class10": {
      "code": "090010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "栃木县南部",
      "zhName": "櫪木縣南部",
      "koName": "도치기 현 남부",
      "esName": "Sur de Prefectura de Tochigi",
      "ptName": "Sul da Província de Tochigi",
      "thName": "จังหวัดโทะจิงิตอนใต้",
      "viName": "Miền Nam tỉnh Tochigi",
      "inName": "Bagian Selatan Prefektur Ibaraki",
      "tlName": "Timog na bahagi ng Tochigi Prefecture",
      "moName": "Өмнөд Точиги аймаг",
      "buName": "တုချိဂိစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្តតុឈីហ្គិ",
      "neName": "तोचिगी जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "090011",
      "name": "県央部",
      "enName": "Ken-o part"
    },
    "class20": {
      "code": "0921400",
      "name": "さくら市",
      "enName": "Sakura City",
      "kana": "さくらし",
      "chName": "栃木樱花市",
      "zhName": "栃木櫻花市",
      "koName": "도치기 사쿠라 시",
      "esName": "Ciudad de Sakura, Tochigi",
      "ptName": "Tochigi, cidade de Sakura",
      "thName": "เมืองซากุระ โทะจิงิ",
      "viName": "Thành phố Sakura, Tochigi",
      "inName": "Kota Sakura, Tochigi",
      "tlName": "siyudad ng Sakura, Tochigi",
      "moName": "Точиги Сакүра хот",
      "buName": "တိုချိဂိဆကူယာမြို့",
      "khName": "ទីក្រុងសាគូរ៉ា តុឈីហ្គិ",
      "neName": "तोचिगी साकुरा सहर"
    }
  },
  "0921500": {
    "office": {
      "code": "090000",
      "name": "栃木県",
      "enName": "Tochigi",
      "officeName": "宇都宮地方気象台",
      "chName": "栃木县",
      "zhName": "櫔木縣",
      "koName": "도치기현",
      "esName": "Prefectura de Tochigi",
      "ptName": "Província de Tochigi",
      "thName": "จังหวัดโทะจิงิ",
      "viName": "Tỉnh Tochigi",
      "inName": "Prefektur Tochigi",
      "tlName": "Tochigi Prefecture",
      "moName": "Точиги аймаг",
      "buName": "တိုချီဂိ ပြည်နယ်",
      "khName": "ខេត្ត តូឈីជី",
      "neName": "तोचिगी जिल्ला"
    },
    "class10": {
      "code": "090010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "栃木县南部",
      "zhName": "櫪木縣南部",
      "koName": "도치기 현 남부",
      "esName": "Sur de Prefectura de Tochigi",
      "ptName": "Sul da Província de Tochigi",
      "thName": "จังหวัดโทะจิงิตอนใต้",
      "viName": "Miền Nam tỉnh Tochigi",
      "inName": "Bagian Selatan Prefektur Ibaraki",
      "tlName": "Timog na bahagi ng Tochigi Prefecture",
      "moName": "Өмнөд Точиги аймаг",
      "buName": "တုချိဂိစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្តតុឈីហ្គិ",
      "neName": "तोचिगी जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "090012",
      "name": "南東部",
      "enName": "South-eastern Region"
    },
    "class20": {
      "code": "0921500",
      "name": "那須烏山市",
      "enName": "Nasukarasuyama City",
      "kana": "なすからすやまし",
      "chName": "那须乌山市",
      "zhName": "那須烏山市",
      "koName": "나스카라스야마 시",
      "esName": "Ciudad de Nasukarasuyama",
      "ptName": "cidade de Nasukarasuyama",
      "thName": "เมืองนาสึคาระสึยามะ",
      "viName": "thành phố Nasukarauyama",
      "inName": "kota Nasukarasuyama",
      "tlName": "siyudad ng Nasukarasuyama",
      "moName": "Насүкарасүяма хот",
      "buName": "နာဆူကာ့ရဆုယာ့မ မြို့",
      "khName": "ទីក្រុង ណាស៊ូការ៉ាស៊ូយ៉ាម៉ា",
      "neName": "नासुकारासुयामा सहर"
    }
  },
  "0921600": {
    "office": {
      "code": "090000",
      "name": "栃木県",
      "enName": "Tochigi",
      "officeName": "宇都宮地方気象台",
      "chName": "栃木县",
      "zhName": "櫔木縣",
      "koName": "도치기현",
      "esName": "Prefectura de Tochigi",
      "ptName": "Província de Tochigi",
      "thName": "จังหวัดโทะจิงิ",
      "viName": "Tỉnh Tochigi",
      "inName": "Prefektur Tochigi",
      "tlName": "Tochigi Prefecture",
      "moName": "Точиги аймаг",
      "buName": "တိုချီဂိ ပြည်နယ်",
      "khName": "ខេត្ត តូឈីជី",
      "neName": "तोचिगी जिल्ला"
    },
    "class10": {
      "code": "090010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "栃木县南部",
      "zhName": "櫪木縣南部",
      "koName": "도치기 현 남부",
      "esName": "Sur de Prefectura de Tochigi",
      "ptName": "Sul da Província de Tochigi",
      "thName": "จังหวัดโทะจิงิตอนใต้",
      "viName": "Miền Nam tỉnh Tochigi",
      "inName": "Bagian Selatan Prefektur Ibaraki",
      "tlName": "Timog na bahagi ng Tochigi Prefecture",
      "moName": "Өмнөд Точиги аймаг",
      "buName": "တုချိဂိစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្តតុឈីហ្គិ",
      "neName": "तोचिगी जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "090013",
      "name": "南西部",
      "enName": "South-western Region"
    },
    "class20": {
      "code": "0921600",
      "name": "下野市",
      "enName": "Shimotsuke City",
      "kana": "しもつけし",
      "chName": "下野市",
      "zhName": "下野市",
      "koName": "시모쓰케 시",
      "esName": "Ciudad de Shimotsuke",
      "ptName": "cidade de Shimotsuke",
      "thName": "เมืองชิโมสึเกะ",
      "viName": "thành phố Shimotsuke",
      "inName": "kota Shimotsuke",
      "tlName": "siyudad ng Shimotsuke",
      "moName": "Шимоцүкэ хот",
      "buName": "ရှီမော့ဆုကဲ့ မြို့",
      "khName": "ទីក្រុង ស៊ីម៉ូស៊ូគី",
      "neName": "शिमोत्सुके सहर"
    }
  },
  "0930100": {
    "office": {
      "code": "090000",
      "name": "栃木県",
      "enName": "Tochigi",
      "officeName": "宇都宮地方気象台",
      "chName": "栃木县",
      "zhName": "櫔木縣",
      "koName": "도치기현",
      "esName": "Prefectura de Tochigi",
      "ptName": "Província de Tochigi",
      "thName": "จังหวัดโทะจิงิ",
      "viName": "Tỉnh Tochigi",
      "inName": "Prefektur Tochigi",
      "tlName": "Tochigi Prefecture",
      "moName": "Точиги аймаг",
      "buName": "တိုချီဂိ ပြည်နယ်",
      "khName": "ខេត្ត តូឈីជី",
      "neName": "तोचिगी जिल्ला"
    },
    "class10": {
      "code": "090010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "栃木县南部",
      "zhName": "櫪木縣南部",
      "koName": "도치기 현 남부",
      "esName": "Sur de Prefectura de Tochigi",
      "ptName": "Sul da Província de Tochigi",
      "thName": "จังหวัดโทะจิงิตอนใต้",
      "viName": "Miền Nam tỉnh Tochigi",
      "inName": "Bagian Selatan Prefektur Ibaraki",
      "tlName": "Timog na bahagi ng Tochigi Prefecture",
      "moName": "Өмнөд Точиги аймаг",
      "buName": "တုချိဂိစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្តតុឈីហ្គិ",
      "neName": "तोचिगी जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "090011",
      "name": "県央部",
      "enName": "Ken-o part"
    },
    "class20": {
      "code": "0930100",
      "name": "上三川町",
      "enName": "Kaminokawa Town",
      "kana": "かみのかわまち",
      "chName": "上三川町",
      "zhName": "上三川町",
      "koName": "가미노카와 정",
      "esName": "Pueblo de Kaminokawa",
      "ptName": "bairro de Kaminokawa",
      "thName": "เมืองคามิโนะคาวะ",
      "viName": "thị trấn Kaminokawa",
      "inName": "kota Kaminokawa",
      "tlName": "bayan ng Kaminokawa",
      "moName": "Каминокава жижиг хот",
      "buName": "ခါမိနောဂါ့ဝ မြို့နယ်",
      "khName": "ទីប្រជុំជន កាមីណូកាវ៉ា",
      "neName": "कामिनोकावा नगर"
    }
  },
  "0934200": {
    "office": {
      "code": "090000",
      "name": "栃木県",
      "enName": "Tochigi",
      "officeName": "宇都宮地方気象台",
      "chName": "栃木县",
      "zhName": "櫔木縣",
      "koName": "도치기현",
      "esName": "Prefectura de Tochigi",
      "ptName": "Província de Tochigi",
      "thName": "จังหวัดโทะจิงิ",
      "viName": "Tỉnh Tochigi",
      "inName": "Prefektur Tochigi",
      "tlName": "Tochigi Prefecture",
      "moName": "Точиги аймаг",
      "buName": "တိုချီဂိ ပြည်နယ်",
      "khName": "ខេត្ត តូឈីជី",
      "neName": "तोचिगी जिल्ला"
    },
    "class10": {
      "code": "090010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "栃木县南部",
      "zhName": "櫪木縣南部",
      "koName": "도치기 현 남부",
      "esName": "Sur de Prefectura de Tochigi",
      "ptName": "Sul da Província de Tochigi",
      "thName": "จังหวัดโทะจิงิตอนใต้",
      "viName": "Miền Nam tỉnh Tochigi",
      "inName": "Bagian Selatan Prefektur Ibaraki",
      "tlName": "Timog na bahagi ng Tochigi Prefecture",
      "moName": "Өмнөд Точиги аймаг",
      "buName": "တုချိဂိစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្តតុឈីហ្គិ",
      "neName": "तोचिगी जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "090012",
      "name": "南東部",
      "enName": "South-eastern Region"
    },
    "class20": {
      "code": "0934200",
      "name": "益子町",
      "enName": "Mashiko Town",
      "kana": "ましこまち",
      "chName": "益子町",
      "zhName": "益子町",
      "koName": "마시코 정",
      "esName": "Pueblo de Mashiko",
      "ptName": "bairro de Mashiko",
      "thName": "เมืองมาชิโกะ",
      "viName": "thị trấn Mashiko",
      "inName": "kota Mashiko",
      "tlName": "bayan ng Mashiko",
      "moName": "Мaшико жижиг хот",
      "buName": "မာရှိကော့ မြို့နယ်",
      "khName": "ទីប្រជុំជន ម៉ាស៊ីកូ",
      "neName": "माशिको नगर"
    }
  },
  "0934300": {
    "office": {
      "code": "090000",
      "name": "栃木県",
      "enName": "Tochigi",
      "officeName": "宇都宮地方気象台",
      "chName": "栃木县",
      "zhName": "櫔木縣",
      "koName": "도치기현",
      "esName": "Prefectura de Tochigi",
      "ptName": "Província de Tochigi",
      "thName": "จังหวัดโทะจิงิ",
      "viName": "Tỉnh Tochigi",
      "inName": "Prefektur Tochigi",
      "tlName": "Tochigi Prefecture",
      "moName": "Точиги аймаг",
      "buName": "တိုချီဂိ ပြည်နယ်",
      "khName": "ខេត្ត តូឈីជី",
      "neName": "तोचिगी जिल्ला"
    },
    "class10": {
      "code": "090010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "栃木县南部",
      "zhName": "櫪木縣南部",
      "koName": "도치기 현 남부",
      "esName": "Sur de Prefectura de Tochigi",
      "ptName": "Sul da Província de Tochigi",
      "thName": "จังหวัดโทะจิงิตอนใต้",
      "viName": "Miền Nam tỉnh Tochigi",
      "inName": "Bagian Selatan Prefektur Ibaraki",
      "tlName": "Timog na bahagi ng Tochigi Prefecture",
      "moName": "Өмнөд Точиги аймаг",
      "buName": "တုချိဂိစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្តតុឈីហ្គិ",
      "neName": "तोचिगी जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "090012",
      "name": "南東部",
      "enName": "South-eastern Region"
    },
    "class20": {
      "code": "0934300",
      "name": "茂木町",
      "enName": "Motegi Town",
      "kana": "もてぎまち",
      "chName": "茂木町",
      "zhName": "茂木町",
      "koName": "모테기 정",
      "esName": "Pueblo de Motegi",
      "ptName": "bairro de Motegi",
      "thName": "เมืองโมเทงิ",
      "viName": "thị trấn Motegi",
      "inName": "kota Motegi",
      "tlName": "bayan ng Motegi",
      "moName": "Мотэги жижиг хот",
      "buName": "မိုးတဲဂိ မြို့နယ်",
      "khName": "ទីប្រជុំជន ម៉ូតេជី",
      "neName": "मोतेगी नगर"
    }
  },
  "0934400": {
    "office": {
      "code": "090000",
      "name": "栃木県",
      "enName": "Tochigi",
      "officeName": "宇都宮地方気象台",
      "chName": "栃木县",
      "zhName": "櫔木縣",
      "koName": "도치기현",
      "esName": "Prefectura de Tochigi",
      "ptName": "Província de Tochigi",
      "thName": "จังหวัดโทะจิงิ",
      "viName": "Tỉnh Tochigi",
      "inName": "Prefektur Tochigi",
      "tlName": "Tochigi Prefecture",
      "moName": "Точиги аймаг",
      "buName": "တိုချီဂိ ပြည်နယ်",
      "khName": "ខេត្ត តូឈីជី",
      "neName": "तोचिगी जिल्ला"
    },
    "class10": {
      "code": "090010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "栃木县南部",
      "zhName": "櫪木縣南部",
      "koName": "도치기 현 남부",
      "esName": "Sur de Prefectura de Tochigi",
      "ptName": "Sul da Província de Tochigi",
      "thName": "จังหวัดโทะจิงิตอนใต้",
      "viName": "Miền Nam tỉnh Tochigi",
      "inName": "Bagian Selatan Prefektur Ibaraki",
      "tlName": "Timog na bahagi ng Tochigi Prefecture",
      "moName": "Өмнөд Точиги аймаг",
      "buName": "တုချိဂိစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្តតុឈីហ្គិ",
      "neName": "तोचिगी जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "090012",
      "name": "南東部",
      "enName": "South-eastern Region"
    },
    "class20": {
      "code": "0934400",
      "name": "市貝町",
      "enName": "Ichikai Town",
      "kana": "いちかいまち",
      "chName": "市贝町",
      "zhName": "市貝町",
      "koName": "이치카이 정",
      "esName": "Pueblo de Ichikai",
      "ptName": "bairro de Ichikai",
      "thName": "เมืองอิจิไก",
      "viName": "thị trấn Ichikai",
      "inName": "kota Ichikai",
      "tlName": "bayan ng Ichikai",
      "moName": "Ичикай жижиг хот",
      "buName": "အီကျိကိုင်းယိ မြို့နယ်",
      "khName": "ទីប្រជុំជន អ៊ីឈីកៃ",
      "neName": "इचिकाई नगर"
    }
  },
  "0934500": {
    "office": {
      "code": "090000",
      "name": "栃木県",
      "enName": "Tochigi",
      "officeName": "宇都宮地方気象台",
      "chName": "栃木县",
      "zhName": "櫔木縣",
      "koName": "도치기현",
      "esName": "Prefectura de Tochigi",
      "ptName": "Província de Tochigi",
      "thName": "จังหวัดโทะจิงิ",
      "viName": "Tỉnh Tochigi",
      "inName": "Prefektur Tochigi",
      "tlName": "Tochigi Prefecture",
      "moName": "Точиги аймаг",
      "buName": "တိုချီဂိ ပြည်နယ်",
      "khName": "ខេត្ត តូឈីជី",
      "neName": "तोचिगी जिल्ला"
    },
    "class10": {
      "code": "090010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "栃木县南部",
      "zhName": "櫪木縣南部",
      "koName": "도치기 현 남부",
      "esName": "Sur de Prefectura de Tochigi",
      "ptName": "Sul da Província de Tochigi",
      "thName": "จังหวัดโทะจิงิตอนใต้",
      "viName": "Miền Nam tỉnh Tochigi",
      "inName": "Bagian Selatan Prefektur Ibaraki",
      "tlName": "Timog na bahagi ng Tochigi Prefecture",
      "moName": "Өмнөд Точиги аймаг",
      "buName": "တုချိဂိစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្តតុឈីហ្គិ",
      "neName": "तोचिगी जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "090012",
      "name": "南東部",
      "enName": "South-eastern Region"
    },
    "class20": {
      "code": "0934500",
      "name": "芳賀町",
      "enName": "Haga Town",
      "kana": "はがまち",
      "chName": "芳贺町",
      "zhName": "芳賀町",
      "koName": "하가 정",
      "esName": "Pueblo de Haga",
      "ptName": "bairro de Haga",
      "thName": "เมืองฮางะ",
      "viName": "thị trấn Haga",
      "inName": "kota Haga",
      "tlName": "bayan ng Haga",
      "moName": "Хaгa жижиг хот",
      "buName": "ဟာဂ မြို့နယ်",
      "khName": "ទីប្រជុំជន ហាហ្គា",
      "neName": "हागा नगर"
    }
  },
  "0936100": {
    "office": {
      "code": "090000",
      "name": "栃木県",
      "enName": "Tochigi",
      "officeName": "宇都宮地方気象台",
      "chName": "栃木县",
      "zhName": "櫔木縣",
      "koName": "도치기현",
      "esName": "Prefectura de Tochigi",
      "ptName": "Província de Tochigi",
      "thName": "จังหวัดโทะจิงิ",
      "viName": "Tỉnh Tochigi",
      "inName": "Prefektur Tochigi",
      "tlName": "Tochigi Prefecture",
      "moName": "Точиги аймаг",
      "buName": "တိုချီဂိ ပြည်နယ်",
      "khName": "ខេត្ត តូឈីជី",
      "neName": "तोचिगी जिल्ला"
    },
    "class10": {
      "code": "090010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "栃木县南部",
      "zhName": "櫪木縣南部",
      "koName": "도치기 현 남부",
      "esName": "Sur de Prefectura de Tochigi",
      "ptName": "Sul da Província de Tochigi",
      "thName": "จังหวัดโทะจิงิตอนใต้",
      "viName": "Miền Nam tỉnh Tochigi",
      "inName": "Bagian Selatan Prefektur Ibaraki",
      "tlName": "Timog na bahagi ng Tochigi Prefecture",
      "moName": "Өмнөд Точиги аймаг",
      "buName": "တုချိဂိစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្តតុឈីហ្គិ",
      "neName": "तोचिगी जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "090013",
      "name": "南西部",
      "enName": "South-western Region"
    },
    "class20": {
      "code": "0936100",
      "name": "壬生町",
      "enName": "Mibu Town",
      "kana": "みぶまち",
      "chName": "壬生町",
      "zhName": "壬生町",
      "koName": "미부 정",
      "esName": "Pueblo de Mibu",
      "ptName": "bairro de Mibu",
      "thName": "เมืองมิบุ",
      "viName": "thị trấn Mibu",
      "inName": "kota Mibu",
      "tlName": "bayan ng Mibu",
      "moName": "Мибү жижиг хот",
      "buName": "မီဘု မြို့နယ်",
      "khName": "ទីប្រជុំជន មីប៊ូ",
      "neName": "मिबु नगर"
    }
  },
  "0936400": {
    "office": {
      "code": "090000",
      "name": "栃木県",
      "enName": "Tochigi",
      "officeName": "宇都宮地方気象台",
      "chName": "栃木县",
      "zhName": "櫔木縣",
      "koName": "도치기현",
      "esName": "Prefectura de Tochigi",
      "ptName": "Província de Tochigi",
      "thName": "จังหวัดโทะจิงิ",
      "viName": "Tỉnh Tochigi",
      "inName": "Prefektur Tochigi",
      "tlName": "Tochigi Prefecture",
      "moName": "Точиги аймаг",
      "buName": "တိုချီဂိ ပြည်နယ်",
      "khName": "ខេត្ត តូឈីជី",
      "neName": "तोचिगी जिल्ला"
    },
    "class10": {
      "code": "090010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "栃木县南部",
      "zhName": "櫪木縣南部",
      "koName": "도치기 현 남부",
      "esName": "Sur de Prefectura de Tochigi",
      "ptName": "Sul da Província de Tochigi",
      "thName": "จังหวัดโทะจิงิตอนใต้",
      "viName": "Miền Nam tỉnh Tochigi",
      "inName": "Bagian Selatan Prefektur Ibaraki",
      "tlName": "Timog na bahagi ng Tochigi Prefecture",
      "moName": "Өмнөд Точиги аймаг",
      "buName": "တုချိဂိစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្តតុឈីហ្គិ",
      "neName": "तोचिगी जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "090013",
      "name": "南西部",
      "enName": "South-western Region"
    },
    "class20": {
      "code": "0936400",
      "name": "野木町",
      "enName": "Nogi Town",
      "kana": "のぎまち",
      "chName": "野木町",
      "zhName": "野木町",
      "koName": "노기 정",
      "esName": "Pueblo de Nogi",
      "ptName": "bairro de Nogi",
      "thName": "เมืองโนงิ",
      "viName": "thị trấn Nogi",
      "inName": "kota Nogi",
      "tlName": "bayan ng Nogi",
      "moName": "Ноги жижиг хот",
      "buName": "နော်ဂိ မြို့နယ်",
      "khName": "ទីប្រជុំជន ណូជី",
      "neName": "नोगी नगर"
    }
  },
  "0938400": {
    "office": {
      "code": "090000",
      "name": "栃木県",
      "enName": "Tochigi",
      "officeName": "宇都宮地方気象台",
      "chName": "栃木县",
      "zhName": "櫔木縣",
      "koName": "도치기현",
      "esName": "Prefectura de Tochigi",
      "ptName": "Província de Tochigi",
      "thName": "จังหวัดโทะจิงิ",
      "viName": "Tỉnh Tochigi",
      "inName": "Prefektur Tochigi",
      "tlName": "Tochigi Prefecture",
      "moName": "Точиги аймаг",
      "buName": "တိုချီဂိ ပြည်နယ်",
      "khName": "ខេត្ត តូឈីជី",
      "neName": "तोचिगी जिल्ला"
    },
    "class10": {
      "code": "090020",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "栃木县北部",
      "zhName": "櫪木縣北部",
      "koName": "도치기 현 북부",
      "esName": "Norte de Prefectura de Tochigi",
      "ptName": "Norte da Província de Tochigi",
      "thName": "จังหวัดโทะจิงิตอนเหนือ",
      "viName": "Miền Bắc tỉnh Tochigi",
      "inName": "Bagian Utara Prefektur Ibaraki",
      "tlName": "Hilagang bahagi ng Tochigi Prefecture",
      "moName": "Хойд Точиги аймаг",
      "buName": "တုချိဂိစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្តតុឈីហ្គិ",
      "neName": "तोचिगी जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "090021",
      "name": "那須地域",
      "enName": "Nasu Area"
    },
    "class20": {
      "code": "0938400",
      "name": "塩谷町",
      "enName": "Shioya Town",
      "kana": "しおやまち",
      "chName": "盐谷町",
      "zhName": "鹽谷町",
      "koName": "시오야 정",
      "esName": "Pueblo de Shioya",
      "ptName": "bairro de Shioya",
      "thName": "เมืองชิโอยะ",
      "viName": "thị trấn Shioya",
      "inName": "kota Shioya",
      "tlName": "bayan ng Shioya",
      "moName": "Шиоя жижиг хот",
      "buName": "ရှိုးယ မြို့နယ်",
      "khName": "ទីប្រជុំជន ស៊ីអូយ៉ា",
      "neName": "शिओया नगर"
    }
  },
  "0938600": {
    "office": {
      "code": "090000",
      "name": "栃木県",
      "enName": "Tochigi",
      "officeName": "宇都宮地方気象台",
      "chName": "栃木县",
      "zhName": "櫔木縣",
      "koName": "도치기현",
      "esName": "Prefectura de Tochigi",
      "ptName": "Província de Tochigi",
      "thName": "จังหวัดโทะจิงิ",
      "viName": "Tỉnh Tochigi",
      "inName": "Prefektur Tochigi",
      "tlName": "Tochigi Prefecture",
      "moName": "Точиги аймаг",
      "buName": "တိုချီဂိ ပြည်နယ်",
      "khName": "ខេត្ត តូឈីជី",
      "neName": "तोचिगी जिल्ला"
    },
    "class10": {
      "code": "090010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "栃木县南部",
      "zhName": "櫪木縣南部",
      "koName": "도치기 현 남부",
      "esName": "Sur de Prefectura de Tochigi",
      "ptName": "Sul da Província de Tochigi",
      "thName": "จังหวัดโทะจิงิตอนใต้",
      "viName": "Miền Nam tỉnh Tochigi",
      "inName": "Bagian Selatan Prefektur Ibaraki",
      "tlName": "Timog na bahagi ng Tochigi Prefecture",
      "moName": "Өмнөд Точиги аймаг",
      "buName": "တုချိဂိစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្តតុឈីហ្គិ",
      "neName": "तोचिगी जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "090011",
      "name": "県央部",
      "enName": "Ken-o part"
    },
    "class20": {
      "code": "0938600",
      "name": "高根沢町",
      "enName": "Takanezawa Town",
      "kana": "たかねざわまち",
      "chName": "高根泽町",
      "zhName": "髙根澤町",
      "koName": "다카네자와 정",
      "esName": "Pueblo de Takanezawa",
      "ptName": "bairro de Takanezawa",
      "thName": "เมืองทากาเนซาวะ",
      "viName": "thị trấn Takanezawa",
      "inName": "kota Takanezawa",
      "tlName": "bayan ng Takanezawa",
      "moName": "Таканэзава жижиг хот",
      "buName": "တာကာနဲ့ဇာ့ဝ မြို့နယ်",
      "khName": "ទីប្រជុំជន តាកាណេសាវ៉ា",
      "neName": "ताकानेजावा नगर"
    }
  },
  "0940700": {
    "office": {
      "code": "090000",
      "name": "栃木県",
      "enName": "Tochigi",
      "officeName": "宇都宮地方気象台",
      "chName": "栃木县",
      "zhName": "櫔木縣",
      "koName": "도치기현",
      "esName": "Prefectura de Tochigi",
      "ptName": "Província de Tochigi",
      "thName": "จังหวัดโทะจิงิ",
      "viName": "Tỉnh Tochigi",
      "inName": "Prefektur Tochigi",
      "tlName": "Tochigi Prefecture",
      "moName": "Точиги аймаг",
      "buName": "တိုချီဂိ ပြည်နယ်",
      "khName": "ខេត្ត តូឈីជី",
      "neName": "तोचिगी जिल्ला"
    },
    "class10": {
      "code": "090020",
      "name": "北部",
      "enName": "Northern Region",
      "chName": "栃木县北部",
      "zhName": "櫪木縣北部",
      "koName": "도치기 현 북부",
      "esName": "Norte de Prefectura de Tochigi",
      "ptName": "Norte da Província de Tochigi",
      "thName": "จังหวัดโทะจิงิตอนเหนือ",
      "viName": "Miền Bắc tỉnh Tochigi",
      "inName": "Bagian Utara Prefektur Ibaraki",
      "tlName": "Hilagang bahagi ng Tochigi Prefecture",
      "moName": "Хойд Точиги аймаг",
      "buName": "တုချိဂိစီရင်စု မြောက်ပိုင်း",
      "khName": "តំបន់ខាងជើងនៃខេត្តតុឈីហ្គិ",
      "neName": "तोचिगी जिल्लाको उत्तरी भाग"
    },
    "class15": {
      "code": "090021",
      "name": "那須地域",
      "enName": "Nasu Area"
    },
    "class20": {
      "code": "0940700",
      "name": "那須町",
      "enName": "Nasu Town",
      "kana": "なすまち",
      "chName": "那须町",
      "zhName": "那須町",
      "koName": "나스 정",
      "esName": "Pueblo de Nasu",
      "ptName": "bairro de Nasu",
      "thName": "เมืองนาสุ",
      "viName": "thị trấn Nasu",
      "inName": "kota Nasu",
      "tlName": "bayan ng Nasu",
      "moName": "Нaсү жижиг хот",
      "buName": "နာဆု မြို့နယ်",
      "khName": "ទីប្រជុំជន ណាស៊ូ",
      "neName": "नासु नगर"
    }
  },
  "0941100": {
    "office": {
      "code": "090000",
      "name": "栃木県",
      "enName": "Tochigi",
      "officeName": "宇都宮地方気象台",
      "chName": "栃木县",
      "zhName": "櫔木縣",
      "koName": "도치기현",
      "esName": "Prefectura de Tochigi",
      "ptName": "Província de Tochigi",
      "thName": "จังหวัดโทะจิงิ",
      "viName": "Tỉnh Tochigi",
      "inName": "Prefektur Tochigi",
      "tlName": "Tochigi Prefecture",
      "moName": "Точиги аймаг",
      "buName": "တိုချီဂိ ပြည်နယ်",
      "khName": "ខេត្ត តូឈីជី",
      "neName": "तोचिगी जिल्ला"
    },
    "class10": {
      "code": "090010",
      "name": "南部",
      "enName": "Southern Region",
      "chName": "栃木县南部",
      "zhName": "櫪木縣南部",
      "koName": "도치기 현 남부",
      "esName": "Sur de Prefectura de Tochigi",
      "ptName": "Sul da Província de Tochigi",
      "thName": "จังหวัดโทะจิงิตอนใต้",
      "viName": "Miền Nam tỉnh Tochigi",
      "inName": "Bagian Selatan Prefektur Ibaraki",
      "tlName": "Timog na bahagi ng Tochigi Prefecture",
      "moName": "Өмнөд Точиги аймаг",
      "buName": "တုချိဂိစီရင်စု တောင်ပိုင်း",
      "khName": "តំបន់ខាងត្បូងនៃខេត្តតុឈីហ្គិ",
      "neName": "तोचिगी जिल्लाको दक्षिणी भाग"
    },
    "class15": {
      "code": "090012",
      "name": "南東部",
      "enName": "South-eastern Region"
    },
    "class20": {
      "code": "0941100",
      "name": "那珂川町",
      "enName": "Nakagawa Town",
      "kana": "なかがわまち",
      "chName": "栃木那珂川町",
      "zhName": "栃木那珂川町",
      "koName": "도치기 나카가와 정",
      "esName": "Pueblo de Nakagawa, Tochigi",
      "ptName": "Tochigi, bairro de Nakagawa",
      "thName": "เมืองนาคากาวะ โทะจิงิ",
      "viName": "Thị trấn Nakagawa, Tochigi",
      "inName": "Kota Nakagawa, Tochigi",
      "tlName": "bayan ng Nakagawa, Tochigi",
      "moName": "Точиги Накагава жижиг хот",
      "buName": "တိုချိဂိနကဂဝမြို့နယ်",
      "khName": "ទីប្រជុំជនណាកាហ្គាវ៉ា តុឈីហ្គិ",
      "neName": "तोचिगी नकागावा नगर"
    }
  }
};
